/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1039);
	module.exports = __webpack_require__(728);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	///////////////////////////
	// CurrentUser.js /////////
	///////////////////////////
	
	var Cookies = __webpack_require__(188);
	var Features = __webpack_require__(16);
	
	// For legacy access
	var WhooosReadingClientApi = __webpack_require__(124);
	
	// For the new client access used by redux
	var APIClient = __webpack_require__(110);
	var CustomersAPIClient = __webpack_require__(1022);
	
	var CustomerIOClient = __webpack_require__(254);
	// var NewRelicClient = require("lib/integrations/NewRelicClient");
	// var LuckyOrangeClient = require("lib/integrations/LuckyOrangeClient");
	var LiveChatClient = __webpack_require__(438);
	var SentryClient = __webpack_require__(439);
	
	var GradeLevel = __webpack_require__(40);
	var AccountPlans = __webpack_require__(53);
	var WhooosReadingServices = __webpack_require__(25);
	var moment = __webpack_require__(15);
	
	var CurrentUser = {
		get: function get() {
			if (this.isLoaded()) {
				return window.wr_currentUserData.userData;
			} else if (this.isPassphraseUser()) {
				return window.wr_currentUserData.passphraseUserData;
			}
		},
	
		updateLocal: function updateLocal(updatedUserData) {
			window.wr_currentUserData.userData = _.extend(window.wr_currentUserData.userData, updatedUserData);
		},
	
		getLevel: function getLevel() {
			if (this.isLoaded()) {
				return GradeLevel.getQuizLevel(this.get().prefs.academic_level);
			}
		},
	
		paymentMethodSummary: function paymentMethodSummary() {
			var cardInfo = this.get().account.card_info;
			if (!cardInfo) {
				return "No payment method information";
			}
	
			var text = cardInfo.brand + " **" + cardInfo.last4;
			if (cardInfo.exp_year && cardInfo.exp_month) {
				text += " expires " + cardInfo.exp_month + "/" + cardInfo.exp_year.toString().slice(-2);
			}
			return text;
		},
	
	
		// Gets api with the current users's authentication already loaded in
		api: function api() {
			if (this.isSignedIn() || this.isPassphraseUser()) {
				if (window.wr_currentUserData.api == undefined) {
	
					window.wr_currentUserData.api = new WhooosReadingClientApi.LegacyClient();
	
					if (this.isSignedIn()) {
						// Auth for legacy client
						window.wr_currentUserData.api.addAuth(window.wr_currentUserData.userToken);
	
						// Adds auth to the new client used by redux
						APIClient.addAuth(window.wr_currentUserData.userToken);
						CustomersAPIClient.addAuth(window.wr_currentUserData.userToken);
					} else {
						window.wr_currentUserData.api.addAuth($wr.getURLParameterByName("passphrase"));
					}
				}
				return window.wr_currentUserData.api;
			}
		},
	
		// setWizardApi: function() {
		// 	if (window.wr_currentUserData.api == undefined) {
		// 		window.wr_currentUserData.api = new WhooosReadingClientApi.LegacyClient();
		// 	}
		// },
	
		getToken: function getToken() {
			return window.wr_currentUserData.userToken;
		},
	
		fetchCurrentUserData: function fetchCurrentUserData(callback, alternateEmbeds) {
			var defaultEmbeds = "user.settings,user.user_alerts,user.email,split_tests";
			defaultEmbeds += ",user.source_data,user.pending_task,user.pending_notification_count";
			defaultEmbeds += ",user.school";
			defaultEmbeds += ",user.sso_data,admin.expectations_date_spans,admin.completed_quiz_count,student.account_overdrawn";
			defaultEmbeds += ",user.prefs,admin.student_list_ids";
	
			if (window.wr_currentUserData.userType == "Student") {
				defaultEmbeds += ",student.account,student.coin_records";
				defaultEmbeds += ",student.avatar,student.perks,student.current_reading_level";
				defaultEmbeds += ",student.primary_student_list,student_list.primary_admin";
			} else if (window.wr_currentUserData.userType == "Admin") {
				defaultEmbeds += ",admin.account,user.org_prefs,admin.primary_school_org_id,admin.primary_district_org_id";
			} else {
				defaultEmbeds += ",user.account,wizard.crm_config";
			}
	
			if (this.isSignedIn()) {
				var embeds = alternateEmbeds == undefined ? defaultEmbeds : alternateEmbeds;
	
				var params = { embed: embeds };
	
				this.api().getUser(window.wr_currentUserData.userID, params, function (response, success, errorCode, jqXHR) {
	
					if (response && response.user && response.user.site_maintenance) {
						$wr.redirect("/maintenance");
						callback(false);
						return;
					}
	
					var userID = window.wr_currentUserData.userID;
	
					if (success && response.user.id == window.wr_currentUserData.userID) {
						if (window.wr_currentUserData.userData == undefined) {
							window.wr_currentUserData.userData = response.user;
						} else {
							window.wr_currentUserData.userData = _.extend(window.wr_currentUserData.userData, response.user);
						}
						window.wr_currentUserData.fullyLoaded = window.wr_currentUserData.fullyLoaded || embeds == defaultEmbeds;
	
						//////////////////
						// Handle special cases depending on what data was requested
						//////////////////
	
						// Displays any new user notices
						if (response.user.user_alerts && response.user.user_alerts.length > 0) {
							var coinDelay = 1200;
							response.user.user_alerts.map(function (alert, i) {
								if (alert.type == this.WP_AWARD && alert.title != "0") {
									setTimeout(function () {
										if (window.wrNotifications && window.wrNotifications.triggerCoinAward) {
											window.wrNotifications.triggerCoinAward();
										}
									}, coinDelay * i);
								} else if (alert.type == this.SITE_MESSAGE || alert.type == this.TEACHER_MESSAGE) {
									setTimeout(function () {
										if (window.wrNotifications == undefined) {
											window.wrNotifications = {};
										}
	
										var allowFormatting = alert.type == this.SITE_MESSAGE;
	
										if (window.wrNotifications.triggerModalNotification) {
											window.wrNotifications.triggerModalNotification(alert, allowFormatting);
										} else {
											window.wrNotifications.pendingModalNotifications = [[alert, allowFormatting]];
										}
									}.bind(this), 100);
								} else if (alert.type == this.CALENDLY_PROMPT) {
									setTimeout(function () {
										if (window.wrNotifications == undefined) {
											window.wrNotifications = {};
										}
										if (window.wrNotifications.triggerCalendlyModal) {
											window.wrNotifications.triggerCalendlyModal(alert);
										} else {
											window.wrNotifications.pendingCalendlyModal = [alert];
										}
									}.bind(this), 100);
								}
							}.bind(this));
						}
	
						// Sets a pending task notice, if one is present
						if (response.user.pending_task && response.user.pending_task.length > 0) {
							// delay, so the notification container to load in
							setTimeout(function () {
								if (window.wrNotifications) {
									window.wrNotifications.loadPendingTask(response.user.pending_task);
								}
							}, 100);
						}
	
						// Sets/updates this user's analytics tracking info
						if (response.user.split_tests) {
							var mycroftUserData = this.get();
	
							Mycroft.setUserData(mycroftUserData, response.user.split_tests);
						}
	
						CustomerIOClient.identify(response.user);
						// NewRelicClient.identify(response.user);
	
						SentryClient.setUserContext(response.user);
	
						// if (response.user.is_admin) {
						// 	FacebookPixelClient.init();
						// }
	
						// // Adds ZD Chat to all of teacher/admin acounts
						// if (response.user.is_admin) {
						// LiveChatClient.init(response.user);
						// }
	
						if (response.user.is_wizard && !$wr.isAppdev()) {
							window.location = WhooosReadingServices.Cheshire.url("/");
						}
	
						// var createdAt = moment().format(response.user.created_at);
						// var createdAtCutoff = moment().subtract(1, "hours").format();
						// if ((response.user.role == "teacherRole") && (createdAt > createdAtCutoff)) {
						// 	LuckyOrangeClient.init();
						// }
	
						// Alert any components that need to update when the current user is updated
						$(document).trigger("current-user-updated");
	
						if (callback) {
							callback(true);
						}
					} else if (errorCode == 401 || errorCode == 404 || response && response.user && response.user.id != userID) {
						// Our token has expired or cookies got scrambled...
						this.logOut();
						this.init(callback);
					} else if (response == undefined) {
						window.wr_allowErrorPage = true;
						$wr.redirect("/error?which=authentication&redirect_refresh=true");
						if (callback) {
							callback(false);
						}
						console.error("No response to CurrentUser Authentication (L2E may be down)");
					} else {
						throw "Unknown error on CurrentUser Authentication: " + jqXHR.statusText;
					}
				}.bind(this));
			} else if (callback) {
				callback(false);
			}
		},
	
		fetchCurrentUserCoinData: function fetchCurrentUserCoinData(callback) {
			CurrentUser.fetchCurrentUserData(callback, "student.coin_records,user.user_alerts");
		},
	
		fetchCurrentUserReferrals: function fetchCurrentUserReferrals(callback) {
			CurrentUser.fetchCurrentUserData(callback, "admin.referred_by,admin.referred_count");
		},
	
		hasID: function hasID(id) {
			return this.get() && this.get().id == id;
		},
	
		fetchSchoolYearDates: function fetchSchoolYearDates() {
			var dateInfo = { startDate: "", endDate: "", numMonths: 0 };
	
			var currentYear = $wr.momentInTimezone(new Date()).year();
			// months must be and index between 0 - 11
			var currentMonth = $wr.momentInTimezone(new Date()).month();
			var startMonth = CurrentUser.get().prefs.school_year_start_month;
			if (currentMonth >= startMonth) {
				// we're in the same calendar year as the school year start
				dateInfo.startDate = new Date(currentYear, startMonth, 1).getTime();
				dateInfo.numMonths = currentMonth - startMonth;
			} else {
				// we're in the next calendar year
				dateInfo.startDate = new Date(currentYear - 1, startMonth, 1).getTime();
				dateInfo.numMonths = 11 - startMonth + currentMonth;
			}
	
			dateInfo.endDate = $wr.momentInTimezone(new Date(currentYear, currentMonth + 1, 1)).endOf('month');
			return dateInfo;
		},
	
	
		isStudent: function isStudent() {
			return this.isLoaded() && this.get().is_student;
		},
		isAdmin: function isAdmin() {
			return this.isLoaded() && this.get().is_admin;
		},
		isTeacherAdmin: function isTeacherAdmin() {
			return this.isAdmin() && this.get().role == "teacherRole";
		},
		isSchoolAdmin: function isSchoolAdmin() {
			return this.isAdmin() && this.get().role == "adminRole";
		},
		isDistrictAdmin: function isDistrictAdmin() {
			return this.isAdmin() && this.get().role == "districtAdminRole";
		},
		isSponsor: function isSponsor() {
			return this.isLoaded() && this.get().is_sponsor;
		},
		isWizard: function isWizard() {
			return this.isLoaded() && this.get().is_wizard;
		},
	
		isDemo: function isDemo() {
			return this.isLoaded() && this.get().demo;
		},
	
		isPassphraseUser: function isPassphraseUser() {
			return this.isInitialized() && window.wr_currentUserData.passphrase != undefined;
		},
		isPendingSSOUser: function isPendingSSOUser() {
			return this.isLoaded() && this.get().sso_data && this.get().sso_data.pending;
		},
		isSSOUser: function isSSOUser() {
			return this.isGoogleSSOUser() || this.isCleverSSOUser();
		},
		isGoogleSSOUser: function isGoogleSSOUser() {
			return this.isLoaded() && this.get().sso_data && this.get().sso_data.google;
		},
		isCleverSSOUser: function isCleverSSOUser() {
			return this.isLoaded() && this.get().sso_data && this.get().sso_data.clever;
		},
	
		isLoaded: function isLoaded() {
			return this.isSignedIn() && window.wr_currentUserData.userData && window.wr_currentUserData.fullyLoaded;
		},
		isSignedIn: function isSignedIn() {
			return this.isInitialized() && window.wr_currentUserData.userID;
		},
		isInitialized: function isInitialized() {
			return window.wr_currentUserData != undefined;
		},
	
		isOverdrawnUser: function isOverdrawnUser() {
			return this.isLoaded() && this.get().account_overdrawn;
		},
	
		isPremiumAccount: function isPremiumAccount() {
			return this.isLoaded() && (this.get().product == AccountPlans.PRODUCTS.WR_GOLD || this.get().product === AccountPlans.PRODUCTS.WR_SILVER || this.get().account.silver_features || this.get().account.gold_features);
		},
	
		isPayingUser: function isPayingUser() {
			return this.get().account.paying;
		},
	
		isPremiumOrTrialAccount: function isPremiumOrTrialAccount() {
			var activeTrials = this.get().account.active_trials;
			var inATrial = Object.keys(activeTrials).length !== 0;
			return inATrial || this.isPremiumAccount();
		},
	
		usernamePasswordAuthenticate: function usernamePasswordAuthenticate(username, password, callback) {
			var client = new WhooosReadingClientApi.LegacyClient();
			var credentials = { username: username, password: password };
			client.postAccessTokens({ credentials: credentials }, function (response, success, error) {
				if (success) {
					this.setUserCredentials(response["user_id"], response["token"], response["user_type"], callback);
				} else if (response) {
					callback(false, response["message"]);
				} else {
					callback(false, "Unknown Error");
				}
			}.bind(this));
		},
	
		setUserCredentials: function setUserCredentials(userID, token, userType, callback) {
			var domain = this.getCookieDomain();
	
			Cookies.set(this.USER_ID_KEY, userID, { expires: 10000, domain: domain });
			Cookies.set(this.USER_TYPE_KEY, userType, { expires: 10000, domain: domain });
			Cookies.set(this.USER_TOKEN_KEY, token, { expires: 10000, domain: domain });
	
			this.init(callback);
		},
	
		logOut: function logOut() {
			var domain = this.getCookieDomain();
	
			Cookies.remove(this.USER_ID_KEY, { domain: domain });
			Cookies.remove(this.USER_TYPE_KEY, { domain: domain });
			Cookies.remove(this.USER_TOKEN_KEY, { domain: domain });
	
			window.wr_currentUserData = {};
		},
	
		getCookieDomain: function getCookieDomain() {
			var hostParts = window.location.host.split(".");
			if (hostParts.length == 1) {
				// localhost domain should be ""
				return "";
			} else {
				var domain = hostParts.slice(hostParts.length - 2).join(".");
			}
	
			return domain;
		},
	
		// Callback should be a function that takes one boolean argument:
		//    true iff user is logged on and could be authenticated
		init: function init(callback) {
			if ($wr.getURLParameterByName("passphrase")) {
				this.initPassphraseUser(callback);
				return;
			}
	
			window.wr_currentUserData = {};
			var domain = this.getCookieDomain();
	
			// Don't change these con
			var userID = Cookies.get(this.USER_ID_KEY, { domain: domain });
			var userType = Cookies.get(this.USER_TYPE_KEY, { domain: domain });
			var userToken = Cookies.get(this.USER_TOKEN_KEY, { domain: domain });
	
			if (userID && userToken && parseInt(userID).toString() == userID) {
				window.wr_currentUserData.userID = userID;
				window.wr_currentUserData.userType = userType;
				window.wr_currentUserData.userToken = userToken;
	
				this.fetchCurrentUserData(callback);
			} else if (callback) {
				callback(false);
			}
		},
	
		initPassphraseUser: function initPassphraseUser(callback) {
			var passphrase = $wr.getURLParameterByName("passphrase");
			window.wr_currentUserData = { passphrase: passphrase };
	
			var embeds = "student_list.primary_admin";
			this.api().getStudentList(passphrase, { embeds: embeds }, function (response, success, errorCode, jqXHR) {
				window.wr_currentUserData.fullyLoaded = true;
				window.wr_currentUserData.passphraseUserData = { passphrase: passphrase, student_list: response.student_list };
				if (success) {
					if (callback) {
						callback(true);
					}
				} else {
					window.wr_currentUserData = {};
					if (callback) {
						callback(false);
					}
				}
			}.bind(this));
		},
	
		// Callback should be a function that takes one boolean argument:
		//    true iff user is logged on and could be authenticated
		initTokenUser: function initTokenUser(userID, userToken, callback) {
			window.wr_currentUserData = {};
			var domain = this.getCookieDomain();
	
			if (userID && userToken && parseInt(userID).toString() == userID) {
				window.wr_currentUserData.userID = userID;
				window.wr_currentUserData.userToken = userToken;
	
				this.fetchCurrentUserData(callback);
			} else if (callback) {
				callback(false);
			}
		},
	
		// Don't change these!
		USER_ID_KEY: "wr_currentUserID",
		USER_TYPE_KEY: "wr_currentUserType",
		USER_TOKEN_KEY: "wr_currentUserToken",
		WP_AWARD: "WpAward",
		SITE_MESSAGE: "SiteMessage",
		TEACHER_MESSAGE: "TeacherMessage",
		CALENDLY_PROMPT: "CalendlyPrompt"
	};
	module.exports = CurrentUser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var _exportNames = {
	  batch: true
	};
	
	var _exports = __webpack_require__(3587);
	
	Object.keys(_exports).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _exports[key]) return;
	  exports[key] = _exports[key];
	});
	
	var _reactBatchedUpdates = __webpack_require__(3592);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _batch = __webpack_require__(632);
	
	// Enable batched updates in our subscriptions for use
	// with standard React renderers (ReactDOM, React Native)
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var core = __webpack_require__(76);
	var hide = __webpack_require__(60);
	var redefine = __webpack_require__(61);
	var ctx = __webpack_require__(77);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isLoadingAdmins = isLoadingAdmins;
	exports.admins = admins;
	exports.admin = admin;
	exports.primaryAdminForStudentListID = primaryAdminForStudentListID;
	exports.avatar = avatar;
	exports.avatarForStudent = avatarForStudent;
	exports.coinRecordsForSubject = coinRecordsForSubject;
	exports.districtOrg = districtOrg;
	exports.districtOrgs = districtOrgs;
	exports.isLoadingDistrictOrgs = isLoadingDistrictOrgs;
	exports.districtOrgsTotal = districtOrgsTotal;
	exports.districtOrgsPaginated = districtOrgsPaginated;
	exports.districtOrgPrefs = districtOrgPrefs;
	exports.schoolOrgPrefs = schoolOrgPrefs;
	exports.studentListPrefs = studentListPrefs;
	exports.globalStudentListPrefs = globalStudentListPrefs;
	exports.studentLists = studentLists;
	exports.studentListsByAdminId = studentListsByAdminId;
	exports.studentList = studentList;
	exports.nonEmptyStudentLists = nonEmptyStudentLists;
	exports.isLoadingStudentLists = isLoadingStudentLists;
	exports.schoolOrg = schoolOrg;
	exports.schoolOrgs = schoolOrgs;
	exports.nonEmptySchoolOrgs = nonEmptySchoolOrgs;
	exports.isLoadingSchoolOrgs = isLoadingSchoolOrgs;
	exports.schoolOrgsPaginated = schoolOrgsPaginated;
	exports.schoolOrgsTotal = schoolOrgsTotal;
	exports.primarySchool = primarySchool;
	exports.school = school;
	exports.schools = schools;
	exports.isLoadingSchool = isLoadingSchool;
	exports.parent = parent;
	exports.parents = parents;
	exports.students = students;
	exports.student = student;
	exports.studentsForStudentListID = studentsForStudentListID;
	exports.studentsForSchoolOrgID = studentsForSchoolOrgID;
	exports.studentsForSubgroupKey = studentsForSubgroupKey;
	exports.studentsForOrgIdentifier = studentsForOrgIdentifier;
	exports.studentsForBookTextID = studentsForBookTextID;
	exports.studentsByStudentListID = studentsByStudentListID;
	exports.getSampleActiveStudent = getSampleActiveStudent;
	exports.getTeacherDemoStudent = getTeacherDemoStudent;
	exports.isLoadingStudents = isLoadingStudents;
	exports.hasNoStudents = hasNoStudents;
	exports.studentTaskCount = studentTaskCount;
	exports.orgIdentifierForStudents = orgIdentifierForStudents;
	exports.nameForOrgIdentifier = nameForOrgIdentifier;
	exports.subgroups = subgroups;
	exports.subgroup = subgroup;
	exports.upgradeTokens = upgradeTokens;
	exports.isLoadingUpgradeTokens = isLoadingUpgradeTokens;
	exports.discountToken = discountToken;
	exports.discountTokens = discountTokens;
	var OrgTypes = __webpack_require__(45);
	
	var ReadingSelectors = __webpack_require__(21);
	
	var SelectorUtility = __webpack_require__(144);
	
	var Queries = __webpack_require__(109);
	
	//////////////////////////////////////////////
	// Admins ////////////////////////////////////
	////////////////////-//////////////////////////
	
	function isLoadingAdmins(_ref) {
		var state = _ref.state,
		    key = _ref.key;
	
		key = key || "index";
		return state.admins.loading[key];
	}
	
	// Gets all admins (sorted by name)
	function admins(_ref2) {
		var state = _ref2.state,
		    filters = _ref2.filters,
		    conditions = _ref2.conditions;
	
		var admins = SelectorUtility.filterBy(state.admins, filters, conditions);
		return _.sortBy(admins, "last_name");
	};
	
	function admin(_ref3) {
		var state = _ref3.state,
		    id = _ref3.id;
	
		return state.admins[id];
	}
	
	// Gets all students (sorted by name) with the provided student list ID
	function primaryAdminForStudentListID(_ref4) {
		var state = _ref4.state,
		    studentListID = _ref4.studentListID;
	
		if (!(studentListID in state.studentLists)) {
			return [];
		}
	
		var admin = null;
	
		_.each(admins({ state: state }), function (a) {
	
			if (a.org_ids) {
				// Method used by teachers, admins
				if (a.org_ids.student_lists.primary.includes(studentListID)) {
					admin = a;
				}
			}
		});
	
		return admin;
	}
	
	//////////////////////////////////////////////
	// Avatars ///////////////////////////////////
	//////////////////////////////////////////////
	
	function avatar(_ref5) {
		var state = _ref5.state,
		    id = _ref5.id;
	
		return state.avatars[id];
	}
	function avatarForStudent(_ref6) {
		var state = _ref6.state,
		    studentID = _ref6.studentID;
	
		var st = student({ state: state, id: studentID });
		if (st && st.avatar) {
			return state.avatars[st.avatar];
		}
	}
	
	//////////////////////////////////////////////
	// CoinRecords ///////////////////////////////
	//////////////////////////////////////////////
	
	// Gets all students (sorted by name)
	function coinRecordsForSubject(_ref7) {
		var state = _ref7.state,
		    subjectType = _ref7.subjectType,
		    subjectID = _ref7.subjectID;
	
		if (subjectType == "Quiz") {
			var coldRecordIDs = state.quizzes[subjectID].gold_records;
		} else if (subjectType == "Answer") {
			var coldRecordIDs = state.answers[subjectID].gold_records;
		}
	
		if (!coldRecordIDs) {
			return [];
		};
	
		return _.values(_.pick(state.coinRecords, coldRecordIDs));
	};
	
	//////////////////////////////////////////////
	// DistrictOrgs ////////////////////////////////
	//////////////////////////////////////////////
	
	function districtOrg(_ref8) {
		var state = _ref8.state,
		    id = _ref8.id;
	
		return state.districtOrgs[id];
	}
	
	function districtOrgs(_ref9) {
		var state = _ref9.state,
		    filters = _ref9.filters,
		    conditions = _ref9.conditions,
		    filterEmpty = _ref9.filterEmpty;
	
		var useDistrictOrgs = SelectorUtility.filterBy(state.districtOrgs, filters, conditions);
	
		return _.sortBy(useDistrictOrgs, "name");
	}
	
	function isLoadingDistrictOrgs(_ref10) {
		var state = _ref10.state,
		    key = _ref10.key;
	
		key = key || "index";
		return state.districtOrgs.loading[key];
	}
	
	function districtOrgsTotal(_ref11) {
		var state = _ref11.state,
		    conditions = _ref11.conditions,
		    filters = _ref11.filters;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.districtOrgs.totals[totalKey];
	}
	
	function districtOrgsPaginated(_ref12) {
		var state = _ref12.state,
		    conditions = _ref12.conditions,
		    filters = _ref12.filters,
		    page = _ref12.page;
	
		var query = Queries.toQuery(filters, conditions);
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.districtOrgs, pageKey, page);
	}
	
	//////////////////////////////////////////////
	// Prefs /////////////////////////////////////
	//////////////////////////////////////////////
	function districtOrgPrefs(_ref13) {
		var state = _ref13.state,
		    districtOrgID = _ref13.districtOrgID;
	
		var useDistrictOrg = districtOrg({ state: state, id: districtOrg });
	
		return (useDistrictOrg || {}).prefs;
	}
	
	function schoolOrgPrefs(_ref14) {
		var state = _ref14.state,
		    schoolOrgID = _ref14.schoolOrgID;
	
		var useSchoolOrg = schoolOrg({ state: state, id: schoolOrgID });
	
		return (useSchoolOrg || {}).prefs;
	}
	
	function studentListPrefs(_ref15) {
		var state = _ref15.state,
		    studentListID = _ref15.studentListID;
	
		if (studentListID) {
			var useStudentList = studentList({ state: state, id: studentListID });
		} else {
			var useStudentList = studentLists({ state: state }).filter(function (x) {
				return x.prefs;
			})[0];
		}
		return (useStudentList || {}).prefs;
	}
	
	function globalStudentListPrefs(_ref16) {
		var state = _ref16.state;
	
		return studentListPrefs({ state: state }) || {};
	}
	
	//////////////////////////////////////////////
	// StudentLists //////////////////////////////
	//////////////////////////////////////////////
	
	// Gets all student lists (sorted by name)
	function studentLists(_ref17) {
		var state = _ref17.state,
		    filters = _ref17.filters,
		    conditions = _ref17.conditions,
		    filterEmpty = _ref17.filterEmpty;
	
		var studentLists = SelectorUtility.filterBy(state.studentLists, filters, conditions);
	
		// Option to return only students lists with students
		if (filterEmpty) {
			var slIDs = _.uniq(_.compact(_.flatten(students({ state: state }).map(function (s) {
				if (s.student_list_ids) {
					return s.student_list_ids.all;
				}
			}))));
			studentLists = _.filter(studentLists, function (sl) {
				return slIDs.includes(sl.id);
			});
		}
		return _.sortBy(studentLists, "name");
	};
	
	// Gets all student lists associated to an admin
	// Student Lists must be loaded into state with the 'student_list.admins' embed
	function studentListsByAdminId(_ref18) {
		var state = _ref18.state,
		    adminId = _ref18.adminId,
		    filters = _ref18.filters,
		    conditions = _ref18.conditions,
		    filterEmpty = _ref18.filterEmpty;
	
	
		var allStudentLists = studentLists({ state: state, filters: filters, conditions: conditions, filterEmpty: filterEmpty });
	
		var admin = state.admins[adminId];
	
		if (admin) {
			if (admin.role == 'districtAdminRole') {
				var filteredStudentLists = allStudentLists;
			} else if (admin.role == 'adminRole') {
	
				var schoolOrgIDs = admin.org_ids.school_orgs.all || [];
				var filteredStudentLists = _.filter(allStudentLists, function (sl) {
					if (sl.school_org_id) {
						return _.includes(schoolOrgIDs, sl.school_org_id);
					}
				});
			} else if (admin.role == 'teacherRole') {
				var filteredStudentLists = _.filter(allStudentLists, function (sl) {
					var adminIds = sl.admin_ids ? sl.admin_ids : [];
					if (sl.admins) {
						adminIds = _.map(sl.admins, function (a) {
							return a.id;
						});
					}
					if (adminIds.length > 0) {
						return _.includes(adminIds, adminId);
					}
				});
			}
		}
	
		return filteredStudentLists;
	};
	
	function studentList(_ref19) {
		var state = _ref19.state,
		    id = _ref19.id;
	
		return state.studentLists[id];
	}
	
	function nonEmptyStudentLists(_ref20) {
		var state = _ref20.state;
	
		return studentLists({ state: state, filterEmpty: true });
	}
	
	function isLoadingStudentLists(_ref21) {
		var state = _ref21.state,
		    key = _ref21.key;
	
		key = key || "index";
		return state.studentLists.loading[key];
	}
	
	//////////////////////////////////////////////
	// SchoolOrgs ////////////////////////////////
	//////////////////////////////////////////////
	
	function schoolOrg(_ref22) {
		var state = _ref22.state,
		    id = _ref22.id;
	
		return state.schoolOrgs[id];
	}
	
	function schoolOrgs(_ref23) {
		var state = _ref23.state,
		    filters = _ref23.filters,
		    conditions = _ref23.conditions,
		    filterEmpty = _ref23.filterEmpty;
	
		var schoolOrgs = SelectorUtility.filterBy(state.schoolOrgs, filters, conditions);
	
		if (filterEmpty) {
			schoolOrgs = schoolOrgs.filter(function (x) {
				return studentsForSchoolOrgID({ state: state, schoolOrgID: x.id }).length;
			});
		}
	
		return _.sortBy(schoolOrgs, "name");
	}
	
	function nonEmptySchoolOrgs(_ref24) {
		var state = _ref24.state;
	
		return schoolOrgs({ state: state, filterEmpty: true });
	}
	
	function isLoadingSchoolOrgs(_ref25) {
		var state = _ref25.state,
		    key = _ref25.key;
	
		key = key || "index";
		return state.schoolOrgs.loading[key];
	}
	
	function schoolOrgsPaginated(_ref26) {
		var state = _ref26.state,
		    conditions = _ref26.conditions,
		    filters = _ref26.filters,
		    page = _ref26.page;
	
		var query = Queries.toQuery(filters, conditions);
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.schoolOrgs, pageKey, page);
	}
	
	function schoolOrgsTotal(_ref27) {
		var state = _ref27.state,
		    conditions = _ref27.conditions,
		    filters = _ref27.filters;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.schoolOrgs.totals[totalKey];
	}
	
	//////////////////////////////////////////////
	// Schools ///////////////////////////////////
	//////////////////////////////////////////////
	
	function primarySchool(_ref28) {
		var state = _ref28.state,
		    filters = _ref28.filters,
		    conditions = _ref28.conditions;
	
		var schools = SelectorUtility.allRecords(state.schools);
		return _.first(schools);
	};
	
	function school(_ref29) {
		var state = _ref29.state,
		    canonicalID = _ref29.canonicalID,
		    id = _ref29.id;
	
		if (id) {
			return state.schools[id];
		}
		if (canonicalID) {
			return schools({ state: state, filters: { canonical_id: canonicalID } })[0];
		}
	};
	
	function schools(_ref30) {
		var state = _ref30.state,
		    filters = _ref30.filters,
		    conditions = _ref30.conditions;
	
		return SelectorUtility.filterBy(state.schools, filters, conditions);
	};
	
	function isLoadingSchool(_ref31) {
		var state = _ref31.state,
		    key = _ref31.key;
	
		key = key || "index";
		return state.schools.loading[key];
	}
	
	//////////////////////////////////////////////
	// Parents //////////////////////////////////
	//////////////////////////////////////////////
	
	function parent(_ref32) {
		var state = _ref32.state,
		    id = _ref32.id;
	
		return state.parents[id];
	}
	
	function parents(_ref33) {
		var state = _ref33.state,
		    filters = _ref33.filters,
		    conditions = _ref33.conditions;
	
		var parents = SelectorUtility.filterBy(state.parents, filters, conditions);
		return _.sortBy(parents, studentSortName);
	};
	
	//////////////////////////////////////////////
	// Students //////////////////////////////////
	//////////////////////////////////////////////
	
	// Gets all students (sorted by name)
	function students(_ref34) {
		var state = _ref34.state,
		    filters = _ref34.filters,
		    conditions = _ref34.conditions;
	
		var students = SelectorUtility.filterBy(state.students, filters, conditions);
		return _.sortBy(students, studentSortName);
	};
	
	function student(_ref35) {
		var state = _ref35.state,
		    id = _ref35.id;
	
		return state.students[id];
	}
	
	// Gets all students (sorted by name) with the provided student list ID
	function studentsForStudentListID(_ref36) {
		var state = _ref36.state,
		    studentListID = _ref36.studentListID;
	
		if (!(studentListID in state.studentLists) || !state.studentLists[studentListID] || state.studentLists[studentListID].length == 0) {
			return [];
		}
	
		var ss = [];
	
		_.each(students({ state: state }), function (s) {
			if (s.student_list_ids) {
				// Method used by teachers, admins
				if (s.student_list_ids.all.includes(studentListID)) {
					ss.push(s);
				}
			} else {
				// Method used by students
				if (state.studentLists[studentListID].students && state.studentLists[studentListID].students.includes(s.id)) {
					ss.push(s);
				}
			}
		});
	
		return _.sortBy(ss, studentSortName);
	}
	
	// Gets all students (sorted by name) with the provided school org ID
	function studentsForSchoolOrgID(_ref37) {
		var state = _ref37.state,
		    schoolOrgID = _ref37.schoolOrgID;
	
		if (!(schoolOrgID in state.schoolOrgs)) {
			return [];
		}
	
		var slIDs = _.pluck(studentLists({ state: state, filters: { school_org_id: schoolOrgID } }), "id");
	
		var ss = _.uniq(_.flatten(slIDs.map(function (slID) {
			return studentsForStudentListID({ state: state, studentListID: slID });
		})), "id");
	
		return _.sortBy(ss, studentSortName);
	}
	
	// Gets all students (sorted by name) in the subgroup matching this key
	function studentsForSubgroupKey(_ref38) {
		var state = _ref38.state,
		    subgroupKey = _ref38.subgroupKey;
	
		return students({ state: state }).filter(function (s) {
			return ((s.prefs || {}).subgroup || {}).key === subgroupKey;
		});
	}
	
	// Gets all students matching the org identifier string (see OrgTypes)
	function studentsForOrgIdentifier(_ref39) {
		var state = _ref39.state,
		    orgIdentifier = _ref39.orgIdentifier;
	
		var _OrgTypes$fromIdentif = OrgTypes.fromIdentifier(orgIdentifier),
		    type = _OrgTypes$fromIdentif.type,
		    key = _OrgTypes$fromIdentif.key;
	
		if (OrgTypes.isEveryoneIdentifier(type)) {
			return students({ state: state });
		} else if (type === OrgTypes.STUDENT_LIST) {
			return studentsForStudentListID({ state: state, studentListID: key });
		} else if (type === OrgTypes.SCHOOL_ORG) {
			return studentsForSchoolOrgID({ state: state, schoolOrgID: key });
		} else if (type === OrgTypes.SUBGROUP) {
			return studentsForSubgroupKey({ state: state, subgroupKey: key });
		} else {
			throw "Unrecognized org type " + type;
		}
	}
	
	// Gets all students (sorted by name) associate with the provided book
	function studentsForBookTextID(_ref40) {
		var state = _ref40.state,
		    textID = _ref40.textID;
	
		var book = ReadingSelectors.books({ state: state, conditions: { textID: textID } })[0];
		if (!book) {
			return [];
		}
	
		var studentIDs = book.user_ids || book.students;
		if (!studentIDs) {
			return [];
		};
	
		return _.sortBy(_.pick(state.students, studentIDs), studentSortName);
	}
	
	// Gets all student list IDs mapped to list of students (sorted by name)
	function studentsByStudentListID(_ref41) {
		var state = _ref41.state;
	
		var studentListIDs = _.pluck(state.studentLists, "id");
		return _.object(_.map(studentListIDs, function (studentListID) {
			return [studentListID, studentsForStudentListID({ state: state, studentListID: studentListID })];
		}));
	}
	
	function getSampleActiveStudent(_ref42) {
		var state = _ref42.state;
	
		var activeStudents = _.select(students({ state: state }), function (student) {
			return student.last_active != undefined;
		});
	
		return _.first(_.sortBy(activeStudents, "first_name"));
	}
	
	function getTeacherDemoStudent(_ref43) {
		var state = _ref43.state;
	
		return _.findWhere(students, { demo_for_teacher: true });
	}
	
	function isLoadingStudents(_ref44) {
		var state = _ref44.state,
		    key = _ref44.key;
	
		key = key || "index";
		return state.students.loading[key];
	}
	
	function hasNoStudents(_ref45) {
		var state = _ref45.state;
	
		return !isLoadingStudentLists({ state: state }) && !isLoadingStudents({ state: state }) && students({ state: state }).length == 0;
	}
	
	function studentTaskCount(_ref46) {
		var state = _ref46.state,
		    studentID = _ref46.studentID;
	
		var st = student({ state: state, id: studentID });
	
		var count = 0;
	
		if (st && st.current_tasks) {
			// Assigned exericises + texts... but just the IDs, note
			count += st.current_tasks.length;
		}
	
		if (st && st.all_tasks) {
			count += st.all_tasks.length;
		}
	
		var revisables = ReadingSelectors.booksWithRevisables({
			state: state, conditions: { userID: studentID }
		});
	
		count += revisables.length;
	
		return count;
	}
	
	//////////////////////////////////////////////
	// OrgIdentifier stuff ///////////////////////
	//////////////////////////////////////////////
	
	
	// Org identifier matching student IDs, if any. Null otherwise
	function orgIdentifierForStudents(_ref47) {
		var state = _ref47.state,
		    studentIDs = _ref47.studentIDs;
	
		studentIDs = _.uniq(studentIDs);
		var stdnts = students({ state: state });
	
		if (studentIDs.length == stdnts.length) {
			return OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENTS });
		}
	
		var sls = studentLists({ state: state });
		for (var i = 0; i < sls.length; i++) {
			if (_.isEqual(_.sortBy(studentIDs), _.sortBy(sls[i].students))) {
				return OrgTypes.toIdentifier({
					type: OrgTypes.STUDENT_LIST,
					key: sls[i].id
				});
			}
		}
	
		var sbgrps = subgroups({ state: state });
		for (var i = 0; i < sbgrps.length; i++) {
			var subgroupIDs = stdnts.filter(function (s) {
				return ((s.prefs || {}).subgroup || {}).key === sbgrps[i].key;
			});
			if (_.isEqual(_.sortBy(studentIDs), _.sortBy(subgroupIDs))) {
				return OrgTypes.toIdentifier({
					type: OrgTypes.SUBGROUP,
					key: sbgrps[i].key
				});
			}
		}
	
		return null; // No match
	}
	
	// Gets all students matching the org identifier string (see OrgTypes)
	function nameForOrgIdentifier(_ref48) {
		var state = _ref48.state,
		    orgIdentifier = _ref48.orgIdentifier,
		    fallback = _ref48.fallback;
	
		if (!orgIdentifier && fallback) {
			return fallback;
		}
	
		var _OrgTypes$fromIdentif2 = OrgTypes.fromIdentifier(orgIdentifier),
		    type = _OrgTypes$fromIdentif2.type,
		    key = _OrgTypes$fromIdentif2.key;
	
		if (type === OrgTypes.ALL_STUDENTS) {
			return "All Students";
		} else if (type === OrgTypes.ALL_STUDENT_LISTS) {
			return "All Classes";
		} else if (type === OrgTypes.ALL_SCHOOL_ORGS) {
			return "All Schools";
		} else if (type === OrgTypes.STUDENT_LIST) {
			return (studentList({ state: state, id: key }) || { name: fallback }).name;
		} else if (type === OrgTypes.SCHOOL_ORG) {
			return (schoolOrg({ state: state, id: key }) || { name: fallback }).name;
		} else if (type === OrgTypes.SUBGROUP) {
			return (subgroup({ state: state, key: key }) || { name: fallback }).name;
		} else {
			throw "Unrecognized org type " + type;
		}
	}
	
	//////////////////////////////////////////////
	// Subgroups (Not a real model) //////////////
	//////////////////////////////////////////////
	
	function subgroups(_ref49) {
		var state = _ref49.state;
	
		var allSubGroups = students({ state: state }).map(function (s) {
			return (s.prefs || {}).subgroup;
		}).filter(function (g) {
			return !_.isEmpty(g);
		});
		return _.uniq(allSubGroups, false, function (group) {
			return group.key;
		});
	}
	
	function subgroup(_ref50) {
		var state = _ref50.state,
		    key = _ref50.key;
	
		return _.findWhere(subgroups({ state: state }), { key: key });
	}
	
	////////////////////////////////////////
	// Upgrade Tokens //////////////////////
	////////////////////////////////////////
	
	function upgradeTokens(_ref51) {
		var state = _ref51.state,
		    filters = _ref51.filters,
		    conditions = _ref51.conditions;
	
		return SelectorUtility.filterBy(state.upgradeTokens, filters, conditions);
	};
	function isLoadingUpgradeTokens(_ref52) {
		var state = _ref52.state,
		    key = _ref52.key;
	
		key = key || "index";
		return state.upgradeTokens.loading[key];
	}
	
	////////////////////////////////////////
	// Discount Tokens /////////////////////
	////////////////////////////////////////
	
	function discountToken(_ref53) {
		var state = _ref53.state,
		    code = _ref53.code;
	
		return state.discountTokens[code];
	}
	function discountTokens(_ref54) {
		var state = _ref54.state,
		    filters = _ref54.filters,
		    conditions = _ref54.conditions;
	
		return SelectorUtility.filterBy(state.discountTokens, filters, conditions);
	};
	
	////////////////////////////////////////////////////
	// Utility functions ///////////////////////////////
	////////////////////////////////////////////////////
	
	// Sort student by "Last, First" unless they are using a filler last name
	function studentSortName(st) {
		if (st.last_name == $wr.Constants.FILLER_LAST_NAME) {
			return st.first_name;
		} else {
			return st.last_name + ", " + st.first_name;
		}
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ReactTooltip = __webpack_require__(12);
	
	var Glyphicon = function Glyphicon(props) {
		var className = "glyphicon glyphicon-" + props.icon;
		if (props.className) {
			className += " " + props.className;
		}
		if (props.dataTip) {
			var spanProps = _.omit(props, "dataTip");
	
			return React.createElement(
				"span",
				null,
				React.createElement("span", _extends({}, spanProps, { className: className, "data-tip": true, "data-for": props.dataTip })),
				React.createElement(
					ReactTooltip,
					{ id: props.dataTip },
					React.createElement(
						"span",
						null,
						" ",
						props.dataTip
					)
				)
			);
		} else {
			return React.createElement("span", _extends({}, props, { className: className }));
		}
	};
	
	Glyphicon.propTypes = StrictPropTypes({
		// "glyphicon glyphicon-*" class will be added to this
		className: PropTypes.string,
	
		// Glyphion suffix
		icon: PropTypes.string.isRequired,
	
		// Passed on to span
		dataTip: PropTypes.string,
		style: PropTypes.object,
		onClick: PropTypes.func
	});
	
	module.exports = Glyphicon;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// React wrapper for Spin.js
	var Spin = __webpack_require__(3615);
	
	__webpack_require__(3816);
	
	var Spinner = function (_React$Component) {
		_inherits(Spinner, _React$Component);
	
		function Spinner(props) {
			_classCallCheck(this, Spinner);
	
			var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(Spinner, [{
			key: "render",
			value: function render() {
				var className = "spinnerBox";
	
				if (this.props.center) {
					className += " center";
				}
				if (this.props.placeholder) {
					className += " placeholder";
				}
	
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				var spanProps = _.omit(this.props, "center", "placeholder", "ops", "scale", "className", "smallOps");
	
				return React.createElement("span", _extends({}, spanProps, { className: className, ref: "spinBox" }));
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var ops = { length: 9, radius: 6, zIndex: 1 };
				if (this.props.smallOps) {
					_.extend(ops, { width: 3, lines: 10, trail: 120, color: '#999' });
				} else {
					_.extend(ops, { width: 2, trail: 40, color: '#ccc' });
				}
				if (this.props.scale) {
					ops.length *= this.props.scale;
					ops.radius *= this.props.scale;
					ops.width *= this.props.scale;
					ops.trail *= this.props.scale;
				}
				var ops = _.extend({}, ops, this.props.ops);
	
				var spinner = new Spin(ops).spin(this.refs.spinBox);
			}
		}]);
	
		return Spinner;
	}(React.Component);
	
	;
	
	Spinner.propTypes = StrictPropTypes({
		// Class to give to the spinner wrapper
		className: PropTypes.string,
	
		// If this is true, center the spinner in its container
		center: PropTypes.bool,
	
		// If this is true, the spinner takes up space
		placeholder: PropTypes.bool,
	
		// If true, triggeres a different set of default ops
		smallOps: PropTypes.bool,
	
		// Override some default spinner ops
		ops: PropTypes.object,
	
		// Automatically increases the size of some default spinner ops
		scale: PropTypes.number
	});
	
	module.exports = Spinner;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	
	function providePopulateData(ops) {
		ops = ops || {};
		return function (WrappedComponent) {
			var PopulateData = function (_React$Component) {
				_inherits(PopulateData, _React$Component);
	
				function PopulateData(props) {
					_classCallCheck(this, PopulateData);
	
					var _this = _possibleConstructorReturn(this, (PopulateData.__proto__ || Object.getPrototypeOf(PopulateData)).call(this));
	
					_this.state = { requested: false, received: false };
					return _this;
				}
	
				_createClass(PopulateData, [{
					key: "render",
					value: function render() {
						if (!this.state.requested) {
							return React.createElement("div", { className: "emptyPopulateData" });
						} else if (ops.waitForLoad && !this.state.received) {
							return React.createElement(
								"div",
								{ className: "emptyPopulateData" },
								React.createElement(Spinner, { placeholder: true, scale: 1.7 })
							);
						} else {
							return React.createElement(WrappedComponent, this.props);
						}
					}
				}, {
					key: "componentDidMount",
					value: function componentDidMount() {
						var _this2 = this;
	
						if (ops.waitForLoad) {
							// In this case, populateData must return a promise
							this.props.populateData().then(function () {
								_this2.setState({ received: true });
							});
							this.setState({ requested: true });
						} else {
							this.props.populateData();
							this.setState({ requested: true });
						}
					}
				}]);
	
				return PopulateData;
			}(React.Component);
	
			PopulateData.WrappedComponent = WrappedComponent;
	
			return PopulateData;
		};
	}
	
	module.exports = {
		providePopulateData: providePopulateData
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchOrgData = fetchOrgData;
	exports.fetchRosterData = fetchRosterData;
	exports.fetchAdmins = fetchAdmins;
	exports.updateAdmin = updateAdmin;
	exports.createAdmin = createAdmin;
	exports.clearAdmins = clearAdmins;
	exports.createAward = createAward;
	exports.fetchDiscountToken = fetchDiscountToken;
	exports.fetchDiscountTokens = fetchDiscountTokens;
	exports.createDiscountTokens = createDiscountTokens;
	exports.updateDiscountToken = updateDiscountToken;
	exports.deleteDiscountToken = deleteDiscountToken;
	exports.clearDiscountTokens = clearDiscountTokens;
	exports.createDistrictOrg = createDistrictOrg;
	exports.updateAdminPrefs = updateAdminPrefs;
	exports.updateStudentPrefs = updateStudentPrefs;
	exports.massUpdateStudentPrefs = massUpdateStudentPrefs;
	exports.updateStudentList = updateStudentList;
	exports.postUserTrigger = postUserTrigger;
	exports.updateStudentListPrefs = updateStudentListPrefs;
	exports.updateAllStudentListPrefs = updateAllStudentListPrefs;
	exports.archiveStudentList = archiveStudentList;
	exports.updateDistrictOrgPrefs = updateDistrictOrgPrefs;
	exports.updateSchoolOrgPrefs = updateSchoolOrgPrefs;
	exports.postReferrals = postReferrals;
	exports.fetchSchool = fetchSchool;
	exports.createSchool = createSchool;
	exports.postRosters = postRosters;
	exports.fetchSchoolOrgs = fetchSchoolOrgs;
	exports.fetchSchoolOrgsPaginated = fetchSchoolOrgsPaginated;
	exports.createSchoolOrg = createSchoolOrg;
	exports.fetchDistrictOrgs = fetchDistrictOrgs;
	exports.fetchDistrictOrgsPaginated = fetchDistrictOrgsPaginated;
	exports.fetchStudentLists = fetchStudentLists;
	exports.fetchStudentListsStoreless = fetchStudentListsStoreless;
	exports.fetchStudentList = fetchStudentList;
	exports.invalidateStudentListCache = invalidateStudentListCache;
	exports.postStudentLists = postStudentLists;
	exports.clearStudentLists = clearStudentLists;
	exports.fetchStudents = fetchStudents;
	exports.fetchStudent = fetchStudent;
	exports.updateStudent = updateStudent;
	exports.updateStudents = updateStudents;
	exports.destroyStudents = destroyStudents;
	exports.deleteStudents = deleteStudents;
	exports.clearStudents = clearStudents;
	exports.fetchParent = fetchParent;
	exports.createParents = createParents;
	exports.updateParent = updateParent;
	exports.fetchUpgradeTokens = fetchUpgradeTokens;
	exports.updateUpgradeToken = updateUpgradeToken;
	exports.clearUpgradeTokens = clearUpgradeTokens;
	exports.createUpgradeTokens = createUpgradeTokens;
	exports.deleteUpgradeToken = deleteUpgradeToken;
	exports.fetchUsersStoreless = fetchUsersStoreless;
	exports.mergeStudents = mergeStudents;
	exports.createUserAlerts = createUserAlerts;
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	var ActionUtility = __webpack_require__(95);
	var RosterSelectors = __webpack_require__(6);
	var SelectorUtility = __webpack_require__(144);
	var Queries = __webpack_require__(109);
	var CurrentUser = __webpack_require__(3);
	
	////////////////////////////////////////
	// Bulk fetch //////////////////////////
	////////////////////////////////////////
	
	var GLOBAL_STUDENT_EMBEDS = exports.GLOBAL_STUDENT_EMBEDS = ["student.prefs", "student.avatar", "student.student_list_ids", "student.primary_student_list_id", "student.current_reading_level", "student.expectations_date_spans", "student.password", "student.sso_data", "student.student_list_ids"];
	
	var GLOBAL_STUDENT_LIST_EMBEDS = exports.GLOBAL_STUDENT_LIST_EMBEDS = [["student_list.expectations_date_spans", "student_list.passphrase", "student_list.school", "student_list.prefs", "student_list.student_ids", "student_list.admin_ids"]];
	
	// Fetches all school and district data the admin account (current user) needs
	function fetchOrgData() {
		return function (dispatch, getState) {
			// I'll need getState for CurrentUser... someday
			var fetchPromises = [];
	
			if (CurrentUser.isAdmin()) {
				fetchPromises.push(dispatch(fetchAdmins({
					embeds: ["admin.org_ids", "admin.prefs"]
				})));
			}
	
			if (CurrentUser.isDistrictAdmin()) {
				fetchPromises.push(dispatch(fetchSchoolOrgs({
					embeds: ["school_org.prefs"]
				})));
			}
			return Promise.all(fetchPromises);
		};
	}
	
	// Fetches all roster data the admin account (current user) needs
	function fetchRosterData() {
		return function (dispatch, getState) {
			// I'll need getState for CurrentUser... someday
			var fetchPromises = [];
	
			// if (CurrentUser.isAdmin() && CurrentUser.isTeacherAdmin()) {
			// Fetch students
			fetchPromises.push(dispatch(fetchStudents({
				embeds: GLOBAL_STUDENT_EMBEDS
			})));
	
			// Fetch student lists in batches for large accounts
			if (_.size(CurrentUser.get().student_list_ids) > 35) {
				var chunkedSLs = _.chunk(CurrentUser.get().student_list_ids, 35);
				_.each(chunkedSLs, function (chunk, i) {
					fetchPromises.push(dispatch(fetchStudentLists({
						conditions: { slIDs: chunk },
						embeds: ["student.prefs", "student_list.students", "student_list.prefs", "student_list.expectations_date_spans", "student_list.admins"]
					})));
				});
			} else {
				// Fetch student lists all at once batches for smaller accounts
				fetchPromises.push(dispatch(fetchStudentLists({
					embeds: ["student.prefs", "student_list.students", "student_list.prefs", "student_list.expectations_date_spans", "student_list.admins"]
				})));
			}
			// }
	
			// if (CurrentUser.isSchoolAdmin() || CurrentUser.isDistrictAdmin()) {
			// 	fetchPromises.push(dispatch(fetchAdmins({
			// 		embeds: [
			// 			"admin.org_ids", "admin.prefs"
			// 		]
			// 	})));
			// }
	
			// if (CurrentUser.isDistrictAdmin()) {
			// 	fetchPromises.push(dispatch(fetchSchoolOrgs({
			// 		embeds: [
			// 			"school_org.prefs"
			// 		]
			// 	})));
			// }
			return Promise.all(fetchPromises);
		};
	}
	
	////////////////////////////////////////
	// Admins //////////////////////////////
	////////////////////////////////////////
	
	function fetchAdmins(_ref) {
		var filters = _ref.filters,
		    conditions = _ref.conditions,
		    loading = _ref.loading,
		    embeds = _ref.embeds,
		    cache = _ref.cache;
	
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getAdmins, { admins: [Schema.ADMIN] }, { params: params, embeds: embeds }, { reducer: "admins", loading: loading || "index", cache: cache }));
		};
	}
	
	function updateAdmin(_ref2) {
		var id = _ref2.id,
		    update = _ref2.update,
		    embeds = _ref2.embeds,
		    query = _ref2.query;
	
		var params = _.extend({}, query, { admin: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, admins: [id], update: update });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchAdmin.bind(null, id), { admin: Schema.ADMIN }, { params: params, embeds: embeds }, { reducer: "admins", loading: "update" }));
		};
	}
	
	function createAdmin(_ref3) {
		var admin = _ref3.admin,
		    embeds = _ref3.embeds,
		    query = _ref3.query,
		    subAdmins = _ref3.subAdmins;
	
		var params = _.extend({}, query, { admin: admin });
	
		if (subAdmins) {
			params.sub_admins = subAdmins;
		}
	
		return function (dispatch) {
	
			return dispatch(ActionUtility.fetchRecords(APIClient.postAdmins, { admin: Schema.ADMIN }, { embeds: embeds, params: params, query: query }, { reducer: "admins", loading: "create" }));
		};
	}
	
	function clearAdmins(_ref4) {
		_objectDestructuringEmpty(_ref4);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, admins: true });
		};
	}
	
	////////////////////////////////////////
	// Awards //////////////////////////////
	////////////////////////////////////////
	
	function createAward(_ref5) {
		var award = _ref5.award;
	
		return function (dispatch) {
			return APIClient.postAwards({ award: award });
		};
	}
	
	////////////////////////////////////////
	// Discount Tokens /////////////////////
	////////////////////////////////////////
	
	function fetchDiscountToken(_ref6) {
		var code = _ref6.code,
		    query = _ref6.query;
	
		var params = _.extend({}, query);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getDiscountToken, code, { discount_token: Schema.DISCOUNT_TOKEN }, { params: params }, { reducer: "discountTokens", loading: code }));
		};
	}
	
	function fetchDiscountTokens(_ref7) {
		var filters = _ref7.filters,
		    conditions = _ref7.conditions,
		    embeds = _ref7.embeds,
		    cache = _ref7.cache,
		    loading = _ref7.loading;
	
		var params = Queries.toQuery(filters, conditions);
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getDiscountTokens, { discount_tokens: [Schema.DISCOUNT_TOKEN] }, { params: params, embeds: embeds }, { reducer: "discountTokens", loading: loading || "index", cache: cache }));
		};
	}
	
	function createDiscountTokens(_ref8) {
		var discountTokens = _ref8.discountTokens,
		    embeds = _ref8.embeds;
	
		var params = { discount_tokens: discountTokens };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postDiscountTokens, { discount_tokens: [Schema.DISCOUNT_TOKENS] }, { embeds: embeds, params: params }, { reducer: "discountTokens", loading: "create" }));
		};
	}
	
	function updateDiscountToken(_ref9) {
		var id = _ref9.id,
		    update = _ref9.update,
		    embeds = _ref9.embeds,
		    query = _ref9.query;
	
		var params = _.extend({}, query, { discount_token: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, discountTokens: [id], update: update });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchDiscountToken.bind(null, id), { discount_token: [Schema.DISCOUNT_TOKEN] }, { params: params, embeds: embeds }, { reducer: "discountTokens", loading: "update" }));
		};
	}
	
	function deleteDiscountToken(_ref10) {
		var id = _ref10.id;
	
		return function (dispatch) {
			APIClient.deleteDiscountToken(id);
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, discountTokens: [id] });
		};
	}
	
	function clearDiscountTokens(_ref11) {
		_objectDestructuringEmpty(_ref11);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, discountTokens: true });
		};
	}
	
	////////////////////////////////////////
	// DistrictOrgs ////////////////////////
	////////////////////////////////////////
	
	function createDistrictOrg(_ref12) {
		var districtOrg = _ref12.districtOrg,
		    embeds = _ref12.embeds;
	
		var params = { district_org: districtOrg };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postDistrictOrgs, { district_org: Schema.DISTRICT_ORG }, { embeds: embeds, params: params }, { reducer: "districtOrgs", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// Prefs ///////////////////////////////
	////////////////////////////////////////
	
	function updateAdminPrefs(_ref13) {
		var id = _ref13.id,
		    update = _ref13.update,
		    resetStudentLists = _ref13.resetStudentLists,
		    embeds = _ref13.embeds,
		    query = _ref13.query;
	
	
		return function (dispatch, getState) {
			// LOCAL ADMIN update
			var admin = getState().admins[id];
			if (admin) {
				var updatedPrefs = _.extend({}, admin.prefs, update);
				dispatch({ type: ActionUtility.UPDATE_RECORDS,
					admins: [id], update: { prefs: updatedPrefs } });
			}
	
			// LOCAL STUDENTLIST UPDATE
			if (resetStudentLists) {
				var studentLists = RosterSelectors.studentListsByAdminId({ state: getState(), adminId: id });
				if (!_.isEmpty(studentLists)) {
					_.each(studentLists, function (studentList) {
						// SET STUDENT LIST PREF TO ADMIN PREF | FORCE RESET OF STUDENTS WITH TRUE
						localStudentListPrefsUpdate(dispatch, getState, studentList, update, true);
					});
				}
			}
	
			// REMOTE update
			var params = _.extend({}, query, { admin: { prefs: update } });
			if (resetStudentLists) {
				params.admin.reset_student_list_prefs = _.keys(update);
				params.admin.reset_student_prefs = _.keys(update);
			}
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchAdmin.bind(null, id), { student: Schema.ADMIN }, { params: params, embeds: embeds }, { reducer: "admins", loading: "update" }));
		};
	
		var params = _.extend({}, query, { admin: update });
	}
	
	function updateStudentPrefs(_ref14) {
		var studentID = _ref14.studentID,
		    update = _ref14.update,
		    embeds = _ref14.embeds,
		    query = _ref14.query;
	
		// We need to split out the updates. We want to PATCH the prefs on their own
		// but we want to merge them into all the other student prefs locally
	
		return function (dispatch, getState) {
			// LOCAL update
			var student = getState().students[studentID];
			if (student) {
				localStudentPrefsUpdate(dispatch, student, update);
			}
	
			// REMOTE update
			var params = _.extend({}, query, { student: { prefs: update } });
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudent.bind(null, studentID), { student: Schema.STUDENT }, { params: params, embeds: embeds }, { reducer: "students", loading: "update" }));
		};
	}
	
	function massUpdateStudentPrefs(_ref15) {
		var studentIDs = _ref15.studentIDs,
		    subgroupKey = _ref15.subgroupKey,
		    update = _ref15.update,
		    embeds = _ref15.embeds,
		    query = _ref15.query;
	
		// We need to split out the updates. We want to PATCH the prefs on their own
		// but we want to merge them into all the other student prefs locally
	
		return function (dispatch, getState) {
			if (!studentIDs && subgroupKey) {
				var students = RosterSelectors.studentsForSubgroupKey({ state: getState(), subgroupKey: subgroupKey });
				studentIDs = _.pluck(students, "id");
			} else {
				var students = _.values(_.pick(getState().students, studentIDs));
			}
	
			// LOCAL update
			_.each(students, function (student) {
				localStudentPrefsUpdate(dispatch, student, update);
			});
	
			// REMOTE update
			var params = _.extend({ mass_update: true }, query, { students: { prefs: update } });
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudent.bind(null, studentIDs.join(",")), { students: [Schema.STUDENT] }, { params: params, embeds: embeds }, { reducer: "students", loading: "update" }));
		};
	}
	
	function updateStudentList(_ref16) {
		var id = _ref16.id,
		    update = _ref16.update,
		    embeds = _ref16.embeds,
		    query = _ref16.query;
	
		var params = _.extend({}, query, { student_list: update });
	
		return function (dispatch, getState) {
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				studentLists: [id],
				update: _.omit(update, "prefs")
			});
	
			// Update prefs on their own
			var studentList = getState().studentLists[id];
			if (studentList && update.prefs) {
				localStudentListPrefsUpdate(dispatch, getState, studentList, update, false);
			}
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudentList.bind(null, id), { student: Schema.STUDENT_LIST }, { params: params, embeds: embeds }, { reducer: "studentList", loading: "update" }));
		};
	}
	
	function postUserTrigger(user_id, params) {
		return function (dispatch) {
			return APIClient.postUserTrigger(user_id, params);
		};
	}
	
	function updateStudentListPrefs(_ref17) {
		var studentListID = _ref17.studentListID,
		    resetStudents = _ref17.resetStudents,
		    update = _ref17.update,
		    embeds = _ref17.embeds,
		    query = _ref17.query;
	
	
		return function (dispatch, getState) {
			// LOCAL update
			var studentList = getState().studentLists[studentListID];
			if (studentList) {
				localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents);
			}
	
			// // REMOTE update
			var params = _.extend({}, query, { student_list: { prefs: update } });
			if (resetStudents) {
				params.student_list.reset_student_prefs = _.keys(update);
			}
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudentList.bind(null, studentListID), { studentList: Schema.STUDENT_LIST }, { params: params, embeds: embeds }, { reducer: "studentLists", loading: "update" }));
		};
	}
	
	function updateAllStudentListPrefs(_ref18) {
		var currentUserID = _ref18.currentUserID,
		    resetStudents = _ref18.resetStudents,
		    update = _ref18.update,
		    embeds = _ref18.embeds,
		    query = _ref18.query;
	
	
		return function (dispatch, getState) {
			// LOCAL update
			var studentLists = SelectorUtility.allRecords(getState().studentLists);
			if (!_.isEmpty(studentLists)) {
				_.each(studentLists, function (studentList) {
					localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents);
				});
			}
	
			// REMOTE update
			var params = _.extend({}, query, { admin: { all_student_list_prefs: update } });
			if (resetStudents) {
				params.admin.reset_student_prefs = _.keys(update);
			}
			return dispatch(ActionUtility.fetchRecords(APIClient.patchAdmin.bind(null, currentUserID), { admin: Schema.ADMIN }, { params: params, embeds: embeds }, { reducer: "admins", loading: "update" }));
		};
	}
	
	function archiveStudentList(_ref19) {
		var id = _ref19.id;
	
		return function (dispatch) {
			APIClient.deleteStudentList(id, { archive: true });
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, studentLists: [id] });
		};
	}
	
	function updateDistrictOrgPrefs(_ref20) {
		var currentUserID = _ref20.currentUserID,
		    districtOrgID = _ref20.districtOrgID,
		    resetPrefs = _ref20.resetPrefs,
		    update = _ref20.update,
		    embeds = _ref20.embeds,
		    query = _ref20.query;
	
		return function (dispatch, getState) {
			// LOCAL update
			var districtOrg = getState().districtOrgs[districtOrgID];
			if (districtOrg) {
				localDistrictOrgPrefsUpdate(dispatch, getState, districtOrg, update, resetPrefs);
			}
			// ADD SCHOOL, STUDENTLIST AND ADMIN's preferences update
	
			// // REMOTE update
			var params = _.extend({}, query, { user_id: currentUserID, district_org: { prefs: update } });
			if (resetPrefs) {
				params.district_org.reset_prefs = _.keys(update);
			}
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchDistrictOrg.bind(null, districtOrgID), { districtOrgID: Schema.DISTRICT_ORG }, { params: params, embeds: embeds }, { reducer: "district_org", loading: "update" }));
		};
	}
	
	function updateSchoolOrgPrefs(_ref21) {
		var currentUserID = _ref21.currentUserID,
		    schoolOrgID = _ref21.schoolOrgID,
		    resetPrefs = _ref21.resetPrefs,
		    update = _ref21.update,
		    embeds = _ref21.embeds,
		    query = _ref21.query;
	
		return function (dispatch, getState) {
	
			//LOCAL UPDATE
			var schoolOrg = getState().schoolOrgs[schoolOrgID];
			if (schoolOrg) {
				localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, resetPrefs);
			}
	
			// REMOTE update
			var params = _.extend({}, query, { user_id: currentUserID, school_org: { prefs: update } });
			if (resetPrefs) {
				params.school_org.reset_prefs = _.keys(update);
			}
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchSchoolOrg.bind(null, schoolOrgID), { schoolOrgID: Schema.SCHOOL_ORG }, { params: params, embeds: embeds }, { reducer: "school_org", loading: "update" }));
		};
	}
	
	/// LOCAL UPDATES FOR PREFS
	function localGeneralPrefUpdate(dispatch, getState, update) {
	
		_.each(_.values(getState().school_orgs), function (schoolOrg) {
			localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, false);
		});
	
		_.each(_.values(getState().admins), function (admin) {
			localAdminPrefsUpdate(dispatch, admin, update);
		});
	
		_.each(_.values(getState().student_lists), function (studentList) {
			localStudentListPrefsUpdate(dispatch, getState, studentList, update, false);
		});
	
		_.each(_.values(getState().students), function (student) {
			localStudentPrefsUpdate(dispatch, student, update, false);
		});
	}
	
	function localDistrictOrgPrefsUpdate(dispatch, getState, districtOrg, update, resetPrefs) {
		var updatedPrefs = _.extend({}, districtOrg.prefs, update);
		dispatch({ type: ActionUtility.UPDATE_RECORDS,
			districtOrgs: [districtOrg.id], update: { prefs: updatedPrefs } });
	
		// LOCAL GENERAL UPDATE
		if (resetPrefs) {
			localGeneralPrefUpdate(dispatch, getState, update);
		}
	}
	
	function localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, resetPrefs) {
	
		// LOCAL GENERAL UPDATE
		if (resetPrefs) {
			localGeneralPrefUpdate(dispatch, getState, update);
		} else {
			var updatedPrefs = _.extend({}, schoolOrg.prefs, update);
			dispatch({ type: ActionUtility.UPDATE_RECORDS,
				schoolOrgs: [schoolOrg.id], update: { prefs: updatedPrefs } });
		}
	}
	
	function localAdminPrefsUpdate(dispatch, admin, update) {
		var updatedPrefs = _.extend({}, admin.prefs, update);
		dispatch({ type: ActionUtility.UPDATE_RECORDS,
			admins: [admin.id], update: { prefs: updatedPrefs } });
	}
	
	function localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents) {
		var updatedPrefs = _.extend({}, studentList.prefs, update);
		dispatch({ type: ActionUtility.UPDATE_RECORDS,
			studentLists: [studentList.id], update: { prefs: updatedPrefs } });
	
		if (resetStudents) {
			var students = RosterSelectors.studentsForStudentListID({ state: getState(), studentListID: studentList.id });
			if (!_.isEmpty(students)) {
				_.each(students, function (student) {
					localStudentPrefsUpdate(dispatch, student, update);
				});
			}
		}
	}
	
	function localStudentPrefsUpdate(dispatch, student, update) {
		var updatedPrefs = _.extend({}, student.prefs, update);
		dispatch({ type: ActionUtility.UPDATE_RECORDS,
			students: [student.id], update: { prefs: updatedPrefs } });
	}
	
	////////////////////////////////////////
	// Referrals ///////////////////////////
	////////////////////////////////////////
	
	function postReferrals(_ref22) {
		var referral = _ref22.referral;
	
		return function (dispatch) {
			return APIClient.postReferrals({ referral: referral });
		};
	}
	
	////////////////////////////////////////
	// Schools ////////////////////////
	////////////////////////////////////////
	
	function fetchSchool(_ref23) {
		var id = _ref23.id,
		    embeds = _ref23.embeds,
		    query = _ref23.query;
	
		var params = _.extend({}, query);
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getSchool, id, { school: Schema.SCHOOL }, { embeds: embeds, params: params }, { reducer: "schools", loading: id }));
		};
	}
	
	function createSchool(_ref24) {
		var school = _ref24.school,
		    embeds = _ref24.embeds;
	
		var params = { school: school };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postSchools, { school: Schema.SCHOOL }, { embeds: embeds, params: params }, { reducer: "schools", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// Rosters /////////////////////////////
	////////////////////////////////////////
	
	function postRosters(_ref25) {
		var studentsData = _ref25.studentsData,
		    noBackground = _ref25.noBackground,
		    effectiveUserID = _ref25.effectiveUserID;
	
		return function (dispatch) {
			var data = {
				students_data: studentsData,
				no_background: noBackground
			};
			if (effectiveUserID) {
				data.effective_user_id = effectiveUserID;
			}
			return APIClient.postRosters(data);
		};
	}
	
	////////////////////////////////////////
	// SchoolOrgs ////////////////////////
	////////////////////////////////////////
	
	function fetchSchoolOrgs(_ref26) {
		var filters = _ref26.filters,
		    conditions = _ref26.conditions,
		    embeds = _ref26.embeds,
		    cache = _ref26.cache;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getSchoolOrgs, { school_orgs: [Schema.SCHOOL_ORG] }, { params: params, embeds: embeds }, { reducer: "schoolOrgs", loading: "index", cache: cache }));
		};
	}
	
	function fetchSchoolOrgsPaginated(_ref27) {
		var filters = _ref27.filters,
		    conditions = _ref27.conditions,
		    embeds = _ref27.embeds,
		    cache = _ref27.cache,
		    page = _ref27.page;
	
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page: page };
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getSchoolOrgs, { school_orgs: [Schema.SCHOOL_ORG] }, { params: params, embeds: embeds }, { reducer: "schoolOrgs", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function createSchoolOrg(_ref28) {
		var schoolOrg = _ref28.schoolOrg,
		    embeds = _ref28.embeds;
	
		var params = { school_org: schoolOrg };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postSchoolOrgs, { school_org: Schema.SCHOOL_ORG }, { embeds: embeds, params: params }, { reducer: "schoolOrgs", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// DistrictOrgs ////////////////////////
	////////////////////////////////////////
	
	function fetchDistrictOrgs(_ref29) {
		var filters = _ref29.filters,
		    conditions = _ref29.conditions,
		    embeds = _ref29.embeds,
		    cache = _ref29.cache;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getDistrictOrgs, { district_orgs: [Schema.DISTRICT_ORG] }, { params: params, embeds: embeds }, { reducer: "districtOrgs", loading: "index", cache: cache }));
		};
	}
	
	function fetchDistrictOrgsPaginated(_ref30) {
		var filters = _ref30.filters,
		    conditions = _ref30.conditions,
		    embeds = _ref30.embeds,
		    cache = _ref30.cache,
		    page = _ref30.page;
	
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page: page };
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getDistrictOrgs, { district_orgs: [Schema.DISTRICT_ORG] }, { params: params, embeds: embeds }, { reducer: "districtOrgs", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	////////////////////////////////////////
	// StudentLists ////////////////////////
	////////////////////////////////////////
	
	function fetchStudentLists(_ref31) {
		var filters = _ref31.filters,
		    conditions = _ref31.conditions,
		    loading = _ref31.loading,
		    embeds = _ref31.embeds,
		    cache = _ref31.cache;
	
		var params = Queries.toQuery(filters, conditions);
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getStudentLists, { student_lists: [Schema.STUDENT_LIST] }, { params: params, embeds: embeds }, { reducer: "studentLists", loading: loading || "index", cache: cache }));
		};
	}
	
	function fetchStudentListsStoreless(_ref32) {
		var query = _ref32.query;
	
		return function (dispatch) {
			return APIClient.getStudentLists(query);
		};
	}
	
	function fetchStudentList(_ref33) {
		var id = _ref33.id,
		    embeds = _ref33.embeds,
		    query = _ref33.query,
		    cache = _ref33.cache;
	
		var params = _.extend({}, query);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getStudentList, id, { student_list: Schema.STUDENT_LIST }, { params: params, embeds: embeds }, { reducer: "studentLists", loading: id, cache: cache }));
		};
	}
	
	function invalidateStudentListCache(_ref34) {
		_objectDestructuringEmpty(_ref34);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.INVALIDATE_CACHE, studentLists: true });
		};
	}
	
	function postStudentLists(_ref35) {
		var studentLists = _ref35.studentLists,
		    embeds = _ref35.embeds;
	
		return function (dispatch) {
			return APIClient.postStudentLists({ student_lists: studentLists, embeds: embeds });
		};
	}
	
	function clearStudentLists(_ref36) {
		_objectDestructuringEmpty(_ref36);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, studentLists: true });
		};
	}
	
	////////////////////////////////////////
	// Students ////////////////////////////
	////////////////////////////////////////
	
	function fetchStudents(_ref37) {
		var filters = _ref37.filters,
		    conditions = _ref37.conditions,
		    embeds = _ref37.embeds,
		    loading = _ref37.loading,
		    cache = _ref37.cache;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getStudents, { students: [Schema.STUDENT] }, { params: params, embeds: embeds }, { reducer: "students", loading: loading || 'index', cache: cache }));
		};
	}
	
	function fetchStudent(_ref38) {
		var id = _ref38.id,
		    embeds = _ref38.embeds,
		    query = _ref38.query;
	
		var params = _.extend({}, query);
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getStudent, id, { student: Schema.STUDENT }, { embeds: embeds, params: params }, { reducer: "students", loading: id }));
		};
	}
	
	function updateStudent(_ref39) {
		var id = _ref39.id,
		    update = _ref39.update,
		    embeds = _ref39.embeds,
		    query = _ref39.query;
	
		var params = _.extend({}, query, { student: update });
	
		return function (dispatch, getState) {
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				students: [id],
				update: _.omit(update, "prefs")
			});
	
			// Update prefs on their own
			var student = getState().students[id];
			if (student && update.prefs) {
				var updatedPrefs = _.extend({}, student.prefs, update.prefs);
				dispatch({
					type: ActionUtility.UPDATE_RECORDS,
					students: [id],
					update: { prefs: updatedPrefs }
				});
			}
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudent.bind(null, id), { student: Schema.STUDENT }, { params: params, embeds: embeds }, { reducer: "students", loading: "update" }));
		};
	}
	
	// updates multiple students
	function updateStudents(_ref40) {
		var studentIDs = _ref40.studentIDs,
		    updates = _ref40.updates,
		    embeds = _ref40.embeds,
		    query = _ref40.query;
	
		var params = _.extend({}, query, { student_ids: studentIDs, updates: updates });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, updates: updates });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudents, { students: [Schema.STUDENT] }, { params: params, embeds: embeds }, { reducer: "students", loading: "update" }));
		};
	}
	
	// destroys multiple students
	function destroyStudents(_ref41) {
		var studentIDs = _ref41.studentIDs,
		    embeds = _ref41.embeds,
		    query = _ref41.query;
	
		var params = _.extend({}, query, { student_ids: studentIDs, destroy: true });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, destroy: true });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchStudents, { students: [Schema.STUDENT] }, { params: params, embeds: embeds }, { reducer: "students", loading: "delete" }));
		};
	}
	
	// removes students from student lists
	function deleteStudents(_ref42) {
		var id = _ref42.id,
		    slIDs = _ref42.slIDs;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.REMOVE_RECORDS, students: [id] });
			return APIClient.deleteStudent(id, { student_list_ids: slIDs });
		};
	}
	
	function clearStudents(_ref43) {
		_objectDestructuringEmpty(_ref43);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, students: true });
		};
	}
	
	////////////////////////////////////////
	// Parents ////////////////////////////
	////////////////////////////////////////
	
	function fetchParent(_ref44) {
		var id = _ref44.id,
		    embeds = _ref44.embeds,
		    query = _ref44.query;
	
		var params = _.extend({}, query);
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getParent, id, { parent: Schema.PARENT }, { embeds: embeds, params: params }, { reducer: "parents", loading: id }));
		};
	}
	
	function createParents(_ref45) {
		var studentIDs = _ref45.studentIDs,
		    parentEmails = _ref45.parentEmails,
		    embeds = _ref45.embeds,
		    query = _ref45.query;
	
		var params = _.extend({}, query, {
			parents: { student_ids: studentIDs, auth_emails: parentEmails }
		});
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postParents, { parents: [Schema.PARENT] }, // Currently, this happens in a background job, so no data
			{ embeds: embeds, params: params }, { reducer: "parents", loading: "create" }));
		};
	}
	
	function updateParent(_ref46) {
		var id = _ref46.id,
		    update = _ref46.update,
		    embeds = _ref46.embeds,
		    query = _ref46.query;
	
		var params = _.extend({}, query, { parent: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, parents: [id], update: update });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchParent.bind(null, id), { parent: Schema.PARENT }, { params: params, embeds: embeds }, { reducer: "parents", loading: "update" }));
		};
	}
	
	////////////////////////////////////////
	// Upgrade Tokens //////////////////////
	////////////////////////////////////////
	
	function fetchUpgradeTokens(_ref47) {
		var filters = _ref47.filters,
		    conditions = _ref47.conditions,
		    embeds = _ref47.embeds,
		    cache = _ref47.cache,
		    loading = _ref47.loading;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getUpgradeTokens, { upgrade_tokens: [Schema.UPGRADE_TOKEN] }, { params: params, embeds: embeds }, { reducer: "upgradeTokens", loading: loading || "index", cache: cache }));
		};
	}
	
	function updateUpgradeToken(_ref48) {
		var id = _ref48.id,
		    update = _ref48.update,
		    embeds = _ref48.embeds,
		    query = _ref48.query;
	
		var params = _.extend({}, query, { upgrade_token: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, upgradeTokens: [id], update: update });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchUpgradeToken.bind(null, id), { upgrade_token: [Schema.UPGRADE_TOKEN] }, { params: params, embeds: embeds }, { reducer: "upgradeTokens", loading: "update" }));
		};
	}
	
	function clearUpgradeTokens(_ref49) {
		_objectDestructuringEmpty(_ref49);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, upgradeTokens: true });
		};
	}
	
	function createUpgradeTokens(_ref50) {
		var upgradeTokens = _ref50.upgradeTokens,
		    embeds = _ref50.embeds;
	
		var params = { upgrade_tokens: upgradeTokens };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postUpgradeTokens, { upgrade_tokens: [Schema.UPGRADE_TOKEN] }, { embeds: embeds, params: params }, { reducer: "upgradeTokens", loading: "create" }));
		};
	}
	
	function deleteUpgradeToken(_ref51) {
		var id = _ref51.id;
	
		return function (dispatch) {
			APIClient.deleteUpgradeToken(id);
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, upgradeTokens: [id] });
		};
	}
	
	////////////////////////////////////////
	// Users ///////////////////////////////
	////////////////////////////////////////
	
	function fetchUsersStoreless(_ref52) {
		var query = _ref52.query;
	
		return APIClient.getUsers(query);
	}
	
	function mergeStudents(_ref53) {
		var mapping = _ref53.mapping;
	
		return APIClient.postStudentsMerge({ mapping: mapping });
	}
	
	////////////////////////////////////////
	// Notifications ///////////////////////
	////////////////////////////////////////
	
	function createUserAlerts(_ref54) {
		var on = _ref54.on,
		    userAlert = _ref54.userAlert;
	
		return function (dispatch) {
			return APIClient.postUserAlerts({ user_alert: userAlert, on: on });
		};
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	
	function ___$insertStyle(css) {
	  if (!css) {
	    return;
	  }
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  var style = document.createElement('style');
	
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	  document.head.appendChild(style);
	  return css;
	}
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(20));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var CONSTANT = {
	  GLOBAL: {
	    HIDE: "__react_tooltip_hide_event",
	    REBUILD: "__react_tooltip_rebuild_event",
	    SHOW: "__react_tooltip_show_event"
	  }
	};
	
	/**
	 * Static methods for react-tooltip
	 */
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event;
	
	  if (typeof window.CustomEvent === "function") {
	    event = new window.CustomEvent(eventName, {
	      detail: opts
	    });
	  } else {
	    event = document.createEvent("Event");
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	};
	
	function staticMethods (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
	      target: target
	    });
	  };
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	
	
	  target.rebuild = function () {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
	  };
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	
	
	  target.show = function (target) {
	    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
	      target: target
	    });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = {
	        currentTarget: event.detail.target
	      };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({
	        currentTarget: hasTarget && event.detail.target
	      }, hasTarget);
	    }
	  };
	}
	
	/**
	 * Events that should be bound to the window
	 */
	function windowListener (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
	
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
	
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
	
	    if (resizeHide) {
	      window.removeEventListener("resize", this.onWindowResize);
	      window.addEventListener("resize", this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener("resize", this.onWindowResize);
	  };
	  /**
	   * invoked by resize event of window
	   */
	
	
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	}
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute("currentItem");
	  if (!isCapture) e.stopPropagation();
	
	  if (show && currentItem === "true") {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute("currentItem", "true");
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute("currentItem", "false");
	    } else {
	      targetArray[i].setAttribute("currentItem", "true");
	    }
	  }
	};
	
	var customListeners = {
	  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};
	function customEvent (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	    return event || !!ele.getAttribute("data-event");
	  };
	  /* Bind listener for custom event */
	
	
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff;
	    var dataEvent = ele.getAttribute("data-event") || event;
	    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
	    dataEvent.split(" ").forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	
	    if (dataEventOff) {
	      dataEventOff.split(" ").forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	  /* Unbind listener for custom event */
	
	
	  target.prototype.customUnbindListener = function (ele) {
	    var _this$state2 = this.state,
	        event = _this$state2.event,
	        eventOff = _this$state2.eventOff;
	    var dataEvent = event || ele.getAttribute("data-event");
	    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	}
	
	/**
	 * Util method to judge if it should follow capture model
	 */
	function isCapture (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	function getEffect (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute("data-effect");
	    return dataEffect || this.props.effect || "float";
	  };
	}
	
	/**
	 * Util method to get effect
	 */
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	
	  for (var key in e) {
	    if (typeof e[key] === "function") {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	
	  return proxy;
	};
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
	  var id = this.props.id;
	  var tip = e.target.getAttribute("data-tip") || null;
	  var forId = e.target.getAttribute("data-for") || null;
	  var target = e.target;
	
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(" ").forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName("body")[0];
	};
	
	function bodyMode (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _this$state = this.state,
	        event = _this$state.event,
	        eventOff = _this$state.eventOff,
	        possibleCustomEvents = _this$state.possibleCustomEvents,
	        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
	    var body = getBody();
	    var customEvents = findCustomEvents(targetArray, "data-event");
	    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(" ").forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(" ").forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	    this.unbindBodyListener(body);
	    var listeners = this.bodyModeListeners = {};
	
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
	        respectEffect: true
	      });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
	        checkStatus.call(_this, targetEventOff, e);
	      }, {
	        customEvent: true
	      });
	    }
	
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
	        customEvent: true
	      });
	    }
	
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	    var listeners = this.bodyModeListeners;
	
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	}
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};
	
	function trackRemoval (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	
	            return;
	          }
	        }
	      }
	    });
	    observer.observe(window.document, {
	      childList: true,
	      subtree: true
	    });
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	}
	
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	function getPosition (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  }; //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	
	
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  }; // Check whether the tooltip with orientation p is completely inside the client window
	
	
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ["top", "bottom", "left", "right"];
	  var insideList = [];
	
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace;
	  var shouldUpdatePlace = desiredPlace !== place;
	
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: {
	        place: newPlace
	      }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	}
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	}; // Get current mouse offset
	
	
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === "float") {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	}; // List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	
	
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top;
	  var right;
	  var bottom;
	  var left;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === "float") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === "solid") {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	}; // Consider additional offset into position calculation
	
	
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === "[object String]") {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
	  }
	
	  for (var key in offset) {
	    if (key === "top") {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === "bottom") {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === "left") {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === "right") {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return {
	    extraOffset_X: extraOffset_X,
	    extraOffset_Y: extraOffset_Y
	  };
	}; // Get the offset of the parent elements
	
	
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	  return {
	    parentTop: parentTop,
	    parentLeft: parentLeft
	  };
	};
	
	/**
	 * To get the tooltip content
	 * it may comes from data-tip or this.props.children
	 * it should support multiline
	 *
	 * @params
	 * - `tip` {String} value of data-tip
	 * - `children` {ReactElement} this.props.children
	 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
	 *
	 * @return
	 * - String or react component
	 */
	function getTipContent (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	
	  if (!multiline || multiline === "false" || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  } // Multiline tooltip content
	
	
	  return tip.split(regexp).map(function (d, i) {
	    return React.createElement("span", {
	      key: i,
	      className: "multi-line"
	    }, d);
	  });
	}
	
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return /(^aria-\w+$|^role$)/.test(prop);
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	  return ariaObj;
	}
	
	/**
	 * Convert nodelist to array
	 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
	 * NodeLists are functions in Safari
	 */
	function nodeListToArray (nodeList) {
	  var length = nodeList.length;
	
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	}
	
	___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
	
	var _class, _class2, _temp;
	
	var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    var _this;
	
	    _classCallCheck(this, ReactTooltip);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
	    _this.state = {
	      place: props.place || "top",
	      // Direction of tooltip
	      desiredPlace: props.place || "top",
	      type: "dark",
	      // Color theme of tooltip
	      effect: "float",
	      // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: "",
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null,
	      // Current mouse event
	      currentTarget: null,
	      // Current target of mouse event
	      ariaProps: parseAria(props),
	      // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || "",
	      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: "bind",
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          insecure = _this$props.insecure,
	          resizeHide = _this$props.resizeHide;
	
	      this.bindListener(); // Bind listener for tooltip
	
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mount = false;
	      this.clearTimer();
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: "mouseOnToolTip",
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	
	        return this.tooltipRef.matches(":hover");
	      }
	
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: "getTargetArray",
	    value: function getTargetArray(id) {
	      var targetArray;
	
	      if (!id) {
	        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
	      } else {
	        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
	      } // targetArray is a NodeList, convert it to a real array
	
	
	      return nodeListToArray(targetArray);
	    }
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: "bindListener",
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          id = _this$props2.id,
	          globalEventOff = _this$props2.globalEventOff,
	          isCapture = _this$props2.isCapture;
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        if (target.getAttribute("currentItem") === null) {
	          target.setAttribute("currentItem", "false");
	        }
	
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	
	          var effect = _this3.getEffect(target);
	
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	
	            return;
	          }
	
	          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
	
	          if (effect === "float") {
	            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
	          }
	
	          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
	        });
	      } // Global event to hide tooltip
	
	
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      } // Track removal of targetArray elements from DOM
	
	
	      this.bindRemovalTracker();
	    }
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: "unbindListener",
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _this$props3 = this.props,
	          id = _this$props3.id,
	          globalEventOff = _this$props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: "unbindBasicListener",
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
	      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
	      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _this$props4 = this.props,
	          getContent = _this$props4.getContent,
	          children = _this$props4.children; // Generate tooltip content
	
	      var content;
	
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: "isEmptyTip",
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
	    }
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: "showTooltip",
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      } // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	
	
	      var _this$props5 = this.props,
	          multiline = _this$props5.multiline,
	          getContent = _this$props5.getContent;
	      var originTooltip = e.currentTarget.getAttribute("data-tip");
	      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
	
	      var scrollHide = true;
	
	      if (e.currentTarget.getAttribute("data-scroll-hide")) {
	        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      } // Make sure the correct place is set
	
	
	      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
	      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
	      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
	
	      this.clearTimer();
	      var target = e.currentTarget;
	      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute("data-type") || self.props.type || "dark",
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
	          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
	          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
	          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
	          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
	          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      }; // If there is no delay call immediately, don't allow events to get in first.
	
	
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: "updateTooltip",
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _this$state = this.state,
	          delayShow = _this$state.delayShow,
	          disable = _this$state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	    /*
	     * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: "listenForTooltipExit",
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	  }, {
	    key: "removeListenerForTooltipExit",
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
	      }
	    }
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltip",
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	        isScroll: false
	      };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	
	          return;
	        }
	
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: "hideTooltipOnScroll",
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, {
	        isScroll: true
	      });
	    }
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: "addScrollListener",
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: "removeScrollListener",
	    value: function removeScrollListener() {
	      window.removeEventListener("scroll", this.hideTooltipOnScroll);
	    } // Calculation the position
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _this$state2 = this.state,
	          currentEvent = _this$state2.currentEvent,
	          currentTarget = _this$state2.currentTarget,
	          place = _this$state2.place,
	          desiredPlace = _this$state2.desiredPlace,
	          effect = _this$state2.effect,
	          offset = _this$state2.offset;
	      var node = this.tooltipRef;
	      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      } // Set tooltip position
	
	
	      node.style.left = result.position.left + "px";
	      node.style.top = result.position.top + "px";
	    }
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	    /* setStyleHeader() {
	      const head = document.getElementsByTagName("head")[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        const tag = document.createElement("style");
	        tag.id = "react-tooltip";
	        tag.innerHTML = cssStyle; */
	
	    /* eslint-disable */
	
	    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	            tag.setAttribute('nonce', __webpack_nonce__)
	          }*/
	
	    /* eslint-enable */
	
	    /*    head.insertBefore(tag, head.firstChild);
	      }
	    } */
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: "clearTimer",
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _this$state3 = this.state,
	          extraClass = _this$state3.extraClass,
	          html = _this$state3.html,
	          ariaProps = _this$state3.ariaProps,
	          disable = _this$state3.disable;
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
	      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
	      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
	      var Wrapper = this.props.wrapper;
	
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");
	
	      if (html) {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          "data-id": "tooltip",
	          dangerouslySetInnerHTML: {
	            __html: placeholder
	          }
	        }));
	      } else {
	        return React.createElement(Wrapper, _extends({
	          className: wrapperClassName,
	          id: this.props.id
	        }, ariaProps, {
	          ref: function ref(_ref2) {
	            return _this8.tooltipRef = _ref2;
	          },
	          "data-id": "tooltip"
	        }), placeholder);
	      }
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	      var newAriaProps = parseAria(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	
	      if (!isChanged) {
	        return null;
	      }
	
	      return _objectSpread2({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(React.Component), _defineProperty(_class2, "propTypes", {
	  children: propTypes.any,
	  place: propTypes.string,
	  type: propTypes.string,
	  effect: propTypes.string,
	  offset: propTypes.object,
	  multiline: propTypes.bool,
	  border: propTypes.bool,
	  insecure: propTypes.bool,
	  "class": propTypes.string,
	  className: propTypes.string,
	  id: propTypes.string,
	  html: propTypes.bool,
	  delayHide: propTypes.number,
	  delayUpdate: propTypes.number,
	  delayShow: propTypes.number,
	  event: propTypes.string,
	  eventOff: propTypes.string,
	  watchWindow: propTypes.bool,
	  isCapture: propTypes.bool,
	  globalEventOff: propTypes.string,
	  getContent: propTypes.any,
	  afterShow: propTypes.func,
	  afterHide: propTypes.func,
	  overridePosition: propTypes.func,
	  disable: propTypes.bool,
	  scrollHide: propTypes.bool,
	  resizeHide: propTypes.bool,
	  wrapper: propTypes.string,
	  bodyMode: propTypes.bool,
	  possibleCustomEvents: propTypes.string,
	  possibleCustomEventsOff: propTypes.string,
	  clickable: propTypes.bool
	}), _defineProperty(_class2, "defaultProps", {
	  insecure: true,
	  resizeHide: true,
	  wrapper: "div",
	  clickable: false
	}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	module.exports = ReactTooltip;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(3593);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getActivity = exports.getMostRecentActivities = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.quizzes = quizzes;
	exports.quizzesPaginated = quizzesPaginated;
	exports.quiz = quiz;
	exports.isLoadingQuizzes = isLoadingQuizzes;
	exports.quizTotal = quizTotal;
	exports.question = question;
	exports.questions = questions;
	exports.mostRecentQuestions = mostRecentQuestions;
	exports.isLoadingQuestions = isLoadingQuestions;
	exports.answers = answers;
	exports.answersPaginated = answersPaginated;
	exports.isLoadingAnswers = isLoadingAnswers;
	exports.answer = answer;
	exports.answersForQuizID = answersForQuizID;
	exports.answerTotal = answerTotal;
	exports.nonQuizAnswers = nonQuizAnswers;
	exports.nonQuizAnswersPaginated = nonQuizAnswersPaginated;
	exports.nonQuizAnswerTotal = nonQuizAnswerTotal;
	exports.reviews = reviews;
	exports.reviewsPaginated = reviewsPaginated;
	exports.reviewTotal = reviewTotal;
	exports.metaCognitiveAnswers = metaCognitiveAnswers;
	exports.metaCognitiveAnswersPaginated = metaCognitiveAnswersPaginated;
	exports.metaCognitiveAnswerTotal = metaCognitiveAnswerTotal;
	exports.ratings = ratings;
	exports.isLoadingRatings = isLoadingRatings;
	exports.comments = comments;
	exports.isLoadingComments = isLoadingComments;
	exports.responses = responses;
	exports.response = response;
	exports.isLoadingResponses = isLoadingResponses;
	exports.responseTotal = responseTotal;
	exports.activity = activity;
	exports.activities = activities;
	exports.assignedActivities = assignedActivities;
	exports.tasks = tasks;
	exports.teacherPicksTasks = teacherPicksTasks;
	exports.userIDsByTaskSubjectID = userIDsByTaskSubjectID;
	exports.task = task;
	exports.isLoadingTasks = isLoadingTasks;
	exports.taskTotal = taskTotal;
	exports.validStudentHomepageTasks = validStudentHomepageTasks;
	exports.evaluations = evaluations;
	exports.evaluation = evaluation;
	exports.evaluationBySubjectAttributes = evaluationBySubjectAttributes;
	exports.evaluationByUserTextType = evaluationByUserTextType;
	exports.evaluationForSubject = evaluationForSubject;
	exports.evaluationsPaginated = evaluationsPaginated;
	exports.evaluationTotal = evaluationTotal;
	exports.isLoadingEvaluations = isLoadingEvaluations;
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectorUtility = __webpack_require__(144);
	var Queries = __webpack_require__(109);
	var QuestionTypes = __webpack_require__(82);
	
	//////////////////////////////////////////////
	// Quizzes ///////////////////////////////////
	//////////////////////////////////////////////
	
	function quizzes(_ref) {
		var state = _ref.state,
		    filters = _ref.filters,
		    conditions = _ref.conditions;
	
		var quizzes = _underscore2.default.filter(SelectorUtility.filterBy(state.quizzes, filters, conditions), function (quiz) {
			if (!_underscore2.default.isEmpty(quiz.text_id) && quiz.text_id !== 'null' && quiz.text_id !== 'undefined') {
				return quiz;
			}
		});
		return quizzes;
	}
	
	function quizzesPaginated(_ref2) {
		var state = _ref2.state,
		    filters = _ref2.filters,
		    conditions = _ref2.conditions,
		    page = _ref2.page;
	
		var query = Queries.toQuery(filters, conditions);
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.quizzes, pageKey, page);
	}
	function quiz(_ref3) {
		var state = _ref3.state,
		    id = _ref3.id;
	
		return state.quizzes[id];
	}
	
	function isLoadingQuizzes(_ref4) {
		var state = _ref4.state,
		    key = _ref4.key,
		    userIDs = _ref4.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any quizzes are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var quizzesInState = _underscore2.default.some(_underscore2.default.keys(state.quizzes), function (key) {
				return state.quizzes[key].id !== undefined;
			});
			if (quizzesInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.quizzes.loading[key];
	}
	
	function quizTotal(_ref5) {
		var state = _ref5.state,
		    filters = _ref5.filters,
		    conditions = _ref5.conditions;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.quizzes.totals[totalKey];
	}
	
	//////////////////////////////////////////////
	// Questions /////////////////////////////////
	//////////////////////////////////////////////
	
	function question(_ref6) {
		var state = _ref6.state,
		    id = _ref6.id;
	
		return state.questions[id];
	}
	function questions(_ref7) {
		var state = _ref7.state,
		    filters = _ref7.filters,
		    conditions = _ref7.conditions;
	
		return SelectorUtility.filterBy(state.questions, filters, conditions);
	}
	function mostRecentQuestions(_ref8) {
		var state = _ref8.state,
		    filters = _ref8.filters,
		    conditions = _ref8.conditions,
		    count = _ref8.count;
	
		var sorted = _underscore2.default.sortBy(questions({ state: state, filters: filters, conditions: conditions }), "receivedAt");
		return _underscore2.default.first(sorted.reverse(), count);
	}
	function isLoadingQuestions(_ref9) {
		var state = _ref9.state,
		    key = _ref9.key;
	
		key = key || "index";
		return state.questions.loading[key];
	}
	
	//////////////////////////////////////////////
	// Answers ///////////////////////////////////
	//////////////////////////////////////////////
	
	function answers(_ref10) {
		var state = _ref10.state,
		    filters = _ref10.filters,
		    conditions = _ref10.conditions;
	
		return SelectorUtility.filterBy(state.answers, filters, conditions);
	}
	function answersPaginated(_ref11) {
		var state = _ref11.state,
		    filters = _ref11.filters,
		    conditions = _ref11.conditions,
		    page = _ref11.page;
	
		var query = Queries.toQuery(filters, conditions);
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.answers, pageKey, page);
	}
	function isLoadingAnswers(_ref12) {
		var state = _ref12.state,
		    key = _ref12.key,
		    userIDs = _ref12.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any answers are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var answersInState = _underscore2.default.some(_underscore2.default.keys(state.answers), function (key) {
				return state.answers[key].id !== undefined;
			});
			if (answersInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.answers.loading[key];
	}
	function answer(_ref13) {
		var state = _ref13.state,
		    id = _ref13.id;
	
		return state.answers[id];
	}
	function answersForQuizID(_ref14) {
		var state = _ref14.state,
		    quizID = _ref14.quizID;
	
		return _underscore2.default.sortBy(answers({ state: state, filters: { quiz_id: quizID } }), "id");
	}
	function answerTotal(_ref15) {
		var state = _ref15.state,
		    filters = _ref15.filters,
		    conditions = _ref15.conditions;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.answers.totals[totalKey];
	}
	
	//////////////////////
	// Non-Quiz Answers //
	//////////////////////
	
	function nonQuizAnswers(_ref16) {
		var state = _ref16.state,
		    filters = _ref16.filters,
		    conditions = _ref16.conditions,
		    page = _ref16.page;
	
		filters = _underscore2.default.extend({}, filters, { quiz_id: null });
		conditions = conditions || {};
	
		var oneOfMatch = _underscore2.default.extend({}, conditions.oneOfMatch, {
			question_type: QuestionTypes.BASIC_TYPES
		});
		var fullConditions = _underscore2.default.extend({}, conditions, { oneOfMatch: oneOfMatch });
	
		return SelectorUtility.filterBy(state.answers, filters, fullConditions);
	}
	
	function nonQuizAnswersPaginated(_ref17) {
		var state = _ref17.state,
		    filters = _ref17.filters,
		    conditions = _ref17.conditions,
		    page = _ref17.page;
	
		var query = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.answers, pageKey, page);
	}
	
	function nonQuizAnswerTotal(_ref18) {
		var state = _ref18.state,
		    filters = _ref18.filters,
		    conditions = _ref18.conditions;
	
		var query = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
		var totalKey = $wr.sortedJSON(query);
		return state.answers.totals[totalKey];
	}
	
	//////////////////////
	// Reviews (Anwers) //
	//////////////////////
	
	function reviews(_ref19) {
		var state = _ref19.state,
		    filters = _ref19.filters,
		    conditions = _ref19.conditions,
		    page = _ref19.page;
	
		filters = _underscore2.default.extend({}, filters, { question_type: QuestionTypes.REVIEW_QUESTION });
		return SelectorUtility.filterBy(state.answers, filters, conditions);
	}
	
	function reviewsPaginated(_ref20) {
		var state = _ref20.state,
		    filters = _ref20.filters,
		    conditions = _ref20.conditions,
		    page = _ref20.page;
	
		var query = Queries.reviewQuery(Queries.toQuery(filters, conditions));
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.answers, pageKey, page);
	}
	
	function reviewTotal(_ref21) {
		var state = _ref21.state,
		    filters = _ref21.filters,
		    conditions = _ref21.conditions;
	
		var query = Queries.reviewQuery(Queries.toQuery(filters, conditions));
		var totalKey = $wr.sortedJSON(query);
		return state.answers.totals[totalKey];
	}
	
	///////////////////////////////////////////
	// Meta Cognitive (Anwers) //////
	///////////////////////////////////////////
	
	function metaCognitiveAnswers(_ref22) {
		var state = _ref22.state,
		    filters = _ref22.filters,
		    conditions = _ref22.conditions,
		    page = _ref22.page;
	
		filters = _underscore2.default.extend({}, filters, { question_type: QuestionTypes.META_COGNITIVE_QUESTION }); //tag change
		return SelectorUtility.filterBy(state.answers, filters, conditions);
	}
	
	function metaCognitiveAnswersPaginated(_ref23) {
		var state = _ref23.state,
		    filters = _ref23.filters,
		    conditions = _ref23.conditions,
		    page = _ref23.page;
	
		// var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
		var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
		var pageKey = $wr.sortedJSON(query);
		return SelectorUtility.selectPage(state.answers, pageKey, page);
	}
	function metaCognitiveAnswerTotal(_ref24) {
		var state = _ref24.state,
		    filters = _ref24.filters,
		    conditions = _ref24.conditions;
	
		var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
		var totalKey = $wr.sortedJSON(query);
		return state.answers.totals[totalKey];
	}
	
	//////////////////////////////////////////////
	// Ratings ///////////////////////////////////
	//////////////////////////////////////////////
	
	function ratings(_ref25) {
		var state = _ref25.state,
		    filters = _ref25.filters,
		    conditions = _ref25.conditions;
	
		return SelectorUtility.filterBy(state.ratings, filters, conditions);
	}
	function isLoadingRatings(_ref26) {
		var state = _ref26.state,
		    key = _ref26.key;
	
		key = key || "index";
		return state.ratings.loading[key];
	}
	
	//////////////////////////////////////////////
	// Comments //////////////////////////////////
	//////////////////////////////////////////////
	
	function comments(_ref27) {
		var state = _ref27.state,
		    filters = _ref27.filters,
		    conditions = _ref27.conditions;
	
		return SelectorUtility.filterBy(state.comments, filters, conditions);
	}
	function isLoadingComments(_ref28) {
		var state = _ref28.state,
		    key = _ref28.key;
	
		key = key || "index";
		return state.comments.loading[key];
	}
	
	//////////////////////////////////////////////
	// Responses /////////////////////////////////
	//////////////////////////////////////////////
	
	function responses(_ref29) {
		var state = _ref29.state,
		    filters = _ref29.filters,
		    conditions = _ref29.conditions;
	
		return SelectorUtility.filterBy(state.responses, filters, conditions);
	}
	function response(_ref30) {
		var state = _ref30.state,
		    id = _ref30.id;
	
		return state.responses[id];
	}
	function isLoadingResponses(_ref31) {
		var state = _ref31.state,
		    key = _ref31.key;
	
		key = key || "index";
		return state.responses.loading[key];
	}
	function responseTotal(_ref32) {
		var state = _ref32.state,
		    filters = _ref32.filters,
		    conditions = _ref32.conditions;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.responses.totals[totalKey];
	}
	
	//////////////////////////////////////////////
	// Activities ////////////////////////////////
	//////////////////////////////////////////////
	
	function activity(_ref33) {
		var state = _ref33.state,
		    id = _ref33.id;
	
		return state.activities[id];
	}
	
	function activities(_ref34) {
		var state = _ref34.state,
		    filters = _ref34.filters,
		    conditions = _ref34.conditions;
	
		return SelectorUtility.filterBy(state.activities, filters, conditions);
	}
	
	function assignedActivities(_ref35) {
		var state = _ref35.state,
		    studentID = _ref35.studentID;
	
		if (studentID) {
			var tks = tasks({
				state: state, filters: { subject_type: "Activity", user_id: studentID }
			});
		} else {
			var tks = tasks({
				state: state, filters: { subject_type: "Activity" }
			});
		}
	
		// Actually can't just map to parseInt
		var activityIDs = _underscore2.default.map(_underscore2.default.pluck(tks, "subject_id"), function (x) {
			return parseInt(x);
		});
	
		return activities({ state: state, conditions: { ids: activityIDs } });
	}
	
	//////////////////////////////////////////////
	// Activities ////////////////////////////////
	//////////////////////////////////////////////
	
	
	var getMostRecentActivities = exports.getMostRecentActivities = function getMostRecentActivities(_ref36) {
		var state = _ref36.state,
		    filters = _ref36.filters,
		    conditions = _ref36.conditions,
		    withAssigned = _ref36.withAssigned;
	
		var activities = SelectorUtility.filterBy(state.activities, filters, conditions).reverse();
		var assignedActivityIDs = _underscore2.default.uniq(_underscore2.default.pluck(tasks({ state: state, filters: {
				subject_type: "Activity",
				completed_at: null
			} }), "subject_id"));
	
		if (withAssigned) {
			activities = activities.map(function (activity) {
				var assigned = _underscore2.default.includes(assignedActivityIDs, activity.id + "");
				return _extends({}, activity, { assigned: assigned
				});
			});
		}
	
		return activities;
	};
	
	var getActivity = exports.getActivity = function getActivity(_ref37) {
		var state = _ref37.state,
		    id = _ref37.id;
	
		return state.activities[id];
	};
	
	//////////////////////////////////////////////
	// Tasks /////////////////////////////////////
	//////////////////////////////////////////////
	
	function tasks(_ref38) {
		var state = _ref38.state,
		    filters = _ref38.filters,
		    conditions = _ref38.conditions;
	
		return SelectorUtility.filterBy(state.tasks, filters, conditions);
	}
	
	function teacherPicksTasks(_ref39) {
		var state = _ref39.state,
		    filters = _ref39.filters,
		    conditions = _ref39.conditions;
	
		return tasks({ state: state, filters: filters, conditions: conditions }).filter(function (x) {
			return x.subject_type === "URLPick" || x.subject_type === "TitlePick";
		});
	}
	
	function userIDsByTaskSubjectID(_ref40) {
		var state = _ref40.state,
		    filters = _ref40.filters,
		    conditions = _ref40.conditions;
	
		var out = {};
	
		_underscore2.default.each(tasks({ state: state, filters: filters, conditions: conditions }), function (task) {
			if (!out[task.subject_id]) {
				out[task.subject_id] = [];
			}
	
			out[task.subject_id].push(task.user_id);
		});
	
		if (filters && filters.subject_type && filters.subject_type === 'exercise') {
	
			_underscore2.default.each(teacherPicksTasks({ state: state }), function (task) {
				var exerciseTaskItems = _underscore2.default.where(task.task_items, { subject_type: 'exercise', subject_assigned: true });
				if (task.task_items && !_underscore2.default.isEmpty(exerciseTaskItems)) {
					_underscore2.default.each(exerciseTaskItems, function (task_item) {
						if (!out[task_item.subject_id]) {
							out[task_item.subject_id] = [];
						}
	
						out[task_item.subject_id].push(task_item.user_id);
					});
				}
			});
		}
	
		return out;
	}
	
	function task(_ref41) {
		var state = _ref41.state,
		    id = _ref41.id;
	
		return state.tasks[id];
	}
	function isLoadingTasks(_ref42) {
		var state = _ref42.state,
		    key = _ref42.key;
	
		key = key || "index";
		return state.tasks.loading[key];
	}
	function taskTotal(_ref43) {
		var state = _ref43.state,
		    filters = _ref43.filters,
		    conditions = _ref43.conditions;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.tasks.totals[totalKey];
	}
	function validStudentHomepageTasks(_ref44) {
		var state = _ref44.state,
		    filters = _ref44.filters,
		    conditions = _ref44.conditions;
	
		return SelectorUtility.validStudentHomepageTasks(tasks({ state: state, filters: filters, conditions: conditions }));
	}
	
	//////////////////////////////////////////////
	// Evaluations ///////////////////////////////
	//////////////////////////////////////////////
	
	function evaluations(_ref45) {
		var state = _ref45.state,
		    filters = _ref45.filters,
		    conditions = _ref45.conditions;
	
		return SelectorUtility.filterBy(state.evaluations, filters, conditions);
	}
	
	function evaluation(_ref46) {
		var state = _ref46.state,
		    id = _ref46.id;
	
		return state.evaluations[id];
	}
	function evaluationBySubjectAttributes(_ref47) {
		var state = _ref47.state,
		    subjectTextID = _ref47.subjectTextID,
		    subjectUserID = _ref47.subjectUserID;
	
		return _underscore2.default.findWhere(state.evaluations, {
			subject_text_id: subjectTextID, subject_user_id: subjectUserID
		});
	}
	function evaluationByUserTextType(_ref48) {
		var state = _ref48.state,
		    subjectTextID = _ref48.subjectTextID,
		    subjectUserID = _ref48.subjectUserID,
		    subjectType = _ref48.subjectType;
	
		return _underscore2.default.findWhere(state.evaluations, {
			subject_text_id: subjectTextID, subject_user_id: subjectUserID, subject_type: subjectType
		});
	}
	function evaluationForSubject(_ref49) {
		var state = _ref49.state,
		    subjectType = _ref49.subjectType,
		    subjectID = _ref49.subjectID;
	
		var filters = { subject_id: subjectID, subject_type: subjectType };
		return SelectorUtility.filterBy(state.evaluations, filters)[0];
	}
	
	function evaluationsPaginated(_ref50) {
		var state = _ref50.state,
		    filters = _ref50.filters,
		    conditions = _ref50.conditions,
		    page = _ref50.page;
	
		var query = Queries.toQuery(filters, conditions);
		var pageKey = $wr.sortedJSON(query);
	
		return SelectorUtility.selectPage(state.evaluations, pageKey, page);
	}
	
	function evaluationTotal(_ref51) {
		var state = _ref51.state,
		    filters = _ref51.filters,
		    conditions = _ref51.conditions;
	
		var query = Queries.toQuery(filters, conditions);
		var totalKey = $wr.sortedJSON(query);
		return state.evaluations.totals[totalKey];
	}
	
	function isLoadingEvaluations(_ref52) {
		var state = _ref52.state,
		    key = _ref52.key,
		    userIDs = _ref52.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any answers are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var evaluationsInState = _underscore2.default.some(_underscore2.default.keys(state.evaluations), function (key) {
				return state.evaluations[key].id !== undefined;
			});
			if (evaluationsInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.evaluations.loading[key];
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(3543)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isEnabled = isEnabled;
	exports.anyDisabled = anyDisabled;
	var moment = __webpack_require__(15);
	
	var DIGITAL_EXERCISES = exports.DIGITAL_EXERCISES = "digital-exercises";
	var LOG_READING = exports.LOG_READING = "log-reading";
	var INVITE_SPONSORS = exports.INVITE_SPONSORS = "invite-sponsors";
	var AUTOGRADER_DATA = exports.AUTOGRADER_DATA = "autograder-data";
	var TEACHER_COMMENTS = exports.TEACHER_COMMENTS = "teacher-comments";
	var TEXT_SPECIFIC_QUESTIONS = exports.TEXT_SPECIFIC_QUESTIONS = "text-specific-questions";
	var CLOZE_ASSESSMENTS = exports.CLOZE_ASSESSMENTS = "cloze-assessments";
	var HISTORICAL_DATA = exports.HISTORICAL_DATA = "historical-data";
	var LEARNING_SERIES = exports.LEARNING_SERIES = "learning-series";
	var AUTOGRADED_ANSWERS = exports.AUTOGRADED_ANSWERS = "autograded-answers";
	var STUDENT_DIFFERENTIATION = exports.STUDENT_DIFFERENTIATION = "student-differentiating"; // Spelling error :(
	var STANDARDS_CUSTOMIZATION = exports.STANDARDS_CUSTOMIZATION = "standards-customization";
	var GROUP_INSIGHTS = exports.GROUP_INSIGHTS = "group-insights";
	var TASK_ITEMS = exports.TASK_ITEMS = "task-items";
	
	function isEnabled(feature, forUser) {
		if (forUser === undefined) {
			// Require here to avoid circular dependencies
			var CurrentUser = __webpack_require__(3);
			forUser = CurrentUser.get();
		}
	
		if (!_.includes(ALL_FEATURES, feature)) {
			console.error("Unrecognized feature " + feature);
		}
	
		if (forUser && forUser.account) {
			return forUser.account.features[feature];
		}
	}
	
	function anyDisabled(features) {
		return _.any(features, function (feature) {
			return !isEnabled(feature);
		});
	}
	
	var HISTORICAL_DATA_DAYS = exports.HISTORICAL_DATA_DAYS = 60;
	
	var ALL_FEATURES = exports.ALL_FEATURES = [DIGITAL_EXERCISES, LOG_READING, INVITE_SPONSORS, AUTOGRADER_DATA, TEACHER_COMMENTS, TEXT_SPECIFIC_QUESTIONS, CLOZE_ASSESSMENTS, HISTORICAL_DATA, AUTOGRADED_ANSWERS, LEARNING_SERIES, STUDENT_DIFFERENTIATION, STANDARDS_CUSTOMIZATION, GROUP_INSIGHTS, TASK_ITEMS];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3810);
	
	var LoadingButton = function (_React$Component) {
		_inherits(LoadingButton, _React$Component);
	
		function LoadingButton(props) {
			_classCallCheck(this, LoadingButton);
	
			var _this = _possibleConstructorReturn(this, (LoadingButton.__proto__ || Object.getPrototypeOf(LoadingButton)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(LoadingButton, [{
			key: "onClick",
			value: function onClick(e) {
				if (this.props.onClick && !this.props.loading && !this.props.enabledButton) {
					this.props.onClick(e);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var className, textStyle;
	
				if (this.props.loading) {
					textStyle = { left: "800px" };
					className = "loadingButton disabledButton";
					var spinner = React.createElement(Spinner, { center: true, ops: { color: "#fff" } });
				} else if (this.props.disabled) {
					textStyle = { left: "0px" };
					className = "loadingButton disabledButton";
				} else {
					textStyle = { left: "0px" };
					className = "loadingButton enabledButton";
				}
	
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				// Omit props for the component only:
				var buttonProps = _.omit(this.props, "text", "loading", "onClick");
	
				return React.createElement(
					"button",
					_extends({}, buttonProps, { onClick: this.onClick, className: className }),
					spinner,
					React.createElement(
						"span",
						{ className: "text", style: textStyle },
						this.props.text
					)
				);
			}
		}]);
	
		return LoadingButton;
	}(React.Component);
	
	;
	
	LoadingButton.propTypes = StrictPropTypes({
		// Text to show on button (when not loading)
		text: PropTypes.string.isRequired,
	
		// If true, text is hidden, spinner is shown
		loading: PropTypes.bool,
	
		// If true, disables button
		disabled: PropTypes.bool,
	
		// Extra className to apply to button tag
		className: PropTypes.string,
	
		value: PropTypes.string,
	
		// Function to call after button is clicked
		onClick: PropTypes.func,
	
		// Props pass on to the button
		"data-tip": PropTypes.string,
	
		type: PropTypes.string
	});
	
	module.exports = LoadingButton;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3788);
	
	var AltModal = function (_React$Component) {
		_inherits(AltModal, _React$Component);
	
		function AltModal(props) {
			_classCallCheck(this, AltModal);
	
			var _this = _possibleConstructorReturn(this, (AltModal.__proto__ || Object.getPrototypeOf(AltModal)).call(this));
	
			autobind(_this);
	
			if (props.open !== undefined) {
				var open = props.open;
			} else {
				var open = false;
			}
			_this.state = { open: open, modalIn: false };
			return _this;
		}
	
		_createClass(AltModal, [{
			key: "show",
			value: function show() {
				var _this2 = this;
	
				this.setState({ open: true }, function () {
					$("body").addClass("modal-open");
	
					// Slightly delay showing the modal as "in" so the CSS transitions work
					setTimeout(function () {
						_this2.setState({ modalIn: true });
					}, 40);
	
					if (_this2.props.onShow) {
						_this2.props.onShow();
					}
				});
				this.activateScrollListener();
			}
		}, {
			key: "hide",
			value: function hide() {
				var _this3 = this;
	
				if (this.props.preventHide) {
					if (this.props.onHidePrevented) {
						this.props.onHidePrevented();
					}
					return;
				}
				this.setState({ modalIn: false }, function () {
					setTimeout(function () {
						_this3.setState({ open: false }, function () {
							_this3.removeBodyModalOpen();
						});
	
						if (_this3.props.onHide) {
							_this3.props.onHide();
						}
					}, 200); // 200 is slightly more than the .15s on the modal transitions
				});
				this.dectivateScrollListener();
			}
		}, {
			key: "removeBodyModalOpen",
			value: function removeBodyModalOpen() {
				// Only remove this class if we're the last modal off the page
				var openModalCount = $(".modal.in").length;
				if (openModalCount == 0) {
					$("body").removeClass("modal-open");
				}
			}
		}, {
			key: "onOutsideClick",
			value: function onOutsideClick(e) {
				// Only if we clicked outside the children of the modal (e.g. the actual modal)
				if (e.target == this.refs.modal) {
					this.hide();
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.state.open) {
					return React.createElement("div", { className: "modalWrap" });
				}
	
				if (this.props.studentProgressEmail) {
					var modalHeader = React.createElement(
						"div",
						{ className: "modal-header" },
						React.createElement(
							"h2",
							{ className: "modal-title" },
							"Student Progress ",
							React.createElement("br", null)
						),
						React.createElement(
							"p",
							{ className: "datesSubHeader" },
							this.props.headerText
						)
					);
				} else if (this.props.headerText) {
					var modalHeader = React.createElement(
						"div",
						{ className: "modal-header" },
						React.createElement(
							"h2",
							{ className: "modal-title" },
							this.props.headerText
						)
					);
				} else if (this.props.headerContent) {
					var modalHeader = React.createElement(
						"div",
						{ className: "modal-header" },
						React.createElement(
							"h2",
							{ className: "modal-title" },
							this.props.headerContent
						)
					);
				}
	
				var modelClass = "altModal modal fade";
				var backdropClass = "modal-backdrop fade";
	
				if (this.state.modalIn) {
					modelClass += " in";
					backdropClass += " in";
				}
	
				if (this.props.className) {
					modelClass += " " + this.props.className;
				}
	
				var backdropZIndex = 999999;
				if (this.props.modalOrder) {
					backdropZIndex += 100 * this.props.modalOrder;
				}
	
				var modalZIndex = backdropZIndex + 1;
	
				if (this.props.actionButtons) {
					var modalFooter = React.createElement(
						"div",
						{ className: "modal-footer" },
						this.props.actionButtons
					);
				}
	
				return React.createElement(
					"div",
					{ className: "modalWrap" },
					React.createElement(
						"div",
						{ className: modelClass, role: "dialog", style: { zIndex: modalZIndex },
							onClick: this.onOutsideClick, ref: "modal" },
						React.createElement(
							"div",
							{ className: "modal-dialog", role: "document" },
							React.createElement(
								"div",
								{ className: "modal-content" },
								modalHeader,
								React.createElement(
									"div",
									{ className: "modal-body" },
									this.props.children
								),
								modalFooter
							)
						)
					),
					React.createElement("div", { className: backdropClass, style: { zIndex: backdropZIndex } })
				);
			}
		}, {
			key: "listenKeyboardExit",
			value: function listenKeyboardExit(e) {
				if (this.state.modalIn && (e.key == "Escape" || e.keyCode == 27)) {
					this.hide();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				window.addEventListener("keydown", this.listenKeyboardExit, true);
	
				if (this.props.selfOpen) {
					this.show();
				}
				this.activateScrollListener();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.removeEventListener("keydown", this.listenKeyboardExit, true);
				setTimeout(this.removeBodyModalOpen, 200);
				this.dectivateScrollListener();
			}
		}, {
			key: "activateScrollListener",
			value: function activateScrollListener() {
				var _this4 = this;
	
				this.dectivateScrollListener(); // In case it's already been activated
	
				// Apparently we need to wait a few ticks for the modal to get instantiated
				// Not sure why?
				setTimeout(function () {
					$(_this4.refs.modal).on("scroll", _this4.globalScrollEvent);
				}, 20);
			}
		}, {
			key: "dectivateScrollListener",
			value: function dectivateScrollListener() {
				$(this.refs.modal).off("scroll", this.globalScrollEvent);
			}
		}, {
			key: "globalScrollEvent",
			value: function globalScrollEvent() {
				$(document).trigger("modal-scroll");
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.open !== this.props.open) {
					if (this.props.open) {
						this.show();
					} else {
						this.hide();
					}
				}
			}
		}]);
	
		return AltModal;
	}(React.Component);
	
	;
	
	AltModal.propTypes = StrictPropTypes({
		// Components to render inside the modal
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	
		// Controls if the modal is open or closed
		// OPTIONAL, if null, modal must be controlled by refs
		open: PropTypes.bool,
	
		// Text to display across the top of the modal
		headerText: PropTypes.string,
		headerContent: PropTypes.object,
	
		// Class to add to the modal
		className: PropTypes.string,
	
		// CSS ID
		id: PropTypes.string,
	
		// Indicates if its progress email modal
		studentProgressEmail: PropTypes.bool,
	
		// If true, modal automatically opens on mount
		selfOpen: PropTypes.bool,
	
		// If true, prevents the user from clicking out of the modal
		preventHide: PropTypes.bool,
		// Function to call after the modal has been prevented from being hidden
		onHidePrevented: PropTypes.func,
	
		// Function to call after the modal is hidden
		onHide: PropTypes.func,
	
		// Function to call after the modal is shown
		onShow: PropTypes.func,
	
		// Stacking order of this modal relative to others (default is 1),
		modalOrder: PropTypes.number,
	
		// Buttons container
		actionButtons: PropTypes.object,
	
		onModalHidden: PropTypes.func
	
	});
	
	module.exports = AltModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.6
	  //     https://underscorejs.org
	  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.6';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3606);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.logs = logs;
	exports.book = book;
	exports.isLoadingLogs = isLoadingLogs;
	exports.books = books;
	exports.isLoadingBooks = isLoadingBooks;
	exports.booksWithRevisables = booksWithRevisables;
	exports.bookIDsFromTasks = bookIDsFromTasks;
	exports.assignedURLBooks = assignedURLBooks;
	exports.assignedTitleBooks = assignedTitleBooks;
	exports.platform = platform;
	exports.platforms = platforms;
	exports.readingLevels = readingLevels;
	exports.assessmentDates = assessmentDates;
	exports.isLoadingReadingLevels = isLoadingReadingLevels;
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrentUser = __webpack_require__(3);
	
	var SelectorUtility = __webpack_require__(144);
	var WritingSelectors = __webpack_require__(14);
	var RosterSelectors = __webpack_require__(6);
	
	//////////////////////////////////////////////
	// Logs //////////////////////////////////////
	//////////////////////////////////////////////
	
	function logs(_ref) {
		var state = _ref.state,
		    filters = _ref.filters,
		    conditions = _ref.conditions;
	
		return SelectorUtility.filterBy(state.logs, filters, conditions);
	}
	
	//////////////////////////////////////////////
	// Books /////////////////////////////////////
	//////////////////////////////////////////////
	
	function book(_ref2) {
		var state = _ref2.state,
		    id = _ref2.id;
	
		return state.books[id];
	}
	function isLoadingLogs(_ref3) {
		var state = _ref3.state,
		    key = _ref3.key,
		    userIDs = _ref3.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any logs are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var logsInState = _underscore2.default.some(_underscore2.default.keys(state.logs), function (key) {
				return state.logs[key].id !== undefined;
			});
			if (logsInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.logs.loading[key];
	}
	
	function books(_ref4) {
		var state = _ref4.state,
		    filters = _ref4.filters,
		    conditions = _ref4.conditions;
	
		conditions = conditions || {};
		// Unpack the values stored for specifc start and end times
		var rangeKey = "activity:" + (conditions.startDate || "any") + ":" + (conditions.endDate || "any");
	
		var unpackedBooks = _underscore2.default.map(SelectorUtility.allRecords(state.books), function (book) {
			return _underscore2.default.extend({}, book, book[rangeKey]);
		});
	
		// Now, filter by date, user, etc.
		return _underscore2.default.filter(SelectorUtility.filterBy(unpackedBooks, filters, conditions), function (book) {
			if (!_underscore2.default.isEmpty(book.text_id) && book.text_id !== 'null' && book.text_id !== 'undefined') {
				// filter by readBook status
				if (conditions.readBook && (conditions.readBook == 'yes' || conditions.readBook == 'no')) {
					if (conditions.readBook == 'yes' && book.read_book_yes) {
						return book;
					} else if (conditions.readBook == 'no' && book.read_book_no) {
						return book;
					}
				} else {
					return book;
				}
			}
		});
	}
	
	function isLoadingBooks(_ref5) {
		var state = _ref5.state,
		    key = _ref5.key,
		    userIDs = _ref5.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any books are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var booksInState = _underscore2.default.some(_underscore2.default.keys(state.books), function (key) {
				return state.books[key].id !== undefined;
			});
			if (booksInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.books.loading[key];
	}
	
	function booksWithRevisables(_ref6) {
		var state = _ref6.state,
		    filters = _ref6.filters,
		    conditions = _ref6.conditions;
	
		var out = [];
	
		_underscore2.default.each(books({ state: state, filters: filters, conditions: conditions }), function (book) {
			if (book.quiz_revisable_counts) {
				out.push({ text_id: book.text_id, type: "quiz" });
			}
	
			if (book.answer_revisable_counts) {
				out.push({ text_id: book.text_id, type: "answer" });
			}
	
			if (book.review_revisable_counts) {
				out.push({ text_id: book.text_id, type: "review" });
			}
		});
		return out;
	}
	
	function bookIDsFromTasks(_ref7) {
		var state = _ref7.state;
	
		return _underscore2.default.uniq(_underscore2.default.pluck(state.tasks, "subject_id"));
	}
	
	function assignedURLBooks(_ref8) {
		var state = _ref8.state,
		    studentID = _ref8.studentID;
	
		if (studentID) {
			var tasks = WritingSelectors.tasks({
				state: state, filters: { subject_type: "URLPick", user_id: studentID }
			});
		} else {
			var tasks = WritingSelectors.tasks({
				state: state, filters: { subject_type: "URLPick" }
			});
		}
	
		return books({ state: state, conditions: { textIDs: _underscore2.default.pluck(tasks, "subject_id") } });
	}
	
	function assignedTitleBooks(_ref9) {
		var state = _ref9.state,
		    studentID = _ref9.studentID;
	
		if (studentID) {
			var tasks = WritingSelectors.tasks({
				state: state, filters: { subject_type: "TitlePick", user_id: studentID }
			});
		} else {
			var tasks = WritingSelectors.tasks({
				state: state, filters: { subject_type: "TitlePick" }
			});
		}
	
		return books({ state: state, conditions: { textIDs: _underscore2.default.pluck(tasks, "subject_id") } });
	}
	
	//////////////////////////////////////////////
	// Platforms /////////////////////////////////
	//////////////////////////////////////////////
	
	function platform(_ref10) {
		var state = _ref10.state,
		    id = _ref10.id;
	
		return state.platforms[id];
	}
	
	function platforms(_ref11) {
		var state = _ref11.state,
		    filters = _ref11.filters,
		    conditions = _ref11.conditions;
	
		var platforms = SelectorUtility.filterBy(state.platforms, filters, conditions);
		return _underscore2.default.sortBy(platforms, "name");
	};
	
	//////////////////////////////////////////////
	// Reading Levels ////////////////////////////
	//////////////////////////////////////////////
	
	function readingLevels(_ref12) {
		var state = _ref12.state,
		    filters = _ref12.filters,
		    conditions = _ref12.conditions;
	
		return SelectorUtility.filterBy(state.readingLevels, filters, conditions);
	}
	
	function assessmentDates(_ref13) {
		var state = _ref13.state,
		    filters = _ref13.filters,
		    conditions = _ref13.conditions,
		    sinceSchoolYear = _ref13.sinceSchoolYear,
		    untilPresent = _ref13.untilPresent;
	
		var rls = readingLevels({ state: state, filters: filters, conditions: conditions });
	
		var dates = _underscore2.default.pluck(rls, "assessment_date");
	
		var slPrefs = RosterSelectors.globalStudentListPrefs({ state: state });
		if (slPrefs) {
			dates = dates.concat(slPrefs.cloze_test_dates); // This may not work the 2nd year
		}
	
		dates = _underscore2.default.uniq(_underscore2.default.compact(dates));
	
		if (sinceSchoolYear) {
			var startDate = (0, _moment2.default)(CurrentUser.fetchSchoolYearDates().startDate).format("YYYY-MM-DD");
	
			dates = dates.filter(function (x) {
				return x >= startDate;
			}).sort();
		}
	
		if (untilPresent) {
			var endDate = (0, _moment2.default)().format("YYYY-MM-DD");
			dates = dates.filter(function (x) {
				return x <= endDate;
			}).sort();
		}
	
		return dates;
	}
	
	function isLoadingReadingLevels(_ref14) {
		var state = _ref14.state,
		    key = _ref14.key,
		    userIDs = _ref14.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any reading levels are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var readingLevelsInState = _underscore2.default.some(_underscore2.default.keys(state.readingLevels), function (key) {
				return state.readingLevels[key].reading_level !== undefined;
			});
			if (readingLevelsInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.readingLevels.loading[key];
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3792);
	
	var ButtonDropdown = function (_React$Component) {
		_inherits(ButtonDropdown, _React$Component);
	
		function ButtonDropdown(props) {
			_classCallCheck(this, ButtonDropdown);
	
			var _this = _possibleConstructorReturn(this, (ButtonDropdown.__proto__ || Object.getPrototypeOf(ButtonDropdown)).call(this));
	
			autobind(_this);
	
			if (props.inputMode) {
				_this.state = { inputModeText: props.defaultText, inputModeValue: props.defaultValue };
			} else if (props.stickyOpen) {
				_this.state = { open: false };
			} else {
				_this.state = {};
			}
	
			_this.wrapRef = React.createRef();
			return _this;
		}
	
		_createClass(ButtonDropdown, [{
			key: "val",
			value: function val() {
				if (this.props.inputMode) {
					return this.state.inputModeValue;
				}
			}
		}, {
			key: "reset",
			value: function reset() {
				if (this.props.inputMode) {
					this.setState({
						inputModeText: this.props.defaultText, inputModeValue: this.props.defaultValue
					});
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.icon) {
					var icon = React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: this.props.icon }),
						" "
					);
				}
	
				if (this.props.dropdownDisplay == "link") {
					var buttonClass = "btn-link";
				} else {
					var buttonClass = "btn-default smallObject";
				}
				if (this.props.buttonClassName) {
					buttonClass += " " + this.props.buttonClassName;
				}
	
				var menuClass = "dropdown-menu scrollable-menu";
				if (this.props.rightMenu) {
					menuClass += " " + "dropdown-menu-right";
				}
	
				if (this.props.wide) {
					menuClass += " " + "wide";
				}
	
				var wrapClassName = "btn-group buttonDropdown";
				if (this.props.className) {
					wrapClassName += " " + this.props.className;
				}
	
				if (this.props.inputMode) {
					var displayText = this.state.inputModeText;
					var originalChildren = _.isArray(this.props.children) ? this.props.children : [this.props.children];
	
					var children = _.map(originalChildren, function (child) {
						var clickHandler = function () {
							this.setState({ inputModeText: child.props.text, inputModeValue: child.props.value }, this.props.onChange);
						}.bind(this);
						return React.cloneElement(child, { onClick: clickHandler });
					}.bind(this));
				} else {
					var displayText = this.props.text;
					var children = this.props.children;
				}
	
				var wrapProps = _.omit(this.props, "children", "dropdownDisplay", "buttonClassName", "defaultText", "rightMenu", "icon", "text", "className", "dataTip", "inputMode", "stickyOpen");
	
				if (this.props.dataTip) {
					var tooltipText = this.props.dataTip;
					var toolip = React.createElement(ReactTooltip, { effect: "solid" });
				}
	
				if (this.props.useRadioButton) {
					var button = React.createElement(
						"label",
						{ className: "normal" },
						React.createElement("input", { type: "radio" }),
						displayText
					);
				} else if (this.props.stickyOpen) {
					if (this.state.open) {
						wrapClassName += " open";
					}
					var button = React.createElement(
						"button",
						{ type: "button",
							onClick: function onClick() {
								return _this2.setState({ open: !_this2.state.open });
							},
							className: "btn dropdown-toggle " + buttonClass },
						icon,
						displayText,
						React.createElement("span", { className: "caret hideOnPrint" })
					);
				} else {
					var button = React.createElement(
						"button",
						{ type: "button", className: "btn dropdown-toggle " + buttonClass, "data-toggle": "dropdown" },
						icon,
						displayText,
						React.createElement("span", { className: "caret hideOnPrint" })
					);
				}
	
				return React.createElement(
					"div",
					_extends({}, wrapProps, { className: wrapClassName,
						"data-tip": tooltipText, ref: this.wrapRef }),
					button,
					React.createElement(
						"ul",
						{ className: menuClass, role: "menu" },
						children
					),
					toolip
				);
			}
		}, {
			key: "onDocumentClick",
			value: function onDocumentClick(e) {
				var $el = $(this.wrapRef.current);
	
				if (!($el.is(e.target) || $el.has(e.target).length)) {
					this.setState({ open: false });
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$('body').off('click', this.onDocumentClick);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$('body').on('click', this.onDocumentClick);
			}
		}]);
	
		return ButtonDropdown;
	}(React.Component);
	
	;
	
	ButtonDropdown.propTypes = StrictPropTypes({
		// Has the list items
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
	
		// "Selected" text to show
		text: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
	
		// Toggles formatting changes
		dropdownDisplay: PropTypes.string,
		rightMenu: PropTypes.bool,
		useRadioButton: PropTypes.bool,
		stickyOpen: PropTypes.bool,
	
		// Glyphicon to show next to the selected option
		icon: PropTypes.string,
	
		// Class to include in the wrap element
		className: PropTypes.string,
	
		// Class for the button itself
		buttonClassName: PropTypes.string,
	
		// Makes the button dropdown operating in "input mode", storing text in state, automatically
		// changing the display on option select and making the selected text available via .val()
		inputMode: PropTypes.bool,
	
		// Only for use when in inputMode
		defaultValue: PropTypes.string,
		defaultText: PropTypes.string,
		onChange: PropTypes.func,
	
		// Tooltip for label
		dataTip: PropTypes.string,
	
		// Passed on to outer div
		style: PropTypes.object,
	
		// used to make wider
		wide: PropTypes.boolean
	});
	
	module.exports = ButtonDropdown;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchQuizzes = fetchQuizzes;
	exports.deleteQuiz = deleteQuiz;
	exports.updateQuiz = updateQuiz;
	exports.createQuiz = createQuiz;
	exports.fetchAnswers = fetchAnswers;
	exports.fetchAnswer = fetchAnswer;
	exports.fetchNonQuizAnswers = fetchNonQuizAnswers;
	exports.fetchMetaCognitionAnswers = fetchMetaCognitionAnswers;
	exports.fetchReviews = fetchReviews;
	exports.deleteAnswer = deleteAnswer;
	exports.updateAnswer = updateAnswer;
	exports.localUpdateAnswer = localUpdateAnswer;
	exports.createAnswer = createAnswer;
	exports.updateEvaluation = updateEvaluation;
	exports.fetchEvaluations = fetchEvaluations;
	exports.fetchQuestions = fetchQuestions;
	exports.createQuestion = createQuestion;
	exports.updateQuestion = updateQuestion;
	exports.deleteQuestion = deleteQuestion;
	exports.fetchComments = fetchComments;
	exports.updateComment = updateComment;
	exports.createComment = createComment;
	exports.deleteComment = deleteComment;
	exports.fetchRatings = fetchRatings;
	exports.updateRating = updateRating;
	exports.deleteRating = deleteRating;
	exports.createRating = createRating;
	exports.fetchResponses = fetchResponses;
	exports.fetchTasks = fetchTasks;
	exports.createTasks = createTasks;
	exports.deleteTask = deleteTask;
	exports.deleteManyTasks = deleteManyTasks;
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	var ActionUtility = __webpack_require__(95);
	var WritingSelectors = __webpack_require__(14);
	var Queries = __webpack_require__(109);
	
	////////////////////////////////////////
	// Quizzes /////////////////////////////
	////////////////////////////////////////
	
	function fetchQuizzes(_ref) {
		var filters = _ref.filters,
		    conditions = _ref.conditions,
		    embeds = _ref.embeds,
		    page = _ref.page,
		    cache = _ref.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			var pagination = { key: $wr.sortedJSON(params), page: page };
			return dispatch(ActionUtility.fetchRecords(APIClient.getQuizzes, { quizzes: [Schema.QUIZ] }, { params: params, embeds: embeds, page: page }, { reducer: "quizzes", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function deleteQuiz(_ref2) {
		var id = _ref2.id;
	
		return function (dispatch) {
			APIClient.deleteQuiz(id);
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, quizzes: [id] });
		};
	}
	
	function updateQuiz(_ref3) {
		var id = _ref3.id,
		    update = _ref3.update,
		    embeds = _ref3.embeds,
		    query = _ref3.query;
	
		var params = _.extend({}, query, { quiz: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, quizzes: [id], update: update });
			// Run this through `ActionUtility.fetchRecords` b/c we sometimes want to load answers
			return dispatch(ActionUtility.fetchRecords(APIClient.patchQuiz.bind(null, id), { quiz: Schema.QUIZ }, { params: params, embeds: embeds }, { reducer: "quizzes", loading: "update" }));
		};
	}
	
	function createQuiz(_ref4) {
		var quiz = _ref4.quiz,
		    embeds = _ref4.embeds;
	
		var params = { quiz: quiz };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postQuizzes, { quiz: Schema.QUIZ }, { embeds: embeds, params: params }, { reducer: "quizzes", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// Answers /////////////////////////////
	////////////////////////////////////////
	
	function fetchAnswers(_ref5) {
		var filters = _ref5.filters,
		    conditions = _ref5.conditions,
		    embeds = _ref5.embeds,
		    page = _ref5.page,
		    cache = _ref5.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			var pagination = { key: $wr.sortedJSON(params), page: page };
			return dispatch(ActionUtility.fetchRecords(APIClient.getAnswers, { answers: [Schema.ANSWER] }, { params: params, embeds: embeds, page: page }, { reducer: "answers", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function fetchAnswer(_ref6) {
		var id = _ref6.id,
		    embeds = _ref6.embeds;
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getAnswer, id, { answer: Schema.ANSWER }, { embeds: embeds }, { reducer: "answers", loading: id }));
		};
	}
	
	function fetchNonQuizAnswers(_ref7) {
		var filters = _ref7.filters,
		    conditions = _ref7.conditions,
		    embeds = _ref7.embeds,
		    page = _ref7.page,
		    cache = _ref7.cache;
	
		return function (dispatch) {
			var params = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
			var pagination = { key: $wr.sortedJSON(params), page: page };
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getAnswers, { answers: [Schema.ANSWER] }, { params: params, embeds: embeds, page: page }, { reducer: "answers", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function fetchMetaCognitionAnswers(_ref8) {
		var filters = _ref8.filters,
		    conditions = _ref8.conditions,
		    embeds = _ref8.embeds,
		    page = _ref8.page,
		    cache = _ref8.cache;
	
		return function (dispatch) {
			var params = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
			var pagination = { key: $wr.sortedJSON(params), page: page };
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getAnswers, { answers: [Schema.ANSWER] }, { params: params, embeds: embeds, page: page }, { reducer: "answers", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function fetchReviews(_ref9) {
		var filters = _ref9.filters,
		    conditions = _ref9.conditions,
		    embeds = _ref9.embeds,
		    page = _ref9.page,
		    cache = _ref9.cache;
	
		return function (dispatch) {
			var params = Queries.reviewQuery(Queries.toQuery(filters, conditions));
			var pagination = { key: $wr.sortedJSON(params), page: page };
			return dispatch(ActionUtility.fetchRecords(APIClient.getAnswers, { answers: [Schema.ANSWER] }, { params: params, embeds: embeds, page: page }, { reducer: "answers", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function deleteAnswer(_ref10) {
		var id = _ref10.id;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.REMOVE_RECORDS, answers: [id] });
			return APIClient.deleteAnswer(id);
		};
	}
	
	function updateAnswer(_ref11) {
		var id = _ref11.id,
		    update = _ref11.update,
		    embeds = _ref11.embeds,
		    query = _ref11.query;
	
		var params = _.extend({}, query, { answer: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, answers: [id], update: update });
			return dispatch(ActionUtility.fetchRecords(APIClient.patchAnswer.bind(null, id), { answer: Schema.ANSWER }, { params: params, embeds: embeds }, { reducer: "answers", loading: "update" }));
		};
	}
	
	function localUpdateAnswer(_ref12) {
		var id = _ref12.id,
		    update = _ref12.update;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, answers: [id], update: update });
			// Theoretically... defer until the change happens? I'm not sure how this works
			return Promise.resolve();
		};
	}
	
	function createAnswer(_ref13) {
		var answer = _ref13.answer,
		    embeds = _ref13.embeds;
	
		var params = { answer: answer };
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postAnswers, { answer: Schema.ANSWER }, { embeds: embeds, params: params }, { reducer: "answers", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// Evaluations /////////////////////////
	////////////////////////////////////////
	
	function updateEvaluation(_ref14) {
		var id = _ref14.id,
		    update = _ref14.update;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, evaluations: [id], update: update });
			return APIClient.patchEvaluation(id, { evaluation: update });
		};
	}
	
	function fetchEvaluations(_ref15) {
		var filters = _ref15.filters,
		    conditions = _ref15.conditions,
		    embeds = _ref15.embeds,
		    page = _ref15.page,
		    cache = _ref15.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			var pagination = { key: $wr.sortedJSON(params), page: page };
			return dispatch(ActionUtility.fetchRecords(APIClient.getEvaluations, { evaluations: [Schema.EVALUATION] }, { params: params, embeds: embeds, page: page }, { reducer: "evaluations", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	////////////////////////////////////////
	// Questions ///////////////////////////
	////////////////////////////////////////
	
	function fetchQuestions(_ref16) {
		var filters = _ref16.filters,
		    conditions = _ref16.conditions,
		    query = _ref16.query,
		    embeds = _ref16.embeds,
		    page = _ref16.page,
		    cache = _ref16.cache;
	
		return function (dispatch) {
			var params = _.extend(Queries.toQuery(filters, conditions), query);
			var pagination = { key: $wr.sortedJSON(params), page: page };
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getQuestions, { questions: [Schema.QUESTION] }, { params: params, embeds: embeds, page: page }, { reducer: "questions", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function createQuestion(_ref17) {
		var question = _ref17.question,
		    embeds = _ref17.embeds,
		    query = _ref17.query;
	
		var params = _.extend({}, query, { question: question });
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postQuestions, { question: Schema.QUESTION }, { embeds: embeds, params: params }, { reducer: "questions", loading: "create" }));
		};
	}
	
	function updateQuestion(_ref18) {
		var id = _ref18.id,
		    update = _ref18.update,
		    embeds = _ref18.embeds,
		    query = _ref18.query;
	
		var params = _.extend({}, query, { question: update });
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, questions: [id], update: update });
			return dispatch(ActionUtility.fetchRecords(APIClient.patchQuestion.bind(null, id), { deal: Schema.QUESTION }, { params: params, embeds: embeds }, { reducer: "questions", loading: "update" }));
		};
	}
	
	function deleteQuestion(_ref19) {
		var id = _ref19.id;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.REMOVE_RECORDS, questions: [id] });
			return APIClient.deleteQuestion(id);
		};
	}
	
	////////////////////////////////////////
	// Comments ////////////////////////////
	////////////////////////////////////////
	
	function fetchComments(_ref20) {
		var filters = _ref20.filters,
		    conditions = _ref20.conditions,
		    embeds = _ref20.embeds,
		    page = _ref20.page,
		    cache = _ref20.cache,
		    loadingKey = _ref20.loadingKey;
	
		loadingKey = loadingKey || "index";
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			return dispatch(ActionUtility.fetchRecords(APIClient.getComments, { comments: [Schema.COMMENT] }, { params: params, embeds: embeds, page: page }, { reducer: "comments", loading: loadingKey, cache: cache }));
		};
	}
	
	function updateComment(_ref21) {
		var id = _ref21.id,
		    update = _ref21.update,
		    embeds = _ref21.embeds,
		    query = _ref21.query;
	
		var params = _.extend({}, query, { comment: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, comments: [id], update: update });
	
			return dispatch(ActionUtility.fetchRecords(APIClient.patchComment.bind(null, id), { comment: Schema.COMMENT }, { params: params, embeds: embeds }, { reducer: "comments", loading: "update" }));
		};
	}
	
	function createComment(_ref22) {
		var comment = _ref22.comment,
		    embeds = _ref22.embeds,
		    query = _ref22.query;
	
		var params = _.extend({}, query, { comment: comment });
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postComments, { comment: Schema.COMMENT }, { embeds: embeds, params: params }, { reducer: "comments", loading: "create" }));
		};
	}
	
	function deleteComment(_ref23) {
		var id = _ref23.id,
		    query = _ref23.query;
	
		var params = _.extend({}, query);
	
		return function (dispatch) {
			APIClient.deleteComment(id, query);
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, comments: [id] });
		};
	}
	
	////////////////////////////////////////
	// Ratings ///////////////////////////////
	////////////////////////////////////////
	
	function fetchRatings(_ref24) {
		var filters = _ref24.filters,
		    conditions = _ref24.conditions,
		    embeds = _ref24.embeds,
		    page = _ref24.page,
		    cache = _ref24.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			return dispatch(ActionUtility.fetchRecords(APIClient.getRatings, { ratings: [Schema.RATING] }, { params: params, embeds: embeds, page: page }, { reducer: "ratings", loading: "index", cache: cache }));
		};
	}
	
	function updateRating(_ref25) {
		var id = _ref25.id,
		    update = _ref25.update,
		    embeds = _ref25.embeds,
		    query = _ref25.query;
	
		var params = _.extend({}, query, { rating: update });
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, ratings: [id], update: update });
			return dispatch(ActionUtility.fetchRecords(APIClient.patchRating.bind(null, id), { rating: Schema.RATING }, { params: params, embeds: embeds }, { reducer: "ratings", loading: "update" }));
		};
	}
	
	function deleteRating(_ref26) {
		var id = _ref26.id;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.REMOVE_RECORDS, ratings: [id] });
			return APIClient.deleteRating(id);
		};
	}
	
	function createRating(_ref27) {
		var rating = _ref27.rating,
		    embeds = _ref27.embeds;
	
		var params = { rating: rating };
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postRatings, { rating: Schema.RATING }, { embeds: embeds, params: params }, { reducer: "ratings", loading: "create" }));
		};
	}
	
	////////////////////////////////////////
	// Responses ///////////////////////////
	////////////////////////////////////////
	
	function fetchResponses(_ref28) {
		var filters = _ref28.filters,
		    conditions = _ref28.conditions,
		    embeds = _ref28.embeds,
		    page = _ref28.page,
		    cache = _ref28.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			return dispatch(ActionUtility.fetchRecords(APIClient.getResponses, { responses: [Schema.RESPONSE] }, { params: params, embeds: embeds, page: page }, { reducer: "responses", loading: "index", cache: cache }));
		};
	}
	
	////////////////////////////////////////
	// Activities //////////////////////////
	////////////////////////////////////////
	
	var fetchActivity = exports.fetchActivity = function fetchActivity(_ref29) {
		var id = _ref29.id,
		    embeds = _ref29.embeds,
		    query = _ref29.query,
		    cache = _ref29.cache;
	
		var params = _extends({}, query);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.getActivity, id, { activity: Schema.ACTIVITY }, { params: params, embeds: embeds }, { reducer: "activities", loading: id, cache: cache }));
		};
	};
	
	var fetchActivities = exports.fetchActivities = function fetchActivities(_ref30) {
		var filters = _ref30.filters,
		    conditions = _ref30.conditions,
		    embeds = _ref30.embeds,
		    page = _ref30.page,
		    cache = _ref30.cache;
	
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page: page };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getActivities, { activities: [Schema.ACTIVITY] }, { params: params, embeds: embeds, page: page }, { reducer: "activities", loading: "index", cache: cache, pagination: pagination }));
		};
	};
	
	var clearActivities = exports.clearActivities = function clearActivities() {
		return function (dispatch) {
			return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, activities: true });
		};
	};
	
	////////////////////////////////////////
	// Tasks ///////////////////////////////
	////////////////////////////////////////
	
	function fetchTasks(_ref31) {
		var filters = _ref31.filters,
		    conditions = _ref31.conditions,
		    embeds = _ref31.embeds,
		    page = _ref31.page,
		    cache = _ref31.cache,
		    query = _ref31.query;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			params = _extends({}, query, params);
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getTasks, { tasks: [Schema.TASK] }, { params: params, embeds: embeds, page: page }, { reducer: "tasks", loading: "index", cache: cache }));
		};
	}
	
	function createTasks(_ref32) {
		var tasks = _ref32.tasks,
		    query = _ref32.query;
	
		var params = _.extend({}, query, { tasks: tasks });
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postTasks, { tasks: [Schema.TASK] }, { params: params }, { reducer: "tasks", loading: "create" }));
		};
	}
	
	function deleteTask(_ref33) {
		var id = _ref33.id;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.REMOVE_RECORDS, tasks: [id] });
			return APIClient.deleteTask(id);
		};
	}
	
	function deleteManyTasks(_ref34) {
		var filters = _ref34.filters,
		    conditions = _ref34.conditions;
	
		return function (dispatch, getState) {
			var tasks = WritingSelectors.tasks({ state: getState(), filters: filters, conditions: conditions });
	
			dispatch({ type: ActionUtility.REMOVE_RECORDS, tasks: _.pluck(tasks, "id") });
	
			var params = Queries.toQuery(filters, conditions);
			return APIClient.deleteTask("many", params);
		};
	}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	////////////////////////////////
	// WhooosReadingServices.js ////
	////////////////////////////////
	
	var WhooosReadingServices = {
		OuterPages: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction()) {
					return "www.whooosreading.org";
				} else if ($wr.isStaging()) {
					return "www.savvashortondev.com";
				} else if ($wr.isDevelopment()) {
					return "localhost:3000";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		WebApp: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction()) {
					return "app.whooosreading.org";
				} else if ($wr.isStaging()) {
					return "app.savvashortondev.com";
				} else if ($wr.isDevelopment()) {
					return "localhost:3001";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		Cheshire: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction()) {
					return "cheshire.whooosreading.org";
				} else if ($wr.isDevelopment()) {
					return "localhost:30010";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		FileStation: {
			protocol: function protocol() {
				return WhooosReadingServices.OuterPages.protocol();
			},
	
			host: function host() {
				// Check process.env here
				return WhooosReadingServices.OuterPages.host() + "/file_station";
			},
	
			url: function url(path) {
				return this.protocol() + this.host() + path;
			}
		},
	
		Documents: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				var hostBase = WhooosReadingServices.ApiServer.host().replace("/api/v1", "");
				return hostBase + "/docs";
			},
	
			url: function url(path) {
				return this.protocol() + this.host() + path;
			}
		},
	
		SsoServer: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				var hostBase = WhooosReadingServices.ApiServer.host().replace("/api/v1", "");
				return hostBase + "/sso";
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		CanonicalSchools: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction() || $wr.isStaging() || $wr.isDevelopment() && !$wr.checkCustomEnv("local-canonical-schools")) {
					return "schools.whooosreading.org/api/v1/public";
				} else if ($wr.isDevelopment()) {
					return "localhost:3005/api/v1/public";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			},
	
			browseUrl: function browseUrl(path, queryParams) {
				return this.protocol() + this.host().replace("/api/v1/public", "") + path + createQueryString(queryParams);
			}
		},
	
		Matilda: {
			protocol: httpsProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction() || $wr.isStaging() || $wr.isDevelopment() && !$wr.checkCustomEnv("local-matilda")) {
					return "matilda.whooosreading.org/api/v1";
				} else if ($wr.isDevelopment()) {
					return "localhost:3007/api/v1";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		ApiServer: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction()) {
					return "api.whooosreading.org/api/v1";
				} else if ($wr.isStaging()) {
					return "api.savvashortondev.com/api/v1";
				} else if ($wr.isDevelopment()) {
					return "localhost:3002/api/v1";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		},
	
		LegacyServer: {
			protocol: defaultProtocolBehavior,
	
			host: function host() {
				if ($wr.isProduction()) {
					return "api.whooosreading.org";
				} else if ($wr.isStaging()) {
					return "api.savvashortondev.com";
				} else if ($wr.isDevelopment()) {
					return "localhost:3002";
				} else {
					throw "Unknown environment";
				}
			},
	
			url: function url(path, queryParams) {
				return this.protocol() + this.host() + path + createQueryString(queryParams);
			}
		}
	
	};
	
	function defaultProtocolBehavior() {
		if ($wr.isProduction() || $wr.isStaging()) {
			return "https://";
		} else if ($wr.isDevelopment()) {
			return "http://";
		} else {
			throw "Unknown environment";
		}
	}
	
	function httpsProtocolBehavior() {
		return "https://";
	}
	
	function createQueryString(queryParams) {
		var queryString = '';
		var first = true;
		for (var queryParamName in queryParams) {
			if (first) {
				first = false;
				queryString += '?';
			} else {
				queryString += '&';
			}
	
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
		}
	
		return queryString;
	}
	
	module.exports = WhooosReadingServices;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var ButtonDropdownOption = __webpack_require__(31);
	var _Skillsets = __webpack_require__(55);
	var AccountPlans = __webpack_require__(53);
	var TextTypes = __webpack_require__(38);
	var _Formats = __webpack_require__(105);
	var GradeLevel = __webpack_require__(40);
	var AltSkillsets = __webpack_require__(200);
	var moment = __webpack_require__(15);
	var ReadingLevelFormat = __webpack_require__(72);
	
	var DropDownOptions = {
		Select: {
			ReadingLevels: function ReadingLevels(props) {
				if (props.lexile_to_formats) {
					var options = [];
					var values = [];
	
					if (props.lexile_to_formats == "Lexile Level") {
						for (var i = 0; i < 2201; i += 5) {
							// inject current reading level into dropdown if present
							if (props.current_reading_level) {
								var current_reading_level = props.current_reading_level.current_reading_level;
	
								if (current_reading_level && current_reading_level > i - 5 && current_reading_level < i) {
									options.push(React.createElement(
										"option",
										{ value: current_reading_level, key: current_reading_level },
										current_reading_level,
										"L"
									));
								}
							}
							options.push(React.createElement(
								"option",
								{ value: i, key: i },
								i,
								"L"
							));
						}
					} else {
						_.each(ReadingLevelFormat.LEXILE_TO_FORMATS[props.lexile_to_formats], function (label, lexile) {
							if (label != "N/A" && lexile != "N/A" && !isNaN(parseInt(lexile)) && values.indexOf(label) == -1) {
								options.push(React.createElement(
									"option",
									{ value: lexile, key: lexile },
									label
								));
								values.push(label);
							}
						});
					}
					options.push(React.createElement(
						"option",
						{ value: -1, key: "cancel" },
						"Cancel"
					));
					return options;
				} else {
					return [];
				}
			},
			ExpectationPeriods: function ExpectationPeriods(props) {
				var options = [];
				_.each($wr.Constants.PERIODS, function (label, key) {
					if (props.filter == undefined || props.filter.indexOf(label) == -1) {
						options.push(React.createElement(
							"option",
							{ value: label, key: key },
							label
						));
					}
				});
				return options;
			},
			RecallQuestionCount: function RecallQuestionCount(props) {
				return [React.createElement(
					"option",
					{ value: 0, key: 0 },
					"0"
				), React.createElement(
					"option",
					{ value: 2, key: 2 },
					"2"
				), React.createElement(
					"option",
					{ value: 3, key: 3 },
					"3"
				), React.createElement(
					"option",
					{ value: 4, key: 4 },
					"4"
				), React.createElement(
					"option",
					{ value: 5, key: 5 },
					"5"
				)];
			},
			AnalysisQuestionCount: function AnalysisQuestionCount(props) {
				return [React.createElement(
					"option",
					{ value: 1, key: 1 },
					"1"
				), React.createElement(
					"option",
					{ value: 2, key: 2 },
					"2"
				), React.createElement(
					"option",
					{ value: 3, key: 3 },
					"3"
				)];
			},
			SentenceStarter: function SentenceStarter(props) {
				return [React.createElement(
					"option",
					{ value: "On", key: 0 },
					"On"
				), React.createElement(
					"option",
					{ value: "Off", key: 1 },
					"Off"
				)];
			},
			GradeLevels: function GradeLevels(props) {
				return [React.createElement(
					"option",
					{ value: "-1", key: "PK" },
					"PK"
				), React.createElement(
					"option",
					{ value: "0", key: "K" },
					"K"
				), React.createElement(
					"option",
					{ value: "1", key: "1" },
					"1st"
				), React.createElement(
					"option",
					{ value: "2", key: "2" },
					"2nd"
				), React.createElement(
					"option",
					{ value: "3", key: "3" },
					"3rd"
				), React.createElement(
					"option",
					{ value: "4", key: "4" },
					"4th"
				), React.createElement(
					"option",
					{ value: "5", key: "5" },
					"5th"
				), React.createElement(
					"option",
					{ value: "6", key: "6" },
					"6th"
				), React.createElement(
					"option",
					{ value: "7", key: "7" },
					"7th"
				), React.createElement(
					"option",
					{ value: "8", key: "8" },
					"8th"
				), React.createElement(
					"option",
					{ value: "9", key: "9" },
					"9th"
				), React.createElement(
					"option",
					{ value: "10", key: "10" },
					"10th"
				), React.createElement(
					"option",
					{ value: "11", key: "11" },
					"11th"
				), React.createElement(
					"option",
					{ value: "12", key: "12" },
					"12th"
				)];
			},
			ExpectationGradeLevels: function ExpectationGradeLevels(props) {
				return [React.createElement(
					"option",
					{ value: "Mixed", key: "Mixed" },
					"All Levels"
				), React.createElement(
					"option",
					{ value: "-1", key: "PK" },
					"PK"
				), React.createElement(
					"option",
					{ value: "0", key: "K" },
					"K"
				), React.createElement(
					"option",
					{ value: "1", key: "1" },
					"1st"
				), React.createElement(
					"option",
					{ value: "2", key: "2" },
					"2nd"
				), React.createElement(
					"option",
					{ value: "3", key: "3" },
					"3rd"
				), React.createElement(
					"option",
					{ value: "4", key: "4" },
					"4th"
				), React.createElement(
					"option",
					{ value: "5", key: "5" },
					"5th"
				), React.createElement(
					"option",
					{ value: "6", key: "6" },
					"6th"
				), React.createElement(
					"option",
					{ value: "7", key: "7" },
					"7th"
				), React.createElement(
					"option",
					{ value: "8", key: "8" },
					"8th"
				), React.createElement(
					"option",
					{ value: "9", key: "9" },
					"9th"
				), React.createElement(
					"option",
					{ value: "10", key: "10" },
					"10th"
				), React.createElement(
					"option",
					{ value: "11", key: "11" },
					"11th"
				), React.createElement(
					"option",
					{ value: "12", key: "12" },
					"12th"
				)];
			},
			contestReadingMetrics: function contestReadingMetrics(props) {
				return [React.createElement(
					"option",
					{ value: "minutes_read", key: "minutes_read" },
					"Minutes Read"
				), React.createElement(
					"option",
					{ value: "pages_read", key: "pages_read" },
					"Pages Read"
				), React.createElement(
					"option",
					{ value: "titles_read", key: "titles_read" },
					"Titles Read"
				), React.createElement(
					"option",
					{ value: "verified_minutes_read", key: "verified_minutes_read" },
					"Verified Minutes Read"
				), React.createElement(
					"option",
					{ value: "verified_pages_read", key: "verified_pages_read" },
					"Verified Pages Read"
				)];
			},
			contestWritingMetrics: function contestWritingMetrics(props) {
				return [React.createElement(
					"option",
					{ value: "writing_count", key: "writing_count" },
					"All Writing"
				), React.createElement(
					"option",
					{ value: "quiz_count", key: "quiz_count" },
					"Quiz Completed"
				), React.createElement(
					"option",
					{ value: "quiz_passed_count", key: "quiz_passed_count" },
					"Quiz Passed"
				), React.createElement(
					"option",
					{ value: "answers_count", key: "answer_count" },
					"Answers"
				), React.createElement(
					"option",
					{ value: "reviews_count", key: "reviews_count" },
					"Reviews Completed"
				)];
			},
			Titles: function Titles(props) {
				return _.map($wr.Constants.BASE_TITLES, function (title) {
					return React.createElement(
						"option",
						{ value: title, key: title },
						title
					);
				});
			},
			Months: function Months(props) {
				var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
				return _.map(months, function (month, i) {
					if (props && props.longForm) {
						var text = i + 1 + " - " + month;
					} else if (props && props.monthNameOnly) {
						var text = month;
					} else {
						var text = i + 1;
					}
					return React.createElement(
						"option",
						{ value: i + 1, key: i + 1 },
						text
					);
				});
			},
			FutureYears: function FutureYears(props) {
				props = props || {};
	
				var yearsForward = props.yearsForward || 25;
				var options = [];
				var year = parseInt($wr.momentInTimezone(new Date()).format("Y"));
	
				for (var i = 0; i < yearsForward; i++) {
					var thisYear = year + i;
					if (props.shortForm) {
						thisYear = thisYear % 100;
					}
	
					options.push(React.createElement(
						"option",
						{ value: thisYear, key: thisYear },
						thisYear
					));
				}
				return options;
			},
			LastWeekDays: function LastWeekDays(props) {
				var options = [];
	
				if (props && props.days && parseInt(props.days) > 0) {
					var dayCount = parseInt(props.days);
				} else {
					var dayCount = 7;
				}
	
				for (var i = 0; i < dayCount; i++) {
					var thisDay = moment().subtract(i, 'days').format('YYYY-MM-DD');
					var dayOfWeek = moment().subtract(i, 'days').format('dddd');
					var displayDay = i + " " + $wr.pluralize("day", i) + " ago " + "(" + dayOfWeek + ")";
					if (i == 0) {
						var displayDay = "Today";
					}
	
					options.push(React.createElement(
						"option",
						{ value: thisDay, key: thisDay },
						displayDay
					));
				}
				return options;
			},
			OwlShopOpeningTimes: function OwlShopOpeningTimes() {
				var options = [];
				options.push(React.createElement(
					"option",
					{ value: "Always", key: "Always" },
					"Always leave open"
				));
				options.push(React.createElement(
					"option",
					{ value: "Never", key: "Never" },
					"Close permanently"
				));
				var DEFAULT_VALUE = "Always leave open";
				var OPTION_LABEL = "Open after ";
				for (var h = 1; h < 8; h++) {
					var value = h + " PM";
					var text = "Open at " + value;
					options.push(React.createElement(
						"option",
						{ value: value, key: h },
						text
					));
				}
				return options;
			},
			QuizClosingTimes: function QuizClosingTimes() {
				var options = [];
				options.push(React.createElement(
					"option",
					{ value: "Never", key: "Never" },
					"Never close"
				));
				options.push(React.createElement(
					"option",
					{ value: "Always", key: "Always" },
					"Always closed"
				));
				for (var h = 1; h < 6; h++) {
					var value = h + " PM";
					var text = "Close at " + value;
					options.push(React.createElement(
						"option",
						{ value: value, key: h },
						text
					));
				}
				return options;
			},
			Time: function Time() {
				var outputOptions = [];
				var hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
	
				_.each(hours, function (hour, i) {
					for (var i = 0; i <= 3; i++) {
						var minutes = i * 15;
						var minutesString = $wr.padleft(minutes, 2);
						var outputTime = $wr.padleft(hour) + ":" + minutesString;
						var pmTime = hour - 12 + ":" + minutesString;
	
						if (hour == 0) {
							var display = "12" + ":" + minutesString + " am";
							var value = "0" + outputTime + ":00";
						} else if (hour == 10 || hour == 11) {
							var display = outputTime + " am";
							var value = outputTime + ":00";
						} else if (hour < 12) {
							var display = outputTime + " am";
							var value = "0" + outputTime + ":00";
						} else if (hour == 12) {
							var display = outputTime + " pm";
							var value = outputTime + ":00";
						} else {
							var display = pmTime + " pm";
							var value = outputTime + ":00";
						}
						outputOptions.push(React.createElement(
							"option",
							{ value: value, key: outputTime },
							display
						));
					}
				});
	
				return outputOptions;
			},
			PaidPlanOptions: function PaidPlanOptions(props) {
				return _.map(AccountPlans.PAID_PLANS, function (planType) {
					return React.createElement(
						"option",
						{ key: planType, value: planType },
						AccountPlans.name(planType)
					);
				});
			},
			PaidPlanTrialOptions: function PaidPlanTrialOptions(props) {
				return _.map(AccountPlans.PAID_ANNUAL_PLANS, function (planType) {
					return React.createElement(
						"option",
						{ key: planType, value: planType + "-trial" },
						"Trial: ",
						AccountPlans.name(planType)
					);
				});
			},
			Locations: function Locations(props) {
				return [React.createElement(
					"option",
					{ value: "School", key: "School" },
					"School"
				), React.createElement(
					"option",
					{ value: "Home", key: "Home" },
					"Home"
				)];
			},
			TextVarieties: function TextVarieties(props) {
				return _.map(_.pairs(TextTypes.Varieties.TYPES), function (pair) {
					return React.createElement(
						"option",
						{ value: pair[0], key: pair[0] },
						pair[1].name
					);
				});
			},
			DifferentiatedLearning: function DifferentiatedLearning(props) {
				return [React.createElement(
					"option",
					{ value: "true", key: "true" },
					"On"
				), React.createElement(
					"option",
					{ value: "false", key: "false" },
					"Off"
				)];
			},
			YesNo: function YesNo(props) {
				return [React.createElement(
					"option",
					{ value: "true", key: "true" },
					"Yes"
				), React.createElement(
					"option",
					{ value: "false", key: "false" },
					"No"
				)];
			},
			simpleText: function simpleText(props) {
				return _.map(props.options, function (opText) {
					return React.createElement(
						"option",
						{ value: opText, key: opText },
						opText
					);
				});
			},
			GroupColors: function GroupColors(props) {
				return [React.createElement("option", { value: "#32b3f6", key: "Blue" }), React.createElement("option", { value: "#409e1a", key: "Green" }), React.createElement("option", { value: "#e8cb3a", key: "Yellow" }), React.createElement("option", { value: "#ca5f2b", key: "Orange" }), React.createElement("option", { value: "#7f45b1", key: "Purple" })];
			},
			GroupIcons: function GroupIcons(props) {
				return [React.createElement("option", { value: "leaf", key: "Leaf" }), React.createElement("option", { value: "tree-conifer", key: "Pine" }), React.createElement("option", { value: "tree-deciduous", key: "Maple" }), React.createElement("option", { value: "cloud", key: "Cloud" }), React.createElement("option", { value: "fire", key: "Fire" })];
			}
		},
	
		Button: {
			GradeLevels: function GradeLevels(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
				var options = [];
	
				for (var i = -1; i <= 13; i++) {
					var text;
					if (i == -1) {
						text = "PK";
					} else if (i == 0) {
						text = "K";
					} else if (i == 13) {
						text = "Mixed";
					} else {
						text = $wr.getOrdinal(i);
					}
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(i),
						text: text, key: i }));
				}
				return options;
			},
			Skillsets: function Skillsets(props) {
				props = props || {};
				var buildF = props.buildOptionF || function (x) {
					_.identity;
				};
	
				var options = [];
				if (props.allOption) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(null),
						text: "All skill sets", key: "all" }));
				}
	
				var pairs = _.sortBy(_.pairs(_Skillsets.TYPES), function (pair) {
					return pair[1].name;
				});
	
				// Optional filter for fiction only or non-fiction only skill sets
				if (props.fictionOnly) {
					pairs = _.filter(pairs, function (pair) {
						return _Skillsets.hasFiction(pair[0]);
					});
				} else if (props.nonFictionOnly) {
					pairs = _.filter(pairs, function (pair) {
						return _Skillsets.hasNonFiction(pair[0]);
					});
				}
	
				if (props.readingOnly) {
					pairs = _.filter(pairs, function (pair) {
						return _Skillsets.isReading(pair[0]);
					});
				}
	
				if (props.ogReadingOnly) {
					pairs = _.filter(pairs, function (pair) {
						return _Skillsets.isOgReading(pair[0]);
					});
				}
	
				if (props.writingOnly) {
					pairs = _.filter(pairs, function (pair) {
						return _Skillsets.isWriting(pair[0]);
					});
				}
	
				_.each(pairs, function (pair) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(pair[0]), key: pair[0],
						value: pair[0], text: pair[1].name }));
				});
	
				return options;
			},
			Grades: function Grades(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
	
				var options = [];
				if (props.allOption) {
	
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(null), text: "All grades", key: "all" }));
				}
	
				_.each(_.pairs(GradeLevel.TYPES), function (pair) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(pair[0]), key: pair[0],
						text: GradeLevel.getName(pair[0]) }));
				});
	
				return options;
			},
			Formats: function Formats(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
	
				var options = [];
				if (props.allOption) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(null),
						text: "All formats", key: "all" }));
				}
				_.each(_.pairs(_Formats.TYPES), function (pair) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(pair[0]),
						text: pair[1].name, key: pair[0] }));
				});
	
				return options;
			},
			TextVarieties: function TextVarieties(props) {
				props = props || {};
	
				var options = [];
	
				if (props.anyOrSpecific) {
					var keys = [TextTypes.Varieties.FICTION_AND_NON_FICTION, TextTypes.Varieties.SPECIFIC_TEXT];
				} else {
					var keys = _.keys(TextTypes.Varieties.TYPES);
					if (props.altOptions) {
						keys.push(TextTypes.Varieties.SPECIFIC_TEXT);
					}
				}
	
				_.each(keys, function (key) {
	
					if (props.buildOptionF) {
						var onClick = props.buildOptionF(key);
					} else if (props.onClick) {
						var onClick = function onClick() {
							props.onClick(key);
						};
					} else {
						var onClick = _.identity;
					}
	
					if (props.altOptions || props.anyOrSpecific) {
						var name = TextTypes.Varieties.getAltName(key);
					} else {
						var name = TextTypes.Varieties.getName(key);
					}
	
					options.push(React.createElement(ButtonDropdownOption, { onClick: onClick, text: name,
						className: props.className, key: key }));
				});
	
				return options;
			},
			Students: function Students(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
	
				var options = [];
	
				_.each(props.students, function (student) {
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(student),
						text: student.display_name, key: student.id }));
				});
	
				return options;
			},
			Standards: function Standards(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
	
				var options = [];
				var standardPairs = _.sortBy(_.pairs(AltSkillsets.STANDARDS), function (pair) {
					if (pair[0] == "wrss") {
						return "AA0";
					} else if (pair[0] == "ccss") {
						return "AA1";
					} else {
						return pair[1].state;
					}
				});
	
				_.each(standardPairs, function (pair) {
					var optionText = pair[1].name;
					if (props.showState && pair[1].state) {
						optionText += " (" + pair[1].state + ")";
					}
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(pair[0]),
						text: optionText, key: pair[0] }));
				});
	
				return options;
			},
			DaysOfWeek: function DaysOfWeek(props) {
				props = props || {};
				var buildF = props.buildOptionF || _.identity;
	
				var options = [];
	
				for (var i = 0; i < 7; i++) {
					var displayText = $wr.getDayOfWeek(i);
					if (props.includeWeeklyRange) {
						displayText += " - " + $wr.getDayOfWeek((i + 6) % 7);
					}
					options.push(React.createElement(ButtonDropdownOption, { onClick: buildF(i),
						text: displayText, key: i }));
				}
	
				return options;
			},
			simpleText: function simpleText(props) {
				return _.map(props.options, function (opText) {
					return React.createElement(ButtonDropdownOption, { text: opText, key: opText,
						onClick: function onClick(e) {
							return props.onClick(opText);
						} });
				});
			}
		}
	};
	
	module.exports = DropDownOptions;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchLogs = fetchLogs;
	exports.deleteLog = deleteLog;
	exports.updateLog = updateLog;
	exports.updateLogs = updateLogs;
	exports.createLogs = createLogs;
	exports.fetchLibraryOnline = fetchLibraryOnline;
	exports.fetchLibraryPlatforms = fetchLibraryPlatforms;
	exports.fetchBookActivity = fetchBookActivity;
	exports.fetchSingleBookActivity = fetchSingleBookActivity;
	exports.batchFetchBook = batchFetchBook;
	exports.fetchBooks = fetchBooks;
	exports.fetchBookSynchronously = fetchBookSynchronously;
	exports.invalidateBookCache = invalidateBookCache;
	exports.localUpdateBook = localUpdateBook;
	exports.createOverrideUpdateBook = createOverrideUpdateBook;
	exports.createBook = createBook;
	exports.fetchReadingLevels = fetchReadingLevels;
	
	var _BatchingActions = __webpack_require__(997);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	var ActionUtility = __webpack_require__(95);
	var Queries = __webpack_require__(109);
	var ReadingSelectors = __webpack_require__(21);
	
	if ($wr.isDevelopment() && $wr.checkCustomEnv("local-matilda")) {
		var MatildaAPIClient = new (__webpack_require__(261).Client)("localhost:3007", "http");
	} else {
		var MatildaAPIClient = new (__webpack_require__(261).Client)("matilda.whooosreading.org", "https");
	}
	
	var WhooosReadingServices = __webpack_require__(25);
	
	//////////////////////////////////////////////
	// Logs //////////////////////////////////////
	//////////////////////////////////////////////
	
	function fetchLogs(_ref) {
		var filters = _ref.filters,
		    conditions = _ref.conditions,
		    embeds = _ref.embeds,
		    page = _ref.page,
		    cache = _ref.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			return dispatch(ActionUtility.fetchRecords(APIClient.getLogs, { logs: [Schema.LOG] }, { params: params, embeds: embeds, page: page }, { reducer: "logs", loading: "index", cache: cache }));
		};
	}
	
	function deleteLog(_ref2) {
		var id = _ref2.id;
	
		return function (dispatch) {
			APIClient.deleteLog(id);
			return dispatch({ type: ActionUtility.REMOVE_RECORDS, logs: [id] });
		};
	}
	
	function updateLog(_ref3) {
		var id = _ref3.id,
		    update = _ref3.update;
	
		return function (dispatch) {
			APIClient.patchLog(id, { log: update });
			return dispatch({ type: ActionUtility.UPDATE_RECORDS, logs: [id], update: update });
		};
	}
	
	function updateLogs(_ref4) {
		var ids = _ref4.ids,
		    update = _ref4.update;
	
		return function (dispatch) {
			var params = { log: update, update_ids: ids };
			APIClient.patchLog(ids[0], params);
			return dispatch({ type: ActionUtility.UPDATE_RECORDS, logs: ids, update: update });
		};
	}
	
	// Note plural
	function createLogs(_ref5) {
		var logs = _ref5.logs,
		    embeds = _ref5.embeds,
		    query = _ref5.query;
	
		var params = _.extend({}, query, { logs: logs });
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postLogs, { logs: [Schema.LOG] }, { embeds: embeds, params: params }, { reducer: "logs", loading: "create" }));
		};
	}
	
	//////////////////////////////////////////////
	// Library ///////////////////////////////////
	//////////////////////////////////////////////
	
	function fetchLibraryOnline(_ref6) {
		var cache = _ref6.cache;
	
		return function (dispatch) {
			var params = {};
			return dispatch(ActionUtility.fetchRecords(MatildaAPIClient.getLibraryOnline, { books: [Schema.BOOK] }, { params: params }, { reducer: "books", loading: "index", cache: cache }));
		};
	}
	
	function fetchLibraryPlatforms(_ref7) {
		var cache = _ref7.cache;
	
		return function (dispatch) {
			var params = {};
			return dispatch(ActionUtility.fetchRecords(MatildaAPIClient.getLibraryPlatforms, { platforms: [Schema.PLATFORM] }, { params: params }, { reducer: "platforms", loading: "index", cache: cache }));
		};
	}
	
	//////////////////////////////////////////////
	// Books /////////////////////////////////////
	//////////////////////////////////////////////
	
	// This is horrible I know - Greg 2020
	function fetchBookActivity(_ref8) {
		var filters = _ref8.filters,
		    conditions = _ref8.conditions,
		    embeds = _ref8.embeds,
		    fetchDetails = _ref8.fetchDetails,
		    userID = _ref8.userID,
		    cache = _ref8.cache;
	
		conditions = conditions || {};
		var rangeKey = "activity:" + (conditions.startDate || "any") + ":" + (conditions.endDate || "any");
	
		return function (dispatch, getState) {
			var previousBooks = getState().books;
	
			function wrapBookActivity(record, recordKey) {
				if (recordKey == "books") {
					var wrappedBook = { text_id: record.text_id };
	
					var newRangeValue = _.omit(record, "text_id");;
	
					wrappedBook[rangeKey] = {};
	
					// If the book is already in the system for that time period
					// (maybe with different params), keep those values around
					var existingBook = previousBooks[record.text_id];
					if (existingBook && existingBook[rangeKey]) {
						Object.assign(wrappedBook[rangeKey], existingBook[rangeKey]);
					}
	
					Object.assign(wrappedBook[rangeKey], newRangeValue);
	
					return wrappedBook;
				} else {
					return record;
				}
			}
	
			var params = Queries.toQuery(filters, conditions);
			return dispatch(ActionUtility.fetchRecords(APIClient.getBooks, { books: [Schema.BOOK] }, { params: params, embeds: embeds }, { reducer: "books", loading: "index", cache: cache, mapRecordF: wrapBookActivity })).then(function (recieveAction) {
	
				if (fetchDetails && recieveAction) {
					// This is prehaps a little hacky...
					// We're going to intercept the action receiving the books, 
					// grab the IDs, and run them through the fetchBooks action
					// as a side effect so we can preemptively load in the titles
					// and (importantly) the text_variety, which we may need for filtering
	
					dispatch(ActionUtility.setLoadingRecords("books", "index"));
	
					var ids = _.pluck(recieveAction.books, "text_id");
					if (ids.length > 0) {
						dispatch(fetchBooks({ ids: ids, userID: userID })).then(function () {
							return dispatch(ActionUtility.clearLoadingRecords("books"));
						});
					} else {
						return dispatch(ActionUtility.clearLoadingRecords("books"));
					}
				}
	
				return recieveAction;
			});
		};
	}
	
	function fetchSingleBookActivity(_ref9) {
		var id = _ref9.id,
		    embeds = _ref9.embeds,
		    query = _ref9.query,
		    cache = _ref9.cache,
		    conditions = _ref9.conditions,
		    filters = _ref9.filters,
		    userID = _ref9.userID;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			_.extend(params, query);
	
			return dispatch(ActionUtility.fetchRecord(APIClient.getBook, id, { book: Schema.BOOK }, { params: params, embeds: embeds }, { reducer: "books", loading: id, cache: cache }));
		};
	}
	
	function batchFetchBook(_ref10) {
		var id = _ref10.id,
		    userID = _ref10.userID;
	
		return (0, _BatchingActions.registerBatched)("books", [id], function (ids) {
			return fetchBooks({ ids: ids, userID: userID });
		});
	}
	
	// Usually we will want to use batchFetchBook or fetchBookActivity instead of fetchBooks directly
	function fetchBooks(_ref11) {
		var ids = _ref11.ids,
		    userID = _ref11.userID,
		    query = _ref11.query;
	
		if (userID == undefined) {
			var params = _extends({}, query, { keys: ids.join(",") });
		} else {
			var params = _extends({}, query, { keys: ids.join(","), user_id: userID });
		}
	
		return function (dispatch) {
			return MatildaAPIClient.postScopedLookup("text_id", params).then(function (data) {
				// Adjust for the fact that we allow text_id to be mapped to different books
				// by replacing the ID of the book with the ID originally requested...
				var dataResults = _.omit(data.results, "_cached_at");
				var results = _.mapObject(dataResults, function (book, requestedID) {
					return _.extend({}, book, { text_id: requestedID });
				});
	
				dispatch(ActionUtility.receiveRecords(_.values(results), [Schema.BOOK]));
			});
		};
	}
	
	// When we want to fetch a single book synchronously
	function fetchBookSynchronously(_ref12) {
		var id = _ref12.id,
		    userID = _ref12.userID;
	
		var params = {};
		if (userID != undefined) {
			params = { user_id: userID };
		}
		return function (dispatch) {
			return MatildaAPIClient.getScopedBook("text_id", id, params).then(function (data) {
				// Adjust for the fact that we allow text_id to be mapped to different books
				// by replacing the ID of the book with the ID originally requested...
				var book = _.extend({}, data.book, { text_id: id });
				return dispatch(ActionUtility.receiveRecords(book, Schema.BOOK));
			});
		};
	}
	
	function invalidateBookCache(_ref13) {
		_objectDestructuringEmpty(_ref13);
	
		return function (dispatch) {
			return dispatch({ type: ActionUtility.INVALIDATE_CACHE, books: true });
		};
	}
	
	function localUpdateBook(_ref14) {
		var id = _ref14.id,
		    update = _ref14.update;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, books: [id], update: update });
			return Promise.resolve();
		};
	}
	
	function createOverrideUpdateBook(_ref15) {
		var override = _ref15.override,
		    update = _ref15.update;
	
		return function (dispatch) {
			dispatch({ type: ActionUtility.UPDATE_RECORDS, books: [override.instance_id], update: update });
			return MatildaAPIClient.postOverrides({ override: override });
		};
	}
	
	function createBook(_ref16) {
		var book = _ref16.book;
	
		var params = { book: book };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postBooks, { book: Schema.BOOK }, { params: params }, { reducer: "books", loading: "create" }));
		};
	}
	
	//////////////////////////////////////////////
	// Reading Levels ////////////////////////////
	//////////////////////////////////////////////
	
	function fetchReadingLevels(_ref17) {
		var filters = _ref17.filters,
		    conditions = _ref17.conditions,
		    embeds = _ref17.embeds,
		    cache = _ref17.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			dispatch(ActionUtility.fetchRecords(APIClient.getReadingLevels, { reading_levels: [Schema.READING_LEVEL] }, { params: params, embeds: embeds }, { reducer: "readingLevels", loading: "index", cache: cache }));
		};
	}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Features = __webpack_require__(16);
	var GradeLevel = __webpack_require__(40);
	var DropDownOptions = __webpack_require__(26);
	
	var StudentMetrics = {
		TYPES: {
			QUIZZES: "quizzes",
			QUIZZES_PASSED: "quizzes-passed",
			QUESTIONS: "questions",
			REVIEWS: "reviews",
			MINUTES: "minutes",
			PAGES: "pages",
			EXERCISES: "exercises",
			QUESTION_BUILDER: "question-builder",
			TEACHERS_PICKS: "teachers-picks"
		},
	
		QUIZ_OPTIONS: {
			RECALL_QUESTIONS: "recall-questions",
			ANALYSIS_QUESTIONS: "analysis-questions",
			SENTENCE_STARTERS: "sentence-starters"
		},
	
		QUIZZES_OPTIONS: {
			LAST_QUIZ: "last-quiz",
			QUIZZES: "quizzes",
			QUIZZES_PASSED: "quizzes-passed",
			LAST_QUIZ_DATE: "last-quiz-date",
			LAST_QUIZ_SCORE: "last-quiz-score",
			MEAN_QUIZ_SCORE: "mean-quiz-score",
			QUIZ_PASS_RATE: "quiz-pass-rate",
			ZPD_COUNTS: "zpd-counts",
			ZPD_BELOW: "zpd-below"
		},
	
		WRITING_OPTIONS: {
			QUESTIONS: "questions",
			REVIEWS: "reviews",
			EXERCISES: "exercises",
			WRITING: "writing",
			QUESTION_BUILDER: "question-builder"
		},
	
		READING_OPTIONS: {
			MINUTES: "minutes",
			LAST_TEXT: "last-text",
			PAGES: "pages",
			TITLES_READ: "titles-read"
		},
	
		OTHER_OPTIONS: {
			ACADEMIC_LEVEL: "academic-level",
			TOTAL_READER_LEVEL: "total-reader-level",
			DAYS_ACTIVE: "days-active",
			COINS: "coins",
			TIER: "tier"
		},
	
		AGGREGATE_OPTIONS: {
			QUIZZES: "quizzes",
			QUIZZES_PASSED: "quizzes-passed",
			MINUTES: "minutes",
			PAGES: "pages",
			COINS: "coins",
			QUESTIONS: "questions",
			REVIEWS: "reviews",
			EXERCISES: "exercises"
		},
	
		TEACHER_PICKS_SUBJECTS: {
			EXERCISE: 'exercise',
			REVIEW: 'review',
			QUIZ: 'quiz',
			PRACTICE_QUESTION: 'practice question',
			QUESTION_BUILDER: 'meta_cognition'
		},
	
		OTHER_TYPES: {
			CHALLENGES: "challenges",
			TEACHER_PICKS: "teacher-picks"
		},
	
		CONFIG: {},
	
		dashboardColumnMetrics: function dashboardColumnMetrics() {
			return _.uniq([].concat(StudentMetrics.quizMetrics(), StudentMetrics.writingMetrics(), StudentMetrics.readingMetrics(), StudentMetrics.otherMetrics())).sort();
		},
	
		aggregateMetrics: function aggregateMetrics() {
			return _.values(StudentMetrics.AGGREGATE_OPTIONS).sort();
		},
	
		quizMetrics: function quizMetrics() {
			return _.values(StudentMetrics.QUIZZES_OPTIONS).sort();
		},
	
		writingMetrics: function writingMetrics() {
			return _.values(StudentMetrics.WRITING_OPTIONS).sort();
		},
	
		readingMetrics: function readingMetrics() {
			return _.values(StudentMetrics.READING_OPTIONS).sort();
		},
	
		otherMetrics: function otherMetrics() {
			return _.values(StudentMetrics.OTHER_OPTIONS).sort();
		},
	
		isMetric: function isMetric(key) {
			return key in StudentMetrics.CONFIG;
		},
	
		getLabel: function getLabel(key) {
			// Don't add a second arg, since we map to this
			if (key in StudentMetrics.CONFIG) {
				return StudentMetrics.CONFIG[key].label;
			} else {
				return "";
			}
		},
		getOptions: function getOptions(key) {
			return StudentMetrics.CONFIG[key].options;
		},
		getUnit: function getUnit(key) {
			return StudentMetrics.CONFIG[key].unit;
		},
		getType: function getType(key) {
			if (StudentMetrics.isMetric(key)) {
				return StudentMetrics.CONFIG[key].type;
			}
		},
		getAction: function getAction(key) {
			return StudentMetrics.CONFIG[key].action;
		},
		getActionLabel: function getActionLabel(key) {
			return StudentMetrics.CONFIG[key].actionLabel;
		},
		getActionButtonText: function getActionButtonText(key) {
			return StudentMetrics.CONFIG[key].buttonText;
		},
		getIcon: function getIcon(key) {
			if (StudentMetrics.CONFIG[key].iconKey) {
				key = StudentMetrics.CONFIG[key].iconKey;
			}
			return dynamicRequire("action-icons/" + key + ".png");
		},
		getValue: function getValue(digest, key) {
			return digest ? StudentMetrics.CONFIG[key].getValue(digest) : 0;
		},
		getFeatureDependencies: function getFeatureDependencies(key) {
			return StudentMetrics.CONFIG[key].feature_dependencies;
		},
		getDigestEmbeds: function getDigestEmbeds(keys) {
			var digestEmbeds = _.map(keys, function (key) {
				return StudentMetrics.CONFIG[key].digestEmbeds;
			});
			return _.flatten(digestEmbeds).join(",");
		},
		inverseLookup: function inverseLookup(embedKey) {
			return StudentMetrics.INVERSE_LOOKUP[embedKey];
		}
	};
	
	StudentMetrics.PRACTICE_EXPECTATION_METRICS = [StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS, StudentMetrics.TYPES.EXERCISES, StudentMetrics.TYPES.MINUTES, StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE, StudentMetrics.READING_OPTIONS.PAGES, StudentMetrics.TYPES.QUESTION_BUILDER];
	
	StudentMetrics.QUIZ_EXPECTATION_METRICS = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS, StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS, StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS];
	
	StudentMetrics.CONFIG[StudentMetrics.TYPES.QUIZZES] = {
		label: "Quizzes Taken",
		unit: "quizzes",
		digestEmbeds: ["quiz_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.quiz_count;
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.TYPES.TEACHERS_PICKS] = {
		label: "Teachers Picks",
		unit: "teachers-picks",
		digestEmbeds: ["teachers_picks"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.teachers_picks;
		},
		action: "quiz",
		actionLabel: "Take a Quiz",
		buttonText: "Take Quiz"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.TYPES.QUESTIONS] = {
		label: "Practice Questions",
		unit: "answers",
		digestEmbeds: ["answers_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.answers_count;
		},
		action: "question",
		actionLabel: "Answer a Question",
		buttonText: "Answer Question"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS] = {
		label: "Fill-in-the-Blank",
		unit: "questions",
		digestEmbeds: ["recall_question_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.recall_question_count;
		},
		options: DropDownOptions.Select.RecallQuestionCount()
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS] = {
		label: "Open-Ended",
		unit: "questions",
		digestEmbeds: ["analysis_question_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.analysis_question_count;
		},
		options: DropDownOptions.Select.AnalysisQuestionCount()
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS] = {
		label: "Sentence Starters",
		unit: "sentence-starter",
		digestEmbeds: ["sentence_starter_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.sentence_starter_count;
		},
		options: DropDownOptions.Select.SentenceStarter()
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ] = {
		label: "Last Quiz",
		digestEmbeds: ["recent_quiz_text"],
		type: "text",
		getValue: function getValue(digest) {
			if (digest.recent_quiz_text) {
				return digest.recent_quiz_text.title;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.QUIZZES_PASSED] = {
		label: "Quizzes Passed",
		unit: "quizzes",
		digestEmbeds: ["quiz_passed_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.quiz_passed_count;
		},
		action: "quiz",
		actionLabel: "Take a Quiz",
		buttonText: "Take Quiz"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ_DATE] = {
		label: "Last Quiz Date",
		digestEmbeds: ["recent_quiz_date"],
		type: "text",
		getValue: function getValue(digest) {
			if (digest.recent_quiz_date) {
				return $wr.momentInTimezone(digest.recent_quiz_date).format("YYYY-MM-DD");
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ_SCORE] = {
		label: "Last Quiz Score",
		digestEmbeds: ["recent_quiz_score"],
		type: "text", // To avoid the sum
		getValue: function getValue(digest) {
			if (digest.recent_quiz_score) {
				return digest.recent_quiz_score;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.REVIEWS] = {
		label: "Reviews",
		unit: "reviews",
		digestEmbeds: ["reviews_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.reviews_count;
		},
		action: "review",
		actionLabel: "Write a Review",
		buttonText: "Write Review"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.MINUTES] = {
		label: "Minutes",
		unit: "minutes",
		digestEmbeds: ["minutes_read", "verified_minutes_read"],
		type: "numeric",
		feature_dependencies: [Features.LOG_READING],
		getValue: function getValue(digest) {
			return digest.minutes_read;
		},
		action: "log",
		actionLabel: "Log Reading",
		buttonText: "Log Reading"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.PAGES] = {
		label: "Pages",
		unit: "pages",
		digestEmbeds: ["pages_read", "verified_pages_read"],
		type: "numeric",
		feature_dependencies: [Features.LOG_READING],
		getValue: function getValue(digest) {
			return digest.pages_read;
		},
		action: "log",
		iconKey: "minutes",
		actionLabel: "Log Reading",
		buttonText: "Log Reading"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.WRITING] = {
		label: "All Writing",
		unit: "writing",
		digestEmbeds: ["writing_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.writing_count;
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.ZPD_COUNTS] = {
		label: "Quizzes By Level",
		unit: "zpd_counts",
		digestEmbeds: ["zpd_counts"],
		type: "text",
		getValue: function getValue(digest) {
			if (digest.zpd_counts) {
				var value = digest.zpd_counts;
				value = "under: " + value.under + "" + " at: " + value.at + "" + " over: " + value.over;
				return value;
			} else {
				return "";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.ZPD_BELOW] = {
		label: "Quizzes Below Level",
		unit: "zpd_counts",
		digestEmbeds: ["zpd_counts"],
		type: "text",
		getValue: function getValue(digest) {
			if (digest.zpd_counts) {
				var value = digest.zpd_counts;
				var underValue = value.under;
				var total = value.under + value.at + value.over;
				if (total <= 0) {
					return "-";
				}
				return Math.round(underValue / total * 100) + "%";
			} else {
				return "";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.EXERCISES] = {
		label: "Exercises",
		unit: "exercises",
		digestEmbeds: ["responses_count"],
		type: "numeric",
		feature_dependencies: [Features.DIGITAL_EXERCISES],
		getValue: function getValue(digest) {
			return digest.responses_count;
		},
		action: "exercise",
		actionLabel: "Start an Activity",
		buttonText: "Start Exercise"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.QUESTION_BUILDER] = {
		label: "Question Builders",
		unit: "question_builder",
		digestEmbeds: ["question_builder_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.question_builder_count;
		},
		action: "question-builder",
		actionLabel: "Build a Question",
		buttonText: "Build a Question"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.LAST_TEXT] = {
		label: "Currently Reading",
		digestEmbeds: ["recent_text_title"],
		type: "text",
		feature_dependencies: [Features.LOG_READING],
		getValue: function getValue(digest) {
			if (digest.recent_text_title) {
				return digest.recent_text_title;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.TITLES_READ] = {
		label: "Titles read",
		digestEmbeds: ["titles_read"],
		type: "numeric",
		unit: "titles read",
		getValue: function getValue(digest) {
			if (digest.titles_read) {
				return digest.titles_read;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.MEAN_QUIZ_SCORE] = {
		label: "Average Quiz Score",
		digestEmbeds: ["mean_quiz_score"],
		type: "text",
		feature_dependencies: [],
		getValue: function getValue(digest) {
			if (digest.mean_quiz_score) {
				return Math.round(digest.mean_quiz_score * 4) / 4;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.QUIZ_PASS_RATE] = {
		label: "Quiz Passing Rate",
		digestEmbeds: ["quiz_pass_rate"],
		type: "text",
		feature_dependencies: [],
		getValue: function getValue(digest) {
			if (digest.quiz_pass_rate != null) {
				return Math.round(digest.quiz_pass_rate * 100) + "%";
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.TOTAL_READER_LEVEL] = {
		label: "Reading Level",
		digestEmbeds: ["total_reader_level", "current_reading_level"],
		type: "text",
		feature_dependencies: [],
		getValue: function getValue(digest) {
			if (digest.total_reader_level) {
				return digest.total_reader_level;
			} else if (digest.current_reading_level) {
				return digest.current_reading_level;
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.COINS] = {
		label: "Coins",
		unit: "coins",
		digestEmbeds: ["coins_count"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.coins_count;
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE] = {
		label: "Days Active",
		unit: "days",
		digestEmbeds: ["days_active"],
		type: "numeric",
		getValue: function getValue(digest) {
			return digest.days_active;
		},
		action: "question",
		actionLabel: "Answer a Question",
		buttonText: "Answer Question"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.ACADEMIC_LEVEL] = {
		label: "Academic Level",
		digestEmbeds: ["academic_level"],
		type: "text",
		feature_dependencies: [],
		getValue: function getValue(digest) {
			if (digest.academic_level) {
				return GradeLevel.getName(digest.academic_level);
			} else {
				return "-";
			}
		}
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_TYPES.CHALLENGES] = {
		label: "Challenges",
		unit: "challenges",
		getValue: function getValue(digest) {
			return "-";
		},
		buttonText: "Take Challenge"
	};
	
	StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.TIER] = {
		label: "Owl Level",
		unit: "tier",
		digestEmbeds: ["tier"],
		type: "text",
		feature_dependencies: [Features.LOG_READING],
		getValue: function getValue(digest) {
			return digest.tier !== undefined ? String(parseInt(digest.tier) + 1) : "-";
		}
	};
	
	StudentMetrics.INVERSE_LOOKUP = {};
	_.each(StudentMetrics.CONFIG, function (config, metricKey) {
		_.each(config.digestEmbeds, function (embed) {
			StudentMetrics.INVERSE_LOOKUP[embed] = metricKey;
		});
	});
	
	StudentMetrics.DEFAULT_COLUMNS = [StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ, StudentMetrics.QUIZZES_OPTIONS.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE];
	
	module.exports = StudentMetrics;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	var ButtonDropdownOption = function (_React$Component) {
		_inherits(ButtonDropdownOption, _React$Component);
	
		function ButtonDropdownOption(props) {
			_classCallCheck(this, ButtonDropdownOption);
	
			var _this = _possibleConstructorReturn(this, (ButtonDropdownOption.__proto__ || Object.getPrototypeOf(ButtonDropdownOption)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ButtonDropdownOption, [{
			key: "onClick",
			value: function onClick(e) {
				$wr.nope(e);
				// Pass on the event any, since legacy code preventDefault manually
				this.props.onClick(e);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.icon) {
					var icon = React.createElement(Glyphicon, { icon: this.props.icon });
				}
	
				if (this.props.bold) {
					var style = { fontWeight: 'bold' };
				}
	
				return React.createElement(
					"li",
					{ className: this.props.className },
					React.createElement(
						"a",
						{ className: "ellipsisText", href: "#", onClick: this.onClick, ref: "link" },
						React.createElement(
							"span",
							{ style: style },
							icon,
							this.props.text,
							this.props.children
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				if (this.props.preventCollapse) {
					this.refs.link.addEventListener("click", function (e) {
						$wr.nope(e);
						e.stopPropagation();
	
						if (_this2.props.onClick) {
							_this2.props.onClick();
						}
					}, false);
				}
			}
		}]);
	
		return ButtonDropdownOption;
	}(React.Component);
	
	;
	
	ButtonDropdownOption.propTypes = StrictPropTypes({
		// Text to show on option
		text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	
		children: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
	
		// If true, menu won't automatically collapse when an option is selected
		preventCollapse: PropTypes.bool,
	
		// Glyphicon to show next to the option
		icon: PropTypes.string,
	
		// Makes the option show in bod
		bold: PropTypes.bool,
	
		// Class to add to the option's li
		className: PropTypes.string,
	
		// Function to call when the option is clicked on
		onClick: PropTypes.func,
	
		// Value of option
		value: PropTypes.string
	
	});
	
	module.exports = ButtonDropdownOption;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	tslib_1.__exportStar(__webpack_require__(719), exports);
	tslib_1.__exportStar(__webpack_require__(365), exports);
	tslib_1.__exportStar(__webpack_require__(720), exports);
	tslib_1.__exportStar(__webpack_require__(232), exports);
	tslib_1.__exportStar(__webpack_require__(721), exports);
	tslib_1.__exportStar(__webpack_require__(114), exports);
	tslib_1.__exportStar(__webpack_require__(233), exports);
	tslib_1.__exportStar(__webpack_require__(366), exports);
	tslib_1.__exportStar(__webpack_require__(158), exports);
	tslib_1.__exportStar(__webpack_require__(234), exports);
	tslib_1.__exportStar(__webpack_require__(235), exports);
	tslib_1.__exportStar(__webpack_require__(722), exports);
	tslib_1.__exportStar(__webpack_require__(724), exports);
	tslib_1.__exportStar(__webpack_require__(236), exports);
	tslib_1.__exportStar(__webpack_require__(237), exports);
	tslib_1.__exportStar(__webpack_require__(367), exports);
	tslib_1.__exportStar(__webpack_require__(368), exports);
	tslib_1.__exportStar(__webpack_require__(725), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Owlvatar = __webpack_require__(115);
	var CurrentUser = __webpack_require__(3);
	var AnimateOwl = __webpack_require__(437);
	
	var RosterSelectors = __webpack_require__(6);
	
	var StudentAvatar = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		// Make this component able to be provided data by IDs or objects
		// For backwards compatability with non-redux pages
	
		var student = props.student;
		if (!student) {
			if (props.studentID) {
				student = RosterSelectors.student({ state: state, id: props.studentID });
			}
		}
	
		var avatar = props.avatar;
		if (!avatar) {
			if (props.avatarID) {
				avatar = RosterSelectors.avatar({ state: state, id: props.avatarID });
			} else if (student && _.isObject(student.avatar)) {
				avatar = student.avatar;
			} else if (student) {
				avatar = RosterSelectors.avatarForStudent({
					state: state, studentID: student.id
				});
			}
		}
	
		return { student: student, avatar: avatar };
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentAvatar, _React$Component);
	
		function StudentAvatar(props) {
			_classCallCheck(this, StudentAvatar);
	
			var _this = _possibleConstructorReturn(this, (StudentAvatar.__proto__ || Object.getPrototypeOf(StudentAvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentAvatar, [{
			key: "getConstraints",
			value: function getConstraints(maxWidth, maxHeight) {
				var constraints = {};
				if (maxWidth) {
					constraints.width = maxWidth + "px";
				};
				if (maxHeight) {
					constraints.height = maxHeight + "px";
				};
				return constraints;
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
				var avatar = this.props.avatar;
				if (!avatar && _.isObject(student.avatar)) {
					avatar = student.avatar;
				}
				var currentUser = CurrentUser.get();
	
				if (currentUser && currentUser.settings && currentUser.settings.hide_owls) {
					var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight);
					var src = __webpack_require__(514);
					return React.createElement("img", { src: src, className: "owlvatarStandin", style: constraints });
				} else if (avatar.is_monster) {
					var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight);
					var imagePath = __webpack_require__(667)("./monster-" + avatar.transform_type + ".png");
					return React.createElement("img", { src: imagePath, className: "owlvatarStandin", style: constraints });
				} else {
					if (this.props.student.settings && this.props.student.settings.took_honor_pledge) {
						var showHonorRays = true;
					}
					return React.createElement(
						"span",
						{ ref: "avatar", className: "studentOwlvatar" },
						React.createElement(Owlvatar, { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight,
							patches: avatar.patches, colors: avatar.colors,
							nofloat: this.props.nofloat,
							showHonorRays: showHonorRays })
					);
				}
			}
		}, {
			key: "getIdentifier",
			value: function getIdentifier() {
				if (this.props.location) {
					return this.props.student.username + "_" + this.props.location;
				} else {
					return this.props.student.username;
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.refs.avatar && this.props.student && this.props.student.perks) {
					if (this.props.disableSound == undefined || !this.props.disableSound) {
						if (window.wrL2eSound) {
							window.wrL2eSound.buildStudentSources(this.getIdentifier(), this.props.student.perks);
						}
					}
					if (!this.props.disableAnimation) {
						setTimeout(function () {
							if (this.props.previewAnimation) {
								this.triggerPreviewAnimation();
							} else {
								this.triggerOwlAnimation();
							}
						}.bind(this), 500);
					}
				}
			}
	
			// previews animation (for owl shop)
	
		}, {
			key: "triggerPreviewAnimation",
			value: function triggerPreviewAnimation() {
				var avatar = this.props.avatar || this.props.student.avatar;
	
				AnimateOwl.alive_owl($(this.refs.avatar).find(".owlConstraintsInner"), 2000, this.getIdentifier(), avatar.patches, this.props.student.perks, this.props.previewAnimation);
			}
		}, {
			key: "triggerOwlAnimation",
			value: function triggerOwlAnimation() {
				var avatar = this.props.avatar || this.props.student.avatar;
				if (!$(this.refs.avatar).find(".owlConstraintsInner").length) {
					setTimeout(function () {
						this.triggerOwlAnimation();
					}.bind(this), 1000);
				} else {
					AnimateOwl.alive_owl($(this.refs.avatar).find(".owlConstraintsInner"), 2000, this.getIdentifier(), avatar.patches, this.props.student.perks, false);
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (window.wrL2eSound) {
					window.wrL2eSound.removeSources(this.getIdentifier());
				}
				if (this.refs.avatar) {
					AnimateOwl.stop_animation($(this.refs.avatar).find(".owlConstraintsInner"), this.getIdentifier());
				}
			}
		}]);
	
		return StudentAvatar;
	}(React.Component)) || _class);
	;
	
	StudentAvatar.WrappedComponent.propTypes = StrictPropTypes({
		// Avatar+Student can be directly provided or via ID or just by student
		student: PropTypes.object,
		avatar: PropTypes.object,
	
		studentID: PropTypes.number,
		avatarID: PropTypes.number,
		nofloat: PropTypes.bool, // Too many legacy uses depend on it floating
	
		disableAnimation: PropTypes.bool,
		disableSound: PropTypes.bool,
		location: PropTypes.string,
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number,
		previewAnimation: PropTypes.string
	});
	
	module.exports = StudentAvatar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _SUBJECT_NOUNS;
	
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	exports.allowDates = allowDates;
	exports.allowWidgetPeriodDates = allowWidgetPeriodDates;
	exports.allowDraft = allowDraft;
	exports.allowDueDate = allowDueDate;
	exports.allowAllDates = allowAllDates;
	exports.allowsText = allowsText;
	exports.allowsTextVariety = allowsTextVariety;
	exports.allowsDrafts = allowsDrafts;
	exports.allowsStatus = allowsStatus;
	exports.allowsReadBookStatus = allowsReadBookStatus;
	exports.allowsStudentFilter = allowsStudentFilter;
	exports.hasTotals = hasTotals;
	exports.requiresLogReading = requiresLogReading;
	exports.requiresReadingLevelGraph = requiresReadingLevelGraph;
	exports.requiresDigitalExercises = requiresDigitalExercises;
	exports.allowsPrinting = allowsPrinting;
	exports.allowsDownload = allowsDownload;
	exports.requiresDates = requiresDates;
	exports.timeKey = timeKey;
	exports.hasPages = hasPages;
	exports.orderAsParam = orderAsParam;
	exports.subjectNoun = subjectNoun;
	exports.getSubjectSubtypes = getSubjectSubtypes;
	exports.getSubjectHeaderType = getSubjectHeaderType;
	exports.validWidgetStartDate = validWidgetStartDate;
	exports.validWidgetEndDate = validWidgetEndDate;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TextTypes = __webpack_require__(38);
	var CurrentUser = __webpack_require__(3);
	
	function getPath(state) {
		var fullPath = "/data";
		if (state.subjectType) {
			if (_.size(state.userIDs) > 0 && state.subjectType == SUBJECT_STUDENT_DASHBOARD) {
				fullPath += "/" + _.first(_.sortBy(state.userIDs));
			} else if (_.size(state.userIDs) > 0 && !allStudents(state)) {
				fullPath += "/" + _.sortBy(state.userIDs).join("-");
			} else {
				fullPath += "/" + ALL_STUDENT_PATH;
			}
	
			fullPath += "/" + stateValueToParam(state.subjectType);
		}
	
		var queryParts = [];
	
		if (allowDates(state.subjectType)) {
			var spans = CurrentUser.get().expectations_date_spans;
	
			if (state.startDate) {
				queryParts.push("start_date=" + state.startDate);
			} else if (requiresDates(state.subjectType)) {
				queryParts.push("start_date=" + spans[0].start);
			}
			if (state.endDate) {
				queryParts.push("end_date=" + state.endDate);
			} else if (requiresDates(state.subjectType)) {
				queryParts.push("end_date=" + spans[0].end);
			}
		}
		// restrict to only allow widget digest dates
		if (allowWidgetPeriodDates(state.subjectType)) {
			var spans = CurrentUser.get().expectations_date_spans;
			if (state.startDate && state.endDate) {
	
				queryParts.push("start_date=" + state.startDate);
				queryParts.push("end_date=" + state.endDate);
			} else {
				queryParts = [].concat(_toConsumableArray(queryParts), ["start_date=" + spans[0].start, "end_date=" + spans[0].end]);
			}
		}
		if (allowsText(state.subjectType)) {
			if (allowsTextVariety(state.subjectType)) {
				if (state.textVariety && state.textVariety != DEFAULT_TEXT_VARIETY) {
					queryParts.push("text_variety=" + state.textVariety);
				}
			}
	
			if (state.textID) {
				queryParts.push("text_id=" + state.textID);
			}
		}
		if (state.status) {
			queryParts.push("status=" + state.status);
		}
	
		if (state.readBook) {
			queryParts.push("read_book=" + state.readBook);
		}
	
		if (state.draft) {
			queryParts.push("draft=" + state.draft);
		}
	
		if (state.dueDate) {
			queryParts.push("dueDate=" + state.dueDate);
		}
	
		if (state.quizID) {
			queryParts.push("quiz_id=" + state.quizID);
		}
	
		if (state.controlMode) {
			queryParts.push("controlMode=" + state.controlMode);
		}
	
		if (hasPages(state.subjectType)) {
			if (state.order && (state.userIDs == undefined || state.userIDs.length != 1)) {
				queryParts.push("order=" + state.order);
			}
			if (state.page) {
				queryParts.push("page=" + state.page);
			}
			if (state.perPage) {
				queryParts.push("per_page=" + state.perPage);
			}
		}
	
		if (state.studentList) {
			queryParts.push("student_list=" + state.studentList);
		}
	
		if (queryParts.length) {
			fullPath += "?" + queryParts.join("&");
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		// Translate subject_type
		if (params.subject_type) {
			state.subjectType = paramKeyToSubjectType(params.subject_type);
			var subjectType = paramKeyToSubjectType(params.subject_type);
		}
	
		// Translate userIDs, if set
		if (params.user_ids && params.user_ids != "everyone") {
			state.userIDs = _.map(params.user_ids.split("-"), function (x) {
				return parseInt(x);
			});
		} else {
			state.userIDs = [];
		}
	
		// Translate completion_status
		if (params.draft && params.draft === 'false') {
			state.draft = false;
		} else if (params.draft && params.draft === 'true') {
			state.draft = true;
		}
	
		// Translate due_date
		if (params.dueDate) {
			state.dueDate = params.dueDate;
		}
	
		// Translate student_list
		if (params.student_list) {
			state.studentList = params.student_list;
		}
	
		// Translate quiz_id
		if (params.quiz_id) {
			state.quizID = parseInt(params.quiz_id);
		}
	
		// Translate edit
		if (params.controlMode) {
			state.controlMode = params.controlMode;
		}
	
		// Translate status
		if (params.status) {
			state.status = params.status;
		}
	
		// Translate status
		if (params.read_book) {
			state.readBook = params.read_book;
		}
	
		if (allowDates(state.subjectType) || allowWidgetPeriodDates(state.subjectType)) {
	
			var spans = CurrentUser.get().expectations_date_spans;
	
			if (params.start_date) {
				state.startDate = params.start_date;
			} else if (requiresDates(state.subjectType)) {
				state.startDate = spans[0].start;
			}
			if (params.end_date) {
				state.endDate = params.end_date;
			} else if (requiresDates(state.subjectType)) {
				state.endDate = spans[0].end;
			}
		}
	
		if (subjectType && hasPages(subjectType)) {
			if (state.userIDs.length == 1) {
				state.order = ORDER_BY_DATE;
			} else {
				if (subjectType == SUBJECT_READING_LEVELS) {
					state.order = params.order || ORDER_BY_STUDENT;
				} else {
					state.order = params.order || ORDER_BY_DATE;
				}
			}
			if (params.page) {
				state.page = parseInt(params.page);
			}
			if (params.per_page) {
				state.perPage = parseInt(params.per_page);
			}
		}
	
		if (allowsText(subjectType)) {
			if (subjectType && allowsTextVariety(subjectType)) {
				// Use text varieties or insert selected
				state.textVariety = params.text_variety || DEFAULT_TEXT_VARIETY;
			}
			if (params.text_id) {
				state.textID = params.text_id;
			}
		}
	
		return state;
	}
	
	function allStudents(state) {
		return state.studentList && state.studentList === ALL_STUDENT_PATH;
	}
	
	function stateValueToParam(subjectType) {
		return subjectType.toLowerCase().replace(/ /g, "_");
	}
	
	function paramKeyToSubjectType(paramKey) {
		var parts = _.map(paramKey.split("_"), function (word) {
			return word.charAt(0).toUpperCase() + word.slice(1);
		});
		return parts.join(" ");
	}
	function allowDates(subjectType) {
		return !_.includes([SUBJECT_READING_LEVEL_GRAPH, SUBJECT_READING_LEVELS, SUBJECT_STUDENT_DASHBOARD, SUBJECT_GOALS], subjectType);
	}
	
	function allowWidgetPeriodDates(subjectType) {
		return _.includes([SUBJECT_GOALS], subjectType);
	}
	
	function allowDraft(subjectType) {
		return _.includes([SUBJECT_TEACHER_PICKS], subjectType);
	}
	function allowDueDate(subjectType) {
		return _.includes([SUBJECT_TEACHER_PICKS, SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES], subjectType);
	}
	function allowAllDates(subjectType) {
		return !_.includes([SUBJECT_GOALS, SUBJECT_OTHER_METRICS], subjectType);
	}
	function allowsText(subjectType) {
		return !_.includes([SUBJECT_READING_LEVEL_GRAPH, SUBJECT_READING_LEVELS, SUBJECT_GOALS, SUBJECT_OTHER_METRICS, SUBJECT_STUDENT_DASHBOARD], subjectType);
	}
	function allowsTextVariety(subjectType) {
		return allowsText(subjectType) && !_.includes([SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR, SUBJECT_GOALS, SUBJECT_OTHER_METRICS, SUBJECT_TEACHER_PICKS, SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES], subjectType);
	}
	function allowsDrafts(subjectType) {
		return _.includes([SUBJECT_QUIZZES, SUBJECT_ANSWERS, SUBJECT_REVIEWS, SUBJECT_ACTIVITIES], subjectType);
	}
	function allowsStatus(subjectType) {
		return _.includes([SUBJECT_QUIZZES], subjectType);
	}
	function allowsReadBookStatus(subjectType) {
		return _.includes([SUBJECT_BOOKS], subjectType);
	}
	function allowsStudentFilter(subjectType) {
		return _.includes([SUBJECT_STUDENT_DASHBOARD], subjectType);
	}
	function hasTotals(subjectType) {
		return hasPages(subjectType);
	}
	function requiresLogReading(subjectType) {
		return _.includes([SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR], subjectType);
	}
	function requiresReadingLevelGraph(subjectType) {
		return _.includes([SUBJECT_READING_LEVEL_GRAPH], subjectType);
	}
	function requiresDigitalExercises(subjectType) {
		return _.includes([SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES, SUBJECT_TEACHER_PICKS], subjectType);
	}
	function allowsPrinting(subjectType) {
		return !_.includes([SUBJECT_STUDENT_DASHBOARD, SUBJECT_READING_LEVEL_GRAPH, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES, SUBJECT_QUESTION_BUILDERS], subjectType);
	}
	
	function allowsDownload(subjectType) {
		return _.includes([SUBJECT_GOALS, SUBJECT_OTHER_METRICS, SUBJECT_READING_LEVELS, SUBJECT_ACTIVITIES, SUBJECT_TEACHER_PICKS], subjectType);
	}
	
	function requiresDates(subjectType) {
		return !_.includes([SUBJECT_GOALS, SUBJECT_OTHER_METRICS], subjectType);
	}
	
	function timeKey(subjectType) {
		if (_.includes([SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR], subjectType)) {
			return "log_date";
		} else if (_.includes([SUBJECT_BOOKS], subjectType)) {
			return "last_active_by_user_id";
		} else if (_.includes([SUBJECT_QUIZZES, SUBJECT_ANSWERS, SUBJECT_WRITING, SUBJECT_REVIEWS, SUBJECT_ACTIVITIES], subjectType)) {
			return "completed_at";
		} else {
			// ASIGNED_EXERCISES
			return "created_at";
		}
	}
	
	function hasPages(subjectType) {
		if (_.includes([SUBJECT_QUIZZES, SUBJECT_ANSWERS, SUBJECT_REVIEWS, SUBJECT_WRITING, SUBJECT_ACTIVITIES, SUBJECT_READING_LEVELS], subjectType)) {
			return true;
		} else {
			return false;
		}
	}
	
	function orderAsParam(orderType) {
		if (orderType == ORDER_BY_DATE) {
			return "completed_at_desc";
		} else {
			return "user_id_asc";
		}
	}
	
	function subjectNoun(subjectType, singular) {
		if (singular) {
			return SUBJECT_NOUNS[subjectType][0];
		} else {
			return SUBJECT_NOUNS[subjectType][1];
		}
	}
	
	function getSubjectSubtypes(subjectType) {
		return SUBJECT_GROUPS.find(function (x) {
			return _.includes(x, subjectType);
		});
	}
	
	function getSubjectHeaderType(subjectType) {
		if (subjectType) {
			return getSubjectSubtypes(subjectType)[0];
		}
	}
	
	function validWidgetStartDate(startDate) {
		var spans = CurrentUser.get().expectations_date_spans;
		return _.includes(_.pluck(spans, 'start'), startDate);
	}
	
	function validWidgetEndDate(endDate) {
		var spans = CurrentUser.get().expectations_date_spans;
		return _.includes(_.pluck(spans, 'end'), endDate);
	}
	
	var PER_PAGE = exports.PER_PAGE = 20;
	var ALL_PER_PAGE = exports.ALL_PER_PAGE = 10000; // Eek. Well, it's July.
	
	var DEFAULT_TEXT_VARIETY = exports.DEFAULT_TEXT_VARIETY = TextTypes.Varieties.FICTION_AND_NON_FICTION;
	
	var ALL_STUDENT_PATH = exports.ALL_STUDENT_PATH = 'everyone';
	
	var PATH = exports.PATH = "/data/:user_ids?/:subject_type?";
	
	var STUDENT_DASHBOARD_PATH = exports.STUDENT_DASHBOARD_PATH = "/data/student_dashboard";
	
	////////////////
	// Subjects ////
	////////////////
	
	var SUBJECT_GOALS = exports.SUBJECT_GOALS = "Goals";
	var SUBJECT_OTHER_METRICS = exports.SUBJECT_OTHER_METRICS = "Other Stats";
	
	var SUBJECT_BOOKS = exports.SUBJECT_BOOKS = "Books";
	var SUBJECT_LOG_LIST = exports.SUBJECT_LOG_LIST = "Reading Logs";
	var SUBJECT_LOG_CALENDAR = exports.SUBJECT_LOG_CALENDAR = "Log Calendar";
	
	var SUBJECT_QUIZZES = exports.SUBJECT_QUIZZES = "Quizzes";
	
	var SUBJECT_WRITING = exports.SUBJECT_WRITING = "Writing";
	var SUBJECT_ANSWERS = exports.SUBJECT_ANSWERS = "Practice Questions";
	var SUBJECT_REVIEWS = exports.SUBJECT_REVIEWS = "Reviews";
	
	var SUBJECT_ACTIVITIES = exports.SUBJECT_ACTIVITIES = "Activities";
	var SUBJECT_ASSIGNED_EXERCISES = exports.SUBJECT_ASSIGNED_EXERCISES = "Assigned Exercises";
	var SUBJECT_COMPLETED_EXERCISES = exports.SUBJECT_COMPLETED_EXERCISES = "Completed Exercises";
	var SUBJECT_QUESTION_BUILDERS = exports.SUBJECT_QUESTION_BUILDERS = "Question Builders";
	var SUBJECT_TEACHER_PICKS = exports.SUBJECT_TEACHER_PICKS = "Teacher Picks";
	
	var SUBJECT_ANSWERS_SHORT = exports.SUBJECT_ANSWERS_SHORT = "Questions";
	
	var SUBJECT_READING_LEVELS = exports.SUBJECT_READING_LEVELS = "Reading Levels";
	var SUBJECT_READING_LEVEL_GRAPH = exports.SUBJECT_READING_LEVEL_GRAPH = "Reading Level Graph";
	
	var SUBJECT_STUDENT_DASHBOARD = exports.SUBJECT_STUDENT_DASHBOARD = "Students";
	
	var SUBJECT_GROUPS = exports.SUBJECT_GROUPS = [[SUBJECT_GOALS, SUBJECT_OTHER_METRICS], [SUBJECT_BOOKS, SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR], [SUBJECT_QUIZZES], [SUBJECT_WRITING, SUBJECT_ANSWERS, SUBJECT_REVIEWS], [SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES, SUBJECT_QUESTION_BUILDERS, SUBJECT_TEACHER_PICKS], [SUBJECT_READING_LEVELS, SUBJECT_READING_LEVEL_GRAPH], [SUBJECT_STUDENT_DASHBOARD]];
	
	////////////////////
	// End Subjects ////
	////////////////////
	
	var ORDER_BY_STUDENT = exports.ORDER_BY_STUDENT = "user_id_asc";
	var ORDER_BY_DATE = exports.ORDER_BY_DATE = "completed_at_desc";
	
	var ORDER_LABELS = exports.ORDER_LABELS = {
		"By Date": ORDER_BY_DATE,
		"By Student": ORDER_BY_STUDENT
	};
	
	var FLAGGED_STATUS = exports.FLAGGED_STATUS = 'flagged';
	var FAILED_STATUS = exports.FAILED_STATUS = 'failed';
	var PASSED_STATUS = exports.PASSED_STATUS = 'passed';
	var ALL_STATUS = exports.ALL_STATUS = 'all';
	
	var STATUS_OPTIONS = exports.STATUS_OPTIONS = [ALL_STATUS, FLAGGED_STATUS, FAILED_STATUS, PASSED_STATUS];
	
	var SUBJECT_NOUNS = (_SUBJECT_NOUNS = {}, _defineProperty(_SUBJECT_NOUNS, SUBJECT_BOOKS, ["book", "books"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_LOG_LIST, ["log", "logs"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_LOG_CALENDAR, ["log", "logs"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_READING_LEVEL_GRAPH, ["book or assessment", "books or assessments"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_QUIZZES, ["quiz", "quizzes"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_ANSWERS, ["answer", "answers"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_REVIEWS, ["review", "reviews"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_WRITING, ["answer", "answers"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_ACTIVITIES, ["activity", "activities"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_ASSIGNED_EXERCISES, ["assigned exercise", "assigned exercises"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_COMPLETED_EXERCISES, ["completed exercise", "completed exercises"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_QUESTION_BUILDERS, ["question builder", "question builders"]), _defineProperty(_SUBJECT_NOUNS, SUBJECT_TEACHER_PICKS, ["teacher pick", "teacher picks"]), _SUBJECT_NOUNS);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(182)('wks');
	var uid = __webpack_require__(134);
	var Symbol = __webpack_require__(28).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	
	var TextTypes = {
		Varieties: {
			FICTION: "fiction",
			NON_FICTION: "non-fiction",
			FICTION_AND_NON_FICTION: "fiction-and-non-fiction",
	
			// For use in other contexts
			SPECIFIC_TEXT: "specific-text",
	
			TYPES: {
				"fiction-and-non-fiction": {
					name: "Fiction and non-fiction",
					altName: "All Texts",
					abbreviation: "F/NF"
				},
				"fiction": {
					name: "Fiction",
					altName: "Fiction Texts",
					abbreviation: "F"
				},
				"non-fiction": {
					name: "Non-fiction",
					altName: "Non-Fiction Texts",
					abbreviation: "NF"
				}
			},
	
			BOTH: "fiction-and-non-fiction",
	
			getName: function getName(textVarietyKey) {
				var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
				if (textVariety) {
					return textVariety.name;
				}
			},
	
			getAltName: function getAltName(textVarietyKey) {
				var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
				if (textVariety) {
					return textVariety.altName;
				} else if (textVarietyKey == TextTypes.Varieties.SPECIFIC_TEXT) {
					return "Specific Text";
				}
			},
	
			getAbbreviation: function getAbbreviation(textVarietyKey) {
				var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
				if (textVariety) {
					return textVariety.abbreviation;
				}
			}
		},
	
		CompletionTypes: {
			TEXT_COMPLETED: "text-completed",
			NO_TEXT: "no-text",
			TEXT_IN_PROGRESS: "text-in-progress",
			SPECIFIC_CHAPTER: "specific-chapter",
			DEFAULT: "default",
	
			// No nice way to load in the types (I think)
			TYPES: {
				"text-completed": { pluralName: "completed texts" },
				"no-text": { pluralName: "text provided" },
				"text-in-progress": { pluralName: "in progress texts" },
				"specific-chapter": { pluralName: "specific chapter texts" },
				"default": { pluralName: "texts" }
			},
	
			requiresText: function requiresText(completionType) {
				return completionType != TextTypes.CompletionTypes.NO_TEXT;
			},
	
			getPluralName: function getPluralName(completionType) {
				var textVariety = TextTypes.CompletionTypes.TYPES[completionType] || TextTypes.CompletionTypes.TYPES[TextTypes.CompletionTypes.DEFAULT];
	
				return textVariety.pluralName;
			}
		}
	};
	
	module.exports = TextTypes;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(79);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	"use strict";
	
	var GradeLevel = {
		TYPES: {
			"12": {
				paid: false,
				answerLength: 400
			},
			"11": {
				paid: false,
				answerLength: 400
			},
			"10": {
				paid: false,
				answerLength: 400
			},
			"9": {
				paid: false,
				answerLength: 400
			},
			"8": {
				paid: false,
				answerLength: 400
			},
			"7": {
				paid: false,
				answerLength: 370
			},
			"6": {
				paid: false,
				answerLength: 325
			},
			"5": {
				paid: false,
				answerLength: 265
			},
			"4": {
				paid: false,
				answerLength: 235
			},
			"3": {
				paid: false,
				answerLength: 195
			},
			"2": {
				paid: false,
				answerLength: 165
			},
			"1": {
				paid: false,
				answerLength: 140
			},
			"0": {
				paid: false,
				answerLength: 100
			},
			"-1": {
				paid: false,
				answerLength: 100
			}
		},
	
		getName: function getName(gradeLevel) {
			switch (gradeLevel.toString()) {
				case "-1":
					return "Pre-Kindergarten";
				case "0":
					return "Kindergarten";
				case "13":
					return "Mixed Grades";
				default:
					return $wr.getOrdinal(parseInt(gradeLevel)) + " Grade";
			}
		},
		getQuizLevel: function getQuizLevel(gradeLevel) {
			gradeLevel = parseInt(gradeLevel);
			if (gradeLevel > 6) {
				return "3";
			} else if (gradeLevel < 4) {
				return "1";
			} else {
				return "2";
			}
		},
		getShortName: function getShortName(gradeLevel) {
			switch (gradeLevel.toString()) {
				case "-1":
					return "PK";
				case "0":
					return "K";
				case "13":
					return "Mixed";
				default:
					return $wr.getOrdinal(parseInt(gradeLevel));
			}
		},
		getRecommendedAnswerLength: function getRecommendedAnswerLength(gradeLevel) {
			if (GradeLevel.TYPES[gradeLevel]) {
				return GradeLevel.TYPES[gradeLevel].answerLength;
			} else {
				return 300;
			}
		},
		getCharCountFilter: function getCharCountFilter(gradeLevel) {
			if (GradeLevel.TYPES[gradeLevel]) {
				var value = GradeLevel.TYPES[gradeLevel].answerLength;
			} else {
				var value = 300;
			}
	
			value /= 3;
			if (value > 120) {
				value = 120;
			}
	
			return value;
		},
		isValid: function isValid(gradeLevel) {
			var asInt = parseInt(gradeLevel);
			return asInt.toString() == gradeLevel.trim() && asInt >= -1 && asInt <= 13;
		},
		isUnknown: function isUnknown(gradeLevel) {
			return gradeLevel == "unknown grade";
		}
	};
	
	module.exports = GradeLevel;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toggleExpandedResponse = toggleExpandedResponse;
	exports.showPaywall = showPaywall;
	exports.toggleEdit = toggleEdit;
	var EXPAND_RESPONSE = exports.EXPAND_RESPONSE = "EXPAND_RESPONSE";
	var SHOW_PAYWALL = exports.SHOW_PAYWALL = "SHOW_PAYWALL";
	var TOGGLE_EDIT = exports.TOGGLE_EDIT = "TOGGLE_EDIT";
	
	function toggleExpandedResponse(_ref) {
		var responseID = _ref.responseID,
		    expanded = _ref.expanded;
	
		return { type: EXPAND_RESPONSE, responseID: responseID, expanded: expanded };
	}
	
	function showPaywall(_ref2) {
		var paywall = _ref2.paywall;
	
		return { type: SHOW_PAYWALL, paywall: paywall };
	}
	
	function toggleEdit(_ref3) {
		var key = _ref3.key,
		    expanded = _ref3.expanded;
	
		return { type: TOGGLE_EDIT, key: key, expanded: expanded };
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(30)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(3553)();
	}


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ValidatingInput = __webpack_require__(91);
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var Features = __webpack_require__(16);
	var WebinarRegistration = __webpack_require__(407);
	
	__webpack_require__(3777);
	
	var PaywallModal = function (_React$Component) {
		_inherits(PaywallModal, _React$Component);
	
		function PaywallModal(props) {
			_classCallCheck(this, PaywallModal);
	
			var _this = _possibleConstructorReturn(this, (PaywallModal.__proto__ || Object.getPrototypeOf(PaywallModal)).call(this));
	
			autobind(_this);
			var currentPaywallFeature = props.featureType;
			var expiredTrials = CurrentUser.get().account.expired_trials;
	
			var triedCurrentFeature = expiredTrials[currentPaywallFeature] != undefined;
	
			_this.state = { showDemoForm: false, showWebinarReg: false, showConsultation: triedCurrentFeature };
			return _this;
		}
	
		_createClass(PaywallModal, [{
			key: "showWebinarRegistration",
			value: function showWebinarRegistration(e) {
				$wr.nope(e);
				this.setState({ showWebinarReg: true });
			}
		}, {
			key: "showDemoForm",
			value: function showDemoForm(e) {
				$wr.nope(e);
				this.setState({ showDemoForm: true });
			}
		}, {
			key: "validateForm",
			value: function validateForm() {
				return this.refs.myInput.validate();
			}
		}, {
			key: "handleSubmit",
			value: function handleSubmit(e) {
				$wr.nope(e);
				if (!this.validateForm()) {
					return;
				}
	
				var callback = $wr.apiHandler(function (response) {});
				var userMessage = "Whooo's Reading School Interest (" + this.props.featureType + ") -- Teachers: " + this.refs.numTeachers.val() + " -- Administration: " + this.refs.adminOpinion.val();
	
				var params = {
					contact_message: {
						message: userMessage
					}
				};
	
				var title = "Message Sent";
				var text = "Thank you for the message! We will contact you shortly.";
				CurrentUser.api().postContactMessages(params, callback);
	
				this.hide();
				this.setState({ showDemoForm: false });
				window.wrNotifications.triggerDropDownNotification({ title: title,
					text: text, icon: "ok-circle" }, 3000);
	
				var label = "paywall-" + this.props.featureType;
				Mycroft.newEvent({ category: "Requests", action: "request-demo", label: label });
			}
		}, {
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "hide",
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: "onShow",
			value: function onShow() {
				Mycroft.buildEventHandler({
					category: "Paywall", action: "show", label: this.props.featureType
				});
			}
		}, {
			key: "isSilverPaywall",
			value: function isSilverPaywall() {
				switch (this.props.featureType) {
					case PaywallModal.HISTORICAL_DATA:
					case PaywallModal.STUDENT_DIFFERENTIATION:
					case PaywallModal.LOG_READING:
					case PaywallModal.TEACHER_DASHBOARD:
					case PaywallModal.TEXT_TABLE_DATA:
					case PaywallModal.OVERDRAWN_ACCOUNT:
					case PaywallModal.ZPD_READING_LEVELS:
						return true;
					default:
						return false;
				}
			}
		}, {
			key: "getFeatureName",
			value: function getFeatureName() {
				switch (this.props.featureType) {
					case PaywallModal.INSIGHTS:
						return "Insights";
					case PaywallModal.PROGRESS:
						return "Progress Data";
					case PaywallModal.COMPARISONS:
						return "Comparison Data";
					case PaywallModal.QUIZ_FEATURES:
						return "Details & Comments";
					case PaywallModal.TEXT_SPECIFIC_QUESTIONS:
						return "Specific Questions";
					case PaywallModal.CLOZE_ASSESSMENTS:
						return "RLDs";
					case PaywallModal.EXERCISES:
						return "Exercises";
					case PaywallModal.LOG_READING:
						return "Reading Logs";
					case PaywallModal.HISTORICAL_DATA:
						return "Writing History";
					case PaywallModal.TEACHER_PICKS:
						return "Teacher's Picks";
					case PaywallModal.TEACHER_DASHBOARD:
						return "Assignment Dashboard";
					case PaywallModal.STUDENT_DIFFERENTIATION:
						return "Student Differentiation";
					case PaywallModal.TEXT_TABLE_DATA:
						return "Text Table";
					case PaywallModal.OVERDRAWN_ACCOUNT:
						return "Additional Accounts";
					case PaywallModal.ZPD_READING_LEVELS:
						return "ZPD Reading Levels";
					default:
						return "Whooo's Reading Silver";
				}
			}
		}, {
			key: "getFeatureBenefit",
			value: function getFeatureBenefit() {
				switch (this.props.featureType) {
					case PaywallModal.CLOZE_ASSESSMENTS:
						return "RLDs";
					case PaywallModal.LOG_READING:
						return "track your students' reading";
					case PaywallModal.HISTORICAL_DATA:
						return "unlock student writing data";
					case PaywallModal.TEACHER_DASHBOARD:
						return "experience the Assignment Dashboard";
					case PaywallModal.STUDENT_DIFFERENTIATION:
						return "access student differentiation";
					case PaywallModal.TEXT_TABLE_DATA:
						return "unlock student text tables";
					case PaywallModal.OVERDRAWN_ACCOUNT:
						return "get more classes for Whooo's Reading";
					case PaywallModal.ZPD_READING_LEVELS:
						return "get more control over your students' accountability";
					default:
						return "access this feature";
				}
			}
		}, {
			key: "getTrialFeatures",
			value: function getTrialFeatures() {
				switch (this.props.featureType) {
					case PaywallModal.INSIGHTS:
					case PaywallModal.EXERCISES:
					case PaywallModal.PROGRESS:
					case PaywallModal.COMPARISONS:
						return Features.DIGITAL_EXERCISES;
					case PaywallModal.QUIZ_FEATURES:
						return Features.AUTOGRADER_DATA + "," + Features.TEACHER_COMMENTS;
					case PaywallModal.TEXT_SPECIFIC_QUESTIONS:
						return Features.TEXT_SPECIFIC_QUESTIONS;
					case PaywallModal.CLOZE_ASSESSMENTS:
						return Features.CLOZE_ASSESSMENTS;
					case PaywallModal.TEACHER_PICKS:
					case PaywallModal.LOG_READING:
						return Features.LOG_READING;
					case PaywallModal.HISTORICAL_DATA:
					case PaywallModal.TEACHER_DASHBOARD:
						return Features.HISTORICAL_DATA;
					default:
						return "";
				}
			}
		}, {
			key: "renderTrialOrWebinarActionSection",
			value: function renderTrialOrWebinarActionSection() {
				var trialEventHandler = Mycroft.buildEventHandler({
					category: "Paywall", action: "start-trial", label: this.props.featureType + "-paywall"
				});
	
				var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=" + this.getTrialFeatures();
				var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
	
				if (this.state.showWebinarReg) {
					var actionDisplay = React.createElement(
						"div",
						{ className: "actionDisplay" },
						React.createElement(WebinarRegistration, { sourceFeature: this.props.featureType + "-paywall" })
					);
				} else if (this.state.showConsultation) {
					var linkEventHandler = Mycroft.buildEventHandler({
						category: "Paywall", action: "schedule-consultation", label: this.props.featureType + "-paywall"
					});
					var actionDisplay = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"It looks like you completed a trial of ",
							React.createElement(
								"i",
								null,
								this.getFeatureName()
							),
							". How did it go?"
						),
						React.createElement(
							"p",
							null,
							"Want to learn more about all of the features included in ",
							React.createElement(
								"i",
								null,
								"Whooo's Reading School"
							),
							"? Schedule a free, 15-minute consultation to see if ",
							React.createElement(
								"i",
								null,
								"Whooo's Reading School"
							),
							" is a good fit for your school."
						),
						React.createElement(
							"div",
							{ className: "actionSection" },
							React.createElement(
								"a",
								{ href: "https://calendly.com/whooos-reading/wrs-consultation",
									className: "buttonSuccess btn", target: "_blank", onClick: linkEventHandler },
								"Schedule My Consultation"
							)
						)
					);
				} else {
	
					if (this.props.featureType != PaywallModal.CLOZE_ASSESSMENTS) {
						var ctaQuestion = React.createElement(
							"div",
							{ className: "ctaQuestion" },
							"What are your needs at this time?"
						);
						var dividerDot = React.createElement("div", { className: "dividerDot" });
						var actionDescription = React.createElement(
							"div",
							{ className: "actionDescription" },
							"I would like to learn more about the basic features and how Whooo's Reading works in general..."
						);
						var reserveWebinar = React.createElement(
							"a",
							{ href: "#", onClick: this.showWebinarRegistration, className: "buttonPrimary actionButton" },
							"Reserve a Webinar Spot"
						);
						var className = "actionOptionsSection";
					} else {
						var className = "actionOptionsSection rld";
					}
	
					var actionDisplay = React.createElement(
						"div",
						{ className: "actionDisplay" },
						React.createElement(
							"div",
							{ className: "actionOption" },
							React.createElement(
								"div",
								{ className: "actionDescription" },
								React.createElement(
									"i",
									null,
									"Reading Level Diagnostics"
								),
								" can be purchased as an add-on to your teacher account, or at a discount with a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license."
							)
						),
						React.createElement(
							"div",
							{ className: "actionOption" },
							actionDescription,
							reserveWebinar
						),
						React.createElement(
							"a",
							{ href: trialURL, onClick: trialEventHandler, className: "buttonSuccess actionButton" },
							"Start Free Trial"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: className },
					dividerDot,
					ctaQuestion,
					actionDisplay
				);
			}
		}, {
			key: "fetchFeatureContent",
			value: function fetchFeatureContent() {
				var _this2 = this;
	
				if (this.state.showDemoForm) {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Let us know where your school stands!"
						),
						React.createElement(
							"form",
							{ className: "contactForm", onSubmit: this.handleSubmit },
							React.createElement(
								"p",
								null,
								"How many teachers are interested in Whooo's Reading?"
							),
							React.createElement(ValidatingInput, { type: "textarea", ref: "numTeachers",
								validators: ValidatingInput.Validators.PRESENT,
								placeholder: "We have 5 teachers interested...",
								inputClassName: "form-control messageArea" }),
							React.createElement("br", null),
							React.createElement(
								"p",
								null,
								"Does your administration know about the program? What do they think?"
							),
							React.createElement(ValidatingInput, { type: "textarea", ref: "adminOpinion",
								validators: ValidatingInput.Validators.PRESENT,
								placeholder: "Yes, my principal wants to learn about schoolwide data...",
								inputClassName: "form-control messageArea" }),
							React.createElement("br", null),
							React.createElement("input", { className: "buttonSuccess center-block", type: "submit", value: "Send" })
						)
					);
				} else {
	
					//////////////////////////////////////////////////////////////////////////////
					////// in use for Silver paywalls ////////////////////////////////////////////
					//////////////////////////////////////////////////////////////////////////////
					if (this.props.featureType == PaywallModal.TEACHER_DASHBOARD) {
						var imgSrc = __webpack_require__(3146);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Easily monitor who in your class has completed their assignments with the ",
								React.createElement(
									"i",
									null,
									"Assignment Dashboard"
								),
								" in Whooo's Reading Silver:"
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.HISTORICAL_DATA) {
						var imgSrc = __webpack_require__(3150);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"See all of your students' writing and the scores they received. Save time and access your students' grades all in one place."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.TEXT_TABLE_DATA) {
						var imgSrc = __webpack_require__(3153);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Immediately pull up a text table for each of your students to see the books they are reading, their quiz and answer scores, and more:"
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.STUDENT_DIFFERENTIATION) {
						var imgSrc = __webpack_require__(3147);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Unlock full student-by-student differentiation: choose who gets sentence starters and warm-up questions; tailor the question and grading difficulty to challenge each student according to their level."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.ZPD_READING_LEVELS) {
						var imgSrc = __webpack_require__(3154);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Change any student's academic or reading level and keep them more accountable by automatically or manually excluding any work completed for a book below their Zone of Proximal Development (ZPD)."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.LOG_READING) {
						var imgSrc = __webpack_require__(3149);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Track your students' independent reading time within Whooo's Reading using ",
								React.createElement(
									"i",
									null,
									"Reading Logs"
								),
								", part of Whooo's Reading Silver."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.OVERDRAWN_ACCOUNT) {
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Whooo's Reading Silver allows for as many classes as you need."
							)
						);
	
						//////////////////////////////////////////////////////////////////////////////
						////// end Silver paywalls ///////////////////////////////////////////////////
						//////////////////////////////////////////////////////////////////////////////
					} else if (this.props.featureType == PaywallModal.TEACHER_PICKS) {
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Send your students specific texts you want them to be writing about, using Teacher's Picks, part of a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license."
							)
						);
					} else if (this.props.featureType == PaywallModal.INSIGHTS) {
						var imgSrc = __webpack_require__(3148);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								React.createElement(
									"i",
									null,
									"Insights"
								),
								" is available under ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading Gold"
								),
								". This feature can help you identify trends in students' and classes' performance."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.QUIZ_FEATURES) {
						var imgSrc = __webpack_require__(3151);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Learn how a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license can make student quizzes really come to life!"
							),
							middleContent
						);
					} else if (this.props.featureType == Features.TEXT_SPECIFIC_QUESTIONS) {
						var imgSrc = __webpack_require__(3152);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Thousands of ",
								React.createElement(
									"i",
									null,
									"Text-Specific Questions"
								),
								" come with a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.CLOZE_ASSESSMENTS) {
						var imgSrc = __webpack_require__(544);
						var middleContent = React.createElement("img", { src: imgSrc, className: "paywallImg", alt: "" });
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Track your students' reading levels throughout the year with Lexile-based cloze assessments, called ",
								React.createElement(
									"i",
									null,
									"Reading Level Diagnostics"
								),
								"."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.PROGRESS) {
						var middleContent = React.createElement(
							"ul",
							null,
							React.createElement(
								"li",
								null,
								"See how Whooo's Reading has helped your students' critical thinking skills improve throughout the school year."
							),
							React.createElement(
								"li",
								null,
								"Compare their growth to your class average and the national average for students in a similar demographic."
							)
						);
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Critical thinking progress graphs for each of your students are included with a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.COMPARISONS) {
						var middleContent = React.createElement(
							"ul",
							null,
							React.createElement(
								"li",
								null,
								"See how each of your students is doing in each standard compared to the national average for students in a similar demographic."
							),
							React.createElement(
								"li",
								null,
								"Use individual and classwide patterns in critical thinking progress to help inform instruction."
							)
						);
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								"Individual student comparison data is available with a ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" license."
							),
							middleContent
						);
					} else if (this.props.featureType == PaywallModal.EXERCISES) {
						var middleContent = React.createElement(
							"ul",
							null,
							React.createElement(
								"li",
								null,
								"Assign Exercises to reinforce the reading comprehension skills you are currently teaching in class."
							),
							React.createElement(
								"li",
								null,
								"Use recommended Exercises from the Insights section to target and strengthen areas of weakness."
							)
						);
						var featureExplanation = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								null,
								React.createElement(
									"i",
									null,
									"Whooo's Reading School"
								),
								" gives you access to hundreds of standards-aligned Exercises that help students improve specific skills."
							),
							middleContent
						);
					}
	
					if (this.isSilverPaywall()) {
						var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;
	
						if (!expiredSilverTrial) {
							var trialEventHandler = Mycroft.buildEventHandler({
								category: "Paywall", action: "start-silver-trial", label: this.props.featureType + "-paywall"
							});
							var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
							var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
	
							var optionLink = React.createElement(
								"a",
								{ href: trialURL, onClick: trialEventHandler, className: "actionButton" },
								"Start Free Trial"
							);
	
							var ctaSentence = "Upgrade your account, or start a 30-day free trial.";
						} else {
							// var ctaSentence = "Upgrade your account today."
							var trialEnded = React.createElement(
								"p",
								{ className: "trialEnded" },
								"Your trial has ended. We hope you enjoyed it!"
							);
							var ctaFullSentence = React.createElement(
								"p",
								null,
								"Upgrade your account today or schedule a free, 15-minute consultation to see if ",
								React.createElement(
									"i",
									null,
									"Whooo's Reading Silver"
								),
								" is a good fit for you."
							);
							var consulationURL = "https://calendly.com/whooos-reading/wrs-consultation";
							var optionLink = React.createElement(
								"a",
								{ href: consulationURL, className: "actionButton", target: "_blank",
									onClick: linkEventHandler },
								"Schedule My Consultation"
							);
						}
	
						var upgradeEventHandler = function upgradeEventHandler(e) {
							$wr.nope(e);
							Mycroft.newEvent({
								category: "Paywall", action: "silver-upgrade-page", label: _this2.props.featureType + "-paywall"
							});
	
							_this2.hide();
	
							$wr.redirect("/upgrade?plan=silver");
						};
	
						var actionSection = React.createElement(
							"div",
							null,
							trialEnded,
							ctaFullSentence,
							React.createElement(
								"div",
								{ className: "actionSection" },
								React.createElement(
									"a",
									{ href: "#", onClick: upgradeEventHandler,
										className: "btn buttonSuccess upgradeButton" },
									"Upgrade to Silver"
								),
								optionLink
							)
						);
					} else if (this.props.featureType == PaywallModal.INSIGHTS) {
						var linkEventHandler = Mycroft.buildEventHandler({
							category: "Paywall", action: "schedule-consultation", label: this.props.featureType + "-paywall"
						});
						if (!this.state.showConsultation) {
							var trialEventHandler = Mycroft.buildEventHandler({
								category: "Paywall", action: "start-trial", label: this.props.featureType + "-paywall"
							});
	
							var upgradeURL = "https://www.whooosreading.org/pricing";
							var actionSection = React.createElement(
								"div",
								null,
								React.createElement(
									"p",
									null,
									"Upgrade to Gold to gain access to ",
									React.createElement(
										"i",
										null,
										"Insights"
									),
									" and get a feel for what Whooo's Reading can do!"
								),
								React.createElement(
									"div",
									{ className: "actionSection" },
									React.createElement(
										"a",
										{ href: upgradeURL, className: "buttonSuccess actionButton" },
										"View Plans"
									)
								)
							);
						} else {
							var actionSection = React.createElement(
								"div",
								null,
								React.createElement(
									"p",
									null,
									"It looks like you have completed a trial of ",
									React.createElement(
										"i",
										null,
										this.getFeatureName()
									),
									". Did you like it? Want to learn more about all of the features included in ",
									React.createElement(
										"i",
										null,
										"Whooo's Reading School"
									),
									"? Schedule a free, 15-minute consultation to see if ",
									React.createElement(
										"i",
										null,
										"Whooo's Reading School"
									),
									" is a good fit for your school."
								),
								React.createElement(
									"div",
									{ className: "actionSection" },
									React.createElement(
										"a",
										{ href: "https://calendly.com/whooos-reading/wrs-consultation",
											className: "buttonSuccess btn", target: "_blank", onClick: linkEventHandler },
										"Schedule My Consultation"
									)
								)
							);
						}
					} else {
						var actionSection = this.renderTrialOrWebinarActionSection();
					}
	
					return React.createElement(
						"div",
						null,
						featureExplanation,
						actionSection
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var paywallModalContent = React.createElement(
					"div",
					{ className: "paywallContentContainer" },
					this.fetchFeatureContent()
				);
	
				var feature = this.props.featureType;
				if (this.isSilverPaywall()) {
					var headerText = "Whooo's Reading Silver";
				} else {
					var headerText = this.getFeatureName();
				}
	
				return React.createElement(
					Modal,
					{ className: "paywallModal", onShow: this.onShow, onHide: this.props.onHide,
						ref: "modal", headerText: headerText },
					paywallModalContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.selfOpen) {
					this.refs.modal.show();
				}
			}
		}]);
	
		return PaywallModal;
	}(React.Component);
	
	;
	
	PaywallModal.propTypes = StrictPropTypes({
		featureType: PropTypes.string,
		onHide: PropTypes.func,
		selfOpen: PropTypes.bool
	});
	
	PaywallModal.INSIGHTS = "insights";
	PaywallModal.PROGRESS = "progress";
	PaywallModal.COMPARISONS = "comparisons";
	PaywallModal.QUIZ_FEATURES = "quizzes";
	PaywallModal.TEXT_SPECIFIC_QUESTIONS = "text-specific-questions";
	PaywallModal.CLOZE_ASSESSMENTS = "cloze-assessments";
	PaywallModal.EXERCISES = "exercises";
	PaywallModal.LOG_READING = "log-reading";
	PaywallModal.HISTORICAL_DATA = "historical-data";
	PaywallModal.TEACHER_PICKS = "teacher-picks";
	PaywallModal.STUDENT_DIFFERENTIATION = "student-differentiation";
	PaywallModal.TEACHER_DASHBOARD = "teacher-dashboard";
	PaywallModal.TEXT_TABLE_DATA = "text-table-data";
	PaywallModal.OVERDRAWN_ACCOUNT = "overdrawn-account";
	PaywallModal.ZPD_READING_LEVELS = "zpd-reading-levels";
	
	module.exports = PaywallModal;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	
	var OrgTypes = {
		ALL_STUDENTS: "all-students",
		ALL_STUDENT_LISTS: "all-student-lists",
		ALL_SCHOOL_ORGS: "all-school-orgs",
	
		STUDENT_LIST: "student-list",
		SUBGROUP: "subgroup",
		SCHOOL_ORG: "school-org",
		DISTRICT_ORG: "district-org",
	
		isEveryoneIdentifier: function isEveryoneIdentifier(identifier) {
			return OrgTypes.EVERYONE_TYPES.includes(OrgTypes.fromIdentifier(identifier).type);
		},
		isStudentListIdentifier: function isStudentListIdentifier(identifier) {
			return OrgTypes.fromIdentifier(identifier).type == OrgTypes.STUDENT_LIST;
		},
		isSchoolOrgIdentifier: function isSchoolOrgIdentifier(identifier) {
			return OrgTypes.fromIdentifier(identifier).type == OrgTypes.SCHOOL_ORG;
		},
		isDistrictOrgIdentifier: function isDistrictOrgIdentifier(identifier) {
			return OrgTypes.fromIdentifier(identifier).type == OrgTypes.DISTRICT_ORG;
		},
	
		toIdentifier: function toIdentifier(_ref) {
			var type = _ref.type,
			    key = _ref.key;
	
			if (key) {
				return type + ":" + key;
			} else {
				return type;
			}
		},
	
		fromIdentifier: function fromIdentifier(identifier) {
			if (!identifier) {
				throw "Missing identifier in OrgTypes";
			}
			var parts = identifier.split(":");
			if (parts[0] == OrgTypes.STUDENT_LIST || parts[0] == OrgTypes.SCHOOL_ORG) {
				return { type: parts[0], key: parseInt(parts[1]) };
			} else {
				return { type: parts[0], key: parts[1] };
			}
		}
	};
	
	OrgTypes.EVERYONE_TYPES = [OrgTypes.ALL_STUDENTS, OrgTypes.ALL_STUDENT_LISTS, OrgTypes.ALL_SCHOOL_ORGS];
	
	// Note: This is (currently) the same as just OrgTypes.ALL_STUDENTS
	// But in case it changes, I'd rather use this as the default in other places
	OrgTypes.ALL_STUDENTS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENTS });
	OrgTypes.ALL_STUDENT_LISTS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENT_LISTS });
	OrgTypes.ALL_SCHOOL_ORGS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_SCHOOL_ORGS });
	
	module.exports = OrgTypes;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArbitrarySubjects = __webpack_require__(107);
	var TextTypes = __webpack_require__(38);
	var GradeLevel = __webpack_require__(40);
	
	var ReadingSelectors = __webpack_require__(21);
	var ReadingActions = __webpack_require__(27);
	var ReadingLevelFormat = __webpack_require__(72);
	
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var ReadingLevelIcon = __webpack_require__(165);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3719);
	
	var BookDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var book = ReadingSelectors.book({ state: state, id: props.textID });
	
		if (book && book.platform_id) {
			var platform = ReadingSelectors.platform({ state: state, id: book.platform_id });
		}
		return {
			book: book, platform: platform,
			readingLevelFormat: CurrentUser.get().prefs.reading_level_format
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(ReadingActions.batchFetchBook({ id: props.textID, userID: (CurrentUser.get() || {}).id }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(BookDisplay, _React$Component);
	
		function BookDisplay(props) {
			_classCallCheck(this, BookDisplay);
	
			var _this = _possibleConstructorReturn(this, (BookDisplay.__proto__ || Object.getPrototypeOf(BookDisplay)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(BookDisplay, [{
			key: "missingBookCover",
			value: function missingBookCover() {
				var book = this.props.book || {};
				return book.cover_url == null || book.cover_url.includes("nophoto");
			}
		}, {
			key: "coverWidth",
			value: function coverWidth() {
				return this.props.coverWidth || 98;
			}
		}, {
			key: "showCover",
			value: function showCover() {
				return this.props.showCover || this.props.contingentShowCover && !this.missingBookCover();
			}
		}, {
			key: "renderCover",
			value: function renderCover() {
				var _props = this.props,
				    book = _props.book,
				    platform = _props.platform;
	
				var coverStyle = {
					width: this.coverWidth(), height: "auto"
				};
	
				if (book.url) {
					var urlCoverWidth = this.coverWidth() * 0.75;
	
					if (this.props.hideTitleIfCover) {
						return React.createElement(
							"div",
							{ className: "urlCover text-center", style: { minHeight: urlCoverWidth } },
							React.createElement(
								"div",
								{ className: "text smallText" },
								book.title
							)
						);
					} else if (platform && platform.img_url) {
						return React.createElement(
							"div",
							{ className: "text-center platformCover" },
							React.createElement("img", { src: platform.img_url, style: coverStyle })
						);
					} else if (platform) {
						return React.createElement(
							"div",
							{ className: "urlCover cursive text-center", style: { minHeight: urlCoverWidth } },
							React.createElement(
								"div",
								{ className: "text" },
								platform.name
							)
						);
					} else {
						return React.createElement(
							"div",
							{ className: "text-center platformCover" },
							React.createElement("img", { src: __webpack_require__(3421), style: coverStyle })
						);
					}
				} else {
					if (this.missingBookCover()) {
						var bookColors = ["red", "blue", "gold", "green", "orange", "purple"];
						var bookNumber = $wr.psuedoRandom("seed", bookColors.length);
						var coverUrl = __webpack_require__(355)("./book-" + bookNumber + ".png");
					} else {
						var coverUrl = book.cover_url;
					}
	
					return React.createElement(
						"div",
						null,
						React.createElement("img", { className: "cover", src: coverUrl, style: coverStyle })
					);
				}
			}
		}, {
			key: "renderAbout",
			value: function renderAbout() {
				var book = this.props.book;
	
				if (this.props.showAuthor && (book.author || book.author_full_name)) {
					var author = React.createElement(
						"span",
						{ className: "author" },
						book.author || book.author_full_name
					);
				}
	
				if (this.props.showURL && book.url) {
					var booksURL = React.createElement(
						"a",
						{ className: "bookURL", href: book.url, target: "_blank" },
						book.url
					);
				}
	
				if (book.url) {
					if (this.props.hideTitleIfCover) {} else {
						if (this.props.linkURL) {
							var urlLink = React.createElement(
								"a",
								{ className: "linkURL", href: book.url, target: "_blank" },
								React.createElement(Glyphicon, { icon: "new-window" })
							);
						}
	
						var title = React.createElement(
							"span",
							{ className: "title titleURL" },
							book.title,
							urlLink
						);
					}
				} else {
					if (this.missingBookCover() || !this.props.hideTitleIfCover) {
						var title = React.createElement(
							"span",
							{ className: "title" },
							book.title
						);
					}
				}
	
				if (CurrentUser.isAdmin()) {
					var tooltipCopyType = ReadingLevelIcon.TEACHER_VIEW;
				} else {
					var tooltipCopyType = ReadingLevelIcon.STUDENT_VIEW;
				}
	
				if (book.lexile_score && this.props.showReadingLevel) {
					if (this.props.studentReadingLevel) {
						var studentReadingLevel = this.props.studentReadingLevel;
					} else {
						var studentReadingLevel = CurrentUser.get().current_reading_level;
					}
					var readingLevelDisplay = React.createElement(ReadingLevelIcon, { studentReadingLevel: studentReadingLevel,
						textReadingLevel: book.lexile_score, showImageOnly: this.props.showImageOnly,
						tooltipCopyType: tooltipCopyType });
				}
	
				if (this.props.showLibraryTags) {
					var libraryTagItems = [];
	
					if (book.text_variety) {
						libraryTagItems.push(React.createElement(
							"span",
							{ className: "badge libraryTag", key: "text-variety" },
							TextTypes.Varieties.getName(book.text_variety)
						));
					}
	
					if (book.lexile_score) {
						libraryTagItems.push(React.createElement(
							"span",
							{ className: "badge libraryTag", key: "lexile" },
							ReadingLevelFormat.getScoreForFormat(book.lexile_score, this.props.readingLevelFormat)
						));
					}
	
					if (book.ages) {
						book.ages.forEach(function (age) {
							libraryTagItems.push(React.createElement(
								"span",
								{ className: "badge libraryTag", key: "age-" + age },
								age
							));
						});
					}
	
					if (book.topics) {
						book.topics.forEach(function (topic) {
							libraryTagItems.push(React.createElement(
								"span",
								{ className: "badge libraryTag", key: "topic-" + topic },
								topic
							));
						});
					}
	
					var libraryTags = React.createElement(
						"div",
						null,
						libraryTagItems,
						" "
					);
				}
	
				return React.createElement(
					"span",
					{ className: "about" },
					title,
					author,
					booksURL,
					libraryTags,
					this.props.children,
					readingLevelDisplay
				);
			}
		}, {
			key: "render",
			value: function render() {
				var book = this.props.book;
	
				if (!book) {
					// Loading state
					if (this.showCover()) {
						var loadingContent = React.createElement(Spinner, { placeholder: true });
					} else {
						var loadingContent = "...";
					}
	
					return React.createElement(
						"div",
						{ className: "bookDisplay" },
						loadingContent
					);
				}
	
				var aboutStyle = {};
				var aboutClassName = "aboutWrap";
	
				if (this.showCover()) {
					aboutStyle.paddingLeft = this.coverWidth() + 15;
					// 15 is the gap between "about" and the cover
	
					var coverStyle = {
						display: "inline-block",
						width: this.coverWidth(),
						height: "auto",
						marginRight: -1 * this.coverWidth()
					};
					var cover = React.createElement(
						"div",
						{ className: "coverWrap", style: coverStyle },
						this.renderCover()
					);
				} else {
					aboutClassName += " withoutCover";
				}
	
				var about = this.renderAbout();
	
				var bookClassName = "bookDisplay";
				if (this.props.onClick) {
					bookClassName += " clickableElement";
				}
	
				if (this.props.inline) {
					bookClassName += " inlineBook";
				}
	
				return React.createElement(
					"div",
					{ className: bookClassName, onClick: this.props.onClick },
					cover,
					React.createElement(
						"div",
						{ className: aboutClassName, style: aboutStyle },
						about
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!(this.props.book && this.props.book.title) && (this.props.loadBook === undefined || this.props.loadBook)) {
					this.props.populateData();
				}
			}
		}]);
	
		return BookDisplay;
	}(React.Component)) || _class);
	
	
	var QUIZZES_VIEW = "quizzes";
	var ANSWERS_VIEW = "answers";
	
	BookDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the book to be displayed
		textID: PropTypes.string,
	
		// If set, renders the book's cover before the title
		showCover: PropTypes.bool,
	
		// If set, renders the book's cover ONLY IF there is a unique book cover image
		contingentShowCover: PropTypes.bool,
	
		// If set, renders the book's author after the title
		showAuthor: PropTypes.bool,
	
		// If set, renders the book's URL (limited to 1 line) after the title
		showURL: PropTypes.bool,
	
		linkURL: PropTypes.bool,
	
		// If set, renders tags for the books text variety, age, topics, etc.
		showLibraryTags: PropTypes.bool,
	
		showReadingLevelIcon: PropTypes.bool,
	
		// If set, renders the title only if the book cover is missing
		hideTitleIfCover: PropTypes.bool,
	
		// Width of the cover (default is 98)
		coverWidth: PropTypes.number,
	
		readingLevelFormat: PropTypes.string,
	
		inline: PropTypes.bool,
	
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	
		onClick: PropTypes.func,
	
		loadBook: PropTypes.bool,
	
		// From @connect
		// Which are present is determined by the other props
		book: PropTypes.object,
		platform: PropTypes.object,
		populateData: PropTypes.func.isRequired,
	
		studentReadingLevel: PropTypes.number,
		showExclusionNote: PropTypes.bool,
		showReadingLevel: PropTypes.bool
	
	});
	
	module.exports = BookDisplay;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(22);
	var IE8_DOM_DEFINE = __webpack_require__(456);
	var toPrimitive = __webpack_require__(87);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3799);
	
	var DisplayToggleControl = function (_React$Component) {
		_inherits(DisplayToggleControl, _React$Component);
	
		function DisplayToggleControl(props) {
			_classCallCheck(this, DisplayToggleControl);
	
			var _this = _possibleConstructorReturn(this, (DisplayToggleControl.__proto__ || Object.getPrototypeOf(DisplayToggleControl)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(DisplayToggleControl, [{
			key: "buildToggleF",
			value: function buildToggleF(key) {
				return function (e) {
					$wr.nope(e);
					this.props.onChange(key);
				}.bind(this);
			}
		}, {
			key: "moveBar",
			value: function moveBar() {
				var $active = $(this.refs.box).find(".activeOp");
				var $bar = $(this.refs.bar);
				if ($active.length > 0 && $bar.length > 0) {
					$bar.css({ left: $active.position().left, width: $active.innerWidth() });
				}
			}
		}, {
			key: "mode",
			value: function mode() {
				return this.props.mode || BAR_MODE;
			}
		}, {
			key: "render",
			value: function render() {
				var optionLinks = _.map(this.props.options, function (option) {
					var className = "toggleOp";
					if (option.key == this.props.activeOptionKey) {
						className += " activeOp";
					}
	
					if (option.newBadge) {
						var newBadge = React.createElement(
							"span",
							{ className: "badge" },
							"New!"
						);
					}
	
					return React.createElement(
						"a",
						{ href: "#", onClick: this.buildToggleF(option.key),
							className: className, key: option.key },
						option.text,
						newBadge
					);
				}.bind(this));
	
				var className = "displayToggleControl";
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				if (this.mode() === BAR_MODE) {
					var selectBar = React.createElement("div", { className: "activeBar", ref: "bar" });
	
					className += " barMode";
				}
	
				if (this.mode() === LINK_MODE) {
					className += " linkMode";
				}
	
				return React.createElement(
					"div",
					{ className: className, ref: "box" },
					optionLinks,
					selectBar
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.moveBar();
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				this.moveBar();
			}
		}]);
	
		return DisplayToggleControl;
	}(React.Component);
	
	;
	
	var LINK_MODE = "link";
	var BAR_MODE = "bar";
	
	DisplayToggleControl.LINK_MODE = LINK_MODE;
	DisplayToggleControl.BAR_MODE = BAR_MODE;
	
	DisplayToggleControl.propTypes = StrictPropTypes({
		// array of hashes, e.g.: [{ key: "tree", text: "Class Tree" }, ...]
		options: PropTypes.array.isRequired,
		activeOptionKey: PropTypes.string,
	
		className: PropTypes.string,
	
		mode: PropTypes.string,
	
		// We'll pass the selected optionKey to this funciton
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = DisplayToggleControl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var KeyToText = __webpack_require__(1517);
	var KeywordToOptions = __webpack_require__(1515);
	var RelationVerbs = __webpack_require__(1516);
	
	var WarmupQuestions = {
		getText: function getText(key) {
			var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			var match = _.findWhere(KeyToText, { key: key });
			if (!match) {
				return "MISSING VALUE";
			}
			var value = match.text;
	
			if (value.includes("{{")) {
				_.map(WarmupQuestions.KEYWORDS, function (keyword) {
					var toReplace = "{{" + keyword + "}}";
	
					// if this keyword is present to replace
					if (value.includes(toReplace)) {
	
						// first check the provided replacements hash for a value
						if (replacements[keyword]) {
							value = value.replace(new RegExp(toReplace, "g"), replacements[keyword]);
	
							// then check our own option lists for a value
						} else if (WarmupQuestions.getOptions(keyword)) {
							value = value.replace(new RegExp(toReplace, "g"), WarmupQuestions.getOptions(keyword));
	
							// handle the relational matrix differently
						} else if (keyword == WarmupQuestions.RELATIONAL_MATRIX) {
							var relationKey = replacements[WarmupQuestions.RELATION_KEY];
							value = value.replace(new RegExp(toReplace, "g"), WarmupQuestions.getRelationVerbOptions(relationKey));
						}
					}
				});
			}
	
			return value;
		},
	
		getOptions: function getOptions(keyword) {
			return KeywordToOptions[0][keyword];
		},
	
		getRelationVerbOptions: function getRelationVerbOptions(keyword) {
			return RelationVerbs[0][keyword];
		},
	
		getKey: function getKey(question, stage, part, level) {
			return question + "." + stage + "." + part + ".level" + level;
		}
	};
	
	window.qq = WarmupQuestions;
	
	// topic question replacement keywords
	WarmupQuestions.TEXT_TYPE = "TEXT_TYPE";
	WarmupQuestions.NF_SUBJECT_OPTIONS = "NF_SUBJECT_OPTIONS";
	
	// fiction replacement keywords
	WarmupQuestions.CHAR1_NAME = "CHAR1_NAME";
	WarmupQuestions.CHAR2_NAME = "CHAR2_NAME";
	WarmupQuestions.TRAIT_OPTIONS = "TRAIT_OPTIONS";
	WarmupQuestions.GOAL_OPTIONS = "GOAL_OPTIONS";
	WarmupQuestions.RELATION_OPTIONS = "RELATION_OPTIONS";
	WarmupQuestions.DESCRIPTOR_OPTIONS = "DESCRIPTOR_OPTIONS";
	WarmupQuestions.ORG_PIECE = "ORG_PIECE";
	WarmupQuestions.ORG_PIECE_NUMBER = "ORG_PIECE_NUMBER";
	WarmupQuestions.SELECTED_TEXT = "SELECTED_TEXT";
	WarmupQuestions.SIMILAR_ELEMENT = "SIMILAR_ELEMENT";
	WarmupQuestions.EMOTION_OPTIONS = "EMOTION_OPTIONS";
	WarmupQuestions.ENTERED_WORD = "ENTERED_WORD";
	
	// nonfiction replacement keywords
	WarmupQuestions.ENTITY_TYPE = "ENTITY_TYPE";
	WarmupQuestions.ENTITY1 = "ENTITY1";
	WarmupQuestions.ENTITY2 = "ENTITY2";
	WarmupQuestions.RELATIONAL_MATRIX = "RELATIONAL_MATRIX";
	WarmupQuestions.HEADING_NUMBER = "HEADING_NUMBER";
	WarmupQuestions.TEXT_FEATURE_OPTIONS = "TEXT_FEATURE_OPTIONS";
	WarmupQuestions.FEATURE_TYPE = "FEATURE_TYPE";
	WarmupQuestions.TOPIC = "TOPIC";
	WarmupQuestions.HARD_WORD = "HARD_WORD";
	WarmupQuestions.SPECIFIC_ENTITY = "SPECIFIC_ENTITY";
	
	// not replacement keywords
	WarmupQuestions.RELATION_KEY = "RELATION_KEY";
	
	WarmupQuestions.KEYWORDS = [WarmupQuestions.TEXT_TYPE, WarmupQuestions.NF_SUBJECT_OPTIONS, WarmupQuestions.CHAR1_NAME, WarmupQuestions.CHAR2_NAME, WarmupQuestions.TRAIT_OPTIONS, WarmupQuestions.GOAL_OPTIONS, WarmupQuestions.RELATION_OPTIONS, WarmupQuestions.DESCRIPTOR_OPTIONS, WarmupQuestions.ORG_PIECE, WarmupQuestions.ORG_PIECE_NUMBER, WarmupQuestions.SELECTED_TEXT, WarmupQuestions.SIMILAR_ELEMENT, WarmupQuestions.EMOTION_OPTIONS, WarmupQuestions.ENTERED_WORD, WarmupQuestions.ENTITY_TYPE, WarmupQuestions.ENTITY1, WarmupQuestions.ENTITY2, WarmupQuestions.RELATIONAL_MATRIX, WarmupQuestions.HEADING_NUMBER, WarmupQuestions.TEXT_FEATURE_OPTIONS, WarmupQuestions.FEATURE_TYPE, WarmupQuestions.TOPIC, WarmupQuestions.HARD_WORD, WarmupQuestions.SPECIFIC_ENTITY];
	
	module.exports = WarmupQuestions;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(85);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3802);
	
	var ErrorDisplay = function (_React$Component) {
		_inherits(ErrorDisplay, _React$Component);
	
		function ErrorDisplay(props) {
			_classCallCheck(this, ErrorDisplay);
	
			var _this = _possibleConstructorReturn(this, (ErrorDisplay.__proto__ || Object.getPrototypeOf(ErrorDisplay)).call(this));
	
			autobind(_this);
			_this.state = {
				errorText: null, errors: null
			};
			return _this;
		}
	
		_createClass(ErrorDisplay, [{
			key: "setError",
			value: function setError(error) {
				this.setState({ errorText: error, errors: null });
			}
		}, {
			key: "setErrors",
			value: function setErrors(errors) {
				if (errors.length == 1) {
					this.setError(errors[0]);
				} else {
					this.setState({ errors: errors, errorText: null });
				}
			}
		}, {
			key: "reset",
			value: function reset(e) {
				$wr.nope(e);
				this.setState({ errorText: null, errors: null });
			}
		}, {
			key: "render",
			value: function render() {
				var errorContent, errors, closeButton;
	
				if (this.state.errorText) {
					errorContent = React.createElement(
						"span",
						null,
						this.state.errorText
					);
				} else if (this.state.errors && this.state.errors.length == 1) {
					errorContent = React.createElement(
						"span",
						null,
						this.state.errors[0]
					);
				} else if (this.state.errors) {
					errors = this.state.errors.map(function (error, i) {
						return React.createElement(
							"li",
							{ key: "error" + i },
							error
						);
					});
					errorContent = React.createElement(
						"div",
						null,
						React.createElement(
							"ul",
							{ className: "move-in" },
							errors
						)
					);
				}
	
				closeButton = React.createElement(
					"a",
					{ className: "closeLink btn-link", "aria-label": "Close", onClick: this.reset },
					React.createElement(
						"span",
						{ "aria-hidden": "true" },
						"Got it"
					)
				);
	
				if (errorContent) {
					return React.createElement(
						"div",
						{ className: "errorDisplay", role: "alert" },
						errorContent,
						closeButton
					);
				} else {
					return null;
				}
			}
		}]);
	
		return ErrorDisplay;
	}(React.Component);
	
	;
	
	ErrorDisplay.propTypes = StrictPropTypes({
		// Makes the error box less intrusive
		errorsLite: PropTypes.bool
	});
	
	module.exports = ErrorDisplay;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var StudentAvatar = __webpack_require__(35);
	var GradeLevel = __webpack_require__(40);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(654);
	
	var StudentDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var requiredRecords = {
			student: RosterSelectors.student({ state: state, id: props.studentID })
		};
	
		if (props.showAvatar) {
			requiredRecords.avatar = RosterSelectors.avatarForStudent({ state: state, studentID: props.studentID });
		}
	
		return requiredRecords;
	}, function (dispatch, props) {
		return {
			// Currently undefined, but we can do this for sure
			// populateData: () => dispatch(RosterActions.batchFetchStudent(props.studentID))
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentDisplay, _React$Component);
	
		function StudentDisplay(props) {
			_classCallCheck(this, StudentDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentDisplay.__proto__ || Object.getPrototypeOf(StudentDisplay)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentDisplay, [{
			key: "render",
			value: function render() {
				var student = this.props.student;
				var className = "studentDisplay";
	
				if (!student) {
					// Loading state
					return React.createElement(
						"div",
						{ className: className },
						"--"
					);
				}
	
				if (this.props.showAvatar && this.props.avatar) {
					className += " nameAndAvatar";
					var avatar = React.createElement(StudentAvatar, { student: student, avatar: this.props.avatar,
						disableAnimation: true,
						maxHeight: this.props.avatarMaxHeight,
						maxWidth: this.props.avatarMaxWidth });
				}
	
				if (!this.props.hideName) {
					// if (student.demo_for_teacher) {
					// 	var demoDisplay = (<span> (Demo)</span>);
					// }
	
					if (this.props.firstNameLastInitial) {
						var name = student.first_name_last_initial;
					} else {
						var name = student.display_name;
					}
				}
	
				return React.createElement(
					"div",
					{ className: className },
					avatar,
					React.createElement(
						"span",
						{ className: "textContent" },
						React.createElement(
							"span",
							{ className: "name" },
							$wr.truncate(name, 20)
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				// this.props.populateData();
			}
		}]);
	
		return StudentDisplay;
	}(React.Component)) || _class);
	
	
	StudentDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the student to be displayed
		studentID: PropTypes.number.isRequired,
	
		// If set, it will put an avatar (on the left)
		showAvatar: PropTypes.bool,
	
		// Usually I don't like to have "hide" props, but almost always we want to show the name
		hideName: PropTypes.bool,
	
		// If set, it will only show the first name, last initial (if set on student)
		firstNameLastInitial: PropTypes.bool,
	
		// Dimension on the avatar
		avatarMaxWidth: PropTypes.number,
		avatarMaxHeight: PropTypes.number,
	
		// From @connect
		student: PropTypes.object,
		avatar: PropTypes.object
		// populateData: PropTypes.func.isRequired
	
	});
	
	module.exports = StudentDisplay;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _PLAN_CONFIG;
	
	exports.name = name;
	exports.nameToKey = nameToKey;
	exports.displayName = displayName;
	exports.increaseType = increaseType;
	exports.pricingSummary = pricingSummary;
	exports.price = price;
	exports.perClassPrice = perClassPrice;
	exports.fixedPrice = fixedPrice;
	exports.tieredPrice = tieredPrice;
	exports.calculateTieredPrice = calculateTieredPrice;
	exports.itemizedQuote = itemizedQuote;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STARTER_PLAN = exports.STARTER_PLAN = "starter_plan";
	var GOLD_PLAN = exports.GOLD_PLAN = "gold_annual";
	var GOLD_SEMESTER_PLAN = exports.GOLD_SEMESTER_PLAN = "gold_semester";
	
	var SILVER_PLAN_2019 = exports.SILVER_PLAN_2019 = "silver_annual_2019";
	var SILVER_SEMESTER_PLAN_2019 = exports.SILVER_SEMESTER_PLAN_2019 = "silver_semester_2019";
	
	var RLD_ONLY_SEMESTER = exports.RLD_ONLY_SEMESTER = "rld_semester";
	var RLD_ONLY_ANNUAL = exports.RLD_ONLY_ANNUAL = "rld_annual";
	
	// Old plans
	var SILVER_PLAN = exports.SILVER_PLAN = "silver_annual";
	var SILVER_SEMESTER_PLAN = exports.SILVER_SEMESTER_PLAN = "silver_semester";
	
	var PAID_PLANS = exports.PAID_PLANS = [GOLD_PLAN, GOLD_SEMESTER_PLAN, SILVER_PLAN_2019, SILVER_SEMESTER_PLAN_2019];
	var PAID_ANNUAL_PLANS = exports.PAID_ANNUAL_PLANS = [GOLD_PLAN, SILVER_PLAN_2019];
	
	var PLAN_CONFIG = (_PLAN_CONFIG = {}, _defineProperty(_PLAN_CONFIG, STARTER_PLAN, {
		name: "Starter",
		increase_type: "silver"
	}), _defineProperty(_PLAN_CONFIG, GOLD_PLAN, {
		name: "Gold",
		per_student_list_price: 22500,
		increase_type: "gold"
	}), _defineProperty(_PLAN_CONFIG, GOLD_SEMESTER_PLAN, {
		name: "Gold (6 Months)",
		per_student_list_price: 13500,
		increase_type: "gold",
		semester: true
	}), _defineProperty(_PLAN_CONFIG, SILVER_PLAN_2019, {
		name: "Silver",
		fixed_price: 11500,
		per_student_list_price: 5000,
		increase_type: "silver"
	}), _defineProperty(_PLAN_CONFIG, SILVER_SEMESTER_PLAN_2019, {
		name: "Silver (6 Months)",
		fixed_price: 7000,
		per_student_list_price: 3000,
		increase_type: "silver",
		semester: true
	}), _defineProperty(_PLAN_CONFIG, RLD_ONLY_ANNUAL, {
		name: "RLD Only"
	}), _defineProperty(_PLAN_CONFIG, RLD_ONLY_SEMESTER, {
		name: "RLD Only (6 Months)",
		semester: true
	}), _defineProperty(_PLAN_CONFIG, SILVER_PLAN, {
		name: "Silver (Legacy)",
		fixed_price: 12500,
		per_student_list_price: 2500,
		increase_type: "silver"
	}), _defineProperty(_PLAN_CONFIG, SILVER_SEMESTER_PLAN, {
		name: "Silver (6 Months, Legacy)",
		fixed_price: 7500,
		per_student_list_price: 1500,
		increase_type: "silver",
		semester: true
	}), _PLAN_CONFIG);
	
	PLAN_CONFIG[GOLD_PLAN].class_pricing_tiers = [{ price: 22500, min: 1, max: 4 }, { price: 17500, min: 5, max: 9 }, { price: 15000, min: 10, max: 19 }, { price: 11500, min: 20, max: 149 }, { price: 8500, min: 150, max: 9999 }];
	
	PLAN_CONFIG[GOLD_SEMESTER_PLAN].class_pricing_tiers = PLAN_CONFIG[GOLD_PLAN].class_pricing_tiers.map(function (tier) {
		var price = tier.price * 0.6;
		// handle ugly prices (2022 price changes)
		if (price == 6900) {
			price = 7000;
		}
		if (price == 5100) {
			price = 5000;
		}
		return _.extend({}, tier, { price: price });
	});
	
	var RLD_ANNUAL_CLASS_PRICING_TIERS = [{ price: 6000, min: 1, max: 15 }, { price: 5000, min: 16, max: 50 }, { price: 3500, min: 51, max: 9999 }];
	var RLD_SEMESTER_CLASS_PRICING_TIERS = RLD_ANNUAL_CLASS_PRICING_TIERS.map(function (tier) {
		return _.extend({}, tier, { price: tier.price * 0.6 });
	});
	
	function name(plan) {
		if (PLAN_CONFIG[plan]) {
			return PLAN_CONFIG[plan].name;
		}
	}
	
	function nameToKey(name) {
		var matchKey;
		_.find(PLAN_CONFIG, function (config, plan) {
			if (config.name == name) {
				matchKey = plan;
				return true;
			}
		});
		return matchKey;
	}
	// display name from plan_type attribute saved in db
	function displayName(plan) {
		switch (plan) {
			case 'gold_annual':
				return 'Gold';
				break;
			case 'gold_semester':
				return 'Gold(6 Months)';
				break;
			case 'silver_annual_2019':
				return 'Silver';
				break;
			case 'silver_semester_2019':
				return 'Silver(6 Months)';
				break;
			case 'gold_annual-trial':
				return 'Trial: Gold';
				break;
			case 'silver_anunual-trial':
				return 'Trial: Silver';
				break;
		}
	}
	
	function increaseType(plan) {
		if (PLAN_CONFIG[plan]) {
			return PLAN_CONFIG[plan].increase_type;
		}
	}
	
	function pricingSummary(plan) {
		if (PLAN_CONFIG[plan]) {
	
			if (PLAN_CONFIG[plan].semester) {
				// Make sure period is clearly spelled out elsewhere
				var perText = "";
			} else {
				var perText = "/year";
			}
			var marginalCost = PLAN_CONFIG[plan].per_student_list_price;
			var fixedCost = PLAN_CONFIG[plan].fixed_price;
	
			if (fixedCost && marginalCost) {
				return $wr.centsToDollars(fixedCost + marginalCost, true) + perText + ", +" + $wr.centsToDollars(marginalCost, true) + "/class" + perText;
			} else if (marginalCost) {
				return $wr.centsToDollars(marginalCost, true) + "/class" + perText;
			} else if (fixedCost) {
				return $wr.centsToDollars(fixedCost, true) + perText;
			}
		}
	}
	
	function price(plan, studentListCount) {
		if (PLAN_CONFIG[plan]) {
			var marginalCost = PLAN_CONFIG[plan].per_student_list_price || 0;
			var fixedCost = PLAN_CONFIG[plan].fixed_price || 0;
			return fixedCost + marginalCost * studentListCount;
		}
	}
	
	function perClassPrice(plan) {
		if (PLAN_CONFIG[plan]) {
			return PLAN_CONFIG[plan].per_student_list_price || 0;
		}
	}
	
	function fixedPrice(plan) {
		if (PLAN_CONFIG[plan]) {
			return PLAN_CONFIG[plan].fixed_price || 0;
		}
	}
	
	function tieredPrice(_ref) {
		var plan = _ref.plan,
		    studentListCount = _ref.studentListCount,
		    teacherCount = _ref.teacherCount,
		    withRLDs = _ref.withRLDs,
		    discount = _ref.discount;
	
		if (PLAN_CONFIG[plan]) {
			var lineItems = itemizedQuote({ plan: plan, studentListCount: studentListCount, teacherCount: teacherCount, withRLDs: withRLDs, discount: discount });
			return _.reduce(lineItems, function (memo, item) {
				return memo + item.total_price;
			}, 0);
		}
	}
	
	function calculateTieredPrice(_ref2) {
		var plan = _ref2.plan,
		    tiers = _ref2.tiers,
		    count = _ref2.count,
		    subject = _ref2.subject,
		    singular = _ref2.singular,
		    plural = _ref2.plural;
	
		var remaining = count;
		var lines = [];
	
		_.each(tiers, function (tier) {
			var range = 1 + tier.max - tier.min;
	
			var tierTotal, count, description;
	
			if (remaining >= range) {
				tierTotal = range * tier.price;
				remaining -= range;
				count = range;
			} else if (remaining > 0) {
				tierTotal = remaining * tier.price;
				count = remaining;
				remaining = 0;
			}
	
			if (count && count > 0) {
				if (count == 1) {
					description = $wr.getOrdinal(tier.min) + " " + singular;
				} else if (tier.min == 1) {
					description = "First " + $wr.pluralizeWithNumber(singular, count, plural);
				} else {
					description = $wr.getOrdinal(tier.min) + " to " + $wr.getOrdinal(tier.min + count - 1) + " " + plural;
				}
	
				lines.push({
					plan: plan, count: count, description: description, subject: subject,
					unit_price: tier.price, total_price: tierTotal
				});
			}
		});
	
		return lines;
	}
	
	function itemizedQuote(_ref3) {
		var plan = _ref3.plan,
		    studentListCount = _ref3.studentListCount,
		    teacherCount = _ref3.teacherCount,
		    withRLDs = _ref3.withRLDs,
		    discount = _ref3.discount,
		    discountReason = _ref3.discountReason;
	
		var config = PLAN_CONFIG[plan];
		var lines = [];
		if (config) {
			if (config.fixed_price) {
				lines.push({
					plan: plan, subject: TEACHERS_SUBJECT, count: teacherCount,
					unit_price: config.fixed_price, total_price: config.fixed_price * teacherCount
				});
			}
			if (config.class_pricing_tiers) {
				lines = lines.concat(calculateTieredPrice({
					plan: plan,
					tiers: config.class_pricing_tiers,
					count: studentListCount,
					subject: CLASSES_SUBJECT,
					singular: "class",
					plural: "classes"
				}));
			} else if (config.per_student_list_price) {
				lines.push({
					plan: plan, subject: CLASSES_SUBJECT, count: studentListCount,
					unit_price: config.per_student_list_price,
					total_price: config.per_student_list_price * studentListCount
				});
			}
		}
	
		if (withRLDs) {
			var tiers = config.semester ? RLD_SEMESTER_CLASS_PRICING_TIERS : RLD_ANNUAL_CLASS_PRICING_TIERS;
			lines = lines.concat(calculateTieredPrice({
				plan: plan,
				tiers: tiers,
				count: studentListCount,
				subject: RLD_SUBJECT,
				singular: "class",
				plural: "classes"
			}));
		}
	
		if (discount) {
			lines.push({
				plan: plan, subject: DISCOUNT_SUBJECT, count: 1,
				unit_price: -1 * discount, total_price: -1 * discount,
				description: discountReason
			});
		}
	
		return lines;
	}
	
	// Estimate subjects
	var TEACHERS_SUBJECT = "teachers";
	var CLASSES_SUBJECT = "classes";
	var DISCOUNT_SUBJECT = "discount";
	var RLD_SUBJECT = "rlds";
	
	var PRODUCTS = exports.PRODUCTS = {
		WR_SOLO: "wrSolo",
		WR_SILVER: "wrSilver",
		WR_GOLD: "wrGold"
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getDistrictExportDataF = exports.getExportDataF = exports.dashboardOtherMetrics = exports.expectationsMetrics = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.report = report;
	exports.isLoadingReport = isLoadingReport;
	exports.digests = digests;
	exports.digestsByOrg = digestsByOrg;
	exports.isLoadingDigests = isLoadingDigests;
	exports.widgetDigests = widgetDigests;
	exports.isLoadingWidgetDigests = isLoadingWidgetDigests;
	exports.surveyPrompts = surveyPrompts;
	exports.surveyPrompt = surveyPrompt;
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SelectorUtility = __webpack_require__(144);
	var Queries = __webpack_require__(109);
	var OrgTypes = __webpack_require__(45);
	var StudentMetrics = __webpack_require__(29);
	
	var CurrentUser = __webpack_require__(3);
	var OrgTypes = __webpack_require__(45);
	var StudentMetrics = __webpack_require__(29);
	var RosterSelectors = __webpack_require__(6);
	var ReadingSelectors = __webpack_require__(21);
	var ReadingLevelFormat = __webpack_require__(72);
	var WritingSelectors = __webpack_require__(14);
	
	function report(_ref) {
		var state = _ref.state,
		    query = _ref.query;
	
		var params = _underscore2.default.extend({}, query);
		var reportKey = $wr.sortedJSON(_underscore2.default.omit(params, "report_lock"));
	
		return state.reports[reportKey];
	}
	
	function isLoadingReport(_ref2) {
		var state = _ref2.state,
		    query = _ref2.query;
	
		var params = _underscore2.default.extend({}, query);
		var reportKey = $wr.sortedJSON(_underscore2.default.omit(params, "report_lock"));
	
		return state.reports.loading[reportKey];
	}
	
	function digests(_ref3) {
		var state = _ref3.state,
		    filters = _ref3.filters,
		    conditions = _ref3.conditions;
	
		return SelectorUtility.filterBy(state.digests, filters, conditions);
	}
	
	function digestsByOrg(_ref4) {
		var state = _ref4.state,
		    filters = _ref4.filters,
		    conditions = _ref4.conditions,
		    orgType = _ref4.orgType;
	
		var dgs = digests({ state: state, filters: filters, conditions: conditions });
		if (!dgs.length) {
			return [];
		}
	
		if (orgType == OrgTypes.STUDENT_LIST) {
			var orgs = RosterSelectors.studentLists({ state: state });
		} else if (orgType == OrgTypes.SCHOOL_ORG) {
			var orgs = RosterSelectors.schoolOrgs({ state: state });
		}
	
		return orgs.map(function (org) {
			if (orgType == OrgTypes.STUDENT_LIST || orgType == OrgTypes.SCHOOL_ORG) {
				var orgIdentifier = OrgTypes.toIdentifier({ type: orgType, key: org.id });
			}
	
			var ssIDs = _underscore2.default.pluck(RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier }), "id");
	
			var out = {
				start_date: dgs[0].start_date,
				end_date: dgs[0].end_date,
				org_identifier: orgIdentifier
			};
	
			dgs.filter(function (x) {
				return ssIDs.includes(x.student_id);
			}).forEach(function (digest) {
				_underscore2.default.each(digest, function (val, key) {
					var metric = StudentMetrics.inverseLookup(key);
	
					if (StudentMetrics.isMetric(metric) && StudentMetrics.getType(metric) == "numeric") {
						if (out[key] === undefined) {
							out[key] = 0;
						}
						out[key] += val;
					}
				});
			});
	
			return out;
		});
	}
	
	function isLoadingDigests(_ref5) {
		var state = _ref5.state,
		    key = _ref5.key,
		    userIDs = _ref5.userIDs;
	
		// TODO: standardize FE requests
		// for large requests, return true if any digests are in state
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			var digestInState = _underscore2.default.some(_underscore2.default.keys(state.digests), function (key) {
				return state.digests[key].student_id !== undefined;
			});
			if (digestInState) {
				return false;
			}
		}
	
		key = key || "index";
		return state.digests.loading[key];
	}
	
	// This function calculates the expectations metrics based on the provided parameters.
	var expectationsMetrics = exports.expectationsMetrics = function expectationsMetrics(_ref6) {
		var state = _ref6.state,
		    student_list_ids = _ref6.student_list_ids,
		    student_ids = _ref6.student_ids;
	
		if (student_list_ids) {
			// If student_list_ids is provided, filter the state.studentLists array based on the matching IDs
			var studentLists = _underscore2.default.filter(state.studentLists, function (sl) {
				return _underscore2.default.includes(student_list_ids, sl.id);
			}); // Include only student lists with matching IDs
	
			// Calculate and return the unique expectations metrics for the selected student lists
			return _underscore2.default.uniq(_underscore2.default.flatten(_underscore2.default.values(studentLists).map(function (x) {
				// Get the grade level expectations metrics for the student list's grade level, or an empty array if not available
				var metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
				// Map the metrics to only extract the metric values
				return metrics.map(function (x) {
					return x.metric;
				});
			})));
		} else if (student_ids) {
			// If student_ids is provided, filter the state.students array to include only students with matching IDs
			var students = _underscore2.default.filter(state.students, function (s) {
				return _underscore2.default.includes(student_ids, s.id);
			});
	
			// If there are matching students, calculate and return the unique expectations metrics
			if (!_underscore2.default.isEmpty(students)) {
				// Flatten the expectations metrics arrays, remove duplicates, and return the unique metrics
				return _underscore2.default.uniq(_underscore2.default.flatten(_underscore2.default.values(students).map(function (x) {
					// Get the grade level expectations metrics for the student's grade level, or an empty array if not available
					var metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
					// Map the metrics to only extract the metric values
					return metrics.map(function (x) {
						return x.metric;
					});
				})));
			}
		} else {
			// If neither student_list_ids nor student_ids is provided, calculate and return the unique expectations metrics for all student lists
			return _underscore2.default.uniq(_underscore2.default.flatten(_underscore2.default.values(state.studentLists).map(function (x) {
				// Get the grade level expectations metrics for the student list's grade level, or an empty array if not available
				var metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
				// Map the metrics to only extract the metric values
				return metrics.map(function (x) {
					return x.metric;
				});
			})));
		}
	};
	
	var dashboardOtherMetrics = exports.dashboardOtherMetrics = function dashboardOtherMetrics(_ref7) {
		var state = _ref7.state,
		    count = _ref7.count,
		    aggregate = _ref7.aggregate;
	
		var count = count || 3;
		var cols = CurrentUser.get().prefs.dashboard_columns;
	
		if (aggregate) {
			cols = _underscore2.default.intersection(cols, StudentMetrics.aggregateMetrics()).concat(StudentMetrics.aggregateMetrics());
		} else {
			cols = cols.concat(StudentMetrics.DEFAULT_COLUMNS);
		}
		return _underscore2.default.first(_underscore2.default.uniq(cols), count);
	};
	
	var getExportDataF = exports.getExportDataF = function getExportDataF(_ref8) {
		var state = _ref8.state;
	
		return function (_ref9) {
			var type = _ref9.type,
			    users = _ref9.users,
			    schools = _ref9.schools,
			    startDate = _ref9.startDate,
			    endDate = _ref9.endDate;
	
			if (type == "goals" || type == "stats" || type == "rld" || type == "all-activities" || type == "expanded-activities" || type == "teacher-picks") {
				var hasExpectations = false;
	
				var studentConditions = {};
				if (users && users.length) {
					studentConditions.ids = users;
				}
	
				var students = RosterSelectors.students({
					state: state,
					conditions: studentConditions
				});
			}
	
			if (type == "goals" || type == "stats") {
				var studentDigests = digests({
					state: state,
					filters: { start_date: startDate, end_date: endDate },
					conditions: { id: _underscore2.default.pluck(students, "id") }
				});
	
				if (type == "goals") {
					var metrics = expectationsMetrics({ state: state });
					hasExpectations = true;
				} else if (type == "stats") {
					var metrics = dashboardOtherMetrics({ state: state });
				}
	
				var headers = ["First Name", "Last Name", "Class"];
				metrics.forEach(function (x) {
					headers.push(StudentMetrics.getLabel(x));
					if (hasExpectations) {
						headers.push(StudentMetrics.getLabel(x) + " Goal");
					}
				});
				var rows = [];
	
				students.forEach(function (student) {
					var studentList = RosterSelectors.studentList({ state: state, id: student.student_list_ids.primary });
					var digest = studentDigests.find(function (x) {
						return x.student_id === student.id;
					});
					var row = {
						"First Name": student.first_name,
						"Last Name": student.last_name,
						"Class": studentList ? studentList.name : "-"
					};
	
					var dateSpans = student.expectations_date_spans || [];
					var matchTimePeriod = _underscore2.default.filter(dateSpans, function (span) {
						return span.start == startDate && span.end == endDate;
					}).length > 0;
					var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5;
					var expectationMetrics = _underscore2.default.pluck(student.prefs.grade_level_expectations_metrics[grade_level], "metric");
	
					metrics.forEach(function (metric) {
						var label = StudentMetrics.getLabel(metric);
						row[label] = StudentMetrics.getValue(digest, metric);
	
						var isExpectationForStudent = hasExpectations && matchTimePeriod && _underscore2.default.contains(expectationMetrics, metric);
	
						if (isExpectationForStudent) {
							var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5;
							var expectation = student.prefs.grade_level_expectations_metrics[grade_level].find(function (x) {
								return x.metric === metric;
							}) || {};
							row[label + " Goal"] = expectation.goal;
						}
					});
					rows.push(row);
				});
			} else if (type == "rld") {
				// headers - dates of assessment.
				var headers = ["First Name", "Last Name", "Class", "Current Reading Level"];
				var studentIDs = students.map(function (student) {
					return student.id;
				});
				var assessmentDates = ReadingSelectors.assessmentDates({
					state: state,
					conditions: { userIDs: studentIDs },
					sinceSchoolYear: true, untilPresent: true
				});
	
				assessmentDates.map(function (assessmentDate) {
					headers.push(assessmentDate);
				});
				var rows = [];
				students.map(function (student) {
					var studentList = RosterSelectors.studentList({ state: state, id: student.student_list_ids.primary });
					var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
					var readingLevel = ReadingLevelFormat.getLexileScoreForFormat(student.current_reading_level, readingLevelFormat);
					var row = {
						"First Name": student.first_name,
						"Last Name": student.last_name,
						"Class": studentList ? studentList.name : "-",
						"Current Reading Level": readingLevel
					};
					var readingLevels = ReadingSelectors.readingLevels({
						state: state,
						conditions: studentIDs
					});
					// return _.sortBy(matches, "created_at").reverse()[0];
					assessmentDates.map(function (assessmentDate) {
						var matches = _underscore2.default.where(readingLevels, { student_id: student.id, assessment_date: assessmentDate });
						if (matches.length > 0) {
							var readingLevel = ReadingLevelFormat.getLexileScoreForFormat(matches[0].reading_level, readingLevelFormat);
							row[assessmentDate] = readingLevel;
						}
					});
	
					rows.push(row);
				});
			} else if (type == "all-activities") {
				// headers - dates of assessment.
				var headers = ["First Name", "Last Name", "Class", "Assigned Exercises", "Completed Exercises", "Teacher Picks Assigned", "Teacher Picks Completed"];
				var studentIDs = students.map(function (student) {
					return student.id;
				});
	
				var tasks = WritingSelectors.tasks({
					state: state,
					conditions: { userIDs: studentIDs }
				});
	
				var rows = [];
				students.map(function (student) {
					var studentList = RosterSelectors.studentList({ state: state, id: student.student_list_ids.primary });
					var taskItems = _underscore2.default.pluck(_underscore2.default.where(tasks, { user_id: student.id, subject_type: 'exercise' }), 'task_items');
					taskItems = [].concat(_toConsumableArray(new Set(taskItems.flat())));
	
					var taskItemExercises = _underscore2.default.where(taskItems, { subject_type: 'exercise' });
					var standAloneExercises = _underscore2.default.where(tasks, { subject_type: 'exercise', user_id: student.id });
	
					var allExercises = taskItemExercises.concat(standAloneExercises);
					var row = {
						"First Name": student.first_name,
						"Last Name": student.last_name,
						"Class": studentList ? studentList.name : "-",
						"Assigned Exercises": _underscore2.default.size(allExercises),
						"Completed Exercises": _underscore2.default.size(_underscore2.default.where(allExercises, { draft: false })),
						"Assigned Teacher Picks": _underscore2.default.size(taskItemExercises),
						"Completed Teacher Picks": _underscore2.default.size(_underscore2.default.where(taskItemExercises, { draft: false }))
					};
					rows.push(row);
				});
			} else if (type == "expanded-activities") {
				// headers - dates of assessment.
				var headers = ["First Name", "Last Name", "Class", "Assigned Date", "Due Date", "Text Title", "Exercise Title", "Skill Set", "Format", "Complete"];
				var studentIDs = students.map(function (student) {
					return student.id;
				});
	
				var tasks = WritingSelectors.tasks({
					state: state,
					conditions: { userIDs: studentIDs }
				});
	
				var responses = WritingSelectors.responses({
					state: state,
					conditions: { userIDs: studentIDs }
				});
	
				var activities = WritingSelectors.activities({ state: state });
	
				var books = ReadingSelectors.books({ state: state });
	
				var rows = [];
				students.map(function (student) {
					var studentList = RosterSelectors.studentList({ state: state, id: student.student_list_ids.primary });
					var studentTasks = _underscore2.default.where(tasks, { user_id: student.id });
					var studentResponses = _underscore2.default.where(responses, { user_id: student.id });
	
					// incomplete tasks would not be pulled by responses
					var incompleteTasks = _underscore2.default.where(studentTasks, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, completed_at: null });
					var incompleteTaskItems = _underscore2.default.filter(_underscore2.default.pluck(studentTasks, 'task_items'), function (task_item) {
						if (task_item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && task_item.draft) {
							return task_item;
						}
					});
					incompleteTasks = incompleteTasks.concat(incompleteTaskItems);
					var allExercises = _underscore2.default.compact(studentResponses.concat(incompleteTasks));
	
					var allExerciseData = _underscore2.default.map(allExercises, function (item) {
						var activityData = {};
						activityData.created_at = item.created_at ? item.created_at : null;
						activityData.due_date = item.due_date ? item.due_date : null;
						activityData.text_id = item.text_id ? item.text_id : null;
						activityData.activity_id = item.activity_id ? item.activity_id : parseInt(item.subject_id);
						activityData.response_id = item.activity_id ? item.id : null;
						activityData.completed_at = item.completed_at ? item.completed_at : null;
						activityData.user_id = item.user_id ? item.user_id : null;
	
						return activityData;
					});
					_underscore2.default.each(allExerciseData, function (data) {
						var activity = _underscore2.default.findWhere(activities, { id: data.activity_id });
						var book = _underscore2.default.findWhere(books, { text_id: data.text_id });
						var row = {
							"First Name": student.first_name,
							"Last Name": student.last_name,
							"Class": studentList ? studentList.name : "-",
							"Assigned Date": data.created_at ? data.created_at : "-",
							"Due Date": data.due_date ? data.due_date : "-",
							"Text Title": book ? book.title : "-",
							"Exercise Title": activity && activity.format_summary ? activity.format_summary.title : "-",
							"Skill Set": activity && activity.format_summary ? activity.format_summary.skillset : "-",
							"Format": activity && activity.format_summary ? activity.format_summary.format_class : "-",
							"Complete": data.completed_at ? "true" : "false"
						};
						rows.push(row);
					});
				});
			} else if (type == "teacher-picks") {
				// headers - dates of assessment.
				var headers = ["First Name", "Last Name", "Class", "Assigned Date", "Due Date", "Text Title", "Quiz Score", "Exercises", "Practice Questions", "Review", "Complete"];
				var studentIDs = students.map(function (student) {
					return student.id;
				});
	
				var teacherPicks = WritingSelectors.teacherPicksTasks({
					state: state,
					conditions: { userIDs: studentIDs }
				});
				var quizzes = WritingSelectors.quizzes({ state: state });
				var books = ReadingSelectors.books({ state: state });
	
				var rows = [];
				students.map(function (student) {
					var studentList = RosterSelectors.studentList({ state: state, id: student.student_list_ids.primary });
					var studentTeacherPicks = _underscore2.default.where(teacherPicks, { user_id: student.id });
					var tearcherPicksTaskItems = _underscore2.default.pluck(studentTeacherPicks, 'task_items');
	
					_underscore2.default.each(studentTeacherPicks, function (teacherPick) {
						var book = _underscore2.default.findWhere(books, { text_id: teacherPick.subject_id });
						var taskItems = teacherPick.task_items;
	
						var quizTaskItem = _underscore2.default.find(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ });
						var evaluation = {};
						var quizScore = 0;
						if (quizTaskItem && quizTaskItem.subject_id !== null && !quizTaskItem.draft) {
							var quizMatch = _underscore2.default.find(quizzes, { id: parseInt(quizTaskItem.subject_id) });
							if (quizMatch && quizMatch.evaluation) {
								evaluation = WritingSelectors.evaluation({ state: state, id: quizMatch.evaluation });
								if (evaluation) {
									quizScore = evaluation.ratio * 4;
									quizScore = Math.floor(quizScore * 2) / 2;
								}
							}
						}
	
						var exercisesAssigned = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }));
						var exercisesCompleted = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false }));
	
						var pqsAssigned = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION }));
						var pqsCompleted = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false }));
	
						var reviewAssigned = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW }));
						var reviewCompleted = _underscore2.default.size(_underscore2.default.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false }));
	
						var row = {
							"First Name": student.first_name,
							"Last Name": student.last_name,
							"Class": studentList ? studentList.name : "-",
							"Assigned Date": teacherPick.created_at ? teacherPick.created_at : "-",
							"Due Date": teacherPick.due_date ? teacherPick.due_date : "-",
							"Text Title": book ? book.title : "-",
							"Quiz Score": quizScore && evaluation ? quizScore + "/" + 4 : "-",
							"Exercises": exercisesAssigned ? exercisesCompleted + "/" + exercisesAssigned : "-",
							"Practice Questions": pqsAssigned ? pqsCompleted + "/" + pqsAssigned : "-",
							"Review": reviewAssigned ? reviewCompleted + "/" + reviewAssigned : "-",
							"Complete": teacherPick.draft ? "true" : "false"
						};
						rows.push(row);
					});
				});
			} else {
				console.error("Unknown export type: ", type);
			}
	
			return { rows: rows, headers: headers };
		};
	};
	var getDistrictExportDataF = exports.getDistrictExportDataF = function getDistrictExportDataF(_ref10) {
		var state = _ref10.state;
	
		return function (_ref11) {
			var type = _ref11.type,
			    schools = _ref11.schools,
			    studentLists = _ref11.studentLists,
			    startDate = _ref11.startDate,
			    endDate = _ref11.endDate;
	
			if (type == ALL_SCHOOLS) {
				var metrics = dashboardOtherMetrics({ state: state, count: 4 });
				var headers = ["School", "Classes", "Students"];
				metrics.forEach(function (x) {
					headers.push(StudentMetrics.getLabel(x));
				});
				var rows = [];
	
				schools.forEach(function (school) {
					var classCount = RosterSelectors.studentLists({
						state: state,
						filters: { school_org_id: school.id }
					}).length;
	
					var digests = digestsByOrg({
						state: state,
						orgType: OrgTypes.SCHOOL_ORG,
						filters: { start_date: startDate, end_date: endDate }
					});
	
					var identifier = OrgTypes.toIdentifier({ type: OrgTypes.SCHOOL_ORG, key: school.id });
					var base = { org_identifier: identifier };
					var digest = _underscore2.default.findWhere(digests, base);
	
					var orgIdentifier = digest.org_identifier;
					var studentCount = RosterSelectors.studentsForOrgIdentifier({
						state: state, orgIdentifier: orgIdentifier
					}).length;
	
					var row = {
						"School": school.name,
						"Classes": classCount,
						"Students": studentCount
					};
	
					metrics.forEach(function (metric) {
						var label = StudentMetrics.getLabel(metric);
						row[label] = StudentMetrics.getValue(digest, metric);
					});
					rows.push(row);
				});
			} else if (type == ALL_CLASSES || type == SCHOOL) {
				var metrics = dashboardOtherMetrics({ state: state, count: 4 });
				if (type == ALL_CLASSES) {
					if (CurrentUser.isSchoolAdmin()) {
						var headers = ["Class", "Teacher", "Students", "Grade"];
					} else {
						var headers = ["Class", "School", "Students", "Grade"];
					}
				} else {
					var headers = ["Class", "Teacher", "Students", "Grade"];
				}
				metrics.forEach(function (x) {
					headers.push(StudentMetrics.getLabel(x));
				});
				var rows = [];
	
				studentLists.forEach(function (studentList) {
					var digests = digestsByOrg({
						state: state,
						orgType: OrgTypes.STUDENT_LIST,
						filters: { start_date: startDate, end_date: endDate }
					});
					var schoolOrg = RosterSelectors.schoolOrg({ state: state, id: studentList.school_org_id });
					var studentListID = studentList.id;
					var admin = RosterSelectors.primaryAdminForStudentListID({ state: state, studentListID: studentListID });
					var adminName = admin.first_name + " " + admin.last_name;
	
					var identifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: studentList.id });
					var base = { org_identifier: identifier };
					var digest = _underscore2.default.findWhere(digests, base);
	
					var orgIdentifier = digest.org_identifier;
					var studentCount = RosterSelectors.studentsForOrgIdentifier({
						state: state, orgIdentifier: orgIdentifier
					}).length;
	
					if (type == ALL_CLASSES) {
						if (schoolOrg) {
							var row = {
								"Class": studentList.name,
								"School": schoolOrg.name,
								"Students": studentCount,
								"Grade": studentList.grade_level
							};
						} else {
							var row = {
								"Class": studentList.name,
								"Teacher": adminName,
								"Students": studentCount,
								"Grade": studentList.grade_level
							};
						}
					} else {
						var headers = ["Class", "Teacher", "Students", "Grade"];
						var row = {
							"Class": studentList.name,
							"Teacher": adminName,
							"Students": studentCount,
							"Grade": studentList.grade_level
						};
					}
	
					metrics.forEach(function (metric) {
						var label = StudentMetrics.getLabel(metric);
						row[label] = StudentMetrics.getValue(digest, metric);
					});
					rows.push(row);
				});
			}
			return { rows: rows, headers: headers };
		};
	};
	
	function widgetDigests(_ref12) {
		var state = _ref12.state,
		    conditions = _ref12.conditions;
	
		return _underscore2.default.where(state.widgetDigests, _extends({}, conditions));
	}
	
	function isLoadingWidgetDigests(_ref13) {
		var state = _ref13.state,
		    key = _ref13.key;
	
		key = key || "index";
		return state.widgetDigests.loading[key];
	}
	
	function surveyPrompts(_ref14) {
		var state = _ref14.state,
		    conditions = _ref14.conditions;
	
		return _underscore2.default.where(state.surveyPrompts, _extends({}, conditions));
	}
	
	function surveyPrompt(_ref15) {
		var state = _ref15.state,
		    conditions = _ref15.conditions;
	
		return _underscore2.default.findWhere(state.surveyPrompts, _extends({}, conditions));
	}
	
	var ALL_CLASSES = "all-student-lists";
	var ALL_SCHOOLS = "all-school-orgs";
	var SCHOOL = "school-org";

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	var READING = "reading";
	var WRITING = "writing";
	var OG_READING = "og-reading";
	
	var Skillsets = {
		TYPES: {
			"ri1-key-details": {
				name: "RI1 - Key Ideas & Details - Details",
				type: READING,
				env: "underwater",
				non_fiction_only: true
			},
			"ri2-key-main": {
				name: "RI2 - Key Ideas & Details - Main Ideas",
				type: READING,
				env: "lake",
				non_fiction_only: true
			},
			"ri5-craft-structure": {
				name: "RI5 - Craft & Structure - Structure",
				type: READING,
				env: "sky",
				non_fiction_only: true
			},
			"ri6-craft-pov": {
				name: "RI6 - Craft & Structure - Points of View",
				type: READING,
				env: "tundra",
				non_fiction_only: true
			},
			"ri7-integration-media": {
				name: "RI7 - Integration of Knowledge & Ideas - Media Portrayals",
				type: READING,
				env: "farm",
				non_fiction_only: true
			},
			"ri8-integration-linear": {
				name: "RI8 - Integration of Knowledge & Ideas - Linear Reasoning",
				type: READING,
				env: "beach",
				non_fiction_only: true
			},
	
			"rl1-key-details": {
				name: "RL1 - Key Ideas & Details - Details",
				type: READING,
				env: "space",
				fiction_only: true
			},
			"rl2-key-main": {
				name: "RL2 - Key Ideas & Details - Main Ideas",
				type: READING,
				env: "city",
				fiction_only: true
			},
			"rl3-key-connections": {
				name: "RL3 - Key Ideas & Details - Connections",
				type: READING,
				env: "savannah",
				fiction_only: true
			},
			"rl5-craft-structure": {
				name: "RL5 - Craft & Structure - Structure",
				type: READING,
				env: "jungle",
				fiction_only: true
			},
			"rl6-craft-pov": {
				name: "RL6 - Craft & Structure - Points of View",
				type: READING,
				env: "mushrooms",
				fiction_only: true
			},
			"rl7-integration-media": {
				name: "RL7 - Integration of Knowledge & Ideas - Media Portrayals",
				type: READING,
				env: "desert",
				fiction_only: true
			},
	
			"pov": {
				name: "Purpose & Point of View",
				type: OG_READING,
				env: "underwater"
			},
			"developments": {
				name: "Developments & Interactions",
				type: OG_READING,
				env: "sky"
			},
			"inferences": {
				name: "Inferences",
				type: OG_READING,
				env: "tundra"
			},
			"ideas": {
				name: "Key Ideas",
				type: OG_READING,
				env: "lake"
			},
			"vocabulary": {
				name: "Vocabulary",
				type: OG_READING,
				env: "farm"
			},
			"structure": {
				name: "Text Structure",
				type: OG_READING,
				env: "beach"
			},
			"media": {
				name: "Medias & Formats",
				type: OG_READING,
				env: "space"
			},
			"arguments": {
				name: "Arguments & Evidence",
				type: OG_READING,
				env: "city",
				stems: ["nfarg"]
			},
			"connections": {
				name: "Text to Text Connections",
				type: OG_READING,
				env: "savannah"
			},
	
			"caps": {
				name: "Capitalization",
				type: WRITING,
				env: "forest"
			},
			"evidence": {
				name: "Citing Evidence",
				type: WRITING,
				env: "forest"
			},
			"org": {
				name: "Organization",
				type: WRITING,
				env: "forest"
			},
			"spelling": {
				name: "Spelling",
				type: WRITING,
				env: "forest"
			},
			"word": {
				name: "Word Use",
				type: WRITING,
				env: "forest"
			},
			"conventions": {
				name: "Writing Conventions",
				type: WRITING,
				env: "forest"
			}
	
		},
	
		// It's not really a skill set but it's sometimes treated like one:
		REVIEW: {
			name: "Book Review",
			standard: "None",
			description: "Write a book review about what you've written to share your knowledge with people who might not have read the text.",
			env: "review",
			paid: false
		},
	
		getData: function getData(skillsetKey) {
			if (skillsetKey == "review") {
				return Skillsets.REVIEW;
			} else {
				return Skillsets.TYPES[skillsetKey];
			}
		},
	
	
		getName: function getName(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.name;
			}
		},
	
		getShortName: function getShortName(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return _.last(skillset.name.split(" - "));
			}
		},
	
		getStandard: function getStandard(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.standard;
			}
		},
	
		getDescription: function getDescription(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.description;
			}
		},
	
		getIcon: function getIcon(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return dynamicRequire("skillset-icons/icon-" + skillset.env + ".png");
			}
		},
	
		getBanner: function getBanner(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if ($wr.isDevelopment()) {
				var imgBase = "http://localhost:3003";
			} else if ($wr.isProduction()) {
				var imgBase = "https://app.whooosreading.org/albus_assets";
			} else if ($wr.isStaging()) {
				var imgBase = "https://app.savvashortondev.com/albus_assets";
			}
	
			if (skillset) {
				return imgBase + "/skillset_banners/banner-" + skillset.env + ".png";
			}
		},
	
		getStems: function getStems(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.stems;
			}
		},
	
		isPaid: function isPaid(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.paid;
			}
		},
	
		hasFiction: function hasFiction(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return !skillset.non_fiction_only;
			}
		},
	
		hasNonFiction: function hasNonFiction(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return !skillset.fiction_only;
			}
		},
	
		isReading: function isReading(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.type == READING;
			}
		},
	
		isOgReading: function isOgReading(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.type == OG_READING;
			}
		},
	
		isWriting: function isWriting(skillsetKey) {
			var skillset = Skillsets.getData(skillsetKey);
			if (skillset) {
				return skillset.type == WRITING;
			}
		}
	
	};
	
	Skillsets.SKILLSET_KEYS = _.keys(Skillsets.TYPES);
	Skillsets.READING_SKILLSET_KEYS = _.select(Skillsets.SKILLSET_KEYS, Skillsets.isReading);
	
	module.exports = Skillsets;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(713);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(137);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	var api_1 = __webpack_require__(703);
	exports.API = api_1.API;
	var baseclient_1 = __webpack_require__(705);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(704);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(710);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(711);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(362);
	exports.NoopTransport = noop_1.NoopTransport;
	var Integrations = __webpack_require__(709);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function provideLocationState(locationToState) {
		return function (WrappedComponent) {
			var LocationState = function (_React$Component) {
				_inherits(LocationState, _React$Component);
	
				function LocationState() {
					_classCallCheck(this, LocationState);
	
					return _possibleConstructorReturn(this, (LocationState.__proto__ || Object.getPrototypeOf(LocationState)).apply(this, arguments));
				}
	
				_createClass(LocationState, [{
					key: "render",
					value: function render() {
						// Combine route params and url params into a single object
						if (this.props.match) {
							var params = this.props.match.params;
						} else {
							var params = {};
						}
						if (this.props.location) {
							var search = $wr.getQueryObject(this.props.location.search);
						} else {
							var search = {};
						}
	
						var locationState = _.extend({}, params, search);
						if (locationToState) {
							locationState = locationToState(locationState);
						}
						var mergedProps = _.extend({}, this.props, { locationState: locationState });
	
						return React.createElement(WrappedComponent, mergedProps);
					}
				}]);
	
				return LocationState;
			}(React.Component);
	
			LocationState.WrappedComponent = WrappedComponent;
	
			return LocationState;
		};
	}
	
	module.exports = {
		provideLocationState: provideLocationState
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(47);
	var createDesc = __webpack_require__(130);
	module.exports = __webpack_require__(42) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var hide = __webpack_require__(60);
	var has = __webpack_require__(67);
	var SRC = __webpack_require__(134)('src');
	var $toString = __webpack_require__(1046);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(76).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var fails = __webpack_require__(30);
	var defined = __webpack_require__(85);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3804);
	
	var HelpSectionLink = function HelpSectionLink(props) {
		var className = props.className || "";
		className += " helpSectionLink hideOnPrint";
		var link = "https://whooosreading.zendesk.com/hc/en-us/articles/" + props.linkSuffix;
		var linkText = "Learn more about " + props.featureName;
	
		if (props.iconOnly) {
			var linkContent = React.createElement(Glyphicon, { icon: "info-sign", dataTip: linkText });
		} else {
			var linkContent = React.createElement(
				"span",
				null,
				React.createElement(Glyphicon, { icon: "info-sign" }),
				" ",
				linkText
			);
		}
	
		return React.createElement(
			"span",
			{ className: className },
			React.createElement(
				"a",
				{ href: link, target: "_blank" },
				linkContent
			)
		);
	};
	
	HelpSectionLink.propTypes = StrictPropTypes({
		// name of feature that is linked
		featureName: PropTypes.string.isRequired,
	
		// help section article suffix from zendesk, e.g. "235179488-Add-Delete-Class-or-Student"
		linkSuffix: PropTypes.string.isRequired,
	
		// will display only the icon if set to true, default to icon and text
		iconOnly: PropTypes.bool,
	
		// optional class
		className: PropTypes.string
	
	});
	
	module.exports = HelpSectionLink;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchReport = fetchReport;
	exports.fetchQuizzes = fetchQuizzes;
	exports.fetchDigests = fetchDigests;
	exports.fetchWidgetDigests = fetchWidgetDigests;
	exports.postWidgetJobTrigger = postWidgetJobTrigger;
	exports.fetchSurveyPrompts = fetchSurveyPrompts;
	exports.createDataExport = createDataExport;
	exports.clearDataLoading = clearDataLoading;
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	var ActionUtility = __webpack_require__(95);
	var Queries = __webpack_require__(109);
	
	function fetchReport(_ref) {
		var query = _ref.query,
		    cache = _ref.cache;
	
		var params = _.extend({}, query);
		var reportKey = $wr.sortedJSON(_.omit(params, "report_lock"));
		var preSchemaF = function preSchemaF(x) {
			return x.results.report_key = reportKey;
		};
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getAnalyzeClassResults, { results: Schema.REPORT }, { params: params }, { reducer: "reports", loading: reportKey, cache: cache, preSchemaF: preSchemaF }));
		};
	}
	
	function fetchQuizzes(_ref2) {
		var filters = _ref2.filters,
		    conditions = _ref2.conditions,
		    embeds = _ref2.embeds,
		    page = _ref2.page,
		    cache = _ref2.cache;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			var pagination = { key: $wr.sortedJSON(params), page: page };
			return dispatch(ActionUtility.fetchRecords(APIClient.getQuizzes, { quizzes: [Schema.QUIZ] }, { params: params, embeds: embeds, page: page }, { reducer: "quizzes", loading: "index", cache: cache, pagination: pagination }));
		};
	}
	
	function fetchDigests(_ref3) {
		var filters = _ref3.filters,
		    conditions = _ref3.conditions,
		    cache = _ref3.cache,
		    query = _ref3.query;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			params = _.extend(params, query);
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getDigests, { digests: [Schema.DIGEST] }, { params: params }, { reducer: "digests", loading: "index", cache: cache }));
		};
	}
	
	function fetchWidgetDigests(_ref4) {
		var filters = _ref4.filters,
		    conditions = _ref4.conditions,
		    cache = _ref4.cache,
		    query = _ref4.query;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			params = _.extend(params, query);
	
			return dispatch(ActionUtility.fetchRecords(APIClient.getWidgetDigests, { widget_digests: [Schema.WIDGET_DIGEST] }, { params: params }, { reducer: "widgetDigests", loading: "index", cache: cache }));
		};
	}
	
	function postWidgetJobTrigger(params) {
		return function (dispatch) {
			return APIClient.postWidgetDigestsTrigger(params);
		};
	}
	
	function fetchSurveyPrompts(_ref5) {
		var filters = _ref5.filters,
		    conditions = _ref5.conditions,
		    cache = _ref5.cache,
		    query = _ref5.query;
	
		return function (dispatch) {
			var params = Queries.toQuery(filters, conditions);
			params = _.extend(params, query);
			return dispatch(ActionUtility.fetchRecords(APIClient.getSurveyPrompts, { survey_prompts: [Schema.SURVEY_PROMPT] }, { params: params }, { reducer: "surveyPrompt", loading: "index", cache: cache }));
		};
	}
	
	function createDataExport(_ref6) {
		var data_export = _ref6.data_export,
		    embeds = _ref6.embeds;
	
		var params = { data_export: data_export };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postDataExports, { data_export: Schema.DATA_EXPORT }, { embeds: embeds, params: params }, { reducer: "dataExports", loading: "create" }));
		};
	}
	
	function clearDataLoading() {
		return function (dispatch) {
			return Promise.all([dispatch(ActionUtility.clearLoadingRecords("books")), dispatch(ActionUtility.clearLoadingRecords("quizzes")), dispatch(ActionUtility.clearLoadingRecords("logs")), dispatch(ActionUtility.clearLoadingRecords("digests")), dispatch(ActionUtility.clearLoadingRecords("answers")), dispatch(ActionUtility.clearLoadingRecords("readingLevels")), dispatch(ActionUtility.clearLoadingRecords("widgetDigests")), dispatch(ActionUtility.clearLoadingRecords("dataExports"))]);
		};
	}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAUL_USER_DIGEST = exports.DEFAULT_TEACHER_GOAL_PROGRESS = exports.DEFAULT_WIDGET_DIGESTS = exports.WIDGET_TITLE_CONFIG = exports.DISTRICT_ORG_ENTITY_TYPE = exports.SCHOOL_ORG_ENTITY_TYPE = exports.TEACHER_ENTITY_TYPE = exports.STUDENT_LIST_ENTITY_TYPE = exports.STUDENT_ENTITY_TYPE = exports.GRAPH = exports.YEARLY = exports.PERIOD = exports.CURRENT = exports.DISTRICT_ADMIN_ROLE = exports.SCHOOL_ADMIN_ROLE = exports.TEACHER_ROLE = exports.STUDENT_ROLE = exports.WRITING_WIDGET = exports.BOOK_WIDGET = exports.GOALS_WIDGET = exports.QUIZ_WIDGET = undefined;
	
	var _WIDGET_TITLE_CONFIG;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isPassing = isPassing;
	exports.getWidgetItemsConfig = getWidgetItemsConfig;
	exports.getEntityTypeByUserRole = getEntityTypeByUserRole;
	exports.buildCurrentMetricLink = buildCurrentMetricLink;
	exports.buildTimePeriodLink = buildTimePeriodLink;
	exports.buildStudentDataLink = buildStudentDataLink;
	exports.buildLink = buildLink;
	exports.showEmptyState = showEmptyState;
	exports.renderWidgetItems = renderWidgetItems;
	exports.renderStudentGoalWidgetItems = renderStudentGoalWidgetItems;
	exports.renderTeacherGoalWidgetItems = renderTeacherGoalWidgetItems;
	exports.renderAdminGoalWidgetItems = renderAdminGoalWidgetItems;
	exports.renderWidgetTitle = renderWidgetTitle;
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LexileGradeLevelLookup = __webpack_require__(3529);
	
	var WidgetItem = __webpack_require__(774);
	var WidgetTitle = __webpack_require__(385);
	var WidgetItemsConfig = __webpack_require__(260);
	
	//////////// CONSTANTS ////////////
	var QUIZ_WIDGET = exports.QUIZ_WIDGET = "quiz_widget";
	var GOALS_WIDGET = exports.GOALS_WIDGET = "goals_widget";
	var BOOK_WIDGET = exports.BOOK_WIDGET = "book_widget";
	var WRITING_WIDGET = exports.WRITING_WIDGET = "writing_widget";
	
	var STUDENT_ROLE = exports.STUDENT_ROLE = 'studentRole';
	var TEACHER_ROLE = exports.TEACHER_ROLE = 'teacherRole';
	var SCHOOL_ADMIN_ROLE = exports.SCHOOL_ADMIN_ROLE = 'adminRole';
	var DISTRICT_ADMIN_ROLE = exports.DISTRICT_ADMIN_ROLE = 'districtAdminRole';
	
	var CURRENT = exports.CURRENT = 'current';
	var PERIOD = exports.PERIOD = 'period';
	var YEARLY = exports.YEARLY = 'yearly';
	var GRAPH = exports.GRAPH = 'graph';
	
	var STUDENT_ENTITY_TYPE = exports.STUDENT_ENTITY_TYPE = 'student';
	var STUDENT_LIST_ENTITY_TYPE = exports.STUDENT_LIST_ENTITY_TYPE = 'student_list';
	var TEACHER_ENTITY_TYPE = exports.TEACHER_ENTITY_TYPE = 'teacher';
	var SCHOOL_ORG_ENTITY_TYPE = exports.SCHOOL_ORG_ENTITY_TYPE = 'school_org';
	var DISTRICT_ORG_ENTITY_TYPE = exports.DISTRICT_ORG_ENTITY_TYPE = 'district_org';
	
	var STUDENT = 'Student';
	var ADMIN = 'Admin';
	//////////////////////////////////
	
	/////// QUIZ SCORE HELPERS ///////
	
	// determins color of score based on teacher prefs
	function isPassing(evaluation, passingThreshold) {
	  var ratio = evaluation.ratio;
	  var threshold = passingThreshold;
	  return ratio >= threshold;
	}
	//////////////////////////////////
	
	////////// DATE HELPERS //////////
	function formatDateString(date) {
	  var dd = String(date.getDate()).padStart(2, '0');
	  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
	  var yyyy = date.getFullYear();
	
	  return yyyy + '-' + mm + '-' + dd;
	}
	
	function todaysDate() {
	  var today = new Date();
	  return formatDateString(today);
	}
	
	function yesterdaysDate() {
	  var yesterday = new Date();
	  yesterday.setDate(yesterday.getDate() - 1);
	  return formatDateString(yesterday);
	}
	//////////////////////////////////
	
	////////// GOALS HELPERS /////////
	
	// returns list of widget lookup and digest keys
	// based on what's in the user's digest
	function getGoalsFromUserDigest(userDigest) {
	  return _underscore2.default.first(_underscore2.default.compact(_underscore2.default.map(_underscore2.default.keys(userDigest), function (digest_key) {
	    var widget_key = WidgetItemsConfig.GOAL_TO_WIDGET_KEY[digest_key];
	    return widget_key ? { digest_key: digest_key, widget_key: widget_key } : null;
	  })), 4);
	}
	
	// outputs font color for a single student goal based on 
	// progress and today's date relative to goal start and end dates
	function goalProgressColor(startDate, endDate, progress) {
	  var start = new Date(startDate);
	  var end = new Date(endDate);
	  var today = new Date();
	
	  var pct = Math.abs(today - start) / Math.abs(end - start);
	
	  if (progress >= 1) {
	    var color = 'green'; // student has completed goal
	  } else if (progress >= pct) {
	    var color = 'yellow';
	  } else {
	    var color = 'red';
	  }
	
	  return color;
	}
	
	// dynamically change width of goal widget items
	// based on number of goals
	function getGoalsWidth(numGoals) {
	  if (numGoals == 4) {
	    return 25;
	  }
	  if (numGoals == 3) {
	    return 33;
	  }
	  if (numGoals <= 2) {
	    return 50;
	  }
	}
	
	// returns progress overview for teachers
	function getStudentGoalProgress(userDigests) {
	  var _totalProgress;
	
	  var totalProgress = (_totalProgress = {}, _defineProperty(_totalProgress, WidgetItemsConfig.GOALS_COMPLETE, { count: 0, userIDs: [] }), _defineProperty(_totalProgress, WidgetItemsConfig.GOALS_ON_PACE, { count: 0, userIDs: [] }), _defineProperty(_totalProgress, WidgetItemsConfig.GOALS_BEHIND, { count: 0, userIDs: [] }), _totalProgress);
	
	  var idx = 0;
	  _underscore2.default.each(userDigests, function (digest) {
	    // for each goals, calculate if the student is on pace, behind, or has completed
	    var goalsBehind = 0;
	    var goalsOnPace = 0;
	    var goalsCompleted = 0;
	
	    var goals = getGoalsFromUserDigest(digest);
	    _underscore2.default.each(goals, function (goal) {
	      var expectation = digest[goal.digest_key + "_expectation"];
	      var completed = digest[goal.digest_key];
	      var goalBenchmark = getPaceBenchmark(digest.start_date, digest.end_date, expectation);
	
	      if (completed >= expectation) {
	        goalsCompleted += 1;
	      } else if (completed >= goalBenchmark) {
	        goalsOnPace += 1;
	      } else {
	        goalsBehind += 1;
	      }
	    });
	
	    // categorize each student will as either complete, on-pace, or behind
	    // userIDs will be kept track for linking purposes
	    var studentBenchmark = getPaceBenchmark(digest.start_date, digest.end_date, _underscore2.default.size(goals));
	    if (goalsCompleted == _underscore2.default.size(goals)) {
	      totalProgress[WidgetItemsConfig.GOALS_COMPLETE]['count'] += 1;
	      totalProgress[WidgetItemsConfig.GOALS_COMPLETE]['userIDs'].push(digest.student_id);
	    } else if (goalsCompleted + goalsOnPace >= studentBenchmark) {
	      totalProgress[WidgetItemsConfig.GOALS_ON_PACE]['count'] += 1;
	      totalProgress[WidgetItemsConfig.GOALS_ON_PACE]['userIDs'].push(digest.student_id);
	    } else {
	      totalProgress[WidgetItemsConfig.GOALS_BEHIND]['count'] += 1;
	      totalProgress[WidgetItemsConfig.GOALS_BEHIND]['userIDs'].push(digest.student_id);
	    }
	
	    idx += 1;
	  });
	
	  if (idx == _underscore2.default.size(userDigests)) {
	    return totalProgress;
	  }
	}
	
	// returns the on-pace value of where a goal should be
	// if a student was perfectly on pace to finish
	function getPaceBenchmark(startDate, endDate, goal) {
	  var start = new Date(startDate);
	  var end = new Date(endDate);
	  var today = new Date();
	
	  var pct = Math.abs(today - start) / Math.abs(end - start);
	  return Math.round(goal * pct);
	}
	
	// pluralizes and gives subject for goals title
	function buildAdminDashboardGoalsTitle(metric, item) {
	  var plural = metric != 1;
	  var subject = plural ? 'students' : 'student';
	
	  if (item == WidgetItemsConfig.GOALS_COMPLETE) {
	    return subject + " " + (plural ? 'have' : 'has') + " completed all goals";
	  } else if (item == WidgetItemsConfig.GOALS_ON_PACE) {
	    return subject + " " + (plural ? 'are' : 'is') + " on pace to complete all goals";
	  } else if (item == WidgetItemsConfig.GOALS_BEHIND) {
	    return subject + " " + (plural ? 'are' : 'is') + " behind pace to complete all goals";
	  }
	}
	
	// pluralized goals title
	function buildDataStudentDigestGoalsTitle(progress, title) {
	  return progress == 1 ? title.replace('goals', 'goal') : title;
	}
	//////////////////////////////////
	
	////////// METRICS ///////////////
	
	// adds commas if needed
	function formatNumberString(statText) {
	  if (statText) {
	    return statText.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	  }
	}
	
	// VERY IMPORTANT FUNCTION
	// it outputs a hash that contains all information that the FE needs to display primary metric
	function calculatePrimaryMetric(digests, metricName, rangeMax, comp) {
	  if (_underscore2.default.isEmpty(digests)) {
	    return null;
	  }
	  // for average metrics, we need to take average of all digest values
	  if (_underscore2.default.includes(WidgetItemsConfig.AVERAGE_METRICS, metricName)) {
	    var totalMetric = 0;
	    _underscore2.default.each(digests, function (digest) {
	      totalMetric += digest[metricName];
	    });
	    var metric = totalMetric / _underscore2.default.size(digests);
	  } else {
	    // for total metrics, sum up the specific metric from all digets supplied
	    var metric = _underscore2.default.pluck(digests, metricName).reduce(function (partialSum, a) {
	      return partialSum + a;
	    }, 0);
	    metric = isNaN(metric) || metric < 0 ? 0 : metric;
	  }
	
	  return formatPrimaryMetric(metric, rangeMax, comp);
	}
	
	// VERY IMPORTANT FUNCTION AGAIN
	// this outputs the text of the metric as well as information about it's color and size
	function formatPrimaryMetric(metric, rangeMax, comp) {
	  var shared = { metric: metric
	
	    // if we have a comparison, the stat color will be determined by how the current
	    // user is doing relative to their comp benchmark
	  };if (comp) {
	    if (comp.success_below_comp) {
	      var statColor = Math.round(10 * metric) / 10 <= Math.round(10 * comp.metric) / 10 ? 'green' : 'red';
	    } else {
	      var statColor = Math.round(10 * metric) / 10 >= Math.round(10 * comp.metric) / 10 ? 'green' : 'red';
	    }
	    metric = Math.round(metric * 10) / 10;
	    shared = _extends({}, shared, { statColor: statColor });
	  }
	
	  // if the metric is just a word, no further calculation is needed
	  if (typeof metric == 'string') {
	    return _extends({}, shared, { statText: metric, 'statSize': 'medium' });
	  }
	
	  // prevent metric texts from getting too long and breaking the styling
	  var statText = metric > rangeMax ? formatNumberString(String(rangeMax)) + "+" : formatNumberString(String(metric));
	
	  // statSize is used in CSS to style the text and icons on a widget item
	  if (String(metric).length > 6) {
	    return _extends({}, shared, { statText: statText, 'statSize': 'x-large' });
	  }
	  if (String(metric).length > 3) {
	    return _extends({}, shared, { statText: statText, 'statSize': 'large' });
	  }
	  if (String(metric).length == 3) {
	    return _extends({}, shared, { statText: statText, 'statSize': 'medium' });
	  }
	  if (String(metric).length == 2) {
	    return _extends({}, shared, { statText: statText, 'statSize': 'small' });
	  }
	  if (String(metric).length == 1) {
	    return _extends({}, shared, { statText: statText, 'statSize': 'x-small' });
	  }
	}
	
	// the secondary metric (including comparisons and time periods)
	function formatSecondaryMetric(metricName, digests, user, comp) {
	  // if there is a comparison, return the scope and the metric
	  if (comp && !isNaN(comp.metric)) {
	    return comp.scope + " Avg: " + comp.metric;
	  }
	
	  if (!metricName) {
	    return null;
	  }
	
	  // handle last active
	  if (metricName == 'last_active') {
	    return 'since last visit';
	  }
	
	  // handle determine time period based on expectations
	  if (metricName == 'time_period') {
	    if (_underscore2.default.first(digests).period == 'yearly') {
	      return 'this year';
	    } else if (_underscore2.default.first(digests).period == 'current') {
	      return 'past 24 hours';
	    } else if (user.prefs && user.prefs.expectations_time_period) {
	      return "this " + user.prefs.expectations_time_period;
	    } else {
	      return 'this grading period';
	    }
	  }
	
	  // if (metricName == 'goals_time_period') { return `this ${digests.goals_time_period}` }
	}
	//////////////////////////////////
	
	//////// COMPARISONS /////////////
	
	// returns hash of comparison metrics
	function getComparison(metric, compDigests, compSize, scope) {
	  // sum up specific metric in all compDigests
	  var compMetric = _underscore2.default.pluck(compDigests, metric).reduce(function (partialSum, a) {
	    return partialSum + a;
	  }, 0);
	  // compSize is the size of all digests if dealing with average metric
	  compSize = _underscore2.default.includes(WidgetItemsConfig.AVERAGE_METRICS, metric) ? _underscore2.default.size(compDigests) : compSize;
	  // average quiz score is handled differently for rounding purposes
	  if (metric == 'average_quiz_score') {
	    var avg = Math.round(compMetric / compSize * 10) / 10;
	  } else {
	    var avg = Math.round(compMetric / compSize);
	  }
	
	  return { scope: scope, metric: avg, success_below_comp: _underscore2.default.includes(WidgetItemsConfig.SUCCESS_BELOW_COMP, metric) };
	}
	//////////////////////////////////
	
	//////// WIDGET ITEM DATA ////////
	// gives list of widget items in order
	function getWidgetItemsConfig(userRole) {
	  switch (userRole) {
	    case DISTRICT_ADMIN_ROLE:
	      return WidgetItemsConfig.districtAdminDigestMetrics;
	    case SCHOOL_ADMIN_ROLE:
	      return WidgetItemsConfig.schoolAdminDigestMetrics;
	    case TEACHER_ROLE:
	      return WidgetItemsConfig.teacherDigestMetrics;
	    default:
	      return WidgetItemsConfig.studentDigestMetrics;
	  }
	}
	// gives widget item data based on user role
	function getWidgetItemData(userRole, widgetType) {
	  switch (userRole) {
	    case DISTRICT_ADMIN_ROLE:
	      return extractWidgetItems(WidgetItemsConfig.districtAdminDigestMetrics, widgetType);
	    case SCHOOL_ADMIN_ROLE:
	      return extractWidgetItems(WidgetItemsConfig.schoolAdminDigestMetrics, widgetType);
	    case TEACHER_ROLE:
	      return extractWidgetItems(WidgetItemsConfig.teacherDigestMetrics, widgetType);
	    default:
	      return extractWidgetItems(WidgetItemsConfig.studentDigestMetrics, widgetType);
	  }
	}
	
	// logic to extract order of widget items
	// also sends information about width of snapshot item
	function extractWidgetItems(widgets, widgetName) {
	  var items = _underscore2.default.map(widgets, function (widget) {
	    var key = _underscore2.default.first(_underscore2.default.keys(widget));
	    if (key == widgetName) {
	      return widget[key];
	    }
	  });
	
	  var items = _underscore2.default.first(_underscore2.default.without(items, undefined));
	  var width = Math.round(_underscore2.default.size(items) >= 4 ? 25 : 100 / _underscore2.default.size(items));
	
	  return { items: items, width: width };
	}
	//////////////////////////////////
	
	////////// LEXILE LEVEL //////////
	function getAverageLexileLevel(user, digests) {
	  // get total lexile of all digests
	  var totalLexile = _underscore2.default.pluck(digests, 'average_lexile_level').reduce(function (partialSum, a) {
	    return partialSum + a;
	  }, 0);
	  // average metrics and roud to nearest 50
	  var avgLexile = String(Math.round(totalLexile / _underscore2.default.size(digests) / 50) * 50);
	  // lookup academic level and change color accordingly
	  if (user.prefs && user.prefs.academic_level) {
	    var userAcademicLevel = user.prefs.academic_level;
	    var gradeLevelForLexile = parseInt(LexileGradeLevelLookup[avgLexile]);
	    var LexileForGradeLevel = getKeyByValue(LexileGradeLevelLookup, String(userAcademicLevel));
	    var statColor = gradeLevelForLexile >= userAcademicLevel ? 'green' : 'red';
	  } else {
	    var statColor = 'black';
	  }
	  return { LexileForGradeLevel: formatNumberString(LexileForGradeLevel), metric: avgLexile, statColor: statColor, statText: formatNumberString(avgLexile), statSize: 'medium' };
	}
	
	function getKeyByValue(object, value) {
	  return Object.keys(object).find(function (key) {
	    return object[key] === value;
	  });
	}
	
	//////////////////////////////////
	
	////////// USER HELPERS //////////
	function getEntityTypeByUserRole(role) {
	  switch (role) {
	    case STUDENT_ROLE:
	      return STUDENT_ENTITY_TYPE;
	    case TEACHER_ROLE:
	      return TEACHER_ENTITY_TYPE;
	    case SCHOOL_ADMIN_ROLE:
	      return SCHOOL_ORG_ENTITY_TYPE;
	    case DISTRICT_ADMIN_ROLE:
	      return DISTRICT_ORG_ENTITY_TYPE;
	  }
	}
	//////////////////////////////////
	
	///////// LINK BUILDERS /////////
	function buildCurrentMetricLink(base) {
	  return base + "&start_date=" + yesterdaysDate() + "&end_date=" + todaysDate();
	}
	
	function buildTimePeriodLink(base, digest) {
	  var start = formatDateString(new Date(digest.start_date));
	  var end = formatDateString(new Date(digest.end_date));
	
	  return base + "&start_date=" + start + "&end_date=" + end;
	}
	
	function buildStudentDataLink(userID, filters, subject, digest) {
	  var start = formatDateString(new Date(digest.start_date));
	  var end = formatDateString(new Date(digest.end_date));
	  var filters = !_underscore2.default.isEmpty(filters) ? filters.join('&') + "&" : '';
	
	  return "/data/" + userID + "/" + subject + "?" + filters + "start_date=" + start + "&end_date=" + end;
	}
	
	function buildLink(base, digest) {
	  var period = digest.period;
	
	  if (period == CURRENT) {
	    return buildCurrentMetricLink(base);
	  } else {
	    return buildTimePeriodLink(base, digest);
	  }
	}
	//////////////////////////////////
	
	/////// EMPTY STATE HELPER ///////
	
	// determine if empty state should show
	function showEmptyState(widgetDigests) {
	  // create array of data hashes from digests
	  var widgetDigestData = _underscore2.default.pluck(widgetDigests, 'data');
	
	  // sums values of all keys that we want to check on the dashboards
	  // all must be 0 to show empty state
	  var checkValues = _underscore2.default.map(widgetDigestData, function (dataHash) {
	    return _underscore2.default.filter(dataHash, function (val, key) {
	      return _underscore2.default.includes(WidgetItemsConfig.NON_GOAL_METRICS, key);
	    }).reduce(function (partialSum, a) {
	      return partialSum + a;
	    }, 0);
	  });
	
	  if (_underscore2.default.isEmpty(widgetDigestData)) {
	    // if widget digests don't exist, show empty state
	    return true;
	  } else if (!_underscore2.default.any(checkValues, function (metric) {
	    return metric > 0;
	  })) {
	    // if all metrics are 0, show empty state
	    return true;
	  } else {
	    return false;
	  }
	}
	//////////////////////////////////
	
	////// RENDER WIDGET ITEMS //////
	
	// VERY IMPORTANT FUNCTION
	// handles most of the rendering of widgets
	function renderWidgetItems(props, widgetSubject, linkBuilder, emptyState) {
	  var user = props.user,
	      compSize = props.compSize,
	      compScope = props.compScope,
	      currentWidgetDigests = props.currentWidgetDigests,
	      periodWidgetDigests = props.periodWidgetDigests,
	      compWidgetDigests = props.compWidgetDigests,
	      yearlyWidgetDigests = props.yearlyWidgetDigests;
	
	  // user default if period digest doesn't exist
	
	  periodWidgetDigests = _underscore2.default.isEmpty(periodWidgetDigests) ? DEFAULT_WIDGET_DIGESTS : periodWidgetDigests;
	
	  // get widget items and order
	  var config = user.role == STUDENT_ROLE ? WidgetItemsConfig.CONFIG[STUDENT] : WidgetItemsConfig.CONFIG[ADMIN];
	  var widgetItemData = getWidgetItemData(user.role, widgetSubject);
	
	  // loop through widget items
	  return _underscore2.default.map(widgetItemData.items, function (item, index) {
	    // get configuation for specific widget item
	    var itemConfig = _extends({}, _underscore2.default.findWhere(config, { lookup_key: item }));
	
	    if (emptyState) {
	      var digests = DEFAULT_WIDGET_DIGESTS;
	    } else if (itemConfig.current_metric && !_underscore2.default.isEmpty(currentWidgetDigests)) {
	      var digests = currentWidgetDigests; // use curentWidgetDigests for current metrics
	    } else if (itemConfig.yearly_metric && !_underscore2.default.isEmpty(yearlyWidgetDigests)) {
	      var digests = yearlyWidgetDigests; // use yearlyWidgetDigests for yearly metrics
	    } else {
	      var digests = periodWidgetDigests; // default, and in most cases, user period
	    }
	
	    // if widget item config requires a comparison, calculate that
	    if (itemConfig.show_comparison && !_underscore2.default.isEmpty(compWidgetDigests)) {
	      var comp = getComparison(itemConfig.primary_metric, _underscore2.default.pluck(compWidgetDigests, 'data'), compSize, compScope);
	    }
	
	    // some widget items need special rendering that wouldn't fit in this function
	    // otherwise, use the calculatePrimaryMetric and formatSecondaryMetric functions
	    if (_underscore2.default.includes(WidgetItemsConfig.SPECIAL_RENDERING, item)) {
	      itemConfig = handleSpecialRendering(itemConfig, digests, user, comp, compSize);
	    } else {
	      itemConfig.primaryMetric = calculatePrimaryMetric(_underscore2.default.pluck(digests, 'data'), itemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp);
	      itemConfig.secondaryMetric = formatSecondaryMetric(itemConfig.secondary_metric, digests, user, comp);
	    }
	
	    // pluralize title
	    itemConfig.title = itemConfig.primaryMetric.metric == 1 ? itemConfig.singular_title : itemConfig.title;
	
	    // update link based on config properties
	    itemConfig.link = linkBuilder(digests[0], itemConfig, itemConfig.primary_metric);
	
	    // annoying little line to add the divider wall between widget items
	    var showDividerColumn = index != 4 && _underscore2.default.size(widgetItemData.items) > index + 1;
	
	    return React.createElement(WidgetItem, _extends({}, itemConfig, {
	      key: itemConfig.title,
	      width: widgetItemData.width,
	      dividerColumn: showDividerColumn,
	      sideScroll: false // used if we have more than 4 items in a row
	    }));
	  });
	}
	
	function handleSpecialRendering(itemConfig, digests, user, comp) {
	  var newItemConfig = _extends({}, itemConfig);
	
	  switch (newItemConfig.primary_metric) {
	    // average quiz score needs the score to be converted before displaing
	    case WidgetItemsConfig.AVERAGE_QUIZ_SCORE:
	      var primaryMetric = calculatePrimaryMetric(_underscore2.default.pluck(digests, 'data'), newItemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp);
	      var studentConvertedScore = $wr.convertedScore(primaryMetric.metric, user.prefs.displayScoreCap || 4);
	
	      newItemConfig.primaryMetric = _extends({}, _underscore2.default.omit(primaryMetric, ['statText', 'metric', 'statSize']), {
	        statText: studentConvertedScore,
	        metric: studentConvertedScore,
	        statSize: 'medium'
	      });
	
	      if (comp) {
	        comp.metric = $wr.convertedScore(comp.metric, user.prefs.displayScoreCap || 4);
	        newItemConfig.secondaryMetric = formatSecondaryMetric(newItemConfig.secondary_metric, digests, user, comp);
	      }
	
	      return newItemConfig;
	
	    // minutes logged are going to need a larger maxRange value
	    case WidgetItemsConfig.MINUTES_LOGGED:
	      newItemConfig.primaryMetric = calculatePrimaryMetric(_underscore2.default.pluck(digests, 'data'), newItemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp);
	      newItemConfig.secondaryMetric = formatSecondaryMetric(newItemConfig.secondary_metric, digests, user, comp);
	      return newItemConfig;
	
	    // average lexile level needs to be calculated separately
	    case WidgetItemsConfig.AVERAGE_LEXILE_LEVEL:
	      var avgLexile = getAverageLexileLevel(user, _underscore2.default.pluck(digests, 'data'));
	      newItemConfig.primaryMetric = avgLexile;
	
	      if (user.role == STUDENT_ROLE) {
	        newItemConfig.secondaryMetric = "Grade Avg: " + avgLexile.LexileForGradeLevel;
	      }
	
	      return newItemConfig;
	  }
	}
	
	function renderStudentGoalWidgetItems(user, userDigest, showEmptyState) {
	  if (_underscore2.default.isEmpty(userDigest)) {
	    return null;
	  }
	
	  userDigest = showEmptyState ? DEFAUL_USER_DIGEST : userDigest;
	
	  if (userDigest) {
	    var goalKeys = getGoalsFromUserDigest(userDigest);
	    var width = getGoalsWidth(_underscore2.default.size(goalKeys));
	    // loop through goal keys
	    return _underscore2.default.map(goalKeys, function (gKey, index) {
	      // find widget item config for goal
	      var itemConfig = _extends({}, _underscore2.default.findWhere(WidgetItemsConfig.CONFIG[STUDENT], { lookup_key: gKey.widget_key }));
	      itemConfig.primaryMetric = formatPrimaryMetric(userDigest[gKey.digest_key], 100);
	      // get goal progress from userDigest
	      var goalProgress = userDigest[gKey.digest_key] / userDigest[gKey.digest_key + "_expectation"];
	      itemConfig.primaryMetric.statColor = goalProgressColor(userDigest['start_date'], userDigest['end_date'], goalProgress);
	      itemConfig.title = buildDataStudentDigestGoalsTitle(userDigest[gKey.digest_key], itemConfig.title);
	
	      // build link based on widget item config
	      var _itemConfig$link = itemConfig.link,
	          text = _itemConfig$link.text,
	          filters = _itemConfig$link.filters,
	          subject = _itemConfig$link.subject;
	
	      itemConfig.link = {
	        text: text,
	        location: buildStudentDataLink(user.id, filters, subject, userDigest)
	      };
	
	      var showDividerColumn = index != 4 && _underscore2.default.size(goalKeys) > index + 1;
	
	      return React.createElement(WidgetItem, _extends({}, itemConfig, {
	        key: itemConfig.title,
	        width: width,
	        dividerColumn: showDividerColumn,
	        sideScroll: false // used if we have more than 4 items in a row
	      }));
	    });
	  }
	}
	
	function renderTeacherGoalWidgetItems(user, userDigests, showEmptyState) {
	  if (_underscore2.default.isEmpty(userDigests) && !showEmptyState) {
	    return null;
	  }
	  // get widget items and order
	  var widgetItemData = getWidgetItemData(user.role, GOALS_WIDGET);
	
	  // gets goal progress
	  var progress = showEmptyState ? DEFAULT_TEACHER_GOAL_PROGRESS : getStudentGoalProgress(userDigests);
	  return _underscore2.default.map(widgetItemData.items, function (item, index) {
	    // config for specific widget item
	    var itemConfig = _extends({}, _underscore2.default.findWhere(WidgetItemsConfig.CONFIG[ADMIN], { lookup_key: item }));
	
	    itemConfig.primaryMetric = formatPrimaryMetric(progress[item]['count'], DEFAULT_MAX_STAT_RANGE);
	    itemConfig.primaryMetric.statColor = itemConfig.font_color;
	    itemConfig.title = buildAdminDashboardGoalsTitle(itemConfig.primaryMetric.metric, item);
	
	    // build link based on widget item and userIDs retruned by getStudentGoalProgress
	    if (itemConfig.primaryMetric.metric > 0 && userDigests.length > 0) {
	      var startDate = userDigests[0].start_date;
	      var endDate = userDigests[0].end_date;
	      itemConfig.link = {
	        text: 'View', location: "/data/" + progress[item]['userIDs'].join('-') + "/goals?start_date=" + startDate + "&end_date=" + endDate
	      };
	    }
	
	    var showDividerColumn = index != 4 && _underscore2.default.size(widgetItemData.items) > index + 1;
	
	    return React.createElement(WidgetItem, _extends({}, itemConfig, {
	      key: itemConfig.title,
	      width: widgetItemData.width,
	      dividerColumn: showDividerColumn,
	      sideScroll: false // used if we have more than 4 items in a row
	    }));
	  });
	}
	
	function renderAdminGoalWidgetItems(user, currentWidgetDigests, showEmptyState) {
	  // return null if current widget digest hasn't been created yet
	  if (!showEmptyState && _underscore2.default.isEmpty(currentWidgetDigests)) {
	    return null;
	  }
	
	  // use empty state if no widget digests exists
	  currentWidgetDigests = showEmptyState ? DEFAULT_WIDGET_DIGESTS : currentWidgetDigests;
	
	  // get widget item names and order
	  var widgetItemData = getWidgetItemData(user.role, GOALS_WIDGET);
	
	  return _underscore2.default.map(widgetItemData.items, function (item, index) {
	    // get config basedon widget item name
	    var itemConfig = _extends({}, _underscore2.default.findWhere(WidgetItemsConfig.CONFIG[ADMIN], { lookup_key: item }));
	
	    // get primary and secondary metric
	    itemConfig.primaryMetric = calculatePrimaryMetric(_underscore2.default.pluck(currentWidgetDigests, 'data'), itemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE);
	    itemConfig.title = buildAdminDashboardGoalsTitle(itemConfig.primaryMetric.metric, item);
	    itemConfig.primaryMetric.statColor = itemConfig.font_color;
	    itemConfig.secondaryMetric = itemConfig.secondary_metric ? formatSecondaryMetric(itemConfig.secondary_metric, currentWidgetDigests, user) : "";
	
	    // link to gaols page
	    if (itemConfig.primaryMetric && itemConfig.primaryMetric.metric > 0) {
	      itemConfig.link = {
	        text: 'View Goals', location: "/data/goals"
	      };
	    }
	
	    var showDividerColumn = index != 4 && _underscore2.default.size(widgetItemData.items) > index + 1;
	
	    return React.createElement(WidgetItem, _extends({}, itemConfig, {
	      key: itemConfig.title,
	      width: widgetItemData.width,
	      dividerColumn: showDividerColumn,
	      sideScroll: false // used if we have more than 4 items in a row
	    }));
	  });
	}
	
	function renderWidgetTitle(widget) {
	  return React.createElement(WidgetTitle, { config: WIDGET_TITLE_CONFIG[widget] });
	}
	//////////////////////////////////
	
	////// WIDGET TITLE CONFIG //////
	var WIDGET_TITLE_CONFIG = exports.WIDGET_TITLE_CONFIG = (_WIDGET_TITLE_CONFIG = {}, _defineProperty(_WIDGET_TITLE_CONFIG, QUIZ_WIDGET, {
	  icon: 'settings-gears-white',
	  title: 'Quizzes'
	}), _defineProperty(_WIDGET_TITLE_CONFIG, GOALS_WIDGET, {
	  icon: 'magnifier-white',
	  title: 'Goals'
	}), _defineProperty(_WIDGET_TITLE_CONFIG, BOOK_WIDGET, {
	  icon: 'open-book-white',
	  title: 'Books'
	}), _defineProperty(_WIDGET_TITLE_CONFIG, WRITING_WIDGET, {
	  icon: 'writing-white',
	  title: 'Writing'
	}), _WIDGET_TITLE_CONFIG);
	
	//////////////////////////////////
	
	////// DEFAULT WIDGET DIGEST //////
	// used when widget digests 
	// haven't been created
	var DEFAULT_WIDGET_DIGESTS = exports.DEFAULT_WIDGET_DIGESTS = [{
	  "start_date": yesterdaysDate(),
	  "end_date": todaysDate(),
	  "data": {
	    "days_active": 30,
	    "pages_logged": 500,
	    "total_quizzes": 20,
	    "total_reviews": 10,
	    "failed_quizzes": 5,
	    "minutes_logged": 600,
	    "flagged_books": 2,
	    "uniq_book_count": 15,
	    "flagged_quizzes": 2,
	    "total_with_lexile": 0,
	    "average_quiz_score": .71,
	    "average_lexile_level": 1000,
	    "excercises_completed": 5,
	    "total_question_builders": 3,
	    "total_practice_questions": 10,
	    "students_complete": 10,
	    "students_on_pace": 20,
	    "students_behind": 5
	  },
	  "current_period": false
	}];
	
	var DEFAULT_TEACHER_GOAL_PROGRESS = exports.DEFAULT_TEACHER_GOAL_PROGRESS = {
	  students_behind: { count: 2, userIDs: [] },
	  students_complete: { count: 4, userIDs: [] },
	  students_on_pace: { count: 7, userIDs: [] }
	};
	
	var DEFAUL_USER_DIGEST = exports.DEFAUL_USER_DIGEST = {
	  answers_count: 3,
	  answers_count_expectation: 4,
	  quiz_passed_count: 1,
	  quiz_passed_count_expectation: 1,
	  reviews_count: 1,
	  reviews_count_expectation: 4
	};
	
	var DEFAULT_MAX_STAT_RANGE = 1000000;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(181);
	var createDesc = __webpack_require__(130);
	var toIObject = __webpack_require__(70);
	var toPrimitive = __webpack_require__(87);
	var has = __webpack_require__(67);
	var IE8_DOM_DEFINE = __webpack_require__(456);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(67);
	var toObject = __webpack_require__(50);
	var IE_PROTO = __webpack_require__(280)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(180);
	var defined = __webpack_require__(85);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var StudentDisplay = __webpack_require__(52);
	__webpack_require__(3648);
	
	var NoActivityBlock = function NoActivityBlock(props) {
		var students = _.map(props.userIDs, function (userID) {
			return React.createElement(
				"div",
				{ key: userID },
				React.createElement(StudentDisplay, { studentID: userID, showAvatar: true, avatarMaxWidth: 40 })
			);
		});
		var header = '';
		if (!props.hideHeader) {
			header = React.createElement(
				"p",
				{ className: "noActivityHeader" },
				"No ",
				props.contentType
			);
		}
		return React.createElement(
			"div",
			{ className: "hideOnPrint noActivityBlock" },
			header,
			students
		);
	};
	
	NoActivityBlock.propTypes = StrictPropTypes({
		studentID: PropTypes.number,
		contentType: PropTypes.string,
		userIDs: PropTypes.array
	});
	
	module.exports = NoActivityBlock;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	var ReadingLevelFormat = {
		getMaxLexileValue: function getMaxLexileValue(format) {
			var keys = _.keys(ReadingLevelFormat.LEXILE_TO_FORMATS[format]).filter(function (k) {
				return parseInt(k);
			});
			return parseInt(keys[keys.length - 1]);
		},
		getMinLexileValue: function getMinLexileValue(format) {
			var keys = _.keys(ReadingLevelFormat.LEXILE_TO_FORMATS[format]).filter(function (k) {
				return parseInt(k);
			});
			return parseInt(keys[0]);
		},
		getScoreForFormat: function getScoreForFormat(lexile_score, format) {
			if (lexile_score == null) {
				var scoreNormal = this.getMinLexileValue(format);
				return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
			}
			if (format == "Lexile Level") {
				return lexile_score.toString() + "L";
			} else {
				if (lexile_score.toString() in ReadingLevelFormat.LEXILE_TO_FORMATS[format]) {
					return ReadingLevelFormat.LEXILE_TO_FORMATS[format][lexile_score.toString()];
				}
				var maxLexileValue = this.getMaxLexileValue(format);
				if (lexile_score < maxLexileValue) {
					var scoreNormal = Math.round(lexile_score / ReadingLevelFormat.POINTS_PER_STEP) * ReadingLevelFormat.POINTS_PER_STEP;
				} else {
					var scoreNormal = maxLexileValue;
				}
				return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
			}
		},
		getLexileScoreForFormat: function getLexileScoreForFormat(lexile_score, format) {
			if (lexile_score == null) {
				var scoreNormal = this.getMinLexileValue(format);
				return ReadingLevelFormat.LEXILE_TO_FORMATS[format][scoreNormal.toString()];
			}
			if (format == "Lexile Level") {
				return (Math.round(parseInt(lexile_score) / 5) * 5).toString();
			} else {
				if (lexile_score.toString() in ReadingLevelFormat.LEXILE_TO_FORMATS[format]) {
					return lexile_score.toString();
				}
				var maxLexileValue = this.getMaxLexileValue(format);
				if (lexile_score < maxLexileValue) {
					var scoreNormal = Math.round(lexile_score / ReadingLevelFormat.POINTS_PER_STEP) * ReadingLevelFormat.POINTS_PER_STEP;
				} else {
					var scoreNormal = maxLexileValue;
				}
				return scoreNormal.toString();
			}
		},
		lexileForGrade: function lexileForGrade(gradelevel) {
			if (gradelevel < 1) {
				gradelevel = 1;
			} else if (gradelevel > 12) {
				gradelevel = 12;
			}
	
			return ReadingLevelFormat.GRADE_LEVEL_TO_LEXILE[gradelevel];
		},
		getShortName: function getShortName(format) {
			return ReadingLevelFormat.FORMAT_TO_SHORT_NAME[format] || format;
		},
		getOriginName: function getOriginName(origin) {
			return ReadingLevelFormat.ORIGINS[origin];
		},
	
	
		MAX_LEXILE: 2200,
		POINTS_PER_STEP: 50,
	
		LEXILE_TO_FORMATS: {
			"Lexile Level": { "BR": "BR", "0": "0", "50": "50", "100": "100", "150": "150", "200": "200", "250": "250", "300": "300", "350": "350", "400": "400", "450": "450", "500": "500", "550": "550", "600": "600", "650": "650", "700": "700", "750": "750", "800": "800", "850": "850", "900": "900", "950": "950", "1000": "1000", "1050": "1050", "1100": "1100", "1150": "1150", "1200": "1200", "1220": "1220" },
			"Grade": { "BR": "Pre-K", "0": "K", "25": "K", "50": "1.1", "75": "1.2", "100": "1.2", "125": "1.3", "150": "1.3", "175": "1.4", "200": "1.5", "225": "1.6", "250": "1.6", "275": "1.7", "300": "1.8", "325": "1.9", "350": "2", "375": "2.1", "400": "2.1", "425": "2.3", "450": "2.5", "475": "2.6", "500": "2.7", "525": "2.9", "550": "3", "575": "3.2", "600": "3.3", "625": "3.5", "650": "3.7", "675": "3.9", "700": "4.1", "725": "4.3", "750": "4.5", "775": "4.7", "800": "5", "825": "5.2", "850": "5.5", "875": "5.8", "900": "6", "925": "6.4", "950": "6.7", "975": "7", "1000": "7.4", "1025": "7.8", "1050": "8.2", "1075": "8.6", "1100": "9", "1125": "9.5", "1150": "10", "1175": "10.5", "1200": "11", "1225": "11.6", "1250": "12.2", "1275": "12.8", "1300": "13.5" },
			"Ages": { "BR": "N/A", "0": "4 - 6", "50": "4 - 7", "100": "6 - 7", "150": "6 - 7", "200": "6 - 7", "250": "6 - 8", "300": "7 - 8", "350": "7 - 8", "400": "7 - 8", "450": "7 - 8", "500": "7 - 9", "550": "8 - 9", "600": "8 - 9", "650": "8 - 9", "700": "8 - 11", "750": "9 - 11", "800": "9 - 11", "850": "9 - 11", "900": "10 - 12", "950": "10 - 12", "1000": "12 - 13", "1050": "13 - 15" },
			"Reading Recovery": { "BR": "N/A", "0": "A - B - 1", "50": "2 - 4", "100": "5 - 6", "150": "7 - 8", "200": "10 - 11", "250": "11 - 12", "300": "13 - 14", "350": "15 - 16", "400": "17 - 18", "450": "19 - 20", "500": "20", "550": "22", "600": "22", "650": "22", "700": "24", "750": "26", "800": "28", "850": "28", "900": "30", "950": "30", "1000": "32", "1050": "34" },
			"DRA": { "BR": "N/A", "0": "A - 1", "25": "A-2", "50": "2", "75": "4", "100": "4", "125": "6", "150": "8", "175": "8", "200": "10", "225": "12", "250": "14", "275": "14", "300": "14", "325": "16", "350": "16", "375": "16", "400": "18", "425": "20", "450": "20", "475": "20", "500": "24", "525": "28", "550": "28", "575": "28", "600": "30", "625": "34", "650": "36", "675": "38", "700": "38", "725": "38", "750": "40", "775": "42", "800": "50", "900": "60", "1000": "70", "1050": "80" },
			"Rigby Literacy Levels": { "BR": "N/A", "0": "1 - 2", "50": "3 - 6", "100": "7", "150": "8 - 9", "200": "10 - 11", "250": "12", "300": "12", "350": "13", "400": "14 - 16", "450": "17", "500": "18", "550": "18", "600": "19", "650": "20" },
			"Rigby PM": { "BR": "N/A", "0": "Starters 1", "50": "2 - 6", "100": "7-8 yellow", "150": "9-10 blue", "200": "13-14 green", "250": "17 turquoise", "300": "18 turquoise", "350": "19-20 purple", "400": "21 gold", "450": "22 gold", "500": "23 silver", "550": "23 silver", "600": "24 silver", "650": "25 emerald", "700": "26 emerald", "750": "27 ruby", "800": "29 sapphire", "850": "30 sapphire" },
			"Reading A-Z Level": { "BR": "N/A", "0": "aa - A", "50": "B - D", "100": "E", "150": "F - G", "200": "G - H", "250": "I - J", "300": "K", "350": "L", "400": "M - N", "450": "O - P", "500": "Q", "550": "R", "600": "S", "650": "T", "700": "U - V", "750": "W", "800": "X - Y", "850": "Z" },
			"Fountas & Pinnell": { "BR": "N/A", "0": "A", "25": "A-B", "50": "C", "75": "C", "100": "D", "125": "E", "150": "E", "175": "F", "200": "F", "225": "F", "250": "G", "275": "G", "300": "H", "325": "I", "350": "I", "375": "I", "400": "J", "425": "J", "450": "K", "475": "K", "500": "L", "525": "L", "550": "M", "575": "M", "600": "N", "625": "O", "650": "O", "675": "P", "700": "Q", "725": "Q", "750": "R", "775": "S", "800": "T", "825": "U", "850": "U", "875": "V", "900": "W", "925": "X", "950": "Y", "975": "Y", "1000": "Z", "1025": "Z", "1050": "Z", "1075": "Z", "1100": "Z", "1125": "Z", "1150": "Z", "1175": "Z", "1200": "Z", "1225": "Z", "1250": "Z", "1275": "Z", "1300": "Z" }
		},
	
		ORIGINS: {
			"TR": "Latest Diagnostic",
			"manual": "Manually Entered",
			"grade-level": "Grade Level Default"
		},
	
		FORMAT_TO_SHORT_NAME: {
			"Lexile Level": "Lexile",
			"Grade": "Grade",
			"Ages": "Ages",
			"Reading Recovery": "RR",
			"DRA": "DRA",
			"Rigby Literacy Levels": "Rigby Lit",
			"Rigby PM": "Rigby PM",
			"Reading A-Z Level": "RAZ",
			"Fountas & Pinnell": "F&P"
		},
	
		GRADE_LEVEL_TO_LEXILE: {
			1: 150,
			2: 350,
			3: 575,
			4: 800,
			5: 925,
			6: 1000,
			7: 1075,
			8: 1150,
			9: 1200,
			10: 1250,
			11: 1275,
			12: 1275
		}
	
	};
	
	module.exports = ReadingLevelFormat;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var FeedbackFormatter = {
		format: function format(feedbackItem, dynamicData) {
	
			var transformedText = FeedbackFormatter.insertDynamicData(this.determineText(feedbackItem), dynamicData);
	
			// Split out the large paragraphs
			var paragraphs = transformedText.split("\n\n");
	
			return _.map(paragraphs, function (text, index) {
	
				var paragraphStyle = {};
	
				if (text.startsWith(">>")) {
					paragraphStyle["paddingLeft"] = 10;
					paragraphStyle["fontStyle"] = "italic";
					paragraphStyle["borderLeft"] = "solid 1px #ddd";
					text = text.substring(2);
				}
	
				// Split up line results within paragraph
				var lines = text.split("\n");
				var paragraphContent = [];
	
				_.each(lines, function (line, index) {
					var lineContent = FeedbackFormatter.formatHelper(line);
					if (index > 0) {
						paragraphContent.push(React.createElement(
							"span",
							null,
							" ",
							React.createElement("br", { key: "br-" + index })
						));
					}
					paragraphContent.push(React.createElement(
						"span",
						{ key: "line-" + index },
						lineContent
					));
				}.bind(this));
	
				return React.createElement(
					"p",
					{ key: index, style: paragraphStyle },
					paragraphContent,
					" "
				);
			}.bind(this));
		},
	
		formatSimple: function formatSimple(text, dynamicData) {
			if (dynamicData) {
				var text = FeedbackFormatter.insertDynamicData(this.determineText(text), dynamicData);
			}
			return FeedbackFormatter.formatHelper(text);
		},
		insertDynamicData: function insertDynamicData(text, dynamicData) {
			text = this.determineText(text) || "";
	
			if (dynamicData === undefined) {
				dynamicData = FeedbackFormatter.DEFAULT_SUBS;
			}
	
			if (dynamicData.firstName !== undefined) {
				text = text.replace(/\$NAME/g, dynamicData.firstName);
			}
	
			if (dynamicData.bookTitle !== undefined) {
				text = text.replace(/\$BOOK-TITLE/g, dynamicData.bookTitle);
			}
	
			if (dynamicData.textVariety !== undefined) {
				var varietyChoiceRegex = /\$TEXT-VARIETY\([\w\| ]*\)/;
				var varietyChoiceIndex = dynamicData.textVariety == "fiction" ? 0 : 1;
	
				text = FeedbackFormatter.substituteChoices(text, varietyChoiceRegex, varietyChoiceIndex);
			}
	
			return text;
		},
		formatHelper: function formatHelper(text, contentList) {
			text = this.determineText(text);
			var contentList = [];
	
			var bestFormatting = undefined;
			var bestMatch = undefined;
	
			for (var i = 0; i < FeedbackFormatter.FORMAT_DETAILS.length; i += 1) {
				var formattingDetails = FeedbackFormatter.FORMAT_DETAILS[i];
				var regex = new RegExp(formattingDetails.pattern);
	
				var match = regex.exec(text);
				if (match && (bestMatch == undefined || match.index < bestMatch.index)) {
					bestFormatting = formattingDetails;
					bestMatch = match;
				}
			}
	
			if (bestFormatting) {
				if (bestMatch.index > 0) {
					// Add the text that comes before the formattingmatch
					contentList.push(React.createElement(
						"span",
						{ key: contentList.length },
						text.substring(0, bestMatch.index)
					));
				}
	
				var matchContent = bestMatch[0];
				if (bestFormatting.handler) {
					var formattedMatchContents = bestFormatting.handler(matchContent);
				} else if (bestFormatting.style) {
					// Add the inner contents of the match, after applying formatting & recursing
					var stripRegex = new RegExp(bestFormatting.stripChar, "g");
					var cleanText = matchContent.replace(stripRegex, "");
					var formattedMatchContents = FeedbackFormatter.formatHelper(cleanText);
				}
				contentList.push(React.createElement(
					"span",
					{ key: contentList.length, style: bestFormatting.style },
					formattedMatchContents
				));
	
				var nextIndex = bestMatch.index + matchContent.length;
				if (nextIndex < text.length) {
					// Add text that comes after the match, recursing to apply additional formatting
					var afterContent = text.substring(nextIndex);
					var formattedAfterContents = FeedbackFormatter.formatHelper(afterContent);
					contentList.push(React.createElement(
						"span",
						{ key: contentList.length },
						formattedAfterContents
					));
				}
			} else {
				// Add the content with no formatting
				contentList.push(React.createElement(
					"span",
					{ key: contentList.length },
					text
				));
			}
	
			return contentList;
		},
		formatLink: function formatLink(linkText) {
			var linkParks = linkText.split(/[\(\|\)]/g);
			if (linkParks[0] == "BUTTON") {
				var linkClassName = "btn buttonPrimary";
			}
			return React.createElement(
				"a",
				{ href: linkParks[2], className: linkClassName, target: "_blank" },
				linkParks[1]
			);
		},
		substituteChoices: function substituteChoices(text, regex, choiceIndex) {
			text = this.determineText(text);
			var match = text.match(regex);
			if (text.match(regex)) {
				var matchContent = match[0];
				var pluralOptions = matchContent.split("(")[1].split(")")[0].split("|");
	
				var newText = text.replace(regex, pluralOptions[choiceIndex]);
	
				return FeedbackFormatter.substituteChoices(newText, regex, choiceIndex);
			} else {
				return text;
			}
		},
	
		// if text is an object due to recent changes in ag feedback (7/2021)
		// extract the feedback text
		determineText: function determineText(text) {
			if ((typeof text === "undefined" ? "undefined" : _typeof(text)) === 'object' && text.content) {
				return _.first(text.content);
			} else {
				return text;
			}
		}
	};
	
	FeedbackFormatter.FORMAT_DETAILS = [{ name: "link", pattern: "(LINK|BUTTON)\\([^\\(\\)\\|]*\\|[^\\(\\)\\|]*\\)", handler: FeedbackFormatter.formatLink }, { name: "underline", pattern: "_[^_]+_", stripChar: "_", style: { textDecoration: "underline" } }, { name: "bold", pattern: "\\*[^\\*]+\\*", stripChar: "\\*", style: { fontWeight: "bold" } }, { name: "italic", pattern: "\\/[^\\/]+\\/", stripChar: "\\/", style: { fontStyle: "italic" } }];
	
	FeedbackFormatter.DEFAULT_SUBS = {
		firstName: "Javon",
		textVariety: "fiction",
		bookTitle: "A Super Fake Book"
	};
	
	module.exports = FeedbackFormatter;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/my";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		} else {
			fullPath += "/" + VIEWS.SHELF_VIEW;
		}
	
		if (state.detailsView) {
			fullPath += "/" + state.detailsView;
			if (state.textID) {
				fullPath += "/" + state.textID;
			}
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		state.activeView = params.active_view;
		state.detailsView = params.details_view;
		state.textID = params.text_id;
	
		return state;
	}
	
	var VIEWS = exports.VIEWS = {
		SHELF_VIEW: "shelf",
		LOGS_VIEW: "reading",
		WORK_VIEW: "work"
	};
	
	var PATH = exports.PATH = "/my/:active_view/:details_view?/:text_id?";

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(56);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(30);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3800);
	
	var EmptyStateContainer = function (_React$Component) {
		_inherits(EmptyStateContainer, _React$Component);
	
		function EmptyStateContainer(props) {
			_classCallCheck(this, EmptyStateContainer);
	
			var _this = _possibleConstructorReturn(this, (EmptyStateContainer.__proto__ || Object.getPrototypeOf(EmptyStateContainer)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(EmptyStateContainer, [{
			key: "renderLeftContent",
			value: function renderLeftContent() {
				var widths = [120, 105, 95];
	
				var emptyStudentRows = [];
				var owlImgSrc = __webpack_require__(543);
				for (var i = 0; i <= 10; i++) {
					var width = _.sample(widths, 1);
					emptyStudentRows.push(React.createElement(
						"div",
						{ className: "emptyStudentRowContainer", key: i },
						React.createElement("img", { src: owlImgSrc, alt: "" }),
						React.createElement("span", { className: "emptyStudentRow", style: { width: width } })
					));
				};
				return React.createElement(
					"div",
					null,
					emptyStudentRows
				);
			}
		}, {
			key: "renderRightContent",
			value: function renderRightContent() {
				if (this.props.linkPath) {
					var image = React.createElement(
						_reactRouterDom.Link,
						{ to: this.props.linkPath },
						React.createElement("img", { src: this.props.imagePath, className: "emptyImg" })
					);
				} else {
					var image = React.createElement("img", { src: this.props.imagePath, className: "emptyImg" });
				}
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						this.props.statusText
					),
					this.props.actionText,
					image
				);
			}
		}, {
			key: "render",
			value: function render() {
				var imagePath = this.props.imagePath;
				if (this.props.sideBar) {
					var emptyStateContent = React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-3 sideBar" },
							this.renderLeftContent()
						),
						React.createElement(
							"div",
							{ className: "col-sm-9 rightContent emptyRightContent" },
							this.renderRightContent()
						)
					);
				} else {
					if (this.props.linkPath) {
						var image = React.createElement(
							_reactRouterDom.Link,
							{ to: this.props.linkPath },
							React.createElement("img", { src: imagePath, className: "emptyImg" })
						);
					} else {
						var image = React.createElement("img", { src: imagePath, className: "emptyImg" });
					}
					var emptyStateContent = React.createElement(
						"div",
						{ className: "emptyStateContent" },
						React.createElement(
							"p",
							null,
							this.props.statusText
						),
						this.props.actionText,
						image
					);
				}
				return React.createElement(
					"div",
					{ className: "container emptyStateContainer" },
					emptyStateContent
				);
			}
		}]);
	
		return EmptyStateContainer;
	}(React.Component);
	
	EmptyStateContainer.propTypes = StrictPropTypes({
		statusText: PropTypes.string,
		imagePath: PropTypes.string,
		className: PropTypes.string,
		linkPath: PropTypes.string,
		actionText: PropTypes.object,
		sideBar: PropTypes.bool
	});
	
	module.exports = EmptyStateContainer;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3813);
	
	var ProgressBar = function (_React$Component) {
		_inherits(ProgressBar, _React$Component);
	
		function ProgressBar(props) {
			_classCallCheck(this, ProgressBar);
	
			var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ProgressBar, [{
			key: "getMessage",
			value: function getMessage(index) {
				if (this.props.message) {
					return React.createElement(
						"div",
						{ className: "progressMessage" },
						this.props.message
					);
				}
				if (this.props.messages && this.props.messages.length > index) {
					return React.createElement(
						"div",
						{ className: "progressMessage" },
						this.props.messages[index]
					);
				}
				return null;
			}
		}, {
			key: "render",
			value: function render() {
				var progress;
				if (this.props.progress) {
					progress = this.props.progress;
				} else {
					progress = this.props.current / this.props.total;
				}
				progress = Math.min(progress || 0.0, 1.0);
	
				var percent = Math.round(progress * 100);
				var total = this.props.total;
	
				var barClassName = "progress-bar";
	
				// Red, Orange, Green thresholds if provided 
				if (this.props.colorThreshold) {
					var first_threshold = this.props.colorThreshold[0] / this.props.total;
					var second_threshold = this.props.colorThreshold[1] / this.props.total;
				} else {
					var first_threshold = 0.30;
					var second_threshold = 1.0;
				}
				if (this.props.dynamicColor) {
					if (progress < first_threshold) {
						barClassName += " progress-bar-danger";
						var messageIndex = 0;
					} else if (progress < second_threshold) {
						barClassName += " progress-bar-warning";
						var messageIndex = 1;
					} else {
						barClassName += " progress-bar-success";
						var messageIndex = 2;
					}
				} else if (this.props.className == null) {
					barClassName += " progress-bar-success";
				}
				if (this.props.className) {
					barClassName += " " + this.props.className;
				}
				var message = this.getMessage(messageIndex);
				return React.createElement(
					"div",
					{ className: "ProgressBar" },
					React.createElement(
						"div",
						{ className: "progress" },
						React.createElement("div", { className: barClassName, role: "progressbar", "aria-valuenow": percent, "aria-valuemin": "0", "aria-valuemax": "100",
							style: { width: percent + "%", minWidth: 0 } })
					),
					message
				);
			}
		}]);
	
		return ProgressBar;
	}(React.Component);
	
	;
	
	ProgressBar.propTypes = StrictPropTypes({
		current: PropTypes.number,
		total: PropTypes.number,
		dynamicColor: PropTypes.bool,
		colorThreshold: PropTypes.array,
		messages: PropTypes.array,
		message: PropTypes.string,
		className: PropTypes.string
	});
	
	module.exports = ProgressBar;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	
	var TEXT_SPECIFIC_QUESTION = "text-specific-question";
	var BLOG_QUESTION = "blog-question";
	var GENERIC_QUESTION = "generic-question";
	var REVIEW_QUESTION = "review-question";
	var META_COGNITIVE_QUESTION = "meta-cognitive-question";
	var FILL_IN_THE_BLANK_QUESTION = "fill-in-the-blank-question";
	
	module.exports = {
		TEXT_SPECIFIC_QUESTION: TEXT_SPECIFIC_QUESTION, BLOG_QUESTION: BLOG_QUESTION, GENERIC_QUESTION: GENERIC_QUESTION, REVIEW_QUESTION: REVIEW_QUESTION, META_COGNITIVE_QUESTION: META_COGNITIVE_QUESTION, FILL_IN_THE_BLANK_QUESTION: FILL_IN_THE_BLANK_QUESTION,
	
		BASIC_TYPES: [TEXT_SPECIFIC_QUESTION, GENERIC_QUESTION]
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getLeafName = getLeafName;
	exports.getLeafDescription = getLeafDescription;
	exports.getLeafOptions = getLeafOptions;
	exports.getLeafRubricKey = getLeafRubricKey;
	exports.getLeafAggregateKey = getLeafAggregateKey;
	exports.sortLeaves = sortLeaves;
	exports.getRubricLeaves = getRubricLeaves;
	exports.aggregateLeaves = aggregateLeaves;
	exports.lookupSubstring = lookupSubstring;
	exports.isDisplayTag = isDisplayTag;
	exports.shouldGroupTagSpans = shouldGroupTagSpans;
	exports.groupTagSpans = groupTagSpans;
	exports.getTagName = getTagName;
	exports.getFilterOrWarningName = getFilterOrWarningName;
	exports.isLeafPostQuizFeedback = isLeafPostQuizFeedback;
	exports.getLeafPostQuizFeedback = getLeafPostQuizFeedback;
	exports.getFilterPostQuizFeedback = getFilterPostQuizFeedback;
	exports.leafValueToScore = leafValueToScore;
	exports.getScoringDisplayRequirement = getScoringDisplayRequirement;
	exports.leafValueToText = leafValueToText;
	var LeavesDisplayData = __webpack_require__(3525);
	var TagsDisplayData = __webpack_require__(3528);
	var FiltersAndWarningsDisplayData = __webpack_require__(3524);
	var CurrentUser = __webpack_require__(3);
	var SkillsetData = __webpack_require__(3527);
	
	function getLeafName(key) {
		if (key in LeavesDisplayData) {
			return LeavesDisplayData[key]["Title"];
		}
	}
	function getLeafDescription(key) {
		if (key in LeavesDisplayData) {
			return LeavesDisplayData[key]["Description"];
		}
	}
	
	function getLeafOptions(key) {
		if (key in LeavesDisplayData) {
			if ("Options" in LeavesDisplayData[key]) return LeavesDisplayData[key]["Options"].split(',');
		}
	}
	
	function getLeafRubricKey(key) {
		if (key in LeavesDisplayData) {
			return LeavesDisplayData[key]["RubricKey"];
		}
	}
	
	function getLeafAggregateKey(key) {
		if (key in LeavesDisplayData) {
			return LeavesDisplayData[key]["Aggregate"];
		}
	}
	
	function sortLeaves(leaves) {
		var sortedLeaves = {};
	
		var sortedKeys = _.sortBy(_.keys(leaves), function (l) {
			if (!LeavesDisplayData[l] || !LeavesDisplayData[l].Order) {
				return 10000;
			} else {
				return LeavesDisplayData[l].Order;
			}
		});
	
		_.each(sortedKeys, function (key) {
			sortedLeaves[key] = leaves[key];
		});
	
		return sortedLeaves;
	}
	
	function getRubricLeaves(leaves, demo) {
		var output = {};
		_.each(RUBRIC_AGGREGATE_KEYS, function (leafKey) {
			var leafConfig = LeavesDisplayData[leafKey];
	
			if (!leafConfig || leafConfig["Display"] != "True") {
				return; // Skip to the next one
			}
	
			var useKey = leafConfig["RubricKey"] || leafKey;
	
			output[useKey] = output[useKey] || {
				values: [],
				labels: [],
				tag_keys: [],
				tags: [],
				rubric: false
			};
	
			if (leafConfig["Rubric"] && leafConfig["Rubric"] == "True") {
				output[useKey].rubric = true;
			}
	
			var leafData = leaves[useKey];
			if (leafData) {
				if (CurrentUser.isPremiumOrTrialAccount() || demo) {
					var label = leafData.admin_label ? leafData.admin_label : leafData.label;
				} else {
					var label = leafData.admin_label;
				}
				output[useKey].labels.push(label);
				output[useKey].values.push(leafData.value);
				output[useKey].tag_keys = _.compact(output[useKey].tag_keys.concat(leafData.tag_keys));
				if (leafData.tags != undefined) {
					output[useKey].tags = _.compact(output[useKey].tags.concat(leafData.tags));
				}
			}
		});
	
		_.each(output, function (leafData, leafKey) {
			if (leafData.rubric) {
				leafData.value = leafData.labels[0];
			} else {
				leafData.value = _.reduce(leafData.values, function (memo, val) {
					return memo + val;
				}) / leafData.values.length;
			}
		});
	
		return this.sortLeaves(output);
	}
	
	function aggregateLeaves(leaves) {
		var output = {};
		_.each(leaves, function (leafData, leafKey) {
			var leafConfig = LeavesDisplayData[leafKey];
	
			if (!leafConfig || leafConfig["Display"] != "True") {
				return; // Skip to the next one
			}
	
			var useKey = leafConfig["Aggregate"] || leafKey;
	
			output[useKey] = output[useKey] || {
				values: [],
				labels: [],
				tag_keys: [],
				tags: [],
				rubric: false
			};
	
			if (leafConfig["Rubric"] && leafConfig["Rubric"] == "True") {
				output[useKey].rubric = true;
			}
	
			output[useKey].values.push(leafData.value);
			output[useKey].labels.push(leafData.label);
			output[useKey].tag_keys = _.compact(output[useKey].tag_keys.concat(leafData.tag_keys));
			if (leafData.tags != undefined) {
				output[useKey].tags = _.compact(output[useKey].tags.concat(leafData.tags));
			}
		});
	
		_.each(output, function (leafData, leafKey) {
			if (leafData.rubric) {
				leafData.value = leafData.labels[0];
			} else {
				leafData.value = _.reduce(leafData.values, function (memo, val) {
					return memo + val;
				}) / leafData.values.length;
			}
		});
	
		return this.sortLeaves(output);
	}
	
	function lookupSubstring(key) {
		return _.find(_.keys(TagsDisplayData), function (k) {
			return key.includes(k);
		});
	}
	
	function isDisplayTag(key) {
		return key in TagsDisplayData || _.size(lookupSubstring(key));
	}
	
	function shouldGroupTagSpans(key) {
		return key in TagsDisplayData && TagsDisplayData[key]["GroupSpans"] != undefined;
	}
	
	function groupTagSpans(tag) {
		var starts = _.map(tag.spans, function (span) {
			return span.start;
		});
		var ends = _.map(tag.spans, function (span) {
			return span.end;
		});
		starts.sort();
		ends.sort();
		return [{ start: starts[0], end: ends[ends.length - 1] }];
	}
	
	function getTagName(key) {
		if (isDisplayTag(key)) {
			var lookupKey = key in TagsDisplayData ? key : lookupSubstring(key);
			return TagsDisplayData[lookupKey]["Title"];
		}
	}
	
	function getFilterOrWarningName(key) {
		if (key in FiltersAndWarningsDisplayData) {
			return FiltersAndWarningsDisplayData[key]["Title"];
		}
	}
	
	function isLeafPostQuizFeedback(key) {
		if (key in LeavesDisplayData) {
			return LeavesDisplayData[key]["PostQuizFeedbackTitle"] != undefined;
		} else {
			return false;
		}
	}
	
	function getLeafPostQuizFeedback(key, isPositive) {
		var title = LeavesDisplayData[key]["PostQuizFeedbackTitle"];
	
		if (isPositive) {
			var description = LeavesDisplayData[key]["PositivePostQuizFeedback"];
		} else {
			var description = LeavesDisplayData[key]["NegativePostQuizFeedback"];
		}
		return { title: title, description: description };
	}
	
	function getFilterPostQuizFeedback(key) {
		var title = FiltersAndWarningsDisplayData[key]["PostQuizFeedbackTitle"];
		var description = FiltersAndWarningsDisplayData[key]["NegativePostQuizFeedback"];
		return { title: title, description: description };
	}
	
	function leafValueToScore(value) {
		if (value >= 0.6) {
			return 4;
		} else if (value >= 0.5) {
			return 3;
		} else if (value >= 0.25) {
			return 2;
		} else {
			return 1;
		}
	}
	
	function getScoringDisplayRequirement(value) {
		if (value >= 0.8) {
			return 0;
		} else if (value >= 0.6) {
			return 1;
		} else {
			return 2;
		}
	}
	
	function leafValueToText(value, requirement) {
		var text = "High";
		if (value <= 0.5) {
			text = "Low";
		} else if (value <= 0.7) {
			text = "Average";
		}
		if (requirement > 0 && text != "Low") {
			return "Average";
		}
		return text;
	}
	
	var LEAF_SCORE_CAP = exports.LEAF_SCORE_CAP = 4;
	
	// flags FE to add 'New' label
	var NEW_KEYS = exports.NEW_KEYS = ['aggregate-restated'];
	// flags FE to add 'Beta' label
	var BETA_KEYS = exports.BETA_KEYS = ['crit-rc-atq-coqa-fully-answered-2'];
	
	// rubric keys
	var RUBRIC_AGGREGATE_KEYS = exports.RUBRIC_AGGREGATE_KEYS = ["aggregate-read-book", "aggregate-fully-answered-question", "aggregate-answer-length", "aggregate-text-details-count", "aggregate-restated",
	// "aggregate-sentence-structure",
	"aggregate-capitalization", "aggregate-punctuation", "aggregate-spelling", "aggregate-grammar", "aggregate-word-count", "aggregate-sentence-count"];
	
	var POLARIZING_KEY_TO_RUBRIC_KEY = exports.POLARIZING_KEY_TO_RUBRIC_KEY = {
		"crit-evi-cote-bert-read-book-1": "01_TEXT-SPE_read-the-book",
		"crit-rc-atq-coqa-fully-answered-2": "02_READ-COMP_fully-answered",
		"03_READ-COMP_answer-present": "03_READ-COMP_answer-present",
		"comm-conv-mech-caps-4": "04_MECH_capitalization",
		"comm-conv-mech-gram-5": "05_MECH_grammar",
		"06_MECH_introduction": "06_MECH_introduction",
		"07_MECH_ling-accpt": "07_MECH_ling-accpt",
		"comm-conv-mech-punc-8": "08_MECH_punct",
		"09_MECH_repetitions": "09_MECH_repetitions",
		"crit-rc-atq-cors-bert-10": "10_READ-COMP_restating",
		"comm-conv-org-sent-count-11": "11_LEN_sent-count",
		"comm-conv-org-sent-struct-coso-12": "12_MECH_sent-struct",
		"comm-conv-mech-spell-13": "13_MECH_spelling",
		"crit-evi-cote-bert-quantity-14": "14_TEXT-SPE_text-details-count",
		"15_MECH_transition": "15_MECH_transition",
		"16_VOC_complex-vocab": "16_VOC_complex-vocab",
		"17_TEXT-SPE_text-details-qual": "17_TEXT-SPE_text-details-qual",
		"comm-conv-org-word-count-18": "18_LEN_sent-count"
	};
	
	var SUCCESS_OUTPUT = exports.SUCCESS_OUTPUT = ['Yes', 'Sufficient', 'Correct', 'Solid', 'Complete'];
	var MIDDLING_OUTPUT = exports.MIDDLING_OUTPUT = ['Partial', 'Developing'];
	var FAIL_OUTPUT = exports.FAIL_OUTPUT = ['No', 'Insufficient', 'No structure', 'No Structure', 'None', 'Incorrect', 'Incomplete'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(77);
	var IObject = __webpack_require__(180);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(39);
	var asc = __webpack_require__(264);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(5);
	var core = __webpack_require__(76);
	var fails = __webpack_require__(30);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(32);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(15),__webpack_require__(20),__webpack_require__(3579)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside"],t):"object"==typeof exports?exports.DatePicker=t(require("moment"),require("react"),require("react-onclickoutside")):e.DatePicker=t(e.moment,e.React,e.onClickOutside)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),u=r(c),l=n(4),f=r(l),d=n(5),h=(r(d),n(21)),m=r(h),y=n(11),v=r(y),b=n(18),g=n(2),w=r(g),_=n(12),D=r(_),k="react-datepicker-ignore-onclickoutside",O=(0,D.default)(u.default),E=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.getPreSelection=function(){return n.props.openToDate?(0,w.default)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,w.default)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,w.default)(n.props.endDate):"undefined"!=typeof n.props.utcOffset?w.default.utc().utcOffset(n.props.utcOffset):(0,w.default)()},n.calcInitialState=function(){var e=n.getPreSelection(),t=(0,b.getEffectiveMinDate)(n.props),r=(0,b.getEffectiveMaxDate)(n.props),o=t&&e.isBefore(t)?t:r&&e.isAfter(r)?r:e;return{open:!1,preventFocus:!1,preSelection:n.props.selected?(0,w.default)(n.props.selected):o}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,b.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.props.shouldCloseOnSelect?n.props.inline||n.setOpen(!1):n.setPreSelection(e)},n.setSelected=function(e,t,r){var o=e;null!==o&&(0,b.isDayDisabled)(o,n.props)||((0,b.isSameDay)(n.props.selected,o)&&!n.props.allowSameDay||(null!==o&&(n.props.selected&&(o=(0,w.default)(o).set({hour:n.props.selected.hour(),minute:n.props.selected.minute(),second:n.props.selected.second()})),n.setState({preSelection:o})),n.props.onChange(o,t)),n.props.onSelect(o,t),r||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,r=!t||!e||(0,b.isDayInRange)(e,n.props.minDate,n.props.maxDate);r&&n.setState({preSelection:e})},n.handleTimeChange=function(e){var t=n.props.selected?n.props.selected:n.getPreSelection(),r=t.clone().set({hour:e.get("hours"),minute:e.get("minutes")});n.setState({preSelection:r}),n.props.onChange(r)},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){n.props.onKeyDown(e);var t=e.key;if(!n.state.open&&!n.props.inline)return void("Enter"!==t&&"Escape"!==t&&"Tab"!==t&&n.onInputClick());var r=(0,w.default)(n.state.preSelection);if("Enter"===t)e.preventDefault(),w.default.isMoment(n.state.preSelection)||w.default.isDate(n.state.preSelection)?(n.handleSelect(r,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(r)):n.setOpen(!1);else if("Escape"===t)e.preventDefault(),n.setOpen(!1);else if("Tab"===t)n.setOpen(!1);else if(!n.props.disabledKeyboardNavigation){var o=void 0;switch(t){case"ArrowLeft":e.preventDefault(),o=r.subtract(1,"days");break;case"ArrowRight":e.preventDefault(),o=r.add(1,"days");break;case"ArrowUp":e.preventDefault(),o=r.subtract(1,"weeks");break;case"ArrowDown":e.preventDefault(),o=r.add(1,"weeks");break;case"PageUp":e.preventDefault(),o=r.subtract(1,"months");break;case"PageDown":e.preventDefault(),o=r.add(1,"months");break;case"Home":e.preventDefault(),o=r.subtract(1,"years");break;case"End":e.preventDefault(),o=r.add(1,"years")}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e)},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(O,{ref:function(e){n.calendar=e},locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:k,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,dayClassName:n.props.dayClassName,showTimeSelect:n.props.showTimeSelect,onTimeChange:n.handleTimeChange,timeIntervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,className:n.props.calendarClassName,yearDropdownItemNumber:n.props.yearDropdownItemNumber},n.props.children):null},n.renderDateInput=function(){var e=(0,v.default)(n.props.className,o({},k,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),r="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,b.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:function(e){n.input=e},value:r,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.calcInitialState(),n}return s(t,e),p(t,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},utcOffset:(0,w.default)().utcOffset(),monthsShown:1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,timeIntervals:30}}}]),p(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.selected&&this.props.selected.month(),n=e.selected&&e.selected.month();this.props.inline&&t!==n&&this.setPreSelection(e.selected)}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{className:this.props.popperClassName,hidePopper:!this.state.open||this.props.disabled,popperModifiers:this.props.popperModifiers,targetComponent:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperComponent:e,popperPlacement:this.props.popperPlacement})}}]),t}(f.default.Component);t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(2),c=r(p),u=n(3),l=r(u),f=n(13),d=r(f),h=n(15),m=r(h),y=n(20),v=r(y),b=n(4),g=r(b),w=n(5),_=(r(w),n(11)),D=r(_),k=n(18),O=["react-datepicker__year-select","react-datepicker__month-select"],E=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return O.some(function(e){return t.indexOf(e)>=0})},C=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){E(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,a=e.utcOffset,i=(0,k.getEffectiveMinDate)(n.props),s=(0,k.getEffectiveMaxDate)(n.props),p=c.default.utc().utcOffset(a),u=o||r||t;return u?u:i&&p.isBefore(i)?i:s&&p.isAfter(s)?s:p},n.localizeMoment=function(e){return e.clone().locale(n.props.locale||c.default.locale())},n.increaseMonth=function(){n.setState({date:n.state.date.clone().add(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:n.state.date.clone().subtract(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:n.state.date.clone().set("year",e)})},n.changeMonth=function(e){n.setState({date:n.state.date.clone().set("month",e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=e.clone().startOf("week"),r=[];return n.props.showWeekNumbers&&r.push(g.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map(function(e){var r=t.clone().add(e,"days"),o=n.props.useWeekdaysShort?r.localeData().weekdaysShort(r):r.localeData().weekdaysMin(r);return g.default.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,k.allDaysDisabledBefore)(n.state.date,"month",n.props))return g.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,k.allDaysDisabledAfter)(n.state.date,"month",n.props)){var e=["react-datepicker__navigation","react-datepicker__navigation--next"];return n.props.showTimeSelect&&e.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&e.push("react-datepicker__navigation--next--with-today-button"),g.default.createElement("a",{className:e.join(" "),onClick:n.increaseMonth})}},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),g.default.createElement("div",{className:t.join(" ")},e.format(n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return g.default.createElement(l.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:n.state.date.year(),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return g.default.createElement(d.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonth,month:n.state.date.month()})},n.renderTodayButton=function(){if(n.props.todayButton)return g.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(c.default.utc().utcOffset(n.props.utcOffset).startOf("date"),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var r=n.state.date.clone().add(t,"M"),o="month-"+t;e.push(g.default.createElement("div",{key:o,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},g.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),g.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),g.default.createElement("div",{className:"react-datepicker__day-names"},n.header(r))),g.default.createElement(m.default,{day:r,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,formatWeekNumber:n.props.formatWeekNumber,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.renderTimeSection=function(){return n.props.showTimeSelect?g.default.createElement(v.default,{selected:n.props.selected,onChange:n.props.onTimeChange,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer}):void 0},n.state={date:n.localizeMoment(n.getDateInView()),selectingDate:null,monthContainer:n.monthContainer},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},utcOffset:c.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=function(){e.setState({monthContainer:e.monthContainer})}())}},{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,k.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(e.preSelection)}):e.openToDate&&!(0,k.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(e.openToDate)})}},{key:"render",value:function(){return g.default.createElement("div",{className:(0,D.default)("react-datepicker",this.props.className)},g.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.props.children)}}]),t}(g.default.Component);t.default=C},function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(10)),f=r(l),d=n(12),h=r(d),m=(0,h.default)(f.default),y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(){for(var e=r.props.minDate?r.props.minDate.year():1900,t=r.props.maxDate?r.props.maxDate.year():2100,n=[],o=e;o<=t;o++)n.push(c.default.createElement("option",{key:o,value:o},o));return n},r.onSelectChange=function(e){r.onChange(e.target.value)},r.renderSelectMode=function(){return c.default.createElement("select",{value:r.props.year,className:"react-datepicker__year-select",onChange:r.onSelectChange},r.renderSelectOptions())},r.renderReadView=function(e){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),c.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},r.props.year))},r.renderDropdown=function(){return c.default.createElement(m,{key:"dropdown",ref:"options",year:r.props.year,onChange:r.onChange,onCancel:r.toggleDropdown,scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})},r.renderScrollMode=function(){var e=r.state.dropdownVisible,t=[r.renderReadView(!e)];return e&&t.unshift(r.renderDropdown()),t},r.onChange=function(e){r.toggleDropdown(),e!==r.props.year&&r.props.onChange(e)},r.toggleDropdown=function(){r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return c.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(c.default.Component);t.default=y},function(e,n){e.exports=t},function(e,t,n){e.exports=n(6)()},function(e,t,n){"use strict";var r=n(7),o=n(8),a=n(9);e.exports=function(){function e(e,t,n,r,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,p){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,r,a,i,s,p],l=0;c=new Error(t.replace(/%s/g,function(){return u[l++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t){for(var n=[],r=0;r<2*t+1;r++)n.push(e+t-r);return n}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=r(c),l=n(5),f=(r(l),n(11)),d=r(f),h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return u.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?u.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)});return t.unshift(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),t.push(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var r=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,p=r||(i?10:5);return n.state={yearsList:s(n.props.year,p)},n}return i(t,e),p(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return u.default.createElement("div",{className:e},this.renderOptions())}}]),t}(u.default.Component);t.default=h},function(e,t,n){var r,o;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var i in r)a.call(r,i)&&r[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(r=[],o=function(){return n}.apply(t,r),!(void 0!==o&&(e.exports=o)))}()},function(e,t){e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(14)),f=r(l),d=n(12),h=r(d),m=n(2),y=r(m),v=(0,h.default)(f.default),b=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},r.renderSelectMode=function(e){return c.default.createElement("select",{value:r.props.month,className:"react-datepicker__month-select",onChange:function(e){return r.onChange(e.target.value)}},r.renderSelectOptions(e))},r.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[r.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},r.renderDropdown=function(e){return c.default.createElement(v,{key:"dropdown",ref:"options",month:r.props.month,monthNames:e,onChange:r.onChange,onCancel:r.toggleDropdown})},r.renderScrollMode=function(e){var t=r.state.dropdownVisible,n=[r.renderReadView(!t,e)];return t&&n.unshift(r.renderDropdown(e)),n},r.onChange=function(e){r.toggleDropdown(),e!==r.props.month&&r.props.onChange(e)},r.toggleDropdown=function(){return r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=this,t=y.default.localeData(this.props.locale),n=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(n){return t.months((0,y.default)({M:n}),e.props.dateFormat)}),r=void 0;switch(this.props.dropdownMode){case"scroll":r=this.renderScrollMode(n);break;case"select":r=this.renderSelectMode(n)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},r)}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.renderOptions=function(){return r.props.monthNames.map(function(e,t){return c.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:r.onChange.bind(r,t)},r.props.month===t?c.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){return r.props.onCancel()},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(c.default.Component));t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=n(16),h=r(d),m=6,y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleMouseLeave=function(){r.props.onMouseLeave&&r.props.onMouseLeave()},r.isWeekInMonth=function(e){var t=r.props.day,n=e.clone().add(6,"days");return e.isSame(t,"month")||n.isSame(t,"month")},r.renderWeeks=function(){for(var e=[],t=r.props.fixedHeight,n=r.props.day.clone().startOf("month").startOf("week"),o=0,a=!1;;){if(e.push(c.default.createElement(h.default,{key:o,day:n,month:r.props.day.month(),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})),a)break;o++,n=n.clone().add(1,"weeks");var i=t&&o>=m,s=!t&&!r.isWeekInMonth(n);if(i||s){if(!r.props.peekNextMonth)break;a=!0}}return e},r.getClassNames=function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd;return(0,f.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||o)})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(17)),f=r(l),d=n(19),h=r(d),m=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleWeekClick=function(e,t,n){"function"==typeof r.props.onWeekSelect&&r.props.onWeekSelect(e,t,n)},r.formatWeekNumber=function(e){return r.props.formatWeekNumber?r.props.formatWeekNumber(e):parseInt(e.format("w"),10)},r.renderDays=function(){var e=r.props.day.clone().startOf("week"),t=[],n=r.formatWeekNumber(e);if(r.props.showWeekNumber){var o=r.props.onWeekSelect?r.handleWeekClick.bind(r,e,n):void 0;t.push(c.default.createElement(h.default,{key:"W",weekNumber:n,onClick:o}))}return t.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return c.default.createElement(f.default,{key:t,day:n,month:r.props.month,onClick:r.handleDayClick.bind(r,n),onMouseEnter:r.handleDayMouseEnter.bind(r,n),minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})}))},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(2),l=r(u),f=n(4),d=r(f),h=n(5),m=(r(h),n(11)),y=r(m),v=n(18),b=function(e){function t(){var e,n,r,s;a(this,t);for(var c=arguments.length,u=Array(c),f=0;f<c;f++)u[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),r.handleClick=function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e)},r.handleMouseEnter=function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.isSameDay=function(e){return(0,v.isSameDay)(r.props.day,e)},r.isKeyboardSelected=function(){return!r.props.inline&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)},r.isDisabled=function(){return(0,v.isDayDisabled)(r.props.day,r.props)},r.getHighLightedClass=function(e){var t=r.props,n=t.day,a=t.highlightDates;if(!a)return o({},e,!1);for(var i={},s=0,c=a.length;s<c;s++){var u=a[s];if(u instanceof l.default)(0,v.isSameDay)(n,u)&&(i[e]=!0);else if("object"===("undefined"==typeof u?"undefined":p(u))){var f=Object.keys(u),d=u[f[0]];if("string"==typeof f[0]&&d.constructor===Array)for(var h=0,m=d.length;h<m;h++)(0,v.isSameDay)(n,d[h])&&(i[f[0]]=!0)}}return i},r.isInRange=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isDayInRange)(t,n,o)},r.isInSelectingRange=function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!o||!a||r.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,v.isDayInRange)(t,a,s):!!(o&&i&&a.isSameOrAfter(i))&&(0,v.isDayInRange)(t,i,a))},r.isSelectingRangeStart=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate,a=e.selectsStart;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isSelectingRangeEnd=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate,a=e.selectsEnd;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isRangeStart=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(n,t)},r.isRangeEnd=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(o,t)},r.isWeekend=function(){var e=r.props.day.day();return 0===e||6===e},r.isOutsideMonth=function(){return void 0!==r.props.month&&r.props.month!==r.props.day.month()},r.getClassNames=function(e){var t=r.props.dayClassName?r.props.dayClassName(e):void 0;return(0,y.default)("react-datepicker__day",t,"react-datepicker__day--"+(0,v.getDayOfWeekCode)(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay(l.default.utc().utcOffset(r.props.utcOffset)),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))},s=n,i(r,s)}return s(t,e),c(t,[{key:"render",value:function(){return d.default.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}}]),t}(d.default.Component);b.defaultProps={utcOffset:l.default.utc().utcOffset()},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function a(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function i(e,t,n){var r=t.clone().startOf("day").subtract(1,"seconds"),o=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(r,o)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,a=t.excludeDates,i=t.includeDates,s=t.filterDate;return n&&e.isBefore(n,"day")||r&&e.isAfter(r,"day")||a&&a.some(function(t){return o(e,t)})||i&&!i.some(function(t){return o(e,t)})||s&&!s(e.clone())||!1}function p(e,t){for(var n=t.length,r=0;r<n;r++)if(t[r].get("hours")===e.get("hours")&&t[r].get("minutes")===e.get("minutes"))return!0;return!1}function c(e,t){var n=t.minTime,r=t.maxTime;if(!n||!r)throw new Error("Both minTime and maxTime props required");var o=(0,b.default)().hours(0).minutes(0).seconds(0),a=o.clone().hours(e.get("hours")).minutes(e.get("minutes")),i=o.clone().hours(n.get("hours")).minutes(n.get("minutes")),s=o.clone().hours(r.get("hours")).minutes(r.get("minutes"));return!(a.isSameOrAfter(i)&&a.isSameOrBefore(s))}function u(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.minDate,o=n.includeDates,a=e.clone().subtract(1,t);return r&&a.isBefore(r,t)||o&&o.every(function(e){return a.isBefore(e,t)})||!1}function l(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.maxDate,o=n.includeDates,a=e.clone().add(1,t);return r&&a.isAfter(r,t)||o&&o.every(function(e){return a.isAfter(e,t)})||!1}function f(e){var t=e.minDate,n=e.includeDates;return n&&t?b.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?b.default.min(n):t}function d(e){var t=e.maxDate,n=e.includeDates;return n&&t?b.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?b.default.max(n):t}function h(e,t){var n=t.dateFormat,r=t.locale,o=(0,b.default)(e,n,r||b.default.locale(),!0);return o.isValid()?o:null}function m(e,t){var n=t.dateFormat,r=t.locale;return e&&e.clone().locale(r||b.default.locale()).format(Array.isArray(n)?n[0]:n)||""}function y(e){return g[e.isoWeekday()]}Object.defineProperty(t,"__esModule",{value:!0}),t.isSameDay=o,t.isSameUtcOffset=a,t.isDayInRange=i,t.isDayDisabled=s,t.isTimeDisabled=p,t.isTimeInDisabledRange=c,t.allDaysDisabledBefore=u,t.allDaysDisabledAfter=l,t.getEffectiveMinDate=f,t.getEffectiveMaxDate=d,t.parseDate=h,t.safeDateFormat=m,t.getDayOfWeekCode=y;var v=n(2),b=r(v),g={1:"mon",2:"tue",3:"wed",4:"thu",5:"fri",6:"sat",7:"sun"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){r.props.onClick&&r.props.onClick(e)},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return c.default.createElement("div",{className:(0,f.default)(e),"aria-label":"week-"+this.props.weekNumber,onClick:this.handleClick},this.props.weekNumber)}}]),t}(c.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(2)),f=r(l),d=n(18),h=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){(r.props.minTime||r.props.maxTime)&&(0,d.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,d.isTimeDisabled)(e,r.props.excludeTimes)||r.props.onChange(e)},r.liClasses=function(e,t,n){var o=["react-datepicker__time-list-item"];return t===e.get("hours")&&n===e.get("minutes")&&o.push("react-datepicker__time-list-item--selected"),((r.props.minTime||r.props.maxTime)&&(0,d.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,d.isTimeDisabled)(e,r.props.excludeTimes))&&o.push("react-datepicker__time-list-item--disabled"),o.join(" ")},r.renderTimes=function(){for(var e=[],t=r.props.intervals,n=r.props.selected?r.props.selected:(0,f.default)(),o=n.get("hours"),a=n.get("minutes"),i=(0,f.default)().startOf("day"),s=1440/t,p=0;p<s;p++)e.push(i.clone().add(p*t,"minutes"));return e.map(function(e,t){return c.default.createElement("li",{key:t,onClick:r.handleClick.bind(r,e),className:r.liClasses(e,o,a)},e.format("hh:mm A"))})},i=n,a(r,i)}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=60/this.props.intervals,t=this.props.selected?this.props.selected.get("hours"):(0,f.default)().get("hours");this.list.scrollTop=30*(e*t)}},{key:"render",value:function(){var e=this,t=null;return this.props.monthRef&&(t=this.props.monthRef.clientHeight-39),c.default.createElement("div",{className:"react-datepicker__time-container "+(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},c.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time"},c.default.createElement("div",{className:"react-datepicker-time__header"},"Time")),c.default.createElement("div",{className:"react-datepicker__time"},c.default.createElement("div",{className:"react-datepicker__time-box"},c.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{}},this.renderTimes.bind(this)()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null}}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.popperPlacementPositions=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(22)),f=(t.popperPlacementPositions=["auto","auto-left","auto-right","bottom","bottom-end","bottom-start","left","left-end","left-start","right","right-end","right-start","top","top-end","top-start"],function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){var e=this.props,t=e.hidePopper,n=e.popperComponent,r=e.popperModifiers,o=e.popperPlacement,a=e.targetComponent;return c.default.createElement(l.Manager,null,c.default.createElement(l.Target,{className:"react-datepicker-wrapper"},a),!t&&c.default.createElement(l.Popper,{className:"react-datepicker-popper",modifiers:r,placement:o},n))}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperPlacement:"bottom-start"}}}]),t}(c.default.Component));t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Arrow=t.Popper=t.Target=t.Manager=void 0;var o=n(23),a=r(o),i=n(24),s=r(i),p=n(25),c=r(p),u=n(29),l=r(u);t.Manager=a.default,t.Target=s.default,t.Popper=c.default,t.Arrow=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=(r(c),n(5)),l=r(u),f=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},o=n,i(r,o)}return s(t,e),p(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,r=o(e,["tag","children"]);return t!==!1?(0,c.createElement)(t,r,n):n}}]),t}(c.Component);f.childContextTypes={popperManager:l.default.object.isRequired},f.propTypes={tag:l.default.oneOfType([l.default.string,l.default.bool])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"div":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popperManager,l=function(e){u.setTargetNode(e),"function"==typeof s&&s(e)};if("function"==typeof p){var f={ref:l};return p({targetProps:f,restProps:c})}var d=a({},c);return"string"==typeof r?d.ref=l:d.innerRef=l,(0,i.createElement)(r,d,p)};c.contextTypes={popperManager:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(4),f=(r(l),n(5)),d=r(f),h=n(26),m=r(h),y=n(27),v=r(y),b=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,p=Array(a),u=0;u<a;u++)p[u]=arguments[u];return n=r=s(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return(r.state.data&&!(0,v.default)(e.offsets,r.state.data.offsets)||!r.state.data)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;if(!r._popper||!e)return{position:"absolute",pointerEvents:"none",opacity:0};var t=e.offsets.popper,n=(t.top,t.left,t.position);return c({position:n},e.styles)},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow,t=e.top,n=e.left;return{top:t,left:n}}return{}},o=n,s(r,o)}return p(t,e),u(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidMount",value:function(){this._updatePopper()}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||this._updatePopper(),this._popper&&e.children!==this.props.children&&this._popper.scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_updatePopper",value:function(){this._destroyPopper(),this._node&&this._createPopper()}},{key:"_createPopper",value:function(){var e=this.props,t=e.placement,n=e.eventsEnabled,r=c({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(r.arrow={
	element:this._arrowNode}),this._popper=new m.default(this._getTargetNode(),this._node,{placement:t,eventsEnabled:n,modifiers:r}),this._popper.scheduleUpdate()}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this,t=this.props,n=t.component,r=t.innerRef,i=(t.placement,t.eventsEnabled,t.modifiers,t.children),s=a(t,["component","innerRef","placement","eventsEnabled","modifiers","children"]),p=function(t){e._node=t,"function"==typeof r&&r(t)},u=this._getPopperStyle(),f=this._getPopperPlacement();if("function"==typeof i){var d=o({ref:p,style:u},"data-placement",f);return i({popperProps:d,restProps:s,scheduleUpdate:this._popper&&this._popper.scheduleUpdate})}var h=c({},s,{style:c({},s.style,u),"data-placement":f});return"string"==typeof n?h.ref=p:h.innerRef=p,(0,l.createElement)(n,h,i)}}]),t}(l.Component);b.contextTypes={popperManager:d.default.object.isRequired},b.childContextTypes={popper:d.default.object.isRequired},b.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(m.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},b.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=b},function(e,t,n){(function(t){/**!
		 * @fileOverview Kickass library to create and place poppers near their reference elements.
		 * @version 1.12.3
		 * @license
		 * Copyright (c) 2016 Federico Zivolo and contributors
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining a copy
		 * of this software and associated documentation files (the "Software"), to deal
		 * in the Software without restriction, including without limitation the rights
		 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		 * copies of the Software, and to permit persons to whom the Software is
		 * furnished to do so, subject to the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be included in all
		 * copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		 * SOFTWARE.
		 */
	!function(t,n){e.exports=n()}(this,function(){"use strict";function e(e){var t=!1,n=0,r=document.createElement("span"),o=new MutationObserver(function(){e(),t=!1});return o.observe(r,{attributes:!0}),function(){t||(t=!0,r.setAttribute("x-index",n),n+=1)}}function n(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},ce))}}function r(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function o(e,t){if(1!==e.nodeType)return[];var n=window.getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function i(e){if(!e||["HTML","BODY","#document"].indexOf(e.nodeName)!==-1)return window.document.body;var t=o(e),n=t.overflow,r=t.overflowX,s=t.overflowY;return/(auto|scroll)/.test(n+s+r)?e:i(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?["TD","TABLE"].indexOf(t.nodeName)!==-1&&"static"===o(t,"position")?s(t):t:window.document.documentElement}function p(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function c(e){return null!==e.parentNode?c(e.parentNode):e}function u(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return window.document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,a=document.createRange();a.setStart(r,0),a.setEnd(o,0);var i=a.commonAncestorContainer;if(e!==i&&t!==i||r.contains(o))return p(i)?i:s(i);var l=c(e);return l.host?u(l.host,t):u(e,c(t).host)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=window.document.documentElement,a=window.document.scrollingElement||o;return a[n]}return e[n]}function f(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=l(t,"top"),o=l(t,"left"),a=n?-1:1;return e.top+=r*a,e.bottom+=r*a,e.left+=o*a,e.right+=o*a,e}function d(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return+e["border"+n+"Width"].split("px")[0]+ +e["border"+r+"Width"].split("px")[0]}function h(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],he()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function m(){var e=window.document.body,t=window.document.documentElement,n=he()&&window.getComputedStyle(t);return{height:h("Height",e,t,n),width:h("Width",e,t,n)}}function y(e){return be({},e,{right:e.left+e.width,bottom:e.top+e.height})}function v(e){var t={};if(he())try{t=e.getBoundingClientRect();var n=l(e,"top"),r=l(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var a={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?m():{},s=i.width||e.clientWidth||a.right-a.left,p=i.height||e.clientHeight||a.bottom-a.top,c=e.offsetWidth-s,u=e.offsetHeight-p;if(c||u){var f=o(e);c-=d(f,"x"),u-=d(f,"y"),a.width-=c,a.height-=u}return y(a)}function b(e,t){var n=he(),r="HTML"===t.nodeName,a=v(e),s=v(t),p=i(e),c=o(t),u=+c.borderTopWidth.split("px")[0],l=+c.borderLeftWidth.split("px")[0],d=y({top:a.top-s.top-u,left:a.left-s.left-l,width:a.width,height:a.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=+c.marginTop.split("px")[0],m=+c.marginLeft.split("px")[0];d.top-=u-h,d.bottom-=u-h,d.left-=l-m,d.right-=l-m,d.marginTop=h,d.marginLeft=m}return(n?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(d=f(d,t)),d}function g(e){var t=window.document.documentElement,n=b(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),a=l(t),i=l(t,"left"),s={top:a-n.top+n.marginTop,left:i-n.left+n.marginLeft,width:r,height:o};return y(s)}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===o(e,"position")||w(a(e)))}function _(e,t,n,r){var o={top:0,left:0},s=u(e,t);if("viewport"===r)o=g(s);else{var p=void 0;"scrollParent"===r?(p=i(a(e)),"BODY"===p.nodeName&&(p=window.document.documentElement)):p="window"===r?window.document.documentElement:r;var c=b(p,s);if("HTML"!==p.nodeName||w(s))o=c;else{var l=m(),f=l.height,d=l.width;o.top+=c.top-c.marginTop,o.bottom=f+c.top,o.left+=c.left-c.marginLeft,o.right=d+c.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function D(e){var t=e.width,n=e.height;return t*n}function k(e,t,n,r,o){var a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(e.indexOf("auto")===-1)return e;var i=_(n,r,a,o),s={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},p=Object.keys(s).map(function(e){return be({key:e},s[e],{area:D(s[e])})}).sort(function(e,t){return t.area-e.area}),c=p.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),u=c.length>0?c[0].key:p[0].key,l=e.split("-")[1];return u+(l?"-"+l:"")}function O(e,t,n){var r=u(t,n);return b(n,r)}function E(e){var t=window.getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight),o={width:e.offsetWidth+r,height:e.offsetHeight+n};return o}function C(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function S(e,t,n){n=n.split("-")[0];var r=E(e),o={width:r.width,height:r.height},a=["right","left"].indexOf(n)!==-1,i=a?"top":"left",s=a?"left":"top",p=a?"height":"width",c=a?"width":"height";return o[i]=t[i]+t[p]/2-r[p]/2,n===s?o[s]=t[s]-r[c]:o[s]=t[C(s)],o}function M(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function P(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=M(e,function(e){return e[t]===n});return e.indexOf(r)}function T(e,t,n){var o=void 0===n?e:e.slice(0,P(e,"name",n));return o.forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&r(n)&&(t.offsets.popper=y(t.offsets.popper),t.offsets.reference=y(t.offsets.reference),t=n(t,e))}),t}function x(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=O(this.state,this.popper,this.reference),e.placement=k(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=S(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=T(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function N(e,t){return e.some(function(e){var n=e.name,r=e.enabled;return r&&n===t})}function j(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],a=o?""+o+n:e;if("undefined"!=typeof window.document.body.style[a])return a}return null}function R(){return this.state.isDestroyed=!0,N(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[j("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function W(e,t,n,r){var o="BODY"===e.nodeName,a=o?window:e;a.addEventListener(t,n,{passive:!0}),o||W(i(a.parentNode),t,n,r),r.push(a)}function I(e,t,n,r){n.updateBound=r,window.addEventListener("resize",n.updateBound,{passive:!0});var o=i(e);return W(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function L(){this.state.eventsEnabled||(this.state=I(this.reference,this.options,this.state,this.scheduleUpdate))}function A(e,t){return window.removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function F(){this.state.eventsEnabled&&(window.cancelAnimationFrame(this.scheduleUpdate),this.state=A(this.reference,this.state))}function B(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function Y(e,t){Object.keys(t).forEach(function(n){var r="";["width","height","top","right","bottom","left"].indexOf(n)!==-1&&B(t[n])&&(r="px"),e.style[n]=t[n]+r})}function H(e,t){Object.keys(t).forEach(function(n){var r=t[n];r!==!1?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function U(e){return Y(e.instance.popper,e.styles),H(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&Y(e.arrowElement,e.arrowStyles),e}function V(e,t,n,r,o){var a=O(o,t,e),i=k(n.placement,a,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",i),Y(t,{position:"absolute"}),n}function q(e,t){var n=t.x,r=t.y,o=e.offsets.popper,a=M(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==a&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==a?a:t.gpuAcceleration,p=s(e.instance.popper),c=v(p),u={position:o.position},l={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},f="bottom"===n?"top":"bottom",d="right"===r?"left":"right",h=j("transform"),m=void 0,y=void 0;if(y="bottom"===f?-c.height+l.bottom:l.top,m="right"===d?-c.width+l.right:l.left,i&&h)u[h]="translate3d("+m+"px, "+y+"px, 0)",u[f]=0,u[d]=0,u.willChange="transform";else{var b="bottom"===f?-1:1,g="right"===d?-1:1;u[f]=y*b,u[d]=m*g,u.willChange=f+", "+d}var w={"x-placement":e.placement};return e.attributes=be({},w,e.attributes),e.styles=be({},u,e.styles),e.arrowStyles=be({},e.offsets.arrow,e.arrowStyles),e}function K(e,t,n){var r=M(e,function(e){var n=e.name;return n===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var a="`"+t+"`",i="`"+n+"`";console.warn(i+" modifier is required by "+a+" modifier in order to work, be sure to include it before "+a+"!")}return o}function z(e,t){if(!K(e.instance.modifiers,"arrow","keepTogether"))return e;var n=t.element;if("string"==typeof n){if(n=e.instance.popper.querySelector(n),!n)return e}else if(!e.instance.popper.contains(n))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var r=e.placement.split("-")[0],a=e.offsets,i=a.popper,s=a.reference,p=["left","right"].indexOf(r)!==-1,c=p?"height":"width",u=p?"Top":"Left",l=u.toLowerCase(),f=p?"left":"top",d=p?"bottom":"right",h=E(n)[c];s[d]-h<i[l]&&(e.offsets.popper[l]-=i[l]-(s[d]-h)),s[l]+h>i[d]&&(e.offsets.popper[l]+=s[l]+h-i[d]);var m=s[l]+s[c]/2-h/2,v=o(e.instance.popper,"margin"+u).replace("px",""),b=m-y(e.offsets.popper)[l]-v;return b=Math.max(Math.min(i[c]-h,b),0),e.arrowElement=n,e.offsets.arrow={},e.offsets.arrow[l]=Math.round(b),e.offsets.arrow[f]="",e}function G(e){return"end"===e?"start":"start"===e?"end":e}function X(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=we.indexOf(e),r=we.slice(n+1).concat(we.slice(0,n));return t?r.reverse():r}function J(e,t){if(N(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=_(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=C(r),a=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case _e.FLIP:i=[r,o];break;case _e.CLOCKWISE:i=X(r);break;case _e.COUNTERCLOCKWISE:i=X(r,!0);break;default:i=t.behavior}return i.forEach(function(s,p){if(r!==s||i.length===p+1)return e;r=e.placement.split("-")[0],o=C(r);var c=e.offsets.popper,u=e.offsets.reference,l=Math.floor,f="left"===r&&l(c.right)>l(u.left)||"right"===r&&l(c.left)<l(u.right)||"top"===r&&l(c.bottom)>l(u.top)||"bottom"===r&&l(c.top)<l(u.bottom),d=l(c.left)<l(n.left),h=l(c.right)>l(n.right),m=l(c.top)<l(n.top),y=l(c.bottom)>l(n.bottom),v="left"===r&&d||"right"===r&&h||"top"===r&&m||"bottom"===r&&y,b=["top","bottom"].indexOf(r)!==-1,g=!!t.flipVariations&&(b&&"start"===a&&d||b&&"end"===a&&h||!b&&"start"===a&&m||!b&&"end"===a&&y);(f||v||g)&&(e.flipped=!0,(f||v)&&(r=i[p+1]),g&&(a=G(a)),e.placement=r+(a?"-"+a:""),e.offsets.popper=be({},e.offsets.popper,S(e.instance.popper,e.offsets.reference,e.placement)),e=T(e.instance.modifiers,e,"flip"))}),e}function Q(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],a=Math.floor,i=["top","bottom"].indexOf(o)!==-1,s=i?"right":"bottom",p=i?"left":"top",c=i?"width":"height";return n[s]<a(r[p])&&(e.offsets.popper[p]=a(r[p])-n[c]),n[p]>a(r[s])&&(e.offsets.popper[p]=a(r[s])),e}function Z(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),a=+o[1],i=o[2];if(!a)return e;if(0===i.indexOf("%")){var s=void 0;switch(i){case"%p":s=n;break;case"%":case"%r":default:s=r}var p=y(s);return p[t]/100*a}if("vh"===i||"vw"===i){var c=void 0;return c="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),c/100*a}return a}function $(e,t,n,r){var o=[0,0],a=["right","left"].indexOf(r)!==-1,i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=i.indexOf(M(i,function(e){return e.search(/,|\s/)!==-1}));i[s]&&i[s].indexOf(",")===-1&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var p=/\s*,\s*|\s+/,c=s!==-1?[i.slice(0,s).concat([i[s].split(p)[0]]),[i[s].split(p)[1]].concat(i.slice(s+1))]:[i];return c=c.map(function(e,r){var o=(1===r?!a:a)?"height":"width",i=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&["+","-"].indexOf(t)!==-1?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return Z(e,o,t,n)})}),c.forEach(function(e,t){e.forEach(function(n,r){B(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function ee(e,t){var n=t.offset,r=e.placement,o=e.offsets,a=o.popper,i=o.reference,s=r.split("-")[0],p=void 0;return p=B(+n)?[+n,0]:$(n,a,i,s),"left"===s?(a.top+=p[0],a.left-=p[1]):"right"===s?(a.top+=p[0],a.left+=p[1]):"top"===s?(a.left+=p[0],a.top-=p[1]):"bottom"===s&&(a.left+=p[0],a.top+=p[1]),e.popper=a,e}function te(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=_(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,a=e.offsets.popper,i={primary:function(e){var n=a[e];return a[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(a[e],r[e])),ve({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=a[n];return a[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(a[n],r[e]-("right"===e?a.width:a.height))),ve({},n,o)}};return o.forEach(function(e){var t=["left","top"].indexOf(e)!==-1?"primary":"secondary";a=be({},a,i[t](e))}),e.offsets.popper=a,e}function ne(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,a=o.reference,i=o.popper,s=["bottom","top"].indexOf(n)!==-1,p=s?"left":"top",c=s?"width":"height",u={start:ve({},p,a[p]),end:ve({},p,a[p]+a[c]-i[c])};e.offsets.popper=be({},i,u[r])}return e}function re(e){if(!K(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=M(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(e.hide===!0)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(e.hide===!1)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function oe(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,a=r.reference,i=["left","right"].indexOf(n)!==-1,s=["top","left"].indexOf(n)===-1;return o[i?"left":"top"]=a[n]-(s?o[i?"width":"height"]:0),e.placement=C(t),e.offsets.popper=y(o),e}for(var ae=["native code","[object MutationObserverConstructor]"],ie=function(e){return ae.some(function(t){return(e||"").toString().indexOf(t)>-1})},se="undefined"!=typeof window,pe=["Edge","Trident","Firefox"],ce=0,ue=0;ue<pe.length;ue+=1)if(se&&navigator.userAgent.indexOf(pe[ue])>=0){ce=1;break}var le=se&&ie(window.MutationObserver),fe=le?e:n,de=void 0,he=function(){return void 0===de&&(de=navigator.appVersion.indexOf("MSIE 10")!==-1),de},me=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},ye=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ve=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],we=ge.slice(3),_e={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},De={shift:{order:100,enabled:!0,fn:ne},offset:{order:200,enabled:!0,fn:ee,offset:0},preventOverflow:{order:300,enabled:!0,fn:te,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Q},arrow:{order:500,enabled:!0,fn:z,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:J,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:oe},hide:{order:800,enabled:!0,fn:re},computeStyle:{order:850,enabled:!0,fn:q,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:U,onLoad:V,gpuAcceleration:void 0}},ke={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:De},Oe=function(){function e(t,n){var o=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};me(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=fe(this.update.bind(this)),this.options=be({},e.Defaults,a),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t.jquery?t[0]:t,this.popper=n.jquery?n[0]:n,this.options.modifiers={},Object.keys(be({},e.Defaults.modifiers,a.modifiers)).forEach(function(t){o.options.modifiers[t]=be({},e.Defaults.modifiers[t]||{},a.modifiers?a.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return be({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&r(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return ye(e,[{key:"update",value:function(){return x.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return L.call(this)}},{key:"disableEventListeners",value:function(){return F.call(this)}}]),e}();return Oe.Utils=("undefined"!=typeof window?window:t).PopperUtils,Oe.placements=ge,Oe.Defaults=ke,Oe})}).call(t,function(){return this}())},function(e,t,n){/*!
		 * is-equal-shallow <https://github.com/jonschlinkert/is-equal-shallow>
		 *
		 * Copyright (c) 2015, Jon Schlinkert.
		 * Licensed under the MIT License.
		 */
	"use strict";var r=n(28);e.exports=function(e,t){if(!e&&!t)return!0;if(!e&&t||e&&!t)return!1;var n,o=0,a=0;for(n in t)if(a++,!r(t[n])||!e.hasOwnProperty(n)||e[n]!==t[n])return!1;for(n in e)o++;return o===a}},function(e,t){/*!
		 * is-primitive <https://github.com/jonschlinkert/is-primitive>
		 *
		 * Copyright (c) 2014-2015, Jon Schlinkert.
		 * Licensed under the MIT License.
		 */
	"use strict";e.exports=function(e){return null==e||"function"!=typeof e&&"object"!=typeof e}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"span":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popper,l=function(e){u.setArrowNode(e),"function"==typeof s&&s(e)},f=u.getArrowStyle();if("function"==typeof p){var d={ref:l,style:f};return p({arrowProps:d,restProps:c})}var h=a({},c,{style:a({},f,c.style)});return"string"==typeof r?h.ref=l:h.innerRef=l,(0,i.createElement)(r,h,p)};c.contextTypes={popper:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c}])});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel_1 = __webpack_require__(714);
	exports.LogLevel = loglevel_1.LogLevel;
	var session_1 = __webpack_require__(715);
	exports.SessionStatus = session_1.SessionStatus;
	var severity_1 = __webpack_require__(716);
	exports.Severity = severity_1.Severity;
	var status_1 = __webpack_require__(717);
	exports.Status = status_1.Status;
	var transaction_1 = __webpack_require__(718);
	exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3812);
	
	var PaginationControls = function PaginationControls(props) {
		var page = props.page;
		var startIndex = (page - 1) * props.perPage;
		var endIndex = Math.min(startIndex + props.perPage, props.totalCount);
		var maxPage = Math.ceil(props.totalCount / props.perPage);
	
		var setPage = function setPage(pageIndex, e) {
			$wr.nope(e);
			if (props.onPageChange) {
				props.onPageChange(pageIndex);
			}
		};
	
		if (props.perPageOptions) {
			var setPerPage = function setPerPage(perPage, e) {
				if (props.onPageChange) {
					props.onPageChange(1, perPage);
				}
			};
	
			var perPageOps = DropDownOptions.Button.simpleText({
				options: props.perPageOptions.map(function (x) {
					return x.toString();
				}), onClick: setPerPage
			});
			var perPageMenu = React.createElement(
				"span",
				{ className: "perPage" },
				"(",
				React.createElement(
					ButtonDropdown,
					{ text: "Show: " + props.perPage, dropdownDisplay: "link" },
					perPageOps
				),
				")"
			);
		}
	
		return React.createElement(
			"div",
			{ className: "paginationControls hideOnPrint" },
			React.createElement(
				"span",
				{ style: { visibility: page == 1 ? "hidden" : "visible" } },
				React.createElement(
					"a",
					{ href: "#", className: "hideOnPrint control",
						onClick: setPage.bind(this, 1) },
					React.createElement(Glyphicon, { icon: "backward" }),
					" First"
				),
				React.createElement(
					"a",
					{ href: "#", className: "hideOnPrint control",
						onClick: setPage.bind(this, page - 1) },
					React.createElement(Glyphicon, { icon: "triangle-left" }),
					" Previous"
				)
			),
			React.createElement(
				"span",
				{ className: "pageLabel" },
				startIndex + 1,
				"-",
				endIndex,
				" of ",
				props.totalCount,
				" ",
				perPageMenu
			),
			React.createElement(
				"span",
				{ style: { visibility: page == maxPage ? "hidden" : "visible" } },
				React.createElement(
					"a",
					{ href: "#", className: "hideOnPrint control",
						onClick: setPage.bind(this, page + 1) },
					"Next ",
					React.createElement(Glyphicon, { icon: "triangle-right" })
				),
				React.createElement(
					"a",
					{ href: "#", className: "hideOnPrint control",
						onClick: setPage.bind(this, maxPage) },
					"Last ",
					React.createElement(Glyphicon, { icon: "forward" })
				)
			)
		);
	};
	
	PaginationControls.propTypes = StrictPropTypes({
		page: PropTypes.number.isRequired,
		perPage: PropTypes.number.isRequired,
		totalCount: PropTypes.number.isRequired,
	
		perPageOptions: PropTypes.array,
	
		// 1st arg, page number. 2nd arg (optional) perPage number
		onPageChange: PropTypes.func
	});
	
	PaginationControls.DEFAULT_PAGE_OPTIONS = [20, 50, 100, 250, 1000];
	
	module.exports = PaginationControls;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	
	__webpack_require__(3819);
	
	var ValidatingInput = function (_React$Component) {
		_inherits(ValidatingInput, _React$Component);
	
		function ValidatingInput(props) {
			_classCallCheck(this, ValidatingInput);
	
			var _this = _possibleConstructorReturn(this, (ValidatingInput.__proto__ || Object.getPrototypeOf(ValidatingInput)).call(this));
	
			autobind(_this);
			_this.state = {
				error: null
			};
			return _this;
		}
	
		_createClass(ValidatingInput, [{
			key: "val",
			value: function val() {
				if (this.props.type == "proxy") {
					return this.props.proxySource() || "";
				} else if (this.props.type == "button-dropdown") {
					return this.refs.input.val();
				} else {
					return this.refs.input.value;
				}
			}
		}, {
			key: "focus",
			value: function focus() {
				this.refs.input.focus();
			}
		}, {
			key: "reset",
			value: function reset() {
				// Assumes this is define
				if (this.refs.input.reset) {
					this.refs.input.reset();
				} else {
					this.refs.input.value = "";
				}
			}
	
			// Return true if the input is valid, false otherwise
			//    by default, it'll display the error message, unless changeErrorState is false
	
		}, {
			key: "validate",
			value: function validate(changeErrorState) {
				changeErrorState = changeErrorState !== false;
	
				var text = this.val();
	
				// If validators aren't an array, make it so
				var validators = this.props.validators || [];
				if (!_.isArray(validators)) {
					validators = [validators];
				}
	
				for (var i = 0; i < validators.length; i += 1) {
					var errorMessage = validators[i](text, this.props.inputName);
					if (errorMessage) {
						var useMessage = this.props.errorMessage ? this.props.errorMessage : errorMessage;
						if (changeErrorState) {
							this.setState({ error: useMessage });
						}
						return false;
					} else if (changeErrorState) {
						this.setState({ error: null });
					}
				}
	
				return true;
			}
		}, {
			key: "resetErrors",
			value: function resetErrors() {
				this.setState({ error: null });
			}
	
			// removes/changes error message after a change
	
		}, {
			key: "checkResetError",
			value: function checkResetError() {
				// Don't ever ADD errors
				if (this.state.error && this.validate(false)) {
					this.resetErrors();
				}
			}
		}, {
			key: "render",
			value: function render() {
				var inputProps = _.omit(this.props, "type", "inputName", "validators", "errorMessage", "selectOptions", "inputClassName", "className", "defaultSubText", "proxySource");
	
				inputProps.className = this.state.error ? "errorInput" : "";
				if (this.props.inputClassName) {
					inputProps.className += " " + this.props.inputClassName;
				}
	
				if (this.props.type == "select") {
					inputProps.onChange = function () {
						this.checkResetError();
						if (this.props.onChange) {
							this.props.onChange();
						}
					}.bind(this);
					var input = React.createElement(
						"select",
						_extends({ ref: "input" }, inputProps),
						this.props.selectOptions
					);
				} else if (this.props.type == "button-dropdown") {
					if (inputProps.onChange) inputProps.onChange = function () {
						this.checkResetError();
						if (this.props.onChange) {
							this.props.onChange();
						}
					}.bind(this);
					var input = React.createElement(
						ButtonDropdown,
						_extends({ ref: "input", dropdownDisplay: "link",
							inputMode: true }, inputProps),
						this.props.selectOptions
					);
				} else if (this.props.type == "textarea") {
					inputProps.onKeyUp = this.checkResetError;
					var input = React.createElement("textarea", _extends({ ref: "input" }, inputProps));
				} else if (this.props.type == "proxy") {
					var input = undefined;
				} else {
					inputProps.onKeyUp = this.checkResetError;
					var input = React.createElement("input", _extends({ ref: "input" }, inputProps, { type: this.props.type || "text" }));
				}
	
				if (this.state.error) {
					var subDisplay = React.createElement(
						"p",
						{ className: "subText errorDisplay" },
						this.state.error
					);
				} else if (this.props.defaultSubText) {
					var subDisplay = React.createElement(
						"p",
						{ className: "subText" },
						this.props.defaultSubText
					);
				}
	
				var className = "validatingInput";
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				return React.createElement(
					"div",
					{ className: className },
					input,
					subDisplay
				);
			}
		}]);
	
		return ValidatingInput;
	}(React.Component);
	
	;
	
	ValidatingInput.Validators = {
		PRESENT: function PRESENT(text, inputName) {
			inputName = inputName || "This input";
	
			if (text == undefined || text.trim().length == 0) {
				return inputName + " is required";
			}
			return null;
		},
	
		EMAIL: function EMAIL(text, inputName) {
			inputName = inputName || "This email";
	
			if (!ValidatingInput.EMAIL_REGEX.test(text)) {
				return inputName + " isn't valid";
			}
			return null;
		},
	
		URL: function URL(text, inputName) {
			inputName = inputName || "This website URL";
	
			if (!ValidatingInput.URL_REGEX.test(text)) {
				return inputName + " isn't valid";
			}
			return null;
		},
	
		INTEGER: function INTEGER(text, inputName) {
			inputName = inputName || "This input";
	
			if (parseInt(text) == NaN) {
				return inputName + " must be a number";
			}
	
			return null;
		},
	
		POSITIVE_INTEGER: function POSITIVE_INTEGER(text, inputName) {
			inputName = inputName || "This input";
	
			if (parseInt(text) == NaN) {
				return inputName + " must be a number";
			} else if (parseInt(text) < 1) {
				return inputName + " must be positive";
			}
			return null;
		},
	
		NON_NEGATIVE: function NON_NEGATIVE(text, inputName) {
			if (parseInt(text) != NaN && parseInt(text) < 0) {
				return inputName + " can't be negative";
			}
			return null;
		},
	
		minLength: function minLength(_minLength) {
			return function (text, inputName) {
				inputName = inputName || "This input";
				if (text.trim().length < _minLength) {
					var noun = _minLength == 1 ? "character" : "characters";
					return inputName + " must be " + _minLength + "+ " + noun;
				}
				return null;
			};
		},
	
		not: function not(avoidValue) {
			return function (text, inputName) {
				inputName = inputName || "This input";
				if (text.trim() == avoidValue) {
					return inputName + " may not be '" + avoidValue + "'";
				}
				return null;
			};
		},
	
		FITB: function FITB(text) {
			var validationPattern = /(\s|^)____(\W|$)/g;
			if (!text.match(validationPattern)) {
				return "Your question needs to have a blank that looks like this ____ (4 underscores).";
			}
			if ((text.match(validationPattern) || []).length > 1) {
				return "Your question can only have one blank in it.";
			}
			return null;
		}
	};
	
	ValidatingInput.RESET_EVENT = "validator-input-reset";
	ValidatingInput.EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	ValidatingInput.URL_REGEX = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
	
	ValidatingInput.propTypes = StrictPropTypes({
		// Type of input (including 'select' or 'textarea'). Default is 'text'
		//    Type 'proxy' means that this will draw the value off a function passed as a prop
		type: PropTypes.oneOf(["text", "password", "email", "textarea", "select", "button-dropdown", "proxy", "number"]),
	
		// Name of the input, passed to the validators for the error message
		inputName: PropTypes.string,
	
		// Contains array of validating functions or a single function
		// => Functions should return error message (if invalid) or a falsy value (if valid),
		//    (this is backwards of how many validators work) 
		// => Validators will be run in order, stopping at the first invalid test
		validators: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
	
		// Array of options (only used if type == select or button-dropdown)
		selectOptions: PropTypes.array,
	
		// className to pass on the input
		inputClassName: PropTypes.string,
	
		// className for our wrapper
		className: PropTypes.string,
	
		// overrides the default error message returned from validators
		errorMessage: PropTypes.string,
	
		// text to display under the input even when there's no error
		defaultSubText: PropTypes.string,
	
		// Provides the value instead of the input itself
		proxySource: PropTypes.func,
	
		// Other props are passed on to the input with { ...this.props }
		placeholder: PropTypes.string,
		defaultValue: PropTypes.string,
		defaultText: PropTypes.string,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		onKeyDown: PropTypes.func
	});
	
	module.exports = ValidatingInput;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/owl_shop";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
		} else {
			state.activeView = VIEWS.SHOP;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/owl_shop/:active_view?";
	
	var VIEWS = exports.VIEWS = {
		SHOP: "shop",
		PHOTOS: "photos"
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	var OrgTypes = __webpack_require__(45);
	
	function getPath(state) {
		var fullPath = "/roster";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
			if (state.orgIdentifier) {
				fullPath += "/" + state.orgIdentifier;
			}
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
			if (params.org_identifier) {
				state.orgIdentifier = params.org_identifier;
			} else {
				state.orgIdentifier = OrgTypes.ALL_STUDENTS_IDENTIFIER;
			}
		} else {
			state.activeView = VIEWS.ROSTER;
			state.orgIdentifier = OrgTypes.ALL_STUDENTS_IDENTIFIER;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/roster/:active_view?/:org_identifier?";
	
	var VIEWS = exports.VIEWS = {
		ROSTER: "roster",
		GOALS: "goals",
		LEVELS: "levels"
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getFurnitures = exports.getPerksByNameAndType = exports.getFilteredPerks = exports.getPerks = exports.getPatchesByNameAndType = exports.getFilteredPatches = exports.getPatches = undefined;
	exports.photographs = photographs;
	exports.photograph = photograph;
	exports.isLoadingPhotographs = isLoadingPhotographs;
	
	var _ShopSales = __webpack_require__(123);
	
	var _ShopSales2 = _interopRequireDefault(_ShopSales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectorUtility = __webpack_require__(144);
	
	var getPatches = exports.getPatches = function getPatches(_ref) {
		var state = _ref.state,
		    filters = _ref.filters,
		    conditions = _ref.conditions;
		return SelectorUtility.filterBy(state.patches, filters, conditions);
	};
	
	var getFilteredPatches = exports.getFilteredPatches = function getFilteredPatches(_ref2) {
		var state = _ref2.state;
		return _.select(getPatches({ state: state }), function (patch) {
			return patch.owned || patch.source == "default" || patch.source == "store" || _ShopSales2.default.isOnSale(patch.origin_patch_type, patch.name);
		});
	};
	
	var getPatchesByNameAndType = exports.getPatchesByNameAndType = function getPatchesByNameAndType(_ref3) {
		var state = _ref3.state,
		    name = _ref3.name,
		    originType = _ref3.originType;
	
		var r = _.select(getFilteredPatches({ state: state }), function (patch) {
			return patch.name == name && patch.origin_patch_type == originType;
		});
		return r;
	};
	
	var getPerks = exports.getPerks = function getPerks(_ref4) {
		var state = _ref4.state,
		    filters = _ref4.filters,
		    conditions = _ref4.conditions;
		return SelectorUtility.filterBy(state.perks, filters, conditions);
	};
	
	var getFilteredPerks = exports.getFilteredPerks = function getFilteredPerks(_ref5) {
		var state = _ref5.state;
		return _.select(getPerks({ state: state }), function (perk) {
			return perk.owned || perk.source == "default" || perk.source == "store";
		});
	};
	
	var getPerksByNameAndType = exports.getPerksByNameAndType = function getPerksByNameAndType(_ref6) {
		var state = _ref6.state,
		    name = _ref6.name,
		    type = _ref6.type;
	
		var r = _.select(getFilteredPerks({ state: state }), function (perk) {
			return perk.name == name && perk.perk_type == type;
		});
		return r;
	};
	var getFurnitures = exports.getFurnitures = function getFurnitures(_ref7) {
		var state = _ref7.state,
		    filters = _ref7.filters,
		    conditions = _ref7.conditions;
		return SelectorUtility.filterBy(state.furnitures, filters, conditions);
	};
	
	function photographs(_ref8) {
		var state = _ref8.state,
		    filters = _ref8.filters,
		    conditions = _ref8.conditions;
	
		return SelectorUtility.filterBy(state.photographs, filters, conditions);
	}
	
	function photograph(_ref9) {
		var state = _ref9.state,
		    id = _ref9.id;
	
		return state.photographs[id];
	}
	
	function isLoadingPhotographs(_ref10) {
		var state = _ref10.state,
		    key = _ref10.key;
	
		key = key || "index";
		return state.photographs.loading[key];
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.receiveHello = receiveHello;
	exports.fetchHello = fetchHello;
	exports.receiveRecords = receiveRecords;
	exports.fetchRecords = fetchRecords;
	exports.fetchRecord = fetchRecord;
	exports.clearLoadingRecords = clearLoadingRecords;
	exports.setLoadingRecords = setLoadingRecords;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	
	var RECEIVE_RECORDS = exports.RECEIVE_RECORDS = "RECEIVE_RECORDS";
	var REMOVE_RECORDS = exports.REMOVE_RECORDS = "REMOVE_RECORDS";
	var REMOVE_ALL_RECORDS = exports.REMOVE_ALL_RECORDS = "REMOVE_ALL_RECORDS";
	var UPDATE_RECORDS = exports.UPDATE_RECORDS = "UPDATE_RECORDS";
	var LOADING_RECORDS = exports.LOADING_RECORDS = "LOADING_RECORDS";
	var CLEAR_LOADING_RECORDS = exports.CLEAR_LOADING_RECORDS = "CLEAR_LOADING_RECORDS";
	var INVALIDATE_CACHE = exports.INVALIDATE_CACHE = "INVALIDATE_CACHE";
	var RECEIVE_HELLO = exports.RECEIVE_HELLO = "RECEIVE_HELLO";
	
	function receiveHello(data) {
		return {
			type: RECEIVE_HELLO,
			data: data
		};
	}
	
	// Testing async pipeline and connection to server
	function fetchHello() {
		return function (dispatch) {
			return APIClient.getHello().then(function (json) {
				return dispatch(receiveHello(json));
			});
		};
	}
	
	function getCacheObject(cacheKey, queryOps) {
		if (cacheKey === true) {
			return queryOps;
		} else {
			return _.extend({}, queryOps, { key: cacheKey });
		}
	}
	
	function receiveRecords(recordData, recordSchema) {
		var queryOps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var keyOps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		if (keyOps.preSchemaF) {
			keyOps.preSchemaF(recordData);
		}
		var entities = Schema.entities(recordData, recordSchema);
	
		if (_.isEmpty(entities) && keyOps.reducer) {
			// Create an empty object to trigger actions in the reducers even
			// For empty arrays
			entities = _defineProperty({}, keyOps.reducer, {});
		}
	
		var eventData = {
			type: RECEIVE_RECORDS
		};
	
		eventData.metaReducer = keyOps.reducer;
	
		if (keyOps.mapRecordF) {
			entities = _.mapObject(entities, function (items, key) {
				return _.map(items, function (x) {
					return keyOps.mapRecordF(x, key);
				});
			});
		}
	
		if ("loading" in keyOps) {
			eventData.loadingKeys = [keyOps.loading];
		}
		if (keyOps.cache) {
			eventData.cache = [getCacheObject(keyOps.cache, queryOps)];
		}
		if (keyOps.pagination) {
			eventData.pagination = keyOps.pagination;
			if (recordData[keyOps.reducer]) {
				var records = recordData[keyOps.reducer];
			} else {
				var records = _.first(_.values(recordData));
			}
	
			if (records && records.length < parseInt(recordData.per_page)) {
				eventData.noMorePages = true;
			}
		}
	
		var query = $wr.sortedJSON(queryOps.params || {});
		if ("total" in recordData) {
			eventData.totals = _defineProperty({}, query, recordData.total);
		}
	
		var receivedAt = Date.now();
	
		_.each(entities, function (items, entityKey) {
			eventData[entityKey] = _.map(items, function (item) {
				return _.extend({}, item, {
					receivedAt: receivedAt,
					embeds: queryOps.embeds
				});
			});
		});
	
		return eventData;
	}
	
	// Generic action creator for async fetching multiple records
	function fetchRecords(fetchF, schema) {
		var queryOps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var keyOps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		var query = _.clone(queryOps.params || {}); // Ok to be undefined
		if (queryOps.embeds && queryOps.embeds.length > 0) {
			query.embed = queryOps.embeds.join(",");
		}
	
		if (queryOps.page !== undefined) {
			query.page = queryOps.page;
		}
	
		return function (dispatch, getState) {
			if (keyOps.reducer && keyOps.cache) {
				var cacheObject = getCacheObject(keyOps.cache, queryOps);
	
				var scopeData = getState()[keyOps.reducer];
				if (scopeData && inIndexCache(cacheObject, scopeData.cached)) {
					return Promise.resolve();
				}
			}
	
			if (keyOps.reducer && keyOps.loading) {
				dispatch(loadingRecords(keyOps.reducer, keyOps.loading));
			}
			return fetchF(query).then(function (data) {
				if (data.patches) {
					data.patches = data.patches.map(function (patch) {
						return _extends({}, patch, {
							id: patch.patch_type + "-" + patch.name
						});
					});
				}
				if (data.perks) {
					data.perks = data.perks.map(function (perk) {
						return _extends({}, perk, {
							id: perk.perk_type + "-" + perk.name
						});
					});
				}
				if (query.furniture_only === true) {
					data.furnitures = data.perks;
					data.perks = null;
				}
				return dispatch(receiveRecords(data, schema, queryOps, keyOps));
			});
		};
	}
	
	function fetchRecord(fetchF, recordID, schema) {
		var queryOps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
		var keyOps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
		var query = _.clone(queryOps.params || {}); // Ok to be undefined
		if (queryOps.embeds) {
			query.embed = queryOps.embeds.join(",");
		}
	
		if (queryOps.page !== undefined) {
			query.page = queryOps.page;
		}
	
		return function (dispatch, getState) {
			if (keyOps.reducer && keyOps.cache) {
				var cacheObject = getCacheObject(keyOps.cache, queryOps);
	
				var scopeData = getState()[keyOps.reducer];
				if (scopeData && inIndexCache(cacheObject, scopeData.cached)) {
					return Promise.resolve();
				}
			}
	
			if (keyOps.reducer && keyOps.loading) {
				loadingRecords(keyOps.reducer, keyOps.loading); // Greg in 2020, no idea why this is here
				// Dispatch event to record the loading state
				// Example action: { type: "LOADING_RECORDS", quizzes: "all" }
				dispatch(_defineProperty({ type: LOADING_RECORDS }, keyOps.reducer, keyOps.loading));
			}
			return fetchF(recordID, query).then(function (data) {
				return dispatch(receiveRecords(data, schema, queryOps, keyOps));
			});
		};
	}
	
	function clearLoadingRecords(reducer) {
		return function (dispatch, getState) {
			return dispatch(_defineProperty({ type: CLEAR_LOADING_RECORDS }, reducer, true));
		};
	}
	
	function setLoadingRecords(reducer, loadingKey) {
		return function (dispatch, getState) {
			return dispatch(_defineProperty({ type: LOADING_RECORDS }, reducer, loadingKey));
		};
	}
	
	/////////////////////////////
	//////// Utility ////////////
	/////////////////////////////
	
	// Dispatch event to record the loading state
	// Example action: { type: "LOADING_RECORDS", quizzes: "all" }
	function loadingRecords(reducer, loadingKey) {
		return _defineProperty({ type: LOADING_RECORDS }, reducer, loadingKey);
	}
	
	function inIndexCache(newCache, cachedQueryOps) {
		return _.any(cachedQueryOps, function (_ref2) {
			var params = _ref2.params,
			    embeds = _ref2.embeds,
			    page = _ref2.page,
			    key = _ref2.key;
	
			// Query, page, and key must be exact matches
			if (!_.isEqual(newCache.params, params) || newCache.page != page || newCache.key != key) {
				return false;
			}
	
			// There can't be any embeds in newCache not already in the cached embeds
			return _.difference(newCache.embeds, embeds).length == 0;
		});
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(478);
	var $export = __webpack_require__(5);
	var shared = __webpack_require__(182)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(482))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(42)) {
	  var LIBRARY = __webpack_require__(112);
	  var global = __webpack_require__(28);
	  var fails = __webpack_require__(30);
	  var $export = __webpack_require__(5);
	  var $typed = __webpack_require__(217);
	  var $buffer = __webpack_require__(285);
	  var ctx = __webpack_require__(77);
	  var anInstance = __webpack_require__(125);
	  var propertyDesc = __webpack_require__(130);
	  var hide = __webpack_require__(60);
	  var redefineAll = __webpack_require__(131);
	  var toInteger = __webpack_require__(79);
	  var toLength = __webpack_require__(39);
	  var toIndex = __webpack_require__(476);
	  var toAbsoluteIndex = __webpack_require__(133);
	  var toPrimitive = __webpack_require__(87);
	  var has = __webpack_require__(67);
	  var classof = __webpack_require__(145);
	  var isObject = __webpack_require__(32);
	  var toObject = __webpack_require__(50);
	  var isArrayIter = __webpack_require__(271);
	  var create = __webpack_require__(127);
	  var getPrototypeOf = __webpack_require__(69);
	  var gOPN = __webpack_require__(128).f;
	  var getIterFn = __webpack_require__(287);
	  var uid = __webpack_require__(134);
	  var wks = __webpack_require__(37);
	  var createArrayMethod = __webpack_require__(84);
	  var createArrayIncludes = __webpack_require__(205);
	  var speciesConstructor = __webpack_require__(183);
	  var ArrayIterators = __webpack_require__(288);
	  var Iterators = __webpack_require__(146);
	  var $iterDetect = __webpack_require__(210);
	  var setSpecies = __webpack_require__(132);
	  var arrayFill = __webpack_require__(263);
	  var arrayCopyWithin = __webpack_require__(448);
	  var $DP = __webpack_require__(47);
	  var $GOPD = __webpack_require__(68);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(3563);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _STAT_DISPLAY;
	
	exports.formatTimestamp = formatTimestamp;
	exports.calculateRubricScore = calculateRubricScore;
	exports.consolidateMonthlyRubrics = consolidateMonthlyRubrics;
	exports.getEntityName = getEntityName;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function formatTimestamp(timestamp) {
	    var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    var dateString = new Date(timestamp);
	    return MONTHS[dateString.getMonth()];
	}
	
	var SCORE_CAP = 4;
	
	var AVG_LEXILE_LEVEL = exports.AVG_LEXILE_LEVEL = "average_lexile_level";
	var TOTAL_QUIZZES = exports.TOTAL_QUIZZES = "total_quizzes";
	var FAILED_QUIZZES = exports.FAILED_QUIZZES = "failed_quizzes";
	var PASSED_QUIZZES = exports.PASSED_QUIZZES = "passed_quizzes";
	var FLAGGED_QUIZZES = exports.FLAGGED_QUIZZES = "flagged_quizzes";
	var TOTAL_WITH_LEXILE = exports.TOTAL_WITH_LEXILE = 'total_with_lexile';
	var AVG_QUIZ_SCORE = exports.AVG_QUIZ_SCORE = "average_quiz_score";
	var DAYS_ACTIVE = exports.DAYS_ACTIVE = "days_active";
	var EXCERCISES_COMPLETED = exports.EXCERCISES_COMPLETED = "excercises_completed";
	var MINUTES_LOGGED = exports.MINUTES_LOGGED = "minutes_logged";
	var PAGES_LOGGED = exports.PAGES_LOGGED = "pages_logged";
	var TOTAL_PRACTICE_QUESTIONS = exports.TOTAL_PRACTICE_QUESTIONS = "total_practice_questions";
	var TOTAL_QUESTION_BUILDERS = exports.TOTAL_QUESTION_BUILDERS = "total_question_builders";
	var TOTAL_REVIEWS = exports.TOTAL_REVIEWS = "total_reviews";
	var TOTAL_EVALUATED_ANSWERS = exports.TOTAL_EVALUATED_ANSWERS = 'total_evaluated_answers';
	var AVG_ANSWER_SCORE = exports.AVG_ANSWER_SCORE = 'average_answer_score';
	
	var QUIZ_PERFORMANCE = exports.QUIZ_PERFORMANCE = 'quiz_performance';
	// all non-rubric activity metrics
	var ACTIVITY_METRICS = exports.ACTIVITY_METRICS = [QUIZ_PERFORMANCE, PASSED_QUIZZES, FAILED_QUIZZES, TOTAL_QUIZZES, FLAGGED_QUIZZES, EXCERCISES_COMPLETED, MINUTES_LOGGED, PAGES_LOGGED, TOTAL_PRACTICE_QUESTIONS, TOTAL_QUESTION_BUILDERS, TOTAL_REVIEWS, AVG_LEXILE_LEVEL];
	
	var MECH_CAPS = exports.MECH_CAPS = 'comm-conv-mech-caps-4';
	var MECH_GRAM = exports.MECH_GRAM = 'comm-conv-mech-gram-5';
	var MECH_PUNC = exports.MECH_PUNC = 'comm-conv-mech-punc-8';
	var MECH_SPELL = exports.MECH_SPELL = 'comm-conv-mech-spell-13';
	var ORG_WORD_COUNT = exports.ORG_WORD_COUNT = 'comm-conv-org-word-count-18';
	var ORG_SENT_COUNT = exports.ORG_SENT_COUNT = 'comm-conv-org-sent-count-11';
	var ORG_SENT_STRUCT = exports.ORG_SENT_STRUCT = 'comm-conv-org-sent-struct-coso-12';
	
	var READ_THE_BOOK = exports.READ_THE_BOOK = 'crit-evi-cote-bert-read-book-1';
	var TEXT_DETAIL_QUANT = exports.TEXT_DETAIL_QUANT = 'crit-evi-cote-bert-quantity-14';
	var TEXT_DETAIL_QUAL = exports.TEXT_DETAIL_QUAL = 'crit-evi-cote-bert-quality-17';
	var RESTATING = exports.RESTATING = 'crit-rc-atq-cors-bert-10';
	var ANSWER_PRESENT = exports.ANSWER_PRESENT = 'crit-rc-atq-coqa-answer-present-3';
	var FULLY_ANSWERED = exports.FULLY_ANSWERED = 'crit-rc-atq-coqa-fully-answered-2';
	
	var RUBRIC_METRICS = exports.RUBRIC_METRICS = [READ_THE_BOOK, TEXT_DETAIL_QUANT, RESTATING, ANSWER_PRESENT, FULLY_ANSWERED, MECH_CAPS, MECH_GRAM, MECH_PUNC, MECH_SPELL, ORG_WORD_COUNT, ORG_SENT_COUNT];
	
	var POSITIVE_RUBRIC_LABELS = ['yes', 'correct', 'sufficient', 'solid', "specific/applicable"];
	var NEUTRAL_RUBIC_LABELS = ['developing'];
	var NEGATIVE_RUBRIC_LABELS = ['no', '-', 'incorrect', 'insufficient', "unspecific/nonapplicable"];
	
	var STUDENT = exports.STUDENT = 'student';
	var STUDENT_LIST = exports.STUDENT_LIST = 'student_list';
	var TEACHER = exports.TEACHER = 'teacher';
	var SCHOOL_ORG = exports.SCHOOL_ORG = 'school_org';
	var DISTRICT_ORG = exports.DISTRICT_ORG = 'district_org';
	
	var STAT_DISPLAY = exports.STAT_DISPLAY = (_STAT_DISPLAY = {}, _defineProperty(_STAT_DISPLAY, AVG_QUIZ_SCORE, {
	    'unit': '',
	    'formatting': function formatting(score) {
	        var rounded = parseFloat(score) * SCORE_CAP;
	        return rounded.toFixed(2);
	    },
	    'name': "Avg. Quiz Score",
	    'domain': [0, 4]
	}), _defineProperty(_STAT_DISPLAY, AVG_ANSWER_SCORE, {
	    'unit': '',
	    'formatting': function formatting(score) {
	        var rounded = parseFloat(score) * SCORE_CAP;
	        return rounded.toFixed(2);
	    },
	    'name': "Avg. Answer Score",
	    'domain': [0, 4]
	}), _defineProperty(_STAT_DISPLAY, TOTAL_QUIZZES, {
	    'name': 'Total Quizzes'
	}), _defineProperty(_STAT_DISPLAY, PASSED_QUIZZES, {
	    'name': "Quizzes Passed"
	}), _defineProperty(_STAT_DISPLAY, FAILED_QUIZZES, {
	    'name': "Quizzes Failed"
	}), _defineProperty(_STAT_DISPLAY, MINUTES_LOGGED, {
	    'name': "Minutes Logged"
	}), _defineProperty(_STAT_DISPLAY, PAGES_LOGGED, {
	    'name': "Pages Logged"
	}), _defineProperty(_STAT_DISPLAY, EXCERCISES_COMPLETED, {
	    'name': "Excercises Completed"
	}), _defineProperty(_STAT_DISPLAY, TOTAL_REVIEWS, {
	    'name': "Reviews Completed"
	}), _defineProperty(_STAT_DISPLAY, FLAGGED_QUIZZES, {
	    'name': "Quizzes Flagged"
	}), _defineProperty(_STAT_DISPLAY, TOTAL_PRACTICE_QUESTIONS, {
	    'name': "Practice Questions Completed"
	}), _defineProperty(_STAT_DISPLAY, TOTAL_QUESTION_BUILDERS, {
	    'name': "Total Question Builders"
	}), _defineProperty(_STAT_DISPLAY, AVG_LEXILE_LEVEL, {
	    'name': "Average Lexile Level"
	}), _defineProperty(_STAT_DISPLAY, QUIZ_PERFORMANCE, {
	    'name': "Quiz Performance",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        data["Quizzes Passed"] = digest.data[PASSED_QUIZZES];
	        data["Quizzes Failed"] = digest.data[FAILED_QUIZZES];
	        return data;
	    }
	}), _defineProperty(_STAT_DISPLAY, READ_THE_BOOK, {
	    'name': "Read the Book",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[READ_THE_BOOK].name;
	        var score = calculateRubricScore(digest, READ_THE_BOOK);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, TEXT_DETAIL_QUANT, {
	    'name': "Text Detail Quantity",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[TEXT_DETAIL_QUANT].name;
	        var score = calculateRubricScore(digest, TEXT_DETAIL_QUANT);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, RESTATING, {
	    'name': "Question Restated",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[RESTATING].name;
	        var score = calculateRubricScore(digest, RESTATING);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, ANSWER_PRESENT, {
	    'name': "Question Answered",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[ANSWER_PRESENT].name;
	        var score = calculateRubricScore(digest, ANSWER_PRESENT);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, FULLY_ANSWERED, {
	    'name': "Fully Answered",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[FULLY_ANSWERED].name;
	        var score = calculateRubricScore(digest, FULLY_ANSWERED);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, MECH_CAPS, {
	    'name': "Capitalization",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[MECH_CAPS].name;
	        var score = calculateRubricScore(digest, MECH_CAPS);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, MECH_GRAM, {
	    'name': "Grammar",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[MECH_GRAM].name;
	        var score = calculateRubricScore(digest, MECH_GRAM);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, MECH_PUNC, {
	    'name': "Punctuation",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[MECH_PUNC].name;
	        var score = calculateRubricScore(digest, MECH_PUNC);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, MECH_SPELL, {
	    'name': "Spelling",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[MECH_SPELL].name;
	        var score = calculateRubricScore(digest, MECH_SPELL);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, ORG_WORD_COUNT, {
	    'name': "Word Count",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[ORG_WORD_COUNT].name;
	        var score = calculateRubricScore(digest, ORG_WORD_COUNT);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _defineProperty(_STAT_DISPLAY, ORG_SENT_COUNT, {
	    'name': "Sentence Count",
	    'data_extraction_func': function data_extraction_func(digest, data) {
	        var displayName = STAT_DISPLAY[ORG_SENT_COUNT].name;
	        var score = calculateRubricScore(digest, ORG_SENT_COUNT);
	        data[displayName] = score.toFixed(2);
	        return data;
	    },
	    'unit': "%"
	}), _STAT_DISPLAY);
	
	// calculate percentage of successful attempts at a rubric item.
	function calculateRubricScore(digest, rubric) {
	    var rubricResults = _.get(digest, ['data', 'rubrics', rubric], {});
	    var positiveOutcomes = 0;
	    var negativeOutcomes = 0;
	    _.each(rubricResults, function (count, label) {
	        if (POSITIVE_RUBRIC_LABELS.includes(label)) {
	            positiveOutcomes += count;
	        } else {
	            negativeOutcomes += count;
	        }
	    });
	
	    //make a percentage
	    var correctPercentage = positiveOutcomes / (negativeOutcomes + positiveOutcomes) * 100;
	    return correctPercentage || 0;
	}
	
	function consolidateMonthlyRubrics(digests) {
	    // consolidated, mock digest.
	    var consolidatedData = { 'data': { 'rubrics': {} } };
	
	    digests.forEach(function (digest) {
	        Object.keys(digest.data.rubrics).forEach(function (rubric) {
	            if (!consolidatedData.data.rubrics[rubric]) {
	                consolidatedData.data.rubrics[rubric] = {};
	            }
	            Object.keys(digest.data.rubrics[rubric]).forEach(function (label) {
	                if (!consolidatedData.data.rubrics[rubric][label]) {
	                    consolidatedData.data.rubrics[rubric][label] = 0;
	                }
	                consolidatedData.data.rubrics[rubric][label] += 1;
	            });
	        });
	    });
	
	    return consolidatedData;
	}
	
	function getEntityName(entityType, entity) {
	    if ([STUDENT, TEACHER].includes(entityType)) {
	        return entity.first_name + " " + entity.last_name;
	    } else {
	        return entity.name;
	    }
	}
	
	var getBarColors = exports.getBarColors = function getBarColors(metricsToGraph) {
	    var STANDARD_COLORS = ["#00a0f4", "#2b9401"];
	    // want to color bars red and green for quiz performance stat.
	    if (metricsToGraph.length <= 1) {
	        return STANDARD_COLORS;
	    }
	
	    // standard blue and green.
	    var PASS_FAIL_COLORS = { "Quizzes Passed": '#42af14', "Quizzes Failed": '#ff7346'
	
	        // used to keep track of the standard color
	    };var standardColorIndex = 0;
	    var orderedColors = [];
	    for (var i = 0; i < metricsToGraph.length; i++) {
	        var metric = metricsToGraph[i];
	        // if pass-fail
	        if (PASS_FAIL_COLORS[metric]) {
	            orderedColors.push(PASS_FAIL_COLORS[metric]);
	        } else {
	            // if standard metric, grab color from normal list
	            orderedColors.push(STANDARD_COLORS[standardColorIndex % STANDARD_COLORS.length]);
	            standardColorIndex += 1;
	        }
	    }
	    return orderedColors;
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var Glyphicon = __webpack_require__(8);
	
	var DataRouting = __webpack_require__(36);
	var OrgTypes = __webpack_require__(45);
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3694);
	
	var OrgDropdown = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var loading = RosterSelectors.isLoadingStudentLists({ state: state });
	
		if (loading) {
			var selectedText = "Loading classes...";
		} else {
			var selectedText = RosterSelectors.nameForOrgIdentifier({
				state: state, fallback: "Select one",
				orgIdentifier: props.selectedIdentifier
			});
		}
	
		if (props.selectionTypes) {
			var selectionTypes = props.selectionTypes;
		} else {
			var selectionTypes = [OrgTypes.ALL_STUDENTS, OrgTypes.STUDENT_LIST];
	
			if (CurrentUser.isTeacherAdmin()) {
				selectionTypes.push(OrgTypes.SUBGROUP);
			} else if (CurrentUser.isDistrictAdmin()) {
				selectionTypes.push(OrgTypes.SCHOOL_ORG);
			}
		}
	
		if (props.omitSelectionTypes) {
			selectionTypes = _.difference(selectionTypes, props.omitSelectionTypes);
		}
	
		return {
			selectedText: selectedText, loading: loading, selectionTypes: selectionTypes,
			studentLists: RosterSelectors.nonEmptyStudentLists({ state: state }),
			schoolOrgs: RosterSelectors.schoolOrgs({ state: state }),
			subgroups: RosterSelectors.subgroups({ state: state })
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(OrgDropdown, _React$Component);
	
		function OrgDropdown(props) {
			_classCallCheck(this, OrgDropdown);
	
			var _this = _possibleConstructorReturn(this, (OrgDropdown.__proto__ || Object.getPrototypeOf(OrgDropdown)).call(this));
	
			autobind(_this);
	
			// No state. Do not add state. Control from above.
			return _this;
		}
	
		_createClass(OrgDropdown, [{
			key: "selectAllOption",
			value: function selectAllOption(type) {
				this.props.onSelect(OrgTypes.toIdentifier({ type: type }), 'everyone');
			}
		}, {
			key: "selectSchoolOrg",
			value: function selectSchoolOrg(schoolOrg) {
				this.props.onSelect(OrgTypes.toIdentifier({
					type: OrgTypes.SCHOOL_ORG,
					key: schoolOrg.id
				}));
			}
		}, {
			key: "selectStudentList",
			value: function selectStudentList(studentList) {
				if (studentList && studentList.id) {
					this.props.onSelect(OrgTypes.toIdentifier({
						type: OrgTypes.STUDENT_LIST,
						key: studentList.id
					}), studentList.id);
				}
			}
		}, {
			key: "selectSubgroup",
			value: function selectSubgroup(group) {
				this.props.onSelect(OrgTypes.toIdentifier({
					type: OrgTypes.SUBGROUP,
					key: group.key
				}));
			}
		}, {
			key: "isSupportedType",
			value: function isSupportedType(type) {
				return _.contains(this.props.selectionTypes, type);
			}
			// sets intiial selected student list
	
		}, {
			key: "setSelected",
			value: function setSelected(selectedList) {
				this.selectStudentList(selectedList);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (!this.props.loading) {
					var everyoneOptions = [];
	
					if (this.isSupportedType(OrgTypes.ALL_SCHOOL_ORGS)) {
						everyoneOptions.push(React.createElement(
							ButtonDropdownOption,
							{ className: "topLevel",
								key: OrgTypes.ALL_SCHOOL_ORGS,
								onClick: function onClick() {
									return _this2.selectAllOption(OrgTypes.ALL_SCHOOL_ORGS);
								} },
							"All Schools"
						));
					}
	
					if (this.isSupportedType(OrgTypes.ALL_STUDENT_LISTS)) {
						everyoneOptions.push(React.createElement(
							ButtonDropdownOption,
							{ className: "topLevel",
								key: OrgTypes.ALL_STUDENT_LISTS,
								onClick: function onClick() {
									return _this2.selectAllOption(OrgTypes.ALL_STUDENT_LISTS);
								} },
							"All Classes"
						));
					}
	
					// FOR LOAD REASONS WE DISABLED EVERYONE
					// if (this.isSupportedType(OrgTypes.ALL_STUDENTS)) {
					// 	everyoneOptions.push((
					// 		<ButtonDropdownOption className="topLevel"
					// 			key={ OrgTypes.ALL_STUDENTS }
					// 			onClick={ () => this.selectAllOption(OrgTypes.ALL_STUDENTS) }>
					// 			All Students
					// 		</ButtonDropdownOption>
					// 	));
					// }
	
					if (this.isSupportedType(OrgTypes.SCHOOL_ORG)) {
						var schoolOrgHeader = React.createElement(
							"li",
							{ className: "dropdown-header" },
							"Schools"
						);
						if (this.props.schoolOrgs.length) {
							var schoolOrgOptions = _.sortBy(this.props.schoolOrgs, "name").map(function (so) {
								return React.createElement(
									ButtonDropdownOption,
									{ onClick: function onClick() {
											return _this2.selectSchoolOrg(so);
										}, key: so.id },
									so.name
								);
							});
						} else {
							var schoolOrgOptions = React.createElement(
								"li",
								{ className: "placeholder" },
								"No schools have students."
							);
						}
					}
	
					if (this.isSupportedType(OrgTypes.STUDENT_LIST)) {
						var studentListHeader = React.createElement(
							"li",
							{ className: "dropdown-header" },
							"Classes"
						);
						if (this.props.studentLists.length) {
							var selectedList = null;
							// preselect list if url param exists
							var studentListOptions = _.sortBy(this.props.studentLists, "name").map(function (sl) {
								if (parseInt($wr.getURLParameterByName('student_list')) === sl.id) {
									selectedList = sl;
								}
								return React.createElement(
									ButtonDropdownOption,
									{ onClick: function onClick() {
											return _this2.selectStudentList(sl);
										}, key: sl.id },
									sl.name
								);
							});
							//this.setSelected(selectedList);  ///////// THIS TRIGGERED UNECESSARY UPDATE MID RENDERING MAY WANT TO REMOVE AT SOME POINT
						} else {
							var studentListOptions = React.createElement(
								"li",
								{ className: "placeholder" },
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/roster" },
									"No classes have students. ",
									React.createElement(
										"span",
										{ className: "linkStyle" },
										"Fix"
									)
								)
							);
						}
					}
	
					if (this.isSupportedType(OrgTypes.SUBGROUP)) {
						var subgroupHeader = React.createElement(
							"li",
							{ className: "dropdown-header" },
							"Groups"
						);
						if (this.props.subgroups.length) {
							var subgroupOptions = _.sortBy(this.props.subgroups, "name").map(function (group) {
								return React.createElement(
									ButtonDropdownOption,
									{ onClick: function onClick() {
											return _this2.selectSubgroup(group);
										}, key: group.key },
									React.createElement(Glyphicon, { icon: group.icon, style: { color: group.color } }),
									group.name
								);
							});
						} else {
							var subgroupOptions = React.createElement(
								"li",
								{ className: "placeholder" },
								React.createElement(
									"a",
									{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/360046698892", target: "_blank" },
									"No groups yet. Learn more ",
									React.createElement(Glyphicon, { icon: "new-window" })
								)
							);
						}
					}
				}
	
				return React.createElement(
					"div",
					{ className: "orgDropdown" },
					React.createElement(
						ButtonDropdown,
						{ text: this.props.selectedText, className: "nested",
							dropdownDisplay: this.props.dropdownDisplay },
						everyoneOptions,
						schoolOrgHeader,
						schoolOrgOptions,
						studentListHeader,
						studentListOptions,
						subgroupHeader,
						subgroupOptions
					)
				);
			}
		}]);
	
		return OrgDropdown;
	}(React.Component)) || _class);
	;
	
	OrgDropdown.WrappedComponent.propTypes = StrictPropTypes({
		onSelect: PropTypes.func.isRequired, // Is passed an org indetifier object (see OrgTypes module)
		selectedIdentifier: PropTypes.string, // See OrgTypes to/from identifiers
		dropdownDisplay: PropTypes.string,
		omitSelectionTypes: PropTypes.array,
	
		// From above and/or data inserted by @connect
		selectionTypes: PropTypes.array, // List of types of org types to list. Default is all.
	
		// Data inserted by @connect
		schoolOrgs: PropTypes.array.isRequired,
		studentLists: PropTypes.array.isRequired,
		subgroups: PropTypes.array.isRequired,
		loading: PropTypes.bool,
		selectedText: PropTypes.string
	});
	
	var ALL_CLASSES_FAKE_ID = -999;
	
	module.exports = OrgDropdown;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoSubmitTextArea = __webpack_require__(418);
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3747);
	
	var ReactionFeedback = function (_React$Component) {
		_inherits(ReactionFeedback, _React$Component);
	
		function ReactionFeedback(props) {
			_classCallCheck(this, ReactionFeedback);
	
			var _this = _possibleConstructorReturn(this, (ReactionFeedback.__proto__ || Object.getPrototypeOf(ReactionFeedback)).call(this));
	
			autobind(_this);
			_this.state = {
				showPopover: props.textOnly, activeEmotion: null,
				reactionFeedbackKey: null, feedbackItemID: null, loading: false
			};
			return _this;
		}
	
		_createClass(ReactionFeedback, [{
			key: "recordFeedback",
			value: function recordFeedback(emotion, e) {
				$wr.nope(e);
	
				if (this.state.loading) {
					return;
				}
	
				if (emotion == this.state.activeEmotion) {
					this.setState({ showPopover: false, activeEmotion: null });
				} else {
					this.setState({ showPopover: true, activeEmotion: emotion }, function () {
						this.submitFeedbackItem();
						this.focusOnTextFeedback();
					}.bind(this));
				}
			}
		}, {
			key: "submitTextFeedback",
			value: function submitTextFeedback() {
				this.submitFeedbackItem();
				window.wrNotifications.triggerDropDownNotification({ title: "Thanks!", icon: "star",
					text: "With your help, we get better every day." }, 4000);
				this.setState({ showPopover: false });
			}
		}, {
			key: "submitFeedbackItem",
			value: function submitFeedbackItem() {
				if (this.state.loading) {
					return;
				}
	
				var itemData = {
					where: this.props.where, subject_type: this.props.subjectType,
					subject_id: this.props.subjectID, body: this.refs.textBox.text(),
					reaction: this.state.activeEmotion
				};
	
				var params = { feedback_item: itemData };
				if (this.state.reactionFeedbackKey) {
					params.key = this.state.reactionFeedbackKey;
					this.setState({ loading: true });
					CurrentUser.api().patchFeedbackItem(this.state.feedbackItemID, params, $wr.apiHandler(function (serverResponse) {
						this.setState({ loading: false, feedbackItemID: serverResponse.feedback_item.id });
					}.bind(this)));
				} else {
					itemData.key = Math.random().toString(36).substr(2, 100);;
					this.setState({ reactionFeedbackKey: itemData.key, loading: true });
					CurrentUser.api().postFeedbackItem(params, $wr.apiHandler(function (serverResponse) {
						this.setState({ loading: false, feedbackItemID: serverResponse.feedback_item.id });
					}.bind(this)));
				}
			}
		}, {
			key: "render",
			value: function render() {
				var activeIndex;
	
				if (this.props.options) {
					var optionList = _.keys(this.props.options);
					var optionMap = this.props.options;
				} else {
					var optionList = ReactionFeedback.DEFAULT_EMOTIONS;
					var optionMap = {};
				}
	
				if (!this.props.textOnly) {
					var reactionOptions = _.map(optionList, function (emotion, index) {
						var selectOpClassname = "reactionOption";
						if (this.state.activeEmotion != null && emotion != this.state.activeEmotion) {
							selectOpClassname += " inactive";
						} else if (this.state.activeEmotion != null) {
							selectOpClassname += " active";
							activeIndex = index;
						}
	
						if (optionMap[emotion] && optionMap[emotion].label) {
							selectOpClassname += " b-tooltip";
							var tooltip = optionMap[emotion].label;
							var tooltipTemplate = ReactionFeedback.ALTERNATE_TOOLTIP_TEMPLATE;
						}
	
						return React.createElement(
							"a",
							{ className: selectOpClassname, href: "#", key: emotion, "data-tip": tooltip,
								"data-template": tooltipTemplate, "data-for": "reaction-feedback",
								onClick: this.recordFeedback.bind(this, emotion) },
							React.createElement("img", { src: ReactionFeedback.ICON_LOOKUP[emotion] }),
							React.createElement(ReactTooltip, { effect: "solid", id: "reaction-feedback" })
						);
					}.bind(this));
				}
	
				if (this.state.showPopover) {
					var popoverClassName = "popover";
	
					if (this.props.textOnly) {
						popoverClassName += " textOnly";
					} else {
						var leftPos = activeIndex * 50 - 365;
					}
	
					if (this.props.popover_position) {
						var bottomPositions = [ReactionFeedback.POSITION_BOTTOM, ReactionFeedback.POSITION_BOTTOM_LEFT, ReactionFeedback.POSITION_BOTTOM_RIGHT];
						if (_.contains(bottomPositions, this.props.popover_position)) {
							popoverClassName += " bottom";
						}
						popoverClassName += " " + this.props.popover_position;
					}
	
					var feedbackPopover = React.createElement(
						"div",
						{ className: popoverClassName, style: { left: leftPos }, ref: "popover" },
						React.createElement("div", { className: "arrow" }),
						React.createElement(
							"h3",
							{ className: "popover-title" },
							this.props.textTitle
						),
						React.createElement(
							"div",
							{ className: "popover-content" },
							React.createElement(AutoSubmitTextArea, { onSubmit: this.submitTextFeedback, ref: "textBox",
								placeholder: this.props.placeholder, submitLink: true, className: "form-control" })
						)
					);
				}
	
				if (this.props.title) {
					var reactionTitle = React.createElement(
						"p",
						{ className: "reactionTitle" },
						this.props.title
					);
				}
				var componentClassName = "";
				if (this.props.component_position) {
					componentClassName += this.props.component_position;
				}
				return React.createElement(
					"div",
					{ className: "reactionFeedback hideOnPrint " + componentClassName, ref: "wrap" },
					reactionTitle,
					React.createElement(
						"div",
						{ className: "reactionRow clearfix " + componentClassName, ref: "reactionRow" },
						reactionOptions
					),
					feedbackPopover
				);
			}
		}, {
			key: "focusOnTextFeedback",
			value: function focusOnTextFeedback() {
				var $popover = $(this.refs.popover);
				var popoverBottom = $popover.offset().top + $popover.height();
				var winHeight = $(window).height();
				var windowBottom = $(window).scrollTop() + winHeight;
				var extraOffset = 20;
				if (windowBottom < popoverBottom + extraOffset) {
					var offset = popoverBottom - winHeight + extraOffset;
					$('html, body').animate({ scrollTop: offset }, 'slow');
				}
	
				$popover.find("textarea").focus();
			}
		}, {
			key: "checkOutsideClick",
			value: function checkOutsideClick(e) {
				var $wrap = $(this.refs.wrap);
	
				if ($(e.target).closest($wrap).length == 0) {
					this.setState({ showPopover: false });
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(this.refs.reactionRow).popover();
	
				$("body").on("click", this.checkOutsideClick);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$("body").off("click", this.checkOutsideClick);
			}
		}]);
	
		return ReactionFeedback;
	}(React.Component);
	
	ReactionFeedback.propTypes = StrictPropTypes({
		where: PropTypes.string.isRequired,
		title: PropTypes.string,
		textTitle: PropTypes.string,
		placeholder: PropTypes.string,
		subjectType: PropTypes.string,
		subjectID: PropTypes.number,
		popover_position: PropTypes.string,
		component_position: PropTypes.string,
	
		textOnly: PropTypes.bool.isRequired,
	
		options: PropTypes.object,
	
		preventManualEntry: PropTypes.bool,
		skipToFallbackSearch: PropTypes.bool,
		onBookSelect: PropTypes.func
	});
	
	ReactionFeedback.HAPPY = "happy";
	ReactionFeedback.NEUTRAL = "neutral";
	ReactionFeedback.SAD = "sad";
	
	ReactionFeedback.DEFAULT_EMOTIONS = [ReactionFeedback.HAPPY, ReactionFeedback.NEUTRAL, ReactionFeedback.SAD];
	
	ReactionFeedback.ICON_LOOKUP = {};
	ReactionFeedback.ICON_LOOKUP[ReactionFeedback.HAPPY] = __webpack_require__(3398);
	ReactionFeedback.ICON_LOOKUP[ReactionFeedback.NEUTRAL] = __webpack_require__(3399);
	ReactionFeedback.ICON_LOOKUP[ReactionFeedback.SAD] = __webpack_require__(3400);
	
	ReactionFeedback.POSITION_BOTTOM = "position-bottom";
	ReactionFeedback.POSITION_BOTTOM_LEFT = "position-bottom-left";
	ReactionFeedback.POSITION_BOTTOM_RIGHT = "position-bottom-right";
	ReactionFeedback.POSITION_MODAL_BOTTOM_LEFT = "position-modal-bottom-left";
	ReactionFeedback.ALTERNATE_TOOLTIP_TEMPLATE = "alternate_tooltip_template";
	
	module.exports = ReactionFeedback;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ImageIcon = function ImageIcon(props) {
		var className = "imageIcon";
		if (props.className) {
			className = className + " " + props.className;
		}
	
		var src = dynamicRequire("official-icons/" + props.icon + ".png");
	
		var width = props.width || "auto";
		var height = props.height || "auto";
	
		var imgProps = _.omit(props, "width", "height", "icon", "type", "className");
	
		return React.createElement("img", _extends({}, imgProps, { width: width, height: height,
			src: src, className: className }));
	};
	
	ImageIcon.propTypes = StrictPropTypes({
		// "imageIcon" class will be added to this
		className: PropTypes.string,
	
		// Glyphion suffix
		icon: PropTypes.string.isRequired,
	
		// Dimension
		width: PropTypes.number,
		height: PropTypes.number,
	
		// Origin
		type: PropTypes.string,
	
		//Styling
		style: PropTypes.object
	});
	
	module.exports = ImageIcon;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var ReactTooltip = __webpack_require__(12);
	var Glyphicon = __webpack_require__(8);
	var NumbersOnlyInput = __webpack_require__(122);
	
	__webpack_require__(3843);
	
	var ScoreDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
		if (props.subjectID && props.subjectType) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state: state, subjectType: props.subjectType, subjectID: props.subjectID
			});
		} else if (props.evaluationID) {
			downProps.evaluation = WritingSelectors.evaluation({ state: state, id: props.evaluationID });
		}
	
		if (downProps.evaluation) {
			if (downProps.evaluation.subject_type == "Answer") {
				var subject = WritingSelectors.answer({ state: state, id: downProps.evaluation.subject_id });
				downProps.noun = "answer";
			} else if (downProps.evaluation.subject_type == "Quiz") {
				var subject = WritingSelectors.quiz({ state: state, id: downProps.evaluation.subject_id });
				downProps.noun = "quiz";
			}
			if (subject) {
				// Would require the answer or quiz to already be loaded into redux state
				downProps.excluded = subject.excluded;
			}
		}
	
		if (CurrentUser.isStudent()) {
			var slPrefs = CurrentUser.get().prefs;
			downProps.asStudent = true;
		} else {
			var slPrefs = RosterSelectors.studentListPrefs({ state: state }) || {};
			downProps.asStudent = false;
		}
		downProps.passingThreshold = slPrefs.passing_threshold;
		downProps.displayScoreCap = slPrefs.display_score_cap;
	
		if (props.answerIDs) {
			var answers = _underscore2.default.map(props.answerIDs, function (answerID) {
				return WritingSelectors.answer({ state: state, id: answerID });
			});
	
			downProps.filters = _underscore2.default.some(answers, function (answer) {
				if (answer.evaluation) {
					var evaluation = WritingSelectors.evaluation({ state: state, id: answer.evaluation });
					if (evaluation.autograder_data && evaluation.autograder_data.filtering && evaluation.autograder_data.filtering.length > 0) {
						return true;
					}
				} else return false;
			});
	
			downProps.warnings = _underscore2.default.some(answers, function (answer) {
				if (answer.evaluation) {
					var evaluation = WritingSelectors.evaluation({ state: state, id: answer.evaluation });
					if (evaluation.autograder_data && evaluation.autograder_data.warning && evaluation.autograder_data.warning.length > 0) {
						return true;
					}
				} else return false;
			});
		}
	
		return downProps;
	}, function (dispatch, props) {
		return {
			onUpdate: function onUpdate(evaluationID, evaluationUpdate) {
				if (evaluationID) {
					dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
				}
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ScoreDisplay, _React$Component);
	
		function ScoreDisplay(props) {
			_classCallCheck(this, ScoreDisplay);
	
			var _this = _possibleConstructorReturn(this, (ScoreDisplay.__proto__ || Object.getPrototypeOf(ScoreDisplay)).call(this));
	
			autobind(_this);
	
			if (props.evaluation && props.evaluation.ratio) {
				var editedScore = _this.hideAutograderScore(props.evaluation) ? 0 : $wr.convertedScore(props.evaluation.ratio, props.displayScoreCap || 4);
			}
	
			_this.state = { editedScore: editedScore };
	
			return _this;
		}
	
		_createClass(ScoreDisplay, [{
			key: "displayScoreCap",
			value: function displayScoreCap(props) {
				return (props || this.props).displayScoreCap || 4;
			}
		}, {
			key: "isPassing",
			value: function isPassing() {
				var ratio = this.props.evaluation.ratio;
				var threshold = this.props.passingThreshold;
				return ratio >= threshold;
			}
		}, {
			key: "hideAutograderScore",
			value: function hideAutograderScore(evaluation) {
				evaluation = evaluation ? evaluation : this.props.evaluation;
				return evaluation && !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score;
			}
		}, {
			key: "isPending",
			value: function isPending() {
				return !this.props.evaluation || this.props.evaluation.score_cap === 0;
			}
		}, {
			key: "noCertainty",
			value: function noCertainty() {
				return this.props.evaluation.certainty === 0;
			}
	
			// saves evaluation score
	
		}, {
			key: "saveEvaluation",
			value: function saveEvaluation() {
				var originalEvaluation = this.props.evaluation;
	
				// Round up to the nearest 0.5
				var override = Math.round(this.state.editedScore * 2) / 2;
	
				var adminRatio = override / this.displayScoreCap();
	
				// Project this onto the scale of the original evaluation
				var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);
	
				// set to 0 or score_cap if outside of 0-score_cap range
				if (adminScore < 0) {
					adminScore = 0;
					adminRatio = 0;
				} else if (adminScore > originalEvaluation.score_cap) {
					adminScore = originalEvaluation.score_cap;
					adminRatio = 1;
				}
	
				var scoreDetails = _underscore2.default.extend({}, originalEvaluation.score_details, { admin_score: adminScore });
	
				// Included both score (for immediate display) and adminScore (for the API Patch)
				var updateData = {
					score: adminScore, ratio: adminRatio, admin_score: adminScore,
					score_details: scoreDetails
				};
	
				this.props.onUpdate(originalEvaluation.id, updateData);
				this.setState({ editingEvaluation: false, showOverrideFeedback: true });
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Score Edited",
					text: "You have edited the score for this " + this.props.noun + ".",
					icon: "ok-sign"
				});
			}
	
			// shows save button if admin has edited score or rubric item
	
		}, {
			key: "renderSaveButton",
			value: function renderSaveButton() {
				return React.createElement(
					"button",
					{ onClick: this.saveEvaluation, className: "btn btn-link saveButton" },
					"Save"
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var evaluation = this.props.evaluation;
	
				var className = "scoreDisplay";
				var tooltipText = undefined;
	
				var flagAlert;
				if (this.props.evaluation && CurrentUser.isPremiumOrTrialAccount()) {
					if (this.props.filters || this.props.evaluation.filtered && !this.props.asStudent) {
						flagAlert = React.createElement(
							"div",
							{ className: "scoringFlags" },
							React.createElement(Glyphicon, { className: "filterIcon", icon: "flag", dataTip: "Some answers don't seem quite right" })
						);
					} else if (this.props.warnings && !this.props.asStudent) {
						flagAlert = React.createElement(
							"div",
							{ className: "scoringFlags" },
							React.createElement(Glyphicon, { className: "warningIcon", icon: "flag", dataTip: "Some answers don't seem quite right" })
						);
					} else {
						flagAlert = "";
					}
				}
	
				if (this.hideAutograderScore()) {
					className += " noAdminScore";
					if (CurrentUser.isStudent()) {
						tooltipText = "Hang tight! Your teacher will grade this item shortly.";
						var mainContent = React.createElement(
							"span",
							null,
							React.createElement(Glyphicon, { icon: "question-sign", dataTip: tooltipText }),
							React.createElement(ReactTooltip, { effect: "solid" })
						);
					} else {
						className += " adminScoreForm";
						if (this.state.editedScore) {
							className += " saveShowing";
							var saveButton = this.renderSaveButton();
						}
						var tip = 'This item has not been graded';
						var mainContent = React.createElement(
							"div",
							null,
							React.createElement(Glyphicon, { icon: "exclamation-sign", className: "warningIcon", dataTip: tip }),
							React.createElement(NumbersOnlyInput, { className: "form-control scoreInput", allowDecimal: true,
								value: this.state.editedScore, step: 0.5,
								onChange: function onChange(e) {
									return _this2.setState({ editedScore: parseFloat(e.target.value) });
								},
								max: this.displayScoreCap(), min: 0 }),
							React.createElement(
								"div",
								{ className: "scoreCap" },
								"/ ",
								this.displayScoreCap()
							),
							saveButton
						);
					}
				} else if (this.isPending()) {
					tooltipText = "Pending. This " + this.props.noun + " will be graded within 24 hours.";
					var mainContent = React.createElement(
						"span",
						{ "data-tip": tooltipText, "data-for": "hourglassDataTip" },
						React.createElement(Glyphicon, { icon: "hourglass" }),
						React.createElement(ReactTooltip, { id: "hourglassDataTip" })
					);
				} else if (this.noCertainty()) {
					tooltipText = "Unable to score. Quizzes for less common books will not be graded unless they include open-ended questions.";
					var mainContent = React.createElement(Glyphicon, { icon: "minus", dataTip: tooltipText });
				} else {
					var convertedScore = $wr.convertedScore(this.props.evaluation.ratio, this.props.displayScoreCap || 4);
					if (this.props.showDenominator) {
						var denominator = React.createElement(
							"span",
							{ className: "denominator" },
							" / ",
							this.displayScoreCap()
						);
					};
	
					var mainContent = React.createElement(
						"span",
						null,
						convertedScore,
						denominator
					);
				}
	
				if (this.props.mode == CIRCLE_MODE) {
					className += " circleMode";
					if (this.isPending() || this.noCertainty() || this.hideAutograderScore()) {
						className += " neutralDisplay";
					} else if (this.isPassing()) {
						className += " passDisplay";
					} else {
						className += " failDisplay";
					}
	
					if (this.props.excluded) {
						className += " excludedStripes";
	
						if (this.props.asStudent) {
							tooltipText = "This " + this.props.noun + " will not count toward the goals your teacher set.";
						} else {
							tooltipText = "This " + this.props.noun + " will not count toward your custom goals.";
						}
					}
				} else if (this.props.mode == INLINE_MODE) {
					if (convertedScore !== undefined && !this.isPending()) {
						var passText = this.isPassing() ? "Pass: " : "Fail: ";
					}
					className += " inlineMode";
				} else if (this.props.mode == SCORE_ONLY_MODE) {
					if (!this.isPending()) {
						className += this.isPassing() ? " passed" : " failed";
					}
					className += " scoreOnlyMode";
				}
	
				// have to render circle + inline modes separately, because of complications from css 
				// + rendering warning flags.
				if (this.props.mode == CIRCLE_MODE && CurrentUser.isPremiumOrTrialAccount()) {
					return React.createElement(
						"div",
						{ className: "scoreContainer" },
						React.createElement(
							"div",
							{ className: className },
							passText,
							mainContent
						),
						React.createElement(
							"div",
							{ className: "flagContainer" },
							flagAlert
						)
					);
				} else {
					if (flagAlert) {
						className += " withFlag inlineFlagContainer";
					} else {
						className += " noFlag";
					}
	
					return React.createElement(
						"div",
						{ className: className },
						passText,
						mainContent,
						flagAlert
					);
				}
			}
		}]);
	
		return ScoreDisplay;
	}(React.Component)) || _class);
	;
	
	var CIRCLE_MODE = "circle";
	var INLINE_MODE = "inline";
	var SCORE_ONLY_MODE = "score_only";
	
	ScoreDisplay.CIRCLE_MODE = CIRCLE_MODE;
	ScoreDisplay.INLINE_MODE = INLINE_MODE;
	ScoreDisplay.SCORE_ONLY_MODE = SCORE_ONLY_MODE;
	
	ScoreDisplay.propTypes = StrictPropTypes({
		subjectID: PropTypes.number,
		subjectType: PropTypes.string,
		evaluationID: PropTypes.number,
		mode: PropTypes.string,
		showDenominator: PropTypes.bool,
		answerIDs: PropTypes.array,
		// From @connect
		evaluation: PropTypes.object,
		passingThreshold: PropTypes.number,
		displayScoreCap: PropTypes.number,
		noun: PropTypes.string,
		excluded: PropTypes.bool,
		asStudent: PropTypes.bool,
		changeLocationState: PropTypes.func,
		onUpdate: PropTypes.func
	});
	
	module.exports = ScoreDisplay;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var TopicQuestion = function (_React$Component) {
		_inherits(TopicQuestion, _React$Component);
	
		function TopicQuestion(props) {
			_classCallCheck(this, TopicQuestion);
	
			var _this = _possibleConstructorReturn(this, (TopicQuestion.__proto__ || Object.getPrototypeOf(TopicQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(TopicQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[TopicQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [BOOK_TYPE_STAGE];
				}
	
				var textVariety = answers[TEXT_VARIETY];
				if (!textVariety || !answers[TEXT_TYPE]) {
					return [BOOK_TYPE_STAGE];
				}
	
				if (textVariety.includes("non-fiction")) {
					var isComplete = answers[MAIN_ENTITY] && answers[MAIN_TOPICS] && (this.props.level != "3" || answers[GENRE]);
					return [NON_FICTION_GENRE_STAGE, isComplete];
				} else if (textVariety.includes("fiction")) {
					var stage = FICTION_GENRE_STAGE;
				} else {
					var stage = OTHER_GENRE_STAGE;
				}
	
				return [stage, answers.genre != undefined];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var bookTypeStageDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", BOOK_TYPE_STAGE),
					this.props.renderDropdownF("choices1", BOOK_TYPE_STAGE, TEXT_TYPE, [TEXT_TYPE, TEXT_VARIETY]),
					this.props.getTextF("label2", BOOK_TYPE_STAGE),
					this.props.renderDropdownF("choices2", BOOK_TYPE_STAGE, TEXT_VARIETY, [TEXT_TYPE, TEXT_VARIETY]),
					"."
				);
	
				if (stage != BOOK_TYPE_STAGE) {
					if (stage == FICTION_GENRE_STAGE || stage == OTHER_GENRE_STAGE) {
						var genreStageDisplay = React.createElement(
							"div",
							null,
							this.props.getTextF("label1", stage),
							this.props.renderDropdownF("choices1", stage, GENRE),
							"."
						);
					} else if (stage == NON_FICTION_GENRE_STAGE) {
						if (this.props.level == "3") {
							var genreStageDisplay = React.createElement(
								"div",
								null,
								this.props.getTextF("label1", stage),
								this.props.renderDropdownF("choices1", stage, GENRE),
								". ",
								React.createElement("br", null),
								this.props.getTextF("label2", stage),
								this.props.renderDropdownF("choices2", stage, MAIN_ENTITY),
								". ",
								React.createElement("br", null),
								this.props.getTextF("label3", stage),
								this.props.renderMultiSelectF("choices3", stage, MAIN_TOPICS, 3),
								"."
							);
						} else {
							if (this.props.level == "2") {
								var mainTopicsDisplay = this.props.renderMultiSelectF("choices2", stage, MAIN_TOPICS, 3);
							} else {
								var mainTopicsDisplay = this.props.renderDropdownF("choices2", stage, MAIN_TOPICS);
							}
							var genreStageDisplay = React.createElement(
								"div",
								null,
								this.props.getTextF("label1", stage),
								this.props.renderDropdownF("choices1", stage, MAIN_ENTITY),
								". ",
								React.createElement("br", null),
								this.props.getTextF("label2", stage),
								mainTopicsDisplay,
								"."
							);
						}
					}
				}
	
				return React.createElement(
					"div",
					null,
					bookTypeStageDisplay,
					genreStageDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return TopicQuestion;
	}(React.Component);
	
	TopicQuestion.STEM = "topic";
	
	// stages
	var BOOK_TYPE_STAGE = "booktype";
	var FICTION_GENRE_STAGE = "fgenre";
	var NON_FICTION_GENRE_STAGE = "nfgenre";
	var OTHER_GENRE_STAGE = "othergenre";
	
	var STAGES = [BOOK_TYPE_STAGE, FICTION_GENRE_STAGE, NON_FICTION_GENRE_STAGE, OTHER_GENRE_STAGE];
	
	// answer keys
	var TEXT_TYPE = "text_type";
	var TEXT_VARIETY = "text_variety";
	var GENRE = "genre";
	var MAIN_ENTITY = "main_entity";
	var MAIN_TOPICS = "main_topics";
	
	// referenced outside of component
	TopicQuestion.TEXT_TYPE = TEXT_TYPE;
	TopicQuestion.TEXT_VARIETY = TEXT_VARIETY;
	TopicQuestion.MAIN_ENTITY = MAIN_ENTITY;
	TopicQuestion.MAIN_TOPICS = MAIN_TOPICS;
	
	TopicQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = TopicQuestion;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	
	var Formats = {
		TYPES: {
			// "AvatarCustomizerFormat": {
			// 	name: "Avatar Customizer"
			// },
			"CollageFormat": {
				name: "Collage"
			},
			"DragDropFormat": {
				name: "Drag & Drop"
			},
			"DrawingFormat": {
				name: "Drawing"
			},
			"GraphicOrganizerFormat": {
				name: "Graphic Organizer"
			},
			// "ReviewFormat": {
			// 	name: "Review a Book"
			// },
			"ImagePromptFormat": {
				name: "Image Prompt"
			},
			"ExternalLinkFormat": {
				name: "External Link"
			},
			"VocabContextFormat": {
				name: "Vocabulary"
			},
			"ShortPassageFormat": {
				name: "Short Passage"
			},
			// "ComicFormat": {
			// 	name: "Comic Strip"
			// },
			"EvaluateResponseFormat": {
				name: "Evaluate a Response"
			},
			// "ShortPromptFormat": {
			// 	name: "Respond to a Question"
			// },
			"MultiStepFormat": {
				name: "Multi Steps"
			}
			// "VoiceFormat": {
			// 	name: "Voice Recording"
			// },
		},
	
		getName: function getName(formatKey) {
			var format = Formats.TYPES[formatKey];
			if (format) {
				return format.name;
			}
		},
	
		isCollaboration: function isCollaboration(formatKey) {
			return formatKey == "CollaborationFormat";
		}
	};
	
	module.exports = Formats;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createPhotograph = createPhotograph;
	var Schema = __webpack_require__(143);
	var APIClient = __webpack_require__(110);
	var ActionUtility = __webpack_require__(95);
	var Queries = __webpack_require__(109);
	var CurrentUser = __webpack_require__(3);
	
	////////////////////////////////////////
	// Avatar //////////////////////////////
	////////////////////////////////////////
	
	var updateAvatar = exports.updateAvatar = function updateAvatar(_ref) {
		var id = _ref.id,
		    update = _ref.update,
		    embeds = _ref.embeds,
		    query = _ref.query;
	
		var params = _.extend({}, query, { avatar: update });
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecord(APIClient.patchAvatar, id, { avatar: Schema.AVATAR }, { params: params, embeds: embeds }, { reducer: "avatar", loading: "update" }));
		};
	};
	
	////////////////////////////////////////
	// Furniture ///////////////////////////
	////////////////////////////////////////
	
	var fetchFurnitures = exports.fetchFurnitures = function fetchFurnitures() {
		var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var filters = attributes.filters,
		    conditions = attributes.conditions,
		    embeds = attributes.embeds,
		    cache = attributes.cache;
	
		var params = Queries.toQuery(_extends({}, filters, { furniture_only: true }), conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getPerks, { furnitures: [Schema.FURNITURE] }, { params: params, embeds: embeds }, { reducer: "furnitures", loading: "index", cache: cache }));
		};
	};
	
	var updateFurnitures = exports.updateFurnitures = function updateFurnitures(_ref2) {
		var ids = _ref2.ids,
		    newProperties = _ref2.newProperties;
		return function (dispatch) {
			return dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				furnitures: ids,
				update: newProperties
			});
		};
	};
	
	var postFurnitures = exports.postFurnitures = function postFurnitures(_ref3) {
		var furniture = _ref3.furniture,
		    newProperties = _ref3.newProperties,
		    embeds = _ref3.embeds,
		    query = _ref3.query,
		    callback = _ref3.callback;
	
		var params = _.extend({}, query, {
			furniture: _extends({}, furniture, newProperties)
		});
	
		return function (dispatch) {
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				furnitures: [furniture.id],
				update: newProperties
			});
			return dispatch(ActionUtility.fetchRecords(function (q) {
				return APIClient.postPerks(q).then(function (response) {
					callback(response);
					return response;
				});
			}, { furniture: Schema.FURNITURE }, { params: params, embeds: embeds }, { reducer: "furniture", loading: "update" }));
		};
	};
	
	////////////////////////////////////////
	// Patches /////////////////////////////
	////////////////////////////////////////
	
	var fetchPatches = exports.fetchPatches = function fetchPatches() {
		var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var filters = attributes.filters,
		    conditions = attributes.conditions,
		    embeds = attributes.embeds,
		    cache = attributes.cache;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getPatches, { patches: [Schema.PATCH] }, { params: params, embeds: embeds }, { reducer: "patches", loading: "index", cache: cache }));
		};
	};
	
	var updatePatches = exports.updatePatches = function updatePatches(_ref4) {
		var ids = _ref4.ids,
		    newProperties = _ref4.newProperties;
		return function (dispatch) {
			return dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				patches: ids,
				update: newProperties
			});
		};
	};
	
	var postPatches = exports.postPatches = function postPatches(_ref5) {
		var patch = _ref5.patch,
		    newProperties = _ref5.newProperties,
		    embeds = _ref5.embeds,
		    query = _ref5.query,
		    callback = _ref5.callback;
	
		var params = _.extend({}, query, { patch: _extends({}, patch, newProperties) });
	
		return function (dispatch) {
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				patches: [patch.id],
				update: newProperties
			});
			return dispatch(ActionUtility.fetchRecords(function (q) {
				return APIClient.postPatches(q).then(function (response) {
					callback(response);
					return response;
				});
			}, { patch: Schema.PATCH }, { params: params, embeds: embeds }, { reducer: "patches", loading: "update" }));
		};
	};
	
	////////////////////////////////////////
	// Perks ///////////////////////////////
	////////////////////////////////////////
	
	var fetchPerks = exports.fetchPerks = function fetchPerks() {
		var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var filters = attributes.filters,
		    conditions = attributes.conditions,
		    embeds = attributes.embeds,
		    cache = attributes.cache;
	
		var params = Queries.toQuery(filters, conditions);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getPerks, { perks: [Schema.PERK] }, { params: params, embeds: embeds }, { reducer: "perks", loading: "index", cache: cache }));
		};
	};
	
	var updatePerks = exports.updatePerks = function updatePerks(_ref6) {
		var ids = _ref6.ids,
		    newProperties = _ref6.newProperties;
		return function (dispatch) {
			return dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				perks: ids,
				update: newProperties
			});
		};
	};
	
	var postPerks = exports.postPerks = function postPerks(_ref7) {
		var perk = _ref7.perk,
		    newProperties = _ref7.newProperties,
		    embeds = _ref7.embeds,
		    query = _ref7.query,
		    callback = _ref7.callback;
	
		//new_properties allows the removal of perks without setting name : ""
		var params = _.extend({}, query, { perk: _extends({}, perk), new_properties: _extends({}, newProperties) });
	
		return function (dispatch) {
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				perks: [perk.id],
				update: newProperties
			});
			return dispatch(ActionUtility.fetchRecords(function (q) {
				return APIClient.postPerks(q).then(function (response) {
					callback(response);
					return response;
				});
			}, { perk: Schema.PERK }, { params: params, embeds: embeds }, { reducer: "perks", loading: "update" }));
		};
	};
	
	////////////////////////////////////////
	// Photographs /////////////////////////
	////////////////////////////////////////
	
	function createPhotograph(_ref8) {
		var photograph = _ref8.photograph,
		    embeds = _ref8.embeds;
	
		var params = { photograph: photograph };
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.postPhotographs, { photograph: Schema.PHOTOGRAPH }, { embeds: embeds, params: params }, { reducer: "photographs", loading: "create" }));
		};
	}
	
	var fetchPhotographs = exports.fetchPhotographs = function fetchPhotographs(_ref9) {
		var filters = _ref9.filters,
		    conditions = _ref9.conditions,
		    embeds = _ref9.embeds,
		    query = _ref9.query,
		    page = _ref9.page,
		    cache = _ref9.cache;
	
		var params = _extends({}, Queries.toQuery(filters, conditions), query);
	
		return function (dispatch) {
			return dispatch(ActionUtility.fetchRecords(APIClient.getPhotographs, { photographs: [Schema.PHOTOGRAPH] }, { params: params, embeds: embeds, page: page }, { reducer: "photographs", loading: "index", cache: cache }));
		};
	};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	
	var ArbitrarySubjects = {
		ANSWER: "JournalActivityAnswer",
		QUIZ_ANSWER: "QuizAnswer",
		EXERCISE: "JournalActivityExercise",
		REVIEW: "JournalActivityReview",
		DRAFT: "Draft",
		CLASS_BOOK: "ClassBook",
		MONTH_LOGS: "MonthLogTable",
		QUESTION_BUILDER: "JournalActivityQuestionBuilder",
	
		onReadingPage: function onReadingPage(type) {
			var config = ArbitrarySubjects.CONFIG[type];
			return config && config.isReading;
		},
		asCollection: function asCollection(type) {
			var config = ArbitrarySubjects.CONFIG[type];
			if (config) {
				return config.collectionName;
			}
		},
		fromCollection: function fromCollection(collectionName) {
			return _.find(_.values(ArbitrarySubjects.TYPES), function (subjectType) {
				return collectionName == ArbitrarySubjects.asCollection(subjectType);
			});
		}
	};
	
	ArbitrarySubjects.TYPES = [ArbitrarySubjects.ANSWER, ArbitrarySubjects.QUIZ_ANSWER, ArbitrarySubjects.EXERCISE, ArbitrarySubjects.REVIEW, ArbitrarySubjects.CLASS_BOOK, ArbitrarySubjects.DRAFT, ArbitrarySubjects.QUESTION_BUILDER];
	
	ArbitrarySubjects.CONFIG = {};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.ANSWER] = {
		collectionName: "answers"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.QUIZ_ANSWER] = {
		collectionName: "quizzes"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.EXERCISE] = {
		collectionName: "exercises"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.REVIEW] = {
		collectionName: "reviews"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.CLASS_BOOK] = {
		collectionName: "class_activity"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.DRAFT] = {
		collectionName: "drafts"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.TEACHERS_PICK] = {
		collectionName: "teachers_pick"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.MONTH_LOGS] = {
		isReading: true,
		collectionName: "logs"
	};
	ArbitrarySubjects.CONFIG[ArbitrarySubjects.QUESTION_BUILDER] = {
		collectionName: "question_builders"
	};
	module.exports = ArbitrarySubjects;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	var Tiers = {
		//////////////////////////////////////////////////////////////////////////////////////////////
		////// CAUTION - THESE REQUIREMENTS ARE IN OTHER CODEBASES, SO BE CAREFUL CHANGING THEM //////
		//////////////////////////////////////////////////////////////////////////////////////////////
		// returns the requirements to advance from the given tier to the next tier up
		// TODO: consumables as requirements for tiers 3+
		REQUIREMENTS: {
			"0": {
				patches: { "body": 1, "head": 1 },
				perks: { "houses": 1 }
			},
	
			"1": {
				patches: { "body": 1, "head": 1, "hand": 2 },
				perks: { "total": 2 }
			},
			"2": {
				patches: { "body": 1, "head": 1, "hand": 2, "feet": 1, "face": 1 },
				perks: { "total": 2 }
			},
			"3": {
				patches: { "body": 1, "head": 1, "hand": 2, "feet": 1, "face": 1, "beak": 1 },
				perks: { "total": 1 },
				furnitures: { "wall_items": 1 }
			},
			"4": {
				patches: { "body": 2, "head": 1, "feet": 1, "face": 1 },
				furnitures: { "wall_items": 1, "bookshelves": 1, "floor_items": 1 }
			},
			"5": {
				patches: { "head": 1 },
				furnitures: { "wall_items": 1, "sofas": 1, "bookshelves": 1, "floor_items": 1 }
			}
		},
		//////////////////////////////////////////////////////////////////////////////////////////////
		////// END CAUTION ///////////////////////////////////////////////////////////////////////////
		//////////////////////////////////////////////////////////////////////////////////////////////
	
		TYPES: {
			"0": {
				name: "Egg",
				description: "",
				color: "#42af14"
			},
			"1": {
				name: "Hatchling",
				description: "",
				color: "#e46e36"
			},
			"2": {
				name: "Nestling",
				description: "",
				color: "#60179e"
			},
			"3": {
				name: "Fledgling",
				description: "",
				color: "#dbb926"
			},
			"4": {
				name: "Grown",
				description: "",
				color: "#0082c8"
			},
			"5": {
				name: "Master",
				description: "",
				color: "#a1011e"
			},
			"6": {
				name: "Wise",
				description: "",
				color: "#555555"
			}
		},
		SCALERS: {
			"addressed_feedback": {
				"qunit": 0.05,
				"factor_x": true
			},
	
			"take_photo": {
				"qunit": 0.5,
				"factor_x": true
			}
		},
		getTierMultiplier: function getTierMultiplier(tier) {
			switch (tier) {
				case 0:
					return 1.0;
				case 1:
					return 2.0;
				case 2:
					return 3.0;
				case 3:
					return 4.0;
				case 4:
					return 5.0;
				case 5:
					return 6.0;
				default:
					return 6.0;
			}
		},
		getData: function getData(tierKey) {
			return Tiers.TYPES[tierKey];
		},
	
	
		getName: function getName(tierKey) {
			var tier = Tiers.getData(tierKey);
			if (tier) {
				return tier.name;
			}
		},
	
		getDescription: function getDescription(tierKey) {
			var tier = Tiers.getData(tierKey);
			if (tier) {
				return tier.description;
			}
		},
	
		getIcon: function getIcon(tierKey) {
			var tier = Tiers.getData(tierKey);
			if (tier) {
				return dynamicRequire("tiers/wing-" + tierKey + ".png");
			}
		},
	
		getColor: function getColor(tierKey) {
			var tier = Tiers.getData(tierKey);
			if (tier) {
				return tier.color;
			}
		},
	
		getRequirements: function getRequirements(tier) {
			// default to tier 3 requirements for unrecognized tier values
			return Tiers.REQUIREMENTS[tier.toString()] || Tiers.REQUIREMENTS["3"];
		},
		isSupportedTier: function isSupportedTier(tier) {
			return tier.toString() in Tiers.REQUIREMENTS;
		},
		getQunitXValue: function getQunitXValue(item_type, tier) {
			if (item_type in Tiers.SCALERS) {
				var item = Tiers.SCALERS[item_type];
				var value = Tiers.QUNIT * item.qunit;
				if (item.factor_x) {
					value *= Tiers.getTierMultiplier(tier);
				}
	
				return value;
			} else {
				return 0;
			}
		}
	};
	
	Tiers.QUNIT = 200;
	module.exports = Tiers;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toQuery = toQuery;
	exports.nonQuizAnswerQuery = nonQuizAnswerQuery;
	exports.metaCogAnswerQuery = metaCogAnswerQuery;
	exports.reviewQuery = reviewQuery;
	var QuestionTypes = __webpack_require__(82);
	var TextTypes = __webpack_require__(38);
	
	// Filters are directly applied as key value to query
	// Conditions are transformed in different ways depending on the key
	function toQuery(filters, conditions) {
		var query = _.clone(filters || {});
	
		if (!_.isEmpty(conditions)) {
			if (conditions.userIDs && conditions.userIDs.length > 0) {
				query.user_ids = conditions.userIDs.join(",");
			}
	
			if (conditions.userID) {
				query.user_id = conditions.userID;
			}
	
			if (conditions.studentListIDs && conditions.studentListIDs.length > 0) {
				query.student_list_ids = conditions.studentListIDs.join(",");
			}
	
			if (conditions.studentListID) {
				query.student_list_id = conditions.studentListID;
			}
	
			if (conditions.textVariety && conditions.textVariety != TextTypes.Varieties.BOTH) {
				query.text_variety = conditions.textVariety;
			}
			if (conditions.startDate) {
				query.start_date = conditions.startDate;
			}
			if (conditions.endDate) {
				query.end_date = conditions.endDate;
			}
			if (conditions.textID) {
				query.text_id = conditions.textID;
			}
			if (conditions.status) {
				query.status = conditions.status;
			}
	
			if (conditions.sample) {
				query.sample = conditions.sample;
			}
			if (conditions.order) {
				query.order_by = conditions.order;
			}
			if (conditions.perPage) {
				query.per_page = conditions.perPage;
			}
			if (conditions.withTotal) {
				query.with_total = conditions.withTotal;
			}
			if (conditions.noPagination) {
				query.no_pagination = conditions.noPagination;
			}
			if (conditions.slIDs) {
				query.sl_ids = conditions.slIDs.join(',');
			}
			if (conditions.adminID) {
				query.id = conditions.adminID;
			}
			if (conditions.entityType) {
				query.entity_type = conditions.entityType;
			}
			if (conditions.entityID) {
				query.entity_id = conditions.entityID;
			}
			if (conditions.period) {
				query.period = conditions.period;
			}
			if (conditions.archived) {
				query.archived = conditions.archived;
			}
			if (conditions.key) {
				query.key = conditions.key;
			}
			if (conditions.readBook) {
				query.read_book = conditions.readBook;
			}
			if (conditions.digestSummary) {
				query.digest_summary = conditions.digestSummary;
			}
			if (conditions.graphDigestsOnly) {
				query.graph_digests_only = conditions.graphDigestsOnly;
			}
			if (conditions.name) {
				query.name = conditions.name;
			}
			if (conditions.page) {
				query.page = conditions.page;
			}
			if (conditions.nameExact) {
				query.name_exact = conditions.nameExact;
			}
			if (conditions.orgAdminID) {
				query.org_admin_id = conditions.orgAdminID;
			}
			if (conditions.orgID) {
				query.org_id = conditions.orgID;
			}
	
			if (conditions.allowDraft) {
				query.draft = true;
			} else if (conditions.draftOnly) {
				query.draft = "only";
			} else if (conditions.draft !== undefined) {
				query.draft = conditions.draft;
			}
	
			if (conditions.oneOfMatch) {
				_.each(conditions.oneOfMatch, function (values, key) {
					query[key] = values.join(",");
				});
			}
		}
	
		return query;
	}
	
	function nonQuizAnswerQuery(baseQuery) {
		return _.extend({}, baseQuery, {
			for_quiz: false,
			question_types: QuestionTypes.BASIC_TYPES.join(",")
		});
	}
	
	function metaCogAnswerQuery(baseQuery) {
		return _.extend({}, baseQuery, {
			question_types: QuestionTypes.META_COGNITIVE_QUESTION
		});
	}
	
	function reviewQuery(baseQuery) {
		return _.extend({}, baseQuery, {
			question_types: QuestionTypes.REVIEW_QUESTION
		});
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var APIError = __webpack_require__(444);
	var WhooosReadingClientApi = __webpack_require__(124);
	
	if (!window.$wr || $wr.isDevelopment()) {
		var Client = new WhooosReadingClientApi.Client("localhost:3002", "http");
	} else if ($wr.isStaging()) {
		var Client = new WhooosReadingClientApi.Client("api.savvashortondev.com", "https");
	} else {
		var Client = new WhooosReadingClientApi.Client("api.whooosreading.org", "https"); // Uses the default endpoint for the library
	}
	
	window.NoUseAPIClient = Client;
	
	Client.addResponseHandler(function (response) {
		if (response.ok) {
			return response;
		} else {
			console.log(response, "ERROR RESPONSE");
			handleHTTPError(response.status);
	
			var error = new APIError("WR", response.status, response.url);
			return Promise.reject(error);
		}
	});
	
	function handleHTTPError(status) {
		LuckyOrangeClient.tagComponent("HTTPError");
		function displayAlert(title, text) {
			if (window.wrNotifications) {
				window.wrNotifications.triggerDropDownNotification({ title: title,
					text: text, icon: "exclamation-sign", type: "error" }, 6000);
			} else {
				alert(title + ": " + text);
			}
		}
	
		switch (status) {
			case 401:
				displayAlert("You've been logged out!", "Log in to see the page you were trying to view.");
				$wr.redirect("/login");
				break;
	
			case 403:
				displayAlert("Sorry!", "You can't view this page");
				$wr.redirect("/");
				break;
	
			case 404:
				displayAlert("Sorry!", "You can't view this page");
				$wr.redirect("/");
				break;
	
			case 400:
				displayAlert("Something went wrong, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				// if (onError) { onError() }
				break;
	
			case 500:
				// This probably wasn't on a route load because we should have caught that in the route onEnter
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				// if (onError) { onError() }
				break;
	
			case 502:
			case 503:
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... one of our servers seems to have gone down. Please try again later!");
				// if (onError) { onError() }
				break;
	
			case 504:
				displayAlert("Something went wrong on our end, sorry!", "Too many people are using WR right now! We are working on it now. Please try again later!");
				// if (onError) { onError() }
				break;
		}
	}
	
	module.exports = Client;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(37)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(60)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(134)('meta');
	var isObject = __webpack_require__(32);
	var has = __webpack_require__(67);
	var setDesc = __webpack_require__(47).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(30)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            return true;
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMError]';
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMException]';
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return Object.prototype.toString.call(wat) === '[object String]';
	}
	exports.isString = isString;
	/**
	 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return Object.prototype.toString.call(wat) === '[object Object]';
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return Object.prototype.toString.call(wat) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvatarPatch = __webpack_require__(371);
	
	__webpack_require__(3623);
	
	var Owlvatar = function (_React$Component) {
		_inherits(Owlvatar, _React$Component);
	
		function Owlvatar(props) {
			_classCallCheck(this, Owlvatar);
	
			var _this = _possibleConstructorReturn(this, (Owlvatar.__proto__ || Object.getPrototypeOf(Owlvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(Owlvatar, [{
			key: "getPatchScale",
			value: function getPatchScale(offsets) {
	
				var scale = 1.0;
				if (this.props.maxWidth && offsets["width"] > this.props.maxWidth) {
					scale = this.props.maxWidth / offsets["width"];
				}
				if (this.props.maxHeight && offsets["height"] > this.props.maxHeight) {
					scale = this.props.maxHeight / offsets["height"];
				}
				return scale;
			}
		}, {
			key: "getPatchOffsets",
			value: function getPatchOffsets() {
				var patches = _.reject(_.values(this.props.patches), function (p) {
					return p == Owlvatar.NO_PATCH;
				});
				var extraLeft = _.max(patches.map(function (p) {
					return p["extra_left"] || 0;
				}));
				var extraWidth = _.max(patches.map(function (p) {
					return p["extra_right"] || 0;
				})) + extraLeft;
				var extraTop = _.max(patches.map(function (p) {
					return p["extra_top"] || 0;
				}));
				var extraHeight = _.max(patches.map(function (p) {
					return p["extra_bottom"] || 0;
				})) + extraTop;
				return {
					left: AvatarPatch.DEFAULT_LEFT + extraLeft,
					width: AvatarPatch.DEFAULT_WIDTH + extraWidth,
					top: AvatarPatch.DEFAULT_TOP + extraTop,
					height: AvatarPatch.DEFAULT_HEIGHT + extraHeight
				};
			}
		}, {
			key: "render",
			value: function render() {
				var patches = [];
	
				var offsets = this.getPatchOffsets();
				var scale = this.getPatchScale(offsets);
	
				var outerStyle = {
					position: "relative",
					width: offsets["width"] * scale + "px",
					height: offsets["height"] * scale + "px"
				};
	
				if (!this.props.nofloat) {
					outerStyle.float = "left";
				}
	
				var innerStyle = {
					position: "relative",
					width: AvatarPatch.WIDTH * scale + "px",
					height: AvatarPatch.HEIGHT * scale + "px",
					left: offsets["left"] * scale + "px",
					top: offsets["top"] * scale + "px"
				};
	
				if (this.props.patches["wings"]) {
					var handOffsets = this.props.patches["wings"]["offsets"];
					var newHandOffsets = {};
					//cannot modify handoffsets directly, it's a shallow copy
					//of props.patches["wings"]["offsets"], and also will alter
					//props in memory
					_.keys(handOffsets).forEach(function (key) {
						newHandOffsets[key] = handOffsets[key] * scale;
					});
				}
				_.pairs(this.props.patches).forEach(function (patchPair) {
					var patchType = patchPair[0];
					var patch = patchPair[1];
					var patchColor = this.props.colors[patchType];
	
					if (patch != Owlvatar.NO_PATCH) {
						patches.push(React.createElement(AvatarPatch, { patch: patch, color: patchColor, key: patchType,
							offsets: newHandOffsets }));
					}
				}.bind(this));
	
				if (this.props.showHonorRays) {
					var honorRayDims = {
						width: AvatarPatch.WIDTH * scale + "px",
						height: AvatarPatch.HEIGHT * scale + "px"
					};
					patches.push(React.createElement("img", { src: __webpack_require__(1734), key: "honorRays",
						style: honorRayDims }));
				}
	
				return React.createElement(
					"div",
					{ className: "owlConstraints", style: outerStyle },
					React.createElement(
						"div",
						{ className: "owlConstraintsInner", style: innerStyle },
						patches
					)
				);
			}
		}]);
	
		return Owlvatar;
	}(React.Component);
	
	;
	
	Owlvatar.NO_PATCH = "no_patch";
	
	Owlvatar.propTypes = StrictPropTypes({
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number,
		nofloat: PropTypes.bool, // Too many legacy uses depend on it floating
	
		patches: PropTypes.object.isRequired,
		colors: PropTypes.object,
	
		showHonorRays: PropTypes.bool
	});
	
	module.exports = Owlvatar;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateSpans = __webpack_require__(177);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var CurrentUser = __webpack_require__(3);
	var DataRouting = __webpack_require__(36);
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(647);
	
	var DateSpanSelector = function (_React$Component) {
		_inherits(DateSpanSelector, _React$Component);
	
		function DateSpanSelector(props) {
			_classCallCheck(this, DateSpanSelector);
	
			var _this = _possibleConstructorReturn(this, (DateSpanSelector.__proto__ || Object.getPrototypeOf(DateSpanSelector)).call(this));
	
			autobind(_this);
	
			_this.state = _this.getInitialState();
			return _this;
		}
	
		_createClass(DateSpanSelector, [{
			key: "getInitialState",
			value: function getInitialState() {
				return {
					showDatePicker: false, showOtherPeriodPicker: false,
					tempStartDate: null, tempEndDate: null
				};
			}
		}, {
			key: "confirmCustomDates",
			value: function confirmCustomDates() {
				var _this2 = this;
	
				var startDate = this.state.tempStartDate;
				var endDate = this.state.tempEndDate;
				this.setState(this.getInitialState(), function () {
					_this2.props.onSelectDates(startDate, endDate);
				});
			}
		}, {
			key: "getAllDates",
			value: function getAllDates() {
				if (CurrentUser.get().first_active) {
					var start = $wr.formatDate(new Date(CurrentUser.get().first_active), "YYYY-MM-DD");
					var end = $wr.formatDate(new Date(), "YYYY-MM-DD");
					return { start: start, end: end };
				}
			}
		}, {
			key: "selectDate",
			value: function selectDate(dateSpan, e) {
				var _this3 = this;
	
				$wr.nope(e);
				if (dateSpan.label == DateSpans.CUSTOM_DATES) {
					this.setState({
						showDatePicker: true, showOtherPeriodPicker: false,
						tempStartDate: this.props.startDate, tempEndDate: this.props.endDate
					});
				} else if (dateSpan.label == DateSpans.OTHER_PERIODS) {
					this.setState(_.extend({}, this.getInitialState(), { showOtherPeriodPicker: true }));
				} else {
					this.setState(this.getInitialState(), function () {
						if (dateSpan.label == ALL_DATES_LABEL) {
							dateSpan.value = _this3.getAllDates() || {};
						}
						_this3.props.onSelectDates(dateSpan.value.start, dateSpan.value.end);
					});
				}
			}
		}, {
			key: "renderCurrentLabel",
			value: function renderCurrentLabel() {
				var _this4 = this;
	
				if (this.state.showDatePicker) {
					// Don't show any dates
					return React.createElement(
						"span",
						null,
						DateSpans.CUSTOM_DATES
					);
				}
	
				if (this.state.showOtherPeriodPicker) {
					// Don't show any dates
					return React.createElement(
						"span",
						null,
						DateSpans.OTHER_PERIODS
					);
				}
	
				if (this.props.noDatesOption && this.props.startDate == undefined && this.props.endDate == undefined) {
					if (this.props.widgetMode) {
						if (this.props.expectationsSpans && this.props.expectationsSpans.length > 0) {
							var label = this.props.expectationsSpans[0].label;
						} else {
							var label = ALL_DATES_LABEL;
						}
	
						return React.createElement(
							"span",
							null,
							label
						);
					} else {
						return React.createElement(
							"span",
							null,
							ALL_DATES_LABEL
						);
					}
				}
	
				var isCurrentSpan = function isCurrentSpan(span) {
					return span.value.start == _this4.props.startDate && span.value.end == _this4.props.endDate;
				};
	
				var conditions = { value: { start: this.props.startDate, end: this.props.endDate } };
				var match = _.find(DateSpans.dashboardSpans(this.props.expectationsSpans), isCurrentSpan);
	
				if (!match) {
					match = _.find(DateSpans.otherExpectationsSpans(this.props.expectationsSpans), isCurrentSpan);
				}
	
				if (match) {
					var label = match.label;
				} else {
					var label = DateSpans.CUSTOM_DATES;
				}
	
				var startDate = (0, _moment2.default)(this.props.startDate).format("M/DD/YY");
				var endDate = (0, _moment2.default)(this.props.endDate).format("M/DD/YY");
	
				return React.createElement(
					"span",
					null,
					label,
					" ",
					React.createElement(
						"span",
						{ className: "spanDates" },
						"(",
						startDate,
						" - ",
						endDate,
						")"
					)
				);
			}
		}, {
			key: "renderDatePickers",
			value: function renderDatePickers() {
				var _this5 = this;
	
				return React.createElement(
					"div",
					{ className: "datePickerContainer" },
					React.createElement(_reactDatepicker2.default, { readOnly: true, selected: (0, _moment2.default)(this.state.tempStartDate),
						onChange: function onChange(date) {
							return _this5.setState({ tempStartDate: date.format(DateSpans.FORMAT) });
						} }),
					React.createElement(
						"span",
						null,
						"To"
					),
					React.createElement(_reactDatepicker2.default, { readOnly: true, minDate: (0, _moment2.default)(this.state.tempStartDate),
						selected: (0, _moment2.default)(this.state.tempEndDate),
						onChange: function onChange(date) {
							return _this5.setState({ tempEndDate: date.format(DateSpans.FORMAT) });
						} }),
					React.createElement(
						"button",
						{ className: "btn buttonPrimary confirmBtn",
							onClick: this.confirmCustomDates },
						"Set"
					)
				);
			}
		}, {
			key: "renderOtherSpanSelector",
			value: function renderOtherSpanSelector() {
				var _this6 = this;
	
				var spanOptions = _.map(DateSpans.otherExpectationsSpans(this.props.expectationsSpans), function (option) {
					if (option.label == DateSpans.CUSTOM_DATES || option.label == DateSpans.OTHER_PERIODS) {
						var text = React.createElement(
							"span",
							null,
							option.label
						);
					} else {
						var text = DateSpans.renderSpan(option);
					}
	
					return React.createElement(ButtonDropdownOption, { onClick: _this6.selectDate.bind(_this6, option),
						text: text, key: option.label });
				});
	
				return React.createElement(
					ButtonDropdown,
					{ text: "Select Time Period", dropdownDisplay: "link" },
					spanOptions
				);
			}
		}, {
			key: "renderMainSpanSelector",
			value: function renderMainSpanSelector() {
				var _this7 = this;
	
				var spanOptions = _.map(DateSpans.dashboardSpans(this.props.expectationsSpans), function (option) {
					if (option.label == DateSpans.CUSTOM_DATES || option.label == DateSpans.OTHER_PERIODS) {
						var text = React.createElement(
							"span",
							null,
							option.label
						);
					} else {
						var text = DateSpans.renderSpan(option);
					}
	
					return React.createElement(ButtonDropdownOption, { onClick: _this7.selectDate.bind(_this7, option),
						text: text, key: option.label });
				});
	
				if (this.props.noDatesOption && this.props.showAllDates) {
					var placeholderOp = { label: ALL_DATES_LABEL, value: {} };
					var onDatesOption = React.createElement(ButtonDropdownOption, { onClick: this.selectDate.bind(this, placeholderOp),
						text: ALL_DATES_LABEL });
				}
	
				var timePeriodLabel = this.renderCurrentLabel();
	
				return React.createElement(
					ButtonDropdown,
					{ text: timePeriodLabel, dropdownDisplay: "link" },
					onDatesOption,
					spanOptions
				);
			}
		}, {
			key: "renderWidgetSpanSelector",
			value: function renderWidgetSpanSelector() {
				var _this8 = this;
	
				var spanOptions = _.map(DateSpans.widgetSpans(this.props.expectationsSpans), function (option) {
	
					if (option.label == DateSpans.CUSTOM_DATES || option.label == DateSpans.OTHER_PERIODS) {
						var text = React.createElement(
							"span",
							null,
							option.label
						);
					} else {
						var text = DateSpans.renderSpan(option);
					}
	
					return React.createElement(ButtonDropdownOption, { onClick: _this8.selectDate.bind(_this8, option),
						text: text, key: option.label });
				});
	
				if (this.props.noDatesOption && this.props.showAllDates) {
					var placeholderOp = { label: ALL_DATES_LABEL, value: {} };
					var onDatesOption = React.createElement(ButtonDropdownOption, { onClick: this.selectDate.bind(this, placeholderOp),
						text: ALL_DATES_LABEL });
				}
	
				var timePeriodLabel = this.renderCurrentLabel();
	
				var dataTip = 'View all dates and metrics<br/>on the Other Stats table';
				var moreDatesOption = React.createElement(
					ButtonDropdownOption,
					{ className: "otherStatsMenuOption", onClick: function onClick() {
							return _this8.props.updateLocationState({ subjectType: DataRouting.SUBJECT_OTHER_METRICS });
						},
						text: MORE_DATES_LABEL },
					React.createElement(
						"span",
						{ className: "otherStatsInfoSign", "data-tip": dataTip, "data-for": dataTip, "data-html": true },
						React.createElement(Glyphicon, { icon: "info-sign" }),
						React.createElement(ReactTooltip, { effect: "solid", id: dataTip })
					)
				);
	
				return React.createElement(
					ButtonDropdown,
					{ text: timePeriodLabel, dropdownDisplay: "link" },
					onDatesOption,
					spanOptions,
					moreDatesOption
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.widgetMode) {
					var mainSpanSelector = this.renderWidgetSpanSelector();
				} else {
					var mainSpanSelector = this.renderMainSpanSelector();
				}
	
				if (this.state.showOtherPeriodPicker) {
					var otherTimeSpanSelectors = this.renderOtherSpanSelector();
				}
	
				if (this.state.showDatePicker) {
					var datePickers = this.renderDatePickers();
				}
	
				return React.createElement(
					"span",
					{ className: "dateSpanSelector" },
					mainSpanSelector,
					otherTimeSpanSelectors,
					datePickers
				);
			}
		}]);
	
		return DateSpanSelector;
	}(React.Component);
	
	;
	
	var ALL_DATES_LABEL = "All Dates";
	var MORE_DATES_LABEL = "More Dates";
	var EXPECTATION_PERIOD_LABELS = {
		"weekly": "Current Week",
		"month": "Current Month",
		"trimester": "Current Trimester",
		"semester": "Current Semester",
		"school-year": "Current School Year"
	};
	
	DateSpanSelector.propTypes = StrictPropTypes({
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		onSelectDates: PropTypes.func.isRequired,
		updateLocationState: PropTypes.func,
		noDatesOption: PropTypes.bool,
		showAllDates: PropTypes.bool,
		widgetMode: PropTypes.bool,
		expectationsSpans: PropTypes.array
	});
	
	module.exports = DateSpanSelector;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3636);
	
	var EmptyState = function (_React$Component) {
		_inherits(EmptyState, _React$Component);
	
		function EmptyState(props) {
			_classCallCheck(this, EmptyState);
	
			var _this = _possibleConstructorReturn(this, (EmptyState.__proto__ || Object.getPrototypeOf(EmptyState)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(EmptyState, [{
			key: "render",
			value: function render() {
				if (this.props.type == BOOKS) {
					var text = "Your students have not done any book activity.";
					var emptyStateContent = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							text
						),
						React.createElement(
							"div",
							{ className: "tableContainer" },
							React.createElement("div", { className: "tableRow" }),
							React.createElement("div", { className: "tableRow" }),
							React.createElement("div", { className: "tableRow" })
						)
					);
				} else if (this.props.type == QUIZZES || this.props.type == PRACTICE_QUESTIONS) {
					if (this.props.type == QUIZZES) {
						var emptyNote = "Your students have not taken any quizzes.";
					} else {
						var emptyNote = "Your students have not answered any practice questions.";
					}
					var emptyStateContent = React.createElement(
						"div",
						{ className: "contentContainer" },
						React.createElement(
							"p",
							{ className: "emptyNote" },
							emptyNote
						),
						React.createElement("div", { className: "emptyText emptyTextShort" }),
						React.createElement("div", { className: "emptyText emptyTextMiddle" }),
						React.createElement("div", { className: "emptyText emptyTextShort emptyTextFinal" })
					);
				} else if (this.props.type == LOGS) {
					var emptyStateContent = React.createElement(
						"div",
						{ className: "logContainer" },
						React.createElement(
							"p",
							{ className: "emptyNote" },
							"Your students have not logged any reading."
						),
						React.createElement("div", { className: "emptyText" }),
						React.createElement("div", { className: "emptyText" }),
						React.createElement("div", { className: "emptyText" })
					);
				} else if (this.props.type == RL_GRAPH) {
					var emptyStateContent = React.createElement(
						"div",
						{ className: "rlGraphContainer" },
						React.createElement(
							"p",
							null,
							"Your students have not done any book activity."
						),
						React.createElement(
							"div",
							{ className: "graphFrame" },
							React.createElement("div", { className: "graphMiddleLine" }),
							React.createElement("div", { className: "valuesLine" })
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "emptyStateContainer" },
					emptyStateContent
				);
			}
		}]);
	
		return EmptyState;
	}(React.Component);
	
	var BOOKS = "books";
	var GOALS = "goals";
	var QUIZZES = "quizzes";
	var LOGS = "logs";
	var PRACTICE_QUESTIONS = "practice-questions";
	var RL_GRAPH = "reading-level-graph";
	
	EmptyState.propTypes = PageStrictPropTypes({
		type: PropTypes.string,
		showFullData: PropTypes.bool
	});
	
	module.exports = EmptyState;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactSelect = __webpack_require__(154);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ZPDRange = __webpack_require__(176);
	var WhooosReadingServices = __webpack_require__(25);
	var BookCover = __webpack_require__(140);
	var Glyphicon = __webpack_require__(8);
	var ValidatingInput = __webpack_require__(91);
	var TextTypes = __webpack_require__(38);
	var Spinner = __webpack_require__(9);
	var ReactTooltip = __webpack_require__(12);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var PaywallModal = __webpack_require__(44);
	
	__webpack_require__(3725);
	
	var SmartBookSearch = (_dec = (0, _reactRedux.connect)(function (state, props) {
		if (props.existingAssignedBooks) {
			return { existingBooks: props.existingAssignedBooks };
		} else if (props.userID) {
			// See BookActionSection selector conditions before changing
			var books = ReadingSelectors.books({ state: state,
				conditions: { userID: props.userID, allowDraft: true, nonBlank: ["text_id", "title"] } });
			books = _.sortBy(books, "last_active").reverse();
			return { existingBooks: books };
		} else {
			return {};
		}
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (props.userID) {
					dispatch(ReadingActions.fetchBookActivity({
						conditions: { userID: props.userID, allowDraft: true },
						cache: true, fetchDetails: true
					}));
				}
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(SmartBookSearch, _React$Component);
	
		function SmartBookSearch(props) {
			_classCallCheck(this, SmartBookSearch);
	
			var _this = _possibleConstructorReturn(this, (SmartBookSearch.__proto__ || Object.getPrototypeOf(SmartBookSearch)).call(this));
	
			autobind(_this);
			_this.state = {
				searchOptions: null, currentInput: "",
				searchTimer: null, showManualFields: false, isManualURL: false, loadingSearch: false,
				matildaError: false, grSearchComplete: false, searchPending: false, showAddManual: false,
				trustedSearchComplete: false, regularSearchComplete: false
			};
			return _this;
		}
	
		_createClass(SmartBookSearch, [{
			key: "selectBook",
			value: function selectBook(selection) {
				if (selection && selection.value) {
					if (selection.value.flagToggleManual) {
						if (CurrentUser.get().prefs.automatic_zpd_exclusion && CurrentUser.isStudent()) {
							if (confirm("This book will not count toward your goals unless your teacher chooses to make it count. Do you want to continue?")) {
								this.toggleManual();
							}
						} else {
							this.toggleManual();
						}
					} else if (selection.value.flagEmptySpace == undefined) {
						if (CurrentUser.get().prefs.automatic_zpd_exclusion && CurrentUser.isStudent()) {
							var studentReadingLevel = CurrentUser.get().current_reading_level;
	
							var textReadingLevel = selection.value.lexile_score;
	
							if (textReadingLevel == undefined) {
								if (confirm("This book will not count toward your goals unless your teacher chooses to make it count. Do you want to continue?")) {
									var isFirst = _.size(this.props.existingBooks) == 0;
									this.props.onBookSelect(selection.value, isFirst);
								}
							} else {
								var zpdStatus = ZPDRange.getTextStatus(textReadingLevel, studentReadingLevel);
	
								var confirmMessage = "This book is below your reading level and will not count toward your goals. Do you want to continue?";
	
								if (zpdStatus != ZPDRange.UNDER || confirm(confirmMessage)) {
									var isFirst = _.size(this.props.existingBooks) == 0;
									this.props.onBookSelect(selection.value, isFirst);
								}
							}
						} else {
							var isFirst = _.size(this.props.existingBooks) == 0;
							this.props.onBookSelect(selection.value, isFirst);
						}
	
						if (this.state.searchOptions) {
							var indexSelect = this.state.searchOptions.map(function (so) {
								return so.value.text_id;
							}).indexOf(selection.value.text_id);
	
							Mycroft.newEvent({
								category: "Book Select",
								action: "index-selected-" + indexSelect,
								label: selection.value.title });
						}
						this.setState({
							showManualFields: false,
							searchOptions: [],
							currentInput: selection.value.title });
					}
				} else {
					this.props.onBookSelect(null);
				}
			}
		}, {
			key: "toggleManual",
			value: function toggleManual(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.setState({ showManual: !this.state.showManual }, function () {
					if (_this2.state.showManual) {
						_this2.refs.manualTitle.focus();
					}
				});
			}
		}, {
			key: "setManualURL",
			value: function setManualURL(value) {
				this.setState({ isManualURL: value });
			}
		}, {
			key: "resetSearch",
			value: function resetSearch() {
				this.setState({ trustedSearchComplete: false, regularSearchComplete: false, grSearchComplete: false,
					loadingSearch: false });
			}
		}, {
			key: "searchBooks",
			value: function searchBooks(input) {
				if (!this.props.blockSearch) {
					this.resetSearch();
					var trimInput = input.trim();
	
					if (trimInput.length == 0) {
						this.setState({ searchOptions: [], currentInput: input });
					} else {
						var searchKey = Math.random();
						this._searchKey = searchKey;
	
						setTimeout(function () {
							if (searchKey == this._searchKey) {
								var searchParams = { q: trimInput, trusted: true };
								this.triggerMatilda(searchParams);
							}
						}.bind(this), DELAY_SEARCH_TIME);
						this.setState({ currentInput: input, loadingSearch: true });
					}
				} else {
					this.refs.paywallModal.show();
				}
			}
		}, {
			key: "scrollTriggerMatilda",
			value: function scrollTriggerMatilda() {
				// TRIGGER REGULAR SEARCH
				var searchParams = { q: this.state.currentInput.trim()
					// UNLESS REGULAR SEARCH WAS COMPLETED, THEN TRIGGER GR SEARCH
				};if (this.state.regularSearchComplete) {
					searchParams.gr = true;
				}
	
				if (!this.state.grSearchComplete && this.state.currentInput != "") {
					this.setState({ loadingSearch: true });
					this.triggerMatilda(searchParams);
				}
			}
		}, {
			key: "handleTrustedSearchCallback",
			value: function handleTrustedSearchCallback(searchParams, searchOptions) {
				var _this3 = this;
	
				this.setState({
					searchOptions: searchOptions,
					loadingSearch: false,
					searchPending: false,
					trustedSearchComplete: true
				}, function () {
					if (searchOptions.length < 3 && !_this3.state.grSearchComplete) {
						delete searchParams["trusted"]; // REMOVE TRUSTED TO MAKE REGULAR SEARCH
						_this3.triggerMatilda(searchParams);
					}
				});
			}
		}, {
			key: "handleGrSearchCallback",
			value: function handleGrSearchCallback(searchParams, searchOptions) {
				this.setState({
					searchOptions: this.addGrResults(searchOptions),
					loadingSearch: false,
					grSearchComplete: true,
					searchPending: false,
					showAddManual: true
				});
			}
		}, {
			key: "handleRegularSearchCallback",
			value: function handleRegularSearchCallback(searchParams, searchOptions) {
				var _this4 = this;
	
				var data = this.addGrResults(searchOptions);
				this.setState({
					searchOptions: data,
					regularSearchComplete: true,
					loadingSearch: false,
					searchPending: false
				}, function () {
					if (data.length < 3 && !_this4.state.grSearchComplete) {
						searchParams["gr"] = true;
						_this4.triggerMatilda(searchParams);
					}
				});
			}
		}, {
			key: "formatSearchOptions",
			value: function formatSearchOptions(data) {
				return _.map(data.results, function (book) {
					return { value: book, label: this.state.currentInput };
				}.bind(this));
			}
		}, {
			key: "triggerMatilda",
			value: function triggerMatilda(searchParams) {
				if (!this.state.searchPending) {
					this.setState({ searchPending: true, showAddManual: false });
					var url = WhooosReadingServices.Matilda.url("/search", searchParams);
	
					// IN CASE SEARCH TAKES TOO LONG, DISPLAY MANUAL INPUT
					var timeout = setTimeout(function () {
						this.setState({ showAddManual: true });
					}.bind(this), FETCH_TIMEOUT);
	
					$wr.requestJSON(url, null, "GET", function (data) {
						clearTimeout(timeout);
						var searchOptions = this.formatSearchOptions(data);
	
						// HANDLE THREE CALLBACKS FOR 3 TYPES OF SEARCH
						if ("trusted" in searchParams) {
							this.handleTrustedSearchCallback(searchParams, searchOptions);
						} else if ("gr" in searchParams) {
							this.handleGrSearchCallback(searchParams, searchOptions);
						} else {
							this.handleRegularSearchCallback(searchParams, searchOptions);
						}
					}.bind(this), function (data) {
						this.setState({ matildaError: true });
					}.bind(this));
				}
			}
		}, {
			key: "addGrResults",
			value: function addGrResults(grResults) {
				var mergedResults = (this.state.searchOptions || []).concat(grResults);
				var text_id_arr = mergedResults.map(function (text) {
					return text.value.text_id;
				});
				return mergedResults.filter(function (item, pos) {
					return text_id_arr.indexOf(item.value.text_id) == pos;
				});
			}
		}, {
			key: "draftClick",
			value: function draftClick(textID, activityType, e) {
				if (e) {
					$wr.nope(e);
					e.stopPropagation();
				}
	
				if (activityType == "quiz") {
					$wr.redirect("/quiz?text_id=" + textID);
				} else if (activityType == "answer") {
					$wr.redirect("/answers/new?text_id=" + textID);
				} else if (activityType == "review") {
					$wr.redirect("/reviews/new?text_id=" + textID);
				} else if (activityType == "exercise") {
					$wr.redirect("/responses/new?text_id=" + textID);
				}
			}
		}, {
			key: "shouldDisplayZPD",
			value: function shouldDisplayZPD() {
				// if not a student, don't display them. Relevant for the question search page.
				if (!CurrentUser.isStudent()) {
					return false;
				}
				// if they are a student, base it out of prefs 
				return CurrentUser.get().prefs.show_students_zpd_icon;
			}
		}, {
			key: "optionRenderer",
			value: function optionRenderer(optionData, index) {
				var book = optionData.value;
				if (book.flagToggleManual) {
					var manualText = "We don't have that book.";
					var linkText = "Add it now!";
	
					return React.createElement(
						"span",
						{ className: "searchOpDisplay" },
						React.createElement(Glyphicon, { icon: "book", className: "coverIconSub" }),
						React.createElement(
							"span",
							null,
							manualText,
							" ",
							React.createElement(
								"a",
								{ href: "#", onClick: $wr.nope },
								linkText
							)
						)
					);
				} else if (book.flagEmptySpace) {
					return React.createElement(
						"span",
						{ className: "emptyContainer" },
						React.createElement(Spinner, { scale: 1.2 })
					);
				} else if (book.flagPlaceholder) {
					return React.createElement("span", { className: "placeholderContainer" });
				} else {
					var draftIcons = [];
					if (_.any(book.quiz_draft_counts)) {
						draftIcons.push(React.createElement(
							"span",
							{ className: "draftPair", key: "quiz",
								onMouseDown: this.draftClick.bind(this, book.text_id, "quiz") },
							React.createElement("img", { src: __webpack_require__(592),
								key: "quiz", className: "quizDraftIcon", title: "Draft quiz" }),
							React.createElement("br", null),
							"Quiz"
						));
					}
					if (_.any(book.answer_draft_counts)) {
						draftIcons.push(React.createElement(
							"span",
							{ className: "draftPair", key: "answer",
								onMouseDown: this.draftClick.bind(this, book.text_id, "answer") },
							React.createElement("img", { src: __webpack_require__(3409),
								key: "answer", title: "Draft answer" }),
							React.createElement("br", null),
							"Answer"
						));
					}
					if (_.any(book.review_draft_counts)) {
						draftIcons.push(React.createElement(
							"span",
							{ className: "draftPair", key: "review",
								onMouseDown: this.draftClick.bind(this, book.text_id, "review") },
							React.createElement("img", { src: __webpack_require__(187),
								key: "review", title: "Draft review" }),
							React.createElement("br", null),
							"Review"
						));
					}
					if (_.any(book.response_draft_counts)) {
						draftIcons.push(React.createElement(
							"span",
							{ className: "draftPair", key: "exercise",
								onMouseDown: this.draftClick.bind(this, book.text_id, "exercise") },
							React.createElement("img", { src: __webpack_require__(186),
								key: "exercise", title: "Draft exercise" }),
							React.createElement("br", null),
							"Exercise"
						));
					}
	
					return React.createElement(
						"span",
						{ className: "searchOpDisplay" },
						React.createElement(BookCover, { book: book, coverWidth: 40, showTitle: true, showAuthor: true,
							showReadingLevelIcon: this.shouldDisplayZPD() }),
						React.createElement(
							"span",
							{ className: "draftIcons" },
							draftIcons
						)
					);
				}
			}
		}, {
			key: "getNonTechnicalOptions",
			value: function getNonTechnicalOptions() {
				var allOptions = [];
				if (this.props.existingBooks) {
					allOptions = allOptions.concat(_.map(this.props.existingBooks, function (book) {
						return { value: book, label: book.title };
					}));
				}
				if (this.state.searchOptions) {
					allOptions = allOptions.concat(this.state.searchOptions);
				}
	
				allOptions = _.uniq(allOptions, function (option) {
					return option.value.text_id;
				});
				return allOptions;
			}
		}, {
			key: "getOptions",
			value: function getOptions() {
				var allOptions = this.getNonTechnicalOptions();
	
				if (this.state.currentInput && this.state.currentInput.trim().length > 0 && !this.state.grSearchComplete) {
					allOptions.push({ label: this.state.currentInput, value: { flagEmptySpace: true } });
				}
	
				if (this.state.currentInput && this.state.currentInput.trim().length > 0 && this.state.showAddManual && !this.props.preventManual) {
					allOptions.push({ label: this.state.currentInput, value: { flagToggleManual: true } });
				}
	
				// if (allOptions.length == 0) {
				// 	allOptions.push({ label: "...", value: { flagPlaceholder: true } });		
				// }
	
	
				return allOptions;
			}
		}, {
			key: "onManualSubmit",
			value: function onManualSubmit(e) {
				$wr.nope(e);
				if (this.validateForm()) {
					var book = {
						title: this.refs.manualTitle.val(),
						text_variety: $(this.refs.manualTextVariety).val()
					};
	
					if (this.state.isManualURL) {
						book["url"] = this.refs.manualURL.val();
					} else {
						book["author_full_name"] = this.refs.manualAuthor.val();
					}
	
					this.selectBook({ label: book.title, value: book });
					this.setState({ showManual: false, currentInput: "" });
				}
			}
		}, {
			key: "validateForm",
			value: function validateForm() {
				if (this.state.isManualURL) {
					return this.refs.manualTitle.validate() & this.refs.manualURL.validate();
				} else {
					return this.refs.manualTitle.validate() & this.refs.manualAuthor.validate();
				}
			}
		}, {
			key: "renderManualForm",
			value: function renderManualForm() {
				if (this.state.isManualURL) {
					var secondField = React.createElement(ValidatingInput, { type: "text", ref: "manualURL", key: "url",
						validators: ValidatingInput.Validators.URL,
						inputClassName: "form-control", className: "url",
						placeholder: "Website URL",
						errorMessage: "Copy/paste a website URL" });
				} else {
					var secondField = React.createElement(ValidatingInput, { type: "text", ref: "manualAuthor", key: "author",
						validators: ValidatingInput.Validators.PRESENT,
						inputClassName: "form-control", className: "author",
						placeholder: "Author",
						errorMessage: "Please enter an author." });
				}
	
				// <div className="bookTypeControl">
				// 	<label className="clickableElement">
				// 		<input type="radio" checked={ !this.state.isManualURL }
				// 			onChange={ this.setManualURL.bind(this, false) } /> Add a book
				// 	</label>
				// 	<span className="or">Or</span>
				// 	<label className="clickableElement">
				// 		<input type="radio" checked={ this.state.isManualURL }
				// 			onChange={ this.setManualURL.bind(this, true) } /> Add online reading
				// 	</label>
				// </div>
	
	
				return React.createElement(
					"form",
					{ onSubmit: this.onManualSubmit, className: "manualForm" },
					React.createElement(
						"div",
						null,
						React.createElement(
							"a",
							{ href: "#", onClick: this.toggleManual, className: "backArrow" },
							React.createElement(Glyphicon, { icon: "arrow-left" })
						),
						React.createElement(ValidatingInput, { type: "text", ref: "manualTitle",
							defaultValue: this.state.currentInput,
							validators: ValidatingInput.Validators.PRESENT,
							inputClassName: "form-control", className: "title",
							placeholder: "Title",
							errorMessage: "Please enter a title." }),
						secondField,
						React.createElement(
							"select",
							{ className: "form-control textVariety", ref: "manualTextVariety" },
							React.createElement(
								"option",
								{ value: TextTypes.Varieties.FICTION },
								TextTypes.Varieties.getName(TextTypes.Varieties.FICTION)
							),
							React.createElement(
								"option",
								{ value: TextTypes.Varieties.NON_FICTION },
								TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION)
							)
						),
						React.createElement(
							"button",
							{ className: "buttonSuccess" },
							"Add Book"
						)
					)
				);
			}
		}, {
			key: "renderSearch",
			value: function renderSearch() {
				var book = this.props.selectedBook;
				if (book) {
					var selectedOption = { value: book, label: book.title };
				}
	
				if (this.state.matildaError) {
					var noResultsText = "Our book finder is having trouble loading books at this time. Try again in a few minutes.";
					var reactSelectClass = "reactSelectError";
				} else {
					var noResultsText = "";
				}
	
				var searchOptions = this.state.searchOptions;
	
				return React.createElement(
					"div",
					{ className: "searchBar", ref: "searchBar" },
					React.createElement(_reactSelect2.default, { className: "reactSelectContainer " + reactSelectClass,
						onInputChange: this.searchBooks, ref: "searchInput",
						onBlurResetsInput: false,
						noResultsText: noResultsText,
						value: selectedOption, placeholder: "Book title...",
						optionRenderer: this.optionRenderer, onChange: this.selectBook,
						onFocus: this.onFocus, onBlur: this.onBlur,
						options: this.getOptions(), isLoading: this.state.loadingSearch })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var className = "smartBookSearch";
				if (this.props.dropUp) {
					className += " dropUp";
				}
	
				if (this.state.showManual) {
					var display = this.renderManualForm();
				} else {
					var display = this.renderSearch();
				}
	
				if (this.props.blockSearch) {
					var logsPaywall = React.createElement(PaywallModal, { ref: "paywallModal", featureType: PaywallModal.TEACHER_PICKS });
				}
	
				return React.createElement(
					"div",
					{ className: className },
					display,
					logsPaywall
				);
			}
		}, {
			key: "selectMenuNode",
			value: function selectMenuNode() {
				return $(this.refs.searchBar).find(".Select-menu");
			}
		}, {
			key: "onFocus",
			value: function onFocus() {
				var _this5 = this;
	
				setTimeout(function () {
					_this5.selectMenuNode().on("scroll", _this5.onSelectScroll);
				}, 30);
			}
		}, {
			key: "onBlur",
			value: function onBlur() {
				this.selectMenuNode().off("scroll", this.onSelectScroll);
			}
		}, {
			key: "onSelectScroll",
			value: function onSelectScroll() {
				var $menu = this.selectMenuNode();
				if ($menu.length > 0) {
					var innerHeight = $menu[0].scrollHeight;
					var outerHeight = $menu.height();
					var scrollTop = $menu.scrollTop();
					var cushion = 100;
	
					var calc = innerHeight - (scrollTop + outerHeight + cushion);
	
					if (calc <= 0) {
						this.scrollTriggerMatilda();
					}
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.populateData) {
					this.props.populateData();
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				this.onBlur();
			}
		}]);
	
		return SmartBookSearch;
	}(React.Component)) || _class);
	
	
	var FETCH_TIMEOUT = 30;
	var DELAY_SEARCH_TIME = 1500;
	
	SmartBookSearch.propTypes = PageStrictPropTypes({
		// User ID to show past books for this userID
		userID: PropTypes.number,
		// Books already ready (selected by userID)
		existingBooks: PropTypes.array,
	
		existingAssignedBooks: PropTypes.array,
		// Method to fetch populate inital data (i.e. existingBooks)
		populateData: PropTypes.func,
	
		selectedBook: PropTypes.object,
	
		// Makes the drop down point up, rather than down
		dropUp: PropTypes.bool,
	
		smartBookSearch: PropTypes.bool,
	
		onBookSelect: PropTypes.func.isRequired,
	
		preventManual: PropTypes.bool
	});
	
	module.exports = SmartBookSearch;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommentForm = __webpack_require__(405);
	var CommentLine = __webpack_require__(859);
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	var Spinner = __webpack_require__(9);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(3744);
	
	function propsToFilters(props) {
		return {
			subject_type: props.subjectType,
			subject_id: props.subjectID + "",
			subject_user_id: props.userID
		};
	}
	
	var CommentBox = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			comments: WritingSelectors.comments({
				state: state, filters: _.omit(propsToFilters(props), "subject_user_id")
			}),
			loading: WritingSelectors.isLoadingComments({
				state: state, key: props.subjectType + "|" + props.subjectID
			})
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(WritingActions.fetchComments({
					filters: propsToFilters(props),
					embeds: ["comment.user"],
					cache: true,
					loadingKey: props.subjectType + "|" + props.subjectID
				}));
			},
	
			createComment: function createComment(comment, userID) {
				return dispatch(WritingActions.createComment({
					comment: comment, embeds: ["comment.user"],
					query: { subject_user_id: userID }
				}));
			},
	
			updateComment: function updateComment(commentID, comment, userID) {
				return dispatch(WritingActions.updateComment({
					id: commentID, update: comment,
					query: { subject_user_id: userID }
				}));
			},
	
			deleteComment: function deleteComment(commentID, userID) {
				return dispatch(WritingActions.deleteComment({
					id: commentID,
					query: { subject_user_id: userID }
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(CommentBox, _React$Component);
	
		function CommentBox(props) {
			_classCallCheck(this, CommentBox);
	
			var _this = _possibleConstructorReturn(this, (CommentBox.__proto__ || Object.getPrototypeOf(CommentBox)).call(this));
	
			autobind(_this);
			_this.state = {
				collapsed: !!props.initialCollapsed,
				awaitingResponse: false
			};
			return _this;
		}
	
		_createClass(CommentBox, [{
			key: "isOwnItem",
			value: function isOwnItem() {
				return CurrentUser.hasID(this.props.userID);
			}
		}, {
			key: "deleteComment",
			value: function deleteComment(toDeleteComment) {
				Mycroft.newEvent({ category: "Comment", action: "remove" });
				this.props.deleteComment(toDeleteComment.id, this.props.userID);
			}
		}, {
			key: "updateComment",
			value: function updateComment(toUpdateComment) {
				Mycroft.newEvent({ category: "Comment", action: "update" });
				this.props.updateComment(toUpdateComment.id, toUpdateComment, this.props.userID);
			}
		}, {
			key: "createComment",
			value: function createComment(commentData) {
				var _this2 = this;
	
				if (!this.state.awaitingResponse && Features.isEnabled(Features.TEACHER_COMMENTS)) {
	
					Mycroft.newEvent({ category: "Comment", action: "create" });
	
					commentData = _.extend({}, commentData, {
						subject_id: this.props.subjectID,
						subject_type: this.props.subjectType
					});
	
					this.setState({ awaitingResponse: true });
	
					this.props.createComment(commentData, this.props.userID).then(function () {
						_this2.setState({ awaitingResponse: false });
						// this.scrollDownComments();
						_this2.refs.newCommentForm.reset();
					});
				}
			}
		}, {
			key: "closeEditComments",
			value: function closeEditComments() {
				for (var i = 0; i < this.props.comments.length; i += 1) {
					var ref = "comment" + i;
					if (this.refs[ref]) {
						this.refs[ref].closeEdit();
					}
				}
			}
		}, {
			key: "getOrderedComments",
			value: function getOrderedComments() {
				var comments = _.sortBy(this.props.comments, function (comment) {
					return new Date(comment.created_at).getTime();
				}.bind(this));
	
				return _.select(comments, function (comment) {
					if (!comment.secretive) {
						return true;
					} else if (CurrentUser.isAdmin() || this.isOwnItem()) {
						return true;
					} else if (CurrentUser.isSponsor()) {
						return comment.user.is_sponsor;
					} else {
						return false;
					}
					return !comment.secretive || CurrentUser.isAdmin() || this.isOwnItem();
				}.bind(this));
			}
		}, {
			key: "toggleCollapsed",
			value: function toggleCollapsed(e) {
				$wr.nope(e);
				if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
					this.setState({ collapsed: !this.state.collapsed });
				} else if (this.props.showPaywallModal) {
					this.props.showPaywallModal();
				}
			}
		}, {
			key: "checkCommentingAbility",
			value: function checkCommentingAbility(e) {
				if (!Features.isEnabled(Features.TEACHER_COMMENTS)) {
					if (this.props.showPaywallModal) {
						this.props.showPaywallModal();
					}
					$wr.nope(e);
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.collapsed) {
					return React.createElement(
						"div",
						{ className: "commentBox", ref: "commentBox" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.toggleCollapsed },
							"Comment"
						)
					);
				}
	
				if (this.props.loading) {
					var content = React.createElement(Spinner, { placeholder: true, scale: 0.8 });
				} else if (this.props.comments) {
					var content = this.getOrderedComments().map(function (comment, index) {
						return React.createElement(CommentLine, { comment: comment, key: comment.id || comment.body,
							ref: "comment" + index, closeEditComments: this.closeEditComments,
							updateComment: this.updateComment, deleteComment: this.deleteComment });
					}.bind(this));
				}
	
				if (!this.props.blockNewComments && (!this.props.blockFirstComment || this.props.comments && this.props.comments.length > 0)) {
					var commentForm = React.createElement(
						"div",
						{ onClick: this.checkCommentingAbility },
						React.createElement(CommentForm, { ref: "newCommentForm", onSubmit: this.createComment,
							noSuggestedComments: this.props.noSuggestedComments })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "commentBox expanded", ref: "commentBox" },
					content,
					commentForm
				);
			}
		}, {
			key: "fetchComments",
			value: function fetchComments(callback) {
	
				// var params = {
				// 	embed: "comment.user",
				// 	subject_type: this.props.subjectType,
				// 	subject_id: this.props.subjectID,
	
				// 	// Only used if subject type has no clear user ID
				// 	subject_user_id: this.props.userID
				// };
				// CurrentUser.api().getComments(params, $wr.apiHandler(function(response) {
				// 	this.setState({ comments: response.comments }, this.closeEditComments);
				// 	if (callback) {
				// 		callback();
				// 	};
	
				// 	setTimeout(() => {
				// 		$(window).trigger("resize");
				// 	}, 20);
				// }.bind(this)))
			}
		}, {
			key: "scrollDownComments",
			value: function scrollDownComments() {
				setTimeout(function () {
					$(this.refs.commentBox).trigger("scroll-to-bottom");
				}.bind(this), 1000);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.comments == null && !this.state.collapsed) {
					this.fetchComments();
				}
			}
		}]);
	
		return CommentBox;
	}(React.Component)) || _class) || _class);
	;
	
	CommentBox.WrappedComponent.propTypes = StrictPropTypes({
		// ID and type of the subject of the comments
		subjectID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	
		subjectType: PropTypes.string.isRequired,
	
		// ID of the owner of the subject of the comments (if any). NOT the commenter's user ID
		userID: PropTypes.number,
	
		// Whether or not to start the container collapsed
		initialCollapsed: PropTypes.bool,
	
		// If this is true, don't show the form unless there are already comments here
		blockFirstComment: PropTypes.bool,
	
		// If this is true, don't show the form 
		blockNewComments: PropTypes.bool,
	
		// Function to call to display paywall modal
		showPaywallModal: PropTypes.func,
	
		noSuggestedComments: PropTypes.bool,
	
		// Data from @connect
		comments: PropTypes.array,
		loading: PropTypes.bool,
	
		// Handlers from @connect
		populateData: PropTypes.func,
		createComment: PropTypes.func,
		updateComment: PropTypes.func,
		deleteComment: PropTypes.func
	});
	
	module.exports = CommentBox;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3790);
	
	var BraveCheckbox = function (_React$Component) {
		_inherits(BraveCheckbox, _React$Component);
	
		function BraveCheckbox(props) {
			_classCallCheck(this, BraveCheckbox);
	
			var _this = _possibleConstructorReturn(this, (BraveCheckbox.__proto__ || Object.getPrototypeOf(BraveCheckbox)).call(this));
	
			autobind(_this);
			_this.state = {
				checked: props.initialValue
			};
			return _this;
		}
	
		_createClass(BraveCheckbox, [{
			key: "onClick",
			value: function onClick(e) {
				if (this.props.disabled) {
					return;
				}
				if (this.props.value === undefined) {
					var checked = !this.state.checked;
					this.setState({ checked: checked });
	
					if (this.props.onChange) {
						this.props.onChange(checked, e);
					}
				} else {
					if (this.props.onClick) {
						this.props.onClick(e);
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var checked = this.props.value === undefined ? this.state.checked : this.props.value;
				if (checked) {
					var checkboxImage = React.createElement("img", { src: __webpack_require__(509),
						onClick: this.toggleStudent, className: "checkedImg" });
				} else {
					var checkboxImage = React.createElement("img", { src: __webpack_require__(521),
						onClick: this.toggleStudent, className: "uncheckedImg" });
				}
	
				var className = "braveCheckbox";
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				if (this.props.text) {
					className += " withLabel";
					var textLabel = React.createElement(
						"span",
						{ className: "textLabel" },
						this.props.text
					);
				}
	
				if (this.props.disabled) {
					className += " disabled";
				}
	
				return React.createElement(
					"div",
					{ className: className, onClick: this.onClick },
					checkboxImage,
					textLabel
				);
			}
		}]);
	
		return BraveCheckbox;
	}(React.Component);
	
	;
	
	BraveCheckbox.propTypes = StrictPropTypes({
		onClick: PropTypes.func,
		onChange: PropTypes.func,
		value: PropTypes.bool,
		disabled: PropTypes.bool,
		text: PropTypes.string
	});
	
	module.exports = BraveCheckbox;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var ImageIcon = __webpack_require__(102);
	
	__webpack_require__(3794);
	
	var CoinDisplay = function CoinDisplay(props) {
		var height = props.height || 30;
		var fontSize = height * 0.7;
		var top = height * 0.07;
	
		var style = props.style || {};
		style["fontSize"] = fontSize;
	
		var className = props.className || "";
		className += " coinDisplay";
		return React.createElement(
			"span",
			{ className: className, style: style },
			React.createElement(ImageIcon, { icon: "coin", style: { width: height, height: height } }),
			React.createElement(
				"span",
				{ className: "coinCount", style: { top: top } },
				props.coins
			)
		);
	};
	
	CoinDisplay.propTypes = StrictPropTypes({
		// How many coins there are
		coins: PropTypes.number.isRequired,
	
		// Height in pixels
		height: PropTypes.number,
	
		className: PropTypes.string,
	
		// CSS style object for the text
		style: PropTypes.object
	});
	
	//    {{{}}}
	//   {{{  }}}
	//  {{{ {} }}}
	// {{{ {{}} }}}
	//  {{{ {} }}}
	//   {{{  }}}
	//    {{{}}}
	
	module.exports = CoinDisplay;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumbersOnlyInput = function (_React$Component) {
		_inherits(NumbersOnlyInput, _React$Component);
	
		function NumbersOnlyInput(props) {
			_classCallCheck(this, NumbersOnlyInput);
	
			var _this = _possibleConstructorReturn(this, (NumbersOnlyInput.__proto__ || Object.getPrototypeOf(NumbersOnlyInput)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NumbersOnlyInput, [{
			key: "myOnKeyDown",
			value: function myOnKeyDown(e) {
				var isDigit = e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105;
				var isAllowedDecimal = this.props.allowDecimal && e.keyCode == 190 && this.text().indexOf(".") == -1;
				var isControlCharacter = CONTROL_CHARS.indexOf(e.keyCode) != -1;
				var hasModifier = e.ctrlKey || e.metaKey;
	
				if (!(isDigit || isAllowedDecimal || isControlCharacter || hasModifier)) {
					$wr.nope(e);
				}
	
				if (this.props.onKeyDown) {
					this.props.onKeyDown(e);
				}
			}
		}, {
			key: "myOnChange",
			value: function myOnChange(e) {
				// Don't stress the additional decimal
				var newText = this.text().replace(/[^\d.]/g, "");
	
				if (newText != this.text()) {
					this.setText(newText);
				} else if (this.props.onChange) {
					this.props.onChange(e);
				}
			}
		}, {
			key: "text",
			value: function text() {
				return this.refs.textfield.value.trim();
			}
		}, {
			key: "isEmpty",
			value: function isEmpty() {
				return this.text().length == 0;
			}
		}, {
			key: "number",
			value: function number() {
				if (this.props.allowDecimal) {
					return parseFloat(this.text());
				} else {
					return parseInt(this.text());
				}
			}
		}, {
			key: "setText",
			value: function setText(val) {
				this.refs.textfield.value = val;
			}
		}, {
			key: "render",
			value: function render(e) {
				var inputProps = _.omit(this.props, "allowDecimal", "onChange", "onKeyDown");
				var type = this.props.type ? this.props.type : 'number';
	
				return React.createElement("input", _extends({}, inputProps, { ref: "textfield", type: type,
					onKeyDown: this.myOnKeyDown, onChange: this.myOnChange }));
			}
		}]);
	
		return NumbersOnlyInput;
	}(React.Component);
	
	;
	
	var CONTROL_CHARS = [8, 9, 13, 17, 37, 38, 39, 40, 46];
	
	NumbersOnlyInput.propTypes = StrictPropTypes({
		autoFocus: PropTypes.bool,
		// Allow floats
		allowDecimal: PropTypes.bool,
	
		// Functions to call if the value changes or there is activity
		onChange: PropTypes.func,
		onKeyDown: PropTypes.func,
	
		// Props to pass on to input
		placeholder: PropTypes.string,
		className: PropTypes.string,
		defaultValue: PropTypes.number,
		value: PropTypes.number,
		max: PropTypes.number,
		min: PropTypes.number,
		step: PropTypes.number,
		type: PropTypes.string
	});
	
	module.exports = NumbersOnlyInput;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DecemberSaleImage = __webpack_require__(511);
	var OctoberSaleImage = __webpack_require__(296);
	var JulySaleImage = __webpack_require__(513);
	var SeptemberSaleImage = __webpack_require__(519);
	var ShopSales = {
		SALES: [{
			"title": "Owl-idays Sale",
			"description": "A few wintery items are now available for you to buy. Will you choose a tree costume or a pet snowman?",
			"start_month": 11,
			"start_day": 1,
			"end_month": 0,
			"end_day": 14,
			"patches": [{
				"name": "beard-santa",
				"title": "Santa Owl Beard",
				"description": "Ho, ho, ho... or is it Hoot, Hoot, Hoot?",
				"source": "special",
				"patch_type": "face",
				"origin_patch_type": "face",
				"patch_directory": "face",
				"z_index": 1700,
				"price": 180,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "antlers",
				"title": "Rudolph's Antlers",
				"description": "Wear these antlers and then all you need is a bright red nose to lead Santa's sleigh through the night.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1900,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 8,
				"extra_bottom": 0
			}, {
				"name": "holly",
				"title": "Owly's Holly",
				"description": "Each December, Owls from the all over the world fly with holly branches and sing songs of joy and hot cocoa.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 20,
				"extra_bottom": 0
			}, {
				"name": "santa-hat",
				"title": "Holly Jolly Hat",
				"description": "The owner of this hat is given a very special power: the ability to know the perfect gift to give to their family and friends. Become the best gift giver with this jolly hat.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 20,
				"extra_bottom": 0
			}, {
				"name": "tree-top",
				"title": "Tree Star",
				"description": "This star will make it easy for all your friends to find you at night. In fact it will bring them to you. Be the host of the greatest holiday parties with this star!",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 20,
				"extra_bottom": 0
			}, {
				"name": "tree-bottom",
				"title": "Tree Pants",
				"description": "Do you love pants but wish they smelled like delicious pine trees? If so, today is your lucky day. Tree pants are super stylish this time of year.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "hannukaih",
				"title": "Hannukiah",
				"description": "Be the light in the world! Share your love, wisdom, and good energy with this Hannukiah!",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 200,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "dreidel",
				"title": "Dreidel",
				"description": "Owls love spinning the dreidel! Try your luck and hope for a gimel.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 200,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "gift",
				"title": "Best-Ever Holiday Present",
				"description": "Do you like surprises? Well this present contains a surprise. You're going to have to use your imagination though, because we're not going to tell you what's inside.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 200,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "mini-snowman",
				"title": "Tiny Snowman",
				"description": "Snowmen and owls have been friends since the beginning of time. Why? Maybe because they both are very wise, or maybe because they both can never get enough popcorn.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 400,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}]
		}, {
			"title": "Summer Sale",
			"description": "A few summer items are now available for you to buy. Will you choose a beach ball or some patriotic sunglasses?",
			"start_month": 7,
			"start_day": 1,
			"end_month": 7,
			"end_day": 14,
			"patches": [{
				"name": "glasses-star",
				"title": "Liberty Glasses",
				"description": "These patriotic star glasses are great for days full of fireworks, trips to the pool, and tasty BBQ. Wear these when you're feeling liberated!",
				"source": "special",
				"patch_type": "face",
				"origin_patch_type": "face",
				"patch_directory": "face",
				"z_index": 3100,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "hat-anchor",
				"title": "Sailor Hat",
				"description": "Sailboats are incredibly beautiful boats, and are also fun to steer! Grab your anchor hat and sail away. Don't forget your real anchor, so you can float at sea and watch the sunset.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "watermelon",
				"title": "Melonhead",
				"description": "Watermelons are a tasty summer treat, but owls also love to wear them on their heads! No one is quite sure why...",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "kite",
				"title": "Kite",
				"description": "Whoever said windy days can't be fun?! Take this kite to the beach and let it fly, spin, and twirl!",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "shirt-crab",
				"title": "Cool Crab Shirt",
				"description": "Wear this shirt when you're feeling cool, because this crab is as cool as it gets. He has traveled the world to visit every beach on Earth. Are you jealous?",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "shirt-surfboards",
				"title": "Surf Shirt",
				"description": "This shirt is perfect for that epic beach party. Show your friends that you know what's up when it comes to beachy attire. Maybe even pair it with a real surfboard for extra points.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "ball-beach",
				"title": "Beach Ball",
				"description": "This inflatable beach ball is fun at the beach, pool, picnic, playground and more! Keep this ball around and you'll always have a great time.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "ball-volleyball",
				"title": "My Friend, Wilson",
				"description": "This ball makes for a great game of volleyball, and it doubles as a friend when you're in need! His name is Wilson, and he's a great listener.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "pineapple",
				"title": "The Apple of the Beach",
				"description": "You won't need a ladder to harvest this fruit. Nope. Pineapples are not apples that grow on pine trees. Actually, they grow on a plant close to the ground, and each pineapple plant bears exactly one pineapple.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "beach",
				"title": "Feet in the Sand",
				"description": "If your heart belongs at the beach, follow your dreams and buy this so you can always have your feet in the sand. Build an epic sand castle while you're at it!",
				"source": "special",
				"patch_type": "feet",
				"origin_patch_type": "feet",
				"patch_directory": "feet",
				"z_index": 800,
				"price": 200,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}]
		}, {
			"title": "Back-to-School Sale",
			"description": "A few back-to-school items are now available for you to buy. Will you choose a new tablet or a delicious red apple?",
			"start_month": 8,
			"start_day": 7,
			"end_month": 8,
			"end_day": 29,
			"start_time": "2020-08-07T23:59:59+00:00",
			"end_time": "2020-09-17T23:59:59+00:00",
			"patches": [{
				"name": "apple",
				"title": "Teacher's Apple",
				"description": "Teachers are owlsome people. Show your love for your teacher and give them a shiny apple.",
				"source": "special",
				"patch_type": "beak",
				"origin_patch_type": "beak",
				"patch_directory": "beak",
				"z_index": 3000,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "backpack",
				"title": "Hipster Backpack",
				"description": "Not only is this backpack the most stylish one at school that no one else has, but it can also fit anything. It can hold three elephants and a boat!",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 4000,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "book-shelf",
				"title": "Discovery Shelf",
				"description": "This magical bookshelf contains any book that's ever been written, including the Enchanted Broccoli Forest.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 800,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "calculator",
				"title": "Newton's Calculator",
				"description": "Once you have this calculator, you will become the master of numbers, just like the great Isaac Newton. You will be able to solve any equation!",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "crayons",
				"title": "DaVinci's Crayons",
				"description": "The great Leonardo DaVinci was a crayon expert before was a great painter. Follow in his footsteps with these famous crayons.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "scissors",
				"title": "Creativity Scissors",
				"description": "With these scissors, your creativity powers will soar. You can do any art project and make any outfit!",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "spiral-notebook",
				"title": "Shakespeare's Notebook",
				"description": "Shakespeare wrote some of the greatest plays of all time in this notebook, including Rome-Owl and Juliet. With this notebook, you will have the power to write stories that will be read far in the future.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "tablet",
				"title": "Tablet of Wonder",
				"description": "This is a special tablet. Not only can you watch videos and play games, but you can read any text and create apps on it for your friends.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}]
		}, {
			"title": "Owl-O-Ween Sale",
			"description": "Mummies and pumpkins and bats, oh my! Spook your friends with these scary Halloween items.",
			"start_month": 9,
			"start_day": 18,
			"end_month": 10,
			"end_day": 2,
			"patches": [{
				"name": "bat",
				"title": "Spooky Bat",
				"description": "Keep a close watch on this bat. You never know if he is your friend or your enemy...",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "candy",
				"title": "Owl-O-Ween Candy",
				"description": "The very best part of Owl-O-Ween: creepy candy!",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "cauldron",
				"title": "Magical Cauldron",
				"description": "This creepy cauldron is perfect for brewing up your own potions.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 2500,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "dracula-cape",
				"title": "Dracula's Cape",
				"description": "This is the cape of the ledendary Count himself. Be careful... he might come back for it.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "hat-witch",
				"title": "Basic Witch Hat",
				"description": "Did you forget it's Halloween? This hat is perfect for owls who need an easy costume.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 40,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 15,
				"extra_bottom": 0
			}, {
				"name": "outfit-witch",
				"title": "Wicked Witch of the West Dress",
				"description": "Bring back the Wicked Witch of the West with this dress... just stay away from water so you don't melt.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 60,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "pumpkin",
				"title": "Jack-Owl-Lantern",
				"description": "Show off your pumpkin-carving skills with this perfectly carved Jack-Owl-Lantern. Candle not included.",
				"source": "special",
				"patch_type": "hand",
				"origin_patch_type": "hand",
				"patch_directory": "hand",
				"z_index": 3000,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "wizard-hat",
				"title": "Hocus Pocus Hat",
				"description": "Even the very best wizards and witches practice their spells daily. Wearing this hat helps you remember your magic.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 20,
				"extra_bottom": 0
			}, {
				"name": "spider",
				"title": "Spider Pet",
				"description": " Oh no! A spider landed on your head. Don't be scared, it's a friendly spider. Why not give it a name?",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 80,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "ghost",
				"title": "Ghost Costume",
				"description": "Haunt your Class Tree with this scary ghost costume. Then tell your friends not to worry, it's just an old white sheet afterall.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1700,
				"price": 180,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "night-sky",
				"title": "Night Sky",
				"description": "Owls love the night. Make yourself at home under the moon and stars. Fly high and call out to your friends in the dark with a hoot.",
				"source": "special",
				"patch_type": "feet",
				"origin_patch_type": "feet",
				"patch_directory": "feet",
				"z_index": 300,
				"price": 180,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 32,
				"extra_bottom": 0
			},
			// {
			//      "name": "mummy-hand",
			//      "title": "Mummy Costume Wing",
			//      "description":  "Two-for-one! Buy this mummy wing and use it for both of your wings.",
			//      "source": "special",
			//      "patch_type": "hand",
			//      "origin_patch_type": "hand",
			//      "patch_directory": "hand",
			//      "z_index": 3000,
			//      "price": 60,
			//      "tier": 0,
			//      "offsets": null,
			//      "animation": null,
			//      "extra_right": 0,
			//      "extra_left": 0,
			//      "extra_top": 0,
			//      "extra_bottom": 0
			// },
			// {
			//      "name": "mummy-head",
			//      "title": "Mummy Costume Hat",
			//      "description": "The only thing spookier than an owl on Halloween is an owl dressed up as a mummy!",
			//      "source": "special",
			//      "patch_type": "head",
			//      "origin_patch_type": "head",
			//      "patch_directory": "head",
			//      "z_index": 1400,
			//      "price": 60,
			//      "tier": 0,
			//      "offsets": null,
			//      "animation": null,
			//      "extra_right": 0,
			//      "extra_left": 0,
			//      "extra_top": 0,
			//      "extra_bottom": 0
			// } ,
			// {
			//      "name": "mummy-body",
			//      "title": "Mummy Costume",
			//      "description":  "Make sure to buy the matching hat and wings to complete this mummy costume for your owl!",
			//      "source": "special",
			//      "patch_type": "body",
			//      "origin_patch_type": "body",
			//      "patch_directory": "body",
			//      "z_index": 1500,
			//      "price": 40,
			//      "tier": 0,
			//      "offsets": null,
			//      "animation": null,
			//      "extra_right": 0,
			//      "extra_left": 0,
			//      "extra_top": 0,
			//      "extra_bottom": 0
			// } 	  
			{
				"name": "zombie-bolts",
				"title": "Zombie Bolts",
				"description": "These bolts help to hold your zombie head together so you can keep all those wise ideas inside.",
				"source": "special",
				"patch_type": "head",
				"origin_patch_type": "head",
				"patch_directory": "head",
				"z_index": 1400,
				"price": 140,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "zombie-glasses",
				"title": "Zombie Glasses",
				"description": "Put on these glasses to scare your friends. They'll think you've come back to life as a zombie!",
				"source": "special",
				"patch_type": "face",
				"origin_patch_type": "face",
				"patch_directory": "face",
				"z_index": 3100,
				"price": 100,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}, {
				"name": "zombie-stitches",
				"title": "Zombie Stitches",
				"description": "Some zombies are put back together by a mad scientist, which leads to these scary stitches.",
				"source": "special",
				"patch_type": "body",
				"origin_patch_type": "body",
				"patch_directory": "body",
				"z_index": 1500,
				"price": 180,
				"tier": 0,
				"offsets": null,
				"animation": null,
				"extra_right": 0,
				"extra_left": 0,
				"extra_top": 0,
				"extra_bottom": 0
			}]
		}],
	
		getCurrentSale: function getCurrentSale() {
			var now = new Date();
			var currentSales = _.find(ShopSales.SALES, function (saleData) {
				var dates = ShopSales.getSaleDates(saleData);
				var endDate = dates["end"];
				var startDate = dates["start"];
				return now < endDate && now > startDate;
			});
			return currentSales;
		},
		hasCurrentSale: function hasCurrentSale() {
			return this.getCurrentSale() != null;
		},
		isOnSale: function isOnSale(patchType, patchName) {
			var currentSale = this.getCurrentSale();
			if (currentSale) {
				return !!_.find(currentSale.patches, function (patchData) {
					return patchData.name == patchName && patchData.patch_type == patchType;
				});
			} else {
				return false;
			}
		},
		getSaleDates: function getSaleDates(sale) {
			if (sale) {
				var now = new Date();
				if (sale.title == "Owl-idays Sale") {
					var month = now.getMonth();
					var day = now.getDay();
					// if january, need to check if we are still in last years holiday sale
					if (month == 0 && sale.end_day >= day) {
						return {
							"start": new Date(now.getFullYear() - 1, sale.start_month, sale.start_day),
							"end": new Date(now.getFullYear(), sale.end_month, sale.end_day)
						};
					} else {
						return {
							"start": new Date(now.getFullYear(), sale.start_month, sale.start_day),
							"end": new Date(now.getFullYear() + 1, sale.end_month, sale.end_day)
						};
					}
				} else {
					return {
						"start": new Date(now.getFullYear(), sale.start_month, sale.start_day),
						"end": new Date(now.getFullYear(), sale.end_month, sale.end_day)
					};
				}
			}
		},
		getSaleBanner: function getSaleBanner() {
			var currentHoliday = this.getCurrentSale();
			if (!currentHoliday) {
				return;
			}
			var name = currentHoliday.title;
	
			if (name == "Owl-idays Sale") {
				return DecemberSaleImage;
			} else if (name == "Summer Sale") {
				return JulySaleImage;
			} else if (name == "Back-to-School Sale") {
				return SeptemberSaleImage;
			} else if (name == "Owl-O-Ween Sale") {
				return OctoberSaleImage;
			}
		}
	};
	
	module.exports = ShopSales;

/***/ }),
/* 124 */
[3926, 1029, 1030],
/* 125 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(77);
	var call = __webpack_require__(459);
	var isArrayIter = __webpack_require__(271);
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(39);
	var getIterFn = __webpack_require__(287);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(22);
	var dPs = __webpack_require__(465);
	var enumBugKeys = __webpack_require__(267);
	var IE_PROTO = __webpack_require__(280)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(266)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(269).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(467);
	var hiddenKeys = __webpack_require__(267).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(467);
	var enumBugKeys = __webpack_require__(267);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(61);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(28);
	var dP = __webpack_require__(47);
	var DESCRIPTORS = __webpack_require__(42);
	var SPECIES = __webpack_require__(37)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(79);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(363);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(364);
	exports.Session = session_1.Session;
	var hub_1 = __webpack_require__(712);
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var StudentListDropdownDisplay = function (_React$Component) {
		_inherits(StudentListDropdownDisplay, _React$Component);
	
		function StudentListDropdownDisplay(props) {
			_classCallCheck(this, StudentListDropdownDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentListDropdownDisplay.__proto__ || Object.getPrototypeOf(StudentListDropdownDisplay)).call(this));
	
			autobind(_this);
	
			var mixedDisplay = false;
			if (props.studentLists.length && !props.allClassesOption) {
				var id = props.studentLists[0].id;
	
				if (props.displayType == "mixed") {
					for (var i = 0; i < props.studentLists.length; i++) {
						if (props.studentLists[i].label != null) {
							mixedDisplay = true;
							break;
						}
					}
				}
			}
	
			if (props.currentStudentList) {
				id = props.currentStudentList.id;
			}
	
			_this.state = {
				currentID: id, mixedDisplay: mixedDisplay
			};
			return _this;
		}
	
		_createClass(StudentListDropdownDisplay, [{
			key: "buildStudentListSelect",
			value: function buildStudentListSelect(studentList) {
				return function (e) {
					$wr.nope(e);
					this.setState({ currentID: studentList.id }, function () {
						if (this.props.onChange) {
							this.props.onChange(studentList);
						}
					});
				}.bind(this);
			}
		}, {
			key: "selectAllClasses",
			value: function selectAllClasses() {
				this.setState({ currentID: null }, function () {
					if (this.props.onChange) {
						this.props.onChange(null);
					}
				});
			}
		}, {
			key: "getStudentListOptions",
			value: function getStudentListOptions(studentList) {
				var options = studentList.map(function (sl) {
					var bold = this.state.mixedDisplay && !sl.label;
					return React.createElement(ButtonDropdownOption, { onClick: this.buildStudentListSelect(sl),
						text: sl.name, icon: sl.label, key: sl.id, bold: bold });
				}.bind(this));
	
				if (this.props.allClassesOption) {
					options.unshift(React.createElement(ButtonDropdownOption, { onClick: this.selectAllClasses,
						text: "All Classes", key: "all-classes" }));
				}
	
				return options;
			}
		}, {
			key: "getSelected",
			value: function getSelected(studentLists) {
				var ids = studentLists.map(function (l) {
					return l.id;
				});
				var index = ids.indexOf(this.state.currentID);
				if (index < 0) {
					if (this.props.allClassesOption) {
						return null;
					}
					index = 0;
				}
				return studentLists[index];
			}
		}, {
			key: "getMixedStudentList",
			value: function getMixedStudentList() {
				var mixedStudentList = [];
				for (var i = 0; i < this.props.studentLists.length; i++) {
					mixedStudentList.push(this.props.studentLists[i]);
					for (var j = 0; j < this.props.studentLists[i].sub_groups.length; j++) {
						mixedStudentList.push(this.props.studentLists[i].sub_groups[j]);
					}
				}
				return mixedStudentList;
			}
		}, {
			key: "render",
			value: function render() {
				switch (this.props.displayType) {
					case "group":
						var studentList = this.props.studentLists.sub_groups;
						break;
					case "mixed":
						var studentList = this.props.studentLists;
						break;
					default:
						var studentList = this.props.studentLists.filter(function (sl) {
							return sl.label == null;
						});
						break;
				}
				var dropdownBody = this.getStudentListOptions(studentList);
				var currentStudentList = this.getSelected(studentList);
	
				if (currentStudentList) {
					var text = currentStudentList.name;
					var label = currentStudentList.label;
				} else if (this.props.allClassesOption) {
					var text = "All Classes";
				}
	
				return React.createElement(
					ButtonDropdown,
					{ text: text, icon: label,
						dropdownDisplay: this.props.dropdownDisplay,
						className: "studentListSelector subGroupLabel" },
					dropdownBody
				);
			}
		}]);
	
		return StudentListDropdownDisplay;
	}(React.Component);
	
	;
	
	StudentListDropdownDisplay.propTypes = StrictPropTypes({
	
		allClassesOption: PropTypes.bool,
	
		// List of student_list objects to form the options
		studentLists: PropTypes.array.isRequired,
	
		// Changes the way the menu is structured
		displayType: PropTypes.string,
	
		// Toggles formatting changes
		dropdownDisplay: PropTypes.string,
	
		// Function to call after selected option changes
		onChange: PropTypes.func,
	
		currentStudentList: PropTypes.object
	});
	
	module.exports = StudentListDropdownDisplay;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentsSelectedDisplay = function (_React$Component) {
		_inherits(StudentsSelectedDisplay, _React$Component);
	
		function StudentsSelectedDisplay(props) {
			_classCallCheck(this, StudentsSelectedDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentsSelectedDisplay.__proto__ || Object.getPrototypeOf(StudentsSelectedDisplay)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentsSelectedDisplay, [{
			key: "render",
			value: function render() {
				var students = $wr.sortByName(this.props.studentsSelected, "lastName");
				if (this.props.studentsSelected.length > 1) {
					var comma = ", ";
				}
				if (this.props.studentsSelected.length == this.props.totalStudents) {
					var studentsSelected = "All Students!";
				} else {
					var studentsSelected = students.map(function (student, i) {
						return React.createElement(
							"span",
							{ className: "comma", ref: "comma", key: student.id },
							student.display_name,
							i + 1 == this.props.studentsSelected.length ? "" : comma
						);
					}.bind(this));
				}
				if (!this.props.hideTo) {
					var toSection = React.createElement(
						"div",
						{ className: "toSection" },
						"To:"
					);
				}
				return React.createElement(
					"div",
					{ className: "studentsSelectedSection" },
					React.createElement(
						"div",
						{ className: "studentsSelected" },
						toSection,
						React.createElement(
							"div",
							{ className: "listOfStudents" },
							studentsSelected,
							" ",
							React.createElement("span", { className: "spacer1" })
						)
					)
				);
			}
		}]);
	
		return StudentsSelectedDisplay;
	}(React.Component);
	
	;
	
	StudentsSelectedDisplay.propTypes = StrictPropTypes({
		studentsSelected: PropTypes.array,
		totalStudents: PropTypes.number,
		hideTo: PropTypes.bool
	});
	
	module.exports = StudentsSelectedDisplay;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3718);
	
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	var ReadingLevelIcon = __webpack_require__(165);
	
	var BookCover = function BookCover(props) {
		var coverWidth = props.coverWidth || 98;
	
		var imgStyle = { width: coverWidth, height: "auto" };
		var missingBookCover = props.book.cover_url == null || props.book.cover_url.includes("nophoto");
	
		if (props.showTitle || props.showAuthor) {
			if (props.showTitle) {
				var title = React.createElement(
					"span",
					{ className: "title" },
					props.book.title
				);
			}
			if (props.showAuthor) {
				var author = React.createElement(
					"span",
					{ className: "author" },
					props.book.author || props.book.author_full_name
				);
			}
			if (props.showReadingLevelIcon && props.book.lexile_score) {
				var readingLevel = React.createElement(ReadingLevelIcon, { studentReadingLevel: CurrentUser.get().current_reading_level,
					textReadingLevel: props.book.lexile_score, tooltipCopyType: ReadingLevelIcon.STUDENT_VIEW });
			}
			var bookDetails = React.createElement(
				"span",
				{ className: "bookDetails" },
				title,
				author,
				" ",
				readingLevel
			);
		} else if (missingBookCover) {
			var bookDetails = React.createElement(
				"span",
				{ className: "emptyCoverTitle" },
				props.book.title
			);
		}
	
		if (missingBookCover) {
			var bookColors = ["red", "blue", "gold", "green", "orange", "purple"];
			var bookNumber = $wr.psuedoRandom("seed", bookColors.length);
			var coverUrl = __webpack_require__(355)("./book-" + bookNumber + ".png");
		} else {
			var coverUrl = props.book.cover_url;
		}
	
		if (props.displayQuizTaken && !props.quizTaken && !props.teachersPick) {
			imgStyle["opacity"] = 0.55;
			if (props.quizDraft) {
				var quizTakenIcon = React.createElement(
					"span",
					{ className: "b-tooltip", "data-tip": "Quiz in progress." },
					React.createElement("img", { src: __webpack_require__(517), className: "quizTakenIcon" }),
					React.createElement(ReactTooltip, { effect: "solid", offset: { top: 15, right: coverWidth } })
				);
			}
		} else if (props.displayQuizTaken && props.quizTaken && !props.teachersPick) {
			var quizTakenIcon = React.createElement(
				"span",
				{ className: "b-tooltip", "data-tip": "Quiz taken. Nice!" },
				React.createElement("img", { src: __webpack_require__(516), className: "quizTakenIcon" }),
				React.createElement(ReactTooltip, { effect: "solid", offset: { top: 15, right: coverWidth } })
			);
		} else if (props.displayQuizTaken && props.quizTaken && props.teachersPick) {
			var quizTakenIcon = React.createElement(
				"span",
				{ className: "b-tooltip", "data-tip": "Quiz taken. Nice!" },
				React.createElement("img", { src: __webpack_require__(294), className: "quizTakenIconSquare" }),
				React.createElement(ReactTooltip, { effect: "solid", offset: { top: 15, right: coverWidth } })
			);
		} else if (props.displayQuizTaken && !props.quizTaken && props.teachersPick) {
			imgStyle["opacity"] = 0.55;
			var quizTakenIcon = React.createElement(
				"span",
				{ className: "b-tooltip", "data-tip": "Quiz in progress." },
				React.createElement("img", { src: __webpack_require__(294), className: "quizTakenIconSquare" }),
				React.createElement(ReactTooltip, { effect: "solid", offset: { top: 15, right: coverWidth } })
			);
		}
	
		return React.createElement(
			"span",
			{ className: "bookCover" },
			quizTakenIcon,
			React.createElement("img", { src: coverUrl, style: imgStyle }),
			bookDetails
		);
	};
	
	BookCover.propTypes = StrictPropTypes({
		book: PropTypes.object.isRequired,
		coverWidth: PropTypes.number,
	
		// If true, the title will show
		showTitle: PropTypes.bool,
		// If true, the title will show
		showAuthor: PropTypes.bool,
		// If true, the missing cover title will never show
		noMissingCoverTitle: PropTypes.bool,
	
		teachersPick: PropTypes.bool,
		displayQuizTaken: PropTypes.bool,
		quizTaken: PropTypes.bool,
		quizDraft: PropTypes.bool,
		showReadingLevelIcon: PropTypes.bool
	});
	
	module.exports = BookCover;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	var Modal = __webpack_require__(18);
	var WhooosReadingServices = __webpack_require__(25);
	var CurrentUser = __webpack_require__(3);
	var TextTypes = __webpack_require__(38);
	
	var ReadingActions = __webpack_require__(27);
	
	__webpack_require__(3723);
	
	var BookTextVariety = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			updateBook: function updateBook(textVariety) {
				var user = CurrentUser.get();
				var overrideData = {
					instance_id: props.book.text_id,
					instance_type: "book",
					attribute_name: "text_variety",
					value: textVariety,
					user_id: user.id,
					user_role: user.role
				};
				var bookUpdate = { text_variety: textVariety };
				dispatch(ReadingActions.createOverrideUpdateBook({ override: overrideData, update: bookUpdate })).then(function (response) {
					if (props.onSelect) {
						props.onSelect(overrideData);
					}
				});
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(BookTextVariety, _React$Component);
	
		function BookTextVariety(props) {
			_classCallCheck(this, BookTextVariety);
	
			var _this = _possibleConstructorReturn(this, (BookTextVariety.__proto__ || Object.getPrototypeOf(BookTextVariety)).call(this));
	
			autobind(_this);
			_this.state = { edit: false };
			LuckyOrangeClient.tagComponent("TextVarietyPage");
			return _this;
		}
	
		_createClass(BookTextVariety, [{
			key: "onCancel",
			value: function onCancel() {
				this.props.reset();
			}
		}, {
			key: "onSelect",
			value: function onSelect(textVariety, e) {
				$wr.nope(e);
				this.props.updateBook(textVariety);
				if (this.props.onSubmit) {
					this.props.onSubmit(this.props.book);
				} else {
					this.setState({ edit: false });
				}
				if (this.props.selectForActivity) {
					this.props.fetchbook;
				}
			}
		}, {
			key: "renderModalDisplay",
			value: function renderModalDisplay() {
				return React.createElement(
					"div",
					{ className: "bookTextVariety text-center" },
					"How would you describe this book?",
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-5 text-center optionContainer" },
							React.createElement(
								"button",
								{ className: "btn btn-default", onClick: this.onSelect.bind(this, "fiction") },
								"Fiction"
							),
							React.createElement(
								"div",
								null,
								"This book is about imaginary events or people."
							)
						),
						React.createElement(
							"div",
							{ className: "col-sm-2 text-center seperator" },
							"OR"
						),
						React.createElement(
							"div",
							{ className: "col-sm-5 text-center optionContainer" },
							React.createElement(
								"button",
								{ className: "btn btn-default", onClick: this.onSelect.bind(this, "non-fiction") },
								"Non Fiction"
							),
							React.createElement(
								"div",
								null,
								"This book is about real events, facts or people."
							)
						)
					)
				);
			}
		}, {
			key: "triggerEdit",
			value: function triggerEdit(e) {
				$wr.nope(e);
				this.setState({ edit: !this.state.edit });
			}
		}, {
			key: "renderCellDisplay",
			value: function renderCellDisplay() {
				if (this.state.edit) {
					var fictionClass = "";
					var nonFictionClass = "";
	
					if (this.props.book.text_variety && TextTypes["Varieties"]["TYPES"][this.props.book.text_variety]) {
						var textVariety = TextTypes["Varieties"]["TYPES"][this.props.book.text_variety].abbreviation;
	
						if (textVariety == "F") {
							var fictionClass = "selected";
						} else {
							var nonFictionClass = "selected";
						}
					}
					var link = React.createElement(
						"div",
						{ className: "selection" },
						React.createElement(
							"a",
							{ href: "#", className: fictionClass, onClick: this.onSelect.bind(this, "fiction") },
							"F"
						),
						" |",
						React.createElement(
							"a",
							{ href: "#", className: nonFictionClass, onClick: this.onSelect.bind(this, "non-fiction") },
							"NF"
						)
					);
					return React.createElement(
						"td",
						{ className: "bookTextVariety" },
						link
					);
				} else {
					if (this.props.book.text_variety && TextTypes["Varieties"]["TYPES"][this.props.book.text_variety]) {
						var textVariety = TextTypes["Varieties"]["TYPES"][this.props.book.text_variety].abbreviation;
					} else {
						var textVariety = "-";
					}
					var link = React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" });
					return React.createElement(
						"td",
						{ className: "clickable editable", onClick: this.triggerEdit },
						React.createElement(
							"span",
							{ className: "textVarietyDisplay" },
							textVariety
						),
						link
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.displayMode && this.props.displayMode == "cell") {
					return this.renderCellDisplay();
				} else {
					return this.renderModalDisplay();
				}
			}
		}]);
	
		return BookTextVariety;
	}(React.Component)) || _class);
	;
	
	BookTextVariety.propTypes = StrictPropTypes({
		reset: PropTypes.func,
		book: PropTypes.object.isRequired,
		onSubmit: PropTypes.func,
		displayMode: PropTypes.string,
		onSelect: PropTypes.func,
		submitTextVariety: PropTypes.func
	});
	
	module.exports = BookTextVariety;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	
	__webpack_require__(3852);
	
	var SpeechControls = function (_React$Component) {
		_inherits(SpeechControls, _React$Component);
	
		function SpeechControls(props) {
			_classCallCheck(this, SpeechControls);
	
			var _this = _possibleConstructorReturn(this, (SpeechControls.__proto__ || Object.getPrototypeOf(SpeechControls)).call(this));
	
			autobind(_this);
			_this.state = { isSpeaking: false, isWaiting: false, recognition: false,
				showSpeechToTextHelpModal: false
			};
			return _this;
		}
	
		_createClass(SpeechControls, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!this.props.readTextOnly) {
					var sources = [{ "ref": "start_recording", "path": "speech-to-text/start_recording", "play": false }, { "ref": "end_recording", "path": "speech-to-text/end_recording", "play": false }];
					window.wrL2eSound.addSource(sources, "speech_control");
				}
				if (this.props.autoReadText) {
					this.readQuestion();
				}
			}
		}, {
			key: "createVoice",
			value: function createVoice(text) {
				var u = new SpeechSynthesisUtterance();
				u.text = text;
				u.voiceURI = 'native';
				u.lang = 'en-US';
				u.rate = 1;
				u.pitch = 1.1;
				u.onstart = this.startSpeaking;
				u.onend = this.stopSpeaking;
	
				return u;
			}
		}, {
			key: "startSpeaking",
			value: function startSpeaking() {
				this.animateSpeechIcon();
				this.setState({ isWaiting: false, isSpeaking: true });
			}
		}, {
			key: "stopSpeaking",
			value: function stopSpeaking() {
				this.setState({ isSpeaking: false });
			}
		}, {
			key: "recordAnswer",
			value: function recordAnswer() {
				if (!window.speechSynthesis) {
					return;
				}
				if (this.state.isSpeaking) {
					window.speechSynthesis.cancel();
				}
	
				if (this.state.isRecording) {
					// this.onStopRecording();
					this.state.recognition.stop();
				} else {
					this.startRecording();
				}
			}
		}, {
			key: "startRecording",
			value: function startRecording() {
				var recognition = new webkitSpeechRecognition();
				recognition.continuous = true;
				recognition.interimResults = true;
	
				var text = this.props.getText();
				if (text.length > 0) {
					var final_transcript = text + " ";
				} else {
					var final_transcript = "";
				}
	
				recognition.onstart = this.onStartRecording;
				recognition.onresult = function (event) {
					var interim_transcript = '';
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							final_transcript += event.results[i][0].transcript;
							this.props.setText(final_transcript);
						} else {
							interim_transcript += event.results[i][0].transcript;
							this.props.setText(final_transcript + interim_transcript);
						}
					}
				}.bind(this);
				recognition.onend = this.onStopRecording;
				recognition.start();
	
				this.setState({ isWaiting: true, isRecording: true, recognition: recognition });
			}
		}, {
			key: "onStartRecording",
			value: function onStartRecording() {
				this.triggerSoundStartRecording();
				this.animateRecordingIcon();
				this.setState({ isWaiting: false, isRecording: true });
			}
		}, {
			key: "onStopRecording",
			value: function onStopRecording() {
				this.triggerSoundStopRecording();
				this.setState({ isRecording: false });
			}
		}, {
			key: "animateRecordingIcon",
			value: function animateRecordingIcon() {
				$(this.refs.speechToText).css("background-color", '#bbbbbb');
				if (this.props.toggleHighlight) {
					this.props.toggleHighlight(true, "recording");
				}
	
				setTimeout(function () {
					$(this.refs.speechToText).css("background-color", '#da3956');
					if (this.props.toggleHighlight) {
						this.props.toggleHighlight(false, "recording");
					}
				}.bind(this), 1000);
	
				setTimeout(function () {
					if (this.state.isRecording) {
						this.animateRecordingIcon();
					} else {
						$(this.refs.speechToText).css("background-color", '');
						if (this.props.toggleHighlight) {
							this.props.toggleHighlight(false, "recording");
						}
					}
				}.bind(this), 2000);
			}
		}, {
			key: "animateSpeechIcon",
			value: function animateSpeechIcon() {
				$(this.refs.textToSpeech).css("background-color", '#bbbbbb');
				if (this.props.toggleHighlight) {
					this.props.toggleHighlight(true, "textToSpeechHighlight");
				}
	
				setTimeout(function () {
					$(this.refs.textToSpeech).css("background-color", '#8e54c1');
					if (this.props.toggleHighlight) {
						this.props.toggleHighlight(false, "textToSpeechHighlight");
					}
				}.bind(this), 1000);
	
				setTimeout(function () {
					if (this.state.isSpeaking) {
						this.animateSpeechIcon();
					} else {
						$(this.refs.textToSpeech).css("background-color", '');
						if (this.props.toggleHighlight) {
							this.props.toggleHighlight(false, "textToSpeechHighlight");
						}
					}
				}.bind(this), 2000);
			}
		}, {
			key: "triggerSoundStartRecording",
			value: function triggerSoundStartRecording() {
				window.wrL2eSound.stopAllSounds();
				window.wrL2eSound.playSound("start_recording" + "_speech_control");
			}
		}, {
			key: "triggerSoundStopRecording",
			value: function triggerSoundStopRecording() {
				window.wrL2eSound.stopAllSounds();
				window.wrL2eSound.playSound("end_recording" + "_speech_control");
			}
		}, {
			key: "readQuestion",
			value: function readQuestion() {
				if (!window.speechSynthesis) {
					return;
				}
				if (this.state.isRecording) {
					this.onStopRecording();
				}
	
				if (this.state.isSpeaking) {
					window.speechSynthesis.cancel();
				} else if (window.speechSynthesis) {
					this.setState({ isWaiting: true }, this.breakAndReadText);
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: "Reading out loud doesn't work in your browser. Please use the latest version of Chrome, Firefox, or Safari.",
						icon: "exclamation-sign", type: "error"
					}, 6000);
				}
			}
		}, {
			key: "breakAndReadText",
			value: function breakAndReadText() {
				if (!window.speechSynthesis) {
					return;
				}
				window.speechSynthesis.cancel();
				window.wrVoice = window.wrVoice || [];
	
				var text = this.props.getTextToRead();
				text = text.replace("____", "... ... ... ...");
	
				var voice = this.createVoice(text);
				window.wrVoice.push(voice);
	
				setTimeout(function () {
					window.speechSynthesis.speak(voice);
				}.bind(this), 150);
			}
		}, {
			key: "openSpeechToTextHelpModal",
			value: function openSpeechToTextHelpModal(e) {
				$wr.nope(e);
				this.refs.modal.show();
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.isWaiting) {
					// We clicked a button and it is loading
					var statusMessage = React.createElement(
						"em",
						null,
						"Loading... "
					);
				}
	
				// Text-to-voice
				var textToSpeech = React.createElement("img", { className: "textToSpeech", ref: "textToSpeech", onClick: this.readQuestion,
					src: __webpack_require__(297) });
				if ($wr.isIOS() && this.props.autoReadText) {
					// It won't actually autoread, so we need alert the user
					var statusMessage = React.createElement(
						"em",
						null,
						"Tap to read: ",
						" "
					);
				}
	
				// Voice-to-text
				if (!this.props.readTextOnly) {
					// When voice-to-text should be included
	
					if ('webkitSpeechRecognition' in window) {
						// Currently just chrome
						var speechToText = React.createElement("img", { className: "speechToText", ref: "speechToText", onClick: this.recordAnswer,
							src: __webpack_require__(185) });
					} else {
						// Anything other than chrome, basically
	
						if ($wr.isIOS()) {
							// iOS/iPad give dication instructions
							var speechToText = React.createElement("img", { className: "speechToText", ref: "speechToText", onClick: this.openSpeechToTextHelpModal,
								src: __webpack_require__(185) });
							var iosModal = React.createElement(
								Modal,
								{ className: "textToSpeechModal", ref: "modal", headerText: "Text to Speech" },
								React.createElement(
									"div",
									{ className: "modalBody" },
									React.createElement(
										"p",
										null,
										"Want to speak instead of typing? Tap the text area (where your answer goes) and then the microphone on your keyboard and get started!"
									),
									React.createElement("img", { className: "keyboardImg", src: __webpack_require__(520) })
								)
							);
						} else {
							// Old FF, IE, tell them to use chrome
							var speechToText = React.createElement("img", { className: "speechToText", ref: "speechToText",
								src: __webpack_require__(185) });
							var useChrome = React.createElement(
								"span",
								{ className: "chromeTip" },
								"To record your answer, use Chrome!"
							);
						}
					}
				}
	
				var speechClassName = "speechControlsContainer";
				if (!(useChrome || statusMessage)) {
					speechClassName += " text-center";
				}
	
				return React.createElement(
					"div",
					{ className: speechClassName },
					statusMessage,
					textToSpeech,
					speechToText,
					useChrome,
					iosModal
				);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (!this.props.readTextOnly) {
					window.wrL2eSound.removeSources('speech_control');
					if (this.state.recognition) {
						this.state.recognition.stop();
					}
				}
			}
		}]);
	
		return SpeechControls;
	}(React.Component);
	
	SpeechControls.propTypes = StrictPropTypes({
		// Gets the existing text that voice will append to, required if readTextOnly is false
		getText: PropTypes.func,
	
		// Sets the text from voice recording, required if readTextOnly is false
		setText: PropTypes.func,
	
		// Gets the text to read out loud
		getTextToRead: PropTypes.func.isRequired,
	
		// Toggles the highlight during recording
		toggleHighlight: PropTypes.func,
	
		// Automatically read the text
		autoReadText: PropTypes.bool,
	
		// If true, read text only, no voice recording
		readTextOnly: PropTypes.bool
	});
	
	module.exports = SpeechControls;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.WIDGET_DIGEST = exports.UPGRADE_TOKEN = exports.TASK = exports.SURVEY_PROMPT = exports.STUDENT_LIST = exports.STUDENT = exports.SCHOOL_ORG = exports.SCHOOL = exports.RESPONSE = exports.REPORT = exports.READING_LEVEL = exports.RATING = exports.QUIZ = exports.QUESTION = exports.FURNITURE = exports.PERK = exports.PLATFORM = exports.PHOTOGRAPH = exports.PATCH = exports.PARENT = exports.LOG = exports.COIN_RECORD = exports.INVOICE = exports.EVALUATION = exports.EXPECTATION_DIGEST = exports.ESTIMATE = exports.DISTRICT_ORG = exports.DISCOUNT_TOKEN = exports.DIGEST = exports.DEAL = exports.DATA_EXPORT = exports.CONTACT = exports.COMMENT = exports.BOOK = exports.AVATAR = exports.ANSWER = exports.ADMIN = exports.ACTIVITY = undefined;
	exports.entities = entities;
	
	var _normalizr = __webpack_require__(3546);
	
	var ACTIVITY = exports.ACTIVITY = new _normalizr.schema.Entity("activities");
	var ADMIN = exports.ADMIN = new _normalizr.schema.Entity("admins");
	var ANSWER = exports.ANSWER = new _normalizr.schema.Entity("answers");
	var AVATAR = exports.AVATAR = new _normalizr.schema.Entity("avatars");
	var BOOK = exports.BOOK = new _normalizr.schema.Entity("books", {}, { idAttribute: "text_id" });
	var COMMENT = exports.COMMENT = new _normalizr.schema.Entity("comments");
	var CONTACT = exports.CONTACT = new _normalizr.schema.Entity("contacts");
	var DATA_EXPORT = exports.DATA_EXPORT = new _normalizr.schema.Entity("dataExports");
	var DEAL = exports.DEAL = new _normalizr.schema.Entity("deals");
	var DIGEST = exports.DIGEST = new _normalizr.schema.Entity("digests", {}, { idAttribute: "key" });
	var DISCOUNT_TOKEN = exports.DISCOUNT_TOKEN = new _normalizr.schema.Entity("discountTokens", { idAttribute: "code" });
	var DISTRICT_ORG = exports.DISTRICT_ORG = new _normalizr.schema.Entity("districtOrgs");
	var ESTIMATE = exports.ESTIMATE = new _normalizr.schema.Entity("estimates");
	var EXPECTATION_DIGEST = exports.EXPECTATION_DIGEST = new _normalizr.schema.Entity("expectationDigests", {}, { idAttribute: "key" });
	var EVALUATION = exports.EVALUATION = new _normalizr.schema.Entity("evaluations");
	var INVOICE = exports.INVOICE = new _normalizr.schema.Entity("invoices");
	var COIN_RECORD = exports.COIN_RECORD = new _normalizr.schema.Entity("coinRecords"); // Intentional name change
	var LOG = exports.LOG = new _normalizr.schema.Entity("logs");
	var PARENT = exports.PARENT = new _normalizr.schema.Entity("parents");
	var PATCH = exports.PATCH = new _normalizr.schema.Entity("patches");
	var PHOTOGRAPH = exports.PHOTOGRAPH = new _normalizr.schema.Entity("photographs");
	var PLATFORM = exports.PLATFORM = new _normalizr.schema.Entity("platforms");
	var PERK = exports.PERK = new _normalizr.schema.Entity("perks");
	var FURNITURE = exports.FURNITURE = new _normalizr.schema.Entity("furnitures");
	var QUESTION = exports.QUESTION = new _normalizr.schema.Entity("questions");
	var QUIZ = exports.QUIZ = new _normalizr.schema.Entity("quizzes");
	var RATING = exports.RATING = new _normalizr.schema.Entity("ratings");
	var READING_LEVEL = exports.READING_LEVEL = new _normalizr.schema.Entity("readingLevels");
	var REPORT = exports.REPORT = new _normalizr.schema.Entity("reports", {}, { idAttribute: "report_key" });
	var RESPONSE = exports.RESPONSE = new _normalizr.schema.Entity("responses");
	var SCHOOL = exports.SCHOOL = new _normalizr.schema.Entity("schools");
	var SCHOOL_ORG = exports.SCHOOL_ORG = new _normalizr.schema.Entity("schoolOrgs");
	var STUDENT = exports.STUDENT = new _normalizr.schema.Entity("students");
	var STUDENT_LIST = exports.STUDENT_LIST = new _normalizr.schema.Entity("studentLists");
	var SURVEY_PROMPT = exports.SURVEY_PROMPT = new _normalizr.schema.Entity("surveyPrompts", {}, { idAttribute: "key" });
	var TASK = exports.TASK = new _normalizr.schema.Entity("tasks");
	var UPGRADE_TOKEN = exports.UPGRADE_TOKEN = new _normalizr.schema.Entity("upgradeTokens");
	var WIDGET_DIGEST = exports.WIDGET_DIGEST = new _normalizr.schema.Entity("widgetDigests");
	
	ADMIN.define({
		primary_school_org: SCHOOL_ORG
	});
	
	ANSWER.define({
		question: QUESTION,
		evaluation: EVALUATION,
		gold_records: [COIN_RECORD]
	});
	
	BOOK.define({
		quiz_evaluations: [EVALUATION],
		quizzes: [QUIZ],
		answers: [ANSWER],
		reviews: [ANSWER],
		ratings: [RATING],
		responses: [RESPONSE],
		students: [STUDENT]
	});
	
	PARENT.define({
		children: [STUDENT]
	});
	
	QUIZ.define({
		answers: [ANSWER],
		evaluation: EVALUATION,
		gold_records: [COIN_RECORD]
	});
	
	REPORT.define({
		students: [STUDENT]
	});
	
	RESPONSE.define({
		activity: ACTIVITY,
		evaluation: EVALUATION
	});
	
	SCHOOL.define({
		active_student_lists: [STUDENT_LIST]
	});
	
	STUDENT.define({
		avatar: AVATAR,
		parent: PARENT,
		current_tasks: [TASK]
	});
	
	STUDENT.define({
		avatar: AVATAR,
		parent: PARENT,
		all_tasks: [TASK]
	});
	
	STUDENT_LIST.define({
		students: [STUDENT],
		primary_admin: ADMIN,
		admins: [ADMIN]
	});
	
	TASK.define({
		subject: ACTIVITY,
		completion: RESPONSE
	});
	
	UPGRADE_TOKEN.define({
		user: ADMIN
	});
	
	WIDGET_DIGEST.define({
		user: ADMIN
	});
	
	function entities(data, dataSchema) {
		return (0, _normalizr.normalize)(data, dataSchema).entities;
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.filterBy = filterBy;
	exports.selectPage = selectPage;
	exports.allRecords = allRecords;
	exports.validStudentHomepageTasks = validStudentHomepageTasks;
	var TextTypes = __webpack_require__(38);
	
	// Filters are directly applied as key value to query
	// Conditions are applied in different ways depending on the key
	function filterBy(items, filters, conditions) {
		conditions = conditions || {};
		items = allRecords(items);
		if (!_.isEmpty(filters)) {
			items = _.where(items, filters);
		}
	
		if (!_.isEmpty(conditions)) {
			// All functions which take item and return if item should be included
			var conditionFilters = _.compact([buildInUserIDs(conditions), buildInTextIDs(conditions), buildInIDs(conditions), buildIsInTimeRange(conditions), buildInDueDateRange(conditions), buildIsTextVariety(conditions), buildInDraft(conditions)]);
	
			if (conditions.oneOfMatch) {
				_.each(conditions.oneOfMatch, function (values, key) {
					conditionFilters.push(function (item) {
						return _.include(values, item[key]);
					});
				});
			}
	
			if (conditions.nonBlank) {
				_.each(conditions.nonBlank, function (key) {
					conditionFilters.push(function (item) {
						return item[key] != null && (item[key] + "").trim().length > 0;
					});
				});
			}
	
			if (_.isEmpty(conditionFilters) && _.isEmpty(filters)) {
				return items;
			}
	
			items = _.select(items, function (item) {
				// All filters have to accept the item
				if (!_.all(conditionFilters, function (filter) {
					return filter(item);
				})) {
					return false;
				}
				return true;
			});
		}
	
		return items;
	}
	
	function selectPage(reducerState, pageKey, page) {
		var pageDetails = reducerState.pages[pageKey];
		if (!pageDetails) {
			return [];
		}
	
		var pageIDs = pageDetails[page];
		if (!pageIDs) {
			return [];
		}
	
		return _.compact(_.map(pageIDs, function (id) {
			return reducerState[id];
		}));
	}
	
	var IGNORE_VALUES = ["loading", "cached", "totals", "pages", "noMorePages"];
	function allRecords(reducerState) {
		return _.values(_.omit(reducerState, IGNORE_VALUES));
	}
	
	//////////////////////////////
	// Private ///////////////////
	//////////////////////////////
	
	function buildIsInTimeRange(conditions) {
		if (conditions.startDate || conditions.endDate) {
			// Inclusive start, exclusive end
			var startTime = null,
			    endTime = null;
	
			if (conditions.startDate) {
				startTime = $wr.momentInTimezone(conditions.startDate);
			}
			if (conditions.endDate) {
				endTime = $wr.momentInTimezone(conditions.endDate).add(1, "day");
			}
	
			return function (item) {
				var time, times;
	
				if (conditions.timeKey) {
					if (conditions.timeKey == "last_active_by_user_id") {
						var userIDs = extractUserIDs(conditions) || [];
	
						times = _.values(_.pick(item.last_actives || {}, userIDs));
					} else {
						time = item[conditions.timeKey];
					}
				} else {
					// The order here is important: keys coming earlier will be favored for checking
					// date inclusion if present on the object
					time = item.completed_at || item.created_at;
				}
	
				if (time) {
					return inTimeRange(startTime, endTime, $wr.momentInTimezone(time));
				} else if (times) {
					return _.any(times, function (time) {
						return inTimeRange(startTime, endTime, $wr.momentInTimezone(time));
					});
				} else {
					return false;
				}
			};
		}
	}
	
	function buildInDueDateRange(conditions) {
		var today = new Date();
		if (conditions.dueDate !== undefined) {
			if (conditions.dueDate === 'upcoming') {
				return function (item) {
					return new Date(item.due_date) > today;
				};
			} else if (conditions.dueDate === 'past') {
				return function (item) {
					if (item.due_date !== null) {
						return new Date(item.due_date) < today;
					}
				};
			} else if (conditions.dueDate === 'none') {
				return function (item) {
					return item.due_date === null;
				};
			} else {
				return null;
			}
		} else {
			return null;
		}
	}
	
	// All should be moment objects
	function inTimeRange(start, end, time) {
		return (start == null || time >= start) && (end == null || time < end);
	}
	
	function extractUserIDs(conditions) {
		var manyIDs = conditions.studentIDs || conditions.adminIDs || conditions.userIDs;
		// Treat an empty array of userIDs the same as no constraint at all
		if (manyIDs !== undefined && manyIDs.length > 0) {
			return manyIDs;
		}
	
		var singleID = conditions.studentID || conditions.adminID || conditions.userID;
		if (singleID !== undefined) {
			return [singleID];
		}
	
		return undefined;
	}
	
	function buildInUserIDs(conditions) {
		var userIDs = extractUserIDs(conditions);
	
		if (!!userIDs) {
			userIDs = new Set(userIDs);
		}
	
		if (userIDs) {
			return function (item) {
				var userID = item.user_id || item.student_id || item.admin_id;
				if (userID !== undefined) {
					return userIDs.has(userID);
				}
				if (_.isArray(item.user_ids)) {
					return _.any(item.user_ids, function (id) {
						return userIDs.has(id);
					});
				}
			};
		}
	}
	
	function buildInIDs(conditions) {
		if (conditions.ids) {
			var ids = new Set(conditions.ids);
			return function (item) {
				return ids.has(item.id);
			};
		}
	}
	
	function buildInTextIDs(conditions) {
		var textIDs;
	
		if (conditions.textIDs !== undefined) {
			textIDs = new Set(conditions.textIDs);
		}
	
		if (conditions.textID !== undefined) {
			textIDs = new Set([conditions.textID]);
		}
	
		if (textIDs) {
			return function (item) {
				if (item.text_id !== undefined) {
					return textIDs.has(item.text_id);
				}
				if (_.isArray(item.text_ids)) {
					return _.any(item.text_ids, function (id) {
						return textIDs.has(id);
					});
				}
			};
		}
	}
	
	function buildIsTextVariety(conditions) {
		if (conditions.textVariety == TextTypes.Varieties.BOTH) {
			return null;
		} else if (conditions.textVariety) {
			return function (item) {
				return item.text_variety == conditions.textVariety;
			};
		}
	}
	
	function buildInDraft(conditions) {
		if (conditions.draft === true || conditions.draft === false) {
			return function (item) {
				return item.draft == conditions.draft;
			};
		} else {
			return null;
		}
	}
	// returns valid tasks for student homepage
	// includes:
	// 	not completed, before due date
	// 	not completed, less than 30 days past due date
	//	not completed, no due date
	//	completed, no due date, less than 7 days past completion date
	// 	completed, not past due date
	function validStudentHomepageTasks(tasks) {
		// get 7 days ago
		var sevenDaysAgo = new Date();
		var pastDate = sevenDaysAgo.getDate() - 7;
	
		// get 30 days ago
		var thirtyDaysAgo = new Date();
		var pastDate = thirtyDaysAgo.getDate() - 30;
		thirtyDaysAgo.setDate(pastDate);
	
		var validTasks = _.map(tasks, function (task) {
			if (task.draft && task.due_date && new Date(task.due_date) > thirtyDaysAgo) {
				return task;
			} else if (task.draft && !task.due_date) {
				return task;
			} else if (!task.draft && !task.due_date && task.completed_at && new Date(task.completed_at) > new Date(sevenDaysAgo)) {
				return task;
			} else if (!task.draft && task.due_date && new Date(task.due_date) > new Date()) {
				return task;
			}
		});
	
		return _.compact(validTasks);
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(75);
	var TAG = __webpack_require__(37)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(47).f;
	var has = __webpack_require__(67);
	var TAG = __webpack_require__(37)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var defined = __webpack_require__(85);
	var fails = __webpack_require__(30);
	var spaces = __webpack_require__(283);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41c9c11212ee00a8bd112e9d86e5f5d3.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(607);
	var DomHandler = __webpack_require__(484);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(608),
	    ElementType: __webpack_require__(149),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(3507));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(3509));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(609));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(3508));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(486));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(3506)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollbars = undefined;
	
	var _Scrollbars = __webpack_require__(3556);
	
	var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Scrollbars2["default"];
	exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(3594);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(222);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(636);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(3595);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(637);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(639);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(638);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(349);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(640);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(641);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(348);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(1521));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1523));
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	var _Transition = _interopRequireDefault(__webpack_require__(3602));
	
	var _PropTypes = __webpack_require__(644);
	
	var _reflow = __webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      if (node) (0, _reflow.forceReflow)(node);
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(643));
	
	var _ChildMapping = __webpack_require__(3604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // We don't wanna wrap it twice
	        if (fn.__sentry__) {
	            return fn;
	        }
	        // If this has already been wrapped in the past, return that wrapped function
	        if (fn.__sentry_wrapped__) {
	            return fn.__sentry_wrapped__;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            if (fn.handleEvent) {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means the sentry.javascript SDK caught an error invoking your application code. This
	                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                return fn.handleEvent.apply(this, wrappedArguments);
	            }
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    var processedEvent = tslib_1.__assign({}, event);
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
	                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
	                    }
	                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
	                    return processedEvent;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    fn.prototype = fn.prototype || {};
	    sentryWrapped.prototype = fn.prototype;
	    Object.defineProperty(fn, '__sentry_wrapped__', {
	        enumerable: false,
	        value: sentryWrapped,
	    });
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    Object.defineProperties(sentryWrapped, {
	        __sentry__: {
	            enumerable: false,
	            value: true,
	        },
	        __sentry_original__: {
	            enumerable: false,
	            value: fn,
	        },
	    });
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        utils_1.logger.error("Missing eventId option in showReportDialog call");
	        return;
	    }
	    if (!options.dsn) {
	        utils_1.logger.error("Missing dsn option in showReportDialog call");
	        return;
	    }
	    var script = document.createElement('script');
	    script.async = true;
	    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    (document.head || document.body).appendChild(script);
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(234);
	var string_1 = __webpack_require__(237);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined'
	            ? window
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    if (event.message) {
	        return event.message;
	    }
	    if (event.exception && event.exception.values && event.exception.values[0]) {
	        var exception = event.exception.values[0];
	        if (exception.type && exception.value) {
	            return exception.type + ": " + exception.value;
	        }
	        return exception.type || exception.value || event.event_id || '<unknown>';
	    }
	    return event.event_id || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/** JSDoc */
	function consoleSandbox(callback) {
	    var global = getGlobalObject();
	    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	    if (!('console' in global)) {
	        return callback();
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    levels.forEach(function (level) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (level in global.console && originalConsole[level].__sentry_original__) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalConsole[level].__sentry_original__;
	        }
	    });
	    // Perform callback manipulations
	    var result = callback();
	    // Revert restoration to wrapped state
	    Object.keys(wrappedLevels).forEach(function (level) {
	        originalConsole[level] = wrappedLevels[level];
	    });
	    return result;
	}
	exports.consoleSandbox = consoleSandbox;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    event.exception = event.exception || {};
	    event.exception.values = event.exception.values || [];
	    event.exception.values[0] = event.exception.values[0] || {};
	    event.exception.values[0].value = event.exception.values[0].value || value || '';
	    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism to a given event.
	 * @param event The event to modify.
	 * @param mechanism Mechanism of the mechanism.
	 * @hidden
	 */
	function addExceptionMechanism(event, mechanism) {
	    if (mechanism === void 0) { mechanism = {}; }
	    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
	    try {
	        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
	        Object.keys(mechanism).forEach(function (key) {
	            // @ts-ignore Mechanism has no index signature
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            event.exception.values[0].mechanism[key] = mechanism[key];
	        });
	    }
	    catch (_oO) {
	        // no-empty
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    try {
	        return document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	var defaultRetryAfter = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param now current unix timestamp
	 * @param header string representation of 'Retry-After' header
	 */
	function parseRetryAfterHeader(now, header) {
	    if (!header) {
	        return defaultRetryAfter;
	    }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return defaultRetryAfter;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	//# sourceMappingURL=misc.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UIActions = __webpack_require__(41);
	var PaywallModal = __webpack_require__(44);
	
	__webpack_require__(3654);
	
	var TruncatedDataNote = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			showHistoricalDataPaywall: function showHistoricalDataPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(TruncatedDataNote, _React$Component);
	
		function TruncatedDataNote(props) {
			_classCallCheck(this, TruncatedDataNote);
	
			var _this = _possibleConstructorReturn(this, (TruncatedDataNote.__proto__ || Object.getPrototypeOf(TruncatedDataNote)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(TruncatedDataNote, [{
			key: "render",
			value: function render() {
				var total = this.props.total;
				var type = this.props.type;
				if (type == BOOKS) {
					var studentsTotalData = React.createElement(
						"p",
						null,
						"Your students have done activites for ",
						React.createElement(
							"b",
							null,
							total
						),
						" ",
						this.props.type,
						"."
					);
				} else if (type == GOALS || type == RL_GRAPH) {
					var className = "truncatedDataNoteNoBorder";
				} else {
					var studentsTotalData = React.createElement(
						"p",
						null,
						"Your students have done ",
						React.createElement(
							"b",
							null,
							total
						),
						" ",
						this.props.type,
						"."
					);
				}
				return React.createElement(
					"div",
					{ className: "truncatedDataNote " + className },
					React.createElement(
						"div",
						{ className: "truncatedInner" },
						React.createElement(
							"p",
							{ className: "entireClassText" },
							studentsTotalData,
							"Want to see all of the data for your students?",
							React.createElement(
								"a",
								{ className: "btn btn-link", onClick: this.props.showHistoricalDataPaywall },
								"Learn about WR Silver"
							)
						)
					)
				);
			}
		}]);
	
		return TruncatedDataNote;
	}(React.Component)) || _class);
	
	
	var BOOKS = "books";
	var GOALS = "goals";
	var RL_GRAPH = "reading-level-graph";
	TruncatedDataNote.propTypes = PageStrictPropTypes({
		total: PropTypes.number,
		type: PropTypes.string
	});
	
	module.exports = TruncatedDataNote;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var StudentDisplay = __webpack_require__(52);
	
	var ItemHeader = function ItemHeader(props) {
		if (props.date) {
			var dateDisplay = React.createElement(
				"div",
				{ className: "date" },
				$wr.formatDateTime(props.date, "show-past-years")
			);
		}
		if (props.pageBreak) {
			var pageBreak = React.createElement("div", { className: "pageBreak" });
		}
		return React.createElement(
			"div",
			{ className: "itemHeader" },
			pageBreak,
			React.createElement(
				"div",
				{ className: "itemHeaderInner" },
				React.createElement(
					"div",
					{ className: "innerHeader clearfix" },
					React.createElement(
						"div",
						{ className: "student" },
						React.createElement(StudentDisplay, { studentID: props.studentID, showAvatar: true, avatarMaxWidth: 40 })
					),
					dateDisplay
				)
			)
		);
	};
	
	ItemHeader.propTypes = StrictPropTypes({
		date: PropTypes.string,
		studentID: PropTypes.number,
		pageBreak: PropTypes.bool
	});
	
	module.exports = ItemHeader;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3676);
	
	var PendingTaskNotice = function (_React$Component) {
		_inherits(PendingTaskNotice, _React$Component);
	
		function PendingTaskNotice(props) {
			_classCallCheck(this, PendingTaskNotice);
	
			var _this = _possibleConstructorReturn(this, (PendingTaskNotice.__proto__ || Object.getPrototypeOf(PendingTaskNotice)).call(this));
	
			autobind(_this);
			_this.state = {
				pendingMessage: null, fadeOut: false
			};
			return _this;
		}
	
		_createClass(PendingTaskNotice, [{
			key: "render",
			value: function render() {
				if (!this.state.pendingMessage) {
					return React.createElement("div", null);
				} else {
	
					var outerClassName = this.state.fadeOut ? "pendingTaskNotice fadeOut" : "pendingTaskNotice";
					return React.createElement(
						"div",
						{ className: outerClassName },
						React.createElement(
							"div",
							{ className: "innerBanner fadeCycle" },
							React.createElement(
								"p",
								null,
								this.state.pendingMessage
							)
						)
					);
				}
			}
		}, {
			key: "getPendingTask",
			value: function getPendingTask() {
				return this.state.pendingMessage;
			}
	
			// If pendingTask isn't provided, make a call to the server to check for it
			// otherwise, set it as the tast to display
	
		}, {
			key: "loadPendingTask",
			value: function loadPendingTask(pendingTask) {
				if (pendingTask) {
					this.setState({ pendingMessage: pendingTask, fadeOut: false });
					this.schedulePendingCheck();
				} else if (CurrentUser.isSignedIn()) {
					var embeds = "user.pending_task";
	
					CurrentUser.api().getUser(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler(function (response) {
						if (response.user.pending_task) {
							this.setState({ pendingMessage: response.user.pending_task, fadeOut: false });
							this.schedulePendingCheck();
						} else {
	
							$(document).trigger('task-finished-loading', this.state.pendingMessage);
							this.setState({ fadeOut: true });
	
							setTimeout(function () {
								this.setState({ pendingMessage: null });
							}.bind(this), 2000);
						}
					}.bind(this)));
				}
			}
	
			// Schedules a time to check is the task has been completed
	
		}, {
			key: "schedulePendingCheck",
			value: function schedulePendingCheck() {
				setTimeout(function () {
					this.loadPendingTask();
				}.bind(this), PendingTaskNotice.POLL_PENDING_TASK_RATE);
			}
		}, {
			key: "checkAddingStudents",
			value: function checkAddingStudents() {
				var task = this.getPendingTask();
				return !!(task && _.includes(PendingTaskNotice.ADDING_STUDENT_TASKS, task));
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (window.wrNotifications == undefined) {
					window.wrNotifications = {};
				}
				window.wrNotifications.loadPendingTask = this.loadPendingTask;
				window.wrNotifications.getPendingTask = this.getPendingTask;
	
				window.wrNotifications.checkAddingStudents = this.checkAddingStudents;
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				delete window.wrLoadPendingTask;
			}
		}]);
	
		return PendingTaskNotice;
	}(React.Component);
	
	;
	
	PendingTaskNotice.POLL_PENDING_TASK_RATE = 5000;
	
	PendingTaskNotice.UPLOADING_STUDENTS = "Uploading Students...";
	PendingTaskNotice.GOOGLE_SYNC = "Syncing Google Students...";
	PendingTaskNotice.CLEVER_SYNC = "Syncing Clever Students...";
	
	PendingTaskNotice.ADDING_STUDENT_TASKS = [PendingTaskNotice.UPLOADING_STUDENTS, PendingTaskNotice.GOOGLE_SYNC, PendingTaskNotice.CLEVER_SYNC];
	
	PendingTaskNotice.propTypes = StrictPropTypes({});
	
	module.exports = PendingTaskNotice;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3711);
	
	var RosterUploadPogressMeter = function RosterUploadPogressMeter(props) {
	
		var stagesNames = ["Upload File", "Verify Columns", "Verify Grades", "Verify Classes", "Confirm"];
	
		var stages = [];
	
		for (var i = 0; i < stagesNames.length; i++) {
			var className = "stage";
			if (props.index == i) {
				className += " current";
			} else if (props.index > i) {
				className += " past";
			}
	
			stages.push(React.createElement(
				"span",
				{ className: className, key: i },
				React.createElement(
					"span",
					{ className: "stageNumber" },
					i + 1
				),
				React.createElement(
					"span",
					{ className: "stageName" },
					stagesNames[i]
				)
			));
		}
	
		return React.createElement(
			"div",
			{ className: "rosterUploadProgressMeter clearfix" },
			stages
		);
	};
	
	RosterUploadPogressMeter.propTypes = StrictPropTypes({
		index: PropTypes.number.isRequired
	});
	
	module.exports = RosterUploadPogressMeter;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var StudentAvatar = __webpack_require__(35);
	
	__webpack_require__(654);
	
	var StudentListDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
		downProps.student = RosterSelectors.student({ state: state, id: props.studentID });
		if (downProps.student && downProps.student.student_list_ids) {
			downProps.studentList = RosterSelectors.studentList({ state: state, id: downProps.student.student_list_ids.primary });
		}
		return downProps;
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentListDisplay, _React$Component);
	
		function StudentListDisplay(props) {
			_classCallCheck(this, StudentListDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentListDisplay.__proto__ || Object.getPrototypeOf(StudentListDisplay)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentListDisplay, [{
			key: "render",
			value: function render() {
				var student = this.props.student;
				var studentList = this.props.studentList;
				if (studentList) {
					if (student.demo_for_teacher) {
						var studentListName = "(Demo Class)";
					} else {
						var studentListName = studentList.name;
					}
				} else {
					var studentListName = "--";
				}
				return React.createElement(
					"div",
					null,
					React.createElement(
						"span",
						{ className: "studentListName" },
						studentListName
					)
				);
			}
		}]);
	
		return StudentListDisplay;
	}(React.Component)) || _class);
	
	
	StudentListDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the student to be displayed
		studentID: PropTypes.number.isRequired,
	
		// From @connect
		student: PropTypes.object,
		studentList: PropTypes.object,
		primaryStudentList: PropTypes.object
	
	});
	
	module.exports = StudentListDisplay;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var AltModal = __webpack_require__(18);
	var TextTypes = __webpack_require__(38);
	
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	
	var BookLogger = __webpack_require__(400);
	var SmartBookSearch = __webpack_require__(118);
	var StudentsSelectedDisplay = __webpack_require__(139);
	
	var RosterSelectors = __webpack_require__(6);
	var ReadingActions = __webpack_require__(27);
	
	__webpack_require__(3724);
	
	var LogReadingModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			asAdmin: CurrentUser.isAdmin(),
			totalStudents: RosterSelectors.students({ state: state }).length
		};
	}, function (dispatch, props) {
		return {
			createLogs: function createLogs(logs, queryParams) {
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(ReadingActions.createLogs({ logs: logs, query: queryParams }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(LogReadingModal, _React$Component);
	
		function LogReadingModal(props) {
			_classCallCheck(this, LogReadingModal);
	
			var _this = _possibleConstructorReturn(this, (LogReadingModal.__proto__ || Object.getPrototypeOf(LogReadingModal)).call(this));
	
			autobind(_this);
	
			var books = [];
			if (props.initialBook) {
				books.push(props.initialBook);
			}
	
			_this.state = {
				existingBooks: null, books: books,
				loading: false, dailyMinuteMax: false
			};
			return _this;
		}
	
		_createClass(LogReadingModal, [{
			key: "onResetSearch",
			value: function onResetSearch() {
				this.setState({
					books: []
				});
			}
		}, {
			key: "onBookSelect",
			value: function onBookSelect(book) {
				var books = this.state.books.concat(book);
				var uniqBooks = _.uniq(books, function (book) {
					return book.title;
				});
				this.setState({ books: uniqBooks, showBookSearch: false });
			}
		}, {
			key: "removeBook",
			value: function removeBook(textTitle) {
				var newBooks = _.reject(this.state.books, function (book) {
					return book.title == textTitle;
				});
	
				this.setState({ books: newBooks });
			}
		}, {
			key: "validate",
			value: function validate() {
				return _.all(this.state.books, function (book, i) {
					return this.refs["logger" + i].validate();
				}.bind(this));
			}
		}, {
			key: "submitReading",
			value: function submitReading() {
				var _this2 = this;
	
				this.setState({ loading: true });
	
				var emptyErrorsList = this.validate();
	
				if (emptyErrorsList) {
					var logList = [];
					for (var i = 0; i < this.state.books.length; i++) {
						var logData = this.refs["logger" + i].getData();
						var bookData = this.state.books[i];
						logData = _.map(logData, function (log) {
							if (bookData.text_id) {
								return _.extend({}, log, { text_id: bookData.text_id });
							} else {
								// Data to allow the server to create the copy of the book
								return _.extend({}, log, { text_data: bookData });
							}
						});
	
						logList = logList.concat(logData);
					}
	
					// If admin logging from roster page
					if (this.props.studentsSelected) {
						var studentIDs = _.pluck(this.props.studentsSelected, "id");
						var queryParams = { student_ids: studentIDs };
	
						if (this.props.studentsSelected.length > 1) {
							var successMessage = "Logs for your students have been saved.";
						} else {
							var successMessage = "A log for your student has been saved.";
						}
					} else {
						var queryParams = {};
						var successMessage = "Good job logging your reading!";
					}
	
					this.props.createLogs(logList, queryParams).then(function (response) {
						if (_.isEmpty(response.logs) && !_this2.props.asAdmin) {
							_this2.setState({ loading: false, dailyMinuteMax: true });
						} else {
							if (_this2.props.onClose) {
								_this2.props.onClose(true);
							}
	
							setTimeout(function () {
								window.wrNotifications.triggerDropDownNotification({
									title: "Reading Logged", text: successMessage,
									icon: "ok-circle"
								});
								CurrentUser.fetchCurrentUserCoinData();
								this.setState({ loading: false });
								setTimeout(function () {
									$(window.document).trigger("clear-selected-book");
								}, 100);
							}.bind(_this2), 100);
						}
					});
				} else {
					this.setState({ loading: false });
				}
			}
		}, {
			key: "goBack",
			value: function goBack(e) {
				$wr.nope(e);
				this.props.onBack(this.props.bookStatus);
			}
		}, {
			key: "render",
			value: function render() {
				var classAddOn = "";
				var bookLogs = this.state.books.map(function (book, i) {
					if (this.state.books.length > 1) {
						var removeBookF = this.removeBook.bind(this, book.title);
					}
					return React.createElement(BookLogger, { book: book, ref: "logger" + i,
						key: book.title, removeBook: removeBookF });
				}.bind(this));
	
				if (this.state.books.length > 0) {
					var logReadingButton = React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.state.loading,
						onClick: this.submitReading, text: "Log Reading!" });
				}
	
				if (this.state.dailyMinuteMax) {
					var dailyMinuteMaxMessage = React.createElement(
						"p",
						{ className: "dailyMinutesMaxErrorText" },
						"Wow, you read so much! You reached the limit of minutes you can log for one day."
					);
				}
				if (this.props.studentsSelected) {
					var studentSelected = React.createElement(StudentsSelectedDisplay, { totalStudents: this.props.totalStudents,
						studentsSelected: this.props.studentsSelected });
					if (this.state.books.length) {
						var resetSearch = React.createElement(
							"a",
							{ className: "resetSearch", onClick: this.onResetSearch },
							"Change Book"
						);
					} else {
						var searchBook = React.createElement(SmartBookSearch, { onBookSelect: this.onBookSelect });
					}
					var classAddOn = "studentRosterModal ";
				} else {
					var student = CurrentUser.get();
					// This is only for students
					var backLink = React.createElement(
						"a",
						{ href: "#", className: "backLink", onClick: this.goBack },
						React.createElement(Glyphicon, { icon: "arrow-left" }),
						" Back"
					);
				}
	
				var className = "logReadingModal " + classAddOn;
	
				return React.createElement(
					AltModal,
					{ className: className, open: this.props.open,
						headerText: "Log Reading", onHide: this.props.onClose },
					studentSelected,
					searchBook,
					dailyMinuteMaxMessage,
					bookLogs,
					React.createElement(
						"div",
						{ className: "modalAction" },
						logReadingButton,
						resetSearch
					)
				);
			}
		}]);
	
		return LogReadingModal;
	}(React.Component)) || _class);
	
	
	LogReadingModal.WrappedComponent.propTypes = StrictPropTypes({
		// Optionally, have a book to populate the books selected
		initialBook: PropTypes.object,
		studentsSelected: PropTypes.array,
		totalStudents: PropTypes.number,
		onBack: PropTypes.func,
		bookStatus: PropTypes.string,
	
		asAdmin: PropTypes.bool,
	
		onClose: PropTypes.func,
		open: PropTypes.bool,
	
		// handler from @connect
		createLogs: PropTypes.func
	});
	
	module.exports = LogReadingModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ICON_TYPE_MAP;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ZPDRange = __webpack_require__(176);
	var ReactTooltip = __webpack_require__(12);
	var ReadingLevelFormat = __webpack_require__(72);
	
	__webpack_require__(3733);
	
	var ReadingLevelIcon = function (_React$Component) {
		_inherits(ReadingLevelIcon, _React$Component);
	
		function ReadingLevelIcon(props) {
			_classCallCheck(this, ReadingLevelIcon);
	
			var _this = _possibleConstructorReturn(this, (ReadingLevelIcon.__proto__ || Object.getPrototypeOf(ReadingLevelIcon)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(ReadingLevelIcon, [{
			key: "getIconType",
			value: function getIconType() {
				if (this.props.status) {
					return this.props.status;
				}
				var status = ZPDRange.getTextStatus(this.props.textReadingLevel, this.props.studentReadingLevel);
	
				return ICON_TYPE_MAP[status];
			}
		}, {
			key: "getReadingLevelIcon",
			value: function getReadingLevelIcon() {
				var status = this.getIconType();
				return dynamicRequire("reading/reading-levels/" + status + ".png");
			}
		}, {
			key: "getFormattedReadingLevel",
			value: function getFormattedReadingLevel() {
				var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
				return ReadingLevelFormat.getScoreForFormat(this.props.textReadingLevel, readingLevelFormat);
			}
		}, {
			key: "render",
			value: function render() {
				var tooltipType = this.props.tooltipCopyType;
				var status = this.getIconType();
				if (!this.props.showImageOnly) {
					var divider = React.createElement("span", { className: "verticalDivider" });
					if (CurrentUser.isAdmin()) {
						var readingLevelValue = this.getFormattedReadingLevel();
					}
				}
				if (tooltipType == ReadingLevelIcon.COLLECTIVE_VIEW) {
					if (status == ReadingLevelIcon.HARD) {
						var tooltipText = "Books above reading level.";
					} else if (status == ReadingLevelIcon.ON_LEVEL) {
						var tooltipText = "Books at reading level.";
					} else {
						var tooltipText = "Books below reading level.";
					}
				} else if (tooltipType == ReadingLevelIcon.STUDENT_VIEW) {
					if (status == ReadingLevelIcon.HARD) {
						var tooltipText = "This book might be a challenge for you.";
					} else if (status == ReadingLevelIcon.ON_LEVEL) {
						var tooltipText = "This book is just right for you.";
					} else {
						var tooltipText = "This book might be too easy for you.";
					}
				} else {
					if (status == ReadingLevelIcon.HARD) {
						var tooltipText = "This book is above the student's reading level.";
					} else if (status == ReadingLevelIcon.ON_LEVEL) {
						var tooltipText = "This book is at the student's reading level.";
					} else {
						var tooltipText = "This book is below the student's reading level.";
					}
				}
				return React.createElement(
					"div",
					{ className: "readingLevelContainer" },
					divider,
					readingLevelValue,
					React.createElement("img", { className: "readingLevelImg", src: this.getReadingLevelIcon(), alt: "", "data-tip": tooltipText }),
					React.createElement(ReactTooltip, { effect: "solid", wrapper: "span" })
				);
			}
		}]);
	
		return ReadingLevelIcon;
	}(React.Component);
	
	ReadingLevelIcon.propTypes = StrictPropTypes({
		studentReadingLevel: PropTypes.number,
		textReadingLevel: PropTypes.number,
		tooltipCopyType: PropTypes.string,
		showImageOnly: PropTypes.bool,
	
		// Forces the component to use this status
		status: PropTypes.string
	});
	
	ReadingLevelIcon.EASY = "easy";
	ReadingLevelIcon.ON_LEVEL = "onlevel";
	ReadingLevelIcon.HARD = "hard";
	
	var ICON_TYPE_MAP = (_ICON_TYPE_MAP = {}, _defineProperty(_ICON_TYPE_MAP, ZPDRange.UNDER, ReadingLevelIcon.EASY), _defineProperty(_ICON_TYPE_MAP, ZPDRange.OVER, ReadingLevelIcon.HARD), _defineProperty(_ICON_TYPE_MAP, ZPDRange.AT, ReadingLevelIcon.ON_LEVEL), _ICON_TYPE_MAP);
	
	ReadingLevelIcon.COLLECTIVE_VIEW = "collective-view";
	ReadingLevelIcon.TEACHER_VIEW = "teacher-view";
	ReadingLevelIcon.STUDENT_VIEW = "student-view";
	
	module.exports = ReadingLevelIcon;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var OnboardingChecklistItem = __webpack_require__(894);
	var OnboardingProgressDisplay = __webpack_require__(895);
	var TeacherOnboarding = __webpack_require__(435);
	var WhooosReadingServices = __webpack_require__(25);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	
	__webpack_require__(3773);
	
	var OnboardingChecklist = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return { admin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }) };
	}, function (dispatch, props) {
		function populateData() {
			dispatch(RosterActions.fetchAdmins({ filters: { ids: [CurrentUser.get().id] },
				embeds: ['user.prefs,admin.org_ids,admin.survey_prompts'] }));
		}
		function updateAdmin(updateData) {
			dispatch(RosterActions.updateAdmin({ id: CurrentUser.get().id, update: updateData }));
		}
		return {
			populateData: populateData,
			updateAdmin: updateAdmin
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(OnboardingChecklist, _React$Component);
	
		function OnboardingChecklist(props) {
			_classCallCheck(this, OnboardingChecklist);
	
			var _this = _possibleConstructorReturn(this, (OnboardingChecklist.__proto__ || Object.getPrototypeOf(OnboardingChecklist)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(OnboardingChecklist, [{
			key: "isOnboardingComplete",
			value: function isOnboardingComplete() {
				if (!this.props.admin) {
					return true;
				} else {
					var onboardingData = this.props.admin.prefs.onboarding;
					return _underscore2.default.select(onboardingData, function (stepData, key) {
						return !stepData;
					}).length == 0;
				}
			}
		}, {
			key: "hideChecklist",
			value: function hideChecklist() {
				return !CurrentUser.isTeacherAdmin() || !this.props.admin || !this.props.admin.prefs;
			}
		}, {
			key: "completeOnboarding",
			value: function completeOnboarding() {
				window.wrNotifications.triggerDropDownNotification({
					title: "Now you are ready!", text: "Your students are in great hands.", icon: "ok-circle" });
			}
		}, {
			key: "triggerViewData",
			value: function triggerViewData() {
				this.trigger("view-data");
			}
		}, {
			key: "triggerCustomizeAssignments",
			value: function triggerCustomizeAssignments() {
				this.trigger("customize-assignments");
			}
		}, {
			key: "triggerSelectSchool",
			value: function triggerSelectSchool() {
				this.trigger("select-school");
			}
		}, {
			key: "triggerSelectStandards",
			value: function triggerSelectStandards() {
				this.trigger('select-standards');
			}
		}, {
			key: "triggerAddStudents",
			value: function triggerAddStudents() {
				this.trigger('add-students');
			}
		}, {
			key: "triggerAutograderDemo",
			value: function triggerAutograderDemo() {
				this.trigger('autograder-demo');
			}
		}, {
			key: "trigger",
			value: function trigger(step) {
				var onboarding = {};
				for (var key in this.props.admin.prefs.onboarding) {
					onboarding[key] = this.props.admin.prefs.onboarding[key];
				}
	
				if (!onboarding[step]) {
					onboarding[step] = true;
					this.updateUserOnboarding(onboarding);
	
					//Check to see if the checklist is finished
					for (var key in onboarding) {
						if (!onboarding[key]) {
							var moreItemsLeft = true;
						}
					}
					//if no more items, display the banner.
					if (!moreItemsLeft) {
						this.completeOnboarding();
					}
				}
			}
		}, {
			key: "skipIntroduction",
			value: function skipIntroduction() {
				var r = confirm("Skipping this introduction will permanently remove the tutorial steps from your account. Are you sure you want to skip the introduction?");
				if (r == true) {
					LuckyOrangeClient.tagComponent("skipChecklist");
					var onboarding = _underscore2.default.clone(this.props.admin.prefs.onboarding);
					_underscore2.default.each(onboarding, function (value, step) {
						onboarding[step] = true;
					});
					this.updateUserOnboarding(onboarding);
				}
			}
		}, {
			key: "simpleSkipIntroduction",
			value: function simpleSkipIntroduction() {
				var onboarding = _underscore2.default.clone(this.props.admin.prefs.onboarding);
				_underscore2.default.each(onboarding, function (value, step) {
					onboarding[step] = true;
				});
				this.updateUserOnboarding(onboarding);
				Mycroft.buildEventHandler({
					category: "Paywall", action: "start-silver-trial", label: this.props.featureType + "-paywall" });
			}
		}, {
			key: "updateUserOnboarding",
			value: function updateUserOnboarding(onboarding) {
				var new_data = {};
				new_data.prefs = _extends({}, this.props.admin.prefs, { onboarding: onboarding });
				this.props.updateAdmin(new_data);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.hideChecklist()) {
					return React.createElement("div", { className: "emptyOnboardingChecklist" });
				}
	
				var onboardingData = this.props.admin ? this.props.admin.prefs.onboarding : CurrentUser.get().prefs.onboarding;
	
				// if there are no incomplete steps, don't display the checklist
				// TODO: show success state and allow user to dismiss
	
				// CurrentUser.get().account.override_data.onboarding_trial
				if (this.isOnboardingComplete()) {
					return null;
				}
	
				var orderedKeys = TeacherOnboarding.getOrderedKeys();
				var completions = _underscore2.default.map(orderedKeys, function (itemKey, k) {
					return _underscore2.default.find(onboardingData, function (stepData, key) {
						return key == itemKey;
					});
				});
				// this.props.completed_quiz
				var quizzesCompleted = CurrentUser.get().completed_quiz_count >= 100;
				var nextIndex = completions.indexOf(false);
				var lasCompleteIndex = -1;
				var checklistItems = _underscore2.default.map(orderedKeys, function (itemKey, k) {
					var isComplete = completions[k];
					var isNext = k == nextIndex;
					if (itemKey == "complete-quizzes") {
						return React.createElement(OnboardingChecklistItem, { itemKey: itemKey, isComplete: quizzesCompleted, hideActionLink: true,
							isNext: isNext, key: itemKey });
					} else {
						return React.createElement(OnboardingChecklistItem, { itemKey: itemKey, isComplete: isComplete,
							isNext: isNext, key: itemKey });
					}
				});
	
				var completionsNoQuizzes = _underscore2.default.reject(completions, function (completion) {
					return completion == undefined;
				});
				completionsNoQuizzes.push(quizzesCompleted);
				var currentComplete = _underscore2.default.select(completionsNoQuizzes, function (completion) {
					return completion == true;
				}).length;
	
				var helpLink = React.createElement(
					"a",
					{ href: "https://www.whooosreading.org/help", target: "_blank" },
					"Visit Help Center"
				);
				var divider = React.createElement("div", { className: "verticalDivider" });
				// var percentage = parseInt(_.select(completions).length / parseFloat(completions.length) * 10) * 10
				// var completionStatus = (
				// 	<div className="completionStatus">
				// 		<div className="display">
				// 			<span className="percentage">
				// 				{ percentage }%
				// 			</span>
				// 		</div>
				// 	</div>
				// )
	
				return React.createElement(
					"div",
					{ className: "onboardingChecklist" },
					React.createElement(
						"div",
						{ className: "itemContainer" },
						React.createElement(
							"div",
							null,
							checklistItems
						)
					),
					React.createElement(
						"div",
						{ className: "text-center" },
						helpLink,
						divider,
						React.createElement(
							"a",
							{ className: "skipLink", onClick: this.skipIntroduction.bind(this) },
							"Skip Introduction"
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window.document).on("onboarding-trigger-view-data", this.triggerViewData.bind(this));
				$(window.document).on("onboarding-trigger-customize-assignments", this.triggerCustomizeAssignments.bind(this));
				$(window.document).on("onboarding-trigger-select-school", this.triggerSelectSchool.bind(this));
				$(window.document).on("onboarding-trigger-select-standards", this.triggerSelectStandards.bind(this));
				$(window.document).on("onboarding-trigger-add-students", this.triggerAddStudents.bind(this));
				if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
					$(window.document).on("onboarding-trigger-autograder-demo", this.triggerAutograderDemo.bind(this));
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("onboarding-trigger-view-data");
				$(window.document).off("onboarding-trigger-customize-assignments");
				$(window.document).off("onboarding-trigger-select-school");
				$(window.document).off("onboarding-trigger-select-standards");
				$(window.document).off("onboarding-trigger-add-students");
				if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
					$(window.document).off("onboarding-trigger-autograder-demo");
				}
			}
		}]);
	
		return OnboardingChecklist;
	}(React.Component)) || _class) || _class);
	
	
	OnboardingChecklist.propTypes = StrictPropTypes({
		completed_quiz_count: PropTypes.number
	});
	
	module.exports = OnboardingChecklist;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterActions = __webpack_require__(11);
	var ErrorDisplay = __webpack_require__(51);
	var LoadingButton = __webpack_require__(17);
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3787);
	
	var UpgradeTokenForm = (_dec = (0, _reactRedux.connect)(function () {
		return {};
	}, function (dispatch, props) {
		return {
			onSubmit: function onSubmit(upgradeCode) {
				var currentUserID = CurrentUser.get().id;
	
				return dispatch(RosterActions.updateAdmin({
					id: currentUserID,
					update: { account: { upgrade_code: upgradeCode } }
				}));
			},
			updateReferral: function updateReferral(referralCode) {
				var currentUserID = CurrentUser.get().id;
	
				return dispatch(RosterActions.updateAdmin({
					id: currentUserID,
					update: { referred_by: referralCode, features: 'wrGold' }
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(UpgradeTokenForm, _React$Component);
	
		function UpgradeTokenForm(props) {
			_classCallCheck(this, UpgradeTokenForm);
	
			var _this = _possibleConstructorReturn(this, (UpgradeTokenForm.__proto__ || Object.getPrototypeOf(UpgradeTokenForm)).call(this));
	
			autobind(_this);
			_this.state = {
				upgraded: false,
				showUpgradeCode: !props.requireToggle, upgradeCode: "", loading: false, referral: false
			};
	
			_this.errors = React.createRef();
			_this.field = React.createRef();
			return _this;
		}
	
		_createClass(UpgradeTokenForm, [{
			key: "toggleUpgradeCode",
			value: function toggleUpgradeCode(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.setState({ showUpgradeCode: !this.state.showUpgradeCode }, function () {
					$(_this2.field.current).focus();
				});
			}
			// display valid referral message
	
		}, {
			key: "validReferralCode",
			value: function validReferralCode() {
				LuckyOrangeClient.tagComponent("submitReferralCode");
				Mycroft.newEvent({ category: "Referrals", action: "onboarding-modal-referral" });
				this.setState({ referral: true });
				window.wrNotifications.triggerDropDownNotification({ title: "Referral submitted successfully!", icon: "ok-sign" });
				window.location.reload();
			}
		}, {
			key: "submitUpgradeOrReferralCode",
			value: function submitUpgradeOrReferralCode() {
				var _this3 = this;
	
				this.errors.current.reset();
	
				var code = this.state.upgradeCode.trim().toUpperCase();
				if (code.length == 0) {
					var errorText = "Enter an 8-digit upgrade code";
					this.errors.current.setError(errorText);
				} else if (code.length == 9 && !this.state.referral) {
					// test if referral code exists code
					// user can't submit 2 referral codes
					this.setState({ loading: true });
					this.props.updateReferral(this.state.upgradeCode.trim()).then(function (response) {
						var errors = response.admins[0].errors;
						_this3.setState({ loading: false });
						// display error or render success banner
						if (_.any(errors)) {
							_this3.errors.current.setErrors(errors);
						} else {
							_this3.validReferralCode();
						}
					});
				} else {
					this.setState({ loading: true });
					this.props.onSubmit(code).then(function (response) {
						var errors = response.admins[0].errors;
	
						if (_.any(errors)) {
							_this3.errors.current.setErrors(errors);
							_this3.setState({ loading: false });
						} else {
							window.wrNotifications.triggerDropDownNotification({
								title: "Matched!", icon: "ok-sign",
								text: "We found your code and are activating your account."
							});
	
							CurrentUser.fetchCurrentUserData(function () {
								if (_this3.props.updateInPlace) {
									_this3.setState({ loading: false, upgradeCode: "", upgraded: true });
								} else {
									if (_this3.props.requireToggle) {
										_this3.setState({ loading: false, upgradeCode: "", showUpgradeCode: false });
									} else {
										_this3.setState({ loading: false, upgradeCode: "" });
									}
									$wr.redirect("/");
								}
							});
						}
					});
				}
			}
		}, {
			key: "onKeyDown",
			value: function onKeyDown(e) {
				if (e.keyCode == 13 && !this.state.loading) {
					$wr.nope(e);
					this.submitUpgradeOrReferralCode();
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this4 = this;
	
				if (this.state.upgraded) {
					return React.createElement(
						"div",
						{ className: "upgradeTokenForm" },
						"Upgraded!"
					);
				} else if (this.state.showUpgradeCode) {
					if (this.state.loading) {
						var button = React.createElement(Spinner, { placeholder: true, scale: 0.8 });
					} else {
						if (this.props.showCompleteButton) {
							var submitText = "Complete Upgrade";
							var button = React.createElement(LoadingButton, { className: "btn buttonSuccess",
								onClick: this.submitUpgradeOrReferralCode, text: submitText,
								loading: !!(this.state.loading || this.props.loadingStudentLists) });
							var buttonArea = React.createElement(
								"div",
								{ className: "buttonArea" },
								button
							);
						} else if (this.state.upgradeCode) {
							var buttonArea = React.createElement(
								"button",
								{ className: "btn btn-link", onClick: this.submitUpgradeOrReferralCode },
								"Save"
							);
						}
					}
	
					return React.createElement(
						"div",
						{ className: "upgradeTokenForm" },
						React.createElement(ErrorDisplay, { ref: this.errors }),
						React.createElement(
							"div",
							{ className: "codeField" },
							React.createElement("input", { className: "form-control", value: this.state.upgradeCode,
								onKeyDown: this.onKeyDown,
								placeholder: "Code goes here", ref: this.field,
	
								onChange: function onChange(e) {
									return _this4.setState({ upgradeCode: e.target.value });
								} })
						),
						buttonArea
					);
				} else {
					return React.createElement(
						"div",
						{ className: "upgradeTokenForm" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.toggleUpgradeCode },
							"Have an activation code?"
						)
					);
				}
			}
		}]);
	
		return UpgradeTokenForm;
	}(React.Component)) || _class);
	
	
	UpgradeTokenForm.WrappedComponent.propTypes = StrictPropTypes({
		// From @connect
		onSubmit: PropTypes.func,
		updateReferral: PropTypes.func,
	
		requireToggle: PropTypes.bool,
		updateInPlace: PropTypes.bool
	
	});
	
	module.exports = UpgradeTokenForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityTile = __webpack_require__(944);
	var ResponseTile = __webpack_require__(992);
	var Spinner = __webpack_require__(9);
	var Masonry = __webpack_require__(627);
	
	__webpack_require__(655);
	
	var Board = function (_React$Component) {
		_inherits(Board, _React$Component);
	
		function Board(props) {
			_classCallCheck(this, Board);
	
			var _this = _possibleConstructorReturn(this, (Board.__proto__ || Object.getPrototypeOf(Board)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(Board, [{
			key: "render",
			value: function render() {
				if (this.props.type == Board.STUDENT_ACTIVITIES) {
					var tileContent = this.props.items.map(function (item) {
						return React.createElement(ActivityTile, { item: item, key: item.id, forStudents: true,
							onClick: this.props.onTileClick,
							hideAssignAction: true });
					}.bind(this));
				} else if (this.props.type == Board.TEACHER_ACTIVITIES) {
					var tileContent = this.props.items.map(function (item) {
						return React.createElement(ActivityTile, { item: item, key: item.id,
							onClick: this.props.onTileClick,
							onItemAssign: this.props.onItemAssign,
							previewParameters: this.props.previewParameters });
					}.bind(this));
				} else if (this.props.type == Board.TEACHER_RESPONSES) {
					var tileContent = this.props.items.map(function (item) {
						return React.createElement(ResponseTile, { response: item, key: item.id,
							userName: item.input_name,
							onRemove: this.props.onRemove,
							allowGrading: true, onClick: this.props.onTileClick });
					}.bind(this));
				}
	
				if (this.props.loading) {
					var spinner = React.createElement(Spinner, { scale: 1.7 });
				}
	
				var masonryOptions = { gutter: 15 };
	
				var className = "tileGridWrapper";
				if (this.props.narrowBoard) {
					className += " narrowGrid";
				}
	
				return React.createElement(
					"div",
					{ className: className, ref: "wrapper" },
					React.createElement(
						Masonry,
						{ updateOnEachImageLoad: true, options: masonryOptions, ref: "masonry" },
						tileContent
					),
					spinner
				);
			}
		}, {
			key: "checkScroll",
			value: function checkScroll() {
				if (!this.props.loading && this.props.onScrollToBottom) {
					var $wrapper = $(this.refs.wrapper);
					var threshold = 300;
					var lim = $wrapper.offset().top + $wrapper.height();
					var loc = $(window).scrollTop() + $(window).height();
					if (loc + threshold > lim) {
						this.props.onScrollToBottom();
					}
				}
			}
		}, {
			key: "refreshMasonry",
			value: function refreshMasonry() {
				this.refs.masonry.forceUpdate();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window).scroll(this.checkScroll);
				$(window).on("masonry-update", this.refreshMasonry);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.checkScroll);
				$(window).off("masonry-update");
			}
		}]);
	
		return Board;
	}(React.Component);
	
	;
	
	Board.STUDENT_NEWS_FEED = "StudentNewsFeed";
	Board.STUDENT_ACTIVITIES = "StudentActivities";
	Board.TEACHER_ACTIVITIES = "TeacherActivities";
	Board.CLASS_NEWS_FEED = "ClassNewsFeed";
	Board.TEACHER_RESPONSES = "TeacherResponses";
	
	Board.propTypes = StrictPropTypes({
		// What type of board this is
		type: PropTypes.string.isRequired,
	
		items: PropTypes.array.isRequired,
	
		// Show a spinner and block onEnd notices if this is true
		loading: PropTypes.bool,
	
		// Function to call once the user has scrolled to the bottom
		onScrollToBottom: PropTypes.func,
	
		// Function to call if a title is clicked on (passed on)
		onTileClick: PropTypes.func,
	
		// Function to call if a title is removed (passed on)
		onRemove: PropTypes.func,
	
		// Makes the board narrower
		narrowBoard: PropTypes.bool,
	
		/////// ActivityTile specific props ///////
		onItemAssign: PropTypes.func, // Call to assign and activity
		previewParameters: PropTypes.object, // Pass to ActivityTile
		hideAssignAction: PropTypes.bool
	});
	
	module.exports = Board;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var Glyphicon = __webpack_require__(8);
	var ButtonDropdownOption = __webpack_require__(31);
	
	__webpack_require__(3808);
	
	var ToggleMultiselect = function (_React$Component) {
		_inherits(ToggleMultiselect, _React$Component);
	
		function ToggleMultiselect(props) {
			_classCallCheck(this, ToggleMultiselect);
	
			var _this = _possibleConstructorReturn(this, (ToggleMultiselect.__proto__ || Object.getPrototypeOf(ToggleMultiselect)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ToggleMultiselect, [{
			key: "forToggleOfType",
			value: function forToggleOfType(type, key) {
				var config = this.props.toggles.find(function (x) {
					return (x.select || SELECT_LEFT_SHIFT_CLICK) === type;
				});
	
				if (config && key) {
					return config[key];
				}
				return config;
			}
		}, {
			key: "onOptionClick",
			value: function onOptionClick(e, selectedKey) {
				var clickType = void 0;
	
				if (e.button === 0) {
					if (e.shiftKey) {
						clickType = SELECT_LEFT_SHIFT_CLICK;
					} else {
						clickType = SELECT_LEFT_CLICK;
					}
				}
	
				var toggleKey = this.forToggleOfType(clickType, "key");
				var isSingleton = !!this.forToggleOfType(clickType, "singleton");
	
				if (toggleKey) {
					var newSelected = {};
	
					if (!this.props.selected || this.props.selected[selectedKey] !== toggleKey) {
	
						// See if there's a key already set to the singleton case
						var previousSingletonKey = void 0;
						if (isSingleton) {
							previousSingletonKey = _.findKey(this.props.selected, function (x) {
								return x === toggleKey;
							});
						}
	
						// Update selection (if possible)
						newSelected = _extends({}, this.props.selected, _defineProperty({}, selectedKey, toggleKey));
						if (previousSingletonKey) {
							newSelected = _.omit(newSelected, previousSingletonKey);
						}
					} else {
						newSelected = _.omit(this.props.selected, selectedKey);
					}
	
					// Confirm the selection is valid (there's at exactly one of each singleton)
					var isValid = true;
					_.each(this.props.toggles, function (config) {
						if (config.singleton) {
							isValid = isValid && _.values(newSelected).filter(function (x) {
								return x === config.key;
							}).length === 1;
						}
					});
	
					if (isValid) {
						this.props.onChange(newSelected);
					}
				}
			}
		}, {
			key: "displayText",
			value: function displayText() {
				var _this2 = this;
	
				var primaryText;
				var otherTexts = [];
	
				_.each(this.props.toggles, function (config) {
					_.each(_this2.props.options, function (_ref) {
						var key = _ref.key,
						    text = _ref.text;
	
						if (_this2.props.selected[key] === config.key) {
							if (config.primary) {
								primaryText = text;
							} else {
								otherTexts.push(text);
							}
						}
					});
				});
	
				if (!primaryText) {
					primaryText = otherTexts.shift();
				}
	
				if (primaryText) {
					if (otherTexts.length) {
						return primaryText + " (+" + $wr.pluralizeWithNumber("other", otherTexts.length) + ")";
					} else {
						return primaryText;
					}
				} else if (this.props.defaultDisplayText) {
					return this.props.defaultDisplayText;
				} else {
					return "Select";
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var className = "toggleMultiselect";
				if (this.props.className) {
					className += " " + this.props.className;
				}
	
				var options = this.props.options.map(function (x) {
					var icon = void 0;
					if (_this3.props.selected[x.key]) {
						var iconKey = _.findWhere(_this3.props.toggles, { key: _this3.props.selected[x.key] }).icon;
						if (_this3.props.selected[x.key] === 'primary' || _this3.props.selected[x.key] === 'secondary') {
							var iconDataTip = $wr.capitalize(_this3.props.selected[x.key]);
							icon = React.createElement(Glyphicon, { icon: iconKey, className: "selectedIcon", dataTip: iconDataTip });
						} else {
							icon = React.createElement(Glyphicon, { icon: iconKey, className: "selectedIcon" });
						}
					} else {
						icon = React.createElement("span", { className: "selectedIconPlaceholder" });
					}
					return React.createElement(
						ButtonDropdownOption,
						{ key: x.key,
							onClick: function onClick(e) {
								return _this3.onOptionClick(e, x.key);
							} },
						icon,
						" ",
						x.text
					);
				});
	
				if (this.props.topContent) {
					var topSection = React.createElement(
						"div",
						{ className: "topContent" },
						this.props.topContent
					);
				}
	
				return React.createElement(
					"div",
					{ className: className },
					React.createElement(
						ButtonDropdown,
						{ stickyOpen: true, dropdownDisplay: this.props.dropdownDisplay,
							text: React.createElement(
								"span",
								{ className: "innerText" },
								this.displayText()
							) },
						topSection,
						options
					)
				);
			}
		}]);
	
		return ToggleMultiselect;
	}(React.Component);
	
	;
	
	var SELECT_LEFT_CLICK = "select-left-click";
	var SELECT_LEFT_SHIFT_CLICK = "select-left-shift-click";
	// Could also do right click, alt click, etc.
	
	ToggleMultiselect.SELECT_LEFT_CLICK = SELECT_LEFT_CLICK;
	ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK = SELECT_LEFT_SHIFT_CLICK;
	
	ToggleMultiselect.propTypes = StrictPropTypes({
		dropdownDisplay: PropTypes.string,
		className: PropTypes.string,
		defaultDisplayText: PropTypes.string,
	
		topContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
	
		// Object of option keys => toggle keys
		selected: PropTypes.object.isRequired,
	
		// Array of { key: "...", text: "..." }
		options: PropTypes.array.isRequired,
	
		// Array of { key: "...", icon: "...", text: "..." }
		//  optional: singleton (clears others with this type before selection; should always be one)
		//  optional: primary (affects displayText)
		//  optional: select (see SELECT options, left is LEFT)
		toggles: PropTypes.array.isRequired,
	
		// Function that gets passed a new version of the selected object
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = ToggleMultiselect;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageIcon = __webpack_require__(102);
	var Spinner = __webpack_require__(9);
	var TextToSpeech = __webpack_require__(1008);
	var SpeechToText = __webpack_require__(1007);
	var TextTypes = __webpack_require__(38);
	var Formats = __webpack_require__(105);
	var CurrentUser = __webpack_require__(3);
	var NameLookup = __webpack_require__(253);
	
	__webpack_require__(3821);
	
	var Activity = function (_React$Component) {
		_inherits(Activity, _React$Component);
	
		function Activity(props) {
			_classCallCheck(this, Activity);
	
			var _this = _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).call(this));
	
			autobind(_this);
	
			_this.state = {
				nodeData: null, openBookPicker: true, bookSelectF: null, phase: null
			};
			return _this;
		}
	
		_createClass(Activity, [{
			key: "onBookSelect",
			value: function onBookSelect(bookData) {
				if (this.state.bookSelectF) {
					this.state.bookSelectF(bookData);
				}
			}
		}, {
			key: "nodeToReact",
			value: function nodeToReact(nodeData, index) {
				nodeData = _.clone(nodeData);
				if (nodeData == null) {
					throw "Empty node";
				}
				if (nodeData.tag == undefined) {
					throw "No tag specified in: " + JSON.stringify(nodeData);
				}
	
				var nodeProps = _.clone(nodeData.attributes) || {};
	
				if (nodeProps["style"]) {
					var mappedStyle = {};
					_.each(nodeProps["style"], function (value, key) {
						// Thanks @rfw http://stackoverflow.com/a/6661012/4557470
						var newKey = key.replace(/-([a-z])/g, function (g) {
							return g[1].toUpperCase();
						});
						mappedStyle[newKey] = value;
					});
					nodeProps["style"] = mappedStyle;
				}
	
				function mapAttribute(fromAttr, toAttr) {
					if (nodeProps[fromAttr] != undefined) {
						nodeProps[toAttr] = nodeProps[fromAttr];
					}
					// It might have been undefined, so delete it anyway
					delete nodeProps[fromAttr];
				}
	
				mapAttribute("class", "className");
				mapAttribute("for", "htmlFor");
	
				delete nodeProps["noWrap"];
	
				var nodeAttr = nodeData.attributes || {};
				if (nodeData.tag == "input" && nodeAttr.value || nodeData.tag == "textarea" && nodeData.text) {
	
					if (nodeData.tag == "input") {
						var defaultText = nodeAttr.value;
						delete nodeProps.value;
					} else {
						var defaultText = nodeData.text;
						delete nodeData.text;
					}
	
					if (!this.isCollaboration() || _.include(this.getRoleRefIDs(), nodeAttr.name)) {
						// In all cases except collaboration areas which don't belong to us
						nodeProps.defaultValue = defaultText;
					} else {
						nodeProps.value = defaultText;
						nodeProps.readOnly = true;
					}
				}
	
				if (nodeData.text != undefined) {
					nodeProps.children = nodeData.text;
				} else if (nodeData.children && nodeData.children.length > 0) {
	
					var children = nodeData.children.map(function (childData, index) {
						return this.nodeToReact(childData, index);
					}.bind(this));
	
					nodeProps.children = children;
				}
	
				// These are the only supported html types
				//    There may be a cleaner way to do this but I don't know it
				switch (nodeData.tag) {
					case "a":
						return React.createElement("a", nodeProps);
					case "button":
						return React.createElement("button", nodeProps);
					case "br":
						return React.createElement("br", nodeProps);
					case "canvas":
						return React.createElement("canvas", nodeProps);
					case "div":
						return React.createElement("div", nodeProps);
					case "em":
						return React.createElement("em", nodeProps);
					case "header":
						return React.createElement("header", nodeProps);
					case "h1":
						return React.createElement("h1", nodeProps);
					case "h2":
						return React.createElement("h2", nodeProps);
					case "h3":
						return React.createElement("h3", nodeProps);
					case "img":
						return React.createElement("img", nodeProps);
					case "input":
						return React.createElement("input", nodeProps);
					case "label":
						return React.createElement("label", nodeProps);
					case "li":
						return React.createElement("li", nodeProps);
					case "option":
						return React.createElement("option", nodeProps);
					case "p":
						return React.createElement("p", nodeProps);
					case "select":
						return React.createElement("select", nodeProps);
					case "span":
						return React.createElement("span", nodeProps);
					case "strong":
						return React.createElement("strong", nodeProps);
					case "textarea":
						return React.createElement("textarea", nodeProps);
					case "ul":
						return React.createElement("ul", nodeProps);
					default:
						throw "Unsupported activity tag: " + nodeData.tag;
	
				}
			}
		}, {
			key: "render",
			value: function render() {
				var activityClassName = "activityBox";
	
				if (this.state.nodeData == null) {
					var activityContent = undefined;
				} else {
	
					if (this.props.book && this.props.book.title) {
						var bookText = React.createElement(
							"h3",
							{ className: "textTitle onQuestionSelect" },
							this.props.book.title
						);
	
						activityClassName += " bookTitlePostionHack";
					}
	
					var activityContent = React.createElement(
						"div",
						{ key: this.state.phase },
						this.nodeToReact(this.state.nodeData)
					);
				}
	
				return React.createElement(
					"div",
					{ ref: "activityBox", className: activityClassName },
					React.createElement("link", { href: "https://fonts.googleapis.com/css?family=Didact+Gothic", rel: "stylesheet" }),
					bookText,
					activityContent
				);
			}
		}, {
			key: "isCollaboration",
			value: function isCollaboration() {
				return Formats.isCollaboration(this.props.activity.format.format_class);
			}
		}, {
			key: "isDraft",
			value: function isDraft() {
				return this.props.response && this.props.response.draft;
			}
		}, {
			key: "getRoleRefIDs",
			value: function getRoleRefIDs() {
				var currentRole = this.getCollaborationRole();
				var rolePhases = _.where(this.props.activity.format.phase_list, { role: currentRole });
	
				return $wr.findAllValues(rolePhases, "ref_id");
			}
		}, {
			key: "getCollaborationRole",
			value: function getCollaborationRole() {
				if (this.isDraft() && this.props.response.input_data) {
					var userID = CurrentUser.get().id;
					var roleList = JSON.parse(this.props.response.input_data["__wr_role_map"]);
	
					return _.findKey(roleList, _.partial(_.isEqual, userID));
				}
			}
		}, {
			key: "initAlbusActivity",
			value: function initAlbusActivity() {
				var updateActivity = function (albusStateData) {
					var nodeData = Albus.Builder.build(this.props.activity, albusStateData);
					this.setState({ nodeData: nodeData, phase: albusStateData.currentPhase });
				}.bind(this);
	
				var stateData = {};
				if (this.isDraft()) {
					stateData["draft"] = this.props.response;
				}
	
				if (this.isCollaboration()) {
					stateData["currentRole"] = this.getCollaborationRole();
				}
	
				var nodeData = Albus.Builder.build(this.props.activity, stateData);
	
				this.setState({ nodeData: nodeData }, function () {
					Albus.Behavior.init(this.refs.activityBox, updateActivity, stateData);
				}.bind(this));
				$(this.refs.activityBox).on(Albus.Behavior.SUBMIT, function (e, responseData) {
					if (this.props.onSubmit) {
						this.props.onSubmit(responseData);
					}
				}.bind(this));
			}
		}, {
			key: "updateAlbusActivity",
			value: function updateAlbusActivity(activity) {
				var albusStateData = {};
	
				if (this.isDraft()) {
					albusStateData.draft = this.props.response;
				} else {
					albusStateData.response = this.props.response;
				}
	
				if (this.isCollaboration()) {
					albusStateData["currentRole"] = this.getCollaborationRole();
					albusStateData["collaborativeActivityStudentMap"] = this.state.collaborativeActivityStudentMap;
	
					if (albusStateData.response) {
						albusStateData.response = _.extend({}, albusStateData.response, { collaborativeActivityStudentMap: this.state.collaborativeActivityStudentMap });
					}
				}
	
				var nodeData = Albus.Builder.build(activity, albusStateData);
				this.setState({ nodeData: nodeData }, function () {
					var $lockedCanvases = $(this.refs.activityBox).find(".nonRolePhase").find(".albus-canvas");
					$lockedCanvases.trigger("albus-canvas-reload-draft");
				});
			}
		}, {
			key: "initAlbusResponse",
			value: function initAlbusResponse() {
				var stateData = { response: this.props.response };
				var nodeData = Albus.Builder.build(this.props.activity, stateData);
				this.setState({ nodeData: nodeData }, function () {
					Albus.Behavior.init(this.refs.activityBox);
				}.bind(this));
			}
		}, {
			key: "initAlbus",
			value: function initAlbus() {
				if (this.isDraft() || this.props.response == null) {
					this.initAlbusActivity();
				} else {
					this.initAlbusResponse();
				}
			}
	
			// autoSaveActivity() {
			// 	var newData = $(this.refs.activityBox).find(".albus-activity").data("auto-save")();
			// 	if (this.checkIfModified(newData.input_data) && this.checkIfBookPresent()) {
			// 		//auto-save
			// 		var autoSavedData = _.clone(this.state.autoSavedData)
			// 		Object.keys(newData.input_data).forEach(function(key) {
			// 			autoSavedData[key] = newData.input_data[key]
			// 		})
			// 		newData.input_data = autoSavedData;
	
			// 		if (this.isCollaboration()) {
			// 			this.props.onAutoSave(newData, { update_ref_ids: this.getRoleRefIDs(), updateDraft: true });
	
			// 		} else {
			// 			this.props.onAutoSave(newData);
			// 		}
	
			// 		this.setState({ autoSavedData: autoSavedData, showAutoSaving: true });
	
			// 		setTimeout(function() {
			// 			this.setState({ showAutoSaving: false });
			// 		}.bind(this), 1000);
	
			// 	} else if (this.isCollaboration() && !$wr.isInactive(40)) {
			// 		this.props.updateDraft();
			// 	}
			// }
	
	
			// checkIfModified(input_data) {
			// 	var previous_input_data = this.state.autoSavedData
	
			// 	var refIDs = Object.keys(input_data);
			// 	if (this.isCollaboration()) {
			// 		refIDs = _.intersection(refIDs, this.getRoleRefIDs());
			// 	}
	
			// 	var modified = refIDs.some(function(ref_id) {
			// 	    var newValue = input_data[ref_id]
			// 	    var previousValue = previous_input_data[ref_id]
			// 	    if (newValue != previousValue) {
			// 	    	modified = true;
			// 	    	return true
			// 	    }
			// 	})
			// 	return modified
			// }
	
		}, {
			key: "getAutosaveData",
			value: function getAutosaveData() {
				var $activity = $(this.refs.activityBox).find(".albus-activity");
				if ($activity.length == 0) {
					return { input_data: {}, activity_data: {} };
				} else {
					return $activity.data("auto-save")();
				}
			}
		}, {
			key: "getAutosaveHash",
			value: function getAutosaveHash() {
				var inputData = this.getAutosaveData().input_data;
	
				var refIDs = _.keys(inputData);
				if (this.isCollaboration()) {
					refIDs = _.intersection(refIDs, this.getRoleRefIDs());
				}
	
				var hashString = _.map(refIDs, function (refID) {
					return "refID: " + refID + "val: " + JSON.stringify(inputData[refID]);
				}.bind(this)).join(" - ");
	
				return $wr.hashCode(hashString);
			}
		}, {
			key: "initTextToSpeech",
			value: function initTextToSpeech() {
				var $wrap = $(this.refs.activityBox);
				var $labels = $wrap.find("label .innerLabel, .albus-instructions");
				$wrap.find(".pastPhase .textToSpeechButton").remove();
	
				$labels.each(function (i, el) {
					var $el = $(el);
					if ($el.closest(".albus-DragDropStructure").length > 0 || $el.data("t2s")) {
						return;
					}
					$el.data("t2s", true);
	
					var actionId = "t2s-text" + i;
					var imgSrc = __webpack_require__(297);
					var $img = $("<img id='" + actionId + "' class='textToSpeechButton' src='" + imgSrc + "' />");
	
					$el.append($img);
	
					var position = $el.position();
					var leftPos = position.left + $el.width() + 35;
	
					$el.addClass('textToSpeechContainer');
	
					// check to make sure it won't be placed too far right and get cut off
					if ($el.closest(".albus-absoluteBox").length > 0) {
						var baseElementLeft = $el.closest("label").position().left;
						var totalWidth = $el.closest(".albus-absoluteBox").width();
						var topPos = position.top;
						var maxLeft = totalWidth - baseElementLeft - 25;
					} else {
						var baseElementLeft = 0;
						var totalWidth = $el.closest(".textToSpeechContainer").width();
						var topPos = 0;
						var maxLeft = totalWidth - baseElementLeft;
					}
					if (leftPos > maxLeft) {
						leftPos = maxLeft;
					}
	
					$img.css("left", leftPos);
					$img.css("top", topPos);
	
					var voice = TextToSpeech.initVoice($el.text());
					$el.find(".textToSpeechButton").on('click', function () {
						if (speechSynthesis.speaking) {
							speechSynthesis.cancel();
						} else {
							speechSynthesis.speak(voice);
						}
					});
				});
			}
		}, {
			key: "initSpeechToText",
			value: function initSpeechToText() {
				var $wrap = $(this.refs.activityBox);
				$wrap.find(".pastPhase .speechToTextButton").remove();
	
				$wrap.find('textarea, input[type=text]').each(function (i, el) {
					var $el = $(el);
					if ($el.data("t2s")) {
						return;
					}
					$el.data("t2s", true);
	
					var actionId = "s2t-textarea-" + i;
					$el.parent().addClass('textToSpeechContainer');
	
					var imgSrc = __webpack_require__(185);
					var $img = $("<img id='" + actionId + "' class='speechToTextButton' src='" + imgSrc + "' />");
	
					$el.after($img);
	
					var position = $el.position();
					var leftPos = position.left + $el.width() + 35;
	
					// check to make sure it won't be placed too far right and get cut off
					if ($el.closest(".albus-absoluteBox").length > 0) {
						var maxLeft = $el.closest(".albus-absoluteBox").width() - 20;
						if (leftPos > maxLeft) {
							leftPos = maxLeft;
						}
					}
	
					$img.css("left", leftPos);
					$img.css("top", position.top);
	
					$img.on('click', function () {
						SpeechToText.trigger(el, actionId);
					});
				});
			}
		}, {
			key: "disableScrollOnCanvas",
			value: function disableScrollOnCanvas() {
				console.log("DISABLE SCROLL ON CANVAS");
				try {
					_.each($("canvas"), function (canvas) {
						console.log("DISABLING FOR ", canvas);
						canvas.addEventListener("touchstart", function (event) {
							event.preventDefault();
						});
						canvas.addEventListener("touchmove", function (event) {
							event.preventDefault();
						});
						canvas.addEventListener("touchend", function (event) {
							event.preventDefault();
						});
						canvas.addEventListener("touchcancel", function (event) {
							event.preventDefault();
						});
					});
				} catch (error) {
					console.log(error);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				var sources = [{ "ref": "start_recording", "path": "speech-to-text/start_recording", "play": false }, { "ref": "end_recording", "path": "speech-to-text/end_recording", "play": false }];
				window.wrL2eSound.addSource(sources, "speech_control");
	
				$wr.loadScript("/dependencies/albus.min.js", "Albus", function () {
					var checkDependencies = function checkDependencies() {
						if (Albus.Dependencies.Fabric && Albus.Dependencies.Recorder && !_this2.state.nodeData) {
							_this2.initAlbus();
						}
					};
	
					$wr.loadScript("/dependencies/fabric.min.js", "Fabric", function () {
						Albus.Dependencies.Fabric = window.fabric;
						checkDependencies();
					});
	
					$wr.loadScript("/dependencies/recorder.js", "Recorder", function () {
						Albus.Dependencies.Recorder = window.Recorder;
						checkDependencies();
					});
	
					// Just for review
					Albus.alternateBookPicker = function (callback) {
						var selectF = function (bookData) {
							this.refs.bookPickerModal.hide();
							callback(bookData);
						}.bind(this);
	
						this.setState({ bookSelectF: selectF });
						this.refs.bookPickerModal.show();
					}.bind(_this2);
	
					if ('webkitSpeechRecognition' in window) {
						SpeechToText.init();
					}
	
					if (_this2.isCollaboration()) {
						var roleMap = JSON.parse(_this2.props.response.input_data["__wr_role_map"]);
	
						NameLookup.translateMap(roleMap, function (studentHash) {
							this.setState({ collaborativeActivityStudentMap: studentHash }, function () {
								this.updateAlbusActivity(this.props.activity);
							}.bind(this));
						}.bind(_this2));
					}
				});
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				// Deal with modals not resizing
				// Hacky, hacky, HAAAACCCCCKYYYY
				for (var i = 0; i < 5; i++) {
					setTimeout(function () {
						$(window).trigger("resize");
					}, i * 1000);
				}
	
				if ('webkitSpeechRecognition' in window) {
					setTimeout(function () {
						this.initTextToSpeech();
						this.initSpeechToText();
					}.bind(this), 1000);
				}
				this.disableScrollOnCanvas();
			}
		}, {
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps(nextProps) {
				window.wrL2eSound.removeSources('speech_control');
				if (this.isCollaboration() && nextProps.response != this.props.response) {
					this.updateAlbusActivity(nextProps.activity);
				}
			}
		}]);
	
		return Activity;
	}(React.Component);
	
	;
	
	Activity.propTypes = StrictPropTypes({
		// Data on the activity. Details handled by Albus library
		activity: PropTypes.object.isRequired,
	
		// Data on the response (may be a draft). Details handled by Albus library
		response: PropTypes.object,
	
		// Book loaded dynamically (during activity completion only)
		book: PropTypes.object,
	
		// Function to call when the activity has been submitted
		onSubmit: PropTypes.func
	});
	
	module.exports = Activity;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	var QuestionTypes = __webpack_require__(82);
	var DataRouting = __webpack_require__(36);
	
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var MultiPartAnswerDisplay = __webpack_require__(172);
	var MultiPartSentenceStarter = __webpack_require__(197);
	var BookDisplay = __webpack_require__(46);
	var CoinsEarnedDisplay = __webpack_require__(193);
	var Glyphicon = __webpack_require__(8);
	var StudentDisplay = __webpack_require__(52);
	var ScoreDisplay = __webpack_require__(103);
	var DisplayToggleControl = __webpack_require__(48);
	var EditControls = __webpack_require__(427);
	var AnalysisControls = __webpack_require__(956);
	var FeedbackControls = __webpack_require__(957);
	
	var AnswerScoringDetails = __webpack_require__(953);
	
	var CommentBox = __webpack_require__(119);
	var ReactTooltip = __webpack_require__(12);
	
	var Skillsets = __webpack_require__(55);
	var RosterSelectors = __webpack_require__(6);
	
	var UIActions = __webpack_require__(41);
	var WritingActions = __webpack_require__(24);
	
	__webpack_require__(657);
	
	var AnswerDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var answer = WritingSelectors.answer({ state: state, id: props.answerID });
		var passProps = {
			answer: answer
		};
	
		if (answer) {
			passProps.question = WritingSelectors.question({ state: state, id: answer.question_id });
			var student = RosterSelectors.student({ state: state, id: answer.user_id });
	
			if (answer.evaluation) {
				var evaluation = WritingSelectors.evaluation({ state: state, id: answer.evaluation });
				if (evaluation) {
					passProps.evaluation = evaluation;
				}
			}
		}
	
		if (student) {
			passProps.studentReadingLevel = student.current_reading_level;
		}
	
		passProps.blockComments = !Features.isEnabled(Features.TEACHER_COMMENTS);
		return passProps;
	}, function (dispatch, props) {
		return {
			// fetches autograder data
			fetchEvaluations: function fetchEvaluations(answerID) {
				dispatch(WritingActions.fetchEvaluations({
					filters: { subject_type: 'Answer', subject_id: answerID },
					embeds: ["evaluation.autograder_data", "evaluation.score_details"]
				}));
			},
			updateEvaluation: function updateEvaluation(evaluationID, update) {
				dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: update }));
			},
			skipRevision: function skipRevision() {
				return dispatch(WritingActions.updateAnswer({
					id: props.answerID, update: { allow_revision: false }, query: { skip: true }
				})).then(function () {
					CurrentUser.fetchCurrentUserCoinData();
				});
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AnswerDisplay, _React$Component);
	
		function AnswerDisplay(props) {
			_classCallCheck(this, AnswerDisplay);
	
			var _this = _possibleConstructorReturn(this, (AnswerDisplay.__proto__ || Object.getPrototypeOf(AnswerDisplay)).call(this));
	
			autobind(_this);
			_this.state = {
				controlMode: props.controlMode ? props.controlMode : null
			};
			return _this;
		}
	
		_createClass(AnswerDisplay, [{
			key: "handleExcludedPunctuation",
			value: function handleExcludedPunctuation(answerString, command) {
				var loopCount = 0;
				var returnString = _.clone(answerString);
				_.each(EXCLUDED_PUNCTUATION, function (punct) {
					loopCount += 1;
					if (command === 'add-spaces') {
						returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(punct, ' ' + punct) : returnString.replaceAll(punct, punct + ' ');
					} else if (command === 'remove-spaces') {
						returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(' ' + punct, punct) : returnString.replaceAll(punct + ' ', punct);
					}
				});
				if (loopCount === _.size(EXCLUDED_PUNCTUATION)) {
					return returnString;
				}
			}
		}, {
			key: "controlMode",
			value: function controlMode() {
				return this.state.controlMode;
			}
		}, {
			key: "onModeChange",
			value: function onModeChange(controlMode) {
				var _this2 = this;
	
				this.setState({ controlMode: controlMode }, function () {
					var _props = _this2.props,
					    evaluation = _props.evaluation,
					    answer = _props.answer;
	
					if (controlMode == ANALYSIS_CONTROLS || controlMode == EDIT_CONTROLS) {
						_this2.updateEvaluationAsViewed();
						// fetches autograder data
						if (answer.id && (!evaluation || !evaluation.autograder_data) && !CurrentUser.isStudent()) {
							_this2.props.fetchEvaluations(answer.id);
						}
					}
				});
	
				setTimeout($wr.triggerResize, 400);
	
				if (this.props.onModeChange) {
					this.props.onModeChange(controlMode);
				}
			}
		}, {
			key: "closeControl",
			value: function closeControl(e) {
				if (this.props.onCloseControl) {
					this.props.onCloseControl(e);
				} else {
					$wr.nope(e);
					this.setState({ controlMode: null });
				}
			}
	
			// Updates evaluation as viewed
	
		}, {
			key: "updateEvaluationAsViewed",
			value: function updateEvaluationAsViewed() {
				var evaluation = this.props.evaluation;
				var controlMode = this.state.controlMode;
	
	
				if (evaluation && !evaluation.viewed && (controlMode == ANALYSIS_CONTROLS || controlMode == EDIT_CONTROLS) && !CurrentUser.isStudent()) {
					this.props.updateEvaluation(evaluation.id, { viewed: true });
				}
			}
		}, {
			key: "onSkipRevision",
			value: function onSkipRevision() {
				if (confirm("Are you sure?")) {
					this.props.skipRevision();
				}
			}
		}, {
			key: "isReview",
			value: function isReview() {
				return this.props.answer.question_type == QuestionTypes.REVIEW_QUESTION;
			}
		}, {
			key: "isFillInTheBlank",
			value: function isFillInTheBlank() {
				return this.props.answer.question_type == "fill-in-the-blank-question";
			}
		}, {
			key: "isMetaCognitive",
			value: function isMetaCognitive() {
				return this.props.answer.question_type == QuestionTypes.META_COGNITIVE_QUESTION;
			}
		}, {
			key: "displayScore",
			value: function displayScore() {
				return !this.isMetaCognitive() && !this.isReview();
			}
		}, {
			key: "toggleEdit",
			value: function toggleEdit() {
				this.props.onEditEvaluation();
			}
		}, {
			key: "noun",
			value: function noun() {
				if (this.isReview()) {
					return "review";
				} else if (this.isMetaCognitive()) {
					return 'question builder';
				} else {
					return "answer";
				}
			}
		}, {
			key: "resumePath",
			value: function resumePath() {
				var answer = this.props.answer;
	
				if (this.isReview()) {
					return "/reviews/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
				} else if (this.isMetaCognitive()) {
					return "/question_builder/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
				} else {
					return "/answers/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
				}
			}
		}, {
			key: "answerKeyActive",
			value: function answerKeyActive() {
				return !!((this.props.enabled.answerKey || this.controlMode() === ANALYSIS_CONTROLS) && this.isFillInTheBlank() && this.props.question && this.props.question.answer_options);
			}
		}, {
			key: "renderAnswerKey",
			value: function renderAnswerKey() {
				var textPart = _.findWhere(this.props.answer.parts, { type: MultiPartSentenceStarter.BODY });
	
				if (textPart && textPart["match"] !== undefined) {
					if (textPart["match"] == 1) {
						var statusDisplay = React.createElement(
							"span",
							{ className: "matchStatus correct" },
							React.createElement(Glyphicon, { icon: "ok" }),
							" Correct"
						);
					} else {
						var statusDisplay = React.createElement(
							"span",
							{ className: "matchStatus incorrect" },
							React.createElement(Glyphicon, { icon: "remove" }),
							" Incorrect"
						);
					}
	
					if (this.props.question) {
						var keyOptions = React.createElement(
							"span",
							null,
							"Answer Key: ",
							this.props.question.answer_options.join(", ")
						);
					}
	
					return React.createElement(
						"div",
						{ className: "answerKey" },
						statusDisplay,
						keyOptions
					);
				}
			}
		}, {
			key: "renderFirstRow",
			value: function renderFirstRow() {
				var _props2 = this.props,
				    enabled = _props2.enabled,
				    answer = _props2.answer;
	
	
				if (enabled.student) {
					var studentDisplay = React.createElement(StudentDisplay, { studentID: answer.user_id, showAvatar: true, avatarMaxWidth: 40 });
				}
	
				if (enabled.date) {
					var dateDisplay = React.createElement(
						"div",
						{ className: "date" },
						$wr.formatDateTime(answer.completed_at, "show-past-years")
					);
				}
	
				if (answer.quiz_id && enabled.linkToQuiz) {
					var quizPath = DataRouting.getPath({
						subjectType: DataRouting.SUBJECT_QUIZZES,
						textID: answer.text_id,
						userIDs: [answer.user_id]
					});
	
					var quizLink = React.createElement(
						_reactRouterDom.Link,
						{ to: quizPath, className: "hideOnPrint linkToQuiz",
							onClick: function onClick() {
								return $wr.setWindowY(0);
							},
							"data-tip": true, "data-for": "quizLink" },
						React.createElement(Glyphicon, { icon: "link" }),
						React.createElement(
							ReactTooltip,
							{ effect: "solid", id: "quizLink" },
							React.createElement(
								"span",
								null,
								"This answer is part of a quiz. Click to view the quiz."
							)
						)
					);
				}
	
				if (enabled.score && !answer.quiz_id && this.displayScore()) {
					var scoreDisplay = React.createElement(ScoreDisplay, { showDenominator: true, subjectID: answer.id,
						subjectType: "Answer", mode: ScoreDisplay.CIRCLE_MODE });
				}
	
				if (answer.draft) {
					var draftText = React.createElement(
						"span",
						null,
						"This ",
						this.noun(),
						" isn't done. ",
						React.createElement(
							_reactRouterDom.Link,
							{ className: "finishAnswer", to: this.resumePath() },
							"Finish ",
							this.noun()
						),
						"!"
					);
				}
	
				if ((enabled.startRevision || enabled.cancelRevision) && answer.allow_revision) {
					if (enabled.startRevision) {
						var goToRevision = React.createElement(
							_reactRouterDom.Link,
							{ className: "btn buttonPrimary revisionButton", to: this.resumePath() },
							"Start Revision"
						);
					}
	
					if (enabled.cancelRevision) {
						var cancelRevision = React.createElement(
							"button",
							{ className: "btn btn-default revisionButton",
								onClick: this.onSkipRevision },
							"Skip"
						);
					}
	
					var revisionButtons = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Your teacher will let you revise this answer."
						),
						goToRevision,
						cancelRevision
					);
				}
	
				var displayPresentClass = enabled.bookDisplayPresent ? '' : 'noBookDisplay';
	
				if (draftText || studentDisplay || dateDisplay || scoreDisplay || quizLink) {
					return React.createElement(
						"div",
						{ className: "answerDisplayRow topRow clearfix " + displayPresentClass },
						React.createElement(
							"div",
							{ className: "pull-left" },
							revisionButtons,
							studentDisplay,
							draftText
						),
						React.createElement(
							"div",
							{ className: "pull-right" },
							dateDisplay,
							scoreDisplay,
							quizLink
						)
					);
				}
			}
		}, {
			key: "renderSecondRow",
			value: function renderSecondRow() {
				var _props3 = this.props,
				    enabled = _props3.enabled,
				    answer = _props3.answer;
	
	
				if (enabled.textTitle) {
					var bookDisplay = React.createElement(BookDisplay, { inline: true, textID: answer.text_id,
						showReadingLevel: enabled.readingLevel,
						studentReadingLevel: this.props.studentReadingLevel,
						showCover: true
					});
				}
	
				var toggleOptions = [];
	
				if (enabled.editControls) {
					toggleOptions.push({
						key: EDIT_CONTROLS,
						text: EDIT_CONTROLS
					});
				}
	
				if (enabled.feedbackControls) {
					toggleOptions.push({
						key: FEEDBACK_CONTROLS,
						text: FEEDBACK_CONTROLS
					});
				}
	
				if (enabled.analysisControls) {
					toggleOptions.push({
						key: ANALYSIS_CONTROLS,
						text: ANALYSIS_CONTROLS
					});
				}
	
				if (toggleOptions.length) {
					var controlToggle = React.createElement(
						"div",
						{ className: "hideOnPrint" },
						React.createElement(DisplayToggleControl, { options: toggleOptions,
							mode: DisplayToggleControl.LINK_MODE,
							onChange: this.onModeChange, activeOptionKey: this.controlMode() })
					);
				}
	
				if (enabled.coinsEarned) {
					var coinsEarned = React.createElement(CoinsEarnedDisplay, { key: answer.id, subjectType: "Answer", subjectID: answer.id });
				}
	
				if (bookDisplay || controlToggle) {
					return React.createElement(
						"div",
						{ key: answer.id + '_answerDisplayRow', className: "answerDisplayRow secondRow clearfix" },
						React.createElement(
							"div",
							{ className: "pull-left" },
							coinsEarned,
							bookDisplay
						),
						React.createElement(
							"div",
							{ className: "pull-right" },
							controlToggle
						)
					);
				}
			}
		}, {
			key: "renderComments",
			value: function renderComments() {
				var _props4 = this.props,
				    answer = _props4.answer,
				    enabled = _props4.enabled;
	
	
				if (enabled.lowerComments) {
					if (answer.quiz_id) {
						var subjectType = "QuizAnswer";
					} else if (answer.question_type == QuestionTypes.META_COGNITIVE_QUESTION) {
						var subjectType = "JournalActivityQuestionBuilder";
					} else if (answer.question_type == QuestionTypes.REVIEW_QUESTION) {
						var subjectType = "JournalActivityReview";
					} else {
						var subjectType = "JournalActivityAnswer";
					}
	
					return React.createElement(CommentBox, { subjectID: answer.id,
						subjectType: subjectType,
						userID: answer.user_id,
						blockFirstComment: true,
						initialCollapsed: false });
				}
			}
		}, {
			key: "setCharAt",
			value: function setCharAt(str, index, chr) {
				if (index > str.length - 1) return str;
				return str.substring(0, index) + chr + str.substring(index + 1);
			}
		}, {
			key: "render",
			value: function render() {
				var _props5 = this.props,
				    answer = _props5.answer,
				    question = _props5.question,
				    enabled = _props5.enabled;
	
	
				var className = "answerDisplay writingDisplay clearfix";
	
				if (answer && answer.draft) {
					className += " asDraft";
				}
	
				if (!this.isFillInTheBlank() && !this.isMetaCognitive()) {
					var questionDisplay = React.createElement(
						"p",
						{ className: "questionText" },
						answer.question_text
					);
				}
	
				if (this.isFillInTheBlank()) {
					var answerBody = React.createElement(
						"div",
						{ className: "answerText" },
						React.createElement(MultiPartAnswerDisplay, { parts: answer.parts, emphasizeInputs: true })
					);
	
					className += " forFITB";
				} else if (this.isMetaCognitive()) {
					// remove answer from question text
					var parts = _.clone(answer.parts);
					var questionPart = _.clone(_.findWhere(parts, { type: QUESTION_TYPE }));
					var answerPart = _.clone(_.findWhere(parts, { type: ANSWER_TYPE }));
					var synonymParts = _.clone(_.filter(parts, function (part) {
						return part.type.includes(SYNONYM_TYPE);
					}));
	
					if (!answer.draft && questionPart && answerPart) {
						var questionString = _.clone(questionPart.text) || '';
						var answerString = _.clone(answerPart.text) || '';
						// add multiple blanks for answers with multiple words
						if (answerPart.index && parseInt(answerPart.index)) {
							var startIndex = parseInt(answerPart.index);
							var numOfWords = this.handleExcludedPunctuation(answerString, 'add-spaces').split(/\s+/).length;
							var questionStringArray = this.handleExcludedPunctuation(questionString, 'add-spaces').split(/\s+/);
							// manipulate question string
							var loopIndex = 0;
							while (loopIndex < numOfWords) {
								if (_.include(EXCLUDED_PUNCTUATION, questionStringArray[startIndex + loopIndex])) {
									numOfWords++;
								} else {
									questionStringArray[startIndex + loopIndex] = '____';
								}
								loopIndex++;
							}
	
							var updatedQuestion = this.handleExcludedPunctuation(questionStringArray.join(' '), 'remove-spaces');
						} else {
							var updatedQuestion = questionString.replace(answerString, '____');
						}
	
						var synonymPart = {};
						if (synonymParts.length) {
							synonymPart.type = SYNONYM_TYPE;
							_.each(synonymParts, function (synonymObj, i) {
								synonymPart[i] = synonymObj.text;
							});
						}
	
						questionPart.text = updatedQuestion;
						parts = { questionPart: questionPart, answerPart: answerPart, synonymPart: synonymPart };
					}
	
					var answerBody = React.createElement(
						"div",
						{ className: "answerText" },
						React.createElement(MultiPartAnswerDisplay, { parts: parts, metaCognitive: true })
					);
	
					className += " forFITB";
				} else {
					if (this.controlMode() == ANALYSIS_CONTROLS || this.controlMode() == EDIT_CONTROLS) {
						if (this.props.evaluation && this.props.evaluation.autograder_data) {
							var answerBody = React.createElement(
								"div",
								{ className: "answerText " + (this.controlMode() == EDIT_CONTROLS ? 'editMode' : '') },
								React.createElement(AnswerScoringDetails, { editMode: this.controlMode() == EDIT_CONTROLS, onModeChange: this.onModeChange, answer: this.props.answer })
							);
						} else {
							var answerBody = React.createElement(
								"div",
								null,
								React.createElement(
									"div",
									{ className: "answerText" },
									React.createElement(MultiPartAnswerDisplay, { parts: answer.parts, breakSections: true })
								),
								React.createElement(
									"p",
									{ className: "text-center missingEvaluation" },
									"Scoring details are unvailable for this answer."
								)
							);
						}
					} else {
						var answerBody = React.createElement(
							"div",
							{ className: "answerText" },
							React.createElement(MultiPartAnswerDisplay, { parts: answer.parts, breakSections: true })
						);
					}
	
					className += " nonFITB";
				}
	
				if (this.answerKeyActive()) {
					var answerKey = this.renderAnswerKey();
				}
	
				var innerStyle = {};
	
				if (this.controlMode()) {
					className += " withControl";
	
					var controlEnabled = _.pick(this.props.enabled, "allowRevision", "editScore", "deletion", "toggleInclude");
	
					if (this.props.controlContent !== undefined) {
						var innerControl = this.props.controlContent;
					} else if (this.controlMode() === EDIT_CONTROLS) {
						var innerControl = React.createElement(EditControls, { answerID: answer.id, enabled: controlEnabled });
					} else if (this.controlMode() === FEEDBACK_CONTROLS) {
						var innerControl = React.createElement(FeedbackControls, { answerID: answer.id, enabled: controlEnabled });
					} else if (this.controlMode() === ANALYSIS_CONTROLS) {
						var innerControl = React.createElement(AnalysisControls, { answerID: answer.id, enabled: controlEnabled });
					}
	
					if (this.props.answer && this.props.answer.quiz_id) {
						// If it's coming from the quiz
						className += " withUpperControl";
					}
	
					if (!this.props.suppressControlHeader) {
						var controlClose = React.createElement(
							"a",
							{ href: "#", onClick: this.closeControl, className: "removeLink" },
							React.createElement(Glyphicon, { icon: "remove" })
						);
						var controlTitle = React.createElement(
							"div",
							{ className: "controlTitle" },
							this.controlMode()
						);
					}
	
					var controlBox = React.createElement(
						"div",
						{ className: "controlBox" },
						controlClose,
						controlTitle,
						innerControl
					);
				}
	
				return React.createElement(
					"div",
					{ className: className },
					this.renderFirstRow(),
					this.renderSecondRow(),
					React.createElement(
						"div",
						{ className: "innerWrap" },
						React.createElement(
							"div",
							{ className: "innerAnswer", style: innerStyle },
							questionDisplay,
							answerBody,
							answerKey,
							this.renderComments()
						),
						controlBox
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.updateEvaluationAsViewed();
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var _this3 = this;
	
				var controlMode = this.props.controlMode;
	
				if (!prevProps || prevProps.controlMode !== controlMode) {
					this.setState({ controlMode: controlMode }, function () {
						return _this3.updateEvaluationAsViewed();
					});
				}
			}
		}]);
	
		return AnswerDisplay;
	}(React.Component)) || _class);
	
	
	AnswerDisplay.QUIZZES_VIEW = "quizzes";
	AnswerDisplay.ANSWERS_VIEW = "answers";
	AnswerDisplay.REVIEWS_VIEW = "reviews";
	
	var EDIT_CONTROLS = "Edit";
	var FEEDBACK_CONTROLS = "Feedback";
	var ANALYSIS_CONTROLS = "Analysis";
	
	var QUESTION_TYPE = "question";
	var ANSWER_TYPE = "answer";
	var SYNONYM_TYPE = "synonym";
	
	var EXCLUDED_PUNCTUATION = [',', '.', '!', '?', ';', ')', '('];
	var NO_PRECEDING_SPACE = [',', '.', '!', '?', ';', ')'];
	
	AnswerDisplay.EDIT_CONTROLS = EDIT_CONTROLS;
	AnswerDisplay.FEEDBACK_CONTROLS = FEEDBACK_CONTROLS;
	AnswerDisplay.ANALYSIS_CONTROLS = ANALYSIS_CONTROLS;
	
	AnswerDisplay.defaultProps = {
		enabled: {}
	};
	
	AnswerDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the answer to be displayed
		answerID: PropTypes.number.isRequired,
	
		// Fetches autograder data
		fetchEvaluations: PropTypes.func,
	
		// Updates evaluation as viewed
		updateEvaluation: PropTypes.func,
	
		// QuizDisplay can control our mode from above
		controlMode: PropTypes.string,
	
		// QuizDisplay can also override what shows in the quiz control box
		controlContent: PropTypes.object,
	
		// QuizDisplay suppress this section showing a title / close button
		suppressControlHeader: PropTypes.bool,
	
		// QuizDisplay can provide its own close control handler
		onCloseControl: PropTypes.func,
		onModeChange: PropTypes.func,
	
		// Former "show" props
		// 
		// "enabled" keys used in *this (answer)* component
		//   date 					-> shows date
		//   student 				-> shows student + avatar
		//   score 					-> shows the scoring circle in the upper right
		//   linkToQuiz				-> shows the scoring circle in the upper right
		//   textTitle 				-> shows the title of the book
		//   readingLevel 			-> shows the reading level of the book
		//   editControls			-> shows the controls to toggle into edit mode
		//   feedbackControls		-> shows the controls to toggle into feedback mode
		//   analysisControls		-> shows the controls to toggle into analysis model
		//   lowerComments			-> shows the comments UNDER the answer (not in feedback window)
		//   answerKey 				-> (FitB only) Show correct answers. Also triggered by edit mode
		// 	 coinsEarned			-> Shows how many coins were earned for the answer
		//   startRevision			-> Shows a button to begin the revision
		//   cancelRevision			-> Shows a button to decline doing a revision
		// 
		// Values passed on to the *control* components
		//   allowRevision			-> Allows student to retake answer
		//   editScore				-> Changes the score
		//   deletion 				-> Deletes the answer
		//   toggleInclude			-> Passed from answers -> controls
		//   
		enabled: PropTypes.object,
	
		// Changes the way the drafts show
		asDraft: PropTypes.bool,
	
		// From @connect
		// Which are present is determined by the other props
		answer: PropTypes.object.isRequired,
		question: PropTypes.object,
	
		// From @connect, paywall related
		blockComments: PropTypes.bool,
	
		// Expand comments to be shown for students
		viewAsStudent: PropTypes.bool,
	
		view: PropTypes.string,
		studentReadingLevel: PropTypes.number,
		exclude: PropTypes.bool,
		bookDisplayPresent: PropTypes.bool,
		evaluation: PropTypes.object,
	
		skipRevision: PropTypes.func
	});
	
	module.exports = AnswerDisplay;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var MultiPartSentenceStarter = __webpack_require__(197);
	
	__webpack_require__(3833);
	
	var MultiPartAnswerDisplay = function MultiPartAnswerDisplay(props) {
		var index = 0;
		var sections = [];
		// for question builders
		var synonyms = [];
	
		_.each(props.parts || [], function (part, index) {
			if (props.metaCognitive) {
				if (part.type == QUESTION) {
					sections.push(React.createElement(
						"span",
						{ key: "question-body-" + index, className: "inputText" },
						React.createElement(
							"strong",
							null,
							"Question:"
						),
						" ",
						part.text,
						React.createElement("br", null)
					));
				} else if (part.type == ANSWER) {
					sections.push(React.createElement(
						"span",
						{ key: "answer-body-" + index, className: "inputText" },
						React.createElement(
							"strong",
							null,
							"Answer:"
						),
						" ",
						part.text
					));
				} else if (part.type = SYNONYM) {
					_.times(3, function (i) {
						if (part[i]) {
							synonyms.push(part[i]);
						}
					});
				}
			} else if (part.type == STARTER) {
				if (index != 0 && props.breakSections) {
					sections.push(React.createElement(
						"span",
						{ key: "br-" + index },
						React.createElement("br", null),
						React.createElement("br", null)
					));
				}
				sections.push(React.createElement(
					"span",
					{ key: "starter-" + index },
					React.createElement(
						"span",
						{ className: "starter" },
						part.text
					),
					" "
				));
			} else {
				sections.push(React.createElement(
					"span",
					{ key: "body-" + index, className: "inputText" },
					part.text
				));
			}
		});
	
		// for question builders
		if (synonyms.length) {
			if (synonyms.length === 1) {
				var synonymsList = _.first(synonyms);
			} else {
				var synonymsList = synonyms.slice(0, -1).join(', ') + ' and ' + synonyms.slice(-1);
			}
			sections.push(React.createElement("br", { key: "synonyms-break-" + index }));
			sections.push(React.createElement(
				"span",
				{ key: "body-" + index, className: "inputText" },
				React.createElement(
					"strong",
					null,
					"Synonyms:"
				),
				" ",
				synonymsList
			));
		}
	
		var className = "multiPartAnswerDisplay";
		if (props.emphasizeInputs) {
			className += " emphasizeInputs";
		} else {
			className += " emphasizeStarters";
		}
	
		return React.createElement(
			"div",
			{ className: className },
			sections
		);
	};
	
	var BODY = MultiPartSentenceStarter.BODY;
	var STARTER = MultiPartSentenceStarter.STARTER;
	var QUESTION = MultiPartSentenceStarter.QUESTION;
	var ANSWER = MultiPartSentenceStarter.ANSWER;
	var SYNONYM = MultiPartSentenceStarter.SYNONYM;
	
	MultiPartAnswerDisplay.propTypes = StrictPropTypes({
		parts: PropTypes.array,
		breakSections: PropTypes.bool,
		emphasizeInputs: PropTypes.bool,
		metaCognitive: PropTypes.bool
	});
	
	module.exports = MultiPartAnswerDisplay;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlfonsoContainer = __webpack_require__(421);
	
	__webpack_require__(3848);
	
	var QuestionFeedback = function (_React$Component) {
		_inherits(QuestionFeedback, _React$Component);
	
		function QuestionFeedback(props) {
			_classCallCheck(this, QuestionFeedback);
	
			var _this = _possibleConstructorReturn(this, (QuestionFeedback.__proto__ || Object.getPrototypeOf(QuestionFeedback)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("QuestionFeedback");
			_this.state = { showCount: 1 };
			return _this;
		}
	
		_createClass(QuestionFeedback, [{
			key: "showMore",
			value: function showMore(e) {
				$wr.nope(e);
				this.setState({ showCount: this.state.showCount + 1 });
			}
			// send data and reason to parent
	
		}, {
			key: "onFeedbackOverride",
			value: function onFeedbackOverride(data, reason, e) {
				$wr.nope(e);
				if (this.state.showCount > 1) {
					this.setState({ showCount: this.state.showCount - 1 });
				}
				this.props.onFeedbackOverride(data, reason);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var visibleFeedback = _.first(this.props.feedbackItems, this.state.showCount);
				var feedbackDisplays = _.map(visibleFeedback, function (itemGroup, index) {
					// checks if the feedback can be overridden
					if (itemGroup.data) {
						return React.createElement(
							OwlfonsoContainer,
							{ key: index + itemGroup.data.trigger, hideOwl: index < _this2.state.showCount - 1,
								owlPosition: "bottom-left", initialAnimation: true, owlWidth: 80,
								showFeedbackReward: _this2.props.showFeedbackReward,
								feedbackToRead: $wr.getInnerText(itemGroup),
								onFeedbackOverride: _this2.onFeedbackOverride,
								feedbackObj: itemGroup.data },
							itemGroup
						);
					} else {
						return React.createElement(
							OwlfonsoContainer,
							{ key: index + $wr.getInnerText(itemGroup).replaceAll(' ', '_'), hideOwl: index < _this2.state.showCount - 1,
								owlPosition: "bottom-left", initialAnimation: true, owlWidth: 80,
								showFeedbackReward: _this2.props.showFeedbackReward,
								feedbackToRead: $wr.getInnerText(itemGroup) },
							itemGroup
						);
					}
				});
	
				if (this.state.showCount < this.props.feedbackItems.length) {
					var moreLink = React.createElement(
						"p",
						{ className: "showMore text-right" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.showMore },
							"Tell Me More"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "questionFeedback" },
					feedbackDisplays,
					moreLink
				);
			}
		}]);
	
		return QuestionFeedback;
	}(React.Component);
	
	;
	
	QuestionFeedback.propTypes = StrictPropTypes({
		feedbackItems: PropTypes.array.isRequired,
		// IF true, show reward for taking feedback into account
		showFeedbackReward: PropTypes.bool,
		onFeedbackOverride: PropTypes.func
	});
	
	module.exports = QuestionFeedback;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = __webpack_require__(16);
	var GradeLevel = __webpack_require__(40);
	var CurrentUser = __webpack_require__(3);
	var QuestionTypes = __webpack_require__(82);
	
	var AnswerDisplay = __webpack_require__(171);
	var BookDisplay = __webpack_require__(46);
	var GradualFade = __webpack_require__(933);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	
	var StudentDisplay = __webpack_require__(52);
	var ScoreDisplay = __webpack_require__(103);
	var DisplayToggleControl = __webpack_require__(48);
	var EditControls = __webpack_require__(427);
	
	var RosterSelectors = __webpack_require__(6);
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	
	var AutograderDisplayConfig = __webpack_require__(83);
	
	__webpack_require__(3856);
	
	var QuizDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var quiz = WritingSelectors.quiz({ state: state, id: props.quizID });
	
		var requiredRecords = {
			quiz: quiz
		};
		var student = RosterSelectors.student({ state: state, id: quiz.user_id });
		if (student) {
			requiredRecords.studentReadingLevel = student.current_reading_level;
		}
		var answers = WritingSelectors.answersForQuizID({ state: state, quizID: props.quizID });
		if (!CurrentUser.isPremiumOrTrialAccount()) {
			answers = _.filter(answers, function (answer) {
				return answer.question_type !== QuestionTypes.FILL_IN_THE_BLANK_QUESTION;
			});
		}
		requiredRecords.answerIDs = _.pluck(answers, "id");
	
		if (answers) {
			requiredRecords.evaluations = _.compact(_.map(_.pluck(answers, "id"), function (id) {
				return WritingSelectors.evaluationForSubject({ state: state, subjectType: "Answer", subjectID: id });
			}));
			requiredRecords.answers = answers;
		}
	
		return requiredRecords;
	}, function (dispatch, props) {
		return {
			skipRevision: function skipRevision() {
				return dispatch(WritingActions.updateQuiz({
					id: props.quizID, update: { allow_revision: false }, query: { skip: true }
				})).then(function () {
					CurrentUser.fetchCurrentUserCoinData();
				});
			},
			fetchAnswers: function fetchAnswers(answerIDs) {
				var filters = { ids: answerIDs };
				var embeds = ["answer.question", "answer.meta_data", "answer.evaluation", "question.answer_options", "evaluation.autograder_data"];
				return dispatch(WritingActions.fetchAnswers({ filters: filters, embeds: embeds }));
			},
			updateEvaluation: function updateEvaluation(evaluationID, update) {
				dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: update }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(QuizDisplay, _React$Component);
	
		function QuizDisplay(props) {
			_classCallCheck(this, QuizDisplay);
	
			var _this = _possibleConstructorReturn(this, (QuizDisplay.__proto__ || Object.getPrototypeOf(QuizDisplay)).call(this));
	
			autobind(_this);
	
			_this.state = {
				controlMode: props.controlMode ? props.controlMode : null
			};
			return _this;
		}
	
		_createClass(QuizDisplay, [{
			key: "controlMode",
			value: function controlMode() {
				return this.state.controlMode; // Kept as a funciton to mirror AnswerDisplay
			}
		}, {
			key: "onModeChange",
			value: function onModeChange(controlMode) {
				var _this2 = this;
	
				this.setState({ controlMode: controlMode }, function () {
					return _this2.updateEvaluationAsViewed();
				});
				setTimeout($wr.triggerResize, 400);
			}
	
			// Updates quiz evaluation as viewed
	
		}, {
			key: "updateEvaluationAsViewed",
			value: function updateEvaluationAsViewed() {
				var quiz = this.props.quiz;
				var controlMode = this.state.controlMode;
	
	
				if (quiz.evaluation && (controlMode == AnswerDisplay.ANALYSIS_CONTROLS || controlMode == AnswerDisplay.EDIT_CONTROLS) && !CurrentUser.isStudent()) {
					this.props.updateEvaluation(quiz.evaluation, { viewed: true });
				}
			}
		}, {
			key: "closeControl",
			value: function closeControl(e) {
				$wr.nope(e);
				this.setState({ controlMode: null });
			}
		}, {
			key: "onSkipRevision",
			value: function onSkipRevision() {
				if (confirm("Are you sure?")) {
					this.props.skipRevision();
				}
			}
		}, {
			key: "afterDelete",
			value: function afterDelete(e) {
				$wr.nope(e);
				window.location.href = window.location.pathname;
			}
		}, {
			key: "renderAnswers",
			value: function renderAnswers() {
				var _this3 = this;
	
				var baseAnswerEnabled = _.pick(this.props.enabled, "lowerComments", "answerKey", "allowRevision");
	
				return _.map(this.props.answerIDs, function (answerID, index) {
					var answerEnabled = _.clone(baseAnswerEnabled);
					var wrapClass = "answerWrap answerIndex" + index;
	
					if (index == _this3.props.answerIDs.length - 1) {
						wrapClass += " answerLastIndex";
					} else {
						delete answerEnabled.allowRevision;
					}
	
					if (_this3.controlMode() === AnswerDisplay.EDIT_CONTROLS) {
						if (index === 0) {
	
							var editControlEnabled = _.pick(_this3.props.enabled, "editScore", "deletion", "toggleInclude");
	
							// Make the first answer show the controls for the quiz
							var controlContent = React.createElement(EditControls, { quizID: _this3.props.quiz.id, enabled: editControlEnabled, afterDelete: _this3.afterDelete });
						} else {
							// Hide edit controls for later answers
							var controlContent = null;
						}
					}
					return React.createElement(
						"div",
						{ className: wrapClass, key: answerID },
						React.createElement(AnswerDisplay, { answerID: answerID,
							onModeChange: _this3.onModeChange,
							enabled: answerEnabled,
							controlMode: _this3.state.controlMode,
							controlContent: controlContent,
							viewAsStudent: _this3.props.viewAsStudent,
							onCloseControl: _this3.closeControl,
							suppressControlHeader: index !== 0 })
					);
				});
			}
		}, {
			key: "toggleEdit",
			value: function toggleEdit() {
				this.props.onEditEvaluation();
			}
		}, {
			key: "renderFirstRow",
			value: function renderFirstRow() {
				var _props = this.props,
				    enabled = _props.enabled,
				    quiz = _props.quiz;
	
	
				if (enabled.student) {
					var studentDisplay = React.createElement(StudentDisplay, { studentID: quiz.user_id, showAvatar: true, avatarMaxWidth: 40 });
				}
	
				if (enabled.date) {
					var dateDisplay = React.createElement(
						"div",
						{ className: "date" },
						$wr.formatDateTime(quiz.completed_at, "show-past-years")
					);
				}
	
				if (enabled.score) {
					var scoreDisplay = React.createElement(ScoreDisplay, { showDenominator: true, subjectID: quiz.id,
						subjectType: "Quiz", mode: ScoreDisplay.CIRCLE_MODE, answerIDs: this.props.answerIDs });
				}
	
				if ((enabled.startRevision || enabled.cancelRevision) && quiz.allow_revision) {
					if (enabled.startRevision) {
						var goToRevision = React.createElement(
							_reactRouterDom.Link,
							{ className: "btn buttonPrimary revisionButton",
								to: "/quiz?text_id=" + quiz.text_id },
							"Start Revision"
						);
					}
	
					if (enabled.cancelRevision) {
						var cancelRevision = React.createElement(
							"button",
							{ className: "btn btn-default revisionButton",
								onClick: this.onSkipRevision },
							"Skip"
						);
					}
	
					var revisionButtons = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Your teacher will let you revise this quiz."
						),
						goToRevision,
						cancelRevision
					);
				}
	
				if (studentDisplay || dateDisplay || scoreDisplay) {
					return React.createElement(
						"div",
						{ className: "quizDisplayRow topRow clearfix" },
						React.createElement(
							"div",
							{ className: "pull-left" },
							revisionButtons,
							studentDisplay
						),
						React.createElement(
							"div",
							{ className: "pull-right displayContainer" },
							dateDisplay,
							scoreDisplay
						)
					);
				}
			}
		}, {
			key: "includeNewBadge",
			value: function includeNewBadge() {
				return _.any(_.map(this.props.evaluations, function (evaluation) {
					var answerDetails = evaluation.autograder_data;
					if (answerDetails) {
						var agKeys = _.keys(AutograderDisplayConfig.aggregateLeaves(answerDetails.polarizing));
						return agKeys.some(function (r) {
							return AutograderDisplayConfig.NEW_KEYS.includes(r);
						});
					}
				}));
			}
		}, {
			key: "renderSecondRow",
			value: function renderSecondRow() {
				var enabled = this.props.enabled;
	
				if (this.props.enabled.textTitle) {
					var bookDisplay = React.createElement(BookDisplay, { inline: true, textID: this.props.quiz.text_id,
						showReadingLevel: enabled.readingLevel,
						studentReadingLevel: this.props.studentReadingLevel });
				}
	
				var toggleOptions = [];
	
				if (enabled.editControls) {
					toggleOptions.push({
						key: AnswerDisplay.EDIT_CONTROLS,
						text: AnswerDisplay.EDIT_CONTROLS
					});
				}
	
				if (enabled.feedbackControls) {
					toggleOptions.push({
						key: AnswerDisplay.FEEDBACK_CONTROLS,
						text: AnswerDisplay.FEEDBACK_CONTROLS
					});
				}
	
				if (enabled.analysisControls) {
					var newBadge = this.includeNewBadge();
					toggleOptions.push({
						key: AnswerDisplay.ANALYSIS_CONTROLS,
						text: AnswerDisplay.ANALYSIS_CONTROLS,
						newBadge: newBadge
					});
				}
	
				if (toggleOptions.length) {
					var controlToggle = React.createElement(
						"div",
						{ className: "hideOnPrint" },
						React.createElement(DisplayToggleControl, { options: toggleOptions,
							mode: DisplayToggleControl.LINK_MODE,
							onChange: this.onModeChange, activeOptionKey: this.controlMode() })
					);
				}
	
				if (bookDisplay || controlToggle) {
					return React.createElement(
						"div",
						{ className: "quizDisplayRow secondRow clearfix" },
						React.createElement(
							"div",
							{ className: "pull-left" },
							bookDisplay
						),
						React.createElement(
							"div",
							{ className: "pull-right" },
							controlToggle
						)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    quiz = _props2.quiz,
				    enabled = _props2.enabled;
	
	
				var className = "quizDisplay writingDisplay";
				if (quiz.draft) {
					className += " draftAnswer";
				}
	
				if (this.controlMode()) {
					className += " controlMode" + this.controlMode().replace(/ /g, "");
				}
	
				// if (this.props.quiz.excluded) {
				// 	className += " excludedQuiz";
	
				// 	if (this.props.viewAsStudent) {
				// 		var exclusionNote = (
				// 			<p className="excludedText">
				// 				This quiz will not count toward your goals
				// 			</p>
				// 		)
				// 	} else {
				// 		var differentiationLink = (<Link to="/roster/goals?edit_expectations=true" >custom goals</Link>)
				// 		var exclusionNote = (
				// 			<p className="excludedText">
				// 				This quiz will not count toward your { differentiationLink }
				// 			</p>
				// 		)
				// 	}
				// }
				// { exclusionNote }
				return React.createElement(
					"div",
					{ "data-quiz-id": this.props.quizID, "data-evaluation-id": this.props.quiz.evaluation, className: className },
					this.renderFirstRow(),
					this.renderSecondRow(),
					this.renderAnswers()
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _props3 = this.props,
				    quiz = _props3.quiz,
				    answers = _props3.answers;
				// fetch answers and evaluations when empty
	
				if (quiz.answer_ids && _.isEmpty(answers)) {
					this.props.fetchAnswers(quiz.answer_ids);
				}
	
				this.updateEvaluationAsViewed();
			}
		}]);
	
		return QuizDisplay;
	}(React.Component)) || _class);
	
	
	QuizDisplay.defaultProps = {
		enabled: {}
	};
	
	QuizDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the quiz to be displayed
		quizID: PropTypes.number.isRequired,
	
		// Former "show" props
		//
		// "enabled" keys used in *this (quiz)* component
		//   date 					-> shows date
		//   student 				-> shows student + avatar
		//   score 					-> shows the scoring circle in the upper right
		//   textTitle 				-> shows the title of the book
		//   readingLevel 			-> shows the reading level of the book
		//   editControls			-> shows the controls to toggle into edit mode
		//   feedbackControls		-> shows the controls to toggle into feedback mode
		//   analysisControls		-> shows the controls to toggle into analysis model
		//
		// Values passed on to the *answer* component
		//   lowerComments			-> shows the comments UNDER the answer (not in feedback window)
		//   answerKey 				-> (FitB only) Show correct answers. Also triggered by edit mode
		//   allowRevision			-> Passed from answers -> controls  (But limited to last answer index)
		//
		// Values passed on to our *edit control* component within the quiz
		//   editScore				-> Passed from answers -> controls
		//   deletion 				-> Passed from answers -> controls
		//   toggleInclude			-> Passed from answers -> controls
		//
		enabled: PropTypes.object,
	
		view: PropTypes.string,
		controlMode: PropTypes.string,
		studentReadingLevel: PropTypes.number,
		evaluations: PropTypes.array,
		answers: PropTypes.array,
	
		// From @connect
		// Which are present is determined by the other props
		quiz: PropTypes.object.isRequired,
		answerIDs: PropTypes.array.isRequired,
		evaulation: PropTypes.object,
		onDelete: PropTypes.func,
		onRevert: PropTypes.func,
		onInclude: PropTypes.func,
		onExclude: PropTypes.func,
		hideWarmUps: PropTypes.bool,
		onEditEvaluation: PropTypes.func,
		skipRevision: PropTypes.func,
		fetchAnswers: PropTypes.func,
		updateEvaluation: PropTypes.func,
	
		viewAsStudent: PropTypes.bool
	});
	
	module.exports = QuizDisplay;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activity = __webpack_require__(170);
	var Glyphicon = __webpack_require__(8);
	var CurrentUser = __webpack_require__(3);
	var TeacherPreviewNotice = __webpack_require__(423);
	var Modal = __webpack_require__(18);
	var Spinner = __webpack_require__(9);
	var EvaluationTags = __webpack_require__(960);
	var EvaluationBox = __webpack_require__(429);
	var CommentBox = __webpack_require__(119);
	var ShareResponse = __webpack_require__(431);
	var StudentActivityInfoLine = __webpack_require__(432);
	var Features = __webpack_require__(16);
	
	__webpack_require__(3861);
	
	var ResponseModal = function (_React$Component) {
		_inherits(ResponseModal, _React$Component);
	
		function ResponseModal(props) {
			_classCallCheck(this, ResponseModal);
	
			var _this = _possibleConstructorReturn(this, (ResponseModal.__proto__ || Object.getPrototypeOf(ResponseModal)).call(this));
	
			autobind(_this);
			_this.state = {
				response: null, newsFeedItem: null, loaded: false
			};
			return _this;
		}
	
		_createClass(ResponseModal, [{
			key: "show",
			value: function show() {
				if (!this.state.loaded) {
					this.setState({ loaded: true }, function () {
						this.loadResponseData();
						this.refs.modal.show();
					}.bind(this));
				} else {
					this.refs.modal.show();
				}
			}
		}, {
			key: "editResponse",
			value: function editResponse() {
				var path = "/responses/new?activity_id=" + this.state.response.activity.id + "&edit_response_id=" + this.state.response.id;
				window.open(path, "_blank");
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.response == null) {
					var responseContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
					if (this.props.adminPreview) {
						var previewNotice = React.createElement(TeacherPreviewNotice, null);
					}
					var infoLine = React.createElement(StudentActivityInfoLine, { response: this.state.response, user: this.props.user });
	
					if (CurrentUser.hasID(this.state.response.user_id) || CurrentUser.isAdmin()) {
						var evaluation = React.createElement(EvaluationBox, { response: this.state.response });
						var tags = React.createElement(
							"div",
							null,
							React.createElement(EvaluationTags, { response: this.state.response, editable: false })
						);
					}
	
					// for now, remove options for sharing collages
					if (CurrentUser.isAdmin() && this.state.response.activity.format.format_class != "CollageFormat") {
						var socialShare = React.createElement(ShareResponse, { responseID: this.state.response.id });
					}
	
					if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
						var commentBox = React.createElement(CommentBox, { subjectID: this.state.response.id, subjectType: "JournalActivityExercise",
							blockFirstComment: CurrentUser.isStudent(),
							userID: this.state.response.user_id, initialCollapsed: !CurrentUser.isStudent() });
					}
	
					// if (CurrentUser.hasID(this.state.response.user_id) && !this.props.adminPreview) {
					// 	var editAction = (
					// 		<a className="editResponse" onClick={this.editResponse}>Edit Response <Glyphicon icon="pencil"/> </a>
					// 	)
					// }
	
	
					var responseContent = React.createElement(
						"div",
						{ className: "responseWrap" },
						previewNotice,
						infoLine,
						evaluation,
						tags,
						React.createElement(Activity, { activity: this.state.response.activity, response: this.state.response }),
						commentBox
					);
				}
	
				return React.createElement(
					Modal,
					{ className: "responseModal veryWideModal", ref: "modal", onHide: this.props.onHide },
					responseContent,
					socialShare
				);
			}
		}, {
			key: "loadResponseData",
			value: function loadResponseData() {
				var responseParams = { embed: "response.activity,activity.format,response.input_data,response.activity_data,response.evaluation,response.mirror_user_ids,response.text" };
				CurrentUser.api().getResponse(this.props.responseID, responseParams, $wr.apiHandler(function (response) {
					this.setState({ response: response.response });
				}.bind(this)));
	
				// var newsFeedItemParams = { embed: "news_feed_item.comments,comment.user,student.avatar" };
				// CurrentUser.api().getResponseNewsFeedItem(this.props.responseID, newsFeedItemParams, $wr.apiHandler(function(response) {
				// 	this.setState({ newsFeedItem: response.news_feed_item });
				// }.bind(this)));
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {}
		}]);
	
		return ResponseModal;
	}(React.Component);
	
	;
	
	ResponseModal.propTypes = StrictPropTypes({
		// ID of the response we're loading
		responseID: PropTypes.number.isRequired,
	
		// Function to call after the modal is hidden
		onHide: PropTypes.func,
	
		// The user of the response (optional, will only show the student if provided)
		user: PropTypes.object,
	
		// This is an admin viewing an preview of the completed activity
		adminPreview: PropTypes.bool
	});
	
	module.exports = ResponseModal;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getTextStatus = getTextStatus;
	var UNDER = exports.UNDER = "under-zpd";
	var OVER = exports.OVER = "over-zpd";
	var AT = exports.AT = "at-zpd";
	
	var LOWER_RANGE = exports.LOWER_RANGE = 100;
	var UPPER_RANGE = exports.UPPER_RANGE = 50;
	
	function getTextStatus(textLexile, studentLexile) {
		var levelsComparison = parseInt(studentLexile) - parseInt(textLexile);
	
		if (levelsComparison < -UPPER_RANGE) {
			return OVER;
		} else if (levelsComparison <= LOWER_RANGE) {
			return AT;
		} else {
			return UNDER;
		}
	}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrentUser = __webpack_require__(3);
	
	function lastSpan(count, momentName, labelName) {
		var start = (0, _moment2.default)().subtract(count, momentName).format(FORMAT);
	
		var end = (0, _moment2.default)().format(FORMAT);
		var label = "Last " + count + " " + labelName;
	
		return { value: { "start": start, "end": end }, label: label };
	}
	
	function getDateSpanLabel(span, i) {
		var startd = new Date(span.start);
		var endd = new Date(span.end);
		var diff = parseInt((endd - startd) / (1000 * 60 * 60 * 24), 10);
	
		var period = "Week";
		if (diff > 200) {
			period = "School Year";
		} else if (diff > 170) {
			period = "Semester";
		} else if (diff > 80) {
			period = "Trimester";
		} else if (diff > 20) {
			period = "Month";
		}
	
		if (i == 1) {
			return "Last " + period;
		} else if (i > 1) {
			return i + " " + period + "s Ago";
		} else {
			return "This " + period;
		}
	}
	
	function getExpectationSpans(expectationSpans, expectation_count) {
		if (expectationSpans) {
			var dateSpans = expectationSpans;
			var defaultDateSpans = dateSpans.slice(0, expectation_count);
	
			return _.map(defaultDateSpans, function (span, s) {
				if (span.label) {
					return { value: _.pick(span, "start", "end"), label: span.label };
				} else {
					return { value: _.pick(span, "start", "end"), label: getDateSpanLabel(span, s) };
				}
			});
		} else {
			return [];
		}
	}
	
	function getSchoolYearSpan() {
		var schoolYearStart = (0, _moment2.default)(CurrentUser.fetchSchoolYearDates().startDate);
	
		var start = schoolYearStart.format(FORMAT);
		var end = (0, _moment2.default)().format(FORMAT);
	
		return { value: { "start": start, "end": end }, label: "This School Year" };
	}
	
	function renderSpan(option) {
		var startDate = (0, _moment2.default)(option.value.start).format("M/DD/YY");
	
		if ((0, _moment2.default)(option.value.end).startOf("day") >= (0, _moment2.default)().startOf("day")) {
			var endDate = "Today";
		} else {
			var endDate = (0, _moment2.default)(option.value.end).format("M/DD/YY");
		}
	
		return React.createElement(
			"span",
			null,
			React.createElement(
				"span",
				{ className: "spanLabel" },
				option.label
			),
			" ",
			React.createElement(
				"span",
				{ className: "spanDates" },
				startDate,
				" - ",
				endDate
			)
		);
	}
	
	function widgetSpans(expectationSpans) {
		var dateOptions = [];
	
		// return all date spans since begining of school year
		dateOptions = dateOptions.concat(getExpectationSpans(expectationSpans, _.size(expectationSpans)));
		// var hasSchoolYear = _.findWhere(dateOptions, { label: SCHOOL_YEAR_LABEL });
		// if (hasSchoolYear == undefined) {
		// 	dateOptions.push(getSchoolYearSpan());
		// }
	
		return dateOptions;
	}
	
	function dashboardSpans(expectationSpans) {
		var dateOptions = [];
	
		dateOptions = dateOptions.concat(getExpectationSpans(expectationSpans, INITIAL_EXPECTATION_SPAN_COUNT));
	
		dateOptions.push(lastSpan(7, "days", "Days")); // Means there's always a "Last 7 Days" span
		dateOptions.push(lastSpan(30, "days", "Days")); // Means there's always a "Last 30 Days" span
	
		var hasSchoolYear = _.findWhere(dateOptions, { label: SCHOOL_YEAR_LABEL });
		if (hasSchoolYear == undefined) {
			dateOptions.push(getSchoolYearSpan());
		}
	
		if (expectationSpans && expectationSpans.length > INITIAL_EXPECTATION_SPAN_COUNT) {
			dateOptions.push({ value: OTHER_PERIODS, label: OTHER_PERIODS });
		}
		dateOptions.push({ value: CUSTOM_DATES, label: CUSTOM_DATES });
	
		return dateOptions;
	}
	
	function otherExpectationsSpans(expectationSpans) {
		if (expectationSpans) {
			var allDateSpans = expectationSpans;
			var otherPeriodSpans = allDateSpans.slice(INITIAL_EXPECTATION_SPAN_COUNT, allDateSpans.length);
			var otherPeriods = _.map(otherPeriodSpans, function (span) {
				return { value: _.pick(span, "start", "end"), label: span.label };
			});
	
			return otherPeriods;
		} else {
			return [];
		}
	}
	
	var OTHER_PERIODS = "Other Time Periods";
	var CUSTOM_DATES = "Custom Dates";
	
	var INITIAL_EXPECTATION_SPAN_COUNT = 2;
	
	var FORMAT = "YYYY-MM-DD";
	var SCHOOL_YEAR_LABEL = "This School Year";
	
	module.exports = {
		OTHER_PERIODS: OTHER_PERIODS, CUSTOM_DATES: CUSTOM_DATES, FORMAT: FORMAT,
		renderSpan: renderSpan,
		dashboardSpans: dashboardSpans, otherExpectationsSpans: otherExpectationsSpans, widgetSpans: widgetSpans
	};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Logic for the roster pages
	var GradeLevel = __webpack_require__(40);
	
	var StudentRoster = function StudentRoster(rosterData) {
		this.rosterData = rosterData;
	
		/////////////////////////////////
		// Get lists of column names ////
		/////////////////////////////////
	
		this.currentColumns = _.memoize(function () {
			return _.keys(this.rosterData);
		});
	
		this.missingColumns = function () {
			return _.difference(REQUIRED_COLUMNS, this.currentColumns());
		};
		this.unrecognizedColumns = function () {
			return _.difference(this.currentColumns(), RECOGNIZED_COLUMNS);
		};
	
		/////////////////////////////////////////
		// Get data on students missing data ////
		/////////////////////////////////////////
		this.studentsMissingColumns = function () {
			var missingStudents = [];
			var data = this.rosterData;
	
			for (var i = 0; i < data[FIRST_NAME].length; i++) {
				var missingCols = [];
				var firstName, lastName, gradeLevel, classroom;
	
				if (data[FIRST_NAME] && data[FIRST_NAME][i]) {
					firstName = data[FIRST_NAME][i];
				} else {
					firstName = null;
				}
	
				if (data[LAST_NAME] && data[LAST_NAME][i]) {
					lastName = data[LAST_NAME][i];
				} else {
					lastName = null;
				}
	
				if (data[GRADE_LEVEL] && data[GRADE_LEVEL][i]) {
					gradeLevel = data[GRADE_LEVEL][i];
				} else {
					gradeLevel = null;
				}
	
				if (data[CLASSROOM] && data[CLASSROOM][i]) {
					classroom = data[CLASSROOM][i];
				} else {
					classroom = null;
				}
	
				if (firstName == null) {
					missingCols.push(FIRST_NAME);
				}
				if (lastName == null) {
					missingCols.push(LAST_NAME);
				}
				if (gradeLevel == null) {
					missingCols.push(GRADE_LEVEL);
				}
				if (classroom == null) {
					missingCols.push(CLASSROOM);
				}
	
				if (missingCols.length > 0) {
					var str = "";
	
					if (firstName != null) {
						str += firstName;
					}
					if (lastName != null) {
						str += " " + lastName;
					}
					if (gradeLevel != null) {
						str += ", " + GradeLevel.getName(gradeLevel);
					}
					if (classroom != null) {
						str += ", " + classroom;
					}
	
					missingStudents.push({
						studentSummary: str,
						missingColumns: missingCols
					});
				}
			}
			return missingStudents;
		};
	
		//////////////////////////////////////////
		// Get lists of invalid column values ////
		//////////////////////////////////////////
	
		this.invalidParentEmails = function () {
			if (this.hasColumn(PARENT_EMAIL)) {
				return _.select(this.getColumn(PARENT_EMAIL), function (email) {
					return email && email.trim().length > 0 && !$wr.isValidEmail(email);
				});
			} else {
				return [];
			}
		};
		this.invalidPasswords = function () {
			if (this.hasColumn(PASSWORD)) {
				return _.select(this.getColumn(PASSWORD), function (password) {
					return password && password.trim().length < MIN_PASSWORD_LENGTH;
				});
			} else {
				return [];
			}
		};
		this.invalidGradeLevels = function () {
			if (this.hasColumn(GRADE_LEVEL)) {
				return _.select(this.getColumn(GRADE_LEVEL), function (gradeLevel) {
					return !GradeLevel.isValid(gradeLevel);
				});
			} else {
				return [];
			}
		};
		this.validUsernames = function () {
			if (this.hasColumn(USERNAME)) {
				return _.select(this.getColumn(USERNAME), function (username) {
					return username.toString().trim().length > 0;
				});
			} else {
				return [];
			}
		};
	
		////////////////////////////////////
		// Check the status of a column ////
		////////////////////////////////////
		this.isRequiredColumn = function (column) {
			return _.includes(REQUIRED_COLUMNS, column);
		};
		this.isOptionalColumn = function (column) {
			return _.includes(OPTIONAL_COLUMNS, column);
		};
		this.isUnknownColumn = function (column) {
			return !_.includes(RECOGNIZED_COLUMNS, column);
		};
		this.isHiddenColumn = function (column) {
			return _.includes(HIDDEN_COLUMNS, column);
		};
		this.hasColumn = function (column) {
			return _.includes(this.currentColumns(), column);
		};
	
		/////////////////////////////////////
		// Get columns and column values ////
		/////////////////////////////////////
		this.getColumn = function (column) {
			return this.rosterData[column];
		};
		this.getValue = function (column, index) {
			return this.getColumn(column)[index];
		};
		this.getStudents = function () {
			var students = [];
			for (var i = 0; i < this.getColumn(FIRST_NAME).length; i++) {
				students.push({
					first_name: this.getValue(FIRST_NAME, i),
					last_name: this.getValue(LAST_NAME, i),
					grade_level: this.getValue(GRADE_LEVEL, i),
					rosterIndex: i
				});
			}
			return students;
		};
	
		/////////////////////////////////////////////////////
		// Info and validations on the roster as a whole ////
		/////////////////////////////////////////////////////
		this.rowCount = function () {
			return (this.getColumn(FIRST_NAME) || []).length;
		};
	
		this.hasAllRequiredColumns = function () {
			return this.missingColumns().length == 0;
		};
		this.hasCombinedNameColumn = function () {
			if (this.hasColumn(FIRST_NAME) || this.hasColumn(LAST_NAME)) {
				return false;
			}
	
			var col = _.find(this.currentColumns(), function (column) {
				return column.toLowerCase().indexOf("name") != -1;
			});
	
			if (col == undefined) {
				return false;
			}
	
			var colData = this.getColumn(col);
			var multiWordColCount = _.select(colData, function (str) {
				return str.trim().split(" ").length > 1;
			}).length;
	
			return multiWordColCount > colData.length / 2;
		};
		this.getClassroomGradeLevels = function (classroom) {
			var gradeLevels = [];
			_.each(this.getColumn(CLASSROOM), function (oClassroom, index) {
				if (oClassroom == classroom) {
					gradeLevels.push(this.getValue(GRADE_LEVEL, index));
				}
			}.bind(this));
	
			return _.uniq(gradeLevels);
		};
	
		this.getClassroomTeacherEmail = function (classroom) {
			if (!this.hasColumn(TEACHER_EMAIL)) {
				return "";
			}
	
			var email = "";
			_.each(this.getColumn(CLASSROOM), function (oClassroom, index) {
				if (oClassroom == classroom) {
					email = this.getValue(TEACHER_EMAIL, index);
				}
			}.bind(this));
	
			return email;
		};
	
		this.allStudentsHaveRequiredColumns = function () {
			return _.all(REQUIRED_COLUMNS, function (col) {
				var colData = this.getColumn(col);
				return colData && _.all(colData, function (val) {
					return val != undefined && val.trim().length > 0;
				}.bind(this));
			}.bind(this));
		};
	
		/////////////////////////////////////////////
		// Gets mapped columns and column values ////
		/////////////////////////////////////////////
		this.mapColumns = function (mapping) {
			var newRosterData = {};
			_.each(_.keys(mapping), function (origCol) {
				newRosterData[mapping[origCol]] = this.getColumn(origCol);
			}.bind(this));
			return newRosterData;
		};
	
		this.mapColumnValues = function (column, mapping) {
			var newRosterData = _.clone(this.rosterData);
			_.each(this.rosterData[column], function (value, index) {
				var mappedValue = mapping[value];
				if (mappedValue.trim().length == 0) {
					mappedValue = column == GRADE_LEVEL ? "13" : "-";
				}
				this.rosterData[column][index] = mappedValue;
			}.bind(this));
			return newRosterData;
		};
	
		this.splitNameColumn = function () {
			var nameColumn = _.find(this.currentColumns(), function (column) {
				return column.toLowerCase().indexOf("name") != -1;
			});
	
			var newRosterData = _.clone(this.rosterData);
	
			if (nameColumn) {
				newRosterData[FIRST_NAME] = [];
				newRosterData[LAST_NAME] = [];
	
				_.each(this.getColumn(nameColumn), function (name) {
					// Reverse the string if it's "Last, First" format
					var names = name.split(",").reverse().join(" ").split(" ");
	
					// Assume the last word is the last name
					newRosterData[LAST_NAME].push(names.pop().trim());
	
					// Assume the rest of the string is the first name
					newRosterData[FIRST_NAME].push(names.join(" ").trim());
				});
	
				delete newRosterData[nameColumn];
			}
	
			return newRosterData;
		};
	
		this.mergeStudentIDs = function (indexToStudentIDs) {
			var newRosterData = _.clone(this.rosterData);
			newRosterData[STUDENT_ID] = [];
			for (var i = 0; i < newRosterData[FIRST_NAME].length; i++) {
				if (_.has(indexToStudentIDs, i)) {
					newRosterData[STUDENT_ID][i] = indexToStudentIDs[i] + "";
				} else {
					newRosterData[STUDENT_ID][i] = "";
				}
			}
	
			return newRosterData;
		};
	};
	
	var FIRST_NAME = "First Name";
	var LAST_NAME = "Last Name";
	var GRADE_LEVEL = "Grade Level";
	var CLASSROOM = "Classroom";
	var TEACHER_EMAIL = "Teacher Email";
	var PARENT_EMAIL = "Parent Email";
	var USERNAME = "Username";
	var PASSWORD = "Password";
	var STUDENT_ID = "Student ID";
	var WR_TEACHER_NAME = "WRTeacherName";
	var IGNORE = "Unknown";
	
	var REQUIRED_COLUMNS = [FIRST_NAME, LAST_NAME, GRADE_LEVEL, CLASSROOM];
	var OPTIONAL_COLUMNS = [TEACHER_EMAIL, PARENT_EMAIL, USERNAME, PASSWORD, IGNORE];
	var HIDDEN_COLUMNS = [WR_TEACHER_NAME];
	
	var VISIBLE_COLUMNS = REQUIRED_COLUMNS.concat(OPTIONAL_COLUMNS);
	var RECOGNIZED_COLUMNS = VISIBLE_COLUMNS.concat(HIDDEN_COLUMNS);
	
	StudentRoster.Columns = {
		FIRST_NAME: FIRST_NAME,
		LAST_NAME: LAST_NAME,
		GRADE_LEVEL: GRADE_LEVEL,
		CLASSROOM: CLASSROOM,
		TEACHER_EMAIL: TEACHER_EMAIL,
		PARENT_EMAIL: PARENT_EMAIL,
		USERNAME: USERNAME,
		PASSWORD: PASSWORD,
		IGNORE: IGNORE,
	
		REQUIRED_COLUMNS: REQUIRED_COLUMNS,
		OPTIONAL_COLUMNS: OPTIONAL_COLUMNS,
		VISIBLE_COLUMNS: VISIBLE_COLUMNS,
		RECOGNIZED_COLUMNS: RECOGNIZED_COLUMNS
	};
	
	var MIN_PASSWORD_LENGTH = 5;
	StudentRoster.MIN_PASSWORD_LENGTH = MIN_PASSWORD_LENGTH;
	
	module.exports = StudentRoster;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(22);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(75);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(76);
	var global = __webpack_require__(28);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(112) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(56);
	var SPECIES = __webpack_require__(37)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Save global object in a variable
	var __global__ =
	(typeof globalThis !== 'undefined' && globalThis) ||
	(typeof self !== 'undefined' && self) ||
	(typeof global !== 'undefined' && global);
	// Create an object that extends from __global__ without the fetch function
	var __globalThis__ = (function () {
	function F() {
	this.fetch = false;
	this.DOMException = __global__.DOMException
	}
	F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
	return new F();
	})();
	// Wraps whatwg-fetch with a function scope to hijack the global object
	// "globalThis" that's going to be patched
	(function(globalThis) {
	
	var irrelevant = (function (exports) {
	
	  var global =
	    (typeof globalThis !== 'undefined' && globalThis) ||
	    (typeof self !== 'undefined' && self) ||
	    (typeof global !== 'undefined' && global);
	
	  var support = {
	    searchParams: 'URLSearchParams' in global,
	    iterable: 'Symbol' in global && 'iterator' in Symbol,
	    blob:
	      'FileReader' in global &&
	      'Blob' in global &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in global,
	    arrayBuffer: 'ArrayBuffer' in global
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
	      throw new TypeError('Invalid character in header field name: "' + name + '"')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      /*
	        fetch-mock wraps the Response object in an ES6 Proxy to
	        provide useful test harness features such as flush. However, on
	        ES5 browsers without fetch or Proxy support pollyfills must be used;
	        the proxy-pollyfill is unable to proxy an attribute unless it exists
	        on the object before the Proxy is created. This change ensures
	        Response.bodyUsed exists on the instance, while maintaining the
	        semantic of setting Request.bodyUsed in the constructor before
	        _initBody is called.
	      */
	      this.bodyUsed = this.bodyUsed;
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          var isConsumed = consumed(this);
	          if (isConsumed) {
	            return isConsumed
	          }
	          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
	            return Promise.resolve(
	              this._bodyArrayBuffer.buffer.slice(
	                this._bodyArrayBuffer.byteOffset,
	                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
	              )
	            )
	          } else {
	            return Promise.resolve(this._bodyArrayBuffer)
	          }
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    if (!(this instanceof Request)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	
	    if (this.method === 'GET' || this.method === 'HEAD') {
	      if (options.cache === 'no-store' || options.cache === 'no-cache') {
	        // Search for a '_' parameter in the query string
	        var reParamSearch = /([?&])_=[^&]*/;
	        if (reParamSearch.test(this.url)) {
	          // If it already exists then set the value with the current time
	          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
	        } else {
	          // Otherwise add a new '_' parameter to the end with the current time
	          var reQueryString = /\?/;
	          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
	        }
	      }
	    }
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
	    // https://github.com/github/fetch/issues/748
	    // https://github.com/zloirock/core-js/issues/751
	    preProcessedHeaders
	      .split('\r')
	      .map(function(header) {
	        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
	      })
	      .forEach(function(line) {
	        var parts = line.split(':');
	        var key = parts.shift().trim();
	        if (key) {
	          var value = parts.join(':').trim();
	          headers.append(key, value);
	        }
	      });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!(this instanceof Response)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = global.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        setTimeout(function() {
	          resolve(new Response(body, options));
	        }, 0);
	      };
	
	      xhr.onerror = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request failed'));
	        }, 0);
	      };
	
	      xhr.ontimeout = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request failed'));
	        }, 0);
	      };
	
	      xhr.onabort = function() {
	        setTimeout(function() {
	          reject(new exports.DOMException('Aborted', 'AbortError'));
	        }, 0);
	      };
	
	      function fixUrl(url) {
	        try {
	          return url === '' && global.location.href ? global.location.href : url
	        } catch (e) {
	          return url
	        }
	      }
	
	      xhr.open(request.method, fixUrl(request.url), true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr) {
	        if (support.blob) {
	          xhr.responseType = 'blob';
	        } else if (
	          support.arrayBuffer &&
	          request.headers.get('Content-Type') &&
	          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
	        ) {
	          xhr.responseType = 'arraybuffer';
	        }
	      }
	
	      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
	        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
	          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
	        });
	      } else {
	        request.headers.forEach(function(value, name) {
	          xhr.setRequestHeader(name, value);
	        });
	      }
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!global.fetch) {
	    global.fetch = fetch;
	    global.Headers = Headers;
	    global.Request = Request;
	    global.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  return exports;
	
	})({});
	})(__globalThis__);
	// This is a ponyfill, so...
	__globalThis__.fetch.ponyfill = true;
	delete __globalThis__.fetch.polyfill;
	// Choose between native implementation (__global__) or custom implementation (__globalThis__)
	var ctx = __global__.fetch ? __global__ : __globalThis__;
	exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
	exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
	exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
	exports.Headers = ctx.Headers
	exports.Request = ctx.Request
	exports.Response = ctx.Response
	module.exports = exports
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "854552cf3155a6a04595a7556d4f9876.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ebcf8bba7d55e4158645d7a54b32b0e.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54eb8f56fdf083e756db4a6782e1d8d1.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var DataSelectors = __webpack_require__(54);
	var DataActions = __webpack_require__(65);
	
	var QuizWidget = __webpack_require__(772);
	var GoalsWidget = __webpack_require__(771);
	var BookWidget = __webpack_require__(770);
	var WritingWidget = __webpack_require__(773);
	
	var WidgetConfig = __webpack_require__(66);
	var WidgetItemsConfig = __webpack_require__(260);
	
	__webpack_require__(3655);
	
	var WidgetContainer = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var userID = props.userID,
	      widgetParams = props.widgetParams;
	  // select user from Redux
	
	  if (widgetParams.topLevelDigest == WidgetConfig.STUDENT_ENTITY_TYPE) {
	    var user = RosterSelectors.student({ state: state, id: userID });
	  } else {
	    var user = RosterSelectors.admin({ state: state, id: userID });
	  }
	  var widgets = DataSelectors.widgetDigests({ state: state, entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), entity_id: user.id });
	  var nonEmptyWidgets = _underscore2.default.filter(widgets, function (widget) {
	    return !_underscore2.default.isEmpty(widget) && widget.period == "period";
	  });
	  var showEmptyState = WidgetConfig.showEmptyState(nonEmptyWidgets);
	
	  return { user: user, showEmptyState: showEmptyState };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var _props$widgetParams = props.widgetParams,
	          adminID = _props$widgetParams.adminID,
	          topLevelDigest = _props$widgetParams.topLevelDigest;
	
	
	      var fetchPromises = [];
	
	      // fetch admin or student data
	      fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { adminID: adminID } })));
	      // based on type of widget container, we need to pull in additional digests
	      if (topLevelDigest == WidgetConfig.STUDENT_ENTITY_TYPE) {
	        // we need to make sure the student digests are loaded 
	        // student list digests are used for comparisons
	        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: topLevelDigest, adminID: adminID } })));
	        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, adminID: adminID } })));
	      }
	      return Promise.all(fetchPromises);
	    },
	    fetchDigests: function fetchDigests(periodWidgetDigests, user) {
	      var digest = _underscore2.default.first(periodWidgetDigests);
	
	      if (!_underscore2.default.isEmpty(periodWidgetDigests) && !_underscore2.default.isEmpty(digest)) {
	        var startDate = digest.start_date;
	        var endDate = digest.end_date;
	      } else if (!_underscore2.default.isEmpty(user) && !_underscore2.default.isEmpty(user.expectations_date_spans)) {
	        var startDate = user.expectations_date_spans[0].start;
	        var endDate = user.expectations_date_spans[0].end;
	      } else {
	        // default begining and end of month
	        var date = new Date();
	        var startDate = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
	        var endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
	      }
	      return dispatch(DataActions.fetchDigests({ conditions: { startDate: startDate, endDate: endDate }, cache: true }));
	    },
	    selectWidgetDigests: function selectWidgetDigests(conditions) {
	      // pulls multiple widget digests for situations where we need to pull multiple current widget digests
	      // i.e. teacher pulling all current SL widget digests
	      return dispatch(function (dispatch, getState) {
	        return DataSelectors.widgetDigests({ state: getState(), conditions: conditions });
	      });
	    },
	    selectStudentList: function selectStudentList(id) {
	      return dispatch(function (dispatch, getState) {
	        return RosterSelectors.studentList({ state: getState(), id: id });
	      });
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(WidgetContainer, _React$Component);
	
	  function WidgetContainer(props) {
	    _classCallCheck(this, WidgetContainer);
	
	    var _this = _possibleConstructorReturn(this, (WidgetContainer.__proto__ || Object.getPrototypeOf(WidgetContainer)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("WidgetContainer");
	    return _this;
	  }
	
	  // selects appropriate widget digests based on user role
	
	
	  _createClass(WidgetContainer, [{
	    key: "getWidgetDigests",
	    value: function getWidgetDigests(currentPeriod) {
	      var _props = this.props,
	          user = _props.user,
	          widgetParams = _props.widgetParams,
	          selectWidgetDigests = _props.selectWidgetDigests,
	          selectStudentList = _props.selectStudentList;
	      var period = widgetParams.period;
	
	      // we pull in period, current, yearly digests for specific widget items
	      // (i.e. 'New Quizzes' need current digest)
	
	      var periodConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), current_period: true, period: period };
	      var currentConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), period: 'current' };
	      var yearlyConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), current_period: true, period: 'yearly' };
	
	      switch (user.role) {
	        // students will pull in their student lists
	        // for comparison purposes
	        case WidgetConfig.STUDENT_ROLE:
	          var slID = user.primary_student_list_id;
	          var compConditions = { period: period, entity_id: slID, entity_type: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, current_period: true };
	          var compSize = _underscore2.default.size(_underscore2.default.pluck(selectStudentList(slID), 'students'));
	          var compScope = 'Class';
	          return {
	            periodWidgetDigests: selectWidgetDigests(_extends({}, periodConditions, { entity_id: user.id })),
	            currentWidgetDigests: selectWidgetDigests(_extends({}, currentConditions, { entity_id: user.id })),
	            compWidgetDigests: selectWidgetDigests(_extends({}, compConditions, { entity_id: slID })),
	            yearlyWidgetDigests: selectWidgetDigests(_extends({}, yearlyConditions, { entity_id: user.id })),
	            compSize: compSize, compScope: compScope
	          };
	        default:
	          return {
	            periodWidgetDigests: selectWidgetDigests(periodConditions),
	            currentWidgetDigests: selectWidgetDigests(currentConditions),
	            yearlyWidgetDigests: selectWidgetDigests(yearlyConditions)
	          };
	      }
	    }
	  }, {
	    key: "componentLookup",
	    value: function componentLookup(widget_name) {
	      var user = this.props.user;
	
	      var widgetDigests = this.getWidgetDigests(true);
	
	      switch (widget_name) {
	        case WidgetConfig.QUIZ_WIDGET:
	          return React.createElement(QuizWidget, _extends({}, widgetDigests, { user: user, key: widget_name, showEmptyState: this.props.showEmptyState }));
	
	        case WidgetConfig.GOALS_WIDGET:
	          this.props.fetchDigests(widgetDigests.periodWidgetDigests, user);
	          return React.createElement(GoalsWidget, _extends({}, widgetDigests, { user: user, key: widget_name, showEmptyState: this.props.showEmptyState }));
	
	        case WidgetConfig.BOOK_WIDGET:
	          return React.createElement(BookWidget, _extends({}, widgetDigests, { user: user, key: widget_name, showEmptyState: this.props.showEmptyState }));
	
	        case WidgetConfig.WRITING_WIDGET:
	          return React.createElement(WritingWidget, _extends({}, widgetDigests, { user: user, key: widget_name, showEmptyState: this.props.showEmptyState }));
	      }
	    }
	  }, {
	    key: "renderWidgets",
	    value: function renderWidgets() {
	      var _this2 = this;
	
	      // loop through widgets in user digest
	      // render appropriate component
	      return _underscore2.default.map(WidgetConfig.getWidgetItemsConfig(this.props.userRole), function (widget) {
	        var key = _underscore2.default.first(_underscore2.default.keys(widget));
	        return _this2.componentLookup(key);
	      });
	    }
	  }, {
	    key: "showEmptyState",
	    value: function showEmptyState() {
	      // first, filter out comp digests
	      var widgetDigests = _underscore2.default.filter(this.getWidgetDigests(false), function (v, k) {
	        return k == 'periodWidgetDigests' || k == 'currentWidgetDigests' || k == 'yearlyWidgetDigests';
	      });
	
	      // then, create array of data hashes from digests
	      var widgetDigestData = _underscore2.default.pluck(_underscore2.default.flatten(_underscore2.default.values(widgetDigests)), 'data');
	
	      // sums values of all keys that we want to check on the dashboards
	      // all must be 0 to show empty state
	      var checkValues = _underscore2.default.map(widgetDigestData, function (dataHash) {
	        return _underscore2.default.filter(dataHash, function (val, key) {
	          return _underscore2.default.includes(WidgetItemsConfig.NON_GOAL_METRICS, key);
	        }).reduce(function (partialSum, a) {
	          return partialSum + a;
	        }, 0);
	      });
	
	      if (_underscore2.default.isEmpty(widgetDigestData)) {
	        // if widget digests don't exist, show empty state
	        return true;
	      } else if (!_underscore2.default.any(checkValues, function (metric) {
	        return metric > 0;
	      })) {
	        // if all metrics are 0, show empty state
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var user = this.props.user;
	
	
	      if (this.props.showEmptyState) {
	        var placeholderDisclaimer = React.createElement(
	          "div",
	          { className: "placeholderDisclaimer" },
	          "Currently displaying placeholder data"
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { className: "widgetContainer " + WidgetConfig.getEntityTypeByUserRole(user.role) },
	        placeholderDisclaimer,
	        React.createElement(
	          "div",
	          { className: "allWidgets" },
	          this.renderWidgets()
	        )
	      );
	    }
	  }]);
	
	  return WidgetContainer;
	}(React.Component)) || _class) || _class);
	;
	
	WidgetContainer.WrappedComponent.propTypes = PageStrictPropTypes({
	  // @connect handlers
	  populateData: PropTypes.func,
	  user: PropTypes.object,
	  selectStudentList: PropTypes.func,
	  selectWidgetDigests: PropTypes.func,
	  fetchDigests: PropTypes.func,
	
	  userID: PropTypes.number,
	  widgetParams: PropTypes.object,
	  forStudent: PropTypes.bool,
	  showEmptyState: PropTypes.bool
	});
	
	module.exports = WidgetContainer;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _CurrentUser = __webpack_require__(3);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DropDownOptions = __webpack_require__(26);
	var NumbersOnlyInput = __webpack_require__(122);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdown = __webpack_require__(23);
	var Glyphicon = __webpack_require__(8);
	var StudentMetrics = __webpack_require__(29);
	var AccountPlans = __webpack_require__(53);
	
	var EditableGoals = function EditableGoals(props) {
		var _this = this;
	
		LuckyOrangeClient.tagComponent("EditableGoals");
	
		////// HELPER //////
		var isPremiumAccount = function isPremiumAccount() {
			return _CurrentUser2.default.get() && _CurrentUser2.default.isPremiumOrTrialAccount() || _CurrentUser2.default.role == "adminRole";
		};
	
		var getExpectationMetric = function getExpectationMetric() {
			return props.prefs.grade_level_expectations_metrics[props.gradeLevel ? props.gradeLevel : "5"];
		};
	
		////// METRICS //////
		if (isPremiumAccount()) {
			var defaultGoals = [].concat(FREE_GOALS, PREMIUM_GOALS);
		} else {
			var defaultGoals = FREE_GOALS;
		}
	
		// metrics that are assigned by admin
		var assignedExpectations = getExpectationMetric().filter(function (_ref) {
			var metric = _ref.metric,
			    goal = _ref.goal;
	
			return metric !== "quizzes-passed";
		});
	
		// metrics that are not currently assigned
		var notAssignedExpectations = _underscore2.default.filter(defaultGoals, function (goal) {
			return !_underscore2.default.includes(_underscore2.default.pluck(assignedExpectations, 'metric'), goal.metric);
		});
	
		// combine assigned and not assigned expectations
		var expectations = _underscore2.default.uniq(assignedExpectations.concat(notAssignedExpectations));
	
		////// GOAL MANIPULATORS //////
		// edits student goals
		var editStudentGoals = function editStudentGoals(editedMetric, editedGoal) {
			var expectations = getExpectationMetric();
			var newExpectations = expectations.map(function (_ref2) {
				var metric = _ref2.metric,
				    goal = _ref2.goal;
	
				if (metric === editedMetric) {
					return { metric: metric, goal: editedGoal };
				} else {
					return { metric: metric, goal: goal };
				}
			});
			var gradeLevelExpectationsMetrics = _extends({}, props.prefs.grade_level_expectations_metrics);
			gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations;
			props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics });
		};
	
		// adds new student goal
		var addStudentGoal = function addStudentGoal(metric, goal) {
			var expectations = getExpectationMetric();
			var newExpectations = [].concat(_toConsumableArray(expectations), [{ metric: metric, goal: goal }]);
			var gradeLevelExpectationsMetrics = _extends({}, props.prefs.grade_level_expectations_metrics);
			gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations;
			props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics });
		};
	
		// removes student goal
		var removeStudentGoal = function removeStudentGoal(metric) {
			var expectations = getExpectationMetric();
			var newExpectations = _underscore2.default.compact(_underscore2.default.filter(expectations, function (exp) {
				return exp.metric !== metric;
			}));
			var gradeLevelExpectationsMetrics = _extends({}, props.prefs.grade_level_expectations_metrics);
			gradeLevelExpectationsMetrics[props.gradeLevel] = newExpectations;
			props.onEditPrefs({ "grade_level_expectations_metrics": gradeLevelExpectationsMetrics });
		};
	
		// dispatch to either add or remove goal metric
		var updateSelectedGoals = function updateSelectedGoals(metric) {
			if (_underscore2.default.size(assignedMetrics) >= 3 && !_underscore2.default.includes(assignedMetrics, metric)) {
				return false;
			}
	
			if (_underscore2.default.includes(assignedMetrics, metric)) {
				removeStudentGoal(metric);
			} else {
				var defaultGoal = _underscore2.default.findWhere(defaultGoals, { metric: metric }).goal;
				addStudentGoal(metric, defaultGoal);
			}
		};
	
		////// MORE HELPERS //////
		// helper for clarification
		var isStudentDisplay = props.student;
	
		// helper for time period name
		var periodName = $wr.capitalize($wr.Constants.PERIOD_TO_NAME[props.prefs.expectations_time_period]).toLowerCase();
	
		// helper to pull metrics
		var assignedMetrics = _underscore2.default.pluck(assignedExpectations, 'metric');
	
		// determines if metric should be read-only
		var disableInput = function disableInput(metric) {
			if (metric === "quizzes-passed") {
				return false;
			}
			return _underscore2.default.size(assignedExpectations) >= 3 && !_underscore2.default.includes(assignedMetrics, metric);
		};
	
		// detrmines if metric checkbox should be checked
		var isChecked = function isChecked(metric) {
			return _underscore2.default.includes(assignedMetrics, metric);
		};
	
		// retuns id if indexKey is present
		var addID = function addID(fieldType, metric) {
			return props.indexKey ? { id: fieldType + '-' + metric + '-' + props.indexKey } : {};
		};
	
		var expectationTimePerodMatches = function expectationTimePerodMatches() {
			return props.prefs.expectations_time_period == props.slExpectationTimePeriod;
		};
	
		// determines if a metric is user-specific
		var isCustomMetric = function isCustomMetric(metric, goal) {
			var expectation = _underscore2.default.findWhere(props.slExpectations, { metric: metric });
			return !expectation || !expectationTimePerodMatches() ? true : expectation['goal'] !== goal;
		};
	
		////// SUPPLEMENTAL GOALS //////
		var renderGoal = function renderGoal(_ref3) {
			var metric = _ref3.metric,
			    goal = _ref3.goal;
	
			var disableClass = disableInput(metric) ? 'disableClass' : '';
	
			if (metric !== "quizzes-passed") {
				var checkbox = React.createElement('input', _extends({ className: 'goalMetricSelector'
				}, addID('checkbox', metric), {
					type: 'checkbox', checked: isChecked(metric),
					onChange: function onChange(e) {
						return updateSelectedGoals(metric);
					} }));
			}
	
			if (isStudentDisplay && isCustomMetric(metric, goal)) {
				var tooltipText = "The goal differs from student list default";
				var iconText = metric !== "quizzes-passed" ? 'This goal differs from the class goal' : '';
	
				var userIcon = React.createElement(
					'span',
					null,
					React.createElement(Glyphicon, { className: 'userIcon', icon: 'user', dataTip: tooltipText }),
					' ',
					iconText
				);
			}
	
			if (isChecked(metric) || metric === 'quizzes-passed') {
				var numbersOnlyInput = React.createElement(
					'span',
					null,
					React.createElement(NumbersOnlyInput, _extends({ value: parseInt(goal || 0)
					}, addID('input', metric), {
						className: 'withFrequency',
						onChange: function onChange(e) {
							return editStudentGoals(metric, parseInt(e.target.value || 0));
						} })),
					React.createElement(
						'span',
						{ className: 'frequency' },
						'/ ',
						periodName,
						' ',
						userIcon
					)
				);
			}
	
			return React.createElement(
				'label',
				{ className: "inputPair " + disableClass, key: metric },
				checkbox,
				React.createElement(
					'span',
					{ className: 'goalMeticText text' },
					StudentMetrics.getLabel(metric)
				),
				numbersOnlyInput
			);
		};
	
		var updateQuestionCount = function updateQuestionCount(update) {
			var gradeLevelQuestionCount = _extends({}, props.prefs.grade_level_question_count);
			gradeLevelQuestionCount[props.gradeLevel] = _extends({}, gradeLevelQuestionCount[props.gradeLevel], update);
			props.onEditPrefs({ "grade_level_question_count": gradeLevelQuestionCount });
		};
	
		var supplementalExpectations = expectations.filter(function (_ref4) {
			var metric = _ref4.metric,
			    goal = _ref4.goal;
	
			return metric !== "quizzes-passed";
		});
		var supplementalGoalInputs = supplementalExpectations.map(renderGoal);
	
		////// QUIZ GOALS //////
		var quizExpectation = getExpectationMetric().find(function (_ref5) {
			var metric = _ref5.metric,
			    goal = _ref5.goal;
	
			return metric === "quizzes-passed";
		});
		if (quizExpectation) {
			var quizGoalInput = renderGoal(quizExpectation);
		}
	
		var question_count = props.prefs.grade_level_question_count[props.gradeLevel ? props.gradeLevel : "5"];
		if (isPremiumAccount()) {
			var recallQuestionCount = question_count.recall_question_count;
			var fitbInput = React.createElement(
				'label',
				{ className: 'inputPair' },
				React.createElement(
					'span',
					{ className: 'FITBSelector text' },
					'Fill-in-the-Blank'
				),
				React.createElement(
					'select',
					_extends({ type: 'text', value: recallQuestionCount
					}, addID('select', 'fitb'), {
						onChange: function onChange(e) {
							return updateQuestionCount({ "recall_question_count": parseInt(e.target.value) });
						} }),
					DropDownOptions.Select.RecallQuestionCount()
				)
			);
		}
	
		if (question_count.sentence_starter_count > 0) {
			var analysis_count = question_count.sentence_starter_count;
			var sentence_starter = "On";
		} else {
			var analysis_count = question_count.analysis_question_count;
			var sentence_starter = "Off";
		}
	
		var updateOpenEnded = function updateOpenEnded(which, value) {
			if (which === "question_count") {
				if (props.prefs.sentence_starter_count > 0) {
					updateQuestionCount({ "sentence_starter_count": parseInt(value), "analysis_question_count": 0 });
				} else {
					updateQuestionCount({ "sentence_starter_count": 0, "analysis_question_count": parseInt(value) });
				}
			} else {
				if (value == "On") {
					updateQuestionCount({ "sentence_starter_count": analysis_count, "analysis_question_count": 0 });
				} else {
					updateQuestionCount({ "sentence_starter_count": 0, "analysis_question_count": analysis_count });
				}
			}
		};
	
		var openEndedInput = React.createElement(
			'label',
			{ className: 'inputPair' },
			React.createElement(
				'span',
				{ className: 'text' },
				'Open-Ended'
			),
			React.createElement(
				'select',
				_extends({ type: 'text', value: analysis_count
				}, addID('select', 'open-ended'), {
					onChange: function onChange(e) {
						return updateOpenEnded("question_count", e.target.value);
					} }),
				DropDownOptions.Select.AnalysisQuestionCount()
			)
		);
	
		if (analysis_count > 0) {
			var sentenceStarterInput = React.createElement(
				'label',
				{ className: 'inputPair' },
				React.createElement(
					'span',
					{ className: 'text' },
					'Sentence Starters'
				),
				React.createElement(
					'select',
					_extends({ type: 'text', value: sentence_starter
					}, addID('select', 'sentence-starters'), {
						onChange: function onChange(e) {
							return updateOpenEnded("sentence_starter", e.target.value);
						} }),
					DropDownOptions.Select.SentenceStarter()
				)
			);
		}
	
		////// FREQENCY SELECTOR //////
		var selectStartOfWeek = function selectStartOfWeek(day) {
			props.onEditPrefs({ "expectations_time_period_starts": [day] });
		};
	
		var selectStartDate = function selectStartDate(periodStartPosition, periodStartDate) {
	
			var newPeriodStartsArray = _underscore2.default.clone(props.prefs.expectations_time_period_starts);
			newPeriodStartsArray[periodStartPosition] = (0, _moment2.default)(periodStartDate).format("YYYY-MM-DD");
			props.onEditPrefs({ "expectations_time_period_starts": newPeriodStartsArray });
		};
	
		var selectTimePeriod = function selectTimePeriod(timePeriod) {
			if (timePeriod == $wr.Constants.PERIODS.WEEK) {
				var defaultPeriodStart = [0];
			} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
				var defaultPeriodStart = [1];
			} else {
				var startMonth = props.prefs.school_year_start_month;
				var currentYear = new Date().getFullYear();
				var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];
	
				if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
				} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
				} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
					defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
				}
			}
			var change = { 'expectations_time_period': timePeriod, 'expectations_time_period_starts': defaultPeriodStart };
			props.onEditPrefs(change);
		};
	
		var renderDatePickerForIndex = function renderDatePickerForIndex(index) {
			return React.createElement(_reactDatepicker2.default, { className: 'startDatePicker',
				onChange: function onChange(date) {
					return selectStartDate(index, date);
				}, readOnly: true,
				selected: (0, _moment2.default)(props.prefs.expectations_time_period_starts[index]) });
		};
		var renderFrequencyStartSelect = function renderFrequencyStartSelect(frequencyType) {
			var currentPeriodStarts = props.prefs.expectations_time_period_starts;
	
			if (frequencyType == $wr.Constants.PERIODS.WEEK) {
				var weekdayOptions = DropDownOptions.Button.DaysOfWeek({
					includeWeeklyRange: true,
					buildOptionF: function (day) {
						return selectStartOfWeek.bind(this, day);
					}.bind(_this)
				});
	
				if ($wr.isValidDayOfWeek(currentPeriodStarts[0]) && $wr.isValidDayOfWeek((currentPeriodStarts[0] + 6) % 7)) {
					var currentWeekdayText = $wr.getDayOfWeek(currentPeriodStarts[0]) + " - " + $wr.getDayOfWeek((currentPeriodStarts[0] + 6) % 7) || 0;
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						React.createElement(
							'span',
							{ className: 'periodSelectorLabel' },
							'From:'
						),
						React.createElement(
							ButtonDropdown,
							{ text: currentWeekdayText,
								dropdownDisplay: 'link', className: 'formatControl' },
							weekdayOptions
						)
					);
				}
			} else if (frequencyType == $wr.Constants.PERIODS.QUARTER) {
				var freqStartSelect = React.createElement(
					'div',
					{ className: 'periodStartSelector' },
					'Quarter 1 Starts:',
					renderDatePickerForIndex(0),
					React.createElement('br', null),
					'Quarter 2 Starts:',
					renderDatePickerForIndex(1),
					React.createElement('br', null),
					'Quarter 3 Starts:',
					renderDatePickerForIndex(2),
					React.createElement('br', null),
					'Quarter 4 Starts:',
					renderDatePickerForIndex(3)
				);
			} else if (frequencyType == $wr.Constants.PERIODS.TRIMESTER) {
				var freqStartSelect = React.createElement(
					'div',
					{ className: 'periodStartSelector' },
					'Trimester 1 Starts:',
					renderDatePickerForIndex(0),
					React.createElement('br', null),
					'Trimester 2 Starts:',
					renderDatePickerForIndex(1),
					React.createElement('br', null),
					'Trimester 3 Starts:',
					renderDatePickerForIndex(2)
				);
			} else if (frequencyType == $wr.Constants.PERIODS.SEMESTER) {
				var freqStartSelect = React.createElement(
					'div',
					{ className: 'periodStartSelector' },
					'Semester 1 Starts:',
					renderDatePickerForIndex(0),
					React.createElement('br', null),
					'Semester 2 Starts:',
					renderDatePickerForIndex(1)
				);
			} else if (frequencyType == $wr.Constants.PERIODS.SCHOOL_YEAR) {
				var freqStartSelect = React.createElement(
					'div',
					{ className: 'periodStartSelector' },
					'School Year Starts:',
					renderDatePickerForIndex(0)
				);
			} else {
				var freqStartSelect = React.createElement('span', null);
			}
	
			return freqStartSelect;
		};
	
		var renderFrequencySelector = function renderFrequencySelector(frequencyText, frequencyType) {
			var currentlySelected = props.prefs.expectations_time_period == frequencyType;
			if (currentlySelected) {
				var startSelect = renderFrequencyStartSelect(frequencyType);
			}
			return React.createElement(
				'span',
				{ className: 'inputFrequency', key: frequencyText },
				React.createElement(
					'span',
					{ className: 'formOption' },
					React.createElement('input', _extends({ type: 'radio', className: 'frequencyRadioBtn', checked: currentlySelected
					}, addID('radio', '' + frequencyType), {
						onChange: function onChange(e) {
							return selectTimePeriod(frequencyType);
						} })),
					React.createElement(
						'span',
						null,
						frequencyText
					)
				),
				startSelect
			);
		};
	
		var showHeader = function showHeader() {
			return !props.hideHeader || props.hideHeader == false;
		};
	
		////// RENDER METHODS //////
		if (props.quiz) {
			var quizDisplay = React.createElement(
				'div',
				{ className: 'goalSectionContainer' },
				React.createElement(
					'div',
					{ className: 'studentSectionHeader' },
					'Quizzes'
				),
				quizGoalInput,
				fitbInput,
				openEndedInput,
				sentenceStarterInput
			);
		}
	
		if (props.supplemental) {
			var supplementalDisplay = React.createElement(
				'div',
				{ className: 'goalSectionContainer' },
				React.createElement(
					'div',
					{ className: 'studentSectionHeader' },
					'Supplemental'
				),
				supplementalGoalInputs
			);
		}
	
		if (props.periodSelector) {
			if (showHeader(props)) {
				var header = React.createElement(
					'div',
					{ className: 'studentSectionHeader' },
					'Time Period'
				);
			}
			var frequencySelectorDisplay = React.createElement(
				'div',
				{ className: 'goalSectionContainer' },
				header,
				React.createElement(
					'div',
					null,
					renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK),
					React.createElement('br', null),
					renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH),
					React.createElement('br', null),
					renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER),
					React.createElement('br', null),
					renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER),
					React.createElement('br', null),
					renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER),
					React.createElement('br', null),
					renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR),
					React.createElement('br', null)
				)
			);
		}
	
		return React.createElement(
			'div',
			null,
			quizDisplay,
			supplementalDisplay,
			frequencySelectorDisplay
		);
	};
	
	var FREE_GOALS = [{ goal: 4, metric: "questions" }, { goal: 4, metric: "reviews" }, { goal: 2, metric: "question-builder" }, { goal: 10, metric: "days-active" }];
	
	var PREMIUM_GOALS = [{ goal: 2, metric: 'exercises' }, { goal: 100, metric: 'minutes' }, { goal: 100, metric: 'pages' }];
	
	EditableGoals.propTypes = StrictPropTypes({
		prefs: PropTypes.object.isRequired,
		gradeLevel: PropTypes.string,
		onEditPrefs: PropTypes.func.isRequired,
		supplemental: PropTypes.bool,
		hideHeader: PropTypes.bool,
		quiz: PropTypes.bool,
		periodSelector: PropTypes.bool,
		student: PropTypes.bool,
		slExpectations: PropTypes.array,
		slExpectationTimePeriod: PropTypes.string,
		indexKey: PropTypes.number
	});
	
	module.exports = EditableGoals;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3710);
	
	var RosterUploadButtons = function (_React$Component) {
		_inherits(RosterUploadButtons, _React$Component);
	
		function RosterUploadButtons(props) {
			_classCallCheck(this, RosterUploadButtons);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadButtons.__proto__ || Object.getPrototypeOf(RosterUploadButtons)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(RosterUploadButtons, [{
			key: "confirmChanges",
			value: function confirmChanges(e) {
				$wr.nope(e);
				this.props.confirmChanges();
			}
		}, {
			key: "next",
			value: function next(e) {
				$wr.nope(e);
				this.props.nextStage();
			}
		}, {
			key: "back",
			value: function back(e) {
				$wr.nope(e);
				this.props.nextStage(true);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.editMode) {
					if (this.props.forceEdits) {
						var forceText = React.createElement(
							"p",
							null,
							React.createElement(
								"em",
								null,
								"You must make edits to your student data to proceed."
							)
						);
					} else {
						var cancelButton = React.createElement(
							"button",
							{ className: "btn btn-link", onClick: this.props.toggleEditMode },
							"Restore"
						);
					}
	
					return React.createElement(
						"div",
						{ className: "rosterUploadButtons" },
						forceText,
						React.createElement(
							"div",
							{ className: "text-center clearfix" },
							React.createElement(
								"button",
								{ className: "btn buttonDefault pull-left", onClick: this.back },
								React.createElement(Glyphicon, { icon: "arrow-left" }),
								" Back"
							),
							React.createElement(
								"button",
								{ className: "btn buttonSuccess", onClick: this.confirmChanges },
								"Confirm Changes"
							),
							cancelButton
						)
					);
				} else {
					if (!this.props.finalStage) {
						var editButton = React.createElement(
							"button",
							{ className: "btn btn-link", onClick: this.props.toggleEditMode },
							"Edit ",
							this.props.noun
						);
					}
	
					if (this.props.nextStage) {
						var nextButton = React.createElement(
							"button",
							{ className: "btn buttonSuccess pull-right", onClick: this.next },
							React.createElement(Glyphicon, { icon: "arrow-right" }),
							" ",
							this.props.finalStage ? "Finish" : "Next"
						);
					}
	
					return React.createElement(
						"div",
						{ className: "rosterUploadButtons" },
						React.createElement(
							"div",
							{ className: "clearfix text-center" },
							React.createElement(
								"button",
								{ className: "btn buttonDefault pull-left", onClick: this.back },
								React.createElement(Glyphicon, { icon: "arrow-left" }),
								" Back"
							),
							editButton,
							nextButton
						)
					);
				}
			}
		}]);
	
		return RosterUploadButtons;
	}(React.Component);
	
	;
	
	RosterUploadButtons.propTypes = StrictPropTypes({
		// What are we editing?
		noun: PropTypes.string,
	
		// If true, show the edit controls
		editMode: PropTypes.bool,
	
		// Don't allow restoring from editMode
		forceEdits: PropTypes.bool,
	
		// For the final state, use different text and hide edits
		finalStage: PropTypes.bool,
	
		// Needed unless finalStage is true to handle edits
		toggleEditMode: PropTypes.func,
		confirmChanges: PropTypes.func,
	
		nextStage: PropTypes.func.isRequired
	});
	
	module.exports = RosterUploadButtons;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3721);
	
	var BookRating = function BookRating(props) {
	
		var maxRating = props.maxRating == undefined ? BookRating.DEFAULT_MAX_RATING : props.maxRating;
	
		// We may want to make these props at some point
		var iconWidth = 36;
		var iconPadding = 1; // Left and right
	
		var iconStyle = { width: iconWidth, paddingRight: iconPadding, paddingLeft: iconPadding };
	
		// We want the last star to be in a span that has all
		// earlier stars. This will help with hover functionality
		var outermostBox = undefined;
	
		_.times(maxRating, function (index) {
			// Opposite of index
			var rateValue = maxRating - index;
			var className = "rateIcon";
			if (props.currentRating != null && rateValue <= props.currentRating) {
				className += " active";
			}
	
			var onSelect = function onSelect(e) {
				if (props.onChange && rateValue != props.currentRating) {
					props.onChange(rateValue);
				}
			};
	
			var icon = React.createElement("img", { className: className, onClick: onSelect, style: iconStyle,
				src: __webpack_require__(187), key: rateValue });
			outermostBox = React.createElement(
				"span",
				{ className: "nestedIconBox" },
				icon,
				outermostBox
			);
		});
	
		var className = "bookRating";
		if (props.editable) {
			className += " editable";
		}
	
		if (props.currentRating && props.currentRating % 1 != 0) {
			var partialValue = props.currentRating % 1;
			var leftDistance = (props.currentRating - partialValue) * iconWidth;
	
			var partialWrapStyle = {
				width: partialValue * iconWidth, left: leftDistance
			};
	
			// Make a partially filled star
			var partialIcon = React.createElement(
				"span",
				{ className: "partialIconWrap", style: partialWrapStyle },
				React.createElement("img", { className: "rateIcon active", style: { width: iconWidth },
					src: __webpack_require__(187) })
			);
		}
	
		return React.createElement(
			"span",
			{ className: className },
			outermostBox,
			partialIcon
		);
	};
	
	BookRating.DEFAULT_MAX_RATING = 5;
	
	BookRating.propTypes = StrictPropTypes({
		// Max rating (i.e. number of stars). Default to BookRating.DEFAULT_MAX_RATING
		maxRating: PropTypes.number,
	
		// Current rating (min 1)
		currentRating: PropTypes.number,
	
		// If true, stars show editing behavior on hover
		editable: PropTypes.bool,
	
		// Passes a selected rating back up to the parent (only if it's a change)
		onChange: PropTypes.func
	});
	
	module.exports = BookRating;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CoinDetailsModal = __webpack_require__(852);
	var CoinDisplay = __webpack_require__(121);
	var QuestionTypes = __webpack_require__(82);
	
	var WritingSelectors = __webpack_require__(14);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3739);
	
	var CoinsEarnedDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var coinRecords = RosterSelectors.coinRecordsForSubject({ state: state,
			subjectType: props.subjectType, subjectID: props.subjectID });
	
		var evaluation = WritingSelectors.evaluationForSubject({
			state: state, subjectType: props.subjectType, subjectID: props.subjectID
		});
	
		var selfOpenModal = $wr.getURLParameterByName("showDetails") == "true";
	
		if (props.subjectType == "Quiz") {
			var subject = WritingSelectors.quiz({ state: state, id: props.subjectID });
		} else if (props.subjectType == "Answer") {
			var subject = WritingSelectors.answer({ state: state, id: props.subjectID });
		}
	
		return {
			evaluation: evaluation, selfOpenModal: selfOpenModal, subject: subject, coinRecords: coinRecords
		};
	}, function () {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(CoinsEarnedDisplay, _React$Component);
	
		function CoinsEarnedDisplay(props) {
			_classCallCheck(this, CoinsEarnedDisplay);
	
			var _this = _possibleConstructorReturn(this, (CoinsEarnedDisplay.__proto__ || Object.getPrototypeOf(CoinsEarnedDisplay)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(CoinsEarnedDisplay, [{
			key: "openCoinDetailsModal",
			value: function openCoinDetailsModal(e) {
				$wr.nope(e);
				this.refs.coinsModal.show();
			}
		}, {
			key: "subjectNoun",
			value: function subjectNoun() {
				if (this.props.subjectType == "Quiz") {
					return "quizzes";
				} else if (this.props.subjectType == "Answer") {
					if (this.props.subject.question_type == QuestionTypes.REVIEW_QUESTION) {
						return "reviews";
					} else {
						return "answers";
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var totalCoinsEarned = 0;
				_.map(this.props.coinRecords, function (coinRecord) {
					totalCoinsEarned += coinRecord.change;
				});
				var coinsModal = React.createElement(CoinDetailsModal, { ref: "coinsModal", coinRecords: this.props.coinRecords,
					evaluation: this.props.evaluation,
					subjectNoun: this.subjectNoun(), subjectID: this.props.subjectID,
					subject: this.props.subject });
				if (this.props.subject.excluded) {
					var className = "excluded";
				}
	
				return React.createElement(
					"div",
					{ className: "hideOnPrint coinsEarnedDisplay" },
					React.createElement(
						"p",
						{ className: className },
						"Coins Earned:",
						" ",
						React.createElement(CoinDisplay, { coins: totalCoinsEarned, height: 20 }),
						React.createElement(
							"a",
							{ href: "#", onClick: this.openCoinDetailsModal },
							"Details"
						)
					),
					coinsModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.selfOpenModal) {
					this.openCoinDetailsModal();
				}
			}
		}]);
	
		return CoinsEarnedDisplay;
	}(React.Component)) || _class);
	;
	
	CoinsEarnedDisplay.WrappedComponent.propTypes = StrictPropTypes({
		// Quiz, Answer
		subjectType: PropTypes.string.isRequired,
		subjectID: PropTypes.number.isRequired,
	
		// data from @connect
		coinRecords: PropTypes.array.isRequired,
		selfOpenModal: PropTypes.bool,
		evaluation: PropTypes.object,
		subject: PropTypes.object
	
	});
	
	module.exports = CoinsEarnedDisplay;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactCircularProgressbar = __webpack_require__(623);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	
	var StudentProgressDisplay = function (_React$Component) {
		_inherits(StudentProgressDisplay, _React$Component);
	
		function StudentProgressDisplay(props) {
			_classCallCheck(this, StudentProgressDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentProgressDisplay.__proto__ || Object.getPrototypeOf(StudentProgressDisplay)).call(this));
	
			autobind(_this);
	
			_this.state = {};
			return _this;
		}
	
		_createClass(StudentProgressDisplay, [{
			key: "render",
			value: function render() {
				var progress;
				if (this.props.progress) {
					progress = this.props.progress;
				} else {
					progress = this.props.current / this.props.total;
				}
				progress = Math.min(progress || 0.0, 1.0);
	
				var percent = Math.round(progress * 100);
				var total = this.props.total;
	
				var metric = this.props.metric;
	
				if (metric == "pages") {
					var imageMetric = "minutes";
				} else if (metric == "days-active") {
					var imageMetric = "questions";
				} else {
					var imageMetric = metric;
				}
	
				if (!this.props.hideButton) {
					var button = React.createElement(
						"button",
						{ className: "buttonPrimary", onClick: this.props.openBookSearch },
						StudentMetrics.getActionButtonText(metric)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "circleContainer" },
					React.createElement(
						_reactCircularProgressbar.CircularProgressbarWithChildren,
						{ value: percent, className: "largeCircle",
							circleRatio: 0.75,
							styles: {
								trail: {
									strokeLinecap: 'butt',
									transform: 'rotate(-135deg)',
									transformOrigin: 'center center'
								},
								path: {
									strokeLinecap: 'butt',
									transform: 'rotate(-135deg)',
									transformOrigin: 'center center'
								} } },
						React.createElement("img", { src: StudentMetrics.getIcon(imageMetric), className: "metricIcon" }),
						React.createElement(
							"div",
							{ className: "infoContainer" },
							React.createElement(
								"p",
								{ className: "statTotal" },
								this.props.current
							),
							React.createElement(
								"p",
								{ className: "metricCategory" },
								StudentMetrics.getLabel(metric)
							),
							React.createElement(
								"p",
								{ className: "totalText" },
								"Goal: ",
								this.props.total
							),
							button
						)
					)
				);
			}
	
			// componentDidMount() {
			// }
	
		}]);
	
		return StudentProgressDisplay;
	}(React.Component);
	
	StudentProgressDisplay.propTypes = StrictPropTypes({
		metric: PropTypes.string,
		title: PropTypes.string,
		unit: PropTypes.string,
		current: PropTypes.number,
		total: PropTypes.number,
		actionLabel: PropTypes.string,
		openBookSearch: PropTypes.func,
		hideButton: PropTypes.bool
	});
	
	module.exports = StudentProgressDisplay;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var StudentOnboardingImage = __webpack_require__(887);
	var OwlfonsoChat = __webpack_require__(886);
	
	__webpack_require__(3767);
	
	var StudentOnboardingModal = function (_React$Component) {
		_inherits(StudentOnboardingModal, _React$Component);
	
		function StudentOnboardingModal(props) {
			_classCallCheck(this, StudentOnboardingModal);
	
			var _this = _possibleConstructorReturn(this, (StudentOnboardingModal.__proto__ || Object.getPrototypeOf(StudentOnboardingModal)).call(this));
	
			autobind(_this);
	
			var isAssignments = true;
			var isSplitOnboarding = true;
	
			if (isSplitOnboarding) {
				if (props.writingTriggered) {
					var conversationData = __webpack_require__(1512);
				} else if (isAssignments) {
					var conversationData = __webpack_require__(1513);
				} else {
					var conversationData = __webpack_require__(1514);
				}
			} else {
				if (isAssignments) {
					var conversationData = __webpack_require__(1510);
				} else {
					var conversationData = __webpack_require__(1511);
				}
			}
	
			_this.state = { conversationData: conversationData, stage: 0, chatHistory: [], preventHide: true };
			return _this;
		}
	
		_createClass(StudentOnboardingModal, [{
			key: "skipOnboarding",
			value: function skipOnboarding() {
				LuckyOrangeClient.tagComponent("skipStudentOnboarding");
				this.endOnboarding();
			}
		}, {
			key: "endOnboarding",
			value: function endOnboarding(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (!this.props.writingTriggered) {
					// mark onboarding complete
					var studentID = CurrentUser.get().id;
					var studentData = { pending_onboarding: false };
					CurrentUser.api().patchStudent(studentID, { student: studentData }, $wr.apiHandler(function (response) {
						_this2.setState({ preventHide: false }, function () {
							CurrentUser.fetchCurrentUserData();
							_this2.refs.modal.hide();
						});
					}));
				} else {
					$wr.redirect(this.props.redirectPath);
					this.refs.modal.hide();
				}
			}
		}, {
			key: "logOut",
			value: function logOut(e) {
				$wr.nope(e);
				CurrentUser.logOut();
				window.location = WhooosReadingServices.OuterPages.url("/");
			}
		}, {
			key: "advanceStage",
			value: function advanceStage(lastChat, increment) {
				// end onboarding if we are at the final stage
				if (this.state.stage == _.size(this.state.conversationData) - 1) {
					this.endOnboarding();
					return;
				}
	
				var newHistory = this.state.chatHistory;
				newHistory.push(lastChat);
	
				var incrementAmount = parseInt(increment) || 1;
				var newStage = this.state.stage + incrementAmount;
	
				this.setState({ stage: newStage, chatHistory: newHistory });
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var user = CurrentUser.get();
				var currentChat = _.findWhere(this.state.conversationData, { stage: this.state.stage });
	
				if (user.demo_for_teacher) {
					var logOutLink = React.createElement(
						"div",
						{ className: "logOutLink" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.logOut },
							"Log Out"
						),
						React.createElement(
							"span",
							{ className: "separator" },
							"|"
						),
						React.createElement(
							"a",
							{ href: "#", onClick: this.skipOnboarding },
							"Skip"
						)
					);
				} else {
					var logOutLink = React.createElement(
						"a",
						{ href: "#", className: "logOutLink", onClick: this.logOut },
						"Log Out"
					);
				}
				var studentOptions = currentChat.speaker == "student" && currentChat.type == "options";
				var leftContent = React.createElement(StudentOnboardingImage, { stage: this.state.stage,
					hasStudentOptions: studentOptions,
					level: CurrentUser.getLevel(),
					imgPath: currentChat.imgPath });
				var hiddenSkipLink = React.createElement("a", { className: "hiddenSkipLink", onClick: this.skipOnboarding });
	
				var leftColDisplay = React.createElement(
					"div",
					{ className: "leftColWrapper" },
					React.createElement(
						"div",
						{ className: "leftCol" },
						logOutLink,
						hiddenSkipLink,
						leftContent
					)
				);
	
				var initialOnly = currentChat && currentChat.initialOnly;
				var rightContent = React.createElement(OwlfonsoChat, { history: this.state.chatHistory, currentChat: currentChat,
					advanceStageF: this.advanceStage, initialOnly: initialOnly,
					scrollToBottomF: function scrollToBottomF() {
						_this3.refs.scrollbar.scrollToBottom();
					} });
	
				var rightColDisplay = React.createElement(
					"div",
					{ className: "rightColWrapper" },
					React.createElement(
						_reactCustomScrollbars.Scrollbars,
						{ className: "modalScroll", ref: "scrollbar",
							style: { height: 450 } },
						React.createElement(
							"div",
							{ className: "rightCol" },
							rightContent
						)
					)
				);
	
				return React.createElement(
					Modal,
					{ className: "studentOnboardingModal", preventHide: this.state.preventHide, ref: "modal" },
					React.createElement(
						"div",
						{ className: "modalContent" },
						leftColDisplay,
						rightColDisplay
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.refs.modal.show();
				Mycroft.newEvent({ category: "Student Onboarding", action: "started-chat" });
			}
		}]);
	
		return StudentOnboardingModal;
	}(React.Component);
	
	StudentOnboardingModal.propTypes = StrictPropTypes({
		// true when triggered upon answering a question or doing a quiz
		writingTriggered: PropTypes.bool,
	
		// redirect path
		redirectPath: PropTypes.string
	});
	
	module.exports = StudentOnboardingModal;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	var AutograderDisplayConfig = __webpack_require__(83);
	
	__webpack_require__(3845);
	
	var TextAreaMarkups = function (_React$Component) {
		_inherits(TextAreaMarkups, _React$Component);
	
		function TextAreaMarkups() {
			_classCallCheck(this, TextAreaMarkups);
	
			return _possibleConstructorReturn(this, (TextAreaMarkups.__proto__ || Object.getPrototypeOf(TextAreaMarkups)).apply(this, arguments));
		}
	
		_createClass(TextAreaMarkups, [{
			key: "combineOverlapping",
			value: function combineOverlapping(arr) {
				var sortedArr = arr.sort(function (a, b) {
					return a.start - b.start;
				});
	
				var combinedArr = [];
	
				if (sortedArr.length > 0) {
					var start = sortedArr[0].start;
					var end = sortedArr[0].end;
					var key = sortedArr[0].key;
	
					for (var i = 1; i < sortedArr.length; i++) {
						var current = sortedArr[i];
						if (current.start > end) {
							combinedArr.push({ start: start, end: end, key: key });
							start = current.start;
							end = current.end;
							key = current.key;
						} else if (current.end > end) {
							end = current.end;
						}
					}
					combinedArr.push({ start: start, end: end, key: key });
				}
	
				return combinedArr;
			}
		}, {
			key: "getMarkups",
			value: function getMarkups() {
				if (this.props.markups) {
					// Legacy
					return this.props.markups;
				} else {
					var tagSpans = [];
					_.each(_.flatten(_.values(this.props.tagging)), function (tag) {
						if (!_.size(tag.spans[0])) {
							return;
						}
						if (tag.key && tag.key == 'KNOWN_TEXT_GROUP') {
							var startSpan = tag.spans[0];
							var endSpan = tag.spans.pop();
							if ("start" in startSpan && "end" in endSpan) {
								var span = { start: startSpan.start, end: endSpan.end };
								tagSpans.push(_.extend({}, span, { key: tag.key }));
							}
						} else {
							_.each(tag.spans || [], function (span) {
								if ("start" in span && "end" in span) {
									tagSpans.push(_.extend({}, span, { key: tag.key }));
								}
							});
						}
						return;
					});
	
					// combine overlapping concepts
					tagSpans = this.combineOverlapping(tagSpans);
	
					var markups = [];
					_.each(_.sortBy(tagSpans, "start"), function (span) {
						if (markups.length == 0 || span.end >= _.last(markups).end) {
							markups.push(span);
						}
					});
	
					return markups;
				}
			}
		}, {
			key: "formatMarkups",
			value: function formatMarkups(markups) {
				var _this2 = this;
	
				if (markups.length) {
					return markups.map(function (d) {
						if (d["key"]) {
							var tag = AutograderDisplayConfig.getTagName(d["key"]) || d["key"];
						} else if (d["tag"]) {
							var tag = d["tag"];
						}
	
						if ("start" in d && tag) {
							var defaultColor = "#faaf88";
							if (_this2.props.tagColors) {
								var color = _this2.props.tagColors[d["key"]] || defaultColor;
							} else {
								var color = d["color"] || defaultColor;
							}
	
							return {
								"start": parseInt(d["start"]),
								"end": parseInt(d["end"]),
								"tag": tag,
								"color": color
							};
						} else {
							return null;
						}
					}).sort(function (x, y) {
						if (y && x) {
							return x["start"] - y["start"];
						} else {
							if (x) {
								return 1;
							} else {
								return -1;
							}
						}
					});
				} else {
					return [];
				}
			}
		}, {
			key: "formatString",
			value: function formatString(text, markups) {
				markups = this.formatMarkups(markups);
				var stringArray = [];
	
				var lastSpanEnd = 0;
				_.each(markups, function (tag) {
					if (tag && tag.start != undefined && tag.start < tag.end && tag.start >= lastSpanEnd) {
						if (tag.start > lastSpanEnd) {
							var beforeSpan = text.substring(lastSpanEnd, tag.start);
							stringArray.push([beforeSpan, "", null]);
						}
						var inSpan = text.substring(tag.start, tag.end);
						stringArray.push([inSpan, tag.tag, tag.color]);
						lastSpanEnd = tag.end;
					}
				});
	
				if (lastSpanEnd < text.length) {
					var afterSpan = text.substring(lastSpanEnd);
					stringArray.push([afterSpan, "", null]);
				}
	
				return stringArray;
			}
		}, {
			key: "getElement",
			value: function getElement(string_array) {
				var index = 0;
				var tag_list = [];
				string_array.forEach(function (el) {
					if (!tag_list.includes(el[1])) {
						tag_list.push(el[1]);
					}
				});
				tag_list.sort();
				var array = string_array.map(function (el, i) {
					index += 1;
					if (el[1].length) {
						var colors = el[2];
						var tagTitle = el[1];
						if (colors) {
							if (_.isArray(colors)) {
								var background = "repeating-linear-gradient(" + "45deg, " + colors[0] + ", " + colors[0] + " 10px, " + colors[1] + " 10px, " + colors[1] + " 20px)";
								var style = { background: background };
							} else {
								var style = { 'backgroundColor': el[2] };
							}
						} else {
							style = {};
						}
	
						if (_.isArray(tagTitle)) {
							tagTitle = tagTitle.join(" + ");
						}
	
						return React.createElement(
							"span",
							{ key: index, ref: "toggleInput",
								className: "tag", "data-tip": tagTitle, "data-for": "text-area-markups", style: style },
							el[0],
							React.createElement(ReactTooltip, { effect: "float", id: "text-area-markups" })
						);
					} else {
						var el_array = el[0].split('\n');
						if (el_array.length == 1) {
							return React.createElement(
								"span",
								{ key: index },
								el[0]
							);
						} else {
							return el_array.map(function (el_a, i) {
								if (i < el_array.length - 1) {
									return [React.createElement(
										"span",
										{ key: index },
										el_a
									), React.createElement("br", { key: "br" + index })];
								} else {
									return React.createElement(
										"span",
										{ key: index },
										el_a
									);
								}
							});
						}
					}
				});
				return array;
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "textAreaMarkups" },
					this.getElement(this.formatString(this.props.text, this.getMarkups()))
				);
			}
		}]);
	
		return TextAreaMarkups;
	}(React.Component);
	
	TextAreaMarkups.propTypes = StrictPropTypes({
		text: PropTypes.string.isRequired,
	
		// Either (legacy)...
		markups: PropTypes.array,
	
		// Or:
		tagging: PropTypes.object,
		tagColors: PropTypes.object
	});
	
	module.exports = TextAreaMarkups;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SentenceStarterTextArea = __webpack_require__(964);
	
	var MultiPartSentenceStarter = function (_React$Component) {
		_inherits(MultiPartSentenceStarter, _React$Component);
	
		function MultiPartSentenceStarter(props) {
			_classCallCheck(this, MultiPartSentenceStarter);
	
			var _this = _possibleConstructorReturn(this, (MultiPartSentenceStarter.__proto__ || Object.getPrototypeOf(MultiPartSentenceStarter)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(MultiPartSentenceStarter, [{
			key: "onChange",
			value: function onChange(index, text) {
				var newParts = _.clone(this.props.answerParts);
				newParts[index] = _.extend({}, this.props.answerParts[index], {
					text: text
				});
				this.props.onChange(newParts);
			}
		}, {
			key: "render",
			value: function render() {
				var index = 0;
				var textareas = [];
	
				var parts = this.props.answerParts;
				while (index + 1 < parts.length) {
					// Assumes they're ordered starter, text, starter, text, ...
					textareas.push(React.createElement(SentenceStarterTextArea, { key: index,
						starterText: parts[index].text,
						handlePasteBehaviour: this.props.handlePasteBehaviour,
						onChange: this.onChange.bind(this, index + 1),
						value: parts[index + 1].text,
						speechControlSetting: this.props.speechControlSetting }));
					index += 2;
				}
	
				return React.createElement(
					"div",
					{ className: "multiPartSentenceStarter" },
					textareas
				);
			}
		}]);
	
		return MultiPartSentenceStarter;
	}(React.Component);
	
	MultiPartSentenceStarter.initialAnswerParts = function (starterOps, seed) {
		var randIndex = $wr.psuedoRandom(seed, starterOps.length);
		return _.flatten(_.map(starterOps[randIndex], function (starterText) {
			return [{ type: STARTER, text: starterText }, { type: BODY, text: "" }];
		}));
	};
	
	var STARTER = "starter";
	var BODY = "body";
	var QUESTION = "question";
	var ANSWER = "answer";
	var SYNONYM = "synonym";
	
	MultiPartSentenceStarter.BODY = BODY;
	MultiPartSentenceStarter.STARTER = STARTER;
	MultiPartSentenceStarter.ANSWER = ANSWER;
	MultiPartSentenceStarter.QUESTION = QUESTION;
	MultiPartSentenceStarter.SYNONYM = SYNONYM;
	
	MultiPartSentenceStarter.propTypes = StrictPropTypes({
		answerParts: PropTypes.array.isRequired,
		onChange: PropTypes.func.isRequired,
		maxLength: PropTypes.number,
		handlePasteBehaviour: PropTypes.func,
		speechControlSetting: PropTypes.string
	});
	
	module.exports = MultiPartSentenceStarter;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3854);
	var Spinner = __webpack_require__(9);
	
	var MyShelfRouting = __webpack_require__(74);
	
	var Autosaver = function (_React$Component) {
		_inherits(Autosaver, _React$Component);
	
		function Autosaver(props) {
			_classCallCheck(this, Autosaver);
	
			var _this = _possibleConstructorReturn(this, (Autosaver.__proto__ || Object.getPrototypeOf(Autosaver)).call(this));
	
			autobind(_this);
			_this.state = { showConfirmDelete: false, changesMade: false,
				autosaveHandler: null, autosaveHash: null };
			return _this;
		}
	
		_createClass(Autosaver, [{
			key: "toggleConfirmDelete",
			value: function toggleConfirmDelete() {
				this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
			}
		}, {
			key: "redirectToDrafts",
			value: function redirectToDrafts() {
				this.props.onAutosave(function () {
					window.wrNotifications.triggerDropDownNotification({
						title: "Great!", text: "Your work has been saved!", icon: "ok-sign" });
					if (!this.props.textID || this.props.textID === 'MISSING_TEXT_ID') {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.WORK_VIEW,
							detailsView: "drafts"
						}));
					} else if (this.props.textID) {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: "drafts",
							textID: this.props.textID
						}));
					} else {
						$wr.redirect("/");
					}
				}.bind(this));
			}
		}, {
			key: "unmatchingAutosaveHashes",
			value: function unmatchingAutosaveHashes() {
				var autosaveHash = this.props.getAutosaveHash();
	
				if (this.state.autosaveHash != null && autosaveHash != null) {
					return autosaveHash != this.state.autosaveHash;
				} else {
					return false;
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.autosaveLoading) {
					return React.createElement(
						"div",
						{ className: "autosaver" },
						React.createElement(Spinner, { className: "draftSpinner", scale: 0.5, smallOps: true }),
						React.createElement(
							"p",
							{ className: "deleteDraft deleteDraftMessage" },
							"Your work is saving..."
						),
						deleteOption
					);
				} else if (this.state.showConfirmDelete) {
					return React.createElement(
						"div",
						{ className: "autosaver autosaverDelete" },
						React.createElement(
							"p",
							{ className: "deleteDraft deleteDraftMessage" },
							"If you delete this you will lose your work below. Are you sure?"
						),
						React.createElement(
							"button",
							{ key: "confirm", className: "deleteDraft confirmDelete btn-link",
								onClick: this.props.onDeleteClick },
							"Yes"
						),
						React.createElement(
							"button",
							{ key: "cancel", className: "deleteDraft btn-link",
								onClick: this.toggleConfirmDelete },
							"No"
						)
					);
				} else {
					if (this.props.onDeleteClick) {
						var deleteOption = React.createElement(
							"button",
							{ key: "confirm", className: "deleteDraft btn-link",
								onClick: this.toggleConfirmDelete },
							"Delete Draft"
						);
					}
					if (!this.props.autosaveDisabled) {
						var saveForLaterOption = React.createElement(
							"button",
							{ className: "saveForLater buttonSuccess btn-link",
								onClick: this.redirectToDrafts },
							"Save for Later"
						);
	
						if (!this.state.changesMade) {
							var changesSavedText = React.createElement(
								"span",
								{ className: "deleteDraft deleteDraftMessage" },
								"Your work is saved!"
							);
						}
					}
	
					return React.createElement(
						"div",
						{ className: "autosaver" },
						changesSavedText,
						React.createElement("br", null),
						saveForLaterOption,
						deleteOption
					);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!this.props.autosaveDisabled) {
					this.setupAutosaver();
					this.setupChangesCheck();
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (!this.props.autosaveDisabled) {
					clearTimeout(this.state.autosaveHandler);
					clearTimeout(this.state.changesCheckHandler);
				}
			}
		}, {
			key: "tickAutosaving",
			value: function tickAutosaving() {
				if (!this.props.autosaveLoading && this.unmatchingAutosaveHashes()) {
					this.props.onAutosave(function () {
						this.setState({ changesMade: false });
						this.setupChangesCheck();
					}.bind(this));
				}
				this.setupAutosaver();
			}
		}, {
			key: "tickChangesCheck",
			value: function tickChangesCheck() {
				if (this.state.autosaveHash != null && this.unmatchingAutosaveHashes()) {
					this.setState({ changesMade: true });
				} else {
					this.setupChangesCheck();
				}
			}
		}, {
			key: "setupAutosaver",
			value: function setupAutosaver() {
				var autosaveHash = this.props.getAutosaveHash();
				if (autosaveHash != undefined) {
					var autosaveHandler = setTimeout(this.tickAutosaving, Autosaver.AUTOSAVE_INTERVAL);
					this.setState({ autosaveHandler: autosaveHandler, autosaveHash: autosaveHash });
				}
			}
		}, {
			key: "setupChangesCheck",
			value: function setupChangesCheck() {
				var changesCheckHandler = setTimeout(this.tickChangesCheck, Autosaver.CHANGES_CHECK_INTERVAL);
				this.setState({ changesCheckHandler: changesCheckHandler });
			}
		}]);
	
		return Autosaver;
	}(React.Component);
	
	;
	
	Autosaver.AUTOSAVE_INTERVAL = 15000;
	Autosaver.CHANGES_CHECK_INTERVAL = 1000;
	
	Autosaver.propTypes = StrictPropTypes({
		// Gets a value representing the autosave status
		// Changes in the value this returns will trigger the autosave
		getAutosaveHash: PropTypes.func,
	
		// Function called to run the autosave
		onAutosave: PropTypes.func,
	
		// Text ID to redirect to appropriate drafts page
		textID: PropTypes.string,
	
		// Trigger the deletion of the associated draft
		// If not present, we'll hide the option to show this
		onDeleteClick: PropTypes.func,
	
		// True if a draft is currently being saved
		autosaveLoading: PropTypes.bool,
	
		// If true, don't do any autosaving (or saving). Just allow deleting.
		// If this value changes, make sure to remount component (e.g. by changing key)
		autosaveDisabled: PropTypes.bool
	
	});
	
	module.exports = Autosaver;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	var Modal = __webpack_require__(18);
	var Spinner = __webpack_require__(9);
	var StudentListDropdownDisplay = __webpack_require__(138);
	var LoadingButton = __webpack_require__(17);
	var StudentDisplay = __webpack_require__(52);
	var RosterRouting = __webpack_require__(93);
	var RosterSelectors = __webpack_require__(6);
	var Glyphicon = __webpack_require__(8);
	var StudentMetrics = __webpack_require__(29);
	
	var AccountPlans = __webpack_require__(53);
	var CurrentUser = __webpack_require__(3);
	var OrgTypes = __webpack_require__(45);
	var OrgDropdown = __webpack_require__(100);
	
	var RosterActions = __webpack_require__(11);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var Features = __webpack_require__(16);
	__webpack_require__(659);
	
	var AssignTaskModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			tasks: WritingSelectors.teacherPicksTasks({ state: state, filters: { assigner_id: CurrentUser.get().id } }),
			exerciseTasks: WritingSelectors.tasks({ state: state, filters: { subject_type: 'exercise', assigner_id: CurrentUser.get().id } }),
			initialSelectedStudentIDs: WritingSelectors.userIDsByTaskSubjectID({
				state: state, filters: {
					subject_type: props.taskSubjectType,
					subject_id: props.taskSubjectID + ""
				}
			})[props.taskSubjectID],
	
			getStudents: function getStudents(orgIdentifier) {
				return RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier });
			},
			loading: RosterSelectors.isLoadingStudents({ state: state, key: 'index' }) || RosterSelectors.isLoadingStudentLists({ state: state, key: 'index' })
		};
	}, function (dispatch, props) {
		return {
			deleteManyTasks: function deleteManyTasks(userIDs) {
				// Delete all tasks
				return dispatch(WritingActions.deleteManyTasks({
					filters: {
						subject_type: props.taskSubjectType,
						subject_id: props.taskSubjectID + ""
					},
					conditions: {
						oneOfMatch: { user_id: userIDs }
					}
				}));
			},
			addStudentsToTaskAssignment: function addStudentsToTaskAssignment(userIDs) {
				var query = {};
				var tasks = _underscore2.default.map(userIDs, function (studentID) {
					return {
						user_id: studentID,
						assigner_id: CurrentUser.get().id,
						subject_type: props.taskSubjectType,
						subject_id: props.taskSubjectID
					};
				});
				if (props.textToAssign && props.textToAssign.taskItems) {
					_underscore2.default.each(props.textToAssign.taskItems, function (item) {
						query = {
							task_items: {
								quiz: _underscore2.default.where(item, { subject_type: 'Quiz' }).length ? true : false,
								practice_questions: _underscore2.default.where(item, { subject_type: 'Practice Question' }).length ? _underscore2.default.where(item, { subject_type: 'Practice Question' }).length : 0,
								review: _underscore2.default.where(item, { subject_type: 'Review' }).length ? true : false,
								due_date_enabled: _underscore2.default.first(item).due_date ? true : false,
								due_date: _underscore2.default.first(item).due_date,
								exercises: _underscore2.default.where(item, { subject_type: 'Exercise' }).length ? _underscore2.default.where(item, { subject_type: 'Exercise' }).length : 0
							}
						};
					});
				}
				if (tasks.length) {
					return dispatch(WritingActions.createTasks({ tasks: tasks, query: query }));
				} else {
					return Promise.resolve();
				}
			},
			populateData: function populateData() {
				var fetchStudents = function fetchStudents() {
					// Loads in stuff we need but didn't get from the loading on App.js
					var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS;
					return dispatch(RosterActions.fetchStudents({ embeds: embeds }));
				};
	
				var fetchStudentLists = function fetchStudentLists() {
					// Loads in stuff we need but didn't get from the loading on App.js
					var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS;
					return dispatch(RosterActions.fetchStudentLists({ embeds: embeds }));
				};
	
				return Promise.all([fetchStudentLists().then(function (slResponse) {
					return fetchStudents();
				})]);
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(AssignTaskModal, _React$Component);
	
		function AssignTaskModal(props) {
			_classCallCheck(this, AssignTaskModal);
	
			var _this = _possibleConstructorReturn(this, (AssignTaskModal.__proto__ || Object.getPrototypeOf(AssignTaskModal)).call(this));
	
			autobind(_this);
	
			var selectedStudentIDs = _underscore2.default.clone(props.initialSelectedStudentIDs || []);
			selectedStudentIDs = _underscore2.default.map(selectedStudentIDs, function (id) {
				return parseInt(id);
			});
	
			var bookTasks = _underscore2.default.filter(props.tasks, function (task) {
				return task.subject_id === props.taskSubjectID;
			}) || [];
	
			var allTaskItems = _underscore2.default.collect(_underscore2.default.flatten(_underscore2.default.uniq(_underscore2.default.pluck(props.tasks, 'task_items'))));
	
			_this.state = {
				bookTasks: bookTasks,
				selectedStudentIDs: selectedStudentIDs,
				allTaskItems: allTaskItems,
				selectedOrgIdentifier: OrgTypes.ALL_STUDENTS_IDENTIFIER,
				loading: false
			};
			return _this;
		}
		// paywall helper method
	
	
		_createClass(AssignTaskModal, [{
			key: "allowAccess",
			value: function allowAccess() {
				var user = CurrentUser.get();
				var activeTrials = user.account.active_trials;
				var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false;
				return user.product === "wrSilver" || user.product === "wrGold" || hasQualifiedTrial ? true : false;
			}
		}, {
			key: "showDeselectAll",
			value: function showDeselectAll() {
				return this.students().length == this.state.selectedStudentIDs.length;
			}
		}, {
			key: "deselectAll",
			value: function deselectAll() {
				this.setState({ selectedStudentIDs: [] });
			}
		}, {
			key: "selectAll",
			value: function selectAll() {
				this.setState({ selectedStudentIDs: _underscore2.default.pluck(this.students(), "id") });
			}
		}, {
			key: "getSubjectName",
			value: function getSubjectName() {
				if (this.props.taskSubjectType == EXERCISE) {
					return "Exercise";
				} else if (this.props.taskSubjectType == URLPICK) {
					return "URL";
				} else if (this.props.taskSubjectType == TITLEPICK) {
					return "Title";
				} else {
					console.error("Unknown taskSubjectType " + this.props.taskSubjectType);
				}
			}
		}, {
			key: "students",
			value: function students() {
				var students = this.props.getStudents(this.state.selectedOrgIdentifier);
				return $wr.sortByName(students, "flexName");
			}
		}, {
			key: "onOrgSelect",
			value: function onOrgSelect(identifier) {
				var students = this.props.getStudents(identifier);
				var studentIDs = _underscore2.default.pluck(students, "id");
				this.setState({ selectedOrgIdentifier: identifier, selectedStudentIDs: [] });
			}
		}, {
			key: "toggleStudentSelect",
			value: function toggleStudentSelect(studentID) {
				studentID = parseInt(studentID);
				var selectedStudentIDs = this.state.selectedStudentIDs;
				var studentIndex = selectedStudentIDs.indexOf(studentID);
				if (studentIndex > -1) {
					selectedStudentIDs.splice(studentIndex, 1);
				} else {
					selectedStudentIDs.push(studentID);
				}
				this.setState({ selectedStudentIDs: selectedStudentIDs });
			}
			// returns all new users added to assignment
	
		}, {
			key: "newUsers",
			value: function newUsers() {
				var _this2 = this;
	
				return this.props.initialSelectedStudentIDs ? this.state.selectedStudentIDs.filter(function (obj) {
					return _this2.props.initialSelectedStudentIDs.indexOf(obj) == -1;
				}) : this.state.selectedStudentIDs;
			}
			// returns all users removed from assignment
	
		}, {
			key: "removedUsers",
			value: function removedUsers() {
				var _this3 = this;
	
				return this.props.initialSelectedStudentIDs ? this.props.initialSelectedStudentIDs.filter(function (obj) {
					return _this3.state.selectedStudentIDs.indexOf(obj) == -1;
				}) : [];
			}
			// add and/or removes students from task assignment
	
		}, {
			key: "updateTaskAssignment",
			value: function updateTaskAssignment() {
				var _this4 = this;
	
				var newUsers = this.newUsers();
				var removedUsers = this.removedUsers();
	
				if (this.props.initialSelectedStudentIDs || !this.allowAccess()) {
					var renderAdditionalModal = false;
				} else {
					var renderAdditionalModal = true;
				}
	
				if (renderAdditionalModal) {
					this.successBannerTrigger(this.state.selectedStudentIDs, renderAdditionalModal);
				} else {
					this.props.deleteManyTasks(removedUsers);
					this.props.addStudentsToTaskAssignment(newUsers).then(function () {
						_this4.successBannerTrigger(_this4.state.selectedStudentIDs, renderAdditionalModal);
					});
				}
			}
		}, {
			key: "submitTasks",
			value: function submitTasks(e) {
				$wr.nope(e);
				this.setState({ loading: true });
				this.updateTaskAssignment();
			}
		}, {
			key: "successBannerTrigger",
			value: function successBannerTrigger(selectedStudents, additonalModal) {
				var _this5 = this;
	
				additonalModal = additonalModal === null ? false : additonalModal;
	
				if (selectedStudents && selectedStudents.length > 1) {
					var text = "Your students have been assigned " + this.props.selectedActivityTitle + ".";
				} else {
					var text = "Your student has been assigned " + this.props.selectedActivityTitle + ".";
				}
	
				this.setState({ loading: false, selectedStudentIDs: [] }, function () {
					if (!additonalModal) {
						var title = "Assigned " + _this5.getSubjectName();
						window.wrNotifications.triggerDropDownNotification({
							title: title, text: text, icon: "ok-sign"
						});
					}
					_this5.props.onAssign(selectedStudents, additonalModal);
				});
			}
		}, {
			key: "renderControls",
			value: function renderControls() {
				if (this.showDeselectAll()) {
					var selectLink = React.createElement(
						"button",
						{ className: "btn btn-link", onClick: this.deselectAll },
						"Clear All"
					);
				} else {
					var selectLink = React.createElement(
						"button",
						{ className: "btn btn-link", onClick: this.selectAll },
						"Select All"
					);
				}
				var button = this.containsStudents() && this.students().length > 50 ? this.renderButton() : '';
	
				return React.createElement(
					"span",
					{ className: "controls" },
					selectLink,
					button
				);
			}
		}, {
			key: "renderLoadingState",
			value: function renderLoadingState() {
				if (this.props.loading || this.state.loading) {
					return React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
				return "";
			}
		}, {
			key: "containsStudents",
			value: function containsStudents() {
				return this.state.selectedStudentIDs && this.state.selectedStudentIDs.length > 0 || this.props.initialSelectedStudentIDs && this.props.initialSelectedStudentIDs.length > 0;
			}
		}, {
			key: "findTask",
			value: function findTask(studentID) {
				return _underscore2.default.find(this.props.tasks, { user_id: studentID, subject_id: this.props.taskSubjectID, subject_type: this.props.taskSubjectType }) || _underscore2.default.find(this.state.allTaskItems, { user_id: studentID, subject_id: this.props.taskSubjectID, subject_type: this.props.taskSubjectType });
			}
		}, {
			key: "findStandAloneExercise",
			value: function findStandAloneExercise(studentID) {
				return _underscore2.default.find(this.props.exerciseTasks, { user_id: studentID, subject_id: String(this.props.taskSubjectID), subject_type: 'exercise' });
			}
		}, {
			key: "isFinishedStudent",
			value: function isFinishedStudent(studentID) {
				var task = this.findTask(studentID);
				var standAloneExercise = this.findStandAloneExercise(studentID);
				if (task && task.task_items) {
					var taskItems = task.task_items;
	
					var finishedQuiz = _underscore2.default.where(taskItems, { subject_type: 'quiz', draft: false }) || [];
					var finishedPracticeQuestions = _underscore2.default.where(taskItems, { subject_type: 'practice question', draft: false }) || [];
					var finishedReview = _underscore2.default.where(taskItems, { subject_type: 'review', draft: false }) || [];
					var finishedExercise = _underscore2.default.where(taskItems, { subject_type: 'exercise', draft: false }) || [];
					// sum completed tasks
					var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length + finishedExercise.length;
					// return comparison
					return taskItems.length <= completed_tasks ? true : false;
				} else if (task) {
					return !task.draft;
				} else if (standAloneExercise) {
					return !standAloneExercise.draft;
				} else {
					return false;
				}
			}
		}, {
			key: "renderStudentStats",
			value: function renderStudentStats(studentID) {
				var out = '';
				var task = this.findTask(studentID);
				if (_underscore2.default.size(task) && task.task_items) {
					// render quiz status
					var assignedQuiz = _underscore2.default.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ });
					if (_underscore2.default.size(assignedQuiz)) {
						var finishedQuiz = _underscore2.default.where(assignedQuiz, { draft: false });
						if (finishedQuiz.length) {
							out = out + "<span>Quiz Complete</span></br>";
						} else {
							out = out + "<span>Quiz Incomplete</span></br>";
						}
					}
					// render practice question status
					var assignedPracticeQuestions = _underscore2.default.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION });
					if (_underscore2.default.size(assignedPracticeQuestions)) {
						var finishedPracticeQuestions = _underscore2.default.where(assignedPracticeQuestions, { draft: false });
						out = out + ("<span>" + _underscore2.default.size(finishedPracticeQuestions) + "/" + _underscore2.default.size(assignedPracticeQuestions) + " Questions</span></br>");
					}
					// render review status
					var assignedReview = _underscore2.default.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW });
					if (_underscore2.default.size(assignedReview)) {
						var finishedReview = _underscore2.default.where(assignedReview, { draft: false });
						if (finishedReview.length) {
							out = out + "<span>Review Complete</span></br>";
						} else {
							out = out + "<span>Review Incomplete</span></br>";
						}
					}
					// render exercise status
					var assignedExercises = _underscore2.default.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE });
					if (_underscore2.default.size(assignedExercises)) {
						var finishedExercises = _underscore2.default.where(assignedExercises, { draft: false });
						out = out + ("<span>" + _underscore2.default.size(finishedExercises) + "/" + _underscore2.default.size(assignedExercises) + " Exercises</span></br>");
					}
				}
				return out;
			}
		}, {
			key: "hasSubArray",
			value: function hasSubArray(master, sub) {
				return sub.every(function (i) {
					return function (v) {
						return i = master.indexOf(v, i) + 1;
					};
				}(0));
			}
			// returns button with relevant text
	
		}, {
			key: "renderButton",
			value: function renderButton() {
				var buttonText = "Next";
				var buttonValue = "Next";
				if (this.props.initialSelectedStudentIDs) {
					buttonText = "Update";
					buttonValue = "Update";
					if (this.newUsers().length) {
						buttonText = "Assign";
						buttonValue = "Assign";
					} else if (this.removedUsers().length) {
						buttonText = "Unassign " + this.getSubjectName();
						buttonValue = "Unassign";
					}
				} else if (!this.allowAccess()) {
					buttonText = "Assign";
					buttonValue = "Assign";
				}
				return React.createElement(LoadingButton, { className: "btn buttonSuccess center-block " + buttonValue,
					value: buttonValue, loading: this.state.loading, text: buttonText,
					onClick: this.submitTasks });
			}
		}, {
			key: "render",
			value: function render() {
				var studentSelectorList = _underscore2.default.map(this.students(), function (student) {
					var studentID = student.id;
					var show_icon = false;
	
					if (_underscore2.default.contains(this.state.selectedStudentIDs, studentID)) {
						var className = " selectedStudent";
						if (this.allowAccess()) {
							show_icon = true;
							var iconColor = 'gray';
							if (this.isFinishedStudent(studentID)) {
								iconColor = 'green';
							}
						}
					}
	
					var studentTaskStats = '';
					if (show_icon && this.state[studentID] && this.renderStudentStats(studentID).length) {
						studentTaskStats = React.createElement(
							"div",
							{ className: "studentTaskStats" },
							this.renderStudentStats(studentID)
						);
					}
	
					var icon = '';
					if (show_icon) {
						icon = React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check",
							style: { color: iconColor, top: '9px', margin: '0 0 0 10px', fontSize: '20px' } });
					}
	
					return React.createElement(
						"div",
						{ key: studentID, "data-tip": this.renderStudentStats(studentID), className: "studentDisplayWrap " + className,
							onClick: this.toggleStudentSelect.bind(this, studentID) },
						React.createElement(StudentDisplay, { studentID: studentID, showAvatar: true, avatarMaxWidth: 50 }),
						icon,
						studentTaskStats,
						React.createElement(ReactTooltip, { effect: "solid", html: true })
					);
				}.bind(this));
	
				var selector = React.createElement(OrgDropdown, { dropdownDisplay: "link",
					selectedIdentifier: this.state.selectedOrgIdentifier,
					onSelect: this.onOrgSelect });
				var button = this.containsStudents() ? this.renderButton() : '';
				var loading = this.renderLoadingState();
	
				if (loading) {
					var modalContent = loading;
				} else {
					var modalContent = React.createElement(
						"div",
						null,
						this.renderLoadingState(),
						selector,
						this.renderControls(),
						React.createElement(
							"div",
							{ className: "studentOptions" },
							studentSelectorList
						),
						button
					);
				}
	
				return React.createElement(
					"div",
					{ className: "assignTaskModal" },
					modalContent
				);
			}
		}]);
	
		return AssignTaskModal;
	}(React.Component)) || _class) || _class);
	;
	
	var EXERCISE = 'exercise';
	var URLPICK = 'URLPick';
	var TITLEPICK = 'TitlePick';
	
	AssignTaskModal.WrappedComponent.propTypes = StrictPropTypes({
		tasks: PropTypes.array,
	
		// ID of the task we're assigning
		taskSubjectID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	
		onAssign: PropTypes.func,
		renderAdditionalModal: PropTypes.bool,
		// subject type of the task we are assigning
		taskSubjectType: PropTypes.string.isRequired,
	
		// From @connect
	
		initialSelectedStudentIDs: PropTypes.array,
		textToAssign: PropTypes.object,
		selectedActivityTitle: PropTypes.string,
		getStudents: PropTypes.func,
		deleteManyTasks: PropTypes.func,
		addStudentsToTaskAssignment: PropTypes.func
	
	});
	
	module.exports = AssignTaskModal;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var AltSkillsets = {
	
		STANDARDS: {
			wrss: {
				name: "Whooo's Reading Skill Sets"
			},
			ccss: {
				name: "CCSS"
			},
	
			teks: {
				name: 'TEKS',
				state: 'Texas'
			},
			aks: {
				name: 'AK Standards',
				state: 'Alaska'
			},
			ins: {
				name: 'IN Standards',
				state: 'Indiana'
			},
			nes: {
				name: 'NE Standards',
				state: 'Nebraska'
			},
			oas: {
				name: 'OAS',
				state: 'Oklahoma'
			},
			scccr: {
				name: 'SCCCR',
				state: 'South Carolina'
			},
			vasol: {
				name: 'Virginia SOL',
				state: 'Virginia'
			},
			lafs: {
				name: 'LAFS',
				state: 'Florida'
			},
			gse: {
				name: 'GSE',
				state: 'Georgia'
			},
			tas: {
				name: 'TN Standards',
				state: 'Tennessee'
			},
			aas: {
				name: 'AZ Standards',
				state: 'Arizona'
			},
			ias: {
				name: 'Iowa Core',
				state: 'Iowa'
			},
			ols: {
				name: 'OH Standards',
				state: 'Ohio'
			},
			pcs: {
				name: 'PA Standards',
				state: 'Pennsylvania'
			},
			ncscs: {
				name: 'NC Standards',
				state: 'North Carolina'
			},
			ace: {
				name: "ACARA",
				state: "Australia"
			},
			njslsa: {
				name: "NJSLS",
				state: "New Jersey"
			},
			alccrs: {
				name: "AL CCRS",
				state: "Alabama"
			},
			cas: {
				name: "CAS",
				state: "Colorado"
			},
			mas: {
				name: 'MA Standards',
				state: 'Massachusetts'
			},
			sdccss: {
				name: 'SD CCSS',
				state: 'South Dakota'
			},
			ars: {
				name: 'AR Standards',
				state: 'Arkansas'
			},
			nysng: {
				name: 'NYS NG ELA',
				state: 'New York'
			},
			msccrs: {
				name: 'MS CCR Standards',
				state: 'Mississippi'
			},
			nds: {
				name: 'ND Standards',
				state: 'North Dakota'
			},
			utcore: {
				name: 'UT Core Standards',
				state: 'Utah'
			},
			ors: {
				name: 'OR Standards',
				state: 'Oregon'
			},
			mdccrs: {
				name: 'MD CCR Standards',
				state: 'Maryland'
			},
			mls612: {
				name: 'MO Standards (6-12)',
				state: 'Missouri'
			},
			mlsk5: {
				name: 'MO Standards (K-5)',
				state: 'Missouri'
			},
			caccss: {
				name: 'CA CCSS',
				state: 'California'
			},
			miccras: {
				name: 'MI CCRAS',
				state: 'Michigan'
			},
			mnccras: {
				name: 'MN CCRAS',
				state: 'Minnesota'
			},
			lass: {
				name: 'LA Standards',
				state: 'Louisiana'
			},
			ilccss: {
				name: 'IL CCSS',
				state: 'Illinois'
			},
			bccan: {
				name: 'BC Canada',
				state: 'BC Canada'
			}
		},
	
		getAltSkillset: function getAltSkillset(altStandard, wrSkillset, textVariety) {
			var altData = AltSkillsets.data().mapping[altStandard];
			if (altData && altData[wrSkillset]) {
				return altData[wrSkillset][textVariety];
			}
			return undefined;
		},
		getSkillsetDetails: function getSkillsetDetails(altStandard, wrSkillset, textVariety) {
			var altKey = AltSkillsets.getAltSkillset(altStandard, wrSkillset, textVariety);
			if (altKey) {
				return AltSkillsets.data().details[altKey];
			}
			return undefined;
		},
		getDynamicFullName: function getDynamicFullName(altStandard, wrSkillset, textVariety) {
			var altData = AltSkillsets.getSkillsetDetails(altStandard, wrSkillset, textVariety);
			if (altData) {
				return this.getStandardName(altStandard) + " - " + altData.name;
			}
			return undefined;
		},
		getName: function getName(altKey) {
			var altData = AltSkillsets.data().details[altKey];
			if (altData) {
				return altData.name;
			}
		},
		getFullName: function getFullName(altKey) {
			var altData = AltSkillsets.data().details[altKey];
			if (altData) {
				return this.getStandardName(altData.standard) + " - " + altData.name;
			}
		},
		getStandardName: function getStandardName(altStandard, withState) {
			var data = AltSkillsets.STANDARDS[altStandard];
			if (data) {
				if (withState && data.state) {
					return data.name + " (" + data.state + ")";
				} else {
					return data.name;
				}
			}
		},
		getStandardForState: function getStandardForState(stateName) {
			_.each(AltSkillsets.STANDARD_KEYS, function (key) {
				var state = AltSkillsets.STANDARDS[key].state;
				if (state && state == stateName) {
					return key;
				}
			});
			// default to wrss
			return "wrss";
		},
		getSubStandards: function getSubStandards(altStandard) {
			return AltSkillsets.data().subStandards[altStandard];
		},
		getReverseSkillsets: function getReverseSkillsets(altKey) {
			return AltSkillsets.reverse()[altKey];
		},
		data: function data() {
			if (AltSkillsets.DATA == null) {
				AltSkillsets.load();
			}
			return AltSkillsets.DATA;
		},
		reverse: function reverse() {
			if (AltSkillsets.REVERSE == null) {
				AltSkillsets.load();
			}
			return AltSkillsets.REVERSE;
		},
	
	
		DATA: null,
		REVERSE: null,
	
		load: function load() {
			AltSkillsets.DATA = { details: {}, mapping: {}, subStandards: {} };
			AltSkillsets.REVERSE = {};
	
			// Require here to avoid cicular dependencies
			var skillsetKeys = __webpack_require__(55).SKILLSET_KEYS;
	
			var add = function add(altStandard, textVariety, wrSkillset, altKey, pattern, name, description) {
	
				if (!_.include(skillsetKeys, wrSkillset)) {
					return;
				}
	
				if (AltSkillsets.DATA.mapping[altStandard] === undefined) {
					AltSkillsets.DATA.mapping[altStandard] = {};
					AltSkillsets.DATA.subStandards[altStandard] = [];
				}
	
				if (AltSkillsets.DATA.mapping[altStandard][wrSkillset] === undefined) {
					AltSkillsets.DATA.mapping[altStandard][wrSkillset] = {};
				}
	
				AltSkillsets.DATA.mapping[altStandard][wrSkillset][textVariety] = altKey;
	
				AltSkillsets.DATA.details[altKey] = {
					pattern: pattern, name: name, description: description, standard: altStandard
				};
	
				if (!_.include(AltSkillsets.DATA.subStandards[altStandard], altKey)) {
					AltSkillsets.DATA.subStandards[altStandard].push(altKey);
				}
	
				AltSkillsets.REVERSE[altKey] = AltSkillsets.REVERSE[altKey] || [];
	
				if (!_.includes(AltSkillsets.REVERSE[altKey], wrSkillset)) {
					AltSkillsets.REVERSE[altKey].push(wrSkillset);
				}
			};
	
			// DON'T EDIT THIS DIRECTLY. EDIT THE SOURCE SPREADSHEET
	
			// CCSS
			add("ccss", "non-fiction", "inferences", "ccss-ri-rl-1", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ccss", "fiction", "inferences", "ccss-ri-rl-1", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ccss", "non-fiction", "ideas", "ccss-ri-rl-2", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ccss", "fiction", "ideas", "ccss-ri-rl-2", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ccss", "non-fiction", "developments", "ccss-ri-rl-3", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ccss", "fiction", "developments", "ccss-ri-rl-3", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ccss", "non-fiction", "vocabulary", "ccss-ri-rl-4", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ccss", "fiction", "vocabulary", "ccss-ri-rl-4", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ccss", "non-fiction", "structure", "ccss-ri-rl-5", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ccss", "fiction", "structure", "ccss-ri-rl-5", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ccss", "non-fiction", "pov", "ccss-ri-rl-6", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ccss", "fiction", "pov", "ccss-ri-rl-6", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ccss", "non-fiction", "media", "ccss-ri-rl-7", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ccss", "fiction", "media", "ccss-ri-rl-7", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ccss", "non-fiction", "arguments", "ccss-ri-8", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ccss", "non-fiction", "connections", "ccss-ri-rl-9", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ccss", "fiction", "connections", "ccss-ri-rl-9", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ccss", "non-fiction", "reading-level", "ccss-ri-rl-10", "CCSS.ELA-LITERACY.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// TEKS
			add("teks", "non-fiction", "inferences", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "inferences", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "ideas", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "ideas", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "developments", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "developments", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "vocabulary", "teks-vocabulary", "TEKS - Reading/Vocabulary Development - {{GRADEPRETTY}}", "Vocabulary Development", "Students understand new vocabulary and use it when reading and writing.");
			add("teks", "fiction", "vocabulary", "teks-vocabulary", "TEKS - Reading/Vocabulary Development - {{GRADEPRETTY}}", "Vocabulary Development", "Students understand new vocabulary and use it when reading and writing.");
			add("teks", "non-fiction", "structure", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "structure", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "pov", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "pov", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "media", "teks-media-literacy", "TEKS - Reading/Media Literacy - {{GRADEPRETTY}}", "Media Literacy", "Students use comprehension skills to analyze how words, images, graphics, and sounds work together in various forms to impact meaning.");
			add("teks", "fiction", "media", "teks-media-literacy", "TEKS - Reading/Media Literacy - {{GRADEPRETTY}}", "Media Literacy", "Students use comprehension skills to analyze how words, images, graphics, and sounds work together in various forms to impact meaning.");
			add("teks", "non-fiction", "arguments", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "non-fiction", "connections", "teks-comp-informational", "TEKS - Reading/Comprehension of Informational Text - {{GRADEPRETTY}}", "Comprehension of Informational Text", "Students understand, analyze, make inferences, and draw conclusions about expository, persuasive, and procedural texts, as well as the author's purpose in cultural, historical, and contemporary contexts.");
			add("teks", "fiction", "connections", "teks-comp-literary", "TEKS - Reading/Comprehension of Literary Text - {{GRADEPRETTY}}", "Comprehension of Literary Text", "Students understand, analyze, make inferences, and draw conclusions about theme, genre, sensory language, structure, and elements in poetry, drama, fiction, and literary nonfiction.");
			add("teks", "non-fiction", "reading-level", "teks-fluency", "TEKS - Reading/Fluency - Grade {{GRADEPRETTYNOK}}", "Fluency", "Students read grade-level text with fluency and comprehension. ");
	
			// AK Standards
			add("aks", "non-fiction", "inferences", "aks-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("aks", "fiction", "inferences", "aks-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("aks", "non-fiction", "ideas", "aks-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("aks", "fiction", "ideas", "aks-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("aks", "non-fiction", "developments", "aks-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text. ");
			add("aks", "fiction", "developments", "aks-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text. ");
			add("aks", "non-fiction", "vocabulary", "aks-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("aks", "fiction", "vocabulary", "aks-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("aks", "non-fiction", "structure", "aks-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("aks", "fiction", "structure", "aks-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("aks", "non-fiction", "pov", "aks-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("aks", "fiction", "pov", "aks-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("aks", "non-fiction", "media", "aks-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("aks", "fiction", "media", "aks-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("aks", "non-fiction", "arguments", "aks-ri-8", "RI.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("aks", "non-fiction", "connections", "aks-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("aks", "fiction", "connections", "aks-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("aks", "non-fiction", "reading-level", "aks-ri-rl-10", "{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend a range of complex literary and informational texts independently and proficiently.");
	
			// IN Standards
			add("ins", "non-fiction", "inferences", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "fiction", "inferences", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "non-fiction", "ideas", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "fiction", "ideas", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "non-fiction", "developments", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "fiction", "developments", "ins-rn-rl-2", "{{GRADE}}.{{RN/RL}}.2", "Key Ideas & Textual Support", "Extract and construct meaning from and appreciation of literature and non-fiction texts using a range of comprehension skills, including analyzing, inferring, and drawing conclusions.");
			add("ins", "non-fiction", "vocabulary", "ins-rv-3", "{{GRADE}}.RV.3", "Vocabulary in Literature & Nonfiction Texts", "Build appreciation and understanding of literature and nonfiction texts by determining or clarifying the figurative, connotative, and technical meanings of words and their uses.");
			add("ins", "fiction", "vocabulary", "ins-rv-3", "{{GRADE}}.RV.3", "Vocabulary in Literature & Nonfiction Texts", "Build appreciation and understanding of literature and nonfiction texts by determining or clarifying the figurative, connotative, and technical meanings of words and their uses.");
			add("ins", "non-fiction", "structure", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "fiction", "structure", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "non-fiction", "pov", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "fiction", "pov", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "non-fiction", "media", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "fiction", "media", "ins-rn-rl-3", "{{GRADE}}.{{RN/RL}}.3", "Structural Elements & Organization", "Build comprehension and appreciation of texts, using knowledge of structure, organization, text features, and author's perspective and purpose.");
			add("ins", "non-fiction", "arguments", "ins-rn-rl-4", "{{GRADE}}.{{RN/RL}}.4", "Synthesis & Connection of Ideas", "Build comprehension and appreciation of texts by connecting elements, themes, topics, and ideas; evaluating specific claims; analyzing how sensory tools, medium, and interpretation impact meaning; and synthesizing and connecting ideas over various works.");
			add("ins", "non-fiction", "connections", "ins-rn-rl-4", "{{GRADE}}.{{RN/RL}}.4", "Synthesis & Connection of Ideas", "Build comprehension and appreciation of texts by connecting elements, themes, topics, and ideas; evaluating specific claims; analyzing how sensory tools, medium, and interpretation impact meaning; and synthesizing and connecting ideas over various works.");
			add("ins", "fiction", "connections", "ins-rn-rl-4", "{{GRADE}}.{{RN/RL}}.4", "Synthesis & Connection of Ideas", "Build comprehension and appreciation of texts by connecting elements, themes, topics, and ideas; evaluating specific claims; analyzing how sensory tools, medium, and interpretation impact meaning; and synthesizing and connecting ideas over various works.");
			add("ins", "non-fiction", "reading-level", "ins-rn-rl-1", "{{GRADE}}.{{RN/RL}}.1", "Learning Outcome", "Read and comprehend a variety of nonfiction independently and proficiently.");
	
			// NE Standards
			add("nes", "non-fiction", "inferences", "nes-la-6-n", "LA {{NEGRADE}}.1.6.n", "Comprehension N", "Make and confirm/modify predictions and inferences before, during, and after reading texts and using text evidence.");
			add("nes", "fiction", "inferences", "nes-la-6-n", "LA {{NEGRADE}}.1.6.n", "Comprehension N", "Make and confirm/modify predictions and inferences before, during, and after reading texts and using text evidence.");
			add("nes", "non-fiction", "ideas", "nes-la-6-e", "LA {{NEGRADE}}.1.6.e", "Comprehension E", "Summarize, analyze, and synthesize informational texts and/or media, using supporting details to determine and formulate the main idea.");
			add("nes", "fiction", "ideas", "nes-la-6-b-d-h", "LA {{NEGRADE}}.1.6.b.d.h", "Comprehension B, D, H", "Summarize and synthesize the elements of one or more literary texts, using key details to identify, describe, and analyze the theme. Compare and contrast similar themes, topics, and/or patterns of events.");
			add("nes", "non-fiction", "developments", "nes-la-6-h", "LA {{NEGRADE}}.1.6.h", "Comprehension H", "Explain relationships or interactions between individuals, cultures, events, and ideas within informational texts.");
			add("nes", "fiction", "developments", "nes-la-6-b-h", "LA {{NEGRADE}}.1.6.b.h", "Comprehension B, H", "Identify, describe, and analyze the relationships or interactions between individuals, cultures, events, and ideas within literary texts.");
			add("nes", "non-fiction", "vocabulary", "nes-la-5", "LA {{NEGRADE}}.1.5", "Vocabulary", "Students will build and use conversational, academic, and content-specific gradelevel vocabulary.");
			add("nes", "fiction", "vocabulary", "nes-la-5", "LA {{NEGRADE}}.1.5", "Vocabulary", "Students will build and use conversational, academic, and content-specific gradelevel vocabulary.");
			add("nes", "non-fiction", "structure", "nes-la-6-f-j", "LA {{NEGRADE}}.1.6.f.j", "Comprehension F, J", "Use text features to locate and evaluate information and explain how the information supports comprehension. Identify and apply knowledge of organizational patterns to comprehend informational text.");
			add("nes", "fiction", "structure", "nes-la-6-c-f", "LA {{NEGRADE}}.1.6.c.f", "Comprehension C, F", "Use text features to locate and evaluate information and explain how the information supports comprehension. Identify and analyze the author's use of literary devices. ");
			add("nes", "non-fiction", "pov", "nes-la-6-a-k", "LA {{NEGRADE}}.1.6.a.k", "Comprehension A, K", "Examine text to determine the author's purpose and describe how the author's perspective influences the text, including the meaning, reliability, and validity. Select text for a particular purpose and explain the purpose.");
			add("nes", "fiction", "pov", "nes-la-6-a-k", "LA {{NEGRADE}}.1.6.a.k", "Comprehension A, K", "Examine text to determine the author's purpose and describe how the author's perspective influences the text, including the meaning, reliability, and validity. Select text for a particular purpose and explain the purpose.");
			add("nes", "non-fiction", "media", "nes-la-6-o-p", "LA {{NEGRADE}}.1.6.o.p", "Comprehension O, P", "Demonstrate an understanding of text using textual evidence via multiple mediums. Analyze the extent to which a visual or oral production of a story, drama, or poem resembles or differs from the text or script.");
			add("nes", "fiction", "media", "nes-la-6-o-p", "LA {{NEGRADE}}.1.6.o.p", "Comprehension O, P", "Demonstrate an understanding of text using textual evidence via multiple mediums. Analyze the extent to which a visual or oral production of a story, drama, or poem resembles or differs from the text or script.");
			add("nes", "non-fiction", "arguments", "nes-la-6-i", "LA {{NEGRADE}}.1.6.i", "Comprehension I", "Construct and/or answer literal, inferential, critical, and interpretive questions and support answers with explicit evidence from the text or additional sources. Construct and/or answer literal, inferential, and critical questions and support answers with explicit evidence from the text or additional sources.");
			add("nes", "non-fiction", "connections", "nes-la-6-g-l", "LA {{NEGRADE}}.1.6.g.l", "Comprehension G, L", "Build background knowledge and and make text-to-text connections to compare and contrast the characteristics that distinguish a variety of literary and informational texts.");
			add("nes", "fiction", "connections", "nes-la-6-g-l", "LA {{NEGRADE}}.1.6.g.l", "Comprehension G, L", "Build background knowledge and and make text-to-text connections to compare and contrast the characteristics that distinguish a variety of literary and informational texts.");
			add("nes", "non-fiction", "reading-level", "nes-la-4", "LA {{NEGRADE}}.1.4", "Fluency", "Students will read a variety of grade-level print/digital texts fluently with accuracy, appropriate pace, phrasing, and expression to support comprehension.");
			add("nes", "non-fiction", "introspection-and-application", "nes-la-6-h-l", "LA {{NEGRADE}}.1.6.h.l", "Comprehension H, L", "Build background knowledge and activate prior knowledge to explain relationships or interactions between individuals, events, ideas, themes, and/or concepts within texts. Make connections to own life and/or other cultures and analyze the various influences in a variety of texts to develop a multicultural perspective.");
			add("nes", "fiction", "introspection-and-application", "nes-la-6-h-l", "LA {{NEGRADE}}.1.6.h.l", "Comprehension H, L", "Build background knowledge and activate prior knowledge to explain relationships or interactions between individuals, events, ideas, themes, and/or concepts within texts. Make connections to own life and/or other cultures and analyze the various influences in a variety of texts to develop a multicultural perspective.");
	
			// OAS
			add("oas", "non-fiction", "inferences", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "fiction", "inferences", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "non-fiction", "ideas", "oas-2-r", "{{GRADE}}.2.R", "Reading Process - Standard 2", "Students will read and comprehend increasingly complex literary and informational texts.");
			add("oas", "fiction", "ideas", "oas-2-r", "{{GRADE}}.2.R", "Reading Process - Standard 2", "Students will read and comprehend increasingly complex literary and informational texts.");
			add("oas", "non-fiction", "developments", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "fiction", "developments", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "non-fiction", "vocabulary", "oas-4-r", "{{GRADE}}.4.R", "Vocabulary - Standard 4", "Students will expand academic, domain-appropriate, grade-level vocabularies.");
			add("oas", "fiction", "vocabulary", "oas-4-r", "{{GRADE}}.4.R", "Vocabulary - Standard 4", "Students will expand academic, domain-appropriate, grade-level vocabularies.");
			add("oas", "non-fiction", "structure", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "fiction", "structure", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "non-fiction", "pov", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "fiction", "pov", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "non-fiction", "media", "oas-7-r", "{{GRADE}}.7.R", "Multimodal Literacies - Standard 7", "Students will evaluate written, oral, visual, and digital texts in order to draw conclusions and analyze arguments.");
			add("oas", "fiction", "media", "oas-7-r", "{{GRADE}}.7.R", "Multimodal Literacies - Standard 7", "Students will evaluate written, oral, visual, and digital texts in order to draw conclusions and analyze arguments.");
			add("oas", "non-fiction", "arguments", "oas-6-r", "{{GRADE}}.6.R", "Research - Standard 6", "Students will comprehend, evaluate, and synthesize resources to acquire and refine knowledge.");
			add("oas", "non-fiction", "connections", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "fiction", "connections", "oas-3-r", "{{GRADE}}.3.R", "Critical Reading - Standard 3", "Students will comprehend, interpret, evaluate, and respond to a variety of complex texts of all literary and informational genres from a variety of historical, cultural, ethnic, and global perspectives.");
			add("oas", "non-fiction", "reading-level", "oas-2-f", "{{GRADE}}.2.F", "Reading Foundations - Fluency", "Students will recognize highfrequency words and read grade-level text smoothly and accurately, with expression that connotes comprehension.");
	
			// SCCCR
			add("scccr", "non-fiction", "inferences", "scccr-ri-s5", "{{GRADEPRETTY}} - RI - Standard 5", "RI - Standard 5", "Determine meaning and develop logical interpretations by making predictions, inferring, drawing conclusions, analyzing, synthesizing, providing evidence, and investigating multiple interpretations.");
			add("scccr", "fiction", "inferences", "scccr-rl-s5", "{{GRADEPRETTY}} - RL - Standard 5", "RL - Standard 5", "Determine meaning and develop logical interpretations by making predictions, inferring, drawing conclusions, analyzing, synthesizing, providing evidence, and investigating multiple interpretations.");
			add("scccr", "non-fiction", "ideas", "scccr-ri-s6", "{{GRADEPRETTY}} - RI - Standard 6", "RI - Standard 6", "Summarize key details and ideas to support analysis of central ideas.");
			add("scccr", "fiction", "ideas", "scccr-rl-s6", "{{GRADEPRETTY}} - RL - Standard 6", "RL - Standard 6", "Summarize key details and ideas to support analysis of thematic development.");
			add("scccr", "fiction", "developments", "scccr-rl-s8", "{{GRADEPRETTY}} - RL - Standard 8", "RL - Standard 8", "Analyze characters, settings, events, and ideas as they develop and interact within a particular context.");
			add("scccr", "non-fiction", "vocabulary", "scccr-ri-s9", "{{GRADEPRETTY}} - RI - Standard 9", "RI - Standard 9", "Apply a range of strategies to determine and deepen the meaning of known, unknown, and multiple-meaning words, phrases, and jargon; acquire and use general academic and domain-specific vocabulary.");
			add("scccr", "fiction", "vocabulary", "scccr-rl-s10", "{{GRADEPRETTY}} - RL - Standard 10", "RL - Standard 10", "Apply a range of strategies to determine and deepen the meaning of known, unknown, and multiple-meaning words, phrases, and jargon; acquire and use general academic and domain-specific vocabulary.");
			add("scccr", "non-fiction", "structure", "scccr-ri-s11", "{{GRADEPRETTY}} - RI - Standard 11", "RI - Standard 11", "Analyze and provide evidence of how the author's choice of point of view, perspective, and purpose shape content, meaning, and style.");
			add("scccr", "fiction", "structure", "scccr-rl-s12", "{{GRADEPRETTY}} - RL - Standard 12", "RL - Standard 12", "Analyze and critique how the author uses structures in print and multimedia texts to shape meaning and impact the reader.");
			add("scccr", "non-fiction", "pov", "scccr-ri-s10", "{{GRADEPRETTY}} - RI - Standard 10", "RI - Standard 10", "Analyze and provide evidence of how the author's choice of purpose and perspective shapes content, meaning, and style.");
			add("scccr", "fiction", "pov", "scccr-rl-s11", "{{GRADEPRETTY}} - RL - Standard 11", "RL - Standard 11", "Analyze and critique how the author uses structures in print and multimedia texts to craft informational and argument writing.");
			add("scccr", "non-fiction", "media", "scccr-ri-s7", "{{GRADEPRETTY}} - RI - Standard 7", "RI - Standard 7", "Research events, topics, ideas, or concepts through multiple media, formats, and in visual, auditory, and kinesthetic modalities.");
			add("scccr", "fiction", "media", "scccr-rl-s7", "{{GRADEPRETTY}} - RL - Standard 7", "RL - Standard 7", "Analyze the relationship among ideas, themes, or topics in multiple media and formats, and in visual, auditory, and kinesthetic modalities.");
			add("scccr", "non-fiction", "reading-level", "scccr-ri-rl-s4", "{{GRADEPRETTY}} - {{RI/RL}} - Standard 4", "RI/RL - Standard 4", "Read with sufficient accuracy and fluency to support comprehension.");
	
			// Virginia SOL
			add("vasol", "non-fiction", "inferences", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "inferences", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
			add("vasol", "non-fiction", "ideas", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "ideas", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
			add("vasol", "non-fiction", "developments", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "developments", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
			add("vasol", "non-fiction", "vocabulary", "vasol-vocab", "{{GRADEPRETTY}} - Reading Standard {{VAVOCAB}}", "Reading Vocabulary", "The student will read, learn, and determine the meanings of unfamiliar words and phrases expand vocabulary when reading.");
			add("vasol", "fiction", "vocabulary", "vasol-vocab", "{{GRADEPRETTY}} - Reading Standard {{VAVOCAB}}", "Reading Vocabulary", "The student will read, learn, and determine the meanings of unfamiliar words and phrases expand vocabulary when reading.");
			add("vasol", "non-fiction", "structure", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "structure", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
			add("vasol", "non-fiction", "pov", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "pov", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
			add("vasol", "non-fiction", "media", "vasol-media", "{{GRADEPRETTY}} - Reading Standard {{VAMEDIA}}", "Media Literacy", "The student will learn how and why media messages are constructed and will understand and analyze the elements of media literacy.");
			add("vasol", "fiction", "media", "vasol-media", "{{GRADEPRETTY}} - Reading Standard {{VAMEDIA}}", "Media Literacy", "The student will learn how and why media messages are constructed and will understand and analyze the elements of media literacy.");
			add("vasol", "non-fiction", "arguments", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "non-fiction", "connections", "vasol-comp-nonfic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPNF}}", "Nonfiction Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of nonfiction texts.");
			add("vasol", "fiction", "connections", "vasol-comp-fic", "{{GRADEPRETTY}} - Reading Standard {{VACOMPF}}", "Fictional Reading Comprehension", "The student will read, analyze, and demonstrate comprehension of a variety of fictional texts.");
	
			// LAFS
			add("lafs", "non-fiction", "inferences", "lafs-ri-rl-1-1", "LAFS.{{GRADE}}.{{RI/RL}}.1.1", "Key Ideas & Details - 1.1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("lafs", "fiction", "inferences", "lafs-ri-rl-1-1", "LAFS.{{GRADE}}.{{RI/RL}}.1.1", "Key Ideas & Details - 1.1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("lafs", "non-fiction", "ideas", "lafs-ri-rl-1-2", "LAFS.{{GRADE}}.{{RI/RL}}.1.2", "Key Ideas & Details - 1.2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("lafs", "fiction", "ideas", "lafs-ri-rl-1-2", "LAFS.{{GRADE}}.{{RI/RL}}.1.2", "Key Ideas & Details - 1.2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("lafs", "non-fiction", "developments", "lafs-ri-rl-1-3", "LAFS.{{GRADE}}.{{RI/RL}}.1.3", "Key Ideas & Details - 1.3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("lafs", "fiction", "developments", "lafs-ri-rl-1-3", "LAFS.{{GRADE}}.{{RI/RL}}.1.3", "Key Ideas & Details - 1.3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("lafs", "non-fiction", "vocabulary", "lafs-ri-rl-2-4", "LAFS.{{GRADE}}.{{RI/RL}}.2.4", "Craft & Structure - 2.4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("lafs", "fiction", "vocabulary", "lafs-ri-rl-2-4", "LAFS.{{GRADE}}.{{RI/RL}}.2.4", "Craft & Structure - 2.4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("lafs", "non-fiction", "structure", "lafs-ri-rl-2-5", "LAFS.{{GRADE}}.{{RI/RL}}.2.5", "Craft & Structure - 2.5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("lafs", "fiction", "structure", "lafs-ri-rl-2-5", "LAFS.{{GRADE}}.{{RI/RL}}.2.5", "Craft & Structure - 2.5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("lafs", "non-fiction", "pov", "lafs-ri-rl-2-6", "LAFS.{{GRADE}}.{{RI/RL}}.2.6", "Craft & Structure - 2.6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("lafs", "fiction", "pov", "lafs-ri-rl-2-6", "LAFS.{{GRADE}}.{{RI/RL}}.2.6", "Craft & Structure - 2.6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("lafs", "non-fiction", "media", "lafs-ri-rl-3-7", "LAFS.{{GRADE}}.{{RI/RL}}.3.7", "Integrate Knowledge & Ideas - 3.7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("lafs", "fiction", "media", "lafs-ri-rl-3-7", "LAFS.{{GRADE}}.{{RI/RL}}.3.7", "Integrate Knowledge & Ideas - 3.7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("lafs", "non-fiction", "arguments", "lafs-ri-3-8", "LAFS.{{GRADE}}.{{RI/RL}}.3.8", "Integrate Knowledge & Ideas - 3.8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("lafs", "non-fiction", "connections", "lafs-ri-rl-3-9", "LAFS.{{GRADE}}.{{RI/RL}}.3.9", "Integrate Knowledge & Ideas - 3.9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("lafs", "fiction", "connections", "lafs-ri-rl-3-9", "LAFS.{{GRADE}}.{{RI/RL}}.3.9", "Integrate Knowledge & Ideas - 3.9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("lafs", "non-fiction", "reading-level", "lafs-ri-rl-4-10", "LAFS.{{GRADE}}.{{RI/RL}}.4.10", "Reading & Text Complexity - 4.10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// GSE
			add("gse", "non-fiction", "inferences", "ela-gse-ri-rl-1", "ELAGSE{{GRADE}}{{RI/RL}}1 ", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("gse", "fiction", "inferences", "ela-gse-ri-rl-1", "ELAGSE{{GRADE}}{{RI/RL}}1 ", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("gse", "non-fiction", "ideas", "ela-gse-ri-rl-2", "ELAGSE{{GRADE}}{{RI/RL}}2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("gse", "fiction", "ideas", "ela-gse-ri-rl-2", "ELAGSE{{GRADE}}{{RI/RL}}2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("gse", "non-fiction", "developments", "ela-gse-ri-rl-3", "ELAGSE{{GRADE}}{{RI/RL}}3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("gse", "fiction", "developments", "ela-gse-ri-rl-3", "ELAGSE{{GRADE}}{{RI/RL}}3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("gse", "non-fiction", "vocabulary", "ela-gse-ri-rl-4", "ELAGSE{{GRADE}}{{RI/RL}}4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("gse", "fiction", "vocabulary", "ela-gse-ri-rl-4", "ELAGSE{{GRADE}}{{RI/RL}}4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("gse", "non-fiction", "structure", "ela-gse-ri-rl-5", "ELAGSE{{GRADE}}{{RI/RL}}5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("gse", "fiction", "structure", "ela-gse-ri-rl-5", "ELAGSE{{GRADE}}{{RI/RL}}5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("gse", "non-fiction", "pov", "ela-gse-ri-rl-6", "ELAGSE{{GRADE}}{{RI/RL}}6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("gse", "fiction", "pov", "ela-gse-ri-rl-6", "ELAGSE{{GRADE}}{{RI/RL}}6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("gse", "non-fiction", "media", "ela-gse-ri-rl-7", "ELAGSE{{GRADE}}{{RI/RL}}7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("gse", "fiction", "media", "ela-gse-ri-rl-7", "ELAGSE{{GRADE}}{{RI/RL}}7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("gse", "non-fiction", "arguments", "ela-gse-ri-8", "ELAGSE{{GRADE}}{{RI/RL}}8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("gse", "non-fiction", "connections", "ela-gse-ri-rl-9", "ELAGSE{{GRADE}}{{RI/RL}}9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("gse", "fiction", "connections", "ela-gse-ri-rl-9", "ELAGSE{{GRADE}}{{RI/RL}}9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("gse", "non-fiction", "reading-level", "ela-gse-ri-rl-10", "ELAGSE{{GRADE}}{{RI/RL}}10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// TN Standards
			add("tas", "non-fiction", "inferences", "tas-ri-rl-kid-1", "{{GRADE}}.{{RI/RL}}.KID.1", "Key Ideas & Details - 1", "Read closely to determine what a text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("tas", "fiction", "inferences", "tas-ri-rl-kid-1", "{{GRADE}}.{{RI/RL}}.KID.1", "Key Ideas & Details - 1", "Read closely to determine what a text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("tas", "non-fiction", "ideas", "tas-ri-rl-kid-2", "{{GRADE}}.{{RI/RL}}.KID.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("tas", "fiction", "ideas", "tas-ri-rl-kid-2", "{{GRADE}}.{{RI/RL}}.KID.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("tas", "non-fiction", "developments", "tas-ri-rl-kid-3", "{{GRADE}}.{{RI/RL}}.KID.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("tas", "fiction", "developments", "tas-ri-rl-kid-3", "{{GRADE}}.{{RI/RL}}.KID.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("tas", "non-fiction", "vocabulary", "tas-ri-rl-cs-4", "{{GRADE}}.{{RI/RL}}.CS.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("tas", "fiction", "vocabulary", "tas-ri-rl-cs-4", "{{GRADE}}.{{RI/RL}}.CS.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("tas", "non-fiction", "structure", "tas-ri-rl-cs-5", "{{GRADE}}.{{RI/RL}}.CS.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of a text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("tas", "fiction", "structure", "tas-ri-rl-cs-5", "{{GRADE}}.{{RI/RL}}.CS.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of a text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("tas", "non-fiction", "pov", "tas-ri-rl-cs-6", "{{GRADE}}.{{RI/RL}}.CS.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("tas", "fiction", "pov", "tas-ri-rl-cs-6", "{{GRADE}}.{{RI/RL}}.CS.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("tas", "non-fiction", "media", "tas-ri-rl-iki-7", "{{GRADE}}.{{RI/RL}}.IKI.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse formats and media, including visually and quantitatively, as well as in words.");
			add("tas", "fiction", "media", "tas-ri-rl-iki-7", "{{GRADE}}.{{RI/RL}}.IKI.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse formats and media, including visually and quantitatively, as well as in words.");
			add("tas", "non-fiction", "arguments", "tas-ri-iki-8", "{{GRADE}}.{{RI/RL}}.IKI.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("tas", "non-fiction", "connections", "tas-ri-rl-iki-9", "{{GRADE}}.{{RI/RL}}.IKI.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches an author takes.");
			add("tas", "fiction", "connections", "tas-ri-rl-iki-9", "{{GRADE}}.{{RI/RL}}.IKI.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches an author takes.");
			add("tas", "non-fiction", "reading-level", "tas-ri-rl-rrtc-10", "{{GRADE}}.{{RI/RL}}.RRTC.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// AZ Standards
			add("aas", "non-fiction", "inferences", "aas-ri-rl-1", "{{GRADE}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read carefully to determine what the text says explicitly and to make logical inferences from it.");
			add("aas", "fiction", "inferences", "aas-ri-rl-1", "{{GRADE}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read carefully to determine what the text says explicitly and to make logical inferences from it.");
			add("aas", "non-fiction", "ideas", "aas-ri-rl-2", "{{GRADE}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development.");
			add("aas", "fiction", "ideas", "aas-ri-rl-2", "{{GRADE}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development.");
			add("aas", "non-fiction", "developments", "aas-ri-rl-3", "{{GRADE}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("aas", "fiction", "developments", "aas-ri-rl-3", "{{GRADE}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("aas", "non-fiction", "vocabulary", "aas-ri-rl-4", "{{GRADE}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("aas", "fiction", "vocabulary", "aas-ri-rl-4", "{{GRADE}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("aas", "non-fiction", "structure", "aas-ri-rl-5", "{{GRADE}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("aas", "fiction", "structure", "aas-ri-rl-5", "{{GRADE}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("aas", "non-fiction", "pov", "aas-ri-rl-6", "{{GRADE}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text");
			add("aas", "fiction", "pov", "aas-ri-rl-6", "{{GRADE}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text");
			add("aas", "non-fiction", "media", "aas-ri-rl-7", "{{GRADE}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("aas", "fiction", "media", "aas-ri-rl-7", "{{GRADE}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("aas", "non-fiction", "arguments", "aas-ri-8", "{{GRADE}}.{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("aas", "non-fiction", "connections", "aas-ri-rl-9", "{{GRADE}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("aas", "fiction", "connections", "aas-ri-rl-9", "{{GRADE}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("aas", "non-fiction", "reading-level", "aas-ri-rl-10", "{{GRADE}}.{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// Iowa Core
			add("ias", "non-fiction", "inferences", "ias-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ias", "fiction", "inferences", "ias-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ias", "non-fiction", "ideas", "ias-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ias", "fiction", "ideas", "ias-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ias", "non-fiction", "developments", "ias-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ias", "fiction", "developments", "ias-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ias", "non-fiction", "vocabulary", "ias-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ias", "fiction", "vocabulary", "ias-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ias", "non-fiction", "structure", "ias-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ias", "fiction", "structure", "ias-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ias", "non-fiction", "pov", "ias-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ias", "fiction", "pov", "ias-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ias", "non-fiction", "media", "ias-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ias", "fiction", "media", "ias-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ias", "non-fiction", "arguments", "ias-ri-8", "{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ias", "non-fiction", "connections", "ias-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ias", "fiction", "connections", "ias-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ias", "non-fiction", "reading-level", "ias-ri-rl-10", "{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// OH Standards
			add("ols", "non-fiction", "inferences", "ols-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ols", "fiction", "inferences", "ols-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ols", "non-fiction", "ideas", "ols-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; provide a summary or thorough analysis of the text, including the appropriate components.");
			add("ols", "fiction", "ideas", "ols-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; provide a summary or thorough analysis of the text, including the appropriate components.");
			add("ols", "non-fiction", "developments", "ols-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ols", "fiction", "developments", "ols-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ols", "non-fiction", "vocabulary", "ols-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific language choices shape meaning, mood, or tone of the text.");
			add("ols", "fiction", "vocabulary", "ols-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific language choices shape meaning, mood, or tone of the text.");
			add("ols", "non-fiction", "structure", "ols-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ols", "fiction", "structure", "ols-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ols", "non-fiction", "pov", "ols-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("ols", "fiction", "pov", "ols-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("ols", "non-fiction", "media", "ols-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ols", "fiction", "media", "ols-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ols", "non-fiction", "arguments", "ols-ri-8", "{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ols", "non-fiction", "connections", "ols-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ols", "fiction", "connections", "ols-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ols", "non-fiction", "reading-level", "ols-ri-rl-10", "{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read, comprehend, and respond to complex literary and informational texts independently and proficiently.");
	
			// PA Standards
			add("pcs", "non-fiction", "inferences", "cc-1.2-b", "CC.1.2.{{GRADE}}.B", "Key Ideas & Details - B", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("pcs", "fiction", "inferences", "cc-1.3-b", "CC.1.3.{{GRADE}}.B", "Key Ideas & Details - B", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("pcs", "non-fiction", "ideas", "cc-1.2-a", "CC.1.2.{{GRADE}}.A", "Key Ideas & Details - A", "Determine central ideas or themes of a text and analyze their development; provide a summary or thorough analysis of the text, including the appropriate components.");
			add("pcs", "fiction", "ideas", "cc-1.3-a", "CC.1.3.{{GRADE}}.A", "Key Ideas & Details - A", "Determine central ideas or themes of a text and analyze their development; provide a summary or thorough analysis of the text, including the appropriate components.");
			add("pcs", "non-fiction", "developments", "cc-1.2-c", "CC.1.2.{{GRADE}}.C", "Key Ideas & Details - C", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("pcs", "fiction", "developments", "cc-1.3-c", "CC.1.3.{{GRADE}}.C", "Key Ideas & Details - C", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("pcs", "non-fiction", "vocabulary", "cc-1.2-f", "CC.1.2.{{GRADE}}.F", "Craft & Structure - F", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific language choices shape meaning, mood, or tone of the text.");
			add("pcs", "fiction", "vocabulary", "cc-1.3-f", "CC.1.3.{{GRADE}}.F", "Craft & Structure - F", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific language choices shape meaning, mood, or tone of the text.");
			add("pcs", "non-fiction", "structure", "cc-1.2-e", "CC.1.2.{{GRADE}}.E", "Craft & Structure - E", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("pcs", "fiction", "structure", "cc-1.3-e", "CC.1.3.{{GRADE}}.E", "Craft & Structure - E", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("pcs", "non-fiction", "pov", "cc-1.2-d", "CC.1.2.{{GRADE}}.D", "Craft & Structure - D", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("pcs", "fiction", "pov", "cc-1.3-d", "CC.1.3.{{GRADE}}.D", "Craft & Structure - D", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("pcs", "non-fiction", "media", "cc-1.2-g", "CC.1.2.{{GRADE}}.G", "Integrate Knowledge & Ideas - G", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("pcs", "fiction", "media", "cc-1.3-g", "CC.1.3.{{GRADE}}.G", "Integrate Knowledge & Ideas - G", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("pcs", "non-fiction", "arguments", "cc-1.2-h", "CC.1.2.{{GRADE}}.H", "Integrate Knowledge & Ideas - H", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("pcs", "non-fiction", "connections", "cc-1.2-i", "CC.1.2.{{GRADE}}.I", "Integrate Knowledge & Ideas - I", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("pcs", "fiction", "connections", "cc-1.3-h", "CC.1.3.{{GRADE}}.H", "Integrate Knowledge & Ideas - H", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("pcs", "non-fiction", "reading-level", "cc-1.2-1.3-l-k", "CC.1.2.{{GRADE}}.L / CC.1.3.{{GRADE}}.K", "Range of Reading", "Read, comprehend, and respond to complex literary and informational texts independently and proficiently.");
	
			// NC Standards
			add("ncscs", "non-fiction", "inferences", "ncscs-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "CCR Anchor Standard R.1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ncscs", "fiction", "inferences", "ncscs-ri-rl-1", "{{RI/RL}}.{{GRADE}}.1", "CCR Anchor Standard R.1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ncscs", "non-fiction", "ideas", "ncscs-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "CCR Anchor Standard R.2", "Determine central ideas (RI) or themes (RL) of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ncscs", "fiction", "ideas", "ncscs-ri-rl-2", "{{RI/RL}}.{{GRADE}}.2", "CCR Anchor Standard R.2", "Determine central ideas (RI) or themes (RL) of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ncscs", "non-fiction", "developments", "ncscs-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "CCR Anchor Standard R.3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ncscs", "fiction", "developments", "ncscs-ri-rl-3", "{{RI/RL}}.{{GRADE}}.3", "CCR Anchor Standard R.3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("ncscs", "non-fiction", "vocabulary", "ncscs-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "CCR Anchor Standard R.4", "Interpret words and phrases as they are used in a text and analyze how specific word choices shape meaning or tone.");
			add("ncscs", "fiction", "vocabulary", "ncscs-ri-rl-4", "{{RI/RL}}.{{GRADE}}.4", "CCR Anchor Standard R.4", "Interpret words and phrases as they are used in a text and analyze how specific word choices shape meaning or tone.");
			add("ncscs", "non-fiction", "structure", "ncscs-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "CCR Anchor Standard R.5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ncscs", "fiction", "structure", "ncscs-ri-rl-5", "{{RI/RL}}.{{GRADE}}.5", "CCR Anchor Standard R.5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ncscs", "non-fiction", "pov", "ncscs-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "CCR Anchor Standard R.6", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("ncscs", "fiction", "pov", "ncscs-ri-rl-6", "{{RI/RL}}.{{GRADE}}.6", "CCR Anchor Standard R.6", "Assess how point of view, perspective, or purpose shapes the content and style of a text.");
			add("ncscs", "non-fiction", "media", "ncscs-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "CCR Anchor Standard R.7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ncscs", "fiction", "media", "ncscs-ri-rl-7", "{{RI/RL}}.{{GRADE}}.7", "CCR Anchor Standard R.7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ncscs", "non-fiction", "arguments", "ncscs-ri-8", "{{RI/RL}}.{{GRADE}}.8", "CCR Anchor Standard R.8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ncscs", "non-fiction", "connections", "ncscs-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "CCR Anchor Standard R.9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ncscs", "fiction", "connections", "ncscs-ri-rl-9", "{{RI/RL}}.{{GRADE}}.9", "CCR Anchor Standard R.9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ncscs", "non-fiction", "reading-level", "ncscs-ri-rl-10", "{{RI/RL}}.{{GRADE}}.10", "CCR Anchor Standard R.10", "Read and understand complex literary and informational texts independently and proficiently, connecting prior knowledge and experiences to text.");
	
			// ACARA
			add("ace", "non-fiction", "inferences", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "fiction", "inferences", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "non-fiction", "ideas", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "fiction", "ideas", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "non-fiction", "developments", "ace-el", "Examining Literature", "ACELT - Examining Literature", "");
			add("ace", "fiction", "developments", "ace-el", "Examining Literature", "ACELT - Examining Literature", "");
			add("ace", "non-fiction", "vocabulary", "ace-edi", "Expressing and Developing Ideas", "ACELA - Expressing and Developing Ideas", "");
			add("ace", "fiction", "vocabulary", "ace-edi", "Expressing and Developing Ideas", "ACELA - Expressing and Developing Ideas", "");
			add("ace", "non-fiction", "structure", "ace-tso", "Text structure and Organisation", "ACELA - Text structure and Organisation", "");
			add("ace", "fiction", "structure", "ace-tso", "Text structure and Organisation", "ACELA - Text structure and Organisation", "");
			add("ace", "non-fiction", "pov", "ace-tc", "Texts in Context", "ACELY - Texts in Context", "");
			add("ace", "fiction", "pov", "ace-tc", "Texts in Context", "ACELY - Texts in Context", "");
			add("ace", "non-fiction", "media", "ace-tc", "Texts in Context", "ACELY - Texts in Context", "");
			add("ace", "fiction", "media", "ace-tc", "Texts in Context", "ACELY - Texts in Context", "");
			add("ace", "non-fiction", "arguments", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "non-fiction", "connections", "ace-lc", "Literature and Context", "ACELT - Literature and Context", "");
			add("ace", "fiction", "connections", "ace-lc", "Literature and Context", "ACELT - Literature and Context", "");
			add("ace", "non-fiction", "reading-level", "ace-iae", "Interpreting, Analysing, Evaluating", "ACELY - Interpreting, Analysing, Evaluating", "");
			add("ace", "non-fiction", "introspection-and-application", "ace-rl", "Responding to Literature", "ACELT - Responding to Literature", "");
			add("ace", "fiction", "introspection-and-application", "ace-rl", "Responding to Literature", "ACELT - Responding to Literature", "");
	
			// NJSLS
			add("njslsa", "non-fiction", "inferences", "njslsa-ri-rl-1", "NJSLSA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences and relevant connections from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("njslsa", "fiction", "inferences", "njslsa-ri-rl-1", "NJSLSA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences and relevant connections from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("njslsa", "non-fiction", "ideas", "njslsa-ri-rl-2", "NJSLSA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("njslsa", "fiction", "ideas", "njslsa-ri-rl-2", "NJSLSA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("njslsa", "non-fiction", "developments", "njslsa-ri-rl-3", "NJSLSA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("njslsa", "fiction", "developments", "njslsa-ri-rl-3", "NJSLSA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("njslsa", "non-fiction", "vocabulary", "njslsa-ri-rl-4", "NJSLSA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("njslsa", "fiction", "vocabulary", "njslsa-ri-rl-4", "NJSLSA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("njslsa", "non-fiction", "structure", "njslsa-ri-rl-5", "NJSLSA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("njslsa", "fiction", "structure", "njslsa-ri-rl-5", "NJSLSA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("njslsa", "non-fiction", "pov", "njslsa-ri-rl-6", "NJSLSA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("njslsa", "fiction", "pov", "njslsa-ri-rl-6", "NJSLSA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("njslsa", "non-fiction", "media", "njslsa-ri-rl-7", "NJSLSA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("njslsa", "fiction", "media", "njslsa-ri-rl-7", "NJSLSA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("njslsa", "non-fiction", "arguments", "njslsa-ri-8", "NJSLSA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("njslsa", "non-fiction", "connections", "njslsa-ri-rl-9", "NJSLSA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze and reflect on how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("njslsa", "fiction", "connections", "njslsa-ri-rl-9", "NJSLSA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze and reflect on how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("njslsa", "non-fiction", "reading-level", "njslsa-ri-rl-10", "NJSLSA.{{RI/RL}}.{{GRADE}}.10", "Integrate Knowledge & Ideas - 10", "Read and comprehend complex literary and informational texts independently and proficiently with scaffolding as needed");
	
			// AL CCRS
			add("alccrs", "non-fiction", "inferences", "alccrs-ri-rl-1", "ALCCRS.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("alccrs", "fiction", "inferences", "alccrs-ri-rl-1", "ALCCRS.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("alccrs", "non-fiction", "ideas", "alccrs-ri-rl-2", "ALCCRS.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("alccrs", "fiction", "ideas", "alccrs-ri-rl-2", "ALCCRS.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("alccrs", "non-fiction", "developments", "alccrs-ri-rl-3", "ALCCRS.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("alccrs", "fiction", "developments", "alccrs-ri-rl-3", "ALCCRS.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, and ideas develop and interact over the course of a text.");
			add("alccrs", "non-fiction", "vocabulary", "alccrs-ri-rl-4", "ALCCRS.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("alccrs", "fiction", "vocabulary", "alccrs-ri-rl-4", "ALCCRS.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("alccrs", "non-fiction", "structure", "alccrs-ri-rl-5", "ALCCRS.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("alccrs", "fiction", "structure", "alccrs-ri-rl-5", "ALCCRS.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("alccrs", "non-fiction", "pov", "alccrs-ri-rl-6", "ALCCRS.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("alccrs", "fiction", "pov", "alccrs-ri-rl-6", "ALCCRS.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("alccrs", "non-fiction", "media", "alccrs-ri-rl-7", "ALCCRS.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse formats and media, including visually and quantitatively, as well as in words.");
			add("alccrs", "fiction", "media", "alccrs-ri-rl-7", "ALCCRS.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse formats and media, including visually and quantitatively, as well as in words.");
			add("alccrs", "non-fiction", "arguments", "alccrs-ri-8", "ALCCRS.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("alccrs", "non-fiction", "connections", "alccrs-ri-rl-9", "ALCCRS.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("alccrs", "fiction", "connections", "alccrs-ri-rl-9", "ALCCRS.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("alccrs", "non-fiction", "reading-level", "alccrs-ri-rl-10", "ALCCRS.{{RI/RL}}.{{GRADE}}.10", "Integrate Knowledge & Ideas - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// CAS
			add("cas", "non-fiction", "inferences", "cas-ri-1", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 1", "");
			add("cas", "fiction", "inferences", "cas-rl-1", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 1", "");
			add("cas", "non-fiction", "ideas", "cas-ri-2", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 2", "");
			add("cas", "fiction", "ideas", "cas-rl-2", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 2", "");
			add("cas", "non-fiction", "developments", "cas-ri-3", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 3", "");
			add("cas", "fiction", "developments", "cas-rl-3", "CAS-RWC10-GR.{{GRADE}}-S.3-GLE.1", "GLE 1 - Anchor 3", "");
			add("cas", "non-fiction", "vocabulary", "cas-ri-4", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 4", "");
			add("cas", "fiction", "vocabulary", "cas-rl-4", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 4", "");
			add("cas", "non-fiction", "structure", "cas-ri-5", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 5", "");
			add("cas", "fiction", "structure", "cas-rl-5", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 5", "");
			add("cas", "non-fiction", "pov", "cas-ri-6", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 6", "");
			add("cas", "fiction", "pov", "cas-rl-6", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 6", "");
			add("cas", "non-fiction", "media", "cas-ri-7", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 7", "");
			add("cas", "fiction", "media", "cas-rl-7", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 7", "");
			add("cas", "non-fiction", "arguments", "cas-ri-8", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 8", "");
			add("cas", "non-fiction", "connections", "cas-ri-9", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.2", "GLE 2 - Anchor 9", "");
			add("cas", "fiction", "connections", "cas-rl-9", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1", "GLE 1 - Anchor 9", "");
			add("cas", "non-fiction", "reading-level", "cas-ri-rl-10", "CAS-RWC10-GR.{{GRADE}}-S.2-GLE.1/2", "GLE 1/2 - Anchor 10", "");
	
			// MA Standards
			add("mas", "non-fiction", "inferences", "mass-ri-rl-1", "MASS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mas", "fiction", "inferences", "mass-ri-rl-1", "MASS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mas", "non-fiction", "ideas", "mass-ri-rl-2", "MASS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mas", "fiction", "ideas", "mass-ri-rl-2", "MASS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mas", "non-fiction", "developments", "mass-ri-rl-3", "MASS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mas", "fiction", "developments", "mass-ri-rl-3", "MASS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mas", "non-fiction", "vocabulary", "mass-ri-rl-4", "MASS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mas", "fiction", "vocabulary", "mass-ri-rl-4", "MASS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mas", "non-fiction", "structure", "mass-ri-rl-5", "MASS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mas", "fiction", "structure", "mass-ri-rl-5", "MASS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mas", "non-fiction", "pov", "mass-ri-rl-6", "MASS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mas", "fiction", "pov", "mass-ri-rl-6", "MASS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mas", "non-fiction", "media", "mass-ri-rl-7", "MASS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mas", "fiction", "media", "mass-ri-rl-7", "MASS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mas", "non-fiction", "arguments", "mass-ri-8", "MASS.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("mas", "non-fiction", "connections", "mass-ri-rl-9", "MASS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mas", "fiction", "connections", "mass-ri-rl-9", "MASS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mas", "non-fiction", "reading-level", "mass-ri-rl-10", "MASS.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// SD CCSS
			add("sdccss", "non-fiction", "inferences", "sdccss-ri-rl-1", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("sdccss", "fiction", "inferences", "sdccss-ri-rl-1", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("sdccss", "non-fiction", "ideas", "sdccss-ri-rl-2", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("sdccss", "fiction", "ideas", "sdccss-ri-rl-2", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("sdccss", "non-fiction", "developments", "sdccss-ri-rl-3", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("sdccss", "fiction", "developments", "sdccss-ri-rl-3", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("sdccss", "non-fiction", "vocabulary", "sdccss-ri-rl-4", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("sdccss", "fiction", "vocabulary", "sdccss-ri-rl-4", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("sdccss", "non-fiction", "structure", "sdccss-ri-rl-5", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("sdccss", "fiction", "structure", "sdccss-ri-rl-5", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("sdccss", "non-fiction", "pov", "sdccss-ri-rl-6", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("sdccss", "fiction", "pov", "sdccss-ri-rl-6", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("sdccss", "non-fiction", "media", "sdccss-ri-rl-7", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("sdccss", "fiction", "media", "sdccss-ri-rl-7", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("sdccss", "non-fiction", "arguments", "sdccss-ri-8", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("sdccss", "non-fiction", "connections", "sdccss-ri-rl-9", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("sdccss", "fiction", "connections", "sdccss-ri-rl-9", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("sdccss", "non-fiction", "reading-level", "sdccss-ri-rl-10", "SDCCSS.ELA.{{GRADE}}{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// AR Standards
			add("ars", "non-fiction", "inferences", "ars-ri-rl-1", "ARS.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ars", "fiction", "inferences", "ars-ri-rl-1", "ARS.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ars", "non-fiction", "ideas", "ars-ri-rl-2", "ARS.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ars", "fiction", "ideas", "ars-ri-rl-2", "ARS.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ars", "non-fiction", "developments", "ars-ri-rl-3", "ARS.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ars", "fiction", "developments", "ars-ri-rl-3", "ARS.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ars", "non-fiction", "vocabulary", "ars-ri-rl-4", "ARS.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ars", "fiction", "vocabulary", "ars-ri-rl-4", "ARS.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ars", "non-fiction", "structure", "ars-ri-rl-5", "ARS.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ars", "fiction", "structure", "ars-ri-rl-5", "ARS.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ars", "non-fiction", "pov", "ars-ri-rl-6", "ARS.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ars", "fiction", "pov", "ars-ri-rl-6", "ARS.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ars", "non-fiction", "media", "ars-ri-rl-7", "ARS.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ars", "fiction", "media", "ars-ri-rl-7", "ARS.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ars", "non-fiction", "arguments", "ars-ri-8", "ARS.ELA.{{GRADE}}{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ars", "non-fiction", "connections", "ars-ri-rl-9", "ARS.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ars", "fiction", "connections", "ars-ri-rl-9", "ARS.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ars", "non-fiction", "reading-level", "ars-ri-rl-10", "ARS.ELA.{{GRADE}}{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// NYSNG
			add("nysng", "non-fiction", "inferences", "nysng-ri-rl-1", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("nysng", "fiction", "inferences", "nysng-ri-rl-1", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("nysng", "non-fiction", "ideas", "nysng-ri-rl-2", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("nysng", "fiction", "ideas", "nysng-ri-rl-2", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("nysng", "non-fiction", "developments", "nysng-ri-rl-3", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("nysng", "fiction", "developments", "nysng-ri-rl-3", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("nysng", "non-fiction", "vocabulary", "nysng-ri-rl-4", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("nysng", "fiction", "vocabulary", "nysng-ri-rl-4", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("nysng", "non-fiction", "structure", "nysng-ri-rl-5", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("nysng", "fiction", "structure", "nysng-ri-rl-5", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("nysng", "non-fiction", "pov", "nysng-ri-rl-6", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("nysng", "fiction", "pov", "nysng-ri-rl-6", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("nysng", "non-fiction", "media", "nysng-ri-rl-7", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("nysng", "fiction", "media", "nysng-ri-rl-7", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("nysng", "non-fiction", "arguments", "nysng-ri-8", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("nysng", "non-fiction", "connections", "nysng-ri-rl-9", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("nysng", "fiction", "connections", "nysng-ri-rl-9", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("nysng", "non-fiction", "reading-level", "nysng-ri-rl-10", "NYSNG.ELA.{{GRADE}}{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// MSCCRS
			add("msccrs", "non-fiction", "inferences", "msccrs-ri-rl-1", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("msccrs", "fiction", "inferences", "msccrs-ri-rl-1", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("msccrs", "non-fiction", "ideas", "msccrs-ri-rl-2", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("msccrs", "fiction", "ideas", "msccrs-ri-rl-2", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("msccrs", "non-fiction", "developments", "msccrs-ri-rl-3", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("msccrs", "fiction", "developments", "msccrs-ri-rl-3", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("msccrs", "non-fiction", "vocabulary", "msccrs-ri-rl-4", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("msccrs", "fiction", "vocabulary", "msccrs-ri-rl-4", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("msccrs", "non-fiction", "structure", "msccrs-ri-rl-5", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("msccrs", "fiction", "structure", "msccrs-ri-rl-5", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("msccrs", "non-fiction", "pov", "msccrs-ri-rl-6", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("msccrs", "fiction", "pov", "msccrs-ri-rl-6", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("msccrs", "non-fiction", "media", "msccrs-ri-rl-7", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("msccrs", "fiction", "media", "msccrs-ri-rl-7", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("msccrs", "non-fiction", "arguments", "msccrs-ri-8", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("msccrs", "non-fiction", "connections", "msccrs-ri-rl-9", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("msccrs", "fiction", "connections", "msccrs-ri-rl-9", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("msccrs", "non-fiction", "reading-level", "msccrs-ri-rl-10", "MSCCRS.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// ND Standards
			add("nds", "non-fiction", "inferences", "nds-ri-rl-1", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("nds", "fiction", "inferences", "nds-ri-rl-1", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("nds", "non-fiction", "ideas", "nds-ri-rl-2", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("nds", "fiction", "ideas", "nds-ri-rl-2", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("nds", "non-fiction", "developments", "nds-ri-rl-3", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("nds", "fiction", "developments", "nds-ri-rl-3", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("nds", "non-fiction", "vocabulary", "nds-ri-rl-4", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("nds", "fiction", "vocabulary", "nds-ri-rl-4", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("nds", "non-fiction", "structure", "nds-ri-rl-5", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("nds", "fiction", "structure", "nds-ri-rl-5", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("nds", "non-fiction", "pov", "nds-ri-rl-6", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("nds", "fiction", "pov", "nds-ri-rl-6", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("nds", "non-fiction", "media", "nds-ri-rl-7", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("nds", "fiction", "media", "nds-ri-rl-7", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("nds", "non-fiction", "arguments", "nds-ri-8", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("nds", "non-fiction", "connections", "nds-ri-rl-9", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("nds", "fiction", "connections", "nds-ri-rl-9", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("nds", "non-fiction", "reading-level", "nds-ri-rl-10", "NDS.ELA-LITERACY.{{GRADEPRETTY}}.{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// UT Core
			add("utcore", "non-fiction", "inferences", "utcore-ri-rl-1", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("utcore", "fiction", "inferences", "utcore-ri-rl-1", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("utcore", "non-fiction", "ideas", "utcore-ri-rl-2", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("utcore", "fiction", "ideas", "utcore-ri-rl-2", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("utcore", "non-fiction", "developments", "utcore-ri-rl-3", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("utcore", "fiction", "developments", "utcore-ri-rl-3", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("utcore", "non-fiction", "vocabulary", "utcore-ri-rl-4", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("utcore", "fiction", "vocabulary", "utcore-ri-rl-4", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("utcore", "non-fiction", "structure", "utcore-ri-rl-5", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("utcore", "fiction", "structure", "utcore-ri-rl-5", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("utcore", "non-fiction", "pov", "utcore-ri-rl-6", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("utcore", "fiction", "pov", "utcore-ri-rl-6", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("utcore", "non-fiction", "media", "utcore-ri-rl-7", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("utcore", "fiction", "media", "utcore-ri-rl-7", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("utcore", "non-fiction", "arguments", "utcore-ri-8", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("utcore", "non-fiction", "connections", "utcore-ri-rl-9", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("utcore", "fiction", "connections", "utcore-ri-rl-9", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("utcore", "non-fiction", "reading-level", "utcore-ri-rl-10", "UTCORE.ELA.{{GRADEPRETTY}}.{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// OR Standards
			add("ors", "non-fiction", "inferences", "ors-ri-rl-1", "ORS.ELA.{{GRADE}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ors", "fiction", "inferences", "ors-ri-rl-1", "ORS.ELA.{{GRADE}}.{{RI/RL}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ors", "non-fiction", "ideas", "ors-ri-rl-2", "ORS.ELA.{{GRADE}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ors", "fiction", "ideas", "ors-ri-rl-2", "ORS.ELA.{{GRADE}}.{{RI/RL}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ors", "non-fiction", "developments", "ors-ri-rl-3", "ORS.ELA.{{GRADE}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ors", "fiction", "developments", "ors-ri-rl-3", "ORS.ELA.{{GRADE}}.{{RI/RL}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ors", "non-fiction", "vocabulary", "ors-ri-rl-4", "ORS.ELA.{{GRADE}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ors", "fiction", "vocabulary", "ors-ri-rl-4", "ORS.ELA.{{GRADE}}.{{RI/RL}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ors", "non-fiction", "structure", "ors-ri-rl-5", "ORS.ELA.{{GRADE}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ors", "fiction", "structure", "ors-ri-rl-5", "ORS.ELA.{{GRADE}}.{{RI/RL}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ors", "non-fiction", "pov", "ors-ri-rl-6", "ORS.ELA.{{GRADE}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ors", "fiction", "pov", "ors-ri-rl-6", "ORS.ELA.{{GRADE}}.{{RI/RL}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ors", "non-fiction", "media", "ors-ri-rl-7", "ORS.ELA.{{GRADE}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ors", "fiction", "media", "ors-ri-rl-7", "ORS.ELA.{{GRADE}}.{{RI/RL}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ors", "non-fiction", "arguments", "ors-ri-8", "ORS.ELA.{{GRADE}}.{{RI/RL}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ors", "non-fiction", "connections", "ors-ri-rl-9", "ORS.ELA.{{GRADE}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ors", "fiction", "connections", "ors-ri-rl-9", "ORS.ELA.{{GRADE}}.{{RI/RL}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ors", "non-fiction", "reading-level", "ors-ri-rl-10", "ORS.ELA.{{GRADE}}.{{RI/RL}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// MD CCRS
			add("mdccrs", "non-fiction", "inferences", "mdccrs-ri-rl-1", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mdccrs", "fiction", "inferences", "mdccrs-ri-rl-1", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mdccrs", "non-fiction", "ideas", "mdccrs-ri-rl-2", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mdccrs", "fiction", "ideas", "mdccrs-ri-rl-2", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mdccrs", "non-fiction", "developments", "mdccrs-ri-rl-3", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mdccrs", "fiction", "developments", "mdccrs-ri-rl-3", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mdccrs", "non-fiction", "vocabulary", "mdccrs-ri-rl-4", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mdccrs", "fiction", "vocabulary", "mdccrs-ri-rl-4", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mdccrs", "non-fiction", "structure", "mdccrs-ri-rl-5", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mdccrs", "fiction", "structure", "mdccrs-ri-rl-5", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mdccrs", "non-fiction", "pov", "mdccrs-ri-rl-6", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mdccrs", "fiction", "pov", "mdccrs-ri-rl-6", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mdccrs", "non-fiction", "media", "mdccrs-ri-rl-7", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mdccrs", "fiction", "media", "mdccrs-ri-rl-7", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mdccrs", "non-fiction", "arguments", "mdccrs-ri-8", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("mdccrs", "non-fiction", "connections", "mdccrs-ri-rl-9", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mdccrs", "fiction", "connections", "mdccrs-ri-rl-9", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mdccrs", "non-fiction", "reading-level", "mdccrs-ri-rl-10", "MDCCRS.ELA.{{GRADEPRETTY}}.{{RI/RL}}10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// MO Standards (6-12)
			add("mls612", "non-fiction", "inferences", "mls612-ri-rl-1a", "{{GRADE}}.{{RI/RL}}.1.A", "Evidence/Inference", "Draw conclusions, infer, and analyze by citing textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.");
			add("mls612", "fiction", "inferences", "mls612-ri-rl-1a", "{{GRADE}}.{{RI/RL}}.1.A", "Evidence/Inference", "Draw conclusions, infer, and analyze by citing textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.");
			add("mls612", "non-fiction", "ideas", "mls612-ri-rl-1d", "{{GRADE}}.{{RI/RL}}.1.D", "Summarize/Claim/Theme ", "Explain the central/main idea(s) of a text and cite evidence of its development. Using appropriate text, determine the theme(s) of a text and cite evidence of its development. Summarize the text. ");
			add("mls612", "fiction", "ideas", "mls612-ri-rl-1d", "{{GRADE}}.{{RI/RL}}.1.D", "Summarize/Claim/Theme ", "Explain the central/main idea(s) of a text and cite evidence of its development. Using appropriate text, determine the theme(s) of a text and cite evidence of its development. Summarize the text. ");
			add("mls612", "fiction", "developments", "mls612-rl-2d", "{{GRADE}}.{{RI/RL}}.2.D", "Interaction and Meaning ", "Describe how a particular text's plot unfolds in a series of episodes as well as how the characters respond or change as the plot moves toward a resolution.");
			add("mls612", "non-fiction", "vocabulary", "mls612-ri-rl-1b-2c", "{{GRADE}}.{{RI/RL}}.1.B.2.C", "Word Meanings/Craft", "Determine the meaning of words and phrases as they are used in the text, including figurative, connotative, and content-specific meanings using context, affixes, or reference materials. Analyze how word choice, including the use of figurative language, connotations, and/or repetition or words or word sounds, contributes to meaning.");
			add("mls612", "fiction", "vocabulary", "mls612-ri-rl-1b-2c", "{{GRADE}}.{{RI/RL}}.1.B.2.C", "Word Meanings/Craft", "Determine the meaning of words and phrases as they are used in the text, including figurative, connotative, and content-specific meanings using context, affixes, or reference materials. Analyze how word choice, including the use of figurative language, connotations, and/or repetition or words or word sounds, contributes to meaning.");
			add("mls612", "non-fiction", "structure", "mls612-ri-rl-2a", "{{GRADE}}.{{RI/RL}}.2.A", "Structure", "Analyze how a particular sentence, chapter, paragraph, section, scene, stanza, or image contributes to meaning. ");
			add("mls612", "fiction", "structure", "mls612-ri-rl-2a", "{{GRADE}}.{{RI/RL}}.2.A", "Structure", "Analyze how a particular sentence, chapter, paragraph, section, scene, stanza, or image contributes to meaning. ");
			add("mls612", "non-fiction", "pov", "mls612-ri-rl-2b", "{{GRADE}}.{{RI/RL}}.2.B", "Point of View", "Explain how an author's point of view or purpose is conveyed in a text. Explain how an author develops the point of view of the narrator or speaker in a text.");
			add("mls612", "fiction", "pov", "mls612-ri-rl-2b", "{{GRADE}}.{{RI/RL}}.2.B", "Point of View", "Explain how an author's point of view or purpose is conveyed in a text. Explain how an author develops the point of view of the narrator or speaker in a text.");
			add("mls612", "non-fiction", "media", "mls612-ri-rl-1c-3a", "{{GRADE}}.{{RI/RL}}.1.C.3.A", "Text Features/Forms", "Compare and contrast the experience of reading a text to listening to or viewing an audio, video, or live version, noting how a performance impacts personal interpretation. Interpret visual elements of a text including those from different media and draw conclusions from them (when applicable). ");
			add("mls612", "fiction", "media", "mls612-ri-rl-1c-3a", "{{GRADE}}.{{RI/RL}}.1.C.3.A", "Text Features/Forms", "Compare and contrast the experience of reading a text to listening to or viewing an audio, video, or live version, noting how a performance impacts personal interpretation. Interpret visual elements of a text including those from different media and draw conclusions from them (when applicable). ");
			add("mls612", "non-fiction", "arguments", "mls612-ri-2d", "{{GRADE}}.{{RI/RL}}.2.D", "Argument/Evidence", "Identify an author's argument in a text and distinguish claims that are supported by reasons and evidence from claims that are not. ");
			add("mls612", "non-fiction", "connections", "mls612-ri-rl-3b", "{{GRADE}}.{{RI/RL}}.3.B", "Relationships in Texts ", "Compare and contrast one author's presentation of events with that of another, and texts in different genres that address similar themes or topics.");
			add("mls612", "fiction", "connections", "mls612-ri-rl-3b", "{{GRADE}}.{{RI/RL}}.3.B", "Relationships in Texts ", "Compare and contrast one author's presentation of events with that of another, and texts in different genres that address similar themes or topics.");
			add("mls612", "non-fiction", "reading-level", "mls612-ri-rl-3d", "{{GRADE}}.{{RI/RL}}.3.D", "Comprehension", "Read and comprehend informational text and literature, including stories, dramas, and poems, independently and proficiently.");
			add("mls612", "non-fiction", "introspection-and-application", "mls612-ri-rl-3c", "{{GRADE}}.{{RI/RL}}.3.C", "Historical Context", "Explain how the text (including plot and conflict in fiction) reflects historical and/or cultural contexts.");
			add("mls612", "fiction", "introspection-and-application", "mls612-ri-rl-3c", "{{GRADE}}.{{RI/RL}}.3.C", "Historical Context", "Explain how the text (including plot and conflict in fiction) reflects historical and/or cultural contexts.");
	
			// MO Standards (K-5)
			add("mlsk5", "non-fiction", "inferences", "mlsk5-ri-3c", "Reading.{{GRADEPRETTY}}.3C", "Text Structures", "");
			add("mlsk5", "fiction", "inferences", "mlsk5-rl-2a", "Reading.{{GRADEPRETTY}}.2A", "Fiction", "");
			add("mlsk5", "non-fiction", "ideas", "mlsk5-ri-3c", "Reading.{{GRADEPRETTY}}.3C", "Text Structures", "");
			add("mlsk5", "fiction", "ideas", "mlsk5-rl-2a", "Reading.{{GRADEPRETTY}}.2A", "Fiction", "");
			add("mlsk5", "fiction", "developments", "mlsk5-rl-2a", "Reading.{{GRADEPRETTY}}.2A", "Fiction", "");
			add("mlsk5", "non-fiction", "vocabulary", "mlsk5-ri-rl-1b", "Reading.{{GRADEPRETTY}}.1B", "Vocabulary", "");
			add("mlsk5", "fiction", "vocabulary", "mlsk5-ri-rl-1b", "Reading.{{GRADEPRETTY}}.1B", "Vocabulary", "");
			add("mlsk5", "non-fiction", "structure", "mlsk5-ri-3a", "Reading.{{GRADEPRETTY}}.3A", "Text Features", "");
			add("mlsk5", "fiction", "structure", "mlsk5-rl-2a", "Reading.{{GRADEPRETTY}}.2A", "Fiction", "");
			add("mlsk5", "non-fiction", "pov", "mlsk5-ri-3b", "Reading.{{GRADEPRETTY}}.3B", "Literary Techniques", "");
			add("mlsk5", "fiction", "pov", "mlsk5-rl-2a", "Reading.{{GRADEPRETTY}}.2A", "Fiction", "");
			add("mlsk5", "non-fiction", "media", "mlsk5-ri-rl-4a", "Reading.{{GRADEPRETTY}}.4A", "Digital and Media Literacy ", "");
			add("mlsk5", "fiction", "media", "mlsk5-ri-rl-4a", "Reading.{{GRADEPRETTY}}.4A", "Digital and Media Literacy ", "");
			add("mlsk5", "non-fiction", "arguments", "mlsk5-ri-3b", "Reading.{{GRADEPRETTY}}.3B", "Literary Techniques", "");
			add("mlsk5", "non-fiction", "connections", "mlsk5-ri-rl-1c", "Reading.{{GRADEPRETTY}}.1C", "Making Connections", "");
			add("mlsk5", "fiction", "connections", "mlsk5-ri-rl-1c", "Reading.{{GRADEPRETTY}}.1C", "Making Connections", "");
			add("mlsk5", "non-fiction", "reading-level", "mlsk5-ri-rl-1d", "Reading.{{GRADEPRETTY}}.1D", "Independent Text", "");
			add("mlsk5", "non-fiction", "introspection-and-application", "mlsk5-ri-rl-1c", "Reading.{{GRADEPRETTY}}.1C", "Making Connections", "");
			add("mlsk5", "fiction", "introspection-and-application", "mlsk5-ri-rl-1c", "Reading.{{GRADEPRETTY}}.1C", "Making Connections", "");
	
			// CA CCSS
			add("caccss", "non-fiction", "inferences", "caccss-ri-rl-1", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("caccss", "fiction", "inferences", "caccss-ri-rl-1", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("caccss", "non-fiction", "ideas", "caccss-ri-rl-2", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("caccss", "fiction", "ideas", "caccss-ri-rl-2", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("caccss", "non-fiction", "developments", "caccss-ri-rl-3", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("caccss", "fiction", "developments", "caccss-ri-rl-3", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("caccss", "non-fiction", "vocabulary", "caccss-ri-rl-4", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("caccss", "fiction", "vocabulary", "caccss-ri-rl-4", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("caccss", "non-fiction", "structure", "caccss-ri-rl-5", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("caccss", "fiction", "structure", "caccss-ri-rl-5", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("caccss", "non-fiction", "pov", "caccss-ri-rl-6", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("caccss", "fiction", "pov", "caccss-ri-rl-6", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("caccss", "non-fiction", "media", "caccss-ri-rl-7", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("caccss", "fiction", "media", "caccss-ri-rl-7", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("caccss", "non-fiction", "arguments", "caccss-ri-8", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("caccss", "non-fiction", "connections", "caccss-ri-rl-9", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("caccss", "fiction", "connections", "caccss-ri-rl-9", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("caccss", "non-fiction", "reading-level", "caccss-ri-rl-10", "CA-CCSS.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// MI CCRAS
			add("miccras", "non-fiction", "inferences", "miccras-ri-rl-1", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("miccras", "fiction", "inferences", "miccras-ri-rl-1", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("miccras", "non-fiction", "ideas", "miccras-ri-rl-2", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("miccras", "fiction", "ideas", "miccras-ri-rl-2", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("miccras", "non-fiction", "developments", "miccras-ri-rl-3", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("miccras", "fiction", "developments", "miccras-ri-rl-3", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("miccras", "non-fiction", "vocabulary", "miccras-ri-rl-4", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("miccras", "fiction", "vocabulary", "miccras-ri-rl-4", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("miccras", "non-fiction", "structure", "miccras-ri-rl-5", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("miccras", "fiction", "structure", "miccras-ri-rl-5", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("miccras", "non-fiction", "pov", "miccras-ri-rl-6", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("miccras", "fiction", "pov", "miccras-ri-rl-6", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("miccras", "non-fiction", "media", "miccras-ri-rl-7", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("miccras", "fiction", "media", "miccras-ri-rl-7", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("miccras", "non-fiction", "arguments", "miccras-ri-8", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("miccras", "non-fiction", "connections", "miccras-ri-rl-9", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("miccras", "fiction", "connections", "miccras-ri-rl-9", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("miccras", "non-fiction", "reading-level", "miccras-ri-rl-10", "MI-CCRAS.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// MN CCRAS
			add("mnccras", "non-fiction", "inferences", "mnccras-1-2-1", "MN-CCRAS.ELA.{{NEGRADE}}.{{RI/RL}}.1.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mnccras", "fiction", "inferences", "mnccras-1-2-1", "MN-CCRAS.ELA.{{NEGRADE}}.{{RI/RL}}.1.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("mnccras", "non-fiction", "ideas", "mnccras-1-2-2", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.2.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mnccras", "fiction", "ideas", "mnccras-1-2-2", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.2.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("mnccras", "non-fiction", "developments", "mnccras-1-2-3", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.3.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mnccras", "fiction", "developments", "mnccras-1-2-3", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.3.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("mnccras", "non-fiction", "vocabulary", "mnccras-1-2-4", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.4.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mnccras", "fiction", "vocabulary", "mnccras-1-2-4", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.4.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("mnccras", "non-fiction", "structure", "mnccras-1-2-5", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.5.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mnccras", "fiction", "structure", "mnccras-1-2-5", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.5.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("mnccras", "non-fiction", "pov", "mnccras-1-2-6", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.6.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mnccras", "fiction", "pov", "mnccras-1-2-6", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.6.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("mnccras", "non-fiction", "media", "mnccras-1-2-7", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.7.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mnccras", "fiction", "media", "mnccras-1-2-7", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.7.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("mnccras", "non-fiction", "arguments", "mnccras-2-8", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.8.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("mnccras", "non-fiction", "connections", "mnccras-1-2-9", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.9.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mnccras", "fiction", "connections", "mnccras-1-2-9", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.9.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("mnccras", "non-fiction", "reading-level", "mnccras-1-2-10", "MN-CCRAS.ELA.{{NEGRADE}}.{{1/2}}.10.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// LA Standards
			add("lass", "non-fiction", "inferences", "lass-ri-rl-1", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("lass", "fiction", "inferences", "lass-ri-rl-1", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("lass", "non-fiction", "ideas", "lass-ri-rl-2", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("lass", "fiction", "ideas", "lass-ri-rl-2", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("lass", "non-fiction", "developments", "lass-ri-rl-3", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("lass", "fiction", "developments", "lass-ri-rl-3", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("lass", "non-fiction", "vocabulary", "lass-ri-rl-4", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("lass", "fiction", "vocabulary", "lass-ri-rl-4", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("lass", "non-fiction", "structure", "lass-ri-rl-5", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("lass", "fiction", "structure", "lass-ri-rl-5", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("lass", "non-fiction", "pov", "lass-ri-rl-6", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("lass", "fiction", "pov", "lass-ri-rl-6", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("lass", "non-fiction", "media", "lass-ri-rl-7", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("lass", "fiction", "media", "lass-ri-rl-7", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("lass", "non-fiction", "arguments", "lass-ri-8", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("lass", "non-fiction", "connections", "lass-ri-rl-9", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("lass", "fiction", "connections", "lass-ri-rl-9", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("lass", "non-fiction", "reading-level", "lass-ri-rl-10", "LA-Student-Standards.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// IL CCSS
			add("ilccss", "non-fiction", "inferences", "ilccss-ri-rl-1", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ilccss", "fiction", "inferences", "ilccss-ri-rl-1", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.1", "Key Ideas & Details - 1", "Read closely to determine what the text says explicitly and to make logical inferences from it; cite specific textual evidence when writing or speaking to support conclusions drawn from the text.");
			add("ilccss", "non-fiction", "ideas", "ilccss-ri-rl-2", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ilccss", "fiction", "ideas", "ilccss-ri-rl-2", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.2", "Key Ideas & Details - 2", "Determine central ideas or themes of a text and analyze their development; summarize the key supporting details and ideas.");
			add("ilccss", "non-fiction", "developments", "ilccss-ri-rl-3", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ilccss", "fiction", "developments", "ilccss-ri-rl-3", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.3", "Key Ideas & Details - 3", "Analyze how and why individuals, events, or ideas develop and interact over the course of a text.");
			add("ilccss", "non-fiction", "vocabulary", "ilccss-ri-rl-4", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ilccss", "fiction", "vocabulary", "ilccss-ri-rl-4", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.4", "Craft & Structure - 4", "Interpret words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, and analyze how specific word choices shape meaning or tone.");
			add("ilccss", "non-fiction", "structure", "ilccss-ri-rl-5", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ilccss", "fiction", "structure", "ilccss-ri-rl-5", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.5", "Craft & Structure - 5", "Analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text (e.g., a section, chapter, scene, or stanza) relate to each other and the whole.");
			add("ilccss", "non-fiction", "pov", "ilccss-ri-rl-6", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ilccss", "fiction", "pov", "ilccss-ri-rl-6", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.6", "Craft & Structure - 6", "Assess how point of view or purpose shapes the content and style of a text.");
			add("ilccss", "non-fiction", "media", "ilccss-ri-rl-7", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ilccss", "fiction", "media", "ilccss-ri-rl-7", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.7", "Integrate Knowledge & Ideas - 7", "Integrate and evaluate content presented in diverse media and formats, including visually and quantitatively, as well as in words.");
			add("ilccss", "non-fiction", "arguments", "ilccss-ri-8", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.8", "Integrate Knowledge & Ideas - 8", "Delineate and evaluate the argument and specific claims in a text, including the validity of the reasoning as well as the relevance and sufficiency of the evidence.");
			add("ilccss", "non-fiction", "connections", "ilccss-ri-rl-9", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ilccss", "fiction", "connections", "ilccss-ri-rl-9", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.9", "Integrate Knowledge & Ideas - 9", "Analyze how two or more texts address similar themes or topics in order to build knowledge or to compare the approaches the authors take.");
			add("ilccss", "non-fiction", "reading-level", "ilccss-ri-rl-10", "IL-CCSS.ELA.{{RI/RL}}.{{GRADE}}.10", "Reading & Text Complexity - 10", "Read and comprehend complex literary and informational texts independently and proficiently.");
	
			// BC Standards
			add("bccan", "non-fiction", "inferences", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "fiction", "inferences", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "non-fiction", "ideas", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "fiction", "ideas", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "non-fiction", "developments", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "fiction", "developments", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "non-fiction", "structure", "bccan-strat", "BC-Reading-{{Literature/Information}}-Strategies", "Strategies", "Adjust for purpose - Word Skills - Comprehension Strategies");
			add("bccan", "fiction", "structure", "bccan-strat", "BC-Reading-{{Literature/Information}}-Strategies", "Strategies", "Adjust for purpose - Word Skills - Comprehension Strategies");
			add("bccan", "non-fiction", "pov", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "fiction", "pov", "bccan-comp", "BC-Reading-{{Literature/Information}}-Comprehension", "Comprehension", "Characters - Events - Retell/Explain Relationships - Inferences");
			add("bccan", "non-fiction", "connections", "bccan-res-ana", "BC-Reading-{{Literature/Information}}-Response-and-Analysis", "Response and Analysis", "Connections to Experiences and Other Selections - Opinions");
			add("bccan", "fiction", "connections", "bccan-res-ana", "BC-Reading-{{Literature/Information}}-Response-and-Analysis", "Response and Analysis", "Connections to Experiences and Other Selections - Opinions");
			add("bccan", "non-fiction", "reading-level", "bccan-strat", "BC-Reading-{{Literature/Information}}-Strategies", "Strategies", "Adjust for purpose - Word Skills - Comprehension Strategies");
			add("bccan", "non-fiction", "introspection-and-application", "bccan-res-ana", "BC-Reading-{{Literature/Information}}-Response-and-Analysis", "Response and Analysis", "Connections to Experiences and Other Selections - Opinions");
			add("bccan", "fiction", "introspection-and-application", "bccan-res-ana", "BC-Reading-{{Literature/Information}}-Response-and-Analysis", "Response and Analysis", "Connections to Experiences and Other Selections - Opinions");
		}
	};
	
	AltSkillsets.STANDARD_KEYS = _.keys(AltSkillsets.STANDARDS);
	
	module.exports = AltSkillsets;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _COOKIE_MAP;
	
	exports.switchToStudent = switchToStudent;
	exports.returnToAccount = returnToAccount;
	exports.hasReturnAccount = hasReturnAccount;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CurrentUser = __webpack_require__(3);
	var Cookies = __webpack_require__(188);
	
	function switchToStudent(student) {
		var username = student.username;
		var password = student.password;
	
		if (!(username && password)) {
			throw "Student is missing username or password.";
		}
	
		if (!student.demo_for_teacher) {
			throw "Can only switch to demo_for_teacher student accounts";
		}
	
		var domain = CurrentUser.getCookieDomain();
		_.each(COOKIE_MAP, function (userKey, returnKey) {
			var userValue = Cookies.get(userKey, { domain: domain });
			Cookies.set(returnKey, userValue, { expires: 10000, domain: domain });
		});
	
		window.wrNotifications.triggerDropDownNotification({
			title: "Switching to demo account", text: "Just a few moments....", icon: "random" }, 10000);
	
		CurrentUser.usernamePasswordAuthenticate(username, password, function (success, errorText) {
			if (success) {
				$wr.redirect('/');
				window.location.reload();
			} else {
				throw "Account switcher error: " + errorText;
			}
		});
	}
	
	function returnToAccount() {
		if (!hasReturnAccount()) {
			return;
		}
	
		var domain = CurrentUser.getCookieDomain();
	
		_.each(COOKIE_MAP, function (userKey, returnKey) {
			var returnValue = Cookies.get(returnKey, { domain: domain });
			Cookies.set(userKey, returnValue, { expires: 10000, domain: domain });
			Cookies.remove(returnKey, { domain: domain });
		});
	
		$wr.redirect('/');
		window.location.reload();
	}
	
	function hasReturnAccount() {
		var user = CurrentUser.get();
	
		if (user == undefined || !user.demo_for_teacher) {
			return false;
		}
	
		var domain = CurrentUser.getCookieDomain();
	
		var hasAccount = true;
		_.each(COOKIE_MAP, function (userKey, returnKey) {
			hasAccount = hasAccount && Cookies.get(returnKey, { domain: domain });
		});
	
		return hasAccount;
	}
	
	var RETURN_USER_ID_KEY = "wr_returnCurrentUserID";
	var RETURN_USER_TYPE_KEY = "wr_returnCurrentUserType";
	var RETURN_USER_TOKEN_KEY = "wr_returnCurrentUserToken";
	
	var COOKIE_MAP = (_COOKIE_MAP = {}, _defineProperty(_COOKIE_MAP, RETURN_USER_ID_KEY, CurrentUser.USER_ID_KEY), _defineProperty(_COOKIE_MAP, RETURN_USER_TYPE_KEY, CurrentUser.USER_TYPE_KEY), _defineProperty(_COOKIE_MAP, RETURN_USER_TOKEN_KEY, CurrentUser.USER_TOKEN_KEY), _COOKIE_MAP);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _METRICS_BY_CATEGORY, _CSV_ORGANIZATION_OPT, _DATE_PERIODS_BY_ORG_, _SUBJECT_TO_EXPORT_ME;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	////////// READ BEFORE EDITING THIS FILE !! //////////
	// The configuration on this file needs to match the configuration on L2E's DataExportComposer
	// Any edits to this file need to transfered to the DataExportComposer as well
	
	var StudentMetrics = __webpack_require__(29);
	var DataRouting = __webpack_require__(36);
	
	var TEACHER = exports.TEACHER = 'teacher';
	var ADMIN = exports.ADMIN = 'admin';
	var PER_STUDENT = exports.PER_STUDENT = 'per-student';
	var PER_CLASS = exports.PER_CLASS = 'per-class';
	var PER_TEACHER = exports.PER_TEACHER = 'per-teacher';
	var CHRONO = exports.CHRONO = 'chrono';
	
	var QUIZZES = exports.QUIZZES = 'quizzes';
	var GOALS = exports.GOALS = 'goals';
	var PRACTICE_QUESTIONS = exports.PRACTICE_QUESTIONS = 'practice_questions';
	var REVIEWS = exports.REVIEWS = 'reviews';
	var BOOKS = exports.BOOKS = 'books';
	var ACTIVITIES = exports.ACTIVITIES = 'activities';
	var READING_LOGS = exports.READING_LOGS = 'reading_logs';
	var ADDITIONAL_METRICS = exports.ADDITIONAL_METRICS = 'additional_metrics';
	var ROSTER = exports.ROSTER = 'roster';
	
	var QUIZ_RUBRIC = [{ key: 'crit-evi-cote-bert-read-book-1', label: "Read Book" }, { key: 'crit-rc-atq-coqa-fully-answered-2', label: "Fully Answered Question" }, { key: 'crit-evi-cote-bert-quantity-14', label: "Text Details Count" }, { key: 'crit-rc-atq-cors-bert-10', label: "Restated Question" }];
	
	var RUBRIC = [].concat(QUIZ_RUBRIC, [{ key: 'comm-conv-mech-caps-4', label: "Capitalization" }, { key: 'comm-conv-mech-punc-8', label: "Punctuation" }, { key: 'comm-conv-mech-spell-13', label: "Spelling" }, { key: 'comm-conv-mech-gram-5', label: "Grammar" }, { key: 'comm-conv-org-word-count-18', label: "Word Count" }, { key: 'comm-conv-org-sent-count-11', label: "Sentence Count" }]);
	
	var METRICS_BY_CATEGORY = exports.METRICS_BY_CATEGORY = (_METRICS_BY_CATEGORY = {}, _defineProperty(_METRICS_BY_CATEGORY, QUIZZES, [{ key: 'quiz-score', label: 'Quiz Score' }, { key: 'lexile-level', label: 'Lexile Level' }].concat(QUIZ_RUBRIC)), _defineProperty(_METRICS_BY_CATEGORY, PRACTICE_QUESTIONS, [{ key: 'practice-question-score', label: 'Practice Question Score' }, { key: 'lexile-level', label: 'Lexile Level' }].concat(_toConsumableArray(RUBRIC))), _defineProperty(_METRICS_BY_CATEGORY, REVIEWS, [{ key: 'lexile-level', label: 'Lexile Level' }]), _defineProperty(_METRICS_BY_CATEGORY, BOOKS, [{ key: 'lexile-level', label: 'Lexile Level' }, { key: 'quiz-score', label: 'Quiz Score' }, { key: 'crit-evi-cote-bert-read-book-1', label: "Read Book" }, { key: 'review-count', label: 'Review Count' }, { key: 'practice-question-count', label: 'Practice Question Count' }, { key: 'exercise-count', label: 'Exercise Count' }, { key: 'question-builder-count', label: 'Question Builder Count' }]), _defineProperty(_METRICS_BY_CATEGORY, ACTIVITIES, [{ key: 'assigned', label: 'Assigned' }, { key: 'due-date', label: 'Due Date' }, { key: 'text-title', label: 'Text Title' }, { key: 'exercise-title', label: 'Exercise Title' }, { key: 'skill-set', label: 'Skill Set' }, { key: 'format', label: 'Format' }, { key: 'completed-at', label: 'Completed At' }]), _defineProperty(_METRICS_BY_CATEGORY, READING_LOGS, [{ key: 'lexile-level', label: 'Lexile Level' }, { key: 'minutes', label: "Minutes" }, { key: 'pages', label: "Pages" }]), _defineProperty(_METRICS_BY_CATEGORY, GOALS, [{ key: 'quizzes-passed', label: 'Quizzes Passed' }, { key: 'questions', label: 'Practice Questions' }, { key: 'reviews', label: 'Reviews' }, { key: 'exercises', label: 'Exercises' }, { key: 'minutes', label: 'Minutes Logged' }, { key: 'pages', label: 'Pages Read' }, { key: 'days-active', label: 'Days Active' }, { key: 'question-builder', label: 'Question Builders' }]), _defineProperty(_METRICS_BY_CATEGORY, ADDITIONAL_METRICS, [{ label: 'Quizzes', children: StudentMetrics.quizMetrics() }, { label: 'Writing', children: StudentMetrics.writingMetrics() }, { label: 'Reading', children: StudentMetrics.readingMetrics() }, { label: 'Other Metrics', children: StudentMetrics.otherMetrics() }]), _defineProperty(_METRICS_BY_CATEGORY, ROSTER, [{ key: 'username', label: 'Username' }, { key: 'password', label: 'Password' }, { key: 'primary_student_list', label: 'Primary Student List' }, { key: 'all_student_lists', label: 'All Student Lists' }, { key: 'grade_level', label: 'Grade Level' }, { key: 'academic_level', label: 'Academic Grade' }, { key: 'reading_level', label: 'Reading Level' }]), _METRICS_BY_CATEGORY);
	
	var CSV_ORGANIZATION_OPTIONS = exports.CSV_ORGANIZATION_OPTIONS = (_CSV_ORGANIZATION_OPT = {}, _defineProperty(_CSV_ORGANIZATION_OPT, TEACHER, [{ key: 'chrono', label: 'Chronologically' }, { key: 'per-class', label: 'Per-Class' }, { key: 'per-student', label: 'Per-Student' }]), _defineProperty(_CSV_ORGANIZATION_OPT, ADMIN, [{ key: 'chrono', label: 'Chronologically' }, { key: 'per-teacher', label: 'Per-Teacher' }, { key: 'per-class', label: 'Per-Class' }, { key: 'per-student', label: 'Per-Student' }]), _CSV_ORGANIZATION_OPT);
	
	var DATE_PERIODS_BY_ORG_TYPE = exports.DATE_PERIODS_BY_ORG_TYPE = (_DATE_PERIODS_BY_ORG_ = {}, _defineProperty(_DATE_PERIODS_BY_ORG_, CHRONO, [{ key: 'week', label: 'Week' }, { key: 'month', label: 'Month' }, { key: 'goal-period', label: 'Goal Period' }]), _defineProperty(_DATE_PERIODS_BY_ORG_, PER_CLASS, [{ key: 'week', label: 'Week' }, { key: 'month', label: 'Month' }, { key: 'goal-period', label: 'Goal Period' }, { key: 'custom', label: 'Custom' }]), _defineProperty(_DATE_PERIODS_BY_ORG_, PER_STUDENT, [{ key: 'week', label: 'Week' }, { key: 'month', label: 'Month' }, { key: 'goal-period', label: 'Goal Period' }, { key: 'custom', label: 'Custom' }]), _defineProperty(_DATE_PERIODS_BY_ORG_, PER_TEACHER, [{ key: 'week', label: 'Week' }, { key: 'month', label: 'Month' }, { key: 'goal-period', label: 'Goal Period' }, { key: 'custom', label: 'Custom' }]), _DATE_PERIODS_BY_ORG_);
	
	var SUBJECT_TO_EXPORT_METRICS = exports.SUBJECT_TO_EXPORT_METRICS = (_SUBJECT_TO_EXPORT_ME = {}, _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_GOALS, GOALS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_OTHER_METRICS, ADDITIONAL_METRICS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_BOOKS, BOOKS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_LOG_LIST, READING_LOGS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_LOG_CALENDAR, READING_LOGS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_QUIZZES, QUIZZES), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_WRITING, ADDITIONAL_METRICS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_ANSWERS, PRACTICE_QUESTIONS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_REVIEWS, REVIEWS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_ACTIVITIES, ACTIVITIES), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_ASSIGNED_EXERCISES, ACTIVITIES), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_COMPLETED_EXERCISES, ACTIVITIES), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_QUESTION_BUILDERS, ADDITIONAL_METRICS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_TEACHER_PICKS, ACTIVITIES), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_ANSWERS_SHORT, ADDITIONAL_METRICS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_READING_LEVELS, ADDITIONAL_METRICS), _defineProperty(_SUBJECT_TO_EXPORT_ME, DataRouting.SUBJECT_READING_LEVEL_GRAPH, ADDITIONAL_METRICS), _SUBJECT_TO_EXPORT_ME);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	var OrgTypes = __webpack_require__(45);
	
	var moment = __webpack_require__(15);
	
	function getPath(state) {
		var fullPath = "/orgs";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
			if (state.orgIdentifier) {
				fullPath += "/" + state.orgIdentifier;
			}
		}
	
		var queryParts = [];
	
		if (state.startDate) {
			queryParts.push("start_date=" + state.startDate);
		} else {
			queryParts.push("start_date=" + moment().subtract(30, "days").format("YYYY-MM-DD"));
		}
		if (state.endDate) {
			queryParts.push("end_date=" + state.endDate);
		} else {
			queryParts.push("end_date=" + moment().format("YYYY-MM-DD"));
		}
	
		if (queryParts.length) {
			fullPath += "?" + queryParts.join("&");
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
	
			if (params.org_identifier) {
				state.orgIdentifier = params.org_identifier;
			}
		} else {
			state.activeView = VIEWS.TABLE;
		}
	
		if (params.start_date) {
			state.startDate = params.start_date;
		} else {
			state.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
		}
		if (params.end_date) {
			state.endDate = params.end_date;
		} else {
			state.endDate = moment().format("YYYY-MM-DD");
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/orgs/:active_view?/:org_identifier?";
	
	var VIEWS = exports.VIEWS = {
		TABLE: "table"
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(70);
	var toLength = __webpack_require__(39);
	var toAbsoluteIndex = __webpack_require__(133);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(28);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(61);
	var redefineAll = __webpack_require__(131);
	var meta = __webpack_require__(113);
	var forOf = __webpack_require__(126);
	var anInstance = __webpack_require__(125);
	var isObject = __webpack_require__(32);
	var fails = __webpack_require__(30);
	var $iterDetect = __webpack_require__(210);
	var setToStringTag = __webpack_require__(147);
	var inheritIfRequired = __webpack_require__(270);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(479);
	var redefine = __webpack_require__(61);
	var hide = __webpack_require__(60);
	var fails = __webpack_require__(30);
	var defined = __webpack_require__(85);
	var wks = __webpack_require__(37);
	var regexpExec = __webpack_require__(278);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(75);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(32);
	var cof = __webpack_require__(75);
	var MATCH = __webpack_require__(37)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(37)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(112) || !__webpack_require__(30)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(28)[K];
	});


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(145);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(56);
	var ctx = __webpack_require__(77);
	var forOf = __webpack_require__(126);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(5);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(79);
	var defined = __webpack_require__(85);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var hide = __webpack_require__(60);
	var uid = __webpack_require__(134);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e090e741e5a0172193839ec517879cab.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d7f731d7f2340607eb96a579080af40.png";

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(3577);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(204);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(98);
	
	var _defaultArrowRenderer = __webpack_require__(640);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(641);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(348);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(349);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(638);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(639);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1405);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_progress_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_progress_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./barn-house-empty.png": 300,
		"./beach-bungalow-empty.png": 301,
		"./bell-tower-empty.png": 302,
		"./chefs-palace-empty.png": 303,
		"./clowns-cabin-empty.png": 304,
		"./eagles-nest-empty.png": 305,
		"./festival-yurt-empty.png": 306,
		"./gamers-paradise-empty.png": 307,
		"./gingerbread-house-empty.png": 308,
		"./hawaiian-beach-hut-empty.png": 309,
		"./jam-pad-empty.png": 310,
		"./japanese-restaurant-empty.png": 311,
		"./leaning-t-owl-er-of-pisa-empty.png": 312,
		"./lighthouse-empty.png": 313,
		"./log-cabin-empty.png": 314,
		"./luxury-apartments-empty.png": 315,
		"./medieval-tower-empty.png": 316,
		"./modern-glass-house-empty.png": 317,
		"./modern-mansion-empty.png": 318,
		"./mongolian-house-empty.png": 319,
		"./owl-dobe-desert-casa-empty.png": 320,
		"./owl-ffel-tower-empty.png": 321,
		"./pirate-hideaway-empty.png": 322,
		"./pirate-ship-empty.png": 323,
		"./purple-hot-air-balloon-empty.png": 324,
		"./rainbow-hot-air-balloon-empty.png": 325,
		"./red-hot-air-balloon-empty.png": 326,
		"./rocket-ship-empty.png": 327,
		"./sir-hoots-a-lots-castle-empty.png": 328,
		"./skaters-shack-empty.png": 329,
		"./space-vision-house-empty.png": 330,
		"./sports-clubhouse-empty.png": 331,
		"./tree-house-empty.png": 332,
		"./trophy-room-empty.png": 333,
		"./windmill-empty.png": 334,
		"./winter-chalet-empty.png": 335,
		"./wizards-hut-empty.png": 336
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 224;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	var parsers_1 = __webpack_require__(359);
	var tracekit_1 = __webpack_require__(230);
	/**
	 * Builds and Event from a Exception
	 * @hidden
	 */
	function eventFromException(options, exception, hint) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    utils_1.addExceptionMechanism(event, {
	        handled: true,
	        type: 'generic',
	    });
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(options, message, level, hint) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        // eslint-disable-next-line no-param-reassign
	        exception = errorEvent.error;
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	        // then we just extract the name, code, and message, as they don't provide anything else
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	        var domException = exception;
	        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	        var message = domException.message ? name_1 + ": " + domException.message : name_1;
	        event = eventFromString(message, syntheticException, options);
	        utils_1.addExceptionTypeValue(event, message);
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it is plain Object or Event, serialize it manually and extract options
	        // This will allow us to group events based on top-level keys
	        // which is much better than creating new group when any key/value change
	        var objectException = exception;
	        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, options);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event = {
	        message: input,
	    };
	    if (options.attachStacktrace && syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(696);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(698);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(695);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(697);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(699);
	exports.UserAgent = useragent_1.UserAgent;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function computeStackTrace(ex) {
	    var stack = null;
	    var popSize = 0;
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            popSize = ex.framesToPop;
	        }
	        else if (reactMinifiedRegexp.test(ex.message)) {
	            popSize = 1;
	        }
	    }
	    try {
	        // This must be tried first because Opera 10 *destroys*
	        // its stacktrace property if you try to access the stack
	        // property first!!
	        stack = computeStackTraceFromStacktraceProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        stack = computeStackTraceFromStackProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex && ex.name,
	        stack: [],
	        failed: true,
	    };
	}
	exports.computeStackTrace = computeStackTrace;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	function computeStackTraceFromStackProp(ex) {
	    if (!ex || !ex.stack) {
	        return null;
	    }
	    var stack = [];
	    var lines = ex.stack.split('\n');
	    var isEval;
	    var submatch;
	    var parts;
	    var element;
	    for (var i = 0; i < lines.length; ++i) {
	        if ((parts = chrome.exec(lines[i]))) {
	            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = submatch[1]; // url
	                parts[3] = submatch[2]; // line
	                parts[4] = submatch[3]; // column
	            }
	            element = {
	                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
	                // prefix here seems like the quickest solution for now.
	                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: isNative ? [parts[2]] : [],
	                line: parts[3] ? +parts[3] : null,
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = winjs.exec(lines[i]))) {
	            element = {
	                url: parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: [],
	                line: +parts[3],
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = gecko.exec(lines[i]))) {
	            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || "eval";
	                parts[3] = submatch[1];
	                parts[4] = submatch[2];
	                parts[5] = ''; // no column when eval
	            }
	            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
	                // FireFox uses this awesome columnNumber property for its top frame
	                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                // so adding 1
	                // NOTE: this hack doesn't work if top-most frame is eval
	                stack[0].column = ex.columnNumber + 1;
	            }
	            element = {
	                url: parts[3],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: parts[2] ? parts[2].split(',') : [],
	                line: parts[4] ? +parts[4] : null,
	                column: parts[5] ? +parts[5] : null,
	            };
	        }
	        else {
	            continue;
	        }
	        if (!element.func && element.line) {
	            element.func = UNKNOWN_FUNCTION;
	        }
	        stack.push(element);
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function computeStackTraceFromStacktraceProp(ex) {
	    if (!ex || !ex.stacktrace) {
	        return null;
	    }
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace;
	    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
	    var lines = stacktrace.split('\n');
	    var stack = [];
	    var parts;
	    for (var line = 0; line < lines.length; line += 2) {
	        var element = null;
	        if ((parts = opera10Regex.exec(lines[line]))) {
	            element = {
	                url: parts[2],
	                func: parts[3],
	                args: [],
	                line: +parts[1],
	                column: null,
	            };
	        }
	        else if ((parts = opera11Regex.exec(lines[line]))) {
	            element = {
	                url: parts[6],
	                func: parts[3] || parts[4],
	                args: parts[5] ? parts[5].split(',') : [],
	                line: +parts[1],
	                column: +parts[2],
	            };
	        }
	        if (element) {
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	            stack.push(element);
	        }
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** Remove N number of frames from the stack */
	function popFrames(stacktrace, popSize) {
	    try {
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
	    }
	    catch (e) {
	        return stacktrace;
	    }
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = new utils_1.PromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._api = new core_1.API(this.options.dsn);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (_) {
	        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = types_1.Status.fromHttpCode(response.status);
	        /**
	         * "The name is case-insensitive."
	         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	         */
	        var limited = this._handleRateLimit(headers);
	        if (limited)
	            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
	        if (status === types_1.Status.Success) {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     */
	    BaseTransport.prototype._disabledUntil = function (category) {
	        return this._rateLimits[category] || this._rateLimits.all;
	    };
	    /**
	     * Checks if a category is rate limited
	     */
	    BaseTransport.prototype._isRateLimited = function (category) {
	        return this._disabledUntil(category) > new Date(Date.now());
	    };
	    /**
	     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
	     */
	    BaseTransport.prototype._handleRateLimit = function (headers) {
	        var e_1, _a, e_2, _b;
	        var now = Date.now();
	        var rlHeader = headers['x-sentry-rate-limits'];
	        var raHeader = headers['retry-after'];
	        if (rlHeader) {
	            try {
	                // rate limit headers are of the form
	                //     <header>,<header>,..
	                // where each <header> is of the form
	                //     <retry_after>: <categories>: <scope>: <reason_code>
	                // where
	                //     <retry_after> is a delay in ms
	                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	                //         <category>;<category>;...
	                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
	                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var limit = _d.value;
	                    var parameters = limit.split(':', 2);
	                    var headerDelay = parseInt(parameters[0], 10);
	                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            this._rateLimits[category || 'all'] = new Date(now + delay);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return true;
	        }
	        else if (raHeader) {
	            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
	            return true;
	        }
	        return false;
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var polyfill_1 = __webpack_require__(723);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var misc_1 = __webpack_require__(158);
	// TODO: Implement different loggers for different environments
	var global = misc_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	/** JSDoc */
	var Logger = /** @class */ (function () {
	    /** JSDoc */
	    function Logger() {
	        this._enabled = false;
	    }
	    /** JSDoc */
	    Logger.prototype.disable = function () {
	        this._enabled = false;
	    };
	    /** JSDoc */
	    Logger.prototype.enable = function () {
	        this._enabled = true;
	    };
	    /** JSDoc */
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.log(PREFIX + "[Log]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.error(PREFIX + "[Error]: " + args.join(' '));
	        });
	    };
	    return Logger;
	}());
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	global.__SENTRY__ = global.__SENTRY__ || {};
	var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
	exports.logger = logger;
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(114);
	var object_1 = __webpack_require__(235);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/** Default request keys that'll be used to extract data from the request */
	var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
	/**
	 * Normalizes data from the request object, accounting for framework differences.
	 *
	 * @param req The request object from which to extract data
	 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
	 * provided.
	 * @returns An object containing normalized request data
	 */
	function extractNodeRequestData(req, keys) {
	    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
	    // make sure we can safely use dynamicRequire below
	    if (!isNodeEnv()) {
	        throw new Error("Can't get node request data outside of a node environment");
	    }
	    var requestData = {};
	    // headers:
	    //   node, express: req.headers
	    //   koa: req.header
	    var headers = (req.headers || req.header || {});
	    // method:
	    //   node, express, koa: req.method
	    var method = req.method;
	    // host:
	    //   express: req.hostname in > 4 and req.host in < 4
	    //   koa: req.host
	    //   node: req.headers.host
	    var host = req.hostname || req.host || headers.host || '<no host>';
	    // protocol:
	    //   node: <n/a>
	    //   express, koa: req.protocol
	    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
	        ? 'https'
	        : 'http';
	    // url (including path and query string):
	    //   node, express: req.originalUrl
	    //   koa: req.url
	    var originalUrl = (req.originalUrl || req.url || '');
	    // absolute url
	    var absoluteUrl = protocol + "://" + host + originalUrl;
	    keys.forEach(function (key) {
	        switch (key) {
	            case 'headers':
	                requestData.headers = headers;
	                break;
	            case 'method':
	                requestData.method = method;
	                break;
	            case 'url':
	                requestData.url = absoluteUrl;
	                break;
	            case 'cookies':
	                // cookies:
	                //   node, express, koa: req.headers.cookie
	                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
	                break;
	            case 'query_string':
	                // query string:
	                //   node: req.url (raw)
	                //   express, koa: req.query
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
	                break;
	            case 'data':
	                if (method === 'GET' || method === 'HEAD') {
	                    break;
	                }
	                // body data:
	                //   node, express, koa: req.body
	                if (req.body !== undefined) {
	                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
	                }
	                break;
	            default:
	                if ({}.hasOwnProperty.call(req, key)) {
	                    requestData[key] = req[key];
	                }
	        }
	    });
	    return requestData;
	}
	exports.extractNodeRequestData = extractNodeRequestData;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(621), __webpack_require__(57)(module)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var browser_1 = __webpack_require__(365);
	var is_1 = __webpack_require__(114);
	var memo_1 = __webpack_require__(366);
	var stacktrace_1 = __webpack_require__(236);
	var string_1 = __webpack_require__(237);
	/**
	 * Wrap a given object method with a higher-order function
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name A name of method to be wrapped.
	 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
	 * will be substituted in for `source[name]`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            wrapped.prototype = wrapped.prototype || {};
	            Object.defineProperties(wrapped, {
	                __sentry_original__: {
	                    enumerable: false,
	                    value: original,
	                },
	            });
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function getWalkSource(value) {
	    if (is_1.isError(value)) {
	        var error = value;
	        var err = {
	            message: error.message,
	            name: error.name,
	            stack: error.stack,
	        };
	        for (var i in error) {
	            if (Object.prototype.hasOwnProperty.call(error, i)) {
	                err[i] = error[i];
	            }
	        }
	        return err;
	    }
	    if (is_1.isEvent(value)) {
	        var event_1 = value;
	        var source = {};
	        source.type = event_1.type;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            source.target = is_1.isElement(event_1.target)
	                ? browser_1.htmlTreeAsString(event_1.target)
	                : Object.prototype.toString.call(event_1.target);
	        }
	        catch (_oO) {
	            source.target = '<unknown>';
	        }
	        try {
	            source.currentTarget = is_1.isElement(event_1.currentTarget)
	                ? browser_1.htmlTreeAsString(event_1.currentTarget)
	                : Object.prototype.toString.call(event_1.currentTarget);
	        }
	        catch (_oO) {
	            source.currentTarget = '<unknown>';
	        }
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            source.detail = event_1.detail;
	        }
	        for (var i in event_1) {
	            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
	                source[i] = event_1;
	            }
	        }
	        return source;
	    }
	    return value;
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var serialized = normalize(object, depth);
	    if (jsonSize(serialized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return serialized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
	 * booleans, null, and undefined.
	 *
	 * @param value The value to stringify
	 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
	 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
	 *  unchanged.
	 */
	function serializeValue(value) {
	    var type = Object.prototype.toString.call(value);
	    // Node.js REPL notation
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (type === '[object Object]') {
	        return '[Object]';
	    }
	    if (type === '[object Array]') {
	        return '[Array]';
	    }
	    var normalized = normalizeValue(value);
	    return is_1.isPrimitive(normalized) ? normalized : type;
	}
	/**
	 * normalizeValue()
	 *
	 * Takes unserializable input and make it serializable friendly
	 *
	 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
	 * - serializes Error objects
	 * - filter global objects
	 */
	function normalizeValue(value, key) {
	    if (key === 'domain' && value && typeof value === 'object' && value._events) {
	        return '[Domain]';
	    }
	    if (key === 'domainEmitter') {
	        return '[DomainEmitter]';
	    }
	    if (typeof global !== 'undefined' && value === global) {
	        return '[Global]';
	    }
	    if (typeof window !== 'undefined' && value === window) {
	        return '[Window]';
	    }
	    if (typeof document !== 'undefined' && value === document) {
	        return '[Document]';
	    }
	    // React's SyntheticEvent thingy
	    if (is_1.isSyntheticEvent(value)) {
	        return '[SyntheticEvent]';
	    }
	    if (typeof value === 'number' && value !== value) {
	        return '[NaN]';
	    }
	    if (value === void 0) {
	        return '[undefined]';
	    }
	    if (typeof value === 'function') {
	        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	    }
	    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
	    if (typeof value === 'symbol') {
	        return "[" + String(value) + "]";
	    }
	    if (typeof value === 'bigint') {
	        return "[BigInt: " + String(value) + "]";
	    }
	    return value;
	}
	/**
	 * Walks an object to perform a normalization on it
	 *
	 * @param key of object that's walked in current iteration
	 * @param value object to be walked
	 * @param depth Optional number indicating how deep should walking be performed
	 * @param memo Optional Memo class handling decycling
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function walk(key, value, depth, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (memo === void 0) { memo = new memo_1.Memo(); }
	    // If we reach the maximum depth, serialize whatever has left
	    if (depth === 0) {
	        return serializeValue(value);
	    }
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // If value implements `toJSON` method, call it and return early
	    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
	        return value.toJSON();
	    }
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
	    var normalized = normalizeValue(value, key);
	    if (is_1.isPrimitive(normalized)) {
	        return normalized;
	    }
	    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
	    var source = getWalkSource(value);
	    // Create an accumulator that will act as a parent for all future itterations of that branch
	    var acc = Array.isArray(value) ? [] : {};
	    // If we already walked that branch, bail out, as it's circular reference
	    if (memo.memoize(value)) {
	        return '[Circular ~]';
	    }
	    // Walk all keys of the source
	    for (var innerKey in source) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
	            continue;
	        }
	        // Recursively walk through all the child nodes
	        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
	    }
	    // Once walked through all the branches, remove the parent from memo storage
	    memo.unmemoize(value);
	    // Return accumulated values
	    return acc;
	}
	exports.walk = walk;
	/**
	 * normalize()
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skip non-enumerablers
	 * - Calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
	 * - Translates known global objects/Classes to a string representations
	 * - Takes care of Error objects serialization
	 * - Optionally limit depth of final output
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function normalize(input, depth) {
	    try {
	        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
	    }
	    catch (_oO) {
	        return '**non-serializable**';
	    }
	}
	exports.normalize = normalize;
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(getWalkSource(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var obj = val;
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof obj[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(obj[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(114);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var ll = newLine.length;
	    if (ll <= 150) {
	        return newLine;
	    }
	    if (colno > ll) {
	        // eslint-disable-next-line no-param-reassign
	        colno = ll;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, ll);
	    if (end > ll - 5) {
	        end = ll;
	    }
	    if (end === ll) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < ll) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	var CurrentUser = __webpack_require__(3);
	var Owlvatar = __webpack_require__(115);
	var OwlShopDisplay = __webpack_require__(372);
	var OwlShopColorPicker = __webpack_require__(731);
	var ShopSales = __webpack_require__(123);
	
	__webpack_require__(3622);
	
	var OwlShopPatcher = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
			filteredPerks: OwlShopSelectors.getFilteredPerks({ state: state }),
			allFurnitures: OwlShopSelectors.getFurnitures({ state: state }),
			getPatchesByNameAndType: function getPatchesByNameAndType(_ref) {
				var name = _ref.name,
				    originType = _ref.originType;
				return OwlShopSelectors.getPatchesByNameAndType({ state: state, name: name, originType: originType });
			},
			getPerksByNameAndType: function getPerksByNameAndType(_ref2) {
				var name = _ref2.name,
				    type = _ref2.type;
				return OwlShopSelectors.getPerksByNameAndType({ state: state, name: name, type: type });
			},
			user: CurrentUser.get()
		};
	}, function (dispatch, props) {
		return {
			postPatches: function postPatches(_ref3) {
				var patch = _ref3.patch,
				    newProperties = _ref3.newProperties,
				    callback = _ref3.callback;
				return dispatch(OwlShopActions.postPatches({ patch: patch, newProperties: newProperties, callback: callback }));
			},
			postPerks: function postPerks(_ref4) {
				var perk = _ref4.perk,
				    newProperties = _ref4.newProperties,
				    callback = _ref4.callback;
				return dispatch(OwlShopActions.postPerks({ perk: perk, newProperties: newProperties, callback: callback }));
			},
			//Fetch updated perks for users
			updateCurrentUser: function updateCurrentUser(callback) {
				CurrentUser.fetchCurrentUserData(callback);
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(OwlShopPatcher, _React$Component);
	
		function OwlShopPatcher(props) {
			_classCallCheck(this, OwlShopPatcher);
	
			var _this = _possibleConstructorReturn(this, (OwlShopPatcher.__proto__ || Object.getPrototypeOf(OwlShopPatcher)).call(this));
	
			_this.notifyErrors = function (errors) {
				return window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!",
					text: errors.join(", "),
					icon: "exclamation-sign",
					type: "error"
				});
			};
	
			_this.notifyPatchBought = function (patch) {
				return window.wrNotifications.triggerDropDownNotification({
					title: "Looking good!",
					text: "You bought " + patch.title,
					icon: "ok-sign"
				});
			};
	
			_this.notifyPatchUpgraded = function (patch) {
				return window.wrNotifications.triggerDropDownNotification({
					title: "Looking good!",
					text: "You upgraded " + patch.title,
					icon: "ok-sign"
				});
			};
	
			_this.isPatchUpgrade = function (patch) {
				return !!patch.has_animation;
			};
	
			_this.isPatch = function (item) {
				return !!item.patch_type;
			};
	
			_this.handlePatchPostResponse = function (itemType) {
				return function (response) {
					var patch = response.patch;
	
	
					if (patch.errors) {
						_this.notifyErrors(patch.errors);
						_this.setState({
							buyLoading: false
						});
					} else {
						if (_this.isPatchUpgrade(patch)) {
							_this.notifyPatchUpgraded(patch);
						} else {
							_this.notifyPatchBought(patch);
						}
	
						//if a hand item is purchased, we need to make sure the 
						//corresponding left/right item is owned and visually updates
						//accordingly
						if (patch.origin_patch_type == "hand") {
							_this.props.fetchPatches();
						}
						_this.props.updateCurrentUser(function (f) {
							return f;
						});
	
						_this.setState({ buyLoading: false }, function () {
							return _this.selectItem(patch, itemType);
						});
	
						Mycroft.newEvent({
							category: "Owl Shop",
							action: "buy-item",
							label: patch.title
						});
					}
				};
			};
	
			_this.isOwned = function (item) {
				return !!item.owned;
			};
	
			_this.getPerkNotificationText = function (perk) {
				if (_this.isOwned(perk)) {
					if (perk.perk_type == BACKGROUNDS) {
						return "Your wallpaper has been saved!";
					} else if (perk.perk_type == TITLES) {
						return "Your title has been saved!";
					}
				} else {
					return "You bought " + perk.name;
				}
			};
	
			_this.notifyPerkChange = function (perk) {
				return window.wrNotifications.triggerDropDownNotification({
					title: "Looking good!",
					text: _this.getPerkNotificationText(perk),
					icon: "ok-sign"
				});
			};
	
			_this.handlePerkPostResponse = function (itemType) {
				return function (response) {
					var perk = response.perk;
	
	
					if (perk.errors) {
						_this.notifyErrors(perk.errors);
						_this.setState({
							buyLoading: false
						});
					} else {
						_this.notifyPerkChange(perk);
	
						_this.props.updateCurrentUser(function (f) {
							return f;
						});
	
						_this.setState({ buyLoading: false }, function () {
							return _this.selectItem(perk, itemType);
						});
	
						_this.props.fetchPerks();
	
						Mycroft.newEvent({
							category: "Owl Shop",
							action: "buy-item",
							label: perk.name
						});
					}
				};
			};
	
			_this.getPerkRemovalMessage = function (perk) {
				if (perk.perk_type == BACKGROUNDS) {
					$(".OwlShopPatcher").removeClass("hasBackground");
					$(".patcher").removeClass("backgroundPatcher");
					$wr.removeBackground();
					return {
						text: "Poof! Your wallpaper has disappeared!",
						title: "Wallpaper removed"
					};
				} else if (perk.perk_type == TITLES) {
					return { title: "Title removed", text: "Poof! your title has vanished!" };
				} else if (perk.perk_type == BACKGROUND_SOUNDS) {
					return {
						title: "Background Tune removed",
						text: "Poof! your background tune has vanished!"
					};
				} else if (perk.perk_type == HOUSES) {
					return { title: "House removed", text: "Poof! your house has vanished!" };
				} else if (perk.perk_type == OWL_HOOTS) {
					return {
						title: "Owl hoot removed",
						text: "Poof! your owl's hoot has vanished!"
					};
				} else if (perk.perk_type == GREETINGS) {
					return {
						title: "Greeting animation removed",
						text: "Poof! your greeting animation has vanished!"
					};
				}
			};
	
			_this.notifyPerkRemoval = function (_ref5) {
				var title = _ref5.title,
				    text = _ref5.text;
				return window.wrNotifications.triggerDropDownNotification({
					title: title,
					text: text,
					icon: "ok-sign"
				});
			};
	
			_this.handlePerkRemovePostResponse = function (itemType) {
				return function (response) {
					var perk = response.perk;
	
					if (perk.errors) {
						_this.notifyErrors(perk.errors);
						_this.setState({
							buyLoading: false
						});
					} else {
						var newProperties = { owned: true };
	
						_this.notifyPerkRemoval(_this.getPerkRemovalMessage(perk));
	
						_this.props.setPreviewItem(null, null);
	
						_this.props.updateCurrentUser(function () {
							_this.forceUpdate();
						});
	
						_this.props.fetchPerks();
	
						_this.setState({ buyLoading: false });
					}
				};
			};
	
			autobind(_this);
	
			_this.state = {
				buyLoading: false,
				isOpen: $wr.shouldShopOpen(props.user)
			};
			return _this;
		}
	
		_createClass(OwlShopPatcher, [{
			key: "getPatches",
			value: function getPatches(patchType) {
				if (this.props.mode == "dressing") {
					return _.select(this.props.filteredPatches, function (patch) {
						return patch.patch_type == patchType && patch.owned;
					});
				}
	
				return _.select(this.props.filteredPatches, function (patch) {
					return patch.patch_type == patchType;
				});
			}
		}, {
			key: "getPerks",
			value: function getPerks(perkType) {
				if (this.props.mode === "furniture") {
					return _.select(this.props.allFurnitures, function (perk) {
						return perk.perk_type == perkType;
					});
				} else {
					return _.select(this.props.filteredPerks, function (perk) {
						return perk.perk_type == perkType;
					});
				}
			}
		}, {
			key: "selectColor",
			value: function selectColor(colorIndex, patchType) {
				var newColors = _.clone(this.props.colors);
				newColors[patchType] = colorIndex;
				this.props.setColors(newColors);
	
				// Mycroft.newEvent({ category: "Owl Shop", action: "select-color", label: ("color" + colorIndex) });
			}
		}, {
			key: "selectItem",
			value: function selectItem(item, equipType) {
				if (item.patch_type) {
					if (item.owned) {
						var newEquippedPatches = _.clone(this.props.equippedPatches);
						newEquippedPatches[equipType] = item;
						this.props.setEquippedPatches(newEquippedPatches);
					}
				} else if (item.perk_type == "backgrounds") {
					$(".patcher").addClass("backgroundPatcher");
					$wr.displayBackground(item.name);
				}
				this.props.setPreviewItem(item.name, equipType);
			}
		}, {
			key: "removeItem",
			value: function removeItem(item, equipPatchType) {
				if (!item || !equipPatchType) {
					return;
				}
				if (item.patch_type) {
					if (item.owned) {
						var newEquippedPatches = _.clone(this.props.equippedPatches);
	
						var isRequiredPatchType = _.include(REQUIRED_PATCH_TYPES, equipPatchType);
						if (isRequiredPatchType) {
							newEquippedPatches[equipPatchType] = _.find(this.getPatches(equipPatchType), function (patch) {
								return patch.source == "default";
							});
						} else {
							newEquippedPatches[equipPatchType] = Owlvatar.NO_PATCH;
						}
						var text = "Magic! You removed an accessory from your owl!";
						window.wrNotifications.triggerDropDownNotification({
							title: "Patch removed",
							text: text,
							icon: "ok-sign"
						});
						this.props.setEquippedPatches(newEquippedPatches);
					}
					this.props.setPreviewItem(null, null);
				} else {
					this.props.postPerks({
						perk: _extends({}, item),
						newProperties: { equipped: false },
						callback: this.handlePerkRemovePostResponse(equipPatchType)
					});
				}
			}
		}, {
			key: "getPreviewItem",
			value: function getPreviewItem() {
				if (this.props.activePatchType) {
					return _.find(this.props.filteredPatches, function (patch) {
						return patch.name == this.props.previewItemName && patch.patch_type == this.props.activePatchType;
					}.bind(this));
				} else {
					return _.find(this.props.filteredPerks, function (perk) {
						return perk.name == this.props.previewItemName && perk.perk_type == this.props.activeOtherType;
					}.bind(this));
				}
			}
		}, {
			key: "purchaseItem",
			value: function purchaseItem(item, equipPatchType) {
				this.setState({ buyLoading: true });
	
				if (this.isPatch(item)) {
					this.props.postPatches({
						patch: item,
						newProperties: null,
						callback: this.handlePatchPostResponse(equipPatchType)
					});
				} else {
					this.props.postPerks({
						perk: item,
						newProperties: null,
						callback: this.handlePerkPostResponse(equipPatchType)
					});
				}
			}
		}, {
			key: "previewAnimation",
			value: function previewAnimation(name) {
				this.props.previewAnimation(name);
			}
		}, {
			key: "buildItemTypeSelectF",
			value: function buildItemTypeSelectF(patchType, otherType) {
				return function (e) {
					if (e) {
						e.preventDefault();
					}
					this.props.setActiveType(patchType, otherType);
					this.props.setPreviewItem(null, null);
					Mycroft.newEvent({
						category: "Owl Shop",
						action: "select-category",
						label: patchType || otherType
					});
				}.bind(this);
			}
	
			// to keep category selector highlighted correctly in hand and body special cases
	
		}, {
			key: "isActivePatchType",
			value: function isActivePatchType(patchType) {
				var activePatchType = this.props.activePatchType;
				if (activePatchType == "left_hand" || activePatchType == "hand" || activePatchType == "wings") {
					return patchType == "left_hand";
				} else if (activePatchType == "body" || activePatchType == "body2") {
					return patchType == "body";
				} else {
					return patchType == activePatchType;
				}
			}
		}, {
			key: "renderCategorySelector",
			value: function renderCategorySelector(text, patchType, otherType) {
				if (patchType) {
					var onClick = this.buildItemTypeSelectF(patchType, null);
				} else {
					var onClick = this.buildItemTypeSelectF(null, otherType);
				}
				if (this.props.activePatchType && this.isActivePatchType(patchType)) {
					var categoryClass = "selector selectedPatchType";
				} else {
					if (this.props.activeOtherType && this.props.activeOtherType == otherType) {
						var categoryClass = "selector selectedPatchType";
					} else {
						var categoryClass = "selector";
					}
				}
	
				return React.createElement(
					"a",
					{ href: "#", className: categoryClass, onClick: onClick },
					React.createElement("img", { src: dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png") }),
					React.createElement(
						"span",
						{ className: "categoryTitle" },
						text
					)
				);
			}
		}, {
			key: "renderOwlShopModeSelectors",
			value: function renderOwlShopModeSelectors() {
				if (!this.props.hideOwls) {
					var owlCustomizers = React.createElement(
						"div",
						null,
						this.renderCategorySelector("Head", "head", null),
						this.renderCategorySelector("Face", "face", null),
						this.renderCategorySelector("Eyes", "eyes", null),
						this.renderCategorySelector("Beak", "beak", null),
						this.renderCategorySelector("Body", "body", null),
						this.renderCategorySelector("Wings", "left_hand", null),
						this.renderCategorySelector("Feet", "feet", null)
					);
					var hoots = this.renderCategorySelector("Hoots", null, "owl_hoots");
					var greetings = this.renderCategorySelector("Greetings", null, "greetings");
				}
				return React.createElement(
					"div",
					{ className: "categorySection" },
					React.createElement(
						"div",
						{ className: "modeSelectorRowContainer" },
						React.createElement(
							"span",
							{ className: "sectionTitle" },
							" Change Your Look "
						),
						owlCustomizers
					),
					React.createElement(
						"div",
						{ className: "modeSelectorRowContainer" },
						React.createElement(
							"span",
							{ className: "sectionTitle" },
							" Get Yourself A Perk "
						),
						React.createElement(
							"div",
							null,
							this.renderCategorySelector("Titles", null, "titles"),
							this.renderCategorySelector("Wallpapers", null, "backgrounds"),
							greetings,
							hoots,
							this.renderCategorySelector("Tunes", null, "background_sounds"),
							this.renderCategorySelector("Houses", null, "houses")
						)
					)
				);
			}
		}, {
			key: "renderDressingModeSelectors",
			value: function renderDressingModeSelectors() {
				if (!this.props.hideOwls) {
					var owlCustomizers = React.createElement(
						"div",
						null,
						this.renderCategorySelector("Head", "head", null),
						this.renderCategorySelector("Face", "face", null),
						this.renderCategorySelector("Eyes", "eyes", null),
						this.renderCategorySelector("Beak", "beak", null),
						this.renderCategorySelector("Body", "body", null),
						this.renderCategorySelector("Wings", "left_hand", null),
						this.renderCategorySelector("Feet", "feet", null)
					);
				}
				return React.createElement(
					"div",
					{ className: "categorySection" },
					React.createElement(
						"div",
						{ className: "modeSelectorRowContainer dressingSelectors" },
						React.createElement(
							"span",
							{ className: "sectionTitle" },
							" Owned Items! "
						),
						owlCustomizers
					)
				);
			}
		}, {
			key: "renderFurnitureModeSelectors",
			value: function renderFurnitureModeSelectors() {
				return React.createElement(
					"div",
					{ className: "categorySection" },
					React.createElement(
						"div",
						null,
						this.renderCategorySelector("Wall Items", null, "wall_items"),
						this.renderCategorySelector("Bookshelves", null, "bookshelves"),
						this.renderCategorySelector("Sofas", null, "sofas"),
						this.renderCategorySelector("Floor Items", null, "floor_items")
					)
				);
			}
		}, {
			key: "renderAllCategorySelectors",
			value: function renderAllCategorySelectors() {
				if (this.props.mode == "furniture") {
					var selectors = this.renderFurnitureModeSelectors();
				} else if (this.props.mode == "dressing") {
					var selectors = this.renderDressingModeSelectors();
				} else {
					var selectors = this.renderOwlShopModeSelectors();
				}
				return React.createElement(
					"div",
					{ className: "categorySelector clearfix" },
					selectors
				);
			}
		}, {
			key: "renderDisplay",
			value: function renderDisplay() {
				var type = this.props.activePatchType || this.props.activeOtherType;
				if (this.props.activeOtherType) {
					var items = this.getPerks(this.props.activeOtherType);
				} else {
					var items = this.getPatches(this.props.activePatchType);
				}
	
				var items = _.sortBy(items, function (item) {
					if (item.patch_type) {
						var onSale = ShopSales.isOnSale(item.origin_patch_type, item.name) ? "0sale" : "1sale";
					} else {
						onSale = "1sale";
					}
					var tier = item.tier || 0;
					var price = item.price || 0;
					return onSale + " " + tier + " " + price;
				});
	
				var beginAtTier = this.props.beginAtTier;
	
				var display = React.createElement(OwlShopDisplay, {
					mode: this.props.mode,
					key: type,
					user: this.props.user,
					itemType: type,
					items: items,
					previewItem: this.getPreviewItem(),
					loading: this.state.buyLoading,
					buildItemTypeSelectF: this.buildItemTypeSelectF,
					selectItem: this.selectItem,
					purchaseItem: this.purchaseItem,
					previewAnimation: this.previewAnimation,
					removeItem: this.removeItem,
					isPatch: !this.props.activeOtherType,
					beginAtTier: beginAtTier
				});
				return display;
			}
		}, {
			key: "renderColorPickers",
			value: function renderColorPickers() {
				var pickers = [];
	
				switch (this.props.activePatchType) {
					case "hand":
					case "left_hand":
					case "wings":
						pickers.push(React.createElement(OwlShopColorPicker, {
							key: "wings",
							currentColor: this.props.colors["wings"],
							patchType: "wings",
							selectColor: this.selectColor
						}));
						break;
					case "body":
					case "body2":
						pickers.push(React.createElement(OwlShopColorPicker, {
							key: "base",
							currentColor: this.props.colors["base"],
							patchType: "base",
							selectColor: this.selectColor
						}));
	
						pickers.push(React.createElement(OwlShopColorPicker, {
							key: "stomach",
							currentColor: this.props.colors["stomach"],
							patchType: "stomach",
							selectColor: this.selectColor
						}));
						break;
					case "face":
						pickers.push(React.createElement(OwlShopColorPicker, {
							key: "eyes",
							currentColor: this.props.colors["eyes"],
							patchType: "eyes",
							selectColor: this.selectColor
						}));
						break;
				}
	
				return React.createElement(
					"div",
					{ className: "colorPickers" },
					pickers
				);
			}
		}, {
			key: "renderShopCurtain",
			value: function renderShopCurtain() {
				var openingTime = $wr.getShopOpeningTime(this.props.user);
				var src = __webpack_require__(150);
				var patchImg = React.createElement("img", { src: src, className: "lockImg" });
				if (openingTime != "Never") {
					var openingDetails = "It will open today at " + openingTime;
				}
				return React.createElement(
					"div",
					{ className: "curtain" },
					React.createElement(
						"div",
						null,
						patchImg
					),
					React.createElement(
						"p",
						null,
						"Your teacher has closed the Owl Shop. ",
						React.createElement("br", null),
						openingDetails
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var shopClass = "";
				if (!this.state.isOpen) {
					shopClass = "closedShop";
					var curtain = this.renderShopCurtain();
				}
	
				if (this.props.mode != "dressing") {
					var colorPickers = this.renderColorPickers();
				} else {
					var displayClass = "dressingDisplay";
				}
	
				return React.createElement(
					"div",
					{ className: "OwlShopPatcher" },
					curtain,
					React.createElement(
						"div",
						{ className: shopClass },
						this.renderAllCategorySelectors(),
						React.createElement(
							"div",
							{ className: displayClass },
							this.renderDisplay()
						),
						colorPickers
					)
				);
			}
		}, {
			key: "onScroll",
			value: function onScroll() {
				var $preview = $(this.refs.preview);
	
				$preview.removeClass("fixed");
				$preview.removeClass("absolute");
				$preview.css("top", "55px");
				var scrollTop = $(window).scrollTop();
				var previewOffset = $preview.offset().top;
				var minDistance = 40;
	
				var footerOffset = $(".siteFooter").offset().top;
				var previewHeight = $preview.height() + 50;
				var docHeight = $(document).height();
				var winHeight = $(window).height();
	
				if (scrollTop + previewHeight > footerOffset) {
					var top = footerOffset - previewHeight - 110;
					$preview.addClass("absolute");
					$preview.css("top", top + "px");
				} else if (previewOffset - minDistance < scrollTop) {
					$preview.addClass("fixed");
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.onScroll);
				// prevent background from being removed when closing house modal
				if (this.props.mode == "owl_shop") {
					$wr.removeBackground();
				}
			}
		}]);
	
		return OwlShopPatcher;
	}(React.Component)) || _class);
	
	// OwlShopPatcher.propTypes = PageStrictPropTypes({
	// });
	
	
	//OwlShopPatcher.REQUIRED_PATCH_TYPES = ["feet", "eyes", "wings", "beak"];
	
	var REQUIRED_PATCH_TYPES = ["feet", "eyes", "wings", "beak"];
	var BACKGROUNDS = "backgrounds";
	var TITLES = "titles";
	var HOUSES = "houses";
	var GREETINGS = "greetings";
	var OWL_HOOTS = "owl_hoots";
	var BACKGROUND_SOUNDS = "background_sounds";
	
	module.exports = OwlShopPatcher;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentAvatar = __webpack_require__(35);
	var AdminAvatar = __webpack_require__(370);
	var SponsorAvatar = __webpack_require__(733);
	
	var UserAvatar = function (_React$Component) {
		_inherits(UserAvatar, _React$Component);
	
		function UserAvatar(props) {
			_classCallCheck(this, UserAvatar);
	
			var _this = _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(UserAvatar, [{
			key: "render",
			value: function render() {
				if (this.props.user.is_student || this.props.user.is_admin && this.props.user.avatar) {
					return React.createElement(StudentAvatar, { student: this.props.user, maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight });
				} else if (this.props.user.is_admin) {
					return React.createElement(AdminAvatar, { admin: this.props.user, maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight });
				} else if (this.props.user.is_sponsor) {
					return React.createElement(SponsorAvatar, { sponsor: this.props.user, maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight });
				} else if (this.props.user.is_wizard) {
					return React.createElement(StudentAvatar, { student: this.props.user, maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight });
				}
			}
		}]);
	
		return UserAvatar;
	}(React.Component);
	
	;
	
	UserAvatar.propTypes = StrictPropTypes({
		user: PropTypes.object.isRequired,
	
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number
	});
	
	module.exports = UserAvatar;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MonthLogTable = __webpack_require__(845);
	__webpack_require__(651);
	
	var AllMonthsLogTable = function (_React$Component) {
		_inherits(AllMonthsLogTable, _React$Component);
	
		function AllMonthsLogTable(props) {
			_classCallCheck(this, AllMonthsLogTable);
	
			var _this = _possibleConstructorReturn(this, (AllMonthsLogTable.__proto__ || Object.getPrototypeOf(AllMonthsLogTable)).call(this));
	
			autobind(_this);
			_this.state = { expanded: false };
			return _this;
		}
	
		_createClass(AllMonthsLogTable, [{
			key: 'expandFromSoftMax',
			value: function expandFromSoftMax() {
				this.setState({ expanded: true });
			}
		}, {
			key: 'getFirstDay',
			value: function getFirstDay(date) {
				var parts = date.split("-");
				return parts[0] + "-" + parts[1] + "-01";
				//returns year-month-01
			}
		}, {
			key: 'render',
			value: function render() {
				var logs = this.props.logs;
	
				if (this.props.softMax && this.props.softMax < logs.length && !this.state.expanded) {
					logs = _.first(logs, this.props.softMax);
					var appliedSoftMax = true;
				} else {
					var appliedSoftMax = false;
				}
	
				var monthsMap = _.map(logs, function (log) {
					var month = this.getFirstDay(log.log_date);
					//y-m-01
					return month;
				}.bind(this));
				//this returns a list of all the logs but months repeat, example: 2017-05-01, 2017-05-01
	
				var uniqueMonths = _.uniq(monthsMap);
				//here we eliminate duplicates, example only one 2017-05-01, 2017-04-01...etc
	
				var tableMonths = _.map(uniqueMonths, function (month) {
					//then we map through those
	
					var filteredLogs = _.filter(this.props.logs, function (log) {
						var firstLogDay = this.getFirstDay(log.log_date);
						//_.filter returns boolean..so it will either give me a true or false
						return firstLogDay == month;
						//here I'm asking it to return when it's true that firstLogDay actually equals month
					}.bind(this));
	
					return React.createElement(MonthLogTable, { key: month, month: month,
						logs: filteredLogs, initExpanded: this.props.initExpanded, hideCommentBox: this.props.hideCommentBox,
						showFullData: this.props.showFullData,
						condensedLayout: this.props.condensedLayout });
				}.bind(this));
	
				if (appliedSoftMax) {
					var truncatedMessage = React.createElement(
						'div',
						{ className: 'truncatedPlaceholder' },
						React.createElement(
							'button',
							{ className: 'btn btn-link', onClick: this.expandFromSoftMax },
							'Show ',
							this.props.logs.length - logs.length,
							' More'
						)
					);
				}
	
				var className = "allMonthsLogTable";
				if (this.props.embedded) {
					className += " embedded";
				} else {
					className += " standalone";
				}
	
				return React.createElement(
					'div',
					{ className: className },
					tableMonths,
					truncatedMessage
				);
			}
		}]);
	
		return AllMonthsLogTable;
	}(React.Component);
	
	;
	
	AllMonthsLogTable.propTypes = StrictPropTypes({
		logs: PropTypes.array.isRequired,
		embedded: PropTypes.bool,
		initExpanded: PropTypes.bool,
		hideCommentBox: PropTypes.bool,
		condensedLayout: PropTypes.bool,
		showFullData: PropTypes.bool,
		softMax: PropTypes.number
	});
	
	module.exports = AllMonthsLogTable;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3727);
	var moment = __webpack_require__(15);
	
	var LogCalendar = function (_React$Component) {
		_inherits(LogCalendar, _React$Component);
	
		function LogCalendar(props) {
			_classCallCheck(this, LogCalendar);
	
			var _this = _possibleConstructorReturn(this, (LogCalendar.__proto__ || Object.getPrototypeOf(LogCalendar)).call(this));
	
			autobind(_this);
	
			_this.state = {
				day: moment().date(), month: moment().month(),
				year: moment().year(), monthCount: 0
			};
			return _this;
		}
	
		_createClass(LogCalendar, [{
			key: 'prevMonth',
			value: function prevMonth() {
				var monthCount = this.state.monthCount - 1;
				var prevDate = moment().add(monthCount, 'months');
				var prevMonth = prevDate.month();
				var year = prevDate.year();
				this.setState({ month: prevMonth, year: year, monthCount: monthCount });
			}
		}, {
			key: 'nextMonth',
			value: function nextMonth() {
				var monthCount = this.state.monthCount + 1;
				var nextDate = moment().add(monthCount, 'months');
				var nextMonth = nextDate.month();
				var year = nextDate.year();
				this.setState({ month: nextMonth, year: year, monthCount: monthCount });
			}
		}, {
			key: 'setStateToToday',
			value: function setStateToToday() {
				this.setState({ day: moment().date(), month: moment().month(),
					year: moment().year(), monthCount: 0
				});
			}
		}, {
			key: 'getDayData',
			value: function getDayData() {
				// [{ date: "2017-04-27", item: "10 minutes" }, { date: "2017-04-05", item: "20 minutes" }, { date: "2017-04-03", item: "1 question" },  { date: "2017-04-05", item: "1 question" }]
				var byDate = _.groupBy(this.props.logs, "log_date");
				// this.props.dataArray
				return _.flatten(_.map(byDate, function (logs, date) {
					var minutes = _.reduce(logs, function (memo, log) {
						return memo + log.minutes;
					}, 0);
	
					var minutesLine = minutes + " " + $wr.pluralize("minute", minutes);
	
					return { date: date, item: minutesLine };
				}));
			}
		}, {
			key: 'render',
			value: function render() {
				var currentDateInState = new Date(this.state.year, this.state.month, this.state.day);
				var currentMonth = currentDateInState.getMonth();
				var currentYear = currentDateInState.getFullYear();
	
				var currentMonthStartDate = new Date(currentYear, currentMonth, 1);
				var currentMonthEndDate = new Date(currentYear, currentMonth + 1, 0);
	
				// offset tells us on which day the first of the month falls
				var offset = -currentMonthStartDate.getDay();
				var daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
				//weekOffSet combines the offset and days in the month to calculate how many days in total a month took up on the calendar
				var weekOffSet = Math.abs(offset) + daysInCurrentMonth;
				//by dividing weekoffset by 7 we can see how many weeks a month took up on the calendar
				var currentNumWeeks = Math.ceil(weekOffSet / 7);
	
				var weeks = [];
				var names = [];
				for (var i = 0; i < 7; i++) {
					names.push(React.createElement(
						'td',
						{ className: 'dayNames', key: i },
						LogCalendar.DAY_NAMES[i]
					));
				}
				//pushing names of days into weeks array
				weeks.push(React.createElement(
					'tr',
					{ key: 'header' },
					names
				));
	
				var dataData = this.getDayData();
	
				for (var y = 0; y < currentNumWeeks; y++) {
					var days = [];
					var result = [];
	
					for (var i = 0; i < 7; i++) {
						result = [];
						var dayCount = i + 1 + y * 7 + offset;
						if (dayCount < 1 || dayCount > currentMonthEndDate.getDate()) {
							dayCount = "";
						} else {
							var newDate = moment([this.state.year, this.state.month, dayCount]).format("YYYY-MM-DD");
							var filterDate = _.filter(dataData, function (num, index) {
								if (num.date == newDate) {
									result.push(React.createElement(
										'p',
										{ key: index, className: 'data-result' },
										num.item
									));
								}
							});
						}
						// highlight if this cell is today's date
						if (dayCount == moment().date() && currentMonth == moment().month() && currentYear == moment().year()) {
							var cellClass = "dayBlank todayHighLight";
						} else {
							var cellClass = "dayBlank";
						}
						days.push(React.createElement(
							'td',
							{ className: cellClass, key: i },
							React.createElement(
								'p',
								{ className: 'dateNumber' },
								dayCount
							),
							React.createElement(
								'div',
								{ className: 'data-result-all' },
								result
							)
						));
					}
					// pushing the day numbers into weeks array
					weeks.push(React.createElement(
						'tr',
						{ key: y },
						days
					));
				}
	
				return React.createElement(
					'div',
					{ className: 'logCalendar' },
					React.createElement(
						'div',
						null,
						React.createElement(
							'p',
							{ className: 'currentMonth' },
							LogCalendar.MONTH_NAMES[currentMonth],
							' ',
							" ",
							'  ',
							currentYear
						),
						React.createElement(
							'div',
							{ className: 'btngroup' },
							React.createElement(
								'button',
								{ onClick: this.prevMonth, type: 'button' },
								React.createElement('span', { className: 'glyphicon glyphicon-chevron-left' })
							),
							React.createElement(
								'button',
								{ onClick: this.setStateToToday, className: 'button' },
								'Today'
							),
							React.createElement(
								'button',
								{ onClick: this.nextMonth, type: 'button' },
								React.createElement('span', { className: 'glyphicon glyphicon-chevron-right' })
							)
						)
					),
					React.createElement(
						'table',
						null,
						React.createElement(
							'tbody',
							null,
							weeks
						)
					)
				);
			}
		}]);
	
		return LogCalendar;
	}(React.Component);
	
	LogCalendar.propTypes = StrictPropTypes({
		logs: PropTypes.array.isRequired
	});
	
	LogCalendar.DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	LogCalendar.MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	module.exports = LogCalendar;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ReadingSelectors = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextTypes = __webpack_require__(38);
	var CurrentUser = __webpack_require__(3);
	
	var Modal = __webpack_require__(18);
	var AddManualURLPick = __webpack_require__(848);
	var AddLibraryURLPick = __webpack_require__(847);
	
	var AddTitlePick = __webpack_require__(849);
	var Glyphicon = __webpack_require__(8);
	var NewTaskCircle = __webpack_require__(941);
	var BookDisplay = __webpack_require__(46);
	var Spinner = __webpack_require__(9);
	
	var ParticipatingStudentsDisplay = __webpack_require__(397);
	var AssignTaskModal = __webpack_require__(199);
	var AssignTaskItemsModal = __webpack_require__(994);
	
	var AccountPlans = __webpack_require__(53);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterActions = __webpack_require__(11);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ActionUtility = __webpack_require__(95);
	
	__webpack_require__(3732);
	
	var PicksPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var tasks = WritingSelectors.teacherPicksTasks({ state: state });
	
		var userIDsByTextID = WritingSelectors.userIDsByTaskSubjectID({
			state: state, conditions: { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } }
		});
	
		return {
			tasks: tasks,
			userIDsByTextID: userIDsByTextID,
			booksByURL: ReadingSelectors.assignedURLBooks({ state: state }),
			booksByTitle: ReadingSelectors.assignedTitleBooks({ state: state })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				var fetchPlatforms = function fetchPlatforms() {
					return dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
				};
				var fetchTasks = function fetchTasks() {
					// TODO: standardize FE requests
					var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } };
					var embeds = ['task.completion', 'task.task_item_ids'];
					if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
						var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } };
						var actionFunction = WritingActions.fetchTasks;
						return new Promise(function (resolve, reject) {
							$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds: embeds }, function (results) {
								resolve(results);
							});
						}).catch(function () {
							return console.log("Tasks failed to load");
						});
					} else {
						return dispatch(WritingActions.fetchTasks({ conditions: conditions, embeds: embeds })).then(function (response) {
							if (response) {
								var textIDs = _underscore2.default.uniq(_underscore2.default.pluck(_underscore2.default.values(response.tasks), "subject_id"));
							}
	
							if (textIDs && textIDs.length) {
								return dispatch(ReadingActions.fetchBooks({
									ids: textIDs,
									cache: true,
									query: { library_content: true }
								}));
							} else {
								return Promise.resolve();
							}
						});
					}
				};
	
				return Promise.all([fetchPlatforms(), fetchTasks()]);
			},
	
			fetchBooks: function fetchBooks(textIDs) {
				if (textIDs.length) {
					return Promise.all([dispatch(ReadingActions.fetchBooks({ ids: textIDs, query: { library_content: true } }))]);
				} else {
					return Promise.resolve();
				}
			},
	
			clearTextTasks: function clearTextTasks(textID) {
				return dispatch(WritingActions.deleteManyTasks({
					filters: { subject_id: textID },
					conditions: {
						oneOfMatch: { subject_type: ["URLPick", "TitlePick"] }
					}
				}));
			},
			// used to refresh task items after assignment
			fetchTasks: function fetchTasks() {
				dispatch(ActionUtility.clearLoadingRecords("tasks"));
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick"] } };
					var actionFunction = WritingActions.fetchTasks;
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, userIDs, conditions, actionFunction, {}, function (results) {
							resolve(results);
						});
					}).catch(function () {
						return console.log("Tasks failed to load");
					});
				} else {
					return dispatch(WritingActions.fetchTasks({
						conditions: {
							oneOfMatch: { subject_type: ["URLPick", "TitlePick"] }
						}
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(PicksPage, _React$Component);
	
		function PicksPage(props) {
			_classCallCheck(this, PicksPage);
	
			var _this = _possibleConstructorReturn(this, (PicksPage.__proto__ || Object.getPrototypeOf(PicksPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("PicksPage");
	
			_this.urlLibraryPickModal = React.createRef();
			_this.titlePickModal = React.createRef();
			_this.urlManualPickModal = React.createRef();
			_this.assignTaskModal = React.createRef();
			_this.assignTaskItemsModal = React.createRef();
	
			_this.state = {
				textToAssign: null,
				selectedUserIDs: [],
				taskItemsEntered: false,
				loading: false
			};
			return _this;
		}
		// paywall helper method
	
	
		_createClass(PicksPage, [{
			key: "allowAccess",
			value: function allowAccess() {
				var user = CurrentUser.get();
				var activeTrials = user.account.active_trials;
				var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false;
				return user.product === "wrSilver" || user.product === "wrGold" || hasQualifiedTrial ? true : false;
			}
		}, {
			key: "unssign",
			value: function unssign(textID) {
				if (confirm("Are you sure you want to delete this?")) {
					this.props.clearTextTasks(textID);
				}
			}
		}, {
			key: "toggleAssign",
			value: function toggleAssign(text, edit) {
				var _this2 = this;
	
				// Book may not yet be in redux (or have library content)
				this.props.fetchBooks([text.text_id]);
	
				this.setState({ textToAssign: text }, function () {
					_this2.titlePickModal.current.hide();
					_this2.assignTaskModal.current.show();
				});
			}
		}, {
			key: "isFinishedStudent",
			value: function isFinishedStudent(studentID) {
				var task = this.findTask(studentID);
				return task.completion;
			}
		}, {
			key: "calculateFinishedStudents",
			value: function calculateFinishedStudents(tasks, bookId) {
				return _underscore2.default.size(_underscore2.default.where(tasks, { completion: true }));
			}
		}, {
			key: "renderTitlePickModal",
			value: function renderTitlePickModal() {
				return React.createElement(
					Modal,
					{ headerText: "Add Title", ref: this.titlePickModal },
					React.createElement(AddTitlePick, { toggleAssign: this.toggleAssign })
				);
			}
		}, {
			key: "renderLibraryURLPickModal",
			value: function renderLibraryURLPickModal() {
				return React.createElement(
					Modal,
					{ headerText: "Discover", className: "wideModal",
						ref: this.urlLibraryPickModal },
					React.createElement(AddLibraryURLPick, { toggleAssign: this.toggleAssign })
				);
			}
		}, {
			key: "renderManualURLPickModal",
			value: function renderManualURLPickModal() {
				return React.createElement(
					Modal,
					{ headerText: "Add URL", ref: this.urlManualPickModal },
					React.createElement(AddManualURLPick, { toggleAssign: this.toggleAssign })
				);
			}
		}, {
			key: "renderAssignedByTitle",
			value: function renderAssignedByTitle() {
				var _this3 = this;
	
				return _underscore2.default.sortBy(this.props.booksByTitle, "title").map(function (book) {
					var studentIDs = _this3.props.userIDsByTextID[book.text_id];
					var finishedCount = _this3.allowAccess() ? 'No activities assigned' : '';
					var tasks = _underscore2.default.where(_this3.props.tasks, { subject_id: book.text_id, subject_type: 'TitlePick' });
					if (tasks.length && _underscore2.default.size(_underscore2.default.first(tasks).task_item_ids)) {
						finishedCount = _this3.calculateFinishedStudents(tasks, book.text_id) + " out of " + studentIDs.length + " have completed all activities";
					}
	
					return React.createElement(
						"div",
						{ className: "assignedText", key: book.text_id },
						React.createElement(
							BookDisplay,
							{ textID: book.text_id, coverWidth: 75,
								showAuthor: true, showCover: true, showLibraryTags: true },
							React.createElement(ParticipatingStudentsDisplay, { studentIDs: studentIDs,
								maxDisplayStudentCount: 3 }),
							React.createElement(
								"a",
								{ href: "#", className: "editTaskAssignment",
									onClick: function onClick(e) {
										$wr.nope(e);_this3.toggleAssign(book);
									} },
								"Edit"
							),
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "statSummary" },
								finishedCount
							)
						),
						React.createElement(
							"a",
							{ href: "#", className: "removeLink",
								onClick: function onClick(e) {
									$wr.nope(e);_this3.unssign(book.text_id);
								} },
							React.createElement(Glyphicon, { icon: "remove" })
						)
					);
				});
			}
		}, {
			key: "renderAssignedByURL",
			value: function renderAssignedByURL() {
				var _this4 = this;
	
				if (this.state.loading) {
					return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
					return _underscore2.default.sortBy(this.props.booksByURL, "title").map(function (book) {
						var studentIDs = _this4.props.userIDsByTextID[book.text_id];
						var finishedCount = _this4.allowAccess() ? 'No assignments' : '';
						var tasks = _underscore2.default.where(_this4.props.tasks, { subject_id: book.text_id, subject_type: 'URLPick' });
						if (tasks.length && _underscore2.default.size(_underscore2.default.first(tasks).task_item_ids)) {
							finishedCount = _this4.calculateFinishedStudents(tasks, book.text_id) + " out of " + studentIDs.length + " have completed all activities";
						}
	
						return React.createElement(
							"div",
							{ className: "assignedText", key: book.text_id },
							React.createElement(
								BookDisplay,
								{ textID: book.text_id, linkURL: true, showLibraryTags: true,
									showCover: true, coverWidth: 100 },
								React.createElement(ParticipatingStudentsDisplay, { studentIDs: studentIDs,
									maxDisplayStudentCount: 3 }),
								React.createElement(
									"a",
									{ href: "#", className: "editTaskAssignment",
										onClick: function onClick(e) {
											$wr.nope(e);_this4.toggleAssign(book);
										} },
									"Edit"
								),
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "statSummary" },
									finishedCount
								)
							),
							React.createElement(
								"a",
								{ href: "#", className: "removeLink",
									onClick: function onClick(e) {
										$wr.nope(e);_this4.unssign(book.text_id);
									} },
								React.createElement(Glyphicon, { icon: "remove" })
							)
						);
					});
				}
			}
		}, {
			key: "renderAssignTaskModal",
			value: function renderAssignTaskModal() {
				if (!this.state.textToAssign) {
					return;
				}
	
				if (this.state.textToAssign.url) {
					var modalHeader = "Assign URL to:";
					var subjectType = "URLPick";
				} else {
					var modalHeader = "Assign Title to:";
					var subjectType = "TitlePick";
				}
	
				var renderAdditionalModal = this.allowAccess() ? true : false;
	
				return React.createElement(
					Modal,
					{ ref: this.assignTaskModal, headerText: modalHeader,
						modalOrder: 2 },
					React.createElement(AssignTaskModal, {
						textToAssign: this.state.textToAssign,
						renderAdditionalModal: renderAdditionalModal,
						taskSubjectType: subjectType,
						taskSubjectID: this.state.textToAssign.text_id,
						selectedActivityTitle: this.state.textToAssign.title,
						onAssign: this.hideAssignModal })
				);
			}
		}, {
			key: "hideAssignModal",
			value: function hideAssignModal(selectedUserIDs, showNextModal) {
				this.setState({ selectedUserIDs: selectedUserIDs });
				this.assignTaskModal.current.hide();
				if (showNextModal) {
					this.setState({ taskItemsEntered: false });
					this.assignTaskItemsModal.current.show();
				}
			}
		}, {
			key: "renderAssignTaskItemsModal",
			value: function renderAssignTaskItemsModal() {
				if (!this.state.textToAssign) {
					return;
				}
	
				var modalHeader = "Assign Activity Items:";
				if (this.state.textToAssign.url) {
					var subjectType = "URLPick";
				} else {
					var subjectType = "TitlePick";
				}
	
				return React.createElement(
					Modal,
					{ ref: this.assignTaskItemsModal, headerText: modalHeader, modalOrder: 3 },
					React.createElement(AssignTaskItemsModal, {
						selectedUserIDs: this.state.selectedUserIDs,
						taskSubjectType: subjectType,
						taskSubjectID: this.state.textToAssign.text_id,
						selectedActivityTitle: this.state.textToAssign.title,
						onAssign: this.hideTaskItemAssignmentModal })
				);
			}
		}, {
			key: "hideTaskItemAssignmentModal",
			value: function hideTaskItemAssignmentModal() {
				this.assignTaskItemsModal.current.hide();
				this.props.fetchTasks();
			}
		}, {
			key: "onAssignTitleAsHide",
			value: function onAssignTitleAsHide() {
				this.setState({ textToAssign: null });
			}
		}, {
			key: "render",
			value: function render() {
				var _this5 = this;
	
				var header = '';
				if (!this.props.hideTitle) {
					header = React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Teacher Picks"
						)
					);
				}
	
				var assignTaskModal = this.renderAssignTaskModal();
				var assignTaskItemsModal = this.renderAssignTaskItemsModal();
	
				return React.createElement(
					"div",
					{ className: "container picksPage" },
					header,
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-md-6" },
							React.createElement(
								"h3",
								{ className: "pickHeader normal" },
								"Assign Offline Reading"
							),
							React.createElement(
								"p",
								{ className: "assignInstructions" },
								"Assign physical books for students to read offline before getting back on Whooo\u2019s Reading to answer questions."
							),
							React.createElement(
								"div",
								{ className: "byTitle" },
								this.renderAssignedByTitle()
							),
							React.createElement(
								"div",
								null,
								React.createElement(
									"button",
									{ className: "addPick", onClick: function onClick() {
											return _this5.titlePickModal.current.show();
										} },
									React.createElement(NewTaskCircle, null),
									"Add Title"
								)
							)
						),
						React.createElement(
							"div",
							{ className: "col-md-6" },
							React.createElement(
								"h3",
								{ className: "pickHeader normal" },
								"Assign Online Reading (By URL)"
							),
							React.createElement(
								"p",
								{ className: "assignInstructions" },
								"Assign online articles and books for students to read via Whooo\u2019s Reading and then return to answer questions."
							),
							React.createElement(
								"div",
								{ className: "byURL" },
								this.renderAssignedByURL()
							),
							React.createElement(
								"div",
								null,
								React.createElement(
									"button",
									{ className: "addPick", onClick: function onClick() {
											return _this5.urlLibraryPickModal.current.show();
										} },
									React.createElement(NewTaskCircle, null),
									" Discover"
								),
								React.createElement(
									"button",
									{ className: "addPick", onClick: function onClick() {
											return _this5.urlManualPickModal.current.show();
										} },
									React.createElement(NewTaskCircle, null),
									" Add URL"
								)
							)
						)
					),
					this.renderTitlePickModal(),
					this.renderLibraryURLPickModal(),
					this.renderManualURLPickModal(),
					assignTaskModal,
					assignTaskItemsModal
				);
			}
		}, {
			key: "pullOrRefreshBooks",
			value: function pullOrRefreshBooks() {
				var _this6 = this;
	
				var textIDs = _underscore2.default.uniq(_underscore2.default.pluck(_underscore2.default.values(this.props.tasks), "subject_id"));
				this.props.fetchBooks(textIDs).then(function () {
					return _this6.setState({ loading: false });
				});
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if ($wr.isLargeRequest(this.props.userIDs) && _underscore2.default.size(this.props.tasks) !== _underscore2.default.size(prevProps.tasks)) {
					if (_underscore2.default.size(prevProps.tasks) == 0) {
						this.setState({ loading: true });
					}
	
					this.pullOrRefreshBooks();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.pullOrRefreshBooks();
			}
		}]);
	
		return PicksPage;
	}(React.Component)) || _class) || _class);
	;
	
	PicksPage.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from @connect
		tasks: PropTypes.array,
		booksByURL: PropTypes.array,
		booksByTitle: PropTypes.array,
		userIDsByTextID: PropTypes.object,
		totalStudentCount: PropTypes.number,
		userIDs: PropTypes.array,
	
		// Handlers from @connect
		fetchBooks: PropTypes.func.isRequired,
		populateData: PropTypes.func.isRequired,
		clearTextTasks: PropTypes.func.isRequired,
		fetchTasks: PropTypes.func,
	
		// From Activities page
		hideTitle: PropTypes.bool
	});
	
	module.exports = PicksPage;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	var ReadingLevelFormat = __webpack_require__(72);
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var ReadingActions = __webpack_require__(27);
	var ReadingLevelIcon = __webpack_require__(165);
	var RosterSelectors = __webpack_require__(6);
	
	var ReadingLevelDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		//if the studentReadingLevel is not passed in, grab from redux state.
		if (!props.studentReadingLevel && props.userID) {
			var student = RosterSelectors.student({ state: state, id: props.userID });
			var studentReadingLevel = student && student.current_reading_level ? student.current_reading_level : 0;
		}
		return {
			format: CurrentUser.get().prefs.reading_level_format,
			studentReadingLevel: props.studentReadingLevel || studentReadingLevel
		};
	}, function (dispatch, props) {
		return {
			updateBook: function updateBook(lexileScore) {
				var user = CurrentUser.get();
				var overrideData = {
					instance_id: props.book.text_id,
					instance_type: "book",
					attribute_name: "lexile_score",
					value: lexileScore,
					user_id: user.id,
					user_role: user.role
				};
				var bookUpdate = { lexile_score: lexileScore };
				dispatch(ReadingActions.createOverrideUpdateBook({
					override: overrideData, update: bookUpdate }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ReadingLevelDisplay, _React$Component);
	
		function ReadingLevelDisplay(props) {
			_classCallCheck(this, ReadingLevelDisplay);
	
			var _this = _possibleConstructorReturn(this, (ReadingLevelDisplay.__proto__ || Object.getPrototypeOf(ReadingLevelDisplay)).call(this));
	
			autobind(_this);
			_this.state = { edit: false };
			return _this;
		}
	
		_createClass(ReadingLevelDisplay, [{
			key: "triggerEdit",
			value: function triggerEdit(e) {
				$wr.nope(e);
				this.setState({ edit: !this.state.edit });
			}
		}, {
			key: "handleChange",
			value: function handleChange(event) {
				var lexileScore = parseInt(this.refs.lexile.value);
				this.setState({ edit: false });
				if (lexileScore != -1) {
					this.props.updateBook(lexileScore);
				}
			}
		}, {
			key: "renderCellDisplay",
			value: function renderCellDisplay() {
				if (this.props.lexile != undefined && this.props.lexile != null) {
					var level = ReadingLevelFormat.getScoreForFormat(this.props.lexile, this.props.format);
				} else {
					var level = "-";
				}
				if (this.props.showReadingLevelIcon) {
					var icon = React.createElement(ReadingLevelIcon, { studentReadingLevel: this.props.studentReadingLevel,
						textReadingLevel: this.props.book.lexile_score, tooltipCopyType: ReadingLevelIcon.TEACHER_VIEW,
						showImageOnly: true });
				}
				if (this.state.edit) {
					var defaultValue = ReadingLevelFormat.getLexileScoreForFormat(this.props.lexile, this.props.format);
					var content = React.createElement(
						"select",
						{ ref: "lexile", defaultValue: defaultValue, onChange: this.handleChange,
							className: "form-control selectOptions" },
						DropDownOptions.Select.ReadingLevels({ lexile_to_formats: this.props.format })
					);
					return React.createElement(
						"td",
						{ className: "" },
						content
					);
				} else {
					var content = React.createElement(
						"span",
						{ className: "readingLevelDisplay" },
						React.createElement(
							"span",
							{ className: "level" },
							level
						),
						" ",
						icon
					);
					var link = React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" });
					return React.createElement(
						"td",
						{ className: "clickable editable", onClick: this.triggerEdit },
						content,
						link
					);
				}
			}
		}, {
			key: "renderInlineDisplay",
			value: function renderInlineDisplay() {
				return React.createElement(
					"span",
					null,
					ReadingLevelFormat.getScoreForFormat(this.props.lexile, this.props.format)
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.displayMode && this.props.displayMode == "cell") {
					return this.renderCellDisplay();
				} else {
					return this.renderInlineDisplay();
				}
			}
		}]);
	
		return ReadingLevelDisplay;
	}(React.Component)) || _class);
	
	
	ReadingLevelDisplay.WrappedComponent.propTypes = StrictPropTypes({
		updateBook: PropTypes.func,
		lexile: PropTypes.number,
		format: PropTypes.string,
		book: PropTypes.object,
		displayMode: PropTypes.string,
		studentReadingLevel: PropTypes.number,
		showReadingLevelIcon: PropTypes.bool,
		userID: PropTypes.string
	});
	
	var ORIGIN_TEXTS = {
		"TR": "Reading Level Diagnostic",
		"manual": "Manually Updated Reading Level"
	};
	
	ReadingLevelDisplay.ORIGIN_TEXTS = ORIGIN_TEXTS;
	
	module.exports = ReadingLevelDisplay;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaskTile = __webpack_require__(422);
	var Spinner = __webpack_require__(9);
	
	var CurrentUser = __webpack_require__(3);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var WritingSelectors = __webpack_require__(14);
	var RosterSelectors = __webpack_require__(6);
	
	var MyShelfRouting = __webpack_require__(74);
	
	var StudentTasks = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			revisables: ReadingSelectors.booksWithRevisables({
				state: state, conditions: { userID: CurrentUser.get().id }
			}),
	
			assignedTitles: ReadingSelectors.assignedTitleBooks({ state: state, userID: CurrentUser.get().id }),
			assignedURLs: ReadingSelectors.assignedURLBooks({ state: state, userID: CurrentUser.get().id }),
			assignedActivities: WritingSelectors.assignedActivities({ state: state, userID: CurrentUser.get().id })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData(startDate, endDate) {
				dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
				return dispatch(function (dispatch, getState) {
	
					// This only works because the tasks are already loaded in before this component mounts
					// It's not very stable. Or elegant.
	
					var readingTasks = WritingSelectors.teacherPicksTasks({
						state: getState(), filters: { user_id: CurrentUser.get().id }
					});
	
					if (readingTasks.length > 0) {
						return dispatch(ReadingActions.fetchBooks({
							ids: _.pluck(readingTasks, "subject_id"),
							user_id: CurrentUser.get().id,
							cache: true,
							query: { library_content: true }
						}));
					} else {
						return Promise.resolve();
					}
				});
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(StudentTasks, _React$Component);
	
		function StudentTasks(props) {
			_classCallCheck(this, StudentTasks);
	
			var _this = _possibleConstructorReturn(this, (StudentTasks.__proto__ || Object.getPrototypeOf(StudentTasks)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentTasks, [{
			key: "onRevisionClick",
			value: function onRevisionClick(item) {
				if (item.type == "quiz") {
					var detailsView = "quizzes";
				} else if (item.type == "answer") {
					var detailsView = "answers";
				} else if (item.type == "review") {
					var detailsView = "reviews";
				}
	
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
					textID: item.text_id,
					detailsView: detailsView
				}));
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var revisableQuizTasks = [];
				var revisableAnswerTasks = [];
				var revisableReviewTasks = [];
	
				var activityTasks = [];
				var bookTasks = [];
				var urlTasks = [];
	
				_.each(this.props.revisables, function (item) {
	
					var tile = React.createElement(TaskTile, { key: item.text_id + ":" + item.type,
						onClick: _this2.onRevisionClick,
						item: item, type: TaskTile.REVISABLE_TASK });
	
					if (item.type === "quiz") {
						revisableQuizTasks.push(tile);
					} else if (item.type === "answer") {
						revisableAnswerTasks.push(tile);
					} else if (item.type === "review") {
						revisableReviewTasks.push(tile);
					} else {
						console.error("Unkonwn revisable-task item type: ", tile.type);
					}
				});
	
				_.each(this.props.assignedActivities, function (activity, index) {
					var onClick = function onClick() {
						return _this2.props.onActivitySelect(activity.id, activity.format_summary.text_completion);
					};
					activityTasks.push(React.createElement(TaskTile, { item: activity, key: index, type: TaskTile.EXERCISE_TASK,
						onClick: onClick }));
				});
	
				_.each(this.props.assignedURLs, function (book, index) {
					urlTasks.push(React.createElement(TaskTile, { item: book, key: index,
						type: TaskTile.READING_URL_TASK, onClick: _this2.props.onPickSelect }));
				});
	
				_.each(this.props.assignedTitles, function (book, index) {
					bookTasks.push(React.createElement(TaskTile, { item: book, key: index,
						type: TaskTile.READING_TITLE_TASK, onClick: _this2.props.onPickSelect }));
				});
	
				return React.createElement(
					"div",
					{ className: "studentTasksContainer" },
					React.createElement(
						"p",
						{ className: "subHeader" },
						"My Tasks"
					),
					React.createElement(
						"div",
						{ className: "studentTasks" },
						revisableQuizTasks,
						revisableAnswerTasks,
						revisableReviewTasks,
						activityTasks,
						urlTasks,
						bookTasks
					)
				);
			}
		}]);
	
		return StudentTasks;
	}(React.Component)) || _class) || _class);
	;
	
	StudentTasks.WrappedComponent.propTypes = StrictPropTypes({
		onPickSelect: PropTypes.func,
		onActivitySelect: PropTypes.func,
	
		// Data from @connect
		revisables: PropTypes.array,
		assignedActivities: PropTypes.array,
		assignedTitles: PropTypes.array,
		assignedURLs: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = StudentTasks;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var SchoolYearMonthsPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var refPrefs = {};
	
		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				});
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				});
			}
	
			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs;
			}
		}
	
		return {
			refPrefs: refPrefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (CurrentUser.isDistrictAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
						filters: { ids: [CurrentUser.get().primary_district_org_id] },
						embeds: ['district_org.prefs'],
						cache: true
					}))]);
				} else if (CurrentUser.isSchoolAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
						filters: { ids: [CurrentUser.get().primary_school_org_id] },
						embeds: ['school_org.prefs'],
						cache: true
					}))]);
				} else {
					return Promise.all([dispatch(RosterActions.fetchAdmins({
						filters: { ids: [CurrentUser.get().id] },
						embeds: ['user.prefs'],
						cache: true
					}))]);
				}
				return Promise.all([]);
			},
	
			onChange: function onChange(prefsUpdate, message) {
				// Will get moved to redux at some point (soon, I hope)
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				if (CurrentUser.isDistrictAdmin()) {
					return dispatch(RosterActions.updateDistrictOrgPrefs({
						currentUserID: CurrentUser.get().id,
						districtOrgID: CurrentUser.get().primary_district_org_id,
						resetPrefs: true,
						update: prefsUpdate
					}));
				} else if (CurrentUser.isSchoolAdmin()) {
					return dispatch(RosterActions.updateSchoolOrgPrefs({
						currentUserID: CurrentUser.get().id,
						resetPrefs: true,
						schoolOrgID: CurrentUser.get().primary_school_org_id,
						update: prefsUpdate
					}));
				} else {
					return dispatch(RosterActions.updateAdminPrefs({
						id: CurrentUser.get().id,
						resetStudentLists: true,
						update: prefsUpdate
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(SchoolYearMonthsPreference, _React$Component);
	
		function SchoolYearMonthsPreference(props) {
			_classCallCheck(this, SchoolYearMonthsPreference);
	
			var _this = _possibleConstructorReturn(this, (SchoolYearMonthsPreference.__proto__ || Object.getPrototypeOf(SchoolYearMonthsPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("SchoolYearMonthsPreference");
			return _this;
		}
	
		_createClass(SchoolYearMonthsPreference, [{
			key: "selectSchoolYearStart",
			value: function selectSchoolYearStart() {
				var selectedStartMonth = this.refs.school_year_start_input.value - 1;
				var preferenceHash = { school_year_start_month: selectedStartMonth };
				this.props.onChange(preferenceHash, "You changed the start of your school year");
			}
		}, {
			key: "selectSchoolYearEnd",
			value: function selectSchoolYearEnd() {
				var selectedEndMonth = this.refs.school_year_end_input.value - 1;
				var preferenceHash = { school_year_end_month: selectedEndMonth };
				this.props.onChange(preferenceHash, "You changed the end of your school year");
			}
		}, {
			key: "renderOrgPreference",
			value: function renderOrgPreference() {
				var org_prefs = CurrentUser.get().org_prefs;
	
				// ONLY SHOW TO TEACHERS AND SCHOOL ADMINS THAT ARE PART OF A DISTRICT
				if (!_.isEmpty(org_prefs) && !(CurrentUser.isDistrictAdmin() || CurrentUser.isSchoolAdmin() && !CurrentUser.get().primary_district_org_id)) {
					var currentSchoolYearStart = CurrentUser.get().org_prefs.school_year_start_month;
					var currentSchoolYearEnd = CurrentUser.get().org_prefs.school_year_end_month;
	
					return React.createElement(
						"div",
						{ className: "orgPreferences" },
						React.createElement(
							"b",
							null,
							"Your Administrator chose the following dates: ",
							MONTHS[currentSchoolYearStart],
							" - ",
							MONTHS[currentSchoolYearEnd]
						)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var currentSchoolYearStart = CurrentUser.get().prefs.school_year_start_month + 1;
				var currentSchoolYearEnd = CurrentUser.get().prefs.school_year_end_month + 1;
	
				return React.createElement(
					"div",
					{ className: "schoolYearContainer" },
					React.createElement(
						"p",
						null,
						"Your students' progress will be calculated based on when your school year starts and ends."
					),
					this.renderOrgPreference(),
					React.createElement(
						"label",
						null,
						React.createElement(
							"span",
							null,
							"Start"
						),
						React.createElement(
							"select",
							{ type: "text", className: "form-control month", ref: "school_year_start_input",
								defaultValue: currentSchoolYearStart, onChange: this.selectSchoolYearStart },
							DropDownOptions.Select.Months({ monthNameOnly: true })
						)
					),
					React.createElement(
						"label",
						null,
						React.createElement(
							"span",
							null,
							"End"
						),
						React.createElement(
							"select",
							{ type: "text", className: "form-control month", ref: "school_year_end_input",
								defaultValue: currentSchoolYearEnd, onChange: this.selectSchoolYearEnd },
							DropDownOptions.Select.Months({ monthNameOnly: true })
						)
					)
				);
			}
		}]);
	
		return SchoolYearMonthsPreference;
	}(React.Component)) || _class) || _class);
	
	
	var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	SchoolYearMonthsPreference.WrappedComponent.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired,
		populateData: PropTypes.func.isRequired,
		refPrefs: PropTypes.object.isRequired
	});
	
	module.exports = SchoolYearMonthsPreference;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountPlans = __webpack_require__(53);
	var CurrentUser = __webpack_require__(3);
	
	var UIActions = __webpack_require__(41);
	
	var PaywallModal = __webpack_require__(44);
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3783);
	
	var OverdrawnAccountNotice = (_dec = (0, _reactRedux.connect)(function () {
		return {};
	}, function (dispatch, props) {
		return {
			showPaywall: function showPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.OVERDRAWN_ACCOUNT }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(OverdrawnAccountNotice, _React$Component);
	
		function OverdrawnAccountNotice(props) {
			_classCallCheck(this, OverdrawnAccountNotice);
	
			var _this = _possibleConstructorReturn(this, (OverdrawnAccountNotice.__proto__ || Object.getPrototypeOf(OverdrawnAccountNotice)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(OverdrawnAccountNotice, [{
			key: "getPlanName",
			value: function getPlanName() {
				var planType = CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
				return AccountPlans.name(planType);
			}
		}, {
			key: "getUpgradePath",
			value: function getUpgradePath() {
				var planType = CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
				return "/upgrade?plan=" + AccountPlans.increaseType(planType);
			}
		}, {
			key: "maxClassText",
			value: function maxClassText() {
				var classCount = CurrentUser.get().account.max_student_list_count;
				return $wr.pluralizeWithNumber("class", classCount, "classes");
			}
		}, {
			key: "maxStudentText",
			value: function maxStudentText() {
				var studentCount = CurrentUser.get().account.max_students_count;
				return $wr.pluralizeWithNumber("student", studentCount);
			}
		}, {
			key: "onUpgrade",
			value: function onUpgrade(e) {
				$wr.nope(e);
				var planType = CurrentUser.get().account.plan_type;
				if (planType == AccountPlans.STARTER_PLAN || planType == undefined) {
					this.props.showPaywall();
				} else {
					$wr.redirect(this.getUpgradePath());
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.source == "roster") {
					// when on the roster, link to the help section
					var classesLink = "https://whooosreading.zendesk.com/hc/en-us/articles/115001333471";
					var reorganizeLink = "https://whooosreading.zendesk.com/hc/en-us/articles/115001704531";
					var fixLink = React.createElement(
						"span",
						null,
						React.createElement(
							"a",
							{ href: classesLink, target: "_blank" },
							"Archive classes"
						),
						React.createElement("div", { className: "verticalDivider" }),
						React.createElement(
							"a",
							{ href: reorganizeLink, target: "_blank" },
							"Reorganize"
						)
					);
				} else {
					// link to the roster on every other page
					var fixLink = React.createElement(
						_reactRouterDom.Link,
						{ to: "/roster" },
						"Reduce your roster"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "overdrawnAccountNotice hideOnPrint" },
					React.createElement(
						"div",
						{ className: "noticeBox" },
						React.createElement(
							"div",
							{ className: "statusDescription" },
							"Your student accounts are frozen because you are over your",
							" " + this.getPlanName(),
							" plan limits of ",
							React.createElement(
								"b",
								null,
								this.maxClassText()
							),
							" with",
							" ",
							React.createElement(
								"b",
								null,
								this.maxStudentText()
							),
							" each."
						),
						React.createElement(
							"div",
							{ className: "actionOptions" },
							"To unfreeze your accounts:",
							React.createElement("br", null),
							" ",
							fixLink,
							React.createElement("div", { className: "verticalDivider" }),
							React.createElement(
								"a",
								{ href: "#", onClick: this.onUpgrade },
								"Upgrade"
							)
						)
					)
				);
			}
		}]);
	
		return OverdrawnAccountNotice;
	}(React.Component)) || _class);
	
	
	OverdrawnAccountNotice.WrappedComponent.propTypes = StrictPropTypes({
		// location of notice, for changing link to roster vs help section
		source: PropTypes.string.isRequired,
	
		showPaywall: PropTypes.func.isRequired
	});
	
	module.exports = OverdrawnAccountNotice;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	
	__webpack_require__(3786);
	
	var UpgradeHeader = function (_React$Component) {
		_inherits(UpgradeHeader, _React$Component);
	
		function UpgradeHeader(props) {
			_classCallCheck(this, UpgradeHeader);
	
			var _this = _possibleConstructorReturn(this, (UpgradeHeader.__proto__ || Object.getPrototypeOf(UpgradeHeader)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(UpgradeHeader, [{
			key: "subHeaderList",
			value: function subHeaderList() {
				return _.map(UpgradeHeader.BENEFITS[this.props.product], function (benefitText) {
					return React.createElement(
						"div",
						{ className: "benefitItem", key: benefitText },
						React.createElement(Glyphicon, { icon: "ok" }),
						React.createElement(
							"div",
							{ className: "benefitText" },
							benefitText
						)
					);
				});
			}
		}, {
			key: "render",
			value: function render() {
				var headerClassName = "upgradeHeader " + this.props.product + "Header";
	
				if (this.props.showSkipOption) {
					var skipToOnboarding = React.createElement(
						"div",
						{ className: "laterWrap" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/", className: "laterLink" },
							"Upgrade Later"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: headerClassName },
					React.createElement(
						"div",
						{ className: "container headerContainer" },
						React.createElement(
							"div",
							{ className: "subHeader headerText" },
							"Upgrade to ",
							$wr.capitalize(this.props.product)
						),
						React.createElement(
							"div",
							{ className: "benefitsList" },
							this.subHeaderList()
						),
						skipToOnboarding
					)
				);
			}
		}]);
	
		return UpgradeHeader;
	}(React.Component);
	
	;
	
	UpgradeHeader.BENEFITS = {
		silver: ["Differentiation", "Writing data", "Reading accountability"],
		gold: ["Identify which students demonstrate comprehension", "Differentiate and customize scaffolds for each student", "Track students’ daily reading using a digital reading log", "Encourage students to read within their ZPD reading level", "Activate standards-aligned questions and reporting", "Customize activities assigned alongside specific titles", "Track reading and writing skills where support is needed", "Assign intervention exercises based on student need", "Observe reading and writing proficiency over time"]
	};
	
	UpgradeHeader.propTypes = StrictPropTypes({
		product: PropTypes.string.isRequired,
		showSkipOption: PropTypes.bool
	});
	
	module.exports = UpgradeHeader;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var Masonry = __webpack_require__(627);
	
	// Use the original board's CSS
	__webpack_require__(655);
	
	var AltBoard = function (_React$Component) {
		_inherits(AltBoard, _React$Component);
	
		function AltBoard(props) {
			_classCallCheck(this, AltBoard);
	
			var _this = _possibleConstructorReturn(this, (AltBoard.__proto__ || Object.getPrototypeOf(AltBoard)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(AltBoard, [{
			key: "render",
			value: function render() {
				if (this.props.loading) {
					var spinner = React.createElement(Spinner, { scale: 1.7 });
				}
	
				var masonryOptions = { gutter: 15 };
	
				var className = "tileGridWrapper";
				if (this.props.narrowBoard) {
					className += " narrowGrid";
				}
	
				return React.createElement(
					"div",
					{ className: className, ref: "wrapper" },
					React.createElement(
						Masonry,
						{ updateOnEachImageLoad: true, options: masonryOptions, ref: "masonry" },
						this.props.children
					),
					spinner
				);
			}
		}, {
			key: "checkScroll",
			value: function checkScroll() {
				if (!this.props.loading && this.props.onScrollToBottom) {
					var $wrapper = $(this.refs.wrapper);
					var threshold = 300;
					var lim = $wrapper.offset().top + $wrapper.height();
					var loc = $(window).scrollTop() + $(window).height();
					if (loc + threshold > lim) {
						this.props.onScrollToBottom();
					}
				}
			}
		}, {
			key: "refreshMasonry",
			value: function refreshMasonry() {
				this.refs.masonry.forceUpdate();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window).scroll(this.checkScroll);
				$(window).on("masonry-update", this.refreshMasonry);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.checkScroll);
				$(window).off("masonry-update", this.refreshMasonry);
			}
		}]);
	
		return AltBoard;
	}(React.Component);
	
	;
	
	AltBoard.propTypes = StrictPropTypes({
		children: PropTypes.array.isRequired,
	
		// Show a spinner and block onEnd notices if this is true
		loading: PropTypes.bool,
	
		// Function to call once the user has scrolled to the bottom
		onScrollToBottom: PropTypes.func,
	
		// Makes the board narrower (3 columns), to allow for a page sidebar
		narrowBoard: PropTypes.bool
	});
	
	module.exports = AltBoard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3817);
	
	var StepProgressMeter = function (_React$Component) {
		_inherits(StepProgressMeter, _React$Component);
	
		function StepProgressMeter(props) {
			_classCallCheck(this, StepProgressMeter);
	
			var _this = _possibleConstructorReturn(this, (StepProgressMeter.__proto__ || Object.getPrototypeOf(StepProgressMeter)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StepProgressMeter, [{
			key: "barWidth",
			value: function barWidth() {
				return 15 / this.props.numSteps;
			}
		}, {
			key: "renderTrackingBar",
			value: function renderTrackingBar(isComplete, keyIndex) {
				var statusClassName = isComplete ? "full" : "empty";
	
				return React.createElement("div", { className: "trackingBar " + statusClassName,
					style: { width: this.barWidth() + "rem" },
					key: "bar" + keyIndex });
			}
		}, {
			key: "renderStepCircle",
			value: function renderStepCircle(iconPathStem, isComplete, keyIndex) {
				var iconPath = iconPathStem;
				if (isComplete) {
					iconPath = iconPath + "-complete";
				}
				iconPath = iconPath + ".png";
	
				return React.createElement(
					"div",
					{ className: "stepCircle", key: "circle" + keyIndex },
					React.createElement("img", { src: dynamicRequire(iconPath), className: "stepIcon" })
				);
			}
		}, {
			key: "renderCurrentStepDisplay",
			value: function renderCurrentStepDisplay() {
				// Step number of bars, and (Step - 1) number of circles
				// (Step is 1-indexed)
				var circleWidth = 5;
				var barWidth = this.barWidth();
	
				var leftAmount = this.props.currentStep * barWidth + (this.props.currentStep - 1) * circleWidth;
	
				var style = { left: leftAmount + "rem" };
	
				return React.createElement(
					"div",
					{ className: "currentStepDisplay", key: "current", style: style },
					this.props.currentStepDisplay
				);
			}
		}, {
			key: "renderFinishImage",
			value: function renderFinishImage() {
				return React.createElement(
					"div",
					{ className: "finishImgDisplay", key: "finish" },
					React.createElement("img", { src: dynamicRequire(this.props.finishImgPath), className: "finishImg" })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var currentStep = this.props.currentStep || 1;
	
				var stepsDisplay = [];
				// include the currentStepDisplay in the array if specified
				if (this.props.currentStepDisplay) {
					stepsDisplay.push(this.renderCurrentStepDisplay());
				}
	
				var initialBarDisplay = this.renderTrackingBar(true, 0);
	
				for (var i = 1; i <= this.props.numSteps; i++) {
					var isComplete = i < currentStep;
	
					stepsDisplay.push(this.renderStepCircle(this.props.iconPathStems[i - 1], isComplete, i));
					stepsDisplay.push(this.renderTrackingBar(isComplete, i));
				}
	
				if (this.props.finishImgPath) {
					var finishImgDisplay = this.renderFinishImage();
				}
	
				return React.createElement(
					"div",
					{ className: "stepProgressMeter" },
					React.createElement(
						"div",
						{ className: "meterContainer" },
						initialBarDisplay,
						stepsDisplay,
						finishImgDisplay
					)
				);
			}
		}]);
	
		return StepProgressMeter;
	}(React.Component);
	
	;
	
	StepProgressMeter.propTypes = StrictPropTypes({
		// starting index 1, total number of circle icon steps
		numSteps: PropTypes.number.isRequired,
	
		// starting index 1, defaults to 1 (first step)
		currentStep: PropTypes.number,
	
		// array of icon path stems for each step, must have corresponding incomplete and complete icons
		// e.g. "quiz-icons/warmup" stem assumes two images
		// incomplete: "quiz-icons/warmup.png" complete: "quiz-icons/warmup-complete.png"
		iconPathStems: PropTypes.array.isRequired,
	
		// image for the end of the meter (optional)
		finishImgPath: PropTypes.string,
	
		// display to replace the icon on the current step (optional)
		currentStepDisplay: PropTypes.object
	});
	
	module.exports = StepProgressMeter;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Glyphicon = __webpack_require__(8);
	var ImageIcon = __webpack_require__(102);
	
	var StandardIcon = function StandardIcon(props) {
		if (props.type == StandardIcon.WR_ICON) {
			return React.createElement(ImageIcon, props);
		} else if (props.type == StandardIcon.WR_SIMPLE_ICON) {
			return React.createElement(ImageIcon, _extends({}, props, { icon: props.icon + "-s" }));
		} else if (props.type == StandardIcon.GLYPHICON) {
			return React.createElement(Glyphicon, props);
		} else {
			return React.createElement("span", null);
		}
	};
	
	StandardIcon.GLYPHICON = "Glyphicon";
	StandardIcon.WR_ICON = "WR Icon";
	StandardIcon.WR_SIMPLE_ICON = "WR Small Icon";
	
	StandardIcon.propTypes = StrictPropTypes({
		// Passed through (this other props) to the child icon component
		className: PropTypes.string,
	
		// Icon name
		icon: PropTypes.string.isRequired,
	
		// Type of icon
		type: PropTypes.oneOf([StandardIcon.GLYPHICON, StandardIcon.WR_ICON, StandardIcon.WR_SIMPLE_ICON]).isRequired
	});
	
	module.exports = StandardIcon;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	var Formats = __webpack_require__(105);
	var Skillsets = __webpack_require__(55);
	var TextTypes = __webpack_require__(38);
	var ReactTooltip = __webpack_require__(12);
	var BookDisplay = __webpack_require__(46);
	
	var WritingSelectors = __webpack_require__(14);
	var UIActions = __webpack_require__(41);
	var WritingActions = __webpack_require__(24);
	
	__webpack_require__(3826);
	
	var ExerciseTile = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var requiredRecords = {};
	
		// We'll sometimes end up setting values more than once
		if (props.responseID) {
			var response = WritingSelectors.response({ state: state, id: props.responseID });
			requiredRecords.response = response;
			requiredRecords.activity = WritingSelectors.activity({ state: state, id: response.activity_id });
		}
	
		if (props.taskID) {
			var task = WritingSelectors.task({ state: state, id: props.taskID });
			requiredRecords.task = task;
			requiredRecords.activity = WritingSelectors.activity({ state: state, id: task.subject_id });
			if (task.completion_id) {
				requiredRecords.response = WritingSelectors.response({ state: state, id: task.completion_id });
			}
		}
		return requiredRecords;
	}, function (dispatch, props) {
		var handlers = {};
	
		if (props.allowExpandResponse && props.responseID) {
			handlers.onClick = function (response) {
				if (response.draft) {
					$wr.redirect("/responses/new?text_id=" + response.text_id + '&activity_id=' + response.activity_id);
				} else {
					dispatch(UIActions.toggleExpandedResponse({ responseID: props.responseID, expanded: true }));
				}
			};
		}
		if (props.allowRemoveTask && props.taskID && !props.responseID) {
			handlers.onRemoveTask = function () {
				return dispatch(WritingActions.deleteTask({ id: props.taskID }));
			};
		}
	
		return handlers;
	}), _dec(_class = function (_React$Component) {
		_inherits(ExerciseTile, _React$Component);
	
		function ExerciseTile(props) {
			_classCallCheck(this, ExerciseTile);
	
			var _this = _possibleConstructorReturn(this, (ExerciseTile.__proto__ || Object.getPrototypeOf(ExerciseTile)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ExerciseTile, [{
			key: "onTileClick",
			value: function onTileClick(e) {
				$wr.nope(e);
				if (this.props.onClick) {
					this.props.onClick(this.props.response);
				} else {
					var url = "/responses/new?activity_id=" + this.props.activity.id;
					// $wr.redirect(url;
					window.open(url, "_blank");
				}
			}
		}, {
			key: "onRemoveTask",
			value: function onRemoveTask(e) {
				if (e) {
					e.stopPropagation();
					$wr.nope(e);
				}
				if (this.props.onRemoveTask) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Exercise Unassigned", text: "You have unassigned the exercise.", icon: "trash" });
					this.props.onRemoveTask();
				}
			}
		}, {
			key: "onOpenPrintable",
			value: function onOpenPrintable(e) {
				$wr.nope(e);
				var activity = this.props.activity;
	
				Mycroft.newEvent({ category: "Printables", action: "view-activitiy", label: activity.key });
				setTimeout(function () {
					Mycroft.newEvent({ category: "Printables", action: "view-skillset", label: activity.format_summary.skillset });
				}, 1100);
				setTimeout(function () {
					Mycroft.newEvent({ category: "Printables", action: "view-format", label: activity.format_summary.format_class });
				}, 2200);
	
				window.open(activity.thumbnail.printable_url, "_blank");
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    response = _props.response,
				    activity = _props.activity,
				    task = _props.task;
	
	
				if (response) {
					if (response.text_id && response.text_id !== 'MISSING_TEXT_ID') {
						var textInfo = React.createElement(
							"div",
							{ className: "bookTitle" },
							"For: ",
							React.createElement(BookDisplay, { textID: response.text_id })
						);
					} else {
						var textInfo = React.createElement(
							"div",
							{ className: "bookTitle" },
							React.createElement(
								"em",
								null,
								"Text provided"
							)
						);
					}
	
					if (response.edited_at) {
						var editedLine = React.createElement(
							"span",
							{ className: "date" },
							"Edited: ",
							$wr.formatDate(response.edited_at)
						);
					}
					if (response.completed_at) {
						var completedLine = React.createElement(
							"span",
							{ className: "date" },
							"Completed: ",
							$wr.formatDate(response.created_at)
						);
					}
				}
	
				if (task) {
					if (task.created_at) {
						var assignedLine = React.createElement(
							"span",
							{ className: "date" },
							"Assigned: ",
							$wr.formatDate(task.created_at)
						);
					}
	
					if (this.props.onRemoveTask && !response) {
						var removeFlag = React.createElement(
							"li",
							{ onClick: this.onRemoveTask, className: "dynamic assignMarker clickableElement" },
							React.createElement(
								"span",
								{ className: "buttonTitle" },
								"Unassign"
							),
							React.createElement(Glyphicon, { icon: "minus", className: "menuIcon" })
						);
					}
	
					if (this.props.showCompleted && response) {
						var completedFlag = React.createElement(
							"li",
							{ onClick: this.onRemoveTask, className: "completedMarker" },
							React.createElement(
								"span",
								{ className: "buttonTitle" },
								"Completed"
							),
							React.createElement(Glyphicon, { icon: "ok", className: "menuIcon" })
						);
					}
				}
	
				var activityTitleClassName = "activityTitle";
				if (response && response.draft) {
					var draftMessage = React.createElement(
						"span",
						null,
						React.createElement("br", null),
						React.createElement(
							"em",
							null,
							"Unfinished"
						)
					);
				}
	
				var textContent = React.createElement(
					"div",
					{ className: "responseInfo smallText" },
					React.createElement(
						"div",
						{ className: "responseHeader" },
						React.createElement(
							"p",
							{ className: activityTitleClassName },
							React.createElement(
								"strong",
								null,
								activity.format_summary.title
							),
							draftMessage
						)
					),
					React.createElement(
						"div",
						{ className: "responseBody" },
						textInfo,
						assignedLine,
						completedLine,
						editedLine
					)
				);
	
				var className = "tile exerciseTile";
				if (this.props.onClick) {
					className += " clickableElement";
				}
	
				var skillset = activity.format_summary.skillset;
	
				var imgContainerClassName = "imgContainer";
				if (this.props.smallThumbnail) {
					imgContainerClassName += " small";
				}
	
				var printControl = React.createElement(
					"li",
					{ onClick: this.onOpenPrintable, className: "dynamic printMarker" },
					React.createElement(
						"span",
						{ className: "buttonTitle" },
						"Print"
					),
					React.createElement(Glyphicon, { icon: "print", className: "menuIcon" })
				);
	
				return React.createElement(
					"div",
					{ className: className },
					React.createElement(
						"div",
						{ className: imgContainerClassName },
						React.createElement(
							"div",
							{ className: "buttonsBar" },
							React.createElement(
								"ul",
								null,
								removeFlag,
								completedFlag,
								printControl
							)
						),
						React.createElement("img", { src: activity.thumbnail.url, className: "tileImg", onClick: this.onTileClick })
					),
					textContent,
					React.createElement(
						"div",
						{ className: "skillsetTitle smallText" },
						React.createElement("img", { src: Skillsets.getIcon(skillset), className: "skillsetImg" }),
						React.createElement(
							"span",
							{ className: "itemName" },
							Skillsets.getName(skillset)
						)
					)
				);
			}
		}]);
	
		return ExerciseTile;
	}(React.Component)) || _class);
	;
	
	ExerciseTile.WrappedComponent.propTypes = StrictPropTypes({
	
		// One of these must be set, but any are sufficient to show this tile
		responseID: PropTypes.number,
		activityID: PropTypes.number,
		taskID: PropTypes.number,
	
		// If set, limits the height of the image of the activity
		smallThumbnail: PropTypes.bool,
	
		// If set, clicking on the tile will open a modal showing the response 
		allowExpandResponse: PropTypes.bool,
	
		// If set, show a flag to indicated the task has been completed (if it's been completed) 
		showCompleted: PropTypes.bool,
	
		// If set, included a button to remove the task
		allowRemoveTask: PropTypes.bool,
	
		allowPreview: PropTypes.bool,
	
		// Data from @connect:
		activity: PropTypes.object.isRequired,
		response: PropTypes.object,
		task: PropTypes.object,
	
		// Handlers from @connect:
		onClick: PropTypes.func,
		onRemoveTask: PropTypes.func
	});
	
	module.exports = ExerciseTile;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Skillsets = __webpack_require__(55);
	
	__webpack_require__(3850);
	
	var SkillsetBanner = function SkillsetBanner(props) {
		var className = "skillsetBanner";
		if (props.className) {
			className += " " + props.className;
		}
		if (props.small) {
			className += " smallBanner";
		} else {
			className += " largeBanner";
		}
	
		if (props.text) {
			var textBox = React.createElement(
				"p",
				{ className: "text" },
				props.text
			);
		}
	
		if (props.classShelf && props.skillset == "review") {
			var title = "Reviews";
		} else if (props.textVariety) {
			var title = React.createElement(
				"span",
				{ className: "inner" },
				Skillsets.getShortName(props.skillset, props.textVariety)
			);
		} else {
			var title = React.createElement(
				"span",
				{ className: "inner" },
				Skillsets.getShortName(props.skillset)
			);
		}
	
		var skillsetData = Skillsets.getData(props.skillset);
		if (skillsetData) {
			var skillsetEnv = skillsetData["env"];
			var src = dynamicRequire("skillset-banners/banner-" + skillsetEnv + ".png");
			var skillsetImg = React.createElement("img", { src: src, className: "banner" });
		}
	
		return React.createElement(
			"div",
			{ className: className, onClick: props.onClick },
			React.createElement(
				"p",
				{ className: "title" },
				title
			),
			skillsetImg,
			textBox
		);
	};
	
	SkillsetBanner.propTypes = StrictPropTypes({
		skillset: PropTypes.string.isRequired,
		textVariety: PropTypes.string,
	
		// Optional text to disply underneath the banner
		text: PropTypes.string,
	
		// Meant to show at slightly less than 50% width
		small: PropTypes.bool,
	
		// Function called when outer div is selected
		onClick: PropTypes.func,
	
		//Boolean detects if banner is being used on Shelves Page
		classShelf: PropTypes.bool,
	
		// Optional className
		className: PropTypes.string
	});
	
	module.exports = SkillsetBanner;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var CurrentUser = __webpack_require__(3);
	
	var NameLookup = {
	
		translateMap: function translateMap(otherMap, callback) {
			var runTranslate = function () {
	
				var studentHash = {};
	
				this[NameLookup.STUDENT_ARRAY_KEY].map(function (s) {
					var key = _.findKey(otherMap, _.partial(_.isEqual, s.id));
					if (key) {
						studentHash[key] = s.display_name;
					}
				}.bind(this));
	
				if (callback) {
					callback(studentHash);
				}
			}.bind(this);
	
			if (!this.isLoaded()) {
				this.loadStudentNames(runTranslate);
			} else {
				setTimeout(runTranslate, 5);
			}
		},
	
		getName: function getName(studentID, callback) {
			var studentData = this[NameLookup.STUDENT_ARRAY_KEY].find(function (student) {
				return student.id == studentID;
			});
	
			if (studentData) {
				return studentData.display_name;
			}
		},
	
		getNames: function getNames(mirrorIDs) {
			return _.map(mirrorIDs, function (userID) {
				return this.getName(userID);
			}.bind(this));
		},
	
		isLoaded: function isLoaded() {
			return this[NameLookup.STUDENT_ARRAY_KEY] != undefined;
		},
	
		loadStudentNames: function loadStudentNames(callback) {
	
			if (CurrentUser.isStudent()) {
				var studentListID = CurrentUser.get().primary_student_list.id;
				CurrentUser.api().getStudentList(studentListID, { embed: "student_list.students" }, $wr.apiHandler(function (rsp) {
					var students = rsp.student_list.students;
					this[NameLookup.STUDENT_ARRAY_KEY] = students;
					if (callback) {
						callback();
					}
				}.bind(this)));
			} else {
				CurrentUser.api().getStudentLists({ embed: "student_list.students" }, $wr.apiHandler(function (rsp) {
					var students = _.flatten(_.pluck(rsp.student_lists, "students"));
					this[NameLookup.STUDENT_ARRAY_KEY] = students;
					if (callback) {
						callback();
					}
				}.bind(this)));
			}
		}
	};
	
	NameLookup.STUDENT_ARRAY_KEY = "__student_array_key__";
	
	module.exports = NameLookup;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	
	var CustomerIOClient = {
		init: function init(clientID) {
			window._cio = window._cio || [];
	
			(function () {
				var a, b, c;a = function a(f) {
					return function () {
						window._cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
					};
				};b = ["identify", "track"];for (c = 0; c < b.length; c++) {
					window._cio[b[c]] = a(b[c]);
				};
				var t = document.createElement('script'),
				    s = document.getElementsByTagName('script')[0];
				t.async = true;
				t.id = 'cio-tracker';
				t.setAttribute('data-site-id', clientID);
				t.src = 'https://assets.customer.io/assets/track.js';
				s.parentNode.insertBefore(t, s);
			})();
		},
	
		identify: function identify(user) {
			if (user.email && !$wr.isDevelopment() && !$wr.isStaging()) {
				var userData = {
					id: CustomerIOClient.getUserIdentifier(user),
					email: user.email,
					environment: $wr.environment(),
					demo: user.demo,
					title: user.title,
					first_name: user.first_name,
					last_name: user.last_name,
					first_active: user.first_active,
					last_active: user.last_active,
					role: user.role,
					product: user.product,
					api_version: user.api_version,
					grade_level: user.grade_level,
					timezone: user.time_zone_region,
	
					account_annual: (user.account || {}).annual,
					account_existing_plan_value: (user.account || {}).existing_plan_value,
					account_has_credit_card: (user.account || {}).has_credit_card,
					account_max_student_list_count: (user.account || {}).max_student_list_count,
					account_max_students_count: (user.account || {}).max_students_count,
					account_next_charge_cents: (user.account || {}).next_charge_cents,
					account_next_charge_time: (user.account || {}).next_charge_time,
					account_plan_has_rlds: (user.account || {}).plan_has_rlds,
					account_plan_payment_status: (user.account || {}).plan_payment_status,
					account_plan_student_list_count: (user.account || {}).plan_student_list_count,
					account_plan_type: (user.account || {}).plan_type
	
				};
	
				_cio.identify(userData);
			}
		},
	
		event: function event(user, name) {
			var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
			CustomerIOClient.identify(user);
	
			if (user.email && !$wr.isDevelopment() && !$wr.isStaging()) {
				_cio.track(name, data);
			}
		},
	
		getUserIdentifier: function getUserIdentifier(user) {
			return $wr.environment().substring(0, 3) + "-" + user.id;
		}
	
	};
	
	module.exports = CustomerIOClient;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
	  var fullPath = "/activities";
	
	  if (state.activeView) {
	    fullPath += "/" + state.activeView;
	  } else {
	    fullPath += "/" + VIEWS.EXERCISE_VIEW;
	  }
	  return fullPath;
	}
	
	function getRouteState(params) {
	  var state = {};
	
	  state.activeView = params.active_view;
	  state.detailsView = params.details_view;
	  state.textID = params.text_id;
	
	  return state;
	}
	
	var VIEWS = exports.VIEWS = {
	  EXERCISE_VIEW: "exercises",
	  TEACHER_PICKS_VIEW: "teacher-picks"
	};
	
	var PATH = exports.PATH = "/activities/:active_view";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/student_lists";
	
		if (state.orgIdentifier) {
			fullPath += "/" + state.orgIdentifier;
		} else {
			fullPath += "/" + DEFAULT_ORG_IDENTIFIER_KEY;
		}
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		} else {
			fullPath += "/" + VIEWS.SHELF_VIEW;
		}
	
		if (state.detailsView) {
			fullPath += "/" + state.detailsView;
			if (state.textID) {
				fullPath += "/" + state.textID;
			}
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		state.orgIdentifier = params.org_identifier;
		state.activeView = params.active_view;
		state.detailsView = params.details_view;
		state.textID = params.text_id;
	
		return state;
	}
	
	var DEFAULT_ORG_IDENTIFIER_KEY = exports.DEFAULT_ORG_IDENTIFIER_KEY = "default";
	
	var VIEWS = exports.VIEWS = {
		TREE_VIEW: "tree",
		SHELF_VIEW: "shelf",
		PHOTO_VIEW: "photos"
	};
	
	var PATH = exports.PATH = "/student_lists/:org_identifier/:active_view/:details_view?/:text_id?";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CONFIG;
	
	exports.getDataPacket = getDataPacket;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FAILED_QUIZ = exports.FAILED_QUIZ = "ask_teacher_about_failed_quiz";
	var OVERALL_INTENTION = exports.OVERALL_INTENTION = "ask_teacher_about_intention";
	var IMPROVE_QUIZ = exports.IMPROVE_QUIZ = "improve_scoring_quiz_general";
	var QUIZ_ACCURACY = exports.QUIZ_ACCURACY = "quiz_score_accuracy_confidence";
	var READ_BOOK = exports.READ_BOOK = "did_student_read_book";
	var SCORING_QUIZ_WRITTEN_RESPONSE = exports.SCORING_QUIZ_WRITTEN_RESPONSE = "improve_scoring_quiz_written_responses";
	var DASHBOARD_HELPFULNESS = exports.DASHBOARD_HELPFULNESS = "improve_helpfulness_of_dashboard";
	var QUIZ_FLAG = exports.QUIZ_FLAG = "quiz_flag_helpfulness";
	var IMPROVE_AUTOGRADER = exports.IMPROVE_AUTOGRADER = "improve_autograder_and_rubric";
	
	var LAYOUTS = exports.LAYOUTS = {
	  EMBEDED_CONTENT: 'embeded_content',
	  SIDEBAR_SURVEY: 'sidebar_survey'
	};
	
	var CONFIG = exports.CONFIG = (_CONFIG = {}, _defineProperty(_CONFIG, FAILED_QUIZ, {
	  description: null,
	  layout: LAYOUTS.EMBEDED_CONTENT,
	  trigger: {
	    paths: ["data", 'quizzes'],
	    // what we are looking for
	    class: ".failDisplay",
	    exclude_classes: ['.neutralDisplay']
	  },
	  location: {
	    // parent that should hold our new div
	    parent: ".quizDisplay",
	    // where to insert our div
	    anchor: ".topRow"
	  },
	  style: {
	    class: 'contentSurvey',
	    circle_animation: true
	  },
	  include_free_response: false,
	  select_multiple: false
	}), _defineProperty(_CONFIG, QUIZ_FLAG, {
	  description: null,
	  layout: LAYOUTS.EMBEDED_CONTENT,
	  trigger: {
	    paths: ["data", 'quizzes'],
	    // what we are looking for
	    class: ".answerDetailsFlag",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: ".singleQuizView",
	    // where to insert our div
	    anchor: ".topRow"
	  },
	  style: {
	    class: 'contentSurvey twoRows',
	    circle_animation: false
	  },
	  include_free_response: false,
	  select_multiple: false
	}), _defineProperty(_CONFIG, DASHBOARD_HELPFULNESS, {
	  description: "pick one answer",
	  layout: LAYOUTS.SIDEBAR_SURVEY,
	  trigger: {
	    paths: ["home"],
	    // what we are looking for
	    class: ".widgetContainer",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: "#pageContent",
	    // where to insert our div
	    anchor: "#teacherHomePage"
	  },
	  style: {
	    class: 'sidebarSurvey'
	  },
	  include_free_response: true,
	  select_multiple: true
	}), _defineProperty(_CONFIG, OVERALL_INTENTION, {
	  description: "pick one answer",
	  layout: LAYOUTS.SIDEBAR_SURVEY,
	  trigger: {
	    paths: ["data"],
	    // what we are looking for
	    class: ".dataPage",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: "#pageContent",
	    // where to insert our div
	    anchor: ".dataPage"
	  },
	  style: {
	    class: 'sidebarSurvey'
	  },
	  include_free_response: true,
	  select_multiple: false
	}), _defineProperty(_CONFIG, IMPROVE_QUIZ, {
	  description: null,
	  layout: LAYOUTS.SIDEBAR_SURVEY,
	  trigger: {
	    paths: ["data", "quizzes"],
	    // what we are looking for
	    class: ".editControls",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: "#pageContent",
	    // where to insert our div
	    anchor: ".dataPage",
	    // if present, survey doesn't move with page scroll
	    absolute_anchor: '.controlModeEdit'
	  },
	  style: {
	    class: 'sidebarSurvey'
	  },
	  include_free_response: true,
	  select_multiple: true
	}), _defineProperty(_CONFIG, QUIZ_ACCURACY, {
	  description: "pick one answer",
	  layout: LAYOUTS.SIDEBAR_SURVEY,
	  trigger: {
	    paths: ["data"],
	    // what we are looking for
	    class: ".dataPage",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: "#pageContent",
	    // where to insert our div
	    anchor: ".dataPage"
	  },
	  style: {
	    class: 'sidebarSurvey'
	  },
	  include_free_response: false,
	  select_multiple: false
	}), _defineProperty(_CONFIG, READ_BOOK, {
	  description: null,
	  layout: LAYOUTS.EMBEDED_CONTENT,
	  trigger: {
	    paths: ["data", 'quizzes'],
	    // what we are looking for
	    class: ".passDisplay",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: ".quizDisplay",
	    // where to insert our div
	    anchor: ".topRow"
	  },
	  style: {
	    class: 'contentSurvey twoRows',
	    circle_animation: true
	  },
	  include_free_response: false,
	  select_multiple: false
	}), _defineProperty(_CONFIG, SCORING_QUIZ_WRITTEN_RESPONSE, {
	  description: null,
	  layout: LAYOUTS.SIDEBAR_SURVEY,
	  trigger: {
	    paths: ["data", "quizzes"],
	    // what we are looking for
	    class: ".answerScoringDetails",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: "#pageContent",
	    // where to insert our div
	    anchor: ".dataPage",
	    // if present, survey doesn't move with page scroll
	    absolute_anchor: '.controlModeAnalysis'
	  },
	  style: {
	    class: 'sidebarSurvey'
	  },
	  include_free_response: true,
	  select_multiple: true
	}), _defineProperty(_CONFIG, IMPROVE_AUTOGRADER, {
	  description: null,
	  layout: LAYOUTS.EMBEDED_CONTENT,
	  trigger: {
	    paths: ["home"],
	    // what we are looking for
	    class: ".rubricTableContainer",
	    exclude_classes: []
	  },
	  location: {
	    // parent that should hold our new div
	    parent: ".answerFeedbackContainer",
	    // where to insert our div
	    anchor: ".rubricTableContainer"
	  },
	  style: {
	    class: 'contentSurvey twoRows',
	    circle_animation: true
	  },
	  include_free_response: false,
	  select_multiple: false,
	  explain_answer: ['No']
	}), _CONFIG);
	
	var VALID_KEYS = exports.VALID_KEYS = _.keys(CONFIG);
	
	var PROMPT_SESSION_KEY = exports.PROMPT_SESSION_KEY = 'prompt_id';
	
	function getDataPacket(newID, prompt) {
	  var el = document.getElementById(newID);
	
	  switch (prompt.key) {
	    case this.FAILED_QUIZ:
	    case this.QUIZ_FLAG:
	    case this.READ_BOOK:
	      return {
	        'quiz_id': $(el).closest('.quizDisplay').attr("data-quiz-id"),
	        'evaluation_id': $(el).closest('.quizDisplay').attr("data-evaluation-id")
	      };
	    case this.IMPROVE_QUIZ:
	    case this.SCORING_QUIZ_WRITTEN_RESPONSE:
	      return {
	        'quiz_id': $("" + prompt.location.absolute_anchor).attr("data-quiz-id"),
	        'evaluation_id': $("" + prompt.location.absolute_anchor).attr("data-evaluation-id")
	      };
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _crossFetch = __webpack_require__(184);
	
	var _crossFetch2 = _interopRequireDefault(_crossFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrentUser = __webpack_require__(3);
	
	
	var AutograderFeedback = {
	
		preProcess: function preProcess(submitAnswerData) {
			var preProcessing = {};
			//ALPHA RATIO - Amount of alpha characters versus 
			var alphaChars = submitAnswerData["answer"].match(/[a-zA-Z]/g);
			if (alphaChars != null) {
				var alphaRatio = alphaChars.length / submitAnswerData["answer"].replace(/\s/g, "").length;;
			} else {
				var alphaRatio = 0;
			}
			preProcessing["alpha_ratio"] = alphaRatio;
	
			return preProcessing;
		},
	
		getHost: function getHost() {
			if ($wr.isStaging() || !$wr.checkCustomEnv("local-alexandria")) {
				return "https://alex4.whooosreading.org";
			} else if ($wr.isProduction() || !$wr.checkCustomEnv("local-alexandria")) {
				return "https://alex5.whooosreading.org";
			} else {
				return "https://alex5-staging.whooosreading.org";
				// return "http://localhost:3007";		
			}
		},
		getFitbApiHost: function getFitbApiHost() {
			if ($wr.isStaging()) {
				return "https://yoo2zmt9qf.execute-api.us-east-1.amazonaws.com/Staging";
			} else if ($wr.isProduction()) {
				return "https://grading.whooosreading.org";
			} else {
				return "https://yoo2zmt9qf.execute-api.us-east-1.amazonaws.com/Staging";
			}
		},
		requestOps: function requestOps(bodyData) {
			return {
				method: "POST",
				mode: "cors", // no-cors, cors, *same-origin
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				credentials: "same-origin", // include, *same-origin, omit
				headers: {
					"Content-Type": "application/json; charset=utf-8"
				},
				redirect: "follow", // manual, *follow, error
				referrer: "no-referrer", // no-referrer, *client
				body: JSON.stringify(bodyData)
			};
		},
	
	
		fetch: function fetch(answerData, callback) {
			if (answerData.quiz) {
				var quiz = answerData.quiz;
			} else {
				var quiz = false;
			}
			var currentUserData = CurrentUser.get();
	
			var gradeLevel = currentUserData.prefs.academic_level;
			var gradeLevel = answerData.gradeLevel ? answerData.gradeLevel : currentUserData.prefs.academic_level;
			var studentID = currentUserData.id;
			var studentFirstName = currentUserData.first_name;
	
			if (answerData.sentenceStarterText) {
				var fullAnswerText = answerData.sentenceStarterText + " " + answerData.answer;
			} else {
				var fullAnswerText = answerData.answer;
			}
	
			var submitAnswerData = {
				answer: fullAnswerText.trim(), question_text: answerData.questionText,
				answer_parts: answerData.answerParts, starters: answerData.starters,
				question_key: answerData.questionKey,
				grade: gradeLevel, student_id: studentID,
				quiz: quiz, paste_detected: answerData.pasteDetected, duration: answerData.duration
			};
	
			if (answerData.forward) {
				submitAnswerData["forward"] = answerData.forward;
			}
	
			if (answerData.text) {
				submitAnswerData.text_id = answerData.text.text_id;
			}
	
			submitAnswerData["pre_processing"] = AutograderFeedback.preProcess(submitAnswerData);
	
			// var autograderPath = answerData.gradeDemo ? this.getHost() + "/api/v5/grade_demo" : this.getHost() + "/api/v5/grade?which=all"; // UNCOMMENT POST MIGRATION
			var autograderPath = answerData.gradeDemo ? this.getHost() + "/api/v4/grade_demo" : this.getHost() + "/api/v4/grade?which=all";
			var request = this.requestOps(submitAnswerData);
	
			(0, _crossFetch2.default)(autograderPath, request).then(function (res) {
				if (res.status >= 400) {
					throw new Error("Bad response from server");
				}
				return res.json();
			}).then(function (response) {
				// $wr.postJSON(autograderPath, submitAnswerData, function(response) {
				// var autograderData = response.content;
				var autograderData = response.content;
				// var newContext = AutograderFeedback.updateContext(autograderContext, response.evaluation);
	
				var feedback = autograderData.assisting;
	
				if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
					var feedbackSubs = {
						firstName: CurrentUser.get().first_name,
						textVariety: answerData.text.text_variety,
						bookTitle: answerData.text.title
					};
	
					var autograderData = _.extend({}, autograderData, {
						feedback_subs: feedbackSubs
					});
	
					callback({ autograderData: autograderData });
				} else {
					callback({ noFeedback: true, autograderData: autograderData });
				}
			}, function () {
				console.error("Failed to get immediate feedback. Falling back to normal submit.");
				callback({ noFeedback: true, autograderData: undefined });
			}.bind(this));
		},
	
		fetchFuzzyMatch: function fetchFuzzyMatch(answerData, callback) {
	
			answerData["grade"] = CurrentUser.get().prefs.academic_level;
			// var matchPath = this.getFitbApiHost() + "/api/v1.0/fuzzy_match"; // UNCOMMENT POST MIGRATION
			var matchPath = this.getHost() + "/api/v4/fuzzy_match";
			var request = this.requestOps(answerData);
	
			(0, _crossFetch2.default)(matchPath, request).then(function (res) {
				if (res.status >= 400) {
					throw new Error("Bad response from server");
				}
				return res.json();
			}).then(function (response) {
				callback({ noFeedback: true, autograderData: response.content });
			}, function () {
				console.error("Failed to get immediate matching. Falling back to normal submit.");
				callback({ noFeedback: true, autograderData: undefined });
			});
		},
	
		fetchQuestionBuilder: function fetchQuestionBuilder(answerData, callback) {
	
			var currentUserData = CurrentUser.get();
	
			var gradeLevel = currentUserData.prefs.academic_level;
	
			var fullAnswerText = answerData.answer;
	
			var submitAnswerData = {
				answer: fullAnswerText, question_text: "What is your favorite character?",
				grade: gradeLevel
			};
	
			if (answerData.text) {
				submitAnswerData.text_id = answerData.text.text_id;
			}
	
			submitAnswerData.question_builder = true;
			// var autograderPath = this.getHost() + "/api/v5/grade?which=all"; // UNCOMMENT POST MIGRATION
			var autograderPath = this.getHost() + "/api/v4/grade_question_builder?which=all";
			var request = this.requestOps(submitAnswerData);
	
			(0, _crossFetch2.default)(autograderPath, request).then(function (res) {
				if (res.status >= 400) {
					throw new Error("Bad response from server");
				}
				return res.json();
			}).then(function (response) {
	
				var autograderData = response.content;
	
				var feedback = autograderData.assisting;
	
				if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
					var feedbackSubs = {
						firstName: CurrentUser.get().first_name,
						textVariety: answerData.text.text_variety,
						bookTitle: answerData.text.title
					};
	
					var autograderData = _.extend({}, autograderData, {
						feedback_subs: feedbackSubs
					});
	
					callback({ autograderData: autograderData });
				} else {
					callback({ noFeedback: true, autograderData: autograderData });
				}
			}, function () {
				console.error("Failed to get immediate feedback. Falling back to normal submit.");
				callback({ noFeedback: true, autograderData: undefined });
			}.bind(this));
		}
	
	};
	
	module.exports = AutograderFeedback;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	
	var DocumentClient = {
	
		buildOpenF: function buildOpenF(fullPath, effectiveUserID) {
			return function (e) {
				if (e) {
					e.preventDefault();
				}
				DocumentClient.open(fullPath, effectiveUserID);
			};
		},
	
		open: function open(fullPath, effectiveUserID) {
			var url = WhooosReadingServices.Documents.url(fullPath);
			var params = { url: url };
			if (effectiveUserID) {
				params["effective_user_id"] = effectiveUserID;
			}
			CurrentUser.api().getDocRequest(params, $wr.apiHandler(function (response) {
				var joinChar = url.indexOf("?") > 0 ? "&" : "?";
				var tokenURL = url + joinChar + "token=" + response.token;
	
				var newWindow = window.open(tokenURL);
				if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
					if ($wr.isSafari()) {
						window.location = tokenURL;
					} else {
						window.wrNotifications.triggerDropDownNotification({
							title: "Enable popups",
							text: "To view this document, enable popups for whooosreading.org",
							icon: "exclamation-sign" }, 4000);
					}
				}
			}.bind(this)));
		}
	
	};
	
	module.exports = DocumentClient;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CONFIG;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var QUIZ_WIDGET = exports.QUIZ_WIDGET = "quiz_widget";
	var GOALS_WIDGET = exports.GOALS_WIDGET = "goals_widget";
	var BOOK_WIDGET = exports.BOOK_WIDGET = "book_widget";
	var WRITING_WIDGET = exports.WRITING_WIDGET = "writing_widget";
	
	// METRICS AND LOOKUP KEYS
	var TOTAL_QUIZZES = exports.TOTAL_QUIZZES = 'total_quizzes';
	var FAILED_QUIZZES = exports.FAILED_QUIZZES = 'failed_quizzes';
	var FLAGGED_QUIZZES = exports.FLAGGED_QUIZZES = 'flagged_quizzes';
	var GOALS_COMPLETE = exports.GOALS_COMPLETE = 'students_complete';
	var GOALS_ON_PACE = exports.GOALS_ON_PACE = 'students_on_pace';
	var GOALS_BEHIND = exports.GOALS_BEHIND = 'students_behind';
	var AVERAGE_LEXILE_LEVEL = exports.AVERAGE_LEXILE_LEVEL = 'average_lexile_level';
	var MINUTES_LOGGED = exports.MINUTES_LOGGED = 'minutes_logged';
	var TOTAL_BOOKS = exports.TOTAL_BOOKS = 'uniq_book_count';
	var FLAGGED_BOOKS = exports.FLAGGED_BOOKS = 'flagged_books';
	var TOTAL_PRACTICE_QUESTIONS = exports.TOTAL_PRACTICE_QUESTIONS = 'total_practice_questions';
	var TOTAL_QUESTION_BUILDERS = exports.TOTAL_QUESTION_BUILDERS = 'total_question_builders';
	var TOTAL_REVIEWS = exports.TOTAL_REVIEWS = 'total_reviews';
	var EXCERCISES_COMPLETED = exports.EXCERCISES_COMPLETED = 'excercises_completed';
	var AVERAGE_QUIZ_SCORE = exports.AVERAGE_QUIZ_SCORE = 'average_quiz_score';
	
	// UNIQUE LOOKUP KEYS
	var NEW_QUIZZES = exports.NEW_QUIZZES = 'new_quizzes';
	var YEARLY_TOTAL_QUIZZES = exports.YEARLY_TOTAL_QUIZZES = 'yearly_total_quizzes';
	var QUIZZES_PASSED_GOAL = exports.QUIZZES_PASSED_GOAL = 'quizzes-passed_goal';
	var QUESTIONS_GOAL = exports.QUESTIONS_GOAL = 'questions_goal';
	var REVIEWS_GOAL = exports.REVIEWS_GOAL = 'reviews_goal';
	var EXERCISES_GOAL = exports.EXERCISES_GOAL = 'exercises_goal';
	var MINUTES_GOAL = exports.MINUTES_GOAL = 'minutes_goal';
	var DAYS_ACTIVE_GOAL = exports.DAYS_ACTIVE_GOAL = 'days-active_goal';
	var PAGES_GOAL = exports.PAGES_GOAL = 'pages_goal';
	var QUESTION_BUILDERS_GOAL = exports.QUESTION_BUILDERS_GOAL = 'question-builder_goal';
	
	// SECONDARY METRICS
	var TIME_PERIOD = exports.TIME_PERIOD = 'time_period';
	
	// USER TYPES
	var STUDENT = 'Student';
	var ADMIN = 'Admin';
	
	var CONFIG = exports.CONFIG = (_CONFIG = {}, _defineProperty(_CONFIG, ADMIN, [{
	  font_color: 'green',
	  icon: 'confetti',
	  title: 'New Quizzes',
	  singular_title: 'New Quiz',
	  primary_metric: TOTAL_QUIZZES,
	  lookup_key: NEW_QUIZZES,
	  current_metric: true,
	  secondary_metric: TIME_PERIOD,
	  link: {
	    text: 'View',
	    build_link: true,
	    base: '/data/everyone/quizzes?order=completed_at_desc&list=everyone'
	  }
	}, {
	  font_color: 'red',
	  icon: 'cancel',
	  title: 'Failed Quizzes',
	  singular_title: 'Failed Quiz',
	  primary_metric: FAILED_QUIZZES,
	  lookup_key: FAILED_QUIZZES,
	  secondary_metric: TIME_PERIOD,
	  link: {
	    text: 'View',
	    build_link: true,
	    base: '/data/everyone/quizzes?status=failed&order=completed_at_desc&student_list=everyone'
	  }
	}, {
	  font_color: 'red',
	  icon: 'flag',
	  title: 'Flagged Quizzes',
	  singular_title: 'Flagged Quiz',
	  primary_metric: FLAGGED_QUIZZES,
	  lookup_key: FLAGGED_QUIZZES,
	  secondary_metric: TIME_PERIOD,
	  link: {
	    text: 'View',
	    build_link: true,
	    base: '/data/everyone/quizzes?status=flagged&order=completed_at_desc&student_list=everyone'
	  }
	}, {
	  icon: 'rising',
	  title: 'Total Quizzes',
	  singular_title: 'Total Quiz',
	  primary_metric: TOTAL_QUIZZES,
	  lookup_key: YEARLY_TOTAL_QUIZZES,
	  yearly_metric: true,
	  secondary_metric: TIME_PERIOD,
	  link: {
	    text: 'View',
	    build_link: true,
	    base: '/data/everyone/quizzes?order=completed_at_desc&student_list=everyone'
	  }
	}, {
	  icon: 'rising',
	  title: 'Total Quizzes',
	  singular_title: 'Total Quiz',
	  primary_metric: 'total_quizzes',
	  lookup_key: 'total_quizzes'
	}, {
	  font_color: 'green',
	  icon: 'target',
	  title: 'students have completed all goals',
	  singular_title: 'student has completed all goals',
	  primary_metric: GOALS_COMPLETE,
	  lookup_key: GOALS_COMPLETE
	}, {
	  font_color: 'yellow',
	  icon: 'gear',
	  title: 'student(s) are on pace to complete all goals',
	  singular_title: 'student is on pace to complete all goals',
	  primary_metric: GOALS_ON_PACE,
	  lookup_key: GOALS_ON_PACE
	}, {
	  font_color: 'red',
	  icon: 'slow',
	  title: 'student(s) are behind on completing all goals',
	  singular_title: 'student is behind on completing all goals',
	  primary_metric: GOALS_BEHIND,
	  lookup_key: GOALS_BEHIND
	}, {
	  icon: 'gauge',
	  title: 'Average Lexile',
	  singular_title: 'Average Lexile',
	  primary_metric: AVERAGE_LEXILE_LEVEL,
	  lookup_key: AVERAGE_LEXILE_LEVEL,
	  link: {
	    text: 'View',
	    location: '/data/everyone/books?student_list=everyone'
	  }
	}, {
	  icon: 'clock',
	  title: 'Mins Logged',
	  singular_title: 'Min Logged',
	  primary_metric: MINUTES_LOGGED,
	  lookup_key: MINUTES_LOGGED,
	  link: {
	    text: 'View Logs',
	    location: '/data/everyone/reading_logs?student_list=everyone'
	  }
	}, {
	  font_color: 'green',
	  icon: 'books',
	  title: 'Total Books',
	  singular_title: 'Total Book',
	  primary_metric: TOTAL_BOOKS,
	  lookup_key: TOTAL_BOOKS,
	  yearly_metric: true,
	  link: {
	    text: 'View',
	    location: '/data/everyone/books?student_list=everyone'
	  }
	}, {
	  font_color: 'red',
	  icon: 'flag',
	  title: 'Books Flagged As Not Read',
	  singular_title: 'Book Flagged As Not Read',
	  primary_metric: FLAGGED_BOOKS,
	  lookup_key: FLAGGED_BOOKS,
	  link: {
	    text: 'View',
	    location: '/data/everyone/books?read_book=no'
	  }
	}, {
	  icon: 'question-and-answer',
	  title: 'Questions',
	  singular_title: 'Question',
	  primary_metric: TOTAL_PRACTICE_QUESTIONS,
	  lookup_key: TOTAL_PRACTICE_QUESTIONS,
	  link: {
	    text: 'View',
	    location: '/data/everyone/practice_questions?student_list=everyone'
	  }
	}, {
	  icon: 'star',
	  title: 'Reviews',
	  singular_title: 'Review',
	  primary_metric: TOTAL_REVIEWS,
	  lookup_key: TOTAL_REVIEWS,
	  link: {
	    text: 'View',
	    location: '/data/everyone/reviews?student_list=everyone'
	  }
	}, {
	  icon: 'pencil',
	  title: 'Exercises',
	  singular_title: 'Exercise',
	  primary_metric: EXCERCISES_COMPLETED,
	  lookup_key: EXCERCISES_COMPLETED,
	  link: {
	    text: 'View',
	    location: '/data/everyone/activities?student_list=everyone'
	  }
	}, {
	  icon: 'blocks',
	  title: 'Question Builders',
	  singular_title: 'Question Builder',
	  primary_metric: TOTAL_QUESTION_BUILDERS,
	  lookup_key: TOTAL_QUESTION_BUILDERS,
	  link: {
	    text: 'View',
	    location: '/data/everyone/question_builders?student_list=everyone'
	  }
	}]), _defineProperty(_CONFIG, STUDENT, [{
	  icon: 'gauge',
	  title: 'Avg Quiz Score',
	  singular_title: 'Avg Quiz Score',
	  primary_metric: AVERAGE_QUIZ_SCORE,
	  lookup_key: AVERAGE_QUIZ_SCORE,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'quizzes'
	  }
	}, {
	  icon: 'cancel',
	  title: 'Failed Quizzes',
	  singular_title: 'Failed Quiz',
	  primary_metric: FAILED_QUIZZES,
	  lookup_key: FAILED_QUIZZES,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: ['status=failed'],
	    subject: 'quizzes'
	  }
	}, {
	  icon: 'flag',
	  title: 'Flagged Quizzes',
	  singular_title: 'Flagged Quiz',
	  primary_metric: FLAGGED_QUIZZES,
	  lookup_key: FLAGGED_QUIZZES,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: ['status=flagged'],
	    subject: 'quizzes'
	  }
	}, {
	  icon: 'rising',
	  title: 'Total Quizzes',
	  singular_title: 'Total Quiz',
	  primary_metric: TOTAL_QUIZZES,
	  lookup_key: TOTAL_QUIZZES,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'quizzes'
	  }
	}, {
	  icon: 'gauge',
	  title: 'Average Lexile',
	  singular_title: 'Average Lexile',
	  primary_metric: AVERAGE_LEXILE_LEVEL,
	  lookup_key: AVERAGE_LEXILE_LEVEL,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'books'
	  }
	}, {
	  icon: 'clock',
	  title: 'Mins Logged',
	  singular_title: 'Min Logged',
	  primary_metric: MINUTES_LOGGED,
	  lookup_key: MINUTES_LOGGED,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'reading_logs'
	  }
	}, {
	  font_color: 'green',
	  icon: 'books',
	  title: 'Total Books',
	  singular_title: 'Total Book',
	  primary_metric: TOTAL_BOOKS,
	  lookup_key: TOTAL_BOOKS,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'books'
	  }
	}, {
	  font_color: 'red',
	  icon: 'flag',
	  title: 'Books Flagged As Not Read',
	  singular_title: 'Book Flagged As Not Read',
	  primary_metric: FLAGGED_BOOKS,
	  lookup_key: FLAGGED_BOOKS,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: ['status=flagged'],
	    subject: 'books'
	  }
	}, {
	  icon: 'gear',
	  title: 'quiz goals complete',
	  singular_title: 'quiz goal complete',
	  lookup_key: QUIZZES_PASSED_GOAL,
	  show_comparison: true,
	  link: {
	    text: 'View Quizzes',
	    filters: [],
	    subject: 'quizzes'
	  }
	}, {
	  icon: 'pencil',
	  title: 'question goals complete',
	  singular_title: 'question goal complete',
	  lookup_key: QUESTIONS_GOAL,
	  link: {
	    text: 'View Questions',
	    filters: [],
	    subject: 'practice_questions'
	  }
	}, {
	  icon: 'star',
	  title: 'review goals complete',
	  singular_title: 'review goal complete',
	  lookup_key: REVIEWS_GOAL,
	  link: {
	    text: 'View Reviews',
	    filters: [],
	    subject: 'reviews'
	  }
	}, {
	  icon: 'blocks',
	  title: 'question builder goals complete',
	  singular_title: 'question builder goal complete',
	  lookup_key: QUESTION_BUILDERS_GOAL,
	  link: {
	    text: 'View Quest. Builders',
	    filters: [],
	    subject: 'question_builders'
	  }
	}, {
	  icon: 'pencil',
	  title: 'exercise goals complete',
	  singular_title: 'exercise goal complete',
	  lookup_key: EXERCISES_GOAL,
	  link: {
	    text: 'View Exercises',
	    filters: [],
	    subject: 'activities'
	  }
	}, {
	  icon: 'clock',
	  title: 'minutes logged',
	  singular_title: 'minute logged',
	  lookup_key: MINUTES_GOAL,
	  link: {
	    text: 'View Reading Logs',
	    filters: [],
	    subject: 'reading_logs'
	  }
	}, {
	  icon: 'clock',
	  title: 'days active',
	  singular_title: 'day active',
	  lookup_key: DAYS_ACTIVE_GOAL
	}, {
	  icon: 'clock',
	  title: 'pages read',
	  singular_title: 'page read',
	  lookup_key: PAGES_GOAL,
	  link: {
	    text: 'View Reading Logs',
	    filters: [],
	    subject: 'reading_logs'
	  }
	}, {
	  icon: 'question-and-answer',
	  title: 'Questions',
	  singular_title: 'Question',
	  primary_metric: TOTAL_PRACTICE_QUESTIONS,
	  lookup_key: TOTAL_PRACTICE_QUESTIONS,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'practice_questions'
	  }
	}, {
	  icon: 'star',
	  title: 'Reviews',
	  singular_title: 'Review',
	  primary_metric: TOTAL_REVIEWS,
	  lookup_key: TOTAL_REVIEWS,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'reviews'
	  }
	}, {
	  icon: 'pencil',
	  title: 'Exercises',
	  singular_title: 'Exercise',
	  primary_metric: EXCERCISES_COMPLETED,
	  lookup_key: EXCERCISES_COMPLETED,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'activities'
	  }
	}, {
	  icon: 'blocks',
	  title: 'Question Builders',
	  singular_title: 'Question Builder',
	  primary_metric: TOTAL_QUESTION_BUILDERS,
	  lookup_key: TOTAL_QUESTION_BUILDERS,
	  show_comparison: true,
	  link: {
	    text: 'View',
	    filters: [],
	    subject: 'question_builders'
	  }
	}]), _CONFIG);
	
	// DIGEST METRICS //
	// this should be replaced by customized
	// metrics metric order in user prefs
	var districtAdminDigestMetrics = exports.districtAdminDigestMetrics = [_defineProperty({}, QUIZ_WIDGET, [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES]), _defineProperty({}, BOOK_WIDGET, [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS]), _defineProperty({}, WRITING_WIDGET, [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS]), _defineProperty({}, GOALS_WIDGET, [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND])];
	
	var schoolAdminDigestMetrics = exports.schoolAdminDigestMetrics = [_defineProperty({}, QUIZ_WIDGET, [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES]), _defineProperty({}, BOOK_WIDGET, [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS]), _defineProperty({}, WRITING_WIDGET, [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS]), _defineProperty({}, GOALS_WIDGET, [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND])];
	
	var teacherDigestMetrics = exports.teacherDigestMetrics = [_defineProperty({}, QUIZ_WIDGET, [NEW_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, YEARLY_TOTAL_QUIZZES]), _defineProperty({}, BOOK_WIDGET, [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS]), _defineProperty({}, WRITING_WIDGET, [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS]), _defineProperty({}, GOALS_WIDGET, [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND])];
	
	var studentDigestMetrics = exports.studentDigestMetrics = [_defineProperty({}, QUIZ_WIDGET, [AVERAGE_QUIZ_SCORE, TOTAL_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES]), _defineProperty({}, BOOK_WIDGET, [AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS]), _defineProperty({}, WRITING_WIDGET, [TOTAL_PRACTICE_QUESTIONS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, TOTAL_QUESTION_BUILDERS]), _defineProperty({}, GOALS_WIDGET, [GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND])];
	
	var SPECIAL_RENDERING = exports.SPECIAL_RENDERING = [AVERAGE_LEXILE_LEVEL, AVERAGE_QUIZ_SCORE, MINUTES_LOGGED];
	var SUCCESS_BELOW_COMP = exports.SUCCESS_BELOW_COMP = [FAILED_QUIZZES, FLAGGED_QUIZZES, FLAGGED_BOOKS];
	var AVERAGE_METRICS = exports.AVERAGE_METRICS = [AVERAGE_LEXILE_LEVEL, AVERAGE_QUIZ_SCORE];
	var GOAL_METRICS = exports.GOAL_METRICS = [QUIZZES_PASSED_GOAL, QUESTIONS_GOAL, REVIEWS_GOAL, EXERCISES_GOAL, MINUTES_GOAL, DAYS_ACTIVE_GOAL, PAGES_GOAL, QUESTION_BUILDERS_GOAL];
	var NON_GOAL_METRICS = exports.NON_GOAL_METRICS = [TOTAL_QUIZZES, FAILED_QUIZZES, FLAGGED_QUIZZES, GOALS_COMPLETE, GOALS_ON_PACE, GOALS_BEHIND, AVERAGE_LEXILE_LEVEL, MINUTES_LOGGED, TOTAL_BOOKS, FLAGGED_BOOKS, TOTAL_PRACTICE_QUESTIONS, TOTAL_QUESTION_BUILDERS, TOTAL_REVIEWS, EXCERCISES_COMPLETED, AVERAGE_QUIZ_SCORE];
	
	var GOAL_TO_WIDGET_KEY = exports.GOAL_TO_WIDGET_KEY = {
	  'answers_count': QUESTIONS_GOAL,
	  'quiz_passed_count': QUIZZES_PASSED_GOAL,
	  'reviews_count': REVIEWS_GOAL,
	  'days_active': DAYS_ACTIVE_GOAL,
	  'responses_count': EXERCISES_GOAL,
	  'minutes_read': MINUTES_GOAL,
	  'question_builder_count': QUESTION_BUILDERS_GOAL,
	  'pages_read': PAGES_GOAL
	};

/***/ }),
/* 261 */
[3926, 1027, 1028],
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(216)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(133);
	var toLength = __webpack_require__(39);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1042);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(47);
	var createDesc = __webpack_require__(130);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	var document = __webpack_require__(28).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(37)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(28).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	var setPrototypeOf = __webpack_require__(279).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(146);
	var ITERATOR = __webpack_require__(37)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(127);
	var descriptor = __webpack_require__(130);
	var setToStringTag = __webpack_require__(147);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(60)(IteratorPrototype, __webpack_require__(37)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(112);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(61);
	var hide = __webpack_require__(60);
	var Iterators = __webpack_require__(146);
	var $iterCreate = __webpack_require__(272);
	var setToStringTag = __webpack_require__(147);
	var getPrototypeOf = __webpack_require__(69);
	var ITERATOR = __webpack_require__(37)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var macrotask = __webpack_require__(284).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(75)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(56);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(179);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(32);
	var anObject = __webpack_require__(22);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(77)(Function.call, __webpack_require__(68).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(182)('keys');
	var uid = __webpack_require__(134);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(209);
	var defined = __webpack_require__(85);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(79);
	var defined = __webpack_require__(85);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(77);
	var invoke = __webpack_require__(457);
	var html = __webpack_require__(269);
	var cel = __webpack_require__(266);
	var global = __webpack_require__(28);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(75)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(28);
	var DESCRIPTORS = __webpack_require__(42);
	var LIBRARY = __webpack_require__(112);
	var $typed = __webpack_require__(217);
	var hide = __webpack_require__(60);
	var redefineAll = __webpack_require__(131);
	var fails = __webpack_require__(30);
	var anInstance = __webpack_require__(125);
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(39);
	var toIndex = __webpack_require__(476);
	var gOPN = __webpack_require__(128).f;
	var dP = __webpack_require__(47).f;
	var arrayFill = __webpack_require__(263);
	var setToStringTag = __webpack_require__(147);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var core = __webpack_require__(76);
	var LIBRARY = __webpack_require__(112);
	var wksExt = __webpack_require__(477);
	var defineProperty = __webpack_require__(47).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(145);
	var ITERATOR = __webpack_require__(37)('iterator');
	var Iterators = __webpack_require__(146);
	module.exports = __webpack_require__(76).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(111);
	var step = __webpack_require__(460);
	var Iterators = __webpack_require__(146);
	var toIObject = __webpack_require__(70);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(273)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a91b21205d13443a5386c408739ee0af.png";

/***/ }),
/* 291 */
220,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "02242164817143381123f859e7a75a1d.png";

/***/ }),
/* 293 */
187,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c533adfe868b5419775a10b0498a3fe.png";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "926d9a3ba2fec1fa4e80843fc5fda7d2.png";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8822f182865946f8ece287fd5d05e315.png";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ead19bf7ffe51d0b703e0734a753605.png";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf01775c3af2e21ec62602e2ce06a36c.png";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e72b64e90440dd1a6793226d56318dff.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef4be122809f5f675d3ac84d0f310fac.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "db8b91e9721b141cf43250fef6074ef1.png";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e83c7cc69bd58b32ab24dbddb592736d.png";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ae402c33f9d6deffb418f76944e77d2.png";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9fa19396cf57252e7c202f511099fddd.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3edc4148e425d91dfb38e4eddf71bd6.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4588117b5eb29f707881089c2f9fb415.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c95431d040e853ddba32ef0c6a82f893.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87da19f4366ed83e131ea37bdc85d777.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c7b5ecfde5f9fa036d0877dea63495e.png";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "851e5eb4eb749e5d0379cb6c03115cfd.png";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4993d043b44ff8f0cbb8a367cc73ed5.png";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f8efd1031d75d9be3e2ca123ebde24e.png";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ffd9c8a66d629e3632ed59ba4f41b24.png";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "998d9bd9eef09cada092c915ae67bdd9.png";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "197a2d6f6cdaa1149609095f6357d293.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4cf1f4f2c7aa3a8f12c48310a852616.png";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0584401d7384877e7c08b2b82fd5530b.png";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "431dc1859f63e3aa91f0b9d27998a95d.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "03eedc7f78b90b26632423f0b14ad690.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "485fa66ed5fe1be6fbbc8ed4fe2d6ba6.png";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18b6d70af229391cff3a29ced065f3b.png";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8aaf3d7cd7759454d2128f984efd8d1.png";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "91b5f5c663efb791780934a10f3d8f98.png";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8962f837935c4bc55a5295a8b9b5edb6.png";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9e2285c8b7e8e2199bad12246a7b2414.png";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cdc5af2b90406cfc7a2a8d562e6ce39c.png";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4229afe68d4ea62df38751376fa39f2f.png";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe31fc4c9f3d9a9eb3934fefed83ee33.png";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe03dfa5f96a083eede69343e32bff95.png";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2471916aa196e9f734c868c0ef90c0eb.png";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e2677724fa78516d4ad78c276c96831d.png";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1bf56c531701f693f99ae590862d838d.png";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d73279821b2772d3f113b40ed2065313.png";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "358beb189467d07bb2777b07e81bfac7.png";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d9226ae086912ab446526f2cdb880d0.png";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6fc8b72661870ad3945ca82a026c78fd.png";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "492858ba6dc41efb95c0a4ffd0e752a8.png";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3b29f7b6b4491776239485f9de3c485f.png";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "40e9790328d4f312157f41b7ffa611ae.png";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	( function( window, factory ) {
	  /* jshint strict: false */ /* globals define, module */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	
	})( window, function factory() {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') == -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console == 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	var measurementsLength = measurements.length;
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	// -------------------------- getStyle -------------------------- //
	
	/**
	 * getStyle, get style of element, check for Firefox bug
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function getStyle( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    logError( 'Style returned ' + style +
	      '. Are you running this code in a hidden iframe on Firefox? ' +
	      'See https://bit.ly/getsizebug1' );
	  }
	  return style;
	}
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var isBoxSizeOuter;
	
	/**
	 * setup
	 * check isBoxSizerOuter
	 * do on first getSize() rather than on page load for Firefox bug
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  // -------------------------- box sizing -------------------------- //
	
	  /**
	   * Chrome & Safari measure the outer-width on style.width on border-box elems
	   * IE11 & Firefox<29 measures the inner-width
	   */
	  var div = document.createElement('div');
	  div.style.width = '200px';
	  div.style.padding = '1px 2px 3px 4px';
	  div.style.borderStyle = 'solid';
	  div.style.borderWidth = '1px 2px 3px 4px';
	  div.style.boxSizing = 'border-box';
	
	  var body = document.body || document.documentElement;
	  body.appendChild( div );
	  var style = getStyle( div );
	  // round value for browser zoom. desandro/masonry#928
	  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
	  getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	  body.removeChild( div );
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display == 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	  // get all measurements
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	return getSize;
	
	});


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(3576);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(624);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3578);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSubscription = createSubscription;
	
	var _batch = __webpack_require__(632);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var nullListeners = {
	  notify: function notify() {},
	  get: function get() {
	    return [];
	  }
	};
	
	function createSubscription(store, parentSub) {
	  var unsubscribe;
	  var listeners = nullListeners;
	
	  function addNestedSub(listener) {
	    trySubscribe();
	    return listeners.subscribe(listener);
	  }
	
	  function notifyNestedSubs() {
	    listeners.notify();
	  }
	
	  function handleChangeWrapper() {
	    if (subscription.onStateChange) {
	      subscription.onStateChange();
	    }
	  }
	
	  function isSubscribed() {
	    return Boolean(unsubscribe);
	  }
	
	  function trySubscribe() {
	    if (!unsubscribe) {
	      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
	      listeners = createListenerCollection();
	    }
	  }
	
	  function tryUnsubscribe() {
	    if (unsubscribe) {
	      unsubscribe();
	      unsubscribe = undefined;
	      listeners.clear();
	      listeners = nullListeners;
	    }
	  }
	
	  var subscription = {
	    addNestedSub: addNestedSub,
	    notifyNestedSubs: notifyNestedSubs,
	    handleChangeWrapper: handleChangeWrapper,
	    isSubscribed: isSubscribed,
	    trySubscribe: trySubscribe,
	    tryUnsubscribe: tryUnsubscribe,
	    getListeners: function getListeners() {
	      return listeners;
	    }
	  };
	  return subscription;
	}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(20);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(642);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(3597);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(204);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1373);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_book_details.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_book_details.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0M1Q0FFOSIgZD0iTTQyIDQySDZWOWwxOC03IDE4IDd6Ii8+PHBhdGggZmlsbD0iIzlGQThEQSIgZD0iTTYgNDJoMzZ2Mkg2eiIvPjxwYXRoIGZpbGw9IiNCRjM2MEMiIGQ9Ik0yMCAzNWg4djloLTh6Ii8+PHBhdGggZD0iTTMxIDI3aDZ2NWgtNnptLTEwIDBoNnY1aC02em0tMTAgMGg2djVoLTZ6bTIwIDhoNnY1aC02em0tMjAgMGg2djVoLTZ6bTIwLTE2aDZ2NWgtNnptLTEwIDBoNnY1aC02em0tMTAgMGg2djVoLTZ6bTIwLThoNnY1aC02em0tMTAgMGg2djVoLTZ6bS0xMCAwaDZ2NWgtNnoiIGZpbGw9IiMxNTY1QzAiLz48L3N2Zz4="

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./barn-house-empty.png": 300,
		"./barn-house.png": 546,
		"./beach-bungalow-empty.png": 301,
		"./beach-bungalow-main.png": 547,
		"./beach-bungalow.png": 548,
		"./bell-tower-empty.png": 302,
		"./bell-tower.png": 549,
		"./chefs-palace-empty.png": 303,
		"./chefs-palace-main.png": 550,
		"./chefs-palace.png": 551,
		"./clowns-cabin-empty.png": 304,
		"./clowns-cabin-main.png": 552,
		"./clowns-cabin.png": 553,
		"./eagles-nest-empty.png": 305,
		"./eagles-nest.png": 554,
		"./festival-yurt-empty.png": 306,
		"./festival-yurt.png": 555,
		"./gamers-paradise-empty.png": 307,
		"./gamers-paradise-main.png": 556,
		"./gamers-paradise.png": 557,
		"./gingerbread-house-empty.png": 308,
		"./gingerbread-house.png": 558,
		"./hawaiian-beach-hut-empty.png": 309,
		"./hawaiian-beach-hut.png": 559,
		"./jam-pad-empty.png": 310,
		"./jam-pad-main.png": 560,
		"./jam-pad.png": 561,
		"./japanese-restaurant-empty.png": 311,
		"./japanese-restaurant.png": 562,
		"./leaning-t-owl-er-of-pisa-empty.png": 312,
		"./leaning-t-owl-er-of-pisa.png": 563,
		"./lighthouse-empty.png": 313,
		"./lighthouse.png": 564,
		"./log-cabin-empty.png": 314,
		"./log-cabin.png": 565,
		"./luxury-apartments-empty.png": 315,
		"./luxury-apartments.png": 566,
		"./medieval-tower-empty.png": 316,
		"./medieval-tower.png": 567,
		"./modern-glass-house-empty.png": 317,
		"./modern-glass-house.png": 568,
		"./modern-mansion-empty.png": 318,
		"./modern-mansion.png": 569,
		"./mongolian-house-empty.png": 319,
		"./mongolian-house.png": 570,
		"./owl-dobe-desert-casa-empty.png": 320,
		"./owl-dobe-desert-casa.png": 571,
		"./owl-ffel-tower-empty.png": 321,
		"./owl-ffel-tower.png": 572,
		"./pirate-hideaway-empty.png": 322,
		"./pirate-hideaway-main.png": 573,
		"./pirate-hideaway.png": 574,
		"./pirate-ship-empty.png": 323,
		"./pirate-ship.png": 575,
		"./purple-hot-air-balloon-empty.png": 324,
		"./purple-hot-air-balloon.png": 576,
		"./rainbow-hot-air-balloon-empty.png": 325,
		"./rainbow-hot-air-balloon.png": 577,
		"./red-hot-air-balloon-empty.png": 326,
		"./red-hot-air-balloon.png": 578,
		"./rocket-ship-empty.png": 327,
		"./rocket-ship.png": 579,
		"./sir-hoots-a-lots-castle-empty.png": 328,
		"./sir-hoots-a-lots-castle.png": 580,
		"./skaters-shack-empty.png": 329,
		"./skaters-shack-main.png": 581,
		"./skaters-shack.png": 582,
		"./space-vision-house-empty.png": 330,
		"./space-vision-house.png": 583,
		"./sports-clubhouse-empty.png": 331,
		"./sports-clubhouse-main.png": 584,
		"./sports-clubhouse.png": 585,
		"./tree-house-empty.png": 332,
		"./tree-house.png": 586,
		"./trophy-room-empty.png": 333,
		"./windmill-empty.png": 334,
		"./windmill.png": 587,
		"./winter-chalet-empty.png": 335,
		"./winter-chalet-main.png": 588,
		"./winter-chalet.png": 589,
		"./wizards-hut-empty.png": 336,
		"./wizards-hut-main.png": 590,
		"./wizards-hut.png": 591
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 354;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./book-1.png": 3401,
		"./book-2.png": 3402,
		"./book-3.png": 3403,
		"./book-4.png": 3404,
		"./book-5.png": 3405,
		"./book-6.png": 3406
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 355;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./blocks.png": 3484,
		"./books-blue.png": 598,
		"./books.png": 3485,
		"./cancel-blue.png": 599,
		"./cancel.png": 3486,
		"./clock-blue.png": 600,
		"./clock.png": 3487,
		"./confetti.png": 3488,
		"./flag-blue.png": 601,
		"./flag.png": 3489,
		"./gauge-blue.png": 602,
		"./gauge.png": 3490,
		"./gear.png": 3491,
		"./lightbulb-blue.png": 603,
		"./lightbulb.png": 3492,
		"./magnifier-white.png": 3493,
		"./open-book-white.png": 3494,
		"./pencil.png": 3495,
		"./question-and-answer.png": 3496,
		"./rising-blue.png": 604,
		"./rising.png": 3497,
		"./settings-gears-white.png": 3498,
		"./slow.png": 3499,
		"./star.png": 3500,
		"./target.png": 3501,
		"./writing-white.png": 3502
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 356;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(227)["default"];
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	  var cache = _getRequireWildcardCache(nodeInterop);
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	  newObj["default"] = obj;
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	  return newObj;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var backend_1 = __webpack_require__(692);
	var helpers_1 = __webpack_require__(157);
	var integrations_1 = __webpack_require__(229);
	var version_1 = __webpack_require__(361);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        return _super.call(this, backend_1.BrowserBackend, options) || this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: version_1.SDK_VERSION,
	                },
	            ]), version: version_1.SDK_VERSION });
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var tracekit_1 = __webpack_require__(230);
	var STACKTRACE_LIMIT = 50;
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromStacktrace(stacktrace) {
	    var frames = prepareFramesForEvent(stacktrace.stack);
	    var exception = {
	        type: stacktrace.name,
	        value: stacktrace.message,
	    };
	    if (frames && frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromStacktrace = exceptionFromStacktrace;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, rejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromStacktrace(stacktrace) {
	    var exception = exceptionFromStacktrace(stacktrace);
	    return {
	        exception: {
	            values: [exception],
	        },
	    };
	}
	exports.eventFromStacktrace = eventFromStacktrace;
	/**
	 * @hidden
	 */
	function prepareFramesForEvent(stack) {
	    if (!stack || !stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].func || '';
	    var lastFrameFunction = localStack[localStack.length - 1].func || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return ({
	        colno: frame.column === null ? undefined : frame.column,
	        filename: frame.url || localStack[0].url,
	        function: frame.func || '?',
	        in_app: true,
	        lineno: frame.line === null ? undefined : frame.line,
	    }); })
	        .reverse();
	}
	exports.prepareFramesForEvent = prepareFramesForEvent;
	//# sourceMappingURL=parsers.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(231);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(701);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(702);
	exports.XHRTransport = xhr_1.XHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_NAME = 'sentry.javascript.browser';
	exports.SDK_VERSION = '5.30.0';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.SyncPromise.resolve({
	            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
	            status: types_1.Status.Skipped,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.SyncPromise.resolve(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifiying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        var _a, _b, _c, _d;
	        // often, this span will be a transaction, but it's not guaranteed to be
	        var span = this.getSpan();
	        // try it the new way first
	        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
	            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
	        }
	        // fallback to the old way (known bug: this only finds transactions with sampled = true)
	        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
	            return span.spanRecorder.spans[0];
	        }
	        // neither way found a transaction
	        return undefined;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs =
	            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
	                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
	                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional informartion about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        var _a;
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relys on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Retruns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
	    var global = utils_1.getGlobalObject();
	    global.__SENTRY__ = global.__SENTRY__ || {};
	    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
	    return global.__SENTRY__.globalEventProcessors;
	    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.timestamp = Date.now();
	        this.started = Date.now();
	        this.duration = 0;
	        this.status = types_1.SessionStatus.Ok;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || Date.now();
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            this.duration = this.timestamp - this.started;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === types_1.SessionStatus.Ok) {
	            this.update({ status: types_1.SessionStatus.Exited });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: true,
	            started: new Date(this.started).toISOString(),
	            timestamp: new Date(this.timestamp).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: utils_1.dropUndefinedKeys({
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            }),
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(114);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push("#" + elem.id);
	    }
	    // eslint-disable-next-line prefer-const
	    className = elem.className;
	    if (className && is_1.isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push("." + classes[i]);
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/**
	 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
	 */
	var Memo = /** @class */ (function () {
	    function Memo() {
	        this._hasWeakSet = typeof WeakSet === 'function';
	        this._inner = this._hasWeakSet ? new WeakSet() : [];
	    }
	    /**
	     * Sets obj to remember.
	     * @param obj Object to remember
	     */
	    Memo.prototype.memoize = function (obj) {
	        if (this._hasWeakSet) {
	            if (this._inner.has(obj)) {
	                return true;
	            }
	            this._inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < this._inner.length; i++) {
	            var value = this._inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        this._inner.push(obj);
	        return false;
	    };
	    /**
	     * Removes object from internal storage.
	     * @param obj Object to forget
	     */
	    Memo.prototype.unmemoize = function (obj) {
	        if (this._hasWeakSet) {
	            this._inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < this._inner.length; i++) {
	                if (this._inner[i] === obj) {
	                    this._inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    return Memo;
	}());
	exports.Memo = Memo;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(233);
	var misc_1 = __webpack_require__(158);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in misc_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = misc_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === "function") {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in misc_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = misc_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(114);
	/** SyncPromise internal states */
	var States;
	(function (States) {
	    /** Pending */
	    States["PENDING"] = "PENDING";
	    /** Resolved / OK */
	    States["RESOLVED"] = "RESOLVED";
	    /** Rejected / Error */
	    States["REJECTED"] = "REJECTED";
	})(States || (States = {}));
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = States.PENDING;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(States.RESOLVED, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(States.REJECTED, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== States.PENDING) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        // TODO: FIXME
	        /** JSDoc */
	        this._attachHandler = function (handler) {
	            _this._handlers = _this._handlers.concat(handler);
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === States.PENDING) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler.done) {
	                    return;
	                }
	                if (_this._state === States.RESOLVED) {
	                    if (handler.onfulfilled) {
	                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                        handler.onfulfilled(_this._value);
	                    }
	                }
	                if (_this._state === States.REJECTED) {
	                    if (handler.onrejected) {
	                        handler.onrejected(_this._value);
	                    }
	                }
	                handler.done = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.resolve = function (value) {
	        return new SyncPromise(function (resolve) {
	            resolve(value);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.reject = function (reason) {
	        return new SyncPromise(function (_, reject) {
	            reject(reason);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.all = function (collection) {
	        return new SyncPromise(function (resolve, reject) {
	            if (!Array.isArray(collection)) {
	                reject(new TypeError("Promise.all requires an array as input."));
	                return;
	            }
	            if (collection.length === 0) {
	                resolve([]);
	                return;
	            }
	            var counter = collection.length;
	            var resolvedCollection = [];
	            collection.forEach(function (item, index) {
	                SyncPromise.resolve(item)
	                    .then(function (value) {
	                    resolvedCollection[index] = value;
	                    counter -= 1;
	                    if (counter !== 0) {
	                        return;
	                    }
	                    resolve(resolvedCollection);
	                })
	                    .then(null, reject);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._attachHandler({
	                done: false,
	                onfulfilled: function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                        return;
	                    }
	                    try {
	                        resolve(onfulfilled(result));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	                onrejected: function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                        return;
	                    }
	                    try {
	                        resolve(onrejected(reason));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.toString = function () {
	        return '[object SyncPromise]';
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(727) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminAvatar = function (_React$Component) {
		_inherits(AdminAvatar, _React$Component);
	
		function AdminAvatar(props) {
			_classCallCheck(this, AdminAvatar);
	
			var _this = _possibleConstructorReturn(this, (AdminAvatar.__proto__ || Object.getPrototypeOf(AdminAvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(AdminAvatar, [{
			key: "render",
			value: function render() {
				var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
				var src = __webpack_require__(539);
	
				return React.createElement("img", { src: src, alt: "adminAvatar", className: "adminAvatar", style: dims });
			}
		}]);
	
		return AdminAvatar;
	}(React.Component);
	
	;
	
	AdminAvatar.propTypes = StrictPropTypes({
		// We don't actually use user but we may at some point
		// so we should require it to be passed
		admin: PropTypes.object.isRequired,
	
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number
	});
	
	module.exports = AdminAvatar;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	"use strict";
	
	var AvatarPatch = function AvatarPatch(props) {
		var patch = props.patch;
		var patchType = patch["patch_type"];
		var patchPath = "patches/" + patch["patch_directory"] + "/" + patch["name"];
		if (props.color !== undefined) {
			patchPath += "-" + props.color;
		}
		patchPath = dynamicRequire(patchPath + ".png");
	
		var patchStyle = {
			position: "absolute",
			display: "block",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%"
		};
	
		if (props.offsets) {
			if (patchType == "hand") {
				patchStyle["left"] = props.offsets["right_x"] + "px";
				patchStyle["top"] = props.offsets["right_y"] + "px";
			} else if (patchType == "left_hand") {
				patchStyle["left"] = props.offsets["left_x"] + "px";
				patchStyle["top"] = props.offsets["left_y"] + "px";
			}
		}
		patchStyle["zIndex"] = patch["z_index"];
	
		return React.createElement("img", { src: patchPath, style: patchStyle, "data-color": props.color, "data-patch": patchType });
	};
	
	AvatarPatch.propTypes = StrictPropTypes({
		// Info on this patch, including .name and .patchType
		patch: PropTypes.object.isRequired,
	
		color: PropTypes.number,
	
		// Contains offsets for the hand
		offsets: PropTypes.object
	});
	
	AvatarPatch.WIDTH = 401;
	AvatarPatch.HEIGHT = AvatarPatch.WIDTH;
	
	AvatarPatch.DEFAULT_WIDTH = 235;
	AvatarPatch.DEFAULT_HEIGHT = 210;
	AvatarPatch.DEFAULT_LEFT = -(AvatarPatch.WIDTH - AvatarPatch.DEFAULT_WIDTH) / 2;
	AvatarPatch.DEFAULT_TOP = -(AvatarPatch.HEIGHT - AvatarPatch.DEFAULT_HEIGHT) / 2 + 15;
	
	module.exports = AvatarPatch;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	var CoinDisplay = __webpack_require__(121);
	var Tiers = __webpack_require__(108);
	var ShopSales = __webpack_require__(123);
	var ReactTooltip = __webpack_require__(12);
	var PurchaseModal = __webpack_require__(781);
	
	__webpack_require__(3620);
	
	var OwlShopDisplay = function (_React$Component) {
		_inherits(OwlShopDisplay, _React$Component);
	
		function OwlShopDisplay(props) {
			_classCallCheck(this, OwlShopDisplay);
	
			var _this = _possibleConstructorReturn(this, (OwlShopDisplay.__proto__ || Object.getPrototypeOf(OwlShopDisplay)).call(this));
	
			autobind(_this);
	
			_this.state = {
				itemOffset: 0
			};
			return _this;
		}
	
		_createClass(OwlShopDisplay, [{
			key: "checkConfirm",
			value: function checkConfirm(value) {
				this.setState({ inConfirm: value });
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var _props = this.props,
				    beginAtTier = _props.beginAtTier,
				    items = _props.items,
				    previewItem = _props.previewItem;
				//rerender beginning with the items at the user's current tier
	
				if (prevProps.beginAtTier != beginAtTier || prevProps.items != items) {
					this.beginAtTierOffset();
				}
	
				if (this.props.previewItem != undefined && prevProps.previewItem != this.props.previewItem) {
					this.beginAtItemOffset();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if ([OwlShopDisplay.BACKGROUND_SOUNDS, OwlShopDisplay.OWL_HOOTS].includes(this.props.itemType)) {
					setTimeout(function () {
						if (window.wrL2eSound) {
							window.wrL2eSound.removeSources('shop');
						}
						this.getSoundPerks();
					}.bind(this), 100);
				}
	
				if (this.props.beginAtTier) {
					this.beginAtTierOffset();
				}
			}
	
			// skip to page with items at the user's tier
	
		}, {
			key: "beginAtTierOffset",
			value: function beginAtTierOffset() {
				var tierPage = this.getTierPage(this.props.items, this.props.user.tier);
				var tierOffset = tierPage * OwlShopDisplay.MAX_ITEMS;
				this.setState({ itemOffset: tierOffset });
			}
	
			// skip to page with item
	
		}, {
			key: "beginAtItemOffset",
			value: function beginAtItemOffset() {
				var _props2 = this.props,
				    previewItem = _props2.previewItem,
				    items = _props2.items;
	
	
				if (!previewItem || !items) {
					return;
				}
	
				var itemIndex = items.findIndex(function (item) {
					return previewItem.id == item.id;
				});
				this.setState({ itemOffset: Math.floor(itemIndex / OwlShopDisplay.MAX_ITEMS) * OwlShopDisplay.MAX_ITEMS });
			}
		}, {
			key: "buildSelectItemF",
			value: function buildSelectItemF(item) {
				return function (e) {
					$wr.nope(e);
					//Trigger perk sound
					if ([OwlShopDisplay.BACKGROUND_SOUNDS, OwlShopDisplay.OWL_HOOTS].includes(item.perk_type)) {
	
						if (window.wrL2eSound) {
							window.wrL2eSound.stopAllSounds();
							window.wrL2eSound.playSound(item.name + "_shop");
						}
					}
	
					this.props.selectItem(item, this.getEquipPatchType());
				}.bind(this);
			}
		}, {
			key: "getEquipPatchType",
			value: function getEquipPatchType() {
				return this.props.itemType;
			}
		}, {
			key: "getAlternatePatchTypes",
			value: function getAlternatePatchTypes() {
				if (this.props.hideAlternates) return [];
				if (_.include(["body", "body2"], this.props.itemType)) {
					return [{ text: "Item 1", value: "body" }, { text: "Item 2", value: "body2" }];
				} else if (_.include(["hand", "left_hand", "wings"], this.props.itemType)) {
					return [{ text: "Left", value: "left_hand" }, { text: "Right", value: "hand" }, { text: "Position", value: "wings" }];
				} else {
					return [];
				}
			}
		}, {
			key: "getAlternatePerkTypes",
			value: function getAlternatePerkTypes() {
				if (this.props.hideAlternates) return [];
				if (_.include(["wall_items", "wall_items2"], this.props.itemType)) {
					return [{ text: "Item 1", value: "wall_items" }, { text: "Item 2", value: "wall_items2" }];
				} else if (_.include(["floor_items", "floor_items2"], this.props.itemType)) {
					return [{ text: "Item 1", value: "floor_items" }, { text: "Item 2", value: "floor_items2" }];
				} else {
					return [];
				}
			}
		}, {
			key: "buildOnClickAlternateF",
			value: function buildOnClickAlternateF(patchType) {
				return function (e) {
					$wr.nope(e);
					this.props.buildItemTypeSelectF(patchType)();
				}.bind(this);
			}
		}, {
			key: "buildOnClickAlternateFPerk",
			value: function buildOnClickAlternateFPerk(perkType) {
				return function (e) {
					e.preventDefault();
					this.props.buildItemTypeSelectF(null, perkType)();
				}.bind(this);
			}
		}, {
			key: "onPurchase",
			value: function onPurchase() {
				this.props.purchaseItem(this.props.previewItem, this.getEquipPatchType());
				this.refs.purchaseModal.hide();
			}
		}, {
			key: "confirmPurchase",
			value: function confirmPurchase() {
				this.refs.purchaseModal.show();
			}
		}, {
			key: "previewAnimation",
			value: function previewAnimation(name) {
				this.props.previewAnimation(name);
			}
		}, {
			key: "onRemove",
			value: function onRemove() {
				this.props.removeItem(this.props.previewItem, this.getEquipPatchType());
			}
		}, {
			key: "canShiftLeft",
			value: function canShiftLeft() {
				return this.state.itemOffset > 0;
			}
		}, {
			key: "canShiftRight",
			value: function canShiftRight() {
				return this.state.itemOffset + OwlShopDisplay.MAX_ITEMS < this.props.items.length;
			}
		}, {
			key: "shiftLeft",
			value: function shiftLeft() {
				if (this.canShiftLeft()) {
					this.setState({ itemOffset: this.state.itemOffset - OwlShopDisplay.MAX_ITEMS });
				}
			}
		}, {
			key: "shiftRight",
			value: function shiftRight() {
				if (this.canShiftRight()) {
					this.setState({ itemOffset: this.state.itemOffset + OwlShopDisplay.MAX_ITEMS });
				}
			}
		}, {
			key: "renderPatchItem",
			value: function renderPatchItem(patch) {
				var patchPath = "patches/" + patch["origin_patch_type"] + "/" + patch["name"] + "-s.png";
				patchPath = dynamicRequire(patchPath);
	
				if (patch == this.props.previewItem) {
					var selectedClass = "selectedPatch ";
				}
	
				if (this.props.user.tier + 2 <= patch.tier) {
					var displayItemClass = " outRangeTier";
					var src = __webpack_require__(150);
					var lockTip = "You must be level " + (patch.tier + 1) + " to buy this item.";
					var patchImg = React.createElement("img", { src: src, className: "lockImg", "data-tip": lockTip });
				} else if (this.props.user.tier + 1 <= patch.tier) {
					var displayItemClass = " inRangeTier";
					var lockTip = "You must be level " + (patch.tier + 1) + " to buy this item.";
					var patchImg = React.createElement("img", { src: patchPath, className: "patchThumbnail", "data-tip": lockTip });
				} else {
					var displayItemClass = " sameTier";
					var patchImg = React.createElement("img", { src: patchPath, className: "patchThumbnail" });
				}
	
				if (this.state.inConfirm) {
					displayItemClass += " inConfirm";
				}
	
				if (this.props.mode != "dressing") {
					if (!patch.owned) {
						if (this.props.user.tier + 2 <= patch.tier) {
							var purchase = "";
						} else {
							var purchase = React.createElement(CoinDisplay, { coins: patch.price, height: 20 });
						}
					} else {
						if (patch.has_animation) {
							var purchase = React.createElement(
								"span",
								{ className: "statusText" },
								React.createElement(Glyphicon, { icon: "flash" }),
								" upgraded"
							);
						} else {
							var purchase = React.createElement(
								"span",
								{ className: "statusText" },
								React.createElement(Glyphicon, { icon: "ok" }),
								" owned"
							);
						}
					}
				}
	
				// don't display tier indicators on special items
				if (patch.source != "special") {
					var tier = React.createElement("img", { src: Tiers.getIcon(patch.tier), className: "tierImg" });
				}
	
				var patchValueContainer = React.createElement(
					"div",
					{ className: "patchValueContainer" },
					purchase,
					tier
				);
	
				return React.createElement(
					"a",
					{ key: patchPath, className: "displayItem " + selectedClass + displayItemClass,
						href: "#", onClick: this.buildSelectItemF(patch) },
					patchImg,
					React.createElement(
						"p",
						{ className: "title" },
						patch.title
					),
					patchValueContainer
				);
			}
		}, {
			key: "renderPerkItem",
			value: function renderPerkItem(perk) {
				if (perk.perk_type == OwlShopDisplay.BACKGROUNDS || perk.perk_type == OwlShopDisplay.HOUSES || perk.perk_type == OwlShopDisplay.OWL_HOOTS || perk.perk_type == OwlShopDisplay.BACKGROUND_SOUNDS || perk.perk_type == OwlShopDisplay.GREETINGS) {
	
					if (perk.perk_type == OwlShopDisplay.HOUSES || OwlShopDisplay.FURNITURES.indexOf(perk.perk_type) >= 0) {
						var name = perk["name"].toLowerCase().replace(/\s/g, "-");
						if (name.indexOf('\'') >= 0) {
							name = name.replace('\'', "");
						}
					} else {
						var name = perk["name"].toLowerCase().replace(/\s/g, "_");
					}
					var perkPath = "perks/" + perk["origin_perk_type"] + "/" + name + ".png";
					perkPath = dynamicRequire(perkPath);
					var perkKey = perkPath;
					var perkTitle = perk["name"];
				} else if (OwlShopDisplay.FURNITURES.indexOf(perk.perk_type) >= 0) {
					var perkPath = "perks/" + perk["origin_perk_type"] + "/" + perk["name"] + ".png";
					perkPath = dynamicRequire(perkPath);
					var perkKey = perkPath;
					var perkTitle = perk["title"];
				} else {
					var perkTitle = perk["name"];
				}
	
				var tier = React.createElement(
					"span",
					{ className: "tierDisplay" },
					perk.tier
				);
	
				if (this.props.user.tier + 2 <= perk.tier) {
					var displayItemClass = " outRangeTier";
					var src = __webpack_require__(150);
					var lockTip = "You must be level " + (perk.tier + 1) + " to buy this perk.";
					var perkImg = React.createElement("img", { src: src, className: "lockImg", "data-tip": lockTip });
				} else if (this.props.user.tier + 1 <= perk.tier) {
					var displayItemClass = " inRangeTier";
					var lockTip = "You must be level " + (perk.tier + 1) + " to buy this perk.";
					var perkImg = React.createElement("img", { src: perkPath, className: "patchThumbnail", "data-tip": lockTip });
				} else {
					var displayItemClass = " sameTier";
					var perkImg = React.createElement("img", { src: perkPath, className: "patchThumbnail" });
				}
	
				if (this.state.inConfirm) {
					displayItemClass += " inConfirm";
				}
	
				if (perk.perk_type == OwlShopDisplay.TITLES) {
					var perkTitle = perk.name;
					var perkDisplay = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "title" },
							perkTitle
						)
					);
					var perkKey = Math.random();
					var titleClass = " titleClass";
				} else {
					var perkDisplay = React.createElement(
						"div",
						null,
						perkImg,
						React.createElement(
							"p",
							{ className: "title" },
							perkTitle
						)
					);
				}
	
				if (perk == this.props.previewItem) {
					var selectedClass = "selectedPatch ";
				}
	
				if (!perk.owned) {
					if (this.props.user.tier + 2 <= perk.tier) {
						var purchase = "";
					} else {
						var purchase = React.createElement(CoinDisplay, { coins: perk.price, height: 20 });
					}
				} else {
					var purchase = React.createElement(
						"span",
						{ className: "statusText" },
						React.createElement(Glyphicon, { icon: "ok" }),
						" owned"
					);
				}
	
				var tier = React.createElement("img", { src: Tiers.getIcon(perk.tier), className: "tierImg" });
	
				var patchValueContainer = React.createElement(
					"div",
					{ className: "patchValueContainer" },
					purchase,
					tier
				);
	
				return React.createElement(
					"a",
					{ key: perkKey, className: "displayItem " + selectedClass + titleClass + displayItemClass, href: "#",
						onClick: this.buildSelectItemF(perk) },
					perkDisplay,
					patchValueContainer
				);
			}
		}, {
			key: "renderControls",
			value: function renderControls() {
				var paired = this.getAlternatePatchTypes();
				if (paired.length > 0) {
					var altOps = [];
					_.each(paired, function (op, index) {
						if (index > 0) {
							altOps.push(React.createElement("span", { className: "verticalDivider", key: "divider" + index }));
						}
	
						altOps.push(React.createElement(
							"a",
							{ href: "#", onClick: this.buildOnClickAlternateF(op.value), key: op.value,
								className: this.getEquipPatchType() == op.value ? "selected" : "" },
							op.text
						));
					}.bind(this));
	
					var alternates = React.createElement(
						"div",
						{ className: "alternatePatchTypes" },
						altOps
					);
				} else {
					var paired = this.getAlternatePerkTypes();
					if (paired.length > 0) {
						var altOps = [];
						_.each(paired, function (op, index) {
							if (index > 0) {
								altOps.push(React.createElement("span", { className: "verticalDivider", key: "divider" + index }));
							}
	
							altOps.push(React.createElement(
								"a",
								{ href: "#", onClick: this.buildOnClickAlternateFPerk(op.value), key: op.value,
									className: this.getEquipPatchType() == op.value ? "selected" : "" },
								op.text
							));
						}.bind(this));
	
						var alternates = React.createElement(
							"div",
							{ className: "alternatePatchTypes" },
							altOps
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "displayControls text-center" },
					alternates,
					React.createElement(
						"button",
						{ className: "btn btn-link arrow", disabled: !this.canShiftLeft(),
							onClick: this.shiftLeft },
						React.createElement(Glyphicon, { icon: "arrow-left" })
					),
					React.createElement(
						"button",
						{ className: "btn btn-link arrow", disabled: !this.canShiftRight(),
							onClick: this.shiftRight },
						React.createElement(Glyphicon, { icon: "arrow-right" })
					)
				);
			}
		}, {
			key: "getSoundPerks",
			value: function getSoundPerks() {
				var sound_sources = [];
				if (this.props.itemType == OwlShopDisplay.BACKGROUND_SOUNDS) {
					var dir = "background/";
				} else {
					var dir = "owl_hoots/";
				}
				this.props.items.forEach(function (item) {
					sound_sources.push({ "ref": item.name, "path": dir + item.name, "play": false });
				});
				if (window.wrL2eSound) {
					window.wrL2eSound.addSource(sound_sources, "shop");
				}
			}
	
			// gets the page on which tier items begin
	
		}, {
			key: "getTierPage",
			value: function getTierPage(items, userTier) {
				var tierIndex = items.findIndex(function (item) {
					return item.tier == userTier;
				});
				// divides index of first item within tier by the max num items per page
				var tierPage = Math.floor(Math.max(0, tierIndex) / OwlShopDisplay.MAX_ITEMS);
				return tierPage;
			}
		}, {
			key: "sortItemsByTier",
			value: function sortItemsByTier(items) {
				var items = _.sortBy(items, function (item) {
					if (item.patch_type) {
						var onSale = ShopSales.isOnSale(item.origin_patch_type, item.name) ? "0sale" : "1sale";
					} else {
						onSale = "1sale";
					}
					var tier = item.tier || 0;
					var price = item.price || 0;
					return onSale + " " + tier + " " + price;
				});
				return items;
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var items = this.props.items.slice(this.state.itemOffset, this.state.itemOffset + OwlShopDisplay.MAX_ITEMS);
	
				if (this.props.mode == "dressing" && this.props.items.length == 0) {
					var displayItems = React.createElement(
						"div",
						{ className: "emptyMessage" },
						"You don't own any items of this type yet!"
					);
				} else {
					if (this.props.isPatch) {
						var displayItems = _.map(items, function (item) {
							return this.renderPatchItem(item);
						}.bind(this));
					} else {
						var displayItems = _.map(items, function (item) {
							return this.renderPerkItem(item);
						}.bind(this));
					}
				}
	
				if (this.props.previewItem) {
					var item = this.props.previewItem;
					var userCoins = this.props.user.coins;
					if (this.props.mode != "dressing") {
						var item_description = item.description;
					}
	
					if (item.owned) {
	
						if (this.props.itemType == OwlShopDisplay.BACKGROUNDS || this.props.itemType == OwlShopDisplay.TITLES || this.props.itemType == OwlShopDisplay.GREETINGS || this.props.itemType == OwlShopDisplay.OWL_HOOTS || this.props.itemType == OwlShopDisplay.BACKGROUND_SOUNDS || this.props.itemType == OwlShopDisplay.HOUSES) {
							var previewControl = React.createElement(
								"div",
								{ className: "previewControl" },
								React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.props.loading,
									onClick: this.onPurchase, text: "Save" }),
								React.createElement(
									"button",
									{ className: "btn btn-link", onClick: this.onRemove },
									"Remove"
								)
							);
						} else {
							if (item.animation && !item.has_animation) {
								var upgrade = React.createElement(
									"div",
									null,
									React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.props.loading,
										onClick: this.confirmPurchase, text: "Upgrade!" })
								);
	
								item_description = React.createElement(
									"div",
									null,
									React.createElement(CoinDisplay, { coins: 250, height: 16 }),
									React.createElement(
										"p",
										{ className: "upgradeText" },
										"Upgrade and watch this ",
										item.title,
										" come to life! "
									)
								);
							}
							var previewControl = React.createElement(
								"div",
								{ className: "previewControl" },
								upgrade,
								React.createElement(
									"button",
									{ className: "btn btn-link", onClick: this.onRemove },
									"Remove"
								),
								React.createElement("br", null)
							);
						}
					} else if (this.props.user.tier >= item.tier) {
	
						if (item.price <= userCoins) {
							var previewControl = React.createElement(
								"div",
								{ className: "previewControl" },
								React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.props.loading,
									onClick: this.confirmPurchase, text: "Buy it" }),
								React.createElement("br", null)
							);
						} else {
							var previewControl = React.createElement(
								"div",
								{ className: "previewControl" },
								React.createElement(
									"p",
									{ className: "statusText" },
									"You can't afford this item yet."
								)
							);
						}
					} else {
						var previewControl = React.createElement(
							"div",
							{ className: "previewControl" },
							React.createElement(
								"p",
								{ className: "statusText" },
								"Available at the ",
								Tiers.getName(item.tier),
								" level."
							)
						);
					}
	
					if (this.props.itemType == OwlShopDisplay.GREETINGS) {
						var previewAnimation = React.createElement(
							"div",
							{ className: "previewControl" },
							React.createElement(
								"button",
								{ className: "btn btn-link", onClick: function onClick() {
										return _this2.previewAnimation(_this2.props.previewItem.name);
									} },
								"Preview"
							)
						);
					}
	
					if (this.props.user.tier + 2 <= item.tier) {
						var previewDetailsClass = " outRangeTier";
					} else if (this.props.user.tier + 1 <= item.tier) {
						var previewDetailsClass = " inRangeTier";
					} else {
						var previewDetailsClass = " sameTier";
					}
	
					var previewDetails = React.createElement(
						CSSTransition,
						{ classNames: "expand", timeout: { enter: 300, exit: 300 } },
						React.createElement(
							"div",
							{ className: "previewDetails" + previewDetailsClass, key: this.props.previewItem.name },
							React.createElement(
								"div",
								{ className: "previewDesc" },
								React.createElement(
									"p",
									null,
									React.createElement(
										"strong",
										null,
										item.title
									)
								),
								React.createElement(
									"p",
									{ className: "itemDescription" },
									item_description
								),
								previewAnimation
							),
							previewControl
						)
					);
	
					var confirmPurchase = React.createElement(PurchaseModal, {
						ref: "purchaseModal",
						student: this.props.user,
						previewItem: this.props.previewItem,
						isPatch: this.props.isPatch,
						renderPatchItem: this.renderPatchItem,
						renderPerkItem: this.renderPerkItem,
						onPurchase: this.onPurchase,
						checkConfirm: this.checkConfirm.bind(this)
					});
				}
	
				return React.createElement(
					"div",
					{ className: "owlShopDisplay" },
					this.renderControls(),
					React.createElement(
						TransitionGroup,
						null,
						previewDetails
					),
					displayItems,
					confirmPurchase
				);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (window.wrL2eSound) {
					window.wrL2eSound.removeSources('shop');
				}
			}
		}]);
	
		return OwlShopDisplay;
	}(React.Component);
	
	;
	
	OwlShopDisplay.MAX_ITEMS = 8;
	OwlShopDisplay.BACKGROUNDS = "backgrounds";
	OwlShopDisplay.TITLES = "titles";
	OwlShopDisplay.HOUSES = "houses";
	OwlShopDisplay.GREETINGS = "greetings";
	OwlShopDisplay.OWL_HOOTS = "owl_hoots";
	OwlShopDisplay.BACKGROUND_SOUNDS = "background_sounds";
	OwlShopDisplay.SOFAS = "sofas";
	OwlShopDisplay.BOOKSHELVES = "bookshelves";
	OwlShopDisplay.WALL_ITEMS = "wall_items";
	OwlShopDisplay.WALL_ITEMS_2 = "wall_items2";
	OwlShopDisplay.FLOOR_ITEMS = "floor_items";
	OwlShopDisplay.FLOOR_ITEMS_2 = "floor_items2";
	
	OwlShopDisplay.FURNITURES = [OwlShopDisplay.SOFAS, OwlShopDisplay.BOOKSHELVES, OwlShopDisplay.WALL_ITEMS, OwlShopDisplay.WALL_ITEMS_2, OwlShopDisplay.FLOOR_ITEMS, OwlShopDisplay.FLOOR_ITEMS_2];
	OwlShopDisplay.propTypes = StrictPropTypes({
		items: PropTypes.array.isRequired,
		previewItem: PropTypes.object,
		itemType: PropTypes.string,
		isPatch: PropTypes.bool,
		user: PropTypes.object,
	
		selectItem: PropTypes.func.isRequired,
		purchaseItem: PropTypes.func,
		removeItem: PropTypes.func,
	
		loading: PropTypes.bool,
		hideAlternates: PropTypes.bool,
	
		buildItemTypeSelectF: PropTypes.func,
		beginAtTier: PropTypes.bool,
		previewAnimation: PropTypes.func,
	
		mode: PropTypes.string
	});
	
	module.exports = OwlShopDisplay;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StandInAvatar = function (_React$Component) {
		_inherits(StandInAvatar, _React$Component);
	
		function StandInAvatar(props) {
			_classCallCheck(this, StandInAvatar);
	
			var _this = _possibleConstructorReturn(this, (StandInAvatar.__proto__ || Object.getPrototypeOf(StandInAvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StandInAvatar, [{
			key: "render",
			value: function render() {
				var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
				var src = __webpack_require__(539);
	
				return React.createElement("img", { src: src, alt: "standInAvatar", className: "adminAvatar", style: dims });
			}
		}]);
	
		return StandInAvatar;
	}(React.Component);
	
	;
	
	StandInAvatar.propTypes = StrictPropTypes({
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number
	});
	
	module.exports = StandInAvatar;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3627);
	
	var PassageTile = function PassageTile(_ref) {
		var title = _ref.title,
		    categoryName = _ref.categoryName,
		    subCategoryName = _ref.subCategoryName,
		    getIcon = _ref.getIcon,
		    onClick = _ref.onClick;
	
		title = decodeHtml(title || "Welcome!");
	
		if (title.indexOf("--Part") != -1) {
			var titleParts = title.split("--Part");
			if (titleParts.length == 2) {
				title = titleParts[0] + " (Part " + titleParts[1].trim() + ")";
			}
		}
	
		if (subCategoryName) {
			var subCategoryDisplay = React.createElement(
				"div",
				{ className: "subCategory" },
				subCategoryName
			);
		}
		if (categoryName) {
			if (getIcon) {
				var icon = React.createElement("img", { src: getIcon(categoryName), className: "icon" });
			}
	
			var categoryDisplay = React.createElement(
				"div",
				{ className: "category" },
				icon,
				categoryName
			);
		}
	
		return React.createElement(
			"div",
			{ className: "Cloze-PassageTile", onClick: onClick },
			React.createElement(
				"div",
				{ className: "title" },
				title
			),
			subCategoryDisplay,
			categoryDisplay
		);
	};
	
	function decodeHtml(content) {
		// Thanks @ Rob W
		// https://stackoverflow.com/a/7394787/4557470
		var textarea = document.createElement("textarea");
		textarea.innerHTML = content;
	
		return textarea.value;
	}
	
	PassageTile.propTypes = {
		title: PropTypes.string,
		categoryName: PropTypes.string,
		subCategoryName: PropTypes.string,
		getIcon: PropTypes.func,
		onClick: PropTypes.func
	};
	
	module.exports = PassageTile;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var BraveCheckbox = __webpack_require__(120);
	
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(648);
	
	var ExpandableStudentListsSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    // MOUNT STUDENT WITHIN STUDENT LISTS
	    var studentLists = {};
	    // filter student lists if selected a school org
	    var filters = props.persistentData.selectedSchoolOrg ? { school_org_id: props.persistentData.selectedSchoolOrg.id } : {};
	    _.each(RosterSelectors.studentListsByAdminId({ state: state, adminId: CurrentUser.get().id, filters: filters }), function (sl) {
	        studentLists[sl.id] = sl;
	        studentLists[sl.id].students = [];
	        studentLists[sl.id].primary_students = [];
	    });
	
	    _.each(state.students, function (student) {
	        if (student.student_list_ids) {
	            _.each(student.student_list_ids.all, function (id) {
	                if (studentLists[id]) {
	                    studentLists[id].students.push(student);
	                }
	            });
	            if (studentLists[student.student_list_ids.primary]) {
	                studentLists[student.student_list_ids.primary].primary_students.push(student);
	            }
	        }
	    });
	
	    var loading = RosterSelectors.isLoadingStudentLists({ state: state }) || RosterSelectors.isLoadingStudents({ state: state });
	
	    return {
	        studentLists: _.values(studentLists),
	        loading: loading
	    };
	}), _dec(_class = function (_React$Component) {
	    _inherits(ExpandableStudentListsSelector, _React$Component);
	
	    function ExpandableStudentListsSelector(props) {
	        _classCallCheck(this, ExpandableStudentListsSelector);
	
	        var _this = _possibleConstructorReturn(this, (ExpandableStudentListsSelector.__proto__ || Object.getPrototypeOf(ExpandableStudentListsSelector)).call(this, props));
	
	        _this.state = {
	            expandedstudentLists: [],
	            selectedStudents: props.persistentData.selectedStudents || [],
	            selectedStudentLists: props.persistentData.selectedStudentLists || []
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	    _createClass(ExpandableStudentListsSelector, [{
	        key: "persistentSelectedStudentLists",
	        value: function persistentSelectedStudentLists() {
	            var persistentData = this.props.persistentData;
	
	            if (_.has(persistentData, 'selectedStudentLists')) {
	                return persistentData.selectedStudentLists;
	            }
	        }
	    }, {
	        key: "selectedOrganizationType",
	        value: function selectedOrganizationType() {
	            var persistentData = this.props.persistentData;
	
	            if (_.has(persistentData, 'selectedOrganizationType')) {
	                return persistentData.selectedOrganizationType;
	            }
	        }
	    }, {
	        key: "perStudentOrganization",
	        value: function perStudentOrganization() {
	            return this.selectedOrganizationType() && this.selectedOrganizationType() == 'per-student';
	        }
	    }, {
	        key: "perStudentListOrganization",
	        value: function perStudentListOrganization() {
	            return this.selectedOrganizationType() && this.selectedOrganizationType() == 'per-class';
	        }
	
	        // check if all students within a student list are selected
	
	    }, {
	        key: "hasAllSelectedStudents",
	        value: function hasAllSelectedStudents(slID) {
	            var selectedStudents = this.state.selectedStudents;
	            var studentLists = this.props.studentLists;
	
	            var studentIDs = _.pluck(studentLists.filter(function (sl) {
	                return sl.id === slID;
	            })[0].students, 'id');
	            var selected = studentIDs.filter(function (id) {
	                return selectedStudents.includes(id);
	            });
	            return selected.length == studentIDs.length;
	        }
	
	        // returns number of students that are selected in a given list
	
	    }, {
	        key: "studentsSelectedPerList",
	        value: function studentsSelectedPerList(slID) {
	            var selectedStudents = this.state.selectedStudents;
	            var studentLists = this.props.studentLists;
	
	            if (!this.perStudentListOrganization()) {
	                var selectedStudentPerList = _.map(studentLists, function (sl) {
	                    var studentIDs = _.pluck(studentLists.filter(function (sl) {
	                        return sl.id === slID;
	                    })[0].students, 'id');
	                    var selected = studentIDs.filter(function (id) {
	                        return selectedStudents.includes(id);
	                    });
	                    return { slID: sl.id, num_selected: _.size(selected) };
	                });
	                var config = _.findWhere(selectedStudentPerList, { slID: slID });
	                if (config && config.num_selected) {
	                    return React.createElement(
	                        "span",
	                        { className: "studentsSelectedCount" },
	                        "(",
	                        config.num_selected,
	                        " students selected)"
	                    );
	                }
	            }
	        }
	
	        ///// VALIDATORS /////
	
	    }, {
	        key: "validSelectedStudents",
	        value: function validSelectedStudents() {
	            return !_.isEmpty(this.state.selectedStudents);
	        }
	    }, {
	        key: "validSelectedStudentLists",
	        value: function validSelectedStudentLists() {
	            return !_.isEmpty(this.state.selectedStudentLists);
	        }
	    }, {
	        key: "validSelection",
	        value: function validSelection() {
	            return this.perStudentListOrganization() ? this.validSelectedStudentLists() : this.validSelectedStudents();
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleSLSelection",
	        value: function handleSLSelection(slID) {
	            var _state = this.state,
	                selectedStudentLists = _state.selectedStudentLists,
	                selectedStudents = _state.selectedStudents;
	            var studentLists = this.props.studentLists;
	
	
	            var studentIds = _.pluck(studentLists.filter(function (sl) {
	                return sl.id === slID;
	            })[0].students, 'id');
	            if (selectedStudentLists.includes(slID)) {
	                selectedStudentLists.splice(selectedStudentLists.indexOf(slID), 1);
	                var selectedStudents = selectedStudents.filter(function (s) {
	                    return !_.includes(studentIds, s);
	                });
	            } else {
	                selectedStudentLists.push(slID);
	                var selectedStudents = _.uniq([].concat(_toConsumableArray(selectedStudents), _toConsumableArray(studentIds)));
	            }
	
	            this.setState({ selectedStudentLists: selectedStudentLists, selectedStudents: selectedStudents });
	        }
	    }, {
	        key: "handleSLToggle",
	        value: function handleSLToggle(slID) {
	            var expandedstudentLists = this.state.expandedstudentLists;
	
	            if (expandedstudentLists.includes(slID)) {
	                expandedstudentLists.splice(expandedstudentLists.indexOf(slID), 1);
	            } else {
	                expandedstudentLists.push(slID);
	            }
	            this.setState({ expandedstudentLists: expandedstudentLists });
	        }
	    }, {
	        key: "handleStudentSelection",
	        value: function handleStudentSelection(studentID) {
	            var _this2 = this;
	
	            var _state2 = this.state,
	                selectedStudentLists = _state2.selectedStudentLists,
	                selectedStudents = _state2.selectedStudents;
	            var studentLists = this.props.studentLists;
	
	            var slIDs = studentLists.filter(function (c) {
	                return _.pluck(c.students, 'id').includes(studentID);
	            }).map(function (c) {
	                return c.id;
	            });
	
	            if (_.isEmpty(slIDs)) {
	                return null;
	            }
	
	            if (selectedStudents.includes(studentID)) {
	                selectedStudents.splice(selectedStudents.indexOf(studentID), 1);
	                _.each(slIDs, function (slID) {
	                    if (selectedStudentLists.includes(slID) && !_this2.hasAllSelectedStudents(slID)) {
	                        selectedStudentLists.splice(selectedStudentLists.indexOf(slID), 1);
	                    }
	                });
	            } else {
	                selectedStudents.push(studentID);
	            }
	
	            this.setState({ selectedStudents: selectedStudents, selectedStudentLists: selectedStudentLists });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var _state3 = this.state,
	                selectedStudents = _state3.selectedStudents,
	                selectedStudentLists = _state3.selectedStudentLists;
	
	            this.props.onRetreat({ selectedStudents: selectedStudents, selectedStudentLists: selectedStudentLists });
	        }
	
	        ///// SUBMIT /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var _state4 = this.state,
	                selectedStudents = _state4.selectedStudents,
	                selectedStudentLists = _state4.selectedStudentLists;
	
	
	            var errorMessage = this.perStudentListOrganization() ? "Please Select Classes Before Continuing" : "Please Select Students Before Continuing";
	
	            if (!this.validSelection()) {
	                this.renderErrorAlert(errorMessage);
	            } else {
	                this.props.onComplete({ selectedStudentLists: selectedStudentLists, selectedStudents: selectedStudents });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var studentLists = this.props.studentLists;
	            var _state5 = this.state,
	                expandedstudentLists = _state5.expandedstudentLists,
	                selectedStudents = _state5.selectedStudents,
	                selectedStudentLists = _state5.selectedStudentLists;
	
	
	            if (this.props.loading) {
	                return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	            }
	
	            return React.createElement(
	                "div",
	                { className: "slDropdownSelectorContainer" },
	                React.createElement(
	                    "div",
	                    { className: "dropdownSelector" },
	                    React.createElement(
	                        "div",
	                        { className: "dropdownSelector__dropdown" },
	                        studentLists.map(function (sl, i) {
	                            return React.createElement(
	                                "div",
	                                { key: i, className: "dropdownSelector__slName" },
	                                React.createElement(BraveCheckbox, {
	                                    onClick: function onClick() {
	                                        return _this3.handleSLSelection(sl.id);
	                                    },
	                                    value: selectedStudentLists.includes(sl.id) }),
	                                React.createElement(
	                                    "div",
	                                    { className: "slNameContainer", onClick: function onClick() {
	                                            return _this3.handleSLToggle(sl.id);
	                                        } },
	                                    React.createElement(
	                                        "span",
	                                        { className: "boldBlue" },
	                                        sl.name
	                                    ),
	                                    " ",
	                                    _this3.studentsSelectedPerList(sl.id)
	                                ),
	                                !_this3.perStudentListOrganization() && expandedstudentLists.includes(sl.id) && React.createElement(
	                                    "div",
	                                    { className: "dropdownSelector__students" },
	                                    sl.students.map(function (student, j) {
	                                        return React.createElement(
	                                            "div",
	                                            { key: j, className: "dropdownSelector__studentsCheckboxContainer" },
	                                            React.createElement(BraveCheckbox, {
	                                                onClick: function onClick() {
	                                                    return _this3.handleStudentSelection(student.id);
	                                                },
	                                                value: selectedStudents.includes(student.id) }),
	                                            React.createElement(
	                                                "span",
	                                                null,
	                                                student.first_name.substring(0, 3) + ". " + $wr.truncate(student.last_name, 15)
	                                            )
	                                        );
	                                    })
	                                )
	                            );
	                        })
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "onSubmitContainer" },
	                    React.createElement(
	                        "button",
	                        { className: "backBtn", onClick: function onClick() {
	                                return _this3.handleRetreatStage();
	                            } },
	                        "Back"
	                    ),
	                    this.validSelection() && React.createElement(
	                        "button",
	                        { className: "nextBtn", onClick: function onClick() {
	                                return _this3.onSubmit();
	                            } },
	                        "Next"
	                    )
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            // preselect student lists if all students in list are preselected
	            var studentLists = this.props.studentLists;
	
	            var selectedStudentLists = studentLists.map(function (sl) {
	                if (_this4.hasAllSelectedStudents(sl.id)) {
	                    return sl.id;
	                }
	            });
	            this.setState({ selectedStudentLists: _.uniq(_.compact([].concat(_toConsumableArray(this.persistentSelectedStudentLists() || []), _toConsumableArray(selectedStudentLists)))) });
	        }
	    }]);
	
	    return ExpandableStudentListsSelector;
	}(React.Component)) || _class);
	
	
	ExpandableStudentListsSelector.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	module.exports = ExpandableStudentListsSelector;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _GraphUtility = __webpack_require__(99);
	
	var _PopulateData = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(99),
	    STAT_DISPLAY = _require.STAT_DISPLAY,
	    formatTimestamp = _require.formatTimestamp;
	
	var DataSelectors = __webpack_require__(54);
	var DataActions = __webpack_require__(65);
	var Spinner = __webpack_require__(9);
	
	var DigestProgressGraph = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {
	        digests: DataSelectors.digests({ state: state, filters: { entity_id: props.entity.id, entity_type: props.entityType, graph: true } })
	    };
	}, function (dispatch, props) {
	    var fetchDigests = function fetchDigests(entityType, entityID) {
	        var conditions = { entityType: entityType, entityID: entityID };
	        return dispatch(DataActions.fetchDigests({
	            conditions: conditions,
	            query: { digest_summary: true, graph_digests_only: true },
	            cache: false
	        }));
	    };
	
	    var populateData = function populateData() {
	        return Promise.all([fetchDigests(props.entityType, props.entity.id)]);
	    };
	
	    return {
	        fetchDigests: fetchDigests,
	        populateData: populateData
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(DigestProgressGraph, _React$Component);
	
	    function DigestProgressGraph(props) {
	        _classCallCheck(this, DigestProgressGraph);
	
	        var _this = _possibleConstructorReturn(this, (DigestProgressGraph.__proto__ || Object.getPrototypeOf(DigestProgressGraph)).call(this));
	
	        autobind(_this);
	
	        _this.state = {
	            digests: [],
	            loadingDigests: false,
	            loadedDependencies: false
	        };
	        return _this;
	    }
	
	    // fetch digests for the type of group that is being shown.
	
	
	    _createClass(DigestProgressGraph, [{
	        key: "fetchData",
	        value: function fetchData() {
	            var _this2 = this;
	
	            this.setState({ loadingDigests: true });
	
	            this.props.fetchDigests(this.props.entityType, this.props.entity.id).then(function (res) {
	                _this2.setState({ loadingDigests: false });
	            });
	        }
	        // can't tell what month a digest corresponds to directly, so figure it out by taking mid point
	        // of digest. 
	
	    }, {
	        key: "getMonthFromDigest",
	        value: function getMonthFromDigest(digest) {
	            if (!digest.start_date || !digest.end_date) {
	                return;
	            }
	            var monthStart = new Date(digest.start_date);
	            var monthEnd = new Date(digest.end_date);
	            var midpoint = new Date((monthStart.getTime() + monthEnd.getTime()) / 2);
	            return formatTimestamp(midpoint.getTime());
	        }
	
	        // takes in data key, and digest. Returns digest name, and formatted metric
	
	    }, {
	        key: "formatData",
	        value: function formatData(digest, metricKey) {
	            var metric = digest.data[metricKey];
	            var formatFunc = STAT_DISPLAY[metricKey]['formatting'];
	            if (formatFunc) {
	                metric = formatFunc(metric);
	            }
	
	            return { "metric": metric, "name": STAT_DISPLAY[metricKey]['name'] };
	        }
	    }, {
	        key: "createEmptyData",
	        value: function createEmptyData() {
	            var startMonth = _underscore2.default.get(this.props.entity, ['prefs', 'school_year_start_month'], 8);
	
	            var now = new Date();
	            if (startMonth <= now.getMonth()) {
	                var startYear = now.getFullYear();
	            } else {
	                var startYear = now.getFullYear() - 1;
	            }
	
	            var emptyMonth = new Date(startYear, startMonth);
	
	            var data = [];
	            while (emptyMonth <= now) {
	                var emptyData = { "Month": formatTimestamp(emptyMonth.getTime()) };
	                this.props.metrics.forEach(function (metric) {
	                    var metricName = STAT_DISPLAY[metric].name;
	                    emptyData[metricName] = 0;
	                });
	
	                data.push(emptyData);
	                emptyMonth = new Date(emptyMonth.getFullYear(), emptyMonth.getMonth() + 1);
	            }
	            return data;
	        }
	
	        // create data organized as necessary to display.
	
	    }, {
	        key: "createData",
	        value: function createData() {
	            if (this.state.loadingDigests || !this.state.loadedDependencies) {
	                return;
	            }
	
	            var digests = [].concat(_toConsumableArray(this.props.digests));
	
	            if (digests.length == 0) {
	                return this.createEmptyData();
	            }
	
	            digests.sort(function (a, b) {
	                return new Date(a.start_date) - new Date(b.start_date);
	            });
	
	            var data = [];
	            var now = new Date();
	            for (var i = 0; i < digests.length; i++) {
	                var digest = digests[i];
	
	                if (now < new Date(digest.start_date)) {
	                    continue;
	                }
	
	                var dataCol = {};
	                dataCol['Month'] = this.getMonthFromDigest(digest);
	
	                // if there is a custom data extraction function for this specific data
	                if (STAT_DISPLAY[this.props.metrics[0]]['data_extraction_func']) {
	                    dataCol = STAT_DISPLAY[this.props.metrics[0]]['data_extraction_func'](digest, dataCol);
	                } else {
	                    // extract data the generic way.
	                    var formattedData = this.formatData(digest, this.props.metrics[0]);
	                    dataCol[formattedData['name']] = formattedData['metric'];
	
	                    if (this.props.metrics.length == 2) {
	                        var formattedData = this.formatData(digest, this.props.metrics[1]);
	                        dataCol[formattedData['name']] = formattedData['metric'];
	                    }
	                }
	                data.push(dataCol);
	            }
	
	            return data;
	        }
	    }, {
	        key: "DigestProgressGraph",
	        value: function DigestProgressGraph() {
	            var data = this.createData();
	            // grab metrics from first row of data
	            var metricsToGraph = [];
	            _underscore2.default.each(data[0], function (value, metric) {
	                if (metric != "Month") {
	                    metricsToGraph.push(metric);
	                }
	            });
	
	            var colors = (0, _GraphUtility.getBarColors)(metricsToGraph);
	            var unit = STAT_DISPLAY[this.props.metrics[0]].unit;
	            var domain = STAT_DISPLAY[this.props.metrics[0]].domain;
	            return React.createElement(
	                "div",
	                null,
	                React.createElement(
	                    Recharts.BarChart,
	                    { width: 730, height: 250, data: data },
	                    React.createElement(Recharts.CartesianGrid, { strokeDasharray: "3 3" }),
	                    React.createElement(Recharts.XAxis, { dataKey: "Month" }),
	                    React.createElement(Recharts.YAxis, { key: Math.random(), unit: unit, domain: domain }),
	                    React.createElement(Recharts.Tooltip, null),
	                    React.createElement(Recharts.Legend, null),
	                    React.createElement(Recharts.Bar, { dataKey: metricsToGraph[0], fill: colors[0], unit: unit }),
	                    metricsToGraph.length == 2 && React.createElement(Recharts.Bar, { dataKey: metricsToGraph[1], fill: colors[1] })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (!this.state.loadedDependencies || this.state.loadingDigests) {
	                var graph = React.createElement(Spinner, null);
	            } else {
	                var graph = this.DigestProgressGraph();
	            }
	
	            return React.createElement(
	                "div",
	                { className: "ScoringGraph" },
	                graph
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            $wr.loadScript("/dependencies/recharts.min.js", "Recharts", function () {
	                _this3.setState({ loadedDependencies: true });
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            if (!_underscore2.default.isEqual(prevProps.entity, this.props.entity)) {
	                this.fetchData();
	            }
	        }
	    }]);
	
	    return DigestProgressGraph;
	}(React.Component)) || _class) || _class);
	
	
	DigestProgressGraph.propTypes = PageStrictPropTypes({
	    entity: PropTypes.object,
	    entityType: PropTypes.string,
	    metrics: PropTypes.array
	});
	
	module.exports = DigestProgressGraph;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _GraphUtility = __webpack_require__(99);
	
	var _PopulateData = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(99),
	    STAT_DISPLAY = _require.STAT_DISPLAY;
	
	var DataSelectors = __webpack_require__(54);
	var DataActions = __webpack_require__(65);
	var Spinner = __webpack_require__(9);
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3646);
	
	var METRIC_NUM = 6;
	
	var RubricRadarGraph = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    var downProps = {};
	    var entityDigests = DataSelectors.digests({ state: state, filters: { entity_id: props.entity.id, entity_type: props.entityType, graph: true } });
	    downProps.entityDigest = (0, _GraphUtility.consolidateMonthlyRubrics)(entityDigests);
	    return downProps;
	}, function (dispatch, props) {
	    var fetchDigests = function fetchDigests(entityType, entity) {
	        if (!entityType || !entity) {
	            return;
	        }
	
	        var entityID = entity.id;
	        var conditions = { entityType: entityType, entityID: entityID };
	        return dispatch(DataActions.fetchDigests({
	            conditions: conditions,
	            query: { digest_summary: true, graph_digests_only: true },
	            cache: false
	        }));
	    };
	
	    var populateData = function populateData() {
	        return Promise.all([fetchDigests(props.entityType, props.entity), fetchDigests(props.comparisonType, props.comparison)]);
	    };
	
	    return {
	        fetchDigests: fetchDigests,
	        populateData: populateData
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(RubricRadarGraph, _React$Component);
	
	    function RubricRadarGraph(props) {
	        _classCallCheck(this, RubricRadarGraph);
	
	        var _this = _possibleConstructorReturn(this, (RubricRadarGraph.__proto__ || Object.getPrototypeOf(RubricRadarGraph)).call(this));
	
	        autobind(_this);
	
	        var starterComparison = null;
	        if (props.comparisons && props.comparisons.length > 0) {
	            starterComparison = props.comparisons[0];
	        }
	
	        _this.state = {
	            metrics: _GraphUtility.RUBRIC_METRICS.slice(0, METRIC_NUM), //take the first six
	            loadingDigests: false,
	            loadedDependencies: false,
	            activeComparison: starterComparison
	        };
	        return _this;
	    }
	
	    _createClass(RubricRadarGraph, [{
	        key: "createData",
	        value: function createData() {
	            var _this2 = this;
	
	            var data = [];
	            var entityKey = this.props.entity.id + "-" + this.props.entityType;
	
	            if (this.state.activeComparison) {
	                var comparisonKey = this.state.activeComparison.id + "-" + this.props.comparisonType;
	            }
	
	            this.state.metrics.forEach(function (metric) {
	                var rubricPerformance = {};
	                rubricPerformance.rubric = STAT_DISPLAY[metric].name;
	                rubricPerformance[entityKey] = (0, _GraphUtility.calculateRubricScore)(_this2.props.entityDigest, metric);
	                rubricPerformance.fullMark = 100;
	
	                if (_this2.state.activeComparison) {
	                    rubricPerformance[comparisonKey] = (0, _GraphUtility.calculateRubricScore)(_this2.state.comparisonDigest, metric);
	                }
	                data.push(rubricPerformance);
	            });
	
	            return data;
	        }
	    }, {
	        key: "changeMetric",
	        value: function changeMetric(metric) {
	            if (this.state.metrics.includes(metric)) {
	                return;
	            }
	            var oldMetrics = [].concat(_toConsumableArray(this.state.metrics));
	            var newMetrics = oldMetrics.slice(1, METRIC_NUM);
	            newMetrics.push(metric);
	            this.setState({ metrics: newMetrics });
	        }
	    }, {
	        key: "changeComparison",
	        value: function changeComparison(newEntity) {
	            if (_underscore2.default.isEqual(this.state.activeComparison, newEntity)) {
	                return;
	            }
	            this.setState({ activeComparison: newEntity });
	        }
	    }, {
	        key: "renderControls",
	        value: function renderControls() {
	            var _this3 = this;
	
	            var activityOptions = _underscore2.default.map(_GraphUtility.RUBRIC_METRICS, function (metric) {
	                var isSelected = _this3.state.metrics.includes(metric);
	
	                return React.createElement(
	                    ButtonDropdownOption,
	                    { onClick: _this3.changeMetric.bind(_this3, metric) },
	                    React.createElement(
	                        "div",
	                        { className: "dropdownText" },
	                        React.createElement(
	                            "div",
	                            { className: "checkContainer" },
	                            isSelected && React.createElement(Glyphicon, { icon: "check" })
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "metricNameContainer" },
	                            STAT_DISPLAY[metric].name
	                        )
	                    )
	                );
	            });
	
	            var select = React.createElement(
	                ButtonDropdown,
	                { wide: true, text: "select skillsets", dropdownDisplay: "link" },
	                activityOptions
	            );
	
	            var entityName = (0, _GraphUtility.getEntityName)(this.props.entityType, this.props.entity);
	
	            if (this.state.activeComparison) {
	                var comparisonName = (0, _GraphUtility.getEntityName)(this.props.comparisonType, this.state.activeComparison);
	                var divider = "|";
	            }
	
	            // only add comparison dropdown if there is more than one comparison to choose from
	            if (this.props.comparisons && this.props.comparisons.length > 1) {
	                var comparisonOptions = this.props.comparisons.map(function (comparison) {
	                    var isSelected = _underscore2.default.isEqual(comparison, _this3.state.activeComparison);
	
	                    return React.createElement(
	                        ButtonDropdownOption,
	                        { onClick: _this3.changeComparison.bind(_this3, comparison) },
	                        React.createElement(
	                            "div",
	                            { className: "dropdownText" },
	                            React.createElement(
	                                "div",
	                                { className: "checkContainer" },
	                                isSelected && React.createElement(Glyphicon, { icon: "check" })
	                            ),
	                            React.createElement(
	                                "div",
	                                { className: "metricNameContainer" },
	                                (0, _GraphUtility.getEntityName)(_this3.props.comparisonType, comparison)
	                            )
	                        )
	                    );
	                });
	
	                var comparisonDropdown = React.createElement(
	                    ButtonDropdown,
	                    { text: comparisonName, dropdownDisplay: "link" },
	                    comparisonOptions
	                );
	
	                var comparisonContent = React.createElement(
	                    "span",
	                    null,
	                    "Benchmark: ",
	                    comparisonDropdown
	                );
	
	                var tooltipText = "Compare the performance of " + entityName + " to other classes. Select different skillsets to explore each class's unique strengths & weaknesses.";
	                var toolTip = React.createElement(Glyphicon, { icon: "question-sign", dataTip: tooltipText });
	            } else if (this.props.comparisons && this.props.comparisons.length == 1) {
	                // if only 1 comparison.
	                var comparisonContent = React.createElement(
	                    "span",
	                    { className: "benchmarkDescription" },
	                    "Benchmark: ",
	                    React.createElement(
	                        "i",
	                        null,
	                        comparisonName
	                    )
	                );
	
	                var tooltipText = "Compare the performance of " + entityName + " to their primary class's averages. Select different skillsets to explore the student's unique strengths & weaknesses.";
	                var toolTip = React.createElement(Glyphicon, { icon: "question-sign", dataTip: tooltipText });
	            }
	
	            return React.createElement(
	                "div",
	                { className: "controlDiv" },
	                comparisonContent,
	                divider,
	                select,
	                toolTip
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.state.loadingDigests) {
	                return React.createElement(
	                    "div",
	                    { className: "RubricRadarGraph" },
	                    React.createElement(Spinner, null)
	                );
	            }
	            var entityKey = this.props.entity.id + "-" + this.props.entityType;
	            if (this.state.activeComparison) {
	                var comparisonKey = this.state.activeComparison.id + "-" + this.props.comparisonType;
	            }
	            var data = this.createData();
	            return React.createElement(
	                "div",
	                { className: "RubricRadarGraph" },
	                this.renderControls(),
	                React.createElement(
	                    Recharts.RadarChart,
	                    { outerRadius: 95, width: 730, height: 300, data: data },
	                    React.createElement(Recharts.PolarGrid, null),
	                    React.createElement(Recharts.PolarAngleAxis, { key: Math.random(), dataKey: "rubric" }),
	                    React.createElement(Recharts.PolarRadiusAxis, { angle: 30, domain: [0, 100] }),
	                    React.createElement(Recharts.Radar, { name: (0, _GraphUtility.getEntityName)(this.props.entityType, this.props.entity), dataKey: entityKey, stroke: "#8884d8", fill: "#8884d8", fillOpacity: 0.6 }),
	                    comparisonKey && React.createElement(Recharts.Radar, { name: (0, _GraphUtility.getEntityName)(this.props.comparisonType, this.state.activeComparison), dataKey: comparisonKey, stroke: "#82ca9d", fill: "#82ca9d", fillOpacity: 0.6 }),
	                    React.createElement(Recharts.Legend, null)
	                )
	            );
	        }
	    }, {
	        key: "fetchComparisonData",
	        value: function fetchComparisonData() {
	            var _this4 = this;
	
	            if (!this.state.activeComparison) {
	                return;
	            }
	
	            this.setState({ loadingDigests: true });
	            this.props.fetchDigests(this.props.comparisonType, this.state.activeComparison).then(function (res) {
	                var consolidatedDigests = (0, _GraphUtility.consolidateMonthlyRubrics)(res.digests);
	                _this4.setState({ comparisonDigest: consolidatedDigests, loadingDigests: false });
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.activeComparison != this.state.activeComparison) {
	                this.fetchComparisonData();
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this5 = this;
	
	            this.fetchComparisonData();
	            $wr.loadScript("/dependencies/recharts.min.js", "Recharts", function () {
	                _this5.setState({ loadedDependencies: true });
	            });
	        }
	    }]);
	
	    return RubricRadarGraph;
	}(React.Component)) || _class) || _class);
	
	
	RubricRadarGraph.propTypes = PageStrictPropTypes({
	    entity: PropTypes.object,
	    entityType: PropTypes.string,
	    metrics: PropTypes.array
	});
	
	module.exports = RubricRadarGraph;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentMetrics = __webpack_require__(29);
	var GradeLevel = __webpack_require__(40);
	var OrgTypes = __webpack_require__(45);
	var CurrentUser = __webpack_require__(3);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var DataSelectors = __webpack_require__(54);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var OrgActivityRouting = __webpack_require__(203);
	var DataRouting = __webpack_require__(36);
	
	__webpack_require__(3649);
	
	var OrgActivityTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			userMetricsColumns: DataSelectors.dashboardOtherMetrics({
				state: state, count: 4, aggregate: true
			}),
	
			getStudentListAdmin: function getStudentListAdmin(studentListID) {
				return RosterSelectors.primaryAdminForStudentListID({ state: state, studentListID: studentListID });
			},
	
			getStudentListSchoolName: function getStudentListSchoolName(studentListID) {
				var studentList = RosterSelectors.studentList({ state: state, id: studentListID });
				var schoolOrg = RosterSelectors.schoolOrg({ state: state, id: studentList.school_org_id });
	
				if (schoolOrg) {
					return schoolOrg.name;
				}
			},
	
			getClassCount: function getClassCount(schoolOrgID) {
				return RosterSelectors.studentLists({ state: state, filters: { school_org_id: schoolOrgID } }).length;
			},
	
			getStudentCount: function getStudentCount(orgIdentifier) {
				return RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier }).length;
			},
	
			getStudentIDs: function getStudentIDs(orgIdentifier) {
				return _.pluck(RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier }), "id");
			}
	
			// loading: DataSelectors.isLoadingDigests({ state }),
		};
	}, function (dispatch, props) {
		return {
			updateDashboardColumns: function updateDashboardColumns(newCols) {
				return dispatch(RosterActions.updateAdmin({
					id: CurrentUser.get().id,
					update: { prefs: { dashboard_columns: newCols } }
				})).then(function () {
					var prefs = _extends({}, CurrentUser.get().prefs, { dashboard_columns: newCols });
					CurrentUser.updateLocal({ prefs: prefs });
				});
			}
	
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(OrgActivityTable, _React$Component);
	
		function OrgActivityTable(props) {
			_classCallCheck(this, OrgActivityTable);
	
			var _this = _possibleConstructorReturn(this, (OrgActivityTable.__proto__ || Object.getPrototypeOf(OrgActivityTable)).call(this));
	
			autobind(_this);
	
			_this.state = { orderBy: NAME_ORDER };
			return _this;
		}
	
		_createClass(OrgActivityTable, [{
			key: "isStudentListTable",
			value: function isStudentListTable() {
				return this.props.orgType === OrgTypes.STUDENT_LIST;
			}
		}, {
			key: "isMultiSchoolStudentListTable",
			value: function isMultiSchoolStudentListTable() {
				if (!this.isStudentListTable()) {
					return false;
				}
	
				return _.uniq(_.pluck(this.props.orgs, "school_org_id")).length > 1;
			}
		}, {
			key: "isSchoolOrgTable",
			value: function isSchoolOrgTable() {
				return this.props.orgType === OrgTypes.SCHOOL_ORG;
			}
		}, {
			key: "selectExtraColumn",
			value: function selectExtraColumn(extraColumnIndex, columnKey) {
				var _this2 = this;
	
				var newDashboardColumns = _.clone(this.props.userMetricsColumns);
				newDashboardColumns[extraColumnIndex] = columnKey;
	
				newDashboardColumns = _.uniq(_.compact(newDashboardColumns));
	
				if (_.isEqual(this.props.userMetricsColumns, newDashboardColumns)) {
					return;
				}
	
				this.props.updateDashboardColumns(newDashboardColumns).then(function () {
					return _this2.props.reloadF();
				});
			}
		}, {
			key: "changeSortBy",
			value: function changeSortBy(orderBy) {
				this.setState({ orderBy: orderBy });
			}
		}, {
			key: "digest",
			value: function digest(org) {
				var base = { org_identifier: this.toIdentifier(org) };
				var digest = _.findWhere(this.props.digests, base);
	
				if (digest) {
					return digest;
				}
	
				return base;
			}
		}, {
			key: "statCellCount",
			value: function statCellCount() {
				return 5; // 1 for students / grade level, plus 4 metrics
			}
		}, {
			key: "statCellWidth",
			value: function statCellWidth() {
				return (100 - this.infoCellWidth()) / this.statCellCount();
			}
		}, {
			key: "infoCellWidth",
			value: function infoCellWidth() {
				return 26;
			}
		}, {
			key: "toIdentifier",
			value: function toIdentifier(org) {
				if (this.isStudentListTable() || this.isSchoolOrgTable()) {
					return OrgTypes.toIdentifier({ type: this.props.orgType, key: org.id });
				}
			}
		}, {
			key: "onRowClick",
			value: function onRowClick(org) {
				if (this.isSchoolOrgTable()) {
					this.props.onChangeView({
						orgIdentifier: this.toIdentifier(org)
					});
				} else if (this.isStudentListTable()) {
					console.log(DataRouting.getPath({
						subjectType: DataRouting.SUBJECT_OTHER_METRICS,
						userIDs: this.props.getStudentIDs(this.toIdentifier(org))
					}));
					$wr.redirect(DataRouting.getPath({
						subjectType: DataRouting.SUBJECT_OTHER_METRICS,
						userIDs: this.props.getStudentIDs(this.toIdentifier(org))
					}));
				}
			}
		}, {
			key: "sortedOrgs",
			value: function sortedOrgs() {
				var _this3 = this;
	
				if (StudentMetrics.isMetric(this.state.orderBy)) {
					var digestKey = StudentMetrics.getDigestEmbeds([this.state.orderBy]).split(",")[0];
	
					var toDigest = function toDigest(org) {
						return _this3.digest(org)[digestKey] || 0;
					};
	
					return _.sortBy(this.props.orgs, toDigest).reverse();
				} else if (this.state.orderBy === GRADE_LEVEL) {
					return _.sortBy(this.props.orgs, "grade_level");
				} else if (this.state.orderBy === TEACHER_NAME) {
					return _.sortBy(this.props.orgs, function (studentList) {
						var teacher = _this3.props.getStudentListAdmin(studentList.id);
						if (teacher) {
							return (teacher.last_name + ", " + teacher.first_name).toUpperCase();
						} else {
							return "ZZZ";
						}
					});
				} else if (this.state.orderBy === SCHOOL_NAME_ORDER) {
					return _.sortBy(this.props.orgs, function (studentList) {
						return _this3.props.getStudentListSchoolName(studentList.id);
					});
				} else if (this.state.orderBy === STUDENT_COUNT) {
					return _.sortBy(this.props.orgs, function (org) {
						return _this3.props.getStudentCount(_this3.toIdentifier(org));
					}).reverse();
				} else {
					return _.sortBy(this.props.orgs, "name");
				}
	
				return;
			}
		}, {
			key: "renderSortControl",
			value: function renderSortControl() {
				var _this4 = this;
	
				var orderOptionText = function orderOptionText(op) {
					if (op === NAME_ORDER) {
						if (_this4.isStudentListTable()) {
							return "Class Name";
						} else {
							return "School Name";
						}
					} else if (op === SCHOOL_NAME_ORDER) {
						return "School Name";
					} else if (op === GRADE_LEVEL) {
						return "Grade Level";
					} else if (op === TEACHER_NAME) {
						return "Teacher Name";
					} else if (op === STUDENT_COUNT) {
						return "Number of Students";
					} else {
						return StudentMetrics.getLabel(op);
					}
				};
	
				var renderOption = function renderOption(op) {
					return React.createElement(ButtonDropdownOption, { key: op, className: "",
						text: orderOptionText(op),
						onClick: _this4.changeSortBy.bind(_this4, op) });
				};
	
				var orderOptions = [];
	
				orderOptions.push(renderOption(NAME_ORDER));
	
				if (this.isStudentListTable()) {
					if (this.isMultiSchoolStudentListTable()) {
						orderOptions.push(renderOption(SCHOOL_NAME_ORDER));
					} else {
						orderOptions.push(renderOption(TEACHER_NAME));
					}
					orderOptions.push(renderOption(GRADE_LEVEL));
				}
	
				orderOptions.push(renderOption(STUDENT_COUNT));
	
				_.each(this.props.userMetricsColumns, function (metric) {
					orderOptions.push(renderOption(metric));
				});
	
				var displayText = orderOptionText(this.state.orderBy);
	
				return React.createElement(
					ButtonDropdown,
					{ dropdownDisplay: "link", text: displayText },
					orderOptions
				);
			}
		}, {
			key: "renderMetricOptions",
			value: function renderMetricOptions(metrics, extraColIndex) {
				var _this5 = this;
	
				metrics = _.reject(metrics, function (m) {
					return _.contains(_this5.props.userMetricsColumns, m);
				});
				return metrics.map(function (columnKey) {
					return React.createElement(ButtonDropdownOption, {
						onClick: _this5.selectExtraColumn.bind(_this5, extraColIndex, columnKey),
						text: StudentMetrics.getLabel(columnKey),
						key: columnKey
					});
				});
			}
		}, {
			key: "renderTableHeaders",
			value: function renderTableHeaders() {
				var _this6 = this;
	
				// Index of this extra column (which are all on the right)
				var extraColIndex = 0;
	
				var headerCells = _.map(this.props.userMetricsColumns, function (col, extraColIndex) {
	
					var cellContents = React.createElement(
						ButtonDropdown,
						{ dropdownDisplay: "link", text: StudentMetrics.getLabel(col) },
						_this6.renderMetricOptions(StudentMetrics.aggregateMetrics(), extraColIndex)
					);
	
					return React.createElement(
						"div",
						{ className: "statSection", key: col, style: { width: _this6.statCellWidth() + "%" } },
						cellContents
					);
				});
	
				return React.createElement(
					"div",
					{ className: "orgRow headerRow" },
					React.createElement(
						"div",
						{ className: "infoSection sortControlCell hideOnPrint",
							style: { width: this.infoCellWidth() + "%" } },
						"Sort By: ",
						this.renderSortControl()
					),
					React.createElement("div", { className: "statSection", style: { width: this.statCellWidth() + "%" } }),
					headerCells
				);
			}
		}, {
			key: "renderTableRows",
			value: function renderTableRows() {
				var _this7 = this;
	
				return this.sortedOrgs().map(function (org, index) {
					var digest = _this7.digest(org);
	
					var statCells = _this7.props.userMetricsColumns.map(function (metric) {
						return React.createElement(
							"div",
							{ className: "statSection", key: metric,
								style: { width: _this7.statCellWidth() + "%" } },
							StudentMetrics.getValue(digest, metric) || 0
						);
					});
	
					var nameText = org.name;
	
					if (_this7.isStudentListTable()) {
						if (_this7.isMultiSchoolStudentListTable()) {
							var nameSubText = React.createElement(
								"div",
								{ className: "subText ellipsisText" },
								_this7.props.getStudentListSchoolName(org.id)
							);
						} else {
							var teacher = _this7.props.getStudentListAdmin(org.id);
	
							if (teacher) {
								var nameSubText = React.createElement(
									"div",
									{ className: "subText ellipsisText" },
									"Teacher: ",
									teacher.first_name,
									" ",
									teacher.last_name
								);
							}
						}
	
						var studentsSubText = React.createElement(
							"div",
							{ className: "subText" },
							GradeLevel.getName(org.grade_level)
						);
					} else {
						var classCount = _this7.props.getClassCount(org.id);
						var nameSubText = React.createElement(
							"div",
							{ className: "subText ellipsisText" },
							$wr.pluralizeWithNumber("class", classCount, "classes")
						);
					}
	
					var studentCount = _this7.props.getStudentCount(digest.org_identifier);
	
					return React.createElement(
						"div",
						{ className: "orgRow clickableElement", key: digest.org_identifier,
							onClick: function onClick() {
								return _this7.onRowClick(org);
							} },
						React.createElement(
							"div",
							{ className: "infoSection",
								style: { width: _this7.infoCellWidth() + "%" } },
							nameText,
							nameSubText
						),
						React.createElement(
							"div",
							{ className: "statSection", style: { width: _this7.statCellWidth() + "%" } },
							$wr.pluralizeWithNumber("student", studentCount),
							studentsSubText
						),
						statCells
					);
				});
			}
		}, {
			key: "renderEmptyState",
			value: function renderEmptyState() {
				if (this.props.orgs.length) {
					return;
				}
	
				return React.createElement(
					"div",
					{ className: "adminEmptyState" },
					"No classes have been added yet! Classes will show up here as teachers activate and set up their accounts."
				);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "orgActivityTable" },
					this.renderTableHeaders(),
					this.renderTableRows(),
					this.renderEmptyState()
				);
			}
		}]);
	
		return OrgActivityTable;
	}(React.Component)) || _class);
	
	
	var NAME_ORDER = "class-name";
	var SCHOOL_NAME_ORDER = "school-name";
	var TEACHER_NAME = "teacher-name";
	var GRADE_LEVEL = "grade-level";
	var STUDENT_COUNT = "student-count";
	
	OrgActivityTable.WrappedComponent.propTypes = PageStrictPropTypes({
		digests: PropTypes.array,
		orgs: PropTypes.array,
		orgType: PropTypes.string,
		reloadF: PropTypes.func,
		onChangeView: PropTypes.func,
	
		// Data from @connect
		userMetricsColumns: PropTypes.array,
	
		// Data getters from @connect
		getStudentListAdmin: PropTypes.func,
		getSchoolOrgAdmin: PropTypes.func,
		getStudentCount: PropTypes.func,
		getClassCount: PropTypes.func,
		getStudentIDs: PropTypes.func,
		getStudentListSchoolName: PropTypes.func,
	
		// Handlers from @connect
		updateDashboardColumns: PropTypes.func
	});
	
	module.exports = OrgActivityTable;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _DataAnswers$ANSWER_T;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	var QuestionTypes = __webpack_require__(82);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var AnswerDisplay = __webpack_require__(171);
	var PaginationControls = __webpack_require__(90);
	var Spinner = __webpack_require__(9);
	
	var TruncatedDataNote = __webpack_require__(159);
	var NoActivityBlock = __webpack_require__(71);
	var EmptyState = __webpack_require__(117);
	var Glyphicon = __webpack_require__(8);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs", "order");
	
		conditions.perPage = props.perPage || DataRouting.PER_PAGE;
		conditions.withTotal = true;
	
		return conditions;
	}
	// returns conditions for multiple requests
	function largeRequestConditions(props) {
		return _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
	}
	
	function sortItems(answers) {
		return _.sortBy(answers, function (x) {
			return new Date(x.completed_at).valueOf();
		}).reverse();
	}
	// determines if the request is large (requiring FE pagination)
	// and returns data accordingly
	function selectData(smallRequestFunction, largeRequestFunction, state, props) {
		if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
			return largeRequestFunction({ state: state, conditions: largeRequestConditions(props) });
		} else {
			var page = props.page || 1;
			return smallRequestFunction({ state: state, page: page, conditions: propsToConditions(props) });
		}
	}
	// returns correct total data
	// large requests have all data saved in state
	function getTotal(smallRequestFunction, state, props, answers) {
		if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
			return $wr.frontEndPaginationTotal(answers || state.answers);
		} else {
			return smallRequestFunction({ state: state, conditions: propsToConditions(props) });
		}
	}
	
	var DataAnswers = (_dec = (0, _reactRedux.connect)(function (state, props) {
		if (props.answerType == PRACTICE_QUESTIONS) {
			var answers = selectData(WritingSelectors.nonQuizAnswersPaginated, WritingSelectors.nonQuizAnswers, state, props);
			var totalCount = getTotal(WritingSelectors.nonQuizAnswerTotal, state, props, _.where(state.answers, { question_type: QuestionTypes.GENERIC_QUESTION, quiz_id: null }));
			var displayText = "Practice Questions";
		} else if (props.answerType == REVIEWS) {
			var answers = selectData(WritingSelectors.reviewsPaginated, WritingSelectors.reviews, state, props);
			var totalCount = getTotal(WritingSelectors.reviewTotal, state, props, _.where(state.answers, { question_type: QuestionTypes.REVIEW_QUESTION }));
			var displayText = "Reviews";
		} else if (props.answerType == QUESTION_BUILDERS) {
			var answers = selectData(WritingSelectors.metaCognitiveAnswersPaginated, WritingSelectors.metaCognitiveAnswers, state, props);
			var totalCount = getTotal(WritingSelectors.metaCognitiveAnswerTotal, state, _.where(state.answers, { question_type: QuestionTypes.META_COGNITIVE_QUESTION }));
			var displayText = "Question Builders";
		} else {
			var answers = selectData(WritingSelectors.answersPaginated, WritingSelectors.answers, state, props);
			var totalCount = getTotal(WritingSelectors.answerTotal, state, props);
			var displayText = "Writing";
		}
	
		return {
			totalCount: totalCount,
			answers: sortItems(answers),
			loading: WritingSelectors.isLoadingAnswers({ state: state }),
			displayText: displayText
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				var conditions = propsToConditions(props);
				var page = props.page || 1;
				// TODO: standardize FE requests
				if (props.answerType == PRACTICE_QUESTIONS) {
					// if the dataset of students is large, send multiple requests
					if ($wr.isLargeRequest(props.userIDs)) {
						var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
						var actionFunction = WritingActions.fetchNonQuizAnswers;
						var options = { embeds: ["answer.question", "answer.evaluation", "evaluation.score_details", "answer.meta_data"], cache: true };
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
					} else {
						return dispatch(WritingActions.fetchNonQuizAnswers({
							conditions: conditions,
							embeds: ["answer.question", "answer.evaluation", "evaluation.score_details", "answer.meta_data"],
							page: page,
							cache: true
						}));
					}
				} else if (props.answerType == REVIEWS) {
					if ($wr.isLargeRequest(props.userIDs)) {
						var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
						var actionFunction = WritingActions.fetchReviews;
						var options = { embeds: ["answer.meta_data"], cache: true };
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
					} else {
						return dispatch(WritingActions.fetchReviews({
							conditions: conditions,
							embeds: ["answer.meta_data"],
							page: page,
							cache: true
						}));
					}
				} else if (props.answerType == QUESTION_BUILDERS) {
					if ($wr.isLargeRequest(props.userIDs)) {
						var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
						var actionFunction = WritingActions.fetchMetaCognitionAnswers;
						var options = { embeds: ["answer.meta_data"], cache: true, page: page };
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
					} else {
						return dispatch(WritingActions.fetchMetaCognitionAnswers({
							conditions: conditions,
							embeds: ["answer.meta_data"],
							page: page,
							cache: true
						}));
					}
				} else {
					if ($wr.isLargeRequest(props.userIDs)) {
						var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
						var actionFunction = WritingActions.fetchAnswers;
						var options = { embeds: ["answer.question", "question.answer_options", "answer.evaluation", "evaluation.score_details", "answer.meta_data"], cache: true };
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
					} else {
						return dispatch(WritingActions.fetchAnswers({
							conditions: conditions,
							embeds: ["answer.question", "question.answer_options", "answer.evaluation", "evaluation.score_details", "answer.meta_data"],
							page: page,
							cache: true
						}));
					}
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataAnswers, _React$Component);
	
		function DataAnswers(props) {
			_classCallCheck(this, DataAnswers);
	
			var _this = _possibleConstructorReturn(this, (DataAnswers.__proto__ || Object.getPrototypeOf(DataAnswers)).call(this));
	
			autobind(_this);
	
			_this.state = { currentAnswerPage: 1 };
	
			LuckyOrangeClient.tagComponent("DataAnswers");
			return _this;
		}
		// FE pagination controlls for large requests
	
	
		_createClass(DataAnswers, [{
			key: "onFrontendPaginationChange",
			value: function onFrontendPaginationChange(page) {
				this.setState({ currentAnswerPage: page });
			}
		}, {
			key: "changeLocationState",
			value: function changeLocationState(quizID) {
				var newLocationState = _extends({}, this.props.prevLocationState);
				this.props.updateRoute(newLocationState);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var isAllWriting = this.props.answerType == ALL_ANSWERS;
	
				if (this.props.showFullData) {
					var answers = this.props.answers;
				} else {
					var answers = _.first(this.props.answers, 1);
					// var paywallDisplay = this.renderWritingPaywallDisplay();
				}
	
				if (this.props.fakePerPage) {
					answers = _.first(answers, this.props.fakePerPage);
				}
	
				if (this.props.loading) {
					var loadingDisplay = React.createElement(Spinner, null);
				} else {
					if (answers.length > 0) {
						var answerDisplays = _.map(answers, function (answer) {
							var userID = answer.user_id;
	
							var enabled = _extends({}, _this2.props.enabled);
	
							var isReview = answer.question_type == QuestionTypes.REVIEW_QUESTION;
							var forQuiz = answer.quiz_id != undefined;
	
							if (isReview) {
								delete enabled.score;
							}
							if (forQuiz) {
								delete enabled.score;
								delete enabled.editControls;
								delete enabled.allowRevision;
							}
	
							var view = isReview ? AnswerDisplay.REVIEWS_VIEW : AnswerDisplay.ANSWERS_VIEW;
	
							return React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
								enabled: enabled, view: view });
						});
						if (!this.props.showFullData) {
							var truncatedRow = React.createElement(TruncatedDataNote, { total: this.props.answers.length, type: PRACTICE_QUESTIONS.replace(/-/g, ' ') });
						}
					} else {
						if (this.props.sketchEmptyState) {
							var emptyState = React.createElement(EmptyState, { type: PRACTICE_QUESTIONS });
						} else {
							var noAnswers = React.createElement(NoActivityBlock, { userIDs: this.props.userIDs, contentType: this.props.displayText });
						}
					}
				}
	
				if (this.props.onPageChange && this.props.totalCount) {
					if (this.props.showFullData) {
						if (answerDisplays && $wr.isLargeRequest(this.props.userIDs)) {
							// chunck all quizzes for pagination
							answerDisplays = _.chunk(answerDisplays, this.props.perPage || DataRouting.PER_PAGE)[this.state.currentAnswerPage - 1];
							//	pagination control
							var pagination = React.createElement(PaginationControls, { page: this.state.currentAnswerPage,
								perPage: DataRouting.PER_PAGE,
								totalCount: this.props.totalCount,
								onPageChange: this.onFrontendPaginationChange });
						} else {
							var pagination = React.createElement(PaginationControls, { page: this.props.page || 1,
								perPage: this.props.perPage || DataRouting.PER_PAGE,
								perPageOptions: PaginationControls.DEFAULT_PAGE_OPTIONS,
								totalCount: this.props.totalCount,
								onPageChange: this.props.onPageChange });
						}
					}
				}
	
				return React.createElement(
					"div",
					{ className: "dataAnswers" },
					pagination,
					emptyState,
					noAnswers,
					loadingDisplay,
					answerDisplays,
					truncatedRow,
					pagination
				);
			}
		}]);
	
		return DataAnswers;
	}(React.Component)) || _class) || _class);
	
	
	DataAnswers.defaultProps = {
		enabled: {}
	};
	
	DataAnswers.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		page: PropTypes.number,
		perPage: PropTypes.number,
		fakePerPage: PropTypes.number,
		order: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		textVariety: PropTypes.string,
		textID: PropTypes.string,
		showFullData: PropTypes.bool,
		answerType: PropTypes.string,
		onPageChange: PropTypes.func,
		showOnDashboard: PropTypes.bool,
		displayText: PropTypes.string,
		sketchEmptyState: PropTypes.bool,
		studentList: PropTypes.string,
		currentAnswerPage: PropTypes.number,
		prevLocationState: PropTypes.object,
		updateRoute: PropTypes.func,
	
		// Reference AnswerDisplay 'enabled'
		enabled: PropTypes.object,
	
		// Data from @connect
		loading: PropTypes.bool,
		answers: PropTypes.array,
		totalCount: PropTypes.number,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	var PRACTICE_QUESTIONS = "practice-questions";
	var REVIEWS = "reviews";
	var ALL_ANSWERS = "all-answers";
	var QUESTION_BUILDERS = "Question Builders";
	
	DataAnswers.PRACTICE_QUESTIONS = PRACTICE_QUESTIONS;
	DataAnswers.REVIEWS = REVIEWS;
	DataAnswers.QUESTION_BUILDERS = QUESTION_BUILDERS;
	DataAnswers.ALL_ANSWERS = ALL_ANSWERS;
	
	DataAnswers.ANSWER_TYPE_LOOKUP = (_DataAnswers$ANSWER_T = {}, _defineProperty(_DataAnswers$ANSWER_T, DataRouting.SUBJECT_ANSWERS, PRACTICE_QUESTIONS), _defineProperty(_DataAnswers$ANSWER_T, DataRouting.SUBJECT_REVIEWS, REVIEWS), _defineProperty(_DataAnswers$ANSWER_T, DataRouting.SUBJECT_QUESTION_BUILDERS, QUESTION_BUILDERS), _defineProperty(_DataAnswers$ANSWER_T, DataRouting.SUBJECT_WRITING, ALL_ANSWERS), _DataAnswers$ANSWER_T);
	
	module.exports = DataAnswers;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentMetrics = __webpack_require__(29);
	
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	
	var GoalsTable = __webpack_require__(742);
	var RosterSelectors = __webpack_require__(6);
	
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdown = __webpack_require__(23);
	var TruncatedDataNote = __webpack_require__(159);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "userIDs");
	
		return conditions;
	}
	
	var DataGoals = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			digests: DataSelectors.digests({ state: state, conditions: { userIDs: props.userIDs } }),
			students: RosterSelectors.students({ state: state, conditions: { ids: props.userIDs } }),
			loading: DataSelectors.isLoadingDigests({ state: state, key: 'index', userIDs: props.userIDs }),
			expectationMetrics: DataSelectors.expectationsMetrics({ state: state })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				var query = {};
	
				var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
				if (!props.showGoals) {
	
					// This is a problem because it
					query.digest_embed = StudentMetrics.getDigestEmbeds(DataSelectors.dashboardOtherMetrics({}));
				}
				// TODO: standardize FE requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate");
					var actionFunction = DataActions.fetchDigests;
					var options = { cache: true, query: query };
					return new Promise(function (resolve, reject) {
						resolve($wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null));
					}).catch(function () {
						return console.log("Digests failed to load");
					});
				} else {
					return dispatch(DataActions.fetchDigests({
						conditions: propsToConditions(props),
						query: query,
						cache: true
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataGoals, _React$Component);
	
		function DataGoals(props) {
			_classCallCheck(this, DataGoals);
	
			var _this = _possibleConstructorReturn(this, (DataGoals.__proto__ || Object.getPrototypeOf(DataGoals)).call(this));
	
			autobind(_this);
			_this.state = { selectedTypeText: "Top 3" };
			if (!props.showGoals) {
				LuckyOrangeClient.tagComponent("OtherStatsTable");
			} else {
				LuckyOrangeClient.tagComponent("GoalsTable");
			}
			LuckyOrangeClient.tagComponent("DataGoals");
			return _this;
		}
	
		_createClass(DataGoals, [{
			key: "changeGoalSort",
			value: function changeGoalSort(option) {
				this.setState({ selectedTypeText: option });
			}
		}, {
			key: "render",
			value: function render() {
				var passProps = _.pick(this.props, "userIDs", "studentList", "showGoals", "showTotals", "studentLimit");
				if (this.props.studentLimit) {
					var goalsOptions = DropDownOptions.Button.simpleText({
						options: [TOP_VIEW, BOTTOM_VIEW, RECENT_VIEW],
						onClick: this.changeGoalSort
					});
					var sortTypeDropdown = React.createElement(
						ButtonDropdown,
						{ text: this.state.selectedTypeText, dropdownDisplay: "link",
							className: "goalsDropdown" },
						goalsOptions
					);
	
					if (this.state.selectedTypeText == TOP_VIEW) {
						var resultType = GoalsTable.TOP_RESULTS;
					} else if (this.state.selectedTypeText == BOTTOM_VIEW) {
						var resultType = GoalsTable.BOTTOM_RESULTS;
					} else if (this.state.selectedTypeText == RECENT_VIEW) {
						var resultType = GoalsTable.LAST_ACTIVE;
					}
				} else {
					if (!this.props.showFullData) {
						var resultType = GoalsTable.TOP_RESULTS;
						var truncatedRow = React.createElement(TruncatedDataNote, { type: GOALS });
					}
				}
	
				var display = React.createElement(
					"div",
					{ className: "dataGoals" },
					sortTypeDropdown,
					React.createElement(GoalsTable, _extends({}, passProps, { reloadF: this.props.populateData, digests: this.props.digests,
						sortByResults: resultType, showFullData: this.props.showFullData })),
					truncatedRow
				);
				return React.createElement(
					"div",
					null,
					display
				);
			}
		}]);
	
		return DataGoals;
	}(React.Component)) || _class) || _class);
	
	
	var TOP_VIEW = "Top 3";
	var BOTTOM_VIEW = "Bottom 3";
	var RECENT_VIEW = "Recently Active";
	var GOALS = "goals";
	
	DataGoals.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showGoals: PropTypes.bool,
		showFullData: PropTypes.bool,
		showTotals: PropTypes.bool,
		studentLimit: PropTypes.number,
		expectationMetrics: PropTypes.array,
		students: PropTypes.array,
		studentList: PropTypes.string,
	
		// Data from @connect
		loading: PropTypes.bool,
		digests: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataGoals;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var AllMonthsLogTable = __webpack_require__(240);
	var ItemHeader = __webpack_require__(160);
	var Spinner = __webpack_require__(9);
	var NoActivityBlock = __webpack_require__(71);
	var EmptyState = __webpack_require__(117);
	var UIActions = __webpack_require__(41);
	var PaywallModal = __webpack_require__(44);
	var Features = __webpack_require__(16);
	
	__webpack_require__(3631);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs");
	
		conditions.timeKey = "log_date";
	
		return conditions;
	}
	
	var DataLogTables = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			logs: ReadingSelectors.logs({
				state: state, conditions: propsToConditions(props)
			}),
			loading: ReadingSelectors.isLoadingLogs({ state: state }),
			hasLogReading: Features.isEnabled(Features.LOG_READING)
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID");
					conditions.timeKey = 'log_date';
					var actionFunction = ReadingActions.fetchLogs;
					var options = { cache: true };
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
							resolve(results);
						});
					}).catch(function () {
						return console.log("Logs failed to load");
					});
				} else {
					return dispatch(ReadingActions.fetchLogs({
						conditions: propsToConditions(props),
						cache: true
					}));
				}
			},
			openLogReadingPaywall: function openLogReadingPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataLogTables, _React$Component);
	
		function DataLogTables(props) {
			_classCallCheck(this, DataLogTables);
	
			var _this = _possibleConstructorReturn(this, (DataLogTables.__proto__ || Object.getPrototypeOf(DataLogTables)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("DataLogTables");
			return _this;
		}
	
		_createClass(DataLogTables, [{
			key: "fetchUserLogs",
			value: function fetchUserLogs(userID) {
				var logs = _.where(this.props.logs, { user_id: userID });
				logs = _.sortBy(logs, "log_date").reverse();
				return logs;
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (!this.props.condensedLayout) {
					var logsDisplay = [];
					// renders hidden component used for printing
					// without pagination
					var printableLogsDisplay = [];
					var studentsWithoutLogs = [];
	
					_.each(this.props.userIDs, function (studentID) {
						var logs = _.where(_this2.props.logs, { user_id: studentID });
						if (logs.length > 0) {
							logsDisplay.push(React.createElement(
								"div",
								{ key: studentID },
								React.createElement(ItemHeader, { studentID: studentID, pageBreak: true }),
								React.createElement(AllMonthsLogTable, { initExpanded: true, embedded: true, logs: logs, key: studentID,
									softMax: _this2.props.softMaxPerTable })
							));
							printableLogsDisplay.push(React.createElement(
								"div",
								{ key: studentID },
								React.createElement(ItemHeader, { studentID: studentID, pageBreak: true }),
								React.createElement(AllMonthsLogTable, { initExpanded: true, embedded: true, logs: logs, key: studentID,
									softMax: _.size(logs) })
							));
						} else {
							studentsWithoutLogs.push(studentID);
						}
					});
					if (studentsWithoutLogs.length > 0) {
						var noLogs = React.createElement(NoActivityBlock, { userIDs: studentsWithoutLogs, contentType: "Reading Logs" });
					}
					var display = React.createElement(
						"div",
						null,
						React.createElement(
							"span",
							{ className: "hideOnPrint" },
							logsDisplay
						),
						React.createElement(
							"span",
							{ className: "showOnPrint" },
							printableLogsDisplay
						),
						noLogs
					);
				} else {
					if (this.props.logs.length > 0) {
						var selectedUserIDs = _.sortBy(this.props.userIDs, function (userID) {
							var logs = _this2.fetchUserLogs(userID);
							if (logs.length > 0) {
								return logs[0].log_date;
							} else {
								return "1900-01-01";
							}
						}).reverse();
						selectedUserIDs = _.first(selectedUserIDs, 3);
						var logsDisplay = _.map(selectedUserIDs, function (studentID) {
							var logs = _.first(_this2.fetchUserLogs(studentID), 3);
							if (logs.length > 0) {
								var header = React.createElement(ItemHeader, { studentID: studentID, pageBreak: true });
								return React.createElement(
									"div",
									{ key: studentID },
									header,
									React.createElement(AllMonthsLogTable, { initExpanded: true, embedded: true, condensedLayout: true,
										logs: logs, key: studentID,
										softMax: _this2.props.softMaxPerTable })
								);
							}
						});
						// renders hidden component used for printing
						// without pagination
						var printableDisplay = _.map(selectedUserIDs, function (studentID) {
							var logs = _.first(_this2.fetchUserLogs(studentID), 3);
							if (logs.length > 0) {
								var header = React.createElement(ItemHeader, { studentID: studentID, pageBreak: true });
								return React.createElement(
									"div",
									{ key: studentID },
									header,
									React.createElement(AllMonthsLogTable, { initExpanded: true, embedded: true, condensedLayout: true,
										logs: logs, key: studentID,
										softMax: _.size(logs) })
								);
							}
						});
	
						var display = React.createElement(
							"div",
							null,
							React.createElement(
								"span",
								{ className: "hideOnPrint" },
								logsDisplay
							),
							React.createElement(
								"span",
								{ className: "showOnPrint" },
								printableLogsDisplay
							)
						);
					} else {
						if (!this.props.hasLogReading) {
							var silverText = React.createElement(
								"p",
								{ className: "silverTextContainer" },
								React.createElement(
									"i",
									null,
									"Reading Logs"
								),
								" are a part of Whooo's Reading Silver.",
								React.createElement(
									"a",
									{ className: "btn btn-link", onClick: this.props.openLogReadingPaywall },
									"Learn about WR Silver"
								)
							);
						}
						var emptyState = React.createElement(EmptyState, { type: LOGS });
					}
				}
	
				return React.createElement(
					"div",
					{ className: "dataLogTables" },
					silverText,
					emptyState,
					display,
					printableDisplay
				);
			}
		}]);
	
		return DataLogTables;
	}(React.Component)) || _class) || _class);
	
	var LOGS = "logs";
	DataLogTables.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showFullData: PropTypes.bool,
		condensedLayout: PropTypes.bool,
		softMaxPerTable: PropTypes.number,
	
		// Data from @connect
		loading: PropTypes.bool,
		logs: PropTypes.array,
		openLogReadingPaywall: PropTypes.func,
		hasLogReading: PropTypes.bool,
	
		// Handlers from @connect
		populateData: PropTypes.func,
	
		// URL params
		studentList: PropTypes.string
	});
	
	module.exports = DataLogTables;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var ReadingLevelGraph = __webpack_require__(743);
	var ItemHeader = __webpack_require__(160);
	var EmptyState = __webpack_require__(117);
	var TruncatedDataNote = __webpack_require__(159);
	
	function propsToBookConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "userIDs");
	
		conditions.timeKey = "last_active_by_user_id";
	
		return conditions;
	}
	function propsToReadingLevelConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "userIDs");
	
		return conditions;
	}
	
	var DataReadingLevelGraph = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			loading: ReadingSelectors.isLoadingBooks({ state: state }) || ReadingSelectors.isLoadingReadingLevels({ state: state }),
			books: ReadingSelectors.books({
				state: state,
				conditions: propsToBookConditions(props),
				showLogs: Features.isEnabled(Features.LOG_READING),
				showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES)
			}),
			readingLevels: ReadingSelectors.readingLevels({
				state: state,
				conditions: propsToReadingLevelConditions(props)
			})
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				// if the dataset of students is large, send multiple requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate");
					var actionFunction = ReadingActions.fetchBookActivity;
					var options = { embeds: ["book.quiz_evaluations", "book.log_sums"], cache: true, fetchDetails: false };
	
					return new Promise(function (resolve, reject) {
						// books
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
							var responses = results;
							actionFunction = ReadingActions.fetchReadingLevels;
							options = { cache: true
								// reading level
							};$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
								var tasks = second_results;
								resolve(_.compact(_.flatten(tasks.concat(responses))));
							});
						});
					}).catch(function () {
						return console.log("Book activity and reading levels failed to load");
					});
				} else {
					var booksPromise = dispatch(ReadingActions.fetchBookActivity({
						conditions: propsToBookConditions(props),
						embeds: ["book.quiz_evaluations", "book.log_sums"],
						fetchDetails: false, // We'll load in book details in a second step
						cache: true
					}));
	
					var readingLevelPromise = dispatch(ReadingActions.fetchReadingLevels({
						conditions: propsToReadingLevelConditions(props),
						cache: true
					}));
	
					return Promise.all([booksPromise, readingLevelPromise]);
				}
			},
	
			fetchBookDetails: function fetchBookDetails(textIDs) {
				return dispatch(ReadingActions.fetchBooks({
					ids: textIDs,
					userID: CurrentUser.get().id
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataReadingLevelGraph, _React$Component);
	
		function DataReadingLevelGraph(props) {
			_classCallCheck(this, DataReadingLevelGraph);
	
			var _this = _possibleConstructorReturn(this, (DataReadingLevelGraph.__proto__ || Object.getPrototypeOf(DataReadingLevelGraph)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("DataReadingLevelGraphs");
			return _this;
		}
	
		_createClass(DataReadingLevelGraph, [{
			key: "getBooks",
			value: function getBooks(studentID) {
				return _.select(this.props.books, function (book) {
					return _.includes(book.user_ids, studentID);
				});
			}
		}, {
			key: "getUserIDs",
			value: function getUserIDs() {
				var _this2 = this;
	
				var userIDs = this.props.userIDs;
				if (this.props.studentLimit) {
					userIDs = _.sortBy(userIDs, function (studentID) {
						var recentBook = _.sortBy(_.map(_this2.getBooks(studentID)), function (book) {
							if (book.last_actives) {
								return book.last_actives[studentID];
							}
						}).reverse()[0];
	
						if (recentBook && recentBook.last_actives) {
							return recentBook.last_actives[studentID];
						} else {
							return "1970-01-01";
						}
					}).reverse();
					userIDs = _.first(userIDs, this.props.studentLimit);
				}
				return userIDs;
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				if (this.props.userIDs && this.props.userIDs.length == 0) {
					var emptyState = React.createElement(EmptyState, { type: RL_GRAPH });
				} else {
					if (this.props.showFullData) {
						var userIDs = this.getUserIDs();
					} else {
						var userIDs = _.first(this.getUserIDs(), 3);
						var truncatedRow = React.createElement(TruncatedDataNote, { type: RL_GRAPH });
					}
					var display = _.map(userIDs, function (studentID) {
						var books = _this3.getBooks(studentID);
	
						var readingLevels = _.where(_this3.props.readingLevels, { student_id: studentID });
	
						var header = React.createElement(ItemHeader, { studentID: studentID, pageBreak: true });
	
						return React.createElement(
							"div",
							{ className: "studentReadingLevelGraph", key: studentID },
							header,
							React.createElement(ReadingLevelGraph, { studentID: studentID,
								numMonths: _this3.props.numMonths,
								readingLevels: readingLevels, books: books })
						);
					});
				}
	
				return React.createElement(
					"div",
					{ className: "dataReadingLevelGraph" },
					display,
					emptyState,
					truncatedRow
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this4 = this;
	
				var textIDs = _.uniq(_.flatten(_.map(this.getUserIDs(), function (userID) {
					return _.pluck(_this4.getBooks(userID), "text_id");
				})));
	
				this.props.fetchBookDetails(textIDs);
			}
		}]);
	
		return DataReadingLevelGraph;
	}(React.Component)) || _class) || _class);
	
	var RL_GRAPH = "reading-level-graph";
	DataReadingLevelGraph.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showFullData: PropTypes.bool,
		studentLimit: PropTypes.number,
		numMonths: PropTypes.number,
	
		// Data from @connect
		loading: PropTypes.bool,
		books: PropTypes.array,
		readingLevels: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func,
		fetchBookDetails: PropTypes.func
	});
	
	module.exports = DataReadingLevelGraph;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var TextTable = __webpack_require__(844);
	var ItemHeader = __webpack_require__(160);
	var NoActivityBlock = __webpack_require__(71);
	var Spinner = __webpack_require__(9);
	var EmptyState = __webpack_require__(117);
	var TruncatedDataNote = __webpack_require__(159);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs");
	
		conditions.timeKey = "last_active_by_user_id";
	
		return conditions;
	}
	
	var DataTextTables = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			loading: ReadingSelectors.isLoadingBooks({ state: state }),
			books: ReadingSelectors.books({
				state: state,
				conditions: propsToConditions(props)
			}),
			showLogs: Features.isEnabled(Features.LOG_READING),
			showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES)
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				// if the dataset of students is large, send multiple requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID");
					var actionFunction = ReadingActions.fetchBookActivity;
					var options = { embeds: ["book.quiz_evaluations", "book.log_sums"], cache: true, fetchDetails: !props.skipPreloadDetails };
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
							resolve(results);
						});
					}).catch(function () {
						return console.log("Book activity failed to load");
					});
				} else {
					return dispatch(ReadingActions.fetchBookActivity({
						userID: CurrentUser.get().id,
						conditions: propsToConditions(props),
						embeds: ["book.quiz_evaluations", "book.log_sums"],
						fetchDetails: !props.skipPreloadDetails,
						cache: true
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataTextTables, _React$Component);
	
		function DataTextTables(props) {
			_classCallCheck(this, DataTextTables);
	
			var _this = _possibleConstructorReturn(this, (DataTextTables.__proto__ || Object.getPrototypeOf(DataTextTables)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("DataTextTables");
			return _this;
		}
	
		_createClass(DataTextTables, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.byStudent) {
					var textTables = [];
					var studentsWithoutBooks = [];
					var booksTotal = 0;
					_.each(this.props.userIDs, function (studentID) {
						var books = _.select(_this2.props.books, function (book) {
							return _.includes(book.user_ids, studentID);
						});
	
						booksTotal += books.length;
	
						if (!_this2.props.showFullData) {
							books = _.first(books, 3);
						}
	
						if (books.length > 0) {
							textTables.push(React.createElement(
								"div",
								{ key: studentID },
								React.createElement(ItemHeader, { studentID: studentID, pageBreak: true }),
								React.createElement(TextTable, { books: books, userID: studentID,
									showLogStats: _this2.props.showLogs,
									softMax: _this2.props.softMaxPerTable,
									showResponseCounts: _this2.props.showDigitalActivities })
							));
						} else {
							studentsWithoutBooks.push(studentID);
						}
					});
					if (studentsWithoutBooks.length > 0) {
						if (this.props.showFullData) {
							var noTables = React.createElement(NoActivityBlock, { userIDs: studentsWithoutBooks, contentType: "Books" });
						} else {
							if (_.isEmpty(textTables)) {
								var noTables = React.createElement(NoActivityBlock, { userIDs: studentsWithoutBooks, contentType: "Books" });
							}
						}
					}
					if (this.props.showFullData) {
						var textTables = textTables;
					} else {
						if (textTables.length > 0) {
							var truncatedRow = React.createElement(TruncatedDataNote, { total: booksTotal, type: BOOKS });
						}
						var textTables = textTables[0];
					}
					var display = React.createElement(
						"div",
						null,
						textTables,
						noTables,
						truncatedRow
					);
				} else {
					var books = _.sortBy(this.props.books, "max_last_active").reverse();
					if (books.length > 0) {
						if (this.props.booksAmount) {
							books = _.first(books, this.props.booksAmount);
						}
						var display = React.createElement(TextTable, { books: books,
							showLogStats: this.props.showLogs,
							softMax: this.props.softMaxPerTable,
							showResponseCounts: this.props.showDigitalActivities,
							showStudentCell: true });
					} else {
						var emptyState = React.createElement(EmptyState, { type: BOOKS });
					}
				}
				return React.createElement(
					"div",
					{ className: "dataTextTables" },
					emptyState,
					display
				);
			}
		}]);
	
		return DataTextTables;
	}(React.Component)) || _class) || _class);
	
	var BOOKS = "books";
	DataTextTables.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showFullData: PropTypes.bool,
		textVariety: PropTypes.string,
	
		byStudent: PropTypes.bool,
		booksAmount: PropTypes.number,
		showLogs: PropTypes.bool,
		showDigitalActivities: PropTypes.bool,
		skipPreloadDetails: PropTypes.bool,
		softMaxPerTable: PropTypes.number,
	
		// Data from @connect
		loading: PropTypes.bool,
		books: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataTextTables;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var Glyphicon = __webpack_require__(8);
	var BookAnswersAnalysisTable = __webpack_require__(768);
	var AutograderDisplayConfig = __webpack_require__(83);
	
	__webpack_require__(3634);
	
	var DataTable = function (_React$Component) {
	  _inherits(DataTable, _React$Component);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this));
	
	    autobind(_this);
	
	    _this.state = {
	      expandedRows: []
	    };
	    return _this;
	  }
	
	  _createClass(DataTable, [{
	    key: "colorClasses",
	    value: function colorClasses(value) {
	      // if value is not a string, return black
	      if (!(typeof value == 'string')) {
	        return { backgroundClass: 'backgroundColor-black', fontClass: 'fontColor-black' };
	      }
	
	      if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-green';
	        var fontClass = 'fontColor-green';
	      } else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-red';
	        var fontClass = 'fontColor-red';
	      } else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-yellow';
	        var fontClass = 'fontColor-yellow';
	      }
	
	      return { backgroundClass: backgroundClass, fontClass: fontClass };
	    }
	  }, {
	    key: "renderEmptyColumn",
	    value: function renderEmptyColumn() {
	      return React.createElement(
	        "div",
	        { className: "emptyColumn" },
	        React.createElement(Glyphicon, { icon: "minus", className: "minusSign" })
	      );
	    }
	  }, {
	    key: "buildBookAnswersAnalysisTable",
	    value: function buildBookAnswersAnalysisTable() {
	      var tableHash = this.state.bookAnswersAnalysisTable;
	      if (tableHash.show) {
	        var textID = tableHash.textID,
	            userID = tableHash.userID;
	
	        return React.createElement(BookAnswersAnalysisTable, { textID: textID, userID: userID });
	      }
	    }
	  }, {
	    key: "buildAvatarColumn",
	    value: function buildAvatarColumn(cell) {
	      return React.createElement(
	        "div",
	        { className: "avatarCell" },
	        React.createElement(
	          "div",
	          { className: "col-left" },
	          cell.avatar
	        ),
	        React.createElement("div", { className: "col-middle" }),
	        React.createElement(
	          "div",
	          { className: "col-right" },
	          cell.value
	        )
	      );
	    }
	  }, {
	    key: "buildRubricColumn",
	    value: function buildRubricColumn(cell) {
	      var _this2 = this;
	
	      var rubricItems = _.map(cell.value, function (label, key) {
	        if (label) {
	          var _colorClasses = _this2.colorClasses(label),
	              fontClass = _colorClasses.fontClass;
	
	          var output = $wr.toTitleCase(label);
	          if (output in OUTPUT_ABBREV) {
	            output = OUTPUT_ABBREV[output];
	          }
	          return React.createElement(
	            "span",
	            { key: key, className: "rubricItemContainer" },
	            React.createElement(
	              "div",
	              { className: "rubricItem" },
	              RUBRIC_ITEM_NAMES[key],
	              ":"
	            ),
	            React.createElement(
	              "div",
	              { className: "rubricItemValue " + fontClass },
	              output
	            )
	          );
	        }
	      });
	
	      return React.createElement(
	        "span",
	        null,
	        rubricItems
	      );
	    }
	  }, {
	    key: "buildReadBookColumn",
	    value: function buildReadBookColumn(cell) {
	      var _colorClasses2 = this.colorClasses(cell.value),
	          backgroundClass = _colorClasses2.backgroundClass,
	          fontClass = _colorClasses2.fontClass;
	
	      return React.createElement(
	        "div",
	        { className: "readBookCell " + backgroundClass },
	        React.createElement(
	          "div",
	          { className: "readBookCellValue " + fontClass },
	          $wr.toTitleCase(cell.value)
	        )
	      );
	    }
	  }, {
	    key: "toggleExpandedContent",
	    value: function toggleExpandedContent(cell) {
	      if (cell.book_answers_analysis) {
	        var _cell$book_answers_an = cell.book_answers_analysis,
	            userID = _cell$book_answers_an.userID,
	            textID = _cell$book_answers_an.textID;
	
	        this.setState({
	          bookAnswersAnalysisTable: {
	            show: !this.state.bookAnswersAnalysisTable.show,
	            userID: userID,
	            textID: textID
	          }
	        });
	      }
	    }
	  }, {
	    key: "expandContent",
	    value: function expandContent(rowIndex) {
	      if (_.includes(this.state.expandedRows, rowIndex)) {
	        this.setState({ expandedRows: [].concat(_toConsumableArray(_.omit(this.state.expandedRows, rowIndex))) });
	      } else {
	        this.setState({ expandedRows: [].concat(_toConsumableArray(this.state.expandedRows), [rowIndex]) });
	      }
	    }
	  }, {
	    key: "buildShowMoreLink",
	    value: function buildShowMoreLink(rowIndex) {
	      var _this3 = this;
	
	      return React.createElement(
	        "div",
	        { onClick: function onClick() {
	            return _this3.expandContent(rowIndex);
	          }, className: "showMoreText" },
	        "Show More"
	      );
	    }
	  }, {
	    key: "renderToolTip",
	    value: function renderToolTip(confidence) {
	      var dataTip = confidence + "% Confidence";
	      return React.createElement(
	        "div",
	        { className: "infoTooltip" },
	        React.createElement(Glyphicon, { icon: "info-sign", className: "infoSign", dataTip: dataTip }),
	        React.createElement(ReactTooltip, { effect: "solid" })
	      );
	    }
	
	    // needs to be handled differently
	
	  }, {
	    key: "buildBookAnswerAnalysisColumn",
	    value: function buildBookAnswerAnalysisColumn(cell, rowIndex) {
	      var _colorClasses3 = this.colorClasses(cell.value),
	          backgroundClass = _colorClasses3.backgroundClass,
	          fontClass = _colorClasses3.fontClass;
	
	      if (cell.confidence) {
	        var confidenceValue = Math.round(cell.confidence * 100);
	        var confidence = React.createElement(
	          "div",
	          { className: "confidenceValue " + fontClass },
	          confidenceValue,
	          "%"
	        );
	        var showMore = this.buildShowMoreLink(rowIndex);
	        var toolTip = this.renderToolTip(confidenceValue);
	      }
	
	      // could render a string or a link
	      var cellValue = typeof cell.value == 'string' ? $wr.toTitleCase(cell.value) : cell.value;
	
	      return React.createElement(
	        "div",
	        { className: "detailedReadBookColumn" },
	        React.createElement(
	          "div",
	          { className: "readBookCell " + backgroundClass },
	          React.createElement(
	            "div",
	            { className: "readBookCellValue " + fontClass },
	            cellValue
	          )
	        ),
	        confidence,
	        toolTip
	      );
	    }
	  }, {
	    key: "generateExpandedContent",
	    value: function generateExpandedContent(row, index) {
	      if (this.props.subjectType) {
	        switch (this.props.subjectType) {
	          // for the books table, expanded content will be book answers analysis table
	          case BOOKS:
	            var bookAnswersAnalysisColumn = _.findWhere(row, { book_answers_analysis_column: true });
	            var component_props = bookAnswersAnalysisColumn.expanded_content.component_props;
	
	
	            var expandedClass = _.includes(this.state.expandedRows, index) ? 'expanded' : '';
	            return React.createElement(
	              "tr",
	              { className: "bookAnswersAnalysisTableRow " + expandedClass },
	              React.createElement(
	                "td",
	                { className: "tableContiner", colSpan: _.size(this.props.columnHeaders) },
	                React.createElement(BookAnswersAnalysisTable, component_props)
	              )
	            );
	        }
	      }
	    }
	  }, {
	    key: "generateColumns",
	    value: function generateColumns(row, rowIndex) {
	      var _this4 = this;
	
	      var columns = _.map(row, function (cell, index) {
	        var cellContent = cell.value;
	
	        if (_.isEmpty(cell.value) || !cell.value) {
	          cellContent = _this4.renderEmptyColumn();
	        } else {
	          if (cell.avatar) {
	            cellContent = _this4.buildAvatarColumn(cell);
	          }
	
	          if (cell.link) {
	            cellContent = React.createElement(
	              "a",
	              { href: cell.link },
	              cell.value
	            );
	          }
	
	          if (cell.read_book_column) {
	            cellContent = _this4.buildReadBookColumn(cell);
	          }
	
	          if (cell.rubric_column) {
	            cellContent = _this4.buildRubricColumn(cell);
	          }
	
	          if (cell.book_answers_analysis_column) {
	            cellContent = _this4.buildBookAnswerAnalysisColumn(cell, rowIndex);
	          }
	        }
	
	        return React.createElement(
	          "td",
	          { key: index, colSpan: 1, className: "cell " + cell.classes.join(' ') },
	          cellContent
	        );
	      });
	
	      return React.createElement(
	        "tr",
	        null,
	        columns
	      );
	    }
	  }, {
	    key: "generateRows",
	    value: function generateRows() {
	      var _this5 = this;
	
	      return _.map(this.props.rows, function (row, index) {
	        return React.createElement(
	          "tbody",
	          { key: index, className: "tbodyRow" },
	          _this5.generateColumns(row, index),
	          _this5.generateExpandedContent(row, index)
	        );
	      });
	    }
	  }, {
	    key: "generateHeaders",
	    value: function generateHeaders() {
	      return _.map(this.props.columnHeaders, function (header) {
	        if (_.includes(_.keys(HEADER_TOOLTIPS), header)) {
	          var dataTip = HEADER_TOOLTIPS[header];
	          return React.createElement(
	            "th",
	            { key: header, className: "columnHeader", "data-tip": dataTip, "data-for": "columnDataTip" },
	            header,
	            React.createElement(ReactTooltip, { effect: "solid", id: "columnDataTip" })
	          );
	        } else {
	          return React.createElement(
	            "th",
	            { key: header, className: "columnHeader" },
	            header
	          );
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          printable = _props.printable,
	          subjectType = _props.subjectType;
	
	
	      return React.createElement(
	        "div",
	        { className: "dataTable " + (printable ? 'showOnPrint' : 'hideOnPrint') + " " + subjectType + "Table" },
	        React.createElement(
	          "table",
	          { className: "table" },
	          React.createElement(
	            "thead",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              this.generateHeaders()
	            )
	          ),
	          this.generateRows()
	        )
	      );
	    }
	  }]);
	
	  return DataTable;
	}(React.Component);
	
	;
	
	var BOOK_ANSWERS_ANALYSIS = 'BookAnswersAnalysis';
	var BOOKS = 'books';
	
	var HEADER_TOOLTIPS = {
	  'Rubric': 'Includes evaluations from all quiz and practice question answers completed for a specific book.',
	  'Read Book': 'Whether the entirety of the student\'s work provides enough text evidence to prove that the student read the book.'
	};
	
	var OUTPUT_ABBREV = {
	  'Sufficient': 'Suf',
	  'Insufficient': 'Insuf'
	};
	
	var RUBRIC_ITEM_NAMES = {
	  "fully_answered": 'Full Answered',
	  "restated": "Restating",
	  "text_evidence": "Text Evidence"
	};
	
	DataTable.propTypes = StrictPropTypes({
	  rows: PropTypes.array,
	  columnHeaders: PropTypes.array,
	  subjectType: PropTypes.string,
	  printable: PropTypes.bool
	});
	
	module.exports = DataTable;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3657);
	
	var WidgetTitle = function (_React$Component) {
	  _inherits(WidgetTitle, _React$Component);
	
	  function WidgetTitle(props) {
	    _classCallCheck(this, WidgetTitle);
	
	    var _this = _possibleConstructorReturn(this, (WidgetTitle.__proto__ || Object.getPrototypeOf(WidgetTitle)).call(this));
	
	    autobind(_this);
	    return _this;
	  }
	
	  _createClass(WidgetTitle, [{
	    key: "renderTitle",
	    value: function renderTitle() {
	      return React.createElement(
	        "div",
	        { className: "title" },
	        this.props.config.title
	      );
	    }
	  }, {
	    key: "renderIcon",
	    value: function renderIcon() {
	      var icon = this.props.config.icon ? this.props.config.icon : 'writing-white';
	      return React.createElement(
	        "div",
	        { className: "iconContainer hideOnPrint" },
	        React.createElement(
	          "div",
	          { className: "iconBackground" },
	          React.createElement("img", { className: "icon", src: __webpack_require__(356)("./" + icon + ".png") })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "widgetTitle" },
	        this.renderIcon(),
	        this.renderTitle()
	      );
	    }
	  }]);
	
	  return WidgetTitle;
	}(React.Component);
	
	;
	
	// WidgetTitle.WrappedComponent.propTypes = PageStrictPropTypes({
	// });
	
	module.exports = WidgetTitle;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoldenEggModal = __webpack_require__(778);
	
	var GoldenEgg = function (_React$Component) {
		_inherits(GoldenEgg, _React$Component);
	
		function GoldenEgg(props) {
			_classCallCheck(this, GoldenEgg);
	
			var _this = _possibleConstructorReturn(this, (GoldenEgg.__proto__ || Object.getPrototypeOf(GoldenEgg)).call(this));
	
			autobind(_this);
			_this.state = {
				mainEggVisible: true
			};
			return _this;
		}
	
		_createClass(GoldenEgg, [{
			key: "onClick",
			value: function onClick(e) {
				$wr.nope(e);
				this.refs.modal.show();
				Mycroft.newEvent({ category: "GoldenEgg", action: "open-egg" });
			}
		}, {
			key: "hideEgg",
			value: function hideEgg() {
				this.setState({ mainEggVisible: false });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.mainEggVisible) {
					var eggImage = React.createElement(
						"a",
						{ href: "#" },
						React.createElement("img", { src: __webpack_require__(497), className: "goldenEggOutofModal", onClick: this.onClick })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "eggs" },
					eggImage,
					React.createElement(GoldenEggModal, { ref: "modal", onComplete: this.hideEgg })
				);
			}
		}]);
	
		return GoldenEgg;
	}(React.Component);
	
	;
	
	module.exports = GoldenEgg;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Modal = __webpack_require__(18);
	var HouseInteriorRoom = __webpack_require__(779);
	var DressingRoom = __webpack_require__(776);
	var TrophyRoom = __webpack_require__(782);
	var Glyphicon = __webpack_require__(8);
	
	var LEFT = "left";
	var RIGHT = "right";
	var DRESSING = "dressing";
	var TROPHY = "trophy";
	var HOUSE = "house";
	
	__webpack_require__(3663);
	
	var HouseModal = function (_React$Component) {
		_inherits(HouseModal, _React$Component);
	
		function HouseModal(props) {
			_classCallCheck(this, HouseModal);
	
			var _this = _possibleConstructorReturn(this, (HouseModal.__proto__ || Object.getPrototypeOf(HouseModal)).call(this));
	
			autobind(_this);
			if (props.activeRoom && props.activeRoom == TROPHY) {
				var currentRoom = HouseModal.TROPHY_ROOM;
			} else if (props.activeRoom && props.activeRoom == HOUSE) {
				var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
			} else if (props.activeRoom && props.activeRoom == DRESSING) {
				var currentRoom = HouseModal.DRESSING_ROOM;
			} else {
				var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
			}
	
			_this.state = {
				currentRoom: currentRoom
	
			};
			return _this;
		}
	
		_createClass(HouseModal, [{
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps, prevState, snapshot) {
				if (prevProps.activeRoom != this.props.activeRoom) {
					if (this.props.activeRoom == TROPHY) {
						var currentRoom = HouseModal.TROPHY_ROOM;
					} else if (this.props.activeRoom == DRESSING) {
						var currentRoom = HouseModal.DRESSING_ROOM;
					} else {
						var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
					}
					this.setState({ currentRoom: currentRoom });
				}
			}
		}, {
			key: "show",
			value: function show() {
				LuckyOrangeClient.tagComponent("HouseModal");
				this.refs.modal.show();
			}
		}, {
			key: "switchRooms",
			value: function switchRooms(direction) {
				if (this.state.currentRoom == HouseModal.TROPHY_ROOM && direction == RIGHT) {
					var newRoom = this.props.ownsHouse ? HouseModal.HOUSE_INTERIOR_ROOM : HouseModal.DRESSING_ROOM;
				} else if (this.state.currentRoom == HouseModal.DRESSING_ROOM && direction == LEFT) {
					var newRoom = this.props.ownsHouse ? HouseModal.HOUSE_INTERIOR_ROOM : HouseModal.TROPHY_ROOM;
				} else if (this.state.currentRoom == HouseModal.HOUSE_INTERIOR_ROOM && direction == RIGHT) {
					var newRoom = HouseModal.DRESSING_ROOM;
				} else {
					var newRoom = HouseModal.TROPHY_ROOM;
				}
				this.setState({ currentRoom: newRoom });
			}
		}, {
			key: "updateFurnitures",
			value: function updateFurnitures(newFurnitures) {
				if (this.props.updateFurnitures == undefined) {
					this.setState({ allFurnitures: newFurnitures });
				} else {
					this.props.updateFurnitures(newFurnitures);
				}
			}
		}, {
			key: "fetchFurnitures",
			value: function fetchFurnitures() {
				var _this2 = this;
	
				CurrentUser.api().getPerks({ furniture_only: true }, $wr.apiHandler(function (response) {
					_this2.setState({ allFurnitures: response.perks });
				}));
			}
		}, {
			key: "getAllFurnitures",
			value: function getAllFurnitures() {
				if (this.props.allFurnitures == undefined) {
					return this.state.allFurnitures;
				} else {
					return this.props.allFurnitures;
				}
			}
		}, {
			key: "renderSwitchRoomButtons",
			value: function renderSwitchRoomButtons() {
				var _this3 = this;
	
				if (this.state.currentRoom == HouseModal.DRESSING_ROOM) {
					var roomLabel = this.props.ownsHouse ? "Main Room" : "Trophy Room";
					var switchRoomButtonLeft = React.createElement(
						"button",
						{
							className: "btn btn-link switchRoomLink switchLeft",
							onClick: function onClick() {
								return _this3.switchRooms(LEFT);
							}
						},
						React.createElement(Glyphicon, { icon: "chevron-left", dataTip: roomLabel })
					);
				}
	
				if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
					var roomLabel = this.props.ownsHouse ? "Main Room" : "Closet";
					var switchRoomButtonRight = React.createElement(
						"button",
						{
							className: "btn btn-link switchRoomLink switchRight",
							onClick: function onClick() {
								return _this3.switchRooms(RIGHT);
							}
						},
						React.createElement(Glyphicon, { icon: "chevron-right", dataTip: "Main Room" })
					);
				}
	
				if (this.props.ownsHouse) {
					if (this.state.currentRoom == HouseModal.HOUSE_INTERIOR_ROOM) {
						var switchRoomButtonLeft = React.createElement(
							"button",
							{
								className: "btn btn-link switchRoomLink switchLeft",
								onClick: function onClick() {
									return _this3.switchRooms(LEFT);
								}
							},
							React.createElement(Glyphicon, { icon: "chevron-left", dataTip: "Trophy Room" })
						);
	
						var switchRoomButtonRight = React.createElement(
							"button",
							{
								className: "btn btn-link switchRoomLink switchRight",
								onClick: function onClick() {
									return _this3.switchRooms(RIGHT);
								}
							},
							React.createElement(Glyphicon, { icon: "chevron-right", dataTip: "Closet" })
						);
					}
				}
	
				return React.createElement(
					"div",
					null,
					switchRoomButtonLeft,
					switchRoomButtonRight
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
					var trophyStyle = {};
					var interiorStyle = { display: "none" };
					var dressingStyle = { display: "none" };
					if (CurrentUser.isAdmin() || this.props.currentStudent) {
						var title = this.props.student.first_name + "'s Trophy Room";
					} else {
						var title = "Trophy Room";
					}
				} else if (this.state.currentRoom == HouseModal.DRESSING_ROOM) {
					var trophyStyle = { display: "none" };
					var interiorStyle = { display: "none" };
					var dressingStyle = {};
					if (CurrentUser.isAdmin() || this.props.currentStudent) {
						var title = this.props.student.first_name + "'s Closet!";
					} else {
						var title = "Closet";
					}
				} else {
					var trophyStyle = { display: "none" };
					var interiorStyle = {};
					var dressingStyle = { display: "none" };
					if (CurrentUser.isAdmin() || this.props.currentStudent) {
						var title = "Welcome to " + this.props.student.first_name + "'s House!";
					} else {
						var title = "Welcome Home!";
					}
				}
	
				var trophyBody = React.createElement(TrophyRoom, { student: this.props.student });
	
				var dressingBody = React.createElement(DressingRoom, { student: this.props.student });
	
				if (this.props.currentStudent) {
					var interiorBody = React.createElement(HouseInteriorRoom, {
						student: this.props.student,
						currentStudent: this.props.currentStudent,
						previewItemName: this.props.previewItemName,
						previewItemType: this.props.previewItemType,
						previewItemTitle: this.props.previewItemTitle,
						ref: "houseInteriorRoom"
					});
				} else {
					if (CurrentUser.hasID(this.props.student.id)) {
						var allFurnitures = this.getAllFurnitures();
						var interiorBody = React.createElement(HouseInteriorRoom, {
							student: this.props.student,
							ref: "houseInteriorRoom",
							activeRoom: this.props.activeRoom,
							allFurnitures: allFurnitures,
							previewItemName: this.props.previewItemName,
							previewItemType: this.props.previewItemType,
							previewItemTitle: this.props.previewItemTitle
						});
					} else {
						var interiorBody = React.createElement(HouseInteriorRoom, {
							student: this.props.student,
							ref: "houseInteriorRoom",
							activeRoom: this.props.activeRoom,
							previewItemName: this.props.previewItemName,
							previewItemType: this.props.previewItemType,
							previewItemTitle: this.props.previewItemTitle
	
						});
					}
				}
	
				return React.createElement(
					Modal,
					{ className: "houseModal", ref: "modal", headerText: title, onShow: this.onModalShow },
					React.createElement(
						"div",
						{ style: trophyStyle },
						trophyBody
					),
					React.createElement(
						"div",
						{ style: interiorStyle },
						interiorBody
					),
					React.createElement(
						"div",
						{ style: dressingStyle },
						dressingBody
					),
					this.renderSwitchRoomButtons()
				);
			}
			// render() {
			// 	if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
			// 		if (CurrentUser.isAdmin() || this.props.currentStudent) {
			// 			var title = this.props.student.first_name + "'s Trophy Room"
			// 		} else {
			// 			var title = "Trophy Room";
			// 		}
			// 		var modalBody = (
			// 			<TrophyRoom studentID={ this.props.student.id } />
			// 		);
			// 		var switchButtonClass = "switchRight";
			// 		var glyphiconType = "chevron-right";
	
			// 	} else {
			// 		if (CurrentUser.isAdmin() || this.props.currentStudent) {
			// 			var title = "Welcome to " + this.props.student.first_name + "'s House!"
			// 		} else {
			// 			var title = "Welcome Home!"
			// 		}
			// 		if (this.props.currentStudent) {
			// 			var modalBody = <HouseInteriorRoom student={ this.props.student }
			// 				currentStudent={ this.props.currentStudent } ref="houseInteriorRoom" />;
			// 		} else {
			// 			var modalBody = <HouseInteriorRoom student={ this.props.student }
			// 				ref="houseInteriorRoom" />;
			// 		}
			// 		var switchButtonClass = "switchLeft";
			// 		var glyphiconType = "chevron-left";
			// 	}
	
			// 	if (!this.props.trophyRoomOnly) {
			// 		var switchRoomButton = (
			// 			<button className={ "btn btn-link switchRoomLink " + switchButtonClass } onClick={ this.switchRooms }>
			// 				<Glyphicon icon={ glyphiconType } />
			// 			</button>
			// 		);
			// 	}
	
			// 	return (
			// 		<Modal className="houseModal" ref="modal" headerText={ title } onShow={ this.onModalShow }>
			// 			{ modalBody }
			// 			{ switchRoomButton }
			// 		</Modal>
			// 	)
			// }
	
		}, {
			key: "onModalShow",
			value: function onModalShow() {
				Mycroft.newEvent({
					category: "Owl-Houses",
					action: "opened-house-modal",
					label: this.state.currentRoom
				});
				this.forceUpdate();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (CurrentUser.hasID(this.props.student.id) && this.props.allFurnitures == undefined) {
					if (this.state.allFurnitures == undefined) {
						this.fetchFurnitures();
					}
				}
			}
		}]);
	
		return HouseModal;
	}(React.Component);
	
	HouseModal.TROPHY_ROOM = "TrophyRoom";
	HouseModal.HOUSE_INTERIOR_ROOM = "HouseInteriorRoom";
	HouseModal.DRESSING_ROOM = "DressingRoom";
	
	HouseModal.propTypes = StrictPropTypes({
		// Data on the student
		student: PropTypes.object.isRequired,
	
		// Data on a visiting student
		currentStudent: PropTypes.object,
	
		// For disabling toggling to rooms other than the trophy room
		activeRoom: PropTypes.string,
		allFurnitures: PropTypes.array,
		updateFurnitures: PropTypes.func,
	
		//for previewing a furniture item
		previewItemName: PropTypes.string,
		previewItemType: PropTypes.string,
		previewItemTitle: PropTypes.string
	});
	
	module.exports = HouseModal;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	var Modal = __webpack_require__(18);
	var OwlShopDisplay = __webpack_require__(372);
	var CurrentUser = __webpack_require__(3);
	var OwlShopRouting = __webpack_require__(92);
	
	__webpack_require__(3664);
	
	var NewItemsModal = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
			filteredPerks: OwlShopSelectors.getFilteredPerks({ state: state }),
			user: CurrentUser.get()
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return Promise.all([dispatch(OwlShopActions.fetchPatches()), dispatch(OwlShopActions.fetchPerks())]);
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(NewItemsModal, _React$Component);
	
		function NewItemsModal(props) {
			_classCallCheck(this, NewItemsModal);
	
			var _this = _possibleConstructorReturn(this, (NewItemsModal.__proto__ || Object.getPrototypeOf(NewItemsModal)).call(this));
	
			autobind(_this);
			_this.state = { activeItemType: 'head', newItems: [], hide: false };
			return _this;
		}
	
		_createClass(NewItemsModal, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "hide",
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: "deleteAlert",
			value: function deleteAlert() {
				var _this2 = this;
	
				if (this.props.alertID) {
					CurrentUser.api().deleteUserAlert(this.props.alertID, function () {
						_this2.setState({ hide: true });
					});
				}
			}
		}, {
			key: "changeCategory",
			value: function changeCategory(itemType) {
				this.setState({ activeItemType: itemType });
			}
		}, {
			key: "selectItem",
			value: function selectItem(item, equipType) {
				if (item.perk_type && item.perk_type == "houses") {
					var itemType = item.perk_type;
				} else {
					var itemType = item.patch_type + "&patch=true";
				}
	
				var params = "?itemName=" + item.name + "&itemType=" + itemType;
	
				$wr.redirect(OwlShopRouting.getPath({}) + params);
			}
	
			//////// Helper Methods ///////////
	
		}, {
			key: "initNewItems",
			value: function initNewItems() {
				var _props = this.props,
				    filteredPatches = _props.filteredPatches,
				    filteredPerks = _props.filteredPerks;
	
				var newItems = _.sortBy(_.filter([].concat(_toConsumableArray(filteredPatches), _toConsumableArray(filteredPerks)), function (item) {
					return _.includes(newItemNames, item.name);
				}), function (item) {
					return item.tier + item.price;
				});
	
				this.setState({ newItems: newItems });
			}
	
			// to keep category selector highlighted correctly in hand and body special cases
	
		}, {
			key: "isActivePatchType",
			value: function isActivePatchType(patchType) {
				var activeItemType = this.state.activeItemType;
	
				if (activeItemType == "left_hand" || activeItemType == "hand" || activeItemType == "wings") {
					return patchType == "left_hand";
				} else if (activeItemType == "body" || activeItemType == "body2") {
					return patchType == "body";
				} else {
					return patchType == activeItemType;
				}
			}
	
			//////// Render Methods ///////////
	
		}, {
			key: "renderCategorySelector",
			value: function renderCategorySelector(text, patchType, otherType) {
				var _this3 = this;
	
				var categoryClass = void 0;
				if (this.props.activePatchType && this.isActivePatchType(patchType)) {
					categoryClass = "selector selectedPatchType";
				} else if (this.props.activeOtherType && this.props.activeOtherType == otherType) {
					categoryClass = "selector selectedPatchType";
				} else {
					categoryClass = "selector";
				}
	
				return React.createElement(
					"a",
					{ onClick: function onClick() {
							return _this3.changeCategory(patchType || otherType);
						}, className: categoryClass },
					React.createElement("img", { src: dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png") }),
					React.createElement(
						"span",
						{ className: "categoryTitle" },
						text
					)
				);
			}
		}, {
			key: "renderOwlshopCategories",
			value: function renderOwlshopCategories() {
				if (!this.props.hideOwls) {
					var owlCustomizers = React.createElement(
						"div",
						null,
						this.renderCategorySelector("Head", "head", null),
						this.renderCategorySelector("Face", "face", null),
						this.renderCategorySelector("Body", "body", null),
						this.renderCategorySelector("Wings", "left_hand", null),
						this.renderCategorySelector("Houses", null, "houses")
					);
				}
				return React.createElement(
					"div",
					{ className: "categorySelector" },
					React.createElement(
						"div",
						{ className: "categorySection" },
						React.createElement(
							"div",
							{ className: "modeSelectorRowContainer" },
							owlCustomizers
						)
					)
				);
			}
		}, {
			key: "renderOwlshopItems",
			value: function renderOwlshopItems() {
				var _state = this.state,
				    activeItemType = _state.activeItemType,
				    newItems = _state.newItems;
	
	
				var items = _.filter(newItems, function (item) {
					return (item.perk_type == activeItemType || item.patch_type == activeItemType) && _.includes(newItemNames, item.name);
				});
	
				return React.createElement(OwlShopDisplay, {
					user: this.props.user,
					itemType: activeItemType,
					items: items,
					hideAlternates: true,
					selectItem: this.selectItem,
					isPatch: !(activeItemType == 'houses')
				});
			}
		}, {
			key: "renderSubheadline",
			value: function renderSubheadline() {
				return React.createElement(
					"div",
					{ className: "subheadline" },
					"Shop new styles and houses to bring in the New Year!"
				);
			}
		}, {
			key: "renderOwlImages",
			value: function renderOwlImages() {
				return React.createElement(
					"div",
					{ className: "owlImages" },
					React.createElement("img", { src: __webpack_require__(1735), key: "new_owl_1" }),
					React.createElement("img", { src: __webpack_require__(1736), key: "new_owl_2" }),
					React.createElement("img", { src: __webpack_require__(1737), key: "new_owl_3" })
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.hide) {
					return null;
				}
				return React.createElement(
					Modal,
					{ onHide: this.deleteAlert, className: "newItemsModal wideModal", headerText: this.props.title,
						ref: "modal" },
					this.renderOwlImages(),
					this.renderSubheadline(),
					this.renderOwlshopCategories(),
					this.renderOwlshopItems()
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var _props2 = this.props,
				    filteredPatches = _props2.filteredPatches,
				    filteredPerks = _props2.filteredPerks;
	
				if (prevProps.filteredPatches != filteredPatches || prevProps.filteredPerks != filteredPerks) {
					this.initNewItems();
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				if (this.props.open && this.refs.modal) {
					this.refs.modal.show();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.open && this.refs.modal) {
					this.refs.modal.show();
				}
				this.initNewItems();
			}
		}]);
	
		return NewItemsModal;
	}(React.Component)) || _class) || _class);
	
	
	NewItemsModal.propTypes = PageStrictPropTypes({
		saleData: PropTypes.object,
		filteredPatches: PropTypes.array,
		filteredPerks: PropTypes.array,
		activePatchType: PropTypes.string,
		title: PropTypes.string,
		alertID: PropTypes.number,
		open: PropTypes.bool
	});
	
	module.exports = NewItemsModal;
	
	var newItemNames = ['binoculars', 'earbuds-blue', 'earbuds-pink', 'earbuds-white', 'earbuds-yellow', 'expression-rage', 'expression-shock', 'makeup-blue', 'makeup-pink', 'makeup-gold', 'makeup-diva', 'makeup-sunset', 'pink-heart-glasses', 'goggles-VR', 'afro-hair', 'army-helmet', 'big-wig', 'bunny-ears', 'cat-ears', 'diver-helmet', 'dog-ears', 'earrings-flower', 'earrings-pearl', 'earrings-ruby', 'fox-ears', 'headscarf', 'mouse-ears', 'plunger-hat', 'hair-ringlets-black', 'spiky-hair', 'bun', 'unicorn-crown', 'coat', 'denim-jacket', 'fannypack', 'floatie-alligator', 'floatie-donut', 'floatie-toucan', 'floatie-watermelon', 'heart-skirt', 'holiday-sweater', 'hoodie-blue', 'hoodie-orange', 'hoodie-finger-heart-brown', 'hoodie-finger-heart-white', 'ripped-jeans', 'motorcycle-jacket', 'overalls-denim', 'overalls-red', 'party-dress', 'puffy-jacket-pink', 'school-girl-uniform', 'sweater', 'swimsuit-neon-green', 'swimsuit-red-stripe', 'swimsuit-yellow', 'tiger-suit', 'trenchcoat', 'magic-wand-right', 'pink-diamond-right', 'balloon-purple-heart-right', 'rabbit-in-hat-right', "Luxury Apartments", "Owl-Dobe Desert Casa", "Barn House", "Hawaiian Beach Hut", "Sir Hoots A Lot's Castle", "Festival Yurt", "Owl-ffel Tower", "Gingerbread House", "Modern Glass House", "Rainbow Hot Air Balloon", "Purple Hot Air Balloon", "Red Hot Air Balloon", "Japanese Restaurant", "Leaning T-owl-er of Pisa", "Lighthouse", "Log Cabin", "Modern Mansion", "Mongolian House", "Eagle's Nest", "Space Vision House", "Pirate Ship", "Rocket Ship", "Tree House", "Medieval Tower", "Windmill"];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var Owlvatar = __webpack_require__(115);
	var ShopSales = __webpack_require__(123);
	
	var moment = __webpack_require__(15);
	
	__webpack_require__(3666);
	
	var SaleModal = function (_React$Component) {
		_inherits(SaleModal, _React$Component);
	
		function SaleModal(props) {
			_classCallCheck(this, SaleModal);
	
			var _this = _possibleConstructorReturn(this, (SaleModal.__proto__ || Object.getPrototypeOf(SaleModal)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(SaleModal, [{
			key: 'show',
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: 'hide',
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: 'render',
			value: function render() {
				var sale = ShopSales.getCurrentSale();
				var dates = ShopSales.getSaleDates(sale);
				var saleEnd = dates["end"];
				var timeNow = new Date();
	
				var imagePatches = this.props.saleData.patches.map(function (patch) {
					var patches = _.clone(CurrentUser.get().avatar.patches);
					_.each(_.keys(patches), function (patchType) {
						if (patches[patchType] != Owlvatar.NO_PATCH && patches[patchType].source != "default") {
							patches[patchType] = Owlvatar.NO_PATCH;
						}
					});
					patches["feet"] = {
						"name": "short",
						"title": "Short Feet",
						"description": null,
						"source": "default",
						"patch_type": "feet",
						"origin_patch_type": "feet",
						"patch_directory": "feet",
						"z_index": 800,
						"price": 0,
						"tier": 0,
						"offsets": null,
						"animation": null,
						"extra_right": 0,
						"extra_left": 0,
						"extra_top": 0,
						"extra_bottom": 0
					};
					patches["beak"] = {
						"name": "normal",
						"title": "Normal Beak",
						"description": null,
						"source": "default",
						"patch_type": "beak",
						"origin_patch_type": "beak",
						"patch_directory": "beak",
						"z_index": 3000,
						"price": 0,
						"tier": 0,
						"offsets": null,
						"animation": null,
						"extra_right": 0,
						"extra_left": 0,
						"extra_top": 0,
						"extra_bottom": 0
					};
	
					patches[patch.patch_data] = patch;
					var colors = CurrentUser.get().avatar.colors;
	
					return React.createElement(
						'div',
						{ key: patch.patch_type + patch.name, className: 'clearfix patchWrap' },
						React.createElement(Owlvatar, { patches: patches, colors: colors, maxWidth: 120 })
					);
				});
	
				var hoursLeft = Math.abs(saleEnd - timeNow) / 36e5;
				if (hoursLeft > 72) {
					var displayUnit = (hoursLeft / 24).toFixed(0);
					var displayUnit = displayUnit.toString() + " days ";
					var timeText = "are";
				} else {
					if (hoursLeft <= 1) {
						var timeText = "is";
						var hoursLeft = 1;
						var displayUnit = hoursLeft + " hour ";
					} else if (hoursLeft > 1) {
						var timeText = "are";
						var displayUnit = hoursLeft.toFixed(0).toString() + " hours ";
					}
				}
	
				return React.createElement(
					Modal,
					{ className: 'saleModal wideModal', headerText: this.props.saleData.title,
						ref: 'modal', onShow: this.handleOpen },
					React.createElement(
						'div',
						{ className: 'data' },
						React.createElement(
							'p',
							null,
							this.props.saleData.description
						),
						React.createElement(
							'div',
							{ className: 'clearfix text-center' },
							imagePatches
						),
						React.createElement(
							'p',
							null,
							'Head over to the Owl Shop until ',
							React.createElement(
								'strong',
								null,
								saleEnd.toLocaleDateString()
							),
							' to get these special items. There ',
							timeText,
							' ',
							React.createElement(
								'strong',
								null,
								displayUnit
							),
							'left!'
						)
					)
				);
			}
		}]);
	
		return SaleModal;
	}(React.Component);
	
	SaleModal.propTypes = PageStrictPropTypes({
		saleData: PropTypes.object.isRequired
	});
	
	module.exports = SaleModal;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tiers = __webpack_require__(108);
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3667);
	
	var TierRequirementsDisplay = function (_React$Component) {
		_inherits(TierRequirementsDisplay, _React$Component);
	
		function TierRequirementsDisplay(props) {
			_classCallCheck(this, TierRequirementsDisplay);
	
			var _this = _possibleConstructorReturn(this, (TierRequirementsDisplay.__proto__ || Object.getPrototypeOf(TierRequirementsDisplay)).call(this));
	
			autobind(_this);
			_this.state = {
				itemOffset: 0
			};
			return _this;
		}
	
		_createClass(TierRequirementsDisplay, [{
			key: "getThumbnailPatchPath",
			value: function getThumbnailPatchPath(patchType, patchName) {
				var patchPath = "patches/" + patchType + "/" + patchName + "-s.png";
				return dynamicRequire(patchPath);
			}
		}, {
			key: "getThumbnailPerkPath",
			value: function getThumbnailPerkPath(perk) {
				if (perk.perk_type == "backgrounds" || perk.perk_type == "houses" || perk.perk_type == "owl_hoots" || perk.perk_type == "background_sounds" || perk.perk_type == "greetings") {
	
					if (perk.perk_type == "houses") {
						var name = perk.name.toLowerCase().replace(/ /g, '-');
						if (name.indexOf('\'') >= 0) {
							name = name.replace('\'', "");
						}
					} else {
						var name = perk.name.toLowerCase().replace(/\s/g, "_");
					}
					var perkPath = "perks/" + perk.perk_type + "/" + name + ".png";
					return dynamicRequire(perkPath);
				} else if (perk.perk_type == "titles") {
					return __webpack_require__(537);
				}
			}
		}, {
			key: "getThumbnailFurniturePath",
			value: function getThumbnailFurniturePath(furniture) {
				var perkPath = "perks/" + furniture.perk_type + "/" + furniture.name + ".png";
				return dynamicRequire(perkPath);
			}
		}, {
			key: "getPatchTypeName",
			value: function getPatchTypeName(patchType, tier) {
				var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
				if (patchType == "beak") {
					return levelPrefix + "Beak";
				} else if (patchType == "body") {
					return levelPrefix + "Body";
				} else if (patchType == "face") {
					return levelPrefix + "Face";
				} else if (patchType == "feet") {
					return levelPrefix + "Feet";
				} else if (patchType == "hand") {
					return levelPrefix + "Wings";
				} else if (patchType == "head") {
					return levelPrefix + "Head";
				} else {
					return "";
				}
			}
		}, {
			key: "getPerkTypeName",
			value: function getPerkTypeName(perkType, tier) {
				var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
				if (perkType == "houses") {
					return levelPrefix + "House";
				} else if (perkType == "total") {
					return "Any " + levelPrefix + "Perk";
				} else if (perkType == "titles") {
					return levelPrefix + "Title";
				} else if (perkType == "backgrounds") {
					return levelPrefix + "Wallpaper";
				} else if (perkType == "background_sounds") {
					return levelPrefix + "Tune";
				} else if (perkType == "owl_hoots") {
					return levelPrefix + "Hoot";
				} else if (perkType == "greetings") {
					return levelPrefix + "Greeting";
				} else {
					return "";
				}
			}
		}, {
			key: "getFurnitureTypeName",
			value: function getFurnitureTypeName(furnitureType, tier) {
				var levelPrefix = "Level " + (parseInt(tier) + 1) + " ";
				if (furnitureType == "sofas") {
					return levelPrefix + "Sofa";
				} else if (furnitureType == "total") {
					return "Any " + levelPrefix + "Furniture";
				} else if (furnitureType == "bookshelves") {
					return levelPrefix + "Bookshelf";
				} else if (furnitureType == "wall_items") {
					return levelPrefix + "Wall Item";
				} else if (furnitureType == "floor_items") {
					return levelPrefix + "Floor Item";
				} else {
					return "";
				}
			}
		}, {
			key: "isTypeFurniture",
			value: function isTypeFurniture(furnitureType) {
				if (["floor_items", "wall_items", "bookshelves", "sofas"].indexOf(furnitureType) > -1) {
					return true;
				}
				return false;
			}
		}, {
			key: "shiftLeft",
			value: function shiftLeft() {
				this.setState({ itemOffset: this.state.itemOffset - this.props.maxSquares });
			}
		}, {
			key: "shiftRight",
			value: function shiftRight() {
				this.setState({ itemOffset: this.state.itemOffset + this.props.maxSquares });
			}
	
			// gets the type of item from the tier reqs square
	
		}, {
			key: "onSquareClick",
			value: function onSquareClick(category, type) {
				if (this.props.toggleCategory) {
					if (typeof category == "string") {
						this.props.toggleCategory(category, type);
						this.props.beginAtTier(true);
						// toggles trophy room if req already met
					} else {
						this.props.toggleRoom("trophy");
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var currentTier = this.props.tier;
				var userCoins = this.props.coins;
				var reqPatchSquares = [];
				var reqPerkSquares = [];
				var reqFurnitureSquares = [];
				var otherItemSquares = [];
				var tierColor = Tiers.getColor(this.props.tier);
	
				_.map(this.props.requirements.patches, function (numPatchesReq, key) {
					var patchType = key == "hand" ? "left_hand" : key;
					var patchReqPath = dynamicRequire("owl-item-types/" + patchType + ".png");
					var ownedPatchesOfType = _.select(this.props.ownedPatches, function (patch) {
						//purposely exludes left handed items so only right hand patch appears
						//on display
						return patch.patch_type == patchType && patch.tier == this.props.tier;
					}.bind(this));
	
					_.times(numPatchesReq, function (i) {
						var _this2 = this;
	
						if (ownedPatchesOfType[i]) {
							var patchPath = this.getThumbnailPatchPath(key, ownedPatchesOfType[i].name);
							reqPatchSquares.push(React.createElement(
								"div",
								{ className: "reqMetSquare", onClick: this.onSquareClick, key: "tier" + this.props.tier + key + i,
									style: { backgroundColor: tierColor, borderColor: tierColor },
									"data-tip": ownedPatchesOfType[i].title },
								React.createElement("img", { src: patchPath, className: "itemImage" }),
								React.createElement(ReactTooltip, { effect: "solid" })
							));
						} else {
							var patchReqTooltipText = this.getPatchTypeName(key, this.props.tier);
							//if user can afford tier req, creates a square highlighted in their tier color
							if ($wr.canAffordItem(userCoins, currentTier, this.props.filteredPatches, "patch", key).length > 0) {
								reqPatchSquares.push(React.createElement(
									"div",
									{ className: "canAffordSquare", onClick: function onClick() {
											return _this2.onSquareClick("patch", patchType);
										}, key: "tier" + this.props.tier + key + i,
										style: { borderColor: tierColor },
										"data-tip": patchReqTooltipText },
									React.createElement("img", { src: patchReqPath, className: "itemImage" })
								));
							} else {
								reqPatchSquares.push(React.createElement(
									"div",
									{ className: "reqNotMetSquare", onClick: function onClick() {
											return _this2.onSquareClick("patch", patchType);
										}, key: "tier" + this.props.tier + key + i,
										"data-tip": patchReqTooltipText },
									React.createElement("img", { src: patchReqPath, className: "itemImage" })
								));
							}
						}
					}.bind(this));
	
					if (this.props.displayAllItems && ownedPatchesOfType.length > numPatchesReq) {
						for (var j = numPatchesReq; j < ownedPatchesOfType.length; j++) {
							var patchPath = this.getThumbnailPatchPath(key, ownedPatchesOfType[j].name);
							otherItemSquares.push(React.createElement(
								"div",
								{ className: "otherSquare", key: "tier" + this.props.tier + key + j,
									"data-tip": ownedPatchesOfType[j].title },
								React.createElement("img", { src: patchPath, className: "itemImage" })
							));
						};
					}
				}.bind(this));
	
				_.map(this.props.requirements.perks, function (numPerksReq, key) {
					if (key == "total") {
						var perkReqPath1 = __webpack_require__(532);
						var perkReqPath2 = __webpack_require__(535);
						var perkReqPath3 = __webpack_require__(531);
						var perkReqPath4 = __webpack_require__(534);
						var perkReqImg = React.createElement(
							"div",
							{ className: "perkMiniItemDisplay" },
							React.createElement("img", { src: perkReqPath1, className: "miniItemImage" }),
							React.createElement("img", { src: perkReqPath2, className: "miniItemImage" }),
							React.createElement("img", { src: perkReqPath3, className: "miniItemImage" }),
							React.createElement("img", { src: perkReqPath4, className: "miniItemImage" })
						);
						var ownedPerksOfType = _.select(this.props.ownedPerks, function (perk) {
							return perk.tier == this.props.tier;
						}.bind(this));
					} else {
						var perkReqPath = dynamicRequire("owl-item-types/" + key + ".png");
						var perkReqImg = React.createElement("img", { src: perkReqPath, className: "itemImage" });
						var ownedPerksOfType = _.select(this.props.ownedPerks, function (perk) {
							return perk.perk_type == key && perk.tier == this.props.tier;
						}.bind(this));
					}
	
					_.times(numPerksReq, function (i) {
						var _this3 = this;
	
						if (ownedPerksOfType[i]) {
							var perkPath = this.getThumbnailPerkPath(ownedPerksOfType[i]);
							reqPerkSquares.push(React.createElement(
								"div",
								{ className: "reqMetSquare", onClick: this.onSquareClick, key: "tier" + this.props.tier + key + i,
									style: { backgroundColor: tierColor, borderColor: tierColor },
									"data-tip": ownedPerksOfType[i].name },
								React.createElement("img", { src: perkPath, className: "itemImage" }),
								React.createElement(ReactTooltip, { effect: "solid" })
							));
						} else {
							var perkReqTooltipText = this.getPerkTypeName(key, this.props.tier);
	
							if ($wr.canAffordItem(userCoins, currentTier, this.props.filteredPerks, "perk", key).length > 0) {
								reqPerkSquares.push(React.createElement(
									"div",
									{ className: "canAffordSquare", onClick: function onClick() {
											return _this3.onSquareClick("perk", key);
										}, key: "tier" + this.props.tier + key + i,
										style: { borderColor: tierColor },
										"data-tip": perkReqTooltipText },
									perkReqImg
								));
							} else {
								reqPerkSquares.push(React.createElement(
									"div",
									{ className: "reqNotMetSquare", onClick: function onClick() {
											return _this3.onSquareClick("perk", key);
										}, key: "tier" + this.props.tier + key + i,
										"data-tip": perkReqTooltipText },
									perkReqImg,
									React.createElement(ReactTooltip, { effect: "solid" })
								));
							}
						}
					}.bind(this));
	
					if (this.props.displayAllItems && ownedPerksOfType.length > numPerksReq) {
						for (var j = numPerksReq; j < ownedPerksOfType.length; j++) {
							var perkPath = this.getThumbnailPerkPath(ownedPerksOfType[j]);
							otherItemSquares.push(React.createElement(
								"div",
								{ className: "otherSquare",
									key: "tier" + this.props.tier + ownedPerksOfType[j].perk_type + j,
									"data-tip": ownedPerksOfType[j].name },
								React.createElement("img", { src: perkPath, className: "itemImage" })
							));
						};
					}
				}.bind(this));
	
				_.map(this.props.requirements.furnitures, function (numFurnituresReq, key) {
					if (key == "total") {
						var furnitureReqPath1 = __webpack_require__(536);
						var furnitureReqPath2 = __webpack_require__(533);
						var furnitureReqPath3 = __webpack_require__(538);
						var furnitureReqImg = React.createElement(
							"div",
							{ className: "perkMiniItemDisplay" },
							React.createElement("img", { src: furnitureReqPath1, className: "miniItemImage" }),
							React.createElement("img", { src: furnitureReqPath2, className: "miniItemImage" }),
							React.createElement("img", { src: furnitureReqPath3, className: "miniItemImage" })
						);
						var ownedFurnituresOfType = _.select(this.props.ownedFurnitures, function (perk) {
							return perk.tier == this.props.tier;
						}.bind(this));
					} else {
						var furnitureReqPath = dynamicRequire("owl-item-types/" + key + ".png");
						var furnitureReqImg = React.createElement("img", { src: furnitureReqPath, className: "itemImage" });
						var ownedFurnituresOfType = _.select(this.props.ownedFurnitures, function (perk) {
							return perk.perk_type == key && perk.tier == this.props.tier;
						}.bind(this));
					}
	
					_.times(numFurnituresReq, function (i) {
						var _this4 = this;
	
						if (ownedFurnituresOfType[i]) {
							var furniturePath = this.getThumbnailFurniturePath(ownedFurnituresOfType[i]);
							reqFurnitureSquares.push(React.createElement(
								"div",
								{ className: "reqMetSquare", onClick: this.onSquareClick, key: "tier" + this.props.tier + key + i,
									style: { backgroundColor: tierColor, borderColor: tierColor },
									"data-tip": ownedFurnituresOfType[i].title },
								React.createElement("img", { src: furniturePath, className: "itemImage" }),
								React.createElement(ReactTooltip, { effect: "solid" })
							));
						} else {
							var furnitureReqTooltipText = this.getFurnitureTypeName(key, this.props.tier);
							if ($wr.canAffordItem(userCoins, currentTier, this.props.allFurnitures, "furniture", key).length > 0) {
								reqFurnitureSquares.push(React.createElement(
									"div",
									{ className: "canAffordSquare", onClick: function onClick() {
											return _this4.onSquareClick("furniture", key);
										}, key: "tier" + this.props.tier + key + i,
										style: { borderColor: tierColor },
										"data-tip": furnitureReqTooltipText },
									furnitureReqImg
								));
							} else {
								//var furnitureReqTooltipText = this.getFurnitureTypeName(key, this.props.tier);
								reqFurnitureSquares.push(React.createElement(
									"div",
									{ className: "reqNotMetSquare", onClick: function onClick() {
											return _this4.onSquareClick("furniture", key);
										}, key: "tier" + this.props.tier + key + i,
										"data-tip": furnitureReqTooltipText },
									furnitureReqImg,
									React.createElement(ReactTooltip, { effect: "solid" })
								));
							}
						}
					}.bind(this));
	
					if (this.props.displayAllItems && ownedFurnituresOfType.length > numFurnituresReq) {
						for (var j = numFurnituresReq; j < ownedFurnituresOfType.length; j++) {
							var furniturePath = this.getThumbnailFurniturePath(ownedFurnituresOfType[j]);
							otherItemSquares.push(React.createElement(
								"div",
								{ className: "otherSquare",
									key: "tier" + this.props.tier + ownedFurnituresOfType[j].perk_type + j,
									"data-tip": ownedFurnituresOfType[j].name },
								React.createElement("img", { src: furniturePath, className: "itemImage" })
							));
						};
					}
				}.bind(this));
	
				var allSquares = reqPatchSquares.concat(reqPerkSquares, reqFurnitureSquares, otherItemSquares);
				if (this.props.maxSquares && allSquares.length > this.props.maxSquares) {
					var maxSquareIndex = this.state.itemOffset + this.props.maxSquares;
					var canShiftLeft = this.state.itemOffset > 0;
					var canShiftRight = allSquares.length >= maxSquareIndex;
					if (canShiftLeft) {
						var arrowLeft = React.createElement(
							"button",
							{ className: "btn btn-link arrowLink arrowLeft", disabled: !canShiftLeft,
								onClick: this.shiftLeft },
							React.createElement(Glyphicon, { icon: "arrow-left" })
						);
					}
					if (canShiftRight) {
						var arrowRight = React.createElement(
							"button",
							{ className: "btn btn-link arrowLink arrowRight", disabled: !canShiftRight,
								onClick: this.shiftRight },
							React.createElement(Glyphicon, { icon: "arrow-right" })
						);
					}
					var currentSquares = allSquares.slice(this.state.itemOffset, maxSquareIndex);
					return React.createElement(
						"div",
						{ className: "tierRequirementsDisplay" },
						arrowLeft,
						currentSquares,
						arrowRight,
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				} else {
					return React.createElement(
						"div",
						{ className: "tierRequirementsDisplay" },
						allSquares,
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				}
			}
		}]);
	
		return TierRequirementsDisplay;
	}(React.Component);
	
	TierRequirementsDisplay.propTypes = StrictPropTypes({
		// requirements for the tier
		requirements: PropTypes.object.isRequired,
		// tier
		tier: PropTypes.string.isRequired,
		// patches owned by user
		ownedPatches: PropTypes.array.isRequired,
		// perks owned by user
		ownedPerks: PropTypes.array.isRequired,
		// furnitures owned by user
		ownedFurnitures: PropTypes.array.isRequired,
	
		// option to display all owned items, not limited to items that meet requirements
		displayAllItems: PropTypes.bool,
	
		// option to specify the maximum number of squares on screen
		maxSquares: PropTypes.number,
		toggleRoom: PropTypes.func,
		toggleCategory: PropTypes.func,
		beginAtTier: PropTypes.func,
	
		filteredPatches: PropTypes.array,
		filteredPerks: PropTypes.array,
		allFurnitures: PropTypes.array,
		coins: PropTypes.number
	});
	
	module.exports = TierRequirementsDisplay;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var RosterActions = __webpack_require__(11);
	var DropDownOptions = __webpack_require__(26);
	var EditableGoals = __webpack_require__(190);
	
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3696);
	
	var ExpectationPeriodPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var refPrefs = {};
	
		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				});
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				});
			}
	
			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs;
			}
		}
	
		return {
			refPrefs: refPrefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (CurrentUser.isDistrictAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
						filters: { ids: [CurrentUser.get().primary_district_org_id] },
						embeds: ['district_org.prefs'],
						cache: true
					}))]);
				} else if (CurrentUser.isSchoolAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
						filters: { ids: [CurrentUser.get().primary_school_org_id] },
						embeds: ['school_org.prefs'],
						cache: true
					}))]);
				} else {
					return Promise.all([dispatch(RosterActions.fetchAdmins({
						filters: { ids: [CurrentUser.get().id] },
						embeds: ['user.prefs'],
						cache: true
					}))]);
				}
				return Promise.all([]);
			},
	
			onChange: function onChange(prefsUpdate) {
				// WE NEED TO RELOAD PAGE TO PREVENT HAVING STUDENT LISTS WITH WRONG PREFERENCES
				var confirmMessage = "Do you want to apply this setting to corresponding students/classes? Selecting yes will override the individual student and class preferences you may have set.";
				var resetStudentLists = false;
	
				if (CurrentUser.isTeacherAdmin()) {
	
					if (confirm(confirmMessage)) {
						resetStudentLists = true;
					}
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: "Expecation Periods were saved!", icon: "ok-sign"
					});
					return dispatch(RosterActions.updateAdminPrefs({
						id: CurrentUser.get().id,
						resetStudentLists: resetStudentLists,
						update: prefsUpdate
					}), window.location.reload());
				} else {
	
					confirmMessage = confirmMessage.replace("you may", "you or other teachers or admins may");
					if (confirm(confirmMessage)) {
						resetStudentLists = true;
					}
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: "Expecation Periods were saved!", icon: "ok-sign"
					});
	
					if (CurrentUser.isDistrictAdmin()) {
						return dispatch(RosterActions.updateDistrictOrgPrefs({
							currentUserID: CurrentUser.get().id,
							resetPrefs: resetStudentLists,
							districtOrgID: CurrentUser.get().primary_district_org_id,
							update: prefsUpdate
						}), window.location.reload());
					} else if (CurrentUser.isSchoolAdmin()) {
						return dispatch(RosterActions.updateSchoolOrgPrefs({
							currentUserID: CurrentUser.get().id,
							resetPrefs: resetStudentLists,
							schoolOrgID: CurrentUser.get().primary_school_org_id,
							update: prefsUpdate
						}), window.location.reload());
					}
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ExpectationPeriodPreference, _React$Component);
	
		function ExpectationPeriodPreference(props) {
			_classCallCheck(this, ExpectationPeriodPreference);
	
			var _this = _possibleConstructorReturn(this, (ExpectationPeriodPreference.__proto__ || Object.getPrototypeOf(ExpectationPeriodPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ExpectationPeriodPreference");
			_this.state = { refPrefs: props.refPrefs, save: false };
			return _this;
		}
	
		_createClass(ExpectationPeriodPreference, [{
			key: "selectGradeLevel",
			value: function selectGradeLevel(selectedGradeLevel) {
				this.setState({ selectedGradeLevel: selectedGradeLevel });
			}
		}, {
			key: "editPeriodPreference",
			value: function editPeriodPreference(change, callback) {
				var refPrefs = this.state.refPrefs;
				_underscore2.default.each(change, function (val, key) {
					refPrefs[key] = val;
				});
	
				this.setState({ refPrefs: refPrefs, save: true });
			}
		}, {
			key: "onSave",
			value: function onSave() {
				var prefsUpdate = { "expectations_time_period_starts": this.state.refPrefs["expectations_time_period_starts"],
					"expectations_time_period": this.state.refPrefs["expectations_time_period"] };
				this.props.onChange(prefsUpdate);
				this.setState({ save: false });
			}
	
			// disclaimer that digests need to be recalculated overnight.
	
		}, {
			key: "renderDisclaimer",
			value: function renderDisclaimer() {
				if (this.state.refPrefs.expectations_time_period != this.props.refPrefs.expectations_time_period || !_underscore2.default.isEqual(this.state.refPrefs.expectations_time_period_starts, this.props.refPrefs.expectations_time_period_starts)) {
					return React.createElement(
						"div",
						{ className: "disclaimer" },
						React.createElement(
							"p",
							null,
							"Note: Changes to data settings are recalculated overnight. This change will be reflected on your data pages ",
							React.createElement(
								"i",
								null,
								"tomorrow"
							),
							"."
						)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
	
				if (this.state.save) {
					var saveAction = React.createElement(
						"div",
						{ className: "saveExpectationPeriod" },
						React.createElement(
							"button",
							{ className: "btn btn-primary", onClick: this.onSave.bind(this) },
							"Save"
						)
					);
				}
	
				if (this.state.refPrefs && _underscore2.default.keys(this.state.refPrefs).length > 0) {
					var goals = React.createElement(EditableGoals, { prefs: this.state.refPrefs, onEditPrefs: this.editPeriodPreference.bind(this), hideHeader: true, periodSelector: true });
				}
				return React.createElement(
					"div",
					{ className: "expectationPeriodPreference" },
					React.createElement(
						"p",
						null,
						"Your students' progress will be calculated with the following interval:"
					),
					this.renderDisclaimer(),
					goals,
					saveAction
				);
			}
		}]);
	
		return ExpectationPeriodPreference;
	}(React.Component)) || _class) || _class);
	
	
	ExpectationPeriodPreference.WrappedComponent.propTypes = StrictPropTypes({
		populateData: PropTypes.func.isRequired,
		onChange: PropTypes.func.isRequired,
		refPrefs: PropTypes.object.isRequired
	});
	
	module.exports = ExpectationPeriodPreference;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var EditableGoals = __webpack_require__(190);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3698);
	
	var GradeLevelExpectationsPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var refPrefs = {};
	
		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				});
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state: state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				});
			}
	
			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs;
			}
		}
	
		return {
			refPrefs: refPrefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (CurrentUser.isDistrictAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
						filters: { ids: [CurrentUser.get().primary_district_org_id] },
						embeds: ['district_org.prefs'],
						cache: true
					}))]);
				} else if (CurrentUser.isSchoolAdmin()) {
					return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
						filters: { ids: [CurrentUser.get().primary_school_org_id] },
						embeds: ['school_org.prefs'],
						cache: true
					}))]);
				} else {
					return Promise.all([dispatch(RosterActions.fetchAdmins({
						filters: { ids: [CurrentUser.get().id] },
						embeds: ['user.prefs'],
						cache: true
					}))]);
				}
				return Promise.all([]);
			},
	
			onChange: function onChange(prefsUpdate) {
				// WE NEED TO RELOAD PAGE TO PREVENT HAVING STUDENT LISTS WITH WRONG PREFERENCES
				var confirmMessage = "Do you want to apply this setting to corresponding students/classes? Selecting yes will override the individual student and class preferences you may have set.";
				var resetStudentLists = false;
	
				if (CurrentUser.isTeacherAdmin()) {
	
					if (confirm(confirmMessage)) {
						resetStudentLists = true;
					}
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: "Grade level expecations were saved!", icon: "ok-sign"
					});
					return dispatch(RosterActions.updateAdminPrefs({
						id: CurrentUser.get().id,
						resetStudentLists: resetStudentLists,
						update: prefsUpdate
					}), window.location.reload());
				} else {
	
					confirmMessage = confirmMessage.replace("you may", "you or other teachers or admins may");
					if (confirm(confirmMessage)) {
						resetStudentLists = true;
					}
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: "Grade level expecations were saved!", icon: "ok-sign"
					});
	
					if (CurrentUser.isDistrictAdmin()) {
						return dispatch(RosterActions.updateDistrictOrgPrefs({
							currentUserID: CurrentUser.get().id,
							resetPrefs: resetStudentLists,
							districtOrgID: CurrentUser.get().primary_district_org_id,
							update: prefsUpdate
						}), window.location.reload());
					} else if (CurrentUser.isSchoolAdmin()) {
						return dispatch(RosterActions.updateSchoolOrgPrefs({
							currentUserID: CurrentUser.get().id,
							resetPrefs: resetStudentLists,
							schoolOrgID: CurrentUser.get().primary_school_org_id,
							update: prefsUpdate
						}), window.location.reload());
					}
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(GradeLevelExpectationsPreference, _React$Component);
	
		function GradeLevelExpectationsPreference(props) {
			_classCallCheck(this, GradeLevelExpectationsPreference);
	
			var _this = _possibleConstructorReturn(this, (GradeLevelExpectationsPreference.__proto__ || Object.getPrototypeOf(GradeLevelExpectationsPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("GradeLevelExpectationsPreference");
			var defaultGrade = CurrentUser.get().grade_level && CurrentUser.get().grade_level != 'unknown grade' ? parseInt(CurrentUser.get().grade_level) : 5;
			_this.state = { selectedGradeLevel: defaultGrade, refPrefs: props.refPrefs };
			return _this;
		}
	
		_createClass(GradeLevelExpectationsPreference, [{
			key: "selectGradeLevel",
			value: function selectGradeLevel(selectedGradeLevel) {
				this.setState({ selectedGradeLevel: parseInt(selectedGradeLevel.target.value) });
			}
		}, {
			key: "editGradeLevelPrefs",
			value: function editGradeLevelPrefs(change, callback) {
				var refPrefs = this.state.refPrefs;
	
				refPrefs = _extends({}, refPrefs, change);
	
				if (callback) {
					callback();
				} else {
					this.setState({ refPrefs: refPrefs, save: true });
				}
			}
		}, {
			key: "getGradeLevel",
			value: function getGradeLevel() {
				return this.state.selectedGradeLevel.toString();
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.save) {
					var saveAction = React.createElement(
						"div",
						{ className: "saveExpectationPeriod text-center" },
						React.createElement(
							"button",
							{ className: "btn btn-primary", onClick: this.onSave.bind(this) },
							"Save"
						)
					);
				}
	
				if (this.state.refPrefs && this.getGradeLevel()) {
					var quizGoals = React.createElement(EditableGoals, { gradeLevel: this.getGradeLevel(), prefs: this.state.refPrefs, onEditPrefs: this.editGradeLevelPrefs.bind(this), quiz: true });
					var supplementalGoals = React.createElement(EditableGoals, { gradeLevel: this.getGradeLevel(), prefs: this.state.refPrefs, onEditPrefs: this.editGradeLevelPrefs.bind(this), supplemental: true });
				}
	
				return React.createElement(
					"div",
					{ className: "gradeLevelExpecationsPreference" },
					React.createElement(
						"p",
						null,
						"Your students will be instructed to complete the following activities:"
					),
					React.createElement(
						"div",
						{ className: "row gradeLevelSelection" },
						React.createElement(
							"div",
							{ className: "col-sm-4" },
							"Academic Grade Level:"
						),
						React.createElement(
							"div",
							{ className: "col-sm-8" },
							React.createElement(
								"select",
								{ value: this.state.selectedGradeLevel, className: "form-control gradeSelect",
									onChange: this.selectGradeLevel.bind(this) },
								DropDownOptions.Select.GradeLevels()
							)
						)
					),
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-6" },
							quizGoals
						),
						React.createElement(
							"div",
							{ className: "col-sm-6" },
							supplementalGoals
						)
					),
					saveAction
				);
			}
		}, {
			key: "onSave",
			value: function onSave() {
				var prefsUpdate = { "grade_level_expectations_metrics": this.state.refPrefs["grade_level_expectations_metrics"],
					"grade_level_question_count": this.state.refPrefs["grade_level_question_count"] };
	
				this.props.onChange(prefsUpdate);
				this.setState({ save: false });
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.refPrefs.expectations_time_period != this.props.refPrefs.expectations_time_period || prevProps.refPrefs.expectations_time_period_starts != this.props.refPrefs.expectations_time_period_starts) {
					this.setState({ refPrefs: this.props.refPrefs });
				}
			}
		}]);
	
		return GradeLevelExpectationsPreference;
	}(React.Component)) || _class) || _class);
	
	
	var ALL_GRADES = ["PK", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Mixed"];
	var QUESTION_COUNTS = ["recall_question_count", "analysis_question_count", "sentence_starter_count"];
	
	GradeLevelExpectationsPreference.WrappedComponent.propTypes = StrictPropTypes({
		populateData: PropTypes.func.isRequired,
		onChange: PropTypes.func.isRequired,
		refPrefs: PropTypes.object
	});
	
	module.exports = GradeLevelExpectationsPreference;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ErrorDisplay = __webpack_require__(51);
	var LoadingButton = __webpack_require__(17);
	var SchoolSearch = __webpack_require__(826);
	var CurrentUser = __webpack_require__(3);
	var HelpSectionLink = __webpack_require__(64);
	
	__webpack_require__(3705);
	
	var SchoolInfoModal = function (_React$Component) {
		_inherits(SchoolInfoModal, _React$Component);
	
		function SchoolInfoModal(props) {
			_classCallCheck(this, SchoolInfoModal);
	
			var _this = _possibleConstructorReturn(this, (SchoolInfoModal.__proto__ || Object.getPrototypeOf(SchoolInfoModal)).call(this));
	
			autobind(_this);
			_this.state = {
				addedSchool: false, selectedSchool: null, loading: false,
				showManualFields: false, manualName: "", manualZIP: ""
			};
			return _this;
		}
	
		_createClass(SchoolInfoModal, [{
			key: "selectSchool",
			value: function selectSchool(selectedSchool) {
				this.setState({ selectedSchool: selectedSchool });
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				$wr.nope(e);
	
				this.refs.errors.reset();
				var errors = [];
	
				if (this.state.showManualFields) {
					var zip = this.state.manualZIP.trim();
					var name = this.state.manualName.trim();
					var schoolData = { name: name, zip: zip, pending: false, demographic_bucket: "non-nces" };
	
					if (name.length == 0) {
						errors.push("Please enter your school's name");
					}
					if (zip.length == 0) {
						errors.push("Please enter your ZIP code (or country if non-US)");
					}
				} else {
					var selectedSchool = this.state.selectedSchool;
					if (!(selectedSchool && selectedSchool.value)) {
						errors.push("Please select a school.");
					} else {
						var searchData = selectedSchool.value;
						var districtName = searchData.district ? searchData.district.name : "No District";
						var schoolData = { pending: false, name: searchData.name, zip: searchData.zip,
							district: districtName, canonical_id: searchData.id,
							demographic_bucket: searchData.demographic_bucket };
					}
				}
	
				if (errors.length == 0) {
					if (this.props.altSubmit) {
						this.props.altSubmit(schoolData);
						this.refs.modal.hide();
						return;
					}
	
					var adminID = CurrentUser.get().id;
					CurrentUser.api().patchAdmin(adminID, { admin: { school: schoolData } }, $wr.apiHandler(function (response) {
						this.setState({ addedSchool: true }, function () {
							this.refs.modal.hide();
						}.bind(this));
	
						window.wrNotifications.triggerDropDownNotification({
							title: "Updated!", text: "Thank you for adding your school information", icon: "star" });
						CurrentUser.fetchCurrentUserData(function () {
							if (this.props.updateSchoolInfo) {
								this.props.updateSchoolInfo();
							}
							$(window.document).trigger("onboarding-trigger-select-school");
						}.bind(this));
					}.bind(this)));
				} else {
					this.refs.errors.setErrors(errors);
				}
			}
		}, {
			key: "toggleManualFields",
			value: function toggleManualFields(e) {
				$wr.nope(e);
				this.refs.errors.reset();
				this.setState({ showManualFields: !this.state.showManualFields });
			}
		}, {
			key: "renderManualFields",
			value: function renderManualFields() {
				var _this2 = this;
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-8" },
							React.createElement("input", { className: "form-control", placeholder: "School", id: "schoolName",
								onChange: function onChange(e) {
									_this2.setState({ manualName: e.target.value });
								} })
						),
						React.createElement(
							"div",
							{ className: "col-sm-4" },
							React.createElement("input", { className: "form-control", placeholder: "ZIP or Country", id: "schoolZIP",
								onChange: function onChange(e) {
									_this2.setState({ manualZIP: e.target.value });
								} })
						)
					),
					React.createElement(
						"p",
						{ className: "toggleView" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.toggleManualFields },
							"Back to search."
						)
					)
				);
			}
		}, {
			key: "renderSchoolSearch",
			value: function renderSchoolSearch() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						{ className: "toggleView" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.toggleManualFields },
							"Your school not listed?"
						)
					),
					React.createElement(SchoolSearch, { ref: "search", onSelect: this.selectSchool,
						selectedSchool: this.state.selectedSchool,
						toggleManual: this.toggleManualFields })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var toggleView = this.state.showManualFields ? this.renderManualFields() : this.renderSchoolSearch();
	
				var saveButton = React.createElement(LoadingButton, { text: "Save", className: "btn buttonPrimary saveBtn",
					loading: this.state.loading });
	
				return React.createElement(
					Modal,
					{ className: "schoolInfoModal", preventHide: !this.props.allowHide && !this.state.addedSchool,
						onHide: this.props.onClose,
						ref: "modal", headerText: "Select School", modalOrder: 2 },
					React.createElement(
						"div",
						{ className: "innerWrap" },
						React.createElement(
							"div",
							{ className: "clearfix" },
							React.createElement(
								"p",
								{ className: "aboveFieldsText" },
								"Select your school to see how your students compare to other students at similar schools."
							),
							React.createElement(
								"form",
								{ onSubmit: this.onSubmit, className: "reverseLabels" },
								React.createElement(ErrorDisplay, { ref: "errors" }),
								toggleView,
								saveButton,
								React.createElement("img", { src: __webpack_require__(518), className: "bannerImg" })
							)
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.refs.modal.show();
			}
		}]);
	
		return SchoolInfoModal;
	}(React.Component);
	
	;
	
	SchoolInfoModal.propTypes = StrictPropTypes({
		altSubmit: PropTypes.func, // Alt submit behavior
		updateSchoolInfo: PropTypes.func,
		afterSubmit: PropTypes.func,
		allowHide: PropTypes.bool,
		onClose: PropTypes.func
	});
	
	module.exports = SchoolInfoModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3709);
	
	var MappingControl = function (_React$Component) {
		_inherits(MappingControl, _React$Component);
	
		function MappingControl(props) {
			_classCallCheck(this, MappingControl);
	
			var _this = _possibleConstructorReturn(this, (MappingControl.__proto__ || Object.getPrototypeOf(MappingControl)).call(this));
	
			autobind(_this);
	
			var initialMapping = {};
			var initialCertainty = {};
	
			if (props.initialMatcher) {
				// To pop from
				var useLeft = _.clone(props.left);
	
				_.each(props.right, function (rightItem) {
					var rightKey = _this.getKey(rightItem, false, props);
	
					var bestLeftItem = undefined;
					var bestCertainty = 0;
	
					_.each(useLeft, function (leftItem) {
						var certainty = props.initialMatcher(leftItem, rightItem);
	
						if (certainty > bestCertainty && certainty >= 0.5) {
							bestLeftItem = leftItem;
							bestCertainty = certainty;
						}
					});
	
					if (bestCertainty > 0) {
						var leftKey = _this.getKey(bestLeftItem, true, props);
						initialMapping[leftKey] = rightKey;
						initialCertainty[leftKey] = bestCertainty;
	
						useLeft = _.without(useLeft, bestLeftItem);
					}
	
					console.log(bestCertainty, initialMapping, initialCertainty);
				});
	
				// var matchedRightKeys = new Set();
	
				// _.each(props.left, function(leftItem) {
				// 	var leftKey = this.getKey(leftItem, true, props);
	
				// 	_.each(props.right, function(rightItem) {
				// 		var rightKey = this.getKey(rightItem, false, props);
	
				// 		var certainty = props.initialMatcher(leftItem, rightItem);
	
				// 		if (certainty > 0 && !matchedRightKeys.has(rightKey)) {
				// 			if ((initialCertainty[leftKey] == undefined) ||
				// 				(initialCertainty[leftKey] < certainty)) {
	
				// 				initialMapping[leftKey] = rightKey;
				// 				initialCertainty[leftKey] = certainty;
				// 			}
				// 		}
				// 	}.bind(this));
	
				// 	if (initialMapping[leftKey]) {
				// 		matchedRightKeys.add(this.getKey(initialMapping[leftKey], false, props));
				// 	}
				// }.bind(this));
			}
	
			_this.state = {
				mapping: initialMapping, certainties: initialCertainty,
				leftActiveKey: null, rightActiveKey: null
			};
			return _this;
		}
	
		_createClass(MappingControl, [{
			key: "getMapping",
			value: function getMapping() {
				return this.state.mapping;
			}
		}, {
			key: "addMapping",
			value: function addMapping(leftKey, rightKey) {
				var newMapping = _.clone(this.state.mapping);
				var newCertainties = _.clone(this.state.certainties);
	
				// Delete other leftKeys mapping to rightKey
				_.each(newMapping, function (right, left) {
					if (right == rightKey) {
						delete newMapping[left];
						delete newCertainties[left];
					}
				});
	
				// Add current mapping to rightKey
				newMapping[leftKey] = rightKey;
				newCertainties[leftKey] = 1;
	
				this.setState({
					mapping: newMapping, certainties: newCertainties,
					leftActiveKey: null, rightActiveKey: null
				});
			}
		}, {
			key: "removeMapping",
			value: function removeMapping(leftKey) {
				var newMapping = _.clone(this.state.mapping);
				delete newMapping[leftKey];
	
				var newCertainties = _.clone(this.state.certainties);
				delete newCertainties[leftKey];
	
				this.setState({ mapping: newMapping, certainties: newCertainties });
			}
		}, {
			key: "selectItem",
			value: function selectItem(itemKey, isLeft) {
				if (isLeft) {
					var activeAttr = "leftActiveKey";
					var otherAttr = "rightActiveKey";
				} else {
					var activeAttr = "rightActiveKey";
					var otherAttr = "leftActiveKey";
				}
	
				if (this.state[activeAttr] == itemKey) {
					// Clicking again on the same item deselects is
					var update = {};
					update[activeAttr] = null;
					this.setState(update);
				} else if (this.state[activeAttr] != null || this.state[otherAttr] == null) {
					// Clicking on a different item in the same column switches the selected item
					// ALSO: clicking on an item selects it if the nothing is selected in the other column
					var update = {};
					update[activeAttr] = itemKey;
					this.setState(update);
				} else if (isLeft) {
					this.addMapping(itemKey, this.state.rightActiveKey);
				} else {
					this.addMapping(this.state.leftActiveKey, itemKey);
				}
			}
		}, {
			key: "defaultItemRenderer",
			value: function defaultItemRenderer(item) {
				var elements = _.map(_.keys(item), function (key) {
					return React.createElement(
						"div",
						{ key: key },
						React.createElement(
							"strong",
							null,
							key
						),
						": ",
						item[key]
					);
				});
				return React.createElement(
					"div",
					null,
					elements
				);
			}
		}, {
			key: "getKey",
			value: function getKey(item, isLeft, props) {
				props = props || this.props; // Allow us to use this in constructor
				if (isLeft) {
					return item[props.keyAttr];
				} else {
					return item[props.rightKeyAttr || props.keyAttr];
				}
			}
		}, {
			key: "renderItem",
			value: function renderItem(item, isLeft) {
				var renderer = this.props.itemRenderer || this.defaultItemRenderer;
				var key = this.getKey(item, isLeft);
	
				if (isLeft) {
					var className = "leftItem";
					if (this.state.leftActiveKey == key) {
						className += " active";
					}
				} else {
					var className = "rightItem";
					if (this.state.rightActiveKey == key) {
						className += " active";
					}
				}
	
				return React.createElement(
					"td",
					{ onClick: this.selectItem.bind(this, key, isLeft), className: className },
					renderer(item, isLeft)
				);
			}
		}, {
			key: "renderMappedRows",
			value: function renderMappedRows(mappedPairs) {
				return _.map(mappedPairs, function (leftRightPair, index) {
					var leftItem = this.renderItem(leftRightPair[0], true);
					var rightItem = this.renderItem(leftRightPair[1], false);
	
					var leftKey = this.getKey(leftRightPair[0], true);
	
					if (this.state.certainties[leftKey] >= 1) {
						var linkIcon = "link";
					} else {
						var linkIcon = "option-horizontal";
					}
	
					return React.createElement(
						"tr",
						{ key: "mapped-" + index },
						leftItem,
						React.createElement(
							"td",
							{ className: "joinItem" },
							React.createElement(
								"button",
								{ onClick: this.removeMapping.bind(this, leftKey),
									className: "btn buttonDefault" },
								React.createElement(Glyphicon, { icon: linkIcon, className: "showNormal" }),
								React.createElement(Glyphicon, { icon: "remove", className: "showHover" })
							)
						),
						rightItem
					);
				}.bind(this));
			}
		}, {
			key: "renderUnmappedRows",
			value: function renderUnmappedRows(unmappedLeft, unmappedRight) {
				var rowCount = Math.max(unmappedLeft.length, unmappedRight.length);
				var unmappedRows = [];
	
				var leftItem, rightItem, i;
				for (i = 0; i < rowCount; i++) {
					leftItem = rightItem = undefined;
					if (unmappedLeft[i]) {
						leftItem = this.renderItem(unmappedLeft[i], true);
					} else {
						leftItem = React.createElement("td", null);
					}
					if (unmappedRight[i]) {
						rightItem = this.renderItem(unmappedRight[i], false);
					} else {
						rightItem = React.createElement("td", null);
					}
	
					unmappedRows.push(React.createElement(
						"tr",
						{ key: "unmapped-" + i },
						leftItem,
						React.createElement("td", { className: "joinItem" }),
						rightItem
					));
				}
	
				return unmappedRows;
			}
		}, {
			key: "render",
			value: function render() {
				var sorter = this.props.itemSorter || _.identity;
	
				var sortedLeft = sorter(this.props.left, true);
				var sortedRight = sorter(this.props.right, false);
	
				var unmappedLeft = []; // We'll add to this
				var unmappedRight = _.clone(sortedRight); // We'll remove from this
	
				var mappedPairs = [];
	
				for (var i = 0; i < sortedLeft.length; i++) {
					var leftItem = sortedLeft[i];
					var leftKey = this.getKey(leftItem, true);
	
					if (_.has(this.state.mapping, leftKey)) {
	
						var rightKey = this.state.mapping[leftKey];
						var rightItem = _.find(sortedRight, function (item) {
							return this.getKey(item, false) == rightKey;
						}.bind(this));
	
						if (rightItem == null) {
							console.error("Missing right item with key: " + rightKey);
						}
	
						mappedPairs.push([leftItem, rightItem]);
						unmappedRight = _.without(unmappedRight, rightItem);
					} else {
						unmappedLeft.push(leftItem);
					}
				}
	
				var mappedRows = this.renderMappedRows(mappedPairs);
				var unmappedRows = this.renderUnmappedRows(unmappedLeft, unmappedRight);
	
				if (this.props.leftLabel || this.props.rightLabel) {
					var headerRow = React.createElement(
						"tr",
						null,
						React.createElement(
							"th",
							null,
							this.props.leftLabel
						),
						React.createElement("th", null),
						React.createElement(
							"th",
							null,
							this.props.rightLabel
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "mappingControl" },
					React.createElement(
						"table",
						null,
						React.createElement(
							"tbody",
							null,
							headerRow,
							mappedRows,
							unmappedRows
						)
					)
				);
			}
		}]);
	
		return MappingControl;
	}(React.Component);
	
	;
	
	MappingControl.propTypes = StrictPropTypes({
		left: PropTypes.array.isRequired,
		right: PropTypes.array.isRequired,
	
		// Key of the items on the left, and right if no rightKeyAttr is provided
		// Used to store the mapping. Values should be unique with each of 'left' and 'right'
		keyAttr: PropTypes.string.isRequired,
		rightKeyAttr: PropTypes.string,
	
		// Optional function to render items:
		//    takes item, (object in left/right), as 1st parameter
		//    takes isLeft, boolean, as optional 2nd parameter
		itemRenderer: PropTypes.func,
	
		// Optional function to render items.
		//   Takes a list of items to sort as the first parameter
		//   Takes isLeft, boolean, as optional 2nd parameter
		itemSorter: PropTypes.func,
	
		// Optional function to generate the initialMapping
		// 	 Takes a right item as the first parameter
		//   Takes a left item as the second parameter
		initialMatcher: PropTypes.func,
	
		// Labels to put at the top of the columns
		leftLabel: PropTypes.string,
		rightLabel: PropTypes.string
	});
	
	module.exports = MappingControl;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3712);
	
	var SSORosterReview = function (_React$Component) {
		_inherits(SSORosterReview, _React$Component);
	
		function SSORosterReview(props) {
			_classCallCheck(this, SSORosterReview);
	
			var _this = _possibleConstructorReturn(this, (SSORosterReview.__proto__ || Object.getPrototypeOf(SSORosterReview)).call(this));
	
			autobind(_this);
	
			var selectedRosterIDs = [];
			var selectedStudentIDs = [];
	
			_this.state = {
				stage: CLASS_SELECTION,
				selectedRosterIDs: selectedRosterIDs, selectedStudentIDs: selectedStudentIDs, selectAll: true
			};
	
			_this.continueButton = React.createRef();
			_this.selectionWrap = React.createRef();
			LuckyOrangeClient.tagComponent("SSORosterReview");
			return _this;
		}
	
		_createClass(SSORosterReview, [{
			key: "isGoogle",
			value: function isGoogle(props) {
				return (props || this.props).method == GOOGLE_SYNC;
			}
		}, {
			key: "isClever",
			value: function isClever(props) {
				return (props || this.props).method == CLEVER_SYNC;
			}
		}, {
			key: "ssoSectionKey",
			value: function ssoSectionKey(props) {
				if (this.isGoogle(props)) {
					return "google_id";
				} else if (this.isClever(props)) {
					return "clever_id";
				}
			}
		}, {
			key: "ssoStudentKey",
			value: function ssoStudentKey(props) {
				if (this.isGoogle(props)) {
					return "google_sign_in_id";
				} else if (this.isClever(props)) {
					return "clever_sign_in_id";
				}
			}
		}, {
			key: "toggleSection",
			value: function toggleSection(sectionID) {
				if (this.isGoogle(this.props)) {
					var section = _.findWhere(this.props.rosterData, { 'google_id': sectionID });
				} else {
					var section = _.findWhere(this.props.rosterData, { 'clever_id': sectionID });
				}
	
				if (section) {
					var students = section['students'];
					var studentIDs = _.pluck(students, this.ssoStudentKey(this.props));
	
					if (this.state.selectedRosterIDs.includes(sectionID)) {
						var selectedRosterIDs = _.without(this.state.selectedRosterIDs, sectionID);
						var selectedStudentIDs = _.filter(this.state.selectedStudentIDs, function (id) {
							return !_.include(studentIDs, id);
						});
					} else {
						var selectedRosterIDs = this.state.selectedRosterIDs.concat(sectionID);
						var selectedStudentIDs = this.state.selectedStudentIDs.concat(studentIDs);
					}
					this.setState({ selectedRosterIDs: selectedRosterIDs, selectedStudentIDs: selectedStudentIDs });
				}
			}
		}, {
			key: "toggleStudent",
			value: function toggleStudent(sectionID) {
				if (this.state.selectedStudentIDs.includes(sectionID)) {
					var selectedStudentIDs = _.without(this.state.selectedStudentIDs, sectionID);
				} else {
					var selectedStudentIDs = this.state.selectedStudentIDs.concat(sectionID);
				}
				this.setState({ selectedStudentIDs: selectedStudentIDs });
			}
		}, {
			key: "changeStage",
			value: function changeStage(stage, e) {
				$wr.nope(e);
				this.setState({ stage: stage }, this.updateButtonPosition);
			}
		}, {
			key: "completeSync",
			value: function completeSync() {
				var _this2 = this;
	
				var finalData = [];
				_.each(this.props.rosterData, function (roster) {
					if (_this2.state.selectedRosterIDs.includes(roster[_this2.ssoSectionKey()])) {
						var finalRoster = _.clone(roster);
						finalRoster.students = _.select(roster.students || [], function (student) {
							return _this2.state.selectedStudentIDs.includes(student[_this2.ssoStudentKey()]);
						});
	
						finalData.push(finalRoster);
					}
				});
				this.props.finalizeRoster(finalData);
			}
		}, {
			key: "renderClassSelection",
			value: function renderClassSelection() {
				var _this3 = this;
	
				if (this.isGoogle()) {
					var header = "Select the classes you want to import into your Roster. Make sure there aren't duplicate classes.";
				} else if (this.isClever()) {
					var header = "Which classes do you want to sync?";
				}
	
				var sortedSections = _.sortBy(this.props.rosterData, "name");
	
				var classOptions = _.map(sortedSections, function (section) {
					var selected = _this3.state.selectedRosterIDs.includes(section[_this3.ssoSectionKey()]);
					return React.createElement(
						"label",
						{ key: section[_this3.ssoSectionKey()], className: "normal selectionOp" },
						React.createElement(
							"span",
							{ className: "double" },
							React.createElement("input", { type: "checkbox", checked: selected, className: "selectionCheckbox",
								onChange: _this3.toggleSection.bind(_this3, section[_this3.ssoSectionKey()]) })
						),
						React.createElement(
							"span",
							{ className: "selectionLabel" },
							section.name
						),
						React.createElement(
							"span",
							{ className: "subLine" },
							$wr.pluralizeWithNumber("student", (section.students || []).length)
						)
					);
				});
	
				if (this.state.selectedRosterIDs.length > 0) {
					var nextButton = React.createElement(
						"button",
						{ className: "continueButton btn buttonPrimary",
							ref: this.continueButton,
							onClick: this.changeStage.bind(this, STUDENT_SELECTION) },
						"Next"
					);
				}
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						header
					),
					React.createElement(
						"div",
						{ className: "selectionWrap", ref: this.selectionWrap },
						React.createElement(
							"div",
							{ className: "selectionOptions" },
							classOptions
						),
						React.createElement(
							"div",
							{ className: "nextSection" },
							nextButton
						)
					)
				);
			}
		}, {
			key: "selectAllStudents",
			value: function selectAllStudents() {
				var _this4 = this;
	
				var selectedSections = _.sortBy(_.select(this.props.rosterData, function (section) {
					return _this4.state.selectedRosterIDs.includes(section[_this4.ssoSectionKey()]);
				}), "name");
	
				_.map(selectedSections, function (section) {
					var sortedStudents = _.sortBy(section.students || [], function (student) {
						return student.last_name + ", " + student.first_name;
					});
					var sectionIDS = [];
					_.map(sortedStudents, function (student) {
						var sectionID = student[_this4.ssoStudentKey()];
						sectionIDS.push(sectionID);
					});
					if (_.intersection(sectionIDS).length == _this4.state.selectedStudentIDs.length) {
						var selectedStudentIDs = [];
						var selectAll = false;
					} else {
						var selectedStudentIDs = _this4.state.selectedStudentIDs.concat(sectionIDS);
						var selectAll = true;
					}
					_this4.setState({ selectedStudentIDs: selectedStudentIDs, selectAll: selectAll });
				});
			}
		}, {
			key: "renderStudentSelection",
			value: function renderStudentSelection() {
				var _this5 = this;
	
				if (this.isGoogle() || this.isClever()) {
					var header = "Select the students you want to import into your Roster";
				}
	
				var selectedSections = _.sortBy(_.select(this.props.rosterData, function (section) {
					return _this5.state.selectedRosterIDs.includes(section[_this5.ssoSectionKey()]);
				}), "name");
	
				var classSections = _.map(selectedSections, function (section) {
					var selected = _this5.state.selectedStudentIDs.includes(section[_this5.ssoSectionKey()]);
	
					var sortedStudents = _.sortBy(section.students || [], function (student) {
						return student.last_name + ", " + student.first_name;
					});
	
					var studentOptions = _.map(sortedStudents, function (student) {
						var selected = _this5.state.selectedStudentIDs.includes(student[_this5.ssoStudentKey()]);
						return React.createElement(
							"p",
							{ key: student[_this5.ssoStudentKey()], className: "normal selectionOp" },
							React.createElement(
								"span",
								{ className: "double" },
								React.createElement("input", { type: "checkbox", checked: selected, className: "selectionCheckbox",
									onChange: _this5.toggleStudent.bind(_this5, student[_this5.ssoStudentKey()]) })
							),
							React.createElement(
								"span",
								{ className: "selectionLabel student" },
								student.first_name,
								" ",
								student.last_name
							)
						);
					});
	
					if (_this5.state.selectAll) {
						var control = React.createElement(
							"a",
							{ className: "control", onClick: _this5.selectAllStudents },
							"Clear All"
						);
					} else {
						var control = React.createElement(
							"a",
							{ className: "control", onClick: _this5.selectAllStudents },
							"Select All"
						);
					}
	
					return React.createElement(
						"div",
						{ key: section[_this5.ssoSectionKey()], className: "classSection" },
						React.createElement(
							"p",
							{ className: "sectionName" },
							section.name,
							control
						),
						React.createElement(
							"div",
							{ className: "studentOptions" },
							studentOptions
						)
					);
				});
	
				if (this.state.selectedStudentIDs.length > 0) {
					var completeButton = React.createElement(
						"button",
						{ className: "continueButton btn buttonSuccess",
							ref: this.continueButton,
							onClick: this.completeSync },
						"Complete Sync"
					);
					var className = "finalStep";
				}
	
				var studentCount = this.props.studentCount;
				if (studentCount > 0) {
					if (this.isClever()) {
						var loginInfo = React.createElement(
							"div",
							{ className: "loginMethod clever" },
							React.createElement(
								"p",
								{ className: "notice" },
								studentCount,
								" students are being added to your ",
								React.createElement(
									"i",
									null,
									"Roster"
								),
								" with your Clever account. "
							),
							React.createElement(
								"div",
								null,
								React.createElement("img", { className: "stepsImg", src: __webpack_require__(1648), alt: "Log into Whooo's Reading with Clever" }),
								React.createElement(
									"div",
									{ className: "infoContainer" },
									React.createElement(
										"p",
										{ className: "header" },
										"How students log in from Whooo's Reading:"
									),
									React.createElement(
										"ol",
										null,
										React.createElement(
											"li",
											null,
											"Go to www.whooosreading.org"
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Log In"
											),
											" button (upper right)"
										),
										React.createElement(
											"li",
											null,
											"Select ",
											React.createElement(
												"b",
												null,
												"Student"
											)
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Sign in with Clever"
											)
										),
										React.createElement(
											"li",
											null,
											"Enter Clever login information"
										)
									)
								)
							),
							React.createElement(
								"div",
								null,
								React.createElement("img", { className: "stepsImg", src: __webpack_require__(1626), alt: "clever-share-settings" }),
								React.createElement(
									"div",
									{ className: "infoContainer" },
									React.createElement(
										"p",
										{ className: "header" },
										"How students log in from Clever:"
									),
									React.createElement(
										"ol",
										null,
										React.createElement(
											"span",
											null,
											"Teacher"
										),
										React.createElement("br", null),
										React.createElement(
											"li",
											null,
											"Go to Clever home page"
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Add"
											),
											" button (bottom right)"
										),
										React.createElement(
											"li",
											null,
											"Select ",
											React.createElement(
												"b",
												null,
												"App"
											)
										),
										React.createElement(
											"span",
											{ className: "studentSteps" },
											"Students"
										),
										React.createElement("br", null),
										React.createElement(
											"li",
											null,
											"Log into Clever"
										),
										React.createElement(
											"li",
											null,
											"Select Whooo's Reading icon shown on their accounts."
										)
									)
								)
							)
						);
					} else if (this.isGoogle()) {
						var loginInfo = React.createElement(
							"div",
							{ className: "loginMethod" },
							React.createElement(
								"p",
								{ className: "notice" },
								studentCount,
								" students are being added to your ",
								React.createElement(
									"i",
									null,
									"Roster"
								),
								" from your Google Classroom account. "
							),
							React.createElement(
								"div",
								null,
								React.createElement("img", { className: "stepsImg", src: __webpack_require__(1649), alt: "Log into Whooo's Reading with Google Classroom" }),
								React.createElement(
									"div",
									{ className: "infoContainer" },
									React.createElement(
										"p",
										{ className: "header" },
										"How students log into Whooo's Reading:"
									),
									React.createElement(
										"ol",
										null,
										React.createElement(
											"li",
											null,
											"Go to www.whooosreading.org"
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Log In"
											),
											" button (upper right)"
										),
										React.createElement(
											"li",
											null,
											"Select ",
											React.createElement(
												"b",
												null,
												"Student"
											)
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Sign in with Google"
											)
										),
										React.createElement(
											"li",
											null,
											"Enter Google account login information"
										)
									),
									React.createElement(
										"p",
										null,
										"If you are unsure how to do this, help your students with ",
										React.createElement(
											"a",
											{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/115001477811", target: "_blank" },
											"these login instructions"
										),
										"."
									)
								)
							)
						);
					}
					var content = loginInfo;
				} else {
					var content = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "stageHeader" },
							header,
							React.createElement("br", null),
							React.createElement(
								"a",
								{ href: "#", className: "backLink",
									onClick: this.changeStage.bind(this, CLASS_SELECTION) },
								"< ",
								" Back"
							)
						),
						React.createElement(
							"div",
							{ className: "selectionWrap", ref: this.selectionWrap },
							React.createElement(
								"div",
								{ className: "selectionOptions" },
								classSections
							),
							React.createElement(
								"div",
								{ className: className + " nextSection" },
								completeButton
							)
						)
					);
				}
	
				return content;
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.stage == CLASS_SELECTION) {
					var stageContent = this.renderClassSelection();
				} else if (this.state.stage == STUDENT_SELECTION) {
					var stageContent = this.renderStudentSelection();
				}
				return React.createElement(
					"div",
					{ className: "ssoRosterReview" },
					stageContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(document).on("modal-scroll", this.updateButtonPosition);
				this.updateButtonPosition();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(document).off("modal-scroll", this.updateButtonPosition);
			}
		}, {
			key: "updateButtonPosition",
			value: function updateButtonPosition() {
				var $btn = $(this.continueButton.current);
				var $wrap = $(this.selectionWrap.current);
	
				var windowHeight = $(window).height();
				var wrapY = $wrap.offset().top;
				var wrapHeight = $wrap.height();
				var buttonHeight = $btn.outerHeight();
				var give = 15;
	
				var baseOffset = Math.max(Math.min(wrapHeight, windowHeight - wrapY), 0);
				var offset = baseOffset - (buttonHeight + give);
	
				$btn.css({ top: offset });
			}
		}]);
	
		return SSORosterReview;
	}(React.Component);
	
	;
	
	var CLASS_SELECTION = "class-selection";
	var STUDENT_SELECTION = "student-selection";
	
	var GOOGLE_SYNC = "google-sync";
	SSORosterReview.GOOGLE_SYNC = GOOGLE_SYNC;
	
	var CLEVER_SYNC = "clever-sync";
	SSORosterReview.CLEVER_SYNC = CLEVER_SYNC;
	
	SSORosterReview.propTypes = StrictPropTypes({
		rosterData: PropTypes.array.isRequired,
		finalizeRoster: PropTypes.func.isRequired,
		method: PropTypes.string.isRequired,
		studentCount: PropTypes.number
	});
	
	module.exports = SSORosterReview;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var ErrorDisplay = __webpack_require__(51);
	var DropDownOptions = __webpack_require__(26);
	var Localization = __webpack_require__(1006);
	var ReactTooltip = __webpack_require__(12);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3716);
	
	var CreditCardInput = function (_React$Component) {
		_inherits(CreditCardInput, _React$Component);
	
		function CreditCardInput(props) {
			_classCallCheck(this, CreditCardInput);
	
			var _this = _possibleConstructorReturn(this, (CreditCardInput.__proto__ || Object.getPrototypeOf(CreditCardInput)).call(this));
	
			autobind(_this);
			_this.state = {
				stripeToken: null, wepayToken: null,
				loadedDependencies: false, loading: false
			};
			return _this;
		}
	
		_createClass(CreditCardInput, [{
			key: "useStripe",
			value: function useStripe() {
				return this.props.paymentInfo.stripe_public_key != undefined;
			}
		}, {
			key: "useWepay",
			value: function useWepay() {
				return this.props.paymentInfo.wepay_account_id != undefined;
			}
	
			// userData: A hash containing "name" and "email"
			// callback: An optional function that takes two arguments:
			//    true/false depending on charge success and a hash containing payment platforms
	
		}, {
			key: "tokenize",
			value: function tokenize(userData, callback) {
				var _this2 = this;
	
				if (!this.state.loading) {
					this.setState({ loading: true });
					this.refs.errors.reset();
					var $wrap = $(this.refs.creditCardInput);
	
					if (userData) {
						$(this.refs.nameInput).val(userData.name);
						$(this.refs.emailInput).val(userData.email);
					}
	
					if (this.useStripe()) {
						Stripe.setPublishableKey(this.props.paymentInfo.stripe_public_key);
	
						Stripe.card.createToken($wrap, function (status, response) {
							if (response.error) {
								_this2.refs.errors.setError(response.error.message);
	
								_this2.setState({ loading: false });
								if (callback) {
									callback(false);
								}
	
								// $wr.scrollToElement($wrap[0])
							} else {
								var token = response.id;
								if (callback) {
									callback(true, { stripe_token: token });
								}
							}
						});
					} else if (this.useWepay()) {
	
						// THIS HASN'T BEEN USED IN WR CREDIT CARD INPUT
	
						var wepayClientID = $('meta[name="wepay-client-id"]').attr("content");
	
						var cardData = {
							client_id: wepayClientID,
	
							cc_number: this.refs.number.value,
							cvv: this.refs.cvc.value,
							expiration_month: this.refs.expMonth.value,
							expiration_year: this.refs.expYear.value,
	
							user_name: this.refs.nameInput.value,
							email: this.refs.emailInput.value,
							address: { zip: this.refs.billingZIP.value.trim() }
						};
	
						var initialResponse = WePay.credit_card.create(cardData, function (data) {
							if (data.error) {
								_this2.handleWepayError(data.error_description);
								if (callback) {
									callback(false);
								}
							} else {
								var token = data.credit_card_id;
								_this2.setState({ wepayToken: token }, function () {
									if (callback) {
										callback(true, { wepay_token: token });
									}
								});
							}
						});
						if (initialResponse.error) {
							$wrap.trigger("credit-card-error");
							this.handleWepayError(initialResponse.error_description);
						}
					} else {
						throw "No payment credentials loaded!";
					}
				}
			}
		}, {
			key: "handleWepayError",
			value: function handleWepayError(rawError) {
				var errorText;
				switch (rawError.trim()) {
					case "The cc_number parameter is required.":
						errorText = "Please enter a credit card number.";break;
					case "The cvv parameter is required.":
						errorText = "Please enter a CVC";break;
					case "ZIP Code '' is invalid":
						errorText = "Please enter a ZIP code";break;
					default:
						errorText = rawError;break;
				}
	
				this.refs.errors.setError(errorText);
				this.setState({ loading: false });
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.state.loadedDependencies) {
					return React.createElement(
						"div",
						{ className: "creditCardInput" },
						React.createElement(Spinner, { placeholder: true })
					);
				}
	
				var translations = Localization.getTranslations("credit_card");
	
				return React.createElement(
					"div",
					{ className: "creditCardInput", ref: "creditCardInput" },
					React.createElement(ErrorDisplay, { ref: "errors" }),
					React.createElement("input", { type: "hidden", "data-stripe": "name", ref: "nameInput" }),
					React.createElement("input", { type: "hidden", "data-stripe": "email", ref: "emailInput" }),
					React.createElement(
						"div",
						{ className: "creditCardInfoLine" },
						React.createElement("img", { src: __webpack_require__(503), alt: "visaLogo", className: "ccLogo" }),
						React.createElement("img", { src: __webpack_require__(502), alt: "visaLogo", className: "ccLogo" }),
						React.createElement("img", { src: __webpack_require__(499), alt: "visaLogo", className: "ccLogo" }),
						React.createElement("img", { src: __webpack_require__(500), alt: "visaLogo", className: "ccLogo" }),
						React.createElement("img", { src: __webpack_require__(501), alt: "visaLogo", className: "ccLogo" })
					),
					React.createElement(
						"div",
						{ className: "creditCardInfoLine" },
						React.createElement(
							"label",
							{ className: "numberField" },
							React.createElement(
								"span",
								null,
								translations.number
							),
							React.createElement(
								"div",
								{ className: "securityNote" },
								React.createElement(Glyphicon, { icon: "lock" }),
								" SECURE"
							),
							React.createElement("input", { type: "text", "data-stripe": "number", ref: "number",
								className: "form-control number", placeholder: "1111 2222 3333 4444" })
						)
					),
					React.createElement(
						"div",
						{ className: "creditCardInfoLine" },
						React.createElement(
							"label",
							{ className: "expMonthField" },
							React.createElement(
								"span",
								null,
								translations.expiration
							),
							React.createElement(
								"select",
								{ type: "text", className: "form-control month", ref: "expMonth",
									"data-stripe": "exp-month", id: "expMonth" },
								DropDownOptions.Select.Months({ longForm: true })
							)
						),
						React.createElement(
							"label",
							{ className: "expYearField" },
							React.createElement("span", null),
							React.createElement(
								"select",
								{ type: "text", className: "form-control year", ref: "expYear",
									"data-stripe": "exp-year" },
								DropDownOptions.Select.FutureYears({ yearsForward: 25, shortFrom: true })
							)
						)
					),
					React.createElement(
						"div",
						{ className: "creditCardInfoLine" },
						React.createElement(
							"label",
							{ className: "cvcField" },
							translations.security_code,
							" ",
							React.createElement(Glyphicon, { icon: "question-sign", dataTip: translations.cvc_tooltip }),
							React.createElement("input", { type: "text", className: "form-control cvc", "data-stripe": "cvc", ref: "cvc" })
						),
						React.createElement(
							"label",
							{ className: "billingZipField" },
							React.createElement(
								"span",
								null,
								translations.zip_code
							),
							React.createElement("input", { type: "text", className: "form-control billing-zip", ref: "billingZIP",
								"data-stripe": "address_zip" })
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this3 = this;
	
				$wr.loadScript("https://js.stripe.com/v1", "Stripe", function () {
					_this3.setState({ loadedDependencies: true });
				});
			}
		}]);
	
		return CreditCardInput;
	}(React.Component);
	
	;
	
	if ($wr.isProduction()) {
		CreditCardInput.STRIPE_PUBLIC_KEY = "pk_live_WPpwqypzAMeHf2FAepHwoAdE";
	} else if ($wr.isStaging()) {
		CreditCardInput.STRIPE_PUBLIC_KEY = "pk_test_ImABw5k0qlia4jLZaY5N3Aa2";
	} else {
		CreditCardInput.STRIPE_PUBLIC_KEY = "pk_test_eeAms8duPFufyoRikibYt4Vl";
	}
	
	CreditCardInput.propTypes = StrictPropTypes({
		// Contains WePay or Stripe Info
		paymentInfo: PropTypes.object.isRequired,
	
		// (optional) Extra info for credit card: name, email
		extraInfo: PropTypes.object
	});
	
	module.exports = CreditCardInput;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentDisplay = __webpack_require__(52);
	var ReactTooltip = __webpack_require__(12);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3728);
	
	var ParticipatingStudentsDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// This isn't particularly elegant
		var studentNameLookup = {};
		_.each(RosterSelectors.students({ state: state }), function (student) {
			studentNameLookup[student.id] = student.display_name;
		});
	
		var orgIdentifier = RosterSelectors.orgIdentifierForStudents({
			state: state, studentIDs: props.studentIDs
		});
	
		if (orgIdentifier) {
			var groupText = RosterSelectors.nameForOrgIdentifier({
				state: state, orgIdentifier: orgIdentifier, fallback: "Select one"
			});
		}
	
		return {
			studentNameLookup: studentNameLookup, groupText: groupText
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(ParticipatingStudentsDisplay, _React$Component);
	
		function ParticipatingStudentsDisplay(props) {
			_classCallCheck(this, ParticipatingStudentsDisplay);
	
			var _this = _possibleConstructorReturn(this, (ParticipatingStudentsDisplay.__proto__ || Object.getPrototypeOf(ParticipatingStudentsDisplay)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(ParticipatingStudentsDisplay, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.groupText) {
					var studentsDisplayContainer = React.createElement(
						"div",
						{ className: "allStudentsDisplay" },
						React.createElement("img", { src: __webpack_require__(542), alt: "" }),
						" ",
						this.props.groupText
					);
				} else {
					var studentsDisplay = _.first(this.props.studentIDs, this.props.maxDisplayStudentCount).map(function (studentID) {
						return React.createElement(
							"div",
							{ key: studentID, className: "studentAvatarWrap b-tooltip",
								"data-tip": _this2.props.studentNameLookup[studentID] },
							React.createElement(StudentDisplay, { studentID: studentID,
								showAvatar: true, hideName: true,
								avatarMaxWidth: 30 }),
							React.createElement(ReactTooltip, { effect: "solid" })
						);
					});
					if (this.props.maxDisplayStudentCount && this.props.studentIDs.length > this.props.maxDisplayStudentCount) {
						var moreStudents = React.createElement(
							"div",
							{ className: "moreStudentsContainer" },
							React.createElement(
								"span",
								null,
								" +",
								this.props.studentIDs.length - this.props.maxDisplayStudentCount
							),
							React.createElement(
								"span",
								{ className: "moreText" },
								" more"
							)
						);
					}
					var studentsDisplayContainer = React.createElement(
						"div",
						{ className: "studentsDisplayContainer" },
						studentsDisplay,
						moreStudents
					);
				}
	
				return React.createElement(
					"div",
					{ className: "participatingStudentsDisplay" },
					studentsDisplayContainer
				);
			}
		}]);
	
		return ParticipatingStudentsDisplay;
	}(React.Component)) || _class);
	
	
	ParticipatingStudentsDisplay.WrappedComponent.propTypes = StrictPropTypes({
		maxDisplayStudentCount: PropTypes.number,
		studentIDs: PropTypes.array,
		groupText: PropTypes.string,
	
		// Show a spinner and block onEnd notices if this is true
		loading: PropTypes.bool,
	
		studentNameLookup: PropTypes.object
	});
	
	module.exports = ParticipatingStudentsDisplay;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var Modal = __webpack_require__(18);
	var Glyphicon = __webpack_require__(8);
	var TextTypes = __webpack_require__(38);
	
	var SmartBookSearch = __webpack_require__(118);
	var LogReadingModal = __webpack_require__(164);
	
	var BookDisplay = __webpack_require__(46);
	
	var Spinner = __webpack_require__(9);
	var ReactTooltip = __webpack_require__(12);
	var BookTextVariety = __webpack_require__(141);
	var WhooosReadingServices = __webpack_require__(25);
	var StudentMetrics = __webpack_require__(29);
	
	__webpack_require__(650);
	
	var BookActionModal = function (_React$Component) {
		_inherits(BookActionModal, _React$Component);
	
		function BookActionModal(props) {
			_classCallCheck(this, BookActionModal);
	
			var _this = _possibleConstructorReturn(this, (BookActionModal.__proto__ || Object.getPrototypeOf(BookActionModal)).call(this));
	
			autobind(_this);
			_this.state = {
				// Note there is also a selectedBook (for log reading only) in StudentHomePage :(
				selectedBook: null,
	
				loading: false, quiz: null, bookStatus: null,
				showBookModal: false, bookKeyIndex: 0
			};
			return _this;
		}
	
		_createClass(BookActionModal, [{
			key: 'isFirstBook',
			value: function isFirstBook() {
				return _.size(this.props.existingBooks) == 0;
			}
		}, {
			key: 'openQuiz',
			value: function openQuiz(e) {
				$wr.nope(e);
				// Don't check text variety for quizzes
				this.setState({ loading: true });
				this.props.openBookActivity("quiz", this.props.selectedBook);
			}
		}, {
			key: 'openLogReading',
			value: function openLogReading(e) {
				$wr.nope(e);
				LuckyOrangeClient.tagComponent("BookActionModal");
				this.setState({ showBookModal: true });
				this.refs.modal.hide();
			}
	
			// closeLogReading(readingWasLogged) {
			// 	if (readingWasLogged) {
			// 		this.setState({ showBookModal: false, bookKeyIndex: (this.state.bookKeyIndex + 1) });
			// 	} else {
			// 		this.setState({ showBookModal: false });
			// 	}
			// }
	
		}, {
			key: 'openReview',
			value: function openReview(e) {
				$wr.nope(e);
				this.setState({ loading: true });
				this.props.openBookActivity("review", this.props.selectedBook);
			}
		}, {
			key: 'openExcercise',
			value: function openExcercise(e) {
				$wr.nope(e);
				this.setState({ loading: true });
				this.props.openBookActivity("exercise", this.props.selectedBook);
			}
		}, {
			key: 'openQuestions',
			value: function openQuestions(e) {
				$wr.nope(e);
				this.setState({ loading: true });
				this.props.openBookActivity("question", this.props.selectedBook);
			}
		}, {
			key: 'textVarietySelected',
			value: function textVarietySelected(book) {
				this.setState({ loading: true });
				this.props.openBookActivity(this.state.requestedAction, book);
			}
		}, {
			key: 'checkTextVariety',
			value: function checkTextVariety(action) {
				if (this.props.studentDashboard) {
					return true;
				}
				if (this.state.selectedBook) {
					if (this.state.selectedBook.overridden) {
						this.setState({
							getTextVariety: true,
							requestedAction: action
						});
						return false;
					}
					return true;
				}
				return false;
			}
		}, {
			key: 'resetTextVariety',
			value: function resetTextVariety() {
				this.setState({
					getTextVariety: false
				});
			}
		}, {
			key: 'submitOverride',
			value: function submitOverride(attribute_name, text_id, value) {
				var user = CurrentUser.get();
				var override_data = {
					instance_id: text_id,
					instance_type: "book",
					attribute_name: attribute_name,
					value: value,
					user_id: user.id,
					user_role: user.role
				};
	
				var url = WhooosReadingServices.Matilda.url("/overrides");
				$wr.postJSON(url, { override: override_data }, function (data) {
					var newBook = $.extend({}, this.props.book);
					newBook.text_variety = value;
				}.bind(this));
			}
		}, {
			key: 'setBookStatus',
			value: function setBookStatus(value) {
				this.setState({ bookStatus: value });
			}
		}, {
			key: 'show',
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: 'renderTaskIcon',
			value: function renderTaskIcon(typeName) {
				if (this.props.selectedBook && this.props.selectedBook.taskItems) {
					var taskItems = this.props.selectedBook.taskItems;
					var requiredTaskItems = _.where(taskItems, { subject_type: typeName }).length;
					var finishedTaskItems = _.where(taskItems, { subject_type: typeName, draft: false }).length;
					if (requiredTaskItems === 0) {
						return React.createElement(
							'span',
							{ className: 'subtaskIcon grayIcon' },
							'Optional'
						);
					} else if (requiredTaskItems <= finishedTaskItems) {
						return React.createElement(
							'span',
							{ className: 'subtaskIcon greenIcon' },
							'Completed'
						);
					} else if (requiredTaskItems > finishedTaskItems) {
						return React.createElement(
							'span',
							{ className: 'subtaskIcon redIcon' },
							'Required'
						);
					} else {
						return React.createElement(
							'span',
							{ className: 'subtaskIcon grayIcon' },
							'Optional'
						);
					}
				}
			}
		}, {
			key: 'renderChoiceModal',
			value: function renderChoiceModal() {
				if (this.state.loading) {
					var loadingIcon = React.createElement(
						'div',
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (this.state.getTextVariety) {
					var modalContent = React.createElement(BookTextVariety, { reset: this.resetTextVariety, book: this.state.selectedBook,
						onSubmit: this.textVarietySelected });
				} else {
					var metrics = _.values(StudentMetrics.TYPES);
					var expectations = _.pluck(this.props.expectations, "metric");
	
					var containsReadingExpectation = false;
	
					var actions = _.sortBy(metrics, function (metric) {
						return expectations.includes(metric);
					});
	
					var actions = actions.reverse().map(function (action) {
						if (action == StudentMetrics.TYPES.QUIZZES_PASSED) {
							return React.createElement(
								'a',
								{ href: '#', key: action, className: 'actionOp quizOp soloOp', onClick: this.openQuiz,
									'data-tip': 'Finish the book before you take a quiz!' },
								React.createElement('img', { src: __webpack_require__(220), alt: 'Take a Quiz' }),
								React.createElement(
									'span',
									null,
									'Take a Quiz'
								),
								this.renderTaskIcon('Quiz')
							);
						} else if (action == StudentMetrics.TYPES.MINUTES || action == StudentMetrics.TYPES.PAGES) {
							if (Features.isEnabled(Features.LOG_READING) && !containsReadingExpectation) {
								containsReadingExpectation = true;
								return React.createElement(
									'a',
									{ href: '#', key: action, className: 'actionOp logReadingOp', onClick: this.openLogReading },
									React.createElement('img', { src: __webpack_require__(337), alt: 'Log Reading' }),
									React.createElement(
										'span',
										null,
										'Log Reading'
									),
									this.renderTaskIcon('Reading')
								);
							}
						} else if (action == StudentMetrics.TYPES.EXERCISES) {
							if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
								return React.createElement(
									'a',
									{ href: '#', key: action, className: 'actionOp', onClick: this.openExcercise },
									React.createElement('img', { src: __webpack_require__(186), alt: 'Do an Exercise' }),
									React.createElement(
										'span',
										null,
										'Start an Exercise'
									),
									this.renderTaskIcon('Exercise')
								);
							}
						} else if (action == StudentMetrics.TYPES.QUESTIONS) {
							return React.createElement(
								'a',
								{ href: '#', key: action, className: 'actionOp questionOp', onClick: this.openQuestions },
								React.createElement('img', { src: __webpack_require__(338), alt: 'Answer a Question' }),
								React.createElement(
									'span',
									null,
									'Answer a Question'
								),
								this.renderTaskIcon('Practice Question')
							);
						} else if (action == StudentMetrics.TYPES.REVIEWS) {
							return React.createElement(
								'a',
								{ href: '#', key: action, className: 'actionOp', onClick: this.openReview },
								React.createElement('img', { src: __webpack_require__(187), alt: 'Write a Review' }),
								React.createElement(
									'span',
									null,
									'Write a Review'
								),
								this.renderTaskIcon('Review')
							);
						}
					}.bind(this));
	
					try {
						if (actions) {
							actions = _.filter(actions, function (action) {
								return action !== undefined;
							});
							var completedActions = _.filter(actions, function (action) {
								var iconClass = action.props.children[action.props.children.length - 1].props.className;
								return iconClass.includes('greenIcon');
							});
							var requiredActions = _.filter(actions, function (action) {
								var iconClass = action.props.children[action.props.children.length - 1].props.className;
								return iconClass.includes('redIcon');
							});
							var optionalActions = _.filter(actions, function (action) {
								var iconClass = action.props.children[action.props.children.length - 1].props.className;
								return iconClass.includes('grayIcon');
							});
						}
						actions = completedActions.concat(requiredActions).concat(optionalActions);
					} catch (e) {
						// silence is golden
					}
	
					var modalContent = React.createElement(
						'div',
						{ className: 'secondaryOptions' },
						React.createElement(
							'div',
							{ className: 'actionsContainer' },
							actions
						)
					);
				}
	
				if (this.props.selectedBook) {
	
					if (this.props.selectedBook.url) {
						var bookDisplay = React.createElement(
							BookDisplay,
							{ textID: this.props.selectedBook.text_id, coverWidth: 120,
								showCover: true },
							React.createElement('br', null),
							React.createElement(
								'a',
								{ href: this.props.selectedBook.url, target: '_blank', className: 'buttonSuccess' },
								'Read it Now!'
							)
						);
					} else {
						var bookDisplay = React.createElement(BookDisplay, { textID: this.props.selectedBook.text_id, coverWidth: 70,
							showCover: true, showAuthor: true });
					}
				}
	
				return React.createElement(
					Modal,
					{ className: 'bookActionModal', ref: 'modal',
						headerText: 'What do you want to do next?', onShow: this.setBookStatus.bind(this, null) },
					React.createElement(
						'div',
						{ className: 'selectedBookHeader' },
						bookDisplay
					),
					loadingIcon,
					React.createElement(
						'div',
						{ className: 'bookOptions' },
						modalContent
					)
				);
			}
		}, {
			key: 'clearSelectedBook',
			value: function clearSelectedBook() {
				this.setState({ selectedBook: null });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				$(window.document).on("clear-selected-book", this.clearSelectedBook);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				$(window.document).off("clear-selected-book", this.clearSelectedBook);
			}
		}, {
			key: 'onBack',
			value: function onBack(bookStatus) {
				var _this2 = this;
	
				this.refs.bookActionModal.show();
				this.setState({ showBookModal: false }, function () {
					_this2.setBookStatus(bookStatus);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var actionModal = this.renderChoiceModal();
				var bookModal = React.createElement(LogReadingModal, { initialBook: this.props.selectedBook,
					open: this.state.showBookModal, onClose: this.closeLogReading,
					key: this.props.selectedBook });
	
				return React.createElement(
					'div',
					{ className: 'bookActionSection studentDashboard' },
					actionModal,
					bookModal
				);
			}
		}]);
	
		return BookActionModal;
	}(React.Component);
	
	BookActionModal.propTypes = StrictPropTypes({
		openBookActivity: PropTypes.func.isRequired,
		popularBooks: PropTypes.array,
		existingBooks: PropTypes.array,
		studentDashboard: PropTypes.bool,
		openActivityType: PropTypes.string,
		selectedBook: PropTypes.object,
		expectations: PropTypes.array
	
	});
	
	var FINISHED = "finished";
	var STILL_READING = "reading";
	
	module.exports = BookActionModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var AltModal = __webpack_require__(18);
	var Glyphicon = __webpack_require__(8);
	var TextTypes = __webpack_require__(38);
	
	var SmartBookSearch = __webpack_require__(118);
	var LogReadingModal = __webpack_require__(164);
	
	var BookCover = __webpack_require__(140);
	var BookDisplay = __webpack_require__(46);
	
	var Spinner = __webpack_require__(9);
	var ReactTooltip = __webpack_require__(12);
	var BookTextVariety = __webpack_require__(141);
	var ReadingSelectors = __webpack_require__(21);
	var WhooosReadingServices = __webpack_require__(25);
	var StudentMetrics = __webpack_require__(29);
	
	__webpack_require__(650);
	
	var BookActionSection = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var userID = CurrentUser.get().id;
		// Must match call in SmartBookSearch EXACTLY
		var books = ReadingSelectors.books({ state: state,
			conditions: { userID: userID, allowDraft: true, nonBlank: ["text_id", "title"] } });
		return { existingBooks: books };
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(BookActionSection, _React$Component);
	
		function BookActionSection(props) {
			_classCallCheck(this, BookActionSection);
	
			var _this = _possibleConstructorReturn(this, (BookActionSection.__proto__ || Object.getPrototypeOf(BookActionSection)).call(this));
	
			autobind(_this);
			_this.state = {
				// Note there is also a selectedBook (for log reading only) in StudentHomePage :(
				selectedBook: null,
	
				loading: false, quiz: null, bookStatus: null,
				showBookModal: false, bookKeyIndex: 0
			};
			return _this;
		}
	
		_createClass(BookActionSection, [{
			key: "isFirstBook",
			value: function isFirstBook() {
				return _.size(this.props.existingBooks) == 0;
			}
		}, {
			key: "onBookSelect",
			value: function onBookSelect(book, isFirst) {
				var _this2 = this;
	
				this.setState({ selectedBook: book }, function () {
					if (!book) {
						return;
					}
					_this2.setState({
						getTextVariety: false
					});
					LuckyOrangeClient.tagComponent("BookActionSection");
	
					if (_this2.props.studentDashboard) {
						var activityType = _this2.props.openActivityType;
						if (activityType == "quizzes-passed") {
							_this2.openQuiz();
						} else if (activityType == "reviews") {
							_this2.openReview();
						} else if (activityType == "questions") {
							_this2.openQuestions();
						} else if (activityType == "minutes" || activityType == "pages") {
							_this2.openLogReading();
						} else if (activityType == "exercises") {
							_this2.openExcercise();
						} else if (activityType == "question-builder") {
							_this2.openQuestionBuilder();
						}
					} else {
						_this2.refs.modal.show();
					}
	
					var quizSearchParams = { draft: true, text_id: _this2.state.selectedBook.text_id,
						user_id: CurrentUser.get().id, start_date: 'any' };
	
					CurrentUser.api().getQuizzes(quizSearchParams, $wr.apiHandler(function (response) {
						var quiz = response.quizzes[0];
						_this2.setState({ quiz: quiz });
					}));
				});
			}
		}, {
			key: "openQuiz",
			value: function openQuiz(e) {
				$wr.nope(e);
				if (this.checkTextVariety("quiz")) {
					this.setState({ loading: true });
					this.props.openBookActivity("quiz", this.state.selectedBook, this.isFirstBook());
				}
			}
		}, {
			key: "openLogReading",
			value: function openLogReading(e) {
				$wr.nope(e);
				this.submitOverride("open_log-reading", this.state.selectedBook.text_id, true);
				this.setState({ showBookModal: true });
				this.refs.modal.hide();
			}
		}, {
			key: "closeLogReading",
			value: function closeLogReading(readingWasLogged) {
				if (readingWasLogged) {
					this.setState({ showBookModal: false, bookKeyIndex: this.state.bookKeyIndex + 1 });
				} else {
					this.setState({ showBookModal: false });
				}
			}
		}, {
			key: "openReview",
			value: function openReview(e) {
				$wr.nope(e);
				if (this.checkTextVariety("review")) {
					this.submitOverride("open_review", this.state.selectedBook.text_id, true);
					this.setState({ loading: true });
					this.props.openBookActivity("review", this.state.selectedBook, this.isFirstBook());
				}
			}
		}, {
			key: "openExcercise",
			value: function openExcercise(e) {
				$wr.nope(e);
				if (this.checkTextVariety("exercise")) {
					this.submitOverride("open_exercice", this.state.selectedBook.text_id, true);
					this.setState({ loading: true });
					this.props.openBookActivity("exercise", this.state.selectedBook, this.isFirstBook());
				}
			}
		}, {
			key: "openQuestions",
			value: function openQuestions(e) {
				$wr.nope(e);
				if (this.checkTextVariety("question")) {
					this.submitOverride("open_question", this.state.selectedBook.text_id, true);
					this.setState({ loading: true });
					this.props.openBookActivity("question", this.state.selectedBook, this.isFirstBook());
				}
			}
		}, {
			key: "openQuestionBuilder",
			value: function openQuestionBuilder(e) {
				$wr.nope(e);
				// Don't check text variety for quizzes
				this.setState({ loading: true });
				this.props.openBookActivity("question_builder", this.state.selectedBook, this.isFirstBook());
			}
		}, {
			key: "textVarietySelected",
			value: function textVarietySelected(book) {
				this.setState({ loading: true });
				this.props.openBookActivity(this.state.requestedAction, book, this.isFirstBook());
			}
		}, {
			key: "checkTextVariety",
			value: function checkTextVariety(action) {
				if (this.props.studentDashboard) {
					return true;
				}
				if (this.state.selectedBook) {
					if (this.state.selectedBook.overridden) {
						this.setState({
							getTextVariety: true,
							requestedAction: action
						});
						return false;
					}
					return true;
				}
				return false;
			}
		}, {
			key: "resetTextVariety",
			value: function resetTextVariety() {
				this.setState({
					getTextVariety: false
				});
			}
		}, {
			key: "submitOverride",
			value: function submitOverride(attribute_name, text_id, value) {
				var user = CurrentUser.get();
				var override_data = {
					instance_id: text_id,
					instance_type: "book",
					attribute_name: attribute_name,
					value: value,
					user_id: user.id,
					user_role: user.role
				};
	
				var url = WhooosReadingServices.Matilda.url("/overrides");
				$wr.postJSON(url, { override: override_data }, function (data) {
					var newBook = $.extend({}, this.props.book);
					newBook.text_variety = value;
				}.bind(this));
			}
		}, {
			key: "setBookStatus",
			value: function setBookStatus(value) {
				this.setState({ bookStatus: value });
			}
		}, {
			key: "renderChoiceModal",
			value: function renderChoiceModal() {
				if (this.state.loading) {
					var loadingIcon = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (this.state.getTextVariety) {
					var modalContent = React.createElement(BookTextVariety, { reset: this.resetTextVariety, book: this.state.selectedBook,
						onSubmit: this.textVarietySelected });
				} else {
	
					if (this.state.bookStatus == null) {
						var modalContent = React.createElement(
							"div",
							{ className: "primaryOnly" },
							React.createElement(
								"p",
								{ className: "finishedQuestion" },
								"Have you finished this book?"
							),
							React.createElement(
								"div",
								{ className: "primaryOptions" },
								React.createElement(
									"a",
									{ href: "#", className: "actionOp", onClick: this.setBookStatus.bind(this, STILL_READING) },
									React.createElement("img", { src: __webpack_require__(3408), alt: "Still Reading" }),
									React.createElement(
										"span",
										null,
										"I'm still reading"
									)
								),
								React.createElement(
									"a",
									{ href: "#", className: "actionOp", onClick: this.setBookStatus.bind(this, FINISHED) },
									React.createElement("img", { src: __webpack_require__(3407), alt: "Finished" }),
									React.createElement(
										"span",
										null,
										"I finished"
									)
								)
							)
						);
					} else if (this.state.bookStatus == STILL_READING) {
						if (Features.isEnabled(Features.LOG_READING)) {
							var logReadingOption = React.createElement(
								"a",
								{ href: "#", className: "actionOp logReadingOp", onClick: this.openLogReading },
								React.createElement("img", { src: __webpack_require__(337), alt: "Log Reading" }),
								React.createElement(
									"span",
									null,
									"Log Reading"
								)
							);
						}
						if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
							var exerciseOption = React.createElement(
								"a",
								{ href: "#", className: "actionOp", onClick: this.openExcercise },
								React.createElement("img", { src: __webpack_require__(186), alt: "Do an Exercise" }),
								React.createElement(
									"span",
									null,
									"Start an Exercise"
								)
							);
						}
	
						if (logReadingOption == undefined && exerciseOption == undefined) {
							var modalContent = React.createElement(
								"div",
								{ className: "primaryOnly" },
								React.createElement(
									"a",
									{ href: "#", className: "backLink", onClick: this.setBookStatus.bind(this, null) },
									React.createElement(Glyphicon, { icon: "arrow-left" }),
									" Back"
								),
								React.createElement(
									"div",
									{ className: "primaryOptions stillReading" },
									React.createElement(
										"a",
										{ href: "#", className: "actionOp questionOp", onClick: this.openQuestions },
										React.createElement("img", { src: __webpack_require__(338), alt: "Answer a Question" }),
										React.createElement(
											"span",
											null,
											"Answer a Question"
										)
									)
								)
							);
						} else {
							var modalContent = React.createElement(
								"div",
								null,
								React.createElement(
									"a",
									{ href: "#", className: "backLink", onClick: this.setBookStatus.bind(this, null) },
									React.createElement(Glyphicon, { icon: "arrow-left" }),
									" Back"
								),
								React.createElement(
									"div",
									{ className: "primaryOptions stillReading" },
									React.createElement(
										"a",
										{ href: "#", className: "actionOp questionOp soloOp", onClick: this.openQuestions },
										React.createElement("img", { src: __webpack_require__(338), alt: "Answer a Question" }),
										React.createElement(
											"span",
											null,
											"Answer a Question"
										)
									),
									React.createElement("span", { className: "verticalDivider" })
								),
								React.createElement(
									"div",
									{ className: "secondaryOptions" },
									logReadingOption,
									exerciseOption
								)
							);
						}
					} else if (this.state.bookStatus == FINISHED) {
						if (Features.isEnabled(Features.LOG_READING)) {
							var logReadingOption = React.createElement(
								"a",
								{ href: "#", className: "actionOp logReadingOp", onClick: this.openLogReading },
								React.createElement("img", { src: __webpack_require__(337), alt: "Log Reading" }),
								React.createElement(
									"span",
									null,
									"Log Reading"
								)
							);
						}
						if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
							var exerciseOption = React.createElement(
								"a",
								{ href: "#", className: "actionOp", onClick: this.openExcercise },
								React.createElement("img", { src: __webpack_require__(186), alt: "Do an Exercise" }),
								React.createElement(
									"span",
									null,
									"Start an Exercise"
								)
							);
						}
	
						if (this.state.quiz) {
							if (this.state.quiz.draft) {
								var quizStatus = " quizDraft";
								var quizOption = React.createElement(
									"a",
									{ href: "#", className: "actionOp quizOp soloOp quizDraft", onClick: this.openQuiz },
									React.createElement("img", { src: __webpack_require__(220), alt: "Complete Your Quiz" }),
									React.createElement(
										"span",
										null,
										"Complete Quiz"
									)
								);
							} else {
								var quizStatus = " quizCompleted";
								var quizOption = React.createElement(
									"a",
									{ href: "#", className: "actionOp quizOp soloOp quizCompleted" },
									React.createElement("img", { src: __webpack_require__(220), alt: "Quiz Completed" }),
									React.createElement(
										"span",
										{ className: "quizCompletedText" },
										"You completed the quiz!"
									)
								);
							}
						} else {
							var quizOption = React.createElement(
								"a",
								{ href: "#", className: "actionOp quizOp soloOp", onClick: this.openQuiz,
									"data-tip": "Finish the book before you take a quiz!" },
								React.createElement("img", { src: __webpack_require__(220), alt: "Take a Quiz" }),
								React.createElement(
									"span",
									null,
									"Take a Quiz"
								)
							);
						}
	
						var modalContent = React.createElement(
							"div",
							null,
							React.createElement(
								"a",
								{ href: "#", className: "backLink", onClick: this.setBookStatus.bind(this, null) },
								React.createElement(Glyphicon, { icon: "arrow-left" }),
								" Back"
							),
							React.createElement(
								"div",
								{ className: "primaryOptions " + quizStatus },
								quizOption,
								React.createElement("span", { className: "verticalDivider" })
							),
							React.createElement(
								"div",
								{ className: "secondaryOptions" },
								logReadingOption,
								React.createElement(
									"a",
									{ href: "#", className: "actionOp", onClick: this.openReview },
									React.createElement("img", { src: __webpack_require__(187), alt: "Write a Review" }),
									React.createElement(
										"span",
										null,
										"Write a Review"
									)
								),
								exerciseOption
							)
						);
					}
				}
	
				return React.createElement(
					AltModal,
					{ className: "bookActionModal", ref: "modal",
						headerText: "What do you want to do next?", onShow: this.setBookStatus.bind(this, null) },
					React.createElement(
						"div",
						{ className: "selectedBookHeader" },
						React.createElement(BookCover, { book: this.state.selectedBook, coverWidth: 70,
							showTitle: true, showAuthor: true })
					),
					loadingIcon,
					React.createElement(
						"div",
						{ className: "bookOptions" },
						modalContent
					)
				);
			}
		}, {
			key: "clearSelectedBook",
			value: function clearSelectedBook() {
				this.setState({ selectedBook: null });
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window.document).on("clear-selected-book", this.clearSelectedBook);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("clear-selected-book", this.clearSelectedBook);
			}
		}, {
			key: "onBack",
			value: function onBack(bookStatus) {
				var _this3 = this;
	
				this.refs.modal.show();
				this.setState({ showBookModal: false }, function () {
					_this3.setBookStatus(bookStatus);
				});
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.selectedBook != null) {
					var actionModal = this.renderChoiceModal();
	
					var bookModal = React.createElement(LogReadingModal, { initialBook: this.state.selectedBook,
						open: this.state.showBookModal, onClose: this.closeLogReading,
						key: this.state.selectedBook.text_id, onBack: this.onBack,
						bookStatus: this.state.bookStatus });
				}
	
				if (!this.props.studentDashboard && this.props.popularBooks.length == 0) {
					var suggestedBooks = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
					if (!_.isEmpty(this.props.recommendedBooks)) {
						var recommendedBooks = _.map(this.props.recommendedBooks, function (book) {
							return React.createElement(BookDisplay, { showCover: true, hideTitleIfCover: true,
								textID: book.text_id, key: book.text_id,
								onClick: this.onBookSelect.bind(this, book) });
						}.bind(this));
	
						// var recommendedBooks = _.map(this.props.recommendedBooks, function(book) {
						// 	return (
						// 		<div className="bookDisplayContainer" key={ book.text_id }>
						// 			<a className="coverLink" key={ book.text_id } onClick={ this.onBookSelect.bind(this, book) }>
						// 				<BookCover book={ book } />
						// 			</a>
						// 		</div>
						// 	);
						// }.bind(this));
						var recommendedBooksContainer = React.createElement(
							"div",
							{ className: "recommendedBooksContainer" },
							React.createElement(
								"p",
								null,
								"Teacher's Picks"
							),
							recommendedBooks
						);
					}
	
					// Popular Books...
	
					if (this.props.recommendedBooks && !this.props.studentDashboard) {
						if (this.props.recommendedBooks.length <= 5) {
							var popularBooks = _.map(this.props.popularBooks, function (book) {
								return React.createElement(
									"a",
									{ className: "coverLink", key: book.text_id, onClick: this.onBookSelect.bind(this, book) },
									React.createElement(BookCover, { book: book, key: book.text_id })
								);
							}.bind(this));
	
							var popularBooksSliced = _.first(popularBooks, 6 - this.props.recommendedBooks.length);
	
							var popularBooksContainer = React.createElement(
								"div",
								{ className: "popularBooksContainer" },
								React.createElement(
									"p",
									null,
									"Popular Books"
								),
								popularBooksSliced
							);
						}
					}
	
					if (!this.props.studentDashboard) {
						var findBookHeader = React.createElement(
							"p",
							{ className: "findBookHeader" },
							"What are you going to read next?"
						);
					}
	
					var suggestedBooks = React.createElement(
						"div",
						{ className: "suggestedBooksArea" },
						findBookHeader,
						recommendedBooksContainer,
						popularBooksContainer
					);
				}
	
				// Recommended Books...
				var openActivityType = this.props.openActivityType;
				if (this.props.studentDashboard && openActivityType) {
					var className = "bookActionSection studentDashboard";
					var actionImage = React.createElement("img", { src: StudentMetrics.getIcon(this.props.openActivityType), className: "actionImage" });
					if (openActivityType == StudentMetrics.TYPES.QUESTIONS) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Answer a question!"
						);
					} else if (openActivityType == StudentMetrics.TYPES.QUIZZES_PASSED) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Take a quiz!"
						);
					} else if (openActivityType == StudentMetrics.TYPES.REVIEWS) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Write a review!"
						);
					} else if (openActivityType == StudentMetrics.TYPES.EXERCISES) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Do an exercise!"
						);
					} else if (openActivityType == StudentMetrics.TYPES.MINUTES) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Log your reading!"
						);
					} else if (openActivityType == StudentMetrics.TYPES.PAGES) {
						var actionText = React.createElement(
							"p",
							{ className: "actionText" },
							"Log your reading!"
						);
					}
				} else {
					var className = "bookActionSection";
				}
	
				var header = React.createElement(
					"span",
					null,
					actionImage,
					actionText,
					React.createElement(
						"p",
						{ className: "findBookHeader" },
						"Find what you read:"
					)
				);
				if (this.props.sectionDividerHeader) {
					header = React.createElement(
						"div",
						{ className: "dividerSection" },
						React.createElement("div", { className: "dividerArea" }),
						React.createElement(
							"div",
							{ className: "nameArea" },
							React.createElement(
								"span",
								{ className: "nameString" },
								"Find a New Book"
							)
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: className },
					header,
					React.createElement(
						"div",
						{ className: "bookSearchBox" },
						React.createElement(SmartBookSearch, { onBookSelect: this.onBookSelect, userID: CurrentUser.get().id,
							selectedBook: this.state.selectedBook, key: this.state.bookKeyIndex })
					),
					suggestedBooks,
					actionModal,
					bookModal
				);
			}
		}]);
	
		return BookActionSection;
	}(React.Component)) || _class);
	
	
	BookActionSection.WrappedComponent.propTypes = StrictPropTypes({
		openBookActivity: PropTypes.func.isRequired,
		popularBooks: PropTypes.array,
		recommendedBooks: PropTypes.array.isRequired,
		existingBooks: PropTypes.array,
		studentDashboard: PropTypes.bool,
		openActivityType: PropTypes.string
	
	});
	
	var FINISHED = "finished";
	var STILL_READING = "reading";
	
	module.exports = BookActionSection;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _momentTimezone = __webpack_require__(3541);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _jstz = __webpack_require__(3535);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropDownOptions = __webpack_require__(26);
	var Glyphicon = __webpack_require__(8);
	var CurrentUser = __webpack_require__(3);
	var NumbersOnlyInput = __webpack_require__(122);
	var ZPDRange = __webpack_require__(176);
	
	__webpack_require__(3720);
	
	var BookLogger = function (_React$Component) {
		_inherits(BookLogger, _React$Component);
	
		function BookLogger(props) {
			_classCallCheck(this, BookLogger);
	
			var _this = _possibleConstructorReturn(this, (BookLogger.__proto__ || Object.getPrototypeOf(BookLogger)).call(this));
	
			autobind(_this);
			_this.state = {
				logRowCount: 1, skipRowIndexes: [], errorsByRow: {}, showDetailedForm: false,
				selectedLocation: BookLogger.READ_AT_SCHOOL, logMinutes: {}
			};
			return _this;
		}
	
		_createClass(BookLogger, [{
			key: "shouldExclude",
			value: function shouldExclude() {
				if (!CurrentUser.get().prefs.automatic_zpd_exclusion) {
					return false;
				} else if (!CurrentUser.isStudent()) {
					return false;
				} else if (!this.props.book) {
					return false;
				} else if (!this.props.book.lexile_score) {
					return true;
				} else {
					var zpdStatus = ZPDRange.getTextStatus(this.props.book.lexile_score, CurrentUser.get().current_reading_level);
					return zpdStatus == ZPDRange.UNDER;
				}
			}
		}, {
			key: "addLogRow",
			value: function addLogRow() {
				this.setState({ logRowCount: this.state.logRowCount + 1 });
			}
		}, {
			key: "buildRemoveLogRow",
			value: function buildRemoveLogRow(row) {
				return function () {
					this.setState({ skipRowIndexes: this.state.skipRowIndexes.concat([row]),
						logRowCount: this.state.logRowCount - 1 });
				}.bind(this);
			}
		}, {
			key: "removeBook",
			value: function removeBook() {
				this.props.removeBook(this.props.book.id);
			}
		}, {
			key: "onChange",
			value: function onChange(i, e) {
				var key = "log" + i;
				var value = e.target.value;
				var mergedMinutes = _.extend({}, this.state.logMinutes, _defineProperty({}, i, value));
				this.setState({ logMinutes: mergedMinutes });
			}
		}, {
			key: "changeDate",
			value: function changeDate(row, event) {
				// console.log(row, event.target.value);
			}
		}, {
			key: "changeLocation",
			value: function changeLocation(location) {
				this.setState({ selectedLocation: location });
			}
		}, {
			key: "validate",
			value: function validate() {
				var noErrors = true;
				var errors = {};
	
				for (var i = 0; i < this.state.logRowCount; i++) {
					var minutes = this.refs["log_minutes" + i].refs["textfield"]["valueAsNumber"];
					var pages = this.refs["log_pages" + i].refs["textfield"]["valueAsNumber"];
					var date = this.refs["log_date" + i].value.trim();
	
					if (this.refs["start_time" + i]) {
						var startTime = this.refs["start_time" + i].value;
						var endTime = this.refs["end_time" + i].value;
						var start = startTime.substr(1, 4).replace(":", "");
						var end = endTime.substr(1, 4).replace(":", "");
						var minutesCalc = parseInt(end) - parseInt(start);
						if (startTime == endTime) {
							errors[i] = "Please enter start and end times that are different.";
							noErrors = false;
						}
					}
	
					if (date.length == 0 && (minutes == 0 || isNaN(minutes)) && (pages < 0 || isNaN(pages))) {
						errors[i] = "Please enter minutes, pages, and a date.";
						noErrors = false;
					} else if ((minutes == 0 || isNaN(minutes)) && (pages < 0 || isNaN(pages))) {
						errors[i] = "Please enter how many minutes and pages you read.";
						noErrors = false;
					} else if (minutes == 0 || isNaN(minutes)) {
						errors[i] = "Please enter how many minutes you read.";
						noErrors = false;
					} else if (!this.isOnlineText() && (pages < 0 || isNaN(pages))) {
						errors[i] = "Please enter how many pages you read.";
						noErrors = false;
					} else if (pages > BookLogger.MAX_LOG_PAGES) {
						errors[i] = "You're logging too many pages!";
						noErrors = false;
					} else if (minutes > BookLogger.MAX_LOG_MINUTES) {
						errors[i] = "You're logging too many minutes!";
						noErrors = false;
					} else if (date.length == 0) {
						errors[i] = "Please enter the day you logged your reading.";
						noErrors = false;
					} else if (startTime > endTime) {
						errors[i] = "Please enter a start time that comes before the end time.";
						noErrors = false;
						// } else if (minutesCalc != this.state.logMinutes[i]) {
						// 	errors[i] = "Something looks wrong. Please make sure your minutes, start and end times are correct.";
						// 	noErrors = false;
					}
				}
				this.setState({ errorsByRow: errors });
				return noErrors;
			}
		}, {
			key: "getData",
			value: function getData() {
				var logs = [];
	
				var excluded = this.shouldExclude();
	
				for (var i = 0; i < this.state.logRowCount; i++) {
					var minutes = this.refs["log_minutes" + i].refs["textfield"]["valueAsNumber"];
					var pages = this.refs["log_pages" + i].refs["textfield"]["valueAsNumber"];
					var date = $(this.refs["log_date" + i]).val();
					var timeZoneOffset = CurrentUser.get().time_zone_offset;
					if (this.useDetailedForm()) {
						var tzName = _jstz2.default.determine().name();
						var startTime = this.refs["start_time" + i].value;
						var startTimeObject = date + " " + startTime;
						// var startTimeFormatted = moment.tz(startTimeObject, tzName).format();
						var startTimeFormatted = (0, _momentTimezone2.default)(startTimeObject).tz(tzName).format();
	
						var endTime = this.refs["end_time" + i].value;
						var endTimeObject = "" + date + " " + endTime;
						// var endTimeFormatted = moment.tz(endTimeObject, tzName).format();
						var endTimeFormatted = (0, _momentTimezone2.default)(endTimeObject).tz(tzName).format();
	
						var location = this.state.selectedLocation;
					}
	
					logs.push({
						minutes: minutes, pages: pages, date: date, location: location, excluded: excluded,
						start_time: startTimeFormatted,
						end_time: endTimeFormatted
					});
				}
				return logs;
			}
		}, {
			key: "getDayOptions",
			value: function getDayOptions() {
				var user = CurrentUser.get();
				return DropDownOptions.Select.LastWeekDays({ days: user.prefs.back_log_date_period });
			}
		}, {
			key: "getTimeOptions",
			value: function getTimeOptions() {
				return DropDownOptions.Select.Time();
			}
		}, {
			key: "isOnlineText",
			value: function isOnlineText() {
				return this.props.book.url != null;
			}
		}, {
			key: "showDetailedForm",
			value: function showDetailedForm() {
				this.setState({ showDetailedForm: true, logRowCount: 1 });
			}
		}, {
			key: "useDetailedForm",
			value: function useDetailedForm() {
				return CurrentUser.get().prefs.log_reading_detailed_view || this.state.showDetailedForm;
			}
		}, {
			key: "render",
			value: function render() {
				var onlineTextClass = this.isOnlineText() ? 'onlineText' : '';
	
				var logRows = [];
				var row = -1;
				for (var i = 0; i < this.state.logRowCount; i++) {
					row += 1;
					if (_.includes(this.state.skipRowIndexes, row)) {
						i -= 1;continue;
					}
					if (this.state.logRowCount > 1) {
						var removeLogRow = React.createElement(
							"button",
							{ className: "btn btn-link removeLogRow", onClick: this.buildRemoveLogRow(row) },
							React.createElement(Glyphicon, { icon: "remove" })
						);
					}
	
					if (this.isOnlineText()) {
						var pagesInput = React.createElement(NumbersOnlyInput, { className: "form-control logPages", type: "hidden",
							ref: "log_pages" + i, value: "0" });
					} else {
						var pagesInput = React.createElement(NumbersOnlyInput, { className: "form-control logPages",
							ref: "log_pages" + i, onKeyDown: this.onKeyDown });
					}
	
					var user = CurrentUser.get();
					var showDetailedForm = this.useDetailedForm();
	
					if (showDetailedForm) {
						var detailedLabels = React.createElement(
							"div",
							{ className: "quantityContainer" },
							React.createElement(NumbersOnlyInput, { className: "form-control numbersOnly logMinutes",
								ref: "log_minutes" + i, onChange: this.onChange.bind(this, i), placeholder: "Minutes..." }),
							React.createElement(NumbersOnlyInput, { className: "form-control logPages",
								ref: "log_pages" + i, onKeyDown: this.onKeyDown, placeholder: "Pages..." })
						);
						var currentlySelectedSchool = this.state.selectedLocation == BookLogger.READ_AT_SCHOOL;
						var currentlySelectedHome = this.state.selectedLocation == BookLogger.READ_AT_HOME;
	
						var currentTimeOfDay = (0, _momentTimezone2.default)().format("A");
						if (currentTimeOfDay.includes("AM")) {
							var currentHour = (0, _momentTimezone2.default)().format("HH");
						} else {
							var currentHour = (0, _momentTimezone2.default)().format("H");
							var noZero = currentHour == "10" || "11" || "12";
							if (!noZero) {
								currentHour = (0, _momentTimezone2.default)().format("HH");
							}
						}
	
						var startDefault = currentHour + ":00:00";
	
						if (this.state.logMinutes["log" + i]) {
							var startHour = this.refs["start_time" + i].value.substr(0, 2);
							var endValue = startHour + ":" + this.state.logMinutes["log" + i] + ":00";
						} else {
							var endValue = currentHour + ":" + "15:00";
						}
	
						logRows.push(React.createElement(
							"div",
							{ className: "logRow clearfix", key: "logRow" + row },
							React.createElement(
								"div",
								{ className: "logError clearfix" },
								this.state.errorsByRow[i]
							),
							detailedLabels,
							React.createElement(
								"div",
								{ className: "whenContainer" },
								React.createElement(
									"select",
									{ className: "form-control selector dateSelector " + onlineTextClass, ref: "log_date" + i, defaultValue: 0,
										onChange: this.changeDate.bind(this, row) },
									this.getDayOptions()
								),
								React.createElement(
									"select",
									{ className: "form-control selector timeSelector", ref: "start_time" + i,
										defaultValue: startDefault },
									this.getTimeOptions()
								),
								React.createElement(
									"select",
									{ className: "form-control selector timeSelector endTime", ref: "end_time" + i,
										defaultValue: endValue },
									this.getTimeOptions()
								)
							),
							React.createElement(
								"div",
								{ className: "placeContainer" },
								React.createElement(
									"label",
									null,
									React.createElement("input", { type: "radio", checked: currentlySelectedSchool,
										ref: "log_location" + i,
										onChange: this.changeLocation.bind(this, BookLogger.READ_AT_SCHOOL) }),
									"I read this at school"
								),
								React.createElement(
									"label",
									null,
									React.createElement("input", { type: "radio", checked: currentlySelectedHome,
										ref: "log_location" + i,
										onChange: this.changeLocation.bind(this, BookLogger.READ_AT_HOME) }),
									"I read this at home"
								),
								removeLogRow
							)
						));
					} else {
						logRows.push(React.createElement(
							"div",
							{ className: "logRow clearfix", key: "logRow" + row },
							React.createElement(
								"div",
								{ className: "logError clearfix" },
								this.state.errorsByRow[i]
							),
							React.createElement(NumbersOnlyInput, { className: "form-control numbersOnly logMinutes",
								ref: "log_minutes" + i }),
							pagesInput,
							React.createElement(
								"select",
								{ className: "form-control dateSelector " + onlineTextClass, ref: "log_date" + i, defaultValue: 0,
									onChange: this.changeDate.bind(this, row) },
								this.getDayOptions()
							),
							removeLogRow
						));
					}
				}
	
				if (this.props.removeBook) {
					var removeBookButton = React.createElement(
						"button",
						{ className: "btn btn-link removeBookRow", onClick: this.removeBook },
						React.createElement(Glyphicon, { icon: "remove" })
					);
				}
	
				if (!this.isOnlineText()) {
					var pagesLabel = React.createElement(
						"label",
						{ className: "logPages" },
						"Pages"
					);
				}
	
				var bookTitleArea = React.createElement(
					"div",
					{ className: "titleSection" },
					React.createElement(
						"span",
						{ className: "title" },
						this.props.book.title
					)
				);
	
				if (showDetailedForm) {
					var className = "bookLogger detailedBookLogger " + onlineTextClass;
					var bookLoggingForm = React.createElement(
						"div",
						{ className: "bookRow detailedBookRow clearfix" },
						removeBookButton,
						React.createElement(
							"div",
							{ className: "logSection" },
							React.createElement(
								"div",
								{ className: "logLabels clearfix" },
								React.createElement(
									"label",
									{ className: "logMinutes" },
									"What"
								),
								React.createElement(
									"label",
									{ className: "logDate" },
									"When"
								),
								React.createElement(
									"label",
									{ className: "logPlace" },
									"Where"
								)
							),
							React.createElement(
								"div",
								{ className: "logRows" },
								logRows
							),
							React.createElement(
								"div",
								{ className: "clearfix moreRowsContainer" },
								React.createElement(
									"a",
									{ className: "moreRows", href: "#", onClick: this.addLogRow },
									React.createElement(Glyphicon, { icon: "plus" }),
									"Log More for this Book"
								)
							)
						)
					);
				} else {
					var className = "bookLogger " + onlineTextClass;
	
					var showDetailedFormLink = React.createElement(
						"a",
						{ className: "showDetailedFormLink " + onlineTextClass, onClick: this.showDetailedForm },
						"Show Advanced Log"
					);
	
					var bookLoggingForm = React.createElement(
						"div",
						{ className: "bookRow clearfix" },
						removeBookButton,
						React.createElement(
							"div",
							{ className: "logSection" },
							React.createElement(
								"div",
								{ className: "logLabels clearfix" },
								React.createElement(
									"label",
									{ className: "logMinutes" },
									"Minutes"
								),
								pagesLabel,
								React.createElement(
									"label",
									{ className: "logDate" },
									"Date"
								)
							),
							React.createElement(
								"div",
								{ className: "logRows" },
								logRows
							),
							React.createElement(
								"div",
								{ className: "clearfix moreRowsContainer" },
								React.createElement(
									"a",
									{ className: "moreRows " + onlineTextClass, href: "#", onClick: this.addLogRow },
									React.createElement(Glyphicon, { icon: "plus" }),
									"Log More for this Book"
								)
							)
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: className },
					bookTitleArea,
					showDetailedFormLink,
					bookLoggingForm
				);
			}
		}]);
	
		return BookLogger;
	}(React.Component);
	
	BookLogger.propTypes = StrictPropTypes({
		book: PropTypes.object.isRequired,
		removeBook: PropTypes.func
	});
	
	BookLogger.MAX_LOG_MINUTES = 480;
	BookLogger.MAX_LOG_PAGES = 1000;
	BookLogger.READ_AT_SCHOOL = "School";
	BookLogger.READ_AT_HOME = "Home";
	
	module.exports = BookLogger;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var SmartBookSearch = __webpack_require__(118);
	var Modal = __webpack_require__(18);
	
	__webpack_require__(3722);
	
	var BookSearchModal = function (_React$Component) {
		_inherits(BookSearchModal, _React$Component);
	
		function BookSearchModal(props) {
			_classCallCheck(this, BookSearchModal);
	
			var _this = _possibleConstructorReturn(this, (BookSearchModal.__proto__ || Object.getPrototypeOf(BookSearchModal)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(BookSearchModal, [{
			key: "show",
			value: function show() {
				LuckyOrangeClient.tagComponent("BookSearchModal");
				this.refs.modal.show();
			}
		}, {
			key: "hide",
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: "render",
			value: function render() {
	
				if (CurrentUser.isStudent()) {
					var userID = CurrentUser.get().id;
				}
	
				return React.createElement(
					Modal,
					{ className: "bookSearchModal", ref: "modal", headerText: "Find Your Book!" },
					React.createElement(SmartBookSearch, { onBookSelect: this.props.onBookSelect, userID: userID }),
					this.props.children
				);
			}
		}]);
	
		return BookSearchModal;
	}(React.Component);
	
	;
	
	BookSearchModal.propTypes = StrictPropTypes({
		onBookSelect: PropTypes.func.isRequired,
	
		// Children are optional, are shown below the search bar
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
	
	});
	
	module.exports = BookSearchModal;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumbersOnlyInput = __webpack_require__(122);
	var ReadingActions = __webpack_require__(27);
	var BookDisplay = __webpack_require__(46);
	var DropDownOptions = __webpack_require__(26);
	var BookLogger = __webpack_require__(400);
	
	var CurrentUser = __webpack_require__(3);
	var moment = __webpack_require__(15);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var ReadingSelectors = __webpack_require__(21);
	var ReadingLevelIcon = __webpack_require__(165);
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(651);
	
	var LogRow = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			book: ReadingSelectors.book({ state: state, id: props.log.text_id }),
			student: RosterSelectors.student({ state: state, id: props.log.user_id })
		};
	}, function (dispatch, props) {
		return {
			onDelete: function onDelete() {
				return dispatch(ReadingActions.deleteLog({ id: props.log.id }));
			},
			onUpdate: function onUpdate(updateData) {
				return dispatch(ReadingActions.updateLog({
					id: props.log.id, update: updateData
				}));
			},
			onInclude: function onInclude(updateData) {
				return dispatch(ReadingActions.updateLog({
					id: props.log.id, update: { excluded: false }
				}));
			},
			onExclude: function onExclude(updateData) {
				return dispatch(ReadingActions.updateLog({
					id: props.log.id, update: { excluded: true }
				}));
			},
			fetchBook: function fetchBook() {
				return dispatch(ReadingActions.batchFetchBook({ id: props.log.text_id, userID: (CurrentUser.get() || {}).id }));
			},
			fetchStudent: function fetchStudent() {
				return dispatch(RosterActions.fetchStudent({
					id: props.log.user_id, query: query, embeds: "student.current_reading_level"
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(LogRow, _React$Component);
	
		function LogRow(props) {
			_classCallCheck(this, LogRow);
	
			var _this = _possibleConstructorReturn(this, (LogRow.__proto__ || Object.getPrototypeOf(LogRow)).call(this));
	
			autobind(_this);
			_this.state = {
				editField: false,
				errors: []
			};
			return _this;
		}
	
		_createClass(LogRow, [{
			key: "onClickEditField",
			value: function onClickEditField(e) {
				$wr.nope(e);
				this.setState({ editField: true });
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				$wr.nope(e);
	
				var newMinutes = this.refs.newMinutesInput.number() || 0;
				var newPages = this.refs.newPagesInput.number() || 0;
				var errors = [];
	
				if (newMinutes > BookLogger.MAX_LOG_MINUTES) {
					errors.push("minutes");
				}
				if (newPages > BookLogger.MAX_LOG_PAGES) {
					errors.push("pages");
				}
	
				if (errors.length > 0) {
					this.setState({ errors: errors });
				} else {
					if (this.refs.newLocationInput) {
						var newLocation = this.refs.newLocationInput.value;
					}
	
					if (newMinutes == 0 && newPages == 0) {
						this.props.onDelete();
					} else {
						this.props.onUpdate({ minutes: newMinutes, pages: newPages, location: newLocation });
						this.setState({ editField: false, errors: [] });
					}
				}
			}
		}, {
			key: "deleteLog",
			value: function deleteLog(e) {
				$wr.nope(e);
				if (confirm("Are you sure you want to delete this reading log?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Log Deleted", text: "You have deleted the log.", icon: "trash" });
					this.props.onDelete();
				}
			}
		}, {
			key: "includeLog",
			value: function includeLog(e) {
				$wr.nope(e);
				if (confirm("This will allow this reading log to count toward your custom goals. Are you sure?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Log Included", text: "You have included this reading log.", icon: "ok-sign" });
					this.props.onInclude();
				}
			}
		}, {
			key: "excludeLog",
			value: function excludeLog(e) {
				$wr.nope(e);
				if (confirm("This will exclude this reading log from counting toward your custom goals. Are you sure?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Log Excluded", text: "You have excluded this reading log.", icon: "ok-sign" });
					this.props.onExclude();
				}
			}
		}, {
			key: "getLocationOptions",
			value: function getLocationOptions() {
				return DropDownOptions.Select.Locations();
			}
		}, {
			key: "render",
			value: function render() {
				var day = moment(this.props.log.log_date).format("ddd, MMM D");
				var dateCell = React.createElement(
					"td",
					{ className: "dateCell" },
					React.createElement(
						"div",
						{ className: "infoContainer" },
						day
					),
					React.createElement(
						"span",
						{ className: "sectionLabel" },
						"Date"
					)
				);
				var titleCell = React.createElement(
					"td",
					{ className: "titleCell" },
					React.createElement(
						"div",
						{ className: "infoContainer textTitle" },
						React.createElement(BookDisplay, { textID: this.props.log.text_id })
					),
					React.createElement(
						"span",
						{ className: "sectionLabel" },
						"Title"
					)
				);
	
				if (this.props.book && this.props.book.lexile_score) {
					if (CurrentUser.isAdmin()) {
						var studentReadingLevel = this.props.student.current_reading_level;
						var tooltipCopyType = ReadingLevelIcon.TEACHER_VIEW;
					} else {
						var studentReadingLevel = CurrentUser.get().current_reading_level;
						var tooltipCopyType = ReadingLevelIcon.STUDENT_VIEW;
					}
					var readingLevelDisplay = React.createElement(ReadingLevelIcon, { studentReadingLevel: studentReadingLevel,
						textReadingLevel: this.props.book.lexile_score,
						tooltipCopyType: tooltipCopyType,
						showImageOnly: true });
				}
	
				var readingLevelCell = React.createElement(
					"td",
					{ className: "minuteCell" },
					React.createElement(
						"div",
						{ className: "infoContainer" },
						readingLevelDisplay
					)
				);
	
				if (this.state.editField) {
					var location = this.props.log.location;
					if (location) {
						dateCell = React.createElement(
							"td",
							{ className: "dateCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								day
							),
							React.createElement(
								"span",
								{ className: "sectionLabel dateLabel" },
								"Date"
							),
							React.createElement(
								"span",
								{ className: "inputBox" },
								React.createElement(
									"select",
									{ className: "form-control logLocationInput", ref: "newLocationInput",
										defaultValue: location },
									this.getLocationOptions()
								),
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "sectionLabel" },
									"Location"
								)
							)
						);
					}
					if (this.state.errors.length > 0) {
						if (this.state.errors.includes("minutes")) {
							var minuteError = React.createElement(
								"span",
								{ className: "logError" },
								"Too high!"
							);
						}
						if (this.state.errors.includes("pages")) {
							var pageError = React.createElement(
								"span",
								{ className: "logError" },
								"Too high!"
							);
						}
					}
					return React.createElement(
						"tr",
						{ className: "logRow editingLogRow" },
						dateCell,
						titleCell,
						React.createElement(
							"td",
							{ className: "editedDataCell hideOnPrint", colSpan: "3" },
							React.createElement(
								"form",
								{ className: "editedData", onSubmit: this.onSubmit },
								React.createElement(
									"span",
									{ className: "inputBox" },
									React.createElement(NumbersOnlyInput, { className: "logMinutesInput form-control",
										defaultValue: this.props.log.minutes, ref: "newMinutesInput" }),
									React.createElement("br", null),
									React.createElement(
										"span",
										{ className: "sectionLabel" },
										"Minutes ",
										minuteError
									)
								),
								React.createElement(
									"span",
									{ className: "inputBox" },
									React.createElement(NumbersOnlyInput, { className: "logPagesInput form-control",
										defaultValue: this.props.log.pages, ref: "newPagesInput" }),
									React.createElement("br", null),
									React.createElement(
										"span",
										{ className: "sectionLabel" },
										"Pages ",
										pageError
									)
								),
								React.createElement(
									"span",
									{ className: "inputBox" },
									React.createElement(
										"button",
										{ className: "btn buttonSuccess saveButton" },
										"Save"
									)
								)
							)
						)
					);
				} else {
					var startTime = this.props.log.start_time;
					if (startTime && this.props.log.location) {
	
						var day = moment(this.props.log.log_date).format("ddd, MMM D");
						var location = this.props.log.location;
						var startTimeFormatted = moment(startTime).format("h:mm a");
						var endTimeFormatted = moment(this.props.log.end_time).format("h:mm a");
						var dateCell = React.createElement(
							"td",
							{ className: "dateCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								day
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Date"
							),
							React.createElement(
								"div",
								{ className: "infoContainer" },
								location
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Location"
							)
						);
						var timeCell = React.createElement(
							"td",
							{ className: "dateCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								startTimeFormatted
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Start Time"
							),
							React.createElement(
								"div",
								{ className: "infoContainer" },
								this.props.log.minutes || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Minutes"
							)
						);
						var logQuantityContainer = React.createElement(
							"td",
							{ className: "minuteCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								endTimeFormatted
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"End Time"
							),
							React.createElement(
								"div",
								{ className: "infoContainer" },
								this.props.log.pages || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Pages"
							)
						);
					} else {
						var logQuantityContainer = React.createElement(
							"td",
							{ className: "minuteCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								this.props.log.minutes || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Minutes"
							)
						);
						var logQuantityContainerTwo = React.createElement(
							"td",
							{ className: "pageCell" },
							React.createElement(
								"div",
								{ className: "infoContainer" },
								this.props.log.pages || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Pages"
							)
						);
					}
	
					if (CurrentUser.get().prefs.automatic_zpd_exclusion || this.props.log.excluded) {
						var goalsLink = React.createElement(
							"a",
							{ href: "#", className: "btn btn-link", onClick: this.includeLog },
							"Include In Goals"
						);
					} else {
						var goalsLink = React.createElement(
							"a",
							{ href: "#", className: "btn btn-link", onClick: this.excludeLog },
							"Exclude From Goals"
						);
					}
					var editLink = React.createElement(
						"a",
						{ href: "#", onClick: this.onClickEditField, className: "btn btn-link" },
						"Edit Log"
					);
					var deleteLink = React.createElement(
						"a",
						{ href: "#", className: "btn btn-link", onClick: this.deleteLog },
						"Remove Log"
					);
					if (CurrentUser.isAdmin()) {
						var teacherLinks = React.createElement(
							"div",
							null,
							goalsLink,
							deleteLink
						);
					}
					var logOptions = React.createElement(
						"td",
						{ className: "optionsCell" },
						React.createElement(
							"div",
							{ className: "infoContainer" },
							React.createElement(
								"div",
								{ className: "dropdown hideOnPrint" },
								React.createElement(
									"a",
									{ role: "button", className: "",
										"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
									React.createElement(
										"span",
										{ className: "ellipsisText btn-link" },
										"Options"
									),
									React.createElement("span", { className: "caret" })
								),
								React.createElement(
									"ul",
									{ className: "dropdown-menu dropdown-menu-right", "aria-labelledby": "dLabel" },
									editLink,
									teacherLinks
								)
							)
						)
					);
					if (this.props.log.excluded) {
						var className = "excludedLog";
						var logTooltipText = "This log will not count toward goals.";
					}
	
					if (this.props.log.verified) {
						var logTooltipText = "This log has parent approval.";
						var parentConfirmation = React.createElement(
							"td",
							{ className: "dateCell" },
							React.createElement(
								"div",
								{ className: "infoContainer", "data-tip": logTooltipText },
								React.createElement(Glyphicon, { icon: "ok-sign" })
							)
						);
					}
	
					if (this.props.condensedLayout) {
						var day = moment(this.props.log.log_date).format("MMM D");
						return React.createElement(
							"tr",
							{ className: "logRow digestLogRow" },
							React.createElement(
								"td",
								{ className: "dateCell" },
								React.createElement(
									"div",
									{ className: "infoContainer" },
									day
								)
							),
							React.createElement(
								"td",
								{ className: "titleCell" },
								React.createElement(
									"div",
									{ className: "infoContainer textTitle" },
									React.createElement(BookDisplay, { textID: this.props.log.text_id })
								)
							),
							React.createElement(
								"td",
								{ className: "minuteCell" },
								React.createElement(
									"div",
									{ className: "infoContainer" },
									this.props.log.minutes || "-",
									" minutes"
								)
							)
						);
					} else {
						return React.createElement(
							"tr",
							{ className: "logRow" },
							dateCell,
							titleCell,
							readingLevelCell,
							timeCell,
							logQuantityContainer,
							logQuantityContainerTwo,
							parentConfirmation,
							logOptions
						);
					}
				}
			}
		}]);
	
		return LogRow;
	}(React.Component)) || _class);
	;
	
	LogRow.WrappedComponent.propTypes = StrictPropTypes({
		log: PropTypes.object.isRequired,
		condensedLayout: PropTypes.bool,
		book: PropTypes.object,
		student: PropTypes.object,
	
		// From @connect
		onDelete: PropTypes.func.isRequired,
		onUpdate: PropTypes.func.isRequired,
		onInclude: PropTypes.func,
		onExclude: PropTypes.func,
		fetchBook: PropTypes.func,
		fetchStudent: PropTypes.func
	});
	
	module.exports = LogRow;
	
	// editCell

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookCover = __webpack_require__(140);
	var Spinner = __webpack_require__(9);
	var EmptyStateContainer = __webpack_require__(80);
	
	var ReactTooltip = __webpack_require__(12);
	var ParticipatingStudentsDisplay = __webpack_require__(397);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3735);
	
	var BookGrid = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// This isn't particularly elegant
		var studentNameLookup = {};
		_.each(RosterSelectors.students({ state: state }), function (student) {
			studentNameLookup[student.id] = student.display_name;
		});
		return { studentNameLookup: studentNameLookup };
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(BookGrid, _React$Component);
	
		function BookGrid(props) {
			_classCallCheck(this, BookGrid);
	
			var _this = _possibleConstructorReturn(this, (BookGrid.__proto__ || Object.getPrototypeOf(BookGrid)).call(this));
	
			autobind(_this);
			_this.state = {
				visibleRowCount: 4
			};
			return _this;
		}
	
		_createClass(BookGrid, [{
			key: "selectBook",
			value: function selectBook(text_id) {
				if (this.props.onBookSelect) {
					this.props.onBookSelect(text_id);
				}
			}
		}, {
			key: "visibleBooks",
			value: function visibleBooks() {
				var sortedBooks = _.sortBy(this.props.books, function (book) {
					return $wr.padleft(book.user_ids.length, 4) + "-" + book.last_active;
				}).reverse();
	
				return _.first(sortedBooks, this.state.visibleRowCount * BOOKS_PER_ROW);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var MAX_DISPLAY_STUDENT_COUNT = 3;
	
				if (this.props.books.length > 0 || this.props.loading) {
	
					var gridContent = _.map(this.visibleBooks(), function (book, index) {
						var teachersPick = false;
						if (book.teachers_pick) {
							teachersPick = true;
						}
						var userDraftCounts = book.quiz_draft_counts || {};
						if (_this2.props.showStudentIDs) {
							var activeStudentIDs = _.intersection(_this2.props.showStudentIDs, book.user_ids);
	
							var studentsDisplayContainer = React.createElement(
								"div",
								{ className: "studentsDisplayContainer" },
								React.createElement(ParticipatingStudentsDisplay, { studentIDs: activeStudentIDs,
									maxDisplayStudentCount: MAX_DISPLAY_STUDENT_COUNT })
							);
						}
	
						return React.createElement(
							"div",
							{ className: "bookContainer", key: book.text_id, onClick: _this2.selectBook.bind(_this2, book.text_id) },
							React.createElement(BookCover, { book: book, coverWidth: 105,
								showTitle: false, showAuthor: false,
								displayQuizTaken: _this2.props.showQuizIcons,
								quizTaken: book.quiz_counts != undefined,
								quizDraft: _.size(userDraftCounts) > 0,
								teachersPick: teachersPick
							}),
							studentsDisplayContainer
						);
					});
				}
	
				if (this.props.loading) {
					var spinner = React.createElement(Spinner, { scale: 2.0, placeholder: true });
				}
	
				return React.createElement(
					"div",
					{ className: "bookGrid", ref: "wrapper" },
					React.createElement(
						"div",
						null,
						gridContent
					),
					spinner
				);
			}
		}, {
			key: "checkScroll",
			value: function checkScroll() {
				if (!this.props.loading) {
					var $wrapper = $(this.refs.wrapper);
					var threshold = 300;
					var lim = $wrapper.offset().top + $wrapper.height();
					var loc = $(window).scrollTop() + $(window).height();
					if (loc + threshold > lim) {
						if (this.state.visibleRowCount * BOOKS_PER_ROW < this.props.books.length) {
							this.setState({ visibleRowCount: this.state.visibleRowCount + 4 });
						}
					}
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window).scroll(this.checkScroll);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.checkScroll);
			}
		}]);
	
		return BookGrid;
	}(React.Component)) || _class);
	
	
	var BOOKS_PER_ROW = 6;
	
	BookGrid.WrappedComponent.propTypes = StrictPropTypes({
		books: PropTypes.array.isRequired,
		onBookSelect: PropTypes.func,
		showQuizIcons: PropTypes.bool,
		showStudentIDs: PropTypes.array,
	
		// Show a spinner and block onEnd notices if this is true
		loading: PropTypes.bool,
	
		studentNameLookup: PropTypes.object
	});
	
	module.exports = BookGrid;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var BookGrid = __webpack_require__(403);
	var BookSidebar = __webpack_require__(851);
	var ExpandedBookDetails = __webpack_require__(854);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var DisplayToggleControl = __webpack_require__(48);
	var EmptyStateContainer = __webpack_require__(80);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	
	var ArbitrarySubjects = __webpack_require__(107);
	var Features = __webpack_require__(16);
	
	var WritingSelectors = __webpack_require__(14);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	__webpack_require__(3736);
	
	var BookShelf = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var textID = props.textID;
	
		if (props.classView) {
			var books = ReadingSelectors.books({ state: state, conditions: {
					userIDs: props.studentIDs
				} });
		} else {
			var userID = CurrentUser.get().id;
	
			var books = ReadingSelectors.books({ state: state, conditions: {
					userID: userID
				} });
	
			if (textID) {
				var draftQuizzes = WritingSelectors.quizzes({
					state: state, conditions: { textID: textID, userID: userID }, filters: { draft: true }
				});
				var draftAnswers = WritingSelectors.nonQuizAnswers({
					state: state, conditions: { textID: textID, userID: userID }, filters: { draft: true }
				});
				var draftReviews = WritingSelectors.reviews({
					state: state, conditions: { textID: textID, userID: userID }, filters: { draft: true }
				});
				var draftResponses = WritingSelectors.responses({
					state: state, conditions: { textID: textID, userID: userID }, filters: { draft: true }
				});
				var draftQuestionBuilders = WritingSelectors.metaCognitiveAnswers({
					state: state, conditions: { textID: textID, userID: userID }, filters: { draft: true }
				});
				var draftCount = draftQuizzes.length + draftAnswers.length + draftReviews.length + draftResponses.length + draftQuestionBuilders.length;
			}
		}
	
		var loading = ReadingSelectors.isLoadingBooks({ state: state });
	
		return {
			books: books, loading: loading, draftCount: draftCount
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (props.classView) {
					var conditions = {
						userIDs: props.studentIDs,
						order: "desc-popularity"
					};
					return dispatch(ReadingActions.fetchBookActivity({
						conditions: conditions,
						fetchDetails: true,
						cache: true
					}));
				} else {
					var filters = {
						user_id: CurrentUser.get().id,
						order: "desc-last-active",
						draft: true
					};
					var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];
	
					return dispatch(ReadingActions.fetchBookActivity({
						filters: filters, embeds: embeds,
						fetchDetails: true,
						cache: true
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(BookShelf, _React$Component);
	
		function BookShelf(props) {
			_classCallCheck(this, BookShelf);
	
			var _this = _possibleConstructorReturn(this, (BookShelf.__proto__ || Object.getPrototypeOf(BookShelf)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("BookShelf");
			_this.state = {
				bookDetails: {},
	
				// Stuff for scrolling (which is a real headache btw.)
				maxHeightSidebar: 0, maxHeightDetails: 0,
				minHeightExpanded: 0, minShelfHeight: 0
			};
			return _this;
		}
	
		_createClass(BookShelf, [{
			key: "isExpandedView",
			value: function isExpandedView() {
				return !!this.props.textID;
			}
		}, {
			key: "unexpandBook",
			value: function unexpandBook(e) {
				$wr.nope(e);
				this.props.switchView({ textID: undefined });
			}
		}, {
			key: "expandBook",
			value: function expandBook(textID) {
				if (this.props.classView) {
					var detailsView = this.props.detailsView || ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK);
				} else {
					var detailsView = this.props.detailsView || ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER);
				}
				this.props.switchView({
					detailsView: detailsView, textID: textID
				});
				$wr.setWindowY(0);
			}
		}, {
			key: "onBookDetailsViewChange",
			value: function onBookDetailsViewChange(detailsViewKey) {
				this.props.switchView({ detailsView: detailsViewKey });
			}
		}, {
			key: "onHeightUpdated",
			value: function onHeightUpdated(height) {
				if (height < this.state.maxHeightSidebar) {
					this.setState({ minShelfHeight: this.state.maxHeightSidebar + 70 });
				} else {
					this.setState({ minShelfHeight: height + 70 });
				}
			}
		}, {
			key: "renderExpandedView",
			value: function renderExpandedView() {
				var _this2 = this;
	
				if (!this.props.classView) {
					var toggleOptions = [{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER), text: "Quiz" }, { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER), text: "Practice Questions" }, { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW), text: "Reviews" }, { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER), text: "Question Builders" }];
					if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						var exercisesKey = { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE), text: "Exercises" };
						toggleOptions.push(exercisesKey);
					}
					// add unfinsihed work option if drafts exist
					if (this.props.draftCount > 0) {
						var draftToggleText = "Unfinished Work (" + this.props.draftCount + ")";
						toggleOptions.push({ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT), text: draftToggleText });
					}
					// show text for current view on dropdown
					var currentDetailViewObj = _.findWhere(toggleOptions, { key: this.props.detailsView });
					if (currentDetailViewObj && currentDetailViewObj.text) {
						var firstOptionText = currentDetailViewObj.text;
					} else {
						var firstOptionText = 'Quiz';
					}
					// display dropdown
					var displayToggleOptions = _.map(toggleOptions, function (option) {
						return React.createElement(ButtonDropdownOption, { text: option.text,
							onClick: _this2.onBookDetailsViewChange.bind(_this2, option.key) });
					});
	
					var displayToggleOptions = React.createElement(
						"div",
						{ className: "toggleOptionContainer" },
						React.createElement(
							ButtonDropdown,
							{ text: firstOptionText, dropdownDisplay: "link", className: "hideOnPrint smallObject" },
							displayToggleOptions
						)
					);
				}
	
				if (this.isExpandedView()) {
					var expandedKey = this.props.textID + "::" + this.props.detailsView;
					if (this.props.classView) {
						var expandedContent = React.createElement(
							"div",
							null,
							React.createElement(
								_reactCustomScrollbars.Scrollbars,
								{ autoHeight: true, id: "bookDetailFrame", className: "bookDetailFrame", autoHeightMin: 0,
									autoHeightMax: this.state.maxHeightDetails },
								React.createElement(ExpandedBookDetails, { key: expandedKey,
									textID: this.props.textID,
									studentIDs: this.props.studentIDs,
									view: this.props.detailsView })
							)
						);
					} else if (this.props.detailsView == "quizzes" || this.props.detailsView == "answers") {
						var expandedContent = React.createElement(ExpandedBookDetails, { key: expandedKey,
							onHeightUpdated: this.onHeightUpdated,
							textID: this.props.textID,
							view: this.props.detailsView });
					} else {
						var expandedContent = React.createElement(
							"div",
							null,
							React.createElement(
								_reactCustomScrollbars.Scrollbars,
								{ autoHeight: true, id: "bookDetailFrame", className: "bookDetailFrame", autoHeightMin: 0,
									autoHeightMax: this.state.maxHeightDetails },
								React.createElement(ExpandedBookDetails, { key: expandedKey,
									textID: this.props.textID,
									view: this.props.detailsView })
							)
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "clearfix" },
					React.createElement(
						"div",
						{ className: "hideOnPrint" },
						React.createElement(
							"div",
							{ className: "sidebarWrap" },
							React.createElement(
								"div",
								{ className: "backLink" },
								React.createElement(
									"a",
									{ href: "#", onClick: this.unexpandBook },
									React.createElement(Glyphicon, { icon: "chevron-left" }),
									" Back"
								)
							),
							React.createElement(
								"div",
								{ ref: "sidebarWrap" },
								React.createElement(
									_reactCustomScrollbars.Scrollbars,
									{ autoHeight: true, ref: "scrollbars",
										autoHeightMin: 0, autoHeightMax: this.state.maxHeightSidebar },
									React.createElement(BookSidebar, { books: _.filter(this.props.books, function (book) {
											return book.text_id !== '' && book.text_id !== 'MISSING_TEXT_ID';
										}), selectedTextID: this.props.textID,
										onBookSelect: this.expandBook })
								)
							)
						)
					),
					React.createElement(
						"div",
						{ className: "detailsWrap" },
						displayToggleOptions,
						React.createElement(
							"div",
							{ ref: "detailsWrap" },
							expandedContent
						)
					)
				);
			}
		}, {
			key: "renderGridEmptyState",
			value: function renderGridEmptyState() {
				if (this.props.classView) {
					if (CurrentUser.isAdmin()) {
						var emptyStatusText = "Once your students start reading, their books and book reviews will appear here.";
					} else {
						var emptyStatusText = "Once you and your classmates read some books, your books will appear here.";
					}
					var emptyImagePath = __webpack_require__(495);
				} else {
					var emptyStatusText = "Once you do some activities and complete some quizzes, your books will appear here.";
					var emptyImagePath = __webpack_require__(1556);
				}
	
				return React.createElement(EmptyStateContainer, { statusText: emptyStatusText, imagePath: emptyImagePath });
			}
		}, {
			key: "renderGridView",
			value: function renderGridView() {
				if (!this.props.loading && _.isEmpty(this.props.books)) {
					return this.renderGridEmptyState();
				}
	
				if (this.props.classView) {
					var showStudentIDs = this.props.studentIDs;
				}
	
				return React.createElement(BookGrid, { books: _.filter(this.props.books, function (book) {
						return book.text_id !== '' && book.text_id !== 'MISSING_TEXT_ID';
					}),
					showQuizIcons: !this.props.classView,
					showStudentIDs: showStudentIDs,
					onBookSelect: this.expandBook, loading: this.props.loading });
			}
		}, {
			key: "render",
			value: function render() {
	
				if (this.isExpandedView()) {
					var viewToggleClassName = "viewToggle expanded";
					var gridStyle = { maxHeight: this.state.minHeightExpanded };
					var shelfStyle = { height: this.state.minShelfHeight };
				} else {
					var viewToggleClassName = "viewToggle grid";
				}
	
				return React.createElement(
					"div",
					{ className: "container bookShelf", style: shelfStyle },
					React.createElement(
						"div",
						{ className: viewToggleClassName },
						React.createElement(
							"div",
							{ className: "gridWrap hideOnPrint", style: gridStyle, ref: "gridWrap" },
							this.renderGridView()
						),
						React.createElement(
							"div",
							{ className: "expandedWrap" },
							this.renderExpandedView()
						)
					)
				);
			}
		}, {
			key: "initSideBars",
			value: function initSideBars() {
				if (!this.refs.detailsWrap || !this.refs.sidebarWrap) {
					setTimeout(this.initSideBars, 300);
				} else {
					var maxHeightDetails = window.innerHeight - $(this.refs.detailsWrap).offset().top - 30;
					var maxHeightSidebar = window.innerHeight - $(this.refs.sidebarWrap).offset().top - 30;
					var minHeightExpanded = window.innerHeight - $(this.refs.gridWrap).offset().top;
	
					// DISPLAY QUIZZES FULLY TO ALLOW PRINTING
					if (this.props.detailsView == "quizzes" || this.props.detailsView == "answers") {
						if (this.state.minShelfHeight > 0) {
							var minShelfHeight = this.state.minShelfHeight;
						} else {
							var minShelfHeight = 0;
						}
					} else {
						var minShelfHeight = minHeightExpanded;
					}
	
					// Kinda arbitrary but ok
					minShelfHeight = Math.max(minShelfHeight, $(this.refs.detailsWrap).height() + 100);
	
					this.setState({ maxHeightSidebar: maxHeightSidebar, maxHeightDetails: maxHeightDetails,
						minHeightExpanded: minHeightExpanded, minShelfHeight: minShelfHeight });
				}
			}
		}, {
			key: "scrollToBook",
			value: function scrollToBook() {
				var uniqueClass = ".book" + this.props.textID;
				var $book = $(this.refs.sidebarWrap).find(uniqueClass);
				if ($book.length > 0) {
					var bookY = $book.position().top;
					var scrollY = this.refs.scrollbars.getScrollTop();
					var scrollPosition = bookY + scrollY;
					this.refs.scrollbars.scrollTop(scrollPosition);
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var textID = this.props.textID;
				if (textID && textID != prevProps.textID) {
					this.scrollToBook();
				}
				// if we switch away from draft view to a book with no drafts, switch off draft view
				if (this.props.detailsView == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT) && this.props.draftCount == 0 && !this.props.loading) {
					this.onBookDetailsViewChange(ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER));
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window).on("resize", this.initSideBars);
				this.initSideBars();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("resize", this.initSideBars);
			}
		}]);
	
		return BookShelf;
	}(React.Component)) || _class) || _class);
	
	
	BookShelf.WrappedComponent.propTypes = StrictPropTypes({
		// From component above
		detailsView: PropTypes.string,
		textID: PropTypes.string,
		studentIDs: PropTypes.array,
		// Too much of a headache to not pass this in... but I'm not happy about it.
		// Generally better to pass in more descriptive individual props
		classView: PropTypes.bool,
	
		// handler from component above
		switchView: PropTypes.func.isRequired,
	
		// @connect data
		loading: PropTypes.bool,
		books: PropTypes.array,
		draftCount: PropTypes.number,
	
		// @connect handler
		populateData: PropTypes.func
	});
	
	module.exports = BookShelf;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var ErrorDisplay = __webpack_require__(51);
	var AutoSubmitTextArea = __webpack_require__(418);
	var Glyphicon = __webpack_require__(8);
	var CurrentUser = __webpack_require__(3);
	var StandardComments = __webpack_require__(996);
	
	var CommentForm = function (_React$Component) {
		_inherits(CommentForm, _React$Component);
	
		function CommentForm(props) {
			_classCallCheck(this, CommentForm);
	
			var _this = _possibleConstructorReturn(this, (CommentForm.__proto__ || Object.getPrototypeOf(CommentForm)).call(this));
	
			autobind(_this);
	
			var isSecret = true;
	
			_this.state = {
				secret: isSecret, inFocus: false
			};
			return _this;
		}
	
		_createClass(CommentForm, [{
			key: "submitComment",
			value: function submitComment(isSecret) {
				var text = this.refs.commentTextArea.text();
				if (text.length > 0) {
					var commentData = { body: text, secretive: isSecret,
						news_feed_item_id: this.props.itemID };
	
					if (this.props.comment) {
						commentData.id = this.props.comment.id;
					}
	
					this.props.onSubmit(commentData);
				}
			}
		}, {
			key: "focusChange",
			value: function focusChange(inFocus) {
				this.setState({ inFocus: inFocus });
			}
		}, {
			key: "reset",
			value: function reset() {
				this.refs.commentTextArea.reset();
				this.refs.errors.reset();
			}
		}, {
			key: "buildSubmitF",
			value: function buildSubmitF(isSecret) {
				return function (e) {
					$wr.nope(e);
					this.setState({ secret: isSecret });
					this.submitComment(isSecret);
				}.bind(this);
			}
		}, {
			key: "getExtraButtons",
			value: function getExtraButtons() {
				if (CurrentUser.isAdmin()) {
					var publicOp = React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: "eye-open" }),
						" ",
						"Public ",
						React.createElement(
							"span",
							{ className: "details" },
							"(to class)"
						)
					);
					var privateOp = React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: "eye-close" }),
						" ",
						"Private ",
						React.createElement(
							"span",
							{ className: "details" },
							"(student only)"
						)
					);
	
					if (this.state.secret) {
						var selText = "Private";
						var selIcon = "eye-close";
					} else {
						var selText = "Public";
						var selIcon = "eye-open";
					}
	
					var selOp = this.state.secret ? privateOp : publicOp;
	
					return React.createElement(
						ButtonDropdown,
						{ text: selText, icon: selIcon, className: "commentSubmitButtons" },
						React.createElement(ButtonDropdownOption, { text: "Public (to class)", icon: "eye-open",
							onClick: this.buildSubmitF(false) }),
						React.createElement(ButtonDropdownOption, { text: "Private (student only)", icon: "eye-close",
							onClick: this.buildSubmitF(true) })
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var currentUser = CurrentUser.get();
				if (currentUser && currentUser.settings && currentUser.settings.block_comments) {
					return React.createElement(
						"p",
						null,
						React.createElement(
							"em",
							null,
							"Your teacher has blocked you from making comments...."
						)
					);
				} else {
					var className = "commentTextArea";
					if (CurrentUser.isAdmin()) {
						className += " commentTextAreaAdmin";
						var placeholderText = "Give feedback on this answer";
					} else if (CurrentUser.isStudent()) {
						className += " commentTextAreaStudent";
						var placeholderText = "Respond to your teacher here";
					}
					if (this.props.comment) {
						var text = this.props.comment.body;
					} else if (this.state.inFocus && CurrentUser.isAdmin() && !this.props.noSuggestedComments) {
						var defaultCommentOptions = _.map(StandardComments.ALL, function (item) {
							var color = item.type == "positive" ? "#70d544" : "#da3956";
							return _.extend({}, item, { label: item.body, value: item.body, color: color });
						});
	
						className += " withSuggestions";
					}
	
					return React.createElement(
						"div",
						{ className: "clearfix commentForm" },
						React.createElement(
							"div",
							{ className: className },
							React.createElement(ErrorDisplay, { ref: "errors" }),
							React.createElement(AutoSubmitTextArea, { ref: "commentTextArea", onSubmit: this.buildSubmitF(this.state.secret),
								className: "form-control makeComment expandOnFocus", submitLink: true,
								prefillOptions: defaultCommentOptions,
								onFocus: this.focusChange.bind(this, true), onBlur: this.focusChange.bind(this, false),
								defaultValue: text, placeholder: placeholderText })
						)
					);
				}
			}
		}]);
	
		return CommentForm;
	}(React.Component);
	
	;
	
	CommentForm.propTypes = StrictPropTypes({
		// Function to pass submitted data to
		onSubmit: PropTypes.func.isRequired,
	
		// Exisiting comment we're editing. If undefined, it's a new comment
		comment: PropTypes.object,
	
		noSuggestedComments: PropTypes.bool
	});
	
	module.exports = CommentForm;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3745);
	
	
	var StudentDisplay = __webpack_require__(52);
	var Spinner = __webpack_require__(9);
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	
	var OwlShopRouting = __webpack_require__(92);
	
	var CurrentUser = __webpack_require__(3);
	
	var PER_PAGE = 12;
	
	var PhotosDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		var photographs = props.isClass ? OwlShopSelectors.photographs({ state: state, conditions: { userIDs: props.ids } }) : OwlShopSelectors.photographs({ state: state, conditions: { studentListIDs: props.ids } });
	
		return {
			loading: OwlShopSelectors.isLoadingPhotographs({ state: state }),
			photographs: photographs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData(page) {
				var conditions = props.isClass ? { userIDs: props.ids } : { studentListIDs: props.ids };
	
				return dispatch(OwlShopActions.fetchPhotographs({
					conditions: conditions,
					page: page || 1,
					query: { per_page: PER_PAGE }
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(PhotosDisplay, _React$Component);
	
		function PhotosDisplay(props) {
			_classCallCheck(this, PhotosDisplay);
	
			var _this = _possibleConstructorReturn(this, (PhotosDisplay.__proto__ || Object.getPrototypeOf(PhotosDisplay)).call(this));
	
			autobind(_this);
			_this.state = {
				doneScrolling: false
			};
	
			_this.wrapperRef = React.createRef();
			return _this;
		}
	
		//render 3 sample photos for the empty state
	
	
		_createClass(PhotosDisplay, [{
			key: "renderEmptyState",
			value: function renderEmptyState() {
				var img_paths = [__webpack_require__(493), __webpack_require__(494), __webpack_require__(492)];
				return img_paths.map(function (path) {
					return React.createElement(
						"div",
						{ className: "photoBox", key: path },
						React.createElement(
							"div",
							{ className: "clearfix textHeader" },
							React.createElement(
								"div",
								{ className: "pull-left" },
								"Name"
							),
							React.createElement(
								"div",
								{ className: "pull-right" },
								"Date"
							)
						),
						React.createElement("img", { className: "photo samplePhoto", src: path })
					);
				});
			}
		}, {
			key: "renderPhotos",
			value: function renderPhotos() {
				var photos = _.sortBy(this.props.photographs, "id").reverse().map(function (photo) {
					return React.createElement(
						"div",
						{ className: "photoBox", key: photo.id },
						React.createElement(
							"div",
							{ className: "clearfix textHeader" },
							React.createElement(
								"div",
								{ className: "pull-left" },
								React.createElement(StudentDisplay, { studentID: photo.user_id })
							),
							React.createElement(
								"div",
								{ className: "pull-right" },
								$wr.formatDate(photo.created_at)
							)
						),
						React.createElement("img", { className: "photo", src: photo.url })
					);
				});
				return photos;
			}
		}, {
			key: "nextPage",
			value: function nextPage() {
				return Math.floor(this.props.photographs.length / PER_PAGE) + 1;
			}
		}, {
			key: "render",
			value: function render() {
				var photos = this.renderPhotos();
				if (this.props.loading) {
					var spinner = React.createElement(Spinner, { scale: 2.0, placeholder: true });
				} else if (!photos.length) {
					var user = CurrentUser.get();
					var samplePhotos = this.renderEmptyState();
	
					//text and sample photos for empty state
					var zeroState = React.createElement(
						"div",
						{ className: "text-center" },
						React.createElement(
							"p",
							{ className: "zeroHeader" },
							"No one has taken any photos yet for your class Owlstagram.",
							!user.is_admin ? React.createElement(
								"p",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: OwlShopRouting.getPath({ activeView: OwlShopRouting.VIEWS.PHOTOS }) },
									"Take the first photo!"
								)
							) : React.createElement(
								"p",
								null,
								React.createElement(
									"a",
									{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/360060957752-Owlstagram" },
									"Learn more about Owlstagram here!"
								)
							)
						),
						samplePhotos
					);
				}
	
				return React.createElement(
					"div",
					{ className: "photosDisplay", ref: this.wrapperRef },
					spinner,
					zeroState,
					React.createElement(
						"div",
						{ className: "photos" },
						photos
					)
				);
			}
		}, {
			key: "checkScroll",
			value: function checkScroll() {
				var _this2 = this;
	
				if (!this.props.loading && !this.state.doneScrolling) {
					var $wrapper = $(this.wrapperRef.current);
					var threshold = 50; //300;
					var lim = $wrapper.offset().top + $wrapper.height();
					var loc = $(window).scrollTop() + $(window).height();
	
					if (loc + threshold > lim) {
						this.props.populateData(this.nextPage()).then(function (response) {
							if (response.photographs.length < PER_PAGE) {
								_this2.setState({ doneScrolling: true });
							}
						});
					}
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.populateData();
				$(window).scroll(this.checkScroll);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.checkScroll);
			}
		}]);
	
		return PhotosDisplay;
	}(React.Component)) || _class);
	;
	
	PhotosDisplay.WrappedComponent.propTypes = StrictPropTypes({
		//students: PropTypes.array.isRequired,
		isClass: PropTypes.bool,
		ids: PropTypes.array.isRequired,
	
		// @connect data
		photographs: PropTypes.array.isRequired,
		loading: PropTypes.bool,
	
		// @connect handler
		populateData: PropTypes.func
	});
	
	module.exports = PhotosDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(15);
	var CurrentUser = __webpack_require__(3);
	var CustomerIOClient = __webpack_require__(254);
	
	__webpack_require__(3749);
	
	var WebinarRegistration = function (_React$Component) {
		_inherits(WebinarRegistration, _React$Component);
	
		function WebinarRegistration(props) {
			_classCallCheck(this, WebinarRegistration);
	
			var _this = _possibleConstructorReturn(this, (WebinarRegistration.__proto__ || Object.getPrototypeOf(WebinarRegistration)).call(this));
	
			autobind(_this);
	
			_this.state = { selectedWebinar: _this.upcomingWebinars()[0] };
			return _this;
		}
	
		_createClass(WebinarRegistration, [{
			key: "selectWebinar",
			value: function selectWebinar(webinarData) {
				this.setState({ selectedWebinar: webinarData });
			}
		}, {
			key: "register",
			value: function register() {
				CustomerIOClient.event(CurrentUser.get(), "registered-for-webinar", this.state.selectedWebinar);
				Mycroft.newEvent({ category: "Paywall", action: "webinar-signup", label: this.props.sourceFeature });
				window.wrNotifications.triggerDropDownNotification({
					title: "Registration Complete!", text: "Check your email for details.", icon: "ok-sign" });
			}
		}, {
			key: "upcomingWebinars",
			value: function upcomingWebinars() {
				return _.filter(SCHEDULED_WEBINARS, function (webinarData) {
					return moment().isBefore(webinarData.dateTime);
				}).slice(0, 2);
			}
		}, {
			key: "renderDateTimeOption",
			value: function renderDateTimeOption(webinarData, index) {
				var currentlySelected = webinarData.dateTime == this.state.selectedWebinar.dateTime;
	
				return React.createElement(
					"label",
					{ className: "formOption", key: webinarData.dateTime },
					React.createElement("input", { type: "radio", checked: currentlySelected,
						onChange: this.selectWebinar.bind(this, webinarData) }),
					React.createElement(
						"span",
						null,
						webinarData.dateText,
						" at ",
						webinarData.timeText
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var webinarOptions = _.map(this.upcomingWebinars(), function (webinarData, index) {
					return _this2.renderDateTimeOption(webinarData, index);
				});
	
				return React.createElement(
					"div",
					{ className: "webinarRegistration" },
					React.createElement(
						"p",
						null,
						"Select the time that works best for you and we will email you instructions on how to join the webinar."
					),
					React.createElement(
						"button",
						{ className: "btn buttonSuccess", onClick: this.register },
						"Save My Spot!"
					),
					webinarOptions
				);
			}
		}]);
	
		return WebinarRegistration;
	}(React.Component);
	
	var SCHEDULED_WEBINARS = [{ dateText: "August 15 (Wednesday)", timeText: "11:00am PDT", dateTime: "2018-08-15 11:00-07:00" }, { dateText: "August 23 (Thursday)", timeText: "3:00pm PDT", dateTime: "2018-08-23 15:00-07:00" }, { dateText: "August 28 (Tuesday)", timeText: "9:00am PDT", dateTime: "2018-08-28 09:00-07:00" }, { dateText: "September 5 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-09-05 15:00-07:00" }, { dateText: "September 13 (Thursday)", timeText: "9:00am PDT", dateTime: "2018-09-13 09:00-07:00" }, { dateText: "September 18 (Tuesday)", timeText: "11:00am PDT", dateTime: "2018-09-18 11:00-07:00" }, { dateText: "September 26 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-09-26 09:00-07:00" }, { dateText: "October 4 (Thursday)", timeText: "11:00am PDT", dateTime: "2018-10-04 11:00-07:00" }, { dateText: "October 9 (Tuesday)", timeText: "3:00pm PDT", dateTime: "2018-10-09 15:00-07:00" }, { dateText: "October 11 (Thursday)", timeText: "11:00am PDT", dateTime: "2018-10-11 11:00-07:00" }, { dateText: "October 16 (Tuesday)", timeText: "3:00pm PDT", dateTime: "2018-10-16 15:00-07:00" }, { dateText: "October 31 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-10-31 15:00-07:00" }, { dateText: "November 14 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-11-14 09:00-07:00" }, { dateText: "November 28 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-11-28 15:00-07:00" }, { dateText: "December 12 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-12-12 09:00-07:00" }];
	
	WebinarRegistration.propTypes = PageStrictPropTypes({
		// to record which location the registration came from
		sourceFeature: PropTypes.string.isRequired
	});
	
	module.exports = WebinarRegistration;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SurveyPromptConfig = __webpack_require__(257);
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3750);
	
	var SurveyPromptDisplay = function (_React$Component) {
	  _inherits(SurveyPromptDisplay, _React$Component);
	
	  function SurveyPromptDisplay(props) {
	    _classCallCheck(this, SurveyPromptDisplay);
	
	    var _this = _possibleConstructorReturn(this, (SurveyPromptDisplay.__proto__ || Object.getPrototypeOf(SurveyPromptDisplay)).call(this));
	
	    autobind(_this);
	
	    _this.state = {
	      answered: false,
	      sidebarCollapsed: false,
	      showFreeResponse: false,
	      loading: false,
	      selectedOptions: [],
	      selectedOp: null
	    };
	    return _this;
	  }
	  // for a given answer, should free response show?
	
	
	  _createClass(SurveyPromptDisplay, [{
	    key: "freeResponsePrompts",
	    value: function freeResponsePrompts(answer) {
	      var prompt = this.props.prompt;
	
	
	      if (prompt.include_free_response && answer == 'Other') {
	        return true;
	      } else if (prompt.explain_answer && _.includes(prompt.explain_answer, answer)) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "sendResponseData",
	    value: function sendResponseData(answer) {
	      this.setState({ loading: true });
	      sessionStorage.removeItem(SurveyPromptConfig.PROMPT_SESSION_KEY);
	
	      var feedbackItem = {
	        user_id: CurrentUser.get().id,
	        subject_type: 'survey',
	        subject_id: this.props.prompt.id,
	        key: this.props.prompt.key,
	        reaction: answer,
	        subject_data: this.props.dataPacket || {}
	      };
	      var params = { feedback_item: feedbackItem };
	
	      CurrentUser.api().postFeedbackItem(params, $wr.apiHandler(function (serverResponse) {
	        // for LO
	        LuckyOrangeClient.tagComponent("SurveyPrompt Submitted: " + this.props.prompt.id);
	        this.setState({ loading: false });
	        console.log('Server Response', serverResponse);
	
	        if (serverResponse.feedback_item) {
	          this.showSuccessMessage();
	          this.props.onSubmitFeedback();
	        } else {
	          LuckyOrangeClient.tagComponent("SurveyPrompt Failed: " + this.props.prompt.id);
	          this.showFailMessage('Oops! Something went wrong and the feedback was no recorded.');
	        }
	      }.bind(this)));
	    }
	  }, {
	    key: "showSuccessMessage",
	    value: function showSuccessMessage() {
	      this.setState({ answered: true });
	
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Thank you for your feedback!",
	        icon: "ok-circle"
	      });
	    }
	  }, {
	    key: "showFailMessage",
	    value: function showFailMessage(message) {
	      window.wrNotifications.triggerDropDownNotification({
	        title: message,
	        icon: "exclamation-sign", type: "error"
	      });
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(answer) {
	      var prompt = this.props.prompt;
	
	      if (this.freeResponsePrompts(answer)) {
	        this.setState({ showFreeResponse: !this.state.showFreeResponse });
	      }
	
	      if (!this.freeResponsePrompts(answer) && !prompt.select_multiple) {
	        // send response data to BE
	        this.sendResponseData(answer);
	      } else {
	        if (prompt.select_multiple) {
	          var oldOps = _.clone(this.state.selectedOptions);
	          var newOps = _.includes(oldOps, answer) ? _.filter([].concat(_toConsumableArray(oldOps)), function (o) {
	            return o !== answer;
	          }) : [].concat(_toConsumableArray(oldOps), [answer]);
	        } else {
	          var newOps = [answer];
	        }
	
	        this.setState({ selectedOptions: newOps });
	      }
	    }
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      $wr.nope(e);
	
	      var selectedOptions = this.state.selectedOptions;
	
	      var fRAnswer = e.target.freeResponseAnswer.value;
	
	      var answer = _.map(selectedOptions, function (op) {
	        return _this2.freeResponsePrompts(op) ? op + ": " + fRAnswer : op;
	      });
	
	      this.sendResponseData(answer.join(' && '));
	    }
	  }, {
	    key: "renderOptionButtons",
	    value: function renderOptionButtons() {
	      var _this3 = this;
	
	      var prompt = this.props.prompt;
	
	      var animationClass = prompt.style.circle_animation ? 'spin circle' : '';
	      if (prompt.options) {
	        return _.map(prompt.options, function (option) {
	          var selectedClass = _this3.state.selectedOp == option ? 'selected' : '';
	          return React.createElement(
	            "button",
	            { className: "surveyOptionBtn " + animationClass + " " + selectedClass, key: option, onClick: function onClick() {
	                return _this3.handleClick(option);
	              } },
	            option
	          );
	        });
	      }
	    }
	  }, {
	    key: "renderOptionRadios",
	    value: function renderOptionRadios() {
	      var _this4 = this;
	
	      var prompt = this.props.prompt;
	      if (prompt.options) {
	
	        if (prompt.include_free_response && !_.include(prompt.options, 'Other')) {
	          var options = [].concat(_toConsumableArray(prompt.options), ['Other']);
	        } else {
	          var options = [].concat(_toConsumableArray(prompt.options));
	        }
	
	        var animationClass = prompt.style.circle_animation ? 'spin circle' : '';
	
	        return _.map(options, function (option) {
	          if (option == 'Other') {
	            var freeResponse = React.createElement("textarea", { name: "freeResponseAnswer", className: "freeResponseAnswer " + (_this4.state.showFreeResponse ? 'showTextArea' : ''), rows: "2", cols: "20" });
	          }
	          return React.createElement(
	            "span",
	            { key: option },
	            React.createElement("input", {
	              className: "surveyOptionBtn " + animationClass,
	              type: "radio",
	              checked: _.includes(_this4.state.selectedOptions, option),
	              readOnly: true,
	              onClick: function onClick() {
	                return _this4.handleClick(option);
	              },
	              value: option
	            }),
	            " ",
	            React.createElement(
	              "p",
	              { className: "optionLabel" },
	              option
	            ),
	            freeResponse
	          );
	        });
	      }
	    }
	  }, {
	    key: "renderEmbededContentLayout",
	    value: function renderEmbededContentLayout(prompt) {
	      if (this.state.showFreeResponse) {
	        var freeResponse = React.createElement(
	          "form",
	          { onSubmit: this.handleSubmit },
	          React.createElement(
	            "div",
	            { className: "freeResponse" },
	            React.createElement(
	              "div",
	              { className: "freeResponsePrompt" },
	              "Please explain your answer"
	            ),
	            React.createElement("textarea", { name: "freeResponseAnswer", className: "freeResponseAnswer", rows: "2", cols: "20" }),
	            React.createElement(
	              "div",
	              { className: "submitBtn" },
	              React.createElement(
	                "button",
	                { className: "btn btn-primary", type: "submit" },
	                "Submit"
	              )
	            )
	          )
	        );
	      }
	      return React.createElement(
	        "div",
	        { className: "embededContentInner" },
	        React.createElement(Glyphicon, { icon: 'glyphicon glyphicon-comment', className: 'commentIcon' }),
	        React.createElement(
	          "div",
	          { className: "promptBody" },
	          prompt.body
	        ),
	        React.createElement(
	          "div",
	          { className: "promptOptions" },
	          this.renderOptionButtons()
	        ),
	        freeResponse
	      );
	    }
	  }, {
	    key: "toggleSidebar",
	    value: function toggleSidebar(e) {
	      var _this5 = this;
	
	      $wr.nope(e);
	      this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed }, function () {
	        if (_this5.state.sidebarCollapsed == true) {
	          $('.surveyPromptContainer').addClass('hideSidebar').removeClass('showSidebar');
	        } else {
	          $('.surveyPromptContainer').addClass('showSidebar').removeClass('hideSidebar');
	        }
	      });
	    }
	  }, {
	    key: "renderSidebarSurveyLayout",
	    value: function renderSidebarSurveyLayout(prompt) {
	      var arrowIcon = this.state.sidebarCollapsed ? 'glyphicon glyphicon-chevron-left' : 'glyphicon glyphicon-chevron-right';
	      var submitBtn = _.size(this.state.selectedOptions) > 0 ? React.createElement(
	        "button",
	        { type: "submit" },
	        "Submit"
	      ) : '';
	
	      if (this.state.loading && submitBtn !== '') {
	        submitBtn = React.createElement(Spinner, { placeholder: true, scale: 1.2 });
	      }
	
	      return React.createElement(
	        "div",
	        { className: "sidebarSurveyInner " + (this.state.sidebarCollapsed == true ? 'hideSidebar' : 'showSidebar') },
	        React.createElement(
	          "div",
	          { className: "promptBody" },
	          React.createElement(Glyphicon, { icon: arrowIcon, className: "promptBodyArrow arrow", onClick: this.toggleSidebar }),
	          React.createElement(
	            "div",
	            { className: "promptBodyText" },
	            prompt.body,
	            React.createElement(
	              "div",
	              { className: "promptDescription" },
	              prompt.description
	            )
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "promptOptions" },
	          React.createElement(
	            "form",
	            { onSubmit: this.handleSubmit },
	            this.renderOptionRadios(),
	            submitBtn
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderSurveyPrompt",
	    value: function renderSurveyPrompt() {
	      if (!this.state.answered) {
	
	        var prompt = this.props.prompt;
	        var layouts = SurveyPromptConfig.LAYOUTS;
	
	        switch (prompt.layout) {
	          case layouts.EMBEDED_CONTENT:
	            return this.renderEmbededContentLayout(prompt);
	          case layouts.SIDEBAR_SURVEY:
	            return this.renderSidebarSurveyLayout(prompt);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        null,
	        this.renderSurveyPrompt()
	      );
	    }
	  }]);
	
	  return SurveyPromptDisplay;
	}(React.Component);
	
	;
	
	SurveyPromptDisplay.propTypes = StrictPropTypes({
	  admin: PropTypes.object,
	  userID: PropTypes.number,
	  prompt: PropTypes.object,
	  dataPacket: PropTypes.object,
	  onSubmitFeedback: PropTypes.func
	});
	
	module.exports = SurveyPromptDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3751);
	
	var ErrorPage = function (_React$Component) {
		_inherits(ErrorPage, _React$Component);
	
		function ErrorPage(props) {
			_classCallCheck(this, ErrorPage);
	
			var _this = _possibleConstructorReturn(this, (ErrorPage.__proto__ || Object.getPrototypeOf(ErrorPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("error");
			return _this;
		}
	
		_createClass(ErrorPage, [{
			key: "render",
			value: function render() {
				var which = $wr.getURLParameterByName("which") || this.props.which;
				if (which == "authentication") {
					var title = "Account Access Error";
					var description = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Whooo's Reading is temporarily having trouble accessing your account. Please try refreshing the page in a few minutes. If you still experience this error after that, please ",
							React.createElement(
								"a",
								{ href: "https://www.whooosreading.org/contact" },
								"contact us"
							),
							"."
						)
					);
					var imgPath = __webpack_require__(541);
				} else if (which == "overdrawn") {
					var title = "Account Frozen";
					var description = React.createElement(
						"div",
						{ className: "description" },
						React.createElement(
							"p",
							null,
							"Your teacher has gone over their account limits. Your account is frozen until your teacher fixes their roster or upgrades."
						)
					);
					var imgPath = __webpack_require__(1733);
				} else {
					var title = "Unknown Error";
					var description = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Whooo's Reading is temporarily having an unknown error for your account. Please try refreshing the page in a few minutes. If you still experience this error after that, please ",
							React.createElement(
								"a",
								{ href: "https://www.whooosreading.org/contact" },
								"contact us"
							),
							"."
						)
					);
					var imgPath = __webpack_require__(541);
				}
	
				return React.createElement(
					"div",
					{ className: "errorPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							title
						)
					),
					React.createElement(
						"div",
						{ className: "container text-center" },
						React.createElement("img", { src: imgPath }),
						description
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var redirectRefresh = $wr.getURLParameterByName("redirect_refresh");
				if (redirectRefresh == "true" && !window.wr_allowErrorPage) {
					$wr.redirect("/");
				}
			}
		}]);
	
		return ErrorPage;
	}(React.Component);
	
	;
	
	ErrorPage.propTypes = PageStrictPropTypes({
		// optional prop for which type of error page
		which: PropTypes.string
	});
	
	module.exports = ErrorPage;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ProgressBar = __webpack_require__(81);
	var StudentReportModal = __webpack_require__(884);
	var DocumentClient = __webpack_require__(259);
	
	__webpack_require__(3762);
	
	var ProgressDisplay = function (_React$Component) {
		_inherits(ProgressDisplay, _React$Component);
	
		function ProgressDisplay(props) {
			_classCallCheck(this, ProgressDisplay);
	
			var _this = _possibleConstructorReturn(this, (ProgressDisplay.__proto__ || Object.getPrototypeOf(ProgressDisplay)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ProgressDisplay, [{
			key: "showReportModal",
			value: function showReportModal(e) {
				$wr.nope(e);
				if (CurrentUser.isStudent()) {
					this.refs.modal.show();
				} else {
					this.openReport();
				}
			}
		}, {
			key: "openReport",
			value: function openReport() {
				var reportURL = "/student_reports/student_report?student_id=" + this.props.studentID + "&date=" + this.props.reportDate;
	
				DocumentClient.open(reportURL);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.reportDate != null) {
					var reportLink = React.createElement(
						"span",
						null,
						React.createElement(
							"a",
							{ href: "#", className: "fullReportLink",
								onClick: this.showReportModal },
							"View HOOTS Report!"
						),
						React.createElement(StudentReportModal, { ref: "modal", openReport: this.openReport })
					);
				}
	
				var actionLink = React.createElement(
					"a",
					{ href: "#", className: "buttonPrimary", onClick: this.props.onActionClick },
					this.props.actionLabel
				);
	
				var currentValue = this.props.current;
	
				if (currentValue) {
					var displayValue = $wr.numberWithCommas(this.props.current);
				} else {
					var displayValue = 0;
				}
	
				return React.createElement(
					"div",
					{ className: "progressDisplay" },
					React.createElement(
						"p",
						{ className: "timeSpanTitle" },
						this.props.title
					),
					React.createElement(
						"p",
						{ className: "pointsTotal" },
						displayValue,
						"/",
						$wr.numberWithCommas(this.props.total || 0),
						" ",
						this.props.unit
					),
					React.createElement(ProgressBar, { current: this.props.current, total: this.props.total }),
					reportLink,
					actionLink
				);
			}
		}]);
	
		return ProgressDisplay;
	}(React.Component);
	
	ProgressDisplay.propTypes = PageStrictPropTypes({
		title: PropTypes.string.isRequired,
		current: PropTypes.number.isRequired,
		total: PropTypes.number.isRequired,
		unit: PropTypes.string.isRequired,
		reportDate: PropTypes.string,
		studentID: PropTypes.number,
		actionLabel: PropTypes.string,
		onActionClick: PropTypes.func
	});
	
	module.exports = ProgressDisplay;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	var Spinner = __webpack_require__(9);
	
	var ProgressDisplay = __webpack_require__(410);
	var DateSpanSelector = __webpack_require__(116);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3764);
	
	var StudentExpectationsDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			student: RosterSelectors.student({ state: state, id: props.studentID }),
			loadingStudent: RosterSelectors.isLoadingStudents({ state: state, key: props.studentID })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData(startDate, endDate) {
				var query = {};
				if (startDate) {
					query.expectations_progress_start_date = startDate;
				}
				if (endDate) {
					query.expectations_progress_end_date = endDate;
				}
	
				return dispatch(RosterActions.fetchStudent({
					id: props.studentID, query: query,
					embeds: ["student.expectations_progress", "student.prefs", "student.expectations_date_spans"]
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(StudentExpectationsDisplay, _React$Component);
	
		function StudentExpectationsDisplay(props) {
			_classCallCheck(this, StudentExpectationsDisplay);
	
			var _this = _possibleConstructorReturn(this, (StudentExpectationsDisplay.__proto__ || Object.getPrototypeOf(StudentExpectationsDisplay)).call(this));
	
			autobind(_this);
			_this.state = {
				startDate: null, endDate: null
			};
			return _this;
		}
	
		_createClass(StudentExpectationsDisplay, [{
			key: "startDate",
			value: function startDate() {
				var dateSpans = this.props.student.expectations_date_spans;
				return this.state.startDate || dateSpans[0].start;
			}
		}, {
			key: "endDate",
			value: function endDate() {
				var dateSpans = this.props.student.expectations_date_spans;
				return this.state.endDate || dateSpans[0].end;
			}
		}, {
			key: "changeDates",
			value: function changeDates(startDate, endDate) {
				var _this2 = this;
	
				this.setState({ startDate: startDate, endDate: endDate }, function () {
					_this2.props.populateData(startDate, endDate);
				});
			}
		}, {
			key: "isMatchingDateSpan",
			value: function isMatchingDateSpan() {
				var _this3 = this;
	
				if (this.props.student && this.props.student.expectations_date_spans) {
					return _.filter(this.props.student.expectations_date_spans, function (span) {
						return span.start == _this3.startDate() && span.end == _this3.endDate();
					}).length > 0;
				}
				return false;
			}
		}, {
			key: "renderDateSelectors",
			value: function renderDateSelectors() {
				if (this.props.student && this.props.student.expectations_date_spans) {
					var dateSpans = this.props.student.expectations_date_spans;
					return React.createElement(
						"div",
						{ className: "dateSpanSelectorWrap" },
						React.createElement(DateSpanSelector, { startDate: this.startDate(), endDate: this.endDate(),
							expectationsSpans: dateSpans,
							onSelectDates: this.changeDates })
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this4 = this;
	
				var student = this.props.student;
	
				if (this.props.loadingStudent || !student || !student.prefs || !student.expectations_progress || !student.expectations_date_spans) {
	
					var progressDisplay = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (this.isMatchingDateSpan()) {
					var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5;
					var expectations = student.prefs.grade_level_expectations_metrics[grade_level];
					var progress = student.expectations_progress;
	
					var progressDisplay = _.map(expectations, function (expectation) {
						var metric = expectation.metric;
	
						if (_this4.props.onActionClick) {
							var onActionClick = _this4.props.onActionClick.bind(_this4, StudentMetrics.getAction(metric), null);
						}
	
						return React.createElement(ProgressDisplay, { key: metric,
							title: StudentMetrics.getLabel(metric),
							unit: StudentMetrics.getUnit(metric),
							total: expectation.goal,
							current: progress[metric],
							actionLabel: StudentMetrics.getActionLabel(metric),
							onActionClick: onActionClick });
					});
				} else {
					var progress = student.expectations_progress;
					var progressDisplay = _.map(progress, function (amount, metric) {
						return React.createElement(
							"span",
							{ className: "singleStat", key: metric },
							React.createElement(
								"span",
								{ className: "metric" },
								StudentMetrics.getLabel(metric)
							),
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "amount" },
								amount
							)
						);
					});
				}
	
				return React.createElement(
					"div",
					{ className: "studentExpectationsDisplay" },
					this.renderDateSelectors(),
					progressDisplay
				);
			}
		}]);
	
		return StudentExpectationsDisplay;
	}(React.Component)) || _class) || _class);
	;
	
	StudentExpectationsDisplay.WrappedComponent.propTypes = StrictPropTypes({
		studentID: PropTypes.number.isRequired,
		onActionClick: PropTypes.func,
	
		// From @connect
		student: PropTypes.object,
		populateData: PropTypes.func,
		loadingStudent: PropTypes.bool
	});
	
	module.exports = StudentExpectationsDisplay;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var LoadingButton = __webpack_require__(17);
	var Features = __webpack_require__(16);
	var PaywallModal = __webpack_require__(44);
	var Glyphicon = __webpack_require__(8);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3770);
	
	var ClozeCustomizer = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
				return dispatch(RosterActions.updateAllStudentListPrefs({
					currentUserID: CurrentUser.get().id,
					update: prefsUpdate
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ClozeCustomizer, _React$Component);
	
		function ClozeCustomizer(props) {
			_classCallCheck(this, ClozeCustomizer);
	
			var _this = _possibleConstructorReturn(this, (ClozeCustomizer.__proto__ || Object.getPrototypeOf(ClozeCustomizer)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, clozeTestDates: props.prefs.cloze_test_dates,
				changesPending: false
			};
			LuckyOrangeClient.tagComponent("ClozeCustomizer");
			return _this;
		}
	
		_createClass(ClozeCustomizer, [{
			key: "handleSubmit",
			value: function handleSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (!this.clozeAssessmentsEnabled()) {
					this.showPaywall();
				} else {
					this.setState({ loading: true });
	
					var preferenceHash = {
						cloze_test_dates: _.uniq(this.state.clozeTestDates)
					};
					var successText = "You have successfully updated your cloze assessment dates.";
					this.props.onChange(preferenceHash, successText).then(function () {
						_this2.setState({ loading: false, changesPending: false });
					});
				}
			}
		}, {
			key: "clozeAssessmentsEnabled",
			value: function clozeAssessmentsEnabled() {
				return Features.isEnabled(Features.CLOZE_ASSESSMENTS);
			}
		}, {
			key: "showPaywall",
			value: function showPaywall(e) {
				$wr.nope(e);
				this.refs.paywallModal.show();
			}
		}, {
			key: "addTestDateRow",
			value: function addTestDateRow(e) {
				$wr.nope(e);
				this.selectTestDate(this.state.clozeTestDates.length, $wr.momentInTimezone());
			}
		}, {
			key: "removeTestDateRow",
			value: function removeTestDateRow(index) {
				if (!this.clozeAssessmentsEnabled()) {
					this.showPaywall();
	
					// we should never get here because link is disabled if only 1 test date, but just in case
				} else if (this.state.clozeTestDates.length == 1) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: "We need at least one cloze assessment date.",
						icon: "exclamation-sign", type: "error"
					});
				} else {
					var newDatesArray = _.clone(this.state.clozeTestDates);
					newDatesArray.splice(index, 1);
					this.setState({ clozeTestDates: newDatesArray, changesPending: true });
				}
			}
		}, {
			key: "selectTestDate",
			value: function selectTestDate(dateIndex, testDate) {
				if (!this.clozeAssessmentsEnabled()) {
					this.showPaywall();
				} else {
					var newDatesArray = _.clone(this.state.clozeTestDates);
					newDatesArray[dateIndex] = (0, _moment2.default)(testDate).format("YYYY-MM-DD");
					this.setState({ clozeTestDates: newDatesArray, changesPending: true });
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.clozeAssessmentsEnabled()) {
	
					var clozeHeaderContent = React.createElement(
						"p",
						{ className: "clozeInstructions" },
						"Select the dates you want your students to start testing with cloze assessments to get their updated reading levels."
					);
	
					var testDateRows = _.map(this.state.clozeTestDates, function (testDate, index) {
						if (this.state.clozeTestDates.length > 1) {
							var removeRowLink = React.createElement(
								"a",
								{ href: "#", className: "removeRowLink",
									onClick: this.removeTestDateRow.bind(this, index) },
								React.createElement(Glyphicon, { icon: "minus-sign" })
							);
						}
						return React.createElement(
							"div",
							{ key: "testDateRow" + index },
							React.createElement(_reactDatepicker2.default, { className: "testDatePicker",
								onChange: this.selectTestDate.bind(this, index), readOnly: true,
								selected: (0, _moment2.default)(testDate) }),
							removeRowLink
						);
					}.bind(this));
	
					var addRowLink = React.createElement(
						"a",
						{ href: "#", onClick: this.addTestDateRow },
						React.createElement(Glyphicon, { icon: "plus-sign" }),
						" Add Test Date"
					);
	
					if (this.state.changesPending) {
						var saveChangesButton = React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: "Save Changes",
							loading: this.state.loading });
					}
	
					return React.createElement(
						"div",
						{ className: "clozeCustomizerContainer" },
						clozeHeaderContent,
						React.createElement(
							"form",
							{ className: "clozeTestDatesForm", onSubmit: this.handleSubmit },
							testDateRows,
							addRowLink,
							saveChangesButton
						)
					);
				} else {
	
					var paywallModal = React.createElement(PaywallModal, { ref: "paywallModal", featureType: PaywallModal.CLOZE_ASSESSMENTS });
	
					var previewMessage = React.createElement(
						"div",
						{ className: "previewMessage" },
						React.createElement(
							"p",
							{ className: "message" },
							"Use ",
							React.createElement(
								"em",
								null,
								"Reading Level Diagnostics"
							),
							" to automatically assess your students' reading levels."
						),
						React.createElement("img", { onClick: this.showPaywall, className: "previewImage clickableElement",
							src: __webpack_require__(544) }),
						React.createElement(
							"p",
							null,
							React.createElement(
								"a",
								{ href: "#", className: "btn buttonSuccess", onClick: this.showPaywall },
								"Learn More"
							)
						)
					);
	
					return React.createElement(
						"div",
						{ className: "clozeCustomizerContainer" },
						previewMessage,
						paywallModal
					);
				}
			}
		}]);
	
		return ClozeCustomizer;
	}(React.Component)) || _class) || _class);
	
	
	ClozeCustomizer.WrappedComponent.propTypes = StrictPropTypes({
		clozeTestDates: PropTypes.array,
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = ClozeCustomizer;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var LoadingButton = __webpack_require__(17);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdown = __webpack_require__(23);
	var Features = __webpack_require__(16);
	var ValidatingInput = __webpack_require__(91);
	var StudentMetrics = __webpack_require__(29);
	var ErrorDisplay = __webpack_require__(51);
	var OrgTypes = __webpack_require__(45);
	
	var QuizCustomization = __webpack_require__(434);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3772);
	
	var ExpectationsCustomizer = (_dec = (0, _reactRedux.connect)(function (state, props) {
		if (props.student) {
			var prefs = props.student.prefs;
		} else if (props.orgIdentifier) {
			var _OrgTypes$fromIdentif = OrgTypes.fromIdentifier(props.orgIdentifier),
			    type = _OrgTypes$fromIdentif.type,
			    key = _OrgTypes$fromIdentif.key;
	
			if (type === OrgTypes.ALL_STUDENTS) {
				// Use one student lists's prefs as the overall defaults
				var prefs = RosterSelectors.nonEmptyStudentLists({ state: state, id: key })[0].prefs;
			} else if (type === OrgTypes.STUDENT_LIST) {
				var studentList = RosterSelectors.studentList({ state: state, id: key });
				var prefs = studentList.prefs;
			} else if (type === OrgTypes.SUBGROUP) {
				var subgroup = RosterSelectors.subgroup({ state: state, key: key });
	
				// Use one student in the group's prefs as the overall defaults
				var prefs = RosterSelectors.studentsForSubgroupKey({ state: state, subgroupKey: key })[0].prefs;
			}
		}
	
		return {
			studentList: studentList, subgroup: subgroup,
			expectationsMetrics: prefs.expectations_metrics,
			expectationsTimePeriod: prefs.expectations_time_period,
			expectationsTimePeriodStarts: prefs.expectations_time_period_starts,
			recall_question_count: prefs.recall_question_count,
			analysis_question_count: prefs.analysis_question_count,
			sentence_starter_count: prefs.sentence_starter_count,
			schoolYearStartMonth: CurrentUser.get().prefs.school_year_start_month,
			asTeacherAdmin: CurrentUser.isTeacherAdmin()
		};
	}, function (dispatch, props) {
		return {
			onChange: function onChange(update, message) {
				var _OrgTypes$fromIdentif2 = OrgTypes.fromIdentifier(props.orgIdentifier),
				    type = _OrgTypes$fromIdentif2.type,
				    key = _OrgTypes$fromIdentif2.key;
	
				if (message) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Update", text: message, icon: "ok-sign"
					});
				}
	
				if (type === OrgTypes.ALL_STUDENTS) {
					return dispatch(RosterActions.updateAllStudentListPrefs({
						update: update, currentUserID: CurrentUser.get().id, resetStudents: true
					}));
				} else if (type == OrgTypes.STUDENT_LIST) {
					return dispatch(RosterActions.updateStudentListPrefs({
						update: update, studentListID: key, resetStudents: true
					}));
				} else if (type == OrgTypes.SUBGROUP) {
					return dispatch(RosterActions.massUpdateStudentPrefs({
						update: update, subgroupKey: key,
						embeds: ["student.prefs"]
					}));
				}
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ExpectationsCustomizer, _React$Component);
	
		function ExpectationsCustomizer(props) {
			_classCallCheck(this, ExpectationsCustomizer);
	
			var _this = _possibleConstructorReturn(this, (ExpectationsCustomizer.__proto__ || Object.getPrototypeOf(ExpectationsCustomizer)).call(this));
	
			autobind(_this);
	
			// set defaults in onboarding, otherwise do normal checks
			if (props.onboardingDefault) {
				var forceChangesPending = true;
				var existingMetrics = ONBOARDING_DEFAULTS[props.onboardingDefault];
				var timePeriod = "month";
			} else {
				var forceChangesPending = false;
	
				// filter out any expectations the teacher shouldn't have
				var existingMetrics = _.reject(props.expectationsMetrics, function (metricData) {
					return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metricData.metric));
				});
	
				var timePeriod = props.expectationsTimePeriod;
			}
	
			_this.state = {
				loading: false, overGoalLimit: false, changesPending: forceChangesPending,
				expectationsTimePeriod: timePeriod,
				expectationsTimePeriodStarts: props.expectationsTimePeriodStarts,
				expectationsMetrics: existingMetrics, allFrequencies: false,
	
				recallQuestionCount: props.recall_question_count,
				openQuestionCount: props.analysis_question_count + props.sentence_starter_count,
				hasSentenceStarters: props.sentence_starter_count != 0
			};
			return _this;
		}
	
		_createClass(ExpectationsCustomizer, [{
			key: 'validate',
			value: function validate() {
				var isValid = true;
				var currentMetrics = _.pluck(this.state.expectationsMetrics, "metric");
				_.each(currentMetrics, function (metric) {
					isValid = this.refs["goalInput" + metric].validate() && isValid;
				}.bind(this));
	
				if (this.state.recallQuestionCount + this.state.openQuestionCount == 0) {
					this.refs.quizErrors.setError("Select at least one of fill-in-the-blank or open-ended.");
					return false;
				}
	
				return isValid;
			}
		}, {
			key: 'addQuizExpectations',
			value: function addQuizExpectations(preferenceHash) {
				var analysis_question_count = this.state.openQuestionCount;
				// ASSING QUESTION COUNT TO SENTENCE STARTERS IF ON
				if (this.state.hasSentenceStarters) {
					var sentence_starter_count = this.state.openQuestionCount;
					analysis_question_count = 0;
				} else {
					var sentence_starter_count = 0;
				}
	
				var quizExpectations = {
					recall_question_count: this.state.recallQuestionCount,
					analysis_question_count: analysis_question_count,
					sentence_starter_count: sentence_starter_count
				};
				return _.extend(preferenceHash, quizExpectations);
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.refs.quizErrors.reset();
	
				if (!this.validate()) {
					return;
				}
	
				if (this.props.askConfirmation) {
					var confirmMessage = "This will change goals for all your students";
	
					if (this.props.orgIdentifier) {
						var _OrgTypes$fromIdentif3 = OrgTypes.fromIdentifier(this.props.orgIdentifier),
						    type = _OrgTypes$fromIdentif3.type,
						    key = _OrgTypes$fromIdentif3.key;
	
						if (type === OrgTypes.STUDENT_LIST) {
							confirmMessage += " in this class";
						} else if (type === OrgTypes.SUBGROUP) {
							confirmMessage += " in this group";
						}
					}
	
					if (!this.props.asTeacherAdmin) {
						confirmMessage += " and possibly override your teachers' settings";
					}
					confirmMessage += ".";
	
					if (!confirm(confirmMessage)) {
						return;
					}
				}
	
				this.setState({ loading: true, overGoalLimit: false });
	
				var newMetrics = [];
	
				_.each(this.state.expectationsMetrics, function (metricData) {
					if (metricData.goal && metricData.goal > 0) {
						newMetrics.push(_.omit(metricData, "default"));
					}
				});
	
				var preferenceHash = {
					expectations_time_period: this.state.expectationsTimePeriod,
					expectations_time_period_starts: this.state.expectationsTimePeriodStarts,
					expectations_metrics: newMetrics
				};
				preferenceHash = this.addQuizExpectations(preferenceHash);
	
				// simple onChange without notification if part of onboarding
				if (this.props.onboardingDefault) {
					this.props.onChange(preferenceHash);
				} else {
					this.props.onChange(preferenceHash, "You have successfully set your students' goals.", function () {
						_this2.setState({ loading: false, changesPending: false });
						$(window.document).trigger("expectations-updated");
					}).then(function () {
						return _this2.setState({ loading: false });
					});
				}
	
				if (this.props.afterChange) {
					this.props.afterChange(preferenceHash);
				}
			}
	
			//////////////////////////// methods for goalsForm ////////////////////////////
	
		}, {
			key: 'getMetricIndex',
			value: function getMetricIndex(metricType) {
				return _.findIndex(this.state.expectationsMetrics, function (metricHash) {
					return metricHash.metric == metricType;
				});
			}
		}, {
			key: 'getMetric',
			value: function getMetric(metricType) {
				return this.state.expectationsMetrics[this.getMetricIndex(metricType)];
			}
		}, {
			key: 'getMetricGoal',
			value: function getMetricGoal(metricType) {
				return (this.getMetric(metricType) || {}).goal;
			}
		}, {
			key: 'metricSelected',
			value: function metricSelected(metricType) {
				return this.getMetric(metricType) != null;
			}
		}, {
			key: 'toggleGoal',
			value: function toggleGoal(metricType) {
				if (this.metricSelected(metricType)) {
					var newMetrics = _.reject(this.state.expectationsMetrics, function (metricHash) {
						return metricHash.metric == metricType;
					});
				} else if (this.state.expectationsMetrics.length < 4) {
					var newMetrics = _.clone(this.state.expectationsMetrics);
					newMetrics.push({ metric: metricType, goal: DEFAULT_GOALS[metricType] });
				} else {
					this.setState({ overGoalLimit: true });
					return;
				}
				this.setState({ expectationsMetrics: newMetrics, changesPending: true, overGoalLimit: false });
			}
		}, {
			key: 'updateGoalAmount',
			value: function updateGoalAmount(metricType, event) {
				var newMetrics = _.clone(this.state.expectationsMetrics);
				var goalValue = parseInt(event.target.value);
	
				if (this.getMetricIndex(metricType) != -1) {
					newMetrics[this.getMetricIndex(metricType)].goal = goalValue;
				} else {
					newMetrics.push({ metric: metricType, goal: goalValue });
				}
				this.setState({ expectationsMetrics: newMetrics, changesPending: true });
			}
		}, {
			key: 'renderGoalInputForType',
			value: function renderGoalInputForType(goalType) {
	
				if (goalType == StudentMetrics.TYPES.QUIZZES_PASSED) {
					var validators = [ValidatingInput.Validators.NON_NEGATIVE];
				} else {
					var validators = [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.POSITIVE_INTEGER];
				}
	
				var defaultGoal = this.getMetricGoal(goalType) ? this.getMetricGoal(goalType).toString() : "";
	
				return React.createElement(ValidatingInput, { ref: "goalInput" + goalType,
					min: '0',
					type: 'number', inputName: 'This goal',
					defaultValue: defaultGoal,
					validators: validators,
					onChange: this.updateGoalAmount.bind(this, goalType),
					inputClassName: "form-control goalAmountBox goal-" + goalType });
			}
		}, {
			key: 'getQuizExpectationMetrics',
			value: function getQuizExpectationMetrics(goalType) {
	
				switch (goalType) {
					case "recall-questions":
						return this.state.recallQuestionCount;
						break;
					case "analysis-questions":
						return this.state.openQuestionCount;
						break;
					case "sentence-starters":
						return this.state.hasSentenceStarters ? "On" : "Off";
						break;
				}
			}
		}, {
			key: 'updateQuizExpectations',
			value: function updateQuizExpectations(goalType, e) {
	
				switch (goalType) {
					case "recall-questions":
						this.setState({ changesPending: true, recallQuestionCount: parseInt(e.target.value) });
						break;
					case "analysis-questions":
						this.setState({ changesPending: true, openQuestionCount: parseInt(e.target.value) });
						break;
					case "sentence-starters":
						this.setState({ changesPending: true, hasSentenceStarters: e.target.value == "On" });
						break;
				}
			}
		}, {
			key: 'renderPerPeriod',
			value: function renderPerPeriod() {
				return React.createElement(
					'span',
					{ className: 'per' },
					'/',
					this.state.expectationsTimePeriod
				);
			}
		}, {
			key: 'renderQuizGoalSelector',
			value: function renderQuizGoalSelector(goalType) {
				var options = StudentMetrics.getOptions(goalType);
				if (options) {
					var goalInput = React.createElement(
						'select',
						{ type: 'text', className: 'form-control',
							onChange: this.updateQuizExpectations.bind(this, goalType),
							value: this.getQuizExpectationMetrics(goalType) },
						options
					);
				} else {
					var goalInput = this.renderGoalInputForType(goalType);
				}
	
				var className = "formOption";
	
				if (goalType == StudentMetrics.TYPES.QUIZZES_PASSED) {
					var label = "Passing Quiz Goal";
					var perDisplay = this.renderPerPeriod();
					className += " withPer";
				} else if (goalType != StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS) {
					var label = StudentMetrics.getLabel(goalType);
					var perDisplay = React.createElement(
						'span',
						{ className: 'per' },
						'questions'
					);
					className += " withPer";
				} else {
					var label = StudentMetrics.getLabel(goalType);
				}
	
				return React.createElement(
					'div',
					{ className: className, key: goalType },
					React.createElement(
						'label',
						{ className: 'quizLabel' },
						React.createElement(
							'span',
							null,
							label
						)
					),
					React.createElement(
						'span',
						{ className: 'quizInput' },
						goalInput,
						perDisplay
					)
				);
			}
		}, {
			key: 'renderPracticeGoalSelector',
			value: function renderPracticeGoalSelector(goalType) {
				var currentlySelected = this.metricSelected(goalType);
				if (currentlySelected) {
					var goalInput = this.renderGoalInputForType(goalType);
					var perPeriod = this.renderPerPeriod();
				} else if (this.state.expectationsMetrics.length == 4) {
					var maxClassName = "maxGoalsSelected";
				}
	
				return React.createElement(
					'div',
					{ className: 'formOption', key: goalType },
					React.createElement(
						'label',
						{ className: maxClassName },
						React.createElement('input', { type: 'checkbox', checked: currentlySelected,
							onChange: this.toggleGoal.bind(this, goalType) }),
						React.createElement(
							'span',
							null,
							StudentMetrics.getLabel(goalType)
						)
					),
					goalInput,
					perPeriod
				);
			}
		}, {
			key: 'renderQuizDuration',
			value: function renderQuizDuration() {
				var durationText = QuizCustomization.quizDuration(this.state.recallQuestionCount, this.state.openQuestionCount, this.state.hasSentenceStarters);
	
				return React.createElement(
					'div',
					{ className: 'lightGray' },
					'Based on your settings, quizzes should take ',
					durationText,
					' minutes.'
				);
			}
	
			//////////////////////////// end methods for goalsForm ////////////////////////////
	
			//////////////////////////// methods for frequencyForm ////////////////////////////
	
		}, {
			key: 'selectTimePeriod',
			value: function selectTimePeriod(timePeriod) {
				if (timePeriod == $wr.Constants.PERIODS.WEEK) {
					var defaultPeriodStart = [0];
				} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
					var defaultPeriodStart = [1];
				} else {
					var startMonth = this.props.schoolYearStartMonth;
					var currentYear = new Date().getFullYear();
					var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];
	
					if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
					} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
					} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
					}
				}
	
				this.setState({
					expectationsTimePeriod: timePeriod,
					expectationsTimePeriodStarts: defaultPeriodStart,
					changesPending: true
				});
			}
		}, {
			key: 'selectStartOfWeek',
			value: function selectStartOfWeek(day) {
				this.setState({ expectationsTimePeriodStarts: [day], changesPending: true });
			}
		}, {
			key: 'selectStartDate',
			value: function selectStartDate(periodStartPosition, periodStartDate) {
				var newPeriodStartsArray = _.clone(this.state.expectationsTimePeriodStarts);
				newPeriodStartsArray[periodStartPosition] = (0, _moment2.default)(periodStartDate).format("YYYY-MM-DD");
				this.setState({ expectationsTimePeriodStarts: newPeriodStartsArray, changesPending: true });
			}
		}, {
			key: 'renderDatePickerForIndex',
			value: function renderDatePickerForIndex(index) {
				return React.createElement(_reactDatepicker2.default, { className: 'startDatePicker',
					onChange: this.selectStartDate.bind(this, index), readOnly: true,
					selected: (0, _moment2.default)(this.state.expectationsTimePeriodStarts[index]) });
			}
		}, {
			key: 'renderFrequencyStartSelect',
			value: function renderFrequencyStartSelect(frequencyType) {
				var currentPeriodStarts = this.state.expectationsTimePeriodStarts;
	
				if (frequencyType == $wr.Constants.PERIODS.WEEK) {
					var weekdayOptions = DropDownOptions.Button.DaysOfWeek({
						includeWeeklyRange: true,
						buildOptionF: function (day) {
							return this.selectStartOfWeek.bind(this, day);
						}.bind(this)
					});
					var currentWeekdayText = $wr.getDayOfWeek(currentPeriodStarts[0]) + " - " + $wr.getDayOfWeek((currentPeriodStarts[0] + 6) % 7);
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						React.createElement(
							'span',
							{ className: 'periodSelectorLabel' },
							'From:'
						),
						React.createElement(
							ButtonDropdown,
							{ text: currentWeekdayText,
								dropdownDisplay: 'link', className: 'formatControl' },
							weekdayOptions
						)
					);
				} else if (frequencyType == $wr.Constants.PERIODS.QUARTER) {
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						'Quarter 1 Starts:',
						this.renderDatePickerForIndex(0),
						React.createElement('br', null),
						'Quarter 2 Starts:',
						this.renderDatePickerForIndex(1),
						React.createElement('br', null),
						'Quarter 3 Starts:',
						this.renderDatePickerForIndex(2),
						React.createElement('br', null),
						'Quarter 4 Starts:',
						this.renderDatePickerForIndex(3)
					);
				} else if (frequencyType == $wr.Constants.PERIODS.TRIMESTER) {
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						'Trimester 1 Starts:',
						this.renderDatePickerForIndex(0),
						React.createElement('br', null),
						'Trimester 2 Starts:',
						this.renderDatePickerForIndex(1),
						React.createElement('br', null),
						'Trimester 3 Starts:',
						this.renderDatePickerForIndex(2)
					);
				} else if (frequencyType == $wr.Constants.PERIODS.SEMESTER) {
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						'Semester 1 Starts:',
						this.renderDatePickerForIndex(0),
						React.createElement('br', null),
						'Semester 2 Starts:',
						this.renderDatePickerForIndex(1)
					);
				} else if (frequencyType == $wr.Constants.PERIODS.SCHOOL_YEAR) {
					var freqStartSelect = React.createElement(
						'div',
						{ className: 'periodStartSelector' },
						'School Year Starts:',
						this.renderDatePickerForIndex(0)
					);
				} else {
					var freqStartSelect = React.createElement('span', null);
				}
	
				return freqStartSelect;
			}
		}, {
			key: 'renderFrequencySelector',
			value: function renderFrequencySelector(frequencyText, frequencyType) {
				var currentlySelected = this.state.expectationsTimePeriod == frequencyType;
				if (currentlySelected) {
					var startSelect = this.renderFrequencyStartSelect(frequencyType);
				}
				return React.createElement(
					'span',
					{ key: frequencyText },
					React.createElement(
						'label',
						{ className: 'formOption' },
						React.createElement('input', { type: 'radio', checked: currentlySelected,
							onChange: this.selectTimePeriod.bind(this, frequencyType) }),
						React.createElement(
							'span',
							null,
							frequencyText
						)
					),
					startSelect
				);
			}
		}, {
			key: 'expandFrequencies',
			value: function expandFrequencies() {
				this.setState({ allFrequencies: true });
			}
			//////////////////////////// end methods for frequencyForm ////////////////////////////
	
		}, {
			key: 'render',
			value: function render() {
				if (this.props.onboardingDefault == null) {
					if (this.props.studentListID) {}
					var headerContent = React.createElement(
						'p',
						null,
						'Set goals for your students to complete.'
					);
				}
	
				var goalTextClassName = "hintText";
				if (this.state.overGoalLimit) {
					goalTextClassName += " goalError";
				}
	
				if (this.props.onboardingDefault) {
					var practiceActiveMetrics = ONBOARDING_METRICS;
					var practiceMetricSelectors = _.map(practiceActiveMetrics, this.renderPracticeGoalSelector);
				} else {
					var practiceActiveMetrics = _.reject(StudentMetrics.PRACTICE_EXPECTATION_METRICS, function (metric) {
						return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metric));
					});
					var quizActiveMetrics = _.reject(StudentMetrics.QUIZ_EXPECTATION_METRICS, function (metric) {
						return Features.anyDisabled(StudentMetrics.getFeatureDependencies(metric));
					});
					var practiceMetricSelectors = _.map(practiceActiveMetrics, this.renderPracticeGoalSelector);
					var quizMetricSelectors = _.map(quizActiveMetrics, this.renderQuizGoalSelector);
				}
	
				if (this.props.onboardingDefault) {
					var goalsForm = React.createElement(
						'div',
						{ className: 'formColumn' },
						React.createElement(
							'p',
							{ className: goalTextClassName },
							React.createElement(
								'span',
								{ className: 'hintHeader' },
								'Choose up to 2 goals.'
							)
						),
						practiceMetricSelectors
					);
	
					if (this.state.allFrequencies) {
						var frequencyForm = React.createElement(
							'div',
							{ className: 'formColumn' },
							React.createElement(
								'p',
								{ className: 'hintText' },
								React.createElement(
									'span',
									{ className: 'hintHeader' },
									'Choose a time period.'
								)
							),
							this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK),
							this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH),
							this.renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER),
							this.renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER),
							this.renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER),
							this.renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR)
						);
					} else {
						var frequencyForm = React.createElement(
							'div',
							{ className: 'formColumn' },
							React.createElement(
								'p',
								{ className: 'hintText' },
								React.createElement(
									'span',
									{ className: 'hintHeader' },
									'Choose a time period.'
								)
							),
							this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK),
							this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH),
							React.createElement(
								'a',
								{ className: 'moreOptionsLink', href: '#', onClick: this.expandFrequencies },
								'More Options'
							)
						);
					}
				} else {
					// not during onboarding, still split on whether it's the assignment split test
	
					var quizGoalsForm = React.createElement(
						'div',
						{ className: 'quizFormColumn' },
						React.createElement(
							'p',
							{ className: goalTextClassName },
							React.createElement(
								'span',
								{ className: 'hintHeader' },
								'Customize quizzes:'
							),
							this.renderQuizDuration(),
							React.createElement(ErrorDisplay, { ref: 'quizErrors' })
						),
						quizMetricSelectors
					);
	
					var practiceGoalsForm = React.createElement(
						'div',
						{ className: 'quizFormColumn' },
						React.createElement(
							'p',
							{ className: goalTextClassName },
							React.createElement(
								'span',
								{ className: 'hintHeader' },
								'Customize supplemental tasks:'
							),
							React.createElement('br', null),
							React.createElement(
								'span',
								{ className: 'lightGray' },
								'(select up to 3)'
							)
						),
						practiceMetricSelectors
					);
	
					var frequencyForm = React.createElement(
						'div',
						{ className: 'quizFormColumn' },
						React.createElement(
							'p',
							{ className: 'hintText' },
							React.createElement(
								'span',
								{ className: 'hintHeader' },
								'Choose a time period:'
							)
						),
						this.renderFrequencySelector("Weekly", $wr.Constants.PERIODS.WEEK),
						this.renderFrequencySelector("Monthly", $wr.Constants.PERIODS.MONTH),
						this.renderFrequencySelector("Quarterly", $wr.Constants.PERIODS.QUARTER),
						this.renderFrequencySelector("Trimester", $wr.Constants.PERIODS.TRIMESTER),
						this.renderFrequencySelector("Semester", $wr.Constants.PERIODS.SEMESTER),
						this.renderFrequencySelector("School Year", $wr.Constants.PERIODS.SCHOOL_YEAR)
					);
				}
	
				if (this.state.changesPending) {
					var buttonClassName = "center-block saveExpectationsButton";
					if (this.props.onboardingDefault) {
						buttonClassName += " buttonPrimary";
					} else {
						buttonClassName += " buttonSuccess";
					}
					var saveChangesButton = React.createElement(LoadingButton, { className: buttonClassName, text: 'Save Goals',
						loading: this.state.loading });
				}
				return React.createElement(
					'div',
					{ className: 'expectationsCustomizerContainer' },
					headerContent,
					React.createElement(
						'form',
						{ className: 'expectationsForm', onSubmit: this.handleSubmit },
						React.createElement(
							'div',
							{ className: 'row' },
							React.createElement(
								'div',
								{ className: 'col-sm-6' },
								quizGoalsForm,
								practiceGoalsForm
							),
							React.createElement(
								'div',
								{ className: 'col-sm-6 freqCol' },
								frequencyForm
							)
						),
						React.createElement(
							'div',
							{ className: 'text-center' },
							saveChangesButton
						)
					)
				);
			}
		}]);
	
		return ExpectationsCustomizer;
	}(React.Component)) || _class);
	
	
	ExpectationsCustomizer.WrappedComponent.propTypes = StrictPropTypes({
		onboardingDefault: PropTypes.string,
		orgIdentifier: PropTypes.string,
		askConfirmation: PropTypes.bool,
		afterChange: PropTypes.func,
	
		// Data from @connect
		studentList: PropTypes.object,
		subgroup: PropTypes.object,
		expectationsMetrics: PropTypes.array,
		expectationsTimePeriod: PropTypes.string,
		expectationsTimePeriodStarts: PropTypes.array,
		schoolYearStartMonth: PropTypes.number,
		asTeacherAdmin: PropTypes.bool,
	
		// Handlers from @connect
		onChange: PropTypes.func.isRequired,
	
		recall_question_count: PropTypes.number.isRequired,
		analysis_question_count: PropTypes.number.isRequired,
		sentence_starter_count: PropTypes.number.isRequired
	});
	
	var DEFAULT_GOALS = {
		"quizzes-passed": 3,
		"questions": 4,
		"reviews": 4,
		"exercises": 2,
		"question-builder": 2,
		"minutes": 100,
		"pages": 100,
		"days-active": 10,
		"points": 10
	};
	
	var ONBOARDING_METRICS = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS, StudentMetrics.TYPES.DAYS_ACTIVE];
	
	var ONBOARDING_DEFAULTS = {
		"check-comprehension": [{ "goal": 1, "metric": "quizzes-passed" }, { "goal": 2, "metric": "questions" }, { "goal": 1, "metric": "reviews" }],
		"writing-practice": [{ "goal": 1, "metric": "quizzes-passed" }, { "goal": 4, "metric": "questions" }],
		"reading-motivation": [{ "goal": 2, "metric": "reviews" }, { "goal": 2, "metric": "questions" }]
	};
	
	module.exports = ExpectationsCustomizer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebinarRegistration = __webpack_require__(407);
	
	__webpack_require__(3776);
	
	var PaywallLink = function (_React$Component) {
		_inherits(PaywallLink, _React$Component);
	
		function PaywallLink(props) {
			_classCallCheck(this, PaywallLink);
	
			var _this = _possibleConstructorReturn(this, (PaywallLink.__proto__ || Object.getPrototypeOf(PaywallLink)).call(this));
	
			autobind(_this);
	
			_this.state = { showWebinarReg: false };
			return _this;
		}
	
		_createClass(PaywallLink, [{
			key: "showWebinarRegistration",
			value: function showWebinarRegistration() {
				this.setState({ showWebinarReg: true });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.featureLocation == PaywallLink.STUDENT_ROSTER) {
					if (this.state.showWebinarReg) {
						var webinarRegistrationDisplay = React.createElement(WebinarRegistration, { sourceFeature: this.props.featureLocation });
					} else {
						var paywallText =
						//<p className="paywallText studentRosterPaywall">
						// Want more differentiation? With <i>Whooo's Reading School</i>, 
						// access your students' reading levels and get questions customized to their levels.
						// Chat with us and see if <i>Whooo's Reading School</i> is a good fit for your school.
						//</p>
						React.createElement(
							"p",
							{ className: "paywallText studentRosterPaywall" },
							"Want to learn more about ",
							React.createElement(
								"i",
								null,
								"Whooo's Reading"
							),
							"? Attend one of our webinars to learn how you and your students can use ",
							React.createElement(
								"i",
								null,
								"Whooo's Reading"
							),
							" as effectively as possible."
						);
						var buttonClass = "buttonDefault";
						var containerClass = "studentRosterBlurb";
						var ctaButton = React.createElement(
							"a",
							{ className: buttonClass + " btn paywallLinkButton", onClick: this.showWebinarRegistration },
							"Reserve a Webinar Spot"
						);
					}
				} else if (this.props.featureLocation == PaywallLink.INSIGHTS) {
					var paywallText = React.createElement(
						"p",
						{ className: "paywallText insightsPaywall" },
						"Want to see your students' strengths and learning gaps for your state's standards? Chat with us and see if ",
						React.createElement(
							"i",
							null,
							"Whooo's Reading School"
						),
						" is a good fit for your school."
					);
					var buttonClass = "buttonSuccess insightsPaywallBtn";
					var linkEventHandler = Mycroft.buildEventHandler({
						category: "Paywall", action: "schedule-consultation", label: this.props.featureLocation
					});
					var ctaButton = React.createElement(
						"a",
						{ href: "https://calendly.com/whooos-reading/wrs-consultation",
							className: buttonClass + " btn paywallLinkButton", target: "_blank", onClick: linkEventHandler },
						"Schedule My Consultation"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "paywallBlurbContainer " + containerClass },
					paywallText,
					ctaButton,
					webinarRegistrationDisplay
				);
			}
		}]);
	
		return PaywallLink;
	}(React.Component);
	
	PaywallLink.propTypes = StrictPropTypes({
		featureLocation: PropTypes.string
	});
	
	PaywallLink.STUDENT_ROSTER = "student-roster-page";
	PaywallLink.INSIGHTS = "insights-page";
	
	module.exports = PaywallLink;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var ProgressBar = __webpack_require__(81);
	
	var OnboardingStageGenericGradeLevel = __webpack_require__(899);
	var OnboardingStageSelectStandards = __webpack_require__(902);
	var OnboardingStageGenericCompletion = __webpack_require__(898);
	
	var OnboardingStageSetAssignments = __webpack_require__(416);
	var OnboardingStageSelectFeatures = __webpack_require__(900);
	var OnboardingStageSelectQuizFormat = __webpack_require__(901);
	var OnboardingStageSetAssignments = __webpack_require__(416);
	
	var OnboardingStageCustomizeQuiz = __webpack_require__(897);
	var OnboardingStageAutograderDemo = __webpack_require__(896);
	
	__webpack_require__(3775);
	
	var OnboardingModal = function (_React$Component) {
		_inherits(OnboardingModal, _React$Component);
	
		function OnboardingModal(props) {
			_classCallCheck(this, OnboardingModal);
	
			var _this = _possibleConstructorReturn(this, (OnboardingModal.__proto__ || Object.getPrototypeOf(OnboardingModal)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("OnboardingModal");
			_this.state = {
				stageIndex: 0, persistentData: {}
			};
			return _this;
		}
	
		_createClass(OnboardingModal, [{
			key: "getCurrentTrack",
			value: function getCurrentTrack() {
				if (this.props.track == "quiz-customization") {
					if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-modal")) {
						var quiz_customization_track = [].concat(_toConsumableArray(OnboardingModal.QUIZ_CUSTOMIZATION_TRACK));
						quiz_customization_track.splice(3, 0, OnboardingModal.AUTOGRADER_DEMO);
						return quiz_customization_track;
					} else {
						return OnboardingModal.QUIZ_CUSTOMIZATION_TRACK;
					}
				} else {
					return OnboardingModal.CONTROL_TRACK;
				}
			}
		}, {
			key: "getStageCount",
			value: function getStageCount() {
				return this.getCurrentTrack().length;
			}
		}, {
			key: "getCurrentStageData",
			value: function getCurrentStageData() {
				return this.getCurrentTrack()[this.state.stageIndex];
			}
		}, {
			key: "getStageTitle",
			value: function getStageTitle() {
				var currentStageData = this.getCurrentStageData();
				return currentStageData.title;
			}
		}, {
			key: "advanceStage",
			value: function advanceStage(newPersistentData) {
				var newStageIndex = this.state.stageIndex + 1;
	
				if (newPersistentData) {
					var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
				} else {
					var updatedPersistentData = this.state.persistentData;
				}
				this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, function () {
					var currentStageData = this.getCurrentStageData();
	
					Mycroft.newEvent({ category: "Onboarding", action: "stage-started", value: currentStageData.name });
	
					if (currentStageData.isComplete) {
						// Mark onboarding complete
						var adminID = CurrentUser.get().id;
						var adminData = { pending_onboarding: false };
						CurrentUser.api().patchAdmin(adminID, { admin: adminData }, $wr.apiHandler(function (response) {}));
					}
				}.bind(this));
			}
		}, {
			key: "endOnboarding",
			value: function endOnboarding(e) {
				$wr.nope(e);
				this.refs.modal.hide();
			}
		}, {
			key: "onModalClose",
			value: function onModalClose() {
				$(window.document).trigger("expectations-updated");
			}
		}, {
			key: "logOut",
			value: function logOut(e) {
				$wr.nope(e);
				CurrentUser.logOut();
				window.location = WhooosReadingServices.OuterPages.url("/");
			}
		}, {
			key: "render",
			value: function render() {
				var currentStageData = this.getCurrentStageData();
	
				var logOutLink = React.createElement(
					"a",
					{ href: "#", className: "logOutLink", onClick: this.logOut },
					"Log Out"
				);
	
				return React.createElement(
					Modal,
					{ className: "onboardingModal", preventHide: this.state.stageIndex == 0,
						onHide: this.onModalClose, ref: "modal" },
					React.createElement(
						"a",
						{ href: "#", className: "logOutLink", onClick: this.logOut },
						"Log Out"
					),
					React.createElement(
						"div",
						{ className: "onboardingProgressSection" },
						React.createElement(
							"p",
							{ className: "onboardingTitle" },
							this.getStageTitle()
						),
						React.createElement(ProgressBar, { current: this.state.stageIndex, total: this.getStageCount() - 1 })
					),
					React.createElement(currentStageData.component, { track: this.props.track,
						persistentData: this.state.persistentData,
						endOnboarding: this.endOnboarding, onComplete: this.advanceStage })
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.refs.modal.show();
				Mycroft.newEvent({ category: "Onboarding", action: "track-started", value: this.props.track });
			}
		}]);
	
		return OnboardingModal;
	}(React.Component);
	
	OnboardingModal.propTypes = StrictPropTypes({
		track: PropTypes.string
	});
	
	// List of Tracks:
	OnboardingModal.CONTROL_TRACK = [{
		name: "control-grade-level",
		title: "Hold your students accountable for reading",
		component: OnboardingStageGenericGradeLevel
	}, {
		name: "control-select-standards",
		title: "Hold your students accountable for reading",
		component: OnboardingStageSelectStandards
	}, {
		name: "control-completion",
		title: "Congratulations, you're all set!",
		component: OnboardingStageGenericCompletion,
		isComplete: true
	}];
	
	OnboardingModal.QUIZ_CUSTOMIZATION_TRACK = [{
		name: "control-grade-level",
		title: "Hold your students accountable for reading",
		component: OnboardingStageGenericGradeLevel
	}, {
		name: "control-select-standards",
		title: "Hold your students accountable for reading",
		component: OnboardingStageSelectStandards
	}, {
		name: "control-quiz-customization",
		title: "Set your expectations",
		component: OnboardingStageCustomizeQuiz
	}, {
		name: "control-completion",
		title: "Congratulations, you're all set!",
		component: OnboardingStageGenericCompletion,
		isComplete: true
	}];
	
	OnboardingModal.AUTOGRADER_DEMO = {
		name: "control-autograder-demo",
		title: "Try Our Autograder",
		component: OnboardingStageAutograderDemo
	};
	
	module.exports = OnboardingModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpectationsCustomizer = __webpack_require__(413);
	
	var OnboardingStageSetAssignments = function (_React$Component) {
		_inherits(OnboardingStageSetAssignments, _React$Component);
	
		function OnboardingStageSetAssignments(props) {
			_classCallCheck(this, OnboardingStageSetAssignments);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageSetAssignments.__proto__ || Object.getPrototypeOf(OnboardingStageSetAssignments)).call(this));
	
			autobind(_this);
			_this.state = {
				selectedGoal: null
			};
			return _this;
		}
	
		_createClass(OnboardingStageSetAssignments, [{
			key: "toggleGoal",
			value: function toggleGoal(goalKey) {
				this.setState({ selectedGoal: goalKey });
			}
		}, {
			key: "afterSubmit",
			value: function afterSubmit(preferenceHash) {
				this.props.onComplete({ selectedGoal: this.state.selectedGoal });
				Mycroft.newEvent({ category: "Onboarding", action: "goal-selected", label: this.state.selectedGoal });
			}
		}, {
			key: "goalDescription",
			value: function goalDescription(goalKey) {
				if (goalKey == COMPREHENSION) {
					return "I need an easy way to check my students' comprehension.";
				} else if (goalKey == WRITING) {
					return "I need help improving my students' writing skills.";
				} else if (goalKey == MOTIVATION) {
					return "I need help motivating my students to read more.";
				}
			}
		}, {
			key: "renderGoalOption",
			value: function renderGoalOption(goalKey) {
				var className = "largeObject clickableElement";
				if (this.state.selectedGoal == goalKey) {
					className += " selectedGoal";
				}
	
				return React.createElement(
					"div",
					{ className: className, key: goalKey,
						onClick: this.toggleGoal.bind(this, goalKey) },
					React.createElement(
						"div",
						{ className: "goalObjectContent" },
						this.goalDescription(goalKey)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var goalObjects = _.map(GOAL_OPTIONS, function (goalKey) {
					return _this2.renderGoalOption(goalKey);
				});
				var goalOptions = React.createElement(
					"div",
					{ className: "goalOptions" },
					goalObjects
				);
	
				var goalQuestion = React.createElement(
					"div",
					{ className: "singleCol" },
					React.createElement(
						"p",
						{ className: "onboardingGreeting" },
						"What is the main reason you need Whooo's Reading?"
					)
				);
	
				if (this.state.selectedGoal) {
					var assignmentCustomizer = React.createElement(ExpectationsCustomizer, { key: this.state.selectedGoal,
						afterChange: this.afterSubmit,
						onboardingDefault: this.state.selectedGoal });
				} else {
					// Render this early, so it can finish loading, but hide it
					var assignmentCustomizer = React.createElement(
						"div",
						{ style: { display: "none" } },
						React.createElement(ExpectationsCustomizer, { key: "preloader",
							afterChange: this.afterSubmit,
							onboardingDefault: this.state.selectedGoal })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageSetAssignments clearfix" },
					goalQuestion,
					goalOptions,
					assignmentCustomizer
				);
			}
		}]);
	
		return OnboardingStageSetAssignments;
	}(React.Component);
	
	var COMPREHENSION = "check-comprehension";
	var WRITING = "writing-practice";
	var MOTIVATION = "reading-motivation";
	
	var GOAL_OPTIONS = [COMPREHENSION, WRITING, MOTIVATION];
	
	OnboardingStageSetAssignments.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageSetAssignments;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = __webpack_require__(16);
	var AccountPlans = __webpack_require__(53);
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3784);
	
	var TrialStatusDisplay = function (_React$Component) {
		_inherits(TrialStatusDisplay, _React$Component);
	
		function TrialStatusDisplay(props) {
			_classCallCheck(this, TrialStatusDisplay);
	
			var _this = _possibleConstructorReturn(this, (TrialStatusDisplay.__proto__ || Object.getPrototypeOf(TrialStatusDisplay)).call(this));
	
			autobind(_this);
	
			_this.state = { expanded: false };
			return _this;
		}
	
		_createClass(TrialStatusDisplay, [{
			key: "renderTrialBox",
			value: function renderTrialBox(trialKey, endDate) {
				var daysLeft = Math.ceil(((0, _moment2.default)(endDate, "YYYY-MM-DD") - (0, _moment2.default)()) / MS_PER_DAY);
				var daysWord = $wr.pluralize("day", daysLeft);
	
				if (daysLeft <= -1) {
					var expired = true;
					var daysLeftDisplay = React.createElement(
						"strong",
						null,
						"This trial has ended"
					);
				} else {
					var expired = false;
					var daysLeftDisplay = React.createElement(
						"strong",
						null,
						daysLeft,
						" ",
						daysWord,
						" left",
						" "
					);
				}
	
				if (this.isProductTrial(trialKey)) {
					var pricingLink = WhooosReadingServices.OuterPages.url("/pricing");
	
					if (trialKey == AccountPlans.PRODUCTS.WR_SILVER) {
						var trialBenefits = " like writing data, student differentiation, and reading logs.";
					} else {
						var trialBenefits = ".";
					}
	
					if (expired) {
						var lowerLeftContent = React.createElement(
							"p",
							null,
							React.createElement(
								_reactRouterDom.Link,
								{ to: this.getUpgradePath(trialKey) },
								"Upgrade now"
							),
							" to get ",
							this.getTrialName(trialKey),
							"."
						);
	
						var rightContent = React.createElement(
							"p",
							null,
							React.createElement(
								"a",
								{ href: this.getCalendlyURL(trialKey), target: "_blank" },
								"Schedule a consultation"
							),
							" to learn more about ",
							" ",
							React.createElement(
								"em",
								null,
								this.getTrialName(trialKey)
							),
							"."
						);
					} else {
						var lowerLeftContent = React.createElement(
							"span",
							null,
							React.createElement(
								"a",
								{ href: pricingLink, target: "_blank" },
								"Learn more about Whooo's Reading plans"
							),
							"."
						);
						var rightContent = React.createElement(
							"p",
							null,
							React.createElement(
								_reactRouterDom.Link,
								{ to: this.getUpgradePath(trialKey) },
								"Upgrade now to keep ",
								this.getTrialName(trialKey),
								" features"
							),
							trialBenefits
						);
					}
				} else {
					if (!expired) {
						var lowerLeftContent = React.createElement(
							"span",
							null,
							React.createElement(
								"a",
								{ href: this.getLeftURL(trialKey), target: "_blank" },
								"Learn how to use this feature"
							),
							"."
						);
					}
					var rightContent = React.createElement(
						"p",
						null,
						React.createElement(
							"a",
							{ href: this.getCalendlyURL(trialKey), target: "_blank" },
							"Schedule a consultation"
						),
						" to learn about how to keep",
						" ",
						React.createElement(
							"em",
							null,
							this.getTrialName(trialKey)
						),
						" ",
						"and other premium ",
						React.createElement(
							"em",
							null,
							"Whooo's Reading"
						),
						" features."
					);
				}
	
				return React.createElement(
					"div",
					{ className: "trialBox hideOnPrint", key: trialKey },
					React.createElement(
						"div",
						{ className: "imageBox" },
						React.createElement("img", { src: __webpack_require__(506) })
					),
					React.createElement(
						"div",
						{ className: "statusBox" },
						React.createElement(
							"p",
							null,
							React.createElement(
								"em",
								null,
								this.getTrialName(trialKey),
								" Trial "
							),
							":",
							" ",
							daysLeftDisplay,
							" ",
							React.createElement("br", null),
							lowerLeftContent
						)
					),
					React.createElement("div", { className: "divider" }),
					React.createElement(
						"div",
						{ className: "consultationBox" },
						rightContent
					)
				);
			}
		}, {
			key: "onExpand",
			value: function onExpand(e) {
				$wr.nope(e);
				this.setState({ expanded: true });
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var sortedPairs = _.select(_.sortBy(_.pairs(this.props.trials), _.last), function (pair) {
					var endDate = pair[1];
					var daysLeft = Math.ceil(((0, _moment2.default)(endDate, "YYYY-MM-DD") - (0, _moment2.default)()) / MS_PER_DAY);
	
					if (daysLeft >= -14) {
						return _this2.isTrialFeature(pair[0]);
					}
				});
	
				if (sortedPairs.length > 1 && !this.state.expanded) {
					var expandLink = React.createElement(
						"div",
						{ className: "expandLinkLine" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.onExpand },
							"+ ",
							sortedPairs.length - 1,
							" more (expand)"
						)
					);
					sortedPairs = [sortedPairs[0]];
				}
	
				var trialBoxes = _.map(sortedPairs, function (pair) {
					var endDate = pair[1];
					var daysLeft = Math.ceil(((0, _moment2.default)(endDate, "YYYY-MM-DD") - (0, _moment2.default)()) / MS_PER_DAY);
	
					if (daysLeft >= -14) {
						return _this2.renderTrialBox(pair[0], pair[1]);
					} else {
						console.log("Nope");
						return;
					}
				});
	
				return React.createElement(
					"div",
					{ className: "trialStatusDisplay" },
					trialBoxes,
					expandLink
				);
			}
		}, {
			key: "isProductTrial",
			value: function isProductTrial(key) {
				return key == AccountPlans.PRODUCTS.WR_SILVER || key == AccountPlans.PRODUCTS.WR_GOLD;
			}
		}, {
			key: "getTrialName",
			value: function getTrialName(key) {
				switch (key) {
					case Features.DIGITAL_EXERCISES:
						return "Insights and Exercises";
					case Features.LOG_READING:
						return "Log Reading";
					case Features.TEACHER_COMMENTS:
						return "Quiz Details and Comments";
					case Features.CLOZE_ASSESSMENTS:
						return "Reading Level Diagnostics";
					case AccountPlans.PRODUCTS.WR_SILVER:
						return "WR Silver";
					case AccountPlans.PRODUCTS.WR_GOLD:
						return "WR Gold";
				}
			}
		}, {
			key: "isTrialFeature",
			value: function isTrialFeature(key) {
				return _.includes([Features.DIGITAL_EXERCISES, Features.LOG_READING, Features.TEACHER_COMMENTS, Features.CLOZE_ASSESSMENTS, AccountPlans.PRODUCTS.WR_SILVER, AccountPlans.PRODUCTS.WR_GOLD], key);
			}
		}, {
			key: "getLeftURL",
			value: function getLeftURL(key) {
				switch (key) {
					case Features.DIGITAL_EXERCISES:
						return "https://whooosreading.zendesk.com/hc/en-us/articles/115001793392-Exercises";
					case Features.LOG_READING:
						return "https://whooosreading.zendesk.com/hc/en-us/articles/115001537272-Logging-Reading";
					case (Features.AUTOGRADER_DATA, Features.TEACHER_COMMENTS):
						return "https://whooosreading.zendesk.com/hc/en-us/articles/115001803091-Teacher-Commenting";
					case Features.CLOZE_ASSESSMENTS:
						return "https://docs.google.com/document/d/1hLPN9Q6MVQhv84DOxXVQgoLjvIOSbrMucwWdumc08WA";
					case AccountPlans.PRODUCTS.WR_SILVER:
					case AccountPlans.PRODUCTS.WR_GOLD:
						return "https://www.whooosreading.org/pricing";
				}
			}
		}, {
			key: "getCalendlyURL",
			value: function getCalendlyURL(key) {
				switch (key) {
					case Features.CLOZE_ASSESSMENTS:
						return "https://calendly.com/whooos-reading/reading-level-diagnostics";
					default:
						return "https://calendly.com/whooos-reading/wrs-consultation";
				}
			}
		}, {
			key: "getUpgradePath",
			value: function getUpgradePath(key) {
				switch (key) {
					case AccountPlans.PRODUCTS.WR_SILVER:
						return "/upgrade?plan=silver";
					case AccountPlans.PRODUCTS.WR_GOLD:
						return "/upgrade?plan=gold";
				}
			}
		}]);
	
		return TrialStatusDisplay;
	}(React.Component);
	
	var MS_PER_DAY = 60 * 60 * 24 * 1000;
	
	TrialStatusDisplay.propTypes = StrictPropTypes({
		trials: PropTypes.object.isRequired
	});
	
	module.exports = TrialStatusDisplay;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectOptions = __webpack_require__(935);
	
	__webpack_require__(3789);
	
	var AutoSubmitTextArea = function (_React$Component) {
		_inherits(AutoSubmitTextArea, _React$Component);
	
		function AutoSubmitTextArea(props) {
			_classCallCheck(this, AutoSubmitTextArea);
	
			var _this = _possibleConstructorReturn(this, (AutoSubmitTextArea.__proto__ || Object.getPrototypeOf(AutoSubmitTextArea)).call(this));
	
			autobind(_this);
			var value = props.defaultValue || (props.numbersOnly ? undefined : "");
			_this.state = { value: value };
			return _this;
		}
	
		_createClass(AutoSubmitTextArea, [{
			key: "onChange",
			value: function onChange(event) {
				this.setState({ value: event.target.value });
			}
		}, {
			key: "selectPrefill",
			value: function selectPrefill(option) {
				var _this2 = this;
	
				this.setState({ value: option.label });
	
				setTimeout(function () {
					_this2.checkShowEnterLine();
				}, 50);
			}
		}, {
			key: "onKeyDown",
			value: function onKeyDown(e) {
				if (e.keyCode == 13) {
					$wr.nope(e);
					this.props.onSubmit(e);
				}
			}
		}, {
			key: "checkShowEnterLine",
			value: function checkShowEnterLine(e) {
				var text = this.text();
				var $line = $(this.refs.enterLine);
	
				if (text.length == 0) {
					$line.addClass("hideLine");
				} else {
					$line.removeClass("hideLine");
				}
			}
		}, {
			key: "focus",
			value: function focus() {
				if (this.props.numbersOnly) {
					this.refs.numberInput.refs.textfield.focus();
				} else {
					this.refs.textarea.focus();
				}
			}
		}, {
			key: "text",
			value: function text() {
				return this.state.value;
			}
		}, {
			key: "setText",
			value: function setText(text) {
				this.setState({ value: text });
			}
		}, {
			key: "reset",
			value: function reset() {
				this.setState({ value: "" });
			}
		}, {
			key: "render",
			value: function render() {
				var link;
				if (this.props.submitLink) {
					link = React.createElement(
						"p",
						{ ref: "enterLine" },
						React.createElement(
							"a",
							{ href: "#", onMouseDown: this.props.onSubmit, onClick: $wr.preventDefaultBehavior },
							"Press enter"
						),
						" to submit."
					);
				}
	
				var inputProps = _.omit(this.props, "numbersOnly", "submitLink", "onSubmit", "prefillOptions");
	
				if (this.props.numbersOnly) {
					var input = React.createElement(NumbersOnlyInput, _extends({}, inputProps, { value: this.state.value, onKeyDown: this.onKeyDown,
						onChange: this.onChange, onKeyUp: this.checkShowEnterLine, ref: "numberInput" }));
				} else {
					var input = React.createElement("textarea", _extends({}, inputProps, { value: this.state.value, onKeyDown: this.onKeyDown,
						onChange: this.onChange, onKeyUp: this.checkShowEnterLine, ref: "textarea" }));
				}
	
				if (this.props.prefillOptions) {
	
					var prefillSelect = React.createElement(SelectOptions, { onSelect: this.selectPrefill, value: this.state.value,
						options: this.props.prefillOptions, hideFullMatch: true });
				}
	
				return React.createElement(
					"div",
					{ className: "autoSubmitTextArea" },
					input,
					prefillSelect,
					link
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.checkShowEnterLine();
			}
		}]);
	
		return AutoSubmitTextArea;
	}(React.Component);
	
	;
	
	AutoSubmitTextArea.propTypes = StrictPropTypes({
		// If true, only allow numbers to be typed
		numbersOnly: PropTypes.bool,
	
		// If true, show a link to allow submitting
		submitLink: PropTypes.bool,
	
		// Function to call after enter is pressed or submit link is clicked
		onSubmit: PropTypes.func,
	
		// Class passed through to input/textarea
		className: PropTypes.string,
	
		// Value text passed through to input/textarea
		defaultValue: PropTypes.string,
	
		// Placeholder text passed through to input/textarea
		placeholder: PropTypes.string,
	
		// A collection of options 
		prefillOptions: PropTypes.array,
	
		// Also passed through to input/textaread
		onFocus: PropTypes.func,
		onBlur: PropTypes.func
	
	});
	
	module.exports = AutoSubmitTextArea;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3793);
	
	var Carousel = function (_React$Component) {
		_inherits(Carousel, _React$Component);
	
		function Carousel(props) {
			_classCallCheck(this, Carousel);
	
			var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this));
	
			autobind(_this);
			_this.state = { displayIndex: 0 };
			return _this;
		}
	
		_createClass(Carousel, [{
			key: "displayPrevious",
			value: function displayPrevious(e) {
				$wr.nope(e);
				var newIndex = this.state.displayIndex - 1;
				if (newIndex == -1) {
					newIndex = this.props.displayItems.length - 1;
				}
				this.setState({ displayIndex: newIndex }, this.onChange.bind(this));
			}
		}, {
			key: "displayNext",
			value: function displayNext(e) {
				$wr.nope(e);
				var newIndex = this.state.displayIndex + 1;
				if (newIndex == this.props.displayItems.length) {
					newIndex = 0;
				}
				this.setState({ displayIndex: newIndex }, this.onChange.bind(this));
			}
		}, {
			key: "onChange",
			value: function onChange() {
				if (this.props.onIndexChange) {
					this.props.onIndexChange(this.state.displayIndex);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var leftArrowPath = __webpack_require__(507);
				var leftArrow = React.createElement("img", { src: leftArrowPath, onClick: this.displayPrevious, className: "leftArrow" });
				var rightArrowPath = __webpack_require__(508);
				var rightArrow = React.createElement("img", { src: rightArrowPath, onClick: this.displayNext, className: "rightArrow" });
				return React.createElement(
					"div",
					{ className: "carousel" },
					leftArrow,
					rightArrow,
					React.createElement(
						"div",
						{ className: "displayContent" },
						this.props.displayItems[this.state.displayIndex]
					)
				);
			}
		}]);
	
		return Carousel;
	}(React.Component);
	
	;
	
	Carousel.propTypes = StrictPropTypes({
		// array of display objects to show in carousel
		displayItems: PropTypes.array.isRequired,
		onIndexChange: PropTypes.func
	
	});
	
	module.exports = Carousel;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3801);
	
	var ErrorBoundary = function (_React$Component) {
		_inherits(ErrorBoundary, _React$Component);
	
		function ErrorBoundary(props) {
			_classCallCheck(this, ErrorBoundary);
	
			var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
			_this.state = { hasError: false, lastErrorKey: null };
			return _this;
		}
	
		_createClass(ErrorBoundary, [{
			key: "componentDidCatch",
			value: function componentDidCatch(error, info) {
				this.setState({ hasError: true, lastErrorKey: this.props.errorKey });
			}
		}, {
			key: "showError",
			value: function showError() {
				return this.state.hasError && this.props.errorKey == this.state.lastErrorKey;
			}
		}, {
			key: "render",
			value: function render() {
				if (this.showError()) {
					if (this.props.type == "big") {
						var content = React.createElement(
							"p",
							{ className: "bigError" },
							"Whooo's Reading is temporarily having an unknown error for your account. Please try refreshing the page in a few minutes. If you still experience this error after that, please ",
							React.createElement(
								"a",
								{ href: "https://www.whooosreading.org/contact" },
								"contact us"
							),
							"."
						);
					} else if (this.props.errorMessage) {
						var content = React.createElement(
							"p",
							null,
							this.props.errorMessage
						);
					} else {
						var content = React.createElement(
							"p",
							null,
							"Something went wrong. Please try again."
						);
					}
					return React.createElement(
						"div",
						{ className: "errorBoundary" },
						content
					);
				} else {
					return this.props.children;
				}
			}
		}]);
	
		return ErrorBoundary;
	}(React.Component);
	
	ErrorBoundary.propTypes = StrictPropTypes({
		children: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	
		type: PropTypes.string,
		errorMessage: PropTypes.string,
		errorKey: PropTypes.string
	});
	
	module.exports = ErrorBoundary;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	var CurrentUser = __webpack_require__(3);
	var CoinDisplay = __webpack_require__(121);
	var FeedbackOverrideDisplay = __webpack_require__(932);
	var Tiers = __webpack_require__(108);
	var SpeechControls = __webpack_require__(142);
	
	__webpack_require__(3811);
	
	var OwlfonsoContainer = function (_React$Component) {
		_inherits(OwlfonsoContainer, _React$Component);
	
		function OwlfonsoContainer(props) {
			_classCallCheck(this, OwlfonsoContainer);
	
			var _this = _possibleConstructorReturn(this, (OwlfonsoContainer.__proto__ || Object.getPrototypeOf(OwlfonsoContainer)).call(this));
	
			autobind(_this);
	
			if (props.feedbackObj) {
				LuckyOrangeClient.tagComponent("feedback_key:" + props.feedbackObj.key);
			};
	
			_this.state = { showOverrideOptions: false, hideRewardFeedback: false, children: props.children, showContent: !props.initialAnimation };
			return _this;
		}
	
		_createClass(OwlfonsoContainer, [{
			key: "hideOwl",
			value: function hideOwl() {
				var user = CurrentUser.get();
				return this.props.hideOwl || user && user.settings && user.settings.hide_owls;
			}
		}, {
			key: "getFeedbackText",
			value: function getFeedbackText() {
				return this.props.feedbackToRead;
			}
		}, {
			key: "isSpellingError",
			value: function isSpellingError() {
				return this.props.feedbackObj ? this.props.feedbackObj.key === SPELLING_ERROR_KEY : false;
			}
			// send reason for override back to parents and renders success message
	
		}, {
			key: "submitReason",
			value: function submitReason(reason, e) {
				var _this2 = this;
	
				$wr.nope(e);
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "Thank you for your feedback!", icon: "star"
				});
				this.setState({ hideRewardFeedback: false, showOverrideOptions: false }, function () {
					_this2.props.onFeedbackOverride(_this2.props.feedbackObj, reason);
				});
			}
			// renders override option buttons or the feedback
	
		}, {
			key: "renderFeedbackOrOverrideOptions",
			value: function renderFeedbackOrOverrideOptions() {
				if (this.state.showOverrideOptions) {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"div",
							{ className: "reasonHeader" },
							"Please help me understand why ",
							React.createElement(
								"span",
								{ className: "boldText" },
								this.props.feedbackObj.trigger
							),
							" was spelled correctly."
						),
						React.createElement(
							"span",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary reasonBtn", onClick: this.submitReason.bind(this, 'PERSON_OR_PLACE') },
								"Person or Place Name"
							)
						),
						React.createElement("br", null),
						React.createElement(
							"span",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary reasonBtn", onClick: this.submitReason.bind(this, 'TEXT_VOCAB') },
								"Text-Specific Vocabulary"
							)
						),
						React.createElement("br", null),
						React.createElement(
							"span",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary reasonBtn", onClick: this.submitReason.bind(this, 'NON_ENGLISH_WORD') },
								"Non-English Word"
							)
						),
						React.createElement("br", null),
						React.createElement(
							"span",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary reasonBtn", onClick: this.submitReason.bind(this, 'OTHER') },
								"Other"
							)
						)
					);
				} else {
					return this.state.children;
				}
			}
			// manipulate display to show override options
	
		}, {
			key: "onFeedbackOverride",
			value: function onFeedbackOverride() {
				this.setState({ showOverrideOptions: true, hideRewardFeedback: true });
			}
		}, {
			key: "render",
			value: function render() {
				var owlWidth = this.props.owlWidth || 80;
				var bubbleClass = "suggestionBubble";
				var owlClass = "owlImg";
				var bubbleStyle = {};
				var owlStyle = { width: owlWidth };
				var user = CurrentUser.get();
	
				switch (this.props.owlPosition) {
					case "bottom-left":
						bubbleClass += " bottomLeft";
						owlClass += " bottomLeft";
						owlStyle["marginLeft"] = Math.max(38 - owlWidth * 0.2, 0);
						break;
					case "left-upper":
					default:
						bubbleClass += " leftUpper";
						owlClass += " leftUpper";
						bubbleStyle["marginLeft"] = owlWidth + 25;
						owlStyle["top"] = Math.max(40 - owlWidth * 0.2, 0);
						break;
				}
	
				if (!this.hideOwl()) {
					bubbleClass += " withArrow";
					var owlImg = React.createElement("img", { src: __webpack_require__(299), className: owlClass,
						style: owlStyle });
				}
				if (this.props.showFeedbackReward && !this.state.hideRewardFeedback && !this.isSpellingError()) {
					var coin_amount = Tiers.getQunitXValue("addressed_feedback", user.tier);
					var reward = React.createElement(
						"div",
						{ className: "feedbackReward" },
						"Fix this and earn",
						React.createElement(CoinDisplay, { coins: coin_amount, height: 20 })
					);
				}
				if (this.isSpellingError() && !this.state.hideRewardFeedback) {
					if (this.props.feedbackObj) {
						var overrideText = "\"" + this.props.feedbackObj.trigger + "\" is spelled correctly";
					} else {
						var overrideText = 'This word is spelled correctly';
					}
					var override = React.createElement(
						"div",
						{ className: "feedbackOverride", onClick: this.onFeedbackOverride },
						React.createElement(
							"p",
							{ className: "overrideLinkText" },
							overrideText
						)
					);
				}
				if (this.state.showContent) {
					var speechControlsPreference = CurrentUser.get().prefs.speech_controls;
					if (this.props.feedbackToRead && speechControlsPreference != "off" && !this.state.hideRewardFeedback) {
						var autoReadFeedback = speechControlsPreference == "voice-first";
						var readFeedbackControls = React.createElement(SpeechControls, { getTextToRead: this.getFeedbackText, autoReadText: autoReadFeedback,
							readTextOnly: true });
					}
					var textBubble = React.createElement(
						CSSTransition,
						{ classNames: "bubble-animation",
							timeout: { enter: 1500, exit: 300 } },
						React.createElement(
							"div",
							{ className: bubbleClass, style: bubbleStyle },
							this.renderFeedbackOrOverrideOptions(),
							readFeedbackControls,
							reward,
							override
						)
					);
				}
	
				var suggestionSection = React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "suggestionSection" },
						React.createElement(
							TransitionGroup,
							null,
							textBubble
						),
						owlImg
					)
				);
				return React.createElement(
					"div",
					{ className: "owlfonsoContainer" },
					suggestionSection
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!this.state.showContent) {
					setTimeout(function () {
						this.setState({ showContent: true });
					}.bind(this), 20);
				}
			}
		}]);
	
		return OwlfonsoContainer;
	}(React.Component);
	
	var SPELLING_ERROR_KEY = 'WRITE_GRAM_SPELLING';
	
	OwlfonsoContainer.propTypes = StrictPropTypes({
		// Components to render inside the container
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string, PropTypes.func]).isRequired,
	
		// Changes the position and the owl relative to the bubble
		// Default: left-upper
		owlPosition: PropTypes.string,
	
		// Changes the width of the owl
		// Default: 80
		owlWidth: PropTypes.number,
	
		// If true, causes the animation to show for the initial content
		// Default: false
		initialAnimation: PropTypes.bool,
	
		// If true, the owl won't be shown
		hideOwl: PropTypes.bool,
	
		// If true, show reward for taking feedback into account
		showFeedbackReward: PropTypes.bool,
	
		// Feedback text to read out loud
		feedbackToRead: PropTypes.string,
	
		onFeedbackOverride: PropTypes.func,
		feedbackObj: PropTypes.object
	});
	
	module.exports = OwlfonsoContainer;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookDisplay = __webpack_require__(46);
	
	var TaskTile = function (_React$Component) {
		_inherits(TaskTile, _React$Component);
	
		function TaskTile(props) {
			_classCallCheck(this, TaskTile);
	
			var _this = _possibleConstructorReturn(this, (TaskTile.__proto__ || Object.getPrototypeOf(TaskTile)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(TaskTile, [{
			key: 'onClick',
			value: function onClick() {
				if (this.props.onClick) {
					this.props.onClick(this.props.item);
				}
			}
		}, {
			key: 'isTaskComplete',
			value: function isTaskComplete(taskItems) {
				// find finished tasks 
				var finishedQuiz = _.where(taskItems, { subject_type: 'Quiz', draft: false });
				var finishedPracticeQuestions = _.where(taskItems, { subject_type: 'Practice Question', draft: false });
				var finishedReview = _.where(taskItems, { subject_type: 'Review', draft: false });
				// sum completed tasks
				var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length;
				// return comparison
				return taskItems.length <= completed_tasks ? true : false;
			}
		}, {
			key: 'daysRemaining',
			value: function daysRemaining(item) {
				if (item.task_items && item.task_items[0].due_date) {
					if (this.isTaskComplete(item.task_items)) {
						return "This task is complete!";
					}
					var today = new Date();
					var dueDate = new Date(item.task_items[0].due_date);
					if (today.getMonth() == 11 && today.getDate() > 25) {
						dueDate.setFullYear(dueDate.getFullYear() + 1);
					}
					var oneDay = 1000 * 60 * 60 * 24;
					var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / oneDay);
					if (daysRemaining === 0) {
						return 'Due today!';
					} else if (daysRemaining > 0) {
						return daysRemaining + ' days left!';
					} else {
						return Math.abs(daysRemaining) + ' days late!';
					}
				} else {
					return 'No due date for this task';
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var item = this.props.item;
				if (this.props.type == READING_URL_TASK) {
					var taskDisplay = React.createElement(
						'div',
						{ className: 'task', onClick: this.onClick },
						React.createElement(
							'div',
							{ className: 'taskTitle' },
							React.createElement(BookDisplay, { textID: item.text_id })
						),
						React.createElement(
							'span',
							{ className: 'category' },
							this.daysRemaining(this.props.item, this.props.userID)
						),
						React.createElement('br', null),
						React.createElement('img', { src: __webpack_require__(3419), alt: 'Teacher Pick' }),
						React.createElement(
							'span',
							{ className: 'category' },
							'Teacher Pick'
						)
					);
				} else if (this.props.type == READING_TITLE_TASK) {
					var taskDisplay = React.createElement(
						'div',
						{ className: 'task', onClick: this.onClick },
						React.createElement(
							'div',
							{ className: 'taskTitle' },
							React.createElement(BookDisplay, { textID: item.text_id })
						),
						React.createElement(
							'span',
							{ className: 'category' },
							this.daysRemaining(this.props.item, this.props.userID)
						),
						React.createElement('br', null),
						React.createElement('img', { src: __webpack_require__(3420), alt: 'Teacher Pick' }),
						React.createElement(
							'span',
							{ className: 'category' },
							'Teacher Pick'
						)
					);
				} else if (this.props.type == EXERCISE_TASK) {
					var taskDisplay = React.createElement(
						'div',
						{ className: 'task', onClick: this.onClick },
						React.createElement(
							'div',
							{ className: 'taskTitle' },
							item.format_summary.title
						),
						React.createElement(
							'span',
							{ className: 'category' },
							this.daysRemaining(this.props.item, this.props.userID)
						),
						React.createElement('br', null),
						React.createElement('img', { src: __webpack_require__(186), alt: 'Do an Exercise' }),
						React.createElement(
							'span',
							{ className: 'category' },
							'Exercise'
						)
					);
				} else if (this.props.type == REVISABLE_TASK) {
					if (this.props.item.type == "quiz") {
						var altText = "Revise your quiz";
						var imgPath = __webpack_require__(292);
					} else if (this.props.item.type == "answer") {
						var altText = "Revise your answer";
						var imgPath = __webpack_require__(290);
					} else if (this.props.item.type == "review") {
						var altText = "Revise your review";
						var imgPath = __webpack_require__(293);
					} else {
						console.error("Unkonwn revisable-task item type: ", this.props.item.type);
					}
	
					var taskDisplay = React.createElement(
						'div',
						{ className: 'task', onClick: this.onClick },
						React.createElement(
							'div',
							{ className: 'taskTitle' },
							React.createElement(BookDisplay, { textID: item.text_id })
						),
						React.createElement('img', { src: imgPath, alt: altText }),
						React.createElement(
							'span',
							{ className: 'category' },
							'Revision'
						)
					);
				}
	
				var taskDisplayClass = '';
				if (this.props.gridView) {
					taskDisplayClass = 'col-sm-4 col-xs-12 text-center';
				}
				return React.createElement(
					'div',
					{ className: taskDisplayClass },
					taskDisplay
				);
			}
		}]);
	
		return TaskTile;
	}(React.Component);
	
	;
	
	var EXERCISE_TASK = "exercise-task";
	var REVISABLE_TASK = "revisable-task";
	var READING_TITLE_TASK = "reading-title-task";
	var READING_URL_TASK = "reading-url-task";
	
	TaskTile.EXERCISE_TASK = EXERCISE_TASK;
	TaskTile.REVISABLE_TASK = REVISABLE_TASK;
	TaskTile.READING_TITLE_TASK = READING_TITLE_TASK;
	TaskTile.READING_URL_TASK = READING_URL_TASK;
	
	TaskTile.propTypes = StrictPropTypes({
		type: PropTypes.string,
		item: PropTypes.object,
		onClick: PropTypes.func,
		userID: PropTypes.number,
		gridView: PropTypes.bool
	});
	
	module.exports = TaskTile;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3818);
	
	var TeacherPreviewNotice = function TeacherPreviewNotice(props) {
		return React.createElement(
			"div",
			{ className: "teacherPreviewNotice" },
			React.createElement(Glyphicon, { icon: "eye-open" }),
			" You are previewing what this page will look like for your students.",
			props.children
		);
	};
	
	TeacherPreviewNotice.propTypes = StrictPropTypes({
		// Components to render inside the container
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
	
	});
	
	module.exports = TeacherPreviewNotice;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateSpans = __webpack_require__(177);
	var CurrentUser = __webpack_require__(3);
	
	var SmartBookSearch = __webpack_require__(118);
	var LoadingButton = __webpack_require__(17);
	
	var ReadingSelectors = __webpack_require__(21);
	var WritingSelectors = __webpack_require__(14);
	
	var ReadingActions = __webpack_require__(27);
	var WritingActions = __webpack_require__(24);
	
	__webpack_require__(3824);
	
	var AssignExerciseDetailsModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    getAssignedTitles: function getAssignedTitles(student_id) {
	      return ReadingSelectors.assignedTitleBooks({ state: state, studentID: student_id });
	    },
	    getAssignedURLs: function getAssignedURLs(student_id) {
	      return ReadingSelectors.assignedURLBooks({ state: state, studentID: student_id });
	    },
	    teacherPicks: WritingSelectors.teacherPicksTasks({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      if (props.selectedUserIDs) {
	        _underscore2.default.each(props.selectedUserIDs, function (userID) {
	          dispatch(ReadingActions.fetchBookActivity({
	            conditions: { userID: userID, allowDraft: true },
	            cache: true, fetchDetails: true
	          }));
	        });
	      }
	    },
	    createTaskAssignment: function createTaskAssignment(userIDs, state, teacherPicks) {
	      // determine if teacher pick exists for this book
	      var selectedBookId = state.selectedBook ? state.selectedBook.text_id : null;
	      // determine due date
	      var due_date = state.due_date_enabled ? new Date(state.due_date) : null;
	      // build teacher pick task
	      var bookTasks = _underscore2.default.map(userIDs, function (studentID) {
	        var existingTeacherPick = _underscore2.default.where(teacherPicks, { user_id: studentID, subject_id: selectedBookId });
	        var pick_exists = existingTeacherPick.length ? true : false;
	        return {
	          user_id: studentID, assigner_id: CurrentUser.get().id,
	          subject_type: 'TitlePick', subject_id: selectedBookId,
	          due_date: due_date, text_id: selectedBookId, pick_exists: pick_exists
	        };
	      });
	      // build query/task items for the book task
	      var query = {
	        task_items: {
	          quiz: 0, practice_questions: 0,
	          review: 0, due_date: due_date,
	          due_date_enabled: state.due_date_enabled, exercises: 1,
	          exercise_id: props.taskSubjectID
	        }
	        // create the task item
	      };return dispatch(WritingActions.createTasks({ tasks: bookTasks, query: query }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(AssignExerciseDetailsModal, _React$Component);
	
	  function AssignExerciseDetailsModal(props) {
	    _classCallCheck(this, AssignExerciseDetailsModal);
	
	    var _this = _possibleConstructorReturn(this, (AssignExerciseDetailsModal.__proto__ || Object.getPrototypeOf(AssignExerciseDetailsModal)).call(this, props));
	
	    _this.handleInputChange = function (event) {
	      var target = event.target;
	      var value = target.type === 'checkbox' ? target.checked : target.value;
	      var name = target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleNoneInput = function (event) {
	      _this.setState({ none: true, quiz: false, review: false, practice_questions: false, due_date_enabled: false });
	    };
	
	    _this.renderDatePicker = function () {
	      var date_picker = '';
	      if (_this.state.due_date_enabled) {
	        date_picker = React.createElement(
	          "span",
	          null,
	          React.createElement(
	            "label",
	            null,
	            "Due Date:",
	            React.createElement(_reactDatepicker2.default, { "data-lpignore": "true", readOnly: true, selected: (0, _moment2.default)(_this.state.due_date),
	              onChange: function onChange(date) {
	                return _this.setState({ due_date: date.format(DateSpans.FORMAT) });
	              } })
	          ),
	          React.createElement("br", null)
	        );
	      }
	      return date_picker;
	    };
	
	    autobind(_this);
	
	    var defaultDate = new Date();
	    defaultDate.setDate(defaultDate.getDate() + 7);
	
	    _this.state = {
	      loading: false,
	      allAssignedBooks: [],
	      selectedBook: null,
	      due_date: defaultDate.toLocaleString(),
	      due_date_enabled: false
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.submitActivity = _this.submitActivity.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssignExerciseDetailsModal, [{
	    key: "submitActivity",
	    value: function submitActivity(e) {
	      var _this2 = this;
	
	      $wr.nope(e);
	      this.setState({ loading: true });
	      // update task items
	      this.props.createTaskAssignment(this.props.selectedUserIDs, _extends({}, this.state), this.props.teacherPicks).then(function () {
	        _this2.setState({ loading: false });
	        var text = "The exercise has been updated";
	        var title = "Exercise Updated";
	        window.wrNotifications.triggerDropDownNotification({
	          title: title, text: text, icon: "ok-sign"
	        });
	        _this2.props.onAssign();
	      });
	    }
	  }, {
	    key: "onBookSelect",
	    value: function onBookSelect(book) {
	      this.setState({ selectedBook: book });
	    }
	  }, {
	    key: "renderCheckBoxes",
	    value: function renderCheckBoxes() {
	      return React.createElement(
	        "div",
	        { className: 'dateCheckboxContainer' },
	        React.createElement(
	          "label",
	          null,
	          "Add Due Date:",
	          React.createElement("input", {
	            name: "due_date_enabled",
	            type: "checkbox",
	            checked: this.state.due_date_enabled,
	            onChange: this.handleInputChange })
	        ),
	        React.createElement("br", null),
	        this.renderDatePicker()
	      );
	    }
	    // shows disclaimer if a book and due date is selected
	
	  }, {
	    key: "renderDisclaimer",
	    value: function renderDisclaimer() {
	      if (this.state.due_date_enabled && this.state.selectedBook) {
	        return React.createElement(
	          "div",
	          { className: "activityDetailsNote" },
	          "Note: If a due date is applied to a Teacher Pick assignment for this same title, that due date will override the due date applied to this Exercise."
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "form",
	        { className: "assignExerciseDetailsForm" },
	        this.renderCheckBoxes(),
	        React.createElement(
	          "div",
	          { className: "bookSearchBox" },
	          React.createElement(
	            "label",
	            null,
	            "Assign to Book:"
	          ),
	          React.createElement(SmartBookSearch, { selectedBook: this.state.selectedBook, onBookSelect: this.onBookSelect }),
	          this.renderDisclaimer()
	        ),
	        React.createElement("br", null),
	        React.createElement(LoadingButton, { className: "btn buttonSuccess center-block",
	          loading: this.state.loading, text: 'Assign',
	          onClick: this.submitActivity })
	      );
	    }
	  }]);
	
	  return AssignExerciseDetailsModal;
	}(React.Component)) || _class) || _class);
	;
	
	AssignExerciseDetailsModal.WrappedComponent.propTypes = StrictPropTypes({
	  // ID of the task we're assigning
	  taskSubjectID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	
	  onAssign: PropTypes.func,
	  selectedUserIDs: PropTypes.array,
	
	  // subject type of the task we are assigning
	  taskSubjectType: PropTypes.string.isRequired,
	
	  getAssignedTitles: PropTypes.func,
	  getAssignedURLs: PropTypes.func,
	  selectedActivityTitle: PropTypes.string,
	  createTaskItems: PropTypes.func,
	  createTaskAssignment: PropTypes.func,
	  buildActivityTask: PropTypes.func,
	  populateData: PropTypes.func,
	  fetchBookActivity: PropTypes.func,
	  loadStudentData: PropTypes.func,
	  books: PropTypes.array,
	  teacherPicks: PropTypes.array,
	  fetchBooks: PropTypes.func
	});
	
	module.exports = AssignExerciseDetailsModal;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var ProgressBar = __webpack_require__(81);
	
	__webpack_require__(3830);
	
	var AnswerLengthMeter = function AnswerLengthMeter(props) {
	
		if (props.filterCount) {
			var colorThreshold = [props.filterCount, props.charCount * 0.7];
		} else {
			var colorThreshold = [props.charCount * 0.3, props.charCount * 0.7];
		}
		var messages = ["Not yet, keep on going!", "Almost there, keep up the good work!", "Your answer is long enough. When you are done, check your grammar and make sure you answer the question well!"];
		return React.createElement(
			"div",
			{ className: "answerLengthMeter" },
			React.createElement(
				"div",
				{ className: "progressionDisplay" },
				React.createElement(
					"div",
					{ className: "title" },
					"Have you written enough?"
				),
				React.createElement(ProgressBar, { current: props.currentCharCount,
					total: props.charCount, dynamicColor: true,
					colorThreshold: colorThreshold, messages: messages })
			)
		);
	};
	
	AnswerLengthMeter.propTypes = StrictPropTypes({
		charCount: PropTypes.number.isRequired,
		currentCharCount: PropTypes.number.isRequired,
		filterCount: PropTypes.number
	});
	
	module.exports = AnswerLengthMeter;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var SpeechControls = __webpack_require__(142);
	var ReactTooltip = __webpack_require__(12);
	var Glyphicon = __webpack_require__(8);
	var ReactionFeedback = __webpack_require__(101);
	var QuestionFeedback = __webpack_require__(173);
	var MultiPartSentenceStarter = __webpack_require__(197);
	var FillInTheBlank = __webpack_require__(963);
	var AnswerLengthMeter = __webpack_require__(425);
	
	var AutograderFeedback = __webpack_require__(258);
	var Chronometer = __webpack_require__(1005);
	var CurrentUser = __webpack_require__(3);
	var GradeLevel = __webpack_require__(40);
	var FeedbackFormatter = __webpack_require__(73);
	
	var ArbitrarySubjects = __webpack_require__(107);
	var QuestionTypes = __webpack_require__(82);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ReadingSelectors = __webpack_require__(21);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3832);
	
	var AnswerWritingInterface = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var answer = WritingSelectors.answer({ state: state, id: props.answerID });
		LuckyOrangeClient.tagComponent("answer_id:" + answer.id);
		var passProps = {
			answer: answer
		};
		if (answer) {
			passProps.question = WritingSelectors.question({ state: state, id: answer.question_id });
			passProps.book = ReadingSelectors.book({ state: state, id: answer.text_id });
		}
	
		passProps.speechControlSetting = CurrentUser.get().prefs.speech_controls;
		passProps.academicLevel = parseInt(CurrentUser.get().prefs.academic_level);
		passProps.coinHistory = _underscore2.default.pluck(CurrentUser.get().coin_records, "key");
	
		return passProps;
	}, function (dispatch, props) {
		return {
			onAnswerChange: function onAnswerChange(update) {
				return dispatch(WritingActions.localUpdateAnswer({ id: props.answerID, update: update }));
			},
			createAward: function createAward(award) {
				return dispatch(RosterActions.createAward({ award: award })).then(function () {
					CurrentUser.fetchCurrentUserCoinData();
				});
			},
			saveHistoryChange: function saveHistoryChange(update) {
				return dispatch(WritingActions.updateAnswer({ id: props.answerID, update: update, embeds: ['answer.history'] }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AnswerWritingInterface, _React$Component);
	
		function AnswerWritingInterface(props) {
			_classCallCheck(this, AnswerWritingInterface);
	
			var _this = _possibleConstructorReturn(this, (AnswerWritingInterface.__proto__ || Object.getPrototypeOf(AnswerWritingInterface)).call(this));
	
			autobind(_this);
	
			_this.state = _this.initialStateData();
			return _this;
		}
	
		_createClass(AnswerWritingInterface, [{
			key: "initialStateData",
			value: function initialStateData() {
				return {
					feedbackLoading: false,
					showQuestionChangeFeedback: false,
					lastSubmittedText: null,
					feedbackOverridden: false,
					overriddenTriggers: []
				};
			}
		}, {
			key: "reset",
			value: function reset() {
				this.setState(this.initialStateData());
				this.initChronometer();
			}
	
			//////////////////////////////////////////
			// Related to parsing autograder data ////
			//////////////////////////////////////////
	
			// Check to see if a particular filter was detected.
	
		}, {
			key: "hasFilter",
			value: function hasFilter(filter, autograderData) {
				if (autograderData && autograderData.filtering) {
					var filters = _underscore2.default.keys(autograderData.filtering);
					return filters.includes(filter);
				} else {
					return false;
				}
			}
	
			// Compared autograder data to see if feedback has been removed and, if it has,
			// awards coins to the student
	
		}, {
			key: "checkAddressedFeedback",
			value: function checkAddressedFeedback(newAutograderData) {
				var oldAutograderData = this.currentAutograderData();
				if (!(oldAutograderData && newAutograderData && oldAutograderData.assisting && newAutograderData.assisting)) {
					return false;
				}
	
				var previousFeedback = oldAutograderData.assisting.selected_feedback;
				var currentFeedback = newAutograderData.assisting.eligible_feedback;
	
				if (!currentFeedback.includes(previousFeedback)) {
					return true;
				}
				return false;
			}
		}, {
			key: "rewardAddressedFeedback",
			value: function rewardAddressedFeedback() {
				if (this.isReview()) {
					var subjectType = ArbitrarySubjects.REVIEW;
				} else {
					var subjectType = ArbitrarySubjects.ANSWER;
				}
	
				var award = {
					type: "qunit", key: "addressed-feedback-$index",
					"dynamic": {
						"index": this.props.questionIndex,
						"title": this.props.book.title,
						"subject_type": subjectType,
						"subject_id": this.props.answerID
					}
				};
	
				this.props.createAward(award).then(function (response) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Addressed Feedback!",
						text: "Well done addressing feedback for this question!",
						icon: "ok-circle"
					});
				});
			}
		}, {
			key: "currentAutograderData",
			value: function currentAutograderData() {
				return this.props.answer.recentAutograderData;
			}
	
			//////////////////////////////////////////
			// Feedback //////////////////////////////
			//////////////////////////////////////////
	
		}, {
			key: "feedbackSubs",
			value: function feedbackSubs() {
				var autograderData = this.currentAutograderData();
				if (autograderData && autograderData.feedback_subs) {
					return autograderData.feedback_subs;
				}
			}
		}, {
			key: "feedbackItems",
			value: function feedbackItems() {
				var _this2 = this;
	
				var autograderData = this.currentAutograderData();
				if (autograderData && autograderData.assisting) {
					var feedbackItems = _underscore2.default.map(autograderData.assisting.selected_content, function (content, priority) {
						if (!content.trigger || !_underscore2.default.includes(_this2.state.overriddenTriggers, content.trigger)) {
							return content;
						}
					});
					return _underscore2.default.compact(feedbackItems);
				}
			}
		}, {
			key: "showFeedback",
			value: function showFeedback() {
				return _underscore2.default.any(this.feedbackItems()) && !this.isLoading();
			}
	
			// For feedback, check to see if we should show the coin award option.
			// Don't show if:
			// - Answer is too short to grade properly
			// - The user has already gotten all the coins today they are going to be able to get
	
		}, {
			key: "shouldRewardShow",
			value: function shouldRewardShow() {
				var autograderData = this.currentAutograderData();
	
				if (!autograderData) {
					return false;
				}
	
				// Check if answer is too short
				if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
					return false;
				}
	
				// Check if max amount of reward hasn't been exceeded
				var checkString = "addressed-feedback-" + this.props.questionIndex;
				var count = this.props.coinHistory.reduce(function (n, val) {
					return n + (val === checkString);
				}, 0);
	
				return count < 2;
			}
	
			//////////////////////////////////////////
			// Answer meta-data //////////////////////
			//////////////////////////////////////////
	
		}, {
			key: "collapseDuration",
			value: function collapseDuration(currentDuration) {
				if (this.props.answer.meta_data) {
					var pastDuration = 0;
					this.props.answer.meta_data.forEach(function (data) {
						pastDuration += data["duration"];
					});
				} else {
					var pastDuration = 0;
				}
				return currentDuration + pastDuration;
			}
		}, {
			key: "sessionMetaData",
			value: function sessionMetaData() {
				var answer = this.props.answer;
				if (Chronometer) {
					var duration = Chronometer.getDuration();
				} else {
					var duration = 0.0;
				}
				return _underscore2.default.extend({}, answer.sessionMetaData || this.defaultMetaData(), {
					duration: duration
				});
			}
		}, {
			key: "defaultMetaData",
			value: function defaultMetaData() {
				return {
					submission_count: 0,
					paste_detected: false,
					pasted_content: null,
					session_start: new Date().getTime()
				};
			}
		}, {
			key: "onPaste",
			value: function onPaste(e) {
				var pastedText = e.clipboardData.getData('Text');
				var metaData = _underscore2.default.clone(this.sessionMetaData());
				metaData.pasted_content = (metaData.pasted_content || []).concat(pastedText);
				metaData.paste_detected = true;
	
				this.props.onAnswerChange({
					sessionMetaData: metaData
				});
			}
	
			//////////////////////////////////////////
			// Other handlers or queries /////////////
			//////////////////////////////////////////
	
			// adds feedback override to metadata
	
		}, {
			key: "onFeedbackOverride",
			value: function onFeedbackOverride(data, reason, e) {
				$wr.nope(e);
				this.setState({ feedbackOverridden: true, overriddenTriggers: [].concat(_toConsumableArray(this.state.overriddenTriggers), [data.trigger]) });
				var metaDataFeedback = { "feedback_key": data.key, "reason_key": reason, "trigger": data.trigger };
				if (this.props.answer) {
					if (this.props.answer.meta_data) {
						this.props.onAnswerChange({
							meta_data: [].concat(_toConsumableArray(this.props.answer.meta_data), [metaDataFeedback])
						});
					} else {
						this.props.onAnswerChange({
							meta_data: [metaDataFeedback]
						});
					}
				}
			}
		}, {
			key: "onQuestionChange",
			value: function onQuestionChange(e) {
				$wr.nope(e);
				this.props.onQuestionChange();
				if (this.props.requestFeedbackOnQuestionChange) {
					this.setState({ showQuestionChangeFeedback: true });
				}
			}
		}, {
			key: "isLoading",
			value: function isLoading() {
				return this.props.loading || this.state.feedbackLoading;
			}
		}, {
			key: "isReview",
			value: function isReview() {
				return this.props.answer.question_type == QuestionTypes.REVIEW_QUESTION;
			}
		}, {
			key: "isQuiz",
			value: function isQuiz() {
				return !!this.props.answer.quiz_id;
			}
		}, {
			key: "isJournalActivityQuestion",
			value: function isJournalActivityQuestion() {
				return !(this.isReview() || this.isQuiz());
			}
		}, {
			key: "getAnswer",
			value: function getAnswer() {
				return this.answerBodyText();
			}
		}, {
			key: "getQuestionText",
			value: function getQuestionText() {
				return this.props.question.body;
			}
	
			//////////////////////////////////////////
			// Answer parts, updating and reading ////
			//////////////////////////////////////////
	
		}, {
			key: "updateSingleAnswerText",
			value: function updateSingleAnswerText(e) {
				this.setSingleAnswerText(e.target.value);
			}
		}, {
			key: "setSingleAnswerText",
			value: function setSingleAnswerText(text) {
				if (text.length > MAX_ANSWER_LENGTH) {
					window.wrNotifications.triggerDropDownNotification({
						title: "This answer is too long!", icon: "pencil", text: "Please remove some text" });
					return;
				}
				var answerParts = _underscore2.default.clone(this.answerParts());
				var firstBodyIndex = _underscore2.default.findIndex(answerParts, function (x) {
					return x.type == MultiPartSentenceStarter.BODY;
				});
	
				if (firstBodyIndex != -1) {
					answerParts[firstBodyIndex] = { type: MultiPartSentenceStarter.BODY, text: text };
				} else {
					answerParts = [{ type: MultiPartSentenceStarter.BODY, text: text }];
				}
	
				this.props.onAnswerChange({
					localParts: answerParts,
					sessionMetaData: this.sessionMetaData()
				});
			}
		}, {
			key: "updateMultiPartAnswer",
			value: function updateMultiPartAnswer(parts) {
				if (_underscore2.default.pluck(parts, "text").join(" ").length > MAX_ANSWER_LENGTH) {
					window.wrNotifications.triggerDropDownNotification({
						title: "This answer is too long!", icon: "pencil", text: "Please remove some text" });
					return;
				}
				this.props.onAnswerChange({
					localParts: parts,
					sessionMetaData: this.sessionMetaData()
				});
			}
		}, {
			key: "answerParts",
			value: function answerParts() {
				return this.props.answer.localParts || this.props.answer.parts;
			}
		}, {
			key: "singleAnswerText",
			value: function singleAnswerText() {
				var parts = this.answerParts();
				if (_underscore2.default.any(parts)) {
					return parts[0].text;
				}
	
				return "";
			}
		}, {
			key: "starters",
			value: function starters() {
				var starters = _underscore2.default.where(this.answerParts(), { type: MultiPartSentenceStarter.STARTER });
				return _underscore2.default.pluck(starters, "text");
			}
		}, {
			key: "hasEmptyParts",
			value: function hasEmptyParts() {
				var answerParts = this.answerParts();
				if (!answerParts) {
					return true;
				}
				return _underscore2.default.any(answerParts, function (part) {
					return !part.text || part.text.trim().length == 0;
				});
			}
		}, {
			key: "answerBodyText",
			value: function answerBodyText() {
				if (!this.hasSentenceStarters()) {
					return this.singleAnswerText();
				}
	
				var textParts = _underscore2.default.map(this.answerParts(), function (part) {
					return (part.text || "").trim();
				});
	
				textParts = _underscore2.default.reject(textParts, function (x) {
					return x.length == 0;
				});
				return textParts.join(" ");
			}
		}, {
			key: "getStarterTextLength",
			value: function getStarterTextLength() {
				return this.starters().join(" ").length;
			}
		}, {
			key: "hasSentenceStarters",
			value: function hasSentenceStarters() {
				return !this.isFillInTheBlank() && (this.answerParts() || []).length >= 2;
			}
		}, {
			key: "isFillInTheBlank",
			value: function isFillInTheBlank() {
				return this.props.question.type == "fill-in-the-blank-question";
			}
	
			//////////////////////////////////////////
			// Submitting answers ////////////////////
			//////////////////////////////////////////
	
		}, {
			key: "forceSubmit",
			value: function forceSubmit() {
				LuckyOrangeClient.tagComponent("forced_quiz");
				this.onAnswerComplete(true);
			}
		}, {
			key: "normalSubmit",
			value: function normalSubmit() {
				LuckyOrangeClient.tagComponent("normal_submit");
				this.onAnswerComplete(false);
			}
	
			// isRevisionEligible(autograderData) {
			// 	if (autograderData && autograderData.filtering && autograderData.polarizing) {
			// 		if (_.keys(autograderData.filtering).length > 0) {
			// 			return false
			// 		}
			// 		var spellRating = (autograderData.polarizing["comm-conv-mech-spell"] || {value:0});
			// 		var gramRating = (autograderData.polarizing["comm-conv-mech-gram"] || {value:0});
			// 		var wordCountRating = (autograderData.polarizing["comm-conv-org-word-count"] || {value:0});
	
			// 		var Mechthreshold = 0.6;
			// 		if (spellRating.value > Mechthreshold && gramRating.value > Mechthreshold &&
			// 		 wordCountRating.value > 0.3) {
			// 			return true
			// 		}
			// 	}
			// 	return false
			// }
	
		}, {
			key: "updateAnswerHistory",
			value: function updateAnswerHistory(answerData, feedbackData, addressedFeedback) {
				var oldAutograderData = this.currentAutograderData();
				var source = this.state.lastSubmittedText;
				var outcome = answerData.answer;
	
				var sourceLength = source ? source.length : 0;
	
				var newHistory = _underscore2.default.clone(this.props.answer.history || []);
				// prevent long answers from being submitted
				if (sourceLength < 1000 && outcome.length < 1000 && source != outcome) {
					var submissionTime = new Date().getTime();
					// if not the first submission, and we have old autograder data
					if (oldAutograderData && oldAutograderData.assisting) {
						var feedbackKey = oldAutograderData.assisting.selected_feedback;
	
						var subs = this.feedbackSubs();
						var feedbackContent = oldAutograderData.assisting.selected_content;
						var firstElegibleKey = _underscore2.default.keys(feedbackContent).sort()[0];
						if (feedbackContent[firstElegibleKey]["content"][0]) {
							var transformedContent = FeedbackFormatter.insertDynamicData(feedbackContent[firstElegibleKey]["content"][0], subs).replace(/\//g, '"');
						} else {
							var transformedContent = null;
						}
	
						var revision = {
							source: this.state.lastSubmittedText,
							outcome: answerData.answer,
							feedback_key: feedbackKey,
							feedback_content: transformedContent,
							addressed: addressedFeedback,
							eligible: feedbackData.autograderData.eligible,
							delta: feedbackData.autograderData.delta,
							encrypted_data: feedbackData.autograderData.encrypted,
							submission_time: submissionTime
						};
					} else {
						// if no revision data, this is the first submission in the session.
						var revision = {
							source: this.state.lastSubmittedText,
							outcome: answerData.answer,
							feedback_key: null,
							feedback_content: null,
							addressed: addressedFeedback,
							eligible: feedbackData.autograderData.eligible,
							delta: feedbackData.autograderData.delta,
							encrypted_data: feedbackData.autograderData.encrypted,
							submission_time: submissionTime
						};
					}
	
					newHistory.push(revision);
					this.props.saveHistoryChange({ history: newHistory });
				}
			}
		}, {
			key: "onAnswerComplete",
			value: function onAnswerComplete(forceSubmit) {
				var _this3 = this;
	
				if (window.speechSynthesis) {
					window.speechSynthesis.cancel();
				}
				if (this.hasEmptyParts()) {
					if (this.hasSentenceStarters()) {
						var errorText = "Please write at least a short response for each part of this question.";
					} else {
						var errorText = "Please write at least a short response to this question.";
					}
					window.wrNotifications.triggerDropDownNotification({
						title: "We need a bit more!", icon: "pencil", text: errorText });
					return;
				}
	
				var answerData = {
					answer: this.answerBodyText(),
					answerParts: this.answerParts(),
					starters: this.starters(),
					text: this.props.book,
					questionKey: this.props.question.key,
					questionText: this.props.question.body, quiz: true
				};
	
				var autograderData = this.currentAutograderData();
				if (autograderData && autograderData.forward && autograderData.forward.length > 0) {
					answerData["forward"] = autograderData.forward;
				}
	
				this.setState({
					feedbackLoading: true, feedbackItems: null
				});
	
				var sessionDuration = Chronometer.getDuration();
				var metaData = _underscore2.default.clone(this.sessionMetaData());
				metaData.submission_count = (metaData.submission_count || 0) + 1;
				metaData.duration = (metaData.duration || 0) + sessionDuration;
	
				// Alexandria expects "true", not a boolean
				if (metaData.paste_detected) {
					answerData.pasteDetected = "true";
				}
	
				if (this.isFillInTheBlank()) {
					var answerOptions = this.props.question.answer_options;
					if (answerOptions && answerOptions.length) {
						var text = _underscore2.default.findWhere(this.answerParts(), { type: MultiPartSentenceStarter.BODY }).text;
						var answerData = {
							text: text,
							options: answerOptions.join(","),
							question_text: this.props.question.body
						};
						AutograderFeedback.fetchFuzzyMatch(answerData, function (result) {
	
							if (result.autograderData && result.autograderData.evaluating) {
								var score = result.autograderData.evaluating["final-evaluation"].value;
								var mergedParts = _underscore2.default.map(_this3.answerParts(), function (part) {
									if (part.type == MultiPartSentenceStarter.BODY) {
										return _underscore2.default.extend({}, part, { match: score });
									} else {
										return part;
									}
								});
							} else {
								var mergedParts = _this3.answerParts();
							}
							_this3.props.onAnswerChange({
								answerParts: mergedParts,
								localParts: mergedParts,
								recentAutograderData: result.autograderData,
								sessionMetaData: metaData
							}).then(function () {
								_this3.props.onComplete();
								_this3.setState({ feedbackLoading: false, lastSubmittedText: null });
							});
						});
					} else {
						this.props.onAnswerChange({
							sessionMetaData: metaData
						}).then(function () {
							_this3.props.onComplete();
							_this3.setState({ feedbackLoading: false, lastSubmittedText: null });
						});
					}
				} else {
					AutograderFeedback.fetch(answerData, function (result) {
						if (result && result.autograderData) {
							var addressedFeedback = _this3.checkAddressedFeedback(result.autograderData);
							_this3.updateAnswerHistory(answerData, result, addressedFeedback);
							if (_this3.shouldRewardShow() && addressedFeedback) {
								_this3.rewardAddressedFeedback();
							}
						}
	
						_this3.props.onAnswerChange({
							recentAutograderData: result.autograderData,
							sessionMetaData: metaData
						}).then(function () {
							if (_underscore2.default.isEmpty(_this3.feedbackItems()) || forceSubmit || result.noFeedback) {
								_this3.props.onComplete();
								_this3.setState({ lastSubmittedText: null, feedbackLoading: false });
							} else {
								_this3.setState({ lastSubmittedText: answerData.answer, feedbackLoading: false });
							}
						});
					});
				}
			}
	
			//////////////////////////////////////////
			// Renderers /////////////////////////////
			//////////////////////////////////////////
	
		}, {
			key: "renderFillInTheBlankArea",
			value: function renderFillInTheBlankArea() {
				return React.createElement(FillInTheBlank, { key: this.props.question.id,
					answerParts: this.answerParts(),
					handlePasteBehaviour: this.onPaste,
					onChange: this.updateMultiPartAnswer,
					speechControlSetting: this.props.speechControlSetting });
			}
		}, {
			key: "renderSentenceStarterArea",
			value: function renderSentenceStarterArea() {
				return React.createElement(MultiPartSentenceStarter, { key: this.props.question.id,
					answerParts: this.answerParts(),
					handlePasteBehaviour: this.onPaste,
					onChange: this.updateMultiPartAnswer,
					speechControlSetting: this.props.speechControlSetting });
			}
		}, {
			key: "renderTextArea",
			value: function renderTextArea() {
				// Ref is for attaching events only
				return React.createElement("textarea", { key: this.props.question.id,
					className: "form-control singleAnswer", rows: "6", ref: "textarea",
					value: this.singleAnswerText(),
					onChange: this.updateSingleAnswerText,
					onPaste: this.onPaste });
			}
		}, {
			key: "renderFeedback",
			value: function renderFeedback() {
				if (this.showFeedback()) {
					var subs = this.feedbackSubs();
					var renderedItems = _underscore2.default.map(this.feedbackItems(), function (item) {
						var feedbackItem = FeedbackFormatter.format(_underscore2.default.first(item.content), subs);
						feedbackItem.data = item;
						return feedbackItem;
					});
					return React.createElement(
						"div",
						{ className: "questionFeedbackBox" },
						React.createElement(QuestionFeedback, { onFeedbackOverride: this.onFeedbackOverride, feedbackItems: renderedItems,
							showFeedbackReward: this.shouldRewardShow() })
					);
				}
			}
		}, {
			key: "renderButtons",
			value: function renderButtons() {
				if (this.isReview()) {
					var nextText = "Finish Review";
				} else if (this.isJournalActivityQuestion()) {
					var nextText = "Finish Question";
				} else if (this.props.hasMoreQuestions) {
					var nextText = "Next Question";
				} else {
					var nextText = "Finish Quiz";
				}
	
				if (this.showFeedback()) {
					var submitAnyway = React.createElement(LoadingButton, { className: "btn buttonDefault submitAnyway", text: nextText,
						onClick: this.forceSubmit, loading: this.isLoading() });
					var trySubmit = React.createElement(LoadingButton, { className: "btn buttonPrimary checkAgain", text: "Check Again",
						"data-tip": "After editing what you wrote, click here to get more helpful tips from Owlfonso.",
						onClick: this.normalSubmit, loading: this.isLoading() });
				} else {
					var trySubmit = React.createElement(LoadingButton, { className: "btn buttonPrimary", text: nextText,
						onClick: this.normalSubmit, loading: this.isLoading() });
				}
	
				return React.createElement(
					"div",
					{ className: "buttons" },
					submitAnyway,
					trySubmit,
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
		}, {
			key: "renderVoiceFirstSpeechControls",
			value: function renderVoiceFirstSpeechControls() {
				if (this.props.speechControlSetting == "voice-first") {
					if (this.hasSentenceStarters()) {
						return React.createElement(
							"div",
							{ className: "voiceFirstSpeechControls" },
							React.createElement(SpeechControls, { key: this.props.questionIndex, getText: this.getAnswer, setText: this.setSingleAnswerText,
								getTextToRead: this.getQuestionText, toggleHighlight: this.toggleHighlight,
								autoReadText: true, readTextOnly: true })
						);
					} else if (!this.isFillInTheBlank()) {
						return React.createElement(
							"div",
							{ className: "voiceFirstSpeechControls" },
							React.createElement(SpeechControls, { key: this.props.questionIndex, getText: this.getAnswer, setText: this.setSingleAnswerText,
								getTextToRead: this.getQuestionText, toggleHighlight: this.toggleHighlight,
								autoReadText: true })
						);
					}
				}
			}
		}, {
			key: "renderNormalSpeechControls",
			value: function renderNormalSpeechControls() {
				if (!(this.hasSentenceStarters() || this.isFillInTheBlank()) && this.props.speechControlSetting == "normal") {
					return React.createElement(
						"div",
						{ className: "normalSpeechControls" },
						React.createElement(SpeechControls, { key: this.props.questionIndex, getText: this.getAnswer, setText: this.setSingleAnswerText,
							getTextToRead: this.getQuestionText, toggleHighlight: this.toggleHighlight })
					);
				}
			}
		}, {
			key: "renderAnswerLengthMeter",
			value: function renderAnswerLengthMeter() {
				if (!this.props.showAnswerLengthMeter) {
					return;
				}
	
				var starterLength = this.getStarterTextLength();
	
				var answerLength = this.answerBodyText().length - starterLength;
	
				var charCount = GradeLevel.getRecommendedAnswerLength(this.props.academicLevel);
				var filterCount = GradeLevel.getCharCountFilter(this.props.academicLevel);
	
				charCount = Math.max((charCount - starterLength) * 0.8, 20);
				filterCount = Math.max(filterCount - starterLength, 20);
	
				return React.createElement(AnswerLengthMeter, { currentCharCount: answerLength,
					charCount: charCount, filterCount: filterCount });
			}
		}, {
			key: "renderQuestionDisplay",
			value: function renderQuestionDisplay() {
				if (this.props.onQuestionChange) {
					if (this.state.showQuestionChangeFeedback) {
						var questionChangeFeedback = React.createElement(ReactionFeedback, { where: "quiz-question-change",
							textOnly: true,
							textTitle: "Why did you change the question?",
							placeholder: "Because...",
							popover_position: ReactionFeedback.POSITION_BOTTOM_RIGHT });
					}
	
					var changeQuestionLink = React.createElement(
						"div",
						{ className: "changeQuestionLink" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.onQuestionChange },
							React.createElement(Glyphicon, { icon: "refresh" }),
							" Change"
						),
						questionChangeFeedback
					);
				}
	
				return React.createElement(
					"div",
					{ className: "promptText clearfix" },
					this.props.question.body,
					" ",
					changeQuestionLink
				);
			}
		}, {
			key: "render",
			value: function render() {
				var loading = this.props.loading || this.state.feedbackLoading;
	
				var slideClassName = this.showFeedback() ? " slideLeft" : "";
				if (this.props.topOuterChild) {
					var topOuterContainer = React.createElement(
						"div",
						{ className: "topOuterContainer" + slideClassName },
						this.props.topOuterChild
					);
				}
	
				if (this.isFillInTheBlank()) {
					var writingInterface = this.renderFillInTheBlankArea();
				} else {
					var lengthMeter = this.renderAnswerLengthMeter();
					var questionDisplay = this.renderQuestionDisplay();
					if (this.hasSentenceStarters()) {
						var writingInterface = this.renderSentenceStarterArea();
					} else {
						var writingInterface = this.renderTextArea();
					}
				}
	
				return React.createElement(
					"div",
					{ className: "answerWritingInterface clearfix" },
					topOuterContainer,
					React.createElement(
						"div",
						{ className: "clearfix" },
						React.createElement(
							"div",
							{ className: "questionOptionBox" + slideClassName },
							questionDisplay,
							this.renderVoiceFirstSpeechControls(),
							writingInterface,
							lengthMeter,
							React.createElement(
								"div",
								{ className: "controls" },
								this.renderNormalSpeechControls(),
								this.renderButtons()
							)
						),
						this.renderFeedback()
					)
				);
			}
	
			//////////////////////////////////////////
			// Component Lifecyle ////////////////////
			//////////////////////////////////////////
	
		}, {
			key: "initChronometer",
			value: function initChronometer() {
				if (Chronometer) {
					Chronometer.init();
				} else {
					setTimeout(this.initChronometer.bind(this), 300);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.initChronometer();
				$(this.refs.textarea).bind("paste", this.handlePasteBehaviour);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				Chronometer.reset();
			}
		}]);
	
		return AnswerWritingInterface;
	}(React.Component)) || _class);
	
	
	var MAX_ANSWER_LENGTH = 5000;
	
	var SPELLING_FEEDBACK = 'WRITE_GRAM_SPELLING';
	
	AnswerWritingInterface.WrappedComponent.propTypes = StrictPropTypes({
		// ID of the answer to be displayed
		answerID: PropTypes.number.isRequired,
	
		// Called when the answer writing in complete (including Feedback)
		onComplete: PropTypes.func.isRequired,
	
		// Boolean, if true shows a loading indicator on button and blocks submitting
		loading: PropTypes.bool,
	
		// Setting of the speech controls, if voice first or on at all
		speechControlSetting: PropTypes.string,
	
		// Index of the question, or "solo" 
		questionIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	
		// True if there are more questions coming after this. If so, button should say "Continue"
		hasMoreQuestions: PropTypes.bool,
	
		// Allows extra content to be added above the answer textbox
		// That moves with it when feedback shows on the right
		topOuterChild: PropTypes.object,
	
		//   Changes the question
		onQuestionChange: PropTypes.func,
		//   Whether we ask for feedback after changing the question
		requestFeedbackOnQuestionChange: PropTypes.bool,
	
		//   If true, shows a meter w/ the answer length
		showAnswerLengthMeter: PropTypes.bool,
	
		//   If set, allows sentence starters to show
		showStarter: PropTypes.bool,
	
		academicLevel: PropTypes.number,
	
		// Data from @connect
		answer: PropTypes.object,
		question: PropTypes.object,
		book: PropTypes.object,
		coinHistory: PropTypes.array,
	
		// Handlers from @connect
		onAnswerChange: PropTypes.func,
		createAward: PropTypes.func
	
	});
	
	module.exports = AnswerWritingInterface;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var QuestionTypes = __webpack_require__(82);
	
	var RosterSelectors = __webpack_require__(6);
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var AutograderDisplayConfig = __webpack_require__(83);
	var NumbersOnlyInput = __webpack_require__(122);
	var ReactionFeedback = __webpack_require__(101);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var RubricItemOverride = __webpack_require__(430);
	
	__webpack_require__(3837);
	
	var EditControls = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
	
		if (props.answerID) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state: state, subjectType: "Answer", subjectID: props.answerID
			});
		}
	
		if (props.quizID) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state: state, subjectType: "Quiz", subjectID: props.quizID
			});
		}
	
		if (props.quizID) {
			var quiz = WritingSelectors.quiz({ state: state, id: props.quizID });
	
			downProps.excluded = quiz.excluded;
	
			downProps.noun = "quiz";
		} else {
			var answer = WritingSelectors.answer({ state: state, id: props.answerID });
	
			downProps.excluded = answer.excluded;
	
			if (answer && answer.question_type == QuestionTypes.REVIEW_QUESTION) {
				downProps.noun = "review";
			} else {
				downProps.noun = "answer";
			}
		}
	
		if (CurrentUser.isStudent()) {
			var slPrefs = CurrentUser.get().prefs;
		} else {
			var slPrefs = RosterSelectors.studentListPrefs({ state: state }) || {};
		}
		downProps.displayScoreCap = slPrefs.display_score_cap;
	
		return downProps;
	}, function (dispatch, props) {
		var handlers = {};
	
		if (props.answerID) {
			handlers.onDelete = function () {
				return dispatch(WritingActions.deleteAnswer({ id: props.answerID }));
			};
	
			handlers.onInclude = function () {
				return dispatch(WritingActions.updateAnswer({
					id: props.answerID, update: { excluded: false }
				}));
			};
	
			handlers.onExclude = function () {
				return dispatch(WritingActions.updateAnswer({
					id: props.answerID, update: { excluded: true }
				}));
			};
		}
	
		if (props.quizID) {
			handlers.onDelete = function () {
				return dispatch(WritingActions.deleteQuiz({ id: props.quizID }));
			};
	
			handlers.onInclude = function () {
				return dispatch(WritingActions.updateQuiz({
					id: props.quizID, update: { excluded: false }
				}));
			};
	
			handlers.onExclude = function () {
				return dispatch(WritingActions.updateQuiz({
					id: props.quizID, update: { excluded: true }
				}));
			};
		}
	
		handlers.onUpdate = function (evaluationID, updateData) {
			dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: updateData }));
		};
	
		return handlers;
	}), _dec(_class = function (_React$Component) {
		_inherits(EditControls, _React$Component);
	
		function EditControls(props) {
			_classCallCheck(this, EditControls);
	
			var _this = _possibleConstructorReturn(this, (EditControls.__proto__ || Object.getPrototypeOf(EditControls)).call(this));
	
			autobind(_this);
			if (props.evaluation && props.evaluation.ratio) {
				var editedScore = _this.hideAutograderScore(props.evaluation) ? 0 : $wr.convertedScore(props.evaluation.ratio, props.displayScoreCap || 4);
			}
	
			_this.state = { editedScore: editedScore, showOverrideFeedback: false, rubricOverride: {} };
			return _this;
		}
	
		_createClass(EditControls, [{
			key: "deleteAnswer",
			value: function deleteAnswer(e) {
				$wr.nope(e);
				if (confirm("Are you sure you want to delete this " + this.props.noun + "?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Deleted",
						text: "You have deleted the " + this.props.noun + ".",
						icon: "trash"
					});
					this.props.onDelete();
					if (this.props.afterDelete) {
						this.props.afterDelete();
					}
				}
			}
		}, {
			key: "includeAnswer",
			value: function includeAnswer(e) {
				$wr.nope(e);
				if (confirm("This will allow this " + this.props.noun + " to count toward your custom goals. Are you sure?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Included",
						text: "You have included this " + this.props.noun + ".",
						icon: "ok-sign"
					});
					this.props.onInclude();
				}
			}
		}, {
			key: "excludeAnswer",
			value: function excludeAnswer(e) {
				$wr.nope(e);
				if (confirm("This will exclude this " + this.props.noun + " from counting toward your custom goals. Are you sure?")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Excluded",
						text: "You have excluded this " + this.props.noun + ".",
						icon: "ok-sign"
					});
					this.props.onExclude();
				}
			}
		}, {
			key: "saveEvaluation",
			value: function saveEvaluation(e) {
				$wr.nope(e);
	
				var originalEvaluation = this.props.evaluation;
	
				// Round up to the nearest 0.5
				var override = Math.round(this.state.editedScore * 2) / 2;
	
				var adminRatio = override / this.displayScoreCap();
	
				// Project this onto the scale of the original evaluation
				var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);
	
				// set to 0 or score_cap if outside of 0-score_cap range
				if (adminScore < 0) {
					adminScore = 0;
					adminRatio = 0;
				} else if (adminScore > originalEvaluation.score_cap) {
					adminScore = originalEvaluation.score_cap;
					adminRatio = 1;
				}
	
				var scoreDetails = _.extend({}, originalEvaluation.score_details, { admin_score: adminScore });
	
				// Included both score (for immediate display) and adminScore (for the API Patch)
				var updateData = {
					score: adminScore, ratio: adminRatio, admin_score: adminScore,
					score_details: scoreDetails, grader_id: this.props.graderID
	
					// add read_book if updated
				};if (!_.isEmpty(this.state.rubricOverride)) {
					updateData = _extends({}, updateData, { rubric_override: _extends({}, this.state.rubricOverride) });
				}
	
				this.props.onUpdate(originalEvaluation.id, updateData);
				this.setState({ editingEvaluation: false, showOverrideFeedback: CurrentUser.isPremiumOrTrialAccount() });
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Score Edited",
					text: "You have edited the score for this " + this.props.noun + ".",
					icon: "ok-sign"
				});
			}
		}, {
			key: "displayScoreCap",
			value: function displayScoreCap(props) {
				return (props || this.props).displayScoreCap || 4;
			}
		}, {
			key: "convertedScore",
			value: function convertedScore(ratio, props) {
				var score = ratio * this.displayScoreCap(props);
				// Round down to nearest 0.5
				score = Math.floor(score * 2) / 2;
				return score;
			}
	
			// extracts read book layer of polarizing hash
	
		}, {
			key: "getReadBookLeaf",
			value: function getReadBookLeaf() {
				var evaluation = this.props.evaluation;
	
				var polarizing = evaluation && evaluation.autograder_data ? evaluation.autograder_data.polarizing : {};
				var leaves = AutograderDisplayConfig.getRubricLeaves(polarizing, false);
				if (!_.isEmpty(leaves) && _.has(leaves, READ_BOOK_RUBRIC_KEY)) {
					return _defineProperty({}, READ_BOOK_RUBRIC_KEY, leaves[READ_BOOK_RUBRIC_KEY]);
				}
			}
	
			// user is on a free account and hasn't manually graded answer
	
		}, {
			key: "hideAutograderScore",
			value: function hideAutograderScore(evaluation) {
				evaluation = evaluation ? evaluation : this.props.evaluation;
				return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score;
			}
		}, {
			key: "handleRubricOverride",
			value: function handleRubricOverride(selectedOp) {
				this.setState({ rubricOverride: _defineProperty({}, READ_BOOK_RUBRIC_KEY, selectedOp) });
			}
	
			// allows teachers to edit rubric items
	
		}, {
			key: "renderRubricItemOverride",
			value: function renderRubricItemOverride() {
				if (this.props.evaluation.subject_type == 'Quiz') {
					return React.createElement(RubricItemOverride, { view: 'quizReadBook', onChange: this.handleRubricOverride, leaves: this.getReadBookLeaf(), evaluation: this.props.evaluation });
				}
			}
	
			// shows save button if admin has edited score or rubric item
	
		}, {
			key: "renderSaveButton",
			value: function renderSaveButton() {
				var _state = this.state,
				    editedScore = _state.editedScore,
				    rubricOverride = _state.rubricOverride;
	
				var currentScore = this.hideAutograderScore() ? 0 : $wr.convertedScore(this.props.evaluation.ratio, this.props.displayScoreCap || 4);
	
				if (editedScore !== currentScore || !_.isEmpty(rubricOverride)) {
					return React.createElement(
						"button",
						{ className: "btn btn-link saveButton" },
						"Save"
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.evaluation && this.props.enabled.editScore) {
	
					if (this.state.showOverrideFeedback) {
						var overrideFeedback = React.createElement(ReactionFeedback, { where: "override-eval",
							textOnly: true,
							textTitle: "Our score was different than yours.",
							placeholder: "What did we miss? Why did you give it that score?",
							popover_position: ReactionFeedback.POSITION_BOTTOM_LEFT,
							subjectType: "Evaluation", subjectID: this.props.evaluation.id });
					}
	
					var editScore = React.createElement(
						"form",
						{ onSubmit: this.saveEvaluation, className: "editRow" },
						React.createElement(
							"div",
							null,
							React.createElement(
								"div",
								null,
								"Edit Score: ",
								React.createElement(NumbersOnlyInput, { className: "form-control scoreEdit", allowDecimal: true,
									value: this.state.editedScore, step: 0.5,
									onChange: function onChange(e) {
										return _this2.setState({ editedScore: parseFloat(e.target.value) });
									},
									max: this.displayScoreCap(), min: 0 }),
								" / ",
								this.displayScoreCap()
							),
							React.createElement(
								"div",
								{ className: "readTheBookOverride" },
								this.renderRubricItemOverride()
							),
							this.renderSaveButton()
						),
						overrideFeedback
					);
				}
	
				if (this.props.enabled.toggleInclude) {
					if (this.props.excluded) {
						var excludeIncludeToggle = React.createElement(
							"div",
							{ className: "editRow" },
							React.createElement(
								"a",
								{ href: "#", onClick: this.includeAnswer },
								"Include In Goals"
							)
						);
					} else {
						var excludeIncludeToggle = React.createElement(
							"div",
							{ className: "editRow" },
							React.createElement(
								"a",
								{ href: "#", onClick: this.excludeAnswer },
								"Exclude From Goals"
							)
						);
					}
				}
	
				if (this.props.enabled.deletion) {
					var deleteSubject = React.createElement(
						"div",
						{ className: "editRow" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.deleteAnswer },
							"Delete ",
							$wr.capitalize(this.props.noun)
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "editControls" },
					editScore,
					excludeIncludeToggle,
					deleteSubject
				);
			}
		}]);
	
		return EditControls;
	}(React.Component)) || _class);
	;
	
	var READ_BOOK_RUBRIC_KEY = "crit-evi-cote-bert-read-book-1";
	
	EditControls.propTypes = StrictPropTypes({
		answerID: PropTypes.number,
		quizID: PropTypes.number,
	
		// "enabled" keys used in *this (edit control)* component (others are ignored)
		//   editScore				-> Changes the score
		//   deletion 				-> Deletes the answer
		//   toggleInclude			-> Passed from answers -> controls
		//
		enabled: PropTypes.object,
	
		// From @connect
		onDelete: PropTypes.func,
		onRevert: PropTypes.func,
		onInclude: PropTypes.func,
		onExclude: PropTypes.func,
		onUpdate: PropTypes.func,
		afterDelete: PropTypes.func,
		noun: PropTypes.string,
		excluded: PropTypes.string
	});
	
	module.exports = EditControls;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactSelect = __webpack_require__(154);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var GradeLevel = __webpack_require__(40);
	var WhooosReadingServices = __webpack_require__(25);
	var AutograderFeedback = __webpack_require__(258);
	var FeedbackFormatter = __webpack_require__(73);
	var AutograderDisplayConfig = __webpack_require__(83);
	var SurveyPromptConfig = __webpack_require__(257);
	var SurveyPromptDisplay = __webpack_require__(408);
	var TextAreaMarkups = __webpack_require__(196);
	
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	var GradeLevelSpecifications = __webpack_require__(995);
	
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	var Spinner = __webpack_require__(9);
	
	var AnswerLengthMeter = __webpack_require__(425);
	var QuestionFeedback = __webpack_require__(173);
	var BookCover = __webpack_require__(140);
	
	__webpack_require__(3839);
	
	var AutograderDemo = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    prompt: DataSelectors.surveyPrompt({ state: state, conditions: { key: 'improve_autograder_and_rubric' } })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      return dispatch(DataActions.fetchSurveyPrompts({ conditions: { key: 'improve_autograder_and_rubric' } }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(AutograderDemo, _React$Component);
	
	  function AutograderDemo(props) {
	    _classCallCheck(this, AutograderDemo);
	
	    var _this = _possibleConstructorReturn(this, (AutograderDemo.__proto__ || Object.getPrototypeOf(AutograderDemo)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("AutograderDemo");
	
	    if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-modal")) {
	      $(window.document).trigger("onboarding-trigger-autograder-demo");
	    }
	
	    _this.state = {
	      book: null, question: _this.defaultQuestion(), showQuestionSelector: false,
	      answer: {}, feedbackLoading: false, hideFeedback: false,
	      lastSubmittedText: null, feedbackOverridden: false, overriddenTriggers: [],
	      gradeEvals: [], showSurveyPrompt: true
	    };
	    return _this;
	  }
	
	  //////////////////////////////////////////
	  // Helpers //////////////////////////////
	  //////////////////////////////////////////
	
	
	  _createClass(AutograderDemo, [{
	    key: "defaultQuestion",
	    value: function defaultQuestion() {
	      return QUESTION_OPTIONS[0];
	    }
	  }, {
	    key: "getAcademicLevel",
	    value: function getAcademicLevel() {
	      return CurrentUser.get().prefs && CurrentUser.get().prefs.academic_level ? CurrentUser.get().prefs.academic_level : 3;
	    }
	  }, {
	    key: "idLoading",
	    value: function idLoading() {
	      return this.state.feedbackLoading;
	    }
	  }, {
	    key: "answerParts",
	    value: function answerParts() {
	      return this.state.answer.parts;
	    }
	  }, {
	    key: "answerBodyText",
	    value: function answerBodyText() {
	      return this.refs.textarea ? this.refs.textarea.value : '';
	    }
	
	    // Check to see if a particular filter was detected.
	
	  }, {
	    key: "hasFilter",
	    value: function hasFilter(filter, autograderData) {
	      if (autograderData && autograderData.filtering) {
	        var filters = _.keys(autograderData.filtering);
	        return filters.includes(filter);
	      } else {
	        return false;
	      }
	    }
	
	    // extract polorizing hash from evaluation
	
	  }, {
	    key: "polarizingHashes",
	    value: function polarizingHashes() {
	      var gradeEvals = this.state.gradeEvals;
	
	      return _.map(_.pluck(gradeEvals, 'polarizing'), function (layer) {
	        return AutograderDisplayConfig.getRubricLeaves(layer, true);
	      });
	    }
	  }, {
	    key: "labelValue",
	    value: function labelValue(val) {
	      var val = $wr.toTitleCase(val);
	      return val in OUTPUT_ABBREV ? OUTPUT_ABBREV[val] : val;
	    }
	  }, {
	    key: "gradeAutograderData",
	    value: function gradeAutograderData() {
	      return _.findWhere(this.state.gradeEvals, { grade_level: this.getAcademicLevel() || 3 });
	    }
	
	    // determinse the background and font classes for rubric labels
	
	  }, {
	    key: "colorClasses",
	    value: function colorClasses(value) {
	      // if value is not a string, return black
	      if (!(typeof value == 'string')) {
	        return { backgroundClass: 'backgroundColor-black', fontClass: 'fontColor-black' };
	      }
	
	      if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-green';
	        var fontClass = 'fontColor-green';
	      } else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-red';
	        var fontClass = 'fontColor-red';
	      } else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, $wr.toTitleCase(value))) {
	        var backgroundClass = 'backgroundColor-yellow';
	        var fontClass = 'fontColor-yellow';
	      }
	
	      return { backgroundClass: backgroundClass, fontClass: fontClass };
	    }
	  }, {
	    key: "getBadgeForAGKey",
	    value: function getBadgeForAGKey(key) {
	      if (_.includes(AutograderDisplayConfig.NEW_KEYS, key)) {
	        return React.createElement(
	          "span",
	          { className: "badge backgroundColor-dark-green" },
	          "New!"
	        );
	      } else if (_.includes(AutograderDisplayConfig.BETA_KEYS, key)) {
	        return React.createElement(
	          "span",
	          { className: "badge backgroundColor-blue" },
	          "Beta"
	        );
	      }
	    }
	
	    // scrolls to bottom of modal
	
	  }, {
	    key: "scrollToBottom",
	    value: function scrollToBottom() {
	      $('.autograderDemoModal').first().animate({ scrollTop: $(".autograderDemoModal").first().height() }, 'slow');
	    }
	
	    //////////////////////////////////////////
	    // Feedback //////////////////////////////
	    //////////////////////////////////////////
	
	  }, {
	    key: "feedbackSubs",
	    value: function feedbackSubs() {
	      var autograderData = this.gradeAutograderData();
	      if (autograderData && autograderData.feedback_subs) {
	        return autograderData.feedback_subs;
	      }
	    }
	  }, {
	    key: "feedbackItems",
	    value: function feedbackItems() {
	      var _this2 = this;
	
	      var autograderData = this.gradeAutograderData();
	      if (autograderData && autograderData.assisting) {
	        var feedbackItems = _.map(autograderData.assisting.selected_content, function (content, priority) {
	          if (!content.trigger || !_.includes(_this2.state.overriddenTriggers, content.trigger)) {
	            return content;
	          }
	        });
	        return _.compact(feedbackItems);
	      }
	    }
	  }, {
	    key: "showFeedback",
	    value: function showFeedback() {
	      return _.any(this.feedbackItems()) && !this.state.hideFeedback && !this.state.feedbackLoading;
	    }
	  }, {
	    key: "checkAddressedFeedback",
	    value: function checkAddressedFeedback(newAutograderData) {
	      var oldAutograderData = this.gradeAutograderData();
	      if (!(oldAutograderData && newAutograderData && oldAutograderData.assisting && newAutograderData.assisting)) {
	        return false;
	      }
	
	      var previousFeedback = oldAutograderData.assisting.selected_feedback;
	      var currentFeedback = newAutograderData.assisting.eligible_feedback;
	
	      if (!currentFeedback.includes(previousFeedback)) {
	        return true;
	      }
	      return false;
	    }
	
	    // For feedback, check to see if we should show the coin award option.
	    // Don't show if answer is too short to grade properly
	
	  }, {
	    key: "shouldRewardShow",
	    value: function shouldRewardShow() {
	      var autograderData = this.gradeAutograderData();
	
	      if (!autograderData) {
	        return false;
	      }
	
	      // Check if answer is too short
	      if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
	        return false;
	      }
	
	      return true;
	    }
	
	    // adds feedback override to metadata
	
	  }, {
	    key: "onFeedbackOverride",
	    value: function onFeedbackOverride(data, reason, e) {
	      $wr.nope(e);
	      this.setState({ feedbackOverridden: true, overriddenTriggers: [].concat(_toConsumableArray(this.state.overriddenTriggers), [data.trigger]) });
	    }
	
	    //////////////////////////////////////////
	    // State setters /////////////////////////
	    //////////////////////////////////////////
	
	  }, {
	    key: "hideSurveyPrompts",
	    value: function hideSurveyPrompts() {
	      this.setState({ showSurveyPrompt: !this.state.showSurveyPrompt });
	    }
	  }, {
	    key: "setSelectedText",
	    value: function setSelectedText(val) {
	      this.setState({ book: val }, this.scrollToBottom);
	    }
	  }, {
	    key: "showQuestionSelector",
	    value: function showQuestionSelector() {
	      this.setState({ showQuestionSelector: true });
	    }
	
	    // changes question
	
	  }, {
	    key: "onQuestionChange",
	    value: function onQuestionChange(newQuestion) {
	      this.setState({ showQuestionSelector: false, question: _.findWhere(QUESTION_OPTIONS, { key: newQuestion.value }) });
	    }
	
	    //////////////////////////////////////////
	    // Submit methods ////////////////////////
	    //////////////////////////////////////////
	
	  }, {
	    key: "submitAnswer",
	    value: function submitAnswer() {
	      var _this3 = this;
	
	      var _state = this.state,
	          book = _state.book,
	          question = _state.question;
	
	
	      if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
	        $(window.document).trigger("onboarding-trigger-autograder-demo");
	      }
	
	      if (_.size(this.answerBodyText()) == 0) {
	        var errorText = "Please write at least a short response to this question.";
	        window.wrNotifications.triggerDropDownNotification({
	          title: "We need a bit more!", icon: "pencil", text: errorText
	        });
	        return;
	      }
	
	      var answerData = {
	        answer: this.answerBodyText(),
	        answerParts: this.answerParts(),
	        starters: [],
	        text: book,
	        questionKey: question.key,
	        questionText: question.body, quiz: true,
	        gradeDemo: true
	      };
	
	      this.setState({ gradeEvals: [], feedbackLoading: true, lastSubmittedText: this.answerBodyText() });
	
	      var evalPromise = function evalPromise(answerData) {
	        return new Promise(function (resolve, reject) {
	          AutograderFeedback.fetch(answerData, function (result) {
	            result && result.autograderData ? resolve(result.autograderData) : resolve(null);
	          });
	        });
	      };
	
	      evalPromise(answerData).then(function (evals) {
	        _this3.setState({ feedbackLoading: false });
	        if (_.any(_.values(evals), function (e) {
	          return e == null;
	        })) {
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Something went wrong on our end, sorry!",
	            text: "This is embarrassing for us... try refreshing the page or trying again later.",
	            icon: "exclamation-sign", type: "error"
	          }, 6000);
	        } else {
	          _this3.setState({ gradeEvals: _.values(evals), feedbackLoading: false }, _this3.scrollToBottom);
	        }
	      }).catch(function (error) {
	        _this3.setState({ feedbackLoading: false });
	        console.log(error);
	      });
	    }
	
	    //////////////////////////////////////////
	    // Render methods ////////////////////////
	    //////////////////////////////////////////
	
	  }, {
	    key: "renderQuestionDisplay",
	    value: function renderQuestionDisplay() {
	      if (this.state.showQuestionSelector) {
	        var options = _.map(QUESTION_OPTIONS, function (q) {
	          return { label: q.body, value: q.key };
	        });
	
	        var content = React.createElement(_reactSelect2.default, { name: "demoQuestion", searchable: false, clearable: false,
	          value: { label: this.state.question.body }, options: options, onChange: this.onQuestionChange.bind(this) });
	      } else {
	        var changeQuestionLink = React.createElement(
	          "div",
	          { className: "changeQuestionLink" },
	          React.createElement(
	            "a",
	            { href: "#", onClick: this.showQuestionSelector },
	            React.createElement(Glyphicon, { icon: "edit" }),
	            " Change Question"
	          )
	        );
	
	        var content = React.createElement(
	          "span",
	          null,
	          this.state.question.body,
	          " ",
	          changeQuestionLink
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { className: "promptText clearfix" },
	        content
	      );
	    }
	  }, {
	    key: "renderWritingInterface",
	    value: function renderWritingInterface() {
	      return React.createElement("textarea", { key: this.state.question.key,
	        className: "form-control singleAnswer LoNotSensitive", rows: "6", ref: "textarea"
	      });
	    }
	  }, {
	    key: "renderAnswerLengthMeter",
	    value: function renderAnswerLengthMeter() {
	      var answerLength = _.size(this.answerBodyText());
	
	      var charCount = GradeLevel.getRecommendedAnswerLength(this.getAcademicLevel());
	      var filterCount = GradeLevel.getCharCountFilter(this.getAcademicLevel());
	
	      charCount = Math.max(charCount * 0.8, 20);
	      filterCount = Math.max(filterCount, 20);
	
	      return React.createElement(
	        "div",
	        { id: "answerLengthMeter" },
	        React.createElement(AnswerLengthMeter, { currentCharCount: answerLength,
	          charCount: charCount, filterCount: filterCount })
	      );
	    }
	  }, {
	    key: "renderButton",
	    value: function renderButton() {
	      var _this4 = this;
	
	      var btnText = _.isEmpty(this.state.gradeEvals) ? "Grade Answer" : "Regrade My Answer";
	      return React.createElement(
	        "div",
	        { className: "buttons" },
	        React.createElement(LoadingButton, { className: "btn buttonPrimary", text: btnText,
	          onClick: function onClick() {
	            return _this4.submitAnswer();
	          }, loading: this.state.feedbackLoading }),
	        React.createElement(ReactTooltip, { effect: "solid" })
	      );
	    }
	  }, {
	    key: "renderFeedback",
	    value: function renderFeedback() {
	      if (this.showFeedback()) {
	        var subs = this.feedbackSubs();
	        var renderedItems = _.map(this.feedbackItems(), function (item) {
	          var feedbackItem = FeedbackFormatter.format(_.first(item.content), subs);
	          feedbackItem.data = item;
	          return feedbackItem;
	        });
	        return React.createElement(
	          "div",
	          { className: "questionFeedbackBox" },
	          React.createElement(QuestionFeedback, { onFeedbackOverride: this.onFeedbackOverride, feedbackItems: renderedItems,
	            showFeedbackReward: this.shouldRewardShow() })
	        );
	      }
	    }
	  }, {
	    key: "renderStartTrialBtn",
	    value: function renderStartTrialBtn() {
	      var user = CurrentUser.get();
	      var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrSilver&days=30";
	      var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
	
	      return React.createElement(
	        "a",
	        { href: trialURL },
	        "Start your free 30 day trial of Silver"
	      );
	    }
	  }, {
	    key: "renderConsultationLink",
	    value: function renderConsultationLink() {
	      var linkEventHandler = Mycroft.buildEventHandler({
	        category: "Consultation Call", action: "schedule-consultation", label: 'Schedule a Consultation'
	      });
	
	      return React.createElement(
	        "span",
	        null,
	        "If you are interested in upgrading your account,",
	        React.createElement(
	          "a",
	          { href: "https://calendly.com/whooos-reading/wrs-consultation", className: "consultationLink", target: "_blank", onClick: linkEventHandler },
	          "schedule a consultation"
	        )
	      );
	    }
	  }, {
	    key: "renderUpgradeLink",
	    value: function renderUpgradeLink() {
	      if (!CurrentUser.isPremiumOrTrialAccount()) {
	        return React.createElement(
	          "div",
	          { className: "upgradeDisclaimer" },
	          React.createElement(
	            "div",
	            { className: "title" },
	            "Important note"
	          ),
	          React.createElement(
	            "div",
	            { className: "description" },
	            "As a free user, ",
	            React.createElement(
	              "b",
	              null,
	              "your plan does not include rubric analytics"
	            ),
	            ". ",
	            this.renderStartTrialBtn(),
	            "."
	          )
	        );
	      }
	    }
	
	    // looks up grade level specifications for a rubric item
	
	  }, {
	    key: "gradeLevelSpecificationToolTip",
	    value: function gradeLevelSpecificationToolTip(rubricKey) {
	      var polarizingKey = AutograderDisplayConfig.POLARIZING_KEY_TO_RUBRIC_KEY[rubricKey];
	      var gradeLevelExpectations = GradeLevelSpecifications[polarizingKey][this.getAcademicLevel()] || GradeLevelSpecifications[polarizingKey]['default'];
	      if (gradeLevelExpectations) {
	        return _.map(gradeLevelExpectations, function (exp, i) {
	          var returnVal = exp;
	          if (i == 0) {
	            returnVal = "<span>" + returnVal;
	          }
	
	          if (_.size(gradeLevelExpectations) - 1 != i) {
	            returnVal = returnVal + "<br/><br/>";
	          }
	
	          if (_.size(gradeLevelExpectations) - 1 == i) {
	            returnVal = returnVal + "</span>";
	          }
	
	          return returnVal;
	        }).join('');
	      }
	    }
	  }, {
	    key: "renderRubric",
	    value: function renderRubric() {
	      var _this5 = this;
	
	      var gradeEvals = this.state.gradeEvals;
	
	      if (_.size(gradeEvals) == 9) {
	        // grade level headers
	        var headerRow = [React.createElement("th", { className: "longCell", key: 'gradeLevel-0' })];
	        _.each([].concat(_toConsumableArray(Array(9).keys())), function (i) {
	          if (i == 0) {
	            var text = 'K-1';
	          } else if (i == 8) {
	            var text = 'Grade 9+';
	          } else {
	            var text = "Grade " + (i + 1);
	          }
	
	          headerRow.push(React.createElement(
	            "th",
	            { className: "standardCell headerCell", key: "gradeLevel-" + (i + 1) },
	            text
	          ));
	        });
	
	        // rows of labels
	        var bodyRows = _.keys(this.polarizingHashes()[0]).map(function (rubricKey, ridx) {
	          var badge = _this5.getBadgeForAGKey(rubricKey);
	          var cells = [React.createElement(
	            "td",
	            { className: "longCell", key: "rubricKey-" + ridx },
	            AutograderDisplayConfig.getLeafName(rubricKey),
	            badge
	          )];
	          _.each(_this5.polarizingHashes(), function (evaluation, eidx) {
	            if (evaluation[rubricKey].value) {
	              var dataTip = _this5.gradeLevelSpecificationToolTip(rubricKey);
	
	              var _colorClasses = _this5.colorClasses(evaluation[rubricKey].value),
	                  backgroundClass = _colorClasses.backgroundClass,
	                  fontClass = _colorClasses.fontClass;
	
	              cells.push(React.createElement(
	                "td",
	                { className: "standardCell", key: rubricKey + "-" + eidx, "data-tip": dataTip, "data-for": rubricKey + "-" + eidx, "data-html": true },
	                React.createElement(
	                  "div",
	                  { className: "textContainer " + backgroundClass + " " + fontClass },
	                  _this5.labelValue(evaluation[rubricKey].value)
	                ),
	                React.createElement(ReactTooltip, { effect: "solid", id: rubricKey + "-" + eidx })
	              ));
	            } else {
	              cells.push(React.createElement("td", null));
	            }
	          });
	          return React.createElement(
	            "tr",
	            { key: rubricKey + "-" + ridx },
	            cells
	          );
	        });
	
	        // return table
	        return React.createElement(
	          "span",
	          null,
	          this.renderStep(3),
	          React.createElement(
	            "div",
	            { className: "rubricTableContainer" },
	            React.createElement(
	              "table",
	              { className: "table table-borderless" },
	              React.createElement(
	                "thead",
	                null,
	                React.createElement(
	                  "tr",
	                  null,
	                  headerRow
	                )
	              ),
	              React.createElement(
	                "tbody",
	                null,
	                bodyRows
	              )
	            )
	          ),
	          this.renderSurveyPrompt(),
	          this.renderUpgradeLink()
	        );
	      } else if (_.size(gradeEvals)) {
	        // render loading
	        return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	      }
	    }
	
	    // highlighted sections of text evidence
	
	  }, {
	    key: "renderTextEvidenceTags",
	    value: function renderTextEvidenceTags() {
	      var autograderData = this.gradeAutograderData();
	      if (autograderData && autograderData.polarizing) {
	        var polarizingHash = autograderData.polarizing;
	        if (polarizingHash[TEXT_EVIDENCE_KEY] && !_.isEmpty(polarizingHash[TEXT_EVIDENCE_KEY].tags)) {
	          var content = React.createElement(TextAreaMarkups, { text: this.state.lastSubmittedText || '', tagColors: { 'KNOWN_TEXT_VOCAB': '#c0f2aa', 'KNOWN_TEXT_GROUP': '#96dafe' },
	            tagging: polarizingHash[TEXT_EVIDENCE_KEY].tags });
	        } else {
	          var content = "No text evidence detected";
	        }
	
	        return React.createElement(
	          "div",
	          { className: "textEvidenceContainer" },
	          React.createElement(
	            "div",
	            { className: "step" },
	            React.createElement(
	              "div",
	              { className: "title" },
	              "Text Evidence Identified"
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "textEvidenceContent" },
	            content
	          )
	        );
	      }
	    }
	
	    // render text area if book is selected
	
	  }, {
	    key: "renderAnswerWritingInterface",
	    value: function renderAnswerWritingInterface() {
	      if (this.state.book) {
	        var slideClassName = this.showFeedback() ? " slideLeft" : "";
	
	        return React.createElement(
	          "span",
	          null,
	          this.renderStep(2),
	          React.createElement(
	            "div",
	            { className: "clearfix answerFeedbackContainer" },
	            React.createElement(
	              "div",
	              { className: "questionOptionBox" + slideClassName },
	              this.renderQuestionDisplay(),
	              this.renderWritingInterface(),
	              this.renderAnswerLengthMeter(),
	              React.createElement(
	                "div",
	                { className: "controls" },
	                this.renderButton()
	              )
	            ),
	            this.renderFeedback(),
	            React.createElement("div", { className: "clearfix" }),
	            this.renderTextEvidenceTags(),
	            React.createElement("div", { className: "clearfix" }),
	            this.renderRubric()
	          )
	        );
	      }
	    }
	
	    // renders book option boxes
	
	  }, {
	    key: "renderTextSelector",
	    value: function renderTextSelector() {
	      var _this6 = this;
	
	      var options = _.map(BOOK_OPTIONS, function (bookOp) {
	        var className = "largeObject clickableElement";
	        if (_this6.state.book && _this6.state.book.text_id == bookOp.text_id) {
	          className += " selected";
	        }
	
	        return React.createElement(
	          "div",
	          { key: bookOp.text_id, className: className,
	            onClick: function onClick() {
	              return _this6.setSelectedText(bookOp);
	            } },
	          React.createElement(BookCover, { book: bookOp, coverWidth: 80,
	            showTitle: true, showAuthor: false })
	        );
	      });
	
	      return React.createElement(
	        "span",
	        null,
	        this.renderStep(1),
	        React.createElement(
	          "div",
	          { className: "bookOptionsContainer" },
	          options
	        )
	      );
	    }
	  }, {
	    key: "renderIntroParagraph",
	    value: function renderIntroParagraph() {
	      return React.createElement(
	        "div",
	        { className: "intro" },
	        "Our autograder, backed by the National Science Foundation, does three things:",
	        React.createElement(
	          "div",
	          { className: "list" },
	          React.createElement(
	            "div",
	            null,
	            "1. Provides ",
	            React.createElement(
	              "b",
	              null,
	              "in-the-moment feedback for your students"
	            ),
	            " to help them revise their answers."
	          ),
	          React.createElement(
	            "div",
	            null,
	            "2. Evaluates and ",
	            React.createElement(
	              "b",
	              null,
	              "scores every written response"
	            ),
	            " your students write about their books."
	          ),
	          React.createElement(
	            "div",
	            null,
	            "3. Gives you data on ",
	            React.createElement(
	              "b",
	              null,
	              "10+ reading and writing skills"
	            ),
	            " based on your students' answers."
	          )
	        ),
	        React.createElement(
	          "p",
	          null,
	          "Our autograder's detailed rubric shows you exactly what skill your students are mastering and where they need extra support."
	        ),
	        React.createElement(
	          "p",
	          null,
	          "The autograder technology includes built-in differentiation based on your students' Academic Level, so a student at a 2nd grade level has a vastly different feedback and evaluation experience than another at an 8th grade level."
	        )
	      );
	    }
	  }, {
	    key: "renderStep",
	    value: function renderStep(stepNum) {
	      return React.createElement(
	        "div",
	        { className: "step" },
	        React.createElement(
	          "div",
	          { className: "title" },
	          "Step ",
	          stepNum,
	          ": ",
	          STEPS[stepNum]['title']
	        ),
	        React.createElement(
	          "div",
	          { className: "subtitle" },
	          STEPS[stepNum]['subtitle']
	        )
	      );
	    }
	  }, {
	    key: "renderSurveyPrompt",
	    value: function renderSurveyPrompt() {
	      if (this.state.showSurveyPrompt) {
	        var prompt = _.extend(SurveyPromptConfig.CONFIG[this.props.prompt.key], this.props.prompt);
	        prompt.options = prompt.options.split('|');
	
	        return React.createElement(
	          "div",
	          { className: "surveyPromptContainer contentSurvey twoRows" },
	          React.createElement(SurveyPromptDisplay, {
	            onSubmitFeedback: this.hideSurveyPrompts,
	            prompt: prompt,
	            userID: CurrentUser.get().id
	          })
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { id: "autograderDemo", className: "autograderDemo" },
	        this.renderIntroParagraph(),
	        this.renderTextSelector(),
	        this.renderAnswerWritingInterface()
	      );
	    }
	  }]);
	
	  return AutograderDemo;
	}(React.Component)) || _class) || _class);
	;
	
	//////////////////////////////////////////
	// Constants /////////////////////////////
	//////////////////////////////////////////
	var BOOK_OPTIONS = [{
	  title: "The Kid Who Ran for President",
	  text_id: "BASEv-ksokC6AqHZMSGcMMlAMQ",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEv-ksokC6AqHZMSGcMMlAMQ.jpg",
	  img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1388248991l/134314.jpg",
	  lexile_score: 730,
	  text_variety: "fiction",
	  author_full_name: "Dan Gutman"
	}, {
	  title: "Dog Man",
	  text_id: "BASEAOH8j3w9WsZOxNQ9dzAUFQ",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEAOH8j3w9WsZOxNQ9dzAUFQ.jpg",
	  img_url: "http://images.gr-assets.com/books/1456963971m/28691896.jpg",
	  lexile_score: 390,
	  text_variety: "fiction",
	  author_full_name: "Dav Pilkey"
	}, {
	  title: "Harry Potter and the Half-Blood Prince",
	  text_id: "BASEm63cVUZNZ5HY11ddGWD4lw",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEm63cVUZNZ5HY11ddGWD4lw.jpg",
	  img_url: "http://images.gr-assets.com/books/1361039191m/1.jpg",
	  lexile_score: 920,
	  text_variety: "fiction",
	  author_full_name: "J.K. Rowling"
	}, {
	  title: "Diary of a Wimpy Kid",
	  text_id: "BASECT2oC2Dz_6QR5EkAW0SaSw",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASECT2oC2Dz_6QR5EkAW0SaSw.jpg",
	  img_url: "https://images.gr-assets.com/books/1388183826l/389627.jpg",
	  lexile_score: 950,
	  text_variety: "fiction",
	  author_full_name: "Jeff Kinney"
	}, {
	  title: "Polar Bear vs. Grizzly Bear",
	  text_id: "BASEG6VrmMVPWsnfxG_fw2_9jA",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEG6VrmMVPWsnfxG_fw2_9jA.jpg",
	  img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1363913976l/9517995.jpg",
	  lexile_score: 720,
	  text_variety: "non-fiction",
	  author_full_name: "Jerry Pallotta"
	}, {
	  title: "To Kill a Mockingbird",
	  text_id: "BASEbPUyebgBeNFuLgVhJ5GvkQ",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEbPUyebgBeNFuLgVhJ5GvkQ.jpg",
	  img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1553383690l/2657.jpg",
	  lexile_score: 790,
	  text_variety: "fiction",
	  author_full_name: "Harper Lee"
	}, {
	  title: "Sisters",
	  text_id: "BASE9S4V0Kl0Hze8FzJi8b4ISA",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASE9S4V0Kl0Hze8FzJi8b4ISA.jpg",
	  img_url: "http://images.gr-assets.com/books/1411022689m/18225810.jpg",
	  lexile_score: 290,
	  text_variety: "fiction",
	  author_full_name: "Raina Telgemeier"
	}, {
	  title: "Hatchet",
	  url: null,
	  text_id: "BASEFtxN7k9uV4e6bfT-bZZjNg",
	  cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEFtxN7k9uV4e6bfT-bZZjNg.jpg",
	  img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1385297074l/50.jpg",
	  lexile_score: 1020,
	  text_variety: "fiction",
	  author_full_name: "Gary Paulsen"
	}];
	
	var QUESTION_OPTIONS = [{
	  body: "What made the main character unique?",
	  key: "rl3-key-connections--3--what-made-the-main-character"
	}, {
	  body: "How do you think the main character would solve a future problem in life? Include details from the text to support your thoughts.",
	  key: "rl3-key-connections-how-do-you-think-the-main-char"
	}, {
	  body: "Would you want to be a part of this story—one of the characters living in this time and place? Explain why or why not.",
	  key: "rl3-key-connections-would-you-want-to-be-a-part-of"
	}, {
	  body: "Which character helped the main character the most? Explain how that character helped using details from the text.",
	  key: "rl1-key-details-which-character-helped-the-mai"
	}, {
	  body: "How did the central idea develop over the course of the text?",
	  key: "ri2-key-main--78--how-did-the-central-idea"
	}];
	
	var TOOLTIP_LOOKUP = {
	  'crit-evi-cote-bert-read-book-1': 'Base on threshold of 2-3 text-specific details'
	};
	
	var STEPS = {
	  1: { title: 'Select a book', subtitle: "The Whooo's Reading library of texts is not restrictive. There are standards-aligned quizzes available for any title students read. Here is a small sample of our most popular books:" },
	  2: { title: 'Write a response', subtitle: 'Click "Change Question" to choose from a small sample of our quiz questions. Then write a response and see how students receive in-the-moment feedback from Owlfonso.' },
	  3: { title: 'Analyze rubric results', subtitle: "With each open-ended quiz question and practice question students write, teachers can analyze the scoring rubric to find where students are excelling and struggling. Evaluations vary by grade level to ensure that students are being graded appropriately." }
	};
	
	var TEXT_EVIDENCE_KEY = 'crit-evi-cote-bert-quantity-14';
	
	var OUTPUT_ABBREV = {
	  'Sufficient': 'Suf',
	  'Insufficient': 'Insuf',
	  'Incorrect': 'Incor',
	  'Developing': 'Dev'
	};
	
	module.exports = AutograderDemo;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EvaluationItem = __webpack_require__(958);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3840);
	
	var EvaluationBox = function (_React$Component) {
		_inherits(EvaluationBox, _React$Component);
	
		function EvaluationBox(props) {
			_classCallCheck(this, EvaluationBox);
	
			var _this = _possibleConstructorReturn(this, (EvaluationBox.__proto__ || Object.getPrototypeOf(EvaluationBox)).call(this));
	
			autobind(_this);
	
			var evaluation = props.response.evaluation;
			var editValue = !(evaluation && evaluation.score >= 0 && (evaluation.finalized || !_this.isEditable(props)));
	
			_this.state = {
				edit: editValue, highlightScore: null
			};
			return _this;
		}
	
		_createClass(EvaluationBox, [{
			key: "isEditable",
			value: function isEditable(props) {
				var props = props || this.props;
				return CurrentUser.isAdmin() && props.onChange != undefined;
			}
		}, {
			key: "handleChange",
			value: function handleChange(newScore) {
				if (this.state.edit) {
					if (this.props.onChange) {
						this.props.onChange(newScore);
					}
	
					this.setState({ edit: false });
				} else {
					this.setState({ edit: true });
				}
			}
		}, {
			key: "render",
			value: function render() {
				var evaluationItem;
				var isVisible = CurrentUser.hasID(this.props.response.user_id) || CurrentUser.isAdmin();
				var evaluation = this.props.response.evaluation;
	
				if (!this.state.edit && isVisible && evaluation && evaluation.finalized) {
					// Show the grade if we are a student or a teacher not in edit mode
					evaluationItem = React.createElement(
						"span",
						{ className: "evalOptions evaluationBox" },
						React.createElement(
							"span",
							{ className: "evalSelected" },
							React.createElement(EvaluationItem, { score: evaluation.score, handleChange: this.handleChange,
								clickable: this.isEditable(), isSelected: true,
								sharedNewsFeedItem: this.props.sharedNewsFeedItem })
						)
					);
				} else if (this.isEditable()) {
	
					var items = [];
					for (var i = 1; i <= EvaluationBox.MAX_SCORE; i++) {
						if (evaluation) {
							var isSel = evaluation.score == i;
							var autoGraded = isSel && !evaluation.finalized;
						} else if (this.state.highlightScore) {
							var isSel = this.state.highlightScore == i;
						}
						items.push(React.createElement(EvaluationItem, { score: i, key: i, isSelected: isSel,
							clickable: this.isEditable(),
							handleChange: this.handleChange, autoGraded: autoGraded }));
					}
					evaluationItem = React.createElement(
						"span",
						{ className: "evaluationBox", ref: "container" },
						React.createElement(
							"span",
							{ className: "evalSelection" },
							items
						)
					);
				} else {
					evaluationItem = React.createElement("span", null);
				}
				return evaluationItem;
			}
		}]);
	
		return EvaluationBox;
	}(React.Component);
	
	;
	
	EvaluationBox.MAX_SCORE = 3;
	
	EvaluationBox.propTypes = StrictPropTypes({
		response: PropTypes.object.isRequired,
		onChange: PropTypes.func
	});
	
	module.exports = EvaluationBox;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var HelpSectionLink = __webpack_require__(64);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var Glyphicon = __webpack_require__(8);
	var AutograderDisplayConfig = __webpack_require__(83);
	var ReactTooltip = __webpack_require__(12);
	
	var WritingActions = __webpack_require__(24);
	
	__webpack_require__(3842);
	
	var RubricItemOverride = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {};
	}, function (dispatch, props) {
	  return {
	    onUpdate: function onUpdate(evaluationID, updateData) {
	      dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: updateData })).then(function (e) {
	        dispatch(WritingActions.fetchEvaluations({
	          filters: { subject_type: 'Answer', subject_id: e.subject_id },
	          embeds: ["evaluation.autograder_data", "evaluation.score_details"]
	        }));
	      });
	    }
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(RubricItemOverride, _React$Component);
	
	  function RubricItemOverride(props) {
	    _classCallCheck(this, RubricItemOverride);
	
	    var _this = _possibleConstructorReturn(this, (RubricItemOverride.__proto__ || Object.getPrototypeOf(RubricItemOverride)).call(this));
	
	    autobind(_this);
	
	    _this.state = { rubricOverride: {}, read_book: null };
	    return _this;
	  }
	
	  _createClass(RubricItemOverride, [{
	    key: "saveEvaluation",
	    value: function saveEvaluation(e) {
	      $wr.nope(e);
	
	      var evaluation = this.props.evaluation;
	
	      // Included both score (for immediate display) and adminScore (for the API Patch)
	
	      var updateData = { rubric_override: _extends({}, this.state.rubricOverride) };
	
	      this.props.onUpdate(evaluation.id, updateData);
	
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Rubric Edited",
	        text: "You have edited the rubric for this answer",
	        icon: "ok-sign"
	      });
	    }
	
	    // quiz-level read the book dropdown
	
	  }, {
	    key: "isQuizReadBook",
	    value: function isQuizReadBook() {
	      return this.props.view == QUIZ_READ_BOOK;
	    }
	
	    // extract polorizing hash from evaluation
	
	  }, {
	    key: "polarizingHash",
	    value: function polarizingHash() {
	      var evaluation = this.props.evaluation;
	
	      return evaluation && evaluation.autograder_data ? evaluation.autograder_data.polarizing : {};
	    }
	
	    // user is on a free account and hasn't manually graded answer
	
	  }, {
	    key: "hideAutograderScore",
	    value: function hideAutograderScore(rubricKey) {
	      var polarizingHash = this.polarizingHash();
	      return !CurrentUser.isPremiumOrTrialAccount() && (!polarizingHash[rubricKey] || !polarizingHash[rubricKey]['admin_label']);
	    }
	
	    // user is on a free account and hasn't manually determined if the
	    // student read the book on a quiz level
	
	  }, {
	    key: "hideQuizReadBook",
	    value: function hideQuizReadBook() {
	      return !CurrentUser.isPremiumOrTrialAccount() && !this.props.evaluation.read_book;
	    }
	
	    // warning should show for admins on free tier who haven't manually added grades
	    // or when the rubric key is not present in polarizing hash
	
	  }, {
	    key: "showWarning",
	    value: function showWarning(rubricKey) {
	      var leaves = this.props.leaves;
	      var _state = this.state,
	          rubricOverride = _state.rubricOverride,
	          read_book = _state.read_book;
	
	
	      if (rubricOverride[rubricKey] || read_book) {
	        return false;
	      }
	
	      if (this.isQuizReadBook()) {
	        return this.hideQuizReadBook();
	      } else {
	        return this.hideAutograderScore(rubricKey) || !_.has(leaves, rubricKey) || _.isEmpty(leaves[rubricKey]['value']);
	      }
	    }
	  }, {
	    key: "getDropdownText",
	    value: function getDropdownText(rubricKey) {
	      var rubricOverride = this.state.rubricOverride;
	
	
	      var polarizingHash = this.polarizingHash();
	
	      if (rubricOverride[rubricKey]) {
	        return $wr.toTitleCase(rubricOverride[rubricKey]);
	      } else if (this.isQuizReadBook() && this.props.evaluation.read_book) {
	        return $wr.toTitleCase(this.props.evaluation.read_book);
	      } else if (!this.hideAutograderScore(rubricKey) && polarizingHash[rubricKey]) {
	        var labelKey = polarizingHash[rubricKey]['admin_label'] ? 'admin_label' : 'label';
	        return polarizingHash[rubricKey][labelKey] ? $wr.toTitleCase(polarizingHash[rubricKey][labelKey]) : 'None';
	      } else {
	        return 'None';
	      }
	    }
	
	    // save new rubric grading
	
	  }, {
	    key: "handleRubricOverride",
	    value: function handleRubricOverride(rubricKey, selectedOp) {
	      var newRubricOverride = _extends({}, this.state.rubricOverride);
	      newRubricOverride[rubricKey] = selectedOp.toLowerCase();
	      this.setState({ rubricOverride: newRubricOverride });
	
	      if (this.props.onChange) {
	        this.props.onChange(selectedOp.toLowerCase());
	      }
	    }
	
	    // warning to tell user that rubric has not been auto-graded
	
	  }, {
	    key: "renderWarning",
	    value: function renderWarning(rubricKey) {
	      if (this.showWarning(rubricKey)) {
	        var tip = 'This item has not been graded';
	        return React.createElement(Glyphicon, { icon: "exclamation-sign", className: "warningIcon", dataTip: tip });
	      }
	    }
	
	    // allows teachers to edit rubric items
	
	  }, {
	    key: "renderDropdown",
	    value: function renderDropdown(aggregateKey, rubricKey) {
	      var _this2 = this;
	
	      var options = AutograderDisplayConfig.getLeafOptions(aggregateKey);
	      // options for rubric item
	      var dropdownOps = _.map(options, function (option) {
	        return React.createElement(
	          ButtonDropdownOption,
	          { key: option,
	            onClick: function onClick() {
	              return _this2.handleRubricOverride(rubricKey, option);
	            } },
	          $wr.toTitleCase(option)
	        );
	      });
	
	      return React.createElement(
	        ButtonDropdown,
	        { text: this.getDropdownText(rubricKey),
	          dropdownDisplay: "link", className: "rubricLabelSelector" },
	        dropdownOps
	      );
	    }
	
	    // renders multiple rubric items as table
	
	  }, {
	    key: "renderTableView",
	    value: function renderTableView() {
	      var _this3 = this;
	
	      var leaves = this.props.leaves;
	
	      if (leaves) {
	        var rows = _.keys(leaves).map(function (rubricKey) {
	          var aggregateKey = AutograderDisplayConfig.getLeafAggregateKey(rubricKey);
	          var title = AutograderDisplayConfig.getLeafName(aggregateKey);
	          var dataTip = AutograderDisplayConfig.getLeafDescription(aggregateKey);
	
	          LuckyOrangeClient.tagComponent("ScoringDataOverride: " + aggregateKey);
	
	          return React.createElement(
	            "tr",
	            { key: aggregateKey },
	            React.createElement(
	              "td",
	              { className: "titleCell", "data-tip": dataTip },
	              title
	            ),
	            React.createElement(
	              "td",
	              null,
	              _this3.renderDropdown(aggregateKey, rubricKey)
	            ),
	            React.createElement(
	              "td",
	              null,
	              _this3.renderWarning(rubricKey)
	            )
	          );
	        });
	
	        return React.createElement(
	          "table",
	          { className: "table table-borderless" },
	          React.createElement(
	            "tbody",
	            null,
	            rows
	          )
	        );
	      }
	    }
	
	    // renders read the book option and dropdown on quiz level
	
	  }, {
	    key: "renderQuizReadBook",
	    value: function renderQuizReadBook() {
	      LuckyOrangeClient.tagComponent("ScoringDataOverride: Quiz-Level " + READ_BOOK_AGG_KEY);
	      var title = AutograderDisplayConfig.getLeafName(READ_BOOK_AGG_KEY);
	      var dataTip = "Whether the entirety of the student's work provides enough text evidence to prove that the student read the book.";
	
	      return React.createElement(
	        "div",
	        { key: "Quiz-" + READ_BOOK_AGG_KEY, className: "rubricOverrideInlineContainer" },
	        React.createElement(
	          "div",
	          { className: "titleContainer", "data-tip": dataTip },
	          title,
	          React.createElement(ReactTooltip, { effect: "solid", className: "readBookDataTip" })
	        ),
	        React.createElement(
	          "div",
	          { className: "dropdownContainer" },
	          this.renderDropdown(READ_BOOK_AGG_KEY, READ_BOOK_RUBRIC_KEY)
	        ),
	        React.createElement(
	          "div",
	          { className: "warningContainer" },
	          this.renderWarning(READ_BOOK_RUBRIC_KEY)
	        )
	      );
	    }
	  }, {
	    key: "renderCategories",
	    value: function renderCategories() {
	      if (this.isQuizReadBook()) {
	        return this.renderQuizReadBook();
	      } else {
	        return this.renderTableView();
	      }
	    }
	  }, {
	    key: "renderSaveButton",
	    value: function renderSaveButton() {
	      if (!_.isEmpty(this.state.rubricOverride) && this.props.view != QUIZ_READ_BOOK) {
	        return React.createElement(
	          "div",
	          { className: "btnContainer" },
	          React.createElement(
	            "button",
	            { onClick: this.saveEvaluation, className: "btn btn-primary saveBtn" },
	            "Save"
	          )
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          leaves = _props.leaves,
	          view = _props.view;
	
	
	      if (!leaves || _.size(leaves) == 0) {
	        return React.createElement(
	          "div",
	          { className: "rubricItemOverride" },
	          React.createElement(
	            "p",
	            { className: "showToggle" },
	            "No scoring details available."
	          )
	        );
	      }
	
	      var containerClass = view ? "rubricItemOverride " + view : "rubricItemOverride " + TABLE_VIEW;
	
	      return React.createElement(
	        "div",
	        { className: containerClass },
	        React.createElement(
	          "div",
	          { className: "scoringCategories" },
	          this.renderCategories()
	        ),
	        this.renderSaveButton()
	      );
	    }
	  }]);
	
	  return RubricItemOverride;
	}(React.Component)) || _class);
	
	
	var QUIZ_READ_BOOK = 'quizReadBook';
	var TABLE_VIEW = 'tableView';
	var READ_BOOK_AGG_KEY = 'aggregate-read-book';
	var READ_BOOK_RUBRIC_KEY = 'crit-evi-cote-bert-read-book-1';
	
	RubricItemOverride.propTypes = StrictPropTypes({
	  onUpdate: PropTypes.func,
	  leaves: PropTypes.object, // Polarizing after aggregating and filtering
	  evaluation: PropTypes.object,
	  view: PropTypes.string,
	  onChange: PropTypes.func
	  // onChange: PropTypes.func.isRequired,
	});
	
	module.exports = RubricItemOverride;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3863);
	
	var ShareResponse = function (_React$Component) {
		_inherits(ShareResponse, _React$Component);
	
		function ShareResponse(props) {
			_classCallCheck(this, ShareResponse);
	
			var _this = _possibleConstructorReturn(this, (ShareResponse.__proto__ || Object.getPrototypeOf(ShareResponse)).call(this));
	
			autobind(_this);
			_this.state = {
				shareURL: null, imgURL: null, loading: false
			};
			return _this;
		}
	
		_createClass(ShareResponse, [{
			key: "loadShareURL",
			value: function loadShareURL(openShareF, e) {
				$wr.nope(e);
	
				if ($wr.isSafari()) {
					var windowReference = window.open();
				}
				if (this.state.shareURL) {
					openShareF(windowReference);
				} else {
					this.setState({ loading: true });
					CurrentUser.api().getResponseLink(this.props.responseID, $wr.apiHandler(function (response) {
						this.setState({ shareURL: response.link, imgURL: response.image_url,
							loading: false }, function () {
							openShareF(windowReference);
						});
					}.bind(this)));
				}
			}
		}, {
			key: "openFacebookShare",
			value: function openFacebookShare(windowReference) {
				Mycroft.newEvent({ category: "Response", action: "social-share", label: "facebook" });
				var fbURL = "http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(this.state.shareURL);
				if (typeof windowReference != "undefined") {
					windowReference.location = fbURL;
				} else {
					window.open(fbURL, "_blank");
				}
			}
		}, {
			key: "openTwitterShare",
			value: function openTwitterShare(windowReference) {
				Mycroft.newEvent({ category: "Response", action: "social-share", label: "twitter" });
				var twURL = "http://twitter.com/share?text=" + encodeURIComponent(this.getShareText() + "#whooosreading") + "&url=" + encodeURIComponent(this.state.shareURL);
				if (typeof windowReference != "undefined") {
					windowReference.location = twURL;
				} else {
					window.open(twURL, "_blank");
				}
			}
		}, {
			key: "openPinterestShare",
			value: function openPinterestShare(windowReference) {
				Mycroft.newEvent({ category: "Response", action: "social-share", label: "pinterest" });
				var pinterestURL = "//www.pinterest.com/pin/create/button/?url=" + encodeURIComponent(this.state.shareURL) + "&media=" + encodeURIComponent(this.state.imgURL) + "&description=" + encodeURIComponent(this.getShareText());
				if (typeof windowReference != "undefined") {
					windowReference.location = pinterestURL;
				} else {
					window.open(pinterestURL, "_blank");
				}
			}
		}, {
			key: "openLinkShare",
			value: function openLinkShare(windowReference) {
				Mycroft.newEvent({ category: "Response", action: "social-share", label: "link" });
				var rawURL = this.state.shareURL;
				if (typeof windowReference != "undefined") {
					windowReference.location = rawURL;
				} else {
					window.open(rawURL, "_blank");
				}
			}
		}, {
			key: "openEmailShare",
			value: function openEmailShare(windowReference) {
				Mycroft.newEvent({ category: "Response", action: "social-share", label: "email" });
				var mailtoLink = "mailto:?subject=Check out what my student did!&body=Hi,%0D%0A%0D%0A" + this.getShareText() + "%0D%0A" + encodeURIComponent(this.state.shareURL);
				if (typeof windowReference != "undefined") {
					windowReference.location = mailtoLink;
				} else {
					window.open(mailtoLink, "_blank");
				}
			}
		}, {
			key: "getShareText",
			value: function getShareText() {
				return "Check out this reading activity my student completed on Whooo's Reading:";
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.loading) {
					var shareContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1 })
					);
				} else {
					var shareContent = React.createElement(
						"div",
						{ className: "social" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.loadShareURL.bind(this, this.openEmailShare) },
							React.createElement("img", { src: __webpack_require__(3463) })
						),
						React.createElement(
							"a",
							{ href: "#", onClick: this.loadShareURL.bind(this, this.openFacebookShare) },
							React.createElement("img", { src: __webpack_require__(3464) })
						),
						React.createElement(
							"a",
							{ href: "#", onClick: this.loadShareURL.bind(this, this.openTwitterShare) },
							React.createElement("img", { src: __webpack_require__(3467) })
						),
						React.createElement(
							"a",
							{ href: "#", onClick: this.loadShareURL.bind(this, this.openPinterestShare) },
							React.createElement("img", { src: __webpack_require__(3466) })
						),
						React.createElement(
							"a",
							{ href: "#", onClick: this.loadShareURL.bind(this, this.openLinkShare) },
							React.createElement("img", { src: __webpack_require__(3465) })
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "shareResponse", ref: "wrap" },
					shareContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var $wrap = $(this.refs.wrap);
				var $modal = $wrap.closest(".modal");
	
				if ($modal.length > 0) {
					$modal.on("scroll", function () {
						var offsetY = $modal.scrollTop();
						$wrap.css("margin-top", offsetY);
					}.bind(this));
				}
			}
		}]);
	
		return ShareResponse;
	}(React.Component);
	
	;
	
	ShareResponse.propTypes = StrictPropTypes({
		responseID: PropTypes.number.isRequired
	});
	
	module.exports = ShareResponse;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EvaluationBox = __webpack_require__(429);
	var UserAvatar = __webpack_require__(239);
	var StandInAvatar = __webpack_require__(373);
	var NameLookup = __webpack_require__(253);
	
	__webpack_require__(3864);
	
	var StudentActivityInfoLine = function (_React$Component) {
		_inherits(StudentActivityInfoLine, _React$Component);
	
		function StudentActivityInfoLine(props) {
			_classCallCheck(this, StudentActivityInfoLine);
	
			var _this = _possibleConstructorReturn(this, (StudentActivityInfoLine.__proto__ || Object.getPrototypeOf(StudentActivityInfoLine)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(StudentActivityInfoLine, [{
			key: "render",
			value: function render() {
				var response = this.props.response;
				if (this.props.response.text && response.text.title) {
					var title = response.text.title;
				} else {
					var title = "Text provided";
				}
	
				if (this.props.user) {
	
					if (this.props.user.unsorted) {
						var mainUser = React.createElement(
							"span",
							null,
							React.createElement(StandInAvatar, { admin: this.props.user, maxWidth: 30 }),
							" ",
							response.input_name
						);
					} else {
						var mainUser = React.createElement(
							"span",
							null,
							React.createElement(UserAvatar, { user: this.props.user, maxWidth: 30 }),
							" ",
							this.props.user.display_name
						);
					}
	
					if (response.mirror_user_ids && NameLookup.isLoaded()) {
						var mirrorIDs = _.without(response.mirror_user_ids, this.props.user.id);
						var otherNames = NameLookup.getNames(mirrorIDs);
	
						var otherUsers = React.createElement(
							"span",
							null,
							", " + otherNames.join(", ")
						);
					}
	
					var userLine = React.createElement(
						"span",
						{ className: "responseUserLine" },
						mainUser,
						otherUsers,
						React.createElement("br", null)
					);
				}
				if (response.edited_at) {
					var edited = React.createElement(
						"div",
						{ className: "editedInfo" },
						"Edited: ",
						$wr.formatDate(response.edited_at)
					);
				}
				var studentInfo = React.createElement(
					"div",
					{ className: "studentInfoContainer" },
					userLine,
					React.createElement(
						"em",
						null,
						title
					),
					React.createElement("br", null),
					"Completed: ",
					$wr.formatDate(response.created_at),
					edited
				);
				return React.createElement(
					"div",
					null,
					studentInfo
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!NameLookup.isLoaded() && this.props.user && this.props.response.mirror_user_ids && this.props.response.mirror_user_ids.length > 1) {
	
					NameLookup.loadStudentNames(function () {
						this.forceUpdate();
					}.bind(this));
				}
			}
		}]);
	
		return StudentActivityInfoLine;
	}(React.Component);
	
	;
	
	StudentActivityInfoLine.propTypes = StrictPropTypes({
		// The activity
		response: PropTypes.object.isRequired,
	
		// If this is present, we'll show the student and the avatar
		user: PropTypes.object
	});
	
	module.exports = StudentActivityInfoLine;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var LearningSeriesData = __webpack_require__(1509);
	
	var LearningSeries = {
	
		videos: function videos(module, level) {
			var tutorials = _.filter(LearningSeriesData, {
				module: module, level: level, type: LearningSeries.VIDEO_TYPE
			});
	
			return _.sortBy(tutorials, "order");
		},
		video: function video(key) {
			return _.findWhere(LearningSeriesData, {
				key: key, type: LearningSeries.VIDEO_TYPE
			});
		},
	
		action: function action(key) {
			return _.findWhere(LearningSeriesData, {
				key: key, type: LearningSeries.ACTION_TYPE
			});
		},
	
		itemsInModule: function itemsInModule(module, type) {
			return _.filter(LearningSeriesData, {
				module: module, type: type
			});
		},
		itemsInModuleAtLevel: function itemsInModuleAtLevel(module, level, type) {
			return _.filter(LearningSeriesData, {
				module: module, level: level, type: type
			});
		},
	
		keysInModule: function keysInModule(module, type) {
			var tutorials = _.filter(LearningSeriesData, {
				module: module, type: type
			});
	
			return _.map(tutorials, function (tutorial) {
				tutorial.key;
			});
		},
	
		countComplete: function countComplete(items, completeKeys) {
			var completeItems = _.map(items, function (item) {
				return _.filter(completeKeys, function (key) {
					return key == item.key;
				});
			});
	
			return _.flatten(completeItems).length;
		},
	
		firstIncompleteVideoInModule: function firstIncompleteVideoInModule(module, completeKeys) {
			var videos = LearningSeries.itemsInModule(module, LearningSeries.VIDEO_TYPE);
			return LearningSeries.firstIncompleteItem(videos, completeKeys);
		},
		firstIncompleteVideoInModuleAtLevel: function firstIncompleteVideoInModuleAtLevel(module, level, completeKeys) {
			var videos = LearningSeries.itemsInModuleAtLevel(module, level, LearningSeries.VIDEO_TYPE);
			return LearningSeries.firstIncompleteItem(videos, completeKeys);
		},
	
		firstIncompleteItem: function firstIncompleteItem(items, completeKeys) {
			var incompleteItems = _.filter(items, function (item) {
				return !_.contains(completeKeys, item.key);
			});
	
			// returns the first incomplete item, or the first item if all are complete
			if (incompleteItems.length > 0) {
				return _.sortBy(incompleteItems, "order")[0];
			} else {
				return items[0];
			}
		},
	
		moduleName: function moduleName(module) {
			if (module == LearningSeries.SETUP_MODULE) {
				return "Account Setup";
			} else if (module == LearningSeries.STUDENT_MODULE) {
				return "Student Account";
			} else if (module == LearningSeries.TEACHER_MODULE) {
				return "Teacher Account";
			} else if (module == LearningSeries.QUICK_MODULE) {
				return "Quick Start";
			}
		}
	};
	
	LearningSeries.QUICK_MODULE = "quick-start";
	LearningSeries.SETUP_MODULE = "account-setup";
	LearningSeries.STUDENT_MODULE = "student-account";
	LearningSeries.TEACHER_MODULE = "teacher-account";
	
	LearningSeries.MODULES = [LearningSeries.QUICK_MODULE, LearningSeries.SETUP_MODULE, LearningSeries.STUDENT_MODULE, LearningSeries.TEACHER_MODULE];
	
	LearningSeries.BEG_LEVEL = "beginner";
	LearningSeries.INT_LEVEL = "intermediate";
	LearningSeries.ADV_LEVEL = "advanced";
	LearningSeries.ACTION_TYPE = "action";
	LearningSeries.VIDEO_TYPE = "video";
	
	module.exports = LearningSeries;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.quizDuration = quizDuration;
	function quizDuration(recallQuestionCount, analysisQuestionCount, sentenceStarters) {
		var baseTime = 2;
	
		baseTime += 2 * recallQuestionCount;
	
		if (sentenceStarters) {
			baseTime += 3 * analysisQuestionCount;
		} else {
			baseTime += 5 * analysisQuestionCount;
		}
	
		var higherTime = baseTime + Math.round(baseTime / 3);
	
		return baseTime + " - " + higherTime;
	}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var CurrentUser = __webpack_require__(3);
	var DemoAccountSwitcher = __webpack_require__(201);
	
	var TeacherOnboarding = {
		STEPS: {
			"select-standards": {
				title: "Choose Your Standards",
				index: 0,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001165471",
				doAction: function doAction() {
					$wr.redirect("/settings/standards");
				},
				imgPath: "standards"
			},
			"select-school": {
				title: "Select Your School",
				index: 1,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001718452",
				doAction: function doAction() {
					$wr.redirect("/contests?show_school_info_modal=true");
				},
				imgPath: "school"
			},
			"add-students": {
				title: "Add Your Students",
				index: 2,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001333171",
				doAction: function doAction() {
					TeacherOnboarding.checkLocation("roster", "Add Your Students", "Click on 'Add a Student' and select an adding method.");
					$wr.redirect("/roster?addNewStudentsButton=true");
				},
				imgPath: "students"
			},
			"student-writing": {
				title: "Do Sample Assignment",
				index: 3,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360027572111",
				doAction: function doAction() {
					var embeds = "student_list.students,student.password";
					CurrentUser.api().getStudentLists({ embed: embeds }, $wr.apiHandler(function (response) {
						var students = _.flatten(_.pluck(response.student_lists, "students"));
						var demoStudent = _.findWhere(students, { demo_for_teacher: true });
						if (demoStudent) {
							DemoAccountSwitcher.switchToStudent(demoStudent);
						} else {
							if (students.length == 0) {
								window.wrNotifications.triggerDropDownNotification({
									title: "No demo account available",
									text: "Add at least one student account first...", icon: "alt" }, 10000);
							} else {
								window.wrNotifications.triggerDropDownNotification({
									title: "No demo account available",
									text: "You can do a sample assigment by using one of your students' account...", icon: "alt" }, 10000);
							}
						}
					}));
				},
				imgPath: "demo"
			},
			"view-data": {
				title: "View Writing Data",
				index: 4,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360000607532",
				doAction: function doAction() {
					$wr.redirect("/data");
					$(window.document).trigger("onboarding-trigger-view-data");
				},
				imgPath: "dashboard"
			},
			"complete-quizzes": {
				title: "Complete Quizzes",
				index: 5,
				imgPath: "quizzes"
			},
			"customize-assignments": {
				title: "Set Up Goals",
				index: 6,
				learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360024761351",
				doAction: function doAction() {
					$wr.redirect("/roster/goals");
					$(window.document).trigger("onboarding-trigger-customize-assignments");
				},
				imgPath: "assignment"
			},
			"autograder-demo": {
				title: "Try Our Autograder",
				index: 3,
				doAction: function doAction() {
					var url = window.location.pathname + "?autograderDemo=show";
					$wr.redirect(url);
				},
				imgPath: "demo"
			}
		},
	
		getData: function getData(key) {
			return TeacherOnboarding.STEPS[key];
		},
		getTitle: function getTitle(key) {
			var step = TeacherOnboarding.getData(key);
			if (step) {
				return step.title;
			}
		},
		getIndex: function getIndex(key) {
			var step = TeacherOnboarding.getData(key);
			if (step) {
				return step.index;
			}
		},
		getLearnLink: function getLearnLink(key) {
			var step = TeacherOnboarding.getData(key);
			if (step) {
				return step.learnLink;
			}
		},
		doIt: function doIt(key) {
			var step = TeacherOnboarding.getData(key);
			if (step) {
				return step.doAction();
			}
		},
		getImgPath: function getImgPath(key) {
			var step = TeacherOnboarding.getData(key);
			if (step) {
				return step.imgPath;
			}
		},
		checkLocation: function checkLocation(target, title, message) {
			var loc = document.URL;
			if (loc.indexOf(target) > -1) {
				window.wrNotifications.triggerDropDownNotification({
					title: title, text: message, icon: "question-sign" });
			}
		},
		getOrderedKeys: function getOrderedKeys() {
			if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
				return ["select-standards", "select-school", "add-students", "autograder-demo", "customize-assignments"];
			} else {
				return ["select-standards", "select-school", "add-students", "student-writing", "view-data", "customize-assignments"];
			}
			// returns all keys in order
		}
	};
	
	module.exports = TeacherOnboarding;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.downloadCSV = downloadCSV;
	var Papa = __webpack_require__(3549);
	
	// Thanks @ Glen Thompson
	// https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
	
	// Data should be an array of objects (or maybe array of arrays)
	function downloadCSV(data, columns, filename) {
		var filename = filename || "wr-export.csv";
		var csv = Papa.unparse({ data: data, fields: columns });
		if (!csv) {
			return;
		}
	
		var blob = new Blob([csv]);
		if (window.navigator.msSaveOrOpenBlob) {
			// IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
			window.navigator.msSaveBlob(blob, filename);
		} else {
			var a = window.document.createElement("a");
			a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
			a.download = filename;
			document.body.appendChild(a);
			a.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
			document.body.removeChild(a);
		}
	}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	__webpack_require__(7);
	
	var AnimateOwl = {
	    handle: {},
	    separate_wings: function separate_wings($owl) {
	        $owl.find(" [data-patch='wings']").eq(0).after($owl.find(" [data-patch='wings']").eq(0).clone()).after($owl.find(" [data-patch='wings']").eq(0).clone());
	        $owl.find(" [data-patch='wings']").eq(0).attr('data-patch', 'originalwings');
	        $owl.find(" [data-patch='wings']").eq(0).hide();
	        $owl.find(" [data-patch='wings']").eq(1).hide();
	        var patchPath = 'patches/wings/solo-left-' + $owl.find(" [data-patch='wings']").data('color') + '.png';
	        patchPath = dynamicRequire(patchPath);
	        $owl.find(" [data-patch='wings']").eq(0).attr('src', patchPath);
	        patchPath = 'patches/wings/solo-right-' + $owl.find(" [data-patch='wings']").data('color') + '.png';
	        patchPath = dynamicRequire(patchPath);
	        $owl.find(" [data-patch='wings']").eq(1).attr('src', patchPath);
	
	        $owl.find(" [data-patch='wings']").eq(1).css('transform-origin', '64% 45%').css('-webkit-transform-origin', '64% 45%');
	        $owl.find(" [data-patch='wings']").eq(0).css('transform-origin', '36% 45%').css('-webkit-transform-origin', '36% 45%');
	    },
	
	    set_wings: function set_wings($owl, time) {
	        $owl.find(" [data-patch='wings']").css('transition', 'transform ' + time + 'ms').css('-webkit-transition', '-webkit-transform ' + time + 'ms');
	        $owl.find(" [data-patch='wings']").show();
	        $owl.find(" [data-patch='originalwings']").hide();
	    },
	
	    moving_eyes: function moving_eyes() {
	        if ($("[data-animate='eyes']").length > 0) {
	            var num = Math.floor(Math.random() * $("[data-animate='eyes']").length);
	            if ($("[data-animate='eyes']").eq(num).attr('data-modify') == "true") {
	                $("[data-animate='eyes']").eq(num).attr('src', $("[data-animate='eyes']").eq(num).data('src')).attr('data-modify', 'false');
	            } else {
	                var patchPath = 'patches/eyes/happy-' + $("[data-animate='eyes']").eq(num).data('color') + '.png';
	                patchPath = dynamicRequire(patchPath);
	                $("[data-animate='eyes']").eq(num).attr('src', patchPath).attr('data-modify', 'true');
	            }
	        }
	    },
	
	    moving_wings: function moving_wings($owl, side, deg) {
	        $owl.find("[data-patch='wings']").eq(side).css('transform', "rotate(" + deg + "deg)").css('-webkit-transform', 'rotate(' + deg + 'deg)');
	    },
	
	    rotate_object: function rotate_object($owl, object, deg) {
	        $owl.find(object).css('transform', 'rotate(' + deg + 'deg)').css('-webkit-transform', 'rotate(' + deg + 'deg)');
	    },
	
	    set_transform: function set_transform($owl, object, time) {
	        $owl.find(object).css('transition', 'transform ' + time + 'ms').css('-webkit-transition', '-webkit-transform ' + time + 'ms');
	    },
	
	    set_eyes: function set_eyes($owl) {
	        $owl.find(" [data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	    },
	    // toggleOverflow: function() {
	    //     if ($('.studentInfoArea').length) {
	    //         if ($('.studentInfoArea').css('overflow') == 'hidden') {
	    //             $('.studentInfoArea').css('overflow','inherit')
	    //         } else {
	    //             $('.studentInfoArea').css('overflow','hidden')
	    //         }
	
	    //     }
	    // },
	
	    resetAnimation: function resetAnimation($owl) {
	        setTimeout(function () {
	            $owl.find("[data-remove='true']").remove();
	            for (var i = 0; i < $owl.find("[data-src]").length; i++) {
	                $owl.find("[data-src]").eq(i).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)').attr('src', $owl.find("[data-src]").eq(i).data('src'));
	            }
	            for (var i = 0; i < $owl.find("[data-moveObjectTop]").length; i++) {
	                $owl.find("[data-moveObjectTop]").eq(i).css('top', $owl.find("[data-moveObjectTop]").eq(i).attr('data-moveObjectTop')).css('left', $owl.find("[data-moveObjectLeft]").eq(i).attr('data-moveObjectLeft')).fadeTo(100, 1.0);
	            }
	            $owl.find("[data-appear]").fadeTo(250, 1.0).removeAttr('data-appear');
	            $owl.find("[data-animate]").removeAttr('data-animate');
	            $owl.find('[data-modify]').removeAttr('data-modify');
	
	            $owl.find(" [data-patch='wings']").hide();
	            $owl.find(" [data-patch='wings']").css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $owl.find(" [data-patch='originalwings']").show();
	        }, 500);
	    },
	
	    fly_controler: function fly_controler(loop, $owl) {
	
	        AnimateOwl.setup_fly($owl);
	        setTimeout(function () {
	            AnimateOwl.flying_motion($owl, $owl.find("[data-patch='wings']").eq(0), $owl.find("[data-patch='wings']").eq(1), loop);
	        }, 1200);
	    },
	
	    setup_fly: function setup_fly($owl) {
	
	        AnimateOwl.set_wings($owl, 1000);
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        setTimeout(function () {
	            $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(-120deg)').css('-webkit-transform', 'rotate(-120deg)');
	            $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	        }, 200);
	    },
	
	    flying_motion: function flying_motion($owl, $wingLeft, $wingRigth, loop) {
	        $wingLeft.css('transform', 'rotate(-10deg)').css('-webkit-transform', 'rotate(-10deg)');
	        $wingRigth.css('transform', 'rotate(+10deg)').css('-webkit-transform', 'rotate(10deg)');
	        $owl.animate({ top: ['-=40', 'swing'] }, 1000, 'linear');
	        AnimateOwl.moving_eyes();
	
	        setTimeout(function () {
	            $wingLeft.css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	            $wingRigth.css('transform', 'rotate(-120deg)').css('-webkit-transform', 'rotate(-120deg)');
	            $owl.animate({ top: ['+=40', 'swing'] }, 1000, 'linear');
	            AnimateOwl.moving_eyes();
	        }, 1000);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.flying_motion($owl, $wingLeft, $wingRigth, loop - 1);
	            } else {
	                $owl.find(" [data-patch='hand']").fadeTo(1500, 1.0);
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 2000);
	    },
	
	    dance_controller: function dance_controller(loop, $owl, type) {
	        if ($wr.isInternetExplorer()) {
	            return;
	        }
	
	        AnimateOwl.setup_dance($owl);
	        setTimeout(function () {
	            switch (type) {
	                case 1:
	                    AnimateOwl.dancing_motion1($owl, $owl.find("[data-dancemovehand='handRight']"), $owl.find(" [data-dancemovehand='handLeft']"), $owl.find("[data-dancemovebodyVertical='true']"), $owl.find("[data-dancemovebodyHorizontal='right']"), $owl.find("[data-dancemovebodyHorizontal='left']"), 0, -100, 100, 0, loop);
	                    break;
	                case 2:
	                    AnimateOwl.dancing_motion2($owl, $owl.find("[data-dancemovehand='handRight']"), $owl.find(" [data-dancemovehand='handLeft']"), $owl.find("[data-dancemovebodyVertical='true']"), $owl.find("[data-dancemovebodyHorizontal='right']"), $owl.find("[data-dancemovebodyHorizontal='left']"), loop);
	                    break;
	                case 3:
	                    AnimateOwl.dancing_motion3($owl, $owl.find("[data-dancemovehand='handRight']"), $owl.find(" [data-dancemovehand='handLeft']"), $owl.find("[data-dancemovebodyVertical='true']"), $owl.find("[data-dancemovebodyHorizontal='right']"), $owl.find("[data-dancemovebodyHorizontal='left']"), loop);
	                    break;
	            }
	        }, 1000);
	    },
	
	    setup_dance: function setup_dance($owl) {
	        AnimateOwl.set_wings($owl, 500);
	        $owl.find(" [data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	
	        $owl.find(" img ").attr('data-danceMovebodyVertical', 'true');
	        $owl.find(" [data-patch='wings']").attr('data-danceMovebodyVertical', 'false');
	        setTimeout(function () {
	            if (Math.floor(Math.random() * 2)) {
	                $owl.find(" [data-patch='wings']").eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)').attr('data-danceMoveHand', 'handRight');
	                $owl.find(" [data-patch='wings']").eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)').attr('data-danceMoveHand', 'handRight');
	                $owl.find(" img ").attr('data-danceMoveBodyHorizontal', 'left');
	            } else {
	                $owl.find(" [data-patch='wings']").eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)').attr('data-danceMovehand', 'handLeft');
	                $owl.find(" [data-patch='wings']").eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)').attr('data-danceMovehand', 'handLeft');
	                $owl.find(" img ").attr('data-danceMovebodyHorizontal', 'right');
	            }
	            $owl.find(" [data-patch='feet']").attr('data-danceMovebodyVertical', 'false').attr('data-danceMovebodyHorizontal', 'false');
	            $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	        }, 200);
	    },
	
	    dancing_motion1: function dancing_motion1($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, deg1, deg2, deg3, deg4, loop) {
	
	        $wingRight.animate({ left: '+=2%' }, 500, 'linear');
	        $wingLeft.animate({ left: '-=2%' }, 500, 'linear');
	        $bodyVert.animate({ top: '+=3%' }, 500, 'linear');
	        $bodyHorRight.animate({ left: '+=3%' }, 250, 'linear');
	        $bodyHorLeft.animate({ left: '-=3%' }, 250, 'linear');
	        AnimateOwl.moving_eyes();
	        setTimeout(function () {
	            $wingRight.animate({ left: '-=2%' }, 500, 'linear');
	            $wingLeft.animate({ left: '+=2%' }, 500, 'linear');
	            $bodyVert.animate({ top: '-=3%' }, 500, 'linear');
	            AnimateOwl.moving_eyes();
	        }, 500);
	
	        setTimeout(function () {
	            $wingRight.animate({ left: '+=2%' }, 500, 'linear');
	            $wingLeft.animate({ left: '-=2%' }, 500, 'linear');
	            $bodyVert.animate({ top: '+=3%' }, 500, 'linear');
	
	            $wingRight.eq(0).css('transform', 'rotate(' + deg1 + 'deg)').css('-webkit-transform', 'rotate(' + deg1 + 'deg)');
	            $wingRight.eq(1).css('transform', 'rotate(' + deg2 + 'deg)').css('-webkit-transform', 'rotate(' + deg2 + 'deg)');
	            $wingLeft.eq(0).css('transform', 'rotate(' + deg3 + 'deg)').css('-webkit-transform', 'rotate(' + deg3 + 'deg)');
	            $wingLeft.eq(1).css('transform', 'rotate(' + deg4 + 'deg)').css('-webkit-transform', 'rotate(' + deg4 + 'deg)');
	
	            AnimateOwl.moving_eyes();
	        }, 1000);
	        setTimeout(function () {
	            $wingRight.animate({ left: '-=2%' }, 500, 'linear');
	            $wingLeft.animate({ left: '+=2%' }, 500, 'linear');
	            $bodyVert.animate({ top: '-=3%' }, 500, 'linear');
	            $bodyHorRight.animate({ left: '-=3%' }, 500, 'linear');
	            $bodyHorLeft.animate({ left: '+=3%' }, 500, 'linear');
	
	            AnimateOwl.moving_eyes();
	        }, 1500);
	        setTimeout(function () {
	
	            if (loop) {
	                AnimateOwl.dancing_motion1($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, deg3, deg4, deg1, deg2, loop - 1);
	            } else {
	
	                $wingRight.removeAttr('data-dancemovehand');
	                $wingLeft.removeAttr('data-dancemovehand');
	                $bodyVert.removeAttr('data-dancemovebodyVertical');
	                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
	                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 2000);
	    },
	
	    dancing_motion2: function dancing_motion2($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, loop) {
	
	        $wingRight.animate({ top: '-=3%' }, 500, 'linear');
	        $wingLeft.animate({ top: '-=3%' }, 500, 'linear');
	        $bodyVert.animate({ top: '+=3%' }, 500, 'linear');
	
	        $wingRight.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	        $wingRight.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	        $wingLeft.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        $wingLeft.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	
	        AnimateOwl.moving_eyes();
	        setTimeout(function () {
	            $wingRight.animate({ top: '+=3%' }, 500, 'linear');
	            $wingLeft.animate({ top: '+=3%' }, 500, 'linear');
	            $bodyVert.animate({ top: '-=3%' }, 500, 'linear');
	        }, 500);
	
	        setTimeout(function () {
	
	            $wingRight.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $wingRight.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $wingLeft.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	            $wingLeft.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	
	            $bodyHorRight.animate({ left: '-=2.5%' }, 250, 'linear');
	            $bodyHorLeft.animate({ left: '+=2.5%' }, 250, 'linear');
	
	            AnimateOwl.moving_eyes();
	        }, 1000);
	        setTimeout(function () {
	            $bodyHorRight.animate({ left: '+=2.5%' }, 250, 'linear');
	            $bodyHorLeft.animate({ left: '-=2.5%' }, 250, 'linear');
	
	            AnimateOwl.moving_eyes();
	        }, 1500);
	        setTimeout(function () {
	
	            if (loop) {
	                AnimateOwl.dancing_motion2($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, loop - 1);
	            } else {
	
	                $wingRight.removeAttr('data-dancemovehand');
	                $wingLeft.removeAttr('data-dancemovehand');
	                $bodyVert.removeAttr('data-dancemovebodyVertical');
	                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
	                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 2000);
	    },
	
	    dancing_motion3: function dancing_motion3($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, loop) {
	
	        $bodyHorRight.animate({ top: '+=10', left: '-=5' }, 500, 'linear');
	        $bodyHorLeft.animate({ top: '+=10', left: '+=5' }, 500, 'linear');
	
	        $wingRight.eq(0).animate({ top: '-=5' }, 250, 'linear');
	        $wingRight.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        $wingRight.eq(1).animate({ top: '+=5' }, 250, 'linear');
	        $wingRight.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	
	        $wingLeft.eq(0).animate({ top: '+=5' }, 250, 'linear');
	        $wingLeft.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	        $wingLeft.eq(1).animate({ top: '-=5' }, 250, 'linear');
	        $wingLeft.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	
	        AnimateOwl.moving_eyes();
	
	        setTimeout(function () {
	            $wingRight.eq(0).animate({ top: '+=5' }, 250, 'linear');
	            $wingRight.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	            $wingRight.eq(1).animate({ top: '-=5' }, 250, 'linear');
	            $wingRight.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	
	            $wingLeft.eq(0).animate({ top: '-=5' }, 250, 'linear');
	            $wingLeft.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $wingLeft.eq(1).animate({ top: '+=5' }, 250, 'linear');
	            $wingLeft.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	        }, 500);
	
	        setTimeout(function () {
	
	            $wingRight.eq(0).animate({ top: '-=5' }, 250, 'linear');
	            $wingRight.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $wingRight.eq(1).animate({ top: '+=5' }, 250, 'linear');
	            $wingRight.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	
	            $wingLeft.eq(0).animate({ top: '+=5' }, 250, 'linear');
	            $wingLeft.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	            $wingLeft.eq(1).animate({ top: '-=5' }, 250, 'linear');
	            $wingLeft.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        }, 1000);
	        setTimeout(function () {
	            $bodyHorRight.animate({ top: '-=10', left: '+=5' }, 500, 'linear');
	            $bodyHorLeft.animate({ top: '-=10', left: '-=5' }, 500, 'linear');
	
	            $wingRight.eq(0).animate({ top: '+=5' }, 250, 'linear');
	            $wingRight.eq(0).css('transform', 'rotate(100deg)').css('-webkit-transform', 'rotate(100deg)');
	            $wingRight.eq(1).animate({ top: '-=5' }, 250, 'linear');
	            $wingRight.eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	
	            $wingLeft.eq(0).animate({ top: '-=5' }, 250, 'linear');
	            $wingLeft.eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $wingLeft.eq(1).animate({ top: '+=5' }, 250, 'linear');
	            $wingLeft.eq(1).css('transform', 'rotate(-100deg)').css('-webkit-transform', 'rotate(-100deg)');
	
	            AnimateOwl.moving_eyes();
	        }, 1500);
	        setTimeout(function () {
	
	            if (loop) {
	                AnimateOwl.dancing_motion3($owl, $wingRight, $wingLeft, $bodyVert, $bodyHorRight, $bodyHorLeft, loop - 1);
	            } else {
	
	                $wingRight.removeAttr('data-dancemovehand');
	                $wingLeft.removeAttr('data-dancemovehand');
	                $bodyVert.removeAttr('data-dancemovebodyVertical');
	                $bodyHorRight.removeAttr('data-dancemovebodyHorizontal');
	                $bodyHorLeft.removeAttr('data-dancemovebodyHorizontal');
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 2000);
	    },
	
	    wave_controller: function wave_controller(loop, $owl) {
	
	        AnimateOwl.setup_wave($owl);
	        setTimeout(function () {
	            AnimateOwl.waving_motion($owl, $owl.find("[data-patch='wings']").eq(0), loop);
	        }, 1200);
	    },
	
	    setup_wave: function setup_wave($owl) {
	        AnimateOwl.set_wings($owl, 1000);
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	
	        setTimeout(function () {
	            $owl.find(" [data-patch='wings']").eq(0).css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	        }, 200);
	    },
	
	    waving_motion: function waving_motion($owl, $waveHand, loop) {
	
	        $waveHand.css('transform', 'rotate(60deg)').css('-webkit-transform', 'rotate(60deg)');
	        AnimateOwl.moving_eyes();
	        setTimeout(function () {
	            $waveHand.css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	        }, 1000);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.waving_motion($owl, $waveHand, loop - 1);
	            } else {
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 2000);
	    },
	
	    spin_animation: function spin_animation(duration, $element, side) {
	        var time = duration / 1000;
	        var angle = 360 * time;
	
	        setTimeout(function () {
	            if (side == "hand") {
	                $element.css('transition', 'transform ' + time + 's').css('-webkit-transition', '-webkit-transform ' + time + 's').css('transform-origin', '71% 54%').css('-webkit-transform-origin', '71% 54%');
	            } else if (side == "left_hand") {
	                $element.css('transition', 'transform ' + time + 's').css('-webkit-transition', '-webkit-transform ' + time + 's').css('transform-origin', '29% 54%').css('-webkit-transform-origin', '29% 54%');
	            } else if (side == "feeding") {
	                $element.css('transition', 'transform ' + time + 's').css('-webkit-transition', '-webkit-transform ' + time + 's').css('transform-origin', '61% 54%').css('-webkit-transform-origin', '61% 54%');
	            } else {
	                $element.css('transition', 'transform ' + time + 's').css('-webkit-transition', '-webkit-transform ' + time + 's').css('transform-origin', '45.5% 55%').css('-webkit-transform-origin', '45.5% 55%');
	            }
	        }, 50);
	        setTimeout(function () {
	            $element.css('transform', 'rotate(' + angle + 'deg)').css('-webkit-transform', 'rotate(' + angle + 'deg)');
	        }, 150);
	
	        setTimeout(function () {
	            $element.css('transition', 'transform 0s').css('-webkit-transition', '-webkit-transform 0s');
	            $element.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        }, duration);
	    },
	
	    ball_animation: function ball_animation(loop, $owl, side) {
	        AnimateOwl.setup_ball($owl, side);
	        setTimeout(function () {
	            if (side == "hand") {
	                AnimateOwl.ball_motion($owl, $owl.find("[data-patch='hand']"), $owl.find("[data-patch='wings']").eq(1), "rotate(-90deg)", "rotate(-70deg)", loop);
	            } else {
	                AnimateOwl.ball_motion($owl, $owl.find("[data-patch='left_hand']"), $owl.find("[data-patch='wings']").eq(0), "rotate(90deg)", "rotate(70deg)", loop);
	            }
	        }, 300);
	    },
	
	    setup_ball: function setup_ball($owl, side) {
	        AnimateOwl.set_wings($owl, 200);
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	
	        setTimeout(function () {
	            if (side == "hand") {
	                $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(-70deg)').css('-webkit-transform', 'rotate(-70deg)');
	                $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            } else {
	                $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(70deg)').css('-webkit-transform', 'rotate(70deg)');
	                $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            }
	            $owl.find("[data-animationtype='ball']").animate({ top: '-30', left: '0' }, 500, 'linear');
	        }, 200);
	    },
	
	    ball_motion: function ball_motion($owl, $ball, $wing, deg1, deg2, loop) {
	
	        $ball.animate({ top: ['30', 'linear'] }, 500, 'linear');
	        $wing.css('transform', deg1).css('-webkit-transform', deg1);
	        AnimateOwl.moving_eyes();
	        setTimeout(function () {
	            $ball.animate({ top: ['-30', 'swing'] }, 500, 'linear');
	            $wing.css('transform', deg2).css('-webkit-transform', deg2);
	        }, 500);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.ball_motion($owl, $ball, $wing, deg1, deg2, loop - 1);
	            } else {
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 1000);
	    },
	
	    catch_animation: function catch_animation($owl, side) {
	        AnimateOwl.set_wings($owl, 490);
	
	        if (side == "hand") {
	            $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	        } else {
	            $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	        }
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	
	        setTimeout(function () {
	            $owl.find("[data-patch=" + side + "]").animate({ top: '-=100' }, 750, 'linear');
	        }, 250);
	        setTimeout(function () {
	            $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(-120deg)').css('-webkit-transform', 'rotate(-120deg)');
	        }, 500);
	        setTimeout(function () {
	            $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $owl.animate({ top: ['-=50', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch=" + side + "]").animate({ top: '+=20' }, 500, 'linear');
	        }, 1000);
	
	        setTimeout(function () {
	            $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(120deg)').css('-webkit-transform', 'rotate(120deg)');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(-120deg)').css('-webkit-transform', 'rotate(-120deg)');
	            $owl.animate({ top: ['+=15', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch=" + side + "]").animate({ top: '-=30' }, 500, 'linear');
	        }, 1500);
	        setTimeout(function () {
	            if (side == "hand") {
	                $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            } else {
	                $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            }
	
	            $owl.animate({ top: ['-=60', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch=" + side + "]").animate({ top: '+=50' }, 500, 'linear');
	            AnimateOwl.moving_eyes();
	        }, 2000);
	        setTimeout(function () {
	            if (side == "hand") {
	                $owl.find("[data-patch='wings']").eq(1).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            } else {
	                $owl.find("[data-patch='wings']").eq(0).css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            }
	            $owl.find("[data-patch=" + side + "]").animate({ top: '+=60' }, 100, 'linear');
	            $owl.animate({ top: ['+=95', 'swing'] }, 500, 'linear');
	        }, 2500);
	
	        setTimeout(function () {
	            AnimateOwl.resetAnimation($owl);
	        }, 2500);
	    },
	
	    swing_animation: function swing_animation(loop, $element, side) {
	
	        $element.closest(".owlConstraintsInner").find("[data-patch='eyes']").attr('data-src', $element.closest(".owlConstraintsInner").find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        if (side == "hand") {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '71% 54%').css('-webkit-transform-origin', '71% 54%');
	        } else if (side == "left_hand") {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '29% 54%').css('-webkit-transform-origin', '29% 54%');
	        } else if (side == "feed") {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '60% 54%').css('-webkit-transform-origin', '60% 54%');
	        } else {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '50% 54%').css('-webkit-transform-origin', '50% 54%');
	        }
	
	        setTimeout(function () {
	            AnimateOwl.swing_motion($element, loop);
	        }, 250);
	    },
	
	    swing_motion: function swing_motion($swing, loop) {
	        $swing.css('transform', 'rotate(50deg)').css('-webkit-transform', 'rotate(50deg)');
	        setTimeout(function () {
	            $swing.css('transform', 'rotate(-50deg)').css('-webkit-transform', 'rotate(-50deg)');
	        }, 500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (loop) {
	                AnimateOwl.swing_motion($swing, loop - 1);
	            } else {
	                $swing.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	                AnimateOwl.resetAnimation($swing.closest(".owlConstraintsInner"));
	            }
	        }, 1000);
	    },
	
	    swing_body_animation: function swing_body_animation(loop, $owl, $element, music, type) {
	
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        if (type == "harp") {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '56% 69%').css('-webkit-transform-origin', '56% 69%');
	        } else if (type == "cello") {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '42% 69%').css('-webkit-transform-origin', '42% 69%');
	        } else {
	            $element.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '50% 54%').css('-webkit-transform-origin', '50% 54%');
	        }
	        var patchPath = dynamicRequire('misc/note-sm.png');
	        if (music) {
	            // if( offset ){
	            // $element.after("<img src='"+patchPath+"' style='left: -185px; z-index: 9000;' data-play='note0' data-remove='true'></img>");
	            // $element.after("<img src='"+patchPath+"' style='left: -195px; z-index: 9000;' data-play='note1' data-remove='true'></img>");
	            // $element.after("<img src='"+patchPath+"' style='left: -205px; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
	            // }
	            // else{
	            $element.after("<img src='" + patchPath + "' style='left: -53%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
	            $element.after("<img src='" + patchPath + "' style='left: -56%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
	            $element.after("<img src='" + patchPath + "' style='left: -59%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
	        }
	        // }
	
	        setTimeout(function () {
	            AnimateOwl.swing_body_motion($element, music, loop);
	
	            if (music) {
	                AnimateOwl.animate_notes($owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop);
	            }
	        }, 250);
	    },
	
	    swing_body_motion: function swing_body_motion($swing, music, loop) {
	        $swing.css('transform', 'rotate(10deg)').css('-webkit-transform', 'rotate(10deg)');
	
	        setTimeout(function () {
	            $swing.css('transform', 'rotate(-10deg)').css('-webkit-transform', 'rotate(-10deg)');
	        }, 500);
	
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (loop) {
	                AnimateOwl.swing_body_motion($swing, true, loop - 1);
	            } else {
	                $swing.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	                AnimateOwl.resetAnimation($swing.closest(".owlConstraintsInner"));
	            }
	        }, 1000);
	    },
	
	    animate_notes: function animate_notes($note1, $note2, $note3, loop) {
	        var side = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "hand_left";
	
	
	        $note1.animate({ top: '-20' }, 330, 'linear');
	        $note2.animate({ top: '-10' }, 330, 'linear');
	        $note3.animate({ top: '-10' }, 330, 'linear');
	        setTimeout(function () {
	            $note1.animate({ top: '-10' }, 330, 'linear');
	            $note2.animate({ top: '-20' }, 330, 'linear');
	        }, 333);
	        setTimeout(function () {
	            if (loop == 0) {
	                if (side == "hand") {
	                    $note1.animate({ left: '+=100' }, 300, 'linear').fadeTo(200, 0);
	                    $note3.animate({ top: '-100', left: '+=100' }, 300, 'linear').fadeTo(200, 0);
	                    $note2.animate({ top: '100', left: '+=100' }, 300, 'linear').fadeTo(200, 0);
	                } else {
	                    $note1.animate({ left: '-=100' }, 300, 'linear').fadeTo(200, 0);
	                    $note3.animate({ top: '-100', left: '-=100' }, 300, 'linear').fadeTo(200, 0);
	                    $note2.animate({ top: '100', left: '-=100' }, 300, 'linear').fadeTo(200, 0);
	                }
	            } else {
	                $note3.animate({ top: '-20' }, 300, 'linear');
	                $note2.animate({ top: '-10' }, 300, 'linear');
	            }
	        }, 666);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.animate_notes($note1, $note2, $note3, loop - 1, side);
	            }
	        }, 1000);
	    },
	
	    play_animation: function play_animation(loop, $owl, $object, type, side) {
	        AnimateOwl.setup_play($owl, $object, side);
	        setTimeout(function () {
	            if (type == "saxophone") {
	                if (side == "hand") {
	                    AnimateOwl.play_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, $owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop, 'rotate(-70deg)', 'rotate(-86deg)', 'rotate(-20deg)', '5.2', '-1.7');
	                } else {
	                    AnimateOwl.play_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, $owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop, 'rotate(70deg)', 'rotate(86deg)', 'rotate(20deg)', '-5.2', '+1.7');
	                }
	            } else {
	                if (side == "hand") {
	                    AnimateOwl.play_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, $owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop, 'rotate(66deg)', 'rotate(30deg)', 'rotate(-20deg)', '-20', '-15');
	                } else {
	                    AnimateOwl.play_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, $owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop, 'rotate(-66deg)', 'rotate(-30deg)', 'rotate(20deg)', '20', '15');
	                }
	            }
	            AnimateOwl.animate_notes($owl.find("[data-play='note0']"), $owl.find("[data-play='note1']"), $owl.find("[data-play='note2']"), loop, side);
	        }, 250);
	    },
	
	    setup_play: function setup_play($owl, $object, side) {
	        var patchPath = dynamicRequire('misc/note-sm.png');
	        AnimateOwl.set_wings($owl, 500);
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        if (side == "hand") {
	            $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            $object.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '71% 54%').css('-webkit-transform-origin', '71% 54%');
	            $object.after("<img src='" + patchPath + "' style='left: -2%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
	            $object.after("<img src='" + patchPath + "' style='left: -5%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
	            $object.after("<img src='" + patchPath + "' style='left: -8%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
	        } else {
	            $object.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '29% 54%').css('-webkit-transform-origin', '29% 54%');
	            // if( offset ){
	            //     $object.after("<img src='"+patchPath+"' style='left: -185px; z-index: 9000;' data-play='note0' data-remove='true'></img>");
	            //     $object.after("<img src='"+patchPath+"' style='left: -195px; z-index: 9000;' data-play='note1' data-remove='true'></img>");
	            //     $object.after("<img src='"+patchPath+"' style='left: -205px; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
	            // }
	            // else{
	            $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	            $object.after("<img src='" + patchPath + "' style='left: -64%; z-index: 9000;' data-play='note0' data-remove='true'></img>");
	            $object.after("<img src='" + patchPath + "' style='left: -67%; z-index: 9000;' data-play='note1' data-remove='true'></img>");
	            $object.after("<img src='" + patchPath + "' style='left: -70%; z-index: 9000;' data-play='note2' data-remove='true' ></img>");
	            // }
	        }
	    },
	
	    play_motion: function play_motion($owl, $wing, $object, $note1, $note2, $note3, loop, deg1, deg2, deg3, l1, l2, t2) {
	
	        AnimateOwl.moving_eyes();
	        $object.animate({ top: '-3.6', left: l1 }, 500, 'linear').css('transform', deg1).css('-webkit-transform', deg1);
	        $wing.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        // $note1.animate({ top: '-20' },330,'linear');
	        // $note2.animate({ top: '-10' },330,'linear');
	        // $note3.animate({ top: '-10' },330,'linear');
	        // setTimeout(function(){
	        //     $note1.animate({ top: '-10' },330,'linear');
	        //     $note2.animate({ top: '-20' },330,'linear');
	        // },333);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $object.animate({ top: '-20.6', left: l2 }, 500, 'linear').css('transform', deg2).css('-webkit-transform', deg2);
	            $wing.css('transform', deg3).css('-webkit-transform', deg3);
	        }, 500);
	        // setTimeout(function(){
	        //     $note2.animate({ top: '-10' },300,'linear');
	        //     $note3.animate({ top: '-20' },300,'linear');
	        // },666);
	
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.play_motion($owl, $wing, $object, $note1, $note2, $note3, loop - 1, deg1, deg2, deg3, l1, l2, t2);
	            } else {
	                $object.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 1000);
	    },
	
	    eat_animation: function eat_animation(loop, $owl, $object, type, side) {
	        AnimateOwl.setup_eat($owl, $object, side);
	        setTimeout(function () {
	            if (side == "hand") {
	                $owl.find("[data-patch='left_hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	                switch (type) {
	                    case "icecream":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(-56deg)', 'rotate(65deg)', '-33', '+=0', loop);
	                        break;
	                    case "popcorn":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(-33deg)', 'rotate(65deg)', '-33', '+=0', loop);
	                        break;
	                    case "megaphone":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(0deg)', 'rotate(65deg)', '-33', '+=0', loop);
	                        break;
	                    case "sandwich":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(65deg)', 'rotate(65deg)', '-40', '-=16', loop);
	                        break;
	                    case "tulip":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(-65deg)', 'rotate(65deg)', '-20', '+=15', loop);
	                        break;
	                    case "microphone":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(-78deg)', 'rotate(65deg)', '-10', '-=0', loop);
	                        break;
	                    case "feeding":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(1), $object, 'rotate(0eg)', 'rotate(65deg)', '226', '-=10', loop);
	                        break;
	                }
	            } else {
	                $owl.find("[data-patch='hand']").attr('data-appear', 'true').fadeTo(200, 0.0);
	                switch (type) {
	                    case "icecream":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(56deg)', 'rotate(-65deg)', '33', '+=0', loop);
	                        break;
	                    case "popcorn":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(33deg)', 'rotate(-65deg)', '33', '+=0', loop);
	                        break;
	                    case "megaphone":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(0deg)', 'rotate(-65deg)', '33', '+=0', loop);
	                        break;
	                    case "sandwich":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(-65deg)', 'rotate(-65deg)', '40', '-=16', loop);
	                        break;
	                    case "tulip":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(65deg)', 'rotate(-65deg)', '20', '+=15', loop);
	                        break;
	                    case "microphone":
	                        AnimateOwl.eat_motion($owl, $owl.find("[data-patch='wings']").eq(0), $object, 'rotate(78deg)', 'rotate(-65deg)', '10', '-=0', loop);
	                        break;
	                }
	            }
	        }, 100);
	    },
	    setup_eat: function setup_eat($owl, $object, side) {
	        AnimateOwl.set_wings($owl, 500);
	        AnimateOwl.set_eyes($owl);
	        if (side == "hand") {
	            $object.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '71% 54%').css('-webkit-transform-origin', '71% 54%');
	        } else {
	            $object.css('transition', 'transform 500ms').css('-webkit-transition', '-webkit-transform 500ms').css('transform-origin', '29% 54%').css('-webkit-transform-origin', '29% 54%');
	        }
	        $object.animate({ top: '0' }, 100);
	    },
	    eat_motion: function eat_motion($owl, $wing, $object, deg1, deg2, left1, top1, loop) {
	        $wing.css('transform', deg2).css('-webkit-transform', deg2);
	        $object.css('transform', deg1).css('-webkit-transform', deg1).animate({ left: left1, top: top1 }, 500, 'linear');
	
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $object.animate({ top: '-=10' }, 500, 'linear');
	        }, 500);
	        setTimeout(function () {
	            $object.animate({ top: '+=10' }, 500, 'linear');
	        }, 1000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $object.animate({ top: '-=10' }, 500, 'linear');
	        }, 1500);
	        setTimeout(function () {
	            $object.animate({ top: '+=10' }, 500, 'linear');
	        }, 2000);
	
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $object.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            $object.animate({ left: '0', top: '0' }, 500, 'linear');
	            $wing.css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        }, 2500);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.eat_motion($owl, $wing, $object, deg1, deg2, left1, top1, loop - 1);
	            } else {
	                AnimateOwl.resetAnimation($owl);
	            }
	        }, 3000);
	    },
	
	    blizzard_animation: function blizzard_animation(loop, $owl, side) {
	        AnimateOwl.setup_blizzard($owl, side);
	        setTimeout(function () {
	            AnimateOwl.blizzard_motion($owl, $("[data-blizzard='ice0']"), $("[data-blizzard='ice1']"), $owl.find("[data-patch='" + side + "']"), loop);
	        }, 1300);
	    },
	    setup_blizzard: function setup_blizzard($owl, side) {
	        $owl.css('overflow', 'hidden');
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find(" [data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        var path = dynamicRequire('patches/hand/ice-powers.png');
	        $owl.find("[data-patch=" + side + "]").fadeTo(100, 0).fadeTo(100, 1).fadeTo(100, 0).fadeTo(100, 1).fadeTo(100, 0).fadeTo(100, 1).fadeTo(100, 0).fadeTo(100, 1).fadeTo(100, 0).fadeTo(100, 1).fadeTo(100, 0).fadeTo(100, 1);
	        setTimeout(function () {
	            if (side == "hand") {
	                $owl.find("[data-patch=" + side + "]").animate({ top: ['-=140', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear');
	                $owl.find("[data-patch=" + side + "]").after("<img src='" + path + "' style='top: -140px; z-index: 9000;' data-blizzard='ice0' data-remove='true'></img>");
	                $owl.find("[data-patch=" + side + "]").after("<img src='" + path + "' style='top: -140px;left: -40px; z-index: 9000;' data-blizzard='ice1' data-remove='true'></img>");
	            } else {
	                $owl.find("[data-patch=" + side + "]").animate({ top: ['-=140', 'swing'], left: ['+=80', 'swing'] }, 500, 'linear');
	                $owl.find("[data-patch=" + side + "]").after("<img src='" + path + "' style='top: -140px;left: -10px; z-index: 9000;' data-blizzard='ice0' data-remove='true'></img>");
	                $owl.find("[data-patch=" + side + "]").after("<img src='" + path + "' style='top: -140px;left: -120px; z-index: 9000;' data-blizzard='ice1' data-remove='true'></img>");
	            }
	        }, 1000);
	    },
	
	    blizzard_motion: function blizzard_motion($owl, $ice1, $ice2, $ice3, loop) {
	        // loop = 2750
	
	        $ice1.animate({ top: '+=160' }, 750, 'linear', function () {
	            $ice1.fadeTo(1400, 0.0, function () {
	                $ice1.css('top', '-140px').fadeTo(0, 1.0);
	            });
	        });
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $ice2.animate({ top: '+=145' }, 750, 'linear', function () {
	                $ice2.fadeTo(1400, 0.0, function () {
	                    $ice2.css('top', '-140px').fadeTo(0, 1.0);
	                });
	            });
	        }, 750);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $ice3.animate({ top: '+=170' }, 750, 'linear', function () {
	                $ice3.fadeTo(1400, 0.0, function () {
	                    $ice3.css('top', '-140px').fadeTo(0, 1.0);
	                });
	            });
	        }, 1500);
	
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.blizzard_motion($owl, $ice1, $ice2, $ice3, loop - 1);
	            } else {
	                setTimeout(function () {
	                    AnimateOwl.resetAnimation($owl, function () {
	                        $owl.css('overflow', 'visible');
	                    });
	                }, 1500);
	            }
	        }, 2250);
	    },
	
	    alive_owl: function alive_owl($owl, period, index, patches, perks, preview) {
	        if ($wr.isInternetExplorer()) {
	            return;
	        }
	        if (!AnimateOwl.handle[index]) {
	            AnimateOwl.handle[index] = -1;
	        }
	        var delayfeeding = 0;
	        AnimateOwl.alive_owl_setup_owl($owl);
	        $owl.find("[data-patch='hand']").attr('data-moveObjectLeft', $owl.find("[data-patch='hand']").css('left')).attr('data-moveObjectTop', $owl.find("[data-patch='hand']").css('top'));
	        $owl.find("[data-patch='left_hand']").attr('data-moveObjectLeft', $owl.find("[data-patch='left_hand']").css('left')).attr('data-moveObjectTop', $owl.find("[data-patch='left_hand']").css('top'));
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_patches($owl, patches);
	        if (perks.greetings && !preview) {
	            AnimateOwl.greet($owl, perks.greetings, index);
	            var timeout_handle = setTimeout(function () {
	                AnimateOwl.alive_owl_animation($owl, period, 12000, index, perks);
	            }, 2000 + delayfeeding);
	            AnimateOwl.handle[index] = parseInt(timeout_handle);
	        } else if (typeof preview == "string") {
	            console.log(preview);
	            AnimateOwl.greet($owl, preview, index);
	            var timeout_handle = setTimeout(function () {
	                AnimateOwl.alive_owl_animation($owl, period, 12000, index, perks);
	            }, 2000 + delayfeeding);
	            AnimateOwl.handle[index] = parseInt(timeout_handle);
	        } else {
	            AnimateOwl.alive_owl_animation($owl, period, 2000 + delayfeeding, index, perks);
	        }
	    },
	    setup_patches: function setup_patches($owl, patches) {
	        var parts = ['body', 'body2', 'hand', 'left_hand'];
	        parts.forEach(function (part) {
	            if (patches[part] != "no_patch") {
	                if (patches[part] && patches[part].has_animation && patches[part].animation) {
	                    $owl.find("[data-patch='" + part + "']").attr('data-animationtype', patches[part].animation);
	                }
	            }
	        });
	    },
	    alive_owl_setup_owl: function alive_owl_setup_owl($owl) {
	        $owl.find(" img ").attr('data-aliveMoveVertical', 'true');
	        $owl.find(" [data-patch='wings']").attr('data-aliveMoveVertical', 'false');
	        $owl.find(" [data-patch='feet']").attr('data-aliveMoveVertical', 'false');
	        $owl.find(" [data-patch='hand']").attr('data-aliveMoveVertical', 'false');
	        $owl.find(" [data-patch='left_hand']").attr('data-aliveMoveVertical', 'false');
	    },
	
	    alive_owl_animation: function alive_owl_animation($owl, period, wait, index, perks) {
	        setTimeout(function () {
	            // switch(8){
	            switch (Math.floor(Math.random() * 9)) {
	                case 0:
	                    //move wings
	                    wait = 4000;
	                    AnimateOwl.alive_owl_move_wings($owl);
	                    break;
	                case 1:
	                    //blink eyes
	                    wait = 0;
	                    AnimateOwl.alive_owl_blink_eyes($owl);
	                    break;
	                case 2:
	                    // move body
	                    wait = 0;
	                    AnimateOwl.alive_owl_move_body($owl);
	                    break;
	                case 3:
	                    //rotate body
	                    wait = 0;
	                    AnimateOwl.alive_owl_rotate_body($owl);
	                    break;
	                case 4:
	                    //animate object right hand
	                    wait = AnimateOwl.animate_object_hand($owl, "hand");
	                    // AnimateOwl.dance_controller( 1,$owl,1 );
	                    // wait = 5000
	                    break;
	                case 5:
	                    //animate object left hand
	                    wait = AnimateOwl.animate_object_hand($owl, "left_hand");
	                    // AnimateOwl.dance_controller( 1,$owl,2 );
	                    // wait = 5000
	                    break;
	                case 6:
	                    //animate object body
	                    wait = AnimateOwl.animate_object_hand($owl, "body");
	                    // AnimateOwl.dance_controller( 1,$owl,3 );
	                    // wait = 5000
	                    break;
	                case 7:
	                    //animate object body
	                    wait = AnimateOwl.animate_object_hand($owl, "body2");
	                    break;
	                case 8:
	                    //play owl sound
	                    if (perks.owl_hoots) {
	                        wait = AnimateOwl.alive_owl_play_sound($owl, perks.owl_hoots + "_" + index);
	                    } else {
	                        wait = 0;
	                        AnimateOwl.alive_owl_rotate_body($owl);
	                    }
	                    break;
	            }
	        }, wait);
	        var random_delay = Math.floor(Math.random() * 500);
	        var timeout_handle = setTimeout(function () {
	            AnimateOwl.alive_owl_animation($owl, period, wait, index, perks);
	        }, period + wait + random_delay);
	        AnimateOwl.handle[index] = parseInt(timeout_handle);
	    },
	
	    alive_owl_move_wings: function alive_owl_move_wings($owl) {
	        $owl.find("[data-patch='originalwings']").animate({ top: '-=10' }, 500, 'linear');
	        setTimeout(function () {
	            $owl.find("[data-patch='originalwings']").animate({ top: '+=10' }, 500, 'linear');
	        }, 200);
	    },
	    alive_owl_blink_eyes: function alive_owl_blink_eyes($owl) {
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find("[data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	        }, 100);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            AnimateOwl.resetAnimation($owl);
	        }, 1100);
	    },
	    alive_owl_move_body: function alive_owl_move_body($owl) {
	        $owl.find(" [data-aliveMoveVertical='true']").animate({ top: '+=10' }, 500, 'linear');
	        setTimeout(function () {
	            $owl.find("[data-aliveMoveVertical='true']").animate({ top: '-=10' }, 500, 'linear');
	        }, 200);
	    },
	    alive_owl_rotate_body: function alive_owl_rotate_body($owl) {
	        $owl.find(" [data-aliveMoveVertical='true']").css('transition', 'transform 1s').css('-webkit-transition', '-webkit-transform 1s');
	        setTimeout(function () {
	            $owl.find(" [data-aliveMoveVertical='true']").css('transform', 'rotate(5deg)').css('-webkit-transform', 'rotate(5deg)');
	        }, 20);
	        setTimeout(function () {
	            $owl.find(" [data-aliveMoveVertical='true']").css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	        }, 1020);
	    },
	
	    animate_object_hand: function animate_object_hand($owl, side) {
	
	        var wait = 0;
	        switch ($owl.find("[data-patch='" + side + "']").data('animationtype')) {
	
	            case "spin":
	                AnimateOwl.spin_animation(10000, $owl.find("[data-patch='" + side + "']"), side);
	                wait = 12000;
	                break;
	            case "swing":
	                AnimateOwl.swing_animation(4, $owl.find("[data-patch='" + side + "']"), side);
	                wait = 9000;
	                break;
	            case "ball":
	                AnimateOwl.ball_animation(5, $owl, side);
	                wait = 9000;
	                break;
	            case "catch":
	                AnimateOwl.catch_animation($owl, side);
	                wait = 5000;
	                break;
	            case "blizzard":
	                AnimateOwl.blizzard_animation(4, $owl, side);
	                wait = 14000;
	                break;
	            case "playsaxophone":
	                AnimateOwl.play_animation(3, $owl, $owl.find("[data-patch='" + side + "']"), "saxophone", side); // Play instrument animation
	                wait = 5000;
	                break;
	            case "playtrumpet":
	                AnimateOwl.play_animation(3, $owl, $owl.find("[data-patch='" + side + "']"), "trumpet", side);
	                wait = 5000;
	                break;
	            case "playviolin":
	                AnimateOwl.play_animation(3, $owl, $owl.find("[data-patch='" + side + "']"), "violin", side);
	                wait = 5000;
	                break;
	            case "eaticecream":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "icecream", side); // eat animation
	                wait = 10000;
	                break;
	            case "eatpopcorn":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "popcorn", side);
	                wait = 10000;
	                break;
	            case "eatsandwich":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "sandwich", side);
	                wait = 10000;
	                break;
	            case "eatmegaphone":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "megaphone", side);
	                wait = 10000;
	                break;
	            case "eatmicrophone":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "microphone", side);
	                wait = 10000;
	                break;
	            case "eattulip":
	                AnimateOwl.eat_animation(2, $owl, $owl.find("[data-patch='" + side + "']"), "tulip", side);
	                wait = 10000;
	                break;
	            case "swingbodymusic":
	                AnimateOwl.swing_body_animation(4, $owl, $owl.find("[data-patch='" + side + "']"), true, "default", side);
	                wait = 9000;
	                break;
	            case "swingbody":
	                AnimateOwl.swing_body_animation(4, $owl, $owl.find("[data-patch='" + side + "']"), false, "default", side);
	                wait = 9000;
	                break;
	            case "swingbodyharp":
	                AnimateOwl.swing_body_animation(4, $owl, $owl.find("[data-patch='" + side + "']"), true, "harp", side);
	                wait = 9000;
	                break;
	            case "swingbodycello":
	                AnimateOwl.swing_body_animation(4, $owl, $owl.find("[data-patch='" + side + "']"), true, "cello", side);
	                wait = 9000;
	                break;
	
	            default:
	                switch (side) {
	
	                    case "hand":
	                        AnimateOwl.alive_owl_blink_eyes($owl);
	                        break;
	                    case "left_hand":
	                        AnimateOwl.alive_owl_rotate_body($owl);
	                        break;
	                    case "body":
	                        AnimateOwl.alive_owl_move_body($owl);
	                        break;
	                    case "body2":
	                        AnimateOwl.alive_owl_move_wings($owl);
	                        break;
	                }
	                wait = 0;
	                break;
	        }
	        return wait;
	    },
	
	    greet: function greet($owl, greet_type, index) {
	
	        switch (greet_type) {
	
	            case "Fly":
	                AnimateOwl.fly_controler(3, $owl);
	                break;
	            case "Wave":
	                AnimateOwl.wave_controller(3, $owl);
	                break;
	            case "Mambo":
	                AnimateOwl.dance_controller(3, $owl, 1);
	                AnimateOwl.play_sound("Mambo" + "_" + index);
	                break;
	            case "Tango":
	                AnimateOwl.dance_controller(3, $owl, 2);
	                AnimateOwl.play_sound("Tango" + "_" + index);
	                break;
	            case "Swing":
	                AnimateOwl.dance_controller(3, $owl, 3);
	                AnimateOwl.play_sound("Swing" + "_" + index);
	                break;
	        }
	    },
	
	    alive_owl_play_sound: function alive_owl_play_sound($owl, hoot) {
	        $owl.find("[data-patch='eyes']").attr('data-src', $owl.find("[data-patch='eyes']").attr('src')).attr('data-animate', 'eyes');
	        AnimateOwl.moving_eyes();
	        AnimateOwl.play_sound(hoot);
	        $owl.find(" [data-aliveMoveVertical='true']").css('transition', 'transform 1s').css('-webkit-transition', '-webkit-transform 1s');
	        setTimeout(function () {
	            $owl.find(" [data-aliveMoveVertical='true']").css('transform', 'rotate(-10deg)').css('-webkit-transform', 'rotate(-10deg)');
	        }, 20);
	        setTimeout(function () {
	            $owl.find(" [data-aliveMoveVertical='true']").css('transform', 'rotate(0deg)').css('-webkit-transform', 'rotate(0deg)');
	            AnimateOwl.moving_eyes();
	            AnimateOwl.resetAnimation($owl);
	        }, 1020);
	
	        return 2000;
	    },
	    stop_animation: function stop_animation($owl, index) {
	        if ($wr.isInternetExplorer()) {
	            return;
	        }
	        clearTimeout(AnimateOwl.handle[index]);
	    },
	
	    play_sound: function play_sound(ref) {
	        window.wrL2eSound.playSound(ref);
	    },
	    /////////////////////////////////: Feeding
	
	    feeding_motion: function feeding_motion($owl, $object, wing, deg, left, top) {
	        AnimateOwl.moving_wings($owl, 1, deg);
	        $object.animate({ left: left, top: top }, 500, 'linear');
	        AnimateOwl.moving_eyes();
	
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('eating');
	            }
	            $object.animate({ top: '-=10' }, 500, 'linear');
	        }, 500);
	        setTimeout(function () {
	            $object.animate({ top: '+=10' }, 500, 'linear');
	        }, 1000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $object.animate({ top: '-=10' }, 500, 'linear');
	        }, 1500);
	        setTimeout(function () {
	            $object.animate({ top: '+=10' }, 500, 'linear');
	        }, 2000);
	        setTimeout(function () {
	            $object.hide("puff");
	        }, 2300);
	    },
	    feeding1_animation: function feeding1_animation($owl, $object) {
	
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        AnimateOwl.alive_owl_setup_owl($owl);
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '240', "+=0");
	        }, 500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            AnimateOwl.moving_wings($owl, 1, -120);
	            AnimateOwl.moving_wings($owl, 0, 120);
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	        }, 3000);
	        setTimeout(function () {
	            AnimateOwl.alive_owl_rotate_body($owl);
	        }, 3500);
	    },
	    feeding2_animation: function feeding2_animation($owl, $object) {
	
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        AnimateOwl.alive_owl_setup_owl($owl);
	        AnimateOwl.swing_animation(3, $object, "feed");
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '240', "+=0");
	        }, 4500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(-120deg)").css('-webkit-transform', 'rotate(-120deg)');
	            $owl.find("[data-patch='wings']").eq(0).css('transform', "rotate(120deg)").css('-webkit-transform', 'rotate(120deg)');
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	        }, 7000);
	        setTimeout(function () {
	            AnimateOwl.alive_owl_rotate_body($owl);
	        }, 7250);
	    },
	
	    feeding3_animation: function feeding3_animation($owl, $object) {
	
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '245', "+=0");
	        }, 500);
	
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	        }, 2500);
	        setTimeout(function () {
	            AnimateOwl.fly_controler(2, $(".modalFeedingOwl").find(".owlConstraints"));
	        }, 3000);
	    },
	
	    feeding4_animation: function feeding4_animation($owl, $object) {
	
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        AnimateOwl.spin_animation(4000, $object, "feeding");
	        AnimateOwl.moving_eyes();
	
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '226', "+=0");
	        }, 4000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	        }, 7000);
	        setTimeout(function () {
	            AnimateOwl.falling_animation(0);
	            AnimateOwl.dance_controller(0, $owl, 1);
	        }, 7550);
	    },
	
	    feeding5_animation: function feeding5_animation($owl, $object) {
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        setTimeout(function () {
	            $object.animate({ top: ['-=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear').animate({ top: ['+=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(-120deg)").css('-webkit-transform', 'rotate(-120deg)');
	            AnimateOwl.moving_eyes();
	        }, 500);
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 0, -65, '220', "-=15");
	        }, 1500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	        }, 3500);
	        setTimeout(function () {
	            AnimateOwl.leaf_animation();
	            AnimateOwl.dance_controller(1, $owl, 2);
	        }, 4200);
	    },
	
	    feeding6_animation: function feeding6_animation($owl, $object) {
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        setTimeout(function () {
	            $object.animate({ top: ['-=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear').animate({ top: ['+=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(-120deg)").css('-webkit-transform', 'rotate(-120deg)');
	            AnimateOwl.moving_eyes();
	        }, 500);
	        setTimeout(function () {
	            $object.animate({ top: ['-=100', 'swing'], left: ['+=80', 'swing'] }, 500, 'linear').animate({ top: ['+=100', 'swing'], left: ['+=80', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(0deg)").css('-webkit-transform', 'rotate(0deg)');
	            $owl.find("[data-patch='wings']").eq(0).css('transform', "rotate(120deg)").css('-webkit-transform', 'rotate(120deg)');
	        }, 1500);
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '226', "+=0");
	        }, 2500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	            AnimateOwl.dance_controller(2, $owl, 3);
	        }, 5000);
	        setTimeout(function () {
	            AnimateOwl.falling_animation(4);
	        }, 6000);
	    },
	
	    feeding7_animation: function feeding7_animation($owl, $object) {
	
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.setup_eat($owl, $object, "hand");
	        setTimeout(function () {
	            $object.animate({ top: ['-=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear').animate({ top: ['+=100', 'swing'], left: ['-=80', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(-120deg)").css('-webkit-transform', 'rotate(-120deg)');
	            AnimateOwl.moving_eyes();
	        }, 500);
	        setTimeout(function () {
	            $object.animate({ top: ['-=100', 'swing'], left: ['+=80', 'swing'] }, 500, 'linear').animate({ top: ['+=100', 'swing'], left: ['+=80', 'swing'] }, 500, 'linear');
	            $owl.find("[data-patch='wings']").eq(1).css('transform', "rotate(0deg)").css('-webkit-transform', 'rotate(0deg)');
	            $owl.find("[data-patch='wings']").eq(0).css('transform', "rotate(120deg)").css('-webkit-transform', 'rotate(120deg)');
	        }, 1500);
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $object, 1, 65, '250', "-=20");
	        }, 2500);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            if (playSound) {
	                L2ESound.play_sound('applause');
	            }
	            AnimateOwl.dance_controller(2, $owl, 3);
	        }, 5000);
	        setTimeout(function () {
	            AnimateOwl.falling_animation(4);
	        }, 5750);
	    },
	
	    falling_animation: function falling_animation(loop) {
	        AnimateOwl.falling_motion_left($("#falling1"), loop);
	        setTimeout(function () {
	            AnimateOwl.falling_motion_right($("#falling4"), loop);
	        }, 250);
	        setTimeout(function () {
	            AnimateOwl.falling_motion_left($("#falling2"), loop);
	        }, 400);
	        setTimeout(function () {
	            AnimateOwl.falling_motion_right($("#falling6"), loop);
	        }, 500);
	        setTimeout(function () {
	            AnimateOwl.falling_motion_right($("#falling5"), loop);
	        }, 600);
	        setTimeout(function () {
	            AnimateOwl.falling_motion_left($("#falling3"), loop);
	        }, 800);
	        setTimeout(function () {
	            if (loop) {
	                AnimateOwl.falling_animation(loop - 1);
	            }
	        }, 1400);
	    },
	
	    falling_motion_left: function falling_motion_left($object, loop) {
	        $object.fadeTo(10, 1.0);
	        $object.animate({ top: ['+=110', 'ease'] }, 500, 'linear').animate({ top: ['+=200', 'swing'], left: ['-=60', 'swing'] }, 500, 'linear');
	        if (loop) {
	            setTimeout(function () {
	                $object.fadeTo(50, 0.0, function () {
	                    $object.animate({ top: '-=310', left: '+=60' }, 0, 'linear');
	                });
	            }, 1000);
	        }
	    },
	    falling_motion_right: function falling_motion_right($object, loop) {
	        $object.fadeTo(10, 1.0);
	        $object.animate({ top: ['+=110', 'ease'] }, 500, 'linear').animate({ top: ['+=200', 'swing'], left: ['+=60', 'swing'] }, 500, 'linear');
	        if (loop) {
	            setTimeout(function () {
	                $object.fadeTo(200, 0.0, function () {
	                    $object.animate({ top: '-=310', left: '-=60' }, 1, 'linear');
	                });
	            }, 1000);
	        }
	    },
	    leaf_animation: function leaf_animation() {
	        AnimateOwl.leaf_motion_left($("#falling1"));
	        setTimeout(function () {
	            AnimateOwl.leaf_motion_right($("#falling4"));
	        }, 400);
	        setTimeout(function () {
	            AnimateOwl.leaf_motion_left($("#falling2"));
	        }, 600);
	        setTimeout(function () {
	            AnimateOwl.leaf_motion_right($("#falling6"));
	        }, 1000);
	        setTimeout(function () {
	            AnimateOwl.leaf_motion_right($("#falling5"));
	        }, 1200);
	        setTimeout(function () {
	            AnimateOwl.leaf_motion_left($("#falling3"));
	        }, 1300);
	    },
	
	    leaf_motion_left: function leaf_motion_left($object) {
	        $object.fadeTo(700, 1.0);
	        $object.animate({ top: ['+=80', 'swing'], left: ['-=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=80', 'swing'], left: ['+=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=80', 'swing'], left: ['-=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=50', 'swing'], left: ['+=80', 'swing'] }, 1000, 'linear').fadeTo(500, 0.0);
	    },
	
	    leaf_motion_right: function leaf_motion_right($object) {
	        $object.fadeTo(700, 1.0);
	        $object.animate({ top: ['+=80', 'swing'], left: ['+=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=80', 'swing'], left: ['-=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=80', 'swing'], left: ['+=80', 'swing'] }, 1000, 'linear').animate({ top: ['+=50', 'swing'], left: ['-=80', 'swing'] }, 1000, 'linear').fadeTo(500, 0.0);
	    },
	
	    feeding_owl: function feeding_owl($owl) {
	        $owl.find("[data-patch='wings']").after("<img src='/patches/food/" + $owl.data("foodanimation") + ".png' style='z-index: 9000;' data-patch='food' data-remove='true'></img>");
	        $owl.find("[data-patch='hand']").hide();
	        $owl.find("[data-patch='left_hand']").hide();
	        AnimateOwl.setup_eat($owl, $owl.find("[data-feed='food']"), "hand");
	        setTimeout(function () {
	            AnimateOwl.feeding_motion($owl, $owl.find("[data-patch='food']"), 1, 65, '-50', "-=10");
	        }, 500);
	        setTimeout(function () {
	            AnimateOwl.resetAnimation($owl);
	        }, 3000);
	    },
	
	    /////////////////////////////////: Badge Notification
	
	    new_badge_animation: function new_badge_animation($owl) {
	        AnimateOwl.separate_wings($owl);
	        AnimateOwl.alive_owl_setup_owl($owl);
	        AnimateOwl.set_wings($owl, 1000);
	        AnimateOwl.set_transform($owl, "[data-aliveMoveVertical='true']", 1000);
	        setTimeout(function () {
	            AnimateOwl.new_badge_motion($owl);
	        }, 3000);
	    },
	    new_badge_motion: function new_badge_motion($owl) {
	        AnimateOwl.fly_controler(1, $owl);
	        setTimeout(function () {
	            AnimateOwl.set_wings($owl, 1000);
	            AnimateOwl.moving_eyes();
	            AnimateOwl.moving_wings($owl, 1, -120);
	            AnimateOwl.moving_wings($owl, 0, 120);
	            AnimateOwl.rotate_object($owl, "[data-aliveMoveVertical='true']", 15);
	        }, 6000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            AnimateOwl.moving_wings($owl, 1, 0);
	            AnimateOwl.moving_wings($owl, 0, 0);
	            AnimateOwl.rotate_object($owl, "[data-aliveMoveVertical='true']", 0);
	        }, 7000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            AnimateOwl.moving_wings($owl, 1, -120);
	            AnimateOwl.moving_wings($owl, 0, 120);
	            AnimateOwl.rotate_object($owl, "[data-aliveMoveVertical='true']", -15);
	        }, 8000);
	        setTimeout(function () {
	            AnimateOwl.moving_eyes();
	            AnimateOwl.moving_wings($owl, 1, 0);
	            AnimateOwl.moving_wings($owl, 0, 0);
	            AnimateOwl.rotate_object($owl, "[data-aliveMoveVertical='true']", 0);
	        }, 9000);
	        setTimeout(function () {
	            AnimateOwl.alive_owl_setup_owl($owl);
	            AnimateOwl.set_wings($owl, 1000);
	            AnimateOwl.new_badge_motion($owl);
	        }, 10000);
	    }
	};
	module.exports = AnimateOwl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	"use strict";
	
	var LiveChatClient = {
		init: function init(user) {
			if (!window.LiveChatWidget) {
				window.__lc = window.__lc || {};
				window.__lc.license = 12140916;
				;(function (n, t, c) {
					function i(n) {
						return e._h ? e._h.apply(null, n) : e._q.push(n);
					}var e = { _q: [], _h: null, _v: "2.0", on: function on() {
							i(["on", c.call(arguments)]);
						}, once: function once() {
							i(["once", c.call(arguments)]);
						}, off: function off() {
							i(["off", c.call(arguments)]);
						}, get: function get() {
							if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get", c.call(arguments)]);
						}, call: function call() {
							i(["call", c.call(arguments)]);
						}, init: function init() {
							var n = t.createElement("script");n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n);
						} };!n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e;
				})(window, document, [].slice);
	
				if (user) {
					window.LiveChatWidget.call('set_customer_name', user.first_name + " " + user.last_name);
					if (user.email) {
						window.LiveChatWidget.call('set_customer_email', user.email);
					}
				}
			}
		},
	
		hide: function hide() {
			if (window.LiveChatWidget) {
				window.LiveChatWidget.call('hide');
			}
		},
		show: function show() {
			if (window.LiveChatWidget) {
				window.LiveChatWidget.call('minimize');
			}
		},
	
		isChatting: function isChatting() {
			return window.LiveChatWidget && window.LiveChatWidget.get('chat_data') && window.LiveChatWidget.get('chat_data').chatId;
		}
	};
	
	module.exports = LiveChatClient;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isActive = isActive;
	exports.init = init;
	exports.setUserContext = setUserContext;
	
	var _browser = __webpack_require__(694);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Can't use $wr methods!
	// No $wr.isProduction specifically
	
	function isActive() {
		return false; //DISABLE SENTRY FOR WEB CLIENT BECAUSE OF JS ERRORS OVERFLOWING SENTRY CREDIT
		// return process.env.NODE_ENV === "production";
	}
	
	var IGNORE_ERRORS = [{ value: "Network request failed" }, { value: "Unexpected end of JSON input" }, { type: "UnhandledRejection" }, { type: "NS_ERROR_FAILURE" },
	
	// Something inside of react-tooltip I can't get a handle on.
	// My guess is something timing related with on
	{ value: "Cannot read property 'getBoundingClientRect' of null" }, { value: "ResizeObserver loop limit exceeded" }, { type: "WR APIError 500" }, { type: "WR APIError 404" }, { type: "WR APIError 403" }, { type: "WR APIError 401" }];
	
	function init() {
		if (!isActive()) {
			return;
		}
	
		var checkpoint = new Date().valueOf();
		var checkpointCount = 0;
		var CHECKPOINT_LIMIT = 3;
		var CHECKPOINT_LENGTH = 30 * 1000;
	
		Sentry.init({
			dsn: "https://7549e9fb52124a38b3bc617c2f231f17@sentry.io/1731988",
	
			beforeSend: function beforeSend(event) {
				// The ignoreErrors thing was being flaky
				var exception = event.exception.values[0];
				if (exception) {
					for (var i = 0; i < IGNORE_ERRORS.length; i += 1) {
						var ignore = IGNORE_ERRORS[i];
						if (ignore.value && ignore.value == exception.value) {
							return null;
						}
	
						if (ignore.type && ignore.type == exception.type) {
							return null;
						}
					}
				}
	
				// Limits errors to at most 3 per 30 seconds
				var now = new Date().valueOf();
	
				if (checkpoint + CHECKPOINT_LENGTH < now) {
					checkpointCount = 0;
					checkpoint = now;
				}
				checkpointCount += 1;
				if (checkpointCount > CHECKPOINT_LIMIT) {
					console.log("Filtering sentry errors, error count: " + checkpointCount);
					return null;
				}
	
				if ($wr.isDevelopment()) {
					console.log("Sending error", exception);
				}
	
				return event;
			}
	
		});
	}
	
	function setUserContext(user) {
		if (!isActive()) {
			return;
		}
	
		var userData = {
			user_id: user.id,
			demo: user.demo,
			product: user.product,
			role: user.role
		};
	
		if (user.role != "studentRole") {
			userData.full_name = user.first_name + " " + user.last_name;
			userData.email = user.email;
		}
	
		if (user.primary_student_list && user.primary_student_list.primary_admin) {
			userData.teacher_user_id = user.primary_student_list.primary_admin.id;
		}
	
		Sentry.configureScope(function (scope) {
			scope.setUser(userData);
		});
	}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/admin_rostering_page";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
			if (state.studentListID) {
				fullPath += "/" + state.studentListID;
			}
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
	
			if (params.student_list_id) {
				state.studentListID = params.student_list_id;
			}
		} else {
			state.activeView = VIEWS.STUDENTS;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/admin_rostering_page/:active_view?/:student_list_id?";
	
	var VIEWS = exports.VIEWS = {
		TEACHERS: "teachers",
		STUDENTS: "students"
	};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getQuery = getQuery;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/class_results";
	
		if (state.reportUserID) {
			fullPath += "/" + state.reportUserID;
		}
	
		var queryParts = [];
	
		if (state.hideNames) {
			queryParts.push("hide_names=" + state.hideNames);
		}
	
		if (state.reportLock) {
			queryParts.push("report_lock=" + state.reportLock);
		}
	
		if (queryParts.length) {
			fullPath += "?" + queryParts.join("&");
		}
	
		return fullPath;
	}
	
	function getQuery(state) {
		var query = {
			precompute_cache: true
		};
	
		if (state.reportUserID) {
			query.report_user_id = state.reportUserID;
		}
	
		if (state.hideNames) {
			query.hide_names = true;
		}
	
		if (state.reportLock) {
			query.report_lock = state.reportLock;
		}
	
		return query;
	}
	
	function getRouteState(params) {
		var state = {};
	
		state.reportUserID = params.report_user_id;
	
		if (params.hide_names) {
			state.hideNames = true;
		} else {
			state.hideNames = false;
		}
	
		if (params.report_lock) {
			state.reportLock = params.report_lock;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/class_results/:report_user_id";

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/contests";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		}
	
		var queryParts = [];
	
		if (state.showInviteModal) {
			queryParts.push("show_invite_modal=" + state.showInviteModal);
		}
		if (state.showSchoolInfoModal) {
			queryParts.push("show_school_info_modal=" + state.showSchoolInfoModal);
		}
		if (state.csSchoolID) {
			queryParts.push("cs_school_id=" + state.csSchoolID);
		}
		if (state.l2eSchoolID) {
			queryParts.push("l2e_school_id=" + state.l2eSchoolID);
		}
	
		if (queryParts.length) {
			fullPath += "?" + queryParts.join("&");
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
		} else {
			state.activeView = VIEWS.WRITING;
		}
	
		if (params.show_invite_modal) {
			state.showInviteModal = true;
		} else {
			state.showInviteModal = false;
		}
	
		if (params.show_school_info_modal) {
			state.showSchoolInfoModal = true;
		} else {
			state.showSchoolInfoModal = false;
		}
	
		if (params.cs_school_id) {
			state.csSchoolID = params.cs_school_id;
		}
		if (params.l2e_school_id) {
			state.l2eSchoolID = params.l2e_school_id;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/contests/:active_view?";
	
	var VIEWS = exports.VIEWS = {
		READING: "reading",
		WRITING: "writing",
		OWLSTAGRAM: "owlstagram"
	};

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/settings";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		if (params.active_view) {
			state.activeView = params.active_view;
		}
	
		return state;
	}
	
	var PATH = exports.PATH = "/settings/:active_view?";

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var APIError = function (_Error) {
		_inherits(APIError, _Error);
	
		function APIError(base, errorCode, url) {
			_classCallCheck(this, APIError);
	
			var _this = _possibleConstructorReturn(this, (APIError.__proto__ || Object.getPrototypeOf(APIError)).call(this, errorCode + " error for " + $wr.getNormalizedPath(url)));
	
			_this.name = base + " APIError " + errorCode;
			return _this;
		}
	
		return APIError;
	}(Error);
	
	module.exports = APIError;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(445)
	var ieee754 = __webpack_require__(610)
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
	    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayView(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof SharedArrayBuffer !== 'undefined' &&
	      (isInstance(value, SharedArrayBuffer) ||
	      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpreted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayView (arrayView) {
	  if (isInstance(arrayView, Uint8Array)) {
	    var copy = new Uint8Array(arrayView)
	    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
	  }
	  return fromArrayLike(arrayView)
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      if (pos + buf.length > buffer.length) {
	        Buffer.from(buf).copy(buffer, pos)
	      } else {
	        Uint8Array.prototype.set.call(
	          buffer,
	          buf,
	          pos
	        )
	      }
	    } else if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    } else {
	      buf.copy(buffer, pos)
	    }
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return asciiWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF)
	      ? 4
	      : (firstByte > 0xDF)
	          ? 3
	          : (firstByte > 0xBF)
	              ? 2
	              : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += hexSliceLookupTable[buf[i]]
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
	  for (var i = 0; i < bytes.length - 1; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUintLE =
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUintBE =
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUint8 =
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUint16LE =
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUint16BE =
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUint32LE =
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUint32BE =
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUintLE =
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUintBE =
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUint8 =
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUint16LE =
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint16BE =
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint32LE =
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUint32BE =
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	// Create lookup table for `toString('hex')`
	// See: https://github.com/feross/buffer/issues/219
	var hexSliceLookupTable = (function () {
	  var alphabet = '0123456789abcdef'
	  var table = new Array(256)
	  for (var i = 0; i < 16; ++i) {
	    var i16 = i * 16
	    for (var j = 0; j < 16; ++j) {
	      table[i16 + j] = alphabet[i] + alphabet[j]
	    }
	  }
	  return table
	})()
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3545).Buffer))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(75);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(133);
	var toLength = __webpack_require__(39);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(126);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(56);
	var toObject = __webpack_require__(50);
	var IObject = __webpack_require__(180);
	var toLength = __webpack_require__(39);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(56);
	var isObject = __webpack_require__(32);
	var invoke = __webpack_require__(457);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(47).f;
	var create = __webpack_require__(127);
	var redefineAll = __webpack_require__(131);
	var ctx = __webpack_require__(77);
	var anInstance = __webpack_require__(125);
	var forOf = __webpack_require__(126);
	var $iterDefine = __webpack_require__(273);
	var step = __webpack_require__(460);
	var setSpecies = __webpack_require__(132);
	var DESCRIPTORS = __webpack_require__(42);
	var fastKey = __webpack_require__(113).fastKey;
	var validate = __webpack_require__(135);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(145);
	var from = __webpack_require__(449);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(131);
	var getWeak = __webpack_require__(113).getWeak;
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(32);
	var anInstance = __webpack_require__(125);
	var forOf = __webpack_require__(126);
	var createArrayMethod = __webpack_require__(84);
	var $has = __webpack_require__(67);
	var validate = __webpack_require__(135);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(208);
	var isObject = __webpack_require__(32);
	var toLength = __webpack_require__(39);
	var ctx = __webpack_require__(77);
	var IS_CONCAT_SPREADABLE = __webpack_require__(37)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(42) && !__webpack_require__(30)(function () {
	  return Object.defineProperty(__webpack_require__(266)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(32);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(22);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(275);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(42);
	var getKeys = __webpack_require__(129);
	var gOPS = __webpack_require__(212);
	var pIE = __webpack_require__(181);
	var toObject = __webpack_require__(50);
	var IObject = __webpack_require__(180);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(30)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(47);
	var anObject = __webpack_require__(22);
	var getKeys = __webpack_require__(129);
	
	module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(70);
	var gOPN = __webpack_require__(128).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(67);
	var toIObject = __webpack_require__(70);
	var arrayIndexOf = __webpack_require__(205)(false);
	var IE_PROTO = __webpack_require__(280)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(42);
	var getKeys = __webpack_require__(129);
	var toIObject = __webpack_require__(70);
	var isEnum = __webpack_require__(181).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(128);
	var gOPS = __webpack_require__(212);
	var anObject = __webpack_require__(22);
	var Reflect = __webpack_require__(28).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(28).parseFloat;
	var $trim = __webpack_require__(148).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(283) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(28).parseInt;
	var $trim = __webpack_require__(148).trim;
	var ws = __webpack_require__(283);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(32);
	var newPromiseCapability = __webpack_require__(277);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(39);
	var repeat = __webpack_require__(282);
	var defined = __webpack_require__(85);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(39);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(37);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(452);
	var validate = __webpack_require__(135);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(206)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(278);
	__webpack_require__(5)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(42) && /./g.flags != 'g') __webpack_require__(47).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(179)
	});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(452);
	var validate = __webpack_require__(135);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(206)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(28);
	var each = __webpack_require__(84)(0);
	var redefine = __webpack_require__(61);
	var meta = __webpack_require__(113);
	var assign = __webpack_require__(464);
	var weak = __webpack_require__(454);
	var isObject = __webpack_require__(32);
	var validate = __webpack_require__(135);
	var NATIVE_WEAK_MAP = __webpack_require__(135);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(206)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var prefix = __webpack_require__(3552)
	var toCamelCase = __webpack_require__(3866)
	var cache = { 'float': 'cssFloat' }
	var addPxToStyle = __webpack_require__(726)
	
	function style (element, property, value) {
	  var camel = cache[property]
	  if (typeof camel === 'undefined') {
	    camel = detect(property)
	  }
	
	  // may be false if CSS prop is unsupported
	  if (camel) {
	    if (value === undefined) {
	      return element.style[camel]
	    }
	
	    element.style[camel] = addPxToStyle(camel, value)
	  }
	}
	
	function each (element, properties) {
	  for (var k in properties) {
	    if (properties.hasOwnProperty(k)) {
	      style(element, k, properties[k])
	    }
	  }
	}
	
	function detect (cssProp) {
	  var camel = toCamelCase(cssProp)
	  var result = prefix(camel)
	  cache[camel] = cache[cssProp] = cache[result] = result
	  return result
	}
	
	function set () {
	  if (arguments.length === 2) {
	    if (typeof arguments[1] === 'string') {
	      arguments[0].style.cssText = arguments[1]
	    } else {
	      each(arguments[0], arguments[1])
	    }
	  } else {
	    style(arguments[0], arguments[1], arguments[2])
	  }
	}
	
	module.exports = set
	module.exports.set = set
	
	module.exports.get = function (element, properties) {
	  if (Array.isArray(properties)) {
	    return properties.reduce(function (obj, prop) {
	      obj[prop] = style(element, prop || '')
	      return obj
	    }, {})
	  } else {
	    return style(element, properties || '')
	  }
	}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(149);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(485);
	var ElementPrototype = __webpack_require__(1525);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(1530),
		__webpack_require__(1531),
		__webpack_require__(1528),
		__webpack_require__(1529),
		__webpack_require__(1527),
		__webpack_require__(1526)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	"use strict";
	
	var detector = module.exports = {};
	
	detector.isIE = function(version) {
	    function isAnyIeVersion() {
	        var agent = navigator.userAgent.toLowerCase();
	        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	    }
	
	    if(!isAnyIeVersion()) {
	        return false;
	    }
	
	    if(!version) {
	        return true;
	    }
	
	    //Shamelessly stolen from https://gist.github.com/padolsey/527683
	    var ieVersion = (function(){
	        var undef,
	            v = 3,
	            div = document.createElement("div"),
	            all = div.getElementsByTagName("i");
	
	        do {
	            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
	        }
	        while (all[0]);
	
	        return v > 4 ? v : undef;
	    }());
	
	    return version === ieVersion;
	};
	
	detector.isLegacyOpera = function() {
	    return !!window.opera;
	};


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	/**
	 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
	 * @public
	 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
	 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
	 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
	 */
	utils.forEach = function(collection, callback) {
	    for(var i = 0; i < collection.length; i++) {
	        var result = callback(collection[i]);
	        if(result) {
	            return result;
	        }
	    }
	};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(3532);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	'use strict';
	
	// do not edit .js files directly - edit src/index.jst
	
	
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      var key = keys[i];
	
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8028f7a1082d4b6a609f4c1f067223dd.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "946610e56fc93dcffe662d1b0377b3a9.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a7ff41feb016e7e44755925af4e5404.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a63ca880d0879f3269040a363f7bc15.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2950e1ee7a38d01db2205728577cd49.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "675244b6094687ca3dc2d2e0c832a5d9.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39d06883416a0fea2a3cbffe7181f7d4.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4615a3adbb3a5f712129eb5b4cdb8e2.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7169d0058408b84b8cf7c469c96b2ee4.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c7e1f010d039aec081a1b9625ab940d.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3ad35330149b9c80f6867f1babf94031.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fca6a1b9ddbb02e135f1f01fe4dcd588.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0d33dadc0fa569495bb96601deba7af.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d72d96ed20c8d95bfc8b99d4c5015898.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3f89800e2b9ddbb45915a2701e945cd.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "746da2a6507288057d0eddfb845af9a6.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be575b1028a8d49d82abfb7385660847.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "273ba6febe480801fe00946cd79aed09.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ffdc0e37695254ba5fb9e6819470538f.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca797216cd2be5bb7882fa423e41199a.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6957c80c7cb94a5b05837e5472e082b.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e2bd81f734c934f677c1879b6bfa19ba.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b17b7050a120a838f6502d3e87116a72.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a08f54c9d55b32c0578a81f090a78dc2.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1facc27ce14cf720eba06cd55467bbdc.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8cd4c5b1a4c9bcb00f16da9adefe5ea8.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bc28cf36fcfa96ee670786f83cbf3e95.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa02c77017f51bb2d4df245e42e0bc62.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca6e9a0c89101a80264285ceaba5c5a7.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "979594c509aebdadb5b852590a95def4.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32ef12152a8bfaee4ddf72d8218bfb80.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3310479257a85e7d1976dbf812aa41c8.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5470f7d85e0b0b20dc4340d2d70945e3.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "366da8f6bdf3e24684d19429b806e266.png";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "712a352ba0fa28ccd06fedf15fb592f9.png";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94d2722cc2a8b0eb883edc5b5f5debfd.png";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "23de03f0eae59ab0d50d131c69b0b005.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "605ae7db1f0bc22ceacfacfd3b0c9e43.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a08a7670c644d2e129041cd809cca97.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "284e2e4a4f66ce7ae7dde1ec1d81ae2c.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4578ca7b601bf7f7d640713f378294a5.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "023ccbf0d08c2e8df718c476230c9fec.png";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7ccdd1813cc0c04493d0da1de23669f.png";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b97e1367f00e3a184a5021c23917c1a.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a020b64700a4800d40ae0745c082998.png";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6b2a268e3c69db169324b079ac86939.png";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9e0a61377a2289a3800d3f85985dffa4.png";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6b1c2ede45baef38768c90601544f36.png";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "171aaaddfd8d9ebedb644656cb303999.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abb3956ba87a600668168cef6a8e79e2.png";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d7486ec57b4200989151850a5c5177de.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3afda2cac0bcca6c5801c0139f34c610.png";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "80fb15f202d38f093a4e89d2a0d083b8.gif";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0003e012fdad3671eb6e30aefa376510.png";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28080ef2f5c2b643b51a4d054382dc9a.png";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2d8da3cf947c41b1508ff167e263f388.png";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6cffcca60f96c5800c8470369ece3f9.png";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e6ba080cb2c6e20ca1fee6c58fe683cd.png";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b95201cc785cddb92d45803f907cf91.png";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55fa948dcf2a3d95c74310ac611d53fb.png";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f48b74dc62cf6604d44dd2c23780baa4.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fd099853f51727d3ec259193f1ad9765.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8021354340bd22ceb1318e6efcef1581.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "534f35774f257667b3db307d384f5df0.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a59e8693c0fd9fe1853f6063257573a.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3ab4daf2e3e12d16048447633ef30891.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8fa73e30b044920b334411494bfd0c01.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56815b72ded87e3b0418ba700a7ecca8.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e23675bf90e90f4b57c5df8aa3052460.png";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "960a053803d371e5b8e868773a5ac25d.png";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c27ca8290f5c9e6d3bda4537e23575e1.png";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3a0b5b05100c51c2b40f1cf65053e87.png";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ec2ab42d1446ba83e94332f7f70f025.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ecb630b74e613ecc1cfe618d79e3b9fa.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b75ab0c31cb162da6dcff093a5531eed.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "93a7363df2524940d8b45b313925e4ff.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1a9713da32b4983e5525570f2081e98a.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ca297f5527045c2d49d7f8343339c8d.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e64718ab06838769c80edc4221a929b1.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "591887d2f375b8ca4301e8b282332663.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ac160305cd38b64d87f1bc3ed91cc5b.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37b32c8adaf313529debad68f9e0ceb7.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1836ac12cbb150307d7aac28c6b3cfa4.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a45da2379c2d91bc553e24437a03df43.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e72718f4fcc37364817521bb11b096fd.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42920a03499070f395ff91ec090734e0.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3e1e36a9f0cbfa0de5c0bf2dda800e6.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4a8563b04066ba61c8707a8a8ca379a2.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7388ea1da18b09eb1f7f9a51bbf4a8f.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07bca9e4f5b2c3e30518c28837be0f04.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cfd0638cb0ab8b5ac795d028293fbaf3.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a50dcefcddfd1140f5e7465cda832a82.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "764c3ea85fdbd8eb20dfaa532a27d7ff.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "57e8c9da62fec47beb4e60e744f0c1d8.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4664fb5099f53fe533d974f91e8f05d3.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0bbb5a7f2bf87542162ca18326cebbcc.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d2d6f4cfbacf19fd67a95ff8a700265.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8df42fb5ed75d1baa885c85a280da65f.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0034ccd577957505e7f84cd2264cfa7.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c898bef07bb1c8231fd83f7c2c46c7c7.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f737b31901f905505dac64bf59b94b8.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "589743af5bad3d1de51a4d7293e87bba.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a29474a4d261db3a1dafa194a8ce384.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a31b7bc32add615c0904f1a9d6b7796.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a08414f298cf18d3680b35a72426114.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad4b37a4cee12ef4b4a142d844d9c56a.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b18918f367e5a5c23c37478baa145011.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8fe491b12454c1cebed451b3dd22dc70.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52fbe6d890bfffed2ce4a589c4a7ee1a.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b09ddd9928c7ff6ad4dd749a1502a1c7.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e0d26d6ff9ff0051204f9134b965065.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7976a62732ec1eb3f4ad937a77a1e8fe.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b32da9a5d8153c9a3020bc4e0c61680.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3504);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(345);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(608);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(221)(Parser, __webpack_require__(1544).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(489);
	var entityMap = __webpack_require__(341);
	var legacyMap = __webpack_require__(611);
	var xmlMap = __webpack_require__(342);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(607);
	var WritableStream = __webpack_require__(3925).Writable;
	var StringDecoder = __webpack_require__(3616).StringDecoder;
	var Buffer = __webpack_require__(446).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(221)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/markedjs/marked
	 */
	
	;(function(root) {
	'use strict';
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
	  table: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  paragraph: /^([^\n]+(?:\n?(?!hr|heading|lheading| {0,3}>|tag)[^\n]+)+)/,
	  text: /^[^\n]+/
	};
	
	block._label = /(?:\\[\[\]]|[^\[\]])+/;
	block._title = /(?:"(?:\\"|[^"]|"[^"\n]*")*"|'\n?(?:[^'\n]+\n?)*'|\([^()]*\))/;
	block.def = edit(block.def)
	  .replace('label', block._label)
	  .replace('title', block._title)
	  .getRegex();
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = edit(block.item, 'gm')
	  .replace(/bull/g, block.bullet)
	  .getRegex();
	
	block.list = edit(block.list)
	  .replace(/bull/g, block.bullet)
	  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
	  .replace('def', '\\n+(?=' + block.def.source + ')')
	  .getRegex();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b';
	
	block.html = edit(block.html)
	  .replace('comment', /<!--[\s\S]*?-->/)
	  .replace('closed', /<(tag)[\s\S]+?<\/\1>/)
	  .replace('closing', /<tag(?:"[^"]*"|'[^']*'|\s[^'"\/>\s]*)*?\/?>/)
	  .replace(/tag/g, block._tag)
	  .getRegex();
	
	block.paragraph = edit(block.paragraph)
	  .replace('hr', block.hr)
	  .replace('heading', block.heading)
	  .replace('lheading', block.lheading)
	  .replace('tag', '<' + block._tag)
	  .getRegex();
	
	block.blockquote = edit(block.blockquote)
	  .replace('paragraph', block.paragraph)
	  .getRegex();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = edit(block.paragraph)
	  .replace('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  .getRegex();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top) {
	  src = src.replace(/^ +$/gm, '');
	  var next,
	      loose,
	      cap,
	      bull,
	      b,
	      item,
	      space,
	      i,
	      tag,
	      l,
	      isordered;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	      isordered = bull.length > 1;
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: isordered,
	        start: isordered ? +bull : ''
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if (top && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
	      tag = cap[1].toLowerCase();
	      if (!this.tokens.links[tag]) {
	        this.tokens.links[tag] = {
	          href: cap[2],
	          title: cap[3]
	        };
	      }
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?[a-zA-Z0-9\-]+(?:"[^"]*"|'[^']*'|\s[^<'">\/\s]*)*?\/?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^_([^\s_](?:[^_]|__)+?[^\s_])_\b|^\*((?:\*\*|[^*])+?)\*(?!\*)/,
	  code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
	};
	
	inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
	inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
	
	inline.autolink = edit(inline.autolink)
	  .replace('scheme', inline._scheme)
	  .replace('email', inline._email)
	  .getRegex()
	
	inline._inside = /(?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = edit(inline.link)
	  .replace('inside', inline._inside)
	  .replace('href', inline._href)
	  .getRegex();
	
	inline.reflink = edit(inline.reflink)
	  .replace('inside', inline._inside)
	  .getRegex();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
	  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/)
	    .replace('email', inline._email)
	    .getRegex(),
	  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: edit(inline.text)
	    .replace(']|', '~]|')
	    .replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|')
	    .getRegex()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: edit(inline.br).replace('{2,}', '*').getRegex(),
	  text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer();
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var out = '',
	      link,
	      text,
	      href,
	      cap;
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += cap[1];
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(this.mangle(cap[1]));
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      cap[0] = this.rules._backpedal.exec(cap[0])[0];
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(cap[0]);
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[0]);
	        if (cap[1] === 'www.') {
	          href = 'http://' + text;
	        } else {
	          href = text;
	        }
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	      out += this.options.sanitize
	        ? this.options.sanitizer
	          ? this.options.sanitizer(cap[0])
	          : escape(cap[0])
	        : cap[0]
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      out += this.outputLink(cap, {
	        href: cap[2],
	        title: cap[3]
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        out += cap[0].charAt(0);
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      out += this.outputLink(cap, link);
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.strong(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.em(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.codespan(escape(cap[2].trim(), true));
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.br();
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.del(this.output(cap[1]));
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.text(escape(this.smartypants(cap[0])));
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href),
	      title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = '',
	      l = text.length,
	      i = 0,
	      ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered, start) {
	  var type = ordered ? 'ol' : 'ul',
	      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
	  return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return text;
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	      return text;
	    }
	  }
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * TextRenderer
	 * returns only the textual part of the token
	 */
	
	function TextRenderer() {}
	
	// no need for block level renderers
	
	TextRenderer.prototype.strong =
	TextRenderer.prototype.em =
	TextRenderer.prototype.codespan =
	TextRenderer.prototype.del =
	TextRenderer.prototype.text = function (text) {
	  return text;
	}
	
	TextRenderer.prototype.link =
	TextRenderer.prototype.image = function(href, title, text) {
	  return '' + text;
	}
	
	TextRenderer.prototype.br = function() {
	  return '';
	}
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer();
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options) {
	  var parser = new Parser(options);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options);
	  // use an InlineLexer with a TextRenderer to extract pure text
	  this.inlineText = new InlineLexer(
	    src.links,
	    merge({}, this.options, {renderer: new TextRenderer()})
	  );
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        unescape(this.inlineText.output(this.token.text)));
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = '',
	          body = '',
	          i,
	          row,
	          cell,
	          j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      body = '';
	      var ordered = this.token.ordered,
	          start = this.token.start;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered, start);
	    }
	    case 'list_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
	  // explicitly match decimal, hex, and named HTML entities
	  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function edit(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return {
	    replace: function(name, val) {
	      val = val.source || val;
	      val = val.replace(/(^|[^\[])\^/g, '$1');
	      regex = regex.replace(name, val);
	      return this;
	    },
	    getRegex: function() {
	      return new RegExp(regex, opt);
	    }
	  };
	}
	
	function resolveUrl(base, href) {
	  if (!baseUrls[' ' + base]) {
	    // we can ignore everything in base after the last slash of its path component,
	    // but we might need to add _that_
	    // https://tools.ietf.org/html/rfc3986#section-3
	    if (/^[^:]+:\/*[^/]*$/.test(base)) {
	      baseUrls[' ' + base] = base + '/';
	    } else {
	      baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	    }
	  }
	  base = baseUrls[' ' + base];
	
	  if (href.slice(0, 2) === '//') {
	    return base.replace(/:[\s\S]*/, ':') + href;
	  } else if (href.charAt(0) === '/') {
	    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	  } else {
	    return base + href;
	  }
	}
	var baseUrls = {};
	var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1,
	      target,
	      key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  // throw error in case of non string input
	  if (typeof src === 'undefined' || src === null) {
	    throw new Error('marked(): input parameter is undefined or null');
	  }
	  if (typeof src !== 'string') {
	    throw new Error('marked(): input parameter is of type '
	      + Object.prototype.toString.call(src) + ', string expected');
	  }
	
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight,
	        tokens,
	        pending,
	        i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occurred:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer(),
	  xhtml: false,
	  baseUrl: null
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	marked.TextRenderer = TextRenderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.exports = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  root.marked = marked;
	}
	})(this || (typeof window !== 'undefined' ? window : global));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 621 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(3551)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(20);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	var VIEWBOX_WIDTH = 100;
	var VIEWBOX_HEIGHT = 100;
	var VIEWBOX_HEIGHT_HALF = 50;
	var VIEWBOX_CENTER_X = 50;
	var VIEWBOX_CENTER_Y = 50;
	
	function Path(_a) {
	    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
	    return (React.createElement("path", { className: className, style: Object.assign({}, style, getDashStyle({ pathRadius: pathRadius, dashRatio: dashRatio, counterClockwise: counterClockwise })), d: getPathDescription({
	            pathRadius: pathRadius,
	            counterClockwise: counterClockwise,
	        }), strokeWidth: strokeWidth, fillOpacity: 0 }));
	}
	function getPathDescription(_a) {
	    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
	    var radius = pathRadius;
	    var rotation = counterClockwise ? 1 : 0;
	    return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
	}
	function getDashStyle(_a) {
	    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
	    var diameter = Math.PI * 2 * pathRadius;
	    var gapLength = (1 - dashRatio) * diameter;
	    return {
	        strokeDasharray: diameter + "px " + diameter + "px",
	        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px",
	    };
	}
	
	var CircularProgressbar = (function (_super) {
	    __extends(CircularProgressbar, _super);
	    function CircularProgressbar() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CircularProgressbar.prototype.getBackgroundPadding = function () {
	        if (!this.props.background) {
	            return 0;
	        }
	        return this.props.backgroundPadding;
	    };
	    CircularProgressbar.prototype.getPathRadius = function () {
	        return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
	    };
	    CircularProgressbar.prototype.getPathRatio = function () {
	        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
	        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
	        return (boundedValue - minValue) / (maxValue - minValue);
	    };
	    CircularProgressbar.prototype.render = function () {
	        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
	        var pathRadius = this.getPathRadius();
	        var pathRatio = this.getPathRatio();
	        return (React.createElement("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
	            this.props.background ? (React.createElement("circle", { className: classes.background, style: styles.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF })) : null,
	            React.createElement(Path, { className: classes.trail, counterClockwise: counterClockwise, dashRatio: circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.trail }),
	            React.createElement(Path, { className: classes.path, counterClockwise: counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.path }),
	            text ? (React.createElement("text", { className: classes.text, style: styles.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text)) : null));
	    };
	    CircularProgressbar.defaultProps = {
	        background: false,
	        backgroundPadding: 0,
	        circleRatio: 1,
	        classes: {
	            root: 'CircularProgressbar',
	            trail: 'CircularProgressbar-trail',
	            path: 'CircularProgressbar-path',
	            text: 'CircularProgressbar-text',
	            background: 'CircularProgressbar-background',
	        },
	        counterClockwise: false,
	        className: '',
	        maxValue: 100,
	        minValue: 0,
	        strokeWidth: 8,
	        styles: {
	            root: {},
	            trail: {},
	            path: {},
	            text: {},
	            background: {},
	        },
	        text: '',
	    };
	    return CircularProgressbar;
	}(React.Component));
	
	function CircularProgressbarWithChildren(props) {
	    var children = props.children, circularProgressbarProps = __rest(props, ["children"]);
	    return (React.createElement("div", { "data-test-id": "CircularProgressbarWithChildren" },
	        React.createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
	            React.createElement(CircularProgressbar, __assign({}, circularProgressbarProps)),
	            props.children ? (React.createElement("div", { "data-test-id": "CircularProgressbarWithChildren__children", style: {
	                    position: 'absolute',
	                    width: '100%',
	                    height: '100%',
	                    marginTop: '-100%',
	                    display: 'flex',
	                    flexDirection: 'column',
	                    justifyContent: 'center',
	                    alignItems: 'center',
	                } }, props.children)) : null)));
	}
	
	function buildStyles(_a) {
	    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
	    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
	    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
	    return {
	        root: {},
	        path: removeUndefinedValues({
	            stroke: pathColor,
	            strokeLinecap: strokeLinecap,
	            transform: rotationTransform,
	            transformOrigin: rotationTransformOrigin,
	            transition: pathTransition,
	            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s",
	        }),
	        trail: removeUndefinedValues({
	            stroke: trailColor,
	            strokeLinecap: strokeLinecap,
	            transform: rotationTransform,
	            transformOrigin: rotationTransformOrigin,
	        }),
	        text: removeUndefinedValues({
	            fill: textColor,
	            fontSize: textSize,
	        }),
	        background: removeUndefinedValues({
	            fill: backgroundColor,
	        }),
	    };
	}
	function removeUndefinedValues(obj) {
	    Object.keys(obj).forEach(function (key) {
	        if (obj[key] == null) {
	            delete obj[key];
	        }
	    });
	    return obj;
	}
	
	exports.CircularProgressbar = CircularProgressbar;
	exports.CircularProgressbarWithChildren = CircularProgressbarWithChildren;
	exports.buildStyles = buildStyles;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(3572);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(3574);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(3575);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var isBrowser = typeof window !== 'undefined';
	var Masonry = isBrowser ? window.Masonry || __webpack_require__(3540) : null;
	var imagesloaded = isBrowser ? __webpack_require__(3510) : null;
	var assign = __webpack_require__(3537);
	var elementResizeDetectorMaker = __webpack_require__(1534);
	var debounce = __webpack_require__(3538);
	var omit = __webpack_require__(3539);
	var PropTypes = __webpack_require__(43);
	var React = __webpack_require__(20);
	var createReactClass = __webpack_require__(1242);
	var refName = 'masonryContainer';
	
	var propTypes = {
	  enableResizableChildren: PropTypes.bool,
	  disableImagesLoaded: PropTypes.bool,
	  onImagesLoaded: PropTypes.func,
	  updateOnEachImageLoad: PropTypes.bool,
	  options: PropTypes.object,
	  elementType: PropTypes.string,
	  onLayoutComplete: PropTypes.func,
	  onRemoveComplete: PropTypes.func
	};
	
	var MasonryComponent = createReactClass({
	  masonry: false,
	  erd: undefined,
	  latestKnownDomChildren: [],
	  displayName: 'MasonryComponent',
	  propTypes: propTypes,
	
	  getDefaultProps: function() {
	    return {
	      enableResizableChildren: false,
	      disableImagesLoaded: false,
	      updateOnEachImageLoad: false,
	      options: {},
	      className: '',
	      elementType: 'div',
	      onLayoutComplete: function() {
	      },
	      onRemoveComplete: function() {
	      }
	    };
	  },
	
	  initializeMasonry: function(force) {
	    if (!this.masonry || force) {
	      this.masonry = new Masonry(
	        this.refs[refName],
	        this.props.options
	      );
	
	      if (this.props.onLayoutComplete) {
	        this.masonry.on('layoutComplete', this.props.onLayoutComplete);
	      }
	
	      if (this.props.onRemoveComplete) {
	        this.masonry.on('removeComplete', this.props.onRemoveComplete);
	      }
	
	      this.latestKnownDomChildren = this.getCurrentDomChildren();
	    }
	  },
	
	  getCurrentDomChildren: function() {
	    var node = this.refs[refName];
	    var children = this.props.options.itemSelector ? node.querySelectorAll(this.props.options.itemSelector) : node.children;
	    return Array.prototype.slice.call(children);
	  },
	
	  diffDomChildren: function() {
	    var forceItemReload = false;
	
	    var knownChildrenStillAttached = this.latestKnownDomChildren.filter(function(element) {
	      /*
	       * take only elements attached to DOM
	       * (aka the parent is the masonry container, not null)
	       * otherwise masonry would try to "remove it" again from the DOM
	       */
	      return !!element.parentNode;
	    });
	
	    /*
	     * If not all known children are attached to the dom - we have no other way of notifying
	     * masonry to remove the ones not still attached besides invoking a complete item reload.
	     * basically all the rest of the code below does not matter in that case.
	     */
	    if (knownChildrenStillAttached.length !== this.latestKnownDomChildren) {
	      forceItemReload = true;
	    }
	
	    var currentDomChildren = this.getCurrentDomChildren();
	
	    /*
	     * Since we are looking for a known child which is also attached to the dom AND
	     * not attached to the dom at the same time - this would *always* produce an empty array.
	     */
	    var removed = knownChildrenStillAttached.filter(function(attachedKnownChild) {
	      return !~currentDomChildren.indexOf(attachedKnownChild);
	    });
	
	    /*
	     * This would get any children which are attached to the dom but are *unkown* to us
	     * from previous renders
	     */
	    var newDomChildren = currentDomChildren.filter(function(currentChild) {
	      return !~knownChildrenStillAttached.indexOf(currentChild);
	    });
	
	    var beginningIndex = 0;
	
	    // get everything added to the beginning of the DOMNode list
	    var prepended = newDomChildren.filter(function(newChild) {
	      var prepend = (beginningIndex === currentDomChildren.indexOf(newChild));
	
	      if (prepend) {
	        // increase the index
	        beginningIndex++;
	      }
	
	      return prepend;
	    });
	
	    // we assume that everything else is appended
	    var appended = newDomChildren.filter(function(el) {
	      return prepended.indexOf(el) === -1;
	    });
	
	    /*
	     * otherwise we reverse it because so we're going through the list picking off the items that
	     * have been added at the end of the list. this complex logic is preserved in case it needs to be
	     * invoked
	     *
	     * var endingIndex = currentDomChildren.length - 1;
	     *
	     * newDomChildren.reverse().filter(function(newChild, i){
	     *     var append = endingIndex == currentDomChildren.indexOf(newChild);
	     *
	     *     if (append) {
	     *         endingIndex--;
	     *     }
	     *
	     *     return append;
	     * });
	     */
	
	    // get everything added to the end of the DOMNode list
	    var moved = [];
	
	    /*
	     * This would always be true (see above about the lofic for "removed")
	     */
	    if (removed.length === 0) {
	      /*
	       * 'moved' will contain some random elements (if any) since the "knownChildrenStillAttached" is a filter
	       * of the "known" children which are still attached - All indexes could basically change. (for example
	       * if the first element is not attached)
	       * Don't trust this array.
	       */
	      moved = knownChildrenStillAttached.filter(function(child, index) {
	        return index !== currentDomChildren.indexOf(child);
	      });
	    }
	
	    this.latestKnownDomChildren = currentDomChildren;
	
	    return {
	      old: knownChildrenStillAttached, // Not used
	      new: currentDomChildren, // Not used
	      removed: removed,
	      appended: appended,
	      prepended: prepended,
	      moved: moved,
	      forceItemReload: forceItemReload
	    };
	  },
	
	  performLayout: function() {
	    var diff = this.diffDomChildren();
	
	    // Would never be true. (see comments of 'diffDomChildren' about 'removed')
	    if (diff.removed.length > 0) {
	      if (this.props.enableResizableChildren) {
	        diff.removed.forEach(this.erd.removeAllListeners, this.erd);
	      }
	      this.masonry.remove(diff.removed);
	      this.masonry.reloadItems();
	    }
	
	    if (diff.appended.length > 0) {
	      this.masonry.appended(diff.appended);
	
	      if (diff.prepended.length === 0) {
	        this.masonry.reloadItems();
	      }
	
	      if (this.props.enableResizableChildren) {
	        diff.appended.forEach(this.listenToElementResize, this);
	      }
	    }
	
	    if (diff.prepended.length > 0) {
	      this.masonry.prepended(diff.prepended);
	
	      if (this.props.enableResizableChildren) {
	        diff.prepended.forEach(this.listenToElementResize, this);
	      }
	    }
	
	    if (diff.forceItemReload || diff.moved.length > 0) {
	      this.masonry.reloadItems();
	    }
	
	    this.masonry.layout();
	  },
	
	  imagesLoaded: function() {
	    if (this.props.disableImagesLoaded) {
	      return;
	    }
	
	    imagesloaded(this.refs[refName])
	      .on(
	        this.props.updateOnEachImageLoad ? 'progress' : 'always',
	        debounce(
	          function(instance) {
	            if (this.props.onImagesLoaded) {
	              this.props.onImagesLoaded(instance);
	            }
	            this.masonry.layout();
	          }.bind(this), 100)
	      );
	  },
	
	  initializeResizableChildren: function() {
	    if (!this.props.enableResizableChildren) {
	      return;
	    }
	
	    this.erd = elementResizeDetectorMaker({
	      strategy: 'scroll'
	    });
	
	    this.latestKnownDomChildren.forEach(this.listenToElementResize, this);
	  },
	
	  listenToElementResize: function(el) {
	    this.erd.listenTo(el, function() {
	      this.masonry.layout()
	    }.bind(this))
	  },
	
	  destroyErd: function() {
	    if (this.erd) {
	      this.latestKnownDomChildren.forEach(this.erd.uninstall, this.erd);
	    }
	  },
	
	  componentDidMount: function() {
	    this.initializeMasonry();
	    this.initializeResizableChildren();
	    this.imagesLoaded();
	  },
	
	  componentDidUpdate: function() {
	    this.performLayout();
	    this.imagesLoaded();
	  },
	
	  componentWillUnmount: function() {
	    this.destroyErd();
	
	    // unregister events
	    if (this.props.onLayoutComplete) {
	      this.masonry.off('layoutComplete', this.props.onLayoutComplete);
	    }
	
	    if (this.props.onRemoveComplete) {
	      this.masonry.off('removeComplete', this.props.onRemoveComplete);
	    }
	
	    this.masonry.destroy();
	  },
	
	  render: function() {
	    var props = omit(this.props, Object.keys(propTypes));
	    return React.createElement(this.props.elementType, assign({}, props, {ref: refName}), this.props.children);
	  }
	});
	
	module.exports = MasonryComponent;
	module.exports.default = MasonryComponent;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	var _interopRequireWildcard = __webpack_require__(357)["default"];
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(225));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(226));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(606));
	
	var _react = _interopRequireWildcard(__webpack_require__(20));
	
	var _reactIs = __webpack_require__(345);
	
	var _Subscription = __webpack_require__(346);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(347);
	
	var _Context = __webpack_require__(136);
	
	var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
	    _excluded2 = ["reactReduxForwardedRef"];
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	      export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = ConnectFunction.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(634));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(20);
	
	var _Context = __webpack_require__(136);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(20);
	
	var _Context = __webpack_require__(136);
	
	var _useReduxContext2 = __webpack_require__(630);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.setBatch = exports.getBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(3591));
	
	var _warning = _interopRequireDefault(__webpack_require__(635));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(222);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(642);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(348);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(349);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(222);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(204);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(3596);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(204);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.forceReflow = void 0;
	
	var forceReflow = function forceReflow(node) {
	  return node.scrollTop;
	};
	
	exports.forceReflow = forceReflow;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(689);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1264);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./date_span_selector.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./date_span_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1268);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expandable_student_list_selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expandable_student_list_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_insights_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_insights_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1349);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_action_section.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_action_section.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1360);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1388);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./admin_home_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./admin_home_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1392);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1400);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1428);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./board.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./board.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1461);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1470);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1501);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./name_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./name_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1508);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./assign_task_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./assign_task_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0Y1N0MwMCIgZD0iTTQgOXYzMnM4LjQtMyAyMC0zIDIwIDMgMjAgM1Y5cy02LjcgMy0yMCAzUzQgOSA0IDl6Ii8+PHBhdGggZmlsbD0iIzk0MkEwOSIgZD0iTTI0IDM0aC40TDE1IDE5IDYuOSAzNi4yYzMuNC0uOSA5LjYtMi4yIDE3LjEtMi4yeiIvPjxwYXRoIGZpbGw9IiNCRjM2MEMiIGQ9Ik0yNCAzNGMzLjMgMCA2LjMuMiA5IC42bC04LTExLjgtNy44IDExLjVjMi4xLS4yIDQuNC0uMyA2LjgtLjN6Ii8+PHBhdGggZmlsbD0iI0U2NTEwMCIgZD0iTTQwLjcgMzZMMzUgMjYuNWwtNSA3LjhjNC41LjQgOC4yIDEuMSAxMC43IDEuN3oiLz48ZWxsaXBzZSBmaWxsPSIjRkZGOUM0IiBjeD0iMzYiIGN5PSIxOS41IiByeD0iMiIgcnk9IjIuNSIvPjwvc3ZnPg=="

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./challenge-small.png": 1546,
		"./challenges.png": 1547,
		"./exercises.png": 1548,
		"./minutes.png": 1549,
		"./owl and book.png": 1550,
		"./question-builder.png": 1551,
		"./questions.png": 290,
		"./questions_old.png": 1552,
		"./quizzes-large.png": 1553,
		"./quizzes-passed-lg.png": 291,
		"./quizzes-passed.png": 292,
		"./reviews.png": 293,
		"./teachers-picks.png": 294
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 662;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./data_exports.gif": 1557,
		"./insights_page.gif": 1558
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 663;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bookshelves/bookshelf-basic-1.png": 1559,
		"./bookshelves/bookshelf-basic-2.png": 1560,
		"./bookshelves/bookshelf-basic-3.png": 1561,
		"./bookshelves/bookshelf-basic-4.png": 1562,
		"./bookshelves/bookshelf-beach.png": 1563,
		"./bookshelves/bookshelf-chef.png": 1564,
		"./bookshelves/bookshelf-circus.png": 1565,
		"./bookshelves/bookshelf-gamer.png": 1566,
		"./bookshelves/bookshelf-jam.png": 1567,
		"./bookshelves/bookshelf-pirate.png": 1568,
		"./bookshelves/bookshelf-skate.png": 1569,
		"./bookshelves/bookshelf-sports.png": 1570,
		"./bookshelves/bookshelf-winter.png": 1571,
		"./bookshelves/bookshelf-wizard.png": 1572,
		"./floor_items/basketball.png": 1573,
		"./floor_items/chest.png": 1574,
		"./floor_items/coffee-table.png": 1575,
		"./floor_items/electric-guitar.png": 1576,
		"./floor_items/fireplace.png": 1577,
		"./floor_items/football.png": 1578,
		"./floor_items/game-controller.png": 1579,
		"./floor_items/green-skateboard.png": 1580,
		"./floor_items/magic-book.png": 1581,
		"./floor_items/magic-staff.png": 1582,
		"./floor_items/mask.png": 1583,
		"./floor_items/palm-tree.png": 1584,
		"./floor_items/popcorn.png": 1585,
		"./floor_items/red-skateboard.png": 1586,
		"./floor_items/sandcastle.png": 1587,
		"./floor_items/side-table.png": 1588,
		"./floor_items/violin.png": 1589,
		"./floor_items/wand.png": 1590,
		"./sofas/sofa-beach.png": 1591,
		"./sofas/sofa-chef.png": 1592,
		"./sofas/sofa-circus.png": 1593,
		"./sofas/sofa-gamer.png": 1594,
		"./sofas/sofa-jam.png": 1595,
		"./sofas/sofa-pirate.png": 1596,
		"./sofas/sofa-skate.png": 1597,
		"./sofas/sofa-sports.png": 1598,
		"./sofas/sofa-winter.png": 1599,
		"./sofas/sofa-wizard.png": 1600,
		"./wall_items/double-note-poster.png": 1601,
		"./wall_items/dragon-poster.png": 1602,
		"./wall_items/elephant-poster.png": 1603,
		"./wall_items/helm.png": 1604,
		"./wall_items/pirate-flag.png": 1605,
		"./wall_items/rocket-poster.png": 1606,
		"./wall_items/single-note-poster.png": 1607,
		"./wall_items/surfboard.png": 1608,
		"./wall_items/television.png": 1609,
		"./wall_items/window-night-beach.png": 1610,
		"./wall_items/window-night-lake.png": 1611,
		"./wall_items/window-night-mountains.png": 1612,
		"./wall_items/window-snowy-mountains.png": 1613,
		"./wall_items/window-sunny-beach.png": 1614,
		"./wall_items/window-sunny-lake.png": 1615,
		"./wall_items/window-sunny-mountains.png": 1616,
		"./wall_items/window-sunset-beach.png": 1617,
		"./wall_items/window-sunset-lake.png": 1618
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 664;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./american-express.png": 499,
		"./discover.png": 500,
		"./jcb.png": 501,
		"./mastercard.png": 502,
		"./savvas-logo.jpg": 1619,
		"./visa.png": 503,
		"./wr-favicon-white.png": 504,
		"./wr-logo-white.png": 219,
		"./wr-logo.png": 505
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 665;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./alarm-clock.png": 506,
		"./amy.png": 1622,
		"./arrow-left.png": 507,
		"./arrow-right.png": 508,
		"./atty-general.png": 1623,
		"./checked-checkbox.png": 509,
		"./clever-share-settings.png": 1624,
		"./clever-share.png": 1625,
		"./collaboration-icon.png": 510,
		"./compare.png": 1627,
		"./coppa.png": 1628,
		"./dashboard-activities.png": 1629,
		"./dashboard-grading.png": 1630,
		"./dashboard-roster.png": 1631,
		"./data.png": 1632,
		"./december-sale-banner.png": 511,
		"./district.png": 1633,
		"./envelope.png": 1634,
		"./film-complete.png": 1635,
		"./film.png": 1636,
		"./google-classroom.png": 512,
		"./group-insights.png": 1637,
		"./halloween-sale-banner.png": 296,
		"./house.png": 1638,
		"./individual-insights.png": 1639,
		"./interior1.png": 1640,
		"./july-sale-banner.png": 513,
		"./lightbulb-off.png": 1641,
		"./lightbulb-on.png": 1642,
		"./main-ideas-icon.png": 1643,
		"./monkey.png": 514,
		"./new-year-sale-banner.png": 515,
		"./note-sm.png": 1644,
		"./presentation.png": 1645,
		"./quiz-complete.png": 516,
		"./quiz-draft.png": 517,
		"./quotes-2.png": 1646,
		"./sample-activities.png": 1647,
		"./school-and-owls.png": 518,
		"./september-sale-banner.png": 519,
		"./speech-to-text.png": 185,
		"./text-to-speech.png": 297,
		"./text_to_speech_keyboard.png": 520,
		"./unchecked-checkbox.png": 521,
		"./watch-icon.png": 1651,
		"./wise-owl-wizard.png": 522,
		"./wise-owls.png": 523
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 666;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./monster-1.png": 1652,
		"./monster-2.png": 1653,
		"./monster-23.png": 1654,
		"./monster-3.png": 1655,
		"./monster-4.png": 1656,
		"./monster-5.png": 1657,
		"./monster-6.png": 1658,
		"./monster-7.png": 1659,
		"./monster-8.png": 1660,
		"./monster-9.png": 1661
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 667;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./book-s.png": 1662,
		"./book.png": 524,
		"./class-s.png": 1663,
		"./class.png": 525,
		"./coin-s.png": 1664,
		"./coin.png": 526,
		"./donation-s.png": 1665,
		"./donation.png": 1666,
		"./invite-s.png": 1667,
		"./invite.png": 1668,
		"./money-s.png": 1669,
		"./money.png": 1670,
		"./reading-off.png": 1671,
		"./reading-s.png": 1672,
		"./reading.png": 1673,
		"./reviews.png": 1674,
		"./school-s.png": 1675,
		"./school.png": 1676,
		"./student-s.png": 1677,
		"./student.png": 1678,
		"./writing-s.png": 1679,
		"./writing.png": 1680
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 668;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./amy.png": 527,
		"./annotated-example-1.png": 1681,
		"./annotated-example-2.png": 1682,
		"./annotated-example-3.png": 1683,
		"./examples-1.png": 1684,
		"./examples-2.png": 1685,
		"./examples-3.png": 1686,
		"./feedback-1.png": 1687,
		"./feedback-2.png": 1688,
		"./feedback-3.png": 1689,
		"./honor-pledge.png": 1690,
		"./icons/assignment-gray.png": 1691,
		"./icons/assignment.png": 1692,
		"./icons/dashboard-gray.png": 1693,
		"./icons/dashboard.png": 1694,
		"./icons/demo-gray.png": 1695,
		"./icons/demo.png": 1696,
		"./icons/quizzes-gray.png": 1697,
		"./icons/quizzes.png": 1698,
		"./icons/school-gray.png": 1699,
		"./icons/school.png": 1700,
		"./icons/standards-gray.png": 1701,
		"./icons/standards.png": 1702,
		"./icons/students-gray.png": 1703,
		"./icons/students.png": 1704,
		"./onboarding-book-reviews.png": 1705,
		"./onboarding-critical-thinking.png": 1706,
		"./onboarding-daily-reading.png": 1707,
		"./onboarding-fill-in-and-short-answer.png": 1708,
		"./onboarding-fill-in-only.png": 1709,
		"./onboarding-short-answer-in-only.png": 1710,
		"./onboarding-track-goals.png": 1711,
		"./onboarding-who-read.png": 1712,
		"./onboarding-writing-skills.png": 1713,
		"./owlfonso-waving.png": 528,
		"./practice-question-1.png": 1714,
		"./practice-question-2.png": 1715,
		"./practice-question-3.png": 1716,
		"./profile-action-buttons.png": 1717,
		"./quiz-1.png": 1718,
		"./quiz-2.png": 1719,
		"./quiz-3.png": 1720,
		"./quotes.png": 529,
		"./student-owl.png": 530,
		"./teacher-owl.png": 298
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 669;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./background_sounds.png": 531,
		"./backgrounds.png": 532,
		"./beak.png": 1721,
		"./body.png": 1722,
		"./bookshelves.png": 533,
		"./eyes.png": 1723,
		"./face.png": 1724,
		"./feet.png": 1725,
		"./floor_items.png": 1726,
		"./furniture_icon.png": 1727,
		"./greetings.png": 1728,
		"./head.png": 1729,
		"./houses.png": 534,
		"./left_hand.png": 1730,
		"./owl_hoots.png": 535,
		"./sofas.png": 536,
		"./titles.png": 537,
		"./wall_items.png": 538
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 670;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./around/cloud.png": 1740,
		"./around/palm-tree.png": 1741,
		"./around/sun.png": 1742,
		"./base/base-0.png": 1743,
		"./base/base-1.png": 1744,
		"./base/base-10.png": 1745,
		"./base/base-11.png": 1746,
		"./base/base-12.png": 1747,
		"./base/base-13.png": 1748,
		"./base/base-14.png": 1749,
		"./base/base-15.png": 1750,
		"./base/base-16.png": 1751,
		"./base/base-17.png": 1752,
		"./base/base-18.png": 1753,
		"./base/base-19.png": 1754,
		"./base/base-2.png": 1755,
		"./base/base-20.png": 1756,
		"./base/base-21.png": 1757,
		"./base/base-22.png": 1758,
		"./base/base-23.png": 1759,
		"./base/base-24.png": 1760,
		"./base/base-25.png": 1761,
		"./base/base-26.png": 1762,
		"./base/base-27.png": 1763,
		"./base/base-28.png": 1764,
		"./base/base-29.png": 1765,
		"./base/base-3.png": 1766,
		"./base/base-4.png": 1767,
		"./base/base-5.png": 1768,
		"./base/base-6.png": 1769,
		"./base/base-7.png": 1770,
		"./base/base-8.png": 1771,
		"./base/base-9.png": 1772,
		"./base/base-o.png": 1773,
		"./beak/apple-s.png": 1774,
		"./beak/apple.png": 1775,
		"./beak/curvy-s.png": 1776,
		"./beak/curvy.png": 1777,
		"./beak/long-s.png": 1778,
		"./beak/long.png": 1779,
		"./beak/mustache-brown-s.png": 1780,
		"./beak/mustache-brown.png": 1781,
		"./beak/mustache-chef-s.png": 1782,
		"./beak/mustache-chef.png": 1783,
		"./beak/mustache-thick-s.png": 1784,
		"./beak/mustache-thick.png": 1785,
		"./beak/mustache-white-s.png": 1786,
		"./beak/mustache-white.png": 1787,
		"./beak/normal-s.png": 1788,
		"./beak/normal.png": 1789,
		"./beak/round-s.png": 1790,
		"./beak/round.png": 1791,
		"./beak/talking-s.png": 1792,
		"./beak/talking.png": 1793,
		"./body/accordion-s.png": 1794,
		"./body/accordion.png": 1795,
		"./body/backpack-s.png": 1796,
		"./body/backpack.png": 1797,
		"./body/bagpipes-s.png": 1798,
		"./body/bagpipes.png": 1799,
		"./body/bandana-s.png": 1800,
		"./body/bandana.png": 1801,
		"./body/banjo-s.png": 1802,
		"./body/banjo.png": 1803,
		"./body/belt-black-s.png": 1804,
		"./body/belt-black.png": 1805,
		"./body/book-s.png": 1806,
		"./body/book-shelf-s.png": 1807,
		"./body/book-shelf.png": 1808,
		"./body/book.png": 1809,
		"./body/bowtie-s.png": 1810,
		"./body/bowtie.png": 1811,
		"./body/business-suit-s.png": 1812,
		"./body/business-suit.png": 1813,
		"./body/cape-black-s.png": 1814,
		"./body/cape-black.png": 1815,
		"./body/cape-stars-s.png": 1816,
		"./body/cape-stars.png": 1817,
		"./body/cauldron-s.png": 1818,
		"./body/cauldron.png": 1819,
		"./body/cello-s.png": 1820,
		"./body/cello.png": 1821,
		"./body/chef-jacket-s.png": 1822,
		"./body/chef-jacket.png": 1823,
		"./body/cloak-king-s.png": 1824,
		"./body/cloak-king.png": 1825,
		"./body/coat-s.png": 1826,
		"./body/coat.png": 1827,
		"./body/denim-jacket-s.png": 1828,
		"./body/denim-jacket.png": 1829,
		"./body/dracula-cape-s.png": 1830,
		"./body/dracula-cape.png": 1831,
		"./body/drum-s.png": 1832,
		"./body/drum.png": 1833,
		"./body/fake-horse-s.png": 1834,
		"./body/fake-horse.png": 1835,
		"./body/fannypack-s.png": 1836,
		"./body/fannypack.png": 1837,
		"./body/floatie-alligator-s.png": 1838,
		"./body/floatie-alligator.png": 1839,
		"./body/floatie-donut-s.png": 1840,
		"./body/floatie-donut.png": 1841,
		"./body/floatie-toucan-s.png": 1842,
		"./body/floatie-toucan.png": 1843,
		"./body/floatie-watermelon-s.png": 1844,
		"./body/floatie-watermelon.png": 1845,
		"./body/ghost-s.png": 1846,
		"./body/ghost.png": 1847,
		"./body/guitar-acoustic-s.png": 1848,
		"./body/guitar-acoustic.png": 1849,
		"./body/guitar-edgy-s.png": 1850,
		"./body/guitar-edgy.png": 1851,
		"./body/harp-s.png": 1852,
		"./body/harp.png": 1853,
		"./body/heart-skirt-s.png": 1854,
		"./body/heart-skirt.png": 1855,
		"./body/helm-s.png": 1856,
		"./body/helm.png": 1857,
		"./body/holiday-sweater-s.png": 1858,
		"./body/holiday-sweater.png": 1859,
		"./body/hoodie-blue-s.png": 1860,
		"./body/hoodie-blue.png": 1861,
		"./body/hoodie-finger-heart-brown-s.png": 1862,
		"./body/hoodie-finger-heart-brown.png": 1863,
		"./body/hoodie-finger-heart-white-s.png": 1864,
		"./body/hoodie-finger-heart-white.png": 1865,
		"./body/hoodie-orange-s.png": 1866,
		"./body/hoodie-orange.png": 1867,
		"./body/jeans-s.png": 1868,
		"./body/jeans.png": 1869,
		"./body/kite-s.png": 1870,
		"./body/kite.png": 1871,
		"./body/march-marathon-medal-s.png": 1872,
		"./body/march-marathon-medal.png": 1873,
		"./body/march-medal-s.png": 1874,
		"./body/march-medal.png": 1875,
		"./body/motorcycle-jacket-s.png": 1876,
		"./body/motorcycle-jacket.png": 1877,
		"./body/mummy-body-s.png": 1878,
		"./body/mummy-body.png": 1879,
		"./body/necklace-coin-s.png": 1880,
		"./body/necklace-coin.png": 1881,
		"./body/necklace-flowers-s.png": 1882,
		"./body/necklace-flowers.png": 1883,
		"./body/necklace-gem-s.png": 1884,
		"./body/necklace-gem.png": 1885,
		"./body/necklace-pearls-s.png": 1886,
		"./body/necklace-pearls.png": 1887,
		"./body/outfit-ballerina-s.png": 1888,
		"./body/outfit-ballerina.png": 1889,
		"./body/outfit-baseball-s.png": 1890,
		"./body/outfit-baseball.png": 1891,
		"./body/outfit-basketball-s.png": 1892,
		"./body/outfit-basketball.png": 1893,
		"./body/outfit-blue-s.png": 1894,
		"./body/outfit-blue.png": 1895,
		"./body/outfit-clown-s.png": 1896,
		"./body/outfit-clown.png": 1897,
		"./body/outfit-cowboy-s.png": 1898,
		"./body/outfit-cowboy.png": 1899,
		"./body/outfit-fancy-dress-s.png": 1900,
		"./body/outfit-fancy-dress.png": 1901,
		"./body/outfit-football-s.png": 1902,
		"./body/outfit-football.png": 1903,
		"./body/outfit-jester-s.png": 1904,
		"./body/outfit-jester.png": 1905,
		"./body/outfit-karate-s.png": 1906,
		"./body/outfit-karate.png": 1907,
		"./body/outfit-pirate-s.png": 1908,
		"./body/outfit-pirate.png": 1909,
		"./body/outfit-police-s.png": 1910,
		"./body/outfit-police.png": 1911,
		"./body/outfit-preppy-s.png": 1912,
		"./body/outfit-preppy.png": 1913,
		"./body/outfit-princess-s.png": 1914,
		"./body/outfit-princess.png": 1915,
		"./body/outfit-robin-hood-s.png": 1916,
		"./body/outfit-robin-hood.png": 1917,
		"./body/outfit-witch-s.png": 1918,
		"./body/outfit-witch.png": 1919,
		"./body/overalls-denim-s.png": 1920,
		"./body/overalls-denim.png": 1921,
		"./body/overalls-red-s.png": 1922,
		"./body/overalls-red.png": 1923,
		"./body/party-dress-s.png": 1924,
		"./body/party-dress.png": 1925,
		"./body/puffy-jacket-pink-s.png": 1926,
		"./body/puffy-jacket-pink.png": 1927,
		"./body/ripped-jeans-s.png": 1928,
		"./body/ripped-jeans.png": 1929,
		"./body/scarf-green-s.png": 1930,
		"./body/scarf-green.png": 1931,
		"./body/scarf-pink-s.png": 1932,
		"./body/scarf-pink.png": 1933,
		"./body/school-girl-uniform-s.png": 1934,
		"./body/school-girl-uniform.png": 1935,
		"./body/shirt-crab-s.png": 1936,
		"./body/shirt-crab.png": 1937,
		"./body/shirt-surfboards-s.png": 1938,
		"./body/shirt-surfboards.png": 1939,
		"./body/sweater-s.png": 1940,
		"./body/sweater.png": 1941,
		"./body/swimsuit-neon-green-s.png": 1942,
		"./body/swimsuit-neon-green.png": 1943,
		"./body/swimsuit-red-stripe-s.png": 1944,
		"./body/swimsuit-red-stripe.png": 1945,
		"./body/swimsuit-yellow-s.png": 1946,
		"./body/swimsuit-yellow.png": 1947,
		"./body/telescope-s.png": 1948,
		"./body/telescope.png": 1949,
		"./body/tie-s.png": 1950,
		"./body/tie.png": 1951,
		"./body/tiger-suit-s.png": 1952,
		"./body/tiger-suit.png": 1953,
		"./body/tree-bottom-s.png": 1954,
		"./body/tree-bottom.png": 1955,
		"./body/trenchcoat-s.png": 1956,
		"./body/trenchcoat.png": 1957,
		"./body/tuxedo-s.png": 1958,
		"./body/tuxedo.png": 1959,
		"./body/zombie-stitches-s.png": 1960,
		"./body/zombie-stitches.png": 1961,
		"./eyes/angry-0.png": 1962,
		"./eyes/angry-1.png": 1963,
		"./eyes/angry-10.png": 1964,
		"./eyes/angry-11.png": 1965,
		"./eyes/angry-12.png": 1966,
		"./eyes/angry-13.png": 1967,
		"./eyes/angry-14.png": 1968,
		"./eyes/angry-15.png": 1969,
		"./eyes/angry-16.png": 1970,
		"./eyes/angry-17.png": 1971,
		"./eyes/angry-18.png": 1972,
		"./eyes/angry-19.png": 1973,
		"./eyes/angry-2.png": 1974,
		"./eyes/angry-20.png": 1975,
		"./eyes/angry-21.png": 1976,
		"./eyes/angry-22.png": 1977,
		"./eyes/angry-23.png": 1978,
		"./eyes/angry-24.png": 1979,
		"./eyes/angry-25.png": 1980,
		"./eyes/angry-26.png": 1981,
		"./eyes/angry-27.png": 1982,
		"./eyes/angry-28.png": 1983,
		"./eyes/angry-29.png": 1984,
		"./eyes/angry-3.png": 1985,
		"./eyes/angry-4.png": 1986,
		"./eyes/angry-5.png": 1987,
		"./eyes/angry-6.png": 1988,
		"./eyes/angry-7.png": 1989,
		"./eyes/angry-8.png": 1990,
		"./eyes/angry-9.png": 1991,
		"./eyes/angry-s.png": 1992,
		"./eyes/beady-0.png": 1993,
		"./eyes/beady-1.png": 1994,
		"./eyes/beady-10.png": 1995,
		"./eyes/beady-11.png": 1996,
		"./eyes/beady-12.png": 1997,
		"./eyes/beady-13.png": 1998,
		"./eyes/beady-14.png": 1999,
		"./eyes/beady-15.png": 2000,
		"./eyes/beady-16.png": 2001,
		"./eyes/beady-17.png": 2002,
		"./eyes/beady-18.png": 2003,
		"./eyes/beady-19.png": 2004,
		"./eyes/beady-2.png": 2005,
		"./eyes/beady-20.png": 2006,
		"./eyes/beady-21.png": 2007,
		"./eyes/beady-22.png": 2008,
		"./eyes/beady-23.png": 2009,
		"./eyes/beady-24.png": 2010,
		"./eyes/beady-25.png": 2011,
		"./eyes/beady-26.png": 2012,
		"./eyes/beady-27.png": 2013,
		"./eyes/beady-28.png": 2014,
		"./eyes/beady-29.png": 2015,
		"./eyes/beady-3.png": 2016,
		"./eyes/beady-4.png": 2017,
		"./eyes/beady-5.png": 2018,
		"./eyes/beady-6.png": 2019,
		"./eyes/beady-7.png": 2020,
		"./eyes/beady-8.png": 2021,
		"./eyes/beady-9.png": 2022,
		"./eyes/beady-s.png": 2023,
		"./eyes/googley-0.png": 2024,
		"./eyes/googley-1.png": 2025,
		"./eyes/googley-10.png": 2026,
		"./eyes/googley-11.png": 2027,
		"./eyes/googley-12.png": 2028,
		"./eyes/googley-13.png": 2029,
		"./eyes/googley-14.png": 2030,
		"./eyes/googley-15.png": 2031,
		"./eyes/googley-16.png": 2032,
		"./eyes/googley-17.png": 2033,
		"./eyes/googley-18.png": 2034,
		"./eyes/googley-19.png": 2035,
		"./eyes/googley-2.png": 2036,
		"./eyes/googley-20.png": 2037,
		"./eyes/googley-21.png": 2038,
		"./eyes/googley-22.png": 2039,
		"./eyes/googley-23.png": 2040,
		"./eyes/googley-24.png": 2041,
		"./eyes/googley-25.png": 2042,
		"./eyes/googley-26.png": 2043,
		"./eyes/googley-27.png": 2044,
		"./eyes/googley-28.png": 2045,
		"./eyes/googley-29.png": 2046,
		"./eyes/googley-3.png": 2047,
		"./eyes/googley-4.png": 2048,
		"./eyes/googley-5.png": 2049,
		"./eyes/googley-6.png": 2050,
		"./eyes/googley-7.png": 2051,
		"./eyes/googley-8.png": 2052,
		"./eyes/googley-9.png": 2053,
		"./eyes/googley-s.png": 2054,
		"./eyes/happy-0.png": 2055,
		"./eyes/happy-1.png": 2056,
		"./eyes/happy-10.png": 2057,
		"./eyes/happy-11.png": 2058,
		"./eyes/happy-12.png": 2059,
		"./eyes/happy-13.png": 2060,
		"./eyes/happy-14.png": 2061,
		"./eyes/happy-15.png": 2062,
		"./eyes/happy-16.png": 2063,
		"./eyes/happy-17.png": 2064,
		"./eyes/happy-18.png": 2065,
		"./eyes/happy-19.png": 2066,
		"./eyes/happy-2.png": 2067,
		"./eyes/happy-20.png": 2068,
		"./eyes/happy-21.png": 2069,
		"./eyes/happy-22.png": 2070,
		"./eyes/happy-23.png": 2071,
		"./eyes/happy-24.png": 2072,
		"./eyes/happy-25.png": 2073,
		"./eyes/happy-26.png": 2074,
		"./eyes/happy-27.png": 2075,
		"./eyes/happy-28.png": 2076,
		"./eyes/happy-29.png": 2077,
		"./eyes/happy-3.png": 2078,
		"./eyes/happy-4.png": 2079,
		"./eyes/happy-5.png": 2080,
		"./eyes/happy-6.png": 2081,
		"./eyes/happy-7.png": 2082,
		"./eyes/happy-8.png": 2083,
		"./eyes/happy-9.png": 2084,
		"./eyes/happy-o.png": 2085,
		"./eyes/happy-s.png": 2086,
		"./eyes/large-0.png": 2087,
		"./eyes/large-1.png": 2088,
		"./eyes/large-10.png": 2089,
		"./eyes/large-11.png": 2090,
		"./eyes/large-12.png": 2091,
		"./eyes/large-13.png": 2092,
		"./eyes/large-14.png": 2093,
		"./eyes/large-15.png": 2094,
		"./eyes/large-16.png": 2095,
		"./eyes/large-17.png": 2096,
		"./eyes/large-18.png": 2097,
		"./eyes/large-19.png": 2098,
		"./eyes/large-2.png": 2099,
		"./eyes/large-20.png": 2100,
		"./eyes/large-21.png": 2101,
		"./eyes/large-22.png": 2102,
		"./eyes/large-23.png": 2103,
		"./eyes/large-24.png": 2104,
		"./eyes/large-25.png": 2105,
		"./eyes/large-26.png": 2106,
		"./eyes/large-27.png": 2107,
		"./eyes/large-28.png": 2108,
		"./eyes/large-29.png": 2109,
		"./eyes/large-3.png": 2110,
		"./eyes/large-4.png": 2111,
		"./eyes/large-5.png": 2112,
		"./eyes/large-6.png": 2113,
		"./eyes/large-7.png": 2114,
		"./eyes/large-8.png": 2115,
		"./eyes/large-9.png": 2116,
		"./eyes/large-s.png": 2117,
		"./eyes/lazy-0.png": 2118,
		"./eyes/lazy-1.png": 2119,
		"./eyes/lazy-10.png": 2120,
		"./eyes/lazy-11.png": 2121,
		"./eyes/lazy-12.png": 2122,
		"./eyes/lazy-13.png": 2123,
		"./eyes/lazy-14.png": 2124,
		"./eyes/lazy-15.png": 2125,
		"./eyes/lazy-16.png": 2126,
		"./eyes/lazy-17.png": 2127,
		"./eyes/lazy-18.png": 2128,
		"./eyes/lazy-19.png": 2129,
		"./eyes/lazy-2.png": 2130,
		"./eyes/lazy-20.png": 2131,
		"./eyes/lazy-21.png": 2132,
		"./eyes/lazy-22.png": 2133,
		"./eyes/lazy-23.png": 2134,
		"./eyes/lazy-24.png": 2135,
		"./eyes/lazy-25.png": 2136,
		"./eyes/lazy-26.png": 2137,
		"./eyes/lazy-27.png": 2138,
		"./eyes/lazy-28.png": 2139,
		"./eyes/lazy-29.png": 2140,
		"./eyes/lazy-3.png": 2141,
		"./eyes/lazy-4.png": 2142,
		"./eyes/lazy-5.png": 2143,
		"./eyes/lazy-6.png": 2144,
		"./eyes/lazy-7.png": 2145,
		"./eyes/lazy-8.png": 2146,
		"./eyes/lazy-9.png": 2147,
		"./eyes/lazy-s.png": 2148,
		"./eyes/sleeping-0.png": 2149,
		"./eyes/sleeping-1.png": 2150,
		"./eyes/sleeping-10.png": 2151,
		"./eyes/sleeping-11.png": 2152,
		"./eyes/sleeping-12.png": 2153,
		"./eyes/sleeping-13.png": 2154,
		"./eyes/sleeping-14.png": 2155,
		"./eyes/sleeping-15.png": 2156,
		"./eyes/sleeping-16.png": 2157,
		"./eyes/sleeping-17.png": 2158,
		"./eyes/sleeping-18.png": 2159,
		"./eyes/sleeping-19.png": 2160,
		"./eyes/sleeping-2.png": 2161,
		"./eyes/sleeping-20.png": 2162,
		"./eyes/sleeping-21.png": 2163,
		"./eyes/sleeping-22.png": 2164,
		"./eyes/sleeping-23.png": 2165,
		"./eyes/sleeping-24.png": 2166,
		"./eyes/sleeping-25.png": 2167,
		"./eyes/sleeping-26.png": 2168,
		"./eyes/sleeping-27.png": 2169,
		"./eyes/sleeping-28.png": 2170,
		"./eyes/sleeping-29.png": 2171,
		"./eyes/sleeping-3.png": 2172,
		"./eyes/sleeping-4.png": 2173,
		"./eyes/sleeping-5.png": 2174,
		"./eyes/sleeping-6.png": 2175,
		"./eyes/sleeping-7.png": 2176,
		"./eyes/sleeping-8.png": 2177,
		"./eyes/sleeping-9.png": 2178,
		"./eyes/sleeping-s.png": 2179,
		"./eyes/squinty-0.png": 2180,
		"./eyes/squinty-1.png": 2181,
		"./eyes/squinty-10.png": 2182,
		"./eyes/squinty-11.png": 2183,
		"./eyes/squinty-12.png": 2184,
		"./eyes/squinty-13.png": 2185,
		"./eyes/squinty-14.png": 2186,
		"./eyes/squinty-15.png": 2187,
		"./eyes/squinty-16.png": 2188,
		"./eyes/squinty-17.png": 2189,
		"./eyes/squinty-18.png": 2190,
		"./eyes/squinty-19.png": 2191,
		"./eyes/squinty-2.png": 2192,
		"./eyes/squinty-20.png": 2193,
		"./eyes/squinty-21.png": 2194,
		"./eyes/squinty-22.png": 2195,
		"./eyes/squinty-23.png": 2196,
		"./eyes/squinty-24.png": 2197,
		"./eyes/squinty-25.png": 2198,
		"./eyes/squinty-26.png": 2199,
		"./eyes/squinty-27.png": 2200,
		"./eyes/squinty-28.png": 2201,
		"./eyes/squinty-29.png": 2202,
		"./eyes/squinty-3.png": 2203,
		"./eyes/squinty-4.png": 2204,
		"./eyes/squinty-5.png": 2205,
		"./eyes/squinty-6.png": 2206,
		"./eyes/squinty-7.png": 2207,
		"./eyes/squinty-8.png": 2208,
		"./eyes/squinty-9.png": 2209,
		"./eyes/squinty-s.png": 2210,
		"./eyes/uneven-0.png": 2211,
		"./eyes/uneven-1.png": 2212,
		"./eyes/uneven-10.png": 2213,
		"./eyes/uneven-11.png": 2214,
		"./eyes/uneven-12.png": 2215,
		"./eyes/uneven-13.png": 2216,
		"./eyes/uneven-14.png": 2217,
		"./eyes/uneven-15.png": 2218,
		"./eyes/uneven-16.png": 2219,
		"./eyes/uneven-17.png": 2220,
		"./eyes/uneven-18.png": 2221,
		"./eyes/uneven-19.png": 2222,
		"./eyes/uneven-2.png": 2223,
		"./eyes/uneven-20.png": 2224,
		"./eyes/uneven-21.png": 2225,
		"./eyes/uneven-22.png": 2226,
		"./eyes/uneven-23.png": 2227,
		"./eyes/uneven-24.png": 2228,
		"./eyes/uneven-25.png": 2229,
		"./eyes/uneven-26.png": 2230,
		"./eyes/uneven-27.png": 2231,
		"./eyes/uneven-28.png": 2232,
		"./eyes/uneven-29.png": 2233,
		"./eyes/uneven-3.png": 2234,
		"./eyes/uneven-4.png": 2235,
		"./eyes/uneven-5.png": 2236,
		"./eyes/uneven-6.png": 2237,
		"./eyes/uneven-7.png": 2238,
		"./eyes/uneven-8.png": 2239,
		"./eyes/uneven-9.png": 2240,
		"./eyes/uneven-s.png": 2241,
		"./eyes/unimpressed-0.png": 2242,
		"./eyes/unimpressed-1.png": 2243,
		"./eyes/unimpressed-10.png": 2244,
		"./eyes/unimpressed-11.png": 2245,
		"./eyes/unimpressed-12.png": 2246,
		"./eyes/unimpressed-13.png": 2247,
		"./eyes/unimpressed-14.png": 2248,
		"./eyes/unimpressed-15.png": 2249,
		"./eyes/unimpressed-16.png": 2250,
		"./eyes/unimpressed-17.png": 2251,
		"./eyes/unimpressed-18.png": 2252,
		"./eyes/unimpressed-19.png": 2253,
		"./eyes/unimpressed-2.png": 2254,
		"./eyes/unimpressed-20.png": 2255,
		"./eyes/unimpressed-21.png": 2256,
		"./eyes/unimpressed-22.png": 2257,
		"./eyes/unimpressed-23.png": 2258,
		"./eyes/unimpressed-24.png": 2259,
		"./eyes/unimpressed-25.png": 2260,
		"./eyes/unimpressed-26.png": 2261,
		"./eyes/unimpressed-27.png": 2262,
		"./eyes/unimpressed-28.png": 2263,
		"./eyes/unimpressed-29.png": 2264,
		"./eyes/unimpressed-3.png": 2265,
		"./eyes/unimpressed-4.png": 2266,
		"./eyes/unimpressed-5.png": 2267,
		"./eyes/unimpressed-6.png": 2268,
		"./eyes/unimpressed-7.png": 2269,
		"./eyes/unimpressed-8.png": 2270,
		"./eyes/unimpressed-9.png": 2271,
		"./eyes/unimpressed-s.png": 2272,
		"./eyes/winking-0.png": 2273,
		"./eyes/winking-1.png": 2274,
		"./eyes/winking-10.png": 2275,
		"./eyes/winking-11.png": 2276,
		"./eyes/winking-12.png": 2277,
		"./eyes/winking-13.png": 2278,
		"./eyes/winking-14.png": 2279,
		"./eyes/winking-15.png": 2280,
		"./eyes/winking-16.png": 2281,
		"./eyes/winking-17.png": 2282,
		"./eyes/winking-18.png": 2283,
		"./eyes/winking-19.png": 2284,
		"./eyes/winking-2.png": 2285,
		"./eyes/winking-20.png": 2286,
		"./eyes/winking-21.png": 2287,
		"./eyes/winking-22.png": 2288,
		"./eyes/winking-23.png": 2289,
		"./eyes/winking-24.png": 2290,
		"./eyes/winking-25.png": 2291,
		"./eyes/winking-26.png": 2292,
		"./eyes/winking-27.png": 2293,
		"./eyes/winking-28.png": 2294,
		"./eyes/winking-29.png": 2295,
		"./eyes/winking-3.png": 2296,
		"./eyes/winking-4.png": 2297,
		"./eyes/winking-5.png": 2298,
		"./eyes/winking-6.png": 2299,
		"./eyes/winking-7.png": 2300,
		"./eyes/winking-8.png": 2301,
		"./eyes/winking-9.png": 2302,
		"./eyes/winking-o.png": 2303,
		"./eyes/winking-s.png": 2304,
		"./face/beard-santa-s.png": 2305,
		"./face/beard-santa.png": 2306,
		"./face/beard-yellow-s.png": 2307,
		"./face/beard-yellow.png": 2308,
		"./face/binoculars-s.png": 2309,
		"./face/binoculars.png": 2310,
		"./face/earbuds-blue-s.png": 2311,
		"./face/earbuds-blue.png": 2312,
		"./face/earbuds-pink-s.png": 2313,
		"./face/earbuds-pink.png": 2314,
		"./face/earbuds-white-s.png": 2315,
		"./face/earbuds-white.png": 2316,
		"./face/earbuds-yellow-s.png": 2317,
		"./face/earbuds-yellow.png": 2318,
		"./face/expression-rage-s.png": 2319,
		"./face/expression-rage.png": 2320,
		"./face/expression-shock-s.png": 2321,
		"./face/expression-shock.png": 2322,
		"./face/eyelashes-s.png": 2323,
		"./face/eyelashes.png": 2324,
		"./face/eyepatch-s.png": 2325,
		"./face/eyepatch.png": 2326,
		"./face/glasses-aviators-s.png": 2327,
		"./face/glasses-aviators.png": 2328,
		"./face/glasses-clover-s.png": 2329,
		"./face/glasses-clover.png": 2330,
		"./face/glasses-cool-s.png": 2331,
		"./face/glasses-cool.png": 2332,
		"./face/glasses-harry-s.png": 2333,
		"./face/glasses-harry.png": 2334,
		"./face/glasses-heart-s.png": 2335,
		"./face/glasses-heart.png": 2336,
		"./face/glasses-hipster-s.png": 2337,
		"./face/glasses-hipster.png": 2338,
		"./face/glasses-old-man-s.png": 2339,
		"./face/glasses-old-man.png": 2340,
		"./face/glasses-pink-s.png": 2341,
		"./face/glasses-pink.png": 2342,
		"./face/glasses-reading-s.png": 2343,
		"./face/glasses-reading.png": 2344,
		"./face/glasses-square-s.png": 2345,
		"./face/glasses-square.png": 2346,
		"./face/glasses-star-s.png": 2347,
		"./face/glasses-star.png": 2348,
		"./face/goggles-VR-s.png": 2349,
		"./face/goggles-VR.png": 2350,
		"./face/goggles-s.png": 2351,
		"./face/goggles.png": 2352,
		"./face/makeup-blue-s.png": 2353,
		"./face/makeup-blue.png": 2354,
		"./face/makeup-diva-s.png": 2355,
		"./face/makeup-diva.png": 2356,
		"./face/makeup-gold-s.png": 2357,
		"./face/makeup-gold.png": 2358,
		"./face/makeup-pink-s.png": 2359,
		"./face/makeup-pink.png": 2360,
		"./face/makeup-sunset-s.png": 2361,
		"./face/makeup-sunset.png": 2362,
		"./face/march-marathon-glasses-clover-s.png": 2363,
		"./face/march-marathon-glasses-clover.png": 2364,
		"./face/mask-feathers-s.png": 2365,
		"./face/mask-feathers.png": 2366,
		"./face/mask-ribbons-s.png": 2367,
		"./face/mask-ribbons.png": 2368,
		"./face/mask-ski-s.png": 2369,
		"./face/mask-ski.png": 2370,
		"./face/mask-snorkel-s.png": 2371,
		"./face/mask-snorkel.png": 2372,
		"./face/mustache-glasses-s.png": 2373,
		"./face/mustache-glasses.png": 2374,
		"./face/pink-heart-glasses-s.png": 2375,
		"./face/pink-heart-glasses.png": 2376,
		"./face/zombie-glasses-s.png": 2377,
		"./face/zombie-glasses.png": 2378,
		"./feet/beach-s.png": 2379,
		"./feet/beach.png": 2380,
		"./feet/boots-black-s.png": 2381,
		"./feet/boots-black.png": 2382,
		"./feet/boots-city-s.png": 2383,
		"./feet/boots-city.png": 2384,
		"./feet/boots-cowboy-s.png": 2385,
		"./feet/boots-cowboy.png": 2386,
		"./feet/boots-high-heels-s.png": 2387,
		"./feet/boots-high-heels.png": 2388,
		"./feet/boots-hiking-s.png": 2389,
		"./feet/boots-hiking.png": 2390,
		"./feet/boots-peg-leg-s.png": 2391,
		"./feet/boots-peg-leg.png": 2392,
		"./feet/boots-pirate-s.png": 2393,
		"./feet/boots-pirate.png": 2394,
		"./feet/flippers-s.png": 2395,
		"./feet/flippers.png": 2396,
		"./feet/long-s.png": 2397,
		"./feet/long.png": 2398,
		"./feet/night-sky-s.png": 2399,
		"./feet/night-sky.png": 2400,
		"./feet/painted-nails-black-s.png": 2401,
		"./feet/painted-nails-black.png": 2402,
		"./feet/painted-nails-blue-s.png": 2403,
		"./feet/painted-nails-blue.png": 2404,
		"./feet/painted-nails-pink-s.png": 2405,
		"./feet/painted-nails-pink.png": 2406,
		"./feet/planet-asteroid-s.png": 2407,
		"./feet/planet-asteroid.png": 2408,
		"./feet/planet-earth-s.png": 2409,
		"./feet/planet-earth.png": 2410,
		"./feet/planet-saturn-s.png": 2411,
		"./feet/planet-saturn.png": 2412,
		"./feet/rollerskates-blackred-s.png": 2413,
		"./feet/rollerskates-blackred.png": 2414,
		"./feet/rollerskates-bluegold-s.png": 2415,
		"./feet/rollerskates-bluegold.png": 2416,
		"./feet/rollerskates-pinkblue-s.png": 2417,
		"./feet/rollerskates-pinkblue.png": 2418,
		"./feet/rollerskates-yellow-s.png": 2419,
		"./feet/rollerskates-yellow.png": 2420,
		"./feet/shoes-ballet-s.png": 2421,
		"./feet/shoes-ballet.png": 2422,
		"./feet/shoes-cleats-s.png": 2423,
		"./feet/shoes-cleats.png": 2424,
		"./feet/shoes-clown-s.png": 2425,
		"./feet/shoes-clown.png": 2426,
		"./feet/shoes-converse-s.png": 2427,
		"./feet/shoes-converse.png": 2428,
		"./feet/shoes-high-heels-pink-s.png": 2429,
		"./feet/shoes-high-heels-pink.png": 2430,
		"./feet/shoes-high-heels-s.png": 2431,
		"./feet/shoes-high-heels.png": 2432,
		"./feet/shoes-jester-s.png": 2433,
		"./feet/shoes-jester.png": 2434,
		"./feet/shoes-running-s.png": 2435,
		"./feet/shoes-running.png": 2436,
		"./feet/short-s.png": 2437,
		"./feet/short.png": 2438,
		"./feet/simple-red-s.png": 2439,
		"./feet/simple-red.png": 2440,
		"./feet/skateboard-green-s.png": 2441,
		"./feet/skateboard-green.png": 2442,
		"./feet/skateboard-red-s.png": 2443,
		"./feet/skateboard-red.png": 2444,
		"./feet/skiis-s.png": 2445,
		"./feet/skiis.png": 2446,
		"./feet/snowboard-s.png": 2447,
		"./feet/snowboard.png": 2448,
		"./feet/surfboard-s.png": 2449,
		"./feet/surfboard.png": 2450,
		"./feet/train-s.png": 2451,
		"./feet/train.png": 2452,
		"./food/food1.png": 2453,
		"./food/food2.png": 2454,
		"./food/food3.png": 2455,
		"./food/food4.png": 2456,
		"./food/food5.png": 2457,
		"./food/food6.png": 2458,
		"./food/food7.png": 2459,
		"./hand/atom-s.png": 2460,
		"./hand/atom.png": 2461,
		"./hand/avocado-s.png": 2462,
		"./hand/avocado.png": 2463,
		"./hand/ball-baseball-glove-s.png": 2464,
		"./hand/ball-baseball-glove.png": 2465,
		"./hand/ball-basketball-s.png": 2466,
		"./hand/ball-basketball.png": 2467,
		"./hand/ball-beach-s.png": 2468,
		"./hand/ball-beach.png": 2469,
		"./hand/ball-football-s.png": 2470,
		"./hand/ball-football.png": 2471,
		"./hand/ball-soccer-s.png": 2472,
		"./hand/ball-soccer.png": 2473,
		"./hand/ball-tennis-racket-s.png": 2474,
		"./hand/ball-tennis-racket.png": 2475,
		"./hand/ball-volleyball-s.png": 2476,
		"./hand/ball-volleyball.png": 2477,
		"./hand/balloon-purple-heart-right-s.png": 2478,
		"./hand/balloon-purple-heart-right.png": 2479,
		"./hand/balloon-s.png": 2480,
		"./hand/balloon.png": 2481,
		"./hand/barbell-s.png": 2482,
		"./hand/barbell.png": 2483,
		"./hand/bat-s.png": 2484,
		"./hand/bat.png": 2485,
		"./hand/beaker-s.png": 2486,
		"./hand/beaker.png": 2487,
		"./hand/blow-dryer-s.png": 2488,
		"./hand/blow-dryer.png": 2489,
		"./hand/book-stack-s.png": 2490,
		"./hand/book-stack.png": 2491,
		"./hand/broom-s.png": 2492,
		"./hand/broom.png": 2493,
		"./hand/burrito-s.png": 2494,
		"./hand/burrito.png": 2495,
		"./hand/calculator-s.png": 2496,
		"./hand/calculator.png": 2497,
		"./hand/candy-s.png": 2498,
		"./hand/candy.png": 2499,
		"./hand/car-s.png": 2500,
		"./hand/car.png": 2501,
		"./hand/cell-phone-s.png": 2502,
		"./hand/cell-phone.png": 2503,
		"./hand/chili-s.png": 2504,
		"./hand/chili.png": 2505,
		"./hand/crayons-s.png": 2506,
		"./hand/crayons.png": 2507,
		"./hand/credit-card-s.png": 2508,
		"./hand/credit-card.png": 2509,
		"./hand/dive-tank-s.png": 2510,
		"./hand/dive-tank.png": 2511,
		"./hand/doctor-bag-s.png": 2512,
		"./hand/doctor-bag.png": 2513,
		"./hand/dreidel-s.png": 2514,
		"./hand/dreidel.png": 2515,
		"./hand/drumsticks-s.png": 2516,
		"./hand/drumsticks.png": 2517,
		"./hand/flask-blue-s.png": 2518,
		"./hand/flask-blue.png": 2519,
		"./hand/flask-green-s.png": 2520,
		"./hand/flask-green.png": 2521,
		"./hand/flask-orange-s.png": 2522,
		"./hand/flask-orange.png": 2523,
		"./hand/flower-tulip-s.png": 2524,
		"./hand/flower-tulip.png": 2525,
		"./hand/fries-s.png": 2526,
		"./hand/fries.png": 2527,
		"./hand/frog-prince-s.png": 2528,
		"./hand/frog-prince.png": 2529,
		"./hand/game-controller-s.png": 2530,
		"./hand/game-controller.png": 2531,
		"./hand/gavel-s.png": 2532,
		"./hand/gavel.png": 2533,
		"./hand/gear-s.png": 2534,
		"./hand/gear.png": 2535,
		"./hand/gift-s.png": 2536,
		"./hand/gift.png": 2537,
		"./hand/hairbrush-s.png": 2538,
		"./hand/hairbrush.png": 2539,
		"./hand/hannukaih-s.png": 2540,
		"./hand/hannukaih.png": 2541,
		"./hand/ice-cream-s.png": 2542,
		"./hand/ice-cream.png": 2543,
		"./hand/ice-powers-s.png": 2544,
		"./hand/ice-powers.png": 2545,
		"./hand/laptop-s.png": 2546,
		"./hand/laptop.png": 2547,
		"./hand/latte-s.png": 2548,
		"./hand/latte.png": 2549,
		"./hand/magic-wand-right-s.png": 2550,
		"./hand/magic-wand-right.png": 2551,
		"./hand/makeup-s.png": 2552,
		"./hand/makeup.png": 2553,
		"./hand/march-marathon-book-stack-s.png": 2554,
		"./hand/march-marathon-book-stack.png": 2555,
		"./hand/megaphone-s.png": 2556,
		"./hand/megaphone.png": 2557,
		"./hand/microphone-s.png": 2558,
		"./hand/microphone.png": 2559,
		"./hand/mini-snowman-s.png": 2560,
		"./hand/mini-snowman.png": 2561,
		"./hand/mummy-hand-s.png": 2562,
		"./hand/mummy-hand.png": 2563,
		"./hand/nachos-s.png": 2564,
		"./hand/nachos.png": 2565,
		"./hand/nail-polish-s.png": 2566,
		"./hand/nail-polish.png": 2567,
		"./hand/owl-store-dollars-s.png": 2568,
		"./hand/owl-store-dollars.png": 2569,
		"./hand/owlidays-cup-s.png": 2570,
		"./hand/owlidays-cup.png": 2571,
		"./hand/paint-brush-s.png": 2572,
		"./hand/paint-brush.png": 2573,
		"./hand/paint-palette-s.png": 2574,
		"./hand/paint-palette.png": 2575,
		"./hand/pencil-s.png": 2576,
		"./hand/pencil.png": 2577,
		"./hand/pineapple-s.png": 2578,
		"./hand/pineapple.png": 2579,
		"./hand/ping-pong-s.png": 2580,
		"./hand/ping-pong.png": 2581,
		"./hand/pink-diamond-right-s.png": 2582,
		"./hand/pink-diamond-right.png": 2583,
		"./hand/pizza-s.png": 2584,
		"./hand/pizza.png": 2585,
		"./hand/popcorn-s.png": 2586,
		"./hand/popcorn.png": 2587,
		"./hand/popsicle-s.png": 2588,
		"./hand/popsicle.png": 2589,
		"./hand/pretzel-s.png": 2590,
		"./hand/pretzel.png": 2591,
		"./hand/pumpkin-s.png": 2592,
		"./hand/pumpkin.png": 2593,
		"./hand/purse-s.png": 2594,
		"./hand/purse.png": 2595,
		"./hand/rabbit-in-hat-right-s.png": 2596,
		"./hand/rabbit-in-hat-right.png": 2597,
		"./hand/sandwich-s.png": 2598,
		"./hand/sandwich.png": 2599,
		"./hand/saxophone-s.png": 2600,
		"./hand/saxophone.png": 2601,
		"./hand/scene-snapper-s.png": 2602,
		"./hand/scene-snapper.png": 2603,
		"./hand/scissors-s.png": 2604,
		"./hand/scissors.png": 2605,
		"./hand/shield-s.png": 2606,
		"./hand/shield.png": 2607,
		"./hand/smoothie-s.png": 2608,
		"./hand/smoothie.png": 2609,
		"./hand/spaceship-s.png": 2610,
		"./hand/spaceship.png": 2611,
		"./hand/spiral-notebook-s.png": 2612,
		"./hand/spiral-notebook.png": 2613,
		"./hand/stethescope-s.png": 2614,
		"./hand/stethescope.png": 2615,
		"./hand/sushi-s.png": 2616,
		"./hand/sushi.png": 2617,
		"./hand/tablet-s.png": 2618,
		"./hand/tablet.png": 2619,
		"./hand/taco-s.png": 2620,
		"./hand/taco.png": 2621,
		"./hand/tea-cups-s.png": 2622,
		"./hand/tea-cups.png": 2623,
		"./hand/tea-pot-s.png": 2624,
		"./hand/tea-pot.png": 2625,
		"./hand/toast-s.png": 2626,
		"./hand/toast.png": 2627,
		"./hand/truck-s.png": 2628,
		"./hand/truck.png": 2629,
		"./hand/trumpet-s.png": 2630,
		"./hand/trumpet.png": 2631,
		"./hand/violin-s.png": 2632,
		"./hand/violin.png": 2633,
		"./hand/wrench-s.png": 2634,
		"./hand/wrench.png": 2635,
		"./head/afro-hair-s.png": 2636,
		"./head/afro-hair.png": 2637,
		"./head/antlers-s.png": 2638,
		"./head/antlers.png": 2639,
		"./head/army-helmet-s.png": 2640,
		"./head/army-helmet.png": 2641,
		"./head/band-egyptian-s.png": 2642,
		"./head/band-egyptian.png": 2643,
		"./head/band-peacock-s.png": 2644,
		"./head/band-peacock.png": 2645,
		"./head/big-wig-s.png": 2646,
		"./head/big-wig.png": 2647,
		"./head/bow-hair-pink-s.png": 2648,
		"./head/bow-hair-pink.png": 2649,
		"./head/bun-s.png": 2650,
		"./head/bun.png": 2651,
		"./head/bunny-ears-s.png": 2652,
		"./head/bunny-ears.png": 2653,
		"./head/cat-ears-s.png": 2654,
		"./head/cat-ears.png": 2655,
		"./head/crown-2-s.png": 2656,
		"./head/crown-2.png": 2657,
		"./head/crown-beaded-s.png": 2658,
		"./head/crown-beaded.png": 2659,
		"./head/diver-helmet-s.png": 2660,
		"./head/diver-helmet.png": 2661,
		"./head/dog-ears-s.png": 2662,
		"./head/dog-ears.png": 2663,
		"./head/earrings-flower-s.png": 2664,
		"./head/earrings-flower.png": 2665,
		"./head/earrings-pearl-s.png": 2666,
		"./head/earrings-pearl.png": 2667,
		"./head/earrings-ruby-s.png": 2668,
		"./head/earrings-ruby.png": 2669,
		"./head/flower-pink-s.png": 2670,
		"./head/flower-pink.png": 2671,
		"./head/flower-white-s.png": 2672,
		"./head/flower-white.png": 2673,
		"./head/fox-ears-s.png": 2674,
		"./head/fox-ears.png": 2675,
		"./head/hair-bun-s.png": 2676,
		"./head/hair-bun.png": 2677,
		"./head/hair-crazy-s.png": 2678,
		"./head/hair-crazy.png": 2679,
		"./head/hair-dark-s.png": 2680,
		"./head/hair-dark.png": 2681,
		"./head/hair-emo-s.png": 2682,
		"./head/hair-emo.png": 2683,
		"./head/hair-girl-blonde-s.png": 2684,
		"./head/hair-girl-blonde.png": 2685,
		"./head/hair-girl-brown-s.png": 2686,
		"./head/hair-girl-brown.png": 2687,
		"./head/hair-granny-s.png": 2688,
		"./head/hair-granny.png": 2689,
		"./head/hair-ice-queen-s.png": 2690,
		"./head/hair-ice-queen.png": 2691,
		"./head/hair-orange-s.png": 2692,
		"./head/hair-orange.png": 2693,
		"./head/hair-princess-s.png": 2694,
		"./head/hair-princess.png": 2695,
		"./head/hair-ringlets-black-s.png": 2696,
		"./head/hair-ringlets-black.png": 2697,
		"./head/hair-side-burn-s.png": 2698,
		"./head/hair-side-burn.png": 2699,
		"./head/hat-1-s.png": 2700,
		"./head/hat-1.png": 2701,
		"./head/hat-2-s.png": 2702,
		"./head/hat-2.png": 2703,
		"./head/hat-3-s.png": 2704,
		"./head/hat-3.png": 2705,
		"./head/hat-4-s.png": 2706,
		"./head/hat-4.png": 2707,
		"./head/hat-anchor-s.png": 2708,
		"./head/hat-anchor.png": 2709,
		"./head/hat-baseball-s.png": 2710,
		"./head/hat-baseball.png": 2711,
		"./head/hat-boot-s.png": 2712,
		"./head/hat-boot.png": 2713,
		"./head/hat-captain-s.png": 2714,
		"./head/hat-captain.png": 2715,
		"./head/hat-chef-s.png": 2716,
		"./head/hat-chef.png": 2717,
		"./head/hat-construction-s.png": 2718,
		"./head/hat-construction.png": 2719,
		"./head/hat-cowboy-s.png": 2720,
		"./head/hat-cowboy.png": 2721,
		"./head/hat-feather-red-s.png": 2722,
		"./head/hat-feather-red.png": 2723,
		"./head/hat-firefighter-s.png": 2724,
		"./head/hat-firefighter.png": 2725,
		"./head/hat-flowers-s.png": 2726,
		"./head/hat-flowers.png": 2727,
		"./head/hat-graduation-s.png": 2728,
		"./head/hat-graduation.png": 2729,
		"./head/hat-jester-s.png": 2730,
		"./head/hat-jester.png": 2731,
		"./head/hat-painter-s.png": 2732,
		"./head/hat-painter.png": 2733,
		"./head/hat-pink-s.png": 2734,
		"./head/hat-pink.png": 2735,
		"./head/hat-pirate-s.png": 2736,
		"./head/hat-pirate.png": 2737,
		"./head/hat-police-s.png": 2738,
		"./head/hat-police.png": 2739,
		"./head/hat-princess-s.png": 2740,
		"./head/hat-princess.png": 2741,
		"./head/hat-ranger-s.png": 2742,
		"./head/hat-ranger.png": 2743,
		"./head/hat-red-stripe-s.png": 2744,
		"./head/hat-red-stripe.png": 2745,
		"./head/hat-reggae-s.png": 2746,
		"./head/hat-reggae.png": 2747,
		"./head/hat-robin-hood-s.png": 2748,
		"./head/hat-robin-hood.png": 2749,
		"./head/hat-santa-s.png": 2750,
		"./head/hat-santa.png": 2751,
		"./head/hat-small-green-s.png": 2752,
		"./head/hat-small-green.png": 2753,
		"./head/hat-teal-s.png": 2754,
		"./head/hat-teal.png": 2755,
		"./head/hat-top-s.png": 2756,
		"./head/hat-top.png": 2757,
		"./head/hat-turkey-s.png": 2758,
		"./head/hat-turkey.png": 2759,
		"./head/hat-winter-green-s.png": 2760,
		"./head/hat-winter-green.png": 2761,
		"./head/hat-winter-pink-s.png": 2762,
		"./head/hat-winter-pink.png": 2763,
		"./head/hat-witch-s.png": 2764,
		"./head/hat-witch.png": 2765,
		"./head/headphones-s.png": 2766,
		"./head/headphones.png": 2767,
		"./head/headscarf-s.png": 2768,
		"./head/headscarf.png": 2769,
		"./head/helmet-astronaut-s.png": 2770,
		"./head/helmet-astronaut.png": 2771,
		"./head/helmet-football-s.png": 2772,
		"./head/helmet-football.png": 2773,
		"./head/holly-s.png": 2774,
		"./head/holly.png": 2775,
		"./head/mouse-ears-s.png": 2776,
		"./head/mouse-ears.png": 2777,
		"./head/mummy-head-s.png": 2778,
		"./head/mummy-head.png": 2779,
		"./head/party-hat-s.png": 2780,
		"./head/party-hat.png": 2781,
		"./head/plunger-hat-s.png": 2782,
		"./head/plunger-hat.png": 2783,
		"./head/pot-s.png": 2784,
		"./head/pot.png": 2785,
		"./head/santa-hat-s.png": 2786,
		"./head/santa-hat.png": 2787,
		"./head/spider-s.png": 2788,
		"./head/spider.png": 2789,
		"./head/spiky-hair-s.png": 2790,
		"./head/spiky-hair.png": 2791,
		"./head/tree-top-s.png": 2792,
		"./head/tree-top.png": 2793,
		"./head/umbrella-purple-s.png": 2794,
		"./head/umbrella-purple.png": 2795,
		"./head/umbrella-red-s.png": 2796,
		"./head/umbrella-red.png": 2797,
		"./head/unicorn-crown-s.png": 2798,
		"./head/unicorn-crown.png": 2799,
		"./head/watermelon-s.png": 2800,
		"./head/watermelon.png": 2801,
		"./head/witch-hat-s.png": 2802,
		"./head/witch-hat.png": 2803,
		"./head/wizard-hat-s.png": 2804,
		"./head/wizard-hat.png": 2805,
		"./head/zombie-bolts-s.png": 2806,
		"./head/zombie-bolts.png": 2807,
		"./left_hand/atom.png": 2808,
		"./left_hand/avocado.png": 2809,
		"./left_hand/ball-baseball-glove.png": 2810,
		"./left_hand/ball-basketball.png": 2811,
		"./left_hand/ball-beach.png": 2812,
		"./left_hand/ball-football.png": 2813,
		"./left_hand/ball-soccer.png": 2814,
		"./left_hand/ball-tennis-racket.png": 2815,
		"./left_hand/ball-volleyball.png": 2816,
		"./left_hand/balloon-purple-heart-right.png": 2817,
		"./left_hand/balloon.png": 2818,
		"./left_hand/banjo.png": 2819,
		"./left_hand/barbell.png": 2820,
		"./left_hand/bat.png": 2821,
		"./left_hand/beaker.png": 2822,
		"./left_hand/blow-dryer.png": 2823,
		"./left_hand/book-stack.png": 2824,
		"./left_hand/broom.png": 2825,
		"./left_hand/burrito.png": 2826,
		"./left_hand/calculator.png": 2827,
		"./left_hand/candy.png": 2828,
		"./left_hand/car.png": 2829,
		"./left_hand/cell-phone.png": 2830,
		"./left_hand/chili.png": 2831,
		"./left_hand/crayons.png": 2832,
		"./left_hand/credit-card.png": 2833,
		"./left_hand/dive-tank.png": 2834,
		"./left_hand/doctor-bag.png": 2835,
		"./left_hand/dreidel.png": 2836,
		"./left_hand/drumsticks.png": 2837,
		"./left_hand/flask-blue.png": 2838,
		"./left_hand/flask-green.png": 2839,
		"./left_hand/flask-orange.png": 2840,
		"./left_hand/flower-tulip.png": 2841,
		"./left_hand/fries.png": 2842,
		"./left_hand/frog-prince.png": 2843,
		"./left_hand/game-controller.png": 2844,
		"./left_hand/gavel.png": 2845,
		"./left_hand/gear.png": 2846,
		"./left_hand/gift.png": 2847,
		"./left_hand/hairbrush.png": 2848,
		"./left_hand/hannukaih.png": 2849,
		"./left_hand/ice-cream.png": 2850,
		"./left_hand/ice-powers.png": 2851,
		"./left_hand/laptop.png": 2852,
		"./left_hand/latte.png": 2853,
		"./left_hand/magic-wand-right.png": 2854,
		"./left_hand/makeup.png": 2855,
		"./left_hand/march-marathon-book-stack.png": 2856,
		"./left_hand/megaphone.png": 2857,
		"./left_hand/microphone.png": 2858,
		"./left_hand/mini-snowman.png": 2859,
		"./left_hand/mummy-hand.png": 2860,
		"./left_hand/nachos.png": 2861,
		"./left_hand/nail-polish.png": 2862,
		"./left_hand/owl-store-dollars.png": 2863,
		"./left_hand/owlidays-cup.png": 2864,
		"./left_hand/paint-brush.png": 2865,
		"./left_hand/paint-palette.png": 2866,
		"./left_hand/pencil.png": 2867,
		"./left_hand/pineapple.png": 2868,
		"./left_hand/ping-pong.png": 2869,
		"./left_hand/pink-diamond-right.png": 2870,
		"./left_hand/pizza.png": 2871,
		"./left_hand/popcorn.png": 2872,
		"./left_hand/popsicle.png": 2873,
		"./left_hand/pretzel.png": 2874,
		"./left_hand/pumpkin.png": 2875,
		"./left_hand/purse.png": 2876,
		"./left_hand/rabbit-in-hat-right.png": 2877,
		"./left_hand/sandwich.png": 2878,
		"./left_hand/saxophone.png": 2879,
		"./left_hand/scene-snapper.png": 2880,
		"./left_hand/scissors.png": 2881,
		"./left_hand/shield.png": 2882,
		"./left_hand/smoothie.png": 2883,
		"./left_hand/spaceship.png": 2884,
		"./left_hand/spiral-notebook.png": 2885,
		"./left_hand/stethescope.png": 2886,
		"./left_hand/sushi.png": 2887,
		"./left_hand/tablet.png": 2888,
		"./left_hand/taco.png": 2889,
		"./left_hand/tea-cups.png": 2890,
		"./left_hand/tea-pot.png": 2891,
		"./left_hand/toast.png": 2892,
		"./left_hand/truck.png": 2893,
		"./left_hand/trumpet.png": 2894,
		"./left_hand/violin.png": 2895,
		"./left_hand/wrench.png": 2896,
		"./stomach/stomach-0.png": 2897,
		"./stomach/stomach-1.png": 2898,
		"./stomach/stomach-10.png": 2899,
		"./stomach/stomach-11.png": 2900,
		"./stomach/stomach-12.png": 2901,
		"./stomach/stomach-13.png": 2902,
		"./stomach/stomach-14.png": 2903,
		"./stomach/stomach-15.png": 2904,
		"./stomach/stomach-16.png": 2905,
		"./stomach/stomach-17.png": 2906,
		"./stomach/stomach-18.png": 2907,
		"./stomach/stomach-19.png": 2908,
		"./stomach/stomach-2.png": 2909,
		"./stomach/stomach-20.png": 2910,
		"./stomach/stomach-21.png": 2911,
		"./stomach/stomach-22.png": 2912,
		"./stomach/stomach-23.png": 2913,
		"./stomach/stomach-24.png": 2914,
		"./stomach/stomach-25.png": 2915,
		"./stomach/stomach-26.png": 2916,
		"./stomach/stomach-27.png": 2917,
		"./stomach/stomach-28.png": 2918,
		"./stomach/stomach-29.png": 2919,
		"./stomach/stomach-3.png": 2920,
		"./stomach/stomach-4.png": 2921,
		"./stomach/stomach-5.png": 2922,
		"./stomach/stomach-6.png": 2923,
		"./stomach/stomach-7.png": 2924,
		"./stomach/stomach-8.png": 2925,
		"./stomach/stomach-9.png": 2926,
		"./stomach/stomach-o.png": 2927,
		"./wings/down-0.png": 2928,
		"./wings/down-1.png": 2929,
		"./wings/down-10.png": 2930,
		"./wings/down-11.png": 2931,
		"./wings/down-12.png": 2932,
		"./wings/down-13.png": 2933,
		"./wings/down-14.png": 2934,
		"./wings/down-15.png": 2935,
		"./wings/down-16.png": 2936,
		"./wings/down-17.png": 2937,
		"./wings/down-18.png": 2938,
		"./wings/down-19.png": 2939,
		"./wings/down-2.png": 2940,
		"./wings/down-20.png": 2941,
		"./wings/down-21.png": 2942,
		"./wings/down-22.png": 2943,
		"./wings/down-23.png": 2944,
		"./wings/down-24.png": 2945,
		"./wings/down-25.png": 2946,
		"./wings/down-26.png": 2947,
		"./wings/down-27.png": 2948,
		"./wings/down-28.png": 2949,
		"./wings/down-29.png": 2950,
		"./wings/down-3.png": 2951,
		"./wings/down-4.png": 2952,
		"./wings/down-5.png": 2953,
		"./wings/down-6.png": 2954,
		"./wings/down-7.png": 2955,
		"./wings/down-8.png": 2956,
		"./wings/down-9.png": 2957,
		"./wings/down-s.png": 2958,
		"./wings/middown-0.png": 2959,
		"./wings/middown-1.png": 2960,
		"./wings/middown-10.png": 2961,
		"./wings/middown-11.png": 2962,
		"./wings/middown-12.png": 2963,
		"./wings/middown-13.png": 2964,
		"./wings/middown-14.png": 2965,
		"./wings/middown-15.png": 2966,
		"./wings/middown-16.png": 2967,
		"./wings/middown-17.png": 2968,
		"./wings/middown-18.png": 2969,
		"./wings/middown-19.png": 2970,
		"./wings/middown-2.png": 2971,
		"./wings/middown-20.png": 2972,
		"./wings/middown-21.png": 2973,
		"./wings/middown-22.png": 2974,
		"./wings/middown-23.png": 2975,
		"./wings/middown-24.png": 2976,
		"./wings/middown-25.png": 2977,
		"./wings/middown-26.png": 2978,
		"./wings/middown-27.png": 2979,
		"./wings/middown-28.png": 2980,
		"./wings/middown-29.png": 2981,
		"./wings/middown-3.png": 2982,
		"./wings/middown-4.png": 2983,
		"./wings/middown-5.png": 2984,
		"./wings/middown-6.png": 2985,
		"./wings/middown-7.png": 2986,
		"./wings/middown-8.png": 2987,
		"./wings/middown-9.png": 2988,
		"./wings/middown-o.png": 2989,
		"./wings/middown-s.png": 2990,
		"./wings/solo-left-0.png": 2991,
		"./wings/solo-left-1.png": 2992,
		"./wings/solo-left-10.png": 2993,
		"./wings/solo-left-11.png": 2994,
		"./wings/solo-left-12.png": 2995,
		"./wings/solo-left-13.png": 2996,
		"./wings/solo-left-14.png": 2997,
		"./wings/solo-left-15.png": 2998,
		"./wings/solo-left-16.png": 2999,
		"./wings/solo-left-17.png": 3000,
		"./wings/solo-left-18.png": 3001,
		"./wings/solo-left-19.png": 3002,
		"./wings/solo-left-2.png": 3003,
		"./wings/solo-left-20.png": 3004,
		"./wings/solo-left-21.png": 3005,
		"./wings/solo-left-22.png": 3006,
		"./wings/solo-left-23.png": 3007,
		"./wings/solo-left-24.png": 3008,
		"./wings/solo-left-25.png": 3009,
		"./wings/solo-left-26.png": 3010,
		"./wings/solo-left-27.png": 3011,
		"./wings/solo-left-28.png": 3012,
		"./wings/solo-left-29.png": 3013,
		"./wings/solo-left-3.png": 3014,
		"./wings/solo-left-4.png": 3015,
		"./wings/solo-left-5.png": 3016,
		"./wings/solo-left-6.png": 3017,
		"./wings/solo-left-7.png": 3018,
		"./wings/solo-left-8.png": 3019,
		"./wings/solo-left-9.png": 3020,
		"./wings/solo-left-o.png": 3021,
		"./wings/solo-right-0.png": 3022,
		"./wings/solo-right-1.png": 3023,
		"./wings/solo-right-10.png": 3024,
		"./wings/solo-right-11.png": 3025,
		"./wings/solo-right-12.png": 3026,
		"./wings/solo-right-13.png": 3027,
		"./wings/solo-right-14.png": 3028,
		"./wings/solo-right-15.png": 3029,
		"./wings/solo-right-16.png": 3030,
		"./wings/solo-right-17.png": 3031,
		"./wings/solo-right-18.png": 3032,
		"./wings/solo-right-19.png": 3033,
		"./wings/solo-right-2.png": 3034,
		"./wings/solo-right-20.png": 3035,
		"./wings/solo-right-21.png": 3036,
		"./wings/solo-right-22.png": 3037,
		"./wings/solo-right-23.png": 3038,
		"./wings/solo-right-24.png": 3039,
		"./wings/solo-right-25.png": 3040,
		"./wings/solo-right-26.png": 3041,
		"./wings/solo-right-27.png": 3042,
		"./wings/solo-right-28.png": 3043,
		"./wings/solo-right-29.png": 3044,
		"./wings/solo-right-3.png": 3045,
		"./wings/solo-right-4.png": 3046,
		"./wings/solo-right-5.png": 3047,
		"./wings/solo-right-6.png": 3048,
		"./wings/solo-right-7.png": 3049,
		"./wings/solo-right-8.png": 3050,
		"./wings/solo-right-9.png": 3051,
		"./wings/solo-right-o.png": 3052,
		"./wings/up-0.png": 3053,
		"./wings/up-1.png": 3054,
		"./wings/up-10.png": 3055,
		"./wings/up-11.png": 3056,
		"./wings/up-12.png": 3057,
		"./wings/up-13.png": 3058,
		"./wings/up-14.png": 3059,
		"./wings/up-15.png": 3060,
		"./wings/up-16.png": 3061,
		"./wings/up-17.png": 3062,
		"./wings/up-18.png": 3063,
		"./wings/up-19.png": 3064,
		"./wings/up-2.png": 3065,
		"./wings/up-20.png": 3066,
		"./wings/up-21.png": 3067,
		"./wings/up-22.png": 3068,
		"./wings/up-23.png": 3069,
		"./wings/up-24.png": 3070,
		"./wings/up-25.png": 3071,
		"./wings/up-26.png": 3072,
		"./wings/up-27.png": 3073,
		"./wings/up-28.png": 3074,
		"./wings/up-29.png": 3075,
		"./wings/up-3.png": 3076,
		"./wings/up-4.png": 3077,
		"./wings/up-5.png": 3078,
		"./wings/up-6.png": 3079,
		"./wings/up-7.png": 3080,
		"./wings/up-8.png": 3081,
		"./wings/up-9.png": 3082,
		"./wings/up-s.png": 3083,
		"./wings/wave-left-0.png": 3084,
		"./wings/wave-left-1.png": 3085,
		"./wings/wave-left-10.png": 3086,
		"./wings/wave-left-11.png": 3087,
		"./wings/wave-left-12.png": 3088,
		"./wings/wave-left-13.png": 3089,
		"./wings/wave-left-14.png": 3090,
		"./wings/wave-left-15.png": 3091,
		"./wings/wave-left-16.png": 3092,
		"./wings/wave-left-17.png": 3093,
		"./wings/wave-left-18.png": 3094,
		"./wings/wave-left-19.png": 3095,
		"./wings/wave-left-2.png": 3096,
		"./wings/wave-left-20.png": 3097,
		"./wings/wave-left-21.png": 3098,
		"./wings/wave-left-22.png": 3099,
		"./wings/wave-left-23.png": 3100,
		"./wings/wave-left-24.png": 3101,
		"./wings/wave-left-25.png": 3102,
		"./wings/wave-left-26.png": 3103,
		"./wings/wave-left-27.png": 3104,
		"./wings/wave-left-28.png": 3105,
		"./wings/wave-left-29.png": 3106,
		"./wings/wave-left-3.png": 3107,
		"./wings/wave-left-4.png": 3108,
		"./wings/wave-left-5.png": 3109,
		"./wings/wave-left-6.png": 3110,
		"./wings/wave-left-7.png": 3111,
		"./wings/wave-left-8.png": 3112,
		"./wings/wave-left-9.png": 3113,
		"./wings/wave-left-s.png": 3114,
		"./wings/wave-right-0.png": 3115,
		"./wings/wave-right-1.png": 3116,
		"./wings/wave-right-10.png": 3117,
		"./wings/wave-right-11.png": 3118,
		"./wings/wave-right-12.png": 3119,
		"./wings/wave-right-13.png": 3120,
		"./wings/wave-right-14.png": 3121,
		"./wings/wave-right-15.png": 3122,
		"./wings/wave-right-16.png": 3123,
		"./wings/wave-right-17.png": 3124,
		"./wings/wave-right-18.png": 3125,
		"./wings/wave-right-19.png": 3126,
		"./wings/wave-right-2.png": 3127,
		"./wings/wave-right-20.png": 3128,
		"./wings/wave-right-21.png": 3129,
		"./wings/wave-right-22.png": 3130,
		"./wings/wave-right-23.png": 3131,
		"./wings/wave-right-24.png": 3132,
		"./wings/wave-right-25.png": 3133,
		"./wings/wave-right-26.png": 3134,
		"./wings/wave-right-27.png": 3135,
		"./wings/wave-right-28.png": 3136,
		"./wings/wave-right-29.png": 3137,
		"./wings/wave-right-3.png": 3138,
		"./wings/wave-right-4.png": 3139,
		"./wings/wave-right-5.png": 3140,
		"./wings/wave-right-6.png": 3141,
		"./wings/wave-right-7.png": 3142,
		"./wings/wave-right-8.png": 3143,
		"./wings/wave-right-9.png": 3144,
		"./wings/wave-right-s.png": 3145
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 671;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./background_sounds/campfire.png": 3155,
		"./background_sounds/forest.png": 3156,
		"./background_sounds/ocean.png": 3157,
		"./background_sounds/river.png": 3158,
		"./background_sounds/savanna.png": 3159,
		"./background_sounds/storm.png": 3160,
		"./backgrounds/blocks.png": 3161,
		"./backgrounds/blue.png": 3162,
		"./backgrounds/camo.png": 3163,
		"./backgrounds/circles.png": 3164,
		"./backgrounds/clouds.png": 3165,
		"./backgrounds/confetti.png": 545,
		"./backgrounds/cow.png": 3166,
		"./backgrounds/cubes.png": 3167,
		"./backgrounds/diamonds.png": 3168,
		"./backgrounds/fire.png": 3169,
		"./backgrounds/floral.png": 3170,
		"./backgrounds/flowers.png": 3171,
		"./backgrounds/food.png": 3172,
		"./backgrounds/forest.png": 3173,
		"./backgrounds/heartbeat.png": 3174,
		"./backgrounds/leaves.png": 3175,
		"./backgrounds/maze.png": 3176,
		"./backgrounds/monsters.png": 3177,
		"./backgrounds/pawprints.png": 3178,
		"./backgrounds/rain.png": 3179,
		"./backgrounds/red.png": 3180,
		"./backgrounds/savannah.png": 3181,
		"./backgrounds/snowflakes.png": 3182,
		"./backgrounds/space.png": 3183,
		"./backgrounds/squares.png": 3184,
		"./backgrounds/stars.png": 3185,
		"./backgrounds/water.png": 3186,
		"./backgrounds/wood.png": 3187,
		"./backgrounds/zigzag.png": 3188,
		"./bookshelves/bookshelf-basic-1.png": 3189,
		"./bookshelves/bookshelf-basic-2.png": 3190,
		"./bookshelves/bookshelf-basic-3.png": 3191,
		"./bookshelves/bookshelf-basic-4.png": 3192,
		"./bookshelves/bookshelf-beach.png": 3193,
		"./bookshelves/bookshelf-chef.png": 3194,
		"./bookshelves/bookshelf-circus.png": 3195,
		"./bookshelves/bookshelf-gamer.png": 3196,
		"./bookshelves/bookshelf-jam.png": 3197,
		"./bookshelves/bookshelf-pirate.png": 3198,
		"./bookshelves/bookshelf-skate.png": 3199,
		"./bookshelves/bookshelf-sports.png": 3200,
		"./bookshelves/bookshelf-winter.png": 3201,
		"./bookshelves/bookshelf-wizard.png": 3202,
		"./floor_items/basketball.png": 3203,
		"./floor_items/chest.png": 3204,
		"./floor_items/coffee-table.png": 3205,
		"./floor_items/electric-guitar.png": 3206,
		"./floor_items/fireplace.png": 3207,
		"./floor_items/football.png": 3208,
		"./floor_items/game-controller.png": 3209,
		"./floor_items/green-skateboard.png": 3210,
		"./floor_items/magic-book.png": 3211,
		"./floor_items/magic-staff.png": 3212,
		"./floor_items/mask.png": 3213,
		"./floor_items/palm-tree.png": 3214,
		"./floor_items/popcorn.png": 3215,
		"./floor_items/red-skateboard.png": 3216,
		"./floor_items/sandcastle.png": 3217,
		"./floor_items/side-table.png": 3218,
		"./floor_items/violin.png": 3219,
		"./floor_items/wand.png": 3220,
		"./greetings/fly.png": 3221,
		"./greetings/mambo.png": 3222,
		"./greetings/swing.png": 3223,
		"./greetings/tango.png": 3224,
		"./greetings/wave.png": 3225,
		"./houses/barn-house-empty.png": 300,
		"./houses/barn-house.png": 546,
		"./houses/beach-bungalow-empty.png": 301,
		"./houses/beach-bungalow-main.png": 547,
		"./houses/beach-bungalow.png": 548,
		"./houses/bell-tower-empty.png": 302,
		"./houses/bell-tower.png": 549,
		"./houses/chefs-palace-empty.png": 303,
		"./houses/chefs-palace-main.png": 550,
		"./houses/chefs-palace.png": 551,
		"./houses/clowns-cabin-empty.png": 304,
		"./houses/clowns-cabin-main.png": 552,
		"./houses/clowns-cabin.png": 553,
		"./houses/eagles-nest-empty.png": 305,
		"./houses/eagles-nest.png": 554,
		"./houses/festival-yurt-empty.png": 306,
		"./houses/festival-yurt.png": 555,
		"./houses/gamers-paradise-empty.png": 307,
		"./houses/gamers-paradise-main.png": 556,
		"./houses/gamers-paradise.png": 557,
		"./houses/gingerbread-house-empty.png": 308,
		"./houses/gingerbread-house.png": 558,
		"./houses/hawaiian-beach-hut-empty.png": 309,
		"./houses/hawaiian-beach-hut.png": 559,
		"./houses/jam-pad-empty.png": 310,
		"./houses/jam-pad-main.png": 560,
		"./houses/jam-pad.png": 561,
		"./houses/japanese-restaurant-empty.png": 311,
		"./houses/japanese-restaurant.png": 562,
		"./houses/leaning-t-owl-er-of-pisa-empty.png": 312,
		"./houses/leaning-t-owl-er-of-pisa.png": 563,
		"./houses/lighthouse-empty.png": 313,
		"./houses/lighthouse.png": 564,
		"./houses/log-cabin-empty.png": 314,
		"./houses/log-cabin.png": 565,
		"./houses/luxury-apartments-empty.png": 315,
		"./houses/luxury-apartments.png": 566,
		"./houses/medieval-tower-empty.png": 316,
		"./houses/medieval-tower.png": 567,
		"./houses/modern-glass-house-empty.png": 317,
		"./houses/modern-glass-house.png": 568,
		"./houses/modern-mansion-empty.png": 318,
		"./houses/modern-mansion.png": 569,
		"./houses/mongolian-house-empty.png": 319,
		"./houses/mongolian-house.png": 570,
		"./houses/owl-dobe-desert-casa-empty.png": 320,
		"./houses/owl-dobe-desert-casa.png": 571,
		"./houses/owl-ffel-tower-empty.png": 321,
		"./houses/owl-ffel-tower.png": 572,
		"./houses/pirate-hideaway-empty.png": 322,
		"./houses/pirate-hideaway-main.png": 573,
		"./houses/pirate-hideaway.png": 574,
		"./houses/pirate-ship-empty.png": 323,
		"./houses/pirate-ship.png": 575,
		"./houses/purple-hot-air-balloon-empty.png": 324,
		"./houses/purple-hot-air-balloon.png": 576,
		"./houses/rainbow-hot-air-balloon-empty.png": 325,
		"./houses/rainbow-hot-air-balloon.png": 577,
		"./houses/red-hot-air-balloon-empty.png": 326,
		"./houses/red-hot-air-balloon.png": 578,
		"./houses/rocket-ship-empty.png": 327,
		"./houses/rocket-ship.png": 579,
		"./houses/sir-hoots-a-lots-castle-empty.png": 328,
		"./houses/sir-hoots-a-lots-castle.png": 580,
		"./houses/skaters-shack-empty.png": 329,
		"./houses/skaters-shack-main.png": 581,
		"./houses/skaters-shack.png": 582,
		"./houses/space-vision-house-empty.png": 330,
		"./houses/space-vision-house.png": 583,
		"./houses/sports-clubhouse-empty.png": 331,
		"./houses/sports-clubhouse-main.png": 584,
		"./houses/sports-clubhouse.png": 585,
		"./houses/tree-house-empty.png": 332,
		"./houses/tree-house.png": 586,
		"./houses/trophy-room-empty.png": 333,
		"./houses/windmill-empty.png": 334,
		"./houses/windmill.png": 587,
		"./houses/winter-chalet-empty.png": 335,
		"./houses/winter-chalet-main.png": 588,
		"./houses/winter-chalet.png": 589,
		"./houses/wizards-hut-empty.png": 336,
		"./houses/wizards-hut-main.png": 590,
		"./houses/wizards-hut.png": 591,
		"./owl_hoots/barn_owl_hoot.png": 3226,
		"./owl_hoots/eagle_owl_hoot.png": 3227,
		"./owl_hoots/elf_owl_hoot.png": 3228,
		"./owl_hoots/horned_owl_hoot.png": 3229,
		"./owl_hoots/screech_owl_hoot.png": 3230,
		"./owl_hoots/snowy_owl_hoot.png": 3231,
		"./sofas/sofa-beach.png": 3232,
		"./sofas/sofa-chef.png": 3233,
		"./sofas/sofa-circus.png": 3234,
		"./sofas/sofa-gamer.png": 3235,
		"./sofas/sofa-jam.png": 3236,
		"./sofas/sofa-pirate.png": 3237,
		"./sofas/sofa-skate.png": 3238,
		"./sofas/sofa-sports.png": 3239,
		"./sofas/sofa-winter.png": 3240,
		"./sofas/sofa-wizard.png": 3241,
		"./wall_items/double-note-poster.png": 3242,
		"./wall_items/dragon-poster.png": 3243,
		"./wall_items/elephant-poster.png": 3244,
		"./wall_items/helm.png": 3245,
		"./wall_items/pirate-flag.png": 3246,
		"./wall_items/rocket-poster.png": 3247,
		"./wall_items/single-note-poster.png": 3248,
		"./wall_items/surfboard.png": 3249,
		"./wall_items/television.png": 3250,
		"./wall_items/window-night-beach.png": 3251,
		"./wall_items/window-night-lake.png": 3252,
		"./wall_items/window-night-mountains.png": 3253,
		"./wall_items/window-snowy-mountains.png": 3254,
		"./wall_items/window-sunny-beach.png": 3255,
		"./wall_items/window-sunny-lake.png": 3256,
		"./wall_items/window-sunny-mountains.png": 3257,
		"./wall_items/window-sunset-beach.png": 3258,
		"./wall_items/window-sunset-lake.png": 3259
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 672;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./finish.png": 3389,
		"./open-no-ss-complete.png": 592,
		"./open-no-ss.png": 3390,
		"./open-ss-complete.png": 3391,
		"./open-ss.png": 3392,
		"./warmup-complete.png": 3393,
		"./warmup.png": 3394
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 673;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./school-comp-medal-1-basic.png": 3395,
		"./school-comp-medal-2-basic.png": 3396,
		"./school-comp-medal-3-basic.png": 3397
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 674;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./easy.png": 3410,
		"./hard.png": 3411,
		"./onlevel.png": 3412
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 675;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./1.png": 3422,
		"./2.png": 3423,
		"./3.png": 3424,
		"./4.png": 3425
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 676;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./1.png": 3426,
		"./2.png": 3427,
		"./3-plus.png": 3428,
		"./3.png": 3429
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 677;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./1.png": 3430,
		"./2.png": 3431,
		"./3.png": 3432,
		"./4.png": 3433
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 678;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./banner-beach.png": 3434,
		"./banner-city.png": 3435,
		"./banner-desert.png": 3436,
		"./banner-fairyland.png": 3437,
		"./banner-farm.png": 3438,
		"./banner-forest.png": 3439,
		"./banner-jungle.png": 3440,
		"./banner-lake.png": 3441,
		"./banner-mushrooms.png": 3442,
		"./banner-review.png": 3443,
		"./banner-savannah.png": 3444,
		"./banner-sky.png": 3445,
		"./banner-space.png": 3446,
		"./banner-tundra.png": 3447,
		"./banner-underwater.png": 3448
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 679;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./icon-beach.png": 3449,
		"./icon-city.png": 3450,
		"./icon-desert.png": 3451,
		"./icon-fairyland.png": 3452,
		"./icon-farm.png": 3453,
		"./icon-forest.png": 3454,
		"./icon-jungle.png": 3455,
		"./icon-lake.png": 3456,
		"./icon-mushrooms.png": 3457,
		"./icon-savannah.png": 3458,
		"./icon-sky.png": 3459,
		"./icon-space.png": 3460,
		"./icon-tundra.png": 3461,
		"./icon-underwater.png": 3462
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 680;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./lock.png": 150,
		"./trophy-shelf-0.png": 593,
		"./trophy-shelf-1.png": 339,
		"./trophy-shelf-2.png": 594,
		"./trophy-shelf-3.png": 595,
		"./trophy-shelf-4.png": 596,
		"./trophy-shelf-5.png": 597,
		"./wing-0.png": 3468,
		"./wing-1.png": 3469,
		"./wing-10.png": 3470,
		"./wing-11.png": 3471,
		"./wing-2.png": 3472,
		"./wing-3.png": 3473,
		"./wing-4.png": 3474,
		"./wing-5.png": 3475,
		"./wing-6.png": 3476,
		"./wing-7.png": 3477,
		"./wing-8.png": 3478,
		"./wing-9.png": 3479
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 681;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./trophy-shelf-0.png": 593,
		"./trophy-shelf-1.png": 339,
		"./trophy-shelf-2.png": 594,
		"./trophy-shelf-3.png": 595,
		"./trophy-shelf-4.png": 596,
		"./trophy-shelf-5.png": 597
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 682;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./books-blue.png": 598,
		"./cancel-blue.png": 599,
		"./clock-blue.png": 600,
		"./flag-blue.png": 601,
		"./gauge-blue.png": 602,
		"./lightbulb-blue.png": 603,
		"./rising-blue.png": 604
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 683;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./campfire.mp3": 3870,
		"./forest.mp3": 3871,
		"./ocean.mp3": 3872,
		"./river.mp3": 3873,
		"./savanna.mp3": 3874,
		"./storm.mp3": 3875
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 684;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./mambo.mp3": 3876,
		"./swing.mp3": 3877,
		"./tango.mp3": 3878
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 685;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./barn_owl_hoot.mp3": 3879,
		"./eagle_owl_hoot.mp3": 3880,
		"./elf_owl_hoot.mp3": 3881,
		"./horned_owl_hoot.mp3": 3882,
		"./screech_owl_hoot.mp3": 3883,
		"./snowy_owl_hoot.mp3": 3884
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 686;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./end_recording.mp3": 3885,
		"./start_recording.mp3": 3886
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 687;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(691);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(688);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(227)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(227)["default"];
	var toPrimitive = __webpack_require__(690);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	var eventbuilder_1 = __webpack_require__(228);
	var transports_1 = __webpack_require__(360);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(this._options, exception, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(89);
	exports.Severity = types_1.Severity;
	exports.Status = types_1.Status;
	var core_1 = __webpack_require__(58);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.startTransaction = core_1.startTransaction;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(358);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(157);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(228);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(700);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(361);
	exports.SDK_NAME = version_1.SDK_NAME;
	exports.SDK_VERSION = version_1.SDK_VERSION;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	tslib_1.__exportStar(__webpack_require__(693), exports);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var BrowserIntegrations = __webpack_require__(229);
	var Transports = __webpack_require__(360);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(58);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        var _this = this;
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'console',
	            });
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'dom',
	            });
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'xhr',
	            });
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'fetch',
	            });
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'history',
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from console API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
	        var breadcrumb = {
	            category: 'console',
	            data: {
	                arguments: handlerData.args,
	                logger: 'console',
	            },
	            level: types_1.Severity.fromString(handlerData.level),
	            message: utils_1.safeJoin(handlerData.args, ' '),
	        };
	        if (handlerData.level === 'assert') {
	            if (handlerData.args[0] === false) {
	                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	                breadcrumb.data.arguments = handlerData.args.slice(1);
	            }
	            else {
	                // Don't capture a breadcrumb for passed assertions
	                return;
	            }
	        }
	        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	            input: handlerData.args,
	            level: handlerData.level,
	        });
	    };
	    /**
	     * Creates breadcrumbs from DOM API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
	        var target;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target)
	                : utils_1.htmlTreeAsString(handlerData.event);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	        });
	    };
	    /**
	     * Creates breadcrumbs from XHR API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
	        if (handlerData.endTimestamp) {
	            // We only capture complete, non-sentry requests
	            if (handlerData.xhr.__sentry_own_request__) {
	                return;
	            }
	            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'xhr',
	                data: {
	                    method: method,
	                    url: url,
	                    status_code: status_code,
	                },
	                type: 'http',
	            }, {
	                xhr: handlerData.xhr,
	                input: body,
	            });
	            return;
	        }
	    };
	    /**
	     * Creates breadcrumbs from fetch API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
	        // We only capture complete fetch requests
	        if (!handlerData.endTimestamp) {
	            return;
	        }
	        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	            return;
	        }
	        if (handlerData.error) {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: handlerData.fetchData,
	                level: types_1.Severity.Error,
	                type: 'http',
	            }, {
	                data: handlerData.error,
	                input: handlerData.args,
	            });
	        }
	        else {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	                type: 'http',
	            }, {
	                input: handlerData.args,
	                response: handlerData.response,
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from history API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
	        var global = utils_1.getGlobalObject();
	        var from = handlerData.from;
	        var to = handlerData.to;
	        var parsedLoc = utils_1.parseUrl(global.location.href);
	        var parsedFrom = utils_1.parseUrl(from);
	        var parsedTo = utils_1.parseUrl(to);
	        // Initial pushState doesn't provide `from` information
	        if (!parsedFrom.path) {
	            parsedFrom = parsedLoc;
	        }
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	            to = parsedTo.relative;
	        }
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	            from = parsedFrom.relative;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'navigation',
	            data: {
	                from: from,
	                to: to,
	            },
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(58);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	var eventbuilder_1 = __webpack_require__(228);
	var helpers_1 = __webpack_require__(157);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /** JSDoc */
	        this._onErrorHandlerInstalled = false;
	        /** JSDoc */
	        this._onUnhandledRejectionHandlerInstalled = false;
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        if (this._options.onerror) {
	            utils_1.logger.log('Global Handler attached: onerror');
	            this._installGlobalOnErrorHandler();
	        }
	        if (this._options.onunhandledrejection) {
	            utils_1.logger.log('Global Handler attached: onunhandledrejection');
	            this._installGlobalOnUnhandledRejectionHandler();
	        }
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
	        var _this = this;
	        if (this._onErrorHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (data) {
	                var error = data.error;
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
	                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: false,
	                    }), data.url, data.line, data.column);
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onerror',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	            },
	            type: 'error',
	        });
	        this._onErrorHandlerInstalled = true;
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
	        var _this = this;
	        if (this._onUnhandledRejectionHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (e) {
	                var error = e;
	                // dig the object of the rejection out of known event types
	                try {
	                    // PromiseRejectionEvents store the object of the rejection under 'reason'
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	                    if ('reason' in e) {
	                        error = e.reason;
	                    }
	                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	                    // https://github.com/getsentry/sentry-javascript/issues/2380
	                    else if ('detail' in e && 'reason' in e.detail) {
	                        error = e.detail.reason;
	                    }
	                }
	                catch (_oO) {
	                    // no-empty
	                }
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return true;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromRejectionWithPrimitive(error)
	                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: true,
	                    });
	                event.level = types_1.Severity.Error;
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onunhandledrejection',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	                return;
	            },
	            type: 'unhandledrejection',
	        });
	        this._onUnhandledRejectionHandlerInstalled = true;
	    };
	    /**
	     * This function creates a stack from an old, error-less onerror handler.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
	        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	        // If 'message' is ErrorEvent, get real message from inside
	        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	        var name;
	        if (utils_1.isString(message)) {
	            var groups = message.match(ERROR_TYPES_RE);
	            if (groups) {
	                name = groups[1];
	                message = groups[2];
	            }
	        }
	        var event = {
	            exception: {
	                values: [
	                    {
	                        type: name || 'Error',
	                        value: message,
	                    },
	                ],
	            },
	        };
	        return this._enhanceEventWithInitialFrame(event, url, line, column);
	    };
	    /**
	     * Create an event from a promise rejection where the `reason` is a primitive.
	     *
	     * @param reason: The `reason` property of the promise rejection
	     * @returns An Event object with an appropriate `exception` value
	     */
	    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
	        return {
	            exception: {
	                values: [
	                    {
	                        type: 'UnhandledRejection',
	                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                        value: "Non-Error promise rejection captured with value: " + String(reason),
	                    },
	                ],
	            },
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
	        event.exception = event.exception || {};
	        event.exception.values = event.exception.values || [];
	        event.exception.values[0] = event.exception.values[0] || {};
	        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
	        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
	        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	        if (event.exception.values[0].stacktrace.frames.length === 0) {
	            event.exception.values[0].stacktrace.frames.push({
	                colno: colno,
	                filename: filename,
	                function: '?',
	                in_app: true,
	                lineno: lineno,
	            });
	        }
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var parsers_1 = __webpack_require__(359);
	var tracekit_1 = __webpack_require__(230);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            if (self) {
	                return self._handler(event, hint);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._handler = function (event, hint) {
	        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	            return event;
	        }
	        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
	        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
	        if (stack === void 0) { stack = []; }
	        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
	            return stack;
	        }
	        var stacktrace = tracekit_1.computeStackTrace(error[key]);
	        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
	        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	var helpers_1 = __webpack_require__(157);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
	        }
	        if (this._options.eventTarget) {
	            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(this._wrapEventTarget.bind(this));
	        }
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapTimeFunction = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var originalCallback = args[0];
	            args[0] = helpers_1.wrap(originalCallback, {
	                mechanism: {
	                    data: { function: utils_1.getFunctionName(original) },
	                    handled: true,
	                    type: 'instrument',
	                },
	            });
	            return original.apply(this, args);
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    TryCatch.prototype._wrapRAF = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function (callback) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return original.call(this, helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }));
	        };
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapEventTarget = function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var global = utils_1.getGlobalObject();
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        utils_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    if (typeof fn.handleEvent === 'function') {
	                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                            mechanism: {
	                                data: {
	                                    function: 'handleEvent',
	                                    handler: utils_1.getFunctionName(fn),
	                                    target: target,
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        });
	                    }
	                }
	                catch (err) {
	                    // can sometimes get 'Permission denied to access property "handle Event'
	                }
	                return original.call(this, eventName, 
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }), options);
	            };
	        });
	        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (eventName, fn, options) {
	                var _a;
	                /**
	                 * There are 2 possible scenarios here:
	                 *
	                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	                 * as a pass-through, and call original `removeEventListener` with it.
	                 *
	                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	                 *
	                 * When someone adds a handler prior to initialization, and then do it again, but after,
	                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	                 * to get rid of the initial handler and it'd stick there forever.
	                 */
	                var wrappedEventHandler = fn;
	                try {
	                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
	                    if (originalEventHandler) {
	                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                    }
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	            };
	        });
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapXHR = function (originalSend) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	            xmlHttpRequestProps.forEach(function (prop) {
	                if (prop in xhr && typeof xhr[prop] === 'function') {
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    utils_1.fill(xhr, prop, function (original) {
	                        var wrapOptions = {
	                            mechanism: {
	                                data: {
	                                    function: prop,
	                                    handler: utils_1.getFunctionName(original),
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        };
	                        // If Instrument integration has been called before TryCatch, get the name of original function
	                        if (original.__sentry_original__) {
	                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
	                        }
	                        // Otherwise wrap directly
	                        return helpers_1.wrap(original, wrapOptions);
	                    });
	                }
	            });
	            return originalSend.apply(this, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            var _a, _b, _c;
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var client_1 = __webpack_require__(358);
	var helpers_1 = __webpack_require__(157);
	var integrations_1 = __webpack_require__(229);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = false;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        options.eventId = core_1.getCurrentHub().lastEventId();
	    }
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.flush = flush;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var hub = core_1.getCurrentHub();
	    /**
	     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
	     * but, as always, it's not available in the IE10-11. Thanks IE.
	     */
	    var loadResolved = document.readyState === 'complete';
	    var fcpResolved = false;
	    var possiblyEndSession = function () {
	        if (fcpResolved && loadResolved) {
	            hub.endSession();
	        }
	    };
	    var resolveWindowLoaded = function () {
	        loadResolved = true;
	        possiblyEndSession();
	        window.removeEventListener('load', resolveWindowLoaded);
	    };
	    hub.startSession();
	    if (!loadResolved) {
	        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
	        // attach and then detach it once completed.
	        window.addEventListener('load', resolveWindowLoaded);
	    }
	    try {
	        var po = new PerformanceObserver(function (entryList, po) {
	            entryList.getEntries().forEach(function (entry) {
	                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
	                    po.disconnect();
	                    fcpResolved = true;
	                    possiblyEndSession();
	                }
	            });
	        });
	        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
	        // so we do it below here.
	        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
	        document.addEventListener('visibilitychange', function (event) {
	            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
	        }, { once: true });
	        po.observe({
	            type: 'paint',
	            buffered: true,
	        });
	    }
	    catch (e) {
	        fcpResolved = true;
	        possiblyEndSession();
	    }
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var base_1 = __webpack_require__(231);
	var global = utils_1.getGlobalObject();
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	            // https://caniuse.com/#feat=referrer-policy
	            // It doesn't. And it throw exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            global
	                .fetch(sentryRequest.url, options)
	                .then(function (response) {
	                var headers = {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                };
	                _this._handleResponse({
	                    requestType: sentryRequest.type,
	                    response: response,
	                    headers: headers,
	                    resolve: resolve,
	                    reject: reject,
	                });
	            })
	                .catch(reject);
	        }));
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var core_1 = __webpack_require__(58);
	var utils_1 = __webpack_require__(34);
	var base_1 = __webpack_require__(231);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            var request = new XMLHttpRequest();
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    var headers = {
	                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                        'retry-after': request.getResponseHeader('Retry-After'),
	                    };
	                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                }
	            };
	            request.open('POST', sentryRequest.url);
	            for (var header in _this.options.headers) {
	                if (_this.options.headers.hasOwnProperty(header)) {
	                    request.setRequestHeader(header, _this.options.headers[header]);
	                }
	            }
	            request.send(sentryRequest.body);
	        }));
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var SENTRY_API_VERSION = '7';
	/** Helper class to provide urls to different Sentry endpoints. */
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn) {
	        this.dsn = dsn;
	        this._dsnObject = new utils_1.Dsn(dsn);
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        var dsn = this._dsnObject;
	        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	        var port = dsn.port ? ":" + dsn.port : '';
	        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return this._getIngestEndpoint('store');
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return this.getStoreEndpoint() + "?" + this._encodedAuth();
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
	    };
	    /** Returns only the path component for the store endpoint. */
	    API.prototype.getStoreEndpointPath = function () {
	        var dsn = this._dsnObject;
	        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
	    };
	    /**
	     * Returns an object that can be used in request headers.
	     * This is needed for node and the old /store endpoint in sentry
	     */
	    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
	        var dsn = this._dsnObject;
	        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	        header.push("sentry_client=" + clientName + "/" + clientVersion);
	        header.push("sentry_key=" + dsn.user);
	        if (dsn.pass) {
	            header.push("sentry_secret=" + dsn.pass);
	        }
	        return {
	            'Content-Type': 'application/json',
	            'X-Sentry-Auth': header.join(', '),
	        };
	    };
	    /** Returns the url to the report dialog endpoint. */
	    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
	        if (dialogOptions === void 0) { dialogOptions = {}; }
	        var dsn = this._dsnObject;
	        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
	        var encodedOptions = [];
	        encodedOptions.push("dsn=" + dsn.toString());
	        for (var key in dialogOptions) {
	            if (key === 'dsn') {
	                continue;
	            }
	            if (key === 'user') {
	                if (!dialogOptions.user) {
	                    continue;
	                }
	                if (dialogOptions.user.name) {
	                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
	                }
	                if (dialogOptions.user.email) {
	                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
	                }
	            }
	            else {
	                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
	            }
	        }
	        if (encodedOptions.length) {
	            return endpoint + "?" + encodedOptions.join('&');
	        }
	        return endpoint;
	    };
	    /** Returns the envelope endpoint URL. */
	    API.prototype._getEnvelopeEndpoint = function () {
	        return this._getIngestEndpoint('envelope');
	    };
	    /** Returns the ingest API endpoint for target. */
	    API.prototype._getIngestEndpoint = function (target) {
	        var base = this.getBaseApiEndpoint();
	        var dsn = this._dsnObject;
	        return "" + base + dsn.projectId + "/" + target + "/";
	    };
	    /** Returns a URL-encoded string with auth config suitable for a query string. */
	    API.prototype._encodedAuth = function () {
	        var dsn = this._dsnObject;
	        var auth = {
	            // We send only the minimum set of required information. See
	            // https://github.com/getsentry/sentry-javascript/issues/2572.
	            sentry_key: dsn.user,
	            sentry_version: SENTRY_API_VERSION,
	        };
	        return utils_1.urlEncode(auth);
	    };
	    return API;
	}());
	exports.API = API;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var noop_1 = __webpack_require__(362);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        this._transport.sendEvent(event).then(null, function (reason) {
	            utils_1.logger.error("Error while sending event: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        this._transport.sendSession(session).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(137);
	var types_1 = __webpack_require__(89);
	var utils_1 = __webpack_require__(34);
	var integration_1 = __webpack_require__(706);
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient.prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of call being processed */
	        this._processing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = new utils_1.Dsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!session.release) {
	            utils_1.logger.warn('Discarded session because of missing release');
	        }
	        else {
	            this._sendSession(session);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientProcessing(timeout).then(function (ready) {
	            return _this._getBackend()
	                .getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return ready && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled()) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var userAgent;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        var user = event.user;
	        if (!session.userAgent) {
	            var headers = event.request ? event.request.headers : {};
	            for (var key in headers) {
	                if (key.toLowerCase() === 'user-agent') {
	                    userAgent = headers[key];
	                    break;
	                }
	            }
	        }
	        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
	            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /** Waits for the client to be done with processing. */
	    BaseClient.prototype._isClientProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._processing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.SyncPromise.resolve(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var sdkInfo = event.sdk;
	        var integrationsArray = Object.keys(this._integrations);
	        if (sdkInfo && integrationsArray.length > 0) {
	            sdkInfo.integrations = integrationsArray;
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        if (!this._isEnabled()) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            if (typeof beforeSendResult === 'undefined') {
	                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
	            }
	            else if (utils_1.isThenable(beforeSendResult)) {
	                return beforeSendResult.then(function (event) { return event; }, function (e) {
	                    throw new utils_1.SentryError("beforeSend rejected with " + e);
	                });
	            }
	            return beforeSendResult;
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._processing += 1;
	        promise.then(function (value) {
	            _this._processing -= 1;
	            return value;
	        }, function (reason) {
	            _this._processing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var hub_1 = __webpack_require__(137);
	var utils_1 = __webpack_require__(34);
	exports.installedIntegrations = [];
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = [];
	    if (Array.isArray(userIntegrations)) {
	        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
	        var pickedIntegrationsNames_1 = [];
	        // Leave only unique default integrations, that were not overridden with provided user integrations
	        defaultIntegrations.forEach(function (defaultIntegration) {
	            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
	                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
	                integrations.push(defaultIntegration);
	                pickedIntegrationsNames_1.push(defaultIntegration.name);
	            }
	        });
	        // Don't add same user integration twice
	        userIntegrations.forEach(function (userIntegration) {
	            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
	                integrations.push(userIntegration);
	                pickedIntegrationsNames_1.push(userIntegration.name);
	            }
	        });
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(defaultIntegrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    else {
	        integrations = tslib_1.__spread(defaultIntegrations);
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = this.__sentry_original__ || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var hub_1 = __webpack_require__(137);
	var utils_1 = __webpack_require__(34);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function () {
	        hub_1.addGlobalEventProcessor(function (event) {
	            var hub = hub_1.getCurrentHub();
	            if (!hub) {
	                return event;
	            }
	            var self = hub.getIntegration(InboundFilters);
	            if (self) {
	                var client = hub.getClient();
	                var clientOptions = client ? client.getOptions() : {};
	                var options = self._mergeOptions(clientOptions);
	                if (self._shouldDropEvent(event, options)) {
	                    return null;
	                }
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._shouldDropEvent = function (event, options) {
	        if (this._isSentryError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isIgnoredError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isDeniedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        if (!this._isAllowedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isSentryError = function (event, options) {
	        if (!options.ignoreInternal) {
	            return false;
	        }
	        try {
	            return ((event &&
	                event.exception &&
	                event.exception.values &&
	                event.exception.values[0] &&
	                event.exception.values[0].type === 'SentryError') ||
	                false);
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isIgnoredError = function (event, options) {
	        if (!options.ignoreErrors || !options.ignoreErrors.length) {
	            return false;
	        }
	        return this._getPossibleEventMessages(event).some(function (message) {
	            // Not sure why TypeScript complains here...
	            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isDeniedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.denyUrls || !options.denyUrls.length) {
	            return false;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isAllowedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.allowUrls || !options.allowUrls.length) {
	            return true;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._mergeOptions = function (clientOptions) {
	        if (clientOptions === void 0) { clientOptions = {}; }
	        return {
	            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
	        };
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getPossibleEventMessages = function (event) {
	        if (event.message) {
	            return [event.message];
	        }
	        if (event.exception) {
	            try {
	                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	                return ["" + value, type + ": " + value];
	            }
	            catch (oO) {
	                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	                return [];
	            }
	        }
	        return [];
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getEventFilterUrl = function (event) {
	        try {
	            if (event.stacktrace) {
	                var frames_1 = event.stacktrace.frames;
	                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
	            }
	            if (event.exception) {
	                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
	                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
	            }
	            return null;
	        }
	        catch (oO) {
	            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(707);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(708);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	/** Creates a SentryRequest from an event. */
	function sessionToSentryRequest(session, api) {
	    var envelopeHeaders = JSON.stringify({
	        sent_at: new Date().toISOString(),
	    });
	    var itemHeaders = JSON.stringify({
	        type: 'session',
	    });
	    return {
	        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
	        type: 'session',
	        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    // since JS has no Object.prototype.pop()
	    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
	    event.tags = otherTags;
	    var useEnvelope = event.type === 'transaction';
	    var req = {
	        body: JSON.stringify(event),
	        type: event.type || 'event',
	        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = JSON.stringify({
	            event_id: event.event_id,
	            sent_at: new Date().toISOString(),
	        });
	        var itemHeaders = JSON.stringify({
	            type: event.type,
	            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
	            // explicitly-set sampling decisions). Are we good with that?
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        });
	        // The trailing newline is optional. We intentionally don't send it to avoid
	        // sending unnecessary bytes.
	        //
	        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
	        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
	        req.body = envelope;
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(137);
	var utils_1 = __webpack_require__(34);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        utils_1.logger.enable();
	    }
	    var hub = hub_1.getCurrentHub();
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	var scope_1 = __webpack_require__(363);
	var session_1 = __webpack_require__(364);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 3;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * Absolute maximum number of breadcrumbs added to an event. The
	 * `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        this.bindClient(client);
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        // End existing session if there's one
	        this.endSession();
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), context));
	        if (scope) {
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            session.close();
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	            scope.setSession();
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/** Returns the global shim registry. */
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 *
	 * @returns The domain, or undefined if there is no active domain
	 */
	function getActiveDomain() {
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var activeDomain = getActiveDomain();
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
	        return carrier.__SENTRY__.hub;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = new Hub();
	    return carrier.__SENTRY__.hub;
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var hub_1 = __webpack_require__(137);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error('Sentry syntheticException');
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param level Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error(message);
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Console logging verbosity for the SDK. */
	var LogLevel;
	(function (LogLevel) {
	    /** No logs will be generated. */
	    LogLevel[LogLevel["None"] = 0] = "None";
	    /** Only SDK internal errors will be logged. */
	    LogLevel[LogLevel["Error"] = 1] = "Error";
	    /** Information useful for debugging the SDK will be logged. */
	    LogLevel[LogLevel["Debug"] = 2] = "Debug";
	    /** All SDK actions will be logged. */
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Session Status
	 */
	var SessionStatus;
	(function (SessionStatus) {
	    /** JSDoc */
	    SessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    SessionStatus["Exited"] = "exited";
	    /** JSDoc */
	    SessionStatus["Crashed"] = "crashed";
	    /** JSDoc */
	    SessionStatus["Abnormal"] = "abnormal";
	})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
	//# sourceMappingURL=session.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	// eslint-disable-next-line import/export
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Severity) {
	    /**
	     * Converts a string-based level into a {@link Severity}.
	     *
	     * @param level string representation of Severity
	     * @returns Severity
	     */
	    function fromString(level) {
	        switch (level) {
	            case 'debug':
	                return Severity.Debug;
	            case 'info':
	                return Severity.Info;
	            case 'warn':
	            case 'warning':
	                return Severity.Warning;
	            case 'error':
	                return Severity.Error;
	            case 'fatal':
	                return Severity.Fatal;
	            case 'critical':
	                return Severity.Critical;
	            case 'log':
	            default:
	                return Severity.Log;
	        }
	    }
	    Severity.fromString = fromString;
	})(Severity = exports.Severity || (exports.Severity = {}));
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an event. */
	// eslint-disable-next-line import/export
	var Status;
	(function (Status) {
	    /** The status could not be determined. */
	    Status["Unknown"] = "unknown";
	    /** The event was skipped due to configuration or callbacks. */
	    Status["Skipped"] = "skipped";
	    /** The event was sent to Sentry successfully. */
	    Status["Success"] = "success";
	    /** The client is currently rate limited and will try again later. */
	    Status["RateLimit"] = "rate_limit";
	    /** The event could not be processed. */
	    Status["Invalid"] = "invalid";
	    /** A server-side error ocurred during submission. */
	    Status["Failed"] = "failed";
	})(Status = exports.Status || (exports.Status = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Status) {
	    /**
	     * Converts a HTTP status code into a {@link Status}.
	     *
	     * @param code The HTTP response status code.
	     * @returns The send status or {@link Status.Unknown}.
	     */
	    function fromHttpCode(code) {
	        if (code >= 200 && code < 300) {
	            return Status.Success;
	        }
	        if (code === 429) {
	            return Status.RateLimit;
	        }
	        if (code >= 400 && code < 500) {
	            return Status.Invalid;
	        }
	        if (code >= 500) {
	            return Status.Failed;
	        }
	        return Status.Unknown;
	    }
	    Status.fromHttpCode = fromHttpCode;
	})(Status = exports.Status || (exports.Status = {}));
	//# sourceMappingURL=status.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var TransactionSamplingMethod;
	(function (TransactionSamplingMethod) {
	    TransactionSamplingMethod["Explicit"] = "explicitly_set";
	    TransactionSamplingMethod["Sampler"] = "client_sampler";
	    TransactionSamplingMethod["Rate"] = "client_rate";
	    TransactionSamplingMethod["Inheritance"] = "inheritance";
	})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var error_1 = __webpack_require__(232);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	/** Error message */
	var ERROR_MESSAGE = 'Invalid Dsn';
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	var Dsn = /** @class */ (function () {
	    /** Creates a new Dsn component */
	    function Dsn(from) {
	        if (typeof from === 'string') {
	            this._fromString(from);
	        }
	        else {
	            this._fromComponents(from);
	        }
	        this._validate();
	    }
	    /**
	     * Renders the string representation of this Dsn.
	     *
	     * By default, this will render the public representation without the password
	     * component. To get the deprecated private representation, set `withPassword`
	     * to true.
	     *
	     * @param withPassword When set to true, the password will be included.
	     */
	    Dsn.prototype.toString = function (withPassword) {
	        if (withPassword === void 0) { withPassword = false; }
	        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
	        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
	            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	    };
	    /** Parses a string into this Dsn. */
	    Dsn.prototype._fromString = function (str) {
	        var match = DSN_REGEX.exec(str);
	        if (!match) {
	            throw new error_1.SentryError(ERROR_MESSAGE);
	        }
	        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	        var path = '';
	        var projectId = lastPath;
	        var split = projectId.split('/');
	        if (split.length > 1) {
	            path = split.slice(0, -1).join('/');
	            projectId = split.pop();
	        }
	        if (projectId) {
	            var projectMatch = projectId.match(/^\d+/);
	            if (projectMatch) {
	                projectId = projectMatch[0];
	            }
	        }
	        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
	    };
	    /** Maps Dsn components into this instance. */
	    Dsn.prototype._fromComponents = function (components) {
	        this.protocol = components.protocol;
	        this.user = components.user;
	        this.pass = components.pass || '';
	        this.host = components.host;
	        this.port = components.port || '';
	        this.path = components.path || '';
	        this.projectId = components.projectId;
	    };
	    /** Validates this Dsn and throws on error. */
	    Dsn.prototype._validate = function () {
	        var _this = this;
	        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
	            if (!_this[component]) {
	                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
	            }
	        });
	        if (!this.projectId.match(/^\d+$/)) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
	        }
	        if (this.protocol !== 'http' && this.protocol !== 'https') {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
	        }
	        if (this.port && isNaN(parseInt(this.port, 10))) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
	        }
	    };
	    return Dsn;
	}());
	exports.Dsn = Dsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(33);
	var is_1 = __webpack_require__(114);
	var logger_1 = __webpack_require__(233);
	var misc_1 = __webpack_require__(158);
	var object_1 = __webpack_require__(235);
	var stacktrace_1 = __webpack_require__(236);
	var supports_1 = __webpack_require__(367);
	var global = misc_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            logger_1.logger.warn('unknown instrumentation type:', type);
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(handler) {
	    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
	        return;
	    }
	    handlers[handler.type] = handlers[handler.type] || [];
	    handlers[handler.type].push(handler.callback);
	    instrument(handler.type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleLevel) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleLevel) {
	                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
	    var requestKeys = [];
	    var requestValues = [];
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            };
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        if (xhr.__sentry_xhr__) {
	                            xhr.__sentry_xhr__.status_code = xhr.status;
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    try {
	                        var requestPos = requestKeys.indexOf(xhr);
	                        if (requestPos !== -1) {
	                            // Make sure to pop both key and value to keep it in sync.
	                            requestKeys.splice(requestPos);
	                            var args_1 = requestValues.splice(requestPos)[0];
	                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
	                                xhr.__sentry_xhr__.body = args_1[0];
	                            }
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            requestKeys.push(this);
	            requestValues.push(args);
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            return oldOnPopState.apply(this, args);
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
	    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
	    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
	    ['EventTarget', 'Node'].forEach(function (target) {
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        object_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                if (fn && fn.handleEvent) {
	                    if (eventName === 'click') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                    if (eventName === 'keypress') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                }
	                else {
	                    if (eventName === 'click') {
	                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
	                    }
	                    if (eventName === 'keypress') {
	                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
	                    }
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    original.call(this, eventName, fn.__sentry_wrapped__, options);
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	    });
	}
	var debounceDuration = 1000;
	var debounceTimer = 0;
	var keypressTimeout;
	var lastCapturedEvent;
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param name the event name (e.g. "click")
	 * @param handler function that will be triggered
	 * @param debounce decides whether it should wait till another event loop
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function domEventHandler(name, handler, debounce) {
	    if (debounce === void 0) { debounce = false; }
	    return function (event) {
	        // reset keypress timeout; e.g. triggering a 'click' after
	        // a 'keypress' will reset the keypress debounce so that a new
	        // set of keypresses can be recorded
	        keypressTimeout = undefined;
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors). Ignore if we've
	        // already captured the event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        lastCapturedEvent = event;
	        if (debounceTimer) {
	            clearTimeout(debounceTimer);
	        }
	        if (debounce) {
	            debounceTimer = setTimeout(function () {
	                handler({ event: event, name: name });
	            });
	        }
	        else {
	            handler({ event: event, name: name });
	        }
	    };
	}
	/**
	 * Wraps addEventListener to capture keypress UI events
	 * @param handler function that will be triggered
	 * @returns wrapped keypress events handler
	 * @hidden
	 */
	function keypressEventHandler(handler) {
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function (event) {
	        var target;
	        try {
	            target = event.target;
	        }
	        catch (e) {
	            // just accessing event properties can throw an exception in some rare circumstances
	            // see: https://github.com/getsentry/raven-js/issues/838
	            return;
	        }
	        var tagName = target && target.tagName;
	        // only consider keypress events on actual input elements
	        // this will disregard keypresses targeting body (e.g. tabbing
	        // through elements, hotkeys, etc)
	        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
	            return;
	        }
	        // record first keypress in a series, but ignore subsequent
	        // keypresses until debounce clears
	        if (!keypressTimeout) {
	            domEventHandler('input', handler)(event);
	        }
	        clearTimeout(keypressTimeout);
	        keypressTimeout = setTimeout(function () {
	            keypressTimeout = undefined;
	        }, debounceDuration);
	    };
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        // eslint-disable-next-line no-prototype-builtins
	        if (!obj.hasOwnProperty(prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(232);
	var syncpromise_1 = __webpack_require__(368);
	/** A simple queue that holds promises. */
	var PromiseBuffer = /** @class */ (function () {
	    function PromiseBuffer(_limit) {
	        this._limit = _limit;
	        /** Internal set of queued Promises */
	        this._buffer = [];
	    }
	    /**
	     * Says if the buffer is ready to take more requests
	     */
	    PromiseBuffer.prototype.isReady = function () {
	        return this._limit === undefined || this.length() < this._limit;
	    };
	    /**
	     * Add a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns The original promise.
	     */
	    PromiseBuffer.prototype.add = function (task) {
	        var _this = this;
	        if (!this.isReady()) {
	            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        if (this._buffer.indexOf(task) === -1) {
	            this._buffer.push(task);
	        }
	        task
	            .then(function () { return _this.remove(task); })
	            .then(null, function () {
	            return _this.remove(task).then(null, function () {
	                // We have to add this catch here otherwise we have an unhandledPromiseRejection
	                // because it's a new Promise chain.
	            });
	        });
	        return task;
	    };
	    /**
	     * Remove a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    PromiseBuffer.prototype.remove = function (task) {
	        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
	        return removedTask;
	    };
	    /**
	     * This function returns the number of unresolved promises in the queue.
	     */
	    PromiseBuffer.prototype.length = function () {
	        return this._buffer.length;
	    };
	    /**
	     * This will drain the whole queue, returns true if queue is empty or drained.
	     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
	     *
	     * @param timeout Number in ms to wait until it resolves with false.
	     */
	    PromiseBuffer.prototype.drain = function (timeout) {
	        var _this = this;
	        return new syncpromise_1.SyncPromise(function (resolve) {
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            syncpromise_1.SyncPromise.all(_this._buffer)
	                .then(function () {
	                clearTimeout(capturedSetTimeout);
	                resolve(true);
	            })
	                .then(null, function () {
	                resolve(true);
	            });
	        });
	    };
	    return PromiseBuffer;
	}());
	exports.PromiseBuffer = PromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(158);
	var node_1 = __webpack_require__(234);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance) {
	        return undefined;
	    }
	    if (performance.timeOrigin) {
	        return performance.timeOrigin;
	    }
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    return (performance.timing && performance.timing.navigationStart) || Date.now();
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	/* The following list is defined in React's core */
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	module.exports = function(name, value) {
	  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	"use strict";
	
	function noop() {
	  return null;
	}
	
	noop.isRequired = noop;
	
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  empty: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  predicate: noopThunk,
	  range: noopThunk,
	  ref: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringEndsWith: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(98);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _routes = __webpack_require__(1023);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(646);
	
	var _reduxThunk = __webpack_require__(3607);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _RootReducer = __webpack_require__(1012);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SentryClient = __webpack_require__(439);
	SentryClient.init();
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var store = (0, _redux.createStore)(_RootReducer.rootReducer, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	
	(0, _reactDom.render)(_react2.default.createElement(
		_reactRedux.Provider,
		{ store: store },
		_react2.default.createElement(
			_reactRouterDom.BrowserRouter,
			null,
			_routes2.default
		)
	), document.getElementById('app'));

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Owlvatar = __webpack_require__(115);
	var HouseModal = __webpack_require__(387);
	
	var HouseAvatar = function (_React$Component) {
		_inherits(HouseAvatar, _React$Component);
	
		function HouseAvatar(props) {
			_classCallCheck(this, HouseAvatar);
	
			var _this = _possibleConstructorReturn(this, (HouseAvatar.__proto__ || Object.getPrototypeOf(HouseAvatar)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(HouseAvatar, [{
			key: "getConstraints",
			value: function getConstraints(maxWidth, maxHeight) {
				var constraints = {};
				if (maxWidth) {
					constraints.width = maxWidth + "px";
				};
				if (maxHeight) {
					constraints.height = maxHeight + "px";
				};
				constraints.cursor = "pointer";
				return constraints;
			}
		}, {
			key: "showInterior",
			value: function showInterior() {
				this.refs.houseModal.show();
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
				var imagePath = __webpack_require__(354)("./" + this.props.student.perks.houses.toLowerCase().replace(/ /g, "-").replace("'", "") + ".png");
				var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight);
	
				var houseModal = React.createElement(HouseModal, { ref: "houseModal", student: student,
					currentStudent: this.props.currentStudent });
	
				return React.createElement(
					"div",
					null,
					React.createElement("img", { src: imagePath, onClick: this.showInterior, className: "owlHouse", style: constraints }),
					houseModal
				);
			}
		}]);
	
		return HouseAvatar;
	}(React.Component);
	
	;
	
	HouseAvatar.propTypes = StrictPropTypes({
		// Data on the student
		student: PropTypes.object.isRequired,
	
		// Data on a visiting student
		currentStudent: PropTypes.object,
	
		// Capped dimensions
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number
	});
	
	module.exports = HouseAvatar;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3618);
	
	var PhotoBooth = __webpack_require__(780);
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	var CoinDisplay = __webpack_require__(121);
	
	var html2canvas = __webpack_require__(3505);
	
	var PhotoBackgrounds = __webpack_require__(999);
	var PhotoCaptions = __webpack_require__(1000);
	var Tiers = __webpack_require__(108);
	var CurrentUser = __webpack_require__(3);
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	var ClassPageRouting = __webpack_require__(256);
	
	var OwlPhotosDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			currentUser: CurrentUser.get(),
			loading: OwlShopSelectors.isLoadingPhotographs({ state: state, key: "create" })
		};
	}, function (dispatch, props) {
		return {
			createPhotograph: function createPhotograph(image) {
				return dispatch(OwlShopActions.createPhotograph({
					photograph: { image: image }
				})).then(function () {
					CurrentUser.fetchCurrentUserData();
					return Promise.resolve();
				});
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(OwlPhotosDisplay, _React$Component);
	
		function OwlPhotosDisplay(props) {
			_classCallCheck(this, OwlPhotosDisplay);
	
			var _this = _possibleConstructorReturn(this, (OwlPhotosDisplay.__proto__ || Object.getPrototypeOf(OwlPhotosDisplay)).call(this));
	
			_this.selectBackground = function (background) {
				_this.setState({ selectedBackground: background });
			};
	
			_this.renderMain = function () {
				var background = _this.backgroundsImages()[_this.state.backgroundIndex];
				var caption = _this.photoCaptions()[_this.state.captionIndex];
	
				var mainDisplay = React.createElement(
					"div",
					null,
					React.createElement(PhotoBooth, { width: 350,
						avatarPos: _this.state.avatarPos,
						avatarSize: _this.state.avatarSize,
						background: background, caption: caption,
						placeOwlCenter: _this.placeOwlCenter })
				);
				return React.createElement(
					"div",
					{ className: "photos", style: { background: _this.state.selectedBackground ? "inherit" : "" } },
					mainDisplay
				);
			};
	
			_this.renderControls = function () {
				return React.createElement(
					"div",
					{ className: "controls" },
					_this.renderPhotoControls()
				);
			};
	
			_this.isSelected = function (background) {
				return _this.state.selectedBackground == background;
			};
	
			_this.renderPhotoControls = function () {
				var isSelected;
	
				var backgrounds = React.createElement(
					"div",
					{ className: "controlSection backgrounds" },
					React.createElement(
						"p",
						{ className: "controlHeader" },
						"Backgrounds"
					),
					_this.renderCarousel(_this.backgroundsImages(), "backgroundIndex", 3)
				);
				var caption = React.createElement(
					"div",
					{ className: "controlSection caption" },
					React.createElement(
						"p",
						{ className: "controlHeader" },
						"Caption"
					),
					_this.renderCarousel(_this.photoCaptions(), "captionIndex", 1)
				);
				var owlControl = React.createElement(
					"div",
					{ className: "controlSection xyControl owlControl" },
					React.createElement(
						"p",
						{ className: "controlHeader" },
						"Position"
					),
					React.createElement(
						"div",
						{ className: "positionControl" },
						React.createElement(
							"button",
							{ className: "btn btn-link arrow left", onClick: _this.toggleAvatarPos.bind(_this, -1, 0) },
							React.createElement(Glyphicon, { icon: "arrow-left" })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow up", onClick: _this.toggleAvatarPos.bind(_this, 0, -1) },
							React.createElement(Glyphicon, { icon: "arrow-up" })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow down", onClick: _this.toggleAvatarPos.bind(_this, 0, 1) },
							React.createElement(Glyphicon, { icon: "arrow-down" })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow right", onClick: _this.toggleAvatarPos.bind(_this, 1, 0) },
							React.createElement(Glyphicon, { icon: "arrow-right" })
						)
					)
				);
				var owlSize = React.createElement(
					"div",
					{ className: "controlSection owlControl" },
					React.createElement(
						"p",
						{ className: "controlHeader" },
						"Size"
					),
					React.createElement(
						"div",
						{ className: "positionControl" },
						React.createElement(
							"button",
							{ className: "btn btn-link arrow" },
							React.createElement(Glyphicon, { icon: "minus-sign", onClick: _this.toggleAvatarSize.bind(_this, -1) })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow" },
							React.createElement(Glyphicon, { icon: "plus-sign", onClick: _this.toggleAvatarSize.bind(_this, 1) })
						)
					)
				);
	
				var cost = Tiers.getQunitXValue("take_photo", _this.props.currentUser.tier);
	
				if (_this.props.currentUser.coins < cost) {
					var userCostMessage = ". You only have " + _this.props.currentUser.coins + " coins!";
				}
	
				var priceInfo = React.createElement(
					"p",
					null,
					"Taking a photo costs ",
					React.createElement(CoinDisplay, { coins: cost, height: 20 }),
					userCostMessage
				);
				var addPhotoControls = React.createElement(
					"div",
					{ className: "addPhotoControls" },
					backgrounds,
					caption,
					owlControl,
					owlSize,
					React.createElement(
						"div",
						{ className: "text-center" },
						priceInfo,
						React.createElement(LoadingButton, { text: "Snap My Photo!", className: "btn buttonPrimary",
							disabled: _this.props.currentUser.coins < cost || _this.state.disabledButton,
							onClick: _this.takePhoto, loading: _this.props.loading })
					)
				);
				return React.createElement(
					"div",
					null,
					addPhotoControls
				);
			};
	
			autobind(_this);
	
			_this.state = {
				backgroundIndex: Math.floor(Math.random() * _this.backgroundsImages().length),
				captionIndex: Math.floor(Math.random() * _this.photoCaptions().length),
				avatarSize: 140,
				avatarPos: { top: 0, left: 0 },
				disabledButton: true
			};
			return _this;
		}
	
		_createClass(OwlPhotosDisplay, [{
			key: "backgroundsImages",
			value: function backgroundsImages() {
				return _.pluck(PhotoBackgrounds.IMAGES, "path");
			}
		}, {
			key: "photoCaptions",
			value: function photoCaptions() {
				return _.pluck(PhotoCaptions.CAPTIONS, "text");
			}
		}, {
			key: "shiftCarousel",
			value: function shiftCarousel(indexKey, dir, list_len) {
				var index = this.state[indexKey];
				if (dir == "random") {
					index = Math.floor(Math.random() * list_len);
				} else {
					index += dir;
				}
				if (index >= list_len) {
					index = 0;
				} else if (index < 0) {
					index = list_len - 1;
				}
				var newState = {};
				newState[indexKey] = index;
				this.setState(newState);
			}
		}, {
			key: "renderCarousel",
			value: function renderCarousel(list, indexKey, itemN) {
				var index = this.state[indexKey];
	
				if (itemN > 1) {
					var indexes = [index - 1, index, index + 1];
				} else {
					var indexes = [index];
				}
	
				var carouselItems = _.map(indexes, function (i) {
					if (i < 0) {
						i = list.length - 1;
					} else if (i >= list.length) {
						i = 0;
					}
					var imagePath = list[i];
					if (indexKey == "backgroundIndex") {
						var item = React.createElement("img", { style: { width: "100%", "height": "100%" }, src: imagePath });
					} else if (indexKey == "captionIndex") {
						var item = imagePath;
					}
					return React.createElement(
						"div",
						{ key: i, className: "carouselItem text-center " + (i == index ? "bg selected" : "bg") },
						item
					);
				});
	
				return React.createElement(
					"div",
					{ className: "carousel" },
					carouselItems,
					React.createElement(
						"div",
						{ className: "carouselControl" },
						React.createElement(
							"button",
							{ className: "btn btn-link arrow",
								onClick: this.shiftCarousel.bind(this, indexKey, -1, list.length) },
							React.createElement(Glyphicon, { icon: "arrow-left" })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow",
								onClick: this.shiftCarousel.bind(this, indexKey, "random", list.length) },
							React.createElement(Glyphicon, { icon: "random" })
						),
						React.createElement(
							"button",
							{ className: "btn btn-link arrow",
								onClick: this.shiftCarousel.bind(this, indexKey, 1, list.length) },
							React.createElement(Glyphicon, { icon: "arrow-right" })
						)
					)
				);
			}
		}, {
			key: "toggleAvatarPos",
			value: function toggleAvatarPos(w, h) {
				var owlSize = this.getRefSize($("#boothAvatar"));
				var imageSize = this.getRefSize($("#boothImage"));
	
				var step = imageSize.w * 0.05;
	
				w = w * step;
				h = h * step;
	
				var pos = this.state.avatarPos;
				var newLeft = pos.left + w;
				var newTop = pos.top + h;
	
				if (newLeft < 3) {
					newLeft = 3;
				} else if (newLeft + owlSize.w > imageSize.w - 3) {
					newLeft = imageSize.w - 3 - owlSize.w;
				}
	
				if (newTop < 3) {
					newTop = 3;
				} else if (newTop + owlSize.h > imageSize.h - 3) {
					newTop = imageSize.h - 3 - owlSize.h;
				}
				var avatarPos = { top: newTop, left: newLeft };
	
				this.setState({ avatarPos: avatarPos });
			}
		}, {
			key: "toggleAvatarSize",
			value: function toggleAvatarSize(size) {
				var MIN_AVATAR_SIZE = 75;
				var MAX_AVATAR_SIZE = 200;
	
				var imageSize = this.getRefSize($("#boothAvatar"));
	
				var step = imageSize.w * 0.1;
				size = step * size;
				var newSize = this.state.avatarSize + size;
	
				if (newSize < MIN_AVATAR_SIZE) {
					newSize = MIN_AVATAR_SIZE;
				}
				if (newSize > MAX_AVATAR_SIZE) {
					newSize = MAX_AVATAR_SIZE;
				}
	
				this.setState({ avatarSize: newSize }, this.toggleAvatarPos.bind(this, 0, 0));
			}
		}, {
			key: "takePhoto",
			value: function takePhoto() {
				var _this2 = this;
	
				// Needs to be at top of page and hide the scrollback, for some stupid reason
				window.scrollTo(0, 0);
				document.body.style.overflow = 'hidden';
	
				this.setState({ disabledButton: true });
	
				var element = $("#polaroid .inner")[0];
				html2canvas(element, { width: $(element).width() }).then(function (canvas) {
					var originalDataURL = canvas.toDataURL();
	
					var imageFile = window.imageCompression.getFilefromDataUrl(originalDataURL).then(function (imageFile) {
						var options = {
							maxSizeMB: 0.7
						};
	
						window.imageCompression(imageFile, options).then(function (compressedBlob) {
							window.imageCompression.getDataUrlFromFile(compressedBlob).then(function (compressedDataURL) {
	
								_this2.props.createPhotograph(compressedDataURL).then(function () {
									$wr.redirect(ClassPageRouting.getPath({
										activeView: ClassPageRouting.VIEWS.PHOTO_VIEW
									}));
								});
							});
						});
					});
	
					// document.body.appendChild(canvas);
	
					document.body.style.overflow = 'visible';
				});
			}
		}, {
			key: "getRefSize",
			value: function getRefSize(element) {
				var width = element.width();
				var height = element.height();
				return { w: width, h: height };
			}
		}, {
			key: "placeOwlCenter",
			value: function placeOwlCenter() {
				var owlSize = this.getRefSize($("#boothAvatar"));
				var imageSize = this.getRefSize($("#boothImage"));
	
				var owlWMidePoint = owlSize.w / 2.0;
				var owlHMidePoint = owlSize.h / 2.0;
				var imageWMidePoint = imageSize.w / 2.0;
				var imageHMidePoint = imageSize.h / 2.0;
	
				this.setState({ avatarPos: { top: imageHMidePoint - owlHMidePoint, left: imageWMidePoint - owlHMidePoint } });
			}
		}, {
			key: "renderCurtain",
			value: function renderCurtain() {
				var openingTime = $wr.getShopOpeningTime(this.props.currentUser);
				var src = __webpack_require__(150);
				var patchImg = React.createElement("img", { src: src, className: "lockImg" });
				if (openingTime != "Never") {
					var openingDetails = "It will open today at " + openingTime;
				}
				return React.createElement(
					"div",
					{ className: "curtain" },
					React.createElement(
						"div",
						null,
						patchImg
					),
					React.createElement(
						"p",
						null,
						"Your teacher has closed the Owlstagram. ",
						React.createElement("br", null),
						openingDetails
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var openClass = "";
				if (this.props.currentUser && !$wr.shouldShopOpen(this.props.currentUser)) {
					openClass = "closedShop";
					var curtain = this.renderCurtain();
				} else {
					var curtain = React.createElement("div", null);
				}
				var main = this.renderMain();
				var controls = this.renderControls();
				return React.createElement(
					"div",
					{ className: "owlPhotosContainer" },
					curtain,
					React.createElement(
						"div",
						{ className: openClass },
						main,
						controls
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this3 = this;
	
				$wr.loadScript("/dependencies/browserImageCompression.js", "imageCompression", function () {
					_this3.setState({ disabledButton: false });
				});
			}
		}]);
	
		return OwlPhotosDisplay;
	}(React.Component)) || _class);
	
	
	OwlPhotosDisplay.WrappedComponent.propTypes = PageStrictPropTypes({
		currentUser: PropTypes.object,
		loading: PropTypes.bool,
		createPhotograph: PropTypes.func
	});
	
	module.exports = OwlPhotosDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3619);
	
	var OwlShopColorPicker = function (_React$Component) {
		_inherits(OwlShopColorPicker, _React$Component);
	
		function OwlShopColorPicker(props) {
			_classCallCheck(this, OwlShopColorPicker);
	
			var _this = _possibleConstructorReturn(this, (OwlShopColorPicker.__proto__ || Object.getPrototypeOf(OwlShopColorPicker)).call(this));
	
			autobind(_this);
			_this.state = {
				expanded: false
			};
			return _this;
		}
	
		_createClass(OwlShopColorPicker, [{
			key: "buildSelectF",
			value: function buildSelectF(colorIndex) {
				return function () {
					this.props.selectColor(colorIndex, this.props.patchType);
				}.bind(this);
			}
		}, {
			key: "expand",
			value: function expand() {
				this.setState({ expanded: true });
			}
		}, {
			key: "render",
			value: function render() {
				var defaultMod = Math.floor(OwlShopColorPicker.COLOR_COUNT / OwlShopColorPicker.DEFAULT_COLOR_COUNT);
	
				var swatches = _.map(OwlShopColorPicker.COLORS, function (color, index) {
					return React.createElement("span", { className: "swatch", style: { background: color },
						onClick: this.buildSelectF(index), key: color });
				}.bind(this));
	
				if (!this.state.expanded) {
					swatches = _.select(swatches, function (swatch, index) {
						return index % defaultMod == 0;
					});
	
					swatches.push(React.createElement(
						"span",
						{ className: "swatch", onClick: this.expand, key: "expand" },
						React.createElement(Glyphicon, { icon: "plus" })
					));
				}
	
				return React.createElement(
					"div",
					{ className: "owlShopColorPicker" },
					swatches
				);
			}
		}]);
	
		return OwlShopColorPicker;
	}(React.Component);
	
	;
	
	OwlShopColorPicker.COLOR_COUNT = 30;
	OwlShopColorPicker.DEFAULT_COLOR_COUNT = 6;
	
	OwlShopColorPicker.COLORS = ["#ED1C24", "#F23929", "#FF5D28", "#FF8E35", "#FFBE43", "#FFEE52", "#D9FE56", "#A3FE55", "#6AFE54", "#38EC51", "#00FE53", "#00EC5E", "#00FE78", "#00ED99", "#00FFC5", "#00EDE0", "#00DEFB", "#00A8E7", "#007EF6", "#1857E4", "#0F2AF4", "#3B2AE3", "#652AE3", "#8E29E3", "#BF20F5", "#F01DF5", "#FF16D7", "#FF0BA8", "#FF007A", "#F21654"];
	
	OwlShopColorPicker.propTypes = StrictPropTypes({
		// Color value from 0 to COLOR_COUNT - 1
		currentColor: PropTypes.number.isRequired,
	
		patchType: PropTypes.string.isRequired,
		selectColor: PropTypes.func.isRequired
	});
	
	module.exports = OwlShopColorPicker;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class, _class2, _temp, _initialiseProps;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	
	var DisplayToggleControl = __webpack_require__(48);
	var CurrentUser = __webpack_require__(3);
	var CoinDisplay = __webpack_require__(121);
	var LoadingButton = __webpack_require__(17);
	var ReactTooltip = __webpack_require__(12);
	var Owlvatar = __webpack_require__(115);
	var StudentAvatar = __webpack_require__(35);
	var OwlShopPatcher = __webpack_require__(238);
	
	var OwlShopRouting = __webpack_require__(92);
	
	var Tiers = __webpack_require__(108);
	var TierRequirementsDisplay = __webpack_require__(390);
	var HouseModal = __webpack_require__(387);
	var AnimationModal = __webpack_require__(775);
	var ShopSales = __webpack_require__(123);
	var OwlPhotosDisplay = __webpack_require__(730);
	
	__webpack_require__(3621);
	
	var OwlShopPage = (_dec = (0, _LocationState.provideLocationState)(OwlShopRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
			filteredPerks: OwlShopSelectors.getFilteredPerks({ state: state }),
			allFurnitures: OwlShopSelectors.getFurnitures({ state: state }),
			user: CurrentUser.get()
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return Promise.all([dispatch(OwlShopActions.fetchPatches()), dispatch(OwlShopActions.fetchPerks()), dispatch(OwlShopActions.fetchFurnitures())]);
			},
			updateAvatar: function updateAvatar(_ref) {
				var id = _ref.id,
				    update = _ref.update,
				    embeds = _ref.embeds,
				    query = _ref.query;
				return dispatch(OwlShopActions.updateAvatar({ id: id, update: update, embeds: embeds, query: query }));
			},
			updateCurrentUser: function updateCurrentUser(callback) {
				return CurrentUser.fetchCurrentUserData(callback);
			},
			fetchPerks: function fetchPerks() {
				return dispatch(OwlShopActions.fetchPerks());
			},
			fetchPatches: function fetchPatches() {
				return dispatch(OwlShopActions.fetchPatches());
			}
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
		_inherits(OwlShopPage, _React$Component);
	
		function OwlShopPage(props) {
			_classCallCheck(this, OwlShopPage);
	
			var _this = _possibleConstructorReturn(this, (OwlShopPage.__proto__ || Object.getPrototypeOf(OwlShopPage)).call(this));
	
			_initialiseProps.call(_this);
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("OwlShopPage");
	
			var avatar = props.user.avatar;
	
			var startPatchType = _this.hideOwls(props.user) ? null : "head";
			var startOtherType = _this.hideOwls(props.user) ? "titles" : null;
	
			// parses url to get preview item from golden egg modal
			if ($wr.getURLParameterByName("itemName") && $wr.getURLParameterByName("itemType")) {
				var itemName = $wr.getURLParameterByName("itemName");
				var itemType = $wr.getURLParameterByName("itemType");
				// preview patch
				if ($wr.getURLParameterByName("patch")) {
					startPatchType = itemType;
					startOtherType = null;
					// preview furniture
				} else if ($wr.getURLParameterByName("furniture")) {
					var furnitureName = itemName;
					var furnitureType = itemType;
					//preview perk
				} else {
					startOtherType = itemType;
					startPatchType = null;
				}
			}
	
			_this.state = {
				equippedPatches: avatar.patches,
				colors: avatar.colors,
				previewFurnitureName: furnitureName ? furnitureName : null,
				previewFurnitureType: furnitureType ? furnitureType : null,
				previewItemName: itemName ? itemName : null,
				previewItemType: itemType ? itemType : null,
				loading: false,
				allFurnitures: [],
				activePatchType: startPatchType,
				activeOtherType: startOtherType,
				activeRoom: "trophy",
				beginAtTier: false
			};
	
			return _this;
		}
	
		_createClass(OwlShopPage, [{
			key: "setEquippedPatches",
			value: function setEquippedPatches(patches) {
				this.setState({ equippedPatches: patches });
			}
		}, {
			key: "setColors",
			value: function setColors(colors) {
				this.setState({ colors: colors });
			}
		}, {
			key: "setPreviewItem",
			value: function setPreviewItem(name, type) {
				this.setState({ previewItemName: name, previewItemType: type });
			}
		}, {
			key: "setActiveType",
			value: function setActiveType(pType, oType) {
				this.setState({ activePatchType: pType, activeOtherType: oType });
			}
		}, {
			key: "requiresSave",
			value: function requiresSave() {
				if (this.props.user == undefined) {
					return false;
				}
				var oldAvatar = this.props.user.avatar;
				var updated = false;
	
				_.each(this.state.equippedPatches, function (patch, patchType) {
					if (patch.name != oldAvatar.patches[patchType].name) {
						updated = true;
					}
				});
	
				_.each(oldAvatar.patches, function (patch, patchType) {
					if (this.state.equippedPatches[patchType] == undefined || patch.name != this.state.equippedPatches[patchType].name) {
						updated = true;
					}
				}.bind(this));
	
				_.each(this.state.colors, function (color, patchType) {
					if (color != oldAvatar.colors[patchType]) {
						updated = true;
					}
				});
	
				return updated;
			}
		}, {
			key: "getPreviewItem",
			value: function getPreviewItem() {
				if (this.state.activePatchType) {
					return _.find(this.props.filteredPatches, function (patch) {
						return patch.name == this.state.previewItemName && patch.patch_type == this.state.activePatchType;
					}.bind(this));
				} else {
					return _.find(this.props.filteredPerks, function (perk) {
						return perk.name == this.state.previewItemName && perk.perk_type == this.state.activeOtherType;
					}.bind(this));
				}
			}
		}, {
			key: "previewAnimation",
			value: function previewAnimation(name) {
				this.setState({ previewAnimationName: name });
				this.refs.animationModal.show();
			}
		}, {
			key: "saveAvatar",
			value: function saveAvatar() {
				var _this2 = this;
	
				var avatarData = {
					patches: this.state.equippedPatches,
					colors: this.state.colors
				};
				var avatarID = this.props.user.avatar.id;
				this.setState({ loading: true });
	
				this.props.updateAvatar({ id: avatarID, update: _extends({}, avatarData) }).then(function (result) {
					_this2.setState({ loading: false });
					_this2.handleAvatarUpdated(result.avatar);
				});
			}
		}, {
			key: "buildItemTypeSelectF",
			value: function buildItemTypeSelectF(patchType, otherType) {
				return function (e) {
					$wr.nope(e);
					this.setState({
						activePatchType: patchType,
						activeOtherType: otherType,
						previewItemName: null,
						previewItemType: null
					});
	
					Mycroft.newEvent({
						category: "Owl Shop",
						action: "select-category",
						label: patchType || otherType
					});
				}.bind(this);
			}
	
			// to keep category selector highlighted correctly in hand and body special cases
	
		}, {
			key: "isActivePatchType",
			value: function isActivePatchType(patchType) {
				var activePatchType = this.state.activePatchType;
				if (activePatchType == "left_hand" || activePatchType == "hand" || activePatchType == "wings") {
					return patchType == "left_hand";
				} else if (activePatchType == "body" || activePatchType == "body2") {
					return patchType == "body";
				} else {
					return patchType == activePatchType;
				}
			}
		}, {
			key: "renderCategorySelector",
			value: function renderCategorySelector(text, patchType, otherType) {
				if (patchType) {
					var onClick = this.buildItemTypeSelectF(patchType, null);
				} else {
					var onClick = this.buildItemTypeSelectF(null, otherType);
				}
				if (this.state.activePatchType && this.isActivePatchType(patchType)) {
					var categoryClass = "selector selectedPatchType";
				} else {
					if (this.state.activeOtherType && this.state.activeOtherType == otherType) {
						var categoryClass = "selector selectedPatchType";
					} else {
						var categoryClass = "selector";
					}
				}
	
				return React.createElement(
					"a",
					{ href: "#", className: categoryClass, onClick: onClick },
					React.createElement("img", { src: dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png") }),
					React.createElement(
						"span",
						{ className: "categoryTitle" },
						text
					)
				);
			}
		}, {
			key: "renderOwlvatar",
			value: function renderOwlvatar() {
				if (this.hideOwls(this.props.user)) {
					return React.createElement(StudentAvatar, { student: this.props.user, maxWidth: 175 });
				}
				var patches = {};
				var previewPatch = this.getPreviewItem();
	
				_.each(this.state.equippedPatches, function (patch, patchType) {
					if (previewPatch && patchType == this.state.previewItemType && previewPatch.tier <= this.props.user.tier + 1) {
						patches[patchType] = previewPatch;
					} else {
						patches[patchType] = patch;
					}
				}.bind(this));
	
				return React.createElement(Owlvatar, { patches: patches, colors: this.state.colors, maxWidth: 280 });
			}
	
			// gets the number of items needed to level up
	
		}, {
			key: "getRemainingReqsCount",
			value: function getRemainingReqsCount(patches, perks, furnitures) {
				var tier = this.props.user.tier;
				var reqs = Tiers.REQUIREMENTS[tier];
	
				var remainingReqs = $wr.getRemainingReqs(tier, reqs, patches, perks, furnitures);
	
				var remaining = 0;
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = Object.entries(remainingReqs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _step$value = _slicedToArray(_step.value, 2),
						    objType = _step$value[0],
						    reqs = _step$value[1];
	
						remaining += reqs;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				return remaining;
			}
		}, {
			key: "renderTierRequirements",
			value: function renderTierRequirements() {
				var tierColor = Tiers.getColor(this.props.user.tier);
				var currentTier = this.props.user.tier.toString();
				if (!this.hideOwls(this.props.user) && Tiers.isSupportedTier(currentTier)) {
					var tierReqs = Tiers.getRequirements(currentTier);
					var ownedPatches = _.select(this.props.filteredPatches, function (patch) {
						return patch.owned && patch.source == "store";
					});
					var ownedPerks = _.select(this.props.filteredPerks, function (perk) {
						return perk.owned && perk.source == "store";
					});
					var ownedFurnitures = _.select(this.props.allFurnitures, function (furniture) {
						return furniture.owned && furniture.source == "store";
					});
	
					var remainingReqsCount = this.getRemainingReqsCount(this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures);
	
					// add explanations to the tier reqs display
					var reqsDescriptionTop = React.createElement(
						"p",
						{ className: "reqsDescriptionTop" },
						"Buy ",
						remainingReqsCount,
						" more items to level up:"
					);
					var reqsDescriptionBottom = React.createElement(
						"p",
						{ className: "reqsDescriptionBottom", style: { color: tierColor } },
						"You can afford items in the highlighted categories!"
					);
	
					return React.createElement(
						"div",
						{ className: "currentTierReqs" },
						reqsDescriptionTop,
						React.createElement(TierRequirementsDisplay, {
							requirements: tierReqs,
							tier: currentTier,
							toggleRoom: this.toggleRoom.bind(this),
							ownedPatches: ownedPatches,
							ownedPerks: ownedPerks,
							ownedFurnitures: ownedFurnitures,
							toggleCategory: this.toggleCategory.bind(this),
							beginAtTier: this.beginAtTier,
							filteredPatches: this.props.filteredPatches,
							filteredPerks: this.props.filteredPerks,
							allFurnitures: this.props.allFurnitures,
							coins: this.props.user.coins
						}),
						reqsDescriptionBottom
					);
				}
			}
	
			//if true, skips to page with items at the user's tier
	
		}, {
			key: "beginAtTier",
			value: function beginAtTier(value, callback) {
				if (value) {
					this.setState({ beginAtTier: value });
				}
			}
	
			// switches item type when a tier req square is clicked
	
		}, {
			key: "toggleCategory",
			value: function toggleCategory(category, type, callback) {
				if (category == "perk") {
					if (type == "houses") {
						this.setState({ activePatchType: null, activeOtherType: "houses" });
					} else {
						this.setState({ activePatchType: null, activeOtherType: "titles" });
					}
				} else if (category == "patch") {
					this.setState({ activePatchType: type, activeOtherType: null });
				} else {
					this.setState({ activePatchType: null, activeOtherType: "titles" });
					this.toggleRoom(type);
				}
			}
		}, {
			key: "toggleRoom",
			value: function toggleRoom(value, callback) {
				this.setState({ activeRoom: value }, this.openTrophyRoom);
			}
		}, {
			key: "openTrophyRoom",
			value: function openTrophyRoom() {
				this.refs.houseModal.show();
			}
		}, {
			key: "switchActiveView",
			value: function switchActiveView(view) {
				$wr.redirect(OwlShopRouting.getPath(_extends({}, this.props.locationState, {
					activeView: view
				})));
				//make sure background and owlshop/owlstagram toggle their styles
				//correctly when flipping between them.
				if (view == "shop") {
					$wr.displayBackground(this.props.user.perks.backgrounds);
					if ($wr.hasBackgroundEquipped(this.props.filteredPerks)) {
						$(".displayToggleControl").addClass('withBackground');
					}
				} else {
					if ($wr.hasBackgroundEquipped(this.props.filteredPerks)) {
						$(".displayToggleControl").removeClass('withBackground');
					}
				}
			}
		}, {
			key: "openHouse",
			value: function openHouse() {
				this.setState({ activeRoom: "house" });
				this.openTrophyRoom();
			}
		}, {
			key: "render",
			value: function render() {
				var shouldHideOwls = this.hideOwls(this.props.user);
				if (this.requiresSave()) {
					var saveButton = React.createElement(LoadingButton, {
						onClick: this.saveAvatar,
						loading: this.state.loading,
						className: "btn buttonSuccess saveButton",
						text: "Save"
					});
				}
				if (this.state.activeOtherType == TITLES && this.state.previewItemName) {
					var nameDisplay = this.state.previewItemName + " " + this.props.user.display_name;
				} else {
					var title = $wr.fetchTitle(this.props.user);
					if (title) {
						var nameDisplay = title;
					} else {
						var nameDisplay = this.props.user.display_name;
					}
				}
	
				// previews background
				if (this.state.activeOtherType == BACKGROUNDS && this.state.previewItemName) {
					$(".patcher").addClass("backgroundPatcher");
					$wr.displayBackground(this.state.previewItemName);
				}
	
				var headerText = shouldHideOwls ? "Shop" : "Owl Shop";
				var tierIconTooltipText = "Level " + (this.props.user.tier + 1) + ": " + Tiers.getName(this.props.user.tier);
	
				var toggleOptions = [{ key: OwlShopRouting.VIEWS.SHOP, text: "Shop" }, { key: OwlShopRouting.VIEWS.PHOTOS, text: "Owlstagram" }];
	
				var activeView = this.props.locationState.activeView;
	
				var toggleDisplay = React.createElement(DisplayToggleControl, { options: toggleOptions,
					onChange: this.switchActiveView, className: $wr.hasBackgroundEquipped(this.props.filteredPerks) ? "withBackground" : "",
					activeOptionKey: activeView });
	
				if (this.props.user.perks.houses) {
					var imagePath = __webpack_require__(354)("./" + this.props.user.perks.houses.toLowerCase().replace(/ /g, "-").replace("'", "") + ".png");
					var constraints = { width: "30px", cursor: "pointer" };
					var ownsHouse = true;
	
					var houseAvatar = React.createElement(
						"div",
						{ className: "houseAvatar" },
						React.createElement("img", { src: imagePath,
							"data-tip": "See inside home",
							onClick: this.openHouse,
							style: constraints })
					);
				} else {
					// student doesn't own a house yet
					var ownsHouse = false;
				}
	
				if (activeView == OwlShopRouting.VIEWS.SHOP) {
					var patcherDisplay = "";
					if ($wr.hasBackgroundEquipped(this.props.filteredPerks)) {
						patcherDisplay = ' backgroundPatcher';
						$(".displayToggleControl").addClass('withBackground');
					}
	
					var contentDisplay = React.createElement(
						"div",
						null,
						React.createElement(
							"div",
							{ className: "row" },
							React.createElement(
								"div",
								{ className: "col-sm-4" },
								React.createElement(
									"div",
									{ className: "preview", ref: "preview" },
									React.createElement(
										"div",
										{ className: "previewOwl" },
										this.renderOwlvatar()
									),
									React.createElement("br", null),
									React.createElement(
										"div",
										{ className: "leftControls" },
										React.createElement(
											"div",
											{ className: "nameDisplay" },
											nameDisplay
										),
										React.createElement(
											"div",
											{ className: "detailsGroup" },
											React.createElement(CoinDisplay, { coins: this.props.user.coins, height: 30 }),
											React.createElement("img", {
												src: Tiers.getIcon(this.props.user.tier),
												className: "currentTierImage",
												"data-tip": tierIconTooltipText
											}),
											houseAvatar
										),
										saveButton,
										this.renderTierRequirements(),
										React.createElement(ReactTooltip, { effect: "solid" })
									)
								)
							),
							React.createElement(
								"div",
								{ className: "patcher col-sm-8" + patcherDisplay },
								React.createElement(OwlShopPatcher, {
									mode: "owl_shop",
									equippedPatches: this.state.equippedPatches,
									colors: this.state.colors,
									previewItemName: this.state.previewItemName,
									activePatchType: this.state.activePatchType,
									activeOtherType: this.state.activeOtherType,
									hideOwls: shouldHideOwls,
									setEquippedPatches: this.setEquippedPatches,
									setColors: this.setColors,
									setPreviewItem: this.setPreviewItem,
									setActiveType: this.setActiveType,
									updateCurrentUser: this.props.updateCurrentUser,
									fetchPerks: this.props.fetchPerks,
									fetchPatches: this.props.fetchPatches,
									beginAtTier: this.state.beginAtTier,
									previewAnimation: this.previewAnimation
								})
							)
						),
						React.createElement(_reactRouterDom.Prompt, { message: this.routerWillLeave }),
						React.createElement(HouseModal, {
							ref: "houseModal",
							student: this.props.user,
							activeRoom: this.state.activeRoom,
							allFurnitures: this.props.allFurnitures,
							previewItemName: this.state.previewFurnitureName,
							previewItemType: this.state.previewFurnitureType,
							ownsHouse: ownsHouse
						}),
						React.createElement(AnimationModal, {
							ref: "animationModal",
							student: this.props.user,
							previewAnimation: this.state.previewAnimationName
						})
					);
				} else {
					var contentDisplay = React.createElement(
						"div",
						{ className: "photosContainer" },
						React.createElement(OwlPhotosDisplay, null)
					);
				}
	
				var houseModal = React.createElement(HouseModal, {
					ref: "houseModal",
					student: this.props.user,
					activeRoom: this.state.activeRoom,
					allFurnitures: this.props.allFurnitures,
					previewItemName: this.state.previewFurnitureName,
					previewItemType: this.state.previewFurnitureType,
					ownsHouse: ownsHouse });
	
				var animationModal = React.createElement(AnimationModal, {
					ref: "animationModal",
					student: this.props.user,
					previewAnimation: this.state.previewAnimationName });
	
				return React.createElement(
					"div",
					{ className: "container", id: "owlShopPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							headerText
						)
					),
					toggleDisplay,
					contentDisplay,
					houseModal,
					animationModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				// Note that Chrome (and Firefox?) won't show the custom message
				window.onbeforeunload = this.routerWillLeave;
				$(window).on("scroll", this.onScroll);
	
				// displays background if in the owl shop
				if (this.props.locationState.activeView == "shop") {
					$wr.displayBackground(this.props.user.perks.backgrounds);
				}
				if ($wr.hasBackgroundEquipped(this.props.filteredPerks)) {
					$(".displayToggleControl").removeClass('withBackground');
				}
	
				if ($wr.getURLParameterByName("openTrophyRoom")) {
					this.openTrophyRoom();
	
					// for previewing furniture
				} else if ($wr.getURLParameterByName("furniture")) {
					this.toggleRoom("furniture");
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.onbeforeunload = null;
			}
		}, {
			key: "routerWillLeave",
			value: function routerWillLeave() {
				if (this.requiresSave()) {
					return "You haven't saved changes to your owlvatar. Are you sure you want to leave?";
				}
			}
		}]);
	
		return OwlShopPage;
	}(React.Component), _initialiseProps = function _initialiseProps() {
		var _this3 = this;
	
		this.notifyErrors = function (errors) {
			return window.wrNotifications.triggerDropDownNotification({
				title: "Sorry!",
				text: errors.join(", "),
				icon: "exclamation-sign",
				type: "error"
			});
		};
	
		this.notifyAvatarSaved = function () {
			return window.wrNotifications.triggerDropDownNotification({
				title: "Great!",
				text: "Your Owlvatar has been saved!",
				icon: "ok-sign"
			});
		};
	
		this.handleAvatarUpdated = function (avatar) {
			if (avatar.errors) _this3.notifyErrors(avatar.errors);else {
				_this3.notifyAvatarSaved();
				_this3.props.updateCurrentUser(function () {
					return _this3.forceUpdate();
				});
				Mycroft.newEvent({ category: "Owl Shop", action: "save-avatar" });
			}
		};
	
		this.hideOwls = function (user) {
			return user && user.settings && user.settings.hide_owls;
		};
	}, _temp)) || _class) || _class) || _class);
	
	
	var BACKGROUNDS = "backgrounds";
	var TITLES = "titles";
	var GREETINGS = "greetings";
	
	module.exports = OwlShopPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SponsorAvatar = function (_React$Component) {
		_inherits(SponsorAvatar, _React$Component);
	
		function SponsorAvatar(props) {
			_classCallCheck(this, SponsorAvatar);
	
			var _this = _possibleConstructorReturn(this, (SponsorAvatar.__proto__ || Object.getPrototypeOf(SponsorAvatar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(SponsorAvatar, [{
			key: "render",
			value: function render() {
				var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
				var src = __webpack_require__(1731);
				return React.createElement("img", { src: src, alt: "sponsorAvatar", style: dims });
			}
		}]);
	
		return SponsorAvatar;
	}(React.Component);
	
	;
	
	SponsorAvatar.propTypes = StrictPropTypes({
		// We don't actually use user but we may at some point
		// so we should require it be passed
		sponsor: PropTypes.object.isRequired,
	
		maxWidth: PropTypes.number,
		maxHeight: PropTypes.number
	});
	
	module.exports = SponsorAvatar;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PassageTile = __webpack_require__(374);
	
	__webpack_require__(3624);
	
	var CategoryPicker = function (_React$Component) {
		_inherits(CategoryPicker, _React$Component);
	
		function CategoryPicker(props) {
			_classCallCheck(this, CategoryPicker);
	
			var _this = _possibleConstructorReturn(this, (CategoryPicker.__proto__ || Object.getPrototypeOf(CategoryPicker)).call(this));
	
			if (props.forcePassageType) {
				var defaultType = props.forcePassageType;
			} else if (props.selectedCategory) {
				// If we started off with a category, use that passageType
				var defaultType = props.selectedCategory.passageType;
			} else {
				// Randomize the default passageType
				var defaultType = _.sample([CategoryPicker.FICTION, CategoryPicker.NON_FICTION]);
			}
	
			_this.state = { passageType: defaultType };
			return _this;
		}
	
		_createClass(CategoryPicker, [{
			key: "onCategorySelect",
			value: function onCategorySelect(category, e) {
				if (e) {
					e.preventDefault();
				}
				this.props.onCategorySelect(category);
			}
		}, {
			key: "onPassageTypeSelect",
			value: function onPassageTypeSelect(passageType, e) {
				if (e) {
					e.preventDefault();
				}
				if (passageType == this.state.passageType) {
					return;
				}
	
				this.setState({ passageType: passageType });
	
				if (this.props.selectedCategory) {
					// Most categories have both fiction and nonFiction options. However, some don't.
					// Just in case, if there isn't, we want to set the selected category to null
					var matches = this.matchingCategories(passageType, this.props.selectedCategory.categoryName);
	
					if (matches.length == 0) {
						this.onCategorySelect(null);
					} else {
						this.onCategorySelect(matches[0]);
					}
				}
			}
		}, {
			key: "onPassageSelect",
			value: function onPassageSelect(passage, e) {
				if (e) {
					e.preventDefault();
				}
				this.props.onPassageSelect(passage);
			}
		}, {
			key: "matchingCategories",
			value: function matchingCategories(passageType, categoryName) {
				var categories = _.where(this.props.categories, { "passageType": passageType });
				if (categoryName) {
					categories = _.where(categories, { "categoryName": categoryName });
				}
				return categories;
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var categories = _.sortBy(this.matchingCategories(this.state.passageType), "categoryName");
				var selectedCategory = this.props.selectedCategory;
				var categoryOptions = _.map(categories, function (category) {
					var key = category.categoryName + "-" + category.passageType;
					var catClassName = "bubbleOp";
	
					if (selectedCategory && selectedCategory.categoryName == category.categoryName) {
						catClassName += " active";
					}
					if (_this2.props.getIcon) {
						var icon = React.createElement("img", { src: _this2.props.getIcon(category.categoryName), className: "icon" });
					}
					return React.createElement(
						"a",
						{ href: "#", key: key, className: catClassName,
							onClick: _this2.onCategorySelect.bind(_this2, category) },
						icon,
						category.categoryName
					);
				});
	
				if (this.props.passages && this.props.passages.length > 0) {
					var passageOptions = _.map(this.props.passages, function (passage) {
						return React.createElement(PassageTile, { key: passage.passageId, title: passage.title,
							subCategoryName: passage.subCategory, getIcon: _this2.props.getIcon,
							onClick: _this2.onPassageSelect.bind(_this2, passage),
							categoryName: selectedCategory.categoryName });
					});
	
					var passageOptionSection = React.createElement(
						"div",
						{ className: "passageOptions" },
						passageOptions
					);
				} else if (this.props.passages && this.props.passages.length == 0) {
					var passageOptionSection = React.createElement(
						"div",
						{ className: "passageOptions" },
						React.createElement(
							"div",
							{ className: "passageMessage" },
							"There aren't any options for this category! Please pick a different one."
						)
					);
				} else if (selectedCategory) {
					if (this.props.loadingIndicator) {
						var passageOptionSection = React.createElement(
							"div",
							{ className: "passageOptions" },
							React.createElement(
								"div",
								{ className: "passageMessage" },
								this.props.loadingIndicator
							)
						);
					} else {
						var passageOptionSection = React.createElement(
							"div",
							{ className: "passageOptions" },
							React.createElement(
								"div",
								{ className: "passageMessage" },
								"Loading passages..."
							)
						);
					}
				}
	
				if (!this.props.forcePassageType) {
					var isFiction = this.state.passageType == CategoryPicker.FICTION;
	
					var passageTypePicker = React.createElement(
						"div",
						{ className: "passageTypeOptions" },
						React.createElement(
							"a",
							{ href: "#", className: isFiction ? "bubbleOp active" : "bubbleOp",
								onClick: this.onPassageTypeSelect.bind(this, CategoryPicker.FICTION) },
							"Fiction"
						),
						React.createElement(
							"a",
							{ href: "#", className: isFiction ? "bubbleOp" : "bubbleOp active",
								onClick: this.onPassageTypeSelect.bind(this, CategoryPicker.NON_FICTION) },
							"Non-Fiction"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "Cloze-CategoryPicker" },
					passageTypePicker,
					React.createElement(
						"div",
						{ className: "categoryOptions" },
						categoryOptions
					),
					passageOptionSection
				);
			}
		}]);
	
		return CategoryPicker;
	}(React.Component);
	
	CategoryPicker.FICTION = "Fiction";
	CategoryPicker.NON_FICTION = "NonFiction";
	
	CategoryPicker.propTypes = {
		categories: PropTypes.array.isRequired,
		onCategorySelect: PropTypes.func.isRequired,
		onPassageSelect: PropTypes.func.isRequired,
		selectedCategory: PropTypes.object,
		passages: PropTypes.array,
		getIcon: PropTypes.func,
		loadingIndicator: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	
		forcePassageType: PropTypes.string
	
	};
	
	module.exports = CategoryPicker;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var CATEGORY_MAP = {
		"About Me": __webpack_require__(3889),
		"Animals": __webpack_require__(3892),
		"Fine Arts and Crafts": __webpack_require__(3912),
		"Cars, Trucks &  Other Motor Vehicles": __webpack_require__(3905),
		"Computers": __webpack_require__(3893),
		"Do the Right Thing": __webpack_require__(3895),
		"Family": __webpack_require__(3894),
		"Style & Fashion": __webpack_require__(3901),
		"General": __webpack_require__(3896),
		"Law & Politics": __webpack_require__(3902),
		"Health": __webpack_require__(3891),
		"Places and History": __webpack_require__(3906),
		"Music": __webpack_require__(3908),
		"News Today": __webpack_require__(3909),
		"On Stage and Screen": __webpack_require__(3900),
		"Our Society": __webpack_require__(3907),
		"Religion": __webpack_require__(3897),
		"Science and Math": __webpack_require__(3904),
		"School": __webpack_require__(3903),
		"Spooky Stuff": __webpack_require__(3890),
		"Sports and Games": __webpack_require__(3911),
		"Stories": __webpack_require__(3910),
		"Travel & Transportation": __webpack_require__(661),
		"Travel": __webpack_require__(661),
		"The Earth": __webpack_require__(660),
		"Environment": __webpack_require__(660),
		"Work & Careers": __webpack_require__(353),
		"Work & Jobs": __webpack_require__(353),
		"Business & Industry": __webpack_require__(3898),
		"World of Business": __webpack_require__(353)
	};
	
	var DEFAULT_ICON = __webpack_require__(3899);
	
	var Icons = {
		getIcon: function getIcon(catName) {
			if (catName in CATEGORY_MAP) {
				return CATEGORY_MAP[catName];
			} else {
				return DEFAULT_ICON;
			}
		}
	};
	
	module.exports = Icons;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryPicker = __webpack_require__(734);
	var Passage = __webpack_require__(737);
	var ClozeIcons = __webpack_require__(735);
	
	var Spinner = __webpack_require__(9);
	var StudentClozeStatus = __webpack_require__(881);
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingClozeApi = __webpack_require__(1025);
	
	__webpack_require__(3625);
	
	var ClozePage = function (_React$Component) {
		_inherits(ClozePage, _React$Component);
	
		function ClozePage(props) {
			_classCallCheck(this, ClozePage);
	
			var _this = _possibleConstructorReturn(this, (ClozePage.__proto__ || Object.getPrototypeOf(ClozePage)).call(this));
	
			autobind(_this);
			_this.state = _this.getInitialState();
			return _this;
		}
	
		_createClass(ClozePage, [{
			key: "reset",
			value: function reset() {
				this.setState(this.getInitialState(), this.fetchCategories);
			}
		}, {
			key: "getInitialState",
			value: function getInitialState() {
				return {
					// State used for CategoryPicker
					categories: null, passages: {}, selectedCategory: null,
	
					// State used to display passages
					selectedPassage: null, selectedPassageDetails: null,
	
					// State used in the completion state
					finalLoading: false, postClozeStatus: null
				};
			}
		}, {
			key: "showError",
			value: function showError() {
				if (this.state.postClozeStatus && this.state.postClozeStatus.current > 40) {
					$wr.redirect("/");
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "We're having trouble loading this page",
						text: "Please try refreshing the page or coming back later.",
						icon: "exclamation-sign", type: "error"
					}, 6000);
				}
			}
		}, {
			key: "selectCategory",
			value: function selectCategory(category) {
				this.setState({ selectedCategory: category }, this.fetchPassages);
			}
		}, {
			key: "fetchPassages",
			value: function fetchPassages() {
				var _this2 = this;
	
				var category = this.state.selectedCategory;
				if (category && !(category.categoryName in this.state.passages)) {
					var params = { categories: category.categoryName, passage_type: category.passageType };
	
					this.clozeClient.getPassages(params).then(function (response) {
						var newPassages = _.clone(_this2.state.passages);
						var passageKey = category.categoryName + "-" + category.passageType;
						newPassages[passageKey] = response.passages;
						_this2.setState({ passages: newPassages }, function () {
							$wr.scrollToElement($(_this2.refs.wrap).find(".passageOptions"), 100);
						});
					}).catch(function (error) {
						_this2.showError();
					});
				}
			}
		}, {
			key: "selectPassage",
			value: function selectPassage(passage) {
				var _this3 = this;
	
				// Pick a sample passage at random
				this.setState({ selectedPassage: passage }, function () {
					_this3.clozeClient.getPassage(passage.passageId).then(function (response) {
						if (response.passage) {
							_this3.setState({ selectedPassageDetails: response.passage });
						} else {
							console.error(response);
						}
					}).catch(function (error) {
						_this3.showError();
					});
				});
			}
		}, {
			key: "onPassageComplete",
			value: function onPassageComplete(completionData) {
				var _this4 = this;
	
				var assessment = {
					passage_id: this.state.selectedPassage.passageId,
					completions: completionData
				};
				this.setState({ finalLoading: true });
	
				this.clozeClient.postAssessments({ assessment: assessment }).then(function (response) {
					CurrentUser.fetchCurrentUserCoinData();
					_this4.setState({ finalLoading: false, postClozeStatus: response.status });
				}).catch(function (error) {
					_this4.showError();
				});
			}
		}, {
			key: "getCategoryPassages",
			value: function getCategoryPassages() {
				if (!this.state.selectedCategory) {
					return;
				}
				var passageKey = this.state.selectedCategory.categoryName + "-" + this.state.selectedCategory.passageType;
	
				return this.state.passages[passageKey];
			}
		}, {
			key: "renderCategorySelector",
			value: function renderCategorySelector() {
				return React.createElement(CategoryPicker, { categories: this.state.categories,
					onCategorySelect: this.selectCategory,
					getIcon: ClozeIcons.getIcon,
					loadingIndicator: this.renderPlaceholder(),
					passages: this.getCategoryPassages(), onPassageSelect: this.selectPassage,
					selectedCategory: this.state.selectedCategory });
			}
		}, {
			key: "renderPassage",
			value: function renderPassage() {
				return React.createElement(Passage, { passage: this.state.selectedPassageDetails,
					categoryName: this.state.selectedPassage.mainCategory,
					getIcon: ClozeIcons.getIcon,
					subCategoryName: this.state.selectedPassage.subCategory,
					onPassageComplete: this.onPassageComplete });
			}
		}, {
			key: "renderPlaceholder",
			value: function renderPlaceholder() {
				if (this.state.finalLoading) {
					var errorMessage = "We're submitting your challenge...";
				} else {
					var errorMessage = "Hang tight, we're loading your challenge...";
				}
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "text-center lightGray" },
						errorMessage
					),
					React.createElement(Spinner, { placeholder: true, scale: 1.7 })
				);
			}
		}, {
			key: "renderPostCompletion",
			value: function renderPostCompletion() {
				var status = this.state.postClozeStatus;
				var action = status.current > status.target ? StudentClozeStatus.DONE : StudentClozeStatus.RETAKE;
				return React.createElement(StudentClozeStatus, { status: this.state.postClozeStatus,
					action: action, onAction: this.reset });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.finalLoading) {
					var content = this.renderPlaceholder();
				} else if (this.state.postClozeStatus) {
					var content = this.renderPostCompletion();
				} else if (this.state.selectedPassageDetails) {
					var content = this.renderPassage();
				} else if (this.state.selectedPassage) {
					var content = this.renderPlaceholder();
				} else if (this.state.categories) {
					var content = this.renderCategorySelector();
				} else {
					var content = this.renderPlaceholder();
				}
	
				return React.createElement(
					"div",
					{ className: "clozePage container", ref: "wrap" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Reading Challenge"
						)
					),
					content
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if ($wr.isDevelopment()) {
					this.clozeClient = new WhooosReadingClozeApi.Client("localhost:3002", "http");
				} else if ($wr.isStaging()) {
					this.clozeClient = new WhooosReadingClozeApi.Client("api.savvashortondev.com", "https");
				} else {
					this.clozeClient = new WhooosReadingClozeApi.Client("api.whooosreading.org", "https"); // Uses the default endpoint for the library
				}
				this.clozeClient.addAuth(CurrentUser.getToken());
	
				this.fetchCategories();
			}
		}, {
			key: "fetchCategories",
			value: function fetchCategories() {
				var _this5 = this;
	
				this.clozeClient.getCategories().then(function (response) {
					if (response.diagnostic) {
						_this5.setState({
							selectedPassage: response.passage,
							selectedPassageDetails: response.passage_details
						});
					} else {
						_this5.setState({ categories: response.categories });
					}
				}).catch(function (error) {
					_this5.showError();
				});
			}
		}]);
	
		return ClozePage;
	}(React.Component);
	
	;
	
	ClozePage.propTypes = PageStrictPropTypes({});
	
	module.exports = ClozePage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = __webpack_require__(7);
	
	var PassageTile = __webpack_require__(374);
	__webpack_require__(3626);
	
	var Passage = function (_React$Component) {
		_inherits(Passage, _React$Component);
	
		function Passage(props) {
			_classCallCheck(this, Passage);
	
			var _this = _possibleConstructorReturn(this, (Passage.__proto__ || Object.getPrototypeOf(Passage)).call(this));
	
			_this.state = {
				selectedIndex: null, completions: {},
				footerFixed: false
			};
	
			_this.stickyWrap = React.createRef();
			_this.stickyFooter = React.createRef();
			_this.updateStickyPosition = _this.updateStickyPosition.bind(_this);
			_this.onComplete = _this.onComplete.bind(_this);
			return _this;
		}
	
		_createClass(Passage, [{
			key: "selectClozeItem",
			value: function selectClozeItem(clozeIndex, e) {
				if (e) {
					e.preventDefault();
				}
				this.setState({ selectedIndex: clozeIndex }, this.updateStickyPosition);
			}
		}, {
			key: "isComplete",
			value: function isComplete() {
				var _this2 = this;
	
				var isComplete = true;
				_.each(this.props.passage.clozes, function (clozeData) {
					isComplete = isComplete && clozeData.clozeItemNumber in _this2.state.completions;
				});
				return isComplete;
			}
		}, {
			key: "onComplete",
			value: function onComplete() {
				var _this3 = this;
	
				var completionData = _.map(this.props.passage.clozes, function (clozeData) {
					return {
						clozeItemNumber: clozeData.clozeItemNumber,
						answer: _this3.state.completions[clozeData.clozeItemNumber]
					};
				});
				this.props.onPassageComplete(completionData);
			}
		}, {
			key: "setClozeCompletion",
			value: function setClozeCompletion(word, e) {
				if (e) {
					e.preventDefault();
				}
				var newCompletions = _.clone(this.state.completions);
				newCompletions[this.state.selectedIndex] = word;
				this.setState({ completions: newCompletions });
			}
		}, {
			key: "insertClozeSelectors",
			value: function insertClozeSelectors(text) {
				var _this4 = this;
	
				var parts = text.split("__||__");
				var output = [];
				// Odd indexes will be for clozeIndexes
				_.map(parts, function (item, index) {
					if (index % 2 == 0) {
						output.push(handleWeirdFormatting(item));
					} else {
						var clozeIndex = parseInt(item);
						var showText = _this4.state.completions[clozeIndex] || clozeIndex;
						var className = "clozeItem";
						if (_this4.state.selectedIndex == clozeIndex) {
							className += " selected";
						}
						if (clozeIndex in _this4.state.completions) {
							className += " completed";
						}
						output.push(React.createElement(
							"a",
							{ href: "#", className: className, key: "cloze" + clozeIndex,
								onClick: _this4.selectClozeItem.bind(_this4, clozeIndex) },
							showText
						));
					}
				});
	
				return output;
			}
		}, {
			key: "getPassageContents",
			value: function getPassageContents() {
				var _this5 = this;
	
				var body = stripSpanTags(decodeHtml(this.props.passage.body));
				var paragraphs = _.map(toParagraphs(body), function (text, index) {
					if (text == SECTION_BREAK_MARK) {
						return React.createElement("hr", null);
					} else {
						return React.createElement(
							"p",
							{ key: index },
							_this5.insertClozeSelectors(text)
						);
					}
				});
	
				return React.createElement(
					"div",
					{ className: "passageContents" },
					paragraphs
				);
			}
		}, {
			key: "renderClozeControls",
			value: function renderClozeControls() {
				var _this6 = this;
	
				if (this.state.selectedIndex === null) {
					return null;
				}
				var className = "clozeControls";
				if (this.state.footerFixed) {
					className += " fixed";
				}
	
				// We need to switch from one-indexed to zero-indexed
				var options = this.props.passage.clozes[this.state.selectedIndex - 1].clozeItems;
				var optionSelectors = _.map(options, function (word) {
					var opClassName = "bubbleOp";
					if (_this6.state.completions[_this6.state.selectedIndex] === word) {
						opClassName += " selected";
					}
					return React.createElement(
						"a",
						{ href: "#", key: word, className: opClassName,
							onClick: _this6.setClozeCompletion.bind(_this6, word) },
						word
					);
				});
	
				if (this.isComplete()) {
					// Gives is a className which will mean something with the WR codebase... maybe not ideal
					var completeDisplay = React.createElement(
						"span",
						{ className: "completeDisplay" },
						React.createElement(
							"button",
							{ className: "finishedButton", onClick: this.onComplete },
							"Finish"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: className, ref: this.stickyFooter },
					React.createElement(
						"div",
						{ className: "inner" },
						React.createElement(
							"div",
							{ className: "content" },
							optionSelectors,
							completeDisplay
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var passage = this.props.passage;
				var summary = "";
				return React.createElement(
					"div",
					{ className: "Cloze-Passage" },
					React.createElement(
						"div",
						{ className: "passageHeader" },
						React.createElement(PassageTile, { title: passage.title,
							subCategoryName: this.props.subCategoryName, getIcon: this.props.getIcon,
							categoryName: this.props.categoryName }),
						React.createElement(
							"div",
							{ className: "summary" },
							summary
						),
						React.createElement(
							"div",
							{ className: "instructions" },
							React.createElement(
								"div",
								null,
								"Here's how to complete the challenge:"
							),
							React.createElement(
								"ol",
								null,
								React.createElement(
									"li",
									null,
									"Read the text"
								),
								React.createElement(
									"li",
									null,
									"Click on the missing words as you find them"
								),
								React.createElement(
									"li",
									null,
									"Choose the word that best completes the sentence"
								)
							)
						)
					),
					React.createElement(
						"div",
						{ className: "passageWrap", ref: this.stickyWrap },
						this.getPassageContents(),
						this.renderClozeControls()
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window).on("scroll", this.updateStickyPosition);
				$(window).on("resize", this.updateStickyPosition);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window).off("scroll", this.updateStickyPosition);
				$(window).off("resize", this.updateStickyPosition);
			}
		}, {
			key: "updateStickyPosition",
			value: function updateStickyPosition() {
				if (this.state.selectedIndex === null) {
					return;
				}
				var $wrap = $(this.stickyWrap.current);
				var $footer = $(this.stickyFooter.current);
				var windowHeight = $(window).height();
				var wrapHeight = $wrap.height();
				var footerPadding = $footer.height() + 100;
	
				var windowTopOffest = $(window).scrollTop();
				var wrapTopOffset = $wrap.offset().top;
	
				var footerOffset = wrapTopOffset + wrapHeight - (windowHeight + windowTopOffest);
				if (footerOffset > 0 && footerOffset + footerPadding < wrapHeight) {
					this.setState({ footerFixed: true });
	
					// Also, we need to set the width, which is normally determined by this
					// component's parent's width
					if ($footer.length > 0) {
						$footer.find(".inner").css("width", $wrap.width());
					}
				} else {
					this.setState({ footerFixed: false });
				}
			}
		}]);
	
		return Passage;
	}(React.Component);
	
	var ATTEMPT_BREAK_LENGTH = 100;
	var SENT_END_REGEX = /^[\.\?\!]\"?\s+([A-Z]|\")/;
	
	// Webpack don't like the raw regex
	var TITLE_REGEX = /\s(m|d)(r|i)?i?(r|s)\./gi;
	
	function toParagraphs(text) {
		if (text.indexOf(LINE_BREAK_MARK) == -1) {
			// Use the fallback 
			return oldToPragraphs(text);
		}
	
		var lines = [];
	
		_.each(text.split(SECTION_BREAK_MARK), function (section, index) {
			if (index != 0) {
				lines.push(SECTION_BREAK_MARK);
			}
			_.each(section.split(LINE_BREAK_MARK), function (paragraph, index) {
				lines.push(paragraph.trim());
			});
		});
	
		return lines;
	}
	
	// From before TR was providing paragraph breaks
	// Soon to be remove completely
	function oldToPragraphs(text) {
		var paragraphs = [];
		var lastBreak = 0;
		var inQuote = false;
	
		for (var index = 1; index < text.length; index += 1) {
			var textFromIndex = text.substring(index - 1);
	
			if (textFromIndex.startsWith(SECTION_BREAK_MARK)) {
				paragraphs.push(text.substring(lastBreak, index - 1).trim());
				paragraphs.push(SECTION_BREAK_MARK);
	
				index += SECTION_BREAK_MARK.length - 1;
				lastBreak = index;
	
				inQuote = false;
				continue;
			}
	
			// If we're at the end of a quote ending with a period
			if (inQuote && SENT_END_REGEX.test(textFromIndex) && text[index] == '"') {
				paragraphs.push(text.substring(lastBreak, index + 1).trim());
				lastBreak = index + 1;
				inQuote = false;
				continue;
			}
	
			if (text[index] == '"') {
				if (text[index + 1] == '"') {
					paragraphs.push(text.substring(lastBreak, index + 1).trim());
					lastBreak = index + 1;
					index += 1;
					inQuote = true;
					continue;
				} else {
					inQuote = !inQuote;
				}
			}
	
			if (!inQuote && SENT_END_REGEX.test(textFromIndex) && index - lastBreak > ATTEMPT_BREAK_LENGTH) {
				var titleText = text.substring(index - 5, index + 1);
				if (!TITLE_REGEX.test(titleText)) {
					paragraphs.push(text.substring(lastBreak, index + 1).trim());
					lastBreak = index + 1;
					continue;
				}
			}
		}
		if (lastBreak < text.length) {
			paragraphs.push(text.substring(lastBreak).trim());
		}
		return paragraphs;
	}
	
	var OTHER_REPLACEMENTS = [[/&quot;/g, '"'], [/&apos;/g, "'"], [/&nbsp;/g, " "]];
	var SECTION_BREAK_REGEX = /<P ALIGN(\w| |=|"|#)*>/g; // Only care about the close ones
	var SECTION_BREAK_MARK = "|-|SectionBreak|-|";
	
	var LINE_BREAK_REGEX = /(<\/?br>)+/g;
	var LINE_BREAK_MARK = "|-|LineBreak|-|";
	
	var JUNK_HTML_REGEX = /<\/?[A-Z](\w| |=|"|#)*>/g;
	
	function decodeHtml(content) {
		// Thanks @ Rob W
		// https://stackoverflow.com/a/7394787/4557470
		var textarea = document.createElement("textarea");
		textarea.innerHTML = content;
	
		var formattedContent = textarea.value;
	
		formattedContent = formattedContent.replace(LINE_BREAK_REGEX, LINE_BREAK_MARK);
		formattedContent = formattedContent.replace(SECTION_BREAK_REGEX, SECTION_BREAK_MARK);
	
		_.each(OTHER_REPLACEMENTS, function (pair) {
			formattedContent = formattedContent.replace(pair[0], pair[1]);
		});
	
		if (JUNK_HTML_REGEX.test(formattedContent)) {
			formattedContent = formattedContent.replace(JUNK_HTML_REGEX, " ");
		}
	
		return formattedContent;
	}
	
	var ITALICS_REGEX = /<\/?i>/g;
	var PARAGRAPH_REGEX = /<\/?(p|br)>/g;
	var ESCAPED_QUOTE_REGEX = /\\'/g;
	
	function handleWeirdFormatting(content) {
		// We're inserting our own line breaks, so ignore these....
		if (PARAGRAPH_REGEX.test(content)) {
			var strippedText = content.replace(PARAGRAPH_REGEX, " ");
			return handleWeirdFormatting(strippedText);
		}
	
		if (ESCAPED_QUOTE_REGEX.test(content)) {
			var strippedText = content.replace(ESCAPED_QUOTE_REGEX, "'");
			return handleWeirdFormatting(strippedText);
		}
	
		if (ITALICS_REGEX.test(content)) {
			var emParts = content.split(ITALICS_REGEX);
			// Odd indexes will be for clozeIndexes
			var formattedParts = _.map(emParts, function (item, index) {
				if (index % 2 == 0) {
					return handleWeirdFormatting(item);
				} else {
					return React.createElement(
						"em",
						{ key: index },
						item
					);
				}
			});
			return formattedParts;
		}
	
		return content;
	}
	
	var OPEN_SPAN_REGEX = /<span[ \w_\"\'=]*>/g;
	var CLOSE_SPAN_REGEX = /<\/span[ \w_\"\'=]*>/g;
	function stripSpanTags(content) {
		return content.replace(OPEN_SPAN_REGEX, "__||").replace(CLOSE_SPAN_REGEX, "||__");
	}
	
	Passage.propTypes = {
		passage: PropTypes.object.isRequired,
		onPassageComplete: PropTypes.func.isRequired,
		subCategoryName: PropTypes.string,
		categoryName: PropTypes.string,
		getIcon: PropTypes.func
	};
	
	module.exports = Passage;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _LocationState = __webpack_require__(59);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var CopyTextInput = __webpack_require__(930);
	var Glyphicon = __webpack_require__(8);
	var DiffDisplay = __webpack_require__(931);
	
	var BookDisplay = __webpack_require__(46);
	
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	var ReadingSelectors = __webpack_require__(21);
	var ClassResultsRouting = __webpack_require__(441);
	var StudentDisplay = __webpack_require__(52);
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3629);
	
	// Provide location state first, since we may want to access the school ID
	var ClassResultsPage = (_dec = (0, _LocationState.provideLocationState)(ClassResultsRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
	
		var query = ClassResultsRouting.getQuery(props.locationState);
		downProps.report = DataSelectors.report({ state: state, query: query });
		downProps.loading = DataSelectors.isLoadingReport({ state: state, query: query });
	
		// This is here to make sure updateState is called when book titles load in
		downProps.totalTextCount = ReadingSelectors.books({ state: state });
	
		return downProps;
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				var query = ClassResultsRouting.getQuery(props.locationState);
	
				return dispatch(DataActions.fetchReport({
					query: query, cache: true
				}));
			}
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(ClassResultsPage, _React$Component);
	
		function ClassResultsPage(props) {
			_classCallCheck(this, ClassResultsPage);
	
			var _this = _possibleConstructorReturn(this, (ClassResultsPage.__proto__ || Object.getPrototypeOf(ClassResultsPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ClassResultsPage");
	
			_this.wrap = React.createRef();
			return _this;
		}
	
		_createClass(ClassResultsPage, [{
			key: "toggleHideNames",
			value: function toggleHideNames() {
				var hideNames = !this.props.locationState.hideNames;
	
				$wr.redirect(ClassResultsRouting.getPath(_.extend({}, this.props.locationState, { hideNames: hideNames })));
			}
		}, {
			key: "hideNames",
			value: function hideNames() {
				return this.props.locationState.hideNames;
			}
		}, {
			key: "renderShareSection",
			value: function renderShareSection() {
				return React.createElement(
					"div",
					{ className: "shareSection hideOnPrint" },
					React.createElement(
						"div",
						{ className: "shareLink" },
						"Share Link: ",
						React.createElement(CopyTextInput, { text: window.location.href })
					),
					React.createElement(
						"div",
						{ className: "printLink" },
						React.createElement(
							"a",
							{ href: "#", onClick: $wr.print },
							React.createElement(Glyphicon, { icon: "print" }),
							" Print Report"
						)
					),
					React.createElement(
						"div",
						{ className: "hideStudents" },
						React.createElement(
							"label",
							{ className: "normal" },
							React.createElement("input", { type: "checkbox", checked: !this.props.locationState.hideNames,
								onChange: this.toggleHideNames }),
							" Show Student Names"
						)
					)
				);
			}
		}, {
			key: "renderBestAnswer",
			value: function renderBestAnswer() {
				var answer = this.props.report.best_answer;
				if (!answer) {
					return React.createElement("div", { className: "bestAnswer" });
				}
	
				var answerParagraphs = _.map(answer.body.split("\n"), function (text, index) {
					return React.createElement(
						"p",
						{ key: index },
						text
					);
				});
	
				return React.createElement(
					"div",
					{ className: "bestAnswer" },
					React.createElement(
						"p",
						{ className: "reportSubHeader" },
						"Best Answer"
					),
					React.createElement(
						"div",
						{ className: "studentTextPair clearfix" },
						React.createElement(BookDisplay, { textID: answer.text_id }),
						React.createElement(StudentDisplay, { studentID: answer.user_id, firstNameLastInitial: true,
							showAvatar: true, hideName: this.hideNames(), avatarMaxWidth: 50 })
					),
					React.createElement(
						"p",
						null,
						React.createElement(
							"strong",
							null,
							answer.question_text
						)
					),
					answerParagraphs
				);
			}
		}, {
			key: "renderTopTexts",
			value: function renderTopTexts() {
				if (!this.props.report.texts) {
					return React.createElement("div", { className: "topTexts" });
				}
	
				var textDisplays = _.map(this.props.report.texts.top, function (text) {
					return React.createElement(
						"li",
						{ key: text.text_id, className: "topTitle" },
						React.createElement(BookDisplay, { textID: text.text_id }),
						React.createElement(
							"span",
							{ className: "readCount" },
							"(",
							text.user_count,
							"x)"
						)
					);
				});
				return React.createElement(
					"div",
					{ className: "topTexts" },
					React.createElement(
						"p",
						{ className: "reportSubHeader" },
						"Top Books"
					),
					React.createElement(
						"ol",
						null,
						textDisplays
					)
				);
			}
		}, {
			key: "renderFeedbackCorrection",
			value: function renderFeedbackCorrection() {
				var revision = this.props.report.best_revision;
				if (!revision) {
					return React.createElement("div", { className: "feedbackCorrection" });
				}
	
				return React.createElement(
					"div",
					{ className: "feedbackCorrection" },
					React.createElement(
						"p",
						{ className: "reportSubHeader" },
						"Improving from Owlfonso's Feedback"
					),
					React.createElement(
						"div",
						{ className: "studentTextPair clearfix" },
						React.createElement(BookDisplay, { textID: revision.text_id }),
						React.createElement(StudentDisplay, { studentID: revision.user_id, firstNameLastInitial: true,
							showAvatar: true, hideName: this.hideNames(), avatarMaxWidth: 50 })
					),
					React.createElement(
						"div",
						{ className: "feedbackRow" },
						React.createElement(
							"div",
							{ className: "rowLabel" },
							"Question:"
						),
						React.createElement(
							"div",
							{ className: "content" },
							revision.question
						)
					),
					React.createElement(
						"div",
						{ className: "feedbackRow" },
						React.createElement(
							"div",
							{ className: "rowLabel" },
							"Before:"
						),
						React.createElement(
							"div",
							{ className: "content" },
							revision.revision.source
						)
					),
					React.createElement(
						"div",
						{ className: "feedbackRow" },
						React.createElement(
							"div",
							{ className: "rowLabel" },
							"Feedback:"
						),
						React.createElement(
							"div",
							{ className: "content" },
							revision.revision.feedback_content
						)
					),
					React.createElement(
						"div",
						{ className: "feedbackRow" },
						React.createElement(
							"div",
							{ className: "rowLabel" },
							"After:"
						),
						React.createElement(
							"div",
							{ className: "content" },
							React.createElement(DiffDisplay, { text: revision.revision.diff })
						)
					)
				);
			}
		}, {
			key: "renderAggregateStats",
			value: function renderAggregateStats() {
				var report = this.props.report;
	
				if (report.aggregate_stats.minutes_read) {
					var varStat = React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.aggregate_stats.minutes_read
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"Minutes"
						)
					);
				} else {
					var varStat = React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.aggregate_stats.writing_count
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"All Writing"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "collectiveStats" },
					React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.aggregate_stats.quiz_count
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"Quizzes"
						)
					),
					React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.aggregate_stats.answers_count
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"Answers"
						)
					),
					React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.aggregate_stats.reviews_count
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"Reviews"
						)
					),
					varStat,
					React.createElement(
						"div",
						{ className: "stat" },
						React.createElement(
							"div",
							{ className: "num" },
							report.texts.text_count
						),
						React.createElement(
							"div",
							{ className: "numLabel" },
							"Books Read"
						)
					)
				);
			}
		}, {
			key: "renderMostImproved",
			value: function renderMostImproved() {
				var _this2 = this;
	
				var scoreCap = 4;
				var improvedStudents = _.map(this.props.report.most_improved, function (improvement, index) {
	
					var imgPath = "ranks/school-comp-medal-" + (index + 1) + "-basic.png";
					var rankingImg = React.createElement("img", { className: "rankImg", src: dynamicRequire(imgPath) });
	
					var change = Math.round(10 * scoreCap * improvement.change) / 10;
	
					return React.createElement(
						"div",
						{ className: "improvedStudent", key: improvement.user_id },
						React.createElement(
							"p",
							{ className: "reportSubHeader" },
							rankingImg,
							" Most Improved"
						),
						React.createElement(
							"div",
							null,
							React.createElement(StudentDisplay, { studentID: improvement.user_id,
								firstNameLastInitial: true, showAvatar: true, hideName: _this2.hideNames(),
								avatarMaxWidth: 50 }),
							" ",
							"(+",
							change,
							" points)"
						)
					);
				});
	
				if (improvedStudents.length > 0) {
					var mostImprovedReport = React.createElement(
						"div",
						{ className: "mostImproved" },
						improvedStudents,
						React.createElement(
							"p",
							{ className: "explanation" },
							"Based on change in students' scores (out of ",
							scoreCap,
							") from the start to the end of the year."
						)
					);
					return mostImprovedReport;
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.loading) {
					var content = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else if (!this.props.report) {
					var content = React.createElement(
						"p",
						null,
						"No report found... you may have been sent to this page by accident."
					);
				} else {
					var teacherName = this.props.report.teacher_name;
	
					var currentUser = CurrentUser.get();
					var shareContent = currentUser && this.props.report.user_id == currentUser.id ? this.renderShareSection() : "";
					var content = React.createElement(
						"div",
						null,
						shareContent,
						React.createElement(
							"div",
							{ className: "topSection clearfix" },
							React.createElement(
								"div",
								{ className: "left" },
								this.renderBestAnswer()
							),
							React.createElement(
								"div",
								{ className: "right" },
								this.renderTopTexts()
							)
						),
						this.renderFeedbackCorrection(),
						this.renderAggregateStats(),
						this.renderMostImproved()
					);
				}
	
				return React.createElement(
					"div",
					{ className: "container classResultsPage", ref: this.wrap },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Teacher Reports"
						),
						React.createElement(
							"p",
							{ className: "teacherName" },
							teacherName
						)
					),
					content
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var reportLock;
				if (this.props.report) {
					reportLock = this.props.report.lock;
				}
	
				if (reportLock != this.props.locationState.reportLock) {
					$wr.redirect(ClassResultsRouting.getPath(_.extend({}, this.props.locationState, { reportLock: reportLock })));
				} else if (!_.isEqual(_.omit(prevProps.locationState, "report_lock"), _.omit(this.props.locationState, "report_lock"))) {
	
					this.props.populateData();
				}
	
				this.adjustVisibleTitles();
			}
		}, {
			key: "adjustVisibleTitles",
			value: function adjustVisibleTitles() {
				var $topTitles = $(this.wrap.current).find("li.topTitle");
				var $titleSection = $(this.wrap.current).find(".topTexts");
				var $answerSection = $(this.wrap.current).find(".bestAnswer");
	
				var MIN_TITLES = 3;
				var MARGIN = 20;
	
				$topTitles.show();
	
				function removeOne() {
					var leftHeight = $answerSection.height();
					var rightHeight = $titleSection.height();
					var $visibleTitles = $topTitles.filter(":visible");
	
					if (leftHeight + MARGIN < rightHeight && $visibleTitles.length > MIN_TITLES) {
						$visibleTitles.last().hide();
						setTimeout(removeOne, 10);
					}
				}
	
				removeOne();
			}
		}]);
	
		return ClassResultsPage;
	}(React.Component)) || _class) || _class) || _class);
	;
	
	ClassResultsPage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object,
	
		// @connect data
		report: PropTypes.object,
		loading: PropTypes.bool,
		totalTextCount: PropTypes.number,
	
		// @connect handlers
		populateData: PropTypes.func
	});
	
	module.exports = ClassResultsPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _marked = __webpack_require__(612);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactSelect = __webpack_require__(154);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var Glyphicon = __webpack_require__(8);
	var Modal = __webpack_require__(18);
	var ButtonDropdownOption = __webpack_require__(31);
	var DataRouting = __webpack_require__(36);
	var BookSearchModal = __webpack_require__(401);
	var DateSpanSelector = __webpack_require__(116);
	var BookDisplay = __webpack_require__(46);
	var StudentAvatar = __webpack_require__(35);
	var DataExportModal = __webpack_require__(750);
	
	var TextTypes = __webpack_require__(38);
	var Features = __webpack_require__(16);
	var PaywallModal = __webpack_require__(44);
	var CurrentUser = __webpack_require__(3);
	var DateSpans = __webpack_require__(177);
	
	var RosterRouting = __webpack_require__(93);
	var RosterSelectors = __webpack_require__(6);
	var DataSelectors = __webpack_require__(54);
	var UIActions = __webpack_require__(41);
	var DownloadData = __webpack_require__(436);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3630);
	
	var DataControls = (_dec = (0, _reactRedux.connect)(function (state) {
		var slPrefs = RosterSelectors.globalStudentListPrefs({ state: state });
		// DatePage populate date will load in the prefs
	
		return {
			studentLists: RosterSelectors.nonEmptyStudentLists({ state: state }),
			loadingStudents: RosterSelectors.isLoadingStudentLists({ state: state }),
			studentsByStudentListID: RosterSelectors.studentsByStudentListID({ state: state }),
			userName: CurrentUser.get().display_name,
			blockLogReading: !Features.isEnabled(Features.LOG_READING),
			blockDigitalExercises: !Features.isEnabled(Features.DIGITAL_EXERCISES),
			bookRecommendations: slPrefs.assigned_text_ids || [],
			blockFullData: false, // made constant during freemium updates 07/2022
	
			dataExportF: DataSelectors.getExportDataF({ state: state }),
	
			digests: DataSelectors.digests({ state: state })
		};
	}, function (dispatch) {
		return {
			openLogReadingPaywall: function openLogReadingPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
			},
			openExercisesPaywall: function openExercisesPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.EXERCISES }));
			},
	
			openHistoricalDataPaywall: function openHistoricalDataPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }));
			},
	
			showZPDReadingLevelsPaywall: function showZPDReadingLevelsPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(DataControls, _React$Component);
	
		function DataControls(props) {
			_classCallCheck(this, DataControls);
	
			var _this = _possibleConstructorReturn(this, (DataControls.__proto__ || Object.getPrototypeOf(DataControls)).call(this));
	
			autobind(_this);
	
			// Only for data temporarily overriding what's being provided in props
			_this.state = { overrideData: {} };
			return _this;
		}
	
		_createClass(DataControls, [{
			key: 'showDataExportModal',
			value: function showDataExportModal() {
				this.refs.dataExportModal.show();
			}
		}, {
			key: 'hideDataExportModal',
			value: function hideDataExportModal() {
				this.refs.dataExportModal.hide();
			}
		}, {
			key: 'handlePrint',
			value: function handlePrint() {
				this.hideDataExportModal();
				setTimeout(function () {
					this.props.printRef.current.handlePrint();
				}.bind(this), 700);
			}
		}, {
			key: 'effectiveData',
			value: function effectiveData() {
				return _underscore2.default.extend({}, this.props.selectedData, this.state.overrideData);
			}
		}, {
			key: 'confirmEdits',
			value: function confirmEdits() {
				var _this2 = this;
	
				var effectiveData = this.effectiveData();
				delete effectiveData.page; // Start again on page 1
				this.setState({ overrideData: {} }, function () {
					_this2.props.updateSelectedData(effectiveData);
				});
			}
		}, {
			key: 'toggleStudent',
			value: function toggleStudent(student, wasSelected) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					var effectiveData = this.effectiveData();
					var effectiveIDs = effectiveData.userIDs;
	
					if (wasSelected) {
						this.updateOverride({ userIDs: _underscore2.default.without(effectiveIDs, student.id) });
					} else {
						this.updateOverride({ userIDs: effectiveIDs.concat([student.id]) });
					}
				}
			}
		}, {
			key: 'toggleStudentList',
			value: function toggleStudentList(studentList, wasSelected) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					var studentIDs = _underscore2.default.pluck(this.props.studentsByStudentListID[studentList.id], "id");
					var effectiveIDs = this.effectiveData().userIDs;
	
					if (wasSelected) {
						this.updateOverride({ userIDs: _underscore2.default.difference(effectiveIDs, studentIDs) });
					} else {
						this.updateOverride({ userIDs: _underscore2.default.union(effectiveIDs, studentIDs) });
					}
				}
			}
	
			// if data filters are taking up >= 80% of row width
			// hide "Export Data" label
	
		}, {
			key: 'showDataExportSpan',
			value: function showDataExportSpan() {
				if (this.props.selectedData.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD) {
					return false;
				}
	
				var flexContainer = document.querySelector(".dataControls");
				return flexContainer && !(flexContainer.children[0].offsetWidth / flexContainer.offsetWidth >= 0.8);
			}
		}, {
			key: 'downloadData',
			value: function downloadData(e) {
				$wr.nope(e);
	
				var _effectiveData = this.effectiveData(),
				    subjectType = _effectiveData.subjectType,
				    startDate = _effectiveData.startDate,
				    endDate = _effectiveData.endDate,
				    userIDs = _effectiveData.userIDs;
	
				// This is a bit janky; I'd prefer not to have to directly access subject type here
	
	
				if (subjectType === DataRouting.SUBJECT_GOALS || subjectType === DataRouting.SUBJECT_OTHER_METRICS || subjectType == DataRouting.SUBJECT_READING_LEVELS || subjectType == DataRouting.SUBJECT_ACTIVITIES || subjectType == DataRouting.SUBJECT_TEACHER_PICKS) {
	
					var downloadFilename = _underscore2.default.compact([this.props.userName, startDate, endDate, subjectType]).join(" - ") + ".csv";
					if (subjectType === DataRouting.SUBJECT_GOALS) {
						var toExport = this.props.dataExportF({ type: "goals", startDate: startDate, endDate: endDate, userIDs: userIDs });
					} else if (subjectType === DataRouting.SUBJECT_READING_LEVELS) {
						var toExport = this.props.dataExportF({ type: "rld", userIDs: userIDs });
					} else if (subjectType === DataRouting.SUBJECT_ACTIVITIES) {
						if (window.location.href.indexOf("everyone") < 0) {
							var toExport = this.props.dataExportF({ type: "expanded-activities", userIDs: userIDs });
						} else {
							var toExport = this.props.dataExportF({ type: "all-activities", userIDs: userIDs });
						}
					} else if (subjectType === DataRouting.SUBJECT_TEACHER_PICKS) {
						var toExport = this.props.dataExportF({ type: "teacher-picks", userIDs: userIDs });
					} else {
						var toExport = this.props.dataExportF({ type: "stats", startDate: startDate, endDate: endDate, userIDs: userIDs });
					}
					DownloadData.downloadCSV(toExport.rows, toExport.headers, downloadFilename);
				} else {
					console.error("Unsupport subjectType for downloadData: ", subjectType);
				}
			}
		}, {
			key: 'updateOverride',
			value: function updateOverride(updateData) {
				this.setState({ overrideData: _underscore2.default.extend({}, this.state.overrideData, updateData) }, function () {
					this.confirmEdits();
				});
			}
		}, {
			key: 'selectDates',
			value: function selectDates(startDate, endDate) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					this.updateOverride({ startDate: startDate, endDate: endDate });
				}
			}
		}, {
			key: 'onDueDateSelect',
			value: function onDueDateSelect(dueDate) {
				this.updateOverride({ dueDate: dueDate });
			}
		}, {
			key: 'onBookSelect',
			value: function onBookSelect(book) {
				this.refs.bookSearchModal.hide();
				this.updateOverride({ textID: book.text_id, textVariety: undefined });
			}
		}, {
			key: 'onDraftSelect',
			value: function onDraftSelect(draft) {
				if (draft === 'all') {
					this.updateOverride({ draft: undefined });
				}
				this.updateOverride({ draft: draft });
			}
		}, {
			key: 'selectTextOption',
			value: function selectTextOption(textOption) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					if (textOption == TextTypes.Varieties.SPECIFIC_TEXT) {
						this.refs.bookSearchModal.show();
					} else {
						this.updateOverride({ textVariety: textOption, textID: undefined });
					}
				}
			}
		}, {
			key: 'selectOrder',
			value: function selectOrder(orderType) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					this.updateOverride({ order: DataRouting.ORDER_LABELS[orderType] });
				}
			}
		}, {
			key: 'selectSubjectType',
			value: function selectSubjectType(subjectType) {
				if (DataRouting.requiresLogReading(subjectType) && this.props.blockLogReading) {
					this.props.openLogReadingPaywall();
				} else if (DataRouting.requiresDigitalExercises(subjectType) && this.props.blockDigitalExercises) {
					this.props.openExercisesPaywall();
				} else {
					this.updateOverride({ subjectType: subjectType });
				}
			}
		}, {
			key: 'selectStatus',
			value: function selectStatus(status) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					if (status == DataRouting.ALL_STATUS) {
						this.updateOverride({ status: undefined });
					} else {
						this.updateOverride({ status: status });
					}
				}
			}
		}, {
			key: 'selectReadBookStatus',
			value: function selectReadBookStatus(readBook) {
				this.updateOverride({ readBook: readBook.value });
			}
		}, {
			key: 'canConfirm',
			value: function canConfirm() {
				// Has to have overridden something
				if (_underscore2.default.isEmpty(this.state.overrideData)) {
					return false;
				}
	
				var effectiveData = this.effectiveData();
	
				// Has to have a subject type
				if (!effectiveData.subjectType) {
					return false;
				}
	
				// Has to not be the same as the original params
				return !_underscore2.default.isEqual(effectiveData, this.props.selectedData);
			}
		}, {
			key: 'renderStatusSelector',
			value: function renderStatusSelector() {
				var _this3 = this;
	
				var selectedStatus = this.effectiveData().status;
	
				// Subject Data Type
				var dropdownOps = _underscore2.default.map(DataRouting.STATUS_OPTIONS, function (status) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: status,
							onClick: _this3.selectStatus.bind(_this3, status) },
						$wr.toTitleCase(status)
					);
				});
	
				var displayText = selectedStatus ? $wr.toTitleCase(selectedStatus) : "All Statuses";
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText,
						dropdownDisplay: 'link', className: 'subjectTypeSelector nested' },
					dropdownOps
				);
			}
		}, {
			key: 'renderSubjectSelector',
			value: function renderSubjectSelector() {
				var _this4 = this;
	
				var selectedSubjectType = this.effectiveData().subjectType;
	
				// Subject Data Type
				var subSubjectOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(selectedSubjectType), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					// if (DataRouting.requiresDigitalExercises(subjectType) && this.props.blockDigitalExercises) {
					// 	return; // Don't even render it
					// 	// if (subjectType == DataRouting.SUBJECT_EXERCISES) {
					// 	// 	return; // Don't even render it
					// 	// }
	
					// 	// var lockIcon = <Glyphicon icon="lock" />
					// 	// var className = "locked";
					// }
					return React.createElement(
						ButtonDropdownOption,
						{ key: subjectType, className: className,
							onClick: _this4.selectSubjectType.bind(_this4, subjectType) },
						lockIcon,
						subjectType
					);
				});
	
				// Don't render an empty subject ops
				if (subSubjectOps.length < 2) {
					return null;
				}
	
				var displayText = selectedSubjectType || "Select Data Type";
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText,
						dropdownDisplay: 'link', className: 'subjectTypeSelector nested' },
					subSubjectOps
				);
			}
		}, {
			key: 'renderStudentSelector',
			value: function renderStudentSelector() {
				var _this5 = this;
	
				var selectors = [];
	
				var selectedNames = [];
				var effectiveIDs = new Set(this.effectiveData().userIDs);
	
				_underscore2.default.each(this.props.studentLists, function (studentList) {
	
					var studentSelectors = [];
					var allSelected = true;
	
					_underscore2.default.each(_this5.props.studentsByStudentListID[studentList.id], function (student) {
						if (effectiveIDs.has(student.id)) {
							var isSelected = true;
							selectedNames.push(student.display_name);
						} else {
							var isSelected = false;
							allSelected = false;
						}
						studentSelectors.push(React.createElement(
							ButtonDropdownOption,
							{ key: "s-" + student.id,
								preventCollapse: true, className: 'studentOp',
								onClick: _this5.toggleStudent.bind(_this5, student, isSelected) },
							React.createElement('input', { type: 'checkbox', checked: isSelected, onChange: function onChange() {} }),
							" ",
							student.display_name
						));
					});
	
					selectors.push(React.createElement(
						ButtonDropdownOption,
						{ key: "sl-" + studentList.id,
							preventCollapse: true, className: 'studentListOp',
							onClick: _this5.toggleStudentList.bind(_this5, studentList, allSelected) },
						React.createElement('input', { type: 'checkbox', checked: allSelected, onChange: function onChange() {} }),
						" ",
						studentList.name
					));
	
					selectors = selectors.concat(studentSelectors);
				});
	
				if (this.props.loadingStudents) {
					var currentLabel = "...";
				} else if (selectedNames.length == 0) {
					var currentLabel = "All Students";
				} else if (selectedNames.length == 1) {
					var currentLabel = selectedNames[0];
				} else {
					var uniqueNames = _underscore2.default.uniq(selectedNames);
	
					var namesLength = uniqueNames.length;
					var currentLabel = namesLength + " Students";
	
					var sortedNames = $wr.sortByName(uniqueNames, "lastName");
					var slicedNames = _underscore2.default.first(sortedNames, 10);
	
					if (namesLength > 10) {
						var surplusStudentsCount = namesLength - 10;
						var toolTipText = slicedNames.join(', ') + " + " + surplusStudentsCount + " more";
					} else {
						var toolTipText = slicedNames.join(', ');
					}
				}
	
				return React.createElement(
					ButtonDropdown,
					{ text: currentLabel, dataTip: toolTipText,
						dropdownDisplay: 'link', className: 'studentSelector' },
					selectors
				);
			}
		}, {
			key: 'findStudent',
			value: function findStudent(studentID) {
				var studentsByStudentListID = this.props.studentsByStudentListID;
	
				return _underscore2.default.findWhere(_underscore2.default.flatten(_underscore2.default.values(studentsByStudentListID)), { id: studentID });
			}
		}, {
			key: 'selectStudent',
			value: function selectStudent(student) {
				if (this.props.blockFullData) {
					this.props.openHistoricalDataPaywall();
				} else {
					this.updateOverride({ userIDs: [student.id] });
				}
			}
		}, {
			key: 'renderDataExportModal',
			value: function renderDataExportModal() {
				return React.createElement(
					Modal,
					{ className: 'dataExportModal', ref: 'dataExportModal' },
					React.createElement(DataExportModal, {
						handlePrint: this.handlePrint,
						effectiveData: this.effectiveData(),
						onComplete: this.hideDataExportModal
					})
				);
			}
		}, {
			key: 'renderExportLink',
			value: function renderExportLink() {
				return React.createElement(
					'a',
					{ href: '#', className: 'exportLink hideOnPrint', onClick: this.showDataExportModal, 'data-tip': true, 'data-for': 'export' },
					this.showDataExportSpan() && React.createElement(
						'span',
						{ className: 'exportDataText' },
						'Export Data'
					),
					React.createElement(Glyphicon, { icon: 'download-alt' }),
					!this.showDataExportSpan() && React.createElement(
						ReactTooltip,
						{ id: 'export' },
						'Export Data'
					)
				);
			}
		}, {
			key: 'renderSearchableStudentSelector',
			value: function renderSearchableStudentSelector() {
				var students = _underscore2.default.flatten(_underscore2.default.values(this.props.studentsByStudentListID));
				var options = _underscore2.default.map(students, function (student) {
					return { label: student.display_name + ' (' + student.username + ')', value: student.display_name, id: student.id };
				});
				var selectedStudent = _underscore2.default.findWhere(options, { id: _underscore2.default.first(this.props.selectedData.userIDs) });
				var selected = selectedStudent ? selectedStudent : options[0];
	
				return React.createElement(_reactSelect2.default, {
					className: "hideOnPrint searchableStudentSelector",
					value: selected,
					options: options,
					onChange: this.selectStudent,
					clearable: false });
			}
		}, {
			key: 'renderTextSelector',
			value: function renderTextSelector() {
				var _this6 = this;
	
				var effectiveData = this.effectiveData();
	
				if (DataRouting.allowsTextVariety(effectiveData.subjectType)) {
					var textVarietyOptions = DropDownOptions.Button.TextVarieties({
						onClick: function onClick(val) {
							_this6.selectTextOption(val);
						},
						altOptions: true, className: "topLevel"
					});
				} else {
					var textVarietyOptions = DropDownOptions.Button.TextVarieties({
						onClick: function onClick(val) {
							_this6.selectTextOption(val);
						},
						anyOrSpecific: true, className: "topLevel"
					});
				}
	
				if (effectiveData.textID) {
					var currentLabel = React.createElement(BookDisplay, { textID: effectiveData.textID });
				} else {
					var currentLabel = TextTypes.Varieties.getAltName(effectiveData.textVariety || TextTypes.Varieties.BOTH);
				}
	
				if (this.props.bookRecommendations.length > 0) {
					textVarietyOptions.push(React.createElement(
						'li',
						{ className: 'dropdown-header', key: 'picks' },
						'Teacher Picks'
					));
					_underscore2.default.each(this.props.bookRecommendations, function (bookID) {
						var label = React.createElement(BookDisplay, { textID: bookID });
						textVarietyOptions.push(React.createElement(
							ButtonDropdownOption,
							{ key: bookID, className: 'bookRecommendation',
								onClick: _this6.onBookSelect.bind(_this6, { text_id: bookID }) },
							label
						));
					});
				}
	
				return React.createElement(
					ButtonDropdown,
					{ text: currentLabel,
						dropdownDisplay: 'link', className: 'textSelector nested' },
					textVarietyOptions
				);
			}
		}, {
			key: 'renderTimePeriodLabel',
			value: function renderTimePeriodLabel() {
				var digests = this.props.digests;
	
				if (_underscore2.default.isEmpty(digests)) {
					return null;
				}
	
				// find unique combo of start_date-end_date
				var uniqDateRanges = _underscore2.default.uniq(_underscore2.default.compact(_underscore2.default.map(digests, function (d) {
					return d.start_date + '-' + d.end_date;
				})));
	
				// if all students have the same date range, display range
				// else, display generic message
				if (_underscore2.default.size(uniqDateRanges) == 1) {
					var startDate = (0, _moment2.default)(_underscore2.default.first(digests).start_date).format("M/DD/YY");
					var endDate = (0, _moment2.default)(_underscore2.default.first(digests).end_date).format("M/DD/YY");
					var goalPeriodLabel = startDate + ' - ' + endDate;
				} else {
					var goalPeriodLabel = 'Varies by Student';
				}
	
				return React.createElement(
					'div',
					{ className: 'timePeriodLabel' },
					'Goal Period:',
					" ",
					React.createElement(
						'span',
						{ className: 'spanDates' },
						'(',
						goalPeriodLabel,
						')'
					)
				);
			}
		}, {
			key: 'renderDateSpanSelector',
			value: function renderDateSpanSelector() {
				var effectiveData = this.effectiveData();
				if (DataRouting.allowAllDates(effectiveData.subjectType)) {
					var showAllDates = true;
				}
				return React.createElement(DateSpanSelector, { noDatesOption: true, onSelectDates: this.selectDates,
					expectationsSpans: this.props.expectationsDateSpans,
					startDate: effectiveData.startDate, endDate: effectiveData.endDate,
					showAllDates: showAllDates });
			}
	
			// VARIATION ON DATESPANSELECTOR ALIGNED WITH WIDGET PERIODS
	
		}, {
			key: 'renderWidgetDateSpanSelector',
			value: function renderWidgetDateSpanSelector() {
				var effectiveData = this.effectiveData();
				if (DataRouting.allowAllDates(effectiveData.subjectType)) {
					var showAllDates = true;
				}
				return React.createElement(DateSpanSelector, { noDatesOption: true, onSelectDates: this.selectDates,
					expectationsSpans: this.props.expectationsDateSpans,
					startDate: effectiveData.startDate, endDate: effectiveData.endDate,
					showAllDates: showAllDates, updateLocationState: this.updateOverride,
					widgetMode: true });
			}
		}, {
			key: 'renderDueDateSelector',
			value: function renderDueDateSelector() {
				var _this7 = this;
	
				var effectiveData = this.effectiveData();
	
				var currentLabel = 'All Due Dates';
				if (effectiveData.dueDate === 'upcoming') {
					currentLabel = 'Upcoming';
				} else if (effectiveData.dueDate === 'past') {
					currentLabel = 'Past Due';
				} else if (effectiveData.dueDate === 'none') {
					currentLabel = 'No Due Date';
				}
	
				var dueDateDropdownOptions = [{
					label: 'All Due Dates',
					key: 'all_dates',
					dueDate: 'all'
				}, {
					label: 'Upcoming',
					key: 'upcoming_dates',
					dueDate: 'upcoming'
				}, {
					label: 'Past Due',
					key: 'past_due',
					dueDate: 'past'
				}, {
					label: 'No Due Date',
					key: 'none',
					dueDate: 'none'
				}];
	
				dueDateDropdownOptions = _underscore2.default.map(dueDateDropdownOptions, function (option) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: option.key, className: 'statusOptions',
							onClick: _this7.onDueDateSelect.bind(_this7, option.dueDate) },
						option.label
					);
				});
				return React.createElement(
					ButtonDropdown,
					{ text: currentLabel,
						dropdownDisplay: 'link', className: 'draftSelector nested' },
					dueDateDropdownOptions
				);
			}
		}, {
			key: 'renderDraftSelector',
			value: function renderDraftSelector() {
				var _this8 = this;
	
				var effectiveData = this.effectiveData();
	
				var currentLabel = 'Completed & Assigned';
				if (effectiveData.draft === true) {
					currentLabel = 'Assigned';
				} else if (effectiveData.draft === false) {
					currentLabel = 'Completed';
				}
	
				var statusDropdownOptions = [{
					label: 'Completed & Assigned',
					key: 'completed_assigned',
					draft: 'all'
				}, {
					label: 'Completed',
					key: 'completed',
					draft: 'false'
				}, {
					label: 'Assigned',
					key: 'assigned',
					draft: 'true'
				}];
	
				statusDropdownOptions = _underscore2.default.map(statusDropdownOptions, function (option) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: option.key, className: 'statusOptions',
							onClick: _this8.onDraftSelect.bind(_this8, option.draft) },
						option.label
					);
				});
				return React.createElement(
					ButtonDropdown,
					{ text: currentLabel,
						dropdownDisplay: 'link', className: 'draftSelector nested' },
					statusDropdownOptions
				);
			}
		}, {
			key: 'renderOrderSelector',
			value: function renderOrderSelector() {
				var orderOps = DropDownOptions.Button.simpleText({
					options: _underscore2.default.keys(DataRouting.ORDER_LABELS), onClick: this.selectOrder
				});
	
				var order = this.effectiveData().order || DataRouting.ORDER_BY_DATE;
				var displayText = _underscore2.default.invert(DataRouting.ORDER_LABELS)[order];
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText,
						dropdownDisplay: 'link', className: 'orderSelector' },
					orderOps
				);
			}
		}, {
			key: 'renderReadBookStatusSelector',
			value: function renderReadBookStatusSelector() {
				var _this9 = this;
	
				var selectedReadBookStatus = this.effectiveData().readBook;
	
				var currentLabel = 'All';
				if (selectedReadBookStatus == 'yes') {
					currentLabel = 'Read Book';
				} else if (selectedReadBookStatus == 'no') {
					currentLabel = 'Did Not Read Book';
				}
	
				var dropdownOptions = [{
					label: 'All',
					key: 'all',
					value: undefined
				}, {
					label: 'Read Book',
					key: 'read_book',
					value: 'yes'
				}, {
					label: 'Did Not Read Book',
					key: 'did_not_read_book',
					value: 'no'
				}];
	
				// Subject Data Type
				var dropdownOps = _underscore2.default.map(dropdownOptions, function (op) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: op.key,
							onClick: _this9.selectReadBookStatus.bind(_this9, op) },
						$wr.toTitleCase(op.label)
					);
				});
	
				return React.createElement(
					ButtonDropdown,
					{ text: currentLabel,
						dropdownDisplay: 'link', className: 'subjectTypeSelector nested' },
					dropdownOps
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var effectiveData = this.effectiveData();
	
				var dataExportModal = this.renderDataExportModal();
	
				if (this.canConfirm()) {
					var confirmButton = React.createElement(
						'button',
						{ className: 'btn buttonPrimary confirmButton', onClick: this.confirmEdits },
						'Show'
					);
				}
	
				if (DataRouting.hasPages(effectiveData.subjectType) && effectiveData.userIDs.length != 1) {
					var orderSelector = this.renderOrderSelector();
				}
	
				if (DataRouting.allowDates(effectiveData.subjectType)) {
					var dateSelector = this.renderDateSpanSelector();
					var bookSearchModal = React.createElement(BookSearchModal, { ref: 'bookSearchModal',
						onBookSelect: this.onBookSelect });
				}
	
				if (DataRouting.allowDraft(effectiveData.subjectType)) {
					var draftSelector = this.renderDraftSelector();
					var bookSearchModal = React.createElement(BookSearchModal, { ref: 'bookSearchModal',
						onBookSelect: this.onBookSelect });
				}
	
				if (DataRouting.allowDueDate(effectiveData.subjectType)) {
					var dueDateSelector = this.renderDueDateSelector();
					var bookSearchModal = React.createElement(BookSearchModal, { ref: 'bookSearchModal',
						onBookSelect: this.onBookSelect });
				}
	
				if (DataRouting.allowsText(effectiveData.subjectType)) {
					var textSelector = this.renderTextSelector();
					var bookSearchModal = React.createElement(BookSearchModal, { ref: 'bookSearchModal',
						onBookSelect: this.onBookSelect });
				}
	
				if (DataRouting.allowsStatus(effectiveData.subjectType)) {
					var statusSelector = this.renderStatusSelector();
				}
	
				if (DataRouting.allowsReadBookStatus(effectiveData.subjectType)) {
					var statusSelector = this.renderReadBookStatusSelector();
				}
	
				if (this.props.selectedData.subjectType == DataRouting.SUBJECT_GOALS) {
					var diffLink = RosterRouting.getPath({
						activeView: RosterRouting.VIEWS.GOALS
					}) + "?edit_expectations=true";
					var editGoalsLink = React.createElement(
						'span',
						{ className: 'editGoalsLink' },
						React.createElement(
							'button',
							{ className: 'btn dropdown-toggle btn-link' },
							React.createElement(
								'a',
								{ href: 'https://whooosreading.zendesk.com/hc/en-us/articles/360024761351', target: '_blank' },
								'Learn How to Edit Goals'
							)
						)
					);
	
					var timePeriodLabel = this.renderWidgetDateSpanSelector();
				}
				if (DataRouting.allowsPrinting(effectiveData.subjectType)) {
					var printLink = React.createElement(
						'a',
						{ href: '#', className: 'printLink hideOnPrint', onClick: $wr.print, 'data-tip': true, 'data-for': 'print' },
						React.createElement(Glyphicon, { icon: 'print' }),
						React.createElement(
							ReactTooltip,
							{ id: 'print' },
							React.createElement(
								'span',
								null,
								'Print Page'
							)
						)
					);
				}
	
				if (DataRouting.allowsDownload(effectiveData.subjectType)) {
					var downloadLink = React.createElement(
						'a',
						{ href: '#', className: 'printLink hideOnPrint', onClick: this.downloadData, 'data-tip': true, 'data-for': 'download' },
						React.createElement(Glyphicon, { icon: 'download-alt' }),
						React.createElement(
							ReactTooltip,
							{ id: 'download' },
							React.createElement(
								'span',
								null,
								'Download CSV'
							)
						)
					);
				}
	
				if (this.props.selectedData.subjectType != DataRouting.SUBJECT_STUDENT_DASHBOARD) {
					var exportLink = this.renderExportLink();
				}
	
				if (this.props.selectedData.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD) {
					var studentID = _underscore2.default.first(this.props.selectedData.userIDs);
					var student = this.findStudent(studentID);
					if (student) {
						var dataStudentDigestHeader = React.createElement(
							'div',
							{ className: 'dataStudentDigestHeaderContainer' },
							this.renderExportLink(),
							React.createElement(
								'div',
								{ className: 'student' },
								React.createElement(StudentAvatar, { student: student, maxWidth: 50 }),
								React.createElement(
									'div',
									{ className: 'studentName' },
									student.display_name
								)
							),
							this.renderSearchableStudentSelector()
						);
					}
				}
	
				if (!DataRouting.allowDates(effectiveData.subjectType) && !DataRouting.allowsText(effectiveData.subjectType) && !DataRouting.allowsPrinting(effectiveData.subjectType)) {
					var emptySection = React.createElement('div', null);
				}
	
				return React.createElement(
					'div',
					{ className: 'dataControls' },
					React.createElement(
						'div',
						{ className: 'mainControls' },
						dateSelector,
						timePeriodLabel,
						editGoalsLink,
						textSelector,
						statusSelector,
						draftSelector,
						dueDateSelector,
						confirmButton,
						bookSearchModal,
						dataExportModal,
						dataStudentDigestHeader
					),
					exportLink && React.createElement(
						'div',
						{ className: 'rightControls' },
						exportLink,
						React.createElement(
							'span',
							{ className: 'badge' },
							'New!'
						)
					)
				);
			}
		}]);
	
		return DataControls;
	}(React.Component)) || _class);
	;
	
	DataControls.WrappedComponent.propTypes = StrictPropTypes({
		// From parent component
		selectedData: PropTypes.object.isRequired,
		updateSelectedData: PropTypes.func.isRequired,
	
		// Data inserted by @connect
		studentLists: PropTypes.array.isRequired,
		studentsByStudentListID: PropTypes.object.isRequired,
		loadingStudents: PropTypes.bool,
		expectationsDateSpans: PropTypes.array,
		digests: PropTypes.array,
		dataExportF: PropTypes.func,
	
		blockLogReading: PropTypes.bool,
		blockDigitalExercises: PropTypes.bool,
		blockFullData: PropTypes.bool,
		bookRecommendations: PropTypes.array,
		userName: PropTypes.string,
		printRef: PropTypes.object,
	
		// Handlers from @connect
		openLogReadingPaywall: PropTypes.func,
		openHistoricalDataPaywall: PropTypes.func,
		openExercisesPaywall: PropTypes.func,
		showZPDReadingLevelsPaywall: PropTypes.func,
		printComponent: PropTypes.func
	});
	
	module.exports = DataControls;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _LocationState = __webpack_require__(59);
	
	var _reactToPrint = __webpack_require__(3601);
	
	var _reactToPrint2 = _interopRequireDefault(_reactToPrint);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(15);
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	var UIActions = __webpack_require__(41);
	var DisplayToggleControl = __webpack_require__(48);
	
	var DataControls = __webpack_require__(739);
	var DataRouting = __webpack_require__(36);
	
	var PaywallModal = __webpack_require__(44);
	var ReactionFeedback = __webpack_require__(101);
	
	var Glyphicon = __webpack_require__(8);
	var Spinner = __webpack_require__(9);
	var EmptyStateContainer = __webpack_require__(80);
	var OnboardingChecklist = __webpack_require__(166);
	
	var DataGoals = __webpack_require__(380);
	var DataQuizTables = __webpack_require__(765);
	var DataBookTables = __webpack_require__(762);
	var DataAnswers = __webpack_require__(379);
	var DataTextTables = __webpack_require__(383);
	var DataLogTables = __webpack_require__(381);
	var DataLogCalendars = __webpack_require__(764);
	var DataReadingLevelGraphs = __webpack_require__(382);
	var DataReadingLevels = __webpack_require__(767);
	var DataExercises = __webpack_require__(763);
	var DataStudentDigest = __webpack_require__(877);
	var DataTableSummary = __webpack_require__(769);
	
	var StudentSelectorSection = __webpack_require__(745);
	var DataToggleRouting = __webpack_require__(1014);
	var NoActivityBlock = __webpack_require__(71);
	
	var ExpandedStudentActivitiesTable = __webpack_require__(947);
	var TeacherPicksTable = __webpack_require__(949);
	var AllStudentActivitiesTable = __webpack_require__(945);
	
	__webpack_require__(3632);
	
	var DataPage = (_dec = (0, _LocationState.provideLocationState)(DataRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		var userIDs = _underscore2.default.isEmpty(props.locationState.userIDs) ? undefined : props.locationState.userIDs;
		var students = RosterSelectors.students({ state: state, conditions: { ids: userIDs } });
	
		if (props.locationState.subjectType) {
			var downProps = {};
	
			// IMPORTANT: If you add to this, also add to DataActions.clearDataLoading
			downProps.loading = WritingSelectors.isLoadingQuizzes({ state: state, key: 'index', userIDs: userIDs }) || ReadingSelectors.isLoadingLogs({ state: state, key: 'index', userIDs: userIDs }) || DataSelectors.isLoadingDigests({ state: state, key: 'index', userIDs: userIDs }) || WritingSelectors.isLoadingAnswers({ state: state, key: 'index', userIDs: userIDs }) || ReadingSelectors.isLoadingReadingLevels({ state: state, key: 'index', userIDs: userIDs }) || RosterSelectors.isLoadingStudents({ state: state, key: 'index' }) || RosterSelectors.isLoadingStudentLists({ state: state, key: 'index' }) || RosterSelectors.isLoadingAdmins({ state: state, key: 'index' });
		} else {
			var downProps = {};
			downProps.loading = RosterSelectors.isLoadingStudents({ state: state, key: 'index' }) || RosterSelectors.isLoadingStudentLists({ state: state, key: 'index' }) || RosterSelectors.isLoadingAdmins({ state: state, key: 'index' });
		}
	
		downProps.onlyDemoStudents = _underscore2.default.isEmpty(_underscore2.default.select(RosterSelectors.students({ state: state }), function (student) {
			return !student.demo_for_teacher;
		})), downProps.showFullData = true; // made constant during freemium updates 07/2022
		downProps.showDigitalActivities = Features.isEnabled(Features.DIGITAL_EXERCISES);
		downProps.showLogs = Features.isEnabled(Features.LOG_READING);
		downProps.showScoringDetails = Features.isEnabled(Features.AUTOGRADER_DATA);
		downProps.studentLists = RosterSelectors.nonEmptyStudentLists({ state: state });
		downProps.students = students;
	
		// IF STUDENT LIST SELECTED THEN CHANGE EXPECTATIONS
		var studentListID = $wr.getURLParameterByName("student_list");
		if (studentListID && state.studentLists[studentListID]) {
			var expectations_date_spans = state.studentLists[studentListID].expectations_date_spans;
		} else {
			var expectations_date_spans = (RosterSelectors.studentLists({ state: state })[0] || {}).expectations_date_spans;
		}
		downProps.expectationsDateSpans = expectations_date_spans;
	
		var studentListID = $wr.getURLParameterByName("student_list");
		if (studentListID) {
			downProps.selectedStudentList = RosterSelectors.nonEmptyStudentLists({ state: state })[studentListID];
		} else {
			downProps.selectedStudentList = downProps.studentLists.length > 0 ? downProps.studentLists[0] : null;
		}
	
		return downProps;
	}, function (dispatch, props) {
		var clearLoading = function clearLoading() {
			return dispatch(DataActions.clearDataLoading());
		};
		var showHistoricalDataPaywall = function showHistoricalDataPaywall() {
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }));
		};
		var openLogReadingPaywall = function openLogReadingPaywall() {
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
		};
		var openExercisesPaywall = function openExercisesPaywall() {
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.EXERCISES }));
		};
	
		var fetchStudents = function fetchStudents() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS;
			return dispatch(RosterActions.fetchStudents({ embeds: embeds }));
		};
	
		var fetchStudentLists = function fetchStudentLists() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS;
			return dispatch(RosterActions.fetchStudentLists({ embeds: embeds }));
		};
	
		var populateData = function populateData() {
			return Promise.all([fetchStudentLists().then(function (slResponse) {
				return fetchStudents();
			})]);
		};
	
		return {
			clearLoading: clearLoading,
			openLogReadingPaywall: openLogReadingPaywall,
			openExercisesPaywall: openExercisesPaywall,
			populateData: populateData
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(DataPage, _React$Component);
	
		function DataPage(props) {
			_classCallCheck(this, DataPage);
	
			var _this = _possibleConstructorReturn(this, (DataPage.__proto__ || Object.getPrototypeOf(DataPage)).call(this));
	
			autobind(_this);
	
			props.clearLoading(); // Do this before anything renders
	
			LuckyOrangeClient.tagComponent("DataPage");
	
			_this.printRef = React.createRef();
	
			_this.state = { prevLocationState: {} };
			return _this;
		}
	
		_createClass(DataPage, [{
			key: "onPageChange",
			value: function onPageChange(newPage, newPerPage) {
				var stateWithPage = _underscore2.default.extend({}, this.props.locationState, { page: newPage });
				if (newPerPage !== undefined) {
					stateWithPage = _underscore2.default.extend(stateWithPage, { perPage: newPerPage });
				}
	
				if (stateWithPage.page === 1) {
					// Otherwise it won't be cached correctly
					delete stateWithPage.page;
				}
				this.updateRoute(stateWithPage);
				$wr.setWindowY(0);
			}
		}, {
			key: "updateRoute",
			value: function updateRoute(updatedState, keepPrevLocationState) {
				var _this2 = this;
	
				// if route change is not coming from a link within a table,
				// wipe the orig state
				if (keepPrevLocationState != true) {
					this.setState({ prevLocationState: {} });
				}
	
				this.props.clearLoading().then(function () {
					if (_this2.props.showFullData) {
						$wr.redirect(DataRouting.getPath(updatedState, "nope"));
					} else {
						$wr.redirect(DataRouting.getPath(_underscore2.default.pick(updatedState, "subjectType", "nope")));
					}
				});
			}
	
			// updates orig state to allow users to get back
			// to table view when clicking on link within table
	
		}, {
			key: "updateRouteFromTable",
			value: function updateRouteFromTable(updatedState) {
				var _this3 = this;
	
				this.setState({ prevLocationState: _extends({}, this.props.locationState) }, function () {
					_this3.updateRoute(updatedState, true);
				});
			}
		}, {
			key: "renderReactionFeedback",
			value: function renderReactionFeedback() {
				var locationState = this.props.locationState;
				var subjectTypeKey = (locationState.subjectType || "").toLowerCase().replace(/ /g, "-");
				return React.createElement(ReactionFeedback, { where: "data-page-" + subjectTypeKey,
					textOnly: false,
					title: "Was it easy to find the data you were looking for?",
					placeholder: "Your feedback goes here...",
					component_position: ReactionFeedback.POSITION_BOTTOM_RIGHT,
					popover_position: ReactionFeedback.POSITION_BOTTOM_RIGHT });
			}
		}, {
			key: "renderNoStudentsEmptyState",
			value: function renderNoStudentsEmptyState() {
				var rosterLink = "/roster?addNewStudentsButton=true";
				var emptyActionText = React.createElement(
					"p",
					{ className: "addStudentsText" },
					"It looks like you haven't added any students yet.",
					React.createElement(
						_reactRouterDom.Link,
						{ to: rosterLink },
						" Add students "
					),
					"and their writing data and scores will appear here!"
				);
				var emptyImgPath = __webpack_require__(496);
				return React.createElement(EmptyStateContainer, { actionText: emptyActionText,
					linkPath: rosterLink, imagePath: emptyImgPath });
			}
		}, {
			key: "renderNoDataEmptyState",
			value: function renderNoDataEmptyState() {
				var locationState = this.props.locationState;
				var statusText = "";
				if (locationState.userIDs.length == 1) {
					statusText += "This student doesn't";
				} else {
					statusText += "These students don't";
				}
	
				statusText += " have any " + DataRouting.subjectNoun(locationState.subjectType) + " for these options.";
				var emptyImgPath = __webpack_require__(496);
				return React.createElement(EmptyStateContainer, { statusText: statusText,
					imagePath: emptyImgPath });
			}
		}, {
			key: "renderWritingPaywallDisplay",
			value: function renderWritingPaywallDisplay() {
				return React.createElement(
					"div",
					{ className: "dataPaywall" },
					"Want to see all writing data for your entire class?",
					React.createElement(
						"button",
						{ className: "btn buttonPrimary", onClick: this.props.showHistoricalDataPaywall },
						"Learn about WR Silver"
					)
				);
			}
		}, {
			key: "renderBackToTableArrow",
			value: function renderBackToTableArrow() {
				var _this4 = this;
	
				var prevLocationState = this.state.prevLocationState;
				var locationState = this.props.locationState;
	
				// show when we have a previous state or on single quiz display
	
				if (!_underscore2.default.isEmpty(prevLocationState)) {
					var linkText = prevLocationState.subjectType;
					var newLocationState = _extends({}, prevLocationState);
				} else if (locationState.subjectType == DataRouting.SUBJECT_QUIZZES && locationState.quizID) {
					var linkText = 'Quiz';
					var newLocationState = _underscore2.default.omit(_extends({}, locationState), 'quizID', 'controlMode');
					newLocationState.subjectType = DataRouting.SUBJECT_QUIZZES;
				}
	
				if (newLocationState) {
					return React.createElement(
						"div",
						{ className: "backArrowContainer" },
						React.createElement(
							"a",
							{ href: "#", onClick: function onClick() {
									return _this4.updateRoute(_extends({}, newLocationState));
								}, className: "backArrow btn btn-link" },
							React.createElement(
								"span",
								{ className: "text" },
								"Back"
							)
						)
					);
				}
			}
		}, {
			key: "renderContent",
			value: function renderContent() {
				var displays;
				var locationState = this.props.locationState;
				var vk = $wr.sortedJSON(locationState);
				var studentIDs = _underscore2.default.pluck(this.props.students, 'id');
	
				var wrapClassName = "contentWrap";
	
				switch (locationState.subjectType) {
	
					case DataRouting.SUBJECT_GOALS:
					case DataRouting.SUBJECT_OTHER_METRICS:
						var locationProps = _underscore2.default.pick(locationState, "userIDs", "studentList", "startDate", "endDate");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
						return React.createElement(
							"div",
							null,
							React.createElement(DataGoals, _extends({ key: vk }, locationProps, propsProps, {
								showTotals: true,
								showGoals: locationState.subjectType === DataRouting.SUBJECT_GOALS }))
						);
	
					case DataRouting.SUBJECT_QUIZZES:
						var locationProps = _underscore2.default.pick(locationState, "userIDs", "startDate", "endDate", "textVariety", "textID", "perPage", "page", "order", "studentList", "quizID", "status");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataQuizTables, _extends({ key: vk }, locationProps, propsProps, {
							locationState: locationState,
							updateRoute: this.updateRouteFromTable,
							onPageChange: this.onPageChange,
							userIDs: studentIDs,
							prevLocationState: this.state.prevLocationState,
							enabled: {
								date: true,
								student: true,
								score: true,
								textTitle: true,
								readingLevel: true,
	
								editControls: true,
								feedbackControls: true,
								analysisControls: true,
	
								allowRevision: true,
								editScore: true,
								deletion: true,
								toggleInclude: true
							} }));
	
					case DataRouting.SUBJECT_ANSWERS:
					case DataRouting.SUBJECT_REVIEWS:
					case DataRouting.SUBJECT_WRITING:
					case DataRouting.SUBJECT_QUESTION_BUILDERS:
						var locationProps = _underscore2.default.pick(locationState, "userIDs", "startDate", "endDate", "textVariety", "textID", "perPage", "page", "order", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						var answerType = DataAnswers.ANSWER_TYPE_LOOKUP[locationState.subjectType];
	
						return React.createElement(DataAnswers, _extends({ key: vk }, locationProps, propsProps, {
							userIDs: studentIDs, answerType: answerType, onPageChange: this.onPageChange,
							prevLocationState: this.state.prevLocationState, updateRoute: this.updateRoute,
							enabled: {
								date: true,
								student: true,
								score: true,
								linkToQuiz: true,
								textTitle: true,
								readingLevel: true,
	
								editControls: true,
								feedbackControls: true,
								analysisControls: true,
	
								allowRevision: true,
								editScore: true,
								deletion: true,
								toggleInclude: true
							} }));
	
					case DataRouting.SUBJECT_BOOKS:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textVariety", "textID", "studentList", "readBook");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataBookTables, _extends({ key: vk }, locationProps, propsProps, {
							softMaxPerTable: 10,
							locationState: locationState,
							updateRoute: this.updateRouteFromTable,
							prevLocationState: this.state.prevLocationState,
							userIDs: studentIDs, byStudent: true }));
	
					case DataRouting.SUBJECT_LOG_LIST:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textVariety", "textID", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataLogTables, _extends({ key: vk }, locationProps, propsProps, {
							softMaxPerTable: 20,
							userIDs: studentIDs }));
	
					case DataRouting.SUBJECT_LOG_CALENDAR:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textVariety", "textID", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataLogCalendars, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs }));
	
					case DataRouting.SUBJECT_READING_LEVELS:
						var locationProps = _underscore2.default.pick(locationState, "perPage", "page", "order", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataReadingLevels, _extends({ key: vk }, locationProps, propsProps, { onPageChange: this.onPageChange, userIDs: studentIDs }));
	
					case DataRouting.SUBJECT_READING_LEVEL_GRAPH:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(DataReadingLevelGraphs, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs }));
	
					case DataRouting.SUBJECT_ACTIVITIES:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textID", "dueDate", "studentList");
	
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						if (window.location.href.indexOf("everyone") < 0) {
							return React.createElement(ExpandedStudentActivitiesTable, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs }));
						} else {
							return React.createElement(AllStudentActivitiesTable, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs }));
						}
	
					case DataRouting.SUBJECT_ASSIGNED_EXERCISES:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textVariety", "textID", "dueDate", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(ExpandedStudentActivitiesTable, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs, assigned: true }));
	
					case DataRouting.SUBJECT_COMPLETED_EXERCISES:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "textVariety", "textID", "dueDate", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(ExpandedStudentActivitiesTable, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs, completed: true }));
	
					case DataRouting.SUBJECT_TEACHER_PICKS:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "status", "textVariety", "textID", "draft", "dueDate", "studentList");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
	
						return React.createElement(TeacherPicksTable, _extends({ key: vk }, locationProps, propsProps, { userIDs: studentIDs, teacherPicks: true }));
	
					case DataRouting.SUBJECT_STUDENT_DASHBOARD:
						var locationProps = _underscore2.default.pick(locationState, "startDate", "endDate", "dueDate");
						var propsProps = _underscore2.default.pick(this.props, "showFullData");
						var studentID = _underscore2.default.first(studentIDs);
	
						return React.createElement(DataStudentDigest, _extends({ key: vk }, locationProps, propsProps, { studentID: studentID }));
	
					default:
						throw "Unknown subject type: " + locationState.subjectType;
				}
	
				return React.createElement(
					"div",
					{ className: wrapClassName },
					displays
				);
			}
		}, {
			key: "changeSelection",
			value: function changeSelection(ids, studentListID) {
	
				if (this.props.showFullData) {
	
					var userIDs = this.isDataStudentDigest() ? [_underscore2.default.first(_underscore2.default.keys(ids))] : _underscore2.default.keys(ids);
					var studentListID = this.isDataStudentDigest() ? null : studentListID;
	
					if (studentListID) {
						var studentList = _underscore2.default.findWhere(this.props.studentLists, { id: studentListID });
	
						if (studentList) {
							this.setRouteToStudentList(this.props.locationState.subjectType, studentList, "changeselection");
							return;
						}
					}
	
					var stateWithPage = _underscore2.default.extend({}, this.props.locationState, {
						userIDs: userIDs,
						studentList: studentListID
					});
	
					$wr.redirect(DataRouting.getPath(stateWithPage));
				}
			}
		}, {
			key: "switchActiveView",
			value: function switchActiveView(viewKey) {
				this.switchView({ subjectType: viewKey });
			}
		}, {
			key: "switchView",
			value: function switchView(change) {
	
				this.setState({ prevLocationState: {} }); // clear location history on view switch
				var newLocationState = _underscore2.default.extend({}, this.props.locationState, change);
	
				$wr.redirect(DataRouting.getPath(newLocationState));
			}
		}, {
			key: "selectSubjectType",
			value: function selectSubjectType(subjectType, e) {
				$wr.nope(e);
				this.switchView({ subjectType: subjectType });
			}
		}, {
			key: "singleStudentListSelected",
			value: function singleStudentListSelected() {
				var locationState = this.props.locationState;
	
				return locationState.studentList && locationState.studentList !== 'everyone';
			}
		}, {
			key: "selectDataStudentDigest",
			value: function selectDataStudentDigest(subjectType, e) {
				$wr.nope(e);
				var _props = this.props,
				    locationState = _props.locationState,
				    students = _props.students;
	
	
				if (_underscore2.default.isEmpty(locationState.userIDs) && !this.singleStudentListSelected()) {
					// no student list, no user ids
					var userID = _underscore2.default.first(_underscore2.default.pluck(students, 'id'));
				} else if (_underscore2.default.isEmpty(locationState.userIDs) && this.singleStudentListSelected()) {
					// student list, no user ids
					var userID = _underscore2.default.first(_underscore2.default.filter(students, function (student) {
						return student.student_list_ids.primary == parseInt(locationState.studentList);
					}));
				} else {
					// student list, user ids
					var userID = _underscore2.default.first(locationState.userIDs);
				}
	
				this.switchView({ subjectType: subjectType, userIDs: [userID], studentList: null });
			}
		}, {
			key: "isDataStudentDigest",
			value: function isDataStudentDigest() {
				return this.props.locationState.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD;
			}
		}, {
			key: "effectiveData",
			value: function effectiveData() {
				var locationState = this.props.locationState;
				return locationState;
			}
		}, {
			key: "headerText",
			value: function headerText(type) {
				var locationState = this.props.locationState;
				var subjectType = locationState.subjectType;
				var superSubjectType = null;
				if (locationState.subjectType) {
					superSubjectType = DataRouting.getSubjectHeaderType(locationState.subjectType);
				}
				if (superSubjectType == type) {
					if (subjectType == type) {
						var linkText = type;
					} else {
						var linkText = subjectType;
					}
				} else {
					var linkText = type;
				}
				return linkText;
			}
		}, {
			key: "handleSummaryCardClick",
			value: function handleSummaryCardClick(change) {
				if (change) {
					this.switchView(_underscore2.default.extend({ textVariety: "fiction-and-non-fiction", userIDs: [] }, _extends({}, change)));
				}
			}
		}, {
			key: "renderSummary",
			value: function renderSummary() {
				var _props$locationState = this.props.locationState,
				    subjectType = _props$locationState.subjectType,
				    studentList = _props$locationState.studentList;
	
				var sharedProps = { admin: CurrentUser.get(), studentListID: parseInt(studentList) || null, onClick: this.handleSummaryCardClick };
				switch (subjectType) {
					case DataRouting.SUBJECT_QUIZZES:
						return React.createElement(DataTableSummary, _extends({ subjectType: 'quiz' }, sharedProps));
					case DataRouting.SUBJECT_BOOKS:
						return React.createElement(DataTableSummary, _extends({ subjectType: 'book' }, sharedProps));
					default:
						return null;
				}
			}
		}, {
			key: "renderStudentSelector",
			value: function renderStudentSelector() {
				if (!this.isDataStudentDigest()) {
					return React.createElement(StudentSelectorSection, { changeSelection: this.changeSelection,
						initialStudentIDs: this.props.locationState.userIDs, showFullData: this.props.showFullData });
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this5 = this;
	
				var locationState = this.props.locationState;
				if (this.props.loading) {
					var displayContent = React.createElement(Spinner, { placeholder: true });
				} else if (this.props.onlyDemoStudents) {
					var displayContent = this.renderNoStudentsEmptyState();
				} else if (locationState.subjectType) {
					if (!hasData(locationState, this.props)) {
						var displayContent = this.renderNoDataEmptyState();
					} else {
						var displayContent = this.renderContent();
					}
				}
				// else {
				// 	// Ooph, this isn't very kosher... and shouldn't happen I think?
				// 	this.switchView({ subjectType: "Goals" });
				// }
	
				var superSubjectType = null;
				if (locationState.subjectType) {
					superSubjectType = DataRouting.getSubjectHeaderType(locationState.subjectType);
					if (superSubjectType == DataRouting.SUBJECT_ACTIVITIES && !Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						superSubjectType = DataRouting.SUBJECT_QUESTION_BUILDERS;
					}
					var headerSuffix = "- " + superSubjectType;
				}
				var onboardingChecklist = React.createElement(OnboardingChecklist, null);
	
				var goalsSubjectOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_GOALS), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
				var booksSubjectOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_BOOKS), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
				var quizzesSubjectOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_QUIZZES), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
				var writingSubject = DataRouting.SUBJECT_WRITING;
				var writingSubjectOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(writingSubject), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
				if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
					var activitiesToShow = DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_ACTIVITIES);
				} else {
					var activitiesToShow = _underscore2.default.filter(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_ACTIVITIES), function (subject) {
						return subject === DataRouting.SUBJECT_QUESTION_BUILDERS;
					});
				}
				var exercisesSubjectOps = _underscore2.default.map(activitiesToShow, function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
	
				if (this.props.locationState && this.props.locationState.subjectType && this.props.locationState.subjectType == DataRouting.SUBJECT_QUESTION_BUILDERS && !Features.isEnabled(Features.DIGITAL_EXERCISES)) {
					var activitiesDropdown = React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_QUESTION_BUILDERS)
						)
					);
				} else {
					var activitiesDropdown = React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_ACTIVITIES),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							exercisesSubjectOps
						)
					);
				}
	
				var readingLevelOps = _underscore2.default.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_READING_LEVELS), function (subjectType) {
					var className = "";
					var lockIcon = undefined;
					return React.createElement(
						"li",
						{ key: subjectType, className: className },
						React.createElement(
							"a",
							{ href: "#", onClick: _this5.selectSubjectType.bind(_this5, subjectType) },
							lockIcon,
							subjectType
						)
					);
				});
	
				var topControlsDisplay = React.createElement(
					"div",
					{ className: "hideOnPrint topButtonsContainer" },
					React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_GOALS),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							goalsSubjectOps
						)
					),
					React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_BOOKS),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							booksSubjectOps
						)
					),
					React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_QUIZZES),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							quizzesSubjectOps
						)
					),
					React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_WRITING),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							writingSubjectOps
						)
					),
					activitiesDropdown,
					React.createElement(
						"div",
						{ className: "btn-group", role: "group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							this.headerText(DataRouting.SUBJECT_READING_LEVELS),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu" },
							readingLevelOps
						)
					),
					React.createElement(
						"div",
						{ className: "btn-group" },
						React.createElement(
							"button",
							{ type: "button", className: "btn btn-default dataStudentDigestBtn", "aria-haspopup": "true", "aria-expanded": "false",
								onClick: this.selectDataStudentDigest.bind(this, DataRouting.SUBJECT_STUDENT_DASHBOARD) },
							this.headerText(DataRouting.SUBJECT_STUDENT_DASHBOARD)
						)
					)
				);
	
				var dataStudentDigestClass = this.isDataStudentDigest() ? 'dataStudentDigest' : '';
	
				return React.createElement(
					"div",
					{ className: "container dataPage" },
					onboardingChecklist,
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							{ className: "hideOnPrint" },
							"Student Data ",
							headerSuffix
						)
					),
					topControlsDisplay,
					this.renderSummary(),
					this.renderStudentSelector(),
					React.createElement(
						"div",
						{ className: "dataContainer " + dataStudentDigestClass },
						React.createElement(DataControls, {
							printRef: this.printRef,
							updateSelectedData: this.updateRoute,
							expectationsDateSpans: this.props.expectationsDateSpans,
							selectedData: locationState
						}),
						this.renderBackToTableArrow(),
						React.createElement(_reactToPrint2.default, {
							trigger: function trigger() {
								return React.createElement("div", { style: { display: "none" } });
							},
							content: function content() {
								return _this5.componentRef;
							},
							ref: this.printRef
						}),
						React.createElement(
							"div",
							{ className: "dataContent", ref: function ref(el) {
									return _this5.componentRef = el;
								} },
							displayContent
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$wr.setWindowY(0);
	
				if (!this.props.loading && !this.props.onlyDemoStudents && !this.props.locationState.subjectType && this.props.studentLists) {
					this.setRouteToStudentList("Goals", this.props.selectedStudentList, "nope");
				}
			}
		}, {
			key: "setRouteToStudentList",
			value: function setRouteToStudentList(subjectType, studentList) {
	
				if (studentList) {
					if (studentList.expectations_date_spans && studentList.expectations_date_spans.length > 0) {
						var recentDates = studentList.expectations_date_spans[0];
	
						this.switchView({ subjectType: subjectType, studentList: studentList.id, userIDs: studentList.student_ids, startDate: recentDates.start, endDate: recentDates.end });
					} else {
						this.switchView({ subjectType: subjectType, studentList: studentList.id, userIDs: studentList.student_ids });
					}
				}
			}
		}]);
	
		return DataPage;
	}(React.Component)) || _class) || _class) || _class);
	;
	
	function hasData(locationState, props) {
		return true;
	
		switch (locationState.subjectType) {
	
			case DataRouting.SUBJECT_GOALS:
				return false; // Temp
	
			case DataRouting.SUBJECT_QUIZZES:
				return !_underscore2.default.isEmpty(props.quizzes);
	
			case DataRouting.SUBJECT_ANSWERS:
			case DataRouting.SUBJECT_REVIEWS:
			case DataRouting.SUBJECT_WRITING:
				return !_underscore2.default.isEmpty(props.answers);
	
			case DataRouting.SUBJECT_ACTIVITIES:
				return !_underscore2.default.isEmpty(props.responses);
	
			case DataRouting.SUBJECT_ASSIGNED_EXERCISES:
				return !_underscore2.default.isEmpty(props.tasks);
	
			case DataRouting.SUBJECT_LOG_LIST:
			case DataRouting.SUBJECT_LOG_CALENDAR:
				return !_underscore2.default.isEmpty(props.logs);
	
			case DataRouting.SUBJECT_BOOKS:
				return !_underscore2.default.isEmpty(props.books);
	
			case DataRouting.SUBJECT_READING_LEVELS:
				return false;
	
			case DataRouting.SUBJECT_READING_LEVEL_GRAPH:
				return !(_underscore2.default.isEmpty(props.books) && _underscore2.default.isEmpty(props.readingLevels));
	
			default:
			// throw "Unknown subject type: " + locationState.subjectType
		}
	}
	
	var QUIZZES_VIEW = "quizzes";
	var BOOKS_VIEW = "books";
	var ANSWERS_VIEW = "answers";
	var REVIEWS_VIEW = "reviews";
	var WRITING_VIEW = "writing";
	var EXERCISES_VIEW = "exercises";
	
	DataPage.WrappedComponent.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object.isRequired,
	
		// Data inserted by @connect
		quizzes: PropTypes.array,
		answers: PropTypes.array,
		responses: PropTypes.array,
		logs: PropTypes.array,
		books: PropTypes.array,
		tasks: PropTypes.array,
		readingLevels: PropTypes.array,
		students: PropTypes.array.isRequired,
		onlyDemoStudents: PropTypes.bool,
		studentList: PropTypes.string,
		prevLocationState: PropTypes.object,
		studentLists: PropTypes.array,
		expectationsDateSpans: PropTypes.array,
		selectedStudentList: PropTypes.object,
		printRef: PropTypes.object,
	
		// Values inserted by @connect
		loading: PropTypes.bool,
		noStudents: PropTypes.bool,
	
		showFullData: PropTypes.bool,
		showDigitalActivities: PropTypes.bool,
		showLogs: PropTypes.bool,
		showScoringDetails: PropTypes.bool,
	
		// Functions inserted by @connect
		showHistoricalDataPaywall: PropTypes.func,
		clearLoading: PropTypes.func.isRequired,
		openLogReadingPaywall: PropTypes.func.isRequired,
		openExercisesPaywall: PropTypes.func.isRequired,
		populateData: PropTypes.func
	});
	
	module.exports = DataPage;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DataSelectors = __webpack_require__(54);
	var DownloadData = __webpack_require__(436);
	
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	var RosterSelectors = __webpack_require__(6);
	var OrgTypes = __webpack_require__(45);
	
	__webpack_require__(647);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate");
	
		return conditions;
	}
	
	var DownloadDataLink = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			userName: CurrentUser.get().display_name,
			dataExportF: DataSelectors.getDistrictExportDataF({ state: state }),
			schoolOrgs: RosterSelectors.schoolOrgs({ state: state }),
			studentLists: props.orgIdentifier != OrgTypes.ALL_STUDENT_LISTS ? RosterSelectors.studentLists({ state: state, filters: { school_org_id: parseInt(OrgTypes.fromIdentifier(props.orgIdentifier).key) } }) : RosterSelectors.studentLists({ state: state })
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(DownloadDataLink, _React$Component);
	
		function DownloadDataLink(props) {
			_classCallCheck(this, DownloadDataLink);
	
			var _this = _possibleConstructorReturn(this, (DownloadDataLink.__proto__ || Object.getPrototypeOf(DownloadDataLink)).call(this));
	
			autobind(_this);
	
			_this.state = _this.getInitialState();
			return _this;
		}
	
		_createClass(DownloadDataLink, [{
			key: "schools",
			value: function schools() {
				return _.sortBy(this.props.schoolOrgs, "name");
			}
		}, {
			key: "studentLists",
			value: function studentLists() {
				return _.sortBy(this.props.studentLists, "name");
			}
		}, {
			key: "getInitialState",
			value: function getInitialState() {
				return {};
			}
		}, {
			key: "downloadData",
			value: function downloadData(e) {
				$wr.nope(e);
				var startDate = this.props.startDate;
				var endDate = this.props.endDate;
				var type = this.props.orgIdentifier;
				if (type == ALL_SCHOOLS) {
					var schools = this.schools();
					var toExport = this.props.dataExportF({ type: ALL_SCHOOLS, startDate: startDate, endDate: endDate, schools: schools });
				} else if (type == ALL_CLASSES) {
					var studentLists = this.studentLists();
					var toExport = this.props.dataExportF({ type: ALL_CLASSES, startDate: startDate, endDate: endDate, studentLists: studentLists });
				} else {
					var studentLists = this.studentLists();
					var toExport = this.props.dataExportF({ type: SCHOOL, startDate: startDate, endDate: endDate, studentLists: studentLists });
				}
				var downloadFilename = _.compact([this.props.userName, startDate, endDate, "stats"]).join(" - ") + ".csv";
				DownloadData.downloadCSV(toExport.rows, toExport.headers, downloadFilename);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"span",
					{ className: "downloadDataLink" },
					React.createElement(
						"a",
						{ href: "#", className: "printLink hideOnPrint", onClick: this.downloadData },
						React.createElement(Glyphicon, { icon: "download-alt", dataTip: "Download CSV" })
					)
				);
			}
		}]);
	
		return DownloadDataLink;
	}(React.Component)) || _class);
	;
	
	var ALL_SCHOOLS = "all-school-orgs";
	var ALL_CLASSES = "all-student-lists";
	var SCHOOL = "school-org";
	
	DownloadDataLink.propTypes = StrictPropTypes({
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		orgIdentifier: PropTypes.string
	});
	
	module.exports = DownloadDataLink;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	
	var Features = __webpack_require__(16);
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	var ParentEmailsModal = __webpack_require__(819);
	var DocumentClient = __webpack_require__(259);
	var AltModal = __webpack_require__(18);
	var ProgressBar = __webpack_require__(81);
	var PaywallModal = __webpack_require__(44);
	
	var DateSpans = __webpack_require__(177);
	var DateSpanSelector = __webpack_require__(116);
	var DropDownOptions = __webpack_require__(26);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var EmptyStateContainer = __webpack_require__(80);
	var HelpSectionLink = __webpack_require__(64);
	var ReadingLevelFormat = __webpack_require__(72);
	var ReadingLevelIcon = __webpack_require__(165);
	
	var StudentAvatar = __webpack_require__(35);
	
	var DataRouting = __webpack_require__(36);
	var RosterRouting = __webpack_require__(93);
	
	var UIActions = __webpack_require__(41);
	var UserAlertsActions = __webpack_require__(998);
	var RosterActions = __webpack_require__(11);
	
	var RosterSelectors = __webpack_require__(6);
	var DataSelectors = __webpack_require__(54);
	var StudentListDisplay = __webpack_require__(163);
	
	__webpack_require__(3643);
	
	var GoalsTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			userIsSchoolAdmin: CurrentUser.isSchoolAdmin(),
			userIsTeacherAdmin: CurrentUser.isTeacherAdmin(),
			students: RosterSelectors.students({
				state: state, conditions: { ids: props.digests.map(function (x) {
						return x.student_id;
					}) }
			}),
			expectationMetrics: DataSelectors.expectationsMetrics({
				state: state,
				student_ids: props.userIDs || null,
				student_list_ids: props.studentList ? [parseInt(props.studentList)] : null
			}),
			expectationDigestKeys: StudentMetrics.getDigestEmbeds(DataSelectors.expectationsMetrics({ state: state })).split(","),
			userMetricsColumns: DataSelectors.dashboardOtherMetrics({}),
			userPrefs: CurrentUser.get().prefs,
			isDisabledMetric: function isDisabledMetric(x) {
				return Features.anyDisabled(StudentMetrics.getFeatureDependencies(x));
			}
		};
	}, function (dispatch, props) {
		return {
			createUserAlert: function createUserAlert(_ref) {
				var userAlertData = _ref.userAlertData;
				return dispatch(UserAlertsActions.createUserAlert({ userAlertData: userAlertData }));
			},
			showHistoricalDataPaywall: function showHistoricalDataPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.TEACHER_DASHBOARD }));
			},
			updateDashboardColumns: function updateDashboardColumns(newCols) {
				return dispatch(RosterActions.updateAdmin({
					id: CurrentUser.get().id,
					update: { prefs: { dashboard_columns: newCols } }
				})).then(function () {
					var prefs = _extends({}, CurrentUser.get().prefs, { dashboard_columns: newCols });
					CurrentUser.updateLocal({ prefs: prefs });
				});
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(GoalsTable, _React$Component);
	
		function GoalsTable(props) {
			_classCallCheck(this, GoalsTable);
	
			var _this = _possibleConstructorReturn(this, (GoalsTable.__proto__ || Object.getPrototypeOf(GoalsTable)).call(this));
	
			autobind(_this);
	
			_this.state = { orderBy: STUDENT_NAME_ORDER };
			return _this;
		}
	
		_createClass(GoalsTable, [{
			key: "tooltipDate",
			value: function tooltipDate(dateString) {
				var arr = dateString.split('-');
				return arr[1] + "/" + arr[2] + "/" + arr[0];
			}
		}, {
			key: "changeSortBy",
			value: function changeSortBy(orderBy) {
				this.setState({ orderBy: orderBy });
			}
		}, {
			key: "expandStudent",
			value: function expandStudent(student) {
				$wr.redirect(DataRouting.getPath({
					subjectType: DataRouting.SUBJECT_BOOKS,
					userIDs: [student.id],
					startDate: this.props.startDate,
					endDate: this.props.endDate
				}));
			}
		}, {
			key: "selectExtraColumn",
			value: function selectExtraColumn(extraColumnIndex, columnKey) {
				var _this2 = this;
	
				var newDashboardColumns = _.clone(this.props.userMetricsColumns);
				newDashboardColumns[extraColumnIndex] = columnKey;
	
				newDashboardColumns = _.uniq(_.compact(newDashboardColumns));
	
				if (_.isEqual(this.props.userMetricsColumns, newDashboardColumns)) {
					return;
				}
	
				this.props.updateDashboardColumns(newDashboardColumns).then(function () {
					return _this2.props.reloadF();
				});
			}
		}, {
			key: "stateCellWidth",
			value: function stateCellWidth() {
				return (100 - 25) / this.activeColumns().length + "%";
			}
		}, {
			key: "getExpectation",
			value: function getExpectation(columnName, student) {
				if (student && student.prefs) {
					var grade_level = student && student.grade_level ? student.grade_level : 5;
					var expectations = student.prefs.grade_level_expectations_metrics[grade_level];
					var expectedData = _.findWhere(expectations, { metric: columnName });
					if (expectedData) {
						return expectedData.goal;
					}
				}
	
				// We should have blocked getting here w/ isExpection(columnName, studnet)
				return undefined;
			}
		}, {
			key: "activeColumns",
			value: function activeColumns() {
				if (this.props.showGoals) {
					return this.props.expectationMetrics;
				} else {
					return this.props.userMetricsColumns;
				}
			}
		}, {
			key: "digest",
			value: function digest(studentID) {
				var start_date = $wr.getURLParameterByName("start_date");
				if (start_date) {
					return _.findWhere(this.props.digests, { student_id: studentID, start_date: start_date });
				}
	
				return _.findWhere(this.props.digests, { student_id: studentID });
			}
		}, {
			key: "renderReadingVerificationCell",
			value: function renderReadingVerificationCell(student, readAmount, verifiedAmount, goal) {
				if (readAmount > 0) {
					if (!student.has_parent) {
						var approvalMessage = "Not approved. Click to add parent email for approval.";
						var approvalIcon = React.createElement(Glyphicon, { icon: "remove-circle", dataTip: approvalMessage });
					} else if (verifiedAmount == readAmount) {
						var approvalMessage = "Approved.";
						var approvalIcon = React.createElement(Glyphicon, { icon: "ok-circle", dataTip: approvalMessage });
					} else {
						var approvalMessage = "Not yet approved. Click to edit parent email.";
						var approvalIcon = React.createElement(Glyphicon, { icon: "question-sign", dataTip: approvalMessage });
					}
				} else {
					if (!student.has_parent) {
						var approvalMessage = "Click to add parent email for approval.";
						var approvalIcon = React.createElement(Glyphicon, { icon: "question-sign", dataTip: approvalMessage });
					} else {
						var approvalMessage = "Parent email added.";
						var approvalIcon = React.createElement(Glyphicon, { icon: "ok", dataTip: approvalMessage });
					}
				}
	
				if (goal == undefined) {
					var readingContent = React.createElement(
						"span",
						null,
						readAmount
					);
				} else {
					var readingContent = React.createElement(
						"span",
						null,
						readAmount,
						"/",
						goal
					);
				}
	
				if (this.props.userIsTeacherAdmin) {
					var cellContent = React.createElement(
						"span",
						{
							className: "parentLink",
							onClick: function onClick(e) {
								e.stopPropagation();$wr.redirect("/student_parents");
							}
						},
						readingContent,
						" ",
						approvalIcon
					);
				} else {
					var cellContent = React.createElement(
						"p",
						null,
						readingContent
					);
				}
				return React.createElement(
					"span",
					null,
					cellContent,
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
		}, {
			key: "renderExpectationCellContent",
			value: function renderExpectationCellContent(student, col) {
				var goal = this.getExpectation(col, student);
				var digest = this.digest(student.id);
				if (col == "minutes") {
					return this.renderReadingVerificationCell(student, digest ? digest.minutes_read : 0, digest ? digest.verified_minutes_read : 0, goal);
				} else if (col == "pages") {
					return this.renderReadingVerificationCell(student, digest ? digest.pages_read : 0, digest ? digest.verified_pages_read : 0, goal);
				} else {
					return React.createElement(
						"span",
						null,
						digest ? StudentMetrics.getValue(digest, col) : 0,
						"/",
						this.getExpectation(col, student)
					);
				}
			}
		}, {
			key: "renderReadingLevelCell",
			value: function renderReadingLevelCell(student, readingLevel) {
				if (readingLevel === undefined) {
					return React.createElement("span", null);
				} else if (readingLevel.indexOf("Incomplete:") >= 0) {
					var progress = _.last(readingLevel.split(":") || "-").trim();
					var tip = progress + " progress toward initial reading level assessment";
					return React.createElement(
						"span",
						{ className: "readingLevel" },
						readingLevel,
						" ",
						React.createElement(Glyphicon, { icon: "question-sign", dataTip: tip })
					);
				} else if (this.props.userPrefs.reading_levels_hidden) {
					return React.createElement(
						"span",
						null,
						React.createElement(
							"a",
							{ href: "#", onClick: this.openShowReadlingLevels },
							"Complete"
						)
					);
				} else {
					var scoreFormat = this.props.userPrefs.reading_level_format;
					var formattedReadingLevel = ReadingLevelFormat.getScoreForFormat(parseInt(readingLevel), scoreFormat);
					var displayLevel = formattedReadingLevel;
					return React.createElement(
						"span",
						null,
						displayLevel
					);
				}
			}
		}, {
			key: "renderAcadmicLevelCell",
			value: function renderAcadmicLevelCell(student, academicLevel) {
				var editPath = "/roster/" + RosterRouting.VIEWS.LEVELS;
				var onClick = function onClick(e) {
					$wr.nope(e);
					e.stopPropagation();
					$wr.redirect(editPath);
				};
	
				return React.createElement(
					"span",
					null,
					academicLevel,
					" ",
					React.createElement(
						"a",
						{ className: "editStudent", href: "#", onClick: onClick },
						"Edit"
					)
				);
			}
		}, {
			key: "renderZPDCountsCell",
			value: function renderZPDCountsCell(student, counts) {
				counts = counts || {};
				return React.createElement(
					"span",
					{ className: "zpdCounts" },
					React.createElement(
						"span",
						{ className: "levelStat" },
						React.createElement(ReadingLevelIcon, {
							tooltipCopyType: ReadingLevelIcon.COLLECTIVE_VIEW,
							showImageOnly: true,
							status: ReadingLevelIcon.EASY
						}),
						" ",
						counts ? counts.under : "-"
					),
					React.createElement(
						"span",
						{ className: "levelStat" },
						React.createElement(ReadingLevelIcon, {
							tooltipCopyType: ReadingLevelIcon.COLLECTIVE_VIEW,
							showImageOnly: true,
							status: ReadingLevelIcon.ON_LEVEL
						}),
						" ",
						counts ? counts.at : "-"
					),
					React.createElement(
						"span",
						{ className: "levelStat" },
						React.createElement(ReadingLevelIcon, {
							tooltipCopyType: ReadingLevelIcon.COLLECTIVE_VIEW,
							showImageOnly: true,
							status: ReadingLevelIcon.HARD
						}),
						" ",
						counts ? counts.over : "-"
					)
				);
			}
		}, {
			key: "renderExtraCellContent",
			value: function renderExtraCellContent(student, col) {
				var digest = this.digest(student.id);
				if (_.include([StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ, StudentMetrics.READING_OPTIONS.LAST_TEXT], col)) {
					return React.createElement(
						"em",
						{ className: "longContent" },
						StudentMetrics.getValue(digest, col)
					);
				} else if (col == StudentMetrics.READING_OPTIONS.MINUTES) {
					return this.renderReadingVerificationCell(student, digest ? digest.minutes_read : 0, digest ? digest.verified_minutes_read : 0);
				} else if (col == StudentMetrics.READING_OPTIONS.PAGES) {
					return this.renderReadingVerificationCell(student, digest ? digest.pages_read : 0, digest ? digest.verified_pages_read : 0);
				} else if (col == StudentMetrics.OTHER_OPTIONS.TOTAL_READER_LEVEL) {
					if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
						return this.renderReadingLevelCell(student, (digest ? digest.total_reader_level : "") + "");
					} else {
						return this.renderReadingLevelCell(student, (digest ? digest.current_reading_level : "") + "");
					}
				} else if (col == StudentMetrics.OTHER_OPTIONS.ACADEMIC_LEVEL) {
					return this.renderAcadmicLevelCell(student, digest.academic_level);
				} else if (col == StudentMetrics.QUIZZES_OPTIONS.ZPD_COUNTS) {
					return this.renderZPDCountsCell(student, digest.zpd_counts);
				} else {
					return React.createElement(
						"span",
						null,
						digest ? StudentMetrics.getValue(digest, col) : ""
					);
				}
			}
		}, {
			key: "renderSortControl",
			value: function renderSortControl() {
				var _this3 = this;
	
				var orderOptionText = function orderOptionText(op) {
					if (STUDENT_NAME_ORDER === op) {
						return "Student Name";
					} else if (LAST_ACTIVE === op) {
						return "Last Activity";
					} else {
						return StudentMetrics.getLabel(op);
					}
				};
	
				var renderOption = function renderOption(op) {
					return React.createElement(ButtonDropdownOption, { key: op, className: "",
						text: orderOptionText(op),
						onClick: _this3.changeSortBy.bind(_this3, op) });
				};
	
				var orderOptions = [];
	
				orderOptions.push(renderOption(STUDENT_NAME_ORDER));
				orderOptions.push(renderOption(LAST_ACTIVE));
	
				if (this.props.showGoals) {
					_.each(this.props.expectationMetrics, function (metric) {
						orderOptions.push(renderOption(metric));
					});
				} else {
					_.each(this.props.userMetricsColumns, function (metric) {
						orderOptions.push(renderOption(metric));
					});
				}
	
				var displayText = orderOptionText(this.state.orderBy);
	
				return React.createElement(
					ButtonDropdown,
					{ dropdownDisplay: "link", text: displayText },
					orderOptions
				);
			}
		}, {
			key: "renderMetricOptions",
			value: function renderMetricOptions(metrics, extraColIndex) {
				var _this4 = this;
	
				metrics = _.reject(metrics, function (m) {
					return _this4.props.isDisabledMetric(m) || _.contains(_this4.props.userMetricsColumns, m);
				});
				return metrics.map(function (columnKey) {
					return React.createElement(ButtonDropdownOption, {
						onClick: _this4.selectExtraColumn.bind(_this4, extraColIndex, columnKey),
						text: StudentMetrics.getLabel(columnKey),
						key: columnKey
					});
				});
			}
		}, {
			key: "renderTotalRow",
			value: function renderTotalRow() {
				var _this5 = this;
	
				if (!this.props.showTotals) {
					return;
				}
	
				var statCells = _.map(this.activeColumns(), function (col) {
					if (StudentMetrics.getType(col) == "numeric") {
						var total = 0;
	
						_.each(_this5.props.students, function (student) {
							var digest = _this5.digest(student.id);
							var value = digest ? StudentMetrics.getValue(digest, col) : 0;
	
							if (value != undefined && value != "-") {
								total += value;
							}
						});
					} else {
						var total = "-";
					}
	
					return React.createElement(
						"div",
						{ className: "statSection dataCell", key: col,
							style: { width: _this5.stateCellWidth() } },
						total
					);
				});
	
				return React.createElement(
					"div",
					{ className: "studentRow dataRow" },
					React.createElement(
						"div",
						{ className: "rowContent" },
						React.createElement(
							"div",
							{ className: "infoSection dataCell" },
							"Total"
						),
						statCells
					)
				);
			}
		}, {
			key: "renderTableHeaders",
			value: function renderTableHeaders() {
				var _this6 = this;
	
				// Index of this extra column (which are all on the right)
				var extraColIndex = 0;
	
				var headerCells = _.map(this.activeColumns(), function (col) {
					var colClassName = "statSection";
	
					if (_this6.props.showGoals) {
						var headerText = StudentMetrics.getLabel(col);
						var cellContents = React.createElement(
							"div",
							{ className: "columnHeaderText" },
							headerText
						);
						var sortLink = React.createElement(
							"div",
							{ className: "infoSection studentNameHeader sortControlCell hideOnPrint" },
							"Sort By: ",
							_this6.renderSortControl()
						);
					} else {
	
						var cellContents = React.createElement(
							ButtonDropdown,
							{ dropdownDisplay: "link", text: StudentMetrics.getLabel(col) },
							React.createElement(
								"li",
								{ className: "dropdown-header" },
								"Quizzes"
							),
							_this6.renderMetricOptions(StudentMetrics.quizMetrics(), extraColIndex),
							React.createElement(
								"li",
								{ className: "dropdown-header" },
								"Writing"
							),
							_this6.renderMetricOptions(StudentMetrics.writingMetrics(), extraColIndex),
							React.createElement(
								"li",
								{ className: "dropdown-header" },
								"Reading"
							),
							_this6.renderMetricOptions(StudentMetrics.readingMetrics(), extraColIndex),
							React.createElement(
								"li",
								{ className: "dropdown-header" },
								"Stats"
							),
							_this6.renderMetricOptions(StudentMetrics.otherMetrics(), extraColIndex)
						);
	
						extraColIndex += 1;
					}
					return React.createElement(
						"div",
						{ className: "statSection", key: col, style: { width: _this6.stateCellWidth() } },
						cellContents
					);
				});
	
				if (this.props.showTotals) {
					var sortLink = React.createElement(
						"div",
						{ className: "infoSection studentNameHeader sortControlCell hideOnPrint" },
						"Sort By: ",
						this.renderSortControl()
					);
				} else {
					var sortLink = React.createElement("div", { className: "infoSection studentNameHeader sortControlCell hideOnPrint" });
				}
	
				return React.createElement(
					"div",
					{ className: "studentRow headerRow" },
					React.createElement(
						"div",
						{ className: "rowContent" },
						sortLink,
						headerCells
					)
				);
			}
		}, {
			key: "renderStudentRows",
			value: function renderStudentRows() {
				var _this7 = this;
	
				var digestsBySums = _.sortBy(this.props.digests, function (digest) {
					var sum = 0;
					for (var i = 0; i <= _this7.props.expectationDigestKeys.length - 1; i++) {
						sum += digest[_this7.props.expectationDigestKeys[i]];
					}
					return sum;
				});
	
				var orderBy = this.props.sortByResults || this.state.orderBy;
	
				if (orderBy == LAST_ACTIVE) {
					var students = _.sortBy(this.props.students, function (student) {
						return student.last_active || "1970-01-01";
					}).reverse();
				} else if (orderBy == TOP_RESULTS) {
					var students = _.map(digestsBySums, function (digest) {
						return _.findWhere(_this7.props.students, { id: digest.student_id });
					}).reverse();
				} else if (orderBy == BOTTOM_RESULTS) {
					var students = _.map(digestsBySums, function (digest) {
						return _.findWhere(_this7.props.students, { id: digest.student_id });
					});
				} else if (StudentMetrics.isMetric(orderBy)) {
					var digestKey = StudentMetrics.getDigestEmbeds([orderBy]).split(",")[0];
	
					var toDigest = function toDigest(s) {
						var val = _this7.digest(s.id)[digestKey];
						return val === "-" ? undefined : val;
					};
	
					var hasValue = _.sortBy(_.select(this.props.students, toDigest), toDigest).reverse();
					var hasNoValue = _.reject(this.props.students, toDigest);
	
					var students = hasValue.concat(hasNoValue);
				} else {
					var students = $wr.sortByName(this.props.students, "flexName");
				}
	
				if (this.props.studentLimit) {
					var students = _.first(students, this.props.studentLimit);
				} else {
					if (!this.props.showFullData) {
						var students = _.first(students, 3);
					}
				}
	
				var activeColumns = this.activeColumns();
	
				var studentRows = students.map(function (student) {
					var digest = _this7.digest(student.id);
	
					var statCells = _.map(activeColumns, function (col) {
						var value = digest ? StudentMetrics.getValue(digest, col) : 0;
	
						if (_this7.props.showGoals) {
							var goal = _this7.getExpectation(col, student);
	
							return React.createElement(
								"div",
								{ className: "statSection dataCell", key: col,
									style: { width: _this7.stateCellWidth() } },
								React.createElement(
									"div",
									null,
									_this7.renderExpectationCellContent(student, col)
								),
								React.createElement(ProgressBar, { current: value, total: goal })
							);
						} else {
							return React.createElement(
								"div",
								{ className: "statSection dataCell", key: col,
									style: { width: _this7.stateCellWidth() } },
								_this7.renderExtraCellContent(student, col)
							);
						}
					});
	
					var cursorClass = "studentRow dataRow clickableElement";
	
					return React.createElement(
						"div",
						{ className: cursorClass, key: student.id,
							onClick: _this7.expandStudent.bind(_this7, student) },
						React.createElement(
							"div",
							{ className: "rowContent" },
							React.createElement(
								"div",
								{ className: "infoSection dataCell" },
								React.createElement(
									"div",
									{ className: "avatarBox hideOnPrint" },
									React.createElement(StudentAvatar, { disableAnimation: true, student: student, maxWidth: 30 })
								),
								React.createElement(
									"div",
									{ className: "infoSection studentName ellipsisText" },
									student.display_name,
									React.createElement(StudentListDisplay, { studentID: student.id })
								)
							),
							statCells
						)
					);
				});
	
				return React.createElement(
					"div",
					null,
					studentRows
				);
			}
		}, {
			key: "render",
			value: function render() {
				var innerClassName = "innerTable";
	
				return React.createElement(
					"div",
					{ className: "goalsTable" },
					React.createElement(
						"div",
						{ className: innerClassName },
						this.renderTableHeaders(),
						this.renderStudentRows(),
						this.renderTotalRow()
					)
				);
			}
		}]);
	
		return GoalsTable;
	}(React.Component)) || _class);
	
	
	var LAST_ACTIVE = "last-active";
	GoalsTable.LAST_ACTIVE = LAST_ACTIVE;
	
	var TOP_RESULTS = "top-results";
	GoalsTable.TOP_RESULTS = TOP_RESULTS;
	
	var BOTTOM_RESULTS = "bottom-results";
	GoalsTable.BOTTOM_RESULTS = BOTTOM_RESULTS;
	
	var STUDENT_NAME_ORDER = "student-name";
	
	GoalsTable.WrappedComponent.propTypes = StrictPropTypes({
		digests: PropTypes.array.isRequired,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showGoals: PropTypes.bool,
		showFullData: PropTypes.bool,
		userPrefs: PropTypes.object,
		reloadF: PropTypes.func,
		sortByResults: PropTypes.string,
		studentLimit: PropTypes.number,
		showTotals: PropTypes.bool,
		studentList: PropTypes.string,
		userIDs: PropTypes.array,
	
		// Data / fetchers from @connect
		userIsSchoolAdmin: PropTypes.bool,
		userIsTeacherAdmin: PropTypes.bool,
		students: PropTypes.array,
		expectationMetrics: PropTypes.array,
		userMetricsColumns: PropTypes.array,
		expectationDigestKeys: PropTypes.array,
		isDisabledMetric: PropTypes.func,
	
		// Handlers from @connect
		showHistoricalDataPaywall: PropTypes.func,
		updateDashboardColumns: PropTypes.func,
		createUserAlert: PropTypes.func
	
	});
	
	var COLUMN_COUNT = 4;
	
	module.exports = GoalsTable;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(15);
	
	var Features = __webpack_require__(16);
	var CurrentUser = __webpack_require__(3);
	
	var BookDisplay = __webpack_require__(46);
	var ReadingLevelDisplay = __webpack_require__(243);
	var GradeLevel = __webpack_require__(40);
	var ReadingLevelFormat = __webpack_require__(72);
	var PaywallModal = __webpack_require__(44);
	var Glyphicon = __webpack_require__(8);
	var Spinner = __webpack_require__(9);
	
	var RosterSelectors = __webpack_require__(6);
	var UIActions = __webpack_require__(41);
	
	__webpack_require__(3650);
	
	var ReadingLevelGraph = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
	
		downProps.clozeEnabled = Features.isEnabled(Features.CLOZE_ASSESSMENTS);
		downProps.lexileFormat = CurrentUser.get().prefs.reading_level_format;
	
		if (props.studentID) {
			var student = RosterSelectors.student({ state: state, id: props.studentID });
			if (student) {
				downProps.studentName = student.first_name;
			}
		}
	
		if (student && _.isEmpty(props.readingLevels)) {
			downProps.useGradeLevelRange = true;
			downProps.gradeLevel = student.grade_level;
		}
	
		var currentYear = $wr.momentInTimezone(new Date()).year();
		var currentMonth = $wr.momentInTimezone(new Date()).month();
	
		if (props.numMonths) {
			downProps.numMonths = props.numMonths;
			downProps.endDate = new Date(currentYear, currentMonth + 1, 1).getTime();
			downProps.startDate = new Date(currentYear, currentMonth - props.numMonths, 1).getTime();
		} else {
			var dateInfo = CurrentUser.fetchSchoolYearDates();
	
			downProps.startDate = dateInfo.startDate;
			downProps.endDate = dateInfo.endDate;
			downProps.numMonths = dateInfo.numMonths;
		}
	
		var books = _.select(props.books, function (book) {
			if (!book.lexile_score) {
				return false;
			}
			var dateVal = $wr.momentInTimezone(book.last_actives[props.studentID]).valueOf();
			return dateVal > downProps.startDate && dateVal < downProps.endDate;
		});
	
		var bookData = _.map(books, function (book) {
			return _.extend({}, book, {
				reading_level: book.lexile_score,
				date: $wr.momentInTimezone(book.last_actives[props.studentID]).valueOf()
			});
		});
	
		downProps.bookData = _.sortBy(bookData, "date");
		return downProps;
	}, function (dispatch) {
		return {
			openZpdPaywall: function openZpdPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ReadingLevelGraph, _React$Component);
	
		function ReadingLevelGraph(props) {
			_classCallCheck(this, ReadingLevelGraph);
	
			var _this = _possibleConstructorReturn(this, (ReadingLevelGraph.__proto__ || Object.getPrototypeOf(ReadingLevelGraph)).call(this));
	
			autobind(_this);
	
			_this.state = {
				loadedDependencies: false
			};
	
			_this.getRenderKey = _this.getRenderKey.bind(_this);
			return _this;
		}
	
		_createClass(ReadingLevelGraph, [{
			key: "openPaywall",
			value: function openPaywall(e) {
				$wr.nope(e);
				this.props.openZpdPaywall();
			}
		}, {
			key: "renderLegend",
			value: function renderLegend() {
				if (this.props.useGradeLevelRange) {
					var zpdLabel = "Target reading range (default for " + GradeLevel.getName(this.props.gradeLevel) + ")";
					var name = this.props.studentName || "this student";
	
					var defaultMessage = React.createElement(
						"span",
						null,
						"This ",
						React.createElement(
							"em",
							null,
							"Target Reading Range"
						),
						" (default) is based on grade level."
					);
	
					if (this.props.clozeEnabled) {
						var fallbackSection = React.createElement(
							"div",
							{ className: "fallbackMessage" },
							defaultMessage,
							React.createElement("br", null),
							"Once ",
							name,
							" completes enough Cloze Assessments, their assessed reading level will show here."
						);
					} else {
						var fallbackSection = React.createElement(
							"div",
							null,
							React.createElement(
								"div",
								{ className: "fallbackMessage" },
								defaultMessage,
								React.createElement("br", null),
								React.createElement(
									"a",
									{ href: "#", onClick: this.openPaywall },
									"View ",
									name,
									"'s ",
									React.createElement(
										"em",
										null,
										"Target Reading Range"
									)
								),
								" based on their assessed reading level."
							),
							React.createElement(PaywallModal, { ref: "paywallModal", featureType: PaywallModal.CLOZE_ASSESSMENTS })
						);
					}
	
					var zpdTooltip = "This range of texts challenges students while still being understandable.";
				} else {
					var zpdTooltip = "This range of texts challenges students while still being understandable.";
					if (this.props.readingLevels && _.any(this.props.readingLevels)) {
						var assessmentIcon = React.createElement(
							"span",
							{ className: "item" },
							React.createElement("span", { className: "assessmentIcon", style: { backgroundColor: ASSESSMENT_COLOR } }),
							" ",
							"Assessments"
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "legend" },
					React.createElement(
						"div",
						null,
						React.createElement(
							"span",
							{ className: "item" },
							React.createElement("span", { className: "textIcon", style: { backgroundColor: TEXT_COLOR } }),
							" ",
							"Texts (hover for details)"
						),
						assessmentIcon,
						React.createElement(
							"span",
							{ className: "item text-left" },
							React.createElement("span", { className: "zpdIcon", style: { borderColor: ZPD_COLOR } }),
							" ",
							"Target Reading Range ",
							React.createElement(Glyphicon, { icon: "question-sign", dataTip: zpdTooltip })
						)
					),
					fallbackSection
				);
			}
	
			//this method tries to force the chart to rerender each time it gets new data, so axis and info appear right
	
		}, {
			key: "getRenderKey",
			value: function getRenderKey() {
				var obj = {};
				if (this.props.gradeLevel) {
					obj = _extends({}, obj, this.props.gradeLevel);
				}
				if (this.props.readingLevels) {
					obj = _extends({}, obj, this.props.readingLevels);
				}
				return btoa(JSON.stringify(obj));
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.state.loadedDependencies) {
					return React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				var _props = this.props,
				    startDate = _props.startDate,
				    endDate = _props.endDate,
				    numMonths = _props.numMonths,
				    currentYear = _props.currentYear,
				    currentMonth = _props.currentMonth,
				    bookData = _props.bookData;
	
				// always display at least DEFAULT_MIN_MONTHS months
	
				if (numMonths < DEFAULT_MIN_MONTHS) {
					numMonths = DEFAULT_MIN_MONTHS;
					endDate = new Date(currentYear, currentMonth + DEFAULT_MIN_MONTHS, 1).getTime();
				}
	
				var tickArray = [];
				for (var i = 1; i <= numMonths; i++) {
					tickArray.push(moment(startDate).add(i, "months").valueOf());
				}
	
				if (this.props.useGradeLevelRange) {
					var gradeLexile = ReadingLevelFormat.lexileForGrade(this.props.gradeLevel);
	
					var upperLevelData = [{
						reading_level: gradeLexile + LEXILE_OVER_ZPD,
						date: moment(startDate).valueOf()
					}, {
						reading_level: gradeLexile + LEXILE_OVER_ZPD,
						date: moment(endDate).valueOf()
					}];
					var lowerLevelData = [{
						reading_level: gradeLexile - LEXILE_UNDER_ZPD,
						date: moment(startDate).valueOf()
					}, {
						reading_level: gradeLexile - LEXILE_UNDER_ZPD,
						date: moment(endDate).valueOf()
					}];
				} else {
					// ZPD based on reading level assessments
					var readingLevelData = [];
					var upperLevelData = [];
					var lowerLevelData = [];
	
					var sortedReadingLevels = _.sortBy(this.props.readingLevels, "created_at");
					var readingLevels = _.select(sortedReadingLevels, function (readingLevel) {
						var dateVal = $wr.momentInTimezone(readingLevel.created_at).valueOf();
						return dateVal > startDate && dateVal < endDate;
					});
	
					if (readingLevels.length < 1) {
						readingLevels = [sortedReadingLevels[sortedReadingLevels.length - 1]];
	
						_.each(readingLevels, function (readingLevel) {
							var point = _.extend({}, readingLevel, {
								date: moment(startDate).valueOf()
							});
	
							readingLevelData.push(point);
							upperLevelData.push(_.extend({}, point, {
								reading_level: point.reading_level + LEXILE_OVER_ZPD
							}));
							lowerLevelData.push(_.extend({}, point, {
								reading_level: Math.max(point.reading_level - LEXILE_UNDER_ZPD, 0)
							}));
						});
	
						assessmentsScatter = null;
					} else {
						_.each(readingLevels, function (readingLevel) {
							var point = _.extend({}, readingLevel, {
								date: $wr.momentInTimezone(readingLevel.created_at).valueOf()
							});
	
							readingLevelData.push(point);
							upperLevelData.push(_.extend({}, point, {
								reading_level: point.reading_level + LEXILE_OVER_ZPD
							}));
							lowerLevelData.push(_.extend({}, point, {
								reading_level: Math.max(point.reading_level - LEXILE_UNDER_ZPD, 0)
							}));
						});
	
						var assessmentsScatter = React.createElement(Recharts.Scatter, { name: "Assessments", data: readingLevelData,
							fill: ASSESSMENT_COLOR, shape: "square", isAnimationActive: false });
					}
	
					_.each([upperLevelData, lowerLevelData], function (series) {
						if (series.length > 0) {
							series.unshift({
								reading_level: series[0].reading_level,
								date: moment(startDate).valueOf()
							});
							series.push({
								reading_level: _.last(series).reading_level,
								date: moment(endDate).valueOf()
							});
						}
					});
				}
	
				var format = this.props.lexileFormat;
	
				function formatYLabel(yVal) {
					// Has to be string, or I'd use ReadingLevelDisplay
					var lexileFormatted = ReadingLevelFormat.getScoreForFormat(yVal, format);
					return lexileFormatted;
				}
	
				var yAxisLabel = "Reading Level (" + format + ")";
	
				var chartHeight = 350;
	
				return React.createElement(
					"div",
					{ className: "readingLevelGraph" },
					this.renderLegend(),
					React.createElement(
						"div",
						{ className: "yLabelWrap", style: { height: chartHeight - 100 } },
						React.createElement(
							"div",
							{ className: "yLabel", style: { maxWidth: chartHeight - 150 } },
							yAxisLabel
						)
					),
					React.createElement(
						"div",
						{ className: "chartWrap" },
						React.createElement(
							Recharts.ResponsiveContainer,
							{ height: chartHeight, width: "100%" },
							React.createElement(
								Recharts.ScatterChart,
								{ key: this.getRenderKey() },
								React.createElement(Recharts.XAxis, { key: 'x_' + this.getRenderKey(), dataKey: "date", name: "Date", type: "number",
									domain: [startDate, endDate], interval: 0,
									tick: React.createElement(CustomizedAxisTick, null), ticks: tickArray, tickCount: numMonths + 2, height: 70 }),
								React.createElement(Recharts.YAxis, { key: 'y_' + this.getRenderKey(), dataKey: "reading_level", type: "number", tickFormatter: formatYLabel, name: "Points" }),
								React.createElement(Recharts.ZAxis, { key: 'z_' + this.getRenderKey(), range: [100] }),
								React.createElement(Recharts.CartesianGrid, { stroke: "#ddd" }),
								React.createElement(Recharts.Tooltip, { content: React.createElement(CustomTooltip, { studentID: this.props.studentID }) }),
								assessmentsScatter,
								React.createElement(Recharts.Scatter, { name: "ZPD", data: upperLevelData, line: { strokeWidth: 2 },
									fill: ZPD_COLOR, shape: function shape() {
										return null;
									}, isAnimationActive: false }),
								React.createElement(Recharts.Scatter, { name: "ZPD", data: lowerLevelData, line: { strokeWidth: 2 },
									fill: ZPD_COLOR, shape: function shape() {
										return null;
									}, isAnimationActive: false }),
								React.createElement(Recharts.Scatter, { name: "Texts", data: bookData, fill: TEXT_COLOR,
									shape: "circle", isAnimationActive: false })
							)
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				$wr.loadScript("/dependencies/recharts.min.js", "Recharts", function () {
					_this2.setState({ loadedDependencies: true });
				});
			}
		}]);
	
		return ReadingLevelGraph;
	}(React.Component)) || _class);
	;
	
	var CustomizedAxisTick = function (_React$Component2) {
		_inherits(CustomizedAxisTick, _React$Component2);
	
		function CustomizedAxisTick() {
			_classCallCheck(this, CustomizedAxisTick);
	
			return _possibleConstructorReturn(this, (CustomizedAxisTick.__proto__ || Object.getPrototypeOf(CustomizedAxisTick)).apply(this, arguments));
		}
	
		_createClass(CustomizedAxisTick, [{
			key: "render",
			value: function render() {
				var _props2 = this.props,
				    x = _props2.x,
				    y = _props2.y,
				    payload = _props2.payload;
	
	
				return React.createElement(
					"g",
					{ transform: "translate(" + x + "," + y + ")" },
					React.createElement(
						"text",
						{ x: 0, y: 0, dy: 16, textAnchor: "end", fill: "#555", transform: "rotate(-35)" },
						moment(new Date(payload.value)).format("MMM 'YY")
					)
				);
			}
		}]);
	
		return CustomizedAxisTick;
	}(React.Component);
	
	;
	
	var TOOLTIP_DATE_FORMAT = "MMM D, YYYY";
	
	var LEXILE_OVER_ZPD = 50;
	var LEXILE_UNDER_ZPD = 100;
	
	var DEFAULT_MIN_MONTHS = 4;
	
	var ASSESSMENT_COLOR = "#42af14";
	var TEXT_COLOR = "#00a0f4";
	var ZPD_COLOR = "#c0f2aa";
	
	var CustomTooltip = function (_React$Component3) {
		_inherits(CustomTooltip, _React$Component3);
	
		function CustomTooltip() {
			_classCallCheck(this, CustomTooltip);
	
			return _possibleConstructorReturn(this, (CustomTooltip.__proto__ || Object.getPrototypeOf(CustomTooltip)).apply(this, arguments));
		}
	
		_createClass(CustomTooltip, [{
			key: "render",
			value: function render() {
				if (this.props.active) {
					var payload = this.props.payload[0].payload;
	
					if (payload.text_id) {
						// It's a book!
						var date = payload.last_actives[this.props.studentID];
	
						return React.createElement(
							"div",
							{ className: "bookTooltip" },
							React.createElement(
								BookDisplay,
								{ textID: payload.text_id, contingentShowCover: true, coverWidth: 70 },
								"Level: ",
								React.createElement(ReadingLevelDisplay, { lexile: payload.reading_level }),
								React.createElement("br", null),
								moment(date).format(TOOLTIP_DATE_FORMAT)
							)
						);
					} else if (payload.origin) {
						var originText = ReadingLevelDisplay.ORIGIN_TEXTS[payload.origin];
						// It's a lexile assessment!
						return React.createElement(
							"div",
							{ className: "assessmentTooltip" },
							originText,
							React.createElement("br", null),
							"Level: ",
							React.createElement(ReadingLevelDisplay, { lexile: payload.reading_level }),
							React.createElement("br", null),
							moment(new Date(payload.date)).format(TOOLTIP_DATE_FORMAT)
						);
					}
				}
	
				return null;
			}
		}]);
	
		return CustomTooltip;
	}(React.Component);
	
	;
	
	var CustomizedShape = function (_React$Component4) {
		_inherits(CustomizedShape, _React$Component4);
	
		function CustomizedShape() {
			_classCallCheck(this, CustomizedShape);
	
			return _possibleConstructorReturn(this, (CustomizedShape.__proto__ || Object.getPrototypeOf(CustomizedShape)).apply(this, arguments));
		}
	
		_createClass(CustomizedShape, [{
			key: "render",
			value: function render() {
				return null;
			}
		}]);
	
		return CustomizedShape;
	}(React.Component);
	
	ReadingLevelGraph.propTypes = StrictPropTypes({
		books: PropTypes.array.isRequired,
		studentID: PropTypes.number,
		readingLevels: PropTypes.array,
		useGradeLevelRange: PropTypes.bool,
		gradeLevel: PropTypes.number,
		studentName: PropTypes.string,
	
		startDate: PropTypes.number,
		endDate: PropTypes.number,
		numMonths: PropTypes.number,
		currentYear: PropTypes.number,
		currentMonth: PropTypes.number,
	
		openZpdPaywall: PropTypes.func,
	
		clozeEnabled: PropTypes.string,
		lexileFormat: PropTypes.string
	});
	
	module.exports = ReadingLevelGraph;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _GraphUtility = __webpack_require__(99);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var StudentAvatar = __webpack_require__(35);
	var Board = __webpack_require__(168);
	var Carousel = __webpack_require__(419);
	var Spinner = __webpack_require__(9);
	var TextAreaMarkups = __webpack_require__(196);
	var EmptyStateContainer = __webpack_require__(80);
	var FeedbackFormatter = __webpack_require__(73);
	var AssignTaskModal = __webpack_require__(199);
	
	var RubricRadarGraph = __webpack_require__(377);
	
	var Features = __webpack_require__(16);
	var PaywallLink = __webpack_require__(414);
	var ReactionFeedback = __webpack_require__(101);
	var Modal = __webpack_require__(18);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var INDIVIDUAL_VIEW = 'individual-view';
	var GROUP_VIEW = 'group-view';
	var COMPARISON_VIEW = 'comparison-view';
	var PROGRESS_VIEW = 'progress-view';
	
	__webpack_require__(649);
	
	var SkillsetsPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			user: CurrentUser.get(),
			activities: WritingSelectors.getMostRecentActivities({ state: state, withAssigned: true }) || [],
			studentLists: RosterSelectors.studentLists({ state: state, embeds: ["student_list.students", "student.avatar", "student.prefs", "student.current_reading_level"] })
		};
	}, function (dispatch, props) {
		return {
			fetchActivities: function fetchActivities(attr) {
				var filters = attr.filters,
				    conditions = attr.conditions,
				    embeds = attr.embeds,
				    page = attr.page,
				    cache = attr.cache;
	
				return dispatch(WritingActions.fetchActivities({
					filters: filters, conditions: conditions, embeds: embeds, page: page, cache: cache
				}));
			},
			fetchStudentLists: function fetchStudentLists() {
				return dispatch(RosterActions.fetchStudentLists({
					embeds: ["student_list.students", "student.avatar", "student.prefs", "student.current_reading_level"]
				}));
			},
			fetchStudentList: function fetchStudentList(id) {
				return dispatch(RosterActions.fetchStudentList({
					id: id,
					embeds: ["student_list.students", "student_list.grade_level", "student.avatar", "student.prefs", "student.student_list.primary_admin", "student.perks"]
				}));
			},
			fetchStudent: function fetchStudent(id) {
				return dispatch(RosterActions.fetchStudent({
					id: id,
					embeds: ["student.avatar", "student.prefs", "student.current_reading_level"]
				}));
			},
			clearActivities: function clearActivities() {
				return dispatch(WritingActions.clearActivities());
			},
	
			populateData: function populateData() {
				// TODO: standardize FE requests
				return dispatch(function (dispatch, getState) {
					var userIDs = _underscore2.default.pluck(RosterSelectors.students({ state: getState() }), "id");
					if ($wr.isLargeRequest(props.userIDs)) {
						var actionFunction = WritingActions.fetchTasks;
						var options = { filters: { subject_type: "exercise" }, query: { completed: false }, cache: true };
						return new Promise(function (resolve, reject) {
							$wr.handleLargeRequest(dispatch, userIDs, {}, actionFunction, options, function (results) {
								resolve(results);
							});
						}).catch(function () {
							return console.log("Tasks failed to load");
						});
					} else {
						return dispatch(WritingActions.fetchTasks({
							filters: { subject_type: "exercise" },
							query: { completed: false },
							cache: true
						}));
					}
				});
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(SkillsetsPage, _React$Component);
	
		function SkillsetsPage(props) {
			_classCallCheck(this, SkillsetsPage);
	
			var _this = _possibleConstructorReturn(this, (SkillsetsPage.__proto__ || Object.getPrototypeOf(SkillsetsPage)).call(this));
	
			autobind(_this);
			_this.assignTaskModal = React.createRef();
			if ($wr.getURLParameterByName("view")) {
				var initialView = $wr.getURLParameterByName("view");
			} else {
				var initialView = INDIVIDUAL_VIEW;
			}
	
			_this.state = {
				currentView: initialView,
				studentLists: props.studentLists || null, activeStudentList: {},
				activeStudent: null,
				exercisesByParams: {}, activityToAssignID: null,
				selectedActivityTitle: "",
				activeAttributeIndex: null, activeTypeKey: "weak",
				activeIndividualData: null, activeGroupData: null
			};
			return _this;
		}
	
		_createClass(SkillsetsPage, [{
			key: "selectAttribute",
			value: function selectAttribute(activeTypeKey, attributeIndex, e) {
				$wr.nope(e);
				this.setState({ activeTypeKey: activeTypeKey, activeAttributeIndex: attributeIndex }, this.fetchActiveExercises);
			}
		}, {
			key: "assignActivity",
			value: function assignActivity(activity) {
				var _this2 = this;
	
				this.setState({ activityToAssignID: activity.id,
					selectedActivityTitle: activity.format_summary.title }, function () {
					if (_this2.refs.assignTaskModal) {
						_this2.refs.assignTaskModal.show();
					}
				});
			}
		}, {
			key: "hideModal",
			value: function hideModal(selectedUserIDs, showNextModal) {
				this.refs.assignTaskModal.hide();
			}
		}, {
			key: "dividerWithTitle",
			value: function dividerWithTitle(titleText) {
				return React.createElement(
					"div",
					{ className: "dividerWithTitle" },
					React.createElement("div", { className: "dividerArea" }),
					React.createElement(
						"div",
						{ className: "titleArea" },
						titleText
					)
				);
			}
		}, {
			key: "isIndividualView",
			value: function isIndividualView() {
				return this.props.entityType == _GraphUtility.STUDENT;
			}
		}, {
			key: "isGroupView",
			value: function isGroupView() {
				return this.props.entityType == _GraphUtility.STUDENT_LIST;
			}
		}, {
			key: "getActiveAttributeData",
			value: function getActiveAttributeData() {
				var data = this.isIndividualView() ? this.state.activeIndividualData : this.state.activeGroupData;
				if (data && data[this.state.activeTypeKey]) {
					return data[this.state.activeTypeKey][this.state.activeAttributeIndex];
				}
	
				return null;
			}
		}, {
			key: "showEmptyState",
			value: function showEmptyState() {
				var data = this.isIndividualView() ? this.state.activeIndividualData : this.state.activeGroupData;
	
				if (data) {
					return (data["weak"] || []).length == 0 && (data["strong"] || []).length == 0;
				}
	
				return false;
			}
		}, {
			key: "attributeListDisplay",
			value: function attributeListDisplay(attributeKey) {
				var _this3 = this;
	
				if (this.isIndividualView()) {
					var data = this.state.activeIndividualData;
				} else {
					var data = this.state.activeGroupData;
				}
				var attributeList = data[attributeKey];
	
				if (!attributeList || attributeList.length == 0) {
					var emptyText = "We don't have enough data yet to report on ";
					if (this.isIndividualView()) {
						emptyText += this.props.entity.first_name + "'s ";
					} else {
						emptyText += " this class' ";
					}
	
					if (attributeKey == "weak") {
						emptyText += "weaknesses.";
					} else {
						emptyText += "strengths.";
					}
					return React.createElement(
						"p",
						{ className: "colEmpty" },
						emptyText
					);
				}
	
				if (attributeKey == this.state.activeTypeKey) {
					var selAttributeTag = this.getActiveAttributeData().key;
				} else {
					var selAttributeTag = undefined;
				}
	
				var attributesDisplay = _underscore2.default.map(attributeList, function (attribute, index) {
					var attributeClass = "attributeRow";
					var nextIndex = index + 1;
					if (attribute.key == selAttributeTag) {
						attributeClass += " selectedAttribute";
					} else if (attributeList.length > nextIndex && attributeList[nextIndex].key == selAttributeTag) {
						attributeClass += " beforeSelectedAttribute";
					}
	
					if (_this3.isIndividualView()) {
						var scoreLine = React.createElement(
							"span",
							{ className: "attributeScore" },
							attribute.count,
							" ",
							$wr.pluralize("time", attribute.count)
						);
					} else {
						var scoreLine = React.createElement(
							"span",
							{ className: "attributeScore" },
							attribute.count,
							"/",
							attribute.total,
							" students"
						);
					}
	
					return React.createElement(
						"a",
						{ className: attributeClass, key: attribute.tag, href: "#",
							onClick: _this3.selectAttribute.bind(_this3, attributeKey, index) },
						React.createElement(
							"span",
							{ className: "attrName ellipsisText" },
							attribute.title
						),
						scoreLine
					);
				});
	
				return React.createElement(
					"div",
					null,
					attributesDisplay
				);
			}
	
			// creates the strengths + weaknesses part
	
		}, {
			key: "renderIndividualObservationsDisplay",
			value: function renderIndividualObservationsDisplay() {
				if (this.showEmptyState()) {
					var studentName = this.props.entity.first_name;
					if (!Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						var paywallSection = React.createElement(PaywallLink, { featureLocation: PaywallLink.INSIGHTS });
					}
					var displayContent = React.createElement(
						"div",
						null,
						React.createElement(EmptyStateContainer, { statusText: "There isn't enough data yet to report on " + studentName + "'s strengths and weaknesses.",
							imagePath: __webpack_require__(295) }),
						paywallSection
					);
				} else {
					var displayContent = React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-6" },
							React.createElement(
								"h3",
								null,
								"Weaknesses"
							),
							this.attributeListDisplay("weak")
						),
						React.createElement(
							"div",
							{ className: "col-sm-6" },
							React.createElement(
								"h3",
								null,
								"Strengths"
							),
							this.attributeListDisplay("strong")
						)
					);
	
					if (this.getActiveAttributeData()) {
						var descriptionText = FeedbackFormatter.formatSimple(this.getActiveAttributeData().description, { "firstName": this.props.entity.first_name });
						var description = React.createElement(
							"p",
							{ className: "itemDescription" },
							descriptionText
						);
					}
				}
	
				var radarGraph = this.renderComparisonDisplay();
	
				return React.createElement(
					"div",
					{ className: "individualObservations" },
					radarGraph,
					displayContent,
					description
				);
			}
		}, {
			key: "renderGroupObservationsDisplay",
			value: function renderGroupObservationsDisplay() {
				var attributeLists = React.createElement(
					"div",
					{ className: "row" },
					React.createElement(
						"div",
						{ className: "col-sm-6" },
						React.createElement(
							"h3",
							null,
							"Weaknesses"
						),
						this.attributeListDisplay("weak")
					),
					React.createElement(
						"div",
						{ className: "col-sm-6" },
						React.createElement(
							"h3",
							null,
							"Strengths"
						),
						this.attributeListDisplay("strong")
					)
				);
				var attributeData = this.getActiveAttributeData();
	
				var students = $wr.sortByName(this.props.entity.students, "flexName");
	
				if (attributeData != undefined) {
					var studentNameDisplays = _underscore2.default.compact(_underscore2.default.map(students, function (student) {
						if (_underscore2.default.includes(attributeData.user_ids, student.id)) {
							return React.createElement(
								"div",
								{ className: "nameAvatarDisplay", key: student.id },
								React.createElement(StudentAvatar, { disableAnimation: true, student: student, maxWidth: 50 }),
								React.createElement(
									"span",
									{ className: "studentName ellipsisText" },
									student.display_name
								)
							);
						}
					}));
					var description = FeedbackFormatter.formatSimple(this.getActiveAttributeData().description, { "firstName": "This group" });
	
					var examples = this.renderExampleCarousel(attributeData.examples, true);
				}
	
				var radarGraph = this.renderComparisonDisplay();
	
				return React.createElement(
					"div",
					{ className: "groupObservations" },
					radarGraph,
					attributeLists,
					React.createElement(
						"p",
						{ className: "itemDescription" },
						description
					),
					studentNameDisplays,
					this.dividerWithTitle("Examples"),
					examples
				);
			}
		}, {
			key: "renderExampleCarousel",
			value: function renderExampleCarousel(examples, showStudent) {
				var _this4 = this;
	
				examples = _underscore2.default.select(examples, function (example) {
					return example.answer;
				});
				var exampleDisplays = _underscore2.default.map(examples, function (example) {
					var answer = example.answer;
					var answerDetailsClassName = "answerDetails";
					if (showStudent) {
						var student = _underscore2.default.find(_this4.state.activeStudentList.students, function (student) {
							return student.id == answer.user_id;
						});
						if (student) {
							answerDetailsClassName += " withStudent";
							var studentDisplay = React.createElement(
								"div",
								{ className: "nameAvatarDisplay" },
								React.createElement(StudentAvatar, { disableAnimation: true, student: student, maxWidth: 40 }),
								React.createElement(
									"span",
									{ className: "studentName ellipsisText" },
									student.first_name
								)
							);
						}
					}
					return React.createElement(
						"div",
						{ key: answer.id, className: "singleExample" },
						studentDisplay,
						React.createElement(
							"p",
							{ className: answerDetailsClassName },
							React.createElement(
								"i",
								null,
								answer.text.title
							),
							", ",
							answer.text.author_full_name,
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "answerDate" },
								$wr.formatDate(answer.completed_at)
							)
						),
						React.createElement(
							"p",
							null,
							React.createElement(
								"strong",
								null,
								answer.question_text
							)
						),
						React.createElement(TextAreaMarkups, { text: example.corrected_answer, tagging: example.tagging })
					);
				});
	
				return React.createElement(Carousel, { displayItems: exampleDisplays,
					key: this.state.activeTypeKey + this.state.activeAttributeIndex });
			}
		}, {
			key: "renderIndividualExamplesDisplay",
			value: function renderIndividualExamplesDisplay() {
				var activeData = this.getActiveAttributeData();
				if (!activeData) {
					return React.createElement("div", { className: "emptyExample" });
				}
	
				return React.createElement(
					"div",
					{ className: "individualExamples" },
					this.dividerWithTitle("Examples"),
					this.renderExampleCarousel(activeData.examples, false)
				);
			}
		}, {
			key: "renderExercisesDisplay",
			value: function renderExercisesDisplay() {
				var attributeData = this.getActiveAttributeData();
	
				if (attributeData == undefined || _underscore2.default.isEmpty(attributeData.exercise_params)) {
					return React.createElement("div", { className: "emptyExercises" });
				}
				// filter activities and display first 3
				var exercises = $wr.sortByName(this.props.activities, "flexName").splice(0, 3);
	
				if (this.isIndividualView()) {
					var previewParameters = { "assign_student_ids": this.props.entity.id };
					if (this.props.entity.prefs) {
						var gradeLevel = this.props.entity.prefs.academic_level;
					} else {
						var gradeLevel = null;
					}
				} else {
					var previewParameters = { "assign_student_ids": attributeData.user_ids.join(",") };
					var gradeLevel = this.props.entity.grade_level;
				}
	
				if (exercises) {
					if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						var recommendedExercises = React.createElement(Board, { type: Board.TEACHER_ACTIVITIES, items: exercises, narrowBoard: true,
							previewParameters: previewParameters,
							onItemAssign: this.assignActivity });
					} else {
						var recommendedExercises = React.createElement(Board, { type: Board.TEACHER_ACTIVITIES, items: exercises, narrowBoard: true,
							previewParameters: previewParameters,
							onItemAssign: this.showPaywall, onTileClick: this.showPaywall });
					}
				} else {
					var recommendedExercises = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				}
	
				var exercisePagePath = "/exercises?grade_level=" + gradeLevel;
				if ("skillsets" in attributeData.exercise_params) {
					exercisePagePath += "&skillset=" + attributeData.exercise_params.skillsets;
				}
	
				if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
					var subheader = React.createElement(
						"p",
						{ className: "exercisesSubheader" },
						"Assign these exercises focused on ",
						attributeData.title,
						", or ",
						React.createElement(
							_reactRouterDom.Link,
							{ to: exercisePagePath, target: "_blank" },
							"find more here"
						),
						"."
					);
				} else {
					var subheader = React.createElement(
						"p",
						{ className: "exercisesSubheader" },
						"Assign these online exercises focused on ",
						attributeData.title,
						" or print and hand them out in class."
					);
				}
	
				return React.createElement(
					"div",
					{ className: "exercises" },
					this.dividerWithTitle("Exercises"),
					subheader,
					recommendedExercises
				);
			}
		}, {
			key: "renderComparisonDisplay",
			value: function renderComparisonDisplay() {
				var _this5 = this;
	
				if (this.showEmptyState()) {
					return;
				}
	
				if (this.isIndividualView()) {
	
					// find the student list that the student belongs to, so we can compare. 
					var studentList = _underscore2.default.find(this.props.studentLists, function (studentList) {
						// students are attached to the student lists, but can either be a obj or id.
						return _underscore2.default.find(studentList.students, function (student) {
							return _underscore2.default.isEqual(student, _this5.props.entity) || student == _this5.props.entity.id;
						});
					});
	
					var radarGraph = React.createElement(RubricRadarGraph, { entity: this.props.entity, entityType: _GraphUtility.STUDENT, comparisons: [studentList], comparisonType: _GraphUtility.STUDENT_LIST });
				} else {
					// dont want to be compared against itself
					var studentLists = _underscore2.default.filter([].concat(_toConsumableArray(this.props.studentLists)), function (sl) {
						return sl.id != _this5.props.entity.id;
					});
					var radarGraph = React.createElement(RubricRadarGraph, { entity: this.props.entity, entityType: _GraphUtility.STUDENT_LIST, comparisons: studentLists, comparisonType: _GraphUtility.STUDENT_LIST });
				}
	
				return radarGraph;
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.props.entity) {
					var rosterLink = "addNewStudentsButton=true";
					var emptyActionText = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "insightsEmptyText" },
							"It looks like you haven't added any students yet.",
							React.createElement(
								_reactRouterDom.Link,
								{ to: "/roster?" + rosterLink },
								" Add students "
							),
							"and their strengths and learning gaps (",
							React.createElement(
								"i",
								null,
								"Insights"
							),
							") will appear here!"
						),
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/roster?" + rosterLink },
							React.createElement(
								"button",
								{ className: "btn buttonPrimary" },
								"Add Students"
							)
						)
					);
	
					var emptyImgPath = __webpack_require__(295);
					var emptyState = React.createElement(EmptyStateContainer, { actionText: emptyActionText,
						linkPath: "/roster?" + rosterLink, imagePath: emptyImgPath, sideBar: true });
					return emptyState;
				}
	
				var isLoading = this.isIndividualView() && !this.state.activeIndividualData || this.isGroupView() && !this.state.activeGroupData || this.state.activeAttributeIndex == null;
				if (isLoading) {
					return React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
					if (this.isIndividualView()) {
						var observationsContent = this.renderIndividualObservationsDisplay();
						var examplesContent = this.renderIndividualExamplesDisplay();
					} else {
						if (this.showEmptyState()) {
							var observationsContent = React.createElement(EmptyStateContainer, { statusText: "There isn't enough data yet to report on the strengths and weaknesses of these students.",
								imagePath: __webpack_require__(1555) });
						} else {
							var observationsContent = this.renderGroupObservationsDisplay();
						}
					}
					var exercisesDisplay = this.renderExercisesDisplay();
	
					if (this.state.activityToAssignID) {
	
						if (this.isIndividualView()) {
							var studentIDs = [this.props.entity];
							var activeStudentList = this.state.activeStudentList;
						} else {
							var studentIDs = this.getActiveAttributeData().user_ids;
						}
	
						var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
	
						var assignTaskModal = React.createElement(
							Modal,
							{ headerText: modalHeader, ref: "assignTaskModal" },
							React.createElement(AssignTaskModal, { key: this.state.activityToAssignID,
								selectedStudentIDs: studentIDs,
								renderAdditionalModal: true,
								taskSubjectType: "exercise",
								taskSubjectID: this.state.activityToAssignID,
								studentLists: activeStudentList,
								selectedActivityTitle: this.state.selectedActivityTitle,
								onAssign: this.hideModal })
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "container teacherInsightsPage" },
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-9" },
							observationsContent,
							examplesContent,
							exercisesDisplay
						)
					),
					assignTaskModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.fetchActiveData();
	
				$(window.document).on("standards-updated", this.onStandardsUpdate);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				this._unmounted = true;
				$(window.document).off("standards-updated", this.onStandardsUpdate);
			}
		}, {
			key: "fetchActiveExercises",
			value: function fetchActiveExercises() {
				var _this6 = this;
	
				if (this.getActiveAttributeData() == undefined) {
					return;
				}
				var exerciseParams = this.getActiveAttributeData().exercise_params;
	
				if (!exerciseParams) {
					return;
				}
				var paramsKey = JSON.stringify(exerciseParams);
				if (paramsKey in this.state.exercisesByParams) {
					return;
				}
	
				var params = _underscore2.default.pick(exerciseParams, "skillsets");
	
				params["embed"] = "activity.format_summary";
				params["grade_levels"] = CurrentUser.get().grade_level;
				params["sample"] = 3;
				// get relevant activities based on the student
				this.props.fetchActivities({
					page: null,
					embeds: ["activity.format_summary"],
					filters: params
				}).then(function (response) {
					// set state's exercisesByParams basked on response
					var newExercisesByParams = _underscore2.default.clone(_this6.state.exercisesByParams);
					newExercisesByParams[paramsKey] = response.activities;
					_this6.setState({ exercisesByParams: newExercisesByParams });
				});
			}
		}, {
			key: "fetchActiveData",
			value: function fetchActiveData() {
				var _this7 = this;
	
				this.setState({ activeIndividualData: null, activeGroupData: null,
					activeAttributeIndex: null, activeTypeKey: "weak" });
				if (this.isIndividualView()) {
	
					var params = {
						student_id: this.props.entity.id, embed: "example.answer,answer.text"
					};
	
					CurrentUser.api().getAnalyzeIndividualInsights(params, $wr.apiHandler(function (response) {
						_this7.setState({ activeIndividualData: response.results, activeAttributeIndex: 0 }, _this7.fetchActiveExercises);
					}));
				} else if (this.isGroupView()) {
					var params = {
						student_list_id: this.props.entity.id, embed: "example.answer,answer.text"
					};
					CurrentUser.api().getAnalyzeGroupInsights(params, $wr.apiHandler(function (response) {
						_this7.setState({ activeGroupData: response.results, activeAttributeIndex: 0 }, _this7.fetchActiveExercises);
					}));
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.entity != this.props.entity) {
					this.fetchActiveData();
				}
			}
		}]);
	
		return SkillsetsPage;
	}(React.Component)) || _class) || _class);
	
	
	SkillsetsPage.propTypes = PageStrictPropTypes({});
	
	module.exports = SkillsetsPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	
	var PaywallModal = __webpack_require__(44);
	var UIActions = __webpack_require__(41);
	var StudentListDisplay = __webpack_require__(163);
	
	var Spinner = __webpack_require__(9);
	var OrgTypes = __webpack_require__(45);
	var OrgDropdown = __webpack_require__(100);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3651);
	
	function arrayToHash(ids) {
		var hash = {};
		if (ids) {
			_.each(ids, function (x) {
				return hash[x] = true;
			});
		}
		return hash;
	}
	var StudentSelectorSection = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		return {
			studentLists: RosterSelectors.nonEmptyStudentLists({ state: state }),
			getStudents: function getStudents(orgIdentifier) {
				if (orgIdentifier) {
					return RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier });
				} else {
					return [];
				}
			}
		};
	}, function (dispatch, props) {
		return {
			showHistoricalDataPaywall: function showHistoricalDataPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentSelectorSection, _React$Component);
	
		function StudentSelectorSection(props) {
			_classCallCheck(this, StudentSelectorSection);
	
			var _this = _possibleConstructorReturn(this, (StudentSelectorSection.__proto__ || Object.getPrototypeOf(StudentSelectorSection)).call(this));
	
			autobind(_this);
	
			var selectedOrgIdentifier = null;
			if (props.studentLists && props.studentLists.length > 0) {
				var studentListID = $wr.getURLParameterByName("student_list");
				if (studentListID) {
					var key = studentListID;
				} else {
					var key = props.studentLists[0].id;
				}
	
				selectedOrgIdentifier = OrgTypes.toIdentifier({
					type: OrgTypes.STUDENT_LIST,
					key: key
				});
			}
	
			_this.state = {
				selectedOrgIdentifier: selectedOrgIdentifier,
				studentsSelectedIDs: arrayToHash(props.initialStudentIDs)
			};
			return _this;
		}
	
		_createClass(StudentSelectorSection, [{
			key: "students",
			value: function students() {
				var students = this.props.getStudents(this.state.selectedOrgIdentifier);
				return $wr.sortByName(students, "flexName");
			}
		}, {
			key: "onOrgSelect",
			value: function onOrgSelect(identifier, studentListID) {
				if (this.props.showFullData) {
					var students = this.props.getStudents(identifier);
					var studentIDs = arrayToHash(_.pluck(students, "id"));
					this.setState({
						selectedOrgIdentifier: identifier,
						studentsSelectedIDs: studentIDs
					});
					this.props.changeSelection(studentIDs, studentListID);
				} else {
					this.props.showHistoricalDataPaywall();
				}
			}
		}, {
			key: "changeStudent",
			value: function changeStudent(student) {
				var _this2 = this;
	
				if (this.props.showFullData) {
					var studentsSelectedIDs = _.clone(this.state.studentsSelectedIDs);
					if (this.allStudentsSelected()) {
						studentsSelectedIDs = _defineProperty({}, student.id, true);
					} else if (this.state.studentsSelectedIDs[student.id]) {
						delete studentsSelectedIDs[student.id];
	
						if (_.size(studentsSelectedIDs) == 0 && this.state.selectedOrgIdentifier) {
							// Instead of showing everyone, show the selected class
							studentsSelectedIDs = arrayToHash(_.pluck(this.students(), "id"));
						}
					} else {
						studentsSelectedIDs[student.id] = true;
					}
					this.setState({ studentsSelectedIDs: studentsSelectedIDs }, function () {
						_this2.props.changeSelection(_this2.state.studentsSelectedIDs);
					});
				} else {
					this.props.showHistoricalDataPaywall();
				}
			}
		}, {
			key: "changeAllStudents",
			value: function changeAllStudents() {
				var _this3 = this;
	
				if (this.state.selectedOrgIdentifier === OrgTypes.ALL_STUDENTS_IDENTIFIER) {
					var studentsSelectedIDs = {};
				} else {
					var studentsSelectedIDs = _.clone(this.state.studentsSelectedIDs);
					_.each(this.students(), function (student) {
						studentsSelectedIDs[student.id] = true;
					});
				}
	
				this.setState({ studentsSelectedIDs: studentsSelectedIDs }, function () {
					_this3.props.changeSelection(_this3.state.studentsSelectedIDs);
				});
			}
		}, {
			key: "allStudentsSelected",
			value: function allStudentsSelected() {
				return this.students().length == _.size(this.state.studentsSelectedIDs) || _.size(this.state.studentsSelectedIDs) == 0;
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!this.props.showFullData) {
					this.changeAllStudents();
				}
			}
		}, {
			key: "renderLoadingState",
			value: function renderLoadingState() {
				return React.createElement(
					"div",
					null,
					React.createElement(Spinner, { placeholder: true, scale: 1.7 })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var allSelected = this.allStudentsSelected();
				var selectedStudents = _.map(this.students(), function (student) {
					if (this.state.studentsSelectedIDs[student.id] && !allSelected) {
						var className = " selectedRow";
					}
					if (!OrgTypes.isStudentListIdentifier(this.state.selectedOrgIdentifier)) {
						var studentListDisplay = React.createElement(StudentListDisplay, { studentID: student.id });
					}
					return React.createElement(
						"div",
						{ key: student.id, className: "row studentRow " + className, onClick: this.changeStudent.bind(this, student) },
						React.createElement(StudentAvatar, { disableAnimation: true, student: student, maxWidth: 50 }),
						React.createElement(
							"div",
							{ className: "studentInfo" },
							React.createElement(
								"span",
								{ className: "studentName" },
								student.display_name
							),
							studentListDisplay
						)
					);
				}.bind(this));
	
				if (allSelected) {
					var allStudentsClassName = " selectedRow";
				}
	
				if (this.props.loadingStudentLists) {
					var spinner = this.renderLoadingState();
				} else {
					var selector = React.createElement(OrgDropdown, { dropdownDisplay: "link",
						selectedIdentifier: this.state.selectedOrgIdentifier,
						onSelect: this.onOrgSelect });
				}
	
				var studentsDisplay = React.createElement(
					"div",
					{ className: "studentsDisplaySection" },
					React.createElement(
						"div",
						null,
						React.createElement(
							"div",
							{ className: "row allStudentsRow " + allStudentsClassName,
								onClick: this.changeAllStudents },
							React.createElement("img", { src: __webpack_require__(542), alt: "" }),
							React.createElement(
								"span",
								null,
								"Select All"
							)
						),
						React.createElement(
							"div",
							{ className: "studentsInner" },
							selectedStudents
						)
					)
				);
	
				return React.createElement(
					"div",
					{ className: "studentSelectorSection hideOnPrint" },
					spinner,
					selector,
					studentsDisplay
				);
			}
		}]);
	
		return StudentSelectorSection;
	}(React.Component)) || _class);
	
	
	StudentSelectorSection.WrappedComponent.propTypes = StrictPropTypes({
	
		// Handler from @connect
		showHistoricalDataPaywall: PropTypes.func,
		showFullData: PropTypes.bool,
		getStudents: PropTypes.func,
	
		// From above
		changeSelection: PropTypes.func,
		initialStudentIDs: PropTypes.array,
		studentLists: PropTypes.array
	});
	
	module.exports = StudentSelectorSection;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentListDropdownDisplay = __webpack_require__(138);
	
	__webpack_require__(3652);
	
	var StudentSelectorSidebar = function (_React$Component) {
		_inherits(StudentSelectorSidebar, _React$Component);
	
		function StudentSelectorSidebar(props) {
			_classCallCheck(this, StudentSelectorSidebar);
	
			var _this = _possibleConstructorReturn(this, (StudentSelectorSidebar.__proto__ || Object.getPrototypeOf(StudentSelectorSidebar)).call(this));
	
			autobind(_this);
			var activeStudentList = _.isEmpty(props.activeStudentList) ? $wr.sortByName(props.studentLists, "studentList")[0] : props.activeStudentList;
			var activeStudent = props.activeStudent === null ? $wr.sortByName(activeStudentList.students, "flexName")[0] : props.activeStudent;
			_this.state = {
				activeStudentList: activeStudentList, activeStudent: activeStudent
			};
			return _this;
		}
	
		_createClass(StudentSelectorSidebar, [{
			key: "studentListChange",
			value: function studentListChange(studentList) {
				var activeStudent = $wr.sortByName(studentList.students, "flexName")[0];
				this.setState({ activeStudentList: studentList, activeStudent: activeStudent }, function () {
					this.props.onStudentListChange(studentList);
					this.props.onStudentChange(activeStudent);
				});
			}
		}, {
			key: "studentChange",
			value: function studentChange(student) {
				this.setState({ activeStudent: student }, this.props.onStudentChange(student));
			}
		}, {
			key: "render",
			value: function render() {
				var sortedStudentLists = $wr.sortByName(this.props.studentLists, "studentList");
				var studentListDropdown = React.createElement(StudentListDropdownDisplay, { dropdownDisplay: "link",
					studentLists: sortedStudentLists,
					currentStudentList: this.state.activeStudentList,
					onChange: this.studentListChange, displayType: "mixed" });
				var students = $wr.sortByName(this.state.activeStudentList.students, "flexName");
				var studentLinks = students.map(function (student) {
					var studentLinkClass = "studentRow ellipsisText";
					if (student.id == this.state.activeStudent.id && !this.props.showPaywallModal) {
						studentLinkClass += " selectedStudent";
					}
					return React.createElement(
						"a",
						{ className: studentLinkClass, key: student.id, href: "#",
							onClick: this.studentChange.bind(this, student) },
						student.display_name
					);
				}.bind(this));
	
				return React.createElement(
					"div",
					{ className: "studentSelectorSidebar" },
					studentListDropdown,
					studentLinks
				);
			}
		}]);
	
		return StudentSelectorSidebar;
	}(React.Component);
	
	StudentSelectorSidebar.propTypes = StrictPropTypes({
		// array of student lists, must include students
		studentLists: PropTypes.array.isRequired,
	
		// function to call when selected student list changes
		onStudentListChange: PropTypes.func.isRequired,
	
		// function to call when a student is clicked
		onStudentChange: PropTypes.func.isRequired,
	
		// optionally, can set which student list and student are active
		activeStudentList: PropTypes.object,
		activeStudent: PropTypes.object,
	
		showPaywallModal: PropTypes.bool
	});
	
	module.exports = StudentSelectorSidebar;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DataRouting = __webpack_require__(36);
	var DataAnswers = __webpack_require__(379);
	var DataGoals = __webpack_require__(380);
	var DataQuizzes = __webpack_require__(766);
	var DataLogTables = __webpack_require__(381);
	var DataTextTables = __webpack_require__(383);
	var DataReadingLevelGraphs = __webpack_require__(382);
	var Spinner = __webpack_require__(9);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var ReadingSelectors = __webpack_require__(21);
	var WritingSelectors = __webpack_require__(14);
	var DataSelectors = __webpack_require__(54);
	var Glyphicon = __webpack_require__(8);
	var RosterRouting = __webpack_require__(93);
	var Features = __webpack_require__(16);
	var EvaluationOverride = __webpack_require__(959);
	
	__webpack_require__(3653);
	// large request should have a smaller loading requirement to prevent large loading
	// times with an empty screen
	function isLoading(state, userIDs) {
		if (userIDs && $wr.isLargeRequest(userIDs)) {
			return DataSelectors.isLoadingDigests({ state: state, key: 'index', userIDs: userIDs });
		} else {
			return ReadingSelectors.isLoadingBooks({ state: state, key: 'index', userIDs: userIDs }) || ReadingSelectors.isLoadingLogs({ state: state, key: 'index', userIDs: userIDs }) || DataSelectors.isLoadingDigests({ state: state, key: 'index', userIDs: userIDs }) || ReadingSelectors.isLoadingReadingLevels({ state: state, key: 'index', userIDs: userIDs });
		}
	}
	
	var TeacherDigestContainer = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			user: CurrentUser.get(),
			userIsSchoolAdmin: CurrentUser.isSchoolAdmin(),
			userIsTeacherAdmin: CurrentUser.isTeacherAdmin(),
	
			expectationsDateSpans: (CurrentUser.get() || {}).expectations_date_spans,
			schoolYearStartDate: (0, _moment2.default)(CurrentUser.fetchSchoolYearDates().startDate).format("YYYY-MM-DD"),
			schoolYearEndDate: (0, _moment2.default)().format("YYYY-MM-DD"),
	
			isLoading: isLoading(state, props.userIDs || _.pluck(RosterSelectors.students({ state: state }), "id")),
			userIDs: _.pluck(RosterSelectors.students({ state: state }), "id"),
			hasLogReading: Features.isEnabled(Features.LOG_READING),
			nonDemoStudents: _.select(RosterSelectors.students({ state: state, conditions: {} }), function (student) {
				return !student.demo_for_teacher;
			})
		};
	}, function () {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(TeacherDigestContainer, _React$Component);
	
		function TeacherDigestContainer(props) {
			_classCallCheck(this, TeacherDigestContainer);
	
			var _this = _possibleConstructorReturn(this, (TeacherDigestContainer.__proto__ || Object.getPrototypeOf(TeacherDigestContainer)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(TeacherDigestContainer, [{
			key: "dataLinkWithExpectationDates",
			value: function dataLinkWithExpectationDates(subject) {
				return DataRouting.getPath({
					subjectType: subject,
					startDate: this.props.expectationsDateSpans[0].start,
					endDate: this.props.expectationsDateSpans[0].end
				});
			}
		}, {
			key: "dataLinkWithSchoolYearDates",
			value: function dataLinkWithSchoolYearDates(subject) {
	
				return DataRouting.getPath({
					subjectType: subject,
					startDate: this.props.schoolYearStartDate,
					endDate: this.props.schoolYearEndDate
				});
			}
		}, {
			key: "isOnboardingComplete",
			value: function isOnboardingComplete() {
				var onboardingData = this.props.user.prefs.onboarding;
				return _.select(onboardingData, function (stepData, key) {
					return !stepData;
				}).length == 0;
			}
		}, {
			key: "addStudents",
			value: function addStudents() {
				$wr.redirect("/roster?addNewStudentsButton=true");
			}
		}, {
			key: "fetchVideo",
			value: function fetchVideo() {
				var weekNumber = (0, _moment2.default)().week();
				var index = weekNumber % 8;
				if (this.props.user.account.product == "wrSolo") {
					switch (index) {
						case 0:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445701238", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 1:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445702087", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 2:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446974856", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 3:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445702959", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 4:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/447264463", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 5:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446987031", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 6:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446980822", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 7:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446978356", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 8:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446980030", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 9:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446979749", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
					}
				} else {
					switch (index) {
						case 0:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445701238", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 1:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445702087", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 2:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445702732", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 3:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446974856", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 4:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446982781", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 5:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/445702959", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 6:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/447264463", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 7:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446980504", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 8:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446981204", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 9:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446986708", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 10:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446987031", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 11:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446980822", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 12:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446978356", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 13:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446975674", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 14:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446989378", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 15:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446980030", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
						case 16:
							var video = React.createElement(
								"div",
								null,
								React.createElement("iframe", { src: "//player.vimeo.com/video/446979749", width: "435", height: "337", frameBorder: "0", allow: "autoplay; fullscreen", webkitAllowFullScreen: true, mozAllowFullScreen: true, allowFullScreen: true })
							);
							break;
					}
				}
				return video;
			}
		}, {
			key: "render",
			value: function render() {
				var goalsStartDate = this.props.expectationsDateSpans[0].start;
				var goalsEndDate = this.props.expectationsDateSpans[0].end;
	
				var yearStartDate = this.props.schoolYearStartDate;
				var yearEndDate = this.props.schoolYearEndDate;
	
				if (this.props.isLoading) {
					return React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
					if (this.props.userIDs && this.props.nonDemoStudents.length == 0) {
						if (this.isOnboardingComplete()) {
							var addStudents = React.createElement(
								"div",
								{ className: "addStudents" },
								React.createElement(
									"p",
									null,
									"Add your students and their writing data and scores will appear here! ",
									React.createElement(
										"a",
										{ onClick: this.addStudents },
										"Add Students "
									)
								)
							);
						}
					}
	
					var booksSection = React.createElement(
						"div",
						{ className: "digestSection" },
						React.createElement(
							"header",
							null,
							"Books"
						),
						React.createElement(
							"div",
							{ className: "digestContent" },
							React.createElement(DataTextTables, { userIDs: this.props.userIDs, booksAmount: 3,
								startDate: yearStartDate, endDate: yearEndDate })
						),
						React.createElement(
							_reactRouterDom.Link,
							{ className: "seeMoreLink", to: this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_BOOKS) },
							"See More",
							React.createElement(Glyphicon, { icon: "menu-right" })
						)
					);
	
					var diffLink = RosterRouting.getPath({
						activeView: RosterRouting.VIEWS.GOALS
					}) + "?edit_expectations=true";
	
					var goalsSection = React.createElement(
						"div",
						{ className: "digestSection clearfix" },
						React.createElement(
							"div",
							{ className: "digestSection clearfix" },
							React.createElement(
								"div",
								null,
								React.createElement(
									"header",
									null,
									"Goals"
								),
								React.createElement(
									"div",
									{ className: "goalDates" },
									$wr.formatDate(goalsStartDate),
									" - ",
									$wr.formatDate(goalsEndDate)
								),
								React.createElement(
									"span",
									{ className: "editGoalsLink" },
									React.createElement(
										"a",
										{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/360024761351", target: "_blank" },
										"Learn How to Edit Goals"
									)
								)
							),
							React.createElement(
								"div",
								{ className: "digestContent" },
								React.createElement(DataGoals, { startDate: goalsStartDate, endDate: goalsEndDate,
									userIDs: this.props.userIDs, studentLimit: 3, showGoals: true })
							),
							React.createElement(
								_reactRouterDom.Link,
								{ className: "seeMoreLink", to: this.dataLinkWithExpectationDates(DataRouting.SUBJECT_GOALS) },
								"See More",
								React.createElement(Glyphicon, { icon: "menu-right" })
							)
						)
					);
	
					if (this.props.hasLogReading) {
						var seeMoreLink = React.createElement(
							_reactRouterDom.Link,
							{ className: "seeMoreLink", to: this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_LOG_LIST) },
							"See More",
							React.createElement(Glyphicon, { icon: "menu-right" })
						);
					}
	
					var upperSection = goalsSection;
					var lowerSection = booksSection;
	
					var itemTwo = React.createElement(
						"div",
						null,
						React.createElement(
							"header",
							null,
							"Tell Us How We're Scoring"
						),
						React.createElement(
							"div",
							{ className: "disgestContent" },
							React.createElement(EvaluationOverride, { userIDs: this.props.userIDs })
						)
					);
					var itemFour = React.createElement(
						"div",
						null,
						React.createElement(
							"header",
							null,
							"Recent Practice Question"
						),
						React.createElement(
							"div",
							{ className: "digestContent" },
							React.createElement(DataAnswers, { answerType: DataAnswers.PRACTICE_QUESTIONS,
								startDate: yearStartDate, endDate: yearEndDate,
								userIDs: this.props.userIDs,
								order: "completed_at_desc",
								perPage: 20, fakePerPage: 1, showFullData: true,
								sketchEmptyState: true })
						),
						React.createElement(
							_reactRouterDom.Link,
							{ className: "seeMoreLink", to: this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_ANSWERS) },
							"See More",
							React.createElement(Glyphicon, { icon: "menu-right" })
						)
					);
	
					var itemThree = React.createElement(
						"div",
						{ className: "digestVideo" },
						React.createElement(
							"header",
							null,
							"Watch a Video"
						),
						React.createElement(
							"div",
							{ className: "digestContent video" },
							this.fetchVideo()
						)
					);
	
					var itemFive = React.createElement(
						"div",
						null,
						React.createElement(
							"header",
							null,
							"Reading Logs"
						),
						React.createElement(
							"div",
							{ className: "digestContent" },
							React.createElement(DataLogTables, { userIDs: this.props.userIDs, condensedLayout: true,
								startDate: yearStartDate, endDate: yearEndDate })
						),
						seeMoreLink
					);
	
					var rlGraph = React.createElement(
						"div",
						null,
						React.createElement(
							"header",
							null,
							"Reading Level Graph"
						),
						React.createElement(
							"div",
							{ className: "digestContent" },
							React.createElement(DataReadingLevelGraphs, { userIDs: this.props.userIDs,
								startDate: yearStartDate, endDate: yearEndDate,
								studentLimit: 1, numMonths: 4 })
						),
						React.createElement(
							_reactRouterDom.Link,
							{ className: "seeMoreLink", to: this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_READING_LEVEL_GRAPH) },
							"See More",
							React.createElement(Glyphicon, { icon: "menu-right" })
						)
					);
					var itemSix = React.createElement(
						"div",
						{ className: "rlGraphContainer" },
						React.createElement(
							"div",
							{ className: "digestSection" },
							rlGraph
						)
					);
	
					return React.createElement(
						"div",
						{ className: "teacherDigestContainer" },
						addStudents,
						upperSection,
						React.createElement(
							"div",
							{ className: "digestMiddleContainer" },
							React.createElement(
								"div",
								{ className: "digestSection widerDigestSection" },
								itemTwo
							),
							React.createElement(
								"div",
								{ className: "digestSection" },
								itemThree
							)
						),
						lowerSection,
						React.createElement(
							"div",
							{ className: "digestMiddleContainer" },
							React.createElement(
								"div",
								{ className: "digestSection widerDigestSection" },
								itemFour
							),
							React.createElement(
								"div",
								{ className: "digestSection" },
								itemFive
							)
						),
						itemSix
					);
				}
			}
		}]);
	
		return TeacherDigestContainer;
	}(React.Component)) || _class);
	
	
	TeacherDigestContainer.WrappedComponent.propTypes = PageStrictPropTypes({
	
		// From @connect
		userIDs: PropTypes.array,
		user: PropTypes.object,
		userIsSchoolAdmin: PropTypes.bool,
		userIsTeacherAdmin: PropTypes.bool,
		expectationsDateSpans: PropTypes.array,
		schoolYearStartDate: PropTypes.string,
		schoolYearEndDate: PropTypes.string,
	
		isLoading: PropTypes.bool,
		hasLogReading: PropTypes.bool,
		nonDemoStudents: PropTypes.array
	});
	
	module.exports = TeacherDigestContainer;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GRAPH_VIEW_KEYS, _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _GraphUtility = __webpack_require__(99);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CurrentUser = __webpack_require__(3);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var IndividualScoringGraph = __webpack_require__(758);
	var DigestProgressGraph = __webpack_require__(376);
	var DigestGraphWithDropdown = __webpack_require__(757);
	var RubricRadarGraph = __webpack_require__(377);
	var PaywallModal = __webpack_require__(44);
	var PaywallLink = __webpack_require__(414);
	var EmptyStateContainer = __webpack_require__(80);
	var StudentSelectorSidebar = __webpack_require__(746);
	var StudentListDropdownDisplay = __webpack_require__(138);
	var DisplayToggleControl = __webpack_require__(48);
	var SkillsetsPage = __webpack_require__(744);
	
	var INDIVIDUAL_VIEW = 'individual-view';
	var STUDENT_LIST_VIEW = 'student-list-view';
	var TEACHER_VIEW = 'teacher-view';
	var SCHOOL_ORG_VIEW = 'school-org-view';
	var DISTRICT_ORG_VIEW = 'district-org-view';
	
	var SCORING = 'scoring-graph-view';
	var ACTIVITY = 'activity-graph-view';
	var SKILLSET = 'skillset-graph-view';
	var INTERVENTION = 'intervention-graph-view';
	
	var GRAPH_VIEW_KEYS = (_GRAPH_VIEW_KEYS = {}, _defineProperty(_GRAPH_VIEW_KEYS, SCORING, 'Scoring'), _defineProperty(_GRAPH_VIEW_KEYS, ACTIVITY, 'Activity'), _defineProperty(_GRAPH_VIEW_KEYS, SKILLSET, "Skillset"), _defineProperty(_GRAPH_VIEW_KEYS, INTERVENTION, "Intervention"), _GRAPH_VIEW_KEYS);
	__webpack_require__(649);
	
	var TeacherInsightsPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {
	        user: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }),
	        studentLists: RosterSelectors.studentListsByAdminId({ state: state, adminId: CurrentUser.get().id }),
	        showPaywall: !CurrentUser.get().account.gold_features
	    };
	}, function (dispatch, props) {
	    var fetchStudentLists = function fetchStudentLists() {
	        return dispatch(RosterActions.fetchStudentLists({
	            embeds: ["student_list.students", "student.prefs", "student.current_reading_level", "student_list.primary_admin", "student_list.admin_ids"]
	        }));
	    };
	
	    var fetchStudentList = function fetchStudentList(id) {
	        return dispatch(RosterActions.fetchStudentList({
	            id: id,
	            embeds: ["student_list.students", "student_list.grade_level", "student.prefs", "student.student_list.primary_admin", 'student.avatar']
	        }));
	    };
	
	    var fetchTeachers = function fetchTeachers(ids) {
	        return dispatch(RosterActions.fetchAdmins({
	            filters: { ids: ids },
	            embeds: ['user.prefs'],
	            cache: true
	        }));
	    };
	
	    var fetchSchoolOrgs = function fetchSchoolOrgs(ids) {
	        return dispatch(RosterActions.fetchSchoolOrgs({
	            filters: { ids: [ids] },
	            embeds: ['school_org.prefs'],
	            cache: true
	        }));
	    };
	
	    var fetchDistrictOrg = function fetchDistrictOrg(id) {
	        return dispatch(RosterActions.fetchDistrictOrgs({
	            filters: { ids: [id] },
	            embeds: ['district_org.prefs'],
	            cache: true
	        }));
	    };
	
	    // used to grab org_ids
	    var fetchAdmin = function fetchAdmin() {
	        dispatch(RosterActions.fetchAdmins({
	            filters: { ids: [CurrentUser.get().id] },
	            embeds: ['admin.org_ids', 'user.prefs'],
	            cache: false
	        }));
	    };
	
	    var populateData = function populateData() {
	        return Promise.all([fetchStudentLists(), fetchAdmin()]);
	    };
	
	    return {
	        populateData: populateData,
	        fetchStudentLists: fetchStudentLists,
	        fetchStudentList: fetchStudentList,
	        fetchSchoolOrgs: fetchSchoolOrgs,
	        fetchDistrictOrg: fetchDistrictOrg,
	        fetchTeachers: fetchTeachers
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(TeacherInsightsPage, _React$Component);
	
	    function TeacherInsightsPage(props) {
	        _classCallCheck(this, TeacherInsightsPage);
	
	        var _this = _possibleConstructorReturn(this, (TeacherInsightsPage.__proto__ || Object.getPrototypeOf(TeacherInsightsPage)).call(this));
	
	        autobind(_this);
	
	        if ($wr.getURLParameterByName("view")) {
	            var initialView = $wr.getURLParameterByName("view");
	        } else {
	            var initialView = INDIVIDUAL_VIEW;
	        }
	
	        if ($wr.getURLParameterByName("graph_view")) {
	            var initialGraphView = $wr.getURLParameterByName("graph_view");
	        } else {
	            var initialGraphView = SCORING;
	        }
	
	        var sortedStudentLists = $wr.sortByName(props.studentLists, "studentList");
	        var initialActiveStudentList = sortedStudentLists[0];
	
	        _this.state = {
	            studentLists: sortedStudentLists || null,
	            teachers: null,
	            schoolOrgs: null,
	            activeStudent: null,
	            activeStudentList: initialActiveStudentList,
	            activeTeacher: null,
	            activeSchoolOrg: null,
	            activeDistrictOrg: null,
	            studentsFetchedByListID: {},
	            loading: false,
	            currentView: initialView,
	            graphView: initialGraphView
	        };
	
	        LuckyOrangeClient.tagComponent("NewInsightsPage");
	        return _this;
	    }
	
	    _createClass(TeacherInsightsPage, [{
	        key: "fetchActiveData",
	        value: function fetchActiveData() {
	            this.setState({ activeIndividualData: null, activeGroupData: null,
	                activeAttributeIndex: null, activeTypeKey: "weak" });
	        }
	    }, {
	        key: "onViewChange",
	        value: function onViewChange(view) {
	            if (view != this.state.currentView) {
	                // fetch data next
	                this.setState({ currentView: view });
	            }
	        }
	    }, {
	        key: "graphPageChange",
	        value: function graphPageChange(newPage) {
	            if (newPage != this.state.graphView) {
	                this.setState({ graphView: newPage });
	            }
	        }
	    }, {
	        key: "renderToggle",
	        value: function renderToggle() {
	            var toggleOptions = [{ key: INDIVIDUAL_VIEW, text: "Individuals" }, { key: STUDENT_LIST_VIEW, text: "Classes" }];
	
	            if (this.props.user.role == "adminRole" || this.props.user.role == "districtAdminRole") {
	                toggleOptions.push({ key: TEACHER_VIEW, text: "Teachers" });
	                toggleOptions.push({ key: SCHOOL_ORG_VIEW, text: "Schools" });
	            }
	            if (this.props.user.role == "districtAdminRole") {
	                toggleOptions.push({ key: DISTRICT_ORG_VIEW, text: "District" });
	            }
	            var toggleDisplay = React.createElement(DisplayToggleControl, { options: toggleOptions,
	                onChange: this.onViewChange, className: "hideOnPrint",
	                activeOptionKey: this.state.currentView });
	            return toggleDisplay;
	        }
	    }, {
	        key: "selectGraphView",
	        value: function selectGraphView(graphView) {
	            this.setState({ graphView: graphView });
	        }
	    }, {
	        key: "renderGraphViewToggle",
	        value: function renderGraphViewToggle() {
	            var options = [];
	            for (var graphViewKey in GRAPH_VIEW_KEYS) {
	                options.push({ key: graphViewKey, text: GRAPH_VIEW_KEYS[graphViewKey] });
	            }
	
	            return React.createElement(DisplayToggleControl, { options: options,
	                onChange: this.graphPageChange, className: "hideOnPrint",
	                activeOptionKey: this.state.graphView
	
	            });
	        }
	    }, {
	        key: "renderSideBar",
	        value: function renderSideBar() {
	            var _this2 = this;
	
	            if (this.state.currentView == STUDENT_LIST_VIEW) {
	                var sortedStudentLists = $wr.sortByName(this.state.studentLists, "studentList");
	                var sidebar = React.createElement(
	                    "div",
	                    { className: "studentSelectorSidebar" },
	                    React.createElement(StudentListDropdownDisplay, { dropdownDisplay: "link",
	                        studentLists: sortedStudentLists,
	                        currentStudentList: this.state.activeStudentList,
	                        onChange: this.selectActiveStudentList.bind(this), displayType: "mixed" })
	                );
	            } else if (this.state.currentView == INDIVIDUAL_VIEW && !this.state.loading) {
	                var sidebar = React.createElement(StudentSelectorSidebar, { studentLists: this.state.studentLists,
	                    activeStudentList: this.state.activeStudentList,
	                    activeStudent: this.state.activeStudent,
	                    onStudentListChange: this.selectActiveStudentList.bind(this),
	                    onStudentChange: this.selectActiveStudent.bind(this) });
	            } else if (this.state.currentView == TEACHER_VIEW) {
	                var teachersOptions = _underscore2.default.map(this.state.teachers, function (teacher) {
	                    return React.createElement(ButtonDropdownOption, {
	                        onClick: _this2.selectActiveTeacher.bind(_this2, teacher),
	                        text: teacher.first_name + " " + teacher.last_name,
	                        key: teacher.id
	                    });
	                });
	
	                var activeTeacherName = "";
	                // add text at top of drop down
	                if (this.state.activeTeacher) {
	                    activeTeacherName = this.state.activeTeacher.first_name + " " + this.state.activeTeacher.last_name;
	                }
	
	                var sidebar = React.createElement(
	                    ButtonDropdown,
	                    { dropdownDisplay: "link", text: activeTeacherName },
	                    teachersOptions
	                );
	            } else if (this.state.currentView == SCHOOL_ORG_VIEW) {
	                var orgOptions = _underscore2.default.map(this.state.schoolOrgs, function (schoolOrg) {
	                    return React.createElement(ButtonDropdownOption, {
	                        onClick: _this2.selectActiveTeacher.bind(_this2, schoolOrg),
	                        text: schoolOrg.name,
	                        key: schoolOrg.id
	                    });
	                });
	
	                var activeOrgName = "";
	                // add text at top of drop down
	                if (this.state.activeSchoolOrg) {
	                    activeOrgName = this.state.activeSchoolOrg.name;
	                }
	
	                var sidebar = React.createElement(
	                    ButtonDropdown,
	                    { dropdownDisplay: "link", text: activeOrgName },
	                    orgOptions
	                );
	            }
	
	            return sidebar;
	        }
	        // used to construct header for graphs
	
	    }, {
	        key: "getSchoolYear",
	        value: function getSchoolYear() {
	            var yearStartMonth = this.props.user.prefs.school_year_start_month || 8;
	            var now = new Date();
	
	            if (now.getMonth() >= yearStartMonth) {
	                var startYear = now.getFullYear();
	            } else {
	                var startYear = now.getFullYear() - 1;
	            }
	
	            var endYear = (startYear + 1).toString();
	
	            return startYear + "-" + endYear.slice(2, 4);
	        }
	
	        // function that is responsible for rendering the content when 'skillsets' is selected
	
	    }, {
	        key: "renderSkillsetViews",
	        value: function renderSkillsetViews(entity, entityType) {
	
	            var barGraph = React.createElement(DigestGraphWithDropdown, { entity: entity, entityType: entityType, rubricGraph: true });
	            var graph = React.createElement(
	                "div",
	                { className: "graphContainer" },
	                React.createElement(
	                    "h2",
	                    { className: "containerLabel" },
	                    "Monthly Performance"
	                ),
	                barGraph
	            );
	            return graph;
	        }
	
	        // renders content when 'scoring' is selected
	
	    }, {
	        key: "renderScoringView",
	        value: function renderScoringView(entity, entityType) {
	            // individual scoring graph is special case...
	            if (entityType == _GraphUtility.STUDENT) {
	                var answerGraph = React.createElement(IndividualScoringGraph, { activeStudentList: this.state.activeStudentList, students: [entity], view: "answer-view" });
	                var quizGraph = React.createElement(IndividualScoringGraph, { activeStudentList: this.state.activeStudentList, students: [entity], view: "quiz-view" });
	            } else {
	                var answerGraph = React.createElement(DigestProgressGraph, { entity: entity, entityType: entityType, metrics: [_GraphUtility.AVG_ANSWER_SCORE] });
	                var quizGraph = React.createElement(DigestProgressGraph, { entity: entity, entityType: entityType, metrics: [_GraphUtility.AVG_QUIZ_SCORE] });
	            }
	            var graph = React.createElement(
	                "div",
	                { className: "graphContainer" },
	                React.createElement(
	                    "h2",
	                    { className: "containerLabel" },
	                    "Quizzes"
	                ),
	                quizGraph,
	                React.createElement(
	                    "h2",
	                    { className: "containerLabel" },
	                    "Answers"
	                ),
	                answerGraph
	            );
	            return graph;
	        }
	    }, {
	        key: "renderInterventionView",
	        value: function renderInterventionView(entity, entityType) {
	            return React.createElement(
	                "div",
	                null,
	                React.createElement(
	                    "h2",
	                    { className: "containerLabel" },
	                    " Strengths & Weaknesses"
	                ),
	                React.createElement(SkillsetsPage, { entity: entity, entityType: entityType, studentLists: this.state.studentLists })
	            );
	        }
	
	        // Given the page view (scoring/activity/skillset, create a graph/s)
	
	    }, {
	        key: "createGraph",
	        value: function createGraph(entity, entityType) {
	            if (this.state.graphView == SCORING) {
	                var graph = this.renderScoringView(entity, entityType);
	            } else if (this.state.graphView == ACTIVITY) {
	                var graph = React.createElement(DigestGraphWithDropdown, { entity: entity, entityType: entityType });
	            } else if (this.state.graphView == SKILLSET) {
	                var graph = this.renderSkillsetViews(entity, entityType);
	            } else if (this.state.graphView == INTERVENTION) {
	                var graph = this.renderInterventionView(entity, entityType);
	            }
	            return graph;
	        }
	    }, {
	        key: "renderMainContent",
	        value: function renderMainContent() {
	            if (this.props.showPaywall) {
	                return this.renderPaywall();
	            }
	
	            if (this.state.loading) {
	                return;
	            }
	
	            var entity = null;
	            var entityType = null;
	            var nameString = "";
	            switch (this.state.currentView) {
	                case INDIVIDUAL_VIEW:
	                    if (!this.state.activeStudent) {
	                        return;
	                    }
	                    entity = this.state.activeStudent;
	                    entityType = _GraphUtility.STUDENT;
	                    nameString = entity.first_name + " " + entity.last_name;
	                    break;
	                case STUDENT_LIST_VIEW:
	                    if (!this.state.activeStudentList) {
	                        return;
	                    }
	                    entity = this.state.activeStudentList;
	                    entityType = _GraphUtility.STUDENT_LIST;
	                    nameString = entity.name;
	                    break;
	                case TEACHER_VIEW:
	                    if (!this.state.activeTeacher) {
	                        return;
	                    }
	                    entity = this.state.activeTeacher;
	                    entityType = _GraphUtility.TEACHER;
	                    nameString = entity.first_name + " " + entity.last_name;
	                    break;
	                case SCHOOL_ORG_VIEW:
	                    if (!this.state.activeSchoolOrg) {
	                        return;
	                    }
	                    entity = this.state.activeSchoolOrg;
	                    entityType = _GraphUtility.SCHOOL_ORG;
	                    nameString = entity.name;
	                    break;
	
	                case DISTRICT_ORG_VIEW:
	                    if (!this.state.activeDistrictOrg) {
	                        return;
	                    }
	                    entity = this.state.activeDistrictOrg;
	                    entityType = _GraphUtility.DISTRICT_ORG;
	                    nameString = entity.name;
	            }
	
	            var header = React.createElement(
	                "div",
	                { className: "nameAndYear" },
	                React.createElement(
	                    "b",
	                    { className: "ellipsisText" },
	                    nameString
	                ),
	                React.createElement(
	                    "i",
	                    null,
	                    this.getSchoolYear()
	                )
	            );
	
	            return React.createElement(
	                "div",
	                null,
	                React.createElement(
	                    "div",
	                    { className: "pageHeader" },
	                    header
	                ),
	                React.createElement(
	                    "div",
	                    { className: "viewToggle" },
	                    this.renderGraphViewToggle()
	                ),
	                React.createElement(
	                    "div",
	                    { className: "graphContainer" },
	                    this.createGraph(entity, entityType)
	                )
	            );
	        }
	    }, {
	        key: "renderPaywall",
	        value: function renderPaywall() {
	
	            return React.createElement(
	                "div",
	                { className: "teacherInsightsPage" },
	                React.createElement(PaywallModal, { featureType: PaywallModal.INSIGHTS, ref: "paywallModal" }),
	                React.createElement(EmptyStateContainer, { statusText: "To view in-depth data on activity and performance, upgrade to WR Gold.",
	                    imagePath: __webpack_require__(295) }),
	                React.createElement(PaywallLink, { featureLocation: PaywallLink.INSIGHTS })
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "container teacherInsightsPage" },
	                React.createElement(
	                    "header",
	                    { className: "pageHeader" },
	                    React.createElement(
	                        "h1",
	                        { className: "hideOnPrint" },
	                        " Insights "
	                    )
	                ),
	                this.renderToggle(),
	                React.createElement(
	                    "div",
	                    { className: "row" },
	                    React.createElement(
	                        "div",
	                        { className: "col-sm-3" },
	                        this.renderSideBar()
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "col-sm-9 rightContent" },
	                        this.renderMainContent()
	                    )
	                )
	            );
	        }
	    }, {
	        key: "selectActiveStudent",
	        value: function selectActiveStudent(student) {
	            this.setState({ activeStudent: student });
	        }
	
	        //adds student list to 
	
	    }, {
	        key: "selectActiveStudentList",
	        value: function selectActiveStudentList(studentList) {
	            var _this3 = this;
	
	            // if student info already loaded in, don't fetch again.
	            var id = studentList.id;
	            if (!this.state.studentsFetchedByListID[id]) {
	                this.setState({ loading: true });
	                var stateListCopy = [].concat(_toConsumableArray(this.state.studentLists));
	                this.props.fetchStudentList(id).then(function (response) {
	                    var correctStudentArray = response.students; // put new student information in array
	                    var listObj = _extends({}, studentList); // copy current list object
	                    var studentArr = _extends({}, listObj.students); // copy student infomration in current list object
	                    studentArr = correctStudentArray; // replace copy of old student information with new student information
	                    listObj.students = studentArr; // insert new student information into current list object
	                    // find the index of the list, replace i.
	                    var listIndex = stateListCopy.findIndex(function (list) {
	                        return list.id == id;
	                    });
	                    stateListCopy[listIndex] = listObj;
	                    var IDHashCopy = _extends({}, _this3.state.studentsFetchedByListID);
	                    IDHashCopy[id] = true;
	                    _this3.setState({ activeStudentList: listObj, studentLists: $wr.sortByName(stateListCopy, "studentList"), activeStudent: $wr.sortByName(listObj.students, "flexName")[0], studentsFetchedByListID: IDHashCopy, loading: false }); // add modified current list to state
	                });
	            } else {
	                // if we already fetched it, don't do it again.
	                this.setState({ activeStudentList: studentList, activeStudent: $wr.sortByName(studentList.students, "flexName")[0] }); // add modified current list to state
	            }
	        }
	    }, {
	        key: "selectActiveTeacher",
	        value: function selectActiveTeacher(teacher) {
	            this.setState({ activeTeacher: teacher });
	        }
	    }, {
	        key: "selectActiveSchoolOrg",
	        value: function selectActiveSchoolOrg(org) {
	            this.setState({ activeSchoolOrg: org });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var activeStudentList = this.props.studentLists[0];
	            this.selectActiveStudentList(activeStudentList);
	            if (this.props.showPaywall) {
	                this.refs.paywallModal.show();
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this4 = this;
	
	            if (this.state.currentView == TEACHER_VIEW && prevState.currentView != TEACHER_VIEW) {
	                // if we have already loaded teachers, don't search again.
	                if (this.state.teachers) {
	                    return;
	                }
	                this.setState({ loading: true });
	                var ids = _underscore2.default.uniq(_underscore2.default.map(this.state.studentLists, function (sl) {
	                    return sl.primary_admin;
	                }));
	                this.props.fetchTeachers(ids).then(function (res) {
	                    var sortedTeachers = $wr.sortByName(res.admins, "lastName");
	                    var activeTeacher = null;
	                    if (sortedTeachers.length > 0) {
	                        var activeTeacher = sortedTeachers[0];
	                    }
	
	                    _this4.setState({ activeTeacher: activeTeacher, teachers: sortedTeachers, loading: false });
	                });
	            } else if (this.state.currentView == SCHOOL_ORG_VIEW && prevState.currentView != SCHOOL_ORG_VIEW) {
	                if (this.state.schoolOrgs) {
	                    return;
	                }
	                this.setState({ loading: true });
	                var ids = _underscore2.default.get(this.props.user, ['org_ids', 'school_orgs', 'all'], []);
	                this.props.fetchSchoolOrgs(ids).then(function (res) {
	                    var activeSchoolOrg = null;
	                    if (res.schoolOrgs.length > 0) {
	                        var activeSchoolOrg = res.schoolOrgs[0];
	                    }
	
	                    _this4.setState({ activeSchoolOrg: activeSchoolOrg, schoolOrgs: res.schoolOrgs, loading: false });
	                });
	            } else if (this.state.currentView == DISTRICT_ORG_VIEW && prevState.currentView != DISTRICT_ORG_VIEW) {
	                if (this.state.activeDistrictOrg) {
	                    return;
	                }
	                this.setState({ loading: true });
	                var ids = _underscore2.default.get(this.props.user, ['org_ids', 'district_orgs', 'all'], []);
	                this.props.fetchDistrictOrg(ids[0]).then(function (res) {
	                    var activeDistrictOrg = null;
	                    if (res.districtOrgs.length > 0) {
	                        var activeDistrictOrg = res.districtOrgs[0];
	                    }
	
	                    _this4.setState({ activeDistrictOrg: activeDistrictOrg, loading: false });
	                });
	            }
	        }
	    }]);
	
	    return TeacherInsightsPage;
	}(React.Component)) || _class) || _class);
	
	
	TeacherInsightsPage.propTypes = PageStrictPropTypes({});
	
	module.exports = TeacherInsightsPage;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(58);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DataExportMetrics = __webpack_require__(202);
	
	
	__webpack_require__(3637);
	
	var DataExportConfirmation = function (_React$Component) {
	    _inherits(DataExportConfirmation, _React$Component);
	
	    function DataExportConfirmation(props) {
	        _classCallCheck(this, DataExportConfirmation);
	
	        var _this = _possibleConstructorReturn(this, (DataExportConfirmation.__proto__ || Object.getPrototypeOf(DataExportConfirmation)).call(this, props));
	
	        _this.state = { email: CurrentUser.get().email || '' };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(DataExportConfirmation, [{
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	
	        ///// VALIDATORS /////
	
	    }, {
	        key: "validOrganizationType",
	        value: function validOrganizationType(selectedOrganizationType) {
	            return _.includes(VALID_ORGANIZATION_TYPES, selectedOrganizationType);
	        }
	    }, {
	        key: "validEmail",
	        value: function validEmail() {
	            return (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)
	            );
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleOrganizationTypeChange",
	        value: function handleOrganizationTypeChange(selectedOrganizationType) {
	            this.setState({ selectedOrganizationType: selectedOrganizationType });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var persistentData = this.props.persistentData;
	
	            this.props.onRetreat(persistentData);
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "renderMetrics",
	        value: function renderMetrics() {
	            var persistentData = this.props.persistentData;
	
	            var selectedMetricLabels = _.map(persistentData.selectedMetrics, function (m) {
	                var metricCategoryConfig = DataExportMetrics.METRICS_BY_CATEGORY[persistentData.selectedMetricCategory];
	                // handle addtional metrics by formatting the key
	                if (metricCategoryConfig[0]['children']) {
	                    return m.replace(/-/g, " ").toLowerCase().split(" ").map(function (word) {
	                        return word[0].toUpperCase() + word.slice(1);
	                    }).join(" ");
	                } else {
	                    var metricConfig = _.findWhere(metricCategoryConfig, { 'key': m });
	                    if (metricConfig) {
	                        return metricConfig.label;
	                    }
	                }
	            });
	
	            return this.renderTwoColumnRow('Selected Metrics', _.compact(selectedMetricLabels).join(', '));
	        }
	    }, {
	        key: "renderDatePeriod",
	        value: function renderDatePeriod() {
	            var persistentData = this.props.persistentData;
	
	            if (persistentData.selectedOrganizationType == 'chrono') {
	                return this.renderTwoColumnRow('Date Period', $wr.toTitleCase(persistentData.selectedDatePeriod.replace('-', ' ')));
	            }
	        }
	    }, {
	        key: "renderDateSpan",
	        value: function renderDateSpan() {
	            var persistentData = this.props.persistentData;
	
	            if (persistentData.selectedMetricCategory == DataExportMetrics.ROSTER) {
	                return null;
	            }
	            var startDate = (0, _moment2.default)(persistentData.startDate).format("MM/DD/YYYY");
	            var endDate = (0, _moment2.default)(persistentData.endDate).format("MM/DD/YYYY");
	            var dateSpan = startDate + " - " + endDate;
	
	            return this.renderTwoColumnRow('Date Span', dateSpan);
	        }
	    }, {
	        key: "renderOrganizationType",
	        value: function renderOrganizationType() {
	            var _props = this.props,
	                persistentData = _props.persistentData,
	                organizationOptions = _props.organizationOptions;
	
	
	            var metricConfig = _.findWhere(organizationOptions, { 'key': persistentData.selectedOrganizationType });
	            var orgLabel = metricConfig ? metricConfig.label : '';
	
	            return this.renderTwoColumnRow('Excel Sheet Organization Type', orgLabel);
	        }
	    }, {
	        key: "renderSelectedMetricCategory",
	        value: function renderSelectedMetricCategory() {
	            var persistentData = this.props.persistentData;
	
	            return this.renderTwoColumnRow('Selected Metric Set', $wr.toTitleCase(persistentData.selectedMetricCategory.replace('-', ' ')));
	        }
	    }, {
	        key: "renderUserSelection",
	        value: function renderUserSelection() {
	            var persistentData = this.props.persistentData;
	
	            var orgType = persistentData.selectedOrganizationType;
	            if (orgType == 'chrono' || orgType == 'per-student') {
	                var count = _.size(persistentData.selectedStudents);
	                return this.renderTwoColumnRow('Users', count + " " + $wr.pluralize("Student", count));
	            } else if (orgType == 'per-class') {
	                var count = _.size(persistentData.selectedStudentLists);
	                return this.renderTwoColumnRow('Entities', count + " " + $wr.pluralize("Class", count));
	            } else if (orgType == 'per-teacher') {
	                var count = _.size(persistentData.selectedTeachers);
	                return this.renderTwoColumnRow('Users', count + " " + $wr.pluralize("Teacher", count));
	            }
	        }
	    }, {
	        key: "renderEmail",
	        value: function renderEmail() {
	            var _this2 = this;
	
	            return React.createElement(
	                "form",
	                { className: "emailForm flexRow" },
	                React.createElement(
	                    "label",
	                    { className: "emailLabel", htmlFor: "email" },
	                    "Send Report To:"
	                ),
	                React.createElement("input", { className: "emailInput", type: "email", name: "email", value: this.state.email,
	                    onChange: function onChange(e) {
	                        return _this2.setState({ email: e.target.value });
	                    } })
	            );
	        }
	    }, {
	        key: "renderConfirmationButton",
	        value: function renderConfirmationButton() {
	            var _this3 = this;
	
	            return React.createElement(
	                "div",
	                { className: "onSubmitContainer" },
	                React.createElement(
	                    "button",
	                    { className: "backBtn", onClick: function onClick() {
	                            return _this3.handleRetreatStage();
	                        } },
	                    "Back"
	                ),
	                this.validEmail() && React.createElement(
	                    "button",
	                    { className: "nextBtn", onClick: function onClick() {
	                            return _this3.props.onSubmit(_this3.state.email);
	                        } },
	                    "Confirm Export"
	                )
	            );
	        }
	    }, {
	        key: "renderTwoColumnRow",
	        value: function renderTwoColumnRow(label, content) {
	            return React.createElement(
	                "div",
	                { className: "flexRow" },
	                React.createElement(
	                    "div",
	                    { className: "itemLabel" },
	                    React.createElement(
	                        "p",
	                        null,
	                        label
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "selectedItems" },
	                    React.createElement(
	                        "p",
	                        null,
	                        content
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "confirmationConatiner" },
	                this.renderDatePeriod(),
	                this.renderDateSpan(),
	                this.renderSelectedMetricCategory(),
	                this.renderMetrics(),
	                this.renderOrganizationType(),
	                this.renderUserSelection(),
	                this.renderEmail(),
	                this.renderConfirmationButton()
	            );
	        }
	    }]);
	
	    return DataExportConfirmation;
	}(React.Component);
	
	DataExportConfirmation.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	var VALID_ORGANIZATION_TYPES = ['chrono', 'per-student', 'per-class'];
	
	module.exports = DataExportConfirmation;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _TRACKS;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ProgressBar = __webpack_require__(81);
	var Spinner = __webpack_require__(9);
	
	var ExpandableStudentListSelector = __webpack_require__(375);
	var ExpandableStatsSelector = __webpack_require__(751);
	var ExportsDateSpanSelector = __webpack_require__(753);
	var DataExportConfirmation = __webpack_require__(749);
	var SchoolOrgSelector = __webpack_require__(754);
	var UserSelectorDispatcher = __webpack_require__(756);
	var ExportTypeSelector = __webpack_require__(752);
	
	var DataExportMetrics = __webpack_require__(202);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var DataActions = __webpack_require__(65);
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	
	__webpack_require__(3638);
	
	var DataExportModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {
	        currentAdmin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id })
	    };
	}, function (dispatch, props) {
	    return {
	        populateData: function populateData() {
	            var loading = 'exports';
	            var fetchStudents = function fetchStudents() {
	                var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS;
	                return dispatch(RosterActions.fetchStudents({ embeds: embeds, loading: loading }));
	            };
	
	            var fetchStudentLists = function fetchStudentLists() {
	                var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS;
	                return dispatch(RosterActions.fetchStudentLists({ embeds: embeds, loading: loading }));
	            };
	
	            var fetchAdmins = function fetchAdmins() {
	                return dispatch(RosterActions.fetchAdmins({
	                    filters: { ids: [CurrentUser.get().id] },
	                    embeds: ['admin.org_ids'],
	                    cache: true,
	                    loading: loading
	                }));
	            };
	
	            return Promise.all([fetchAdmins(), fetchStudentLists(), fetchStudents()]);
	        },
	        createDataExport: function createDataExport(data_export) {
	            return dispatch(DataActions.createDataExport({ data_export: data_export }));
	        }
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(DataExportModal, _React$Component);
	
	    function DataExportModal(props) {
	        _classCallCheck(this, DataExportModal);
	
	        var _this = _possibleConstructorReturn(this, (DataExportModal.__proto__ || Object.getPrototypeOf(DataExportModal)).call(this));
	
	        autobind(_this);
	        LuckyOrangeClient.tagComponent("DataExportModal");
	
	        _this.state = _extends({}, _this.initTrackAndOrgOps(), {
	            stageIndex: 0,
	            persistentData: _this.initPersistentData(props)
	        });
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	    // selects xsl organization options and track
	    // based on the user's role
	
	
	    _createClass(DataExportModal, [{
	        key: "initTrackAndOrgOps",
	        value: function initTrackAndOrgOps() {
	            if (CurrentUser.isDistrictAdmin()) {
	                return {
	                    track: TRACKS[DISTRICT_ADMIN],
	                    organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.ADMIN]
	                };
	            } else if (CurrentUser.isSchoolAdmin()) {
	                return {
	                    track: TRACKS[SCHOOL_ADMIN],
	                    organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.ADMIN]
	                };
	            } else {
	                return {
	                    track: TRACKS[TEACHER],
	                    organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.TEACHER]
	                };
	            }
	        }
	
	        // preloads persistent data based on where
	        // user loads the modal on data page
	
	    }, {
	        key: "initPersistentData",
	        value: function initPersistentData(props) {
	            var effectiveData = props.effectiveData;
	
	            var newPersistentData = {};
	
	            if (effectiveData) {
	                var subjectType = effectiveData.subjectType,
	                    startDate = effectiveData.startDate,
	                    endDate = effectiveData.endDate,
	                    userIDs = effectiveData.userIDs,
	                    studentList = effectiveData.studentList;
	
	
	                if (subjectType) {
	                    var metric = DataExportMetrics.SUBJECT_TO_EXPORT_METRICS[subjectType];
	                    if (metric) {
	                        newPersistentData['selectedMetricCategory'] = metric;
	                    }
	                }
	
	                if (startDate && endDate) {
	                    newPersistentData['startDate'] = startDate;
	                    newPersistentData['endDate'] = endDate;
	                }
	
	                if (userIDs) {
	                    newPersistentData['selectedStudents'] = userIDs;
	                }
	
	                if (studentList) {
	                    newPersistentData['selectedStudentLists'] = [parseInt(studentList)];
	                }
	            }
	            return newPersistentData;
	        }
	    }, {
	        key: "resetStageData",
	        value: function resetStageData() {
	            this.setState({
	                stageIndex: 0,
	                persistentData: {}
	            });
	        }
	    }, {
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	    }, {
	        key: "skipStage",
	        value: function skipStage(updatedPersistentData, newStageIndex) {
	            // skip date selector when exporting roster data
	            if (updatedPersistentData.selectedMetricCategory == DataExportMetrics.ROSTER) {
	                return this.state.track[newStageIndex].name == 'date-selector';
	            }
	        }
	
	        ///// STAGE CONTROLLERS /////
	
	    }, {
	        key: "getStageCount",
	        value: function getStageCount() {
	            return this.state.track.length;
	        }
	    }, {
	        key: "getCurrentStageData",
	        value: function getCurrentStageData() {
	            return this.state.track[this.state.stageIndex];
	        }
	    }, {
	        key: "getStageTitle",
	        value: function getStageTitle() {
	            var persistentData = this.state.persistentData;
	
	
	            var currentStageData = this.getCurrentStageData();
	
	            // handle special cases
	            if (currentStageData.name == 'student-selector' && persistentData['selectedOrganizationType'] && persistentData['selectedOrganizationType'] == 'per-class') {
	                return 'Select Classes';
	            }
	
	            if (currentStageData.name == 'user-selector' && persistentData['selectedOrganizationType'] && persistentData['selectedOrganizationType'] == 'per-teacher') {
	                return 'Select Teachers';
	            }
	
	            return currentStageData.title;
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleCloseModal",
	        value: function handleCloseModal() {
	            if (this.props.onComplete) {
	                this.props.onComplete();
	            }
	        }
	
	        // handles next button
	
	    }, {
	        key: "handleAdvanceStage",
	        value: function handleAdvanceStage(newPersistentData) {
	            var _this2 = this;
	
	            var newStageIndex = this.state.stageIndex + 1;
	            if (newPersistentData) {
	                var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
	            } else {
	                var updatedPersistentData = this.state.persistentData;
	            }
	
	            this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, function () {
	                if (_this2.skipStage(updatedPersistentData, newStageIndex)) {
	                    _this2.handleAdvanceStage(updatedPersistentData);
	                }
	            });
	        }
	
	        // handles back button
	
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage(newPersistentData) {
	            var _this3 = this;
	
	            var newStageIndex = this.state.stageIndex - 1;
	
	            if (newPersistentData) {
	                var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
	            } else {
	                var updatedPersistentData = this.state.persistentData;
	            }
	            this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, function () {
	                if (_this3.skipStage(updatedPersistentData, newStageIndex)) {
	                    _this3.handleRetreatStage(updatedPersistentData);
	                }
	            });
	        }
	    }, {
	        key: "handlePrint",
	        value: function handlePrint() {
	            this.props.handlePrint();
	        }
	
	        ///// SUBMIT METHOD /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit(email) {
	            var _this4 = this;
	
	            var persistentData = this.state.persistentData;
	
	
	            if (persistentData.selectedMetricCategory == DataExportMetrics.ADDITIONAL_METRICS) {
	                // convert selected metrics to digest embed
	                var digestEmbeds = persistentData.selectedMetrics.map(function (m) {
	                    // some digets embeds need to be handled differently than
	                    // they are on the other stats table (i.e. 'zpd-below')
	                    if (_.includes(_.keys(DIGEST_EMBED_OVERIDES), m)) {
	                        return DIGEST_EMBED_OVERIDES[m];
	                    } else {
	                        return StudentMetrics.getDigestEmbeds([m]);
	                    }
	                });
	            }
	
	            var data_export = {
	                email: email,
	                organization_type: persistentData.selectedOrganizationType || null,
	                date_span: persistentData.selectedDatePeriod || null,
	                start_date: persistentData.startDate || null,
	                end_date: persistentData.endDate || null,
	                metrics_list: digestEmbeds || persistentData.selectedMetrics || null,
	                metric_category: persistentData.selectedMetricCategory || null,
	                student_ids: persistentData.selectedStudents || null,
	                student_list_ids: persistentData.selectedStudentLists || null,
	                admin_ids: persistentData.selectedTeachers || null
	            };
	
	            return this.props.createDataExport(data_export).then(function (response) {
	                if (!response.errors) {
	                    window.wrNotifications.triggerDropDownNotification({
	                        title: "Done!", text: 'Your data export is being generated and will be sent to your email shortly.', icon: "star"
	                    });
	
	                    _this4.handleCloseModal();
	                }
	            });
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "renderContent",
	        value: function renderContent() {
	            if (this.props.loading) {
	                return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	            } else {
	                var currentStageData = this.getCurrentStageData();
	                return React.createElement(currentStageData.display, _extends({}, currentStageData.props, {
	                    track: this.state.track,
	                    persistentData: this.state.persistentData,
	                    organizationOptions: this.state.organizationOptions,
	                    currentAdmin: this.props.currentAdmin,
	                    onSubmit: this.onSubmit,
	                    onRetreat: this.handleRetreatStage,
	                    onComplete: this.handleAdvanceStage,
	                    handlePrint: this.handlePrint }));
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "dataExportModal" },
	                React.createElement(
	                    "div",
	                    { className: "dataExportProgressSection" },
	                    React.createElement(
	                        "p",
	                        { className: "dataExportTitle" },
	                        this.getStageTitle()
	                    ),
	                    React.createElement(ProgressBar, { current: this.state.stageIndex, total: this.getStageCount() - 1 })
	                ),
	                this.renderContent()
	            );
	        }
	    }]);
	
	    return DataExportModal;
	}(React.Component)) || _class) || _class);
	
	
	DataExportModal.propTypes = StrictPropTypes({
	    onComplete: PropTypes.func,
	    effectiveData: PropTypes.object,
	    handlePrint: PropTypes.func
	});
	
	var DISTRICT_ADMIN = 'districtAdmin';
	var SCHOOL_ADMIN = 'schoolAdmin';
	var TEACHER = 'teacher';
	
	var TRACKS = (_TRACKS = {}, _defineProperty(_TRACKS, DISTRICT_ADMIN, [{
	    name: 'export-type-selector',
	    title: 'Select a Report Type',
	    display: ExportTypeSelector
	}, {
	    name: 'school-org-selector',
	    title: 'Select a School Org',
	    display: SchoolOrgSelector
	}, {
	    name: "metric-selector",
	    title: "Select Metrics",
	    display: ExpandableStatsSelector
	}, {
	    name: "date-selector",
	    title: "Select a Timeframe",
	    display: ExportsDateSpanSelector
	}, {
	    name: "user-selector",
	    title: "Select Students",
	    display: UserSelectorDispatcher
	}, {
	    name: "confirmation",
	    title: "Confirm Your Data Export",
	    display: DataExportConfirmation
	}]), _defineProperty(_TRACKS, SCHOOL_ADMIN, [{
	    name: 'export-type-selector',
	    title: 'Select a Report Type',
	    display: ExportTypeSelector
	}, {
	    name: "metric-selector",
	    title: "Select Metrics",
	    display: ExpandableStatsSelector
	}, {
	    name: "date-selector",
	    title: "Select a Timeframe",
	    display: ExportsDateSpanSelector
	}, {
	    name: "user-selector",
	    title: "Select Students",
	    display: UserSelectorDispatcher
	}, {
	    name: "confirmation",
	    title: "Confirm Your Data Export",
	    display: DataExportConfirmation
	}]), _defineProperty(_TRACKS, TEACHER, [{
	    name: 'export-type-selector',
	    title: 'Select a Report Type',
	    display: ExportTypeSelector
	}, {
	    name: "metric-selector",
	    title: "Select Metrics",
	    display: ExpandableStatsSelector
	}, {
	    name: "date-selector",
	    title: "Select a Timeframe",
	    display: ExportsDateSpanSelector
	}, {
	    name: "student-selector",
	    title: "Select Students",
	    display: ExpandableStudentListSelector
	}, {
	    name: "confirmation",
	    title: "Confirm Your Data Export",
	    display: DataExportConfirmation
	}]), _TRACKS);
	
	var DIGEST_EMBED_OVERIDES = {
	    'zpd-below': 'zpd_below'
	};
	
	module.exports = DataExportModal;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var StudentMetrics = __webpack_require__(29);
	var DataExportMetrics = __webpack_require__(202);
	var Glyphicon = __webpack_require__(8);
	var BraveCheckbox = __webpack_require__(120);
	var Spinner = __webpack_require__(9);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3639);
	
	var ExpandableStatsSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    // MOUNT STUDENT WITHIN STUDENT LISTS
	    var studentLists = {};
	
	    // filter student lists if selected a school org
	    var filters = props.persistentData.selectedSchoolOrg ? { school_org_id: props.persistentData.selectedSchoolOrg.id } : {};
	    _.each(RosterSelectors.studentListsByAdminId({ state: state, adminId: CurrentUser.get().id, filters: filters }), function (sl) {
	        studentLists[sl.id] = sl;
	        studentLists[sl.id].students = [];
	        studentLists[sl.id].primary_students = [];
	    });
	
	    _.each(state.students, function (student) {
	        if (student.student_list_ids) {
	            _.each(student.student_list_ids.all, function (id) {
	                if (studentLists[id]) {
	                    studentLists[id].students.push(student);
	                }
	            });
	            if (studentLists[student.student_list_ids.primary]) {
	                studentLists[student.student_list_ids.primary].primary_students.push(student);
	            }
	        }
	    });
	
	    var loading = RosterSelectors.isLoadingStudentLists({ state: state });
	
	    return {
	        studentLists: _.values(studentLists),
	        loading: loading
	    };
	}), _dec(_class = function (_React$Component) {
	    _inherits(ExpandableStatsSelector, _React$Component);
	
	    function ExpandableStatsSelector(props) {
	        _classCallCheck(this, ExpandableStatsSelector);
	
	        var _this = _possibleConstructorReturn(this, (ExpandableStatsSelector.__proto__ || Object.getPrototypeOf(ExpandableStatsSelector)).call(this, props));
	
	        _this.state = {
	            expandedCategories: [],
	            selectedMetrics: [],
	            selectedMetricCategory: null,
	            selectedOrganizationType: null
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(ExpandableStatsSelector, [{
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	    }, {
	        key: "selectedAddtionalMetrics",
	        value: function selectedAddtionalMetrics() {
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	            return selectedMetricCategory == DataExportMetrics.ADDITIONAL_METRICS;
	        }
	    }, {
	        key: "selectedGoalMetrics",
	        value: function selectedGoalMetrics() {
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	            return selectedMetricCategory == DataExportMetrics.GOALS;
	        }
	    }, {
	        key: "selectedRosterMetrics",
	        value: function selectedRosterMetrics() {
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	            return selectedMetricCategory == DataExportMetrics.ROSTER;
	        }
	
	        // returns unique list of goal metrics from all student lists
	
	    }, {
	        key: "extractGoalMetrics",
	        value: function extractGoalMetrics() {
	            var goalMetrics = [];
	            _.each(_.pluck(this.props.studentLists, 'prefs'), function (prefs) {
	                var glGoals = prefs.grade_level_expectations_metrics;
	                for (var g in prefs.grade_level_expectations_metrics) {
	                    var goalKeys = _.pluck(glGoals[g], 'metric');
	                    _.each(goalKeys, function (gk) {
	                        var goalConfig = _.findWhere(DataExportMetrics.METRICS_BY_CATEGORY['goals'], { key: gk });
	                        if (goalConfig) {
	                            goalMetrics = _.uniq([].concat(_toConsumableArray(goalMetrics), [goalConfig]));
	                        }
	                    });
	                }
	            });
	            return _.compact(goalMetrics);
	        }
	    }, {
	        key: "retreatePossible",
	        value: function retreatePossible() {
	            var track = this.props.track;
	
	            return _.indexOf(track, _.findWhere(track, { name: 'metric-selector' })) > 0;
	        }
	
	        ///// VALIDATORS /////
	
	    }, {
	        key: "validSelectedMetrics",
	        value: function validSelectedMetrics() {
	            return !_.isEmpty(this.state.selectedMetrics);
	        }
	    }, {
	        key: "validOrganizationType",
	        value: function validOrganizationType(selectedOrganizationType) {
	            var organizationOptions = this.props.organizationOptions;
	
	            return _.includes(_.pluck(organizationOptions, 'key'), selectedOrganizationType);
	        }
	
	        ///// HANDLERS /////
	        // toggles metric set selection
	
	    }, {
	        key: "handleMetricCategoryToggle",
	        value: function handleMetricCategoryToggle(label) {
	            var expandedCategories = this.state.expandedCategories;
	
	            if (expandedCategories.includes(label)) {
	                expandedCategories.splice(expandedCategories.indexOf(label), 1);
	            } else {
	                expandedCategories.push(label);
	            }
	            this.setState({ expandedCategories: expandedCategories });
	        }
	
	        // toggles metric selection
	
	    }, {
	        key: "handleMetricSelection",
	        value: function handleMetricSelection(metric) {
	            var selectedMetrics = this.state.selectedMetrics;
	
	            if (selectedMetrics.includes(metric)) {
	                selectedMetrics.splice(selectedMetrics.indexOf(metric), 1);
	            } else {
	                selectedMetrics.push(metric);
	            }
	
	            this.setState({ selectedMetrics: selectedMetrics });
	        }
	    }, {
	        key: "handleCategoryChange",
	        value: function handleCategoryChange(selectedMetricCategory) {
	            var _this2 = this;
	
	            var selectedOrganizationType = this.state.selectedOrganizationType;
	
	            var selectedMetrics = [];
	            var expandedCategories = [];
	            this.setState({ selectedMetricCategory: selectedMetricCategory, selectedMetrics: selectedMetrics, expandedCategories: expandedCategories }, function () {
	                if (_this2.selectedGoalMetrics()) {
	                    // preselect all goals
	                    selectedMetrics = _.pluck(_this2.extractGoalMetrics(), 'key');
	                    _this2.setState({ selectedMetrics: selectedMetrics });
	                } else if (!_this2.selectedAddtionalMetrics()) {
	                    // preselect all metrics within a category
	                    selectedMetrics = _.pluck(DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory], 'key');
	                    _this2.setState({ selectedMetrics: selectedMetrics });
	
	                    // restrict user from using chrono xls organization type when roster category is selected
	                    if (_this2.selectedRosterMetrics() && selectedOrganizationType == DataExportMetrics.CHRONO) {
	                        _this2.setState({ selectedOrganizationType: DataExportMetrics.PER_CLASS });
	                    }
	                }
	            });
	        }
	    }, {
	        key: "handleOrganizationTypeChange",
	        value: function handleOrganizationTypeChange(selectedOrganizationType) {
	            this.setState({ selectedOrganizationType: selectedOrganizationType });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var _state = this.state,
	                selectedMetrics = _state.selectedMetrics,
	                selectedMetricCategory = _state.selectedMetricCategory,
	                selectedOrganizationType = _state.selectedOrganizationType;
	
	            this.props.onRetreat({ selectedMetrics: selectedMetrics, selectedMetricCategory: selectedMetricCategory, selectedOrganizationType: selectedOrganizationType });
	        }
	
	        ///// SUBMIT /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var _state2 = this.state,
	                selectedMetrics = _state2.selectedMetrics,
	                selectedMetricCategory = _state2.selectedMetricCategory,
	                selectedOrganizationType = _state2.selectedOrganizationType;
	
	            if (!this.validSelectedMetrics()) {
	                this.renderErrorAlert("Please Select Metrics");
	            } else if (!this.validOrganizationType(selectedOrganizationType)) {
	                this.renderErrorAlert("Please Select How You'd Like The Data Organized");
	            } else {
	                this.props.onComplete({ selectedMetrics: selectedMetrics, selectedMetricCategory: selectedMetricCategory, selectedOrganizationType: selectedOrganizationType });
	            }
	        }
	
	        ///// RENDER METHODS /////
	
	        // special rendering for goal metrics
	        // we need to aggregate all goals from all student lists
	        // add a loader if the student lists are still loading
	
	    }, {
	        key: "renderGoalMetricsSelector",
	        value: function renderGoalMetricsSelector() {
	            var _this3 = this;
	
	            var _state3 = this.state,
	                selectedMetrics = _state3.selectedMetrics,
	                selectedMetricCategory = _state3.selectedMetricCategory;
	
	            var goalMetrics = this.extractGoalMetrics();
	
	            if (this.props.loading) {
	                goalMetrics = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	            } else {
	                goalMetrics = React.createElement(
	                    "div",
	                    { className: "dropdownSelector__metricCategoryName" },
	                    React.createElement(
	                        "div",
	                        { className: "metricCategoryTitle", onClick: function onClick() {
	                                return _this3.handleMetricCategoryToggle(selectedMetricCategory);
	                            } },
	                        $wr.toTitleCase(selectedMetricCategory.replace('_', ' '))
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "dropdownSelector__metrics" },
	                        goalMetrics.map(function (metricConfig, j) {
	                            return React.createElement(
	                                "div",
	                                { key: j, className: "dropdownSelector__metricsContainer" },
	                                React.createElement(BraveCheckbox, {
	                                    onClick: function onClick() {
	                                        return _this3.handleMetricSelection(metricConfig.key);
	                                    },
	                                    value: selectedMetrics.includes(metricConfig.key)
	                                }),
	                                React.createElement(
	                                    "div",
	                                    { className: "metricLabel" },
	                                    metricConfig.label
	                                )
	                            );
	                        })
	                    )
	                );
	            }
	
	            return React.createElement(
	                "div",
	                { className: "dropdownSelector" },
	                React.createElement(
	                    "div",
	                    { className: "dropdownSelector__dropdown" },
	                    goalMetrics
	                )
	            );
	        }
	
	        // expandable metric selector, each category has children
	
	    }, {
	        key: "renderExpandableSelector",
	        value: function renderExpandableSelector() {
	            var _this4 = this;
	
	            var _state4 = this.state,
	                expandedCategories = _state4.expandedCategories,
	                selectedMetrics = _state4.selectedMetrics,
	                selectedMetricCategory = _state4.selectedMetricCategory;
	
	
	            return React.createElement(
	                "div",
	                { className: "dropdownSelector" },
	                React.createElement(
	                    "div",
	                    { className: "dropdownSelector__dropdown" },
	                    DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory].map(function (cat, i) {
	                        return React.createElement(
	                            "div",
	                            { key: i, className: "dropdownSelector__metricCategoryName" },
	                            React.createElement(
	                                "div",
	                                { className: "metricCategoryTitle", onClick: function onClick() {
	                                        return _this4.handleMetricCategoryToggle(cat.label);
	                                    } },
	                                cat.label
	                            ),
	                            expandedCategories.includes(cat.label) && React.createElement(
	                                "div",
	                                { className: "dropdownSelector__metrics" },
	                                cat.children.map(function (metricKey, j) {
	                                    return React.createElement(
	                                        "div",
	                                        { key: j, className: "dropdownSelector__metricsContainer" },
	                                        React.createElement(BraveCheckbox, {
	                                            onClick: function onClick() {
	                                                return _this4.handleMetricSelection(metricKey);
	                                            },
	                                            value: selectedMetrics.includes(metricKey)
	                                        }),
	                                        React.createElement(
	                                            "div",
	                                            { className: "metricLabel" },
	                                            StudentMetrics.getLabel(metricKey)
	                                        )
	                                    );
	                                })
	                            )
	                        );
	                    })
	                )
	            );
	        }
	
	        // basic metric selector, takes array from DataExportMetrics.METRICS_BY_CATEGORY
	
	    }, {
	        key: "renderMetricsSelector",
	        value: function renderMetricsSelector() {
	            var _this5 = this;
	
	            var _state5 = this.state,
	                selectedMetrics = _state5.selectedMetrics,
	                selectedMetricCategory = _state5.selectedMetricCategory;
	
	            return React.createElement(
	                "div",
	                { className: "dropdownSelector" },
	                React.createElement(
	                    "div",
	                    { className: "dropdownSelector__dropdown" },
	                    React.createElement(
	                        "div",
	                        { className: "dropdownSelector__metricCategoryName" },
	                        React.createElement(
	                            "div",
	                            { className: "metricCategoryTitle", onClick: function onClick() {
	                                    return _this5.handleMetricCategoryToggle(selectedMetricCategory);
	                                } },
	                            $wr.toTitleCase(selectedMetricCategory.replace('_', ' '))
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "dropdownSelector__metrics" },
	                            DataExportMetrics.METRICS_BY_CATEGORY[selectedMetricCategory].map(function (metricConfig, j) {
	                                return React.createElement(
	                                    "div",
	                                    { key: j, className: "dropdownSelector__metricsContainer" },
	                                    React.createElement(BraveCheckbox, {
	                                        onClick: function onClick() {
	                                            return _this5.handleMetricSelection(metricConfig.key);
	                                        },
	                                        value: selectedMetrics.includes(metricConfig.key)
	                                    }),
	                                    React.createElement(
	                                        "div",
	                                        { className: "metricLabel" },
	                                        metricConfig.label
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderCategoryMetrics",
	        value: function renderCategoryMetrics() {
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	
	            if (selectedMetricCategory == null || selectedMetricCategory == 'none') {
	                return null;
	            }
	
	            if (this.selectedAddtionalMetrics()) {
	                return this.renderExpandableSelector();
	            } else if (this.selectedGoalMetrics()) {
	                return this.renderGoalMetricsSelector();
	            } else {
	                return this.renderMetricsSelector();
	            }
	        }
	    }, {
	        key: "renderCategorySelector",
	        value: function renderCategorySelector() {
	            var _this6 = this;
	
	            return React.createElement(
	                "div",
	                { className: "selectContainer" },
	                React.createElement(
	                    "select",
	                    { value: this.state.selectedMetricCategory || '', onChange: function onChange(e) {
	                            return _this6.handleCategoryChange(e.target.value);
	                        }, className: "selectElement" },
	                    _.keys(DataExportMetrics.METRICS_BY_CATEGORY).map(function (m) {
	                        return React.createElement(
	                            "option",
	                            { value: m, key: m },
	                            $wr.toTitleCase(m.replace('_', ' '))
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderOrganizationSelector",
	        value: function renderOrganizationSelector() {
	            var _this7 = this;
	
	            var organizationOptions = this.props.organizationOptions;
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	            // filter out chrono option when pulling roster data
	
	            if (selectedMetricCategory == DataExportMetrics.ROSTER) {
	                organizationOptions = _.filter(organizationOptions, function (op) {
	                    return op.key !== DataExportMetrics.CHRONO;
	                });
	            }
	
	            return React.createElement(
	                "div",
	                { className: "selectContainer" },
	                React.createElement(
	                    "select",
	                    { value: this.state.selectedOrganizationType || '', onChange: function onChange(e) {
	                            return _this7.handleOrganizationTypeChange(e.target.value);
	                        }, className: "selectElement" },
	                    organizationOptions.map(function (c) {
	                        return React.createElement(
	                            "option",
	                            { value: c.key, key: c.key },
	                            c.label
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderInfoTooltip",
	        value: function renderInfoTooltip(dataTip) {
	            return React.createElement(
	                "span",
	                null,
	                React.createElement(Glyphicon, { icon: "info-sign", className: "infoSign", dataTip: dataTip }),
	                React.createElement(ReactTooltip, { effect: "solid" })
	            );
	        }
	    }, {
	        key: "renderStatsSelector",
	        value: function renderStatsSelector() {
	            var selectedMetricCategory = this.state.selectedMetricCategory;
	
	
	            return React.createElement(
	                "div",
	                null,
	                React.createElement(
	                    "div",
	                    { className: "selectorsContainer" },
	                    React.createElement(
	                        "div",
	                        null,
	                        React.createElement(
	                            "div",
	                            { className: "selectorTitle" },
	                            "Select a Metric Set ",
	                            this.renderInfoTooltip(METRIC_SET_TOOLTIP)
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "selector" },
	                            this.renderCategorySelector()
	                        )
	                    ),
	                    React.createElement(
	                        "div",
	                        null,
	                        React.createElement(
	                            "div",
	                            { className: "selectorTitle" },
	                            "Organize Excel Sheets ",
	                            this.renderInfoTooltip(CSV_ORGANIZATION_TOOLTIP)
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "selector" },
	                            this.renderOrganizationSelector()
	                        )
	                    )
	                ),
	                selectedMetricCategory && this.renderCategoryMetrics()
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this8 = this;
	
	            return React.createElement(
	                "div",
	                { className: "metricsDropdownSelectorContainer" },
	                this.renderStatsSelector(),
	                React.createElement(
	                    "div",
	                    { className: "onSubmitContainer" },
	                    this.retreatePossible() && React.createElement(
	                        "button",
	                        { className: "backBtn", onClick: function onClick() {
	                                return _this8.handleRetreatStage();
	                            } },
	                        "Back"
	                    ),
	                    this.validSelectedMetrics() && React.createElement(
	                        "button",
	                        { className: "nextBtn", onClick: function onClick() {
	                                return _this8.onSubmit();
	                            } },
	                        "Next"
	                    )
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                persistentData = _props.persistentData,
	                organizationOptions = _props.organizationOptions;
	            // preselect metric set and xls organization type if already exists in persistent data
	
	            var selectedMetricCategory = _.has(persistentData, 'selectedMetricCategory') ? persistentData.selectedMetricCategory : DataExportMetrics.QUIZZES;
	            var selectedOrganizationType = _.has(persistentData, 'selectedOrganizationType') ? persistentData.selectedOrganizationType : organizationOptions[0].key;
	            this.handleCategoryChange(selectedMetricCategory);
	            this.handleOrganizationTypeChange(selectedOrganizationType);
	        }
	    }]);
	
	    return ExpandableStatsSelector;
	}(React.Component)) || _class);
	
	
	ExpandableStatsSelector.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	var CSV_ORGANIZATION_TOOLTIP = "Organize your Excel sheets to fit your needs. Sort metrics by students or by classes, or see data chronologically by date.";
	var METRIC_SET_TOOLTIP = 'Select a data metric category, then specify individual metrics within that category to tailor the data export to display exactly what you need.';
	
	module.exports = ExpandableStatsSelector;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3640);
	
	var ExportTypeSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {
	        loading: RosterSelectors.isLoadingStudents({ state: state, key: 'index' }) || RosterSelectors.isLoadingStudentLists({ state: state, key: 'index' }) || RosterSelectors.isLoadingAdmins({ state: state, key: 'index' })
	    };
	}), _dec(_class = function (_React$Component) {
	    _inherits(ExportTypeSelector, _React$Component);
	
	    function ExportTypeSelector(props) {
	        _classCallCheck(this, ExportTypeSelector);
	
	        var _this = _possibleConstructorReturn(this, (ExportTypeSelector.__proto__ || Object.getPrototypeOf(ExportTypeSelector)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(ExportTypeSelector, [{
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handlePrintPDF",
	        value: function handlePrintPDF() {
	            this.props.handlePrint();
	        }
	    }, {
	        key: "handleDownloadXsl",
	        value: function handleDownloadXsl() {
	            this.props.onComplete({});
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "renderExportTypeSelector",
	        value: function renderExportTypeSelector() {
	            var _this2 = this;
	
	            if (this.props.loading) {
	                var content = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	            } else {
	                var content = React.createElement(
	                    "div",
	                    { className: "buttonContainer" },
	                    React.createElement(
	                        "button",
	                        { className: "pdfBtn", onClick: function onClick() {
	                                return _this2.handlePrintPDF();
	                            } },
	                        "Print PDF"
	                    ),
	                    React.createElement(
	                        "button",
	                        { className: "xslBtn", onClick: function onClick() {
	                                return _this2.handleDownloadXsl();
	                            } },
	                        "Generate Excel"
	                    ),
	                    content
	                );
	            }
	            return content;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "exportTypeSelector" },
	                this.renderExportTypeSelector()
	            );
	        }
	    }]);
	
	    return ExportTypeSelector;
	}(React.Component)) || _class);
	
	
	ExportTypeSelector.propTypes = StrictPropTypes({
	    loading: PropTypes.bool,
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	module.exports = ExportTypeSelector;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataExportMetrics = __webpack_require__(202);
	var CurrentUser = __webpack_require__(3);
	var WeekPicker = __webpack_require__(938);
	var MonthPicker = __webpack_require__(937);
	
	__webpack_require__(3641);
	
	var ExportsDateSpanSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return { expectationsDateSpans: CurrentUser.get().expectations_date_spans };
	}, function (dispatch, props) {
	    return {};
	}), _dec(_class = function (_React$Component) {
	    _inherits(ExportsDateSpanSelector, _React$Component);
	
	    function ExportsDateSpanSelector(props) {
	        _classCallCheck(this, ExportsDateSpanSelector);
	
	        var _this = _possibleConstructorReturn(this, (ExportsDateSpanSelector.__proto__ || Object.getPrototypeOf(ExportsDateSpanSelector)).call(this, props));
	
	        _this.state = {
	            selectedDatePeriod: props.persistentData.selectedDatePeriod || 'custom',
	            startDate: props.persistentData.startDate || null,
	            endDate: props.persistentData.endDate || null,
	            selectedGoalPeriodStart: props.persistentData.selectedGoalPeriodStart || null,
	            selectedGoalPeriodEnd: props.persistentData.selectedGoalPeriodEnd || null
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(ExportsDateSpanSelector, [{
	        key: "initDateSelections",
	        value: function initDateSelections() {
	            return {
	                startDate: null,
	                endDate: null,
	                selectedGoalPeriodStart: null,
	                selectedGoalPeriodEnd: null
	            };
	        }
	    }, {
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	    }, {
	        key: "selectedOrganizationType",
	        value: function selectedOrganizationType() {
	            var persistentData = this.props.persistentData;
	
	            if (_.has(persistentData, 'selectedOrganizationType')) {
	                return persistentData.selectedOrganizationType;
	            }
	        }
	    }, {
	        key: "chronoOrganizationType",
	        value: function chronoOrganizationType() {
	            return this.selectedOrganizationType() && this.selectedOrganizationType() == 'chrono';
	        }
	    }, {
	        key: "selectedMetricCategory",
	        value: function selectedMetricCategory() {
	            var persistentData = this.props.persistentData;
	
	            if (_.has(persistentData, 'selectedMetricCategory')) {
	                return persistentData.selectedMetricCategory;
	            }
	        }
	    }, {
	        key: "goalMetricCategory",
	        value: function goalMetricCategory() {
	            return this.selectedMetricCategory() && this.selectedMetricCategory() == 'goals';
	        }
	    }, {
	        key: "convertStringToDate",
	        value: function convertStringToDate(string) {
	            return this.formatDate((0, _moment2.default)(string, "YYYY-MM-DD").toDate());
	        }
	
	        // formats all dates the same before sending to state
	
	    }, {
	        key: "formatDate",
	        value: function formatDate(date) {
	            return (0, _moment2.default)(date).format("YYYY-MM-DD");
	        }
	
	        ///// VALIDATORS /////
	
	    }, {
	        key: "validDateRange",
	        value: function validDateRange() {
	            var _state = this.state,
	                startDate = _state.startDate,
	                endDate = _state.endDate;
	
	
	            return startDate && endDate && endDate >= startDate;
	        }
	    }, {
	        key: "validDatePeriod",
	        value: function validDatePeriod() {
	            return _.includes(VALID_DATE_PERIODS, this.state.selectedDatePeriod);
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleDatePeriodChange",
	        value: function handleDatePeriodChange(selectedDatePeriod) {
	            this.setState(_extends({ selectedDatePeriod: selectedDatePeriod }, this.initDateSelections()));
	        }
	    }, {
	        key: "handleGoalPeriodStartChange",
	        value: function handleGoalPeriodStartChange(selectedGoalPeriodStart) {
	            var expectationsDateSpans = this.props.expectationsDateSpans;
	
	
	            var expectationDateSpan = _.findWhere(expectationsDateSpans, { label: selectedGoalPeriodStart });
	            if (expectationDateSpan) {
	                this.setState({
	                    selectedGoalPeriodStart: selectedGoalPeriodStart,
	                    startDate: this.convertStringToDate(expectationDateSpan.start)
	                });
	            }
	        }
	    }, {
	        key: "handleGoalPeriodEndChange",
	        value: function handleGoalPeriodEndChange(selectedGoalPeriodEnd) {
	            var expectationsDateSpans = this.props.expectationsDateSpans;
	
	
	            var expectationDateSpan = _.findWhere(expectationsDateSpans, { label: selectedGoalPeriodEnd });
	            if (expectationDateSpan) {
	                this.setState({
	                    selectedGoalPeriodEnd: selectedGoalPeriodEnd,
	                    endDate: this.convertStringToDate(expectationDateSpan.end)
	                });
	            }
	        }
	    }, {
	        key: "handleStartDateChange",
	        value: function handleStartDateChange(startDate) {
	            startDate = this.formatDate(startDate);
	            this.setState({ startDate: startDate });
	        }
	    }, {
	        key: "handleEndDateChange",
	        value: function handleEndDateChange(endDate) {
	            endDate = this.formatDate(endDate);
	            this.setState({ endDate: endDate });
	        }
	    }, {
	        key: "handleStartWeekChange",
	        value: function handleStartWeekChange(startDate, endDate, selectedDate) {
	            startDate = this.formatDate(startDate);
	            this.setState({ startDate: startDate });
	        }
	    }, {
	        key: "handleEndWeekChange",
	        value: function handleEndWeekChange(startDate, endDate, selectedDate) {
	            endDate = this.formatDate(endDate);
	            this.setState({ endDate: endDate });
	        }
	    }, {
	        key: "handleStartMonthChange",
	        value: function handleStartMonthChange(startDate, endDate, selectedDate) {
	            startDate = this.formatDate(startDate);
	            this.setState({ startDate: startDate });
	        }
	    }, {
	        key: "handleEndMonthChange",
	        value: function handleEndMonthChange(startDate, endDate, selectedDate) {
	            endDate = this.formatDate(endDate);
	            this.setState({ endDate: endDate });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var _state2 = this.state,
	                startDate = _state2.startDate,
	                endDate = _state2.endDate,
	                selectedDatePeriod = _state2.selectedDatePeriod;
	
	
	            var newPersistentData = this.validDateRange() ? { startDate: startDate, endDate: endDate, selectedDatePeriod: selectedDatePeriod } : {};
	            this.props.onRetreat(newPersistentData);
	        }
	
	        ///// SUBMIT /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var _state3 = this.state,
	                startDate = _state3.startDate,
	                endDate = _state3.endDate,
	                selectedDatePeriod = _state3.selectedDatePeriod;
	
	
	            if (!this.validDateRange()) {
	                this.renderErrorAlert("Please Select a Valid Date Range");
	            } else {
	                this.props.onComplete({ startDate: startDate, endDate: endDate, selectedDatePeriod: selectedDatePeriod });
	            }
	        }
	
	        ///// RENDER METHODS /////
	
	        // goal period picker is based on user epxecatation date spans
	
	    }, {
	        key: "renderGoalPeriodPicker",
	        value: function renderGoalPeriodPicker() {
	            var _this2 = this;
	
	            var expectationDateSpans = [React.createElement(
	                "option",
	                { key: "defaultOption", value: "" },
	                "Select a Goal Period"
	            )].concat(_toConsumableArray(this.props.expectationsDateSpans.map(function (d) {
	                return React.createElement(
	                    "option",
	                    { value: d.label, key: d.label },
	                    d.label
	                );
	            })));
	
	            return React.createElement(
	                "div",
	                { className: "exportsDatePickerContainer" },
	                React.createElement(
	                    "div",
	                    { className: "datePicker" },
	                    React.createElement(
	                        "div",
	                        { className: "selectLabel" },
	                        "Start Goal Period:"
	                    ),
	                    React.createElement(
	                        "select",
	                        { value: this.state.selectedGoalPeriodStart, onChange: function onChange(e) {
	                                return _this2.handleGoalPeriodStartChange(e.target.value);
	                            }, className: "selectElement" },
	                        expectationDateSpans
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "datePicker" },
	                    React.createElement(
	                        "div",
	                        { className: "selectLabel" },
	                        "End Goal Period:"
	                    ),
	                    React.createElement(
	                        "select",
	                        { value: this.state.selectedGoalPeriodEnd, onChange: function onChange(e) {
	                                return _this2.handleGoalPeriodEndChange(e.target.value);
	                            }, className: "selectElement" },
	                        expectationDateSpans
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderDatePicker",
	        value: function renderDatePicker() {
	            var _state4 = this.state,
	                startDate = _state4.startDate,
	                endDate = _state4.endDate,
	                selectedDatePeriod = _state4.selectedDatePeriod;
	
	
	            if (!this.validDatePeriod()) {
	                return null;
	            }
	
	            if (selectedDatePeriod == 'goal-period') {
	                return this.renderGoalPeriodPicker();
	            }
	
	            // render date picker based on selected date period
	            if (selectedDatePeriod == 'week') {
	                var startSelector = React.createElement(WeekPicker, { selectedDate: startDate, startDate: startDate, endDate: endDate, onChange: this.handleStartWeekChange.bind(this) });
	                var endSelector = React.createElement(WeekPicker, { selectedDate: endDate, startDate: startDate, endDate: endDate, onChange: this.handleEndWeekChange.bind(this) });
	            } else if (selectedDatePeriod == 'month') {
	                var startSelector = React.createElement(MonthPicker, { selectedDate: startDate, startDate: startDate, endDate: endDate, onChange: this.handleStartMonthChange.bind(this) });
	                var endSelector = React.createElement(MonthPicker, { selectedDate: endDate, startDate: startDate, endDate: endDate, onChange: this.handleEndMonthChange.bind(this) });
	            } else {
	                var startSelector = React.createElement(_reactDatepicker2.default, { className: "form-control", selected: startDate ? (0, _moment2.default)(startDate) : null, onChange: this.handleStartDateChange.bind(this) });
	                var endSelector = React.createElement(_reactDatepicker2.default, { className: "form-control", selected: endDate ? (0, _moment2.default)(endDate) : null, onChange: this.handleEndDateChange.bind(this) });
	            }
	
	            return React.createElement(
	                "div",
	                { className: "exportsDatePickerContainer" },
	                React.createElement(
	                    "div",
	                    { className: "datePicker" },
	                    React.createElement(
	                        "div",
	                        { className: "selectLabel" },
	                        "Start " + $wr.toTitleCase(selectedDatePeriod),
	                        ":"
	                    ),
	                    startSelector
	                ),
	                React.createElement(
	                    "div",
	                    { className: "datePicker" },
	                    React.createElement(
	                        "div",
	                        { className: "selectLabel" },
	                        "End " + $wr.toTitleCase(selectedDatePeriod),
	                        ":"
	                    ),
	                    endSelector
	                )
	            );
	        }
	
	        // selects time periods in which users can specifiy start and end dates
	
	    }, {
	        key: "renderDatePeriodSelector",
	        value: function renderDatePeriodSelector() {
	            var _this3 = this;
	
	            var orgTypeKey = this.selectedOrganizationType() ? this.selectedOrganizationType() : 'chrono';
	            return React.createElement(
	                "div",
	                { className: "selectContainer" },
	                React.createElement(
	                    "div",
	                    { className: "datePeriodLabel" },
	                    "Select a Date Period:"
	                ),
	                React.createElement(
	                    "select",
	                    { value: this.state.selectedDatePeriod, onChange: function onChange(e) {
	                            return _this3.handleDatePeriodChange(e.target.value);
	                        }, className: "selectElement" },
	                    DataExportMetrics.DATE_PERIODS_BY_ORG_TYPE[orgTypeKey].map(function (d) {
	                        return React.createElement(
	                            "option",
	                            { value: d.key, key: d.key },
	                            d.label
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            // render date period selector if user wants
	            // the xls organized by date periods
	            if (this.chronoOrganizationType() && !this.goalMetricCategory()) {
	                var datePeriodSelector = this.renderDatePeriodSelector();
	            }
	
	            var datePicker = this.renderDatePicker();
	            return React.createElement(
	                "div",
	                { className: "exportsDateSpanSelectorContainer" },
	                React.createElement(
	                    "div",
	                    { className: "dateSelectorsConainer" },
	                    datePeriodSelector,
	                    datePicker
	                ),
	                React.createElement(
	                    "div",
	                    { className: "onSubmitContainer" },
	                    React.createElement(
	                        "button",
	                        { className: "backBtn", onClick: function onClick() {
	                                return _this4.handleRetreatStage();
	                            } },
	                        "Back"
	                    ),
	                    this.validDateRange() && React.createElement(
	                        "button",
	                        { className: "nextBtn", onClick: function onClick() {
	                                return _this4.onSubmit();
	                            } },
	                        "Next"
	                    )
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                persistentData = _props.persistentData,
	                expectationsDateSpans = _props.expectationsDateSpans;
	
	            // default selected period to week for chronological export
	
	            if (this.chronoOrganizationType() && _.isEmpty(persistentData.selectedDatePeriod)) {
	                if (persistentData.startDate && persistentData.endDate) {
	                    var startDate = (0, _moment2.default)(persistentData.startDate).startOf('week').format('YYYY-MM-DD');
	                    var endDate = (0, _moment2.default)(persistentData.endDate).endOf('week').format('YYYY-MM-DD');
	                    this.setState({ startDate: startDate, endDate: endDate, selectedDatePeriod: 'week' });
	                } else {
	                    this.setState({ selectedDatePeriod: 'week' });
	                }
	            }
	
	            // default lock into custom date periods for non-chrono exports
	            if (!this.chronoOrganizationType()) {
	                this.setState({ selectedDatePeriod: 'custom' });
	            }
	
	            // if the user seleced to see goal metrics, lock them into selecting goal periods
	            if (this.goalMetricCategory()) {
	                this.setState({ selectedDatePeriod: 'goal-period' });
	                // preselect labels if user is going back in modal sequence
	                if (persistentData.startDate && persistentData.endDate && expectationsDateSpans.length) {
	                    var start = _.findWhere(expectationsDateSpans, { start: persistentData.startDate });
	                    var end = _.findWhere(expectationsDateSpans, { end: persistentData.endDate });
	                    if (start && end) {
	                        this.setState({ selectedGoalPeriodStart: start.label, selectedGoalPeriodEnd: end.label });
	                    } else {
	                        var goalDateSpan = expectationsDateSpans[0];
	                        this.setState({
	                            selectedGoalPeriodStart: goalDateSpan.label,
	                            selectedGoalPeriodEnd: goalDateSpan.label,
	                            startDate: (0, _moment2.default)(goalDateSpan.start).startOf('day').format('YYYY-MM-DD'),
	                            endDate: (0, _moment2.default)(goalDateSpan.end).startOf('day').format('YYYY-MM-DD')
	                        });
	                    }
	                }
	            }
	        }
	    }]);
	
	    return ExportsDateSpanSelector;
	}(React.Component)) || _class);
	
	
	ExportsDateSpanSelector.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	var VALID_DATE_PERIODS = ['week', 'month', 'goal-period', 'custom'];
	
	module.exports = ExportsDateSpanSelector;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3642);
	
	var SchoolOrgSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    // aggregate school orgs
	    var schoolOrgs = [];
	    var admin = RosterSelectors.admin({ state: state, id: props.currentAdmin.id || CurrentUser.get().id });
	    var loadingDistrictOrgs = RosterSelectors.isLoadingDistrictOrgs({ state: state, key: 'index' });
	
	    if (CurrentUser.isSchoolAdmin()) {
	        if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
	            var schoolOrgs = RosterSelectors.schoolOrgs({
	                state: state, conditions: { ids: admin.org_ids.school_orgs.all }
	            });
	        }
	    } else {
	        if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.primary) {
	            var selectedDistrictOrg = RosterSelectors.districtOrg({
	                state: state, id: admin.org_ids.district_orgs.primary[0]
	            });
	
	            if (selectedDistrictOrg) {
	                var schoolOrgs = RosterSelectors.schoolOrgs({
	                    state: state, conditions: { ids: _.map(selectedDistrictOrg.school_orgs, function (so) {
	                            return so.id;
	                        }) }
	                });
	            }
	        }
	    }
	
	    return {
	        schoolOrgs: schoolOrgs,
	        loadingDistrictOrgs: loadingDistrictOrgs
	    };
	}, function (dispatch, props) {
	    return {
	        // fetch school orgs for a district
	        populateData: function populateData() {
	            var currentAdmin = props.currentAdmin;
	
	            if (currentAdmin && currentAdmin.role == 'districtAdminRole') {
	                if (currentAdmin.org_ids && currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.primary) {
	                    return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
	                        filters: { ids: currentAdmin.org_ids.district_orgs.primary },
	                        embeds: ['district_org.school_orgs'],
	                        cache: false
	                    }))]);
	                }
	            }
	        }
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(SchoolOrgSelector, _React$Component);
	
	    function SchoolOrgSelector(props) {
	        _classCallCheck(this, SchoolOrgSelector);
	
	        var _this = _possibleConstructorReturn(this, (SchoolOrgSelector.__proto__ || Object.getPrototypeOf(SchoolOrgSelector)).call(this, props));
	
	        _this.state = {
	            selectedSchoolOrg: null
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(SchoolOrgSelector, [{
	        key: "renderErrorAlert",
	        value: function renderErrorAlert(text) {
	            window.wrNotifications.triggerDropDownNotification({
	                text: text,
	                icon: "exclamation-sign", type: "error"
	            }, 3000);
	        }
	    }, {
	        key: "retreatePossible",
	        value: function retreatePossible() {
	            var track = this.props.track;
	
	            return _.indexOf(track, _.findWhere(track, { name: 'school-org-selector' })) > 0;
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleSchoolOrgChange",
	        value: function handleSchoolOrgChange(schoolOrgID) {
	            var schoolOrgs = this.props.schoolOrgs;
	
	            var schoolOrg = _.findWhere(schoolOrgs, { id: parseInt(schoolOrgID) });
	            var selectedSchoolOrg = schoolOrg ? { id: schoolOrg.id, name: schoolOrg.name } : null;
	            this.setState({ selectedSchoolOrg: selectedSchoolOrg });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var selectedSchoolOrg = this.state.selectedSchoolOrg;
	
	            this.props.onRetreat({ selectedSchoolOrg: selectedSchoolOrg });
	        }
	
	        ///// SUBMIT /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var selectedSchoolOrg = this.state.selectedSchoolOrg;
	
	            if (!selectedSchoolOrg) {
	                this.renderErrorAlert("Please Select a School Org");
	            } else {
	                this.props.onComplete({ selectedSchoolOrg: selectedSchoolOrg });
	            }
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "renderSchoolOrgSelector",
	        value: function renderSchoolOrgSelector() {
	            var _this2 = this;
	
	            return React.createElement(
	                "div",
	                { className: "selectorContainer" },
	                React.createElement(
	                    "select",
	                    { placeholder: "Select a School Org", onChange: function onChange(e) {
	                            return _this2.handleSchoolOrgChange(e.target.value);
	                        }, className: "selectElement" },
	                    React.createElement(
	                        "option",
	                        { value: '' },
	                        "Select a School Org"
	                    ),
	                    this.props.schoolOrgs.map(function (s) {
	                        return React.createElement(
	                            "option",
	                            { value: s.id, key: s.id },
	                            s.name
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            return React.createElement(
	                "div",
	                { className: "schoolOrgDropdownSelectorContainer" },
	                this.renderSchoolOrgSelector(),
	                React.createElement(
	                    "div",
	                    { className: "onSubmitContainer" },
	                    this.retreatePossible() && React.createElement(
	                        "button",
	                        { className: "backBtn", onClick: function onClick() {
	                                return _this3.handleRetreatStage();
	                            } },
	                        "Back"
	                    ),
	                    this.state.selectedSchoolOrg && React.createElement(
	                        "button",
	                        { className: "nextBtn", onClick: function onClick() {
	                                return _this3.onSubmit();
	                            } },
	                        "Next"
	                    )
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var persistentData = this.props.persistentData;
	
	            // preset selected school org if previously selected
	
	            if (persistentData.selectedSchoolOrg) {
	                this.setState({ selectedSchoolOrg: persistentData.selectedSchoolOrg });
	            }
	        }
	    }]);
	
	    return SchoolOrgSelector;
	}(React.Component)) || _class) || _class);
	
	
	SchoolOrgSelector.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	module.exports = SchoolOrgSelector;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var BraveCheckbox = __webpack_require__(120);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(648);
	
	function getSchoolOrgID(props) {
	    var currentAdmin = props.currentAdmin,
	        persistentData = props.persistentData;
	
	
	    if (persistentData.selectedSchoolOrg) {
	        var schoolOrgId = [parseInt(persistentData.selectedSchoolOrg.id)];
	    } else {
	        var schoolOrgId = [parseInt(currentAdmin.org_ids.school_orgs.primary)];
	    }
	    return schoolOrgId;
	}
	
	var TeacherSelector = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {
	        schoolOrg: RosterSelectors.schoolOrg({ state: state, id: getSchoolOrgID(props) }),
	        loading: RosterSelectors.isLoadingSchoolOrgs({ state: state, key: 'index' })
	    };
	}, function (dispatch, props) {
	    return {
	        // extract teachers for each school org
	        populateData: function populateData() {
	            return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
	                filters: { ids: getSchoolOrgID(props) },
	                embeds: ['school_org.teachers'],
	                cache: true
	            }))]);
	        }
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(TeacherSelector, _React$Component);
	
	    function TeacherSelector(props) {
	        _classCallCheck(this, TeacherSelector);
	
	        var _this = _possibleConstructorReturn(this, (TeacherSelector.__proto__ || Object.getPrototypeOf(TeacherSelector)).call(this, props));
	
	        _this.state = {
	            selectedTeachers: props.persistentData.selectedTeachers || []
	        };
	        return _this;
	    }
	
	    ///// VALIDATORS /////
	
	
	    _createClass(TeacherSelector, [{
	        key: "validSelectedTeachers",
	        value: function validSelectedTeachers() {
	            return !_.isEmpty(this.state.selectedTeachers);
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleTeacherSelect",
	        value: function handleTeacherSelect(id) {
	            var selectedTeachers = this.state.selectedTeachers;
	
	
	            if (selectedTeachers.includes(id)) {
	                selectedTeachers.splice(selectedTeachers.indexOf(id), 1);
	            } else {
	                selectedTeachers.push(id);
	            }
	
	            this.setState({ selectedTeachers: selectedTeachers });
	        }
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var _state = this.state,
	                selectedStudents = _state.selectedStudents,
	                selectedTeachers = _state.selectedTeachers;
	
	            this.props.onRetreat({ selectedStudents: selectedStudents, selectedTeachers: selectedTeachers });
	        }
	
	        ///// SUBMIT /////
	
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var selectedTeachers = this.state.selectedTeachers;
	
	
	            var errorMessage = "Please Select A Teacher Before Continuing";
	
	            if (!this.validSelectedTeachers()) {
	                this.renderErrorAlert(errorMessage);
	            } else {
	                this.props.onComplete({ selectedTeachers: selectedTeachers });
	            }
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var schoolOrg = this.props.schoolOrg;
	            var selectedTeachers = this.state.selectedTeachers;
	
	
	            if (this.props.loading) {
	                return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	            }
	
	            return React.createElement(
	                "div",
	                { className: "slDropdownSelectorContainer" },
	                React.createElement(
	                    "div",
	                    { className: "dropdownSelector" },
	                    React.createElement(
	                        "div",
	                        { className: "dropdownSelector__dropdown" },
	                        schoolOrg.teachers.map(function (t, i) {
	                            return React.createElement(
	                                "div",
	                                { key: i, className: "dropdownSelector__slName" },
	                                React.createElement(BraveCheckbox, { className: "dropdownSelector__slNameCheckbox",
	                                    onClick: function onClick() {
	                                        return _this2.handleTeacherSelect(t.id);
	                                    },
	                                    value: selectedTeachers.includes(t.id) }),
	                                React.createElement(
	                                    "div",
	                                    { className: "slNameContainer" },
	                                    React.createElement(
	                                        "span",
	                                        { className: "boldBlue" },
	                                        t.first_name + " " + t.last_name
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "onSubmitContainer" },
	                    React.createElement(
	                        "button",
	                        { className: "backBtn", onClick: function onClick() {
	                                return _this2.handleRetreatStage();
	                            } },
	                        "Back"
	                    ),
	                    this.validSelectedTeachers() && React.createElement(
	                        "button",
	                        { className: "nextBtn", onClick: function onClick() {
	                                return _this2.onSubmit();
	                            } },
	                        "Next"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeacherSelector;
	}(React.Component)) || _class) || _class);
	
	
	TeacherSelector.propTypes = StrictPropTypes({
	    endOnboarding: PropTypes.func,
	    handleAdvanceStage: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onComplete: PropTypes.func,
	    onRetreat: PropTypes.func,
	    track: PropTypes.array,
	    persistentData: PropTypes.object,
	    currentAdmin: PropTypes.object,
	    organizationTypes: PropTypes.array,
	    organizationOptions: PropTypes.array,
	    handlePrint: PropTypes.func
	});
	
	module.exports = TeacherSelector;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableStudentListSelector = __webpack_require__(375);
	var TeacherSelector = __webpack_require__(755);
	
	var UserSelectorDispatcher = function (_React$Component) {
	    _inherits(UserSelectorDispatcher, _React$Component);
	
	    function UserSelectorDispatcher(props) {
	        _classCallCheck(this, UserSelectorDispatcher);
	
	        return _possibleConstructorReturn(this, (UserSelectorDispatcher.__proto__ || Object.getPrototypeOf(UserSelectorDispatcher)).call(this, props));
	    }
	
	    _createClass(UserSelectorDispatcher, [{
	        key: "dispatch",
	        value: function dispatch() {
	            var persistentData = this.props.persistentData;
	            // return correct selector based on the selected organization type
	
	            if (persistentData && persistentData.selectedOrganizationType == 'per-teacher') {
	                return React.createElement(TeacherSelector, this.props);
	            } else {
	                return React.createElement(ExpandableStudentListSelector, this.props);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return this.dispatch();
	        }
	    }]);
	
	    return UserSelectorDispatcher;
	}(React.Component);
	
	module.exports = UserSelectorDispatcher;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(99),
	    AVG_QUIZ_SCORE = _require.AVG_QUIZ_SCORE,
	    AVG_ANSWER_SCORE = _require.AVG_ANSWER_SCORE,
	    STAT_DISPLAY = _require.STAT_DISPLAY,
	    ACTIVITY_METRICS = _require.ACTIVITY_METRICS,
	    RUBRIC_METRICS = _require.RUBRIC_METRICS;
	
	var DigestProgressGraph = __webpack_require__(376);
	
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	__webpack_require__(3644);
	
	var DigestGraphWithDropdown = function (_React$Component) {
	    _inherits(DigestGraphWithDropdown, _React$Component);
	
	    function DigestGraphWithDropdown(props) {
	        _classCallCheck(this, DigestGraphWithDropdown);
	
	        var _this = _possibleConstructorReturn(this, (DigestGraphWithDropdown.__proto__ || Object.getPrototypeOf(DigestGraphWithDropdown)).call(this));
	
	        autobind(_this);
	
	        // passed in when we want to graph rubric performance, not activity data
	        if (props.rubricGraph) {
	            var startMetric = RUBRIC_METRICS[0];
	        } else {
	            var startMetric = ACTIVITY_METRICS[0];
	        }
	
	        _this.state = {
	            metric: startMetric
	        };
	        return _this;
	    }
	
	    _createClass(DigestGraphWithDropdown, [{
	        key: "changeMetric",
	        value: function changeMetric(selection) {
	            this.setState({ metric: selection });
	        }
	    }, {
	        key: "renderHeader",
	        value: function renderHeader() {
	            var _this2 = this;
	
	            var metricHeader = STAT_DISPLAY[this.state.metric].name;
	
	            if (this.props.rubricGraph) {
	                var metricsToList = RUBRIC_METRICS;
	                var prompt = "change skillset";
	            } else {
	                var metricsToList = ACTIVITY_METRICS;
	                var prompt = "change metric";
	            }
	            var activityOptions = _underscore2.default.map(metricsToList, function (metric) {
	                return React.createElement(ButtonDropdownOption, { onClick: _this2.changeMetric.bind(_this2, metric),
	                    text: STAT_DISPLAY[metric].name, key: metric });
	            });
	
	            var select = React.createElement(
	                ButtonDropdown,
	                { text: prompt, dropdownDisplay: "link" },
	                activityOptions
	            );
	
	            return React.createElement(
	                "div",
	                { className: "header" },
	                React.createElement(
	                    "div",
	                    { className: "metricNames" },
	                    metricHeader
	                ),
	                select
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "DigestGraphWithDropdown" },
	                this.renderHeader(),
	                React.createElement(DigestProgressGraph, { metrics: [this.state.metric], entity: this.props.entity, entityType: this.props.entityType })
	            );
	        }
	    }]);
	
	    return DigestGraphWithDropdown;
	}(React.Component);
	
	DigestGraphWithDropdown.propTypes = PageStrictPropTypes({
	    entity: PropTypes.object,
	    entityType: PropTypes.string
	});
	
	module.exports = DigestGraphWithDropdown;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var WritingActions = __webpack_require__(24);
	var ScoringToolTip = __webpack_require__(759);
	var DataRouting = __webpack_require__(36);
	var DisplayToggleControl = __webpack_require__(48);
	var Spinner = __webpack_require__(9);
	
	var _require = __webpack_require__(99),
	    formatTimestamp = _require.formatTimestamp;
	
	var QUIZ_VIEW = 'quiz-view';
	var ANSWER_VIEW = 'answer-view';
	
	var PER_PAGE = 25;
	
	__webpack_require__(3647);
	var IndividualScoringGraph = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    return {};
	}, function (dispatch, props) {
	    var fetchAnswers = function fetchAnswers(ids, pageNum) {
	        return dispatch(WritingActions.fetchAnswers({
	            conditions: { userIDs: [ids], draft: false },
	            filters: { page: pageNum, per_page: PER_PAGE },
	            embeds: ["answer.evaluation", "evaluation.score_details"],
	            cache: false
	        }));
	    };
	
	    var fetchQuizzes = function fetchQuizzes(ids, pageNum) {
	        return dispatch(WritingActions.fetchQuizzes({
	            conditions: { userIDs: [ids], draft: false },
	            filters: { page: pageNum, per_page: PER_PAGE },
	            embeds: ["quiz.evaluation", "evaluation.score_details"],
	            cache: false
	        }));
	    };
	
	    return {
	        fetchQuizzes: fetchQuizzes,
	        fetchAnswers: fetchAnswers
	    };
	}), _dec(_class = function (_React$Component) {
	    _inherits(IndividualScoringGraph, _React$Component);
	
	    function IndividualScoringGraph(props) {
	        _classCallCheck(this, IndividualScoringGraph);
	
	        var _this = _possibleConstructorReturn(this, (IndividualScoringGraph.__proto__ || Object.getPrototypeOf(IndividualScoringGraph)).call(this));
	
	        autobind(_this);
	
	        var initialView = props.view || QUIZ_VIEW;
	        _this.state = {
	            view: initialView,
	            answers: [],
	            quizzes: [],
	            loadingWork: false,
	            loadedDependencies: false
	        };
	        return _this;
	    }
	
	    // function called recursively to fetch all data
	
	
	    _createClass(IndividualScoringGraph, [{
	        key: "fetchData",
	        value: function fetchData(pageNum) {
	            var _this2 = this;
	
	            if (!pageNum) {
	                pageNum = 1;
	            }
	
	            // if the first request, set loading to true
	            if (pageNum == 1) {
	                this.setState({ loadingWork: true });
	            }
	
	            var studentIDs = _underscore2.default.pluck(this.props.students, 'id');
	
	            if (this.state.view == QUIZ_VIEW) {
	                this.props.fetchQuizzes(studentIDs, pageNum).then(function (res) {
	                    // add evaluations straight to the quizzes, so they are easier to work w
	                    var quizzesWithEvals = [];
	                    for (var i = 0; i < res.quizzes.length; i++) {
	                        var quiz = res.quizzes[i];
	                        quiz.evaluation = res.evaluations[i];
	                        quizzesWithEvals.push(quiz);
	                    }
	                    var quizzes = [].concat(_toConsumableArray(_this2.state.quizzes)).concat(quizzesWithEvals);
	
	                    // add those quizzes to data
	                    _this2.setState({ quizzes: quizzes });
	
	                    if (res.quizzes.length == PER_PAGE) {
	                        _this2.fetchData(pageNum + 1);
	                    } else {
	                        _this2.setState({ loadingWork: false });
	                    }
	                });
	            } else if (this.state.view == ANSWER_VIEW) {
	                this.props.fetchAnswers(studentIDs, pageNum).then(function (res) {
	                    // add evaluations straight to the quizzes, so they are easier to work w
	                    var answersWithEvals = [];
	                    for (var i = 0; i < res.answers.length; i++) {
	                        var answer = res.answers[i];
	                        answer.evaluation = res.evaluations[i];
	                        answersWithEvals.push(answer);
	                    }
	                    var answers = [].concat(_toConsumableArray(_this2.state.answers)).concat(answersWithEvals);
	
	                    // add those answers to data
	                    _this2.setState({ answers: answers });
	
	                    if (res.answers.length == PER_PAGE) {
	                        _this2.fetchData(pageNum + 1);
	                    } else {
	                        _this2.setState({ loadingWork: false });
	                    }
	                });
	            }
	        }
	    }, {
	        key: "createTicks",
	        value: function createTicks() {
	            var dates = [];
	            var now = new Date();
	            var startMonth = CurrentUser.get().prefs.school_year_start_month || 8;
	            if (now.getMonth() >= startMonth) {
	                var startYear = now.getFullYear();
	            } else {
	                var startYear = now.getFullYear() - 1;
	            }
	            var yearStartDate = new Date(startYear, startMonth);
	
	            // want to know how many months we are into the year, to add filler.
	            var monthDifference = now.getFullYear() * 12 + now.getMonth() - (yearStartDate.getFullYear() * 12 + yearStartDate.getMonth());
	
	            // if less than 3 months into the school year, add ticks for the first three months
	            if (monthDifference < 3) {
	                dates.push(new Date(now.getFullYear(), startMonth));
	                dates.push(new Date(now.getFullYear(), startMonth + 1));
	                dates.push(new Date(now.getFullYear(), startMonth + 2));
	            } else {
	                for (var monthNum = 0; monthNum <= monthDifference; monthNum++) {
	                    dates.push(new Date(startYear, startMonth + monthNum));
	                }
	            }
	            //now that we have list of months, convert to timestamps.
	            return _underscore2.default.map(dates, function (time) {
	                return time.getTime();
	            });
	        }
	
	        // create ratio for the score of the answer/quiz.
	
	    }, {
	        key: "convertedScore",
	        value: function convertedScore(ratio) {
	            var SCORE_DISPLAY_CAP = 4;
	            var score = ratio * SCORE_DISPLAY_CAP;
	            // Round down to nearest 0.5
	            score = Math.floor(score * 2) / 2;
	            return score;
	        }
	
	        // creates formatted data
	
	    }, {
	        key: "createData",
	        value: function createData() {
	            if (this.state.view == QUIZ_VIEW) {
	                var workType = 'quizzes';
	            } else if (this.state.view == ANSWER_VIEW) {
	                workType = 'answers';
	            }
	
	            var failing = [];
	            var passing = [];
	            var thresholdRatio = CurrentUser.get().prefs.passing_threshold || .75;
	            var threshold = this.convertedScore(thresholdRatio);
	            for (var i = 0; i < this.state[workType].length; i++) {
	                var work = this.state[workType][i];
	                var scatterPoint = { timeStamp: [], score: [] };
	                if (work.evaluation) {
	                    var score = this.convertedScore(work.evaluation['ratio']);
	                    scatterPoint.score.push(score);
	                    scatterPoint.timeStamp.push(Date.parse(work.evaluation['created_at']));
	                    if (score >= threshold) {
	                        passing.push(scatterPoint);
	                    } else {
	                        failing.push(scatterPoint);
	                    }
	                }
	            }
	            return { 'failing': failing, 'passing': passing };
	        }
	    }, {
	        key: "handlePointClick",
	        value: function handlePointClick(pointInfo) {
	            if (this.state.view == QUIZ_VIEW) {
	                var view = 'quizzes';
	            } else {
	                var view = 'answers';
	            }
	
	            var completedAt = new Date(pointInfo.payload.timeStamp[0]);
	            // find the quiz that was clicked on
	            var selectedWork = _underscore2.default.find(this.state[[view]], function (data) {
	                return _underscore2.default.isEqual(new Date(data.evaluation.created_at), completedAt);
	            });
	
	            // need to get query end because datapage url routing requires dates. The date is just a 1 day range.
	            // also need to increment by a month, bc js indexes months from 0
	            var queryStart = new Date(completedAt.getFullYear(), completedAt.getMonth() + 1, completedAt.getDate());
	            var queryEnd = new Date(completedAt.getFullYear(), completedAt.getMonth() + 1, completedAt.getDate() + 1);
	            var dateStrings = _underscore2.default.map([queryStart, queryEnd], function (date) {
	                return date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
	            });
	
	            var query = {
	                userIDs: [selectedWork.user_id],
	                studentList: this.props.activeStudentList.id.toString(),
	                startDate: dateStrings[0],
	                endDate: dateStrings[1]
	            };
	
	            if (this.state.view == QUIZ_VIEW) {
	                query.subjectType = 'Quizzes';
	                query.quizID = selectedWork.id;
	            } else {
	                query.subjectType = "Writing";
	                query.answerID = selectedWork.id;
	            }
	
	            var path = DataRouting.getPath(query, "nope");
	            $wr.redirect(path);
	        }
	    }, {
	        key: "createIndividualScoringGraph",
	        value: function createIndividualScoringGraph() {
	            var data = this.createData();
	            if (this.state.view == QUIZ_VIEW) {
	                var passingThreshold = this.convertedScore(CurrentUser.get().prefs.passing_threshold) || 3;
	                var thresholdLine = React.createElement(Recharts.ReferenceLine, { y: passingThreshold, stroke: "red", strokeDasharray: "3 3" });
	                var toolTipData = this.state.quizzes;
	                return React.createElement(
	                    Recharts.ScatterChart,
	                    { width: 730, height: 300 },
	                    React.createElement(Recharts.CartesianGrid, { strokeDasharray: "3 3" }),
	                    React.createElement(Recharts.XAxis, { dataKey: "timeStamp", tickFormatter: formatTimestamp, ticks: this.createTicks(), domain: ["auto", "auto"], name: "Time", type: "number" }),
	                    React.createElement(Recharts.YAxis, { dataKey: "score", name: "Scores", domain: [0, 4] }),
	                    React.createElement(Recharts.Scatter, { name: "data", data: data['failing'], fill: "#ff7979", onClick: this.handlePointClick }),
	                    React.createElement(Recharts.Scatter, { name: "data", data: data['passing'], fill: "#aae58c", onClick: this.handlePointClick }),
	                    React.createElement(Recharts.Tooltip, { content: React.createElement(ScoringToolTip, { data: toolTipData }) }),
	                    thresholdLine
	                );
	            } else if (this.state.view == ANSWER_VIEW) {
	                var toolTipData = _underscore2.default.where(this.state.answers, function (answer) {
	                    answer.evaluation;
	                });
	                var passingThreshold = this.convertedScore(CurrentUser.get().prefs.passing_threshold) || 3;
	                var thresholdLine = React.createElement(Recharts.ReferenceLine, { y: passingThreshold, stroke: "red", strokeDasharray: "3 3" });
	                return React.createElement(
	                    Recharts.ScatterChart,
	                    { width: 730, height: 300 },
	                    React.createElement(Recharts.CartesianGrid, { strokeDasharray: "3 3" }),
	                    React.createElement(Recharts.XAxis, { dataKey: "timeStamp", tickFormatter: formatTimestamp, ticks: this.createTicks(), domain: ["auto", "auto"], name: "Time", type: "number" }),
	                    React.createElement(Recharts.YAxis, { dataKey: "score", name: "Scores", domain: [0, 4] }),
	                    React.createElement(Recharts.Scatter, { name: "data", data: data['failing'], fill: "#ff7979", onClick: this.handlePointClick }),
	                    React.createElement(Recharts.Scatter, { name: "data", data: data['passing'], fill: "#aae58c", onClick: this.handlePointClick }),
	                    React.createElement(Recharts.Tooltip, { content: React.createElement(ScoringToolTip, { data: toolTipData }) }),
	                    thresholdLine
	                );
	            }
	        }
	    }, {
	        key: "onViewChange",
	        value: function onViewChange(view) {
	            if (view != this.state.view) {
	                // fetch data next
	                this.setState({ view: view });
	            }
	        }
	    }, {
	        key: "renderToggle",
	        value: function renderToggle() {
	            var toggleOptions = [{ key: QUIZ_VIEW, text: "Quizzes" }, { key: ANSWER_VIEW, text: "Answers" }];
	
	            var toggleDisplay = React.createElement(DisplayToggleControl, { options: toggleOptions,
	                onChange: this.onViewChange, className: "hideOnPrint",
	                activeOptionKey: this.state.view });
	            return toggleDisplay;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (!this.state.loadedDependencies || this.state.loadingWork) {
	                var graph = React.createElement(Spinner, { className: "spinner" });
	            } else {
	                var graph = this.createIndividualScoringGraph();
	            }
	
	            return React.createElement(
	                "div",
	                { className: "ScoringGraph" },
	                graph
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            $wr.loadScript("/dependencies/recharts.min.js", "Recharts", function () {
	                _this3.setState({ loadedDependencies: true });
	            });
	            this.fetchData();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            // if new set of students are passed in, need to fetch more data
	            if (!_underscore2.default.isEqual(this.props.students, prevProps.students)) {
	                this.setState({ quizzes: [], answers: [] });
	                this.fetchData();
	            } else if (this.state.view != prevState.view) {
	                this.fetchData();
	            }
	        }
	    }]);
	
	    return IndividualScoringGraph;
	}(React.Component)) || _class);
	
	
	IndividualScoringGraph.propTypes = PageStrictPropTypes({
	    activeStudentList: PropTypes.object,
	    students: PropTypes.array,
	    view: PropTypes.string
	});
	
	module.exports = IndividualScoringGraph;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MatildaAPIClient = new (__webpack_require__(261).Client)("matilda.whooosreading.org", "https");
	
	__webpack_require__(3645);
	
	// This class is used for as a custom tooltip in IndividualScoringGraph.js.
	// Allows us to handle onClick behavior and display bookname, and completed_at for a given answer/quiz. 
	
	var ScoringToolTip = function (_React$Component) {
	    _inherits(ScoringToolTip, _React$Component);
	
	    function ScoringToolTip(props) {
	        _classCallCheck(this, ScoringToolTip);
	
	        var _this = _possibleConstructorReturn(this, (ScoringToolTip.__proto__ || Object.getPrototypeOf(ScoringToolTip)).call(this));
	
	        autobind(_this);
	
	        _this.state = {
	            loading: true,
	            bookName: null
	        };
	        return _this;
	    }
	
	    _createClass(ScoringToolTip, [{
	        key: "render",
	        value: function render() {
	            if (this.props.active && this.props.payload && this.props.payload.length) {
	                var completedAt = new Date(_.find(this.props.payload, function (metric) {
	                    return metric.dataKey = 'timeStamp';
	                }).value[0]);
	
	                var tooltip = React.createElement(
	                    "div",
	                    { className: "mainContainer" },
	                    this.state.bookName ? React.createElement(
	                        "span",
	                        null,
	                        " ",
	                        this.state.bookName
	                    ) : React.createElement(
	                        "i",
	                        null,
	                        " Loading title "
	                    ),
	                    completedAt.toDateString(),
	                    React.createElement(
	                        "i",
	                        null,
	                        "click to view"
	                    )
	                );
	            } else {
	                var tooltip = React.createElement("p", null);
	            }
	
	            return tooltip;
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            var _this2 = this;
	
	            if (this.props.active && this.props.payload && this.props.payload.length && !prevProps.active) {
	                var completedAt = _.find(this.props.payload, function (metric) {
	                    return metric.dataKey = 'timeStamp';
	                }).value[0];
	
	                var completedAt = new Date(completedAt);
	                var validWork = _.filter(this.props.data, function (datum) {
	                    return datum.evaluation;
	                });
	                var selectedWork = _.find(validWork, function (datum) {
	                    return _.isEqual(new Date(datum.evaluation.created_at), completedAt);
	                });
	
	                MatildaAPIClient.postScopedLookup("text_id", { 'keys': selectedWork.text_id }).then(function (res) {
	                    _this2.setState({ bookName: res.results[[selectedWork.text_id]].title });
	                });
	            }
	        }
	    }]);
	
	    return ScoringToolTip;
	}(React.Component);
	
	module.exports = ScoringToolTip;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentMetrics = __webpack_require__(29);
	
	var OrgActivityTable = __webpack_require__(378);
	var Spinner = __webpack_require__(9);
	var OrgTypes = __webpack_require__(45);
	
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	
	var RosterSelectors = __webpack_require__(6);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate");
	
		return conditions;
	}
	
	var DataClassActivity = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			digests: DataSelectors.digestsByOrg({
				state: state,
				orgType: OrgTypes.STUDENT_LIST,
				filters: { start_date: props.startDate, end_date: props.endDate }
			}),
			loading: DataSelectors.isLoadingDigests({ state: state }),
			studentLists: props.schoolOrgID ? RosterSelectors.studentLists({ state: state, filters: { school_org_id: props.schoolOrgID } }) : RosterSelectors.studentLists({ state: state })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(function (dispatch, getState) {
					var query = {};
					if (!props.showGoals) {
						query.digest_embed = StudentMetrics.getDigestEmbeds(DataSelectors.dashboardOtherMetrics({
							state: getState(), count: 4, aggregate: true
						}));
					}
					return dispatch(DataActions.fetchDigests({
						conditions: propsToConditions(props),
						query: query,
						cache: true
					}));
				});
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataClassActivity, _React$Component);
	
		function DataClassActivity(props) {
			_classCallCheck(this, DataClassActivity);
	
			var _this = _possibleConstructorReturn(this, (DataClassActivity.__proto__ || Object.getPrototypeOf(DataClassActivity)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("DataClassActivity");
			return _this;
		}
	
		_createClass(DataClassActivity, [{
			key: "render",
			value: function render() {
				if (this.props.loading) {
					var content = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
					var content = React.createElement(OrgActivityTable, { orgs: this.props.studentLists,
						orgType: OrgTypes.STUDENT_LIST,
						digests: this.props.digests,
						onChangeView: this.props.onChangeView,
						reloadF: this.props.populateData });
				}
	
				return React.createElement(
					"div",
					{ className: "dataClassActivity" },
					content
				);
			}
		}]);
	
		return DataClassActivity;
	}(React.Component)) || _class) || _class);
	
	
	DataClassActivity.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		orgType: PropTypes.string,
		onChangeView: PropTypes.func,
		schoolOrgID: PropTypes.number,
	
		// Data from @connect
		digests: PropTypes.array,
		studentLists: PropTypes.array,
		loading: PropTypes.bool,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataClassActivity;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentMetrics = __webpack_require__(29);
	
	var OrgActivityTable = __webpack_require__(378);
	var Spinner = __webpack_require__(9);
	var OrgTypes = __webpack_require__(45);
	
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	
	var RosterSelectors = __webpack_require__(6);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate");
	
		return conditions;
	}
	
	var DataSchoolActivity = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			digests: DataSelectors.digestsByOrg({
				state: state,
				orgType: OrgTypes.SCHOOL_ORG,
				filters: { start_date: props.startDate, end_date: props.endDate }
			}),
			loading: DataSelectors.isLoadingDigests({ state: state }),
			schoolOrgs: RosterSelectors.schoolOrgs({ state: state })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(function (dispatch, getState) {
					var query = {};
					if (!props.showGoals) {
						query.digest_embed = StudentMetrics.getDigestEmbeds(DataSelectors.dashboardOtherMetrics({
							state: getState(), count: 4, aggregate: true
						}));
					}
					return dispatch(DataActions.fetchDigests({
						conditions: propsToConditions(props),
						query: query,
						cache: true
					}));
				});
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataSchoolActivity, _React$Component);
	
		function DataSchoolActivity(props) {
			_classCallCheck(this, DataSchoolActivity);
	
			var _this = _possibleConstructorReturn(this, (DataSchoolActivity.__proto__ || Object.getPrototypeOf(DataSchoolActivity)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("DataClassActivity");
			return _this;
		}
	
		_createClass(DataSchoolActivity, [{
			key: "render",
			value: function render() {
				if (this.props.loading) {
					var content = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
					var content = React.createElement(OrgActivityTable, { orgs: this.props.schoolOrgs,
						orgType: OrgTypes.SCHOOL_ORG,
						digests: this.props.digests,
						reloadF: this.props.populateData,
						onChangeView: this.props.onChangeView });
				}
	
				return React.createElement(
					"div",
					{ className: "dataSchoolActivity" },
					content
				);
			}
		}]);
	
		return DataSchoolActivity;
	}(React.Component)) || _class) || _class);
	
	
	DataSchoolActivity.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		orgType: PropTypes.string,
		onChangeView: PropTypes.func,
	
		// Data from @connect
		digests: PropTypes.array,
		schoolOrgs: PropTypes.array,
		loading: PropTypes.bool,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataSchoolActivity;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = __webpack_require__(16);
	var CurrentUser = __webpack_require__(3);
	
	var DataRouting = __webpack_require__(36);
	var WidgetConfig = __webpack_require__(66);
	
	var ReadingActions = __webpack_require__(27);
	
	var WritingSelectors = __webpack_require__(14);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	var Spinner = __webpack_require__(9);
	var EmptyState = __webpack_require__(117);
	var PaginationControls = __webpack_require__(90);
	var DataTable = __webpack_require__(384);
	var ScoreDisplay = __webpack_require__(103);
	var Glyphicon = __webpack_require__(8);
	var QuizDisplay = __webpack_require__(174);
	
	function reverseTimeZoneOffset(startDate, endDate) {
	  // reverse the time zone offset pull all books based
	  // on the user's time zone
	  var currentUser = CurrentUser.get();
	  if (currentUser.time_zone_offset) {
	    var offset = -currentUser.time_zone_offset / (60 * 60);
	  } else {
	    var offset = 7; // default to Pacific time
	  }
	
	  startDate = (0, _moment2.default)(startDate).startOf('day').utcOffset(offset).format("YYYY-MM-DD");
	  endDate = (0, _moment2.default)(endDate).endOf('day').utcOffset(offset).format("YYYY-MM-DD");
	
	  return { startDate: startDate, endDate: endDate };
	}
	
	function propsToConditions(props) {
	  var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs", "readBook");
	
	  conditions.timeKey = "last_active_by_user_id";
	
	  if (conditions.startDate && conditions.endDate) {
	    var reversedTimeSpan = reverseTimeZoneOffset(conditions.startDate, conditions.endDate);
	    conditions.startDate = reversedTimeSpan.startDate;
	    conditions.endDate = reversedTimeSpan.endDate;
	  }
	
	  return conditions;
	}
	
	var DataBookTables = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    loading: ReadingSelectors.isLoadingBooks({ state: state, userIDs: props.userIDs }),
	    books: ReadingSelectors.books({
	      state: state,
	      conditions: propsToConditions(props)
	    }),
	    showLogs: Features.isEnabled(Features.LOG_READING),
	    showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES),
	    prefs: RosterSelectors.globalStudentListPrefs({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "readBook");
	
	      if (conditions.startDate && conditions.endDate) {
	        var reversedTimeSpan = reverseTimeZoneOffset(conditions.startDate, conditions.endDate);
	        conditions.startDate = reversedTimeSpan.startDate;
	        conditions.endDate = reversedTimeSpan.endDate;
	      }
	
	      var actionFunction = ReadingActions.fetchBookActivity;
	      var options = { embeds: ["book.quiz_evaluations", "book.log_sums", "book.answers", "book.reviews"], cache: true, fetchDetails: !props.skipPreloadDetails };
	      new Promise(function (resolve, reject) {
	        $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
	      }).catch(function () {
	        return console.log("Book activity failed to load");
	      });
	    },
	    selectEvaluation: function selectEvaluation(textID, userID) {
	      return dispatch(function (dispatch, getState) {
	        return WritingSelectors.evaluationByUserTextType({
	          state: getState(), subjectTextID: textID,
	          subjectUserID: userID, subjectType: 'Quiz'
	        });
	      });
	    },
	    selectStudent: function selectStudent(studentID) {
	      return dispatch(function (dispatch, getState) {
	        return RosterSelectors.student({ state: getState(), id: studentID });
	      });
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(DataBookTables, _React$Component);
	
	  function DataBookTables(props) {
	    _classCallCheck(this, DataBookTables);
	
	    var _this = _possibleConstructorReturn(this, (DataBookTables.__proto__ || Object.getPrototypeOf(DataBookTables)).call(this));
	
	    autobind(_this);
	
	    LuckyOrangeClient.tagComponent("DataBookTables");
	    _this.state = {
	      bookChunks: _.chunk(_.sortBy(props.books, "max_last_active").reverse(), DataRouting.PER_PAGE),
	      currentPage: 1,
	      totalCount: _.size(props.books)
	    };
	    return _this;
	  }
	
	  // changes location on the data table
	  // saves current location state for users to come back
	
	
	  _createClass(DataBookTables, [{
	    key: "changeLocationState",
	    value: function changeLocationState(subjectType, subjectID, controlMode) {
	      var newLocationState = _extends({}, this.props.locationState);
	      newLocationState.subjectType = subjectType;
	
	      if (subjectType == DataRouting.SUBJECT_QUIZZES) {
	        newLocationState.quizID = subjectID;
	      } else {
	        newLocationState.textID = subjectID;
	      }
	
	      if (controlMode) {
	        newLocationState = _extends({}, newLocationState, { controlMode: controlMode });
	      }
	
	      this.props.updateRoute(newLocationState);
	    }
	  }, {
	    key: "onPageChange",
	    value: function onPageChange(page) {
	      this.setState({ currentPage: page });
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return $wr.formatDate(date, "MM/DD/YY");
	    }
	
	    // hides score for free user until they manually enter it
	
	  }, {
	    key: "hideAutograderScore",
	    value: function hideAutograderScore(evaluation) {
	      return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score;
	    }
	
	    // checks user id and book with read_book filter
	
	  }, {
	    key: "readBookFilterMatches",
	    value: function readBookFilterMatches(book, user_id) {
	      var readBook = this.props.readBook;
	
	
	      if (!readBook) {
	        return true;
	      }
	      if (readBook == 'yes' && book.read_book_yes && book.read_book_yes[user_id]) {
	        return true;
	      }
	      if (readBook == 'no' && book.read_book_no && book.read_book_no[user_id]) {
	        return true;
	      }
	    }
	
	    // link that sends user to quiz view with edit tab open
	
	  }, {
	    key: "renderGradeQuizLink",
	    value: function renderGradeQuizLink(quizID, linkText) {
	      var _this2 = this;
	
	      return React.createElement(
	        "a",
	        { onClick: function onClick() {
	            return _this2.changeLocationState(DataRouting.SUBJECT_QUIZZES, quizID, EDIT_CONTROLS);
	          }, className: "gradeQuizLink" },
	        linkText
	      );
	    }
	  }, {
	    key: "buildWritingItem",
	    value: function buildWritingItem(stat, title, subjectType, subjectID) {
	      var _this3 = this;
	
	      return React.createElement(
	        "div",
	        { key: title + "_" + subjectID, className: "writingItem" },
	        React.createElement(
	          "span",
	          { className: "itemSubject" },
	          title,
	          ":"
	        ),
	        React.createElement(
	          "span",
	          { className: "itemStat" },
	          stat
	        ),
	        React.createElement(
	          "a",
	          { className: "hideOnPrint", onClick: function onClick() {
	              return _this3.changeLocationState(subjectType, subjectID);
	            } },
	          React.createElement(Glyphicon, { icon: "new-window" })
	        )
	      );
	    }
	
	    // returns counts of answers and reviews
	    // completed by student (TODO: add question builders and exercises)
	
	  }, {
	    key: "writingCells",
	    value: function writingCells(book, userID) {
	      var writingCountElements = [];
	
	      if (book['answer_counts'] && book['answer_counts'][userID]) {
	        var title = book['answer_counts'][userID] > 1 ? 'Answers' : 'Answer';
	        var subjectType = DataRouting.SUBJECT_ANSWERS;
	        writingCountElements.push(this.buildWritingItem(book['answer_counts'][userID], title, subjectType, book.text_id));
	      }
	
	      if (book['review_counts'] && book['review_counts'][userID]) {
	        var title = book['review_counts'][userID] > 1 ? 'Reviews' : 'Review';
	        var subjectType = DataRouting.SUBJECT_REVIEWS;
	        writingCountElements.push(this.buildWritingItem(book['review_counts'][userID], title, subjectType, book.text_id));
	      }
	
	      return writingCountElements;
	    }
	  }, {
	    key: "generateBookRows",
	    value: function generateBookRows(books) {
	      var _this4 = this;
	
	      var rows = [];
	      _.each(books, function (book) {
	        var user_ids = book.user_ids,
	            last_actives = book.last_actives,
	            text_id = book.text_id,
	            title = book.title,
	            lexile_score = book.lexile_score;
	
	
	        _.each(user_ids, function (user_id) {
	          // continue loop if read book filter doesn't match
	          // albus sends one response per book, so we have to check
	          // user id against read_book filter
	          if (!_this4.readBookFilterMatches(book, user_id)) {
	            return;
	          }
	          // student information
	          var student = _this4.props.selectStudent(user_id);
	          // quiz evaluaiton for book
	          var quizEvaluation = _this4.props.selectEvaluation(text_id, user_id);
	          var writingCells = _this4.writingCells(book, user_id);
	
	          // a quiz is required in order to determine if the
	          // student read the book or not
	          if (!_.isEmpty(writingCells)) {
	            var writingValue = React.createElement(
	              "div",
	              { className: "writingContainer" },
	              writingCells
	            );
	          }
	
	          if (quizEvaluation && _this4.hideAutograderScore(quizEvaluation)) {
	            var readTheBook = _this4.renderGradeQuizLink(quizEvaluation.subject_id, 'Grade Quiz');
	            var readBookColumnClass = 'readBookColumn-EmptyState';
	          } else if (quizEvaluation) {
	            // quiz score
	            var stat = React.createElement(ScoreDisplay, { evaluationID: quizEvaluation.id, mode: ScoreDisplay.SCORE_ONLY_MODE });
	            var writingValue = React.createElement(
	              "div",
	              { className: "writingContainer" },
	              _this4.buildWritingItem(stat, 'Quiz Score', DataRouting.SUBJECT_QUIZZES, quizEvaluation.subject_id),
	              writingCells
	            );
	
	            if (quizEvaluation.read_book) {
	              var readTheBook = quizEvaluation.read_book;
	              var readBookColumnClass = 'readBookColumn';
	              var confidence = quizEvaluation.read_book_confidence;
	            } else {
	              var readTheBook = _this4.renderGradeQuizLink(quizEvaluation.subject_id, 'Complete Grade');
	              var readBookColumnClass = 'readBookColumn-EmptyState';
	            }
	          } else {
	            var readTheBook = 'Quiz Pending';
	            var readBookColumnClass = 'readBookColumn-Pending';
	          }
	
	          var bookTitle = lexile_score ? title + " (L: " + lexile_score + ")" : title;
	
	          var row = [{
	            // date column
	            value: _this4.formatDate(last_actives[user_id]),
	            classes: ['no-wrap', 'dateColumn']
	          }, {
	            // student name column
	            value: student.display_name,
	            classes: ['studentNameColumn']
	          }, {
	            // book title column
	            value: bookTitle,
	            classes: ['pre-wrap', 'italic', 'bookTitle']
	          }, {
	            // displays if the student read the book based on
	            // totality of writing data for book
	            value: readTheBook,
	            classes: ['no-wrap', readBookColumnClass, 'extraWidth'],
	            confidence: confidence,
	            book_answers_analysis_column: true,
	            expanded_content: { component: 'BookAnswersAnalysis', component_props: { textID: text_id, userID: user_id } }
	          }, {
	            // shows all writing done for a book
	            value: writingValue,
	            classes: ['no-wrap', 'writingColumn']
	          }];
	          rows.push(row);
	        });
	      });
	      return rows;
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination() {
	      if (this.state.totalCount) {
	        return React.createElement(PaginationControls, { page: this.state.currentPage,
	          perPage: DataRouting.PER_PAGE,
	          totalCount: this.state.totalCount,
	          onPageChange: this.onPageChange });
	      }
	    }
	  }, {
	    key: "renderBooksTable",
	    value: function renderBooksTable() {
	      if (this.props.loading) {
	        return React.createElement(Spinner, null);
	      } else if (this.state.totalCount) {
	        var books = this.state.bookChunks[this.state.currentPage - 1];
	        return React.createElement(DataTable, {
	          subjectType: "books",
	          columnHeaders: QUIZ_TABLE_HEADERS,
	          rows: this.generateBookRows(books),
	          printable: false
	        });
	      } else {
	        return React.createElement(EmptyState, { type: BOOKS });
	      }
	    }
	
	    // renders hidden component used for printing
	    // without pagination
	
	  }, {
	    key: "renderPrintableBooksTable",
	    value: function renderPrintableBooksTable() {
	      var _props = this.props,
	          books = _props.books,
	          loading = _props.loading;
	
	      if (books && !loading) {
	        var books = _.flatten(this.state.bookChunks);
	        return React.createElement(DataTable, {
	          subjectType: "books",
	          columnHeaders: QUIZ_TABLE_HEADERS,
	          rows: this.generateBookRows(books),
	          printable: true
	        });
	      }
	    }
	  }, {
	    key: "renderLoading",
	    value: function renderLoading() {
	      if (this.props.loading) {
	        return React.createElement(Spinner, null);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "dataBookTables" },
	        this.renderPagination(),
	        this.renderBooksTable(),
	        this.renderPrintableBooksTable(),
	        this.renderPagination()
	      );
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.books !== prevProps.books) {
	        this.setState({
	          bookChunks: _.chunk(_.sortBy(this.props.books, "max_last_active").reverse(), DataRouting.PER_PAGE),
	          currentPage: 1,
	          totalCount: _.size(this.props.books)
	        });
	      }
	    }
	  }]);
	
	  return DataBookTables;
	}(React.Component)) || _class) || _class);
	
	
	var BOOKS = "books";
	var QUIZ_TABLE_HEADERS = ['Date', 'Student', 'Title', 'Read Book', 'Writing'];
	var EDIT_CONTROLS = "Edit";
	
	DataBookTables.WrappedComponent.propTypes = PageStrictPropTypes({
	  // Data from above
	  userIDs: PropTypes.array,
	  startDate: PropTypes.string,
	  endDate: PropTypes.string,
	  showFullData: PropTypes.bool,
	  textVariety: PropTypes.string,
	  textID: PropTypes.string,
	  readBook: PropTypes.string,
	  prefs: PropTypes.object,
	
	  byStudent: PropTypes.bool,
	  booksAmount: PropTypes.number,
	  showLogs: PropTypes.bool,
	  showDigitalActivities: PropTypes.bool,
	  skipPreloadDetails: PropTypes.bool,
	  softMaxPerTable: PropTypes.number,
	  locationState: PropTypes.object,
	  prevLocationState: PropTypes.object,
	  updateRoute: PropTypes.func,
	
	  // Data from @connect
	  loading: PropTypes.bool,
	  books: PropTypes.array,
	  studentList: PropTypes.string,
	
	  // Handlers from @connect
	  populateData: PropTypes.func,
	  selectEvaluation: PropTypes.func,
	  selectStudent: PropTypes.func
	});
	
	module.exports = DataBookTables;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var AltBoard = __webpack_require__(248);
	var ExerciseTile = __webpack_require__(251);
	var ItemHeader = __webpack_require__(160);
	var NoActivityBlock = __webpack_require__(71);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textID", "userIDs");
	
		return conditions;
	}
	
	var DataExercises = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			loading: WritingSelectors.isLoadingResponses({ state: state }),
			responses: WritingSelectors.responses({
				state: state, conditions: propsToConditions(props)
			})
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(WritingActions.fetchResponses({
					conditions: propsToConditions(props),
					embeds: ["response.activity", "activity.format_summary"],
					cache: true
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataExercises, _React$Component);
	
		function DataExercises(props) {
			_classCallCheck(this, DataExercises);
	
			var _this = _possibleConstructorReturn(this, (DataExercises.__proto__ || Object.getPrototypeOf(DataExercises)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("DataExercises");
			return _this;
		}
	
		_createClass(DataExercises, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var exercisesDisplay = [];
				var studentsWithoutExercises = [];
	
				_.each(this.props.userIDs, function (studentID) {
					var responses = _.where(_this2.props.responses, { user_id: studentID });
					if (responses.length > 0) {
						var tiles = _.map(responses, function (response) {
							return React.createElement(ExerciseTile, { responseID: response.id, key: response.id,
								smallThumbnail: true, allowExpandResponse: true });
						});
						exercisesDisplay.push(React.createElement(
							"div",
							{ key: studentID },
							React.createElement(ItemHeader, { studentID: studentID, pageBreak: true }),
							React.createElement(
								AltBoard,
								{ narrowBoard: true },
								tiles
							)
						));
					} else {
						studentsWithoutExercises.push(studentID);
					}
				});
	
				if (studentsWithoutExercises.length > 0) {
					var noExcersises = React.createElement(NoActivityBlock, { userIDs: studentsWithoutExercises, contentType: "Exercises" });
				}
	
				var display = React.createElement(
					"div",
					null,
					exercisesDisplay,
					noExcersises
				);
	
				return React.createElement(
					"div",
					{ className: "dataExercises" },
					display
				);
			}
		}]);
	
		return DataExercises;
	}(React.Component)) || _class) || _class);
	
	DataExercises.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showFullData: PropTypes.bool,
	
		// Data from @connect
		loading: PropTypes.bool,
		responses: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataExercises;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var LogCalendar = __webpack_require__(241);
	var ItemHeader = __webpack_require__(160);
	var NoActivityBlock = __webpack_require__(71);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs");
	
		conditions.timeKey = "log_date";
	
		return conditions;
	}
	
	var DataLogCalendars = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			logs: ReadingSelectors.logs({
				state: state, conditions: propsToConditions(props)
			}),
			loading: ReadingSelectors.isLoadingLogs({ state: state })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID");
					var actionFunction = ReadingActions.fetchLogs;
					var options = { cache: true };
					return new Promise(function (resolve, reject) {
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
							resolve(results);
						});
					}).catch(function () {
						return console.log("Logs failed to load");
					});
				} else {
					return dispatch(ReadingActions.fetchLogs({
						conditions: propsToConditions(props),
						cache: true
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataLogCalendars, _React$Component);
	
		function DataLogCalendars(props) {
			_classCallCheck(this, DataLogCalendars);
	
			var _this = _possibleConstructorReturn(this, (DataLogCalendars.__proto__ || Object.getPrototypeOf(DataLogCalendars)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("DataLogCalendars");
			return _this;
		}
	
		_createClass(DataLogCalendars, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var calendarLogsDisplay = [];
				var studentsWithoutLogs = [];
	
				_.each(this.props.userIDs, function (studentID) {
					var logs = _.where(_this2.props.logs, { user_id: studentID });
					if (logs.length > 0) {
						calendarLogsDisplay.push(React.createElement(
							"div",
							{ key: studentID },
							React.createElement(ItemHeader, { studentID: studentID, pageBreak: true }),
							React.createElement(LogCalendar, { logs: logs, key: studentID })
						));
					} else {
						studentsWithoutLogs.push(studentID);
					}
				});
				if (studentsWithoutLogs.length > 0) {
					var noLogs = React.createElement(NoActivityBlock, { userIDs: studentsWithoutLogs, contentType: "Reading Log Calendars" });
				}
				var display = React.createElement(
					"div",
					null,
					calendarLogsDisplay,
					noLogs
				);
	
				return React.createElement(
					"div",
					{ className: "dataLogCalendars" },
					display
				);
			}
		}]);
	
		return DataLogCalendars;
	}(React.Component)) || _class) || _class);
	
	DataLogCalendars.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		showFullData: PropTypes.bool,
	
		// Data from @connect
		loading: PropTypes.bool,
		logs: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataLogCalendars;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _PageStrictPropTypes;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	
	var DataRouting = __webpack_require__(36);
	
	var WritingActions = __webpack_require__(24);
	var ReadingActions = __webpack_require__(27);
	
	var WritingSelectors = __webpack_require__(14);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	var WidgetConfig = __webpack_require__(66);
	
	var QuizDisplay = __webpack_require__(174);
	var AnswerDisplay = __webpack_require__(171);
	var PaginationControls = __webpack_require__(90);
	var Spinner = __webpack_require__(9);
	var NoActivityBlock = __webpack_require__(71);
	var DataTable = __webpack_require__(384);
	var EmptyState = __webpack_require__(117);
	var ScoreDisplay = __webpack_require__(103);
	var Glyphicon = __webpack_require__(8);
	
	function propsToConditions(props) {
	  var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs", "order", "status");
	
	  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	  conditions.withTotal = true;
	
	  if (conditions.startDate && conditions.endDate) {
	    // reverse the time zone offset pull all quizzes based
	    // on the user's time zone
	    var currentUser = CurrentUser.get();
	    if (currentUser.time_zone_offset) {
	      var offset = -currentUser.time_zone_offset / (60 * 60);
	    } else {
	      var offset = 7; // default to Pacific time
	    }
	
	    conditions.startDate = (0, _moment2.default)(conditions.startDate).startOf('day').utcOffset(offset).format("YYYY-MM-DD");
	    conditions.endDate = (0, _moment2.default)(conditions.endDate).endOf('day').utcOffset(offset).format("YYYY-MM-DD");
	  }
	
	  return conditions;
	}
	
	function sortItems(quizzes) {
	  return _.sortBy(quizzes, function (x) {
	    return new Date(x.completed_at).valueOf();
	  }).reverse();
	}
	
	// FOR DEMO PURPOSES ONLY
	// REMOVE THIS JUNK IMMEDIATELY ONCE L2E CAN TELL
	// WEB IF A QUIZ IS PASSED
	function filterStatus(quizzes, state, props) {
	  if (!props.status) {
	    return quizzes;
	  }
	
	  var prefs = RosterSelectors.globalStudentListPrefs({ state: state });
	  return _.filter(quizzes, function (quiz) {
	    var evaluation = WritingSelectors.evaluation({ state: state, id: quiz.evaluation });
	    if (!evaluation) {
	      return false;
	    }
	
	    if (props.status == 'flagged') {
	      return evaluation.filtered;
	    } else if (props.status == 'failed') {
	      return !WidgetConfig.isPassing(evaluation, prefs.passing_threshold);
	    } else if (props.status == 'passed') {
	      return WidgetConfig.isPassing(evaluation, prefs.passing_threshold);
	    }
	  });
	}
	
	var DataQuizTables = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    loading: WritingSelectors.isLoadingQuizzes({ state: state, key: 'index', userIDs: props.userIDs }),
	    quizzes: filterStatus(sortItems(WritingSelectors.quizzes({ state: state, conditions: propsToConditions(props) })), state, props),
	    books: ReadingSelectors.books({ state: state, conditions: propsToConditions(props) })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order", "status");
	      var actionFunction = WritingActions.fetchQuizzes;
	      var embeds = ["quiz.evaluation", "quiz.answer_ids", "evaluation.score_details"];
	
	      var options = { embeds: embeds, cache: true };
	      return new Promise(function (resolve, reject) {
	        $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);
	      }).catch(function () {
	        return console.log("Quizzes failed to load");
	      });
	    },
	    fetchBooks: function fetchBooks(textIDs) {
	      return dispatch(ReadingActions.fetchBooks({ ids: textIDs }));
	    },
	    fetchSingleBookActivity: function fetchSingleBookActivity(textID, userID) {
	      var embeds = ["book.answers", "answer.evaluation"];
	      var conditions = { allowDraft: false };
	      var query = { user_id: userID };
	      return dispatch(ReadingActions.fetchSingleBookActivity({ id: textID, embeds: embeds, query: query, conditions: conditions }));
	    },
	    selectEvaluation: function selectEvaluation(evaluationID) {
	      return dispatch(function (dispatch, getState) {
	        return WritingSelectors.evaluation({ state: getState(), id: evaluationID });
	      });
	    },
	    selectStudent: function selectStudent(studentID) {
	      return dispatch(function (dispatch, getState) {
	        return RosterSelectors.student({ state: getState(), id: studentID });
	      });
	    },
	    selectBook: function selectBook(textID) {
	      return dispatch(function (dispatch, getState) {
	        return ReadingSelectors.book({ state: getState(), id: textID });
	      });
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(DataQuizTables, _React$Component);
	
	  function DataQuizTables(props) {
	    _classCallCheck(this, DataQuizTables);
	
	    var _this = _possibleConstructorReturn(this, (DataQuizTables.__proto__ || Object.getPrototypeOf(DataQuizTables)).call(this));
	
	    autobind(_this);
	
	    _this.state = {
	      quizChunks: _.chunk(props.quizzes, DataRouting.PER_PAGE),
	      currentQuizPage: 1,
	      totalCount: _.size(props.quizzes),
	      showAdditionalAnswers: false,
	      currentAnswerPage: 1
	    };
	
	    LuckyOrangeClient.tagComponent("DataQuizTables");
	    return _this;
	  }
	
	  _createClass(DataQuizTables, [{
	    key: "singleQuiz",
	    value: function singleQuiz() {
	      if (!this.props.quizID) {
	        return null;
	      }
	      return _.findWhere(this.props.quizzes, { id: this.props.quizID });
	    }
	  }, {
	    key: "additionalAnswerIDs",
	    value: function additionalAnswerIDs() {
	      if (!this.singleQuiz()) {
	        return null;
	      }
	
	      var book = this.props.selectBook(this.singleQuiz().text_id);
	      return book && book.answers ? book.answers : [];
	    }
	  }, {
	    key: "toggleShowAdditionalAnswers",
	    value: function toggleShowAdditionalAnswers() {
	      this.setState({ showAdditionalAnswers: !this.state.showAdditionalAnswers });
	    }
	  }, {
	    key: "onQuizPageChange",
	    value: function onQuizPageChange(page) {
	      this.setState({ currentQuizPage: page });
	    }
	  }, {
	    key: "onAnswerPageChange",
	    value: function onAnswerPageChange(page) {
	      this.setState({ currentAnswerPage: page });
	    }
	  }, {
	    key: "changeLocationState",
	    value: function changeLocationState(quizID, controlMode) {
	      if (!_.isEmpty(this.props.prevLocationState)) {
	        var newLocationState = _extends({}, this.props.prevLocationState);
	      } else if (quizID && quizID != null) {
	        var newLocationState = _extends({}, this.props.locationState);
	        newLocationState.quizID = quizID;
	      } else {
	        var newLocationState = _.omit(_extends({}, this.props.locationState), 'quizID');
	      }
	
	      this.props.updateRoute(newLocationState);
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(date) {
	      return $wr.formatDate(date, "MM/DD/YY");
	    }
	
	    // link to view quiz answers
	
	  }, {
	    key: "buildViewLink",
	    value: function buildViewLink(quizID) {
	      var _this2 = this;
	
	      return React.createElement(
	        "span",
	        { className: "itemLink" },
	        React.createElement(
	          "a",
	          { className: "hideOnPrint", onClick: function onClick() {
	              return _this2.changeLocationState(quizID);
	            } },
	          React.createElement(Glyphicon, { icon: "new-window" })
	        )
	      );
	    }
	
	    // hides score for free user until they manually enter it
	
	  }, {
	    key: "hideAutograderScore",
	    value: function hideAutograderScore(evaluation) {
	      return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score;
	    }
	
	    // link that sends user to quiz view with edit tab open
	
	  }, {
	    key: "renderGradeQuizLink",
	    value: function renderGradeQuizLink(quiz) {
	      var _this3 = this;
	
	      return React.createElement(
	        "a",
	        { onClick: function onClick() {
	            return _this3.changeLocationState(quiz.id, EDIT_CONTROLS);
	          }, className: "gradeQuizLink" },
	        "Grade Quiz"
	      );
	    }
	  }, {
	    key: "generateQuizRows",
	    value: function generateQuizRows(quizzes) {
	      var _this4 = this;
	
	      return _.map(quizzes, function (quiz) {
	        var completed_at = quiz.completed_at,
	            user_id = quiz.user_id,
	            text_id = quiz.text_id,
	            evaluation = quiz.evaluation;
	
	        // evaluation for quiz
	
	        var evaluation = _this4.props.selectEvaluation(evaluation);
	        // student information
	        var student = _this4.props.selectStudent(user_id);
	        // book information
	        var book = _this4.props.selectBook(text_id);
	
	        var title = book ? book.title : '';
	
	        var rubricValue = _.pick(_.pick(evaluation, "restated", "text_evidence", "fully_answered"), _.identity);
	
	        var readBookValue = '';
	        var readBookConfidence = '';
	        if (evaluation && _this4.hideAutograderScore(evaluation)) {
	          var evalValue = _this4.renderGradeQuizLink(quiz);
	        } else if (evaluation) {
	          var evalValue = React.createElement(ScoreDisplay, { evaluationID: evaluation.id, changeLocationState: _this4.changeLocationState, mode: ScoreDisplay.SCORE_ONLY_MODE });
	          var readBookValue = evaluation.read_book;
	          var readBookConfidence = evaluation.read_book_confidence;
	        } else {
	          var tooltipText = "Pending. This quiz will be graded within 24 hours.";
	          var evalValue = React.createElement(
	            "span",
	            { "data-tip": tooltipText, "data-for": "hourglassDataTip" },
	            React.createElement(Glyphicon, { icon: "hourglass" }),
	            React.createElement(ReactTooltip, { id: "hourglassDataTip" })
	          );
	        }
	
	        return [{
	          // date column
	          value: _this4.formatDate(completed_at),
	          classes: ['no-wrap', 'dateColumn']
	        }, {
	          // student name column
	          value: student.display_name,
	          classes: ['studentNameColumn']
	        }, {
	          // book title column
	          value: title,
	          classes: ['pre-wrap', 'italic', 'bookTitle']
	        }, {
	          // displays quiz evaluation score
	          value: evalValue,
	          classes: ['bold', 'quizScoreColumn']
	        }, {
	          // displays determination on wether the student
	          // read the book or not
	          value: readBookValue,
	          classes: ['no-wrap', 'readBookColumn'],
	          read_book_column: true,
	          confidence: 95
	
	        }, {
	          // displays rubric performance
	          value: rubricValue,
	          classes: ['no-wrap', 'rubricColumn'],
	          rubric_column: true,
	          confidence: readBookConfidence
	
	        }, {
	          // view quiz answers
	          value: _this4.buildViewLink(quiz.id),
	          classes: ['no-wrap', 'viewColumn']
	        }];
	      });
	    }
	  }, {
	    key: "loadPagination",
	    value: function loadPagination() {
	      if (this.state.totalCount && !this.props.quizID) {
	        return React.createElement(PaginationControls, { page: this.state.currentQuizPage,
	          perPage: DataRouting.PER_PAGE,
	          totalCount: this.state.totalCount,
	          onPageChange: this.onQuizPageChange });
	      }
	    }
	
	    // chunks and returns answer displays and total count
	
	  }, {
	    key: "renderAnswerDisplays",
	    value: function renderAnswerDisplays() {
	      var _this5 = this;
	
	      var enabled = _extends({}, this.props.enabled);
	      var view = AnswerDisplay.ANSWERS_VIEW;
	      var answers = _.map(this.additionalAnswerIDs(), function (aid, i) {
	        if (i != _.size(_this5.additionalAnswerIDs()) - 1) {
	          var divider = React.createElement("hr", null);
	        }
	
	        return React.createElement(
	          "span",
	          null,
	          React.createElement(AnswerDisplay, { answerID: aid, key: aid,
	            enabled: enabled, view: view }),
	          divider
	        );
	      });
	
	      return { 'totalCount': _.size(answers), 'answers': _.chunk(answers, DataRouting.PER_PAGE)[this.state.currentAnswerPage - 1] };
	    }
	  }, {
	    key: "renderPracticeQuestions",
	    value: function renderPracticeQuestions() {
	      if (!_.isEmpty(this.additionalAnswerIDs())) {
	        var _renderAnswerDisplays = this.renderAnswerDisplays(),
	            totalCount = _renderAnswerDisplays.totalCount,
	            answers = _renderAnswerDisplays.answers;
	
	        var expandedClass = 'collapsed';
	        var header = _.size(this.additionalAnswerIDs()) + " Practice " + $wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions') + " For This Text";
	        var icon = 'menu-down';
	
	        if (this.state.showAdditionalAnswers) {
	          expandedClass = 'expanded';
	          header = "Hide Practice " + $wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions');
	          icon = 'menu-up';
	        }
	
	        return React.createElement(
	          "div",
	          { className: "additonalAnswersContainer " + expandedClass },
	          React.createElement(
	            "div",
	            { className: "headerSection", onClick: this.toggleShowAdditionalAnswers },
	            header,
	            React.createElement(
	              "div",
	              { className: "menuOption" },
	              React.createElement(Glyphicon, { icon: icon })
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "answersContainer" },
	            React.createElement(PaginationControls, { page: this.state.currentAnswerPage,
	              perPage: DataRouting.PER_PAGE,
	              totalCount: totalCount,
	              onPageChange: this.onAnswerPageChange }),
	            answers
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderSingleQuizDisplay",
	    value: function renderSingleQuizDisplay() {
	      return React.createElement(
	        "div",
	        { className: "singleQuizView" },
	        React.createElement(QuizDisplay, { quizID: this.props.quizID, controlMode: "Analysis", view: "quizzes", enabled: _extends({}, this.props.enabled) }),
	        this.renderPracticeQuestions()
	      );
	    }
	  }, {
	    key: "renderQuizDisplay",
	    value: function renderQuizDisplay() {
	      if (this.props.loading) {
	        return React.createElement(Spinner, null);
	      }
	
	      var quizzes = this.props.showFullData ? this.state.quizChunks[this.state.currentQuizPage - 1] : _.first(this.props.quizzes, 1);
	      if (quizzes) {
	        if (this.props.fakePerPage) {
	          quizzes = _.first(quizzes, this.props.fakePerPage);
	        }
	        // if quizID param, show single quiz with all answers
	        // else, show table of quizzes
	        if (this.props.quizID) {
	          return this.renderSingleQuizDisplay();
	        } else {
	          return React.createElement(DataTable, {
	            subjectType: QUIZZES,
	            columnHeaders: QUIZ_TABLE_HEADERS,
	            rows: this.generateQuizRows(quizzes),
	            printable: false
	          });
	        }
	      } else {
	        if (this.props.sketchEmptyState) {
	          return React.createElement(NoActivityBlock, { userIDs: this.props.userIDs, contentType: "Quizzes" });
	        } else {
	          return React.createElement(EmptyState, { type: QUIZZES });
	        }
	      }
	    }
	  }, {
	    key: "renderPrintableQuizDisplay",
	    value: function renderPrintableQuizDisplay() {
	      var _props = this.props,
	          quizzes = _props.quizzes,
	          loading = _props.loading;
	
	      if (!this.props.quizID && quizzes && !loading) {
	        var quizzes = _.flatten(this.state.quizChunks);
	        return React.createElement(DataTable, {
	          subjectType: QUIZZES,
	          columnHeaders: QUIZ_TABLE_HEADERS,
	          rows: this.generateQuizRows(quizzes),
	          printable: true
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "dataQuizTables" },
	        this.loadPagination(),
	        this.renderQuizDisplay(),
	        this.renderPrintableQuizDisplay(),
	        this.loadPagination()
	      );
	    }
	  }, {
	    key: "loadBooks",
	    value: function loadBooks(prevProps) {
	      // load new text ids
	      var booksLoaded = prevProps == null ? [] : _.pluck(prevProps.quizzes, 'text_id');
	      var allBooks = _.pluck(this.props.quizzes, 'text_id');
	      var newBooks = allBooks.filter(function (obj) {
	        return booksLoaded.indexOf(obj) == -1;
	      });
	      if (!_.isEmpty(newBooks)) {
	        this.props.fetchBooks(newBooks);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadBooks(null);
	      if (this.singleQuiz()) {
	        this.props.fetchSingleBookActivity(this.singleQuiz().text_id, this.singleQuiz().user_id);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.loadBooks(prevProps);
	    }
	  }]);
	
	  return DataQuizTables;
	}(React.Component)) || _class) || _class);
	
	
	var QUIZZES = "quizzes";
	var QUIZ_TABLE_HEADERS = ['Date', 'Student', 'Title', 'Score', 'Read Book', 'Rubric', ''];
	var EDIT_CONTROLS = "Edit";
	
	var RUBRIC = {
	  "02_READ-COMP_fully-answered": { text: "2. Is the question fully answered?", "options": ["yes", "no"], "answer": "yes" },
	  "10_READ-COMP_restating": { text: "10. Restating is present", "options": ["yes", "yes not literal", "no"], "answer": "yes" },
	  "14_TEXT-SPE_text-details-count": { text: "14. Text details", "options": ["sufficient", "insufficient"], "answer": "insufficient" }
	};
	
	DataQuizTables.defaultProps = {
	  enabled: {}
	};
	
	DataQuizTables.WrappedComponent.propTypes = PageStrictPropTypes((_PageStrictPropTypes = {
	  // Data from above
	  userIDs: PropTypes.array,
	  startDate: PropTypes.string,
	  page: PropTypes.number,
	  perPage: PropTypes.number,
	  fakePerPage: PropTypes.number,
	  order: PropTypes.string
	}, _defineProperty(_PageStrictPropTypes, "startDate", PropTypes.string), _defineProperty(_PageStrictPropTypes, "endDate", PropTypes.string), _defineProperty(_PageStrictPropTypes, "status", PropTypes.string), _defineProperty(_PageStrictPropTypes, "textVariety", PropTypes.string), _defineProperty(_PageStrictPropTypes, "textID", PropTypes.string), _defineProperty(_PageStrictPropTypes, "showFullData", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "sketchEmptyState", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "studentList", PropTypes.string), _defineProperty(_PageStrictPropTypes, "quizID", PropTypes.number), _defineProperty(_PageStrictPropTypes, "locationState", PropTypes.object), _defineProperty(_PageStrictPropTypes, "prevLocationState", PropTypes.object), _defineProperty(_PageStrictPropTypes, "updateRoute", PropTypes.func), _defineProperty(_PageStrictPropTypes, "onPageChange", PropTypes.func), _defineProperty(_PageStrictPropTypes, "fetchSingleBookActivity", PropTypes.func), _defineProperty(_PageStrictPropTypes, "enabled", PropTypes.object), _defineProperty(_PageStrictPropTypes, "loading", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "quizzes", PropTypes.array), _defineProperty(_PageStrictPropTypes, "books", PropTypes.array), _defineProperty(_PageStrictPropTypes, "populateData", PropTypes.func), _defineProperty(_PageStrictPropTypes, "fetchBooks", PropTypes.func), _defineProperty(_PageStrictPropTypes, "selectEvaluation", PropTypes.func), _defineProperty(_PageStrictPropTypes, "selectStudent", PropTypes.func), _defineProperty(_PageStrictPropTypes, "selectBook", PropTypes.func), _PageStrictPropTypes));
	
	module.exports = DataQuizTables;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _PageStrictPropTypes;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var QuizDisplay = __webpack_require__(174);
	var PaginationControls = __webpack_require__(90);
	var Spinner = __webpack_require__(9);
	var NoActivityBlock = __webpack_require__(71);
	var TruncatedDataNote = __webpack_require__(159);
	var EmptyState = __webpack_require__(117);
	
	__webpack_require__(3633);
	
	function propsToConditions(props) {
		var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs", "order");
	
		conditions.perPage = props.perPage || DataRouting.PER_PAGE;
		conditions.withTotal = true;
	
		return conditions;
	}
	
	function sortItems(quizzes) {
		return _.sortBy(quizzes, function (x) {
			return new Date(x.completed_at).valueOf();
		}).reverse();
	}
	// large requests will store all quizzes in props and paginate on FE
	// small requests will use BE pagination
	function pickQuizSelector(state, props) {
		if ($wr.isLargeRequest(props.userIDs)) {
			return sortItems(WritingSelectors.quizzes({ state: state, conditions: propsToConditions(props) }));
		} else {
			return sortItems(WritingSelectors.quizzesPaginated({ state: state, page: props.page || 1, conditions: propsToConditions(props) }));
		}
	}
	// large requests count all quizzes held in props
	// small requests get total from BE
	function totalCount(state, props) {
		if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
			return $wr.frontEndPaginationTotal(state.quizzes);
		} else {
			return WritingSelectors.quizTotal({ state: state, conditions: propsToConditions(props) });
		}
	}
	
	var DataQuizzes = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			loading: WritingSelectors.isLoadingQuizzes({ state: state, key: 'index', userIDs: props.userIDs }),
			quizzes: pickQuizSelector(state, props),
			totalCount: totalCount(state, props)
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
					var actionFunction = WritingActions.fetchQuizzes;
					var options = {
						embeds: ["quiz.answers", "quiz.evaluation", "answer.question", "answer.meta_data", "answer.evaluation", "question.answer_options", "question.answer_options", "question.answer_options", "evaluation.autograder_data", "evaluation.score_details"], cache: true
					};
					return new Promise(function (resolve, reject) {
						resolve($wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null));
					}).catch(function () {
						return console.log("Quizzes failed to load");
					});
				} else {
					return dispatch(WritingActions.fetchQuizzes({
						conditions: propsToConditions(props),
						embeds: ["quiz.answers", "quiz.evaluation", "answer.question", "answer.meta_data", "answer.evaluation", "question.answer_options", "question.answer_options", "question.answer_options", "evaluation.autograder_data", "evaluation.score_details"],
						page: props.page || 1,
						cache: true
					}));
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataQuizzes, _React$Component);
	
		function DataQuizzes(props) {
			_classCallCheck(this, DataQuizzes);
	
			var _this = _possibleConstructorReturn(this, (DataQuizzes.__proto__ || Object.getPrototypeOf(DataQuizzes)).call(this));
	
			autobind(_this);
	
			_this.state = { currentQuizPage: 1 };
	
			LuckyOrangeClient.tagComponent("DataQuizzes");
			return _this;
		}
		// FE pagination controlls for large requests
	
	
		_createClass(DataQuizzes, [{
			key: "onFrontendPaginationChange",
			value: function onFrontendPaginationChange(page) {
				this.setState({ currentQuizPage: page });
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.loading) {
					var loadingDisplay = React.createElement(Spinner, null);
				} else {
					if (this.props.showFullData) {
						var quizzes = this.props.quizzes;
					} else {
						var quizzes = _.first(this.props.quizzes, 1);
					}
	
					if (this.props.fakePerPage) {
						quizzes = _.first(quizzes, this.props.fakePerPage);
					}
	
					if (quizzes && quizzes.length > 0) {
						var quizDisplays = _.map(quizzes, function (quiz) {
							if (quiz) {
								var enabled = _extends({}, _this2.props.enabled);
								return React.createElement(
									"div",
									{ key: quiz.id },
									React.createElement(QuizDisplay, { quizID: quiz.id, view: "quizzes", enabled: enabled })
								);
							}
						});
						if (!this.props.showFullData) {
							var truncatedRow = React.createElement(TruncatedDataNote, { total: this.props.quizzes.length, type: QUIZZES });
						}
					} else {
						if (this.props.sketchEmptyState) {
							var noQuizzes = React.createElement(NoActivityBlock, { userIDs: this.props.userIDs, contentType: "Quizzes" });
						} else {
							var emptyState = React.createElement(EmptyState, { type: QUIZZES });
						}
					}
	
					if (this.props.onPageChange && this.props.totalCount) {
						if (this.props.showFullData & !this.props.fakePerPage) {
							if ($wr.isLargeRequest(this.props.userIDs)) {
								// chunck all quizzes for pagination
								quizDisplays = _.chunk(quizDisplays, DataRouting.PER_PAGE)[this.state.currentQuizPage - 1];
								//	pagination control
								var pagination = React.createElement(PaginationControls, { page: this.state.currentQuizPage,
									perPage: DataRouting.PER_PAGE,
									totalCount: this.props.totalCount,
									onPageChange: this.onFrontendPaginationChange });
							} else {
								var pagination = React.createElement(PaginationControls, { page: this.props.page || 1,
									perPage: this.props.perPage || DataRouting.PER_PAGE,
									perPageOptions: PaginationControls.DEFAULT_PAGE_OPTIONS,
									totalCount: this.props.totalCount,
									onPageChange: this.props.onPageChange });
							}
						}
					}
				}
	
				return React.createElement(
					"div",
					{ className: "dataQuizzes" },
					loadingDisplay,
					pagination,
					emptyState,
					noQuizzes,
					quizDisplays,
					truncatedRow,
					pagination
				);
			}
		}]);
	
		return DataQuizzes;
	}(React.Component)) || _class) || _class);
	
	
	var QUIZZES = "quizzes";
	
	DataQuizzes.defaultProps = {
		enabled: {}
	};
	
	DataQuizzes.WrappedComponent.propTypes = PageStrictPropTypes((_PageStrictPropTypes = {
		// Data from above
		userIDs: PropTypes.array,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		page: PropTypes.number,
		perPage: PropTypes.number,
		fakePerPage: PropTypes.number,
		order: PropTypes.string
	}, _defineProperty(_PageStrictPropTypes, "startDate", PropTypes.string), _defineProperty(_PageStrictPropTypes, "endDate", PropTypes.string), _defineProperty(_PageStrictPropTypes, "textVariety", PropTypes.string), _defineProperty(_PageStrictPropTypes, "textID", PropTypes.string), _defineProperty(_PageStrictPropTypes, "showFullData", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "onPageChange", PropTypes.func), _defineProperty(_PageStrictPropTypes, "sketchEmptyState", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "studentList", PropTypes.string), _defineProperty(_PageStrictPropTypes, "enabled", PropTypes.object), _defineProperty(_PageStrictPropTypes, "loading", PropTypes.bool), _defineProperty(_PageStrictPropTypes, "quizzes", PropTypes.array), _defineProperty(_PageStrictPropTypes, "totalCount", PropTypes.number), _defineProperty(_PageStrictPropTypes, "populateData", PropTypes.func), _PageStrictPropTypes));
	
	module.exports = DataQuizzes;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	
	var ReadingLevelTable = __webpack_require__(850);
	
	var Spinner = __webpack_require__(9);
	var PaginationControls = __webpack_require__(90);
	
	var RosterActions = __webpack_require__(11);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	function propsToConditions(props) {
		var conditions = { userIDs: paginateUserIds(props) };
		conditions.perPage = props.perPage || DataRouting.PER_PAGE;
		return conditions;
	}
	
	function paginateUserIds(props) {
		var page = props.page || 1;
		var perPage = props.perPage || DataRouting.PER_PAGE;
		return props.userIDs.slice(perPage * (page - 1), page * perPage);
	}
	
	var DataReadingLevels = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		var downProps = {};
	
		downProps.userIDs = paginateUserIds(props);
		downProps.loading = ReadingSelectors.isLoadingReadingLevels({ state: state });
		downProps.readingLevels = ReadingSelectors.readingLevels({
			state: state,
			conditions: propsToConditions(props)
		});
		downProps.assessmentDates = ReadingSelectors.assessmentDates({
			state: state,
			conditions: propsToConditions(props),
			sinceSchoolYear: true, untilPresent: true
		});
		downProps.totalStudentCount = props.userIDs.length;
	
		return downProps;
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				// TODO: standardize FE requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var actionFunction = ReadingActions.fetchReadingLevels;
					var options = { cache: true };
					return new Promise(function (resolve, reject) {
						// reading level
						$wr.handleLargeRequest(dispatch, props.userIDs, {}, actionFunction, options, function (results) {
							var readingLevelPromise = results;
							actionFunction = RosterActions.fetchStudents;
							options.embeds = ["student.cloze_status", "student.current_reading_level_origin"];
							options.page = props.page || 1;
							// students
							$wr.handleLargeRequest(dispatch, props.userIDs, {}, actionFunction, options, function (second_results) {
								var studentsPromise = second_results;
								resolve(_.compact(_.flatten(readingLevelPromise.concat(studentsPromise))));
							});
						});
					}).catch(function () {
						return console.log("Reading levels and students failed to load");
					});
				} else {
					var readingLevelPromise = dispatch(ReadingActions.fetchReadingLevels({
						conditions: propsToConditions(props),
						cache: true
					}));
	
					var studentsPromise = dispatch(RosterActions.fetchStudents({
						conditions: propsToConditions(props),
						embeds: ["student.cloze_status", "student.current_reading_level_origin"],
						page: props.page || 1,
						cache: true
					}));
	
					return Promise.all([readingLevelPromise, studentsPromise]);
				}
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(DataReadingLevels, _React$Component);
	
		function DataReadingLevels(props) {
			_classCallCheck(this, DataReadingLevels);
	
			var _this = _possibleConstructorReturn(this, (DataReadingLevels.__proto__ || Object.getPrototypeOf(DataReadingLevels)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("DataReadingLevels");
			return _this;
		}
	
		_createClass(DataReadingLevels, [{
			key: "render",
			value: function render() {
				var display = "Display here";
				if (this.props.loading) {
					var display = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
					var display = React.createElement(ReadingLevelTable, { userIDs: this.props.userIDs,
						dates: this.props.assessmentDates,
						readingLevels: this.props.readingLevels });
				}
				if (this.props.onPageChange && this.props.totalStudentCount) {
					if (this.props.showFullData) {
						var pagination = React.createElement(PaginationControls, { page: this.props.page || 1,
							perPage: this.props.perPage || DataRouting.PER_PAGE,
							perPageOptions: PaginationControls.DEFAULT_PAGE_OPTIONS,
							totalCount: this.props.totalStudentCount,
							onPageChange: this.props.onPageChange });
					}
				}
				return React.createElement(
					"div",
					{ className: "dataReadingLevels" },
					pagination,
					display
				);
			}
		}]);
	
		return DataReadingLevels;
	}(React.Component)) || _class) || _class);
	
	DataReadingLevels.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from above
		userIDs: PropTypes.array,
		showFullData: PropTypes.bool,
		onPageChange: PropTypes.func,
		page: PropTypes.number,
		perPage: PropTypes.number,
		order: PropTypes.string,
		totalStudentCount: PropTypes.number,
	
		// Data from @connect
		loading: PropTypes.bool,
		readingLevels: PropTypes.array,
		assessmentDates: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	module.exports = DataReadingLevels;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Glyphicon = __webpack_require__(8);
	var WidgetConfig = __webpack_require__(66);
	
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(3628);
	
	var BookAnswersAnalysisTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    answers: WritingSelectors.answers({ state: state, conditions: { textID: props.textID, userID: props.userID }, filters: { draft: false } })
	  };
	}, function () {
	  return {};
	}), _dec(_class = function (_React$Component) {
	  _inherits(BookAnswersAnalysisTable, _React$Component);
	
	  function BookAnswersAnalysisTable(props) {
	    _classCallCheck(this, BookAnswersAnalysisTable);
	
	    var _this = _possibleConstructorReturn(this, (BookAnswersAnalysisTable.__proto__ || Object.getPrototypeOf(BookAnswersAnalysisTable)).call(this));
	
	    autobind(_this);
	
	    _this.state = {
	      expandedRows: []
	    };
	    return _this;
	  }
	
	  _createClass(BookAnswersAnalysisTable, [{
	    key: "expandWriting",
	    value: function expandWriting(rowIndex) {
	      if (_.includes(this.state.expandedRows, rowIndex)) {
	        this.setState({ expandedRows: [].concat(_toConsumableArray(_.omit(this.state.expandedRows, rowIndex))) });
	      } else {
	        this.setState({ expandedRows: [].concat(_toConsumableArray(this.state.expandedRows), [rowIndex]) });
	      }
	    }
	  }, {
	    key: "generateSummary",
	    value: function generateSummary() {
	      return React.createElement(
	        "div",
	        { className: "summary" },
	        React.createElement(
	          "span",
	          { className: "summaryTitle" },
	          "Answers Summary:"
	        ),
	        React.createElement(
	          "div",
	          { className: "yesSummary" },
	          React.createElement(
	            "span",
	            { className: "yesBlock backgroundColor-green fontColor-green" },
	            "Yes"
	          ),
	          " - 5"
	        ),
	        React.createElement(
	          "div",
	          { className: "maybeSummary" },
	          React.createElement(
	            "span",
	            { className: "maybeBlock backgroundColor-yellow fontColor-yellow" },
	            "Maybe"
	          ),
	          " - 1"
	        ),
	        React.createElement(
	          "div",
	          { className: "noSummary" },
	          React.createElement(
	            "span",
	            { className: "noBlock backgroundColor-red fontColor-red" },
	            "No"
	          ),
	          " - 1"
	        )
	      );
	    }
	  }, {
	    key: "generateAnswer",
	    value: function generateAnswer(rowIndex) {
	      if (_.includes(this.state.expandedRows, rowIndex)) {
	        return ANSWERS[rowIndex];
	      }
	    }
	  }, {
	    key: "generateRows",
	    value: function generateRows() {}
	  }, {
	    key: "generateHeaders",
	    value: function generateHeaders() {
	      return _.map(COLUMN_HEADERS, function (header, index) {
	        return React.createElement(
	          "th",
	          { key: index, className: "columnHeader" },
	          header
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return React.createElement(
	        "div",
	        { className: "bookAnswersAnalysisTable" },
	        this.generateSummary(),
	        React.createElement(
	          "table",
	          { className: "table" },
	          React.createElement(
	            "thead",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              this.generateHeaders()
	            )
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell readBookCellContainer" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-green" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-green" },
	                    "Yes"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell typeCell" },
	                "FITB"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell questionCell" },
	                "Castle steals _____ from a store."
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell reasonCell" },
	                "Correct"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell viewCell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(0);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(0)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-red" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-red" },
	                    "No"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "FITB"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "Ghost's _____ tries to shoot him."
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Inorrect"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(1);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(1)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-green" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-green" },
	                    "Yes"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "FITB"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "Castle joins the _____ team."
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Correct"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(2);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(2)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-green" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-green" },
	                    "Yes"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "FITB"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "Castle steals sunflower seeds from a _____."
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Correct"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(3);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(3)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-yellow" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-yellow" },
	                    "Maybe"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Quiz Free Response"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "Does the relationship between two characters make each character better or worse? Use details about the relationship to explain."
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Some text details"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(4);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(4)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-green" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-green" },
	                    "Yes"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Quiz Free Response"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "In what ways did you notice the plot helping you understand the theme more clearly?"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Enough text details"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(5);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(5)
	          ),
	          React.createElement(
	            "tbody",
	            null,
	            React.createElement(
	              "tr",
	              null,
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "div",
	                  { className: "readBookCell backgroundColor-green" },
	                  React.createElement(
	                    "div",
	                    { className: "readBookCellValue fontColor-green" },
	                    "Yes"
	                  )
	                )
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Practice Question"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                "What made the main character unique?"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell centerCell" },
	                "Enough text details"
	              ),
	              React.createElement(
	                "td",
	                { colSpan: 1, className: "cell" },
	                React.createElement(
	                  "a",
	                  { onClick: function onClick() {
	                      return _this2.expandWriting(6);
	                    } },
	                  React.createElement(Glyphicon, { icon: "new-window" })
	                )
	              )
	            ),
	            this.generateAnswer(6)
	          )
	        )
	      );
	    }
	  }]);
	
	  return BookAnswersAnalysisTable;
	}(React.Component)) || _class);
	;
	
	var COLUMN_HEADERS = ['Read Book', 'Type', 'Question', 'Reason', ''];
	
	var ANSWERS = [React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer fitb" },
	      "Castle steals ",
	      React.createElement(
	        "span",
	        { className: "answerGiven backgroundColor-green fontColor-green" },
	        "sunflower seeds"
	      ),
	      " from a store."
	    ),
	    React.createElement(
	      "div",
	      { className: "answerKeyContainer" },
	      React.createElement(
	        "span",
	        { className: "answerKey" },
	        "Answer key:"
	      ),
	      " sunflower seeds, sunflower"
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer fitb" },
	      "Ghost's ",
	      React.createElement(
	        "span",
	        { className: "answerGiven backgroundColor-red fontColor-red" },
	        "dad"
	      ),
	      " tries to shoot him."
	    ),
	    React.createElement(
	      "div",
	      { className: "answerKeyContainer" },
	      React.createElement(
	        "span",
	        { className: "answerKey" },
	        "Answer key:"
	      ),
	      " mom, mother"
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer fitb" },
	      "Castle joins the ",
	      React.createElement(
	        "span",
	        { className: "answerGiven backgroundColor-green fontColor-green" },
	        "track"
	      ),
	      " team."
	    ),
	    React.createElement(
	      "div",
	      { className: "answerKeyContainer" },
	      React.createElement(
	        "span",
	        { className: "answerKey" },
	        "Answer key:"
	      ),
	      " track"
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer fitb" },
	      "Castle steals sunflower seeds from a ",
	      React.createElement(
	        "span",
	        { className: "answerGiven backgroundColor-green fontColor-green" },
	        "store"
	      ),
	      "."
	    ),
	    React.createElement(
	      "div",
	      { className: "answerKeyContainer" },
	      React.createElement(
	        "span",
	        { className: "answerKey" },
	        "Answer key:"
	      ),
	      " store, convenience store, grocery store"
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer freeResponse" },
	      "Two characters in the text who had a relationship were ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "castle and Mr. Charles"
	      ),
	      " The relationship between these two characters made the ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "characters feel safe Mr. Charles was like a father figure"
	      ),
	      ". Details that support this are when ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "castles dad went on a rampage and got drunk Mr. Charles was there to help them and make him feel safe"
	      ),
	      "."
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer freeResponse" },
	      "The plot helped me understand the theme more clearly by by showing me that even though life has struggles you always keep going, ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "castle has had a hard life"
	      ),
	      " and they help me understand by him still ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "pushing through all of his problems and doing what he started to love"
	      ),
	      "."
	    )
	  )
	), React.createElement(
	  "tr",
	  { className: "writingView" },
	  React.createElement(
	    "td",
	    { className: "noBorderTop", colSpan: _.size(COLUMN_HEADERS) },
	    React.createElement(
	      "div",
	      { className: "writingContainer freeResponse" },
	      "The main character ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "castle"
	      ),
	      " was very unique because he was ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "born with a gift to run"
	      ),
	      ", even thought ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "he has never trained or played sports in his life he was born with incredible speed"
	      ),
	      ", and he also ",
	      React.createElement(
	        "span",
	        { className: "textDetails backgroundColor-green fontColor-green" },
	        "wasn't the regular kid with good clothes and an amazing life , he didn't have as much money as everyone but he always managed to have a good spirit"
	      ),
	      "."
	    )
	  )
	)];
	
	BookAnswersAnalysisTable.propTypes = StrictPropTypes({
	  textID: PropTypes.string,
	  userID: PropTypes.number
	});
	
	module.exports = BookAnswersAnalysisTable;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _SUMMARY_METRICS;
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(15);
	
	var WidgetConfig = __webpack_require__(66);
	var WidgetItemsConfig = __webpack_require__(260);
	var DataSelectors = __webpack_require__(54);
	var DataActions = __webpack_require__(65);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3635);
	
	function selectWidgetDigest(state, props) {
	  var conditions = { period: 'yearly', entity_type: WidgetConfig.getEntityTypeByUserRole(props.admin.role) };
	  if (props.studentListID) {
	    conditions.entity_type = WidgetConfig.STUDENT_LIST_ENTITY_TYPE;
	    conditions.entity_id = props.studentListID;
	  }
	
	  return _.first(DataSelectors.widgetDigests({ state: state, conditions: conditions }));
	}
	
	var DataTableSummary = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    widgetDigest: selectWidgetDigest(state, props),
	    studentList: RosterSelectors.studentList({ state: state, id: props.studentListID })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var fetchPromises = [];
	      fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { adminID: props.admin.id } })));
	
	      if (props.studentListID) {
	        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, adminID: props.admin.id } })));
	      }
	
	      return Promise.all(fetchPromises);
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(DataTableSummary, _React$Component);
	
	  function DataTableSummary(props) {
	    _classCallCheck(this, DataTableSummary);
	
	    var _this = _possibleConstructorReturn(this, (DataTableSummary.__proto__ || Object.getPrototypeOf(DataTableSummary)).call(this));
	
	    autobind(_this);
	    return _this;
	  }
	
	  _createClass(DataTableSummary, [{
	    key: "buildCard",
	    value: function buildCard(metric) {
	      var digest = this.props.widgetDigest;
	      if (!digest) {
	        return null;
	      }
	
	      var lookup_key = metric.lookup_key;
	
	      var config = WidgetItemsConfig.CONFIG['Admin'];
	      var widgetItemConfig = _.findWhere(config, { lookup_key: lookup_key });
	
	      if (widgetItemConfig) {
	        var icon = widgetItemConfig.icon,
	            title = widgetItemConfig.title,
	            primary_metric = widgetItemConfig.primary_metric;
	
	        return React.createElement(
	          "div",
	          { key: lookup_key, className: "summaryCard" },
	          React.createElement(
	            "div",
	            { className: "cardContent" },
	            React.createElement(
	              "div",
	              { className: "stat" },
	              Math.round(digest.data[primary_metric]) || 0
	            ),
	            React.createElement(
	              "div",
	              { className: "iconContainer" },
	              React.createElement("img", { className: "iconImage", src: __webpack_require__(683)("./" + icon + "-blue.png") }),
	              React.createElement(
	                "div",
	                { className: "title" },
	                title
	              )
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var _props = this.props,
	          widgetDigest = _props.widgetDigest,
	          studentList = _props.studentList;
	
	      if (!widgetDigest) {
	        return null;
	      }
	
	      if (widgetDigest.entity_type == WidgetConfig.STUDENT_LIST_ENTITY_TYPE && studentList) {
	        var title = React.createElement(
	          "strong",
	          null,
	          "Data Summary for ",
	          studentList.name,
	          " (",
	          moment(widgetDigest.start_date).format("M/YY"),
	          "-",
	          moment(widgetDigest.end_date).format("M/YY"),
	          ")"
	        );
	      } else {
	        var title = React.createElement(
	          "strong",
	          null,
	          "All Student Data Summary (",
	          moment(widgetDigest.start_date).format("M/YY"),
	          "-",
	          moment(widgetDigest.end_date).format("M/YY"),
	          ")"
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { key: 'date-cell', className: "summaryDateCell" },
	        React.createElement(
	          "div",
	          { className: "content" },
	          title
	        )
	      );
	    }
	  }, {
	    key: "renderCards",
	    value: function renderCards() {
	      var _this2 = this;
	
	      var metrics = SUMMARY_METRICS[this.props.subjectType];
	      var cards = _.map(metrics, function (metric) {
	        return _this2.buildCard(metric);
	      });
	
	      return React.createElement(
	        "span",
	        null,
	        this.renderHeader(),
	        React.createElement(
	          "div",
	          { className: "summaryCardsContainer" },
	          cards
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "dataTableSummary hideOnPrint" },
	        this.renderCards()
	      );
	    }
	  }]);
	
	  return DataTableSummary;
	}(React.Component)) || _class) || _class);
	;
	
	var QUIZ = 'quiz';
	var BOOK = 'book';
	
	var SUMMARY_METRICS = (_SUMMARY_METRICS = {}, _defineProperty(_SUMMARY_METRICS, QUIZ, [{ lookup_key: WidgetItemsConfig.AVERAGE_LEXILE_LEVEL }, { lookup_key: WidgetItemsConfig.YEARLY_TOTAL_QUIZZES, change: { status: null } }, { lookup_key: WidgetItemsConfig.FAILED_QUIZZES, change: { status: 'failed' } }, { lookup_key: WidgetItemsConfig.FLAGGED_QUIZZES, change: { status: 'flagged' } }]), _defineProperty(_SUMMARY_METRICS, BOOK, [{ lookup_key: WidgetItemsConfig.AVERAGE_LEXILE_LEVEL }, { lookup_key: WidgetItemsConfig.TOTAL_BOOKS }, { lookup_key: WidgetItemsConfig.MINUTES_LOGGED }]), _SUMMARY_METRICS);
	
	DataTableSummary.propTypes = StrictPropTypes({
	  subjectType: PropTypes.string,
	  onClick: PropTypes.func,
	  admin: PropTypes.object,
	  studentListID: PropTypes.number
	});
	
	module.exports = DataTableSummary;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetConfig = __webpack_require__(66);
	
	var BookWidget = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {};
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // load book data
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(BookWidget, _React$Component);
	
	  function BookWidget(props) {
	    _classCallCheck(this, BookWidget);
	
	    var _this = _possibleConstructorReturn(this, (BookWidget.__proto__ || Object.getPrototypeOf(BookWidget)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("BookWidget");
	    return _this;
	  }
	
	  _createClass(BookWidget, [{
	    key: "isStudentDash",
	    value: function isStudentDash() {
	      return this.props.user.role == WidgetConfig.STUDENT_ROLE;
	    }
	
	    // handles expansion of component
	
	  }, {
	    key: "onClick",
	    value: function onClick(item) {
	      console.log(item);
	      // show appropriate component based on widget item
	    }
	  }, {
	    key: "buildWidgetItemLink",
	    value: function buildWidgetItemLink(digest, itemConfig, item) {
	      var link = itemConfig.link;
	      var user = this.props.user;
	      // build link object for widget item
	
	      // REPLACE THIS SECTION WHEN //
	      // WE CAN EXPAND COMPONENTS //
	
	      if (this.isStudentDash()) {
	        return {
	          text: link.text,
	          location: WidgetConfig.buildStudentDataLink(user.id, link.filters, link.subject, digest)
	        };
	      }
	      /////////////////////////////
	      else if (link.expand_component) {
	          return {
	            text: link.text,
	            expand_component: true,
	            location: this.onClick.bind(this, item)
	          };
	        } else {
	          return link;
	        }
	    }
	  }, {
	    key: "renderWidgetItems",
	    value: function renderWidgetItems() {
	      return WidgetConfig.renderWidgetItems(this.props, WidgetConfig.BOOK_WIDGET, this.buildWidgetItemLink, this.props.showEmptyState);
	    }
	  }, {
	    key: "renderWidgetTitle",
	    value: function renderWidgetTitle() {
	      return WidgetConfig.renderWidgetTitle(WidgetConfig.BOOK_WIDGET);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "widgetItemsContainer bookWidget" },
	        this.renderWidgetTitle(),
	        this.renderWidgetItems()
	      );
	    }
	  }]);
	
	  return BookWidget;
	}(React.Component)) || _class) || _class);
	;
	
	BookWidget.WrappedComponent.propTypes = PageStrictPropTypes({
	  // @connect handlers
	  populateData: PropTypes.func,
	  selectStudentList: PropTypes.func,
	  selectWidgetDigests: PropTypes.func,
	
	  user: PropTypes.object,
	  periodWidgetDigests: PropTypes.array,
	  currentWidgetDigests: PropTypes.array,
	  compWidgetDigests: PropTypes.array,
	  yearlyWidgetDigests: PropTypes.array,
	  compSize: PropTypes.number,
	  compScope: PropTypes.string,
	  showEmptyState: PropTypes.bool
	});
	
	module.exports = BookWidget;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataSelectors = __webpack_require__(54);
	var WidgetConfig = __webpack_require__(66);
	
	var WidgetTitle = __webpack_require__(385);
	
	var GoalsWidget = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    userDigests: DataSelectors.digests({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {},
	    selectWidgetDigests: function selectWidgetDigests(conditions) {
	      return dispatch(function (dispatch, getState) {
	        return DataSelectors.widgetDigests({ state: getState(), conditions: conditions });
	      });
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(GoalsWidget, _React$Component);
	
	  function GoalsWidget(props) {
	    _classCallCheck(this, GoalsWidget);
	
	    var _this = _possibleConstructorReturn(this, (GoalsWidget.__proto__ || Object.getPrototypeOf(GoalsWidget)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("GoalsWidget");
	    return _this;
	  }
	  // handles expansion of component
	
	
	  _createClass(GoalsWidget, [{
	    key: "onClick",
	    value: function onClick(item) {
	      console.log(item);
	      // show appropriate component based on widget item
	    }
	  }, {
	    key: "renderWidgetItems",
	    value: function renderWidgetItems() {
	      var _props = this.props,
	          user = _props.user,
	          currentWidgetDigests = _props.currentWidgetDigests,
	          periodWidgetDigests = _props.periodWidgetDigests,
	          yearlyWidgetDigests = _props.yearlyWidgetDigests,
	          userDigests = _props.userDigests;
	
	
	      switch (user.role) {
	        case WidgetConfig.STUDENT_ROLE:
	          var userDigest = _.findWhere(userDigests, { student_id: user.id });
	          return WidgetConfig.renderStudentGoalWidgetItems(user, userDigest, this.props.showEmptyState);
	        case WidgetConfig.TEACHER_ROLE:
	          return WidgetConfig.renderTeacherGoalWidgetItems(user, userDigests, this.props.showEmptyState);
	        default:
	          return WidgetConfig.renderAdminGoalWidgetItems(user, currentWidgetDigests, this.props.showEmptyState);
	      }
	    }
	  }, {
	    key: "renderWidgetTitle",
	    value: function renderWidgetTitle() {
	      return WidgetConfig.renderWidgetTitle(WidgetConfig.GOALS_WIDGET);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var widgetItems = this.renderWidgetItems();
	      if (widgetItems) {
	        return React.createElement(
	          "div",
	          { className: "widgetItemsContainer goalsWidget" },
	          this.renderWidgetTitle(),
	          widgetItems
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return GoalsWidget;
	}(React.Component)) || _class) || _class);
	;
	
	GoalsWidget.WrappedComponent.propTypes = PageStrictPropTypes({
	  // @connect handlers
	  populateData: PropTypes.func,
	  selectWidgetDigests: PropTypes.func,
	  fetchUserDigests: PropTypes.func,
	
	  user: PropTypes.object,
	  periodWidgetDigests: PropTypes.array,
	  currentWidgetDigests: PropTypes.array,
	  compWidgetDigests: PropTypes.array,
	  yearlyWidgetDigests: PropTypes.array,
	  userDigests: PropTypes.array,
	  compSize: PropTypes.number,
	  compScope: PropTypes.string,
	  showEmptyState: PropTypes.bool
	});
	
	module.exports = GoalsWidget;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetConfig = __webpack_require__(66);
	
	var QuizWidget = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {};
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {}
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(QuizWidget, _React$Component);
	
	  function QuizWidget(props) {
	    _classCallCheck(this, QuizWidget);
	
	    var _this = _possibleConstructorReturn(this, (QuizWidget.__proto__ || Object.getPrototypeOf(QuizWidget)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("QuizWidget");
	    return _this;
	  }
	
	  _createClass(QuizWidget, [{
	    key: "isStudentDash",
	    value: function isStudentDash() {
	      return this.props.user.role == WidgetConfig.STUDENT_ROLE;
	    }
	    // handles expansion of component
	
	  }, {
	    key: "onClick",
	    value: function onClick(item) {
	      console.log(item);
	      // show appropriate component based on widget item
	    }
	  }, {
	    key: "buildWidgetItemLink",
	    value: function buildWidgetItemLink(digest, itemConfig, item) {
	      var link = itemConfig.link;
	      var user = this.props.user;
	
	      // build link object for widget item
	      // REPLACE THIS SECTION WHEN //
	      // WE CAN EXPAND COMPONENTS //
	
	      if (this.isStudentDash()) {
	        return {
	          text: link.text,
	          location: WidgetConfig.buildStudentDataLink(user.id, link.filters, link.subject, digest)
	        };
	      }
	      /////////////////////////////
	      else if (link.build_link) {
	          return {
	            text: link.text,
	            location: WidgetConfig.buildLink(link.base, digest)
	          };
	        } else if (link.expand_component) {
	          return {
	            text: link.text,
	            expand_component: true,
	            location: this.onClick.bind(this, item)
	          };
	        } else {
	          return link;
	        }
	    }
	  }, {
	    key: "renderWidgetItems",
	    value: function renderWidgetItems() {
	      return WidgetConfig.renderWidgetItems(this.props, WidgetConfig.QUIZ_WIDGET, this.buildWidgetItemLink, this.props.showEmptyState);
	    }
	  }, {
	    key: "renderWidgetTitle",
	    value: function renderWidgetTitle() {
	      return WidgetConfig.renderWidgetTitle(WidgetConfig.QUIZ_WIDGET);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "widgetItemsContainer quizWidget" },
	        this.renderWidgetTitle(),
	        this.renderWidgetItems()
	      );
	    }
	  }]);
	
	  return QuizWidget;
	}(React.Component)) || _class) || _class);
	;
	
	QuizWidget.WrappedComponent.propTypes = PageStrictPropTypes({
	  // @connect handlers
	  populateData: PropTypes.func,
	
	  user: PropTypes.object,
	  periodWidgetDigests: PropTypes.array,
	  currentWidgetDigests: PropTypes.array,
	  compWidgetDigests: PropTypes.array,
	  yearlyWidgetDigests: PropTypes.array,
	  compSize: PropTypes.number,
	  compScope: PropTypes.string,
	  showEmptyState: PropTypes.bool
	});
	
	module.exports = QuizWidget;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetConfig = __webpack_require__(66);
	
	var WritingWidget = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {};
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // load writing data
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(WritingWidget, _React$Component);
	
	  function WritingWidget(props) {
	    _classCallCheck(this, WritingWidget);
	
	    var _this = _possibleConstructorReturn(this, (WritingWidget.__proto__ || Object.getPrototypeOf(WritingWidget)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("WritingWidget");
	    return _this;
	  }
	
	  _createClass(WritingWidget, [{
	    key: "isStudentDash",
	    value: function isStudentDash() {
	      return this.props.user.role == WidgetConfig.STUDENT_ROLE;
	    }
	
	    // handles expansion of component
	
	  }, {
	    key: "onClick",
	    value: function onClick(item) {
	      console.log(item);
	      // show appropriate component based on widget item
	    }
	  }, {
	    key: "buildWidgetItemLink",
	    value: function buildWidgetItemLink(digest, itemConfig, item) {
	      var link = itemConfig.link;
	      var user = this.props.user;
	
	      // build link object  for widget item
	      // REPLACE THIS SECTION WHEN //
	      // WE CAN EXPAND COMPONENTS //
	
	      if (this.isStudentDash()) {
	        return {
	          text: link.text,
	          location: WidgetConfig.buildStudentDataLink(user.id, link.filters, link.subject, digest)
	        };
	      }
	      /////////////////////////////
	      else if (link.expand_component) {
	          return {
	            text: link.text,
	            expand_component: true,
	            location: this.onClick.bind(this, item)
	          };
	        } else {
	          return link;
	        }
	    }
	  }, {
	    key: "renderWidgetItems",
	    value: function renderWidgetItems() {
	      return WidgetConfig.renderWidgetItems(this.props, WidgetConfig.WRITING_WIDGET, this.buildWidgetItemLink, this.props.showEmptyState);
	    }
	  }, {
	    key: "renderWidgetTitle",
	    value: function renderWidgetTitle() {
	      return WidgetConfig.renderWidgetTitle(WidgetConfig.WRITING_WIDGET);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "widgetItemsContainer writingWidget" },
	        this.renderWidgetTitle(),
	        this.renderWidgetItems()
	      );
	    }
	  }]);
	
	  return WritingWidget;
	}(React.Component)) || _class) || _class);
	;
	
	WritingWidget.WrappedComponent.propTypes = PageStrictPropTypes({
	  // @connect handlers
	  populateData: PropTypes.func,
	  selectStudentList: PropTypes.func,
	  selectWidgetDigests: PropTypes.func,
	
	  user: PropTypes.object,
	  periodWidgetDigests: PropTypes.array,
	  currentWidgetDigests: PropTypes.array,
	  compWidgetDigests: PropTypes.array,
	  yearlyWidgetDigests: PropTypes.array,
	  compSize: PropTypes.number,
	  compScope: PropTypes.string,
	  showEmptyState: PropTypes.bool
	});
	
	module.exports = WritingWidget;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3656);
	
	var WidgetItem = function (_React$Component) {
	  _inherits(WidgetItem, _React$Component);
	
	  function WidgetItem(props) {
	    _classCallCheck(this, WidgetItem);
	
	    var _this = _possibleConstructorReturn(this, (WidgetItem.__proto__ || Object.getPrototypeOf(WidgetItem)).call(this));
	
	    autobind(_this);
	    return _this;
	  }
	
	  _createClass(WidgetItem, [{
	    key: "dividerColumn",
	    value: function dividerColumn() {
	      if (this.props.dividerColumn) {
	        return React.createElement("div", { className: "widgetItem-column divider-column" });
	      }
	    }
	  }, {
	    key: "fontColorClass",
	    value: function fontColorClass() {
	      var _props = this.props,
	          primaryMetric = _props.primaryMetric,
	          font_color = _props.font_color;
	
	
	      if (!primaryMetric || primaryMetric.metric == 0) {
	        return null;
	      }
	
	      if (font_color) {
	        return "fontColor-" + font_color;
	      } else if (primaryMetric.statColor) {
	        return "fontColor-" + primaryMetric.statColor;
	      }
	    }
	  }, {
	    key: "fontSizeClass",
	    value: function fontSizeClass() {
	      var primaryMetric = this.props.primaryMetric;
	
	      return primaryMetric ? "statSize-" + primaryMetric.statSize : '';
	    }
	  }, {
	    key: "renderLink",
	    value: function renderLink() {
	      var link = this.props.link;
	
	      if (link) {
	        return link.expand_component ? React.createElement(
	          "a",
	          { className: "hideOnPrint", onClick: link.location },
	          link.text
	        ) : React.createElement(
	          "a",
	          { className: "hideOnPrint", href: link.location },
	          link.text
	        );
	      }
	    }
	  }, {
	    key: "renderSubContent",
	    value: function renderSubContent() {
	      var _props2 = this.props,
	          sublink = _props2.sublink,
	          secondaryMetric = _props2.secondaryMetric,
	          subtitle = _props2.subtitle;
	
	
	      if (sublink) {
	        return React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "a",
	            { href: sublink.location },
	            sublink.text
	          )
	        );
	      } else if (subtitle) {
	        return React.createElement(
	          "div",
	          { className: "subtitle " + this.fontSizeClass() + " " + this.fontColorClass() },
	          subtitle
	        );
	      } else if (secondaryMetric) {
	        return React.createElement(
	          "div",
	          { className: "subtitle " + this.fontSizeClass() + " " + this.fontColorClass() },
	          secondaryMetric
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          icon = _props3.icon,
	          width = _props3.width,
	          primaryMetric = _props3.primaryMetric,
	          title = _props3.title,
	          lookup_key = _props3.lookup_key;
	
	      // default icon
	
	      icon = icon ? icon : 'books';
	
	      var statText = "";
	      if (primaryMetric) {
	        statText = primaryMetric.statText;
	      }
	
	      return React.createElement(
	        "div",
	        { className: "widgetItem width-" + width },
	        React.createElement(
	          "div",
	          { className: "widgetItem-table" },
	          React.createElement(
	            "div",
	            { className: "widgetItem-column icon " + this.fontSizeClass() },
	            React.createElement("img", { className: "iconImage", src: __webpack_require__(356)("./" + icon + ".png") })
	          ),
	          React.createElement(
	            "div",
	            { className: "widgetItem-column stat " + lookup_key.replace(/ /g, '-') + "-stat " + this.fontSizeClass() + " " + this.fontColorClass() },
	            statText
	          ),
	          React.createElement(
	            "div",
	            { className: "widgetItem-column text-column" },
	            React.createElement(
	              "div",
	              { className: "title " + this.fontColorClass() + " " + this.fontSizeClass() },
	              title
	            ),
	            this.renderSubContent(),
	            this.renderLink()
	          ),
	          this.dividerColumn()
	        )
	      );
	    }
	  }]);
	
	  return WidgetItem;
	}(React.Component);
	
	;
	
	// WidgetItem.WrappedComponent.propTypes = PageStrictPropTypes({
	// });
	
	module.exports = WidgetItem;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var StudentAvatar = __webpack_require__(35);
	
	__webpack_require__(3659);
	
	var AnimationModal = function (_React$Component) {
	    _inherits(AnimationModal, _React$Component);
	
	    function AnimationModal(props) {
	        _classCallCheck(this, AnimationModal);
	
	        var _this = _possibleConstructorReturn(this, (AnimationModal.__proto__ || Object.getPrototypeOf(AnimationModal)).call(this));
	
	        autobind(_this);
	        return _this;
	    }
	
	    _createClass(AnimationModal, [{
	        key: "show",
	        value: function show() {
	            this.refs.modal.show();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var studentAvatar = React.createElement(
	                "div",
	                { className: "studentAvatar" },
	                React.createElement(StudentAvatar, {
	                    student: this.props.student,
	                    maxWidth: 200,
	                    location: "modal",
	                    previewAnimation: this.props.previewAnimation
	                })
	            );
	
	            var title = "Preview Animation";
	            return React.createElement(
	                Modal,
	                { ref: "modal", className: "animationModal", headerText: title },
	                React.createElement(
	                    "div",
	                    { className: "studentAvatar" },
	                    studentAvatar
	                )
	            );
	        }
	    }]);
	
	    return AnimationModal;
	}(React.Component);
	
	module.exports = AnimationModal;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp, _initialiseProps;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	var LoadingButton = __webpack_require__(17);
	var Owlvatar = __webpack_require__(115);
	var StudentAvatar = __webpack_require__(35);
	var OwlShopPatcher = __webpack_require__(238);
	
	var OwlShopRouting = __webpack_require__(92);
	
	__webpack_require__(3660);
	
	function studentPropsToConditions(props) {
		var conditions = {};
		if (props.student) {
			conditions = { userID: props.student.id };
		}
		return conditions;
	}
	
	var DressingRoom = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
			user: ownProps.student || CurrentUser.get()
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(OwlShopActions.fetchPatches({ conditions: studentPropsToConditions(props) }));
			},
			updateAvatar: function updateAvatar(_ref) {
				var id = _ref.id,
				    update = _ref.update,
				    embeds = _ref.embeds,
				    query = _ref.query;
				return dispatch(OwlShopActions.updateAvatar({ id: id, update: update, embeds: embeds, query: query }));
			},
			updateCurrentUser: function updateCurrentUser(callback) {
				return CurrentUser.fetchCurrentUserData(callback);
			},
			fetchPerks: function fetchPerks() {
				return dispatch(OwlShopActions.fetchPerks());
			},
			fetchPatches: function fetchPatches() {
				return dispatch(OwlShopActions.fetchPatches({ conditions: studentPropsToConditions(props) }));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
		_inherits(DressingRoom, _React$Component);
	
		function DressingRoom(props) {
			_classCallCheck(this, DressingRoom);
	
			var _this = _possibleConstructorReturn(this, (DressingRoom.__proto__ || Object.getPrototypeOf(DressingRoom)).call(this));
	
			_initialiseProps.call(_this);
	
			autobind(_this);
	
			var startPatchType = _this.hideOwls(props.user) ? null : "head";
	
			var avatar = props.user.avatar;
	
			_this.state = {
				equippedPatches: avatar.patches,
				colors: avatar.colors,
				previewItemName: null,
				previewItemType: null,
				loading: false,
				allFurnitures: [],
				activePatchType: startPatchType
			};
			return _this;
		}
	
		_createClass(DressingRoom, [{
			key: "renderOwlvatar",
			value: function renderOwlvatar() {
				if (this.hideOwls(this.props.user)) {
					return React.createElement(StudentAvatar, { student: this.props.user, maxWidth: 100 });
				}
				var patches = {};
				var previewPatch = this.getPreviewItem();
	
				_.each(this.state.equippedPatches, function (patch, patchType) {
					if (previewPatch && patchType == this.state.previewItemType && previewPatch.tier <= this.props.user.tier + 1) {
						patches[patchType] = previewPatch;
					} else {
						patches[patchType] = patch;
					}
				}.bind(this));
				return React.createElement(
					"div",
					{ className: "owlvatar" },
					React.createElement(Owlvatar, { patches: patches, colors: this.state.colors, maxWidth: 250 }),
					";"
				);
			}
		}, {
			key: "getPreviewItem",
			value: function getPreviewItem() {
				return _.find(this.props.filteredPatches, function (patch) {
					return patch.name == this.state.previewItemName && patch.patch_type == this.state.activePatchType;
				}.bind(this));
			}
		}, {
			key: "setActiveType",
			value: function setActiveType(pType) {
				this.setState({ activePatchType: pType });
			}
		}, {
			key: "setEquippedPatches",
			value: function setEquippedPatches(patches) {
				this.setState({ equippedPatches: patches });
			}
		}, {
			key: "setPreviewItem",
			value: function setPreviewItem(name, type) {
				this.setState({ previewItemName: name, previewItemType: type });
			}
		}, {
			key: "renderShelf",
			value: function renderShelf() {
				var rowBackgroundPath = __webpack_require__(339);
				return React.createElement(
					"div",
					{ className: "shelf" },
					React.createElement("img", { src: rowBackgroundPath, className: "shelfBackground" }),
					React.createElement("img", { src: rowBackgroundPath, className: "shelfBackground" })
				);
			}
		}, {
			key: "requiresSave",
			value: function requiresSave() {
				if (this.props.user == undefined) {
					return false;
				}
				var oldAvatar = this.props.user.avatar;
				var updated = false;
	
				_.each(this.state.equippedPatches, function (patch, patchType) {
					if (patch.name != oldAvatar.patches[patchType].name) {
						updated = true;
					}
				});
	
				_.each(oldAvatar.patches, function (patch, patchType) {
					if (this.state.equippedPatches[patchType] == undefined || patch.name != this.state.equippedPatches[patchType].name) {
						updated = true;
					}
				}.bind(this));
	
				_.each(this.state.colors, function (color, patchType) {
					if (color != oldAvatar.colors[patchType]) {
						updated = true;
					}
				});
	
				return updated;
			}
		}, {
			key: "saveAvatar",
			value: function saveAvatar() {
				var _this2 = this;
	
				var avatarData = {
					patches: this.state.equippedPatches,
					colors: this.state.colors
				};
				var avatarID = this.props.user.avatar.id;
				this.setState({ loading: true });
	
				this.props.updateAvatar({ id: avatarID, update: _extends({}, avatarData) }).then(function (result) {
					_this2.setState({ loading: false });
					_this2.handleAvatarUpdated(result.avatar);
				});
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
				var shouldHideOwls = this.hideOwls(this.props.user);
				var previewOwl = this.renderOwlvatar();
	
				if (this.requiresSave()) {
					var saveButton = React.createElement(LoadingButton, {
						onClick: this.saveAvatar,
						loading: this.state.loading,
						className: "btn buttonSuccess saveButton",
						text: "Save"
					});
				}
	
				if (student.perks.houses != "") {
					var backgroundPath = __webpack_require__(224)("./" + student.perks.houses.toLowerCase().replace(/ /g, "-").replace("'", "") + "-empty.png");
				}
	
				return React.createElement(
					"div",
					{ className: "dressingRoom" },
					React.createElement("img", { src: backgroundPath, className: "modalBackground" }),
					React.createElement(
						"div",
						{ className: "owlvatarControl" },
						previewOwl,
						saveButton
					),
					React.createElement(
						"div",
						{ className: "dressingPatcher" },
						React.createElement(OwlShopPatcher, {
							mode: "dressing",
							equippedPatches: this.state.equippedPatches,
							colors: this.state.colors,
							previewItemName: this.state.previewItemName,
							activePatchType: this.state.activePatchType,
							activeOtherType: this.state.activeOtherType,
							hideOwls: shouldHideOwls,
							setEquippedPatches: this.setEquippedPatches,
							setColors: this.setColors,
							setPreviewItem: this.setPreviewItem,
							setActiveType: this.setActiveType,
							updateCurrentUser: this.props.updateCurrentUser,
							fetchPerks: this.props.fetchPerks,
							fetchPatches: this.props.fetchPatches,
							beginAtTier: false
						})
					)
				);
			}
		}]);
	
		return DressingRoom;
	}(React.Component), _initialiseProps = function _initialiseProps() {
		var _this3 = this;
	
		this.hideOwls = function (user) {
			return user && user.settings && user.settings.hide_owls;
		};
	
		this.handleAvatarUpdated = function (avatar) {
			if (avatar.errors) _this3.notifyErrors(avatar.errors);else {
				_this3.notifyAvatarSaved();
				_this3.props.updateCurrentUser(function () {
					return _this3.forceUpdate();
				});
				Mycroft.newEvent({ category: "Owl Shop", action: "save-avatar" });
			}
		};
	
		this.notifyErrors = function (errors) {
			return window.wrNotifications.triggerDropDownNotification({
				title: "Sorry!",
				text: errors.join(", "),
				icon: "exclamation-sign",
				type: "error"
			});
		};
	
		this.notifyAvatarSaved = function () {
			return window.wrNotifications.triggerDropDownNotification({
				title: "Great!",
				text: "Your Owlvatar has been saved!",
				icon: "ok-sign"
			});
		};
	}, _temp)) || _class) || _class);
	
	
	module.exports = DressingRoom;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	
	__webpack_require__(3658);
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	var FurnitureDisplay = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
			filteredPerks: OwlShopSelectors.getFilteredPerks({ state: state }),
			allFurnitures: OwlShopSelectors.getFurnitures({ state: state }),
			getPatchesByNameAndType: function getPatchesByNameAndType(_ref) {
				var name = _ref.name,
				    originType = _ref.originType;
				return OwlShopSelectors.getPatchesByNameAndType({ state: state, name: name, originType: originType });
			},
			getPerksByNameAndType: function getPerksByNameAndType(_ref2) {
				var name = _ref2.name,
				    type = _ref2.type;
				return OwlShopSelectors.getPerksByNameAndType({ state: state, name: name, type: type });
			}
		};
	}, function (dispatch, props) {
		return {
			updateFurnitures: function updateFurnitures(_ref3) {
				var ids = _ref3.ids,
				    newProperties = _ref3.newProperties;
				return dispatch(OwlShopActions.updateFurnitures({ ids: ids, newProperties: newProperties }));
			},
			postFurnitures: function postFurnitures(_ref4) {
				var furniture = _ref4.furniture,
				    newProperties = _ref4.newProperties,
				    callback = _ref4.callback;
				return dispatch(OwlShopActions.postFurnitures({ furniture: furniture, newProperties: newProperties, callback: callback }));
			},
			updateCurrentUser: function updateCurrentUser(callback) {
				return CurrentUser.fetchCurrentUserCoinData(callback);
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(FurnitureDisplay, _React$Component);
	
		function FurnitureDisplay(props) {
			_classCallCheck(this, FurnitureDisplay);
	
			var _this = _possibleConstructorReturn(this, (FurnitureDisplay.__proto__ || Object.getPrototypeOf(FurnitureDisplay)).call(this));
	
			_this.notifyErrors = function (errors) {
				return window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!",
					text: errors.join(", "),
					icon: "exclamation-sign",
					type: "error"
				});
			};
	
			_this.updateLocalFurnitureList = function (_ref5) {
				var furniture = _ref5.furniture,
				    newProperties = _ref5.newProperties;
				return _this.props.updateFurnitures({
					ids: [furniture.id],
					newProperties: newProperties
				});
			};
	
			_this.handleFurniturePostResponse = function (furniture) {
				return function (response) {
					var perk = response.perk;
	
	
					if (perk.errors) {
						_this.notifyErrors(perk.errors);
						_this.setState({
							buyLoading: false
						});
					} else {
						if (_this.isFurnitureOwned()) {
							var text = "Your furniture has been saved!";
						} else {
							var text = "You bought " + furniture.title + "!";
						}
						window.wrNotifications.triggerDropDownNotification({
							title: "Looking good!",
							text: text,
							icon: "ok-sign"
						});
	
						furniture["owned"] = true;
						furniture["equipped"] = true;
						_this.props.equipFurniture(furniture);
	
						_this.setState({ buyLoading: false });
	
						_this.props.updateCurrentUser(function () {
							return _this.updateLocalFurnitureList({ furniture: furniture, newProperties: furniture });
						});
	
						Mycroft.newEvent({
							category: "Owl Shop",
							action: "buy-item",
							label: furniture.title
						});
					}
				};
			};
	
			_this.handleFurnitureRemoveResponse = function (furniture) {
				return function (response) {
					var perk = response.perk;
	
	
					if (perk.errors) {
						_this.notifyErrors(perk.errors);
						_this.setState({
							buyLoading: false
						});
					} else {
						if (_this.props.previewItemType == constants.SOFAS) {
							var title = "Sofa removed";
							var text = "Poof! your sofa has vanished!";
						} else if (_this.props.previewItemType == constants.BOOKSHELVES) {
							var title = "Bookshelf removed";
							var text = "Poof! your bookshelf have vanished!";
						} else if (_this.props.previewItemType == constants.WALL_ITEM || _this.props.previewItemType == "wall_items2") {
							var title = "Wall item removed";
							var text = "Poof! your wall item has vanished!";
						} else if (_this.props.previewItemType == constants.FLOOR_ITEM || _this.props.previewItemType == "floor_items2") {
							var title = "Floor item removed";
							var text = "Poof! your floor item has vanished!";
						}
	
						window.wrNotifications.triggerDropDownNotification({
							title: title,
							text: text,
							icon: "ok-sign"
						});
	
						_this.props.equipFurniture(furniture);
					}
				};
			};
	
			autobind(_this);
			_this.previewItemRef = React.createRef();
	
			_this.state = {
				editStyle: { top: 0, left: 0 },
				buyLoading: false
			};
			return _this;
		}
	
		// previews furniture (when redirected from golden egg modal)
	
	
		_createClass(FurnitureDisplay, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.previewItemName && this.props.previewItemType) {
					this.setNewStyle(this.props.previewItemType);
				}
			}
		}, {
			key: "resetEditMode",
			value: function resetEditMode() {
				this.props.setPreviewItem(null, null);
			}
		}, {
			key: "getPerkPath",
			value: function getPerkPath(name, type) {
				var adjustedFurnitureType = this.getAdjustedFurnitureType(type);
				var perkPath = "furnitures/" + adjustedFurnitureType + "/" + name + ".png";
				return dynamicRequire(perkPath);
			}
		}, {
			key: "renderPreviewItem",
			value: function renderPreviewItem() {
				var perkPath = this.getPerkPath(this.props.previewItemName, this.props.previewItemType);
				var previewStyle = {
					top: this.state.editStyle.top + "%",
					left: this.state.editStyle.left + "%"
				};
				return React.createElement("img", {
					ref: this.previewItemRef,
					className: "furnitureItem " + this.props.previewItemType,
					style: previewStyle,
					src: perkPath
				});
			}
		}, {
			key: "renderFurnitures",
			value: function renderFurnitures() {
				var _this2 = this;
	
				var images = [];
				var opacity = 1.0;
				if (this.props.previewItemType) {
					opacity = 0.5;
				}
				if (this.props.furnitures) {
					_.each(this.props.furnitures, function (furnitures, furniture_type) {
						if (furniture_type != _this2.props.previewItemType) {
							_.each(furnitures, function (data, furniture) {
								if (data.equipped) {
									var perkPath = _this2.getPerkPath(furniture, furniture_type);
									var furnitureStyle = {
										top: data.style.top + "%",
										left: data.style.left + "%",
										opacity: opacity
									};
									images.push(React.createElement("img", {
										key: furniture_type + "_" + furniture,
										className: "furnitureItem " + furniture_type,
										style: furnitureStyle,
										src: perkPath
									}));
								}
							});
						}
					});
				}
				return images;
			}
		}, {
			key: "onFurnitureClick",
			value: function onFurnitureClick(furniture, furniture_type) {
				if (this.props.editMode) {
					this.props.setPreviewItem(furniture, furniture_type);
				}
			}
		}, {
			key: "moveObject",
			value: function moveObject(direction) {
				var newStyle = _.clone(this.state.editStyle);
	
				switch (direction) {
					case "up":
						newStyle.top -= constants.INCREMENT;
						break;
					case "down":
						newStyle.top += constants.INCREMENT;
						break;
					case "left":
						newStyle.left -= constants.INCREMENT;
						break;
					case "right":
						newStyle.left += constants.INCREMENT;
						break;
				}
				if (this.isFurnitureWithinBounds(newStyle)) {
					this.setState({ editStyle: newStyle });
				}
			}
		}, {
			key: "isFurnitureWithinBounds",
			value: function isFurnitureWithinBounds(newStyle) {
				var size = this.getFurnitureSize();
	
				var upperBound = 5;
				var lowerBound = 95;
				if (_.include(["wall_items", "wall_items2"], this.props.previewItemType)) {
					lowerBound = 76;
					if (newStyle.top + size.h > 76 || newStyle.left + size.w > 95) {
						return false;
					}
				} else if (_.include(["floor_items", "floor_items2"], this.props.previewItemType)) {
					if (newStyle.top + size.h > 90 || newStyle.top + size.h < 84 || newStyle.left + size.w > 95) {
						return false;
					}
				} else {
					if (newStyle.top + size.h > 95 || newStyle.left + size.w > 95) {
						return false;
					}
				}
	
				if (newStyle.top < 5 || newStyle.left < 5) {
					return false;
				}
				return true;
			}
		}, {
			key: "renderEditOptions",
			value: function renderEditOptions() {
				if (_.include(["wall_items", "wall_items2", "floor_items", "floor_items2"], this.props.previewItemType)) {
					var upOption = React.createElement(
						"a",
						{
							className: "up-arrow arrow",
							"data-tip": "Move furniture up",
							onClick: this.moveObject.bind(this, "up")
						},
						React.createElement(Glyphicon, { icon: "circle-arrow-up" })
					);
					var downOption = React.createElement(
						"a",
						{
							className: "down-arrow arrow",
							"data-tip": "Move furniture down",
							onClick: this.moveObject.bind(this, "down")
						},
						React.createElement(Glyphicon, { icon: "circle-arrow-down" })
					);
				}
				if (this.isFurnitureOwned()) {
					var purchaseText = "Save";
				} else {
					var purchaseText = "Buy it";
				}
				if (this.isFurnitureTypeEquipped()) {
					var removeAction = React.createElement(
						"a",
						{ className: "remove", onClick: this.removeFurniture },
						"Remove"
					);
				}
				return React.createElement(
					"div",
					{ className: "editOptions" },
					React.createElement(
						"a",
						{
							className: "left-arrow arrow",
							"data-tip": "Move left",
							onClick: this.moveObject.bind(this, "left")
						},
						React.createElement(Glyphicon, { icon: "circle-arrow-left" })
					),
					React.createElement(
						"a",
						{
							className: "right-arrow arrow",
							"data-tip": "Move right",
							onClick: this.moveObject.bind(this, "right")
						},
						React.createElement(Glyphicon, { icon: "circle-arrow-right" })
					),
					upOption,
					downOption,
					React.createElement(
						"div",
						{ className: "shopActions backgroundPatcher" },
						React.createElement(
							"button",
							{ className: "btn btn-default", onClick: this.resetEditMode },
							"Cancel"
						),
						React.createElement(LoadingButton, {
							className: "btn buttonSuccess purchase",
							loading: this.state.buyLoading,
							onClick: this.purchaseFurniture,
							text: purchaseText
						}),
						removeAction
					),
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
	
			// componentWillReceiveProps(nextProps) {
			// 	if (nextProps.previewItemName != this.props.previewItemName) {
			// 		this.setNewStyle(nextProps.previewItemType)
			// 	}
			// }
	
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (this.props.previewItemName && prevProps.previewItemName != this.props.previewItemName) {
					this.setNewStyle(this.props.previewItemType);
				}
			}
		}, {
			key: "getFurnitureSize",
			value: function getFurnitureSize() {
				var width = null;
				var height = null;
				var previewItem = this.previewItemRef.current;
				if (previewItem) {
					var backgroundImage = $(this.refs.wrap).closest(".houseInteriorRoom").find(".backgroundImage");
					var backgroundWidth = backgroundImage.width();
					var backgroundHeight = backgroundImage.height();
	
					width = previewItem.width / parseFloat(backgroundWidth) * 100;
					height = previewItem.height / parseFloat(backgroundHeight) * 100;
				}
				return { w: width, h: height };
			}
		}, {
			key: "setNewStyle",
			value: function setNewStyle(furnitureType) {
				var adjustedFurnitureType = this.getAdjustedFurnitureType(furnitureType);
				var size = this.getFurnitureSize();
				var initialPlacement = constants.INITIAL_PLACEMENT[adjustedFurnitureType];
				var newTop = initialPlacement.top - size.h;
				var newLeft = initialPlacement.left - size.w;
	
				if (newTop != initialPlacement.top && newLeft != initialPlacement.left) {
					var style = { top: newTop, left: newLeft };
					this.setState({ editStyle: style });
				} else {
					setTimeout(this.setNewStyle.bind(this, furnitureType), 50);
				}
			}
		}, {
			key: "getAdjustedFurnitureType",
			value: function getAdjustedFurnitureType(furnitureType) {
				if (furnitureType == "wall_items2") {
					return "wall_items";
				} else if (furnitureType == "floor_items2") {
					return "floor_items";
				}
				return furnitureType;
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.editMode) {
					var editOptions = this.renderEditOptions();
				}
				if (this.props.previewItemType) {
					var previewItem = React.createElement(
						CSSTransition,
						{ classNames: "appear", timeout: { enter: 300, exit: 300 } },
						this.renderPreviewItem()
					);
				}
				return React.createElement(
					"div",
					{ className: "FurnitureDisplay", ref: "wrap" },
					React.createElement(
						TransitionGroup,
						null,
						previewItem
					),
					this.renderFurnitures(),
					editOptions,
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
		}, {
			key: "isFurnitureOwned",
			value: function isFurnitureOwned() {
				if (this.props.previewItemType == "wall_items" || this.props.previewItemType == "wall_items2") {
					return this.props.furnitures["wall_items"] && this.props.furnitures["wall_items"][this.props.previewItemName] || this.props.furnitures["wall_items2"] && this.props.furnitures["wall_items2"][this.props.previewItemName];
				} else if (this.props.previewItemType == "floor_items" || this.props.previewItemType == "floor_items2") {
					return this.props.furnitures["floor_items"] && this.props.furnitures["floor_items"][this.props.previewItemName] || this.props.furnitures["floor_items2"] && this.props.furnitures["floor_items2"][this.props.previewItemName];
				}
				return this.props.furnitures[this.props.previewItemType] && this.props.furnitures[this.props.previewItemType][this.props.previewItemName];
			}
		}, {
			key: "isFurnitureTypeEquipped",
			value: function isFurnitureTypeEquipped() {
				if (this.props.furnitures[this.props.previewItemType] == undefined) {
					return false;
				}
				var equipped = _.map(this.props.furnitures[this.props.previewItemType], function (furniture, name) {
					return furniture.equipped;
				});
				return equipped.indexOf(true) > -1;
			}
		}, {
			key: "purchaseFurniture",
			value: function purchaseFurniture() {
				this.setState({ buyLoading: true });
	
				var furniture = {};
				furniture["name"] = this.props.previewItemName;
				furniture["title"] = this.props.previewItemTitle;
				furniture["furniture_type"] = this.props.previewItemType;
				furniture["origin_furniture_type"] = this.getAdjustedFurnitureType(this.props.previewItemType);
				furniture["style"] = this.state.editStyle;
	
				furniture.id = furniture.furniture_type + "-" + furniture.name;
	
				this.props.postFurnitures({
					furniture: furniture,
					newProperties: null,
					callback: this.handleFurniturePostResponse(furniture)
				});
			}
		}, {
			key: "removeFurniture",
			value: function removeFurniture() {
				var blankItem = {};
				blankItem["furniture_type"] = this.props.previewItemType;
				blankItem["origin_furniture_type"] = this.getAdjustedFurnitureType(this.props.previewItemType);
	
				this.props.postFurnitures({
					furniture: blankItem,
					newProperties: null,
					callback: this.handleFurnitureRemoveResponse(blankItem)
				});
			}
		}]);
	
		return FurnitureDisplay;
	}(React.Component)) || _class);
	
	
	var constants = {};
	constants.INCREMENT = 2;
	
	constants.SOFAS = "sofas";
	constants.BOOKSHELVES = "bookshelves";
	constants.WALL_ITEM = "wall_items";
	constants.FLOOR_ITEM = "floor_items";
	
	constants.INITIAL_PLACEMENT = {
		sofas: { top: 83, left: 75 },
		bookshelves: { top: 80, left: 30 },
		wall_items: { top: 45, left: 70 },
		floor_items: { top: 90, left: 40 }
	};
	
	module.exports = FurnitureDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlShopSelectors = __webpack_require__(94);
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var AvatarPatch = __webpack_require__(371);
	var Tiers = __webpack_require__(108);
	var OwlShopRouting = __webpack_require__(92);
	
	__webpack_require__(3661);
	
	var GoldenEggModal = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	    return {
	        //get the patches that the user doesn't own
	        filteredPatches: OwlShopSelectors.getFilteredPatches({ state: state }),
	        filteredPerks: OwlShopSelectors.getFilteredPerks({ state: state }),
	        allFurnitures: OwlShopSelectors.getFurnitures({ state: state }),
	        user: CurrentUser.get()
	    };
	}, null, null, { forwardRef: true }), _dec(_class = function (_React$Component) {
	    _inherits(GoldenEggModal, _React$Component);
	
	    function GoldenEggModal(props) {
	        _classCallCheck(this, GoldenEggModal);
	
	        var _this = _possibleConstructorReturn(this, (GoldenEggModal.__proto__ || Object.getPrototypeOf(GoldenEggModal)).call(this));
	
	        autobind(_this);
	        _this.state = {
	            eggOpen: false,
	            awardType: null,
	            awardDetails: null
	        };
	        return _this;
	    }
	
	    _createClass(GoldenEggModal, [{
	        key: 'show',
	        value: function show() {
	            this.refs.modal.show();
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.refs.modal.hide();
	        }
	
	        // gets all unowned items at the current tier which the student can afford 
	
	    }, {
	        key: 'getUnownedItems',
	        value: function getUnownedItems() {
	            var reqs = Tiers.REQUIREMENTS[this.props.user.tier];
	            var currentTier = this.props.user.tier;
	            var reqsRemaining = $wr.getRemainingReqs(currentTier, reqs, this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures);
	            var userCoins = this.props.user.coins;
	            var unownedPatches = _.select(this.props.filteredPatches, function (patch) {
	                //removes duplicates by removing right hand and body 2 items
	                var handType = patch.origin_patch_type == "hand" ? "left_hand" : patch.patch_type;
	                var bodyType = patch.origin_patch_type == "body" ? "body" : patch.patch_type;
	                //adds field to identify item is a patch (vs perk or furniture)
	                patch["category"] = "patch";
	                return !patch.owned && patch.source == "store" && patch.tier == currentTier && (Object.keys(reqsRemaining).includes(patch.patch_type) || Object.keys(reqsRemaining).includes(patch.origin_patch_type)) && patch.patch_type == handType && patch.patch_type == bodyType;
	            });
	
	            var unownedPerks = _.select(this.props.filteredPerks, function (perk) {
	                perk["category"] = "perk";
	                return Object.keys(reqsRemaining).includes(perk.perk_type) || Object.keys(reqsRemaining).includes("total") && perk.perk_type != "titles" && !perk.owned && perk.source == "store" && perk.tier == currentTier;
	            });
	
	            var unownedFurniture = _.select(this.props.allFurnitures, function (furniture) {
	                furniture["category"] = "furniture";
	                //removes duplicates (wall items2 and floor items2)
	                return !furniture.owned && furniture.source == "store" && furniture.tier == currentTier && Object.keys(reqsRemaining).includes(furniture.perk_type);
	            });
	
	            var coinAmount = this.state.awardCoinsDetails;
	
	            var unownedItems = unownedPatches.concat(unownedPerks, unownedFurniture).filter(function (item) {
	                return item.price <= userCoins + coinAmount;
	            });
	            return unownedItems;
	        }
	    }, {
	        key: 'getAdjustedFurnitureType',
	        value: function getAdjustedFurnitureType(furnitureType) {
	            if (furnitureType == "wall_items2") {
	                return "wall_items";
	            } else if (furnitureType == "floor_items2") {
	                return "floor_items";
	            }
	            return furnitureType;
	        }
	
	        // renders the item with its picture, name, and link
	
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item) {
	            var _this2 = this;
	
	            var itemName = item.title || item.name;
	            var path = "";
	            if (item["category"] == "patch") {
	                path = "patches/" + item["origin_patch_type"] + "/" + item["name"] + "-s.png";
	                path = dynamicRequire(path);
	            } else if (item["category"] == "perk") {
	                if (item.perk_type == "backgrounds" || item.perk_type == "houses" || item.perk_type == "owl_hoots" || item.perk_type == "background_sounds" || item.perk_type == "greetings") {
	
	                    if (item.perk_type == "houses" || this.props.allFurnitures.indexOf(item.perk_type) >= 0) {
	                        var name = item["name"].toLowerCase().replace(/\s/g, "-");
	                        if (name.indexOf('\'') >= 0) {
	                            name = name.replace('\'', "");
	                        }
	                    } else {
	                        var name = item["name"].toLowerCase().replace(/\s/g, "_");
	                    }
	                    var path = "perks/" + item["origin_perk_type"] + "/" + name + ".png";
	                    path = dynamicRequire(path);
	                } else if (this.props.allFurnitures.indexOf(item.perk_type) >= 0) {
	                    var path = "perks/" + item["origin_perk_type"] + "/" + item["name"] + ".png";
	                    path = dynamicRequire(path);
	                }
	            } else {
	                var adjustedFurnitureType = this.getAdjustedFurnitureType(item.perk_type);
	                var path = "furnitures/" + adjustedFurnitureType + "/" + item["name"] + ".png";
	                path = dynamicRequire(path);
	            }
	
	            var key = path;
	
	            return React.createElement(
	                'a',
	                { key: key, href: '#', onClick: function onClick() {
	                        return _this2.redirectToOwlShopItem(item);
	                    } },
	                React.createElement(
	                    'div',
	                    { className: 'displayItem' },
	                    React.createElement('img', { src: path, className: 'patchThumbnail' }),
	                    React.createElement('br', null),
	                    React.createElement(
	                        'p',
	                        { className: 'title' },
	                        itemName
	                    )
	                )
	            );
	        }
	
	        // gets three random items (still unowned, can afford, same tier as student)
	
	    }, {
	        key: 'getRandomItems',
	        value: function getRandomItems() {
	            var unownedItems = this.getUnownedItems();
	            var randomItems = unownedItems.sort(function () {
	                return .5 - Math.random();
	            }).slice(0, 3).map(function (item) {
	                return item;
	            });
	            this.setState({ randomItems: randomItems });
	        }
	
	        // redirects to preview the item in the owl shop
	
	    }, {
	        key: 'redirectToOwlShopItem',
	        value: function redirectToOwlShopItem(item) {
	            var itemName = item.name;
	            if (item["category"] == "patch") {
	                var itemType = item.patch_type + "&patch=true";
	            } else {
	                var itemType = item.perk_type;
	            }
	            if (item["category"] == "furniture") {
	                var params = "?itemName=" + itemName + "&itemType=" + itemType + "&furniture=true";
	            } else {
	                var params = "?itemName=" + itemName + "&itemType=" + itemType;
	            }
	            $wr.redirect(OwlShopRouting.getPath({}) + params);
	        }
	    }, {
	        key: 'handleOpen',
	        value: function handleOpen() {
	            var _this3 = this;
	
	            var params = { award: { type: "golden_egg", student_id: CurrentUser.get().id } };
	            CurrentUser.api().postAwards(params, $wr.apiHandler(function (response) {
	                setTimeout(function () {
	                    if (response && response.response && response.response.award && response.response.success) {
	                        var responseData = response.response.award;
	                        _this3.setState({ eggOpen: true, awardType: responseData["type"], awardPatchDetails: responseData["details"]["patch"], awardCoinsDetails: responseData["details"]["amount"] });
	                        if (_this3.state.awardType == "coins") {
	                            _this3.getRandomItems();
	                        }
	                    } else {
	                        if (_this3) {
	                            _this3.hide();
	                        }
	                    }
	                    _this3.props.onComplete();
	                    CurrentUser.fetchCurrentUserData();
	                }, 750);
	            }));
	        }
	    }, {
	        key: 'renderCoinsAward',
	        value: function renderCoinsAward() {
	            var eggPath = __webpack_require__(498);
	            var awardImage = React.createElement('img', { src: __webpack_require__(526), className: 'awardsCoin' });
	            var coinAmount = this.state.awardCoinsDetails;
	            var awardName = React.createElement(
	                'p',
	                { className: 'coinAmount' },
	                'You just got ',
	                coinAmount,
	                ' coins!'
	            );
	            var randomItems = this.state.randomItems;
	            // renders item pictures and names
	            if (randomItems && randomItems.length > 0) {
	                var displayItems = _.map(randomItems, function (item) {
	                    return this.renderItem(item);
	                }.bind(this));
	                var randomItemsDesc = React.createElement(
	                    'p',
	                    { className: 'patchDescription' },
	                    'To level up, you can now purchase:'
	                );
	            }
	
	            return React.createElement(
	                'div',
	                { className: 'data' },
	                awardName,
	                React.createElement(
	                    'p',
	                    { className: 'awardImage' },
	                    awardImage
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'eggContainer' },
	                    React.createElement('img', { src: eggPath, className: 'goldenEggInsideModal' })
	                ),
	                React.createElement('br', null),
	                randomItemsDesc,
	                React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'div',
	                        { className: 'itemsDisplay' },
	                        displayItems
	                    ),
	                    React.createElement(
	                        'p',
	                        { className: 'owlShopLink' },
	                        'Visit the ',
	                        React.createElement(
	                            'a',
	                            { href: '/owl_shop' },
	                            'Owl Shop'
	                        ),
	                        ' to see more!'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderPatchAward',
	        value: function renderPatchAward() {
	            var eggPath = __webpack_require__(498);
	            var awardImagePath = "patches/" + this.state.awardPatchDetails["origin_patch_type"] + "/" + this.state.awardPatchDetails["name"] + "-s.png";
	            var awardImage = React.createElement('img', { src: dynamicRequire(awardImagePath), className: 'awardsPatch' });
	            var patchName = this.state.awardPatchDetails["title"];
	            var patchDescription = this.state.awardPatchDetails["description"];
	            var awardName = React.createElement(
	                'p',
	                { className: 'patchName' },
	                'You just got a new patch:',
	                React.createElement('br', null),
	                ' ',
	                patchName,
	                '!'
	            );
	
	            return React.createElement(
	                'div',
	                { className: 'data' },
	                awardName,
	                React.createElement(
	                    'p',
	                    { className: 'patchDescription' },
	                    patchDescription
	                ),
	                React.createElement(
	                    'p',
	                    { className: 'awardImage' },
	                    awardImage
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'eggContainer' },
	                    React.createElement('img', { src: eggPath, className: 'goldenEggInsideModal' })
	                ),
	                React.createElement('br', null),
	                React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'p',
	                        { className: 'owlShopLink' },
	                        'Visit the ',
	                        React.createElement(
	                            'a',
	                            { href: '/owl_shop' },
	                            'Owl Shop'
	                        ),
	                        ' to see more!'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.eggOpen) {
	                if (this.state.awardType == "coins") {
	                    var eggModalContent = this.renderCoinsAward();
	                } else {
	                    //var coinImage = <img src={ require('official-icons/coin-s.png') } className="awardsCoin" />
	                    var eggModalContent = this.renderPatchAward();
	                }
	            } else {
	                var eggPath = __webpack_require__(497);
	            }
	            return React.createElement(
	                Modal,
	                { className: 'eggModal', ref: 'modal', headerText: 'Golden Egg', onShow: this.handleOpen },
	                eggModalContent
	            );
	        }
	    }]);
	
	    return GoldenEggModal;
	}(React.Component)) || _class);
	
	
	module.exports = GoldenEggModal;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	var FurnitureDisplay = __webpack_require__(777);
	var OwlShopPatcher = __webpack_require__(238);
	var Spinner = __webpack_require__(9);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3662);
	
	var HouseInteriorRoom = function (_React$Component) {
		_inherits(HouseInteriorRoom, _React$Component);
	
		function HouseInteriorRoom(props) {
			_classCallCheck(this, HouseInteriorRoom);
	
			var _this = _possibleConstructorReturn(this, (HouseInteriorRoom.__proto__ || Object.getPrototypeOf(HouseInteriorRoom)).call(this));
	
			autobind(_this);
	
			if (props.activeRoom && props.activeRoom != "trophy") {
				var activeOtherType = props.activeRoom;
			} else {
				var activeOtherType = "wall_items";
			}
	
			_this.state = {
				showOwls: true,
				extended: false,
				loading: false,
				activeOtherType: activeOtherType
			};
			return _this;
		}
		// PATCHER SUPPORT
	
	
		_createClass(HouseInteriorRoom, [{
			key: "setPreviewItem",
			value: function setPreviewItem(name, type) {
				var title = "";
				_.some(this.props.allFurnitures, function (furniture) {
					if (furniture.name == name && furniture.perk_type) {
						title = furniture.title;
						return true;
					}
				});
				this.setState({
					previewItemName: name,
					previewItemType: type,
					previewItemTitle: title
				});
			}
		}, {
			key: "setActiveType",
			value: function setActiveType(pType, oType) {
				this.setState({ activePatchType: pType, activeOtherType: oType });
			}
		}, {
			key: "equipFurniture",
			value: function equipFurniture(newFurniture) {
				var _this2 = this;
	
				var newStudentFurnitures = _.extend({}, this.state.studentFurnitures);
				if (newStudentFurnitures[this.state.previewItemType] == undefined) {
					newStudentFurnitures[this.state.previewItemType] = {};
				}
				// UNEQUIP ALL FURNITURE IN CATEGORY
				_.each(newStudentFurnitures[this.state.previewItemType], function (furniture, name) {
					furniture["equipped"] = false;
				});
	
				if (newFurniture.name != undefined) {
					// SET NEW STUDENT FURNITURES
					newStudentFurnitures[this.state.previewItemType][this.state.previewItemName] = newFurniture;
					// MARK NEWLY PURCHASED FURNITURE IN STORE
					var furnitures = _.map(this.props.allFurnitures, function (furniture) {
						if (furniture.name == _this2.state.previewItemName) {
							return _.extend({}, furniture, newFurniture);
						}
						return furniture;
					});
					this.setState({ studentFurnitures: newStudentFurnitures });
				} else {
					// UNEQUIP FURNITURE
					this.setState({ studentFurnitures: newStudentFurnitures });
				}
				// RESET STORE
				this.setPreviewItem(null, null);
			}
	
			// SHOP SUPPORT
	
		}, {
			key: "triggerShop",
			value: function triggerShop() {
				var newState = !this.state.extended;
				if (newState) {
					this.onShopAction("open");
				} else {
					this.onShopAction("close");
				}
				this.setState({ extended: newState });
			}
		}, {
			key: "onShopAction",
			value: function onShopAction(action) {
				if (action == "open") {
					LuckyOrangeClient.tagComponent("FurnitureShop");
					$(".switchRoomLink").hide();
					this.setState({ showOwls: false });
				} else {
					$(".switchRoomLink").show();
					this.setState({ showOwls: true });
				}
			}
		}, {
			key: "displayShopHeader",
			value: function displayShopHeader() {
				return React.createElement(
					"div",
					{ className: "shopHeader" },
					React.createElement(
						"a",
						{ className: "shopTrigger", onClick: this.triggerShop.bind(this) },
						React.createElement("img", {
							className: "shopLogo",
							"data-tip": "Furniture Shop",
							src: dynamicRequire("owl-item-types/" + "furniture_icon.png")
						}),
						React.createElement(ReactTooltip, { effect: "solid" })
					)
				);
			}
		}, {
			key: "renderPatcher",
			value: function renderPatcher() {
				return React.createElement(
					"div",
					{ className: "patcher backgroundPatcher" },
					React.createElement(
						"a",
						{ className: "right_close", onClick: this.triggerShop },
						"close"
					),
					React.createElement(OwlShopPatcher, {
						ref: "OwlShopPatcher",
						mode: "furniture",
						allPerks: this.props.allFurnitures,
						previewItemName: this.state.previewItemName,
						previewItemType: this.state.previewItemType,
						activeOtherType: this.state.activeOtherType,
						setPreviewItem: this.setPreviewItem,
						setActiveType: this.setActiveType
					})
				);
			}
			//
	
		}, {
			key: "getSoundPerks",
			value: function getSoundPerks() {
				var perks = this.props.student.perks;
				var sound_sources = [];
				var has_greeting = false;
				// Grabs sources from perks of host
				if (perks.background_sounds) {
					sound_sources.push({
						ref: perks.background_sounds,
						path: "background/" + perks.background_sounds,
						play: true,
						loop: true
					});
				}
				if (perks.owl_hoots) {
					sound_sources.push({
						ref: perks.owl_hoots,
						path: "owl_hoots/" + perks.owl_hoots,
						play: false
					});
				}
				if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings)) {
					sound_sources.push({
						ref: perks.greetings,
						path: "dances/" + perks.greetings,
						play: false
					});
					has_greeting = true;
				}
				// Grabs sources for guest (if guest)
				if (this.props.currentStudent) {
					var perks = this.props.currentStudent.perks;
					if (perks.owl_hoots) {
						sound_sources.push({
							ref: perks.owl_hoots + "_" + "1",
							path: "owl_hoots/" + perks.owl_hoots,
							play: false
						});
					}
					if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings)) {
						sound_sources.push({
							ref: perks.greetings + "_" + "1",
							path: "dances/" + perks.greetings,
							play: false
						});
					}
					if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings) && !has_greeting) {
						sound_sources.push({
							ref: perks.greetings,
							path: "dances/" + perks.greetings,
							play: false
						});
					}
				}
				return sound_sources;
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
				var editMode = false;
				if (student.perks.houses != "") {
					var imagePath = __webpack_require__(224)("./" + student.perks.houses.toLowerCase().replace(/ /g, "-").replace("'", "") + "-empty.png");
				}
	
				if (this.state.studentFurnitures) {
					if (this.state.showOwls) {
						if (this.props.currentStudent) {
							var owlTwo = React.createElement(
								"div",
								{ id: "owlTwo", ref: "owlTwo", className: "owlsInside owlTwo" },
								React.createElement(StudentAvatar, {
									student: this.props.currentStudent,
									maxWidth: 150,
									location: "modal"
								})
							);
							var owlOne = React.createElement(
								"div",
								{ id: "owlOne", ref: "owlOne", className: "owlsInside owlOneSide" },
								React.createElement(StudentAvatar, { student: student, maxWidth: 150, location: "modal" })
							);
						} else {
							if (!CurrentUser.isAdmin()) {
								var header = this.displayShopHeader();
							}
							var owlOne = React.createElement(
								"div",
								{ id: "owlOne", ref: "owlOne", className: "owlsInside owlOne" },
								React.createElement(StudentAvatar, { student: student, maxWidth: 150, location: "modal" })
							);
						}
					} else if (this.state.extended) {
						if (this.props.allFurnitures) {
							if (this.state.previewItemName) {
								editMode = true;
							} else {
								var patcher = this.renderPatcher();
							}
						} else {
							var patcher = React.createElement(Spinner, { scale: 2, center: true });
						}
					}
	
					var furnitureDisplay = React.createElement(FurnitureDisplay, {
						furnitures: this.state.studentFurnitures,
						editMode: editMode,
						previewItemName: this.state.previewItemName,
						previewItemType: this.state.previewItemType,
						previewItemTitle: this.state.previewItemTitle,
						setPreviewItem: this.setPreviewItem,
						equipFurniture: this.equipFurniture
					});
				} else {
					var furnitureDisplay = React.createElement(Spinner, { scale: 2, center: true });
				}
	
				return React.createElement(
					"div",
					{ className: "houseInteriorRoom" },
					React.createElement("img", { src: imagePath, className: "backgroundImage" }),
					header,
					furnitureDisplay,
					owlOne,
					owlTwo,
					patcher
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this3 = this;
	
				CurrentUser.api().getUser(this.props.student.id, { embed: "student.furnitures" }, $wr.apiHandler(function (response) {
					if (response.user.furnitures) {
						var furnitures = response.user.furnitures;
					} else {
						var furnitures = {};
					}
					_this3.setState({ studentFurnitures: furnitures });
				}));
				if (this.props.activeRoom && this.props.activeRoom != "trophy" && this.props.activeRoom != "house") {
					this.triggerShop();
				}
	
				if (this.props.previewItemName && this.props.previewItemType) {
					this.setPreviewItem(this.props.previewItemName, this.props.previewItemType);
				}
			}
		}]);
	
		return HouseInteriorRoom;
	}(React.Component);
	
	HouseInteriorRoom.propTypes = StrictPropTypes({
		// Data about the student
		student: PropTypes.object.isRequired,
	
		// Data on the visiting student
		currentStudent: PropTypes.object,
		activeRoom: PropTypes.string,
		allFurnitures: PropTypes.array,
		updateFurnitures: PropTypes.func,
	
		//for previewing a furniture item
		previewItemName: PropTypes.string,
		previewItemType: PropTypes.string,
		previewItemTitle: PropTypes.string
	});
	
	module.exports = HouseInteriorRoom;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	
	// @providePopulateData()
	
	var PhotoBooth = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
		return {
			user: CurrentUser.get()
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(PhotoBooth, _React$Component);
	
		function PhotoBooth(props) {
			_classCallCheck(this, PhotoBooth);
	
			var _this = _possibleConstructorReturn(this, (PhotoBooth.__proto__ || Object.getPrototypeOf(PhotoBooth)).call(this));
	
			autobind(_this);
			if (props.width) {
				var width = props.width;
			} else {
				var width = 400;
			}
			_this.state = {
				width: width, imageIndex: 0, taglineIndex: 0, avatarSize: 140, avatarPos: { top: "0px", left: "0px" }, minAvatarSize: 100
			};
			return _this;
		}
	
		_createClass(PhotoBooth, [{
			key: "renderBackground",
			value: function renderBackground() {
				var imagePath = this.props.background;
				return React.createElement("img", { style: { "width": "100%", "height": "100%", "zIndex": 0, "display": "inline-block" }, src: imagePath });
			}
		}, {
			key: "renderOwl",
			value: function renderOwl() {
				var top = this.props.avatarPos.top;
				var left = this.props.avatarPos.left;
				return React.createElement(
					"div",
					{ ref: "avatar", id: "boothAvatar", style: { "position": "absolute", "top": top, "left": left, "zIndex": 1000 } },
					React.createElement(StudentAvatar, { student: this.props.user, maxWidth: this.props.avatarSize, disableAnimation: true })
				);
			}
		}, {
			key: "renderImage",
			value: function renderImage() {
				var width = this.state.width * 0.89;
				var height = width;
				var background = this.renderBackground();
				var owl = this.renderOwl();
				return React.createElement(
					"div",
					{ ref: "image", id: "boothImage", className: "image", style: { "width": width, "height": height, "backgroundColor": "black", "position": "relative", "overflow": "hidden" } },
					background,
					owl
				);
			}
		}, {
			key: "renderCaption",
			value: function renderCaption() {
				return React.createElement(
					"div",
					{ style: { "textAlign": "center", "paddingTop": "12px", "paddingBottom": "12px", "fontSize": "120%" } },
					this.props.caption
				);
			}
		}, {
			key: "renderPolaroid",
			value: function renderPolaroid() {
				var width = parseInt(this.state.width);
				var height = this.state.width * 1.2;
				var image = this.renderImage();
				var tagLine = this.renderCaption();
				var padding = width * 0.06;
	
				return React.createElement(
					"div",
					{ id: "polaroid", ref: "polaroid", style: { width: width, height: height, padding: padding, backgroundColor: "white", margin: "auto" } },
					React.createElement(
						"div",
						{ className: "inner" },
						image,
						tagLine
					)
				);
			}
		}, {
			key: "placeOwlCenter",
			value: function placeOwlCenter() {
				var owlSize = this.getRefSize(this.refs.avatar);
				var imageSize = this.getRefSize(this.refs.image);
				var owlWMidePoint = owlSize.w / 2.0;
				var owlHMidePoint = owlSize.h / 2.0;
				var imageWMidePoint = imageSize.w / 2.0;
				var imageHMidePoint = imageSize.h / 2.0;
				this.setState({ avatarPos: { top: imageHMidePoint - owlHMidePoint, left: imageWMidePoint - owlHMidePoint } });
			}
		}, {
			key: "getRefSize",
			value: function getRefSize(ref) {
				var width = $(ref).width();
				var height = $(ref).height();
				return { w: width, h: height };
			}
		}, {
			key: "render",
			value: function render() {
				var polaroid = this.renderPolaroid();
				return React.createElement(
					"div",
					{ className: "PhotoBooth", ref: "output", style: { "backgroundColor": "black" } },
					polaroid
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.placeOwlCenter();
			}
		}]);
	
		return PhotoBooth;
	}(React.Component)) || _class);
	;
	
	module.exports = PhotoBooth;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	
	__webpack_require__(3665);
	
	var PurchaseModal = function (_React$Component) {
	    _inherits(PurchaseModal, _React$Component);
	
	    function PurchaseModal(props) {
	        _classCallCheck(this, PurchaseModal);
	
	        var _this = _possibleConstructorReturn(this, (PurchaseModal.__proto__ || Object.getPrototypeOf(PurchaseModal)).call(this));
	
	        autobind(_this);
	        return _this;
	    }
	
	    _createClass(PurchaseModal, [{
	        key: "show",
	        value: function show() {
	            this.props.checkConfirm(true);
	            this.refs.modal.show();
	        }
	    }, {
	        key: "hide",
	        value: function hide() {
	            this.props.checkConfirm(false);
	            this.refs.modal.hide();
	        }
	    }, {
	        key: "renderControls",
	        value: function renderControls() {
	            return React.createElement(
	                "div",
	                { className: "controls" },
	                React.createElement(
	                    "button",
	                    { className: "btn buttonSuccess", onClick: this.props.onPurchase },
	                    "Buy"
	                ),
	                React.createElement(
	                    "a",
	                    { href: "#", onClick: this.hide },
	                    " Cancel "
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var item = this.props.previewItem;
	            if (this.props.isPatch) {
	                var displayItem = this.props.renderPatchItem(item);
	            } else {
	                var displayItem = this.props.renderPerkItem(item);
	            }
	
	            var controls = this.renderControls();
	            var title = "Confirm Purchase";
	            return React.createElement(
	                Modal,
	                { ref: "modal", className: "purchaseModal", headerText: title },
	                React.createElement(
	                    "div",
	                    { className: "modalItem" },
	                    displayItem
	                ),
	                React.createElement(
	                    "div",
	                    { className: "modalItem" },
	                    controls
	                )
	            );
	        }
	    }]);
	
	    return PurchaseModal;
	}(React.Component);
	
	module.exports = PurchaseModal;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var TierRequirementsDisplay = __webpack_require__(390);
	var Tiers = __webpack_require__(108);
	
	__webpack_require__(3668);
	
	var TrophyRoom = function (_React$Component) {
		_inherits(TrophyRoom, _React$Component);
	
		function TrophyRoom(props) {
			_classCallCheck(this, TrophyRoom);
	
			var _this = _possibleConstructorReturn(this, (TrophyRoom.__proto__ || Object.getPrototypeOf(TrophyRoom)).call(this));
	
			autobind(_this);
			_this.state = {
				ownedPatches: [], ownedPerks: [], ownedFurnitures: []
			};
			return _this;
		}
	
		_createClass(TrophyRoom, [{
			key: "render",
			value: function render() {
				var tierRows = _.map(Tiers.REQUIREMENTS, function (tierReqs, currentTier) {
					var tierIconPath = Tiers.getIcon(currentTier);
					var rowBackgroundPath = __webpack_require__(682)("./trophy-shelf-" + currentTier.toString() + ".png");
					var tierReqDisplay = React.createElement(TierRequirementsDisplay, { requirements: tierReqs, tier: currentTier,
						ownedPatches: this.state.ownedPatches, ownedPerks: this.state.ownedPerks,
						ownedFurnitures: this.state.ownedFurnitures, maxSquares: 8, displayAllItems: true });
	
					return React.createElement(
						"div",
						{ className: "row tierRow", key: "tier" + currentTier },
						React.createElement("img", { src: rowBackgroundPath, className: "shelfBackground" }),
						React.createElement(
							"div",
							{ className: "col-sm-1" },
							React.createElement("img", { src: tierIconPath, className: "tierIcon" })
						),
						React.createElement(
							"div",
							{ className: "col-sm-11" },
							tierReqDisplay
						)
					);
				}.bind(this));
	
				var student = this.props.student;
	
				if (student.perks.houses != "") {
					var backgroundPath = __webpack_require__(224)("./" + student.perks.houses.toLowerCase().replace(/ /g, "-").replace("'", "") + "-empty.png");
				}
	
				//var backgroundPath = require("perks/houses/trophy-room-empty.png");
	
				return React.createElement(
					"div",
					{ className: "trophyRoom" },
					React.createElement("img", { src: backgroundPath, className: "modalBackground" }),
					React.createElement(
						"div",
						{ className: "row trophyShelf" },
						React.createElement("div", { className: "col-sm-1" }),
						React.createElement(
							"div",
							{ className: "col-sm-10" },
							tierRows
						),
						React.createElement("div", { className: "col-sm-1" })
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var studentID = this.props.student.id;
				CurrentUser.api().getPatches({ user_id: studentID }, $wr.apiHandler(function (response) {
					var filteredPatches = _.select(response.patches, function (patch) {
						return patch.owned && patch.source == "store";
					});
					this.setState({ ownedPatches: filteredPatches });
				}.bind(this)));
				CurrentUser.api().getPerks({ user_id: studentID }, $wr.apiHandler(function (response) {
					var filteredPerks = _.select(response.perks, function (perk) {
						return perk.owned && perk.source == "store";
					});
					this.setState({ ownedPerks: filteredPerks });
				}.bind(this)));
				CurrentUser.api().getPerks({ furniture_only: true, user_id: studentID }, $wr.apiHandler(function (response) {
					var filteredFurnitures = _.select(response.perks, function (perk) {
						return perk.owned && perk.source == "store";
					});
					this.setState({ ownedFurnitures: filteredFurnitures });
				}.bind(this)));
			}
		}]);
	
		return TrophyRoom;
	}(React.Component);
	
	;
	
	TrophyRoom.propTypes = StrictPropTypes({
		// Subject student's ID
		student: PropTypes.object.isRequired
	});
	
	module.exports = TrophyRoom;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3675);
	
	var BasicSiteHeader = function (_React$Component) {
		_inherits(BasicSiteHeader, _React$Component);
	
		function BasicSiteHeader(props) {
			_classCallCheck(this, BasicSiteHeader);
	
			var _this = _possibleConstructorReturn(this, (BasicSiteHeader.__proto__ || Object.getPrototypeOf(BasicSiteHeader)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(BasicSiteHeader, [{
			key: "logOut",
			value: function logOut(e) {
				$wr.nope(e);
				CurrentUser.logOut();
				window.location = WhooosReadingServices.OuterPages.url("/");
			}
		}, {
			key: "renderUserDropdown",
			value: function renderUserDropdown() {
				if (CurrentUser.isLoaded()) {
					var nameLabel = CurrentUser.get().first_name;
				} else {
					var nameLabel = "...";
				}
				return React.createElement(
					"div",
					{ className: "dropdown" },
					React.createElement(
						"a",
						{ id: "dLabel", role: "button", "data-toggle": "dropdown",
							"aria-haspopup": "true", "aria-expanded": "false" },
						React.createElement(
							"span",
							{ className: "ellipsisText" },
							nameLabel
						),
						React.createElement("span", { className: "caret" })
					),
					React.createElement(
						"ul",
						{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
						React.createElement(
							"li",
							null,
							React.createElement(
								"a",
								{ href: "https://whooosreading.zendesk.com", target: "_blank" },
								"Help"
							)
						),
						React.createElement(
							"li",
							null,
							React.createElement(
								"a",
								{ href: "", onClick: this.logOut },
								"Log Out"
							)
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var rootPath = "/";
				var leftNav = React.createElement(
					"div",
					{ className: "leftNav" },
					React.createElement(
						_reactRouterDom.Link,
						{ to: rootPath, className: "backLink" },
						"Back"
					)
				);
	
				var centerNav = React.createElement(
					"div",
					{ className: "centerNav" },
					React.createElement(
						_reactRouterDom.Link,
						{ to: rootPath, className: "homeLogoLink" },
						React.createElement("img", { src: __webpack_require__(505), className: "wrLogo" })
					)
				);
	
				var rightNav = React.createElement(
					"div",
					{ className: "rightNav" },
					this.renderUserDropdown()
				);
	
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(
						"div",
						{ className: "basicSiteHeader", ref: "header" },
						React.createElement(
							"div",
							{ className: "headerContainer" },
							leftNav,
							centerNav,
							rightNav
						)
					)
				);
			}
		}]);
	
		return BasicSiteHeader;
	}(React.Component);
	
	;
	
	BasicSiteHeader.propTypes = StrictPropTypes({});
	
	module.exports = BasicSiteHeader;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DemoAccountSwitcher = __webpack_require__(201);
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3677);
	
	var ReturnAccountHeader = function (_React$Component) {
		_inherits(ReturnAccountHeader, _React$Component);
	
		function ReturnAccountHeader(props) {
			_classCallCheck(this, ReturnAccountHeader);
	
			var _this = _possibleConstructorReturn(this, (ReturnAccountHeader.__proto__ || Object.getPrototypeOf(ReturnAccountHeader)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ReturnAccountHeader, [{
			key: "returnToAccount",
			value: function returnToAccount(e) {
				$wr.nope(e);
				window.wrNotifications.triggerDropDownNotification({
					title: "Switching back to account", text: "Just a few moments....", icon: "random" }, 10000);
				DemoAccountSwitcher.returnToAccount();
			}
		}, {
			key: "logOut",
			value: function logOut(e) {
				$wr.nope(e);
				CurrentUser.logOut();
				window.location = WhooosReadingServices.OuterPages.url("/");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "container returnAccountHeader" },
					React.createElement(
						"div",
						{ className: "inner" },
						React.createElement(
							"div",
							{ className: "leftSection" },
							React.createElement("img", { src: __webpack_require__(1732), className: "demoImg" }),
							"This is how Whooo's Reading looks for your students. Explore!"
						),
						React.createElement(
							"div",
							{ className: "rightSection" },
							React.createElement(
								"a",
								{ href: "#", onClick: this.returnToAccount },
								"Return to Teacher Account"
							),
							React.createElement("br", null),
							React.createElement(
								"a",
								{ href: "#", onClick: this.logOut },
								"Log Out"
							)
						)
					)
				);
			}
		}]);
	
		return ReturnAccountHeader;
	}(React.Component);
	
	;
	
	ReturnAccountHeader.propTypes = StrictPropTypes({});
	
	module.exports = ReturnAccountHeader;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhooosReadingServices = __webpack_require__(25);
	var ContactModal = __webpack_require__(860);
	var CurrentUser = __webpack_require__(3);
	
	var HelpCenterLink = __webpack_require__(861);
	
	__webpack_require__(3678);
	
	var SiteFooter = function (_React$Component) {
		_inherits(SiteFooter, _React$Component);
	
		function SiteFooter(props) {
			_classCallCheck(this, SiteFooter);
	
			var _this = _possibleConstructorReturn(this, (SiteFooter.__proto__ || Object.getPrototypeOf(SiteFooter)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(SiteFooter, [{
			key: "onClick",
			value: function onClick(e) {
				$wr.nope(e);
				this.refs.modal.show();
			}
		}, {
			key: "getHiddenInfo",
			value: function getHiddenInfo() {
				if (CurrentUser.isLoaded()) {
					var user = CurrentUser.get();
					var infoLine = "ID: " + user.id + " | CreatedAt: " + user.created_at;
					infoLine += " | Product: " + user.product + " | Role: " + user.role;
					if (user.demo) {
						infoLine += " | Demo: " + user.demo;
					}
					return infoLine;
				} else {
					return "CurrentUser Not Loaded";
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (CurrentUser.isLoaded() && !CurrentUser.isStudent()) {
					var contactLink = React.createElement(
						"p",
						null,
						React.createElement(
							"a",
							{ href: "#", onClick: this.onClick, className: "footerLink" },
							"Contact"
						)
					);
					var helpCenter = React.createElement(HelpCenterLink, null);
				}
	
				return React.createElement(
					"footer",
					{ className: "clearfix siteFooter hideOnPrint" },
					React.createElement(
						"div",
						{ className: "container" },
						React.createElement(
							"div",
							{ className: "navigationArea clearfix" },
							React.createElement(
								"div",
								{ className: "faviconColumn" },
								React.createElement(
									"p",
									{ className: "faviconP" },
									React.createElement("img", { src: __webpack_require__(504), className: "favicon" })
								)
							),
							React.createElement(
								"div",
								{ className: "linkColumn" },
								React.createElement(
									"p",
									{ className: "footerColumnLabel" },
									"About"
								),
								React.createElement(
									"p",
									null,
									React.createElement(
										"a",
										{ href: WhooosReadingServices.OuterPages.url("/teachers"),
											className: "footerLink" },
										"Teachers"
									)
								),
								React.createElement(
									"p",
									null,
									React.createElement(
										"a",
										{ href: WhooosReadingServices.OuterPages.url("/schools"),
											className: "footerLink" },
										"Schools"
									)
								),
								React.createElement(
									"p",
									null,
									React.createElement(
										"a",
										{ href: WhooosReadingServices.OuterPages.url("/about_us"),
											className: "footerLink" },
										"Company"
									)
								)
							),
							React.createElement(
								"div",
								{ className: "linkColumn" },
								React.createElement(
									"p",
									{ className: "footerColumnLabel" },
									"Support"
								),
								React.createElement(
									"p",
									null,
									React.createElement(
										"a",
										{ href: "https://whooosreading.zendesk.com/hc", className: "footerLink" },
										"Help"
									)
								),
								contactLink
							)
						),
						React.createElement(
							"div",
							{ className: "row" },
							React.createElement(
								"div",
								{ className: "col-sm-12" },
								React.createElement(
									"p",
									{ className: "legal" },
									"(c) ",
									new Date().getFullYear(),
									" Whooo's Reading | ",
									" ",
									React.createElement(
										"a",
										{ href: WhooosReadingServices.OuterPages.url("/terms"),
											className: "legalLink" },
										"Terms"
									),
									" | ",
									" ",
									React.createElement(
										"a",
										{ href: WhooosReadingServices.OuterPages.url("/privacy"),
											className: "legalLink" },
										"Privacy"
									)
								),
								React.createElement(
									"p",
									{ className: "hiddenInfo" },
									this.getHiddenInfo()
								)
							)
						)
					),
					React.createElement(ContactModal, { ref: "modal" }),
					helpCenter
				);
			}
		}]);
	
		return SiteFooter;
	}(React.Component);
	
	;
	
	SiteFooter.propTypes = StrictPropTypes({});
	
	module.exports = SiteFooter;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataRouting = __webpack_require__(36);
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var TopBarWarning = __webpack_require__(787);
	var CoinsNotificationContainer = __webpack_require__(795);
	var SocialNotificationContainer = __webpack_require__(802);
	var SiteBanner = __webpack_require__(800);
	var StudentAvatar = __webpack_require__(35);
	var Features = __webpack_require__(16);
	var ImageIcon = __webpack_require__(102);
	var AccountPlans = __webpack_require__(53);
	
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3679);
	
	function selectStudentLists(state) {
		return CurrentUser.isAdmin() ? RosterSelectors.studentLists({ state: state }) : [];
	}
	
	var SiteHeader = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = { studentLists: selectStudentLists(state) };
	
		if (CurrentUser.isPassphraseUser()) {
			downProps.rootPath = "/class_access?passphrase=" + CurrentUser.get().passphrase;
		} else {
			downProps.rootPath = "/";
		}
	
		return downProps;
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(SiteHeader, _React$Component);
	
		function SiteHeader(props) {
			_classCallCheck(this, SiteHeader);
	
			var _this = _possibleConstructorReturn(this, (SiteHeader.__proto__ || Object.getPrototypeOf(SiteHeader)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(SiteHeader, [{
			key: "logOut",
			value: function logOut(e) {
				$wr.nope(e);
				CurrentUser.logOut();
				window.location = WhooosReadingServices.OuterPages.url("/");
			}
		}, {
			key: "renderHomeLink",
			value: function renderHomeLink() {
				if (CurrentUser.isSponsor()) {
					var homeLink = React.createElement(
						"span",
						{ className: "logoBox" },
						React.createElement("img", { src: __webpack_require__(219), className: "wrLogo" })
					);
				} else {
					var homeLink = React.createElement(
						_reactRouterDom.Link,
						{ to: this.props.rootPath, className: "logoBox" },
						React.createElement("img", { src: __webpack_require__(219), className: "wrLogo" })
					);
				}
				return homeLink;
			}
		}, {
			key: "renderLoadingHeader",
			value: function renderLoadingHeader() {
				var headerClassName = "";
	
				var leftNav = React.createElement(
					"div",
					{ className: "leftNav" },
					React.createElement("span", null)
				);
	
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/login/", className: "loginButton" },
						"Log In"
					)
				);
				var homeLink = React.createElement(
					_reactRouterDom.Link,
					{ to: this.props.rootPath, className: "logoBox" },
					React.createElement("img", { src: __webpack_require__(219), className: "wrLogo" })
				);
				// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", className: headerClassName, ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							leftNav,
							homeLink,
							rightNavContainer
						)
					)
				);
			}
		}, {
			key: "renderPendingSSOUserHeader",
			value: function renderPendingSSOUserHeader() {
				var currentUser = CurrentUser.get();
				var homeLink = this.renderHomeLink();
	
				var dropdownLowerLinks = React.createElement(
					"div",
					null,
					React.createElement(
						"li",
						null,
						React.createElement(
							"a",
							{ href: "https://whooosreading.zendesk.com/hc", target: "_blank" },
							"Help"
						)
					),
					React.createElement(
						"li",
						{ onClick: this.logOut },
						React.createElement(
							"a",
							{ href: "" },
							"Log Out"
						)
					)
				);
	
				var nameLine = currentUser.first_name;
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					React.createElement(
						"div",
						{ className: "dropdown" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								nameLine
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							dropdownLowerLinks
						)
					)
				);
				// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							homeLink,
							rightNavContainer
						)
					)
				);
			}
		}, {
			key: "renderStudentHeader",
			value: function renderStudentHeader() {
				var headerClassName = "studentHeader";
				var currentUser = CurrentUser.get();
				if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
					var socialNotifications = React.createElement(
						"span",
						null,
						React.createElement(SocialNotificationContainer, null)
					);
				}
	
				var rightShopLink = React.createElement(
					"div",
					{ className: "owlShopContainer right" },
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/owl_shop" },
						React.createElement(StudentAvatar, { student: currentUser, maxWidth: 30, disableSound: true, disableAnimation: true }),
						React.createElement(
							"span",
							null,
							"Shop"
						)
					)
				);
	
				if (currentUser.display_class_shelf) {
					var classPagePath = "/student_lists/default/shelf";
				} else {
					var classPagePath = "/student_lists/default/tree";
				}
	
				var leftNav = React.createElement(
					"div",
					{ className: "leftNav" },
					React.createElement(
						"div",
						{ className: "myShelfContainer" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/my/shelf" },
							React.createElement("img", { src: __webpack_require__(524) }),
							React.createElement(
								"span",
								null,
								"My Shelf"
							)
						)
					),
					React.createElement(
						"div",
						{ className: "myClassNavContainer" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: classPagePath },
							React.createElement("img", { src: __webpack_require__(525) }),
							React.createElement(
								"span",
								null,
								"Class"
							)
						)
					),
					React.createElement(
						"div",
						{ className: "mySchoolNavContainer" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/contests" },
							React.createElement(ImageIcon, { icon: "school" }),
							React.createElement(
								"span",
								null,
								"School"
							)
						)
					)
				);
				var dropdownTopLinks = React.createElement(
					"div",
					null,
					React.createElement(
						"li",
						null,
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/" },
							"My Home Page"
						)
					)
				);
	
				var dropdownLowerLinks = React.createElement(
					"div",
					{ onClick: this.logOut },
					React.createElement(
						"li",
						null,
						React.createElement(
							"a",
							{ className: "logOutLink", href: "" },
							"Log Out"
						)
					)
				);
	
				var rightNavContent = React.createElement(
					"div",
					{ className: "rightNavContent" },
					rightShopLink,
					React.createElement(CoinsNotificationContainer, null),
					socialNotifications,
					React.createElement("div", { className: "verticalDivider" })
				);
	
				var nameLine = currentUser.first_name;
				if (dropdownTopLinks && dropdownLowerLinks) {
					var dropdownDivider = React.createElement("div", { className: "dropdownDivider" });
				}
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					rightNavContent,
					React.createElement(
						"div",
						{ className: "dropdown" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								nameLine
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							dropdownTopLinks,
							dropdownDivider,
							dropdownLowerLinks
						)
					)
				);
	
				var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function (alert) {
					return alert.type == "SiteBanner";
				});
	
				if (siteBannerAlerts.length > 0) {
					var siteBannerContent = React.createElement(SiteBanner, { alerts: siteBannerAlerts });
				}
	
				var homeLink = this.renderHomeLink();
	
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", className: headerClassName, ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							leftNav,
							homeLink,
							rightNavContainer
						)
					),
					siteBannerContent
				);
			}
		}, {
			key: "renderAdminHeader",
			value: function renderAdminHeader() {
				var headerClassName = "adminHeader";
				var currentUser = CurrentUser.get();
	
				var homeLink = this.renderHomeLink();
	
				var dropdownLowerLinks = React.createElement(
					"div",
					null,
					React.createElement(
						"li",
						null,
						React.createElement(
							"a",
							{ href: "https://whooosreading.zendesk.com/hc", target: "_blank" },
							"Help"
						)
					),
					React.createElement(
						"li",
						{ onClick: this.logOut },
						React.createElement(
							"a",
							{ href: "" },
							"Log Out"
						)
					)
				);
	
				var dataLink = React.createElement(
					_reactRouterDom.Link,
					{ to: "/data", className: "dataLink" },
					"Data"
				);
	
				var newLabel = React.createElement(
					"span",
					{ className: "navStatus badge" },
					"New!"
				);
				var insightsLink = React.createElement(
					"span",
					null,
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/insights", className: "insightsLink" },
						"Insights"
					),
					newLabel
				);
	
				if (CurrentUser.isTeacherAdmin()) {
					if (CurrentUser.isPremiumOrTrialAccount()) {
						var dropdownTopLinks = React.createElement(
							"div",
							null,
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/settings/information" },
									"Settings"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/questions" },
									"Question Search"
								)
							)
						);
					} else {
						var dropdownTopLinks = React.createElement(
							"div",
							null,
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/settings/information" },
									"Settings"
								)
							)
						);
					}
	
					if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						var exercisesLink = React.createElement(
							_reactRouterDom.Link,
							{ to: "/activities/exercises", className: "insightsLink" },
							"Activities"
						);
					} else {
						var exercisesLink = React.createElement(
							_reactRouterDom.Link,
							{ to: "/activities/teacher-picks", className: "insightsLink" },
							"Picks"
						);
					}
	
					var leftNav = React.createElement(
						"div",
						{ className: "leftNav", id: "adminLeftNav" },
						dataLink,
						exercisesLink,
						insightsLink
					);
	
					var socialNotifications = null;
	
					var rightNavContent = React.createElement(
						"div",
						{ className: "rightNavContent" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/contests", className: "rightNavLink" },
							"School"
						),
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/roster", className: "rightNavLink" },
							"Roster"
						),
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/student_lists/default/shelf", className: "rightNavLink" },
							"Shelves"
						),
						socialNotifications
					);
				} else {
					var leftNav = React.createElement(
						"div",
						{ className: "leftNav", id: "adminLeftNav" },
						dataLink,
						insightsLink
					);
	
					if (CurrentUser.isDistrictAdmin()) {
						var schoolText = "Schools";
					} else {
						var schoolText = "School";
					}
	
					var rightNavContent = React.createElement(
						"div",
						{ className: "rightNavContent" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/contests", className: "rightNavLink" },
							schoolText
						),
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/roster", className: "rightNavLink" },
							"Roster"
						)
					);
	
					var dropdownTopLinks = React.createElement(
						"div",
						null,
						React.createElement(
							"li",
							null,
							React.createElement(
								_reactRouterDom.Link,
								{ to: "/settings/information" },
								"Settings"
							)
						)
					);
				}
	
				if (dropdownTopLinks && dropdownLowerLinks) {
					var dropdownDivider = React.createElement("div", { className: "dropdownDivider" });
				}
	
				var nameLine = currentUser.first_name;
	
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					rightNavContent,
					React.createElement(
						"div",
						{ className: "dropdown" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								currentUser.first_name
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							dropdownTopLinks,
							dropdownDivider,
							dropdownLowerLinks
						)
					)
				);
	
				var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function (alert) {
					return alert.type == "SiteBanner";
				});
	
				if (siteBannerAlerts.length > 0) {
					var siteBannerContent = React.createElement(SiteBanner, { alerts: siteBannerAlerts });
				}
	
				// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", className: headerClassName, ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							leftNav,
							homeLink,
							rightNavContainer
						)
					),
					siteBannerContent
				);
			}
		}, {
			key: "renderWizardHeader",
			value: function renderWizardHeader() {
				var currentUser = CurrentUser.get();
				var nameLine = currentUser.first_name;
				var dropdownLowerLinks = React.createElement(
					"div",
					null,
					React.createElement(
						"li",
						{ onClick: this.logOut },
						React.createElement(
							"a",
							{ className: "logOutLink", href: "" },
							"Log Out"
						)
					)
				);
				var leftNav = React.createElement(
					"div",
					{ className: "leftNav" },
					React.createElement(
						"div",
						{ className: "dropdown wizLink" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								"User Tools"
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/users/search", className: "wizLink" },
									"Power Drill"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/merge_students", className: "wizLink" },
									"Merge Students"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/digests_page", className: "wizLink" },
									"Digests Page"
								)
							)
						)
					),
					React.createElement(
						"div",
						{ className: "dropdown wizLink" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								"CRM Tools"
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/new_deal?contact_id=???" },
									"New Deal"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/new_quotes?deal_id=???" },
									"New Quotes"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/received?deal_id=???" },
									"PO/Payment Accepted"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/upgrade_tokens" },
									"Upgrade Tokens"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/discount_tokens" },
									"Discount Tokens"
								)
							),
							React.createElement(
								"li",
								null,
								React.createElement(
									_reactRouterDom.Link,
									{ to: "/deal_transforms?deal_id=???" },
									"Deal Transforms"
								)
							)
						)
					)
				);
	
				var rightNavContent = React.createElement(
					"div",
					{ className: "rightNavContent" },
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/school_orgs", className: "rightNavLink" },
						"School Orgs"
					),
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/district_orgs", className: "rightNavLink" },
						"District Orgs"
					)
				);
	
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					rightNavContent,
					React.createElement(
						"div",
						{ className: "dropdown" },
						React.createElement(
							"a",
							{ id: "dLabel", role: "button",
								"data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
							React.createElement(
								"span",
								{ className: "ellipsisText" },
								nameLine
							),
							React.createElement("span", { className: "caret" })
						),
						React.createElement(
							"ul",
							{ className: "dropdown-menu", "aria-labelledby": "dLabel" },
							dropdownLowerLinks
						)
					)
				);
	
				var homeLink = this.renderHomeLink();
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", className: "", ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							leftNav,
							homeLink,
							rightNavContainer
						)
					)
				);
			}
		}, {
			key: "renderSponsorHeader",
			value: function renderSponsorHeader() {
				var homeLink = this.renderHomeLink();
	
				// Make it an <a>, not a <Link> so the page is forced to reload
				var rightNavContainer = React.createElement(
					"div",
					{ className: "rightNav" },
					React.createElement(
						"a",
						{ href: "/login", className: "loginButton" },
						"Log In As Student"
					)
				);
	
				var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function (alert) {
					return alert.type == "SiteBanner";
				});
	
				if (siteBannerAlerts.length > 0) {
					var siteBannerContent = React.createElement(SiteBanner, { alerts: siteBannerAlerts });
				}
	
				return React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(TopBarWarning, null),
					React.createElement("div", { id: "siteHeaderPlaceholder", ref: "placeholder", style: { display: "none" } }),
					React.createElement(
						"div",
						{ id: "siteHeader", ref: "header" },
						React.createElement(
							"div",
							{ className: "container" },
							homeLink,
							rightNavContainer
						)
					),
					siteBannerContent
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (CurrentUser.isLoaded()) {
					if (CurrentUser.isPendingSSOUser()) {
						return this.renderPendingSSOUserHeader();
					} else if (CurrentUser.isStudent()) {
						return this.renderStudentHeader();
					} else if (CurrentUser.isAdmin()) {
						return this.renderAdminHeader();
					} else if (CurrentUser.isWizard()) {
						return this.renderWizardHeader();
					} else if (CurrentUser.isSponsor()) {
						return this.renderSponsorHeader();
					}
				} else {
					return this.renderLoadingHeader();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				var $navbar = $(this.refs.header),
				    $placeholder = $(this.refs.placeholder),
				    y_pos = $navbar.offset().top,
				    height = $navbar.height();
	
				$(document).scroll(function () {
					var scrollTop = $(this).scrollTop();
	
					if (scrollTop + 20 > y_pos + height) {
						if (!$navbar.hasClass('headerFixed')) {
							$navbar.addClass("headerFixed").animate({
								top: 0
							});
							$placeholder.show();
						};
					} else if (scrollTop <= y_pos) {
						if ($navbar.hasClass('headerFixed')) {
							$navbar.removeClass("headerFixed").animate({
								top: "-54px"
							}, 0);
							$placeholder.hide();
						};
					}
				});
	
				$(document).on("current-user-updated", function () {
					_this2.forceUpdate();
				});
			}
		}]);
	
		return SiteHeader;
	}(React.Component)) || _class);
	;
	
	SiteHeader.INFORMATION_VIEW = "information";
	SiteHeader.PREFERENCES_VIEW = "preferences";
	SiteHeader.STANDARDS_VIEW = "standards";
	SiteHeader.GOALS_VIEW = "goals";
	
	SiteHeader.propTypes = StrictPropTypes({
		studentLists: PropTypes.array
	});
	
	module.exports = SiteHeader;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3680);
	
	var TopBarWarning = function TopBarWarning(props) {
		if ($wr.isInternetExplorer()) {
			var ieWarning = React.createElement(
				"div",
				{ className: "ieWarning" },
				React.createElement(
					"strong",
					null,
					"We noticed you're using Internet Explorer."
				),
				" Some parts of Whooo's Reading don't work on Internet Explorer. We recommend using either",
				" ",
				React.createElement(
					"a",
					{ href: "https://www.google.com/chrome/" },
					"Google Chrome"
				),
				" or",
				" ",
				React.createElement(
					"a",
					{ href: "https://www.mozilla.org/en-US/firefox/products/" },
					"Mozilla Firefox"
				),
				"."
			);
		}
	
		return React.createElement(
			"div",
			{ className: "topBarWarning" },
			ieWarning
		);
	};
	
	TopBarWarning.propTypes = StrictPropTypes({});
	
	module.exports = TopBarWarning;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var NotificationContainer = __webpack_require__(798);
	var PendingTaskNotice = __webpack_require__(161);
	var L2eSound = __webpack_require__(934);
	
	var PaywallModal = __webpack_require__(44);
	var ResponseModal = __webpack_require__(175);
	
	var UISelectors = __webpack_require__(1015);
	var UIActions = __webpack_require__(41);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3681);
	
	var UniversalControls = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			expandedResponseID: UISelectors.expandedResponseID({ state: state }),
			showPaywall: UISelectors.showPaywall({ state: state })
		};
	}, function (dispatch, props) {
		return {
			resetExpandedResponse: function resetExpandedResponse() {
				return dispatch(UIActions.toggleExpandedResponse({ responseID: null, expanded: false }));
			},
			resetPaywall: function resetPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: null }));
			},
			bustRosterCache: function bustRosterCache() {
				return dispatch(RosterActions.invalidateStudentListCache({}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(UniversalControls, _React$Component);
	
		function UniversalControls(props) {
			_classCallCheck(this, UniversalControls);
	
			var _this = _possibleConstructorReturn(this, (UniversalControls.__proto__ || Object.getPrototypeOf(UniversalControls)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(UniversalControls, [{
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				var _this2 = this;
	
				// This hacky and not a great way to do this at all
				if (this.props.expandedResponseID && !prevProps.expandedResponseID) {
					setTimeout(function () {
						_this2.refs.responseModal.show();
					}, 50);
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (CurrentUser.isSignedIn() && CurrentUser.isTeacherAdmin()) {
					var feedbackEmail = "teacherfeedback@whooosreading.org";
					var feedbackBanner = React.createElement(
						"div",
						{ className: "feedbackBar" },
						React.createElement(
							"a",
							{ className: "feedbackEmail", href: "https://whooosreading.zendesk.com/hc/en-us/requests/new",
								target: "_blank" },
							"Have feedback for us?"
						)
					);
				} else if (CurrentUser.isSponsor()) {
					var feedbackBanner = React.createElement(
						"div",
						{ className: "feedbackBar" },
						React.createElement(
							"a",
							{ className: "feedbackEmail", href: "https://whooosreading.zendesk.com/hc/en-us/requests/new",
								target: "_blank" },
							"Have feedback for us?"
						)
					);
				}
	
				var responseID = this.props.expandedResponseID;
				if (responseID) {
					var responseModal = React.createElement(ResponseModal, { ref: "responseModal", responseID: responseID,
						onHide: this.props.resetExpandedResponse, key: responseID });
				}
	
				var showPaywall = this.props.showPaywall;
				if (showPaywall) {
					var paywallModal = React.createElement(PaywallModal, { selfOpen: true, onHide: this.props.resetPaywall,
						featureType: showPaywall, key: showPaywall });
				}
	
				return React.createElement(
					"div",
					{ id: "universalControls" },
					React.createElement(L2eSound, null),
					React.createElement(NotificationContainer, null),
					React.createElement(PendingTaskNotice, null),
					responseModal,
					paywallModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(document).on("current-user-updated", function () {
					this.forceUpdate();
				}.bind(this));
			}
		}]);
	
		return UniversalControls;
	}(React.Component)) || _class);
	;
	
	UniversalControls.propTypes = StrictPropTypes({
		expandedResponseID: PropTypes.number,
		showPaywall: PropTypes.string,
		resetExpandedResponse: PropTypes.func,
		bustRosterCache: PropTypes.func
	});
	
	module.exports = UniversalControls;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var ValidatingInput = __webpack_require__(91);
	var WhooosReadingClientApi = __webpack_require__(124);
	
	__webpack_require__(3682);
	
	var ForgotPasswordPage = function (_React$Component) {
		_inherits(ForgotPasswordPage, _React$Component);
	
		function ForgotPasswordPage(props) {
			_classCallCheck(this, ForgotPasswordPage);
	
			var _this = _possibleConstructorReturn(this, (ForgotPasswordPage.__proto__ || Object.getPrototypeOf(ForgotPasswordPage)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, expandMessage: false
			};
			return _this;
		}
	
		_createClass(ForgotPasswordPage, [{
			key: "validateForm",
			value: function validateForm() {
				return this.refs.usernameEmail.validate();
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				$wr.nope(e);
				if (!this.validateForm()) {
					return;
				}
	
				var username = this.refs.usernameEmail.val();
				var client = new WhooosReadingClientApi.LegacyClient();
				this.setState({ loading: true });
	
				client.postPasswordResets({ username: username }, function (response) {
					var resetData = response.password_reset;
					if (resetData.errors && resetData.errors.length > 0) {
						window.wrNotifications.triggerDropDownNotification({
							text: resetData.errors.join(", "),
							icon: "exclamation-sign", type: "error" }, 6000);
	
						this.setState({ loading: false });
					} else {
						window.wrNotifications.triggerDropDownNotification({
							title: "Sent!", text: "Check your inbox for instructions to reset your password.",
							icon: "envelope" }, 6000);
	
						$wr.redirect("/login");
					}
				}.bind(this));
			}
		}, {
			key: "onFieldFocus",
			value: function onFieldFocus() {
				this.setState({ expandMessage: true });
			}
		}, {
			key: "onFieldBlur",
			value: function onFieldBlur() {
				this.setState({ expandMessage: false });
			}
		}, {
			key: "render",
			value: function render() {
				var messageHeight = this.state.expandMessage ? 20 : 0;
	
				return React.createElement(
					"div",
					{ className: "forgotPasswordPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Forgot your Password?"
						)
					),
					React.createElement("img", { src: __webpack_require__(1738), className: "forgotOwl" }),
					React.createElement(
						"form",
						{ onSubmit: this.onSubmit, className: "resetForm" },
						React.createElement(
							"p",
							null,
							"Enter your username below and we will email you instructions to reset your password."
						),
						React.createElement(
							"label",
							{ htmlFor: "usernameEmail" },
							"Enter Your Username"
						),
						React.createElement(ValidatingInput, { type: "text", ref: "usernameEmail",
							validators: ValidatingInput.Validators.PRESENT,
							inputClassName: "form-control usernameEmail",
							onFocus: this.onFieldFocus, onBlur: this.onFieldBlur }),
						React.createElement(
							"div",
							{ className: "resetMessage", style: { height: messageHeight } },
							"We'll email you a link to reset your password"
						),
						React.createElement(
							"div",
							{ className: "btnLine" },
							React.createElement(LoadingButton, { text: "Request Reset", loading: this.state.loading,
								className: "btn buttonPrimary" }),
							React.createElement(
								_reactRouterDom.Link,
								{ to: "/login", className: "btn btn-link" },
								"Back to login"
							)
						),
						React.createElement(
							"p",
							null,
							"If you cannot remember your username, reply to any email sent to you from Whooo's Reading, and we will help you reset your password."
						)
					)
				);
			}
		}]);
	
		return ForgotPasswordPage;
	}(React.Component);
	
	;
	
	ForgotPasswordPage.propTypes = PageStrictPropTypes({});
	
	module.exports = ForgotPasswordPage;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var WhooosReadingServices = __webpack_require__(25);
	
	var GoogleSignin = function (_React$Component) {
		_inherits(GoogleSignin, _React$Component);
	
		function GoogleSignin(props) {
			_classCallCheck(this, GoogleSignin);
	
			var _this = _possibleConstructorReturn(this, (GoogleSignin.__proto__ || Object.getPrototypeOf(GoogleSignin)).call(this));
	
			autobind(_this);
			_this.state = {
				dependenciesLoaded: false
			};
			return _this;
		}
	
		_createClass(GoogleSignin, [{
			key: "render",
			value: function render() {
				if (this.state.dependenciesLoaded) {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"div",
							{ className: "g-signin2-alt", id: "gSignin", ref: "signinBox",
								"data-onsuccess": "onSignIn", "data-height": "30" },
							"Sign In"
						),
						React.createElement(
							"button",
							{ className: "googleBtn buttonDefault", type: "button" },
							React.createElement("img", { src: __webpack_require__(512) }),
							" ",
							"Log in with Google"
						)
					);
				} else {
					return React.createElement(Spinner, { placeholder: true });
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$wr.loadScript("https://apis.google.com/js/client.js", "gapi", function () {
					this.setState({ dependenciesLoaded: true }, this.initGoogleSync);
				}.bind(this));
			}
		}, {
			key: "initGoogleSync",
			value: function initGoogleSync() {
				var googleUser = {};
				var auth2;
	
				gapi.load('auth2', function () {
					auth2 = gapi.auth2.init({
						client_id: '685312089971-sq3b4ov7s8e1c8774hakb0tq5i8v9l6q.apps.googleusercontent.com',
						cookiepolicy: 'single_host_origin',
						scope: "profile"
					});
	
					var options = new gapi.auth2.SigninOptionsBuilder();
					options.setPrompt('select_account');
	
					auth2.attachClickHandler(this.refs.signinBox, {}, function (googleUser) {
						var profile = googleUser.getBasicProfile();
						var id_token = googleUser.getAuthResponse().id_token;
						var ssoURL = WhooosReadingServices.SsoServer.url("/google", { id_token: id_token });
						location.href = ssoURL;
					}, function (error) {
						alert(JSON.stringify(error, undefined, 2));
					});
				}.bind(this));
			}
		}]);
	
		return GoogleSignin;
	}(React.Component);
	
	;
	
	GoogleSignin.propTypes = StrictPropTypes({});
	
	module.exports = GoogleSignin;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var GoogleSignIn = __webpack_require__(790);
	var ErrorDisplay = __webpack_require__(51);
	var LoadingButton = __webpack_require__(17);
	var Router = __webpack_require__(153);
	var WhooosReadingServices = __webpack_require__(25);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3683);
	
	var LoginPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			fetchOrgData: function fetchOrgData() {
				return dispatch(RosterActions.fetchOrgData({}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(LoginPage, _React$Component);
	
		function LoginPage(props) {
			_classCallCheck(this, LoginPage);
	
			var _this = _possibleConstructorReturn(this, (LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false
			};
			return _this;
		}
	
		_createClass(LoginPage, [{
			key: "onSubmit",
			value: function onSubmit(e) {
				$wr.nope(e);
				this.refs.errors.reset();
	
				var username = this.refs.username.value;
				var password = this.refs.password.value;
	
				if (username.toLowerCase().trim().startsWith("wr.")) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Redirecting...",
						text: "Please log in on the Whooo's Reading homepage.",
						icon: "asterisk"
					}, 4000);
	
					setTimeout(function () {
						window.location.href = WhooosReadingServices.OuterPages.url("/");
					}, 4000);
	
					return;
				}
	
				this.setState({ loading: true });
				CurrentUser.usernamePasswordAuthenticate(username, password, function (success, errorText) {
					if (success) {
						this.props.fetchOrgData().then(function () {
							$wr.redirect('/');
						});
					} else {
						this.setState({ loading: false });
						this.refs.errors.setError(errorText);
					}
				}.bind(this));
			}
		}, {
			key: "render",
			value: function render() {
				if (!($wr.isInternetExplorer() || $wr.isAppdev())) {
					var googleSignIn = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "text-center" },
							"Or"
						),
						React.createElement(GoogleSignIn, null)
					);
				}
	
				if (!$wr.isAppdev()) {
					var forgotPassword = React.createElement(
						"p",
						{ className: "loginLinks" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/forgot_password" },
							"Forgot your password?"
						)
					);
					var owlPath = __webpack_require__(523);
					var owlCaption = "Owls are reading a lot these days!";
				} else {
					var owlPath = __webpack_require__(522);
					var owlCaption = "Owls are doing magic a lot these days!";
				}
	
				return React.createElement(
					"div",
					{ className: "loginPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Log In"
						)
					),
					React.createElement(
						"div",
						{ className: "col-sm-5" },
						React.createElement(
							"form",
							{ id: "loginForm", onSubmit: this.onSubmit },
							React.createElement(ErrorDisplay, { ref: "errors" }),
							React.createElement(
								"div",
								{ className: "form-group" },
								React.createElement("input", { type: "text", ref: "username", className: "form-control", placeholder: "Username or email" })
							),
							React.createElement(
								"div",
								{ className: "form-group" },
								React.createElement("input", { type: "password", ref: "password", className: "form-control", placeholder: "Password" })
							),
							forgotPassword,
							React.createElement(LoadingButton, { className: "buttonPrimary", text: "Log in!", loading: this.state.loading }),
							googleSignIn
						)
					),
					React.createElement(
						"div",
						{ className: "col-sm-7 loginImgSection" },
						React.createElement("img", { src: owlPath, className: "img-responsive wiseOwlsImg" }),
						React.createElement(
							"p",
							{ className: "imgCaption" },
							owlCaption
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if ($wr.getURLParameterByName("suspended") == "true") {
					this.refs.errors.setError("Your account is currently disabled. Please contact your account administrator.");
				} else if ($wr.getURLParameterByName("existing_google_account") == "true") {
					this.refs.errors.setError("You already have a Whooo's Reading account tied to your Google account. Click the 'Log in with Google' button below to log in.");
				} else if ($wr.getURLParameterByName("unsynced_google_account") == "true") {
					this.refs.errors.setError("There is no Whooo's Reading account tied to this Google account. Try another login method, or return to the Whooo's Reading homepage to sign up (teachers only).");
				} else if ($wr.getURLParameterByName("unsynced_clever_account") == "true") {
					this.refs.errors.setError("Your teacher hasn't synced your account with Clever yet. Ask your teacher to finish syncing or to contact Whooo's Reading support.");
				}
			}
		}]);
	
		return LoginPage;
	}(React.Component)) || _class);
	;
	
	LoginPage.WrappedComponent.propTypes = PageStrictPropTypes({
		fetchRosterData: PropTypes.func
	});
	
	module.exports = LoginPage;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var WhooosReadingClientApi = __webpack_require__(124);
	var ValidatingInput = __webpack_require__(91);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3684);
	
	var ResetPasswordPage = function (_React$Component) {
		_inherits(ResetPasswordPage, _React$Component);
	
		function ResetPasswordPage(props) {
			_classCallCheck(this, ResetPasswordPage);
	
			var _this = _possibleConstructorReturn(this, (ResetPasswordPage.__proto__ || Object.getPrototypeOf(ResetPasswordPage)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false
			};
			return _this;
		}
	
		_createClass(ResetPasswordPage, [{
			key: "getUserID",
			value: function getUserID() {
				return $wr.getURLParameterByName("user_id");
			}
		}, {
			key: "getResetToken",
			value: function getResetToken() {
				return $wr.getURLParameterByName("token");
			}
		}, {
			key: "validateForm",
			value: function validateForm() {
				return this.refs.password.validate() & this.refs.passwordConfirmation.validate();
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				$wr.nope(e);
				if (!this.validateForm()) {
					return;
				}
	
				var client = new WhooosReadingClientApi.LegacyClient();
				this.setState({ loading: true });
				var params = {
					user_id: this.getUserID(),
					token: this.getResetToken(),
					password_reset: {
						password: this.refs.password.val(),
						password_confirmation: this.refs.passwordConfirmation.val()
					}
				};
				client.postPasswordResets(params, function (response) {
					var resetData = response.password_reset;
					if (resetData.errors && resetData.errors.length > 0) {
						window.wrNotifications.triggerDropDownNotification({
							text: resetData.errors.join(", "),
							icon: "exclamation-sign", type: "error" }, 6000);
	
						this.setState({ loading: false });
					} else {
						window.wrNotifications.triggerDropDownNotification({
							title: "Reset!", text: "Your password has been reset. Now, please log in.",
							icon: "ok-sign" }, 6000);
	
						if (CurrentUser.isSignedIn()) {
							CurrentUser.logOut();
						}
						$wr.redirect("/login");
					}
				}.bind(this));
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "resetPasswordPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Change Password"
						)
					),
					React.createElement(
						"form",
						{ onSubmit: this.onSubmit, className: "resetForm" },
						React.createElement(
							"label",
							{ htmlFor: "password" },
							"Password"
						),
						React.createElement(ValidatingInput, { type: "password", ref: "password",
							validators: ValidatingInput.Validators.PRESENT,
							inputClassName: "form-control password",
							defaultSubText: "At least 6 characters" }),
						React.createElement(
							"label",
							{ htmlFor: "passwordConfirmation" },
							"Password confirmation"
						),
						React.createElement(ValidatingInput, { type: "password", ref: "passwordConfirmation",
							validators: ValidatingInput.Validators.PRESENT,
							inputClassName: "form-control password" }),
						React.createElement(
							"div",
							{ className: "btnLine" },
							React.createElement(LoadingButton, { text: "Reset Password", loading: this.state.loading,
								className: "btn buttonPrimary" })
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var client = new WhooosReadingClientApi.LegacyClient();
				var params = { user_id: this.getUserID(), token: this.getResetToken() };
	
				client.getPasswordResets(params, function (response) {
					var resets = response.password_resets;
					if (resets == undefined || resets.length == 0) {
						window.wrNotifications.triggerDropDownNotification({
							text: "Your reset link has expired!", icon: "exclamation-sign", type: "error" });
	
						$wr.redirect("/login");
					}
				}.bind(this));
			}
		}]);
	
		return ResetPasswordPage;
	}(React.Component);
	
	;
	
	ResetPasswordPage.propTypes = PageStrictPropTypes({
		// location has query, query has "user_id" and "token"
		query: PropTypes.object
	});
	
	module.exports = ResetPasswordPage;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var Spinner = __webpack_require__(9);
	
	var SignoutPage = function (_React$Component) {
		_inherits(SignoutPage, _React$Component);
	
		function SignoutPage() {
			_classCallCheck(this, SignoutPage);
	
			return _possibleConstructorReturn(this, (SignoutPage.__proto__ || Object.getPrototypeOf(SignoutPage)).apply(this, arguments));
		}
	
		_createClass(SignoutPage, [{
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "signoutPage container" },
					React.createElement(Spinner, { placeholder: true, scale: 1.5 })
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				CurrentUser.logOut();
			}
		}]);
	
		return SignoutPage;
	}(React.Component);
	
	;
	
	SignoutPage.propTypes = PageStrictPropTypes({});
	
	module.exports = SignoutPage;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	
	var CalendlyContainer = function (_React$Component) {
		_inherits(CalendlyContainer, _React$Component);
	
		function CalendlyContainer(props) {
			_classCallCheck(this, CalendlyContainer);
	
			var _this = _possibleConstructorReturn(this, (CalendlyContainer.__proto__ || Object.getPrototypeOf(CalendlyContainer)).call(this));
	
			autobind(_this);
			_this.state = { loading: true };
			return _this;
		}
	
		_createClass(CalendlyContainer, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				$wr.loadScript("https://assets.calendly.com/assets/external/widget.js", "CalendlyContainer", function () {
					_this2.setState({ loading: false });
				});
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.loading) {
					var spinner = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				}
				return React.createElement(
					"div",
					{ className: "calendlyContainer" },
					spinner,
					React.createElement("div", { className: "calendly-inline-widget", "data-url": this.props.url,
						style: { minWidth: '480px', height: '640px' } })
				);
			}
		}]);
	
		return CalendlyContainer;
	}(React.Component);
	
	;
	
	CalendlyContainer.propTypes = StrictPropTypes({
		url: PropTypes.string.isRequired
	});
	
	module.exports = CalendlyContainer;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackFormatter = __webpack_require__(73);
	var CurrentUser = __webpack_require__(3);
	var ImageIcon = __webpack_require__(102);
	var ReactTooltip = __webpack_require__(12);
	
	var CoinsNotificationContainer = function (_React$Component) {
		_inherits(CoinsNotificationContainer, _React$Component);
	
		function CoinsNotificationContainer(props) {
			_classCallCheck(this, CoinsNotificationContainer);
	
			var _this = _possibleConstructorReturn(this, (CoinsNotificationContainer.__proto__ || Object.getPrototypeOf(CoinsNotificationContainer)).call(this));
	
			autobind(_this);
			_this.state = {
				popoverOpen: false
			};
			return _this;
		}
	
		_createClass(CoinsNotificationContainer, [{
			key: "toggleCoinsData",
			value: function toggleCoinsData(e) {
				$wr.nope(e);
				if (this.state.popoverOpen) {
					this.setState({ popoverOpen: false });
				} else {
	
					$(".studentGoalDataWrapper").not(this.refs.wrapper).trigger("closePopover");
					Mycroft.newEvent({ category: "Navbar", action: "view-coin-history" });
	
					this.setState({ popoverOpen: true });
				}
			}
		}, {
			key: "animateCoins",
			value: function animateCoins() {
				var $coinsContainer = $(this.refs.coinsContainer);
				$coinsContainer.hide().fadeIn();
	
				var driftScale = 160;
	
				var $coins = $coinsContainer.find(".displayCoin");
	
				$coins.finish().css({ top: 0, left: 0 }).show();
	
				setTimeout(function () {
					$coinsContainer.fadeOut();
				}, 1000); // Need to coordinate this w/ delay in CurrentUser
	
				$coins.each(function () {
					var speed = _.random(1000, 1500);
					var drift = Math.random() - 0.5;
					var randGroup = Math.random();
	
					if (randGroup < 0.333) {
						$(this).animate({
							top: 300,
							left: driftScale * drift
						}, speed);
					} else if (randGroup < 0.666) {
						$(this).animate({
							left: 300,
							top: 50 + driftScale * drift
						}, speed);
					} else {
						$(this).animate({
							left: -300,
							top: 50 + driftScale * drift
						}, speed);
					}
				});
			}
		}, {
			key: "render",
			value: function render() {
				var currentUser = CurrentUser.get();
				if (this.state.popoverOpen) {
					if (currentUser.coin_records.length > 0) {
						var recordItems = _.map(currentUser.coin_records, function (coinRecord) {
							if (coinRecord.change >= 0) {
								var verb = "got";
								var icon = "coin";
							} else if (coinRecord.key && coinRecord.key.startsWith("reverse-")) {
								var verb = "lost";
								var icon = "student";
							} else {
								var verb = "spent";
								var icon = "student";
							}
							var reason = FeedbackFormatter.formatSimple(coinRecord.reason);
							return React.createElement(
								"div",
								{ className: "coinNotificationItem clearfix", key: coinRecord.id },
								React.createElement(
									"p",
									null,
									React.createElement(ImageIcon, { icon: icon, className: "itemCoin" }),
									" ",
									React.createElement(
										"strong",
										null,
										"You ",
										verb,
										" ",
										Math.abs(coinRecord.change),
										" coins: "
									),
									React.createElement("br", null),
									reason
								)
							);
						});
					} else {
						var emptyCoinRecords = [];
						for (var i = 0; i <= 4; i++) {
							emptyCoinRecords.push(React.createElement(
								"div",
								{ className: "emptyCoinRow", key: i },
								React.createElement("div", { className: "emptyCoinImage" }),
								React.createElement("div", { className: "emptyCoinText" })
							));
						};
	
						var emptyRecordContainer = React.createElement(
							"div",
							{ className: "emptyStateContainer" },
							React.createElement(
								"p",
								{ className: "emptyText" },
								"Take a quiz to earn some coins!"
							),
							emptyCoinRecords
						);
					}
					var popover = React.createElement(
						"div",
						{ className: "popover fade in bottom" },
						React.createElement("div", { className: "arrow" }),
						React.createElement(
							"div",
							{ className: "popover-content" },
							emptyRecordContainer,
							recordItems
						)
					);
				}
	
				var coins = [];
				for (var i = 0; i < 15; i++) {
					var className = "displayCoin";
					coins.push(React.createElement(ImageIcon, { icon: "coin", className: className, key: i }));
				}
	
				return React.createElement(
					"div",
					{ className: "coinsContainer studentGoalDataWrapper", ref: "wrapper",
						onClick: this.toggleCoinsData },
					React.createElement(
						"div",
						{ className: "totalDisplay", "data-tip": currentUser.coins, "data-for": "coin-toolip" },
						React.createElement(ImageIcon, { icon: "coin", height: 20 }),
						" "
					),
					React.createElement(ReactTooltip, { place: "bottom", effect: "solid", id: "coin-toolip" }),
					React.createElement(
						"div",
						{ className: "animatedCoinsContainer", ref: "coinsContainer" },
						coins
					),
					popover
				);
			}
		}, {
			key: "onDocumentClick",
			value: function onDocumentClick(e) {
				var isChild = $(e.target).closest(this.refs.wrapper).length > 0;
				if (!isChild && this.state.popoverOpen) {
					this.setState({ popoverOpen: false });
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(this.refs.wrapper).on("closePopover", function () {
					if (this.state.popoverOpen) {
						this.setState({ popoverOpen: false });
					}
				}.bind(this));
	
				if (window.wrNotifications == undefined) {
					window.wrNotifications = {};
				}
				window.wrNotifications.triggerCoinAward = this.animateCoins;
	
				$(window.document).on("click", this.onDocumentClick);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("click", this.onDocumentClick);
			}
		}]);
	
		return CoinsNotificationContainer;
	}(React.Component);
	
	;
	
	CoinsNotificationContainer.propTypes = StrictPropTypes({});
	
	module.exports = CoinsNotificationContainer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Glyphicon = __webpack_require__(8);
	
	var DropDownNotification = function DropDownNotification(props) {
		var className = "dropDownNotification";
	
		if (props.type == undefined) {
			className += " " + DropDownNotification.success;
		} else {
			className += " " + props.type;
		}
	
		if (props.icon) {
			var icon = React.createElement(Glyphicon, { icon: props.icon });
		}
	
		if (props.title && props.title.trim().length > 0) {
			var title = React.createElement(
				"strong",
				null,
				props.title
			);
		}
	
		if (props.text && props.text.trim().length > 0) {
			if (title) {
				var text = React.createElement(
					"span",
					null,
					" - ",
					" ",
					props.text
				);
			} else {
				var text = React.createElement(
					"span",
					null,
					props.text
				);
			}
		}
	
		return React.createElement(
			"div",
			{ className: className, onClick: props.onClick },
			icon,
			" ",
			title,
			text
		);
	};
	
	DropDownNotification.success = "success";
	DropDownNotification.error = "error";
	
	DropDownNotification.propTypes = StrictPropTypes({
		// Glyphicon suffix (like 'remove')
		icon: PropTypes.string,
	
		// Bold text on the left
		title: PropTypes.string,
	
		// Normal weight text that comes next
		text: PropTypes.string,
	
		// Action to take when the notification is clicked on
		onClick: PropTypes.func,
	
		// The type of alert (success, error, etc.). Default success
		type: PropTypes.oneOf([DropDownNotification.success, DropDownNotification.error])
	});
	
	module.exports = DropDownNotification;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var AutograderDemo = __webpack_require__(428);
	
	__webpack_require__(658);
	
	var GlobalModalContainer = function (_React$Component) {
	  _inherits(GlobalModalContainer, _React$Component);
	
	  function GlobalModalContainer(props) {
	    _classCallCheck(this, GlobalModalContainer);
	
	    var _this = _possibleConstructorReturn(this, (GlobalModalContainer.__proto__ || Object.getPrototypeOf(GlobalModalContainer)).call(this));
	
	    autobind(_this);
	
	    _this.state = { modalConfig: null };
	    return _this;
	  }
	
	  _createClass(GlobalModalContainer, [{
	    key: "setInitalState",
	    value: function setInitalState() {
	      var _this2 = this;
	
	      for (var key in MODALS) {
	        var modalConfig = MODALS[key];
	        if (modalConfig.active && modalConfig.trigger(this.props)) {
	          this.setState({ modalConfig: modalConfig }, function () {
	            _this2.refs.globalModal.show();
	          });
	          break;
	        }
	      }
	    }
	  }, {
	    key: "renderModal",
	    value: function renderModal() {
	      var modalConfig = this.state.modalConfig;
	
	      if (modalConfig) {
	        var content = modalConfig.action(this.props);
	        var headerText = modalConfig.headerText;
	        var classes = modalConfig.classes;
	      }
	
	      return React.createElement(
	        Modal,
	        { className: "globalModal " + classes, ref: "globalModal", headerText: headerText || '' },
	        content
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderModal();
	    }
	  }, {
	    key: "pageOrParamsChanged",
	    value: function pageOrParamsChanged(prevProps) {
	      return this.props.location.path !== prevProps.location.path || this.props.location.search !== prevProps.location.search;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setInitalState();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.pageOrParamsChanged(prevProps)) {
	        this.setInitalState();
	      }
	    }
	  }]);
	
	  return GlobalModalContainer;
	}(React.Component);
	
	;
	
	var MODALS = {
	  'autograder-demo': {
	    active: true,
	    trigger: function trigger(props) {
	      // if (CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard && Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) { // TEMP COMMENT
	      if (CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard) {
	        var searchParams = props.location.search.replace('?', '').split('&');
	        return _.includes(searchParams, 'autograderDemo=show');
	      }
	    },
	    action: function action(props) {
	      return React.createElement(AutograderDemo, null);
	    },
	    classes: 'onboardingModal',
	    headerText: 'Try Our Autograder'
	  }
	};
	
	GlobalModalContainer.propTypes = StrictPropTypes({
	  location: PropTypes.object
	});
	
	module.exports = GlobalModalContainer;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	var DropDownNotification = __webpack_require__(796);
	var Modal = __webpack_require__(18);
	var FeedbackFormatter = __webpack_require__(73);
	var CalendlyContainer = __webpack_require__(794);
	
	__webpack_require__(3685);
	
	var NotificationContainer = function (_React$Component) {
		_inherits(NotificationContainer, _React$Component);
	
		function NotificationContainer(props) {
			_classCallCheck(this, NotificationContainer);
	
			var _this = _possibleConstructorReturn(this, (NotificationContainer.__proto__ || Object.getPrototypeOf(NotificationContainer)).call(this));
	
			autobind(_this);
			_this.state = {
				dropDownNotifications: {}, siteMessageInfo: {}, allowFormatting: false, calendlyModalInfo: {}
			};
			return _this;
		}
	
		// notificationProps: 	See propTypes for DropDownNotification.js ('shown' set manually)
		// duration: 			Time the notification should show (in ms, default 2000)
	
	
		_createClass(NotificationContainer, [{
			key: "newDropDownNotification",
			value: function newDropDownNotification(notificationProps, duration) {
				duration = duration || 3000;
	
				var key = this.generateKey();
	
				var updatedList = _.clone(this.state.dropDownNotifications);
				updatedList[key] = notificationProps;
	
				this.setState({ dropDownNotifications: updatedList });
	
				// Set timeout for finally removing the item from our state
				setTimeout(function () {
					this.buildRemoveFunction("dropDownNotifications", key)();
				}.bind(this), duration);
			}
		}, {
			key: "newModalNotification",
			value: function newModalNotification(userAlertInfo, allowFormatting) {
				this.setState({ siteMessageInfo: userAlertInfo, allowFormatting: allowFormatting });
				this.refs.modal.show();
			}
		}, {
			key: "newCalendlyModal",
			value: function newCalendlyModal(userAlertInfo) {
				this.setState({ calendlyModalInfo: userAlertInfo });
				this.refs.modal.show();
			}
		}, {
			key: "generateKey",
			value: function generateKey() {
				return Math.random().toString(36).slice(2);
			}
		}, {
			key: "buildRemoveFunction",
			value: function buildRemoveFunction(notificationType, key) {
				return function () {
					var updatedList = _.clone(this.state[notificationType]);
					if (updatedList[key]) {
						delete updatedList[key];
	
						var stateUpdate = {};stateUpdate[notificationType] = updatedList;
						this.setState(stateUpdate);
					}
				}.bind(this);
			}
		}, {
			key: "render",
			value: function render() {
				var dropDowns = _.map(this.state.dropDownNotifications, function (props, key) {
					var useProps = _.omit(props, "duration");
					return React.createElement(
						CSSTransition,
						{ classNames: "drop-down", timeout: { enter: 500, exit: 500 }, key: key },
						React.createElement(DropDownNotification, _extends({}, useProps, {
							onClick: this.buildRemoveFunction("dropDownNotifications", key) }))
					);
				}.bind(this));
	
				if (this.state.calendlyModalInfo.data && this.state.calendlyModalInfo.data.calendly_url) {
					var siteMessageParagraphs = React.createElement(CalendlyContainer, { url: this.state.calendlyModalInfo.data.calendly_url });
				} else if (this.state.siteMessageInfo.text) {
					var className = "twoThirdsWidth";
					if (this.state.allowFormatting) {
						var siteMessageParagraphs = FeedbackFormatter.format(this.state.siteMessageInfo.text);
					} else {
						var siteMessageTexts = this.state.siteMessageInfo.text.split("\n");
						var siteMessageParagraphs = siteMessageTexts.map(function (text, index) {
							return React.createElement(
								"p",
								{ key: index },
								text
							);
						});
					}
					if (this.state.siteMessageInfo.data.survey_url) {
						var url = "https://docs.google.com/forms/d/1zNYW0GNrS2XAjhSxRWIwMml0LHZKJsuEmJspkZ1lwo0/";
						var studentSurveyContainer = React.createElement(
							"div",
							{ className: "studentSurveyContainer" },
							React.createElement("img", { src: __webpack_require__(1739) }),
							React.createElement(
								"a",
								{ className: "buttonPrimary", href: url, target: "_blank" },
								"Take Survey!"
							)
						);
					}
				}
				var title = this.state.siteMessageInfo.title || this.state.calendlyModalInfo.title;
				return React.createElement(
					"div",
					null,
					React.createElement(
						TransitionGroup,
						null,
						dropDowns
					),
					React.createElement(
						Modal,
						{ className: className, ref: "modal", headerText: title },
						React.createElement(
							"div",
							{ className: "modalBody" },
							siteMessageParagraphs,
							studentSurveyContainer
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (window.wrNotifications == undefined) {
					window.wrNotifications = {};
				}
				window.wrNotifications.triggerDropDownNotification = this.newDropDownNotification;
				window.wrNotifications.triggerModalNotification = this.newModalNotification;
	
				if (window.wrNotifications.pendingModalNotifications) {
					_.each(window.wrNotifications.pendingModalNotifications, function (alertPair) {
						window.wrNotifications.triggerModalNotification(alertPair[0], alertPair[1]);
					});
				}
	
				window.wrNotifications.triggerCalendlyModal = this.newCalendlyModal;
	
				if (window.wrNotifications.pendingCalendlyModal) {
					_.each(window.wrNotifications.pendingCalendlyModal, function (alert) {
						window.wrNotifications.triggerCalendlyModal(alert);
					});
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				delete window.wrNotifications;
			}
		}]);
	
		return NotificationContainer;
	}(React.Component);
	
	;
	
	NotificationContainer.propTypes = StrictPropTypes({});
	
	module.exports = NotificationContainer;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var Modal = __webpack_require__(18);
	
	__webpack_require__(3687);
	
	var SiteAnnoucementModal = function (_React$Component) {
	    _inherits(SiteAnnoucementModal, _React$Component);
	
	    function SiteAnnoucementModal(props) {
	        _classCallCheck(this, SiteAnnoucementModal);
	
	        var _this = _possibleConstructorReturn(this, (SiteAnnoucementModal.__proto__ || Object.getPrototypeOf(SiteAnnoucementModal)).call(this));
	
	        autobind(_this);
	
	        _this.state = {
	            hide: false
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(SiteAnnoucementModal, [{
	        key: "deleteAlert",
	        value: function deleteAlert() {
	            var _this2 = this;
	
	            if (this.props.alertID) {
	                CurrentUser.api().deleteUserAlert(this.props.alertID, function (res) {
	                    _this2.setState({ hide: true });
	                    var newUserAlerts = _.filter(CurrentUser.get().user_alerts, function (alert) {
	                        return alert.data.annoucement_key !== res.user_alert.data.annoucement_key;
	                    });
	                    CurrentUser.updateLocal({ user_alerts: newUserAlerts });
	                });
	            }
	        }
	
	        //////// Render Methods ////////
	
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.state.hide) {
	                return null;
	            }
	
	            var _props = this.props,
	                title = _props.title,
	                actionButtons = _props.actionButtons,
	                bodyContent = _props.bodyContent;
	
	
	            return React.createElement(
	                Modal,
	                { className: "siteAnnoucementModal", ref: "siteAnnoucementModal", headerText: title || '', onHide: this.deleteAlert },
	                bodyContent
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.refs.siteAnnoucementModal.show();
	        }
	    }]);
	
	    return SiteAnnoucementModal;
	}(React.Component);
	
	;
	
	SiteAnnoucementModal.propTypes = StrictPropTypes({
	    bodyContent: PropTypes.object.isRequired,
	    title: PropTypes.string,
	    titleImage: PropTypes.string,
	    alertID: PropTypes.number
	});
	
	module.exports = SiteAnnoucementModal;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactHtmlParser = __webpack_require__(3573);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaywallModal = __webpack_require__(44);
	var Glyphicon = __webpack_require__(8);
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var Modal = __webpack_require__(18);
	var GoldTrialModal = __webpack_require__(868);
	var AccountPlans = __webpack_require__(53);
	
	__webpack_require__(3688);
	
	var SiteBanner = function (_React$Component) {
		_inherits(SiteBanner, _React$Component);
	
		function SiteBanner(props) {
			_classCallCheck(this, SiteBanner);
	
			var _this = _possibleConstructorReturn(this, (SiteBanner.__proto__ || Object.getPrototypeOf(SiteBanner)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, paywallType: null
			};
	
			_this.goldTrialModal = React.createRef();
			return _this;
		}
	
		_createClass(SiteBanner, [{
			key: "deleteAlert",
			value: function deleteAlert(alertID) {
				this.setState({ loading: true });
				CurrentUser.api().deleteUserAlert(alertID, $wr.apiHandler(function (response) {
					CurrentUser.fetchCurrentUserData(function () {
						this.setState({ loading: false });
					}.bind(this));
				}.bind(this)));
			}
		}, {
			key: "userAlert",
			value: function userAlert() {
				return _.last(_.sortBy(this.props.alerts, "created_at"));
			}
		}, {
			key: "openPaywall",
			value: function openPaywall(e) {
				$wr.nope(e);
				var userAlert = this.userAlert();
	
				Mycroft.newEvent({
					category: "Notifications", action: "site-banner-cta-click", label: userAlert.data.cta_action
				});
	
				var paywallType = userAlert.data.cta_action.split(":")[1];
				this.setState({ paywallType: paywallType }, function () {
					this.refs.paywallModal.show();
				}.bind(this));
			}
		}, {
			key: "renderGoldTrialModal",
			value: function renderGoldTrialModal() {
				return React.createElement(
					Modal,
					{ headerText: "Unlock Gold Free for 60 Days", ref: this.goldTrialModal },
					React.createElement(GoldTrialModal, { alertID: this.userAlert().id })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var userAlert = this.userAlert();
	
				var ctaText = userAlert.data.cta_text || "Learn More";
				if (userAlert.data.cta_action && userAlert.data.cta_url) {
					if (SiteBanner.PAYWALL_LINK_REGEX.test(userAlert.data.cta_action)) {
						var alertButton = React.createElement(
							"a",
							{ href: "#", className: "buttonSuccess alertButton", onClick: this.openPaywall },
							ctaText
						);
					}
				} else if (userAlert.data.cta_url) {
					var alertURL = userAlert.data.cta_url;
					var linkEventHandler = Mycroft.buildEventHandler({
						category: "Notifications", action: "site-banner-cta-click", label: alertURL
					});
	
					var alertButton = React.createElement(
						"a",
						{ href: alertURL, className: "buttonSuccess alertButton", target: "_blank",
							onClick: linkEventHandler },
						ctaText
					);
				}
	
				if (this.state.loading) {
					var removeLink = React.createElement(Spinner, { className: "removeLink", placeholder: false, scale: 1 });
				} else {
					var removeLink = React.createElement(
						"a",
						{ href: "#", onClick: this.deleteAlert.bind(this, userAlert.id),
							className: "removeLink" },
						React.createElement(Glyphicon, { icon: "remove" })
					);
				}
	
				var numAlerts = this.props.alerts.length;
				if (numAlerts > 1) {
					var multiAlertText = React.createElement(
						"div",
						{ className: "alertNumber" },
						"1 of ",
						numAlerts
					);
				}
	
				if (this.state.paywallType) {
					var paywallModal = React.createElement(PaywallModal, { ref: "paywallModal", featureType: this.state.paywallType });
				}
	
				var contentClass = 'content';
				var siteBannerContainerClass = 'siteBannerContainer';
				if (userAlert.data.feature === AccountPlans.PRODUCTS.WR_GOLD) {
					LuckyOrangeClient.tagComponent("SiteBannerGoldTrial");
					contentClass += ' gold';
					siteBannerContainerClass += ' goldBackground';
					if (!alertButton && userAlert.data && userAlert.data.cta_text && userAlert.data.cta_text.length > 0) {
						var actionText = userAlert.data.cta_text !== undefined ? userAlert.data.cta_text : 'Start Today';
	
						// actionLink = (
						// 	<button className='btn btn-default goldTrialBannerCTA' onClick={() => this.goldTrialModal.current.show()}>
						// 		{actionText}
						// 	</button>
						// )
						var alertButton = React.createElement(
							"a",
							{ onClick: function onClick() {
									return _this2.goldTrialModal.current.show();
								}, className: "btn btn-default goldTrialBannerCTA" },
							actionText
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: siteBannerContainerClass },
					React.createElement(
						"div",
						{ className: "container" },
						React.createElement(
							"div",
							{ className: contentClass },
							React.createElement(
								"div",
								{ className: "alertText" },
								React.createElement(
									"strong",
									null,
									(0, _reactHtmlParser2.default)(userAlert.title)
								)
							),
							removeLink,
							alertButton,
							multiAlertText
						)
					),
					paywallModal
				);
			}
		}]);
	
		return SiteBanner;
	}(React.Component);
	
	;
	
	SiteBanner.propTypes = StrictPropTypes({
		alerts: PropTypes.array.isRequired
	});
	
	SiteBanner.PAYWALL_LINK_REGEX = /PAYWALL:[\w-]+/;
	
	module.exports = SiteBanner;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3689);
	
	var SlideInAnnouncement = function (_React$Component) {
	    _inherits(SlideInAnnouncement, _React$Component);
	
	    function SlideInAnnouncement(props) {
	        _classCallCheck(this, SlideInAnnouncement);
	
	        var _this = _possibleConstructorReturn(this, (SlideInAnnouncement.__proto__ || Object.getPrototypeOf(SlideInAnnouncement)).call(this));
	
	        autobind(_this);
	        _this.state = {
	            hide: false,
	            collapsed: false
	        };
	        return _this;
	    }
	
	    _createClass(SlideInAnnouncement, [{
	        key: "removeAlert",
	        value: function removeAlert() {
	            var _this2 = this;
	
	            CurrentUser.api().deleteUserAlert(this.props.alertID, function () {
	                _this2.setState({ hide: true });
	            });
	        }
	    }, {
	        key: "toggle",
	        value: function toggle() {
	            this.setState({ collapsed: !this.state.collapsed });
	        }
	    }, {
	        key: "renderSlideInAnnouncement",
	        value: function renderSlideInAnnouncement() {
	            var arrowIcon = this.state.collapsed ? 'glyphicon glyphicon-chevron-left' : 'glyphicon glyphicon-chevron-right';
	
	            return React.createElement(
	                "div",
	                { className: "inner " + (this.state.collapsed == true ? 'hideSidebar' : 'showSidebar') },
	                React.createElement(
	                    "div",
	                    { className: "arrowContainer" },
	                    React.createElement(Glyphicon, { icon: arrowIcon, className: "bodyArrow arrow", onClick: this.toggle })
	                ),
	                React.createElement(
	                    "div",
	                    { className: "bodyText" },
	                    this.props.bodyContent,
	                    React.createElement(
	                        "div",
	                        { className: "removeContainer" },
	                        React.createElement(Glyphicon, { icon: 'remove', className: 'removeAlert',
	                            onClick: this.removeAlert })
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.state.hide) {
	                return null;
	            }
	
	            return React.createElement(
	                "div",
	                { key: this.props.alertID, className: "slideInAnnouncement " + (this.state.collapsed == true ? 'hideSidebar' : 'showSidebar') },
	                this.renderSlideInAnnouncement()
	            );
	        }
	    }]);
	
	    return SlideInAnnouncement;
	}(React.Component);
	
	;
	
	module.exports = SlideInAnnouncement;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	var CurrentUser = __webpack_require__(3);
	var FeedbackFormatter = __webpack_require__(73);
	var ArbitrarySubjects = __webpack_require__(107);
	
	var Spinner = __webpack_require__(9);
	var UserAvatar = __webpack_require__(239);
	var AdminAvatar = __webpack_require__(370);
	
	var MyShelfRouting = __webpack_require__(74);
	
	__webpack_require__(3690);
	
	var SocialNotificationContainer = function (_React$Component) {
		_inherits(SocialNotificationContainer, _React$Component);
	
		function SocialNotificationContainer(props) {
			_classCallCheck(this, SocialNotificationContainer);
	
			var _this = _possibleConstructorReturn(this, (SocialNotificationContainer.__proto__ || Object.getPrototypeOf(SocialNotificationContainer)).call(this));
	
			autobind(_this);
			_this.state = {
				popoverOpen: false, notifications: null,
				pendingNotificationCount: CurrentUser.get().pending_notification_count,
				doneLoading: false, page: null, loading: false
			};
			return _this;
		}
	
		_createClass(SocialNotificationContainer, [{
			key: "toggleSocialData",
			value: function toggleSocialData(e) {
				$wr.nope(e);
				if (this.state.popoverOpen) {
					this.setState({ popoverOpen: false });
					$(this.refs.scrollArea).off("scroll", this.onPopoverScroll);
				} else {
					this.setState({ popoverOpen: true }, function () {
						$(this.refs.scrollArea).on("scroll", this.onPopoverScroll);
					}.bind(this));
	
					if (this.state.notifications == null) {
						this.fetchNotifications();
					}
				}
			}
		}, {
			key: "goToItem",
			value: function goToItem(notification, e) {
				var viewData = notification.view_data;
				if (!viewData || !viewData.subject_type) {
					console.error("No view_data or view_data.subject_type");
					return;
				}
	
				if (ArbitrarySubjects.onReadingPage(viewData.subject_type)) {
					$wr.redirect(MyShelfRouting.getPath({
						activeView: MyShelfRouting.VIEWS.LOGS_VIEW
					}));
				} else {
					var collection = ArbitrarySubjects.asCollection(viewData.subject_type);
	
					$wr.redirect(MyShelfRouting.getPath({
						activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
						detailsView: collection,
						textID: viewData.text_id
					}));
				}
				this.setState({ popoverOpen: false });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.popoverOpen) {
					if (this.state.loading) {
						var loadingIndicator = React.createElement(
							"div",
							null,
							React.createElement(Spinner, { placeholder: true, scale: 1.5 })
						);
					}
					if (this.state.notifications != null) {
						var popoverContent = _.map(this.state.notifications, function (notification, i) {
							// if (newsItem.subject.avatar) {
							// 	var avatar = (<StudentAvatar maxWidth={ 50 } student={ { avatar: newsItem.subject.avatar } } />);
							// } else {
							// 	var avatar = (<AdminAvatar maxWidth={ 50 } admin={ {} } />);
							// }
							// var activityTitle = newsItem.subject.response.activity.format_summary.title;
	
							// if (CurrentUser.hasID(newsItem.subject.response.user_id)) {
							// 	var ownerLine = "your response";
							// } else {
							// 	var ownerLine = `${ newsItem.subject.owner_name }'s response`;
							// }
	
							// return (
							// 	<div key={ i } onClick={ this.goToItem.bind(this, newsItem) }
							// 		className="socialNotificationItem clearfix">
							// 		{ avatar }
							// 		<div className="itemSummary">
							// 			<strong>{ newsItem.subject.commenter_name } </strong>
							// 			commented on { ownerLine } for <em>{ activityTitle }</em>
							// 		</div>
							// 	</div>
							// );
	
							if (notification.view_data && notification.view_data.source_user) {
								var avatar = React.createElement(UserAvatar, { user: notification.view_data.source_user, maxWidth: 50 });
							}
	
							return React.createElement(
								"div",
								{ key: i, onClick: this.goToItem.bind(this, notification),
									className: "socialNotificationItem clearfix" },
								avatar,
								React.createElement(
									"div",
									{ className: "itemSummary" },
									FeedbackFormatter.formatSimple(notification.body)
								)
							);
						}.bind(this));
	
						if (CurrentUser.isAdmin()) {
							var teacherClass = "teacherPopover";
							var emptyStatePrompt = "Notifications about conversations with your students will appear here.";
						} else {
							teacherClass = "";
							var emptyStatePrompt = "Your teacher's comments on your work will show here.";
						}
						if (this.state.notifications.length == 0) {
							var emptyNotifications = [];
							var owlImgSrc = __webpack_require__(543);
							for (var i = 0; i < 2; i++) {
								emptyNotifications.push(React.createElement(
									"div",
									{ className: "emptyNotificationRow", key: i },
									React.createElement("img", { src: owlImgSrc, alt: "" }),
									React.createElement(
										"div",
										{ className: "emptyNotificationLineContainer" },
										React.createElement("div", { className: "emptyNotificationLine" }),
										React.createElement("div", { className: "emptyNotificationLine" })
									)
								));
							};
	
							var emptyNotificationsContainer = React.createElement(
								"div",
								{ className: "emptyStateContainer" },
								React.createElement(
									"p",
									{ className: "emptyText" },
									emptyStatePrompt
								),
								emptyNotifications
							);
						}
					}
	
					var popover = React.createElement(
						"div",
						{ className: "popover fade in bottom " + teacherClass },
						React.createElement("div", { className: "arrow" }),
						React.createElement(
							"div",
							{ className: "popover-content", ref: "scrollArea" },
							emptyNotificationsContainer,
							popoverContent,
							loadingIndicator
						)
					);
				}
				var className = "notificationContainer socialNotificationContainer";
				if (this.state.pendingNotificationCount > 0) {
					var notificationsBell = "notificationsBell";
					if (CurrentUser.isAdmin()) {
						var adminNotificationsBadge = "adminBadge";
					}
					var notificationsBadge = "notificationBadge ";
					var notificationsCount = this.state.pendingNotificationCount;
					className += " fullSocialNotificationContainer";
				} else {
					notificationsBadge = "";
				}
	
				return React.createElement(
					"div",
					{ ref: "wrapper", className: className },
					React.createElement("span", { className: "glyphicon glyphicon-bell " + notificationsBell, onClick: this.toggleSocialData }),
					React.createElement(
						"span",
						{ className: notificationsBadge + adminNotificationsBadge, onClick: this.toggleSocialData },
						notificationsCount
					),
					React.createElement("br", null),
					React.createElement(
						"span",
						{ className: "notifyLabel", onClick: this.toggleSocialData },
						"News"
					),
					popover
				);
			}
		}, {
			key: "onPopoverScroll",
			value: function onPopoverScroll() {
				if ($(this.refs.scrollArea).scrollTop() >= 130 && !this.state.loading && !this.state.doneLoading) {
	
					this.fetchNotifications();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(window.document).on("click", this.onDocumentClick);
				this.updatePageTitle();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("click", this.onDocumentClick);
				$(this.refs.scrollArea).off("scroll", this.onPopoverScroll);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				this.updatePageTitle();
			}
		}, {
			key: "onDocumentClick",
			value: function onDocumentClick(e) {
				var isChild = $(e.target).closest(this.refs.wrapper).length > 0;
				if (!isChild && this.state.popoverOpen) {
					this.setState({ popoverOpen: false });
				}
			}
		}, {
			key: "fetchNotifications",
			value: function fetchNotifications() {
				if (this.state.doneLoading) {
					return;
				}
	
				var params = { view_all: true, embed: "view_data.source_user,student.avatar" };
	
				if (this.state.page) {
					params.page = this.state.page + 1;
				}
	
				this.setState({ loading: true });
	
				CurrentUser.api().getNotifications(params, $wr.apiHandler(function (response) {
					var doneLoading = response.notifications.length < response.per_page;
					var newNotifications = (this.state.notifications || []).concat(response.notifications);
					this.setState({ notifications: newNotifications, page: response.page,
						doneLoading: doneLoading, loading: false, pendingNotificationCount: 0 });
				}.bind(this)));
			}
		}, {
			key: "updatePageTitle",
			value: function updatePageTitle() {
				if (this.state.pendingNotificationCount > 0) {
					$('title').text("Whooo's Reading (" + this.state.pendingNotificationCount + ") | " + CurrentUser.get().display_name);
				} else {
					$('title').text("Whooo's Reading | " + CurrentUser.get().display_name);
				}
			}
		}]);
	
		return SocialNotificationContainer;
	}(React.Component);
	
	;
	
	SocialNotificationContainer.propTypes = StrictPropTypes({});
	
	module.exports = SocialNotificationContainer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewFeatureInfo = function (_React$Component) {
	    _inherits(NewFeatureInfo, _React$Component);
	
	    function NewFeatureInfo(props) {
	        _classCallCheck(this, NewFeatureInfo);
	
	        var _this = _possibleConstructorReturn(this, (NewFeatureInfo.__proto__ || Object.getPrototypeOf(NewFeatureInfo)).call(this));
	
	        autobind(_this);
	        LuckyOrangeClient.tagComponent("NewFeatureInfo");
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(NewFeatureInfo, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                imagePath = _props.imagePath,
	                descriptions = _props.descriptions;
	
	
	            return React.createElement(
	                "div",
	                { className: "newFeatureInfo" },
	                React.createElement(
	                    "div",
	                    { className: "imgContainer" },
	                    React.createElement("img", { src: dynamicRequire(imagePath), alt: "New Feature", className: "newFeatureImage" })
	                ),
	                descriptions.map(function (desc, index) {
	                    return React.createElement(
	                        "p",
	                        { key: index, className: "newFeatureDescription" },
	                        desc
	                    );
	                })
	            );
	        }
	    }]);
	
	    return NewFeatureInfo;
	}(React.Component);
	
	module.exports = NewFeatureInfo;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var NewFeatureInfo = __webpack_require__(803);
	var Features = __webpack_require__(16);
	
	__webpack_require__(3686);
	
	var NewFeaturesModal = function (_React$Component) {
	    _inherits(NewFeaturesModal, _React$Component);
	
	    function NewFeaturesModal(props) {
	        _classCallCheck(this, NewFeaturesModal);
	
	        var _this = _possibleConstructorReturn(this, (NewFeaturesModal.__proto__ || Object.getPrototypeOf(NewFeaturesModal)).call(this));
	
	        autobind(_this);
	        LuckyOrangeClient.tagComponent("NewFeaturesModal");
	
	        _this.state = {
	            track: _this.createTrack(),
	            stageIndex: 0,
	            hide: false
	        };
	        return _this;
	    }
	
	    ///// HELPERS /////
	
	
	    _createClass(NewFeaturesModal, [{
	        key: "createTrack",
	        value: function createTrack() {
	            return _.filter(NEW_FEATURES, function (f) {
	                if (f.conditions() && f.active) {
	                    return f;
	                }
	            });
	        }
	    }, {
	        key: "retreatePossible",
	        value: function retreatePossible() {
	            var stageIndex = this.state.stageIndex;
	
	            return stageIndex > 0;
	        }
	    }, {
	        key: "nextPossible",
	        value: function nextPossible() {
	            var _state = this.state,
	                stageIndex = _state.stageIndex,
	                track = _state.track;
	
	            return _.size(track) - 1 > stageIndex;
	        }
	    }, {
	        key: "donePossible",
	        value: function donePossible() {
	            var _state2 = this.state,
	                stageIndex = _state2.stageIndex,
	                track = _state2.track;
	
	            return _.size(track) - 1 == stageIndex;
	        }
	    }, {
	        key: "deleteAlert",
	        value: function deleteAlert() {
	            var _this2 = this;
	
	            if (this.props.alertID) {
	                CurrentUser.api().deleteUserAlert(this.props.alertID, function (res) {
	                    _this2.setState({ hide: true });
	
	                    var newUserAlerts = _.filter(CurrentUser.get().user_alerts, function (alert) {
	                        return alert.data.annoucement_key !== res.user_alert.data.annoucement_key;
	                    });
	                    CurrentUser.updateLocal({ user_alerts: newUserAlerts });
	                });
	            }
	        }
	
	        ///// STAGE CONTROLLERS /////
	
	    }, {
	        key: "getStageCount",
	        value: function getStageCount() {
	            return this.state.track.length;
	        }
	    }, {
	        key: "getCurrentStageData",
	        value: function getCurrentStageData() {
	            return this.state.track[this.state.stageIndex];
	        }
	    }, {
	        key: "getStageTitle",
	        value: function getStageTitle() {
	            var currentStageData = this.getCurrentStageData();
	
	            return currentStageData.title;
	        }
	
	        ///// HANDLERS /////
	
	    }, {
	        key: "handleCloseModal",
	        value: function handleCloseModal() {
	            this.refs.newFeaturesModal.hide();
	            this.deleteAlert();
	        }
	
	        // handles next button
	
	    }, {
	        key: "handleAdvanceStage",
	        value: function handleAdvanceStage() {
	            var newStageIndex = this.state.stageIndex + 1;
	            this.setState({ stageIndex: newStageIndex });
	        }
	
	        // handles back button
	
	    }, {
	        key: "handleRetreatStage",
	        value: function handleRetreatStage() {
	            var newStageIndex = this.state.stageIndex - 1;
	            this.setState({ stageIndex: newStageIndex });
	        }
	
	        ///// RENDER METHODS /////
	
	    }, {
	        key: "renderContent",
	        value: function renderContent() {
	            var currentStageData = this.getCurrentStageData();
	            return React.createElement(currentStageData.display, _extends({}, currentStageData.props, {
	                track: this.state.track,
	                onRetreat: this.handleRetreatStage,
	                onComplete: this.handleAdvanceStage
	            }));
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            if (this.state.hide) {
	                return null;
	            }
	            return React.createElement(
	                Modal,
	                { onHide: this.deleteAlert, headerText: this.getStageTitle(), className: "newFeaturesModal", ref: "newFeaturesModal" },
	                React.createElement(
	                    "div",
	                    { className: "newFeaturesModal" },
	                    this.renderContent(),
	                    React.createElement(
	                        "div",
	                        { className: "buttonContainer" },
	                        this.retreatePossible() && React.createElement(
	                            "button",
	                            { className: "backBtn", onClick: function onClick() {
	                                    return _this3.handleRetreatStage();
	                                } },
	                            "Back"
	                        ),
	                        this.nextPossible() && React.createElement(
	                            "button",
	                            { className: "nextBtn", onClick: function onClick() {
	                                    return _this3.handleAdvanceStage();
	                                } },
	                            "Next"
	                        ),
	                        this.donePossible() && React.createElement(
	                            "button",
	                            { className: "closeBtn", onClick: function onClick() {
	                                    return _this3.handleCloseModal();
	                                } },
	                            "Close"
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.refs.newFeaturesModal.show();
	        }
	    }]);
	
	    return NewFeaturesModal;
	}(React.Component);
	
	// Configs for new features
	// Future users can add new features by adding an object to the NEW_FEATURES array with the following properties:
	// active: whether the feature is currently active or not
	// name: a unique identifier for the feature
	// title: the display name for the feature
	// display: the React component to use for displaying the feature
	// conditions: a function that returns a boolean indicating whether the feature should be displayed
	// props: an object containing any additional properties required by the React component used for displaying the feature, such as image path and descriptions.
	
	
	var NEW_FEATURES = [{
	    active: true,
	    name: 'improved-exports',
	    title: 'Enhanced Data Export Feature',
	    display: NewFeatureInfo,
	    conditions: function conditions() {
	        return Features.isEnabled(Features.DIGITAL_EXERCISES);
	    },
	    props: {
	        imagePath: 'features/data_exports.gif',
	        descriptions: ['Now you have the ability to tailor your exports by selecting specific time periods, students, and metrics that best fit your needs.', "You can now input your email address and receive the customized XLS export straight to your mailbox for easy accessibility.", "Furthermore, we made improvements to the layout of data on printable PDF pages, ensuring that they are now more legible and presentable when printed."]
	    }
	}, {
	    active: true,
	    name: 'improved-insights',
	    title: 'Discover More with our Upgraded Insights Page',
	    conditions: function conditions() {
	        return true;
	    },
	    display: NewFeatureInfo,
	    props: {
	        imagePath: 'features/insights_page.gif',
	        descriptions: ["Admins can now see scoring trends for individual students, gaining insights into student performance over time with easy-to-view scoring trends.", "It is also now possible to monitor the activity of both classes and individual students all year round, which enables you to gain valuable insights into their performance and adjust instruction as needed."]
	    }
	}];
	
	NewFeaturesModal.propTypes = StrictPropTypes({
	    onComplete: PropTypes.func,
	    effectiveData: PropTypes.object,
	    handlePrint: PropTypes.func,
	    track: PropTypes.array,
	    alertID: PropTypes.number
	});
	
	module.exports = NewFeaturesModal;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GradeLevel = __webpack_require__(40);
	var StudentMetrics = __webpack_require__(29);
	
	var ClassesDisplay = function (_React$Component) {
		_inherits(ClassesDisplay, _React$Component);
	
		function ClassesDisplay() {
			_classCallCheck(this, ClassesDisplay);
	
			return _possibleConstructorReturn(this, (ClassesDisplay.__proto__ || Object.getPrototypeOf(ClassesDisplay)).apply(this, arguments));
		}
	
		_createClass(ClassesDisplay, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.showTopClasses) {
					var className = "upperClass";
				} else {
					var className = "lowerClass";
				}
	
				var metric = this.props.metric;
				var unitName = StudentMetrics.inverseLookup(metric);
				var adjustedUnitName = StudentMetrics.getUnit(unitName);
	
				var classes = _.map(this.props.classes, function (studentList, index) {
					if (_this2.props.showTopClasses) {
						var imgPath = "ranks/school-comp-medal-" + (index + 1) + "-basic.png";
						var rankingImg = React.createElement("img", { className: "rankImg", src: dynamicRequire(imgPath) });
					}
	
					var value = studentList.digest[metric];
	
					if (!value) {
						var numberValue = 0;
					} else {
						var numberValue = $wr.numberWithCommas(studentList.digest[metric]);
					}
	
					return React.createElement(
						"div",
						{ key: studentList.id, className: className },
						React.createElement(
							"div",
							{ className: "leftContainer" },
							rankingImg,
							React.createElement(
								"p",
								null,
								React.createElement(
									"span",
									null,
									studentList.name
								),
								" ",
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "gradeLevel" },
									GradeLevel.getName(studentList.grade_level)
								)
							)
						),
						React.createElement(
							"div",
							{ className: "rightContainer" },
							React.createElement(
								"span",
								{ className: "unitText" },
								numberValue,
								" "
							),
							React.createElement(
								"span",
								null,
								adjustedUnitName
							)
						)
					);
				});
				return React.createElement(
					"div",
					{ className: "topClassesContainer" },
					classes
				);
			}
		}]);
	
		return ClassesDisplay;
	}(React.Component);
	
	ClassesDisplay.propTypes = PageStrictPropTypes({
		classes: PropTypes.array,
		metric: PropTypes.string,
		showTopClasses: PropTypes.bool
	});
	
	module.exports = ClassesDisplay;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LocationState = __webpack_require__(59);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassesDisplay = __webpack_require__(805);
	var InviteTeachersModal = __webpack_require__(807);
	var ContestsRouting = __webpack_require__(442);
	var DisplayToggleControl = __webpack_require__(48);
	var ProgressBar = __webpack_require__(81);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	var ReactTooltip = __webpack_require__(12);
	var OrgDropdown = __webpack_require__(100);
	var OwlShopRouting = __webpack_require__(92);
	
	var OrgTypes = __webpack_require__(45);
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var SchoolInfoModal = __webpack_require__(393);
	var OnboardingChecklist = __webpack_require__(166);
	var PhotosDisplay = __webpack_require__(406);
	
	__webpack_require__(3691);
	
	// Provide location state first, since we may want to access the school ID
	var ContestsPage = (_dec = (0, _LocationState.provideLocationState)(ContestsRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		var asDistrictAdmin = CurrentUser.isSignedIn() && CurrentUser.isDistrictAdmin();
	
		if (asDistrictAdmin) {
	
			var school = RosterSelectors.school({
				state: state, id: props.locationState.l2eSchoolID
			});
	
			if (school) {
				var selectedSchoolOrg = RosterSelectors.schoolOrgs({
					state: state, filters: { school_id: school.l2e_id }
				});
	
				if (selectedSchoolOrg) {
					var selectedSchoolOrgID = selectedSchoolOrg[0].id;
				}
			}
		} else {
			var school = RosterSelectors.primarySchool({ state: state });
		}
		if (school) {
			if (asDistrictAdmin) {
				var studentLists = RosterSelectors.studentLists({
					state: state, filters: { school_id: school.l2e_id }
				});
			} else {
				// No filter here will cause an issue if there's ever a time
				// Non district admins will want to swich between school pages
				var studentLists = RosterSelectors.studentLists({
					state: state
				});
			}
			studentLists = studentLists.filter(function (sl) {
				return sl.digest;
			});
		}
	
		if (props.locationState.csSchoolID) {
			var loading = RosterSelectors.isLoadingSchool({
				state: state, key: props.locationState.csSchoolID
			});
		} else if (props.locationState.l2eSchoolID) {
			var loading = RosterSelectors.isLoadingSchool({
				state: state, key: props.locationState.l2eSchoolID
			});
		} else {
			var loading = false;
		}
	
		var showModal = CurrentUser.isSignedIn() && CurrentUser.isAdmin();
		var showEditPrompt = CurrentUser.isSignedIn() && CurrentUser.isAdmin();
		var asSchoolAdmin = CurrentUser.isSignedIn() && CurrentUser.isSchoolAdmin();
	
		return {
			school: school, studentLists: studentLists, selectedSchoolOrgID: selectedSchoolOrgID,
			loading: loading,
			showModal: showModal, showEditPrompt: showEditPrompt,
			asSchoolAdmin: asSchoolAdmin, asDistrictAdmin: asDistrictAdmin,
	
			getSchoolID: function getSchoolID(schoolOrgID) {
				return RosterSelectors.schoolOrg({ state: state, id: schoolOrgID }).school_id;
			}
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				if (props.locationState.csSchoolID) {
					var id = props.locationState.csSchoolID;
					var query = {
						id_type: "cs_id"
					};
				} else if (props.locationState.l2eSchoolID) {
					var id = props.locationState.l2eSchoolID;
					var query = {
						id_type: "l2e_id"
					};
				} else if (CurrentUser.isSignedIn()) {
					var school = CurrentUser.get().school;
					if (school) {
						var query = {};
						if (school.canonical_id) {
							var id = school.canonical_id;
							query.id_type = "cs_id";
						} else {
							var id = school.l2e_id;
							query.id_type = "l2e_id";
						}
					}
				}
	
				if (query && id) {
					dispatch(RosterActions.fetchSchool({
						id: id, query: query,
						embeds: ["school.contests", "school.digest", "school.active_student_lists", "student_list.digest"]
					}));
				}
			}
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(ContestsPage, _React$Component);
	
		function ContestsPage(props) {
			_classCallCheck(this, ContestsPage);
	
			var _this = _possibleConstructorReturn(this, (ContestsPage.__proto__ || Object.getPrototypeOf(ContestsPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ContestsPage");
			return _this;
		}
	
		_createClass(ContestsPage, [{
			key: "onViewChange",
			value: function onViewChange(view) {
				this.changeView({ activeView: view });
			}
		}, {
			key: "openInviteModal",
			value: function openInviteModal() {
				this.changeView({ showInviteModal: true });
			}
		}, {
			key: "onInviteLinkClick",
			value: function onInviteLinkClick() {
				$wr.redirect("/settings/referral");
			}
		}, {
			key: "hideInviteModal",
			value: function hideInviteModal() {
				this.changeView({ showInviteModal: false });
			}
		}, {
			key: "openSchoolInfoModal",
			value: function openSchoolInfoModal() {
				this.changeView({ showSchoolInfoModal: true });
			}
		}, {
			key: "hideSchoolInfoModal",
			value: function hideSchoolInfoModal() {
				this.changeView({ showSchoolInfoModal: false });
			}
		}, {
			key: "updateSchoolInfo",
			value: function updateSchoolInfo() {
				this.props.populateData();
			}
		}, {
			key: "changeView",
			value: function changeView(update) {
				var _this2 = this;
	
				var newLocationState = _.extend({}, this.props.locationState, update);
	
				$wr.redirect(ContestsRouting.getPath(newLocationState));
				setTimeout(function () {
					_this2.props.populateData();
				}, 10);
			}
		}, {
			key: "changeSubject",
			value: function changeSubject(activeView, subjectType, subjectID) {
				$wr.redirect(ContestsRouting.getPath({
					activeView: this.props.locationState.activeView
				}));
			}
		}, {
			key: "onOrgSelect",
			value: function onOrgSelect(orgIdentifier) {
				var schoolOrgID = parseInt(OrgTypes.fromIdentifier(orgIdentifier).key);
				var schoolID = this.props.getSchoolID(schoolOrgID);
	
				this.changeView({ l2eSchoolID: schoolID });
			}
	
			// invite link should only show when: 
			// 1. current user is not an admin is not a district/school admin
			// 2. current admin is on free product
	
		}, {
			key: "shouldInviteLinkShow",
			value: function shouldInviteLinkShow() {
				if (this.props.asDistrictAdmin || this.props.asSchoolAdmin) {
					return false;
				}
	
				var user = CurrentUser.get();
				return user.product == "wrSolo";
			}
		}, {
			key: "renderToggleControl",
			value: function renderToggleControl() {
				var activeView = this.props.locationState.activeView;
	
				var toggleOptions = [{ key: ContestsRouting.VIEWS.READING, text: "Reading" }, { key: ContestsRouting.VIEWS.WRITING, text: "Writing" }, { key: ContestsRouting.VIEWS.OWLSTAGRAM, text: "Owlstagram" }];
	
				var toggleDisplay = React.createElement(DisplayToggleControl, { options: toggleOptions,
					onChange: this.onViewChange,
					activeOptionKey: activeView });
	
				return toggleDisplay;
			}
		}, {
			key: "renderHeader",
			value: function renderHeader() {
				var school = this.props.school;
				var schoolName = school.name;
				var startDate = school.contests[0].start_date;
				var endDate = school.contests[0].end_date;
	
				if (this.props.asDistrictAdmin) {
					if (school) {
						var orgIdentifier = OrgTypes.toIdentifier({
							type: OrgTypes.SCHOOL_ORG,
							key: this.props.selectedSchoolOrgID
						});
					}
					var orgDropdown = React.createElement(OrgDropdown, { dropdownDisplay: "link",
						selectedIdentifier: orgIdentifier,
						selectionTypes: [OrgTypes.SCHOOL_ORG],
						onSelect: this.onOrgSelect });
				}
	
				if (this.props.showModal) {
					if (!(this.props.asSchoolAdmin || this.props.asDistrictAdmin)) {
						var changeSchoolLink = React.createElement(
							"a",
							{ className: "changeSchoolLink", onClick: this.openSchoolInfoModal },
							"Change School"
						);
					}
				}
	
				var firstOfMonth = (0, _moment2.default)().startOf("month").format("YYYY-MM-DD");
				var lastOfMonth = (0, _moment2.default)().endOf("month").format("YYYY-MM-DD");
	
				if (firstOfMonth == startDate && lastOfMonth == endDate) {
					var datesDisplay = React.createElement(
						"span",
						{ className: "datesHeader" },
						(0, _moment2.default)().format("MMMM YYYY")
					);
				} else {
					var datesDisplay = React.createElement(
						"span",
						{ className: "datesHeader" },
						(0, _moment2.default)(startDate).format("MMM Do, YYYY"),
						" - ",
						(0, _moment2.default)(endDate).format("MMM Do, YYYY")
					);
				}
	
				return React.createElement(
					"header",
					{ className: "pageHeader" },
					React.createElement(
						"h1",
						null,
						schoolName
					),
					changeSchoolLink,
					orgDropdown,
					datesDisplay
				);
			}
		}, {
			key: "renderSamplePhotos",
			value: function renderSamplePhotos() {
				var img_paths = [__webpack_require__(493), __webpack_require__(494), __webpack_require__(492)];
				return img_paths.map(function (path) {
					return React.createElement(
						"div",
						{ className: "photoBox", key: path },
						React.createElement(
							"div",
							{ className: "clearfix textHeader" },
							React.createElement(
								"div",
								{ className: "pull-left" },
								"Name"
							),
							React.createElement(
								"div",
								{ className: "pull-right" },
								"Date"
							)
						),
						React.createElement("img", { className: "photo samplePhoto", src: path })
					);
				});
			}
		}, {
			key: "renderOwlstagram",
			value: function renderOwlstagram() {
				var studentListIDs = _.pluck(this.props.studentLists, "id");
				return React.createElement(PhotosDisplay, {
					isClass: false,
					ids: studentListIDs
				});
			}
		}, {
			key: "renderPageContent",
			value: function renderPageContent(activeView) {
				var school = this.props.school;
	
				var studentLists = _.select(this.props.studentLists, function (studentList) {
					return studentList.digest.student_count > 0;
				});
	
				// Reading Variables
				var readingMetric = school.contests[0].reading_metric;
				var readingGoal = school.contests[0].reading_goal;
				var readingValue = school.digest[readingMetric];
	
				var sortedReadingStudentLists = _.sortBy(studentLists, function (sl) {
					return sl["digest"][readingMetric];
				}).reverse();
				var topReadingStudentLists = _.first(sortedReadingStudentLists, 3);
	
				var topReadingStudentListIDS = _.map(topReadingStudentLists, function (sl) {
					return sl.id;
				});
				var lowerReadingStudentLists = _.reject(sortedReadingStudentLists, function (sl) {
					return _.contains(topReadingStudentListIDS, sl.id);
				});
	
				// Writing Variables
				var writingMetric = school.contests[0].writing_metric;
				var writingGoal = school.contests[0].writing_goal;
				var writingValue = school.digest[writingMetric];
	
				var sortedWritingStudentLists = _.sortBy(studentLists, function (sl) {
					return sl["digest"][writingMetric];
				}).reverse();
				var topWritingStudentLists = _.first(sortedWritingStudentLists, 3);
	
				var topWritingStudentListIDS = _.map(topWritingStudentLists, function (sl) {
					return sl.id;
				});
				var lowerWritingStudentLists = _.reject(sortedWritingStudentLists, function (sl) {
					return _.contains(topWritingStudentListIDS, sl.id);
				});
	
				if (activeView == "reading") {
					var topClasses = topReadingStudentLists;
					var lowerClasses = lowerReadingStudentLists;
					var value = readingValue;
					var goal = readingGoal;
					var metric = readingMetric;
					var imgSrc = __webpack_require__(1620);
				} else {
					var topClasses = topWritingStudentLists;
					var lowerClasses = lowerWritingStudentLists;
					var value = writingValue;
					var goal = writingGoal;
					var metric = writingMetric;
					var imgSrc = __webpack_require__(1621);
				}
	
				var progress;
				progress = value / goal;
				progress = Math.min(progress || 0.0, 1.0);
	
				var percent = Math.round(progress * 100);
	
				if (percent >= 100) {
					var celebrationImgSrc = __webpack_require__(545);
					var celebrationImage = React.createElement("img", { src: imgSrc, alt: "" });
					var celebrationText = React.createElement(
						"p",
						{ className: "statusText" },
						"Congratulations. Your goal has been reached!"
					);
					var celebrationStyle = { backgroundImage: "url(" + celebrationImgSrc + ")" };
					var statusContainer = React.createElement(
						"div",
						{ className: "celebrationContainer" },
						celebrationText,
						React.createElement("div", { className: "celebrationImage", style: celebrationStyle })
					);
					var goalMet = "goalMet";
				} else if (percent == 0) {
					var statusContainer = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "statusText" },
							"It's time to get to work and make some progress on this goal!"
						)
					);
				}
	
				var meterStyle = { backgroundImage: "url(" + imgSrc + ")", width: percent + "%" };
	
				var unitName = StudentMetrics.inverseLookup(metric);
				var adjustedUnitName = StudentMetrics.getUnit(unitName);
	
				if (unitName == "writing") {
					var unitTip = "Answers, Quizzes, Reviews, and Exercises";
					var tooltipIcon = React.createElement(
						"span",
						null,
						" ",
						React.createElement(Glyphicon, { icon: "question-sign" })
					);
				}
	
				if (!value) {
					var numberValue = 0;
				} else {
					var numberValue = $wr.numberWithCommas(value);
				}
	
				var goalTracker = React.createElement(
					"div",
					{ className: "meterSection" },
					React.createElement(
						"div",
						{ className: "thermometerContainer" },
						React.createElement("div", { className: "progressContainer", style: meterStyle })
					),
					React.createElement(
						"div",
						{ className: "trackerContainer" },
						React.createElement(
							"p",
							{ className: "tracker" },
							React.createElement(
								"span",
								null,
								"Goal: "
							),
							React.createElement(
								"span",
								{ className: "unitText" },
								$wr.numberWithCommas(goal),
								" "
							),
							React.createElement(
								"span",
								{ "data-tip": unitTip },
								adjustedUnitName,
								tooltipIcon
							)
						),
						React.createElement(
							"p",
							{ className: "tracker" },
							React.createElement(
								"span",
								null,
								"So Far: "
							),
							React.createElement(
								"span",
								{ className: "unitText " + goalMet },
								numberValue,
								" "
							),
							React.createElement(
								"span",
								{ className: goalMet },
								adjustedUnitName
							)
						),
						React.createElement(ReactTooltip, { effect: "solid" })
					)
				);
	
				if (studentLists.length) {
					var classesDisplay = React.createElement(
						"div",
						null,
						React.createElement(
							"h3",
							null,
							"Top Classes"
						),
						React.createElement(ClassesDisplay, { classes: topClasses, metric: metric, showTopClasses: true }),
						React.createElement("div", { className: "dividerArea" }),
						React.createElement(ClassesDisplay, { classes: lowerClasses, metric: metric })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "contestContainer readingContainer" },
					statusContainer,
					goalTracker,
					classesDisplay
				);
			}
		}, {
			key: "render",
			value: function render() {
				var school = this.props.school;
	
				var activeView = this.props.locationState.activeView;
	
	
				if (school == null) {
					if (this.props.asDistrictAdmin && !this.props.loading) {
						var school = this.props.school;
	
						if (school) {
							var orgIdentifier = OrgTypes.toIdentifier({
								type: OrgTypes.SCHOOL_ORG,
								key: this.props.selectedSchoolOrgID
							});
						}
	
						var orgDropdown = React.createElement(OrgDropdown, { dropdownDisplay: "link",
							selectedIdentifier: orgIdentifier,
							selectionTypes: [OrgTypes.SCHOOL_ORG],
							onSelect: this.onOrgSelect });
						return React.createElement(
							"div",
							{ className: "" },
							React.createElement(
								"header",
								{ className: "pageHeader" },
								React.createElement(
									"h1",
									null,
									"School Page"
								),
								React.createElement(
									"p",
									null,
									"Select a school:"
								),
								orgDropdown
							)
						);
					} else {
						return React.createElement(
							"div",
							{ className: "" },
							React.createElement(Spinner, { placeholder: true, scale: 1.7 })
						);
					}
				}
	
				if (activeView != "owlstagram") {
					var pageContent = this.renderPageContent(activeView);
				} else {
					var pageContent = this.renderOwlstagram();
				}
	
				if (this.props.showModal) {
					if (this.props.locationState.showInviteModal) {
						var inviteModal = React.createElement(InviteTeachersModal, { onClose: this.hideInviteModal });
					} else if (this.props.locationState.showSchoolInfoModal) {
						var schoolInfoModal = React.createElement(SchoolInfoModal, { allowHide: true,
							onClose: this.hideSchoolInfoModal, updateSchoolInfo: this.updateSchoolInfo });
					}
					// Kevin 10/2021: the modal was not functional since the Cio campaign was turned off
					// Redirect users to the referral settings page instead
					if (this.shouldInviteLinkShow()) {
						var inviteTeachers = React.createElement(
							"div",
							{ className: "inviteTeachersContainer" },
							React.createElement(
								"span",
								null,
								"Want more classes to participate?"
							),
							React.createElement(
								"button",
								{ className: "buttonPrimary", onClick: this.onInviteLinkClick },
								"Invite Teachers"
							),
							inviteModal
						);
					}
				}
	
				if (CurrentUser.isAdmin()) {
					var onboardingChecklist = React.createElement(OnboardingChecklist, null);
				}
	
				if (this.props.showEditPrompt && activeView != 'owlstagram') {
					var editInstructions = React.createElement(
						"p",
						null,
						React.createElement("br", null),
						"Want to set this page to specific dates or make other customizations?",
						" ",
						React.createElement(
							"a",
							{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/360038828332-Customize-your-School-Page",
								target: "_blank" },
							"Learn how here."
						)
					);
				}
	
				var toggleDisplay = this.renderToggleControl();
				var pageHeader = this.renderHeader();
	
				return React.createElement(
					"div",
					{ className: "container contestsPage" },
					onboardingChecklist,
					pageHeader,
					toggleDisplay,
					editInstructions,
					pageContent,
					inviteTeachers,
					schoolInfoModal
				);
			}
		}]);
	
		return ContestsPage;
	}(React.Component)) || _class) || _class) || _class);
	
	
	ContestsPage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object,
	
		// @connect data
		school: PropTypes.object,
		studentLists: PropTypes.array,
		showInvite: PropTypes.bool,
		asSchoolAdmin: PropTypes.bool,
		asDistrictAdmin: PropTypes.bool,
		showEditPrompt: PropTypes.bool,
		loading: PropTypes.bool,
		selectedSchoolOrgID: PropTypes.number,
	
		// @connect data fetchers
		getSchoolID: PropTypes.func,
	
		// @connect handlers
		populateData: PropTypes.func
	});
	
	module.exports = ContestsPage;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ErrorDisplay = __webpack_require__(51);
	
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3692);
	
	var InviteTeachersModal = (_dec = (0, _reactRedux.connect)(function () {
		return {};
	}, function (dispatch, propTypes) {
		return {
			postReferrals: function postReferrals(referralData) {
				dispatch(RosterActions.postReferrals({
					referral: referralData
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(InviteTeachersModal, _React$Component);
	
		function InviteTeachersModal(props) {
			_classCallCheck(this, InviteTeachersModal);
	
			var _this = _possibleConstructorReturn(this, (InviteTeachersModal.__proto__ || Object.getPrototypeOf(InviteTeachersModal)).call(this));
	
			autobind(_this);
	
			_this.state = { emailsText: "" };
			_this.modal = React.createRef();
			_this.errors = React.createRef();
			return _this;
		}
	
		_createClass(InviteTeachersModal, [{
			key: "onSubmit",
			value: function onSubmit() {
				this.errors.current.reset();
	
				var recipients = _.map(this.state.emailsText.split(/[ ,\n]/g), function (x) {
					return x.trim();
				});
				var validEmails = _.select(recipients, $wr.isValidEmail);
	
				if (validEmails.length) {
					this.props.postReferrals({ emails: validEmails });
					this.modal.current.hide();
				} else {
					this.errors.current.setError("Enter at least one valid email.");
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				return React.createElement(
					"div",
					{ className: "inviteTeachersModal" },
					React.createElement(
						Modal,
						{ ref: this.modal, selfOpen: true, onHide: this.props.onClose, headerText: "Invite teachers to use Whooo's Reading" },
						React.createElement(
							"div",
							{ className: "modal-body" },
							React.createElement(
								"p",
								null,
								"Once other teachers at your school sign up, classes will be able to compare progress, work towards a common goal, or set up a friendly competition!"
							),
							React.createElement(ErrorDisplay, { ref: this.errors }),
							React.createElement("textarea", { className: "form-control inviteRecipients", rows: "2", cols: "20",
								placeholder: "Enter emails", value: this.state.emailsText,
								onChange: function onChange(e) {
									_this2.setState({ emailsText: e.target.value });
								} }),
							React.createElement(
								"button",
								{ className: "buttonSuccess center-block", onClick: this.onSubmit },
								"Send"
							)
						)
					)
				);
			}
		}]);
	
		return InviteTeachersModal;
	}(React.Component)) || _class);
	;
	
	InviteTeachersModal.WrappedComponent.propTypes = StrictPropTypes({
		// @connect handlers
		postReferrals: PropTypes.func,
		onClose: PropTypes.func
	});
	
	module.exports = InviteTeachersModal;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var UIActions = __webpack_require__(41);
	var OrgTypes = __webpack_require__(45);
	
	var DropDownOptions = __webpack_require__(26);
	var NumbersOnlyInput = __webpack_require__(122);
	var PaywallModal = __webpack_require__(44);
	var StudentMetrics = __webpack_require__(29);
	var Features = __webpack_require__(16);
	var Glyphicon = __webpack_require__(8);
	var GradeLevel = __webpack_require__(40);
	var CurrentUser = __webpack_require__(3);
	var ExpectationsCustomizer = __webpack_require__(413);
	var AltModal = __webpack_require__(18);
	var RosterRouting = __webpack_require__(93);
	var ReadingLevelFormat = __webpack_require__(72);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	function triggerDifferentiationDropDown(student) {
		if (student) {
			var text = "You updated " + student.display_name + ".";
		} else {
			var text = "You updated your students.";
		}
		window.wrNotifications.triggerDropDownNotification({
			title: "Success", text: text,
			icon: "ok-sign" });
	}
	
	var DifferentiationRow = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		if (props.student) {
			var prefs = props.student.prefs;
		} else if (props.orgIdentifier) {
			var _OrgTypes$fromIdentif = OrgTypes.fromIdentifier(props.orgIdentifier),
			    type = _OrgTypes$fromIdentif.type,
			    key = _OrgTypes$fromIdentif.key;
	
			if (type === OrgTypes.ALL_STUDENTS) {
				// Use one student lists's prefs as the overall defaults
				var prefs = RosterSelectors.globalStudentListPrefs({ state: state });
			} else if (type === OrgTypes.STUDENT_LIST) {
				var studentList = RosterSelectors.studentList({ state: state, id: key });
				var prefs = studentList.prefs;
			} else if (type === OrgTypes.SUBGROUP) {
				var subgroup = RosterSelectors.subgroup({ state: state, key: key });
	
				// Use one student in the group's prefs as the overall defaults
				var prefs = RosterSelectors.studentsForSubgroupKey({ state: state, subgroupKey: key })[0].prefs;
			}
		}
	
		return {
			prefs: prefs, studentList: studentList, subgroup: subgroup,
			allowStudentDifferentiation: Features.isEnabled(Features.STUDENT_DIFFERENTIATION)
		};
	}, function (dispatch, props) {
		return {
			updatePrefs: function updatePrefs(update) {
				if (props.student) {
					triggerDifferentiationDropDown(props.student);
					return dispatch(RosterActions.updateStudentPrefs({ studentID: props.student.id, update: update }));
				} else {
					var _OrgTypes$fromIdentif2 = OrgTypes.fromIdentifier(props.orgIdentifier),
					    type = _OrgTypes$fromIdentif2.type,
					    key = _OrgTypes$fromIdentif2.key;
	
					if (type === OrgTypes.ALL_STUDENTS) {
						return dispatch(RosterActions.updateAllStudentListPrefs({
							update: update, currentUserID: CurrentUser.get().id, resetStudents: true
						}), triggerDifferentiationDropDown());
					} else if (type == OrgTypes.STUDENT_LIST) {
						return dispatch(RosterActions.updateStudentListPrefs({
							update: update, studentListID: key, resetStudents: true
						}), triggerDifferentiationDropDown());
					} else if (type == OrgTypes.SUBGROUP) {
						return dispatch(RosterActions.massUpdateStudentPrefs({
							update: update, subgroupKey: key,
							embeds: ["student.prefs"]
						}));
					}
				}
			},
	
			updateStudent: function updateStudent(studentID, update) {
				return dispatch(RosterActions.updateStudent({ id: studentID, update: update, embeds: ["student.current_reading_level"]
				}));
			},
	
			showDifferentiationPaywall: function showDifferentiationPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.STUDENT_DIFFERENTIATION }));
			},
	
			showZPDReadingLevelsPaywall: function showZPDReadingLevelsPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS }));
			},
	
			openZpdPaywall: function openZpdPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(DifferentiationRow, _React$Component);
	
		function DifferentiationRow(props) {
			_classCallCheck(this, DifferentiationRow);
	
			var _this = _possibleConstructorReturn(this, (DifferentiationRow.__proto__ || Object.getPrototypeOf(DifferentiationRow)).call(this));
	
			autobind(_this);
			_this.state = _this.getInitialState();
			_this.expectationsModal = React.createRef();
			return _this;
		}
	
		_createClass(DifferentiationRow, [{
			key: "getInitialState",
			value: function getInitialState() {
				return {
					overrideGoals: {}, openFields: {},
					overrideQuizExpectations: {},
					overrideAcademicLevel: null,
					overrideReadingLevel: null,
					overrideSentenceStarter: null,
					overrideWarmupQuestions: null
				};
			}
		}, {
			key: "isStudentRow",
			value: function isStudentRow() {
				return !!this.props.student;
			}
		}, {
			key: "isStudentListRow",
			value: function isStudentListRow() {
				if (this.props.orgIdentifier) {
					return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.STUDENT_LIST;
				}
				return false;
			}
		}, {
			key: "isSubgroupRow",
			value: function isSubgroupRow() {
				if (this.props.orgIdentifier) {
					return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.SUBGROUP;
				}
				return false;
			}
		}, {
			key: "isGlobalRow",
			value: function isGlobalRow() {
				if (this.props.orgIdentifier) {
					return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.ALL_STUDENTS;
				}
				return false;
			}
		}, {
			key: "openAssignmentModal",
			value: function openAssignmentModal(e) {
				$wr.nope(e);
				this.expectationsModal.current.show();
			}
		}, {
			key: "rowLabel",
			value: function rowLabel() {
				if (this.isStudentRow()) {
					return React.createElement(
						"div",
						{ className: "ellipsisText" },
						this.props.student.display_name
					);
				} else if (this.isStudentListRow()) {
					return React.createElement(
						"div",
						{ className: "ellipsisText" },
						this.props.studentList.name,
						React.createElement("br", null),
						React.createElement(
							"span",
							{ className: "smallText" },
							"Classwide Defaults"
						)
					);
				} else if (this.isSubgroupRow()) {
					return React.createElement(
						"div",
						{ className: "ellipsisText" },
						this.props.subgroup.name,
						React.createElement("br", null),
						React.createElement(
							"span",
							{ className: "smallText" },
							"Group Defaults"
						)
					);
				} else {
					return React.createElement(
						"div",
						{ className: "ellipsisText" },
						"All Classes",
						React.createElement("br", null),
						React.createElement(
							"span",
							{ className: "smallText" },
							"Accountwide Defaults"
						)
					);
				}
			}
		}, {
			key: "changedAcademicLevel",
			value: function changedAcademicLevel() {
				return this.state.overrideAcademicLevel !== null;
			}
		}, {
			key: "changedSentenceStarter",
			value: function changedSentenceStarter() {
				return this.state.overrideSentenceStarter !== null;
			}
		}, {
			key: "changedWarmupQuestions",
			value: function changedWarmupQuestions() {
				return this.state.overrideWarmupQuestions !== null;
			}
		}, {
			key: "changedGoals",
			value: function changedGoals() {
				return !_.isEmpty(this.state.overrideGoals);
			}
		}, {
			key: "changedQuizExpectations",
			value: function changedQuizExpectations() {
				return !_.isEmpty(this.state.overrideQuizExpectations);
			}
		}, {
			key: "changedReadingLevels",
			value: function changedReadingLevels() {
				return !_.isEmpty(this.state.overrideReadingLevel);
			}
		}, {
			key: "hasChange",
			value: function hasChange() {
				return this.changedAcademicLevel() || this.changedSentenceStarter() || this.changedWarmupQuestions() || this.changedGoals() || this.changedQuizExpectations() || this.changedReadingLevels();
			}
		}, {
			key: "setGoal",
			value: function setGoal(value, type) {
				var joined = _.extend({}, this.state.overrideGoals, _defineProperty({}, type, value));
				this.setOverride("overrideGoals", joined);
			}
		}, {
			key: "setQuizExpectations",
			value: function setQuizExpectations(value, type) {
				var joined = _.extend({}, this.state.overrideQuizExpectations, _defineProperty({}, type, value));
				this.setOverride("overrideQuizExpectations", joined);
			}
		}, {
			key: "setReadingLevel",
			value: function setReadingLevel(value, type) {
				var joined = _.extend({}, this.state.overrideReadingLevel, _defineProperty({}, type, value));
				this.setOverride("overrideReadingLevel", joined);
			}
		}, {
			key: "setOverride",
			value: function setOverride(key, value) {
				if (this.isStudentRow() && !this.props.allowStudentDifferentiation) {
					if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
						this.props.showDifferentiationPaywall();
					} else {
						this.props.showZPDReadingLevelsPaywall();
					}
					return;
				}
	
				this.setState(_defineProperty({}, key, value));
			}
		}, {
			key: "changeGoal",
			value: function changeGoal(field, e) {
				$wr.nope(e);
				var joined = _.extend({}, this.state.openFields, _defineProperty({}, field, true));
				this.setState({ openFields: joined });
			}
		}, {
			key: "addQuizExpectations",
			value: function addQuizExpectations(update) {
				if (this.changedQuizExpectations()) {
					// UPDATE RECALL COUNT IF OVERIDDED
					var recall_question_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS];
	
					if (recall_question_count != undefined) {
						update.recall_question_count = parseInt(recall_question_count);
					}
	
					// GRAB ANALYSIS QUESTION COUNT FROM OVERRIDE OR PREFS
					var analysis_question_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS];
	
					if (analysis_question_count != undefined) {
						var analysisOveride = true;
					} else {
						var analysisOveride = false;
						analysis_question_count = this.prefs().analysis_question_count > 0 ? this.prefs().analysis_question_count : this.prefs().sentence_starter_count;
					}
	
					// IF SENTENCE STARTER CHANGED UPDATE QUESTIONS COUNTS
					var sentence_starter_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS];
					if (sentence_starter_count != undefined) {
						if (sentence_starter_count == "On") {
							update.sentence_starter_count = parseInt(analysis_question_count);
							update.analysis_question_count = 0;
						} else {
							update.sentence_starter_count = 0;
							update.analysis_question_count = parseInt(analysis_question_count);
						}
					} else {
						if (analysisOveride) {
							if (this.prefs().sentence_starter_count > 0) {
								update.sentence_starter_count = parseInt(analysis_question_count);
							} else {
								update.analysis_question_count = parseInt(analysis_question_count);
							}
						}
					}
				}
			}
		}, {
			key: "submit",
			value: function submit(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (!this.isStudentRow()) {
					var confirmParts = [];
					if (this.changedAcademicLevel()) {
						confirmParts.push("academic level");
					}
					if (this.changedGoals()) {
						confirmParts.push("goals");
					}
					if (this.changedSentenceStarter()) {
						confirmParts.push("sentence starters");
					}
					if (this.changedWarmupQuestions()) {
						confirmParts.push("warmup questions");
					}
					if (this.changedQuizExpectations()) {
						confirmParts.push("quiz composition");
					}
					var confirmMessage = "This will change";
					if (confirmParts.length == 1) {
						confirmMessage += " " + confirmParts[0];
					} else if (confirmParts.length == 2) {
						confirmMessage += " " + confirmParts.join(" and ");
					} else {
						confirmMessage += " " + confirmParts.slice(0, confirmParts.length - 1).join(", ") + ", and " + _.last(confirmParts);
					}
	
					confirmMessage += " for all your students";
					if (this.isStudentListRow()) {
						confirmMessage += " in this class";
					}
					confirmMessage += ".";
	
					if (!confirm(confirmMessage)) {
						return;
					}
				}
	
				var update = {};
	
				if (this.changedAcademicLevel()) {
					update.academic_level = this.state.overrideAcademicLevel;
				}
				if (this.changedSentenceStarter()) {
					update.sentence_starter_count = this.state.overrideSentenceStarter;
				}
				if (this.changedWarmupQuestions()) {
					update.active_warmup_questions = this.state.overrideWarmupQuestions;
				}
	
				if (this.changedGoals()) {
					var expectations = this.prefs().expectations_metrics;
					update.expectations_metrics = _.map(expectations, function (_ref) {
						var metric = _ref.metric,
						    goal = _ref.goal;
	
						var override = _this2.state.overrideGoals[metric];
						if (override === undefined) {
							var value = goal; // Stays the original goal
						} else if (override.trim().length == 0) {
							var value = 0;
						} else {
							var value = parseInt(override);
						}
						return { metric: metric, goal: value };
					});
				}
	
				if (this.changedReadingLevels()) {
					var readingLevelValue = this.refs.lexile.value;
					var params = { current_reading_level: readingLevelValue };
					this.props.updateStudent(this.props.student.id, params);
				}
				this.addQuizExpectations(update);
	
				this.props.updatePrefs(update);
				this.setState(this.getInitialState());
			}
		}, {
			key: "getGoalText",
			value: function getGoalText(metric) {
				return StudentMetrics.getLabel(metric);
			}
		}, {
			key: "prefs",
			value: function prefs() {
				return this.props.prefs;
			}
		}, {
			key: "renderExpectationsModal",
			value: function renderExpectationsModal() {
				if (this.isStudentListRow()) {
					var headerText = this.props.studentList.name + " Goals";
				} else {
					var headerText = "Accountwide Goals";
				}
				return React.createElement(
					AltModal,
					{ className: "expectationsModal", ref: this.expectationsModal,
						headerText: headerText },
					React.createElement(ExpectationsCustomizer, { askConfirmation: true, orgIdentifier: this.props.orgIdentifier })
				);
			}
		}, {
			key: "renderAcademicLevel",
			value: function renderAcademicLevel() {
				var _this3 = this;
	
				if (this.state.overrideAcademicLevel === null) {
					var value = this.prefs().academic_level;
				} else {
					var value = this.state.overrideAcademicLevel;
				}
	
				if (this.isStudentRow() || this.state.openFields["academic_level"]) {
					var cellContent = React.createElement(
						"select",
						{ value: value, className: "form-control studentEditSelectField gradeSelect",
							onChange: function onChange(e) {
								return _this3.setOverride("overrideAcademicLevel", e.target.value);
							} },
						DropDownOptions.Select.GradeLevels()
					);
				} else {
					var cellContent = React.createElement(
						"span",
						{ className: "defaultVal" },
						GradeLevel.getShortName(value),
						" ",
						React.createElement(
							"a",
							{ href: "#", className: "editLink",
								onClick: this.changeGoal.bind(this, "academic_level") },
							"Edit"
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "infoSection academicLevelCell" },
					cellContent
				);
			}
			// defaultReadingLevel() {
			// 	var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
			// 	return ReadingLevelFormat.getLexileScoreForFormat(
			// 		this.props.student.current_reading_level, readingLevelFormat
			// 	);
			// }
	
		}, {
			key: "formattedReadingLevel",
			value: function formattedReadingLevel() {
				var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
				return ReadingLevelFormat.getScoreForFormat(this.props.student.current_reading_level, readingLevelFormat);
			}
		}, {
			key: "triggerRLDPaywall",
			value: function triggerRLDPaywall() {
				this.props.openZpdPaywall();
			}
		}, {
			key: "renderReadingLevel",
			value: function renderReadingLevel() {
				var _this4 = this;
	
				var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
				if (this.props.student) {
					var value = this.formattedReadingLevel();
				}
	
				if (this.isStudentRow()) {
					if (this.state.openFields["reading_level"]) {
						var cellContent = React.createElement(
							"select",
							{ ref: "lexile", defaultValue: this.formattedReadingLevel(),
								className: "form-control", onChange: function onChange(e) {
									return _this4.setReadingLevel(e.target.value, "current_reading_level");
								} },
							DropDownOptions.Select.ReadingLevels({ lexile_to_formats: readingLevelFormat })
						);
					} else {
						var cellContent = React.createElement(
							"span",
							{ className: "defaultVal" },
							value,
							React.createElement(
								"a",
								{ href: "#", className: "editLink",
									onClick: this.changeGoal.bind(this, "reading_level") },
								"Edit"
							)
						);
					}
				} else {
					if (!Features.isEnabled(Features.CLOZE_ASSESSMENTS) && Features.isEnabled(Features.HISTORICAL_DATA)) {
						var cellContent = React.createElement(
							"span",
							{ className: "defaultVal" },
							React.createElement(
								"a",
								{ className: "editLink editClassLink",
									onClick: this.triggerRLDPaywall.bind(this) },
								"Start classwide assessment"
							)
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "infoSection academicLevelCell" },
					cellContent
				);
			}
		}, {
			key: "renderQuizGoals",
			value: function renderQuizGoals() {
				var _this5 = this;
	
				var prefs = this.prefs();
				var expectations = prefs.expectations_metrics.filter(function (_ref2) {
					var metric = _ref2.metric,
					    goal = _ref2.goal;
					return metric == "quizzes-passed";
				});
	
				expectations.push({ metric: StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS, goal: prefs.recall_question_count });
	
				// IF SENTENCE STARTER PRESENT TRANSLATE INTO ANALYSIS QUESTIONS
				if (prefs.sentence_starter_count > 0) {
					var analysis_count = prefs.sentence_starter_count;
					var sentence_starter = "On";
				} else {
					var analysis_count = prefs.analysis_question_count;
					var sentence_starter = "Off";
				}
				expectations.push({ metric: StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS, goal: analysis_count });
				expectations.push({ metric: StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS, goal: sentence_starter });
	
				var periodName = $wr.capitalize($wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]);
	
				if (this.isStudentRow()) {
					var editIcon = React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" })
					);
				}
	
				if (expectations.length == 0) {
					if (this.isStudentRow()) {
						var goalsContainers = React.createElement(
							"span",
							null,
							"No Assignment"
						);
					} else {
						var overallExpectations = React.createElement(
							"span",
							{ onClick: this.openAssignmentModal },
							"No Assignment",
							editIcon
						);
					}
				} else {
					var goalsContainers = _.map(expectations, function (_ref3) {
						var metric = _ref3.metric,
						    goal = _ref3.goal;
	
						if (_this5.state.overrideGoals[metric] === undefined) {
							var value = goal;
						} else {
							var value = _this5.state.overrideGoals[metric];
						}
	
						if (metric == "quizzes-passed") {
							var frequency = "/" + periodName;
						}
						if (_this5.state.openFields[metric]) {
							var options = StudentMetrics.getOptions(metric);
							if (options) {
								var input = React.createElement(
									"select",
									{ type: "text", className: "goalInput", ref: metric,
										defaultValue: goal, onChange: function onChange(e) {
											_this5.setQuizExpectations(_this5.refs[metric].value, metric);
										} },
									options
								);
							} else {
								var input = React.createElement(NumbersOnlyInput, { value: value, className: "goalInput",
									onChange: function onChange(e) {
										return _this5.setGoal(e.target.value, metric);
									},
									autoFocus: true });
							}
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this5.getGoalText(metric)
								),
								input
							);
						} else if (_this5.isStudentRow()) {
							// var options = StudentMetrics.getOptions(metric)
							// if (options) {
							// 	var input = (
							// 		<select type="text" className="goalInput" ref={metric}
							// 				defaultValue={ goal } onChange={(e) => {this.setGoal(metric, this.refs[metric].value)}}>
							// 				{ options }
							// 		</select>
							// 	)
							// } else {
							var input = React.createElement(
								"span",
								{ className: "goalInput", onClick: _this5.changeGoal.bind(_this5, metric) },
								value
							);
							// }
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this5.getGoalText(metric)
								),
								input,
								editIcon
							);
						} else {
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this5.getGoalText(metric)
								),
								React.createElement(
									"span",
									null,
									value
								),
								frequency
							);
						}
					});
					if (this.isStudentRow()) {
						var className = "studentGoalsSection";
					} else {
						var periodName = $wr.capitalize($wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]);
						// var overallExpectations = (
						// 	<div className="goalContainer">
						// 		<span className="goalTitle">Time Period</span>
						// 		<span>
						// 			{ periodName }
						// 		</span>
						// 	</div>
						// );
						var overallEdit = React.createElement(
							"a",
							{ className: "btn-link overallEdit", href: "#",
								onClick: this.openAssignmentModal },
							"Edit"
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "infoSection quizzesCell" },
					React.createElement(
						"div",
						{ className: "goalsSection " + className },
						goalsContainers,
						overallExpectations
					),
					overallEdit
				);
			}
		}, {
			key: "renderPracticeGoals",
			value: function renderPracticeGoals() {
				var _this6 = this;
	
				var filtered_metrics = this.prefs().expectations_metrics.filter(function (_ref4) {
					var metric = _ref4.metric,
					    goal = _ref4.goal;
					return StudentMetrics.PRACTICE_EXPECTATION_METRICS.includes(metric);
				});
	
				var expectations = _.sortBy(filtered_metrics, "metric");
	
				if (this.isStudentRow()) {
					var editIcon = React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" })
					);
				}
	
				if (expectations.length == 0) {
					if (this.isStudentRow()) {
						var goalsContainers = React.createElement(
							"span",
							null,
							"No Assignment"
						);
					} else {
						var overallExpectations = React.createElement(
							"span",
							{ onClick: this.openAssignmentModal },
							"No Assignment",
							editIcon
						);
					}
				} else {
					var goalsContainers = _.map(expectations, function (_ref5) {
						var metric = _ref5.metric,
						    goal = _ref5.goal;
	
						if (_this6.state.overrideGoals[metric] === undefined) {
							var value = goal;
						} else {
							var value = _this6.state.overrideGoals[metric];
						}
	
						if (_this6.state.openFields[metric]) {
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this6.getGoalText(metric)
								),
								React.createElement(NumbersOnlyInput, { value: value, className: "goalInput",
									onChange: function onChange(e) {
										return _this6.setGoal(e.target.value, metric);
									},
									autoFocus: true })
							);
						} else if (_this6.isStudentRow()) {
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this6.getGoalText(metric)
								),
								React.createElement(
									"span",
									{ className: "goalInput", onClick: _this6.changeGoal.bind(_this6, metric) },
									value
								),
								editIcon
							);
						} else {
							return React.createElement(
								"div",
								{ className: "goalContainer", key: metric },
								React.createElement(
									"span",
									{ className: "goalTitle" },
									_this6.getGoalText(metric)
								),
								React.createElement(
									"span",
									null,
									value
								)
							);
						}
					});
					if (this.isStudentRow()) {
						var className = "studentGoalsSection";
					} else {
						var periodName = $wr.capitalize($wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]);
						// var overallExpectations = (
						// 	<div className="goalContainer">
						// 		<span className="goalTitle">Time Period</span>
						// 		<span>
						// 			{ periodName }
						// 		</span>
						// 	</div>
						// );
						var overallEdit = React.createElement(
							"a",
							{ className: "btn-link overallEdit", href: "#",
								onClick: this.openAssignmentModal },
							"Edit"
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "infoSection practiceCell" },
					React.createElement(
						"div",
						{ className: "goalsSection " + className },
						goalsContainers,
						overallExpectations
					),
					overallEdit
				);
			}
		}, {
			key: "sentenceStarterText",
			value: function sentenceStarterText(index) {
				if (index == 0) {
					return "No starters";
				} else if (index == 1) {
					return "First question only";
				} else if (index == 2) {
					return "All questions";
				}
			}
		}, {
			key: "renderSentenceStarters",
			value: function renderSentenceStarters() {
				var _this7 = this;
	
				if (this.state.overrideSentenceStarter === null) {
					var value = this.prefs().sentence_starter_count;
				} else {
					var value = this.state.overrideSentenceStarter;
				}
	
				if (this.isStudentRow() || this.state.openFields["sentence_starter_count"]) {
					var cellContent = React.createElement(
						"select",
						{ value: value, className: "form-control studentEditSelectField gradeSelect",
							onChange: function onChange(e) {
								return _this7.setOverride("overrideSentenceStarter", e.target.value);
							} },
						React.createElement(
							"option",
							{ value: 0 },
							this.sentenceStarterText(0)
						),
						React.createElement(
							"option",
							{ value: 1 },
							this.sentenceStarterText(1)
						),
						React.createElement(
							"option",
							{ value: 2 },
							this.sentenceStarterText(2)
						)
					);
				} else {
					var cellContent = React.createElement(
						"span",
						{ className: "defaultVal" },
						this.sentenceStarterText(value),
						" ",
						React.createElement(
							"a",
							{ href: "#", className: "editLink",
								onClick: this.changeGoal.bind(this, "sentence_starter_count") },
							"Edit"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "infoSection sentenceStarterCell" },
					cellContent
				);
			}
		}, {
			key: "renderWarmupQuestions",
			value: function renderWarmupQuestions() {
				var _this8 = this;
	
				if (this.state.overrideWarmupQuestions === null) {
					var value = this.prefs().active_warmup_questions;
				} else {
					var value = this.state.overrideWarmupQuestions;
				}
	
				if (this.isStudentRow() || this.state.openFields["active_warmup_questions"]) {
					var cellContent = React.createElement(
						"select",
						{ value: value + "", className: "form-control studentEditSelectField gradeSelect",
							onChange: function onChange(e) {
								return _this8.setOverride("overrideWarmupQuestions", e.target.value);
							} },
						DropDownOptions.Select.DifferentiatedLearning()
					);
				} else {
					var cellContent = React.createElement(
						"span",
						{ className: "defaultVal" },
						value ? "On" : "Off",
						" ",
						React.createElement(
							"a",
							{ href: "#", className: "editLink",
								onClick: this.changeGoal.bind(this, "active_warmup_questions") },
							"Edit"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "infoSection warmupCell" },
					cellContent
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.hasChange()) {
					var saveLink = React.createElement(
						"div",
						{ className: "saveCell" },
						React.createElement(
							"a",
							{ className: "saveLink", href: "#", onClick: this.submit },
							"Save"
						)
					);
				}
	
				if (!this.isStudentRow()) {
					var expectationModal = this.renderExpectationsModal();
				}
	
				if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
					var data = React.createElement(
						"div",
						{ className: "dataContainer" },
						React.createElement("div", { className: "infoSection academicLevelCell" }),
						this.renderQuizGoals(),
						this.renderPracticeGoals()
					);
				} else {
					var data = React.createElement(
						"div",
						{ className: "dataContainer" },
						React.createElement("div", { className: "infoSection firstEmptyCell" }),
						this.renderAcademicLevel(),
						React.createElement("div", { className: "infoSection lastEmptyCell" }),
						this.renderReadingLevel()
					);
				}
	
				return React.createElement(
					"div",
					{ className: "differentiationRow" },
					React.createElement(
						"div",
						{ className: "rowContent" },
						React.createElement(
							"div",
							{ className: "" },
							React.createElement(
								"div",
								{ className: "ellipsisText studentNameCell" },
								this.rowLabel()
							),
							data,
							saveLink,
							expectationModal
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if ($wr.getURLParameterByName("edit_expectations") && !this.isStudentRow()) {
					this.expectationsModal.current.show();
				}
			}
		}]);
	
		return DifferentiationRow;
	}(React.Component)) || _class);
	;
	
	DifferentiationRow.propTypes = StrictPropTypes({
		student: PropTypes.object,
		orgIdentifier: PropTypes.string,
		activeView: PropTypes.string,
	
		// Data from @connect
		allowStudentDifferentiation: PropTypes.bool,
		studentList: PropTypes.object,
		subgroup: PropTypes.object,
		prefs: PropTypes.object,
	
		// Handlers from @connect
		showDifferentiationPaywall: PropTypes.func,
		updatePrefs: PropTypes.func
	
	});
	
	module.exports = DifferentiationRow;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DifferentiationRow = __webpack_require__(808);
	var DropDownOptions = __webpack_require__(26);
	
	var Spinner = __webpack_require__(9);
	var OrgTypes = __webpack_require__(45);
	var OrgDropdown = __webpack_require__(100);
	
	var RosterSelectors = __webpack_require__(6);
	
	var RosterRouting = __webpack_require__(93);
	var EmptyStateContainer = __webpack_require__(80);
	var StudentMetrics = __webpack_require__(29);
	
	__webpack_require__(3693);
	
	var DifferentiationTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			students: RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: props.orgIdentifier })
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(DifferentiationTable, _React$Component);
	
		function DifferentiationTable(props) {
			_classCallCheck(this, DifferentiationTable);
	
			var _this = _possibleConstructorReturn(this, (DifferentiationTable.__proto__ || Object.getPrototypeOf(DifferentiationTable)).call(this));
	
			autobind(_this);
			var openExpectationsModal = window.location.href.includes("showExpectations");
	
			_this.state = { openExpectationsModal: openExpectationsModal, currentView: DifferentiationTable.GOALS_VIEW };
			_this.expectationsModal = React.createRef();
			return _this;
		}
	
		_createClass(DifferentiationTable, [{
			key: "onOrgSelect",
			value: function onOrgSelect(orgIdentifier) {
				this.props.changeOrgIdentifier(orgIdentifier);
			}
		}, {
			key: "renderTableHeaders",
			value: function renderTableHeaders() {
				if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
					var headerRows = React.createElement(
						"div",
						null,
						React.createElement("div", { className: "header studentNameCell" }),
						React.createElement("div", { className: "header studentNameCell" }),
						React.createElement(
							"div",
							{ className: "header quizzesCell" },
							"Quizzes"
						),
						React.createElement(
							"div",
							{ className: "header practiceCell" },
							"Supplemental Tasks"
						)
					);
				} else {
					var headerRows = React.createElement(
						"div",
						null,
						React.createElement("div", { className: "header studentNameCell" }),
						React.createElement("div", { className: "header studentNameCell" }),
						React.createElement(
							"div",
							{ className: "header quizzesCell" },
							"Academic Level",
							React.createElement("br", null)
						),
						React.createElement(
							"div",
							{ className: "header practiceCell" },
							"Reading Level",
							React.createElement("br", null)
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "studentRow headerRow" },
					React.createElement(
						"div",
						{ className: "rowContent" },
						headerRows
					)
				);
			}
		}, {
			key: "renderStudentRows",
			value: function renderStudentRows() {
				var _this2 = this;
	
				var students = $wr.sortByName(this.props.students, "flexName");
	
				var studentRows = _.map(students, function (student) {
					return React.createElement(DifferentiationRow, { student: student, prefs: student.prefs,
						activeView: _this2.props.activeView, key: student.id });
				});
	
				return React.createElement(
					"div",
					null,
					studentRows
				);
			}
		}, {
			key: "renderEmptyState",
			value: function renderEmptyState() {
				var rosterPath = "/roster?addNewStudentsButton=true";
				var emptyActionText = React.createElement(
					"p",
					null,
					"It looks like you haven't added any students yet.",
					" ",
					React.createElement(
						_reactRouterDom.Link,
						{ to: rosterPath },
						"Add students"
					),
					" ",
					"and their recent quiz data will appear here!"
				);
				var emptyImgPath = __webpack_require__(1554);
	
				return React.createElement(
					"div",
					{ className: "text-center" },
					React.createElement(EmptyStateContainer, { className: "emptyDashboard", actionText: emptyActionText,
						linkPath: rosterPath, imagePath: emptyImgPath })
				);
			}
		}, {
			key: "renderGroupSettings",
			value: function renderGroupSettings() {
				// If this is undefined, this is for global instead
				return React.createElement(
					"div",
					{ className: "groupDiff" },
					React.createElement(DifferentiationRow, { activeView: this.props.activeView,
						orgIdentifier: this.props.orgIdentifier })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var selector = React.createElement(OrgDropdown, { dropdownDisplay: "link",
					selectedIdentifier: this.props.orgIdentifier,
					omitSelectionTypes: [OrgTypes.SCHOOL_ORG],
					onSelect: this.onOrgSelect });
	
				return React.createElement(
					"div",
					{ className: "differentiationTable" },
					selector,
					this.renderTableHeaders(),
					this.renderGroupSettings(),
					this.renderStudentRows()
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.state.openExpectationsModal) {
					this.openAssignmentModal();
				}
				$(window.document).trigger("onboarding-trigger-customize-assignments");
			}
		}]);
	
		return DifferentiationTable;
	}(React.Component)) || _class);
	;
	
	DifferentiationTable.WrappedComponent.propTypes = StrictPropTypes({
		// Data inserted by @connect
		students: PropTypes.array.isRequired,
	
		// From above component
		changeOrgIdentifier: PropTypes.func.isRequired, // Called to change subject of the table,
		orgIdentifier: PropTypes.string,
		activeView: PropTypes.string
	});
	
	var ALL_CLASSES_FAKE_ID = -999;
	
	module.exports = DifferentiationTable;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var LoadingButton = __webpack_require__(17);
	var ReactTooltip = __webpack_require__(12);
	var Glyphicon = __webpack_require__(8);
	
	var HelpSectionLink = __webpack_require__(64);
	
	__webpack_require__(3695);
	
	// EVENT LISTENER FUNCTIONS TO ALERT USERS UPON LEAVING BEFORE SAVING
	var preventLeavingWindowFunc = null;
	var preventReloadingFunc = null;
	
	var ActivationCodesPreferences = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var selectedSchoolOrgs = [];
		var selectedDistrictOrgs = [];
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
		var refPrefs = {};
	
		var selectedSchoolOrgs = [];
	
		if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
			selectedSchoolOrgs = RosterSelectors.schoolOrgs({
				state: state, conditions: { ids: admin.org_ids.school_orgs.all }
			});
		}
		if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.all) {
			var selectedDistrictOrgs = RosterSelectors.districtOrgs({
				state: state, conditions: { ids: admin.org_ids.district_orgs.all }
			});
	
			if (selectedDistrictOrgs.length > 0) {
				selectedSchoolOrgs = selectedDistrictOrgs[0].school_orgs;
			}
		}
	
		return {
			admin: admin,
			selectedSchoolOrgs: selectedSchoolOrgs
		};
	}, function (dispatch, props) {
		return {
	
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['admin.org_ids'],
					cache: false
				})).then(function (response) {
					var currentAdmin = response.admins[0];
					if (currentAdmin) {
						if (CurrentUser.isSchoolAdmin()) {
							if (currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all.length > 0) {
								// LOAD SCHOOL ORGS
								return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
									filters: { ids: currentAdmin.org_ids.school_orgs.all },
									embeds: ['school_org.prefs'],
									cache: false
								}))]);
							}
						} else {
							if (currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.all.length > 0) {
								// LOAD DISTRICT ORGS
								return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
									filters: { ids: currentAdmin.org_ids.district_orgs.all },
									embeds: ['school_org.prefs,district_org.school_orgs'],
									cache: false
								}))]);
							}
						}
					}
				})]);
			},
			onSchoolPrefChange: function onSchoolPrefChange(schoolOrgID, prefsUpdate) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Activation Codes have been saved!", text: "Activation codes will be sent shortly. Hang tight!", icon: "ok-sign"
				});
				return dispatch(RosterActions.updateSchoolOrgPrefs({
					currentUserID: CurrentUser.get().id,
					schoolOrgID: schoolOrgID,
					resetPrefs: true,
					embeds: ['school_org.prefs,district_org.school_orgs'],
					update: { "activation_codes": prefsUpdate }
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ActivationCodesPreferences, _React$Component);
	
		function ActivationCodesPreferences(props) {
			_classCallCheck(this, ActivationCodesPreferences);
	
			var _this = _possibleConstructorReturn(this, (ActivationCodesPreferences.__proto__ || Object.getPrototypeOf(ActivationCodesPreferences)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ActivationCodesPreferences");
	
			var state = { toggleBulkEntry: false, activationCodes: [], updated: false, selectedRole: TEACHER_TYPE };
			if (props.selectedSchoolOrgs.length > 0) {
				var schoolOrgs = _.sortBy(props.selectedSchoolOrgs, function (schoolOrg) {
					return schoolOrg.name;
				});
				state["selectedSchool"] = schoolOrgs[0].id;
				if (schoolOrgs[0].prefs.activation_codes) {
					state["activationCodes"] = schoolOrgs[0].prefs.activation_codes;
				}
			}
			_this.state = state;
			return _this;
		}
	
		_createClass(ActivationCodesPreferences, [{
			key: "codesHaveChanged",
			value: function codesHaveChanged() {
				return false;
			}
		}, {
			key: "selectSchool",
			value: function selectSchool(selectedSchool) {
	
				if (!this.state.updated || window.confirm("Your changes will not be saved. Are you sure you'd like to proceed?")) {
					var activationCodes = _.values(_.pick(this.props.selectedSchoolOrgs, function (so) {
						return so.id == selectedSchool.target.value;
					}))[0].prefs.activation_codes;
					this.setState({ selectedSchool: selectedSchool.target.value, toggleBulkEntry: false, activationCodes: activationCodes, selectedRole: TEACHER_TYPE, updated: false });
				}
			}
		}, {
			key: "selectRole",
			value: function selectRole(i, selectedRole) {
				selectedRole = selectedRole.target.value;
				if (i > -1) {
					var newAC = this.state.activationCodes;
					newAC[i]["role"] = selectedRole;
					this.setState({ activationCodes: newAC });
				} else {
					this.setState({ selectedRole: selectedRole });
				}
			}
		}, {
			key: "renderSchoolSelect",
			value: function renderSchoolSelect() {
				var schoolOrgs = _.sortBy(this.props.selectedSchoolOrgs, function (schoolOrg) {
					return schoolOrg.name;
				});
	
				var options = _.map(schoolOrgs, function (school) {
					return React.createElement(
						"option",
						{ value: school.id, key: school.id },
						" ",
						school.name,
						" "
					);
				});
				return React.createElement(
					"div",
					{ className: "school-select" },
					React.createElement(
						"b",
						null,
						"Select a school"
					),
					React.createElement(
						"select",
						{ value: this.state.selectedSchool, className: "form-control gradeSelect",
							onChange: this.selectSchool.bind(this) },
						options
					)
				);
			}
		}, {
			key: "renderBulkEntry",
			value: function renderBulkEntry() {
				var _this2 = this;
	
				if (this.state.toggleBulkEntry) {
					return React.createElement(
						"div",
						{ className: "bulk-entry" },
						React.createElement("textarea", { ref: "bulk_entry", className: "form-control", rows: 10, placeholder: "You can paste teacher names and emails directly in this form.\n\nValid format:\nfirst name, last name, email\n\nExample:\nHarry, Potter, mischiefmanaged@hogwarts.edu\nMatilda, Wormwood, readingismagic@library.k21.us\n..." }),
						React.createElement(
							"div",
							{ className: "action" },
							React.createElement(
								"a",
								{ onClick: function onClick(e) {
										_this2.setState({ toggleBulkEntry: !_this2.state.toggleBulkEntry });
									} },
								"hide"
							),
							React.createElement(
								"button",
								{ className: "btn btn-default text-center", onClick: this.addBulkEntry.bind(this) },
								"add"
							)
						)
					);
				} else {
					return React.createElement(
						"a",
						{ onClick: function onClick(e) {
								_this2.setState({ toggleBulkEntry: !_this2.state.toggleBulkEntry });
							} },
						"show bulk entry"
					);
				}
			}
		}, {
			key: "toggleStatus",
			value: function toggleStatus(i) {
				var newAC = this.state.activationCodes;
				newAC[i].status = "edit";
				this.setState({ activationCodes: newAC });
			}
		}, {
			key: "removeCode",
			value: function removeCode(i) {
				var newAC = this.state.activationCodes;
				newAC.splice(i, 1);
				if (window.confirm("Are you sure you';'d like to delete this Validation Code?")) {
					this.setState({ activationCodes: newAC }, this.triggerSend.bind(this));
				}
			}
		}, {
			key: "renderCodeRow",
			value: function renderCodeRow(ac, i) {
	
				if ("first_name" in ac) {
					if (ac.status == "pending" || ac.status == "error") {
						if (ac.status == "pending") {
							var edit = React.createElement(
								"a",
								{ onClick: this.toggleStatus.bind(this, i) },
								"edit"
							);
						}
						return React.createElement(
							"tr",
							{ key: ac.email, className: ac.status },
							React.createElement(
								"td",
								null,
								React.createElement(
									"div",
									null,
									React.createElement("input", { disabled: true, className: "form-control name-field", type: "text", placeholder: "First name", defaultValue: ac.first_name }),
									React.createElement("input", { disabled: true, className: "form-control name-field", type: "text", placeholder: "Last name", defaultValue: ac.last_name })
								),
								React.createElement("input", { disabled: true, className: "form-control", type: "text", placeholder: "Email", defaultValue: ac.email })
							),
							React.createElement(
								"td",
								null,
								React.createElement(
									"select",
									{ value: ac.role, disabled: true, className: "form-control gradeSelect",
										onChange: this.selectRole.bind(this, i) },
									React.createElement(
										"option",
										{ value: TEACHER_TYPE, key: "Teacher" },
										" Teacher "
									),
									React.createElement(
										"option",
										{ value: SUB_ADMIN_TYPE, key: "Sub-Admin" },
										" Sub Admin "
									),
									React.createElement(
										"option",
										{ value: HEAD_ADMIN_TYPE, key: "Head-Admin" },
										" Head Admin "
									)
								)
							),
							React.createElement(
								"td",
								null,
								React.createElement(
									"div",
									{ className: "text-center" },
									React.createElement(
										"div",
										null,
										React.createElement(
											"b",
											null,
											ac.status
										)
									),
									React.createElement(
										"div",
										null,
										edit
									),
									React.createElement(
										"div",
										null,
										React.createElement(
											"a",
											{ onClick: this.removeCode.bind(this, i), className: "remove" },
											"remove"
										)
									)
								)
							)
						);
					} else if (ac.status == "edit") {
						return React.createElement(
							"tr",
							{ key: ac.email },
							React.createElement(
								"td",
								null,
								React.createElement(
									"div",
									null,
									React.createElement("input", { ref: "first_name_" + i, className: "form-control name-field", type: "text", placeholder: "First name", defaultValue: ac.first_name }),
									React.createElement("input", { ref: "last_name_" + i, className: "form-control name-field", type: "text", placeholder: "Last name", defaultValue: ac.last_name })
								),
								React.createElement("input", { ref: "email_" + i, className: "form-control", type: "text", placeholder: "Email", defaultValue: ac.email })
							),
							React.createElement(
								"td",
								null,
								React.createElement(
									"select",
									{ value: ac.role, className: "form-control gradeSelect",
										onChange: this.selectRole.bind(this, i) },
									React.createElement(
										"option",
										{ value: TEACHER_TYPE, key: "Teacher" },
										" Teacher "
									),
									React.createElement(
										"option",
										{ value: SUB_ADMIN_TYPE, key: "Sub-Admin" },
										" Sub Admin "
									),
									React.createElement(
										"option",
										{ value: HEAD_ADMIN_TYPE, key: "Head-Admin" },
										" Head Admin "
									)
								)
							),
							React.createElement(
								"td",
								null,
								React.createElement(
									"button",
									{ className: "btn btn-default", onClick: this.editCode.bind(this, i) },
									"validate"
								)
							)
						);
					} else if (ac.status == "sent") {
						return React.createElement(
							"tr",
							{ key: ac.email, className: ac.status },
							React.createElement(
								"td",
								null,
								React.createElement(
									"div",
									null,
									ac.first_name + " " + ac.last_name
								),
								React.createElement(
									"div",
									null,
									React.createElement(
										"b",
										null,
										ac.email
									)
								)
							),
							React.createElement(
								"td",
								null,
								ac.role
							),
							React.createElement(
								"td",
								{ className: "text-center" },
								React.createElement(
									"b",
									null,
									ac.status,
									"!"
								)
							)
						);
					}
				} else {
					// LAST ROW ALLOWING USERS TO ADD NEW CODES
					return React.createElement(
						"tr",
						{ key: this.state.activationCodes.length + 1 },
						React.createElement(
							"td",
							null,
							React.createElement(
								"div",
								null,
								React.createElement("input", { ref: "first_name", className: "form-control name-field", type: "text", placeholder: "First name" }),
								React.createElement("input", { ref: "last_name", className: "form-control name-field", type: "text", placeholder: "Last name" })
							),
							React.createElement("input", { ref: "email", className: "form-control", type: "text", placeholder: "Email" })
						),
						React.createElement(
							"td",
							null,
							React.createElement(
								"select",
								{ value: this.state.selectedRole, className: "form-control gradeSelect",
									onChange: this.selectRole.bind(this, -1) },
								React.createElement(
									"option",
									{ value: TEACHER_TYPE, key: "Teacher" },
									" Teacher "
								),
								React.createElement(
									"option",
									{ value: SUB_ADMIN_TYPE, key: "Sub-Admin" },
									" Sub Admin "
								),
								React.createElement(
									"option",
									{ value: HEAD_ADMIN_TYPE, key: "Head-Admin" },
									" Head Admin "
								)
							)
						),
						React.createElement(
							"td",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-default", onClick: this.manualAddCode.bind(this) },
								"add"
							)
						)
					);
				}
			}
		}, {
			key: "renderAssistedInput",
			value: function renderAssistedInput() {
				var _this3 = this;
	
				var rows = _.map(this.state.activationCodes, function (ac, i) {
					return _this3.renderCodeRow(ac, i);
				});
	
				if (this.getCodesByStatus("edit").length == 0) {
					rows.push(this.renderCodeRow({}, 1000));
				}
	
				return React.createElement(
					"table",
					{ className: "table code-table" },
					React.createElement(
						"thead",
						null,
						React.createElement(
							"tr",
							null,
							React.createElement(
								"th",
								null,
								"Account Info"
							),
							React.createElement(
								"th",
								null,
								"Role",
								React.createElement(
									"div",
									{ className: "infoTooltip" },
									React.createElement(Glyphicon, { icon: "info-sign", className: "infoSign", dataTip: "Select admin only if this person needs access to all classes in the school and has no classes of their own" }),
									React.createElement(ReactTooltip, { effect: "solid" })
								)
							),
							React.createElement(
								"th",
								null,
								"Status"
							)
						)
					),
					React.createElement(
						"tbody",
						null,
						rows
					)
				);
			}
		}, {
			key: "editCode",
			value: function editCode(index) {
				var first_name = this.refs["first_name_" + index].value;
				var last_name = this.refs["last_name_" + index].value;
				var email = this.refs["email_" + index].value;
				var role = this.state.activationCodes[index].role;
	
				if (this.validateRow(first_name.trim(), last_name.trim(), email.trim(), -1)) {
					// Add to AC list
					this.addNewCode(first_name, last_name, email, role, index);
				}
			}
		}, {
			key: "manualAddCode",
			value: function manualAddCode() {
				var first_name = this.refs.first_name.value;
				var last_name = this.refs.last_name.value;
				var email = this.refs.email.value;
				if (this.validateRow(first_name.trim(), last_name.trim(), email.trim(), -1)) {
					// Add to AC list
					this.addNewCode(first_name, last_name, email, this.state.selectedRole, -1);
				}
			}
		}, {
			key: "addBulkEntry",
			value: function addBulkEntry() {
				var _this4 = this;
	
				var bulkEntry = this.refs.bulk_entry.value;
				if (bulkEntry.length == 0) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Issue with bulk entry!", text: "It appears you haven't typed anything yet!",
						icon: "exclamation-sign", type: "error" });
				} else if (bulkEntry.split("\n").length > 100) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Limit reached!", text: "Our sending limit is 100 codes at a time. We kindly ask you chunk your request in groups. Send a first 100 codes and then add additional ones.",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else {
					var total = bulkEntry.split("\n").length;
					bulkEntry.split("\n").forEach(function (row, index) {
						_this4.validateBulkString(row, index, total);
					});
				}
			}
		}, {
			key: "validateBulkString",
			value: function validateBulkString(row, index, total) {
				var hasThreePartsRegex = /^[^\s,]+\s*,\s*[^\s,]+\s*,\s*[^\s,]+\s*$/;
	
				if (!hasThreePartsRegex.test(row)) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Issue with line: " + (index + 1) + " in bulk entry!", text: "Check that line and make sure it has a first name, last name and email separated by 2 commas!",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else {
					var parts = row.split(",");
					if (this.validateRow(parts[0].trim(), parts[1].trim(), parts[2].trim(), index)) {
						this.addNewCode(parts[0].trim(), parts[1].trim(), parts[2].trim(), TEACHER_TYPE, -1);
					}
				}
				if (index + 1 >= total) {
					this.setState({ toggleBulkEntry: false });
				}
			}
		}, {
			key: "validateRow",
			value: function validateRow(first_name, last_name, email, index) {
	
				var bulkEntryAlert = "";
				if (index != -1) {
					bulkEntryAlert = " Bulk entry, line: " + (index + 1);
				}
	
				if (!this.validateName(first_name)) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Issue with first name!" + bulkEntryAlert, text: "The first name you entered doesn't look right!",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else if (!this.validateName(last_name)) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Issue with last name!" + bulkEntryAlert, text: "The last name you entered doesn't look right!",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else if (!this.validateEmail(email)) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Issue with email!" + bulkEntryAlert, text: "The email you entered doesn't look right!",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else {
					return true;
				}
			}
		}, {
			key: "isEmailUnique",
			value: function isEmailUnique(email) {
				var eligibleCodes = this.getCodesByStatus("pending");
				eligibleCodes = eligibleCodes.concat(this.getCodesByStatus("sent"));
				var emails = _.map(eligibleCodes, function (ac) {
					return ac.email;
				});
				return !emails.includes(email.toLowerCase());
			}
		}, {
			key: "addNewCode",
			value: function addNewCode(first_name, last_name, email, role, code_index) {
				var _this5 = this;
	
				if (this.state.activationCodes.length > 100) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Limit reached!", text: "Our sending limit is 100 codes at a time. We kindly ask you chunk your request in groups. Send a first 100 codes and then add additional ones.",
						icon: "exclamation-sign", type: "error" }, 6000);
					return null;
				}
	
				if (this.isEmailUnique(email)) {
					var newAC = this.state.activationCodes;
					var update = { "first_name": first_name, "last_name": last_name, "email": email.toLowerCase(), "role": role, "status": "pending"
	
						// Allow for updating Single AC or ADD in bulk
					};if (code_index == -1) {
						newAC.push(update);
					} else {
						newAC[code_index] = update;
					}
					this.setState({ activationCodes: newAC, updated: true, selectedRole: TEACHER_TYPE }, function () {
						localStorage.setItem("activation_codes", JSON.stringify(_this5.getCodesByStatus("pending")));
					});
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Duplicate email addresses!", text: "Warning, it looks like you have duplicate email addresses in your list! Duplicates have not been added.",
						icon: "exclamation-sign", type: "error" }, 6000);
				}
			}
		}, {
			key: "validateName",
			value: function validateName(name) {
				if (name.length == 0 || name.length > 20) {
					return false;
				}
				return true;
			}
		}, {
			key: "validateEmail",
			value: function validateEmail(email) {
				if (!email.includes("@") || !email.includes(".") || email.length < 6) {
					return false;
				}
				return true;
			}
		}, {
			key: "getCodesByStatus",
			value: function getCodesByStatus(status) {
				return _.values(_.pick(this.state.activationCodes, function (ac) {
					return ac.status == status;
				}));
			}
		}, {
			key: "renderSendAction",
			value: function renderSendAction() {
				var pendingCodesCount = this.getCodesByStatus("pending").length;
				var editCodesCount = this.getCodesByStatus("edit").length;
	
				if (pendingCodesCount == 0) {
					return "";
				}
	
				if (editCodesCount > 0) {
					return React.createElement(
						"div",
						{ className: "text-center" },
						React.createElement(LoadingButton, { disabled: true, loading: this.state.loading,
							text: "Send " + pendingCodesCount + " new Activation Code(s)",
							className: "btn buttonSuccess",
							onClick: this.triggerSend.bind(this) }),
						React.createElement(
							"p",
							{ className: "sending-alert" },
							"Make sure you validate every activation code before sending them!"
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "text-center" },
					React.createElement(LoadingButton, { loading: this.state.loading,
						text: "Send " + pendingCodesCount + " new Activation Code(s)",
						className: "btn buttonSuccess",
						onClick: this.triggerSend.bind(this) })
				);
			}
		}, {
			key: "render",
			value: function render() {
	
				if (this.props.selectedSchoolOrgs.length > 0) {
					return React.createElement(
						"div",
						{ className: "ActivationCodesPreferences" },
						React.createElement(
							"p",
							null,
							"Send activation codes to teachers who need to either create a new Whooo's Reading account or need to connect their existing teacher account to the school."
						),
						React.createElement(
							"p",
							null,
							"It's a good idea to",
							React.createElement(
								"a",
								{ onClick: function onClick() {
										$wr.redirect("/settings/rostering-method");
									}, target: "_blank" },
								" select a rostering method"
							),
							" before sending activation code emails.",
							React.createElement(HelpSectionLink, { featureName: "sending Activation Codes to teachers and admins", linkSuffix: "18733905870093", iconOnly: false })
						),
						this.renderSchoolSelect(),
						this.renderBulkEntry(),
						this.renderAssistedInput(),
						this.renderSendAction()
					);
				} else {
					return React.createElement(
						"div",
						null,
						"It looks like your account isn't attached to any school. If this doesn't seem right, please contact ",
						React.createElement(
							"a",
							null,
							"support@whooosreading.org"
						)
					);
				}
			}
		}, {
			key: "triggerSend",
			value: function triggerSend() {
				var _this6 = this;
	
				var editCodesCount = this.getCodesByStatus("edit").length;
				if (editCodesCount > 0) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Some activation codes are still being edited!", text: "Make sure you validate every activation code before sending them!",
						icon: "exclamation-sign", type: "error" }, 6000);
				} else {
					this.props.onSchoolPrefChange(this.state.selectedSchool, this.state.activationCodes).then(function (result) {
						var activationCodes = _.map(_this6.state.activationCodes, function (code) {
							if (code.status == "pending") {
								code["status"] = "sent";
								return code;
							} else {
								return code;
							}
						});
						_this6.setState({ activationCodes: activationCodes, updated: false }, function () {
							localStorage.setItem("activation_codes", "{}");
						});
					});
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				// console.log("REMOVING EVENT LISTENERS")
				document.getElementsByClassName('linksSection')[0].removeEventListener('click', preventLeavingWindowFunc, true);
				document.getElementById('siteHeader').removeEventListener('click', preventLeavingWindowFunc, true);
				window.removeEventListener("beforeunload", preventReloadingFunc, true);
			}
		}, {
			key: "preventLeavingComponent",
			value: function preventLeavingComponent(event) {
				if (this.state.updated) {
					if (!window.confirm("Are you sure you\'d like to proceed? Your pending activation codes will be lost.")) {
						event.stopPropagation();
						event.preventDefault();
					}
				}
			}
		}, {
			key: "preventReload",
			value: function preventReload(event) {
				if (this.state.updated) {
					var confirmationMessage = 'Are you sure you\'d like to proceed?' + 'Your pending activation codes will be lost.';
	
					(event || window.event).returnValue = confirmationMessage; //Gecko + IE
					return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
				}
				// var r = confirm("You pressed a Back button! Are you sure?!");
	
				// if (r != true) {
				// 	console.log("STAY")
				//     // Stay on the current page.
				//     window.history.pushState(null, null, window.location.pathname);
				//     event.stopPropagation();
				//    	event.preventDefault();
				// }
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				// PLACING FUNCTION WITHIN GLOBAL VAR TO ALLOW REMOVING LISTENER ON UNMOUNT
				preventLeavingWindowFunc = this.preventLeavingComponent.bind(this);
				preventReloadingFunc = this.preventReload.bind(this);
	
				window.addEventListener("beforeunload", preventReloadingFunc, true);
				document.getElementsByClassName('linksSection')[0].addEventListener('click', preventLeavingWindowFunc, true);
				document.getElementById('siteHeader').addEventListener('click', preventLeavingWindowFunc, true);
	
				this.loadPendingCodesFromLocal();
			}
		}, {
			key: "loadPendingCodesFromLocal",
			value: function loadPendingCodesFromLocal() {
				var _this7 = this;
	
				var activation_codes = JSON.parse(localStorage.getItem("activation_codes"));
				_.select(activation_codes, function (code) {
					if (code.status == "pending" && _this7.isEmailUnique(code.email)) {
						_this7.addNewCode(code.first_name, code.last_name, code.email, code.role, -1);
					}
				});
			}
		}]);
	
		return ActivationCodesPreferences;
	}(React.Component)) || _class) || _class);
	
	
	var DISTRICT_MANAGER = "district_org";
	var SCHOOL_MANAGER = "school_org";
	
	var TEACHER_TYPE = "teacher";
	var HEAD_ADMIN_TYPE = "head-admin";
	var SUB_ADMIN_TYPE = "sub-admin";
	
	module.exports = ActivationCodesPreferences;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var SchoolYearMonthsPreference = __webpack_require__(245);
	var ExpectationPeriodPreference = __webpack_require__(391);
	var GradeLevelExpectationsPreference = __webpack_require__(392);
	
	__webpack_require__(3697);
	
	var GeneralOrgPreferences = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			onChange: function onChange(prefsUpdate, message) {
				// Will get moved to redux at some point (soon, I hope)
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				var adminID = CurrentUser.get().id;
				var params = { admin: { prefs: prefsUpdate } };
	
				var newPrefs = _.extend({}, CurrentUser.get().prefs, prefsUpdate);
				CurrentUser.updateLocal({ prefs: newPrefs });
	
				CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function (response) {}.bind(undefined)));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(GeneralOrgPreferences, _React$Component);
	
		function GeneralOrgPreferences(props) {
			_classCallCheck(this, GeneralOrgPreferences);
	
			var _this = _possibleConstructorReturn(this, (GeneralOrgPreferences.__proto__ || Object.getPrototypeOf(GeneralOrgPreferences)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("GeneralOrgPreferences");
			return _this;
		}
	
		_createClass(GeneralOrgPreferences, [{
			key: "render",
			value: function render() {
	
				return React.createElement(
					"div",
					{ className: "GeneralOrgPreferences" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h2",
							null,
							"School Year"
						)
					),
					React.createElement(SchoolYearMonthsPreference, null),
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h2",
							null,
							"Expectation Period"
						)
					),
					React.createElement(ExpectationPeriodPreference, null),
					React.createElement(
						"h2",
						null,
						"Grade Level Expectations"
					),
					React.createElement(GradeLevelExpectationsPreference, null)
				);
			}
		}]);
	
		return GeneralOrgPreferences;
	}(React.Component)) || _class);
	
	
	GeneralOrgPreferences.WrappedComponent.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = GeneralOrgPreferences;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3699);
	
	//////////////////// PARTIALLY ABLE TO SUPPORT MULTI ORG ACCOUNTS !!!!!!
	
	var RosteringMethodPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var selectedSchoolOrgs = [];
		var selectedDistrictOrgs = [];
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
		var refPrefs = {};
	
		if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
			var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
				state: state, conditions: { ids: admin.org_ids.school_orgs.all }
			});
			if (selectedSchoolOrgs.length > 0) {
				refPrefs = selectedSchoolOrgs[0].prefs;
			}
		}
		if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.all) {
			var selectedDistrictOrgs = RosterSelectors.districtOrgs({
				state: state, conditions: { ids: admin.org_ids.district_orgs.all }
			});
			if (selectedDistrictOrgs.length > 0) {
				refPrefs = selectedDistrictOrgs[0].prefs;
			}
		}
	
		return {
			admin: admin,
			selectedSchoolOrgs: selectedSchoolOrgs,
			selectedDistrictOrgs: selectedDistrictOrgs,
			refPrefs: refPrefs,
			prefs: {}
		};
	}, function (dispatch, props) {
		return {
	
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['admin.org_ids'],
					cache: false
				})).then(function (response) {
					var currentAdmin = response.admins[0];
					if (currentAdmin) {
						if (CurrentUser.isSchoolAdmin()) {
							if (currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all.length > 0) {
								// LOAD SCHOOL ORGS
								return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
									filters: { ids: currentAdmin.org_ids.school_orgs.all },
									embeds: ['school_org.prefs,school_org.district_org,district_org.prefs'],
									cache: false
								}))]);
							}
						} else {
							if (currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.all.length > 0) {
								// LOAD DISTRICT ORGS
								return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
									filters: { ids: currentAdmin.org_ids.district_orgs.all },
									embeds: ['district_org.prefs,district_org.clever_access_tokens'],
									cache: false
								}))]);
							}
						}
					}
				})]);
			},
			onDistrictPrefChange: function onDistrictPrefChange(districtOrgID, prefsUpdate) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Rostering method saved", text: "Your district preferences were updated", icon: "ok-sign"
				});
				return dispatch(RosterActions.updateDistrictOrgPrefs({
					currentUserID: CurrentUser.get().id,
					districtOrgID: districtOrgID,
					resetPrefs: true,
					update: { "rostering_method": prefsUpdate }
				}), window.location.reload());
			},
			onSchoolPrefChange: function onSchoolPrefChange(schoolOrgID, prefsUpdate) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Rostering method saved", text: "Your school preferences were updated", icon: "ok-sign"
				});
				return dispatch(RosterActions.updateSchoolOrgPrefs({
					currentUserID: CurrentUser.get().id,
					schoolOrgID: schoolOrgID,
					resetPrefs: true,
					update: { "rostering_method": prefsUpdate }
				}), window.location.reload());
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(RosteringMethodPreference, _React$Component);
	
		function RosteringMethodPreference(props) {
			_classCallCheck(this, RosteringMethodPreference);
	
			var _this = _possibleConstructorReturn(this, (RosteringMethodPreference.__proto__ || Object.getPrototypeOf(RosteringMethodPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("RosteringMethodPreference");
	
			// DEFINE DEFAULT PREFS
			if (CurrentUser.isDistrictAdmin()) {
				var selectedManager = DISTRICT_MANAGER;
			} else {
				var selectedManager = SCHOOL_MANAGER;
			}
			var selectedMethod = CLEVER_METHOD;
	
			if (props.refPrefs && props.refPrefs.rostering_method) {
				selectedMethod = props.refPrefs.rostering_method.method;
				selectedManager = props.refPrefs.rostering_method.manager;
			}
	
			_this.state = { selectedManager: selectedManager, selectedMethod: selectedMethod };
			return _this;
		}
	
		_createClass(RosteringMethodPreference, [{
			key: "getInitialSelectedManager",
			value: function getInitialSelectedManager() {
				if (CurrentUser.isDistrictAdmin()) {
					return DISTRICT_MANAGER;
				} else {
					return SCHOOL_MANAGER;
				}
			}
		}, {
			key: "selectOwnedOrgs",
			value: function selectOwnedOrgs(orgs, field) {
				var _this2 = this;
	
				return _.select(orgs, function (org) {
					return _this2.props.admin.org_ids[field]["all"].includes(org.id);
				});
			}
		}, {
			key: "getOrgLabel",
			value: function getOrgLabel() {
				if (CurrentUser.isSchoolAdmin()) {
					return "School";
				} else {
					return "District";
				}
			}
		}, {
			key: "updateManager",
			value: function updateManager(selectedManager) {
				if (selectedManager != this.state.selectedMethod) {
					this.setState({ selectedManager: selectedManager });
				}
			}
		}, {
			key: "updateMethod",
			value: function updateMethod(selectedMethod) {
				if (selectedMethod != this.state.selectedMethod) {
					this.setState({ selectedMethod: selectedMethod });
				}
			}
		}, {
			key: "renderRosteringManagerOption",
			value: function renderRosteringManagerOption() {
	
				if (CurrentUser.isDistrictAdmin()) {
					return React.createElement(
						"div",
						{ className: "section" },
						React.createElement(
							"b",
							null,
							"Who will be in charge of rostering students?"
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", onChange: this.updateManager.bind(this, DISTRICT_MANAGER), checked: this.state.selectedManager == DISTRICT_MANAGER ? true : false }),
								"Rostering will be managed at the district level"
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", onChange: this.updateManager.bind(this, SCHOOL_MANAGER), checked: this.state.selectedManager == SCHOOL_MANAGER ? true : false }),
								"Rostering will be managed by each school admin"
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", onChange: this.updateManager.bind(this, INDIVIDUAL_MANAGER), checked: this.state.selectedManager == INDIVIDUAL_MANAGER ? true : false }),
								"Rostering will be managed by individual teachers"
							)
						)
					);
				} else {
					var disabled = this.isPrefsDisabled();
					return React.createElement(
						"div",
						{ className: "section" },
						React.createElement(
							"b",
							null,
							"Who will be in charge of rostering students?"
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", onChange: this.updateManager.bind(this, SCHOOL_MANAGER), checked: this.state.selectedManager == SCHOOL_MANAGER ? true : false, disabled: disabled }),
								"Rostering will be managed at the school level"
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", onChange: this.updateManager.bind(this, INDIVIDUAL_MANAGER), checked: this.state.selectedManager == INDIVIDUAL_MANAGER ? true : false, disabled: disabled }),
								"Rostering will be managed by individual teachers"
							)
						)
					);
				}
			}
		}, {
			key: "renderUploadMethod",
			value: function renderUploadMethod() {
				var disabled = this.isPrefsDisabled();
	
				if (this.state.selectedManager == INDIVIDUAL_MANAGER) {
					return React.createElement(
						"div",
						{ className: "section" },
						React.createElement(
							"b",
							null,
							"Which rostering method should all teachers use?"
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { disabled: disabled, type: "radio", onChange: this.updateMethod.bind(this, CLEVER_METHOD), checked: this.state.selectedMethod == CLEVER_METHOD ? true : false }),
								"Clever SSO (recommended)"
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { disabled: disabled, type: "radio", onChange: this.updateMethod.bind(this, GOOGLE_METHOD), checked: this.state.selectedMethod == GOOGLE_METHOD ? true : false }),
								"Google SSO (recommended)"
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"label",
								null,
								React.createElement("input", { disabled: disabled, type: "radio", onChange: this.updateMethod.bind(this, MANUAL_METHOD), checked: this.state.selectedMethod == MANUAL_METHOD ? true : false }),
								"Excel, CSV file upload, copy-paste or class codes"
							)
						)
					);
				} else {
	
					// IF DISTRICT ADMIN DELEGATES TO SCHOOL ADMIN
					if (this.state.selectedManager == SCHOOL_MANAGER && CurrentUser.isDistrictAdmin()) {
						return React.createElement(
							"div",
							{ className: "section" },
							React.createElement(
								"b",
								null,
								"School admins will choose the rostering method for each school"
							)
						);
					} else {
						return React.createElement(
							"div",
							{ className: "section" },
							React.createElement(
								"b",
								null,
								"Which rostering method do you wish to use?"
							),
							React.createElement(
								"div",
								null,
								React.createElement(
									"label",
									null,
									React.createElement("input", { disabled: disabled, type: "radio", onChange: this.updateMethod.bind(this, CLEVER_METHOD), checked: this.state.selectedMethod == CLEVER_METHOD ? true : false }),
									"Clever SSO (recommended)"
								)
							),
							React.createElement(
								"div",
								null,
								React.createElement(
									"label",
									null,
									React.createElement("input", { disabled: disabled, type: "radio", onChange: this.updateMethod.bind(this, MANUAL_METHOD), checked: this.state.selectedMethod == MANUAL_METHOD ? true : false }),
									"Excel, CSV file upload, copy-paste or class codes"
								)
							)
						);
					}
				}
			}
		}, {
			key: "renderOrgCleverExplanation",
			value: function renderOrgCleverExplanation(org) {
				if (org.clever_access_tokens && org.clever_access_tokens.length > 0) {
					var lastToken = org.clever_access_tokens.sort(function (a, b) {
						return b.id - a.id;
					})[0];
					if (lastToken.synced_at) {
						var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
	
						var date = new Date(lastToken.synced_at);
						return React.createElement(
							"div",
							null,
							"You have successfully shared your Clever rostering information.",
							React.createElement("br", null),
							"Last Synced: ",
							date.toLocaleDateString(undefined, options)
						);
					}
				}
				return React.createElement(
					"div",
					null,
					"We have not received your Clever rostering data yet.",
					React.createElement("br", null)
				);
			}
		}, {
			key: "renderOrgCsvExplanation",
			value: function renderOrgCsvExplanation() {
				return React.createElement(
					"div",
					null,
					"We have not received your rostering data yet.",
					React.createElement("br", null)
				);
			}
		}, {
			key: "renderIndividualCleverExplanation",
			value: function renderIndividualCleverExplanation() {
				return React.createElement(
					"div",
					null,
					"Note: Teachers will only be able to add students using Clever. This consistency prevents rostering issues."
				);
			}
		}, {
			key: "renderIndividualGoogleExplanation",
			value: function renderIndividualGoogleExplanation() {
				return React.createElement(
					"div",
					null,
					"Note: Teachers will only be able to add students using Google Classroom. This consistency prevents rostering issues."
				);
			}
		}, {
			key: "renderIndividualManualExplanation",
			value: function renderIndividualManualExplanation() {
				return React.createElement(
					"div",
					null,
					"Note: Teachers will only be able to add students using manual methods. This consistency prevents rostering issues."
				);
			}
		}, {
			key: "renderDistrictDelegatingToSchoolAdminExplanation",
			value: function renderDistrictDelegatingToSchoolAdminExplanation() {
				return React.createElement(
					"div",
					null,
					"We have not received a list of school admins yet.",
					React.createElement("br", null)
				);
			}
		}, {
			key: "renderMethodExplanation",
			value: function renderMethodExplanation(org) {
				if (this.state.selectedManager == DISTRICT_MANAGER || this.state.selectedManager == SCHOOL_MANAGER) {
					// DISTRICT ADMIN DELEGATES TO SCHOOL ADMIN
					if (CurrentUser.isDistrictAdmin() && this.state.selectedManager == SCHOOL_MANAGER) {
						var content = this.renderDistrictDelegatingToSchoolAdminExplanation();
					} else if (this.state.selectedMethod == CLEVER_METHOD) {
						var content = this.renderOrgCleverExplanation(org);
					} else if (this.state.selectedMethod == MANUAL_METHOD) {
						var content = this.renderOrgCsvExplanation();
					}
				} else {
					if (this.state.selectedMethod == CLEVER_METHOD) {
						var content = this.renderIndividualCleverExplanation();
					} else if (this.state.selectedMethod == GOOGLE_METHOD) {
						var content = this.renderIndividualGoogleExplanation();
					} else {
						var content = this.renderIndividualManualExplanation();
					}
				}
	
				return React.createElement(
					"div",
					{ className: "section" },
					content
				);
			}
		}, {
			key: "shouldSave",
			value: function shouldSave() {
				if (this.isPrefsDisabled() || this.props.refPrefs.rostering_method["method"] == this.state.selectedMethod && this.props.refPrefs.rostering_method["manager"] == this.state.selectedManager) {
					return false;
				}
				return true;
			}
		}, {
			key: "getUpdatedPrefs",
			value: function getUpdatedPrefs() {
				return { "method": this.state.selectedMethod, "manager": this.state.selectedManager };
			}
		}, {
			key: "renderSchoolOrgPrefs",
			value: function renderSchoolOrgPrefs() {
				var _this3 = this;
	
				var ownedOrgs = this.selectOwnedOrgs(this.props.selectedSchoolOrgs, "school_orgs");
				var sections = _.map(ownedOrgs, function (school, s) {
	
					if (!_this3.isPrefsDisabled()) {
	
						var updateButton = React.createElement(
							"button",
							{ className: "btn btn-primary saveAction", onClick: _this3.onSaveSchoolPrefs.bind(_this3, school.id) },
							"Save changes"
						);
					}
	
					if (!_this3.isPrefsDisabled()) {
						var explanation = _this3.renderMethodExplanation(school);
					}
	
					return React.createElement(
						"div",
						{ index: s },
						React.createElement(
							"h2",
							null,
							school.name
						),
						_this3.renderEditWarning(),
						_this3.renderRosteringManagerOption(),
						_this3.renderUploadMethod(),
						explanation,
						updateButton
					);
				});
	
				return React.createElement(
					"div",
					{ className: "org-section" },
					sections
				);
			}
		}, {
			key: "onSaveDistrictPrefs",
			value: function onSaveDistrictPrefs(districtOrgID) {
				var prefs = this.getUpdatedPrefs();
	
				if (prefs["manager"] == SCHOOL_MANAGER) {
					prefs["method"] = CLEVER_METHOD;
				}
	
				this.props.onDistrictPrefChange(districtOrgID, prefs);
			}
		}, {
			key: "onSaveSchoolPrefs",
			value: function onSaveSchoolPrefs(schoolOrgID) {
				var prefs = this.getUpdatedPrefs();
				this.props.onSchoolPrefChange(schoolOrgID, prefs);
			}
		}, {
			key: "isPrefsDisabled",
			value: function isPrefsDisabled() {
				if (CurrentUser.isSchoolAdmin()) {
					console.log("IS A SCHOOL ADMIN");
	
					var schoolOrg = this.selectOwnedOrgs(this.props.selectedSchoolOrgs, "school_orgs");
					console.log(schoolOrg);
	
					if (schoolOrg && schoolOrg.length > 0) {
						console.log("WE GOT SCHOOL ORGS");
						schoolOrg = schoolOrg[0];
						if (schoolOrg.district_org && schoolOrg.district_org.prefs && schoolOrg.district_org.prefs["rostering_method"]) {
							console.log("SCHOOL ORG HAS PREFS");
							var pref = schoolOrg.district_org.prefs["rostering_method"];
							console.log(pref);
							if (pref["manager"] == "individual" || pref["manager"] == "district_org") {
								return true;
							}
						}
					}
				}
				return false;
			}
		}, {
			key: "renderEditWarning",
			value: function renderEditWarning() {
				if (this.isPrefsDisabled()) {
					return React.createElement(
						"p",
						null,
						"Rostering settings were set by your district admnistrator"
					);
				}
				return "";
			}
		}, {
			key: "renderDistrictPrefs",
			value: function renderDistrictPrefs() {
				var _this4 = this;
	
				var ownedOrgs = this.selectOwnedOrgs(this.props.selectedDistrictOrgs, "district_orgs");
				var sections = _.map(ownedOrgs, function (district, s) {
					if (!_this4.isPrefsDisabled()) {
						var updateButton = React.createElement(
							"button",
							{ className: "btn btn-primary saveAction", onClick: _this4.onSaveDistrictPrefs.bind(_this4, district.id) },
							"Save changes"
						);
					}
	
					return React.createElement(
						"div",
						{ index: s },
						React.createElement(
							"h2",
							null,
							district.name
						),
						_this4.renderRosteringManagerOption(),
						_this4.renderUploadMethod(),
						_this4.renderMethodExplanation(district),
						updateButton
					);
				});
	
				return React.createElement(
					"div",
					{ className: "org-section" },
					sections
				);
			}
		}, {
			key: "render",
			value: function render() {
	
				return React.createElement(
					"div",
					{ className: "RosteringMethodPreference" },
					this.renderSchoolOrgPrefs(),
					this.renderDistrictPrefs()
				);
			}
		}]);
	
		return RosteringMethodPreference;
	}(React.Component)) || _class) || _class);
	
	
	var DISTRICT_MANAGER = "district_org";
	var SCHOOL_MANAGER = "school_org";
	var INDIVIDUAL_MANAGER = "individual";
	var CLEVER_METHOD = "clever";
	var GOOGLE_METHOD = "google";
	var MANUAL_METHOD = "manual";
	
	RosteringMethodPreference.WrappedComponent.propTypes = StrictPropTypes({
		// Handlers from @connect
		admin: PropTypes.object,
		selectedSchoolOrgs: PropTypes.array,
		selectedDistrictOrgs: PropTypes.array,
		prefs: PropTypes.object,
		populateData: PropTypes.func.isRequired
		// onChange: PropTypes.func.isRequired,
	});
	
	module.exports = RosteringMethodPreference;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var SchoolYearMonthsPreference = __webpack_require__(245);
	var ExpectationPeriodPreference = __webpack_require__(391);
	var GradeLevelExpectationsPreference = __webpack_require__(392);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3700);
	
	var SchoolContestPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var selectedSchoolOrgs = [];
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
		var refPrefs = {};
	
		if (CurrentUser.isSchoolAdmin()) {
			if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
				var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
					state: state, conditions: { ids: admin.org_ids.school_orgs.all }
				});
			}
		} else {
			if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.primary) {
				var selectedDistrictOrg = RosterSelectors.districtOrg({
					state: state, id: admin.org_ids.district_orgs.primary[0] });
	
				if (selectedDistrictOrg) {
					var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
						state: state, conditions: { ids: _.map(selectedDistrictOrg.school_orgs, function (so) {
								return so.id;
							}) }
					});
				}
			}
		}
	
		return {
			admin: admin,
			selectedSchoolOrgs: selectedSchoolOrgs,
			prefs: {}
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['admin.org_ids'],
					cache: false
				})).then(function (response) {
					var currentAdmin = response.admins[0];
					if (currentAdmin) {
						if (CurrentUser.isSchoolAdmin()) {
							if (currentAdmin.org_ids && currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all) {
								return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
									filters: { ids: currentAdmin.org_ids.school_orgs.all },
									embeds: ['school_org.prefs'],
									cache: false
								}))]);
							}
						} else {
							if (currentAdmin.org_ids && currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.primary) {
								return Promise.all([dispatch(RosterActions.fetchDistrictOrgs({
									filters: { ids: currentAdmin.org_ids.district_orgs.primary },
									embeds: ['district_org.school_orgs,school_org.prefs'],
									cache: false
								}))]);
							}
						}
					}
				})]);
			},
			onChange: function onChange(schoolOrg, message) {
				// Will get moved to redux at some point (soon, I hope)
				window.wrNotifications.triggerDropDownNotification({
					title: "Contest Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateSchoolOrgPrefs({
					currentUserID: CurrentUser.get().id,
					schoolOrgID: schoolOrg.id,
					update: { "school_contests": schoolOrg.prefs.school_contests }
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(SchoolContestPreference, _React$Component);
	
		function SchoolContestPreference(props) {
			_classCallCheck(this, SchoolContestPreference);
	
			var _this = _possibleConstructorReturn(this, (SchoolContestPreference.__proto__ || Object.getPrototypeOf(SchoolContestPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("SchoolContestPreference");
			_this.state = { selectedSchoolOrgs: props.selectedSchoolOrgs, save: [],
				selectedReadingMetric: "minutes_read", selectedWritingMetric: "all_writing" };
			return _this;
		}
	
		_createClass(SchoolContestPreference, [{
			key: "getSchoolIndex",
			value: function getSchoolIndex(school) {
				var indexes = _.map(this.state.selectedSchoolOrgs, function (s) {
					return s.id;
				});
				return indexes.indexOf(school.id);
			}
		}, {
			key: "setValueOnSchoolPref",
			value: function setValueOnSchoolPref(school, key, value) {
				var index = this.getSchoolIndex(school);
				var selectedSchoolOrgs = this.state.selectedSchoolOrgs;
				if (selectedSchoolOrgs) {
					selectedSchoolOrgs[index].prefs.school_contests[0][key] = value;
					this.state.save.push(school.id);
					this.setState({ selectedSchoolOrgs: selectedSchoolOrgs, save: this.state.save });
				}
			}
		}, {
			key: "selectStartDate",
			value: function selectStartDate(school, startDate) {
				this.setValueOnSchoolPref(school, "start_date", (0, _moment2.default)(startDate).format("YYYY-MM-DD"));
			}
		}, {
			key: "selectEndDate",
			value: function selectEndDate(school, endDate) {
				this.setValueOnSchoolPref(school, "end_date", (0, _moment2.default)(endDate).format("YYYY-MM-DD"));
			}
		}, {
			key: "onSelectReadingMetric",
			value: function onSelectReadingMetric(school, selected) {
				this.setValueOnSchoolPref(school, "reading_metric", selected.target.value);
			}
		}, {
			key: "onSelectWritingMetric",
			value: function onSelectWritingMetric(school, selected) {
				this.setValueOnSchoolPref(school, "writing_metric", selected.target.value);
			}
		}, {
			key: "onSetGoal",
			value: function onSetGoal(school, metric, input) {
				this.setValueOnSchoolPref(school, metric, input.target.value);
			}
		}, {
			key: "renderselectedSchoolOrgs",
			value: function renderselectedSchoolOrgs() {
				var _this2 = this;
	
				return _.map(this.state.selectedSchoolOrgs, function (school) {
					if (!school.prefs || !school.prefs.school_contests || _.isEmpty(school.prefs.school_contests)) {
						return "";
					}
					if (_this2.state.save.includes(school.id)) {
						var saveAction = React.createElement(
							"div",
							{ className: "saveAction" },
							React.createElement(
								"button",
								{ className: "btn btn-primary", onClick: _this2.onSave.bind(_this2, school) },
								"Save"
							)
						);
					}
					var contest = school.prefs.school_contests[0];
					return React.createElement(
						"div",
						{ key: school.id, className: "classSection" },
						React.createElement(
							"h2",
							null,
							" ",
							school.name,
							" "
						),
						React.createElement(
							"div",
							{ className: "dateSection" },
							React.createElement(
								"label",
								null,
								React.createElement(
									"span",
									null,
									"Start"
								),
								React.createElement(_reactDatepicker2.default, { className: "startDatePicker",
									onChange: _this2.selectStartDate.bind(_this2, school),
									selected: (0, _moment2.default)(contest.start_date) })
							),
							React.createElement(
								"label",
								null,
								React.createElement(
									"span",
									null,
									"End"
								),
								React.createElement(_reactDatepicker2.default, { className: "startDatePicker",
									onChange: _this2.selectEndDate.bind(_this2, school),
									selected: (0, _moment2.default)(contest.end_date) })
							)
						),
						React.createElement(
							"div",
							{ className: "metricSection" },
							React.createElement(
								"table",
								{ className: "table" },
								React.createElement(
									"thead",
									null,
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Contest"
										),
										React.createElement(
											"th",
											null,
											"Metric"
										),
										React.createElement(
											"th",
											null,
											"Goal"
										)
									)
								),
								React.createElement(
									"tbody",
									null,
									React.createElement(
										"tr",
										null,
										React.createElement(
											"td",
											null,
											"Reading"
										),
										React.createElement(
											"td",
											null,
											React.createElement(
												"select",
												{ value: contest.reading_metric, className: "form-control",
													onChange: _this2.onSelectReadingMetric.bind(_this2, school) },
												DropDownOptions.Select.contestReadingMetrics()
											)
										),
										React.createElement(
											"td",
											null,
											React.createElement("input", { className: "form-control input", type: "numder", onChange: _this2.onSetGoal.bind(_this2, school, "reading_goal"), defaultValue: contest.reading_goal })
										)
									),
									React.createElement(
										"tr",
										null,
										React.createElement(
											"td",
											null,
											"Writing"
										),
										React.createElement(
											"td",
											null,
											React.createElement(
												"select",
												{ value: contest.writing_metric, className: "form-control",
													onChange: _this2.onSelectWritingMetric.bind(_this2, school) },
												DropDownOptions.Select.contestWritingMetrics()
											)
										),
										React.createElement(
											"td",
											null,
											React.createElement("input", { className: "form-control input", type: "numder", onChange: _this2.onSetGoal.bind(_this2, school, "writing_goal"), defaultValue: contest.writing_goal })
										)
									)
								)
							)
						),
						saveAction
					);
				});
			}
		}, {
			key: "onLinkSchoolPage",
			value: function onLinkSchoolPage() {
				$wr.redirect("/contests");
			}
		}, {
			key: "onSave",
			value: function onSave(schoolOrg) {
				this.props.onChange(schoolOrg);
				this.state.save = _.select(this.state.save, function (id) {
					return id != schoolOrg.id;
				});
				this.setState({ save: this.state.save });
			}
		}, {
			key: "render",
			value: function render() {
	
				return React.createElement(
					"div",
					{ className: "SchoolContestPreference" },
					"Contests are displayed on the ",
					React.createElement(
						"a",
						{ onClick: this.onLinkSchoolPage },
						"School page"
					),
					React.createElement("br", null),
					this.renderselectedSchoolOrgs()
				);
			}
		}]);
	
		return SchoolContestPreference;
	}(React.Component)) || _class) || _class);
	
	
	SchoolContestPreference.WrappedComponent.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = SchoolContestPreference;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropDownOptions = __webpack_require__(26);
	var LoadingButton = __webpack_require__(17);
	var CurrentUser = __webpack_require__(3);
	
	var RosterActions = __webpack_require__(11);
	
	var AddRosterClasses = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			defaultGradeLevel: parseInt(CurrentUser.get().grade_level)
		};
	}, function (dispatch, props) {
		return {
			// creates new student list
			postStudentLists: function postStudentLists(studentLists) {
				var embeds = ["student_list.students,student_list.primary_admin,admin.email,student_list.passphrase,student_list.prefs"];
				return dispatch(RosterActions.postStudentLists({ studentLists: studentLists, embeds: embeds }));
			}
	
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AddRosterClasses, _React$Component);
	
		function AddRosterClasses(props) {
			_classCallCheck(this, AddRosterClasses);
	
			var _this = _possibleConstructorReturn(this, (AddRosterClasses.__proto__ || Object.getPrototypeOf(AddRosterClasses)).call(this));
	
			autobind(_this);
	
			_this.state = {
				studentLists: _.times(3, function () {
					return { name: "", grade_level: props.defaultGradeLevel };
				}),
				loading: false
			};
			return _this;
		}
	
		// filters out empty input rows
		// creates new student list
		// sends user result message
	
	
		_createClass(AddRosterClasses, [{
			key: "submitClass",
			value: function submitClass(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.setState({ loading: true });
				var filteredStudentLists = _.filter(this.state.studentLists, function (sl) {
					return !_.isEmpty(sl.name);
				});
	
				var names = _.pluck(filteredStudentLists, 'name');
				var grade_levels = _.pluck(filteredStudentLists, 'grade_level');
	
				var params = { name: names, grade_level: grade_levels };
				this.props.postStudentLists(params).then(function (response) {
					_this2.setState({ loading: false });
					if (!response.errors) {
						var classNumber = response["student_lists"].length;
						var title = "New " + $wr.pluralize("class", classNumber, "classes") + " added";
						var text = "You have successfully created " + classNumber + $wr.pluralize(" class", classNumber, " classes") + "!";
	
						_this2.props.addStudentLists(response["student_lists"]);
	
						window.wrNotifications.triggerDropDownNotification({
							title: title, text: text, icon: "ok-circle"
						}, 4000);
					} else {
						window.wrNotifications.triggerDropDownNotification({
							title: "Sorry!", text: response.error, icon: "exclamation-sign", type: "error"
						});
					}
				});
			}
		}, {
			key: "setValue",
			value: function setValue(setIndex, key, value) {
				this.setState({
					studentLists: this.state.studentLists.map(function (studentList, index) {
						if (index === setIndex) {
							return _extends({}, studentList, _defineProperty({}, key, value));
						} else {
							return studentList;
						}
					})
				});
			}
		}, {
			key: "addClassRow",
			value: function addClassRow() {
				this.setState({
					studentLists: this.state.studentLists.concat([{
						name: "", grade_level: this.props.defaultGradeLevel
					}])
				});
			}
		}, {
			key: "removeClassRow",
			value: function removeClassRow(removeIndex) {
				this.setState({
					studentLists: this.state.studentLists.filter(function (studentIndex, index) {
						return removeIndex != index;
					})
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var anyWithName = false;
				var classRows = this.state.studentLists.map(function (studentList, index) {
					if (studentList.name.trim().length) {
						anyWithName = true;
					}
	
					return React.createElement(
						"div",
						{ key: index, className: "classRow" },
						React.createElement("input", { className: "form-control nameCol",
							value: studentList.name,
							onChange: function onChange(e) {
								return _this3.setValue(index, "name", e.target.value);
							} }),
						React.createElement(
							"select",
							{ className: "form-control gradeLevelCol",
								onChange: function onChange(e) {
									return _this3.setValue(index, "grade_level", e.target.value);
								},
								value: studentList.grade_level },
							DropDownOptions.Select.GradeLevels()
						),
						React.createElement(
							"button",
							{ type: "button",
								className: "btn btn-link removeLink",
								disabled: _this3.state.studentLists.length < 2,
								onClick: function onClick() {
									return _this3.removeClassRow(index);
								} },
							React.createElement("span", { className: "glyphicon glyphicon-minus-sign" })
						)
					);
				});
	
				return React.createElement(
					"div",
					{ className: "addRosterClasses" },
					React.createElement(
						"form",
						{ onSubmit: this.submitClass, className: "addNewClassForm" },
						React.createElement(
							"p",
							{ className: "colHeader nameCol" },
							"Class Name"
						),
						React.createElement(
							"p",
							{ className: "colHeader gradeLevelCol" },
							"Grade"
						),
						classRows,
						React.createElement(
							"div",
							{ className: "text-right" },
							React.createElement(
								"button",
								{ type: "button", className: "btn btn-link addLink", onClick: this.addClassRow },
								"Add Class ",
								React.createElement("span", { className: "glyphicon glyphicon-plus-sign" })
							)
						),
						React.createElement(LoadingButton, { className: "buttonSuccess center-block",
							text: "Add Classes",
							disabled: !anyWithName,
							loading: this.state.loading })
					)
				);
			}
		}]);
	
		return AddRosterClasses;
	}(React.Component)) || _class);
	;
	
	AddRosterClasses.WrappedComponent.propTypes = StrictPropTypes({
		addStudentLists: PropTypes.func,
		defaultGradeLevel: PropTypes.number,
		loading: PropTypes.bool,
		postStudentLists: PropTypes.func
	});
	
	module.exports = AddRosterClasses;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddStudentsMethodSelect = __webpack_require__(831);
	var ManualAddStudents = __webpack_require__(834);
	var AddStudentsClassCode = __webpack_require__(830);
	var UploadStudentRoster = __webpack_require__(840);
	var LoadingButton = __webpack_require__(17);
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var GoogleSync = __webpack_require__(833);
	var CleverSync = __webpack_require__(832);
	
	var AddRosterStudents = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var studentLists = RosterSelectors.nonEmptyStudentLists({ state: state });
	
		var methodOptions = ALL_METHOD_OPTIONS;
	
		if (studentLists.length > 0 && studentLists[0].prefs && studentLists[0].prefs["rostering_method"]) {
			var rosteringPrefs = studentLists[0].prefs["rostering_method"];
	
			if (rosteringPrefs && !_.isEmpty(rosteringPrefs)) {
				// ONLY FREE USERS SHOULD HAVE EMPTY ROSTERING PREFERENCE
				if (rosteringPrefs["manager"] == "individual") {
					// IF METHOD USED DELGATES ROSTERING TO TEACHERS
					switch (rosteringPrefs["method"]) {
						case "clever":
							methodOptions = INDIVIDUAL_CLEVER_METHODS;
							break;
						case "google":
							methodOptions = INDIVIDUAL_GOOGLE_METHODS;
							break;
						case "manual":
							methodOptions = INDIVIDUAL_MANUAL_METHODS;
							break;
					}
				} else {
					var methodOptions = []; // REMOVE ALL OPTIONS
				}
			}
		}
	
		if (!CurrentUser.isTeacherAdmin()) {
			methodOptions = _.without(methodOptions, GOOGLE);
			methodOptions = _.without(methodOptions, CLEVER);
		}
	
		if (!(CurrentUser.isTeacherAdmin() || CurrentUser.isWizard())) {
			methodOptions = _.without(methodOptions, UPLOAD);
		}
	
		// // remove Google if using Clever, otherwise remove Clever
		// if (CurrentUser.isCleverSSOUser()) {
		// 	methodOptions = _.without(methodOptions, GOOGLE);
		// } else {
		// 	methodOptions = _.without(methodOptions, CLEVER);
		// }
	
		// also remove Google & clever option for non teacherAdmins
	
		return {
			methodOptions: methodOptions, studentLists: studentLists,
			effectiveUserID: CurrentUser.get().id
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(AddRosterStudents, _React$Component);
	
		function AddRosterStudents(props) {
			_classCallCheck(this, AddRosterStudents);
	
			var _this = _possibleConstructorReturn(this, (AddRosterStudents.__proto__ || Object.getPrototypeOf(AddRosterStudents)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("AddRosterStudents");
	
			var mode = $wr.getURLParameterByName('add_student_method') == 'clever' ? 'clever' : null;
	
			_this.state = {
				mode: mode, studentCount: 0
			};
			return _this;
		}
	
		// returns list of student list ids from list of class names
		// used to expand appropriate student lists after adding students
	
	
		_createClass(AddRosterStudents, [{
			key: "studentListIDsByClassName",
			value: function studentListIDsByClassName(classNames) {
				var studentLists = this.props.studentLists;
	
				if (_.isEmpty(studentLists) || !classNames) {
					return [];
				}
	
				var filteredStudentLists = _.filter(studentLists, function (sl) {
					return _.includes(classNames, sl.name);
				});
				return _.pluck(filteredStudentLists, 'id');
			}
		}, {
			key: "changeTab",
			value: function changeTab(tabKey) {
				this.setState({ mode: tabKey }, function () {
					$(window).trigger("resize");
				});
			}
		}, {
			key: "onRosterUploadShowStatus",
			value: function onRosterUploadShowStatus(studentCount) {
				this.setState({ studentCount: studentCount });
			}
		}, {
			key: "onRosterUpload",
			value: function onRosterUpload(studentCount, alreadyLoaded, pendingTask) {
				$(window.document).trigger("onboarding-trigger-add-students");
				this.showUploadNotification(studentCount, alreadyLoaded, pendingTask);
	
				if (this.refs && this.refs.modal) {
					this.refs.modal.hide();
				}
			}
		}, {
			key: "showUploadNotification",
			value: function showUploadNotification(studentCount, alreadyLoaded, pendingTask) {
				var title = $wr.pluralize("Student", studentCount) + " Added";
				var studentText = studentCount + " student " + $wr.pluralize("account", studentCount);
	
				if (alreadyLoaded) {
					var text = "You added " + studentText + "!";
				} else {
					var text = "You are adding " + studentText + "! Hang tight, this could take a few minutes.";
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: title,
					text: text, icon: "ok-circle"
				}, 4000);
	
				// This will automatically trigger the notice for manual addition
				window.wrNotifications.loadPendingTask(pendingTask);
	
				if (this.props.afterCreate) {
					this.props.afterCreate();
				}
			}
		}, {
			key: "afterCreate",
			value: function afterCreate(studentCount, fetchImmediately, pendingTask, classNames) {
				var title = $wr.pluralize("Student", studentCount) + " Added";
				var studentText = studentCount + " student " + $wr.pluralize("account", studentCount);
	
				if (fetchImmediately) {
					var text = "You added " + studentText + "!";
				} else {
					var text = "You are adding " + studentText + "! Hang tight, this could take a few minutes.";
				}
	
				var studentListIDs = this.studentListIDsByClassName(classNames);
				if (!_.isEmpty(studentListIDs)) {
					$wr.redirect("/roster?expand_sl=" + studentListIDs.join(','));
				}
	
				// if students were added, complete onboarding checklist item
				if (studentCount > 0) {
					$(window.document).trigger("onboarding-trigger-add-students");
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: title, text: text, icon: "ok-circle"
				}, 4000);
	
				// This will automatically trigger the notice for manual addition
				window.wrNotifications.loadPendingTask(pendingTask);
				if (this.props.afterCreate) {
					this.props.afterCreate();
				}
			}
	
			// options for adding students
	
		}, {
			key: "render",
			value: function render() {
				var studentCount = this.state.studentCount;
				var mode = this.state.mode;
				if (mode === MANUAL) {
					var methodContent = React.createElement(ManualAddStudents, {
						defaultStudentListID: this.props.defaultStudentListID,
						afterCreate: this.afterCreate,
						onRosterUploadShowStatus: this.onRosterUploadShowStatus });
					if (studentCount > 0) {
						var loginInfo = React.createElement(
							"div",
							{ className: "loginMethod" },
							React.createElement(
								"p",
								{ className: "notice" },
								studentCount,
								" students are being added to your ",
								React.createElement(
									"i",
									null,
									"Roster"
								),
								"."
							),
							React.createElement(
								"div",
								null,
								React.createElement("img", { className: "stepsImg", src: __webpack_require__(1650), alt: "Log into Whooo's Reading" }),
								React.createElement(
									"div",
									{ className: "infoContainer" },
									React.createElement(
										"p",
										{ className: "header" },
										"How students log into Whooo's Reading:"
									),
									React.createElement(
										"ol",
										null,
										React.createElement(
											"li",
											null,
											"Go to www.whooosreading.org"
										),
										React.createElement(
											"li",
											null,
											"Click ",
											React.createElement(
												"b",
												null,
												"Log In"
											),
											" button (upper right)"
										),
										React.createElement(
											"li",
											null,
											"Select ",
											React.createElement(
												"b",
												null,
												"Student"
											)
										),
										React.createElement(
											"li",
											null,
											"Enter login information"
										)
									),
									React.createElement(
										"p",
										null,
										"If you are unsure how to do this, help your students by following ",
										React.createElement(
											"a",
											{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/115001179552", target: "_blank" },
											"these login instructions"
										),
										"."
									)
								)
							)
						);
					}
				} else if (mode === GOOGLE) {
					var methodContent = React.createElement(GoogleSync, { onUpload: this.onRosterUpload, currentStudentLists: this.props.studentLists,
						studentCount: this.state.studentCount });
				} else if (mode === CLEVER) {
					var methodContent = React.createElement(CleverSync, { onUpload: this.onRosterUpload, currentStudentLists: this.props.studentLists,
						studentCount: this.state.studentCount });
				} else if (mode === CODE) {
					var methodContent = React.createElement(AddStudentsClassCode, null);
				} else if (mode == UPLOAD) {
					var methodContent = React.createElement(UploadStudentRoster, { afterCreate: this.afterCreate,
						effectiveUserID: this.props.effectiveUserID });
				}
	
				var addStudentOptions = React.createElement(AddStudentsMethodSelect, { methodOptions: this.props.methodOptions,
					onMethodSelect: this.changeTab, selectedOption: this.state.mode });
				return React.createElement(
					"div",
					{ className: "addRosterStudents" },
					addStudentOptions,
					loginInfo,
					methodContent
				);
			}
		}]);
	
		return AddRosterStudents;
	}(React.Component)) || _class);
	;
	
	var MANUAL = "manual";
	var CODE = "class-code";
	var UPLOAD = "upload";
	var GOOGLE = "google-classroom";
	var CLEVER = "clever";
	
	var ALL_METHOD_OPTIONS = [MANUAL, CODE, UPLOAD, GOOGLE, CLEVER];
	var INDIVIDUAL_CLEVER_METHODS = [CLEVER];
	var INDIVIDUAL_GOOGLE_METHODS = [GOOGLE];
	var INDIVIDUAL_MANUAL_METHODS = [MANUAL, CODE, UPLOAD];
	
	AddRosterStudents.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		defaultStudentListID: PropTypes.number,
		afterCreate: PropTypes.func,
		effectiveUserID: PropTypes.number,
	
		// Data from @connect
		methodOptions: PropTypes.array,
		studentLists: PropTypes.array
	});
	
	module.exports = AddRosterStudents;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _LocationState = __webpack_require__(59);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminRosterRouting = __webpack_require__(440);
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var StudentListDropdownDisplay = __webpack_require__(138);
	var AdminRosteringPage = (_dec = (0, _LocationState.provideLocationState)(AdminRosterRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		var studentLists = RosterSelectors.studentLists({ state: state });
		return { studentLists: studentLists };
	}, function (dispatch, propTypes) {
		return {
			populateData: function populateData() {
				return dispatch(RosterActions.fetchStudentLists({
					embeds: ["student_list.admins", "student_list.students", "student_list.primary_admin", "student.primary_student_list_id"]
				}));
			}
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(AdminRosteringPage, _React$Component);
	
		function AdminRosteringPage(props) {
			_classCallCheck(this, AdminRosteringPage);
	
			var _this = _possibleConstructorReturn(this, (AdminRosteringPage.__proto__ || Object.getPrototypeOf(AdminRosteringPage)).call(this));
	
			autobind(_this);
			// var studentList = _.sortBy(this.props.studentLists, function(studentList) {
			// 	return studentList.students.length * -1;
			// })[0]
	
			// this.state = { currentStudentList: this.props.studentLists[0] }
			return _this;
		}
	
		// renderStudentLists() {
		// 	_.each(this.props.studentLists, (studentList) => {
	
		// 		var studentSelectors = [];
		// 		var allSelected = true;
	
		// 		_.each(this.props.studentsByStudentListID[studentList.id], (student) => {
		// 			if (effectiveIDs.has(student.id)) {
		// 				var isSelected = true;
		// 				selectedNames.push(student.display_name);
		// 			} else {
		// 				var isSelected = false;
		// 				allSelected = false;
		// 			}
		// 			studentSelectors.push(
		// 				<ButtonDropdownOption key={ "s-" + student.id }
		// 					preventCollapse={ true } className="studentOp"
		// 					onClick={ this.toggleStudent.bind(this, student, isSelected) }>
	
		// 					<input type="checkbox" checked={ isSelected } onChange={ () => {} } />
		// 					{" "}{ student.display_name }
		// 				</ButtonDropdownOption>
		// 			);
		// 		});
	
		// 		selectors.push(
		// 			<ButtonDropdownOption key={ "sl-" + studentList.id }
		// 				preventCollapse={ true } className="studentListOp" 
		// 				onClick={ this.toggleStudentList.bind(this, studentList, allSelected) }>
	
		// 				<input type="checkbox" checked={ allSelected } onChange={ () => {} } />
		// 				{" "}{ studentList.name }
		// 			</ButtonDropdownOption>
		// 		);
	
		// 		selectors = selectors.concat(studentSelectors);
	
		// 	});
		// }
	
		_createClass(AdminRosteringPage, [{
			key: "studentListSubject",
			value: function studentListSubject() {
				return this.props.subjectType == AdminRosterRouting.SUBJECTS.STUDENTS && this.props.subjectID;
			}
		}, {
			key: "activeStudentList",
			value: function activeStudentList() {
				if (this.studentListSubject()) {
					return _.findWhere(this.props.studentLists, { id: this.props.subjectID });
				}
			}
		}, {
			key: "changeSubject",
			value: function changeSubject(activeView, studentListID) {
				$wr.redirect(AdminRosterRouting.getPath({
					activeView: this.props.locationState.activeView,
					studentListID: studentListID
				}));
			}
		}, {
			key: "studentListChange",
			value: function studentListChange(studentList) {
				this.changeSubject(this.props.locationState.activeView, studentList.id);
			}
		}, {
			key: "getStudentLists",
			value: function getStudentLists() {
				return _.select(this.props.studentLists, function (studentList) {
					return studentList.students.length > 0;
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _props$locationState = this.props.locationState,
				    activeView = _props$locationState.activeView,
				    studentListID = _props$locationState.studentListID;
	
				console.log(this.props.studentLists);
	
				var sortedStudentLists = $wr.sortByName(this.props.studentLists, "studentList");
				var studentLists = this.getStudentLists();
	
				if (studentLists.length == 0) {
					return this.renderEmptyState();
				}
	
				studentLists = $wr.sortByName(studentLists, "studentList");
	
				var allStudentLists = { id: ALL_CLASSES_FAKE_ID, name: "All Classes" };
				var studentListsClone = _.clone(studentLists);
				studentListsClone.unshift(allStudentLists);
	
				var dropdownDisplay = React.createElement(
					"div",
					null,
					React.createElement(StudentListDropdownDisplay, { studentLists: studentListsClone,
						currentStudentList: this.activeStudentList(),
						onChange: this.studentListChange,
						dropdownDisplay: "link", displayType: "mixed" })
				);
				return React.createElement(
					"div",
					{ className: "container AdminRosteringPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Scratch Page"
						),
						dropdownDisplay
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.populateData();
			}
		}]);
	
		return AdminRosteringPage;
	}(React.Component)) || _class) || _class) || _class);
	
	
	AdminRosteringPage.propTypes = PageStrictPropTypes({
		populateData: PropTypes.func
	});
	
	var ALL_CLASSES_FAKE_ID = -999;
	
	module.exports = AdminRosteringPage;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var StudentsSelectedDisplay = __webpack_require__(139);
	var ErrorDisplay = __webpack_require__(51);
	var StandardIcon = __webpack_require__(250);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var AwardCoins = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			totalStudents: RosterSelectors.students({ state: state }).length
		};
	}, function (dispatch, props) {
		return {
			createAward: function createAward(award) {
				return dispatch(RosterActions.createAward({ award: award }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AwardCoins, _React$Component);
	
		function AwardCoins(props) {
			_classCallCheck(this, AwardCoins);
	
			var _this = _possibleConstructorReturn(this, (AwardCoins.__proto__ || Object.getPrototypeOf(AwardCoins)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, showCustomCoinsInput: false
			};
			return _this;
		}
	
		_createClass(AwardCoins, [{
			key: "awardCoins",
			value: function awardCoins(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.refs.errors.reset();
				var errors = [];
				if (!this.state.loading) {
					this.setState({ loading: true });
					var coinsAmount = this.refs.coinsAmount.value;
					var coinsReason = this.refs.coinsReason.value;
	
					if (coinsAmount == 0) {
						errors.push("Please select an amount of coins to award.");
					} else if (coinsReason == 0) {
						errors.push("Please enter a reason for awarding the coins.");
					}
	
					if (errors.length == 0) {
						var title = "Coins Awarded";
						var text = "You awarded " + coinsAmount + " coins.";
						var studentIds = _.pluck(this.props.students, "id");
						var award = { type: "coins", amount: coinsAmount, reason: coinsReason, student_ids: studentIds };
	
						this.props.createAward(award).then(function () {
							_this2.setState({ loading: false });
	
							window.wrNotifications.triggerDropDownNotification({
								title: title, text: text, icon: "ok-circle", duration: 4000 });
	
							if (_this2.props.onComplete) {
								_this2.props.onComplete();
							}
						});
					} else {
						this.setState({ loading: false });
						this.refs.errors.setErrors(errors);
					}
				}
			}
		}, {
			key: "toggleCustomCoins",
			value: function toggleCustomCoins() {
				if (this.state.showCustomCoinsInput) {
					this.setState({ showCustomCoinsInput: false });
				} else {
					this.setState({ showCustomCoinsInput: true });
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.showCustomCoinsInput) {
					var coinsAmount = React.createElement("input", { type: "number", className: "form-control selectCoins", ref: "coinsAmount",
						placeholder: "Enter Amount" });
				} else {
					var coinsAmount = React.createElement(
						"select",
						{ name: "coinsAmount", className: "selectCoins form-control",
							ref: "coinsAmount" },
						React.createElement(
							"option",
							{ value: "" },
							"Select amount"
						),
						React.createElement(
							"option",
							{ value: "25" },
							"25 - Good Job"
						),
						React.createElement(
							"option",
							{ value: "50" },
							"50 - Great Work"
						),
						React.createElement(
							"option",
							{ value: "75" },
							"75 - Fantastic"
						),
						React.createElement(
							"option",
							{ value: "100" },
							"100 - Amazing"
						),
						React.createElement(
							"option",
							{ value: "200" },
							"200 - Woohoo!"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "awardCoins" },
					React.createElement(StudentsSelectedDisplay, { totalStudents: this.props.totalStudents, studentsSelected: this.props.students }),
					React.createElement(
						"form",
						{ onSubmit: this.awardCoins },
						React.createElement(ErrorDisplay, { ref: "errors" }),
						React.createElement(
							"div",
							{ className: "awardCoinsAmountSection" },
							React.createElement(
								"p",
								{ className: "coinsInputTitle" },
								"Amount"
							),
							React.createElement(StandardIcon, { icon: "coin", type: StandardIcon.WR_ICON, className: "iconImage" }),
							coinsAmount,
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "checkbox", checked: this.state.showCustomCoinsInput,
									onChange: this.toggleCustomCoins }),
								"Award Custom Amount"
							)
						),
						React.createElement(
							"div",
							{ className: "awardCoinsInputSection" },
							React.createElement(
								"p",
								{ className: "coinsInputTitle" },
								"Reason"
							),
							React.createElement("input", { className: "form-control coinsReason", ref: "coinsReason", placeholder: "Ex: Class participation or Homework" })
						),
						React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: "Award Coins", loading: this.state.loading })
					)
				);
			}
		}]);
	
		return AwardCoins;
	}(React.Component)) || _class);
	;
	
	AwardCoins.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		students: PropTypes.array,
		onComplete: PropTypes.func,
	
		// Data from @connect
		totalStudents: PropTypes.number,
	
		// Handler from @connect
		createAward: PropTypes.func
	});
	
	module.exports = AwardCoins;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	function propsToSchoolID(props) {
		if (_underscore2.default.has(props.studentList, 'school')) return props.studentList.school.l2e_id;
	}
	
	var DeleteStudentModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			classStudentLists: RosterSelectors.studentLists({ state: state, filters: { school_id: propsToSchoolID(props) } })
		};
	}, function (dispatch, props) {
		return {
			// removes students from student lists student in state
			deleteStudents: function deleteStudents(stuID, slIDs) {
				return new Promise(function (resolve, reject) {
					dispatch(RosterActions.deleteStudents({ id: stuID, slIDs: slIDs })).then(function (response) {
						resolve(response);
					});
				});
			},
			fetchStudent: function fetchStudent(id) {
				var embeds = ["student.password", "student.sso_data"].concat(RosterActions.GLOBAL_STUDENT_EMBEDS);
				return dispatch(RosterActions.fetchStudent({ id: id, embeds: embeds }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(DeleteStudentModal, _React$Component);
	
		function DeleteStudentModal(props) {
			_classCallCheck(this, DeleteStudentModal);
	
			var _this = _possibleConstructorReturn(this, (DeleteStudentModal.__proto__ || Object.getPrototypeOf(DeleteStudentModal)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("DeleteStudentModal");
	
			_this.state = { loading: false };
			return _this;
		}
	
		// displays successful update message
	
	
		_createClass(DeleteStudentModal, [{
			key: 'triggerSuccessMessage',
			value: function triggerSuccessMessage(stu, slCount) {
				var title = "Student Removed";
				if (slCount > 1) {
					var text = "You have removed " + stu.display_name + " from " + slCount + " classes.";
				} else {
					var text = "You have removed " + stu.display_name + " from " + slCount + " class.";
				}
	
				// show message
				window.wrNotifications.triggerDropDownNotification({
					title: title, text: text, icon: "ok-circle"
				}, 4000);
	
				// hide modal
				this.props.onHide();
			}
	
			// displays error on update message
	
		}, {
			key: 'triggerErrorMessage',
			value: function triggerErrorMessage() {
				window.wrNotifications.triggerDropDownNotification({
					title: "Oops!", text: "Something went wrong and the student was not removed",
					type: "error", icon: "remove"
				}, 4000);
			}
	
			// removes student from all associated student lists
	
		}, {
			key: 'submit',
			value: function submit(slIDs) {
				var _this2 = this;
	
				var stu = this.props.student;
				if (stu && slIDs) {
	
					// remove student from list
					// this removes student from state as well
					this.props.deleteStudents(stu.id, slIDs).then(function (response) {
						if (response['destroyed']) {
							var slIDSize = Array.isArray(slIDs) ? _underscore2.default.size(slIDs) : 1;
							_this2.triggerSuccessMessage(stu, slIDSize);
	
							// re-enter student into state with updates
							var activeSLIDs = stu.student_list_ids.active;
							if (_underscore2.default.size(activeSLIDs) > 1 && _underscore2.default.size(slIDs) !== _underscore2.default.size(activeSLIDs)) {
								_this2.props.fetchStudent(stu.id);
							}
						} else {
							_this2.triggerErrorMessage();
						}
					});
				}
			}
	
			// renders start buttons or spinner
	
		}, {
			key: 'renderButtons',
			value: function renderButtons(activeSLCount) {
				if (this.state.loading) {
					return React.createElement(Spinner, { scale: 1 });
				} else {
					var stu = this.props.student;
					var sl = this.props.studentList;
					var activeSLIDs = stu.student_list_ids.active;
	
					// store buttons in variable
					var cancelBtn = React.createElement(
						'button',
						{ key: 'cancelBtn', className: 'btn', onClick: this.props.onHide },
						'Cancel'
					);
					var removeAllBtn = React.createElement(
						'button',
						{ key: 'removeAllBtn', className: 'btn buttonPrimary', onClick: this.submit.bind(this, activeSLIDs) },
						'Delete From All'
					);
					var removeOneBtn = React.createElement(
						'button',
						{ key: 'removeOneBtn', className: 'btn buttonPrimary', onClick: this.submit.bind(this, sl.id) },
						'Delete From 1 Class'
					);
	
					// decide which buttons to show based on student's SL size
					if (activeSLCount > 1) {
						var buttons = [cancelBtn, removeAllBtn, removeOneBtn];
					} else {
						var buttons = [cancelBtn, removeOneBtn];
					}
	
					return React.createElement(
						'div',
						{ className: 'options' },
						buttons
					);
				}
			}
	
			// creates array of student lists
	
		}, {
			key: 'renderMultipleSLs',
			value: function renderMultipleSLs(slIDs) {
				var _this3 = this;
	
				// make array of list items with sl names
				var stuListItems = _underscore2.default.compact(_underscore2.default.map(slIDs, function (slID) {
					var sl = _underscore2.default.findWhere(_this3.props.classStudentLists, { id: slID });
					return React.createElement(
						'li',
						{ key: slID, className: 'slName' },
						$wr.truncate(sl.name, 30)
					);
				}));
	
				return React.createElement(
					'ul',
					null,
					stuListItems
				);
			}
	
			// returns body  based on # of student lists
	
		}, {
			key: 'renderDisplay',
			value: function renderDisplay() {
				var stu = this.props.student;
				var slIDs = stu.student_list_ids;
	
				// adjust content based on # of student lists
				if (slIDs && _underscore2.default.size(slIDs.active) === 1) {
					var modalContent = React.createElement(
						'span',
						null,
						stu.display_name,
						' will be removed from ',
						React.createElement(
							'b',
							null,
							this.props.studentList.name
						)
					);
				} else {
					var modalContent = React.createElement(
						'div',
						null,
						React.createElement(
							'div',
							{ className: 'slCount' },
							stu.display_name,
							' is included in ',
							_underscore2.default.size(slIDs.active),
							' lists: '
						),
						this.renderMultipleSLs(slIDs.active),
						React.createElement(
							'div',
							{ className: 'slConfirm' },
							'Do you want to remove them from all lists or only ',
							React.createElement(
								'b',
								null,
								this.props.studentList.name
							),
							'?'
						)
					);
				}
	
				return React.createElement(
					'div',
					null,
					React.createElement(
						'div',
						{ className: 'modalBody' },
						modalContent
					),
					this.renderButtons(_underscore2.default.size(slIDs.active))
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return React.createElement(
					'div',
					{ className: 'deleteStudentModalContainer' },
					this.renderDisplay()
				);
			}
		}]);
	
		return DeleteStudentModal;
	}(React.Component)) || _class);
	;
	
	module.exports = DeleteStudentModal;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Modal = __webpack_require__(18);
	var LoadingButton = __webpack_require__(17);
	var ErrorDisplay = __webpack_require__(51);
	
	__webpack_require__(3702);
	
	var ParentEmailsModal = function (_React$Component) {
		_inherits(ParentEmailsModal, _React$Component);
	
		function ParentEmailsModal(props) {
			_classCallCheck(this, ParentEmailsModal);
	
			var _this = _possibleConstructorReturn(this, (ParentEmailsModal.__proto__ || Object.getPrototypeOf(ParentEmailsModal)).call(this));
	
			autobind(_this);
			_this.state = { students: {}, loading: false };
			return _this;
		}
	
		_createClass(ParentEmailsModal, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
				this.fetchStudentList();
			}
		}, {
			key: "fetchStudentList",
			value: function fetchStudentList() {
				var params = { embed: "student_list.students,student.parent,parent.email" };
	
				CurrentUser.api().getStudentList(this.props.activeStudentListID, params, $wr.apiHandler(function (response) {
					this.setState({ students: response.student_list.students });
				}.bind(this)));
			}
		}, {
			key: "submitParentEmail",
			value: function submitParentEmail(e) {
				$wr.nope(e);
				this.refs.errors.reset();
				var errors = [];
	
				if (!this.state.loading) {
					this.setState({ loading: true });
	
					var addedStudentIDs = [];
					var addedParentEmails = [];
					var updatedParentIDs = [];
					var updatedParentEmails = [];
					var newStudents = [];
	
					this.state.students.map(function (student) {
						var studentRef = "parentEmails" + student.id;
						var newStudent = _.clone(student);
	
						var emailRegEx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;
	
						if (this.refs[studentRef] && this.refs[studentRef].value != "") {
							var newParentEmail = this.refs[studentRef].value;
							if (!emailRegEx.test(newParentEmail)) {
								errors.push("Please make sure all email addresses are valid.");
								$(this.refs[studentRef]).addClass('errorRow');
							} else if (!student.has_parent) {
								var parentInfo = { email: newParentEmail, not_accepted_terms: true };
								newStudent.parent = parentInfo;
								newStudent.has_parent = true;
	
								addedStudentIDs.push(student.id);
								addedParentEmails.push(newParentEmail);
							} else if (student.has_parent && student.parent.email != newParentEmail) {
								newStudent.parent.email = newParentEmail;
	
								updatedParentIDs.push(student.parent.id);
								updatedParentEmails.push(newParentEmail);
							}
						}
						newStudents.push(newStudent);
					}.bind(this));
	
					var totalParentEmails = addedParentEmails.length + updatedParentEmails.length;
					if (errors.length == 0) {
						if (totalParentEmails > 0) {
							$(this.refs.parentEmailTable).find("input").removeClass('errorRow');
	
							var addressWord = $wr.pluralize("Address", totalParentEmails, "Addresses");
							var title = "Email " + addressWord + " Added!";
	
							if (totalParentEmails == 1) {
								var emailText = " The email has been ";
							} else {
								var emailText = " The emails have been ";
							}
							var text = "You have updated " + totalParentEmails + " parent email " + addressWord.toLowerCase() + "!" + emailText + "scheduled and will send shortly.";
	
							if (addedParentEmails.length > 0) {
								var parentData = { parents: { student_ids: addedStudentIDs, auth_emails: addedParentEmails } };
								CurrentUser.api().postParents(parentData, $wr.apiHandler(function (response) {
									// Do nothing
								}.bind(this)));
							}
							if (updatedParentEmails.length > 0) {
								this.updateParentEmails(updatedParentIDs, updatedParentEmails);
							}
	
							this.setState({ loading: false, students: newStudents });
							this.refs.modal.hide();
							window.wrNotifications.triggerDropDownNotification({
								title: title, text: text, icon: "ok-circle" });
						} else {
							this.setState({ loading: false });
							this.refs.modal.hide();
						}
					} else {
						this.setState({ loading: false });
						this.refs.errors.setErrors(errors);
					}
				}
			}
		}, {
			key: "updateParentEmails",
			value: function updateParentEmails(ids, emails) {
				var parentData = { parent: { email: emails.pop() } };
				CurrentUser.api().patchParent(ids.pop(), parentData, $wr.apiHandler(function (response) {
					if (emails.length > 0) {
						this.updateParentEmails(ids, emails);
					}
				}.bind(this)));
			}
		}, {
			key: "render",
			value: function render() {
				var headerRow = React.createElement(
					"tr",
					null,
					React.createElement(
						"th",
						{ className: "studentName" },
						"Student"
					),
					React.createElement(
						"th",
						null,
						"Parent Email"
					)
				);
				var students = _.sortBy(this.state.students, function (s) {
					return s.last_name;
				});
				var studentRows = students.map(function (student) {
					if (student.parent != null) {
						var currentParentEmail = student.parent.email;
					} else {
						var placeholderValue = "Enter parent email";
					}
					var parentEmailSection = React.createElement("input", { className: "form-control", placeholder: placeholderValue,
						type: "email", ref: "parentEmails" + student.id, defaultValue: currentParentEmail });
					return React.createElement(
						"tr",
						{ key: student.id },
						React.createElement(
							"td",
							{ className: "studentName" },
							student.display_name
						),
						React.createElement(
							"td",
							null,
							parentEmailSection
						)
					);
				}.bind(this));
				var modalBody = React.createElement(
					"div",
					{ className: "parentEmailTable", ref: "parentEmailTable" },
					React.createElement(
						"p",
						{ className: "instructionsText" },
						"Add parent emails so that they can sign off on their students' reading logs every week. We don't share email addresses and we only email parents to request reading log approval and share their child's reading progress."
					),
					React.createElement(
						"form",
						{ onSubmit: this.submitParentEmail },
						React.createElement(ErrorDisplay, { ref: "errors" }),
						React.createElement(
							"table",
							{ className: "table" },
							React.createElement(
								"tbody",
								null,
								headerRow,
								studentRows
							)
						),
						React.createElement(
							"button",
							{ className: "btn buttonSuccess center-block", onClick: this.submitParentEmail },
							"Save Emails"
						)
					)
				);
	
				return React.createElement(
					Modal,
					{ className: "parentEmailsModal", ref: "modal", headerText: "Add & Edit Parent Emails" },
					modalBody
				);
			}
		}]);
	
		return ParentEmailsModal;
	}(React.Component);
	
	ParentEmailsModal.propTypes = StrictPropTypes({
		activeStudentListID: PropTypes.number.isRequired
	});
	
	module.exports = ParentEmailsModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactTooltip = __webpack_require__(12);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrgDropdown = __webpack_require__(100);
	var BraveCheckbox = __webpack_require__(120);
	var BraveToolbar = __webpack_require__(929);
	var Modal = __webpack_require__(18);
	var Glyphicon = __webpack_require__(8);
	var StandardIcon = __webpack_require__(250);
	var Spinner = __webpack_require__(9);
	
	var RosterStudent = __webpack_require__(823);
	var RosterUnAssignedStudent = __webpack_require__(825);
	var RosterStudentList = __webpack_require__(824);
	var AddRosterClasses = __webpack_require__(814);
	var AddRosterStudents = __webpack_require__(815);
	var StudentSubgroups = __webpack_require__(829);
	var StudentLogins = __webpack_require__(828);
	var SchoolInfoModal = __webpack_require__(393);
	var AwardCoins = __webpack_require__(817);
	var SendNote = __webpack_require__(827);
	var RosterEditStudentLists = __webpack_require__(821);
	var LogReadingModal = __webpack_require__(164);
	var OverdrawnAccountNotice = __webpack_require__(246);
	var PendingTaskNotice = __webpack_require__(161);
	
	var OrgTypes = __webpack_require__(45);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3704);
	
	var RosterContent = (_dec = (0, _reactRedux.connect)(function (state, props) {
	
		// MOUNT STUDENT WITHIN STUDENT LISTS
		var studentLists = {};
		_underscore2.default.each(RosterSelectors.studentListsByAdminId({ state: state, adminId: CurrentUser.get().id }), function (sl) {
			studentLists[sl.id] = sl;
			studentLists[sl.id].students = [];
			studentLists[sl.id].primary_students = [];
		});
	
		_underscore2.default.each(state.students, function (student) {
			if (student.student_list_ids) {
				_underscore2.default.each(student.student_list_ids.all, function (id) {
					if (studentLists[id]) {
						studentLists[id].students.push(student);
					}
				});
				if (studentLists[student.student_list_ids.primary]) {
					studentLists[student.student_list_ids.primary].primary_students.push(student);
				}
			}
		});
	
		var loading = RosterSelectors.isLoadingStudentLists({ state: state });
	
		return {
			currentAdmin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }),
			studentLists: _underscore2.default.values(studentLists),
			loading: loading,
			getStudents: function getStudents(orgIdentifier) {
				return RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier });
			}
		};
	}, function (dispatch, props) {
	
		var fetchStudents = function fetchStudents() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS;
			return dispatch(RosterActions.fetchStudents({ embeds: embeds }));
		};
	
		var fetchStudentLists = function fetchStudentLists() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS;
			return dispatch(RosterActions.fetchStudentLists({ embeds: embeds }));
		};
	
		var getCleverUser = function getCleverUser() {
			return dispatch(RosterActions.fetchAdmins({
				filters: { ids: [CurrentUser.get().id] },
				embeds: ["admin.clever_user"]
			}));
		};
	
		var addDemoStudent = function addDemoStudent(adminID, studentListID) {
			return dispatch(RosterActions.updateAdmin({
				id: adminID,
				update: { add_demo_for_teacher: true, student_list_id: studentListID }
			}));
		};
	
		var archiveStudentList = function archiveStudentList(slID) {
			return dispatch(RosterActions.archiveStudentList({
				id: slID
			}));
		};
	
		var destroyStudents = function destroyStudents(studentIDs) {
			return dispatch(RosterActions.destroyStudents({
				studentIDs: studentIDs,
				embeds: ["student.student_list_ids"]
			}));
		};
	
		var updateStudentList = function updateStudentList(id, update) {
			var promises = [];
			if (!_underscore2.default.isEmpty(update)) {
				promises.push(dispatch(RosterActions.updateStudentList({
					id: id, update: update
				})));
			}
			return Promise.all(promises);
		};
	
		var fetchArchivedStudentLists = function fetchArchivedStudentLists() {
			var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id;
	
			var query = {
				inactive: true,
				inactive_within_year: true,
				effective_user_id: effectiveUserID,
				embed: ["student.avatar", "student.student_list_ids", "student.primary_student_list_id"]
			};
	
			return dispatch(RosterActions.fetchStudentListsStoreless({ query: query }));
		};
	
		var populateData = function populateData() {
			return Promise.all([fetchStudentLists().then(function (slResponse) {
				return fetchStudents();
			})]);
		};
	
		return {
			fetchStudents: fetchStudents,
			fetchStudentLists: fetchStudentLists,
			getCleverUser: getCleverUser,
			addDemoStudent: addDemoStudent,
			archiveStudentList: archiveStudentList,
			destroyStudents: destroyStudents,
			fetchArchivedStudentLists: fetchArchivedStudentLists,
			updateStudentList: updateStudentList,
			populateData: populateData
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(RosterContent, _React$Component);
	
		function RosterContent(props) {
			_classCallCheck(this, RosterContent);
	
			var _this = _possibleConstructorReturn(this, (RosterContent.__proto__ || Object.getPrototypeOf(RosterContent)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("RosterContent");
	
			// if expand param present, expand those sls
			// if only one sl exist, expand it by default
			var initExpandedSLSections = [];
			if ($wr.getURLParameterByName('expand_sl')) {
				var initExpandedSLSections = _underscore2.default.map($wr.getURLParameterByName('expand_sl').split(','), function (id) {
					return parseInt(id);
				});
			} else if (_underscore2.default.size(props.studentLists) === 1) {
				var initExpandedSLSections = [_underscore2.default.first(props.studentLists).id];
			}
	
			_this.state = {
				selectedStudentIDs: [],
				clickedStudentListID: null, // Only for default manual add students
	
				// Modals that are opened by state :(
				logReadingModalOpen: false,
	
				// Tracks opened student list sections
				expandedStudentListSections: initExpandedSLSections,
	
				// Tracks status of edit SL form
				expandedStudentListForms: [],
				expandedStudentListFormClass: null,
	
				demoStudentLoading: false,
				unassignedStudentLists: []
			};
	
			_this.addClassesModal = React.createRef();
			_this.addStudentsModal = React.createRef();
	
			_this.subgroupsModal = React.createRef();
			_this.awardCoinsModal = React.createRef();
			_this.sendNoteModal = React.createRef();
			_this.studentLoginsModal = React.createRef();
	
			_this.editStudentListsModal = React.createRef();
			_this.deleteStudentModal = React.createRef();
			return _this;
		}
	
		///////// HELPER METHODS /////////
	
	
		_createClass(RosterContent, [{
			key: "maxStudentListCount",
			value: function maxStudentListCount() {
				return CurrentUser.get().account.max_student_list_count;
			}
		}, {
			key: "maxStudentCount",
			value: function maxStudentCount() {
				return CurrentUser.get().account.max_students_count;
			}
		}, {
			key: "isOverdrawnStudentLists",
			value: function isOverdrawnStudentLists() {
				return this.props.studentLists.length > this.maxStudentListCount();
			}
		}, {
			key: "isOverdrawnStudents",
			value: function isOverdrawnStudents() {
				var _this2 = this;
	
				return _underscore2.default.filter(this.props.studentLists, function (studentList) {
					if (studentList.students) {
						return studentList.students.length > _this2.maxStudentCount();
					}
				}).length > 0;
			}
		}, {
			key: "isAdmin",
			value: function isAdmin() {
				return CurrentUser.isSchoolAdmin() || CurrentUser.isDistrictAdmin();
			}
		}, {
			key: "isRosterDisabled",
			value: function isRosterDisabled() {
				if (this.props.studentLists.length > 0) {
					var prefs = this.props.studentLists[0].prefs;
					if (prefs && prefs["rostering_method"] && !_underscore2.default.isEmpty(prefs["rostering_method"]) && prefs["rostering_method"]["manager"] != "individual") {
						return true;
					}
				}
	
				return false; //this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false
			}
		}, {
			key: "hasCleverUser",
			value: function hasCleverUser() {
				return this.props.currentAdmin && this.props.currentAdmin.clever_user;
			}
	
			// used to tell if we should display button.
	
		}, {
			key: "slHasNonPrimaryStudents",
			value: function slHasNonPrimaryStudents(studentList) {
				return _underscore2.default.some(studentList.students, function (student) {
					return student.student_list_ids.primary != studentList.id;
				});
			}
		}, {
			key: "hasMismatchedGradeLevels",
			value: function hasMismatchedGradeLevels(studentList) {
				return _underscore2.default.some(studentList.students, function (student) {
					return student.prefs.academic_level.toString() != studentList.grade_level;
				});
			}
		}, {
			key: "isAddingClassDisabled",
			value: function isAddingClassDisabled() {
				if (this.props.studentLists.length > 0) {
					var prefs = this.props.studentLists[0].prefs;
					if (prefs && prefs["rostering_method"] && !_underscore2.default.isEmpty(prefs["rostering_method"])) {
						// DISABLE ADDING CLASS FOR USERS THAT SHOULD SYNC WITH CLEVER OR GOOGLE SSO
						if (prefs["rostering_method"]["manager"] != "individual" || prefs["rostering_method"]["method"] != "manual") {
							return true;
						}
					}
				}
	
				return false;
			}
		}, {
			key: "checkIsPendingSchool",
			value: function checkIsPendingSchool() {
				if (this.props.studentLists && this.props.studentLists.length > 0) {
					var schools = _underscore2.default.pluck(this.props.studentLists, 'school');
					if (!schools) {
						return true;
					}
	
					var pendingSchools = _underscore2.default.where(schools, { zip: "00000" });
					if (_underscore2.default.size(pendingSchools) == _underscore2.default.size(schools)) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: "getStudentListIDs",
			value: function getStudentListIDs() {
				return _underscore2.default.map(this.props.studentLists, function (sl) {
					return sl.id;
				});
			}
		}, {
			key: "unassignedStudents",
			value: function unassignedStudents() {
				return _underscore2.default.where(_underscore2.default.flatten(_underscore2.default.pluck(this.state.unassignedStudentLists, 'primary_students')), { suspended: false });
			}
		}, {
			key: "unassignedSLLookup",
			value: function unassignedSLLookup(student) {
				return _underscore2.default.first(_underscore2.default.filter(this.state.unassignedStudentLists, function (sl) {
					return _underscore2.default.contains(_underscore2.default.pluck(sl.students, 'id'), student.id);
				}));
			}
	
			///////// STUDENT GETTERS /////////
	
		}, {
			key: "filteredStudents",
			value: function filteredStudents(studentListID) {
				if (this.props.orgIdentifier.includes(OrgTypes.SUBGROUP)) {
					var allStudents = this.props.getStudents(OrgTypes.toIdentifier({
						type: OrgTypes.SUBGROUP, key: this.props.orgIdentifier.replace('subgroup:', '')
					}));
	
					return _underscore2.default.filter(allStudents, function (stu) {
						return _underscore2.default.includes(stu.student_list_ids.all, studentListID);
					});
				}
				return this.props.getStudents(OrgTypes.toIdentifier({
					type: OrgTypes.STUDENT_LIST, key: studentListID
				}));
			}
		}, {
			key: "filteredStudentLists",
			value: function filteredStudentLists() {
				if (this.props.orgIdentifier.includes(OrgTypes.SUBGROUP)) {
					var students = this.props.getStudents(OrgTypes.toIdentifier({
						type: OrgTypes.SUBGROUP, key: this.props.orgIdentifier.replace('subgroup:', '')
					}));
	
					var slIDs = _underscore2.default.uniq(_underscore2.default.flatten(_underscore2.default.pluck(_underscore2.default.pluck(students, 'student_list_ids'), 'all')));
	
					return _underscore2.default.filter(this.props.studentLists, function (sl) {
						return _underscore2.default.includes(slIDs, sl.id);
					});
				}
			}
		}, {
			key: "allStudents",
			value: function allStudents() {
				var _this3 = this;
	
				if (this.props.studentLists.length) {
					return _underscore2.default.uniq(_underscore2.default.flatten(this.props.studentLists.map(function (sl) {
						return _this3.filteredStudents(sl.id);
					})));
				}
			}
		}, {
			key: "allSelectedStudents",
			value: function allSelectedStudents() {
				var _this4 = this;
	
				var students = this.allStudents();
				if (students && students.length > 0) {
					return this.allStudents().filter(function (s) {
						return _this4.isSelectedStudentID(s.id);
					});
				}
				return [];
			}
	
			///////// STUDENT SETTERS /////////
	
		}, {
			key: "afterStudentCreate",
			value: function afterStudentCreate() {
				if (this.addDemoStudentModal.current) {
					this.addDemoStudentModal.current.hide();
				}
				this.props.fetchStudentLists();
				this.props.fetchStudents();
			}
		}, {
			key: "handleMultipleStudentDestroy",
			value: function handleMultipleStudentDestroy(e) {
				var _this5 = this;
	
				$wr.nope(e);
				if (confirm("Are you sure you want to delete all selected students? Students will be removed from all classes.")) {
					this.props.destroyStudents(this.state.selectedStudentIDs).then(function () {
						var bannerTitle = _underscore2.default.size(_this5.state.selectedStudentIDs) + " Students Deleted";
						_this5.setState({ selectedStudentIDs: [] });
						window.wrNotifications.triggerDropDownNotification({
							title: bannerTitle, icon: "ok-sign"
						}, 4000);
					}).catch(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Oops!", text: "Something went wrong and the students were not deleted",
							type: "error", icon: "remove"
						}, 4000);
					});
				}
			}
		}, {
			key: "updateArchivedStudentLists",
			value: function updateArchivedStudentLists() {
				var _this6 = this;
	
				this.props.fetchArchivedStudentLists().then(function (response) {
					if (response.student_lists) {
						_this6.setState({ unassignedStudentLists: response.student_lists });
					}
				});
			}
		}, {
			key: "onUpdateArchivedStudent",
			value: function onUpdateArchivedStudent() {
				this.updateArchivedStudentLists();
				this.props.fetchStudentLists();
				this.props.fetchStudents();
			}
	
			///////// STUDENT LIST EXPANSION /////////
	
		}, {
			key: "handleExpandStudentListSection",
			value: function handleExpandStudentListSection(slID) {
				if (this.slExpanded(slID)) {
					this.setState({ expandedStudentListSections: _underscore2.default.without(this.state.expandedStudentListSections, slID), expandedStudentListForms: _underscore2.default.without(this.state.expandedStudentListForms, slID) });
				} else {
					this.setState({ expandedStudentListSections: [].concat(_toConsumableArray(this.state.expandedStudentListSections), [slID]) });
				}
			}
		}, {
			key: "slExpanded",
			value: function slExpanded(slID) {
				return _underscore2.default.includes(this.state.expandedStudentListSections, slID);
			}
		}, {
			key: "slFormExpanded",
			value: function slFormExpanded(slID) {
				return _underscore2.default.includes(this.state.expandedStudentListForms, slID);
			}
		}, {
			key: "allExpanded",
			value: function allExpanded() {
				return _underscore2.default.size(this.props.studentLists) == _underscore2.default.size(this.state.expandedStudentListSections);
			}
		}, {
			key: "toggleAllStudentLists",
			value: function toggleAllStudentLists() {
				var expandedSLs = this.allExpanded() ? [] : this.getStudentListIDs();
				this.setState({ expandedStudentListSections: expandedSLs });
			}
	
			///////// STUDENT LIST FORM EXPANSION /////////
	
			// Shows and hides edit student list form
	
		}, {
			key: "toggleEditSLForm",
			value: function toggleEditSLForm(slID) {
				var _this7 = this;
	
				if (_underscore2.default.includes(this.state.expandedStudentListForms, slID)) {
					this.setState({ expandedStudentListFormClass: 'drawerClosed' }, function () {
						// keep this setTimeout function to ensure all 
						// transitions are complete before removing
						setTimeout(function () {
							this.setState({ expandedStudentListForms: _underscore2.default.without(this.state.expandedStudentListForms, slID) });
						}.bind(_this7), 1500);
					});
				} else {
					this.setState({ expandedStudentListForms: [].concat(_toConsumableArray(this.state.expandedStudentListForms), [slID]) }, function () {
						setTimeout(function () {
							this.setState({ expandedStudentListFormClass: 'drawerOpen' });
						}.bind(_this7), 50);
					});
				}
			}
	
			///////// STUDENT LIST MANIPULATORS /////////
	
		}, {
			key: "onArchive",
			value: function onArchive(slID) {
				if (confirm('Are you sure you want to delete this class? This will also delete students who are ONLY in this class. This will NOT delete any students who are in multiple classes.')) {
					this.props.archiveStudentList(slID);
					var title = "Class Archived";
					var text = "You have archived this class. However, no class is left behind.";
	
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle"
					}, 4000);
				}
			}
	
			// makes studentList the primary sl for all of its students
	
		}, {
			key: "onForcePrimary",
			value: function onForcePrimary(studentList, e) {
				var _this8 = this;
	
				$wr.nope(e);
				this.props.updateStudentList(studentList.id, { "force_primary": true }).then(function (res) {
					_this8.props.fetchStudentLists();
					_this8.props.fetchStudents();
				});
			}
		}, {
			key: "onForceGradeLevel",
			value: function onForceGradeLevel(studentList, e) {
				var _this9 = this;
	
				$wr.nope(e);
				this.props.updateStudentList(studentList.id, { "force_grade_level": true }).then(function (res) {
					_this9.props.fetchStudentLists();
					_this9.props.fetchStudents();
				});
			}
	
			// adds student list after creation
	
		}, {
			key: "addStudentLists",
			value: function addStudentLists() {
				this.addClassesModal.current.hide();
				this.props.fetchStudentLists();
			}
		}, {
			key: "handleRosterUpdate",
			value: function handleRosterUpdate(event, taskName) {
				if ($wr.getURLParameterByName('expand_sl')) {
					var studentListIDs = _underscore2.default.map($wr.getURLParameterByName('expand_sl').split(','), function (id) {
						return parseInt(id);
					});
					this.setState({ expandedStudentListSections: [].concat(_toConsumableArray(this.state.expandedStudentListSections), _toConsumableArray(studentListIDs)) });
				}
	
				if (taskName == PendingTaskNotice.UPLOADING_STUDENTS || taskName == PendingTaskNotice.CLEVER_SYNC || taskName == PendingTaskNotice.GOOGLE_SYNC || taskName == undefined) {
					if (this.addStudentsModal.current) {
						this.addStudentsModal.current.hide();
					}
					// reload data needed since PendingTaskNotice doesn't use redux
					this.props.fetchStudentLists();
					this.props.fetchStudents();
				}
			}
	
			///////// STUDENT CHECKBOX METHODS /////////
	
		}, {
			key: "isSelectedStudentID",
			value: function isSelectedStudentID(studentID) {
				return !!_underscore2.default.contains(this.state.selectedStudentIDs, studentID);
			}
		}, {
			key: "isSelectedStudentListID",
			value: function isSelectedStudentListID(studentListID) {
				var _this10 = this;
	
				var students = this.filteredStudents(studentListID);
				return !!(students.length && _underscore2.default.all(students, function (s) {
					return _this10.isSelectedStudentID(s.id);
				}));
			}
		}, {
			key: "isAllStudentsSelected",
			value: function isAllStudentsSelected() {
				var studentIDs = _underscore2.default.pluck(this.allStudents(), "id");
				return _underscore2.default.difference(studentIDs, this.state.selectedStudentIDs).length === 0;
			}
		}, {
			key: "toggleStudentID",
			value: function toggleStudentID(studentID) {
				if (this.isSelectedStudentID(studentID)) {
					var selectedStudentIDs = _underscore2.default.difference(this.state.selectedStudentIDs, [studentID]);
				} else {
					var selectedStudentIDs = _underscore2.default.uniq(this.state.selectedStudentIDs.concat([studentID]));
				}
				this.setState({ selectedStudentIDs: selectedStudentIDs });
			}
		}, {
			key: "toggleStudentListID",
			value: function toggleStudentListID(studentListID) {
				var studentIDs = _underscore2.default.pluck(this.filteredStudents(studentListID), "id");
				if (this.isSelectedStudentListID(studentListID)) {
					var selectedStudentIDs = _underscore2.default.difference(this.state.selectedStudentIDs, studentIDs);
				} else {
					var selectedStudentIDs = _underscore2.default.uniq(this.state.selectedStudentIDs.concat(studentIDs));
				}
				this.setState({ selectedStudentIDs: selectedStudentIDs });
			}
		}, {
			key: "toggleAll",
			value: function toggleAll() {
				if (this.isAllStudentsSelected()) {
					var selectedStudentIDs = [];
				} else {
					var selectedStudentIDs = _underscore2.default.pluck(this.allStudents(), "id");
				}
				this.setState({ selectedStudentIDs: selectedStudentIDs });
			}
		}, {
			key: "deselectedAll",
			value: function deselectedAll() {
				this.setState({ selectedStudentIDs: [] });
			}
	
			///////// MODALS /////////
	
		}, {
			key: "openAddStudentModal",
			value: function openAddStudentModal(studentListID) {
				this.setState({
					clickedStudentListID: studentListID
				});
				this.addStudentsModal.current.show();
			}
		}, {
			key: "addDemoStudent",
			value: function addDemoStudent(studentListID) {
				var _this11 = this;
	
				this.setState({ clickedStudentListID: studentListID, demoStudentLoading: true });
				this.props.addDemoStudent(CurrentUser.get().id, studentListID).then(function () {
	
					// we need to fetch the students since our action edits the admin
					_this11.props.fetchStudents().then(function () {
						_this11.setState({ demoStudentLoading: false });
						window.wrNotifications.triggerDropDownNotification({
							title: "Demo Student Added", text: '', icon: "ok-circle"
						}, 4000);
					});
				});
			}
	
			///////// RENDER METHODS /////////
	
		}, {
			key: "renderOverdrawnMessage",
			value: function renderOverdrawnMessage() {
				if (this.props.studentLists) {
					if (CurrentUser.isTeacherAdmin() && (this.isOverdrawnStudents() || this.isOverdrawnStudentLists())) {
						if (this.isOverdrawnStudentLists()) {
							var overdrawnAlert = React.createElement(
								"div",
								{ className: "overdrawnAlert classLimit" },
								"Over Limit: ",
								this.props.studentLists.length,
								"/",
								this.maxStudentListCount(),
								" classes"
							);
						}
	
						return React.createElement(
							"div",
							null,
							React.createElement(OverdrawnAccountNotice, { source: "roster" }),
							overdrawnAlert
						);
					}
				}
			}
		}, {
			key: "renderToolbar",
			value: function renderToolbar() {
				var _this12 = this;
	
				var selectedStudents = this.allSelectedStudents();
				var maybe = function maybe(openF) {
					return function () {
						if (_underscore2.default.isEmpty(selectedStudents)) {
							window.wrNotifications.triggerDropDownNotification({
								title: "Select Students", text: "Please select one or more students first.",
								icon: "remove-sign"
							}, 4000);
							return;
						}
						openF();
					};
				};
	
				return React.createElement(
					"div",
					{ className: "toolbarContainer" },
					React.createElement(
						BraveToolbar,
						{ itemCount: selectedStudents.length,
							icon: "student", iconType: StandardIcon.WR_ICON,
							onClear: this.deselectedAll },
						React.createElement(
							"div",
							{ className: "rowOne" },
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.subgroupsModal.current.show();
									}) },
								this.renderGroupLinkText()
							),
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.setState({ logReadingModalOpen: true });
									}) },
								"Log Reading"
							),
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.awardCoinsModal.current.show();
									}) },
								"Award Coins"
							),
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.sendNoteModal.current.show();
									}) },
								"Send Note"
							),
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.editStudentListsModal.current.show();
									}) },
								"Edit Classes"
							),
							React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: maybe(function () {
										return _this12.handleMultipleStudentDestroy();
									}) },
								"Delete Students"
							),
							!this.isAddingClassDisabled() && React.createElement(
								"button",
								{ className: "btn btn-link",
									onClick: function onClick() {
										return _this12.studentLoginsModal.current.show();
									} },
								"Login Information"
							)
						)
					),
					React.createElement(
						Modal,
						{ ref: this.subgroupsModal, headerText: "Student Groups" },
						React.createElement(StudentSubgroups, { students: selectedStudents,
							onComplete: function onComplete() {
								return _this12.subgroupsModal.current.hide();
							} })
					),
					React.createElement(LogReadingModal, { open: this.state.logReadingModalOpen,
						onClose: function onClose() {
							return _this12.setState({ logReadingModalOpen: false });
						},
						studentsSelected: selectedStudents }),
					React.createElement(
						Modal,
						{ ref: this.awardCoinsModal, headerText: "AwardCoins" },
						React.createElement(AwardCoins, { students: selectedStudents,
							onComplete: function onComplete() {
								return _this12.awardCoinsModal.current.hide();
							} })
					),
					React.createElement(
						Modal,
						{ ref: this.sendNoteModal, headerText: "Send Note" },
						React.createElement(SendNote, { students: selectedStudents,
							onComplete: function onComplete() {
								return _this12.sendNoteModal.current.hide();
							} })
					),
					React.createElement(
						Modal,
						{ ref: this.studentLoginsModal, className: "wideModal", headerText: "Student Groups" },
						React.createElement(StudentLogins, { students: selectedStudents })
					),
					React.createElement(
						Modal,
						{ ref: this.editStudentListsModal, headerText: "Edit Classes" },
						React.createElement(RosterEditStudentLists, { students: selectedStudents, totalStudentCount: _underscore2.default.size(this.allStudents()),
							onComplete: function onComplete() {
								return _this12.editStudentListsModal.current.hide();
							} })
					)
				);
			}
		}, {
			key: "renderGroupLinkText",
			value: function renderGroupLinkText() {
				var students = this.allSelectedStudents();
				var studentsWithGroups = 0;
	
				students.map(function (student) {
					if (!_underscore2.default.isEmpty(student.prefs.subgroup)) {
						studentsWithGroups++;
					}
				});
	
				return students.length > 0 && students.length == studentsWithGroups ? "Edit Group" : "Add To Group";
			}
		}, {
			key: "renderEmptySection",
			value: function renderEmptySection() {
				return React.createElement(
					"div",
					{ key: "emptySection", className: "emptySection" },
					"You have not added any students yet."
				);
			}
		}, {
			key: "renderAddClassButton",
			value: function renderAddClassButton() {
				var _this13 = this;
	
				if (!this.isAdmin() && !this.isRosterDisabled() && !this.isAddingClassDisabled()) {
					return React.createElement(
						"button",
						{ className: "btn btn-link rowButton",
							onClick: function onClick() {
								return _this13.addClassesModal.current.show();
							} },
						"Add Classes"
					);
				}
			}
		}, {
			key: "renderAddClassModal",
			value: function renderAddClassModal() {
				if (!this.isAdmin() && !this.isRosterDisabled()) {
					return React.createElement(
						Modal,
						{ className: "slightlyNarrowModal",
							headerText: "Add Classes",
							ref: this.addClassesModal },
						React.createElement(AddRosterClasses, { addStudentLists: this.addStudentLists })
					);
				}
			}
		}, {
			key: "renderExpandAllButton",
			value: function renderExpandAllButton() {
				var _this14 = this;
	
				var btnText = this.allExpanded() ? 'Collapse All' : 'Expand All';
				return React.createElement(
					"button",
					{ className: "btn btn-link rowButton",
						onClick: function onClick() {
							return _this14.toggleAllStudentLists();
						} },
					btnText
				);
			}
		}, {
			key: "renderAddStudentButton",
			value: function renderAddStudentButton() {
				var _this15 = this;
	
				if (!this.isAdmin() && !this.isRosterDisabled()) {
					return React.createElement(
						"button",
						{ className: "btn btn-link rowButton",
							onClick: function onClick() {
								return _this15.openAddStudentModal();
							} },
						"Add Students"
					);
				}
			}
		}, {
			key: "renderAddStudentsModal",
			value: function renderAddStudentsModal() {
				return React.createElement(
					Modal,
					{ className: "moreWideModal",
						headerText: "Add Students",
						ref: this.addStudentsModal },
					React.createElement(AddRosterStudents, {
						defaultStudentListID: this.state.clickedStudentListID,
						afterCreate: this.handleRosterUpdate })
				);
			}
		}, {
			key: "renderOverallLine",
			value: function renderOverallLine() {
				return React.createElement(
					"div",
					_defineProperty({ key: "overalLine", className: "overallLine" }, "key", "overall"),
					React.createElement(
						"div",
						{ className: "overallLineContent" },
						React.createElement(
							"div",
							{ className: "checkboxSection" },
							React.createElement(BraveCheckbox, { value: this.isAllStudentsSelected(),
								onClick: this.toggleAll })
						),
						React.createElement(
							"div",
							{ className: "nameSection" },
							React.createElement(
								"strong",
								null,
								"All Students"
							)
						),
						React.createElement(
							"div",
							{ className: "detailSection" },
							this.renderExpandAllButton()
						),
						React.createElement(
							"div",
							{ className: "detailSection double text-right" },
							this.renderAddStudentButton(),
							this.renderAddClassButton()
						),
						this.renderAddStudentsModal(),
						this.renderAddClassModal()
					)
				);
			}
		}, {
			key: "renderStudentsAndStudentLists",
			value: function renderStudentsAndStudentLists() {
				var _this16 = this;
	
				var items = [];
	
				var _OrgTypes$fromIdentif = OrgTypes.fromIdentifier(this.props.orgIdentifier),
				    type = _OrgTypes$fromIdentif.type,
				    key = _OrgTypes$fromIdentif.key;
	
				if (type == OrgTypes.ALL_STUDENTS) {
					var studentLists = this.props.studentLists;
				} else if (type == OrgTypes.SUBGROUP) {
					var studentLists = this.filteredStudentLists();
				} else {
					var studentLists = _underscore2.default.filter(this.props.studentLists, function (sl) {
						return sl.id === key;
					});
				}
	
				studentLists = _underscore2.default.sortBy(studentLists, "name");
				studentLists = _underscore2.default.sortBy(studentLists, function (sl) {
					if (sl.school) {
						return sl.school.name;
					}
				});
	
				studentLists.forEach(function (studentList, idx) {
					var classItems = [];
					var studentItems = [];
					classItems.push(React.createElement(RosterStudentList, { key: "sl-" + studentList.id,
						slIndex: idx,
						fetchStudents: _this16.props.fetchStudents,
						toggleFormStatus: _this16.toggleEditSLForm,
						openSectionClass: _this16.state.expandedStudentListFormClass,
						expanded: _this16.slExpanded(studentList.id),
						formExpanded: _this16.slFormExpanded(studentList.id),
						handleExpandStudentListSection: _this16.handleExpandStudentListSection,
						studentList: studentList,
						resetStudentLists: _this16.props.fetchStudentLists }));
	
					var students = $wr.sortByName(_this16.filteredStudents(studentList.id), $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST);
	
					//////// DISPLY SPINNER IF STUDENTS ARE STILL LOADING
					if (studentList.student_ids && studentList.student_ids.length > 0 && students.length == 0) {
						studentItems = React.createElement(Spinner, { key: "spinner-" + studentList.id, scale: 1, placeholder: true, className: "studentLoadingSpinner" });
					} else {
						_underscore2.default.sortBy(students, function (s) {
							return s.suspended;
						}).forEach(function (student, stuIdx) {
							studentItems.push(React.createElement(RosterStudent, { key: "sl-" + studentList.id + "-student-" + student.id,
								index: stuIdx,
								slIndex: idx,
								student: student,
								studentList: studentList,
								selected: _this16.isSelectedStudentID(student.id),
								toggleSelected: function toggleSelected() {
									return _this16.toggleStudentID(student.id);
								} }));
						});
	
						// DEFINE DEMO STUDENT ACTION STATUS
						var demoInClass = _underscore2.default.size(_underscore2.default.where(students, { demo_for_teacher: true })) > 0;
						if (_this16.state.demoStudentLoading) {
							var demoStudentButton = React.createElement(Spinner, { key: "demo-spinner", scale: 1, placeholder: true, className: "demoBtnSpinner" });
						} else if (!demoInClass) {
							var demoStudentButton = React.createElement(
								"button",
								{ key: "demo-btn-" + studentList.id, className: "btn btn-link textColorButton",
									onClick: function onClick() {
										return _this16.addDemoStudent(studentList.id);
									} },
								React.createElement(Glyphicon, { icon: "plus-sign" }),
								" Add Demo Student"
							);
						} else {
							var demoStudentButton = '';
						}
	
						// DEFINE STUDENT CREATION ACTION (DEMO AND/OR REAL)
						if (!_this16.isRosterDisabled()) {
							studentItems.push(React.createElement(
								"div",
								{ className: "overallLine", key: "all-students-" + studentList.id },
								React.createElement(
									"div",
									{ className: "text-center" },
									React.createElement(
										"button",
										{ className: "btn btn-link textColorButton",
											onClick: function onClick() {
												return _this16.openAddStudentModal(studentList.id);
											} },
										React.createElement(Glyphicon, { icon: "plus-sign" }),
										" Add Students"
									),
									demoStudentButton
								)
							));
						} else if (!demoInClass || _this16.state.demoStudentLoading) {
							studentItems.push(React.createElement(
								"div",
								{ className: "overallLine", key: "all-students-" + studentList.id },
								React.createElement(
									"div",
									{ className: "text-center" },
									demoStudentButton
								)
							));
						}
	
						if (!_this16.isRosterDisabled() && !_this16.hasCleverUser()) {
							var archiveBtn = React.createElement(
								"button",
								{ key: "archive-btn-" + studentList.id, className: "btn btn-link rowButton archiveBtn", onClick: function onClick() {
										return _this16.onArchive(studentList.id);
									} },
								" Archive Class "
							);
						}
	
						if (_this16.slHasNonPrimaryStudents(studentList)) {
							var forcePrimaryBtn = React.createElement(
								"button",
								{ key: "primary-btn-" + studentList.id, onClick: _this16.onForcePrimary.bind(_this16, studentList), className: "\"btn btn-link rowButton resetSL", "data-tip": true, "data-for": "primary" },
								" Make Primary For All "
							);
						}
	
						if (_this16.hasMismatchedGradeLevels(studentList)) {
							var forceGradeLevelBtn = React.createElement(
								"button",
								{ key: "gl-btn-" + studentList.id, onClick: _this16.onForceGradeLevel.bind(_this16, studentList), className: "\"btn btn-link rowButton resetGL", "data-tip": true, "data-for": "gradeLevel" },
								" Reset Grade Levels "
							);
						}
	
						var menuOptions = React.createElement(
							"div",
							{ className: "slMenuOptions studentListMultiselect", key: "slMenuOptions-" + studentList.id },
							React.createElement(
								"div",
								{ className: "checkboxSection" },
								React.createElement(BraveCheckbox, { value: _this16.isSelectedStudentListID(studentList.id),
									onClick: function onClick() {
										return _this16.toggleStudentListID(studentList.id);
									} })
							),
							React.createElement(
								"div",
								{ className: "nameSection" },
								React.createElement(
									"strong",
									null,
									"Select Class"
								)
							),
							React.createElement("div", { className: "detailSection" }),
							React.createElement(
								"div",
								{ className: "detailSection double text-right" },
								React.createElement(
									"button",
									{
										className: "btn btn-link rowButton editClassBtn",
										id: "editClassBtn-" + idx,
										onClick: function onClick() {
											return _this16.toggleEditSLForm(studentList.id);
										} },
									" Edit Class"
								),
								archiveBtn,
								forcePrimaryBtn,
								forceGradeLevelBtn
							),
							React.createElement(
								_reactTooltip2.default,
								{ id: "gradeLevel" },
								"This will set the academic and grade level of each student in this class to grade ",
								studentList.grade_level,
								"."
							),
							React.createElement(
								_reactTooltip2.default,
								{ id: "primary" },
								"This will set all this student list as the primary student list for all students in this class."
							)
						);
					}
	
					// FINAL ASSEMBLY OF STUDENTS LIST AND STUDENT DISPLAYS
					var collapsedClass = _underscore2.default.include(_this16.state.expandedStudentListSections, studentList.id) ? "expanded" : "collapsed";
					var classSection = React.createElement(
						"div",
						{ className: "classSectionContainer " + collapsedClass, key: 'classSectionContainer-' + studentList.id },
						classItems,
						React.createElement(
							"div",
							{ className: "studentSectionContainer" },
							menuOptions,
							studentItems
						)
					);
					items.push(classSection);
				});
				return items;
			}
		}, {
			key: "renderUnassignedStudents",
			value: function renderUnassignedStudents() {
				var _this17 = this;
	
				var items = [];
				if (!_underscore2.default.isEmpty(this.state.unassignedStudentLists)) {
					var students = this.unassignedStudents();
					if (_underscore2.default.isEmpty(students)) {
						return null;
					} // don't display if there are no students
	
					var classItems = [];
					var studentItems = [];
	
					var fakeStudentList = { id: 0, name: 'Unassigned Students' };
	
					classItems.push(React.createElement(RosterStudentList, { key: "sl-" + 0,
						slIndex: 0,
						fetchStudents: this.props.fetchStudents,
						toggleFormStatus: this.toggleEditSLForm,
						openSectionClass: this.state.expandedStudentListFormClass,
						expanded: this.slExpanded(0),
						formExpanded: this.slFormExpanded(0),
						handleExpandStudentListSection: this.handleExpandStudentListSection,
						studentList: fakeStudentList }));
	
					$wr.sortByName(students, $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST).forEach(function (student) {
						var studentList = _this17.unassignedSLLookup(student);
						studentItems.push(React.createElement(RosterUnAssignedStudent, { key: "sl-" + 0 + "-student-" + student.id,
							student: student,
							toggleSelected: function toggleSelected() {
								return _this17.toggleStudentID(student.id);
							},
							onUpdateArchivedStudent: function onUpdateArchivedStudent() {
								return _this17.onUpdateArchivedStudent();
							},
							studentList: studentList }));
					});
	
					var collapsedClass = _underscore2.default.include(this.state.expandedStudentListSections, 0) ? "expanded" : "collapsed";
					var classSection = React.createElement(
						"div",
						{ className: "classSectionContainer " + collapsedClass, key: 'classSectionContainer-' + 0 },
						classItems,
						React.createElement(
							"div",
							{ className: "studentSectionContainer unassignedStudent" },
							studentItems
						)
					);
					items.push(classSection);
				}
				return items;
			}
		}, {
			key: "render",
			value: function render() {
				var _this18 = this;
	
				if (this.checkIsPendingSchool()) {
					var schoolInfoModal = React.createElement(SchoolInfoModal, { onClose: function onClose() {
							return _this18.props.fetchStudentLists();
						} });
				}
	
				var items = [];
	
				items.push(this.renderOverallLine());
	
				if (this.props.loading) {
					items.push(React.createElement(Spinner, { key: "spinner", scale: 1, className: "demoBtnSpinner" }));
				} else if (!this.props.studentLists.length) {
					items.push(this.renderEmptySection());
				} else {
					_underscore2.default.flatten(items.push(this.renderStudentsAndStudentLists()));
				}
	
				return React.createElement(
					"div",
					{ className: "container rosterContent" },
					this.renderOverdrawnMessage(),
					React.createElement(Glyphicon, { className: "filterIcon", icon: "filter" }),
					React.createElement(OrgDropdown, { dropdownDisplay: "link",
						selectedIdentifier: this.props.orgIdentifier,
						onSelect: this.props.changeOrgIdentifier }),
					items,
					this.renderUnassignedStudents(),
					this.renderToolbar(),
					schoolInfoModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(document).on('task-finished-loading', this.handleRosterUpdate);
	
				// this.props.fetchStudents();
				// this.props.fetchStudentLists();
				this.props.getCleverUser();
				this.updateArchivedStudentLists();
				this.props.populateData();
	
				if ($wr.getURLParameterByName('add_student_method') == 'clever') {
					this.addStudentsModal.current.show();
				}
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(document).off('task-finished-loading', this.handleRosterUpdate);
			}
		}]);
	
		return RosterContent;
	}(React.Component)) || _class);
	
	
	RosterContent.WrappedComponent.propTypes = PageStrictPropTypes({
		// From above
		orgIdentifier: PropTypes.string.isRequired,
		changeOrgIdentifier: PropTypes.func.isRequired,
	
		// @connect data
		getStudents: PropTypes.func,
		studentLists: PropTypes.array,
		currentAdmin: PropTypes.object,
		loading: PropTypes.bool,
	
		// @connect handlers
		populateData: PropTypes.func,
		fetchStudents: PropTypes.func,
		fetchStudentLists: PropTypes.func,
		fetchArchivedStudentLists: PropTypes.func,
		addDemoStudent: PropTypes.func,
		archiveStudentList: PropTypes.func,
		destroyStudents: PropTypes.func,
		getCleverUser: PropTypes.func,
		updateStudentList: PropTypes.func
	});
	
	module.exports = RosterContent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentsSelectedDisplay = __webpack_require__(139);
	
	var ToggleMultiselect = __webpack_require__(169);
	var HelpSectionLink = __webpack_require__(64);
	var LoadingButton = __webpack_require__(17);
	var StudentDisplay = __webpack_require__(52);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3703);
	
	var RosterEditStudentLists = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    studentLists: RosterSelectors.studentLists({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    updateStudents: function updateStudents(updates, studentIDs) {
	      return dispatch(RosterActions.updateStudents({
	        studentIDs: studentIDs,
	        updates: updates,
	        embeds: ["student.student_list_ids", "student.prefs"]
	      }));
	    }
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(RosterEditStudentLists, _React$Component);
	
	  function RosterEditStudentLists(props) {
	    _classCallCheck(this, RosterEditStudentLists);
	
	    var _this = _possibleConstructorReturn(this, (RosterEditStudentLists.__proto__ || Object.getPrototypeOf(RosterEditStudentLists)).call(this));
	
	    autobind(_this);
	    _this.state = _this.getInitialState();
	    return _this;
	  }
	
	  //////// HELPERS ////////
	
	
	  _createClass(RosterEditStudentLists, [{
	    key: "getInitialState",
	    value: function getInitialState() {
	      return { showStudents: false, overrides: {}, loading: false };
	    }
	  }, {
	    key: "editStudentForm",
	    value: function editStudentForm(key, val, callback) {
	      this.setState({
	        overrides: _extends({}, this.state.overrides, _defineProperty({}, key, val))
	      }, callback);
	    }
	  }, {
	    key: "showSuccessAlert",
	    value: function showSuccessAlert() {
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Classes Edited", icon: "ok-sign"
	      }, 4000);
	    }
	  }, {
	    key: "showErrorAlert",
	    value: function showErrorAlert() {
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Oops!", text: "Something went wrong and the class was not edited",
	        type: "error", icon: "remove"
	      }, 4000);
	    }
	  }, {
	    key: "editAlertText",
	    value: function editAlertText(studentsEdited) {
	      if (studentsEdited == 'all' && _underscore2.default.has(this.state.overrides.all, 'primary')) {
	        return "Are you sure you want to modify the classes for all selected students? This will override the current class rosters.";
	      } else if (studentsEdited == 'all' && !_underscore2.default.has(this.state.overrides.all, 'primary')) {
	        return "Are you sure you want to modify the classes for all selected students? This will add them all to a secondary class and they will remain in their primary classes.";
	      } else {
	        return "Are you sure you want to modify the classes for " + studentsEdited + " students? This will override the current class rosters.";
	      }
	    }
	
	    //////// SUBMIT ////////
	
	  }, {
	    key: "onSubmit",
	    value: function onSubmit(e) {
	      $wr.nope(e);
	
	      if (_underscore2.default.has(this.state.overrides, 'all')) {
	        if (confirm(this.editAlertText('all'))) {
	          this.setState({ loading: true });
	          // modify all students
	          var updates = _extends({}, this.state.overrides);
	          var studentIDs = _underscore2.default.compact(_underscore2.default.flatten(_underscore2.default.pluck(this.props.students, 'id')));
	          this.updateStudents(updates, studentIDs);
	        }
	      } else if (_underscore2.default.isEmpty(this.state.overrides)) {
	        window.wrNotifications.triggerDropDownNotification({
	          title: "Modify a class before saving", icon: "exclamation-sign", type: "error"
	        });
	      } else {
	        var studentsEdited = Object.keys(this.state.overrides).length;
	        if (confirm(this.editAlertText(studentsEdited))) {
	          this.setState({ loading: true });
	          // modify some students
	          this.updateStudents(this.state.overrides, _underscore2.default.keys(this.state.overrides));
	        }
	      }
	    }
	  }, {
	    key: "updateStudents",
	    value: function updateStudents(updates, studentIDs) {
	      var _this2 = this;
	
	      this.props.updateStudents(updates, studentIDs).then(function () {
	        _this2.setState({ loading: false });
	        // close modal
	        _this2.props.onComplete();
	        _this2.showSuccessAlert();
	        // this.props.fetchStudents(true)
	      }).catch(function () {
	        _this2.setState({ loading: false });
	        _this2.showErrorAlert();
	      });
	    }
	
	    //////// RENDER METHOD ////////
	
	    // START STUDENT ROW //
	
	  }, {
	    key: "renderStudentListSelector",
	    value: function renderStudentListSelector(student) {
	      var _this3 = this;
	
	      var topContent = React.createElement(
	        "div",
	        null,
	        "Click a class to set it as primary.",
	        React.createElement("br", null),
	        "Hold shift & click to set secondary.",
	        " ",
	        React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
	      );
	
	      var toggles = [{
	        key: "primary",
	        icon: "star",
	        select: ToggleMultiselect.SELECT_LEFT_CLICK,
	        primary: true
	      }, {
	        key: "secondary",
	        icon: "star-empty",
	        select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK
	      }];
	
	      var options = this.props.studentLists.map(function (x) {
	        return { key: x.id, text: x.name };
	      });
	      var selected = {};
	
	      if (student === 'all') {
	        var studentLists = _underscore2.default.has(this.state.overrides, 'all') ? this.state.overrides['all'] : {};
	      } else if (_underscore2.default.has(this.state.overrides, student.id)) {
	        var studentLists = this.state.overrides[student.id];
	      } else {
	        var studentLists = student.student_list_ids;
	      }
	
	      if (studentLists && studentLists.active) {
	        _underscore2.default.each(studentLists.active, function (slID) {
	          selected[slID] = slID === studentLists.primary ? "primary" : "secondary";
	        });
	      }
	
	      var onClassChange = function onClassChange(updatedSelected) {
	        if (student === 'all') {
	          var studentID = 'all';
	          var newStudentListIDs = { 'active': [], 'all': [] };
	        } else {
	          var studentID = student.id;
	          var newStudentListIDs = {
	            'active': [],
	            'all': _underscore2.default.difference(student.student_list_ids.all, student.student_list_ids.active)
	          };
	        }
	        _underscore2.default.each(updatedSelected, function (toggleKey, studentListID) {
	          newStudentListIDs.active.push(parseInt(studentListID));
	          newStudentListIDs.all.push(parseInt(studentListID));
	
	          if (toggleKey === "primary") {
	            newStudentListIDs.primary = parseInt(studentListID);
	          }
	        });
	        _this3.editStudentForm(studentID, newStudentListIDs);
	      };
	
	      return React.createElement(ToggleMultiselect, { className: "classSelector", dropdownDisplay: "link",
	        topContent: topContent,
	        selected: selected,
	        toggles: toggles,
	        options: options,
	        onChange: onClassChange });
	    }
	  }, {
	    key: "allStudentDisplay",
	    value: function allStudentDisplay() {
	      if (this.props.students) {
	        return React.createElement(
	          "div",
	          { className: "studentRow" },
	          React.createElement(
	            "div",
	            { className: "allStudentColumn" },
	            React.createElement(StudentsSelectedDisplay, { totalStudents: this.props.totalStudentCount, studentsSelected: this.props.students, hideTo: true })
	          ),
	          React.createElement(
	            "div",
	            { className: "studentListColumn" },
	            this.renderStudentListSelector('all')
	          )
	        );
	      }
	    }
	  }, {
	    key: "handleShowStudentClick",
	    value: function handleShowStudentClick() {
	      this.setState({ showStudents: !this.state.showStudents });
	    }
	  }, {
	    key: "renderStudentRows",
	    value: function renderStudentRows() {
	      var _this4 = this;
	
	      if (this.state.showStudents) {
	        var showClass = 'showStudents';
	        var linkText = 'Hide Student View';
	      } else {
	        var showClass = 'hideStudents';
	        var linkText = 'Show Student View';
	      }
	
	      var displayToggle = React.createElement(
	        "div",
	        { className: "displayToggle" },
	        React.createElement(
	          "a",
	          { onClick: this.handleShowStudentClick },
	          linkText
	        )
	      );
	
	      var studentDisplays = _underscore2.default.map(this.props.students, function (student) {
	        return React.createElement(
	          "div",
	          { className: "studentRow", key: 'student-' + student.id },
	          React.createElement(
	            "div",
	            { className: "studentColumn" },
	            React.createElement(StudentDisplay, { studentID: student.id, showAvatar: true, avatarMaxWidth: 50 })
	          ),
	          React.createElement(
	            "div",
	            { className: "studentListColumn" },
	            _this4.renderStudentListSelector(student)
	          )
	        );
	      });
	
	      return React.createElement(
	        "div",
	        { className: "studentRowsContainer" },
	        React.createElement(
	          "div",
	          { className: "section studentTitle" },
	          React.createElement(
	            "p",
	            { className: "title" },
	            "Students"
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "section classTitle" },
	          React.createElement(
	            "p",
	            { className: "title" },
	            "Class"
	          )
	        ),
	        this.allStudentDisplay(),
	        React.createElement(
	          "div",
	          { className: 'studentRowContainer ' + showClass },
	          studentDisplays
	        ),
	        displayToggle
	      );
	    }
	
	    // END STUDENT ROW //
	
	  }, {
	    key: "renderSubmitButton",
	    value: function renderSubmitButton() {
	      return React.createElement(
	        "div",
	        { className: "buttonContainer" },
	        React.createElement(LoadingButton, { type: "submit",
	          loading: this.state.loading,
	          text: "Edit Classes",
	          className: "btn buttonSuccess",
	          onClick: this.onSubmit })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var modalBody = React.createElement(
	        "div",
	        { className: "rosterEditStudentLists" },
	        this.renderStudentRows(),
	        this.renderSubmitButton()
	      );
	      return React.createElement(
	        "div",
	        { className: "modal-body" },
	        modalBody
	      );
	    }
	  }]);
	
	  return RosterEditStudentLists;
	}(React.Component)) || _class);
	;
	
	RosterEditStudentLists.WrappedComponent.propTypes = StrictPropTypes({
	  // From above
	  studentLists: PropTypes.array,
	
	  students: PropTypes.array,
	  onComplete: PropTypes.func,
	  totalStudentCount: PropTypes.number,
	
	  // Handlers from @connect
	  assignSubgroup: PropTypes.func,
	  updateStudents: PropTypes.func
	});
	
	module.exports = RosterEditStudentLists;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisplayToggleControl = __webpack_require__(48);
	
	var RosterContent = __webpack_require__(820);
	var DifferentiationTable = __webpack_require__(809);
	
	var CurrentUser = __webpack_require__(3);
	var RosterRouting = __webpack_require__(93);
	var OnboardingChecklist = __webpack_require__(166);
	
	// require("org/roster/roster_page.scss");
	
	var RosterPage = (_dec = (0, _LocationState.provideLocationState)(RosterRouting.getRouteState), _dec(_class = function (_React$Component) {
		_inherits(RosterPage, _React$Component);
	
		function RosterPage(props) {
			_classCallCheck(this, RosterPage);
	
			var _this = _possibleConstructorReturn(this, (RosterPage.__proto__ || Object.getPrototypeOf(RosterPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("RosterPage");
			return _this;
		}
	
		_createClass(RosterPage, [{
			key: "onViewChange",
			value: function onViewChange(view) {
				$wr.redirect(RosterRouting.getPath({ activeView: view }));
			}
		}, {
			key: "changeOrg",
			value: function changeOrg(orgIdentifier) {
				$wr.redirect(RosterRouting.getPath({
					activeView: this.props.locationState.activeView,
					orgIdentifier: orgIdentifier
				}));
			}
		}, {
			key: "render",
			value: function render() {
				var orgIdentifier = this.props.locationState.orgIdentifier;
	
	
				var pageContent = React.createElement(RosterContent, { orgIdentifier: orgIdentifier,
					changeOrgIdentifier: this.changeOrg });
	
				var onboardingChecklist = React.createElement(OnboardingChecklist, null);
	
				return React.createElement(
					"div",
					{ className: "container rosterPage" },
					onboardingChecklist,
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Student Roster"
						)
					),
					pageContent
				);
			}
		}]);
	
		return RosterPage;
	}(React.Component)) || _class);
	;
	
	RosterPage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object.isRequired
	});
	
	module.exports = RosterPage;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReadingLevelFormat = __webpack_require__(72);
	
	var _ReadingLevelFormat2 = _interopRequireDefault(_ReadingLevelFormat);
	
	var _StudentMetrics = __webpack_require__(29);
	
	var _StudentMetrics2 = _interopRequireDefault(_StudentMetrics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var BraveCheckbox = __webpack_require__(120);
	var Modal = __webpack_require__(18);
	var StudentDisplay = __webpack_require__(52);
	var Glyphicon = __webpack_require__(8);
	var DropDownOptions = __webpack_require__(26);
	var ToggleMultiselect = __webpack_require__(169);
	var HelpSectionLink = __webpack_require__(64);
	var Spinner = __webpack_require__(9);
	var EditableGoals = __webpack_require__(190);
	var DeleteStudentModal = __webpack_require__(818);
	
	var GradeLevel = __webpack_require__(40);
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var DemoAccountSwitcher = __webpack_require__(201);
	
	var INACTIVE_PRIMARY_SL = "inactive_primary_sl";
	var NON_PRIMARY_SL = "non_primary_sl";
	var NO_PRIMARY_SL = "no_primary_sl";
	var PRIMARY_SL = "primary_sl";
	var RosterStudent = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {
			currentAdmin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }),
			studentLists: RosterSelectors.studentLists({ state: state }),
			readingLevelFormat: CurrentUser.get().prefs.reading_level_format,
			isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state: state })
		};
	
		var studentListLinkStatus = null;
		// Checking:
		// 1. if the student's primary sl is active.
		// 2. if the student primary sl is viewed sl.
		if (!props.student.student_list_ids.primary) {
			studentListLinkStatus = NO_PRIMARY_SL;
		} else if (!props.student.student_list_ids.active.includes(props.student.student_list_ids.primary)) {
			studentListLinkStatus = INACTIVE_PRIMARY_SL;
		} else if (props.student.student_list_ids.primary != props.studentList.id) {
			studentListLinkStatus = NON_PRIMARY_SL;
		} else {
			studentListLinkStatus = PRIMARY_SL;
		}
	
		downProps.studentListLinkStatus = studentListLinkStatus;
		return downProps;
	}, function (dispatch, props) {
		return {
			updateStudent: function updateStudent(update) {
				return new Promise(function (resolve, reject) {
					// manipulate object to send password_plain_text
					if (_.has(update, 'password')) {
						update['password_plain_text'] = update['password']; // Assign new key
						delete update['password']; // Delete old key
					}
					dispatch(RosterActions.updateStudent({ id: props.student.id, update: update })).then(function (response) {
						resolve(response);
					}).catch(function () {
						return resolve({ error: true });
					});
				});
			},
			// updates student in state
			fetchStudent: function fetchStudent(id) {
				return dispatch(RosterActions.fetchStudent({ id: id, embeds: ["student.password"] }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(RosterStudent, _React$Component);
	
		function RosterStudent(props) {
			_classCallCheck(this, RosterStudent);
	
			var _this = _possibleConstructorReturn(this, (RosterStudent.__proto__ || Object.getPrototypeOf(RosterStudent)).call(this));
	
			autobind(_this);
			// confirms deletion with user
			_this.deleteStudentModal = React.createRef();
	
			_this.state = _this.getInitialState();
			return _this;
		}
	
		///////// HELPERS /////////
	
		// returns the sl and student index used for element ids
		// when adding new element, add the index key to end of id
		// for selenium testing
	
	
		_createClass(RosterStudent, [{
			key: "indexKey",
			value: function indexKey() {
				var _props = this.props,
				    slIndex = _props.slIndex,
				    index = _props.index;
	
				return "sl" + slIndex + "-stu" + index;
			}
		}, {
			key: "getInitialState",
			value: function getInitialState() {
				return {
					showPasswordOverride: false,
					openSectionClass: null,
					showEditForm: false,
					showEditLink: false,
					overrides: {},
					showPasswords: false,
					savingChanges: false,
					ssoShowUserPass: false
				};
			}
		}, {
			key: "prefs",
			value: function prefs() {
				return this.props.student.prefs;
			}
	
			// returns current student
	
		}, {
			key: "formStudent",
			value: function formStudent() {
				return _extends({}, this.props.student, this.state.overrides, {
					prefs: _extends({}, this.prefs(), this.state.overrides.prefs)
				});
			}
	
			// checks if objects are equal
	
		}, {
			key: "objectsEqual",
			value: function objectsEqual(o1, o2) {
				return Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(function (p) {
					return o1[p] === o2[p];
				});
			}
	
			// checks if array of objects are equal
	
		}, {
			key: "arraysEqual",
			value: function arraysEqual(a1, a2) {
				var _this2 = this;
	
				return a1.length === a2.length && a1.every(function (o, idx) {
					return _this2.objectsEqual(o, a2[idx]);
				});
			}
		}, {
			key: "switchToDemo",
			value: function switchToDemo() {
				DemoAccountSwitcher.switchToStudent(this.props.student);
			}
		}, {
			key: "isDemoStudent",
			value: function isDemoStudent() {
				return this.props.student.demo_for_teacher;
			}
		}, {
			key: "hasCleverUser",
			value: function hasCleverUser() {
				return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false;
			}
		}, {
			key: "studentCanBeDeleted",
			value: function studentCanBeDeleted() {
				return !this.props.isLoadingStudents && !this.hasCleverUser() && !this.isDemoStudent();
			}
		}, {
			key: "studentCanBeActivated",
			value: function studentCanBeActivated() {
				return !this.props.isLoadingStudents;
			}
	
			///////// STATE MANIPULATORS /////////
	
		}, {
			key: "ssoToggleUserPass",
			value: function ssoToggleUserPass() {
				this.setState({ ssoShowUserPass: !this.state.ssoShowUserPass });
			}
			// edits student information
	
		}, {
			key: "editStudentForm",
			value: function editStudentForm(key, val, callback) {
				this.setState({
					overrides: _extends({}, this.state.overrides, _defineProperty({}, key, val))
				}, callback);
			}
	
			// edits student prefs
	
		}, {
			key: "editStudentFormPrefs",
			value: function editStudentFormPrefs(change, callback) {
				this.setState({
					overrides: _extends({}, this.state.overrides, {
						prefs: _extends({}, this.state.overrides.prefs, change)
					})
				}, callback);
			}
	
			///////// DATABASE MANIPULATORS /////////
	
		}, {
			key: "saveChanges",
			value: function saveChanges(e) {
				var _this3 = this;
	
				if (e) {
					$wr.nope(e);
				}
				this.setState({ savingChanges: true });
				if (!_.isEmpty(this.state.overrides)) {
					this.props.updateStudent(this.state.overrides).then(function (response) {
						var studentResponse = response.students[0];
						if (!studentResponse.errors) {
							window.wrNotifications.triggerDropDownNotification({
								title: "Student Edited!", text: "You have successfully edited a student!",
								icon: "ok-circle"
							});
							// update student data in state
							_this3.props.fetchStudent(studentResponse.id);
							// reset component state
							_this3.setState(_this3.getInitialState());
						} else {
							_this3.setState({ savingChanges: false });
							window.wrNotifications.triggerDropDownNotification({
								title: "Oops!", text: "Something went wrong and the student was not edited",
								type: "error", icon: "exclamation-sign"
							}, 4000);
						}
					});
				}
			}
	
			///////// DELETE STUDENT MODAL /////////
	
			// modal that asks if the user wants student to 
			// be removed from all lists or the current list
	
		}, {
			key: "activateDeleteStudentModal",
			value: function activateDeleteStudentModal(e, student) {
				$wr.nope(e);
				if (student) {
					this.deleteStudentModal.current.show();
				}
			}
	
			// modal code
	
		}, {
			key: "renderDeleteStudentModal",
			value: function renderDeleteStudentModal() {
				return React.createElement(
					Modal,
					{ headerText: 'Are you sure you want to delete this student?', ref: this.deleteStudentModal },
					React.createElement(DeleteStudentModal, {
						studentList: this.props.studentList,
						onHide: this.hideModal,
						student: this.formStudent() })
				);
			}
	
			// hide modal, reset state
	
		}, {
			key: "hideModal",
			value: function hideModal() {
				if (this.deleteStudentModal.current) {
					this.deleteStudentModal.current.hide();
				}
				this.setState(this.getInitialState());
			}
	
			///////// EDIT STUDENT FORM /////////
	
			// handles the display of the edit student form
	
		}, {
			key: "toggleFormStatus",
			value: function toggleFormStatus() {
				var _this4 = this;
	
				if (this.state.showEditForm) {
					this.setState({ openSectionClass: 'drawerClosed' }, function () {
						// keep this setTimeout function to ensure all 
						// transitions are complete before removing
						setTimeout(function () {
							this.setState({ showEditForm: false });
						}.bind(_this4), 1500);
					});
				} else {
					this.setState({ showEditForm: true }, function () {
						setTimeout(function () {
							this.setState({ openSectionClass: 'drawerOpen' });
						}.bind(_this4), 50);
					});
				}
			}
	
			// manages display of 'Edit Student' link
	
		}, {
			key: "showEditStudentLink",
			value: function showEditStudentLink() {
				this.state.showEditForm ? this.setState({ showEditLink: false }) : this.setState({ showEditLink: true });
			}
	
			// allows admin ot override password
	
		}, {
			key: "openPasswordOverride",
			value: function openPasswordOverride() {
				this.setState({ showPasswordOverride: true });
			}
	
			// manages if the full passwords are displayed
	
		}, {
			key: "togglePasswordDisplay",
			value: function togglePasswordDisplay() {
				this.setState({ showPasswords: !this.state.showPasswords });
			}
	
			///////// RENDER METHODS /////////
	
		}, {
			key: "renderSubgroup",
			value: function renderSubgroup() {
				var student = this.props.student;
	
	
				if (student && student.prefs && !_.isEmpty(student.prefs.subgroup)) {
					var group = student.prefs.subgroup;
					var tip = "Group " + group.name;
					return React.createElement(
						"span",
						{ className: "studentGroup" },
						React.createElement(Glyphicon, { icon: group.icon,
							style: { color: group.color }, dataTip: tip }),
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				}
			}
		}, {
			key: "renderStudentListSelector",
			value: function renderStudentListSelector() {
				var _this5 = this;
	
				var student = this.formStudent();
	
				if (this.hasCleverUser()) {
					var disableClass = "disableEvents";
					var topContent = React.createElement(
						"div",
						null,
						"A filled star is a primary class.",
						React.createElement("br", null),
						"Empty stars are secondary classes.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				} else {
					var topContent = React.createElement(
						"div",
						null,
						"Click a class to set it as primary.",
						React.createElement("br", null),
						"Hold shift & click to set secondary.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				}
	
				var toggles = [{
					key: "primary",
					icon: "star",
					select: ToggleMultiselect.SELECT_LEFT_CLICK,
					primary: true,
					singleton: true
				}, {
					key: "secondary",
					icon: "star-empty",
					select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK
				}];
	
				var options = this.props.studentLists.map(function (x) {
					return { key: x.id, text: x.name };
				});
	
				var selected = {};
				_.each(student.student_list_ids.active, function (slID) {
					if (slID === student.student_list_ids.primary) {
						selected[slID] = "primary";
					} else {
						selected[slID] = "secondary";
					}
				});
	
				var onClassChange = function onClassChange(updatedSelected) {
					var newStudentListIDs = {
						'active': [],
						'all': _.difference(student.student_list_ids.all, student.student_list_ids.active)
					};
					_.each(updatedSelected, function (toggleKey, studentListID) {
						newStudentListIDs.active.push(parseInt(studentListID));
						newStudentListIDs.all.push(parseInt(studentListID));
	
						if (toggleKey === "primary") {
							newStudentListIDs.primary = parseInt(studentListID);
						}
					});
	
					_this5.editStudentForm("student_list_ids", newStudentListIDs);
				};
	
				return React.createElement(ToggleMultiselect, { className: "classSelector classSelector-" + this.indexKey() + " " + disableClass, dropdownDisplay: "link",
					topContent: topContent,
					selected: selected,
					toggles: toggles,
					options: options,
					onChange: onClassChange });
			}
	
			// These items are editable for non-Clever users
	
		}, {
			key: "buildEditableInformation",
			value: function buildEditableInformation(student) {
				var _this6 = this;
	
				if (student.sso_data && !_.isEmpty(student.sso_data) && !this.state.ssoShowUserPass) {
					var ssoTitle = student.sso_data['google'] ? 'Google Classroom' : 'Clever';
					var ssoToggleUserPassBtn = React.createElement(
						"label",
						{ className: "inputPair" },
						React.createElement("span", { className: "text" }),
						React.createElement(
							"a",
							{ onClick: this.ssoToggleUserPass },
							"Show Username & Password"
						)
					);
	
					var loginMethod = React.createElement(
						"label",
						{ className: "inputPair" },
						React.createElement(
							"span",
							{ className: "text" },
							"Login Method"
						),
						React.createElement(
							"span",
							{ id: "ssoTitle-" + this.indexKey() },
							ssoTitle
						)
					);
				} else {
					var passwordInput = React.createElement(
						"label",
						{ className: "inputPair" },
						React.createElement(
							"span",
							{ className: "text" },
							"Password"
						),
						React.createElement(
							"span",
							{ className: "passwordDisplayInput" },
							React.createElement("input", { "data-lpignore": "true", className: "passwordInput", type: "text", value: student.password || '',
								id: "input-password-" + this.indexKey(),
								onChange: function onChange(e) {
									return _this6.editStudentForm('password', e.target.value);
								} }),
							React.createElement(
								"a",
								{ id: "link-toggle-password-" + this.indexKey(), onClick: this.togglePasswordDisplay },
								"Hide"
							)
						)
					);
	
					var usernameInput = React.createElement(
						"label",
						{ className: "inputPair" },
						React.createElement(
							"span",
							{ className: "text" },
							"Username"
						),
						React.createElement("input", {
							id: "input-username-" + this.indexKey(),
							"data-lpignore": "true", type: "text", value: student.username,
							onChange: function onChange(e) {
								return _this6.editStudentForm('username', e.target.value);
							} })
					);
				}
	
				var firstNameInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"First Name"
					),
					React.createElement("input", {
						id: "input-first-name-" + this.indexKey(),
						"data-lpignore": "true", type: "text", value: student.first_name,
						onChange: function onChange(e) {
							return _this6.editStudentForm('first_name', e.target.value);
						} })
				);
	
				var lastNameInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Last Name"
					),
					React.createElement("input", {
						id: "input-last-name-" + this.indexKey(),
						"data-lpignore": "true", type: "text", value: student.last_name,
						onChange: function onChange(e) {
							return _this6.editStudentForm('last_name', e.target.value);
						} })
				);
	
				return { passwordInput: passwordInput, firstNameInput: firstNameInput, lastNameInput: lastNameInput, usernameInput: usernameInput, loginMethod: loginMethod, ssoToggleUserPassBtn: ssoToggleUserPassBtn };
			}
	
			// These items are not editable for Clever users
	
		}, {
			key: "buildStaticInformation",
			value: function buildStaticInformation(student) {
				var passwordInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Password"
					),
					React.createElement(
						"span",
						{ className: "passwordDisplayInput" },
						React.createElement(
							"span",
							{ className: "passwordInput" },
							student.password || ''
						),
						React.createElement(
							"a",
							{ onClick: this.togglePasswordDisplay },
							"Hide"
						)
					)
				);
	
				var firstNameInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"First Name"
					),
					React.createElement(
						"span",
						null,
						student.first_name
					)
				);
	
				var lastNameInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Last Name"
					),
					React.createElement(
						"span",
						null,
						student.last_name
					)
				);
	
				var usernameInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Username"
					),
					React.createElement(
						"span",
						null,
						student.username
					)
				);
	
				return { passwordInput: passwordInput, firstNameInput: firstNameInput, lastNameInput: lastNameInput, usernameInput: usernameInput };
			}
		}, {
			key: "renderReactivateStudentBtn",
			value: function renderReactivateStudentBtn() {
				var _this7 = this;
	
				return this.studentCanBeActivated() ? React.createElement(
					"div",
					null,
					React.createElement(
						"a",
						{ className: "btn-link reactivateButton", onClick: function onClick() {
								return _this7.editStudentForm('suspended', false, _this7.saveChanges);
							} },
						"Reactivate"
					)
				) : '';
			}
		}, {
			key: "renderDeleteStudentBtn",
			value: function renderDeleteStudentBtn(student) {
				var _this8 = this;
	
				// student lists must be loaded before delete student modal
				return this.studentCanBeDeleted() ? React.createElement(
					"div",
					null,
					React.createElement(
						"a",
						{ className: "btn-link deleteButton", onClick: function onClick(e) {
								return _this8.activateDeleteStudentModal(e, student);
							} },
						"Delete Student"
					)
				) : '';
			}
		}, {
			key: "renderDemoStudentBtn",
			value: function renderDemoStudentBtn(student) {
				return this.isDemoStudent() ? React.createElement(
					"div",
					null,
					React.createElement(
						"a",
						{ className: "btn-link switchToDemo", onClick: this.switchToDemo },
						"Switch to Demo"
					)
				) : '';
			}
	
			// RETURN STUDENT LIST'S EXPECTATIONS METRIC IF EXISTS OR DEFAULT GRADE LEVEL PREFERENCES
	
		}, {
			key: "getSLExpectationsMetrics",
			value: function getSLExpectationsMetrics() {
				var student = this.formStudent();
				var gradeLevel = student.prefs.academic_level;
				var glMetrics = this.props.studentList.prefs.grade_level_expectations_metrics;
				return glMetrics[gradeLevel] || glMetrics['-1'];
			}
		}, {
			key: "renderAccountSection",
			value: function renderAccountSection() {
				var _this9 = this;
	
				var student = this.formStudent();
	
				if (this.hasCleverUser()) {
					var _buildEditableInforma = this.buildEditableInformation(student),
					    firstNameInput = _buildEditableInforma.firstNameInput,
					    lastNameInput = _buildEditableInforma.lastNameInput;
	
					var _buildStaticInformati = this.buildStaticInformation(student),
					    passwordInput = _buildStaticInformati.passwordInput,
					    usernameInput = _buildStaticInformati.usernameInput;
				} else {
					var _buildEditableInforma2 = this.buildEditableInformation(student),
					    passwordInput = _buildEditableInforma2.passwordInput,
					    firstNameInput = _buildEditableInforma2.firstNameInput,
					    lastNameInput = _buildEditableInforma2.lastNameInput,
					    usernameInput = _buildEditableInforma2.usernameInput,
					    loginMethod = _buildEditableInforma2.loginMethod,
					    ssoToggleUserPassBtn = _buildEditableInforma2.ssoToggleUserPassBtn;
				}
	
				if (this.state.savingChanges) {
					var buttonSection = React.createElement(Spinner, { scale: 1, className: "buttonSpinner" });
				} else {
					var buttonSection = React.createElement(
						"div",
						{ className: "buttons" },
						React.createElement(
							"div",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary saveButton", type: "submit" },
								"Save"
							)
						),
						this.renderDeleteStudentBtn(student),
						this.renderDemoStudentBtn(student)
					);
				}
	
				// render spinner while waiting for password to load
				if (passwordInput) {
					if (this.props.isLoadingStudents) {
						var passwordInput = React.createElement(Spinner, { scale: 0.5, className: "passwordSpinner" });
					}
					// student has set password
					else if (student.password === null && !this.state.showPasswordOverride) {
							var passwordInput = React.createElement(
								"span",
								null,
								React.createElement(
									"span",
									{ className: "passwordSetByStudent" },
									"set by student"
								),
								React.createElement(
									"a",
									{ onClick: this.openPasswordOverride },
									"Change"
								)
							);
						}
						// hide passwords as default
						else if (!this.state.showPasswords) {
								var displayPassword = student.password ? student.password.replace(/./g, '*') : '';
								var passwordInput = React.createElement(
									"label",
									{ className: "inputPair" },
									React.createElement(
										"span",
										{ className: "text" },
										"Password"
									),
									React.createElement(
										"span",
										{ className: "passwordDisplayInput" },
										React.createElement("input", { id: "input-password-" + this.indexKey(), className: "passwordInput", type: "text", value: displayPassword, disabled: true }),
										React.createElement(
											"a",
											{ id: "link-toggle-password-" + this.indexKey(),
												onClick: this.togglePasswordDisplay },
											"Show"
										)
									)
								);
							}
				}
	
				if (student.prefs.academic_level.toString() != this.props.studentList.grade_level) {
					var academicGLMismatch = React.createElement(Glyphicon, { "data-tip": true, "data-for": "mismatchingIcon", icon: "user", className: "userGlyph" });
				}
				if (student.grade_level.toString() != this.props.studentList.grade_level) {
					var glMismatch = React.createElement(Glyphicon, { "data-tip": true, "data-for": "mismatchingIcon", icon: "user", className: "userGlyph" });
				}
	
				var slGradeLevelExpectations = this.getSLExpectationsMetrics();
	
				return React.createElement(
					"form",
					{ className: "editSection " + this.state.openSectionClass, onSubmit: this.saveChanges },
					React.createElement(
						"div",
						{ className: "firstCol" },
						React.createElement(
							"div",
							{ className: "accountInfo" },
							React.createElement(
								"div",
								{ className: "studentSectionHeader" },
								"Account Information"
							),
							firstNameInput,
							lastNameInput,
							usernameInput,
							passwordInput,
							loginMethod,
							ssoToggleUserPassBtn,
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Owl Shop"
								),
								React.createElement(
									"select",
									{ type: "text", value: student.prefs.shop_opening_time, id: "select-owlShopHours-" + this.indexKey(),
										onChange: function onChange(e) {
											return _this9.editStudentFormPrefs({ "shop_opening_time": e.target.value });
										} },
									DropDownOptions.Select.OwlShopOpeningTimes()
								)
							),
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Quizzes"
								),
								React.createElement(
									"select",
									{ type: "text", value: student.prefs.quiz_close_time || "Never close",
										id: "select-quizCloseTime-" + this.indexKey(),
										onChange: function onChange(e) {
											return _this9.editStudentFormPrefs({ "quiz_close_time": e.target.value });
										} },
									DropDownOptions.Select.QuizClosingTimes()
								)
							),
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Class"
								),
								this.renderStudentListSelector()
							)
						),
						React.createElement(
							"div",
							{ className: "studentLevels" },
							React.createElement(
								"div",
								{ className: "studentSectionHeader" },
								"Levels"
							),
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Grade"
								),
								React.createElement(
									"select",
									{ type: "text", value: student.grade_level,
										id: "select-grade-" + this.indexKey(),
										onChange: function onChange(e) {
											return _this9.editStudentForm("grade_level", e.target.value);
										} },
									DropDownOptions.Select.GradeLevels()
								),
								glMismatch
							),
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Academic Grade"
								),
								React.createElement(
									"select",
									{ type: "text", value: student.prefs.academic_level,
										id: "select-academic-grade-" + this.indexKey(),
										onChange: function onChange(e) {
											return _this9.editStudentFormPrefs({ "academic_level": e.target.value });
										} },
									DropDownOptions.Select.GradeLevels()
								),
								academicGLMismatch
							),
							React.createElement(
								"label",
								{ className: "inputPair" },
								React.createElement(
									"span",
									{ className: "text" },
									"Reading Level"
								),
								React.createElement(
									"select",
									{ value: student.current_reading_level,
										id: "select-reading-level-" + this.indexKey(),
										onChange: function onChange(e) {
											return _this9.editStudentForm("current_reading_level", e.target.value);
										} },
									DropDownOptions.Select.ReadingLevels({ lexile_to_formats: this.props.readingLevelFormat, current_reading_level: student.current_reading_level }).slice(0, -1)
								)
							),
							React.createElement(
								ReactTooltip,
								{ id: "mismatchingIcon" },
								" This student's grade level does not match the class grade level."
							)
						)
					),
					React.createElement(
						"div",
						{ className: "secondCol" },
						React.createElement(EditableGoals, {
							indexKey: "" + this.indexKey(),
							slExpectations: slGradeLevelExpectations,
							slExpectationTimePeriod: this.props.studentList.prefs.expectations_time_period,
							prefs: student.prefs,
							gradeLevel: student.prefs.academic_level.toString(),
							onEditPrefs: this.editStudentFormPrefs,
							quiz: true,
							student: true }),
						React.createElement(EditableGoals, {
							indexKey: "" + this.indexKey(),
							slExpectations: slGradeLevelExpectations,
							slExpectationTimePeriod: this.props.studentList.prefs.expectations_time_period,
							prefs: student.prefs,
							gradeLevel: student.prefs.academic_level.toString(),
							onEditPrefs: this.editStudentFormPrefs,
							supplemental: true,
							student: true })
					),
					React.createElement(
						"div",
						{ className: "thirdCol" },
						React.createElement(
							"div",
							{ className: "hideBtn" },
							React.createElement(
								"a",
								{ className: "btn btn-link", onClick: this.toggleFormStatus },
								"Hide ",
								React.createElement(Glyphicon, { icon: 'menu-up' })
							)
						),
						React.createElement(
							"div",
							{ className: "btnContainer" },
							buttonSection
						)
					)
				);
			}
		}, {
			key: "renderStudentListStatus",
			value: function renderStudentListStatus(student) {
				if (this.props.studentListLinkStatus == NON_PRIMARY_SL) {
					var type = "link";
					var toolTip = this.props.studentList.name + " is a secondary student list for the student.";
					var className = "grey";
				} else if (this.props.studentListLinkStatus == INACTIVE_PRIMARY_SL) {
					var type = "exclamation-sign";
					var toolTip = "This student's primary student list is archived.";
					var className = "red";
				} else if (this.props.studentListLinkStatus == NO_PRIMARY_SL) {
					var type = "exclamation-sign";
					var toolTip = "This student has no primary student list.";
					var className = "red";
				} else {
					var type = "link";
					var toolTip = this.props.studentList.name + " is the student's primary student list.";
					var className = "blue primaryLink";
				}
	
				return React.createElement(
					"div",
					{ className: 'detailSection narrow ' + className },
					React.createElement(Glyphicon, { icon: type, dataTip: toolTip })
				);
			}
		}, {
			key: "renderGoalsSection",
			value: function renderGoalsSection(student) {
				if (student.suspended) {
					return React.createElement(
						"div",
						{ className: "detailSection" },
						this.renderDeleteStudentBtn(student)
					);
				} else {
					var studentPrefs = student.prefs;
					var studentListPrefs = this.props.studentList.prefs;
					if (studentPrefs && studentListPrefs) {
	
						var stuExpectationCount = _.size(studentPrefs.expectations_metrics);
	
						if (stuExpectationCount >= 4) {
							var mainText = "All 4 goals assigned";
						} else {
							var goalPluralized = stuExpectationCount < 2 ? "goal" : "goals";
							var mainText = "" + stuExpectationCount + " " + goalPluralized + " assigned, " + (4 - stuExpectationCount) + " remain";
						}
						if (!this.arraysEqual(studentPrefs.expectations_metrics, studentListPrefs.expectations_metrics)) {
							var userIcon = React.createElement(Glyphicon, { className: "userIcon", icon: "user" });
						}
	
						return React.createElement(
							"div",
							{ className: "detailSection" },
							mainText,
							userIcon
						);
					}
				}
			}
		}, {
			key: "renderLevelsSection",
			value: function renderLevelsSection(student) {
				if (student.suspended) {
					var content = this.renderReactivateStudentBtn();
				} else {
					if (student.prefs.academic_level.toString() != this.props.studentList.grade_level || student.grade_level.toString() != this.props.studentList.grade_level) {
						var icon = React.createElement(Glyphicon, { className: "mismatchingGL", icon: "user" });
					}
					var content = React.createElement(
						"div",
						{ className: "gradeLevelContainer" },
						React.createElement(
							"span",
							null,
							GradeLevel.getShortName(student.grade_level),
							" grade"
						),
						icon
					);
				}
				return React.createElement(
					"div",
					{ className: "detailSection" },
					content
				);
			}
		}, {
			key: "renderEditIcon",
			value: function renderEditIcon(student) {
				if (this.state.showEditLink) {
					return React.createElement(Glyphicon, { className: "editIcon", icon: "edit" });
				}
			}
		}, {
			key: "renderCollapsedView",
			value: function renderCollapsedView(student) {
				if (student.suspended) {
					var lastActive = React.createElement(
						"span",
						{ className: "lastActive" },
						React.createElement(
							"strong",
							null,
							"Deactivated Student"
						)
					);
				} else if (this.isDemoStudent()) {
					var lastActive = React.createElement(
						"span",
						{ className: "lastActive" },
						React.createElement(
							"strong",
							null,
							"Demo Account"
						)
					);
				} else if (student.last_active) {
					var activeDate = (0, _moment2.default)(student.last_active).format("M/DD/YY");
					var lastActive = React.createElement(
						"span",
						{ className: "lastActive" },
						"Last Active: ",
						activeDate
					);
				} else {
					var lastActive = React.createElement(
						"span",
						{ className: "noActivity" },
						"No Activity"
					);
				}
	
				var statSectionClass = this.state.showEditLink ? 'statSection truncate' : 'statSection fullLength';
				return React.createElement(
					"div",
					{ className: statSectionClass },
					this.renderStudentListStatus(student),
					React.createElement(
						"div",
						{ className: "detailSection" },
						lastActive
					),
					this.renderLevelsSection(student),
					this.renderGoalsSection(student)
				);
			}
		}, {
			key: "renderSuspendedStudentDisplay",
			value: function renderSuspendedStudentDisplay() {
				var student = this.props.student;
	
	
				return React.createElement(
					"div",
					{ className: "studentListMultiselect", id: "studentListMultiselect-" + this.indexKey() },
					React.createElement(
						"div",
						{ className: "checkboxSection" },
						React.createElement(BraveCheckbox, { value: this.props.selected, onClick: this.props.toggleSelected })
					),
					React.createElement(
						"div",
						{ className: "topRow suspended" },
						React.createElement(
							"div",
							{ className: "studentInfo",
								id: "studentInfo-" + this.indexKey(),
								onClick: this.toggleFormStatus },
							React.createElement(
								"div",
								{ className: "nameSection" },
								React.createElement(StudentDisplay, { studentID: student.id, showAvatar: true, avatarMaxWidth: 50 })
							),
							this.renderCollapsedView(student)
						)
					),
					this.renderDeleteStudentModal()
				);
			}
		}, {
			key: "renderActiveStudentDisplay",
			value: function renderActiveStudentDisplay() {
				var _this10 = this;
	
				var student = this.props.student;
	
	
				if (this.state.showEditForm) {
					var selectedEditSection = this.renderAccountSection();
				}
	
				return React.createElement(
					"div",
					{ className: "studentListMultiselect",
						id: "studentListMultiselect-" + this.indexKey(),
						onMouseOver: this.showEditStudentLink,
						onMouseLeave: function onMouseLeave() {
							return _this10.setState({ showEditLink: false });
						}
					},
					React.createElement(
						"div",
						{ className: "checkboxSection" },
						React.createElement(BraveCheckbox, { value: this.props.selected, onClick: this.props.toggleSelected })
					),
					React.createElement(
						"div",
						{ className: "topRow clickableElement" },
						React.createElement(
							"div",
							{ className: "studentInfo",
								id: "studentInfo-" + this.indexKey(),
								onClick: this.toggleFormStatus },
							React.createElement(
								"div",
								{ className: "nameSection" },
								React.createElement(StudentDisplay, { studentID: student.id, showAvatar: true, avatarMaxWidth: 50 }),
								this.renderSubgroup()
							),
							this.renderCollapsedView(student),
							this.renderEditIcon(student)
						)
					),
					selectedEditSection,
					this.renderDeleteStudentModal()
				);
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
	
	
				return student.suspended ? this.renderSuspendedStudentDisplay() : this.renderActiveStudentDisplay();
			}
		}]);
	
		return RosterStudent;
	}(React.Component)) || _class);
	
	
	RosterStudent.WrappedComponent.propTypes = PageStrictPropTypes({
		// From above
		student: PropTypes.object.isRequired,
		currentAdmin: PropTypes.object,
		selected: PropTypes.bool,
		studentListLinkStatus: PropTypes.string,
		toggleSelected: PropTypes.func,
		updateStudents: PropTypes.func,
		index: PropTypes.number,
		slIndex: PropTypes.number,
	
		// @connect data
		populateData: PropTypes.func,
		studentLists: PropTypes.array,
		readingLevelFormat: PropTypes.string,
		isLoadingStudents: PropTypes.bool,
		studentList: PropTypes.object,
	
		// @connect handlers
		updateStudent: PropTypes.func,
		fetchStudent: PropTypes.func
	});
	
	module.exports = RosterStudent;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _fastDeepEqual = __webpack_require__(490);
	
	var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BraveCheckbox = __webpack_require__(120);
	var Glyphicon = __webpack_require__(8);
	var DropDownOptions = __webpack_require__(26);
	var HelpSectionLink = __webpack_require__(64);
	var EditableGoals = __webpack_require__(190);
	var ToggleMultiselect = __webpack_require__(169);
	var Spinner = __webpack_require__(9);
	var PaywallModal = __webpack_require__(44);
	
	var StudentMetrics = __webpack_require__(29);
	var Features = __webpack_require__(16);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var UIActions = __webpack_require__(41);
	var CurrentUser = __webpack_require__(3);
	
	var RosterStudentList = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {
			currentAdmin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }),
			teachers: RosterSelectors.admins({
				state: state, filters: { role: "teacherRole" }
			}),
			isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state: state })
	
			// if any student does not have a primary, or if their primary is inactive.
		};var studentListLinkProblem = _.some(props.studentList.students, function (student) {
			return !student.student_list_ids.primary || !student.student_list_ids.active.includes(student.student_list_ids.primary);
		});
	
		downProps.studentListLinkProblem = studentListLinkProblem;
	
		return downProps;
	}, function (dispatch, props) {
		return {
			updateStudentList: function updateStudentList(update) {
				var promises = [];
				if (update.prefs) {
					promises.push(dispatch(RosterActions.updateStudentListPrefs({
						update: update.prefs,
						studentListID: props.studentList.id,
						resetStudents: true
					})));
	
					update = _.omit(update, "prefs");
				}
	
				if (!_.isEmpty(update)) {
					promises.push(dispatch(RosterActions.updateStudentList({
						id: props.studentList.id, update: update
					})));
				}
	
				return Promise.all(promises);
			},
	
			updateTeacherOrgIDs: function updateTeacherOrgIDs(teacher, orgIDs) {
				return dispatch(RosterActions.updateAdmin({
					id: teacher.id,
					update: {
						org_ids: orgIDs
					}
				}));
			},
	
			archiveStudentList: function archiveStudentList() {
				return dispatch(RosterActions.archiveStudentList({
					id: props.studentList.id
				}));
			},
	
			openZpdPaywall: function openZpdPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(RosterStudentList, _React$Component);
	
		function RosterStudentList(props) {
			_classCallCheck(this, RosterStudentList);
	
			var _this = _possibleConstructorReturn(this, (RosterStudentList.__proto__ || Object.getPrototypeOf(RosterStudentList)).call(this));
	
			autobind(_this);
	
			_this.state = _this.getInitialState(props);
			return _this;
		}
	
		///////// HELPERS /////////
	
		_createClass(RosterStudentList, [{
			key: "getInitialState",
			value: function getInitialState(props) {
				props = props || this.props;
	
				if (props.studentList.id !== 0) {
					return {
						overrides: {},
						teachersSelected: this.teachersSelectedFromProps(props),
						savingChanges: false,
						extraFormHeight: props.studentList.prefs ? this.extraHeightNeeded(props.studentList.prefs.expectations_time_period) : false
					};
				} else {
					return {};
				}
			}
		}, {
			key: "extraHeightNeeded",
			value: function extraHeightNeeded(val) {
				return val === $wr.Constants.PERIODS.QUARTER || val === $wr.Constants.PERIODS.TRIMESTER;
			}
		}, {
			key: "teachersSelectedFromProps",
			value: function teachersSelectedFromProps(props) {
				props = props || this.props;
	
				var slID = props.studentList.id;
	
				var selected = {};
	
				_.each(props.teachers, function (teacher) {
					if (teacher.org_ids) {
						if (teacher.org_ids.student_lists.primary.includes(slID)) {
							selected[teacher.id] = "primary";
						} else if (teacher.org_ids.student_lists.sub.includes(slID)) {
							selected[teacher.id] = "sub";
						}
					}
				});
	
				return selected;
			}
		}, {
			key: "prefs",
			value: function prefs() {
				return this.props.studentList.prefs;
			}
		}, {
			key: "realStudentList",
			value: function realStudentList() {
				return this.props.studentList && this.props.studentList.id != 0;
			}
		}, {
			key: "changeGoalsConfirmationNeeded",
			value: function changeGoalsConfirmationNeeded() {
				var overrides = this.state.overrides;
				if (overrides && overrides.prefs) {
					return _.keys(overrides.prefs).some(function (metric) {
						return _.includes(METRICS_TO_CONFIRM, metric);
					});
				} else {
					return false;
				}
			}
		}, {
			key: "changeGradeLevelConfirmationNeeded",
			value: function changeGradeLevelConfirmationNeeded() {
				var overrides = this.state.overrides;
				return overrides && overrides.grade_level;
			}
		}, {
			key: "hasCleverUser",
			value: function hasCleverUser() {
				return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false;
			}
	
			///////// STUDENT LIST GETTERS /////////
	
		}, {
			key: "formStudentList",
			value: function formStudentList() {
				return _extends({}, this.props.studentList, this.state.overrides, {
					prefs: _extends({}, this.prefs(), this.state.overrides.prefs)
				});
			}
	
			///////// STATE MANIPULATORS /////////
	
		}, {
			key: "editStudentListForm",
			value: function editStudentListForm(key, val) {
				this.setState({
					overrides: _extends({}, this.state.overrides, _defineProperty({}, key, val))
				});
			}
		}, {
			key: "editStudentListFormPrefs",
			value: function editStudentListFormPrefs(change, callback) {
	
				if (_.includes(_.keys(change), 'expectations_time_period')) {
					var extraFormHeight = this.extraHeightNeeded(change['expectations_time_period']);
				} else {
					var extraFormHeight = this.state.extraFormHeight;
				}
	
				if (callback) {
					this.setState({
						overrides: _extends({}, this.state.overrides, {
							prefs: _extends({}, this.state.overrides.prefs, change)
						}),
						extraFormHeight: extraFormHeight
					}, callback);
				} else {
					this.setState({
						overrides: _extends({}, this.state.overrides, {
							prefs: _extends({}, this.state.overrides.prefs, change)
						}),
						extraFormHeight: extraFormHeight
					});
				}
			}
		}, {
			key: "editSelectedStudents",
			value: function editSelectedStudents(selection) {
				if (!this.hasCleverUser()) {
					this.setState({ teachersSelected: selection });
				}
			}
	
			///////// DATABASE MANIPULATORS /////////
	
		}, {
			key: "onArchive",
			value: function onArchive(e) {
				$wr.nope(e);
				if (confirm('Are you sure you want to delete this class? This will also delete students who are ONLY in this class. This will NOT delete any students who are in multiple classes.')) {
					this.props.archiveStudentList();
					var title = "Class Archived";
					var text = "You have archived this class. However, no class is left behind.";
	
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle"
					}, 4000);
				}
			}
		}, {
			key: "saveChanges",
			value: function saveChanges(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				this.setState({ savingChanges: true });
	
				var promises = [];
	
				if (!_.isEmpty(this.state.overrides)) {
					if (this.changeGoalsConfirmationNeeded()) {
						if (confirm("Are you sure you want to edit the class goals? This will override all student goals in this class.")) {
							promises.push(this.props.updateStudentList(this.state.overrides));
						}
					} else if (this.changeGradeLevelConfirmationNeeded()) {
						if (confirm("Are you sure you want to edit the class grade level? This will override the grade levels for all students in this class.")) {
							promises.push(this.props.updateStudentList(this.state.overrides));
						}
					} else {
						promises.push(this.props.updateStudentList(this.state.overrides));
					}
				}
	
				// Note from Greg: This is not the ideal way. Ideally, we'd accomplish
				// This by posting the info to student lists. This way might leave
				// a student list without a primary admins (or with two) if a call fails.
				// However, I was somewhat boxed into this by earlier decisions on how
				// to represent teacher <-> studentList relations in redux state
	
				var originalTeachersSelected = this.teachersSelectedFromProps();
				var slID = this.props.studentList.id;
	
				_.each(this.props.teachers, function (teacher) {
					if (originalTeachersSelected[teacher.id] !== _this2.state.teachersSelected[teacher.id]) {
						var newOrgIDs = void 0;
						if (!_this2.state.teachersSelected[teacher.id]) {
							// Remove this studentList ID from the teacher
							newOrgIDs = _extends({}, teacher.org_ids, { // keep other org types
								student_lists: {
									primary: _.without(teacher.org_ids.student_lists.primary, slID),
									sub: _.without(teacher.org_ids.student_lists.sub, slID),
									all: _.without(teacher.org_ids.student_lists.all, slID)
								}
							});
						} else if (_this2.state.teachersSelected[teacher.id] === "sub") {
							// Add as sub, remove from primary if set
							newOrgIDs = _extends({}, teacher.org_ids, { // keep other org types
								student_lists: {
									primary: _.without(teacher.org_ids.student_lists.primary, slID),
									sub: _.union(teacher.org_ids.student_lists.sub, [slID]),
									all: _.union(teacher.org_ids.student_lists.all, [slID])
								}
							});
						} else if (_this2.state.teachersSelected[teacher.id] === "primary") {
							// Add as primary, remove from sub if set
							newOrgIDs = _extends({}, teacher.org_ids, { // keep other org types
								student_lists: {
									primary: _.union(teacher.org_ids.student_lists.primary, [slID]),
									sub: _.without(teacher.org_ids.student_lists.sub, slID),
									all: _.union(teacher.org_ids.student_lists.all, [slID])
								}
							});
						}
	
						if (newOrgIDs) {
							promises.push(_this2.props.updateTeacherOrgIDs(teacher, newOrgIDs));
						}
					}
				});
	
				Promise.all(promises).then(function () {
					_this2.setState(_this2.getInitialState());
					_this2.props.fetchStudents();
					CurrentUser.fetchCurrentUserData();
	
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", icon: "ok-sign"
					}, 4000);
				}).catch(function () {
					_this2.setState({ savingChanges: false });
					window.wrNotifications.triggerDropDownNotification({
						title: "Oops!", text: "Something went wrong and the student list was not edited",
						type: "error", icon: "remove"
					}, 4000);
				});
			}
	
			///////// RENDER METHODS /////////
	
		}, {
			key: "triggerRLDPaywall",
			value: function triggerRLDPaywall() {
				this.props.openZpdPaywall();
			}
		}, {
			key: "renderTeacherSelector",
			value: function renderTeacherSelector() {
				var _this3 = this;
	
				var studentList = this.formStudentList();
	
				if (this.hasCleverUser()) {
					var disableClass = "disableEvents";
					var topContent = React.createElement(
						"div",
						null,
						"A filled star is a primary teacher.",
						React.createElement("br", null),
						"Empty stars are secondary teachers.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				} else {
					var topContent = React.createElement(
						"div",
						null,
						"Click to select the primary admin.",
						React.createElement("br", null),
						"Hold shift & click to set a subadmin.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				}
	
				var toggles = [{
					key: "primary",
					icon: "star",
					select: ToggleMultiselect.SELECT_LEFT_CLICK,
					primary: true,
					singleton: true
				}, {
					key: "sub",
					icon: "star-empty",
					select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK
				}];
	
				var options = this.props.teachers.map(function (x) {
					return {
						key: x.id, text: x.first_name + " " + x.last_name
					};
				});
	
				return React.createElement(ToggleMultiselect, { className: "classSelector " + disableClass, dropdownDisplay: "link",
					topContent: topContent,
					selected: this.state.teachersSelected,
					toggles: toggles,
					options: options,
					defaultDisplayText: 'Select Student List(s)',
					onChange: function onChange(selection) {
						return _this3.editSelectedStudents(selection);
					} });
			}
		}, {
			key: "buildPassPhraseSection",
			value: function buildPassPhraseSection() {
				var _this4 = this;
	
				if (this.props.currentAdmin.clever_user) {
					return;
				}
	
				if (this.props.isLoadingStudents) {
					var classCodeValue = React.createElement(Spinner, { scale: 0.5, className: "classCodeSpinner" });
				} else if (this.props.studentList.passphrase) {
					var classCodeValue = React.createElement("input", { readOnly: true, value: this.props.studentList.passphrase || "" });
				} else {
					var addClasscode = function addClasscode(e) {
						$wr.nope(e);
						_this4.props.updateStudentList({ "add_passphrase": true }).then(function (res) {
							_this4.props.resetStudentLists();
						});
					};
					var classCodeValue = React.createElement(
						"a",
						{ onClick: addClasscode, className: "classCodeLink" },
						"Add Class Code"
					);
				}
	
				return React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Class Code",
						" ",
						React.createElement(
							"span",
							{ className: "helpSectionContainer" },
							React.createElement(HelpSectionLink, { featureName: "Class Codes", linkSuffix: "360001605011", iconOnly: true })
						)
					),
					classCodeValue
				);
			}
	
			// these attributes are not editable by Clever users
	
		}, {
			key: "buildStaticInfoSection",
			value: function buildStaticInfoSection(studentList) {
				var gradeInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Grade"
					),
					React.createElement(
						"span",
						null,
						studentList.grade_level
					)
				);
	
				var teachersInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Teachers"
					),
					this.renderTeacherSelector()
				);
	
				return { gradeInput: gradeInput, teachersInput: teachersInput };
			}
	
			// make editable for non-Clever users
	
		}, {
			key: "buildEditableInfoSection",
			value: function buildEditableInfoSection(studentList) {
				var _this5 = this;
	
				var gradeInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Grade"
					),
					React.createElement(
						"select",
						{ type: "text", value: studentList.grade_level,
							id: "select-grade-sl" + this.props.slIndex,
							onChange: function onChange(e) {
								return _this5.editStudentListForm("grade_level", e.target.value);
							} },
						DropDownOptions.Select.GradeLevels()
					)
				);
	
				var teachersInput = React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Teachers"
					),
					this.renderTeacherSelector()
				);
	
				var classCodeInput = this.buildPassPhraseSection();
				return { gradeInput: gradeInput, teachersInput: teachersInput, classCodeInput: classCodeInput };
			}
	
			// Class names can be edited by all users
	
		}, {
			key: "nameInput",
			value: function nameInput(studentList) {
				var _this6 = this;
	
				return React.createElement(
					"label",
					{ className: "inputPair" },
					React.createElement(
						"span",
						{ className: "text" },
						"Name"
					),
					React.createElement("input", { type: "text", value: studentList.name, "data-lpignore": "true",
						id: "input-slName-sl" + this.props.slIndex,
						onChange: function onChange(e) {
							return _this6.editStudentListForm('name', e.target.value);
						} })
				);
			}
	
			// disclaimer that digests need to be recalculated overnight.
	
		}, {
			key: "renderDisclaimer",
			value: function renderDisclaimer() {
				if (this.state.overrides['prefs'] && this.props.expanded) {
					if (this.state.overrides['prefs']['expectations_time_period'] || this.state.overrides['prefs']['expectations_time_period_starts']) {
						return React.createElement(
							"div",
							{ className: "disclaimer" },
							React.createElement(
								"p",
								null,
								"Note: Changes to data settings are recalculated overnight. This change will be reflected on your data pages ",
								React.createElement(
									"i",
									null,
									"tomorrow"
								),
								"."
							)
						);
					}
				}
			}
		}, {
			key: "renderInfoSection",
			value: function renderInfoSection() {
				var _this7 = this;
	
				var studentList = this.formStudentList();
	
				if (this.state.savingChanges) {
					var buttonSection = React.createElement(Spinner, { scale: 1, className: "btnSectionSpinner" });
				} else {
					var archiveBtn = this.hasCleverUser() ? '' : React.createElement(
						"a",
						{ className: "btn-link archiveClassBtn", type: "button", onClick: this.onArchive },
						"Archive Class"
					);
					var buttonSection = React.createElement(
						"div",
						{ className: "buttons" },
						React.createElement(
							"div",
							null,
							React.createElement(
								"button",
								{ className: "btn btn-link buttonPrimary saveButton", type: "submit" },
								"Save"
							)
						),
						archiveBtn
					);
				}
	
				var openSectionClass = this.props.expanded ? this.props.openSectionClass : 'drawerClosed';
				var extraFormHeightClass = this.state.extraFormHeight ? ' extraHeight' : '';
	
				if (this.hasCleverUser()) {
					var _buildStaticInfoSecti = this.buildStaticInfoSection(studentList),
					    gradeInput = _buildStaticInfoSecti.gradeInput,
					    teachersInput = _buildStaticInfoSecti.teachersInput;
				} else {
					var _buildEditableInfoSec = this.buildEditableInfoSection(studentList),
					    gradeInput = _buildEditableInfoSec.gradeInput,
					    teachersInput = _buildEditableInfoSec.teachersInput,
					    classCodeInput = _buildEditableInfoSec.classCodeInput;
				}
	
				return React.createElement(
					"form",
					{ className: "editSection " + openSectionClass + extraFormHeightClass, onSubmit: this.saveChanges },
					React.createElement(
						"div",
						{ className: "firstCol" },
						React.createElement(
							"div",
							{ className: "studentSectionHeader" },
							"Class Information"
						),
						this.nameInput(studentList),
						gradeInput,
						teachersInput,
						React.createElement(
							"label",
							{ className: "inputPair" },
							React.createElement(
								"span",
								{ className: "text" },
								"Owl Shop"
							),
							React.createElement(
								"select",
								{ type: "text", value: studentList.prefs.shop_opening_time,
									id: "select-owlShopHours-sl" + this.props.slIndex,
									onChange: function onChange(e) {
										return _this7.editStudentListFormPrefs({ "shop_opening_time": e.target.value });
									} },
								DropDownOptions.Select.OwlShopOpeningTimes()
							)
						),
						React.createElement(
							"label",
							{ className: "inputPair" },
							React.createElement(
								"span",
								{ className: "text" },
								"Quizzes"
							),
							React.createElement(
								"select",
								{ type: "text", value: studentList.prefs.quiz_close_time || "Never close",
									id: "select-quizCloseTime-sl" + this.props.slIndex,
									onChange: function onChange(e) {
										return _this7.editStudentListFormPrefs({ "quiz_close_time": e.target.value });
									} },
								DropDownOptions.Select.QuizClosingTimes()
							)
						),
						classCodeInput
					),
					React.createElement(
						"div",
						{ className: "secondCol" },
						React.createElement(EditableGoals, { indexKey: "sl" + this.props.slIndex, prefs: studentList.prefs, gradeLevel: studentList.grade_level.toString(), onEditPrefs: this.editStudentListFormPrefs, quiz: true, supplemental: true })
					),
					React.createElement(
						"div",
						{ className: "thirdCol" },
						React.createElement(EditableGoals, { indexKey: "sl" + this.props.slIndex, prefs: studentList.prefs, gradeLevel: studentList.grade_level.toString(), onEditPrefs: this.editStudentListFormPrefs, periodSelector: true })
					),
					React.createElement(
						"div",
						{ className: "fourthCol" },
						React.createElement(
							"div",
							{ className: "hideBtn" },
							React.createElement(
								"a",
								{ className: "btn btn-link", onClick: this.props.toggleFormStatus.bind(this, studentList.id) },
								"Hide ",
								React.createElement(Glyphicon, { icon: 'menu-up' })
							)
						)
					),
					React.createElement(
						"div",
						{ className: "btnContainer" },
						buttonSection
					)
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (!(0, _fastDeepEqual2.default)(this.props.teachers, prevProps.teachers)) // Check if it's a new teacher
					{
						this.setState({ teachersSelected: this.teachersSelectedFromProps(this.props) });
					}
			}
		}, {
			key: "isLoadingStudents",
			value: function isLoadingStudents() {
				if (this.props.studentList && this.props.studentList.student_ids && this.props.studentList.student_ids.length > 0) {
					if (!this.props.studentList.students || this.props.studentList.students.length != this.props.studentList.student_ids.length) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: "render",
			value: function render() {
				var studentList = this.props.studentList;
	
	
				if (this.realStudentList() && this.props.formExpanded) {
					var selectedEditSection = this.renderInfoSection();
				}
				// add school name under student list
				if (this.realStudentList() && studentList.school) {
					// truncate just in case
					var schoolName = $wr.truncate(studentList.school.name, 50);
				}
	
				var icon = this.props.expanded ? "menu-up" : "menu-down";
	
				if (this.isLoadingStudents()) {
					var loading = React.createElement(
						"span",
						null,
						"Loading.."
					);
				}
	
				if (this.props.studentListLinkProblem) {
					var warning = React.createElement(Glyphicon, { icon: "exclamation-sign" });
				}
	
				return React.createElement(
					"div",
					{ className: "rosterStudentList",
						key: "studentList-" + studentList.id,
						id: "rosterStudentListHeader-sl" + this.props.slIndex
					},
					React.createElement(
						"div",
						{ className: "nameSection studentList-" + studentList.id,
							onClick: this.props.handleExpandStudentListSection.bind(this, studentList.id) },
						React.createElement(
							"div",
							{ className: "detailSection studentListName" },
							React.createElement(
								"div",
								{ className: "studentInfoText" },
								React.createElement(
									"div",
									{ className: "topRow" },
									studentList.name,
									warning
								),
								React.createElement(
									"div",
									{ className: "schoolName" },
									schoolName
								),
								loading
							)
						),
						React.createElement(
							"div",
							{ className: "detailSection" },
							React.createElement(
								"div",
								{ className: "menuOption" },
								React.createElement(Glyphicon, { icon: icon })
							)
						)
					),
					this.renderDisclaimer(),
					selectedEditSection
				);
			}
		}]);
	
		return RosterStudentList;
	}(React.Component)) || _class);
	
	
	var METRICS_TO_CONFIRM = ['expectations_metrics', 'expectations_time_period', 'expectations_time_period_starts', 'recall_question_count', 'sentence_starter_count'];
	
	RosterStudentList.WrappedComponent.propTypes = PageStrictPropTypes({
		// From above
		studentList: PropTypes.object,
		currentAdmin: PropTypes.object,
		selected: PropTypes.bool,
		toggleSelected: PropTypes.func,
		teachers: PropTypes.array,
		openSectionClass: PropTypes.string,
		expanded: PropTypes.bool,
		formExpanded: PropTypes.bool,
		handleExpandStudentListSection: PropTypes.func,
		toggleFormStatus: PropTypes.func,
		openZpdPaywall: PropTypes.func,
		studentListLinkProblem: PropTypes.bool,
		slIndex: PropTypes.number,
	
		// @connect handler
		updateStudentList: PropTypes.func,
		updateTeacherOrgIDs: PropTypes.func,
		archiveStudentList: PropTypes.func,
		fetchStudents: PropTypes.func,
		isLoadingStudents: PropTypes.bool,
		resetStudentLists: PropTypes.func
	});
	
	module.exports = RosterStudentList;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToggleMultiselect = __webpack_require__(169);
	var HelpSectionLink = __webpack_require__(64);
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var RosterUnassignedStudent = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			currentAdmin: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }),
			studentLists: RosterSelectors.studentLists({ state: state }),
			readingLevelFormat: CurrentUser.get().prefs.reading_level_format,
			isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state: state })
		};
	}, function (dispatch, props) {
		return {
			updateStudent: function updateStudent(update) {
				return new Promise(function (resolve, reject) {
					dispatch(RosterActions.updateStudent({ id: props.student.id, update: update })).then(function (response) {
						resolve(response);
					}).catch(function () {
						return resolve({ error: true });
					});
				});
			},
			// updates student in state
			fetchStudent: function fetchStudent(id) {
				return dispatch(RosterActions.fetchStudent({ id: id, embeds: ["student.password"] }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(RosterUnassignedStudent, _React$Component);
	
		function RosterUnassignedStudent(props) {
			_classCallCheck(this, RosterUnassignedStudent);
	
			var _this = _possibleConstructorReturn(this, (RosterUnassignedStudent.__proto__ || Object.getPrototypeOf(RosterUnassignedStudent)).call(this));
	
			autobind(_this);
	
			_this.state = _this.getInitialState();
			return _this;
		}
	
		///////// HELPERS /////////
	
	
		_createClass(RosterUnassignedStudent, [{
			key: "getInitialState",
			value: function getInitialState() {
				return {
					overrides: {},
					savingChanges: false
				};
			}
		}, {
			key: "prefs",
			value: function prefs() {
				return this.props.student.prefs;
			}
	
			// returns current student
	
		}, {
			key: "formStudent",
			value: function formStudent() {
				return _extends({}, this.props.student, this.state.overrides, {
					prefs: _extends({}, this.prefs(), this.state.overrides.prefs)
				});
			}
		}, {
			key: "isDemoStudent",
			value: function isDemoStudent() {
				return this.props.student.demo_for_teacher;
			}
		}, {
			key: "hasCleverUser",
			value: function hasCleverUser() {
				return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false;
			}
		}, {
			key: "slOverrides",
			value: function slOverrides() {
				var student_list_ids = this.state.overrides.student_list_ids;
	
				return student_list_ids;
			}
	
			///////// STATE MANIPULATORS /////////
	
			// edits student information
	
		}, {
			key: "editStudentForm",
			value: function editStudentForm(key, val, callback) {
				this.setState({
					overrides: _extends({}, this.state.overrides, _defineProperty({}, key, val))
				}, callback);
			}
	
			///////// DATABASE MANIPULATORS /////////
	
		}, {
			key: "saveChanges",
			value: function saveChanges(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.setState({ savingChanges: true });
				if (!_.isEmpty(this.state.overrides)) {
					this.props.updateStudent(this.state.overrides).then(function (response) {
						var studentResponse = response.students[0];
						if (!studentResponse.errors) {
							window.wrNotifications.triggerDropDownNotification({
								title: "Student Edited!", text: "You have successfully edited a student!",
								icon: "ok-circle"
							});
							// update student data in state
							_this2.props.fetchStudent(studentResponse.id);
							if (_this2.props.onUpdateArchivedStudent) {
								_this2.props.onUpdateArchivedStudent();
							}
							// reset component state
							_this2.setState(_this2.getInitialState());
						} else {
							_this2.setState({ savingChanges: false });
							window.wrNotifications.triggerDropDownNotification({
								title: "Oops!", text: "Something went wrong and the student was not edited",
								type: "error", icon: "exclamation-sign"
							}, 4000);
						}
					});
				}
			}
	
			///////// RENDER METHODS /////////
	
		}, {
			key: "renderUpdateButton",
			value: function renderUpdateButton() {
				return this.slOverrides() ? React.createElement(
					"a",
					{ className: "btn btn-link saveButton", onClick: this.saveChanges.bind(this) },
					"Save"
				) : '';
			}
		}, {
			key: "renderStudentListSelector",
			value: function renderStudentListSelector() {
				var _this3 = this;
	
				if (this.hasCleverUser()) {
					var disableClass = "disableEvents";
					var topContent = React.createElement(
						"div",
						null,
						"A filled star is a primary class.",
						React.createElement("br", null),
						"Empty stars are secondary classes.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				} else {
					var topContent = React.createElement(
						"div",
						null,
						"Click a class to set it as primary.",
						React.createElement("br", null),
						"Hold shift & click to set secondary.",
						" ",
						React.createElement(HelpSectionLink, { featureName: "Primary & Secondary Classes", linkSuffix: "360054128371", iconOnly: true })
					);
				}
	
				var toggles = [{
					key: "primary",
					icon: "star",
					select: ToggleMultiselect.SELECT_LEFT_CLICK,
					primary: true,
					singleton: true
				}, {
					key: "secondary",
					icon: "star-empty",
					select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK
				}];
	
				var options = this.props.studentLists.map(function (x) {
					return { key: x.id, text: x.name };
				});
	
				var selected = {};
				if (this.slOverrides()) {
					_.each(this.slOverrides().active, function (slID) {
						if (slID === _this3.slOverrides().primary) {
							selected[slID] = "primary";
						} else {
							selected[slID] = "secondary";
						}
					});
				}
	
				var onClassChange = function onClassChange(updatedSelected) {
					var newStudentListIDs = {
						'active': [],
						'all': []
					};
					_.each(updatedSelected, function (toggleKey, studentListID) {
						newStudentListIDs.active.push(parseInt(studentListID));
						newStudentListIDs.all.push(parseInt(studentListID));
	
						if (toggleKey === "primary") {
							newStudentListIDs.primary = parseInt(studentListID);
						}
					});
	
					_this3.editStudentForm("student_list_ids", newStudentListIDs);
				};
	
				return React.createElement(ToggleMultiselect, { className: "classSelector unassignedSLToggle " + disableClass, dropdownDisplay: "link",
					topContent: topContent,
					selected: selected,
					toggles: toggles,
					options: options,
					defaultDisplayText: 'Select Student Lists',
					onChange: onClassChange });
			}
		}, {
			key: "render",
			value: function render() {
				var student = this.props.student;
	
	
				return React.createElement(
					"div",
					{ className: "studentListMultiselect" },
					React.createElement(
						"div",
						{ className: "topRow" },
						React.createElement(
							"div",
							{ className: "studentInfo unassignedStudent" },
							React.createElement(
								"div",
								{ className: "nameSection" },
								student.display_name
							),
							this.renderStudentListSelector(),
							this.renderUpdateButton()
						)
					)
				);
			}
		}]);
	
		return RosterUnassignedStudent;
	}(React.Component)) || _class);
	
	
	RosterUnassignedStudent.WrappedComponent.propTypes = PageStrictPropTypes({
		// From above
		student: PropTypes.object.isRequired,
		currentAdmin: PropTypes.object,
		selected: PropTypes.bool,
		toggleSelected: PropTypes.func,
		updateStudents: PropTypes.func,
		updateUnassignedStudents: PropTypes.func,
		onUpdateArchivedStudent: PropTypes.func,
	
		// @connect data
		populateData: PropTypes.func,
		studentLists: PropTypes.array,
		readingLevelFormat: PropTypes.string,
		isLoadingStudents: PropTypes.bool,
		studentList: PropTypes.object,
	
		// @connect handlers
		updateStudent: PropTypes.func,
		fetchStudent: PropTypes.func
	});
	
	module.exports = RosterUnassignedStudent;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSelect = __webpack_require__(154);
	var WhooosReadingServices = __webpack_require__(25);
	var Glyphicon = __webpack_require__(8);
	
	var SchoolSearch = function (_React$Component) {
		_inherits(SchoolSearch, _React$Component);
	
		function SchoolSearch(props) {
			_classCallCheck(this, SchoolSearch);
	
			var _this = _possibleConstructorReturn(this, (SchoolSearch.__proto__ || Object.getPrototypeOf(SchoolSearch)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: true, searchTimer: null
			};
			return _this;
		}
	
		_createClass(SchoolSearch, [{
			key: "selectSchool",
			value: function selectSchool(selectedSchool) {
				if (selectedSchool == null) {
					this.props.onSelect(null);
				} else if (selectedSchool.value == SchoolSearch.MANUAL_ENTRY) {
					this.props.toggleManual();
				} else {
					this.props.onSelect(selectedSchool);
				}
			}
		}, {
			key: "setSchoolSearchTimer",
			value: function setSchoolSearchTimer(input, callback) {
				if (this.state.searchTimer) {
					clearTimeout(this.state.searchTimer);
				}
				this.state.searchTimer = setTimeout(this.getSchoolOptions, 500, input, callback);
			}
		}, {
			key: "getSchoolOptions",
			value: function getSchoolOptions(input, callback) {
				var searchParams = { q: input.trim(), embed: "school.district,school.demographic_bucket" };
				var url = WhooosReadingServices.CanonicalSchools.url("/search", searchParams);
	
				if (input.trim().length == 0) {
					callback(null, { options: [] });
					return;
				}
	
				$.getJSON(url, function (data) {
					var options = _.map(data.schools, function (school) {
						return { value: school, label: school.name + " (" + school.zip + ")" };
					});
	
					options.push({ value: SchoolSearch.MANUAL_ENTRY, label: input.trim() });
	
					callback(null, { options: options });
				});
			}
		}, {
			key: "optionRenderer",
			value: function optionRenderer(optionData, index) {
				if (optionData.value == SchoolSearch.MANUAL_ENTRY) {
					return React.createElement(
						"span",
						{ className: "searchOpDisplay text-center" },
						React.createElement(
							"span",
							null,
							"Not finding your school? Try ZIP code or ",
							" ",
							React.createElement(
								"a",
								{ href: "#", onClick: $wr.nope },
								"add it manually."
							)
						)
					);
				} else {
					return React.createElement(
						"span",
						{ className: "schoolOpDisplay" },
						optionData.label
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var placeholderText = "Search by ZIP code (or school name)";
	
				return React.createElement(
					"div",
					{ className: "schoolSearch" },
					React.createElement(ReactSelect.Async, { name: "school-name", autoload: false,
						optionRenderer: this.optionRenderer, keepInputCase: true,
						value: this.props.selectedSchool, placeholder: placeholderText,
						loadOptions: this.setSchoolSearchTimer, onChange: this.selectSchool })
				);
			}
		}]);
	
		return SchoolSearch;
	}(React.Component);
	
	;
	
	SchoolSearch.NOT_PRESENT = "not-present";
	
	SchoolSearch.MANUAL_ENTRY = "manaul-entry";
	
	SchoolSearch.propTypes = StrictPropTypes({
		toggleManual: PropTypes.func,
		selectedSchool: PropTypes.object,
		onSelect: PropTypes.func
	
	});
	
	module.exports = SchoolSearch;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var StudentsSelectedDisplay = __webpack_require__(139);
	var ErrorDisplay = __webpack_require__(51);
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var SendNote = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			totalStudents: RosterSelectors.students({ state: state }).length
		};
	}, function (dispatch, props) {
		return {
			createUserAlerts: function createUserAlerts(userAlert, on) {
				return dispatch(RosterActions.createUserAlerts({ on: on, userAlert: userAlert }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(SendNote, _React$Component);
	
		function SendNote(props) {
			_classCallCheck(this, SendNote);
	
			var _this = _possibleConstructorReturn(this, (SendNote.__proto__ || Object.getPrototypeOf(SendNote)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false
			};
			return _this;
		}
	
		_createClass(SendNote, [{
			key: "sendNote",
			value: function sendNote(e) {
				var _this2 = this;
	
				$wr.nope(e);
				this.refs.errors.reset();
				var errors = [];
	
				if (!this.state.loading) {
					this.setState({ loading: true });
					var message = this.refs.note.value;
	
					if (message == "") {
						errors.push("Please enter a message for your note.");
					}
	
					if (errors.length == 0) {
						var title = "Note Sent";
						var text = "A carrier pigeon, no, an owl is delivering your note.";
						var studentIds = _.pluck(this.props.students, "id");
						var userAlert = {
							message: message, student_ids: studentIds
						};
	
						this.props.createUserAlerts(userAlert, "site").then(function () {
							_this2.setState({ loading: false });
							window.wrNotifications.triggerDropDownNotification({
								title: title, text: text, icon: "ok-circle", duration: 4000 });
	
							if (_this2.props.onComplete) {
								_this2.props.onComplete();
							}
						});
					} else {
						this.setState({ loading: false });
						this.refs.errors.setErrors(errors);
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var nudgeStudents = window.location.href.includes("nudgeStudents");
				if (nudgeStudents) {
					var placeholderText = "Hey Kiddos, let's get some more quizzes done!";
				} else {
					var placeholderText = "Your message goes here...";
				}
	
				return React.createElement(
					"div",
					{ className: "sendNote" },
					React.createElement(StudentsSelectedDisplay, { totalStudents: this.props.totalStudents,
						studentsSelected: this.props.students }),
					React.createElement(
						"form",
						{ onSubmit: this.sendNote, className: "sendNoteForm" },
						React.createElement(ErrorDisplay, { ref: "errors" }),
						React.createElement(
							"label",
							null,
							"Note:"
						),
						React.createElement("textarea", { className: "form-control noteContent", name: "message", rows: "3", ref: "note",
							placeholder: placeholderText }),
						React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: "Send Note", loading: this.state.loading })
					)
				);
			}
		}]);
	
		return SendNote;
	}(React.Component)) || _class);
	;
	
	SendNote.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		students: PropTypes.array,
		onComplete: PropTypes.func,
	
		// Data from @connect
		totalStudents: PropTypes.number,
	
		// Handler from @connect
		createUserAlerts: PropTypes.func
	});
	
	module.exports = SendNote;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentsSelectedDisplay = __webpack_require__(139);
	var ErrorDisplay = __webpack_require__(51);
	var CurrentUser = __webpack_require__(3);
	
	var HelpSectionLink = __webpack_require__(64);
	var Glyphicon = __webpack_require__(8);
	var ValidatingInput = __webpack_require__(91);
	
	var WhooosReadingServices = __webpack_require__(25);
	var DocumentClient = __webpack_require__(259);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var StudentLogins = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			totalStudents: RosterSelectors.students({ state: state }).length,
			students: props.students.length ? props.students : RosterSelectors.students({ state: state })
		};
	}, function (dispatch, props) {
		return {
			updateStudent: function updateStudent(studentID, update) {
				return dispatch(RosterActions.updateStudent({
					id: studentID, update: update, embeds: ["student.password"]
				}));
			},
			setParentLogins: function setParentLogins() {}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentLogins, _React$Component);
	
		function StudentLogins(props) {
			_classCallCheck(this, StudentLogins);
	
			var _this = _possibleConstructorReturn(this, (StudentLogins.__proto__ || Object.getPrototypeOf(StudentLogins)).call(this));
	
			autobind(_this);
			_this.state = {
				editingStudent: null, overrideLoginData: {},
				errorMessages: {}, discardEdits: false
			};
			return _this;
		}
	
		_createClass(StudentLogins, [{
			key: "openEdit",
			value: function openEdit(student) {
				if (!this.validateFields()) {
					return;
				}
				this.submitEditedInformation();
				this.setState({ editingStudent: student });
			}
		}, {
			key: "closeEdit",
			value: function closeEdit(e) {
				$wr.nope(e);
				if (!this.validateFields()) {
					return;
				}
				this.submitEditedInformation();
				this.setState({ editingStudent: null });
			}
		}, {
			key: "onKeyPress",
			value: function onKeyPress(event) {
				if (event.keyCode == 13) {
					this.closeEdit(event);
				}
			}
		}, {
			key: "setErrors",
			value: function setErrors(studentID, errorArray) {
				var errorData = _.clone(this.state.errorMessages);
				var usernameErrors = _.filter(errorArray, function (error) {
					return error.includes("sername");
				});
				var passwordErrors = _.filter(errorArray, function (error) {
					return error.includes("assword");
				});
				errorData[studentID] = {};
				errorData[studentID].usernameErrors = usernameErrors;
				errorData[studentID].passwordErrors = passwordErrors;
	
				this.setState({ errorMessages: errorData });
			}
		}, {
			key: "updateOverrideData",
			value: function updateOverrideData(studentID, attribute, event) {
				var overrideData = _.clone(this.state.overrideLoginData);
				overrideData[studentID] = _.clone(overrideData[studentID] || {});
				overrideData[studentID][attribute] = event.target.value.trim();
				this.setState({ overrideLoginData: overrideData });
			}
		}, {
			key: "clearOverridesAndErrors",
			value: function clearOverridesAndErrors(studentID) {
				var newOverrideData = _.omit(this.state.overrideLoginData, studentID);
				var newErrorData = _.omit(this.state.errorMessages, studentID);
				this.setState({ overrideLoginData: newOverrideData, errorMessages: newErrorData });
			}
		}, {
			key: "submitEditedInformation",
			value: function submitEditedInformation() {
				var _this2 = this;
	
				if (!this.validateFields()) {
					return;
				}
	
				var previousStudent = this.state.editingStudent;
	
				if (previousStudent) {
					var studentData = this.state.overrideLoginData[previousStudent.id];
	
					if (studentData && (studentData.username || studentData.password_plain_text)) {
						var params = { student: studentData, embed: "student.password,student.student_list" };
						var text = "You have edited the login information of " + previousStudent.display_name + ".";
	
						this.props.updateStudent(previousStudent.id, studentData).then(function (response) {
							var studentResponse = response.students[0];
							if (!studentResponse.errors) {
								_this2.clearOverridesAndErrors(previousStudent.id);
	
								window.wrNotifications.triggerDropDownNotification({
									title: "Information Edited!", text: text,
									icon: "ok-circle"
								});
							} else {
								_this2.setErrors(previousStudent.id, studentResponse.errors);
							}
						});
					}
				}
			}
		}, {
			key: "validateFields",
			value: function validateFields() {
				var isValid = true;
				if (this.refs["usernameInput"]) {
					isValid = isValid & this.refs["usernameInput"].validate();
				}
				if (this.refs["passwordInput"]) {
					isValid = isValid & this.refs["passwordInput"].validate();
				}
				return isValid;
			}
		}, {
			key: "renderStudentRows",
			value: function renderStudentRows() {
				var _this3 = this;
	
				var selectedStudents = _.clone(this.props.students);
	
				// unfortunate code to bring the demo student to the top of the list
				var demoStudents = _.filter(selectedStudents, function (student) {
					return student.demo_for_teacher;
				});
				var nonDemoStudents = _.reject(selectedStudents, function (student) {
					return student.demo_for_teacher;
				});
				var sortedNonDemoStudents = $wr.sortByName(nonDemoStudents, "flexName");
				var sortedStudents = _.union(demoStudents, sortedNonDemoStudents);
	
				return sortedStudents.map(function (student) {
					var studentOverrideData = _this3.state.overrideLoginData[student.id];
					if (studentOverrideData) {
						var defaultUsername = studentOverrideData.username || student.username;
						var defaultPassword = studentOverrideData.password_plain_text || student.password;
					} else {
						var defaultUsername = student.username;
						var defaultPassword = student.password;
					}
	
					if (_this3.state.editingStudent == student) {
						var usernameContent = React.createElement(
							"div",
							{ className: "username" },
							React.createElement(ValidatingInput, { ref: "usernameInput", type: "text", inputName: "Username",
								defaultValue: defaultUsername, onKeyDown: _this3.onKeyPress,
								validators: ValidatingInput.Validators.PRESENT,
								onChange: _this3.updateOverrideData.bind(_this3, student.id, "username"),
								inputClassName: "form-control usernameInput" })
						);
						var passwordContent = React.createElement(
							"div",
							{ className: "password" },
							React.createElement(ValidatingInput, { ref: "passwordInput", type: "text", inputName: "Password",
								defaultValue: defaultPassword, onKeyDown: _this3.onKeyPress,
								validators: ValidatingInput.Validators.PRESENT,
								onChange: _this3.updateOverrideData.bind(_this3, student.id, "password_plain_text"),
								inputClassName: "form-control passwordInput" }),
							React.createElement(
								"div",
								{ className: "enterToSubmit" },
								React.createElement(
									"a",
									{ href: "#", onClick: _this3.closeEdit },
									"Press enter"
								),
								" to submit"
							)
						);
					} else {
						if (defaultPassword) {
							var passwordDisplay = defaultPassword;
						} else {
							var passwordDisplay = React.createElement(
								"em",
								null,
								"set by student"
							);
						}
	
						var studentErrors = _this3.state.errorMessages[student.id];
						if (studentErrors && studentErrors.usernameErrors.length > 0) {
							var usernameIcon = React.createElement(Glyphicon, { icon: "exclamation-sign", className: "errorIcon",
								dataTip: studentErrors.usernameErrors.join(". ") });
						} else {
							var usernameIcon = React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" });
						}
						if (studentErrors && studentErrors.passwordErrors.length > 0) {
							var passwordIcon = React.createElement(Glyphicon, { icon: "exclamation-sign", className: "errorIcon",
								dataTip: studentErrors.passwordErrors.join(". ") });
						} else {
							var passwordIcon = React.createElement(Glyphicon, { icon: "pencil", className: "editIcon" });
						}
						var usernameContent = React.createElement(
							"div",
							{ className: "username editable",
								onClick: function onClick() {
									return _this3.openEdit(student);
								} },
							React.createElement(
								"span",
								{ className: "clickableElement ellipsisText" },
								defaultUsername
							),
							" ",
							usernameIcon
						);
						var passwordContent = React.createElement(
							"div",
							{ className: "password editable",
								onClick: function onClick() {
									return _this3.openEdit(student);
								} },
							React.createElement(
								"span",
								{ className: "clickableElement ellipsisText" },
								passwordDisplay
							),
							" ",
							passwordIcon
						);
					}
	
					if (student.demo_for_teacher) {
						var demoIndicator = React.createElement(
							"span",
							{ className: "demoIndicator" },
							"DEMO"
						);
					}
	
					return React.createElement(
						"div",
						{ key: student.id, className: "studentRow" },
						React.createElement(
							"div",
							{ className: "name" },
							student.display_name,
							demoIndicator
						),
						usernameContent,
						passwordContent
					);
				});
			}
		}, {
			key: "renderMainDisplay",
			value: function renderMainDisplay() {
				var students = this.props.students;
				if (students && students.length > 0) {
					var studentIDs = _.pluck(this.props.students, "id");
					var viewAllPath = "/logins/cards?student_ids=" + studentIDs.join(",");
	
					var students = this.props.students;
					var studentsWithParents = [];
					students.map(function (student) {
						if (student.has_parent) {
							studentsWithParents.push(student.has_parent);
						}
						studentIDs.push(student.id);
					});
					if (studentsWithParents.length > 0) {
						var sendParentEmailLink = React.createElement(
							"a",
							{ onClick: this.sendParentEmail },
							"Send Parent Email"
						);
					}
	
					var addParentEmailsLink = React.createElement(
						_reactRouterDom.Link,
						{ to: "/student_parents" },
						"Add Parent Emails"
					);
	
					return React.createElement(
						"div",
						null,
						React.createElement(
							"div",
							null,
							React.createElement(
								"div",
								{ className: "printSection" },
								React.createElement(
									"a",
									{ href: "#", onClick: DocumentClient.buildOpenF(viewAllPath) },
									"Print login cards"
								),
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "smallText" },
									"Enable pop-ups to open"
								),
								React.createElement(HelpSectionLink, { featureName: "allowing pop-ups", linkSuffix: "115002455792", iconOnly: true })
							),
							React.createElement(
								"div",
								{ className: "sendParentEmailSection" },
								sendParentEmailLink,
								addParentEmailsLink
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"div",
								{ className: "headerRow" },
								React.createElement(
									"div",
									{ className: "name" },
									"Name"
								),
								React.createElement(
									"div",
									{ className: "username" },
									"Username",
									React.createElement(
										"span",
										{ className: "editHelperText" },
										"Click to edit"
									)
								),
								React.createElement(
									"div",
									{ className: "password" },
									"Password",
									React.createElement(
										"span",
										{ className: "editHelperText" },
										"Click to edit"
									)
								)
							),
							this.renderStudentRows()
						)
					);
				} else {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							React.createElement(
								"a",
								{ href: "#", onClick: DocumentClient.buildOpenF("/logins/cards") },
								"Print all of your students' usernames and passwords."
							)
						),
						React.createElement(
							"p",
							null,
							"Select students on your roster to see individual login information."
						)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "studentLogins" },
					this.renderMainDisplay()
				);
			}
		}]);
	
		return StudentLogins;
	}(React.Component)) || _class);
	;
	
	StudentLogins.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		students: PropTypes.array,
	
		// Data from @connect
		totalStudents: PropTypes.number,
	
		// Handler from @connect
		updateStudent: PropTypes.func,
		setParentLogins: PropTypes.func
	});
	
	module.exports = StudentLogins;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var LoadingButton = __webpack_require__(17);
	var StudentsSelectedDisplay = __webpack_require__(139);
	var DropDownOptions = __webpack_require__(26);
	var Glyphicon = __webpack_require__(8);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3706);
	
	var StudentGroups = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			subgroups: RosterSelectors.subgroups({ state: state }),
			totalStudents: RosterSelectors.students({ state: state }).length
		};
	}, function (dispatch, props) {
		return {
			assignSubgroup: function assignSubgroup(studentIDs, subgroup) {
				return dispatch(RosterActions.massUpdateStudentPrefs({
					studentIDs: studentIDs, update: { subgroup: subgroup },
					embeds: ["student.prefs"]
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentGroups, _React$Component);
	
		function StudentGroups(props) {
			_classCallCheck(this, StudentGroups);
	
			var _this = _possibleConstructorReturn(this, (StudentGroups.__proto__ || Object.getPrototypeOf(StudentGroups)).call(this));
	
			_this.resetSubgroup = function () {
				_this.setState({ loading: true });
				var students = _this.props.students;
				_this.props.assignSubgroup(_.pluck(students, "id"), null).then(function () {
					setTimeout(function () {
						if (students.length > 1) {
							var text = "You removed students from a group!";
						} else {
							var text = "You removed a student from a group!";
						}
						window.wrNotifications.triggerDropDownNotification({
							title: "Groups Updated", text: text,
							icon: "ok-circle"
						});
						this.setState({ loading: false });
						if (this.props.onComplete) {
							this.props.onComplete();
						}
					}.bind(_this), 100);
				});
			};
	
			_this.selectColor = function (color) {
				_this.setState({ selectedColorKey: color.key, selectedColorValue: color.props.value });
			};
	
			_this.selectedColorText = function () {
				if (_this.state.selectedColorKey) {
					return _this.state.selectedColorKey;
				} else {
					return "Select Color";
				}
			};
	
			_this.selectIcon = function (icon) {
				_this.setState({ selectedIconKey: icon.key, selectedIconValue: icon.props.value });
			};
	
			_this.selectedIconText = function () {
				if (_this.state.selectedIconKey) {
					var colorValue = _this.state.selectedColorValue;
					return React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: _this.state.selectedIconValue,
							style: colorValue ? { color: colorValue } : { color: "#555" } }),
						_this.state.selectedIconKey
					);
				} else {
					return "Select Icon";
				}
			};
	
			_this.selectGroup = function (group) {
				_this.setState({ selectedGroup: group });
			};
	
			_this.selectedGroupText = function () {
				if (_this.state.selectedGroup) {
					var colorValue = _this.state.selectedGroup.color;
					return React.createElement(
						"span",
						null,
						React.createElement(Glyphicon, { icon: _this.state.selectedGroup.icon,
							style: colorValue ? { color: colorValue } : { color: "#555" } }),
						_this.state.selectedGroup.name
					);
				} else {
					return "Select Group";
				}
			};
	
			autobind(_this);
			_this.state = { selectedAction: "addNewGroup", groupName: "" };
			return _this;
		}
	
		_createClass(StudentGroups, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "updateSubgroup",
			value: function updateSubgroup() {
				var _this2 = this;
	
				this.setState({ loading: true });
				var students = this.props.students;
				if (this.state.selectedGroup) {
					var selectedGroup = this.state.selectedGroup;
					var key = selectedGroup.key;
					var name = selectedGroup.name;
					var color = selectedGroup.color;
					var icon = selectedGroup.icon;
				} else {
					var key = $wr.randomString(20);
					var name = this.state.groupName;
					var color = this.state.selectedColorValue;
					var icon = this.state.selectedIconValue;
				}
				this.props.assignSubgroup(_.pluck(students, "id"), { key: key,
					name: name,
					color: color,
					icon: icon
				}).then(function () {
					setTimeout(function () {
						if (students.length > 1) {
							var text = "You added students to a group!";
						} else {
							var text = "You added a student to a group!";
						}
						window.wrNotifications.triggerDropDownNotification({
							title: "Groups Updated", text: text,
							icon: "ok-circle"
						});
						this.setState({ loading: false });
						if (this.props.onComplete) {
							this.props.onComplete();
						}
					}.bind(_this2), 100);
				});
			}
		}, {
			key: "renderStudentsSelected",
			value: function renderStudentsSelected() {
				return React.createElement(
					"div",
					{ className: "section" },
					React.createElement(
						"p",
						{ className: "title" },
						"Students"
					),
					React.createElement(StudentsSelectedDisplay, { totalStudents: this.props.totalStudents,
						studentsSelected: this.props.students,
						hideTo: true })
				);
			}
		}, {
			key: "renderActionOptions",
			value: function renderActionOptions() {
				var _this3 = this;
	
				var students = this.props.students;
				var studentsWithGroups = 0;
	
				students.map(function (student) {
					if (!_.isEmpty(student.prefs.subgroup)) {
						studentsWithGroups++;
					}
				});
	
				if (students.length == studentsWithGroups) {
					var remomveOption = React.createElement(
						"label",
						{ className: "normal" },
						React.createElement("input", { type: "radio", checked: this.state.selectedAction == REMOVE_FROM_GROUP,
							onChange: function onChange() {
								return _this3.setState({ selectedAction: REMOVE_FROM_GROUP });
							}
						}),
						"Remove from group"
					);
				}
				return React.createElement(
					"div",
					{ className: "section" },
					React.createElement(
						"label",
						{ className: "normal" },
						React.createElement("input", { type: "radio", checked: this.state.selectedAction == ADD_NEW_GROUP,
							onChange: function onChange() {
								return _this3.setState({ selectedAction: ADD_NEW_GROUP });
							}
						}),
						"Add to new group ",
						React.createElement("br", null)
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						{ className: "normal" },
						React.createElement("input", { type: "radio", checked: this.state.selectedAction == ADD_TO_OLD_GROUP,
							onChange: function onChange() {
								return _this3.setState({ selectedAction: ADD_TO_OLD_GROUP });
							}
						}),
						"Add to existing group ",
						React.createElement("br", null)
					),
					React.createElement("br", null),
					remomveOption
				);
			}
		}, {
			key: "isInvalid",
			value: function isInvalid() {
				return !(this.state.selectedColorKey && this.state.selectedIconKey && this.state.groupName.trim());
			}
		}, {
			key: "renderGroupForm",
			value: function renderGroupForm() {
				var _this4 = this;
	
				var students = this.props.students;
	
				var colorOptions = DropDownOptions.Select.GroupColors().map(function (color) {
					var key = color.key;
					var value = color.props.value;
					return React.createElement(
						ButtonDropdownOption,
						{ key: key, onClick: function onClick() {
								return _this4.selectColor(color);
							} },
						React.createElement(Glyphicon, { icon: value }),
						" ",
						key
					);
				});
				var iconOptions = DropDownOptions.Select.GroupIcons().map(function (icon) {
					var key = icon.key;
					var value = icon.props.value;
					var colorValue = _this4.state.selectedColorValue;
					return React.createElement(
						ButtonDropdownOption,
						{ key: key, onClick: function onClick() {
								return _this4.selectIcon(icon);
							} },
						React.createElement(Glyphicon, { icon: value, style: colorValue ? { color: colorValue } : { color: "#555" } }),
						" ",
						key
					);
				});
				if (this.state.selectedAction == ADD_NEW_GROUP) {
					var buttonText = students.length > 1 ? "Add Students" : "Add Student";
					var button = React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: buttonText,
						disabled: this.isInvalid(),
						loading: this.state.loading, onClick: this.updateSubgroup });
					var formFields = React.createElement(
						"div",
						{ className: "newGroupContainer" },
						React.createElement(
							"p",
							{ className: "title" },
							"Group"
						),
						React.createElement("input", { className: "form-control", type: "text", placeholder: "Group Name...",
							value: this.state.groupName,
							onChange: function onChange(e) {
								return _this4.setState({ groupName: e.target.value });
							} }),
						React.createElement(
							ButtonDropdown,
							{ text: this.selectedColorText(), className: "", dropdownDisplay: "link" },
							colorOptions
						),
						React.createElement(
							ButtonDropdown,
							{ text: this.selectedIconText(), className: "", dropdownDisplay: "link" },
							iconOptions
						)
					);
				} else if (this.state.selectedAction == ADD_TO_OLD_GROUP) {
					var buttonText = students.length > 1 ? "Add Students" : "Add Student";
					var button = React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: buttonText,
						loading: this.state.loading, onClick: this.updateSubgroup });
					var groupOptions = this.props.subgroups.map(function (group) {
						var color = group.color;
						var key = group.key;
						var name = group.name;
						var icon = group.icon;
						return React.createElement(
							ButtonDropdownOption,
							{ key: key, onClick: function onClick() {
									return _this4.selectGroup(group);
								} },
							React.createElement(Glyphicon, { icon: icon,
								style: { color: color } }),
							" ",
							name
						);
					});
					var formFields = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "title" },
							"Group"
						),
						React.createElement(
							ButtonDropdown,
							{ text: this.selectedGroupText(), className: "", dropdownDisplay: "link" },
							groupOptions
						)
					);
				} else if (this.state.selectedAction == REMOVE_FROM_GROUP) {
					var buttonText = students.length > 1 ? "Remove Students" : "Remove Student";
					var button = React.createElement(LoadingButton, { className: "buttonSuccess center-block", text: buttonText,
						loading: this.state.loading, onClick: this.resetSubgroup });
					// if (this.props.students[0].prefs.subgroup) {
					// 	var group = this.props.students[0].prefs.subgroup;
					// 	var groupInformation = (
					// 		<div className="groupInformation">
					// 			<p>
					// 				<Glyphicon icon={ group.icon } 
					// 				style={{ color: group.color }} />{ group.name }
					// 			</p>
					// 		</div>
					// 	)
					// }
				}
				return React.createElement(
					"div",
					null,
					formFields,
					button
				);
			}
		}, {
			key: "render",
			value: function render() {
				var groups = this.props.subgroups;
				if (groups.length > 0) {
					var actions = this.renderActionOptions();
				}
				var modalBody = React.createElement(
					"div",
					{ className: "studentSubgroups" },
					this.renderStudentsSelected(),
					actions,
					this.renderGroupForm()
				);
				return React.createElement(
					"div",
					{ className: "modal-body" },
					modalBody
				);
			}
		}]);
	
		return StudentGroups;
	}(React.Component)) || _class);
	;
	
	var ADD_NEW_GROUP = "addNewGroup";
	var ADD_TO_OLD_GROUP = "addToGroup";
	var REMOVE_FROM_GROUP = "removeFromGroup";
	
	StudentGroups.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		students: PropTypes.array,
		onComplete: PropTypes.func,
	
		// Data from @connect
		subgroups: PropTypes.array,
		totalStudents: PropTypes.number,
	
		// Handlers from @connect
		assignSubgroup: PropTypes.func
	});
	
	module.exports = StudentGroups;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhooosReadingServices = __webpack_require__(25);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	__webpack_require__(3707);
	
	var AddStudentsClassCode = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			studentLists: RosterSelectors.studentLists({ state: state })
		};
	}, function (dispatch, props) {
		return {
			updateStudentList: function updateStudentList(id, update) {
				var promises = [];
				if (!_.isEmpty(update)) {
					promises.push(dispatch(RosterActions.updateStudentList({
						id: id, update: update
					})));
				}
				return Promise.all(promises);
			},
			fetchStudentLists: function fetchStudentLists() {
				var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS;
				return dispatch(RosterActions.fetchStudentLists({ embeds: embeds }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AddStudentsClassCode, _React$Component);
	
		function AddStudentsClassCode(props) {
			_classCallCheck(this, AddStudentsClassCode);
	
			var _this = _possibleConstructorReturn(this, (AddStudentsClassCode.__proto__ || Object.getPrototypeOf(AddStudentsClassCode)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(AddStudentsClassCode, [{
			key: "addPassphrase",
			value: function addPassphrase(e, id) {
				var _this2 = this;
	
				console.log('helo');
				$wr.nope(e);
				this.props.updateStudentList(id, { "add_passphrase": true }).then(function (res) {
					_this2.props.fetchStudentLists();
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var studentLists = _.sortBy(this.props.studentLists, "name");
				var classCodeRows = _.map(studentLists, function (studentList) {
					if (studentList.passphrase) {
						var classLink = WhooosReadingServices.OuterPages.url("/class_code_student", {
							passphrase: studentList.passphrase
						});
						var passphraseSection = studentList.passphrase;
					} else {
						var classLink = "";
						var passphraseSection = React.createElement(
							"a",
							{ onClick: function onClick(e) {
									return _this3.addPassphrase(e, studentList.id);
								} },
							"Add Class Code"
						);
					}
					return React.createElement(
						"tr",
						{ className: "classCodeRow", key: studentList.id },
						React.createElement(
							"td",
							{ className: "name" },
							studentList.name
						),
						React.createElement(
							"td",
							{ className: "code" },
							passphraseSection
						),
						React.createElement(
							"td",
							{ className: "link" },
							React.createElement(
								"a",
								{ href: classLink, target: "_blank" },
								classLink
							)
						)
					);
				});
				return React.createElement(
					"div",
					{ className: "addStudentsClassCode" },
					React.createElement(
						"p",
						null,
						"Get your students started without having to enter in all of their names yourself.",
						" ",
						React.createElement(
							"a",
							{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/115001714992", target: "_blank" },
							"Learn more about ",
							React.createElement(
								"em",
								null,
								"Class Codes"
							),
							"."
						)
					),
					React.createElement(
						"table",
						{ className: "table classCodeTable" },
						React.createElement(
							"tbody",
							null,
							React.createElement(
								"tr",
								null,
								React.createElement(
									"th",
									null,
									"Class"
								),
								React.createElement(
									"th",
									null,
									"Class Code"
								),
								React.createElement(
									"th",
									null,
									"Class Signup Link"
								)
							),
							classCodeRows
						)
					),
					React.createElement(
						"p",
						null,
						React.createElement(
							"em",
							null,
							"Class Code"
						),
						": Students should go to ",
						React.createElement(
							"a",
							{ href: WhooosReadingServices.OuterPages.url("/") },
							WhooosReadingServices.OuterPages.url("/")
						),
						" > \"Login\" > \"Student\" > \"Have a Class Code?\" > Enter the code."
					),
					React.createElement(
						"p",
						null,
						React.createElement(
							"em",
							null,
							"Class Signup Link"
						),
						": Students should copy and paste the link into their browser."
					)
				);
			}
		}]);
	
		return AddStudentsClassCode;
	}(React.Component)) || _class);
	;
	
	AddStudentsClassCode.WrappedComponent.propTypes = StrictPropTypes({
		studentLists: PropTypes.array.isRequired
	});
	
	module.exports = AddStudentsClassCode;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3708);
	
	var AddStudentsMethodSelect = function (_React$Component) {
		_inherits(AddStudentsMethodSelect, _React$Component);
	
		function AddStudentsMethodSelect(props) {
			_classCallCheck(this, AddStudentsMethodSelect);
	
			var _this = _possibleConstructorReturn(this, (AddStudentsMethodSelect.__proto__ || Object.getPrototypeOf(AddStudentsMethodSelect)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(AddStudentsMethodSelect, [{
			key: "methodDescription",
			value: function methodDescription(methodKey) {
				if (methodKey == "manual") {
					return "Type names manually";
				} else if (methodKey == "upload") {
					return "Upload a roster file";
				} else if (methodKey == "class-code") {
					return "Hand out a class code";
				} else if (methodKey == "google-classroom") {
					return "Sync Google Classroom";
				} else if (methodKey == "clever") {
					return "Sync Clever account";
				}
			}
		}, {
			key: "changeTab",
			value: function changeTab(tabKey) {
				this.setState({ mode: tabKey }, function () {
					$(window).trigger("resize");
				});
			}
		}, {
			key: "renderMethodOption",
			value: function renderMethodOption(methodKey) {
				var className = "largeObject clickableElement";
				if (this.props.selectedOption == methodKey) {
					className += " selectedOption";
				}
	
				return React.createElement(
					"div",
					{ className: className, key: methodKey,
						onClick: this.props.onMethodSelect.bind(this, methodKey) },
					React.createElement(
						"div",
						{ className: "methodObjectContent" },
						this.methodDescription(methodKey)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.methodOptions.length == 0) {
					var methodQuestion = React.createElement(
						"p",
						{ className: "text-center" },
						"Rostering was disabled by your administator"
					);
				} else {
					var methodQuestion = React.createElement(
						"p",
						{ className: "text-center" },
						"Select a method for adding your students"
					);
	
					var methodObjects = _.map(this.props.methodOptions, function (methodKey) {
						return _this2.renderMethodOption(methodKey);
					});
					var methodOptions = React.createElement(
						"div",
						{ className: "methodOptions" },
						methodObjects
					);
				}
	
				return React.createElement(
					"div",
					{ className: "addStudentsMethodSelect" },
					methodQuestion,
					methodOptions
				);
			}
		}]);
	
		return AddStudentsMethodSelect;
	}(React.Component);
	
	;
	
	AddStudentsMethodSelect.propTypes = StrictPropTypes({
		// method options to be displayed
		methodOptions: PropTypes.array.isRequired,
		selectedOption: PropTypes.string,
	
		// function to call when a method is selected
		onMethodSelect: PropTypes.func.isRequired
	});
	
	module.exports = AddStudentsMethodSelect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhooosReadingServices = __webpack_require__(25);
	var SSORosterReview = __webpack_require__(395);
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var PendingTaskNotice = __webpack_require__(161);
	
	var CleverSync = function (_React$Component) {
		_inherits(CleverSync, _React$Component);
	
		function CleverSync(props) {
			_classCallCheck(this, CleverSync);
	
			var _this = _possibleConstructorReturn(this, (CleverSync.__proto__ || Object.getPrototypeOf(CleverSync)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("CleverSync");
			_this.state = {
				loadingDataStores: false, rosterData: null
			};
			LuckyOrangeClient.tagComponent("CleverSync");
			return _this;
		}
	
		_createClass(CleverSync, [{
			key: "submitRoster",
			value: function submitRoster(uploadData, callback) {
				var syncURL = WhooosReadingServices.SsoServer.url("/clever_sync");
				$.post(syncURL, uploadData);
			}
		}, {
			key: "finalizeRoster",
			value: function finalizeRoster(updatedRosterData) {
				var accessToken = CurrentUser.getToken();
	
				var uploadData = {
					access_token: accessToken,
					roster_data: JSON.stringify(updatedRosterData),
					create: true
				};
	
				this.submitRoster(uploadData);
	
				var studentCount = 0;
				_.each(updatedRosterData, function (section) {
					studentCount += section.students.length;
				});
				this.props.onUpload(studentCount, false, PendingTaskNotice.CLEVER_SYNC);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.loadingDataStores) {
					var section = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else if (this.state.rosterData == null) {
	
					var syncURL = WhooosReadingServices.SsoServer.url("/clever_sync");
	
					if ($wr.isProduction()) {
						var cleverSsoUrl = "https://clever.com/oauth/authorize?response_type=code&redirect_uri=" + syncURL + "&client_id=7af64e2d8fcf51128936";
					} else {
						var cleverSsoUrl = "https://clever.com/oauth/authorize?response_type=code&redirect_uri=" + syncURL + "&client_id=a5b512fca82d417a64c9";
					}
	
					var accessToken = CurrentUser.getToken();
	
					cleverSsoUrl += "&state=" + accessToken;
	
					var section = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "text-center" },
							"Sync or update your roster by connecting your Clever account."
						),
						React.createElement(
							"p",
							{ className: "text-center" },
							React.createElement(
								"a",
								{ href: cleverSsoUrl, className: "btn buttonPrimary" },
								"Connect Clever"
							)
						)
					);
				} else {
					var section = React.createElement(
						"div",
						{ className: "cleverStepTwo" },
						React.createElement(SSORosterReview, { rosterData: this.state.rosterData,
							finalizeRoster: this.finalizeRoster,
							method: SSORosterReview.CLEVER_SYNC })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "cleverSync" },
					section
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				this.setState({ loadingDataStores: true });
				var embeds = "user.pending_data_stores";
	
				var userID = CurrentUser.get().id;
				CurrentUser.api().getUser(userID, { embed: embeds }, $wr.apiHandler(function (response) {
					var cleverSyncStore = _.findWhere(response.user.pending_data_stores, {
						type: "clever-sync"
					});
	
					console.log(cleverSyncStore);
	
					if (cleverSyncStore) {
						_this2.setState({ rosterData: cleverSyncStore.data, loadingDataStores: false });
					} else {
						_this2.setState({ loadingDataStores: false });
					}
				}));
			}
		}]);
	
		return CleverSync;
	}(React.Component);
	
	;
	
	CleverSync.propTypes = StrictPropTypes({
		onUpload: PropTypes.func.isRequired
	});
	
	module.exports = CleverSync;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var ErrorDisplay = __webpack_require__(51);
	var Spinner = __webpack_require__(9);
	var WhooosReadingServices = __webpack_require__(25);
	var GoogleClassroomSync = __webpack_require__(1002);
	var CurrentUser = __webpack_require__(3);
	var SSORosterReview = __webpack_require__(395);
	var PendingTaskNotice = __webpack_require__(161);
	
	__webpack_require__(3701);
	
	var GoogleSync = function (_React$Component) {
		_inherits(GoogleSync, _React$Component);
	
		function GoogleSync(props) {
			_classCallCheck(this, GoogleSync);
	
			var _this = _possibleConstructorReturn(this, (GoogleSync.__proto__ || Object.getPrototypeOf(GoogleSync)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("GoogleSync");
			_this.state = {
				loading: false, loadingDataStores: false,
				dependenciesLoaded: false, rosterData: null,
				teacherEmail: "", error: false, syncMessage: null
			};
			return _this;
		}
	
		_createClass(GoogleSync, [{
			key: "handleAuthClick",
			value: function handleAuthClick() {
				this.refs.errors.reset();
				this.setState({ loading: true, syncMessage: "Select your Google Account" });
				GoogleClassroomSync.beginSync(this.onSyncSuccess, this.onSyncMessageUpdate);
			}
		}, {
			key: "onSyncSuccess",
			value: function onSyncSuccess(success, teacherData, rosterData, errorMessage) {
				if (success) {
					this.setState({ loading: false, syncMessage: null, rosterData: rosterData });
					this.savePendingRoster(rosterData, teacherData.google_sso_id);
				} else {
					this.refs.errors.setError(errorMessage);
					this.setState({ loading: false });
				}
			}
		}, {
			key: "onSyncMessageUpdate",
			value: function onSyncMessageUpdate(message) {
				this.setState({ syncMessage: message });
			}
		}, {
			key: "savePendingRoster",
			value: function savePendingRoster(rosterData, teacherGoogleID) {
				var accessToken = CurrentUser.getToken();
				var uploadData = {
					access_token: accessToken,
					roster_data: JSON.stringify(rosterData),
					teacher_google_id: teacherGoogleID,
					store: true
				};
	
				this.submitRoster(uploadData);
			}
		}, {
			key: "submitRoster",
			value: function submitRoster(uploadData, callback) {
				var syncURL = WhooosReadingServices.SsoServer.url("/google_classroom_sync");
				$.post(syncURL, uploadData);
			}
		}, {
			key: "finalizeRoster",
			value: function finalizeRoster(updatedRosterData) {
				var accessToken = CurrentUser.getToken();
	
				var uploadData = {
					access_token: accessToken,
					roster_data: JSON.stringify(updatedRosterData),
					create: true
				};
	
				this.submitRoster(uploadData);
	
				var studentCount = 0;
				_.each(updatedRosterData, function (section) {
					studentCount += section.students.length;
				});
				this.props.onUpload(studentCount, false, PendingTaskNotice.GOOGLE_SYNC);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.loadingDataStores) {
					var section = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
	
					// ALLOW GOOGLE SYNC AT ALL TIMES
					if (this.state.dependenciesLoaded) {
	
						// DISPLAY DIFFERENT BTN MESSAGES BASED ON 3 STATES. NO SYNC, SYNCED WITH DATE, SYNCED BUT NO DATE
						if (this.state.lastUpdate) {
							var lastUpdate = new Date(this.state.lastUpdate);
							var btnText = "Refresh classes - last update: " + lastUpdate.toLocaleDateString();
						} else if (!this.state.rosterData == null) {
							var btnText = "Sync new classes";
						} else {
							var btnText = "Connect Google Classroom";
						}
	
						var button = React.createElement(LoadingButton, { text: btnText, className: "btn buttonPrimary",
							loading: this.state.loading, onClick: this.handleAuthClick });
					} else {
						var button = React.createElement(Spinner, { placeholder: true });
					}
	
					if (this.state.rosterData == null) {
						var syncMessage = this.state.syncMessage;
						if (this.state.loading && this.state.syncMessage) {
							var textDisplay = React.createElement(
								"p",
								{ className: "loadingText" },
								React.createElement(
									"em",
									null,
									"Connecting your Google Classroom Account..."
								)
							);
						} else {
							var textDisplay = React.createElement(
								"div",
								null,
								React.createElement(
									"p",
									{ className: "googleClassroomText" },
									"Connect your Google Classroom account to upload your classes and students."
								)
							);
						}
	
						var section = React.createElement(
							"div",
							{ className: "googleClassroomStepOne" },
							textDisplay,
							button
						);
					} else {
						var section = React.createElement(
							"div",
							{ className: "googleClassroomStepTwo" },
							React.createElement(SSORosterReview, { rosterData: this.state.rosterData,
								finalizeRoster: this.finalizeRoster,
								method: SSORosterReview.GOOGLE_SYNC,
								studentCount: this.props.studentCount }),
							button
						);
					}
				}
	
				// } else if (this.state.rosterData == null) {
				// 	if (this.state.dependenciesLoaded) {
				// 		var button = (
				// 			<LoadingButton text="Connect Google Classroom" className="btn buttonPrimary"
				// 				loading={ this.state.loading } onClick={ this.handleAuthClick } />
				// 		);
				// 	} else {
				// 		var button = (
				// 			<Spinner placeholder={ true } />
				// 		);
				// 	}
				// 	var syncMessage = this.state.syncMessage;
				// 	if (this.state.loading && this.state.syncMessage) {
				// 		var textDisplay = (
				// 			<p className="loadingText">
				// 				<em>Connecting your Google Classroom Account...</em>
				// 			</p>
				// 		);
				// 	} else {
				// 		var textDisplay = (
				// 			<div>
				// 				<p className="googleClassroomText">
				// 					Connect your Google Classroom account to upload your classes and students.
				// 				</p>
				// 			</div>
				// 		)
				// 	}
	
				// 	var section = (
				// 		<div className="googleClassroomStepOne">
				// 			{ textDisplay }
				// 			{ button }
				// 		</div>
				// 	);
	
	
				// } else {
				// 	var section = (
				// 		<div className="googleClassroomStepTwo">
				// 			<SSORosterReview rosterData={ this.state.rosterData } lastUpdate={this.state.lastUpdate}
				// 				finalizeRoster={ this.finalizeRoster }
				// 				method={ SSORosterReview.GOOGLE_SYNC }
				// 				studentCount={ this.props.studentCount } />
				// 		</div>
				// 	)
				// }
	
				return React.createElement(
					"div",
					{ className: "googleClassroomView" },
					React.createElement(ErrorDisplay, { ref: "errors" }),
					section
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				$wr.loadScript("https://apis.google.com/js/client.js", "gapi", function () {
					this.setState({ dependenciesLoaded: true });
				}.bind(this));
	
				this.setState({ loadingDataStores: true });
				var embeds = "user.pending_data_stores";
	
				var userID = CurrentUser.get().id;
				CurrentUser.api().getUser(userID, { embed: embeds }, $wr.apiHandler(function (response) {
					var googleSyncStore = _.findWhere(response.user.pending_data_stores, {
						type: "google-sync"
					});
	
					if (googleSyncStore) {
						_this2.setState({ rosterData: googleSyncStore.data, lastUpdate: googleSyncStore.updated_at, loadingDataStores: false });
					} else {
						_this2.setState({ loadingDataStores: false });
					}
				}));
			}
		}]);
	
		return GoogleSync;
	}(React.Component);
	
	;
	
	GoogleSync.propTypes = StrictPropTypes({
		onUpload: PropTypes.func.isRequired,
		currentStudentLists: PropTypes.array,
		studentCount: PropTypes.number
	});
	
	module.exports = GoogleSync;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropDownOptions = __webpack_require__(26);
	var LoadingButton = __webpack_require__(17);
	var CurrentUser = __webpack_require__(3);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var ManualAddStudents = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			defaultGradeLevel: parseInt(CurrentUser.get().grade_level) || 1,
			studentLists: RosterSelectors.studentLists({ state: state })
		};
	}, function (dispatch, props) {
		return {
			createRoster: function createRoster(studentsData) {
				var data = {
					studentsData: studentsData,
					noBackground: true
				};
				// // I think this might enable uploading as a wizard
				// if (props.effectiveUserID) {
				// 	data["effective_user_id"] = this.props.effectiveUserID;
				// }
	
				return dispatch(RosterActions.postRosters(data));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ManualAddStudents, _React$Component);
	
		function ManualAddStudents(props) {
			_classCallCheck(this, ManualAddStudents);
	
			var _this = _possibleConstructorReturn(this, (ManualAddStudents.__proto__ || Object.getPrototypeOf(ManualAddStudents)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ManualAddStudents");
	
			_this.state = _extends({}, _this.getInitialState(), {
	
				// If set, shows only one class. Don't override when resetting
				shownStudentListID: props.defaultStudentListID
			});
			return _this;
		}
	
		_createClass(ManualAddStudents, [{
			key: "getInitialState",
			value: function getInitialState() {
				return {
					byStudentListID: {
						// Keys: name, gradeLevel, firstNamesOnly
					},
	
					errors: {
						// Keys: Student list IDs + 'button'
					},
	
					// For batch upload
					loading: false,
					uploadProgressCount: null,
					uploadTotalCount: null
				};
			}
		}, {
			key: "isVisibleStudentListID",
			value: function isVisibleStudentListID(studentListID) {
				return this.state.shownStudentListID && this.state.shownStudentListID !== studentListID;
			}
		}, {
			key: "submitStudents",
			value: function submitStudents() {
				var _this2 = this;
	
				var errors = {};
	
				var firstNames = [];
				var lastNames = [];
				var studentLists = [];
				var schoolOrgIDs = [];
				var gradeLevels = [];
	
				_.each(this.props.studentLists, function (studentList) {
					if (_this2.isVisibleStudentListID(studentList.id)) {
						return;
					}
					var slData = _this2.state.byStudentListID[studentList.id] || {};
	
					var studentNames = slData.names || "";
					var gradeLevel = slData.gradeLevel || _this2.props.defaultGradeLevel;
					var firstNamesOnly = !!slData.firstNamesOnly;
	
					if (firstNamesOnly) {
						var singleFirstNames = formatStudentNames(studentNames, /[\n\t\,]/);
	
						firstNames = firstNames.concat(singleFirstNames);
						lastNames = lastNames.concat(singleFirstNames.map(function () {
							return $wr.Constants.FILLER_LAST_NAME;
						}));
						studentLists = studentLists.concat(singleFirstNames.map(function () {
							return studentList.name;
						}));
						schoolOrgIDs = schoolOrgIDs.concat(singleFirstNames.map(function () {
							return studentList.school_org_id;
						}));
						gradeLevels = gradeLevels.concat(singleFirstNames.map(function () {
							return gradeLevel;
						}));
					} else {
						var studentLines = formatStudentNames(studentNames, /[\n]/);
	
						var namePairs = [];
						studentLines.forEach(function (studentLine) {
							var splitLines = formatStudentLines(studentLine, studentLines.length);
	
							splitLines.forEach(function (student) {
								if (student.trim().length == 0) {
									return;
								}
								var namePair = student.trim().split(/[\t ]/);
								var lastName = namePair.pop();
								var firstName = namePair.join(" ").replace(/^\d+\.\s+/, '');
								if (namePair.length >= 1) {
									lastNames.push(lastName);
									firstNames.push(firstName);
								}
	
								namePairs.push(namePair);
								studentLists.push(studentList.name);
								schoolOrgIDs.push(studentList.school_org_id);
								gradeLevels.push(gradeLevel);
							});
						});
						if (isNameMissing(namePairs)) {
							errors[studentList.id] = "Please enter a first and last name for each student.";
						}
					}
				});
	
				if (!firstNames.length && _.isEmpty(errors)) {
					errors["button"] = "Please enter at least one student's name.";
				} else if (_.isEmpty(errors)) {
					var studentsData = {
						first_name: firstNames, last_name: lastNames,
						classroom: studentLists, grade_level: gradeLevels
					};
	
					if (_.compact(schoolOrgIDs).length) {
						studentsData.school_org_id = schoolOrgIDs;
					}
	
					this.setState({
						loading: true,
						uploadProgressCount: 0,
						uploadTotalCount: studentsData.first_name.length
					}, function () {
						_this2.batchUploadStudents(studentsData, 0);
						_this2.props.onRosterUploadShowStatus(studentsData.first_name.length);
					});
				}
	
				this.setState({ errors: errors });
			}
		}, {
			key: "batchUploadStudents",
			value: function batchUploadStudents(studentsData, previousCount) {
				var _this3 = this;
	
				var BATCH_SIZE = 5;
				var COLUMNS = ["first_name", "last_name", "classroom", "grade_level", "school_org_id"];
	
				var theseStudents = {};
				var remainingStudents = {};
	
				_.each(COLUMNS, function (col) {
					if (studentsData[col]) {
						theseStudents[col] = _.first(studentsData[col], BATCH_SIZE);
						remainingStudents[col] = _.rest(studentsData[col], BATCH_SIZE);
					}
				});
	
				this.props.createRoster(theseStudents).then(function (response) {
					if (!response) {
						return;
					}
					var totalCount = previousCount + response.student_count;
	
					if (remainingStudents.first_name.length > 0) {
						_this3.setState({ uploadProgressCount: totalCount });
						_this3.batchUploadStudents(remainingStudents, totalCount);
					} else {
						_this3.setState(_this3.getInitialState(), function () {
							if (_this3.props.afterCreate) {
								// Take: Number of students, and if the students are
								//   already in created and should be fetched immediately
								_this3.props.afterCreate(totalCount, true, null, response.classrooms);
							}
						});
					}
				});
			}
		}, {
			key: "setValue",
			value: function setValue(studentListID, key, value) {
				this.setState({
					byStudentListID: _extends({}, this.state.byStudentListID, _defineProperty({}, studentListID, _extends({}, this.state.byStudentListID[studentListID], _defineProperty({}, key, value))))
				});
			}
		}, {
			key: "expandAllClasses",
			value: function expandAllClasses(e) {
				$wr.nope(e);
				this.setState({ shownStudentListID: null });
			}
		}, {
			key: "render",
			value: function render() {
				var _this4 = this;
	
				var sections = [];
				this.props.studentLists.forEach(function (studentList) {
					if (_this4.state.shownStudentListID) {
						if (_this4.isVisibleStudentListID(studentList.id)) {
							return;
						} else if (_this4.props.studentLists.length > 1) {
							var allClassesLink = React.createElement(
								"a",
								{ href: "#", className: "smallText", onClick: _this4.expandAllClasses },
								"View all"
							);
						}
					}
	
					var slData = _this4.state.byStudentListID[studentList.id] || {};
	
					var placeholder = slData.firstNamesOnly ? "Adam, Beth" : "Adam Apple, Beth Banks";
	
					var rowCount = Math.min(Math.max((slData.names || "").split("\n").length, 2), 8);
	
					if (_this4.state.errors[studentList.id]) {
						var slErrorMessage = React.createElement(
							"div",
							{ className: "errorRed smallText" },
							_this4.state.errors[studentList.id]
						);
					}
	
					sections.push(React.createElement(
						"div",
						{ className: "manualClass", key: studentList.id },
						React.createElement(
							"div",
							null,
							React.createElement(
								"strong",
								null,
								studentList.name
							),
							" ",
							allClassesLink
						),
						slErrorMessage,
						React.createElement(
							"div",
							{ className: "textAreaForm" },
							React.createElement(
								"span",
								{ className: "inputFieldTitle" },
								"Names"
							),
							React.createElement("textarea", { value: slData.names || "",
								onChange: function onChange(e) {
									return _this4.setValue(studentList.id, "names", e.target.value);
								},
								className: "form-control studentsTextArea",
								rows: rowCount,
								cols: "20",
								placeholder: placeholder,
								autoComplete: "off",
								autoCorrect: "off",
								autoCapitalize: "off",
								spellCheck: "false" })
						),
						React.createElement(
							"div",
							{ className: "rightOps" },
							React.createElement(
								"div",
								{ className: "gradeLevelContainer" },
								React.createElement(
									"span",
									{ className: "inputFieldTitle" },
									"Grade"
								),
								React.createElement(
									"select",
									{ value: slData.gradeLevel || _this4.props.defaultGradeLevel,
										onChange: function onChange(e) {
											return _this4.setValue(studentList.id, "gradeLevel", e.target.value);
										},
										className: "form-control" },
									DropDownOptions.Select.GradeLevels()
								)
							),
							React.createElement(
								"label",
								{ className: "normal firstNamesOnly" },
								React.createElement("input", { checked: !!slData.firstNamesOnly,
									onChange: function onChange(e) {
										return _this4.setValue(studentList.id, "firstNamesOnly", !slData.firstNamesOnly);
									},
									type: "checkbox" }),
								" ",
								"Use student first names only"
							)
						)
					));
				});
	
				if (this.state.errors['button']) {
					var buttonErrorMessage = React.createElement(
						"p",
						{ className: "errorRed smallText" },
						this.state.errors['button']
					);
				}
	
				if (this.state.uploadProgressCount != undefined) {
					var uploadProgress = React.createElement(
						"p",
						{ className: "lightGray smallText" },
						this.state.uploadProgressCount,
						" of ",
						this.state.uploadTotalCount,
						" uploaded..."
					);
				}
	
				return React.createElement(
					"div",
					{ className: "manualAddStudents addStudentMethod" },
					React.createElement(
						"p",
						null,
						"Type or paste students' names here. For multiple students, use separate lines or a comma. For multiple grades or classes, repeat this process."
					),
					sections,
					React.createElement(
						"div",
						{ className: "text-center" },
						buttonErrorMessage,
						uploadProgress,
						React.createElement(LoadingButton, { className: "buttonSuccess",
							text: "Add Students",
							onClick: this.submitStudents,
							loading: this.state.loading })
					)
				);
			}
		}]);
	
		return ManualAddStudents;
	}(React.Component)) || _class);
	;
	
	// Helper methods for generating roster upload
	
	function isNameMissing(namePairs) {
		return _.map(namePairs, function (pair) {
			return pair.length >= 1;
		}).includes(false);
	}
	
	function formatStudentLines(studentLine, studentLinesLength) {
		var splitLines = studentLine.split(",");
		if (splitLines.length == 2 && studentLinesLength > 1) {
			splitLines.reverse();
			splitLines = [splitLines.join(" ")];
		}
		return splitLines;
	}
	
	function formatStudentNames(studentNames, splitRegex) {
		var names = studentNames.split(splitRegex);
		return _.reject(names, function (s) {
			return s.trim().length == 0;
		});
	}
	
	ManualAddStudents.WrappedComponent.propTypes = StrictPropTypes({
		// From above
		defaultStudentListID: PropTypes.number,
		afterCreate: PropTypes.func,
	
		// Data from @connect
		defaultGradeLevel: PropTypes.number,
		studentLists: PropTypes.array,
	
		// Handlers from @connect
		createRoster: PropTypes.func,
		onRosterUploadShowStatus: PropTypes.func
	});
	
	module.exports = ManualAddStudents;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterUploadProgressMeter = __webpack_require__(162);
	var RosterUploadButtons = __webpack_require__(191);
	var Glyphicon = __webpack_require__(8);
	var StudentRoster = __webpack_require__(178);
	var CurrentUser = __webpack_require__(3);
	var GradeLevel = __webpack_require__(40);
	
	var RosterUploadClasses = function (_React$Component) {
		_inherits(RosterUploadClasses, _React$Component);
	
		function RosterUploadClasses(props) {
			_classCallCheck(this, RosterUploadClasses);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadClasses.__proto__ || Object.getPrototypeOf(RosterUploadClasses)).call(this));
	
			autobind(_this);
			_this.state = {
				editMode: false
			};
			return _this;
		}
	
		_createClass(RosterUploadClasses, [{
			key: "toggleEditMode",
			value: function toggleEditMode(e) {
				$wr.nope(e);
				this.setState({ editMode: !this.state.editMode }, function () {
					$(window).trigger("resize");
				});
			}
		}, {
			key: "confirmChanges",
			value: function confirmChanges() {
				var mapValues = {};
				var $selects = $(this.refs.table).find("[data-classroom]");
	
				_.each($selects, function (select) {
					var origClassroom = $(select).data("classroom");
					var newVal = $(select).val();
					mapValues[origClassroom] = newVal;
				});
	
				var mappedRosterData = this.props.roster.mapColumnValues(StudentRoster.Columns.CLASSROOM, mapValues);
	
				this.props.updateRosterData(mappedRosterData, function () {
					this.setState({ editMode: false });
				}.bind(this));
			}
	
			// Takes a single string name and deduces title and names
	
		}, {
			key: "deduceNameData",
			value: function deduceNameData(name) {
				var nameData = {};
	
				// Handle "Last, First format"
				if (name.indexOf(",") != -1) {
					name = name.split(",").reverse().join(" ");
				}
	
				var names = _.compact(name.split(" "));
				nameData.lastName = names.pop() || "???";
				if (names.length > 0 && _.includes($wr.Constants.TITLES, names[0])) {
					nameData.title = names.shift();
				}
	
				nameData.firstName = names.length > 0 ? names.join(" ") : "???";
				return nameData;
			}
		}, {
			key: "hasKindergartenOrPreK",
			value: function hasKindergartenOrPreK(gradeLevels) {
				return _.includes(gradeLevels, "-1") || _.includes(gradeLevels, "0");
			}
		}, {
			key: "renderRosterStatus",
			value: function renderRosterStatus() {
				var gradeLevels = _.compact(this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL));
				if (this.hasKindergartenOrPreK(gradeLevels)) {
					return React.createElement(
						"p",
						null,
						React.createElement(Glyphicon, { icon: "exclamation-sign", className: "alertMark" }),
						" ",
						React.createElement(
							"em",
							null,
							"You have Kindergarten or Pre-K classes in your roster. If you have AM/PM sections, please make sure that they're listed separately in the table below. You may have to modify the teacher names in your original roster file to make sure that they are correctly separated."
						)
					);
				}
			}
		}, {
			key: "renderTableHeader",
			value: function renderTableHeader() {
				if (CurrentUser.isSchoolAdmin()) {
					var extraCells = [React.createElement(
						"th",
						{ key: "title" },
						"Title"
					), React.createElement(
						"th",
						{ key: "firstName" },
						"First Name"
					), React.createElement(
						"th",
						{ key: "lastName" },
						"Last Name"
					), React.createElement(
						"th",
						{ key: "email" },
						"Email"
					)];
				}
				return React.createElement(
					"tr",
					null,
					React.createElement(
						"th",
						null,
						"Class Name"
					),
					extraCells,
					React.createElement(
						"th",
						null,
						"Grade"
					),
					React.createElement(
						"th",
						null,
						"Students"
					)
				);
			}
		}, {
			key: "renderTableRows",
			value: function renderTableRows() {
				var classrooms = this.props.roster.getColumn(StudentRoster.Columns.CLASSROOM);
				classrooms = _.compact(classrooms).sort();
	
				return _.map(_.uniq(classrooms), function (classroom) {
					var classCount = _.select(classrooms, function (oClassroom) {
						return oClassroom == classroom;
					}).length;
	
					var sampleCell = React.createElement(
						"td",
						{ className: "csvSampleText" },
						classCount
					);
					var gradeLevels = this.props.roster.getClassroomGradeLevels(classroom);
					var gradeLevelText = $wr.toSentence(_.map(gradeLevels, function (gradeLevel) {
						return GradeLevel.getName(gradeLevel);
					}));
					if (this.hasKindergartenOrPreK(gradeLevels)) {
						var alertIcon = React.createElement(Glyphicon, { icon: "exclamation-sign", className: "alertMark" });
					}
	
					var teacherEmail = this.props.roster.getClassroomTeacherEmail(classroom);
	
					if (this.state.editMode) {
						if (CurrentUser.isSchoolAdmin()) {
							if (teacherEmail) {
								var emailMessage = React.createElement(
									"span",
									null,
									teacherEmail
								);
							} else {
								var emailMessage = React.createElement(
									"em",
									null,
									"Add email to roster file"
								);
							}
	
							var extraCells = [React.createElement(
								"td",
								{ colSpan: 3, key: "name" },
								React.createElement(
									"em",
									null,
									"Edit class name to change teacher name"
								)
							), React.createElement(
								"td",
								{ key: "email" },
								emailMessage
							)];
						}
	
						var gradeLevels = this.props.roster.getClassroomGradeLevels(classroom);
						var gradeLevelText = $wr.toSentence(_.map(gradeLevels, function (gradeLevel) {
							return GradeLevel.getName(gradeLevel);
						}));
						if (this.hasKindergartenOrPreK(gradeLevels)) {
							var alertIcon = React.createElement(Glyphicon, { icon: "exclamation-sign", className: "alertMark" });
						}
	
						return React.createElement(
							"tr",
							{ key: classroom },
							React.createElement(
								"td",
								null,
								React.createElement("input", { type: "text", "data-classroom": classroom,
									defaultValue: classroom, className: "form-control" })
							),
							extraCells,
							React.createElement(
								"td",
								null,
								alertIcon,
								" ",
								gradeLevelText
							),
							sampleCell
						);
					} else {
						if (CurrentUser.isSchoolAdmin()) {
							var nameData = this.deduceNameData(classroom);
							var extraCells = [React.createElement(
								"td",
								{ key: "title" },
								nameData.title
							), React.createElement(
								"td",
								{ key: "firstName" },
								nameData.firstName
							), React.createElement(
								"td",
								{ key: "lastName" },
								nameData.lastName
							), React.createElement(
								"td",
								{ key: "email" },
								teacherEmail
							)];
						}
	
						return React.createElement(
							"tr",
							{ key: classroom },
							React.createElement(
								"td",
								null,
								classroom
							),
							extraCells,
							React.createElement(
								"td",
								null,
								alertIcon,
								" ",
								gradeLevelText
							),
							sampleCell
						);
					}
				}.bind(this));
			}
		}, {
			key: "render",
			value: function render() {
				var classCount = _.uniq(this.props.roster.getColumn(StudentRoster.Columns.CLASSROOM)).length;
				return React.createElement(
					"div",
					{ className: "uploadManager" },
					React.createElement(RosterUploadProgressMeter, { index: 3 }),
					this.renderRosterStatus(),
					React.createElement(
						"p",
						null,
						"Your roster has ",
						classCount,
						" ",
						$wr.pluralize("class", classCount, "classes"),
						"."
					),
					React.createElement(RosterUploadButtons, { noun: "Classrooms",
						editMode: this.state.editMode,
						nextStage: this.props.nextStage,
						toggleEditMode: this.toggleEditMode,
						confirmChanges: this.confirmChanges }),
					React.createElement(
						"table",
						{ className: "table table-striped table-bordered csvConfirmTable", ref: "table" },
						React.createElement(
							"tbody",
							null,
							this.renderTableHeader(),
							this.renderTableRows()
						)
					)
				);
			}
		}]);
	
		return RosterUploadClasses;
	}(React.Component);
	
	;
	
	RosterUploadClasses.propTypes = StrictPropTypes({
		nextStage: PropTypes.func.isRequired,
		updateRosterData: PropTypes.func.isRequired,
	
		// Instance of StudentRoster.js
		roster: PropTypes.object.isRequired
	});
	
	module.exports = RosterUploadClasses;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterUploadProgressMeter = __webpack_require__(162);
	var RosterUploadButtons = __webpack_require__(191);
	var Glyphicon = __webpack_require__(8);
	var StudentRoster = __webpack_require__(178);
	
	var RosterUploadColumns = function (_React$Component) {
		_inherits(RosterUploadColumns, _React$Component);
	
		function RosterUploadColumns(props) {
			_classCallCheck(this, RosterUploadColumns);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadColumns.__proto__ || Object.getPrototypeOf(RosterUploadColumns)).call(this));
	
			autobind(_this);
			_this.state = {
				editMode: _this.forceEdits(props)
			};
			return _this;
		}
	
		_createClass(RosterUploadColumns, [{
			key: "toggleEditMode",
			value: function toggleEditMode(e) {
				$wr.nope(e);
				this.setState({ editMode: !this.state.editMode }, function () {
					$(window).trigger("resize");
				});
			}
		}, {
			key: "forceEdits",
			value: function forceEdits(props) {
				var props = props || this.props;
				return !props.roster.hasAllRequiredColumns();
			}
		}, {
			key: "splitNameColumn",
			value: function splitNameColumn() {
				var mappedRosterData = this.props.roster.splitNameColumn();
				this.props.updateRosterData(mappedRosterData, function () {
					this.setState({ editMode: this.forceEdits() });
				}.bind(this));
			}
		}, {
			key: "confirmChanges",
			value: function confirmChanges() {
				var mapValues = {};
				var $selects = $(this.refs.colValues).find("[data-col]");
	
				_.each($selects, function (select) {
					var origCol = $(select).data("col");
					var newVal = $(select).val();
					mapValues[origCol] = newVal;
				});
	
				var mappedRosterData = this.props.roster.mapColumns(mapValues);
				this.props.updateRosterData(mappedRosterData, function () {
					this.setState({ editMode: this.forceEdits() });
				}.bind(this));
			}
		}, {
			key: "renderIncompleteStudents",
			value: function renderIncompleteStudents() {
				var missingLines = [];
				var incompleteStudents = this.props.roster.studentsMissingColumns();
				_.each(StudentRoster.Columns.REQUIRED_COLUMNS, function (col) {
					var totalMissing = 0;
					var firstMissing = null;
	
					_.each(incompleteStudents, function (missingData) {
						if (_.includes(missingData.missingColumns, col)) {
							totalMissing += 1;
							if (firstMissing == undefined) {
								firstMissing = missingData;
							}
						}
					});
	
					if (firstMissing != undefined) {
						if (totalMissing > 1) {
							var missingDetails = "and other " + (totalMissing - 1) + $wr.pluralize(" row", totalMissing - 1);
						} else {
							var missingDetails = "is";
						}
						missingLines.push(React.createElement(
							"li",
							null,
							React.createElement(
								"em",
								null,
								firstMissing.studentSummary
							),
							React.createElement("br", null),
							React.createElement("span", { className: "spacer4" }),
							missingDetails,
							" misssing the column \"",
							col,
							".\""
						));
					}
				}.bind(this));
	
				return missingLines;
			}
		}, {
			key: "renderExtraColumnAlerts",
			value: function renderExtraColumnAlerts() {
				var roster = this.props.roster;
				var badEmails = roster.invalidParentEmails();
				if (badEmails && badEmails.length > 0) {
					if (badEmails.length == 0) {
						var badEmailText = '1 invalid parent email address, "' + badEmails[0] + '."';
					} else {
						var badEmailText = badEmails.length + ' invalid parent email addresses, like "' + badEmails[0] + '."';
					}
	
					var badEmailDisplay = React.createElement(
						"p",
						{ className: "text-smaller alertIndent" },
						React.createElement(Glyphicon, { icon: "exclamation-sign alertMark" }),
						" ",
						badEmailText,
						" The associated student ",
						$wr.pluralize("account", badEmails.length),
						" will still be created."
					);
				}
	
				var usernames = roster.validUsernames();
				if (usernames && usernames.length > 0) {
					var usernameDisplay = React.createElement(
						"p",
						{ className: "text-smaller alertIndent" },
						React.createElement(Glyphicon, { icon: "exclamation-sign alertMark" }),
						" Your roster has custom usernames. Since usernames have to be unique across all the students on the website, it is possible your usernames will have to be modified. For example, if a student with the username ",
						React.createElement(
							"strong",
							null,
							usernames[0]
						),
						" already exists, your student may get the username ",
						React.createElement(
							"strong",
							null,
							usernames[0],
							"-1"
						),
						"."
					);
				}
	
				var badPasswords = roster.invalidPasswords();
				if (badPasswords && badPasswords.length > 0) {
					badPasswords = _.sortBy(badPasswords, "length");
					var betterPassword = badPasswords[0];
					while (betterPassword.length < StudentRoster.MIN_PASSWORD_LENGTH) {
						betterPassword += "0";
					}
	
					var badPasswordDisplay = React.createElement(
						"p",
						{ className: "text-smaller alertIndent" },
						React.createElement(Glyphicon, { icon: "exclamation-sign alertMark" }),
						" Your roster has some custom passwords that are too short. These will be increased in length by adding '0's to the end. For example, the password ",
						React.createElement(
							"strong",
							null,
							badPasswords[0]
						),
						" will be extended to ",
						React.createElement(
							"strong",
							null,
							betterPassword
						),
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					badEmailDisplay,
					usernameDisplay,
					badPasswordDisplay
				);
			}
		}, {
			key: "renderRosterStatus",
			value: function renderRosterStatus() {
				var roster = this.props.roster;
				if (roster.hasCombinedNameColumn()) {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "redBold" },
							"Uh oh! It looks like you may have combined \"First Name\" and \"Last Name\" columns into one column. If you want us to try to separate the names for you automatically, ",
							React.createElement(
								"a",
								{ href: "#", onClick: this.splitNameColumn },
								"click this link"
							),
							"."
						),
						React.createElement(
							"p",
							{ className: "redBold" },
							"Otherwise, manually edit your student roster file and upload it again."
						)
					);
				} else if (!roster.hasAllRequiredColumns()) {
					var missingCols = _.map(roster.missingColumns(), function (col) {
						return React.createElement(
							"li",
							{ key: col },
							col
						);
					});
					var unrecognizedCols = _.map(roster.unrecognizedColumns(), function (col) {
						return React.createElement(
							"li",
							{ key: col },
							col
						);
					});
	
					if (unrecognizedCols.length > 0) {
						var unrecognizedContent = React.createElement(
							"div",
							null,
							React.createElement(
								"p",
								{ className: "redBold" },
								"There were unrecognized ",
								unrecognizedCols.length,
								$wr.pluralize("column", unrecognizedCols.length),
								". Please use the dropdown menus to match the columns with the correct headers."
							),
							React.createElement(
								"ul",
								{ className: "move-in disc" },
								unrecognizedCols
							)
						);
					}
	
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "redBold" },
							"Uh oh! Your roster is missing some required columns:"
						),
						React.createElement(
							"ul",
							{ className: "move-in disc" },
							missingCols
						),
						React.createElement(
							"p",
							{ className: "redBold" },
							"If the missing fields just aren't present on your roster, you'll have to edit your CSV and upload it again on the previous page."
						)
					);
				} else if (!roster.allStudentsHaveRequiredColumns()) {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "redBold" },
							"Oh no! Some of your student rows are missing required columns. If you proceed, the following students will not get accounts:"
						),
						React.createElement(
							"ul",
							{ className: "move-in disc" },
							this.renderIncompleteStudents()
						),
						React.createElement(
							"p",
							{ className: "redBold" },
							"If you want to make accounts for these students, you will have to edit your spreadsheet to add the missing data and upload it again on the previous page."
						)
					);
				} else {
					return React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Your roster has all required columns and your students look good to go!"
						),
						this.renderExtraColumnAlerts()
					);
				}
			}
		}, {
			key: "renderTableHeader",
			value: function renderTableHeader() {
				var roster = this.props.roster;
	
				if (this.state.editMode) {
					var colOptions = _.map(StudentRoster.Columns.VISIBLE_COLUMNS, function (col) {
						return React.createElement(
							"option",
							{ key: col, value: col },
							col
						);
					});
				}
	
				var cells = _.map(roster.currentColumns(), function (col) {
					var unrecognized = roster.isUnknownColumn(col);
					var optional = roster.isOptionalColumn(col);
					var hidden = roster.isHiddenColumn(col);
					var required = roster.isRequiredColumn(col);
					var tooltipID = "confirmColumn" + col;
	
					if (unrecognized) {
						var icon = React.createElement(Glyphicon, { icon: "question-sign", dataTip: "Unknown Column" });
					} else if (optional || hidden) {
						var icon = React.createElement(Glyphicon, { icon: "ok-circle", dataTip: "Optional Column" });
					} else if (required) {
						var icon = React.createElement(Glyphicon, { icon: "ok", dataTip: "Required Column" });
					} else {
						throw "Shouldn't get here";
					}
	
					if (this.state.editMode) {
						var defaultValue = roster.isUnknownColumn(col) ? StudentRoster.Columns.IGNORE : col;
	
						if (roster.isHiddenColumn(col)) {
							colOptions = colOptions.concat([React.createElement(
								"option",
								{ key: col, value: col },
								col
							)]);
						}
	
						return React.createElement(
							"th",
							{ key: col },
							React.createElement(
								"select",
								{ defaultValue: defaultValue, className: "form-control", "data-col": col },
								colOptions
							)
						);
					} else {
						return React.createElement(
							"th",
							{ key: col, className: unrecognized ? "unrecognized" : "" },
							icon,
							" ",
							col
						);
					}
				}.bind(this));
	
				return React.createElement(
					"tr",
					{ ref: "colValues" },
					cells
				);
			}
		}, {
			key: "renderTableRows",
			value: function renderTableRows() {
				var roster = this.props.roster;
				var sampleRowCount = 3;
	
				var rows = [];
				for (var i = 0; i < sampleRowCount; i++) {
					var cells = _.map(roster.currentColumns(), function (col) {
						return React.createElement(
							"td",
							{ key: col, className: "csvSampleText" },
							roster.getValue(col, i)
						);
					});
					rows.push(React.createElement(
						"tr",
						{ key: i },
						cells
					));
				}
	
				var extraRowCount = roster.rowCount() - sampleRowCount;
				if (extraRowCount > 0) {
					rows.push(React.createElement(
						"tr",
						{ key: "more" },
						React.createElement(
							"td",
							{ colSpan: roster.currentColumns().length, className: "text-center" },
							React.createElement(
								"em",
								null,
								"... and ",
								extraRowCount,
								" more ",
								$wr.pluralize("row", extraRowCount),
								"..."
							)
						)
					));
				}
	
				return rows;
			}
		}, {
			key: "render",
			value: function render() {
				var roster = this.props.roster;
	
				return React.createElement(
					"div",
					{ className: "uploadManager" },
					React.createElement(RosterUploadProgressMeter, { index: 1 }),
					this.renderRosterStatus(),
					React.createElement(RosterUploadButtons, { noun: "Columns",
						editMode: this.state.editMode,
						forceEdits: this.forceEdits(),
						nextStage: this.props.nextStage,
						toggleEditMode: this.toggleEditMode,
						confirmChanges: this.confirmChanges }),
					React.createElement(
						"div",
						{ className: "tableWrap" },
						React.createElement(
							"table",
							{ className: "table table-striped table-bordered csvConfirmTable horiz" },
							React.createElement(
								"tbody",
								null,
								this.renderTableHeader(),
								this.renderTableRows()
							)
						)
					)
				);
			}
		}]);
	
		return RosterUploadColumns;
	}(React.Component);
	
	;
	
	RosterUploadColumns.propTypes = StrictPropTypes({
		nextStage: PropTypes.func.isRequired,
		updateRosterData: PropTypes.func.isRequired,
	
		// Instance of StudentRoster.js
		roster: PropTypes.object.isRequired
	});
	
	module.exports = RosterUploadColumns;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterUploadProgressMeter = __webpack_require__(162);
	var RosterUploadButtons = __webpack_require__(191);
	var StudentRoster = __webpack_require__(178);
	var CurrentUser = __webpack_require__(3);
	
	var RosterUploadConfirm = function (_React$Component) {
		_inherits(RosterUploadConfirm, _React$Component);
	
		function RosterUploadConfirm(props) {
			_classCallCheck(this, RosterUploadConfirm);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadConfirm.__proto__ || Object.getPrototypeOf(RosterUploadConfirm)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(RosterUploadConfirm, [{
			key: "render",
			value: function render() {
				var roster = this.props.roster;
	
				var rowCount = roster.rowCount();
				var studentCount = rowCount - roster.studentsMissingColumns().length;
				var gradeLevelCount = _.uniq(_.compact(roster.getColumn(StudentRoster.Columns.GRADE_LEVEL))).length;
				var classroomCount = _.uniq(_.compact(roster.getColumn(StudentRoster.Columns.CLASSROOM))).length;
	
				var parentEmailText = "No";
				if (roster.hasColumn(StudentRoster.Columns.PARENT_EMAIL)) {
					var count = _.select(roster.getColumn(StudentRoster.Columns.PARENT_EMAIL), function (email) {
						return email && $wr.isValidEmail(email);
					}).length;
					var parentEmailText = "Yes (" + count + ")";
				}
	
				var usernameText = "No";
				if (roster.hasColumn(StudentRoster.Columns.USERNAME)) {
					var count = _.select(roster.getColumn(StudentRoster.Columns.USERNAME), function (username) {
						return username && username.trim().length > 0;
					}).length;
					var usernameText = "Yes (" + count + ")";
				}
	
				var passwordText = "No";
				if (roster.hasColumn(StudentRoster.Columns.PASSWORD)) {
					var count = _.select(roster.getColumn(StudentRoster.Columns.PASSWORD), function (password) {
						return password && password.trim().length > 0;
					}).length;
					var passwordText = "Yes (" + count + ")";
				}
	
				if (CurrentUser.isSchoolAdmin()) {
					var teacherEmailText = "No";
					if (roster.hasColumn(StudentRoster.Columns.TEACHER_EMAIL)) {
						var teacherEmailText = "Yes";
					}
	
					var teacherEmails = React.createElement(
						"tr",
						null,
						React.createElement(
							"th",
							null,
							"Teacher Emails?"
						),
						React.createElement(
							"td",
							null,
							teacherEmailText
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "uploadManager" },
					React.createElement(RosterUploadProgressMeter, { index: 4 }),
					React.createElement(
						"p",
						null,
						"Please look over the table below and then click 'Finish' if everything looks correct."
					),
					React.createElement(RosterUploadButtons, { finalStage: true,
						nextStage: this.props.nextStage,
						confirmChanges: this.confirmChanges }),
					React.createElement(
						"div",
						{ className: "row" },
						React.createElement(
							"div",
							{ className: "col-sm-8 col-sm-offset-2" },
							React.createElement(
								"table",
								{ className: "table table-striped table-bordered csvConfirmTable" },
								React.createElement(
									"tbody",
									null,
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Students"
										),
										React.createElement(
											"td",
											null,
											rowCount
										)
									),
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Classrooms"
										),
										React.createElement(
											"td",
											null,
											classroomCount
										)
									),
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Grades"
										),
										React.createElement(
											"td",
											null,
											gradeLevelCount
										)
									),
									teacherEmails,
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Parent Emails?"
										),
										React.createElement(
											"td",
											null,
											parentEmailText
										)
									),
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Custom Usernames?"
										),
										React.createElement(
											"td",
											null,
											usernameText
										)
									),
									React.createElement(
										"tr",
										null,
										React.createElement(
											"th",
											null,
											"Custom Passwords?"
										),
										React.createElement(
											"td",
											null,
											passwordText
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return RosterUploadConfirm;
	}(React.Component);
	
	;
	
	RosterUploadConfirm.propTypes = StrictPropTypes({
		nextStage: PropTypes.func.isRequired,
		updateRosterData: PropTypes.func.isRequired,
	
		// Instance of StudentRoster.js
		roster: PropTypes.object.isRequired
	});
	
	module.exports = RosterUploadConfirm;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterUploadProgressMeter = __webpack_require__(162);
	var RosterUploadButtons = __webpack_require__(191);
	var Glyphicon = __webpack_require__(8);
	var DropDownOptions = __webpack_require__(26);
	var StudentRoster = __webpack_require__(178);
	var GradeLevel = __webpack_require__(40);
	var MappingControl = __webpack_require__(394);
	
	var RosterUploadGrades = function (_React$Component) {
		_inherits(RosterUploadGrades, _React$Component);
	
		function RosterUploadGrades(props) {
			_classCallCheck(this, RosterUploadGrades);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadGrades.__proto__ || Object.getPrototypeOf(RosterUploadGrades)).call(this));
	
			autobind(_this);
			_this.state = {
				editMode: _this.forceEdits(props)
			};
			return _this;
		}
	
		_createClass(RosterUploadGrades, [{
			key: "forceEdits",
			value: function forceEdits(props) {
				var props = props || this.props;
				return props.roster.invalidGradeLevels().length > 0;
			}
		}, {
			key: "toggleEditMode",
			value: function toggleEditMode(e) {
				$wr.nope(e);
				this.setState({ editMode: !this.state.editMode }, function () {
					$(window).trigger("resize");
				});
			}
		}, {
			key: "confirmChanges",
			value: function confirmChanges() {
				var mapValues = {};
				var $selects = $(this.refs.table).find("[data-grade-level]");
	
				_.each($selects, function (select) {
					var origGradeLevel = $(select).data("grade-level");
					var newVal = $(select).val();
					mapValues[origGradeLevel] = newVal;
				});
	
				var mappedRosterData = this.props.roster.mapColumnValues(StudentRoster.Columns.GRADE_LEVEL, mapValues);
	
				this.props.updateRosterData(mappedRosterData, function () {
					this.setState({ editMode: this.forceEdits() });
				}.bind(this));
			}
		}, {
			key: "archivedStudents",
			value: function archivedStudents() {
				return this.props.archivedStudents || [];
			}
		}, {
			key: "tryNextStage",
			value: function tryNextStage() {
				if (this.archivedStudents().length > 0) {
					if (confirm("Have you reviewed the existing student accounts?")) {
						var mergedRosterData = this.props.roster.mergeStudentIDs(_.invert(this.refs.mapper.getMapping()));
	
						this.props.updateRosterData(mergedRosterData, function () {
							this.props.nextStage();
						}.bind(this));
					}
				} else {
					this.props.nextStage();
				}
			}
		}, {
			key: "renderRosterStatus",
			value: function renderRosterStatus() {
				if (this.props.roster.invalidGradeLevels().length > 0) {
					return React.createElement(
						"p",
						{ className: "redBold" },
						"Your roster contained some unknown grade levels (the ones marked with ",
						React.createElement(Glyphicon, { icon: "question-sign", className: "unrecognized" }),
						"). Please edit these, so the student accounts will be created correctly."
					);
				}
			}
		}, {
			key: "renderTableHeader",
			value: function renderTableHeader() {
				return React.createElement(
					"tr",
					null,
					React.createElement(
						"th",
						{ className: "editCol", colSpan: 2 },
						"Grade Level"
					),
					React.createElement(
						"th",
						null,
						"Number of Students"
					)
				);
			}
		}, {
			key: "renderTableRows",
			value: function renderTableRows() {
				var gradeLevels = this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL);
				gradeLevels = _.compact(gradeLevels).sort();
				return _.map(_.uniq(gradeLevels), function (gradeLevel) {
					var valid = GradeLevel.isValid(gradeLevel);
					var glCount = _.select(gradeLevels, function (gl) {
						return gl == gradeLevel;
					}).length;
	
					var sampleCell = React.createElement(
						"td",
						{ className: "csvSampleText" },
						glCount
					);
	
					if (this.state.editMode) {
						var selectClassName = "form-control" + (valid ? "" : " unrecognized");
						return React.createElement(
							"tr",
							{ key: gradeLevel },
							React.createElement(
								"td",
								null,
								gradeLevel,
								React.createElement("span", { className: "spacer2" }),
								React.createElement(Glyphicon, { icon: "arrow-right" })
							),
							React.createElement(
								"td",
								null,
								React.createElement(
									"select",
									{ className: selectClassName, defaultValue: gradeLevel,
										"data-grade-level": gradeLevel },
									DropDownOptions.Select.GradeLevels()
								)
							),
							sampleCell
						);
					} else {
						if (valid) {
							var gradeContents = GradeLevel.getName(gradeLevel);
						} else {
							var gradeContents = React.createElement(
								"span",
								null,
								React.createElement(Glyphicon, { icon: "question-sign", className: "unrecognized" }),
								" ",
								gradeLevel
							);
						}
	
						return React.createElement(
							"tr",
							{ key: gradeLevel },
							React.createElement(
								"td",
								{ colSpan: 2 },
								gradeContents
							),
							sampleCell
						);
					}
				}.bind(this));
			}
		}, {
			key: "mapItemRenderer",
			value: function mapItemRenderer(item) {
				return React.createElement(
					"div",
					null,
					item.first_name,
					" ",
					item.last_name,
					React.createElement("br", null),
					React.createElement(
						"em",
						null,
						GradeLevel.getName(item.grade_level)
					)
				);
			}
		}, {
			key: "mapItemSorter",
			value: function mapItemSorter(list) {
				return _.sortBy(list, function (item) {
					return [$wr.padleft(item.grade_level, 2), item.last_name, item.first_name].join("_");
				});
			}
		}, {
			key: "mapItemMatcher",
			value: function mapItemMatcher(oldStudent, newStudent) {
				var points = 0;
				var maxPoints = 6;
	
				if (parseInt(oldStudent.grade_level) + 1 == parseInt(newStudent.grade_level)) {
					points += 2;
				}
	
				var oldFirst = (oldStudent.first_name || "").toLowerCase();
				var newFirst = (newStudent.first_name || "").toLowerCase();
				var oldLast = (oldStudent.last_name || "").toLowerCase();
				var newLast = (newStudent.last_name || "").toLowerCase();
	
				if (oldFirst == newFirst) {
					points += 2;
				} else if (oldFirst.includes(newFirst)) {
					points += 1;
				} else if (newFirst.includes(oldFirst)) {
					points += 1;
				}
	
				if (oldLast.length == 1 || newLast.length == 1) {
					if (oldLast.charAt(0) == newLast.charAt(0)) {
						points += 2;
					}
				} else {
					if (oldLast == newLast) {
						points += 2;
					} else if (oldLast.includes(newLast)) {
						points += 1;
					} else if (newLast.includes(oldLast)) {
						points += 1;
					}
				}
	
				return points / maxPoints;
			}
		}, {
			key: "renderArchivedMapper",
			value: function renderArchivedMapper() {
				return React.createElement(
					"div",
					{ className: "archivedMapper" },
					React.createElement(
						"p",
						null,
						"We've detected archived student accounts which should potentially be included in this upload. Please review:"
					),
					React.createElement(MappingControl, { ref: "mapper", keyAttr: "id", rightKeyAttr: "rosterIndex",
						left: this.archivedStudents(), right: this.props.roster.getStudents(),
						leftLabel: "Last year", rightLabel: "This year",
						itemRenderer: this.mapItemRenderer,
						initialMatcher: this.mapItemMatcher, itemSorter: this.mapItemSorter })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var gradeCount = _.uniq(this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL)).length;
	
				if (this.archivedStudents().length > 0) {
					var archivedMapper = this.renderArchivedMapper();
				}
	
				return React.createElement(
					"div",
					{ className: "uploadManager" },
					React.createElement(RosterUploadProgressMeter, { index: 2 }),
					this.renderRosterStatus(),
					React.createElement(
						"p",
						null,
						"Your roster has ",
						gradeCount,
						" grade ",
						$wr.pluralize("level", gradeCount),
						"."
					),
					React.createElement(RosterUploadButtons, { noun: "Grades Levels",
						editMode: this.state.editMode,
						forceEdits: this.forceEdits(),
						nextStage: this.tryNextStage,
						toggleEditMode: this.toggleEditMode,
						confirmChanges: this.confirmChanges }),
					React.createElement(
						"table",
						{ className: "table table-striped table-bordered csvConfirmTable", ref: "table" },
						React.createElement(
							"tbody",
							null,
							this.renderTableHeader(),
							this.renderTableRows()
						)
					),
					archivedMapper
				);
			}
		}]);
	
		return RosterUploadGrades;
	}(React.Component);
	
	;
	
	RosterUploadGrades.propTypes = StrictPropTypes({
		nextStage: PropTypes.func.isRequired,
		updateRosterData: PropTypes.func.isRequired,
	
		// Instance of StudentRoster.js
		roster: PropTypes.object.isRequired,
	
		// Students to consider porting over
		archivedStudents: PropTypes.array
	
	});
	
	module.exports = RosterUploadGrades;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var ErrorDisplay = __webpack_require__(51);
	var WhooosReadingServices = __webpack_require__(25);
	var CurrentUser = __webpack_require__(3);
	
	var RosterUploadInitial = function (_React$Component) {
		_inherits(RosterUploadInitial, _React$Component);
	
		function RosterUploadInitial(props) {
			_classCallCheck(this, RosterUploadInitial);
	
			var _this = _possibleConstructorReturn(this, (RosterUploadInitial.__proto__ || Object.getPrototypeOf(RosterUploadInitial)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false
			};
			return _this;
		}
	
		_createClass(RosterUploadInitial, [{
			key: "submitUpload",
			value: function submitUpload(e) {
				$wr.nope(e);
				this.refs.errors.reset();
	
				var ext = this.refs.file.value.split(".").pop().toLowerCase();
				var validExtensions = ["csv", "xls", "xlsx"];
	
				if (validExtensions.indexOf(ext) == -1) {
					this.refs.errors.setError("Please upload a CSV, XLS, or XLSX spreadsheet file.");
				} else {
					this.setState({ loading: true });
	
					var file = this.refs.file.files[0];
	
					var formData = new FormData();
					formData.append("file", file);
	
					CurrentUser.api().postRostersParse(null, { form: formData }, $wr.apiHandler(function (response) {
						this.props.updateRosterData(response.roster, function () {
							this.props.nextStage();
						}.bind(this));
					}.bind(this)));
				}
			}
		}, {
			key: "onTaskUpdate",
			value: function onTaskUpdate() {
				this.forceUpdate();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$(document).on('start_task', this.onTaskUpdate);
				$(document).on('task_finished_loading', this.onTaskUpdate);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(document).off('start_task', this.onTaskUpdate);
				$(document).off('task_finished_loading', this.onTaskUpdate);
			}
		}, {
			key: "render",
			value: function render() {
				if (window.pendingTaskRunning) {
					var loadingMessage = React.createElement(
						"p",
						{ className: "loadingText" },
						"Your students are still uploading, they will be added to your roster shortly."
					);
					var disabledClassName = "disabled";
				}
	
				var rosterImageURL = WhooosReadingServices.FileStation.url("/screenshots/roster-1.png");
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"form",
						{ encType: "multipart/form-data", method: "post", onSubmit: this.submitUpload },
						React.createElement(ErrorDisplay, { ref: "errors" }),
						React.createElement("input", { type: "text", style: { display: 'none' }, name: "process", defaultValue: this.props.process }),
						React.createElement("input", { type: "text", style: { display: 'none' }, name: "stage", defaultValue: this.props.stage }),
						React.createElement(
							"div",
							{ className: "uploadPair clearfix" },
							loadingMessage,
							React.createElement("input", { type: "file", name: "file", ref: "file", className: disabledClassName + " btn btn-default uploadField" }),
							React.createElement(LoadingButton, { className: disabledClassName + " btn buttonSuccess uploadSubmit", loading: this.state.loading, text: "Upload" })
						)
					),
					React.createElement(
						"div",
						{ className: "explanation" },
						React.createElement(
							"div",
							{ className: "textExplanation" },
							"The student roster needs to be either a CSV (ending in .csv) or Microsoft Excel file (ending in .xlsx or .xls) with headers for these columns:",
							React.createElement(
								"ol",
								null,
								React.createElement(
									"li",
									null,
									"First Name"
								),
								React.createElement(
									"li",
									null,
									"Last Name (or Initial)"
								),
								React.createElement(
									"li",
									null,
									"Grade Level"
								),
								React.createElement(
									"li",
									null,
									"Teacher Name"
								),
								React.createElement(
									"li",
									null,
									"Parent Email (optional)"
								),
								React.createElement(
									"li",
									null,
									"Username (optional)"
								),
								React.createElement(
									"li",
									null,
									"Password (optional)"
								)
							)
						),
						React.createElement(
							"div",
							{ className: "exampleTableSection" },
							React.createElement("img", { height: 169, src: rosterImageURL }),
							React.createElement(
								"span",
								{ className: "smallText formatText" },
								"(An example of a correctly formatted student roster.)"
							)
						)
					)
				);
			}
		}]);
	
		return RosterUploadInitial;
	}(React.Component);
	
	;
	
	RosterUploadInitial.propTypes = StrictPropTypes({
		nextStage: PropTypes.func.isRequired,
		updateRosterData: PropTypes.func.isRequired,
		roster: PropTypes.object
	});
	
	module.exports = RosterUploadInitial;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterUploadInitial = __webpack_require__(839);
	var RosterUploadColumns = __webpack_require__(836);
	var RosterUploadClasses = __webpack_require__(835);
	var RosterUploadGrades = __webpack_require__(838);
	var RosterUploadConfirm = __webpack_require__(837);
	var RosterUploadProgressMeter = __webpack_require__(162);
	var PendingTaskNotice = __webpack_require__(161);
	var CurrentUser = __webpack_require__(3);
	var StudentRoster = __webpack_require__(178);
	var Spinner = __webpack_require__(9);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3713);
	
	var UploadStudentRoster = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var studentLists = RosterSelectors.nonEmptyStudentLists({ state: state });
		var methodOptions = STAGES;
	
		// remove Google if using Clever, otherwise remove Clever
		if (CurrentUser.isCleverSSOUser()) {
			methodOptions = _.without(methodOptions, GOOGLE);
		} else {
			methodOptions = _.without(methodOptions, CLEVER);
		}
	
		// also remove Google & clever option for non teacherAdmins
		if (!CurrentUser.isTeacherAdmin()) {
			methodOptions = _.without(methodOptions, GOOGLE);
			methodOptions = _.without(methodOptions, CLEVER);
		}
	
		if (!(CurrentUser.isTeacherAdmin() || CurrentUser.isWizard())) {
			methodOptions = _.without(methodOptions, UPLOAD);
		}
	
		return {
			methodOptions: methodOptions, studentLists: studentLists,
			effectiveUserID: CurrentUser.get().id
		};
	}, function (dispatch, props) {
		return {
			uploadRoster: function uploadRoster(studentsData) {
	
				var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id;
	
				return dispatch(RosterActions.postRosters({ studentsData: studentsData, effectiveUserID: effectiveUserID })).then(function (response) {
					$(window.document).trigger("onboarding-trigger-add-students");
					if (props.afterCreate) {
						props.afterCreate(response.student_count, null, null, response.classrooms);
					}
					if (props.onUpload) {
						props.onUpload(response.student_count, false, PendingTaskNotice.UPLOADING_STUDENTS);
					}
				});
			},
	
			fetchArchivedStudentLists: function fetchArchivedStudentLists() {
	
				var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id;
	
				var query = {
					inactive: true,
					effective_user_id: effectiveUserID,
					embed: "student_list.students,student_list.primary_students"
				};
	
				return dispatch(RosterActions.fetchStudentListsStoreless({ query: query }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(UploadStudentRoster, _React$Component);
	
		function UploadStudentRoster(props) {
			_classCallCheck(this, UploadStudentRoster);
	
			var _this = _possibleConstructorReturn(this, (UploadStudentRoster.__proto__ || Object.getPrototypeOf(UploadStudentRoster)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("RosterUpload");
			_this.state = {
				stage: INITIAL, rosterData: null, archivedStudents: null
			};
			return _this;
		}
	
		// Go backwards if inReverse is present and true
	
	
		_createClass(UploadStudentRoster, [{
			key: "nextStage",
			value: function nextStage(inReverse) {
				var _this2 = this;
	
				if (this.state.stage == INITIAL && (CurrentUser.isSchoolAdmin() || CurrentUser.isWizard())) {
					this.props.fetchArchivedStudentLists().then(function (response) {
						var students = _.flatten(_.pluck(response.student_lists, "primary_students"));
						_this2.setState({ archivedStudents: students });
					});
				}
	
				var currentIndex = STAGES.indexOf(this.state.stage);
				var change = inReverse ? -1 : 1;
				var nextStage = STAGES[currentIndex + change];
	
				this.setState({ stage: nextStage });
	
				if (nextStage == DONE) {
					this.props.uploadRoster(this.state.rosterData);
				}
			}
		}, {
			key: "updateRosterData",
			value: function updateRosterData(updatedData, callback) {
				this.setState({ rosterData: updatedData }, callback);
			}
		}, {
			key: "render",
			value: function render() {
				var roster = new StudentRoster(this.state.rosterData);
				var stageProps = {
					roster: roster, nextStage: this.nextStage,
					updateRosterData: this.updateRosterData
				};
	
				switch (this.state.stage) {
					case INITIAL:
						var stageContent = React.createElement(RosterUploadInitial, stageProps);
						break;
	
					case COLUMNS:
						var stageContent = React.createElement(RosterUploadColumns, stageProps);
						break;
	
					case GRADES:
						var stageContent = React.createElement(RosterUploadGrades, _extends({}, stageProps, {
							archivedStudents: this.state.archivedStudents }));
						break;
	
					case CLASSES:
						var stageContent = React.createElement(RosterUploadClasses, stageProps);
						break;
	
					case CONFIRM:
						var stageContent = React.createElement(RosterUploadConfirm, stageProps);
						break;
	
					case DONE:
						var stageContent = React.createElement(
							"div",
							{ className: "uploadingWait" },
							React.createElement(RosterUploadProgressMeter, { index: 5 }),
							React.createElement(
								"strong",
								null,
								"Currently uploading..."
							),
							React.createElement(Spinner, { center: true, ops: { length: 20, radius: 15, width: 8, color: "#888" } })
						);
				}
	
				return React.createElement(
					"div",
					{ className: "uploadRoster" },
					stageContent
				);
			}
		}]);
	
		return UploadStudentRoster;
	}(React.Component)) || _class);
	;
	
	var INITIAL = "initial";
	var COLUMNS = "columns";
	var CLASSES = "classes";
	var GRADES = "grades";
	var CONFIRM = "confirm";
	var DONE = "done";
	
	var STAGES = [INITIAL, COLUMNS, GRADES, CLASSES, CONFIRM, DONE];
	
	var MANUAL = "manual";
	var CODE = "class-code";
	var UPLOAD = "upload";
	var GOOGLE = "google-classroom";
	var CLEVER = "clever";
	
	var ALL_METHOD_OPTIONS = [MANUAL, CODE, UPLOAD, GOOGLE, CLEVER];
	
	UploadStudentRoster.propTypes = StrictPropTypes({
		// Function to call once the roster has been uploaded
		uploadRoster: PropTypes.func,
		afterCreate: PropTypes.func,
		effectiveUserID: PropTypes.number
	});
	
	module.exports = UploadStudentRoster;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _LocationState = __webpack_require__(59);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ClassTree = __webpack_require__(842);
	var PhotosDisplay = __webpack_require__(406);
	var BookShelf = __webpack_require__(404);
	var DisplayToggleControl = __webpack_require__(48);
	var Spinner = __webpack_require__(9);
	var StudentListDropdownDisplay = __webpack_require__(138);
	var EmptyStateContainer = __webpack_require__(80);
	
	var ClassPageRouting = __webpack_require__(256);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var OrgTypes = __webpack_require__(45);
	var OrgDropdown = __webpack_require__(100);
	
	var OwlShopRouting = __webpack_require__(92);
	
	__webpack_require__(3714);
	
	var ClassPage = (_dec = (0, _LocationState.provideLocationState)(ClassPageRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		var orgIdentifier = props.locationState.orgIdentifier;
		if (CurrentUser.isAdmin()) {
			var studentLists = RosterSelectors.nonEmptyStudentLists({ state: state });
			if (orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
				if (studentLists.length > 0) {
					orgIdentifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: studentLists[0].id });
				} else {
					orgIdentifier = null;
				}
			}
		} else {
			if (orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
				orgIdentifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: CurrentUser.get().primary_student_list.id });
			}
		}
		if (orgIdentifier) {
			var students = RosterSelectors.studentsForOrgIdentifier({ state: state, orgIdentifier: orgIdentifier });
			var studentListID = OrgTypes.fromIdentifier(orgIdentifier).key;
		}
	
		var isLoadingStudentLists = RosterSelectors.isLoadingStudentLists({ state: state, key: studentListID });
		if (CurrentUser.isAdmin()) {
			return {
				students: students,
	
				showClassShelf: true,
				allowChangeClass: true,
				orgIdentifier: orgIdentifier,
	
				isLoadingStudentLists: isLoadingStudentLists
			};
		} else {
			return {
				students: students,
				isStudent: true,
				showClassShelf: CurrentUser.get().prefs.display_class_shelf,
				allowChangeClass: false,
				orgIdentifier: orgIdentifier,
	
				isLoadingStudentLists: isLoadingStudentLists
			};
		}
	}, function (dispatch, props) {
		var fetchStudentList = function fetchStudentList(id) {
			var embeds = ["student_list.primary_admin", "student_list.students", "student.avatar", "student.settings", "student.perks", "student.student_list_ids"];
	
			return dispatch(RosterActions.fetchStudentList({
				id: id, embeds: embeds
			}));
		};
	
		var populateData = function populateData() {
			return dispatch(function (dispatch, getState) {
				// This one loads in some extra stuff that's not (currently) covered in the
				// fetchRosterData action from App.js
				// Plus students need it to be loaded in
	
				if (props.locationState.orgIdentifier == ClassPageRouting.DEFAULT_ORG_IDENTIFIER_KEY) {
					if (CurrentUser.isAdmin()) {
						var studentList = RosterSelectors.nonEmptyStudentLists({
							state: getState()
						});
	
						if (!studentList || !studentList.length) {
							var studentList = RosterSelectors.studentLists({
								state: getState()
							});
						}
	
						if (_.isEmpty(studentList)) {
							var studentListID = !_.isEmpty(CurrentUser.get().student_list_ids) ? CurrentUser.get().student_list_ids[0] : null;
						} else {
							var studentListID = studentList[0].id;
						}
					} else {
						var studentListID = CurrentUser.get().primary_student_list.id;
					}
				} else {
					var studentListID = OrgTypes.fromIdentifier(props.locationState.orgIdentifier).key;
				}
				return studentListID ? fetchStudentList(studentListID) : null;
			});
		};
	
		return {
			populateData: populateData, fetchStudentList: fetchStudentList
	
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(ClassPage, _React$Component);
	
		function ClassPage(props) {
			_classCallCheck(this, ClassPage);
	
			var _this = _possibleConstructorReturn(this, (ClassPage.__proto__ || Object.getPrototypeOf(ClassPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ClassPage");
			_this.state = {};
			return _this;
		}
	
		//////////////////////////////////////
		// Redirecting to change the view ////
		//////////////////////////////////////
	
		_createClass(ClassPage, [{
			key: "switchActiveView",
			value: function switchActiveView(viewKey) {
				Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
				this.switchView({ activeView: viewKey });
			}
		}, {
			key: "switchView",
			value: function switchView(change) {
				var newLocationState = _.extend({}, this.props.locationState, change);
				$wr.redirect(ClassPageRouting.getPath(newLocationState));
			}
	
			//////////////////////////////////////
			// Rendering /////////////////////////
			//////////////////////////////////////
	
		}, {
			key: "renderNoStudentsEmptyState",
			value: function renderNoStudentsEmptyState() {
				var rosterLink = "/roster?add_students=true";
				var emptyActionText = React.createElement(
					"p",
					null,
					"It looks like you haven't added any students yet.",
					React.createElement(
						_reactRouterDom.Link,
						{ to: rosterLink },
						" Add students "
					),
					"and their books and book reviews will appear here."
				);
				var emptyImgPath = __webpack_require__(495);
				return React.createElement(EmptyStateContainer, { actionText: emptyActionText,
					linkPath: rosterLink, imagePath: emptyImgPath });
			}
		}, {
			key: "onOrgSelect",
			value: function onOrgSelect(orgIdentifier) {
				var studentListID = OrgTypes.fromIdentifier(orgIdentifier).key;
				this.props.fetchStudentList(studentListID);
	
				$wr.redirect(ClassPageRouting.getPath({
					activeView: this.props.locationState.activeView,
					orgIdentifier: orgIdentifier
				}));
			}
		}, {
			key: "render",
			value: function render() {
				var lState = this.props.locationState;
	
				var toggleOptions = [{ key: ClassPageRouting.VIEWS.TREE_VIEW, text: "Tree" }, { key: ClassPageRouting.VIEWS.PHOTO_VIEW, text: "Owlstagram" }];
	
				if (this.props.showClassShelf) {
					toggleOptions.push({ key: ClassPageRouting.VIEWS.SHELF_VIEW, text: "Shelf" });
				}
	
				var displayToggleControl = React.createElement(DisplayToggleControl, { options: toggleOptions,
					onChange: this.switchActiveView,
					activeOptionKey: lState.activeView });
	
				if (this.props.isLoadingStudentLists) {
					var classContentDisplay = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else if (this.props.allowChangeClass && _.isEmpty(this.props.students)) {
					var classContentDisplay = this.renderNoStudentsEmptyState();
				} else if (lState.activeView == ClassPageRouting.VIEWS.SHELF_VIEW) {
					var classContentDisplay = React.createElement(BookShelf, { classView: true, key: this.props.orgIdentifier,
						studentIDs: _.pluck(this.props.students, "id"),
						detailsView: lState.detailsView,
						textID: lState.textID,
						switchView: this.switchView });
				} else if (lState.activeView == ClassPageRouting.VIEWS.TREE_VIEW) {
					var classContentDisplay = React.createElement(ClassTree, { students: this.props.students });
					if (this.props.isStudent) {
						var owlShopLink = React.createElement(
							"div",
							{ "class": "owlShopLink" },
							React.createElement(
								"a",
								{ href: "/owl_shop" },
								"Visit the Owl Shop!"
							)
						);
					}
				} else if (lState.activeView == ClassPageRouting.VIEWS.PHOTO_VIEW) {
					var studentIDs = _.pluck(this.props.students, "id");
					var classContentDisplay = React.createElement(PhotosDisplay, {
						isClass: true,
						ids: studentIDs });
	
					if (this.props.isStudent) {
						var owlShopLink = React.createElement(
							"div",
							{ className: "text-center" },
							React.createElement(
								_reactRouterDom.Link,
								{ to: OwlShopRouting.getPath({ activeView: OwlShopRouting.VIEWS.PHOTOS }) },
								"Snap a photo!"
							)
						);
					}
				}
				var controlsClassName = "viewControls";
	
				if (!this.props.isLoadingStudentLists && this.props.orgIdentifier && !this.props.isStudent) {
					var selectionTypes = [OrgTypes.STUDENT_LIST, OrgTypes.SUBGROUP];
					var selector = React.createElement(
						"div",
						{ className: "text-center" },
						React.createElement(OrgDropdown, { dropdownDisplay: "link",
							selectedIdentifier: this.props.orgIdentifier,
							onSelect: this.onOrgSelect,
							selectionTypes: selectionTypes })
					);
				}
				return React.createElement(
					"div",
					{ className: "container classPage", ref: "page" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"My Class"
						)
					),
					React.createElement(
						"div",
						{ className: "linksGroup" },
						React.createElement(
							"div",
							{ className: controlsClassName },
							displayToggleControl,
							selector,
							owlShopLink
						)
					),
					classContentDisplay
				);
			}
		}]);
	
		return ClassPage;
	}(React.Component)) || _class) || _class) || _class);
	;
	
	ClassPage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object.isRequired,
	
		// @connect data
		studentList: PropTypes.object,
		students: PropTypes.array,
		showClassShelf: PropTypes.bool,
		allowChangeClass: PropTypes.bool,
		isLoadingStudentLists: PropTypes.bool,
		orgIdentifier: PropTypes.string,
	
		// @connect handler
		populateData: PropTypes.func,
		fetchStudentList: PropTypes.func
	
	});
	
	module.exports = ClassPage;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	var HouseAvatar = __webpack_require__(729);
	
	__webpack_require__(3715);
	
	var ClassTree = function (_React$Component) {
		_inherits(ClassTree, _React$Component);
	
		function ClassTree(props) {
			_classCallCheck(this, ClassTree);
	
			var _this = _possibleConstructorReturn(this, (ClassTree.__proto__ || Object.getPrototypeOf(ClassTree)).call(this));
	
			autobind(_this);
			var currentStudent;
			if (CurrentUser.isStudent()) {
				currentStudent = _.find(props.students, function (student) {
					return CurrentUser.hasID(student.id);
				});
				currentStudent = currentStudent || props.students[0];
			}
			_this.state = { currentStudent: currentStudent };
			return _this;
		}
	
		_createClass(ClassTree, [{
			key: "render",
			value: function render() {
				// Function to flatten owl array
				var flatten = function flatten(arr) {
					return arr.reduce(function (a, b) {
						return a.concat(Array.isArray(b) ? flatten(b) : b);
					}, []);
				};
	
				var students = $wr.sortByName(this.props.students, "flexName");
				// var studentGroups = $wr.fetchSlicedItems(students, 6);
				// Split owls and houses on branches
				var studentGroups = [[]];
				var available_spots = 6;
				var array_index = 0;
				students.forEach(function (s, i) {
					if (s.perks && s.perks.houses) {
						if (available_spots > 1) {
							available_spots -= 2;
						} else {
							available_spots = 4;
							studentGroups.push([]);
							array_index += 1;
						}
					} else {
						available_spots -= 1;
					}
					studentGroups[array_index].push(s);
					if (available_spots <= 0 && i < students.length - 1) {
						studentGroups.push([]);
						array_index += 1;
						available_spots = 6;
					}
				});
				var branch1 = React.createElement("img", { src: __webpack_require__(3481), className: "treeBranchImg" });
				var branch2 = React.createElement("img", { src: __webpack_require__(3480), className: "treeBranchImg" });
				var currentBranch = true;
				var studentsRowDisplay = studentGroups.map(function (studentGroup, j) {
					if (currentBranch) {
						var displayBranch = branch1;
					} else {
						var displayBranch = branch2;
					}
					currentBranch = !currentBranch;
					//Get Owls and houses
					var item_index = 0;
					var owls = flatten(studentGroup.map(function (student, i) {
	
						var ret = [];
						ret.push(React.createElement(
							"div",
							{ key: item_index, ref: "owl_" + student.id, className: "avatarAndName" },
							React.createElement(
								"div",
								{ className: "studentName" },
								React.createElement(
									"div",
									null,
									$wr.fetchTitle(student, "onlyFirstName")
								),
								React.createElement(
									"span",
									{ className: "owlLevel" },
									"Owl Level " + (student.tier + 1)
								)
							),
							React.createElement(StudentAvatar, { student: student, maxWidth: 115, disableSound: true })
						));
						item_index += 1;
						// Add house second
						if (student.perks && student.perks.houses) {
							if (CurrentUser.isAdmin() || CurrentUser.hasID(student.id)) {
								var houseAvatar = React.createElement(
									"div",
									{ key: item_index, className: "avatarAndName avatarWithHouse" },
									React.createElement(HouseAvatar, { maxWidth: 90, student: student })
								);
							} else {
								var houseAvatar = React.createElement(
									"div",
									{ key: item_index, className: "avatarAndName avatarWithHouse" },
									React.createElement(HouseAvatar, { maxWidth: 90, student: student, currentStudent: this.state.currentStudent })
								);
							}
							item_index += 1;
						}
						ret.push(houseAvatar);
						return ret;
					}.bind(this)));
					var key = _.pluck(studentGroup, "id").join("-");
					return React.createElement(
						"div",
						{ className: "studentRows", key: key },
						React.createElement(
							"div",
							{ className: "owlLine" },
							owls
						),
						displayBranch
					);
				}.bind(this));
	
				return React.createElement(
					"div",
					{ className: "classTree" },
					React.createElement(
						"div",
						{ className: "treeTopContainer" },
						React.createElement("img", { src: __webpack_require__(3483), className: "" })
					),
					React.createElement(
						"div",
						{ className: "studentsContainer classTreeArea" },
						React.createElement(
							"div",
							{ className: "studentRowsSection" },
							studentsRowDisplay
						)
					),
					React.createElement(
						"div",
						{ className: "treeRootsContainer" },
						React.createElement("img", { src: __webpack_require__(3482), className: "treeRoots" })
					)
				);
			}
		}, {
			key: "adjustAvatars",
			value: function adjustAvatars() {
				this.props.students.forEach(function (s, i) {
					var height = $(this.refs["owl_" + s.id]).find(".studentName").css('height');
					if (height) {
						var h = parseInt(height.replace('px', ''));
						// var h = parseInt($("#owl_"+s.username).find(".studentName").css('height').replace('px',''))
						if (h > 25) {
							$(this.refs["owl_" + s.id]).addClass('adjustedAvatarAndName');
						}
					}
				}.bind(this));
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.adjustAvatars();
			}
		}]);
	
		return ClassTree;
	}(React.Component);
	
	;
	
	ClassTree.propTypes = StrictPropTypes({
		students: PropTypes.array.isRequired
	});
	
	module.exports = ClassTree;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3717);
	
	var PurchaseOrderInput = function (_React$Component) {
		_inherits(PurchaseOrderInput, _React$Component);
	
		function PurchaseOrderInput(props) {
			_classCallCheck(this, PurchaseOrderInput);
	
			var _this = _possibleConstructorReturn(this, (PurchaseOrderInput.__proto__ || Object.getPrototypeOf(PurchaseOrderInput)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(PurchaseOrderInput, [{
			key: "onChange",
			value: function onChange(key, e) {
				var updatedValues = _.extend({}, this.props.values, _defineProperty({}, key, e.target.value));
				this.props.onChange(updatedValues);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "purchaseOrderInput" },
					React.createElement(
						"label",
						{ className: "contactInfoField" },
						React.createElement(
							"span",
							null,
							"Accounts payable full name"
						),
						React.createElement("input", { type: "text", className: "form-control",
							value: this.props.values["payable_name"] || "",
							onChange: this.onChange.bind(this, "payable_name") })
					),
					React.createElement(
						"label",
						{ className: "contactInfoField" },
						React.createElement(
							"span",
							null,
							"Accounts payable email"
						),
						React.createElement("input", { type: "text", className: "form-control",
							value: this.props.values["payable_email"] || "",
							onChange: this.onChange.bind(this, "payable_email") })
					),
					React.createElement(
						"label",
						{ className: "contactInfoField" },
						React.createElement(
							"span",
							null,
							"Accounts payable phone"
						),
						React.createElement("input", { type: "text", className: "form-control",
							value: this.props.values["payable_phone"] || "",
							onChange: this.onChange.bind(this, "payable_phone") })
					),
					React.createElement(
						"label",
						{ className: "contactInfoField" },
						React.createElement(
							"span",
							null,
							"Comments (optional)"
						),
						React.createElement("input", { type: "text", className: "form-control",
							placeholder: "More than one teacher? Other questions?",
							value: this.props.values["comments"] || "",
							onChange: this.onChange.bind(this, "comments") })
					)
				);
			}
		}]);
	
		return PurchaseOrderInput;
	}(React.Component);
	
	;
	
	PurchaseOrderInput.propTypes = StrictPropTypes({
		values: PropTypes.object.isRequired,
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = PurchaseOrderInput;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var TextTypes = __webpack_require__(38);
	
	var DataRouting = __webpack_require__(36);
	var PaywallModal = __webpack_require__(44);
	
	var BookTextVariety = __webpack_require__(141);
	var ScoreDisplay = __webpack_require__(103);
	var BookDisplay = __webpack_require__(46);
	var ReadingLevelDisplay = __webpack_require__(243);
	var ReadingLevelFormat = __webpack_require__(72);
	
	var RosterSelectors = __webpack_require__(6);
	var StudentDisplay = __webpack_require__(52);
	var StudentListDisplay = __webpack_require__(163);
	var WritingSelectors = __webpack_require__(14);
	var UIActions = __webpack_require__(41);
	
	__webpack_require__(3726);
	
	var TextTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
		downProps.evaluationIDsByTextID = {};
	
		_.each(props.books, function (book) {
			//if the table has multiple students, find the last student to work on each book.
			var userID = props.userID || parseInt(_.max(_.keys(book.last_actives), function (x) {
				return Date.parse(book.last_actives[x]);
			}));
	
			var evaluation = WritingSelectors.evaluationBySubjectAttributes({
				state: state, subjectTextID: book.text_id, subjectUserID: userID
			});
			//make sure that answer evals aren't passed to the quiz column
			if (evaluation && evaluation.subject_type == "Quiz") {
				downProps.evaluationIDsByTextID[book.text_id] = evaluation.id;
			}
		});
	
		var student = RosterSelectors.student({ state: state, id: props.userID });
		if (student) {
			downProps.studentFirstName = student.first_name;
			downProps.studentReadingLevel = student.current_reading_level;
		}
		return downProps;
	}, function (dispatch, props) {
		return {
			onCellClick: function onCellClick(subjectType, textID) {
				$wr.redirect(DataRouting.getPath({ subjectType: subjectType, textID: textID, userIDs: [props.userID] }));
				$wr.setWindowY(0);
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(TextTable, _React$Component);
	
		function TextTable(props) {
			_classCallCheck(this, TextTable);
	
			var _this = _possibleConstructorReturn(this, (TextTable.__proto__ || Object.getPrototypeOf(TextTable)).call(this));
	
			autobind(_this);
	
			_this.state = { expanded: false };
			return _this;
		}
	
		_createClass(TextTable, [{
			key: "onCellClick",
			value: function onCellClick(subjectType, book) {
				//if multiple users, make sure that the right id is grabbed
				var userID = this.props.userID || parseInt(_.max(_.keys(book.last_actives), function (x) {
					return Date.parse(book.last_actives[x]);
				}));
	
				$wr.redirect(DataRouting.getPath({ subjectType: subjectType, textID: book.text_id, userIDs: [userID] }));
				$wr.setWindowY(0);
			}
		}, {
			key: "expandFromSoftMax",
			value: function expandFromSoftMax() {
				this.setState({ expanded: true });
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.userID) {
					var books = _.sortBy(this.props.books, function (b) {
						return (b["last_actives"] || {})[_this2.props.userID] || "0";
					});
				} else {
					var books = _.sortBy(this.props.books, function (b) {
						return _.max(_.values(b.last_actives).map(function (x) {
							return Date.parse(x);
						}));
					});
				}
				books.reverse();
	
				if (this.props.softMax && this.props.softMax < books.length && !this.state.expanded) {
					books = _.first(books, this.props.softMax);
					var appliedSoftMax = true;
				} else {
					var appliedSoftMax = false;
				}
	
				var rows = _.map(books, function (book) {
					if (_this2.props.userID) {
						var userID = _this2.props.userID;
					} else {
						var userID = _.max(_.keys(book.last_actives), function (x) {
							return Date.parse(book.last_actives[x]);
						});
					}
					if (book.title) {
						// All these things may not be initially present, but will be when the
						// detailed textData gets loaded in
						if (book.text_variety && TextTypes["Varieties"]["TYPES"][book.text_variety]) {
							var textVariety = TextTypes["Varieties"]["TYPES"][book.text_variety].abbreviation;
						} else {
							var textVariety = "-";
						}
						var textVariety = React.createElement(BookTextVariety, { book: book, displayMode: "cell" });
						if (book.lexile_score) {
							var readingLevel = React.createElement(ReadingLevelDisplay, { studentReadingLevel: _this2.props.studentReadingLevel, userID: userID, book: book,
								lexile: book.lexile_score, displayMode: "cell", showReadingLevelIcon: true });
						} else {
							var readingLevel = React.createElement(
								"td",
								null,
								"-"
							);
						}
					} else {
						var textVariety = React.createElement("td", null);
						var readingLevel = React.createElement("td", null);
					}
	
					var evaluationID = _this2.props.evaluationIDsByTextID[book.text_id];
	
					if (evaluationID == undefined) {
						var evaluationCell = React.createElement(
							"td",
							null,
							React.createElement(
								"span",
								{ className: "pointsEarned" },
								"-"
							)
						);
					} else {
						var expandQuizF = _this2.onCellClick.bind(_this2, DataRouting.SUBJECT_QUIZZES, book);
	
						var evaluationCell = React.createElement(
							"td",
							{ className: "clickable", onClick: expandQuizF },
							React.createElement(ScoreDisplay, { evaluationID: evaluationID, mode: ScoreDisplay.INLINE_MODE }),
							React.createElement(
								"a",
								{ href: "#", className: "hideOnPrint",
									onClick: $wr.preventDefaultBehavior },
								"View"
							)
						);
					}
	
					var activityCount = 0;
					var excludedCount = 0;
	
					_.each(book, function (val, key) {
						if (key.endsWith("_counts")) {
							activityCount += book[key][userID] || 0;
						}
						if (key.endsWith("_counts_excluded")) {
							excludedCount += book[key][userID] || 0;
						}
					});
	
					if (excludedCount > 0 && excludedCount < activityCount) {
						var className = "excludedStripes";
						var tooltipText = "Some activities have been excluded";
					} else if (excludedCount == activityCount) {
						var className = "excludedStripes";
						var tooltipText = "All activities have been excluded";
					}
	
					// There's now 3 cases
					// - excludedCount == 0: Nothing was excluded
					// - excludedCount < activityCount: Some activity was excluded, not other
					// - excludedCount == activityCount: All activity was exlcuede
	
					var countPairs = [[DataRouting.SUBJECT_ANSWERS, book.answer_counts], [DataRouting.SUBJECT_REVIEWS, book.review_counts]];
	
					if (_this2.props.showResponseCounts) {
						countPairs.push([DataRouting.SUBJECT_ACTIVITIES, book.response_counts]);
					}
	
					var countCells = _.map(countPairs, function (pair) {
						var subjectType = pair[0];
						var count = (pair[1] || {})[userID];
						if (count) {
							var noun = subjectType.replace("Practice ", "");
							var expandCellF = _this2.onCellClick.bind(_this2, subjectType, book);
							return React.createElement(
								"span",
								{ key: subjectType, onClick: expandCellF },
								$wr.pluralizeWithNumber(noun.slice(0, -1), count, noun),
								React.createElement(
									"a",
									{ href: "#", className: "hideOnPrint",
										onClick: $wr.preventDefaultBehavior },
									"View"
								),
								React.createElement("br", null)
							);
						} else {
							return React.createElement("span", { key: subjectType });
						}
					});
	
					if (_this2.props.showLogStats) {
						var logSums = (book.log_sums || {})[userID] || {};
						if (logSums.minutes) {
							var minutesSum = React.createElement(
								"span",
								{ className: "minutesContainer" },
								logSums.minutes || 0,
								" min. ",
								React.createElement("br", null)
							);
						}
						if (logSums.pages) {
							var pagesSum = React.createElement(
								"span",
								null,
								logSums.pages || 0,
								" pgs."
							);
						}
						var readingCell = React.createElement(
							"td",
							null,
							minutesSum,
							pagesSum
						);
					}
	
					var lastActive = (book.last_actives || {})[userID];
					if (_this2.props.student) {
						var primaryStudentListID = _this2.props.student.student_list_ids.primary;
					}
					if (_this2.props.showStudentCell) {
						var studentInfoCell = React.createElement(
							"td",
							null,
							React.createElement(StudentDisplay, { studentID: parseInt(userID), showAvatar: true,
								avatarMaxWidth: 30 }),
							React.createElement(StudentListDisplay, { studentID: parseInt(userID) })
						);
					}
	
					return React.createElement(
						"tr",
						{ className: "textRow " + className, key: book.text_id, "data-tip": tooltipText },
						React.createElement(
							"td",
							null,
							$wr.momentInTimezone(lastActive).format("MM/DD/YY")
						),
						studentInfoCell,
						React.createElement(
							"td",
							null,
							React.createElement(BookDisplay, { textID: book.text_id, loadBook: false })
						),
						readingLevel,
						evaluationCell,
						React.createElement(
							"td",
							{ className: "writingCount" },
							countCells
						),
						readingCell
					);
				});
	
				var cellCount = 7;
	
				if (this.props.showResponseCounts) {
					cellCount += 1;
					var responseHeader = React.createElement(
						"th",
						{ className: "responseCol" },
						"Exercises"
					);
				}
				if (this.props.showLogStats) {
					cellCount += 2;
					var minutesHeader = React.createElement(
						"th",
						null,
						"Minutes"
					);
					var pagesHeader = React.createElement(
						"th",
						{ className: "pageCol" },
						"Pages"
					);
	
					var readingHeader = React.createElement(
						"th",
						null,
						"Reading"
					);
				}
	
				var scoreFormat = CurrentUser.get().prefs.reading_level_format;
	
				if (appliedSoftMax) {
					var truncatedRow = React.createElement(
						"tr",
						{ className: "truncatedPlaceholder" },
						React.createElement(
							"td",
							{ colSpan: cellCount },
							React.createElement(
								"button",
								{ className: "btn btn-link", onClick: this.expandFromSoftMax },
								"Show ",
								this.props.books.length - books.length,
								" More"
							)
						)
					);
				}
	
				if (this.props.showStudentCell) {
					var studentHeader = React.createElement(
						"th",
						null,
						"Student"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "textTable" },
					React.createElement(
						"table",
						{ className: "table table-bordered" },
						React.createElement(
							"tbody",
							null,
							React.createElement(
								"tr",
								null,
								React.createElement(
									"th",
									{ "data-tip": "Most recent date of any activity during time period" },
									"Date"
								),
								studentHeader,
								React.createElement(
									"th",
									{ className: "bookCol" },
									"Title"
								),
								React.createElement(
									"th",
									{ className: "ReadingLevelCol", "data-tip": scoreFormat },
									ReadingLevelFormat.getShortName(scoreFormat)
								),
								React.createElement(
									"th",
									{ className: "quizCol", "data-tip": "Pass or fail" },
									"Quiz Score"
								),
								React.createElement(
									"th",
									{ className: "writingCol" },
									"Other Writing"
								),
								readingHeader
							),
							rows,
							truncatedRow
						)
					)
				);
			}
		}]);
	
		return TextTable;
	}(React.Component)) || _class);
	
	
	TextTable.WrappedComponent.propTypes = StrictPropTypes({
		// userID of the student for this table
		userID: PropTypes.number,
	
		// List of books
		books: PropTypes.array.isRequired,
	
		showResponseCounts: PropTypes.bool,
		showLogStats: PropTypes.bool,
		softMax: PropTypes.number,
		showStudentCell: PropTypes.bool,
	
		// From @connnect
		studentFirstName: PropTypes.string,
		onCellClick: PropTypes.func.isRequired,
		evaluationIDsByTextID: PropTypes.object.isRequired,
		showHistoricalDataPaywall: PropTypes.func,
		studentReadingLevel: PropTypes.number,
		showReadingLevelIcon: PropTypes.bool
	});
	
	module.exports = TextTable;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var moment = __webpack_require__(15);
	
	var CommentBox = __webpack_require__(119);
	var LogRow = __webpack_require__(402);
	var PaywallModal = __webpack_require__(44);
	var Features = __webpack_require__(16);
	var ReactTooltip = __webpack_require__(12);
	
	var EachMonthLogTable = function (_React$Component) {
		_inherits(EachMonthLogTable, _React$Component);
	
		function EachMonthLogTable(props) {
			_classCallCheck(this, EachMonthLogTable);
	
			var _this = _possibleConstructorReturn(this, (EachMonthLogTable.__proto__ || Object.getPrototypeOf(EachMonthLogTable)).call(this));
	
			autobind(_this);
			_this.state = {
				monthDataHidden: !props.initExpanded && props.initExpanded != undefined
			};
			return _this;
		}
	
		_createClass(EachMonthLogTable, [{
			key: "showCommentPaywall",
			value: function showCommentPaywall() {
				this.refs.commentPaywallModal.show();
			}
		}, {
			key: "toggleShowLogData",
			value: function toggleShowLogData() {
				if (this.state.monthDataHidden) {
					this.setState({ monthDataHidden: false });
				} else {
					this.setState({ monthDataHidden: true });
				}
			}
		}, {
			key: "renderCommentBox",
			value: function renderCommentBox() {
				var log = _.first(this.props.logs);
				if (!log) {
					return;
				}
	
				var initialCollapsed = CurrentUser.isAdmin();
				var subjectID = log.user_id + "-" + "logs-month-" + this.props.month;
				if (!this.props.hideCommentBox) {
					var commentBox = React.createElement(CommentBox, { subjectID: subjectID, subjectType: "MonthLogTable",
						userID: log.user_id, initialCollapsed: initialCollapsed,
						blockFirstComment: CurrentUser.isStudent(),
						showPaywallModal: this.showCommentPaywall, noSuggestedComments: true });
				}
	
				return React.createElement(
					"div",
					{ className: "commentWrap" },
					commentBox,
					React.createElement(PaywallModal, { ref: "commentPaywallModal", featureType: PaywallModal.QUIZ_FEATURES })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var sumMins = 0;
				var sumPages = 0;
	
				if (this.state.monthDataHidden) {
					var sum = 0;
					_.each(this.props.logs, function (log, index) {
						//here we used .each instead of .map because we don't have to use return
						//look up difference between the two
						sumMins = sumMins + log.minutes;
						sumPages = sumPages + log.pages;
					});
	
					var expandLink = React.createElement(
						"a",
						{ href: "#", className: "expandLink", onClick: $wr.nope },
						"View"
					);
				} else {
	
					var sum = 0;
					var logs = _.sortBy(this.props.logs, "log_date");
					var logRows = _.map(logs, function (log, index) {
						sumMins = sumMins + log.minutes;
						sumPages = sumPages + log.pages;
	
						return React.createElement(LogRow, { log: log, key: log.id, condensedLayout: this.props.condensedLayout });
					}.bind(this));
				}
	
				if (this.props.showFullData) {
					var monthName = moment(this.props.month).format('MMMM YYYY');
					var tableHeaders = React.createElement(
						"tr",
						{ className: "outerTitles clickable", onClick: this.toggleShowLogData },
						React.createElement(
							"th",
							{ className: "dateTitle", colSpan: 2 },
							monthName
						),
						React.createElement(
							"th",
							{ className: "minuteCell" },
							React.createElement(
								"p",
								{ className: "infoContainer" },
								sumMins || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Total Minutes"
							)
						),
						React.createElement(
							"th",
							{ className: "pageCell" },
							React.createElement(
								"p",
								{ className: "infoContainer" },
								sumPages || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Total Pages"
							)
						),
						React.createElement(
							"th",
							{ className: "editCell" },
							expandLink
						),
						React.createElement("th", null)
					);
					if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
						var commentBox = this.renderCommentBox();
					}
				}
	
				return React.createElement(
					"div",
					{ className: "monthLogTable" },
					React.createElement(
						"table",
						{ className: "logTable" },
						React.createElement(
							"tbody",
							null,
							tableHeaders,
							logRows
						)
					),
					commentBox
				);
			}
		}]);
	
		return EachMonthLogTable;
	}(React.Component);
	
	;
	
	EachMonthLogTable.propTypes = StrictPropTypes({
		logs: PropTypes.array.isRequired,
		month: PropTypes.string,
		initExpanded: PropTypes.bool,
		hideCommentBox: PropTypes.bool,
		showFullData: PropTypes.bool,
		condensedLayout: PropTypes.bool
	});
	
	module.exports = EachMonthLogTable;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadingActions = __webpack_require__(27);
	var LogRow = __webpack_require__(402);
	var CurrentUser = __webpack_require__(3);
	
	var moment = __webpack_require__(15);
	
	var WeekLogTable = (_dec = (0, _reactRedux.connect)(null, function (dispatch, props) {
		return {
			verifyLogs: function verifyLogs() {
				var logIDs = _.pluck(props.logs, "id");
				dispatch(ReadingActions.updateLogs({ ids: logIDs, update: { verified: true } }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(WeekLogTable, _React$Component);
	
		function WeekLogTable(props) {
			_classCallCheck(this, WeekLogTable);
	
			var _this = _possibleConstructorReturn(this, (WeekLogTable.__proto__ || Object.getPrototypeOf(WeekLogTable)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(WeekLogTable, [{
			key: "verifyLogs",
			value: function verifyLogs(e) {
				$wr.nope(e);
				this.props.verifyLogs();
				window.wrNotifications.triggerDropDownNotification({
					title: "Verified!", text: "Thank you for reviewing!", icon: "ok-sign" });
			}
		}, {
			key: "render",
			value: function render() {
	
				var sumMins = 0;
				var sumPages = 0;
	
				var logs = _.sortBy(this.props.logs, "log_date");
				var logRows = _.map(logs, function (log, index) {
					sumMins = sumMins + log.minutes;
					sumPages = sumPages + log.pages;
	
					return React.createElement(LogRow, { log: log, key: log.id });
				}.bind(this));
	
				var startDate = moment(this.props.week);
				var weekStart = startDate.format('M/D');
				var weekEnd = startDate.add(6, "days").format('M/D');
				var weekSummary = "Week of " + weekStart + " - " + weekEnd;
	
				if (this.props.logsApproval) {
					var tableHeaders = React.createElement(
						"tr",
						{ className: "outerTitles" },
						React.createElement(
							"th",
							{ className: "dateTitle", colSpan: "2" },
							weekSummary
						),
						React.createElement(
							"th",
							{ className: "minuteCell" },
							React.createElement(
								"p",
								{ className: "infoContainer" },
								sumMins || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Total Minutes"
							)
						),
						React.createElement(
							"th",
							{ className: "pageCell" },
							React.createElement(
								"p",
								{ className: "infoContainer" },
								sumPages || "-"
							),
							React.createElement(
								"span",
								{ className: "sectionLabel" },
								"Total Pages"
							)
						),
						React.createElement(
							"th",
							{ className: "", colSpan: "1" },
							React.createElement(
								"a",
								{ className: "btn buttonSuccess", href: "#", onClick: this.verifyLogs },
								"Approve"
							)
						)
					);
				} else {
					var tableHeaders = React.createElement(
						"tr",
						{ className: "outerTitles" },
						React.createElement(
							"th",
							{ className: "dateTitle", colSpan: "2" },
							weekSummary
						),
						React.createElement(
							"th",
							{ className: "minutesTitle", colSpan: "3" },
							" ",
							sum,
							" Minutes "
						)
					);
				}
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"table",
						{ className: "logTable" },
						React.createElement(
							"tbody",
							null,
							tableHeaders,
							logRows
						)
					)
				);
			}
		}]);
	
		return WeekLogTable;
	}(React.Component)) || _class);
	;
	
	WeekLogTable.WrappedComponent.propTypes = StrictPropTypes({
		logs: PropTypes.array.isRequired,
		verifyLogs: PropTypes.func,
		logsApproval: PropTypes.bool,
		week: PropTypes.string
	});
	
	module.exports = WeekLogTable;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var TextTypes = __webpack_require__(38);
	
	var PaginationControls = __webpack_require__(90);
	var BookDisplay = __webpack_require__(46);
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var Glyphicon = __webpack_require__(8);
	
	var ReadingActions = __webpack_require__(27);
	var RosterActions = __webpack_require__(11);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3729);
	
	var AddLibraryURLPick = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			books: ReadingSelectors.books({ state: state, filters: { library: true } }),
			platforms: ReadingSelectors.platforms({ state: state }),
			assignedTextIDs: RosterSelectors.globalStudentListPrefs({ state: state }).assigned_text_ids
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return Promise.all([dispatch(ReadingActions.fetchLibraryOnline({ cache: true }))]
				// dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true })),
				);
			},
	
			setAssignedTexts: function setAssignedTexts(textIDs) {
				return dispatch(RosterActions.updateAllStudentListPrefs({
					currentUserID: CurrentUser.get().id,
					update: { assigned_text_ids: textIDs }
				}));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(AddLibraryURLPick, _React$Component);
	
		function AddLibraryURLPick(props) {
			_classCallCheck(this, AddLibraryURLPick);
	
			var _this = _possibleConstructorReturn(this, (AddLibraryURLPick.__proto__ || Object.getPrototypeOf(AddLibraryURLPick)).call(this));
	
			autobind(_this);
	
			_this.state = {
				page: 1,
				filters: {}
			};
			return _this;
		}
	
		_createClass(AddLibraryURLPick, [{
			key: "applyFilter",
			value: function applyFilter(key, val) {
				this.setState({
					filters: _extends({}, this.state.filters, _defineProperty({}, key, val))
				});
			}
		}, {
			key: "onPageChange",
			value: function onPageChange(page) {
				this.setState({ page: page });
			}
		}, {
			key: "isAssigned",
			value: function isAssigned(textID) {
				return _.includes(this.props.assignedTextIDs, textID);
			}
		}, {
			key: "toggleAssign",
			value: function toggleAssign(textID) {
				// if (this.isAssigned(textID)) {
				// 	var textIDs = _.without(this.props.assignedTextIDs, textID);
				// } else {
				// 	var textIDs = this.props.assignedTextIDs.concat(textID);
				// }
				// this.props.setAssignedTexts(textIDs);
				var selectedURLText = _.find(this.props.books, function (item) {
					return item.text_id == textID;
				});
				this.props.toggleAssign(selectedURLText);
			}
		}, {
			key: "filteredBooks",
			value: function filteredBooks() {
				var books = this.props.books;
	
				var _state$filters = this.state.filters,
				    platformID = _state$filters.platformID,
				    age = _state$filters.age,
				    topic = _state$filters.topic,
				    textVariety = _state$filters.textVariety;
	
	
				if (platformID) {
					books = _.where(books, { platform_id: platformID });
				}
	
				if (textVariety) {
					books = _.where(books, { text_variety: textVariety });
				}
	
				if (age) {
					books = books.filter(function (x) {
						return _.includes(x.ages, age);
					});
				}
	
				if (topic) {
					books = books.filter(function (x) {
						return _.includes(x.topics, topic);
					});
				}
	
				return _.sortBy(books, "title");
			}
		}, {
			key: "pageBooks",
			value: function pageBooks() {
				var books = this.filteredBooks();
				if (books.length) {
					return _.chunk(books, PER_PAGE)[this.state.page - 1];
				} else {
					return [];
				}
			}
		}, {
			key: "renderPlatformSelector",
			value: function renderPlatformSelector() {
				var _this2 = this;
	
				var platformOptions = _.map(this.props.platforms, function (platform) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: platform.id,
							onClick: function onClick() {
								return _this2.applyFilter("platformID", platform.id);
							} },
						platform.name
					);
				});
	
				var selectedPlatform = _.findWhere(this.props.platforms, {
					id: this.state.filters.platformID
				});
	
				var displayText = selectedPlatform ? selectedPlatform.name : "All Websites";
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText, dropdownDisplay: "link" },
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this2.applyFilter("platformID", null);
							} },
						"All Websites"
					),
					platformOptions
				);
			}
		}, {
			key: "renderTextVarietySelector",
			value: function renderTextVarietySelector() {
				var _this3 = this;
	
				var displayText = TextTypes.Varieties.getName(this.state.filters.textVariety || TextTypes.Varieties.FICTION_AND_NON_FICTION);
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText, dropdownDisplay: "link" },
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this3.applyFilter("textVariety", null);
							} },
						TextTypes.Varieties.getName(TextTypes.Varieties.FICTION_AND_NON_FICTION)
					),
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this3.applyFilter("textVariety", TextTypes.Varieties.FICTION);
							} },
						TextTypes.Varieties.getName(TextTypes.Varieties.FICTION)
					),
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this3.applyFilter("textVariety", TextTypes.Varieties.NON_FICTION);
							} },
						TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION)
					)
				);
			}
		}, {
			key: "renderAgeSelector",
			value: function renderAgeSelector() {
				var _this4 = this;
	
				var ages = _.sortBy(_.uniq(_.flatten(this.props.books.map(function (p) {
					return p.ages;
				}))), function (age) {
					if (age == "K-1") {
						return 0;
					} else {
						return parseInt(age.split("-"));
					}
				});
	
				var platformOptions = _.map(ages, function (age) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: age,
							onClick: function onClick() {
								return _this4.applyFilter("age", age);
							} },
						age
					);
				});
	
				var displayText = this.state.filters.age || "All Grades";
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText, dropdownDisplay: "link" },
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this4.applyFilter("age", null);
							} },
						"All Grades"
					),
					platformOptions
				);
			}
		}, {
			key: "renderTopicSelector",
			value: function renderTopicSelector() {
				var _this5 = this;
	
				var topics = _.uniq(_.flatten(this.props.books.map(function (p) {
					return p.topics;
				}))).sort();
	
				var platformOptions = _.map(topics, function (topic) {
					return React.createElement(
						ButtonDropdownOption,
						{ key: topic,
							onClick: function onClick() {
								return _this5.applyFilter("topic", topic);
							} },
						topic
					);
				});
	
				var displayText = this.state.filters.topic || "Any Topic";
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText, dropdownDisplay: "link" },
					React.createElement(
						ButtonDropdownOption,
						{ onClick: function onClick() {
								return _this5.applyFilter("topic", null);
							} },
						"Any Topic"
					),
					platformOptions
				);
			}
		}, {
			key: "renderTexts",
			value: function renderTexts() {
				var _this6 = this;
	
				var filteredBooks = this.pageBooks().length; // instead of using this.props.books.length...
				if (filteredBooks > 0) {
					return this.pageBooks().map(function (book) {
	
						if (_this6.isAssigned(book.text_id)) {
							var assignAction = React.createElement(
								"div",
								null,
								React.createElement(Glyphicon, { icon: "ok" }),
								" Assigned"
							);
						} else {
							var assignAction = React.createElement(
								"button",
								{ className: "btn btn-default", onClick: function onClick() {
										return _this6.toggleAssign(book.text_id);
									} },
								"Assign"
							);
						}
	
						return React.createElement(
							"div",
							{ className: "assignable", key: book.text_id },
							React.createElement(BookDisplay, { textID: book.text_id, showCover: true, showURL: true, showLibraryTags: true }),
							React.createElement(
								"div",
								{ className: "actions" },
								assignAction
							)
						);
					});
				} else {
					return React.createElement(
						"div",
						{ className: "noResultsText" },
						"We don't have these texts yet. Try searching for another text."
					);
				}
			}
		}, {
			key: "renderPagination",
			value: function renderPagination() {
				var bookCount = this.filteredBooks().length;
	
				if (bookCount / PER_PAGE > 1) {
					return React.createElement(PaginationControls, { page: this.state.page,
						perPage: PER_PAGE,
						totalCount: bookCount,
						onPageChange: this.onPageChange });
				}
			}
		}, {
			key: "render",
			value: function render() {
				var textVariety = this.state.filters.textVariety;
				if (textVariety != TextTypes.Varieties.FICTION) {
					var topicSelector = this.renderTopicSelector();
				}
				return React.createElement(
					"div",
					{ className: "addLibraryURLPick" },
					React.createElement(
						"div",
						{ className: "filters" },
						this.renderAgeSelector(),
						this.renderPlatformSelector(),
						this.renderTextVarietySelector(),
						topicSelector
					),
					this.renderTexts(),
					this.renderPagination()
				);
			}
		}]);
	
		return AddLibraryURLPick;
	}(React.Component)) || _class) || _class);
	;
	
	var PER_PAGE = 25;
	
	AddLibraryURLPick.WrappedComponent.propTypes = StrictPropTypes({
		toggleAssign: PropTypes.func,
		// Data from @connect
		books: PropTypes.array,
		platforms: PropTypes.array,
		assignedTextIDs: PropTypes.array,
	
		// Handlers from @connect
		populateData: PropTypes.func.isRequired,
		setAssignedTexts: PropTypes.func
	});
	
	module.exports = AddLibraryURLPick;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var TextTypes = __webpack_require__(38);
	
	var PaginationControls = __webpack_require__(90);
	var BookDisplay = __webpack_require__(46);
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var LoadingButton = __webpack_require__(17);
	
	var ReadingActions = __webpack_require__(27);
	
	__webpack_require__(3730);
	
	var AddManualURLPick = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			createBook: function createBook(book) {
				return dispatch(ReadingActions.createBook({ book: book }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AddManualURLPick, _React$Component);
	
		function AddManualURLPick(props) {
			_classCallCheck(this, AddManualURLPick);
	
			var _this = _possibleConstructorReturn(this, (AddManualURLPick.__proto__ || Object.getPrototypeOf(AddManualURLPick)).call(this));
	
			autobind(_this);
	
			_this.state = _this.getInitialState();
			return _this;
		}
	
		_createClass(AddManualURLPick, [{
			key: "getInitialState",
			value: function getInitialState() {
				return {
					url: "", title: "",
					textVariety: TextTypes.Varieties.FICTION,
					loading: false
				};
			}
		}, {
			key: "addText",
			value: function addText(book) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Added URL!", text: "You have added a URL for your students.", icon: "ok-sign"
				});
	
				this.props.toggleAssign(book);
			}
		}, {
			key: "isValid",
			value: function isValid() {
				return this.state.url.trim().length && this.state.title.trim().length;
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (!this.isValid()) {
					return;
				}
	
				var book = {
					url: this.state.url,
					title: this.state.title,
					as_admin: true,
					text_variety: this.state.textVariety
				};
	
				this.setState({ loading: true });
				this.props.createBook(book).then(function (response) {
					_this2.addText(response.books[0]);
	
					_this2.setState(_this2.getInitialState());
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				return React.createElement(
					"div",
					{ className: "addManualURLPick" },
					React.createElement(
						"form",
						{ onSubmit: this.onSubmit },
						React.createElement(
							"div",
							{ className: "row" },
							React.createElement(
								"div",
								{ className: "col-sm-7" },
								React.createElement(
									"label",
									null,
									"Text Title"
								),
								React.createElement("input", { className: "form-control", type: "text",
									placeholder: "Your Awesome Article",
									onChange: function onChange(e) {
										return _this3.setState({ title: e.target.value.trim() });
									} })
							),
							React.createElement(
								"div",
								{ className: "col-sm-5" },
								React.createElement(
									"label",
									null,
									"Text Type"
								),
								React.createElement(
									"select",
									{ className: "form-control",
										onChange: function onChange(e) {
											return _this3.setState({ textVariety: e.target.value.trim() });
										} },
									React.createElement(
										"option",
										{ value: TextTypes.Varieties.FICTION },
										TextTypes.Varieties.getName(TextTypes.Varieties.FICTION)
									),
									React.createElement(
										"option",
										{ value: TextTypes.Varieties.NON_FICTION },
										TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION)
									)
								)
							)
						),
						React.createElement(
							"label",
							null,
							"URL"
						),
						React.createElement("input", { className: "form-control", type: "url",
							placeholder: "https://www.example.com/your-awesome-article",
							onChange: function onChange(e) {
								return _this3.setState({ url: e.target.value.trim() });
							} }),
						React.createElement(
							"div",
							{ className: "text-center" },
							React.createElement(LoadingButton, { className: "btn buttonSuccess addButton",
								disabled: !this.isValid(),
								loading: this.state.loading,
								text: "Add URL",
								onClick: this.submitTasks })
						)
					)
				);
			}
		}]);
	
		return AddManualURLPick;
	}(React.Component)) || _class);
	;
	
	var URL_REGEX = "[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)";
	
	AddManualURLPick.WrappedComponent.propTypes = StrictPropTypes({
		toggleAssign: PropTypes.func.isRequired,
	
		// Handlers from @connect
		createBook: PropTypes.func
	});
	
	module.exports = AddManualURLPick;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var ReadingActions = __webpack_require__(27);
	var SmartBookSearch = __webpack_require__(118);
	var Modal = __webpack_require__(18);
	
	__webpack_require__(3731);
	
	var AddTitlePick = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			createBook: function createBook(book) {
				return dispatch(ReadingActions.createBook({ book: book }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(AddTitlePick, _React$Component);
	
		function AddTitlePick(props) {
			_classCallCheck(this, AddTitlePick);
	
			var _this = _possibleConstructorReturn(this, (AddTitlePick.__proto__ || Object.getPrototypeOf(AddTitlePick)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(AddTitlePick, [{
			key: "addText",
			value: function addText(book) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Added Title!", text: "You have added a title for your students.", icon: "ok-sign"
				});
	
				this.props.toggleAssign(book);
			}
		}, {
			key: "onAddTitle",
			value: function onAddTitle(book) {
				var _this2 = this;
	
				if (book.flagPlaceholder) {
					return;
				}
				if (book.text_id) {
					this.addText(book);
				} else {
					this.props.createBook(book).then(function (response) {
						_this2.addText(response.books[0]);
					});
				}
			}
		}, {
			key: "render",
			value: function render() {
				var noteText = React.createElement(
					"p",
					{ className: "noteText" },
					React.createElement(
						"b",
						null,
						"Note:"
					),
					" Books assigned here are not available via Whooo\u2019s Reading. Be sure your students have access to the text before assigning."
				);
				return React.createElement(
					"div",
					{ className: "addTitlePick" },
					noteText,
					React.createElement(SmartBookSearch, { onBookSelect: this.onAddTitle })
				);
			}
		}]);
	
		return AddTitlePick;
	}(React.Component)) || _class);
	;
	
	AddTitlePick.WrappedComponent.propTypes = StrictPropTypes({
		toggleAssign: PropTypes.func.isRequired,
	
		// Handlers from @connect
		createBook: PropTypes.func.isRequired
	});
	
	module.exports = AddTitlePick;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var TextTypes = __webpack_require__(38);
	var Features = __webpack_require__(16);
	
	var ReadingLevelDisplay = __webpack_require__(243);
	var ReadingLevelFormat = __webpack_require__(72);
	
	var StudentDisplay = __webpack_require__(52);
	var StudentListDisplay = __webpack_require__(163);
	var StudentAvatar = __webpack_require__(35);
	
	var RosterSelectors = __webpack_require__(6);
	var UIActions = __webpack_require__(41);
	var PaywallModal = __webpack_require__(44);
	
	__webpack_require__(3734);
	
	var ReadingLevelTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			students: RosterSelectors.students({ state: state, conditions: { ids: props.userIDs } }),
			clozeEnabled: Features.isEnabled(Features.CLOZE_ASSESSMENTS)
		};
	}, function (dispatch, props) {
		return {
			showRLDPaywall: function showRLDPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ReadingLevelTable, _React$Component);
	
		function ReadingLevelTable(props) {
			_classCallCheck(this, ReadingLevelTable);
	
			var _this = _possibleConstructorReturn(this, (ReadingLevelTable.__proto__ || Object.getPrototypeOf(ReadingLevelTable)).call(this));
	
			autobind(_this);
	
			_this.state = { expanded: false };
			return _this;
		}
	
		_createClass(ReadingLevelTable, [{
			key: "getReadingLevel",
			value: function getReadingLevel(userID, date) {
				var matches = _.where(this.props.readingLevels, {
					student_id: userID, assessment_date: date
				});
				return _.sortBy(matches, "created_at").reverse()[0];
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var dates = this.props.dates.slice().reverse();
	
				var rows = _.map(this.props.students, function (student) {
					var userID = student.id;
	
					var studentInfoCell = React.createElement(
						"td",
						null,
						React.createElement(
							"div",
							{ className: "avatarBox hideOnPrint" },
							React.createElement(StudentAvatar, { studentID: userID, maxWidth: 30 })
						),
						React.createElement(
							"div",
							{ className: "names" },
							React.createElement(StudentDisplay, { studentID: userID }),
							React.createElement(StudentListDisplay, { studentID: userID })
						)
					);
	
					var assessmentCells = dates.map(function (date) {
						var rl = _this2.getReadingLevel(userID, date);
						var status = student.cloze_status;
	
						if (status && status.trigger && status.date === date) {
							var progress = Math.round(100 * status.current / status.target);
							var rlDisplay = React.createElement(
								"span",
								null,
								progress,
								"% Complete"
							);
						} else if (rl) {
							var rlDisplay = React.createElement(ReadingLevelDisplay, { lexile: rl.reading_level });
						} else {
							var rlDisplay = "-";
						}
	
						return React.createElement(
							"td",
							{ key: date },
							rlDisplay
						);
					});
	
					return React.createElement(
						"tr",
						{ key: userID },
						studentInfoCell,
						React.createElement(
							"td",
							null,
							React.createElement(ReadingLevelDisplay, { lexile: student.current_reading_level }),
							React.createElement(
								"div",
								{ className: "rlOrigin" },
								ReadingLevelFormat.getOriginName(student.current_reading_level_origin)
							)
						),
						assessmentCells
					);
				});
	
				var assessmentHeaderCells = dates.map(function (date) {
					return React.createElement(
						"th",
						{ key: date },
						$wr.formatDateWithoutTimezone(date, "MMM D"),
						" Diagnostic"
					);
				});
	
				if (!this.props.clozeEnabled) {
					var rldPrompt = React.createElement(
						"p",
						{ className: "rldText" },
						"Measure your students\u2019 reading levels throughout the year with our",
						React.createElement(
							"a",
							{ onClick: function onClick() {
									return _this2.props.showRLDPaywall();
								} },
							React.createElement(
								"i",
								null,
								" Reading Level Diagnostics "
							)
						),
						" tool."
					);
				} else {
					var rldLink = React.createElement(
						"p",
						{ className: "hideOnPrint" },
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/settings/reading-level?showRLD=true" },
							"Schedule Reading Level Assessment"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "readingLevelTable" },
					rldPrompt,
					rldLink,
					React.createElement(
						"table",
						{ className: "table table-bordered" },
						React.createElement(
							"tbody",
							null,
							React.createElement(
								"tr",
								null,
								React.createElement(
									"th",
									{ className: "studentColumn" },
									"Student"
								),
								React.createElement(
									"th",
									null,
									"Most Recent"
								),
								assessmentHeaderCells
							),
							rows
						)
					)
				);
			}
		}]);
	
		return ReadingLevelTable;
	}(React.Component)) || _class);
	
	
	ReadingLevelTable.WrappedComponent.propTypes = StrictPropTypes({
		userIDs: PropTypes.array.isRequired,
		readingLevels: PropTypes.array.isRequired,
		dates: PropTypes.array.isRequired,
		hasRLDs: PropTypes.bool,
	
		// Data from @connect
		students: PropTypes.array,
		clozeEnabled: PropTypes.bool,
	
		// Handlers from @connect
		showRLDPaywall: PropTypes.func
	});
	
	module.exports = ReadingLevelTable;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookCover = __webpack_require__(140);
	
	__webpack_require__(3737);
	
	var BookSidebar = function (_React$Component) {
		_inherits(BookSidebar, _React$Component);
	
		function BookSidebar(props) {
			_classCallCheck(this, BookSidebar);
	
			var _this = _possibleConstructorReturn(this, (BookSidebar.__proto__ || Object.getPrototypeOf(BookSidebar)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(BookSidebar, [{
			key: "selectBook",
			value: function selectBook(text_id) {
				if (this.props.onBookSelect) {
					this.props.onBookSelect(text_id);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var sortedBooks = $wr.sortByName(this.props.books, "bookTitle");
				var smallBooks = _.map(sortedBooks, function (book) {
					if (this.props.selectedTextID == book.text_id) {
						var className = " selectedBook";
					}
					return React.createElement(
						"div",
						{ className: "bookContainer book" + book.text_id + className, key: book.text_id,
							onClick: this.selectBook.bind(this, book.text_id) },
						React.createElement(BookCover, { book: book, coverWidth: 50,
							showTitle: true, showAuthor: false })
					);
				}.bind(this));
				return React.createElement(
					"div",
					{ className: "bookSidebar" },
					smallBooks
				);
			}
		}]);
	
		return BookSidebar;
	}(React.Component);
	
	BookSidebar.propTypes = StrictPropTypes({
		books: PropTypes.array.isRequired,
	
		selectedTextID: PropTypes.string,
	
		onBookSelect: PropTypes.func
	});
	
	module.exports = BookSidebar;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CoinDisplay = __webpack_require__(121);
	var Spinner = __webpack_require__(9);
	var QuizAnalysisDisplay = __webpack_require__(967);
	var FeedbackFormatter = __webpack_require__(73);
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3738);
	
	var CoinDetailsModal = function (_React$Component) {
		_inherits(CoinDetailsModal, _React$Component);
	
		function CoinDetailsModal() {
			_classCallCheck(this, CoinDetailsModal);
	
			return _possibleConstructorReturn(this, (CoinDetailsModal.__proto__ || Object.getPrototypeOf(CoinDetailsModal)).apply(this, arguments));
		}
	
		_createClass(CoinDetailsModal, [{
			key: "deFrame",
			value: function deFrame() {
				if ($('#bookDetailFrame').length > 0) {
					var frame = $('#bookDetailFrame')[0].firstChild;
					$(frame).css('overflow', 'visible');
				}
			}
		}, {
			key: "reFrame",
			value: function reFrame() {
				if ($('#bookDetailFrame').length > 0) {
					var frame = $('#bookDetailFrame')[0].firstChild;
					$(frame).css('overflow', 'scroll');
				}
			}
		}, {
			key: "show",
			value: function show() {
				this.deFrame();
				this.refs.modal.show();
			}
		}, {
			key: "getShortReasonText",
			value: function getShortReasonText(coinRecord) {
				if (!CurrentUser.isPremiumAccount()) {
					return "Completed Quiz";
				} else if (coinRecord.key == "passed-quiz") {
					return "Passed the quiz";
				} else if (coinRecord.key == "failed-quiz") {
					return "Took the quiz";
				} else if (coinRecord.key.includes("addressed-feedback")) {
					return "Listened to Owlfonso's advice";
				} else if (coinRecord.key == "journal-activity-question") {
					return "Answered the question";
				} else if (coinRecord.key == "journal-activity-review") {
					return "Wrote the review";
				}
				return FeedbackFormatter.formatSimple(coinRecord.reason);
			}
		}, {
			key: "showCoinTable",
			value: function showCoinTable() {
				$(this.refs.coinTable).show(300);
			}
		}, {
			key: "renderCoinTable",
			value: function renderCoinTable(f_height, s_height) {
	
				var totalCoinsEarned = 0;
				var coinRows = _.map(this.props.coinRecords, function (coinRecord) {
					totalCoinsEarned += coinRecord.change;
					return React.createElement(
						"tr",
						{ key: coinRecord.id },
						React.createElement(
							"td",
							{ className: "subCoins" },
							React.createElement(CoinDisplay, { coins: coinRecord.change, height: f_height })
						),
						React.createElement(
							"td",
							null,
							this.getShortReasonText(coinRecord)
						)
					);
				}.bind(this));
	
				var totalCoinsRow = React.createElement(
					"tr",
					{ className: "totalCoinsRow", key: Math.random() },
					React.createElement(
						"td",
						null,
						React.createElement(CoinDisplay, { coins: totalCoinsEarned, height: s_height })
					),
					React.createElement(
						"td",
						null,
						"Total"
					)
				);
	
				return React.createElement(
					"table",
					{ className: "coinTable" },
					React.createElement(
						"tbody",
						null,
						coinRows,
						totalCoinsRow
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
	
				// did they receive coins for anything other than addressing feedback?
				var nonFeedbackCoinRecords = _.filter(this.props.coinRecords, function (coinRecord) {
					return !coinRecord.key.includes("addressed-feedback");
				});
				// if they didn't, show the disclaimer
				if (nonFeedbackCoinRecords.length == 0) {
					if (this.props.coinRecords.length > 0) {
						// if there happen to be feedback coin records, tell them the day
						var dayOfMax = $wr.formatDate(this.props.coinRecords[0].created_at);
					} else {
						// otherwise, it's not worth figuring out what day this is
						var dayOfMax = "this day";
					}
					var coinMaxDisclaimer = React.createElement(
						"p",
						{ className: "coinMaxDisclaimer" },
						"Note: You already earned the max coins for ",
						this.props.subjectNoun,
						" for ",
						dayOfMax,
						"."
					);
				}
				var modalClass = "coinDetailsModal";
				if (this.props.subjectNoun == "quizzes" && this.props.evaluation && this.props.evaluation.autograder_version >= "v3-beta") {
					var coinTable = React.createElement(
						"div",
						{ className: "hiddenElement", ref: "coinTable" },
						this.renderCoinTable(15, 18),
						coinMaxDisclaimer
					);
					modalClass += " fullSize";
					var headerText = "Quiz Details";
					var analysis = React.createElement(QuizAnalysisDisplay, {
						delay: 600,
						quiz: this.props.subject,
						showCoinTable: this.showCoinTable.bind(this) });
				} else {
					modalClass += " smallSize";
					var headerText = "Coins Earned";
					var coinTable = React.createElement(
						"div",
						null,
						this.renderCoinTable(22, 30),
						coinMaxDisclaimer
					);
				}
				return React.createElement(
					Modal,
					{ className: modalClass, ref: "modal", headerText: headerText, onHide: this.reFrame },
					React.createElement(
						"div",
						{ className: "innerWrap" },
						React.createElement(
							"div",
							{ className: "clearfix" },
							analysis,
							coinTable
						)
					)
				);
			}
		}]);
	
		return CoinDetailsModal;
	}(React.Component);
	
	;
	
	CoinDetailsModal.propTypes = StrictPropTypes({
		// gold records to display
		coinRecords: PropTypes.array.isRequired,
	
		subjectID: PropTypes.number,
		subject: PropTypes.object,
		evaluation: PropTypes.object,
	
		// quizzes, answers, reviews
		subjectNoun: PropTypes.string.isRequired
	
	});
	
	module.exports = CoinDetailsModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Board = __webpack_require__(168);
	var ResponseModal = __webpack_require__(175);
	var TeacherViewResponseModal = __webpack_require__(993);
	
	__webpack_require__(350);
	
	var ExercisesDisplay = function (_React$Component) {
		_inherits(ExercisesDisplay, _React$Component);
	
		function ExercisesDisplay(props) {
			_classCallCheck(this, ExercisesDisplay);
	
			var _this = _possibleConstructorReturn(this, (ExercisesDisplay.__proto__ || Object.getPrototypeOf(ExercisesDisplay)).call(this));
	
			autobind(_this);
			_this.state = { expandedResponse: null };
			return _this;
		}
	
		_createClass(ExercisesDisplay, [{
			key: "expandActivity",
			value: function expandActivity(activity) {
				// We added a reference to the response onto the activity
				var response = activity.response_reference;
				if (response && response.draft) {
					$wr.redirect("/responses/new?text_id=" + response.text_id + "&activity_id=" + response.activity_id);
				} else {
					this.setState({ expandedResponse: response }, function () {
						this.refs.responseModal.show();
					}.bind(this));
				}
			}
		}, {
			key: "expandResponse",
			value: function expandResponse(response) {
				// Two methods because this component is for both teachers and students, which is
				// way more trouble than it's worth
				this.setState({ expandedResponse: response }, function () {
					this.refs.responseModal.show();
				}.bind(this));
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.book.responses.length == 0 && !this.props.draftsOnly) {
					if (CurrentUser.isStudent()) {
						var exercisesContent = React.createElement(
							"div",
							{ className: "emptySection" },
							"Exercises you do about this book go here. ",
							React.createElement(
								"a",
								{ href: "#", onClick: this.props.startExerciseF },
								"Start an exercise"
							),
							"!"
						);
					} else {
						var exercisesContent = React.createElement(
							"div",
							{ className: "emptySection" },
							"There are no exercises completed for this text."
						);
					}
				} else {
					if (CurrentUser.isStudent() && !this.props.draftsOnly) {
						var exerciseLink = React.createElement(
							"a",
							{ href: "#", className: "exerciseLink",
								onClick: this.props.startExerciseF },
							"Start Another Exercise"
						);
					}
	
					if (this.props.draftsOnly) {
						var responsesToDisplay = _.filter(this.props.book.responses, function (response) {
							return response.draft == true;
						});
					} else if (this.props.hideDrafts) {
						var responsesToDisplay = _.filter(this.props.book.responses, function (response) {
							return response.draft == false;
						});
					} else {
						var responsesToDisplay = this.props.book.responses;
					}
	
					var activities = _.map(responsesToDisplay, function (response) {
						var activityData = _.extend({}, response.activity, { response_reference: response });
						return activityData;
					}.bind(this));
	
					if (CurrentUser.isStudent()) {
						if (this.state.expandedResponse) {
							var responseModal = React.createElement(ResponseModal, { ref: "responseModal", key: this.state.expandedResponse.id,
								responseID: this.state.expandedResponse.id, user: CurrentUser.get() });
						};
						var exercisesContent = React.createElement(
							"div",
							null,
							React.createElement(Board, { type: Board.STUDENT_ACTIVITIES, items: activities,
								onTileClick: this.expandActivity, narrowBoard: true,
								hideAssignAction: true }),
							responseModal
						);
					} else {
						if (this.state.expandedResponse) {
							var responseModal = React.createElement(TeacherViewResponseModal, { key: this.state.expandedResponse.id, ref: "responseModal",
								response: this.state.expandedResponse, student: this.props.student });
						}
	
						var exercisesContent = React.createElement(
							"div",
							null,
							React.createElement(Board, { type: Board.TEACHER_RESPONSES, narrowBoard: true,
								items: responsesToDisplay, loading: false,
								onTileClick: this.expandResponse }),
							responseModal
						);
					}
				}
				return React.createElement(
					"div",
					{ className: "exercisesContent" },
					exerciseLink,
					exercisesContent
				);
			}
		}]);
	
		return ExercisesDisplay;
	}(React.Component);
	
	ExercisesDisplay.propTypes = StrictPropTypes({
		book: PropTypes.object.isRequired,
	
		// optional function, for linking to start an exercise in empty state
		startExerciseF: PropTypes.func,
		hideAssignAction: PropTypes.bool,
	
		// whether to show only drafts / no drafts
		draftsOnly: PropTypes.bool,
		hideDrafts: PropTypes.bool,
	
		// required for teacher view of exercises
		student: PropTypes.object
	});
	
	module.exports = ExercisesDisplay;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookDisplay = __webpack_require__(46);
	var SkillsetBanner = __webpack_require__(252);
	var BookRating = __webpack_require__(192);
	var StudentAvatar = __webpack_require__(35);
	var ReactTooltip = __webpack_require__(12);
	
	// var AnswersDisplay = require("components/reading/shelves/AnswersDisplay");
	var ReviewsDisplay = __webpack_require__(858);
	var ExercisesDisplay = __webpack_require__(853);
	var CoinsEarnedDisplay = __webpack_require__(193);
	
	var AltBoard = __webpack_require__(248);
	var ResponseModal = __webpack_require__(175);
	var EmptyStateContainer = __webpack_require__(80);
	var AnswerCircle = __webpack_require__(939);
	var CommentBox = __webpack_require__(119);
	var Features = __webpack_require__(16);
	var ArbitrarySubjects = __webpack_require__(107);
	var AnswerAnalysisDisplay = __webpack_require__(950);
	var MultiPartAnswerDisplay = __webpack_require__(172);
	var WarmupQuestionsDisplay = __webpack_require__(987);
	var TopicQuestion = __webpack_require__(104);
	var LogReadingModal = __webpack_require__(164);
	
	var ScoreDisplay = __webpack_require__(103);
	var QuizDisplay = __webpack_require__(174);
	var AnswerDisplay = __webpack_require__(171);
	var ExerciseTile = __webpack_require__(251);
	
	var WritingSelectors = __webpack_require__(14);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	var GradeLevel = __webpack_require__(40);
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(350);
	
	var ExpandedBookDetails = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var book = ReadingSelectors.book({ state: state, id: props.textID });
		if (book) {
			var textID = book.text_id;
		}
	
		if (props.studentIDs) {
			// Indicates class view... for now
			var students = RosterSelectors.studentsForBookTextID({ state: state, textID: textID });
			var avatarsByStudentID = {};
			_underscore2.default.each(students, function (s) {
				avatarsByStudentID[s.id] = RosterSelectors.avatarForStudent({ state: state, studentID: s.id });
			});
	
			// Class shelf
			return {
				book: book,
				students: students, avatarsByStudentID: avatarsByStudentID,
				answers: WritingSelectors.nonQuizAnswers({ state: state, conditions: { textID: textID, userID: userID } }),
				reviews: WritingSelectors.reviews({ state: state, conditions: { textID: textID, userID: userID } }),
				questionBuilder: WritingSelectors.metaCognitiveAnswers({ state: state, conditions: { textID: textID, userID: userID } })
			};
		} else {
			var userID = CurrentUser.get().id;
	
			// My shelf
			return {
				book: book,
				visibleScores: CurrentUser.get().prefs.visible_student_scores,
				quiz: WritingSelectors.quizzes({ state: state, conditions: { textID: textID, userID: userID } })[0],
				answers: WritingSelectors.nonQuizAnswers({ state: state, conditions: { textID: textID, userID: userID } }),
				reviews: WritingSelectors.reviews({ state: state, conditions: { textID: textID, userID: userID } }),
				responses: WritingSelectors.responses({ state: state, conditions: { textID: textID, userID: userID } }),
				questionBuilders: WritingSelectors.metaCognitiveAnswers({ state: state, conditions: { textID: textID, userID: userID } })
			};
		}
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
	
				if (props.studentIDs) {
					// Indicates class view... for now
					var embeds = ["book.reviews", "book.average_rating", "book.students", "student.avatar"];
					if (CurrentUser.get().prefs.answers_on_class_shelf) {
						embeds = embeds.concat(["book.answers", "answer.question"]);
					}
					var query = { user_ids: props.studentIDs };
				} else {
					var embeds = ["book.responses", "response.activity", "activity.format_summary", "book.answers", "answer.question", "book.reviews", "book.ratings", "book.quizzes", "quiz.answers", "quiz.gold_records", "answer.gold_records", "quiz.evaluation", "quiz.warmup_questions"];
	
					if (CurrentUser.get().prefs.visible_student_scores) {
						embeds = embeds.concat(["answer.evaluation", "evaluation.score_details"]);
					}
	
					var conditions = { allowDraft: true };
				}
	
				return dispatch(ReadingActions.fetchSingleBookActivity({ id: props.textID, embeds: embeds, query: query, conditions: conditions, cache: props.textID }));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ExpandedBookDetails, _React$Component);
	
		function ExpandedBookDetails(props) {
			_classCallCheck(this, ExpandedBookDetails);
	
			var _this = _possibleConstructorReturn(this, (ExpandedBookDetails.__proto__ || Object.getPrototypeOf(ExpandedBookDetails)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("ExpandedBookDetails");
			// right now this only affects quizzes, but we could use it later for journal activities
			var showCoinDetailsModal = $wr.getURLParameterByName("showDetails") == "true";
			_this.state = {
				expandedResponse: null, showCoinDetailsModal: showCoinDetailsModal, showBookModal: false
			};
			return _this;
		}
	
		_createClass(ExpandedBookDetails, [{
			key: "startQuestion",
			value: function startQuestion(e) {
				$wr.nope(e);
				$wr.redirect("/answers/new?text_id=" + this.props.book.text_id);
			}
		}, {
			key: "startReview",
			value: function startReview(e) {
				$wr.nope(e);
				$wr.redirect("/reviews/new?text_id=" + this.props.book.text_id);
			}
		}, {
			key: "startExercise",
			value: function startExercise(e) {
				$wr.nope(e);
				$wr.redirect("/responses/new?text_id=" + this.props.book.text_id);
			}
		}, {
			key: "startQuiz",
			value: function startQuiz(e) {
				$wr.nope(e);
				$wr.redirect("/quiz?text_id=" + this.props.book.text_id);
			}
		}, {
			key: "startQuestionBuilder",
			value: function startQuestionBuilder(e) {
				$wr.nope(e);
				$wr.redirect("/question_builder/new?text_id=" + this.props.book.text_id);
			}
		}, {
			key: "renderEmptyState",
			value: function renderEmptyState(introText, buttonText, clickEvent) {
				return React.createElement(
					"p",
					{ className: "emptySection" },
					introText,
					React.createElement(
						"a",
						{ href: "#", onClick: clickEvent },
						buttonText
					),
					"!"
				);
			}
		}, {
			key: "renderQuestionBuilderView",
			value: function renderQuestionBuilderView() {
				var introText = 'Questions you build about this book go here.';
				var buttonText = ' Build a question';
				var emptyClickEvent = this.startQuestionBuilder;
	
				if (_underscore2.default.isEmpty(this.props.questionBuilders)) {
					return this.renderEmptyState(introText, buttonText, emptyClickEvent);
				} else {
	
					var draftQuestionBuilder = _underscore2.default.map(_underscore2.default.where(this.props.questionBuilders, { draft: true }), function (questionBuilder) {
	
						return React.createElement(AnswerDisplay, { answerID: questionBuilder.id, key: questionBuilder.id });
					});
	
					if (CurrentUser.get().prefs.allow_student_writing_deletion) {
						var showRemove = true;
					}
	
					var revisionQuestionBuilder = _underscore2.default.map(_underscore2.default.where(this.props.questionBuilders, { allow_revision: true }), function (questionBuilder) {
	
						return React.createElement(AnswerDisplay, {
							answerID: questionBuilder.id,
							key: questionBuilder.id,
							viewAsStudent: true,
							enabled: {
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove
								//coinsEarned: true,
								//startRevision: true,
								//cancelRevision: true
							}
						});
						//}
					});
	
					var completedQuestionBuilder = _underscore2.default.map(_underscore2.default.where(this.props.questionBuilders, { draft: false, allow_revision: false }), function (questionBuilder) {
						return React.createElement(AnswerDisplay, {
							answerID: questionBuilder.id,
							key: questionBuilder.id,
							viewAsStudent: true,
							enabled: {
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove
								//coinsEarned: true,
							}
						});
					});
	
					return React.createElement(
						"div",
						null,
						draftQuestionBuilder,
						revisionQuestionBuilder,
						completedQuestionBuilder
					);
				}
			}
		}, {
			key: "renderAnswersView",
			value: function renderAnswersView() {
				var _this2 = this;
	
				var introText = 'Questions you answer about this book go here.';
				var buttonText = ' Answer a question';
				var emptyClickEvent = this.startQuestion;
				if (_underscore2.default.isEmpty(this.props.answers)) {
					return this.renderEmptyState(introText, buttonText, emptyClickEvent);
				} else {
					var revisionAnswers = _underscore2.default.map(_underscore2.default.where(this.props.answers, { allow_revision: true }), function (answer) {
						return React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
							view: "answer", viewAsStudent: true,
							enabled: {
								score: _this2.props.visibleScores,
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove,
								coinsEarned: true,
								startRevision: true,
								cancelRevision: true
							} });
					});
	
					if (CurrentUser.get().prefs.allow_student_writing_deletion) {
						var showRemove = true;
					}
	
					var completedAnswers = _underscore2.default.map(_underscore2.default.where(this.props.answers, { draft: false, allow_revision: false }), function (answer) {
						return React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
							view: "answer", viewAsStudent: true,
							enabled: {
								score: _this2.props.visibleScores,
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove,
								coinsEarned: true
							} });
					});
	
					if (_underscore2.default.isEmpty(revisionAnswers) && _underscore2.default.isEmpty(completedAnswers)) {
						return this.renderEmptyState(introText, buttonText, emptyClickEvent);
					} else {
						return React.createElement(
							"div",
							{ className: "answersList" },
							revisionAnswers,
							completedAnswers
						);
					}
				}
			}
		}, {
			key: "renderReviewsView",
			value: function renderReviewsView() {
				var _this3 = this;
	
				var introText = "Reviews you write about this book go here. If you're done with the book,";
				var buttonText = 'write a review';
				var emptyClickEvent = this.startReview;
				if (_underscore2.default.isEmpty(this.props.reviews)) {
					return this.renderEmptyState(introText, buttonText, emptyClickEvent);
				} else {
					if (CurrentUser.get().prefs.allow_student_writing_deletion) {
						var showRemove = true;
					}
	
					var completedReviews = _underscore2.default.map(_underscore2.default.where(this.props.reviews, { draft: false }), function (review) {
						return React.createElement(AnswerDisplay, { answerID: review.id, key: review.id, view: "review", viewAsStudent: true,
							enabled: {
								score: _this3.props.visibleScores,
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove,
								coinsEarned: true,
								startRevision: true,
								cancelRevision: true
							} });
					});
	
					if (_underscore2.default.isEmpty(completedReviews)) {
						return this.renderEmptyState(introText, buttonText, emptyClickEvent);
					} else {
						return React.createElement(
							"div",
							{ className: "reviewsList" },
							completedReviews
						);
					}
				}
			}
		}, {
			key: "renderExercisesView",
			value: function renderExercisesView() {
				var introText = "Exercises you do about this book go here. ";
				var buttonText = 'Start an exercise';
				var emptyClickEvent = this.startExercise;
				if (_underscore2.default.isEmpty(this.props.responses)) {
					return this.renderEmptyState(introText, buttonText, emptyClickEvent);
				} else {
					var responses = _underscore2.default.sortBy(this.props.responses, function (response) {
						return response.demo + "-" + response.completed_at;
					});
					var responseTiles = _underscore2.default.map(responses, function (response) {
						return React.createElement(ExerciseTile, { responseID: response.id, key: response.id,
							smallThumbnail: true, allowExpandResponse: true });
					});
					if (_underscore2.default.isEmpty(responseTiles)) {
						return this.renderEmptyState(introText, buttonText, emptyClickEvent);
					} else {
						return React.createElement(
							"div",
							{ className: "responsesList" },
							React.createElement(
								AltBoard,
								{ narrowBoard: true },
								responseTiles
							)
						);
					}
				}
			}
		}, {
			key: "renderQuizzesView",
			value: function renderQuizzesView() {
				var quiz = this.props.quiz;
				var introText = "The quiz you take on this book goes here. If you're done with the book, ";
				var buttonText = 'do the quiz';
				var emptyClickEvent = this.startQuiz;
				if (!quiz) {
					return this.renderEmptyState(introText, buttonText, emptyClickEvent);
				} else if (quiz.draft) {
					return React.createElement(
						"p",
						{ className: "emptySection" },
						"Your progress on this quiz is saved. If you're ready to do more, ",
						React.createElement(
							"a",
							{ href: "#", onClick: this.startQuiz },
							"finish the quiz"
						),
						"!"
					);
				} else {
					var quiz;
					if (this.props.visibleScores && !quiz.excluded) {
						var quizScoreDisplay = React.createElement(ScoreDisplay, { subjectID: quiz.id, subjectType: "Quiz",
							showDenominator: true, mode: ScoreDisplay.CIRCLE_MODE });
					}
	
					if (this.props.view == "quizzes" && this.props.visibleScores) {
						var className = "quizzesTopRight";
					}
	
					var quizCoinsDisplay = React.createElement(CoinsEarnedDisplay, { subjectType: "Quiz", subjectID: quiz.id });
	
					if (CurrentUser.get().prefs.allow_student_writing_deletion) {
						var showRemove = true;
					}
	
					return React.createElement(
						"div",
						{ className: "quizContent" },
						React.createElement(
							"div",
							{ className: "topRightContainer " + className },
							quizScoreDisplay,
							quizCoinsDisplay
						),
						React.createElement(QuizDisplay, { quizID: quiz.id, view: AnswerDisplay.QUIZZES_VIEW,
							viewAsStudent: true,
							enabled: {
								lowerComments: true,
								date: true,
								editControls: showRemove,
								deletion: showRemove,
								startRevision: true,
								cancelRevision: true
							} })
					);
				}
			}
		}, {
			key: "renderDraftView",
			value: function renderDraftView() {
				var quiz = this.props.quiz;
				var reviews = _underscore2.default.where(this.props.reviews, { draft: true });
				var answers = _underscore2.default.where(this.props.answers, { draft: true });
				var responses = _underscore2.default.where(this.props.responses, { draft: true });
				var questionBuilders = _underscore2.default.where(this.props.questionBuilders, { draft: true });
	
				if (quiz && quiz.draft) {
					var quizContent = React.createElement(
						"p",
						{ className: "emptySection" },
						"Your progress on this quiz is saved. If you're ready to do more, ",
						React.createElement(
							"a",
							{ href: "#", onClick: this.startQuiz },
							"finish the quiz"
						),
						"!"
					);
				}
				if (reviews.length) {
					var reviewContent = _underscore2.default.map(reviews, function (review) {
						return React.createElement(AnswerDisplay, { answerID: review.id, key: review.id, asDraft: true });
					});
				}
				if (answers.length) {
					var answerContent = _underscore2.default.map(answers, function (answer) {
						return React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id, asDraft: true });
					});
				}
				if (responses.length) {
					var responseTiles = _underscore2.default.map(responses, function (response) {
						return React.createElement(ExerciseTile, { responseID: response.id, key: response.id,
							smallThumbnail: true, allowExpandResponse: true });
					});
	
					var responseContent = React.createElement(
						AltBoard,
						{ narrowBoard: true },
						responseTiles
					);
				}
	
				if (questionBuilders.length) {
					var questionBuildContent = _underscore2.default.map(questionBuilders, function (questionBuilder) {
						return React.createElement(AnswerDisplay, { answerID: questionBuilder.id, key: questionBuilder.id });
					});
				}
	
				return React.createElement(
					"div",
					{ className: "draftContent" },
					quizContent,
					reviewContent,
					answerContent,
					responseContent,
					questionBuildContent
				);
			}
		}, {
			key: "renderClassReviewsView",
			value: function renderClassReviewsView() {
				var book = this.props.book;
	
				if (this.props.reviews.length == 0 && (this.props.answers == null || this.props.answers.length == 0)) {
					if (CurrentUser.isStudent()) {
						var emptyState = React.createElement(
							"p",
							null,
							"Nobody in your class has reviewed ",
							React.createElement(
								"em",
								null,
								book.title
							),
							" yet. If you've read it, ",
							React.createElement(
								"a",
								{ href: "#", onClick: this.startReview },
								"write your review"
							),
							"!"
						);
					} else {
						var emptyState = React.createElement(
							"p",
							null,
							"Nobody in this class has reviewed ",
							React.createElement(
								"em",
								null,
								book.title
							),
							" yet."
						);
					}
				} else {
					if (this.props.answers != null && this.props.answers.length > 0) {
						var bookAnswers = _underscore2.default.map(this.props.answers, function (answer) {
							return React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
								enabled: {
									student: true,
									date: true
								} });
						});
					}
					if (this.props.reviews.length > 0) {
						var bookReviews = _underscore2.default.map(this.props.reviews, function (review) {
							return React.createElement(AnswerDisplay, { answerID: review.id, key: review.id,
								enabled: {
									student: true,
									date: true
								} });
						});
					}
				}
	
				return React.createElement(
					"div",
					{ className: "classReviewsContent" },
					emptyState,
					bookReviews,
					bookAnswers
				);
			}
		}, {
			key: "renderClassBookStats",
			value: function renderClassBookStats() {
				var _this4 = this;
	
				var book = this.props.book;
				var uniqueStudents = _underscore2.default.uniq(_underscore2.default.map(this.props.students, function (student) {
					return student.id;
				}));
				var sortedStudents = $wr.sortByName(uniqueStudents, "lastName");
	
				var students = _underscore2.default.map(this.props.students, function (student) {
					var avatar = _this4.props.avatarsByStudentID[student.id];
					return React.createElement(
						"div",
						{ key: student.id, className: "studentAvatar b-tooltip", "data-tip": student.display_name },
						React.createElement(StudentAvatar, { student: student, disableAnimation: true, avatar: avatar, maxWidth: 30 }),
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				});
	
				if (book.average_rating != null) {
					var bookRating = React.createElement(
						"div",
						{ className: "ratingContainer" },
						React.createElement(BookRating, { editable: false, currentRating: book.average_rating }),
						" ",
						React.createElement("br", null)
					);
				}
				return React.createElement(
					"div",
					{ className: "bookStats" },
					bookRating,
					React.createElement(
						"p",
						{ className: "readersLabel" },
						"Readers:"
					),
					React.createElement(
						"div",
						{ className: "bookStudents" },
						students
					)
				);
			}
		}, {
			key: "closeLogReading",
			value: function closeLogReading() {
				this.setState({ showBookModal: false });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER)) {
					var fullBookContent = this.renderAnswersView();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW)) {
					var fullBookContent = this.renderReviewsView();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE)) {
					var fullBookContent = this.renderExercisesView();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER)) {
					var fullBookContent = this.renderQuizzesView();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT)) {
					var fullBookContent = this.renderDraftView();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK)) {
					var fullBookContent = this.renderClassReviewsView();
					var bookStatsContent = this.renderClassBookStats();
				} else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER)) {
					var fullBookContent = this.renderQuestionBuilderView();
				}
	
				if (CurrentUser.get().prefs.prompt_log_reading) {
					var bookModal = React.createElement(LogReadingModal, { initialBook: this.props.book,
						open: this.state.showBookModal,
						key: this.props.book.text_id,
						onClose: this.closeLogReading });
				}
	
				var showReadingLevel = CurrentUser.get().prefs.show_students_zpd_icon && this.props.view != ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK);
	
				return React.createElement(
					"div",
					{ className: "expandedBookDetails", ref: "content" },
					React.createElement(
						"div",
						{ className: "bookInformationContainer" },
						React.createElement(BookDisplay, { textID: this.props.textID, coverWidth: 75,
							showCover: true, showAuthor: true, showReadingLevel: showReadingLevel }),
						bookStatsContent
					),
					React.createElement(
						"div",
						{ className: "fullBookArea" },
						fullBookContent
					),
					bookModal
				);
			}
		}, {
			key: "updateHeight",
			value: function updateHeight() {
				if (this.props.onHeightUpdated) {
					var height = $(this.refs.content).height();
					this.props.onHeightUpdated(height);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.updateHeight();
				var showBookModal = $wr.getURLParameterByName("showDetails") == "true";
				this.setState({ showBookModal: showBookModal });
	
				// Lord this is hacky
				this.resizeInterval = setInterval(function () {
					$wr.triggerResize();
				}, 500);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				clearInterval(this.resizeInterval);
			}
		}]);
	
		return ExpandedBookDetails;
	}(React.Component)) || _class) || _class);
	
	
	ExpandedBookDetails.WrappedComponent.propTypes = StrictPropTypes({
		view: PropTypes.string.isRequired,
		studentIDs: PropTypes.array,
		textID: PropTypes.string,
		students: PropTypes.array,
		avatarsByStudentID: PropTypes.object,
	
		// Data from @connect
		book: PropTypes.object,
	
		quiz: PropTypes.object,
		answers: PropTypes.array,
		reviews: PropTypes.array,
		responses: PropTypes.array,
		questionBuilder: PropTypes.array,
	
		visibleScores: PropTypes.bool,
		onHeightUpdated: PropTypes.func, // Update css for printing
		// Handlers from @connect
		populateData: PropTypes.func
	});
	
	ExpandedBookDetails.ANSWERS_VIEW = "answers-view";
	ExpandedBookDetails.REVIEWS_VIEW = "reviews-view";
	ExpandedBookDetails.EXERCISES_VIEW = "exercises-view";
	ExpandedBookDetails.QUIZZES_VIEW = "quizzes-view";
	ExpandedBookDetails.QUESTION_BUILDER_VIEW = "question-builder-view";
	
	ExpandedBookDetails.CLASS_REVIEWS_VIEW = "class-reviews-view";
	
	module.exports = ExpandedBookDetails;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookDisplay = __webpack_require__(46);
	var BookGrid = __webpack_require__(403);
	var CoinsEarnedDisplay = __webpack_require__(193);
	var PaginationControls = __webpack_require__(90);
	
	var AltBoard = __webpack_require__(248);
	var StudentTasks = __webpack_require__(244);
	var ScoreDisplay = __webpack_require__(103);
	var QuizDisplay = __webpack_require__(174);
	var AnswerDisplay = __webpack_require__(171);
	var ExerciseTile = __webpack_require__(251);
	
	var ReadingActions = __webpack_require__(27);
	
	var ArbitrarySubjects = __webpack_require__(107);
	
	var WritingSelectors = __webpack_require__(14);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(350);
	
	var ExpandedWorkDetails = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var userID = CurrentUser.get().id;
	  // My shelf
	  return {
	    visibleScores: CurrentUser.get().prefs.visible_student_scores,
	    quizzes: WritingSelectors.quizzes({ state: state, conditions: { userID: userID, allowDraft: true } }),
	    answers: WritingSelectors.nonQuizAnswers({ state: state, conditions: { userID: userID } }),
	    reviews: WritingSelectors.reviews({ state: state, conditions: { userID: userID } }),
	    responses: WritingSelectors.responses({ state: state, conditions: { userID: userID } }),
	    tasks: WritingSelectors.tasks({ state: state, conditions: { userID: userID } }),
	    questionBuilders: WritingSelectors.metaCognitiveAnswers({ state: state, conditions: { userID: userID } }),
	    books: ReadingSelectors.books({ state: state, conditions: { userID: userID, allowDraft: true, nonBlank: ["text_id", "title"] } })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var textID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var filters = {
	        user_id: CurrentUser.get().id,
	        order: "desc-last-active",
	        draft: true
	      };
	      var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];
	
	      return dispatch(ReadingActions.fetchBookActivity({
	        filters: filters, embeds: embeds,
	        fetchDetails: true,
	        cache: true
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(ExpandedWorkDetails, _React$Component);
	
	  function ExpandedWorkDetails(props) {
	    _classCallCheck(this, ExpandedWorkDetails);
	
	    var _this = _possibleConstructorReturn(this, (ExpandedWorkDetails.__proto__ || Object.getPrototypeOf(ExpandedWorkDetails)).call(this));
	
	    autobind(_this);
	
	    LuckyOrangeClient.tagComponent("ExpandedWorkDetails");
	    _this.state = {
	      currentQuizPage: 1,
	      currentReviewPage: 1,
	      currentAnswerPage: 1,
	      userID: CurrentUser.get().id
	    };
	    return _this;
	  }
	
	  _createClass(ExpandedWorkDetails, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initScrollbar();
	    }
	    // dynamically sets height for draft scrollbar
	
	  }, {
	    key: "initScrollbar",
	    value: function initScrollbar() {
	      if ($(this.refs.draftContentWrap).length) {
	        this.setState({ minWindoHeight: window.innerHeight - $(this.refs.draftContentWrap).offset().top - 30 });
	      }
	    }
	    // for separation on draft page
	
	  }, {
	    key: "renderDividerSection",
	    value: function renderDividerSection(title) {
	      return React.createElement(
	        "div",
	        { className: "dividerSection" },
	        React.createElement("div", { className: "dividerArea" }),
	        React.createElement(
	          "div",
	          { className: "nameArea" },
	          React.createElement(
	            "span",
	            { className: "nameString" },
	            title
	          )
	        )
	      );
	    }
	    // pagination on quiz section
	
	  }, {
	    key: "onQuizPageChange",
	    value: function onQuizPageChange(page) {
	      this.setState({ currentQuizPage: page });
	    }
	    // pagination on review section
	
	  }, {
	    key: "onReviewPageChange",
	    value: function onReviewPageChange(page) {
	      this.setState({ currentReviewPage: page });
	    }
	    // pagination on answer section
	
	  }, {
	    key: "onAnswerPageChange",
	    value: function onAnswerPageChange(page) {
	      this.setState({ currentAnswerPage: page });
	    }
	  }, {
	    key: "goToBook",
	    value: function goToBook(text_id) {
	      $wr.redirect("/quiz?text_id=" + text_id);
	    }
	  }, {
	    key: "handleEmptyLink",
	    value: function handleEmptyLink(e) {
	      $wr.nope(e);
	      $wr.redirect("/?bookSearchDropdown=" + e.target.className);
	    }
	    //  renders question builders
	
	  }, {
	    key: "renderQuestionBuilderView",
	    value: function renderQuestionBuilderView() {
	      var _this2 = this;
	
	      // render empty text
	      var completedQuestionBuildersFromProps = _.where(this.props.questionBuilders, { draft: false });
	      completedQuestionBuildersFromProps = _.sortBy(completedQuestionBuildersFromProps, function (questionBuilder) {
	        return -new Date(questionBuilder.completed_at);
	      });
	      if (_.isEmpty(completedQuestionBuildersFromProps)) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "You have not finished a question builders yet. If you're done with a book,",
	          React.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "question-builder", onClick: this.handleEmptyLink },
	            " do a question builders!"
	          )
	        );
	      } else {
	        if (CurrentUser.get().prefs.allow_student_writing_deletion) {
	          var showRemove = true;
	        }
	        // group answers by book
	        var questionBuildersByText = (0, _underscore.groupBy)(completedQuestionBuildersFromProps, 'text_id');
	        var textIDArray = _.uniq(_.map(completedQuestionBuildersFromProps, function (questionBuilders) {
	          return questionBuilders.text_id;
	        }));
	        // placeholders for completed component arrays
	        var completedQuestionBuilders = [];
	        var revisionQuestionBuilders = [];
	        // loop through books
	        // Note: in the past, temp revision answers and completed answers
	        // have been kept separate and rendered one after another
	        textIDArray.forEach(function (text_id) {
	          // add 1 book cover per book
	          var bookCover = React.createElement(BookDisplay, { key: text_id, textID: text_id, coverWidth: 75, showCover: true, showAuthor: true });
	          // store all temp revision answers for the book
	          var tempRevisionQuestionBuilders = _.map(_.where(questionBuildersByText[text_id], { draft: false, allow_revision: true }), function (answer, index) {
	            var bookDisplayPresent = _.size(tempRevisionAnswers) && index == 0;
	            return React.createElement(
	              "div",
	              { className: "questionBuilderList myWorkAnswers" },
	              React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
	                view: "question-builder", viewAsStudent: true,
	                enabled: {
	                  score: _this2.props.visibleScores,
	                  lowerComments: true,
	                  date: true,
	                  editControls: showRemove,
	                  deletion: showRemove,
	                  coinsEarned: true,
	                  startRevision: true,
	                  cancelRevision: true,
	                  bookDisplayPresent: bookDisplayPresent
	                } })
	            );
	          });
	          // store all answers for the book
	          var tempCompletedQuestionBuilders = _.map(_.where(questionBuildersByText[text_id], { draft: false, allow_revision: false }), function (answer) {
	            return React.createElement(
	              "div",
	              { className: "questionBuilderList myWorkAnswers", key: answer.completed_at },
	              React.createElement(AnswerDisplay, { answerID: answer.id,
	                view: "question-builder", viewAsStudent: true,
	                enabled: {
	                  score: _this2.props.visibleScores,
	                  lowerComments: true,
	                  date: true,
	                  editControls: showRemove,
	                  deletion: showRemove,
	                  coinsEarned: false
	                } })
	            );
	          });
	          // add completed answers to placholder array
	          var tempCompletedAnswersList = React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: text_id },
	            bookCover,
	            tempCompletedQuestionBuilders
	          );
	          completedQuestionBuilders = [].concat(_toConsumableArray(completedQuestionBuilders), [tempCompletedAnswersList]);
	          // add temp revision answers to placholder array
	          if (tempRevisionQuestionBuilders.length > 0) {
	            var tempRevisionAnswersList = React.createElement(
	              "div",
	              { className: "bookInformationContainer myWorkContainer", key: text_id },
	              bookCover,
	              tempRevisionQuestionBuilders
	            );
	            revisionQuestionBuilders = [].concat(_toConsumableArray(revisionQuestionBuilders), [tempRevisionAnswersList]);
	          }
	        });
	        // combine temp revision answers and completed answers
	        var allQuestionBuilders = [].concat(_toConsumableArray(revisionQuestionBuilders), _toConsumableArray(completedQuestionBuilders));
	        // chunck all answers for pagination
	        var allQuestionBuilderDisplay = _.chunk(allQuestionBuilders, PER_PAGE)[this.state.currentAnswerPage - 1];
	        //	pagination control
	        var pagination = React.createElement(PaginationControls, { page: this.state.currentAnswerPage,
	          perPage: PER_PAGE,
	          totalCount: allQuestionBuilders.length,
	          onPageChange: this.onAnswerPageChange });
	
	        return React.createElement(
	          "div",
	          { className: "fullBookInformationContainer" },
	          pagination,
	          allQuestionBuilderDisplay,
	          pagination
	        );
	      }
	    }
	  }, {
	    key: "renderAnswersView",
	    value: function renderAnswersView() {
	      var _this3 = this;
	
	      // render empty text
	      var completedAnswers = _.where(this.props.answers, { draft: false });
	      completedAnswers = _.sortBy(completedAnswers, function (answer) {
	        return -new Date(answer.completed_at);
	      });
	      if (_.isEmpty(completedAnswers)) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "You have not finished a paractice question yet. If you're done with a book,",
	          React.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "questions", onClick: this.handleEmptyLink },
	            " answer a practice question!"
	          )
	        );
	      } else {
	        if (CurrentUser.get().prefs.allow_student_writing_deletion) {
	          var showRemove = true;
	        }
	        // group answers by book
	        var answersByText = (0, _underscore.groupBy)(completedAnswers, 'text_id');
	        var textIDArray = _.uniq(_.map(completedAnswers, function (answer) {
	          return answer.text_id;
	        }));
	        // placeholders for completed component arrays
	        var completedAnswers = [];
	        var revisionAnswers = [];
	        // loop through books
	        // Note: in the past, temp revision answers and completed answers
	        // have been kept separate and rendered one after another
	        textIDArray.forEach(function (text_id) {
	          // add 1 book cover per book
	          var bookCover = React.createElement(BookDisplay, { key: text_id, textID: text_id, coverWidth: 75, showCover: true, showAuthor: true });
	          // store all temp revision answers for the book
	          var tempRevisionAnswers = _.map(_.where(answersByText[text_id], { draft: false, allow_revision: true }), function (answer, index) {
	            var bookDisplayPresent = index == 0;
	            return React.createElement(
	              "div",
	              { className: "answersList myWorkAnswers" },
	              React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id,
	                view: "answer", viewAsStudent: true,
	                enabled: {
	                  score: _this3.props.visibleScores,
	                  lowerComments: true,
	                  date: true,
	                  editControls: showRemove,
	                  deletion: showRemove,
	                  coinsEarned: true,
	                  startRevision: true,
	                  cancelRevision: true,
	                  bookDisplayPresent: bookDisplayPresent
	                } })
	            );
	          });
	          // store all answers for the book
	          var tempCompletedAnswers = _.map(_.where(answersByText[text_id], { draft: false, allow_revision: false }), function (answer, index) {
	            var bookDisplayPresent = !_.size(tempRevisionAnswers) && index == 0;
	            return React.createElement(
	              "div",
	              { className: "answersList myWorkAnswers", key: answer.completed_at },
	              React.createElement(AnswerDisplay, { answerID: answer.id,
	                view: "answer", viewAsStudent: true,
	                enabled: {
	                  score: _this3.props.visibleScores,
	                  lowerComments: true,
	                  date: true,
	                  editControls: showRemove,
	                  deletion: showRemove,
	                  coinsEarned: false,
	                  bookDisplayPresent: bookDisplayPresent
	                } })
	            );
	          });
	          // add completed answers to placholder array
	          var tempCompletedAnswersList = React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: text_id },
	            bookCover,
	            tempCompletedAnswers
	          );
	          completedAnswers = [].concat(_toConsumableArray(completedAnswers), [tempCompletedAnswersList]);
	          // add temp revision answers to placholder array
	          if (tempRevisionAnswers.length > 0) {
	            var tempRevisionAnswersList = React.createElement(
	              "div",
	              { className: "bookInformationContainer myWorkContainer", key: text_id },
	              bookCover,
	              tempRevisionAnswers
	            );
	            revisionAnswers = [].concat(_toConsumableArray(revisionAnswers), [tempRevisionAnswersList]);
	          }
	        });
	        // combine temp revision answers and completed answers
	        var allAnswers = [].concat(_toConsumableArray(revisionAnswers), _toConsumableArray(completedAnswers));
	        // chunck all answers for pagination
	        var allAnswerDisplay = _.chunk(allAnswers, PER_PAGE)[this.state.currentAnswerPage - 1];
	        //	pagination control
	        var pagination = React.createElement(PaginationControls, { page: this.state.currentAnswerPage,
	          perPage: PER_PAGE,
	          totalCount: allAnswers.length,
	          onPageChange: this.onAnswerPageChange });
	
	        return React.createElement(
	          "div",
	          { className: "fullBookInformationContainer" },
	          pagination,
	          allAnswerDisplay,
	          pagination
	        );
	      }
	    }
	  }, {
	    key: "renderReviewsView",
	    value: function renderReviewsView() {
	      var _this4 = this;
	
	      var completedReviews = _.where(this.props.reviews, { draft: false });
	      completedReviews = _.sortBy(completedReviews, function (review) {
	        return -new Date(review.completed_at);
	      });
	      if (_.isEmpty(completedReviews)) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "You have not finished a review yet. If you're done with a book,",
	          React.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "reviews", onClick: this.handleEmptyLink },
	            " write a review!"
	          )
	        );
	      } else {
	        if (CurrentUser.get().prefs.allow_student_writing_deletion) {
	          var showRemove = true;
	        }
	        // pull all non-draft reviews and group by book
	        var reviewsByText = (0, _underscore.groupBy)(completedReviews, 'text_id');
	        var textIDArray = _.uniq(_.map(completedReviews, function (review) {
	          return review.text_id;
	        }));
	        var completedReviews = [];
	        // loop through books
	        textIDArray.forEach(function (text_id) {
	          // add book cover
	          var bookCover = React.createElement(BookDisplay, { key: text_id, textID: text_id, coverWidth: 75, showCover: true, showAuthor: true });
	          // add all reviews under the book cover
	          // should only be 1 review per book
	          var tempCompletedReviews = _.map(_.where(reviewsByText[text_id], { draft: false }), function (review) {
	            return React.createElement(
	              "div",
	              { className: "reveiwsList", key: review.completed_at },
	              React.createElement(AnswerDisplay, { answerID: review.id, key: review.id, view: "review", viewAsStudent: true,
	                enabled: {
	                  score: _this4.props.visibleScores,
	                  lowerComments: true,
	                  date: true,
	                  editControls: showRemove,
	                  deletion: showRemove,
	                  coinsEarned: true,
	                  startRevision: true,
	                  cancelRevision: true
	                } })
	            );
	          });
	
	          var tempCompletedReviewsList = React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: text_id },
	            bookCover,
	            tempCompletedReviews
	          );
	          // add to completed reviews placeholder
	          completedReviews = [].concat(_toConsumableArray(completedReviews), [tempCompletedReviewsList]);
	        });
	        // chunk for pagination
	        completedReviews = _.chunk(completedReviews, PER_PAGE)[this.state.currentReviewPage - 1];
	
	        var pagination = React.createElement(PaginationControls, { page: this.state.currentReviewPage,
	          perPage: PER_PAGE,
	          totalCount: completedReviews.length,
	          onPageChange: this.onReviewPageChange });
	
	        return React.createElement(
	          "div",
	          { className: "reviewsList" },
	          pagination,
	          completedReviews,
	          pagination
	        );
	      }
	    }
	  }, {
	    key: "renderExercisesView",
	    value: function renderExercisesView() {
	      // filter responses by completed-only
	      var responses = _.where(this.props.responses, { draft: false });
	      responses = _.sortBy(responses, function (response) {
	        return -new Date(response.completed_at);
	      });
	      if (_.isEmpty(responses)) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "You have not finished an exercise yet.",
	          React.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "exercises", onClick: this.handleEmptyLink },
	            " Start an exercise!"
	          )
	        );
	      } else {
	        // render exercise titles (used elseware on site)
	        var responses = _.sortBy(responses, function (response) {
	          return response.demo + "-" + response.completed_at;
	        });
	        var responseTiles = _.map(responses, function (response) {
	          return React.createElement(ExerciseTile, { responseID: response.id, key: response.id,
	            smallThumbnail: true, allowExpandResponse: true });
	        });
	
	        return React.createElement(
	          "div",
	          { className: "responsesList" },
	          React.createElement(
	            AltBoard,
	            { narrowBoard: true },
	            responseTiles
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderQuizzesView",
	    value: function renderQuizzesView() {
	      var _this5 = this;
	
	      // filter quizzes for completed quizzes only
	      var quizzes = _.select(this.props.quizzes, function (quiz) {
	        return quiz.completed_at !== null;
	      });
	      quizzes = _.sortBy(quizzes, function (quiz) {
	        return -new Date(quiz.completed_at);
	      });
	      if (!quizzes || !quizzes.length) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "You have not finished a quiz yet. If you're done with a book,",
	          React.createElement(
	            _reactRouterDom.Link,
	            { to: "/", className: "quizzes-passed", onClick: this.handleEmptyLink },
	            " do the quiz!"
	          )
	        );
	      } else {
	        // chunck quizzes for pagination
	        var pagedQuizzes = _.chunk(quizzes, PER_PAGE)[this.state.currentQuizPage - 1];
	        // loop through all quizzes and display 
	        // the same way as the expanded book details page
	        var allQuizDisplay = _.map(pagedQuizzes, function (quiz) {
	          if (quiz.draft) {
	            return React.createElement(
	              "p",
	              { className: "emptySection", key: quiz.id },
	              React.createElement(BookDisplay, { textID: quiz.text_id, coverWidth: 75,
	                showCover: true, showAuthor: true, showReadingLevel: showReadingLevel }),
	              React.createElement("br", null),
	              React.createElement("br", null),
	              "Your progress on this quiz is saved. If you're ready to do more, ",
	              React.createElement(
	                "a",
	                { href: "#", onClick: _this5.startQuiz },
	                "finish the quiz"
	              ),
	              "!"
	            );
	          } else {
	            if (_this5.props.visibleScores && !quiz.excluded) {
	              var quizScoreDisplay = React.createElement(ScoreDisplay, { subjectID: quiz.id, subjectType: "Quiz",
	                showDenominator: true, mode: ScoreDisplay.CIRCLE_MODE });
	            }
	
	            if (_this5.props.view == "quizzes" && _this5.props.visibleScores) {
	              var className = "quizzesTopRight";
	            }
	
	            var quizCoinsDisplay = React.createElement(CoinsEarnedDisplay, { subjectType: "Quiz", subjectID: quiz.id });
	
	            if (CurrentUser.get().prefs.allow_student_writing_deletion) {
	              var showRemove = true;
	            }
	
	            var showReadingLevel = CurrentUser.get().prefs.show_students_zpd_icon && _this5.props.view != ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK);
	
	            return React.createElement(
	              "div",
	              { className: "bookInformationContainer myWorkContainer", key: quiz.id },
	              React.createElement(BookDisplay, { textID: quiz.text_id, coverWidth: 75,
	                showCover: true, showAuthor: true, showReadingLevel: showReadingLevel }),
	              React.createElement(
	                "div",
	                { className: "quizContent" },
	                React.createElement(
	                  "div",
	                  { className: "topRightContainer " + className },
	                  quizScoreDisplay,
	                  quizCoinsDisplay
	                ),
	                React.createElement(QuizDisplay, { quizID: quiz.id, view: AnswerDisplay.QUIZZES_VIEW,
	                  viewAsStudent: true,
	                  enabled: {
	                    lowerComments: true,
	                    date: true,
	                    editControls: showRemove,
	                    deletion: showRemove,
	                    startRevision: true,
	                    cancelRevision: true
	                  } })
	              )
	            );
	          }
	        });
	        var pagination = React.createElement(PaginationControls, { page: this.state.currentQuizPage,
	          perPage: PER_PAGE,
	          totalCount: quizzes.length,
	          onPageChange: this.onQuizPageChange });
	
	        return React.createElement(
	          "div",
	          { className: "allQuizDisplay" },
	          pagination,
	          allQuizDisplay,
	          pagination
	        );
	      }
	    }
	  }, {
	    key: "renderDraftView",
	    value: function renderDraftView() {
	      var minWindoHeight = 0;
	      if ($(this.refs.draftContentWrap).length) {
	        var minWindoHeight = window.innerHeight - $(this.refs.draftContentWrap).offset().top - 30;
	      }
	      // filter books by incomplete
	      // TODO: find a better way to do this....
	      var books = _.filter(this.props.books, function (book) {
	        if (book['activity:any:any'] !== undefined && book['activity:any:any'].quiz_draft_counts !== undefined) {
	          return book;
	        }
	      });
	      // filter all other activities by draft-only
	      var reviews = _.where(this.props.reviews, { draft: true });
	      var answers = _.where(this.props.answers, { draft: true });
	      var responses = _.where(this.props.responses, { draft: true });
	      var questionBuilders = _.where(this.props.questionBuilders, { draft: true });
	
	      // render book grid
	      if (books) {
	        var quizContent = React.createElement(BookGrid, { books: books,
	          onBookSelect: this.goToBook
	        });
	      }
	      // render reviews
	      if (reviews.length) {
	        var reviewContent = _.map(reviews, function (review) {
	          return React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: review.text_id },
	            React.createElement(BookDisplay, { key: review.text_id, textID: review.text_id, coverWidth: 75, showCover: true, showAuthor: true }),
	            React.createElement(AnswerDisplay, { answerID: review.id, key: review.id, asDraft: true })
	          );
	        });
	      }
	      if (answers.length) {
	        // render answers
	        var answerContent = _.map(answers, function (answer) {
	          return React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: answer.text_id },
	            React.createElement(BookDisplay, { key: answer.text_id, textID: answer.text_id, coverWidth: 75, showCover: true, showAuthor: true }),
	            React.createElement(AnswerDisplay, { answerID: answer.id, key: answer.id, asDraft: true })
	          );
	        });
	      }
	      // render exercises
	      if (responses.length) {
	        var responseTiles = _.map(responses, function (response) {
	          return React.createElement(ExerciseTile, { responseID: response.id, key: response.id,
	            smallThumbnail: true, allowExpandResponse: true });
	        });
	
	        var responseContent = React.createElement(
	          AltBoard,
	          { narrowBoard: true },
	          responseTiles
	        );
	      }
	      // render question Builders
	      if (questionBuilders.length) {
	        var questionBuilderContent = _.map(questionBuilders, function (questionBuilder) {
	          return React.createElement(
	            "div",
	            { className: "bookInformationContainer myWorkContainer", key: questionBuilder.text_id },
	            React.createElement(BookDisplay, { key: questionBuilder.text_id, textID: questionBuilder.text_id, coverWidth: 75, showCover: true, showAuthor: true }),
	            React.createElement(AnswerDisplay, { answerID: questionBuilder.id, key: questionBuilder.id, asDraft: true })
	          );
	        });
	      }
	
	      return React.createElement(
	        "div",
	        { ref: "draftContentWrap" },
	        React.createElement(
	          _reactCustomScrollbars.Scrollbars,
	          { autoHeight: true, ref: "scrollbars", autoHeightMin: minWindoHeight },
	          React.createElement(
	            "div",
	            { className: "draftContent" },
	            books.length > 0 ? this.renderDividerSection('Quizzes') : '',
	            books.length > 0 ? quizContent : '',
	            reviews.length > 0 ? this.renderDividerSection('Reviews') : '',
	            reviews.length > 0 ? reviewContent : '',
	            answers.length > 0 ? this.renderDividerSection('Answers') : '',
	            answers.length > 0 ? answerContent : '',
	            responses.length > 0 ? this.renderDividerSection('Exercises') : '',
	            responses.length > 0 ? responseContent : '',
	            questionBuilders.length > 0 ? this.renderDividerSection('Question Builders') : '',
	            questionBuilders.length > 0 ? questionBuilderContent : ''
	          )
	        )
	      );
	    }
	
	    // placeholder for later
	
	  }, {
	    key: "renderTeachersPickView",
	    value: function renderTeachersPickView() {}
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER)) {
	        var fullBookContent = this.renderAnswersView();
	      } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW)) {
	        var fullBookContent = this.renderReviewsView();
	      } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE)) {
	        var fullBookContent = this.renderExercisesView();
	      } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER)) {
	        var fullBookContent = this.renderQuizzesView();
	      } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT)) {
	        var fullBookContent = this.renderDraftView();
	      } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER)) {
	        var fullBookContent = this.renderQuestionBuilderView();
	      }
	      // else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.TEACHERS_PICK_VIEW)) {
	      // 	if (this.props.tasks.length > 0) {
	      // 		var fullBookContent = this.renderTeachersPickView();
	      // 	}
	      // }
	
	      return React.createElement(
	        "div",
	        { className: "expandedBookDetails", ref: "content" },
	        React.createElement(
	          "div",
	          { className: "fullBookArea" },
	          fullBookContent
	        )
	      );
	    }
	  }]);
	
	  return ExpandedWorkDetails;
	}(React.Component)) || _class) || _class);
	
	
	var PER_PAGE = 5;
	
	ExpandedWorkDetails.WrappedComponent.propTypes = StrictPropTypes({
	  view: PropTypes.string,
	  // Data from @connect
	  reviews: PropTypes.array,
	  responses: PropTypes.array,
	  answers: PropTypes.array,
	  quizzes: PropTypes.array,
	  activities: PropTypes.array,
	  tasks: PropTypes.array,
	  books: PropTypes.array,
	  questionBuilders: PropTypes.array,
	  visibleScores: PropTypes.bool,
	  // Handlers from @connect
	  populateData: PropTypes.func
	});
	
	ExpandedWorkDetails.ANSWERS_VIEW = "answers-view";
	ExpandedWorkDetails.REVIEWS_VIEW = "reviews-view";
	ExpandedWorkDetails.EXERCISES_VIEW = "exercises-view";
	ExpandedWorkDetails.QUIZZES_VIEW = "quizzes-view";
	ExpandedWorkDetails.TEACHERS_PICK_VIEW = "teachers-pick";
	
	ExpandedWorkDetails.CLASS_REVIEWS_VIEW = "class-reviews-view";
	
	module.exports = ExpandedWorkDetails;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3740);
	
	var CurrentUser = __webpack_require__(3);
	
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var BookShelf = __webpack_require__(404);
	var Spinner = __webpack_require__(9);
	var DisplayToggleControl = __webpack_require__(48);
	var LogCalendar = __webpack_require__(241);
	var AllMonthsLogTable = __webpack_require__(240);
	var Features = __webpack_require__(16);
	var MyWorkDisplay = __webpack_require__(857);
	
	var MyShelfRouting = __webpack_require__(74);
	
	var MyShelfPage = (_dec = (0, _LocationState.provideLocationState)(MyShelfRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		// TODO: Pass books in from reswift too
		// TODO: Only pass logs for the current view
		var userID = CurrentUser.get().id;
	
		return {
			logs: ReadingSelectors.logs({ state: state, conditions: { userID: userID } }),
			isLoadingLogs: ReadingSelectors.isLoadingLogs({ state: state })
		};
	}, function (dispatch, props) {
		var userID = CurrentUser.get().id;
	
		return {
			populateLogs: function populateLogs() {
				return dispatch(ReadingActions.fetchLogs({
					conditions: { userID: userID }
				}));
			}
		};
	}), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(MyShelfPage, _React$Component);
	
		function MyShelfPage(props) {
			_classCallCheck(this, MyShelfPage);
	
			var _this = _possibleConstructorReturn(this, (MyShelfPage.__proto__ || Object.getPrototypeOf(MyShelfPage)).call(this));
	
			autobind(_this);
	
			_this.state = {
				view: SHELF_VIEW,
	
				books: null, loading: false
			};
			return _this;
		}
	
		_createClass(MyShelfPage, [{
			key: "switchActiveView",
			value: function switchActiveView(viewKey) {
				Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
				this.switchView({ activeView: viewKey });
			}
		}, {
			key: "switchView",
			value: function switchView(change) {
				var locationState = _extends({}, this.props.locationState);
				if (change.backToShelf) {
					locationState.activeView = MyShelfRouting.VIEWS.SHELF_VIEW;
					change = { textID: undefined };
				}
				var newLocationState = _.extend({}, locationState, change);
				if (newLocationState.activeView === 'work' && newLocationState.detailsView === undefined) {
					newLocationState.detailsView = 'quizzes';
				}
				$wr.redirect(MyShelfRouting.getPath(newLocationState));
			}
	
			// routeParams(props) {
			// 	props = props || this.props;
			// 	if (props && props.match) {
			// 		return props.match.params || {};
			// 	} else {
			// 		return {};
			// 	}
			// }
	
			// routeActiveView(props) {
			// 	var params = this.routeParams(props);
	
			// 	if (params.active_view == "shelf") {
			// 		return SHELF_VIEW;
			// 	} else if (params.active_view == "reading") {
			// 		return LOGS_VIEW;
			// 	}
			// }
			// isLogView() {
			// 	return !this.isShelfView();
			// }
	
			// routeDetailsView(props) {
			// 	return this.routeParams(props).details_view;
			// }
	
			// routeTextID(props) {
			// 	return this.routeParams(props).text_id;
			// }
	
			// onViewChange(activeView) {
			// 	this.switchView(activeView);
			// }
	
			// switchView(activeView, detailsView, textID) {
			// 	if (this.state.loading) { return; }
			// 	if (detailsView && textID) {
			// 		$wr.redirect("/my/" + activeView + "/" + detailsView + "/" + textID);
			// 	} else {
			// 		$wr.redirect("/my/" + activeView);
			// 	}
			// }
	
		}, {
			key: "isShelfView",
			value: function isShelfView() {
				return this.props.locationState.activeView == MyShelfRouting.VIEWS.SHELF_VIEW;
			}
		}, {
			key: "isWorkView",
			value: function isWorkView() {
				return this.props.locationState.activeView == MyShelfRouting.VIEWS.WORK_VIEW;
			}
		}, {
			key: "loadBooks",
			value: function loadBooks() {
				// You might want to use these embeds at some point, but they're technically not needed now:
				// "book.average_rating"
				var params = {
					user_id: CurrentUser.get().id,
					order: "desc-last-active",
					draft: true,
					merge_text_data: true,
					embed: "book.quiz_user_ids,book.quiz_draft_user_ids"
				};
	
				this.setState({ loading: true });
				CurrentUser.api().getBooks(params, $wr.apiHandler(function (response) {
					var books = (this.state.books || []).concat(response.books);
					this.setState({ books: books, loading: false });
				}.bind(this)));
			}
		}, {
			key: "render",
			value: function render() {
				var lState = this.props.locationState;
	
				var pageClassName = "container myShelfPage";
	
				var toggleOptions = [{ key: MyShelfRouting.VIEWS.SHELF_VIEW, text: "My Books" }, { key: MyShelfRouting.VIEWS.WORK_VIEW, text: "My Work" }];
	
				if (Features.isEnabled(Features.LOG_READING)) {
					toggleOptions.unshift({ key: MyShelfRouting.VIEWS.LOGS_VIEW, text: "My Reading" });
				}
				var displayToggleOptions = '';
				if (!this.isWorkView()) {
					displayToggleOptions = React.createElement(
						"div",
						{ className: "hideOnPrint" },
						React.createElement(DisplayToggleControl, { options: toggleOptions, className: "topToggle",
							onChange: this.switchActiveView,
							activeOptionKey: lState.activeView })
					);
				}
	
				pageClassName += " withToggle";
	
				if (this.isShelfView()) {
					var pageContent = React.createElement(BookShelf, { detailsView: lState.detailsView,
						textID: lState.textID,
						switchView: this.switchView });
				} else if (this.isWorkView()) {
					var pageContent = React.createElement(MyWorkDisplay, { detailsView: lState.detailsView,
						switchView: this.switchView });
				} else {
					if (this.props.isLoadingLogs) {
						var pageContent = React.createElement(Spinner, { placeholder: true, scale: 1.7, className: "shelfSpin" });
					} else {
						var pageContent = React.createElement(
							"div",
							{ className: "logsWrap" },
							React.createElement(LogCalendar, { logs: this.props.logs }),
							React.createElement(AllMonthsLogTable, { logs: this.props.logs })
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: pageClassName },
					React.createElement(
						"div",
						{ className: "headerSection clearfix" },
						React.createElement(
							"header",
							{ className: "pageHeader" },
							React.createElement(
								"h1",
								{ className: "hideOnPrint" },
								"My Shelf"
							)
						),
						displayToggleOptions
					),
					pageContent
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if ($wr.didParamsChange(prevProps, this.props)) {
					this.loadPageContent();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.loadPageContent();
			}
		}, {
			key: "loadPageContent",
			value: function loadPageContent() {
				if (!this.isShelfView()) {
					this.props.populateLogs();
				}
			}
		}]);
	
		return MyShelfPage;
	}(React.Component)) || _class) || _class);
	
	
	MyShelfPage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object,
	
		// From @connect
		logs: PropTypes.array,
		isLoadingLogs: PropTypes.bool,
		populateLogs: PropTypes.func
	});
	
	var SHELF_VIEW = "shelf";
	var LOGS_VIEW = "reading";
	
	module.exports = MyShelfPage;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _StrictPropTypes;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _WritingSelectors = __webpack_require__(14);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3741);
	
	var CurrentUser = __webpack_require__(3);
	
	
	var DisplayToggleControl = __webpack_require__(48);
	var ExpandedWorkDetails = __webpack_require__(855);
	
	var ArbitrarySubjects = __webpack_require__(107);
	var Features = __webpack_require__(16);
	
	var Glyphicon = __webpack_require__(8);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var DataActions = __webpack_require__(65);
	var DataSelectors = __webpack_require__(54);
	
	var MyShelfRouting = __webpack_require__(74);
	
	var MyWorkDisplay = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var userID = CurrentUser.get().id;
	
	  var draftQuizzes = WritingSelectors.quizzes({
	    state: state, conditions: { userID: userID }, filters: { draft: true }
	  });
	  var draftAnswers = WritingSelectors.nonQuizAnswers({
	    state: state, conditions: { userID: userID }, filters: { draft: true }
	  });
	  var draftReviews = WritingSelectors.reviews({
	    state: state, conditions: { userID: userID }, filters: { draft: true }
	  });
	  var draftResponses = WritingSelectors.responses({
	    state: state, conditions: { userID: userID }, filters: { draft: true }
	  });
	  var draftQuestionBuilders = WritingSelectors.metaCognitiveAnswers({
	    state: state, conditions: { userID: userID }, filters: { draft: true }
	  });
	
	  var draftCount = draftQuizzes.length + draftAnswers.length + draftReviews.length + draftResponses.length + draftQuestionBuilders.length;;
	
	  var quizzes = WritingSelectors.quizzes({ state: state, conditions: { userID: userID } });
	  var answers = WritingSelectors.nonQuizAnswers({ state: state, filters: { userID: userID } });
	  var reviews = WritingSelectors.reviews({ state: state, conditions: { userID: userID } });
	  var activities = WritingSelectors.activities({ state: state, conditions: { userID: userID } });
	  var tasks = WritingSelectors.tasks({ state: state, conditions: { userID: userID } });
	  var questionBuilders = WritingSelectors.metaCognitiveAnswers({ state: state, conditions: { userID: userID } });
	
	  return { userID: userID, quizzes: quizzes, answers: answers, reviews: reviews, activities: activities, tasks: tasks, questionBuilders: questionBuilders, draftCount: draftCount };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // TODO: trello card made to convert this to BE pagination
	      var conditions = { allowDraft: true, perPage: 1000 };
	      // get quizzes
	      var filters = {
	        user_id: CurrentUser.get().id,
	        draft: true
	      };
	      var embeds = ["quiz.gold_records", "quiz.answer_ids"];
	
	      var quizzes = dispatch(WritingActions.fetchQuizzes({
	        filters: filters, embeds: embeds,
	        conditions: { noPagination: true },
	        fetchDetails: false,
	        cache: true
	      }));
	
	      // get responses
	      filters = {
	        user_id: CurrentUser.get().id,
	        draft: true
	      };
	      var responses = dispatch(WritingActions.fetchResponses({
	        filters: filters,
	        embeds: ["response.activity", "activity.format_summary"],
	        draft: true,
	        cache: true
	      }));
	
	      // get tasks
	      filters = {
	        user_id: CurrentUser.get().id,
	        draft: true
	      };
	      embeds = ["activity.format_summary", 'task.task_items'];
	
	      var tasks = dispatch(WritingActions.fetchTasks({
	        filters: filters, embeds: embeds,
	        fetchDetails: true,
	        conditions: conditions,
	        cache: true
	      }));
	      // get answers
	      filters = {
	        user_id: CurrentUser.get().id,
	        draft: true
	      };
	      var embeds = ["answer.question", "question.answer_options", "answer.evaluation", "evaluation.score_details", "answer.meta_data", "answer.gold_records"];
	      var answers = dispatch(WritingActions.fetchAnswers({
	        filters: filters, embeds: embeds,
	        fetchDetails: true,
	        conditions: conditions,
	        page: 1,
	        cache: true
	      }));
	
	      return Promise.all([quizzes, responses, tasks, answers]);
	    },
	    fetchSingleBookActivity: function fetchSingleBookActivity(textID) {
	      var userID = CurrentUser.get().id;
	      var embeds = ["book.ratings", "book.quizzes", "quiz.gold_records", "quiz.evaluation", "quiz.warmup_questions", "evaluation.score_details"];
	
	      var conditions = { allowDraft: true };
	      var query = { user_id: userID };
	
	      return dispatch(ReadingActions.fetchSingleBookActivity({ id: textID, embeds: embeds, query: query, conditions: conditions, cache: props.textID }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(MyWorkDisplay, _React$Component);
	
	  function MyWorkDisplay(props) {
	    _classCallCheck(this, MyWorkDisplay);
	
	    var _this = _possibleConstructorReturn(this, (MyWorkDisplay.__proto__ || Object.getPrototypeOf(MyWorkDisplay)).call(this));
	
	    autobind(_this);
	    var quizzes = _.select(props.quizzes, function (quiz) {
	      return quiz.completed_at !== null;
	    });
	    quizzes.forEach(function (quiz) {
	      return props.fetchSingleBookActivity(quiz.text_id);
	    });
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(MyWorkDisplay, [{
	    key: "backToShelf",
	    value: function backToShelf(e) {
	      $wr.nope(e);
	      this.props.switchView({ backToShelf: true });
	    }
	  }, {
	    key: "loadWork",
	    value: function loadWork() {}
	  }, {
	    key: "onWorkDetailsViewChange",
	    value: function onWorkDetailsViewChange(detailsViewKey) {
	      this.props.switchView({ detailsView: detailsViewKey });
	    }
	  }, {
	    key: "renderQuizzesView",
	    value: function renderQuizzesView() {
	      var quiz = this.props.quiz;
	
	      if (!quiz) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "The quiz you take on this book goes here. If you're done with the book, ",
	          React.createElement(
	            "a",
	            { href: "#", onClick: this.startQuiz },
	            "do the quiz"
	          ),
	          "!"
	        );
	      } else if (quiz.draft) {
	        return React.createElement(
	          "p",
	          { className: "emptySection" },
	          "Your progress on this quiz is saved. If you're ready to do more, ",
	          React.createElement(
	            "a",
	            { href: "#", onClick: this.startQuiz },
	            "finish the quiz"
	          ),
	          "!"
	        );
	      } else {
	        var quiz;
	        if (this.props.visibleScores && !quiz.excluded) {
	          var quizScoreDisplay = React.createElement(ScoreDisplay, { subjectID: quiz.id, subjectType: "Quiz",
	            showDenominator: true, mode: ScoreDisplay.CIRCLE_MODE });
	        }
	
	        if (this.props.view == "quizzes" && this.props.visibleScores) {
	          var className = "quizzesTopRight";
	        }
	
	        var quizCoinsDisplay = React.createElement(CoinsEarnedDisplay, { subjectType: "Quiz", subjectID: quiz.id });
	
	        if (CurrentUser.get().prefs.allow_student_writing_deletion) {
	          var showRemove = true;
	        }
	
	        return React.createElement(
	          "div",
	          { className: "quizContent" },
	          React.createElement(
	            "div",
	            { className: "topRightContainer " + className },
	            quizScoreDisplay,
	            quizCoinsDisplay
	          ),
	          React.createElement(QuizDisplay, { quizID: quiz.id, view: AnswerDisplay.QUIZZES_VIEW,
	            viewAsStudent: true,
	            enabled: {
	              lowerComments: true,
	              date: true,
	              editControls: showRemove,
	              deletion: showRemove,
	              startRevision: true,
	              cancelRevision: true
	            } })
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var toggleOptions = [{ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER), text: "Quiz" }, { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER), text: "Practice Questions" }, { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW), text: "Reviews" },
	      // { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.TEACHERS_PICK), text: "Teacher Picks" },
	      { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER), text: "Question Builders" }];
	      if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
	        var exercisesKey = { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE), text: "Exercises" };
	        toggleOptions.push(exercisesKey);
	      }
	      if (this.props.draftCount > 0) {
	        var draftToggleText = "Unfinished Work (" + this.props.draftCount + ")";
	        toggleOptions.push({ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT), text: draftToggleText });
	      }
	      // show text for current view on dropdown
	      var currentDetailViewObj = _.findWhere(toggleOptions, { key: this.props.detailsView });
	      if (currentDetailViewObj && currentDetailViewObj.text) {
	        var firstOptionText = currentDetailViewObj.text;
	      } else {
	        var firstOptionText = 'Quiz';
	      }
	      // display dropdown
	      var displayToggleOptions = _.map(toggleOptions, function (option) {
	        return React.createElement(ButtonDropdownOption, { key: option.text, text: option.text,
	          onClick: _this2.onWorkDetailsViewChange.bind(_this2, option.key) });
	      });
	
	      var displayToggleOptions = React.createElement(
	        "div",
	        { className: "toggleOptionContainer" },
	        React.createElement(
	          ButtonDropdown,
	          { text: firstOptionText, dropdownDisplay: "link", className: "hideOnPrint smallObject" },
	          displayToggleOptions
	        )
	      );
	      // var displayToggleOptions = (
	      //   <div className="hideOnPrint">
	      //     <DisplayToggleControl options={toggleOptions} className="subToggle"
	      //       onChange={this.onWorkDetailsViewChange}
	      //       activeOptionKey={this.props.detailsView}
	      //     />
	      //   </div>
	      // );
	      return React.createElement(
	        "div",
	        { className: "clearfix" },
	        React.createElement(
	          "div",
	          { className: "hideOnPrint myWork" },
	          React.createElement(
	            "div",
	            { className: "sidebarWrap" },
	            React.createElement(
	              "div",
	              { className: "backLink" },
	              React.createElement(
	                "a",
	                { href: "#", onClick: this.backToShelf },
	                React.createElement(Glyphicon, { icon: "chevron-left" }),
	                " Back"
	              )
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "detailsWrap" },
	            displayToggleOptions,
	            React.createElement(ExpandedWorkDetails, { view: this.props.detailsView })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyWorkDisplay;
	}(React.Component)) || _class) || _class);
	
	
	MyWorkDisplay.WrappedComponent.propTypes = StrictPropTypes((_StrictPropTypes = {
	  // From component above
	  quizzes: PropTypes.func,
	  populateData: PropTypes.func,
	  fetchQuizzes: PropTypes.func,
	  fetchQuestions: PropTypes.func,
	  fetchAnswers: PropTypes.func,
	  fetchActivities: PropTypes.func,
	  fetchTasks: PropTypes.func,
	  fetchResponses: PropTypes.func,
	  fetchSingleBookActivity: PropTypes.func,
	
	  userID: PropTypes.number,
	  draftCount: PropTypes.number,
	  reviews: PropTypes.array
	}, _defineProperty(_StrictPropTypes, "reviews", PropTypes.array), _defineProperty(_StrictPropTypes, "responses", PropTypes.array), _defineProperty(_StrictPropTypes, "answers", PropTypes.array), _defineProperty(_StrictPropTypes, "quizzes", PropTypes.array), _defineProperty(_StrictPropTypes, "activities", PropTypes.array), _defineProperty(_StrictPropTypes, "tasks", PropTypes.array), _defineProperty(_StrictPropTypes, "questionBuilders", PropTypes.array), _defineProperty(_StrictPropTypes, "detailsView", PropTypes.string), _defineProperty(_StrictPropTypes, "switchView", PropTypes.func.isRequired), _defineProperty(_StrictPropTypes, "populateData", PropTypes.func), _StrictPropTypes));
	
	module.exports = MyWorkDisplay;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsetBanner = __webpack_require__(252);
	var BookRating = __webpack_require__(192);
	var CurrentUser = __webpack_require__(3);
	var CoinsEarnedDisplay = __webpack_require__(193);
	var MultiPartAnswerDisplay = __webpack_require__(172);
	
	var EmptyStateContainer = __webpack_require__(80);
	var CommentBox = __webpack_require__(119);
	var Features = __webpack_require__(16);
	
	__webpack_require__(3742);
	
	var ReviewsDisplay = function (_React$Component) {
		_inherits(ReviewsDisplay, _React$Component);
	
		function ReviewsDisplay(props) {
			_classCallCheck(this, ReviewsDisplay);
	
			var _this = _possibleConstructorReturn(this, (ReviewsDisplay.__proto__ || Object.getPrototypeOf(ReviewsDisplay)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(ReviewsDisplay, [{
			key: "deleteReview",
			value: function deleteReview(review) {
				if (confirm("Are you sure you want to delete this review?")) {
					CurrentUser.api().deleteAnswer(review.id, $wr.apiHandler(function (response) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Review Deleted", text: "You have deleted the review.", icon: "trash" });
						this.props.updateReviews(review);
					}.bind(this)));
				}
			}
		}, {
			key: "makeReviewDraft",
			value: function makeReviewDraft(review) {
				if (confirm("This will allow your student to make revisions to this review and resubmit. Are you sure?")) {
					var params = { answer: { draft: true, question_id: review.question_id } };
					CurrentUser.api().patchAnswer(review.id, params, $wr.apiHandler(function (response) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Review Updated", text: "You have allowed revisions for this review.", icon: "ok-sign" });
						this.props.updateReviews(review);
					}.bind(this)));
				}
			}
		}, {
			key: "render",
			value: function render() {
				var book = this.props.book;
	
				if (book.reviews.length == 0 && !this.props.draftsOnly) {
					if (CurrentUser.isStudent()) {
						var reviewsContent = React.createElement(
							"div",
							{ className: "emptySection" },
							"Reviews you write about this book go here. If you're done with the book, ",
							React.createElement(
								"a",
								{ href: "#", onClick: this.props.startReviewF },
								"write a review"
							),
							"!"
						);
					} else {
						var reviewsContent = React.createElement(
							"div",
							{ className: "emptySection" },
							"There are no reviews written for this text yet."
						);
					}
				} else {
					if (CurrentUser.isStudent()) {
						if (this.props.draftsOnly) {
							// only display the draft
							var sortedReviews = _.filter(book.reviews, function (answer) {
								return answer.draft == true;
							});
						} else {
							// sort to put the draft (if any) at the top
							var sortedReviews = _.sortBy(book.reviews, function (answer) {
								return answer.draft == false;
							});
						}
	
						if (sortedReviews.length > 0) {
							if (sortedReviews[0].draft) {
								var startReviewText = "Finish Review";
							} else {
								var startReviewText = "Write Another Review";
							}
						}
	
						if (!this.props.draftsOnly || sortedReviews.length > 0) {
							var reviewLink = React.createElement(
								"div",
								{ className: "hideOnPrint" },
								React.createElement(
									"a",
									{ href: "#", className: "reviewLink",
										onClick: this.props.startReviewF },
									startReviewText
								)
							);
						}
					} else {
						// don't display the draft for admins
						var sortedReviews = _.filter(book.reviews, function (answer) {
							return answer.draft == false;
						});
					}
	
					// only display the header and the rating for draftsOnly if there is a draft to show
					if (!this.props.draftsOnly || sortedReviews.length > 0) {
						// change its opacity if its a draft
						if (this.props.draftsOnly) {
							var draftClassName = "draftReview";
						}
						var reviewHeader = React.createElement(SkillsetBanner, { skillset: "review", classShelf: true, className: draftClassName });
						var ratings = book.ratings;
						if (ratings && ratings.length > 0) {
							var bookRating = React.createElement(
								"div",
								{ className: "bookRating" },
								React.createElement(BookRating, { editable: false, currentRating: ratings[0].value }),
								" ",
								React.createElement("br", null)
							);
						}
					}
	
					var reviewsContent = sortedReviews.map(function (review, i) {
						if (review.draft) {
							var draftClassName = "draftReview";
						} else {
							if (CurrentUser.isAdmin()) {
								var dateText = $wr.formatDateTime(review.completed_at);
								var dateLine = React.createElement(
									"span",
									{ className: "dateLine" },
									dateText
								);
								var deleteLink = React.createElement(
									"p",
									{ className: "removeReview hideOnPrint" },
									React.createElement("span", { className: "verticalDivider" }),
									React.createElement(
										"a",
										{ href: "#", onClick: this.deleteReview.bind(this, review) },
										"Remove Review"
									)
								);
								var reviseLink = React.createElement(
									"p",
									{ className: "reviseReview hideOnPrint" },
									React.createElement("span", { className: "verticalDivider" }),
									React.createElement(
										"a",
										{ href: "#", onClick: this.makeReviewDraft.bind(this, review) },
										"Allow Revision"
									)
								);
							} else {
								// only show coin display if a student and not a draft
								var reviewCoinsDisplay = React.createElement(CoinsEarnedDisplay, { coinRecords: review.gold_records, subjectType: "reviews" });
							}
						}
						var reviewsCount = sortedReviews.length;
						if (reviewsCount > 1 && i + 1 != reviewsCount) {
							var reviewClassName = "borderedReview";
						}
	
						if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
							var commentBox = React.createElement(CommentBox, { subjectID: review.id, subjectType: "JournalActivityReview",
								blockFirstComment: CurrentUser.isStudent(),
								userID: review.user_id, initialCollapsed: !CurrentUser.isStudent() });
						}
						return React.createElement(
							"div",
							{ className: "bookReview " + reviewClassName + " " + draftClassName, key: review.id },
							React.createElement(
								"div",
								{ className: "ratingContainer" },
								bookRating
							),
							reviewCoinsDisplay,
							React.createElement(
								"p",
								{ className: "detailsViewPrompt" },
								review.question_text
							),
							dateLine,
							deleteLink,
							reviseLink,
							React.createElement(
								"div",
								{ className: "reviewText" },
								React.createElement(MultiPartAnswerDisplay, { parts: review.parts })
							),
							commentBox
						);
					}.bind(this));
				}
				return React.createElement(
					"div",
					{ className: "reviewsContent" },
					reviewLink,
					reviewHeader,
					reviewsContent
				);
			}
		}]);
	
		return ReviewsDisplay;
	}(React.Component);
	
	ReviewsDisplay.propTypes = StrictPropTypes({
		book: PropTypes.object.isRequired,
	
		// optional function, for linking to start a review in empty state or from drafts
		startReviewF: PropTypes.func,
	
		updateReviews: PropTypes.func,
	
		// whether to show only drafts
		draftsOnly: PropTypes.bool
	});
	
	module.exports = ReviewsDisplay;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	var CommentForm = __webpack_require__(405);
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	
	var CommentLine = function (_React$Component) {
		_inherits(CommentLine, _React$Component);
	
		function CommentLine(props) {
			_classCallCheck(this, CommentLine);
	
			var _this = _possibleConstructorReturn(this, (CommentLine.__proto__ || Object.getPrototypeOf(CommentLine)).call(this));
	
			autobind(_this);
			_this.state = {
				editMode: false
			};
			return _this;
		}
	
		_createClass(CommentLine, [{
			key: "onDeleteClick",
			value: function onDeleteClick(e) {
				$wr.nope(e);
				if (confirm('Are you sure you want to delete this comment?')) {
					this.props.deleteComment(this.props.comment);
				}
			}
		}, {
			key: "openEdit",
			value: function openEdit(e) {
				$wr.nope(e);
				this.props.closeEditComments();
				setTimeout(function () {
					this.setState({ editMode: true });
				}.bind(this), 20);
			}
		}, {
			key: "closeEdit",
			value: function closeEdit() {
				this.setState({ editMode: false });
			}
		}, {
			key: "getCommentInfoLine",
			value: function getCommentInfoLine() {
				var comment = this.props.comment;
				var date = $wr.formatDate(comment.created_at);
	
				if (comment.secretive) {
					var secretive = React.createElement(
						"span",
						null,
						"| ",
						React.createElement(Glyphicon, { icon: "eye-close", dataTip: "Private comment" }),
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				}
				if (CurrentUser.hasID(comment.user_id)) {
					var editControl = React.createElement(
						"span",
						null,
						"| ",
						React.createElement(
							"a",
							{ href: "#", onClick: this.openEdit },
							"Edit"
						)
					);
				}
	
				if (CurrentUser.hasID(comment.user_id) || CurrentUser.isAdmin()) {
					var deleteControl = React.createElement(
						"span",
						null,
						"| ",
						React.createElement(
							"a",
							{ href: "#", onClick: this.onDeleteClick },
							"Delete"
						)
					);
				}
	
				return React.createElement(
					"span",
					{ className: "commentInfoLine" },
					date,
					" ",
					secretive,
					" ",
					editControl,
					" ",
					deleteControl
				);
			}
		}, {
			key: "onUpdateSubmit",
			value: function onUpdateSubmit(commetData) {
				this.refs.editCommentForm.reset();
				this.props.updateComment(commetData);
				this.setState({ editMode: false });
			}
		}, {
			key: "render",
			value: function render() {
				var comment = this.props.comment;
	
				if (this.state.editMode) {
					var content = React.createElement(
						"div",
						{ className: "commentEdit" },
						React.createElement(CommentForm, { comment: comment, onSubmit: this.onUpdateSubmit,
							ref: "editCommentForm" })
					);
				} else {
					var content = React.createElement(
						"div",
						{ className: "commentDisplay" },
						React.createElement(
							"div",
							{ className: "content" },
							React.createElement(
								"span",
								{ className: "commenter" },
								comment.user.display_name,
								" "
							),
							comment.body,
							React.createElement("br", null),
							this.getCommentInfoLine()
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "commentRow" },
					content
				);
			}
		}]);
	
		return CommentLine;
	}(React.Component);
	
	;
	
	CommentLine.propTypes = StrictPropTypes({
		// The comment the line is displaying
		comment: PropTypes.object.isRequired,
	
		closeEditComments: PropTypes.func,
		updateComment: PropTypes.func,
		deleteComment: PropTypes.func
	});
	
	module.exports = CommentLine;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var ValidatingInput = __webpack_require__(91);
	
	__webpack_require__(3748);
	
	var ContactModal = function (_React$Component) {
		_inherits(ContactModal, _React$Component);
	
		function ContactModal(props) {
			_classCallCheck(this, ContactModal);
	
			var _this = _possibleConstructorReturn(this, (ContactModal.__proto__ || Object.getPrototypeOf(ContactModal)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ContactModal, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "hide",
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: "validateForm",
			value: function validateForm() {
				return this.refs.myInput.validate();
			}
		}, {
			key: "handleSubmit",
			value: function handleSubmit(e) {
				$wr.nope(e);
				if (!this.validateForm()) {
					return;
				}
				var callback = $wr.apiHandler(function (response) {});
				var userMessage = this.refs.myInput.val();
				var params = {
					contact_message: {
						message: userMessage
					}
				};
				var title = "Message Sent";
				var text = "You have successfully sent us a message. Thank you!";
				CurrentUser.api().postContactMessages(params, callback);
				this.hide();
				window.wrNotifications.triggerDropDownNotification({ title: title,
					text: text, icon: "ok-circle" }, 3000);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					Modal,
					{ className: "contactModal", ref: "modal", headerText: "Contact Us" },
					React.createElement(
						"form",
						{ className: "contactForm", onSubmit: this.handleSubmit },
						React.createElement(ValidatingInput, { type: "textarea", ref: "myInput", placeholder: "Message goes here...",
							validators: ValidatingInput.Validators.PRESENT, inputClassName: "form-control messageArea" }),
						React.createElement("br", null),
						React.createElement("input", { className: "buttonSuccess center-block", type: "submit", value: "Send" })
					)
				);
			}
		}]);
	
		return ContactModal;
	}(React.Component);
	
	;
	
	ContactModal.propTypes = StrictPropTypes({});
	
	module.exports = ContactModal;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3746);
	
	var HelpCenterLink = function (_React$Component) {
		_inherits(HelpCenterLink, _React$Component);
	
		function HelpCenterLink(props) {
			_classCallCheck(this, HelpCenterLink);
	
			var _this = _possibleConstructorReturn(this, (HelpCenterLink.__proto__ || Object.getPrototypeOf(HelpCenterLink)).call(this));
	
			autobind(_this);
			_this.state = {
				showPopover: props.textOnly, activeEmotion: null,
				reactionFeedbackKey: null, feedbackItemID: null, loading: false
			};
			return _this;
		}
	
		_createClass(HelpCenterLink, [{
			key: "render",
			value: function render() {
				var url = "https://www.whooosreading.org/help";
				return React.createElement(
					"div",
					{ className: "HelpCenterLink", onClick: function onClick(e) {
							window.open(url, '_blank');
						} },
					React.createElement(
						"div",
						{ className: "icon" },
						React.createElement("span", { className: "glyphicon glyphicon-question-sign", "aria-hidden": "true" })
					),
					React.createElement(
						"div",
						{ className: "content" },
						"Open Help Center."
					)
				);
			}
		}]);
	
		return HelpCenterLink;
	}(React.Component);
	
	module.exports = HelpCenterLink;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__(153);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	var SiteHeader = __webpack_require__(786);
	var BasicSiteHeader = __webpack_require__(783);
	var SiteFooter = __webpack_require__(785);
	var UniversalControls = __webpack_require__(788);
	var ReturnAccountHeader = __webpack_require__(784);
	var PendingSSOPage = __webpack_require__(865);
	var ErrorPage = __webpack_require__(409);
	var ErrorBoundary = __webpack_require__(420);
	var CurrentUser = __webpack_require__(3);
	var DemoAccountSwitcher = __webpack_require__(201);
	var RosterActions = __webpack_require__(11);
	var Spinner = __webpack_require__(9);
	var SurveyPromptUtility = __webpack_require__(1017);
	var Modal = __webpack_require__(18);
	var GlobalModalContainer = __webpack_require__(797);
	var AnnouncementsConfig = __webpack_require__(1009);
	
	__webpack_require__(3672);
	__webpack_require__(3670);
	__webpack_require__(3671);
	__webpack_require__(3674);
	__webpack_require__(3673);
	__webpack_require__(3669);
	
	var App = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			fetchOrgData: function fetchOrgData() {
				return dispatch(RosterActions.fetchOrgData({}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(App, _React$Component);
	
		function App(props) {
			_classCallCheck(this, App);
	
			var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
			autobind(_this);
	
			_this.state = {
				loadedCurrentUser: false,
				loadedRosterData: false
			};
			return _this;
		}
	
		_createClass(App, [{
			key: "renderGlobalModalContainer",
			value: function renderGlobalModalContainer() {
				return React.createElement(GlobalModalContainer, { location: this.props.location });
			}
	
			// Checks if the user has any announcements and renders them on the website
	
		}, {
			key: "renderAnnouncements",
			value: function renderAnnouncements() {
				if (!CurrentUser.get() || !CurrentUser.get().user_alerts) {
					return;
				};
	
				// filter user_alerts for announcements
				var announcements = _.filter(CurrentUser.get().user_alerts, function (a) {
					return a.type == ANNOUNCEMENT;
				});
	
				// if user has announcements, render them
				if (!_.isEmpty(announcements)) {
					return _.map(announcements, function (alert) {
						var path = window.location.pathname;
						return AnnouncementsConfig.showAnnouncement(path, alert, CurrentUser.get());
					});
				}
			}
		}, {
			key: "renderPrompts",
			value: function renderPrompts() {
				if (this.showSurveyPrompts()) {
					return React.createElement(SurveyPromptUtility, { pathname: window.location.pathname, watchContainer: "#pageContent" });
				}
			}
		}, {
			key: "showSurveyPrompts",
			value: function showSurveyPrompts() {
				return CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard;
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.state.loadedCurrentUser) {
					return React.createElement("div", { className: "emptyAppContainer" });
				}
	
				if (!this.state.loadedRosterData) {
					var pageContent = React.createElement(
						"div",
						{ id: "pageContent" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (CurrentUser.isPendingSSOUser()) {
					var pageContent = React.createElement(
						"div",
						{ id: "pageContent" },
						React.createElement(PendingSSOPage, null)
					);
				} else if (CurrentUser.isOverdrawnUser()) {
					var pageContent = React.createElement(
						"div",
						{ id: "pageContent" },
						React.createElement(ErrorPage, { which: "overdrawn" })
					);
				} else {
					var pageContent = React.createElement(
						"div",
						{ id: "pageContent" },
						this.props.children,
						this.renderPrompts(),
						this.renderAnnouncements()
					);
				}
	
				var path = this.props.location.pathname;
	
				// use basic header and no footer for upgrade page
				if (path == "/upgrade") {
					var headerContent = React.createElement(BasicSiteHeader, null);
				} else {
					var headerContent = React.createElement(SiteHeader, null);
					var footerContent = React.createElement(
						ErrorBoundary,
						{ type: "big" },
						React.createElement(SiteFooter, null)
					);
				}
	
				if (DemoAccountSwitcher.hasReturnAccount()) {
					var returnToTeacher = React.createElement(ReturnAccountHeader, null);
				}
	
				return React.createElement(
					"div",
					{ className: "outerMostContainer" },
					React.createElement(
						"div",
						{ className: "outerPageContainer" },
						React.createElement(
							ErrorBoundary,
							{ type: "big" },
							headerContent,
							returnToTeacher
						),
						React.createElement(
							ErrorBoundary,
							{ type: "big", errorKey: path },
							pageContent,
							this.renderGlobalModalContainer()
						),
						React.createElement(
							ErrorBoundary,
							{ type: "big" },
							React.createElement(UniversalControls, null)
						)
					),
					footerContent
				);
			}
		}, {
			key: "hideLoadingContent",
			value: function hideLoadingContent() {
				$("#app").css("height", "100%");
				if (window.onLoadedContent) {
					window.onLoadedContent();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				$("#app").css("height", "0");
				CurrentUser.init(function (isLoggedIn) {
					var _this2 = this;
	
					if (isLoggedIn) {
						this.hideLoadingContent();
						this.setState({ loadedCurrentUser: true });
						this.props.fetchOrgData().then(function () {
							_this2.setState({ loadedRosterData: true });
						});
					} else {
						this.hideLoadingContent();
						this.setState({ loadedCurrentUser: true, loadedRosterData: true });
					}
				}.bind(this));
	
				window.redirectWorkaround = function (path) {
					this.props.history.push(path);
				}.bind(this);
	
				this.props.history.listen(function (location, action) {
					if (location.pathname == "/" && CurrentUser.isStudent()) {
						CurrentUser.fetchCurrentUserCoinData();
					}
					Mycroft.newPage(location.pathname);
				});
	
				// Hacky workaroudn for the roster page not being in redux
				$(document).on("bust-roster-cache", function () {
					// Doesn't prevent rendering, so changes might flicker
					this.props.fetchOrgData();
				}.bind(this));
			}
		}]);
	
		return App;
	}(React.Component)) || _class);
	;
	
	var ANNOUNCEMENT = 'Announcement';
	
	App.WrappedComponent.propTypes = StrictPropTypes({
		children: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	
		// From @connect handlers
		fetchOrgData: PropTypes.func,
	
		// From withRouter
		match: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
		staticContext: PropTypes.object
	});
	
	module.exports = (0, _reactRouter.withRouter)(App);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var OrgTypes = __webpack_require__(45);
	
	var StudentHomePageStreamlined = __webpack_require__(882);
	var StudentHomePageVertical = __webpack_require__(883);
	var AdminHomePage = __webpack_require__(869);
	var CustomAdminHomePage = __webpack_require__(870);
	var TeacherHomePage = __webpack_require__(893);
	var CustomTeacherHomePage = __webpack_require__(889);
	var WhooosReadingServices = __webpack_require__(25);
	
	var HomePage = function (_React$Component) {
		_inherits(HomePage, _React$Component);
	
		function HomePage(props) {
			_classCallCheck(this, HomePage);
	
			var _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(HomePage, [{
			key: "render",
			value: function render() {
				if (CurrentUser.isSignedIn()) {
					var params = _.extend({}, this.props.match.params, { id: CurrentUser.get().id });
					var match = _.extend({}, this.props.match, { params: params });
				}
	
				var pageContent = [];
	
				if (!CurrentUser.isSignedIn()) {
					var pageContent = React.createElement("div", null);
				} else if (CurrentUser.isStudent()) {
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(StudentHomePageVertical, _extends({}, this.props, { match: match }))
					);
				} else if (CurrentUser.isTeacherAdmin()) {
					var pageContent = React.createElement(CustomTeacherHomePage, _extends({}, this.props, { match: match }));
				} else if (CurrentUser.isSchoolAdmin()) {
					var pageContent = React.createElement(CustomAdminHomePage, _extends({}, this.props, { match: match, adminOrgLevel: OrgTypes.SCHOOL_ORG }));
				} else if (CurrentUser.isDistrictAdmin()) {
					var pageContent = React.createElement(CustomAdminHomePage, _extends({}, this.props, { match: match, adminOrgLevel: OrgTypes.DISTRICT_ORG }));
				}
	
				return React.createElement(
					"div",
					null,
					pageContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!CurrentUser.isSignedIn()) {
					window.location.href = WhooosReadingServices.OuterPages.url("/");
				}
			}
		}]);
	
		return HomePage;
	}(React.Component);
	
	;
	
	HomePage.propTypes = PageStrictPropTypes({});
	
	module.exports = HomePage;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaintenancePage = function (_React$Component) {
		_inherits(MaintenancePage, _React$Component);
	
		function MaintenancePage(props) {
			_classCallCheck(this, MaintenancePage);
	
			var _this = _possibleConstructorReturn(this, (MaintenancePage.__proto__ || Object.getPrototypeOf(MaintenancePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(MaintenancePage, [{
			key: "render",
			value: function render() {
				var imgPath = __webpack_require__(540);
	
				return React.createElement(
					"div",
					{ className: "maintenancePage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Whooo's Reading is down for maintenance!"
						)
					),
					React.createElement(
						"div",
						{ className: "container text-center" },
						React.createElement("img", { src: imgPath }),
						React.createElement(
							"p",
							null,
							"We'll be back shortly!"
						)
					)
				);
			}
		}]);
	
		return MaintenancePage;
	}(React.Component);
	
	;
	
	MaintenancePage.propTypes = PageStrictPropTypes({});
	
	module.exports = MaintenancePage;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	
	var Spinner = __webpack_require__(9);
	var LoadingButton = __webpack_require__(17);
	var ErrorDisplay = __webpack_require__(51);
	
	__webpack_require__(3752);
	
	var PendingSSOPage = function (_React$Component) {
		_inherits(PendingSSOPage, _React$Component);
	
		function PendingSSOPage(props) {
			_classCallCheck(this, PendingSSOPage);
	
			var _this = _possibleConstructorReturn(this, (PendingSSOPage.__proto__ || Object.getPrototypeOf(PendingSSOPage)).call(this));
	
			autobind(_this);
			_this.state = {
				schoolOrg: null,
	
				username: "", password: "",
	
				mergeLoading: false, newAccountLoading: false
			};
			return _this;
		}
	
		///////////////////////////////////////////////////////
		// Deprecated - This was the old Passphrase system ////
		///////////////////////////////////////////////////////
		// passphraseChange(e) {
		// 	var code = e.target.value.trim().toUpperCase();
		// 	var studentList = _.find(this.state.schoolOrg.student_lists, function(sl) {
		// 		return sl.passphrase == code;
		// 	});
		// 	this.setState({ studentList: studentList });
		// }
		// confirmStudentList(e) {
		// 	$wr.nope(e)
		// 	var params = {
		// 		access_token: CurrentUser.getToken(),
		// 		student_list_id: this.state.studentList.id
		// 	}
		// 	var ssoURL = WhooosReadingServices.SsoServer.url("/select_student_list");
		// 	$wr.postJSON(ssoURL, params, function(response) {
		// 		if (response.success) {
		// 			window.location.reload();
		// 		} else {
		// 			window.wrNotifications.triggerDropDownNotification({
		// 				title: "Sorry!", text: response.error, 
		// 				icon: "exclamation-sign", type: "error" 
		// 			});
		// 		}
		// 	}.bind(this));
		// }
		// oldRender() {
		// 	if (this.state.schoolOrg == null) {
		// 		return (
		// 			<div className="pendingSSOPage container">
		// 				<Spinner placeholder={ true } scale={ 1.7 } />
		// 			</div>
		// 		);
		// 	}
		// 	if (this.state.schoolOrg.student_lists.length == 0) {
		// 		return (
		// 			<div className="pendingSSOPage container">
		// 				<header className="pageHeader">
		// 					<h1>Welcome to Whooo's Reading!</h1>
		// 				</header>
		// 				<div className="row">
		// 					<div className="col-sm-7 col-sm-offset-1">
		// 						<p>
		// 							Hi { CurrentUser.get().first_name }!
		// 						</p>
		// 						<p>
		// 							Your school isn't set up to use Whooo's Reading yet.
		// 							Please contact <a href="mailto:support@whooosreading.org">
		// 								support@whooosreading.org
		// 							</a> if you'd like to use Whooo's Reading.
		// 						</p>
		// 					</div>
		// 					<div className="col-sm-3">
		// 						<img src={ require("owls/owlfonso-green.png") }
		// 							className="img-responsive" />
		// 					</div>
		// 				</div>
		// 			</div>
		// 		);
		// 	}
		// 	if (CurrentUser.isAdmin()) {
		// 		if (this.state.studentList) {
		// 			var confirmDisplay = (
		// 				<div className="selectedStudentList">
		// 					<p>
		// 						Is this your class? <span className="confirmName">
		// 							{ this.state.studentList.name }
		// 						</span>
		// 					</p>
		// 					<p>
		// 						If not, check your code or contact your administrator.
	
		// 						<a href="#" className="btn buttonPrimary confirmButton"
		// 							onClick={ this.confirmStudentList }>
		// 							Confirm
		// 						</a>
		// 					</p>
		// 				</div>
		// 			);
		// 		} else {
		// 			var confirmDisplay = (
		// 				<div className="selectedStudentList empty" />
		// 			);
		// 		}
		// 	} else {
		// 		if (this.state.studentList) {
		// 			var confirmDisplay = (
		// 				<div className="selectedStudentList">
		// 					<a href="#" className="btn buttonPrimary studentConfirmButton" onClick={ this.confirmStudentList }>
		// 						Go!
		// 					</a>
		// 				</div>
		// 			);
		// 		} else {
		// 			var confirmDisplay = (
		// 				<div className="selectedStudentList empty" />
		// 			);
		// 		}
		// 	}
	
		// 	return (
		// 		<div className="pendingSSOPage container">
		// 			<header className="pageHeader">
		// 				<h1>{ this.state.schoolOrg.school.name }</h1>
		// 			</header>
		// 			<div className="row">
		// 				<div className="col-sm-7 col-sm-offset-1">
		// 					<p>
		// 						Welcome to Whooo's Reading { CurrentUser.get().first_name }! 
		// 					</p>
		// 					<p>
		// 						Enter your class code, which should be 4 letters and 4 numbers.
		// 						<br/>
		// 						<em className="smallText">(No need to worry about remembering this code, you'll only have to enter it once)</em>
		// 					</p>
	
		// 					<div className="inputSection">
		// 						<input className="form-control classCodeField"
		// 							onChange={ this.passphraseChange }
		// 							placeholder="Like this: AAAA4444" />
		// 						{ confirmDisplay }
		// 					</div>
		// 				</div>
		// 				<div className="col-sm-3">
		// 					<img src={ require("owls/owlfonso-green.png") }
		// 						className="img-responsive" />
		// 				</div>
		// 			</div>
		// 		</div>
		// 	);
		// }
		///////////////////////////////////////////////////////
		// End Deprecated /////////////////////////////////////
		///////////////////////////////////////////////////////
	
		_createClass(PendingSSOPage, [{
			key: "onNewAccount",
			value: function onNewAccount(e) {
				$wr.nope(e);
	
				if (this.state.mergeLoading || this.state.newAccountLoading) {
					return;
				}
				this.refs.mergeErrors.reset();
	
				var params = {
					access_token: CurrentUser.getToken()
				};
	
				var ssoURL = WhooosReadingServices.SsoServer.url("/clever_sync");
				this.setState({ newAccountLoading: true });
				$wr.postJSON(ssoURL, params, function (response) {
					if (response.success) {
						window.location.reload();
					} else {
						console.error("Clever Sync Failed");
						console.log(response);
					}
				}, console.error);
			}
		}, {
			key: "onExistingAccountSubmit",
			value: function onExistingAccountSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (this.state.mergeLoading || this.state.newAccountLoading) {
					return;
				}
	
				this.refs.mergeErrors.reset();
	
				var params = {
					access_token: CurrentUser.getToken(),
					merge_credentials: {
						username: this.state.username,
						password: this.state.password
					}
				};
	
				var ssoURL = WhooosReadingServices.SsoServer.url("/merge_accounts");
				this.setState({ mergeLoading: true });
				$wr.postJSON(ssoURL, params, function (response) {
					if (response.success) {
						CurrentUser.usernamePasswordAuthenticate(_this2.state.username, _this2.state.password, function (success, errorText) {
							if (success) {
								if (response.pending_onboarding) {
									window.location.reload();
								} else {
									window.location.href = "/roster?add_students=true";
								}
							} else {
								// Shouldn't happen
								_this2.refs.mergeErrors.setError(errorText);
								_this2.setState({ mergeLoading: false });
							}
						});
					} else {
						_this2.refs.mergeErrors.setError(response.error);
						_this2.setState({ mergeLoading: false });
					}
				}, console.error);
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				if (this.state.schoolOrg == null) {
					return React.createElement(
						"div",
						{ className: "pendingSSOPage container" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				if (this.state.schoolOrg.school.name == "Whooo's Reading") {
					var schoolName = "Sync with Clever";
				} else {
					var schoolName = this.state.schoolOrg.school.name;
				}
	
				return React.createElement(
					"div",
					{ className: "pendingSSOPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							schoolName
						)
					),
					React.createElement(
						"p",
						{ className: "text-center" },
						"Add your students and sections from Clever to your Whooo's Reading account."
					),
					React.createElement(
						"div",
						{ className: "choice" },
						React.createElement(
							"div",
							{ className: "option" },
							React.createElement(
								"p",
								{ className: "opHeader" },
								"Create a new account?"
							),
							React.createElement(
								"p",
								null,
								"This will add your students and sections to a new Whooo's Reading account."
							),
							React.createElement(LoadingButton, { className: "btn buttonPrimary", text: "Create Account",
								loading: this.state.newAccountLoading, onClick: this.onNewAccount })
						),
						React.createElement(
							"div",
							{ className: "option small" },
							React.createElement(
								"p",
								{ className: "bigOr" },
								"OR"
							)
						),
						React.createElement(
							"div",
							{ className: "option" },
							React.createElement(
								"p",
								{ className: "opHeader" },
								"Merge into an existing account?"
							),
							React.createElement(
								"p",
								null,
								"This will merge your students and sections into an existing Whooo's Reading account."
							),
							React.createElement(ErrorDisplay, { ref: "mergeErrors" }),
							React.createElement(
								"div",
								{ className: "accountFields" },
								React.createElement(
									"form",
									{ onSubmit: this.onExistingAccountSubmit },
									React.createElement("input", { className: "form-control", placeholder: "Username or email",
										value: this.state.username,
										onChange: function onChange(e) {
											_this3.setState({ username: e.target.value });
										} }),
									React.createElement("input", { className: "form-control", placeholder: "Password",
										type: "password",
										value: this.state.password,
										onChange: function onChange(e) {
											_this3.setState({ password: e.target.value });
										} }),
									React.createElement(LoadingButton, { className: "btn buttonPrimary", text: "Merge Account",
										loading: this.state.mergeLoading })
								)
							)
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var embeds = "user.pending_primary_school_org,school_org.school,school_org.active_student_lists,student_list.passphrase";
	
				CurrentUser.api().getUser(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler(function (response) {
					this.setState({ schoolOrg: response.user.pending_primary_school_org });
				}.bind(this)));
			}
		}]);
	
		return PendingSSOPage;
	}(React.Component);
	
	;
	
	PendingSSOPage.propTypes = PageStrictPropTypes({});
	
	module.exports = PendingSSOPage;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	
	var ReferralPage = function (_React$Component) {
		_inherits(ReferralPage, _React$Component);
	
		function ReferralPage(props) {
			_classCallCheck(this, ReferralPage);
	
			var _this = _possibleConstructorReturn(this, (ReferralPage.__proto__ || Object.getPrototypeOf(ReferralPage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ReferralPage, [{
			key: "render",
			value: function render() {
				var redirectTitle = "Hang in there...";
				var imgPath = __webpack_require__(540);
				var redirectText = "You are being redirected...";
	
				var where = $wr.getURLParameterByName("where");
				if (where == "legacy") {
					redirectText = "";
				}
				var spinner = React.createElement(Spinner, { placeholder: true, scale: 1.5 });
	
				return React.createElement(
					"div",
					{ className: "redirectPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							redirectTitle
						)
					),
					React.createElement(
						"div",
						{ className: "container text-center" },
						spinner,
						React.createElement("img", { src: imgPath }),
						React.createElement(
							"p",
							null,
							redirectText
						)
					)
				);
			}
		}]);
	
		return ReferralPage;
	}(React.Component);
	
	;
	
	ReferralPage.propTypes = PageStrictPropTypes({});
	
	module.exports = ReferralPage;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	
	var ToggleMultiselect = __webpack_require__(169);
	
	__webpack_require__(3743);
	
	var ScratchPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			studentLists: RosterSelectors.studentLists({ state: state })
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(ScratchPage, _React$Component);
	
		function ScratchPage(props) {
			_classCallCheck(this, ScratchPage);
	
			var _this = _possibleConstructorReturn(this, (ScratchPage.__proto__ || Object.getPrototypeOf(ScratchPage)).call(this));
	
			autobind(_this);
	
			_this.state = {
				selected: {}
			};
			return _this;
		}
	
		_createClass(ScratchPage, [{
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var toggles = [{
					key: "primary",
					text: "Primary",
					icon: "star",
					select: ToggleMultiselect.SELECT_LEFT_CLICK,
					singleton: true
				}, {
					key: "secondary",
					text: "Secondary",
					icon: "star-empty",
					select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK
				}];
	
				var topContent = React.createElement(
					"div",
					null,
					"Click a class to set it as primary.",
					React.createElement("br", null),
					"Hold shift & click to set secondary."
				);
	
				return React.createElement(
					"div",
					{ className: "scratchPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							{ className: "hideOnPrint" },
							"Scratch Page"
						)
					),
					React.createElement("hr", null),
					React.createElement(ToggleMultiselect, { topContent: topContent,
						selected: this.state.selected,
						toggles: toggles,
						options: this.props.studentLists.map(function (x) {
							return { key: x.id, text: x.name };
						}),
						onChange: function onChange(selected) {
							return _this2.setState({ selected: selected });
						} })
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.studentLists.length) {
					this.setState({
						selected: _defineProperty({}, this.props.studentLists[0].id, "primary")
					});
				}
			}
		}]);
	
		return ScratchPage;
	}(React.Component)) || _class);
	
	
	ScratchPage.propTypes = PageStrictPropTypes({
		studentLists: PropTypes.array
	});
	
	module.exports = ScratchPage;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	
	var Spinner = __webpack_require__(9);
	var LoadingButton = __webpack_require__(17);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3753);
	
	var GoldTrialModal = function (_React$Component) {
	  _inherits(GoldTrialModal, _React$Component);
	
	  function GoldTrialModal(props) {
	    _classCallCheck(this, GoldTrialModal);
	
	    var _this = _possibleConstructorReturn(this, (GoldTrialModal.__proto__ || Object.getPrototypeOf(GoldTrialModal)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("GoldTrialModal");
	    _this.state = { showBasicInfo: true, loading: false };
	    return _this;
	  }
	  // removes gold trial alert
	
	
	  _createClass(GoldTrialModal, [{
	    key: "startFreeTrial",
	    value: function startFreeTrial() {
	      this.setState({ loading: true });
	      LuckyOrangeClient.tagComponent("startGoldTrial");
	      Mycroft.newEvent({ category: "Gold Trial", action: "gold-trial-initiated" });
	      // remove alert for gold trial
	      CurrentUser.api().deleteUserAlert(this.props.alertID);
	    }
	    // shows additonal information modal
	
	  }, {
	    key: "showInformation",
	    value: function showInformation() {
	      this.setState({ showBasicInfo: false });
	    }
	    // renders start trial button or spinner
	
	  }, {
	    key: "renderStartTrialButton",
	    value: function renderStartTrialButton() {
	      // construct url to start trial
	      var user = CurrentUser.get();
	      var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrGold&days=60&numReferred=0";
	      var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
	
	      if (this.state.loading) {
	        return React.createElement(Spinner, { scale: 1 });
	      } else {
	        return React.createElement(
	          "div",
	          { className: "row buttonRow" },
	          React.createElement(
	            "div",
	            { className: "startTrialBtnContainer" },
	            React.createElement(
	              "div",
	              { className: "btnAndText" },
	              React.createElement(
	                "a",
	                { className: "btn buttonSuccess", href: trialURL, onClick: this.startFreeTrial },
	                "Start Your Free Trial"
	              ),
	              React.createElement(
	                "div",
	                { className: "noCreditCardText" },
	                "(No credit card required!)"
	              )
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "startTrialImageContainer" },
	            React.createElement("img", { className: "teacherOwl", src: __webpack_require__(298) }),
	            React.createElement("img", { className: "studentOwl", src: __webpack_require__(530) })
	          )
	        );
	      }
	    }
	    // renders first modal
	
	  }, {
	    key: "renderBasicInfo",
	    value: function renderBasicInfo() {
	      if (this.state.showBasicInfo) {
	        var user = CurrentUser.get();
	        var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrGold&days=60&numReferred=0";
	        var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
	        var checkMarkIcon = React.createElement(Glyphicon, { icon: "glyphicon glyphicon-ok" });
	        return React.createElement(
	          "div",
	          { className: "goldTrialContainer" },
	          React.createElement(
	            "div",
	            { className: "row contentRow" },
	            React.createElement(
	              "div",
	              { className: "col-sm-12" },
	              React.createElement(
	                "div",
	                { className: "featureListIntro" },
	                "Gain access to these features to help you and your students:"
	              ),
	              React.createElement(
	                "ul",
	                { className: "featureListContainer" },
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Identify which students demonstrate comprehension"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Differentiate and customize scaffolds for each student"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Track students\u2019 daily reading using a digital reading log"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Encourage students to read within their ZPD reading level"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Activate standards-aligned questions and reporting"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Customize activities assigned alongside specific titles"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Track reading and writing skills where support is needed"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Assign intervention exercises based on student need"
	                ),
	                React.createElement(
	                  "li",
	                  null,
	                  checkMarkIcon,
	                  " Observe reading and writing proficiency over time"
	                )
	              )
	            )
	          ),
	          this.renderStartTrialButton()
	        );
	      }
	    }
	    // controlls display of information based on user input
	
	  }, {
	    key: "renderDisplay",
	    value: function renderDisplay() {
	      if (this.state.showBasicInfo) {
	        return this.renderBasicInfo();
	      } else {
	        return this.renderMoreInfoModal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        null,
	        this.renderDisplay()
	      );
	    }
	  }]);
	
	  return GoldTrialModal;
	}(React.Component);
	
	;
	
	module.exports = GoldTrialModal;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var OrgTypes = __webpack_require__(45);
	
	var Spinner = __webpack_require__(9);
	var DataClassActivity = __webpack_require__(760);
	var DataSchoolActivity = __webpack_require__(761);
	var DateSpanSelector = __webpack_require__(116);
	var DownloadDataLink = __webpack_require__(741);
	var OrgDropdown = __webpack_require__(100);
	
	var OrgActivityRouting = __webpack_require__(203);
	
	__webpack_require__(652);
	
	var AdminHomePage = (_dec = (0, _LocationState.provideLocationState)(OrgActivityRouting.getRouteState), _dec(_class = function (_React$Component) {
		_inherits(AdminHomePage, _React$Component);
	
		function AdminHomePage(props) {
			_classCallCheck(this, AdminHomePage);
	
			var _this = _possibleConstructorReturn(this, (AdminHomePage.__proto__ || Object.getPrototypeOf(AdminHomePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(AdminHomePage, [{
			key: "onChangeView",
			value: function onChangeView(change) {
				$wr.redirect(OrgActivityRouting.getPath(_extends({}, this.props.locationState, change)));
			}
		}, {
			key: "selectDates",
			value: function selectDates(startDate, endDate) {
				this.onChangeView({ startDate: startDate, endDate: endDate });
			}
		}, {
			key: "onOrgSelect",
			value: function onOrgSelect(orgIdentifier) {
				this.onChangeView({ orgIdentifier: orgIdentifier });
			}
		}, {
			key: "onClick",
			value: function onClick() {
				LuckyOrangeClient.tagComponent("upgradeCodeTable");
			}
		}, {
			key: "render",
			value: function render() {
				var _props$locationState = this.props.locationState,
				    startDate = _props$locationState.startDate,
				    endDate = _props$locationState.endDate,
				    orgIdentifier = _props$locationState.orgIdentifier;
	
	
				var vk = $wr.sortedJSON(this.props.locationState);
	
				if (this.props.adminOrgLevel === OrgTypes.DISTRICT_ORG) {
					orgIdentifier = orgIdentifier || OrgTypes.ALL_SCHOOL_ORGS;
	
					var headerText = "District Admin Dashboard";
					if (OrgTypes.isSchoolOrgIdentifier(orgIdentifier)) {
						var report = React.createElement(DataClassActivity, { startDate: startDate, endDate: endDate,
							schoolOrgID: parseInt(OrgTypes.fromIdentifier(orgIdentifier).key),
							onChangeView: this.onChangeView });
					} else if (orgIdentifier === OrgTypes.ALL_STUDENT_LISTS_IDENTIFIER) {
						var report = React.createElement(DataClassActivity, { startDate: startDate, endDate: endDate,
							onChangeView: this.onChangeView });
					} else {
						var report = React.createElement(DataSchoolActivity, { startDate: startDate, endDate: endDate,
							onChangeView: this.onChangeView });
					}
	
					var orgDropdown = React.createElement(OrgDropdown, { dropdownDisplay: "link",
						selectedIdentifier: orgIdentifier,
						selectionTypes: [OrgTypes.ALL_SCHOOL_ORGS, OrgTypes.ALL_STUDENT_LISTS, OrgTypes.SCHOOL_ORG],
						onSelect: this.onOrgSelect });
	
					var setupProgressLink = React.createElement(
						"span",
						null,
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/settings/code-table", onClick: this.onClick },
							"View your district's setup progress"
						)
					);
				} else {
					orgIdentifier = orgIdentifier || OrgTypes.ALL_STUDENT_LISTS;
					var headerText = "School Admin Dashboard";
	
					var report = React.createElement(DataClassActivity, { startDate: startDate, endDate: endDate,
						onChangeView: this.onChangeView });
					var setupProgressLink = React.createElement(
						"span",
						null,
						React.createElement(
							_reactRouterDom.Link,
							{ to: "/settings/code-table", onClick: this.onClick },
							"View your school's setup progress"
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "container adminHomePage" },
					React.createElement(
						"header",
						{ className: "pageHeader hideOnPrint" },
						React.createElement(
							"h1",
							null,
							headerText
						),
						React.createElement(
							"div",
							{ className: "setupLink" },
							" ",
							setupProgressLink
						)
					),
					React.createElement(
						"div",
						{ className: "controlBox" },
						orgDropdown,
						React.createElement(DateSpanSelector, { onSelectDates: this.selectDates,
							expectationsSpans: [],
							startDate: startDate, endDate: endDate }),
						React.createElement(DownloadDataLink, { startDate: startDate, endDate: endDate,
							orgIdentifier: orgIdentifier })
					),
					React.createElement(
						"div",
						{ key: vk },
						report
					)
				);
			}
		}]);
	
		return AdminHomePage;
	}(React.Component)) || _class);
	;
	
	AdminHomePage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object.isRequired,
		adminOrgLevel: PropTypes.string.isRequired
	});
	
	module.exports = AdminHomePage;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var OrgTypes = __webpack_require__(45);
	var OrgActivityRouting = __webpack_require__(203);
	var WidgetConfig = __webpack_require__(66);
	
	var WidgetContainer = __webpack_require__(189);
	
	__webpack_require__(652);
	
	var CustomAdminHomePage = (_dec = (0, _LocationState.provideLocationState)(OrgActivityRouting.getRouteState), _dec(_class = function (_React$Component) {
		_inherits(CustomAdminHomePage, _React$Component);
	
		function CustomAdminHomePage(props) {
			_classCallCheck(this, CustomAdminHomePage);
	
			var _this = _possibleConstructorReturn(this, (CustomAdminHomePage.__proto__ || Object.getPrototypeOf(CustomAdminHomePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(CustomAdminHomePage, [{
			key: "onClick",
			value: function onClick() {
				LuckyOrangeClient.tagComponent("upgradeCodeTable");
			}
		}, {
			key: "renderWidgetContainer",
			value: function renderWidgetContainer(entityType) {
				var currentUser = CurrentUser.get();
				var widgetParams = { topLevelDigest: entityType, period: WidgetConfig.PERIOD, adminID: [currentUser.id] };
				return React.createElement(WidgetContainer, { userID: currentUser.id, widgetParams: widgetParams });
			}
		}, {
			key: "districtAdminContent",
			value: function districtAdminContent() {
				var headerText = "District Admin Dashboard";
	
				var setupProgressLink = React.createElement(
					"span",
					null,
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/settings/code-table", onClick: this.onClick },
						"View your district's setup progress"
					)
				);
	
				var widgetContainer = this.renderWidgetContainer(WidgetConfig.DISTRICT_ORG_ENTITY_TYPE);
	
				return { headerText: headerText, setupProgressLink: setupProgressLink, widgetContainer: widgetContainer };
			}
		}, {
			key: "schoolAdminContent",
			value: function schoolAdminContent() {
				var headerText = "School Admin Dashboard";
	
				var setupProgressLink = React.createElement(
					"span",
					null,
					React.createElement(
						_reactRouterDom.Link,
						{ to: "/settings/code-table", onClick: this.onClick },
						"View your school's setup progress"
					)
				);
	
				var widgetContainer = this.renderWidgetContainer(WidgetConfig.SCHOOL_ORG_ENTITY_TYPE);
	
				return { headerText: headerText, setupProgressLink: setupProgressLink, widgetContainer: widgetContainer };
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.adminOrgLevel === OrgTypes.DISTRICT_ORG) {
					var _districtAdminContent = this.districtAdminContent(),
					    headerText = _districtAdminContent.headerText,
					    setupProgressLink = _districtAdminContent.setupProgressLink,
					    widgetContainer = _districtAdminContent.widgetContainer;
				} else {
					var _schoolAdminContent = this.schoolAdminContent(),
					    headerText = _schoolAdminContent.headerText,
					    setupProgressLink = _schoolAdminContent.setupProgressLink,
					    widgetContainer = _schoolAdminContent.widgetContainer;
				}
	
				return React.createElement(
					"div",
					{ className: "container adminHomePage" },
					React.createElement(
						"header",
						{ className: "pageHeader hideOnPrint" },
						React.createElement(
							"h1",
							null,
							headerText
						),
						React.createElement(
							"div",
							{ className: "setupLink" },
							" ",
							setupProgressLink
						)
					),
					widgetContainer
				);
			}
		}]);
	
		return CustomAdminHomePage;
	}(React.Component)) || _class);
	;
	
	CustomAdminHomePage.WrappedComponent.propTypes = PageStrictPropTypes({
		locationState: PropTypes.object.isRequired,
		adminOrgLevel: PropTypes.string.isRequired
	});
	
	module.exports = CustomAdminHomePage;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var Modal = __webpack_require__(18);
	var ErrorDisplay = __webpack_require__(51);
	var LoadingButton = __webpack_require__(17);
	var WhooosReadingServices = __webpack_require__(25);
	
	__webpack_require__(3756);
	
	var ParentInfoModal = function (_React$Component) {
		_inherits(ParentInfoModal, _React$Component);
	
		function ParentInfoModal(props) {
			_classCallCheck(this, ParentInfoModal);
	
			var _this = _possibleConstructorReturn(this, (ParentInfoModal.__proto__ || Object.getPrototypeOf(ParentInfoModal)).call(this));
	
			autobind(_this);
			_this.state = { loading: false };
			return _this;
		}
	
		_createClass(ParentInfoModal, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "handleInformationSubmit",
			value: function handleInformationSubmit(e) {
				$wr.nope(e);
				this.refs.errors.reset();
				var errors = [];
	
				if (!this.state.loading) {
					this.setState({ loading: true });
					var firstName = this.refs.first_name.value;
					var lastName = this.refs.last_name.value;
	
					if (firstName == "" || lastName == "") {
						errors.push("Please enter your first and last name.");
					}
	
					if (errors.length == 0) {
						var parentData = { first_name: firstName, last_name: lastName, not_accepted_terms: false };
						var title = "Name Saved!";
						var text = "Thank you for updating your name on Whooo's Reading.";
	
						CurrentUser.api().patchParent(this.props.parentID, { parent: parentData }, $wr.apiHandler(function (response) {
							this.setState({ loading: false });
							this.refs.modal.hide();
							window.wrNotifications.triggerDropDownNotification({
								title: title, text: text, icon: "ok-circle" });
							if (this.props.onUpdateSuccess) {
								this.props.onUpdateSuccess();
							}
						}.bind(this)));
					} else {
						this.setState({ loading: false });
						this.refs.errors.setErrors(errors);
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var modalBody = React.createElement(
					"div",
					{ className: "modalBody" },
					React.createElement(
						"p",
						null,
						"Welcome to Whooo's Reading! ",
						React.createElement("br", null),
						"Your name will appear when you sign off on your child's reading logs."
					),
					React.createElement(ErrorDisplay, { ref: "errors" }),
					React.createElement(
						"form",
						{ className: "parentInfoForm", onSubmit: this.handleInformationSubmit },
						React.createElement(
							"div",
							{ className: "inputContainer" },
							React.createElement(
								"p",
								{ className: "inputLabel" },
								"First Name"
							),
							React.createElement("input", { className: "form-control", ref: "first_name" })
						),
						React.createElement(
							"div",
							{ className: "inputContainer" },
							React.createElement(
								"p",
								{ className: "inputLabel" },
								"Last Name"
							),
							React.createElement("input", { className: "form-control", ref: "last_name" })
						),
						React.createElement(LoadingButton, { className: "btn buttonSuccess center-block",
							loading: this.state.loading, text: "Submit" }),
						React.createElement(
							"p",
							{ className: "terms" },
							"By clicking this button, you are agreeing to our",
							React.createElement("span", { className: "spacer0" }),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/terms") },
								"Terms of Service"
							),
							" and",
							React.createElement("span", { className: "spacer0" }),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/privacy") },
								"Privacy Policy"
							),
							"."
						)
					)
				);
	
				return React.createElement(
					Modal,
					{ className: "parentInfoModal", ref: "modal", modalOrder: 2,
						headerText: "Parent Information", selfOpen: true },
					modalBody
				);
			}
		}]);
	
		return ParentInfoModal;
	}(React.Component);
	
	ParentInfoModal.propTypes = StrictPropTypes({
		parentID: PropTypes.string.isRequired,
		onUpdateSuccess: PropTypes.func,
		parentToken: PropTypes.string
	});
	
	module.exports = ParentInfoModal;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var CurrentUser = __webpack_require__(3);
	var WeekLogTable = __webpack_require__(846);
	
	var moment = __webpack_require__(15);
	
	__webpack_require__(3755);
	
	var ParentLogsApprovalModal = function (_React$Component) {
		_inherits(ParentLogsApprovalModal, _React$Component);
	
		function ParentLogsApprovalModal(props) {
			_classCallCheck(this, ParentLogsApprovalModal);
	
			var _this = _possibleConstructorReturn(this, (ParentLogsApprovalModal.__proto__ || Object.getPrototypeOf(ParentLogsApprovalModal)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(ParentLogsApprovalModal, [{
			key: 'getFirstDayOfWeek',
			value: function getFirstDayOfWeek(dateString) {
				var date = moment(dateString, "YYYY-MM-DD");
				if (date.day() < WEEK_START_DAY) {
					var shift = date.day() + 7 - WEEK_START_DAY;
				} else {
					var shift = date.day() - WEEK_START_DAY;
				}
				var firstDayDate = date.subtract(shift, "days");
	
				return firstDayDate.format("YYYY-MM-DD");
			}
		}, {
			key: 'render',
			value: function render() {
				var weeksMap = _.map(this.props.logs, function (log) {
					var month = this.getFirstDayOfWeek(log.log_date);
					return month;
				}.bind(this));
				//this returns a list of all the logs but months repeat, example: 2017-05-01, 2017-05-01
	
				var uniqueWeeks = _.uniq(weeksMap).sort().reverse();
	
				var tableWeeks = _.map(uniqueWeeks, function (week) {
					var filteredLogs = _.filter(this.props.logs, function (log) {
						return this.getFirstDayOfWeek(log.log_date) == week;
					}.bind(this));
	
					return React.createElement(WeekLogTable, { logs: filteredLogs, week: week, key: week,
						logsApproval: true, onLogVerification: this.props.onLogVerification });
				}.bind(this));
	
				return React.createElement(
					Modal,
					{ className: 'logsApprovalModal', preventHide: true,
						headerText: 'Verify Reading Logs', ref: 'modal' },
					React.createElement(
						'p',
						{ className: 'instructionsText' },
						'Please review and sign off on ',
						this.props.student.first_name,
						'\'s reading logs so that your child will get credit for their reading.'
					),
					tableWeeks
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.modal.show();
			}
		}]);
	
		return ParentLogsApprovalModal;
	}(React.Component);
	
	ParentLogsApprovalModal.propTypes = PageStrictPropTypes({
		student: PropTypes.object.isRequired,
		logs: PropTypes.array.isRequired,
		onUpdateLog: PropTypes.func.isRequired,
		onLogVerification: PropTypes.func.isRequired
	
	});
	
	var WEEK_START_DAY = 1;
	
	module.exports = ParentLogsApprovalModal;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRouter = __webpack_require__(153);
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	
	var DateSpanSelector = __webpack_require__(116);
	var CurrentUser = __webpack_require__(3);
	
	var ParentInfoModal = __webpack_require__(871);
	var ParentLogsApprovalModal = __webpack_require__(872);
	
	var Spinner = __webpack_require__(9);
	var DisplayToggleControl = __webpack_require__(48);
	
	var StudentAvatar = __webpack_require__(35);
	var StudentMetrics = __webpack_require__(29);
	var StudentProgressDisplay = __webpack_require__(194);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var ProgressDisplay = __webpack_require__(410);
	var LogCalendar = __webpack_require__(241);
	var AllMonthsLogTable = __webpack_require__(240);
	var StudentExpectationsDisplay = __webpack_require__(411);
	
	__webpack_require__(653);
	__webpack_require__(223);
	
	var ParentPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var parent = RosterSelectors.parent({ state: state, id: props.match.params.id });
		if (parent) {
			var studentID = parent.children[0];
			var student = RosterSelectors.student({ state: state, id: studentID });
		}
		return {
			logs: ReadingSelectors.logs({ state: state }),
			isLoadingLogs: ReadingSelectors.isLoadingLogs({ state: state }),
			parent: parent,
			student: student
		};
	}, function (dispatch, props) {
		function populateLogs(userID) {
			return dispatch(ReadingActions.fetchLogs({ conditions: { userID: userID } }));
		}
		function fetchStudentData(startDate, endDate, studentID) {
			var embeds = ["student.expectations_date_spans", "student.expectations_progress", "student.avatar", "student.prefs"];
			var query = {};
			if (startDate) {
				query.expectations_progress_start_date = startDate;
			}
			if (endDate) {
				query.expectations_progress_end_date = endDate;
			}
			return dispatch(RosterActions.fetchStudent({
				id: studentID, query: query,
				embeds: embeds
			}));
		}
		return {
			fetchStudent: fetchStudentData,
			fetchParent: function fetchParent(parentID) {
				return dispatch(RosterActions.fetchParent({ id: parentID, embeds: ["parent.children"] })).then(function (response) {
					var studentID = response.students[0].id;
					populateLogs(studentID);
					fetchStudentData(undefined, undefined, studentID);
				});
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ParentPage, _React$Component);
	
		function ParentPage(props) {
			_classCallCheck(this, ParentPage);
	
			var _this = _possibleConstructorReturn(this, (ParentPage.__proto__ || Object.getPrototypeOf(ParentPage)).call(this));
	
			autobind(_this);
			_this.state = { parent: null, currentView: "student-reports" };
			return _this;
		}
	
		_createClass(ParentPage, [{
			key: "onViewChange",
			value: function onViewChange(view) {
				this.setState({ currentView: view });
			}
		}, {
			key: "startDate",
			value: function startDate() {
				var dateSpans = this.props.student.expectations_date_spans;
				return this.state.startDate || dateSpans[0].start;
			}
		}, {
			key: "endDate",
			value: function endDate() {
				var dateSpans = this.props.student.expectations_date_spans;
				return this.state.endDate || dateSpans[0].end;
			}
		}, {
			key: "changeDates",
			value: function changeDates(startDate, endDate) {
				var _this2 = this;
	
				this.setState({ startDate: startDate, endDate: endDate }, function () {
					_this2.props.fetchStudent(startDate, endDate, _this2.props.student.id);
				});
			}
		}, {
			key: "isMatchingDateSpan",
			value: function isMatchingDateSpan() {
				var _this3 = this;
	
				if (this.props.student && this.props.student.expectations_date_spans) {
					return _.filter(this.props.student.expectations_date_spans, function (span) {
						return span.start == _this3.startDate() && span.end == _this3.endDate();
					}).length > 0;
				}
				return false;
			}
		}, {
			key: "renderDateSelectors",
			value: function renderDateSelectors() {
				if (this.props.student && this.props.student.expectations_date_spans) {
					var dateSpans = this.props.student.expectations_date_spans;
					return React.createElement(
						"div",
						{ className: "dateSpanSelectorWrap" },
						React.createElement(DateSpanSelector, { startDate: this.startDate(), endDate: this.endDate(),
							expectationsSpans: dateSpans,
							onSelectDates: this.changeDates })
					);
				}
			}
		}, {
			key: "renderStudentSection",
			value: function renderStudentSection() {
				// var student = this.getStudentData();
	
				// var studentReports = (
				// 	<div className="row">
				// 		<div className="col-sm-12 parentContentContainer">
				// 			<StudentExpectationsDisplay studentID={ student.id } />
				// 		</div>
				// 	</div>
				// );
				// return (
				// 	<div>
				// 		<header className="pageHeader">
				// 			<h1>{ parent.children[0].first_name }'s Progress Reports</h1>
				// 		</header>
				// 		{ studentReports }
				// 	</div>
				// )
				var student = this.props.student;
				var parent = this.props.parent;
	
				var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5;
				var expectations = student.prefs.grade_level_expectations_metrics[grade_level];
				var progress = student.expectations_progress;
				expectations = _.sortBy(expectations, function (expectation) {
					if (expectation.metric == StudentMetrics.TYPES.QUIZZES_PASSED) {
						return "AAA";
					} else {
						return expectation.metric;
					}
				});
				if ((expectations || []).length) {
					var progressDisplay = _.map(expectations, function (expectation, index) {
						var metric = expectation.metric;
						if (progress) {
							var current = progress[metric];
						} else {
							var current = 0;
						}
						return React.createElement(StudentProgressDisplay, {
							key: index,
							metric: metric,
							title: StudentMetrics.getLabel(metric),
							unit: StudentMetrics.getUnit(metric),
							total: expectation.goal,
							current: current,
							actionLabel: StudentMetrics.getActionLabel(metric),
							hideButton: true });
					});
				}
				return React.createElement(
					"div",
					null,
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							student.first_name,
							"'s Learning Progress"
						)
					),
					React.createElement(StudentAvatar, { student: this.props.student, maxWidth: 170 }),
					React.createElement(
						"div",
						{ className: "dashboardContainer" },
						progressDisplay,
						this.renderDateSelectors()
					)
				);
			}
		}, {
			key: "afterLogUpdate",
			value: function afterLogUpdate(newData, removeLog) {
				var newDataID = newData.id;
	
				var newLogsData = _.compact(_.map(this.props.logs, function (log) {
					if (log.id != newDataID) {
						return log;
					} else if (!removeLog) {
						return newData;
					}
				}));
	
				this.setState({ logs: newLogsData });
			}
		}, {
			key: "afterLogVerification",
			value: function afterLogVerification(logIDs) {
				var studentID = this.getStudentData().id;
				this.props.populateLogs(studentID);
	
				setTimeout(function () {
					window.wrNotifications.triggerDropDownNotification({
						title: "Reading Approved", text: "Thank you for signing off.", icon: "ok-circle"
					}, 2000);
				}, 500);
			}
		}, {
			key: "getStudentData",
			value: function getStudentData() {
				return this.props.student;
			}
		}, {
			key: "getParentID",
			value: function getParentID() {
				return this.props.match.params.id;
			}
		}, {
			key: "getParentToken",
			value: function getParentToken() {
				return $wr.getURLParameterByName("token");
			}
		}, {
			key: "logsRequireVerification",
			value: function logsRequireVerification() {
				var unverifiedLogs = _.select(this.props.logs, function (log) {
					return !log.verified;
				});
	
				return unverifiedLogs.length > 0;
			}
		}, {
			key: "renderReadingSection",
			value: function renderReadingSection() {
				if (this.props.isLoadingLogs) {
					return React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "readingLogsSection" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							this.props.student.first_name,
							"'s Reading Logs"
						)
					),
					React.createElement(LogCalendar, { logs: this.props.logs }),
					React.createElement(AllMonthsLogTable, { logs: this.props.logs, onUpdateLog: this.afterLogUpdate, hideCommentBox: true })
				);
			}
		}, {
			key: "checkVerifiedLogs",
			value: function checkVerifiedLogs() {
				var verifyIDs = $wr.getURLParameterByName("verify_ids");
				if (verifyIDs != null) {
					var logIDs = _.map(verifyIDs.split(","), parseInt);
	
					var params = { log: { verified: true }, update_ids: logIDs };
					CurrentUser.api().patchLog(logIDs[0], params, $wr.apiHandler(function (response) {
						// No action needed
					}));
					this.afterLogVerification(logIDs);
				}
			}
		}, {
			key: "render",
			value: function render() {
				// filler for now, to demonstrate that we have updating parent data here
				if (this.props.parent) {
					var parentInfo = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Parent ID: ",
							this.props.parent.id
						),
						React.createElement(
							"p",
							null,
							"Parent First Name: ",
							this.props.parent.first_name
						),
						React.createElement(
							"p",
							null,
							"Parent Last Name: ",
							this.props.parent.last_name
						)
					);
	
					var toggleOptions = [{ key: "student-reports", text: "Reports" }, { key: "reading-history", text: "Reading" }];
	
					var toggleDisplay = React.createElement(DisplayToggleControl, { options: toggleOptions,
						onChange: this.onViewChange,
						activeOptionKey: this.state.currentView });
	
					if (this.state.currentView == "student-reports") {
						if (this.props.student.prefs) {
							var pageContent = this.renderStudentSection();
						}
					} else {
						var pageContent = this.renderReadingSection();
					}
	
					if (this.props.parent.not_accepted_terms) {
						var parentInfoModal = React.createElement(ParentInfoModal, { ref: "modal", parentID: this.getParentID(),
							parentToken: this.getParentToken(), onUpdateSuccess: this.fetchParent });
					}
	
					if (!this.props.isLoadingLogs && this.logsRequireVerification()) {
						var unverifiedLogs = _.select(this.props.logs, function (log) {
							return !log.verified;
						});
						var parentLogsApprovalModal = React.createElement(ParentLogsApprovalModal, { student: this.props.parent.children[0],
							logs: unverifiedLogs, onUpdateLog: this.afterLogUpdate,
							onLogVerification: this.afterLogVerification });
					}
				}
	
				return React.createElement(
					"div",
					{ className: "container", id: "parentPage" },
					toggleDisplay,
					pageContent,
					parentLogsApprovalModal,
					parentInfoModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				CurrentUser.initTokenUser(this.getParentID(), this.getParentToken(), function (success) {
					$(document).trigger("current-user-updated");
					this.props.fetchParent(this.getParentID());
				}.bind(this));
			}
		}]);
	
		return ParentPage;
	}(React.Component)) || _class);
	
	
	ParentPage.WrappedComponent.propTypes = PageStrictPropTypes({
		logs: PropTypes.array.isRequired,
		isLoadingLogs: PropTypes.bool,
		populateLogs: PropTypes.func,
		parent: PropTypes.object,
		student: PropTypes.object,
		fetchParent: PropTypes.func,
		fetchStudent: PropTypes.func,
		hideCommentBox: PropTypes.bool
	});
	
	module.exports = ParentPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRouter = __webpack_require__(153);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var ErrorDisplay = __webpack_require__(51);
	var LoadingButton = __webpack_require__(17);
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(653);
	__webpack_require__(223);
	
	var StudentParentsPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			students: RosterSelectors.students({ state: state }),
			parents: RosterSelectors.parents({ state: state }),
			studentLists: RosterSelectors.studentLists({ state: state })
		};
	}, function (dispatch, props) {
		function createParents(studentIDs, parentEmails) {
			// Do 5 at a time
			var BATCH_SIZE = 5;
	
			var theseStudentIDs = studentIDs.splice(0, BATCH_SIZE);
			var theseParentEmails = parentEmails.splice(0, BATCH_SIZE);
	
			return dispatch(RosterActions.createParents({
				studentIDs: theseStudentIDs,
				parentEmails: theseParentEmails,
				query: { no_background: true }
			})).then(function () {
				if (studentIDs.length) {
					return createParents(studentIDs, parentEmails);
				} else {
					return Promise.resolve();
				}
			});
		}
	
		function updateParents(parentIDs, parentEmails) {
			return dispatch(RosterActions.updateParent({
				id: parentIDs.pop(),
				update: { email: parentEmails.pop() }
			})).then(function () {
				if (parentIDs.length) {
					return updateParents(parentIDs, parentEmails);
				} else {
					return Promise.resolve();
				}
			});
		}
		return {
			populateData: function populateData() {
				return dispatch(RosterActions.fetchStudents({
					embeds: ["student.parent", "parent.email"]
				}));
			},
	
			createParents: createParents,
			updateParents: updateParents
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(StudentParentsPage, _React$Component);
	
		function StudentParentsPage(props) {
			_classCallCheck(this, StudentParentsPage);
	
			var _this = _possibleConstructorReturn(this, (StudentParentsPage.__proto__ || Object.getPrototypeOf(StudentParentsPage)).call(this));
	
			autobind(_this);
	
			var parentEmails = {};
			props.students.forEach(function (student) {
				var parent = _this.getParent(student, props);
				if (parent) {
					parentEmails[student.id] = parent.email;
				} else {
					parentEmails[student.id] = "";
				}
			});
	
			_this.state = { parentEmails: parentEmails, errors: {}, loading: false };
			return _this;
		}
	
		_createClass(StudentParentsPage, [{
			key: "getParent",
			value: function getParent(student, props) {
				props = props || this.props;
				return props.parents.find(function (x) {
					return x.id === student.parent;
				});
			}
		}, {
			key: "getStudentListName",
			value: function getStudentListName(student) {
				var studentList = this.props.studentLists.find(function (x) {
					return x.id === student.student_list_ids.primary;
				});
				return studentList ? studentList.name : "-";
			}
		}, {
			key: "setParentEmail",
			value: function setParentEmail(student, e) {
				var parentEmails = _extends({}, this.state.parentEmails, _defineProperty({}, student.id, e.target.value));
				var errors = _extends({}, this.state.errors);
				delete errors[student.id];
				this.setState({
					parentEmails: parentEmails, errors: errors
				});
			}
		}, {
			key: "validateParentEmail",
			value: function validateParentEmail(student) {
				var email = this.state.parentEmails[student.id];
				if (email && email.trim().length) {
					if (!EMAIL_REGEX.test(email)) {
						this.setState({
							errors: _extends({}, this.state.errors, _defineProperty({}, student.id, "This email is invalid"))
						});
					}
				}
			}
		}, {
			key: "submitParentEmails",
			value: function submitParentEmails(e) {
				var _this2 = this;
	
				$wr.nope(e);
	
				if (_.keys(this.state.errors).length) {
					return;
				}
	
				var addedStudentIDs = [];
				var addedParentEmails = [];
				var updatedParentIDs = [];
				var updatedParentEmails = [];
	
				this.props.students.map(function (student) {
					var parent = _this2.getParent(student);
	
					var newParentEmail = (_this2.state.parentEmails[student.id] || "").trim();
					if (newParentEmail.length) {
						if (!EMAIL_REGEX.test(newParentEmail)) {
							// Shouldn't have been able to submit, but filter it anyway
						} else if (!parent) {
							addedStudentIDs.push(student.id);
							addedParentEmails.push(newParentEmail);
						} else if (parent.email !== newParentEmail) {
							updatedParentIDs.push(parent.id);
							updatedParentEmails.push(newParentEmail);
						}
					}
				});
	
				var totalParentEmails = addedParentEmails.length + updatedParentEmails.length;
				if (totalParentEmails > 0) {
					var addressWord = $wr.pluralize("Address", totalParentEmails, "Addresses");
					var title = "Email " + addressWord + " Added!";
	
					if (totalParentEmails == 1) {
						var emailText = " The email has been ";
					} else {
						var emailText = " The emails have been ";
					}
	
					var text = "You have updated " + totalParentEmails + " parent email " + addressWord.toLowerCase() + "!" + emailText + "scheduled and will send shortly.";
	
					console.log("Adding: ", addedParentEmails.length);
					var promises = [];
					if (addedParentEmails.length > 0) {
						promises.push(this.props.createParents(addedStudentIDs, addedParentEmails));
					}
	
					if (updatedParentEmails.length > 0) {
						promises.push(this.props.updateParents(updatedParentIDs, updatedParentEmails));
					}
	
					this.setState({ loading: true });
	
					Promise.all(promises).then(function () {
						_this2.props.populateData().then(function () {
							_this2.setState({ loading: false });
						});
					});
	
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle"
					});
				} else {
					// "Fake" saving
					this.setState({ loading: true });
					setTimeout(function () {
						_this2.setState({ loading: false });
					}, 2000);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				var students = _.sortBy(this.props.students, function (s) {
					var base = _this3.getStudentListName(s);
					if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
						return base + " - " + s.first_name;
					} else {
						return base + " - " + s.last_name + ", " + s.first_name;
					}
				});
				var studentRows = students.map(function (student) {
	
					if (student.parent != null) {
						var currentParentEmail = student.parent.email;
					} else {
						var placeholderValue = "Enter parent email";
					}
					if (_this3.state.errors[student.id]) {
						var error = React.createElement(
							"div",
							{ className: "errorRed smallText" },
							_this3.state.errors[student.id]
						);
					}
					return React.createElement(
						"tr",
						{ key: student.id },
						React.createElement(
							"td",
							null,
							_this3.getStudentListName(student)
						),
						React.createElement(
							"td",
							{ className: "studentName" },
							student.display_name
						),
						React.createElement(
							"td",
							null,
							React.createElement("input", { className: "form-control", placeholder: placeholderValue,
								type: "email",
								value: _this3.state.parentEmails[student.id],
								onChange: _this3.setParentEmail.bind(_this3, student),
								onBlur: _this3.validateParentEmail.bind(_this3, student) }),
							error
						)
					);
				});
	
				if (_.keys(this.state.errors).length) {
					var buttonDisabled = true;
					var overallError = React.createElement(
						"div",
						{ className: "errorRed smallText text-center" },
						"Fix errors with emails above before saving"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "container studentParentsPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Add & Edit Parent Emails"
						)
					),
					React.createElement(
						"p",
						{ className: "instructionsText" },
						"Add parent emails so that they can sign off on their students' reading logs every week. We don't share email addresses and we only email parents to request reading log approval and share their child's reading progress."
					),
					React.createElement(
						"form",
						{ onSubmit: this.submitParentEmails },
						React.createElement(ErrorDisplay, { ref: "errors" }),
						React.createElement(
							"table",
							{ className: "table" },
							React.createElement(
								"tbody",
								null,
								React.createElement(
									"tr",
									null,
									React.createElement(
										"th",
										null,
										"Class"
									),
									React.createElement(
										"th",
										{ className: "studentName" },
										"Student"
									),
									React.createElement(
										"th",
										null,
										"Parent Email"
									)
								),
								studentRows
							)
						),
						React.createElement(LoadingButton, { className: "btn buttonSuccess center-block",
							text: "Save Emails",
							disabled: buttonDisabled,
							loading: this.state.loading,
							onClick: this.submitParentEmails }),
						overallError
					)
				);
			}
		}]);
	
		return StudentParentsPage;
	}(React.Component)) || _class) || _class);
	
	
	var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;
	
	StudentParentsPage.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from @connect
		students: PropTypes.array.isRequired,
		parents: PropTypes.array.isRequired,
		studentLists: PropTypes.array.isRequired,
	
		// Handlers from @connect
		populateData: PropTypes.func.isRequired,
		createParents: PropTypes.func.isRequired,
		updateParents: PropTypes.func.isRequired
	});
	
	module.exports = StudentParentsPage;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var LoadingButton = __webpack_require__(17);
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3757);
	
	var MergeStudentListsForm = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var id = props.effectiveUserID ? props.effectiveUserID : CurrentUser.get().id;
	  return {
	    admin: RosterSelectors.admin({ state: state, id: id }),
	    studentLists: RosterSelectors.studentLists({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var id = props.effectiveUserID ? props.effectiveUserID : CurrentUser.get().id;
	      var admin = RosterActions.fetchAdmins({ conditions: { userIDs: [id] }, embeds: ['user.link_suggestion', 'admin.related_users'] });
	      var studentLists = dispatch(RosterActions.fetchStudentLists({ embeds: ["student_list.admins"] }));
	
	      return Promise.all([studentLists, admin]);
	    },
	    mergeStudentLists: function mergeStudentLists(params) {
	      return dispatch(RosterActions.postUserTrigger(CurrentUser.get().id, params));
	    },
	    fetchRosterData: function fetchRosterData() {
	      var clearStudentLists = dispatch(RosterActions.clearStudentLists({}));
	      var rosterRefresh = dispatch(RosterActions.fetchRosterData({}));
	      return Promise.all([clearStudentLists, rosterRefresh]);
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(MergeStudentListsForm, _React$Component);
	
	  function MergeStudentListsForm(props) {
	    _classCallCheck(this, MergeStudentListsForm);
	
	    var _this = _possibleConstructorReturn(this, (MergeStudentListsForm.__proto__ || Object.getPrototypeOf(MergeStudentListsForm)).call(this));
	
	    autobind(_this);
	
	    LuckyOrangeClient.tagComponent("MergeStudentListsForm");
	
	    _this.state = {
	      slMapping: [],
	      loading: false
	    };
	    return _this;
	  }
	
	  ///////// HELPERS /////////
	
	
	  _createClass(MergeStudentListsForm, [{
	    key: "formatMappingHash",
	    value: function formatMappingHash() {
	      var remove = _.pluck(_.filter(this.state.slMapping, function (map) {
	        return map.option == REMOVE;
	      }), 'student_list_id');
	      var keep = _.pluck(_.filter(this.state.slMapping, function (map) {
	        return map.option == KEEP;
	      }), 'student_list_id');
	      return { keep: keep, remove: remove };
	    }
	  }, {
	    key: "mergedStudentLists",
	    value: function mergedStudentLists() {
	      return _.flatten(_.pluck(this.props.admin.related_users, 'student_list_ids'));
	    }
	  }, {
	    key: "initMap",
	    value: function initMap() {
	      var _props = this.props,
	          admin = _props.admin,
	          studentLists = _props.studentLists;
	
	      if (admin && studentLists) {
	        var mergedStudentLists = _.flatten(_.pluck(admin.related_users, 'student_list_ids'));
	        var slMapping = _.map(studentLists, function (sl) {
	          var option = _.contains(mergedStudentLists, sl.id) ? REMOVE : KEEP;
	          return { student_list_id: sl.id, option: option };
	        });
	
	        this.setState({ slMapping: slMapping });
	      }
	    }
	
	    //////////////////////////
	
	    //// SUBMIT HANDLER /////
	
	  }, {
	    key: "onSubmit",
	    value: function onSubmit() {
	      var _this2 = this;
	
	      this.setState({ loading: true });
	
	      var slMapping = this.formatMappingHash();
	
	      // merge student lists
	      var params = { what: "merge_student_lists", mapping: slMapping };
	
	      this.props.mergeStudentLists(params).then(function (response) {
	        _this2.setState({ loading: false });
	
	        if (response.success) {
	          // reload student lists in state (needed since trigger function isn't Reduxy)
	          _this2.props.fetchRosterData().then(function () {
	            window.wrNotifications.triggerDropDownNotification({
	              title: "Success!", text: "Student lists have been merged with this account", icon: "ok-sign"
	            });
	            if (_this2.props.afterSubmit) {
	              _this2.props.afterSubmit();
	            }
	            _this2.setState({ loading: false });
	          });
	        } else {
	          _this2.setState({ loading: false });
	          // error message
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Oops!", text: "Something went wrong and the student lists were not merged",
	            type: "error", icon: "exclamation-sign"
	          }, 4000);
	        }
	      });
	    }
	  }, {
	    key: "dropdownText",
	    value: function dropdownText(slID) {
	      var map = _.findWhere(this.state.slMapping, { student_list_id: slID });
	      return map ? map.option : '';
	    }
	    //////////////////////////
	
	    ///// EVENT HANDLERS /////
	
	  }, {
	    key: "handleClick",
	    value: function handleClick(sl, option) {
	      var slMapping = _.filter(this.state.slMapping, function (map) {
	        return map.student_list_id != sl.id;
	      });
	      slMapping = [].concat(_toConsumableArray(slMapping), [{ student_list_id: sl.id, option: option }]);
	      this.setState({ slMapping: slMapping });
	    }
	    //////////////////////////
	
	    /// RENDER FUNCTIONS ////
	
	  }, {
	    key: "renderOptionDropdown",
	    value: function renderOptionDropdown(sl) {
	      var _this3 = this;
	
	      var dropdownOptions = _.map(OPTIONS, function (option) {
	        return React.createElement(ButtonDropdownOption, { onClick: function onClick() {
	            return _this3.handleClick(sl, option);
	          },
	          text: option, key: option });
	      });
	      return React.createElement(
	        "div",
	        { className: "slOptionsDropdown" },
	        React.createElement(
	          ButtonDropdown,
	          { text: this.dropdownText(sl.id), className: "duplicateUserButtonDropdown" },
	          dropdownOptions
	        )
	      );
	    }
	  }, {
	    key: "renderRows",
	    value: function renderRows() {
	      var _this4 = this;
	
	      return _.map(this.props.studentLists, function (sl, index) {
	        var borderClass = index == _.size(_this4.props.studentLists) - 1 ? '' : 'borderBottom';
	        return React.createElement(
	          "div",
	          { className: "slRow " + borderClass, key: 'sl-' + sl.id },
	          React.createElement(
	            "div",
	            { className: "slColumn" },
	            sl.name
	          ),
	          React.createElement(
	            "div",
	            { className: "slOptionsColumn" },
	            _this4.renderOptionDropdown(sl)
	          )
	        );
	      });
	    }
	    //////////////////////////
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      if (this.state.loading) {
	        return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	      } else if (!_.isEmpty(this.props.studentLists)) {
	        return React.createElement(
	          "div",
	          { className: "mergeStudentListsForm" },
	          React.createElement(
	            "div",
	            { className: "labelRow" },
	            React.createElement(
	              "div",
	              { className: "studentListListLabel" },
	              "Student lists"
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "slList" },
	            this.renderRows(),
	            React.createElement(
	              "div",
	              { className: "btnContainer" },
	              React.createElement(LoadingButton, { loading: this.state.loading, text: "Submit",
	                className: "btn buttonPrimary submitLink",
	                onClick: function onClick() {
	                  return _this5.onSubmit();
	                } })
	            )
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initMap();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (_.size(prevProps.studentLists) !== _.size(this.props.studentLists)) {
	        this.initMap();
	      }
	    }
	  }]);
	
	  return MergeStudentListsForm;
	}(React.Component)) || _class) || _class);
	
	
	var KEEP = 'Keep';
	var REMOVE = 'Remove';
	var OPTIONS = [KEEP, REMOVE];
	
	MergeStudentListsForm.WrappedComponent.propTypes = PageStrictPropTypes({
	  studentListIDs: PropTypes.array,
	  studentLists: PropTypes.array,
	  admin: PropTypes.object,
	  effectiveUserID: PropTypes.number,
	
	  populateData: PropTypes.func.isRequired,
	  afterSubmit: PropTypes.func,
	  mergeStudentLists: PropTypes.func,
	  fetchRosterData: PropTypes.func
	});
	
	module.exports = MergeStudentListsForm;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactSelect = __webpack_require__(154);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var LoadingButton = __webpack_require__(17);
	var PaginationControls = __webpack_require__(90);
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3758);
	
	function selectUsers(state, props, grabDuplicates) {
	  var duplicateUserIDs = props.duplicateUserIDs,
	      userIDs = props.userIDs,
	      mergeType = props.mergeType;
	
	
	  var userIDs = grabDuplicates ? duplicateUserIDs : userIDs;
	
	  if (mergeType == ADMIN_MERGE_TYPE) {
	    return RosterSelectors.admins({ state: state, conditions: { ids: userIDs } });
	  } else if (mergeType == CLEVER_MERGE_TYPE) {
	    if (grabDuplicates) {
	      var admins = RosterSelectors.admins({ state: state, conditions: { ids: userIDs } });
	      var students = _.compact(_.uniq(_.flatten(_.map(admins, function (admin) {
	        return _.pluck(admin.all_student_lists, 'students');
	      }))));
	
	      return admins.concat(students);
	    } else {
	      return props.cleverUsers;
	    }
	  } else {
	    return RosterSelectors.students({ state: state, conditions: { ids: userIDs } });
	  }
	}
	
	function fetchUsers(props, grabDuplicates) {
	  var duplicateUserIDs = props.duplicateUserIDs,
	      userIDs = props.userIDs,
	      mergeType = props.mergeType;
	
	
	  var userIDs = grabDuplicates ? duplicateUserIDs : userIDs;
	
	  if (mergeType == ADMIN_MERGE_TYPE || mergeType == CLEVER_MERGE_TYPE) {
	    var embeds = ["admin.all_student_lists", "student_list.students", "admin.related_users", "user.clever_link_suggestion"];
	    return RosterActions.fetchAdmins({ filters: { ids: userIDs }, embeds: embeds });
	  } else {
	    var embeds = ['user.link_suggestion', "user.link_suggestions", "student.password", "student.sso_data"].concat(RosterActions.GLOBAL_STUDENT_EMBEDS);
	    return RosterActions.fetchStudents({ conditions: { userIDs: userIDs }, embeds: embeds });
	  }
	}
	
	var MergeUsersForm = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    users: selectUsers(state, props, false),
	    duplicateUsers: selectUsers(state, props, true)
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      var users = dispatch(fetchUsers(props, false));
	      var dupUsers = dispatch(fetchUsers(props, true));
	
	      var promises = [users, dupUsers];
	
	      if (props.mergeType !== CLEVER_MERGE_TYPE) {
	        var conditions = CurrentUser.get().is_wizard ? { slIDs: props.studentListIDs } : {};
	        var studentLists = dispatch(RosterActions.fetchStudentLists({
	          conditions: conditions, embeds: ["student_list.admins", "student_list.students", "student_list.primary_admin", "student.primary_student_list_id"]
	        }));
	        promises = promises.concat(studentLists);
	      }
	
	      return Promise.all(promises);
	    },
	    mergeUsers: function mergeUsers(params) {
	      return dispatch(RosterActions.postUserTrigger(CurrentUser.get().id, params));
	    },
	    fetchRosterData: function fetchRosterData() {
	      var clearUsers = props.mergeType == ADMIN_MERGE_TYPE ? dispatch(RosterActions.clearAdmins({})) : dispatch(RosterActions.clearStudents({}));
	      var rosterRefresh = dispatch(RosterActions.fetchRosterData({}));
	      return Promise.all([clearUsers, rosterRefresh]);
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(MergeUsersForm, _React$Component);
	
	  function MergeUsersForm(props) {
	    _classCallCheck(this, MergeUsersForm);
	
	    var _this = _possibleConstructorReturn(this, (MergeUsersForm.__proto__ || Object.getPrototypeOf(MergeUsersForm)).call(this));
	
	    autobind(_this);
	
	    LuckyOrangeClient.tagComponent("MergeUsersForm");
	
	    _this.state = {
	      chunked_users: [],
	      idMapping: [],
	      ignoreSuggestion: [],
	      overrideMerge: [],
	      loading: false,
	      page: 1
	    };
	    return _this;
	  }
	
	  ///////// HELPERS /////////
	
	
	  _createClass(MergeUsersForm, [{
	    key: "buildPageConfirm",
	    value: function buildPageConfirm(pageMap) {
	      var _this2 = this;
	
	      var confirmText = 'Are you sure you want to merge the following users:\n';
	      _.each(_.keys(pageMap), function (dupUserId) {
	        var dupUser = _.findWhere(_this2.props.duplicateUsers, { id: parseInt(dupUserId) });
	        var cleverUser = _.findWhere(_this2.props.users, { id: pageMap[dupUserId] });
	        confirmText += dupUser.first_name + " " + dupUser.last_name + " (ID: " + dupUser.id + ") ";
	        confirmText += "==> " + cleverUser.first_name + " " + cleverUser.last_name + " (ID: " + cleverUser.id + ")\n";
	      });
	      return confirmText;
	    }
	  }, {
	    key: "dupUserSearch",
	    value: function dupUserSearch(userID) {
	      var duplicateUsers = this.props.duplicateUsers;
	
	      var userMap = this.userMapSearch(userID);
	      if (userMap) {
	        return _.findWhere(duplicateUsers, { id: userMap.dup_user_id });
	      }
	    }
	  }, {
	    key: "userMapSearch",
	    value: function userMapSearch(userID) {
	      return _.findWhere(this.state.idMapping, { user_id: userID });
	    }
	  }, {
	    key: "dropdownValue",
	    value: function dropdownValue(user) {
	      if (!_.isEmpty(this.userMapSearch(user.id))) {
	        var dupUser = this.dupUserSearch(user.id);
	        var grade = "";
	        if (user.grade) {
	          grade = user.grade;
	        } else if (user.grade_level) {
	          grade = user.grade_level;
	        }
	        return { value: dupUser.id, label: dupUser.first_name + " " + dupUser.last_name + " " + grade + " (ID: " + dupUser.id + ")" };
	      } else {
	        return { value: 0, label: 'No Match' };
	      }
	    }
	  }, {
	    key: "suggestionMatches",
	    value: function suggestionMatches(user) {
	      return _.filter(this.props.duplicateUsers, function (dupUser) {
	        return user.link_suggestion == dupUser.id;
	      });
	    }
	  }, {
	    key: "showSuggestion",
	    value: function showSuggestion(user) {
	      return !_.isEmpty(this.suggestionMatches(user)) && !_.include(_.pluck(this.state.ignoreSuggestion, 'user_id'), user.id);
	    }
	  }, {
	    key: "getLinkSuggestion",
	    value: function getLinkSuggestion(user) {
	      if (!_.include(_.pluck(this.state.ignoreSuggestion, 'user_id'), user.id)) {
	        return _.findWhere(this.props.duplicateUsers, { id: user.link_suggestion });
	      }
	    }
	  }, {
	    key: "formatMappingHash",
	    value: function formatMappingHash() {
	      var _this3 = this;
	
	      // format mapping hash for l2e
	      // from_user_id: to_user_id
	      var idMapping = {};
	      _.each([].concat(_toConsumableArray(this.state.idMapping)), function (map) {
	        idMapping[map.dup_user_id] = map.user_id;
	      });
	
	      // add suggestions that were confirmed
	      var index = 0;
	      _.each(this.props.users, function (user) {
	        index += 1;
	        if (_this3.getLinkSuggestion(user)) {
	          idMapping[_this3.getLinkSuggestion(user).id] = user.id;
	        }
	      });
	
	      if (index == _.size(this.props.users)) {
	        return idMapping;
	      }
	    }
	  }, {
	    key: "dropdownOptions",
	    value: function dropdownOptions(user) {
	      var _this4 = this;
	
	      var _props = this.props,
	          duplicateUsers = _props.duplicateUsers,
	          users = _props.users,
	          mergeType = _props.mergeType;
	
	      // if clever merge, filter dropdown by duplicate users that
	      // are not already merged with clever users
	
	      if (mergeType == CLEVER_MERGE_TYPE) {
	        duplicateUsers = _.filter(duplicateUsers, function (dupUser) {
	          return _.isEmpty(_.where(users, { user_id: dupUser.id }));
	        });
	      }
	
	      // filter dropdown options based on user type
	      if (this.isDistrictAdmin(user)) {
	        duplicateUsers = _.filter(duplicateUsers, function (dupUser) {
	          return _this4.isDistrictAdmin(dupUser);
	        });
	      } else if (this.isSchoolAdmin(user)) {
	        duplicateUsers = _.filter(duplicateUsers, function (dupUser) {
	          return _this4.isSchoolAdmin(dupUser);
	        });
	      } else if (this.isTeacher(user)) {
	        duplicateUsers = _.filter(duplicateUsers, function (dupUser) {
	          return _this4.isTeacher(dupUser);
	        });
	      } else if (this.isStudent(user)) {
	        duplicateUsers = _.filter(duplicateUsers, function (dupUser) {
	          return _this4.isStudent(dupUser);
	        });
	      }
	
	      // remove duplicate user
	      duplicateUsers = _.uniq(duplicateUsers, function (dupUser) {
	        return dupUser.id;
	      });
	
	      return _.map(duplicateUsers, function (dupUser) {
	        var grade = "";
	        if (dupUser.grade) {
	          grade = dupUser.grade;
	        } else if (dupUser.grade_level) {
	          grade = dupUser.grade_level;
	        }
	
	        return { value: dupUser.id, label: dupUser.first_name + " " + dupUser.last_name + " " + grade + " (ID: " + dupUser.id + ")" };
	      });
	    }
	  }, {
	    key: "totalUserCount",
	    value: function totalUserCount() {
	      return _.size(this.props.users);
	    }
	  }, {
	    key: "sortedUsers",
	    value: function sortedUsers() {
	      var _this5 = this;
	
	      return _.sortBy(this.props.users, function (user) {
	
	        var linkStrengthIndex = 0;
	        var mergeStrenghtIndex = 0;
	
	        // IF NO USER MERGED
	        if (user.user_id == null) {
	          var suggestion = _this5.getLinkSuggestion(user);
	
	          if (suggestion) {
	            linkStrengthIndex = 1;
	            var strength = _this5.getMatchStrength(user, suggestion);
	
	            if (strength == "partial") {
	              linkStrengthIndex = 2;
	            } else if (strength == "perfect") {
	              linkStrengthIndex = 3;
	            }
	          }
	        } else {
	          // IF USER MERGED
	          var suggestion = _this5.mergedCleverUser(user);
	          if (suggestion) {
	            mergeStrenghtIndex = 1;
	            var _strength = _this5.getMatchStrength(user, suggestion);
	
	            if (_strength == "partial") {
	              mergeStrenghtIndex = 2;
	            } else if (_strength == "perfect") {
	              mergeStrenghtIndex = 3;
	            }
	          } else {
	            mergeStrenghtIndex = 0;
	          }
	        }
	        // PLACE WEAK LINK AND MERGE FIRST
	        return [user.grade, mergeStrenghtIndex, linkStrengthIndex, user.last_name, user.first_name].join("_");
	      });
	    }
	    // chunk users in state for pagination
	
	  }, {
	    key: "getPerPage",
	    value: function getPerPage() {
	      if (this.props.mergeType == CLEVER_MERGE_TYPE) {
	        return 20;
	      }
	      return PER_PAGE;
	    }
	  }, {
	    key: "chunkUsers",
	    value: function chunkUsers() {
	      this.setState({ chunked_users: _.chunk(this.sortedUsers(), this.getPerPage()) });
	    }
	    // return dup user that is merged with a clever user or false
	
	  }, {
	    key: "mergedCleverUser",
	    value: function mergedCleverUser(user) {
	      if (user.user_id && // user id exists
	      _.size(this.props.duplicateUsers) && // duplicate users exist
	      !_.findWhere(this.state.overrideMerge, { user_id: user.id }) && // user is not overrriden
	      this.props.mergeType == CLEVER_MERGE_TYPE) {
	        // merge type is correct
	        return _.findWhere(this.props.duplicateUsers, { id: user.user_id });
	      } else {
	        return false;
	      }
	    }
	    // places suggestion in map automatically
	
	  }, {
	    key: "addSuggestionsToMap",
	    value: function addSuggestionsToMap() {
	      var _this6 = this;
	
	      var newMap = [].concat(_toConsumableArray(this.state.idMapping));
	
	      var index = 0;
	      _.each(this.props.users, function (user) {
	        index += 1;
	        if (_this6.getLinkSuggestion(user) && !_this6.mergedCleverUser(user)) {
	          var existingMap = _.findWhere(newMap, { user_id: user.id });
	          if (existingMap) {
	            newMap = _.filter(newMap, function (map) {
	              return map.user_id != user.id;
	            });
	          }
	          newMap = [].concat(_toConsumableArray(newMap), [{ user_id: user.id, dup_user_id: _this6.getLinkSuggestion(user).id }]);
	        }
	      });
	
	      if (index == _.size(this.props.users)) {
	        this.setState({ idMapping: newMap });
	      }
	    }
	  }, {
	    key: "isDistrictAdmin",
	    value: function isDistrictAdmin(user) {
	      return _.includes(DISTRICT_ADMIN_ROLES, user.role);
	    }
	  }, {
	    key: "isSchoolAdmin",
	    value: function isSchoolAdmin(user) {
	      return _.includes(SCHOOL_ADMIN_ROLES, user.role);
	    }
	  }, {
	    key: "isTeacher",
	    value: function isTeacher(user) {
	      return _.includes(TEACHER_ROLES, user.role);
	    }
	  }, {
	    key: "isStudent",
	    value: function isStudent(user) {
	      return _.includes(STUDENT_ROLES, user.role);
	    }
	    //////////////////////////
	
	    //// SUBMIT HANDLER /////
	
	  }, {
	    key: "onSubmitSingle",
	    value: function onSubmitSingle(suggestionId, cleverUserId) {
	      var _this7 = this;
	
	      var idMapping = {};
	      idMapping[suggestionId] = cleverUserId;
	
	      var params = {
	        what: "merge_users",
	        mapping: idMapping,
	        merge_type: this.props.mergeType
	      };
	
	      this.props.mergeUsers(params).then(function (response) {
	        if (response.success) {
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
	          });
	          // UPDATE CLEVER USER IN PARENT COMPONENT
	          _this7.props.afterSubmit(suggestionId, cleverUserId);
	        } else {
	          _this7.setState({ loading: false });
	          // error message
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Oops!", text: "Something went wrong and the users were not merged",
	            type: "error", icon: "exclamation-sign"
	          }, 4000);
	        }
	      });
	    }
	  }, {
	    key: "onPageSubmit",
	    value: function onPageSubmit() {
	      var _this8 = this;
	
	      var _state = this.state,
	          page = _state.page,
	          chunked_users = _state.chunked_users;
	
	      var cleverUsers = chunked_users[page - 1];
	
	      var masterMap = this.formatMappingHash();
	      // pull current page from master map
	      var pageMap = {};
	      _.each(cleverUsers, function (cUser) {
	        if (_.includes(_.values(masterMap), cUser.id)) {
	          var dupUserId = Object.keys(masterMap).find(function (key) {
	            return masterMap[key] === cUser.id;
	          });
	          pageMap[dupUserId] = cUser.id;
	        }
	      });
	
	      if (confirm(this.buildPageConfirm(pageMap))) {
	        var params = {
	          what: "merge_users",
	          mapping: pageMap,
	          merge_type: this.props.mergeType
	        };
	
	        this.props.mergeUsers(params).then(function (response) {
	          if (response.success) {
	            window.wrNotifications.triggerDropDownNotification({
	              title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
	            });
	            // UPDATE CLEVER USER IN PARENT COMPONENT
	            _.each(_.keys(pageMap), function (suggestionId) {
	              _this8.props.afterSubmit(parseInt(suggestionId), pageMap[suggestionId]);
	            });
	          } else {
	            _this8.setState({ loading: false });
	            // error message
	            window.wrNotifications.triggerDropDownNotification({
	              title: "Oops!", text: "Something went wrong and the users were not merged",
	              type: "error", icon: "exclamation-sign"
	            }, 4000);
	          }
	        });
	      }
	    }
	  }, {
	    key: "onSubmit",
	    value: function onSubmit() {
	      var _this9 = this;
	
	      LuckyOrangeClient.tagComponent("UsersMerging");
	
	      this.setState({ loading: true });
	      var idMapping = this.formatMappingHash();
	
	      // merge users
	      var params = {
	        what: "merge_users",
	        mapping: idMapping,
	        merge_type: this.props.mergeType
	      };
	
	      this.props.mergeUsers(params).then(function (response) {
	        if (response.success) {
	          // refresh users
	          _this9.props.fetchRosterData().then(function () {
	            // success message
	            window.wrNotifications.triggerDropDownNotification({
	              title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
	            });
	            // post submit method
	            if (_this9.props.afterSubmit) {
	              _this9.props.afterSubmit();
	            }
	            _this9.setState({ loading: false });
	          });
	        } else {
	          _this9.setState({ loading: false });
	          // error message
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Oops!", text: "Something went wrong and the users were not merged",
	            type: "error", icon: "exclamation-sign"
	          }, 4000);
	        }
	      });
	    }
	    //////////////////////////
	
	    ///// EVENT HANDLERS /////
	
	  }, {
	    key: "handleDuplicateDropdownClick",
	    value: function handleDuplicateDropdownClick(user, dupUserID) {
	
	      if (!_.isEmpty(this.userMapSearch(user.id)) && this.userMapSearch(user.id).dup_user_id == dupUserID) {
	        // selects previously-selected dup user
	        var newIDMap = _.filter([].concat(_toConsumableArray(this.state.idMapping)), function (map) {
	          return map.user_id != user.id;
	        });
	      } else if (!_.isEmpty(this.userMapSearch(user.id))) {
	        // updateds duplicate user selection
	        var newIDMap = _.filter([].concat(_toConsumableArray(this.state.idMapping)), function (map) {
	          return map.user_id != user.id;
	        });
	        newIDMap = [].concat(_toConsumableArray(newIDMap), [{ user_id: user.id, dup_user_id: dupUserID }]);
	      } else {
	        // new duplicate user selection
	        var newIDMap = [].concat(_toConsumableArray(this.state.idMapping), [{ user_id: user.id, dup_user_id: dupUserID }]);
	      }
	
	      // check if dupUser is selected for a different user
	      var dupUserMap = _.findWhere(newIDMap, { dup_user_id: dupUserID });
	      if (dupUserMap && dupUserMap.user_id !== user.id) {
	        newIDMap = _.filter(newIDMap, function (map) {
	          return map.dup_user_id != dupUserID;
	        });
	        newIDMap = [].concat(_toConsumableArray(newIDMap), [{ user_id: user.id, dup_user_id: dupUserID }]);
	      }
	
	      // check if the dup_user is a current suggestion
	      var ignoreSuggestion = [].concat(_toConsumableArray(this.state.ignoreSuggestion));
	      var linkSuggestion = _.findWhere(this.props.users, { link_suggestion: dupUserID });
	      if (linkSuggestion) {
	        ignoreSuggestion = _.filter(ignoreSuggestion, function (suggestion) {
	          return suggestion.dup_user_id != dupUserID;
	        });
	        ignoreSuggestion = [].concat(_toConsumableArray(ignoreSuggestion), [{ user_id: linkSuggestion.id, dup_user_id: dupUserID }]);
	      }
	
	      this.setState({ idMapping: newIDMap, ignoreSuggestion: ignoreSuggestion });
	    }
	  }, {
	    key: "handleChangeSuggestion",
	    value: function handleChangeSuggestion(dupUserID, userID) {
	      this.setState({ ignoreSuggestion: [].concat(_toConsumableArray(this.state.ignoreSuggestion), [{ dup_user_id: dupUserID, user_id: userID }]) });
	    }
	  }, {
	    key: "handleChangeMerge",
	    value: function handleChangeMerge(dupUserID, userID) {
	      this.setState({ overrideMerge: [].concat(_toConsumableArray(this.state.overrideMerge), [{ dup_user_id: dupUserID, user_id: userID }]) });
	    }
	  }, {
	    key: "onPageChange",
	    value: function onPageChange(page) {
	      this.setState({ page: page });
	    }
	    //////////////////////////
	
	    /// RENDER FUNCTIONS ////
	
	  }, {
	    key: "renderLoadingBtn",
	    value: function renderLoadingBtn() {
	      var _this10 = this;
	
	      if (this.props.mergeType == CLEVER_MERGE_TYPE) {
	        return React.createElement(
	          "div",
	          { className: "btnContainer" },
	          React.createElement(LoadingButton, { loading: this.state.loading, text: 'Submit Page',
	            className: "btn buttonPrimary submitLink",
	            onClick: function onClick() {
	              return _this10.onPageSubmit();
	            } })
	        );
	      } else {
	        return React.createElement(
	          "div",
	          { className: "btnContainer" },
	          React.createElement(LoadingButton, { loading: this.state.loading, text: 'Submit',
	            className: "btn buttonPrimary submitLink",
	            onClick: function onClick() {
	              return _this10.onSubmit();
	            } })
	        );
	      }
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination() {
	
	      return React.createElement(
	        "div",
	        { className: "paginationControlls" },
	        React.createElement(PaginationControls, { page: this.state.page,
	          perPage: this.getPerPage(),
	          totalCount: this.totalUserCount(),
	          onPageChange: this.onPageChange })
	      );
	    }
	  }, {
	    key: "renderConfirmChange",
	    value: function renderConfirmChange(userID, cleverUserID) {
	      var _this11 = this;
	
	      return React.createElement(
	        "a",
	        { onClick: function onClick() {
	            return _this11.onSubmitSingle(userID, cleverUserID);
	          }, className: "changeSuggestion" },
	        "confirm"
	      );
	    }
	  }, {
	    key: "renderChangeSuggestion",
	    value: function renderChangeSuggestion(suggestion, user) {
	      var _this12 = this;
	
	      return React.createElement(
	        "a",
	        { onClick: function onClick() {
	            return _this12.handleChangeSuggestion(suggestion.id, user.id);
	          }, className: "changeSuggestion" },
	        "change"
	      );
	    }
	  }, {
	    key: "renderDuplicateUserDropdown",
	    value: function renderDuplicateUserDropdown(user) {
	      var _this13 = this;
	
	      var dupUserSelection = this.dupUserSearch(user.id);
	      if (dupUserSelection) {
	        var confirmChange = this.renderConfirmChange(dupUserSelection.id, user.id);
	        console.log(dupUserSelection, user);
	        var suggestions = this.renderAllSuggestions(user, false);
	      }
	
	      return React.createElement(
	        "span",
	        null,
	        React.createElement(
	          "div",
	          { className: "duplicateUsersDropdown" },
	          React.createElement(_reactSelect2.default, {
	            clearable: false,
	            value: this.dropdownValue(user),
	            options: this.dropdownOptions(user),
	            onChange: function onChange(opt) {
	              return _this13.handleDuplicateDropdownClick(user, opt.value);
	            } }),
	          confirmChange
	        ),
	        suggestions
	      );
	    }
	  }, {
	    key: "getMatchStrength",
	    value: function getMatchStrength(user, suggestion) {
	      if (user == undefined || suggestion == undefined) {
	        return "";
	      }
	
	      if (user.first_name.toLowerCase() == suggestion.first_name.toLowerCase() && user.last_name.toLowerCase() == suggestion.last_name.toLowerCase()) {
	        return "perfect";
	      } else if (user.first_name.toLowerCase() == suggestion.first_name.toLowerCase() || user.last_name.toLowerCase() == suggestion.last_name.toLowerCase()) {
	        return "partial";
	      } else {
	        return "weak";
	      }
	    }
	  }, {
	    key: "renderAllSuggestions",
	    value: function renderAllSuggestions(user, ignoreTopSuggestion) {
	      var _this14 = this;
	
	      if (_.size(user.all_link_suggestions) > 1) {
	        var intro = ignoreTopSuggestion ? 'Other Suggestions: ' : 'All Suggestions: ';
	        return React.createElement(
	          "div",
	          { className: "otherSuggestions" },
	          intro,
	          _.map(user.all_link_suggestions, function (otherSuggestionID, idx) {
	            if (!ignoreTopSuggestion || otherSuggestionID != user.link_suggestion) {
	              var otherSuggestion = _.findWhere(_this14.props.duplicateUsers, { id: user.link_suggestion });
	              var content = otherSuggestion.first_name + " " + otherSuggestion.last_name + " (" + otherSuggestionID + ")";
	              if (idx !== _.size(user.all_link_suggestions) - 1) {
	                content = content + ', ';
	              }
	              return React.createElement(
	                "span",
	                null,
	                content
	              );
	            }
	          })
	        );
	      }
	    }
	  }, {
	    key: "renderSuggestion",
	    value: function renderSuggestion(user) {
	      var suggestion = this.getLinkSuggestion(user);
	      var colorCode = this.getMatchStrength(user, suggestion) + "Match";
	
	      return React.createElement(
	        "div",
	        { className: "suggestionContainer" },
	        React.createElement(
	          "div",
	          { className: "suggestionRow" },
	          React.createElement(
	            "div",
	            { className: "column one " + colorCode, style: { width: '80%' } },
	            suggestion.first_name + " " + suggestion.last_name,
	            " ",
	            React.createElement("br", null),
	            " ",
	            "grade: " + suggestion.grade_level + " (ID: " + suggestion.id + ")"
	          ),
	          React.createElement(
	            "div",
	            { className: "column two", style: { width: '20%' } },
	            this.renderConfirmChange(suggestion.id, user.id)
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "suggestionRow" },
	          React.createElement(
	            "div",
	            { className: "column one", style: { width: '80%' } },
	            this.renderAllSuggestions(user, true)
	          ),
	          React.createElement(
	            "div",
	            { className: "column two", style: { width: '20%' } },
	            this.renderChangeSuggestion(suggestion, user)
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderMergeOutsideSchool",
	    value: function renderMergeOutsideSchool(user) {
	      return React.createElement(
	        "div",
	        { className: "mergeContainer" },
	        React.createElement(
	          "div",
	          { className: "merge warning" },
	          "Merged With User Outside of School Org: (ID: ",
	          user.user_id,
	          ")"
	        )
	      );
	    }
	  }, {
	    key: "renderMergedUser",
	    value: function renderMergedUser(user) {
	      var mergedUser = this.mergedCleverUser(user);
	      var colorCode = this.getMatchStrength(user, mergedUser) + "Merge";
	
	      return React.createElement(
	        "div",
	        { className: "mergeContainer" },
	        React.createElement(
	          "div",
	          { className: "merge " + colorCode },
	          "Merged With ",
	          mergedUser.first_name + " " + mergedUser.last_name,
	          " ",
	          React.createElement("br", null),
	          " ",
	          "grade: " + mergedUser.grade_level + " (ID: " + mergedUser.id + ")"
	        )
	      );
	    }
	  }, {
	    key: "renderColumnHeaders",
	    value: function renderColumnHeaders() {
	      if (this.props.mergeType == STUDENT_MERGE_TYPE) {
	        return React.createElement(
	          "div",
	          { className: "labelRow" },
	          React.createElement(
	            "div",
	            { className: "userListLabel" },
	            "Users from this account"
	          ),
	          React.createElement(
	            "div",
	            { className: "dupUserListLabel" },
	            "Users from merged account"
	          )
	        );
	      }
	    }
	  }, {
	    key: "pendingText",
	    value: function pendingText() {
	      var _props2 = this.props,
	          duplicateUsers = _props2.duplicateUsers,
	          mergeType = _props2.mergeType;
	
	      if (mergeType == CLEVER_MERGE_TYPE) {
	        if (_.isEmpty(duplicateUsers)) {
	          return React.createElement(
	            "div",
	            null,
	            "Duplicate users loading..."
	          );
	        }
	      }
	    }
	  }, {
	    key: "renderRows",
	    value: function renderRows() {
	      var _this15 = this;
	
	      var _state2 = this.state,
	          chunked_users = _state2.chunked_users,
	          page = _state2.page;
	
	      var users = chunked_users[page - 1];
	      return _.map(users, function (user, index) {
	        // renders suggestion, merge, or dropdown
	        if (_this15.mergedCleverUser(user)) {
	          var dupUserColumn = _this15.renderMergedUser(user);
	        } else if (_this15.getLinkSuggestion(user)) {
	          var dupUserColumn = _this15.renderSuggestion(user);
	        } else if (user.user_id) {
	          var dupUserColumn = _this15.renderMergeOutsideSchool(user);
	        } else {
	          var dupUserColumn = _this15.renderDuplicateUserDropdown(user);
	        }
	        var borderClass = index == _.size(users) - 1 ? '' : 'borderBottom';
	
	        return React.createElement(
	          "div",
	          { className: "userRow " + borderClass, key: 'user-' + user.id },
	          React.createElement(
	            "div",
	            { className: "userColumn" },
	            user.first_name + " " + user.last_name,
	            " ",
	            React.createElement("br", null),
	            " ",
	            "grade: " + user.grade + " (ID: " + user.id + ")"
	          ),
	          React.createElement(
	            "div",
	            { className: "duplicateUsersColumn" },
	            dupUserColumn
	          )
	        );
	      });
	    }
	    //////////////////////////
	
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.loading) {
	        return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	      } else {
	        return React.createElement(
	          "div",
	          { className: "mergeUserForm" },
	          this.renderColumnHeaders(),
	          this.pendingText(),
	          React.createElement(
	            "div",
	            { className: "usersList" },
	            this.renderRows()
	          ),
	          this.renderPagination(),
	          this.renderLoadingBtn()
	        );
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.chunkUsers();
	      this.addSuggestionsToMap();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.users !== this.props.users) {
	        this.chunkUsers();
	        this.addSuggestionsToMap();
	      }
	    }
	  }]);
	
	  return MergeUsersForm;
	}(React.Component)) || _class) || _class);
	
	
	var ADMIN_MERGE_TYPE = "admin";
	var STUDENT_MERGE_TYPE = "student";
	var CLEVER_MERGE_TYPE = 'clever';
	var PER_PAGE = 10;
	
	var STUDENT_ROLE = "studentRole";
	var TEACHER_ROLE = "teacherRole";
	var SCHOOL_ADMIN_ROLE = "adminRole";
	var DISTRICT_ADMIN_ROLE = "districtAdminRole";
	
	var CLEVER_STUDENT_ROLE = "student";
	var CLEVER_TEACHER_ROLE = "teacher";
	var CLEVER_SCHOOL_ADMIN_ROLE = "school_admin";
	var CLEVER_DISTRICT_ADMIN_ROLE = "district_admin";
	
	var DISTRICT_ADMIN_ROLES = [DISTRICT_ADMIN_ROLE, CLEVER_DISTRICT_ADMIN_ROLE];
	var SCHOOL_ADMIN_ROLES = [SCHOOL_ADMIN_ROLE, CLEVER_SCHOOL_ADMIN_ROLE];
	var TEACHER_ROLES = [TEACHER_ROLE, CLEVER_TEACHER_ROLE];
	var STUDENT_ROLES = [STUDENT_ROLE, CLEVER_STUDENT_ROLE];
	
	MergeUsersForm.WrappedComponent.propTypes = PageStrictPropTypes({
	  userIDs: PropTypes.array,
	  duplicateUserIDs: PropTypes.array,
	  mergeType: PropTypes.string,
	  studentListIDs: PropTypes.array,
	  duplicateUsers: PropTypes.array,
	  users: PropTypes.array,
	  cleverUsers: PropTypes.array,
	
	  populateData: PropTypes.func.isRequired,
	  mergeUsers: PropTypes.func,
	  afterSubmit: PropTypes.func,
	  fetchRosterData: PropTypes.func
	});
	
	module.exports = MergeUsersForm;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	var WidgetContainer = __webpack_require__(189);
	var WidgetConfig = __webpack_require__(66);
	var StudentAvatar = __webpack_require__(35);
	
	var DataStudentDigest = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    student: RosterSelectors.student({ state: state, id: props.studentID })
	  };
	}, function (dispatch, props) {
	  return {
	    // Currently undefined, but we can do this for sure
	    // populateData: () => dispatch(RosterActions.batchFetchStudent(props.studentID))
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(DataStudentDigest, _React$Component);
	
	  function DataStudentDigest(props) {
	    _classCallCheck(this, DataStudentDigest);
	
	    var _this = _possibleConstructorReturn(this, (DataStudentDigest.__proto__ || Object.getPrototypeOf(DataStudentDigest)).call(this));
	
	    autobind(_this);
	    return _this;
	  }
	
	  _createClass(DataStudentDigest, [{
	    key: "render",
	    value: function render() {
	      var student = this.props.student;
	
	      var currentUser = CurrentUser.get();
	      var widgetParams = { topLevelDigest: WidgetConfig.STUDENT_ENTITY_TYPE, period: WidgetConfig.PERIOD, adminID: [currentUser.id] };
	      var widgetContainer = React.createElement(WidgetContainer, { userID: this.props.studentID, widgetParams: widgetParams });
	
	      return React.createElement(
	        "div",
	        { className: "dataStudentDigest" },
	        React.createElement(
	          "div",
	          { className: "showOnPrint" },
	          React.createElement(
	            "h1",
	            { style: { textAlign: 'center' } },
	            student.display_name
	          )
	        ),
	        widgetContainer
	      );
	    }
	  }]);
	
	  return DataStudentDigest;
	}(React.Component)) || _class);
	
	
	DataStudentDigest.WrappedComponent.propTypes = StrictPropTypes({
	  studentID: PropTypes.number,
	  startDate: PropTypes.string,
	  endDate: PropTypes.string,
	  showFullData: PropTypes.bool,
	  student: PropTypes.object
	
	});
	
	module.exports = DataStudentDigest;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRouterDom = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoldenEgg = __webpack_require__(386);
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	var CoinDisplay = __webpack_require__(121);
	var Tiers = __webpack_require__(108);
	var ProgressBar = __webpack_require__(81);
	var ReactTooltip = __webpack_require__(12);
	var OwlShopRouting = __webpack_require__(92);
	
	var OwlShopActions = __webpack_require__(106);
	var OwlShopSelectors = __webpack_require__(94);
	
	__webpack_require__(3759);
	
	var GamifiedStudentDisplay = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	    var filteredPatches = OwlShopSelectors.getFilteredPatches({ state: state });
	    //"false" argument specifies that the equipped background shouldn't 
	    //be displayed on the student homepage background.
	    var filteredPerks = OwlShopSelectors.getFilteredPerks({ state: state });
	    var allFurnitures = OwlShopSelectors.getFurnitures({ state: state });
	
	    return {
	        filteredPatches: filteredPatches,
	        filteredPerks: filteredPerks,
	        allFurnitures: allFurnitures,
	        ownedPatches: _underscore2.default.select(filteredPatches, function (patch) {
	            return patch.owned && patch.source == "store";
	        }),
	
	        ownedPerks: _underscore2.default.select(filteredPerks, function (perk) {
	            return perk.owned && perk.source == "store";
	        }),
	        filteredFurnitures: _underscore2.default.select(allFurnitures, function (furniture) {
	            return furniture.owned && furniture.source == "store";
	        })
	    };
	}, function (dispatch, props) {
	    return {
	        populateData: function populateData() {
	            return Promise.all([dispatch(OwlShopActions.fetchPatches()), dispatch(OwlShopActions.fetchPerks()), dispatch(OwlShopActions.fetchFurnitures())]);
	        }
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(GamifiedStudentDisplay, _React$Component);
	
	    function GamifiedStudentDisplay(props) {
	        _classCallCheck(this, GamifiedStudentDisplay);
	
	        var _this = _possibleConstructorReturn(this, (GamifiedStudentDisplay.__proto__ || Object.getPrototypeOf(GamifiedStudentDisplay)).call(this));
	
	        autobind(_this);
	        return _this;
	    }
	
	    //get total number of items required for current level.
	
	
	    _createClass(GamifiedStudentDisplay, [{
	        key: "getTierRequirementCount",
	        value: function getTierRequirementCount() {
	            var total_required = 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.entries(Tiers.REQUIREMENTS[this.props.student.tier])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = _slicedToArray(_step.value, 2),
	                        objType = _step$value[0],
	                        reqs = _step$value[1];
	
	                    total_required += Object.values(reqs).reduce(function (a, b) {
	                        return a + b;
	                    });
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return total_required;
	        }
	    }, {
	        key: "getRemainingReqsCount",
	        value: function getRemainingReqsCount(patches, perks, furnitures) {
	            if (!patches || !perks || !furnitures) {
	                return 0;
	            }
	
	            var tier = this.props.student.tier;
	            var reqs = Tiers.REQUIREMENTS[tier];
	
	            var remainingReqs = $wr.getRemainingReqs(tier, reqs, patches, perks, furnitures);
	            if (!remainingReqs) {
	                return 0;
	            }
	
	            var remaining = 0;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.entries(remainingReqs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        objType = _step2$value[0],
	                        reqs = _step2$value[1];
	
	                    remaining += reqs;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return remaining;
	        }
	    }, {
	        key: "redirectToTrophyRoom",
	        value: function redirectToTrophyRoom() {
	            var params = "?openTrophyRoom=true";
	            $wr.redirect(OwlShopRouting.getPath({}) + params);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var student = this.props.student;
	
	            if (this.props.student && this.props.student.is_clickable_egg) {
	                var goldenEgg = _react2.default.createElement(GoldenEgg, null);
	            }
	
	            var studentForAvatar = CurrentUser.get();
	            var tierIconTooltipText = "Level " + (this.props.student.tier + 1) + ": " + Tiers.getName(this.props.student.tier);
	            var remainingReqsCount = this.getRemainingReqsCount(this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures);
	            var display = _react2.default.createElement(
	                "div",
	                { className: "mainSection" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "name" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "nameString" },
	                        student ? $wr.fetchTitle(student) : ""
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "eggContainer" },
	                        goldenEgg
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "panelContainer" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "leftPanel" },
	                        _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: OwlShopRouting.getPath({}) },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "avatarBackground" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "owlvatar" },
	                                    _react2.default.createElement(StudentAvatar, { student: studentForAvatar, maxWidth: 150 })
	                                ),
	                                $wr.hasBackgroundEquipped(this.props.ownedPerks) ? _react2.default.createElement("div", { className: "shadow" }) : ""
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "rightPanel" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "sidePanel shopPanel" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "progressContainer" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "tierNumber", onClick: this.redirectToTrophyRoom },
	                                    _react2.default.createElement("img", {
	                                        src: Tiers.getIcon(this.props.student.tier),
	                                        className: "currentTierImage",
	                                        "data-tip": tierIconTooltipText,
	                                        height: 40
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "explanationString" },
	                                    this.props.student.tier < 6 ? _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        " Buy ",
	                                        " " + remainingReqsCount + " ",
	                                        " more level",
	                                        " " + (this.props.student.tier + 1).toString() + ' ',
	                                        " items to level up!"
	                                    ) : _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        " You have maxed out your owl!"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "levelContainer" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "progressBar" },
	                                    _react2.default.createElement(ProgressBar, { current: this.props.student.tier < 6 ? this.getTierRequirementCount() - remainingReqsCount : 1,
	                                        total: this.props.student.tier < 6 ? this.getTierRequirementCount() : 1, className: "levelBar" })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "coinsContainer" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { "data-tip": "Spend coins to unlock missing items and level up!" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: OwlShopRouting.getPath({}) },
	                                        _react2.default.createElement(CoinDisplay, { coins: this.props.student.coins, height: 20 })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	            return display;
	        }
	
	        //adds a background circle behind the student avatar
	
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var userBackground = this.props.student.perks.backgrounds;
	            if (userBackground != "") {
	                var $avatarBackground = $(".avatarBackground");
	                var perkPath = dynamicRequire("perks/backgrounds/" + userBackground.toLowerCase() + ".png");
	                $avatarBackground.addClass("hasBackground").css('background', 'url(' + perkPath + ')');
	                $avatarBackground.addClass("backgroundBorder");
	                var $owlvatar = $(".owlvatar");
	                $owlvatar.addClass("centeredOwl");
	                $(".rightPanel").addClass('adjustedRightPanel');
	            }
	        }
	    }]);
	
	    return GamifiedStudentDisplay;
	}(_react2.default.Component)) || _class) || _class);
	
	
	module.exports = GamifiedStudentDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	'use strict';
	
	var ProgressBar = function ProgressBar(props) {
	  var completed = props.completed;
	
	  if (!isNaN(completed)) {
	    return React.createElement(
	      'div',
	      { className: 'progressBarContainer' },
	      React.createElement(
	        'div',
	        { className: 'progressBarFiller', style: { width: completed + '%' } },
	        React.createElement(
	          'span',
	          { className: 'progressBarLabels' },
	          completed + '%'
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	module.exports = ProgressBar;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaskTile = __webpack_require__(422);
	var Spinner = __webpack_require__(9);
	var SlidingDrawer = __webpack_require__(936);
	var Glyphicon = __webpack_require__(8);
	var ProgressBar = __webpack_require__(879);
	var Features = __webpack_require__(16);
	
	var CurrentUser = __webpack_require__(3);
	
	var AccountPlans = __webpack_require__(53);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var RosterSelectors = __webpack_require__(6);
	var BookDisplay = __webpack_require__(46);
	var BookCover = __webpack_require__(140);
	var StudentMetrics = __webpack_require__(29);
	
	var MyShelfRouting = __webpack_require__(74);
	
	var StudentActivities = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    revisables: ReadingSelectors.booksWithRevisables({ state: state, conditions: { userID: CurrentUser.get().id } }),
	    books: ReadingSelectors.books({ state: state, conditions: { allowDraft: true, nonBlank: ["text_id", "title"] } }),
	    allExercises: WritingSelectors.activities({ state: state }) || [],
	    allTasks: WritingSelectors.validStudentHomepageTasks({ state: state, conditions: { userID: CurrentUser.get().id } }),
	    product: CurrentUser.get().product,
	    showQuestionBuilders: CurrentUser.get().prefs.display_question_builder || false
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
	      // loads exercises into state
	      dispatch(function (dispatch, getState) {
	        var allAssignedExercisesIDs = _underscore2.default.compact(_underscore2.default.map(getState().tasks, function (activity) {
	          var exerciseTaskItems = _underscore2.default.where(activity.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE });
	          exerciseTaskItems = exerciseTaskItems.concat(_underscore2.default.where(activity.task_items, { subject_type: ACTIVITY_SUBJECT_TYPE }));
	          if (activity.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || activity.subject_type === ACTIVITY_SUBJECT_TYPE) {
	            return parseInt(activity.subject_id);
	          } else if (!_underscore2.default.isEmpty(exerciseTaskItems)) {
	            return parseInt(exerciseTaskItems.subject_id);
	          }
	        }));
	
	        if (!_underscore2.default.isEmpty(allAssignedExercisesIDs)) {
	          _underscore2.default.each(allAssignedExercisesIDs, function (exerciseID) {
	            dispatch(WritingActions.fetchActivity({ id: exerciseID, embeds: ["activity.format"] }));
	          });
	        }
	      });
	      // loads books into state
	      return dispatch(function (dispatch, getState) {
	        // This only works because the tasks are already loaded in before this component mounts
	        // It's not very stable. Or elegant.
	        var readingTasks = WritingSelectors.teacherPicksTasks({
	          state: getState(), filters: { user_id: CurrentUser.get().id }
	        });
	
	        if (readingTasks.length > 0) {
	          return dispatch(ReadingActions.fetchBooks({
	            ids: _underscore2.default.pluck(readingTasks, "subject_id"),
	            user_id: CurrentUser.get().id,
	            cache: true,
	            query: { library_content: true }
	          }));
	        } else {
	          return Promise.resolve();
	        }
	      });
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(StudentActivities, _React$Component);
	
	  function StudentActivities(props) {
	    _classCallCheck(this, StudentActivities);
	
	    var _this = _possibleConstructorReturn(this, (StudentActivities.__proto__ || Object.getPrototypeOf(StudentActivities)).call(this));
	
	    autobind(_this);
	
	    var allActivities = props.allTasks;
	    allActivities.sort(function compare(a, b) {
	      var dateA = a.due_date === null ? new Date(new Date().setFullYear(new Date().getFullYear() + 100)) : new Date(a.due_date);
	      var dateB = b.due_date === null ? new Date(new Date().setFullYear(new Date().getFullYear() + 100)) : new Date(b.due_date);
	      return dateA - dateB;
	    });
	    // set drawer status for each item
	    var drawerOpen = {};
	    if (!_underscore2.default.isEmpty(allActivities)) {
	      _underscore2.default.each(allActivities, function (item) {
	        var drawerOpenCopy = _extends({}, drawerOpen);
	        drawerOpenCopy["" + item.id] = false;
	        drawerOpen = drawerOpenCopy;
	      });
	    }
	    _this.state = { allActivities: allActivities, drawerOpen: drawerOpen };
	    return _this;
	  }
	
	  /*//////////////////
	  Redirect users
	  ///////////////////*/
	
	
	  _createClass(StudentActivities, [{
	    key: "openQuiz",
	    value: function openQuiz(e) {
	      $wr.nope(e);
	      // Don't check text variety for quizzes
	      this.setState({ loading: true });
	      $wr.redirect("/quiz?text_id=" + e.target.getAttribute('data-text-id'));
	    }
	  }, {
	    key: "openLogReading",
	    value: function openLogReading(e) {
	      $wr.nope(e);
	      LuckyOrangeClient.tagComponent("ReadingLogModal");
	      this.props.openBookActivity('log', _underscore2.default.findWhere(this.props.books, { text_id: e.target.getAttribute('data-text-id') }));
	    }
	  }, {
	    key: "openReview",
	    value: function openReview(e) {
	      $wr.nope(e);
	      this.setState({ loading: true });
	      $wr.redirect("/reviews/new?text_id=" + e.target.getAttribute('data-text-id'));
	    }
	  }, {
	    key: "openExercise",
	    value: function openExercise(e) {
	      $wr.nope(e);
	      this.setState({ loading: true });
	      var redirectURL = "/responses/new?text_id=" + e.target.getAttribute('data-text-id') + "&activity_ids=" + e.target.getAttribute('data-activity-ids');
	      if (e.target.getAttribute('data-activity-id') !== 'none') {
	        redirectURL = "/responses/new?text_id=" + e.target.getAttribute('data-text-id') + "&activity_id=" + e.target.getAttribute('data-activity-id');
	      }
	      $wr.redirect(redirectURL);
	    }
	  }, {
	    key: "openQuestions",
	    value: function openQuestions(e) {
	      $wr.nope(e);
	      this.setState({ loading: true });
	      $wr.redirect("/answers/new?text_id=" + e.target.getAttribute('data-text-id'));
	    }
	    // opens question builder for text
	
	  }, {
	    key: "openQuestionBuilder",
	    value: function openQuestionBuilder(e) {
	      $wr.nope(e);
	      this.setState({ loading: true });
	      $wr.redirect("/question_builder/new?text_id=" + e.target.getAttribute('data-text-id'));
	    }
	  }, {
	    key: "onRevisionClick",
	    value: function onRevisionClick(e) {
	      if (e.currentTarget.getAttribute('data-item-type')) {
	        if (e.currentTarget.getAttribute('data-item-type') == "quiz") {
	          var detailsView = "quizzes";
	        } else if (e.currentTarget.getAttribute('data-item-type') == "answer") {
	          var detailsView = "answers";
	        } else if (e.currentTarget.getAttribute('data-item-type') == "review") {
	          var detailsView = "reviews";
	        }
	
	        $wr.redirect(MyShelfRouting.getPath({
	          activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
	          textID: e.currentTarget.getAttribute('data-text-id'),
	          detailsView: detailsView
	        }));
	      }
	    }
	  }, {
	    key: "noEvent",
	    value: function noEvent(e) {
	      $wr.nope(e);
	    }
	
	    /*///////////////////////////////
	    Dynamic based on completed status
	    ////////////////////////////////*/
	
	  }, {
	    key: "calculatePercentFinished",
	    value: function calculatePercentFinished(task_items) {
	      if (task_items) {
	        // find finished tasks 
	        var finishedQuiz = _underscore2.default.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ, draft: false });
	        var finishedPracticeQuestions = _underscore2.default.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false });
	        var finishedReview = _underscore2.default.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false });
	        var finishedExercise = _underscore2.default.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false });
	        var finishedQuestionBuilders = _underscore2.default.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER, draft: false });
	        // sum completed tasks
	        var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length + finishedExercise.length + finishedQuestionBuilders.length;
	        // return comparison
	        return completed_tasks / task_items.length;
	      } else {
	        return 0;
	      }
	    }
	
	    /*///////////////////////////////
	    Helpers
	    ////////////////////////////////*/
	
	  }, {
	    key: "hasQualifiedPlan",
	    value: function hasQualifiedPlan() {
	      var activeTrials = CurrentUser.get().account.active_trials;
	      var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false;
	      return this.props.product === 'wrGold' || this.props.product === 'wrSilver' || hasQualifiedTrial ? true : false;
	    }
	  }, {
	    key: "isStandAloneBookActivity",
	    value: function isStandAloneBookActivity(item) {
	      if (!item.task_items || !item.task_items.length) {
	        return false;
	      }
	
	      var exerciseTaskItems = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE });
	      return _underscore2.default.size(exerciseTaskItems) !== _underscore2.default.size(item.task_items) ? false : true;
	    }
	  }, {
	    key: "textID",
	    value: function textID(item) {
	      if (item.text_id) {
	        return item.text_id;
	      }
	      // accounts for activities saved without textID (assigned before updates)
	      else if (item.subject_id && (item.subject_type === URL_PICK_SUBJECT_TYPE || item.subject_type === TITLE_PICK_SUBJECT_TYPE)) {
	          return item.subject_id;
	        }
	    }
	  }, {
	    key: "allBookActivity",
	    value: function allBookActivity(item) {
	      var book = _underscore2.default.first(_underscore2.default.where(this.props.books, { text_id: item.text_id }));
	      if (book && book["activity:any:any"]) {
	        var bookActivity = book["activity:any:any"];
	        return bookActivity;
	      }
	    }
	    // incase a teacher enters an absurd number of assignments
	
	  }, {
	    key: "truncateMainText",
	    value: function truncateMainText(text, charLength) {
	      if (text.length > charLength) {
	        return text.substring(0, charLength - 1) + "...";
	      } else {
	        return text;
	      }
	    }
	    // returns placeholder image for activities
	
	  }, {
	    key: "getPlaceholderImage",
	    value: function getPlaceholderImage() {
	      if ($wr.isDevelopment()) {
	        var imgBase = "http://localhost:3003";
	      } else if ($wr.isProduction()) {
	        var imgBase = "https://app.whooosreading.org/albus_assets";
	      } else if ($wr.isStaging()) {
	        var imgBase = "https://app.savvashortondev.com/albus_assets";
	      }
	
	      return imgBase + "/imgs/placeholder-thumbnail.png";
	    }
	
	    /*///////////////////////////////
	    Render elements
	    ////////////////////////////////*/
	
	  }, {
	    key: "renderQuizActivity",
	    value: function renderQuizActivity(item) {
	      var glyphiconClass = 'hide-glyphicon';
	      var altText = 'Take a Quiz';
	      var mainText = 'Quiz';
	      var clickEvent = this.openQuiz;
	      var dataTip = 'Complete the item before you start the quiz!';
	      var completedClass = 'notRequired';
	      var bookActivity = this.allBookActivity(item);
	      var activityTextClass = 'activityItemText';
	
	      var assignedQuiz = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ });
	      if (assignedQuiz.length) {
	        var finishedQuiz = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ, draft: false });
	        if (finishedQuiz.length) {
	          glyphiconClass = 'glyphicon glyphicon-check-green';
	          altText = 'Completed Quiz';
	          mainText = '1/1 Quiz';
	          clickEvent = this.noEvent;
	          dataTip = 'You have completed the quiz!';
	          completedClass = 'isCompleted';
	          activityTextClass += ' deactivateLink';
	        } else {
	          glyphiconClass = 'glyphicon glyphicon-check-gray';
	          mainText = '0/1 Quiz';
	          completedClass = 'isRequired';
	          activityTextClass = 'activityItemText';
	        }
	      } else if (bookActivity) {
	        if (bookActivity.quiz_counts && bookActivity.quiz_counts["" + item.user_id] > 0) {
	          mainText = '1/1 Quiz';
	          activityTextClass += ' deactivateLink';
	          clickEvent = this.noEvent;
	        }
	      }
	      mainText = this.truncateMainText(mainText, 25);
	      completedClass += ' activityContainer';
	      return React.createElement(
	        "a",
	        { className: completedClass, href: "#", "data-text-id": this.textID(item), key: item.id + '_' + item.receivedAt + '_quizIcon', onClick: clickEvent,
	          "data-tip": dataTip },
	        React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	        React.createElement("img", { className: "activityIcon", src: __webpack_require__(3416), alt: altText }),
	        React.createElement(
	          "span",
	          { "data-text-id": this.textID(item), className: activityTextClass },
	          mainText
	        )
	      );
	    }
	  }, {
	    key: "renderQuestionActivity",
	    value: function renderQuestionActivity(item) {
	      var glyphiconClass = 'hide-glyphicon';
	      var altText = 'Answer a Question';
	      var mainText = 'Questions';
	      var clickEvent = this.openQuestions;
	      var dataTip = 'Try out some practice questions!';
	      var completedClass = 'notRequired';
	      var bookActivity = this.allBookActivity(item);
	      var activityTextClass = 'activityItemText';
	
	      var assignedPracticeQuestions = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION });
	
	      if (assignedPracticeQuestions.length) {
	        var finishedPracticeQuestions = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false });
	
	        if (finishedPracticeQuestions.length === assignedPracticeQuestions.length) {
	          glyphiconClass = 'glyphicon glyphicon-check-green';
	          altText = 'Answered all Questions';
	          mainText = finishedPracticeQuestions.length + '/' + assignedPracticeQuestions.length + ' Questions';
	          clickEvent = this.noEvent;
	          dataTip = 'You have completed the practice questions!';
	          completedClass = 'isCompleted';
	          activityTextClass += ' deactivateLink';
	        } else {
	          completedClass = 'isRequired';
	          activityTextClass = 'activityItemText';
	          glyphiconClass = 'glyphicon glyphicon-check-gray';
	          mainText = finishedPracticeQuestions.length + '/' + assignedPracticeQuestions.length + ' Questions';
	        }
	      } else if (bookActivity && bookActivity.answer_counts) {
	        var questionsCompleted = bookActivity.answer_counts["" + item.user_id];
	        if (questionsCompleted > 0) {
	          if (questionsCompleted === 1) {
	            mainText = "1 Question";
	          } else {
	            mainText = questionsCompleted + " Questions";
	          }
	        }
	      }
	      mainText = this.truncateMainText(mainText, 25);
	      completedClass += ' activityContainer';
	      return React.createElement(
	        "a",
	        { className: completedClass, href: "#", "data-text-id": this.textID(item), key: item.title + '_' + item.receivedAt + '_questionsIcon', onClick: clickEvent,
	          "data-tip": dataTip },
	        React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	        React.createElement("img", { className: "activityIcon", src: __webpack_require__(3415), alt: altText }),
	        React.createElement(
	          "span",
	          { "data-text-id": this.textID(item), className: activityTextClass },
	          mainText
	        )
	      );
	    }
	  }, {
	    key: "renderExerciseActivity",
	    value: function renderExerciseActivity(item) {
	      var glyphiconClass = 'hide-glyphicon';
	      var altText = 'Complete an Exercise';
	      var mainText = 'Exercises';
	      var clickEvent = this.openExercise;
	      var dataTip = 'Complete an exercise!';
	      var completedClass = 'notRequired';
	      var bookActivity = this.allBookActivity(item);
	      var activityTextClass = 'activityItemText';
	
	      var assignedExercises = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE });
	
	      if (assignedExercises.length) {
	        var finishedExercises = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false });
	
	        if (finishedExercises.length === assignedExercises.length) {
	          glyphiconClass = 'glyphicon glyphicon-check-green';
	          altText = 'Completed all Exercises';
	          mainText = finishedExercises.length + '/' + assignedExercises.length + ' Exercises';
	          clickEvent = this.noEvent;
	          dataTip = 'You have completed all exercises!';
	          var completedClass = 'isCompleted';
	          activityTextClass += ' deactivateLink';
	        } else {
	          completedClass = 'isRequired';
	          activityTextClass = 'activityItemText';
	          glyphiconClass = 'glyphicon glyphicon-check-gray';
	          mainText = finishedExercises.length + '/' + assignedExercises.length + ' Exercises';
	        }
	      } else if (bookActivity && bookActivity.response_counts) {
	        var exercisesCompleted = bookActivity.response_counts["" + item.user_id];
	        if (exercisesCompleted > 0) {
	          if (exercisesCompleted === 1) {
	            mainText = "1 Exercise";
	          } else {
	            mainText = exercisesCompleted + " Exercises";
	          }
	        }
	      }
	      completedClass += ' activityContainer';
	      // assigned activity ids with associated book
	      var exerciseIDs = 'none';
	      var remainingAssignedExercises = _underscore2.default.filter(_underscore2.default.pluck(_underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: true }), 'subject_id'), function (activity_id) {
	        return activity_id !== null;
	      });
	      if (remainingAssignedExercises.length) {
	        exerciseIDs = remainingAssignedExercises.join();
	      }
	      // solo book activities
	      var exerciseID = 'none';
	      if (item && (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || item.subject_type === ACTIVITY_SUBJECT_TYPE)) {
	        exerciseID = parseInt(item.subject_id);
	        glyphiconClass = item.draft ? 'glyphicon glyphicon-check-gray' : 'glyphicon glyphicon-check-green';
	        mainText = item.draft ? '1 Exercise' : 'Exercise Complete';
	      }
	      mainText = this.truncateMainText(mainText, 25);
	      return React.createElement(
	        "a",
	        { "data-complete": completedClass, className: completedClass, "data-text-id": this.textID(item), "data-activity-id": exerciseID, "data-activity-ids": exerciseIDs, href: "#", key: item.id + '_' + item.receivedAt + '_activityIcon', onClick: clickEvent,
	          "data-tip": dataTip },
	        React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	        React.createElement("img", { className: "activityIcon", src: __webpack_require__(3413), alt: altText }),
	        React.createElement(
	          "span",
	          { className: activityTextClass, "data-text-id": this.textID(item), "data-activity-id": exerciseID, "data-activity-ids": exerciseIDs },
	          mainText
	        )
	      );
	    }
	  }, {
	    key: "renderReadingActivity",
	    value: function renderReadingActivity(item) {
	      var glyphiconClass = 'hide-glyphicon';
	      var altText = 'Reading Log';
	      var mainText = 'Reading Log';
	      var clickEvent = this.openLogReading;
	      var dataTip = 'Reading Log!';
	
	      mainText = this.truncateMainText(mainText, 25);
	      return React.createElement(
	        "a",
	        { className: "activityContainer", href: "#", "data-text-id": this.textID(item), key: item.id + '_' + item.receivedAt + '_readingIcon', onClick: clickEvent,
	          "data-tip": dataTip },
	        React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	        React.createElement("img", { className: "activityIcon", src: __webpack_require__(3417), alt: altText }),
	        React.createElement(
	          "span",
	          { className: "activityItemText", "data-text-id": this.textID(item) },
	          mainText
	        )
	      );
	    }
	  }, {
	    key: "renderReviewActivity",
	    value: function renderReviewActivity(item) {
	      var glyphiconClass = 'hide-glyphicon';
	      var altText = 'Complete a Review';
	      var mainText = 'Review';
	      var clickEvent = this.openReview;
	      var dataTip = 'Complete the quiz before you start the review!';
	      var completedClass = 'notRequired';
	      var bookActivity = this.allBookActivity(item);
	      var activityTextClass = 'activityItemText';
	
	      var assignedReview = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW });
	      if (assignedReview.length) {
	        var finishedReview = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false });
	        if (finishedReview.length) {
	          glyphiconClass = 'glyphicon glyphicon-check-green';
	          altText = 'Completed Review';
	          mainText = '1/1 Review';
	          clickEvent = this.noEvent;
	          dataTip = 'You have completed the review!';
	          completedClass = 'isCompleted';
	          activityTextClass += ' deactivateLink';
	        } else {
	          completedClass = 'isRequired';
	          activityTextClass = 'activityItemText';
	          glyphiconClass = 'glyphicon glyphicon-check-gray';
	          mainText = '0/1 Review';
	        }
	      } else if (bookActivity) {
	        if (bookActivity.quiz_counts && bookActivity.quiz_counts["" + item.user_id] > 0) {
	          mainText = '1/1 Review';
	          activityTextClass += ' deactivateLink';
	          clickEvent = this.noEvent;
	        }
	      }
	      mainText = this.truncateMainText(mainText, 25);
	      completedClass += ' activityContainer';
	      return React.createElement(
	        "a",
	        { className: completedClass, "data-text-id": this.textID(item), href: "#", key: item.id + '_' + item.receivedAt + '_reviewIcon', onClick: clickEvent,
	          "data-tip": dataTip },
	        React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	        React.createElement("img", { className: "activityIcon", src: __webpack_require__(3418), alt: altText }),
	        React.createElement(
	          "span",
	          { "data-text-id": this.textID(item), className: activityTextClass },
	          mainText
	        )
	      );
	    }
	    // builds question builder task item
	
	  }, {
	    key: "renderQuestionBuilderActivity",
	    value: function renderQuestionBuilderActivity(item) {
	      if (this.props.showQuestionBuilders) {
	        var glyphiconClass = 'hide-glyphicon';
	        var altText = 'Complete a Question Builder';
	        var mainText = 'Builders';
	        var clickEvent = this.openQuestionBuilder;
	        var dataTip = 'Complete an exercise!';
	        var completedClass = 'notRequired';
	        var bookActivity = this.allBookActivity(item);
	        var activityTextClass = 'activityItemText';
	
	        var assignedQuestionBuilders = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER });
	
	        if (assignedQuestionBuilders.length) {
	          var finishedQuestionBuilders = _underscore2.default.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER, draft: false });
	
	          if (finishedQuestionBuilders.length === assignedQuestionBuilders.length) {
	            glyphiconClass = 'glyphicon glyphicon-check-green';
	            altText = 'Completed all Question Builders';
	            mainText = finishedQuestionBuilders.length + '/' + assignedQuestionBuilders.length + ' Builders';
	            clickEvent = this.noEvent;
	            dataTip = 'You have completed all question builders!';
	            completedClass = 'isCompleted';
	            activityTextClass = 'deactivateLink';
	          } else {
	            completedClass = 'isRequired';
	            activityTextClass = 'activityItemText';
	            glyphiconClass = 'glyphicon glyphicon-check-gray';
	            mainText = finishedQuestionBuilders.length + '/' + assignedQuestionBuilders.length + ' Builders';
	          }
	        } else if (bookActivity && bookActivity.metacognition_counts) {
	          var QuestionBuildersCompleted = bookActivity.metacognition_counts["" + item.user_id];
	          if (QuestionBuildersCompleted > 0) {
	            if (QuestionBuildersCompleted === 1) {
	              mainText = "1 Builder";
	            } else {
	              mainText = QuestionBuildersCompleted + " Builders";
	            }
	          }
	        }
	        completedClass += ' activityContainer';
	        mainText = this.truncateMainText(mainText, 25);
	        return React.createElement(
	          "a",
	          { "data-complete": completedClass, "data-text-id": this.textID(item), className: completedClass, href: "#", key: item.id + '_' + item.receivedAt + '_qbIcon', onClick: clickEvent,
	            "data-tip": dataTip },
	          React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check", className: glyphiconClass }),
	          React.createElement("img", { className: "activityIcon", src: __webpack_require__(3414), alt: altText }),
	          React.createElement(
	            "span",
	            { className: activityTextClass, "data-text-id": this.textID(item) },
	            mainText
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "renderDueDate",
	    value: function renderDueDate(item) {
	      if (item.subject_type !== 'exercise') {
	        var textColor = 'colorBlack';
	        var mainText = 'No due date';
	        if (item.task_items && item.task_items[0] && item.task_items[0].due_date) {
	          if (this.calculatePercentFinished(item.task_items) === 1) {
	            var textColor = 'colorGreen';
	            mainText = "Completed!";
	          } else {
	            var today = new Date();
	            var dueDate = new Date(item.task_items[0].due_date);
	            if (today.getMonth() == 11 && today.getDate() > 25) {
	              dueDate.setFullYear(dueDate.getFullYear() + 1);
	            }
	            var oneDay = 1000 * 60 * 60 * 24;
	            var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / oneDay);
	            if (daysRemaining === 0) {
	              var textColor = 'colorRed';
	              mainText = 'Due today!';
	            } else if (daysRemaining > 0) {
	              if (daysRemaining <= 5) {
	                var textColor = 'colorRed';
	              }
	              mainText = daysRemaining === 1 ? daysRemaining + " day left!" : daysRemaining + " days left!";
	            } else {
	              var textColor = 'colorRed';
	              mainText = daysRemaining === 1 ? "1 day late!" : Math.abs(daysRemaining) + " days late!";
	            }
	          }
	          // determins with of bar based on drawer status
	          var widthClass = this.state.drawerOpen["" + item.id] ? 'truncated' : 'fullWidth';
	          var textClass = 'dueDate ' + textColor + ' ' + widthClass;
	
	          mainText = this.truncateMainText(mainText, 15);
	          return React.createElement(
	            "div",
	            { className: "row dueDateRow" },
	            this.renderBookTitle(item),
	            React.createElement(
	              "div",
	              { className: 'progressBar ' + widthClass },
	              React.createElement(ProgressBar, { key: item.id, bgcolor: '#00a0f4', completed: Math.floor(this.calculatePercentFinished(item.task_items) * 100) })
	            ),
	            React.createElement(
	              "div",
	              { className: textClass },
	              mainText
	            )
	          );
	        } else {
	          return this.renderBookTitle(item);
	        }
	      } else if (item.due_date) {
	        var completed = 0;
	        var textColor = 'colorBlack';
	        var today = new Date();
	        var dueDate = new Date(item.due_date);
	        if (today.getMonth() == 11 && today.getDate() > 25) {
	          dueDate.setFullYear(dueDate.getFullYear() + 1);
	        }
	        var oneDay = 1000 * 60 * 60 * 24;
	        var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / oneDay);
	        if (daysRemaining === 0) {
	          var textColor = 'colorRed';
	          mainText = 'Due today!';
	        } else if (daysRemaining > 0) {
	          if (daysRemaining <= 5) {
	            var textColor = 'colorRed';
	          }
	          mainText = daysRemaining === 1 ? daysRemaining + " day left!" : daysRemaining + " days left!";
	        } else {
	          var textColor = 'colorRed';
	          mainText = daysRemaining === 1 ? "1 day late!" : Math.abs(daysRemaining) + " days late!";
	        }
	        // determins with of bar based on drawer status
	        var widthClass = this.state.drawerOpen["" + item.id] ? 'truncated' : 'fullWidth';
	        var textClass = 'dueDate ' + textColor + ' ' + widthClass;
	
	        if (!item.draft) {
	          completed = 100;
	          mainText = '';
	        }
	
	        mainText = this.truncateMainText(mainText, 25);
	        return React.createElement(
	          "div",
	          { className: "row dueDateRow" },
	          this.renderBookTitle(item),
	          React.createElement(
	            "div",
	            { className: 'progressBar ' + widthClass },
	            React.createElement(ProgressBar, { key: item.id, bgcolor: '#00a0f4', completed: completed })
	          ),
	          React.createElement(
	            "div",
	            { className: textClass },
	            mainText
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderBookTitle",
	    value: function renderBookTitle(item) {
	      if (item.text_id) {
	        var book = _underscore2.default.first(_underscore2.default.where(this.props.books, { text_id: item.text_id }));
	        if (book) {
	          return React.createElement(
	            "div",
	            { className: "bookTitle" },
	            book.title
	          );
	        }
	      } else if (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || item.subject_type === ACTIVITY_SUBJECT_TYPE) {
	        var exercise = _underscore2.default.findWhere(this.props.allExercises, { id: parseInt(item.subject_id) });
	        if (exercise && exercise.format_summary && exercise.format_summary.title) {
	          return React.createElement(
	            "div",
	            { className: "bookTitle" },
	            exercise.format_summary.title
	          );
	        }
	      }
	    }
	  }, {
	    key: "renderBookCover",
	    value: function renderBookCover(item) {
	      var textID = this.textID(item);
	      var book = _underscore2.default.first(_underscore2.default.filter(this.props.books, { text_id: textID }));
	
	      var readNowBtn = '';
	      if (book && book.url && item.subject_type === URL_PICK_SUBJECT_TYPE) {
	        readNowBtn = React.createElement(
	          "a",
	          { className: "btn btn-link", href: book.url, target: "_blank" },
	          "Read Now"
	        );
	      }
	
	      var thumbnail = '';
	      if (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || this.isStandAloneBookActivity(item)) {
	        if (_underscore2.default.size(item.task_items)) {
	          var activity = _underscore2.default.first(_underscore2.default.filter(this.props.allExercises, function (activity) {
	            return activity.id === parseInt(_underscore2.default.first(item.task_items).subject_id);
	          }));
	        } else {
	          var activity = _underscore2.default.first(_underscore2.default.filter(this.props.allExercises, function (activity) {
	            return activity.id === parseInt(item.subject_id);
	          }));
	        }
	      } else if (item.subject_type === ACTIVITY_SUBJECT_TYPE) {
	        var activity = _underscore2.default.findWhere(this.props.allExercises, { id: parseInt(item.subject_id) });
	      }
	      if (!_underscore2.default.isEmpty(activity)) {
	        thumbnail = activity.thumbnail.url || this.getPlaceholderImage();
	      }
	
	      if (!item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && !this.isStandAloneBookActivity(item)) {
	        return React.createElement(
	          "div",
	          { className: "col-sm-2 activityColumn bookCoverContainer" },
	          React.createElement(BookCover, { book: book, coverWidth: 105,
	            showTitle: false, showAuthor: false
	          })
	        );
	      } else {
	        if (!book && thumbnail !== '') {
	          return React.createElement(
	            "div",
	            { className: "col-sm-2 activityColumn bookCoverContainer" },
	            React.createElement(
	              "span",
	              { className: "bookCover activityCover" },
	              React.createElement("img", { src: thumbnail, className: "activityCoverImage" })
	            )
	          );
	        } else if (book) {
	          return React.createElement(
	            "div",
	            { className: "col-sm-2 activityColumn bookCoverContainer" },
	            React.createElement(BookCover, { book: book, coverWidth: 105,
	              showTitle: false, showAuthor: false
	            }),
	            readNowBtn
	          );
	        }
	      }
	    }
	  }, {
	    key: "drawerToggleClickHandler",
	    value: function drawerToggleClickHandler(item_id) {
	      var drawerStateCopy = _extends({}, this.state.drawerOpen);
	      drawerStateCopy["" + item_id] = !drawerStateCopy["" + item_id];
	      this.setState({ drawerOpen: drawerStateCopy });
	    }
	    // renders row content
	
	  }, {
	    key: "renderMainContent",
	    value: function renderMainContent(item) {
	      if (item.subject_type === ACTIVITY_SUBJECT_TYPE || item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE) {
	        return React.createElement(
	          "div",
	          { className: "row row-padding-bottom" },
	          React.createElement(
	            "div",
	            { className: "col-sm-10 padding-left" },
	            this.renderExerciseActivity(item)
	          )
	        );
	      } else {
	        var activityElements = [this.renderQuestionActivity(item), this.renderExerciseActivity(item), this.renderQuizActivity(item), this.renderReviewActivity(item), this.renderQuestionBuilderActivity(item), this.renderReadingActivity(item)];
	        if (!this.hasQualifiedPlan()) {
	          activityElements = [this.renderQuestionActivity(item), this.renderQuizActivity(item), this.renderReviewActivity(item), this.renderQuestionBuilderActivity(item)];
	        }
	
	        activityElements = _underscore2.default.compact(activityElements);
	
	        // sort activities by required then completed
	        activityElements = _underscore2.default.sortBy(activityElements, function (element) {
	          return !element.props.className.includes('isRequired');
	        });
	
	        activityElements = _underscore2.default.sortBy(activityElements, function (element) {
	          return !element.props.className.includes('isCompleted');
	        });
	
	        var requiredElements = _underscore2.default.filter(activityElements, function (element) {
	          return element.props.className.includes('isRequired') || element.props.className.includes('isCompleted');
	        });
	
	        var additionalElements = _underscore2.default.filter(activityElements, function (element) {
	          return !element.props.className.includes('isRequired') && !element.props.className.includes('isCompleted');
	        });
	
	        // handle items with no assignments
	        if (_underscore2.default.isEmpty(requiredElements)) {
	          requiredElements = activityElements;
	          additionalElements = [];
	        }
	        var borderClass = '';
	        var additionalHeightClassRight = '';
	        var additionalHeightClassLeft = '';
	        var triggerText = 'View all activities';
	
	        if (_underscore2.default.isEmpty(additionalElements)) {
	          var rightColumn = requiredElements.slice(0, 3).map(function (i) {
	            return i;
	          });
	          var leftColumn = requiredElements.slice(3, requiredElements.length).map(function (i) {
	            return i;
	          });
	          return React.createElement(
	            "div",
	            null,
	            React.createElement(
	              "div",
	              { className: 'col-sm-5 activityColumn assignedActivityContainer ' + borderClass },
	              rightColumn
	            ),
	            React.createElement(
	              "div",
	              { className: 'col-sm-5 activityColumn additionalActivityContainer' + borderClass },
	              leftColumn
	            )
	          );
	        } else {
	          // controlls display and height of optional activities column
	          if (requiredElements.length >= 4) {
	            additionalHeightClassRight = 'expandedColumn300';
	            additionalHeightClassLeft = 'expandedColumn300';
	          }
	
	          if (this.state.drawerOpen["" + item.id]) {
	            borderClass = 'borderLeft';
	            triggerText = 'Hide';
	            if (additionalElements.length === 3) {
	              additionalHeightClassRight = 'expandedColumn220';
	            } else if (additionalElements.length >= 4) {
	              additionalHeightClassRight = 'expandedColumn300';
	            }
	          }
	          return React.createElement(
	            "div",
	            null,
	            React.createElement(
	              "div",
	              { className: 'col-sm-5 assignedActivityContainer activityColumn ' + borderClass + ' ' + additionalHeightClassLeft },
	              requiredElements
	            ),
	            React.createElement(
	              "div",
	              { className: 'col-sm-5 additionalActivityContainer activityColumn ' + borderClass + ' ' + additionalHeightClassRight },
	              React.createElement(SlidingDrawer, { show: this.state.drawerOpen["" + item.id], content: additionalElements }),
	              React.createElement(
	                "a",
	                { className: "drawerTrigger", onClick: this.drawerToggleClickHandler.bind(this, item.id) },
	                triggerText
	              )
	            )
	          );
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var allActivityElements = [];
	
	      var revisableQuizTasks = [];
	      var revisableAnswerTasks = [];
	      var revisableReviewTasks = [];
	
	      _underscore2.default.each(this.props.revisables, function (item) {
	
	        if (item.type == "quiz") {
	          var altText = "Revise your quiz";
	          var imgPath = __webpack_require__(292);
	        } else if (item.type == "answer") {
	          var altText = "Revise your answer";
	          var imgPath = __webpack_require__(290);
	        } else if (item.type == "review") {
	          var altText = "Revise your review";
	          var imgPath = __webpack_require__(293);
	        } else {
	          console.error("Unkonwn revisable-task item type: ", item.type);
	        }
	
	        var tile = React.createElement(
	          "div",
	          { className: "revisionTask", key: item.type + '_' + item.text_id + '_revisable', "data-text-id": _this2.textID(item), "data-item-type": item.type, onClick: _this2.onRevisionClick },
	          React.createElement("img", { src: imgPath, alt: altText }),
	          React.createElement(
	            "div",
	            { className: "taskTitle" },
	            React.createElement(BookDisplay, { textID: item.text_id })
	          ),
	          React.createElement(
	            "span",
	            { className: "category" },
	            "Revision"
	          )
	        );
	
	        if (item.type === "quiz") {
	          revisableQuizTasks.push(tile);
	        } else if (item.type === "answer") {
	          revisableAnswerTasks.push(tile);
	        } else if (item.type === "review") {
	          revisableReviewTasks.push(tile);
	        } else {
	          console.error("Unkonwn revisable-task item type: ", tile.type);
	        }
	      });
	      // use to determine if activity is past due
	      var now = new Date();
	      now.setHours(0, 0, 0, 0);
	      _underscore2.default.each(this.state.allActivities, function (item, index) {
	        var className = index === _this2.state.allActivities.length - 1 ? 'activityRowContainer' : 'activityRowContainer borderBottom';
	        allActivityElements.push(React.createElement(
	          "div",
	          { className: className, key: item.id + '_' + index },
	          _this2.renderDueDate(item),
	          React.createElement(
	            "div",
	            { className: "row pickContainer" },
	            _this2.renderBookCover(item),
	            _this2.renderMainContent(item)
	          )
	        ));
	      });
	
	      if (this.props.gridView) {
	        var containerClassName = 'studentTaskGridContainer';
	      } else {
	        var containerClassName = 'studentActivitiesContainer';
	      }
	
	      return React.createElement(
	        "div",
	        { className: containerClassName },
	        React.createElement(
	          "div",
	          { className: "studentActivities" },
	          revisableQuizTasks,
	          revisableAnswerTasks,
	          revisableReviewTasks,
	          allActivityElements
	        )
	      );
	    }
	  }]);
	
	  return StudentActivities;
	}(React.Component)) || _class) || _class);
	;
	
	var ACTIVITY_SUBJECT_TYPE = 'Activity';
	var URL_PICK_SUBJECT_TYPE = 'URLPick';
	var TITLE_PICK_SUBJECT_TYPE = 'TitlePick';
	
	StudentActivities.WrappedComponent.propTypes = StrictPropTypes({
	  onPickSelect: PropTypes.func,
	  onActivitySelect: PropTypes.func,
	  openBookActivity: PropTypes.func,
	  fetchActivity: PropTypes.func,
	  activity: PropTypes.func,
	  // Data from @connect
	  product: PropTypes.string,
	  revisables: PropTypes.array,
	  allActivities: PropTypes.array,
	  allTasks: PropTypes.array,
	  soloBookActivities: PropTypes.array,
	  assignedActivities: PropTypes.array,
	  assignedTitles: PropTypes.array,
	  assignedURLs: PropTypes.array,
	  teacherPicks: PropTypes.array,
	  books: PropTypes.array,
	  standAloneExercises: PropTypes.array,
	  allExercises: PropTypes.array,
	  showQuestionBuilders: PropTypes.bool,
	
	  // Handlers from @connect
	  populateData: PropTypes.func,
	
	  gridView: PropTypes.bool
	});
	
	module.exports = StudentActivities;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ProgressBar = __webpack_require__(81);
	
	__webpack_require__(3763);
	
	var StudentClozeStatus = function (_React$Component) {
		_inherits(StudentClozeStatus, _React$Component);
	
		function StudentClozeStatus(props) {
			_classCallCheck(this, StudentClozeStatus);
	
			var _this = _possibleConstructorReturn(this, (StudentClozeStatus.__proto__ || Object.getPrototypeOf(StudentClozeStatus)).call(this));
	
			autobind(_this);
			_this.state = { hidden: false };
			return _this;
		}
	
		_createClass(StudentClozeStatus, [{
			key: "openTotalReader",
			value: function openTotalReader() {
				$wr.redirect("/cloze");
			}
		}, {
			key: "backHome",
			value: function backHome() {
				$wr.redirect("/");
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.hidden) {
					return React.createElement("div", null);
				}
	
				if (this.props.status.current == 0) {
					var title = "Ready for your Reading Challenge?";
					var message = "Take the Challenge and watch your reading soar like Owlfonso!";
				} else if (this.props.status.current < this.props.status.target) {
					var title = "Continue your Reading Challenge!";
					var message = "Keep soaring and earning coins.";
				} else {
					var title = "You completed the Reading Challenge!";
					var message = "You soared! Owlfonso is very proud.";
				}
	
				if (this.props.action == StudentClozeStatus.START) {
					var button = React.createElement(
						"button",
						{ className: "btn buttonPrimary actionButton", onClick: this.openTotalReader },
						"Take the Challenge!"
					);
				} else if (this.props.action == StudentClozeStatus.RETAKE) {
					var button = React.createElement(
						"button",
						{ className: "btn buttonPrimary actionButton", onClick: this.props.onAction },
						"Take Another!"
					);
				} else {
					var button = React.createElement(
						"button",
						{ className: "btn buttonPrimary actionButton", onClick: this.backHome },
						"Back Home!"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "studentClozeStatus" },
					React.createElement(
						"div",
						{ className: "cLeft" },
						React.createElement(
							"p",
							{ className: "clozeHeader" },
							title
						),
						React.createElement(
							"p",
							null,
							message
						)
					),
					React.createElement(ProgressBar, { current: this.props.status.current, total: this.props.status.target }),
					button
				);
			}
		}]);
	
		return StudentClozeStatus;
	}(React.Component);
	
	;
	
	StudentClozeStatus.propTypes = StrictPropTypes({
		status: PropTypes.object.isRequired,
		action: PropTypes.string.isRequired,
		onAction: PropTypes.func
	});
	
	StudentClozeStatus.START = "start";
	StudentClozeStatus.RETAKE = "retake";
	StudentClozeStatus.DONE = "done";
	
	module.exports = StudentClozeStatus;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookActionSection = __webpack_require__(399);
	var BookActionModal = __webpack_require__(398);
	var CurrentUser = __webpack_require__(3);
	var DateSpanSelector = __webpack_require__(116);
	var GoldenEgg = __webpack_require__(386);
	
	var Features = __webpack_require__(16);
	var Glyphicon = __webpack_require__(8);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var Spinner = __webpack_require__(9);
	var StudentAvatar = __webpack_require__(35);
	var StudentMetrics = __webpack_require__(29);
	var StudentProgressDisplay = __webpack_require__(194);
	var SaleModal = __webpack_require__(389);
	var ShopSales = __webpack_require__(123);
	var StudentTasks = __webpack_require__(244);
	
	var StudentOnboardingModal = __webpack_require__(195);
	
	var moment = __webpack_require__(15);
	
	
	__webpack_require__(3765);
	__webpack_require__(223);
	
	var StudentHomePageStreamlined = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    student: RosterSelectors.student({ state: state, id: props.match.params.id }),
	    showLogReading: Features.isEnabled(Features.LOG_READING),
	    showExercises: Features.isEnabled(Features.DIGITAL_EXERCISES),
	
	    hasTasks: RosterSelectors.studentTaskCount({ state: state, studentID: props.match.params.id }) > 0
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData(startDate, endDate) {
	      var studentID = props.match.params.id;
	
	      var fetchStudent = function fetchStudent() {
	        if (CurrentUser.hasID(studentID)) {
	          var embeds = ["student.expectations_progress", "student.prefs", "student.expectations_date_spans", "student.perks", "student.is_clickable_egg", "current_tasks"];
	
	          if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
	            embeds = embeds.concat(["task.subject", "activity.format_summary"]);
	          }
	
	          if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
	            embeds = embeds.concat(["student.cloze_status"]);
	          }
	        }
	        var studentQuery = {};
	        if (startDate) {
	          studentQuery.expectations_progress_start_date = startDate;
	        }
	        if (endDate) {
	          studentQuery.expectations_progress_end_date = endDate;
	        }
	
	        return dispatch(RosterActions.fetchStudent({
	          id: studentID, query: studentQuery,
	          embeds: embeds
	        }));
	      };
	
	      // We fetch it here because we need to know if there are pending tasks
	      //   (RosterSelectors.studentTaskCount)
	      // We actually select the books in StudentTasks
	      var fetchRevisables = function fetchRevisables() {
	        var filters = {
	          user_id: studentID,
	          revisable: true
	        };
	        var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];
	
	        return dispatch(ReadingActions.fetchBookActivity({
	          filters: filters, embeds: embeds, cache: true
	        }));
	      };
	
	      var promises = [fetchStudent(), fetchRevisables()];
	
	      return Promise.all(promises);
	    },
	    postBooks: function postBooks(book, callback) {
	      CurrentUser.api().postBooks({ book: book }, $wr.apiHandler(function (response) {
	        callback(response.book);
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(StudentHomePageStreamlined, _React$Component);
	
	  function StudentHomePageStreamlined(props) {
	    _classCallCheck(this, StudentHomePageStreamlined);
	
	    var _this = _possibleConstructorReturn(this, (StudentHomePageStreamlined.__proto__ || Object.getPrototypeOf(StudentHomePageStreamlined)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("StudentHomePageStreamlined");
	    _this.state = {
	      showFindBookSection: false, openActivityType: null,
	      selectedActivityID: null
	    };
	    _this.actionModal = React.createRef();
	    return _this;
	  }
	
	  _createClass(StudentHomePageStreamlined, [{
	    key: "openBookSearch",
	    value: function openBookSearch(activityType, activityID, textProvided) {
	      if (textProvided) {
	        var redirectURL = "/responses/new?text_id=&activity_id=" + activityID;
	        $wr.redirect(redirectURL);
	      } else {
	        this.setState({ openActivityType: activityType, showFindBookSection: true, selectedActivityID: activityID }, function () {
	          $wr.scrollToElement($(this.refs.container).find(".bookActionSection"), 100);
	        }.bind(this));
	      }
	    }
	  }, {
	    key: "openBookActivity",
	    value: function openBookActivity(activityType, book, isFirst) {
	      var goToActivity = function (selBook) {
	        var _this2 = this;
	
	        if (isFirst) {
	          var firstParam = "&first=true";
	        } else {
	          var firstParam = "";
	        }
	
	        if (activityType == "quiz") {
	          $wr.redirect("/quiz?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "question") {
	          $wr.redirect("/answers/new?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "review") {
	          $wr.redirect("/reviews/new?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "exercise") {
	          var redirectURL = "/responses/new?text_id=" + selBook.text_id + firstParam;
	          if (this.state.selectedActivityID != null) {
	            redirectURL += "&activity_id=" + this.state.selectedActivityID;
	          }
	          $wr.redirect(redirectURL);
	        } else if (activityType == "log") {
	          this.setState({ logReadingSelectedBook: book }, function () {
	            _this2.setState({ showLogReadingModal: true });
	          });
	          this.refs.bookSearchModal.hide();
	        } else {
	          throw "Unknown activity type: " + activityType;
	        }
	      }.bind(this);
	
	      if (book.text_id) {
	        goToActivity(book);
	      } else {
	        this.props.postBooks(book, goToActivity);
	        // CurrentUser.api().postBooks({ book: book }, $wr.apiHandler((response) => {
	        // 	goToActivity(response.book);
	        // }));
	      }
	    }
	  }, {
	    key: "hideOwls",
	    value: function hideOwls() {
	      var user = CurrentUser.get();
	      return user.settings && user.settings.hide_owls;
	    }
	  }, {
	    key: "recentlyCreated",
	    value: function recentlyCreated() {
	      moment(CurrentUser.get().created_at) < moment().subtract(2, "days");
	    }
	  }, {
	    key: "startDate",
	    value: function startDate() {
	      var dateSpans = this.props.student.expectations_date_spans;
	      return this.state.startDate || dateSpans[0].start;
	    }
	  }, {
	    key: "endDate",
	    value: function endDate() {
	      var dateSpans = this.props.student.expectations_date_spans;
	      return this.state.endDate || dateSpans[0].end;
	    }
	  }, {
	    key: "changeDates",
	    value: function changeDates(startDate, endDate) {
	      var _this3 = this;
	
	      this.setState({ startDate: startDate, endDate: endDate, showFindBookSection: false }, function () {
	        _this3.props.populateData(startDate, endDate);
	      });
	    }
	  }, {
	    key: "isMatchingDateSpan",
	    value: function isMatchingDateSpan() {
	      var _this4 = this;
	
	      if (this.props.student && this.props.student.expectations_date_spans) {
	        return _.filter(this.props.student.expectations_date_spans, function (span) {
	          return span.start == _this4.startDate() && span.end == _this4.endDate();
	        }).length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: "showArrow",
	    value: function showArrow() {
	      var progressMade = _.map(this.props.student.expectations_progress, function (value) {
	        if (value > 0) {
	          return true;
	        } else {
	          return false;
	        }
	      });
	      return !_.contains(progressMade, true);
	    }
	  }, {
	    key: "renderDateSelectors",
	    value: function renderDateSelectors() {
	      if (this.props.student && this.props.student.expectations_date_spans) {
	        var dateSpans = this.props.student.expectations_date_spans;
	        return React.createElement(
	          "div",
	          { className: "dateSpanSelectorWrap" },
	          React.createElement(DateSpanSelector, { startDate: this.startDate(), endDate: this.endDate(),
	            expectationsSpans: dateSpans,
	            onSelectDates: this.changeDates })
	        );
	      }
	    }
	  }, {
	    key: "onPickSelect",
	    value: function onPickSelect(book) {
	      this.setState({ selectedBook: book });
	      this.actionModal.current.show();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var student = this.props.student;
	
	      if (student && student.pending_onboarding) {
	        var studentOnboardingModal = React.createElement(StudentOnboardingModal, null);
	      }
	
	      if (this.props.loadingStudent || !student || !student.prefs || !student.expectations_progress || !student.expectations_date_spans) {
	
	        var progressDisplay = React.createElement(
	          "div",
	          null,
	          React.createElement(Spinner, { placeholder: true, scale: 1.7 })
	        );
	      } else if (this.isMatchingDateSpan()) {
	        var className = "linksContainer";
	        var expectations = student.prefs.expectations_metrics;
	        var progress = student.expectations_progress;
	        var actions = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS];
	        var metricsOnly = _.pluck(expectations, 'metric');
	
	        if (this.props.showLogReading) {
	          if (!_.contains(metricsOnly, "minutes") && !_.contains(metricsOnly, "pages")) {
	            actions.push("minutes");
	          }
	        }
	
	        expectations = _.sortBy(expectations, function (expectation) {
	          if (expectation.metric == StudentMetrics.TYPES.QUIZZES_PASSED) {
	            return "AAA";
	          } else {
	            return expectation.metric;
	          }
	        });
	        if ((expectations || []).length || (student.cloze_status || {}).trigger) {
	          var progressDisplay = _.map(expectations, function (expectation) {
	            var metric = expectation.metric;
	
	            if (metric == "days-active") {
	              var actionMetric = "questions";
	            } else {
	              var actionMetric = metric;
	            }
	
	            return React.createElement(
	              "a",
	              { onClick: _this5.openBookSearch.bind(_this5, actionMetric, null, false),
	                key: metric },
	              React.createElement(StudentProgressDisplay, {
	                metric: metric,
	                title: StudentMetrics.getLabel(metric),
	                unit: StudentMetrics.getUnit(metric),
	                total: expectation.goal,
	                current: progress[metric],
	                actionLabel: StudentMetrics.getActionLabel(metric),
	                openBookSearch: _this5.openBookSearch.bind(_this5, actionMetric, null, false) })
	            );
	          });
	          if (student.cloze_status && student.cloze_status.trigger) {
	            var rld = student.cloze_status;
	            var actionMetric = "challenges";
	            var metric = "challenges";
	            var rldProgressDisplay = React.createElement(
	              "a",
	              { onClick: this.openChallenges, href: "/cloze",
	                key: metric },
	              React.createElement(StudentProgressDisplay, {
	                metric: metric,
	                title: StudentMetrics.getLabel(metric),
	                unit: StudentMetrics.getLabel(metric),
	                current: rld.current,
	                total: rld.target,
	                actionLabel: "" })
	            );
	            progressDisplay.push(rldProgressDisplay);
	          }
	          if (this.props.showExercises) {
	            actions.push("exercises");
	          }
	          if (this.showArrow()) {
	            var arrow = React.createElement(Glyphicon, { icon: "chevron-right", className: "arrow" });
	          }
	        } else {
	          var className = "emptyStateLinks";
	          var emptyDashboard = "emptyDashboard";
	          var quizAction = StudentMetrics.TYPES.QUIZZES_PASSED;
	          var emptyState = React.createElement(
	            "div",
	            { className: "leftContainer" },
	            React.createElement(
	              "p",
	              null,
	              "Take a Quiz!"
	            ),
	            React.createElement(
	              "a",
	              { onClick: this.openBookSearch.bind(this, quizAction, null, false), key: quizAction },
	              React.createElement("img", { src: __webpack_require__(291), className: "" })
	            )
	          );
	          var emptyStateHeader = React.createElement(
	            "p",
	            null,
	            "Other Things to Do"
	          );
	          actions.shift();
	          if (this.props.showExercises) {
	            actions.push("exercises");
	          }
	        }
	      } else {
	        var progress = student.expectations_progress;
	        var progressDisplay = _.map(progress, function (amount, metric) {
	          if (metric == "pages") {
	            var imageMetric = "minutes";
	          } else if (metric == "days-active") {
	            var imageMetric = "questions";
	          } else {
	            var imageMetric = metric;
	          }
	          return React.createElement(
	            "span",
	            { className: "regularContainer", key: metric },
	            React.createElement(
	              "span",
	              { className: "amount" },
	              amount
	            ),
	            React.createElement(
	              "p",
	              { className: "metric" },
	              StudentMetrics.getLabel(metric)
	            ),
	            React.createElement("img", { src: StudentMetrics.getIcon(imageMetric), className: "metricIcon" })
	          );
	        });
	      }
	
	      var freeActions = _.reject(actions, function (action) {
	        return _.contains(metricsOnly, action);
	      });
	
	      var linksDisplay = _.map(freeActions, function (freeAction) {
	        return React.createElement(
	          "a",
	          { onClick: _this5.openBookSearch.bind(_this5, freeAction, null, false), key: freeAction },
	          React.createElement("img", { src: StudentMetrics.getIcon(freeAction), className: "" }),
	          $wr.capitalize(StudentMetrics.getUnit(freeAction))
	        );
	      });
	      var expectations = student.prefs.expectations_metrics;
	
	      if ((expectations || []).length || (student.cloze_status || {}).trigger) {
	        var links = React.createElement(
	          "div",
	          { className: className },
	          linksDisplay
	        );
	        var dateSelectors = this.renderDateSelectors();
	      } else {
	        var emptyLinks = React.createElement(
	          "div",
	          { className: className },
	          emptyStateHeader,
	          linksDisplay
	        );
	      }
	
	      if (this.state.showFindBookSection) {
	        var bookSearch = React.createElement(BookActionSection, { openBookActivity: this.openBookActivity,
	          studentDashboard: true,
	          openActivityType: this.state.openActivityType });
	      }
	
	      if (student) {
	        if (this.props.hasTasks) {
	          var tasksContainer = React.createElement(StudentTasks, { onPickSelect: this.onPickSelect,
	            onActivitySelect: this.openBookSearch.bind(this, "exercises") });
	          var widerDashboard = "";
	          var dividerClassName = "";
	        } else {
	          var widerDashboard = " widerDashboard";
	          var dividerClassName = "eggMargin";
	        }
	
	        if (student.is_clickable_egg) {
	          var goldenEgg = React.createElement(GoldenEgg, null);
	        }
	      }
	
	      var userForAvatar = CurrentUser.get();
	      var dividerSection = React.createElement(
	        "div",
	        { className: "dividerSection " + dividerClassName },
	        React.createElement("div", { className: "dividerArea" }),
	        React.createElement(
	          "div",
	          { className: "nameArea" },
	          React.createElement(StudentAvatar, { student: userForAvatar, maxWidth: 300 }),
	          React.createElement(
	            "span",
	            { className: "nameString" },
	            student ? $wr.fetchTitle(student) : ""
	          ),
	          goldenEgg
	        )
	      );
	
	      if (ShopSales.hasCurrentSale() && !this.hideOwls() && !this.recentlyCreated()) {
	        var saleModal = React.createElement(SaleModal, { ref: "saleModal", saleData: ShopSales.getCurrentSale() });
	        var saleBanner = React.createElement(
	          "div",
	          { onClick: function onClick() {
	              _this5.refs.saleModal.show();
	            },
	            className: "saleBanner" },
	          React.createElement("img", { src: __webpack_require__(296), className: "bannerImg" })
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { id: "studentHomePageStreamlined", className: "container", ref: "container" },
	        saleModal,
	        saleBanner,
	        dividerSection,
	        tasksContainer,
	        React.createElement(
	          "div",
	          { className: "dashboardContainer " + emptyDashboard + widerDashboard },
	          progressDisplay,
	          emptyState,
	          emptyLinks,
	          React.createElement(
	            "div",
	            null,
	            dateSelectors,
	            links
	          ),
	          bookSearch
	        ),
	        React.createElement(BookActionModal, { studentDashboard: true, ref: this.actionModal,
	          selectedBook: this.state.selectedBook, openBookActivity: this.openBookActivity,
	          expectations: CurrentUser.get().prefs.expectations_metrics }),
	        studentOnboardingModal
	      );
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      Mycroft.newEvent({ category: "Student-Profile", action: "show-streamlined-profile" });
	      // expand dropdown if url param
	      var queryString = window.location.search;
	      var urlParams = new URLSearchParams(queryString);
	      var acceptableParams = ['exercises', 'quizzes-passed', 'reviews', 'questions', 'question-builder'];
	      var bookSearchDropdown = urlParams.get('bookSearchDropdown');
	      if (bookSearchDropdown && acceptableParams.includes(bookSearchDropdown)) {
	        this.openBookSearch(bookSearchDropdown, null, false, true);
	      }
	    }
	  }]);
	
	  return StudentHomePageStreamlined;
	}(React.Component)) || _class) || _class);
	
	
	var EXERCISE_TASK = "exercise-task";
	var READING_TASK = "reading-task";
	
	StudentHomePageStreamlined.WrappedComponent.propTypes = PageStrictPropTypes({
	  populateData: PropTypes.func,
	  postBooks: PropTypes.func,
	  student: PropTypes.object,
	  showLogReading: PropTypes.bool,
	  showExercises: PropTypes.bool,
	  fetchLibraryPlatforms: PropTypes.func,
	  hasTasks: PropTypes.bool
	});
	
	module.exports = StudentHomePageStreamlined;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookActionSection = __webpack_require__(399);
	var BookActionModal = __webpack_require__(398);
	var CurrentUser = __webpack_require__(3);
	var DateSpanSelector = __webpack_require__(116);
	
	var Features = __webpack_require__(16);
	var Glyphicon = __webpack_require__(8);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var WritingSelectors = __webpack_require__(14);
	
	var Spinner = __webpack_require__(9);
	var StudentMetrics = __webpack_require__(29);
	var StudentProgressDisplay = __webpack_require__(194);
	var SaleModal = __webpack_require__(389);
	var NewItemsModal = __webpack_require__(388);
	var ShopSales = __webpack_require__(123);
	var StudentTasks = __webpack_require__(244);
	var StudentActivities = __webpack_require__(880);
	var GamifiedStudentDisplay = __webpack_require__(878);
	var LogReadingModal = __webpack_require__(164);
	var StudentOnboardingModal = __webpack_require__(195);
	
	var NewYearSaleBanner = __webpack_require__(515);
	
	var moment = __webpack_require__(15);
	
	
	__webpack_require__(3766);
	__webpack_require__(223);
	
	var StudentHomePageVertical = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    student: RosterSelectors.student({ state: state, id: props.match.params.id }),
	    showLogReading: Features.isEnabled(Features.LOG_READING),
	    showExercises: Features.isEnabled(Features.DIGITAL_EXERCISES),
	    showQuestionBuilders: CurrentUser.get().prefs.display_question_builder || false,
	    validTasks: WritingSelectors.validStudentHomepageTasks({ state: state, conditions: { userID: CurrentUser.get().id } }),
	
	    hasTasks: RosterSelectors.studentTaskCount({ state: state, studentID: props.match.params.id }) > 0,
	    hasRevisables: _underscore2.default.size(ReadingSelectors.booksWithRevisables({ state: state, conditions: { userID: CurrentUser.get().id } })) > 0
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData(startDate, endDate) {
	      var studentID = props.match.params.id;
	
	      var fetchStudent = function fetchStudent() {
	        if (CurrentUser.hasID(studentID)) {
	          var embeds = ["student.expectations_progress", "student.prefs", "student.expectations_date_spans", "student.perks", "student.is_clickable_egg", "all_tasks", "task.task_items"];
	
	          embeds = embeds.concat(["task.subject", "activity.format_summary"]);
	
	          if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
	            embeds = embeds.concat(["student.cloze_status"]);
	          }
	        }
	        var studentQuery = {};
	        if (startDate) {
	          studentQuery.expectations_progress_start_date = startDate;
	        }
	        if (endDate) {
	          studentQuery.expectations_progress_end_date = endDate;
	        }
	
	        return dispatch(RosterActions.fetchStudent({
	          id: studentID, query: studentQuery,
	          embeds: embeds
	        }));
	      };
	
	      // We fetch it here because we need to know if there are pending tasks
	      //   (RosterSelectors.studentTaskCount)
	      // We actually select the books in StudentTasks
	      var fetchRevisables = function fetchRevisables() {
	        var filters = {
	          user_id: studentID,
	          revisable: true
	        };
	        var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];
	
	        return dispatch(ReadingActions.fetchBookActivity({
	          filters: filters, embeds: embeds, cache: true
	        }));
	      };
	
	      var promises = [fetchStudent(), fetchRevisables()];
	
	      return Promise.all(promises);
	    },
	    postBooks: function postBooks(book, callback) {
	      CurrentUser.api().postBooks({ book: book }, $wr.apiHandler(function (response) {
	        callback(response.book);
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(StudentHomePageVertical, _React$Component);
	
	  function StudentHomePageVertical(props) {
	    _classCallCheck(this, StudentHomePageVertical);
	
	    var _this = _possibleConstructorReturn(this, (StudentHomePageVertical.__proto__ || Object.getPrototypeOf(StudentHomePageVertical)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("StudentHomePageVertical");
	    _this.state = {
	      showFindBookSection: false,
	      openActivityType: null,
	      selectedActivityID: null,
	      logReadingSelectedBook: null,
	      showLogReadingModal: false,
	      showNewItemsModal: false
	    };
	    _this.actionModal = React.createRef();
	    return _this;
	  }
	
	  /////// STUDENT HELPERS ///////
	
	  _createClass(StudentHomePageVertical, [{
	    key: "getStudentGradeLevel",
	    value: function getStudentGradeLevel() {
	      var student = this.props.student;
	
	      return student && student.grade_level ? parseInt(student.grade_level) : 5;
	    }
	  }, {
	    key: "studentLoading",
	    value: function studentLoading() {
	      var _props = this.props,
	          student = _props.student,
	          loadingStudent = _props.loadingStudent;
	
	      return loadingStudent || !student || !student.prefs || !student.expectations_progress || !student.expectations_date_spans;
	    }
	  }, {
	    key: "sortedStudentExpecations",
	    value: function sortedStudentExpecations() {
	      var student = this.props.student;
	
	      var grade_level = this.getStudentGradeLevel();
	
	      var expectations = _underscore2.default.filter(student.prefs.grade_level_expectations_metrics[grade_level], function (e) {
	        return e.goal !== 0;
	      });
	      return _underscore2.default.sortBy(expectations, function (e) {
	        return e.metric == StudentMetrics.TYPES.QUIZZES_PASSED ? "AAA" : e.metric;
	      });
	    }
	  }, {
	    key: "studentActions",
	    value: function studentActions() {
	      var _props2 = this.props,
	          showLogReading = _props2.showLogReading,
	          showQuestionBuilders = _props2.showQuestionBuilders,
	          showExercises = _props2.showExercises;
	
	
	      var metricsOnly = _underscore2.default.pluck(this.sortedStudentExpecations(), 'metric');
	      var actions = [StudentMetrics.TYPES.QUIZZES_PASSED, StudentMetrics.TYPES.QUESTIONS, StudentMetrics.TYPES.REVIEWS];
	
	      // add reading logs
	      if (showLogReading) {
	        if (!_underscore2.default.contains(metricsOnly, "minutes") && !_underscore2.default.contains(metricsOnly, "pages")) {
	          actions.push("minutes");
	        }
	      }
	
	      // add question builders
	      if (showQuestionBuilders) {
	        actions.push(StudentMetrics.TYPES.QUESTION_BUILDER);
	      }
	
	      if (showExercises) {
	        actions.push("exercises");
	      }
	
	      var freeActions = _underscore2.default.reject(actions, function (action) {
	        return _underscore2.default.contains(metricsOnly, action);
	      });
	
	      return { actions: actions, freeActions: freeActions };
	    }
	    ////////////////////////////
	
	
	  }, {
	    key: "openBookSearch",
	    value: function openBookSearch(activityType, activityID, textProvided) {
	      if (textProvided) {
	        var redirectURL = "/responses/new?text_id=&activity_id=" + activityID;
	        $wr.redirect(redirectURL);
	      } else {
	        this.setState({ openActivityType: activityType, showFindBookSection: true, selectedActivityID: activityID }, function () {
	          $wr.scrollToElement($(this.refs.container).find(".bookActionSection"), 100);
	        }.bind(this));
	      }
	    }
	  }, {
	    key: "openBookActivity",
	    value: function openBookActivity(activityType, book, isFirst) {
	      var goToActivity = function (selBook) {
	        var _this2 = this;
	
	        if (isFirst) {
	          var firstParam = "&first=true";
	        } else {
	          var firstParam = "";
	        }
	
	        if (activityType == "quiz") {
	          $wr.redirect("/quiz?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "question") {
	          $wr.redirect("/answers/new?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "question_builder") {
	          $wr.redirect("/question_builder/new?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "review") {
	          $wr.redirect("/reviews/new?text_id=" + selBook.text_id + firstParam);
	        } else if (activityType == "exercise") {
	          var redirectURL = "/responses/new?text_id=" + selBook.text_id + firstParam;
	          if (this.state.selectedActivityID != null) {
	            redirectURL += "&activity_id=" + this.state.selectedActivityID;
	          }
	          $wr.redirect(redirectURL);
	        } else if (activityType == "log") {
	          this.setState({ logReadingSelectedBook: book }, function () {
	            _this2.setState({ showLogReadingModal: true });
	          });
	        } else {
	          throw "Unknown activity type: " + activityType;
	        }
	      }.bind(this);
	
	      if (book.text_id) {
	        goToActivity(book);
	      } else {
	        this.props.postBooks(book, goToActivity);
	      }
	    }
	  }, {
	    key: "hideOwls",
	    value: function hideOwls() {
	      var user = CurrentUser.get();
	      return user.settings && user.settings.hide_owls;
	    }
	  }, {
	    key: "recentlyCreated",
	    value: function recentlyCreated() {
	      moment(CurrentUser.get().created_at) < moment().subtract(2, "days");
	    }
	  }, {
	    key: "startDate",
	    value: function startDate() {
	      var dateSpans = this.props.student.expectations_date_spans;
	      return this.state.startDate || dateSpans[0].start;
	    }
	  }, {
	    key: "endDate",
	    value: function endDate() {
	      var dateSpans = this.props.student.expectations_date_spans;
	      return this.state.endDate || dateSpans[0].end;
	    }
	  }, {
	    key: "changeDates",
	    value: function changeDates(startDate, endDate) {
	      var _this3 = this;
	
	      this.setState({ startDate: startDate, endDate: endDate, showFindBookSection: false }, function () {
	        _this3.props.populateData(startDate, endDate);
	      });
	    }
	  }, {
	    key: "isMatchingDateSpan",
	    value: function isMatchingDateSpan() {
	      var _this4 = this;
	
	      if (this.props.student && this.props.student.expectations_date_spans) {
	        return _underscore2.default.filter(this.props.student.expectations_date_spans, function (span) {
	          return span.start == _this4.startDate() && span.end == _this4.endDate();
	        }).length > 0;
	      }
	      return false;
	    }
	  }, {
	    key: "showArrow",
	    value: function showArrow() {
	      var progressMade = _underscore2.default.map(this.props.student.expectations_progress, function (value) {
	        if (value > 0) {
	          return true;
	        } else {
	          return false;
	        }
	      });
	      return !_underscore2.default.contains(progressMade, true);
	    }
	  }, {
	    key: "renderDateSelectors",
	    value: function renderDateSelectors() {
	      if (this.props.student && this.props.student.expectations_date_spans) {
	        var dateSpans = this.props.student.expectations_date_spans;
	        return React.createElement(
	          "div",
	          { className: "dateSpanSelectorWrap" },
	          React.createElement(DateSpanSelector, { startDate: this.startDate(), endDate: this.endDate(),
	            expectationsSpans: dateSpans,
	            onSelectDates: this.changeDates })
	        );
	      }
	    }
	  }, {
	    key: "onPickSelect",
	    value: function onPickSelect(book) {
	      this.setState({ selectedBook: book });
	      this.actionModal.current.show();
	    }
	  }, {
	    key: "renderDividerSection",
	    value: function renderDividerSection(title) {
	      return React.createElement(
	        "div",
	        { className: "subTitleContainer" },
	        React.createElement(
	          "div",
	          { className: "nameArea" },
	          React.createElement(
	            "span",
	            { className: "nameString subHeader" },
	            title
	          )
	        )
	      );
	    }
	  }, {
	    key: "closeLogReading",
	    value: function closeLogReading() {
	      this.setState({ showLogReadingModal: false, logReadingSelectedBook: null });
	    }
	  }, {
	    key: "readingLogModal",
	    value: function readingLogModal() {
	      return React.createElement(LogReadingModal, {
	        initialBook: this.state.logReadingSelectedBook,
	        open: this.state.showLogReadingModal, onClose: this.closeLogReading,
	        key: _underscore2.default.pluck(this.state.logReadingSelectedBook, 'text_id') });
	    }
	  }, {
	    key: "showActivitiesColumn",
	    value: function showActivitiesColumn() {
	      return this.props.hasRevisables || this.props.hasTasks && this.props.validTasks.length;
	    }
	
	    /////// RENDER FUNCTIONS ///////
	
	  }, {
	    key: "renderOnboardingModal",
	    value: function renderOnboardingModal() {
	      var student = this.props.student;
	
	      if (student && (student.pending_onboarding || student.pending_onboarding === null)) {
	        return React.createElement(StudentOnboardingModal, null);
	      }
	    }
	  }, {
	    key: "renderSpinner",
	    value: function renderSpinner() {
	      return React.createElement(
	        "div",
	        null,
	        React.createElement(Spinner, { placeholder: true, scale: 1.7 })
	      );
	    }
	  }, {
	    key: "renderGoalPeriodProgress",
	    value: function renderGoalPeriodProgress() {
	      var _this5 = this;
	
	      var student = this.props.student;
	
	      var progress = student.expectations_progress;
	
	      var expectations = this.sortedStudentExpecations();
	      var actions = this.studentActions()['actions'];
	
	      if ((expectations || []).length || (student.cloze_status || {}).trigger) {
	        var progressDisplay = _underscore2.default.map(expectations, function (expectation) {
	          var metric = expectation.metric;
	          var actionMetric = metric == "days-active" ? "questions" : metric;
	          return React.createElement(
	            "a",
	            { onClick: _this5.openBookSearch.bind(_this5, actionMetric, null, false),
	              key: metric },
	            React.createElement(StudentProgressDisplay, {
	              metric: metric,
	              title: StudentMetrics.getLabel(metric),
	              unit: StudentMetrics.getUnit(metric),
	              total: expectation.goal,
	              current: progress[metric],
	              actionLabel: StudentMetrics.getActionLabel(metric),
	              openBookSearch: _this5.openBookSearch.bind(_this5, actionMetric, null, false) })
	          );
	        });
	        if (student.cloze_status && student.cloze_status.trigger) {
	          var rld = student.cloze_status;
	          var metric = "challenges";
	          var rldProgressDisplay = React.createElement(
	            "a",
	            { onClick: this.openChallenges, href: "/cloze",
	              key: metric },
	            React.createElement(StudentProgressDisplay, {
	              metric: metric,
	              title: StudentMetrics.getLabel(metric),
	              unit: StudentMetrics.getLabel(metric),
	              current: rld.current,
	              total: rld.target,
	              actionLabel: "" })
	          );
	          progressDisplay.push(rldProgressDisplay);
	        }
	        return progressDisplay;
	      } else {
	        actions.shift();
	        var quizAction = StudentMetrics.TYPES.QUIZZES_PASSED;
	        return React.createElement(
	          "div",
	          { className: "leftContainer" },
	          React.createElement(
	            "p",
	            null,
	            "Take a Quiz!"
	          ),
	          React.createElement(
	            "a",
	            { onClick: this.openBookSearch.bind(this, quizAction, null, false), key: quizAction },
	            React.createElement("img", { src: __webpack_require__(291), className: "" })
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderGenericProgressDisplay",
	    value: function renderGenericProgressDisplay() {
	      var student = this.props.student;
	
	      var progress = student.expectations_progress;
	      return _underscore2.default.map(progress, function (amount, metric) {
	        if (metric == "pages") {
	          var imageMetric = "minutes";
	        } else if (metric == "days-active") {
	          var imageMetric = "questions";
	        } else {
	          var imageMetric = metric;
	        }
	        return React.createElement(
	          "span",
	          { className: "regularContainer", key: metric },
	          React.createElement(
	            "span",
	            { className: "amount" },
	            amount
	          ),
	          React.createElement(
	            "p",
	            { className: "metric" },
	            StudentMetrics.getLabel(metric)
	          ),
	          React.createElement("img", { src: StudentMetrics.getIcon(imageMetric), className: "metricIcon" })
	        );
	      });
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks() {
	      var _this6 = this;
	
	      var student = this.props.student;
	
	      var grade_level = this.getStudentGradeLevel();
	      var expectations = student.prefs.grade_level_expectations_metrics[grade_level];
	
	      var linksDisplay = _underscore2.default.map(this.studentActions()['freeActions'], function (freeAction) {
	        if (USE_LABELS.includes(freeAction)) {
	          var iconLable = $wr.capitalize(StudentMetrics.getLabel(freeAction));
	        } else {
	          var iconLable = $wr.capitalize(StudentMetrics.getUnit(freeAction));
	        }
	        return React.createElement(
	          "a",
	          { onClick: _this6.openBookSearch.bind(_this6, freeAction, null, false), key: freeAction },
	          React.createElement("img", { src: StudentMetrics.getIcon(freeAction), className: "" }),
	          iconLable
	        );
	      });
	
	      if ((expectations || []).length || (student.cloze_status || {}).trigger) {
	        return React.createElement(
	          "div",
	          { className: 'linksContainer' },
	          linksDisplay
	        );
	      } else {
	        return React.createElement(
	          "div",
	          { className: 'emptyStateLinks' },
	          React.createElement(
	            "p",
	            null,
	            "Other Things to Do"
	          ),
	          linksDisplay
	        );
	      }
	    }
	  }, {
	    key: "renderBookSearch",
	    value: function renderBookSearch() {
	      if (this.state.showFindBookSection) {
	        if (this.showActivitiesColumn()) {
	          return React.createElement(
	            "div",
	            null,
	            React.createElement(BookActionSection, { sectionDividerHeader: true,
	              openBookActivity: this.openBookActivity,
	              studentDashboard: true,
	              openActivityType: this.state.openActivityType })
	          );
	        } else {
	          return React.createElement(BookActionSection, { openBookActivity: this.openBookActivity,
	            studentDashboard: true,
	            openActivityType: this.state.openActivityType });
	        }
	      }
	    }
	  }, {
	    key: "renderTaskContainer",
	    value: function renderTaskContainer() {
	      var student = this.props.student;
	
	
	      if (student && this.showActivitiesColumn()) {
	        return React.createElement(StudentActivities, { openBookActivity: this.openBookActivity, onPickSelect: this.onPickSelect,
	          onActivitySelect: this.openBookSearch.bind(this, "exercises") });
	      }
	    }
	  }, {
	    key: "renderSale",
	    value: function renderSale() {
	      var _this7 = this;
	
	      var saleModal = null;
	      var saleBanner = null;
	
	      if (ShopSales.hasCurrentSale() && !this.hideOwls() && !this.recentlyCreated()) {
	        var saleModal = React.createElement(SaleModal, { ref: "saleModal", saleData: ShopSales.getCurrentSale() });
	
	        var banner = ShopSales.getSaleBanner();
	        var saleBanner = React.createElement(
	          "div",
	          { onClick: function onClick() {
	              _this7.refs.saleModal.show();
	            },
	            className: "saleBanner" },
	          React.createElement("img", { src: banner, className: "bannerImg" })
	        );
	
	        return { saleModal: saleModal, saleBanner: saleBanner };
	      }
	      return { saleModal: saleModal, saleBanner: saleBanner };
	    }
	  }, {
	    key: "renderNewItemsModal",
	    value: function renderNewItemsModal() {
	      return React.createElement(NewItemsModal, { open: this.state.showNewItemsModal, title: "New Year, New Owl Shop Items!" });
	    }
	  }, {
	    key: "renderNewItemsBanner",
	    value: function renderNewItemsBanner() {
	      var _this8 = this;
	
	      return React.createElement(
	        "div",
	        { onClick: function onClick() {
	            // trigger new items modal
	            _this8.setState({ showNewItemsModal: true }, function () {
	              _this8.setState({ showNewItemsModal: false });
	            });
	          },
	          className: "saleBanner" },
	        React.createElement("img", { src: NewYearSaleBanner, className: "bannerImg" })
	      );
	    }
	  }, {
	    key: "renderProgressDisplay",
	    value: function renderProgressDisplay() {
	      if (this.studentLoading()) {
	        return this.renderSpinner();
	      } else if (this.isMatchingDateSpan()) {
	        return this.renderGoalPeriodProgress();
	      } else {
	        return this.renderGenericProgressDisplay();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var student = this.props.student;
	
	      var grade_level = this.getStudentGradeLevel();
	      var expectations = student.prefs.grade_level_expectations_metrics[grade_level];
	      if ((expectations || []).length || (student.cloze_status || {}).trigger) {
	        var dateSelectors = this.renderDateSelectors();
	      } else {
	        var emptyDashboard = "emptyDashboard";
	      }
	
	      var tasksContainer = this.renderTaskContainer();
	      var widerDashboard = tasksContainer ? '' : " widerDashboard";
	      var studentDisplay = React.createElement(GamifiedStudentDisplay, { student: student });
	
	      var _renderSale = this.renderSale(),
	          saleModal = _renderSale.saleModal,
	          saleBanner = _renderSale.saleBanner;
	
	      if (!saleBanner) {
	        // var newItemsModal = this.renderNewItemsModal()
	        // var newItemsBanner = this.renderNewItemsBanner()
	      }
	
	      if (this.showActivitiesColumn()) {
	
	        return React.createElement(
	          "div",
	          { className: "studentHomePageVertical container", ref: "container" },
	          saleModal,
	          saleBanner,
	          studentDisplay,
	          React.createElement(
	            "div",
	            { className: "dashboardContainer activitiesPresent " + emptyDashboard + widerDashboard },
	            this.renderDividerSection('My Goals'),
	            dateSelectors,
	            this.renderProgressDisplay(),
	            React.createElement(
	              "div",
	              null,
	              this.renderLinks()
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "activitiesContainer " + emptyDashboard + widerDashboard },
	            this.renderDividerSection('My Activites'),
	            tasksContainer
	          ),
	          this.renderBookSearch(),
	          React.createElement(BookActionModal, { studentDashboard: true, ref: this.actionModal,
	            selectedBook: this.state.selectedBook, openBookActivity: this.openBookActivity,
	            expectations: student.prefs.grade_level_expectations_metrics[grade_level] }),
	          this.renderOnboardingModal(),
	          this.readingLogModal()
	        );
	      } else {
	        return React.createElement(
	          "div",
	          { className: "studentHomePageVertical container", ref: "container" },
	          saleModal,
	          saleBanner,
	          studentDisplay,
	          React.createElement(
	            "div",
	            { className: "dashboardContainer noActivities" },
	            this.renderDividerSection('My Goals'),
	            this.renderProgressDisplay(),
	            React.createElement(
	              "div",
	              null,
	              dateSelectors,
	              this.renderLinks()
	            )
	          ),
	          this.renderBookSearch(),
	          React.createElement(BookActionModal, { studentDashboard: true, ref: this.actionModal,
	            selectedBook: this.state.selectedBook, openBookActivity: this.openBookActivity,
	            expectations: student.prefs.grade_level_expectations_metrics[grade_level] }),
	          this.renderOnboardingModal(),
	          this.readingLogModal()
	        );
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      Mycroft.newEvent({ category: "Student-Profile", action: "show-streamlined-profile" });
	      // expand dropdown if url param
	      var queryString = window.location.search;
	      var urlParams = new URLSearchParams(queryString);
	      var acceptableParams = ['exercises', 'quizzes-passed', 'reviews', 'questions', 'question-builder'];
	      var bookSearchDropdown = urlParams.get('bookSearchDropdown');
	      if (bookSearchDropdown && acceptableParams.includes(bookSearchDropdown)) {
	        this.openBookSearch(bookSearchDropdown, null, false, true);
	      }
	    }
	  }]);
	
	  return StudentHomePageVertical;
	}(React.Component)) || _class) || _class);
	
	
	var EXERCISE_TASK = "exercise-task";
	var READING_TASK = "reading-task";
	
	var USE_LABELS = [StudentMetrics.TYPES.QUESTION_BUILDER];
	
	StudentHomePageVertical.WrappedComponent.propTypes = PageStrictPropTypes({
	  populateData: PropTypes.func,
	  postBooks: PropTypes.func,
	  student: PropTypes.object,
	  showLogReading: PropTypes.bool,
	  showExercises: PropTypes.bool,
	  fetchLibraryPlatforms: PropTypes.func,
	  validTasks: PropTypes.array,
	  hasTasks: PropTypes.bool,
	  showQuestionBuilders: PropTypes.bool,
	  hasRevisables: PropTypes.bool
	});
	
	module.exports = StudentHomePageVertical;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var moment = __webpack_require__(15);
	var LoadingButton = __webpack_require__(17);
	
	var CurrentUser = __webpack_require__(3);
	
	__webpack_require__(3768);
	
	var StudentReportModal = function (_React$Component) {
		_inherits(StudentReportModal, _React$Component);
	
		function StudentReportModal(props) {
			_classCallCheck(this, StudentReportModal);
	
			var _this = _possibleConstructorReturn(this, (StudentReportModal.__proto__ || Object.getPrototypeOf(StudentReportModal)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, evaluationAmount: ""
			};
			return _this;
		}
	
		_createClass(StudentReportModal, [{
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "hideModal",
			value: function hideModal() {
				this.refs.modal.hide();
				this.props.openReport();
			}
		}, {
			key: "changeEvaluation",
			value: function changeEvaluation() {
				var evaluationValue = $(this.refs.evaluation_option).closest(".selfEvaluationForm").find("input:checked").val();
				this.setState({ evaluationAmount: evaluationValue });
			}
		}, {
			key: "submitEvaluation",
			value: function submitEvaluation(e) {
				$wr.nope(e);
				this.setState({ loading: true });
				var evaluationValue = $(this.refs.evaluation_option).closest(".selfEvaluationForm").find("input:checked").val();
	
				if (evaluationValue == undefined) {
					this.setState({ loading: false });
				} else {
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Thank You", text: "Thank you for sharing that. The report is on it's way!",
							icon: "ok-sign"
						}, this.setState({ loading: false }));
	
						setTimeout(function () {
							this.hideModal();
						}.bind(this), 1200);
					}.bind(this), 500);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var month = moment().subtract(1, "months").format('MMMM');
				var title = "How did your " + month + " go?";
	
				var modalBody = React.createElement(
					"div",
					{ className: "evaluationContainer" },
					React.createElement(
						"p",
						{ className: "initialInstructions" },
						"We know you were busy reading and writing. How do you think you did?"
					),
					React.createElement(
						"form",
						{ className: "selfEvaluationForm", onSubmit: this.submitEvaluation },
						React.createElement(
							"div",
							{ className: "labelsContainer" },
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", name: "learningRating", ref: "evaluation_option", value: StudentReportModal.OPTION_ONE,
									checked: this.state.evaluationAmount == StudentReportModal.OPTION_ONE, onChange: this.changeEvaluation }),
								"I did not try hard enough."
							),
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", name: "learningRating", ref: "evaluation_option", value: StudentReportModal.OPTION_TWO,
									checked: this.state.evaluationAmount == StudentReportModal.OPTION_TWO, onChange: this.changeEvaluation }),
								"I tried a bit, but I can do better."
							),
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", name: "learningRating", ref: "evaluation_option", value: StudentReportModal.OPTION_THREE = "option three",
									checked: this.state.evaluationAmount == StudentReportModal.OPTION_THREE, onChange: this.changeEvaluation }),
								"I tried hard and did well."
							),
							React.createElement(
								"label",
								null,
								React.createElement("input", { type: "radio", name: "learningRating", ref: "evaluation_option", value: StudentReportModal.OPTION_FOUR = "option four",
									checked: this.state.evaluationAmount == StudentReportModal.OPTION_FOUR, onChange: this.changeEvaluation }),
								"I worked really hard and did amazing work!"
							)
						),
						React.createElement(
							"p",
							{ className: "extraCoinsText" },
							"(Want extra coins? Tell us about what you think you did well and where you want to improve.)"
						),
						React.createElement("textArea", { className: "form-control evaluationTextArea", rows: "2", cols: "20", ref: "evaluation_option" }),
						React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.state.loading, text: "View My Progress!" })
					)
				);
				return React.createElement(
					Modal,
					{ className: "studentReportModal", ref: "modal", headerText: title },
					modalBody
				);
			}
		}]);
	
		return StudentReportModal;
	}(React.Component);
	
	StudentReportModal.OPTION_ONE = "option one";
	StudentReportModal.OPTION_TWO = "option two";
	StudentReportModal.OPTION_THREE = "option three";
	StudentReportModal.OPTION_FOUR = "option four";
	
	StudentReportModal.propTypes = PageStrictPropTypes({
		openReport: PropTypes.func.isRequired
	});
	
	module.exports = StudentReportModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is a placeholder until we get a better solution
	var QuestionFeedback = __webpack_require__(173);
	
	__webpack_require__(3760);
	
	var ComponentDemonstrator = function (_React$Component) {
		_inherits(ComponentDemonstrator, _React$Component);
	
		function ComponentDemonstrator(props) {
			_classCallCheck(this, ComponentDemonstrator);
	
			var _this = _possibleConstructorReturn(this, (ComponentDemonstrator.__proto__ || Object.getPrototypeOf(ComponentDemonstrator)).call(this));
	
			_this.state = { showFeedback: false, slide: false };
			return _this;
		}
	
		_createClass(ComponentDemonstrator, [{
			key: "renderFeedback",
			value: function renderFeedback(message) {
				return React.createElement(QuestionFeedback, { feedbackItems: message });
			}
		}, {
			key: "trigger",
			value: function trigger() {
				this.setState({ showFeedback: true, slide: true });
			}
		}, {
			key: "getFeedback",
			value: function getFeedback() {
				switch (this.props.component) {
					case "warmup_question_1":
						return this.renderFeedback(["Congratulation on starting your first quiz! First tell me about the book you are reading. Is it about a true story or something imaginary?"]);
						break;
					case "warmup_question_2":
						return this.renderFeedback(["Next, answer these few questions. Remember to keep it short!"]);
						break;
				}
				return null;
			}
		}, {
			key: "getDemoStyle",
			value: function getDemoStyle() {
				switch (this.props.component) {
					case "warmup_question_1":
						return { width: '60%' };
						break;
					case "warmup_question_2":
						return { width: '75%' };
						break;
				}
				return {};
			}
		}, {
			key: "getFeedbackStyle",
			value: function getFeedbackStyle() {
				switch (this.props.component) {
					case "warmup_question_1":
						return { width: '40%' };
						break;
					case "warmup_question_2":
						return { width: '25%' };
						break;
				}
				return null;
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.showFeedback) {
					var feedback = this.getFeedback();
				}
				if (this.state.slide) {
					var slideClass = "";
				}
				return React.createElement(
					"div",
					{ className: "ComponentDemonstrator" },
					React.createElement(
						"div",
						{ className: "demo", style: this.getDemoStyle() },
						this.props.children
					),
					React.createElement(
						"div",
						{ className: "questionFeedbackBox", style: this.getFeedbackStyle() },
						feedback
					)
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.component != this.props.component) {
					this.setState({ showFeedback: false, slide: false });
					setTimeout(this.trigger.bind(this), 1000);
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				setTimeout(this.trigger.bind(this), 1000);
			}
		}]);
	
		return ComponentDemonstrator;
	}(React.Component);
	
	module.exports = ComponentDemonstrator;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var AvatarCircle = __webpack_require__(940);
	var Glyphicon = __webpack_require__(8);
	var SpeechControls = __webpack_require__(142);
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	var StudentMetrics = __webpack_require__(29);
	
	__webpack_require__(3761);
	
	var OwlfonsoChat = function (_React$Component) {
		_inherits(OwlfonsoChat, _React$Component);
	
		function OwlfonsoChat(props) {
			_classCallCheck(this, OwlfonsoChat);
	
			var _this = _possibleConstructorReturn(this, (OwlfonsoChat.__proto__ || Object.getPrototypeOf(OwlfonsoChat)).call(this));
	
			autobind(_this);
	
			_this.state = { isTyping: false, currentChat: props.currentChat };
			return _this;
		}
	
		_createClass(OwlfonsoChat, [{
			key: "getGradeLevelExpectations",
			value: function getGradeLevelExpectations() {
				var gradeLevel = CurrentUser.get().prefs.academic_level;
				var glMetrics = CurrentUser.get().prefs.grade_level_expectations_metrics;
				return glMetrics[gradeLevel] || glMetrics['-1'];
			}
		}, {
			key: "getReplacementText",
			value: function getReplacementText(toReplace) {
				switch (toReplace) {
					case STUDENT_NAME:
						return CurrentUser.get().first_name;
					case ASSIGNMENT_METRICS:
						var metrics = this.getGradeLevelExpectations();
						var metricArray = _.map(metrics, function (metricData) {
							var label = StudentMetrics.getLabel(metricData.metric);
							if (label) {
								return metricData.goal + " " + StudentMetrics.getLabel(metricData.metric);
							} else {
								return null;
							}
						});
	
						return _.select(metricArray).join(", ");
					case ASSIGNMENT_TIME_PERIOD:
						return CurrentUser.get().prefs.expectations_time_period;
				}
			}
		}, {
			key: "parseCurrentChatText",
			value: function parseCurrentChatText() {
				var _this2 = this;
	
				var currentChat = this.props.currentChat;
	
				// pick correct option to display based on chat history
				if (currentChat.type == "options") {
					var parts = currentChat.text.split(";");
					var chosenOption = _.find(parts, function (option) {
						return _.first(option.split("::")) === _.last(_this2.props.history).text;
					}).split("::");
	
					currentChat = _.extend({}, currentChat, { text: chosenOption[1], type: "static", increment: chosenOption[2] });
				}
	
				if (currentChat.text.includes("{{")) {
					var updatedText = currentChat.text;
					_.map(REPLACEMENT_STRINGS, function (toReplace) {
						updatedText = updatedText.replace(toReplace, _this2.getReplacementText(toReplace));
					});
					currentChat = _.extend({}, currentChat, { text: updatedText });
				}
	
				return currentChat;
			}
		}, {
			key: "renderChatItem",
			value: function renderChatItem(chat) {
				var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
				var avatarCircle = React.createElement(AvatarCircle, { avatarType: chat.speaker, user: CurrentUser.get(),
					initialOnly: this.props.initialOnly });
	
				if (chat.speaker == "owlfonso") {
					var readChatControls = React.createElement(SpeechControls, { getTextToRead: function getTextToRead() {
							return chat.text;
						}, readTextOnly: true });
				}
				var chatBox = React.createElement(
					"div",
					{ className: "chatBox" },
					chat.text
				);
	
				return React.createElement(
					CSSTransition,
					{ classNames: "slide", key: "chat-" + key,
						timeout: { enter: 10, exit: 1 },
						transitionEnterTimeout: 10, transitionLeaveTimeout: 1 },
					React.createElement(
						"div",
						{ className: chat.speaker + "ChatItem" },
						avatarCircle,
						chatBox,
						readChatControls
					)
				);
			}
		}, {
			key: "renderChatChoices",
			value: function renderChatChoices(chat) {
				var _this3 = this;
	
				var chatChoices = chat.text.split(";");
	
				var choicesDisplay = _.map(chatChoices, function (choiceText, index) {
					var chat = _.extend({}, _this3.state.currentChat, { text: choiceText, type: "static" });
	
					return React.createElement(
						"div",
						{ className: "chatChoice clickableElement", key: "choice-" + index,
							onClick: _this3.props.advanceStageF.bind(_this3, chat, 1) },
						choiceText
					);
				});
	
				return React.createElement(
					"div",
					{ className: "chatChoicesDisplay" },
					choicesDisplay
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this4 = this;
	
				var chatHistoryDisplay = _.map(this.props.history, function (chat, index) {
					return _this4.renderChatItem(chat, index);
				});
	
				var currentChat = this.state.currentChat;
				if (this.state.isTyping) {
					var typingDisplay = React.createElement(
						CSSTransition,
						{ classNames: "slide", key: "typing_display-" + chatHistoryDisplay.length,
							timeout: { enter: 10, exit: .9 },
							transitionEnterTimeout: 10, transitionLeaveTimeout: .9 },
						React.createElement(
							"div",
							{ className: "typingDisplay" },
							React.createElement(Glyphicon, { icon: "option-horizontal", className: "typingIcon" })
						)
					);
					chatHistoryDisplay.push(typingDisplay);
				} else if (currentChat.type == "static") {
	
					// Check if this is a weird in-between renders millisecond where we'd be doubling up
					var lastHistory = _.last(this.props.history);
					if (lastHistory == undefined || lastHistory.stage != currentChat.stage) {
						// Add the "currentChat" item to the end of the history
						chatHistoryDisplay.push(this.renderChatItem(currentChat, this.props.history.length));
					}
				} else {
					var currentChatChoices = this.renderChatChoices(currentChat);
				}
	
				return React.createElement(
					"div",
					{ className: "owlfonsoChat" },
					React.createElement(
						"div",
						{ className: "chatHistory clearfix" },
						React.createElement(
							TransitionGroup,
							null,
							chatHistoryDisplay
						)
					),
					currentChatChoices
				);
			}
		}, {
			key: "resetTimeouts",
			value: function resetTimeouts() {
				var _this5 = this;
	
				var currentChat = this.props.currentChat;
				if (currentChat.speaker == "owlfonso") {
					currentChat = this.parseCurrentChatText();
	
					this.setState({ isTyping: true, currentChat: currentChat }, function () {
						_this5.props.scrollToBottomF();
						setTimeout(function () {
							_this5.setState({ isTyping: false }, function () {
								_this5.props.scrollToBottomF();
								setTimeout(function () {
									_this5.props.advanceStageF(currentChat, currentChat.increment);
								}, 1200);
							});
						}, 1200);
					});
				} else {
					this.setState({ currentChat: currentChat }, function () {
						_this5.props.scrollToBottomF();
					});
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.currentChat.stage != this.props.currentChat.stage) {
					this.resetTimeouts();
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.resetTimeouts();
			}
		}]);
	
		return OwlfonsoChat;
	}(React.Component);
	
	var STUDENT_NAME = "{{STUDENT_NAME}}";
	var ASSIGNMENT_METRICS = "{{ASSIGNMENT_METRICS}}";
	var ASSIGNMENT_TIME_PERIOD = "{{ASSIGNMENT_TIME_PERIOD}}";
	
	var REPLACEMENT_STRINGS = [STUDENT_NAME, ASSIGNMENT_METRICS, ASSIGNMENT_TIME_PERIOD];
	
	OwlfonsoChat.propTypes = StrictPropTypes({
		// all previous chat messages
		history: PropTypes.array.isRequired,
	
		// current chat message
		currentChat: PropTypes.object.isRequired,
	
		// function to advance the stage to the next chat message
		advanceStageF: PropTypes.func.isRequired,
	
		// function to scroll down to the bottom of the chat area
		scrollToBottomF: PropTypes.func.isRequired,
	
		// to only display the user's initial, not their avatar
		initialOnly: PropTypes.bool
	});
	
	module.exports = OwlfonsoChat;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var StudentAvatar = __webpack_require__(35);
	var StudentExpectationsDisplay = __webpack_require__(411);
	var StudentProgressDisplay = __webpack_require__(194);
	
	var StudentOnboardingImage = function (_React$Component) {
		_inherits(StudentOnboardingImage, _React$Component);
	
		function StudentOnboardingImage(props) {
			_classCallCheck(this, StudentOnboardingImage);
	
			var _this = _possibleConstructorReturn(this, (StudentOnboardingImage.__proto__ || Object.getPrototypeOf(StudentOnboardingImage)).call(this));
	
			autobind(_this);
	
			_this.state = { activeHat: null, confirmedHat: false };
			return _this;
		}
	
		_createClass(StudentOnboardingImage, [{
			key: "stageImgKey",
			value: function stageImgKey() {
				var imgKey = this.props.imgPath;
	
				if (imgKey && imgKey.includes("{{LEVEL}}")) {
					imgKey = imgKey.replace("{{LEVEL}}", this.props.level);
				}
	
				return imgKey;
			}
		}, {
			key: "showHatOnOwl",
			value: function showHatOnOwl(hatKey) {
				this.setState({ activeHat: hatKey });
			}
		}, {
			key: "renderHat",
			value: function renderHat(hatKey) {
				var hatImgPath = dynamicRequire("patches/head/" + hatKey + "-s.png");
				return React.createElement("img", { src: hatImgPath, alt: hatKey, className: "hatImg clickableElement",
					onClick: this.showHatOnOwl.bind(this, hatKey), key: hatKey });
			}
		}, {
			key: "renderStudentAvatarHatsDisplay",
			value: function renderStudentAvatarHatsDisplay() {
				var _this2 = this;
	
				var hatImages = _.map(["hat-1", "hat-2", "hat-3", "hat-4"], function (hatKey) {
					return _this2.renderHat(hatKey);
				});
	
				if (this.state.activeHat) {
					var activeHatDisplay = React.createElement("img", { src: dynamicRequire("patches/head/" + this.state.activeHat + ".png"), className: "activeHat" });
				}
	
				return React.createElement(
					"div",
					{ className: "stage-student-avatar-hats" },
					React.createElement(
						"div",
						{ className: "hatContainer" },
						hatImages
					),
					activeHatDisplay,
					React.createElement(StudentAvatar, { student: CurrentUser.get(), maxWidth: 200 })
				);
			}
		}, {
			key: "renderStudentExpectationsDisplay",
			value: function renderStudentExpectationsDisplay() {
	
				// <StudentExpectationsDisplay studentID={ CurrentUser.get().id } />
				return React.createElement(
					"div",
					{ className: "expectationsContainer" },
					React.createElement(StudentProgressDisplay, {
						metric: "quizzes-passed",
						title: "Quizzes Passed",
						unit: "quizzes",
						total: 1,
						current: 0,
						actionLabel: "Take a Quiz" }),
					React.createElement(StudentProgressDisplay, {
						metric: "questions",
						title: "Practice Questions",
						unit: "answers",
						total: 1,
						current: 0,
						actionLabel: "Answer a Question" })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var imgKey = this.stageImgKey();
				var className = "studentOnboardingImage";
	
				// custom display for student avatar with hats and with rays
				if (imgKey && imgKey.includes("student-avatar")) {
					if (imgKey.includes("hats")) {
						var imgDisplay = this.renderStudentAvatarHatsDisplay();
					} else if (imgKey.includes("rays")) {
						var imgDisplay = React.createElement(
							"div",
							{ className: "stage-student-avatar-rays" },
							React.createElement("img", { src: __webpack_require__(528), alt: "owlfonso",
								className: "owlfonsoWaving" }),
							React.createElement(StudentAvatar, { student: CurrentUser.get(), maxWidth: 200 })
						);
					}
				} else if (imgKey && imgKey.includes("profile-action-buttons")) {
					var imgDisplay = this.renderStudentExpectationsDisplay();
					className += " studentExpectationsDisplay";
				} else if (imgKey) {
					var imgClass = "stage-" + imgKey;
					var imgPath = dynamicRequire("onboarding/" + imgKey + ".png");
					var imgDisplay = React.createElement("img", { src: imgPath, alt: "welcome", className: imgClass });
				}
	
				return React.createElement(
					"div",
					{ className: className },
					imgDisplay
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(prevProps) {
				if (prevProps.stage != this.props.stage && this.state.activeHat != null && prevProps.hasStudentOptions && prevProps.imgPath == 'student-avatar-hats') {
					var award_data = {
						type: "onboarding_hat", student_id: CurrentUser.get().id,
						patch_name: this.state.activeHat
					};
	
					this.setState({ confirmedHat: true });
					CurrentUser.api().postAwards({ award: award_data }, $wr.apiHandler(function (response) {
						CurrentUser.fetchCurrentUserData();
					}));
				}
			}
		}]);
	
		return StudentOnboardingImage;
	}(React.Component);
	
	StudentOnboardingImage.propTypes = StrictPropTypes({
		stage: PropTypes.number.isRequired,
		level: PropTypes.string.isRequired,
		hasStudentOptions: PropTypes.bool,
		imgPath: PropTypes.string
	});
	
	module.exports = StudentOnboardingImage;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var AccountPlans = __webpack_require__(53);
	var DropDownOptions = __webpack_require__(26);
	var LoadingButton = __webpack_require__(17);
	var Spinner = __webpack_require__(9);
	var UpgradeHeader = __webpack_require__(247);
	var UpgradeTokenForm = __webpack_require__(167);
	var WhooosReadingServices = __webpack_require__(25);
	var Glyphicon = __webpack_require__(8);
	var CreditCardInput = __webpack_require__(396);
	
	__webpack_require__(3769);
	
	var AccountCustomizer = function (_React$Component) {
		_inherits(AccountCustomizer, _React$Component);
	
		function AccountCustomizer(props) {
			_classCallCheck(this, AccountCustomizer);
	
			var _this = _possibleConstructorReturn(this, (AccountCustomizer.__proto__ || Object.getPrototypeOf(AccountCustomizer)).call(this));
	
			autobind(_this);
			_this.state = {
				currentView: PROFILE, loading: false,
				loadingBilling: false, billingHistory: null, showPaymentMethodForm: false
			};
			return _this;
		}
	
		_createClass(AccountCustomizer, [{
			key: "handlePersonalInformationSubmit",
			value: function handlePersonalInformationSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
				var firstName = this.refs.first_name.value;
				var lastName = this.refs.last_name.value;
				var title = this.refs.title.value;
				var username = this.refs.username.value;
				var email = this.refs.email.value;
				var newPassword = this.refs.new_password.value;
				var confirmedPassword = this.refs.confirmed_password.value;
				var currentPassword = this.refs.current_password.value;
	
				var params = { first_name: firstName, last_name: lastName,
					title: title, username: username, email: email };
	
				if (newPassword || confirmedPassword || currentPassword) {
					_.extend(params, {
						password: newPassword, password_confirmation: confirmedPassword, current_password: currentPassword
						// double_password: newPassword, current_password: currentPassword
					});
				}
				var adminId = CurrentUser.get().id;
				this.setState({ loading: true });
				CurrentUser.api().patchAdmin(adminId, { admin: params }, $wr.apiHandler(function (response) {
					if (response.admin.errors) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Sorry!", text: response.admin.errors.join(", "),
							icon: "exclamation-sign", type: "error" });
						_this2.setState({ loading: false });
					} else {
						setTimeout(function () {
							window.wrNotifications.triggerDropDownNotification({
								title: "Information Edited", text: "You successfully changed your account information.",
								icon: "ok-sign" });
						}, 1000);
						CurrentUser.fetchCurrentUserData(function () {
							_this2.forceUpdate();
							_this2.setState({ loading: false });
						});
					}
				}));
			}
		}, {
			key: "deleteSubscription",
			value: function deleteSubscription(e) {
				var _this3 = this;
	
				$wr.nope(e);
				if (confirm("Are you sure you want to cancel your subscription?")) {
					var currentUser = CurrentUser.get();
	
					var params = { admin: { account: { has_credit_card: false } } };
					CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler(function (response) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Subscription Canceled", text: "You have canceled your subscription.", icon: "trash" });
						CurrentUser.fetchCurrentUserData(function () {
							_this3.forceUpdate();
						});
					}));
				}
			}
	
			// to do
	
		}, {
			key: "sendReceipt",
			value: function sendReceipt(chargeData, e) {
				$wr.nope(e);
	
				var params = { what: "premium_account_receipt",
					stripe_payment_id: chargeData.stripe_payment_id };
	
				CurrentUser.api().postUserTrigger(CurrentUser.get().id, params, $wr.apiHandler(function (response) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sent!", text: "Check your inbox for your receipt.", icon: "envelope" });
				}));
			}
		}, {
			key: "viewName",
			value: function viewName(viewKey) {
				if (viewKey == PROFILE) {
					return "Profile";
				} else if (viewKey == PLAN) {
					return "Plan";
				} else if (viewKey == BILLING) {
					return "Billing";
				}
			}
		}, {
			key: "toggleView",
			value: function toggleView(viewKey, e) {
				var _this4 = this;
	
				$wr.nope(e);
				this.setState({ currentView: viewKey }, function () {
					if (viewKey == BILLING && !_this4.state.billingHistory) {
						_this4.fetchBillingHistory();
					}
				});
			}
		}, {
			key: "currentPlan",
			value: function currentPlan() {
				return CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
			}
		}, {
			key: "hasCreditCard",
			value: function hasCreditCard() {
				return CurrentUser.get().account.has_credit_card;
			}
		}, {
			key: "isPaying",
			value: function isPaying() {
				return CurrentUser.get().account.paying;
			}
		}, {
			key: "planClassCount",
			value: function planClassCount() {
				return CurrentUser.get().account.plan_student_list_count;
			}
		}, {
			key: "nextChargeTime",
			value: function nextChargeTime() {
				return CurrentUser.get().account.next_charge_time;
			}
		}, {
			key: "nextChargeAmount",
			value: function nextChargeAmount() {
				return CurrentUser.get().account.next_charge_cents;
			}
		}, {
			key: "planName",
			value: function planName(plan) {
				plan = plan || this.currentPlan();
				return AccountPlans.name(plan);
			}
		}, {
			key: "onPaymentSubmit",
			value: function onPaymentSubmit(e) {
				var _this5 = this;
	
				$wr.nope(e);
				this.setState({ loadingPaymentUpdate: true });
	
				var currentUser = CurrentUser.get();
				var userData = { name: currentUser.first_name + " " + currentUser.last_name,
					email: currentUser.email };
	
				this.refs.creditCard.tokenize(userData, function (success, tokenData) {
					if (success) {
						var params = {
							admin: {
								account: {
									update_card: true
								}
							},
							card_token_data: tokenData
						};
						CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler(function (response) {
							window.wrNotifications.triggerDropDownNotification({
								title: "Upgrade",
								text: "You have added a new payment method!",
								icon: "star"
							});
							CurrentUser.fetchCurrentUserData(function () {
								_this5.setState({ loadingPaymentUpdate: false, showPaymentMethodForm: false });
							});
						}));
					} else {
						_this5.setState({ loadingPaymentUpdate: false });
					}
				});
			}
		}, {
			key: "toggleEditPaymentMethod",
			value: function toggleEditPaymentMethod(e) {
				$wr.nope(e);
				this.setState({ showPaymentMethodForm: !this.state.showPaymentMethodForm });
			}
		}, {
			key: "editPlanLink",
			value: function editPlanLink() {
				var plan = this.currentPlan();
				if (plan == AccountPlans.SILVER_PLAN_2019 || plan == AccountPlans.SILVER_SEMESTER_PLAN_2019) {
					return "/upgrade?plan=silver";
				} else {
					return "/upgrade?plan=gold";
				}
			}
		}, {
			key: "planPricingInfo",
			value: function planPricingInfo() {
				return AccountPlans.pricingSummary(this.currentPlan());
			}
		}, {
			key: "renderLeftNavLink",
			value: function renderLeftNavLink(viewKey) {
				var navClassName = "leftNavLink";
				if (this.state.currentView == viewKey) {
					navClassName += " selected";
				}
				return React.createElement(
					"a",
					{ href: "#", onClick: this.toggleView.bind(this, viewKey),
						className: navClassName, key: viewKey },
					this.viewName(viewKey)
				);
			}
		}, {
			key: "renderProfileView",
			value: function renderProfileView() {
				var user = CurrentUser.get();
	
				return React.createElement(
					"form",
					{ className: "personalInfoForm", onSubmit: this.handlePersonalInformationSubmit },
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"First Name",
							React.createElement("input", { className: "form-control", ref: "first_name",
								defaultValue: user.first_name })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Last Name",
							React.createElement("input", { className: "form-control", ref: "last_name",
								defaultValue: user.last_name })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Title",
							React.createElement(
								"select",
								{ ref: "title", defaultValue: user.title,
									className: "form-control selectOptions" },
								DropDownOptions.Select.Titles()
							)
						)
					),
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer emailInput" },
							"Email",
							React.createElement("input", { className: "form-control", ref: "email", placeholder: "Enter your email",
								defaultValue: user.email })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Username",
							React.createElement("input", { className: "form-control", ref: "username",
								defaultValue: user.username, placeholder: "Enter a username (optional)" })
						)
					),
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Current Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "current_password" })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"New Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "new_password" })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Confirm Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "confirmed_password" })
						)
					),
					React.createElement(LoadingButton, { className: "btn buttonSuccess center-block", loading: this.state.loading,
						text: "Save Information" })
				);
			}
		}, {
			key: "renderPlanView",
			value: function renderPlanView() {
				var currentPlan = this.currentPlan();
	
				var sectionClassName = "currentPlan";
	
				var planPaymentStatus = CurrentUser.get().account.plan_payment_status;
	
				if (currentPlan == AccountPlans.STARTER_PLAN && CurrentUser.get().role != "adminRole" && CurrentUser.get().account.product != "wrGold") {
					sectionClassName += " starterPlan";
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planLabel" },
							"Current Plan:"
						),
						this.planName()
					);
					var benefitsList = _.map(UpgradeHeader.BENEFITS.silver, function (benefitText) {
						return React.createElement(
							"div",
							{ className: "benefitItem", key: benefitText },
							React.createElement(Glyphicon, { icon: "ok" }),
							React.createElement(
								"div",
								{ className: "benefitText" },
								benefitText
							)
						);
					});
					var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;
					var currentSilverTrial = CurrentUser.get().account.active_trials.wrSilver != undefined;
	
					var expiredGoldTrial = CurrentUser.get().account.expired_trials.wrGold != undefined;
					var currentGoldTrial = CurrentUser.get().account.active_trials.wrGold != undefined;
	
					if (!expiredSilverTrial && !currentSilverTrial) {
						var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
						var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
						var trialLink = React.createElement(
							"a",
							{ href: trialURL },
							"Start 30 day trial"
						);
						var className = "btn buttonDefault";
					} else {
						var className = "btn btn-link";
					}
	
					if (currentGoldTrial) {
						var currentTrialDetails = React.createElement(
							"div",
							{ className: "planSection" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Trial:"
							),
							"Gold"
						);
					} else if (currentSilverTrial) {
						var currentTrialDetails = React.createElement(
							"div",
							{ className: "planSection" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Trial:"
							),
							"Silver"
						);
					}
	
					var additionalInfo = React.createElement(
						"div",
						{ className: "upgradeBox" },
						React.createElement(
							"div",
							{ className: "upgradeSentence" },
							"Upgrade to Silver"
						),
						React.createElement(
							"div",
							{ className: "benefitsList" },
							benefitsList
						),
						React.createElement(
							"div",
							{ className: "upgradeContainer" },
							React.createElement(
								"a",
								{ href: "/upgrade?plan=silver", className: "btn buttonSuccess" },
								"Upgrade"
							),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"), className: className },
								"Learn More"
							),
							trialLink
						)
					);
				} else if (this.isPaying()) {
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Plan:"
							),
							this.planName(),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"),
									className: "changeLink" },
								"Change"
							)
						),
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Plan Price:"
							),
							this.planPricingInfo()
						),
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Class Count:"
							),
							$wr.pluralizeWithNumber("class", this.planClassCount(), "classes"),
							React.createElement(
								_reactRouterDom.Link,
								{ to: this.editPlanLink(),
									className: "changeLink" },
								"Add classes"
							)
						)
					);
	
					if (this.hasCreditCard()) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Next Charge:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Charge Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true),
									React.createElement(
										"a",
										{ href: "#", onClick: this.deleteSubscription,
											className: "changeLink" },
										"Cancel"
									)
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									CurrentUser.paymentMethodSummary(),
									React.createElement(
										"a",
										{ href: "#", onClick: this.toggleEditPaymentMethod,
											className: "changeLink" },
										"Edit"
									)
								)
							)
						);
					} else if (planPaymentStatus == CREDIT_CARD_REMOVED) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Cancellation Date:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Charge Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true),
									" (will not be charged)"
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									"None",
									React.createElement(
										"a",
										{ href: "#", onClick: this.toggleEditPaymentMethod,
											className: "changeLink" },
										"Add payment method"
									)
								)
							)
						);
					} else if (planPaymentStatus == PURCHASE_ORDER_ACTIVE) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Renewal Date:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Renewal Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true)
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									"Purchase Order"
								)
							)
						);
					}
				}
	
				if (CurrentUser.get().role == "adminRole" || CurrentUser.get().account.product == "wrGold") {
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Plan:"
							),
							"Gold",
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"),
									className: "changeLink" },
								"Change"
							)
						)
					);
				} else {
					var upgradeTokenForm = React.createElement(UpgradeTokenForm, { requireToggle: true });
				}
	
				if (this.state.showPaymentMethodForm) {
					var paymentInfo = { stripe_public_key: CreditCardInput.STRIPE_PUBLIC_KEY };
	
					var updatePaymentForm = React.createElement(
						"div",
						{ className: "updatePaymentForm" },
						React.createElement(
							"div",
							{ className: "purchaseDisclaimer" },
							"By adding your payment information, you authorize Whooo's Reading to charge you every year until you cancel your subscription."
						),
						React.createElement(CreditCardInput, { ref: "creditCard", paymentInfo: paymentInfo }),
						React.createElement(
							"div",
							{ className: "submitButton" },
							React.createElement(LoadingButton, { className: "btn buttonSuccess", onClick: this.onPaymentSubmit,
								loading: this.state.loadingPaymentUpdate, text: "Update Account" })
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: sectionClassName },
					currentPlanDetails,
					currentTrialDetails,
					additionalInfo,
					updatePaymentForm,
					upgradeTokenForm
				);
			}
		}, {
			key: "renderHistoryRow",
			value: function renderHistoryRow(rowContent, key) {
				var contents = _.map(rowContent, function (cellContent, index) {
					return React.createElement(
						"div",
						{ className: "historyCell", key: index },
						cellContent
					);
				});
				return React.createElement(
					"div",
					{ className: "historyRow", key: key },
					contents
				);
			}
		}, {
			key: "renderBillingView",
			value: function renderBillingView() {
				var _this6 = this;
	
				if (this.state.billingHistory == null) {
					return React.createElement(
						"div",
						{ className: "billingHistory" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				if (this.state.billingHistory.length == 0) {
					return React.createElement(
						"div",
						{ className: "billingHistory" },
						"You have no billing history."
					);
				}
	
				var chargeHistoryRows = _.map(this.state.billingHistory, function (chargeData, index) {
					var receiptLink = React.createElement(
						"a",
						{ href: "#", className: "receiptLink",
							onClick: _this6.sendReceipt.bind(_this6, chargeData) },
						"Send"
					);
	
					var date = $wr.formatDate(chargeData.date);
	
					if (chargeData.waived) {
						var chargeAmount = "Waived";
					} else {
						var chargeAmount = $wr.centsToDollars(chargeData.cents, true);
					}
	
					var classText = $wr.pluralizeWithNumber("class", chargeData.student_list_count, "classes");
					var planText = chargeData.plan_name + " (" + classText + ")";
	
					return _this6.renderHistoryRow([date, planText, chargeAmount, receiptLink], index);
				});
	
				return React.createElement(
					"div",
					{ className: "billingHistory" },
					React.createElement(
						"div",
						{ className: "historyHeader" },
						this.renderHistoryRow(["Date", "Plan", "Amount", "Receipt"], "header")
					),
					chargeHistoryRows
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this7 = this;
	
				if (!CurrentUser.isLoaded()) {
					return React.createElement(
						"div",
						{ className: "accountCustomizer" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				var leftNavLinks = _.map(LEFT_NAV_LINKS, function (viewKey) {
					return _this7.renderLeftNavLink(viewKey);
				});
	
				if (this.state.currentView == PROFILE) {
					var currentViewContent = this.renderProfileView();
				} else if (this.state.currentView == PLAN) {
					var currentViewContent = this.renderPlanView();
				} else if (this.state.currentView == BILLING) {
					var currentViewContent = this.renderBillingView();
				}
	
				return React.createElement(
					"div",
					{ className: "accountCustomizer" },
					React.createElement(
						"div",
						{ className: "leftNavSection" },
						leftNavLinks
					),
					React.createElement(
						"div",
						{ className: "currentViewContent" },
						currentViewContent
					)
				);
			}
		}, {
			key: "fetchBillingHistory",
			value: function fetchBillingHistory() {
				var _this8 = this;
	
				this.setState({ loadingBilling: true });
				CurrentUser.api().getUser(CurrentUser.get().id, { embed: "user.billing_history" }, function (response) {
					_this8.setState({ loadingBilling: false, billingHistory: response.user.billing_history || [] });
				});
			}
		}]);
	
		return AccountCustomizer;
	}(React.Component);
	
	var PROFILE = "profile";
	var PLAN = "plan";
	var BILLING = "billing";
	
	var LEFT_NAV_LINKS = [PROFILE, PLAN, BILLING];
	
	// Plan status types
	var CREDIT_CARD_ACTIVE = "credit-card-active";
	var CREDIT_CARD_REMOVED = "credit-card-removed";
	var CREDIT_CARD_EXPIRED = "credit-card-expired";
	var PURCHASE_ORDER_ACTIVE = "credit-card-active";
	var PURCHASE_ORDER_EXPIRED = "credit-card-expired";
	var STATUS_UNKNOWN = "status-unknown";
	
	module.exports = AccountCustomizer;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var OnboardingModal = __webpack_require__(415);
	var OnboardingChecklist = __webpack_require__(166);
	var TrialStatusDisplay = __webpack_require__(417);
	var OverdrawnAccountNotice = __webpack_require__(246);
	
	var WidgetContainer = __webpack_require__(189);
	var WidgetConfig = __webpack_require__(66);
	
	__webpack_require__(3771);
	
	var CustomTeacherHomePage = function (_React$Component) {
		_inherits(CustomTeacherHomePage, _React$Component);
	
		function CustomTeacherHomePage(props) {
			_classCallCheck(this, CustomTeacherHomePage);
	
			var _this = _possibleConstructorReturn(this, (CustomTeacherHomePage.__proto__ || Object.getPrototypeOf(CustomTeacherHomePage)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("CustomTeacherHomePage");
			_this.state = {
				admin: null,
				showOnboardingModal: false, skipOnboarding: false
			};
			return _this;
		}
	
		_createClass(CustomTeacherHomePage, [{
			key: "onViewChange",
			value: function onViewChange(view) {
				this.setState({ currentView: view });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.showOnboardingModal) {
					var track = "quiz-customization";
					var onboardingModal = React.createElement(OnboardingModal, { track: track });
				}
	
				var currentUser = CurrentUser.get();
	
				var activeTrials = currentUser.account.active_trials;
				var expiredTrials = currentUser.account.expired_trials;
				var allTrials = _.extend({}, activeTrials, expiredTrials);
	
				if (currentUser && currentUser.account && _.any(allTrials)) {
					var trialDisplay = React.createElement(TrialStatusDisplay, { trials: allTrials });
				}
	
				if (this.state.admin) {
					if (this.state.admin.account_overdrawn) {
						var overdrawnDisplay = React.createElement(OverdrawnAccountNotice, { source: "dashboard" });
					}
				}
	
				var onboardingChecklist = React.createElement(OnboardingChecklist, null);
	
				var widgetParams = { topLevelDigest: WidgetConfig.TEACHER_ENTITY_TYPE, period: WidgetConfig.PERIOD, adminID: [currentUser.id] };
				var widgetContainer = React.createElement(WidgetContainer, { userID: currentUser.id, widgetParams: widgetParams });
	
				return React.createElement(
					"div",
					{ className: "container", id: "teacherHomePage" },
					onboardingChecklist,
					React.createElement(
						"header",
						{ className: "pageHeader hideOnPrint" },
						React.createElement(
							"h1",
							null,
							" Teacher Dashboard "
						)
					),
					overdrawnDisplay,
					trialDisplay,
					widgetContainer,
					onboardingModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.fetchAdminData();
				$(window.document).on("expectations-updated", this.onExectationsUpdate);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("expectations-updated", this.onExectationsUpdate);
			}
		}, {
			key: "onExectationsUpdate",
			value: function onExectationsUpdate() {
				this.setState({ admin: null }, this.fetchAdminData);
			}
		}, {
			key: "fetchAdminData",
			value: function fetchAdminData() {
				var _this2 = this;
	
				var embeds = "admin.account_overdrawn";
				CurrentUser.api().getAdmin(this.props.match.params.id, { embed: embeds }, $wr.apiHandler(function (response) {
					var pendingOnboarding = response.admin.role == "teacherRole" && response.admin.pending_onboarding;
	
					_this2.setState({ admin: response.admin, showOnboardingModal: pendingOnboarding });
				}));
			}
		}]);
	
		return CustomTeacherHomePage;
	}(React.Component);
	
	CustomTeacherHomePage.propTypes = PageStrictPropTypes({
		userIDs: PropTypes.array
	});
	
	CustomTeacherHomePage.SCHOOL_YEAR = 'School Year';
	CustomTeacherHomePage.LAST_WEEK = 'Last 7 Days';
	CustomTeacherHomePage.LAST_MONTH = 'Last 30 Days';
	CustomTeacherHomePage.CUSTOM_DATES = 'Custom Dates';
	
	module.exports = CustomTeacherHomePage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var SkillsetStandardPreference = __webpack_require__(917);
	var ClassShelfPreference = __webpack_require__(903);
	var SoundPreference = __webpack_require__(918);
	var QuizScoringPreference = __webpack_require__(914);
	var QuestionCustomizer = __webpack_require__(891);
	var ClozeCustomizer = __webpack_require__(412);
	var SpeechControlsPreference = __webpack_require__(919);
	
	var WritingDeletionPreference = __webpack_require__(921);
	var LogReadingPreferences = __webpack_require__(906);
	var OwlShopPreference = __webpack_require__(908);
	var SchoolYearMonthsPreference = __webpack_require__(245);
	var ZPDPreferences = __webpack_require__(922);
	var InformationPreferences = __webpack_require__(904);
	var PaymentPreferences = __webpack_require__(909);
	var PlanPreferences = __webpack_require__(910);
	var ClozeCustomizer = __webpack_require__(412);
	var ReferralPreference = __webpack_require__(916);
	var QuestionBuilderPreferences = __webpack_require__(912);
	var UpgradeCodeTablePreference = __webpack_require__(920);
	var LinkAccountsPreferences = __webpack_require__(905);
	var MergeAccountsPreferences = __webpack_require__(907);
	var QuizLimitPreference = __webpack_require__(913);
	
	var RosteringMethodPreference = __webpack_require__(812);
	var ActivationCodesPreferences = __webpack_require__(810);
	var GeneralOrgPreferences = __webpack_require__(811);
	var SchoolContestPreference = __webpack_require__(813);
	
	__webpack_require__(3778);
	
	var Preferences = function (_React$Component) {
		_inherits(Preferences, _React$Component);
	
		function Preferences(props) {
			_classCallCheck(this, Preferences);
	
			var _this = _possibleConstructorReturn(this, (Preferences.__proto__ || Object.getPrototypeOf(Preferences)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false
			};
			return _this;
		}
	
		_createClass(Preferences, [{
			key: "render",
			value: function render() {
				if (this.props.type == Preferences.QUIZ_SCORING) {
					var preferenceContent = React.createElement(QuizScoringPreference, null);
				} else if (this.props.type == Preferences.DISPLAY_CLASS_SHELF) {
					var preferenceContent = React.createElement(ClassShelfPreference, null);
				} else if (this.props.type == Preferences.SKILLSET_CUSTOMIZER) {
					var preferenceContent = React.createElement(SkillsetStandardPreference, null);
				} else if (this.props.type == Preferences.QUESTION_CUSTOMIZER) {
					var preferenceContent = React.createElement(QuestionCustomizer, null);
				} else if (this.props.type == Preferences.CLOZE_CUSTOMIZER) {
					var preferenceContent = React.createElement(ClozeCustomizer, null);
				} else if (this.props.type == Preferences.SPEECH_CONTROLS) {
					var preferenceContent = React.createElement(SpeechControlsPreference, null);
				} else if (this.props.type == Preferences.SCHOOL_YEAR) {
					var preferenceContent = React.createElement(SchoolYearMonthsPreference, null);
				} else if (this.props.type == Preferences.SOUND_OPTION) {
					var preferenceContent = React.createElement(SoundPreference, null);
				} else if (this.props.type == Preferences.ALLOW_STUDENT_WRITING_DELETION) {
					var preferenceContent = React.createElement(WritingDeletionPreference, null);
				} else if (this.props.type == Preferences.BACK_LOG_DATE_PERIOD) {
					var preferenceContent = React.createElement(LogReadingPreferences, null);
				} else if (this.props.type == Preferences.OWL_SHOP) {
					var preferenceContent = React.createElement(OwlShopPreference, null);
				} else if (this.props.type == Preferences.ZPD) {
					var preferenceContent = React.createElement(ZPDPreferences, null);
				} else if (this.props.type == Preferences.INFORMATION) {
					var preferenceContent = React.createElement(InformationPreferences, null);
				} else if (this.props.type == Preferences.PAYMENT) {
					var preferenceContent = React.createElement(PaymentPreferences, { billingHistory: this.props.billingHistory });
				} else if (this.props.type == Preferences.PLAN) {
					var preferenceContent = React.createElement(PlanPreferences, null);
				} else if (this.props.type == Preferences.READING_LEVEL) {
					var preferenceContent = React.createElement(ClozeCustomizer, null);
				} else if (this.props.type == Preferences.REFERRAL) {
					var preferenceContent = React.createElement(ReferralPreference, null);
				} else if (this.props.type == Preferences.ALLOW_STUDENT_QUESTION_BUILDER) {
					var preferenceContent = React.createElement(QuestionBuilderPreferences, null);
				} else if (this.props.type == Preferences.CODE_TABLE) {
					var preferenceContent = React.createElement(UpgradeCodeTablePreference, null);
				} else if (this.props.type == Preferences.LINK_ACCOUNTS) {
					var preferenceContent = React.createElement(LinkAccountsPreferences, null);
				} else if (this.props.type == Preferences.MERGE_USERS) {
					var preferenceContent = React.createElement(MergeAccountsPreferences, null);
				} else if (this.props.type == Preferences.QUIZ_LIMIT) {
					var preferenceContent = React.createElement(QuizLimitPreference, null);
				} else if (this.props.type == Preferences.ROSTERING_METHOD) {
					var preferenceContent = React.createElement(RosteringMethodPreference, null);
				} else if (this.props.type == Preferences.ACTIVATION_CODES) {
					var preferenceContent = React.createElement(ActivationCodesPreferences, null);
				} else if (this.props.type == Preferences.GENERAL_ORG_SETTINGS) {
					var preferenceContent = React.createElement(GeneralOrgPreferences, null);
				} else if (this.props.type == Preferences.SCHOOL_CONTEST) {
					var preferenceContent = React.createElement(SchoolContestPreference, null);
				}
	
				return React.createElement(
					"div",
					{ className: "preferenceContainer" },
					preferenceContent
				);
			}
		}]);
	
		return Preferences;
	}(React.Component);
	
	;
	
	Preferences.ALLOW_STUDENT_WRITING_DELETION = "AllowStudentWritingDeletion";
	Preferences.BACK_LOG_DATE_PERIOD = "BackLogDatePeriod";
	Preferences.QUIZ_SCORING = "QuizScoring";
	Preferences.DISPLAY_CLASS_SHELF = "DisplayClassNewsShelf";
	Preferences.SCHOOL_YEAR = "SchoolYear";
	Preferences.SOUND_OPTION = "Sound";
	Preferences.SKILLSET_CUSTOMIZER = "SkillsetsStandards";
	Preferences.QUESTION_CUSTOMIZER = "QuestionCustomizer";
	Preferences.SPEECH_CONTROLS = "SpeechControls";
	Preferences.CLOZE_CUSTOMIZER = "ClozeCustomizer";
	Preferences.LOG_BACK_DATING_PERIOD = "LogBackDatingPeriod";
	Preferences.OWL_SHOP = "OwlShop";
	Preferences.ZPD = "zpd";
	Preferences.INFORMATION = "Information";
	Preferences.PAYMENT = "Payment";
	Preferences.PLAN = "Plan";
	Preferences.READING_LEVEL = "Reading Level";
	Preferences.REFERRAL = "Referral";
	Preferences.ALLOW_STUDENT_QUESTION_BUILDER = "displayQuestionBuilder";
	Preferences.LINK_ACCOUNTS = "Link Accounts";
	Preferences.MERGE_USERS = "Merge Users";
	
	// ORG SETUP CHECKLIST
	Preferences.ROSTERING_METHOD = "Rostering Method";
	Preferences.ACTIVATION_CODES = "Activation Codes";
	Preferences.GENERAL_ORG_SETTINGS = "General Settings";
	Preferences.CODE_TABLE = "Code Table";
	Preferences.SCHOOL_CONTEST = "School Contest";
	
	Preferences.propTypes = StrictPropTypes({
		type: PropTypes.string.isRequired,
		classShelfDisplaySetting: PropTypes.bool,
		billingHistory: PropTypes.array,
		onChange: PropTypes.func
	});
	
	module.exports = Preferences;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var Skillsets = __webpack_require__(55);
	var ReactTooltip = __webpack_require__(12);
	var LoadingButton = __webpack_require__(17);
	var BookSearchModal = __webpack_require__(401);
	var ValidatingInput = __webpack_require__(91);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3779);
	
	var QuestionCustomizer = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var prefs = RosterSelectors.globalStudentListPrefs({ state: state });
		return {
			preferTeacherPracticeQuestions: prefs.prefer_teacher_practice_questions
		};
	}, function (dispatch, props) {
		return {
			onChange: function onChange(prefsUpdate, message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAllStudentListPrefs({
					currentUserID: CurrentUser.get().id,
					update: prefsUpdate
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(QuestionCustomizer, _React$Component);
	
		function QuestionCustomizer(props) {
			_classCallCheck(this, QuestionCustomizer);
	
			var _this = _possibleConstructorReturn(this, (QuestionCustomizer.__proto__ || Object.getPrototypeOf(QuestionCustomizer)).call(this));
	
			autobind(_this);
			_this.state = {
				questions: null, addingQuestion: false,
				selectedQuestionType: ALL_TEXTS, selectedBook: null,
				loading: false, editingID: null
			};
			LuckyOrangeClient.tagComponent("QuestionCustomizer");
			return _this;
		}
	
		_createClass(QuestionCustomizer, [{
			key: "toggleAddingQuestion",
			value: function toggleAddingQuestion(e) {
				$wr.nope(e);
				this.setState({ addingQuestion: !this.state.addingQuestion,
					selectedQuestionType: ALL_TEXTS, selectedBook: null });
			}
		}, {
			key: "toggleEditingQuestion",
			value: function toggleEditingQuestion(questionID) {
				if (this.state.editingID == questionID) {
					this.setState({ editingID: null });
				} else {
					this.setState({ editingID: questionID });
				}
			}
		}, {
			key: "selectQuestionType",
			value: function selectQuestionType(questionType) {
				if (questionType == SPECIFIC_TEXT) {
					this.refs.bookSearchModal.show();
				} else {
					this.setState({ selectedQuestionType: questionType, selectedBook: null });
	
					if (this.refs.skillsetDropdown != undefined) {
						var skillsetHasFiction = Skillsets.hasFiction(this.refs.skillsetDropdown.val());
						var skillsetHasNonFiction = Skillsets.hasNonFiction(this.refs.skillsetDropdown.val());
	
						if (!skillsetHasFiction && questionType == ALL_FICTION_TEXTS) {
							this.refs.skillsetDropdown.reset();
						}
	
						if (!skillsetHasNonFiction && questionType == ALL_NONFICTION_TEXTS) {
							this.refs.skillsetDropdown.reset();
						}
					}
				}
			}
		}, {
			key: "onSelectSkillset",
			value: function onSelectSkillset() {
				var questionOptions = this.getQuestionOptions();
				if (!_.includes(questionOptions, this.state.selectedQuestionType)) {
					this.setState({ selectedQuestionType: questionOptions[0].value });
				}
			}
		}, {
			key: "getQuestionOptions",
			value: function getQuestionOptions() {
				return [{ value: ALL_TEXTS, label: ALL_TEXTS }, { value: ALL_FICTION_TEXTS, label: ALL_FICTION_TEXTS }, { value: ALL_NONFICTION_TEXTS, label: ALL_NONFICTION_TEXTS }, { value: SPECIFIC_TEXT, label: SPECIFIC_TEXT }];
			}
		}, {
			key: "onQuestionBookSelect",
			value: function onQuestionBookSelect(book) {
				var bookTitle = book.title.substring(0, 30);
				var ellipsis = bookTitle == book.title ? "" : "...";
				var questionTypeText = "For: " + bookTitle + ellipsis;
				this.setState({ selectedBook: book, selectedQuestionType: questionTypeText });
				this.refs.bookSearchModal.hide();
			}
		}, {
			key: "submitNewQuestion",
			value: function submitNewQuestion(e) {
				$wr.nope(e);
	
				if (this.refs.questionBody.validate() & this.refs.skillsetDropdown.validate()) {
					var questionData = { body: this.refs.questionBody.val(), skillset: this.refs.skillsetDropdown.val() };
					// may allow this to be customized later, for now set to all grade levels
					questionData.grade_levels = "0,1,2,3,4,5,6,7,8";
	
					if (this.state.selectedBook) {
						questionData.type = "text-specific-question";
						questionData.text_id = this.state.selectedBook.text_id;
						// to ensure the student sees the question, even though we know the text_variety
						questionData.text_variety = "fiction-and-non-fiction";
					} else {
						var selectedQuestionType = this.state.selectedQuestionType;
						questionData.type = "generic-question";
						if (selectedQuestionType == ALL_NONFICTION_TEXTS) {
							questionData.text_variety = "non-fiction";
						} else if (selectedQuestionType == ALL_FICTION_TEXTS) {
							questionData.text_variety = "fiction";
						} else {
							questionData.text_variety = "fiction-and-non-fiction";
						}
					}
					CurrentUser.api().postQuestions({ question: questionData }, $wr.apiHandler(function (response) {
						var newQuestion = response.question;
						if (this.state.selectedBook) {
							newQuestion.text = this.state.selectedBook;
						}
						var questionArray = _.clone(this.state.questions || []);
						questionArray.push(newQuestion);
						this.setState({ questions: questionArray }, this.toggleAddingQuestion);
					}.bind(this)));
				}
			}
		}, {
			key: "submitEditedQuestion",
			value: function submitEditedQuestion(e) {
				$wr.nope(e);
	
				var editedQuestion = _.find(this.state.questions, function (question) {
					return question.id == this.state.editingID;
				}.bind(this));
	
				if (this.refs.editedQuestionBody.val() != editedQuestion.body && this.refs.editedQuestionBody.validate()) {
					var questionData = { body: this.refs.editedQuestionBody.val() };
					CurrentUser.api().patchQuestion(editedQuestion.id, { question: questionData }, $wr.apiHandler(function (response) {
						var questionArray = _.map(this.state.questions, function (question) {
							if (question.id == editedQuestion.id) {
								question.body = response.question.body;
							}
							return question;
						});
						this.setState({ questions: questionArray });
						this.toggleEditingQuestion(editedQuestion.id);
					}.bind(this)));
				}
			}
		}, {
			key: "deleteQuestion",
			value: function deleteQuestion(questionID, e) {
				if (this.state.questions.length == 1 && this.refs.toggleQuestions.checked) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Oops!", text: "You need at least one question if you want to use only your questions in Practice Questions.",
						icon: "exclamation-sign", type: "error"
					});
				} else if (confirm("Are you sure you want to delete this question?")) {
					CurrentUser.api().deleteQuestion(questionID, $wr.apiHandler(function (response) {
						var questionArray = _.clone(this.state.questions).filter(function (question) {
							return question.id != questionID;
						});
						this.setState({ questions: questionArray });
						this.toggleEditingQuestion(questionID);
					}.bind(this)));
				}
			}
		}, {
			key: "toggleCustomizableQuestionPreference",
			value: function toggleCustomizableQuestionPreference() {
	
				var preferenceHash = {
					prefer_teacher_practice_questions: !this.props.preferTeacherPracticeQuestions
				};
				this.props.onChange(preferenceHash, "You successfully changed your custom questions preference.");
			}
		}, {
			key: "render",
			value: function render() {
				var headerContent = React.createElement(
					"p",
					null,
					"Add and edit your own questions for students to answer in ",
					React.createElement(
						"i",
						null,
						"Practice Questions"
					),
					"."
				);
	
				if (this.state.questions == null) {
					return React.createElement(
						"div",
						{ className: "questionCustomizerContainer" },
						headerContent,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				if (this.state.questions.length > 0) {
					var existingQuestionsContent = _.map(this.state.questions, function (question) {
						if (this.state.editingID == question.id) {
							var questionDisplay = React.createElement(
								"form",
								{ className: "editQuestionForm", onSubmit: this.submitEditedQuestion },
								React.createElement(ValidatingInput, { type: "textarea", ref: "editedQuestionBody",
									defaultValue: question.body,
									validators: ValidatingInput.Validators.PRESENT,
									inputClassName: "form-control" }),
								React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.state.loading,
									text: "Save" }),
								React.createElement(
									"a",
									{ className: "cancelLink", href: "#",
										onClick: this.toggleEditingQuestion.bind(this, question.id) },
									"Cancel"
								),
								React.createElement(
									"a",
									{ className: "deleteLink", href: "#",
										onClick: this.deleteQuestion.bind(this, question.id) },
									"Delete Question"
								)
							);
						} else {
							if (question.text) {
								var textTitleDisplay = React.createElement(
									"span",
									{ className: "textTitle" },
									"For ",
									question.text.title,
									":",
									React.createElement("span", { className: "spacer1" })
								);
							}
							var questionDisplay = React.createElement(
								"div",
								{ className: "existingQuestion" },
								React.createElement("img", { src: Skillsets.getIcon(question.skillset),
									"data-tip": Skillsets.getName(question.skillset) }),
								React.createElement(
									"p",
									{ onClick: this.toggleEditingQuestion.bind(this, question.id) },
									textTitleDisplay,
									question.body,
									React.createElement(Glyphicon, { icon: "pencil", className: "editQuestionIcon" })
								)
							);
						}
	
						return React.createElement(
							"div",
							{ key: question.id },
							questionDisplay
						);
					}.bind(this));
				}
	
				if (this.state.addingQuestion || this.state.questions.length == 0) {
					var questionType = this.state.selectedQuestionType;
	
					var limitSkillsetsFiction = questionType == ALL_FICTION_TEXTS || questionType == SPECIFIC_TEXT && this.state.selectedBook.text_variety == "fiction";
					var limitSkillsetsNonFiction = questionType == ALL_NONFICTION_TEXTS || questionType == SPECIFIC_TEXT && this.state.selectedBook.text_variety == "non-fiction";
	
					if (limitSkillsetsFiction) {
						var skillsetOptions = DropDownOptions.Button.Skillsets({ fictionOnly: true, readingOnly: true });
					} else if (limitSkillsetsNonFiction) {
						var skillsetOptions = DropDownOptions.Button.Skillsets({ nonFictionOnly: true, readingOnly: true });
					} else {
						var skillsetOptions = DropDownOptions.Button.Skillsets({ readingOnly: true });
					}
	
					var questionTypes = this.getQuestionOptions();
	
					var questionTypeOptions = questionTypes.map(function (option) {
						var text = option.label;
						var clickedType = function () {
							this.selectQuestionType(option.label);
						}.bind(this);
						return React.createElement(ButtonDropdownOption, { onClick: clickedType, text: text,
							key: option.value });
					}.bind(this));
	
					var bookSearchModal = React.createElement(BookSearchModal, { ref: "bookSearchModal", onBookSelect: this.onQuestionBookSelect });
	
					var newQuestionContent = React.createElement(
						"div",
						null,
						React.createElement(
							"form",
							{ className: "newQuestionForm", onSubmit: this.submitNewQuestion },
							React.createElement(ValidatingInput, { type: "textarea", ref: "questionBody",
								validators: ValidatingInput.Validators.PRESENT,
								inputClassName: "form-control",
								placeholder: "Your new question..." }),
							React.createElement(
								"div",
								{ className: "controls" },
								React.createElement(ValidatingInput, { type: "button-dropdown", defaultText: "Choose Skillset",
									validators: ValidatingInput.Validators.PRESENT,
									errorMessage: "Please select a skill set",
									selectOptions: skillsetOptions, ref: "skillsetDropdown",
									className: "skillsetDropdown", onChange: this.onSelectSkillset }),
								React.createElement(
									ButtonDropdown,
									{ text: questionType, dropdownDisplay: "link" },
									questionTypeOptions
								),
								React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.state.loading,
									text: "Save" }),
								React.createElement(
									"a",
									{ className: "cancelLink", href: "#", onClick: this.toggleAddingQuestion },
									"Cancel"
								)
							)
						),
						bookSearchModal
					);
				} else {
					var newQuestionContent = React.createElement(
						"a",
						{ className: "newQuestionLink", href: "#", onClick: this.toggleAddingQuestion },
						React.createElement(Glyphicon, { icon: "plus" }),
						React.createElement("span", { className: "spacer1" }),
						"New Question"
					);
				}
	
				if (this.state.questions.length > 0) {
					var customQuestionsToggle = React.createElement(
						"label",
						{ className: "customQuestionsToggle" },
						React.createElement("input", { type: "checkbox", ref: "toggleQuestions",
							checked: this.props.preferTeacherPracticeQuestions,
							onChange: this.toggleCustomizableQuestionPreference }),
						React.createElement(
							"span",
							{ className: "defaultLink" },
							"Use only my custom questions, when applicable, in ",
							React.createElement(
								"em",
								null,
								"Practice Questions"
							),
							"."
						)
					);
				}
	
				return React.createElement(
					"div",
					{ className: "questionCustomizerContainer" },
					headerContent,
					existingQuestionsContent,
					newQuestionContent,
					customQuestionsToggle,
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var params = {
					user_id: CurrentUser.get().id, user_id_only: true, per_page: 1000,
					embed: "question.text",
					types: "generic-question,text-specific-question"
				};
				CurrentUser.api().getQuestions(params, $wr.apiHandler(function (response) {
					this.setState({ questions: _.sortBy(response.questions, "created_at") });
				}.bind(this)));
			}
		}]);
	
		return QuestionCustomizer;
	}(React.Component)) || _class);
	
	
	QuestionCustomizer.WrappedComponent.propTypes = StrictPropTypes({
		preferTeacherPracticeQuestions: PropTypes.bool,
		onChange: PropTypes.func.isRequired
	});
	
	var ALL_TEXTS = 'For All Texts';
	var ALL_FICTION_TEXTS = 'For All Fiction Texts';
	var ALL_NONFICTION_TEXTS = 'For All Nonfiction Texts';
	var SPECIFIC_TEXT = 'For A Specific Text';
	
	module.exports = QuestionCustomizer;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ErrorDisplay = __webpack_require__(51);
	var CurrentUser = __webpack_require__(3);
	var DisplayToggleControl = __webpack_require__(48);
	var Preferences = __webpack_require__(890);
	var AccountCustomizer = __webpack_require__(888);
	var Features = __webpack_require__(16);
	var AccountPlans = __webpack_require__(53);
	var SettingsRouting = __webpack_require__(443);
	
	__webpack_require__(3780);
	var SettingsPage = (_dec = (0, _LocationState.provideLocationState)(SettingsRouting.getRouteState), _dec(_class = function (_React$Component) {
		_inherits(SettingsPage, _React$Component);
	
		function SettingsPage(props) {
			_classCallCheck(this, SettingsPage);
	
			var _this = _possibleConstructorReturn(this, (SettingsPage.__proto__ || Object.getPrototypeOf(SettingsPage)).call(this));
	
			autobind(_this);
			_this.state = {};
			LuckyOrangeClient.tagComponent("SettingsPage");
			return _this;
		}
	
		_createClass(SettingsPage, [{
			key: "fetchBillingHistory",
			value: function fetchBillingHistory() {
				var _this2 = this;
	
				CurrentUser.api().getUser(CurrentUser.get().id, { embed: "user.billing_history" }, function (response) {
					_this2.setState({ billingHistory: response.user.billing_history || [] });
				});
			}
		}, {
			key: "onViewChange",
			value: function onViewChange(view) {
				this.changeView({ activeView: view });
				if ($wr.capitalize(view) == Preferences.PAYMENT) {
					this.fetchBillingHistory();
				}
			}
		}, {
			key: "changeView",
			value: function changeView(update) {
				var newLocationState = _.extend({}, this.props.locationState, update);
				$wr.redirect(SettingsRouting.getPath(newLocationState));
			}
		}, {
			key: "selectPreference",
			value: function selectPreference(preference) {
				this.onViewChange(preference);
			}
		}, {
			key: "getPreferenceName",
			value: function getPreferenceName(preference) {
				if (preference == SKILLSET_CUSTOMIZER) {
					return Preferences.SKILLSET_CUSTOMIZER;
				} else if (preference == DISPLAY_CLASS_SHELF) {
					return Preferences.DISPLAY_CLASS_SHELF;
				} else if (preference == QUIZ_SCORING) {
					return Preferences.QUIZ_SCORING;
				} else if (preference == BACK_LOG_DATE_PERIOD) {
					return Preferences.BACK_LOG_DATE_PERIOD;
				} else if (preference == ALLOW_STUDENT_WRITING_DELETION) {
					return Preferences.ALLOW_STUDENT_WRITING_DELETION;
				} else if (preference == QUESTION_CUSTOMIZER) {
					return Preferences.QUESTION_CUSTOMIZER;
				} else if (preference == SPEECH_CONTROLS) {
					return Preferences.SPEECH_CONTROLS;
				} else if (preference == SCHOOL_YEAR) {
					return Preferences.SCHOOL_YEAR;
				} else if (preference == SOUND_OPTION) {
					return Preferences.SOUND_OPTION;
				} else if (preference == OWL_SHOP) {
					return Preferences.OWL_SHOP;
				} else if (preference == INFORMATION) {
					return Preferences.INFORMATION;
				} else if (preference == PAYMENT) {
					return Preferences.PAYMENT;
				} else if (preference == PLAN) {
					return Preferences.PLAN;
				} else if (preference == ZPD) {
					return Preferences.ZPD;
				} else if (preference == REFERRAL) {
					return Preferences.REFERRAL;
				} else if (preference == ALLOW_STUDENT_QUESTION_BUILDER) {
					return Preferences.ALLOW_STUDENT_QUESTION_BUILDER;
				} else if (preference == CODE_TABLE) {
					return Preferences.CODE_TABLE;
				} else if (preference == LINK_ACCOUNTS) {
					return Preferences.LINK_ACCOUNTS;
				} else if (preference == QUIZ_LIMIT) {
					return Preferences.QUIZ_LIMIT;
				} else if (preference == ROSTERING_METHOD) {
					return Preferences.ROSTERING_METHOD;
				} else if (preference == ACTIVATION_CODES) {
					return Preferences.ACTIVATION_CODES;
				} else if (preference == GENERAL_ORG_SETTINGS) {
					return Preferences.GENERAL_ORG_SETTINGS;
				} else if (preference == MERGE_USERS) {
					return Preferences.MERGE_USERS;
				} else if (preference == SCHOOL_CONTEST) {
					return Preferences.SCHOOL_CONTEST;
				}
			}
		}, {
			key: "getSubHeaderName",
			value: function getSubHeaderName(preference) {
				if (preference == INFORMATION || preference == QUIZ_SCORING || preference == SKILLSET_CUSTOMIZER || preference == QUESTION_CUSTOMIZER || preference == SOUND_OPTION) {
					return preference;
				} else if (preference == BACK_LOG_DATE_PERIOD) {
					return "Log Reading";
				} else if (preference == PLAN) {
					return "Status";
				} else if (preference == ALLOW_STUDENT_WRITING_DELETION) {
					return "Delete Writing";
				} else if (preference == SPEECH_CONTROLS) {
					return "Voice Options";
				} else if (preference == SCHOOL_YEAR) {
					return "School Year";
				} else if (preference == OWL_SHOP) {
					return "Owl Shop Hours";
				} else if (preference == ZPD) {
					return "Reading Level";
				} else if (preference == PAYMENT) {
					return "Billing";
				} else if (preference == DISPLAY_CLASS_SHELF) {
					return "Class Shelf";
				} else if (preference == REFERRAL) {
					return "Referrals";
				} else if (preference == ALLOW_STUDENT_QUESTION_BUILDER) {
					return "Question Builder";
				} else if (preference == CODE_TABLE) {
					return "Setup Progress";
				} else if (preference == LINK_ACCOUNTS) {
					return "Link Accounts";
				} else if (preference == QUIZ_LIMIT) {
					return "Quiz Hours";
				} else if (preference == ROSTERING_METHOD) {
					return "Rostering Method";
				} else if (preference == ACTIVATION_CODES) {
					return "Activation Codes";
				} else if (preference == GENERAL_ORG_SETTINGS) {
					if (CurrentUser.isTeacherAdmin()) {
						return "Expecations";
					} else {
						return "General Settings";
					}
				} else if (preference == MERGE_USERS) {
					return "Merge Users";
				} else if (preference == SCHOOL_CONTEST) {
					return "School Contest";
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				if (!this.props.locationState.activeView) {
					this.changeView({ activeView: INFORMATION });
				}
			}
		}, {
			key: "preferenceClassName",
			value: function preferenceClassName(preference) {
				return this.props.locationState.activeView == preference ? "selected" : "";
			}
		}, {
			key: "renderAccountSection",
			value: function renderAccountSection() {
				var activeView = this.props.locationState.activeView;
	
	
				var merge = React.createElement(
					"a",
					{ onClick: this.selectPreference.bind(this, MERGE_USERS),
						className: this.preferenceClassName(MERGE_USERS) },
					"Merge Users"
				);
	
				var link = React.createElement(
					"a",
					{ onClick: this.selectPreference.bind(this, LINK_ACCOUNTS),
						className: this.preferenceClassName(LINK_ACCOUNTS) },
					"Link Accounts"
				);
	
				if (CurrentUser.isTeacherAdmin()) {
					if (CurrentUser.isPayingUser()) {
						var billingHistory = React.createElement(
							"a",
							{ onClick: this.selectPreference.bind(this, PAYMENT),
								className: this.preferenceClassName(PAYMENT) },
							"Billing"
						);
					} else {
						var billingHistory = null;
					}
					var plan = React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, PLAN),
							className: this.preferenceClassName(PLAN) },
						"Status"
					);
				}
				return React.createElement(
					"div",
					{ className: "linksGroup" },
					React.createElement(
						"p",
						null,
						"Account"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, INFORMATION),
							className: this.preferenceClassName(INFORMATION) },
						"Information"
					),
					CurrentUser.isTeacherAdmin() ? React.createElement(
						"div",
						null,
						billingHistory,
						plan,
						link,
						merge
					) : React.createElement(
						"div",
						null,
						link
					)
				);
			}
		}, {
			key: "renderOrgSection",
			value: function renderOrgSection() {
				var orgLabel = null;
	
				if (CurrentUser.isSchoolAdmin()) {
					orgLabel = "School";
				} else if (CurrentUser.isDistrictAdmin()) {
					orgLabel = "District";
				}
	
				if (!orgLabel) {
					return;
				}
	
				var activeView = this.props.locationState.activeView;
	
				return React.createElement(
					"div",
					{ className: "linksGroup" },
					React.createElement(
						"p",
						null,
						orgLabel
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, GENERAL_ORG_SETTINGS),
							className: this.preferenceClassName(GENERAL_ORG_SETTINGS) },
						"General Settings"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, ROSTERING_METHOD),
							className: this.preferenceClassName(ROSTERING_METHOD) },
						"Rostering Method"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, ACTIVATION_CODES),
							className: this.preferenceClassName(ACTIVATION_CODES) },
						"Activation Codes"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, CODE_TABLE),
							className: this.preferenceClassName(CODE_TABLE) },
						"Setup Progress"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, SCHOOL_CONTEST),
							className: this.preferenceClassName(SCHOOL_CONTEST) },
						"School Contest"
					)
				);
			}
		}, {
			key: "renderContentSection",
			value: function renderContentSection() {
				if (!CurrentUser.isTeacherAdmin()) {
					return;
				}
	
				var activeView = this.props.locationState.activeView;
	
				return React.createElement(
					"div",
					{ className: "linksGroup" },
					React.createElement(
						"p",
						null,
						"Content"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, QUESTION_CUSTOMIZER),
							className: this.preferenceClassName(QUESTION_CUSTOMIZER) },
						"Questions"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, ZPD),
							className: this.preferenceClassName(ZPD) },
						"Reading Level"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, SKILLSET_CUSTOMIZER),
							className: this.preferenceClassName(SKILLSET_CUSTOMIZER) },
						"Standards"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, ALLOW_STUDENT_QUESTION_BUILDER),
							className: this.preferenceClassName(ALLOW_STUDENT_QUESTION_BUILDER) },
						"Question Builder"
					)
				);
			}
		}, {
			key: "renderStudentsSection",
			value: function renderStudentsSection() {
				if (!CurrentUser.isTeacherAdmin()) {
					return;
				}
	
				var activeView = this.props.locationState.activeView;
	
				return React.createElement(
					"div",
					{ className: "linksGroup" },
					React.createElement(
						"p",
						null,
						"Students"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, DISPLAY_CLASS_SHELF),
							className: this.preferenceClassName(DISPLAY_CLASS_SHELF) },
						"Class Shelf"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, ALLOW_STUDENT_WRITING_DELETION),
							className: this.preferenceClassName(ALLOW_STUDENT_WRITING_DELETION) },
						"Delete Writing"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, BACK_LOG_DATE_PERIOD),
							className: this.preferenceClassName(BACK_LOG_DATE_PERIOD) },
						"Log Reading"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, QUIZ_LIMIT),
							className: this.preferenceClassName(QUIZ_LIMIT) },
						"Quiz Hours"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, OWL_SHOP),
							className: this.preferenceClassName(OWL_SHOP) },
						"Owl Shop Hours"
					)
				);
			}
		}, {
			key: "renderSystemSection",
			value: function renderSystemSection() {
				if (!CurrentUser.isTeacherAdmin()) {
					return;
				}
	
				var activeView = this.props.locationState.activeView;
	
				return React.createElement(
					"div",
					{ className: "linksGroup" },
					React.createElement(
						"p",
						null,
						"System"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, GENERAL_ORG_SETTINGS),
							className: this.preferenceClassName(GENERAL_ORG_SETTINGS) },
						"Expectations"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, QUIZ_SCORING),
							className: this.preferenceClassName(QUIZ_SCORING) },
						"Scoring"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, SOUND_OPTION),
							className: this.preferenceClassName(SOUND_OPTION) },
						"Sounds"
					),
					React.createElement(
						"a",
						{ onClick: this.selectPreference.bind(this, SPEECH_CONTROLS),
							className: this.preferenceClassName(SPEECH_CONTROLS) },
						"Voice Options"
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var activeView = this.props.locationState.activeView;
	
	
				var accountSettingsLinks = React.createElement(
					"div",
					{ className: "linksSection" },
					this.renderAccountSection(),
					this.renderOrgSection(),
					this.renderContentSection(),
					this.renderStudentsSection(),
					this.renderSystemSection()
				);
				var header = React.createElement(
					"header",
					{ className: "pageHeader" },
					React.createElement(
						"h1",
						null,
						this.getSubHeaderName(activeView)
					)
				);
	
				var currentViewContent = React.createElement(
					"div",
					{ className: "accountSettingsSection clearfix" },
					accountSettingsLinks,
					React.createElement(
						"div",
						{ className: "preferenceArea" },
						header,
						React.createElement(Preferences, { type: this.getPreferenceName(activeView), billingHistory: this.state.billingHistory })
					)
				);
	
				var pageContent = React.createElement(
					"div",
					{ className: "" },
					React.createElement(ErrorDisplay, { ref: "errors" }),
					currentViewContent
				);
	
				return React.createElement(
					"div",
					{ className: "settingsPage container" },
					pageContent
				);
			}
		}]);
	
		return SettingsPage;
	}(React.Component)) || _class);
	
	
	var INFORMATION = "information";
	var PAYMENT = "payment";
	var PLAN = "plan";
	var REFERRAL = "referral";
	var QUESTION_CUSTOMIZER = "questions";
	var ZPD = "reading-level";
	var SKILLSET_CUSTOMIZER = "standards";
	var DISPLAY_CLASS_SHELF = "class-shelf";
	var ALLOW_STUDENT_WRITING_DELETION = "delete-writing";
	var BACK_LOG_DATE_PERIOD = "log-reading";
	var QUIZ_LIMIT = "quiz-limit";
	var OWL_SHOP = "owl-shop";
	var SCHOOL_YEAR = "school-year";
	var QUIZ_SCORING = "scoring";
	var SOUND_OPTION = "sounds";
	var SPEECH_CONTROLS = "voice-options";
	var ALLOW_STUDENT_QUESTION_BUILDER = "quesion-builder";
	var LINK_ACCOUNTS = "link-accounts";
	var MERGE_USERS = "merge-users";
	
	// ORG SETUP CHECKLIST
	var ROSTERING_METHOD = "rostering-method";
	var ACTIVATION_CODES = "activation-codes";
	var GENERAL_ORG_SETTINGS = "general_org_settings";
	var CODE_TABLE = "code-table";
	var SCHOOL_CONTEST = "school-contest";
	
	SettingsPage.propTypes = PageStrictPropTypes({});
	
	module.exports = SettingsPage;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var OnboardingModal = __webpack_require__(415);
	var OnboardingChecklist = __webpack_require__(166);
	var TrialStatusDisplay = __webpack_require__(417);
	var OverdrawnAccountNotice = __webpack_require__(246);
	var GradeLevel = __webpack_require__(40);
	
	var TeacherDigestContainer = __webpack_require__(747);
	var WidgetContainer = __webpack_require__(189);
	
	__webpack_require__(3781);
	
	var TeacherHomePage = function (_React$Component) {
		_inherits(TeacherHomePage, _React$Component);
	
		function TeacherHomePage(props) {
			_classCallCheck(this, TeacherHomePage);
	
			var _this = _possibleConstructorReturn(this, (TeacherHomePage.__proto__ || Object.getPrototypeOf(TeacherHomePage)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("TeacherHomePage");
			_this.state = {
				admin: null,
				showOnboardingModal: false, skipOnboarding: false
			};
			return _this;
		}
	
		_createClass(TeacherHomePage, [{
			key: "onViewChange",
			value: function onViewChange(view) {
				this.setState({ currentView: view });
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.showOnboardingModal) {
					var track = "quiz-customization";
					var onboardingModal = React.createElement(OnboardingModal, { track: track });
				}
	
				var currentUser = CurrentUser.get();
	
				var activeTrials = currentUser.account.active_trials;
				var expiredTrials = currentUser.account.expired_trials;
				var allTrials = _.extend({}, activeTrials, expiredTrials);
	
				if (currentUser && currentUser.account && _.any(allTrials)) {
					var trialDisplay = React.createElement(TrialStatusDisplay, { trials: allTrials });
				}
	
				if (this.state.admin) {
					if (this.state.admin.account_overdrawn) {
						var overdrawnDisplay = React.createElement(OverdrawnAccountNotice, { source: "dashboard" });
					}
				}
	
				var onboardingChecklist = React.createElement(OnboardingChecklist, null);
				var digestContainer = React.createElement(TeacherDigestContainer, null);
	
				return React.createElement(
					"div",
					{ className: "container", id: "teacherHomePage" },
					onboardingChecklist,
					React.createElement(
						"header",
						{ className: "pageHeader hideOnPrint" },
						React.createElement(
							"h1",
							null,
							" Teacher Dashboard "
						)
					),
					overdrawnDisplay,
					trialDisplay,
					digestContainer,
					onboardingModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.fetchAdminData();
				$(window.document).on("expectations-updated", this.onExectationsUpdate);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				$(window.document).off("expectations-updated", this.onExectationsUpdate);
			}
		}, {
			key: "onExectationsUpdate",
			value: function onExectationsUpdate() {
				this.setState({ admin: null }, this.fetchAdminData);
			}
		}, {
			key: "fetchAdminData",
			value: function fetchAdminData() {
				var _this2 = this;
	
				var embeds = ["admin.account_overdrawn"];
				CurrentUser.api().getAdmin(this.props.match.params.id, { embed: embeds }, $wr.apiHandler(function (response) {
					var pendingOnboarding = response.admin.role == "teacherRole" && response.admin.pending_onboarding;
	
					_this2.setState({ admin: response.admin, showOnboardingModal: pendingOnboarding });
				}));
			}
		}]);
	
		return TeacherHomePage;
	}(React.Component);
	
	TeacherHomePage.propTypes = PageStrictPropTypes({
		userIDs: PropTypes.array
	});
	
	TeacherHomePage.SCHOOL_YEAR = 'School Year';
	TeacherHomePage.LAST_WEEK = 'Last 7 Days';
	TeacherHomePage.LAST_MONTH = 'Last 30 Days';
	TeacherHomePage.CUSTOM_DATES = 'Custom Dates';
	
	module.exports = TeacherHomePage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var TeacherOnboarding = __webpack_require__(435);
	
	__webpack_require__(3774);
	
	var OnboardingChecklistItem = function (_React$Component) {
		_inherits(OnboardingChecklistItem, _React$Component);
	
		function OnboardingChecklistItem(props) {
			_classCallCheck(this, OnboardingChecklistItem);
	
			var _this = _possibleConstructorReturn(this, (OnboardingChecklistItem.__proto__ || Object.getPrototypeOf(OnboardingChecklistItem)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(OnboardingChecklistItem, [{
			key: "doItNow",
			value: function doItNow(e) {
				if (this.alreadyclicked) {
					return "";
				} else {
					this.alreadyclicked = true;
					TeacherOnboarding.doIt(this.props.itemKey);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var itemKey = this.props.itemKey;
	
				if (this.props.isComplete) {
					var itemClassName = "complete";
					var itemImgPath = dynamicRequire("onboarding/icons/" + TeacherOnboarding.getImgPath(itemKey) + ".png");
					var callToAction = React.createElement(
						"div",
						{ className: "completeText" },
						"Done!"
					);
				} else {
					var itemClassName = "incomplete";
					if (this.props.isNext) {
						itemClassName += " next";
					}
					if (this.props.hideActionLink) {
						var status = React.createElement(
							"div",
							null,
							CurrentUser.get().completed_quiz_count,
							" / 100 "
						);
					} else {
						var action = this.doItNow;
						var callToAction = React.createElement(
							"div",
							null,
							React.createElement(
								"a",
								{ onClick: action },
								"Do it Now"
							)
						);
					}
					var itemImgPath = dynamicRequire("onboarding/icons/" + TeacherOnboarding.getImgPath(itemKey) + "-gray.png");
				}
	
				return React.createElement(
					"div",
					{ className: "onboardingChecklistItem " + itemClassName, onClick: action },
					React.createElement(
						"div",
						{ className: "imageSection" },
						React.createElement("img", { src: itemImgPath, alt: itemKey, className: "itemImg" })
					),
					React.createElement(
						"div",
						{ className: "infoSection" },
						React.createElement(
							"div",
							null,
							TeacherOnboarding.getTitle(itemKey)
						),
						callToAction,
						status
					)
				);
			}
		}]);
	
		return OnboardingChecklistItem;
	}(React.Component);
	
	OnboardingChecklistItem.propTypes = StrictPropTypes({
		itemKey: PropTypes.string.isRequired,
		isComplete: PropTypes.bool.isRequired,
		isNext: PropTypes.bool,
		hideActionLink: PropTypes.bool
	});
	
	module.exports = OnboardingChecklistItem;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactCircularProgressbar = __webpack_require__(623);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var OnboardingProgressDisplay = function (_React$Component) {
		_inherits(OnboardingProgressDisplay, _React$Component);
	
		function OnboardingProgressDisplay(props) {
			_classCallCheck(this, OnboardingProgressDisplay);
	
			var _this = _possibleConstructorReturn(this, (OnboardingProgressDisplay.__proto__ || Object.getPrototypeOf(OnboardingProgressDisplay)).call(this));
	
			autobind(_this);
	
			_this.state = {};
			return _this;
		}
	
		_createClass(OnboardingProgressDisplay, [{
			key: "render",
			value: function render() {
				var progress = this.props.current / this.props.total;
				var percent = Math.round(progress * 100);
				var imgPath = __webpack_require__(299);
	
				return React.createElement(
					"div",
					{ className: "circleContainer" },
					React.createElement(
						_reactCircularProgressbar.CircularProgressbarWithChildren,
						{ value: percent, className: "largeCircle",
							circleRatio: 0.75,
							styles: {
								trail: {
									strokeLinecap: 'butt',
									transform: 'rotate(-135deg)',
									transformOrigin: 'center center'
								},
								path: {
									strokeLinecap: 'butt',
									transform: 'rotate(-135deg)',
									transformOrigin: 'center center'
								} } },
						React.createElement(
							"div",
							{ className: "infoContainer" },
							React.createElement("img", { src: imgPath, alt: "owlfonso", className: "progressImg" }),
							React.createElement(
								"p",
								{ className: "currentContainer" },
								percent,
								"%"
							)
						)
					)
				);
			}
	
			// componentDidMount() {
			// }
	
		}]);
	
		return OnboardingProgressDisplay;
	}(React.Component);
	
	OnboardingProgressDisplay.propTypes = StrictPropTypes({
		metric: PropTypes.string,
		title: PropTypes.string,
		unit: PropTypes.string,
		current: PropTypes.number,
		total: PropTypes.number,
		actionLabel: PropTypes.string
	});
	
	module.exports = OnboardingProgressDisplay;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutograderDemo = __webpack_require__(428);
	
	var OnboardingStageAutograderDemo = function (_React$Component) {
		_inherits(OnboardingStageAutograderDemo, _React$Component);
	
		function OnboardingStageAutograderDemo(props) {
			_classCallCheck(this, OnboardingStageAutograderDemo);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageAutograderDemo.__proto__ || Object.getPrototypeOf(OnboardingStageAutograderDemo)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("OnboardingStageAutograderDemo");
			return _this;
		}
	
		_createClass(OnboardingStageAutograderDemo, [{
			key: "renderSetButton",
			value: function renderSetButton() {
				return React.createElement(
					"div",
					{ className: "text-right nextStage" },
					React.createElement(
						"button",
						{ className: "btn buttonPrimary setButton",
							onClick: this.props.onComplete },
						"Next"
					)
				);
			}
		}, {
			key: "renderAutograderDemo",
			value: function renderAutograderDemo() {
				return React.createElement(AutograderDemo, null);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageAutograderDemo clearfix" },
					this.renderAutograderDemo(),
					this.renderSetButton()
				);
			}
		}]);
	
		return OnboardingStageAutograderDemo;
	}(React.Component);
	
	OnboardingStageAutograderDemo.propTypes = StrictPropTypes({});
	
	module.exports = OnboardingStageAutograderDemo;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _OPTIONS, _FREE_OPTIONS;
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var QuizCustomization = __webpack_require__(434);
	
	var DropDownOptions = __webpack_require__(26);
	var Glyphicon = __webpack_require__(8);
	
	var RosterActions = __webpack_require__(11);
	
	var OnboardingStageCustomizeQuiz = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return { "premiumAccount": CurrentUser.isPremiumAccount() };
	}, function (dispatch, props) {
		return {
	
			onChange: function onChange(update) {
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					update: update
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(OnboardingStageCustomizeQuiz, _React$Component);
	
		function OnboardingStageCustomizeQuiz(props) {
			_classCallCheck(this, OnboardingStageCustomizeQuiz);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageCustomizeQuiz.__proto__ || Object.getPrototypeOf(OnboardingStageCustomizeQuiz)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("OnboardingStageCustomizeQuiz");
			_this.initState(props);
			return _this;
		}
	
		_createClass(OnboardingStageCustomizeQuiz, [{
			key: "initState",
			value: function initState(props) {
				var selectedComposition = props.premiumAccount ? MIXED_QUIZ : MEDIUM;
				this.state = {
					selectedComposition: selectedComposition,
					selectedFrequency: "month",
					selectedQuizCount: 1,
					questionsCount: 1,
					frequencyStarts: [1]
				};
			}
		}, {
			key: "useSentenceStarters",
			value: function useSentenceStarters() {
				var gradeLevel = parseInt(CurrentUser.get().grade_level);
				if (Number.isNaN(gradeLevel)) {
					gradeLevel = 1;
				}
	
				return gradeLevel < 5;
			}
		}, {
			key: "getCurrentComposition",
			value: function getCurrentComposition() {
				if (this.props.premiumAccount) {
					var options = OPTIONS;
				} else {
					var options = FREE_OPTIONS;
				}
				var base = _.clone(options[this.state.selectedComposition]);
	
				if (this.useSentenceStarters()) {
					// K-4th start with sentence starters
					base.starter_count = base.open_count;
					base.open_count = 0;
				}
	
				return base;
			}
		}, {
			key: "getQuizMetrics",
			value: function getQuizMetrics(prefs) {
				var _this2 = this;
	
				if (prefs && prefs.expectations_metrics) {
					var hasMetric = false;
					var newMetrics = _.map(prefs.expectations_metrics, function (metric) {
						if (metric.metric == "quizzes-passed") {
							metric.goal = parseInt(_this2.state.selectedQuizCount);
						} else if (metric.metric == "questions") {
							// Also use this amount for practice question default 
							metric.goal = parseInt(_this2.state.questionsCount);
						}
						return metric;
					});
				} else {
					var newMetrics = [{
						metric: "quizzes-passed", goal: parseInt(this.state.selectedQuizCount)
					}];
				}
				return newMetrics;
			}
		}, {
			key: "createGradeLevelPrefHash",
			value: function createGradeLevelPrefHash() {
				var _this3 = this;
	
				var settings = this.getCurrentComposition();
				var grade_level_expectations_metrics = {};
				var grade_level_question_count = {};
				var settings = this.getCurrentComposition();
				ALL_GRADES.map(function (gl) {
					grade_level_expectations_metrics[gl] = [{ metric: "quizzes-passed", "goal": parseInt(_this3.state.selectedQuizCount) }, { metric: "questions", goal: 3 }];
					grade_level_question_count[gl] = {
						recall_question_count: parseInt(settings.fitb_count),
						analysis_question_count: parseInt(settings.open_count),
						sentence_starter_count: parseInt(settings.starter_count)
					};
				});
	
				return {
					expectations_time_period: this.state.selectedFrequency,
					expectations_time_period_starts: this.state.frequencyStarts,
					grade_level_expectations_metrics: grade_level_expectations_metrics,
					grade_level_question_count: grade_level_question_count,
					speech_controls: settings.speech_controls
				};
			}
		}, {
			key: "submitSettings",
			value: function submitSettings() {
				var settingsData = this.createGradeLevelPrefHash();
				this.props.onChange(settingsData);
				this.props.onComplete();
				Mycroft.newEvent({ category: "Onboarding", action: "quiz-customized" });
				Mycroft.newEvent({ category: "Mode", action: "selected-questions-amount" });
			}
		}, {
			key: "skipToNextStage",
			value: function skipToNextStage() {
				this.props.onComplete();
				Mycroft.newEvent({ category: "Onboarding", action: "skipped-quiz-customization" });
			}
	
			////////// QUIZ FREQUENCY
	
		}, {
			key: "onQuizCountChange",
			value: function onQuizCountChange() {
				var value = this.refs.quiz_count.value;
				this.setState({ selectedQuizCount: value });
			}
		}, {
			key: "onQuestionsCount",
			value: function onQuestionsCount() {
				var value = this.refs.questions_count.value;
				this.setState({ questionsCount: value });
			}
		}, {
			key: "setQuizComposition",
			value: function setQuizComposition(val) {
				this.setState({ selectedComposition: val });
			}
		}, {
			key: "onExpectationPeriod",
			value: function onExpectationPeriod() {
				var timePeriod = this.refs.expectation_period.value;
				if (timePeriod == $wr.Constants.PERIODS.WEEK) {
					var defaultPeriodStart = [0];
				} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
					var defaultPeriodStart = [1];
				} else {
					var startMonth = CurrentUser.get().prefs.school_year_start_month;
					var currentYear = new Date().getFullYear();
					var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];
	
					if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
					} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
					} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
						defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
					}
				}
				this.setState({ selectedFrequency: timePeriod, frequencyStarts: defaultPeriodStart });
			}
		}, {
			key: "renderFrequencyOption",
			value: function renderFrequencyOption() {
				var options = [];
				for (var i = 1; i < 21; i++) {
					options.push(React.createElement(
						"option",
						{ value: i, key: i },
						i
					));
				}
				if (this.props.persistentData.literacy_intention) {
					var bookNoun = $wr.pluralize("book", this.state.selectedQuizCount, "books");
					var quizzesDropdown = React.createElement(
						"div",
						null,
						React.createElement(
							"select",
							{ type: "text", className: "form-control quizCount", ref: "quiz_count",
								defaultValue: 1, onChange: this.onQuizCountChange },
							options
						),
						React.createElement(
							"p",
							null,
							bookNoun
						)
					);
					var title = React.createElement(
						"p",
						{ className: "categoryTitle" },
						"While students are reading books, they will practice standard-aligned literacy skills by responding to questions that deepen their text engagement."
					);
					var questionNoun = $wr.pluralize("question", this.state.questionsCount, "questions");
					var questionsDropdown = React.createElement(
						"div",
						{ className: "questionsContainer" },
						React.createElement(
							"p",
							{ className: "questionsText" },
							"How many questions will your students answer?"
						),
						React.createElement(
							"select",
							{ type: "text", className: "form-control quizCount", ref: "questions_count",
								defaultValue: 1, onChange: this.onQuestionsCount },
							options
						),
						React.createElement(
							"p",
							null,
							questionNoun
						)
					);
					var text = React.createElement(
						"p",
						null,
						"How many books will your students read (quizzes completed)?"
					);
					var frequency = React.createElement(
						"div",
						{ className: "frequencyContainer" },
						React.createElement(
							"p",
							{ className: "frequencyText" },
							"How often will your students read books and answer questions?"
						),
						React.createElement(
							"p",
							null,
							this.state.selectedQuizCount,
							" ",
							bookNoun,
							" ",
							this.state.questionsCount,
							" ",
							questionNoun,
							" per "
						),
						React.createElement(
							"select",
							{ type: "text", className: "form-control quizFrenquency", ref: "expectation_period",
								value: this.state.selectedFrequency, onChange: this.onExpectationPeriod },
							DropDownOptions.Select.ExpectationPeriods({ filter: [$wr.Constants.PERIODS.ALLTIME] })
						)
					);
				} else {
					var noun = $wr.pluralize("quiz", this.state.selectedQuizCount, "quizzes");
					var quizzesDropdown = React.createElement(
						"div",
						null,
						React.createElement(
							"select",
							{ type: "text", className: "form-control quizCount", ref: "quiz_count",
								defaultValue: 1, onChange: this.onQuizCountChange },
							options
						),
						React.createElement(
							"p",
							null,
							noun,
							" per"
						),
						React.createElement(
							"select",
							{ type: "text", className: "form-control quizFrenquency", ref: "expectation_period",
								value: this.state.selectedFrequency, onChange: this.onExpectationPeriod },
							DropDownOptions.Select.ExpectationPeriods({ filter: [$wr.Constants.PERIODS.ALLTIME] })
						)
					);
					var title = React.createElement(
						"p",
						{ className: "categoryTitle" },
						"After your students read books, they take quizzes about them on Whooo's Reading. How often do you want your students to take quizzes?"
					);
				}
				return React.createElement(
					"div",
					{ className: "settingContainer" },
					title,
					React.createElement(
						"div",
						{ className: "selectContainer" },
						text,
						quizzesDropdown,
						questionsDropdown,
						frequency
					)
				);
			}
		}, {
			key: "renderPremiumCompositionSection",
			value: function renderPremiumCompositionSection() {
				var _this4 = this;
	
				var options = _.map(OPTIONS, function (option, optionKey) {
					var className = "largeObject clickableElement";
					if (_this4.state.selectedComposition == optionKey) {
						className += " selected";
					}
	
					var duration = QuizCustomization.quizDuration(option.fitb_count, option.open_count || option.starter_count, _this4.useSentenceStarters());
	
					var parts = [];
					if (option.fitb_count) {
						parts.push(option.fitb_count + " fill-in-the-blank");
					}
					if (option.open_count || option.starter_count) {
						parts.push((option.open_count || option.starter_count) + " open");
					}
					var compText = parts.join(", ");
	
					return React.createElement(
						"div",
						{ key: optionKey, className: className,
							onClick: _this4.setQuizComposition.bind(_this4, optionKey) },
						React.createElement(
							"div",
							{ className: "opTitle" },
							option.title
						),
						React.createElement(
							"div",
							{ className: "comp" },
							compText
						),
						React.createElement(
							"div",
							{ className: "time" },
							duration,
							" minutes"
						)
					);
				});
				return React.createElement(
					"div",
					{ className: "settingContainer" },
					React.createElement(
						"p",
						{ className: "categoryTitle" },
						"Quizzes have a mix of \"fill-in-the-blank\" and \"open-ended\" questions. What balance do you want?"
					),
					React.createElement(
						"div",
						{ className: "options" },
						options
					),
					this.renderTextVarietyImgs()
				);
			}
		}, {
			key: "renderFreeCompositionSection",
			value: function renderFreeCompositionSection() {
				var _this5 = this;
	
				var options = _.map(FREE_OPTIONS, function (option, optionKey) {
					var className = "largeObject clickableElement";
					if (_this5.state.selectedComposition == optionKey) {
						className += " selected";
					}
	
					var duration = QuizCustomization.quizDuration(option.fitb_count, option.open_count || option.starter_count, _this5.useSentenceStarters());
	
					var parts = [];
					if (option.open_count || option.starter_count) {
						parts.push((option.open_count || option.starter_count) + " open");
					}
					var compText = parts.join(", ");
	
					return React.createElement(
						"div",
						{ key: optionKey, className: className,
							onClick: _this5.setQuizComposition.bind(_this5, optionKey) },
						React.createElement(
							"div",
							{ className: "opTitle" },
							option.title
						),
						React.createElement(
							"div",
							{ className: "comp" },
							compText
						),
						React.createElement(
							"div",
							{ className: "time" },
							duration,
							" minutes"
						)
					);
				});
				return React.createElement(
					"div",
					{ className: "settingContainer" },
					React.createElement(
						"p",
						{ className: "categoryTitle" },
						"How many Open-Ended Questions do you want on quizzes?"
					),
					React.createElement(
						"div",
						{ className: "options" },
						options
					),
					this.renderTextVarietyImgs(),
					React.createElement(
						"div",
						{ className: "disclaimerContainer" },
						React.createElement("br", null),
						React.createElement(
							"i",
							null,
							" Fill-in-the-Blank Questions are available through our Gold and Silver plans, or our Silver Trial."
						)
					)
				);
			}
	
			////////// QUIZ COMPOSITION
	
		}, {
			key: "renderCompositionSection",
			value: function renderCompositionSection() {
				// If the user is a premium account, they should be shown
				// option for FITBs. If not, they should be only shown OEQ count.
				if (this.props.premiumAccount) {
					var section = this.renderPremiumCompositionSection();
				} else {
					var section = this.renderFreeCompositionSection();
				}
	
				return section;
			}
		}, {
			key: "renderTextVarietyImgs",
			value: function renderTextVarietyImgs() {
				var recallImgPath = "onboarding/onboarding-fill-in-only.png";
				var analysisImgPath = "onboarding/onboarding-short-answer-in-only.png";
	
				var recallOpacity = 1.0;
				var analysisOpacity = 1.0;
				var recallIcon = "ok";
				var analysisIcon = "ok";
	
				var settings = this.getCurrentComposition();
	
				if (!(settings.open_count || settings.starter_count)) {
					analysisOpacity = 0.4;
					analysisIcon = "remove";
				}
				if (!settings.fitb_count) {
					recallOpacity = 0.4;
					recallIcon = "remove";
				}
	
				return React.createElement(
					"div",
					{ className: "textVarietyImg" },
					React.createElement(
						"div",
						{ className: "imgContainer row" },
						React.createElement(
							"div",
							{ className: "col-sm-6", style: { opacity: recallOpacity } },
							React.createElement(
								"div",
								{ className: "text-center description" },
								React.createElement(Glyphicon, { icon: recallIcon }),
								" Fill-in-the-Blank Question"
							),
							React.createElement("img", { src: dynamicRequire(recallImgPath), className: "formatImg" })
						),
						React.createElement(
							"div",
							{ className: "col-sm-6", style: { opacity: analysisOpacity } },
							React.createElement(
								"div",
								{ className: "text-center description" },
								React.createElement(Glyphicon, { icon: analysisIcon }),
								" Open-Ended Question"
							),
							React.createElement("img", { src: dynamicRequire(analysisImgPath), className: "formatImg" })
						)
					)
				);
			}
	
			////////// CONFIRM ACTIONS
	
		}, {
			key: "renderSetButton",
			value: function renderSetButton() {
				return React.createElement(
					"div",
					{ className: "text-right nextStage" },
					React.createElement(
						"button",
						{ className: "btn btn-link setButton",
							onClick: this.skipToNextStage },
						"Skip"
					),
					React.createElement(
						"button",
						{ className: "btn buttonPrimary setButton",
							onClick: this.submitSettings },
						"Next"
					),
					React.createElement(
						"div",
						{ className: "changeLater" },
						"You can always change this later."
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageCustomizeQuiz clearfix" },
					this.renderFrequencyOption(),
					this.renderCompositionSection(),
					this.renderSetButton()
				);
			}
		}]);
	
		return OnboardingStageCustomizeQuiz;
	}(React.Component)) || _class);
	
	
	var OPEN_QUIZ = "2-open-only";
	var MIXED_QUIZ = "3-mixed";
	var ADVANCED_QUIZ = "4-advanced";
	
	var OPTIONS = (_OPTIONS = {}, _defineProperty(_OPTIONS, OPEN_QUIZ, {
		title: "Open-ended only",
		fitb_count: 0,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _defineProperty(_OPTIONS, MIXED_QUIZ, {
		title: "Mixed quiz",
		fitb_count: 2,
		open_count: 1,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _defineProperty(_OPTIONS, ADVANCED_QUIZ, {
		title: "Advanced quiz",
		fitb_count: 3,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _OPTIONS);
	
	var SHORT = '1-open';
	var MEDIUM = '2-open';
	var LONG = '3-open';
	
	var FREE_OPTIONS = (_FREE_OPTIONS = {}, _defineProperty(_FREE_OPTIONS, SHORT, {
		title: "One open ended",
		fitb_count: 0,
		open_count: 1,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _defineProperty(_FREE_OPTIONS, MEDIUM, {
		title: "Two open ended",
		fitb_count: 0,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _defineProperty(_FREE_OPTIONS, LONG, {
		title: "Three open ended",
		fitb_count: 0,
		open_count: 3,
		starter_count: 0 // Replaced by open_count based on grade level
	}), _FREE_OPTIONS);
	
	var ALL_GRADES = ["-1", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Mixed"];
	
	OnboardingStageCustomizeQuiz.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		onChange: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageCustomizeQuiz;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookDisplay = __webpack_require__(46);
	var CurrentUser = __webpack_require__(3);
	var GradeLevel = __webpack_require__(40);
	var RecentQuizzesDisplayData = __webpack_require__(3526);
	var Features = __webpack_require__(16);
	
	var AnimateOwl = __webpack_require__(437);
	var Owlvatar = __webpack_require__(115);
	var OnboardingAvatarData = __webpack_require__(3530);
	
	var OnboardingStageGenericCompletion = function (_React$Component) {
		_inherits(OnboardingStageGenericCompletion, _React$Component);
	
		function OnboardingStageGenericCompletion(props) {
			_classCallCheck(this, OnboardingStageGenericCompletion);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageGenericCompletion.__proto__ || Object.getPrototypeOf(OnboardingStageGenericCompletion)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(OnboardingStageGenericCompletion, [{
			key: "render",
			value: function render() {
				var completionText = "You will get automatic quiz grades, but your students will only get positive reinforcement.";
				var nextStepsText = "Add your students now to hold them accountable for their independent reading in a better way!";
				var buttonText = "Add Students";
				var buttonPath = "/roster?addNewStudentsButton=true";
	
				var leftContent = React.createElement(
					"span",
					{ ref: "avatar", className: "studentOwlvatar" },
					React.createElement(Owlvatar, { maxWidth: 200, maxHeight: 200,
						patches: OnboardingAvatarData.patches,
						colors: OnboardingAvatarData.colors })
				);
	
				var actionsContent = React.createElement(
					"div",
					{ className: "actionsContainer" },
					React.createElement(
						_reactRouterDom.Link,
						{ className: "btn buttonPrimary newStudentsButton", to: buttonPath },
						React.createElement(
							"span",
							{ className: "newTaskText" },
							buttonText
						)
					)
				);
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageGenericCompletion" },
					React.createElement(
						"div",
						{ className: "leftCol" },
						leftContent
					),
					React.createElement(
						"div",
						{ className: "rightCol completionSection" },
						React.createElement(
							"p",
							{ className: "completionActionContainer" },
							React.createElement(
								"span",
								{ className: "completionText" },
								completionText,
								React.createElement("br", null),
								React.createElement("br", null),
								nextStepsText
							)
						),
						actionsContent
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				AnimateOwl.dance_controller(100, $(this.refs.avatar), 1);
			}
		}]);
	
		return OnboardingStageGenericCompletion;
	}(React.Component);
	
	OnboardingStageGenericCompletion.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		endOnboarding: PropTypes.func.isRequired,
		onComplete: PropTypes.func.isRequired,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageGenericCompletion;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var GradeLevel = __webpack_require__(40);
	var CurrentUser = __webpack_require__(3);
	var Glyphicon = __webpack_require__(8);
	var UpgradeTokenForm = __webpack_require__(167);
	
	var OnboardingStageGenericGradeLevel = function (_React$Component) {
		_inherits(OnboardingStageGenericGradeLevel, _React$Component);
	
		function OnboardingStageGenericGradeLevel(props) {
			_classCallCheck(this, OnboardingStageGenericGradeLevel);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageGenericGradeLevel.__proto__ || Object.getPrototypeOf(OnboardingStageGenericGradeLevel)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(OnboardingStageGenericGradeLevel, [{
			key: "buildOnGradeSelectF",
			value: function buildOnGradeSelectF(gradeLevel) {
				var _this2 = this;
	
				return function () {
					var adminID = CurrentUser.get().id;
					var adminData = { grade_level: gradeLevel };
					CurrentUser.api().patchAdmin(adminID, { admin: adminData }, $wr.apiHandler(function (response) {
						CurrentUser.fetchCurrentUserData();
					}));
	
					_this2.props.onComplete({ gradeLevel: gradeLevel });
	
					Mycroft.newEvent({ category: "Onboarding", action: "grade-selected" });
				};
			}
		}, {
			key: "skipUpgradeCode",
			value: function skipUpgradeCode() {}
		}, {
			key: "render",
			value: function render() {
				var leftContent = React.createElement(
					"div",
					{ className: "onboardingTestimonial" },
					React.createElement("img", { className: "educatorImg", src: __webpack_require__(527) }),
					React.createElement(
						"p",
						{ className: "educatorInfo" },
						"Amy Talvac | 3rd Grade Teacher"
					),
					React.createElement(
						"div",
						{ className: "quote" },
						React.createElement("img", { className: "quoteImg", src: __webpack_require__(529) }),
						React.createElement(
							"p",
							{ className: "quoteText" },
							"In my class, students are required to read for 20 minutes each day as a part of their daily homework. Whooo's Reading makes it easy for me to check on each student's progress."
						)
					)
				);
	
				var gradeOptions = DropDownOptions.Button.Grades({
					buildOptionF: this.buildOnGradeSelectF
				});
	
				var gradeLevelDropdown = React.createElement(
					ButtonDropdown,
					{ text: "Choose", dropdownDisplay: "button",
						className: "gradePicker", buttonClassName: "buttonPrimary" },
					gradeOptions
				);
	
				if (CurrentUser.get().product == "wrSolo") {
	
					var instructionsTitle = 'Upgrade or Referral Code:';
					var instructions = 'If you have an upgrade or referral code already, enter it. Otherwise, you can enter one later.';
	
					var upgradeForm = React.createElement(
						"div",
						{ className: "subStage" },
						React.createElement(
							"p",
							{ className: "onboardingInstructions" },
							React.createElement(
								"span",
								{ className: "instructionTitle" },
								instructionsTitle
							),
							instructions
						),
						React.createElement(UpgradeTokenForm, { updateInPlace: true })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageGenericGradeLevel clearfix" },
					React.createElement(
						"div",
						{ className: "leftCol" },
						leftContent
					),
					React.createElement(
						"div",
						{ className: "gradeSelection rightCol" },
						React.createElement(
							"p",
							{ className: "onboardingGreeting" },
							"Thank you for signing up!"
						),
						upgradeForm,
						React.createElement(
							"div",
							{ className: "subStage" },
							React.createElement(
								"p",
								{ className: "onboardingInstructions" },
								React.createElement(
									"span",
									{ className: "instructionTitle" },
									"Grade Level:"
								),
								"Align Whooo's Reading to the right level. Pick one of the grades you teach."
							),
							gradeLevelDropdown,
							React.createElement(
								"p",
								{ className: "onboardingInstructions" },
								"If you teach multiple grade levels, don't worry! You can pick different grades for your students when you add them later."
							)
						)
					)
				);
			}
		}]);
	
		return OnboardingStageGenericGradeLevel;
	}(React.Component);
	
	OnboardingStageGenericGradeLevel.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageGenericGradeLevel;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var OnboardingStageSelectFeatures = function (_React$Component) {
		_inherits(OnboardingStageSelectFeatures, _React$Component);
	
		function OnboardingStageSelectFeatures(props) {
			_classCallCheck(this, OnboardingStageSelectFeatures);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageSelectFeatures.__proto__ || Object.getPrototypeOf(OnboardingStageSelectFeatures)).call(this));
	
			autobind(_this);
			_this.state = {
				selectedFeatures: [], orderedFeatureKeys: _.shuffle(FEATURE_OPTIONS)
			};
			return _this;
		}
	
		_createClass(OnboardingStageSelectFeatures, [{
			key: "toggleFeature",
			value: function toggleFeature(featureKey) {
				var newFeatures = this.state.selectedFeatures;
				if (_.includes(newFeatures, featureKey)) {
					newFeatures = _.without(newFeatures, featureKey);
				} else {
					newFeatures.push(featureKey);
				}
	
				this.setState({ selectedFeatures: newFeatures });
			}
		}, {
			key: "submitFeatures",
			value: function submitFeatures() {
				var adminID = CurrentUser.get().id;
				var featuresData = { feature_overrides: this.state.selectedFeatures.join(",") };
				var params = { admin: featuresData };
				CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function (response) {
					CurrentUser.fetchCurrentUserData();
				}));
				this.props.onComplete(featuresData);
				Mycroft.newEvent({ category: "Onboarding", action: "features-selected" });
			}
		}, {
			key: "featureDescription",
			value: function featureDescription(featureKey) {
				if (featureKey == BOOK_REVIEWS) {
					return "Share book reviews";
				} else if (featureKey == CRITICAL_THINKING) {
					return "Practice critical thinking";
				} else if (featureKey == DAILY_READING) {
					return "Monitor daily reading";
				} else if (featureKey == TRACK_GOALS) {
					return "Track ELA goals";
				} else if (featureKey == WHO_READ) {
					return "Know who's reading";
				} else if (featureKey == WRITING_SKILLS) {
					return "Practice writing skills";
				}
			}
		}, {
			key: "renderFeatureOption",
			value: function renderFeatureOption(featureKey) {
				var featureImagePath = "onboarding/" + featureKey + ".png";
	
				var className = "largeObject clickableElement";
				if (_.includes(this.state.selectedFeatures, featureKey)) {
					className += " selectedFeature";
				}
	
				return React.createElement(
					"div",
					{ className: className, key: featureKey,
						onClick: this.toggleFeature.bind(this, featureKey) },
					React.createElement(
						"div",
						{ className: "featureObjectContent" },
						React.createElement("img", { src: dynamicRequire(featureImagePath), className: "featureImg" }),
						React.createElement(
							"div",
							{ className: "featureDesc" },
							this.featureDescription(featureKey)
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var featureObjects = _.map(this.state.orderedFeatureKeys, function (featureKey) {
					return _this2.renderFeatureOption(featureKey);
				});
				var featureOptions = React.createElement(
					"div",
					{ className: "featureOptions" },
					featureObjects
				);
	
				var mainContent = React.createElement(
					"div",
					{ className: "singleCol" },
					React.createElement(
						"p",
						{ className: "onboardingGreeting" },
						"What would you like to do with Whooo's Reading?"
					),
					React.createElement(
						"p",
						{ className: "onboardingInstructions" },
						React.createElement(
							"span",
							{ className: "instructionTitle" },
							"This is just to get you started. You can always do more later."
						)
					)
				);
	
				if (this.state.selectedFeatures.length > 0) {
					var submitButton = React.createElement(
						"button",
						{ className: "btn buttonPrimary", onClick: this.submitFeatures },
						"All Set"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageSelectFeatures clearfix" },
					mainContent,
					featureOptions,
					submitButton
				);
			}
		}]);
	
		return OnboardingStageSelectFeatures;
	}(React.Component);
	
	var BOOK_REVIEWS = "onboarding-book-reviews";
	var CRITICAL_THINKING = "onboarding-critical-thinking";
	var DAILY_READING = "onboarding-daily-reading";
	var TRACK_GOALS = "onboarding-track-goals";
	var WHO_READ = "onboarding-who-read";
	var WRITING_SKILLS = "onboarding-writing-skills";
	
	var FEATURE_OPTIONS = [BOOK_REVIEWS, CRITICAL_THINKING, DAILY_READING, TRACK_GOALS, WHO_READ, WRITING_SKILLS];
	
	OnboardingStageSelectFeatures.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageSelectFeatures;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var OnboardingStageSelectQuizFormat = function (_React$Component) {
		_inherits(OnboardingStageSelectQuizFormat, _React$Component);
	
		function OnboardingStageSelectQuizFormat(props) {
			_classCallCheck(this, OnboardingStageSelectQuizFormat);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageSelectQuizFormat.__proto__ || Object.getPrototypeOf(OnboardingStageSelectQuizFormat)).call(this));
	
			autobind(_this);
			var selectedFormat = null;
			_this.state = {
				selectedFormat: selectedFormat, orderedFormatOptions: _.shuffle(FORMAT_OPTIONS)
			};
			return _this;
		}
	
		_createClass(OnboardingStageSelectQuizFormat, [{
			key: "toggleFeature",
			value: function toggleFeature(selectedFormat) {
				this.setState({ selectedFormat: selectedFormat });
			}
		}, {
			key: "submitFeatures",
			value: function submitFeatures() {
				var adminID = CurrentUser.get().id;
				var featuresData = { feature_overrides: this.state.selectedFormat };
				var params = { admin: featuresData };
				CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function (response) {
					CurrentUser.fetchCurrentUserData();
				}));
				this.props.onComplete(featuresData);
				Mycroft.newEvent({ category: "Onboarding", action: "format-selected" });
			}
		}, {
			key: "featureTitle",
			value: function featureTitle(featureKey) {
				if (featureKey == FILL_IN_ONLY) {
					return "Fill-in-the-blank questions only";
				} else if (featureKey == SHORT_ANSWER_ONLY) {
					return "Short response questions only";
				} else if (featureKey == FILL_IN_AND_SHORT_ANSWER) {
					return "Both fill-in-the-blank and short response questions";
				}
			}
		}, {
			key: "renderFormatOption",
			value: function renderFormatOption(formatKey) {
				var featureImagePath = "onboarding/" + formatKey + ".png";
	
				var className = "largeObject clickableElement";
				if (this.state.selectedFormat == formatKey) {
					className += " selectedFormat";
				}
				// Hacky, but I can't be bothered to do better for a test
				if (formatKey != FILL_IN_AND_SHORT_ANSWER) {
					className += " push";
				}
	
				return React.createElement(
					"div",
					{ className: className, key: formatKey,
						onClick: this.toggleFeature.bind(this, formatKey) },
					this.featureTitle(formatKey)
				);
			}
		}, {
			key: "renderSelectedImage",
			value: function renderSelectedImage() {
				var featureImagePath = "onboarding/" + this.state.selectedFormat + ".png";
	
				return React.createElement("img", { src: dynamicRequire(featureImagePath), className: "formatImg" });
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var formatObjects = _.map(this.state.orderedFormatOptions, function (featureKey) {
					return _this2.renderFormatOption(featureKey);
				});
				var formatOptions = React.createElement(
					"div",
					{ className: "formatOptions" },
					formatObjects
				);
	
				var mainContent = React.createElement(
					"div",
					{ className: "singleCol" },
					React.createElement(
						"p",
						{ className: "onboardingGreeting" },
						"What kinds of questions would you like on your reading quizzes?"
					),
					React.createElement(
						"p",
						{ className: "onboardingInstructions" },
						React.createElement(
							"span",
							{ className: "instructionTitle" },
							"You can always change this later."
						)
					)
				);
	
				if (this.state.selectedFormat != null) {
					var selectedImage = this.renderSelectedImage();
					var submitButton = React.createElement(
						"button",
						{ className: "btn buttonPrimary confirmFormat",
							onClick: this.submitFeatures },
						"All Set"
					);
				}
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageSelectQuizFormat clearfix" },
					mainContent,
					formatOptions,
					selectedImage,
					submitButton
				);
			}
		}]);
	
		return OnboardingStageSelectQuizFormat;
	}(React.Component);
	
	var FILL_IN_ONLY = "onboarding-fill-in-only";
	var SHORT_ANSWER_ONLY = "onboarding-short-answer-in-only";
	var FILL_IN_AND_SHORT_ANSWER = "onboarding-fill-in-and-short-answer";
	
	var FORMAT_OPTIONS = [FILL_IN_ONLY, SHORT_ANSWER_ONLY, FILL_IN_AND_SHORT_ANSWER];
	
	OnboardingStageSelectQuizFormat.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageSelectQuizFormat;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var AltSkillsets = __webpack_require__(200);
	var GradeLevel = __webpack_require__(40);
	
	var OnboardingStageSelectStandards = function (_React$Component) {
		_inherits(OnboardingStageSelectStandards, _React$Component);
	
		function OnboardingStageSelectStandards(props) {
			_classCallCheck(this, OnboardingStageSelectStandards);
	
			var _this = _possibleConstructorReturn(this, (OnboardingStageSelectStandards.__proto__ || Object.getPrototypeOf(OnboardingStageSelectStandards)).call(this));
	
			autobind(_this);
			_this.state = {
				selectedStandard: null, selectedLiteracyMode: false
			};
			return _this;
		}
	
		_createClass(OnboardingStageSelectStandards, [{
			key: "buildOnStandardsSelectF",
			value: function buildOnStandardsSelectF(standardKey) {
				return function () {
					var adminID = CurrentUser.get().id;
					var standardData = { skillset_standard: standardKey, literacy_intention: this.state.selectedLiteracyMode };
					var params = { admin: { prefs: standardData }, global: true };
					CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function (response) {
						CurrentUser.fetchCurrentUserData();
						$(window.document).trigger("onboarding-trigger-select-standards");
					}));
					this.props.onComplete({ skillsetStandard: standardKey, literacy_intention: this.state.selectedLiteracyMode });
					Mycroft.newEvent({ category: "Onboarding", action: "standards-selected" });
				}.bind(this);
			}
		}, {
			key: "getShortGradeLevelRec",
			value: function getShortGradeLevelRec() {
				var grade = Number(CurrentUser.get().grade_level);
				if (grade < 4) {
					var recText = "Check out the text-to-voice and voice-to-text option for students who aren't yet reading or typing!";
				} else {
					var recText = "Have your students do practice questions while reading longer books to prepare for the quiz!";
				}
				return recText;
			}
		}, {
			key: "onSelectModeType",
			value: function onSelectModeType(modeType) {
				if (modeType == LITERACY_MODE) {
					this.setState({ selectedLiteracyMode: true });
					Mycroft.newEvent({ category: "Mode", action: "selected-literacy-mode" });
				} else {
					this.setState({ selectedLiteracyMode: false });
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (CurrentUser.get().grade_level != "unknown grade") {
					var gradeText = GradeLevel.getName(CurrentUser.get().grade_level);
				}
				var leftContent = React.createElement(
					"div",
					{ className: "leftCol" },
					React.createElement(
						"div",
						{ className: "onboardingGradeLevelRec" },
						React.createElement("img", { className: "educatorOwl", src: __webpack_require__(298) }),
						React.createElement(
							"p",
							{ className: "recHeader" },
							"Tips for ",
							gradeText,
							" Teachers"
						),
						React.createElement(
							"div",
							{ className: "recommendation" },
							React.createElement(
								"p",
								null,
								this.getShortGradeLevelRec()
							)
						)
					)
				);
	
				var standardOptions = DropDownOptions.Button.Standards({
					buildOptionF: this.buildOnStandardsSelectF,
					showState: true
				});
				var standardSelected = this.state.selectedStandard != undefined;
				var standardsText = standardSelected ? AltSkillsets.getStandardName(this.state.selectedStandard, true) : "Choose";
	
				var standardsDropdown = React.createElement(
					ButtonDropdown,
					{ text: standardsText, dropdownDisplay: "button",
						className: "standardsPicker", buttonClassName: "buttonPrimary" },
					standardOptions
				);
	
				var rightContent = React.createElement(
					"div",
					{ className: "rightCol onboardingLiteracy" },
					React.createElement(
						"p",
						{ className: "onboardingInstructions" },
						React.createElement(
							"span",
							{ className: "instructionTitle" },
							"How do you plan on using Whooo's Reading?"
						)
					),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", checked: !this.state.selectedLiteracyMode,
							onChange: this.onSelectModeType.bind(this, ACCOUNTABILITY_MODE) }),
						React.createElement(
							"span",
							null,
							"Accountability & Comprehension"
						),
						React.createElement(
							"p",
							null,
							"Whooo\u2019s Reading provides students with quizzes to take after reading books and you get comprehension data back."
						)
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", checked: this.state.selectedLiteracyMode,
							onChange: this.onSelectModeType.bind(this, LITERACY_MODE) }),
						React.createElement(
							"span",
							null,
							"Thinking & Writing about Literacy"
						),
						React.createElement(
							"p",
							null,
							"Whooo\u2019s Reading provides thoughtful questions and feedback."
						)
					),
					React.createElement("br", null),
					React.createElement(
						"p",
						{ className: "onboardingInstructions" },
						React.createElement(
							"span",
							{ className: "instructionTitle" },
							"Which standards do you use?"
						)
					),
					standardsDropdown
				);
	
				return React.createElement(
					"div",
					{ className: "onboardingStage onboardingStageSelectStandards clearfix" },
					leftContent,
					rightContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				CurrentUser.fetchCurrentUserData(function () {
					this.forceUpdate();
				}.bind(this));
			}
		}]);
	
		return OnboardingStageSelectStandards;
	}(React.Component);
	
	var ACCOUNTABILITY_MODE = "accountability-mode";
	var LITERACY_MODE = "literacy-mode";
	
	OnboardingStageSelectStandards.propTypes = StrictPropTypes({
		track: PropTypes.string.isRequired,
		onComplete: PropTypes.func.isRequired,
		// only used for the final stage of onboarding
		endOnboarding: PropTypes.func,
		persistentData: PropTypes.object
	});
	
	module.exports = OnboardingStageSelectStandards;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	var ClassShelfPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ClassShelfPreference, _React$Component);
	
		function ClassShelfPreference(props) {
			_classCallCheck(this, ClassShelfPreference);
	
			var _this = _possibleConstructorReturn(this, (ClassShelfPreference.__proto__ || Object.getPrototypeOf(ClassShelfPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("ClassShelfPreference");
			return _this;
		}
	
		_createClass(ClassShelfPreference, [{
			key: "onOptionChange",
			value: function onOptionChange(which) {
				if (which == "hide") {
					var prefsHash = { display_class_shelf: false, answers_on_class_shelf: false };
				} else if (which == "reviewsOnly") {
					var prefsHash = { display_class_shelf: true, answers_on_class_shelf: false };
				} else if (which == "both") {
					var prefsHash = { display_class_shelf: true, answers_on_class_shelf: true };
				}
	
				this.props.onChange(prefsHash, "You successfully changed the Class Shelf display setting.");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "newsfeedSettingContainer" },
					React.createElement(
						"p",
						null,
						"On the ",
						React.createElement(
							"i",
							null,
							"Class Shelf"
						),
						", students can see their classmates' book ",
						React.createElement(
							"em",
							null,
							"Reviews "
						),
						"and, optionally, ",
						React.createElement(
							"em",
							null,
							"Practice Questions"
						),
						"."
					),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "hide"),
							checked: !this.props.prefs.display_class_shelf }),
						"Hide Class Shelf"
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "reviewsOnly"),
							checked: this.props.prefs.display_class_shelf && !this.props.prefs.answers_on_class_shelf }),
						"Show Class Shelf with book reviews only"
					),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "both"),
							checked: this.props.prefs.display_class_shelf && this.props.prefs.answers_on_class_shelf }),
						"Show Class Shelf with book reviews and practice questions"
					)
				);
			}
		}]);
	
		return ClassShelfPreference;
	}(React.Component)) || _class) || _class);
	
	
	ClassShelfPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object.isRequired,
		populateData: PropTypes.func.isRequired,
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = ClassShelfPreference;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var DropDownOptions = __webpack_require__(26);
	var LoadingButton = __webpack_require__(17);
	
	var InformationPreferences = function (_React$Component) {
		_inherits(InformationPreferences, _React$Component);
	
		function InformationPreferences(props) {
			_classCallCheck(this, InformationPreferences);
	
			var _this = _possibleConstructorReturn(this, (InformationPreferences.__proto__ || Object.getPrototypeOf(InformationPreferences)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, loadingBilling: false,
				billingHistory: null, showPaymentMethodForm: false
			};
			LuckyOrangeClient.tagComponent("InformationPreferences");
			return _this;
		}
	
		_createClass(InformationPreferences, [{
			key: "handlePersonalInformationSubmit",
			value: function handlePersonalInformationSubmit(e) {
				var _this2 = this;
	
				$wr.nope(e);
				var firstName = this.refs.first_name.value;
				var lastName = this.refs.last_name.value;
				var title = this.refs.title.value;
				var username = this.refs.username.value;
				var email = this.refs.email.value;
				var newPassword = this.refs.new_password.value;
				var confirmedPassword = this.refs.confirmed_password.value;
				var currentPassword = this.refs.current_password.value;
	
				var params = { first_name: firstName, last_name: lastName,
					title: title, username: username, email: email };
	
				if (newPassword || confirmedPassword || currentPassword) {
					_.extend(params, {
						password: newPassword, password_confirmation: confirmedPassword, current_password: currentPassword
						// double_password: newPassword, current_password: currentPassword
					});
				}
				var adminId = CurrentUser.get().id;
				this.setState({ loading: true });
				CurrentUser.api().patchAdmin(adminId, { admin: params }, $wr.apiHandler(function (response) {
					if (response.admin.errors) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Sorry!", text: response.admin.errors.join(", "),
							icon: "exclamation-sign", type: "error" });
						_this2.setState({ loading: false });
					} else {
						setTimeout(function () {
							window.wrNotifications.triggerDropDownNotification({
								title: "Information Edited", text: "You successfully changed your account information.",
								icon: "ok-sign" });
						}, 1000);
						CurrentUser.fetchCurrentUserData(function () {
							_this2.forceUpdate();
							_this2.setState({ loading: false });
						});
					}
				}));
			}
		}, {
			key: "render",
			value: function render() {
				var user = CurrentUser.get();
	
				return React.createElement(
					"form",
					{ className: "personalInfoForm", onSubmit: this.handlePersonalInformationSubmit },
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"First Name",
							React.createElement("input", { className: "form-control", ref: "first_name",
								defaultValue: user.first_name })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Last Name",
							React.createElement("input", { className: "form-control", ref: "last_name",
								defaultValue: user.last_name })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Title",
							React.createElement(
								"select",
								{ ref: "title", defaultValue: user.title,
									className: "form-control selectOptions" },
								DropDownOptions.Select.Titles()
							)
						)
					),
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer emailInput" },
							"Email",
							React.createElement("input", { className: "form-control", ref: "email", placeholder: "Enter your email",
								defaultValue: user.email })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Username",
							React.createElement("input", { className: "form-control", ref: "username",
								defaultValue: user.username, placeholder: "Enter a username (optional)" })
						)
					),
					React.createElement(
						"div",
						{ className: "inputRow" },
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Current Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "current_password" })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"New Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "new_password" })
						),
						React.createElement(
							"label",
							{ className: "inputContainer" },
							"Confirm Password",
							React.createElement("input", { type: "password", className: "form-control",
								ref: "confirmed_password" })
						)
					),
					React.createElement(LoadingButton, { className: "btn buttonSuccess center-block", loading: this.state.loading,
						text: "Save Information" })
				);
			}
		}]);
	
		return InformationPreferences;
	}(React.Component);
	
	module.exports = InformationPreferences;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var LoadingButton = __webpack_require__(17);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	
	var LinkAccountsPreferences = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var id = CurrentUser.get().id;
	  return {
	    admin: RosterSelectors.admin({ state: state, id: id })
	  };
	}, function (dispatch, props) {
	  var userID = CurrentUser.get().id;
	  return {
	    populateData: function populateData() {
	      return dispatch(RosterActions.fetchAdmins({
	        filter: { id: userID },
	        embeds: ["admin.related_users"]
	      }));
	    },
	    linkAccounts: function linkAccounts(params) {
	      return dispatch(RosterActions.postUserTrigger(userID, params));
	    },
	    fetchAdmins: function fetchAdmins() {
	      return dispatch(RosterActions.fetchAdmins({
	        filter: { id: userID },
	        embeds: ["admin.related_users"]
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(LinkAccountsPreferences, _React$Component);
	
	  function LinkAccountsPreferences(props) {
	    _classCallCheck(this, LinkAccountsPreferences);
	
	    var _this = _possibleConstructorReturn(this, (LinkAccountsPreferences.__proto__ || Object.getPrototypeOf(LinkAccountsPreferences)).call(this));
	
	    autobind(_this);
	    _this.state = { loading: false };
	    LuckyOrangeClient.tagComponent("LinkAccountsPreferences");
	    return _this;
	  }
	
	  _createClass(LinkAccountsPreferences, [{
	    key: "handleLinkAccountSubmit",
	    value: function handleLinkAccountSubmit(e) {
	      var _this2 = this;
	
	      $wr.nope(e);
	      LuckyOrangeClient.tagComponent("LinkingAccounts");
	      this.setState({ loading: true });
	      var username = this.refs.username.value;
	      var password = this.refs.password.value;
	
	      var params = { username: username, password: password, what: "link_accounts", user_id: this.props.admin.id };
	
	      this.props.linkAccounts(params).then(function (response) {
	        _this2.setState({ loading: false });
	        if (response.success) {
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Linked!",
	            text: "Your accounts have been synced. Your roster has been updated accordingly.",
	            icon: "ok-circle"
	          });
	          _this2.props.fetchAdmins();
	        } else if (response.error) {
	          window.wrNotifications.triggerDropDownNotification({
	            title: "Accounts not linked!", text: response.error,
	            icon: "exclamation-sign", type: "error"
	          });
	        }
	      });
	    }
	  }, {
	    key: "renderMergeUsersLink",
	    value: function renderMergeUsersLink() {
	      var admin = this.props.admin;
	
	      var userMergePending = _.filter(admin.related_users, function (rUser) {
	        return !rUser.merged_student_lists || !rUser.merged_students;
	      });
	
	      if (_.size(userMergePending)) {
	        return React.createElement(
	          "a",
	          { className: "btn btn-link mergeUsersLink", href: '/settings/merge-users' },
	          "Merge users"
	        );
	      }
	    }
	  }, {
	    key: "renderLinkedAccounts",
	    value: function renderLinkedAccounts() {
	      if (this.props.admin && _.size(this.props.admin.related_users)) {
	        var related_users = _.map(this.props.admin.related_users, function (user) {
	
	          if (user.username) {
	            var accountDetail = "(username: " + user.username + ")";
	          } else if (user.sign_in_email) {
	            var accountDetail = "(email: " + user.sign_in_email + ")";
	          }
	
	          return React.createElement(
	            "span",
	            { className: "relatedUserDisplay", key: 'related_user-' + user.id },
	            React.createElement(
	              "strong",
	              null,
	              user.first_name,
	              " ",
	              user.last_name
	            ),
	            " ",
	            accountDetail
	          );
	        });
	        return React.createElement(
	          "div",
	          { className: "linkedAccountsContainer" },
	          React.createElement(
	            "div",
	            { className: "linkedAccountText" },
	            "This account is linked with the following accounts:"
	          ),
	          related_users,
	          this.renderMergeUsersLink()
	        );
	      }
	    }
	  }, {
	    key: "renderForm",
	    value: function renderForm() {
	      return React.createElement(
	        "div",
	        { className: "accountSyncFormContainer" },
	        React.createElement(
	          "div",
	          { className: "accountSyncInstructions" },
	          "Have another account? We can link your other account with this one, which will allow you to merge data under any duplicate student accounts under your other account into the matching student accounts in this account."
	        ),
	        React.createElement(
	          "form",
	          { className: "accountSyncForm", onSubmit: this.handleLinkAccountSubmit },
	          React.createElement(
	            "div",
	            { className: "inputRow" },
	            React.createElement(
	              "label",
	              { className: "inputContainer" },
	              "Username or Email",
	              React.createElement("input", { className: "form-control", ref: "username",
	                placeholder: "Username or Email" })
	            ),
	            React.createElement(
	              "label",
	              { className: "inputContainer" },
	              "Password",
	              React.createElement("input", { className: "form-control", ref: "password",
	                placeholder: "Password" })
	            ),
	            React.createElement(LoadingButton, { className: "btn buttonSuccess center-block", loading: this.state.loading,
	              text: "Link Account" })
	          )
	        ),
	        React.createElement(
	          "div",
	          null,
	          "Don't have a username or email? ",
	          React.createElement(
	            "a",
	            { href: "https://whooosreading.zendesk.com/hc/en-us/articles/115001812652-Edit-Your-Name-Username-Email-or-Password", target: "_blank" },
	            "Learn how to create a username"
	          ),
	          "."
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var user = CurrentUser.get();
	
	      return React.createElement(
	        "div",
	        { className: "accountSyncContainer" },
	        this.renderLinkedAccounts(),
	        this.renderForm()
	      );
	    }
	  }]);
	
	  return LinkAccountsPreferences;
	}(React.Component)) || _class) || _class);
	
	
	LinkAccountsPreferences.WrappedComponent.propTypes = PageStrictPropTypes({
	  //signed in admin
	  admin: PropTypes.object,
	
	  populateData: PropTypes.func,
	  linkAccounts: PropTypes.func,
	  fetchAdmins: PropTypes.func
	});
	
	module.exports = LinkAccountsPreferences;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var BackLogReadingPreference = __webpack_require__(923);
	var LogReadingViewPreference = __webpack_require__(924);
	var PromptLogReadingPreference = __webpack_require__(911);
	
	var LogReadingPreference = function (_React$Component) {
		_inherits(LogReadingPreference, _React$Component);
	
		function LogReadingPreference(props) {
			_classCallCheck(this, LogReadingPreference);
	
			var _this = _possibleConstructorReturn(this, (LogReadingPreference.__proto__ || Object.getPrototypeOf(LogReadingPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("LogReadingPreference");
			return _this;
		}
	
		_createClass(LogReadingPreference, [{
			key: "render",
			value: function render() {
				var promptLogReadingPreference = React.createElement(PromptLogReadingPreference, null);
				var logReadingViewPreference = React.createElement(LogReadingViewPreference, null);
				var backLogReadingPreference = React.createElement(BackLogReadingPreference, null);
				return React.createElement(
					"div",
					null,
					promptLogReadingPreference,
					logReadingViewPreference,
					backLogReadingPreference
				);
			}
		}]);
	
		return LogReadingPreference;
	}(React.Component);
	
	module.exports = LogReadingPreference;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var Spinner = __webpack_require__(9);
	var MergeUsersForm = __webpack_require__(876);
	var MergeStudentListsForm = __webpack_require__(875);
	
	var MergeAccountsPreferences = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var id = CurrentUser.get().id;
	  return {
	    admin: RosterSelectors.admin({ state: state, id: id }),
	    students: RosterSelectors.students({ state: state })
	  };
	}, function (dispatch, props) {
	  var userID = CurrentUser.get().id;
	  return {
	    populateData: function populateData() {
	      return dispatch(RosterActions.fetchAdmins({
	        filter: { id: userID },
	        embeds: ["admin.student_lists", "student_list.students", "admin.related_users", "user.link_suggestion"]
	      }));
	    },
	    mergeAccounts: function mergeAccounts(params) {
	      return dispatch(RosterActions.postUserTrigger(userID, params));
	    },
	    fetchAdmin: function fetchAdmin(userID) {
	      return dispatch(RosterActions.fetchAdmins({
	        filter: { id: userID },
	        embeds: ["admin.student_lists", "student_list.students", "admin.related_users", "user.link_suggestion"]
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(MergeAccountsPreferences, _React$Component);
	
	  function MergeAccountsPreferences(props) {
	    _classCallCheck(this, MergeAccountsPreferences);
	
	    var _this = _possibleConstructorReturn(this, (MergeAccountsPreferences.__proto__ || Object.getPrototypeOf(MergeAccountsPreferences)).call(this));
	
	    autobind(_this);
	    _this.state = {
	      loading: false,
	      dupUserIDs: [],
	      dupSLIDs: [],
	      studentMergeLoading: false,
	      slMergeLoading: false
	    };
	
	    _this.mergUsersModal = React.createRef();
	    _this.mergeStudentListModal = React.createRef();
	
	    LuckyOrangeClient.tagComponent("MergeAccountsPreferences");
	    return _this;
	  }
	
	  ///////// HELPERS /////////
	
	
	  _createClass(MergeAccountsPreferences, [{
	    key: "relatedUsersLookup",
	    value: function relatedUsersLookup(conditions) {
	      var admin = this.props.admin;
	
	      return conditions ? _underscore2.default.where(admin.related_users, conditions) : admin.related_users;
	    }
	  }, {
	    key: "dupUserIDs",
	    value: function dupUserIDs() {
	      var conditions = { merged_students: false };
	      if (!_underscore2.default.isEmpty(this.relatedUsersLookup(conditions))) {
	        return _underscore2.default.flatten(_underscore2.default.map(this.relatedUsersLookup(), function (user) {
	          return user.student_ids;
	        }));
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "userIDs",
	    value: function userIDs() {
	      var _this2 = this;
	
	      var conditions = { merged_students: false };
	      var allUserIDs = _underscore2.default.map(this.props.students, function (student) {
	        return student.id;
	      });
	      return !_underscore2.default.isEmpty(this.relatedUsersLookup()) ? allUserIDs.filter(function (id) {
	        return !_this2.dupUserIDs(conditions).includes(id);
	      }) : allUserIDs;
	    }
	  }, {
	    key: "refreshUserProps",
	    value: function refreshUserProps() {
	      var _this3 = this;
	
	      this.setState({ loading: true });
	      this.props.fetchAdmin(this.props.admin.id).then(function () {
	        _this3.setState({ loading: false });
	      });
	    }
	
	    ///////////////////////////
	
	    ///// EVENT HANDLERS /////
	
	  }, {
	    key: "handleMergeSLSubmit",
	    value: function handleMergeSLSubmit(e) {
	      $wr.nope(e);
	      this.refreshUserProps();
	    }
	  }, {
	    key: "handleMergeStudentsSubmit",
	    value: function handleMergeStudentsSubmit(e) {
	      $wr.nope(e);
	      this.refreshUserProps();
	    }
	    //////////////////////////
	
	    //// RENDER METHODS /////
	
	  }, {
	    key: "renderLinkedAccounts",
	    value: function renderLinkedAccounts() {
	      if (!_underscore2.default.isEmpty(this.relatedUsersLookup())) {
	        var related_users = _underscore2.default.map(this.props.admin.related_users, function (user) {
	          return React.createElement(
	            "span",
	            { className: "relatedUserDisplay", key: 'related_user-' + user.id },
	            React.createElement(
	              "strong",
	              null,
	              user.first_name,
	              " ",
	              user.last_name
	            ),
	            " (username: ",
	            user.username,
	            ")"
	          );
	        });
	        return React.createElement(
	          "div",
	          { className: "linkedAccountsContainer" },
	          React.createElement(
	            "div",
	            { className: "linkedAccountText" },
	            "This account is linked with the following accounts:"
	          ),
	          related_users
	        );
	      }
	    }
	  }, {
	    key: "renderForm",
	    value: function renderForm() {
	      var unMergedStudents = { merged_students: false };
	      var unMergedStudentLists = { merged_student_lists: false };
	
	      if (this.state.loading) {
	        return React.createElement(Spinner, { placeholder: true, scale: 1.7 });
	      } else if (_underscore2.default.isEmpty(this.relatedUsersLookup())) {
	        var content = React.createElement(
	          "div",
	          { className: "accountSyncFormContainer" },
	          React.createElement(
	            "div",
	            { className: "accountSyncInstructions" },
	            "Your account is not linked with another account. First, please ",
	            React.createElement(
	              "a",
	              { href: "/settings/link-accounts" },
	              "link an account"
	            ),
	            "."
	          )
	        );
	      } else if (!_underscore2.default.isEmpty(this.relatedUsersLookup(unMergedStudents))) {
	        var content = React.createElement(MergeUsersForm, { userIDs: this.userIDs(), duplicateUserIDs: this.dupUserIDs(), mergeType: 'student', afterSubmit: this.handleMergeStudentsSubmit });
	      } else if (!_underscore2.default.isEmpty(this.relatedUsersLookup(unMergedStudentLists))) {
	        var content = React.createElement(MergeStudentListsForm, { afterSubmit: this.handleMergeSLSubmit });
	      } else {
	        var content = React.createElement(
	          "div",
	          { className: "accountSyncFormContainer" },
	          React.createElement(
	            "div",
	            { className: "accountSyncInstructions" },
	            React.createElement(
	              "b",
	              null,
	              "All user data is merged"
	            )
	          )
	        );
	      }
	      return content;
	    }
	
	    //////////////////////////
	
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "div",
	        { className: "accountSyncContainer" },
	        this.renderLinkedAccounts(),
	        this.renderForm()
	      );
	    }
	  }]);
	
	  return MergeAccountsPreferences;
	}(React.Component)) || _class) || _class);
	
	
	MergeAccountsPreferences.WrappedComponent.propTypes = PageStrictPropTypes({
	  //signed in admin
	  admin: PropTypes.object,
	  students: PropTypes.array,
	
	  populateData: PropTypes.func,
	  mergeAccounts: PropTypes.func,
	  fetchAdmin: PropTypes.func
	});
	
	module.exports = MergeAccountsPreferences;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	var OwlShopPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
	
				// var loc = document.URL
				// 	if (loc.indexOf("roster") > -1) {
				// 		$(document).trigger('roster-update', ["updateOnly"])				
				// }
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(OwlShopPreference, _React$Component);
	
		function OwlShopPreference(props) {
			_classCallCheck(this, OwlShopPreference);
	
			var _this = _possibleConstructorReturn(this, (OwlShopPreference.__proto__ || Object.getPrototypeOf(OwlShopPreference)).call(this));
	
			autobind(_this);
			_this.state = { openingTime: props.prefs.shop_opening_time };
			LuckyOrangeClient.tagComponent("OwlShopPreference");
			return _this;
		}
	
		_createClass(OwlShopPreference, [{
			key: "onOptionChange",
			value: function onOptionChange(value, pos) {
				var preferenceHash = {};
				preferenceHash = { shop_opening_time: value };
				this.props.onChange(preferenceHash, "You successfully changed the Owl Shop settings.");
				this.setState({ openingTime: value });
			}
		}, {
			key: "getOptions",
			value: function getOptions() {
				var _this2 = this;
	
				var options = [];
				options.push(React.createElement(ButtonDropdownOption, { onClick: this.onOptionChange.bind(this, ALWAYS_STRING),
					text: ALWAYS_VALUE, key: ALWAYS_STRING }));
				options.push(React.createElement(ButtonDropdownOption, { onClick: this.onOptionChange.bind(this, NEVER_STRING),
					text: NEVER_VALUE, key: NEVER_STRING }));
	
				_.each(OPENING_OPTIONS, function (time) {
					var text = OPTION_LABEL + time;
					options.push(React.createElement(ButtonDropdownOption, { onClick: _this2.onOptionChange.bind(_this2, time),
						text: text, key: time }));
				});
				return options;
			}
		}, {
			key: "render",
			value: function render() {
	
				if (this.state.openingTime != undefined) {
					var closingOptions = this.getOptions();
	
					if (this.state.openingTime == ALWAYS_STRING) {
						var openingTime = ALWAYS_VALUE;
					} else if (this.state.openingTime == NEVER_STRING) {
						var openingTime = NEVER_VALUE;
					} else {
						var openingTime = this.state.openingTime;
	
						var disclaimer = React.createElement(
							"div",
							{ className: "browserDisclaimer" },
							React.createElement(
								"p",
								null,
								"The Owl Shop will be closed from 7 AM to " + openingTime + " from Mondays to Fridays.",
								" ",
								React.createElement("br", null)
							),
							React.createElement(
								"p",
								null,
								"This setting will also apply during vacations."
							)
						);
					}
	
					var section = React.createElement(
						"div",
						null,
						React.createElement(
							"label",
							null,
							React.createElement(
								ButtonDropdown,
								{ text: openingTime, className: "standardsPicker" },
								closingOptions
							)
						),
						disclaimer
					);
				}
	
				return React.createElement(
					"div",
					{ className: "OwlShopPreferenceContainer" },
					React.createElement(
						"p",
						{ className: "selectOwlShopText" },
						"You can close the Owl Shop and prevent your students from accessing it during class time."
					),
					section
				);
			}
		}]);
	
		return OwlShopPreference;
	}(React.Component)) || _class) || _class);
	
	
	var OPENING_OPTIONS = ["1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM"];
	var ALWAYS_VALUE = "Always leave open";
	var ALWAYS_STRING = "Always";
	var NEVER_VALUE = "Close permanently";
	var NEVER_STRING = "Never";
	var OPTION_LABEL = "Open shop after ";
	
	OwlShopPreference.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired,
		populateData: PropTypes.func.isRequired,
		prefs: PropTypes.object.isRequired
	});
	
	module.exports = OwlShopPreference;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var UpgradeTokenForm = __webpack_require__(167);
	var WhooosReadingServices = __webpack_require__(25);
	
	var PaymentPreferences = function (_React$Component) {
		_inherits(PaymentPreferences, _React$Component);
	
		function PaymentPreferences(props) {
			_classCallCheck(this, PaymentPreferences);
	
			var _this = _possibleConstructorReturn(this, (PaymentPreferences.__proto__ || Object.getPrototypeOf(PaymentPreferences)).call(this));
	
			autobind(_this);
			_this.state = {
				loading: false, showPaymentMethodForm: false
			};
			LuckyOrangeClient.tagComponent("PaymentPreferences");
			return _this;
		}
	
		_createClass(PaymentPreferences, [{
			key: "renderHistoryRow",
			value: function renderHistoryRow(rowContent, key) {
				var contents = _.map(rowContent, function (cellContent, index) {
					return React.createElement(
						"div",
						{ className: "historyCell", key: index },
						cellContent
					);
				});
				return React.createElement(
					"div",
					{ className: "historyRow", key: key },
					contents
				);
			}
		}, {
			key: "sendReceipt",
			value: function sendReceipt(chargeData, e) {
				$wr.nope(e);
	
				var params = { what: "premium_account_receipt",
					stripe_payment_id: chargeData.stripe_payment_id };
	
				CurrentUser.api().postUserTrigger(CurrentUser.get().id, params, $wr.apiHandler(function (response) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sent!", text: "Check your inbox for your receipt.", icon: "envelope" });
				}));
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				if (this.props.billingHistory == null) {
					return React.createElement(
						"div",
						{ className: "billingHistory" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				if (this.props.billingHistory.length == 0) {
					return React.createElement(
						"div",
						{ className: "billingHistory" },
						"You have no billing history."
					);
				}
	
				var chargeHistoryRows = _.map(this.props.billingHistory, function (chargeData, index) {
					var receiptLink = React.createElement(
						"a",
						{ href: "#", className: "receiptLink",
							onClick: _this2.sendReceipt.bind(_this2, chargeData) },
						"Send"
					);
	
					var date = $wr.formatDate(chargeData.date);
	
					if (chargeData.waived) {
						var chargeAmount = "Waived";
					} else {
						var chargeAmount = $wr.centsToDollars(chargeData.cents, true);
					}
	
					var classText = $wr.pluralizeWithNumber("class", chargeData.student_list_count, "classes");
					var planText = chargeData.plan_name + " (" + classText + ")";
	
					return _this2.renderHistoryRow([date, planText, chargeAmount, receiptLink], index);
				});
	
				return React.createElement(
					"div",
					{ className: "billingHistory" },
					React.createElement(
						"div",
						{ className: "historyHeader" },
						this.renderHistoryRow(["Date", "Plan", "Amount", "Receipt"], "header")
					),
					chargeHistoryRows
				);
			}
		}]);
	
		return PaymentPreferences;
	}(React.Component);
	
	module.exports = PaymentPreferences;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountPlans = __webpack_require__(53);
	var CurrentUser = __webpack_require__(3);
	var LoadingButton = __webpack_require__(17);
	var UpgradeHeader = __webpack_require__(247);
	var WhooosReadingServices = __webpack_require__(25);
	var Glyphicon = __webpack_require__(8);
	var UpgradeTokenForm = __webpack_require__(167);
	
	var PlanPreferences = function (_React$Component) {
		_inherits(PlanPreferences, _React$Component);
	
		function PlanPreferences(props) {
			_classCallCheck(this, PlanPreferences);
	
			var _this = _possibleConstructorReturn(this, (PlanPreferences.__proto__ || Object.getPrototypeOf(PlanPreferences)).call(this));
	
			autobind(_this);
			_this.state = {};
			LuckyOrangeClient.tagComponent("PlanPreferences");
			return _this;
		}
	
		_createClass(PlanPreferences, [{
			key: "currentPlan",
			value: function currentPlan() {
				return CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
			}
		}, {
			key: "editPlanLink",
			value: function editPlanLink() {
				var plan = this.currentPlan();
				if (plan == AccountPlans.SILVER_PLAN_2019 || plan == AccountPlans.SILVER_SEMESTER_PLAN_2019) {
					return "/upgrade?plan=silver";
				} else {
					return "/upgrade?plan=gold";
				}
			}
		}, {
			key: "hasCreditCard",
			value: function hasCreditCard() {
				return CurrentUser.get().account.has_credit_card;
			}
		}, {
			key: "isPaying",
			value: function isPaying() {
				return CurrentUser.get().account.paying;
			}
		}, {
			key: "planClassCount",
			value: function planClassCount() {
				return CurrentUser.get().account.plan_student_list_count;
			}
		}, {
			key: "nextChargeAmount",
			value: function nextChargeAmount() {
				return CurrentUser.get().account.next_charge_cents;
			}
		}, {
			key: "nextChargeTime",
			value: function nextChargeTime() {
				return CurrentUser.get().account.next_charge_time;
			}
		}, {
			key: "planName",
			value: function planName(plan) {
				plan = plan || this.currentPlan();
				return AccountPlans.name(plan);
			}
		}, {
			key: "planPricingInfo",
			value: function planPricingInfo() {
				return AccountPlans.pricingSummary(this.currentPlan());
			}
		}, {
			key: "toggleEditPaymentMethod",
			value: function toggleEditPaymentMethod(e) {
				$wr.nope(e);
				this.setState({ showPaymentMethodForm: !this.state.showPaymentMethodForm });
			}
		}, {
			key: "deleteSubscription",
			value: function deleteSubscription(e) {
				var _this2 = this;
	
				$wr.nope(e);
				if (confirm("Canceling this subscription will not reverse previous charges. Are you sure you want to cancel your subscription?")) {
					var currentUser = CurrentUser.get();
	
					var params = { admin: { account: { has_credit_card: false } } };
					CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler(function (response) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Subscription Canceled", text: "You have canceled your subscription.", icon: "trash" });
						CurrentUser.fetchCurrentUserData(function () {
							_this2.forceUpdate();
						});
					}));
				}
			}
		}, {
			key: "onPaymentSubmit",
			value: function onPaymentSubmit(e) {
				var _this3 = this;
	
				$wr.nope(e);
				this.setState({ loadingPaymentUpdate: true });
	
				var currentUser = CurrentUser.get();
				var userData = { name: currentUser.first_name + " " + currentUser.last_name,
					email: currentUser.email };
	
				this.refs.creditCard.tokenize(userData, function (success, tokenData) {
					if (success) {
						var params = {
							admin: {
								account: {
									update_card: true
								}
							},
							card_token_data: tokenData
						};
						CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler(function (response) {
							window.wrNotifications.triggerDropDownNotification({
								title: "Upgrade",
								text: "You have added a new payment method!",
								icon: "star"
							});
							CurrentUser.fetchCurrentUserData(function () {
								_this3.setState({ loadingPaymentUpdate: false, showPaymentMethodForm: false });
							});
						}));
					} else {
						_this3.setState({ loadingPaymentUpdate: false });
					}
				});
			}
		}, {
			key: "getRemainingTrialDays",
			value: function getRemainingTrialDays(expirationDate) {
				var now = new Date();
				var delta = Math.round((expirationDate - now) / (1000 * 3600 * 24));
				return delta + " " + (delta > 1 ? "days" : "day");
			}
		}, {
			key: "renderCurrentTrialDetails",
			value: function renderCurrentTrialDetails() {
				var userAccount = CurrentUser.get().account;
				var currentSilverTrial = userAccount.active_trials.wrSilver != undefined;
				var currentGoldTrial = userAccount.active_trials.wrGold != undefined;
	
				if (currentGoldTrial) {
					if (userAccount.override_data && userAccount.override_data.wrGold && userAccount.override_data.wrGold.expiration_date) {
						var expirationDate = new Date(userAccount.override_data.wrGold.expiration_date);
					}
	
					return React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planLabel" },
							"Current Trial:"
						),
						"Gold",
						React.createElement(
							"i",
							null,
							"  expires in ",
							this.getRemainingTrialDays(expirationDate)
						)
					);
				} else if (currentSilverTrial) {
					if (userAccount.override_data && userAccount.override_data.wrSilver && userAccount.override_data.wrSilver.expiration_date) {
						var expirationDate = new Date(userAccount.override_data.wrSilver.expiration_date);
					}
	
					return React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planLabel" },
							"Current Trial:"
						),
						"Silver",
						React.createElement(
							"i",
							null,
							"  expires in ",
							this.getRemainingTrialDays(expirationDate)
						)
					);
				}
			}
		}, {
			key: "renderTrialOffer",
			value: function renderTrialOffer() {
				var expiredGoldTrial = CurrentUser.get().account.expired_trials.wrGold != undefined;
				var currentGoldTrial = CurrentUser.get().account.active_trials.wrGold != undefined;
				var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;
				var currentSilverTrial = CurrentUser.get().account.active_trials.wrSilver != undefined;
	
				if (!currentSilverTrial) {
	
					if (!expiredSilverTrial) {
						var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
						var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
						var trialLink = React.createElement(
							"a",
							{ href: trialURL },
							"Start 30 day trial"
						);
						var className = "btn buttonDefault";
					} else {
						var className = "btn btn-link";
					}
					var benefitsList = _.map(UpgradeHeader.BENEFITS.silver, function (benefitText) {
						return React.createElement(
							"div",
							{ className: "benefitItem", key: benefitText },
							React.createElement(Glyphicon, { icon: "ok" }),
							React.createElement(
								"div",
								{ className: "benefitText" },
								benefitText
							)
						);
					});
					return React.createElement(
						"div",
						{ className: "upgradeBox" },
						React.createElement(
							"div",
							{ className: "upgradeSentence" },
							"Upgrade to Silver"
						),
						React.createElement(
							"div",
							{ className: "benefitsList" },
							benefitsList
						),
						React.createElement(
							"div",
							{ className: "upgradeContainer" },
							React.createElement(
								"a",
								{ href: "/upgrade?plan=silver", className: "btn buttonSuccess" },
								"Upgrade"
							),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"), className: className },
								"Learn More"
							),
							trialLink
						)
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var currentPlan = this.currentPlan();
	
				var sectionClassName = "currentPlan";
	
				var planPaymentStatus = CurrentUser.get().account.plan_payment_status;
	
				if (currentPlan == AccountPlans.STARTER_PLAN && CurrentUser.get().role != "adminRole" && CurrentUser.get().account.product != "wrGold") {
					sectionClassName += " starterPlan";
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planLabel" },
							"Current Plan:"
						),
						this.planName()
					);
	
					var currentTrialDetails = this.renderCurrentTrialDetails();
					var additionalInfo = this.renderTrialOffer();
				} else if (this.isPaying()) {
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Plan:"
							),
							this.planName(),
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"),
									className: "changeLink" },
								"Info"
							)
						),
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Plan Price:"
							),
							this.planPricingInfo()
						),
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Class Count:"
							),
							$wr.pluralizeWithNumber("class", this.planClassCount(), "classes"),
							React.createElement(
								_reactRouterDom.Link,
								{ to: this.editPlanLink(),
									className: "changeLink" },
								"Add classes"
							)
						)
					);
	
					if (this.hasCreditCard()) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Next Charge:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Charge Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true),
									React.createElement(
										"a",
										{ href: "#", onClick: this.deleteSubscription,
											className: "changeLink" },
										"Cancel"
									),
									React.createElement(
										"span",
										{ className: "cancelNote" },
										"Canceling will not reverse previous charges"
									)
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									CurrentUser.paymentMethodSummary(),
									React.createElement(
										"a",
										{ href: "#", onClick: this.toggleEditPaymentMethod,
											className: "changeLink" },
										"Edit"
									)
								)
							)
						);
					} else if (planPaymentStatus == CREDIT_CARD_REMOVED) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Cancellation Date:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Charge Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true),
									" (will not be charged)"
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									"None",
									React.createElement(
										"a",
										{ href: "#", onClick: this.toggleEditPaymentMethod,
											className: "changeLink" },
										"Add payment method"
									)
								)
							)
						);
					} else if (planPaymentStatus == PURCHASE_ORDER_ACTIVE) {
						var additionalInfo = React.createElement(
							"div",
							{ className: "nextChargeDetails" },
							React.createElement(
								"div",
								{ className: "planSection" },
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Renewal Date:"
									),
									$wr.formatDate(this.nextChargeTime())
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Renewal Amount:"
									),
									$wr.centsToDollars(this.nextChargeAmount(), true)
								),
								React.createElement(
									"div",
									{ className: "planRow" },
									React.createElement(
										"div",
										{ className: "planLabel" },
										"Payment Method:"
									),
									"Purchase Order"
								)
							)
						);
					}
				}
	
				if (CurrentUser.get().role == "adminRole" || CurrentUser.get().account.product == "wrGold") {
					var currentPlanDetails = React.createElement(
						"div",
						{ className: "planSection" },
						React.createElement(
							"div",
							{ className: "planRow" },
							React.createElement(
								"div",
								{ className: "planLabel" },
								"Current Plan:"
							),
							"Gold",
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/pricing"),
									className: "changeLink" },
								"Info"
							)
						)
					);
				}
	
				if (CurrentUser.isTeacherAdmin()) {
					var upgradeTokenForm = React.createElement(UpgradeTokenForm, { requireToggle: true });
				}
	
				return React.createElement(
					"div",
					{ className: sectionClassName + " accountCustomizer" },
					currentPlanDetails,
					currentTrialDetails,
					additionalInfo,
					upgradeTokenForm
				);
			}
		}]);
	
		return PlanPreferences;
	}(React.Component);
	
	// Plan status types
	
	
	var CREDIT_CARD_ACTIVE = "credit-card-active";
	var CREDIT_CARD_REMOVED = "credit-card-removed";
	var CREDIT_CARD_EXPIRED = "credit-card-expired";
	var PURCHASE_ORDER_ACTIVE = "purchase-order-active";
	var PURCHASE_ORDER_EXPIRED = "purchase-order-expired";
	var STATUS_UNKNOWN = "status-unknown";
	
	module.exports = PlanPreferences;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var PaywallModal = __webpack_require__(44);
	var UIActions = __webpack_require__(41);
	var Features = __webpack_require__(16);
	
	var PromptLogReadingPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
		var hasLogReading = Features.isEnabled(Features.LOG_READING);
		return {
			prefs: prefs,
			hasLogReading: hasLogReading
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			showLogReadingPaywall: function showLogReadingPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(PromptLogReadingPreference, _React$Component);
	
		function PromptLogReadingPreference(props) {
			_classCallCheck(this, PromptLogReadingPreference);
	
			var _this = _possibleConstructorReturn(this, (PromptLogReadingPreference.__proto__ || Object.getPrototypeOf(PromptLogReadingPreference)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(PromptLogReadingPreference, [{
			key: "onPromptLogReadingChange",
			value: function onPromptLogReadingChange(value) {
				if (!this.props.hasLogReading) {
					this.props.showLogReadingPaywall();
				} else {
					var prefsHash = { prompt_log_reading: value };
					this.props.onChange(prefsHash, "You successfully changed the log reading prompt setting.");
				}
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						" Automatically prompt your students to log reading after completing their writing."
					),
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onPromptLogReadingChange.bind(this, true),
								checked: this.props.prefs.prompt_log_reading == true }),
							"Ask my students to log reading"
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onPromptLogReadingChange.bind(this, false),
								checked: this.props.prefs.prompt_log_reading == false }),
							"Do not ask my students to log reading"
						)
					)
				);
			}
		}]);
	
		return PromptLogReadingPreference;
	}(React.Component)) || _class) || _class);
	
	
	PromptLogReadingPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object,
		// Handlers from @connect
		hasLogReading: PropTypes.bool,
		onChange: PropTypes.func.isRequired,
		showLogReadingPaywall: PropTypes.func,
		populateData: PropTypes.func.isRequired
	});
	
	module.exports = PromptLogReadingPreference;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var QuestionBuilderPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(QuestionBuilderPreference, _React$Component);
	
		function QuestionBuilderPreference(props) {
			_classCallCheck(this, QuestionBuilderPreference);
	
			var _this = _possibleConstructorReturn(this, (QuestionBuilderPreference.__proto__ || Object.getPrototypeOf(QuestionBuilderPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("QuestionBuilderPreference");
			return _this;
		}
	
		_createClass(QuestionBuilderPreference, [{
			key: "onQuestionBuilderChange",
			value: function onQuestionBuilderChange(value) {
				var prefsHash = { display_question_builder: value };
				this.props.onChange(prefsHash, "You successfully changed the question builder setting.");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						"Control whether your students can write their own Question Builders."
					),
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onQuestionBuilderChange.bind(this, true),
								checked: this.props.prefs.display_question_builder === true }),
							"Display Question Builders on student dashboard"
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onQuestionBuilderChange.bind(this, false),
								checked: this.props.prefs.display_question_builder === false }),
							"Remove Question Builders from student dashboard"
						)
					),
					React.createElement("br", null),
					React.createElement(
						"div",
						null,
						React.createElement(
							"span",
							null,
							" For more information on Question Builders, ",
							React.createElement(
								"a",
								{ href: "https://whooosreading.zendesk.com/hc/en-us/articles/8108230080013" },
								" refer to our Help Center."
							)
						)
					)
				);
			}
		}]);
	
		return QuestionBuilderPreference;
	}(React.Component)) || _class) || _class);
	
	
	QuestionBuilderPreference.WrappedComponent.propTypes = StrictPropTypes({
		// Handlers from @connect
		onChange: PropTypes.func.isRequired,
		prefs: PropTypes.object.isRequired,
		populateData: PropTypes.func.isRequired
	});
	
	module.exports = QuestionBuilderPreference;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	var QuizLimitPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
	
				// var loc = document.URL
				// 	if (loc.indexOf("roster") > -1) {
				// 		$(document).trigger('roster-update', ["updateOnly"])				
				// }
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(QuizLimitPreference, _React$Component);
	
		function QuizLimitPreference(props) {
			_classCallCheck(this, QuizLimitPreference);
	
			var _this = _possibleConstructorReturn(this, (QuizLimitPreference.__proto__ || Object.getPrototypeOf(QuizLimitPreference)).call(this));
	
			autobind(_this);
			_this.state = { quizCloseTime: props.prefs.quiz_close_time || NEVER_STRING };
			LuckyOrangeClient.tagComponent("OwlShopPreference");
			return _this;
		}
	
		_createClass(QuizLimitPreference, [{
			key: "onOptionChange",
			value: function onOptionChange(value, pos) {
				var preferenceHash = {};
				preferenceHash = { quiz_close_time: value };
				if (value == ALWAYS_STRING) {
					var message = "Students are blocked from taking quizzes until you change adjust your settings.";
				} else {
					var message = "You successfully changed the Quiz settings.";
				}
				this.props.onChange(preferenceHash, message);
				this.setState({ quizCloseTime: value });
			}
		}, {
			key: "getOptions",
			value: function getOptions() {
				var _this2 = this;
	
				var options = [];
				options.push(React.createElement(ButtonDropdownOption, { onClick: this.onOptionChange.bind(this, NEVER_STRING),
					text: NEVER_VALUE, key: NEVER_STRING }));
	
				options.push(React.createElement(ButtonDropdownOption, { onClick: this.onOptionChange.bind(this, ALWAYS_STRING),
					text: ALWAYS_VALUE, key: ALWAYS_STRING }));
	
				_.each(OPENING_OPTIONS, function (time) {
					var text = OPTION_LABEL + time;
					options.push(React.createElement(ButtonDropdownOption, { onClick: _this2.onOptionChange.bind(_this2, time),
						text: text, key: time }));
				});
				return options;
			}
		}, {
			key: "render",
			value: function render() {
	
				var openingOptions = this.getOptions();
	
				if (this.state.quizCloseTime == NEVER_STRING) {
					var quizCloseTime = NEVER_VALUE;
				} else {
					var quizCloseTime = this.state.quizCloseTime;
	
					var sentence = "";
					if (quizCloseTime && quizCloseTime != ALWAYS_STRING) {
						sentence = "Students will only able to take quizzes before " + quizCloseTime + " on Mondays to Fridays.";
					} else if (quizCloseTime == ALWAYS_STRING) {
						sentence = "Students are blocked from taking quizzes. To re-enable quizzes, adjust your settings.";
					} else {
						sentence = "Students are able to take quizzes at any time.";
					}
					var disclaimer = React.createElement(
						"div",
						{ className: "browserDisclaimer" },
						React.createElement(
							"p",
							null,
							sentence,
							" ",
							React.createElement("br", null)
						)
					);
				}
				var section = React.createElement(
					"div",
					null,
					disclaimer,
					React.createElement(
						"label",
						null,
						React.createElement(
							ButtonDropdown,
							{ text: quizCloseTime, className: "standardsPicker" },
							openingOptions
						)
					)
				);
	
				return React.createElement(
					"div",
					{ className: "OwlShopPreferenceContainer" },
					React.createElement(
						"p",
						{ className: "selectOwlShopText" },
						"You can lock quizzes to prevent your students from taking quizzes outside of class time."
					),
					section
				);
			}
		}]);
	
		return QuizLimitPreference;
	}(React.Component)) || _class) || _class);
	
	
	var OPENING_OPTIONS = ["1 PM", "2 PM", "3 PM", "4 PM", "5 PM"];
	var NEVER_VALUE = "Never close";
	var NEVER_STRING = "Never";
	var ALWAYS_VALUE = "Always closed";
	var ALWAYS_STRING = "Always";
	var OPTION_LABEL = "Close quizzes after ";
	
	module.exports = QuizLimitPreference;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var LoadingButton = __webpack_require__(17);
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var QuizScoringPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(QuizScoringPreference, _React$Component);
	
		function QuizScoringPreference(props) {
			_classCallCheck(this, QuizScoringPreference);
	
			var _this = _possibleConstructorReturn(this, (QuizScoringPreference.__proto__ || Object.getPrototypeOf(QuizScoringPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("QuizScoringPreference");
			return _this;
		}
	
		_createClass(QuizScoringPreference, [{
			key: "onPassingThresholdChange",
			value: function onPassingThresholdChange(value) {
				var prefsHash = { passing_threshold: value };
				this.props.onChange(prefsHash, "You successfully changed the minimum passing score.");
			}
		}, {
			key: "onViewableScoresChange",
			value: function onViewableScoresChange(value) {
				var prefsHash = { visible_student_scores: value };
				this.props.onChange(prefsHash, "You successfully changed the visibility of scores.");
			}
		}, {
			key: "scoreCap",
			value: function scoreCap() {
				return this.props.prefs.display_score_cap;
			}
		}, {
			key: "render",
			value: function render() {
				var scoringOptions = _.map(THRESHOLD_OPTIONS, function (threshold) {
					var text = threshold * this.scoreCap() + "/" + this.scoreCap();
					return React.createElement(
						"div",
						{ key: threshold },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onPassingThresholdChange.bind(this, threshold),
								checked: this.props.prefs.passing_threshold === threshold }),
							text
						)
					);
				}.bind(this));
	
				var currentScoreThreshold = this.props.prefs.passing_threshold * this.scoreCap();
				var currentText = "Minimum Passing Score: " + currentScoreThreshold + "/" + this.scoreCap();
	
				return React.createElement(
					"div",
					{ className: "quizScoringSettingContainer" },
					React.createElement(
						"p",
						{ className: "subTitle" },
						"Minimum Passing Score"
					),
					React.createElement(
						"p",
						null,
						"Adjust the minimum number of points required to pass quizzes to make the autograder easier or harder on your students."
					),
					React.createElement(
						"p",
						{ className: "selectScoringText" },
						React.createElement(
							"b",
							null,
							"Note:"
						),
						" This setting will affect the scoring of quizzes already taken."
					),
					scoringOptions,
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"p",
							{ className: "subTitle" },
							"Show Scores to Students"
						),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onViewableScoresChange.bind(this, true),
								checked: this.props.prefs.visible_student_scores === true }),
							"Show scores to students"
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onViewableScoresChange.bind(this, false),
								checked: this.props.prefs.visible_student_scores === false }),
							"Do not show scores to students"
						)
					)
				);
			}
		}]);
	
		return QuizScoringPreference;
	}(React.Component)) || _class) || _class);
	
	
	var THRESHOLD_OPTIONS = [0.5, 0.625, 0.75, 0.875, 1.0];
	
	QuizScoringPreference.WrappedComponent.propTypes = StrictPropTypes({
		// Data from @connect
		prefs: PropTypes.object,
	
		// Handlers from @connect
		onChange: PropTypes.func.isRequired,
		populateData: PropTypes.func.isRequired
	});
	
	module.exports = QuizScoringPreference;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdownOption = __webpack_require__(31);
	
	var ReadingLevelFormatPreference = function (_React$Component) {
		_inherits(ReadingLevelFormatPreference, _React$Component);
	
		function ReadingLevelFormatPreference(props) {
			_classCallCheck(this, ReadingLevelFormatPreference);
	
			var _this = _possibleConstructorReturn(this, (ReadingLevelFormatPreference.__proto__ || Object.getPrototypeOf(ReadingLevelFormatPreference)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ReadingLevelFormatPreference, [{
			key: "buildSelectReadingLevelF",
			value: function buildSelectReadingLevelF(readingLevel) {
				return function () {
					var newPrefs = { reading_level_format: readingLevel };
					var params = { admin: { prefs: newPrefs } };
					CurrentUser.updateLocal({ prefs: newPrefs });
	
					this.forceUpdate();
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited",
						text: "You successfully changed your reading level format.",
						icon: "ok-sign"
					});
	
					CurrentUser.api().patchAdmin(CurrentUser.get().id, params, $wr.apiHandler(function (response) {
						CurrentUser.fetchCurrentUserData();
					}.bind(this)));
				}.bind(this);
			}
		}, {
			key: "render",
			value: function render() {
				var currentReadingLevelFormat = CurrentUser.get().prefs.reading_level_format;
	
				var readingLevelOptions = [];
				_.each(ReadingLevelFormatPreference.READING_LEVEL_OPTIONS, function (levelOption) {
					readingLevelOptions.push(React.createElement(ButtonDropdownOption, { onClick: this.buildSelectReadingLevelF(levelOption),
						text: levelOption, key: levelOption }));
				}.bind(this));
	
				var readingLevelDropdown = React.createElement(
					ButtonDropdown,
					{ text: currentReadingLevelFormat, className: "readingLevelsPicker" },
					readingLevelOptions
				);
	
				// <p className="smallText">
				// 	Please note: Our default system is Lexile. The conversion to other systems can be inexact.
				// </p>
	
				return React.createElement(
					"div",
					{ className: "readingLevelPickerContainer" },
					React.createElement(
						"p",
						{ className: "subTitle" },
						"Format"
					),
					React.createElement(
						"div",
						null,
						"Select the format you use for your students' reading levels."
					),
					readingLevelDropdown
				);
			}
		}]);
	
		return ReadingLevelFormatPreference;
	}(React.Component);
	
	ReadingLevelFormatPreference.READING_LEVEL_OPTIONS = ["Lexile Level", "Grade", "Ages", "Reading Recovery", "DRA", "Rigby Literacy Levels", "Rigby PM", "Reading A-Z Level", "Fountas & Pinnell"];
	
	ReadingLevelFormatPreference.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = ReadingLevelFormatPreference;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var AccountPlans = __webpack_require__(53);
	var Spinner = __webpack_require__(9);
	var ProgressBar = __webpack_require__(81);
	var LoadingButton = __webpack_require__(17);
	
	var ReferralPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var id = CurrentUser.get().id;
	  return {
	    admin: RosterSelectors.admin({ state: state, id: id })
	  };
	}, function (dispatch, props) {
	  var userID = CurrentUser.get().id;
	
	  return {
	    populateData: function populateData() {
	      return dispatch(RosterActions.fetchAdmins({ filter: { id: userID }, embeds: ["admin.referred_by", "admin.referred_count"] }));
	    },
	    updateReferralCode: function updateReferralCode(referralCode) {
	      return dispatch(RosterActions.updateAdmin({
	        id: userID,
	        update: { referred_by: referralCode, features: AccountPlans.PRODUCTS.WR_SILVER },
	        embeds: ["admin.referred_by", "admin.referred_count"]
	      }));
	    },
	    sendReferralEmail: function sendReferralEmail() {
	      return dispatch(RosterActions.updateAdmin({
	        id: currentUserID,
	        update: { referred_email: userInput },
	        embeds: ["admin.referred_by", "admin.referred_count"]
	      }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(ReferralPreference, _React$Component);
	
	  function ReferralPreference(props) {
	    _classCallCheck(this, ReferralPreference);
	
	    var _this = _possibleConstructorReturn(this, (ReferralPreference.__proto__ || Object.getPrototypeOf(ReferralPreference)).call(this));
	
	    autobind(_this);
	    LuckyOrangeClient.tagComponent("ReferralPreference");
	
	    _this.state = { loading: false };
	    return _this;
	  }
	
	  // catches an error in the ajax call
	
	
	  _createClass(ReferralPreference, [{
	    key: "onServerError",
	    value: function onServerError() {
	      this.setState({ submitError: true, submitErrorMessage: 'Something went went wrong. Please refresh the page and try again or contact support.', loading: false });
	    }
	    // display invalid referral message
	
	  }, {
	    key: "invalidReferralCode",
	    value: function invalidReferralCode(title, text) {
	      window.wrNotifications.triggerDropDownNotification({ title: title, text: text, icon: "exclamation-sign", type: "error" });
	    }
	    // display valid referral message
	
	  }, {
	    key: "validReferralEmail",
	    value: function validReferralEmail() {
	      window.wrNotifications.triggerDropDownNotification({ title: "The Email has been Sent!", icon: "ok-sign" });
	    }
	    // submits referral code
	
	  }, {
	    key: "onSubmitReferralCode",
	    value: function onSubmitReferralCode() {
	      var _this2 = this;
	
	      var referralCode = this.refs.referralCode.value.trim();
	      if (referralCode === this.props.admin.referral_code) {
	        this.invalidReferralCode("Invalid referral code", "You can\'t use your own referral code");
	      } else {
	        this.setState({ loading: true });
	        this.props.updateReferralCode(referralCode).then(function (response) {
	
	          _this2.setState({ loading: false });
	          var errors = _.first(response.admins).errors;
	          // display error or render success banner
	          if (_.any(errors)) {
	            _this2.invalidReferralCode("Invalid referral code", _.first(errors));
	          } else {
	            LuckyOrangeClient.tagComponent("submitReferralCode");
	            Mycroft.newEvent({ category: "Referrals", action: "settings-tab-referral" });
	            window.wrNotifications.triggerDropDownNotification({ title: "Referral submitted successfully!", icon: "ok-sign" });
	            window.location.reload();
	          }
	        });
	      }
	    }
	  }, {
	    key: "onSubmitReferralEmail",
	    value: function onSubmitReferralEmail() {
	      var _this3 = this;
	
	      this.props.updateReferral(userInput.trim(), inputType).then(function (response) {
	        _this3.setState({ loading: false });
	        var errors = _.first(response.admins).errors;
	        // display error or render success banner
	        if (_.any(errors)) {
	          _this3.setState({ submitError: true, submitErrorMessage: _.first(errors), loading: false });
	        } else {
	          _this3.validReferralCode(inputType);
	        }
	      });
	    }
	    // render error message below input field
	
	  }, {
	    key: "showErrorMessage",
	    value: function showErrorMessage() {
	      if (this.state.submitErrorMessage && this.state.submitError) {
	        return React.createElement(
	          "div",
	          { className: "errorMessageContainer" },
	          React.createElement(
	            "p",
	            { className: "errorMessage" },
	            this.state.submitErrorMessage
	          )
	        );
	      }
	    }
	    // renders input field or spinner
	
	  }, {
	    key: "renderInput",
	    value: function renderInput(inputType) {
	      var _this4 = this;
	
	      return React.createElement("input", { className: "form-control referralCodeEmailInputField", type: "text", placeholder: "Email", onKeyDown: function onKeyDown(e) {
	          return _this4.onKeyPress(e, inputType);
	        } });
	    }
	    // determines if user has already used a referral code
	
	  }, {
	    key: "renderReferralCodeInput",
	    value: function renderReferralCodeInput() {
	      if (CurrentUser.isPremiumOrTrialAccount()) {
	        return null;
	      }
	      if (_.isEmpty(this.props.admin.referred_by)) {
	        return React.createElement(
	          "div",
	          { className: "referralInputAreaContainer" },
	          React.createElement(
	            "p",
	            { className: "referralInputHeader" },
	            "Did someone refer you to Whooo's Reading? Enter their referral code below and you'll both receive an extra 15 days on your free trials of Whooo's Reading Silver."
	          ),
	          React.createElement(
	            "div",
	            { className: "referralInputContainer row" },
	            React.createElement(
	              "div",
	              { className: "col-sm-4" },
	              React.createElement(
	                "p",
	                { className: "referralCodeInputIntro" },
	                "Enter referral code: "
	              )
	            ),
	            React.createElement(
	              "div",
	              { className: "col-sm-8" },
	              React.createElement("input", { className: "form-control referralCodeInputField", type: "text", placeholder: "Referral code", ref: "referralCode" }),
	              React.createElement(LoadingButton, { className: "btn buttonDefault", text: "Submit", onClick: this.onSubmitReferralCode, loading: this.state.loading })
	            )
	          )
	        );
	      } else {
	        return React.createElement(
	          "div",
	          { className: "referralInputAreaContainer" },
	          React.createElement(
	            "p",
	            { className: "referralInputHeader" },
	            "You successfully used the following referral code: ",
	            React.createElement(
	              "b",
	              null,
	              this.props.admin.referred_by
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderReferralCode",
	    value: function renderReferralCode() {
	      return React.createElement(
	        "div",
	        { className: "referrralPreferenceSection" },
	        React.createElement(
	          "p",
	          null,
	          "Refer up to two teachers and they will receive ",
	          React.createElement(
	            "strong",
	            null,
	            "15 days of free Silver."
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "row" },
	          React.createElement(
	            "div",
	            { className: "col-sm-5" },
	            React.createElement(
	              "p",
	              null,
	              "Your referal code: ",
	              React.createElement(
	                "span",
	                { className: "userReferralCode" },
	                React.createElement(
	                  "strong",
	                  null,
	                  this.props.admin.referral_code
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderSilverTrialProgress",
	    value: function renderSilverTrialProgress() {
	      var extensionProgress = this.props.admin.referred_count * 15;
	
	      if (this.props.admin.referred_count == 0) {
	        var progressBarMessage = "Waiting on 2 more referrals";
	      } else if (this.props.admin.referred_count == 1) {
	        var progressBarMessage = "Waiting on 1 more referral. Trial was extended by 15 days!";
	      } else {
	        var progressBarMessage = "You referred two or more teachers. Your trial was extended by 30 days!";
	      }
	
	      return React.createElement(
	        "div",
	        { className: "referrralPreferenceSection" },
	        React.createElement(
	          "p",
	          null,
	          "Refer up to two teachers and receive ",
	          React.createElement(
	            "strong",
	            null,
	            "15 days of free Silver per person."
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "row" },
	          React.createElement(
	            "div",
	            { className: "col-sm-5" },
	            React.createElement(
	              "p",
	              { className: "userReferralCode" },
	              "Your referal code: ",
	              React.createElement(
	                "span",
	                { className: "userReferralCode" },
	                React.createElement(
	                  "strong",
	                  null,
	                  this.props.admin.referral_code
	                )
	              )
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "col-sm-7" },
	            React.createElement(ProgressBar, { current: extensionProgress, total: 30, className: "levelBar", message: progressBarMessage })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderAdminReferralCodeSection",
	    value: function renderAdminReferralCodeSection() {
	      return CurrentUser.isPremiumOrTrialAccount() ? this.renderReferralCode() : this.renderSilverTrialProgress();
	    }
	  }, {
	    key: "renderEmailReferralInput",
	    value: function renderEmailReferralInput() {
	      return React.createElement(
	        "div",
	        { className: "referralInputAreaContainer referrralPreferenceSection" },
	        React.createElement(
	          "p",
	          { className: "referralInputHeader" },
	          "Do you know someone who'd love Whooo's Reading? Send them an email and we will attribute a referral to your account."
	        ),
	        React.createElement(
	          "div",
	          { className: "referralEmailInputContainer" },
	          this.renderInput(),
	          this.showErrorMessage()
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return React.createElement(
	        "div",
	        { className: "referralContainer" },
	        this.renderReferralCodeInput(),
	        this.renderAdminReferralCodeSection()
	      );
	    }
	  }]);
	
	  return ReferralPreference;
	}(React.Component)) || _class) || _class);
	
	
	ReferralPreference.WrappedComponent.propTypes = StrictPropTypes({
	  // Handlers from @connect
	  populateData: PropTypes.func,
	  updateReferralCode: PropTypes.func,
	  sendReferralEmail: PropTypes.func,
	  admin: PropTypes.object
	});
	
	module.exports = ReferralPreference;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var HelpSectionLink = __webpack_require__(64);
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var AltSkillsets = __webpack_require__(200);
	
	var SkillsetStandardPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {
			onChange: function onChange(prefsUpdate, message) {
				// Will get moved to redux at some point (soon, I hope)
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				var adminID = CurrentUser.get().id;
				var params = { admin: { prefs: prefsUpdate } };
	
				var newPrefs = _.extend({}, CurrentUser.get().prefs, prefsUpdate);
				CurrentUser.updateLocal({ prefs: newPrefs });
	
				CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function (response) {
	
					$(window.document).trigger("standards-updated");
				}.bind(undefined)));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(SkillsetStandardPreference, _React$Component);
	
		function SkillsetStandardPreference(props) {
			_classCallCheck(this, SkillsetStandardPreference);
	
			var _this = _possibleConstructorReturn(this, (SkillsetStandardPreference.__proto__ || Object.getPrototypeOf(SkillsetStandardPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("SkillsetStandardPreference");
			return _this;
		}
	
		_createClass(SkillsetStandardPreference, [{
			key: "buildSelectStandardF",
			value: function buildSelectStandardF(standardKey) {
				return function () {
					this.props.onChange({ skillset_standard: standardKey }, "You successfully changed your standards");
	
					this.forceUpdate(); // Won't need this when prefs update happens with redux				
				}.bind(this);
			}
		}, {
			key: "render",
			value: function render() {
				var standardOptions = DropDownOptions.Button.Standards({
					buildOptionF: this.buildSelectStandardF,
					showState: true
				});
	
				var current = CurrentUser.get().prefs.skillset_standard;
	
				var standardsDropdown = React.createElement(
					ButtonDropdown,
					{ text: AltSkillsets.getStandardName(current, true),
						className: "standardsPicker" },
					standardOptions
				);
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						{ className: "selectStandardsText" },
						"Select a standards system to use:"
					),
					standardsDropdown
				);
			}
		}]);
	
		return SkillsetStandardPreference;
	}(React.Component)) || _class);
	
	
	SkillsetStandardPreference.WrappedComponent.propTypes = StrictPropTypes({
		onChange: PropTypes.func.isRequired
	});
	
	module.exports = SkillsetStandardPreference;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	
	var SoundPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(SoundPreference, _React$Component);
	
		function SoundPreference(props) {
			_classCallCheck(this, SoundPreference);
	
			var _this = _possibleConstructorReturn(this, (SoundPreference.__proto__ || Object.getPrototypeOf(SoundPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("SoundPreference");
			return _this;
		}
	
		_createClass(SoundPreference, [{
			key: "onOptionChange",
			value: function onOptionChange(which) {
				this.props.onChange({ sound_enabled: which }, "You successfully changed your sound setting.");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "newsfeedSettingContainer" },
					React.createElement(
						"p",
						null,
						"Students can add owl and background sounds that will play on some pages."
					),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, true),
							checked: this.props.prefs.sound_enabled }),
						"Enable sounds"
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, false),
							checked: !this.props.prefs.sound_enabled }),
						"Disable sounds"
					)
				);
			}
		}]);
	
		return SoundPreference;
	}(React.Component)) || _class) || _class);
	
	
	SoundPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object,
		onChange: PropTypes.func,
		populateData: PropTypes.func
	});
	
	module.exports = SoundPreference;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var SpeechControlsPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(SpeechControlsPreference, _React$Component);
	
		function SpeechControlsPreference(props) {
			_classCallCheck(this, SpeechControlsPreference);
	
			var _this = _possibleConstructorReturn(this, (SpeechControlsPreference.__proto__ || Object.getPrototypeOf(SpeechControlsPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("SpeechControlsPreference");
			return _this;
		}
	
		_createClass(SpeechControlsPreference, [{
			key: "onOptionChange",
			value: function onOptionChange(value) {
				var preferenceHash = {};
				preferenceHash = { speech_controls: value };
				this.props.onChange(preferenceHash, "You successfully changed the voice setting.");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "speechControlsPreferenceContainer" },
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "voice-first"),
							checked: this.props.prefs.speech_controls == "voice-first" }),
						"Voice-first: have questions and feedback read aloud automatically, highlight ability to speak answers"
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "normal"),
							checked: this.props.prefs.speech_controls == "normal" }),
						"Voice optional: allow students to use voice and audio"
					),
					React.createElement("br", null),
					React.createElement(
						"label",
						null,
						React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "off"),
							checked: this.props.prefs.speech_controls == "off" }),
						"No voice: remove all audio and voice capabilities"
					),
					React.createElement(
						"p",
						{ className: "browserDisclaimer" },
						"Audio and voice capabilities require an updated version of Google Chrome, Mozilla Firefox, or Safari."
					)
				);
			}
		}]);
	
		return SpeechControlsPreference;
	}(React.Component)) || _class) || _class);
	
	
	SpeechControlsPreference.propTypes = StrictPropTypes({
		prefs: PropTypes.object,
		onChange: PropTypes.func,
		populateData: PropTypes.func
	});
	
	module.exports = SpeechControlsPreference;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	
	__webpack_require__(3754);
	
	//create a search filter for the token that depends
	//on the current admin being in a school org OR a district org.
	function createFilterForOrgID(admin) {
	    if (admin.primary_district_org_id) {
	        return {
	            "district_org_id": admin.primary_district_org_id,
	            "all_district_tokens": true
	        };
	    } else if (admin.primary_school_org_id) {
	        return { "school_org_id": admin.primary_school_org_id };
	    }
	}
	
	//returns list of admin ids from a list of tokens
	function subAdminIDsFromTokens(tokens) {
	    var userIDs = [];
	    tokens.forEach(function (token) {
	        if (token.user) {
	            userIDs.push(token.user);
	        }
	    });
	    return userIDs;
	}
	
	var UpgradeCodeTablePreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
	    var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	    var filter = createFilterForOrgID(admin);
	    //tokens w no email were manually entered by Claire
	    //no filter here...
	    var tokens = _underscore2.default.filter(RosterSelectors.upgradeTokens({ state: state }), function (token) {
	        return token.contact_email;
	    });
	
	    var loading = RosterSelectors.isLoadingUpgradeTokens({ state: state }) || RosterSelectors.isLoadingAdmins({ state: state });
	
	    var tokensBySchool = _underscore2.default.groupBy(tokens, 'contact_school');
	
	    function orderByLastName(a, b) {
	        if (a.contact_name && b.contact_name) {
	            //Not sure how many spaces might be in a name, just grabbing the 
	            //last word in the name to be safe
	            var splitNameA = a.contact_name.split(" ");
	            var lastNameA = splitNameA[splitNameA.length - 1];
	
	            var splitNameB = b.contact_name.split(" ");
	            var lastNameB = splitNameB[splitNameB.length - 1];
	
	            if (lastNameA > lastNameB) {
	                return 1;
	            } else if (lastNameB > lastNameA) {
	                return -1;
	            } else return 0;
	        }
	        //cases where one name is undefined.
	        if (a.contact_name && !b.contact_name) {
	            return -1;
	        } else if (b.contact_name && !a.contact_name) {
	            return 1;
	        }
	        //both undefined
	        else return 0;
	    }
	
	    // find the start plan by school
	    var currentPlanStartBySchool = {};
	    //sort the tables by teacher last name, and gather most recent start date by school.
	    for (var school in tokensBySchool) {
	        tokensBySchool[school].sort(orderByLastName);
	
	        var startDates = _underscore2.default.pluck(tokensBySchool[school], "start_date");
	        var mostRecentPlanStart;
	        startDates.forEach(function (stringDate) {
	            var newDate = new Date(stringDate);
	            if (!mostRecentPlanStart) {
	                mostRecentPlanStart = newDate;
	            } else if (newDate > mostRecentPlanStart) {
	                mostRecentPlanStart = newDate;
	            }
	        });
	        currentPlanStartBySchool[school] = mostRecentPlanStart;
	    }
	
	    return {
	        admin: admin,
	        tokens: tokens,
	        loading: loading,
	        tokensBySchool: tokensBySchool,
	        currentPlanStartBySchool: currentPlanStartBySchool
	    };
	}, function (dispatch, props) {
	    return {
	        populateData: function populateData() {
	            //STEP 1: Grab logged in admin
	            var admin = CurrentUser.get();
	            //STEP 2: Grab all tokens for the current admins org.
	            var filter = createFilterForOrgID(admin);
	            if (filter) {
	                dispatch(RosterActions.fetchUpgradeTokens({
	                    filters: _extends({}, filter),
	                    embeds: ['upgrade_token.user_info']
	                }));
	            }
	        }
	    };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	    _inherits(UpgradeCodeTablePreference, _React$Component);
	
	    function UpgradeCodeTablePreference(props) {
	        _classCallCheck(this, UpgradeCodeTablePreference);
	
	        var _this = _possibleConstructorReturn(this, (UpgradeCodeTablePreference.__proto__ || Object.getPrototypeOf(UpgradeCodeTablePreference)).call(this));
	
	        autobind(_this);
	        _this.state = {};
	        LuckyOrangeClient.tagComponent("AdminCodeTable");
	        return _this;
	    }
	
	    _createClass(UpgradeCodeTablePreference, [{
	        key: "renderTables",
	        value: function renderTables() {
	            var _this2 = this;
	
	            var display = _underscore2.default.map(this.props.tokensBySchool, function (tokens) {
	                return _this2.renderSchoolTable(tokens);
	            });
	            return display;
	        }
	    }, {
	        key: "renderSchoolTable",
	        value: function renderSchoolTable(tokens) {
	            var planStart = this.props.currentPlanStartBySchool[tokens[0].contact_school];
	            var table = React.createElement(
	                "div",
	                { className: "codeTable", key: tokens[0].contact_school },
	                React.createElement(
	                    "h3",
	                    null,
	                    " ",
	                    tokens[0].contact_school
	                ),
	                React.createElement(
	                    "p",
	                    null,
	                    " Plan start: ",
	                    planStart.toLocaleDateString()
	                ),
	                React.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    React.createElement(
	                        "tbody",
	                        null,
	                        this.renderTableHeader(),
	                        this.renderTableRows(tokens)
	                    )
	                )
	            );
	            return table;
	        }
	    }, {
	        key: "renderTableHeader",
	        value: function renderTableHeader() {
	            return React.createElement(
	                "tr",
	                null,
	                React.createElement(
	                    "th",
	                    { className: "nameHeader" },
	                    "Name"
	                ),
	                React.createElement(
	                    "th",
	                    { className: "emailHeader" },
	                    "Email"
	                ),
	                React.createElement(
	                    "th",
	                    { className: "codeHeader" },
	                    "Activation Code"
	                ),
	                React.createElement(
	                    "th",
	                    { className: "codeStatusHeader" },
	                    "Code Status"
	                ),
	                React.createElement(
	                    "th",
	                    { className: "onboardingHeader" },
	                    "Students Added"
	                )
	            );
	        }
	    }, {
	        key: "renderTableRows",
	        value: function renderTableRows(tokens) {
	            var _this3 = this;
	
	            // Filter tokens by start date
	            var schoolName = tokens[0].contact_school;
	            var currentPlanStart = this.props.currentPlanStartBySchool[schoolName];
	
	            var planStartRange = new Date(currentPlanStart.getFullYear(), currentPlanStart.getMonth() - 1, currentPlanStart.getDate());
	            var planEndRange = new Date(currentPlanStart.getFullYear(), currentPlanStart.getMonth() + 1, currentPlanStart.getDate());
	
	            var currentTokens = _underscore2.default.filter(tokens, function (token) {
	                var tokenDate = new Date(token.start_date).getTime();
	                return tokenDate > planStartRange.getTime() && tokenDate < planEndRange.getTime();
	            });
	
	            var rows = currentTokens.map(function (token) {
	                return React.createElement(
	                    "tr",
	                    { key: token.code },
	                    React.createElement(
	                        "td",
	                        null,
	                        token.contact_name ? token.contact_name : "--"
	                    ),
	                    React.createElement(
	                        "td",
	                        null,
	                        token.contact_email ? token.contact_email : "--"
	                    ),
	                    React.createElement(
	                        "td",
	                        null,
	                        token.code ? token.code : "--"
	                    ),
	                    React.createElement(
	                        "td",
	                        null,
	                        _this3.generateStatusText(token)
	                    ),
	                    React.createElement(
	                        "td",
	                        null,
	                        _this3.generateOnboardingStatus(token)
	                    )
	                );
	            });
	            return rows;
	        }
	    }, {
	        key: "generateStatusText",
	        value: function generateStatusText(token) {
	            if (token.user_info && !_underscore2.default.isEmpty(token.user_info)) {
	                var text = React.createElement(
	                    "span",
	                    { className: "success" },
	                    "Redeemed"
	                );
	            } else {
	                text = React.createElement(
	                    "div",
	                    null,
	                    React.createElement(
	                        "span",
	                        { className: "fail" },
	                        "Not redeemed "
	                    )
	                );
	            }
	            return text;
	        }
	    }, {
	        key: "generateOnboardingStatus",
	        value: function generateOnboardingStatus(token) {
	            var adminInfo = token.user_info;
	
	            // If no user is connected to the token
	            if (_underscore2.default.isEmpty(adminInfo)) {
	                return "Pending";
	            }
	
	            //If the subadmin is an admin (not a teacher), they don't have primary students.
	            if (!adminInfo.role || adminInfo.role == "adminRole" || adminInfo.role == "districtAdminRole") {
	                return "N/A";
	            }
	
	            // If they're a teacher, check if they added students
	            if (adminInfo['add_students']) {
	                return React.createElement(
	                    "span",
	                    { className: "success" },
	                    "Yes"
	                );
	            } else {
	                return React.createElement(
	                    "span",
	                    { className: "fail" },
	                    " No "
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.props.loading) {
	                return React.createElement(
	                    "div",
	                    { className: "spinnerContainer" },
	                    React.createElement(Spinner, null)
	                );
	            }
	            if (_underscore2.default.isEmpty(this.props.tokensBySchool)) {
	                return React.createElement(
	                    "div",
	                    null,
	                    React.createElement(
	                        "span",
	                        null,
	                        "No upgrade codes exist for your school or district "
	                    )
	                );
	            }
	            var helpText = React.createElement(
	                "a",
	                { href: "https://whooosreading.zendesk.com/hc/en-us/articles/360024144952", target: "_blank" },
	                "Need help with activation codes? Learn more ",
	                React.createElement(Glyphicon, { icon: "new-window" })
	            );
	            var tables = this.renderTables();
	            return React.createElement(
	                "div",
	                null,
	                helpText,
	                tables
	            );
	        }
	    }]);
	
	    return UpgradeCodeTablePreference;
	}(React.Component)) || _class) || _class);
	
	
	UpgradeCodeTablePreference.WrappedComponent.propTypes = PageStrictPropTypes({
	
	    // All data from @connect
	
	    loading: PropTypes.bool,
	    //signed in admin
	    admin: PropTypes.object,
	    //all other subadmins that have a token in their district
	    subAdmins: PropTypes.array,
	    //all tokens in the district
	    tokens: PropTypes.array,
	    //tokens organized into tables
	    tokensBySchool: PropTypes.object,
	    // Handlers from @connect
	    populateData: PropTypes.func
	});
	
	module.exports = UpgradeCodeTablePreference;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	
	var WritingDeletionPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			prefs: prefs
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(WritingDeletionPreference, _React$Component);
	
		function WritingDeletionPreference(props) {
			_classCallCheck(this, WritingDeletionPreference);
	
			var _this = _possibleConstructorReturn(this, (WritingDeletionPreference.__proto__ || Object.getPrototypeOf(WritingDeletionPreference)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("WritingDeletionPreference");
			return _this;
		}
	
		_createClass(WritingDeletionPreference, [{
			key: "onWritingDeletionChange",
			value: function onWritingDeletionChange(value) {
				var prefsHash = { allow_student_writing_deletion: value };
				this.props.onChange(prefsHash, "You successfully changed the writing deletion setting.");
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						"Control whether your students can delete their previous answers, reviews, or quizzes."
					),
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onWritingDeletionChange.bind(this, true),
								checked: this.props.prefs.allow_student_writing_deletion === true }),
							"Allow students to delete their written responses"
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onWritingDeletionChange.bind(this, false),
								checked: this.props.prefs.allow_student_writing_deletion === false }),
							"Do not allow students to delete their written responses"
						)
					)
				);
			}
		}]);
	
		return WritingDeletionPreference;
	}(React.Component)) || _class) || _class);
	
	
	WritingDeletionPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object.isRequired,
		// Handlers from @connect
		onChange: PropTypes.func.isRequired,
		populateData: PropTypes.func.isRequired
	
	});
	
	module.exports = WritingDeletionPreference;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	var UIActions = __webpack_require__(41);
	var ReadingLevelFormatPreference = __webpack_require__(915);
	var PaywallModal = __webpack_require__(44);
	
	var ZPDPreferences = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
		var hasDifferentiation = Features.isEnabled(Features.STUDENT_DIFFERENTIATION);
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
	
		return {
			automaticZPDExclude: prefs.automatic_zpd_exclusion,
			showStudentsZPDIcon: prefs.show_students_zpd_icon,
			hasDifferentiation: hasDifferentiation
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			},
			showZPDReadingLevelsPaywall: function showZPDReadingLevelsPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS }));
			}
	
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ZPDPreferences, _React$Component);
	
		function ZPDPreferences(props) {
			_classCallCheck(this, ZPDPreferences);
	
			var _this = _possibleConstructorReturn(this, (ZPDPreferences.__proto__ || Object.getPrototypeOf(ZPDPreferences)).call(this));
	
			autobind(_this);
			_this.myRef = React.createRef();
			LuckyOrangeClient.tagComponent("ZPDPreferences");
			return _this;
		}
	
		_createClass(ZPDPreferences, [{
			key: "onOptionChange",
			value: function onOptionChange(which) {
				if (!this.props.hasDifferentiation) {
					this.props.showZPDReadingLevelsPaywall();
				} else {
					if (which == "optionOne") {
						var prefsHash = { automatic_zpd_exclusion: true, show_students_zpd_icon: true };
					} else if (which == "optionTwo") {
						var prefsHash = { automatic_zpd_exclusion: false, show_students_zpd_icon: true };
					} else if (which == "optionThree") {
						var prefsHash = { automatic_zpd_exclusion: false, show_students_zpd_icon: false };
					}
	
					this.props.onChange(prefsHash, "You successfully changed the ZPD setting.");
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var scrollToRLD = $wr.getURLParameterByName("showRLD");
				if (scrollToRLD) {
					var section = document.querySelector('.rld');
					section.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		}, {
			key: "render",
			value: function render() {
				var readingLevelFormatSelector = React.createElement(ReadingLevelFormatPreference, { onChange: this.props.onChange });
				return React.createElement(
					"div",
					null,
					readingLevelFormatSelector,
					React.createElement(
						"div",
						{ className: "subContainer" },
						React.createElement(
							"p",
							{ className: "subTitle" },
							"ZPD"
						),
						React.createElement(
							"p",
							null,
							"Control whether books below students\u2019 reading levels count toward your goals."
						),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "optionOne"),
								checked: this.props.automaticZPDExclude && this.props.showStudentsZPDIcon }),
							"Exclude & Show ZPD Icons",
							React.createElement(
								"p",
								null,
								"Don't count books below a student's reading level toward goals. Students can see if books are below, at, or above their reading level."
							)
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "optionTwo"),
								checked: !this.props.automaticZPDExclude && this.props.showStudentsZPDIcon }),
							"Don't Exclude & Show ZPD Icons",
							React.createElement(
								"p",
								null,
								"Count books of any reading level toward goals but show students if books are below, at, or above their reading level."
							)
						),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onOptionChange.bind(this, "optionThree"),
								checked: !this.props.automaticZPDExclude && !this.props.showStudentsZPDIcon }),
							"Don't Exclude & Don't show ZPD Icons",
							React.createElement(
								"p",
								null,
								"Allow books of any reading level to count toward goals and do not show students if books are below, at, or above their reading level."
							)
						)
					)
				);
			}
		}]);
	
		return ZPDPreferences;
	}(React.Component)) || _class);
	
	
	module.exports = ZPDPreferences;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var PaywallModal = __webpack_require__(44);
	var UIActions = __webpack_require__(41);
	var Features = __webpack_require__(16);
	
	var BackLogReadingPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
		var hasLogReading = Features.isEnabled(Features.LOG_READING);
		return {
			prefs: prefs,
			hasLogReading: hasLogReading
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			showLogReadingPaywall: function showLogReadingPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(BackLogReadingPreference, _React$Component);
	
		function BackLogReadingPreference(props) {
			_classCallCheck(this, BackLogReadingPreference);
	
			var _this = _possibleConstructorReturn(this, (BackLogReadingPreference.__proto__ || Object.getPrototypeOf(BackLogReadingPreference)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(BackLogReadingPreference, [{
			key: "onBackLogChange",
			value: function onBackLogChange(value) {
				if (!this.props.hasLogReading) {
					this.props.showLogReadingPaywall();
				} else {
					var prefsHash = { back_log_date_period: value };
					this.props.onChange(prefsHash, "You successfully changed the backlog reading setting.");
				}
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"p",
						null,
						"Control whether your students can log reading for only today or up to seven days before today."
					),
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onBackLogChange.bind(this, 7),
								checked: this.props.prefs.back_log_date_period == 7 }),
							"Allow students to log reading for the previous week."
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onBackLogChange.bind(this, 1),
								checked: this.props.prefs.back_log_date_period == 1 }),
							"Do not allow students to log reading for the last week (just today)."
						)
					)
				);
			}
		}]);
	
		return BackLogReadingPreference;
	}(React.Component)) || _class) || _class);
	
	
	BackLogReadingPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object,
		// Handlers from @connect
		hasLogReading: PropTypes.bool,
		onChange: PropTypes.func.isRequired,
		showLogReadingPaywall: PropTypes.func,
		populateData: PropTypes.func.isRequired
	});
	module.exports = BackLogReadingPreference;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var PaywallModal = __webpack_require__(44);
	var UIActions = __webpack_require__(41);
	var Features = __webpack_require__(16);
	
	var LogReadingViewPreference = (_dec = (0, _reactRedux.connect)(function (state, props) {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {};
		var admin = RosterSelectors.admin({ state: state, id: CurrentUser.get().id });
	
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
		var hasLogReading = Features.isEnabled(Features.LOG_READING);
		return {
			prefs: prefs,
			hasLogReading: hasLogReading
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				//STEP 1: Grab logged in admin
				return Promise.all([dispatch(RosterActions.fetchAdmins({
					filters: { ids: [CurrentUser.get().id] },
					embeds: ['user.prefs'],
					cache: true
				}))]);
			},
			showLogReadingPaywall: function showLogReadingPaywall() {
				return dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }));
			},
			onChange: function onChange(prefsUpdate, message) {
	
				// RESETING ALL STUDENT LISTS
				var resetStudentLists = false;
	
				if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
					resetStudentLists = true;
				}
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: message, icon: "ok-sign"
				});
	
				return dispatch(RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}));
			}
	
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(LogReadingViewPreference, _React$Component);
	
		function LogReadingViewPreference(props) {
			_classCallCheck(this, LogReadingViewPreference);
	
			var _this = _possibleConstructorReturn(this, (LogReadingViewPreference.__proto__ || Object.getPrototypeOf(LogReadingViewPreference)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(LogReadingViewPreference, [{
			key: "onLogReadingViewChange",
			value: function onLogReadingViewChange(value) {
				if (!this.props.hasLogReading) {
					this.props.showLogReadingPaywall();
				} else {
					var prefsHash = { log_reading_detailed_view: value };
					this.props.onChange(prefsHash, "You successfully changed the log reading view setting.");
				}
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "logReadingViewPreference" },
					React.createElement(
						"p",
						null,
						"Have your students fill out more detailed reading logs, including start and end times, and where they did the reading."
					),
					React.createElement(
						"div",
						{ className: "viewableScoreOptions" },
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onLogReadingViewChange.bind(this, true),
								checked: this.props.prefs.log_reading_detailed_view == true }),
							"Show detailed reading log"
						),
						React.createElement("br", null),
						React.createElement(
							"label",
							null,
							React.createElement("input", { type: "radio", onChange: this.onLogReadingViewChange.bind(this, false),
								checked: this.props.prefs.log_reading_detailed_view == false }),
							"Hide detailed reading log"
						)
					)
				);
			}
		}]);
	
		return LogReadingViewPreference;
	}(React.Component)) || _class) || _class);
	
	
	LogReadingViewPreference.WrappedComponent.propTypes = StrictPropTypes({
		prefs: PropTypes.object,
		// Handlers from @connect
		hasLogReading: PropTypes.bool,
		onChange: PropTypes.func.isRequired,
		showLogReadingPaywall: PropTypes.func,
		populateData: PropTypes.func.isRequired
	});
	
	module.exports = LogReadingViewPreference;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactYoutube = __webpack_require__(3605);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactSticky = __webpack_require__(3600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisplayToggleControl = __webpack_require__(48);
	var StepProgressMeter = __webpack_require__(249);
	var LearningSeries = __webpack_require__(433);
	
	var TutorialDisplay = function (_React$Component) {
		_inherits(TutorialDisplay, _React$Component);
	
		function TutorialDisplay(props) {
			_classCallCheck(this, TutorialDisplay);
	
			var _this = _possibleConstructorReturn(this, (TutorialDisplay.__proto__ || Object.getPrototypeOf(TutorialDisplay)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(TutorialDisplay, [{
			key: 'onViewChange',
			value: function onViewChange(view) {
				this.props.changeLevelF(view);
			}
		}, {
			key: 'onEnd',
			value: function onEnd(videoKey) {
				this.props.completeVideoF(videoKey);
				window.wrNotifications.triggerDropDownNotification({
					title: "Video Finished!", text: "We're sure you learned a lot!", icon: "ok-sign"
				});
			}
		}, {
			key: 'renderProgressMeter',
			value: function renderProgressMeter() {
				// Step Progress Meter for progress within a module level *
	
				var allVideos = this.props.allVideos;
				var videosCount = allVideos.length;
				var iconPathStems = [];
	
				_.times(videosCount, function (n) {
					iconPathStems.push("misc/film");
				});
	
				var currentStep = LearningSeries.countComplete(this.props.allVideos, this.props.completedVideos) + 1;
	
				var progressMeter = React.createElement(StepProgressMeter, { numSteps: videosCount, currentStep: currentStep, iconPathStems: iconPathStems });
	
				var progressMeterArea = React.createElement(
					'div',
					{ className: 'progressBarContainer' },
					progressMeter
				);
	
				return progressMeterArea;
			}
		}, {
			key: 'renderVideoContainer',
			value: function renderVideoContainer(stickyProps) {
				var mainVideo = this.props.video;
	
				// Actual iframe video from YouTube iframe API and video title* 
				var videoTitle = React.createElement(
					'p',
					{ className: 'videoTitle' },
					mainVideo.title
				);
				var opts = { height: '315', width: '560' };
				var videoID = mainVideo.videoID;
				var iframeVideo = React.createElement(_reactYoutube2.default, { videoId: videoID, opts: opts, onEnd: this.onEnd.bind(this, mainVideo.key) });
	
				// Checks and sets content based on whether action is complete *
				// If there is an action related to this video, this is it *
	
				if (this.props.action) {
					var mainAction = this.props.action; // -- .title for once its completed? and icon? 
					var actionCompleted = _.includes(this.props.completedActions, mainAction.key);
					var nextStepDescription = mainAction.description;
	
					if (actionCompleted) {
						var completedActionClass = "complete";
					}
	
					var actionContent = React.createElement(
						'div',
						{ className: "actionContent " + completedActionClass },
						React.createElement(
							'p',
							{ className: 'nextStepLabel' },
							'Next Step:'
						),
						React.createElement(
							'p',
							{ className: 'actionContentText' },
							React.createElement('span', { className: 'glyphicon glyphicon-ok-circle' }),
							nextStepDescription
						)
					);
				}
	
				if (stickyProps.isSticky) {
					var stickyStyle = _.extend({}, stickyProps.style, { paddingTop: "55px" });
				}
				var videoContainer = React.createElement(
					'div',
					{ className: 'videoContainer', style: stickyStyle },
					videoTitle,
					iframeVideo,
					React.createElement(
						'div',
						{ className: 'actionContainer' },
						actionContent
					)
				);
				return videoContainer;
			}
		}, {
			key: 'renderToggleOptions',
			value: function renderToggleOptions() {
				var toggleOptions = [{ key: LearningSeries.BEG_LEVEL, text: "Beginner" }, { key: LearningSeries.INT_LEVEL, text: "Intermediate" }, { key: LearningSeries.ADV_LEVEL, text: "Advanced" }];
	
				var displayToggleControl = React.createElement(DisplayToggleControl, { options: toggleOptions,
					onChange: this.onViewChange,
					activeOptionKey: this.props.video.level });
	
				return React.createElement(
					'div',
					{ className: 'toggleLinks' },
					displayToggleControl
				);
			}
		}, {
			key: 'renderNextVideosDisplay',
			value: function renderNextVideosDisplay() {
				var _this2 = this;
	
				var allVideos = this.props.allVideos;
				var videosCount = allVideos.length;
				var nextVideosDisplay = _.map(allVideos, function (video) {
					var videoKey = video.key;
					if (_.includes(_this2.props.completedVideos, video.key)) {
						var completedVideoClass = "completedVideo";
					}
					return React.createElement(
						'div',
						{ className: "nextVideo clickableElement " + completedVideoClass,
							onClick: _this2.props.changeVideoF.bind(_this2, video),
							key: video.key },
						React.createElement(
							'div',
							null,
							React.createElement('span', { className: 'glyphicon glyphicon-film' }),
							React.createElement(
								'span',
								{ className: 'videoTitle' },
								video.title
							)
						),
						React.createElement(
							'span',
							null,
							video.description
						)
					);
				});
				return nextVideosDisplay;
			}
		}, {
			key: 'render',
			value: function render() {
				var mainVideo = this.props.video;
	
				// don't display the toggle for the quick start module because only one level
				if (this.props.video.module != LearningSeries.QUICK_MODULE) {
					var toggleOptions = this.renderToggleOptions();
				}
	
				var videoContainer = React.createElement(
					_reactSticky.StickyContainer,
					null,
					React.createElement(
						'div',
						{ className: 'stickyContainer' },
						React.createElement(
							_reactSticky.Sticky,
							{ topOffset: -55 },
							this.renderVideoContainer
						)
					),
					React.createElement(
						'div',
						{ className: 'otherModuleVideosContainer' },
						toggleOptions,
						React.createElement(
							'div',
							{ className: 'otherModuleVideos' },
							this.renderNextVideosDisplay(),
							React.createElement('span', { className: 'videoTitle' })
						)
					)
				);
	
				return React.createElement(
					'div',
					{ className: 'tutorialDisplay' },
					this.renderProgressMeter(),
					videoContainer
				);
			}
		}]);
	
		return TutorialDisplay;
	}(React.Component);
	
	TutorialDisplay.propTypes = PageStrictPropTypes({
		// array of videos that have been watched
		completedVideos: PropTypes.array.isRequired,
		// array of actions that have been done
		completedActions: PropTypes.array.isRequired,
	
		// current video to display
		video: PropTypes.object.isRequired,
		// corresponding action for current video, if there is one
		action: PropTypes.object,
	
		// all videos in the current module and level
		allVideos: PropTypes.array.isRequired,
	
		// function to call when changing videos, provide new video key
		changeVideoF: PropTypes.func.isRequired,
		// function to call when changing levels, provide new level
		changeLevelF: PropTypes.func.isRequired,
		// function to call when changing modules, provide new module
		changeModuleF: PropTypes.func.isRequired,
	
		// function to call to complete a video, provide video key
		completeVideoF: PropTypes.func.isRequired
	});
	
	module.exports = TutorialDisplay;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var LearningSeries = __webpack_require__(433);
	var TutorialDisplay = __webpack_require__(925);
	
	__webpack_require__(3782);
	
	var TutorialsPage = function (_React$Component) {
		_inherits(TutorialsPage, _React$Component);
	
		function TutorialsPage(props) {
			_classCallCheck(this, TutorialsPage);
	
			var _this = _possibleConstructorReturn(this, (TutorialsPage.__proto__ || Object.getPrototypeOf(TutorialsPage)).call(this));
	
			autobind(_this);
			_this.state = {
				completedVideos: [], completedActions: [], currentVideo: null
			};
			return _this;
		}
	
		_createClass(TutorialsPage, [{
			key: "changeVideo",
			value: function changeVideo(newVideo) {
				this.setState({ currentVideo: newVideo });
			}
		}, {
			key: "changeLevel",
			value: function changeLevel(newLevel) {
				var currentVideo = this.state.currentVideo;
				var firstIncompleteVideo = LearningSeries.firstIncompleteVideoInModuleAtLevel(currentVideo.module, newLevel, this.state.completedVideos);
				this.setState({ currentVideo: firstIncompleteVideo });
			}
		}, {
			key: "changeModule",
			value: function changeModule(newModule) {
				var firstIncompleteVideo = LearningSeries.firstIncompleteVideoInModule(newModule, this.state.completedVideos);
				this.setState({ currentVideo: firstIncompleteVideo });
			}
		}, {
			key: "completeVideo",
			value: function completeVideo(videoKey) {
				var _this2 = this;
	
				var params = {
					admin: { completed_tutorial_video: videoKey },
					embed: "admin.completed_tutorial_videos"
				};
				CurrentUser.api().patchAdmin(CurrentUser.get().id, params, $wr.apiHandler(function (response) {
					_this2.setState({ completedVideos: response.admin.completed_tutorial_videos });
				}));
			}
		}, {
			key: "renderModuleNav",
			value: function renderModuleNav(moduleKey) {
				var moduleNavClassName = "navModuleHeaderLink";
				if (this.state.currentVideo.module == moduleKey) {
					moduleNavClassName += " selectedLinkClass";
				}
	
				return React.createElement(
					"div",
					{ className: moduleNavClassName, key: "link-" + moduleKey,
						onClick: this.changeModule.bind(this, moduleKey) },
					LearningSeries.moduleName(moduleKey)
				);
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				if (this.state.currentVideo == null) {
					return React.createElement(
						"div",
						{ className: "tutorialsPage container" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				var currentVideo = this.state.currentVideo;
				var currentModule = currentVideo.module;
				var tutorialDisplay = React.createElement(TutorialDisplay, { video: currentVideo,
					action: LearningSeries.action(currentVideo.key),
					allVideos: LearningSeries.videos(currentModule, currentVideo.level),
					completedVideos: this.state.completedVideos,
					completedActions: this.state.completedActions,
					changeVideoF: this.changeVideo,
					changeLevelF: this.changeLevel,
					changeModuleF: this.changeModule,
					completeVideoF: this.completeVideo });
	
				var moduleNavDisplay = [];
				_.map(LearningSeries.MODULES, function (module, index) {
					moduleNavDisplay.push(_this3.renderModuleNav(module));
					if (index < LearningSeries.MODULES.length - 1) {
						moduleNavDisplay.push(React.createElement("span", { className: "verticalDivider", key: "div-" + index }));
					}
				});
	
				return React.createElement(
					"div",
					{ className: "tutorialsPage container" },
					React.createElement(
						"header",
						{ className: "pageHeader hideOnPrint" },
						React.createElement(
							"h1",
							null,
							"Learning Series"
						)
					),
					React.createElement(
						"div",
						{ className: "tutorialsNavContainer" },
						moduleNavDisplay
					),
					tutorialDisplay
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this4 = this;
	
				var embeds = "admin.completed_tutorial_videos,admin.completed_tutorial_actions";
				CurrentUser.api().getAdmin(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler(function (response) {
					var admin = response.admin;
					_this4.setState({
						completedVideos: admin.completed_tutorial_videos,
						completedActions: admin.completed_tutorial_actions,
						currentVideo: LearningSeries.firstIncompleteVideoInModule(LearningSeries.QUICK_MODULE, admin.completed_tutorial_videos)
					});
				}));
			}
		}]);
	
		return TutorialsPage;
	}(React.Component);
	
	TutorialsPage.propTypes = PageStrictPropTypes({});
	
	module.exports = TutorialsPage;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterDom = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountPlans = __webpack_require__(53);
	var LoadingButton = __webpack_require__(17);
	var CreditCardInput = __webpack_require__(396);
	var PurchaseOrderInput = __webpack_require__(843);
	var CurrentUser = __webpack_require__(3);
	var WhooosReadingServices = __webpack_require__(25);
	var ButtonDropdown = __webpack_require__(23);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdownOption = __webpack_require__(31);
	var Glyphicon = __webpack_require__(8);
	var ErrorDisplay = __webpack_require__(51);
	var Cookies = __webpack_require__(188);
	
	var Spinner = __webpack_require__(9);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var UpgradeTokenForm = __webpack_require__(167);
	var FacebookPixelClient = __webpack_require__(1001);
	
	var DISCOUNT_CODE_KEY = "DISCOUNT_CODE_KEY";
	
	__webpack_require__(3785);
	
	function getDiscountCode() {
		var discountCode = $wr.getURLParameterByName("discount_code");
	
		if (discountCode) {
			Cookies.set(DISCOUNT_CODE_KEY, discountCode, { expires: 10 });
			return discountCode;
		}
	
		discountCode = Cookies.get(DISCOUNT_CODE_KEY);
		if (discountCode) {
			return discountCode;
		}
	}
	
	function clearDiscountCodeCookie() {
		Cookies.remove(DISCOUNT_CODE_KEY);
	}
	
	var UpgradeForm = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			studentLists: RosterSelectors.nonEmptyStudentLists({ state: state }),
			loadingStudentLists: RosterSelectors.isLoadingStudentLists({ state: state }),
			existingPlanStudentListCount: CurrentUser.get().account.plan_student_list_count || 1,
			possibleDiscountToken: RosterSelectors.discountToken({ state: state, code: getDiscountCode() })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				var discountCode = getDiscountCode();
				if (discountCode) {
					return dispatch(RosterActions.fetchDiscountToken({ code: discountCode }));
				} else {
					return Promise.resolve();
				}
			},
	
			upgradeAccount: function upgradeAccount(_ref) {
				var discountCode = _ref.discountCode,
				    planType = _ref.planType,
				    studentListCount = _ref.studentListCount,
				    cardTokenData = _ref.cardTokenData;
	
				var account = {
					plan_type: planType,
					student_list_count: studentListCount
				};
	
				return dispatch(RosterActions.updateAdmin({
					id: CurrentUser.get().id,
					update: { account: account },
					query: {
						discount_code: discountCode,
						card_token_data: cardTokenData
					}
				}));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(UpgradeForm, _React$Component);
	
		function UpgradeForm(props) {
			_classCallCheck(this, UpgradeForm);
	
			var _this = _possibleConstructorReturn(this, (UpgradeForm.__proto__ || Object.getPrototypeOf(UpgradeForm)).call(this));
	
			autobind(_this);
			_this.state = {
				selectedPaymentText: "Credit Card",
				selectedClassCount: null, loading: false,
				showCardFields: false, purchaseOrderValues: {}
			};
			return _this;
		}
	
		////// URL Helper Functions //////
	
	
		_createClass(UpgradeForm, [{
			key: "currentURL",
			value: function currentURL() {
				return new URL(window.location.href);
			}
		}, {
			key: "changeTimeURL",
			value: function changeTimeURL() {
				var currentURL = this.currentURL();
	
				if (this.props.possibleDiscountToken) {
					currentURL.searchParams.set('discount_code', this.props.possibleDiscountToken.code);
				}
	
				if (this.isSemester()) {
					currentURL.searchParams.set('period', 'year');
					return "/upgrade" + currentURL.search;
				} else {
					currentURL.searchParams.set('period', 'semester');
					return "/upgrade" + currentURL.search;
				}
			}
		}, {
			key: "changeProductURL",
			value: function changeProductURL() {
				var currentURL = this.currentURL();
				if (this.props.product == 'silver') {
					currentURL.searchParams.set('plan', 'gold');
					return "/upgrade" + currentURL.search;
				} else {
					currentURL.searchParams.set('plan', 'silver');
					return "/upgrade" + currentURL.search;
				}
			}
			/////////////////////////////////
	
		}, {
			key: "isSemester",
			value: function isSemester() {
				return this.props.period == "semester";
			}
		}, {
			key: "planType",
			value: function planType() {
				if (this.props.product == "silver") {
					if (this.isSemester()) {
						return AccountPlans.SILVER_SEMESTER_PLAN_2019;
					} else {
						return AccountPlans.SILVER_PLAN_2019;
					}
				} else if (this.props.product == "gold") {
					if (this.isSemester()) {
						return AccountPlans.GOLD_SEMESTER_PLAN;
					} else {
						return AccountPlans.GOLD_PLAN;
					}
				}
			}
		}, {
			key: "appliedDiscountToken",
			value: function appliedDiscountToken() {
				var token = this.props.possibleDiscountToken;
				if (token && token.plan_type == this.planType()) {
					return token;
				}
			}
		}, {
			key: "timeDisplay",
			value: function timeDisplay() {
				if (this.isSemester()) {
					return "6 months";
				} else {
					return "1 year";
				}
			}
		}, {
			key: "subTotalPrice",
			value: function subTotalPrice() {
				if (this.props.product == 'silver') {
					return AccountPlans.price(this.planType(), this.numClassesSelected());
				} else {
					return AccountPlans.tieredPrice({ plan: this.planType(), studentListCount: this.numClassesSelected() });
				}
			}
		}, {
			key: "existingPlanValue",
			value: function existingPlanValue() {
				return CurrentUser.get().account.existing_plan_value;
			}
		}, {
			key: "togglePaymentType",
			value: function togglePaymentType(e) {
				$wr.nope(e);
				this.setState({ showCardFields: !this.state.showCardFields });
			}
		}, {
			key: "creditCardFieldsVisible",
			value: function creditCardFieldsVisible() {
				return this.state.showCardFields || !CurrentUser.get().account.has_credit_card;
			}
	
			// selectClasses(event) {
			// 	this.setState({ selectedClassCount: parseInt(event.target.value) });
			// }
	
		}, {
			key: "selectClasses",
			value: function selectClasses(count) {
				this.setState({ selectedClassCount: count });
			}
		}, {
			key: "numClassesSelected",
			value: function numClassesSelected() {
				var defaultAmount = this.props.classCount || Math.max(this.props.studentLists.length, this.props.existingPlanStudentListCount);
				return this.state.selectedClassCount || defaultAmount;
			}
		}, {
			key: "selectPaymentType",
			value: function selectPaymentType(paymentText) {
				this.setState({ selectedPaymentText: paymentText, showCardFields: false });
			}
		}, {
			key: "onPurchaseOrderChange",
			value: function onPurchaseOrderChange(purchaseOrderValues) {
				this.setState({ purchaseOrderValues: purchaseOrderValues });
			}
		}, {
			key: "selectedCreditCard",
			value: function selectedCreditCard() {
				return this.state.selectedPaymentText == "Credit Card";
			}
		}, {
			key: "upgradeAdmin",
			value: function upgradeAdmin(cardTokenData) {
				var _this2 = this;
	
				var upgradeArgs = {
					planType: this.planType(),
					studentListCount: this.numClassesSelected()
				};
	
				if (cardTokenData) {
					upgradeArgs.cardTokenData = cardTokenData;
				}
	
				if (this.appliedDiscountToken()) {
					upgradeArgs.discountCode = this.appliedDiscountToken().code;
				}
	
				this.props.upgradeAccount(upgradeArgs).then(function () {
					Mycroft.newEvent({ category: "Upgrade", action: "pay-by-cc", label: _this2.props.product });
	
					window.wrNotifications.triggerDropDownNotification({
						title: "Thank You!",
						text: "You have upgraded your account to " + $wr.capitalize(_this2.props.product) + "!",
						icon: "star"
					}, 5000);
	
					FacebookPixelClient.upgrade(_this2.subTotalPrice() / 100);
	
					if (_this2.props.afterUpgrade) {
						_this2.props.afterUpgrade();
					} else {
						CurrentUser.fetchCurrentUserData(function () {
							_this2.setState({ loading: false });
							$wr.redirect("/");
						});
					}
				});
			}
		}, {
			key: "sendPOInfo",
			value: function sendPOInfo(poFields) {
				var _this3 = this;
	
				var user = CurrentUser.get();
				poFields = _.extend({}, poFields, {
					plan_type: this.planType(),
					student_list_count: this.numClassesSelected(),
					existing_plan_value: $wr.centsToDollars(this.existingPlanValue())
				});
	
				var purchaseInfoText = _.map(_.pairs(poFields), function (pair) {
					return pair.join(": ");
				}).join("\n\n");
	
				var message = "Purchase Order Request\n\n" + purchaseInfoText;
	
				var params = {
					contact_message: {
						message: message
					},
					purchase_order: true
				};
	
				this.setState({ loading: true });
				CurrentUser.api().postContactMessages(params, function () {
					Mycroft.newEvent({ category: "Upgrade", action: "pay-by-po", label: _this3.props.product });
	
					window.wrNotifications.triggerDropDownNotification({
						title: "PO Request Received!",
						text: "We'll send a quote to your accounts payable contact.",
						icon: "star"
					}, 5000);
					$wr.redirect("/");
				});
			}
		}, {
			key: "onSubmit",
			value: function onSubmit(e) {
				var _this4 = this;
	
				$wr.nope(e);
	
				if (this.selectedCreditCard()) {
					this.setState({ loading: true });
	
					var currentUser = CurrentUser.get();
					var userData = { name: currentUser.first_name + " " + currentUser.last_name,
						email: currentUser.email };
	
					if (this.creditCardFieldsVisible()) {
						this.refs.creditCard.tokenize(userData, function (success, tokenData) {
							if (success) {
								_this4.upgradeAdmin(tokenData);
							} else {
								_this4.setState({ loading: false });
							}
						});
					} else {
						this.upgradeAdmin();
					}
				} else {
					this.refs.poErrors.reset();
	
					var poFields = _.clone(this.state.purchaseOrderValues);
					var requiredFields = _.reject(poFields, function (val, key) {
						return key == "comments";
					});
					var nonBlankCount = _.select(_.values(requiredFields), function (t) {
						return t.trim().length > 0;
					}).length;
					if (nonBlankCount < 3) {
						this.refs.poErrors.setError("Please provide a name, email, and phone number for your school's purchasing contact.");
						return;
					}
	
					this.sendPOInfo(poFields);
				}
			}
		}, {
			key: "calculateDiscount",
			value: function calculateDiscount(classCount) {
				var token = this.appliedDiscountToken();
				var plan = this.planType();
	
				var discount = 0;
				if (token) {
					if (token.fixed_discount) {
						discount += token.fixed_discount;
					}
					if (token.fixed_price) {
						discount += AccountPlans.fixedPrice(plan) - token.fixed_price;
					}
					if (token.per_class_price) {
						discount += (AccountPlans.perClassPrice(plan) - token.per_class_price) * classCount;
					}
				}
	
				return discount;
			}
		}, {
			key: "removeDiscount",
			value: function removeDiscount(e) {
				$wr.nope(e);
	
				var switchURL = "/upgrade?plan=" + this.props.product;
				switchURL += "&period=" + (this.isSemester() ? "semester" : "year");
	
				clearDiscountCodeCookie();
	
				$wr.redirect(switchURL);
				this.props.populateData();
			}
		}, {
			key: "renderDiscountInfo",
			value: function renderDiscountInfo() {
				var token = this.appliedDiscountToken();
	
				if (token) {
					if (token.end_date) {
						var expiration = "Discount expires: " + $wr.formatDate(token.end_date);
					}
					return React.createElement(
						"div",
						{ className: "discountInfo clearfix" },
						expiration,
						React.createElement(
							"a",
							{ className: "removeLink", href: "#", onClick: this.removeDiscount },
							React.createElement(Glyphicon, { icon: "remove" }),
							" Remove discount"
						)
					);
				}
			}
		}, {
			key: "renderPlanContent",
			value: function renderPlanContent() {
				var _this5 = this;
	
				var selectedContent = null;
				var numSelected = this.numClassesSelected();
	
				var numClassesOptions = _.map(Array(MAX_CLASSES - 1).fill(), function (_, index) {
					var classCount = index + 1;
					var classesText = $wr.pluralizeWithNumber("class", classCount, "classes");
	
					if (_this5.props.product == 'silver') {
						var basePrice = AccountPlans.price(_this5.planType(), classCount);
					} else {
						var basePrice = AccountPlans.tieredPrice({ plan: _this5.planType(), studentListCount: classCount });
					}
	
					var basePriceText = $wr.centsToDollars(basePrice, true);
	
					var discount = _this5.calculateDiscount(classCount);
	
					if (discount == 0) {
						var periodText = _this5.isSemester() ? "/semester" : "/year";
	
						var optionDisplay = React.createElement(
							"span",
							null,
							classesText,
							" - ",
							basePriceText,
							periodText
						);
					} else {
						var discountedPriceText = $wr.centsToDollars(basePrice - discount, true);
						var optionDisplay = React.createElement(
							"span",
							null,
							classesText,
							" - ",
							React.createElement(
								"span",
								{ className: "originalPrice" },
								basePriceText
							),
							" ",
							discountedPriceText,
							periodText
						);
					}
	
					if (classCount == numSelected) {
						selectedContent = optionDisplay;
					}
	
					return React.createElement(ButtonDropdownOption, { onClick: _this5.selectClasses.bind(_this5, classCount),
						text: optionDisplay, key: classCount });
				});
	
				if (this.props.loadingStudentLists) {
					var planPriceContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
					var numClassesDropdown = React.createElement(
						ButtonDropdown,
						{ text: selectedContent, dropdownDisplay: "button" },
						numClassesOptions
					);
	
					if (this.numClassesSelected() >= MAX_CLASSES) {
						var planPriceContent = React.createElement(
							"div",
							{ className: "contactUsLink" },
							React.createElement(
								"a",
								{ href: WhooosReadingServices.OuterPages.url("/schools#contactForm") },
								"Contact us"
							)
						);
					}
				}
	
				var changeTimeText = this.isSemester() ? 'Switch to Annual' : 'Switch to Semester';
				var changePricingLink = React.createElement(
					_reactRouterDom.Link,
					{ to: this.changeTimeURL() },
					changeTimeText
				);
	
				var changeProductURL = this.changeProductURL();
	
				return React.createElement(
					"div",
					{ className: "planContent" },
					React.createElement(
						"div",
						{ className: "planBoxHeader" },
						"Your plan",
						React.createElement(
							"a",
							{ href: changeProductURL,
								className: "changePlanLink" },
							"Change plan"
						)
					),
					React.createElement(
						"div",
						{ className: "planDetailsBox" },
						React.createElement(
							"div",
							{ className: "planDetails" },
							this.timeDisplay(),
							" of WR ",
							$wr.capitalize(this.props.product),
							React.createElement("span", { className: "verticalDivider" }),
							changePricingLink
						),
						React.createElement(
							"div",
							{ className: "classesPricing" },
							numClassesDropdown,
							planPriceContent
						),
						this.renderDiscountInfo()
					)
				);
			}
		}, {
			key: "renderPaymentContent",
			value: function renderPaymentContent() {
				var paymentOptions = DropDownOptions.Button.simpleText({
					options: ["Credit Card", "Purchase Order", "Upgrade Code"],
					onClick: this.selectPaymentType
				});
				var paymentTypeDropdown = React.createElement(
					ButtonDropdown,
					{ text: this.state.selectedPaymentText, dropdownDisplay: "button",
						className: "paymentTypeDropdown" },
					paymentOptions
				);
	
				var existingValue = this.existingPlanValue();
				var oneTimeDiscount = this.calculateDiscount(this.numClassesSelected());
				var subTotalPrice = this.subTotalPrice();
	
				if (this.selectedCreditCard()) {
					if (this.creditCardFieldsVisible()) {
						var paymentInfo = { stripe_public_key: CreditCardInput.STRIPE_PUBLIC_KEY };
						var paymentForm = React.createElement(CreditCardInput, { ref: "creditCard", paymentInfo: paymentInfo });
					} else {
						var paymentForm = React.createElement(
							"div",
							{ className: "existingPaymentMethod" },
							"Payment Method: ",
							CurrentUser.paymentMethodSummary(),
							React.createElement("br", null),
							React.createElement(
								"a",
								{ href: "#", onClick: this.togglePaymentType, className: "changeLink" },
								"Change payment method"
							)
						);
					}
	
					if (this.isSemester()) {
						var chargeText = "charge you every 6 months";
					} else {
						var chargeText = "charge you every year";
					}
	
					if (oneTimeDiscount + existingValue > 0) {
						var higherRenewalMessage = React.createElement(
							"span",
							null,
							"This plan will renew at the regular price of ",
							$wr.centsToDollars(subTotalPrice, false),
							"."
						);
					}
	
					var purchaseDisclaimer = React.createElement(
						"div",
						{ className: "purchaseDisclaimer" },
						"By completing this purchase, you authorize Whooo's Reading to ",
						chargeText,
						" until you cancel your subscription.",
						" ",
						higherRenewalMessage
					);
					var submitText = "Complete Purchase";
				} else {
					if (this.state.selectedPaymentText == UPGRADE_CODE) {
						var upgradeForm = React.createElement(UpgradeTokenForm, { showCompleteButton: true, loadingStudentLists: this.props.loadingStudentLists });
					} else {
						var paymentForm = React.createElement(
							"div",
							null,
							React.createElement(ErrorDisplay, { ref: "poErrors" }),
							React.createElement(PurchaseOrderInput, { values: this.state.purchaseOrderValues,
								onChange: this.onPurchaseOrderChange })
						);
						var purchaseDisclaimer = React.createElement(
							"div",
							{ className: "purchaseDisclaimer" },
							"We will provide a formal quote to the contact above and turn on your paid features once we receive a purchase order."
						);
	
						var submitText = "Submit PO Request";
					}
				}
	
				if (this.state.selectedPaymentText != UPGRADE_CODE) {
					var submitButton = React.createElement(
						"div",
						{ className: "submitButton" },
						React.createElement(LoadingButton, { className: "btn buttonSuccess",
							onClick: this.onSubmit, text: submitText,
							loading: !!(this.state.loading || this.props.loadingStudentLists) })
					);
	
					var amountClass = "totalDollars";
	
					var totalPrice = subTotalPrice;
	
					var discountMessage = "";
	
					if (existingValue && existingValue > 0) {
						totalPrice = totalPrice - existingValue;
	
						discountMessage = "You are getting a " + $wr.centsToDollars(existingValue, false) + " discount based on value remaining on your current plan.";
	
						var existingValueDiscountSection = React.createElement(
							"span",
							{ className: "subtotalLine" },
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "totalLabel" },
								"Discount:"
							),
							"-",
							$wr.centsToDollars(existingValue, false)
						);
					}
	
					if (oneTimeDiscount && oneTimeDiscount > 0) {
						totalPrice = totalPrice - oneTimeDiscount;
	
						if (discountMessage.length > 0) {
							discountMessage += " You are also ";
						} else {
							discountMessage += "You are ";
						}
	
						discountMessage += "getting a one-time ";
	
						discountMessage += $wr.centsToDollars(oneTimeDiscount, false) + " discount.";
	
						var oneTimeDiscountSection = React.createElement(
							"span",
							{ className: "subtotalLine" },
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "totalLabel" },
								"Discount:"
							),
							"-",
							$wr.centsToDollars(oneTimeDiscount, false)
						);
					}
	
					if (totalPrice < 0) {
						totalPrice = 0;
					}
	
					if (existingValueDiscountSection || oneTimeDiscountSection) {
						var subTotalSection = React.createElement(
							"div",
							{ className: "subTotalSection" },
							React.createElement(
								"span",
								{ className: "totalLabel" },
								"Subtotal:"
							),
							$wr.centsToDollars(subTotalPrice, false),
							existingValueDiscountSection,
							oneTimeDiscountSection
						);
					}
	
					var totalPriceDisplay = $wr.centsToDollars(totalPrice, false);
	
					if (totalPrice == subTotalPrice) {
						amountClass += " noSubtotal";
					}
	
					if (discountMessage.length) {
						var discountMessageDisplay = React.createElement(
							"div",
							{ className: "discountMessage" },
							discountMessage
						);
					}
	
					var submitSection = React.createElement(
						"div",
						{ className: "submitPayment" },
						discountMessageDisplay,
						React.createElement(
							"div",
							{ className: "totalAmount" },
							subTotalSection,
							React.createElement(
								"span",
								{ className: "totalLine" },
								React.createElement(
									"span",
									{ className: "totalLabel" },
									"Total:"
								),
								React.createElement(
									"span",
									{ className: amountClass },
									totalPriceDisplay
								)
							)
						),
						submitButton
					);
					var term = "purchase";
				} else {
					var term = "upgrade";
				}
	
				var termsLink = React.createElement(
					"a",
					{ href: WhooosReadingServices.OuterPages.url("/terms") },
					"Terms of Service"
				);
				var privacyLink = React.createElement(
					"a",
					{ href: WhooosReadingServices.OuterPages.url("/privacy") },
					"Privacy Policy"
				);
	
				var termsDisclaimer = React.createElement(
					"div",
					{ className: "termsDisclaimer" },
					"By completing this ",
					term,
					", you agree to our ",
					termsLink,
					" and ",
					privacyLink,
					"."
				);
	
				return React.createElement(
					"div",
					{ className: "paymentContentContainer" },
					React.createElement(
						"div",
						{ className: "paymentChoiceLabel" },
						"Choose your payment method"
					),
					paymentTypeDropdown,
					paymentForm,
					upgradeForm,
					purchaseDisclaimer,
					submitSection,
					termsDisclaimer
				);
			}
		}, {
			key: "render",
			value: function render() {
				// only display payment content if less than MAX_CLASSES classes selected
				if (this.numClassesSelected() < MAX_CLASSES) {
					var paymentContent = this.renderPaymentContent();
				}
	
				return React.createElement(
					"div",
					{ className: "upgradeForm" },
					React.createElement(
						"div",
						{ className: "container upgradeContainer" },
						this.renderPlanContent(),
						paymentContent
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.populateData();
				FacebookPixelClient.init();
			}
		}]);
	
		return UpgradeForm;
	}(React.Component)) || _class);
	;
	
	var MAX_CLASSES = 7;
	
	var UPGRADE_CODE = "Upgrade Code";
	
	UpgradeForm.WrappedComponent.propTypes = StrictPropTypes({
		// From @connect
		studentLists: PropTypes.array.isRequired,
		existingPlanStudentListCount: PropTypes.number.isRequired,
		loadingStudentLists: PropTypes.bool,
		populateData: PropTypes.func.isRequired,
		upgradeAccount: PropTypes.func.isRequired,
		possibleDiscountToken: PropTypes.object,
		classCount: PropTypes.number,
	
		product: PropTypes.string.isRequired,
		period: PropTypes.string.isRequired,
		afterUpgrade: PropTypes.func
	
	});
	
	module.exports = UpgradeForm;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpgradeHeader = __webpack_require__(247);
	var UpgradeForm = __webpack_require__(927);
	var CurrentUser = __webpack_require__(3);
	var LiveChatClient = __webpack_require__(438);
	
	var UpgradePage = function (_React$Component) {
		_inherits(UpgradePage, _React$Component);
	
		function UpgradePage(props) {
			_classCallCheck(this, UpgradePage);
	
			var _this = _possibleConstructorReturn(this, (UpgradePage.__proto__ || Object.getPrototypeOf(UpgradePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(UpgradePage, [{
			key: "getPlan",
			value: function getPlan() {
				return $wr.getURLParameterByName("plan");
			}
		}, {
			key: "getPeriod",
			value: function getPeriod() {
				return $wr.getURLParameterByName("period") || "year";
			}
		}, {
			key: "getClassCount",
			value: function getClassCount() {
				return parseInt($wr.getURLParameterByName("class_count")) || 1;
			}
		}, {
			key: "afterUpgrade",
			value: function afterUpgrade() {
				CurrentUser.fetchCurrentUserData(function () {
					$wr.redirect('/');
				});
			}
		}, {
			key: "render",
			value: function render() {
				var plan = this.getPlan();
	
				return React.createElement(
					"div",
					{ className: "upgradePage" },
					React.createElement(UpgradeHeader, { product: plan,
						showSkipOption: CurrentUser.get().pending_onboarding }),
					React.createElement(UpgradeForm, { product: plan, period: this.getPeriod(),
						classCount: this.getClassCount(), afterUpgrade: this.afterUpgrade })
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				LiveChatClient.init(CurrentUser.get());
	
				// temporarily make view mobile-responsive
				var metaTag = document.createElement("meta");
				metaTag.name = "viewport";
				metaTag.id = "tempViewportElement";
				metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
				document.getElementsByTagName('head')[0].appendChild(metaTag);
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				// remove mobile-responsive metatag
				var metaTag = document.getElementById("tempViewportElement");
				metaTag.content = "width=970";
			}
		}]);
	
		return UpgradePage;
	}(React.Component);
	
	;
	
	UpgradePage.propTypes = PageStrictPropTypes({});
	
	module.exports = UpgradePage;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StandardIcon = __webpack_require__(250);
	
	__webpack_require__(3791);
	
	var BraveToolbar = function (_React$Component) {
		_inherits(BraveToolbar, _React$Component);
	
		function BraveToolbar(props) {
			_classCallCheck(this, BraveToolbar);
	
			var _this = _possibleConstructorReturn(this, (BraveToolbar.__proto__ || Object.getPrototypeOf(BraveToolbar)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(BraveToolbar, [{
			key: "render",
			value: function render() {
				if (this.props.itemCount != undefined) {
	
					if (this.props.iconImage != undefined) {
						var icon = React.createElement("img", { className: "iconImage", src: this.props.iconImage, alt: "" });
					} else if (this.props.icon && this.props.iconType) {
						var icon = React.createElement(StandardIcon, { icon: this.props.icon, type: this.props.iconType,
							className: "iconImage" });
					}
					if (icon && this.props.itemCount > 1) {
						var plural = React.createElement(
							"span",
							{ className: "pluralSpan" },
							"s"
						);
					}
					if (this.props.itemCount > 0) {
						var clearAllLink = React.createElement(
							"a",
							{ href: "#", className: "clearAll", onClick: this.props.onClear },
							"Clear All"
						);
					}
					var selectedItems = React.createElement(
						"div",
						{ className: "selectedItems" },
						React.createElement(
							"div",
							{ className: "selectedTotal" },
							React.createElement(
								"span",
								{ className: "itemCount" },
								this.props.itemCount
							),
							icon,
							plural,
							" selected"
						),
						clearAllLink
					);
				}
	
				return React.createElement(
					"div",
					{ className: "braveToolbar initalHiddenPosition", ref: "toolbar" },
					React.createElement(
						"div",
						{ className: "container" },
						React.createElement(
							"div",
							{ className: "col-sm-12 clearfix" },
							selectedItems,
							React.createElement(
								"div",
								{ className: "actions" },
								this.props.children
							)
						)
					)
				);
			}
		}, {
			key: "checkPositioning",
			value: function checkPositioning() {
				if ($(".siteFooter").length > 0) {
					var footerOffset = $(".siteFooter").offset().top;
					var winHeight = $(window).height();
					var scrollTop = $(window).scrollTop();
	
					if (scrollTop + winHeight > footerOffset) {
						$(this.refs.toolbar).addClass("atBottom");
	
						var isMobile = window.matchMedia("only screen and (max-width: 45rem)").matches;
						var top = isMobile ? footerOffset - scrollTop - $(window).height() * .1 : footerOffset - scrollTop - 80;
	
						$(this.refs.toolbar).css("top", top + "px");
					} else {
						$(this.refs.toolbar).attr("style", "");
						$(this.refs.toolbar).attr("style", "").removeClass("atBottom");
					}
				}
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate() {
				this.checkPositioning();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				$(window).scroll(this.checkPositioning);
				$(document.body).on("document_height_adjustment", this.checkPositioning);
				this.onElementHeightChange(document, this.checkPositioning);
	
				setTimeout(function () {
					$(_this2.refs.toolbar).removeClass("initalHiddenPosition");
					_this2.checkPositioning();
				}, 2000);
			}
		}, {
			key: "onElementHeightChange",
			value: function onElementHeightChange(elm, callback) {
				var lastHeight = $(elm).height();
				var newHeight;
				(function run() {
					if ($(elm).length == 0) {
						return;
					}
	
					newHeight = $(elm).height();
					if (lastHeight != newHeight) {
						callback();
					}
	
					lastHeight = newHeight;
	
					if (elm.onElementHeightChangeTimer) {
						clearTimeout(elm.onElementHeightChangeTimer);
					}
	
					elm.onElementHeightChangeTimer = setTimeout(run, 10);
				})();
			}
		}]);
	
		return BraveToolbar;
	}(React.Component);
	
	;
	
	BraveToolbar.propTypes = StrictPropTypes({
		children: PropTypes.object,
		icon: PropTypes.string,
		iconType: PropTypes.string,
		itemCount: PropTypes.number,
		onClear: PropTypes.func
	});
	
	module.exports = BraveToolbar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Glyphicon = __webpack_require__(8);
	
	var CopyToClipboard = __webpack_require__(1040);
	
	__webpack_require__(3795);
	
	var CopyTextInput = function (_React$Component) {
		_inherits(CopyTextInput, _React$Component);
	
		function CopyTextInput(props) {
			_classCallCheck(this, CopyTextInput);
	
			var _this = _possibleConstructorReturn(this, (CopyTextInput.__proto__ || Object.getPrototypeOf(CopyTextInput)).call(this));
	
			autobind(_this);
	
			_this.input = React.createRef();
			return _this;
		}
	
		_createClass(CopyTextInput, [{
			key: "onFocus",
			value: function onFocus() {
				this.input.current.select();
			}
		}, {
			key: "onCopyClick",
			value: function onCopyClick() {
				CopyToClipboard(this.props.text);
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					"div",
					{ className: "copyTextInput" },
					React.createElement("input", { className: "form-control", value: this.props.text,
						onFocus: this.onFocus, readOnly: true, ref: this.input }),
					React.createElement(
						"button",
						{ className: "btn btn-default", onClick: this.onCopyClick },
						React.createElement(Glyphicon, { icon: "copy" })
					)
				);
			}
		}]);
	
		return CopyTextInput;
	}(React.Component);
	
	;
	
	CopyTextInput.propTypes = StrictPropTypes({
		text: PropTypes.string.isRequired
	});
	
	module.exports = CopyTextInput;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3798);
	
	var DiffDisplay = function DiffDisplay(props) {
		var text = props.text;
	
		var className = props.className || "";
		className += " diffDisplay";
	
		return React.createElement(
			"span",
			{ className: className },
			splitText(text)
		);
	};
	
	function splitText(text) {
		var match = text.match(changePattern);
	
		if (match) {
			var start = match.index;
			var end = start + match[0].length;
	
			var before = text.substring(0, start).trim();
			var matchText = text.substring(start, end).trim();
			var after = text.substring(end).trim();
	
			if (before.length) {
				var beforeContent = splitText(before);
			}
			if (after.length) {
				var afterContent = splitText(after);
			}
	
			if (matchText.startsWith("{+")) {
				// Except for leading '"(+' and trailing '"}'
				var innerText = matchText.substring(3, matchText.length - 2);
				var innerContent = React.createElement(
					"span",
					{ className: "addition" },
					innerText
				);
			} else if (matchText.startsWith("{-")) {
				// Except for leading '"(-' and trailing '"}'
				var innerText = matchText.substring(3, matchText.length - 2);
				var innerContent = React.createElement(
					"span",
					{ className: "subtraction" },
					innerText
				);
			} else if (matchText.includes('" >> "')) {
				var parts = matchText.split('" >> "');
				var preText = parts[0].substring(2);
				var postText = parts[1].substring(0, parts[1].length - 2);
	
				var innerContent = React.createElement(
					"span",
					null,
					React.createElement(
						"span",
						{ className: "subtraction" },
						preText
					),
					" ",
					React.createElement(
						"span",
						{ className: "addition" },
						postText
					)
				);
			}
		} else {
			var innerContent = React.createElement(
				"span",
				null,
				text
			);
		}
	
		return React.createElement(
			"span",
			null,
			beforeContent,
			" ",
			innerContent,
			" ",
			afterContent
		);
	}
	
	var changePattern = /\{[^\{\}]*\}/;
	
	DiffDisplay.propTypes = StrictPropTypes({
		className: PropTypes.string,
		text: PropTypes.string.isRequired
	});
	
	module.exports = DiffDisplay;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var ImageIcon = __webpack_require__(102);
	
	__webpack_require__(3803);
	
	var FeedbackOverrideDisplay = function FeedbackOverrideDisplay(props) {
		var height = props.height || 30;
		var fontSize = height * 0.7;
		var top = height * 0.07;
	
		var style = props.style || {};
		style["fontSize"] = fontSize;
	
		var className = props.className || "";
		className += " feedbackOverrideDisplay";
		return React.createElement(
			"span",
			{ className: className, style: style },
			React.createElement(ImageIcon, { icon: "reviews", style: { width: height, height: height } }),
			React.createElement("span", { className: "overrideStar", style: { top: top } })
		);
	};
	
	FeedbackOverrideDisplay.propTypes = StrictPropTypes({
	
		// Height in pixels
		height: PropTypes.number,
	
		className: PropTypes.string,
	
		// CSS style object for the text
		style: PropTypes.object
	});
	
	module.exports = FeedbackOverrideDisplay;

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	"use strict";
	
	var GradualFade = function GradualFade(_ref) {
		var text = _ref.text,
		    spanLen = _ref.spanLen,
		    iterCount = _ref.iterCount,
		    ellipsis = _ref.ellipsis,
		    opacityFactor = _ref.opacityFactor;
	
		if (opacityFactor === undefined) {
			opacityFactor = 0.85;
		}
		return React.createElement(
			"span",
			{ className: "gradualFade" },
			fadeHelper(text, spanLen, iterCount, ellipsis, opacityFactor)
		);
	};
	
	function fadeHelper(text, spanLen, iterCount, ellipsis, opacityFactor) {
		if (text.length == 0 || iterCount == 0) {
			if (ellipsis) {
				return "...";
			} else {
				return undefined;
			}
		}
	
		var thisText = text.substring(0, spanLen);
		var nextText = text.substring(spanLen);
	
		return React.createElement(
			"span",
			{ style: { opacity: opacityFactor } },
			thisText,
			fadeHelper(nextText, spanLen, iterCount - 1, ellipsis, opacityFactor)
		);
	}
	
	GradualFade.propTypes = StrictPropTypes({
		text: PropTypes.string.isRequired,
		spanLen: PropTypes.number.isRequired,
		iterCount: PropTypes.number.isRequired,
		ellipsis: PropTypes.bool,
		opacityFactor: PropTypes.number
	});
	
	module.exports = GradualFade;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3809);
	var CurrentUser = __webpack_require__(3);
	var Cookies = __webpack_require__(188);
	var ReactTooltip = __webpack_require__(12);
	
	var L2eSound = function (_React$Component) {
		_inherits(L2eSound, _React$Component);
	
		function L2eSound(props) {
			_classCallCheck(this, L2eSound);
	
			var _this = _possibleConstructorReturn(this, (L2eSound.__proto__ || Object.getPrototypeOf(L2eSound)).call(this));
	
			autobind(_this);
			var newState = _this.get_user_cookie();
			if (props.sources) {
				newState['sources'] = _this.update_sources(props.sources);
			} else {
				newState['sources'] = [];
			}
			newState['adminEnabled'] = _this.get_prefs();
			newState['update'] = 0;
			_this.state = newState;
			return _this;
		}
	
		_createClass(L2eSound, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.initSounds();
				if (window.wrL2eSound == undefined) {
					window.wrL2eSound = {};
				}
				window.wrL2eSound.addSource = this.addSource;
				window.wrL2eSound.playSound = this.playSound;
				window.wrL2eSound.stopSound = this.stopSound;
				window.wrL2eSound.stopAllSounds = this.stopAllSounds;
	
				window.wrL2eSound.buildStudentSources = this.buildStudentSources;
				window.wrL2eSound.removeSources = this.removeSources;
			}
		}, {
			key: "initSounds",
			value: function initSounds() {
				if (this.state.sources.length) {
					this.updateVolume(this.state.volume);
					if (this.state.soundEnabled) {
						this.startShouldPlay();
					}
				}
			}
		}, {
			key: "addSource",
			value: function addSource(sources, identifier) {
				sources.forEach(function (s) {
					if (identifier) {
						s['ref'] = s['ref'] + "_" + identifier;
					}
				});
				var newSources = this.state.sources.slice();
				if (sources.constructor === Array) {
					newSources = newSources.concat(this.update_sources(sources));
				} else {
					newSources = newSources.concat(this.update_sources([sources]));
				}
				this.setState({
					sources: newSources
				});
			}
		}, {
			key: "update_sources",
			value: function update_sources(sources) {
				sources.forEach(function (s) {
					if (!s['dynamic_path']) {
						s['dynamic_path'] = dynamicRequire(s["path"].toLowerCase().replace(/\s/g, "_") + ".mp3");
					}
				});
				return sources;
			}
		}, {
			key: "get_prefs",
			value: function get_prefs() {
				if (CurrentUser) {
					if (CurrentUser.isAdmin()) {
						return true;
					} else {
						var user = CurrentUser.get();
						if (user) {
							if (user.prefs.sound_enabled) {
								return true;
							} else {
								return false;
							}
						}
					}
				}
			}
		}, {
			key: "get_user_cookie",
			value: function get_user_cookie() {
				var sound_enabled = Cookies.get("sound_enabled");
				var volume = Cookies.get("volume");
				if (!sound_enabled) {
					Cookies.set("sound_enabled", true, { expires: 10000 });
					sound_enabled = true;
				} else {
					if (sound_enabled == "true") {
						sound_enabled = true;
					} else {
						sound_enabled = false;
					}
				}
				if (!volume) {
					Cookies.set("volume", 1, { expires: 10000 });
					volume = 1;
				} else {
					volume = parseFloat(volume);
				}
				return { "volume": volume, "soundEnabled": sound_enabled };
			}
		}, {
			key: "toggleSoundOption",
			value: function toggleSoundOption() {
				if (this.state.adminEnabled) {
					if (this.state.soundEnabled) {
						this.state.sources.forEach(function (s) {
							this.stopSound(s['ref']);
						}.bind(this));
						this.state.soundEnabled = false;
						this.state.volume = 0;
						this.setState({
							volume: 0
						});
						Cookies.set("sound_enabled", false, { expires: 10000 });
						Cookies.set("volume", 0, { expires: 10000 });
						this.updateVolume(0);
					} else {
						this.state.soundEnabled = true;
						this.state.volume = 1;
						this.setState({ volume: 1 });
						Cookies.set("sound_enabled", true, { expires: 10000 });
						Cookies.set("volume", 1, { expires: 10000 });
						this.updateVolume(1);
						this.startShouldPlay();
					}
				}
			}
		}, {
			key: "startShouldPlay",
			value: function startShouldPlay() {
				this.state.sources.forEach(function (s) {
					if (s['play']) {
						this.playSound(s['ref']);
					} else {
						this.stopSound(s['ref']);
					}
				}.bind(this));
			}
		}, {
			key: "updateVolume",
			value: function updateVolume(volume) {
				if (this.state.adminEnabled) {
					this.state.sources.forEach(function (s) {
						if (this.refs[s['ref']]) {
							this.refs[s['ref']].volume = volume;
						}
					}.bind(this));
					Cookies.set("volume", volume, { expires: 10000 });
				} else {
					this.state.sources.forEach(function (s) {
						this.refs[s['ref']].volume = 0;
					}.bind(this));
				}
			}
		}, {
			key: "playSound",
			value: function playSound(ref) {
				var _this2 = this;
	
				if (this.refs[ref] && this.state.adminEnabled && this.state.soundEnabled) {
					this.refs[ref].currentTime = 0;
					var promise = this.refs[ref].play();
					if (promise !== undefined) {
						promise.catch(function (error) {
							_this2.handleAutoPlayFail();
						});
					}
				}
			}
		}, {
			key: "handleAutoPlayFail",
			value: function handleAutoPlayFail() {
				this.setState({
					soundEnabled: false,
					volume: 0
				}, this.triggerTooltip.bind(this, this.refs.mainButton));
			}
		}, {
			key: "triggerTooltip",
			value: function triggerTooltip(ref) {
				ReactTooltip.show(ref);
				setTimeout(ReactTooltip.hide.bind(this, ref), 4000);
			}
		}, {
			key: "stopAllSounds",
			value: function stopAllSounds() {
				Object.keys(this.refs).forEach(function (ref) {
					if (ref != "mainButton") {
						this.stopSound(ref);
					}
				}.bind(this));
			}
		}, {
			key: "stopSound",
			value: function stopSound(ref) {
				if (this.refs[ref]) {
					this.refs[ref].pause();
				}
			}
		}, {
			key: "volumeUp",
			value: function volumeUp() {
				var volume = this.state.volume;
				volume += 0.21;
				if (volume > 1) {
					volume = 1;
				}
				this.updateVolume(volume);
				this.setState({ volume: volume });
			}
		}, {
			key: "volumeDown",
			value: function volumeDown() {
				var volume = this.state.volume;
				volume -= 0.21;
				if (volume < 0) {
					volume = 0;
				}
				this.updateVolume(volume);
				this.setState({ volume: volume });
			}
		}, {
			key: "waitForUpdate",
			value: function waitForUpdate() {
				setTimeout(function () {
					if (this.state.update) {
						this.waitForUpdate();
					}
				}.bind(this), 300);
			}
		}, {
			key: "checkExistence",
			value: function checkExistence(item, key) {
				for (var i = 0; i < this.state.sources.length; i++) {
					if (this.state.sources[i][key].includes(item)) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: "buildStudentSources",
			value: function buildStudentSources(username, perks) {
				if (this.state.update) {
					this.waitForUpdate();
				}
				// Directly updates the state on purpose
				this.state.update = true;
				var sound_sources = [];
				if (perks.owl_hoots) {
					sound_sources.push({ "ref": perks.owl_hoots + "_" + username, "path": "owl_hoots/" + perks.owl_hoots, "play": false });
				}
				if (!this.checkExistence('background', 'path')) {
					if (perks.background_sounds) {
						sound_sources.push({ "ref": perks.background_sounds + "_" + username, "path": "background/" + perks.background_sounds, "play": true, "loop": true });
					}
				}
				var depency = false;
				// Check if greeting sound not already registered
				if (!this.checkExistence('dances', 'path')) {
					if (perks.greetings && ["Mambo", "Swing", "Tango"].includes(perks.greetings)) {
						sound_sources.push({ "ref": perks.greetings + "_" + username, "path": "dances/" + perks.greetings, "play": false });
					}
				}
				sound_sources = this.update_sources(sound_sources);
				// Directly updates the state  on purpose
				this.state.sources = this.state.sources.concat(sound_sources);
				this.setState({
					update: false
				}, function () {
					this.initSounds();
				}.bind(this));
			}
		}, {
			key: "removeSources",
			value: function removeSources(username) {
				if (this.state.update) {
					this.waitForUpdate();
				}
				// Directly updates the state  on purpose 
				this.state.update = true;
				function checkUsername(source) {
					return source['ref'].indexOf(username) == -1;
				}
				// Directly updates the state  on purpose
				this.state.sources = this.state.sources.filter(checkUsername);
				this.setState({
					update: false
				});
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.sources.length) {
					var audio_sources = [];
					var inModal = "";
					if (this.props.inModal) {
						inModal = "-modal";
					}
					this.state.sources.forEach(function (s, i) {
						if (s['loop']) {
							audio_sources.push(React.createElement(
								"audio",
								{ controls: true, key: i, className: "sound_controller", ref: s['ref'], id: s['ref'], loop: true },
								React.createElement("source", { src: s['dynamic_path'], type: "audio/mp3" }),
								"Your browser does not support the audio element."
							));
						} else {
							audio_sources.push(React.createElement(
								"audio",
								{ controls: true, key: i, className: "sound_controller", ref: s['ref'], id: s['ref'] },
								React.createElement("source", { src: s['dynamic_path'], type: "audio/mp3" }),
								"Your browser does not support the audio element."
							));
						}
					});
					if (this.state.adminEnabled) {
						if (this.state.soundEnabled) {
							if (this.state.volume > 0.6) {
								var volume_class = "glyphicon-volume-up";
								var main_button_tip = "Turn sound off";
							} else if (this.state.volume > 0) {
								var volume_class = "glyphicon-volume-down";
								var main_button_tip = "Turn sound off";
							} else {
								var volume_class = "glyphicon-volume-off";
								var main_button_tip = "Click on the + to increase your volume";
							}
	
							var plusButton = React.createElement("span", { className: "glyphicon soundOption b-tooltip glyphicon-plus", id: 'plusButton' + inModal, "data-tip": "Increase volume", onClick: this.volumeUp });
							var minusButton = React.createElement("span", { className: "glyphicon soundOption b-tooltip glyphicon-minus", id: 'minusButton' + inModal, "data-tip": "Lower volume", onClick: this.volumeDown });
						} else {
							var volume_class = "glyphicon-volume-off";
							var main_button_tip = "Turn sound on";
						}
					} else {
						var volume_class = "glyphicon-volume-off";
						var main_button_tip = "Your teacher turned sound off";
					}
					return React.createElement(
						"div",
						{ className: "l2e_sound hideOnPrint" },
						React.createElement("span", { ref: "mainButton", className: "glyphicon soundOption b-tooltip " + volume_class, id: 'mainButton' + inModal, "data-tip": main_button_tip, onClick: this.toggleSoundOption }),
						plusButton,
						minusButton,
						audio_sources,
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				} else {
					return null;
				}
			}
		}]);
	
		return L2eSound;
	}(React.Component);
	
	L2eSound.propTypes = StrictPropTypes({
		// used for twitter text (and possibly Pinterest)
		sources: PropTypes.array,
		inModal: PropTypes.bool
	});
	
	module.exports = L2eSound;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactCustomScrollbars = __webpack_require__(152);
	
	__webpack_require__(3814);
	
	var SelectOptions = function SelectOptions(props) {
		var options = props.options;
		if (props.value) {
			var lowerCaseValue = props.value.toString().toLowerCase().trim();
			options = _.select(options, function (option) {
				var optionValue = option.label.toString().toLowerCase().trim();
	
				if (props.hideFullMatch && lowerCaseValue == optionValue) {
					return false;
				}
				return optionValue.indexOf(lowerCaseValue) > -1;
			});
		}
	
		var selectContents = [];
		var currentGroup = undefined;
		var currentSubGroup = undefined;
	
		_.each(options, function (option, index) {
			if (props.onSelect) {
				var selectF = function selectF(e) {
					$wr.nope(e);
					props.onSelect(option);
				};
			}
	
			if (currentSubGroup != option.subgroup) {
				selectContents.push(React.createElement("div", { key: "divider-" + option.subgroup + "-" + index, className: "subDivider" }));
				currentSubGroup = option.subgroup;
			}
	
			if (option.color) {
				var colorDot = React.createElement("span", { className: "colorDot", style: { backgroundColor: option.color } });
			}
	
			selectContents.push(React.createElement(
				"div",
				{ className: "selectOp", key: option.value, onMouseDown: selectF },
				colorDot,
				" ",
				option.label
			));
		});
	
		var className = "selectOptions ";
		if (options.length > 0) {
			className += "present";
		}
	
		return React.createElement(
			"div",
			{ className: className },
			React.createElement(
				"div",
				{ className: "selectInner" },
				React.createElement(
					_reactCustomScrollbars.Scrollbars,
					{ autoHeight: true, autoHeightMin: 0, autoHeightMax: 200 },
					selectContents
				)
			)
		);
	};
	
	SelectOptions.propTypes = StrictPropTypes({
		// list of { label: "A and B and C", value: "abc" }
		options: PropTypes.array.isRequired,
	
		value: PropTypes.string,
	
		onSelect: PropTypes.func,
	
		// If true, it won't show perfect matches
		hideFullMatch: PropTypes.bool
	});
	
	module.exports = SelectOptions;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3815);
	
	var SlidingDrawer = function (_React$Component) {
	  _inherits(SlidingDrawer, _React$Component);
	
	  function SlidingDrawer() {
	    _classCallCheck(this, SlidingDrawer);
	
	    return _possibleConstructorReturn(this, (SlidingDrawer.__proto__ || Object.getPrototypeOf(SlidingDrawer)).apply(this, arguments));
	  }
	
	  _createClass(SlidingDrawer, [{
	    key: 'render',
	    value: function render() {
	      var drawerClasses = 'slideDrawer closed';
	
	      if (this.props.show) {
	        drawerClasses = 'slideDrawer open';
	      }
	
	      return React.createElement(
	        'div',
	        { className: drawerClasses },
	        React.createElement(
	          'div',
	          { className: 'optionalHeader' },
	          'Optional activities'
	        ),
	        this.props.content
	      );
	    }
	  }]);
	
	  return SlidingDrawer;
	}(React.Component);
	
	;
	
	SlidingDrawer.propTypes = StrictPropTypes({
	  show: PropTypes.bool,
	  content: PropTypes.array
	});
	
	module.exports = SlidingDrawer;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3796);
	
	var MonthPicker = function (_React$Component) {
	    _inherits(MonthPicker, _React$Component);
	
	    function MonthPicker(props) {
	        _classCallCheck(this, MonthPicker);
	
	        var _this = _possibleConstructorReturn(this, (MonthPicker.__proto__ || Object.getPrototypeOf(MonthPicker)).call(this));
	
	        autobind(_this);
	        _this.state = {
	            startDate: props.startDate || (0, _moment2.default)().startOf('month').toDate(),
	            endDate: props.endDate || (0, _moment2.default)().endOf('month').toDate(),
	            selectedDate: props.selectedDate || null
	        };
	        return _this;
	    }
	
	    _createClass(MonthPicker, [{
	        key: "onChange",
	        value: function onChange(selectedDate) {
	            var startDate = (0, _moment2.default)(selectedDate, "YYYY-MM-DD").startOf('month').toDate();
	            var endDate = (0, _moment2.default)(selectedDate, "YYYY-MM-DD").endOf('month').toDate();
	            this.setState({ selectedDate: selectedDate, endDate: endDate, startDate: startDate });
	            if (this.props.onChange) {
	                this.props.onChange(startDate, endDate, selectedDate);
	            }
	        }
	    }, {
	        key: "isSameMonth",
	        value: function isSameMonth(date1, date2) {
	            var moment1 = (0, _moment2.default)(date1);
	            var moment2 = (0, _moment2.default)(date2);
	            return moment1.month() === moment2.month() && moment1.year() === moment2.year();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var selectedDate = this.state.selectedDate;
	
	
	            return React.createElement(
	                "div",
	                { className: "monthPickerContainer" },
	                React.createElement(_reactDatepicker2.default, { className: "form-control",
	                    dateFormat: "MM/yyyy",
	                    selected: selectedDate ? (0, _moment2.default)(selectedDate) : null,
	                    onChange: function onChange(date) {
	                        return _this2.onChange(date.format("YYYY-MM-DD"));
	                    },
	                    dayClassName: function dayClassName(date) {
	                        return _this2.isSameMonth(date, selectedDate) ? "react-datepicker__day--selected" : '';
	                    },
	                    dateFormatCalendar: "MMM yyyy",
	                    showYearDropdown: true
	                })
	            );
	        }
	    }]);
	
	    return MonthPicker;
	}(React.Component);
	
	module.exports = MonthPicker;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3797);
	
	var WeekPicker = function (_React$Component) {
	    _inherits(WeekPicker, _React$Component);
	
	    function WeekPicker(props) {
	        _classCallCheck(this, WeekPicker);
	
	        var _this = _possibleConstructorReturn(this, (WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call(this));
	
	        autobind(_this);
	        _this.state = {
	            startDate: props.startDate || (0, _moment2.default)().startOf('week').toDate(),
	            endDate: props.endDate || (0, _moment2.default)().endOf('week').toDate(),
	            selectedDate: props.selectedDate || null
	        };
	        return _this;
	    }
	
	    _createClass(WeekPicker, [{
	        key: "onChange",
	        value: function onChange(selectedDate) {
	            var startDate = (0, _moment2.default)(selectedDate, "YYYY-MM-DD").startOf('week').toDate();
	            var endDate = (0, _moment2.default)(selectedDate, "YYYY-MM-DD").endOf('week').toDate();
	            this.setState({ selectedDate: selectedDate, endDate: endDate, startDate: startDate });
	
	            if (this.props.onChange) {
	                this.props.onChange(startDate, endDate, selectedDate);
	            }
	        }
	    }, {
	        key: "isSameWeek",
	        value: function isSameWeek(date1, date2) {
	            var moment1 = (0, _moment2.default)(date1);
	            var moment2 = (0, _moment2.default)(date2);
	            return moment1.week() === moment2.week() && moment1.year() === moment2.year();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var selectedDate = this.state.selectedDate;
	
	
	            return React.createElement(
	                "div",
	                { className: "weekSelectorContainer" },
	                React.createElement(_reactDatepicker2.default, { className: "form-control",
	                    dateFormat: "ww/yyyy",
	                    selected: selectedDate ? (0, _moment2.default)(selectedDate) : null,
	                    onChange: function onChange(date) {
	                        return _this2.onChange(date.format("YYYY-MM-DD"));
	                    },
	                    dayClassName: function dayClassName(date) {
	                        return _this2.isSameWeek(date, selectedDate) ? "react-datepicker__day--selected" : '';
	                    },
	                    dateFormatCalendar: "MMM yyyy",
	                    showYearDropdown: true
	                })
	            );
	        }
	    }]);
	
	    return WeekPicker;
	}(React.Component);
	
	module.exports = WeekPicker;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3805);
	
	var AnswerCircle = function AnswerCircle(props) {
		var answerIconPath;
		if (props.warmUp) {
			answerIconPath = "quiz-icons/warmup-complete.png";
		} else if (props.fillInTheBlank) {
			// Yeah, this is mis-labelled
			answerIconPath = "quiz-icons/open-ss-complete.png";
		} else if (props.withSentenceStarter) {
			// Yeah, this is mis-labelled
			answerIconPath = "quiz-icons/open-no-ss-complete.png";
		} else {
			answerIconPath = "quiz-icons/open-no-ss-complete.png";
		}
	
		return React.createElement(
			"div",
			{ className: "answerCircle" },
			React.createElement("img", { src: dynamicRequire(answerIconPath),
				className: "answerIcon" })
		);
	};
	
	AnswerCircle.propTypes = StrictPropTypes({
		warmUp: PropTypes.bool,
		fillInTheBlank: PropTypes.bool,
		withSentenceStarter: PropTypes.bool,
		openEnded: PropTypes.bool
	});
	
	module.exports = AnswerCircle;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var StudentAvatar = __webpack_require__(35);
	
	__webpack_require__(3806);
	
	var AvatarCircle = function AvatarCircle(props) {
		var circleClassName = "avatarCircle";
	
		if (props.avatarType == "owlfonso") {
			var avatarImg = React.createElement("img", { src: __webpack_require__(299), className: "avatarIcon" });
		} else if (props.avatarType == "student") {
			if (props.initialOnly) {
				var avatarImg = React.createElement(
					"div",
					{ className: "avatarIcon" },
					props.user.first_name.charAt(0)
				);
				circleClassName += " initial";
			} else {
				var avatarImg = React.createElement(StudentAvatar, { student: props.user, maxWidth: 35 });
			}
		}
	
		return React.createElement(
			"div",
			{ className: circleClassName },
			avatarImg
		);
	};
	
	AvatarCircle.propTypes = StrictPropTypes({
		// which type of avatar to display in the circle
		avatarType: PropTypes.string.isRequired,
	
		// needed if displaying the user's avatar or initial
		user: PropTypes.object,
	
		// true if we want to display user's initial as a placeholder
		initialOnly: PropTypes.bool
	});
	
	module.exports = AvatarCircle;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(3807);
	
	var NewTaskCircle = function NewTaskCircle(props) {
		return React.createElement(
			"div",
			{ className: "newTaskCircle" },
			"+"
		);
	};
	
	NewTaskCircle.propTypes = StrictPropTypes({});
	
	module.exports = NewTaskCircle;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _LocationState = __webpack_require__(59);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var DisplayToggleControl = __webpack_require__(48);
	var PicksPage = __webpack_require__(242);
	var ExercisePage = __webpack_require__(946);
	
	var Features = __webpack_require__(16);
	var AccountPlans = __webpack_require__(53);
	var DisplayToggleControl = __webpack_require__(48);
	
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var ActivitiesPageRouting = __webpack_require__(255);
	
	__webpack_require__(3820);
	
	var ActivitiesPage = (_dec = (0, _LocationState.provideLocationState)(ActivitiesPageRouting.getRouteState), _dec2 = (0, _reactRedux.connect)(function (state, props) {
		return {
			user: CurrentUser.get(),
			isLoadingLogs: ReadingSelectors.isLoadingLogs({ state: state }),
			product: CurrentUser.get().product,
			userIDs: _.pluck(RosterSelectors.students({ state: state }), "id")
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(RosterActions.fetchStudents({
					embeds: RosterActions.GLOBAL_STUDENT_EMBEDS
				}));
			}
		};
	}), _dec3 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
		_inherits(ActivitiesPage, _React$Component);
	
		function ActivitiesPage(props) {
			_classCallCheck(this, ActivitiesPage);
	
			var _this = _possibleConstructorReturn(this, (ActivitiesPage.__proto__ || Object.getPrototypeOf(ActivitiesPage)).call(this));
	
			autobind(_this);
			var selGradeLevel = $wr.getURLParameterByName("grade_level") || props.user.grade_level;
			_this.assignTaskModal = React.createRef();
			_this.AssignExerciseDetailsModal = React.createRef();
	
			_this.state = {
				loading: false,
				view: EXERCISE_VIEW
			};
			return _this;
		}
	
		_createClass(ActivitiesPage, [{
			key: "hasQualifiedPlan",
			value: function hasQualifiedPlan() {
				var activeTrials = this.props.user.account.active_trials;
				var hasQualifiedTrial = activeTrials && activeTrials[AccountPlans.PRODUCTS.WR_GOLD] ? true : false;
				return this.props.product === 'wrGold' || hasQualifiedTrial ? true : false;
			}
		}, {
			key: "isExerciseView",
			value: function isExerciseView() {
				return this.props.locationState.activeView == ActivitiesPageRouting.VIEWS.EXERCISE_VIEW;
			}
		}, {
			key: "switchActiveView",
			value: function switchActiveView(viewKey) {
				Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
				this.switchView({ activeView: viewKey });
			}
		}, {
			key: "switchView",
			value: function switchView(change) {
				var newLocationState = _.extend({}, this.props.locationState, change);
				$wr.redirect(ActivitiesPageRouting.getPath(newLocationState));
			}
		}, {
			key: "render",
			value: function render() {
				var lState = this.props.locationState;
				var pageClassName = "container activitiesPage";
	
				if (Features.isEnabled(Features.LOG_READING)) {
					var toggleOptions = [{ key: ActivitiesPageRouting.VIEWS.EXERCISE_VIEW, text: "Exercises" }, { key: ActivitiesPageRouting.VIEWS.TEACHER_PICKS_VIEW, text: "Teacher Picks" }];
	
					var pageHeaderText = this.hasQualifiedPlan() ? 'Activities' : 'Teacher Picks';
	
					var displayToggle = React.createElement(DisplayToggleControl, { options: toggleOptions, className: "topToggle",
						onChange: this.switchActiveView,
						activeOptionKey: lState.activeView });
	
					var pageHeader = React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							{ className: "hideOnPrint" },
							pageHeaderText
						)
					);
	
					var displayToggleOptions = React.createElement(
						"div",
						{ className: "hideOnPrint " },
						pageHeader
					);
	
					if (this.hasQualifiedPlan()) {
						displayToggleOptions = React.createElement(
							"div",
							{ className: "hideOnPrint " },
							pageHeader,
							displayToggle
						);
					}
	
					pageClassName += " withToggle";
				}
				if (this.isExerciseView() && this.hasQualifiedPlan()) {
					var pageContent = React.createElement(ExercisePage, { hasQualifiedPlan: this.hasQualifiedPlan(), userIDs: this.props.userIDs });
				} else {
					if (this.props.isLoadingLogs) {
						var pageContent = React.createElement(Spinner, { placeholder: true, scale: 1.7, className: "shelfSpin" });
					} else {
						var pageContent = React.createElement(
							"div",
							{ className: "teacherPicksWrap" },
							React.createElement(PicksPage, { userIDs: this.props.userIDs, hideTitle: true })
						);
					}
				}
				return React.createElement(
					"div",
					{ className: pageClassName },
					displayToggleOptions,
					pageContent
				);
			}
		}]);
	
		return ActivitiesPage;
	}(React.Component)) || _class) || _class) || _class);
	;
	
	var EXERCISE_VIEW = "exercises";
	var TEACHER_PICKS_VIEW = "teacher-picks";
	
	module.exports = ActivitiesPage;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activity = __webpack_require__(170);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(656);
	
	var ActivityPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			activity: WritingSelectors.getActivity({ state: state, id: props.match.params.id })
		};
	}, function (dispatch, props) {
		return {
			populateData: function populateData() {
				return dispatch(WritingActions.fetchActivity({ id: props.match.params.id, embeds: ["activity.format"] }));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(ActivityPage, _React$Component);
	
		function ActivityPage(props) {
			_classCallCheck(this, ActivityPage);
	
			var _this = _possibleConstructorReturn(this, (ActivityPage.__proto__ || Object.getPrototypeOf(ActivityPage)).call(this));
	
			autobind(_this);
			_this.state = {};
			return _this;
		}
	
		_createClass(ActivityPage, [{
			key: "render",
			value: function render() {
				if (this.props.activity == null) {
					return React.createElement("div", { className: "container", id: "activityPage" });
				}
	
				return React.createElement(
					"div",
					{ className: "container", id: "activityPage" },
					React.createElement(Activity, { activity: this.props.activity })
				);
			}
		}]);
	
		return ActivityPage;
	}(React.Component)) || _class) || _class);
	;
	
	ActivityPage.propTypes = PageStrictPropTypes({});
	
	module.exports = ActivityPage;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ImageIcon = __webpack_require__(102);
	var Glyphicon = __webpack_require__(8);
	var Skillsets = __webpack_require__(55);
	var TextTypes = __webpack_require__(38);
	var ReactTooltip = __webpack_require__(12);
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(3822);
	
	var ActivityTile = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			isAdmin: CurrentUser.isAdmin(),
			tasks: WritingSelectors.tasks({ state: state })
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(ActivityTile, _React$Component);
	
		function ActivityTile(props) {
			_classCallCheck(this, ActivityTile);
	
			var _this = _possibleConstructorReturn(this, (ActivityTile.__proto__ || Object.getPrototypeOf(ActivityTile)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ActivityTile, [{
			key: "onAssignToggle",
			value: function onAssignToggle(e) {
				$wr.nope(e);
				this.props.onItemAssign(this.props.item);
			}
		}, {
			key: "onOpenPrintable",
			value: function onOpenPrintable(e) {
				$wr.nope(e);
				var activity = this.props.item;
	
				Mycroft.newEvent({ category: "Printables", action: "view-activitiy", label: activity.key });
				setTimeout(function () {
					Mycroft.newEvent({ category: "Printables", action: "view-skillset", label: activity.format_summary.skillset });
				}, 1100);
				setTimeout(function () {
					Mycroft.newEvent({ category: "Printables", action: "view-format", label: activity.format_summary.format_class });
				}, 2200);
	
				window.open(activity.thumbnail.printable_url, "_blank");
			}
		}, {
			key: "onActivityClick",
			value: function onActivityClick() {
				if (this.props.nonInteractive) {
					return;
				}
				if (this.props.onClick) {
					this.props.onClick(this.props.item);
					return;
				}
	
				// Maybe we don't need this stuff? It'd be good to move it out of the class
				var passphrase = this.props.passphrase;
				if (passphrase == undefined) {
					var path = "/responses/new?activity_id=" + this.props.item.id;
				} else {
					var path = "/responses/access?activity_id=" + this.props.item.id + "&passphrase=" + passphrase;
				}
	
				if (passphrase != undefined) {
					$wr.redirect(path);
				} else if (this.props.forStudents) {
					window.open(path);
				} else {
					if (this.props.previewParameters) {
						path += "&" + $.param(this.props.previewParameters);
					}
					window.open(path, "_blank");
				}
			}
			// checks task to see if activity is assigned as task or task item
	
		}, {
			key: "assingedAsTask",
			value: function assingedAsTask(activity) {
				var standAloneTasks = _.where(this.props.tasks, { subject_type: 'exercise', subject_id: activity.id.toString() });
				var taskItems = _.flatten(_.collect(_.pluck(this.props.tasks, 'task_items')));
				var matchingTaskItems = _.where(taskItems, { subject_type: 'exercise', subject_id: activity.id, subject_assigned: true });
	
				return _.size(standAloneTasks) || _.size(matchingTaskItems) ? true : false;
			}
		}, {
			key: "render",
			value: function render() {
				var activity = this.props.item;
	
				var buttonClassName = "buttonsBar";
	
				var textVariety = TextTypes.Varieties.getName(activity.format_summary.text_variety);
				var textCompletion = TextTypes.CompletionTypes.getPluralName(activity.format_summary.text_completion);
				if (this.props.isAdmin) {
					if (!this.props.nonInteractive) {
						if (this.props.hideAssignAction) {
							var assignmentControl = null;
						} else {
							if (this.props.assigned || activity.assigned || this.assingedAsTask(activity)) {
								buttonClassName += " assignedTile";
								var assignmentControl = React.createElement(
									"li",
									{ onClick: this.onAssignToggle, className: "assignedMarker" },
									React.createElement(
										"span",
										{ className: "buttonTitle" },
										"Assigned"
									),
									React.createElement(Glyphicon, { icon: "star", className: "menuIcon" })
								);
							} else {
								var assignmentControl = React.createElement(
									"li",
									{ onClick: this.onAssignToggle, className: "dynamic assignMarker" },
									React.createElement(
										"span",
										{ className: "buttonTitle" },
										"Assign"
									),
									React.createElement(Glyphicon, { icon: "plus", className: "menuIcon" })
								);
							}
							if (activity.new) {
								var newMarker = React.createElement(
									"li",
									{ className: "newMarker" },
									React.createElement(
										"span",
										{ className: "buttonTitle" },
										"New"
									),
									React.createElement(Glyphicon, { icon: "flash", className: "menuIcon" })
								);
							} else if (activity.featured) {
								buttonClassName += " featuredTile";
	
								var featuredMarker = React.createElement(
									"li",
									{ className: "featuredMarker" },
									React.createElement(
										"span",
										{ className: "buttonTitle" },
										"Featured"
									),
									React.createElement(Glyphicon, { icon: "star", className: "menuIcon" })
								);
							}
							var printControl = React.createElement(
								"li",
								{ onClick: this.onOpenPrintable, className: "dynamic printMarker" },
								React.createElement(
									"span",
									{ className: "buttonTitle" },
									"Print"
								),
								React.createElement(Glyphicon, { icon: "print", className: "menuIcon" })
							);
						}
					}
				}
	
				if (this.props.unassignedDraft) {
					var textContent = React.createElement(
						"div",
						{ className: "activityInfo smallText" },
						React.createElement(
							"strong",
							null,
							activity.format_summary.title,
							" "
						)
					);
				} else {
	
					if (!this.props.forStudents) {
						var teacherDescription = activity.format_summary.teacher_description;
					}
	
					var textContent = React.createElement(
						"div",
						{ className: "activityInfo smallText" },
						React.createElement(
							"p",
							null,
							React.createElement(
								"strong",
								null,
								activity.format_summary.title,
								" "
							),
							teacherDescription
						),
						React.createElement(
							"p",
							null,
							React.createElement(
								"em",
								null,
								textVariety,
								" ",
								textCompletion
							)
						)
					);
				}
	
				var className = "tile activityTile";
				if (this.props.unassignedDraft) {
					className += " smallTile";
				}
	
				if (this.props.completedMark) {
					var completedMark = React.createElement(
						"span",
						{ className: "completedMark" },
						React.createElement(Glyphicon, { icon: "check" }),
						" Done!"
					);
				}
				if (this.props.draftedMark) {
					var draftMarker = React.createElement(
						"li",
						{ className: "draftMarker" },
						React.createElement(
							"span",
							{ className: "buttonTitle" },
							"Finish"
						),
						React.createElement(Glyphicon, { icon: "star-empty", className: "menuIcon" })
					);
				}
	
				if (this.props.completedAt) {
					var completedAt = React.createElement(
						"div",
						{ className: "completedAt" },
						"Completed ",
						$wr.formatDateTime(this.props.completedAt)
					);
				}
	
				if (this.props.item.format_summary.format_class == "CollaborationFormat") {
					var collaborationMarker = React.createElement(
						"div",
						{ className: "smallText", "data-tip": "You get to do this activity with 1-4 of your classmates!" },
						React.createElement("img", { src: __webpack_require__(510), className: "collaborationImg" }),
						React.createElement(ReactTooltip, { effect: "solid" })
					);
				}
	
				if (this.props.nonInteractive) {
					className += " nonInteractive";
				}
	
				var skillset = activity.format_summary.skillset;
	
				return React.createElement(
					"div",
					{ className: className },
					React.createElement(
						"div",
						{ className: "imgContainer withImageHover" },
						collaborationMarker,
						React.createElement(
							"div",
							{ className: buttonClassName },
							React.createElement(
								"ul",
								null,
								featuredMarker,
								newMarker,
								assignmentControl,
								draftMarker,
								printControl
							)
						),
						React.createElement("img", { src: activity.thumbnail.url, className: "tileImg", onClick: this.onActivityClick })
					),
					textContent,
					React.createElement(
						"div",
						{ className: "skillsetTitle smallText" },
						React.createElement("img", { src: Skillsets.getIcon(skillset), className: "skillsetImg" }),
						React.createElement(
							"span",
							{ className: "itemName" },
							Skillsets.getName(skillset)
						)
					),
					completedMark,
					completedAt
				);
			}
		}]);
	
		return ActivityTile;
	}(React.Component)) || _class);
	;
	
	ActivityTile.propTypes = StrictPropTypes({
		// The activity
		item: PropTypes.object.isRequired,
	
		// Function to assign an item
		onItemAssign: PropTypes.func,
	
		// Overrides default onClick behavior. We pass the activity on to this function
		onClick: PropTypes.func,
	
		// Two types of drafts
		draftedMark: PropTypes.bool,
		unassignedDraft: PropTypes.bool,
	
		// If this is an assigned title (for teacher view)
		assigned: PropTypes.bool,
	
		// If we want to hide clickable behavior 
		nonInteractive: PropTypes.bool,
	
		// If this is an assigned title (for teacher view)
		forStudents: PropTypes.bool,
	
		// Show a completed mark underneath the tile
		// A little hacky, perhaps
		completedMark: PropTypes.bool,
		// If provided, shows the date completed underneath the tile
		completedAt: PropTypes.string,
	
		// If provided, this user is using passphrase access
		// And we should link them to a different path
		passphrase: PropTypes.string,
	
		// Makes this a preview card (for teachers)
		previewParameters: PropTypes.object,
	
		hideAssignAction: PropTypes.bool
	});
	
	module.exports = ActivityTile;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _WritingSelectors = __webpack_require__(14);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var StudentMetrics = __webpack_require__(29);
	var DataRouting = __webpack_require__(36);
	var Formats = __webpack_require__(105);
	var Skillsets = __webpack_require__(55);
	var UIActions = __webpack_require__(41);
	
	var Glyphicon = __webpack_require__(8);
	var NoActivityBlock = __webpack_require__(71);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var ProgressBar = __webpack_require__(81);
	var StudentAvatar = __webpack_require__(35);
	var StudentListDisplay = __webpack_require__(163);
	
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3823);
	
	function propsToConditions(props) {
	  var conditions = _underscore2.default.pick(props, "startDate", "endDate", "textID", "userIDs", "dueDate");
	
	  return conditions;
	}
	
	var AllStudentActivitiesTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    tasks: WritingSelectors.tasks({ state: state, conditions: propsToConditions(props) }),
	    students: RosterSelectors.students({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // TODO: standardize FE requests
	      // if the dataset of students is large, send multiple requests
	      if ($wr.isLargeRequest(props.userIDs)) {
	        var conditions = _underscore2.default.pick(props, "startDate", "endDate", "textID", "dueDate");
	        var actionFunction = WritingActions.fetchTasks;
	        var options = { embeds: ['task.task_items'], cache: true };
	        return new Promise(function (resolve, reject) {
	          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
	            resolve(results);
	          });
	        }).catch(function () {
	          return console.log("Tasks failed to load");
	        });
	      } else {
	        return dispatch(WritingActions.fetchTasks({
	          embeds: ['task.task_items'],
	          conditions: propsToConditions(props),
	          cache: true
	        }));
	      }
	    },
	    fetchBook: function fetchBook(textID) {
	      dispatch(ReadingActions.batchFetchBook({ id: textID }));
	    },
	    toggleExpandedResponse: function toggleExpandedResponse(responseID) {
	      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(AllStudentActivitiesTable, _React$Component);
	
	  function AllStudentActivitiesTable(props) {
	    _classCallCheck(this, AllStudentActivitiesTable);
	
	    var _this = _possibleConstructorReturn(this, (AllStudentActivitiesTable.__proto__ || Object.getPrototypeOf(AllStudentActivitiesTable)).call(this));
	
	    autobind(_this);
	
	    _this.state = { orderBy: STUDENT_NAME_ORDER };
	    return _this;
	  }
	
	  _createClass(AllStudentActivitiesTable, [{
	    key: "changeSortBy",
	    value: function changeSortBy(orderBy) {
	      this.setState({ orderBy: orderBy });
	    }
	  }, {
	    key: "handleActivityClick",
	    value: function handleActivityClick(e) {
	      if (e.currentTarget.getAttribute('data-response-id')) {
	        this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'));
	      }
	    }
	  }, {
	    key: "dateFormat",
	    value: function dateFormat(date) {
	      var d = new Date(date);
	      var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
	      var mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
	      var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
	
	      return da + "/" + mo + "/" + ye;
	    }
	  }, {
	    key: "renderSortControl",
	    value: function renderSortControl() {
	      var _this2 = this;
	
	      var orderOptionText = function orderOptionText(op) {
	        if (STUDENT_NAME_ORDER === op) {
	          return "Student Name";
	        } else if (LAST_ACTIVE === op) {
	          return "Last Activity";
	        } else if (TEACHER_PICKS_COMPLETE === op) {
	          return "Teacher Picks Completed";
	        } else if (EXERCISE_COMPLETE === op) {
	          return "Exercises Completed";
	        } else {
	          return StudentMetrics.getLabel(op);
	        }
	      };
	
	      var renderOption = function renderOption(op) {
	        return React.createElement(ButtonDropdownOption, { key: op, className: "",
	          text: orderOptionText(op),
	          onClick: _this2.changeSortBy.bind(_this2, op) });
	      };
	
	      var orderOptions = [];
	
	      orderOptions.push(renderOption(STUDENT_NAME_ORDER));
	      orderOptions.push(renderOption(LAST_ACTIVE));
	      orderOptions.push(renderOption(TEACHER_PICKS_COMPLETE));
	      orderOptions.push(renderOption(EXERCISE_COMPLETE));
	
	      if (this.props.showGoals) {
	        _underscore2.default.each(this.props.expectationMetrics, function (metric) {
	          orderOptions.push(renderOption(metric));
	        });
	      } else {
	        _underscore2.default.each(this.props.userMetricsColumns, function (metric) {
	          orderOptions.push(renderOption(metric));
	        });
	      }
	
	      var displayText = orderOptionText(this.state.orderBy);
	
	      return React.createElement(
	        ButtonDropdown,
	        { dropdownDisplay: "link", text: displayText },
	        orderOptions
	      );
	    }
	  }, {
	    key: "renderTableHeaders",
	    value: function renderTableHeaders(rows) {
	      if (rows.length) {
	        var sortLink = React.createElement(
	          "div",
	          { className: "infoSection studentNameHeader sortControlCell hideOnPrint" },
	          "Sort By: ",
	          this.renderSortControl()
	        );
	        var activitiesHeader = React.createElement(
	          "div",
	          { className: "statSection" },
	          React.createElement(
	            "div",
	            { className: "columnHeaderText" },
	            "Exercises"
	          )
	        );
	        var teacherPicksHeader = React.createElement(
	          "div",
	          { className: "statSection" },
	          React.createElement(
	            "div",
	            { className: "columnHeaderText" },
	            "Teacher Picks"
	          )
	        );
	
	        return React.createElement(
	          "div",
	          { className: "studentRow headerRow" },
	          React.createElement(
	            "div",
	            { className: "rowContent" },
	            sortLink,
	            activitiesHeader,
	            teacherPicksHeader
	          )
	        );
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: "isComplete",
	    value: function isComplete(exercise) {
	      return 'completed_at' in exercise && exercise.completed_at !== null || 'draft' in exercise && exercise.daft === true ? true : false;
	    }
	    // returns all task items for a user
	
	  }, {
	    key: "getTaskItems",
	    value: function getTaskItems(userID) {
	      var taskItems = _underscore2.default.pluck(_underscore2.default.where(this.props.tasks, { user_id: userID }), 'task_items');
	      return [].concat(_toConsumableArray(new Set(taskItems.flat())));
	    }
	    // retuns all tasks and task items for a user
	
	  }, {
	    key: "getAllTasks",
	    value: function getAllTasks(userID) {
	      var standAloneExercises = _underscore2.default.where(this.props.tasks, { subject_type: 'exercise', user_id: userID });
	      var taskItemExercises = _underscore2.default.where(this.getTaskItems(userID), { subject_type: 'exercise', user_id: userID });
	      return taskItemExercises.concat(standAloneExercises);
	    }
	    // sort user tables
	
	  }, {
	    key: "sortUserIDs",
	    value: function sortUserIDs() {
	      var _this3 = this;
	
	      var orderBy = this.state.orderBy;
	      if (orderBy == LAST_ACTIVE) {
	        var students = _underscore2.default.sortBy(this.props.students, function (student) {
	          return student.last_active || "1970-01-01";
	        }).reverse();
	      } else if (orderBy == EXERCISE_COMPLETE) {
	        var students = _underscore2.default.sortBy(this.props.students, function (student) {
	          var allExercises = _this3.getAllTasks(student.id);
	          return _underscore2.default.size(_underscore2.default.filter(allExercises, function (exercise) {
	            return _this3.isComplete(exercise);
	          }));
	        }).reverse();
	      } else if (orderBy == TEACHER_PICKS_COMPLETE) {
	        var students = _underscore2.default.sortBy(this.props.students, function (student) {
	          return _underscore2.default.size(_underscore2.default.where(_this3.getTaskItems(student.id), { draft: false }));
	        }).reverse();
	      } else {
	        var students = $wr.sortByName(this.props.students, "flexName");
	      }
	      return _underscore2.default.pluck(students, 'id');
	    }
	    // renders no activities block if there are students with no assigned activities
	
	  }, {
	    key: "renderNoActivitiesBlock",
	    value: function renderNoActivitiesBlock(studentsWithoutExercises) {
	      return studentsWithoutExercises.length ? React.createElement(NoActivityBlock, { userIDs: studentsWithoutExercises, contentType: "Activities" }) : '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var studentsWithoutExercises = [];
	      var rows = _underscore2.default.map(this.sortUserIDs(), function (userID) {
	        // combine array of arrays
	        var taskItems = _this4.getTaskItems(userID);
	        var allExercises = _this4.getAllTasks(userID);
	
	        var assignedExercises = _underscore2.default.size(allExercises);
	        var completedExercises = _underscore2.default.size(_underscore2.default.filter(allExercises, function (exercise) {
	          return _this4.isComplete(exercise);
	        }));
	
	        if (taskItems.length || allExercises.length) {
	          var assignedTaskItems = taskItems.length;
	          var completedTaskItems = _underscore2.default.size(_underscore2.default.where(taskItems, { draft: false }));
	
	          var studentName = _underscore2.default.findWhere(_this4.props.students, { id: userID }).display_name || '';
	
	          return React.createElement(
	            "div",
	            { className: "studentRow", key: userID },
	            React.createElement(
	              "div",
	              { className: "rowContent" },
	              React.createElement(
	                "div",
	                { className: "infoSection dataCell" },
	                React.createElement(
	                  "div",
	                  { className: "avatarBox hideOnPrint" },
	                  React.createElement(StudentAvatar, { studentID: userID, maxWidth: 30 })
	                ),
	                React.createElement(
	                  "div",
	                  { className: "infoSection studentName ellipsisText" },
	                  studentName,
	                  React.createElement(StudentListDisplay, { studentID: userID })
	                )
	              ),
	              React.createElement(
	                "div",
	                { className: "statSection dataCell" },
	                React.createElement(
	                  "div",
	                  null,
	                  React.createElement(
	                    "span",
	                    null,
	                    completedExercises,
	                    "/",
	                    assignedExercises
	                  )
	                ),
	                React.createElement(ProgressBar, { current: completedExercises, total: assignedExercises })
	              ),
	              React.createElement(
	                "div",
	                { className: "statSection dataCell" },
	                React.createElement(
	                  "div",
	                  null,
	                  React.createElement(
	                    "span",
	                    null,
	                    completedTaskItems,
	                    "/",
	                    assignedTaskItems
	                  )
	                ),
	                React.createElement(ProgressBar, { current: completedTaskItems, total: assignedTaskItems })
	              )
	            )
	          );
	        } else {
	          studentsWithoutExercises.push(userID);
	        }
	      });
	
	      rows = _underscore2.default.filter(rows, function (row) {
	        return row !== undefined;
	      });
	
	      return React.createElement(
	        "div",
	        { className: "allStudentActivitiesTable" },
	        this.renderTableHeaders(rows),
	        rows,
	        this.renderNoActivitiesBlock(studentsWithoutExercises)
	      );
	    }
	  }]);
	
	  return AllStudentActivitiesTable;
	}(React.Component)) || _class) || _class);
	
	
	var LAST_ACTIVE = "last-active";
	var STUDENT_NAME_ORDER = "student-name";
	var TEACHER_PICKS_COMPLETE = "teacher-picks-complete";
	var EXERCISE_COMPLETE = "exercise-complete";
	
	AllStudentActivitiesTable.WrappedComponent.propTypes = StrictPropTypes({
	  // userID of the student for this table
	  startDate: PropTypes.string,
	  userIDs: PropTypes.array,
	  endDate: PropTypes.string,
	  textVariety: PropTypes.string,
	  textID: PropTypes.string,
	  showFullData: PropTypes.bool,
	  // List of activities
	  activities: PropTypes.array,
	  students: PropTypes.array,
	  tasks: PropTypes.array,
	  activityTasks: PropTypes.array,
	  books: PropTypes.array,
	  // List of responses
	  responses: PropTypes.array,
	  // Data from @connect
	  loading: PropTypes.bool,
	  // Handlers from @connect
	  populateData: PropTypes.func,
	  fetchBook: PropTypes.func,
	  toggleExpandedResponse: PropTypes.func
	});
	
	module.exports = AllStudentActivitiesTable;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Board = __webpack_require__(168);
	var DropDownOptions = __webpack_require__(26);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var AssignTaskModal = __webpack_require__(199);
	var AssignExerciseDetailsModal = __webpack_require__(424);
	var DisplayToggleControl = __webpack_require__(48);
	var PicksPage = __webpack_require__(242);
	
	var Skillsets = __webpack_require__(55);
	var TextTypes = __webpack_require__(38);
	var Features = __webpack_require__(16);
	var ResponseModal = __webpack_require__(175);
	var Formats = __webpack_require__(105);
	var GradeLevel = __webpack_require__(40);
	var HelpSectionLink = __webpack_require__(64);
	var DisplayToggleControl = __webpack_require__(48);
	
	var RosterActions = __webpack_require__(11);
	var RosterSelectors = __webpack_require__(6);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ReadingSelectors = __webpack_require__(21);
	var ActionUtility = __webpack_require__(95);
	var Modal = __webpack_require__(18);
	
	var ActivitiesPageRouting = __webpack_require__(255);
	
	__webpack_require__(3825);
	
	var ExercisePage = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    user: CurrentUser.get(),
	    activities: WritingSelectors.getMostRecentActivities({ state: state, withAssigned: true }) || [],
	    studentLists: RosterSelectors.studentLists({ state: state }),
	    isLoadingLogs: ReadingSelectors.isLoadingLogs({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    fetchActivities: function fetchActivities(attr) {
	      var filters = attr.filters,
	          conditions = attr.conditions,
	          embeds = attr.embeds,
	          page = attr.page,
	          cache = attr.cache;
	
	      return dispatch(WritingActions.fetchActivities({
	        filters: filters, conditions: conditions, embeds: embeds, page: page, cache: cache
	      }));
	    },
	    clearActivities: function clearActivities() {
	      return dispatch(WritingActions.clearActivities());
	    },
	
	    populateData: function populateData() {
	      // TODO: standardize FE requests
	      var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick", 'exercise'] } };
	      var embeds = ['task.task_items'];
	      if ($wr.isLargeRequest(props.userIDs)) {
	        var actionFunction = WritingActions.fetchTasks;
	        return new Promise(function (resolve, reject) {
	          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds: embeds }, function (results) {
	            resolve(results);
	          });
	        }).catch(function () {
	          return console.log("Tasks failed to load");
	        });
	      } else {
	        return dispatch(WritingActions.fetchTasks({ embeds: embeds, conditions: conditions }));
	      }
	    },
	    fetchTasks: function fetchTasks() {
	      dispatch(ActionUtility.clearLoadingRecords("tasks"));
	      var conditions = { oneOfMatch: { subject_type: ["URLPick", "TitlePick", 'exercise'] } };
	      var embeds = ['task.task_items'];
	      if ($wr.isLargeRequest(props.userIDs)) {
	        var actionFunction = WritingActions.fetchTasks;
	        return new Promise(function (resolve, reject) {
	          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, { embeds: embeds }, function (results) {
	            resolve(results);
	          });
	        }).catch(function () {
	          return console.log("Tasks failed to load");
	        });
	      } else {
	        return dispatch(WritingActions.fetchTasks({ embeds: embeds, conditions: conditions }));
	      }
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(ExercisePage, _React$Component);
	
	  function ExercisePage(props) {
	    _classCallCheck(this, ExercisePage);
	
	    var _this = _possibleConstructorReturn(this, (ExercisePage.__proto__ || Object.getPrototypeOf(ExercisePage)).call(this));
	
	    autobind(_this);
	    var selGradeLevel = $wr.getURLParameterByName("grade_level") || props.user.grade_level;
	    _this.assignTaskModal = React.createRef();
	    _this.AssignExerciseDetailsModal = React.createRef();
	
	    _this.state = {
	      stateVersion: 0,
	
	      // Vars for lazyloading activities
	      page: null, loading: false, doneLoading: false,
	
	      // Allows us to show a completed response on this page
	      previewResponseID: null,
	
	      // Allow teachers to create tasks
	      activityToAssignID: null,
	
	      // Activity title
	      selectedActivityTitle: "",
	
	      // Filter options
	      selectedSkillset: $wr.getURLParameterByName("skillset"),
	      selectedTextVariety: TextTypes.Varieties.BOTH,
	      selectedGrade: selGradeLevel,
	      selectedFormat: null,
	      selectedUserIDs: [],
	
	      view: EXERCISE_VIEW
	    };
	    return _this;
	  }
	
	  _createClass(ExercisePage, [{
	    key: "assignActivity",
	    value: function assignActivity(activity) {
	      var _this2 = this;
	
	      this.setState({
	        activityToAssignID: activity.id,
	        selectedActivityTitle: activity.format_summary.title
	      }, function () {
	        _this2.assignTaskModal.current.show();
	      });
	    }
	  }, {
	    key: "buildOnSkillsetSelectF",
	    value: function buildOnSkillsetSelectF(skillset) {
	      return function (e) {
	        $wr.nope(e);
	        this.setState({ selectedSkillset: skillset }, function () {
	          this.resetActivities();
	        }.bind(this));
	        Mycroft.newEvent({ category: "Activities Board", action: "select-skillset", label: skillset });
	      }.bind(this);
	    }
	  }, {
	    key: "buildOnTextVarietySelectF",
	    value: function buildOnTextVarietySelectF(textVariety) {
	      return function (e) {
	        $wr.nope(e);
	        this.setState({ selectedTextVariety: textVariety }, function () {
	          this.resetActivities();
	        }.bind(this));
	        Mycroft.newEvent({ category: "Activities Board", action: "select-text-variety", label: textVariety });
	      }.bind(this);
	    }
	  }, {
	    key: "buildOnFormatSelectF",
	    value: function buildOnFormatSelectF(format) {
	      return function () {
	        this.setState({ selectedFormat: format }, function () {
	          this.resetActivities();
	        }.bind(this));
	        Mycroft.newEvent({ category: "Activities Board", action: "select-format", label: format });
	      }.bind(this);
	    }
	  }, {
	    key: "buildOnGradeSelectF",
	    value: function buildOnGradeSelectF(grade) {
	      return function () {
	        this.setState({ selectedGrade: grade }, function () {
	          this.resetActivities();
	        }.bind(this));
	        Mycroft.newEvent({ category: "Activities Board", action: "select-grade", label: grade });
	      }.bind(this);
	    }
	  }, {
	    key: "renderSkillsetSelector",
	    value: function renderSkillsetSelector() {
	      var readingOptions = DropDownOptions.Button.Skillsets({
	        buildOptionF: this.buildOnSkillsetSelectF, ogReadingOnly: true
	      });
	
	      var writingOptions = DropDownOptions.Button.Skillsets({
	        buildOptionF: this.buildOnSkillsetSelectF, writingOnly: true
	      });
	
	      var skillset = this.state.selectedSkillset;
	      if (skillset == undefined) {
	        var skillsetText = "All skill sets";
	      } else {
	        var skillsetText = Skillsets.getName(skillset);
	      }
	
	      return React.createElement(
	        ButtonDropdown,
	        { text: skillsetText, dropdownDisplay: "link",
	          className: "skillsetControl nested" },
	        React.createElement(ButtonDropdownOption, { onClick: this.buildOnSkillsetSelectF(null),
	          text: "All skill sets", className: "topLevel" }),
	        React.createElement(
	          "li",
	          { className: "dropdown-header" },
	          "Reading"
	        ),
	        readingOptions,
	        React.createElement(
	          "li",
	          { className: "dropdown-header" },
	          "Writing"
	        ),
	        writingOptions
	      );
	    }
	  }, {
	    key: "renderFilterControls",
	    value: function renderFilterControls() {
	
	      var formatOptions = DropDownOptions.Button.Formats({
	        buildOptionF: this.buildOnFormatSelectF, allOption: true
	      });
	      var format = this.state.selectedFormat;
	      if (format == undefined) {
	        var formatText = "All formats";
	      } else {
	        var formatText = Formats.getName(format);
	      }
	
	      var textVarietyOptions = DropDownOptions.Button.TextVarieties({
	        buildOptionF: this.buildOnTextVarietySelectF
	      });
	      var textVarietyText = TextTypes.Varieties.getName(this.state.selectedTextVariety);
	      var buttonDropdownFormatFilter = React.createElement(
	        ButtonDropdown,
	        { text: formatText, dropdownDisplay: "link",
	          className: "formatControl" },
	        formatOptions
	      );
	
	      var grade = this.state.selectedGrade;
	      if (grade == undefined) {
	        var gradeText = "All grades";
	      } else {
	        var gradeText = GradeLevel.getName(grade);
	      }
	      var gradeOptions = DropDownOptions.Button.Grades({
	        buildOptionF: this.buildOnGradeSelectF, allOption: true,
	        currentGradeLevel: this.props.user.grade_level
	      });
	
	      return React.createElement(
	        "div",
	        { className: "filterControls" },
	        React.createElement(
	          ButtonDropdown,
	          { text: gradeText, dropdownDisplay: "link",
	            className: "gradeControl" },
	          gradeOptions
	        ),
	        this.renderSkillsetSelector(),
	        buttonDropdownFormatFilter,
	        React.createElement(
	          ButtonDropdown,
	          { text: textVarietyText, dropdownDisplay: "link",
	            className: "textVarietyControl" },
	          textVarietyOptions
	        )
	      );
	    }
	  }, {
	    key: "renderAssignTaskModal",
	    value: function renderAssignTaskModal() {
	      var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
	      return React.createElement(
	        Modal,
	        { headerText: modalHeader, ref: this.assignTaskModal, modalOrder: 2 },
	        React.createElement(AssignTaskModal, { key: this.state.activityToAssignID,
	          taskSubjectType: "exercise",
	          taskSubjectID: this.state.activityToAssignID,
	          selectedActivityTitle: this.state.selectedActivityTitle,
	          renderAdditionalModal: true,
	          onAssign: this.hideAssignModal
	        })
	      );
	    }
	  }, {
	    key: "hideAssignModal",
	    value: function hideAssignModal(selectedUserIDs, showNextModal) {
	      showNextModal = showNextModal === null ? false : showNextModal;
	
	      this.setState({ selectedUserIDs: selectedUserIDs });
	
	      this.assignTaskModal.current.hide();
	      if (showNextModal) {
	        this.AssignExerciseDetailsModal.current.show();
	      }
	    }
	  }, {
	    key: "renderAssignExerciseDetailsModal",
	    value: function renderAssignExerciseDetailsModal() {
	      var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
	      return React.createElement(
	        Modal,
	        { ref: this.AssignExerciseDetailsModal, headerText: modalHeader, modalOrder: 3 },
	        React.createElement(AssignExerciseDetailsModal, {
	          selectedUserIDs: this.state.selectedUserIDs,
	          taskSubjectType: "Exercise",
	          taskSubjectID: this.state.activityToAssignID,
	          selectedActivityTitle: this.state.selectedActivityTitle,
	          onAssign: this.hideAssignExerciseDetailsModal })
	      );
	    }
	  }, {
	    key: "hideAssignExerciseDetailsModal",
	    value: function hideAssignExerciseDetailsModal() {
	      this.AssignExerciseDetailsModal.current.hide();
	      this.props.fetchTasks();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      if (this.state.previewResponseID) {
	        var previewModal = React.createElement(ResponseModal, { ref: "previewResponseModal",
	          key: this.state.previewResponseID, adminPreview: true,
	          responseID: this.state.previewResponseID });
	      }
	
	      if (this.state.activityToAssignID) {
	        var assignTaskModal = this.renderAssignTaskModal();
	      }
	
	      var activities = this.props.activities || [];
	
	      if (this.state.selectedSkillset == undefined) {
	        var skillsetText = "All skill sets";
	      } else {
	        var skillsetText = Skillsets.getName(this.state.selectedSkillset);
	      }
	
	      if (this.state.doneLoading) {
	        var doneLoadingNotice = React.createElement(
	          "div",
	          { className: "doneLoadingNotice" },
	          "That's it for now, but we are always adding new exercises. Have exercise ideas of your own? Email ideas or worksheets to ",
	          React.createElement(
	            "a",
	            { href: "mailto:exercises@whooosreading.org" },
	            "exercises@whooosreading.org"
	          ),
	          " and we will create them! (Note: We cannot create exercises that go with a specific book)."
	        );
	      }
	
	      var activeViewContent = React.createElement(
	        "div",
	        null,
	        React.createElement(
	          "div",
	          { className: "clearfix" },
	          this.renderFilterControls(),
	          React.createElement(
	            "p",
	            null,
	            React.createElement(HelpSectionLink, { featureName: "allowing pop-ups to view/print", linkSuffix: "115002455792", iconOnly: false })
	          )
	        ),
	        React.createElement(Board, { type: Board.TEACHER_ACTIVITIES, key: this.state.stateVersion,
	          items: activities, onItemAssign: this.assignActivity,
	          loading: this.state.loading, onScrollToBottom: this.fetchActivities }),
	        doneLoadingNotice
	      );
	
	      return React.createElement(
	        "div",
	        { className: "container exercisePage" },
	        activeViewContent,
	        previewModal,
	        assignTaskModal,
	        this.renderAssignExerciseDetailsModal()
	      );
	    }
	  }, {
	    key: "resetActivities",
	    value: function resetActivities() {
	      this.props.clearActivities();
	      this.setState({
	        doneLoading: false, page: null,
	        stateVersion: this.state.stateVersion + 1
	      }, function () {
	        this.fetchActivities();
	      }.bind(this));
	    }
	  }, {
	    key: "fetchActivities",
	    value: function fetchActivities() {
	      var _this3 = this;
	
	      if (!this.state.doneLoading) {
	        this.props.fetchActivities({
	          page: this.state.page + 1 || null,
	          embeds: ["activity.format_summary"],
	          filters: _extends({
	            text_varieties: this.state.selectedTextVariety
	          }, this.state.selectedGrade != null ? { grade_levels: this.state.selectedGrade } : null, this.state.selectedFormat ? { formats: this.state.selectedFormat } : null, this.state.selectedSkillset ? { skillsets: this.state.selectedSkillset } : null)
	        }).then(function (action) {
	          var doneLoading = action.noMorePages || false;
	          var page = action.pagination.page;
	
	          _this3.setState({ page: page, doneLoading: doneLoading, loading: false });
	        });
	        this.setState({ loading: true });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchActivities();
	    }
	  }]);
	
	  return ExercisePage;
	}(React.Component)) || _class) || _class);
	;
	
	ExercisePage.EXERCISES_VIEW = "all-exercises";
	ExercisePage.ASSIGNED_TASKS_VIEW = "assigned-tasks";
	ExercisePage.COMPLETED_TASKS_VIEW = "completed-tasks";
	
	var EXERCISE_VIEW = "exercise";
	var TEACHER_PICKS_VIEW = "teacher-picks";
	
	module.exports = ExercisePage;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _WritingSelectors = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var DataRouting = __webpack_require__(36);
	var Formats = __webpack_require__(105);
	var Skillsets = __webpack_require__(55);
	var UIActions = __webpack_require__(41);
	var StudentMetrics = __webpack_require__(29);
	
	var Glyphicon = __webpack_require__(8);
	var NoActivityBlock = __webpack_require__(71);
	var StudentDisplay = __webpack_require__(52);
	
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	__webpack_require__(3827);
	
	function propsToConditions(props) {
	  var conditions = _underscore2.default.pick(props, "startDate", "endDate", "textID", "textVariety", "userIDs", "dueDate");
	
	  return conditions;
	}
	
	var ExpandedStudentActivitiesTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    loading: WritingSelectors.isLoadingResponses({ state: state }),
	    books: ReadingSelectors.books({ state: state }),
	    responses: WritingSelectors.responses({ state: state }),
	    activities: WritingSelectors.activities({ state: state }),
	    tasks: WritingSelectors.tasks({ state: state }),
	    students: RosterSelectors.students({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // TODO: standardize FE requests
	      // if the dataset of students is large, send multiple requests
	      if ($wr.isLargeRequest(props.userIDs)) {
	        var conditions = _underscore2.default.pick(props, "startDate", "endDate", "textID", "textVariety", "dueDate");
	        var actionFunction = WritingActions.fetchResponses;
	        var options = { cache: true };
	
	        return new Promise(function (resolve, reject) {
	          // responses
	          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
	            var responses = results;
	            actionFunction = WritingActions.fetchTasks;
	            options.embeds = ['task.task_items'];
	            // tasks
	            $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
	              var tasks = second_results;
	              resolve(_underscore2.default.compact(_underscore2.default.flatten(tasks.concat(responses))));
	            });
	          });
	        }).catch(function () {
	          return console.log("Responses and tasks failed to load");
	        });
	      } else {
	        var responses = dispatch(WritingActions.fetchResponses({
	          conditions: propsToConditions(props),
	          cache: true
	        }));
	
	        var tasks = dispatch(WritingActions.fetchTasks({
	          embeds: ['task.task_items'],
	          conditions: propsToConditions(props),
	          cache: true
	        }));
	
	        return Promise.all([responses, tasks]);
	      }
	    },
	    fetchBook: function fetchBook(textID) {
	      dispatch(ReadingActions.batchFetchBook({ id: textID }));
	    },
	    toggleExpandedResponse: function toggleExpandedResponse(responseID) {
	      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
	    },
	    fetchActivity: function fetchActivity(activityID) {
	      dispatch(WritingActions.fetchActivity({ id: activityID, embeds: ["activity.format_summary"] }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(ExpandedStudentActivitiesTable, _React$Component);
	
	  function ExpandedStudentActivitiesTable(props) {
	    _classCallCheck(this, ExpandedStudentActivitiesTable);
	
	    var _this = _possibleConstructorReturn(this, (ExpandedStudentActivitiesTable.__proto__ || Object.getPrototypeOf(ExpandedStudentActivitiesTable)).call(this));
	
	    autobind(_this);
	    // incomplete tasks would not be pulled by responses
	    var incompleteTasks = _underscore2.default.where(props.tasks, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, completed_at: null });
	    incompleteTasks = incompleteTasks.concat(_underscore2.default.where(props.tasks, { subject_type: ACTIVITY_SUBJECT_TYPE, completed_at: null }));
	
	    var unifiedTaskItemArray = _underscore2.default.flatten(_underscore2.default.uniq(_underscore2.default.compact(_underscore2.default.pluck(props.tasks, 'task_items'))));
	    var incompleteTaskItems = _underscore2.default.filter(unifiedTaskItemArray, function (task_item) {
	      if (task_item && task_item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && task_item.draft) {
	        return task_item;
	      }
	    });
	    incompleteTasks = incompleteTasks.concat(incompleteTaskItems);
	    var allExercises = props.responses.concat(incompleteTasks);
	    // get all userIDs of students who have activities
	    var studentsWithExercisesIDs = _underscore2.default.compact(_underscore2.default.uniq(_underscore2.default.map(allExercises, function (exercise) {
	      return exercise.user_id;
	    })));
	    var studentsWithCompletedExercisesIDs = _underscore2.default.compact(_underscore2.default.uniq(_underscore2.default.map(allExercises, function (exercise) {
	      return !exercise.draft && exercise.user_id;
	    })));
	    // students without exercises
	    var studentsWithoutExercises = _underscore2.default.filter([].concat(_toConsumableArray(props.userIDs)), function (userID) {
	      return !studentsWithExercisesIDs.includes(userID);
	    });
	    var studentsWithoutCompletedExercises = _underscore2.default.filter([].concat(_toConsumableArray(props.userIDs)), function (userID) {
	      return !studentsWithCompletedExercisesIDs.includes(userID);
	    });
	    // get book information
	    _underscore2.default.each(allExercises, function (item) {
	      if (item.text_id && item.text_id !== 'MISSING_TEXT_ID' && item.text_id !== '') {
	        props.fetchBook(item.text_id);
	      }
	      // get activity information for responses
	      if (item.activity_id) {
	        props.fetchActivity(item.activity_id);
	      }
	      // get activity information for tasks
	      if (item.subject_id) {
	        props.fetchActivity(parseInt(item.subject_id));
	      }
	    });
	
	    _this.state = { studentsWithoutExercises: studentsWithoutExercises, studentsWithoutCompletedExercises: studentsWithoutCompletedExercises, incompleteTasks: incompleteTasks, allExercises: allExercises, orderBy: STUDENT_NAME_ORDER };
	    return _this;
	  }
	
	  _createClass(ExpandedStudentActivitiesTable, [{
	    key: "handleActivityClick",
	    value: function handleActivityClick(e) {
	      if (e.currentTarget.getAttribute('data-response-id')) {
	        this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'));
	      }
	    }
	  }, {
	    key: "dateFormat",
	    value: function dateFormat(date) {
	      var d = new Date(date);
	      var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
	      var mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
	      var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
	
	      return mo + "/" + da + "/" + ye;
	    }
	  }, {
	    key: "renderSortContainer",
	    value: function renderSortContainer(activityDisplay) {
	      var sort = '';
	      if (activityDisplay && !_underscore2.default.isEmpty(activityDisplay)) {
	        sort = React.createElement(
	          "div",
	          { className: "sortControlContainer hideOnPrint" },
	          React.createElement(
	            "div",
	            { className: "sortControlCell" },
	            "Sort By: ",
	            this.renderSortControl()
	          )
	        );
	      }
	      return sort;
	    }
	  }, {
	    key: "renderSortControl",
	    value: function renderSortControl() {
	      var _this2 = this;
	
	      var orderOptionText = function orderOptionText(op) {
	        if (STUDENT_NAME_ORDER === op) {
	          return "Student Name";
	        } else if (LAST_ACTIVE === op) {
	          return "Last Activity";
	        } else if (ASSIGNED_DATE === op) {
	          return "Date Assigned";
	        } else if (DUE_DATE === op) {
	          return "Due Date";
	        } else {
	          return StudentMetrics.getLabel(op);
	        }
	      };
	
	      var renderOption = function renderOption(op) {
	        return React.createElement(ButtonDropdownOption, { key: op, className: "",
	          text: orderOptionText(op),
	          onClick: _this2.changeSortBy.bind(_this2, op) });
	      };
	
	      var orderOptions = [];
	
	      orderOptions.push(renderOption(STUDENT_NAME_ORDER));
	      orderOptions.push(renderOption(LAST_ACTIVE));
	      orderOptions.push(renderOption(ASSIGNED_DATE));
	      orderOptions.push(renderOption(DUE_DATE));
	
	      if (this.props.showGoals) {
	        _underscore2.default.each(this.props.expectationMetrics, function (metric) {
	          orderOptions.push(renderOption(metric));
	        });
	      } else {
	        _underscore2.default.each(this.props.userMetricsColumns, function (metric) {
	          orderOptions.push(renderOption(metric));
	        });
	      }
	
	      var displayText = orderOptionText(this.state.orderBy);
	
	      return React.createElement(
	        ButtonDropdown,
	        { dropdownDisplay: "link", text: displayText },
	        orderOptions
	      );
	    }
	  }, {
	    key: "changeSortBy",
	    value: function changeSortBy(orderBy) {
	      this.setState({ orderBy: orderBy });
	    }
	    // sorts user tables
	
	  }, {
	    key: "sortUserIDs",
	    value: function sortUserIDs() {
	      var _this3 = this;
	
	      var orderBy = this.state.orderBy;
	      var students = _underscore2.default.filter(this.props.students, function (student) {
	        return _underscore2.default.contains(_this3.props.userIDs, student.id);
	      });
	      students = $wr.sortByName(students, "flexName");
	      if (orderBy == LAST_ACTIVE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          return student.last_active || "1970-01-01";
	        }).reverse();
	      } else if (orderBy == ASSIGNED_DATE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          var responses = _underscore2.default.where(_this3.props.responses, { user_id: student.id });
	          var firstResponse = _underscore2.default.first(_underscore2.default.sortBy(responses, 'created_at'));
	          return firstResponse ? firstResponse.created_at : "1970-01-01";
	        });
	      } else if (orderBy == DUE_DATE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          var responses = _underscore2.default.where(_this3.props.responses, { user_id: student.id });
	          var firstResponse = _underscore2.default.first(_underscore2.default.sortBy(responses, 'due_date'));
	          return firstResponse ? firstResponse.due_date : "1970-01-01";
	        });
	      }
	      return _underscore2.default.pluck(students, 'id');
	    }
	
	    // sorts rows in tables
	
	  }, {
	    key: "sortExercises",
	    value: function sortExercises(allExerciseData) {
	      var orderBy = this.state.orderBy;
	      if (orderBy == DUE_DATE) {
	        allExerciseData = _underscore2.default.sortBy(allExerciseData, 'due_date');
	      } else {
	        allExerciseData = _underscore2.default.sortBy(allExerciseData, 'created_at');
	      }
	      return allExerciseData;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var allExercises = [].concat(_toConsumableArray(this.state.allExercises));
	      if (this.props.completed) {
	        allExercises = this.props.responses;
	      } else if (this.props.assigned) {
	        allExercises = [].concat(_toConsumableArray(this.state.incompleteTasks));
	      }
	
	      var allExerciseData = _underscore2.default.map(allExercises, function (item) {
	        var activityData = {};
	        activityData.created_at = item.created_at ? item.created_at : null;
	        activityData.due_date = item.due_date ? item.due_date : null;
	        activityData.text_id = item.text_id ? item.text_id : null;
	        activityData.activity_id = item.activity_id ? item.activity_id : parseInt(item.subject_id);
	        activityData.response_id = item.activity_id ? item.id : null;
	        activityData.completed_at = item.completed_at ? item.completed_at : null;
	        activityData.user_id = item.user_id ? item.user_id : null;
	
	        return activityData;
	      });
	
	      var activityDisplay = [];
	      var userIDs = this.sortUserIDs();
	      _underscore2.default.each(userIDs, function (userID) {
	        var rows = _underscore2.default.map(_this4.sortExercises(_underscore2.default.where(allExerciseData, { user_id: userID })), function (exercise) {
	          var activity = _underscore2.default.find(_this4.props.activities, { id: exercise.activity_id });
	          if (exercise) {
	            var assigned = React.createElement("td", null);
	            if (exercise && exercise.created_at) {
	              assigned = React.createElement(
	                "td",
	                null,
	                _this4.dateFormat(exercise.created_at)
	              );
	            }
	
	            var dueDate = React.createElement("td", null);
	            var taskForExercise = _underscore2.default.find(_this4.props.tasks, { user_id: exercise.user_id, subject_id: exercise.text_id });
	            if (exercise && exercise.due_date) {
	              dueDate = React.createElement(
	                "td",
	                null,
	                _this4.dateFormat(exercise.due_date)
	              );
	            } else if (taskForExercise && taskForExercise.due_date) {
	              dueDate = React.createElement(
	                "td",
	                null,
	                _this4.dateFormat(taskForExercise.due_date)
	              );
	            }
	
	            var textTitle = React.createElement("td", null);
	            if (exercise.text_id !== 'MISSING_TEXT_ID' && exercise.text_id !== '') {
	              var book = _underscore2.default.find(_this4.props.books, { text_id: exercise.text_id });
	              if (book) {
	                textTitle = React.createElement(
	                  "td",
	                  null,
	                  book.title
	                );
	              }
	            }
	
	            var activityTitle = React.createElement("td", null);
	            if (activity && activity.format_summary && activity.format_summary.title) {
	              var activityTitle = React.createElement(
	                "td",
	                null,
	                activity.format_summary.title
	              );
	            }
	
	            var skillSet = React.createElement("td", null);
	            if (activity && activity.format_summary && activity.format_summary.skillset) {
	              skillSet = React.createElement(
	                "td",
	                null,
	                Skillsets.getName(activity.format_summary.skillset)
	              );
	            }
	
	            var format = React.createElement("td", null);
	            if (activity && activity.format_summary && activity.format_summary.format_class) {
	              format = React.createElement(
	                "td",
	                null,
	                Formats.getName(activity.format_summary.format_class)
	              );
	            }
	
	            var complete = React.createElement(
	              "td",
	              { className: 'iconContainer' },
	              React.createElement(Glyphicon, { icon: "glyphicon glyphicon-unchecked icon-gray" })
	            );
	            if (exercise.completed_at && exercise.response_id) {
	              complete = React.createElement(
	                "td",
	                { className: 'iconContainer' },
	                React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check icon-green" }),
	                React.createElement(
	                  "a",
	                  { className: 'viewLink', onClick: _this4.handleActivityClick, "data-response-id": exercise.response_id },
	                  "View"
	                )
	              );
	            }
	
	            return React.createElement(
	              "tr",
	              { key: exercise.created_at + '_' + exercise.user_id + '_' + exercise.activity_id },
	              assigned,
	              dueDate,
	              textTitle,
	              activityTitle,
	              skillSet,
	              format,
	              complete
	            );
	          }
	        });
	
	        rows = _underscore2.default.compact(rows);
	
	        var studentTable = '';
	        if (rows.length) {
	          studentTable = React.createElement(
	            "div",
	            { className: "StudentActivitiesTable", key: userID + '_' + _this4.props.key },
	            React.createElement(StudentDisplay, { studentID: userID, showAvatar: true, avatarMaxWidth: 40 }),
	            React.createElement(
	              "table",
	              { className: "table table-bordered" },
	              React.createElement(
	                "tbody",
	                null,
	                React.createElement(
	                  "tr",
	                  null,
	                  React.createElement(
	                    "th",
	                    { "data-tip": "Most recent date of any activity during time period" },
	                    "Assigned"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "dueDateCol" },
	                    "Due Date"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "textTitleCol" },
	                    "Text Title"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "exerciseTitleCol" },
	                    "Exercise Title"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "skillSetCol" },
	                    "Skill Set"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "formatCol" },
	                    "Format"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "completeCol" },
	                    "Complete"
	                  )
	                ),
	                rows
	              )
	            )
	          );
	          activityDisplay.push(studentTable);
	        }
	      });
	
	      var noExercises = '';
	      // filter user ids for users without assigned or completed exercises
	      var contentType = this.props.assigned ? 'Assigned Exercises' : 'Completed Exercises';
	      var userIDs = this.props.assigned ? this.state.studentsWithoutExercises : this.state.studentsWithoutCompletedExercises;
	      if (userIDs.length) {
	        noExercises = React.createElement(NoActivityBlock, { userIDs: userIDs, contentType: contentType });
	      }
	
	      return React.createElement(
	        "div",
	        { className: "expandedStudentActivitiesTable", key: this.props.key },
	        this.renderSortContainer(activityDisplay),
	        activityDisplay,
	        noExercises
	      );
	    }
	  }]);
	
	  return ExpandedStudentActivitiesTable;
	}(React.Component)) || _class) || _class);
	
	
	var LAST_ACTIVE = "last-active";
	var STUDENT_NAME_ORDER = "student-name";
	var ASSIGNED_DATE = "assigned-date";
	var DUE_DATE = "due-date";
	
	var ACTIVITY_SUBJECT_TYPE = "Activity";
	
	ExpandedStudentActivitiesTable.WrappedComponent.propTypes = StrictPropTypes({
	  userID: PropTypes.number,
	  userIDs: PropTypes.array,
	  students: PropTypes.array,
	  startDate: PropTypes.string,
	  endDate: PropTypes.string,
	  textVariety: PropTypes.string,
	  textID: PropTypes.string,
	  showFullData: PropTypes.bool,
	  assigned: PropTypes.bool,
	  completed: PropTypes.bool,
	  includeAllActivities: PropTypes.bool,
	  // List of activities
	  activities: PropTypes.array,
	  activityTasks: PropTypes.array,
	  books: PropTypes.array,
	  tasks: PropTypes.array,
	  // List of responses
	  responses: PropTypes.array,
	  // Data from @connect
	  loading: PropTypes.bool,
	  // Handlers from @connect
	  populateData: PropTypes.func,
	  fetchActivity: PropTypes.func,
	  fetchBook: PropTypes.func,
	  toggleExpandedResponse: PropTypes.func
	});
	
	module.exports = ExpandedStudentActivitiesTable;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Activity = __webpack_require__(170);
	var Board = __webpack_require__(168);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(656);
	
	var StudentActivitiesPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			user: CurrentUser.get(),
			activities: WritingSelectors.getMostRecentActivities({ state: state }) || []
		};
	}, function (dispatch, props) {
		return {
			fetchActivities: function fetchActivities(attr) {
				var filters = attr.filters,
				    conditions = attr.conditions,
				    embeds = attr.embeds,
				    page = attr.page,
				    cache = attr.cache;
	
				return dispatch(WritingActions.fetchActivities({ filters: filters, conditions: conditions, embeds: embeds, page: page, cache: cache }));
			},
			clearActivities: function clearActivities() {
				return dispatch(WritingActions.clearActivities());
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(StudentActivitiesPage, _React$Component);
	
		function StudentActivitiesPage(props) {
			_classCallCheck(this, StudentActivitiesPage);
	
			var _this = _possibleConstructorReturn(this, (StudentActivitiesPage.__proto__ || Object.getPrototypeOf(StudentActivitiesPage)).call(this));
	
			autobind(_this);
			_this.state = {
				page: null, loading: false, doneLoading: false
			};
			return _this;
		}
	
		_createClass(StudentActivitiesPage, [{
			key: "render",
			value: function render() {
				var activities = this.props.activities;
				var pageBody = React.createElement(Board, { type: Board.STUDENT_ACTIVITIES, items: activities,
					loading: this.state.loading, onScrollToBottom: this.fetchActivities });
	
				return React.createElement(
					"div",
					{ className: "container", id: "activitiesPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Activity Center"
						)
					),
					pageBody
				);
			}
		}, {
			key: "fetchActivities",
			value: function fetchActivities() {
				var _this2 = this;
	
				if (!this.state.doneLoading) {
					this.props.fetchActivities({
						page: this.state.page + 1 || null,
						embeds: ["activity.format_summary"],
						filters: {
							grade_levels: this.props.user.prefs.academic_level
	
						}
					}).then(function (action) {
						var doneLoading = action.noMorePages || false;
						var page = action.pagination.page;
	
						_this2.setState({ page: page, doneLoading: doneLoading, loading: false });
					});
	
					this.setState({ loading: true });
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.fetchActivities();
			}
		}]);
	
		return StudentActivitiesPage;
	}(React.Component)) || _class);
	;
	
	StudentActivitiesPage.propTypes = PageStrictPropTypes({});
	
	module.exports = StudentActivitiesPage;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	var _underscore = __webpack_require__(19);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = __webpack_require__(12);
	
	var CurrentUser = __webpack_require__(3);
	var DataRouting = __webpack_require__(36);
	var Formats = __webpack_require__(105);
	var Skillsets = __webpack_require__(55);
	var UIActions = __webpack_require__(41);
	var StudentMetrics = __webpack_require__(29);
	
	var Glyphicon = __webpack_require__(8);
	var NoActivityBlock = __webpack_require__(71);
	var StudentDisplay = __webpack_require__(52);
	var ScoreDisplay = __webpack_require__(103);
	var ButtonDropdownOption = __webpack_require__(31);
	var ButtonDropdown = __webpack_require__(23);
	
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(3828);
	
	function propsToConditions(props) {
	  var conditions = _underscore2.default.pick(props, "startDate", "endDate", "textVariety", "textID", "userIDs", "draft", "dueDate");
	
	  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	  conditions.withTotal = true;
	
	  return conditions;
	}
	
	var TeacherPicksTable = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    loading: WritingSelectors.isLoadingResponses({ state: state }),
	    books: ReadingSelectors.books({ state: state }),
	    quizzes: WritingSelectors.quizzes({ state: state }),
	    teacherPicks: WritingSelectors.teacherPicksTasks({ state: state, conditions: propsToConditions(props) }),
	    students: RosterSelectors.students({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    populateData: function populateData() {
	      // TODO: standardize FE requests
	      if ($wr.isLargeRequest(props.userIDs)) {
	        // define params for quiz call
	        var actionFunction = WritingActions.fetchQuizzes;
	        var conditions = {};
	        var embeds = ["quiz.evaluation", "evaluation.score_details"];
	        var options = { cache: true, embeds: embeds };
	        return new Promise(function (resolve, reject) {
	          // fetch quizzes
	          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
	            var quizzesPromise = results;
	            // define params for response call
	            actionFunction = WritingActions.fetchResponses;
	            conditions = _underscore2.default.pick(props, "startDate", "endDate", "textVariety", "textID", "draft", "dueDate");
	            options = { cache: true
	              // fetch responses
	            };$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
	              var responsesPromise = second_results;
	              // define params for task call
	              actionFunction = WritingActions.fetchTasks;
	              options.embeds = ['task.task_items'];
	              // fetch responses
	              $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (third_results) {
	                var tasksPromise = third_results;
	                // resolve all promises
	                resolve(_underscore2.default.compact(_underscore2.default.flatten(quizzesPromise.concat(responsesPromise, tasksPromise))));
	              });
	            });
	          });
	        }).catch(function () {
	          return console.log("Reading levels and students failed to load");
	        });
	      } else {
	        var quizes = dispatch(WritingActions.fetchQuizzes({
	          conditions: { userIDs: [props.userIDs] },
	          embeds: ["quiz.evaluation", "evaluation.score_details"],
	          page: props.page || 1,
	          cache: true
	        }));
	
	        var responses = dispatch(WritingActions.fetchResponses({
	          conditions: propsToConditions(props),
	          cache: true
	        }));
	
	        var tasks = dispatch(WritingActions.fetchTasks({
	          embeds: ['task.task_items'],
	          conditions: propsToConditions(props),
	          cache: true
	        }));
	
	        return Promise.all([responses, tasks, quizes]);
	      }
	    },
	    fetchBook: function fetchBook(textID) {
	      dispatch(ReadingActions.batchFetchBook({ id: textID }));
	    },
	    toggleExpandedResponse: function toggleExpandedResponse(responseID) {
	      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
	    },
	    fetchEvaluation: function fetchEvaluation(evaluationID) {
	      return dispatch(function (dispatch, getState) {
	        return WritingSelectors.evaluation({ state: getState(), id: evaluationID });
	      });
	    },
	    fetchActivity: function fetchActivity(activityID) {
	      dispatch(WritingActions.fetchActivity({ id: activityID, embeds: ["activity.format_summary"] }));
	    }
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(TeacherPicksTable, _React$Component);
	
	  function TeacherPicksTable(props) {
	    _classCallCheck(this, TeacherPicksTable);
	
	    var _this = _possibleConstructorReturn(this, (TeacherPicksTable.__proto__ || Object.getPrototypeOf(TeacherPicksTable)).call(this));
	
	    autobind(_this);
	
	    var studentsWithoutExercises = [];
	    // get all userIDs of students who have activities
	    var studentsWithExercisesIDs = _underscore2.default.uniq(_underscore2.default.pluck(props.teacherPicks, 'user_id'));
	    // check if selected students have activities
	    _underscore2.default.each(props.userIDs, function (userID) {
	      if (!_underscore2.default.includes(studentsWithExercisesIDs, userID)) {
	        studentsWithoutExercises.push(userID);
	      }
	    });
	    // get book information
	    _underscore2.default.each(props.teacherPicks, function (item) {
	      if (item.subject_id && item.subject_id !== 'MISSING_TEXT_ID' && item.subject_id !== '') {
	        props.fetchBook(item.subject_id);
	      }
	    });
	    _this.state = { orderBy: STUDENT_NAME_ORDER, studentsWithoutExercises: studentsWithoutExercises, studentsWithExercisesIDs: studentsWithExercisesIDs };
	    return _this;
	  }
	
	  _createClass(TeacherPicksTable, [{
	    key: "renderSortControl",
	    value: function renderSortControl(teacherPicksDisplay) {
	      var _this2 = this;
	
	      if (_underscore2.default.size(_underscore2.default.compact(teacherPicksDisplay))) {
	        var orderOptionText = function orderOptionText(op) {
	          if (STUDENT_NAME_ORDER === op) {
	            return "Student Name";
	          } else if (LAST_ACTIVE === op) {
	            return "Last Activity";
	          } else if (TEACHER_PICKS_COMPLETE === op) {
	            return "Teacher Picks Completed";
	          } else if (TEACHER_PICKS_INCOMPLETE === op) {
	            return "Teacher Picks Incomplete";
	          } else if (ASSIGNED_DATE === op) {
	            return "Assigned Date";
	          } else if (DUE_DATE === op) {
	            return "Due Date";
	          } else {
	            return StudentMetrics.getLabel(op);
	          }
	        };
	
	        var renderOption = function renderOption(op) {
	          return React.createElement(ButtonDropdownOption, { key: op, className: "",
	            text: orderOptionText(op),
	            onClick: _this2.changeSortBy.bind(_this2, op) });
	        };
	
	        var orderOptions = [];
	
	        orderOptions.push(renderOption(STUDENT_NAME_ORDER));
	        orderOptions.push(renderOption(LAST_ACTIVE));
	        orderOptions.push(renderOption(TEACHER_PICKS_COMPLETE));
	        orderOptions.push(renderOption(TEACHER_PICKS_INCOMPLETE));
	        orderOptions.push(renderOption(ASSIGNED_DATE));
	        orderOptions.push(renderOption(DUE_DATE));
	
	        if (this.props.showGoals) {
	          _underscore2.default.each(this.props.expectationMetrics, function (metric) {
	            orderOptions.push(renderOption(metric));
	          });
	        } else {
	          _underscore2.default.each(this.props.userMetricsColumns, function (metric) {
	            orderOptions.push(renderOption(metric));
	          });
	        }
	
	        var displayText = orderOptionText(this.state.orderBy);
	
	        return React.createElement(
	          "div",
	          { className: "sortControlContainer hideOnPrint" },
	          React.createElement(
	            "div",
	            { className: "sortControlCell" },
	            "Sort By: ",
	            React.createElement(
	              ButtonDropdown,
	              { dropdownDisplay: "link", text: displayText },
	              " ",
	              orderOptions,
	              " "
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "changeSortBy",
	    value: function changeSortBy(orderBy) {
	      this.setState({ orderBy: orderBy });
	    }
	  }, {
	    key: "onCellClick",
	    value: function onCellClick(subjectType, textID, userID) {
	      $wr.redirect(DataRouting.getPath({ subjectType: subjectType, textID: textID, userID: userID }));
	      $wr.setWindowY(0);
	    }
	  }, {
	    key: "handleActivityClick",
	    value: function handleActivityClick(e) {
	      if (e.currentTarget.getAttribute('data-response-id')) {
	        this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'));
	      }
	    }
	  }, {
	    key: "dateFormat",
	    value: function dateFormat(date) {
	      var d = new Date(date);
	      var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
	      var mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
	      var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
	
	      return mo + "/" + da + "/" + ye;
	    }
	  }, {
	    key: "filterTaskItems",
	    value: function filterTaskItems(taskItems, key, value) {
	      return _underscore2.default.filter(taskItems, function (item) {
	        return item[key] === value;
	      });
	    }
	  }, {
	    key: "handleWritingClick",
	    value: function handleWritingClick(e) {
	      $wr.nope(e);
	      if (e.target.getAttribute('data-text-id') && e.target.getAttribute('data-subject-type') && e.target.getAttribute('data-user-id')) {
	        var viewPath = "/data/" + e.target.getAttribute('data-user-id') + "/" + e.target.getAttribute('data-subject-type') + "?text_id=" + e.target.getAttribute('data-text-id');
	        $wr.redirect(viewPath);
	      }
	    }
	  }, {
	    key: "createViewLink",
	    value: function createViewLink(numCompleted, text_id, subject_type, user_id) {
	      var viewLink = '';
	      if (numCompleted !== 0) {
	        var viewLink = React.createElement(
	          "a",
	          { className: 'viewLink',
	            onClick: this.handleWritingClick,
	            "data-subject-type": subject_type,
	            "data-text-id": text_id,
	            "data-user-id": user_id },
	          "View"
	        );
	      }
	      return viewLink;
	    }
	
	    // sorts rows in tables
	
	  }, {
	    key: "sortTeacherPicks",
	    value: function sortTeacherPicks(userID) {
	      var orderBy = this.state.orderBy;
	      var teacherPicks = _underscore2.default.where(this.props.teacherPicks, { user_id: userID });
	      if (orderBy == TEACHER_PICKS_COMPLETE) {
	        teacherPicks = _underscore2.default.sortBy(teacherPicks, function (teacherPick) {
	          return teacherPick.draft;
	        });
	      } else if (orderBy == TEACHER_PICKS_INCOMPLETE) {
	        teacherPicks = _underscore2.default.sortBy(teacherPicks, function (teacherPick) {
	          return teacherPick.draft;
	        }).reverse();
	      } else if (orderBy == DUE_DATE) {
	        teacherPicks = _underscore2.default.sortBy(teacherPicks, 'due_date');
	      } else {
	        teacherPicks = _underscore2.default.sortBy(teacherPicks, ['draft', 'created_at']);
	      }
	      return teacherPicks;
	    }
	    // sorts user tables
	
	  }, {
	    key: "sortUserIDs",
	    value: function sortUserIDs() {
	      var _this3 = this;
	
	      var orderBy = this.state.orderBy;
	      var students = $wr.sortByName(this.props.students, "flexName");
	      if (orderBy == LAST_ACTIVE) {
	        students = _underscore2.default.sortBy(this.props.students, function (student) {
	          return student.last_active || "1970-01-01";
	        }).reverse();
	      } else if (orderBy == TEACHER_PICKS_COMPLETE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          return _underscore2.default.size(_underscore2.default.where(_this3.props.teacherPicks, { user_id: student.id, draft: false }));
	        }).reverse();
	      } else if (orderBy == TEACHER_PICKS_INCOMPLETE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          return _underscore2.default.size(_underscore2.default.where(_this3.props.teacherPicks, { user_id: student.id, draft: true }));
	        }).reverse();
	      } else if (orderBy == ASSIGNED_DATE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          var studentTeacherPicks = _underscore2.default.where(_this3.props.teacherPicks, { user_id: student.id });
	          var firstTeacherPickAssigned = _underscore2.default.first(_underscore2.default.sortBy(studentTeacherPicks, 'created_at'));
	          return firstTeacherPickAssigned ? firstTeacherPickAssigned.created_at : "1970-01-01";
	        });
	      } else if (orderBy == DUE_DATE) {
	        students = _underscore2.default.sortBy(students, function (student) {
	          var studentTeacherPicks = _underscore2.default.where(_this3.props.teacherPicks, { user_id: student.id });
	          var firstTeacherPickAssigned = _underscore2.default.first(_underscore2.default.sortBy(studentTeacherPicks, 'due_date'));
	          return firstTeacherPickAssigned ? firstTeacherPickAssigned.due_date : "1970-01-01";
	        });
	      }
	      return _underscore2.default.pluck(students, 'id');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var teacherPicksDisplay = [];
	      _underscore2.default.each(this.sortUserIDs(), function (userID) {
	        var rows = _underscore2.default.map(_this4.sortTeacherPicks(userID), function (task) {
	
	          var taskItems = task.task_items;
	
	          if (taskItems) {
	            var assigned = React.createElement("td", null);
	            if (task.created_at) {
	              assigned = React.createElement(
	                "td",
	                null,
	                _this4.dateFormat(task.created_at)
	              );
	            }
	
	            var dueDate = React.createElement("td", null);
	            if (task.due_date) {
	              dueDate = React.createElement(
	                "td",
	                null,
	                _this4.dateFormat(task.due_date)
	              );
	            }
	
	            var textTitle = React.createElement("td", null);
	            if (task.subject_id !== 'MISSING_TEXT_ID' && task.subject_id !== '') {
	              var book = _underscore2.default.find(_this4.props.books, { text_id: task.subject_id });
	              if (book) {
	                textTitle = React.createElement(
	                  "td",
	                  { className: "textTitleColumn" },
	                  book.title
	                );
	              }
	            }
	
	            var quiz = React.createElement("td", null);
	            var quizTaskItem = _underscore2.default.find(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ });
	            if (quizTaskItem && quizTaskItem.subject_id !== null) {
	              if (!quizTaskItem.draft) {
	                var quizMatch = _underscore2.default.find(_this4.props.quizzes, { id: parseInt(quizTaskItem.subject_id) });
	                if (quizMatch && quizMatch.evaluation) {
	                  var evaluation = _this4.props.fetchEvaluation(quizMatch.evaluation);
	                  if (evaluation) {
	                    var expandQuizF = _this4.onCellClick.bind(_this4, DataRouting.SUBJECT_QUIZZES, quizMatch.text_id, quizMatch.user_id);
	                    quiz = React.createElement(
	                      "td",
	                      { className: "clickable", onClick: expandQuizF },
	                      React.createElement(ScoreDisplay, { evaluationID: evaluation.id, mode: ScoreDisplay.INLINE_MODE }),
	                      React.createElement(
	                        "a",
	                        { href: "#", className: "hideOnPrint", onClick: $wr.preventDefaultBehavior },
	                        "View"
	                      )
	                    );
	                  }
	                }
	              }
	            }
	
	            var otherWriting = React.createElement("td", null);
	            var otherWritingTaskItems = _underscore2.default.filter(taskItems, function (item) {
	              return item['subject_type'] !== StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ;
	            });
	            if (otherWritingTaskItems.length) {
	              var otherWritingDisplay = [];
	
	              var exerciseTaskItems = _this4.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE);
	              var pqTaskItems = _this4.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION);
	              var reviewTaskItem = _underscore2.default.first(_this4.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW));
	              var meatCogTaskItem = _this4.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER);
	
	              if (pqTaskItems.length) {
	                var numAssignedPQs = pqTaskItems.length;
	                var numCompletedPQs = _underscore2.default.size(_this4.filterTaskItems(pqTaskItems, 'draft', false));
	
	                var expandQuestionF = $wr.preventDefaultBehavior;
	                var viewLink = '';
	                if (numCompletedPQs > 0) {
	                  expandQuestionF = _this4.onCellClick.bind(_this4, DataRouting.SUBJECT_ANSWERS, pqTaskItems[0].text_id, task.user_id);
	                  viewLink = React.createElement(
	                    "a",
	                    { href: "#", className: "hideOnPrint viewLink", onClick: $wr.preventDefaultBehavior },
	                    "View"
	                  );
	                }
	                otherWritingDisplay.push(React.createElement(
	                  "div",
	                  { key: userID + '_pq', className: "clickable", onClick: expandQuestionF },
	                  React.createElement(
	                    "span",
	                    null,
	                    numCompletedPQs,
	                    "/",
	                    numAssignedPQs,
	                    " Questions"
	                  ),
	                  viewLink
	                ));
	              }
	
	              if (reviewTaskItem) {
	                var completedReview = reviewTaskItem.draft ? 0 : 1;
	                var expandReviewF = $wr.preventDefaultBehavior;
	                var viewLink = '';
	                if (completedReview > 0) {
	                  expandReviewF = _this4.onCellClick.bind(_this4, DataRouting.SUBJECT_REVIEWS, reviewTaskItem.text_id, reviewTaskItem.user_id);
	                  viewLink = React.createElement(
	                    "a",
	                    { href: "#", className: "hideOnPrint viewLink", onClick: $wr.preventDefaultBehavior },
	                    "View"
	                  );
	                }
	                otherWritingDisplay.push(React.createElement(
	                  "div",
	                  { key: userID + '_review', onClick: expandReviewF },
	                  React.createElement(
	                    "span",
	                    null,
	                    completedReview,
	                    "/",
	                    1,
	                    " Review"
	                  ),
	                  viewLink
	                ));
	              }
	
	              if (exerciseTaskItems.length) {
	                var numAssignedExercises = exerciseTaskItems.length;
	                var numCompletedExercises = _underscore2.default.size(_this4.filterTaskItems(exerciseTaskItems, 'draft', false));
	
	                var expandExercisesF = $wr.preventDefaultBehavior;
	                var viewLink = '';
	                if (numCompletedExercises > 0) {
	                  expandExercisesF = _this4.onCellClick.bind(_this4, DataRouting.SUBJECT_ACTIVITIES, exerciseTaskItems[0].text_id, exerciseTaskItems[0].user_id);
	                  viewLink = React.createElement(
	                    "a",
	                    { href: "#", className: "hideOnPrint viewLink", onClick: $wr.preventDefaultBehavior },
	                    "View"
	                  );
	                }
	
	                otherWritingDisplay.push(React.createElement(
	                  "div",
	                  { key: userID + '_exercise', onClick: expandExercisesF },
	                  React.createElement(
	                    "span",
	                    null,
	                    numCompletedExercises,
	                    "/",
	                    numAssignedExercises,
	                    " Exercises"
	                  ),
	                  viewLink
	                ));
	              }
	              // caluclate and display number of question builders assigned
	              if (meatCogTaskItem.length) {
	                var numAssignedQBs = meatCogTaskItem.length;
	                var numCompletedQBs = _underscore2.default.size(_this4.filterTaskItems(meatCogTaskItem, 'draft', false));
	
	                var expandQBsF = $wr.preventDefaultBehavior;
	                var viewLink = '';
	                if (numCompletedQBs > 0) {
	                  expandQBsF = _this4.onCellClick.bind(_this4, DataRouting.SUBJECT_QUESTION_BUILDERS, meatCogTaskItem[0].text_id, meatCogTaskItem[0].user_id);
	                  viewLink = React.createElement(
	                    "a",
	                    { href: "#", className: "hideOnPrint viewLink", onClick: $wr.preventDefaultBehavior },
	                    "View"
	                  );
	                }
	
	                otherWritingDisplay.push(React.createElement(
	                  "div",
	                  { key: userID + '_qb', onClick: expandQBsF },
	                  React.createElement(
	                    "span",
	                    null,
	                    numCompletedQBs,
	                    "/",
	                    numAssignedQBs,
	                    " Builders"
	                  ),
	                  viewLink
	                ));
	              }
	
	              if (otherWritingDisplay.length) {
	                otherWriting = React.createElement(
	                  "td",
	                  { className: "otherWritingContainer", key: String(userID) },
	                  otherWritingDisplay
	                );
	              }
	            }
	
	            var hideClass = taskItems.length === 0 ? 'hide-glyphicon' : '';
	            var complete = React.createElement(
	              "td",
	              { className: 'iconContainer ' + hideClass },
	              React.createElement(Glyphicon, { icon: "glyphicon glyphicon-unchecked icon-gray" })
	            );
	            var completedTaskItems = _underscore2.default.size(_underscore2.default.where(taskItems, { draft: false }));
	            if (completedTaskItems === _underscore2.default.size(taskItems)) {
	              complete = React.createElement(
	                "td",
	                { className: 'iconContainer ' + hideClass },
	                React.createElement(Glyphicon, { icon: "glyphicon glyphicon-check icon-green" })
	              );
	            }
	
	            return React.createElement(
	              "tr",
	              { key: task.id + '_' + task.user_id + '_' + task.receivedAt },
	              assigned,
	              dueDate,
	              textTitle,
	              quiz,
	              otherWriting,
	              complete
	            );
	          }
	        });
	        rows = _underscore2.default.compact(rows);
	
	        var studentTable = '';
	        if (rows.length) {
	          studentTable = React.createElement(
	            "div",
	            { className: "teacherPicksTableContainer", key: userID.toString() },
	            React.createElement(StudentDisplay, { studentID: userID, showAvatar: true, avatarMaxWidth: 40 }),
	            React.createElement(
	              "table",
	              { className: "table table-bordered" },
	              React.createElement(
	                "tbody",
	                null,
	                React.createElement(
	                  "tr",
	                  null,
	                  React.createElement(
	                    "th",
	                    { "data-tip": "Most recent date of any activity during time period" },
	                    "Assigned"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "dueDateCol" },
	                    "Due Date"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "textTitleCol" },
	                    "Text Title"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "quizCol" },
	                    "Quiz"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "otherWritingCol" },
	                    "Other Writing"
	                  ),
	                  React.createElement(
	                    "th",
	                    { className: "completeCol" },
	                    "Complete"
	                  )
	                ),
	                rows
	              )
	            )
	          );
	        }
	        teacherPicksDisplay.push(studentTable);
	      });
	
	      var noExercises = '';
	      if (this.state.studentsWithoutExercises.length) {
	        noExercises = React.createElement(NoActivityBlock, { userIDs: this.state.studentsWithoutExercises, contentType: "Exercises" });
	      }
	
	      if (_underscore2.default.size(this.state.studentsWithExercisesIDs) + _underscore2.default.size(this.state.studentsWithoutExercises) === _underscore2.default.size(this.props.userIDs)) {
	        return React.createElement(
	          "div",
	          { className: "teacherPicksTable", key: this.props.key },
	          this.renderSortControl(teacherPicksDisplay),
	          teacherPicksDisplay,
	          noExercises
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return TeacherPicksTable;
	}(React.Component)) || _class) || _class);
	
	
	var LAST_ACTIVE = "last-active";
	var STUDENT_NAME_ORDER = "student-name";
	var TEACHER_PICKS_COMPLETE = "teacher-picks-complete";
	var TEACHER_PICKS_INCOMPLETE = "teacher-picks-incomplete";
	var ASSIGNED_DATE = "assigned-date";
	var DUE_DATE = "due-date";
	
	TeacherPicksTable.WrappedComponent.propTypes = StrictPropTypes({
	  userIDs: PropTypes.array,
	  startDate: PropTypes.string,
	  endDate: PropTypes.string,
	  textVariety: PropTypes.string,
	  textID: PropTypes.string,
	  quizzes: PropTypes.array,
	  students: PropTypes.array,
	  fetchEvaluation: PropTypes.func,
	  fetchActivity: PropTypes.func,
	  books: PropTypes.array,
	  teacherPicks: PropTypes.array,
	  studentList: PropTypes.string,
	  loading: PropTypes.bool,
	  showFullData: PropTypes.bool,
	  draft: PropTypes.bool,
	  dueDate: PropTypes.string,
	  populateData: PropTypes.func,
	  fetchBook: PropTypes.func,
	  toggleExpandedResponse: PropTypes.func
	});
	
	module.exports = TeacherPicksTable;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackFormatter = __webpack_require__(73);
	var Glyphicon = __webpack_require__(8);
	var Spinner = __webpack_require__(9);
	var ReactionFeedback = __webpack_require__(101);
	var AutograderDisplayConfig = __webpack_require__(83);
	
	__webpack_require__(3829);
	
	var CurrentUser = __webpack_require__(3);
	
	var AnswerAnalysisDisplay = function (_React$Component) {
		_inherits(AnswerAnalysisDisplay, _React$Component);
	
		function AnswerAnalysisDisplay(props) {
			_classCallCheck(this, AnswerAnalysisDisplay);
	
			var _this = _possibleConstructorReturn(this, (AnswerAnalysisDisplay.__proto__ || Object.getPrototypeOf(AnswerAnalysisDisplay)).call(this));
	
			autobind(_this);
			if (props.shouldCollapse) {
				var show = false;
			} else {
				var show = true;
			}
			_this.state = {
				leaves: null,
				show: show
			};
			return _this;
		}
	
		_createClass(AnswerAnalysisDisplay, [{
			key: "triggerShow",
			value: function triggerShow() {
				if (!this.state.show) {
					if (!this.state.analysis) {
						this.loadAnalysis();
						this.setState({ show: !this.state.show });
					} else {
						this.setState({ show: !this.state.show }, this.triggerChainDisplay.bind(this, ">"));
					}
				} else {
					this.setState({ show: !this.state.show });
				}
			}
		}, {
			key: "renderReactionFeedback",
			value: function renderReactionFeedback() {
				var reactionDetails = {};
				reactionDetails[ReactionFeedback.HAPPY] = { label: "Great!" };
				reactionDetails[ReactionFeedback.NEUTRAL] = { label: "Not quite..." };
				reactionDetails[ReactionFeedback.SAD] = { label: "Completely wrong!" };
	
				var subjectType = "answer";
				var subjectID = this.props.answerID;
	
				var reactionWhere = "component-post-quiz-feedback-" + subjectType;
	
				return React.createElement(ReactionFeedback, { where: reactionWhere,
					key: reactionWhere,
					textOnly: false,
					options: reactionDetails,
					title: "Was this helpful?",
					placeholder: "Help us improve our scoring by telling us why...",
					component_position: ReactionFeedback.POSITION_BOTTOM_RIGHT,
					popover_position: ReactionFeedback.POSITION_BOTTOM_RIGHT,
					subjectType: subjectType,
					subjectID: subjectID });
			}
		}, {
			key: "renderCategory",
			value: function renderCategory(catKey, index) {
				var _this2 = this,
				    _React$createElement;
	
				var dynamicDisplayClass = ">" + index;
	
				var index = 0;
				var elements = _.map(ANALYSIS_CONFIG[catKey], function (leafKeys, label) {
					index += 1;
					return _this2.renderElement(dynamicDisplayClass, label, leafKeys, index);
				});
	
				return React.createElement(
					"div",
					(_React$createElement = { key: catKey }, _defineProperty(_React$createElement, "key", catKey), _defineProperty(_React$createElement, "className", "categoryRow"), _React$createElement),
					React.createElement(
						"b",
						{ className: "hiddenElement", ref: dynamicDisplayClass + "_0" },
						catKey
					),
					React.createElement(
						"table",
						{ className: "feedbackTable", ref: catKey + "_table" },
						React.createElement(
							"tbody",
							null,
							elements
						)
					)
				);
			}
		}, {
			key: "renderElement",
			value: function renderElement(cat, label, leafKeys, index) {
				var leaves = _.values(_.pick(this.state.leaves, leafKeys));
				var leafValue = _.reduce(leaves, function (sum, leaf) {
					return sum + leaf.value;
				}, 0) / leaves.length;
	
				var asScore = AutograderDisplayConfig.leafValueToScore(leafValue);
				var dynamicDisplayClass = cat + "_" + index;
				return React.createElement(
					"tr",
					{ className: "feebackTableRow hiddenElement", ref: dynamicDisplayClass + "_0", key: label },
					React.createElement(
						"td",
						{ className: "descriptionCell" },
						this.renderLabel(label, asScore)
					),
					this.renderValidCount(asScore, dynamicDisplayClass)
				);
			}
		}, {
			key: "renderValidCount",
			value: function renderValidCount(asScore, dynamicDisplayClass) {
	
				if (asScore == 4) {
					var cssClass = "valid";
					var glyphi = React.createElement(Glyphicon, { icon: "glyphicon glyphicon-ok-sign" });
				} else if (asScore == 3) {
					var cssClass = "average";
					var glyphi = React.createElement(Glyphicon, { icon: "glyphicon glyphicon-exclamation-sign" });
				} else {
					var cssClass = "error";
					var glyphi = React.createElement(Glyphicon, { icon: "glyphicon glyphicon-exclamation-sign" });
				}
				return React.createElement(
					"td",
					{ className: "validCountCell" },
					React.createElement(
						"div",
						{ className: "icon hiddenElement " + cssClass, ref: dynamicDisplayClass + "_1" },
						glyphi
					)
				);
			}
		}, {
			key: "renderLabel",
			value: function renderLabel(label, asScore) {
				if (asScore == 4) {
					var textIndex = 0;
				} else if (asScore == 3) {
					var textIndex = 1;
				} else {
					var textIndex = ANALYSIS_LABEL[label].length - 1;
				}
				return React.createElement(
					"div",
					{ className: "description" },
					ANALYSIS_LABEL[label][textIndex]
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.props.shouldCollapse) {
					if (this.state.show) {
						var optionText = "Hide results";
					} else {
						var optionText = "Show results";
					}
					var collapseOption = React.createElement(
						"a",
						{ className: "collapseOption hideOnPrint", onClick: this.triggerShow },
						optionText
					);
				}
				if (this.state.show) {
					if (this.state.leaves) {
						var feedback = _.keys(ANALYSIS_CONFIG).map(this.renderCategory.bind(this));
						var content = React.createElement(
							"div",
							{ className: "feedbackArea" },
							feedback,
							React.createElement(
								"div",
								{ className: "hiddenElement", ref: ">_999" },
								this.renderReactionFeedback()
							)
						);
					} else {
						var content = React.createElement(Spinner, { placeholder: true });
					}
				}
				return React.createElement(
					"div",
					{ className: "answerAnalysisDisplay" },
					collapseOption,
					content
				);
			}
		}, {
			key: "triggerChainDisplay",
			value: function triggerChainDisplay(dynamicDisplayClass) {
				var refs = Object.keys(this.refs).filter(function (key) {
					if (key.includes(dynamicDisplayClass)) {
						return 1;
					} else {
						return 0;
					}
				});
				if (refs.length > 0) {
					var _showNext = function _showNext() {
						index += 1;
						if (index < refs.length) {
							$(this.refs[refs[index]]).show(this.props.delay, _showNext.bind(this));
						} else {
							if (this.props.showCoinTable) {
								this.props.showCoinTable();
							}
						}
					};
	
					var index = 0;
					refs.sort();
	
					$(this.refs[refs[index]]).show(this.props.delay, _showNext.bind(this));
				}
			}
		}, {
			key: "loadAnalysis",
			value: function loadAnalysis() {
				CurrentUser.api().getAnswer(this.props.answerID, { "embed": "answer.evaluation_details" }, $wr.apiHandler(function (response) {
	
					if (response.answer && response.answer.evaluation_details && response.answer.evaluation_details.polarizing) {
						this.setState({
							leaves: response.answer.evaluation_details.polarizing
						}, this.triggerChainDisplay.bind(this, ">"));
					}
				}.bind(this)));
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!this.props.shouldCollapse) {
					this.loadAnalysis();
				}
			}
		}]);
	
		return AnswerAnalysisDisplay;
	}(React.Component);
	
	var ANALYSIS_CONFIG = {
		"Spelling and Grammar": {
			"Capitalization issues": ["comm-conv-mech-caps"],
			"Ending punctuation is present": ["comm-conv-mech-punc"],
			"Correct grammar and spelling": ["comm-conv-mech-gram", "comm-conv-mech-spell"]
		},
		"Organization and Vocabulary": {
			"Good usage of punctuation": ["comm-conv-org-sent-struct"],
			"Good introduction": ["comm-conv-org-intro"],
			"Avoiding overused words": ["comm-conv-voc-overused-vary"],
			"Advanced word choice": ["comm-conv-voc-level-complex", "comm-conv-voc-level-metrics"]
		},
		"Comprehension": {
			"Including details from the text": ["crit-evi-form-detail"],
			"Fully answering the question": ["crit-rc-atq-restated"]
		}
	};
	
	var ANALYSIS_LABEL = {
		"Capitalization issues": ["Good use of capitalization", "Some capitalization issues", "Capitalization issues"],
		"Ending punctuation is present": ["Ending punctuation is present", "Some punctuation marks are present", "Missing end punctuation"],
		"Correct grammar and spelling": ["Correct grammar and spelling", "Some grammar or spelling issues", "Grammar or spelling issues"],
		"Good usage of punctuation": ["Good usage of punctuation", "Some issues with organization", "Issues with organization"],
		"Good introduction": ["Good introduction", "Issues with the introduction"],
		"Avoiding overused words": ["Few repeated words", "Some repeated words", "Many repeated words"],
		"Advanced word choice": ["Good word choice", "Some overused words", "Many repeated words"],
		"Including details from the text": ["Included details from the text", "Included some details from the text", "Did not include details from the text"],
		"Fully answering the question": ["Fully answered the question", "Partially answered the question", "Did not answer to the question"]
	};
	
	AnswerAnalysisDisplay.propTypes = StrictPropTypes({
		// gold records to display
		answerID: PropTypes.number.isRequired,
		delay: PropTypes.number.isRequired,
		showCoinTable: PropTypes.func,
		shouldCollapse: PropTypes.bool
	});
	
	module.exports = AnswerAnalysisDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WritingActions = __webpack_require__(24);
	
	var NumbersOnlyInput = __webpack_require__(122);
	var CurrentUser = __webpack_require__(3);
	
	var AnswerEvalOverride = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var downProps = {};
	  downProps.nextQuestion = props.nextQuestion;
	  downProps.evaluation = props.evaluation;
	  downProps.graderID = CurrentUser.get().id;
	  return downProps;
	}, function (dispatch, props) {
	  return {
	    onUpdate: function onUpdate(evaluationID, evaluationUpdate) {
	      if (evaluationID) {
	        dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
	      }
	    }
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(AnswerEvalOverride, _React$Component);
	
	  function AnswerEvalOverride(props) {
	    _classCallCheck(this, AnswerEvalOverride);
	
	    var _this = _possibleConstructorReturn(this, (AnswerEvalOverride.__proto__ || Object.getPrototypeOf(AnswerEvalOverride)).call(this));
	
	    autobind(_this);
	
	    if (props.evaluation && props.evaluation.ratio) {
	      var editedScore = $wr.convertedScore(props.evaluation.ratio, 4);
	    }
	    _this.state = { editedScore: editedScore };
	    return _this;
	  }
	
	  _createClass(AnswerEvalOverride, [{
	    key: "saveEvaluation",
	    value: function saveEvaluation(e) {
	      $wr.nope(e);
	
	      var originalEvaluation = this.props.evaluation;
	
	      // Round up to the nearest 0.5
	      var override = Math.round(this.state.editedScore * 2) / 2;
	
	      var adminRatio = override / this.displayScoreCap();
	
	      // Project this onto the scale of the original evaluation
	      var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);
	
	      // set to 0 or score_cap if outside of 0-score_cap range
	      if (adminScore < 0) {
	        adminScore = 0;
	        adminRatio = 0;
	      } else if (adminScore > originalEvaluation.score_cap) {
	        adminScore = originalEvaluation.score_cap;
	        adminRatio = 1;
	      }
	
	      var scoreDetails = _.extend({}, originalEvaluation.score_details, { admin_score: adminScore });
	
	      // Included both score (for immediate display) and adminScore (for the API Patch)
	      var updateData = {
	        score: adminScore,
	        ratio: adminRatio,
	        admin_score: adminScore,
	        score_details: scoreDetails,
	        grader_id: this.props.graderID
	      };
	
	      this.props.onUpdate(originalEvaluation.id, updateData);
	
	      this.setState({ editingEvaluation: false });
	
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Score Edited",
	        text: "You have edited the score for this question",
	        icon: "ok-sign"
	      });
	
	      // Finds the next question in the parent component
	      this.props.nextQuestion();
	    }
	  }, {
	    key: "displayScoreCap",
	    value: function displayScoreCap() {
	      return 4;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.evaluation) {
	        var currentScore = $wr.convertedScore(this.props.evaluation.ratio, 4);
	
	        if (this.state.editedScore !== currentScore) {
	          var saveButton = React.createElement(
	            "button",
	            { className: "btn btn-link saveButton" },
	            "Save"
	          );
	        }
	
	        var editScore = React.createElement(
	          "form",
	          { onSubmit: this.saveEvaluation, className: "editRow" },
	          React.createElement(
	            "div",
	            null,
	            "Edit Score:",
	            " ",
	            React.createElement(NumbersOnlyInput, {
	              className: "form-control scoreEdit",
	              allowDecimal: true,
	              value: this.state.editedScore,
	              step: 0.5,
	              onChange: function onChange(e) {
	                return _this2.setState({ editedScore: parseFloat(e.target.value) });
	              },
	              max: this.displayScoreCap(),
	              min: 0
	            }),
	            " ",
	            "/ ",
	            this.displayScoreCap(),
	            saveButton
	          )
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { className: "editControls" },
	        editScore
	      );
	    }
	  }]);
	
	  return AnswerEvalOverride;
	}(React.Component)) || _class);
	
	
	AnswerEvalOverride.propTypes = StrictPropTypes({
	  quizEvaluation: PropTypes.object,
	  answerEvaluation: PropTypes.object,
	  evaluation: PropTypes.object,
	  nextQuestion: PropTypes.func,
	
	  //From @connect
	  onUpdate: PropTypes.func
	});
	
	module.exports = AnswerEvalOverride;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = __webpack_require__(16);
	
	var WritingSelectors = __webpack_require__(14);
	var MultiPartAnswerDisplay = __webpack_require__(172);
	var StudentDisplay = __webpack_require__(52);
	
	var ReactTooltip = __webpack_require__(12);
	
	var RosterSelectors = __webpack_require__(6);
	
	__webpack_require__(657);
	
	var AnswerReview = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var answer = WritingSelectors.answer({ state: state, id: props.answerID });
	  var passProps = {
	    answer: answer
	  };
	
	  if (answer) {
	    passProps.question = WritingSelectors.question({ state: state, id: answer.question_id });
	    var student = RosterSelectors.student({ state: state, id: answer.user_id });
	
	    passProps.quizEvaluation = WritingSelectors.evaluationForSubject({
	      state: state,
	      subjectType: "Quiz",
	      subjectID: answer.quiz_id
	    });
	
	    passProps.answerEvaluation = WritingSelectors.evaluationForSubject({
	      state: state,
	      subjectType: "Answer",
	      subjectID: answer.id
	    });
	
	    if (answer.evaluation) {
	      var evaluation = WritingSelectors.evaluation({ state: state, id: answer.evaluation });
	      if (evaluation) {
	        passProps.evaluation = evaluation;
	      }
	    }
	  }
	
	  if (student) {
	    passProps.studentReadingLevel = student.current_reading_level;
	  }
	
	  passProps.blockComments = !Features.isEnabled(Features.TEACHER_COMMENTS);
	  return passProps;
	}, function (dispatch, props) {
	  return {};
	}), _dec(_class = function (_React$Component) {
	  _inherits(AnswerReview, _React$Component);
	
	  function AnswerReview(props) {
	    _classCallCheck(this, AnswerReview);
	
	    var _this = _possibleConstructorReturn(this, (AnswerReview.__proto__ || Object.getPrototypeOf(AnswerReview)).call(this));
	
	    autobind(_this);
	
	    _this.state = {
	      controlMode: null
	    };
	    return _this;
	  }
	
	  _createClass(AnswerReview, [{
	    key: "render",
	    value: function render() {
	      var answer = this.props.answer;
	
	
	      var className = "answerDisplay writingDisplay clearfix nonFITB";
	
	      var questionDisplay = React.createElement(
	        "p",
	        { className: "questionText" },
	        answer.question_text
	      );
	
	      var answerBody = React.createElement(
	        "div",
	        { className: "answerText" },
	        React.createElement(MultiPartAnswerDisplay, { parts: answer.parts, breakSections: true })
	      );
	
	      return React.createElement(
	        "div",
	        { className: className },
	        React.createElement(
	          "div",
	          { className: "innerWrap" },
	          React.createElement(
	            "div",
	            { className: "innerAnswer" },
	            questionDisplay,
	            answerBody
	          )
	        )
	      );
	    }
	  }]);
	
	  return AnswerReview;
	}(React.Component)) || _class);
	
	
	AnswerReview.defaultProps = {
	  enabled: {}
	};
	
	AnswerReview.WrappedComponent.propTypes = StrictPropTypes({
	  // ID of the answer to be displayed
	  answerID: PropTypes.number.isRequired,
	
	  // From @connect
	  // Which are present is determined by the other props
	  answer: PropTypes.object.isRequired,
	  question: PropTypes.object,
	  enabled: PropTypes.object,
	  quizEvaluation: PropTypes.object,
	  answerEvaluation: PropTypes.object,
	  evaluation: PropTypes.object,
	  studentReadingLevel: PropTypes.number,
	  blockComments: PropTypes.bool
	});
	
	module.exports = AnswerReview;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionFeedback = __webpack_require__(101);
	var ScoringData = __webpack_require__(961);
	var RubricItemOverride = __webpack_require__(430);
	var TextAreaMarkups = __webpack_require__(196);
	var MultiPartAnswerDisplay = __webpack_require__(172);
	
	var Spinner = __webpack_require__(9);
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	
	var AutograderDisplayConfig = __webpack_require__(83);
	
	__webpack_require__(3831);
	
	var AnswerScoringDetails = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {
			evaluation: WritingSelectors.evaluation({ state: state, id: props.answer.evaluation })
		};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(AnswerScoringDetails, _React$Component);
	
		function AnswerScoringDetails(props) {
			_classCallCheck(this, AnswerScoringDetails);
	
			var _this = _possibleConstructorReturn(this, (AnswerScoringDetails.__proto__ || Object.getPrototypeOf(AnswerScoringDetails)).call(this));
	
			autobind(_this);
	
			_this.state = {
				markupKey: null
			};
			return _this;
		}
	
		_createClass(AnswerScoringDetails, [{
			key: "onModeChange",
			value: function onModeChange(controlMode) {
				if (this.props.onModeChange) {
					this.props.onModeChange(controlMode);
				}
			}
		}, {
			key: "answerDetails",
			value: function answerDetails() {
				if (this.props.answer && this.props.evaluation) {
					return this.props.evaluation.autograder_data;
				}
			}
		}, {
			key: "selectMarkup",
			value: function selectMarkup(markupKey) {
				this.setState({ markupKey: markupKey });
			}
		}, {
			key: "currentMarkupKey",
			value: function currentMarkupKey() {
				if (this.state.markupKey) {
					return this.state.markupKey;
				}
	
				var leaves = this.leaves();
				if (leaves) {
					return _.keys(leaves)[0];
				}
			}
		}, {
			key: "leaves",
			value: function leaves() {
				var answerDetails = this.answerDetails();
				if (answerDetails) {
					return AutograderDisplayConfig.getRubricLeaves(answerDetails.polarizing, false);
				}
			}
		}, {
			key: "activeTagging",
			value: function activeTagging() {
				var leaves = this.leaves();
				var markupKey = this.currentMarkupKey();
	
				if (leaves && leaves[markupKey]) {
					var activeTags = {};
					_.each(leaves[markupKey].tags, function (tag) {
						if (activeTags[tag.key] == undefined) {
							activeTags[tag.key] = [];
						}
						activeTags[tag.key].push(tag);
					});
	
					_.each(activeTags, function (tags, key) {
						if (!AutograderDisplayConfig.isDisplayTag(key)) {
							delete activeTags[key];
						}
					});
	
					_.each(activeTags, function (tags, key) {
						if (AutograderDisplayConfig.shouldGroupTagSpans(key)) {
							_.each(tags, function (tag, t) {
								activeTags[key][t].spans = AutograderDisplayConfig.groupTagSpans(tag);
							});
						}
					});
	
					return activeTags;
				} else {
					return {};
				}
			}
		}, {
			key: "renderScoringData",
			value: function renderScoringData() {
				var answerDetails = this.answerDetails();
				var scoringDetails = _.pick(answerDetails, "filtering", "warning", "evaluating");
				var activeTagging = this.activeTagging();
				var tagColors = pickTagColors(activeTagging);
	
				if (this.props.editMode) {
					var scoringData = React.createElement(RubricItemOverride, { leaves: this.leaves(), evaluation: this.props.evaluation });
				} else {
					var scoringData = React.createElement(ScoringData, _extends({ onModeChange: this.onModeChange, markupKey: this.currentMarkupKey(),
						tagging: activeTagging, leaves: this.leaves(), tagColors: tagColors,
						selectMarkup: this.selectMarkup }, scoringDetails));
				}
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "answerText" },
						React.createElement(TextAreaMarkups, { text: answerDetails.corrected_answer,
							tagging: activeTagging, tagColors: tagColors })
					),
					scoringData
				);
			}
		}, {
			key: "render",
			value: function render() {
				var originalAnswer = this.props.answer;
				var answerDetails = this.answerDetails();
				if (!originalAnswer) {
					var displayContent = React.createElement(Spinner, { placeholder: true });
				} else if (!answerDetails) {
					if (originalAnswer.body != undefined) {
						var answerText = originalAnswer.body;
					} else {
						var answerText = React.createElement(MultiPartAnswerDisplay, { parts: originalAnswer.parts, breakSections: true });
					}
					if ("evaluation_details" in this.props.answer) {
						var status = React.createElement(
							"p",
							{ className: "text-center" },
							"Scoring details are unvailable for this answer."
						);
					} else {
						var status = React.createElement(Spinner, { placeholder: true });
					}
					var displayContent = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "answerText" },
							answerText
						),
						status
					);
				} else if (!answerDetails.corrected_answer) {
					var displayContent = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							{ className: "answerText" },
							originalAnswer.body
						),
						React.createElement(
							"i",
							null,
							"Our scoring algorithm has changed since this answer was scored. Please contact",
							" ",
							React.createElement(
								"a",
								{ href: "mailto:support@whooosreading.org" },
								"support@whooosreading.org"
							),
							" ",
							"if you would like us to re-score this answer."
						)
					);
				} else {
					var displayContent = this.renderScoringData(answerDetails);
				}
	
				return React.createElement(
					"div",
					{ className: "answerScoringDetails" },
					displayContent
				);
			}
		}]);
	
		return AnswerScoringDetails;
	}(React.Component)) || _class);
	
	
	function pickTagColors(tagging) {
		var tagToColors = {};
		_.each(_.sortBy(_.keys(tagging)), function (key, index) {
			var hasSpans = _.any(tagging[key], function (tag) {
				return "spans" in tag;
			});
			if (hasSpans) {
				tagToColors[key] = AUTOGRADER_COLOR_LIST[index % AUTOGRADER_COLOR_LIST.length];
			}
		});
	
		return tagToColors;
	}
	
	var AUTOGRADER_COLOR_LIST = ["#96dafe", "#a0e881", "#ffcbb3", "#cfadec", "#f2de7f", "#c8ecff", "#c0f2aa", "#faaf88", "#fff864"];
	
	AnswerScoringDetails.WrappedComponent.propTypes = StrictPropTypes({
	
		// Inserted by @connect
		evaluation: PropTypes.object,
	
		answer: PropTypes.object,
		editMode: PropTypes.bool,
		onModeChange: PropTypes.func
	
	});
	
	module.exports = AnswerScoringDetails;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsetBanner = __webpack_require__(252);
	var AnswerWritingInterface = __webpack_require__(426);
	var BookRating = __webpack_require__(192);
	var BookTextVariety = __webpack_require__(141);
	
	var Skillsets = __webpack_require__(55);
	var CurrentUser = __webpack_require__(3);
	var Spinner = __webpack_require__(9);
	var Autosaver = __webpack_require__(198);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var StudentOnboardingModal = __webpack_require__(195);
	
	var MyShelfRouting = __webpack_require__(74);
	var ZPDRange = __webpack_require__(176);
	
	__webpack_require__(3834);
	
	var NewAnswerPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var textID = $wr.getURLParameterByName("text_id");
		var answerID = $wr.getURLParameterByName("answer_id");
		var isReview = props.location.pathname == "/reviews/new";
	
		var book = ReadingSelectors.book({ state: state, id: textID });
	
		var downProps = { book: book };
	
		if (!(WritingSelectors.isLoadingQuestions({ state: state }) || WritingSelectors.isLoadingRatings({ state: state, key: "index" }) || WritingSelectors.isLoadingAnswers({ state: state, key: "index" }) || WritingSelectors.isLoadingAnswers({ state: state, key: "create" }))) {
	
			if (answerID) {
				var answer = WritingSelectors.answer({
					state: state, id: answerID
				});
			} else if (isReview) {
				var answer = WritingSelectors.reviews({
					state: state, filters: { text_id: textID }
				}).filter(function (x) {
					return x.draft || x.allow_revision;
				})[0];
			} else {
				var answer = WritingSelectors.nonQuizAnswers({
					state: state, filters: { text_id: textID }
				}).filter(function (x) {
					return x.draft || x.allow_revision;
				})[0];
			}
	
			if (answer) {
				downProps.draftAnswer = answer;
				downProps.question = WritingSelectors.question({ state: state, id: answer.question_id });
				downProps.draftRating = WritingSelectors.ratings({
					state: state, filters: { text_id: textID }
				})[0];
			} else if (!isReview) {
				if (downProps.book && downProps.book.text_variety) {
					downProps.questionOptions = WritingSelectors.mostRecentQuestions({
						state: state, count: QUESTION_OPTION_COUNT
					});
				}
			}
		}
	
		if (!CurrentUser.get().prefs.automatic_zpd_exclusion) {
			downProps.shouldExclude = false;
		} else if (!book) {
			downProps.shouldExclude = false;
		} else if (!book.lexile_score) {
			downProps.shouldExclude = true;
		} else {
			var zpdStatus = ZPDRange.getTextStatus(book.lexile_score, CurrentUser.get().current_reading_level);
	
			downProps.shouldExclude = zpdStatus == ZPDRange.UNDER;
		}
	
		return downProps;
	}, function (dispatch, props) {
		var userID = CurrentUser.get().id;
		var textID = $wr.getURLParameterByName("text_id");
		var isReview = props.location.pathname == "/reviews/new";
	
		// PopulateData Step A: Fetch the book so we can show the title and know the text variety
		function fetchBook() {
			dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then(function (response) {
				var book = _.first(response.books);
				if (book) {
					fetchDraft(book.text_variety);
				} else {
					console.log("No book matching text ID found.");
				}
			});
		}
	
		// PopulateData Step B: Check to see if there is a draft answer or review
		function fetchDraft(textVariety) {
			if (isReview) {
				dispatch(WritingActions.fetchReviews({
					conditions: { textID: textID, draftOnly: true },
					embeds: ["answer.question", "answer.meta_data", "answer.history"]
				})).then(function (response) {
					if (_.isEmpty(response.answers) && textVariety) {
						fetchReviewQuestion(textVariety, null, true);
					}
				});
				dispatch(WritingActions.fetchRatings({ conditions: { textID: textID } }));
			} else {
				dispatch(WritingActions.fetchNonQuizAnswers({
					conditions: { textID: textID, draftOnly: true },
					embeds: ["answer.question", "answer.meta_data", "answer.history"]
				})).then(function (response) {
					if (_.isEmpty(response.answers) && textVariety) {
						fetchAnswerQuestions(textVariety);
					}
				});
			}
		}
	
		// PopulateData Step C: If there wasn't a draft answer or review, fetch question options
		// 					 C.1: If this is review, we also need to create the answer record
		function fetchAnswerQuestions(textVariety) {
			var conditions = {
				textID: textID, sample: QUESTION_OPTION_COUNT
			};
	
			var filters = {
				allow_global_linked: true,
				allow_generic: true,
				types: "generic-question,text-specific-question",
				text_varieties: textVariety,
				apply_scope: true
			};
	
			if (CurrentUser.get().prefs.prefer_teacher_practice_questions) {
				filters["prefer_user_id"] = true;
			}
	
			return dispatch(WritingActions.fetchQuestions({ filters: filters, conditions: conditions }));
		}
		function fetchReviewQuestion(textVariety, excludeID, buildAnswer) {
			var conditions = { sample: 1 };
	
			var filters = {
				allow_global_linked: true,
				allow_generic: true,
				types: REVIEW_QUESTION,
				text_varieties: textVariety,
				apply_scope: true
			};
	
			if (excludeID) {
				filters["exclude_ids"] = excludeID;
			}
	
			return dispatch(WritingActions.fetchQuestions({ filters: filters, conditions: conditions })).then(function (response) {
				// We need to create the new answer record for this review for the question
				if (buildAnswer) {
					var questionID = response.questions[0].id;
					if (!questionID) {
						console.error("No review question found");return;
					}
					return createNewAnswer(questionID, textVariety, REVIEW_ANSWER);
				} else {
					return response;
				}
			});
		}
	
		function createNewAnswer(questionID, textVariety, answerType) {
			var answerData = {
				text_id: textID, draft: true,
				text_variety: textVariety, question_id: questionID,
				answer_type: answerType
			};
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.createAnswer({ answer: answerData }));
		}
	
		return {
			populateData: fetchBook,
			changeQuestion: isReview ? fetchReviewQuestion : fetchAnswerQuestions,
			createAnswer: createNewAnswer,
			fetchReviewQuestion: fetchReviewQuestion,
			fetchAnswerQuestions: fetchAnswerQuestions,
	
			deleteAnswer: function deleteAnswer(answerID) {
				var update = { "activity:any:any": null };
				dispatch(ReadingActions.localUpdateBook({ id: textID, update: update }));
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.deleteAnswer({ id: answerID }));
			},
	
			updateAnswer: function updateAnswer(answerID, answerData) {
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.updateAnswer({ id: answerID, update: answerData }));
			},
	
			createRating: function createRating(ratingData) {
				return dispatch(WritingActions.createRating({ rating: ratingData }));
			},
	
			updateRating: function updateRating(ratingID, ratingData) {
				return dispatch(WritingActions.updateRating({ id: ratingID, update: ratingData }));
			}
	
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(NewAnswerPage, _React$Component);
	
		function NewAnswerPage(props) {
			_classCallCheck(this, NewAnswerPage);
	
			var _this = _possibleConstructorReturn(this, (NewAnswerPage.__proto__ || Object.getPrototypeOf(NewAnswerPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("NewAnswerPage");
			_this.state = _this.initialStateData();
			return _this;
		}
	
		_createClass(NewAnswerPage, [{
			key: "initialStateData",
			value: function initialStateData() {
				return {
					autosaveLoading: false, questionChanged: false,
					loading: false, showConfirmDelete: false,
	
					// Answers only
					selectedQuestionID: null,
	
					// Reviews only
					tempRatingValue: null
				};
			}
		}, {
			key: "selectQuestions",
			value: function selectQuestions() {
				var book = this.props.book;
				var isReview = this.props.location.pathname == "/reviews/new";
				if (isReview) {
					if (_.isEmpty(book.answers) && book.text_variety) {
						this.props.fetchReviewQuestion(book.text_variety, null, true);
					}
				} else {
					if (_.isEmpty(book.answers) && book.text_variety) {
						this.props.fetchAnswerQuestions(book.text_variety);
					}
				}
			}
		}, {
			key: "textID",
			value: function textID() {
				if (this.props.book) {
					return this.props.book.text_id;
				} else {
					return $wr.getURLParameterByName("text_id");
				}
			}
		}, {
			key: "textVariety",
			value: function textVariety() {
				var textVariety = this.props.book.text_variety;
				if (!textVariety) {
					textVariety = "fiction";
				}
				return textVariety;
			}
		}, {
			key: "isReview",
			value: function isReview() {
				return this.props.location.pathname == "/reviews/new";
			}
		}, {
			key: "onQuestionSelect",
			value: function onQuestionSelect(question, e) {
				this.buildNewAnswer(question.id);
			}
		}, {
			key: "answerType",
			value: function answerType() {
				if (this.props.question && this.props.question.type === REVIEW_QUESTION) {
					return REVIEW_ANSWER;
				} else {
					return PRACTICE_QUESTION_ANSWER;
				}
			}
		}, {
			key: "buildNewAnswer",
			value: function buildNewAnswer(questionID) {
				this.props.createAnswer(questionID, this.textVariety(), this.answerType());
			}
		}, {
			key: "onAnswerComplete",
			value: function onAnswerComplete() {
				var _this2 = this;
	
				this.setState({ loading: true }, function () {
					_this2.saveAnswer(false).then(function () {
						LuckyOrangeClient.tagComponent("completed_answer");
						var awardText = _this2.isReview() ? "Great job on that review!" : "Great job on that answer!";
						var completedTask = _this2.isReview() ? "reviews" : "answers";
	
						_this2.setState({ autosaveLoading: false });
						window.wrNotifications.triggerDropDownNotification({
							title: "Done!", text: awardText, icon: "star" });
						CurrentUser.fetchCurrentUserCoinData();
	
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: completedTask,
							textID: _this2.props.book.text_id
						}));
					});
				});
			}
		}, {
			key: "autosaveDraft",
			value: function autosaveDraft(callback) {
				var _this3 = this;
	
				this.setState({ autosaveLoading: true }, function () {
					_this3.saveAnswer(_this3.props.draftAnswer.draft).then(function () {
						_this3.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					}).catch(function () {
						// Error Handling... allow future autosaving even if this one failed
						_this3.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					});
				});
			}
		}, {
			key: "saveAnswer",
			value: function saveAnswer(draftStatus) {
				var answer = this.props.draftAnswer;
	
				if (answer.sessionMetaData) {
					if (_.isEmpty(answer.meta_data)) {
						// First time saving the answer; Make a new meta data array
						var metaData = [answer.sessionMetaData];
					} else {
						var metaData = _.clone(answer.meta_data);
						if (_.last(metaData).session_start != answer.sessionMetaData.session_start) {
							// First time saving the answer this session, but was loaded from draft
							// Push new meta data onto the array
							metaData.push(answer.sessionMetaData);
						} else {
							// Update this session's meta data
							metaData[metaData.length - 1] = answer.sessionMetaData;
						}
					}
				}
	
				var answerData = {
					draft: draftStatus,
					parts: answer.localParts || answer.parts,
					meta_data: metaData,
					history: answer.history
				};
	
				if (!answer.allow_revision) {
					answerData.excluded = this.props.shouldExclude;
				}
	
				if (!draftStatus) {
					answerData.autograder_data = answer.recentAutograderData;
					answerData.allow_revision = false;
				}
	
				if (this.props.questionChanged) {
					answerData.question_id = this.props.question.id;
				}
	
				return this.props.updateAnswer(answer.id, answerData);
			}
		}, {
			key: "getAutosaveHash",
			value: function getAutosaveHash() {
				var answer = this.props.draftAnswer;
	
				if (answer) {
					var hashString = _.pluck(answer.localParts, "text").join("|");
					hashString += "|" + this.props.question.body;
					hashString += "|" + JSON.stringify(answer.sessionMetaData);
					hashString += "|" + JSON.stringify(answer.recentAutograderData);
	
					var hashValue = $wr.hashCode(hashString);
	
					return hashValue;
				}
			}
		}, {
			key: "showConfirmDelete",
			value: function showConfirmDelete() {
				if (confirm("If you delete this you will lose your work below. Are you sure?")) {
					this.deleteDraft(NewAnswerPage.BACKTOQUESTIONS);
				}
			}
		}, {
			key: "deleteDraft",
			value: function deleteDraft(changeQuestion) {
				var _this4 = this;
	
				this.setState({ loading: true });
				this.props.deleteAnswer(this.props.draftAnswer.id).then(function () {
					_this4.setState({ loading: false });
					window.wrNotifications.triggerDropDownNotification({
						title: "Your work has been deleted!", text: "", icon: "trash" });
	
					if (changeQuestion == NewAnswerPage.BACKTOQUESTIONS) {
						_this4.setState(_this4.initialStateData(), _this4.componentDidMount);
					} else {
						$wr.redirect("/");
					}
				});
			}
		}, {
			key: "onRatingChange",
			value: function onRatingChange(newValue) {
				if (this.props.draftRating) {
					this.props.updateRating(this.props.draftRating.id, { value: newValue });
				} else if (!this.state.tempRatingValue) {
					// Prevents creating two
					this.setState({ tempRatingValue: newValue });
	
					this.props.createRating({
						value: newValue,
						value_cap: BookRating.DEFAULT_MAX_RATING,
						text_id: this.textID()
					});
				}
			}
		}, {
			key: "changeQuestions",
			value: function changeQuestions(e) {
				$wr.nope(e);
				this.props.changeQuestion(this.textVariety());
			}
		}, {
			key: "changeReviewQuestion",
			value: function changeReviewQuestion() {
				var _this5 = this;
	
				this.props.changeQuestion(this.textVariety(), this.props.question.id).then(function (response) {
					var newQuestion = response.questions[0];
					if (!newQuestion) {
						console.error("No more review questions!");return;
					}
	
					_this5.props.updateAnswer(_this5.props.draftAnswer.id, {
						question_id: newQuestion.id, parts: null, localParts: null,
						meta_data: null, sessionMetaData: null, recentAutograderData: null
					});
				});
			}
		}, {
			key: "renderChooseQuestion",
			value: function renderChooseQuestion() {
				var _this6 = this;
	
				var title = "Choose Your Question";
	
				var skillsetPreviews = _.map(this.props.questionOptions, function (question) {
					return React.createElement(SkillsetBanner, { skillset: question.skillset, key: question.id,
						textVariety: _this6.textVariety(),
						text: question.body, small: true,
						onClick: _this6.onQuestionSelect.bind(_this6, question) });
				});
	
				var changeQuestionsLink = React.createElement(
					"p",
					{ className: "changeQuestionsContainer" },
					React.createElement(
						"a",
						{ href: "#", className: "changeQuestionsLink",
							onClick: this.changeQuestions },
						"Change Questions"
					)
				);
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							title
						)
					),
					React.createElement(
						"h3",
						{ className: "textTitle onQuestionSelect" },
						this.props.book.title
					),
					changeQuestionsLink,
					React.createElement(
						"div",
						{ className: "skillsetOptions" },
						skillsetPreviews
					)
				);
			}
		}, {
			key: "renderWriteAnswer",
			value: function renderWriteAnswer() {
				var skillset = this.isReview() ? "review" : this.props.question.skillset;
	
				if (this.isReview()) {
					if (this.props.draftRating) {
						var ratingValue = this.props.draftRating.value;
					} else {
						ratingValue = this.state.tempRatingValue;
					}
					var bookRating = React.createElement(
						"div",
						{ className: "reviewRating" },
						"How many stars would you give the book?",
						" ",
						React.createElement(BookRating, { editable: true, currentRating: ratingValue,
							onChange: this.onRatingChange })
					);
					if (!this.state.loading) {
						var changeQuestionF = this.changeReviewQuestion;
					}
				} else {
					var backtoQuestionsContent = React.createElement(
						"a",
						{ href: "#", key: "confirm", onClick: this.showConfirmDelete },
						"Back to Questions"
					);
				}
	
				return React.createElement(
					"div",
					null,
					React.createElement(SkillsetBanner, { skillset: skillset, textVariety: this.textVariety() }),
					React.createElement(
						"div",
						{ className: "backToQuestionsContainer" },
						backtoQuestionsContent
					),
					React.createElement(
						"h3",
						{ className: "textTitle" },
						this.props.book.title
					),
					React.createElement(Autosaver, { onDeleteClick: this.deleteDraft, textID: this.textID(),
						autosaveLoading: this.state.loading || this.state.autosaveLoading,
						getAutosaveHash: this.getAutosaveHash, onAutosave: this.autosaveDraft }),
					React.createElement(AnswerWritingInterface, { topOuterChild: bookRating,
						loading: this.state.loading,
						answerID: this.props.draftAnswer.id,
						onComplete: this.onAnswerComplete,
						onQuestionChange: changeQuestionF,
						questionIndex: "solo" })
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.loading || !this.props.book) {
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (!this.props.book.text_variety) {
					var pageContent = React.createElement(
						"div",
						{ className: "textVariety" },
						React.createElement(
							"header",
							{ className: "pageHeader" },
							React.createElement(
								"h1",
								null,
								"Select a Book Type"
							)
						),
						React.createElement(
							"h3",
							{ className: "textTitle" },
							this.props.book.title
						),
						React.createElement(BookTextVariety, { book: this.props.book, onSelect: this.selectQuestions })
					);
				} else if (this.props.question && this.props.draftAnswer) {
					var pageContent = this.renderWriteAnswer();
				} else if (this.props.questionOptions) {
					var pageContent = this.renderChooseQuestion();
				} else {
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				var triggerOnboarding = $wr.getURLParameterByName("first") == "true";
				if (triggerOnboarding) {
					var redirectPath = this.props.location.pathname + "?text_id=" + this.textID();
					var studentOnboardingModal = React.createElement(StudentOnboardingModal, { writingTriggered: true,
						redirectPath: redirectPath });
				}
	
				return React.createElement(
					"div",
					{ className: "container newAnswerPage" },
					pageContent,
					studentOnboardingModal
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.textID() != undefined) {
					this.props.populateData();
				}
			}
		}]);
	
		return NewAnswerPage;
	}(React.Component)) || _class);
	;
	
	var REVIEW_QUESTION = 'review-question';
	var REVIEW_ANSWER = 'review-answer';
	var PRACTICE_QUESTION_ANSWER = 'practice-question-answer';
	
	NewAnswerPage.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from @connect
		book: PropTypes.object,
		question: PropTypes.object,
		draftRating: PropTypes.object,
		draftAnswer: PropTypes.object,
		questionOptions: PropTypes.array,
		isLoadingDraft: PropTypes.bool,
		shouldExclude: PropTypes.bool,
		onSelect: PropTypes.func,
	
		// Action hooks from @connect
		populateData: PropTypes.func.isRequired,
		changeQuestion: PropTypes.func,
		createAnswer: PropTypes.func,
		deleteAnswer: PropTypes.func,
		updateAnswer: PropTypes.func,
		createRating: PropTypes.func,
		updateRating: PropTypes.func,
		fetchReviewQuestion: PropTypes.func,
		fetchAnswerQuestions: PropTypes.func
	
	});
	
	NewAnswerPage.BACKTOQUESTIONS = "backToQuestions";
	
	var QUESTION_OPTION_COUNT = 4;
	
	module.exports = NewAnswerPage;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OwlfonsoContainer = __webpack_require__(421);
	var Spinner = __webpack_require__(9);
	var StudentAvatar = __webpack_require__(35);
	var CurrentUser = __webpack_require__(3);
	var StepProgressMeter = __webpack_require__(249);
	var LoadingButton = __webpack_require__(17);
	
	var AutograderFeedback = __webpack_require__(258);
	var BookRating = __webpack_require__(192);
	var QuestionFeedback = __webpack_require__(173);
	var FeedbackFormatter = __webpack_require__(73);
	var Spinner = __webpack_require__(9);
	var Autosaver = __webpack_require__(198);
	//for connecting////////////
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	///////////////////////////////
	var MyShelfRouting = __webpack_require__(74);
	__webpack_require__(3835);
	
	function getPartIndexes(parts, part_type) {
		var targetIndex = -1;
		_.some(parts, function (part, i) {
			if (part["type"] == part_type) {
				targetIndex = i;
				return true;
			}
		});
		return targetIndex;
	}
	
	var QuestionBuilderPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var textID = $wr.getURLParameterByName("text_id");
		var answerID = $wr.getURLParameterByName("answer_id");
		var userID = CurrentUser.get().id;
	
		var book = ReadingSelectors.book({ state: state, id: textID });
	
		var downProps = { book: book };
	
		if (!(WritingSelectors.isLoadingQuestions({ state: state }) || WritingSelectors.isLoadingAnswers({ state: state, key: "index" }) || WritingSelectors.isLoadingAnswers({ state: state, key: "create" }))) {
	
			if (downProps.book) {
				var conditions = {
					textID: textID
				};
	
				downProps.metaQuestion = WritingSelectors.mostRecentQuestions({
					state: state,
					filters: {
						type: "meta-cognitive-question",
						key: "fill-in-the-blank"
					}
				});
				if (answerID) {
					downProps.questionBuilder = WritingSelectors.answer({
						state: state, id: answerID
					});
				} else if (downProps.metaQuestion) {
					downProps.questionBuilder = WritingSelectors.answers({
						state: state,
						filters: {
							text_id: textID,
							question_id: downProps.metaQuestion.id
						}
					}).filter(function (x) {
						return x.draft || x.allow_revision;
					})[0];
				}
			}
		}
		downProps.currentStage = SENTENCE_INPUT_STAGE;
		return downProps;
	}, function (dispatch, props) {
		var userID = CurrentUser.get().id;
		var textID = $wr.getURLParameterByName("text_id");
	
		function fetchBook() {
	
			return dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then(function (response) {
				var book = _.first(response.books);
				if (book) {
					fetchMetaCognitiveQuestion();
				} else {
					console.log("No book matching text ID found.");
				}
			});
		}
	
		function fetchDraft(questionID) {
			dispatch(WritingActions.fetchAnswers({
				filters: {
					question_id: questionID
				},
				conditions: {
					textID: textID,
					draftOnly: true
				},
				embeds: ["answer.question", "answer.meta_data", "answer.history"]
			})).then(function (response) {
				if (_.isEmpty(response.answers)) {
					createMetaCognitiveAnswer(questionID);
				}
			});
		}
	
		function fetchMetaCognitiveQuestion() {
			var filters = {
				types: "meta-cognitive-question",
				key: "fill-in-the-blank"
			};
			dispatch(WritingActions.fetchQuestions({ filters: filters })).then(function (response) {
				var question = _.first(response.questions);
				if (question) {
					fetchDraft(question.id);
				} else {
					console.log("No question found!");
				}
			});
		}
	
		function createMetaCognitiveAnswer(questionID) {
			var answerData = {
				draft: true, text_id: textID,
				question_id: questionID
			};
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.createAnswer({ answer: answerData }));
		}
	
		function updateMetaCognitiveAnswer(answerID, answerData) {
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.updateAnswer({
				id: answerID,
				update: answerData
			}));
		}
	
		function deleteMetaCognitiveAnswer(answerID) {
			var update = { "activity:any:any": null };
			dispatch(ReadingActions.localUpdateBook({ id: textID, update: update }));
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.deleteAnswer({ id: answerID }));
		}
	
		return {
			populateData: fetchBook,
			fetchMetaCognitiveQuestion: fetchMetaCognitiveQuestion,
			createMetaCognitiveAnswer: createMetaCognitiveAnswer,
			updateMetaCognitiveAnswer: updateMetaCognitiveAnswer,
			deleteMetaCognitiveAnswer: deleteMetaCognitiveAnswer
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)({ waitForLoad: true }), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(QuestionBuilderPage, _React$Component);
	
		function QuestionBuilderPage(props) {
			_classCallCheck(this, QuestionBuilderPage);
	
			var _this = _possibleConstructorReturn(this, (QuestionBuilderPage.__proto__ || Object.getPrototypeOf(QuestionBuilderPage)).call(this));
	
			autobind(_this);
			//don't understand this part in NWP need replicate for new component?
			LuckyOrangeClient.tagComponent("QuestionBuilderPage");
	
			// INIT SELECTD BLANKS
			_this.state = {
				//Klim fitb pages iteration
				currentStage: props.currentStage,
				loading: false,
				//Owlfonso show
				feedbackShow: false, /// what is this
				//question Builder answer data button index holders for button highlighting display in step 2
				selectedBlanks: {},
				synonyms: {},
				//autograder
				recentAutograderData: null,
				//end
				finish: false, /// what is this
				unsavedSynonyms: false /// tracks if user didn't add a synonym
			};
			return _this;
		}
	
		/****************************** PAGE TEXT ******************************************/
	
		//Error Handling
	
	
		_createClass(QuestionBuilderPage, [{
			key: "errorText",
			value: function errorText(errorID) {
				var errorArray = {
					"questionShort": "In order for me to help you write the very best answer you can, I will need you to write a bit more first. Click 'Check again!' when you are ready",
					"noQuestion": "Please write at least a short response to this question.",
					"answerShort": "In order for me to help you write the very best answer you can, I will need you to write a bit more first. Click 'add' again when you are ready",
					"answerLong": "In order for me to help you write the very best answer you can, I will need you to write a maximum of three words. Click 'add' again when you are ready",
					"consecutiveWords": "Words must be next to each other to form one blank.",
					"threeWordLimit": "Please choose up to 3 words for your blank.",
					"repeatingAnswer": "Please make sure the answer you have written isn't the same as a previous answer."
				};
				return errorArray[errorID];
			}
			//Page text
	
		}, {
			key: "pageText",
			value: function pageText(pageTextID) {
				var gradeLevel = CurrentUser.get().prefs.academic_level;
				var textTitle = this.props.book.title;
				if (gradeLevel > 3) {
					var owlMessage = "Write a complete sentence about a detail or event in " + textTitle + ". Your sentence should be a statement, not a question, and should include a text detail you learned while reading the text.";
				} else {
					var owlMessage = "Write a sentence about " + textTitle + ". Your sentence should be about something you learned while reading the book.";
				}
				var pageTextArray = {
					"textSelectBlank": "Select a word or phrase (up to three words) to be blanked out and become the answer. Be sure to choose a blank that someone who read the book would know, but someone who did not read the book could not easily guess.\n\n*Example:*\nThe Once-ler cut down a ____ tree and used it to knit a Thneed.",
					"initialText": owlMessage,
					"addSynonymsMessage": "Sometimes blanks can have more than one right answer. Read your sentence again and think about other words that would also be correct answers for your blank.",
					"submitQuestionBuilder": "You have provided 3 answer options, submit your Question Builder to recieve your coins!",
					"submitPopUp": "You have completed your Question Builder!",
					"selectBlankPopUp": "You have chosen where the blank belongs.",
					"sentenceWritePopUp": "You wrote a sentence. That's step one!"
				};
				return pageTextArray[pageTextID];
			}
	
			/****************************** OWLFONSO FEEDBACK ***************************************/
	
			// Check to see if a particular filter was detected.
	
		}, {
			key: "hasFilter",
			value: function hasFilter(filter, autograderData) {
				if (autograderData && autograderData.filtering) {
					var filters = _.keys(autograderData.filtering);
					return filters.includes(filter);
				} else {
					return false;
				}
			}
		}, {
			key: "isLoading",
			value: function isLoading() {
				return this.props.loading || this.state.feedbackLoading;
			}
		}, {
			key: "currentAutograderData",
			value: function currentAutograderData() {
				return this.state.recentAutograderData;
			}
		}, {
			key: "showFeedback",
			value: function showFeedback() {
				return _.any(this.feedbackItems()) && !this.isLoading();
			}
		}, {
			key: "feedbackSubs",
			value: function feedbackSubs() {
				var autograderData = this.currentAutograderData();
				if (autograderData && autograderData.feedback_subs) {
					return autograderData.feedback_subs;
				}
			}
		}, {
			key: "feedbackItems",
			value: function feedbackItems() {
				var autograderData = this.currentAutograderData();
				if (autograderData && autograderData.assisting) {
					var firstElegibleKeys = _.keys(autograderData.assisting.selected_content);
					if (firstElegibleKeys.length > 0) {
						var selectedKey = firstElegibleKeys.sort()[0];
						return autograderData.assisting.selected_content[selectedKey].content || autograderData.assisting.selected_content[selectedKey];
					}
					return null;
				}
			}
		}, {
			key: "shouldRewardShow",
			value: function shouldRewardShow() {
				return false;
				var autograderData = this.currentAutograderData();
	
				if (!autograderData) {
					return false;
				}
	
				// Check if answer is too short
				if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
					return false;
				}
	
				// Check if max amount of reward hasn't been exceeded
				var checkString = "addressed-feedback-" + this.props.questionIndex;
				var count = this.props.coinHistory.reduce(function (n, val) {
					return n + (val === checkString);
				}, 0);
	
				return count < 2;
			}
		}, {
			key: "renderFeedback",
			value: function renderFeedback() {
				if (this.showFeedback()) {
					var subs = this.feedbackSubs();
					if (typeof this.feedbackItems() === "string") {
						var feedbackItemsArr = [this.feedbackItems()];
					} else if (Array.isArray(this.feedbackItems())) {
						var feedbackItemsArr = this.feedbackItems();
					} else {
						var feedbackItemsArr = [];
					}
					var renderedItems = _.map(feedbackItemsArr, function (item) {
						return FeedbackFormatter.format(item, subs);
					});
					return React.createElement(QuestionFeedback, { feedbackItems: renderedItems,
						showFeedbackReward: this.shouldRewardShow() });
				}
			}
	
			/******************************* questionBuilder Helpers ***********************************/
	
		}, {
			key: "getPartItemText",
			value: function getPartItemText(part_type) {
				if (this.props.questionBuilder) {
					var index = getPartIndexes(this.props.questionBuilder.parts, part_type);
					if (index > -1) {
						return this.props.questionBuilder.parts[index].text;
					}
				}
	
				return "";
			}
		}, {
			key: "areConsecutive",
			value: function areConsecutive(selectedBlanks, questionWords) {
				// BLANKS SHOULD BE CONSECUTIVE
				var consecutiveKeys = true;
				var lastIndex = null;
	
				_.each(_.keys(selectedBlanks), function (key) {
					var k = parseInt(key);
					var acceptableBeforeIndex = k - 1;
					// adjust acceptable before index if there is excluded pubncutation involved
					for (var i = acceptableBeforeIndex; i > 0; i--) {
						if (!_.include(EXCLUDED_PUNCTUATION, questionWords[i])) {
							acceptableBeforeIndex = i;
							break;
						}
					}
					// return false if last index is not the acceptable before index
					if (lastIndex != null && lastIndex != acceptableBeforeIndex) {
						consecutiveKeys = false;
						return false;
					}
	
					lastIndex = k;
				});
				return consecutiveKeys;
			}
		}, {
			key: "getQuestionBuilderAnswers",
			value: function getQuestionBuilderAnswers() {
				return _.values(this.state.synonyms);
			}
		}, {
			key: "updateQuestionParts",
			value: function updateQuestionParts(text, part_type, index) {
				var parts = this.props.questionBuilder.parts;
				if (parts == null) {
					parts = [];
				}
				var targetIndex = getPartIndexes(parts, part_type);
				if (targetIndex == -1) {
					parts.push({ text: text, type: part_type, index: index });
				} else {
					parts[targetIndex]["text"] = text;
					parts[targetIndex]["index"] = index;
				}
				return parts;
			}
		}, {
			key: "updateQuestionAnswer",
			value: function updateQuestionAnswer(text) {
				var parts = this.props.questionBuilder.parts;
				var targetIndex = getPartIndexes(parts, "answer");
	
				if (targetIndex == -1) {
					parts.push({ text: text, type: "answer" });
				} else {
					parts[targetIndex]["text"] = text;
				}
				this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, { parts: parts });
			}
		}, {
			key: "updateQuestionSynonym",
			value: function updateQuestionSynonym(body) {
				var parts = this.props.questionBuilder.parts;
			}
		}, {
			key: "updateQuestionBuilder",
			value: function updateQuestionBuilder(question, ansArr) {
				var qs = question;
				if (!ansArr[0] && question.includes("____")) {
					qs = question.replace("____", this.props.questionBuilder.parts[1].text);
				} else if (ansArr[0] && !question.includes("____")) {
					qs = question.replace(ansArr[0], "____");
				}
				var answerData = {
					parts: [{ text: qs, type: "body" }, { text: ansArr[0] ? ansArr[0] : "", type: "answer" }, { text: ansArr[1] ? ansArr[1] : "", type: "answer" }, { text: ansArr[2] ? ansArr[2] : "", type: "answer" }, { text: ansArr[3] ? ansArr[3] : "", type: "answer" }, { text: ansArr[4] ? ansArr[4] : "", type: "answer" }]
				};
				this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, answerData);
			}
	
			/************************************ STEP 1 *********************************************/
	
		}, {
			key: "handleExcludedPunctuation",
			value: function handleExcludedPunctuation(answerString, command) {
				var loopCount = 0;
				var returnString = _.clone(answerString);
				_.each(EXCLUDED_PUNCTUATION, function (punct) {
					loopCount += 1;
					if (command === 'add-spaces') {
						returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(punct, ' ' + punct) : returnString.replaceAll(punct, punct + ' ');
					} else if (command === 'remove-spaces') {
						returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(' ' + punct, punct) : returnString.replaceAll(punct + ' ', punct);
					}
				});
				if (loopCount === _.size(EXCLUDED_PUNCTUATION)) {
					return returnString;
				}
			}
		}, {
			key: "gotoBlankOut",
			value: function gotoBlankOut() {
				var question = this.refs.question.value;
	
				this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, { parts: this.getLatestParts() });
	
				// EXTRACTING SELECTED BLANKS
				var selectedBlanks = {};
				var answerIndex = getPartIndexes(this.props.questionBuilder.parts, "answer");
				if (answerIndex > -1) {
					var answerPart = this.props.questionBuilder.parts[answerIndex];
					_.each(this.handleExcludedPunctuation(answerPart.text, 'add-spaces').split(/\s+/), function (word, i) {
						selectedBlanks[parseInt(answerPart.index) + i] = word;
					});
				}
				this.setState({
					currentStage: BLANK_SELECTION_STAGE,
					loading: false,
					feedbackShow: true,
					selectedBlanks: selectedBlanks,
					recentAutograderData: {
						assisting: { selected_content: { 1: { content: [this.pageText("textSelectBlank")] } } }
					}
				});
	
				window.wrNotifications.triggerDropDownNotification({
					title: "Excellent!", text: this.pageText("sentenceWritePopUp"), icon: "star" });
			}
	
			// Asking students for a good question
	
		}, {
			key: "handleFitbButtons",
			value: function handleFitbButtons() {
				var _this2 = this;
	
				// some conditions to make sure question follows the right syntax:
				// grammar, wording, phrasing, etc.
				// print red banner if conditions arent met
				var question = this.refs.question.value;
	
				if (!question) {
					window.wrNotifications.triggerDropDownNotification({
						title: "We need a bit more!", icon: "pencil", text: this.errorText("noQuestion") });
				} else if (question.split(' ').length < 5) {
					//update database
					this.setState({
						feedbackShow: true,
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.errorText("questionShort")] } } }
						}
					});
				} else {
					this.setState({ loading: true });
					//add grade level of student
					AutograderFeedback.fetchQuestionBuilder({ answer: question, question: "", text: { title: this.props.book.title, text_variety: this.props.book.text_variety } }, function (result) {
						if (result && result.autograderData) {
							/*var addressedFeedback = this.checkAddressedFeedback(result.autograderData);
	      if (this.shouldRewardShow() && addressedFeedback) {
	      	this.rewardAddressedFeedback();
	      }*/
							// filter for eligible_feedback
							// var autograderData = { ...result.autograderData }
							// if (autograderData) {
							// 	var assistingData = { ...result.autograderData.assisting }
							// 	if (assistingData.selected_content) {
							// 		var newAssistingData = []
							// 		for (var id in assistingData.selected_content) {
							// 			if (_.include(assistingData.eligible_feedback, assistingData.selected_content[id].key)) {
							// 				newAssistingData.push(assistingData.selected_content[id].content)
							// 			}
							// 		}
							// 		newAssistingData = _.compact(newAssistingData)
							// 		autograderData.assisting = newAssistingData
							// 	}
							// }
							_this2.setState(function (state) {
								return {
									recentAutograderData: result.autograderData,
									feedbackShow: true,
									loading: false
								};
							});
							if (result.noFeedback) {
								_this2.gotoBlankOut();
							}
						}
					});
				}
			}
		}, {
			key: "renderButtonsQuestionDisplay",
			value: function renderButtonsQuestionDisplay() {
				if (!this.state.feedbackShow) {
					var submit = React.createElement(LoadingButton, {
						className: "btn buttonPrimary buttonPrimaryRight",
						text: "Next",
						onClick: this.handleFitbButtons.bind(this),
						loading: this.state.loading });
				} else {
					var submit = React.createElement(LoadingButton, {
						className: "btn buttonDefault buttonPrimaryRight submitAnyway",
						text: "Skip",
						onClick: this.gotoBlankOut.bind(this),
						loading: this.state.loading });
					var tryAgain = React.createElement(LoadingButton, {
						className: "btn buttonPrimary buttonPrimaryRight",
						text: "Check Again",
						onClick: this.handleFitbButtons.bind(this),
						loading: this.state.loading });
				}
				return React.createElement(
					"div",
					{ className: "buttonsBox" },
					tryAgain,
					submit
				);
			}
		}, {
			key: "renderQuestionDisplay",
			value: function renderQuestionDisplay() {
				//Owlfonso feedback
				if (!this.state.recentAutograderData) {
					this.setState({
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.pageText("initialText")] } } }
						}
					});
				}
				var questionText = this.getPartItemText("question");
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "questionDisplayBox slideLeft" },
						React.createElement(
							"h3",
							null,
							"Write a Sentence"
						),
						React.createElement("textarea", {
							ref: "question",
							className: "form-control",
							placeholder: "Write a sentence about your text.",
							defaultValue: questionText
						}),
						React.createElement(
							"b",
							{ className: "exampleStylingWriteSentence" },
							"Example:"
						),
						React.createElement(
							"p",
							{ className: "textStylingWriteSentence" },
							"The Once-ler cut down a Truffula tree and used it to knit a Thneed."
						),
						this.renderButtonsQuestionDisplay()
					),
					React.createElement(
						"div",
						{ className: "questionFeedbackBox" },
						this.renderFeedback()
					)
				);
			}
	
			/**************************************** STEP 2 *********************************************/
			//	Asking student to select blank
	
		}, {
			key: "goBackToWriteASentence",
			value: function goBackToWriteASentence() {
				var _this3 = this;
	
				this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, { parts: this.getLatestParts() });
				this.setState(function (state) {
					return {
						currentStage: SENTENCE_INPUT_STAGE,
						feedbackShow: false,
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [_this3.pageText("initialText")] } } }
						}
					};
				});
			}
		}, {
			key: "goNextToSubmit",
			value: function goNextToSubmit() {
				if (_.size(this.state.selectedBlanks) == 0) {
					window.wrNotifications.triggerDropDownNotification({
						type: "error",
						title: "Select Answer!",
						text: "Don't forget to press which word you want to blank out!",
						icon: "remove"
					});
				} else {
	
					this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, { parts: this.getLatestParts() });
	
					// EXTRACT SYNONYMS
					var synonyms = {};
					_.each(this.props.questionBuilder.parts, function (part) {
						if (part.type.includes("synonym")) {
							synonyms[part.index] = part.text;
						}
					});
	
					this.setState({
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.pageText("addSynonymsMessage")] } } }
						},
						currentStage: SYNONYM_INPUT_STAGE,
						synonyms: synonyms
					});
					window.wrNotifications.triggerDropDownNotification({
						title: "Great Work!", text: this.pageText("selectBlankPopUp"), icon: "star" });
				}
			}
		}, {
			key: "getRightOrderAnswer",
			value: function getRightOrderAnswer(questionWords, arrActiveAnswer) {
	
				var answer = "";
				for (var i = 0; i < arrActiveAnswer.length; i++) {
					if (arrActiveAnswer[i] === ACTIVE_BTN) {
						answer = answer + (answer ? " " : "") + questionWords[i];
					}
				}
				//handle punctuation
				if (answer.charAt(answer.length - 1) === "." || answer.charAt(answer.length - 1) === "!" || answer.charAt(answer.length - 1) === "?") {
					//delete the last character of your answer if you find a dot
					return [answer.slice(0, -1)];
				}
				return [answer];
			}
		}, {
			key: "cleanOutBlankQuestion",
			value: function cleanOutBlankQuestion(questionWords, arrActiveAnswer) {
	
				var addWords = "";
				var underScoreMarker = 0;
	
				for (var i = 0; i < arrActiveAnswer.length; i++) {
					if (arrActiveAnswer[i] === INACTIVE_BTN) {
						addWords = i === 0 ? questionWords[i] : addWords + " " + questionWords[i];
					} else if (arrActiveAnswer[i] === ACTIVE_BTN && underScoreMarker == 0) {
						addWords = i === 0 ? "____" : addWords + " " + "____";
						underScoreMarker = 1;
					}
				}
				//handle punctuation
				if (arrActiveAnswer[arrActiveAnswer.length - 1] === ACTIVE_BTN) {
					//add a dot to your question with blank if your last word was a blank
					var str = questionWords[questionWords.length - 1];
					addWords = addWords + str.charAt(str.length - 1);
				}
				return addWords;
			}
		}, {
			key: "clickBlankStoreAnswer",
			value: function clickBlankStoreAnswer(blank, index, questionWords) {
	
				var selectedBlanks = _.clone(this.state.selectedBlanks);
				if (index in selectedBlanks) {
					// MUST BE BEGINING OR ENDING BLANK
					if (index != 0 && index != _.size(_.keys(selectedBlanks)) - 1) {
						window.wrNotifications.triggerDropDownNotification({
							type: "error",
							title: "Consecutive Words",
							text: this.errorText("consecutiveWords"),
							icon: "remove"
						});
					} else {
						delete selectedBlanks[index];
						this.setState({ selectedBlanks: selectedBlanks });
					}
				} else {
	
					selectedBlanks[index] = blank;
	
					// SHOULD SELECT 1 TO 3 BLANKS
					if (_.size(selectedBlanks) > 3) {
						window.wrNotifications.triggerDropDownNotification({
							type: "error",
							title: "Try Again!",
							text: this.errorText("threeWordLimit"),
							icon: "remove"
						});
					} else {
						// BLANKS SHOULD BE CONSECUTIVE
						var consecutive = this.areConsecutive(selectedBlanks, questionWords);
						if (!consecutive) {
							window.wrNotifications.triggerDropDownNotification({
								type: "error",
								title: "Consecutive Words",
								text: this.errorText("consecutiveWords"),
								icon: "remove"
							});
						} else {
							this.setState({ selectedBlanks: selectedBlanks });
						}
					}
				}
			}
		}, {
			key: "makeBlankButton",
			value: function makeBlankButton(blank, index, questionWords) {
				var _this4 = this;
	
				if (!EXCLUDED_PUNCTUATION.includes(blank)) {
					//swap button style arround to deselect the button the student selected
					var buttonStyleOnOff = "btn buttonDefault";
					if (this.state.selectedBlanks && index in this.state.selectedBlanks) buttonStyleOnOff = "btn buttonPrimary";
					return React.createElement(
						"button",
						{
							className: buttonStyleOnOff,
							onClick: function onClick() {
								return _this4.clickBlankStoreAnswer(blank, index, questionWords);
							} },
						blank
					);
				} else {
					//render punctuation as disabled button
					return React.createElement(
						"button",
						{
							disabled: true,
							className: "btn buttonNonClickable" },
						blank
					);
				}
			}
		}, {
			key: "getQuestionWithBlank",
			value: function getQuestionWithBlank() {
				var _this5 = this;
	
				var question = this.getPartItemText("question");
				return this.handleExcludedPunctuation(_.map(this.handleExcludedPunctuation(question, 'add-spaces').split(/\s+/), function (word, i) {
					return i in _this5.state.selectedBlanks ? "_" : word;
				}).join(" ").replaceAll("_", " ____ "), 'remove-spaces');
			}
		}, {
			key: "renderAnswerBlank",
			value: function renderAnswerBlank() {
				var _this6 = this;
	
				//check question and question with blank
				var question = this.getPartItemText("question");
	
				var questionWords = this.handleExcludedPunctuation(question, 'add-spaces').split(/\s+/);
				var feedbackDisplay = React.createElement(
					"div",
					{ className: "questionFeedbackBox" },
					this.renderFeedback()
				);
	
				if (_.size(this.state.selectedBlanks) > 0) {
					var questionWithBlank = this.getQuestionWithBlank();
					var answer = this.handleExcludedPunctuation(_.values(this.state.selectedBlanks).join(" "), 'remove-spaces');
					var blankDisplay = React.createElement(
						"div",
						{ className: "blankDisplay" },
						React.createElement(
							"b",
							{ className: "questionStylingSelectBlank" },
							"Question:"
						),
						React.createElement(
							"p",
							{ className: "textStylingSelectBlank" },
							questionWithBlank
						),
						React.createElement(
							"b",
							{ className: "questionStylingSelectBlank" },
							"Answer:"
						),
						React.createElement(
							"p",
							{ className: "textStylingSelectBlank" },
							answer
						)
					);
				}
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "questionDisplayBox slideLeft" },
						React.createElement(
							"h3",
							null,
							"Select the Blank"
						),
						questionWords.map(function (blank, index) {
							return _this6.makeBlankButton(blank, index, questionWords);
						}),
						React.createElement("br", null),
						blankDisplay,
						React.createElement(
							"div",
							{ className: "buttonsBox" },
							React.createElement(LoadingButton, {
								className: "btn buttonPrimary buttonPrimaryLeft",
								text: "Back",
								onClick: this.goBackToWriteASentence.bind(this)
							}),
							React.createElement(LoadingButton, {
								className: "btn buttonPrimary buttonPrimaryRight",
								text: "Next",
								onClick: this.goNextToSubmit.bind(this)
							})
						)
					),
					feedbackDisplay
				);
			}
	
			/**************************************** STEP 3 *********************************************/
			//	Adding synonyms to fitb
	
		}, {
			key: "goBackToSelectFitb",
			value: function goBackToSelectFitb() {
				var _this7 = this;
	
				this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, { parts: this.getLatestParts() });
				this.setState(function (state) {
					return {
						currentStage: BLANK_SELECTION_STAGE,
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [_this7.pageText("textSelectBlank")] } } }
						}
					};
				});
			}
		}, {
			key: "validateSynonym",
			value: function validateSynonym(synonym) {
	
				if (!synonym || synonym === "") {
					this.setState({
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.errorText("answerShort")] } } }
						}
					});
					return false;
				} else if (synonym.split(' ').length > 3) {
					this.setState({
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.errorText("answerLong")] } } }
						}
					});
					return false;
				} else if (_.contains(_.map(_.values(this.state.selectedBlanks), function (word) {
					return word.toLowerCase();
				}), synonym.toLowerCase())) {
					this.setState({
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [this.errorText("repeatingAnswer")] } } }
						}
					});
					return false;
				}
				return true;
			}
		}, {
			key: "addSynonym",
			value: function addSynonym(index) {
				if (index == -1) {
					// NEW SYNONYM
					var newSynonym = this.refs.newSynonym.value;
					index = _.size(this.state.synonyms);
				} else {
					var newSynonym = this.refs["synonym-" + index].value;
				}
	
				if (this.validateSynonym(newSynonym)) {
					var synonyms = _.clone(this.state.synonyms);
					synonyms[index] = newSynonym;
	
					if (_.size(synonyms) < 3) {
						var feedbackContent = this.pageText("addSynonymsMessage");
					} else {
						var feedbackContent = this.pageText("submitQuestionBuilder");
					}
					this.setState({
						unsavedSynonyms: false,
						synonyms: synonyms,
						recentAutograderData: {
							assisting: { selected_content: { 1: { content: [feedbackContent] } } }
						}
					});
				}
			}
		}, {
			key: "deleteAnswerOption",
			value: function deleteAnswerOption(index) {
				var synonyms = _.clone(this.state.synonyms);
				delete synonyms[index];
	
				var newSynonyms = {};
				_.each(_.values(synonyms), function (synonym, s) {
					newSynonyms[s] = synonym;
				});
				if (_.size(newSynonyms) < 3) {
					var feedbackContent = this.pageText("addSynonymsMessage");
				} else {
					var feedbackContent = this.pageText("submitQuestionBuilder");
				}
				this.setState({
					synonyms: synonyms,
					recentAutograderData: {
						assisting: { selected_content: { 1: { content: [feedbackContent] } } }
					}
				});
			}
		}, {
			key: "handleOptionOnKeydown",
			value: function handleOptionOnKeydown(e) {
				this.setState({ unsavedSynonyms: e.target.value.length > 0 });
			}
		}, {
			key: "answersDisplay",
			value: function answersDisplay() {
				var _this8 = this;
	
				var answerContent = this.getQuestionBuilderAnswers().map(function (item, index) {
	
					return React.createElement(
						"div",
						{ key: index },
						React.createElement("input", {
							className: "form-control synonym-input",
							ref: "synonym-" + index,
							defaultValue: item
						}),
						React.createElement(LoadingButton, {
							className: "btn-link editButtonStyling",
							text: "edit",
							onClick: _this8.addSynonym.bind(_this8, index)
						}),
						"|",
						React.createElement(LoadingButton, {
							className: "btn-link deleteButtonStyling",
							text: "delete",
							onClick: _this8.deleteAnswerOption.bind(_this8, index)
						})
					);
				});
				return React.createElement(
					"div",
					null,
					React.createElement(
						"b",
						null,
						"Options:"
					),
					answerContent
				);
			}
		}, {
			key: "addAnswersSection",
			value: function addAnswersSection() {
				var _this9 = this;
	
				var getExtraAnswers = this.getQuestionBuilderAnswers().length >= 3 ? "" : React.createElement(
					"div",
					{ key: _.size(this.state.synonyms) },
					React.createElement("input", {
						className: "form-control synonym-input",
						ref: "newSynonym",
						placeholder: "add synonym",
						onKeyUp: function onKeyUp(e) {
							return _this9.handleOptionOnKeydown(e);
						}
					}),
					React.createElement(LoadingButton, {
						className: "btn-link doneButtonStyling",
						text: "Add",
						onClick: this.addSynonym.bind(this, -1)
					})
				);
	
				return React.createElement(
					"div",
					null,
					this.answersDisplay(),
					getExtraAnswers
				);
			}
		}, {
			key: "confirmReturnHome",
			value: function confirmReturnHome() {
				if (this.state.unsavedSynonyms) {
					if (confirm("You have unsaved edits that will be lost if you close this window. Make sure to click 'Add' next to each answer option. Still want to submit?")) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			}
		}, {
			key: "returnHome",
			value: function returnHome() {
				var _this10 = this;
	
				if (this.confirmReturnHome()) {
					var answerData = {
						draft: false,
						parts: this.getLatestParts()
					};
					this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, answerData).then(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Fantastic!", text: _this10.pageText("submitPopUp"), icon: "star"
						});
					});
	
					if (!this.props.book.text_id || this.props.book.text_id === 'MISSING_TEXT_ID') {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.WORK_VIEW,
							detailsView: "question_builders"
						}));
					} else if (this.props.book && this.props.book.text_id) {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: "question_builders",
							textID: this.props.book.text_id
						}));
					} else {
						var redirectPath = "/";
					}
					$wr.redirect(redirectPath);
				}
			}
		}, {
			key: "renderSubmit",
			value: function renderSubmit() {
				return React.createElement(
					"div",
					null,
					React.createElement(
						"div",
						{ className: "questionDisplayBox slideLeft" },
						React.createElement(
							"h3",
							null,
							"Confirm Your Answers"
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"b",
								null,
								"Question:"
							),
							React.createElement(
								"p",
								null,
								this.getQuestionWithBlank()
							)
						),
						React.createElement(
							"div",
							null,
							React.createElement(
								"b",
								null,
								"Answer:"
							),
							React.createElement(
								"p",
								null,
								this.getPartItemText("answer")
							)
						),
						this.addAnswersSection(),
						React.createElement(
							"div",
							{ className: "buttonsBox" },
							React.createElement(LoadingButton, {
								className: "btn buttonPrimary buttonPrimaryLeft",
								text: "Back",
								onClick: this.goBackToSelectFitb.bind(this),
								loading: this.state.loading
							}),
							React.createElement(LoadingButton, {
								className: "btn buttonPrimary buttonPrimaryRight",
								text: "Submit",
								onClick: this.returnHome.bind(this),
								loading: this.state.loading
							})
						)
					),
					React.createElement(
						"div",
						{ className: "questionFeedbackBox" },
						this.renderFeedback()
					)
				);
			}
	
			/*************************** Progress Bar *******************************/
	
		}, {
			key: "getPhase",
			value: function getPhase(finish) {
				switch (this.state.currentStage) {
					case SENTENCE_INPUT_STAGE:
						return 1;
						break;
					case BLANK_SELECTION_STAGE:
						return 2;
						break;
					case SYNONYM_INPUT_STAGE:
						return 3;
						break;
				}
			}
		}, {
			key: "renderProgressMeter",
			value: function renderProgressMeter() {
				var iconStems = ["quiz-icons/warmup", "quiz-icons/open-ss", "quiz-icons/open-ss"];
	
				var studentAvatar = React.createElement(StudentAvatar, { student: CurrentUser.get(), maxWidth: 45, disableAnimation: true });
				return React.createElement(StepProgressMeter, {
					numSteps: iconStems.length,
					currentStep: this.getPhase(),
					iconPathStems: iconStems,
					currentStepDisplay: studentAvatar,
					finishImgPath: "quiz-icons/finish.png"
				});
			}
	
			/**************************** AutoSaver *************************************/
	
		}, {
			key: "getLatestParts",
			value: function getLatestParts() {
				var _this11 = this;
	
				switch (this.state.currentStage) {
					case SENTENCE_INPUT_STAGE:
						var question = this.refs.question.value;
						var parts = this.updateQuestionParts(question, "question", null);
						break;
					case BLANK_SELECTION_STAGE:
						var answerText = this.handleExcludedPunctuation(_.values(this.state.selectedBlanks).join(" "), 'remove-spaces');
						var index = _.keys(this.state.selectedBlanks)[0];
						if (!_.isEmpty(answerText) && index && !isNaN(index)) {
							var parts = this.updateQuestionParts(answerText, "answer", index);
						}
						break;
					case SYNONYM_INPUT_STAGE:
						// ADD SYNONYMS TO PARTS
						var parts = this.props.questionBuilder.parts;
						_.each(this.state.synonyms, function (synonym, k) {
							parts = _this11.updateQuestionParts(synonym, "synonym-" + k, k);
						});
	
						// REMOVE SYNONYMS THAT WERE DELETED
						var parts = _.select(parts, function (part) {
							if (part.type.includes("synonym") && part.index > _.size(_this11.state.synonyms) - 1) {
								return false;
							} else {
								return true;
							}
						});
						break;
				}
				return parts;
			}
		}, {
			key: "saveAnswer",
			value: function saveAnswer(draftStatus) {
	
				var answerData = {
					parts: this.getLatestParts(),
					draft: draftStatus
				};
				return this.props.updateMetaCognitiveAnswer(this.props.questionBuilder.id, answerData);
			}
		}, {
			key: "deleteDraft",
			value: function deleteDraft() {
				this.props.deleteMetaCognitiveAnswer(this.props.questionBuilder.id).then(function () {
					window.wrNotifications.triggerDropDownNotification({
						title: "Your work has been deleted!", text: "", icon: "trash" });
					$wr.redirect("/");
				});
			}
		}, {
			key: "getAutosaveHash",
			value: function getAutosaveHash() {
				// if (this.props.questionBuilder) {
				// 	var parts = this.getLatestParts();
				// 	var hashString = _.pluck(parts, "text").join("_");
				// 	var hashValue = $wr.hashCode(hashString);
				// 	return hashValue;
				// } else {
				return "missingQuestionBuilder";
				// }
			}
		}, {
			key: "autosaveDraft",
			value: function autosaveDraft(callback) {
				var _this12 = this;
	
				this.setState({ autosaveLoading: true }, function () {
					_this12.saveAnswer(_this12.props.questionBuilder.draft).then(function () {
						_this12.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					}).catch(function () {
						// Error Handling... allow future autosaving even if this one failed
						_this12.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					});
				});
			}
	
			/**************************** Helpers *************************************/
	
		}, {
			key: "textID",
			value: function textID() {
				if (this.props.book) {
					return this.props.book.text_id;
				} else {
					return $wr.getURLParameterByName("text_id");
				}
			}
	
			/**************************** RENDER FITB **********************************/
	
		}, {
			key: "render",
			value: function render() {
				//progressMeterBar at top of page
				var progressMeter = this.renderProgressMeter();
	
				//Content
				if (this.props.questionBuilder == null) {
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else if (this.state.currentStage == SENTENCE_INPUT_STAGE) {
					var pageContent = this.renderQuestionDisplay();
				} else if (this.state.currentStage == BLANK_SELECTION_STAGE) {
					var pageContent = this.renderAnswerBlank();
				} else if (this.state.currentStage == SYNONYM_INPUT_STAGE) {
					var pageContent = this.renderSubmit();
				}
	
				return React.createElement(
					"div",
					{ className: "questionBuilderPage clearfix container" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Question Builder"
						)
					),
					React.createElement(
						"h3",
						{ className: "textTitle onQuestionSelect" },
						this.props.book.title
					),
					React.createElement(Autosaver, { onDeleteClick: this.deleteDraft, textID: this.textID(),
						autosaveLoading: this.state.loading || this.state.autosaveLoading,
						getAutosaveHash: this.getAutosaveHash, onAutosave: this.autosaveDraft }),
					progressMeter,
					pageContent
				);
			}
	
			// componentDidMount() {
			// 	if (this.textID() != undefined) {
			// 		this.props.populateData();
			// 	}
			// }
	
		}]);
	
		return QuestionBuilderPage;
	}(React.Component)) || _class) || _class);
	;
	
	var EXCLUDED_PUNCTUATION = [',', '.', '!', '?', ';', ')', '('];
	var NO_PRECEDING_SPACE = [',', '.', '!', '?', ';', ')'];
	
	QuestionBuilderPage.WrappedComponent.propTypes = PageStrictPropTypes({
		// Data from @connect
		book: PropTypes.object,
		questionBuilder: PropTypes.object,
		metaQuestion: PropTypes.object,
		currentStage: PropTypes.string,
		// Action hooks from @connect
		populateData: PropTypes.func.isRequired,
		fetchMetaCognitiveQuestion: PropTypes.func,
		createMetaCognitiveAnswer: PropTypes.func,
		updateMetaCognitiveAnswer: PropTypes.func,
		deleteMetaCognitiveAnswer: PropTypes.func
	});
	
	var MAX_ANSWER_AMOUNT = 3;
	var ACTIVE_BTN = 1;
	var INACTIVE_BTN = 0;
	
	var SENTENCE_INPUT_STAGE = "sentence-input-stage";
	var BLANK_SELECTION_STAGE = "blank-selection-stage";
	var SYNONYM_INPUT_STAGE = "synonym-input-stage";
	
	module.exports = QuestionBuilderPage;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkillsetStandardLabel = __webpack_require__(965);
	
	var WritingSelectors = __webpack_require__(14);
	
	__webpack_require__(3836);
	
	var AnalysisControls = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
	
		var answer = WritingSelectors.answer({ state: state, id: props.answerID });
		var question = WritingSelectors.question({ state: state, id: answer.question_id });
		var evaluation = WritingSelectors.evaluationForSubject({
			state: state, subjectType: "Answer", subjectID: props.answerID
		});
	
		return { answer: answer, question: question, evaluation: evaluation };
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(AnalysisControls, _React$Component);
	
		function AnalysisControls(props) {
			_classCallCheck(this, AnalysisControls);
	
			var _this = _possibleConstructorReturn(this, (AnalysisControls.__proto__ || Object.getPrototypeOf(AnalysisControls)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(AnalysisControls, [{
			key: "isFillInTheBlank",
			value: function isFillInTheBlank() {
				return this.props.answer.question_type == "fill-in-the-blank-question";
			}
		}, {
			key: "render",
			value: function render() {
				var pasteDetected = _.any(this.props.answer.meta_data || [], function (x) {
					return x.paste_detected;
				});
	
				if (this.props.question && this.props.question.skillset) {
					var skillsetLabel = React.createElement(
						"p",
						null,
						React.createElement(
							"strong",
							null,
							"Question Standard"
						),
						":",
						React.createElement(SkillsetStandardLabel, { skillset: this.props.question.skillset,
							textVariety: this.props.answer.text_variety })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "analysisControls" },
					React.createElement(
						"div",
						{ className: "infoBox" },
						skillsetLabel,
						React.createElement(
							"p",
							null,
							React.createElement(
								"strong",
								null,
								"Copy/Pasted"
							),
							": ",
							pasteDetected ? "Yes" : "No"
						)
					)
				);
			}
		}]);
	
		return AnalysisControls;
	}(React.Component)) || _class);
	;
	
	AnalysisControls.propTypes = StrictPropTypes({
		answerID: PropTypes.number,
	
		// "enabled" keys used in *this (analysis control)* component (others are ignored)
		// None currently used
		enabled: PropTypes.object,
	
		// From @connect
		answer: PropTypes.object,
		question: PropTypes.object,
		evaluation: PropTypes.object
	});
	
	module.exports = AnalysisControls;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionTypes = __webpack_require__(82);
	
	var WritingSelectors = __webpack_require__(14);
	var WritingActions = __webpack_require__(24);
	var CommentBox = __webpack_require__(119);
	var BraveCheckbox = __webpack_require__(120);
	
	__webpack_require__(3838);
	
	var FeedbackControls = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var downProps = {};
	
		var answer = WritingSelectors.answer({ state: state, id: props.answerID });
	
		if (answer.quiz_id) {
			var subjectType = "QuizAnswer";
			var noun = "quiz";
			var quizID = answer.quiz_id;
			var quiz = WritingSelectors.quiz({ state: state, id: quizID });
			var allowRevision = (quiz || {}).allow_revision;
	
			var commentCount = 0;
			if (quiz) {
				var answerIDs = quiz.answers || quiz.answer_ids;
				if (answerIDs) {
					_.each(answerIDs, function (answerID) {
						commentCount += WritingSelectors.comments({
							state: state, filters: { subject_type: subjectType, subject_id: answerID + "" }
						}).length;
					});
				}
	
				var revisedAt = quiz.revised_at;
			}
		} else {
			if (answer.question_type == QuestionTypes.REVIEW_QUESTION) {
				var subjectType = "JournalActivityReview";
				var noun = "review";
				var allowRevision = answer.allow_revision;
			} else {
				var subjectType = "JournalActivityAnswer";
				var noun = "answer";
				var allowRevision = answer.allow_revision;
			}
	
			var revisedAt = answer.revised_at;
	
			var commentCount = WritingSelectors.comments({
				state: state, filters: { subject_type: subjectType, subject_id: props.answerID + "" }
			}).length;
		}
	
		return {
			userID: answer.user_id,
			quizID: quizID, subjectType: subjectType, noun: noun, allowRevision: allowRevision, commentCount: commentCount, revisedAt: revisedAt
		};
	}, function (dispatch, props) {
		return {
			setAllowRevisions: function setAllowRevisions(id, isQuiz, allowRevision) {
				if (isQuiz) {
					return dispatch(WritingActions.updateQuiz({
						id: id, update: { allow_revision: allowRevision }
					}));
				} else {
					return dispatch(WritingActions.updateAnswer({
						id: id, update: { allow_revision: allowRevision }
					}));
				}
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(FeedbackControls, _React$Component);
	
		function FeedbackControls(props) {
			_classCallCheck(this, FeedbackControls);
	
			var _this = _possibleConstructorReturn(this, (FeedbackControls.__proto__ || Object.getPrototypeOf(FeedbackControls)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FeedbackControls, [{
			key: "toggleAllowRevision",
			value: function toggleAllowRevision() {
				if (this.props.quizID) {
					this.props.setAllowRevisions(this.props.quizID, true, !this.props.allowRevision);
				} else {
					this.props.setAllowRevisions(this.props.answerID, false, !this.props.allowRevision);
				}
			}
		}, {
			key: "render",
			value: function render() {
				console.log("!!11!!", this.props.revisedAt, this.props.enabled.allowRevision);
				if (this.props.enabled.allowRevision) {
					var needsComments = this.props.commentCount < 1;
	
					if (needsComments) {
						var needsCommentsMessage = React.createElement(
							"p",
							{ className: "needsCommentsMessage" },
							"Leave at least one comment to request a revision"
						);
					}
	
					if (!needsComments || this.props.allowRevision) {
						var revisionCheckbox = React.createElement(BraveCheckbox, { value: this.props.allowRevision,
							onClick: this.toggleAllowRevision,
							disabled: needsComments && !this.props.allowRevision,
							text: "Request a revision for this " + this.props.noun });
					}
	
					if (this.props.revisedAt) {
						var revisedAtText = React.createElement(
							"p",
							{ className: "revisedAtText" },
							React.createElement(
								"strong",
								null,
								"Revised At"
							),
							": ",
							$wr.formatDateTime(this.props.revisedAt, "show-past-years")
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "feedbackControls" },
					React.createElement(CommentBox, { subjectID: this.props.answerID,
						subjectType: this.props.subjectType,
						userID: this.props.userID, initialCollapsed: false }),
					needsCommentsMessage,
					revisionCheckbox,
					revisedAtText
				);
			}
		}]);
	
		return FeedbackControls;
	}(React.Component)) || _class);
	;
	
	FeedbackControls.WrappedComponent.propTypes = StrictPropTypes({
		answerID: PropTypes.number,
		quizID: PropTypes.number,
		allowRevision: PropTypes.bool,
	
		// "enabled" keys used in *this (feedback control)* component (others are ignored)
		//   allowRevision			-> Allows student to retake answer
		//
		enabled: PropTypes.object,
	
		// From @connect
		userID: PropTypes.number,
		noun: PropTypes.string,
		subjectType: PropTypes.string,
		commentCount: PropTypes.number,
		revisedAt: PropTypes.string,
	
		// Handlers from @connect
		setAllowRevisions: PropTypes.func
	});
	
	module.exports = FeedbackControls;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var EvaluationItem = function (_React$Component) {
		_inherits(EvaluationItem, _React$Component);
	
		function EvaluationItem(props) {
			_classCallCheck(this, EvaluationItem);
	
			var _this = _possibleConstructorReturn(this, (EvaluationItem.__proto__ || Object.getPrototypeOf(EvaluationItem)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(EvaluationItem, [{
			key: "onClick",
			value: function onClick() {
				this.props.handleChange(this.props.score);
			}
		}, {
			key: "render",
			value: function render() {
				var classString = "btn btn-link " + "score" + this.props.score;
				if (!this.props.isSelected) {
					classString += " not-selected";
				}
				if (this.props.autoGraded) {
					classString += " autoGraded";
				}
	
				if (this.props.clickable == undefined) {
					var clickable = CurrentUser.isAdmin();
				} else {
					var clickable = this.props.clickable;
				}
	
				// This type of evaluation is barely (if at all) visible, and I'm removing preferences
				var ribbonType = "numbers"; // CurrentUser.getAdminPreferences().scoring_system;
				var ribbonPath = dynamicRequire("ribbons/" + ribbonType + "/" + this.props.score + ".png");
	
				if (clickable) {
					return React.createElement("img", { alt: this.props.score, className: classString,
						src: ribbonPath, onClick: this.onClick });
				} else {
					return React.createElement("img", { alt: this.props.score, className: classString,
						src: ribbonPath, style: { cursor: 'default' } });
				}
			}
		}]);
	
		return EvaluationItem;
	}(React.Component);
	
	;
	
	EvaluationItem.propTypes = StrictPropTypes({});
	
	module.exports = EvaluationItem;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var DataRouting = __webpack_require__(36);
	var BookDisplay = __webpack_require__(46);
	var AnswerReview = __webpack_require__(952);
	var AnswerEvalOverride = __webpack_require__(951);
	var StudentDisplay = __webpack_require__(52);
	var Spinner = __webpack_require__(9);
	
	__webpack_require__(3858);
	
	function propsToConditions(props) {
	  var conditions = _.pick(props, "userIDs");
	  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	  conditions.withTotal = true;
	  conditions.order = "graded_at_desc";
	  return conditions;
	}
	
	function sortItems(item) {
	  return _.sortBy(item, function (x) {
	    return new Date(x.completed_at).valueOf();
	  }).reverse();
	}
	
	function selectEvaluations(state, props) {
	  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
	    return sortItems(WritingSelectors.evaluations({
	      state: state,
	      filters: { admin_score: null, subject_type: "Answer" }
	    }));
	  } else {
	    return sortItems(WritingSelectors.evaluationsPaginated({
	      state: state,
	      page: 1,
	      conditions: propsToConditions(props),
	      filters: {
	        "admin_score": null,
	        "subject_type": "Answer",
	        "question_type": ["generic-question, text-specific-question"]
	      }
	    }));
	  }
	}
	
	function selectAnswers(state, props, answerIDs) {
	  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
	    return sortItems(WritingSelectors.answers({
	      state: state,
	      conditions: { ids: answerIDs.reverse() }
	    }));
	  } else {
	    return sortItems(WritingSelectors.answersPaginated({
	      state: state,
	      conditions: { perPage: props.perPage || DataRouting.PER_PAGE },
	      filters: { ids: answerIDs.reverse() }
	    }));
	  }
	}
	
	function getTotals(state, props) {
	  if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
	    if (state && state.evaluations) {
	      return _.size(_.where(state.evaluations, { admin_score: null, subject_type: "Answer" }));
	    } else {
	      return 0;
	    }
	  } else {
	    return WritingSelectors.evaluationTotal({
	      state: state,
	      conditions: propsToConditions(props),
	      filters: {
	        "admin_score": null,
	        "subject_type": "Answer",
	        "question_type": ["generic-question, text-specific-question"]
	      }
	    });
	  }
	}
	
	var EvaluationOverride = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  var evaluations = selectEvaluations(state, props);
	
	  var answerIDs = [];
	  answerIDs = _.pluck(evaluations, "subject_id");
	
	  var answers = selectAnswers(state, props, answerIDs);
	
	  return {
	    evaluations: evaluations,
	    answers: answers,
	    loading: WritingSelectors.isLoadingAnswers({ state: state, key: 'index', userIDs: props.userIDs }) || WritingSelectors.isLoadingEvaluations({ state: state, key: 'index', userIDs: props.userIDs }),
	    totalCount: getTotals(state, props)
	  };
	}, function (dispatch, props) {
	
	  function populateData() {
	    // TODO: standardize FE requests
	    var filters = { admin_score: null, subject_type: "Answer", question_type: ["generic-question, text-specific-question"] };
	
	    var embeds = ["evaluation.score_details", "evaluation.analysis", "evaluation.response"];
	    // handle large requests
	    if ($wr.isLargeRequest(props.userIDs)) {
	      var conditions = {};
	      var actionFunction = WritingActions.fetchEvaluations;
	      var options = { embeds: embeds, filters: filters, cache: false
	        // fetch all evaluations
	      };return new Promise(function (resolve, reject) {
	        $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (evalPromises) {
	          resolve(evalPromises);
	
	          conditions = {};
	          embeds = ["answer.question", "answer.meta_data"];
	          actionFunction = WritingActions.fetchAnswers;
	          options = { embeds: embeds
	            // fetch all answers
	          };$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (answerPromises) {
	            resolve(answerPromises);
	          });
	        });
	      }).catch(function () {
	        return console.log("Evaluations and answers failed to load");
	      });
	    } else {
	      dispatch(WritingActions.fetchEvaluations({
	        //Add filter for subject type
	        filters: filters,
	        conditions: propsToConditions(props),
	        embeds: embeds,
	        page: 1,
	        cache: false
	      })).then(function (response) {
	        var answerIDs = [];
	        answerIDs = _.pluck(response.evaluations, "subject_id");
	
	        dispatch(WritingActions.fetchAnswers({
	          filters: { ids: answerIDs },
	          conditions: { perPage: props.perPage || DataRouting.PER_PAGE },
	          embeds: ["answer.question", "answer.meta_data"]
	        }));
	      });
	    }
	  }
	
	  function onUpdate(evaluationID, evaluationUpdate) {
	    if (evaluationID) {
	      dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
	    }
	  }
	
	  return {
	    populateData: populateData,
	    onUpdate: onUpdate
	  };
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
	  _inherits(EvaluationOverride, _React$Component);
	
	  function EvaluationOverride(props) {
	    _classCallCheck(this, EvaluationOverride);
	
	    var _this = _possibleConstructorReturn(this, (EvaluationOverride.__proto__ || Object.getPrototypeOf(EvaluationOverride)).call(this));
	
	    _this.handleOverride = function () {
	      _this.setState({ displayEdit: true });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({ displayEdit: false });
	    };
	
	    LuckyOrangeClient.tagComponent("EvaluationOverride");
	    //DisplayEdit controls the appearance of the component that appears
	    //when an evaluation pops up. 
	    _this.state = { evaluationIndex: 0, outOfAnswers: false, displayEdit: false };
	    autobind(_this);
	    return _this;
	  }
	
	  _createClass(EvaluationOverride, [{
	    key: "nextQuestion",
	    value: function nextQuestion() {
	      // TODO: standardize FE requests
	      //More evals in this page    
	      if (this.state.evaluationIndex < this.props.evaluations.length - 1) {
	        // large requests will remove reviewed evals/answers automatically
	        // so evaluation index should always be 0
	        if (!$wr.isLargeRequest(this.props.userIDs)) {
	          this.setState({ evaluationIndex: this.state.evaluationIndex + 1, displayEdit: false });
	        } else {
	          this.setState({ evaluationIndex: this.state.evaluationIndex, displayEdit: false });
	        }
	      } else {
	        //No more evals on this page, and no more pages
	        if (this.props.totalCount <= this.props.answers.length) {
	          this.setState({ outOfAnswers: true });
	        }
	        //If all evals on this page have been reviewed, but more pages.
	        else {
	            this.setState({ displayEdit: false, evaluationIndex: 0 });
	            this.props.populateData();
	          }
	      }
	    }
	
	    //Override button is clicked, bringing up AnswerEvalOverride
	
	
	    //Cancels override, closing AnswerEvalOverride
	
	  }, {
	    key: "formatScoreString",
	    value: function formatScoreString() {
	      var score = this.props.evaluations[this.state.evaluationIndex].ratio * 4;
	      score = Math.floor(score * 2) / 2;
	      return "This answer received a " + score + " out of 4";
	    }
	
	    //Needs to be async so onUpdate() returns before populateData
	
	  }, {
	    key: "handleValidate",
	    value: function handleValidate(e) {
	      $wr.nope(e);
	
	      var originalEvaluation = this.props.evaluations[this.state.evaluationIndex];
	
	      // Round up to the nearest 0.5
	      var override = originalEvaluation.score_details.machine_score;
	
	      var adminRatio = override / 10;
	
	      // Project this onto the scale of the original evaluation
	      var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);
	
	      var scoreDetails = _.extend({}, originalEvaluation.score_details, { admin_score: adminScore });
	
	      // Included both score (for immediate display) and adminScore (for the API Patch)
	      var updateData = {
	        score: adminScore,
	        ratio: adminRatio,
	        admin_score: adminScore,
	        score_details: scoreDetails,
	        grader_id: originalEvaluation.score_details.grader_id
	      };
	
	      LuckyOrangeClient.tagComponent("AdminScoreOverride");
	
	      this.props.onUpdate(originalEvaluation.id, updateData);
	
	      window.wrNotifications.triggerDropDownNotification({
	        title: "Score Validated",
	        text: "You have validated the score for this question",
	        icon: "ok-sign"
	      });
	
	      this.nextQuestion();
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      if (this.state.displayEdit) {
	        return React.createElement(
	          "div",
	          { className: "overrideControls" },
	          React.createElement(AnswerEvalOverride, {
	            evaluation: this.props.evaluations[this.state.evaluationIndex],
	            nextQuestion: this.nextQuestion
	          }),
	          React.createElement(
	            "button",
	            { className: "cancelButton buttonPrimary", onClick: this.handleCancel },
	            "Cancel"
	          )
	        );
	      } else {
	        return React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "p",
	            { className: "scoreText" },
	            this.formatScoreString()
	          ),
	          React.createElement(
	            "div",
	            { className: "buttons" },
	            React.createElement(
	              "button",
	              { className: "buttonPrimary firstButton", onClick: this.handleOverride },
	              "Override"
	            ),
	            React.createElement(
	              "button",
	              { className: "buttonSuccess spacedButton", onClick: this.handleValidate },
	              "Validate"
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display;
	      //answers load in evaluations, have to check for answer array being empty
	      if (this.props.loading) {
	        display = React.createElement(
	          "div",
	          { className: "spinnerBox" },
	          React.createElement(Spinner, null)
	        );
	      } else {
	        if (this.props.answers.length > 0 && this.state.outOfAnswers == false) {
	          display = React.createElement(
	            "div",
	            null,
	            React.createElement(StudentDisplay, {
	              studentID: this.props.answers[this.state.evaluationIndex].user_id,
	              showAvatar: true,
	              avatarMaxWidth: 40
	            }),
	            React.createElement("br", null),
	            React.createElement(BookDisplay, { textID: this.props.answers[this.state.evaluationIndex].text_id }),
	            React.createElement(
	              "div",
	              { className: "date" },
	              $wr.formatDateTime(this.props.answers[this.state.evaluationIndex].completed_at, "show-past-years")
	            ),
	            React.createElement("br", null),
	            React.createElement(AnswerReview, { answerID: this.props.answers[this.state.evaluationIndex].id }),
	            this.renderControls()
	          );
	        } else {
	          display = React.createElement(
	            "p",
	            null,
	            "You have reviewed all answers!"
	          );
	        }
	      }
	      display = React.createElement(
	        "div",
	        null,
	        React.createElement(
	          "p",
	          null,
	          "Optional: Edit scores and help us improve"
	        ),
	        display
	      );
	      return React.createElement(
	        "div",
	        { className: "quizReview" },
	        display
	      );
	    }
	  }]);
	
	  return EvaluationOverride;
	}(React.Component)) || _class) || _class);
	
	
	EvaluationOverride.WrappedComponent.propTypes = StrictPropTypes({
	  userIDs: PropTypes.array,
	  order: PropTypes.string,
	  answers: PropTypes.array,
	  evaluations: PropTypes.array,
	  loading: PropTypes.bool,
	
	  onUpdate: PropTypes.func,
	  populateData: PropTypes.func,
	  totalCount: PropTypes.number
	});
	
	module.exports = EvaluationOverride;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3841);
	
	var EvaluationTags = function (_React$Component) {
		_inherits(EvaluationTags, _React$Component);
	
		function EvaluationTags(props) {
			_classCallCheck(this, EvaluationTags);
	
			var _this = _possibleConstructorReturn(this, (EvaluationTags.__proto__ || Object.getPrototypeOf(EvaluationTags)).call(this));
	
			autobind(_this);
			_this.state = {
				tags: null, startingTags: null, showMore: false
			};
			return _this;
		}
	
		_createClass(EvaluationTags, [{
			key: "isEditable",
			value: function isEditable() {
				if (this.props.editable == undefined) {
					return CurrentUser.isAdmin();
				} else {
					return this.props.editable;
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.fetchTags();
			}
		}, {
			key: "selectTag",
			value: function selectTag(name) {
				var tagSelected = "";
				var newTags = this.state.tags.map(function (t) {
					if (t['name'] == name) {
						tagSelected = t['selected'];
						return _.extend({}, t, { selected: !t['selected'] });
					} else {
						return t;
					}
				});
	
				var newStartingTags = this.state.startingTags.map(function (t) {
					if (t['name'] == name) {
						tagSelected = t['selected'];
						return _.extend({}, t, { selected: !t['selected'] });
					} else {
						return t;
					}
				});
	
				this.setState({ tags: newTags, startingTags: newStartingTags });
				if (!tagSelected) {
					this.saveSelectedTag(name);
				} else {
					this.deleteSelectedTag(name);
				}
			}
		}, {
			key: "saveSelectedTag",
			value: function saveSelectedTag(name) {
				Mycroft.newEvent({ category: "Response", action: "add-tag", label: name });
	
				var params = {
					parent_type: "activity",
					parent_id: this.props.response.id,
					title: name
				};
				CurrentUser.api().postTags(params, $wr.apiHandler(function (serverResponse) {}.bind(this)));
			}
		}, {
			key: "deleteSelectedTag",
			value: function deleteSelectedTag(name) {
				Mycroft.newEvent({ category: "Response", action: "remove-tag", label: name });
	
				var params = {
					parent_type: "activity",
					parent_id: this.props.response.id
				};
				CurrentUser.api().deleteTag(name, params, $wr.apiHandler(function (serverResponse) {}.bind(this)));
			}
		}, {
			key: "fetchTags",
			value: function fetchTags() {
				var params = {
					parent_type: "activity",
					parent_id: this.props.response.id
				};
	
				CurrentUser.api().getTags(params, $wr.apiHandler(function (serverResponse) {
					var selectedTags = _.select(serverResponse.tags, function (st) {
						return st['selected'];
					});
	
					if (this.isEditable()) {
						var unselectedTags = _.select(serverResponse.tags, function (st) {
							return !st['selected'];
						});
						var startingTags = _.sample(unselectedTags, 6);
						var combinedTags = selectedTags.concat(startingTags);
	
						this.setState({ tags: serverResponse.tags, startingTags: combinedTags });
					} else {
						this.setState({ tags: serverResponse.tags, startingTags: selectedTags });
					}
				}.bind(this)));
			}
		}, {
			key: "showTags",
			value: function showTags() {
				this.setState({ showMore: true });
			}
		}, {
			key: "displaySmallTags",
			value: function displaySmallTags(tags) {
				return tags.map(function (t, i) {
					var className = "tagContainer " + t['type'];
	
					var innerClassName = "evaluationTag " + t['type'];
					if (t['selected']) {
						innerClassName += " activeTag";
					}
					return React.createElement(
						"div",
						{ className: className, "data-tip": t['teacher_description'],
							onClick: this.selectTag.bind(this, t['name']), key: i },
						React.createElement(
							"span",
							{ className: innerClassName },
							t['name']
						)
					);
				}.bind(this));
			}
		}, {
			key: "displayExpandedTags",
			value: function displayExpandedTags(tags) {
				return tags.map(function (t, i) {
					var expandedClassName = "expandedTag activeTag " + t['type'];
					return React.createElement(
						"div",
						{ className: expandedClassName, key: i },
						React.createElement(
							"span",
							{ className: t['type'] + " title" },
							t['name']
						),
						React.createElement(
							"span",
							{ className: "feedback" },
							t['student_description']
						)
					);
				}.bind(this));
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.startingTags && this.state.startingTags.length > 0) {
	
					if (this.isEditable()) {
	
						if (this.state.showMore) {
							var tagDisplays = this.displaySmallTags(this.state.tags);
							tagDisplays.push(React.createElement(ReactTooltip, { effect: "solid", key: "tip1" }));
						} else {
							var tagDisplays = this.displaySmallTags(this.state.startingTags);
							tagDisplays.push(React.createElement(ReactTooltip, { effect: "solid", key: "tip2" }));
	
							var moreContent = React.createElement(
								"a",
								{ className: "moreTagsLink", onClick: this.showTags },
								"More"
							);
						}
					} else {
						var tagDisplays = this.displayExpandedTags(this.state.startingTags);
					}
	
					return React.createElement(
						"span",
						{ className: "evaluationTags" },
						React.createElement(
							"span",
							null,
							tagDisplays,
							moreContent
						)
					);
				} else {
					return React.createElement("span", null);
				}
			}
		}]);
	
		return EvaluationTags;
	}(React.Component);
	
	;
	
	EvaluationTags.propTypes = StrictPropTypes({
		response: PropTypes.object.isRequired,
		editable: PropTypes.bool
	});
	
	module.exports = EvaluationTags;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ReactionFeedback = __webpack_require__(101);
	var HelpSectionLink = __webpack_require__(64);
	var Glyphicon = __webpack_require__(8);
	var AutograderDisplayConfig = __webpack_require__(83);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3844);
	
	var ScoringData = function (_React$Component) {
		_inherits(ScoringData, _React$Component);
	
		function ScoringData(props) {
			_classCallCheck(this, ScoringData);
	
			var _this = _possibleConstructorReturn(this, (ScoringData.__proto__ || Object.getPrototypeOf(ScoringData)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ScoringData, [{
			key: "showCategoryInfo",
			value: function showCategoryInfo(markupKey) {
				if (CurrentUser.isPremiumOrTrialAccount()) {
					this.props.selectMarkup(markupKey);
				}
			}
		}, {
			key: "activeTags",
			value: function activeTags(category) {
				var _props = this.props,
				    leaves = _props.leaves,
				    tagging = _props.tagging;
	
	
				if (leaves && tagging) {
					var tagKeys = leaves[this.props.markupKey].tag_keys;
					return _.pick(tagging, tagKeys);
				} else {
					return {};
				}
			}
	
			// determins color of rubric label
	
		}, {
			key: "getLabelColor",
			value: function getLabelColor(label) {
				if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, label)) {
					return 'green';
				} else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, label)) {
					return 'yellow';
				} else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, label)) {
					return 'red';
				} else {
					return 'black';
				}
			}
		}, {
			key: "gatherScoreLabels",
			value: function gatherScoreLabels(leaves) {
				if ('final-evaluation' in this.props.evaluating) {
					var answerScore = this.props.evaluating['final-evaluation'].value;
				} else {
					var answerScore = 0.0;
				}
				var requirement = AutograderDisplayConfig.getScoringDisplayRequirement(answerScore);
				var sorted = _.keys(leaves).sort(function (ka, kb) {
					return leaves[ka].value - leaves[kb].value;
				});
				var labels = {};
	
				_.each(sorted, function (key, i) {
					if (leaves[key].value) {
						if (leaves[key].rubric) {
							labels[key] = $wr.capitalize(leaves[key].value);
						} else {
							labels[key] = AutograderDisplayConfig.leafValueToText(leaves[key].value, requirement - i);
						}
					}
				});
				return labels;
			}
	
			// renders link to item's edit tab
	
		}, {
			key: "renderEditLink",
			value: function renderEditLink(key) {
				var _this2 = this;
	
				return React.createElement(
					"a",
					{ key: key, onClick: function onClick() {
							return _this2.props.onModeChange('Edit');
						} },
					"Select Label"
				);
			}
	
			// renders link to edit tab
	
		}, {
			key: "renderEditButton",
			value: function renderEditButton() {
				var _this3 = this;
	
				return React.createElement(
					"div",
					{ className: "editBtnContainer" },
					React.createElement(
						"button",
						{ className: "btn btn-primary", onClick: function onClick() {
								return _this3.props.onModeChange('Edit');
							} },
						"Edit Rubric"
					)
				);
			}
		}, {
			key: "renderCategories",
			value: function renderCategories(categories) {
				var _this4 = this;
	
				var leaves = this.props.leaves;
				if (leaves) {
					var labels = this.gatherScoreLabels(leaves);
					var rows = _.keys(leaves).map(function (key) {
						LuckyOrangeClient.tagComponent("ScoringData: " + key);
	
						var scoreLabel = labels[key] ? labels[key] : _this4.renderEditLink(key);
						var title = AutograderDisplayConfig.getLeafName(key);
	
						var categoryClassName = "";
						if (_this4.props.markupKey == key && CurrentUser.isPremiumOrTrialAccount()) {
							categoryClassName += "selectedCategory";
						};
	
						if (_.includes(AutograderDisplayConfig.NEW_KEYS, key)) {
							var badge = React.createElement(
								"span",
								{ className: "badge greeen" },
								"New!"
							);
						} else if (_.includes(AutograderDisplayConfig.BETA_KEYS, key)) {
							var badge = React.createElement(
								"span",
								{ className: "badge blue" },
								"Beta"
							);
						}
	
						var dataTip = AutograderDisplayConfig.getLeafDescription(key);
						return React.createElement(
							"tr",
							{ key: key, className: categoryClassName, onClick: _this4.showCategoryInfo.bind(_this4, key), "data-tip": dataTip },
							React.createElement(
								"td",
								{ className: "titleCell" },
								title,
								badge
							),
							React.createElement(
								"td",
								{ className: "color-" + _this4.getLabelColor(scoreLabel) },
								scoreLabel
							)
						);
					});
	
					return React.createElement(
						"table",
						{ className: "table table-borderless" },
						React.createElement(
							"tbody",
							null,
							rows
						)
					);
				}
			}
		}, {
			key: "renderCategoryInfo",
			value: function renderCategoryInfo() {
				var _this5 = this;
	
				var details = _.map(this.props.tagging, function (tags, tagKey) {
					var title = AutograderDisplayConfig.getTagName(tagKey);
					if (!title) {
						return;
					}
	
					if (_this5.props.tagColors && tagKey in _this5.props.tagColors) {
						var swatchStyle = { backgroundColor: _this5.props.tagColors[tagKey] };
						var swatch = React.createElement("span", { className: "swatch", style: swatchStyle });
					}
	
					return React.createElement(
						"p",
						{ className: "tagDetails", key: tagKey },
						swatch,
						React.createElement(
							"span",
							{ className: "descriptionAndCount" },
							title,
							" (",
							tags.length,
							")"
						)
					);
				});
	
				var descriptionText = AutograderDisplayConfig.getLeafDescription(this.props.markupKey);
				if (descriptionText) {
					var description = React.createElement(
						"p",
						null,
						descriptionText
					);
				}
	
				return React.createElement(
					"div",
					null,
					description
				);
			}
		}, {
			key: "renderScoringFlags",
			value: function renderScoringFlags() {
				if (CurrentUser.isPremiumOrTrialAccount()) {
					var renderFlags = function renderFlags(keys, className) {
						return keys.map(function (key) {
							var title = AutograderDisplayConfig.getFilterOrWarningName(key.key) || key.key;
	
							return React.createElement(
								"div",
								{ key: key },
								React.createElement(Glyphicon, { className: className, icon: "flag" }),
								" ",
								title
							);
						});
					};
	
					var _props2 = this.props,
					    filtering = _props2.filtering,
					    warning = _props2.warning;
	
	
					var shouldDisplay = false;
	
					if (filtering && _.size(filtering) > 0) {
						var filters = renderFlags(filtering, "filterIcon");
						shouldDisplay = true;
					}
					if (warning && _.size(warning) > 0) {
						var warnings = renderFlags(warning, "warningIcon");
						shouldDisplay = true;
					}
					if (shouldDisplay) {
						return React.createElement(
							"div",
							{ className: "scoringFlags answerDetailsFlag" },
							filters,
							warnings
						);
					}
					return undefined;
				}
			}
		}, {
			key: "render",
			value: function render() {
				if (!this.props.leaves || _.size(this.props.leaves) == 0) {
					if (!this.props.leaves || _.size(this.props.leaves) == 0) {
						return React.createElement(
							"div",
							{ className: "scoringData" },
							React.createElement(
								"div",
								{ className: "categoriesSection" },
								this.renderScoringFlags()
							)
						);
					} else {
						return React.createElement(
							"div",
							{ className: "scoringData" },
							React.createElement(
								"p",
								{ className: "showToggle" },
								"No scoring details available."
							)
						);
					}
				}
	
				return React.createElement(
					"div",
					{ className: "scoringData" },
					React.createElement(
						"div",
						{ className: "categoriesSection" },
						this.renderScoringFlags(),
						React.createElement(
							"div",
							{ className: "scoringCategories" },
							this.renderCategories(),
							this.renderEditButton()
						)
					),
					React.createElement(ReactTooltip, { effect: "solid" })
				);
			}
		}]);
	
		return ScoringData;
	}(React.Component);
	
	ScoringData.propTypes = StrictPropTypes({
		markupKey: PropTypes.string.isRequired,
	
		leaves: PropTypes.object, // Polarizing after aggregating and filtering
		tagging: PropTypes.object, // Keys limited only to those in markupKey
	
		filtering: PropTypes.array,
		warning: PropTypes.array,
		evaluating: PropTypes.object,
		tagColors: PropTypes.object,
	
		selectMarkup: PropTypes.func.isRequired,
		onModeChange: PropTypes.func
	});
	
	module.exports = ScoringData;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3847);
	
	var FITBAnswerBox = function (_React$Component) {
		_inherits(FITBAnswerBox, _React$Component);
	
		function FITBAnswerBox(props) {
			_classCallCheck(this, FITBAnswerBox);
	
			var _this = _possibleConstructorReturn(this, (FITBAnswerBox.__proto__ || Object.getPrototypeOf(FITBAnswerBox)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FITBAnswerBox, [{
			key: "onAnswersChange",
			value: function onAnswersChange(e) {
				var newAnswers = _.clone(this.props.answers);
	
				var text = e.target.value;
	
				if (text.length > MAX_ANSWER_LEN) {
					return;
				}
	
				var parts = text.split(/[,\n]/g).map(function (x) {
					return x.trim();
				});
	
				if (parts.length > 1) {
					var lastPart = parts.pop();
	
					newAnswers.pop(); // Remove the working answer
					newAnswers = _.uniq(newAnswers.concat(parts.concat(_.reject(parts, _.isEmpty))));
					newAnswers.push(lastPart); // Allow last part to be non-unique
				} else if (newAnswers.length == 0) {
					newAnswers = [text];
				} else {
					// Update the last element
					newAnswers[newAnswers.length - 1] = text;
				}
	
				this.props.updateAnswers(newAnswers);
			}
		}, {
			key: "onAnswersBlur",
			value: function onAnswersBlur() {
				var newAnswers = _.uniq(_.reject(this.props.answers.map(function (x) {
					return x.trim();
				}), _.isEmpty));
	
				if ((_.last(newAnswers) || "").length < MAX_ANSWER_LEN) {
					newAnswers.push("");
				}
				this.props.updateAnswers(newAnswers);
			}
		}, {
			key: "removeAnswer",
			value: function removeAnswer(text) {
				var newAnswers = _.without(this.props.answers, text);
				this.props.updateAnswers(newAnswers);
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this,
				    _React$createElement;
	
				var answerOps = _.clone(this.props.answers);
				var workingAnswer = answerOps.pop() || "";
	
				var answerBubbles = answerOps.map(function (answer, index) {
					return React.createElement(
						"span",
						{ className: "answerOp", key: index,
							onClick: _this2.removeAnswer.bind(_this2, answer) },
						answer
					);
				});
	
				if (workingAnswer.length == MAX_ANSWER_LEN) {
					var errorDisplay = React.createElement(
						"p",
						{ className: "smallText errorRed" },
						"Answers are for fill-in-the-blank questions, and shouldn't be too long"
					);
				}
	
				var rowCount = answerBubbles.length ? 1 : 2;
	
				return React.createElement(
					"div",
					{ className: "FITBAnswerBox" },
					answerBubbles,
					React.createElement("textarea", (_React$createElement = { className: "questionAnswersInput",
						onChange: this.onAnswersChange, value: workingAnswer,
						onBlur: this.onAnswersBlur,
						rows: rowCount }, _defineProperty(_React$createElement, "className", "form-control"), _defineProperty(_React$createElement, "placeholder", "Your answers..."), _React$createElement)),
					errorDisplay
				);
			}
		}]);
	
		return FITBAnswerBox;
	}(React.Component);
	
	var MAX_ANSWER_LEN = 50;
	
	FITBAnswerBox.propTypes = StrictPropTypes({
		answers: PropTypes.array.isRequired,
		updateAnswers: PropTypes.func.isRequired
	});
	
	module.exports = FITBAnswerBox;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpeechControls = __webpack_require__(142);
	
	__webpack_require__(3846);
	
	var FillInTheBlank = function (_React$Component) {
		_inherits(FillInTheBlank, _React$Component);
	
		function FillInTheBlank(props) {
			_classCallCheck(this, FillInTheBlank);
	
			var _this = _possibleConstructorReturn(this, (FillInTheBlank.__proto__ || Object.getPrototypeOf(FillInTheBlank)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FillInTheBlank, [{
			key: "onChange",
			value: function onChange(index, e) {
				var newParts = _.clone(this.props.answerParts);
				newParts[index] = _.extend({}, this.props.answerParts[index], {
					text: e.target.value
				});
				this.props.onChange(newParts);
			}
		}, {
			key: "getAnswer",
			value: function getAnswer() {
				return _.findWhere(this.props.answerParts, { type: BODY }).text;
			}
		}, {
			key: "getTextToRead",
			value: function getTextToRead() {
				var starterParts = _.where(this.props.answerParts, { type: STARTER });
				return _.pluck(starterParts, "text").join(" ... ... ... ");
			}
		}, {
			key: "setVoiceText",
			value: function setVoiceText(text) {
				var firstBodyIndex = _.findIndex(this.props.answerParts, function (x) {
					return x.type == BODY;
				});
				this.onChange(firstBodyIndex, { target: { value: text } });
			}
		}, {
			key: "renderSpeechControls",
			value: function renderSpeechControls() {
				if (this.props.speechControlSetting != "off") {
					return React.createElement(
						"div",
						{ className: "voiceFirstSpeechControls" },
						React.createElement(SpeechControls, { getText: this.getAnswer, setText: this.setVoiceText,
							getTextToRead: this.getTextToRead,
							autoReadText: this.props.speechControlSetting == "voice-first" })
					);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this2 = this;
	
				var index = 0;
				var textareas = [];
	
				var elements = [];
				_.each(this.props.answerParts, function (part, index) {
					if (part.type == STARTER) {
						elements.push(React.createElement(
							"span",
							{ className: "text", key: "starter-" + index },
							part.text
						));
					} else {
						elements.push(React.createElement("input", { className: "form-control",
							onChange: _this2.onChange.bind(_this2, index),
							key: "input-" + index, value: part.text,
							onPaste: _this2.props.handlePasteBehaviour }));
					}
				});
	
				return React.createElement(
					"div",
					{ className: "fillInTheBlank" },
					React.createElement(
						"div",
						null,
						elements
					),
					this.renderSpeechControls()
				);
			}
		}]);
	
		return FillInTheBlank;
	}(React.Component);
	
	FillInTheBlank.initialAnswerParts = function (starterOps, seed) {
		var randIndex = $wr.psuedoRandom(seed, starterOps.length);
		return _.flatten(_.map(starterOps[randIndex], function (starterText) {
			return [{ type: STARTER, text: starterText }, { type: BODY, text: "" }];
		}));
	};
	
	var STARTER = "starter";
	var BODY = "body";
	
	FillInTheBlank.BODY = BODY;
	FillInTheBlank.STARTER = STARTER;
	
	FillInTheBlank.propTypes = StrictPropTypes({
		answerParts: PropTypes.array.isRequired,
		onChange: PropTypes.func.isRequired,
		maxLength: PropTypes.number,
		handlePasteBehaviour: PropTypes.func,
		speechControlSetting: PropTypes.string
	});
	
	module.exports = FillInTheBlank;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(3849);
	var SpeechControls = __webpack_require__(142);
	
	var SentenceStarterTextArea = function (_React$Component) {
		_inherits(SentenceStarterTextArea, _React$Component);
	
		function SentenceStarterTextArea(props) {
			_classCallCheck(this, SentenceStarterTextArea);
	
			var _this = _possibleConstructorReturn(this, (SentenceStarterTextArea.__proto__ || Object.getPrototypeOf(SentenceStarterTextArea)).call(this));
	
			autobind(_this);
	
			_this.textarea = React.createRef();
			_this.starterDisplay = React.createRef();
	
			_this.state = { starterWidth: 0, starterYOffset: 1, textAreaHeight: undefined };
			return _this;
		}
	
		_createClass(SentenceStarterTextArea, [{
			key: "focus",
			value: function focus() {
				this.textarea.current.focus();
			}
		}, {
			key: "onChange",
			value: function onChange(e) {
				this.props.onChange(e.target.value);
				setTimeout(this.updateTextAreaHeight, 10);
			}
		}, {
			key: "setText",
			value: function setText(text) {
				this.props.onChange(text);
				setTimeout(this.updateTextAreaHeight, 10);
			}
		}, {
			key: "lineHeight",
			value: function lineHeight() {
				// Works as long as line-heigh is in px...
				if (this.starterDisplay.current) {
					return parseFloat($(this.starterDisplay.current).css("line-height"));
				} else {
					return 22;
				}
			}
		}, {
			key: "width",
			value: function width() {
				if (this.textarea.current) {
					return $(this.textarea.current).width();
				} else {
					return 487;
				}
			}
		}, {
			key: "getAnswer",
			value: function getAnswer() {
				return this.textarea.current.value;
			}
		}, {
			key: "getTextToRead",
			value: function getTextToRead() {
				return this.props.starterText;
			}
		}, {
			key: "renderSpeechControls",
			value: function renderSpeechControls() {
				return React.createElement(
					"div",
					{ className: "voiceFirstSpeechControls" },
					React.createElement(SpeechControls, { getText: this.getAnswer, setText: this.setText,
						getTextToRead: this.getTextToRead, toggleHighlight: this.toggleHighlight,
						autoReadText: false })
				);
			}
		}, {
			key: "render",
			value: function render() {
				var lineHeight = this.lineHeight();
				var yOffset = this.state.starterYOffset;
				var trueYOffest = yOffset;
				var textIndent = this.state.starterWidth + 10;
	
				if (textIndent > this.width() * 0.8) {
					// If text indent is more than 80% of the width, word breaks
					// for the first word might be rough. Push to next line.
					var yOffset = yOffset + lineHeight;
					var textIndent = 0;
				}
	
				var starterLines = Math.round(trueYOffest / lineHeight);
	
				var textAreaProps = _.omit(this.props, "starterText", "onChange", "rows", "handlePasteBehaviour", "speechControlSetting");
				textAreaProps.className = textAreaProps.className || "form-control";
	
				textAreaProps.style = textAreaProps.style || {};
	
				if (this.state.textAreaHeight) {
					textAreaProps.style.height = this.state.textAreaHeight;
				} else if (this.props.rows) {
					textAreaProps.rows = parseInt(this.props.rows || "3");
					textAreaProps.rows += starterLines - 1;
				}
	
				var paddingTop = yOffset - lineHeight + 7;
	
				textAreaProps.style.textIndent = textIndent;
				textAreaProps.style.paddingTop = paddingTop;
	
				var starterStyle = {};
	
				var leftLine = React.createElement("div", { className: "lineFix", style: { left: 0, top: trueYOffest } });
				if (starterLines > 1) {
					// We only need to add a line on the right if it wraps around at least once
					var rightLine = React.createElement("div", { className: "lineFix rightFix",
						style: { right: 0, top: trueYOffest - this.lineHeight() } });
				} else {
					// Makes border go up to top of text area. Normally this is 3.
					starterStyle.paddingTop = 7;
				}
	
				// NOTE: "end" needs contenct, or it doesn't hold its position
				// We make it opacity and width 0 in CSS
	
				return React.createElement(
					"div",
					{ className: "sentenceStarterTextArea" },
					leftLine,
					rightLine,
					React.createElement(
						"div",
						{ className: "starterWrap" },
						React.createElement(
							"span",
							{ className: "starter", style: starterStyle, ref: this.starterDisplay },
							this.props.starterText,
							React.createElement(
								"span",
								{ className: "end" },
								"."
							)
						)
					),
					React.createElement("textarea", _extends({}, textAreaProps, { ref: this.textarea, onChange: this.onChange, onPaste: this.props.handlePasteBehaviour })),
					this.renderSpeechControls()
				);
			}
		}, {
			key: "updateStarterDisplay",
			value: function updateStarterDisplay() {
				var $starter = $(this.starterDisplay.current);
	
				// Lots of credit @Nelson https://stackoverflow.com/a/22266818/4557470
				var starterWidth = $starter.find(".end").position().left;
	
				// This is a little hacky, and might break easily on different browsers...
				var starterYOffset = $starter.parents(".starterWrap").height();
	
				// Check if it's more than 75% of the width and if we haven't shrunk it too much yet
				this.setState({
					starterWidth: starterWidth, starterYOffset: starterYOffset
				}, this.updateTextAreaHeight);
			}
		}, {
			key: "updateTextAreaHeight",
			value: function updateTextAreaHeight() {
				// For some reason, this.textarea.current sometimes becomes undefined
				// even if we check first...
				var scrollHeight = (this.textarea.current || {}).scrollHeight;
				var clientHeight = (this.textarea.current || {}).clientHeight;
	
				if (scrollHeight === undefined || clientHeight === undefined) {
					return;
				}
	
				if (scrollHeight > clientHeight) {
					var effectiveHeight = Math.min(scrollHeight + 2, 250);
					this.setState({ textAreaHeight: effectiveHeight });
				}
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.updateStarterDisplay();
			}
		}]);
	
		return SentenceStarterTextArea;
	}(React.Component);
	
	SentenceStarterTextArea.propTypes = StrictPropTypes({
		starterText: PropTypes.string,
		onChange: PropTypes.func,
		handlePasteBehaviour: PropTypes.func,
	
		// To pass on to NormalTextArea
		className: PropTypes.string,
		placeholder: PropTypes.string,
		rows: PropTypes.string,
		value: PropTypes.string,
		speechControlSetting: PropTypes.string
	});
	
	module.exports = SentenceStarterTextArea;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var AltSkillsets = __webpack_require__(200);
	var CurrentUser = __webpack_require__(3);
	var Skillsets = __webpack_require__(55);
	
	__webpack_require__(3851);
	
	var SkillsetStandardLabel = function SkillsetStandardLabel(props) {
		var name = Skillsets.getName(props.skillset);
		var standard = CurrentUser.get().prefs.skillset_standard;
	
		if (standard) {
			var standardName = AltSkillsets.getDynamicFullName(standard, props.skillset, props.textVariety);
	
			if (standardName) {
				name = standardName + " - " + name;
			} else {
				name = "Whooo's Reading Skill Sets - " + name;
			}
		} else {
			var onEditStandards = function onEditStandards(e) {
				$wr.nope(e);
				window.wrPreferences.openPreferencesModal("account", "SkillsetStandard");
			};
			var standardLink = React.createElement(
				"span",
				null,
				" - ",
				React.createElement(
					"a",
					{ href: "#", onClick: onEditStandards },
					"Customize"
				)
			);
		}
	
		return React.createElement(
			"span",
			{ className: "skillsetStandardLabel" },
			name,
			standardLink
		);
	};
	
	SkillsetStandardLabel.propTypes = StrictPropTypes({
		skillset: PropTypes.string.isRequired,
		textVariety: PropTypes.string.isRequired
	});
	
	module.exports = SkillsetStandardLabel;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisplayToggleControl = __webpack_require__(48);
	var CurrentUser = __webpack_require__(3);
	var Glyphicon = __webpack_require__(8);
	var LoadingButton = __webpack_require__(17);
	var BookDisplay = __webpack_require__(46);
	var FITBAnswerBox = __webpack_require__(962);
	
	var MappingControl = __webpack_require__(394);
	var Spinner = __webpack_require__(9);
	var SmartBookSearch = __webpack_require__(118);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var ValidatingInput = __webpack_require__(91);
	
	__webpack_require__(3853);
	
	var TextQuestionsPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var textID = props.match.params.text_id;
		if (textID) {
			var questions = WritingSelectors.questions({
				state: state, filters: {
					text_id: textID, type: "fill-in-the-blank-question"
				}
			});
		}
		var pageLoading = WritingSelectors.isLoadingQuestions({ state: state });
		var buttonLoading = WritingSelectors.isLoadingQuestions({ state: state, key: "create" });
		return {
			questions: questions, pageLoading: pageLoading, buttonLoading: buttonLoading
		};
	}, function (dispatch, props) {
		var textID = props.match.params.text_id;
		var userID = CurrentUser.get().id;
	
		return {
			populateData: function populateData(newTextID) {
				var useTextID = newTextID || textID;
				if (useTextID) {
					var filters = {
						text_id: useTextID,
						types: "fill-in-the-blank-question",
						any_user_id: true,
						check_linked_user_id: CurrentUser.get().id
					};
					return dispatch(WritingActions.fetchQuestions({ filters: filters, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
				}
			},
			addQuestion: function addQuestion(question) {
				question = _.extend({}, question, { linked: true, linked_count: question.linked_count + 1 });
				var query = { check_linked_user_id: userID, link_user_id: userID };
				return dispatch(WritingActions.updateQuestion({ id: question.id, update: question, query: query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			createQuestion: function createQuestion(newQuestion) {
				var query = { check_linked_user_id: userID };
				return dispatch(WritingActions.createQuestion({ question: newQuestion, query: query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			removeQuestion: function removeQuestion(question) {
				question = _.extend({}, question, { linked: false, linked_count: question.linked_count - 1 });
				var query = { check_linked_user_id: userID, unlink_user_id: userID };
				return dispatch(WritingActions.updateQuestion({ id: question.id, update: question, query: query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			updateQuestion: function updateQuestion(updatedQuestion) {
				var query = { check_linked_user_id: userID };
				return dispatch(WritingActions.updateQuestion({ id: updatedQuestion.id, update: updatedQuestion, query: query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			deleteQuestion: function deleteQuestion(questionID) {
				return dispatch(WritingActions.deleteQuestion({ id: questionID }));
			}
		};
	}), _dec2 = (0, _PopulateData.providePopulateData)(), _dec(_class = _dec2(_class = function (_React$Component) {
		_inherits(TextQuestionsPage, _React$Component);
	
		function TextQuestionsPage(props) {
			_classCallCheck(this, TextQuestionsPage);
	
			var _this = _possibleConstructorReturn(this, (TextQuestionsPage.__proto__ || Object.getPrototypeOf(TextQuestionsPage)).call(this));
	
			autobind(_this);
	
			_this.state = {
				addingQuestion: false, loading: false, editingID: null, currentView: ACTIVE_QUESTIONS,
				newAnswerOptions: [], editAnswerOptions: []
			};
			return _this;
		}
	
		_createClass(TextQuestionsPage, [{
			key: "textID",
			value: function textID() {
				return this.props.match.params.text_id;
			}
		}, {
			key: "onBookSelect",
			value: function onBookSelect(book) {
				var textID = book.text_id;
				$wr.redirect("/questions/" + textID);
				this.props.populateData(textID);
			}
		}, {
			key: "goBack",
			value: function goBack() {
				$wr.redirect("/questions/");
			}
		}, {
			key: "toggleAddingQuestion",
			value: function toggleAddingQuestion(e) {
				$wr.nope(e);
				this.setState({ addingQuestion: !this.state.addingQuestion });
			}
		}, {
			key: "toggleEditingQuestion",
			value: function toggleEditingQuestion(questionID) {
				if (this.state.editingID == questionID) {
					this.setState({ editingID: null });
				} else {
					var editAnswerOptions = _.findWhere(this.props.questions, { id: questionID }).answer_options.concat("");
					this.setState({ editingID: questionID, editAnswerOptions: editAnswerOptions });
				}
			}
		}, {
			key: "addQuestion",
			value: function addQuestion(question) {
				this.props.addQuestion(question);
				setTimeout(function () {
					window.wrNotifications.triggerDropDownNotification({
						title: "Success!", text: "You successfully added a question.", icon: "ok-sign" });
				}, 1000);
			}
		}, {
			key: "removeQuestion",
			value: function removeQuestion(question) {
				if (confirm("Are you sure you want to remove this question?")) {
					this.props.removeQuestion(question);
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Success!", text: "You successfully removed a question.", icon: "ok-sign" });
					}, 1000);
				}
			}
		}, {
			key: "deleteQuestion",
			value: function deleteQuestion(questionID) {
				if (confirm("Are you sure you want to delete this question?")) {
					this.props.deleteQuestion(questionID);
					var text = "You successfully deleted a question.";
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Question Deleted", text: text, icon: "trash" });
					}, 1000);
				}
			}
		}, {
			key: "newAnswerOps",
			value: function newAnswerOps() {
				return _.reject(this.state.newAnswerOptions.map(function (x) {
					return x.trim();
				}), _.isEmpty);
			}
		}, {
			key: "editAnswerOps",
			value: function editAnswerOps() {
				return _.reject(this.state.editAnswerOptions.map(function (x) {
					return x.trim();
				}), _.isEmpty);
			}
		}, {
			key: "validateForm",
			value: function validateForm(edit) {
				if (edit) {
					return this.refs.editedQuestionBody.validate() && this.editAnswerOps().length > 0;
				} else {
					return this.refs.questionBody.validate() && this.newAnswerOps().length > 0;
				}
			}
		}, {
			key: "submitNewQuestion",
			value: function submitNewQuestion(e) {
				var _this2 = this;
	
				$wr.nope(e);
				if (!this.validateForm()) {
					return;
				}
				this.setState({ loading: true });
				var question = this.refs.questionBody.val();
				var answers = this.newAnswerOps();
	
				var questionData = { body: question, text_id: this.textID(),
					type: "fill-in-the-blank-question", user_id: CurrentUser.get().id, answer_options: answers
				};
				this.setState({ loading: false }, function () {
					_this2.props.createQuestion(questionData);
					_this2.refs.questionBody.reset();
					_this2.setState({ newAnswerOptions: [] });
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Success!", text: "You successfully added a question.", icon: "ok-sign" });
					}, 1000);
				});
			}
		}, {
			key: "submitEditedQuestion",
			value: function submitEditedQuestion(editedQuestion) {
				var _this3 = this;
	
				if (!this.validateForm("edit")) {
					return;
				}
				this.setState({ loading: true });
				var question = this.refs.editedQuestionBody.val();
				var answers = this.editAnswerOps();
				var questionData = { id: editedQuestion.id, body: question, answer_options: answers };
				this.setState({ loading: false }, function () {
					_this3.props.updateQuestion(questionData);
					_this3.toggleEditingQuestion(editedQuestion.id);
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Success!", text: "You successfully edited a question.", icon: "ok-sign" });
					}, 1000);
				});
			}
		}, {
			key: "onViewChange",
			value: function onViewChange(viewKey) {
				this.setState({ currentView: viewKey });
			}
		}, {
			key: "renderWRQuestions",
			value: function renderWRQuestions(questions) {
				var questionsContent = _.map(questions, function (question) {
					var questionDisplay = React.createElement(
						"div",
						{ className: "question", key: question.id },
						React.createElement(
							"p",
							{ className: "bodyContainer" },
							question.body
						),
						React.createElement(
							"p",
							{ className: "answersContainer" },
							React.createElement(
								"span",
								{ className: "answersLabel" },
								"answers:"
							),
							" ",
							(question.answer_options || []).join(", ")
						),
						React.createElement(
							"p",
							{ className: "originTag" },
							"Selected by Whooo's Reading"
						)
					);
					return React.createElement(
						"div",
						{ className: "questionAnswerContainer", key: question.id },
						questionDisplay,
						React.createElement("span", { className: "verticalDivider" })
					);
				}.bind(this));
				return questionsContent;
			}
		}, {
			key: "renderUserQuestions",
			value: function renderUserQuestions(questions) {
				var questionsContent = _.map(questions, function (question) {
					var _this4 = this;
	
					if (this.state.editingID == question.id) {
						var editControls = React.createElement(
							"div",
							{ className: "controls" },
							React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.props.buttonLoading,
								text: "Save", onClick: this.submitEditedQuestion.bind(this, question) }),
							React.createElement(
								"a",
								{ className: "cancelLink",
									onClick: this.toggleEditingQuestion.bind(this, question.id) },
								"Cancel"
							)
						);
						var questionDisplay = React.createElement(
							"div",
							{ key: question.id, className: "editingContainer" },
							React.createElement(
								"form",
								{ className: "editQuestionForm", onSubmit: $wr.nope },
								React.createElement(
									"label",
									null,
									"Question"
								),
								React.createElement(ValidatingInput, { type: "textarea", ref: "editedQuestionBody",
									validators: [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.FITB],
									inputClassName: "form-control",
									defaultValue: question.body,
									placeholder: "Your question..." }),
								React.createElement(
									"label",
									null,
									"Answers"
								),
								React.createElement(FITBAnswerBox, { answers: this.state.editAnswerOptions,
									updateAnswers: function updateAnswers(editAnswerOptions) {
										return _this4.setState({ editAnswerOptions: editAnswerOptions });
									} }),
								editControls
							)
						);
					} else {
						if (question.linked_count == 1) {
							var questionControls = React.createElement(
								"div",
								{ className: "questionControls" },
								React.createElement(
									"a",
									{ className: "editLink", onClick: this.toggleEditingQuestion.bind(this, question.id) },
									"Edit"
								),
								React.createElement(
									"a",
									{ className: "controlLink", onClick: this.deleteQuestion.bind(this, question.id) },
									"Delete"
								)
							);
							var originTag = React.createElement(
								"p",
								{ className: "originTag" },
								"Your question "
							);
						} else {
							var originTag = React.createElement(
								"p",
								{ className: "originTag" },
								"Selected by ",
								question.linked_count,
								" ",
								$wr.pluralize("teacher", question.linked_count),
								" "
							);
							var questionControls = React.createElement(
								"div",
								{ className: "questionControls" },
								React.createElement(
									"a",
									{ onClick: this.removeQuestion.bind(this, question) },
									"Remove"
								)
							);
						}
						var questionDisplay = React.createElement(
							"div",
							{ className: "question" },
							React.createElement(
								"p",
								{ className: "bodyContainer" },
								question.body
							),
							React.createElement(
								"p",
								{ className: "answersContainer" },
								React.createElement(
									"span",
									{ className: "answersLabel" },
									"answers:"
								),
								" ",
								(question.answer_options || []).join(", ")
							),
							questionControls,
							originTag
						);
					}
					return React.createElement(
						"div",
						{ className: "questionAnswerContainer", key: question.id },
						questionDisplay,
						React.createElement("span", { className: "verticalDivider" })
					);
				}.bind(this));
				return questionsContent;
			}
		}, {
			key: "renderInactiveQuestions",
			value: function renderInactiveQuestions(questions) {
				var questionsContent = _.map(questions, function (question) {
					var questionControls = React.createElement(
						"div",
						{ className: "questionControls" },
						React.createElement(
							"a",
							{ className: "controlLink", onClick: this.addQuestion.bind(this, question) },
							"Add"
						)
					);
					var originTag = React.createElement(
						"p",
						{ className: "originTag" },
						"Selected by ",
						question.linked_count,
						" ",
						$wr.pluralize("teacher", question.linked_count),
						" "
					);
					var questionDisplay = React.createElement(
						"div",
						{ className: "question", key: question.id },
						React.createElement(
							"p",
							{ className: "bodyContainer" },
							question.body
						),
						React.createElement(
							"p",
							{ className: "answersContainer" },
							React.createElement(
								"span",
								{ className: "answersLabel" },
								"answers:"
							),
							" ",
							(question.answer_options || []).join(", ")
						),
						questionControls,
						originTag
					);
					return React.createElement(
						"div",
						{ className: "questionAnswerContainer", key: question.id },
						questionDisplay,
						React.createElement("span", { className: "verticalDivider" })
					);
				}.bind(this));
				return questionsContent;
			}
		}, {
			key: "render",
			value: function render() {
				var _this5 = this;
	
				// Questions created by WR
				var wrQuestions = _.select(this.props.questions, function (question) {
					return question.user_id == null;
				}.bind(this));
	
				// Questions created by Current User
				var userQuestions = _.select(this.props.questions, function (question) {
					return question.linked;
				}.bind(this));
	
				// Questions created by other teachers
				var inactiveQuestions = _.select(this.props.questions, function (question) {
					return question.user_id && !question.linked;
				}.bind(this));
	
				var questionsCount = " (" + (wrQuestions.length + userQuestions.length) + ")";
				var activeQuestionsText = "My Questions" + questionsCount;
				var inactiveQuestionsCount = " (" + inactiveQuestions.length + ")";
				var inactiveQuestionsText = "Teacher Questions" + inactiveQuestionsCount;
	
				var toggleOptions = [{ key: ACTIVE_QUESTIONS, text: activeQuestionsText }, { key: INACTIVE_QUESTIONS, text: inactiveQuestionsText // Question Pool
				}];
	
				var displayToggleOptions = React.createElement(
					"div",
					{ className: "hideOnPrint" },
					React.createElement(DisplayToggleControl, { options: toggleOptions,
						onChange: this.onViewChange, activeOptionKey: this.state.currentView })
				);
	
				if (this.textID()) {
					if (this.props.pageLoading) {
						var content = React.createElement(
							"div",
							null,
							React.createElement(Spinner, { placeholder: true, scale: 1.7 })
						);
					} else {
						if (this.state.currentView == ACTIVE_QUESTIONS) {
							var wrQuestionsContent = this.renderWRQuestions(wrQuestions);
							var questionsContent = this.renderUserQuestions(userQuestions);
							var placeholderText = "Write some questions here PLEASE.....";
							var newQuestionContent = React.createElement(
								"div",
								null,
								React.createElement(
									"form",
									{ className: "newQuestionForm" },
									React.createElement(
										"div",
										{ className: "inputContainer" },
										React.createElement(
											"p",
											{ className: "inputLabel" },
											"Question"
										),
										React.createElement(ValidatingInput, { type: "textarea", ref: "questionBody", className: "questionBodyInput",
											validators: [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.FITB],
											inputClassName: "form-control",
											placeholder: "Your question..." }),
										React.createElement(
											"p",
											{ className: "instructionText" },
											"Questions should look like this: \"Sam-I-Am wanted his friend to try ____\" (4 underscores)."
										)
									),
									React.createElement(
										"div",
										{ className: "inputContainer" },
										React.createElement(
											"p",
											{ className: "inputLabel" },
											"Answers"
										),
										React.createElement(FITBAnswerBox, { answers: this.state.newAnswerOptions,
											updateAnswers: function updateAnswers(newAnswerOptions) {
												return _this5.setState({ newAnswerOptions: newAnswerOptions });
											} }),
										React.createElement(
											"p",
											{ className: "instructionText" },
											"Answers should look like this: \"eggs, ham.\" (Separate each answer with a comma or line return.)"
										)
									),
									React.createElement(
										"div",
										{ className: "controls" },
										React.createElement(LoadingButton, { className: "btn buttonSuccess", loading: this.props.buttonLoading,
											text: "Save", onClick: this.submitNewQuestion })
									)
								)
							);
	
							if (wrQuestions.length == 0 && userQuestions.length == 0) {
								if (inactiveQuestions.length > 0) {
									var otherTeacherText = "or select questions written by other teachers";
								}
	
								var text = React.createElement(
									"div",
									{ className: "text" },
									React.createElement(
										"p",
										null,
										"There aren't any text-specific fill-in-the-blank questions for this book yet. Students can still take quizzes for it, but scores won't be as accurate."
									),
									React.createElement(
										"p",
										null,
										"You can add your own questions below ",
										otherTeacherText,
										" to improve quizzes and challenge your students."
									)
								);
							}
						} else {
							if (inactiveQuestions.length == 0) {
								var text = React.createElement(
									"div",
									{ className: "text" },
									React.createElement(
										"p",
										null,
										"This book doesn't have any questions from other teachers yet."
									)
								);
							} else {
								var text = React.createElement(
									"div",
									{ className: "text" },
									React.createElement(
										"p",
										null,
										"Select questions written by other teachers to add them to your students' quizzes."
									)
								);
							}
	
							var questionsContent = this.renderInactiveQuestions(inactiveQuestions);
						}
						var content = React.createElement(
							"div",
							{ className: "contentContainer" },
							React.createElement(
								"a",
								{ className: "backLink", onClick: this.goBack },
								"Back to Question Search"
							),
							displayToggleOptions,
							React.createElement(BookDisplay, { textID: this.textID() }),
							React.createElement(
								"div",
								{ className: "textQuestionsContainer" },
								text,
								React.createElement(
									"div",
									null,
									wrQuestionsContent,
									questionsContent,
									newQuestionContent
								)
							)
						);
					}
				} else {
					var content = React.createElement(
						"div",
						null,
						React.createElement(
							"p",
							null,
							"Find a book to view all text-specific fill-in-the-blank quiz questions, select new ones written by teachers, or add your own."
						),
						React.createElement(
							"div",
							{ className: "bookSearchBox" },
							React.createElement(SmartBookSearch, { onBookSelect: this.onBookSelect, preventManual: true,
								selectedBook: this.state.selectedBook })
						)
					);
				}
				return React.createElement(
					"div",
					{ className: "container textQuestionsPage" },
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							null,
							"Question Search"
						)
					),
					content
				);
			}
		}]);
	
		return TextQuestionsPage;
	}(React.Component)) || _class) || _class);
	
	
	var ACTIVE_QUESTIONS = "owned questions";
	var INACTIVE_QUESTIONS = "non owned questions";
	var WR_QUESTIONS = "wr";
	
	TextQuestionsPage.propTypes = PageStrictPropTypes({
		populateData: PropTypes.func,
		loading: PropTypes.bool
	});
	
	module.exports = TextQuestionsPage;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackFormatter = __webpack_require__(73);
	var Glyphicon = __webpack_require__(8);
	var Spinner = __webpack_require__(9);
	var ReactionFeedback = __webpack_require__(101);
	var FeedbackFormatter = __webpack_require__(73);
	var CurrentUser = __webpack_require__(3);
	var Carousel = __webpack_require__(419);
	var TextAreaMarkups = __webpack_require__(196);
	var QuestionFeedback = __webpack_require__(173);
	var AutograderDisplayConfig = __webpack_require__(83);
	
	var SpeechControls = __webpack_require__(142);
	
	var CSSTransition = __webpack_require__(155);
	var TransitionGroup = __webpack_require__(156);
	
	__webpack_require__(3855);
	
	var QuizAnalysisDisplay = function (_React$Component) {
		_inherits(QuizAnalysisDisplay, _React$Component);
	
		function QuizAnalysisDisplay(props) {
			_classCallCheck(this, QuizAnalysisDisplay);
	
			var _this = _possibleConstructorReturn(this, (QuizAnalysisDisplay.__proto__ || Object.getPrototypeOf(QuizAnalysisDisplay)).call(this));
	
			autobind(_this);
			var speechControlSetting = CurrentUser.get().prefs.speech_controls;
			LuckyOrangeClient.tagComponent("QuizAnalysisDisplay");
			_this.state = {
				"analysis": null,
				"Strengths": 1,
				"Weaknesses": 1,
				"owlfonsoShow": true,
				"viewed": ["Strengths-0", "Weaknesses-0"],
				"speechControlSetting": speechControlSetting
			};
			return _this;
		}
	
		////////////////
		////////////
		////////
		////
		// FIRST RENDER OWLFONSO
	
		_createClass(QuizAnalysisDisplay, [{
			key: "renderOwlfonso",
			value: function renderOwlfonso() {
				if (this.state.owlfonsoShow) {
					var text = "Hi " + CurrentUser.get().first_name + ",\n\n here is how you did on your quiz!";
					return React.createElement(
						CSSTransition,
						{ classNames: "owlfonso-animation",
							timeout: { enter: 2500, exit: 5000 } },
						React.createElement(QuestionFeedback, { ref: "owlfonso", feedbackItems: [text] })
					);
				} else {
					return "";
				}
			}
		}, {
			key: "removeOwlfonso",
			value: function removeOwlfonso() {
				if (this.state.speechControlSetting == "voice-first") {
					var timeout = 5500;
				} else {
					var timeout = 3000;
				}
				setTimeout(function () {
					this.setState({ owlfonsoShow: false }, this.triggerChainDisplay.bind(this, ">"));
				}.bind(this), timeout);
			}
	
			////////////////
			////////////
			////////
			////
			// SECOND RENDER FEEDBACK CONTENT
	
		}, {
			key: "getCategory",
			value: function getCategory(cat) {
				if (this.state.analysis[cat].length > 0) {
					if (cat == "Strengths") {
						var colorClass = " valid";
						var catName = "Well Done";
						var icon = "glyphicon-ok-sign";
					} else {
						var colorClass = " error";
						var catName = "Could Improve";
						var icon = "glyphicon-exclamation-sign";
					}
	
					var descriptions = this.state.analysis[cat].map(function (item, i) {
						var description = item.description;
						var title = item.title;
						function getTextToRead() {
							return catName + "\n" + title + "\n" + description;
						}
						if (this.state.speechControlSetting == "voice-first") {
							var speechControl = React.createElement(SpeechControls, { key: cat, getTextToRead: getTextToRead, autoReadText: true, readTextOnly: true });
						} else if (this.state.speechControlSetting == "normal") {
							var speechControl = React.createElement(SpeechControls, { key: cat, getTextToRead: getTextToRead, autoReadText: false, readTextOnly: true });
						}
						var feedbackContainer = this.renderOverriddenFeedbackDisclaimer(item);
						var asktrisk = feedbackContainer ? '*' : '';
						return React.createElement(
							"div",
							{ key: i },
							React.createElement(
								"div",
								{ className: "feedbackDescription" },
								React.createElement(
									"div",
									{ className: "feedbackTitle" },
									React.createElement(Glyphicon, { className: colorClass, icon: "glyphicon " + icon }),
									React.createElement(
										"span",
										{ className: "titleContent" },
										catName,
										": ",
										title,
										asktrisk
									),
									speechControl
								),
								FeedbackFormatter.format(description)
							),
							this.renderIndividualExamplesDisplay(cat, i),
							feedbackContainer
						);
					}.bind(this));
					if (this.refs["carousel_" + cat]) {
						var index = this.refs["carousel_" + cat].state.displayIndex;
					} else {
						var index = 1;
					}
					return React.createElement(
						"div",
						{ className: "categoryDisplay" },
						React.createElement(
							"div",
							{ className: "feedbackContent" },
							React.createElement(Carousel, { onIndexChange: this.carouselChange.bind(this, cat), displayItems: descriptions }),
							React.createElement(
								"div",
								{ className: "carouselFooter" },
								React.createElement(
									"span",
									{ className: "badge" + colorClass + "Background" },
									this.state[cat],
									"/",
									this.state.analysis[cat].length
								)
							)
						)
					);
				} else {
					return "";
				}
			}
	
			////////////////
			////////////
			////////
			////
			// THIRD RENDER EXAMPLE CONTENT
	
		}, {
			key: "renderIndividualExamplesDisplay",
			value: function renderIndividualExamplesDisplay(category, index) {
				var activeData = this.state.analysis[category][index];
				if (!activeData) {
					return React.createElement("div", { className: "emptyExample" });
				}
	
				return React.createElement(
					"div",
					{ className: "individualExamples" },
					this.dividerWithTitle("Example"),
					this.renderBestExample(activeData.example)
				);
			}
	
			// pulls overridden words from answer meta_data
	
		}, {
			key: "pullOverriddenWords",
			value: function pullOverriddenWords() {
				var overriddenWords = [];
				if (this.state.answers) {
					overriddenWords = _.map(this.state.answers, function (answer) {
						if (answer.meta_data) {
							var metaDataArray = _.where(answer.meta_data, { feedback_key: "WRITE_GRAM_SPELLING" });
							return _.map(metaDataArray, function (meta_data) {
								return meta_data.trigger;
							});
						}
					});
					overriddenWords = _.uniq(_.compact(_.flatten(overriddenWords)));
				}
				return overriddenWords;
			}
	
			// determins if feedback has been overridden and displays disclaimer if so
	
		}, {
			key: "renderOverriddenFeedbackDisclaimer",
			value: function renderOverriddenFeedbackDisclaimer(item) {
				if (item.title === SPELLING) {
					var overriddenWords = this.pullOverriddenWords();
					if (overriddenWords) {
						var givenAnswer = item.example.corrected_answer;
						var overriddenWords = overriddenWords;
						var spans = [];
						for (var key in item.example.tags) {
							spans = [].concat(_toConsumableArray(spans), [item.example.tags[key][0].spans]);
						}
						var highlightedWords = _.map(spans, function (span) {
							var charNumber = span[0].end - span[0].start;
							return givenAnswer.substr(span[0].start, charNumber);
						});
						highlightedWords = _.uniq(highlightedWords);
						var overriddenAndHighlighted = _.compact(_.map(highlightedWords, function (word) {
							if (overriddenWords.includes(word)) {
								return word;
							}
						}));
						if (overriddenAndHighlighted.length === 1) {
							return React.createElement(
								"div",
								{ className: "overriddenDisclaimer" },
								React.createElement(
									"strong",
									null,
									"* You marked \"",
									_.first(overriddenAndHighlighted),
									"\" as spelled correctly"
								)
							);
						} else if (overriddenAndHighlighted.length == 2) {
							return React.createElement(
								"div",
								{ className: "overriddenDisclaimer" },
								React.createElement(
									"strong",
									null,
									"* You marked \"",
									overriddenAndHighlighted[0],
									"\" and \"",
									overriddenAndHighlighted[1],
									"\" as spelled correctly"
								)
							);
						} else if (overriddenAndHighlighted.length > 1) {
							var textValues = '';
							_.each(overriddenAndHighlighted, function (text, i) {
								if (i === overriddenAndHighlighted.length - 1) {
									textValues = textValues + " and " + text;
								} else {
									textValues = text + ", ";
								}
							});
							return React.createElement(
								"div",
								{ className: "overriddenDisclaimer" },
								React.createElement(
									"strong",
									null,
									"* You marked \"",
									textValues,
									"\" as spelled correctly"
								)
							);
						}
					}
				}
			}
		}, {
			key: "selectBestExample",
			value: function selectBestExample(examples) {
				var selected_examples = _.select(examples, function (example) {
					return example.answer;
				});
				if (selected_examples.length > 0) {
					selected_examples.sort(function (a, b) {
						return a.markups.length < b.markups.length;
					});
					return selected_examples[0];
				} else {
					return null;
				}
			}
		}, {
			key: "fetchAnswerByID",
			value: function fetchAnswerByID(id) {
				for (var i = 0; i < this.props.quiz.answers.length; i += 1) {
					if (this.props.quiz.answers[i].id == id) {
						return this.props.quiz.answers[i];
					}
				}
				return null;
			}
		}, {
			key: "renderBestExample",
			value: function renderBestExample(example) {
				if (example) {
					var tagColors = pickTagColors(example.tags);
					return React.createElement(
						"div",
						{ key: 0, className: "singleExample" },
						React.createElement(
							"p",
							null,
							React.createElement(
								"strong",
								null,
								example.question_text
							)
						),
						React.createElement(TextAreaMarkups, { text: example.corrected_answer,
							tagging: example.tags, tagColors: tagColors })
					);
				}
			}
		}, {
			key: "dividerWithTitle",
			value: function dividerWithTitle(titleText) {
				return React.createElement(
					"div",
					{ className: "dividerWithTitle" },
					React.createElement("div", { className: "dividerArea" }),
					React.createElement(
						"div",
						{ className: "titleArea" },
						titleText
					)
				);
			}
	
			////////////////
			////////////
			////////
			////
			// HANDLE CAROUSEL CHANGE AND REWARD
	
		}, {
			key: "getViewCount",
			value: function getViewCount() {
				var count = 0;
				Object.keys(this.state.analysis).forEach(function (key) {
					count += this.state.analysis[key].length;
				}.bind(this));
				return count;
			}
		}, {
			key: "shouldReward",
			value: function shouldReward() {
				if (this.state.viewed.length >= this.getViewCount() && !this.state.reviewComplete) {
					var params = {
						award: {
							type: "qunit", key: "reviewed-post-quiz-feedback",
							"dynamic": {
								"subject_type": "quiz",
								"subject_id": this.props.quiz.id
							},
							student_id: CurrentUser.get().id
						}
					};
					this.setState({ reviewComplete: true });
					CurrentUser.api().postAwards(params, $wr.apiHandler(function (response) {
						window.wrNotifications.triggerDropDownNotification({
							title: "Reviewed feedback!", text: "Well done reviewing all feedback items for this question!", icon: "ok-circle" });
						CurrentUser.fetchCurrentUserCoinData();
					}.bind(this)));
				}
			}
		}, {
			key: "carouselChange",
			value: function carouselChange(ref, index) {
				var newStates = {};
				var newViewed = this.state.viewed.slice();
				newStates[ref] = index + 1;
				var viewString = ref + "-" + index;
				if (!newViewed.includes(viewString)) {
					newViewed.push(viewString);
					newStates["viewed"] = newViewed;
				}
	
				this.setState(newStates, this.shouldReward);
			}
			////////////////
			////////////
			////////
			////
			// DISPLAY AND FEEDBACK
	
		}, {
			key: "triggerChainDisplay",
			value: function triggerChainDisplay(dynamicDisplayClass) {
				var refs = Object.keys(this.refs).filter(function (key) {
					if (key.includes(dynamicDisplayClass)) {
						return 1;
					} else {
						return 0;
					}
				});
				if (refs.length > 0) {
					var _showNext = function _showNext() {
						index += 1;
						if (index < refs.length) {
							$(this.refs[refs[index]]).show(this.props.delay, _showNext.bind(this));
						} else {
							if (this.props.showCoinTable) {
								this.props.showCoinTable();
							}
						}
					};
	
					var index = 0;
					refs.sort();
	
					$(this.refs[refs[index]]).show(this.props.delay, _showNext.bind(this));
				}
			}
		}, {
			key: "buildReactionFeedback",
			value: function buildReactionFeedback() {
				var reactionDetails = {};
				reactionDetails[ReactionFeedback.HAPPY] = { label: "Great!" };
				reactionDetails[ReactionFeedback.NEUTRAL] = { label: "Not quite..." };
				reactionDetails[ReactionFeedback.SAD] = { label: "Completely wrong!" };
	
				var subjectType = "quiz";
				var subjectID = this.props.quiz.id;
	
				var reactionWhere = "component-post-quiz-feedback-" + subjectType;
	
				return React.createElement(ReactionFeedback, { where: reactionWhere,
					key: reactionWhere,
					textOnly: false,
					options: reactionDetails,
					title: "Was this helpful?",
					placeholder: "Help us improve our scoring by telling us why...",
					component_position: ReactionFeedback.POSITION_BOTTOM_RIGHT,
					popover_position: ReactionFeedback.POSITION_BOTTOM_RIGHT,
					subjectType: subjectType,
					subjectID: subjectID
				});
			}
	
			////////////////
			////////////
			////////
			////
			// RENDER
	
		}, {
			key: "render",
			value: function render() {
				if (!this.state.owlfonsoShow) {
					if (this.state.analysis) {
						var strongFeedback = this.getCategory('Strengths');
						var weakFeedback = this.getCategory('Weaknesses');
						var content = React.createElement(
							CSSTransition,
							{ classNames: "feedback-animation",
								timeout: { enter: 3000, exit: 1000 } },
							React.createElement(
								"div",
								{ className: "feedbackArea" },
								strongFeedback,
								weakFeedback
							)
						);
					} else if (this.state.analysis == null) {
						var spinner = React.createElement(Spinner, { placeholder: true });
					}
				}
				return React.createElement(
					"div",
					{ className: "quizAnalysisDisplay" },
					React.createElement(
						TransitionGroup,
						null,
						this.renderOwlfonso()
					),
					React.createElement(
						TransitionGroup,
						null,
						content
					),
					spinner,
					React.createElement(
						"div",
						{ className: "hiddenElement", ref: ">_999" },
						this.buildReactionFeedback()
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.loadEvaluationDetails();
			}
	
			////////////////
			////////////
			////////
			////
			// LOAD DATA
	
		}, {
			key: "loadEvaluationDetails",
			value: function loadEvaluationDetails() {
				CurrentUser.api().getQuiz(this.props.quiz.id, { "embed": "quiz.answers,answer.evaluation_details,answer.meta_data" }, $wr.apiHandler(function (response) {
					var quiz = response["quiz"];
	
					if (quiz) {
						var answers = _.reject(quiz.answers, function (x) {
							return x.question_type == "fill-in-the-blank-question";
						});
	
						if (answers && answers.length > 0 && answers[0].evaluation_details) {
							this.setState({ answers: answers }, this.buildEvaluation);
						}
					}
				}.bind(this)));
				this.removeOwlfonso();
			}
		}, {
			key: "isEvaluationValid",
			value: function isEvaluationValid(evaluation) {
				if (!(evaluation && evaluation.filtering && evaluation.polarizing && evaluation.corrected_answer)) {
					return false;
				}
				return true;
			}
		}, {
			key: "buildEvaluation",
			value: function buildEvaluation() {
				var _this2 = this;
	
				var filters = {};
				var breakdown = {};
	
				var validation = _.map(this.state.answers, function (answer, i) {
					if (!answer.filtering) {
						_this2.state.answers[i].evaluation_details['filtering'] = [];
					}
					return _this2.isEvaluationValid(answer.evaluation_details);
				});
				if (validation.includes(false)) {
					this.setState({ analysis: false });
					return;
				}
				// GATHER SCORES FOR EACH ELIGIBLE POST QUIZ FEEDBACK KEYS
				_.each(this.state.answers, function (answer, i) {
					if (_.keys(answer.evaluation_details.filtering).length > 0) {
						filters[i] = 0;
					} else {
						filters[i] = 1;
						if (answer.evaluation_details.polarizing != undefined) {
							_.each(answer.evaluation_details.polarizing, function (rating, key) {
								if (AutograderDisplayConfig.isLeafPostQuizFeedback(key)) {
									if (breakdown[key] == undefined) {
										breakdown[key] = {};
									}
									breakdown[key][i] = AutograderDisplayConfig.leafValueToScore(rating.value);
								}
							});
						}
					}
				});
				// ONLY KEEP THE LOWEST SCORE (FRENCH SCORING)
				var analysis = { "Strengths": [], "Weaknesses": [] };
				var examples = {};
	
				function activeTagging(polarizerkey, answerDetails) {
	
					if (answerDetails && answerDetails.polarizing && answerDetails.polarizing[polarizerkey] != undefined) {
						var tags = answerDetails.polarizing[polarizerkey].tags || [];
						var activeTags = {};
						_.each(tags, function (tag, key) {
							if (activeTags[key] == undefined) {
								activeTags[key] = [];
							}
							LuckyOrangeClient.tagComponent("AutograderKey: " + tag.key);
							activeTags[key].push(tag);
						});
	
						_.each(activeTags, function (key) {
							if (!AutograderDisplayConfig.isDisplayTag(key)) {
								delete activeTags[key];
							}
						});
	
						return activeTags;
					} else {
						return {};
					}
				}
	
				// ASSIGN FEEDBACK FOR FILTERS
				if (_.keys(filters).length > 0) {
					var targetIndex = _.values(filters).indexOf(0);
					if (targetIndex > -1) {
						targetIndex = _.keys(filters)[targetIndex];
						var item = AutograderDisplayConfig.getFilterPostQuizFeedback("REQUIREMENT-MINIMUM_LENGTH", false);
						item["example"] = { tags: {},
							corrected_answer: this.state.answers[targetIndex].evaluation_details.corrected_answer,
							question_text: this.state.answers[targetIndex].question_text };
						analysis["Weaknesses"].push(item);
					}
				}
	
				// ASSIGN FEEDBACK FOR POLARIZER
				_.each(breakdown, function (scores, key) {
					var minScore = Math.min.apply(null, _.values(scores));
					var targetIndex = _.values(scores).indexOf(minScore);
					targetIndex = _.keys(scores)[targetIndex];
					var tags = activeTagging(key, _this2.state.answers[targetIndex].evaluation_details);
	
					if (minScore > 3) {
						var category = "Strengths";
						var item = AutograderDisplayConfig.getLeafPostQuizFeedback(key, true);
					} else {
						var category = "Weaknesses";
						var item = AutograderDisplayConfig.getLeafPostQuizFeedback(key, false);
					}
					item["example"] = { tags: tags,
						corrected_answer: _this2.state.answers[targetIndex].evaluation_details.corrected_answer,
						question_text: _this2.state.answers[targetIndex].question_text };
					analysis[category].push(item);
				});
	
				this.setState({ analysis: analysis });
			}
		}]);
	
		return QuizAnalysisDisplay;
	}(React.Component);
	
	function pickTagColors(tagging) {
		var tagToColors = {};
		_.each(_.sortBy(_.keys(tagging)), function (key, index) {
			var hasSpans = _.any(tagging[key], function (tag) {
				return "spans" in tag;
			});
			if (hasSpans) {
				tagToColors[key] = AUTOGRADER_COLOR_LIST[index % AUTOGRADER_COLOR_LIST.length];
			}
		});
	
		return tagToColors;
	}
	
	var AUTOGRADER_COLOR_LIST = ["#96dafe", "#a0e881", "#ffcbb3", "#cfadec", "#f2de7f", "#c8ecff", "#c0f2aa", "#faaf88", "#fff864"];
	var SPELLING = 'Spelling';
	
	QuizAnalysisDisplay.propTypes = StrictPropTypes({
		// gold records to display
		quiz: PropTypes.object.isRequired,
		delay: PropTypes.number.isRequired,
		showCoinTable: PropTypes.func
	});
	
	module.exports = QuizAnalysisDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnswerWritingInterface = __webpack_require__(426);
	var MultiPartSentenceStarter = __webpack_require__(197);
	var Autosaver = __webpack_require__(198);
	var Spinner = __webpack_require__(9);
	var StepProgressMeter = __webpack_require__(249);
	var StudentAvatar = __webpack_require__(35);
	var TopicQuestion = __webpack_require__(104);
	var BookTextVariety = __webpack_require__(141);
	
	var GradeLevel = __webpack_require__(40);
	var TextTypes = __webpack_require__(38);
	var ZPDRange = __webpack_require__(176);
	var ArbitrarySubjects = __webpack_require__(107);
	var BookDisplay = __webpack_require__(46);
	
	var ReadingActions = __webpack_require__(27);
	var ReadingSelectors = __webpack_require__(21);
	var WritingActions = __webpack_require__(24);
	var RosterActions = __webpack_require__(11);
	var WritingSelectors = __webpack_require__(14);
	
	var AccountPlans = __webpack_require__(53);
	var QuestionTypes = __webpack_require__(82);
	var MyShelfRouting = __webpack_require__(74);
	
	var CurrentUser = __webpack_require__(3);
	var StudentOnboardingModal = __webpack_require__(195);
	
	__webpack_require__(3857);
	
	var QuizPage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		var textID = $wr.getURLParameterByName("text_id");
	
		var book = ReadingSelectors.book({ state: state, id: textID });
	
		var user = CurrentUser.get();
	
		var downProps = { book: book };
	
		downProps.userPrefs = user.prefs;
	
		downProps.loading = WritingSelectors.isLoadingQuestions({ state: state, key: "index" }) || WritingSelectors.isLoadingQuizzes({ state: state, key: "update" });
		// Note not answers update. We track that in state instead... Why?
		// Some reason. Maybe so we can recover from autosave failing
	
		var quiz = WritingSelectors.quizzes({ state: state, filters: { text_id: textID } })[0];
	
		if (quiz) {
			downProps.quiz = quiz;
			downProps.answers = WritingSelectors.answersForQuizID({ state: state, quizID: quiz.id });
			if (!CurrentUser.isPremiumOrTrialAccount()) {
				downProps.answers = _.filter(downProps.answers, function (answer) {
					return answer.question_type !== QuestionTypes.FILL_IN_THE_BLANK_QUESTION;
				});
			}
			downProps.questions = _.map(downProps.answers, function (answer) {
				return WritingSelectors.question({ state: state, id: answer.question_id });
			});
		}
	
		if (!user.prefs.automatic_zpd_exclusion) {
			downProps.shouldExclude = false;
		} else if (!book) {
			downProps.shouldExclude = false;
		} else if (!book.lexile_score) {
			downProps.shouldExclude = true;
		} else {
			var zpdStatus = ZPDRange.getTextStatus(book.lexile_score, user.current_reading_level);
	
			downProps.shouldExclude = zpdStatus == ZPDRange.UNDER;
		}
	
		downProps.canTakeQuiz = $wr.canStudentTakeQuiz(user);
	
		return downProps;
	}, function (dispatch, props) {
		var userID = CurrentUser.get().id;
		var textID = $wr.getURLParameterByName("text_id");
		LuckyOrangeClient.tagComponent("text_id:" + textID);
	
		function fetchText() {
			// Have to make sure the text loads in, otherwise we won't be
			// able to use the title to customize feedback
			dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then(function (response) {
				if (response.books && response.books.length > 0) {
					fetchQuizzes(response.books[0]);
				}
			});
		}
		// Step A: Fetch any quizzes, look to see if are drafts
		function fetchQuizzes(book) {
			// Fetch all quizzes, draft or non-draft, for this text (there should only be 0 or 1)
			dispatch(WritingActions.fetchQuizzes({
				conditions: { textID: textID, allowDraft: true, startDate: 'any' },
				embeds: ["quiz.answers", "answer.question", "question.starters", "question.answer_options", "answer.meta_data", "answer.history"]
			})).then(function (response) {
				// ONLY create QUIZ if NO QUIZZES FOR TEXT ID AND USER AND TEXT VARIETY SUPPLIED
	
				if (_.isEmpty(response.quizzes)) {
					createNewQuiz(book);
				} else {
					var quiz = response.quizzes[0];
					if (!(quiz.draft || quiz.allow_revision)) {
						window.wrNotifications.triggerDropDownNotification({
							text: "You've already done a quiz for this text!", icon: "ok" });
	
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: "quizzes",
							textID: textID
						}));
					} else {
						checkQuiz(quiz, book);
					}
				}
			});
		}
	
		// Step A.1: Check for malformed quizzes
		function checkQuiz(quiz, book) {
			if (_.isEmpty(quiz.answers) && book.text_variety) {
				createQuizAnswers(quiz.id, { text_variety: book.text_variety });
			}
		}
	
		// Step B: If we didn't find any drafts, make a new quiz draft
		function createNewQuiz(book) {
			if (book.text_variety) {
				var quizData = { text_id: textID, draft: true, text_variety: book.text_variety };
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.createQuiz({
					quiz: quizData
				})).then(function (response) {
					// CREATE ANSWERS DIRECTLY AFTER QUIZ IS CREATED
					createQuizAnswers(response.quizzes[0].id, { text_variety: book.text_variety });
				});
			}
		}
	
		function updateQuiz(quizID, quizData, embeds, queryParams) {
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.updateQuiz({
				id: quizID, update: quizData, embeds: embeds, query: queryParams
			}));
		}
	
		function createQuizAnswers(quizID, quizData) {
			var queryParams = {
				draft_answers: true
			};
	
			var embeds = ["quiz.answers", "answer.meta_data", "answer.history", "answer.question", "question.starters", "question.answer_options"];
	
			return updateQuiz(quizID, quizData, embeds, queryParams);
		}
	
		function deleteQuiz(quizID) {
			var update = { "activity:any:any": null };
			dispatch(ReadingActions.localUpdateBook({ id: textID, update: update }));
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.deleteQuiz({ id: quizID }));
		}
	
		return {
			populateData: fetchText,
	
			getNewQuestion: function getNewQuestion(query, embeds) {
				return dispatch(WritingActions.fetchQuestions({ query: query, embeds: embeds }));
			},
			createNewQuiz: createNewQuiz, createQuizAnswers: createQuizAnswers, updateQuiz: updateQuiz, deleteQuiz: deleteQuiz,
			updateAnswer: function updateAnswer(answerID, answerData) {
				return dispatch(WritingActions.updateAnswer({ id: answerID, update: answerData }));
			}
		};
	}), _dec(_class = function (_React$Component) {
		_inherits(QuizPage, _React$Component);
	
		function QuizPage(props) {
			_classCallCheck(this, QuizPage);
	
			var _this = _possibleConstructorReturn(this, (QuizPage.__proto__ || Object.getPrototypeOf(QuizPage)).call(this));
	
			autobind(_this);
			LuckyOrangeClient.tagComponent("QuizPage");
	
			_this.state = {
				answerSaving: false,
				autosaveLoading: false,
				questionIndex: 0
			};
			return _this;
		}
	
		_createClass(QuizPage, [{
			key: "textID",
			value: function textID() {
				return $wr.getURLParameterByName("text_id");
			}
		}, {
			key: "hasTextVariety",
			value: function hasTextVariety() {
				if (this.props.books) {
					return this.props.books.text_variety;
				}
			}
		}, {
			key: "quizHasWrittenContent",
			value: function quizHasWrittenContent() {
				var genericAnswers = _.select(this.props.answers, function (answer) {
					return answer.question_type == "generic-question";
				});
				var hasContent = _.map(genericAnswers, function (answer) {
					var body = _.map(_.select(answer.parts, function (part) {
						return part.type == "body";
					}), function (part) {
						return part.text;
					}).join("");
					return body != "";
				});
				return hasContent.includes(true);
			}
		}, {
			key: "sentenceStarterCount",
			value: function sentenceStarterCount() {
				return this.props.userPrefs.sentence_starter_count;
			}
		}, {
			key: "isLoading",
			value: function isLoading(ignoreAutosave) {
				return this.props.loading || this.state.answerSaving || this.state.autosaveLoading && !ignoreAutosave;
			}
		}, {
			key: "quizID",
			value: function quizID() {
				if (this.props.quiz) {
					return this.props.quiz.id;
				}
			}
		}, {
			key: "isLastQuestion",
			value: function isLastQuestion() {
				if (this.props.questions) {
					return this.state.questionIndex + 1 == this.props.questions.length;
				}
			}
		}, {
			key: "getPhase",
			value: function getPhase() {
				// if we are loading and on the final question, we have just submitted our final answer
				if (this.isLastQuestion() && (this.isLoading(true) || !this.props.quiz.draft)) {
					return this.props.questions.length + 1;
				} else {
					return this.state.questionIndex + 1;
				}
			}
	
			//we want a method to call when we are done answering the text variety section
			//It should call create quiz
	
		}, {
			key: "submitTextVariety",
			value: function submitTextVariety(data) {
				if (!this.props.quiz) {
					this.props.createNewQuiz({ text_variety: data.value });
				} else if (_.isEmpty(this.props.quiz.answers)) {
					this.props.createQuizAnswers(this.quizID(), { text_variety: data.value });
				}
			}
		}, {
			key: "getUpdatedAnswers",
			value: function getUpdatedAnswers(currentAnswerText, autograderData) {
				var answer = this.props.answers[this.state.questionIndex];
	
				var updatedAnswer = _.extend({}, answer, {
					body: currentAnswerText, autograderData: autograderData
				});
				var updatedAnswerList = _.clone(this.props.answers);
				updatedAnswerList[this.state.questionIndex] = updatedAnswer;
	
				return updatedAnswerList;
			}
		}, {
			key: "onAnswerComplete",
			value: function onAnswerComplete() {
				var _this2 = this;
	
				if (this.isLoading()) {
					return;
				}
	
				this.setState({ answerSaving: true }, function () {
					_this2.saveCurrentAnswer(function (success) {
						if (success) {
							if (_this2.isLastQuestion()) {
								_this2.finalizeQuiz();
							} else {
								_this2.toNextQuestion();
							}
						} else {
							// There was an error saving, let the user try again
							_this2.setState({ answerSaving: false });
						}
					});
				});
			}
		}, {
			key: "hasEmptyParts",
			value: function hasEmptyParts(answer) {
				var answerParts = answer.parts;
				if (!answerParts) {
					return true;
				}
				return _.any(answerParts, function (part) {
					return !part.text || part.text.trim().length == 0;
				});
			}
		}, {
			key: "saveCurrentAnswer",
			value: function saveCurrentAnswer(callback) {
				var answer = this.props.answers[this.state.questionIndex];
	
				if (answer.sessionMetaData) {
					if (_.isEmpty(answer.meta_data)) {
						// First time saving the answer; Make a new meta data array
						var metaData = [answer.sessionMetaData];
					} else {
						var metaData = _.clone(answer.meta_data);
						if (_.last(metaData).session_start != answer.sessionMetaData.session_start) {
							// First time saving the answer this session, but was loaded from draft
							// Push new meta data onto the array
							metaData.push(answer.sessionMetaData);
						} else {
							// Update this session's meta data
							metaData[metaData.length - 1] = answer.sessionMetaData;
						}
					}
				}
	
				var answerData = {
					draft: this.props.quiz.draft,
					parts: answer.localParts || answer.parts,
					meta_data: metaData,
					history: answer.history
				};
	
				var currentAnswerID = answer.id;
				this.props.updateAnswer(currentAnswerID, answerData).then(callback).catch(callback);
			}
		}, {
			key: "autosaveDraft",
			value: function autosaveDraft(callback) {
				var _this3 = this;
	
				this.setState({ autosaveLoading: true }, function () {
					_this3.saveCurrentAnswer(function () {
						_this3.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					});
				});
			}
		}, {
			key: "deleteDraft",
			value: function deleteDraft() {
				window.wrNotifications.triggerDropDownNotification({
					title: "Your draft has been deleted!", text: "", icon: "trash" });
	
				this.props.deleteQuiz(this.quizID());
				$wr.redirect("/");
			}
		}, {
			key: "finalizeQuiz",
			value: function finalizeQuiz() {
				var _this4 = this;
	
				var quizData = {
					draft: false,
					allow_revision: false
				};
	
				// Don't update excluded status if this a revision
				if (!this.props.quiz.allow_revision) {
					quizData.excluded = this.props.shouldExclude;
				}
	
				var queryParams = { autograder_data: {} };
	
				_.each(this.props.answers, function (answer) {
					queryParams.autograder_data[answer.id] = answer.recentAutograderData;
				});
	
				LuckyOrangeClient.tagComponent("completed_quiz");
				this.props.updateQuiz(this.quizID(), quizData, ["quiz.evaluation"], queryParams).then(function (response) {
					var quiz = _.first(response.quizzes);
					if (quiz && quiz.evaluation) {
						if (quiz.evaluation.filtered) {
							var notification = "Quiz Completed.";
						} else {
							var notification = "Great job on that quiz!";
						}
	
						window.wrNotifications.triggerDropDownNotification({
							title: "Done!", text: notification, icon: "star" });
					}
	
					var params = "?showDetails=true";
	
					CurrentUser.fetchCurrentUserCoinData();
					$wr.redirect(MyShelfRouting.getPath({
						activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
						detailsView: "quizzes",
						textID: _this4.textID()
					}) + params);
				});
			}
		}, {
			key: "toNextQuestion",
			value: function toNextQuestion() {
				this.setState({
					questionIndex: this.state.questionIndex + 1,
					answerSaving: false
				});
			}
		}, {
			key: "quizLevel",
			value: function quizLevel() {
				if (this.props.quiz) {
					return GradeLevel.getQuizLevel(this.props.quiz.grade_level);
				}
			}
		}, {
			key: "iconPathStems",
			value: function iconPathStems() {
				var stems = [];
				var answers = this.props.answers;
	
				// Note that these icon images aren't named what they currently do
	
				if (answers == null || answers.length == 0) {
					if (CurrentUser.isPremiumOrTrialAccount()) {
						_.times(this.props.userPrefs.recall_question_count, function () {
							stems.push("quiz-icons/open-ss");
						});
					}
					_.times(this.props.userPrefs.sentence_starter_count, function () {
						stems.push("quiz-icons/open-no-ss");
					});
					_.times(this.props.userPrefs.analysis_question_count, function () {
						stems.push("quiz-icons/open-no-ss");
					});
				} else {
					_.each(answers, function (answer) {
						if (answer.question_type == "fill-in-the-blank-question") {
							stems.push("quiz-icons/open-ss");
						} else if ((answer.parts || []).length > 1) {
							stems.push("quiz-icons/open-no-ss");
						} else {
							stems.push("quiz-icons/open-no-ss");
						}
					});
				}
				return stems;
			}
		}, {
			key: "renderProgressMeter",
			value: function renderProgressMeter() {
				var iconStems = this.iconPathStems();
	
				var studentAvatar = React.createElement(StudentAvatar, { student: CurrentUser.get(), maxWidth: 45, disableAnimation: true });
				return React.createElement(StepProgressMeter, { numSteps: iconStems.length, currentStep: this.getPhase(),
					iconPathStems: iconStems, currentStepDisplay: studentAvatar,
					finishImgPath: "quiz-icons/finish.png" });
			}
		}, {
			key: "renderQuizCurtain",
			value: function renderQuizCurtain() {
				var src = __webpack_require__(150);
				var patchImg = React.createElement("img", { src: src, className: "lockImg" });
				return React.createElement(
					"div",
					{ className: "curtainContainer" },
					React.createElement(
						"div",
						{ className: "curtain" },
						React.createElement(
							"div",
							null,
							patchImg
						),
						React.createElement(
							"p",
							null,
							"Your teacher has restricted you from taking quizzes at this hour.",
							React.createElement("br", null),
							"Wait until the next school day to start a quiz."
						)
					)
				);
			}
		}, {
			key: "render",
			value: function render() {
				//loadBook => false as to not send double request to matilda
				var bookHeader = React.createElement(
					"header",
					{ className: "pageHeader" },
					React.createElement(
						"h1",
						null,
						React.createElement(BookDisplay, { textID: this.textID(), loadBook: false })
					)
				);
				var progressMeter = this.renderProgressMeter();
	
				var quizLevel = this.quizLevel();
	
				// ASK FOR TEXT VARIETY TO TRIGGER QUIZ AND ANSWERS CREATION
				if (this.props.book && !this.props.book.text_variety) {
					var pageContent = React.createElement(
						"div",
						{ className: "textVariety" },
						React.createElement(
							"header",
							{ className: "pageHeader" },
							React.createElement(
								"h1",
								null,
								"Select a Book Type"
							)
						),
						React.createElement(BookTextVariety, { book: this.props.book, onSelect: this.submitTextVariety.bind(this) })
					);
				} else if (!this.quizID()) {
					// Waiting for the quiz to load 
					var pageContent = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else if (_.isEmpty(this.props.questions) || _.isEmpty(this.props.answers)) {
					// We just finished the warm up phase and are waiting to load questions and answers
					var pageContent = React.createElement(Spinner, { placeholder: true, scale: 1.7 });
				} else {
					var showAnswerProgress = !CurrentUser.get().account.web_demo;
					var hasMoreQuestions = this.props.questions.length != this.state.questionIndex + 1;
					var answer = this.props.answers[this.state.questionIndex];
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(Autosaver, { key: "open-ended", textID: this.textID(),
							onDeleteClick: this.deleteDraft,
							autosaveLoading: this.isLoading(),
							getAutosaveHash: this.getAutosaveHash,
							onAutosave: this.autosaveDraft }),
						React.createElement(AnswerWritingInterface, { answerID: answer.id,
							loading: this.isLoading(true),
							onQuestionChange: this.changeQuestion,
							hasMoreQuestions: hasMoreQuestions,
							onComplete: this.onAnswerComplete,
							requestFeedbackOnQuestionChange: true,
							showAnswerLengthMeter: true,
							questionIndex: this.state.questionIndex })
					);
				}
	
				// var triggerOnboarding = ($wr.getURLParameterByName("first") == "true");
				// if (triggerOnboarding) {
				// 	var redirectPath = this.props.location.pathname + "?text_id=" + this.textID();
				// 	var studentOnboardingModal = <StudentOnboardingModal writingTriggered={ true }
				// 		redirectPath={ redirectPath } />;
				// }
				if (!this.props.canTakeQuiz) {
					var content = this.renderQuizCurtain();
				} else {
					var content = React.createElement(
						"div",
						null,
						progressMeter,
						pageContent
					);
				}
				return React.createElement(
					"div",
					{ className: "container quizPage" },
					bookHeader,
					content
				);
				//{ studentOnboardingModal }
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.props.populateData) {
					this.props.populateData();
				}
			}
	
			// Loads a new question for quiz with same question params as old question
	
		}, {
			key: "changeQuestion",
			value: function changeQuestion() {
				var _this5 = this;
	
				var oldQuestion = this.props.questions[this.state.questionIndex];
				var currentQuestionIDs = _.uniq(_.pluck(this.props.questions, "id"));
	
				var hasStarters = (this.props.answers[this.state.questionIndex].parts || []).length > 1;
	
				var questionQuery = {
					sample: 1,
					types: oldQuestion.type,
					text_varieties: this.props.quiz.text_variety,
					grade_levels: this.props.quiz.grade_level,
					exclude_ids: currentQuestionIDs.join(","),
					with_starter: hasStarters
				};
	
				if (oldQuestion.type == "generic-question") {
					questionQuery.skillsets = oldQuestion.skillset;
				} else {
					questionQuery.text_id = oldQuestion.text_id;
				}
	
				var embeds = ["question.starters", "question.answer_options", "question.initial_answer_parts"];
				this.props.getNewQuestion(questionQuery, embeds).then(function (response) {
					var newQuestion = response.questions[0];
					if (!newQuestion) {
						window.wrNotifications.triggerDropDownNotification({
							text: "Sorry! This is the only question option right now.", icon: "exclamation-sign" });
						return;
					}
	
					var answerData = {
						draft: _this5.props.quiz.draft,
						allow_revision: _this5.props.quiz.allow_revision,
						question_id: newQuestion.id, meta_data: null,
						parts: newQuestion.initial_answer_parts,
						localParts: null,
						sessionMetaData: null, recentAutograderData: null
					};
	
					var currentAnswerID = _this5.props.answers[_this5.state.questionIndex].id;
	
					_this5.props.updateAnswer(currentAnswerID, answerData);
				});
			}
		}, {
			key: "getAutosaveHash",
			value: function getAutosaveHash() {
				var answer = this.props.answers[this.state.questionIndex];
				var question = this.props.questions[this.state.questionIndex];
	
				var hashString = _.pluck(answer.localParts, "text").join("|");
				hashString += "|" + question.body;
				hashString += "|" + JSON.stringify(answer.sessionMetaData);
				hashString += "|" + JSON.stringify(answer.recentAutograderData);
	
				var hashValue = $wr.hashCode(hashString);
	
				return hashValue;
			}
		}]);
	
		return QuizPage;
	}(React.Component)) || _class);
	;
	
	QuizPage.WrappedComponent.propTypes = PageStrictPropTypes({
	
		// Data from @connect
		quiz: PropTypes.object,
		answers: PropTypes.array,
		questions: PropTypes.array,
		book: PropTypes.object,
		loading: PropTypes.bool,
		userPrefs: PropTypes.object,
		shouldExclude: PropTypes.bool,
		canStudentTakeQuiz: PropTypes.bool,
	
		// Handlers from @connect
		populateData: PropTypes.func.isRequired,
	
		updateQuiz: PropTypes.func.isRequired,
		createQuizAnswers: PropTypes.func.isRequired,
		deleteQuiz: PropTypes.func.isRequired,
		getNewQuestion: PropTypes.func.isRequired,
		createNewQuiz: PropTypes.func.isRequired,
	
		updateAnswer: PropTypes.func.isRequired
	});
	
	module.exports = QuizPage;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionCharactersQuestion = function (_React$Component) {
		_inherits(FictionCharactersQuestion, _React$Component);
	
		function FictionCharactersQuestion(props) {
			_classCallCheck(this, FictionCharactersQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionCharactersQuestion.__proto__ || Object.getPrototypeOf(FictionCharactersQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionCharactersQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionCharactersQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [NUM_CHARS_STAGE];
				}
	
				var numChars = answers[NUM_CHARS];
				if (numChars == "0") {
					return [NUM_CHARS_STAGE, true];
				}
	
				if (!answers[CHAR1_NAME]) {
					return [CHAR1_NAME_STAGE];
				}
	
				if (!answers[CHAR1_TRAIT]) {
					return [CHAR1_TRAIT_STAGE];
				} else if (this.props.level == "1" || this.props.level == "2" && numChars == "1") {
					return [CHAR1_TRAIT_STAGE, true];
				}
	
				if (this.props.level == "3" && !answers[CHAR1_GOAL]) {
					return [CHAR1_GOAL_STAGE];
				} else if (this.props.level == "3" && numChars == "1") {
					return [CHAR1_GOAL_STAGE, true];
				}
	
				if (!answers[CHAR2_NAME]) {
					return [CHAR2_NAME_STAGE];
				}
				if (!answers[CHAR2_REL]) {
					return [CHAR2_REL_STAGE];
				}
				if (!answers[CHAR2_TRAIT]) {
					return [CHAR2_TRAIT_STAGE];
				}
	
				return [CHAR2_TRAIT_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var numCharsDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", NUM_CHARS_STAGE),
					this.props.renderDropdownF("choices1", NUM_CHARS_STAGE, NUM_CHARS, [NUM_CHARS]),
					this.props.getTextF("label2", NUM_CHARS_STAGE),
					"."
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var char1NameDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR1_NAME_STAGE),
						this.props.renderInputF(CHAR1_NAME)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;
	
					var char1TraitDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR1_TRAIT_STAGE, replacementsHash),
						this.props.renderMultiSelectF("choices1", CHAR1_TRAIT_STAGE, CHAR1_TRAIT, 1)
					);
				}
	
				// goal is only for level 3
				if (_.indexOf(STAGES, stage) > 2 && this.props.level == "3") {
					var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;
	
					var char1GoalDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR1_GOAL_STAGE, replacementsHash),
						this.props.renderDropdownF("choices1", CHAR1_GOAL_STAGE, CHAR1_GOAL)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 3) {
					var char2NameDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR2_NAME_STAGE),
						this.props.renderInputF(CHAR2_NAME)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 4) {
					var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;
	
					var char2RelDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR2_REL_STAGE, replacementsHash),
						this.props.renderDropdownF("choices1", CHAR2_REL_STAGE, CHAR2_REL)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 5) {
					var char2Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR2_NAME];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.CHAR2_NAME] = char2Name;
	
					var char2TraitDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHAR2_TRAIT_STAGE, replacementsHash),
						this.props.renderMultiSelectF("choices1", CHAR2_TRAIT_STAGE, CHAR2_TRAIT, 1)
					);
				}
	
				return React.createElement(
					"div",
					null,
					numCharsDisplay,
					char1NameDisplay,
					char1TraitDisplay,
					char1GoalDisplay,
					char2NameDisplay,
					char2RelDisplay,
					char2TraitDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionCharactersQuestion;
	}(React.Component);
	
	FictionCharactersQuestion.STEM = "fchar";
	
	// stages
	var NUM_CHARS_STAGE = "numchars";
	var CHAR1_NAME_STAGE = "char1name";
	var CHAR1_TRAIT_STAGE = "char1trait";
	var CHAR1_GOAL_STAGE = "char1goal";
	var CHAR2_NAME_STAGE = "char2name";
	var CHAR2_REL_STAGE = "char2rel";
	var CHAR2_TRAIT_STAGE = "char2trait";
	
	var STAGES = [NUM_CHARS_STAGE, CHAR1_NAME_STAGE, CHAR1_TRAIT_STAGE, CHAR1_GOAL_STAGE, CHAR2_NAME_STAGE, CHAR2_REL_STAGE, CHAR2_TRAIT_STAGE];
	
	// answer keys
	var NUM_CHARS = "num_characters";
	var CHAR1_NAME = "character_1_name";
	var CHAR1_TRAIT = "character_1_trait";
	var CHAR1_GOAL = "character_1_goal";
	var CHAR2_NAME = "character_2_name";
	var CHAR2_REL = "character_2_relation";
	var CHAR2_TRAIT = "character_2_trait";
	
	FictionCharactersQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionCharactersQuestion;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionComparisonQuestion = function (_React$Component) {
		_inherits(FictionComparisonQuestion, _React$Component);
	
		function FictionComparisonQuestion(props) {
			_classCallCheck(this, FictionComparisonQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionComparisonQuestion.__proto__ || Object.getPrototypeOf(FictionComparisonQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionComparisonQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionComparisonQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [DIAGNOSIS_STAGE];
				}
	
				if (!answers[HAS_READ_TEXT]) {
					return [DIAGNOSIS_STAGE];
				}
	
				if (answers[HAS_READ_TEXT].includes("no")) {
					return [DIAGNOSIS_STAGE, true];
				}
	
				if (!answers[COMP_TEXT_TITLE]) {
					return [OTHER_TEXT_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[CHAR_COMP]) {
						return [ELEMENTS_STAGE];
					} else {
						return [ELEMENTS_STAGE, true];
					}
				}
	
				if (this.props.level == "2") {
					if (!answers[SETTING_COMP] || !answers[PLOT_COMP] || !answers[THEME_COMP]) {
						return [ELEMENTS_STAGE];
					} else {
						return [ELEMENTS_STAGE, true];
					}
				}
	
				if (!answers[SIMILAR_ELEMENT]) {
					return [ELEMENTS_STAGE];
				}
	
				if (!answers[SIMILAR_ELEMENT_DESC]) {
					return [DESCRIPTION_STAGE];
				} else {
					return [DESCRIPTION_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var diagnosisDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", DIAGNOSIS_STAGE),
					this.props.renderDropdownF("choices1", DIAGNOSIS_STAGE, HAS_READ_TEXT, [HAS_READ_TEXT])
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var otherTextDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", OTHER_TEXT_STAGE),
						this.props.renderInputF(COMP_TEXT_TITLE, [HAS_READ_TEXT, COMP_TEXT_TITLE])
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					if (this.props.level != "3") {
						var selectedText = this.props.answers[FictionComparisonQuestion.STEM][COMP_TEXT_TITLE];
						var elementsReplacementsHash = {};
						elementsReplacementsHash[WarmupQuestions.SELECTED_TEXT] = selectedText;
	
						if (this.props.level == "2") {
							var additionalLevel2Elements = React.createElement(
								"span",
								null,
								React.createElement("br", null),
								this.props.getTextF("label3", ELEMENTS_STAGE),
								this.props.renderDropdownF("choices1", ELEMENTS_STAGE, PLOT_COMP),
								this.props.getTextF("label4", ELEMENTS_STAGE, elementsReplacementsHash),
								".",
								React.createElement("br", null),
								this.props.getTextF("label5", ELEMENTS_STAGE),
								this.props.renderDropdownF("choices5", ELEMENTS_STAGE, THEME_COMP),
								this.props.getTextF("label6", ELEMENTS_STAGE, elementsReplacementsHash),
								"."
							);
						}
	
						var additionalElementsDisplay = React.createElement(
							"span",
							null,
							this.props.getTextF("label2", ELEMENTS_STAGE, elementsReplacementsHash),
							".",
							additionalLevel2Elements
						);
					}
	
					if (this.props.level == "1") {
						var answerKey = CHAR_COMP;
					} else if (this.props.level == "2") {
						var answerKey = SETTING_COMP;
					} else {
						var answerKey = SIMILAR_ELEMENT;
					}
	
					var elementsDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", ELEMENTS_STAGE),
						this.props.renderDropdownF("choices1", ELEMENTS_STAGE, answerKey),
						additionalElementsDisplay
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var similarElement = this.props.answers[FictionComparisonQuestion.STEM][SIMILAR_ELEMENT];
					var descriptionReplacementsHash = {};
					descriptionReplacementsHash[WarmupQuestions.SIMILAR_ELEMENT] = similarElement;
	
					var descriptionDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIPTION_STAGE, descriptionReplacementsHash),
						this.props.renderInputF(SIMILAR_ELEMENT_DESC)
					);
				}
	
				return React.createElement(
					"div",
					null,
					diagnosisDisplay,
					otherTextDisplay,
					elementsDisplay,
					descriptionDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionComparisonQuestion;
	}(React.Component);
	
	FictionComparisonQuestion.STEM = "fcomp";
	
	// stages
	var DIAGNOSIS_STAGE = "diagnosis";
	var OTHER_TEXT_STAGE = "othertext";
	var ELEMENTS_STAGE = "elements";
	var DESCRIPTION_STAGE = "describe";
	
	var STAGES = [DIAGNOSIS_STAGE, OTHER_TEXT_STAGE, ELEMENTS_STAGE, DESCRIPTION_STAGE];
	
	// answer keys
	var HAS_READ_TEXT = "has_read_comp_text";
	var COMP_TEXT_TITLE = "comp_text_title";
	var CHAR_COMP = "character_comparison";
	var SETTING_COMP = "setting_comparison";
	var PLOT_COMP = "plot_comparison";
	var THEME_COMP = "theme_comparison";
	var SIMILAR_ELEMENT = "similar_element";
	var SIMILAR_ELEMENT_DESC = "similar_element_description";
	
	FictionComparisonQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionComparisonQuestion;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionEmotionQuestion = function (_React$Component) {
		_inherits(FictionEmotionQuestion, _React$Component);
	
		function FictionEmotionQuestion(props) {
			_classCallCheck(this, FictionEmotionQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionEmotionQuestion.__proto__ || Object.getPrototypeOf(FictionEmotionQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionEmotionQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionEmotionQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [BEGINNING_STAGE];
				}
	
				if (this.props.level != "3" && !answers[BEGINNING] || this.props.level == "3" && !answers[RISING_ACTION]) {
					return [BEGINNING_STAGE];
				}
	
				if (this.props.level == "2" && !answers[MIDDLE] || this.props.level == "3" && !answers[CLIMAX]) {
					return [MIDDLE_STAGE];
				}
	
				if (this.props.level != "3") {
					if (!answers[END]) {
						return [END_STAGE];
					} else if (this.props.level == "1") {
						return [END_STAGE, true];
					}
				} else {
					if (!answers[FALLING_ACTION]) {
						return [FALLING_ACTION_STAGE];
					}
					if (!answers[RESOLUTION]) {
						return [END_STAGE];
					}
				}
	
				if (!answers[OVERALL]) {
					return [OVERALL_STAGE];
				} else {
					return [OVERALL_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var beginningKey = this.props.level == "3" ? RISING_ACTION : BEGINNING;
				var beginningDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", BEGINNING_STAGE),
					this.props.renderMultiSelectF("choices1", BEGINNING_STAGE, beginningKey, 1),
					"."
				);
	
				if (_.indexOf(STAGES, stage) > 0 && this.props.level != "1") {
					var middleKey = this.props.level == "3" ? CLIMAX : MIDDLE;
					var middleDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", MIDDLE_STAGE),
						this.props.renderMultiSelectF("choices1", MIDDLE_STAGE, middleKey, 1),
						"."
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1 && this.props.level == "3") {
					var fallingActionDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", FALLING_ACTION_STAGE),
						this.props.renderMultiSelectF("choices1", FALLING_ACTION_STAGE, FALLING_ACTION, 1),
						"."
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var endKey = this.props.level == "3" ? RESOLUTION : END;
					var endDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", END_STAGE),
						this.props.renderMultiSelectF("choices1", END_STAGE, endKey, 1),
						"."
					);
				}
	
				if (_.indexOf(STAGES, stage) > 3) {
					var overallDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", OVERALL_STAGE),
						this.props.renderMultiSelectF("choices1", OVERALL_STAGE, OVERALL, 1),
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					beginningDisplay,
					middleDisplay,
					fallingActionDisplay,
					endDisplay,
					overallDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionEmotionQuestion;
	}(React.Component);
	
	FictionEmotionQuestion.STEM = "femo";
	
	// stages
	var BEGINNING_STAGE = "beginning";
	var MIDDLE_STAGE = "middle";
	var FALLING_ACTION_STAGE = "fallingaction";
	var END_STAGE = "end";
	var OVERALL_STAGE = "overall";
	
	var STAGES = [BEGINNING_STAGE, MIDDLE_STAGE, FALLING_ACTION_STAGE, END_STAGE, OVERALL_STAGE];
	
	// answer keys
	var BEGINNING = "beginning_feeling";
	var MIDDLE = "middle_feeling";
	var END = "end_feeling";
	var RISING_ACTION = "rising_action_feeling";
	var CLIMAX = "climax_feeling";
	var FALLING_ACTION = "falling_action_feeling";
	var RESOLUTION = "resolution_feeling";
	var OVERALL = "overall_feeling";
	
	FictionEmotionQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionEmotionQuestion;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionMainIdeasQuestion = function (_React$Component) {
		_inherits(FictionMainIdeasQuestion, _React$Component);
	
		function FictionMainIdeasQuestion(props) {
			_classCallCheck(this, FictionMainIdeasQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionMainIdeasQuestion.__proto__ || Object.getPrototypeOf(FictionMainIdeasQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionMainIdeasQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionMainIdeasQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [MAIN_IDEA_1_STAGE];
				}
	
				if (!answers[MAIN_IDEA_1]) {
					return [MAIN_IDEA_1_STAGE];
				}
	
				if (this.props.level != "3") {
					return [MAIN_IDEA_1_STAGE, true];
				} else if (!answers[MAIN_IDEA_2]) {
					return [MAIN_IDEA_2_STAGE];
				} else {
					return [MAIN_IDEA_2_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var mainIdea1Display = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", MAIN_IDEA_1_STAGE),
					this.props.renderInputF(MAIN_IDEA_1)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var mainIdea2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", MAIN_IDEA_2_STAGE),
						this.props.renderInputF(MAIN_IDEA_2)
					);
				}
	
				return React.createElement(
					"div",
					null,
					mainIdea1Display,
					mainIdea2Display,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionMainIdeasQuestion;
	}(React.Component);
	
	FictionMainIdeasQuestion.STEM = "fmain";
	
	// stages
	var MAIN_IDEA_1_STAGE = "mainidea1";
	var MAIN_IDEA_2_STAGE = "mainidea2";
	
	var STAGES = [MAIN_IDEA_1_STAGE, MAIN_IDEA_2_STAGE];
	
	// answer keys
	var MAIN_IDEA_1 = "main_idea_1";
	var MAIN_IDEA_2 = "main_idea_2";
	
	FictionMainIdeasQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionMainIdeasQuestion;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var FictionOrganizationQuestion = function (_React$Component) {
		_inherits(FictionOrganizationQuestion, _React$Component);
	
		function FictionOrganizationQuestion(props) {
			_classCallCheck(this, FictionOrganizationQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionOrganizationQuestion.__proto__ || Object.getPrototypeOf(FictionOrganizationQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionOrganizationQuestion, [{
			key: "isPictureBook",
			value: function isPictureBook() {
				if (this.props.answers[TopicQuestion.STEM]) {
					return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";
				}
			}
		}, {
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionOrganizationQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [NUM_PAGES_STAGE];
				}
	
				if (!answers[NUM_PAGES] || answers[NUM_PAGES] < 1 || this.isPictureBook() && !answers[SEL_PIECE_NUMBER]) {
					return [NUM_PAGES_STAGE];
				}
	
				if (!this.isPictureBook() && (!answers[NUM_PIECES] || !answers[PIECE_TYPE] || !answers[SEL_PIECE_NUMBER] || answers[NUM_PIECES] < 1)) {
					return [ORG_STRUCTURE_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[SEL_PIECE_DESCRIPTION]) {
						return [RANDOM_PIECE_STAGE];
					} else {
						return [RANDOM_PIECE_STAGE, true];
					}
				}
	
				if (!answers[SEL_PIECE_TIMING] || !answers[SEL_PIECE_CHAR] || !answers[SEL_PIECE_ACTION]) {
					return [RANDOM_PIECE_STAGE];
				} else if (this.props.level == "2") {
					return [RANDOM_PIECE_STAGE, true];
				}
	
				if (!answers[SEL_PIECE_STORY_PART]) {
					return [RANDOM_PIECE_PART_STAGE];
				} else {
					return [RANDOM_PIECE_PART_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var numPagesDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", NUM_PAGES_STAGE),
					this.props.renderInputF(NUM_PAGES, null, "number"),
					this.props.getTextF("label2", NUM_PAGES_STAGE),
					"."
				);
	
				if (_.indexOf(STAGES, stage) > 0 && !this.isPictureBook()) {
					var orgStructureDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", ORG_STRUCTURE_STAGE),
						this.props.renderInputF(NUM_PIECES, null, "number"),
						this.props.renderDropdownF("choices1", ORG_STRUCTURE_STAGE, PIECE_TYPE, [NUM_PAGES, NUM_PIECES, SEL_PIECE_NUMBER]),
						"."
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var answers = this.props.answers[FictionOrganizationQuestion.STEM];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.ORG_PIECE] = this.isPictureBook() ? "page" : answers[PIECE_TYPE].slice(0, -1);
					replacementsHash[WarmupQuestions.ORG_PIECE_NUMBER] = answers[SEL_PIECE_NUMBER];
	
					if (this.props.level == "1") {
						var randomPieceInputs = this.props.renderInputF(SEL_PIECE_DESCRIPTION);
					} else {
						var randomPieceInputs = React.createElement(
							"span",
							null,
							this.props.renderDropdownF("choices1", RANDOM_PIECE_STAGE, SEL_PIECE_TIMING),
							this.props.getTextF("label2", RANDOM_PIECE_STAGE),
							React.createElement("br", null),
							React.createElement(
								"div",
								{ className: "inputGroup" },
								this.props.renderInputF(SEL_PIECE_CHAR),
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "subtext" },
									this.props.getTextF("label3", RANDOM_PIECE_STAGE)
								)
							),
							React.createElement(
								"div",
								{ className: "inputGroup" },
								this.props.renderInputF(SEL_PIECE_ACTION),
								React.createElement("br", null),
								React.createElement(
									"span",
									{ className: "subtext" },
									this.props.getTextF("label4", RANDOM_PIECE_STAGE)
								)
							)
						);
					}
					var randomPieceDisplay = React.createElement(
						"div",
						null,
						$wr.capitalize(this.props.getTextF("label1", RANDOM_PIECE_STAGE, replacementsHash)),
						randomPieceInputs
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var randomPiecePartDisplay = React.createElement(
						"div",
						null,
						$wr.capitalize(this.props.getTextF("label1", RANDOM_PIECE_PART_STAGE, replacementsHash)),
						this.props.renderDropdownF("choices1", RANDOM_PIECE_PART_STAGE, SEL_PIECE_STORY_PART),
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					numPagesDisplay,
					orgStructureDisplay,
					randomPieceDisplay,
					randomPiecePartDisplay,
					finishButtonDisplay
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(oldProps) {
				var oldAnswers = oldProps.answers[FictionOrganizationQuestion.STEM];
				var newAnswers = this.props.answers[FictionOrganizationQuestion.STEM];
				if (oldAnswers && newAnswers) {
					if (this.isPictureBook()) {
						var optionKey = NUM_PAGES;
					} else {
						var optionKey = NUM_PIECES;
					}
	
					if (newAnswers[optionKey] && oldAnswers[optionKey] != newAnswers[optionKey]) {
						var options = [];
						for (var i = 1; i <= parseInt(newAnswers[optionKey]); i++) {
							options.push(i.toString());
						}
	
						this.props.pickRandomOptionF(SEL_PIECE_NUMBER, options);
					}
				}
			}
		}]);
	
		return FictionOrganizationQuestion;
	}(React.Component);
	
	FictionOrganizationQuestion.STEM = "forg";
	
	// stages
	var NUM_PAGES_STAGE = "numpages";
	var ORG_STRUCTURE_STAGE = "orgstructure";
	var RANDOM_PIECE_STAGE = "randompiece";
	var RANDOM_PIECE_PART_STAGE = "randompiecepart";
	
	var STAGES = [NUM_PAGES_STAGE, ORG_STRUCTURE_STAGE, RANDOM_PIECE_STAGE, RANDOM_PIECE_PART_STAGE];
	
	// answer keys
	var NUM_PAGES = "num_pages";
	var NUM_PIECES = "num_pieces";
	var PIECE_TYPE = "piece_type";
	var SEL_PIECE_NUMBER = "selected_piece_number";
	var SEL_PIECE_DESCRIPTION = "selected_piece_description";
	var SEL_PIECE_TIMING = "selected_piece_timing";
	var SEL_PIECE_CHAR = "selected_piece_character";
	var SEL_PIECE_ACTION = "selected_piece_action";
	var SEL_PIECE_STORY_PART = "selected_piece_story_part";
	
	FictionOrganizationQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired,
		pickRandomOptionF: PropTypes.func.isRequired
	});
	
	module.exports = FictionOrganizationQuestion;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionPicturesQuestion = function (_React$Component) {
		_inherits(FictionPicturesQuestion, _React$Component);
	
		function FictionPicturesQuestion(props) {
			_classCallCheck(this, FictionPicturesQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionPicturesQuestion.__proto__ || Object.getPrototypeOf(FictionPicturesQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionPicturesQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionPicturesQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [NUM_PICS_STAGE];
				}
	
				var numPics = answers[NUM_PICS];
				if (numPics == "0") {
					return [NUM_PICS_STAGE, true];
				}
	
				if (!answers[PIC1_DESC] || this.props.level != "1" && !answers[PIC1_ADJ]) {
					return [PIC1_STAGE];
				} else if (numPics == "1") {
					return [PIC1_STAGE, true];
				}
	
				if (!answers[PIC2_DESC] || this.props.level != "1" && !answers[PIC2_ADJ]) {
					return [PIC2_STAGE];
				}
	
				return [PIC2_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var numPicsDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", NUM_PICS_STAGE),
					this.props.renderDropdownF("choices1", NUM_PICS_STAGE, NUM_PICS, [NUM_PICS]),
					this.props.getTextF("label2", NUM_PICS_STAGE),
					"."
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					if (this.props.level != "1") {
						var additionalPic1Display = React.createElement(
							"div",
							null,
							this.props.getTextF("label2", PIC1_STAGE),
							this.props.renderMultiSelectF("choices2", PIC1_STAGE, PIC1_ADJ, 1)
						);
					}
	
					var pic1Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", PIC1_STAGE),
						this.props.renderInputF(PIC1_DESC),
						additionalPic1Display
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					if (this.props.level != "1") {
						var additionalPic2Display = React.createElement(
							"div",
							null,
							this.props.getTextF("label2", PIC2_STAGE),
							this.props.renderMultiSelectF("choices2", PIC2_STAGE, PIC2_ADJ, 1)
						);
					}
	
					var pic2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", PIC2_STAGE),
						this.props.renderInputF(PIC2_DESC),
						additionalPic2Display
					);
				}
	
				return React.createElement(
					"div",
					null,
					numPicsDisplay,
					pic1Display,
					pic2Display,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionPicturesQuestion;
	}(React.Component);
	
	FictionPicturesQuestion.STEM = "fpic";
	
	// stages
	var NUM_PICS_STAGE = "numpics";
	var PIC1_STAGE = "pic1";
	var PIC2_STAGE = "pic2";
	
	var STAGES = [NUM_PICS_STAGE, PIC1_STAGE, PIC2_STAGE];
	
	// answer keys
	var NUM_PICS = "num_pictures";
	var PIC1_DESC = "picture_1_description";
	var PIC1_ADJ = "picture_1_adjective";
	var PIC2_DESC = "picture_2_description";
	var PIC2_ADJ = "picture_2_adjective";
	
	FictionPicturesQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionPicturesQuestion;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionPlotQuestion = function (_React$Component) {
		_inherits(FictionPlotQuestion, _React$Component);
	
		function FictionPlotQuestion(props) {
			_classCallCheck(this, FictionPlotQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionPlotQuestion.__proto__ || Object.getPrototypeOf(FictionPlotQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionPlotQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionPlotQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [EVENT_1_STAGE];
				}
	
				var event1Complete = answers[EVENT_1_CHAR] && answers[EVENT_1_ACTION] && (this.props.level != "3" || answers[EVENT_1_TYPE]);
				var event2Complete = answers[EVENT_2_CHAR] && answers[EVENT_2_ACTION] && (this.props.level != "3" || answers[EVENT_2_TYPE]);
	
				if (!event1Complete) {
					return [EVENT_1_STAGE];
				} else if (!event2Complete) {
					return [EVENT_2_STAGE];
				} else {
					return [EVENT_2_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				if (this.props.level == "3") {
					var event1TypeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label4", EVENT_1_STAGE),
						this.props.renderDropdownF("choices4", EVENT_1_STAGE, EVENT_1_TYPE)
					);
				}
	
				var event1Display = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", EVENT_1_STAGE),
					React.createElement("br", null),
					React.createElement(
						"div",
						{ className: "inputGroup" },
						this.props.renderInputF(EVENT_1_CHAR),
						React.createElement("br", null),
						React.createElement(
							"span",
							{ className: "subtext" },
							this.props.getTextF("label2", EVENT_1_STAGE)
						)
					),
					React.createElement(
						"div",
						{ className: "inputGroup" },
						this.props.renderInputF(EVENT_1_ACTION),
						React.createElement("br", null),
						React.createElement(
							"span",
							{ className: "subtext" },
							this.props.getTextF("label3", EVENT_1_STAGE)
						)
					),
					React.createElement("br", null),
					event1TypeDisplay
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					if (this.props.level == "3") {
						var event2TypeDisplay = React.createElement(
							"div",
							null,
							this.props.getTextF("label4", EVENT_2_STAGE),
							this.props.renderDropdownF("choices4", EVENT_2_STAGE, EVENT_2_TYPE)
						);
					}
	
					var event2Display = React.createElement(
						"div",
						{ className: "topMargin" },
						this.props.getTextF("label1", EVENT_2_STAGE),
						React.createElement("br", null),
						React.createElement(
							"div",
							{ className: "inputGroup" },
							this.props.renderInputF(EVENT_2_CHAR),
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "subtext" },
								this.props.getTextF("label2", EVENT_2_STAGE)
							)
						),
						React.createElement(
							"div",
							{ className: "inputGroup" },
							this.props.renderInputF(EVENT_2_ACTION),
							React.createElement("br", null),
							React.createElement(
								"span",
								{ className: "subtext" },
								this.props.getTextF("label3", EVENT_2_STAGE)
							)
						),
						React.createElement("br", null),
						event2TypeDisplay
					);
				}
	
				return React.createElement(
					"div",
					null,
					event1Display,
					event2Display,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionPlotQuestion;
	}(React.Component);
	
	FictionPlotQuestion.STEM = "fplot";
	
	// stages
	var EVENT_1_STAGE = "event1";
	var EVENT_2_STAGE = "event2";
	
	var STAGES = [EVENT_1_STAGE, EVENT_2_STAGE];
	
	// answer keys
	var EVENT_1_CHAR = "event_1_char";
	var EVENT_1_ACTION = "event_1_action";
	var EVENT_1_TYPE = "event_1_type";
	var EVENT_2_CHAR = "event_2_char";
	var EVENT_2_ACTION = "event_2_action";
	var EVENT_2_TYPE = "event_2_type";
	
	FictionPlotQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionPlotQuestion;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var FictionPointOfViewQuestion = function (_React$Component) {
		_inherits(FictionPointOfViewQuestion, _React$Component);
	
		function FictionPointOfViewQuestion(props) {
			_classCallCheck(this, FictionPointOfViewQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionPointOfViewQuestion.__proto__ || Object.getPrototypeOf(FictionPointOfViewQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionPointOfViewQuestion, [{
			key: "isPictureBook",
			value: function isPictureBook() {
				if (this.props.answers[TopicQuestion.STEM]) {
					return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";
				}
			}
		}, {
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionPointOfViewQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [TYPE_STAGE];
				}
	
				if (!answers[POV_TYPE]) {
					return [TYPE_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[AUTHOR] || this.isPictureBook() && !answers[ILLUSTRATOR]) {
						return [NARRATOR_STAGE];
					} else {
						return [NARRATOR_STAGE, true];
					}
				}
	
				var povType = answers[POV_TYPE];
	
				if (povType.includes("2nd") || this.props.level == "2" && povType.includes("3rd")) {
					return [TYPE_STAGE, true];
				}
	
				if (povType.includes("1st")) {
					if (!answers[NARRATOR]) {
						return [NARRATOR_STAGE];
					} else {
						return [NARRATOR_STAGE, true];
					}
				}
	
				if (!answers[THIRD_PERSON_TYPE]) {
					return [THIRD_PERSON_TYPE_STAGE];
				} else if (!answers[THIRD_PERSON_TYPE].includes("limited")) {
					return [THIRD_PERSON_TYPE_STAGE, true];
				}
	
				if (!answers[THIRD_PERSON_CHAR]) {
					return [THIRD_PERSON_CHAR_STAGE];
				} else {
					return [THIRD_PERSON_CHAR_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var typeDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", TYPE_STAGE),
					this.props.renderDropdownF("choices1", TYPE_STAGE, POV_TYPE, [POV_TYPE]),
					"."
				);
	
				if (_.indexOf(STAGES, stage) == 1) {
					if (this.props.level == "1") {
						var inputKey = AUTHOR;
	
						if (this.isPictureBook()) {
							var illustratorDisplay = React.createElement(
								"div",
								null,
								this.props.getTextF("label2", NARRATOR_STAGE),
								this.props.renderInputF(ILLUSTRATOR)
							);
						}
					} else {
						var inputKey = NARRATOR;
					}
	
					var narratorDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", NARRATOR_STAGE),
						this.props.renderInputF(inputKey),
						illustratorDisplay
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var thirdPersonTypeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", THIRD_PERSON_TYPE_STAGE),
						this.props.renderDropdownF("choices1", THIRD_PERSON_TYPE_STAGE, THIRD_PERSON_TYPE, [POV_TYPE])
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var thirdPersonCharDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", THIRD_PERSON_CHAR_STAGE),
						this.props.renderInputF(THIRD_PERSON_CHAR)
					);
				}
	
				return React.createElement(
					"div",
					null,
					typeDisplay,
					narratorDisplay,
					thirdPersonTypeDisplay,
					thirdPersonCharDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionPointOfViewQuestion;
	}(React.Component);
	
	FictionPointOfViewQuestion.STEM = "fpov";
	
	// stages
	var TYPE_STAGE = "povtype";
	var NARRATOR_STAGE = "narrator";
	var THIRD_PERSON_TYPE_STAGE = "thirdptype";
	var THIRD_PERSON_CHAR_STAGE = "thirdpchar";
	
	var STAGES = [TYPE_STAGE, NARRATOR_STAGE, THIRD_PERSON_TYPE_STAGE, THIRD_PERSON_CHAR_STAGE];
	
	// answer keys
	var POV_TYPE = "pov_type";
	var AUTHOR = "author";
	var ILLUSTRATOR = "illustrator";
	var NARRATOR = "narrator";
	var THIRD_PERSON_TYPE = "third_person_type";
	var THIRD_PERSON_CHAR = "third_person_character";
	
	FictionPointOfViewQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionPointOfViewQuestion;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionSettingQuestion = function (_React$Component) {
		_inherits(FictionSettingQuestion, _React$Component);
	
		function FictionSettingQuestion(props) {
			_classCallCheck(this, FictionSettingQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionSettingQuestion.__proto__ || Object.getPrototypeOf(FictionSettingQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionSettingQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionSettingQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [TIME_STAGE];
				}
	
				if (!answers[TIME]) {
					return [TIME_STAGE];
				}
				if (!answers[PLACE]) {
					return [PLACE_STAGE];
				}
	
				if (this.props.level == "1") {
					return [PLACE_STAGE, true];
				} else if (!answers[DESCRIPTOR]) {
					return [DESCRIPTOR_STAGE];
				} else {
					return [DESCRIPTOR_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				if (this.props.level != "1") {
					var additionalTimeLabel = React.createElement(
						"span",
						null,
						React.createElement("br", null),
						this.props.getTextF("label2", TIME_STAGE)
					);
				}
	
				var timeDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", TIME_STAGE),
					additionalTimeLabel,
					this.props.renderInputF(TIME)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var placeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", PLACE_STAGE),
						this.props.renderInputF(PLACE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var descriptorDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIPTOR_STAGE),
						this.props.renderMultiSelectF("choices1", DESCRIPTOR_STAGE, DESCRIPTOR, 1)
					);
				}
	
				return React.createElement(
					"div",
					null,
					timeDisplay,
					placeDisplay,
					descriptorDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionSettingQuestion;
	}(React.Component);
	
	FictionSettingQuestion.STEM = "fsetting";
	
	// stages
	var TIME_STAGE = "time";
	var PLACE_STAGE = "place";
	var DESCRIPTOR_STAGE = "descriptor";
	
	var STAGES = [TIME_STAGE, PLACE_STAGE, DESCRIPTOR_STAGE];
	
	// answer keys
	var TIME = "time";
	var PLACE = "place";
	var DESCRIPTOR = "descriptor";
	
	FictionSettingQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionSettingQuestion;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var FictionVocabularyQuestion = function (_React$Component) {
		_inherits(FictionVocabularyQuestion, _React$Component);
	
		function FictionVocabularyQuestion(props) {
			_classCallCheck(this, FictionVocabularyQuestion);
	
			var _this = _possibleConstructorReturn(this, (FictionVocabularyQuestion.__proto__ || Object.getPrototypeOf(FictionVocabularyQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(FictionVocabularyQuestion, [{
			key: "isConnotative",
			value: function isConnotative() {
				return this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD_TYPE].includes("connotative");
			}
		}, {
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[FictionVocabularyQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [HARD_WORD_STAGE];
				}
	
				if (!answers[HARD_WORD]) {
					return [HARD_WORD_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[SENSORY_WORD]) {
						return [SPECIAL_WORD_STAGE];
					} else {
						return [SPECIAL_WORD_STAGE, true];
					}
				}
	
				if (!answers[NONLITERAL_WORD]) {
					return [SPECIAL_WORD_STAGE];
				}
	
				if (this.props.level == "2") {
					if (!answers[NONLITERAL_WORD_TYPE]) {
						return [SPECIAL_TYPE_STAGE];
					} else {
						return [SPECIAL_TYPE_STAGE, true];
					}
				}
	
				if (!answers[NONLITERAL_WORD_TYPE]) {
					return [SPECIAL_WORD_STAGE];
				}
	
				if (!answers[LITERAL_MEANING]) {
					return [MEANING_LITERAL_STAGE];
				}
	
				if (!answers[NONLITERAL_MEANING]) {
					return [MEANING_NONLITERAL_STAGE];
				} else {
					return [MEANING_NONLITERAL_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var hardWordDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", HARD_WORD_STAGE),
					this.props.renderInputF(HARD_WORD)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					if (this.props.level == "3") {
						var additionalSpecWordDisplay = React.createElement(
							"span",
							null,
							this.props.renderDropdownF("choices1", SPECIAL_WORD_STAGE, NONLITERAL_WORD_TYPE, [HARD_WORD, NONLITERAL_WORD]),
							this.props.getTextF("label2", SPECIAL_WORD_STAGE)
						);
					}
	
					var answerKey = this.props.level == "1" ? SENSORY_WORD : NONLITERAL_WORD;
					var specialWordDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", SPECIAL_WORD_STAGE),
						additionalSpecWordDisplay,
						this.props.renderInputF(answerKey)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1 && this.props.level == "2") {
					var specialWord = this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.ENTERED_WORD] = specialWord;
	
					var specialTypeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", SPECIAL_TYPE_STAGE, replacementsHash),
						this.props.renderDropdownF("choices1", SPECIAL_TYPE_STAGE, NONLITERAL_WORD_TYPE, [HARD_WORD, NONLITERAL_WORD])
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var specialWord = this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.ENTERED_WORD] = specialWord;
	
					var label = this.isConnotative() ? "label1" : "label2";
					var literalMeaningDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF(label, MEANING_LITERAL_STAGE, replacementsHash),
						this.props.renderInputF(LITERAL_MEANING)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 3) {
					var label = this.isConnotative() ? "label1" : "label2";
					var nonliteralMeaningDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF(label, MEANING_NONLITERAL_STAGE, replacementsHash),
						this.props.renderInputF(NONLITERAL_MEANING)
					);
				}
	
				return React.createElement(
					"div",
					null,
					hardWordDisplay,
					specialWordDisplay,
					specialTypeDisplay,
					literalMeaningDisplay,
					nonliteralMeaningDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return FictionVocabularyQuestion;
	}(React.Component);
	
	FictionVocabularyQuestion.STEM = "fvocab";
	
	// stages
	var HARD_WORD_STAGE = "hardword";
	var SPECIAL_WORD_STAGE = "specialword";
	var SPECIAL_TYPE_STAGE = "specialtype";
	var MEANING_LITERAL_STAGE = "meaningliteral";
	var MEANING_NONLITERAL_STAGE = "meaningnonliteral";
	
	var STAGES = [HARD_WORD_STAGE, SPECIAL_WORD_STAGE, SPECIAL_TYPE_STAGE, MEANING_LITERAL_STAGE, MEANING_NONLITERAL_STAGE];
	
	// answer keys
	var HARD_WORD = "hard_word";
	var SENSORY_WORD = "sensory_word";
	var NONLITERAL_WORD = "nonliteral_word";
	var NONLITERAL_WORD_TYPE = "nonliteral_word_type";
	var LITERAL_MEANING = "literal_meaning";
	var NONLITERAL_MEANING = "nonliteral_meaning";
	
	FictionVocabularyQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = FictionVocabularyQuestion;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var NonFictionArgumentsQuestion = function (_React$Component) {
		_inherits(NonFictionArgumentsQuestion, _React$Component);
	
		function NonFictionArgumentsQuestion(props) {
			_classCallCheck(this, NonFictionArgumentsQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionArgumentsQuestion.__proto__ || Object.getPrototypeOf(NonFictionArgumentsQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionArgumentsQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionArgumentsQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [SPECIFIC_ENTITY_STAGE];
				}
	
				if (!answers[SPECIFIC_ENTITY]) {
					return [SPECIFIC_ENTITY_STAGE];
				}
	
				if (!answers[POINT_SUBJECT] || !answers[POINT_VERB] || !answers[POINT_PREDICATE]) {
					return [POINT_STAGE];
				}
	
				if (this.props.level == "1") {
					return [POINT_STAGE, true];
				}
	
				if (!answers[EVIDENCE_SUBJECT] || !answers[EVIDENCE_VERB] || !answers[EVIDENCE_PREDICATE]) {
					return [EVIDENCE_STAGE];
				}
	
				if (this.props.level == "2") {
					return [EVIDENCE_STAGE, true];
				}
	
				if (!answers[EVIDENCE_TYPE]) {
					return [EVIDENCE_TYPE_STAGE];
				}
	
				return [EVIDENCE_TYPE_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var specificEntityDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", SPECIFIC_ENTITY_STAGE),
					this.props.renderInputF(SPECIFIC_ENTITY)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var specificEntity = this.props.answers[NonFictionArgumentsQuestion.STEM][SPECIFIC_ENTITY];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.SPECIFIC_ENTITY] = specificEntity;
	
					var pointDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", POINT_STAGE, replacementsHash),
						this.props.renderDropdownF("choices1", POINT_STAGE, POINT_SUBJECT),
						this.props.renderDropdownF("choices2", POINT_STAGE, POINT_VERB),
						this.props.renderInputF(POINT_PREDICATE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var evidenceDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", EVIDENCE_STAGE),
						this.props.renderDropdownF("choices1", EVIDENCE_STAGE, EVIDENCE_SUBJECT),
						this.props.renderDropdownF("choices2", EVIDENCE_STAGE, EVIDENCE_VERB),
						this.props.renderInputF(EVIDENCE_PREDICATE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var evidenceTypeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", EVIDENCE_TYPE_STAGE),
						this.props.renderDropdownF("choices1", EVIDENCE_TYPE_STAGE, EVIDENCE_TYPE),
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					specificEntityDisplay,
					pointDisplay,
					evidenceDisplay,
					evidenceTypeDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionArgumentsQuestion;
	}(React.Component);
	
	NonFictionArgumentsQuestion.STEM = "nfarg";
	
	// stages
	var SPECIFIC_ENTITY_STAGE = "specificentity";
	var POINT_STAGE = "point";
	var EVIDENCE_STAGE = "evidence";
	var EVIDENCE_TYPE_STAGE = "evidencetype";
	
	var STAGES = [SPECIFIC_ENTITY_STAGE, POINT_STAGE, EVIDENCE_STAGE, EVIDENCE_TYPE_STAGE];
	
	// answer keys
	var SPECIFIC_ENTITY = "specific_entity";
	var POINT_SUBJECT = "point_subject";
	var POINT_VERB = "point_verb";
	var POINT_PREDICATE = "point_predicate";
	var EVIDENCE_SUBJECT = "evidence_subject";
	var EVIDENCE_VERB = "evidence_verb";
	var EVIDENCE_PREDICATE = "evidence_predicate";
	var EVIDENCE_TYPE = "evidence_type";
	
	NonFictionArgumentsQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionArgumentsQuestion;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var NonFictionComparisonQuestion = function (_React$Component) {
		_inherits(NonFictionComparisonQuestion, _React$Component);
	
		function NonFictionComparisonQuestion(props) {
			_classCallCheck(this, NonFictionComparisonQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionComparisonQuestion.__proto__ || Object.getPrototypeOf(NonFictionComparisonQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionComparisonQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionComparisonQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [DIAGNOSIS_STAGE];
				}
	
				if (!answers[HAS_READ_TEXT]) {
					return [DIAGNOSIS_STAGE];
				}
	
				if (answers[HAS_READ_TEXT].includes("no")) {
					return [DIAGNOSIS_STAGE, true];
				}
	
				if (!answers[COMP_TEXT_TITLE]) {
					return [OTHER_TEXT_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[TOPIC_COMP]) {
						return [ELEMENTS_STAGE];
					} else {
						return [ELEMENTS_STAGE, true];
					}
				}
	
				if (!answers[SIMILAR_ELEMENT]) {
					return [ELEMENTS_STAGE];
				}
	
				if (this.props.level == "2") {
					return [ELEMENTS_STAGE, true];
				}
	
				if (!answers[SIMILAR_ELEMENT_DESC]) {
					return [DESCRIPTION_STAGE];
				}
	
				return [DESCRIPTION_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var diagnosisDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", DIAGNOSIS_STAGE),
					this.props.renderDropdownF("choices1", DIAGNOSIS_STAGE, HAS_READ_TEXT, [HAS_READ_TEXT])
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var otherTextDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", OTHER_TEXT_STAGE),
						this.props.renderInputF(COMP_TEXT_TITLE, [HAS_READ_TEXT, COMP_TEXT_TITLE])
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					if (this.props.level == "1") {
						var selectedText = this.props.answers[NonFictionComparisonQuestion.STEM][COMP_TEXT_TITLE];
						var elementsReplacementsHash = {};
						elementsReplacementsHash[WarmupQuestions.SELECTED_TEXT] = selectedText;
	
						var additionalElementsDisplay = React.createElement(
							"span",
							null,
							this.props.getTextF("label2", ELEMENTS_STAGE, elementsReplacementsHash),
							"."
						);
	
						var answerKey = TOPIC_COMP;
					} else {
						var answerKey = SIMILAR_ELEMENT;
					}
	
					var elementsDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", ELEMENTS_STAGE),
						this.props.renderDropdownF("choices1", ELEMENTS_STAGE, answerKey),
						additionalElementsDisplay
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var similarElement = this.props.answers[NonFictionComparisonQuestion.STEM][SIMILAR_ELEMENT];
					var descriptionReplacementsHash = {};
					descriptionReplacementsHash[WarmupQuestions.SIMILAR_ELEMENT] = similarElement;
	
					var descriptionDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIPTION_STAGE, descriptionReplacementsHash),
						this.props.renderInputF(SIMILAR_ELEMENT_DESC)
					);
				}
	
				return React.createElement(
					"div",
					null,
					diagnosisDisplay,
					otherTextDisplay,
					elementsDisplay,
					descriptionDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionComparisonQuestion;
	}(React.Component);
	
	NonFictionComparisonQuestion.STEM = "nfcomp";
	
	// stages
	var DIAGNOSIS_STAGE = "diagnosis";
	var OTHER_TEXT_STAGE = "othertext";
	var ELEMENTS_STAGE = "elements";
	var DESCRIPTION_STAGE = "describe";
	
	var STAGES = [DIAGNOSIS_STAGE, OTHER_TEXT_STAGE, ELEMENTS_STAGE, DESCRIPTION_STAGE];
	
	// answer keys
	var HAS_READ_TEXT = "has_read_comp_text";
	var COMP_TEXT_TITLE = "comp_text_title";
	var TOPIC_COMP = "topic_comparison";
	var SIMILAR_ELEMENT = "similar_element";
	var SIMILAR_ELEMENT_DESC = "similar_element_description";
	
	NonFictionComparisonQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionComparisonQuestion;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var NonFictionMainIdeasQuestion = function (_React$Component) {
		_inherits(NonFictionMainIdeasQuestion, _React$Component);
	
		function NonFictionMainIdeasQuestion(props) {
			_classCallCheck(this, NonFictionMainIdeasQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionMainIdeasQuestion.__proto__ || Object.getPrototypeOf(NonFictionMainIdeasQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionMainIdeasQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionMainIdeasQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [MAIN_IDEA_1_STAGE];
				}
	
				if (!answers[MAIN_IDEA_1]) {
					return [MAIN_IDEA_1_STAGE];
				}
	
				if (this.props.level != "3") {
					return [MAIN_IDEA_1_STAGE, true];
				}
	
				if (!answers[MAIN_IDEA_2]) {
					return [MAIN_IDEA_2_STAGE];
				}
	
				return [MAIN_IDEA_2_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var mainIdea1Display = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", MAIN_IDEA_1_STAGE),
					this.props.renderInputF(MAIN_IDEA_1)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var mainIdea2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", MAIN_IDEA_2_STAGE),
						this.props.renderInputF(MAIN_IDEA_2)
					);
				}
	
				return React.createElement(
					"div",
					null,
					mainIdea1Display,
					mainIdea2Display,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionMainIdeasQuestion;
	}(React.Component);
	
	NonFictionMainIdeasQuestion.STEM = "nfmain";
	
	// stages
	var MAIN_IDEA_1_STAGE = "mainidea1";
	var MAIN_IDEA_2_STAGE = "mainidea2";
	
	var STAGES = [MAIN_IDEA_1_STAGE, MAIN_IDEA_2_STAGE];
	
	// answer keys
	var MAIN_IDEA_1 = "main_idea_1";
	var MAIN_IDEA_2 = "main_idea_2";
	
	NonFictionMainIdeasQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionMainIdeasQuestion;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var NonFictionOrganizationQuestion = function (_React$Component) {
		_inherits(NonFictionOrganizationQuestion, _React$Component);
	
		function NonFictionOrganizationQuestion(props) {
			_classCallCheck(this, NonFictionOrganizationQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionOrganizationQuestion.__proto__ || Object.getPrototypeOf(NonFictionOrganizationQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionOrganizationQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionOrganizationQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [NUM_PAGES_STAGE];
				}
	
				if (!answers[NUM_PAGES] || answers[NUM_PAGES] < 1) {
					return [NUM_PAGES_STAGE];
				}
	
				if (this.props.level == "1") {
					if (!answers[SEL_HEADING_NUMBER] || !answers[NUM_HEADINGS] || answers[NUM_HEADINGS] < 1) {
						return [ORG_STRUCTURE_STAGE];
					}
	
					if (!answers[SEL_HEADING_DESCRIPTION]) {
						return [RANDOM_HEADING_STAGE];
					} else {
						return [RANDOM_HEADING_STAGE, true];
					}
				}
	
				if (!answers[STRUCTURE_TYPE]) {
					return [ORG_STRUCTURE_STAGE];
				}
	
				var structure = answers[STRUCTURE_TYPE];
				if (structure.includes("chronological")) {
					if (!answers[EVENT_1] || !answers[EVENT_2]) {
						return [CHRONOLOGICAL_STAGE];
					} else {
						return [CHRONOLOGICAL_STAGE, true];
					}
				}
				if (structure.includes("compare")) {
					if (!answers[SPECIFIC_ENTITY_1] || !answers[SPECIFIC_ENTITY_2]) {
						return [COMPARISON_STAGE];
					} else {
						return [COMPARISON_STAGE, true];
					}
				}
				if (structure.includes("cause")) {
					if (!answers[CAUSE] || !answers[EFFECT]) {
						return [CAUSE_EFFECT_STAGE];
					} else {
						return [CAUSE_EFFECT_STAGE, true];
					}
				}
				if (structure.includes("problem")) {
					if (!answers[PROBLEM] || !answers[SOLUTION]) {
						return [PROBLEM_SOLUTION_STAGE];
					} else {
						return [PROBLEM_SOLUTION_STAGE, true];
					}
				}
				if (structure.includes("descriptive")) {
					if (!answers[SUBJECT] || !answers[DESCRIPTION]) {
						return [DESCRIPTION_STAGE];
					} else {
						return [DESCRIPTION_STAGE, true];
					}
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var numPagesDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", NUM_PAGES_STAGE),
					this.props.renderInputF(NUM_PAGES, null, "number"),
					this.props.getTextF("label2", NUM_PAGES_STAGE),
					"."
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					if (this.props.level == "1") {
						var orgStructureDisplay = React.createElement(
							"div",
							null,
							this.props.getTextF("label1", ORG_STRUCTURE_STAGE),
							this.props.renderInputF(NUM_HEADINGS, null, "number"),
							this.props.getTextF("label2", ORG_STRUCTURE_STAGE),
							"."
						);
					} else {
						var orgStructureDisplay = React.createElement(
							"div",
							null,
							this.props.getTextF("label1", ORG_STRUCTURE_STAGE),
							this.props.renderDropdownF("choices1", ORG_STRUCTURE_STAGE, STRUCTURE_TYPE, [NUM_PAGES]),
							"."
						);
					}
				}
	
				if (_.indexOf(STAGES, stage) == 2) {
					var answers = this.props.answers[NonFictionOrganizationQuestion.STEM];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.HEADING_NUMBER] = answers[SEL_HEADING_NUMBER];
	
					var randomHeadingDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", RANDOM_HEADING_STAGE, replacementsHash),
						this.props.renderInputF(SEL_HEADING_DESCRIPTION)
					);
				}
	
				if (_.indexOf(STAGES, stage) == 3) {
					var chronologicalDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CHRONOLOGICAL_STAGE),
						this.props.renderInputF(EVENT_1),
						React.createElement("br", null),
						this.props.getTextF("label2", CHRONOLOGICAL_STAGE),
						this.props.renderInputF(EVENT_2)
					);
				}
				if (_.indexOf(STAGES, stage) == 4) {
					var comparisonDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", COMPARISON_STAGE),
						this.props.renderInputF(SPECIFIC_ENTITY_1),
						React.createElement("br", null),
						this.props.getTextF("label2", COMPARISON_STAGE),
						this.props.renderInputF(SPECIFIC_ENTITY_2)
					);
				}
				if (_.indexOf(STAGES, stage) == 5) {
					var causeEffectDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", CAUSE_EFFECT_STAGE),
						this.props.renderInputF(CAUSE),
						React.createElement("br", null),
						this.props.getTextF("label2", CAUSE_EFFECT_STAGE),
						this.props.renderInputF(EFFECT)
					);
				}
				if (_.indexOf(STAGES, stage) == 6) {
					var problemSolutionDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", PROBLEM_SOLUTION_STAGE),
						this.props.renderInputF(PROBLEM),
						React.createElement("br", null),
						this.props.getTextF("label2", PROBLEM_SOLUTION_STAGE),
						this.props.renderInputF(SOLUTION)
					);
				}
				if (_.indexOf(STAGES, stage) == 7) {
					var descriptionDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIPTION_STAGE),
						this.props.renderInputF(SUBJECT),
						React.createElement("br", null),
						this.props.getTextF("label2", DESCRIPTION_STAGE),
						this.props.renderInputF(DESCRIPTION)
					);
				}
	
				return React.createElement(
					"div",
					null,
					numPagesDisplay,
					orgStructureDisplay,
					randomHeadingDisplay,
					chronologicalDisplay,
					comparisonDisplay,
					causeEffectDisplay,
					problemSolutionDisplay,
					descriptionDisplay,
					finishButtonDisplay
				);
			}
		}, {
			key: "componentDidUpdate",
			value: function componentDidUpdate(oldProps) {
				var oldAnswers = oldProps.answers[NonFictionOrganizationQuestion.STEM];
				var newAnswers = this.props.answers[NonFictionOrganizationQuestion.STEM];
				if (oldAnswers && newAnswers) {
					var optionKey = NUM_HEADINGS;
	
					if (newAnswers[optionKey] && oldAnswers[optionKey] != newAnswers[optionKey]) {
						var options = [];
						for (var i = 1; i <= parseInt(newAnswers[optionKey]); i++) {
							options.push($wr.getOrdinal(i));
						}
	
						this.props.pickRandomOptionF(SEL_HEADING_NUMBER, options);
					}
				}
			}
		}]);
	
		return NonFictionOrganizationQuestion;
	}(React.Component);
	
	NonFictionOrganizationQuestion.STEM = "nforg";
	
	// stages
	var NUM_PAGES_STAGE = "numpages";
	var ORG_STRUCTURE_STAGE = "orgstructure";
	var RANDOM_HEADING_STAGE = "headinginfo";
	var CHRONOLOGICAL_STAGE = "chronological";
	var COMPARISON_STAGE = "comparison";
	var CAUSE_EFFECT_STAGE = "causeeffect";
	var PROBLEM_SOLUTION_STAGE = "problemsolution";
	var DESCRIPTION_STAGE = "description";
	
	var STAGES = [NUM_PAGES_STAGE, ORG_STRUCTURE_STAGE, RANDOM_HEADING_STAGE, CHRONOLOGICAL_STAGE, COMPARISON_STAGE, CAUSE_EFFECT_STAGE, PROBLEM_SOLUTION_STAGE, DESCRIPTION_STAGE];
	
	// answer keys
	var NUM_PAGES = "num_pages";
	var NUM_HEADINGS = "num_headings";
	var SEL_HEADING_NUMBER = "selected_heading_number";
	var SEL_HEADING_DESCRIPTION = "selected_heading_description";
	var STRUCTURE_TYPE = "structure_type";
	var EVENT_1 = "event_1";
	var EVENT_2 = "event_2";
	var SPECIFIC_ENTITY_1 = "specific_entity_1";
	var SPECIFIC_ENTITY_2 = "specific_entity_2";
	var CAUSE = "cause";
	var EFFECT = "effect";
	var PROBLEM = "problem";
	var SOLUTION = "solution";
	var SUBJECT = "subject";
	var DESCRIPTION = "description";
	
	NonFictionOrganizationQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired,
		pickRandomOptionF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionOrganizationQuestion;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	
	var NonFictionPicturesQuestion = function (_React$Component) {
		_inherits(NonFictionPicturesQuestion, _React$Component);
	
		function NonFictionPicturesQuestion(props) {
			_classCallCheck(this, NonFictionPicturesQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionPicturesQuestion.__proto__ || Object.getPrototypeOf(NonFictionPicturesQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionPicturesQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionPicturesQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [FEATURE_TYPE_STAGE];
				}
	
				var numPics = answers[NUM_PICS];
				var features = answers[FEATURES].split(",");
				if (this.props.level == "1" && !numPics || this.props.level != "1" && !features) {
					return [FEATURE_TYPE_STAGE];
				}
	
				if (numPics && numPics == "0" || features && features.includes("none")) {
					return [FEATURE_TYPE_STAGE, true];
				}
	
				if (!answers[FEATURE_1_DESC]) {
					return [DESCRIBE_1_STAGE];
				}
				if (this.props.level == "3" && !answers[FEATURE_1_TYPE]) {
					return [INFO_TYPE_1_STAGE];
				}
	
				if (numPics && numPics == "1" || features && features.length < 2) {
					if (this.props.level == "3") {
						return [INFO_TYPE_1_STAGE, true];
					} else {
						return [DESCRIBE_1_STAGE, true];
					}
				}
	
				if (!answers[FEATURE_2_DESC]) {
					return [DESCRIBE_2_STAGE];
				}
				if (this.props.level == "3" && !answers[FEATURE_2_TYPE]) {
					return [INFO_TYPE_2_STAGE];
				}
	
				if (this.props.level == "1") {
					return [DESCRIBE_2_STAGE, true];
				}
	
				if (features.length < 3) {
					if (this.props.level == "3") {
						return [INFO_TYPE_2_STAGE, true];
					} else {
						return [DESCRIBE_2_STAGE, true];
					}
				}
	
				if (!answers[FEATURE_3_DESC]) {
					return [DESCRIBE_3_STAGE];
				}
				if (this.props.level == "3" && !answers[FEATURE_3_TYPE]) {
					return [INFO_TYPE_3_STAGE];
				}
	
				if (this.props.level == "3") {
					return [INFO_TYPE_3_STAGE, true];
				} else {
					return [DESCRIBE_3_STAGE, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				if (this.props.level == "1") {
					var featureTypeInput = this.props.renderDropdownF("choices1", FEATURE_TYPE_STAGE, NUM_PICS, [NUM_PICS]);
				} else {
					var featureTypeInput = this.props.renderMultiSelectF("choices1", FEATURE_TYPE_STAGE, FEATURES, 3, [FEATURES]);
				}
				var featureTypeDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", FEATURE_TYPE_STAGE),
					featureTypeInput
				);
	
				var answers = this.props.answers[NonFictionPicturesQuestion.STEM];
				if (answers && answers[FEATURES]) {
					var features = answers[FEATURES].split(",");
				}
	
				if (_.indexOf(STAGES, stage) > 0) {
					if (features) {
						var replacementsHash1 = {};
						replacementsHash1[WarmupQuestions.FEATURE_TYPE] = features[0];
					}
					var describe1Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIBE_1_STAGE, replacementsHash1),
						this.props.renderInputF(FEATURE_1_DESC)
					);
				}
				if (_.indexOf(STAGES, stage) > 1 && this.props.level == "3") {
					var infoType1Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", INFO_TYPE_1_STAGE),
						this.props.renderDropdownF("choices1", INFO_TYPE_1_STAGE, FEATURE_1_TYPE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					if (features) {
						var replacementsHash2 = {};
						replacementsHash2[WarmupQuestions.FEATURE_TYPE] = features[1];
					}
					var describe2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIBE_2_STAGE, replacementsHash2),
						this.props.renderInputF(FEATURE_2_DESC)
					);
				}
				if (_.indexOf(STAGES, stage) > 3 && this.props.level == "3") {
					var infoType2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", INFO_TYPE_2_STAGE),
						this.props.renderDropdownF("choices1", INFO_TYPE_2_STAGE, FEATURE_2_TYPE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 4) {
					if (features) {
						var replacementsHash3 = {};
						replacementsHash3[WarmupQuestions.FEATURE_TYPE] = features[2];
					}
					var describe3Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", DESCRIBE_3_STAGE, replacementsHash3),
						this.props.renderInputF(FEATURE_3_DESC)
					);
				}
				if (_.indexOf(STAGES, stage) > 5 && this.props.level == "3") {
					var infoType3Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", INFO_TYPE_3_STAGE),
						this.props.renderDropdownF("choices1", INFO_TYPE_3_STAGE, FEATURE_3_TYPE)
					);
				}
	
				return React.createElement(
					"div",
					null,
					featureTypeDisplay,
					describe1Display,
					infoType1Display,
					describe2Display,
					infoType2Display,
					describe3Display,
					infoType3Display,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionPicturesQuestion;
	}(React.Component);
	
	NonFictionPicturesQuestion.STEM = "nfpic";
	
	// stages
	var FEATURE_TYPE_STAGE = "featuretype";
	var DESCRIBE_1_STAGE = "describe1";
	var INFO_TYPE_1_STAGE = "infotype1";
	var DESCRIBE_2_STAGE = "describe2";
	var INFO_TYPE_2_STAGE = "infotype2";
	var DESCRIBE_3_STAGE = "describe3";
	var INFO_TYPE_3_STAGE = "infotype3";
	
	var STAGES = [FEATURE_TYPE_STAGE, DESCRIBE_1_STAGE, INFO_TYPE_1_STAGE, DESCRIBE_2_STAGE, INFO_TYPE_2_STAGE, DESCRIBE_3_STAGE, INFO_TYPE_3_STAGE];
	
	// answer keys
	var NUM_PICS = "num_pictures";
	var FEATURES = "features";
	var FEATURE_1_DESC = "feature_1_description";
	var FEATURE_1_TYPE = "feature_1_type";
	var FEATURE_2_DESC = "feature_2_description";
	var FEATURE_2_TYPE = "feature_2_type";
	var FEATURE_3_DESC = "feature_3_description";
	var FEATURE_3_TYPE = "feature_3_type";
	
	NonFictionPicturesQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderMultiSelectF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionPicturesQuestion;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var NonFictionPointOfViewQuestion = function (_React$Component) {
		_inherits(NonFictionPointOfViewQuestion, _React$Component);
	
		function NonFictionPointOfViewQuestion(props) {
			_classCallCheck(this, NonFictionPointOfViewQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionPointOfViewQuestion.__proto__ || Object.getPrototypeOf(NonFictionPointOfViewQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionPointOfViewQuestion, [{
			key: "isPictureBook",
			value: function isPictureBook() {
				if (this.props.answers[TopicQuestion.STEM]) {
					return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";
				}
			}
		}, {
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionPointOfViewQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					if (this.props.level == "1") {
						return [NAMING_STAGE];
					} else {
						return [PURPOSE_STAGE];
					}
				}
	
				if (this.props.level == "1") {
					if (!answers[AUTHOR] || this.isPictureBook() && !answers[ILLUSTRATOR]) {
						return [NAMING_STAGE];
					} else {
						return [NAMING_STAGE, true];
					}
				}
	
				var purpose = answers[PURPOSE_TYPE];
				if (!purpose) {
					return [PURPOSE_STAGE];
				}
	
				if (purpose.includes("entertain")) {
					var stageName = ENTERTAIN_STAGE;
				} else if (purpose.includes("describe")) {
					var stageName = DESCRIBE_STAGE;
				} else if (purpose.includes("inform")) {
					var stageName = INFORM_STAGE;
				} else if (purpose.includes("persuade")) {
					var stageName = PERSUADE_STAGE;
				}
	
				if (this.props.level == "2" && !answers[PURPOSE_DESCRIPTION] || this.props.level == "3" && !answers[PURPOSE_SOURCE]) {
					return [stageName];
				} else {
					return [stageName, true];
				}
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				if (this.props.level == "1") {
					if (this.isPictureBook()) {
						var illustratorDisplay = React.createElement(
							"div",
							null,
							this.props.getTextF("label2", NAMING_STAGE),
							this.props.renderInputF(ILLUSTRATOR)
						);
					}
	
					var namingDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", NAMING_STAGE),
						this.props.renderInputF(AUTHOR),
						illustratorDisplay
					);
				}
	
				if (_.indexOf(STAGES, stage) > 0) {
					var purposeDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", PURPOSE_STAGE),
						this.props.renderDropdownF("choices1", PURPOSE_STAGE, PURPOSE_TYPE, [PURPOSE_TYPE]),
						"."
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					if (this.props.level == "2") {
						var inputDisplay = this.props.renderInputF(PURPOSE_DESCRIPTION);
					} else {
						var inputDisplay = this.props.renderDropdownF("choices1", stage, PURPOSE_SOURCE);
					}
	
					var purposeInfoDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", stage),
						inputDisplay,
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					namingDisplay,
					purposeDisplay,
					purposeInfoDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionPointOfViewQuestion;
	}(React.Component);
	
	NonFictionPointOfViewQuestion.STEM = "nfpov";
	
	// stages
	var NAMING_STAGE = "naming";
	var PURPOSE_STAGE = "purpose";
	var ENTERTAIN_STAGE = "entertain";
	var DESCRIBE_STAGE = "describe";
	var INFORM_STAGE = "inform";
	var PERSUADE_STAGE = "persuade";
	
	var STAGES = [NAMING_STAGE, PURPOSE_STAGE, ENTERTAIN_STAGE, DESCRIBE_STAGE, INFORM_STAGE, PERSUADE_STAGE];
	
	// answer keys
	var AUTHOR = "author";
	var ILLUSTRATOR = "illustrator";
	var PURPOSE_TYPE = "purpose_type";
	var PURPOSE_SOURCE = "purpose_source";
	var PURPOSE_DESCRIPTION = "purpose_description";
	
	NonFictionPointOfViewQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionPointOfViewQuestion;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var NonFictionSubjectQuestion = function (_React$Component) {
		_inherits(NonFictionSubjectQuestion, _React$Component);
	
		function NonFictionSubjectQuestion(props) {
			_classCallCheck(this, NonFictionSubjectQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionSubjectQuestion.__proto__ || Object.getPrototypeOf(NonFictionSubjectQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionSubjectQuestion, [{
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionSubjectQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [ENTITY_1_STAGE];
				}
	
				if (!answers[ENTITY_1]) {
					return [ENTITY_1_STAGE];
				}
	
				if (!answers[ENTITY_2_TYPE] || !answers[ENTITY_2]) {
					return [ENTITY_2_STAGE];
				}
	
				if (this.props.level == "1") {
					return [ENTITY_2_STAGE, true];
				}
	
				if (!answers[RELATIONSHIP]) {
					return [RELATIONSHIP_STAGE];
				}
	
				return [RELATIONSHIP_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var entity1Display = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", ENTITY_1_STAGE),
					this.props.renderInputF(ENTITY_1)
				);
	
				if (_.indexOf(STAGES, stage) > 0) {
					var answers = this.props.answers[NonFictionSubjectQuestion.STEM];
					var entity1 = answers[ENTITY_1];
					var replacementsHash = {};
					replacementsHash[WarmupQuestions.ENTITY1] = entity1;
	
					var entity2Display = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", ENTITY_2_STAGE),
						this.props.renderDropdownF("choices1", ENTITY_2_STAGE, ENTITY_2_TYPE, [ENTITY_1]),
						this.props.getTextF("label2", ENTITY_2_STAGE, replacementsHash),
						this.props.renderInputF(ENTITY_2)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					var entity2 = answers[ENTITY_2];
					replacementsHash[WarmupQuestions.ENTITY2] = entity2;
	
					if (this.props.answers[TopicQuestion.STEM]) {
						var entity1Type = this.props.answers[TopicQuestion.STEM][TopicQuestion.MAIN_ENTITY];
					} else {
						var entity1Type = "MISSING ENTITIY";
					}
					var entity2Type = answers[ENTITY_2_TYPE];
					replacementsHash[WarmupQuestions.RELATION_KEY] = [entity1Type, entity2Type].sort().join("_");
	
					var relationshipDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", RELATIONSHIP_STAGE, replacementsHash),
						this.props.renderDropdownF("choices1", RELATIONSHIP_STAGE, RELATIONSHIP, undefined, replacementsHash),
						this.props.getTextF("label2", RELATIONSHIP_STAGE, replacementsHash),
						"."
					);
				}
	
				return React.createElement(
					"div",
					null,
					entity1Display,
					entity2Display,
					relationshipDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionSubjectQuestion;
	}(React.Component);
	
	NonFictionSubjectQuestion.STEM = "nfsubj";
	
	// stages
	var ENTITY_1_STAGE = "entity1";
	var ENTITY_2_STAGE = "entity2";
	var RELATIONSHIP_STAGE = "relationship";
	
	var STAGES = [ENTITY_1_STAGE, ENTITY_2_STAGE, RELATIONSHIP_STAGE];
	
	// answer keys
	var ENTITY_1 = "entity_1";
	var ENTITY_2_TYPE = "entity_2_type";
	var ENTITY_2 = "entity_2";
	var RELATIONSHIP = "relationship";
	
	NonFictionSubjectQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionSubjectQuestion;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var NonFictionVocabularyQuestion = function (_React$Component) {
		_inherits(NonFictionVocabularyQuestion, _React$Component);
	
		function NonFictionVocabularyQuestion(props) {
			_classCallCheck(this, NonFictionVocabularyQuestion);
	
			var _this = _possibleConstructorReturn(this, (NonFictionVocabularyQuestion.__proto__ || Object.getPrototypeOf(NonFictionVocabularyQuestion)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NonFictionVocabularyQuestion, [{
			key: "isConnotative",
			value: function isConnotative() {
				return this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD_TYPE].includes("connotative");
			}
		}, {
			key: "isTechnical",
			value: function isTechnical() {
				return this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD_TYPE].includes("technical");
			}
		}, {
			key: "getDisplayStatus",
			value: function getDisplayStatus() {
				var answers = this.props.answers[NonFictionVocabularyQuestion.STEM];
				if (answers == undefined || _.isEmpty(answers)) {
					return [HARD_WORD_STAGE];
				}
	
				if (!answers[HARD_WORD]) {
					return [HARD_WORD_STAGE];
				}
	
				if (this.props.level == "2" && !answers[HARD_WORD_PIECE]) {
					return [HARD_WORD_PIECE_STAGE];
				}
	
				if (!answers[TOPIC_WORD] || this.props.level == "3" && !answers[TOPIC_WORD_TYPE]) {
					return [TOPIC_WORD_STAGE];
				}
	
				if (this.props.level == "1") {
					return [TOPIC_WORD_STAGE, true];
				}
	
				if (this.props.level == "2") {
					if (!answers[TOPIC_WORD_PIECE]) {
						return [TOPIC_WORD_PIECE_STAGE];
					}
					return [TOPIC_WORD_PIECE_STAGE, true];
				}
	
				if (!this.isTechnical()) {
					if (!answers[LITERAL_MEANING]) {
						return [MEANING_LITERAL_STAGE];
					}
					if (!answers[NONLITERAL_MEANING]) {
						return [MEANING_NONLITERAL_STAGE];
					}
					return [MEANING_NONLITERAL_STAGE, true];
				}
	
				if (!answers[TECHNICAL_MEANING]) {
					return [MEANING_TECHNICAL_STAGE];
				}
	
				return [MEANING_TECHNICAL_STAGE, true];
			}
		}, {
			key: "render",
			value: function render() {
				var displayStatus = this.getDisplayStatus();
				var stage = displayStatus[0];
				var displayButton = displayStatus[1];
				if (displayButton) {
					var finishButtonDisplay = this.props.renderFinishButtonF();
				}
	
				var hardWordDisplay = React.createElement(
					"div",
					null,
					this.props.getTextF("label1", HARD_WORD_STAGE),
					this.props.renderInputF(HARD_WORD)
				);
	
				if (_.indexOf(STAGES, stage) > 0 && this.props.level == "2") {
					var hardWord = this.props.answers[NonFictionVocabularyQuestion.STEM][HARD_WORD];
					var hardReplacementsHash = {};
					hardReplacementsHash[WarmupQuestions.HARD_WORD] = hardWord;
	
					var hardWordPieceDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", HARD_WORD_PIECE_STAGE, hardReplacementsHash),
						this.props.renderDropdownF("choices1", HARD_WORD_PIECE_STAGE, HARD_WORD_PIECE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 1) {
					if (this.props.answers[TopicQuestion.STEM]) {
						var topic = this.props.answers[TopicQuestion.STEM][TopicQuestion.MAIN_TOPICS].split(",")[0];
					} else {
						var topic = "MISSING TOPIC";
					}
					var mainTopicsReplacementsHash = {};
					mainTopicsReplacementsHash[WarmupQuestions.TOPIC] = topic;
	
					if (this.props.level == "3") {
						var additionalTopicWordDisplay = React.createElement(
							"span",
							null,
							this.props.renderDropdownF("choices1", TOPIC_WORD_STAGE, TOPIC_WORD_TYPE, [HARD_WORD, TOPIC_WORD]),
							this.props.getTextF("label2", TOPIC_WORD_STAGE)
						);
					}
	
					var topicWordDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", TOPIC_WORD_STAGE, mainTopicsReplacementsHash),
						additionalTopicWordDisplay,
						this.props.renderInputF(TOPIC_WORD)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 2) {
					var topicWord = this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD];
					var topicReplacementsHash = {};
					topicReplacementsHash[WarmupQuestions.ENTERED_WORD] = topicWord;
				}
	
				if (_.indexOf(STAGES, stage) > 2 && this.props.level == "2") {
					var topicWordPieceDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", TOPIC_WORD_PIECE_STAGE, topicReplacementsHash),
						this.props.renderDropdownF("choices1", TOPIC_WORD_PIECE_STAGE, TOPIC_WORD_PIECE)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 3 && !this.isTechnical()) {
					var label = this.isConnotative() ? "label1" : "label2";
					var literalMeaningDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF(label, MEANING_LITERAL_STAGE, topicReplacementsHash),
						this.props.renderInputF(LITERAL_MEANING)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 4 && !this.isTechnical()) {
					var label = this.isConnotative() ? "label1" : "label2";
					var nonliteralMeaningDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF(label, MEANING_NONLITERAL_STAGE, topicReplacementsHash),
						this.props.renderInputF(NONLITERAL_MEANING)
					);
				}
	
				if (_.indexOf(STAGES, stage) > 5) {
					var technicalMeaningDisplay = React.createElement(
						"div",
						null,
						this.props.getTextF("label1", MEANING_TECHNICAL_STAGE, topicReplacementsHash),
						this.props.renderInputF(TECHNICAL_MEANING)
					);
				}
	
				return React.createElement(
					"div",
					null,
					hardWordDisplay,
					hardWordPieceDisplay,
					topicWordDisplay,
					topicWordPieceDisplay,
					literalMeaningDisplay,
					nonliteralMeaningDisplay,
					technicalMeaningDisplay,
					finishButtonDisplay
				);
			}
		}]);
	
		return NonFictionVocabularyQuestion;
	}(React.Component);
	
	NonFictionVocabularyQuestion.STEM = "nfvocab";
	
	// stages
	var HARD_WORD_STAGE = "hardword";
	var HARD_WORD_PIECE_STAGE = "hardwordpiece";
	var TOPIC_WORD_STAGE = "topicword";
	var TOPIC_WORD_PIECE_STAGE = "topicwordpiece";
	var MEANING_LITERAL_STAGE = "meaningliteral";
	var MEANING_NONLITERAL_STAGE = "meaningnonliteral";
	var MEANING_TECHNICAL_STAGE = "meaningtechnical";
	
	var STAGES = [HARD_WORD_STAGE, HARD_WORD_PIECE_STAGE, TOPIC_WORD_STAGE, TOPIC_WORD_PIECE_STAGE, MEANING_LITERAL_STAGE, MEANING_NONLITERAL_STAGE, MEANING_TECHNICAL_STAGE];
	
	// answer keys
	var HARD_WORD = "hard_word";
	var HARD_WORD_PIECE = "hard_word_piece";
	var TOPIC_WORD = "topic_word";
	var TOPIC_WORD_PIECE = "topic_word_piece";
	var TOPIC_WORD_TYPE = "topic_word_type";
	var LITERAL_MEANING = "literal_meaning";
	var NONLITERAL_MEANING = "nonliteral_meaning";
	var TECHNICAL_MEANING = "technical_meaning";
	
	NonFictionVocabularyQuestion.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		answers: PropTypes.object.isRequired,
		getTextF: PropTypes.func.isRequired,
		renderDropdownF: PropTypes.func.isRequired,
		renderInputF: PropTypes.func.isRequired,
		renderFinishButtonF: PropTypes.func.isRequired
	});
	
	module.exports = NonFictionVocabularyQuestion;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactSelect = __webpack_require__(154);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	
	var ButtonDropdown = __webpack_require__(23);
	var ButtonDropdownOption = __webpack_require__(31);
	var LoadingButton = __webpack_require__(17);
	var ErrorBoundary = __webpack_require__(420);
	
	var WarmupQuestions = __webpack_require__(49);
	var TopicQuestion = __webpack_require__(104);
	
	var FictionCharactersQuestion = __webpack_require__(969);
	var FictionMainIdeasQuestion = __webpack_require__(972);
	var FictionPlotQuestion = __webpack_require__(975);
	var FictionSettingQuestion = __webpack_require__(977);
	var FictionOrganizationQuestion = __webpack_require__(973);
	var FictionPointOfViewQuestion = __webpack_require__(976);
	var FictionPicturesQuestion = __webpack_require__(974);
	var FictionComparisonQuestion = __webpack_require__(970);
	var FictionEmotionQuestion = __webpack_require__(971);
	var FictionVocabularyQuestion = __webpack_require__(978);
	
	var NonFictionSubjectQuestion = __webpack_require__(985);
	var NonFictionMainIdeasQuestion = __webpack_require__(981);
	var NonFictionOrganizationQuestion = __webpack_require__(982);
	var NonFictionPointOfViewQuestion = __webpack_require__(984);
	var NonFictionPicturesQuestion = __webpack_require__(983);
	var NonFictionComparisonQuestion = __webpack_require__(980);
	var NonFictionVocabularyQuestion = __webpack_require__(986);
	var NonFictionArgumentsQuestion = __webpack_require__(979);
	
	var Skillsets = __webpack_require__(55);
	var Glyphicon = __webpack_require__(8);
	
	var ComponentDemonstrator = __webpack_require__(885);
	
	__webpack_require__(3859);
	
	var WarmupQuestionsDisplay = function (_React$Component) {
		_inherits(WarmupQuestionsDisplay, _React$Component);
	
		function WarmupQuestionsDisplay(props) {
			_classCallCheck(this, WarmupQuestionsDisplay);
	
			var _this = _possibleConstructorReturn(this, (WarmupQuestionsDisplay.__proto__ || Object.getPrototypeOf(WarmupQuestionsDisplay)).call(this));
	
			autobind(_this);
	
			LuckyOrangeClient.tagComponent("WarmupQuestionsDisplay");
			// assume only one key value pair in initAnswers when displayOnly
			if (props.displayOnly) {
				var questionKey = props.displayOnlyKey;
				var answers = props.initAnswers;
			} else {
				// assume that we save warmup answers between every recall question, not intra-question
				var initialAnswers = props.initAnswers;
				// if (initialAnswers && initialAnswers[TopicQuestion.STEM]) {
				// 	var questionKey = this.getRecallQuestionStem(initialAnswers);
				// 	var answers = initialAnswers;
				// } else {
				var questionKey = TopicQuestion.STEM;
				var answers = {};
				// }
			}
	
			answers = _.extend({}, answers, { level: props.level });
	
			_this.state = {
				currentQuestion: questionKey, answers: answers, loading: false
			};
			return _this;
		}
	
		//////////////////// functions called by question components ////////////////////
	
	
		_createClass(WarmupQuestionsDisplay, [{
			key: "getTextForPart",
			value: function getTextForPart(part, stage) {
				var replacementsHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
				var key = this.getKeyForPart(part, stage);
	
				// set up to replace text_type, since most components use it
				var topicAnswers = this.state.answers[TopicQuestion.STEM];
				if (topicAnswers && topicAnswers[TopicQuestion.TEXT_TYPE]) {
					replacementsHash[WarmupQuestions.TEXT_TYPE] = topicAnswers[TopicQuestion.TEXT_TYPE];
				}
	
				// set up to replace entity_type for nonfiction
				if (topicAnswers && topicAnswers[TopicQuestion.MAIN_ENTITY]) {
					replacementsHash[WarmupQuestions.ENTITY_TYPE] = topicAnswers[TopicQuestion.MAIN_ENTITY];
				}
	
				var text = WarmupQuestions.getText(key, replacementsHash);
	
				return text;
			}
		}, {
			key: "pickAndSaveOption",
			value: function pickAndSaveOption(answerKey, options) {
				var randomIndex = Math.floor(Math.random() * options.length);
				this.updateAnswers(answerKey, options[randomIndex]);
			}
		}, {
			key: "renderInput",
			value: function renderInput(answerKey, whitelistKeys) {
				var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text";
	
				if (this.props.displayOnly) {
					return React.createElement(
						"div",
						{ className: "displayOnly" },
						" ",
						this.props.initAnswers[this.state.currentQuestion][answerKey],
						" "
					);
				}
	
				var currentAnswers = this.state.answers[this.state.currentQuestion];
				if (currentAnswers) {
					var defaultText = currentAnswers[answerKey] || "";
				} else {
					var defaultText = "";
				}
	
				var inputClassName = "inlineInput";
				if (inputType == "number") {
					inputClassName += " numberInput";
				}
	
				return React.createElement("input", { type: inputType, className: inputClassName, value: defaultText,
					onChange: this.onInputChange.bind(this, answerKey, whitelistKeys) });
			}
		}, {
			key: "renderDropdown",
			value: function renderDropdown(part, stage, answerKey, whitelistKeys) {
				var _this2 = this;
	
				var replacementsHash = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
				if (this.props.displayOnly) {
					return React.createElement(
						"div",
						{ className: "displayOnly" },
						" ",
						this.props.initAnswers[this.state.currentQuestion][answerKey],
						" "
					);
				}
	
				var optionKey = this.getKeyForPart(part, stage);
				var options = WarmupQuestions.getText(optionKey, replacementsHash).split(",").map(function (option) {
					var op = option.trim();
					return React.createElement(ButtonDropdownOption, { text: op, key: op,
						onClick: _this2.updateAnswers.bind(_this2, answerKey, op, whitelistKeys) });
				});
	
				var answers = this.state.answers[this.state.currentQuestion];
				if (answers && answers[answerKey]) {
					var displayText = answers[answerKey];
				} else {
					var displayText = "pick one";
				}
	
				return React.createElement(
					ButtonDropdown,
					{ text: displayText },
					options
				);
			}
		}, {
			key: "renderMultiSelect",
			value: function renderMultiSelect(part, stage, answerKey) {
				var maxSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
				var whitelistKeys = arguments[4];
	
				if (this.props.displayOnly) {
					return React.createElement(
						"div",
						{ className: "displayOnly" },
						" ",
						this.props.initAnswers[this.state.currentQuestion][answerKey].split(",").join(", "),
						" "
					);
				}
	
				var optionKey = this.getKeyForPart(part, stage);
				var options = WarmupQuestions.getText(optionKey).split(",").map(function (option) {
					var op = option.trim();
					return { value: op, label: op };
				});
	
				var answers = this.state.answers[this.state.currentQuestion];
				if (answers && answers[answerKey]) {
					var displayText = answers[answerKey];
				}
	
				// to adjust the width of the select bar
				var selectClassName = "multiSelect";
				if (maxSelect == 1) {
					selectClassName += " oneOption";
				} else if (maxSelect == 2) {
					selectClassName += " twoOptions";
				} else if (maxSelect == 3) {
					selectClassName += " threeOptions";
				} else {
					selectClassName += " noMaxOptions";
				}
	
				return React.createElement(_reactSelect2.default, { name: answerKey, options: options, value: displayText,
					multi: true, joinValues: true, delimiter: ",", simpleValue: true,
					className: selectClassName, autoBlur: true,
					onChange: this.onMultiSelectChange.bind(this, answerKey, maxSelect, whitelistKeys) });
			}
		}, {
			key: "renderFinishButton",
			value: function renderFinishButton() {
				var _this3 = this;
	
				if (this.props.displayOnly) {
					return;
				}
	
				if (this.state.currentQuestion == TopicQuestion.STEM) {
					var onClickF = this.nextRecallQuestion;
				} else {
					var onClickF = this.submitWarmupAnswers;
				}
	
				return React.createElement(LoadingButton, { className: "btn buttonPrimary finishButton", text: "Next Question",
					onClick: function onClick() {
						return _this3.setState({ loading: true }, onClickF);
					},
					loading: this.state.loading });
			}
			////////////////////////////////////////////////////////////////////////////////
	
	
			//////////////////// internal functions ////////////////////////////////////////
	
		}, {
			key: "getKeyForPart",
			value: function getKeyForPart(part, stage) {
				var stem = this.state.currentQuestion;
				var level = this.props.level;
				return WarmupQuestions.getKey(stem, stage, part, level);
			}
		}, {
			key: "onInputChange",
			value: function onInputChange(key, whitelistKeys, event) {
				var newValue = event.target.value;
				this.updateAnswers(key, newValue, whitelistKeys);
			}
		}, {
			key: "updateAnswers",
			value: function updateAnswers(key, value, whitelistKeys) {
				var currentQuestion = this.state.currentQuestion;
				var updatedAnswers = _.clone(this.state.answers);
				if (updatedAnswers[currentQuestion] == undefined) {
					updatedAnswers[currentQuestion] = {};
				}
	
				if (whitelistKeys != undefined) {
					updatedAnswers[currentQuestion] = _.pick(updatedAnswers[currentQuestion], whitelistKeys);
				} else {
					updatedAnswers[currentQuestion] = _.clone(updatedAnswers[currentQuestion]);
				}
				// update the key's value if there is content
				if (value && value.trim().length > 0) {
					updatedAnswers[currentQuestion][key] = value;
					this.setState({ answers: updatedAnswers });
	
					// otherwise, remove the key from the answers object
				} else {
					updatedAnswers[currentQuestion] = _.omit(updatedAnswers[currentQuestion], key);
					this.setState({ answers: updatedAnswers });
				}
			}
		}, {
			key: "onMultiSelectChange",
			value: function onMultiSelectChange(answerKey, maxSelect, whitelistKeys, selectedOptions) {
				// return if we have reached the maximum number of options
				if (maxSelect > 0 && selectedOptions.split(",").length > maxSelect) {
					// should never be greater, but just in case
					var notificationText = "You can only pick " + maxSelect + ".";
					window.wrNotifications.triggerDropDownNotification({
						title: "Question Tip", text: notificationText,
						icon: "exclamation-sign", type: "error" });
					return;
				}
	
				this.updateAnswers(answerKey, selectedOptions, whitelistKeys);
			}
		}, {
			key: "getRecallQuestionStem",
			value: function getRecallQuestionStem(answers) {
				var overlapStems = this.getStemOptions();
				return _.sample(overlapStems);
			}
		}, {
			key: "nextRecallQuestion",
			value: function nextRecallQuestion() {
				var _this4 = this;
	
				var questionKey = this.getRecallQuestionStem(this.state.answers);
				this.props.onFinishQuestionF(this.state.answers, false, function () {
					return _this4.setState({ currentQuestion: questionKey, loading: false });
				});
			}
		}, {
			key: "submitWarmupAnswers",
			value: function submitWarmupAnswers() {
				this.props.onFinishQuestionF(this.state.answers, true);
			}
		}, {
			key: "changeQuestion",
			value: function changeQuestion() {
				var initialAnswers = this.props.initAnswers;
				var questionKey = this.getRecallQuestionStem(initialAnswers);
				var answers = initialAnswers;
	
				this.setState({ currentQuestion: questionKey, answers: answers });
			}
		}, {
			key: "isNonFiction",
			value: function isNonFiction() {
				if (!this.state || !this.state.answers) {
					return false;
				}
				var topicAnswer = this.state.answers[TopicQuestion.STEM];
				if (topicAnswer && topicAnswer[TopicQuestion.TEXT_VARIETY]) {
					return topicAnswer[TopicQuestion.TEXT_VARIETY].includes("non-fiction");
				}
			}
		}, {
			key: "getStemOptions",
			value: function getStemOptions() {
				if (this.isNonFiction()) {
					var baseStems = WarmupQuestionsDisplay.NON_FICTION_RECALL_OPTIONS;
				} else {
					var baseStems = WarmupQuestionsDisplay.FICTION_RECALL_OPTIONS;
				}
	
				return baseStems;
			}
	
			////////////////////////////////////////////////////////////////////////////////
	
		}, {
			key: "render",
			value: function render() {
				var currentQuestion = this.state.currentQuestion;
				var demoComponent = "warmup_question_2";
	
				if (currentQuestion == TopicQuestion.STEM) {
					demoComponent = "warmup_question_1";
					var questionDisplay = React.createElement(TopicQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, renderMultiSelectF: this.renderMultiSelect,
						renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionCharactersQuestion.STEM) {
					var questionDisplay = React.createElement(FictionCharactersQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, renderMultiSelectF: this.renderMultiSelect,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionMainIdeasQuestion.STEM) {
					var questionDisplay = React.createElement(FictionMainIdeasQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionPlotQuestion.STEM) {
					var questionDisplay = React.createElement(FictionPlotQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionSettingQuestion.STEM) {
					var questionDisplay = React.createElement(FictionSettingQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderMultiSelectF: this.renderMultiSelect,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionOrganizationQuestion.STEM) {
					var questionDisplay = React.createElement(FictionOrganizationQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, pickRandomOptionF: this.pickAndSaveOption,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionPointOfViewQuestion.STEM) {
					var questionDisplay = React.createElement(FictionPointOfViewQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, renderMultiSelectF: this.renderMultiSelect,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionPicturesQuestion.STEM) {
					var questionDisplay = React.createElement(FictionPicturesQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, renderMultiSelectF: this.renderMultiSelect,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionComparisonQuestion.STEM) {
					var questionDisplay = React.createElement(FictionComparisonQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionEmotionQuestion.STEM) {
					var questionDisplay = React.createElement(FictionEmotionQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderMultiSelectF: this.renderMultiSelect,
						renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == FictionVocabularyQuestion.STEM) {
					var questionDisplay = React.createElement(FictionVocabularyQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionSubjectQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionSubjectQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionMainIdeasQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionMainIdeasQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionOrganizationQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionOrganizationQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, pickRandomOptionF: this.pickAndSaveOption,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionPointOfViewQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionPointOfViewQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionPicturesQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionPicturesQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown, renderMultiSelectF: this.renderMultiSelect,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionComparisonQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionComparisonQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionVocabularyQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionVocabularyQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				} else if (currentQuestion == NonFictionArgumentsQuestion.STEM) {
					var questionDisplay = React.createElement(NonFictionArgumentsQuestion, { level: this.props.level,
						answers: this.state.answers, getTextF: this.getTextForPart,
						renderDropdownF: this.renderDropdown,
						renderInputF: this.renderInput, renderFinishButtonF: this.renderFinishButton });
				}
	
				if (!this.props.displayOnly) {
					var stemOptions = this.getStemOptions();
	
					if (currentQuestion != TopicQuestion.STEM && stemOptions.length > 1) {
						var changeQuestionLink = React.createElement(
							"a",
							{ className: "changeQuestionLink btn", onClick: this.changeQuestion },
							"Change ",
							React.createElement(Glyphicon, { icon: "refresh" })
						);
					}
				}
	
				var errorMessage = "Something went wrong with this warmup question. " + "Please try again and, if the issue continues, report your username " + "and this book title to support@whooosreading.org.";
	
				var content = React.createElement(
					ErrorBoundary,
					{ errorMessage: errorMessage },
					changeQuestionLink,
					questionDisplay
				);
				if (this.props.demonstrate) {
					content = React.createElement(
						ComponentDemonstrator,
						{ component: demoComponent },
						content
					);
				}
				return React.createElement(
					"div",
					{ className: "warmupQuestionsDisplay" },
					content
				);
			}
		}]);
	
		return WarmupQuestionsDisplay;
	}(React.Component);
	
	WarmupQuestionsDisplay.FICTION_RECALL_OPTIONS = [FictionCharactersQuestion.STEM, FictionMainIdeasQuestion.STEM, FictionPlotQuestion.STEM, FictionSettingQuestion.STEM, FictionOrganizationQuestion.STEM, FictionPointOfViewQuestion.STEM, FictionPicturesQuestion.STEM, FictionComparisonQuestion.STEM, FictionEmotionQuestion.STEM, FictionVocabularyQuestion.STEM];
	WarmupQuestionsDisplay.NON_FICTION_RECALL_OPTIONS = [NonFictionSubjectQuestion.STEM, NonFictionMainIdeasQuestion.STEM, NonFictionOrganizationQuestion.STEM, NonFictionPointOfViewQuestion.STEM, NonFictionPicturesQuestion.STEM, NonFictionComparisonQuestion.STEM, NonFictionVocabularyQuestion.STEM, NonFictionArgumentsQuestion.STEM];
	
	WarmupQuestionsDisplay.propTypes = PageStrictPropTypes({
		level: PropTypes.string.isRequired,
		onFinishQuestionF: PropTypes.func,
		initAnswers: PropTypes.object,
		displayOnly: PropTypes.bool,
		displayOnlyKey: PropTypes.string,
		demonstrate: PropTypes.bool
	});
	
	module.exports = WarmupQuestionsDisplay;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = __webpack_require__(18);
	var ErrorDisplay = __webpack_require__(51);
	
	__webpack_require__(658);
	
	var NameModal = function (_React$Component) {
		_inherits(NameModal, _React$Component);
	
		function NameModal(props) {
			_classCallCheck(this, NameModal);
	
			var _this = _possibleConstructorReturn(this, (NameModal.__proto__ || Object.getPrototypeOf(NameModal)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(NameModal, [{
			key: "onSubmit",
			value: function onSubmit() {
				this.refs.errors.reset();
	
				var name = this.refs.signatureField.value.trim();
				if (name.length > 4) {
					this.props.onNameEntry(name);
				} else {
					this.refs.errors.setError("Please enter your full name.");
				}
			}
		}, {
			key: "show",
			value: function show() {
				this.refs.modal.show();
			}
		}, {
			key: "hide",
			value: function hide() {
				this.refs.modal.hide();
			}
		}, {
			key: "render",
			value: function render() {
				return React.createElement(
					Modal,
					{ modalOrder: 3, className: "nameModal", ref: "modal", headerText: "Now, sign your work!" },
					React.createElement(ErrorDisplay, { ref: "errors" }),
					React.createElement(
						"div",
						{ className: "clearfix nameLine" },
						React.createElement(
							"a",
							{ href: "#", onClick: this.onSubmit, className: "btn buttonPrimary pull-right" },
							"I'm Done!"
						),
						React.createElement(
							"div",
							{ className: "signatureWrap" },
							React.createElement("input", { className: "form-control", ref: "signatureField",
								placeholder: "Your first and last name" })
						)
					)
				);
			}
		}]);
	
		return NameModal;
	}(React.Component);
	
	;
	
	NameModal.propTypes = StrictPropTypes({
		onNameEntry: PropTypes.func.isRequired
	});
	
	module.exports = NameModal;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _PopulateData = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponseComposer = __webpack_require__(990);
	var Spinner = __webpack_require__(9);
	var CurrentUser = __webpack_require__(3);
	var Board = __webpack_require__(168);
	var BookTextVariety = __webpack_require__(141);
	var TextTypes = __webpack_require__(38);
	var Features = __webpack_require__(16);
	var StudentMetrics = __webpack_require__(29);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	var CurrentUser = __webpack_require__(3);
	
	// @providePopulateData({ waitForLoad: true })
	
	var NewResponsePage = (_dec = (0, _reactRedux.connect)(function (state, props) {
		return {};
	}, function (dispatch, props) {
		return {};
	}), _dec(_class = function (_React$Component) {
		_inherits(NewResponsePage, _React$Component);
	
		function NewResponsePage(props) {
			_classCallCheck(this, NewResponsePage);
	
			var _this = _possibleConstructorReturn(this, (NewResponsePage.__proto__ || Object.getPrototypeOf(NewResponsePage)).call(this));
	
			autobind(_this);
	
			_this.state = {
				activityOptions: null, assignedActivites: null, book: null,
				activityID: null, draftResponseID: null
			};
			return _this;
		}
	
		_createClass(NewResponsePage, [{
			key: "isAdminPreview",
			value: function isAdminPreview() {
				return CurrentUser.isTeacherAdmin();
			}
		}, {
			key: "getTextID",
			value: function getTextID() {
				if (this.state.book) {
					return this.state.book.text_id;
				} else {
					return $wr.getURLParameterByName("text_id");
				}
			}
		}, {
			key: "selectActivity",
			value: function selectActivity(activity) {
				this.setState({ activityID: activity.id });
			}
		}, {
			key: "selectAssignedActivity",
			value: function selectAssignedActivity(activityID) {
				this.setState({ activityID: activityID });
			}
		}, {
			key: "loadActivityOptions",
			value: function loadActivityOptions() {
				var params = {
					embed: "activity.format_summary"
				};
				var activityOptions = [];
				CurrentUser.api().getActivities(params, $wr.apiHandler(function (response) {
					activityOptions = response.activities;
					this.getStudents(activityOptions);
				}.bind(this)));
			}
		}, {
			key: "getAssignedExercises",
			value: function getAssignedExercises(exerciseIDs) {
				var _this2 = this;
	
				var exercises = [];
				_.each(exerciseIDs, function (exerciseID, index) {
					CurrentUser.api().getActivity(exerciseID, { embed: "activity.format" }, $wr.apiHandler(function (serverResponse) {
						exercises = [].concat(_toConsumableArray(exercises), [serverResponse.activity]);
						if (index === exerciseIDs.length - 1) {
							this.setState({ activityOptions: exercises });
						}
					}.bind(_this2)));
				});
			}
		}, {
			key: "getStudents",
			value: function getStudents(activityOptions) {
				var _this3 = this;
	
				var assignmentsParams = {
					embed: "current_tasks,task.subject,activity.format_summary"
				};
	
				CurrentUser.api().getStudent(CurrentUser.get().id, assignmentsParams, $wr.apiHandler(function (response) {
					_this3.setState({ assignedActivites: response.student.current_tasks });
					if (_this3.state.assignedActivites !== null && activityOptions.length) {
						_this3.filterActivityOptions(activityOptions);
					}
				}));
			}
			// filter activities based on url parameter
	
		}, {
			key: "filterActivityOptions",
			value: function filterActivityOptions(activityOptions) {
				var _this4 = this;
	
				// build activity options based on url param
				var queryString = window.location.search;
				var urlParams = new URLSearchParams(queryString);
				var activityIDs = urlParams.get('activity_ids');
	
				// var standAloneExerciseIDs = _.pluck(_.where(this.state.assignedActivites, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }), 'subject_id')
				// var exerciseTaskItemIDs = _.pluck(_.where(_.flatten(_.pluck(this.state.assignedActivites, 'task_items')), { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }), 'subject_id')
				// var usedExerciseIDs = _.map(_.collect(_.uniq(standAloneExerciseIDs.concat(exerciseTaskItemIDs))), exerciseID => { return parseInt(exerciseID)})
	
				// filter out activities that aren't assigned or are completed
				if (activityIDs !== 'none' && activityIDs !== null && this.state.assignedActivites !== null) {
					activityIDs = activityIDs.includes(',') ? activityIDs.split(',') : [activityIDs];
					activityIDs = _.map(activityIDs, function (id) {
						return parseInt(id);
					});
					// retrives exercises that are assigned
					if (activityIDs.length) {
						var exercises = [];
						_.each(activityIDs, function (exerciseID, index) {
							CurrentUser.api().getActivity(exerciseID, { embed: ["activity.format", "activity.format_summary"] }, $wr.apiHandler(function (serverResponse) {
								exercises = [].concat(_toConsumableArray(exercises), [serverResponse.activity]);
								if (index === activityIDs.length - 1) {
									this.setState({ activityOptions: exercises });
								}
							}.bind(_this4)));
						});
					} else {
						this.setState({ activityOptions: activityOptions });
					}
				} else {
					this.setState({ activityOptions: activityOptions });
				}
			}
			// load book information to redux
	
		}, {
			key: "fetchBook",
			value: function fetchBook(bookID) {
				var activityID = parseInt($wr.getURLParameterByName("activity_id"));
				if (bookID != 'null') {
					var params = { embed: "book.responses", draft: "only" };
					CurrentUser.api().getBook(bookID, params, $wr.apiHandler(function (response) {
						var book = _.omit(response.book, "responses");
	
						var draftResponse = response.book.responses[0];
	
						if (draftResponse && (!activityID || draftResponse.activity_id == activityID)) {
							this.setState({ book: book, draftResponseID: draftResponse.id, activityID: draftResponse.activity_id });
						} else {
							this.setState({ book: book }, function () {
								if ($wr.getURLParameterByName("activity_id")) {
									this.setState({ activityID: activityID });
								} else {
									this.loadActivityOptions();
								}
							}.bind(this));
						}
					}.bind(this)));
				} else if (activityID) {
					var newState = { activityID: activityID };
	
					var params = { user_id: CurrentUser.get().id, activity_id: activityID, draft: "only", text_id: null };
					CurrentUser.api().getResponses(params, $wr.apiHandler(function (serverResponse) {
	
						if (_.size(serverResponse.responses)) {
							var draftResponse = serverResponse.responses[0];
							newState = _extends({}, newState, { draftResponseID: draftResponse.id });
						}
	
						this.setState(_extends({}, newState));
					}.bind(this)));
				} else {
					this.loadActivityOptions();
				}
			}
		}, {
			key: "renderChooseActivity",
			value: function renderChooseActivity() {
				var student = CurrentUser.get();
				if (CurrentUser.hasID(student)) {
					var tasks = this.state.assignedActivites;
					var collaboration = student.current_collaboration;
				}
				var className = " largerHeader";
	
				return React.createElement(
					"div",
					null,
					React.createElement(
						"h3",
						{ className: "textTitle onQuestionSelect" },
						this.state.book.title
					),
					React.createElement(
						"header",
						{ className: "pageHeader" },
						React.createElement(
							"h1",
							{ className: "selectExerciseTitle" + className },
							"Choose an Exercise"
						)
					),
					React.createElement(Board, { type: Board.STUDENT_ACTIVITIES, items: this.state.activityOptions,
						onTileClick: this.selectActivity })
				);
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.book && !this.state.book.text_variety) {
					var pageContent = React.createElement(
						"div",
						{ className: "textVariety" },
						React.createElement(
							"header",
							{ className: "pageHeader" },
							React.createElement(
								"h1",
								null,
								"Select a Book Type"
							)
						),
						React.createElement(
							"h3",
							{ className: "textTitle" },
							this.state.book.title
						),
						React.createElement(BookTextVariety, { book: this.state.book, selectForActivity: true,
							fetchBook: this.fetchBook(this.getTextID()) })
					);
				} else if (this.state.activityID) {
					var pageContent = React.createElement(ResponseComposer, { activityID: this.state.activityID,
						responseID: this.state.draftResponseID, book: this.state.book,
						adminPreview: this.isAdminPreview() });
				} else if (this.state.activityOptions) {
					var pageContent = this.renderChooseActivity();
				} else {
					var pageContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				return React.createElement(
					"div",
					{ className: "container newResponsePage" },
					pageContent
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (this.getTextID()) {
					this.fetchBook(this.getTextID());
				} else if ($wr.getURLParameterByName("activity_id")) {
					this.setState({ activityID: parseInt($wr.getURLParameterByName("activity_id")) });
				}
			}
		}]);
	
		return NewResponsePage;
	}(React.Component)) || _class);
	;
	
	NewResponsePage.propTypes = PageStrictPropTypes({});
	
	module.exports = NewResponsePage;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingButton = __webpack_require__(17);
	var Activity = __webpack_require__(170);
	var TeacherPreviewNotice = __webpack_require__(423);
	var Spinner = __webpack_require__(9);
	var Glyphicon = __webpack_require__(8);
	var Autosaver = __webpack_require__(198);
	var NameModal = __webpack_require__(988);
	var AssignTaskModal = __webpack_require__(199);
	var AssignExerciseDetailsModal = __webpack_require__(424);
	
	var CurrentUser = __webpack_require__(3);
	var TextTypes = __webpack_require__(38);
	var WhooosReadingServices = __webpack_require__(25);
	var Modal = __webpack_require__(18);
	var MyShelfRouting = __webpack_require__(74);
	
	__webpack_require__(3860);
	
	var ResponseComposer = function (_React$Component) {
		_inherits(ResponseComposer, _React$Component);
	
		function ResponseComposer(props) {
			_classCallCheck(this, ResponseComposer);
	
			var _this = _possibleConstructorReturn(this, (ResponseComposer.__proto__ || Object.getPrototypeOf(ResponseComposer)).call(this));
	
			autobind(_this);
			_this.assignTaskModal = React.createRef();
			_this.assignExerciseDetailsModal = React.createRef();
	
			_this.state = {
				activity: null, response: null,
	
				loading: false, autosaveLoading: false,
				selectedActivityTitle: "", selectedUserIDs: [],
	
				// Both used by passphrase activities
				name: null, savedResponseData: null
			};
			return _this;
		}
	
		_createClass(ResponseComposer, [{
			key: "submitResponse",
			value: function submitResponse(responseData) {
				if (this.props.requireName) {
					if (this.state.name == null) {
						// Get the student to enter their name
						this.refs.nameModal.show();
						this.setState({ savedResponseData: responseData });
						return;
					} else {
						// Add in the name to the response data
						this.refs.nameModal.hide();
						var responseData = _.clone(responseData);
						var inputData = _.clone(responseData.input_data);
						inputData["__wr_name"] = this.state.name;
						responseData.input_data = inputData;
					}
				}
	
				// We're going to mutate this, so let's try to avoid mutating the parameter
				// NOTE: This is a shallow clone
				responseData = _.clone(responseData);
				responseData["minute_count"] = this.getMinuteCount();
				responseData["draft"] = false;
	
				// if edit mode
				if (this.hasDraft()) {
					responseData["edited_at"] = true;
				}
				if (!this.state.loading) {
					this.setState({ loading: true });
					if (this.state.response == null) {
						this.handleComplexInputs(responseData, function () {
							this.postResponse(responseData, function (serverResponse) {
								this.completionAction(serverResponse);
							}.bind(this));
						}.bind(this));
					} else {
						this.handleComplexInputs(responseData, function () {
							this.patchResponse(responseData, function (serverResponse) {
								this.completionAction(serverResponse);
							}.bind(this));
						}.bind(this));
					}
				}
			}
		}, {
			key: "deleteDraft",
			value: function deleteDraft() {
				if (this.state.response == null) {
					return;
				}
				CurrentUser.api().deleteResponse(this.state.response.id, $wr.apiHandler(function (serverResponse) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Your draft has been deleted!", text: "", icon: "trash" });
	
					$wr.redirect("/");
				}.bind(this)));
			}
		}, {
			key: "autosaveResponse",
			value: function autosaveResponse(callback) {
				var responseData = _.clone(this.refs.activity.getAutosaveData());
				responseData["minute_count"] = this.getMinuteCount();
				responseData["draft"] = true;
	
				var activity_id = this.props.activityID;
	
				this.setState({ autosaveLoading: true });
	
				if (this.state.response == null) {
					var data = { response: responseData, activity_id: activity_id };
					this.postResponse(responseData, function (serverResponse) {
						this.setState({ response: serverResponse.response, autosaveLoading: false });
						if (callback) {
							callback();
						}
					}.bind(this));
				} else {
					this.patchResponse(responseData, function (serverResponse) {
						this.setState({ autosaveLoading: false });
						if (callback) {
							callback();
						}
					}.bind(this));
				}
			}
		}, {
			key: "onNameEntry",
			value: function onNameEntry(name) {
				this.setState({ name: name }, function () {
					this.submitResponse(this.state.savedResponseData);
				}.bind(this));
			}
		}, {
			key: "handleComplexInputs",
			value: function handleComplexInputs(responseData, callback) {
				var blobMap = {};
				_.each(responseData.input_data, function (value, key) {
					if (value instanceof Blob) {
						blobMap[key] = value;
					}
				});
	
				if (_.size(blobMap) > 0) {
					this.uploadFiles(blobMap, function (referenceMap) {
						// Replace all the blobs with a reference to the uploaded file
						_.each(referenceMap, function (reference, key) {
							responseData.input_data[key] = reference;
						});
	
						callback();
					}.bind(this));
				} else {
					callback();
				}
			}
		}, {
			key: "printActivity",
			value: function printActivity(e) {
				$wr.nope(e);
				var activity = this.state.activity;
	
				Mycroft.newEvent({ category: "Printables", action: "view-activitiy-onpage", label: activity.key });
				if (activity.format_summary) {
					setTimeout(function () {
						Mycroft.newEvent({ category: "Printables", action: "view-skillset-onpage", label: activity.format_summary.skillset });
					}, 1100);
					setTimeout(function () {
						Mycroft.newEvent({ category: "Printables", action: "view-format-onpage", label: activity.format_summary.format_class });
					}, 2200);
				}
	
				window.open(activity.thumbnail.printable_url, "_blank");
			}
		}, {
			key: "postResponse",
			value: function postResponse(responseData, callback) {
				responseData = _.clone(responseData);
				if (this.props.book) {
					responseData.text_id = this.props.book.text_id;
					responseData.text_variety = this.props.book.text_variety;
				}
				responseData.activity_id = this.props.activityID;
	
				CurrentUser.api().postResponses({ response: responseData }, $wr.apiHandler(function (serverResponse) {
					if (serverResponse.response.errors) {
						console.error(serverResponse.response.errors);
					} else if (callback) {
						callback(serverResponse);
					}
				}.bind(this)));
			}
		}, {
			key: "patchResponse",
			value: function patchResponse(responseData, callback) {
				responseData = _.clone(responseData);
				if (this.props.book) {
					responseData.text_id = this.props.book.text_id;
				}
	
				CurrentUser.api().patchResponse(this.state.response.id, { response: responseData }, $wr.apiHandler(function (serverResponse) {
					if (serverResponse.response.errors) {
						console.error(serverResponse.response.errors);
					} else if (callback) {
						callback(serverResponse);
					}
				}.bind(this)));
			}
		}, {
			key: "completionAction",
			value: function completionAction(serverResponse) {
				if (this.state.activity.draft && !this.state.activity.draft.draft) {
					var text = "You edited: '" + this.state.activity.format.title + "'";
				} else {
					var text = "You completed: '" + this.state.activity.format.title + "'";
				}
	
				if (serverResponse.response.errors && serverResponse.response.errors.length > 0) {
					var errorText = serverResponse.response.errors.join("; ");
					window.wrNotifications.triggerDropDownNotification({
						title: "Something unexpected went wrong!", text: errorText, icon: "remove" }, 10000);
	
					return;
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Done!", text: text, icon: "star" });
				}
	
				CurrentUser.fetchCurrentUserCoinData();
				var mycroftAction = CurrentUser.isStudent() ? "complete" : "complete-preview";
				Mycroft.newEvent({ category: "Activity", action: mycroftAction, label: this.state.activity.key });
	
				// THIS WON'T RUN ANY MORE:
				// if (this.props.adminPreview && window.opener && window.opener.wr_openPreviewResposeModal) {
				// 	window.opener.wr_openPreviewResposeModal(serverResponse.response);
				if (this.props.adminPreview) {
					$wr.redirect("/");
				} else if (this.props.afterSubmit) {
					this.props.afterSubmit();
				} else {
					CurrentUser.fetchCurrentUserCoinData();
					if (!this.props.book.text_id || this.props.book.text_id === 'MISSING_TEXT_ID') {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.WORK_VIEW,
							detailsView: "exercises"
						}));
					} else if (this.props.book && this.props.book.text_id) {
						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: "exercises",
							textID: this.props.book.text_id
						}));
					} else {
						var redirectPath = "/";
					}
					$wr.redirect(redirectPath);
				}
			}
		}, {
			key: "uploadFiles",
			value: function uploadFiles(blobMap, callback) {
				var referenceMap = {};
				var url = WhooosReadingServices.ApiServer.url("/file_uploads");
	
				_.each(blobMap, function (blob, key) {
					var fd = new FormData();
					fd.append("file_format", "wav");
					fd.append("data", blob);
	
					$.ajax({
						type: "POST", url: url, data: fd,
						processData: false, contentType: false
					}).done(function (serverResponse) {
	
						referenceMap[key] = serverResponse.upload_location;
						if (_.size(blobMap) == _.size(referenceMap)) {
							callback(referenceMap);
						}
					});
				});
			}
		}, {
			key: "hasDraft",
			value: function hasDraft() {
				return this.state.response && this.state.response.draft;
			}
		}, {
			key: "onAssign",
			value: function onAssign() {
				var _this2 = this;
	
				if (this.props.adminPreview) {
					this.setState({ selectedActivityTitle: this.state.activity.format.title }, function () {
						_this2.assignTaskModal.current.show();
					});
				}
			}
		}, {
			key: "hideAssignModal",
			value: function hideAssignModal(selectedUserIDs, showNextModal) {
				showNextModal = showNextModal === null ? false : showNextModal;
	
				this.setState({ selectedUserIDs: selectedUserIDs });
	
				this.assignTaskModal.current.hide();
				if (showNextModal) {
					this.assignExerciseDetailsModal.current.show();
				}
			}
		}, {
			key: "renderAssignTaskModal",
			value: function renderAssignTaskModal() {
				if ($wr.getURLParameterByName("assign_student_ids")) {
					var assignStudentIDs = $wr.getURLParameterByName("assign_student_ids").split(",");
				}
				var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
				return React.createElement(
					Modal,
					{ headerText: modalHeader, ref: this.assignTaskModal, modalOrder: 2 },
					React.createElement(AssignTaskModal, { key: this.state.activity.id,
						selectedStudentIDs: assignStudentIDs,
						renderAdditionalModal: true,
						taskSubjectType: "exercise", taskSubjectID: this.state.activity.id,
						selectedActivityTitle: this.state.selectedActivityTitle,
						onAssign: this.hideAssignModal
					})
				);
			}
		}, {
			key: "renderAssignExerciseDetailsModal",
			value: function renderAssignExerciseDetailsModal() {
				var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
				return React.createElement(
					Modal,
					{ ref: this.assignExerciseDetailsModal, headerText: modalHeader, modalOrder: 3 },
					React.createElement(AssignExerciseDetailsModal, {
						selectedUserIDs: this.state.selectedUserIDs,
						taskSubjectType: "Exercise",
						taskSubjectID: this.state.activity.id,
						selectedActivityTitle: this.state.selectedActivityTitle,
						onAssign: this.hideAssignExerciseDetailsModal })
				);
			}
		}, {
			key: "hideAssignExerciseDetailsModal",
			value: function hideAssignExerciseDetailsModal() {
				this.assignExerciseDetailsModal.current.hide();
			}
		}, {
			key: "render",
			value: function render() {
				if (this.state.activity == null || this.state.loading) {
					return React.createElement(
						"div",
						{ className: "responseComposer" },
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				}
	
				if (this.props.adminPreview) {
					var assignButton = React.createElement(
						"button",
						{ className: "btn buttonSuccess", onClick: this.onAssign },
						"Assign"
					);
	
					var printOp = React.createElement(
						"a",
						{ className: "printOp", href: "#", onClick: this.printActivity },
						React.createElement(Glyphicon, { icon: "print" }),
						" Print Exercise"
					);
	
					var previewNotice = React.createElement(
						TeacherPreviewNotice,
						null,
						assignButton,
						printOp
					);
					var assignModal = this.renderAssignTaskModal();
				}
	
				var textCompletion = this.state.activity.format.text_completion;
	
				if (this.props.requireName) {
					var nameModal = React.createElement(NameModal, { onNameEntry: this.onNameEntry, ref: "nameModal" });
				}
	
				if (!CurrentUser.isAdmin()) {
					if (this.props.book) {
						var textID = this.props.book.text_id;
					}
					var autosaver = React.createElement(Autosaver, { onDeleteClick: this.deleteDraft, textID: textID,
						autosaveLoading: this.state.loading || this.state.autosaveLoading,
						getAutosaveHash: this.getAutosaveHash, onAutosave: this.autosaveResponse });
				}
	
				return React.createElement(
					"div",
					{ className: "responseComposer" },
					nameModal,
					previewNotice,
					React.createElement(Activity, { ref: "activity", activity: this.state.activity,
						response: this.state.response,
						book: this.props.book, onSubmit: this.submitResponse }),
					autosaver,
					assignModal,
					this.renderAssignExerciseDetailsModal()
				);
			}
		}, {
			key: "getAutosaveHash",
			value: function getAutosaveHash() {
				if (this.refs && this.refs.activity) {
					return this.refs.activity.getAutosaveHash();
				}
			}
		}, {
			key: "getMinuteCount",
			value: function getMinuteCount() {
				var diff = Math.round((new Date() - this.state.startDate) / 60000);
				return this.state.previousMinuteCount + diff;
			}
		}, {
			key: "pauseTimer",
			value: function pauseTimer() {
				this.setState({ previousMinuteCount: this.getMinuteCount() });
			}
		}, {
			key: "resumeTimer",
			value: function resumeTimer() {
				this.setState({ startDate: new Date() });
			}
		}, {
			key: "initTimer",
			value: function initTimer() {
				window.actionPause = this.pauseTimer;
				window.actionResume = this.resumeTimer;
				$(window).blur(function () {
					if (window.actionPause) {
						window.actionPause();
					}
				});
				$(window).focus(function () {
					if (window.actionResume) {
						window.actionResume();
					}
				});
			}
		}, {
			key: "getActivity",
			value: function getActivity() {
				CurrentUser.api().getActivity(this.props.activityID, { embed: "activity.format" }, $wr.apiHandler(function (serverResponse) {
					var activity = serverResponse.activity;
	
					if (this.props.responseID) {
						var responseEmbeds = "response.activity,activity.format,response.input_data,response.activity_data,response.evaluation";
						CurrentUser.api().getResponse(this.props.responseID, { embed: responseEmbeds }, $wr.apiHandler(function (serverResponse) {
							this.setActivity(activity, serverResponse.response);
						}.bind(this)));
					} else {
						this.setActivity(activity, null);
					}
				}.bind(this)));
			}
		}, {
			key: "setActivity",
			value: function setActivity(activity, response) {
				var previousMinuteCount = 0;
				if (response) {
					previousMinuteCount = response.minute_count;
				}
				this.setState({ activity: activity, response: response,
					previousMinuteCount: previousMinuteCount, startDate: new Date() });
	
				var mycroftAction = CurrentUser.isStudent() ? "begin" : "begin-preview";
				Mycroft.newEvent({ category: "Activity", action: mycroftAction, label: activity.key });
				this.initTimer();
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.getActivity();
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.actionPause = null;
				window.actionResume = null;
			}
		}]);
	
		return ResponseComposer;
	}(React.Component);
	
	;
	
	ResponseComposer.propTypes = StrictPropTypes({
		// ID of the activity to complete
		activityID: PropTypes.number.isRequired,
	
		// ID of the response draft to edit
		responseID: PropTypes.number,
	
		// Alternate behavior after the redirect
		afterSubmit: PropTypes.func,
	
		// Makes the student enter a name after completing the response
		requireName: PropTypes.bool,
	
		// Is an admin previewing the activity
		adminPreview: PropTypes.bool,
	
		// Book is optional (some don't have text_id)
		book: PropTypes.object,
	
		selectedStudentIDs: PropTypes.array
	});
	
	module.exports = ResponseComposer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Router = __webpack_require__(153);
	var CurrentUser = __webpack_require__(3);
	var ResponseModal = __webpack_require__(175);
	
	var ResponsePage = function (_React$Component) {
		_inherits(ResponsePage, _React$Component);
	
		function ResponsePage(props) {
			_classCallCheck(this, ResponsePage);
	
			var _this = _possibleConstructorReturn(this, (ResponsePage.__proto__ || Object.getPrototypeOf(ResponsePage)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ResponsePage, [{
			key: "render",
			value: function render() {
				var responseID = this.props.match.params.id;
				var responseModal = React.createElement(ResponseModal, { ref: "responseModal", key: responseID,
					responseID: responseID, user: CurrentUser.get(),
					onHide: this.onModalHide });
	
				return React.createElement(
					"div",
					{ className: "container", id: "responsePage" },
					responseModal
				);
			}
		}, {
			key: "onModalHide",
			value: function onModalHide() {
				$wr.redirect('/');
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				this.refs.responseModal.show();
			}
		}]);
	
		return ResponsePage;
	}(React.Component);
	
	;
	
	ResponsePage.propTypes = PageStrictPropTypes({});
	
	module.exports = ResponsePage;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var ImageIcon = __webpack_require__(102);
	var Glyphicon = __webpack_require__(8);
	var UserAvatar = __webpack_require__(239);
	var StandInAvatar = __webpack_require__(373);
	var Formats = __webpack_require__(105);
	var Skillsets = __webpack_require__(55);
	var NameLookup = __webpack_require__(253);
	var TextTypes = __webpack_require__(38);
	var ReactTooltip = __webpack_require__(12);
	
	__webpack_require__(3862);
	
	var ResponseTile = function (_React$Component) {
		_inherits(ResponseTile, _React$Component);
	
		function ResponseTile(props) {
			_classCallCheck(this, ResponseTile);
	
			var _this = _possibleConstructorReturn(this, (ResponseTile.__proto__ || Object.getPrototypeOf(ResponseTile)).call(this));
	
			autobind(_this);
			return _this;
		}
	
		_createClass(ResponseTile, [{
			key: "onClick",
			value: function onClick() {
				if (this.props.onClick) {
					this.props.onClick(this.props.response);
				}
			}
		}, {
			key: "onRemove",
			value: function onRemove(e) {
				e.stopPropagation();
				$wr.nope(e);
				if (this.props.onRemove) {
					this.props.onRemove(this.props.response);
				}
			}
		}, {
			key: "render",
			value: function render() {
				var response = this.props.response;
				var activity = response.activity;
	
				if (response.text && _.size(response.text) > 0) {
					var textInfo = React.createElement(
						"p",
						{ className: "bookTitle" },
						"For: ",
						React.createElement(
							"em",
							null,
							response.text.title
						)
					);
				} else {
					var textInfo = React.createElement(
						"p",
						{ className: "bookTitle" },
						React.createElement(
							"em",
							null,
							"Text provided"
						)
					);
				}
	
				if (this.props.user) {
					var mainUser = React.createElement(
						"span",
						null,
						React.createElement(UserAvatar, { user: this.props.user, maxWidth: 30 }),
						" ",
						this.props.user.display_name
					);
	
					if (response.mirror_user_ids && NameLookup.isLoaded()) {
						var mirrorIDs = _.without(response.mirror_user_ids, this.props.user.id);
						var otherNames = NameLookup.getNames(mirrorIDs);
	
						var otherUsers = React.createElement(
							"span",
							null,
							", " + otherNames.join(", ")
						);
					}
	
					var userLine = React.createElement(
						"div",
						{ className: "userLine" },
						mainUser,
						otherUsers
					);
				} else if (this.props.userName) {
					var userLine = React.createElement(
						"div",
						{ className: "userLine" },
						React.createElement(
							"span",
							null,
							React.createElement(StandInAvatar, { maxWidth: 30 }),
							" ",
							this.props.userName
						)
					);
				}
				if (response.edited_at) {
					var edited = React.createElement(
						"span",
						{ className: "date" },
						"Edited: ",
						$wr.formatDate(response.edited_at)
					);
				}
	
				var activityTitleClassName = "text-center activityTitle";
				if (this.props.onRemove) {
					activityTitleClassName += " narrow";
					var removeButton = React.createElement(
						"button",
						{ className: "btn btn-link removeButton", onClick: this.onRemove,
							"data-tip": "Archive Response" },
						React.createElement(Glyphicon, { icon: "remove" })
					);
				}
	
				var textContent = React.createElement(
					"div",
					{ className: "responseInfo smallText" },
					React.createElement(
						"div",
						{ className: "responseHeader" },
						React.createElement(
							"p",
							{ className: activityTitleClassName },
							React.createElement(
								"strong",
								null,
								activity.format_summary.title
							),
							" "
						),
						removeButton,
						React.createElement(ReactTooltip, { effect: "solid", place: "left" })
					),
					userLine,
					React.createElement(
						"div",
						{ className: "responseBody" },
						textInfo,
						React.createElement(
							"span",
							{ className: "date" },
							"Completed: ",
							$wr.formatDate(response.created_at)
						),
						edited
					)
				);
	
				var className = "tile responseTile";
				if (this.props.onClick) {
					className += " clickableElement";
				}
	
				var skillset = activity.format_summary.skillset;
				return React.createElement(
					"div",
					{ className: className, onClick: this.onClick },
					textContent,
					React.createElement(
						"div",
						{ className: "skillsetTitle smallText" },
						React.createElement("img", { src: Skillsets.getIcon(skillset), className: "skillsetImg" }),
						React.createElement(
							"span",
							{ className: "itemName" },
							Skillsets.getName(skillset)
						)
					)
				);
			}
		}, {
			key: "componentDidMount",
			value: function componentDidMount() {
				if (!NameLookup.isLoaded() && this.props.user && Formats.isCollaboration(this.props.response.activity.format_summary.format_class)) {
					NameLookup.loadStudentNames(function () {
						this.forceUpdate();
						setTimeout(function () {
							$(window).trigger("masonry-update");
						}, 100);
					}.bind(this));
				}
			}
		}]);
	
		return ResponseTile;
	}(React.Component);
	
	;
	
	ResponseTile.propTypes = StrictPropTypes({
		// The response
		response: PropTypes.object.isRequired,
	
		// Function to call when the tile is clicked
		onClick: PropTypes.func,
	
		// Function to archive the response. Will show an "X" if present
		onRemove: PropTypes.func,
	
		// If this is present, we'll show the student and the avatar
		user: PropTypes.object,
	
		// If this is present, we'll show this name and a default avatar
		userName: PropTypes.string
	});
	
	module.exports = ResponseTile;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var Features = __webpack_require__(16);
	var Modal = __webpack_require__(18);
	var Spinner = __webpack_require__(9);
	var Activity = __webpack_require__(170);
	var StudentActivityInfoLine = __webpack_require__(432);
	var ShareResponse = __webpack_require__(431);
	var CommentBox = __webpack_require__(119);
	
	__webpack_require__(3865);
	
	var TeacherViewResponseModal = function (_React$Component) {
		_inherits(TeacherViewResponseModal, _React$Component);
	
		function TeacherViewResponseModal(props) {
			_classCallCheck(this, TeacherViewResponseModal);
	
			var _this = _possibleConstructorReturn(this, (TeacherViewResponseModal.__proto__ || Object.getPrototypeOf(TeacherViewResponseModal)).call(this));
	
			autobind(_this);
			_this.state = {
				responseWithDetails: null
			};
			return _this;
		}
	
		_createClass(TeacherViewResponseModal, [{
			key: "submitScore",
			value: function submitScore(score) {
				var newEvaluation = { score: score, finalized: true };
				var newResponse = _.extend({}, this.state.responseWithDetails, { evaluation: newEvaluation });
	
				var evaluationData = { admin_score: score,
					grader_id: CurrentUser.get().id,
					response_id: this.state.responseWithDetails.id };
	
				var updateWithEvaluation = $wr.apiHandler(function (serverResponse) {
					var newResponse = _.extend({}, this.state.responseWithDetails, { evaluation: serverResponse.evaluation, processed: true });
					this.setState({ responseWithDetails: newResponse });
				}.bind(this));
	
				if (this.state.responseWithDetails.evaluation) {
					var evaluationID = this.state.responseWithDetails.evaluation.id;
					CurrentUser.api().patchEvaluation(evaluationID, { evaluation: evaluationData }, updateWithEvaluation);
	
					Mycroft.newEvent({ category: "Response", action: "update-grade", value: score });
				} else {
					CurrentUser.api().postEvaluations({ evaluation: evaluationData }, updateWithEvaluation);
	
					Mycroft.newEvent({ category: "Response", action: "submit-grade", value: score });
				}
	
				this.setState({ responseWithDetails: newResponse });
			}
		}, {
			key: "archiveResponse",
			value: function archiveResponse() {
				var updateWithProcessedResponse = $wr.apiHandler(function (serverResponse) {
					var newResponse = _.extend({}, this.state.responseWithDetails, { processed: true });
					this.setState({ responseWithDetails: newResponse });
				}.bind(this));
	
				var data = { response: { processed: true }, activity_id: this.state.responseWithDetails.activity_id };
				CurrentUser.api().patchResponse(this.state.responseWithDetails.id, data, updateWithProcessedResponse);
	
				this.refs.modal.hide();
			}
		}, {
			key: "show",
			value: function show() {
				this.refs.modal.show();
				this.fetchDetails();
			}
		}, {
			key: "onHide",
			value: function onHide() {
				setTimeout(function () {
					var responseDetails = this.state.responseWithDetails;
	
					this.setState({ responseWithDetails: null }, function () {
						if (this.props.onResponseUpdate) {
							this.props.onResponseUpdate(responseDetails);
						}
					});
				}.bind(this), 200);
			}
		}, {
			key: "fetchDetails",
			value: function fetchDetails() {
				var embeds = "response.activity,activity.format,response.evaluation,response.input_data,response.input_name,response.activity_data,response.mirror_user_ids,response.text";
				CurrentUser.api().getResponse(this.props.response.id, { embed: embeds }, $wr.apiHandler(function (serverResponse) {
					this.setState({ responseWithDetails: serverResponse.response });
				}.bind(this)));
			}
		}, {
			key: "render",
			value: function render() {
				var response = this.state.responseWithDetails;
	
				if (response == null) {
					var responseContent = React.createElement(
						"div",
						null,
						React.createElement(Spinner, { placeholder: true, scale: 1.7 })
					);
				} else {
	
					if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
						var commentBox = React.createElement(CommentBox, { subjectID: response.id, subjectType: "JournalActivityExercise",
							blockFirstComment: CurrentUser.isStudent(),
							userID: response.user_id, initialCollapsed: !CurrentUser.isStudent() });
					}
	
					var responseContent = React.createElement(
						"div",
						null,
						React.createElement(StudentActivityInfoLine, { response: response,
							forceEvaluation: true, user: this.props.student }),
						React.createElement(Activity, { activity: response.activity,
							response: response }),
						commentBox
					);
					// for now, remove options for sharing collages
					if (response.activity.format.format_class != "CollageFormat") {
						var socialShare = React.createElement(ShareResponse, { responseID: this.props.response.id });
					}
				}
	
				return React.createElement(
					Modal,
					{ className: "teacherViewResponseModal veryWideModal", onHide: this.onHide, ref: "modal" },
					responseContent,
					socialShare
				);
			}
		}]);
	
		return TeacherViewResponseModal;
	}(React.Component);
	
	;
	
	TeacherViewResponseModal.propTypes = StrictPropTypes({
		response: PropTypes.object.isRequired,
		student: PropTypes.object.isRequired,
		onResponseUpdate: PropTypes.func
	});
	
	module.exports = TeacherViewResponseModal;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactDatepicker = __webpack_require__(88);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateSpans = __webpack_require__(177);
	
	var CurrentUser = __webpack_require__(3);
	var Modal = __webpack_require__(18);
	var Spinner = __webpack_require__(9);
	var StudentListDropdownDisplay = __webpack_require__(138);
	var LoadingButton = __webpack_require__(17);
	var StudentDisplay = __webpack_require__(52);
	var RosterRouting = __webpack_require__(93);
	var RosterSelectors = __webpack_require__(6);
	
	var OrgTypes = __webpack_require__(45);
	var OrgDropdown = __webpack_require__(100);
	
	var WritingActions = __webpack_require__(24);
	var WritingSelectors = __webpack_require__(14);
	
	var Features = __webpack_require__(16);
	__webpack_require__(659);
	
	var AssignTaskItemsModal = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    tasks: WritingSelectors.teacherPicksTasks({ state: state })
	  };
	}, function (dispatch, props) {
	  return {
	    createTaskAssignment: function createTaskAssignment(userIDs, state) {
	      // Delete all tasks first
	
	      return dispatch(WritingActions.deleteManyTasks({
	        filters: {
	          subject_type: props.taskSubjectType,
	          subject_id: props.taskSubjectID + ""
	        }
	      })).then(function () {
	        var tasks = _.map(userIDs, function (studentID) {
	          return {
	            user_id: studentID,
	            assigner_id: CurrentUser.get().id,
	            subject_type: props.taskSubjectType,
	            subject_id: props.taskSubjectID
	          };
	        });
	
	        var query = {
	          task_items: {
	            quiz: state.quiz,
	            practice_questions: state.practice_questions_quantity,
	            review: state.review,
	            due_date_enabled: state.due_date_enabled,
	            due_date: new Date(state.due_date),
	            exercises: state.exercise_quantity,
	            question_builders: state.question_builder_quantity
	          }
	        };
	
	        if (tasks.length) {
	          return dispatch(WritingActions.createTasks({ tasks: tasks, query: query }));
	        } else {
	          return Promise.resolve();
	        }
	      });
	    }
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(AssignTaskItemsModal, _React$Component);
	
	  function AssignTaskItemsModal(props) {
	    _classCallCheck(this, AssignTaskItemsModal);
	
	    var _this = _possibleConstructorReturn(this, (AssignTaskItemsModal.__proto__ || Object.getPrototypeOf(AssignTaskItemsModal)).call(this, props));
	
	    _this.handleInputChange = function (event) {
	      var _this$setState;
	
	      var target = event.target;
	      var value = target.type === 'checkbox' ? target.checked : target.value;
	      var name = target.name;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, "none", false), _this$setState));
	
	      if (name === PRACTICE_QUESTIONS && !value) {
	        _this.setState({ practice_questions_quantity: 0 });
	      }
	      if (name === PRACTICE_QUESTIONS && value) {
	        _this.setState({ practice_questions_quantity: 1 });
	      }
	      if (name === EXERCISES && !value) {
	        _this.setState({ exercise_quantity: 0 });
	      }
	      if (name === EXERCISES && value) {
	        _this.setState({ exercise_quantity: 1 });
	      }
	      if (name === QUESTION_BUILDERS && !value) {
	        _this.setState({ question_builder_quantity: 0 });
	      }
	      if (name === QUESTION_BUILDERS && value) {
	        _this.setState({ question_builder_quantity: 1 });
	      }
	    };
	
	    _this.handleNoneInput = function (event) {
	      if (_this.state.none) {
	        _this.setState(BASE_STATE);
	      } else {
	        var baseStateCopy = _extends({}, BASE_STATE);
	        baseStateCopy.none = true;
	        _this.setState(baseStateCopy);
	      }
	    };
	
	    _this.renderDatePicker = function () {
	      var date_picker = '';
	      if (_this.state.due_date_enabled) {
	        date_picker = React.createElement(
	          "span",
	          null,
	          React.createElement(
	            "label",
	            null,
	            React.createElement(_reactDatepicker2.default, { "data-lpignore": "true", readOnly: true, selected: (0, _moment2.default)(_this.state.due_date),
	              onChange: function onChange(date) {
	                return _this.setState({ due_date: date.format(DateSpans.FORMAT) });
	              } })
	          ),
	          React.createElement("br", null)
	        );
	      }
	      return date_picker;
	    };
	
	    _this.renderQuantity = function (quantity_var, boolean_var) {
	      var return_val = '';
	      if (_this.state[boolean_var]) {
	        return_val = React.createElement(
	          "label",
	          null,
	          React.createElement("input", {
	            "data-lpignore": "true",
	            name: quantity_var,
	            type: "number",
	            value: _this.state[quantity_var],
	            onChange: _this.handleInputChange })
	        );
	      }
	      return return_val;
	    };
	
	    autobind(_this);
	
	    var defaultDate = new Date();
	    defaultDate.setDate(defaultDate.getDate() + 7);
	
	    var defaultState = _.extend(BASE_STATE, {
	      loading: false,
	      due_date: defaultDate.toLocaleString(),
	      due_date_enabled: false,
	      task_items: []
	    });
	
	    _this.state = defaultState;
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.submitTasks = _this.submitTasks.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssignTaskItemsModal, [{
	    key: "submitTasks",
	    value: function submitTasks(e) {
	      var _this2 = this;
	
	      $wr.nope(e);
	      this.setState({ loading: true });
	      this.props.createTaskAssignment(this.props.selectedUserIDs, _extends({}, this.state)).then(function () {
	        _this2.setState({ loading: false });
	        var text = "The pick has been assigned";
	        var title = "Pick Assigned";
	        window.wrNotifications.triggerDropDownNotification({
	          title: title, text: text, icon: "ok-sign"
	        });
	        _this2.props.onAssign();
	      });
	    }
	    // renders input box to assign number of activities
	
	  }, {
	    key: "renderCheckBoxes",
	    value: function renderCheckBoxes() {
	      if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
	        var exercises = React.createElement(
	          "span",
	          null,
	          React.createElement(
	            "label",
	            null,
	            React.createElement(
	              "span",
	              null,
	              "Exercises"
	            ),
	            React.createElement("input", {
	              name: "exercises",
	              type: "checkbox",
	              checked: this.state.exercises,
	              onChange: this.handleInputChange })
	          ),
	          this.renderQuantity(EXERCISE_QUANTITY, EXERCISES),
	          React.createElement("br", null)
	        );
	      }
	
	      return React.createElement(
	        "div",
	        { className: 'taskItemModal' },
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "Quiz"
	          ),
	          React.createElement("input", {
	            name: "quiz",
	            type: "checkbox",
	            checked: this.state.quiz,
	            onChange: this.handleInputChange })
	        ),
	        React.createElement("br", null),
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "Practice Questions"
	          ),
	          React.createElement("input", {
	            name: "practice_questions",
	            type: "checkbox",
	            checked: this.state.practice_questions,
	            onChange: this.handleInputChange })
	        ),
	        this.renderQuantity(PRACTICE_QUESTION_QUANTITY, PRACTICE_QUESTIONS),
	        React.createElement("br", null),
	        exercises,
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "Question Builders"
	          ),
	          React.createElement("input", {
	            name: "question_builders",
	            type: "checkbox",
	            checked: this.state.question_builders,
	            onChange: this.handleInputChange })
	        ),
	        this.renderQuantity(QUESTION_BUILDER_QUANTITY, QUESTION_BUILDERS),
	        React.createElement("br", null),
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "Review"
	          ),
	          React.createElement("input", {
	            name: "review",
	            type: "checkbox",
	            checked: this.state.review,
	            onChange: this.handleInputChange })
	        ),
	        React.createElement("br", null),
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "Add Due Date"
	          ),
	          React.createElement("input", {
	            name: "due_date_enabled",
	            type: "checkbox",
	            checked: this.state.due_date_enabled,
	            onChange: this.handleInputChange })
	        ),
	        React.createElement("br", null),
	        this.renderDatePicker(),
	        React.createElement(
	          "label",
	          null,
	          React.createElement(
	            "span",
	            null,
	            "None"
	          ),
	          React.createElement("input", {
	            name: "none",
	            type: "checkbox",
	            checked: this.state.none,
	            onChange: this.handleNoneInput })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "form",
	        null,
	        this.renderCheckBoxes(),
	        React.createElement(LoadingButton, { className: "btn buttonSuccess center-block",
	          loading: this.state.loading, text: 'Assign',
	          onClick: this.submitTasks })
	      );
	    }
	  }]);
	
	  return AssignTaskItemsModal;
	}(React.Component)) || _class);
	;
	
	var PRACTICE_QUESTIONS = 'practice_questions';
	var PRACTICE_QUESTION_QUANTITY = 'practice_questions_quantity';
	var EXERCISES = 'exercises';
	var EXERCISE_QUANTITY = 'exercise_quantity';
	var QUESTION_BUILDERS = 'question_builders';
	var QUESTION_BUILDER_QUANTITY = 'question_builder_quantity';
	
	var BASE_STATE = {
	  none: false,
	  quiz: false,
	  review: false,
	  practice_questions: false,
	  practice_questions_quantity: 0,
	  exercises: false,
	  exercise_quantity: 0,
	  question_builders: false,
	  question_builder_quantity: 0,
	  due_date_enabled: false
	};
	
	AssignTaskItemsModal.WrappedComponent.propTypes = StrictPropTypes({
	  // ID of the task we're assigning
	  taskSubjectID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	
	  onAssign: PropTypes.func,
	  selectedUserIDs: PropTypes.array,
	
	  // subject type of the task we are assigning
	  taskSubjectType: PropTypes.string.isRequired,
	
	  // From @connect
	  tasks: PropTypes.array,
	  selectedActivityTitle: PropTypes.string,
	  createTaskItems: PropTypes.func,
	  createTaskAssignment: PropTypes.func
	});
	
	module.exports = AssignTaskItemsModal;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	"use strict";
	
	var GradeLevelSpecifications = {
	  "01_TEXT-SPE_read-the-book": {
	    "default": ["2 specific details from the text, regardless of relevance to the question"]
	  },
	  "02_READ-COMP_fully-answered": {
	    "default": ["Are all parts of the question answered?"]
	  },
	  "03_READ-COMP_answer-present": {
	    "default": ["See Sample Answers"]
	  },
	  "04_MECH_capitalization": {
	    "default": ["See Sample Answers"]
	  },
	  "05_MECH_grammar": {
	    "default": ["See Sample Answers"]
	  },
	  "06_MECH_introduction": {
	    "1": ["1. Not yet expected"],
	    "2": ["1. Some context expected in the first sentence"],
	    "3": ["1. Context expected in the first sentence"],
	    "4": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
	    "5": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
	    "6": ["1. Somewhat-effectively introduce the topic or situation in the first sentence"],
	    "7": ["1. Effectively introduces a topic or situation in the first sentence"],
	    "8": ["1. Effectively introduces a topic or situation in the first sentence"],
	    "9": ["1. Effectively introduces a topic or situation in the first sentence"]
	  },
	  "07_MECH_ling-accpt": {
	    "default": ["1. Must use words with the intention of making meaning (not nonsense)"]
	  },
	  "08_MECH_punct": {
	    "default": ["See Sample Answers"]
	  },
	  "09_MECH_repetitions": {
	    "1": ["1. None: 2 repeates", "2. Some: 3 or fewer", "3. Many: more than 3"],
	    "2": ["1. None: 1 repeate", "2. Some: 2 or 3 repeates", "3. Many: more than 3"],
	    "3": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
	    "4": ["1. None: none", "2. Some: 3 or fewer", "3. Many: more than 3"],
	    "5": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
	    "6": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
	    "7": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
	    "8": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"],
	    "9": ["1. None: none", "2. Some: 2 or fewer", "3. Many: more than 2"]
	  },
	  "10_READ-COMP_restating": {
	    "1": ["1. not yet expected (but please click the correct evaluation anyway)"],
	    "2": ["1. not yet expected (but please click the correct evaluation anyway)"],
	    "3": ["1. restates at least one question asked"],
	    "default": ["Restates all parts of the question/s?"]
	  },
	  "11_LEN_sent-count": {
	    "1": ["1. One complete sentence"],
	    "2": ["1. Two or more complete sentences"],
	    "3": ["1. Two or more complete sentences"],
	    "4": ["1. Two or more complete sentences"],
	    "5": ["1. Two or more complete sentences"],
	    "6": ["1. Three or more complete sentences"],
	    "7": ["1. Four or more complete sentences"],
	    "8": ["1. Four or more complete sentences"],
	    "9": ["1. Four or more complete sentences"]
	  },
	  "12_MECH_sent-struct": {
	    "1": ["Solid:", "1. Sentences have a subject & predicate (noun & verb)", "2. Not yet expected: Doesn't have run-on sentences"],
	    "2": ["Solid:", "1. Sentences have a subject & predicate (noun & verb)", "2. If 3 or more sentences: Adjective or Adverb--1 used for every 3 sentences in answer", "3. If 3 or more sentences: Compound sentence with the conjunctions (and, but)--1 used for every 3 sentences in answer", "4. Doesn't have exclusively run-on sentences"],
	    "3": ["Solid:", "1. sentences have a subject & predicate (noun & verb)", "2. If 3 or more sentences: Adjective or Adverb--1 used for every 3 sentences in answer", "3. If 3 or more sentences: Compound sentence with the conjunctions (and, but, for, neither/nor, or)--1 used for every 3 sentences in answer", "4. Doesn't have any run-on sentences"],
	    "4": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are somewhat varied and complex"],
	    "5": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are varied and complex", "3. Show understanding of usage of conjunctions", "4. Have accurate quotes from passages."],
	    "6": ["Solid:", "1. Complete sentences without fragments or run-ons", "2. Sentences are appropriately varied, complex to enhance meaning."],
	    "7": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."],
	    "8": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."],
	    "9": ["1. Solid: Effectively varies sentence patterns for meaning.", "2. Partial: Varies some sentence patterns for meaning.", "3. No structure: Has fragments, run-ons, and/or other sentence structure errors."]
	  },
	  "13_MECH_spelling": {
	    "default": ["See Sample Answers"]
	  },
	  "14_TEXT-SPE_text-details-count": {
	    "1": ["Two specific details"],
	    "2": ["Two specific details"],
	    "3": ["Two specific details"],
	    "4": ["Two specific details"],
	    "5": ["Three specific details"],
	    "6": ["Three specific details"],
	    "7": ["Four specific details"],
	    "8": ["Five specific details"],
	    "9": ["Six specific details"]
	  },
	  "15_MECH_transition": {
	    "1": ["Not required", "1. But could be between ideas, sentences, or to show time (first, then, because, also)"],
	    "2": ["Not required", "1. But could be between ideas, sentences or to show time (first, second, third, then, because, also; after, next, before, last)"],
	    "3": ["Not required", "1. But could be between ideas, sentences, to show time, conclusion (first, second, third, then, because, also, after, next, before, last)", "2. Or to indicate more to come (besides, in addition)"],
	    "4": ["Standard: At least 1 transition in answers of 3 or more sentences"],
	    "5": ["Standard: At least 1 transition in answers of 3 or more sentences"],
	    "6": ["Standard: At least 1 transition in answers of 3 or more sentences"],
	    "7": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"],
	    "8": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"],
	    "9": ["Standard: Include a conclusion statement/s and use at least 1 transition per 3 sentences"]
	  },
	  "16_VOC_complex-vocab": {
	    "1": ["One or more appropriate usages"],
	    "2": ["One or more appropriate usages"],
	    "3": ["One or more appropriate usages"],
	    "4": ["Two or more appropriate usages"],
	    "5": ["Two or more appropriate usages"],
	    "6": ["Two or more appropriate usages"],
	    "7": ["One or more appropriate usage"],
	    "8": ["Two or more appropriate usages"],
	    "9": ["Three or more appropriate usages"]
	  },
	  "17_TEXT-SPE_text-details-qual": {
	    "default": ["Regardless of accuracy--do the details apply to the question asked?"]
	  },
	  "18_LEN_sent-count": {
	    "1": ["Sentences have at least 2 words"],
	    "2": ["Sentences have at least 4 words"],
	    "3": ["Sentences have at least 5 words"],
	    "4": ["Sentences have 5 or more words, or one sentence type"],
	    "5": ["Sentences have 6 or more words, or one sentence type"],
	    "6": ["Sentences have 7 or more words, or one sentence type"],
	    "7": ["At least 2 types of sentences"],
	    "8": ["At least 3 types of sentences"],
	    "9": ["At least 4 types of sentences"]
	  }
	};
	
	module.exports = GradeLevelSpecifications;

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	"use strict";
	
	var StandardComments = {
		ALL: [{ type: "positive", group: "Content", subgroup: "overall",
			body: "I like that you wrote a very thoughtful and creative answer!" }, { type: "negative", group: "Content", subgroup: "overall",
			body: "Please stay focused on answering the question." }, { type: "positive", group: "Content", subgroup: "restatement",
			body: "I like that you restated the question in your answer!" }, { type: "negative", group: "Content", subgroup: "restatement",
			body: "Please restate the question in your answer." }, { type: "positive", group: "Content", subgroup: "all-parts",
			body: "I like that you answered all parts of the question!" }, { type: "negative", group: "Content", subgroup: "all-parts",
			body: "Please answer all parts of the question." }, { type: "positive", group: "Content", subgroup: "text-evidence",
			body: "I like that you used evidence from the text in your answer!" }, { type: "negative", group: "Content", subgroup: "text-evidence",
			body: "Please use evidence from the text in your answer." }, { type: "positive", group: "Content", subgroup: "description",
			body: "I like that you used description and details in your answer!" }, { type: "negative", group: "Content", subgroup: "description",
			body: "Please use more description and details in your answer." }, { type: "positive", group: "Content", subgroup: "organized",
			body: "I like that you organized your answer well and it is easy to read!" }, { type: "negative", group: "Content", subgroup: "organized",
			body: "Please read your answer after you finish to make sure it is organized and easy to read." }, { type: "positive", group: "Mechanics", subgroup: "length",
			body: "I like how much you wrote!" }, { type: "negative", group: "Mechanics", subgroup: "length",
			body: "Please make sure you are writing enough." }, { type: "positive", group: "Mechanics", subgroup: "vocabulary",
			body: "I like that you used advanced vocabulary!" }, { type: "negative", group: "Mechanics", subgroup: "vocabulary",
			body: "Please use grade-level vocabulary instead of basic vocabulary." }, { type: "positive", group: "Mechanics", subgroup: "spelling",
			body: "I like that you paid attention to spelling!" }, { type: "negative", group: "Mechanics", subgroup: "spelling",
			body: "Please remember to check your spelling." }, { type: "positive", group: "Mechanics", subgroup: "grammar",
			body: "I like that you paid attention to grammar!" }, { type: "negative", group: "Mechanics", subgroup: "grammar",
			body: "Please remember to check your grammar." }, { type: "positive", group: "Mechanics", subgroup: "sentences",
			body: "I like that you wrote in complete sentences!" }, { type: "negative", group: "Mechanics", subgroup: "sentences",
			body: "Please write in complete sentences." }, { type: "positive", group: "Mechanics", subgroup: "general-mechanics",
			body: "I like that you used a good mix of long and short sentences!" }, { type: "negative", group: "Mechanics", subgroup: "general-mechanics",
			body: "Please watch the length and punctuation of your sentences to avoid run-on sentences." }, { type: "positive", group: "Mechanics", subgroup: "capitalization",
			body: "I like that you used capital letters correctly!" }, { type: "negative", group: "Mechanics", subgroup: "capitalization",
			body: "Please remember to use capital letters." }, { type: "negative", group: "Mechanics", subgroup: "capitalization",
			body: "Please do not capitalize words that should not be capitalized." }, { type: "positive", group: "Mechanics", subgroup: "punctuation",
			body: "I like that you used punctuation correctly!" }, { type: "negative", group: "Mechanics", subgroup: "punctuation",
			body: "Please use punctuation marks in the right places." }, { type: "positive", group: "Mechanics", subgroup: "commas",
			body: "I like that you used commas correctly!" }, { type: "negative", group: "Mechanics", subgroup: "commas",
			body: "Please use commas in the right places." }]
	};
	
	module.exports = StandardComments;

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.registerBatched = registerBatched;
	var registered = {};
	var requested = {};
	var received = {};
	
	function registerBatched(key, ids, fetchF) {
		return function (dispatch) {
			// Only use string keys
			ids = _.map(ids, String);
	
			// Filter out ids already in registered, requested, or received
			ids = _.reject(ids, function (id) {
				return _.any([registered, requested, received], function (collection) {
					return key in collection && _.includes(collection[key], id);
				});
			});
	
			// Only continue if there are at least one id left
			if (ids.length == 0) {
				return;
			}
	
			addIDsToStage(registered, key, ids);
	
			// Registers a new timeout to trigger the fetch function
			setTimeout(function () {
	
				// Clear out the registered IDs
				var requestIDs = registered[key];
	
				// If requestIDs if empty, a previous handler must have requested our IDs
				if (requestIDs.length == 0) {
					return;
				}
	
				// Move IDs into requested from registered
				registered[key] = [];
				addIDsToStage(requested, key, requestIDs);
	
				dispatch(fetchF(requestIDs)).then(function () {
					requested[key] = _.difference(requested[key], requestIDs);
					addIDsToStage(received, key, requestIDs);
				});
			}, BATCH_TIMEOUT);
		};
	}
	
	function addIDsToStage(collection, key, ids) {
		if (!(key in collection)) {
			collection[key] = [];
		}
		collection[key] = collection[key].concat(ids);
	}
	
	// Hopefully long enough for render delays not trip us up
	// But not so slow as to delay the user's experience
	var BATCH_TIMEOUT = 50;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//const Schema = require("lib/shared/Schema");
	var APIClient = __webpack_require__(110);
	//const ActionUtility = require("lib/shared/ActionUtility");
	// const Queries = require("lib/shared/Queries");
	
	var createUserAlert = exports.createUserAlert = function createUserAlert(_ref) {
	  var userAlertData = _ref.userAlertData;
	  return function (dispatch) {
	    return APIClient.postUserAlerts(userAlertData);
	  };
	};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var IMAGES = exports.IMAGES = [{
		category: "Airport",
		path: __webpack_require__(3260)
	}, {
		category: "Airport",
		path: __webpack_require__(3261)
	}, {
		category: "Airport",
		path: __webpack_require__(3262)
	}, {
		category: "Amusement Parks",
		path: __webpack_require__(3263)
	}, {
		category: "Amusement Parks",
		path: __webpack_require__(3264)
	}, {
		category: "Amusement Parks",
		path: __webpack_require__(3265)
	}, {
		category: "Amusement Parks",
		path: __webpack_require__(3266)
	}, {
		category: "Amusement Parks",
		path: __webpack_require__(3267)
	}, {
		category: "Animals",
		path: __webpack_require__(3268)
	}, {
		category: "Animals",
		path: __webpack_require__(3269)
	}, {
		category: "Animals",
		path: __webpack_require__(3270)
	}, {
		category: "Animals",
		path: __webpack_require__(3271)
	}, {
		category: "Animals",
		path: __webpack_require__(3272)
	}, {
		category: "Animals",
		path: __webpack_require__(3273)
	}, {
		category: "Animals",
		path: __webpack_require__(3274)
	}, {
		category: "Animals",
		path: __webpack_require__(3275)
	}, {
		category: "Animals",
		path: __webpack_require__(3276)
	}, {
		category: "Animals",
		path: __webpack_require__(3277)
	}, {
		category: "Animals",
		path: __webpack_require__(3278)
	}, {
		category: "Animals",
		path: __webpack_require__(3279)
	}, {
		category: "Animals",
		path: __webpack_require__(3280)
	}, {
		category: "Animals",
		path: __webpack_require__(3281)
	}, {
		category: "Animals",
		path: __webpack_require__(3282)
	}, {
		category: "Animals",
		path: __webpack_require__(3283)
	}, {
		category: "Animals",
		path: __webpack_require__(3284)
	}, {
		category: "Animals",
		path: __webpack_require__(3285)
	}, {
		category: "Animals",
		path: __webpack_require__(3286)
	}, {
		category: "Animals",
		path: __webpack_require__(3287)
	}, {
		category: "Animals",
		path: __webpack_require__(3288)
	}, {
		category: "Animals",
		path: __webpack_require__(3289)
	}, {
		category: "Animals",
		path: __webpack_require__(3290)
	}, {
		category: "Animals",
		path: __webpack_require__(3291)
	}, {
		category: "Animals",
		path: __webpack_require__(3292)
	}, {
		category: "Animals",
		path: __webpack_require__(3293)
	}, {
		category: "Animals",
		path: __webpack_require__(3294)
	}, {
		category: "Animals",
		path: __webpack_require__(3295)
	}, {
		category: "Animals",
		path: __webpack_require__(3296)
	}, {
		category: "Animals",
		path: __webpack_require__(3297)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3298)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3299)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3300)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3301)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3302)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3303)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3304)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3305)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3306)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3307)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3308)
	}, {
		category: "Black & White Images",
		path: __webpack_require__(3309)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3310)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3311)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3312)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3313)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3314)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3315)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3316)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3317)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3318)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3319)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3320)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3321)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3322)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3323)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3324)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3325)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3326)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3327)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3328)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3329)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3330)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3331)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3332)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3333)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3334)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3335)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3336)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3337)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3338)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3339)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3340)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3341)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3342)
	}, {
		category: "Cities & Countries",
		path: __webpack_require__(3343)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3344)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3345)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3346)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3347)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3348)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3349)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3350)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3351)
	}, {
		category: "National & State Parks",
		path: __webpack_require__(3352)
	}, {
		category: "Nature",
		path: __webpack_require__(3353)
	}, {
		category: "Nature",
		path: __webpack_require__(3354)
	}, {
		category: "Nature",
		path: __webpack_require__(3355)
	}, {
		category: "Nature",
		path: __webpack_require__(3356)
	}, {
		category: "Nature",
		path: __webpack_require__(3357)
	}, {
		category: "Nature",
		path: __webpack_require__(3358)
	}, {
		category: "Nature",
		path: __webpack_require__(3359)
	}, {
		category: "Around The House",
		path: __webpack_require__(3360)
	}, {
		category: "Around The House",
		path: __webpack_require__(3361)
	}, {
		category: "Around The House",
		path: __webpack_require__(3362)
	}, {
		category: "Around The House",
		path: __webpack_require__(3363)
	}, {
		category: "Around The House",
		path: __webpack_require__(3364)
	}, {
		category: "Around The House",
		path: __webpack_require__(3365)
	}, {
		category: "Around The House",
		path: __webpack_require__(3366)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3367)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3368)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3369)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3370)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3371)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3372)
	}, {
		category: "Places To Hang Out After School",
		path: __webpack_require__(3373)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3374)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3375)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3376)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3377)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3378)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3379)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3380)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3381)
	}, {
		category: "Random Backgrounds",
		path: __webpack_require__(3382)
	}, {
		category: "School",
		path: __webpack_require__(3383)
	}, {
		category: "School",
		path: __webpack_require__(3384)
	}, {
		category: "School",
		path: __webpack_require__(3385)
	}, {
		category: "School",
		path: __webpack_require__(3386)
	}, {
		category: "School",
		path: __webpack_require__(3387)
	}, {
		category: "School",
		path: __webpack_require__(3388)
	}];

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAPTIONS = exports.CAPTIONS = [{
	  text: "Feeling hootiful today",
	  category: "Puns"
	}, {
	  text: "I've got my eyes on hoo",
	  category: "Puns"
	}, {
	  text: "Everyone's hootin' at me",
	  category: "Puns"
	}, {
	  text: "Owl see you later",
	  category: "Puns"
	}, {
	  text: "Owlways late...sorry",
	  category: "Puns"
	}, {
	  text: "Owlways slaying the day",
	  category: "Puns"
	}, {
	  text: "Me, myself, and owl",
	  category: "Puns"
	}, {
	  text: "Owl I need is some love",
	  category: "Puns"
	}, {
	  text: "Owl I need is some coffee",
	  category: "Puns"
	}, {
	  text: "I'm a night owl",
	  category: "Puns"
	}, {
	  text: "I'm a know-it-owl",
	  category: "Puns"
	}, {
	  text: "By owl means, tell me I'm cute",
	  category: "Puns"
	}, {
	  text: "I'll owlways be there for you",
	  category: "Puns"
	}, {
	  text: "I'm a day dreamer and a night thinker",
	  category: "Puns"
	}, {
	  text: "Smart owleck",
	  category: "Puns"
	}, {
	  text: "Hooooo let the dogs out?",
	  category: "Puns"
	}, {
	  text: "Owl be waiting",
	  category: "Puns"
	}, {
	  text: "Owl-Am a reader",
	  category: "Puns"
	}, {
	  text: "Owlways love to learn",
	  category: "Puns"
	}, {
	  text: "Owl help you",
	  category: "Puns"
	}, {
	  text: "How's this outfit? Yes or no?",
	  category: "Non-Puns"
	}, {
	  text: "Every day I'm flipping pages",
	  category: "Non-Puns"
	}, {
	  text: "'A day without laughter is a day wasted' -Charlie Chaplin",
	  category: "Non-Puns"
	}, {
	  text: "Sun's shining but I'm brighter",
	  category: "Non-Puns"
	}, {
	  text: "Messy hair, don't care",
	  category: "Non-Puns"
	}, {
	  text: "'The only way to have a friend is to be one' -Ralph Waldo Emmerson",
	  category: "Non-Puns"
	}, {
	  text: "Beach day!!!",
	  category: "Non-Puns"
	}, {
	  text: "'I solemnly swear I am up to no good.' ― Harry Potter",
	  category: "Non-Puns"
	}, {
	  text: "Espresso yourself",
	  category: "Non-Puns"
	}, {
	  text: "See you on the Hogwarts express",
	  category: "Non-Puns"
	}, {
	  text: "I see you seeing me",
	  category: "Non-Puns"
	}, {
	  text: "Smiling cuz' it's summer",
	  category: "Non-Puns"
	}, {
	  text: "Live, love, laugh",
	  category: "Non-Puns"
	}, {
	  text: "Be love",
	  category: "Non-Puns"
	}, {
	  text: "Everyday I'm hustling ",
	  category: "Non-Puns"
	}, {
	  text: "Be a baguette in a box of bagels",
	  category: "Non-Puns"
	}, {
	  text: "Work hard, be kind",
	  category: "Non-Puns"
	}, {
	  text: "Girl from another world",
	  category: "Non-Puns"
	}, {
	  text: "Boy from another world",
	  category: "Non-Puns"
	}, {
	  text: "Owl from another world",
	  category: "Non-Puns"
	}, {
	  text: "Be happy",
	  category: "Non-Puns"
	}, {
	  text: "Smile while you still have teeth",
	  category: "Non-Puns"
	}, {
	  text: "Seas the day",
	  category: "Non-Puns"
	}, {
	  text: "You're snow much fun",
	  category: "Non-Puns"
	}, {
	  text: "Say 'Happy Birthday' to me!",
	  category: "Non-Puns"
	}, {
	  text: "Can you not?",
	  category: "Non-Puns"
	}, {
	  text: "Be blessed",
	  category: "Non-Puns"
	}, {
	  text: "Just beeee yourself",
	  category: "Non-Puns"
	}, {
	  text: "Motivation Monday",
	  category: "Non-Puns"
	}, {
	  text: "Travel Tuesday",
	  category: "Non-Puns"
	}, {
	  text: "Taco Tuesday",
	  category: "Non-Puns"
	}, {
	  text: "Wisdom Wednesday",
	  category: "Non-Puns"
	}, {
	  text: "Fashion Friday",
	  category: "Non-Puns"
	}, {
	  text: "Saturday Style",
	  category: "Non-Puns"
	}, {
	  text: "Sunday Funday",
	  category: "Non-Puns"
	}, {
	  text: "Sunshine mixed with a little hurricane",
	  category: "Non-Puns"
	}, {
	  text: "Hi there!",
	  category: "Non-Puns"
	}, {
	  text: "Struck by wanderlust",
	  category: "Non-Puns"
	}, {
	  text: "Eat, sleep, travel, repeat",
	  category: "Non-Puns"
	}, {
	  text: "Good friends bring you coffee",
	  category: "Non-Puns"
	}, {
	  text: "Good things come to those who sleep",
	  category: "Non-Puns"
	}, {
	  text: "Lovin' nature",
	  category: "Non-Puns"
	}, {
	  text: "In my happy place",
	  category: "Non-Puns"
	}, {
	  text: "Smiles are always trending",
	  category: "Non-Puns"
	}, {
	  text: "Be unique",
	  category: "Non-Puns"
	}, {
	  text: "Work hard and the rest will fall into place",
	  category: "Non-Puns"
	}, {
	  text: "Enjoy the moments, for one day, they will become memories",
	  category: "Non-Puns"
	}, {
	  text: "#rockyourself",
	  category: "Hashtag"
	}, {
	  text: "#imabird",
	  category: "Hashtag"
	}, {
	  text: "#love",
	  category: "Hashtag"
	}, {
	  text: "#photooftheday",
	  category: "Hashtag"
	}, {
	  text: "#beautiful",
	  category: "Hashtag"
	}, {
	  text: "#hootiful",
	  category: "Hashtag"
	}, {
	  text: "#fashion",
	  category: "Hashtag"
	}, {
	  text: "#travel",
	  category: "Hashtag"
	}, {
	  text: "#summer",
	  category: "Hashtag"
	}, {
	  text: "#winter",
	  category: "Hashtag"
	}, {
	  text: "#spring",
	  category: "Hashtag"
	}, {
	  text: "#fall",
	  category: "Hashtag"
	}, {
	  text: "#beachgirl",
	  category: "Hashtag"
	}, {
	  text: "#beachboy",
	  category: "Hashtag"
	}, {
	  text: "#beachowl",
	  category: "Hashtag"
	}, {
	  text: "#wanderer",
	  category: "Hashtag"
	}, {
	  text: "#model",
	  category: "Hashtag"
	}, {
	  text: "#style",
	  category: "Hashtag"
	}, {
	  text: "#happy",
	  category: "Hashtag"
	}, {
	  text: "#food",
	  category: "Hashtag"
	}, {
	  text: "#owlsjustwannahavefun",
	  category: "Hashtag"
	}, {
	  text: "#owlstagood",
	  category: "Hashtag"
	}, {
	  text: "#selfie",
	  category: "Hashtag"
	}, {
	  text: "#nofilter",
	  category: "Hashtag"
	}, {
	  text: "#owlwaysready",
	  category: "Hashtag"
	}, {
	  text: "#owlsrock",
	  category: "Hashtag"
	}, {
	  text: "#happyplace",
	  category: "Hashtag"
	}, {
	  text: "#trendsetter",
	  category: "Hashtag"
	}, {
	  text: "#uniqueness",
	  category: "Hashtag"
	}, {
	  text: "#NewYork",
	  category: "Hashtag"
	}, {
	  text: "#London",
	  category: "Hashtag"
	}, {
	  text: "#Dubai",
	  category: "Hashtag"
	}, {
	  text: "#Switzerland",
	  category: "Hashtag"
	}, {
	  text: "#Iloveanimals",
	  category: "Hashtag"
	}, {
	  text: "#tacos",
	  category: "Hashtag"
	}, {
	  text: "#bookworm",
	  category: "Hashtag"
	}];

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isActive = isActive;
	exports.init = init;
	exports.upgrade = upgrade;
	function isActive() {
		return ("production") === "production";
	}
	
	function init() {
		if (!isActive()) {
			return;
		}
	
		!function (f, b, e, v, n, t, s) {
			if (f.fbq) return;n = f.fbq = function () {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};if (!f._fbq) f._fbq = n;
			n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;
			t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
		}(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js');
	
		fbq('init', '888301704521459');
		fbq('track', "PageView");
	}
	
	function upgrade(value) {
		if (!isActive()) {
			return;
		}
	
		fbq('track', 'Subscribe', {
			value: 10,
			currency: 'USD'
		});
	}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	'use strict';
	
	var GoogleClassroomSync = {
		beginSync: function beginSync(finalCallback, updateMessageCallback) {
			var teacherData = {};
			var teacherCourses = [];
	
			function requestAuth() {
				var clientID = "685312089971-sq3b4ov7s8e1c8774hakb0tq5i8v9l6q.apps.googleusercontent.com";
				var scopes = ['https://www.googleapis.com/auth/classroom.courses.readonly', 'https://www.googleapis.com/auth/classroom.rosters.readonly', "email", "profile", 'https://www.googleapis.com/auth/userinfo.profile'];
	
				gapi.auth.authorize({ client_id: clientID, scope: scopes, immediate: false, authuser: -1 }, function (authResult) {
					if (authResult && !authResult.error) {
						updateMessageCallback("Fetching account...");
						getTeacherData();
					} else {
						console.log("Error 1");
						finalCallback(false, null, null, "Error loading google account");
					}
				});
			}
	
			function getTeacherData() {
				var request = gapi.client.request({
					root: 'https://www.googleapis.com',
					path: 'oauth2/v1/userinfo?alt=json'
				});
	
				request.execute(function (response) {
					teacherData = {
						first_name: response.given_name,
						last_name: response.family_name,
						sign_in_email: response.email,
						google_sso_id: response.id
					};
	
					updateMessageCallback("Fetching courses...");
					getCourses();
				});
			}
	
			function getCourses() {
				var request = gapi.client.request({
					root: 'https://classroom.googleapis.com',
					path: 'v1/courses'
				});
	
				request.execute(function (response) {
					var courses = response.courses;
					if (typeof courses != 'undefined') {
						if (courses.length > 0) {
							var ownerIDs = [];
	
							for (var i = 0; i < courses.length; i++) {
								if (courses[i].courseState == "ACTIVE") {
									teacherCourses = teacherCourses.concat([{
										name: courses[i].name,
										google_id: courses[i].id,
										students: []
									}]);
									ownerIDs.push(courses[i].ownerId);
								}
							}
	
							if (_.includes(ownerIDs, teacherData.google_sso_id)) {
								getStudents(0, null);
							} else {
								console.log("Error 6");
								finalCallback(false, null, null, "You can only sign up with a teacher's Google account.");
							}
						} else {
							console.log("Error 4");
							finalCallback(false, null, null, "You don't have any courses on Google Classroom.");
						}
					} else {
						console.log("Error 5");
						finalCallback(false, null, null, "We were not able to retrieve your Google Classroom data. Did you use the right Google account?");
					}
				});
			}
	
			// Should be called once, in order, for every course in teacherCourses
			function getStudents(courseIndex, pageToken) {
				var course = teacherCourses[courseIndex];
	
				if (course) {
					var request = gapi.client.request({
						root: 'https://classroom.googleapis.com',
						path: 'v1/courses/' + course.google_id + '/students',
						params: {
							pageToken: pageToken
						}
					});
	
					updateMessageCallback("Fetching students (" + (courseIndex + 1) + ")...");
	
					request.execute(function (response) {
						if (response.students && response.students.length > 0) {
							course["students"] = course["students"].concat(response.students.map(function (student) {
								return {
									first_name: student.profile.name.givenName,
									last_name: student.profile.name.familyName,
									google_sign_in_id: student.profile.id
								};
							}));
						} else {
							course["students"] = [];
							console.log("No students!");
						}
	
						if (response.nextPageToken) {
							getStudents(courseIndex, response.nextPageToken);
						} else {
							getStudents(courseIndex + 1, null);
						}
					}.bind(this));
				} else {
					finalCallback(true, teacherData, teacherCourses);
				}
			}
	
			requestAuth();
		}
	};
	
	module.exports = GoogleClassroomSync;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var CurrentUser = __webpack_require__(3);
	
	var LuckyOrangeClient = {
		forced: false,
		userTagged: false,
		lo_id: 149493,
		init: function init() {
			if ($wr.isProduction()) {
				// window.__lo_log_console = true;
				// window.__lo_site_id = this.lo_id;
	
				var wa = document.createElement('script');
				wa.type = 'text/javascript';
				wa.async = true;
				wa.src = 'https://tools.luckyorange.com/core/lo.js?site-id=29d2c8b1';
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(wa, s);
			}
		},
	
		tagUser: function tagUser() {
			var user = CurrentUser.get();
			if (!user) {
				window._loq.push(["tag", "signedOut"]); // PRODUCT
				return;
			}
			window._loq = window._loq || []; // ensure queue available
			window._loq.push(["tag", "user_id:" + user.id]); // USER ID
			window._loq.push(["tag", user.account.product]); // PRODUCT
			var role = user.role;
			window._loq.push(["tag", role]); // ROLE
	
	
			if (role == "studentRole") {
				if (user.primary_student_list) {
					window._loq.push(["tag", "primary_student_list_id:" + user.primary_student_list.id]); // PRODUCT
				}
				if (user.pending_onboarding) {
					window._loq.push(["tag", "studentOnboarding"]);
				}
			} else {
				if (user.pending_onboarding) {
					window._loq.push(["tag", "adminOnboarding"]);
				}
				// CHECK FOR PEDING CHECKLIST
				if (this.isOnboardingComplete(user)) {
					window._loq.push(["tag", "onboardingChecklistComplete"]);
				} else {
					window._loq.push(["tag", "onboardingChecklistPending"]);
				}
			}
			if (user.school) {
				window._loq.push(["tag", "school_canonical_id:" + user.school.canonical_id]); // PRODUCT
			}
			if (user.grade_level) {
				window._loq.push(["tag", "grade_level:" + user.grade_level]);
			}
			if (user.last_active == null) {
				window._loq.push(["tag", "first_session"]);
			}
			if ($wr.isProduction()) {
				window._loq.push(["tag", "production"]);
			} else {
				window._loq.push(["tag", "development"]);
			}
			this.getAdoptionFunnel(user);
			this.tagSplitTest();
			this.userTagged = true;
		},
		tagSplitTest: function tagSplitTest() {
			if (typeof Mycroft != "undefined") {
				_.each(Mycroft.splitTests, function (test) {
					window._loq.push(["tag", test.full_variation]);
				});
			}
		},
		getAdoptionFunnel: function getAdoptionFunnel(user) {
			var created_at = new Date(user.created_at);
			var now = new Date();
			var diffTime = Math.abs(created_at.getTime() - now.getTime());
			var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			if (diffDays < 1) {
				window._loq.push(["tag", "first_day"]);
			} else if (diffDays < 8) {
				window._loq.push(["tag", "first_week"]);
			} else if (diffDays < 15) {
				window._loq.push(["tag", "second_week"]);
			} else if (diffDays < 32) {
				window._loq.push(["tag", "first_month"]);
			} else if (diffDays < 62) {
				window._loq.push(["tag", "second_month"]);
			} else {
				window._loq.push(["tag", "three_months_plus"]);
			}
		},
		isOnboardingComplete: function isOnboardingComplete(user) {
			if (user && user.prefs && user.prefs.onboarding) {
				var values = _.values(user.prefs.onboarding);
				return values.filter(function (item) {
					return !item;
				}).length == 0;
			}
			return true;
		},
		shouldRecord: function shouldRecord() {
			if (!$wr.isProduction()) return false;
	
			var user = CurrentUser.get();
			var shouldRecord = false;
			if (!user) {
				// So we record signed out people on class page
				shouldRecord = true;
			} else if (user.role == "teacherRole" || user.role == "adminRole") {
				// if (user.pending_onboarding || !this.isOnboardingComplete(user) || user.product == "wrSilver" || user.product == "wrGold") {
				shouldRecord = true;
				// }
			} else if (user.role == "studentRole" && user.product == "wrGold") {
				shouldRecord = true;
			} else {
				if (user && user.demo_for_teacher) {
					shouldRecord = true;
				}
			}
			if (shouldRecord && !window.__lo_site_id) {
				this.init();
			}
			return shouldRecord;
		},
		forceRecording: function forceRecording() {
			this.forced = true;
			if (!window.__lo_site_id) {
				this.init();
				this.tagUser();
			}
		},
		reset: function reset() {
			this.forced = false;
		},
	
		tagComponent: function tagComponent(reactComponent) {
			if (this.shouldRecord() || this.forced) {
				try {
					if (!this.userTagged) {
						this.tagUser();
					}
					window._loq = window._loq || [];
					if (typeof reactComponent == "string") {
						var name = reactComponent;
					} else {
						var name = reactComponent.constructor.name.replace("bound ", "");
					}
					window._loq.push(["tag", name]);
				} catch (err) {
					console.log("LO issue");
				}
			}
		}
	};
	
	module.exports = LuckyOrangeClient;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var Mycroft = {
	
		// Values that can be set directly on Mycroft:
		//   - userData. Hash of data about the current user
		//   - splitTest
		//   - forcedVariations
		//   - isDisabled
	
		init: function init(gaID, ops) {
			ops = ops || {};
			var scriptContent = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');";
	
			if (ops.onLocalhost) {
				scriptContent += "ga('create', '" + gaID + "', {'cookieDomain': 'none'});";
			} else {
				scriptContent += "ga('create', '" + gaID + "', 'auto');";
			}
	
			// // We're doing this manually instead:
			// scriptContent += "ga('send', 'pageview');";
	
			$("head").append("<script>" + scriptContent + "</script>");
	
			this.newPage(document.location.pathname);
		},
	
		initExceptionTracking: function initExceptionTracking() {
			if (!Mycroft.isInitialized() || Mycroft.isDisabled) {
				return;
			}
	
			window.addEventListener('error', function (err) {
				ga('send', 'exception', {
					'exDescription': err.message,
					'exFatal': false
				});
			});
		},
	
		setUserData: function setUserData(userData, splitTests) {
			if (userData && userData.disableMycroft) {
				Mycroft.isDisabled = true;
			}
			if (!Mycroft.isInitialized() || Mycroft.isDisabled) {
				return;
			}
	
			Mycroft.userID = userData.id;
			Mycroft.splitTests = splitTests;
	
			// Set user custom dimensions
			Mycroft.setDimension(11, userData.grade_level);
			Mycroft.setDimension(12, userData.role);
	
			Mycroft.setDimension(13, userData.product);
	
			if (userData.source_data) {
				if (userData.source_data.source) {
					Mycroft.setDimension(14, userData.source_data.source);
				} else {
					Mycroft.setDimension(14, "None");
				}
			}
	
			ga('set', 'userId', userData.id);
	
			Mycroft.newEvent({ category: "Split Test", action: "loading",
				fieldsObject: { nonInteraction: 1 } });
	
			for (var i = 0; i < splitTests.length; i++) {
				var test = splitTests[i];
				Mycroft.setDimension(test.dimension_index, test.variation);
	
				// Mycroft.newEvent({ category: "Split Test", action: test.name, 
				// 	label: test.full_variation, fieldsObject: { nonInteraction: 1 } });
			}
			Mycroft.newEvent({ category: "Split Test", action: "Loaded",
				fieldsObject: { nonInteraction: 1 } });
		},
	
		isInitialized: function isInitialized() {
			return typeof ga != "undefined";
		},
	
		setDimension: function setDimension(index, value) {
			if (!Mycroft.isInitialized() || Mycroft.isDisabled) {
				return;
			}
			ga('set', "dimension" + index, value);
		},
	
		newPage: function newPage(path) {
			if (!Mycroft.isInitialized() || Mycroft.isDisabled) {
				return;
			}
			path = path.replace(/\/\d+$/g, "/:id");
			path = path.replace(/\/\d+\//g, "/:id/");
	
			ga('set', 'page', path);
			ga('send', 'pageview');
		},
	
		// Takes hash: { category: "..", action: "..", label: '..' value: "..", fieldsObject: {} }
		// 'category' and 'action' are required, 'label' is recommended
		// IMPORTANT: refer to Event Schema before adding new events (ask Greg)
		newEvent: function newEvent(eventData) {
			if (!Mycroft.isInitialized() || Mycroft.isDisabled) {
				return;
			}
			if ((eventData.category || "").trim().length == 0 || (eventData.action || "").trim().length == 0) {
				console.error("eventData must define non-empty 'category' and 'action:'", eventData);
				return;
			}
	
			ga('send', 'event', eventData.category, eventData.action, eventData.label, eventData.value, eventData.fieldsObject || {});
		},
	
		buildEventHandler: function buildEventHandler(eventData) {
			return function (e) {
				// DO NOT: e.preventDefault()
				Mycroft.newEvent(eventData);
			};
		},
	
		isActiveVariation: function isActiveVariation(testName, testVariation) {
			if (Mycroft.splitTests == undefined) {
				return;
			}
	
			if (Mycroft.forcedVariations && Mycroft.forcedVariations[testName]) {
				return Mycroft.forcedVariations[testName] == testVariation;
			} else {
				var test = _.findWhere(Mycroft.splitTests, { name: testName });
				if (test) {
					return test.variation == testVariation;
				}
			}
		},
		forceVariation: function forceVariation(testName, testVariation) {
			Mycroft.forcedVariations = Mycroft.forcedVariations || {};
			Mycroft.forcedVariations[testName] = testVariation;
		}
	};
	
	module.exports = Mycroft;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	"use strict";
	
	/////// DANGER ///////////////////////////////
	// Be careful using this in multiple places //
	//////////////////////////////////////////////
	
	var Chronometer = {
	
		duration: 0,
		referenceDate: null,
		init: function init() {
			Chronometer.duration = 0;
			Chronometer.referenceDate = new Date();
		},
		getDuration: function getDuration() {
			if (Chronometer.referenceDate) {
				var delta = new Date() - Chronometer.referenceDate;
				return (delta + Chronometer.duration) / 1000;
			} else {
				return Chronometer.duration;
			}
		},
		start: function start() {
			if (!Chronometer.referenceDate) {
				Chronometer.referenceDate = new Date();
			}
		},
		pause: function pause() {
			Chronometer.duration = Chronometer.getDuration();
			Chronometer.referenceDate = null;
		},
		reset: function reset() {
			Chronometer.duration = 0;
			Chronometer.referenceDate = new Date();
		}
	};
	
	module.exports = Chronometer;

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	"use strict";
	
	// This is a placeholder until we get a better solution
	var Localization = {
	
		TRANSLATIONS: {
			credit_card: {
				number: "Card number",
				security_code: "Security code",
				cvc_tooltip: "The 3 or 4 digit security code located on the back of your card.",
				expiration: "Expiration date",
				zip_code: "Zip code"
			}
		},
	
		getTranslations: function getTranslations(key) {
			return Localization.TRANSLATIONS[key];
		}
	};
	
	module.exports = Localization;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var SpeechToText = {
		recognition: null,
		currentEl: null,
		recording: false,
		newRequest: null,
	
		init: function init() {
			this.recognition = new webkitSpeechRecognition();
			this.recognition.continuous = true;
			this.recognition.interimResults = true;
		},
	
		trigger: function trigger(el, id) {
			if (this.recording) {
				this.newRequest = el;
				this.recognition.onend = this.checkWhenDone;
				this.recognition.stop();
				this.recording = false;
				$(el).removeClass('recording');
				window.wrL2eSound.stopAllSounds();
				window.wrL2eSound.playSound("end_recording" + "_speech_control");
			} else {
				this.launchRecording(el, id);
				window.wrL2eSound.stopAllSounds();
				window.wrL2eSound.playSound("start_recording" + "_speech_control");
			}
		},
		launchRecording: function launchRecording(el, id) {
			this.recording = true;
			this.currentEl = el;
			$('.speechToTextButton').each(function () {
				if ($(this).attr('id') != id) {
					$(this).hide();
				}
			});
			$(el).addClass('recording');
			var text = $(el).val();
			if (text.length > 0) {
				var final_transcript = text + " ";
			} else {
				var final_transcript = "";
			}
			this.recognition.onresult = function (event) {
				var interim_transcript = '';
				for (var i = event.resultIndex; i < event.results.length; ++i) {
					if (event.results[i].isFinal) {
						final_transcript += event.results[i][0].transcript;
						$(el).val(final_transcript);
					} else {
						interim_transcript += event.results[i][0].transcript;
						$(el).val(final_transcript + interim_transcript);
					}
				}
			}.bind(this);
			this.currentEl = el;
			this.recognition.start();
		},
	
		checkWhenDone: function checkWhenDone() {
			$('.speechToTextButton').each(function () {
				$(this).show();
			});
		}
	};
	module.exports = SpeechToText;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	'use strict';
	
	var TextToSpeech = {
		initVoice: function initVoice(text) {
			var v = new SpeechSynthesisUtterance();
			v.text = text;
			v.voiceURI = 'native';
			v.lang = 'en-US';
			v.rate = 0.9;
			v.pitch = 1.1;
			v.onstart = this.startSpeaking;
			v.onend = this.stopSpeaking;
	
			return v;
		}
	
	};
	module.exports = TextToSpeech;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CONFIG;
	
	exports.showAnnouncement = showAnnouncement;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// This file contains configuration data for various announcements to be displayed on the website.
	
	// load proptypes if this runs before app inits
	if (!window.PropTypes) {
	    window.PropTypes = __webpack_require__(43);
	    window.StrictPropTypes = __webpack_require__(369).forbidExtraProps;
	}
	
	var Glyphicon = __webpack_require__(8);
	var SlideInAnnouncement = __webpack_require__(801);
	var NewItemsModal = __webpack_require__(388);
	var NewFeaturesModal = __webpack_require__(804);
	var SiteAnnoucementModal = __webpack_require__(799);
	
	// This section defines keys for the different types of announcements that can be displayed on the website
	// These keys are used to identify the specific announcement in the configuration object
	// It is important that the keys match the announcement_key in the data hash coming from the l2e announcement
	var LANDING_PAGE_PROMO = exports.LANDING_PAGE_PROMO = "landing_page_promo";
	var OWLSHOP_UPDATE = exports.OWLSHOP_UPDATE = "owlshop_update";
	var NEW_FEATURES = exports.NEW_FEATURES = "new_features";
	var ACQUISITION_ANNOUCEMENT = exports.ACQUISITION_ANNOUCEMENT = "acquisition_announcement";
	var SITE_DOWNTIME = exports.SITE_DOWNTIME = "site_downtime";
	
	// To add a new announcement, follow the existing pattern and add a new entry to the CONFIG object
	// Be sure to include a unique key for the announcement and specify the launch date, description, trigger, and component to be used
	// The trigger specifies when the announcement should be displayed based on the user's role and current path
	// The component specifies the React component to be used for displaying the announcement
	// If additional props are needed for the component, they can be added to the props object
	var CONFIG = exports.CONFIG = (_CONFIG = {}, _defineProperty(_CONFIG, LANDING_PAGE_PROMO, {
	    launch_date: new Date("2022-11-22"),
	    expo_date: null,
	    description: 'Promotes teachers to share WR landing page with admins',
	    trigger: {
	        paths: ["/"],
	        conditions: function conditions(user) {
	            return user.role == 'teacherRole' && waitForElm('.allWidgets').then(function () {
	                // prevent conflicts from survey prompts
	                return $(document.getElementsByClassName('surveyPromptContainer')).length == 0;
	            });
	        }
	    },
	    component: SlideInAnnouncement,
	    props: {
	        bodyContent: React.createElement(
	            "div",
	            { className: "bodyContent" },
	            React.createElement(
	                "p",
	                null,
	                React.createElement(
	                    "span",
	                    { className: "blueText" },
	                    "Whooo's Reading"
	                ),
	                " is better when you upgrade!"
	            ),
	            React.createElement(
	                "p",
	                null,
	                "Share this link with your admin so they can learn more and watch a demo:"
	            ),
	            React.createElement(
	                "p",
	                { className: 'cta blueText', onClick: function onClick() {
	                        navigator.clipboard.writeText('www.whooosreading.org/learnmore');
	                        LuckyOrangeClient.tagComponent("LearnMoreLinkCopied");
	                        window.wrNotifications.triggerDropDownNotification({
	                            title: "Copied!", text: 'The link was coppied to your clipboard', icon: "link"
	                        });
	                    } },
	                "Copy Link ",
	                React.createElement(Glyphicon, { icon: 'link', className: 'link' })
	            )
	        )
	    }
	}), _defineProperty(_CONFIG, OWLSHOP_UPDATE, {
	    launch_date: new Date("2023-01-01"),
	    expo_date: null,
	    description: 'Promotes Owlshop Updates',
	    trigger: {
	        paths: ["/"],
	        conditions: function conditions(user) {
	            return user.role == 'studentRole';
	        }
	    },
	    component: NewItemsModal,
	    props: {
	        title: "\uD83D\uDEA8\uD83D\uDEA8 New Owl Shop Items Alert \uD83D\uDEA8\uD83D\uDEA8",
	        open: true
	    }
	}), _defineProperty(_CONFIG, NEW_FEATURES, {
	    launch_date: new Date("2023-03-01"),
	    expo_date: null,
	    description: 'Promotes New Features',
	    trigger: {
	        paths: ["/"],
	        conditions: function conditions(user) {
	            return user.role != 'studentRole';
	        }
	    },
	    component: NewFeaturesModal,
	    props: {}
	}), _defineProperty(_CONFIG, ACQUISITION_ANNOUCEMENT, {
	    launch_date: new Date("2023-03-28"),
	    expo_date: null,
	    description: 'Displays Acquisition Announcement',
	    trigger: {
	        paths: ["/"],
	        conditions: function conditions(user) {
	            return user.role != 'studentRole';
	        }
	    },
	    component: SiteAnnoucementModal,
	    props: {
	        title: "Savvas Learning Company Acquires Whooo's Reading",
	        titleImage: 'logos/savvas-logo.jpg',
	        bodyContent: React.createElement(
	            "div",
	            null,
	            React.createElement(
	                "div",
	                { className: "titleImgeContainer" },
	                React.createElement("img", { className: "savvasLogo titleImage", src: dynamicRequire('logos/savvas-logo.jpg') }),
	                React.createElement("img", { className: "wrLogo titleImage", src: dynamicRequire('logos/wr-logo.png') })
	            ),
	            React.createElement(
	                "p",
	                null,
	                "We are excited to share with you the ",
	                React.createElement(
	                    "a",
	                    { href: "https://www.savvas.com/index.cfm?locator=PS3mXi", target: "_blank" },
	                    "news"
	                ),
	                " that Whooo's Reading has been acquired by ",
	                React.createElement(
	                    "a",
	                    { href: "https://www.savvas.com/", target: "_blank" },
	                    "Savvas Learning Company"
	                ),
	                "."
	            ),
	            React.createElement(
	                "p",
	                null,
	                React.createElement(
	                    "strong",
	                    null,
	                    "First things first"
	                ),
	                " - Your access to the Whooo's Reading program will not be changing, and the entire Whooo's Reading team has joined Savvas, so you can continue to connect with us the same way you always have."
	            ),
	            React.createElement(
	                "p",
	                null,
	                React.createElement(
	                    "strong",
	                    null,
	                    "Now the exciting part"
	                ),
	                " - Teaming up with Savvas gives us the opportunity to advance our machine-learning technology, allowing us to support schools in providing the most advanced personalized learning for students. This could lead to more accurate and robust rubric-driven evaluations of your students' written responses, more personalized in-the-moment feedback for your students, and more actionable data to support your instruction."
	            ),
	            React.createElement(
	                "p",
	                null,
	                "We are eager to continue working with you and striving to provide the most personalized and engaging learning experience for your students."
	            )
	        )
	    }
	}), _defineProperty(_CONFIG, SITE_DOWNTIME, {
	    launch_date: new Date("2023-06-20"),
	    expo_date: null,
	    description: 'Displays Site Downtime Announcement',
	    trigger: {
	        paths: ["/"],
	        conditions: function conditions(user) {
	            return true;
	        }
	    },
	    component: SiteAnnoucementModal,
	    props: {
	        title: "\uD83D\uDEA8 Website Downtime for Back to School Maintenance \uD83D\uDEA8",
	        bodyContent: React.createElement(
	            "div",
	            null,
	            React.createElement(
	                "p",
	                null,
	                "We would like to inform you that our website will be temporarily unavailable for essential maintenance work. To ensure a seamless user experience, we will be conducting this maintenance for approximately four days. We apologize for any inconvenience caused and appreciate your understanding."
	            ),
	            React.createElement(
	                "p",
	                null,
	                "Maintenance Schedule:"
	            ),
	            React.createElement(
	                "ul",
	                null,
	                React.createElement(
	                    "li",
	                    null,
	                    "Start Date: ",
	                    React.createElement(
	                        "strong",
	                        null,
	                        "July 27, 2023, at 7 pm EST"
	                    )
	                ),
	                React.createElement(
	                    "li",
	                    null,
	                    "End Date: ",
	                    React.createElement(
	                        "strong",
	                        null,
	                        "July 31, 2023, at 12 am EST"
	                    )
	                )
	            ),
	            React.createElement(
	                "p",
	                null,
	                "During the maintenance period:"
	            ),
	            React.createElement(
	                "ul",
	                null,
	                React.createElement(
	                    "li",
	                    null,
	                    "The website will be inaccessible."
	                ),
	                React.createElement(
	                    "li",
	                    null,
	                    "User accounts and data will remain secure."
	                ),
	                React.createElement(
	                    "li",
	                    null,
	                    "New registrations, logins, and transactions will be temporarily disabled."
	                ),
	                React.createElement(
	                    "li",
	                    null,
	                    "Any changes made to your account before the maintenance will be saved."
	                )
	            ),
	            React.createElement(
	                "p",
	                null,
	                "If you have any questions, please email us at ",
	                React.createElement(
	                    "strong",
	                    null,
	                    "support@whooosreading.org"
	                ),
	                ", and we would be very happy to help you!"
	            ),
	            React.createElement(
	                "p",
	                null,
	                "Thank you for your understanding and support."
	            ),
	            React.createElement(
	                "p",
	                null,
	                "Sincerely,"
	            ),
	            React.createElement(
	                "p",
	                null,
	                "Whooo's Reading"
	            )
	        )
	    }
	}), _CONFIG);
	
	// This function shows an announcement on the website if the conditions specified in the configuration object are met
	function showAnnouncement(path, alert, user) {
	    if (!alert || !('annoucement_key' in alert.data)) {
	        return null;
	    }
	
	    var key = alert.data['annoucement_key'];
	    var config = CONFIG[key];
	    // check key exists
	    if (!config) {
	        return null;
	    }
	
	    // check expo date
	    if (config.expo_date && config.expo_date < new Date()) {
	        return null;
	    }
	
	    // check path
	    if (!_.includes(config.trigger.paths, path)) {
	        return null;
	    }
	
	    // check conditions
	    if (!config.trigger.conditions(user)) {
	        return null;
	    }
	
	    var props = _extends({}, config.props, { alertID: alert.id });
	
	    return React.createElement(config.component, _extends({ key: alert.id }, props));
	}
	
	///// HELPERS /////
	function waitForElm(selector) {
	    return new Promise(function (resolve) {
	        if (document.querySelector(selector)) {
	            return resolve(document.querySelector(selector));
	        }
	
	        var observer = new MutationObserver(function (mutations) {
	            if (document.querySelector(selector)) {
	                resolve(document.querySelector(selector));
	                observer.disconnect();
	            }
	        });
	
	        observer.observe(document.body, {
	            childList: true,
	            subtree: true
	        });
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ActionUtility = __webpack_require__(95);
	
	var initialState = {};
	
	function internal() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
	
			case _ActionUtility.RECEIVE_HELLO:
				return _.extend({}, state, { hello: action.data });
	
			default:
				return state;
		}
	}
	
	module.exports = {
		internal: internal
	};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.buildRecordReducer = buildRecordReducer;
	
	var _ActionUtility = __webpack_require__(95);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function buildRecordReducer(key) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var idKey = options.idKey || "id";
	
		var initialState = { loading: {}, cached: [], totals: {}, pages: {} };
	
		return function () {
			var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
			var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			switch (action.type) {
	
				case _ActionUtility.LOADING_RECORDS:
					if (key in action) {
						// Makes the key as being loading
						var newLoading = _.extend({}, state.loading, _defineProperty({}, action[key], true));
						return _.extend({}, state, { loading: newLoading });
					};break;
	
				case _ActionUtility.CLEAR_LOADING_RECORDS:
					if (key in action) {
						return _.extend({}, state, { loading: {} });
					};break;
	
				case _ActionUtility.RECEIVE_RECORDS:
					if (key in action) {
	
						var mergedRecords = _.map(action[key], function (item) {
							var existingRecord = state[item[idKey]];
							if (existingRecord) {
								return _.extend({}, existingRecord, item);
							} else {
								return item;
							}
						});
	
						// Adds/replaces existing records with the new records
						var byID = _.indexBy(mergedRecords, idKey);
	
						if (action.metaReducer == key) {
							if (action.loadingKeys) {
								var newLoading = _.omit(state.loading, action.loadingKeys);
								state = _.extend({}, state, { loading: newLoading });
							}
	
							if (action.cache) {
								var newCached = state.cached.concat(action.cache);
								state = _.extend({}, state, { cached: newCached });
							}
	
							if (action.totals) {
								var newTotals = _.extend({}, state.totals, action.totals);
								state = _.extend({}, state, { totals: newTotals });
							}
	
							if (action.pagination) {
								var newPages = _.clone(state.pages);
								var pageKey = action.pagination.key;
								var pageIDs = _.pluck(mergedRecords, "id");
	
								newPages[pageKey] = _.extend({}, newPages[pageKey], _defineProperty({}, action.pagination.page, pageIDs));
	
								state = _.extend({}, state, { pages: newPages });
	
								if (action.noMorePages) {
									state = _.extend({}, state, { noMorePages: _defineProperty({}, action.pagination.key, true) });
								}
							}
						}
	
						return _.extend({}, state, byID);
					};break;
	
				case _ActionUtility.REMOVE_RECORDS:
					if (key in action) {
						// Filter out the IDs provided in action[key]
						return _.omit(state, action[key]);
					};break;
	
				case _ActionUtility.REMOVE_ALL_RECORDS:
					if (key in action && action[key]) {
						return initialState;
					}
	
				case _ActionUtility.UPDATE_RECORDS:
					if (key in action) {
						var IDs = new Set(_.map(action[key], String));
						// Filter out the IDs provided in action[key]
						return _.mapObject(state, function (x, id) {
							return IDs.has(id) ? _.extend({}, x, action.update) : x;
						});
					};break;
	
				case _ActionUtility.INVALIDATE_CACHE:
					if (key in action) {
						return _.extend({}, state, { cached: [] });
					};break;
			}
	
			return state;
		};
	}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _redux = __webpack_require__(646);
	
	var _InternalReducer = __webpack_require__(1010);
	
	var _UIReducer = __webpack_require__(1013);
	
	var _ReducerTemplates = __webpack_require__(1011);
	
	var rootReducer = (0, _redux.combineReducers)({
		internal: _InternalReducer.internal,
		ui: _UIReducer.ui,
		activities: (0, _ReducerTemplates.buildRecordReducer)("activities"),
		admins: (0, _ReducerTemplates.buildRecordReducer)("admins"),
		avatars: (0, _ReducerTemplates.buildRecordReducer)("avatars"),
		answers: (0, _ReducerTemplates.buildRecordReducer)("answers"),
		books: (0, _ReducerTemplates.buildRecordReducer)("books", { idKey: "text_id" }),
		comments: (0, _ReducerTemplates.buildRecordReducer)("comments"),
		contacts: (0, _ReducerTemplates.buildRecordReducer)("contacts"),
		deals: (0, _ReducerTemplates.buildRecordReducer)("deals"),
		digests: (0, _ReducerTemplates.buildRecordReducer)("digests", { idKey: "key" }),
		discountTokens: (0, _ReducerTemplates.buildRecordReducer)("discountTokens", { idKey: "code" }),
		districtOrgs: (0, _ReducerTemplates.buildRecordReducer)("districtOrgs"),
		estimates: (0, _ReducerTemplates.buildRecordReducer)("estimates"),
		evaluations: (0, _ReducerTemplates.buildRecordReducer)("evaluations"),
		exercises: (0, _ReducerTemplates.buildRecordReducer)("exercises"),
		coinRecords: (0, _ReducerTemplates.buildRecordReducer)("coinRecords"),
		invoices: (0, _ReducerTemplates.buildRecordReducer)("invoices"),
		logs: (0, _ReducerTemplates.buildRecordReducer)("logs"),
		parents: (0, _ReducerTemplates.buildRecordReducer)("parents"),
		patches: (0, _ReducerTemplates.buildRecordReducer)("patches"),
		photographs: (0, _ReducerTemplates.buildRecordReducer)("photographs"),
		platforms: (0, _ReducerTemplates.buildRecordReducer)("platforms"),
		perks: (0, _ReducerTemplates.buildRecordReducer)("perks"),
		furnitures: (0, _ReducerTemplates.buildRecordReducer)("furnitures"),
		questions: (0, _ReducerTemplates.buildRecordReducer)("questions"),
		quizzes: (0, _ReducerTemplates.buildRecordReducer)("quizzes"),
		ratings: (0, _ReducerTemplates.buildRecordReducer)("ratings"),
		readingLevels: (0, _ReducerTemplates.buildRecordReducer)("readingLevels"),
		reports: (0, _ReducerTemplates.buildRecordReducer)("reports", { idKey: "report_key" }),
		responses: (0, _ReducerTemplates.buildRecordReducer)("responses"),
		schoolOrgs: (0, _ReducerTemplates.buildRecordReducer)("schoolOrgs"),
		schools: (0, _ReducerTemplates.buildRecordReducer)("schools", { idKey: "l2e_id" }),
		studentLists: (0, _ReducerTemplates.buildRecordReducer)("studentLists"),
		students: (0, _ReducerTemplates.buildRecordReducer)("students"),
		tasks: (0, _ReducerTemplates.buildRecordReducer)("tasks"),
		upgradeTokens: (0, _ReducerTemplates.buildRecordReducer)("upgradeTokens"),
		surveyPrompts: (0, _ReducerTemplates.buildRecordReducer)("surveyPrompts", { idKey: "key" }),
		widgetDigests: (0, _ReducerTemplates.buildRecordReducer)("widgetDigests")
	});
	
	module.exports = {
		rootReducer: rootReducer
	};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _UIActions = __webpack_require__(41);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
		expandedResponseID: null,
		showPaywall: null,
		editKeys: {}
	};
	
	function ui() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
	
			case _UIActions.EXPAND_RESPONSE:
				if (action.expanded) {
					return _.extend({}, state, { expandedResponseID: action.responseID });
				} else {
					return _.extend({}, state, { expandedResponseID: null });
				}
	
			case _UIActions.SHOW_PAYWALL:
				return _.extend({}, state, { showPaywall: action.paywall });
	
			case _UIActions.TOGGLE_EDIT:
				if (action.expanded) {
					var editKeys = _.extend({}, state.editKeys, _defineProperty({}, action.key, true));
					return _.extend({}, state, { editKeys: editKeys });
				} else {
					var editKeys = _.omit(state.editKeys, action.key);
					return _.extend({}, state, { editKeys: editKeys });
				}
	
			default:
				return state;
		}
	}
	
	module.exports = {
		ui: ui // Interface is a reserved keywork
	};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPath = getPath;
	exports.getRouteState = getRouteState;
	function getPath(state) {
		var fullPath = "/my";
	
		if (state.activeView) {
			fullPath += "/" + state.activeView;
		} else {
			fullPath += "/" + VIEWS.SHELF_VIEW;
		}
	
		if (state.detailsView) {
			fullPath += "/" + state.detailsView;
			if (state.textID) {
				fullPath += "/" + state.textID;
			}
		}
	
		return fullPath;
	}
	
	function getRouteState(params) {
		var state = {};
	
		state.activeView = params.active_view;
		state.detailsView = params.details_view;
		state.textID = params.text_id;
	
		return state;
	}
	
	var VIEWS = exports.VIEWS = {
		SHELF_VIEW: "shelf",
		LOGS_VIEW: "reading"
	};
	
	var PATH = exports.PATH = "/my/:active_view/:details_view?/:text_id?";

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.showPaywall = showPaywall;
	exports.expandedResponseID = expandedResponseID;
	exports.isActiveEditKey = isActiveEditKey;
	function showPaywall(_ref) {
		var state = _ref.state;
	
		return state.ui.showPaywall;
	}
	function expandedResponseID(_ref2) {
		var state = _ref2.state;
	
		return state.ui.expandedResponseID;
	}
	function isActiveEditKey(_ref3) {
		var state = _ref3.state,
		    key = _ref3.key;
	
		return state.ui.editKeys[key];
	}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	////////////////////////////////////////
	// WhooosReadingUtility.js /////////////
	////////////////////////////////////////
	// Referenced elsewhere as $wr /////////
	////////////////////////////////////////
	
	var moment = __webpack_require__(15);
	var ReactDOM = __webpack_require__(98);
	// Note: CurrentUser reqired below
	
	var WhooosReadingUtility = {
		// Take the location of an image with within the /public/images directory
		//	Note: This is set up as its own function to make it easier to change it's behavior
		//	in production if we need to
	
		redirect: function redirect(path) {
			window.redirectWorkaround(path);
		},
	
		didParamsChange: function didParamsChange(propsA, propsB) {
			if (propsA.match && propsA.match.params && propsB.match && propsB.match.params) {
				return !_.isEqual(propsA.match.params, propsB.match.params);
			}
		},
	
		getOrdinal: function getOrdinal(n) {
			n = parseInt(n);
			var s = ["th", "st", "nd", "rd"];
			var v = n % 100;
			return n + (s[(v - 20) % 10] || s[v] || s[0]);
		},
	
		isValidDayOfWeek: function isValidDayOfWeek(n) {
			if (n < 0 || n > 6) {
				return false;
			} else {
				return true;
			}
		},
	
		getDayOfWeek: function getDayOfWeek(n) {
			n = parseInt(n);
			if (n < 0 || n > 6) {
				throw "Invalid Day of Week";
			} else {
				return $wr.Constants.DAYS_OF_WEEK[n];
			}
		},
	
		padleft: function padleft(n, width, padWith) {
			padWith = padWith || "0";
			var nString = n + "";
			if (nString.length < width) {
				return new Array(width - nString.length + 1).join(padWith) + n;
			} else {
				return nString;
			}
		},
	
		numberWithCommas: function numberWithCommas(n) {
			if (n) {
				return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return 0;
			}
		},
		centsToDollars: function centsToDollars(cents, dollarsOnly) {
			if (cents != undefined) {
				if (dollarsOnly) {
					return "$" + $wr.numberWithCommas(Math.floor(cents / 100));
				} else {
					var dollarPart = "$" + $wr.numberWithCommas(Math.floor(cents / 100));
					var centsPart = (cents / 100).toFixed(2).split(".")[1];
					return dollarPart + "." + centsPart;
				}
			}
		},
		momentInTimezone: function momentInTimezone(date) {
			var format = "YYYY-MM-DD HH:mm:ss";
	
			// Move it here to avoid issues requiring this file elsewhere
			var CurrentUser = __webpack_require__(3);
	
			if (CurrentUser.isSignedIn()) {
				var offset = CurrentUser.get().time_zone_offset / (60 * 60);
				if (date == undefined) {
					return moment().utcOffset(offset);
				} else {
					return moment.utc(date, format).utcOffset(offset);
				}
			} else {
				// Default to Pacific time
				return moment.utc(date, format).utcOffset(-7);
			}
		},
		sortByName: function sortByName(grouping, listType) {
			if (listType == $wr.Constants.FIELDS.STUDENTLIST) {
				return _.sortBy(grouping, function (s) {
					return s.name;
				});
			} else if (listType == $wr.Constants.FIELDS.FIRSTNAME) {
				return _.sortBy(grouping, function (s) {
					return s.first_name;
				});
			} else if (listType == $wr.Constants.FIELDS.LASTNAME) {
				return _.sortBy(grouping, function (s) {
					return s.last_name;
				});
			} else if (listType == $wr.Constants.FIELDS.BOOKTITLE) {
				return _.sortBy(grouping, function (b) {
					return b.title;
				});
			} else if (listType == $wr.Constants.FIELDS.FLEXNAME) {
				return _.sortBy(grouping, function (s) {
					if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
						return s.first_name;
					} else {
						return s.last_name + ", " + s.first_name;
					}
				});
			} else if (listType == $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST) {
				return _.sortBy(grouping, function (s) {
					if (s.demo_for_teacher) {
						return "A";
					} else if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
						return s.first_name;
					} else {
						return s.last_name + ", " + s.first_name;
					}
				});
			} else {
				throw "Unrecognized List Type";
			}
		},
	
	
		formatDateTime: function formatDateTime(date, yearOption) {
			var tzDate = this.momentInTimezone(date);
			if (yearOption == "show-past-years" && tzDate.year() != moment().year()) {
				return tzDate.format("MMM D YYYY, h:mm a");
			} else {
				return tzDate.format("MMM D, h:mm a");
			}
		},
	
		formatDate: function formatDate(date, format) {
			if (date) {
				format = format || "MMM D, YYYY";
				return this.momentInTimezone(date).format(format);
			}
		},
	
		formatTime: function formatTime(date) {
			if (date) {
				return this.momentInTimezone(date).format("h:mm a");
			}
		},
	
		//Format a date without taking timezone offset into account
		formatDateWithoutTimezone: function formatDateWithoutTimezone(date, format) {
			if (date) {
				return moment(date).format(format);
			}
		},
	
		fetchSlicedItems: function fetchSlicedItems(array, maxSize) {
			var lists = [[]];
			var array = array;
	
			for (var i = 0; i < array.length; i++) {
				if (_.last(lists).length >= maxSize) {
					lists.push([]);
				}
				_.last(lists).push(array[i]);
			}
			return lists;
		},
	
		displayBackground: function displayBackground(background) {
			// If the background is being previewed in the shop, perks is just the background that
			// is to be previewed.
			if (background == "") {
				return;
			}
			var $container = $(".outerPageContainer");
			var name = background.toLowerCase();
			var perkPath = dynamicRequire("perks/backgrounds/" + name + ".png");
			$container.addClass("hasBackground").css('background', 'url(' + perkPath + ')');
		},
	
		removeBackground: function removeBackground() {
			var $container = $(".outerPageContainer");
			$container.removeClass("hasBackground").css('background', '#fff');
		},
	
		hasBackgroundEquipped: function hasBackgroundEquipped(perks) {
			return perks.find(function (perk) {
				return perk.perk_type == "backgrounds" && perk.equipped;
			});
		},
	
		fetchTitle: function fetchTitle(student, onlyFirstName) {
			if (onlyFirstName) {
				if (student.perks.titles) {
					return student.perks.titles + " " + student.first_name;
				} else {
					return student.first_name;
				}
			} else {
				if (student.perks.titles) {
					return student.perks.titles + " " + student.display_name;
				} else {
					return student.display_name;
				}
			}
		},
	
		getShopOpeningTime: function getShopOpeningTime(user) {
			var prefs = user.prefs || {};
			return prefs.shop_opening_time || "Always";
		},
	
		shouldShopOpen: function shouldShopOpen(user) {
			var prefs = user.prefs || {};
			var openingTime = prefs.shop_opening_time || "Always";
			if (openingTime != undefined) {
				if (openingTime == "Never") {
					return false;
				}
				var currentTime = new Date();
				var weekDay = currentTime.getDay();
				if (openingTime != "Always" && weekDay > 0 && weekDay < 6) {
					var openHour = parseInt(openingTime.split(" ")[0]) + 12;
					var openingDate = new Date();
					openingDate.setHours(openHour);
					openingDate.setMinutes(0);
	
					if (currentTime < openingDate) {
						return false;
					}
				}
			}
			return true;
		},
	
		canStudentTakeQuiz: function canStudentTakeQuiz(user) {
			var prefs = user.prefs || {};
			var closeTime = prefs.quiz_close_time || "Never";
			//  always can take quiz if never close or undefined close time.
			if (closeTime == "Never" || closeTime == undefined) {
				return true;
			} else if (closeTime == "Always") {
				return false;
			}
			//student hour and day 
			var currentHourAndDay = moment().tz(user.time_zone_region).format('h a d').split(" ");
	
			var weekDay = parseInt(currentHourAndDay[2]);
			var currentHour = parseInt(currentHourAndDay[0]);
	
			//if its the weekend, quizzes are closed because closing time is defined here
			if (weekDay > 0 && weekDay < 6) {
				var closingHour = parseInt(closeTime.split(" ")[0]) + 12;
	
				// Need to handle edge case for 12am/pm separately
				if (currentHour == 12) {
					if (currentHourAndDay[1] == "am") {
						currentHour = 0;
					}
				} else {
					//add time offset for pm
					if (currentHourAndDay[1] == "pm") {
						currentHour += 12;
					}
				}
	
				if (currentHour < closingHour) {
					return true;
				} else {
					return false;
				}
			}
			//it's the weekend.
			else {
					return false;
				}
		},
	
		// Can handle arrays, functions, objects, and basic types (like numbers and strings)
		checkComplexObjectEquals: function checkComplexObjectEquals(itemA, itemB) {
			if (_.isArray(itemA)) {
				// itemB also has to be an array
				if (!_.isArray(itemB)) {
					return false;
				}
	
				// itemB should have the same length
				if (itemA.length != itemB.length) {
					return false;
				}
	
				// Every element in itemB should be the same as the element in itemA
				for (var i = 0; i < itemA.length; i++) {
					if (!this.checkComplexObjectEquals(itemA[i], itemB[i])) {
						return false;
					}
				}
				return true;
			} else if (_.isFunction(itemA)) {
				// itemB also has to be a function
				if (!_.isFunction(itemB)) {
					return false;
				}
	
				// No better way to compare functions
				return itemA == itemB;
			} else if (_.isObject(itemA)) {
				// itemB also has to be an object
				if (!_.isObject(itemB)) {
					return false;
				}
	
				var keys = _.keys(itemA);
	
				// They should have the same number of keys
				if (keys.length != _.keys(itemB).length) {
					return false;
				}
	
				// Every value in itemB should be the same as the value in itemA
				for (var i = 0; i < keys.length; i++) {
					if (!this.checkComplexObjectEquals(itemA[keys[i]], itemB[keys[i]])) {
						return false;
					}
				}
				return true;
			} else {
				// === should work well for basic data types.
				// === catches differences between null and underfined
				return itemA === itemB;
			}
		},
	
		sortedJSON: function sortedJSON(obj) {
			var output = {};
			_.each(_.sortBy(_.keys(obj)), function (key) {
				output[key] = obj[key];
			});
			return JSON.stringify(output);
		},
	
		// Build a handler that provides default behavior for 401, 403, 404, and 500 errors
		// Use only for users that are signed in
		//   401 Error: Redirect to login page with error explaining they've been
		//		logged off. On successful login, redirect to the desired page
		//   403 Error: Redirect to profile with error explaining they can't visit
		//		the page they were trying to view
		//   404 Error: Redirect to profile with error explaining they can't view
		//		the page they were trying to view
		//   400 Error: Don't redirect. Explain that something went wrong with the client
		//		and they should try to refresh the page or come back later
		//   500 Error: Don't redirect. Explain that something went wrong on the server
		//		and they should try to refresh the page or come back later
	
		apiHandler: function apiHandler(expectedCallback, onError) {
			return function (responseJSON, success, statusCode, jqXHR) {
	
				switch (statusCode) {
					case 401:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("You've been logged out!", "Log in to see the page you were trying to view.");
						this.redirect("/login");
						break;
	
					case 403:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("Sorry!", "You can't view this page");
						this.redirect("/");
						break;
	
					case 404:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("Sorry!", "You can't view this page");
						this.redirect("/");
						break;
	
					case 400:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("Something went wrong, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
						if (onError) {
							onError();
						}
						break;
	
					case 500:
						console.log("WR Api Error " + statusCode, jqXHR);
						// This probably wasn't on a route load because we should have caught that in the route onEnter
						displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
						if (onError) {
							onError();
						}
						break;
	
					case 502:
					case 503:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... one of our servers seems to have gone down. Please try again later!");
						if (onError) {
							onError();
						}
						break;
	
					case 504:
						console.log("WR Api Error " + statusCode, jqXHR);
						displayAlert("Something went wrong on our end, sorry!", "Too many people are using WR right now! We are working on it now. Please try again later!");
						if (onError) {
							onError();
						}
						break;
	
					default:
						// do the right thing if it's 2xx
						if (statusCode >= 200 || statusCode < 300 && responseJSON != undefined) {
							expectedCallback(responseJSON, success, statusCode, jqXHR);
						} else {
							try {
								expectedCallback(responseJSON, success, statusCode, jqXHR);
							} catch (error) {
								console.error(error);
							}
							if (responseJSON == undefined) {
								console.error("Response JSON is undefined, Status Code: " + statusCode);
							} else {
								console.error("Uncaught Status Code: " + statusCode);
							}
						}
				}
			}.bind(this);
		},
	
		pluralize: function pluralize(string, count, pluralForm) {
			if (pluralForm == undefined) {
				pluralForm = string + "s";
			}
			return count == 1 ? string : pluralForm;
		},
	
		pluralizeWithNumber: function pluralizeWithNumber(string, count, pluralForm) {
			return count + " " + $wr.pluralize(string, count, pluralForm);
		},
	
		capitalize: function capitalize(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
	
		toSentence: function toSentence(items) {
			return _.reduce(items, function (memo, item, index) {
				if (index == items.length - 1) {
					// We know there are at least 2 elements, since we didn't pass an inital memo
					return memo + (items.length > 2 ? ", and " : " and ") + item;
				} else {
					return memo + ", " + item;
				}
			});
		},
	
		isValidEmail: function isValidEmail(email) {
			var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return EMAIL_REGEX.test(email);
		},
	
		hashCode: function hashCode(text) {
			var hash = 0;
	
			if (text.length === 0) {
				return hash;
			}
	
			for (var i = 0; i < text.length; i++) {
				var chr = text.charCodeAt(i);
				var hash = (hash << 5) - hash + chr;
				hash |= 0; // Convert to 32bit integer
			}
			return hash;
		},
	
		psuedoRandom: function psuedoRandom(seed, limit) {
			if (typeof seed == "string") {
				seed = $wr.hashCode(seed);
			}
			var x = Math.sin(seed) * 10000;
			var y = x - Math.floor(x);
	
			if (limit === undefined) {
				return y;
			} else {
				return Math.floor(y * limit);
			}
		},
	
		randomString: function randomString(length) {
			// Thanks @csharptest.net
			// https://stackoverflow.com/a/1349426/4557470
			var result = '';
			var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		},
	
		getInnerText: function getInnerText(obj) {
			var buf = "";
			if (obj) {
				var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
				if (type === "string" || type === "number") {
					buf += obj;
				} else if (type === 'object') {
					var children = null;
					if (Array.isArray(obj)) {
						children = obj;
					} else {
						var props = obj.props;
						if (props) {
							children = props.children;
						}
					}
					if (children) {
						if (Array.isArray(children)) {
							children.forEach(function (o) {
								buf += this.getInnerText(o);
							}.bind(this));
						} else {
							buf += this.getInnerText(children);
						}
					}
				}
			}
			return buf;
		},
	
		preventDefaultBehavior: function preventDefaultBehavior(e) {
			e.preventDefault();
		},
		nope: function nope(e) {
			if (e) {
				e.preventDefault();
			}
		},
	
		print: function print(e) {
			$wr.nope(e);
			window.print();
		},
	
		notImplemented: function notImplemented() {
			throw "Not Implemented!";
		},
		loadScript: function loadScript(url, checkKey, callback) {
			window.wr_loadScriptFetching = window.wr_loadScriptFetching || {};
	
			if (window[checkKey] !== undefined) {
				// Immediately go back to the callback
				setTimeout(callback, 0);
			} else if (window.wr_loadScriptFetching[checkKey]) {
				// Recurse on loadScript till it loads in from the other call
				setTimeout(function () {
					$wr.loadScript(url, checkKey, callback);
				}, 250);
			} else {
				window.wr_loadScriptFetching[checkKey] = true;
	
				// Fetch the script, use the callback on return
				$.ajax({
					url: url,
					dataType: 'script',
					success: callback,
					async: true
				});
			}
		},
		triggerResize: function triggerResize() {
			$(window).trigger("resize");
		},
		repeatedTriggerResize: function repeatedTriggerResize() {
			setTimeout(this.triggerResize, 10);
			setTimeout(this.triggerResize, 100);
			setTimeout(this.triggerResize, 500);
			setTimeout(this.triggerResize, 1000);
			setTimeout(this.triggerResize, 2000);
			setTimeout(this.triggerResize, 3000);
			setTimeout(this.triggerResize, 5000);
		},
		isProduction: function isProduction() {
			return ("production") === "production";
		},
		isDevelopment: function isDevelopment() {
			return ("production") === "development";
		},
		isStaging: function isStaging() {
			return ("production") === "staging";
		},
		environment: function environment() {
			return ("production");
		},
		isAppdev: function isAppdev() {
			return ('false') == "true";
		},
		checkCustomEnv: function checkCustomEnv(key) {
			if (this.isDevelopment() && ('{}')) {
				if (window.wrCustomEnv == undefined) {
					window.wrCustomEnv = JSON.parse(('{}'));
				}
				return window.wrCustomEnv[key];
			}
		},
		isInternetExplorer: function isInternetExplorer() {
			var msIndex = window.navigator.userAgent.indexOf("MSIE ");
			return msIndex > 0;
		},
		isSafari: function isSafari() {
			var safariVar1 = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
			var safariVar2 = function (p) {
				return p.toString() === "[object SafariRemoteNotification]";
			}(!window['safari'] || safari.pushNotification);
			return safariVar1 || safariVar2;
		},
		isIOS: function isIOS() {
			return (/iPad|iPhone/.test(navigator.userAgent)
			);
		},
		findAllValues: function findAllValues(searchObj, targetKey) {
			var helperF = function helperF(obj, values) {
				_.each(_.keys(obj), function (key) {
					if (targetKey == key) {
						values.push(obj[key]);
					} else {
						helperF(obj[key], values);
					}
				});
			};
			var accumulator = [];
			helperF(searchObj, accumulator);
			return accumulator;
		},
		initInactivityTimer: function initInactivityTimer() {
			window.wrInactivityTimer = new Date();
			document.onmousemove = function () {
				window.wrInactivityTimer = new Date();
			};
		},
		isInactive: function isInactive(seconds) {
			if (seconds == undefined) {
				seconds = 200;
			}
	
			var msDiff = new Date() - window.wrInactivityTimer;
	
			return msDiff / 1000 >= seconds;
		},
		getURLParameterByName: function getURLParameterByName(name) {
			var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
			return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
		},
		getQueryObject: function getQueryObject(fullURL) {
			if (fullURL == undefined) {
				fullURL = window.location.href;
			}
			var queryIndex = fullURL.indexOf("?");
			if (queryIndex == -1) {
				return {};
			}
			var query = fullURL.substring(queryIndex + 1);
			// Thanks @ Wolfgang Kuehn
			// https://stackoverflow.com/a/8649003/4557470
			return JSON.parse('{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
		},
		getNormalizedPath: function getNormalizedPath(url) {
			var el = document.createElement('a');
			el.href = url;
	
			var path = el.pathname;
			path = path.replace(/\/\d+/g, "/*");
	
			return path;
		},
		scrollToElement: function scrollToElement(element, offset) {
			offset = offset || 0;
			var $element = $(element);
			if ($element.length > 0) {
				$("html, body").animate({ scrollTop: $element.offset().top - offset }, "slow");
			}
		},
		setWindowY: function setWindowY(scrollTop) {
			$("html, body").scrollTop(scrollTop);
		},
		toBase64: function toBase64(file) {
			return new Promise(function (resolve, reject) {
				var reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = function () {
					return resolve(reader.result);
				};
				reader.onerror = function (error) {
					return reject(error);
				};
			});
		},
		componentToText: function componentToText(component) {
			var tempDiv = document.createElement("div");
			ReactDOM.render(component, tempDiv);
			return tempDiv.innerText;
		},
		getJSON: function getJSON(url, onSuccess) {
			this.requestJSON(url, null, 'GET', onSuccess);
		},
		postJSON: function postJSON(url, data, onSuccess, onFailure) {
			this.requestJSON(url, data, 'POST', onSuccess, onFailure);
		},
		patchJSON: function patchJSON(url, data, onSuccess) {
			this.requestJSON(url, data, 'PATCH', onSuccess);
		},
		deleteJSON: function deleteJSON(url, onSuccess) {
			this.requestJSON(url, null, 'DELETE', onSuccess);
		},
		requestJSON: function requestJSON(url, data, type, onSuccess, onFailure) {
			this.remoteRequest(url, data, type, "json", onSuccess, onFailure);
		},
		remoteRequest: function remoteRequest(url, data, type, dataType, onSuccess, onFailure) {
			$.ajax({
				url: url, dataType: dataType, type: type, data: data, success: onSuccess,
				error: function error(xhr, status, err) {
					console.error(url, status, err.toString());
					if (onFailure) {
						onFailure();
					}
				}
			});
		},
		altRemoteRequest: function altRemoteRequest(url, method, data, callback) {
			var options = {
				type: method,
				async: true,
				contentType: "application/json",
				dataType: "json",
				processData: true
			};
			if (data) {
				options["data"] = JSON.stringify(data);
			}
			var request = $.ajax(url, options);
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
		},
		truncate: function truncate(string, charLimit) {
			if (string) {
				return string.length > charLimit ? string.substring(0, charLimit) + "..." : string;
			}
		},
	
		// TODO: standardize FE requests
		isLargeRequest: function isLargeRequest(userIDs) {
			return userIDs !== undefined ? userIDs.length > $wr.Constants.ACCOUNT_SIZE.LARGE_ACCOUNT_LIMIT : false;
		},
		handleLargeRequest: function handleLargeRequest(dispatch, userIDs, conditions, actionFunction, options, callback) {
			var chunkedUsers = _.chunk(userIDs, $wr.Constants.ACCOUNT_SIZE.REQUEST_CHUNK_SIZE);
			var promiseArray = [];
	
			_.each(chunkedUsers, function (userIDs, i) {
				conditions = _.extend(conditions, { userIDs: userIDs, noPagination: true });
				options.conditions = conditions;
				promiseArray.push(dispatch(actionFunction(options)));
				// return dispatch(actionFunction(options));
	
				if (i + 1 === chunkedUsers.length) {
					if (callback && typeof callback === 'function') {
						callback(promiseArray);
					} else {
						return _.compact(promiseArray);
					}
				}
			});
		},
		frontEndPaginationTotal: function frontEndPaginationTotal(stateObj) {
			return _.size(_.compact(_.map(_.keys(stateObj), function (key) {
				if (stateObj[key] && stateObj[key]['id']) {
					return stateObj[key];
				}
			})));
		},
		toTitleCase: function toTitleCase(str) {
			return str.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
	
	
		// gets items that the user can afford
		canAffordItem: function canAffordItem(userCoins, currentTier, allItems, category, type) {
			if (category == "patch") {
				var items = _.select(allItems, function (patch) {
					//removes duplicates by removing right hand and body 2 items
					var handType = patch.origin_patch_type == "hand" ? "left_hand" : patch.patch_type;
					var bodyType = patch.origin_patch_type == "body" ? "body" : patch.patch_type;
					return patch.price <= userCoins && !patch.owned && patch.source == "store" && patch.tier == currentTier && patch.patch_type == type;
				});
			} else if (category == "perk") {
				if (type == "total") {
					var items = _.select(allItems, function (perk) {
						return perk.price <= userCoins && !perk.owned && perk.source == "store" && perk.tier == currentTier;
					});
				} else {
					var items = _.select(allItems, function (perk) {
						return perk.price <= userCoins && !perk.owned && perk.source == "store" && perk.tier == currentTier && perk.perk_type == type;
					});
				}
			} else {
				var items = _.select(allItems, function (furniture) {
					return furniture.perk_type == type && furniture.price <= userCoins && !furniture.owned && furniture.source == "store" && furniture.tier == currentTier;
				});
			}
	
			return items;
		},
	
	
		// returns the number of reqs remaining to level up, by type
		getRemainingReqs: function getRemainingReqs(tier, reqs, patches, perks, furnitures) {
			if (!reqs) {
				return;
			}
			var reqsRemaining = Object();
	
			if (reqs.patches) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = Object.entries(reqs.patches)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _step$value = _slicedToArray(_step.value, 2),
						    patch_type = _step$value[0],
						    count = _step$value[1];
	
						var requiredPatchesOwned = _.filter(patches, function (patch) {
							return patch.owned && tier == patch.tier && patch_type == patch.patch_type;
						});
	
						var remaining = count - Math.min(count, requiredPatchesOwned.length);
						if (remaining > 0) reqsRemaining[patch_type] = remaining;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
			if (reqs.perks) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = Object.entries(reqs.perks)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var _step2$value = _slicedToArray(_step2.value, 2),
						    perk_type = _step2$value[0],
						    count = _step2$value[1];
	
						var requiredPerksOwned;
	
						if (perk_type == "total") {
							requiredPerksOwned = _.filter(perks, function (perk) {
								return perk.owned && tier == perk.tier;
							});
						} else {
							requiredPerksOwned = _.filter(perks, function (perk) {
								return perk.owned && tier == perk.tier && perk_type == perk.perk_type;
							});
						}
						remaining = count - Math.min(count, requiredPerksOwned.length);
						if (remaining > 0) reqsRemaining[perk_type] = remaining;
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}
	
			if (reqs.furnitures) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = Object.entries(reqs.furnitures)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var _step3$value = _slicedToArray(_step3.value, 2),
						    furniture_type = _step3$value[0],
						    count = _step3$value[1];
	
						var requiredFurnitureOwned = _.filter(furnitures, function (furniture) {
							return furniture.owned && furniture_type == furniture.origin_perk_type && tier == furniture.tier;
						});
	
						remaining = count - Math.min(count, requiredFurnitureOwned.length);
						if (remaining > 0) reqsRemaining[furniture_type] = remaining;
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
			}
			return reqsRemaining;
		},
	
	
		// converts score based on user preferences
		convertedScore: function convertedScore(ratio, displayScoreCap) {
			displayScoreCap = displayScoreCap || 4;
	
			var score = ratio * displayScoreCap;
			// Round down to nearest 0.5
			score = Math.floor(score * 2) / 2;
	
			return score;
		},
	
	
		Constants: {
			BASE_TITLES: ["Mr.", "Ms.", "Mrs.", "Miss", "Dr."],
			FILLER_LAST_NAME: "Owlsomestudent",
			PERIODS: {
				WEEK: "week",
				MONTH: "month",
				QUARTER: "quarter",
				TRIMESTER: "trimester",
				SEMESTER: "semester",
				SCHOOL_YEAR: "school-year",
				ALLTIME: "all-time"
			},
			DAYS_OF_WEEK: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
			FIELDS: {
				STUDENTLIST: "studentList",
				FIRSTNAME: "firstName",
				LASTNAME: "lastName",
				BOOKTITLE: "bookTitle",
				FLEXNAME: "flexName",
				FLEXNAMEDEMOFIRST: "flexNameDemoFirst"
			},
			ACCOUNT_SIZE: {
				LARGE_ACCOUNT_LIMIT: 30,
				REQUEST_CHUNK_SIZE: 30
			}
		}
	};
	
	WhooosReadingUtility.Constants.TITLES = WhooosReadingUtility.Constants.BASE_TITLES.concat(WhooosReadingUtility.Constants.BASE_TITLES.map(function (title) {
		return title.replace(".", "");
	}));
	
	WhooosReadingUtility.Constants.PERIOD_TO_NAME = {};
	Object.values(WhooosReadingUtility.Constants.PERIODS).map(function (period) {
		WhooosReadingUtility.Constants.PERIOD_TO_NAME[period] = period.split("-").join(" ");
	});
	
	function displayAlert(title, text) {
		if (window.wrNotifications) {
			window.wrNotifications.triggerDropDownNotification({ title: title,
				text: text, icon: "exclamation-sign", type: "error" }, 6000);
		} else {
			alert(title + ": " + text);
		}
	}
	
	module.exports = WhooosReadingUtility;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _reactDom = __webpack_require__(98);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CurrentUser = __webpack_require__(3);
	var SurveyPromptConfig = __webpack_require__(257);
	var SurveyPromptDisplay = __webpack_require__(408);
	
	var RosterSelectors = __webpack_require__(6);
	var RosterActions = __webpack_require__(11);
	
	var SurveyPromptUtility = (_dec = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    prompts: RosterSelectors.admin({ state: state, id: CurrentUser.get().id }) ? RosterSelectors.admin({ state: state, id: CurrentUser.get().id }).survey_prompts : []
	  };
	}, function (dispatch, props) {
	  return {
	    fetchAdmin: function fetchAdmin() {
	      dispatch(RosterActions.fetchAdmins({
	        filters: { ids: [CurrentUser.get().id] },
	        embeds: ['admin.survey_prompts']
	      }));
	    }
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(SurveyPromptUtility, _React$Component);
	
	  function SurveyPromptUtility(props) {
	    _classCallCheck(this, SurveyPromptUtility);
	
	    var _this = _possibleConstructorReturn(this, (SurveyPromptUtility.__proto__ || Object.getPrototypeOf(SurveyPromptUtility)).call(this));
	
	    autobind(_this);
	
	    _this.state = { prompt: null };
	    return _this;
	  }
	
	  _createClass(SurveyPromptUtility, [{
	    key: "start",
	    value: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var prompt;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.selectPrompt();
	
	              case 2:
	                prompt = _context.sent;
	
	                if (prompt) {
	                  this.observe();
	                }
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function start() {
	        return _ref.apply(this, arguments);
	      }
	
	      return start;
	    }()
	
	    // selects random prompt
	
	  }, {
	    key: "selectPrompt",
	    value: function selectPrompt() {
	      var _this2 = this;
	
	      return new Promise(function (resolve) {
	        // Get saved data from sessionStorage
	        var existingPromptID = parseInt(sessionStorage.getItem(SurveyPromptConfig.PROMPT_SESSION_KEY));
	
	        var possiblePromptIDs = _.map(_this2.props.prompts, 'id');
	
	        if (existingPromptID && _.include(possiblePromptIDs, existingPromptID)) {
	          var prompt = _.find(_this2.props.prompts, { id: existingPromptID });
	          // for LO
	          console.log('prompt:', prompt);
	        } else {
	          var prompt = _this2.props.prompts[Math.floor(Math.random() * _this2.props.prompts.length)];
	          if (prompt.id) {
	            // for LO
	            console.log('prompt:', prompt);
	            sessionStorage.setItem(SurveyPromptConfig.PROMPT_SESSION_KEY, prompt.id);
	          }
	        }
	        if (prompt && _this2.validKey(prompt) && _this2.promptTriggerLocation(SurveyPromptConfig.CONFIG[prompt.key])) {
	          var prompt = _.extend(SurveyPromptConfig.CONFIG[prompt.key], prompt);
	          prompt.options = prompt.options.split('|');
	          _this2.setState({ prompt: prompt }, resolve(prompt));
	        }
	      });
	    }
	
	    // checks if user is on prompt's key is in config file
	
	  }, {
	    key: "validKey",
	    value: function validKey(prompt) {
	      return _.includes(SurveyPromptConfig.VALID_KEYS, prompt.key);
	    }
	
	    // checks if user is on prompt's target location
	
	  }, {
	    key: "promptTriggerLocation",
	    value: function promptTriggerLocation(promptConfig) {
	      if (_.includes(promptConfig.trigger.paths, 'home') && window.location.pathname == '/') {
	        return true;
	      } else {
	        return promptConfig.trigger.paths.every(function (str) {
	          return window.location.pathname.includes(str);
	        });
	      }
	    }
	  }, {
	    key: "excludedClassesPresent",
	    value: function excludedClassesPresent(prompt, el) {
	      var excludedElements = _.compact(_.map(prompt.trigger.exclude_classes, function (exClass) {
	        return $(el).hasClass(exClass.replace('.', ''));
	      }));
	
	      return _.size(excludedElements) > 0;
	    }
	  }, {
	    key: "getAnchors",
	    value: function getAnchors(anchor, excludedClasses) {
	      var stippedAnchor = anchor.replace('.', '').replace('#', '');
	
	      if ($(document.getElementsByClassName(stippedAnchor)).length > 0) {
	        return $(document.getElementsByClassName(stippedAnchor));
	      } else if (document.getElementById(stippedAnchor)) {
	        return [document.getElementById(stippedAnchor)];
	      } else {
	        return [];
	      }
	    }
	
	    // Every time a class changes down the DOM, determine if it needs a survey
	
	  }, {
	    key: "observe",
	    value: function observe() {
	      var _this3 = this;
	
	      var prompt = this.state.prompt;
	
	
	      var observerElement = document.querySelector(this.props.watchContainer);
	
	      var observer = new MutationObserver(function () {
	
	        var anchors = _this3.getAnchors(prompt.trigger.class);
	        if (anchors.length == 1 && !_this3.excludedClassesPresent(prompt, anchors)) {
	
	          LuckyOrangeClient.tagComponent("SurveyPrompt Shown: " + prompt.key);
	          _this3.injectElement(anchors, prompt, 0, observer);
	        } else if (anchors.length > 1) {
	
	          LuckyOrangeClient.tagComponent("SurveyPrompt Shown: " + prompt.key);
	          anchors.each(function (i, el) {
	            if (!_this3.excludedClassesPresent(prompt, el)) {
	              _this3.injectElement(el, prompt, i, observer);
	            }
	          });
	        }
	      });
	
	      observer.observe(observerElement, { childList: true, subtree: true });
	    }
	  }, {
	    key: "injectElement",
	    value: function injectElement(el, prompt, i, observer) {
	      var newClass = "surveyPromptContainer-" + prompt.key;
	      // if the element doesn't already have a survey, create one
	      var parent = $(el).closest(prompt.location.parent);
	      if ($(parent).find("." + newClass).length == 0) {
	
	        // prevents infinite loop
	        observer.disconnect();
	
	        // find preceding element
	        var anchor = $(parent).find(prompt.location.anchor);
	
	        // create div for survey
	        var newID = newClass + "-" + i;
	        $("<div class=\"surveyPromptContainer " + newClass + " " + prompt.style.class + "\" id=\"" + newID + "\"></div>").insertAfter(anchor);
	
	        // attach extra data to send to backend
	        var dataPacket = SurveyPromptConfig.getDataPacket(newID, prompt);
	
	        // inject survey
	        _reactDom2.default.render(React.createElement(SurveyPromptDisplay, { onSubmitFeedback: this.props.fetchAdmin, prompt: prompt, userID: CurrentUser.get().id, dataPacket: dataPacket }), document.getElementById(newID));
	
	        // add additional styling if survey is contained within specific item
	        if (prompt.location.absolute_anchor) {
	          // style survey
	          var pos = $("" + prompt.location.absolute_anchor).position();
	          if ($(window).width() <= 500) {
	            $("#" + newID).css({
	              top: "calc(" + pos.top + "px + 100px)",
	              position: 'absolute',
	              left: "60%",
	              bottom: "0px",
	              width: "40%",
	              float: 'unset'
	            });
	          } else {
	            $("#" + newID).css({
	              top: "calc(" + pos.top + "px + 100px)",
	              position: 'absolute',
	              left: "80%",
	              bottom: "0px",
	              width: "20%",
	              float: 'unset'
	            });
	          }
	
	          // style page to make survey animations work
	          // REMOVE THIS WHEN SURVEYS ARE NOT RUNNING
	          $("#pageContent").css({ 'position': 'relative', 'overflow-x': 'hidden' });
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (_.size(this.props.prompts) && (prevProps.prompts !== this.props.prompts || prevProps.pathname !== this.props.pathname)) {
	        // remove existing survey prompts
	        $('.surveyPromptContainer').each(function (i, el) {
	          $(el).remove();
	        });
	
	        // remove possible added styling to parent div
	        if ($('#pageContent').css('position') == 'relative') {
	          $("#pageContent").css({ position: 'initial', 'overflow-x': 'initial' });
	        }
	
	        // start listening
	        this.start();
	      }
	    }
	  }]);
	
	  return SurveyPromptUtility;
	}(React.Component)) || _class);
	
	
	module.exports = SurveyPromptUtility;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1034);
	
	window.React = _react2.default;
	
	// Make extension libraries global. Don't put anything else here!
	window.$wr = __webpack_require__(1016);
	window._ = __webpack_require__(19);
	window.$ = __webpack_require__(7);
	
	window.Mycroft = __webpack_require__(1004);
	var CustomerIOClient = __webpack_require__(254);
	// var NewRelicClient = require("lib/integrations/NewRelicClient");
	
	window.dynamicRequire = __webpack_require__(1020).require;
	window.autobind = __webpack_require__(1019);
	
	window.LuckyOrangeClient = __webpack_require__(1003);
	
	window.PropTypes = __webpack_require__(43);
	window.StrictPropTypes = __webpack_require__(369).forbidExtraProps;
	
	var pagePropTypes = {
		history: PropTypes.object,
		location: PropTypes.object,
		match: PropTypes.object,
		staticContext: PropTypes.object,
	
		children: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.array])
	};
	
	window.PageStrictPropTypes = function (propsTypes) {
		return window.StrictPropTypes(_.extend({}, pagePropTypes, propsTypes));
	};
	
	// ONLY FOR CONSOLE TESTING PURPOSES
	window.NoUseCurrentUser = __webpack_require__(3);
	window.NoUseCookies = __webpack_require__(188);
	
	if ($wr.isDevelopment()) {
		var WhooosReadingClientApi = __webpack_require__(124);
		WhooosReadingClientApi.LegacyClient.setHost("localhost:3002", "http");
	} else if ($wr.isStaging()) {
		var WhooosReadingClientApi = __webpack_require__(124);
		WhooosReadingClientApi.LegacyClient.setHost("api.savvashortondev.com", "https");
	} else {
		var WhooosReadingClientApi = __webpack_require__(124);
		WhooosReadingClientApi.LegacyClient.setHost("api.whooosreading.org", "https");
	}
	
	if (!$wr.isAppdev()) {
		// Set up Albus stuff
		$wr.loadScript("/dependencies/albus.min.js", "Albus", function () {
			Albus.Dependencies = {
				Marked: __webpack_require__(612)
	
				// This is a little brittle...
			};Albus.alternateErrorDisplay = function (errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "You're missing something.", text: errors.join(" "),
					icon: "exclamation-sign", type: "error" });
			};
		});
	}
	
	// Load Fonts
	var $head = $("head");
	$head.append('<link href="https://fonts.googleapis.com/css?family=Didact+Gothic" rel="stylesheet" />');
	
	if ($wr.isDevelopment()) {
		var faviconPath = "/fixed/favicon-dev.ico";
	} else if ($wr.isAppdev()) {
		var faviconPath = "/fixed/favicon-wizards.ico";
	} else {
		var faviconPath = "/fixed/favicon-1.ico";
	}
	$head.append('<link rel="icon" sizes="16x16 32x32 64x64" href="' + faviconPath + '">');
	
	var fontLoaderScript = document.createElement('script');
	$head.append(fontLoaderScript);
	
	fontLoaderScript.onload = function () {
		try {
			Typekit.load({ async: true });
		} catch (e) {}
	};
	fontLoaderScript.src = "https://use.typekit.net/sat8ely.js";
	
	// In production/staging, redirect to https
	if (window.location.protocol != "https:" && !($wr.isDevelopment() || $wr.isAppdev())) {
		var url = window.location.href.substring(window.location.protocol.length);
		window.location.href = "https:" + url;
	}
	
	if (!$wr.isDevelopment() && !$wr.isStaging()) {
		CustomerIOClient.init("204a51c74b5e3b6269a0");
		// NewRelicClient.init();
	}
	
	if ($wr.isProduction()) {
		Mycroft.init("UA-47529006-3");
	} else {
		Mycroft.init("UA-47529006-2", { onLocalhost: true });
	}
	Mycroft.initExceptionTracking();
	
	$wr.initInactivityTimer();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	'use strict';
	
	// All code take from class autobind package by @kodefox
	// https://github.com/kodefox/class-autobind, specifically:
	// https://github.com/kodefox/class-autobind/blob/master/src/autobind.js
	
	// The following React methods should not be automatically bound.
	var REACT_EXCLUDE_METHODS = {
	  getChildContext: true,
	  render: true,
	  componentWillMount: true,
	  componentDidMount: true,
	  componentWillReceiveProps: true,
	  shouldComponentUpdate: true,
	  componentWillUpdate: true,
	  componentDidUpdate: true,
	  componentWillUnmount: true
	};
	
	function isExcluded(methodName) {
	  return REACT_EXCLUDE_METHODS[methodName] === true;
	}
	
	function isFunction(item) {
	  return typeof item === 'function';
	}
	
	function autobind(instance, proto) {
	  if (proto == null) {
	    proto = Object.getPrototypeOf(instance);
	  }
	  var propertyNames = Object.getOwnPropertyNames(proto);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = propertyNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var name = _step.value;
	
	      var value = proto[name];
	      if (isFunction(value) && !isExcluded(name)) {
	        instance[name] = proto[name].bind(instance);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	module.exports = autobind;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var DynamicRequire = {
		require: function require(fileName) {
			// Check if this was a required di
			var directory = _.find(_.keys(DynamicRequire.directories), function (dir) {
				return fileName.indexOf(dir) === 0;
			});
	
			if (directory) {
				var relativePath = fileName.replace(directory, ".");
				return DynamicRequire.directories[directory](relativePath);
			} else {
				throw "Could not dynamically require " + fileName;
			}
		},
	
		directories: {
			"action-icons": __webpack_require__(662),
			"patches": __webpack_require__(671),
			"misc": __webpack_require__(666),
			"perks": __webpack_require__(672),
			"furnitures": __webpack_require__(664),
			"official-icons": __webpack_require__(668),
			"onboarding": __webpack_require__(669),
			"owl-item-types": __webpack_require__(670),
			"quiz-icons": __webpack_require__(673),
			"skillset-banners": __webpack_require__(679),
			"skillset-icons": __webpack_require__(680),
			"reading/reading-levels": __webpack_require__(675),
			"ribbons/letters": __webpack_require__(676),
			"ribbons/numbers": __webpack_require__(677),
			"ribbons/smilies": __webpack_require__(678),
			"owl_hoots": __webpack_require__(686),
			"background": __webpack_require__(684),
			"dances": __webpack_require__(685),
			"speech-to-text": __webpack_require__(687),
			"tiers": __webpack_require__(681),
			"ranks": __webpack_require__(674),
			"features": __webpack_require__(663),
			"logos": __webpack_require__(665)
		}
	};
	
	module.exports = DynamicRequire;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var CurrentUser = __webpack_require__(3);
	var Redirect = __webpack_require__(13).Redirect;
	
	function getWrapperComponent(baseComponent, permissions) {
		function checkPermissions() {
			if (permissions.allAccess) {
				return true;
			}
	
			if (permissions.developmentAccess && $wr.isDevelopment()) {
				return true;
			}
	
			if (permissions.loggedOut && !CurrentUser.isLoaded()) {
				return true;
			}
			if (permissions.loggedIn && CurrentUser.isLoaded()) {
				return true;
			}
	
			if (permissions.students && CurrentUser.isStudent()) {
				return true;
			}
			if (permissions.wizards && CurrentUser.isWizard()) {
				return true;
			}
			if (permissions.teachers && CurrentUser.isTeacherAdmin()) {
				return true;
			}
			if (permissions.allAdmins && CurrentUser.isAdmin()) {
				return true;
			}
	
			if (permissions.passcodes && CurrentUser.isPassphraseUser()) {
				return true;
			}
	
			return false;
		}
	
		return function (props) {
			if (checkPermissions()) {
				return React.createElement(baseComponent, props);
			} else {
				var redirectPath = CurrentUser.isLoaded() ? "/" : "/login";
				return React.createElement(Redirect, { to: redirectPath });
			}
		};
	}
	
	module.exports = {
		Students: function Students(baseComponent) {
			return getWrapperComponent(baseComponent, { students: true });
		},
		Teachers: function Teachers(baseComponent) {
			return getWrapperComponent(baseComponent, { teachers: true });
		},
		Wizards: function Wizards(baseComponent) {
			return getWrapperComponent(baseComponent, { wizards: true });
		},
		TeachersAndSchoolAdmins: function TeachersAndSchoolAdmins(baseComponent) {
			return getWrapperComponent(baseComponent, { allAdmins: true });
		},
		LoggedIn: function LoggedIn(baseComponent) {
			return getWrapperComponent(baseComponent, { loggedIn: true });
		},
		LoggedOut: function LoggedOut(baseComponent) {
			return getWrapperComponent(baseComponent, { loggedOut: true });
		},
		Passcodes: function Passcodes(baseComponent) {
			return getWrapperComponent(baseComponent, { passcodes: true });
		},
		AllAccess: function AllAccess(baseComponent) {
			return getWrapperComponent(baseComponent, { allAccess: true });
		},
		DevelopmentAccess: function DevelopmentAccess(baseComponent) {
			return getWrapperComponent(baseComponent, { developmentAccess: true });
		}
	};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var WhooosReadingCRMApi = __webpack_require__(1032);
	var APIError = __webpack_require__(444);
	
	if (!window.$wr || $wr.isDevelopment()) {
		var Client = new WhooosReadingCRMApi.Client("localhost:3002", "http");
	} else if ($wr.isStaging()) {
		var Client = new WhooosReadingCRMApi.Client("api.savvashortondev.com", "https");
	} else {
		var Client = new WhooosReadingCRMApi.Client("api.whooosreading.org", "https"); // Uses the default endpoint for the library
	}
	
	Client.addResponseHandler(function (response) {
		if (response.ok) {
			return response;
		} else {
			handleHTTPError(response.status);
	
			var error = new APIError("CRM", response.status, response.url);
			return Promise.reject(error);
		}
	});
	
	function handleHTTPError(status) {
		function displayAlert(title, text) {
			if (window.wrNotifications) {
				window.wrNotifications.triggerDropDownNotification({ title: title,
					text: text, icon: "exclamation-sign", type: "error" }, 6000);
			} else {
				alert(title + ": " + text);
			}
		}
	
		switch (status) {
			case 401:
				displayAlert("You've been logged out!", "Log in to see the page you were trying to view.");
				$wr.redirect("/login");
				break;
	
			case 403:
				displayAlert("Sorry!", "You can't view this page");
				$wr.redirect("/");
				break;
	
			case 404:
				displayAlert("Sorry!", "You can't view this page");
				$wr.redirect("/");
				break;
	
			case 400:
				displayAlert("Something went wrong, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				// if (onError) { onError() }
				break;
	
			case 500:
				// This probably wasn't on a route load because we should have caught that in the route onEnter
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				// if (onError) { onError() }
				break;
	
			case 502:
			case 503:
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... one of our servers seems to have gone down. Please try again later!");
				// if (onError) { onError() }
				break;
	
			case 504:
				displayAlert("Something went wrong on our end, sorry!", "Too many people are using WR right now! We are working on it now. Please try again later!");
				// if (onError) { onError() }
				break;
		}
	}
	
	module.exports = Client;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(13);
	
	// Sets global variables and completes other setup steps
	__webpack_require__(1018);
	
	var Auth = __webpack_require__(1021);
	
	var App = __webpack_require__(862);
	
	var HomePage = __webpack_require__(863);
	
	var UpgradePage = __webpack_require__(928);
	var ParentPage = __webpack_require__(873);
	
	var LoginPage = __webpack_require__(791);
	var SignoutPage = __webpack_require__(793);
	var ForgotPasswordPage = __webpack_require__(789);
	var ResetPasswordPage = __webpack_require__(792);
	
	var OwlShopPage = __webpack_require__(732);
	var ClozePage = __webpack_require__(736);
	
	var PicksPage = __webpack_require__(242);
	var ActivitiesPage = __webpack_require__(942);
	
	var StudentParentsPage = __webpack_require__(874);
	
	var ActivityPage = __webpack_require__(943);
	var StudentActivitiesPage = __webpack_require__(948);
	var NewResponsePage = __webpack_require__(989);
	
	var ResponsePage = __webpack_require__(991);
	
	var NewAnswerPage = __webpack_require__(954);
	
	var QuestionBuilderPage = __webpack_require__(955);
	
	var QuizPage = __webpack_require__(968);
	var ContestsPage = __webpack_require__(806);
	var ClassResultsPage = __webpack_require__(738);
	
	var ClassPage = __webpack_require__(841);
	var MyShelfPage = __webpack_require__(856);
	
	var AdminRosteringPage = __webpack_require__(816);
	var RosterPage = __webpack_require__(822);
	
	var TutorialsPage = __webpack_require__(926);
	
	var DataPage = __webpack_require__(740);
	var TextQuestionsPage = __webpack_require__(966);
	
	var InsightsPage = __webpack_require__(748);
	var MaintenancePage = __webpack_require__(864);
	var ErrorPage = __webpack_require__(409);
	var RedirectPage = __webpack_require__(866);
	var ScratchPage = __webpack_require__(867);
	
	var SettingsPage = __webpack_require__(892);
	
	var DataRouting = __webpack_require__(36);
	var OrgActivityRouting = __webpack_require__(203);
	var AdminRosterRouting = __webpack_require__(440);
	var RosterRouting = __webpack_require__(93);
	var ContestsRouting = __webpack_require__(442);
	var ClassResultsRouting = __webpack_require__(441);
	var ClassPageRouting = __webpack_require__(256);
	var MyShelfRouting = __webpack_require__(74);
	var OwlShopRouting = __webpack_require__(92);
	var SettingsRouting = __webpack_require__(443);
	var ActivitiesPageRouting = __webpack_require__(255);
	
	module.exports = React.createElement(
		App,
		null,
		React.createElement(
			_reactRouterDom.Switch,
			null,
			React.createElement(_reactRouterDom.Route, { path: "/login", component: Auth.LoggedOut(LoginPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/forgot_password", component: Auth.LoggedOut(ForgotPasswordPage) }),
			React.createElement(_reactRouterDom.Route, { exact: true, path: "/", component: Auth.AllAccess(HomePage) }),
			React.createElement(_reactRouterDom.Route, { path: OrgActivityRouting.PATH, component: Auth.AllAccess(HomePage) }),
			React.createElement(_reactRouterDom.Route, { path: "/responses/new", component: Auth.LoggedIn(NewResponsePage) }),
			React.createElement(_reactRouterDom.Route, { path: "/responses/:id", component: Auth.LoggedIn(ResponsePage) }),
			React.createElement(_reactRouterDom.Route, { path: "/answers/new", component: Auth.Students(NewAnswerPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/reviews/new", component: Auth.Students(NewAnswerPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/question_builder/new", component: Auth.Students(QuestionBuilderPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/activity_center", component: Auth.Students(StudentActivitiesPage) }),
			React.createElement(_reactRouterDom.Route, { path: OwlShopRouting.PATH, component: Auth.Students(OwlShopPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/quiz", component: Auth.Students(QuizPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/cloze", component: Auth.Students(ClozePage) }),
			React.createElement(_reactRouterDom.Route, { path: MyShelfRouting.PATH, component: Auth.Students(MyShelfPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/insights", component: Auth.TeachersAndSchoolAdmins(InsightsPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/learning_series", component: Auth.TeachersAndSchoolAdmins(TutorialsPage) }),
			React.createElement(_reactRouterDom.Route, { path: ActivitiesPageRouting.PATH, component: Auth.Teachers(ActivitiesPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/activities/:id", component: Auth.Teachers(ActivityPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/picks", component: Auth.Teachers(PicksPage) }),
			React.createElement(_reactRouterDom.Route, { path: ClassPageRouting.PATH, component: Auth.LoggedIn(ClassPage) }),
			React.createElement(_reactRouterDom.Route, { path: RosterRouting.PATH, component: Auth.TeachersAndSchoolAdmins(RosterPage) }),
			React.createElement(_reactRouterDom.Route, { path: DataRouting.PATH, component: Auth.TeachersAndSchoolAdmins(DataPage) }),
			React.createElement(_reactRouterDom.Route, { path: AdminRosterRouting.PATH, component: Auth.TeachersAndSchoolAdmins(AdminRosteringPage) }),
			React.createElement(_reactRouterDom.Route, { path: ContestsRouting.PATH, component: Auth.AllAccess(ContestsPage) }),
			React.createElement(_reactRouterDom.Route, { path: ClassResultsRouting.PATH, component: Auth.AllAccess(ClassResultsPage) }),
			React.createElement(_reactRouterDom.Route, { path: SettingsRouting.PATH, component: Auth.AllAccess(SettingsPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/questions/:text_id?", component: Auth.TeachersAndSchoolAdmins(TextQuestionsPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/upgrade", component: Auth.Teachers(UpgradePage) }),
			React.createElement(_reactRouterDom.Route, { path: "/redirect", component: Auth.AllAccess(RedirectPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/maintenance", component: Auth.AllAccess(MaintenancePage) }),
			React.createElement(_reactRouterDom.Route, { path: "/error", component: Auth.AllAccess(ErrorPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/reset_password", component: Auth.AllAccess(ResetPasswordPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/signout", component: Auth.AllAccess(SignoutPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/student_parents", component: Auth.TeachersAndSchoolAdmins(StudentParentsPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/parents/:id", component: Auth.AllAccess(ParentPage) }),
			React.createElement(_reactRouterDom.Route, { path: "/scratch", component: Auth.DevelopmentAccess(ScratchPage) })
		)
	);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		var fetch = __webpack_require__(184);
		var _ = __webpack_require__(19);
	}
	
	var Client = function Client(alternateHost, alternateProtocol) {
		var self = this;
		self.sharedHeaders = {};
		self.responseHandlers = [];
	
		self.alternateHost = alternateHost;
		self.alternateProtocol = alternateProtocol;
		self.errorHandler = function (error) {
			// Placeholder
			return Promise.reject(error);
		};
	
		function getUrlBase() {
			var protocol = self.alternateProtocol || "https";
			var host = self.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
		self.addResponseHandler = function (handler) {
			self.responseHandlers.push(handler);
		};
		self.resetResponseHandlers = function (value) {
			self.responseHandlers = [];
		};
		self.setErrorHandler = function (handler) {
			self.errorHandler = handler;
		};
	
		// api.postAssessments((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAssessments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/cloze/assessments";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCategories((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCategories = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/cloze/categories";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPassages((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPassages = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/cloze/passages";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPassage(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPassage = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/cloze/passages/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	};
	
	function createQueryString(queryParams) {
		var queryString = '';
		var i = 0;
		for (var queryParamName in queryParams) {
			if (i == 0) {
				queryString += '?';
			} else {
				queryString += '&';
			}
	
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
			i++;
		}
	
		return queryString;
	}
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = Client;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1025 */
[3926, 1024, 1026],
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		$ = __webpack_require__(7);
		_ = __webpack_require__(19);
	}
	
	var LegacyClient = function LegacyClient() {
		var self = this;
		self.sharedHeaders = {};
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
	
		// api.postAssessments((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAssessments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/cloze/assessments";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCategories((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCategories = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/cloze/categories";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPassages((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPassages = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/cloze/passages";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPassage(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPassage = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/cloze/passages/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		function replaceAll(haystack, needle, replace) {
			var result = haystack;
			if (needle != null && replace != null) {
				result = haystack.replace(new RegExp(needle, 'g'), replace);
			}
			return result;
		}
	
		function createQueryString(queryParams) {
			var queryString = '';
			var i = 0;
			for (var queryParamName in queryParams) {
				if (i == 0) {
					queryString += '?';
				} else {
					queryString += '&';
				}
	
				queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
				i++;
			}
	
			return queryString;
		}
	
		function getUrlBase() {
			var protocol = LegacyClient.alternateProtocol || "https";
			var host = LegacyClient.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	};
	
	LegacyClient.setHost = function (host, protocol) {
		LegacyClient.alternateHost = host;
		LegacyClient.alternateProtocol = protocol;
	};
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = LegacyClient;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		var fetch = __webpack_require__(184);
		var _ = __webpack_require__(19);
	}
	
	var Client = function Client(alternateHost, alternateProtocol) {
		var self = this;
		self.sharedHeaders = {};
		self.responseHandlers = [];
	
		self.alternateHost = alternateHost;
		self.alternateProtocol = alternateProtocol;
		self.errorHandler = function (error) {
			// Placeholder
			return Promise.reject(error);
		};
	
		function getUrlBase() {
			var protocol = self.alternateProtocol || "https";
			var host = self.alternateHost || "matilda.whooosreading.org";
			return protocol + "://" + host;
		}
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
		self.addResponseHandler = function (handler) {
			self.responseHandlers.push(handler);
		};
		self.resetResponseHandlers = function (value) {
			self.responseHandlers = [];
		};
		self.setErrorHandler = function (handler) {
			self.errorHandler = handler;
		};
	
		// api.postBooks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postBooks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getScopedBooks(scope, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getScopedBooks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}";
			// url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getScopedBook(scope, id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getScopedBook = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
			// url += ".json";
	
			url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);
	
			var primaryParamsIndex = 2;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchScopedBook(scope, id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchScopedBook = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
			// url += ".json";
	
			url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);
	
			var primaryParamsIndex = 2;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getLibraryOnline((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getLibraryOnline = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/library/online";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getLibraryPlatforms((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getLibraryPlatforms = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/library/platforms";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getScopedLookup(scope, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getScopedLookup = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/lookup/{scope}";
			// url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postScopedLookup(scope, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postScopedLookup = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/lookup/{scope}";
			// url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postOverrides((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postOverrides = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/overrides";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSearch((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSearch = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/search";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	};
	
	function createQueryString(queryParams) {
		var queryString = '';
		var i = 0;
		for (var queryParamName in queryParams) {
			if (i == 0) {
				queryString += '?';
			} else {
				queryString += '&';
			}
	
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
			i++;
		}
	
		return queryString;
	}
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = Client;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		$ = __webpack_require__(7);
		_ = __webpack_require__(19);
	}
	
	var LegacyClient = function LegacyClient() {
		var self = this;
		self.sharedHeaders = {};
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
	
		// api.postBooks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postBooks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getScopedBooks(scope, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getScopedBooks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}";
			url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getScopedBook(scope, id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getScopedBook = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
			url += ".json";
	
			url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 3 && arguments[2]) {
				_.extend(queryParams, arguments[2]);
			}
			if (arguments.length > 4 && arguments[3]) {
				extraParameters = arguments[3];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchScopedBook(scope, id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchScopedBook = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books/{scope}/{id}";
			url += ".json";
	
			url = url.replace('{scope}', arguments[0]).replace('{id}', arguments[1]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 3 && arguments[2]) {
				data = JSON.stringify(arguments[2]);
			}
			if (arguments.length > 4 && arguments[3]) {
				extraParameters = arguments[3];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getLibraryOnline((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getLibraryOnline = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/library/online";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getLibraryPlatforms((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getLibraryPlatforms = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/library/platforms";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getScopedLookup(scope, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getScopedLookup = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/lookup/{scope}";
			url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postScopedLookup(scope, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postScopedLookup = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/lookup/{scope}";
			url += ".json";
	
			url = url.replace('{scope}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postOverrides((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postOverrides = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/overrides";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSearch((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSearch = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/search";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		function replaceAll(haystack, needle, replace) {
			var result = haystack;
			if (needle != null && replace != null) {
				result = haystack.replace(new RegExp(needle, 'g'), replace);
			}
			return result;
		}
	
		function createQueryString(queryParams) {
			var queryString = '';
			var i = 0;
			for (var queryParamName in queryParams) {
				if (i == 0) {
					queryString += '?';
				} else {
					queryString += '&';
				}
	
				queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
				i++;
			}
	
			return queryString;
		}
	
		function getUrlBase() {
			var protocol = LegacyClient.alternateProtocol || "https";
			var host = LegacyClient.alternateHost || "matilda.whooosreading.org";
			return protocol + "://" + host;
		}
	};
	
	LegacyClient.setHost = function (host, protocol) {
		LegacyClient.alternateHost = host;
		LegacyClient.alternateProtocol = protocol;
	};
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = LegacyClient;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		var fetch = __webpack_require__(184);
		var _ = __webpack_require__(19);
	}
	
	var Client = function Client(alternateHost, alternateProtocol) {
		var self = this;
		self.sharedHeaders = {};
		self.responseHandlers = [];
	
		self.alternateHost = alternateHost;
		self.alternateProtocol = alternateProtocol;
		self.errorHandler = function (error) {
			// Placeholder
			return Promise.reject(error);
		};
	
		function getUrlBase() {
			var protocol = self.alternateProtocol || "https";
			var host = self.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
		self.addResponseHandler = function (handler) {
			self.responseHandlers.push(handler);
		};
		self.resetResponseHandlers = function (value) {
			self.responseHandlers = [];
		};
		self.setErrorHandler = function (handler) {
			self.errorHandler = handler;
		};
	
		// api.postAccessTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAccessTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/access_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getActivities((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getActivities = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/activities";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postActivities((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postActivities = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/activities";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getActivity(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getActivity = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchActivity(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchActivity = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteActivity(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteActivity = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAdmins((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAdmins = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/admins";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postAdmins((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAdmins = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/admins";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAdmin(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAdmin = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchAdmin(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchAdmin = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteAdmin(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteAdmin = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnalyzeClassResults((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnalyzeClassResults = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/analyze/class_results";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnalyzeGroupInsights((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnalyzeGroupInsights = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/analyze/group_insights";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnalyzeIndividualInsights((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnalyzeIndividualInsights = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/analyze/individual_insights";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnalyzeProgress((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnalyzeProgress = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/analyze/progress";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnalyzeSkillsets((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnalyzeSkillsets = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/analyze/skillsets";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnswers((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnswers = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/answers";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postAnswers((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAnswers = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/answers";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAnswer(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAnswer = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchAnswer(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchAnswer = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteAnswer(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteAnswer = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAssignments((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAssignments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postAssignments((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAssignments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAssignment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAssignment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchAssignment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchAssignment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteAssignment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteAssignment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAssignmentsCurrent((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAssignmentsCurrent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/assignments/current";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getAvatar(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getAvatar = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/avatars/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchAvatar(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchAvatar = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/avatars/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postAwards((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postAwards = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/awards";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getBooks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getBooks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postBooks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postBooks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getBook(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getBook = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getBookNewsFeedItem(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getBookNewsFeedItem = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/books/{id}/news_feed_item";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverAccessTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverAccessTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverAccessToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverAccessToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchCleverAccessToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchCleverAccessToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverEvents((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverEvents = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_events";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverSections((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverSections = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverSection(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverSection = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchCleverSection(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchCleverSection = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverUsers((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverUsers = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_users";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getCleverUser(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getCleverUser = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_users/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchCleverUser(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchCleverUser = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/clever_users/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getComments((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getComments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/comments";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postComments((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postComments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/comments";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getComment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getComment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchComment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchComment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteComment(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteComment = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postContactMessages((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postContactMessages = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/contact_messages";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postDataExports((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postDataExports = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/data_exports";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDigests((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDigests = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/digests";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDiscountToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDiscountToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchDiscountToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchDiscountToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteDiscountToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteDiscountToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDiscountTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDiscountTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postDiscountTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postDiscountTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDistrictOrgs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDistrictOrgs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postDistrictOrgs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postDistrictOrgs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDistrictOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDistrictOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchDistrictOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchDistrictOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteDistrictOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteDistrictOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDocRequest((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDocRequest = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/doc_request";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getEvaluations((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getEvaluations = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/evaluations";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postEvaluations((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postEvaluations = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/evaluations";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getEvaluation(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getEvaluation = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/evaluations/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchEvaluation(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchEvaluation = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/evaluations/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postFeedbackItem((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postFeedbackItem = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/feedback_item";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchFeedbackItem(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchFeedbackItem = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/feedback_item/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getHello((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getHello = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/hello";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getLogs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getLogs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/logs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postLogs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postLogs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/logs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getLog(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getLog = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchLog(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchLog = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteLog(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteLog = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getNewsFeedItems((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getNewsFeedItems = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getNewsFeedItem(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getNewsFeedItem = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getNewsFeedItemComments(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getNewsFeedItemComments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postNewsFeedItemComments(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postNewsFeedItemComments = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getNotifications((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getNotifications = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/notifications";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postParents((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postParents = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/parents";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getParent(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getParent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/parents/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchParent(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchParent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/parents/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postParentsLogins((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postParentsLogins = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/parents/logins";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPatches((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPatches = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/patches";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postPatches((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postPatches = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/patches";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPasswordResets((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPasswordResets = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/password_resets";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postPasswordResets((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postPasswordResets = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/password_resets";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPerks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPerks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/perks";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postPerks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postPerks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/perks";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPhotographs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPhotographs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/photographs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postPhotographs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postPhotographs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/photographs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getPhotograph(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getPhotograph = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchPhotograph(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchPhotograph = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deletePhotograph(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deletePhotograph = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getQuestions((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getQuestions = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postQuestions((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postQuestions = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getQuestionsQuiz((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getQuestionsQuiz = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions/quiz";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getQuestion(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getQuestion = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchQuestion(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchQuestion = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteQuestion(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteQuestion = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getQuizzes((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getQuizzes = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quizzes";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postQuizzes((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postQuizzes = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quizzes";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getQuiz(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getQuiz = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchQuiz(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchQuiz = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteQuiz(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteQuiz = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getRatings((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getRatings = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/ratings";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postRatings((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postRatings = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/ratings";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getRating(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getRating = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchRating(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchRating = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteRating(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteRating = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getReadingLevels((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getReadingLevels = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/reading_levels";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postReadingLevels((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postReadingLevels = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/reading_levels";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getReferrals((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getReferrals = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/referrals";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postReferrals((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postReferrals = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/referrals";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getResponses((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getResponses = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postResponses((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postResponses = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getResponse(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getResponse = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchResponse(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchResponse = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteResponse(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteResponse = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getResponseNewsFeedItem(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getResponseNewsFeedItem = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}/news_feed_item";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getResponseLink(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getResponseLink = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}/link";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postQuoteRequest((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postQuoteRequest = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/quote_request";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postRosters((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postRosters = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/rosters";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postRostersParse((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postRostersParse = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/rosters/parse";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getStats((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getStats = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/stats";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSchoolOrgs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSchoolOrgs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postSchoolOrgs((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postSchoolOrgs = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSchoolOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSchoolOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchSchoolOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchSchoolOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteSchoolOrg(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteSchoolOrg = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSchools((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSchools = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/schools";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postSchools((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postSchools = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/schools";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSchool(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSchool = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/schools/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchSchool(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchSchool = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/schools/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getStudentList(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getStudentList = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchStudentList(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchStudentList = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteStudentList(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteStudentList = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getStudentLists((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getStudentLists = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/student_lists";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postStudentLists((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postStudentLists = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/student_lists";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getStudents((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getStudents = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postStudents((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postStudents = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchStudents((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchStudents = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getStudent(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getStudent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchStudent(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchStudent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteStudent(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteStudent = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postStudentsMerge((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postStudentsMerge = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/students/merge";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getSurveyPrompts((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getSurveyPrompts = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/survey_prompts";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getTags((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getTags = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tags";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postTags((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postTags = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tags";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteTag(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteTag = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tags/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getTasks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getTasks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tasks";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postTasks((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postTasks = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tasks";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getTask(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getTask = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchTask(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchTask = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteTask(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteTask = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUpgradeToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUpgradeToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchUpgradeToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchUpgradeToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteUpgradeToken(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteUpgradeToken = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUpgradeTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUpgradeTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postUpgradeTokens((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postUpgradeTokens = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postUserAlerts((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postUserAlerts = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/user_alerts";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.deleteUserAlert(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.deleteUserAlert = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/user_alerts/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "DELETE",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUserNewsItems((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUserNewsItems = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/user_news_items";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUsers((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUsers = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/users";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUser(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUser = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getUserTrigger(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getUserTrigger = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}/trigger";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postUserTrigger(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postUserTrigger = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}/trigger";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getWidgetDigests((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getWidgetDigests = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/widget_digests";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postWidgetDigestsTrigger((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postWidgetDigestsTrigger = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/v1/widget_digests/trigger";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	};
	
	function createQueryString(queryParams) {
		var queryString = '';
		var i = 0;
		for (var queryParamName in queryParams) {
			if (i == 0) {
				queryString += '?';
			} else {
				queryString += '&';
			}
	
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
			i++;
		}
	
		return queryString;
	}
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = Client;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		$ = __webpack_require__(7);
		_ = __webpack_require__(19);
	}
	
	var LegacyClient = function LegacyClient() {
		var self = this;
		self.sharedHeaders = {};
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
	
		// api.postAccessTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAccessTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/access_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getActivities((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getActivities = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/activities";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postActivities((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postActivities = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/activities";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getActivity(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getActivity = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchActivity(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchActivity = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteActivity(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteActivity = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/activities/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAdmins((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAdmins = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/admins";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postAdmins((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAdmins = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/admins";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAdmin(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAdmin = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchAdmin(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchAdmin = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteAdmin(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteAdmin = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/admins/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnalyzeClassResults((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnalyzeClassResults = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/analyze/class_results";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnalyzeGroupInsights((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnalyzeGroupInsights = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/analyze/group_insights";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnalyzeIndividualInsights((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnalyzeIndividualInsights = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/analyze/individual_insights";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnalyzeProgress((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnalyzeProgress = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/analyze/progress";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnalyzeSkillsets((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnalyzeSkillsets = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/analyze/skillsets";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnswers((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnswers = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/answers";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postAnswers((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAnswers = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/answers";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAnswer(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAnswer = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchAnswer(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchAnswer = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteAnswer(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteAnswer = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/answers/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAssignments((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAssignments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postAssignments((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAssignments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAssignment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAssignment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchAssignment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchAssignment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteAssignment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteAssignment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAssignmentsCurrent((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAssignmentsCurrent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/assignments/current";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getAvatar(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getAvatar = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/avatars/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchAvatar(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchAvatar = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/avatars/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postAwards((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postAwards = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/awards";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getBooks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getBooks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postBooks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postBooks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getBook(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getBook = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getBookNewsFeedItem(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getBookNewsFeedItem = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/books/{id}/news_feed_item";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverAccessTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverAccessTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverAccessToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverAccessToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchCleverAccessToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchCleverAccessToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverEvents((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverEvents = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_events";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverSections((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverSections = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverSection(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverSection = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchCleverSection(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchCleverSection = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_sections/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverUsers((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverUsers = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_users";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getCleverUser(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getCleverUser = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_users/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchCleverUser(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchCleverUser = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/clever_users/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getComments((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getComments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/comments";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postComments((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postComments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/comments";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getComment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getComment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchComment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchComment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteComment(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteComment = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/comments/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postContactMessages((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postContactMessages = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/contact_messages";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postDataExports((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postDataExports = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/data_exports";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDigests((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDigests = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/digests";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDiscountToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDiscountToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchDiscountToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchDiscountToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteDiscountToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteDiscountToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDiscountTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDiscountTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postDiscountTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postDiscountTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/discount_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDistrictOrgs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDistrictOrgs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postDistrictOrgs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postDistrictOrgs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDistrictOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDistrictOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchDistrictOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchDistrictOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteDistrictOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteDistrictOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/district_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDocRequest((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDocRequest = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/doc_request";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getEvaluations((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getEvaluations = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/evaluations";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postEvaluations((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postEvaluations = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/evaluations";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getEvaluation(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getEvaluation = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/evaluations/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchEvaluation(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchEvaluation = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/evaluations/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postFeedbackItem((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postFeedbackItem = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/feedback_item";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchFeedbackItem(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchFeedbackItem = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/feedback_item/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getHello((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getHello = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/hello";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getLogs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getLogs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/logs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postLogs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postLogs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/logs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getLog(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getLog = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchLog(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchLog = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteLog(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteLog = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/logs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getNewsFeedItems((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getNewsFeedItems = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getNewsFeedItem(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getNewsFeedItem = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getNewsFeedItemComments(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getNewsFeedItemComments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postNewsFeedItemComments(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postNewsFeedItemComments = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getNotifications((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getNotifications = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/notifications";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postParents((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postParents = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/parents";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getParent(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getParent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/parents/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchParent(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchParent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/parents/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postParentsLogins((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postParentsLogins = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/parents/logins";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPatches((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPatches = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/patches";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postPatches((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postPatches = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/patches";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPasswordResets((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPasswordResets = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/password_resets";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postPasswordResets((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postPasswordResets = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/password_resets";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPerks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPerks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/perks";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postPerks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postPerks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/perks";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPhotographs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPhotographs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/photographs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postPhotographs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postPhotographs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/photographs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getPhotograph(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getPhotograph = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchPhotograph(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchPhotograph = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deletePhotograph(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deletePhotograph = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/photographs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getQuestions((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getQuestions = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postQuestions((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postQuestions = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getQuestionsQuiz((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getQuestionsQuiz = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions/quiz";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getQuestion(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getQuestion = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchQuestion(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchQuestion = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteQuestion(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteQuestion = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/questions/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getQuizzes((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getQuizzes = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quizzes";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postQuizzes((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postQuizzes = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quizzes";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getQuiz(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getQuiz = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchQuiz(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchQuiz = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteQuiz(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteQuiz = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quizzes/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getRatings((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getRatings = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/ratings";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postRatings((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postRatings = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/ratings";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getRating(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getRating = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchRating(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchRating = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteRating(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteRating = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/ratings/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getReadingLevels((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getReadingLevels = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/reading_levels";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postReadingLevels((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postReadingLevels = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/reading_levels";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getReferrals((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getReferrals = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/referrals";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postReferrals((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postReferrals = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/referrals";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getResponses((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getResponses = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postResponses((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postResponses = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getResponse(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getResponse = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchResponse(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchResponse = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteResponse(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteResponse = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getResponseNewsFeedItem(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getResponseNewsFeedItem = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}/news_feed_item";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getResponseLink(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getResponseLink = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/responses/{id}/link";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postQuoteRequest((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postQuoteRequest = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/quote_request";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postRosters((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postRosters = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/rosters";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postRostersParse((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postRostersParse = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/rosters/parse";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getStats((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getStats = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/stats";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSchoolOrgs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSchoolOrgs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postSchoolOrgs((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postSchoolOrgs = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSchoolOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSchoolOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchSchoolOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchSchoolOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteSchoolOrg(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteSchoolOrg = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/school_orgs/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSchools((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSchools = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/schools";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postSchools((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postSchools = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/schools";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSchool(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSchool = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/schools/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchSchool(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchSchool = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/schools/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getStudentList(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getStudentList = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchStudentList(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchStudentList = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteStudentList(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteStudentList = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/student_lists/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getStudentLists((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getStudentLists = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/student_lists";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postStudentLists((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postStudentLists = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/student_lists";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getStudents((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getStudents = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postStudents((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postStudents = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchStudents((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchStudents = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getStudent(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getStudent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchStudent(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchStudent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteStudent(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteStudent = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postStudentsMerge((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postStudentsMerge = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/students/merge";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getSurveyPrompts((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getSurveyPrompts = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/survey_prompts";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getTags((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getTags = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tags";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postTags((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postTags = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tags";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteTag(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteTag = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tags/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getTasks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getTasks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tasks";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postTasks((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postTasks = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tasks";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getTask(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getTask = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchTask(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchTask = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteTask(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteTask = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/tasks/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUpgradeToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUpgradeToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchUpgradeToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchUpgradeToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteUpgradeToken(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteUpgradeToken = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUpgradeTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUpgradeTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postUpgradeTokens((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postUpgradeTokens = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/upgrade_tokens";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postUserAlerts((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postUserAlerts = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/user_alerts";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.deleteUserAlert(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.deleteUserAlert = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/user_alerts/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "DELETE",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUserNewsItems((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUserNewsItems = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/user_news_items";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUsers((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUsers = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/users";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUser(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUser = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getUserTrigger(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getUserTrigger = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}/trigger";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postUserTrigger(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postUserTrigger = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/users/{id}/trigger";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getWidgetDigests((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getWidgetDigests = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/widget_digests";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postWidgetDigestsTrigger((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postWidgetDigestsTrigger = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/v1/widget_digests/trigger";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		function replaceAll(haystack, needle, replace) {
			var result = haystack;
			if (needle != null && replace != null) {
				result = haystack.replace(new RegExp(needle, 'g'), replace);
			}
			return result;
		}
	
		function createQueryString(queryParams) {
			var queryString = '';
			var i = 0;
			for (var queryParamName in queryParams) {
				if (i == 0) {
					queryString += '?';
				} else {
					queryString += '&';
				}
	
				queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
				i++;
			}
	
			return queryString;
		}
	
		function getUrlBase() {
			var protocol = LegacyClient.alternateProtocol || "https";
			var host = LegacyClient.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	};
	
	LegacyClient.setHost = function (host, protocol) {
		LegacyClient.alternateHost = host;
		LegacyClient.alternateProtocol = protocol;
	};
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = LegacyClient;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		var fetch = __webpack_require__(184);
		var _ = __webpack_require__(19);
	}
	
	var Client = function Client(alternateHost, alternateProtocol) {
		var self = this;
		self.sharedHeaders = {};
		self.responseHandlers = [];
	
		self.alternateHost = alternateHost;
		self.alternateProtocol = alternateProtocol;
		self.errorHandler = function (error) {
			// Placeholder
			return Promise.reject(error);
		};
	
		function getUrlBase() {
			var protocol = self.alternateProtocol || "https";
			var host = self.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
		self.addResponseHandler = function (handler) {
			self.responseHandlers.push(handler);
		};
		self.resetResponseHandlers = function (value) {
			self.responseHandlers = [];
		};
		self.setErrorHandler = function (handler) {
			self.errorHandler = handler;
		};
	
		// api.postContacts((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postContacts = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/contacts";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getContact(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getContact = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/contacts/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchContact(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchContact = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/contacts/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postDeals((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postDeals = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/deals";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getDeal(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getDeal = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/deals/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchDeal(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchDeal = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/deals/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postEstimates((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postEstimates = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/estimates";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getEstimates((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getEstimates = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/estimates";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchEstimate(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchEstimate = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/estimates/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.postInvoices((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.postInvoices = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/invoices";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "POST",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.getInvoices((primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.getInvoices = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/invoices";
			// url += ".json";
	
			url = url;
	
			var primaryParamsIndex = 0;
			var primaryParamsAsData = true;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "GET",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	
		// api.patchInvoice(id, (primary_parameters), (additional_parameters))
	
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		//   returns: promise of json data
	
		self.patchInvoice = function () {
			var data = null;
			var queryParams = {};
			var headerParams = { "content-type": "application/json" };
			// var postBinaryBody = null;
	
			var url = getUrlBase() + "/api/crm/invoices/{id}";
			// url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var primaryParamsIndex = 1;
			var primaryParamsAsData = false;
	
			if (primaryParamsAsData) {
				_.extend(queryParams, arguments[primaryParamsIndex]);
			} else {
				data = JSON.stringify(arguments[primaryParamsIndex]);
			}
	
			var extraParameters = arguments[primaryParamsIndex + 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			if (extraParameters != null) {
				if (extraParameters["query"]) {
					_.extend(queryParams, extraParameters["query"]);
				}
	
				if (extraParameters["header"]) {
					_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
				}
	
				if (extraParameters["body"]) {
					data = JSON.stringify(extraParameters["body"]);
				}
	
				if (extraParameters["form"]) {
					// Unimplemented, something to do with form data
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				method: "PATCH",
				body: data,
				headers: headerParams
			};
	
			var promise = fetch(url, options);
	
			_.each(self.responseHandlers, function (handler) {
				promise = promise.then(handler);
			});
	
			return promise.then(function (response) {
				return response.json();
			}).catch(self.errorHandler);
		};
	};
	
	function createQueryString(queryParams) {
		var queryString = '';
		var i = 0;
		for (var queryParamName in queryParams) {
			if (i == 0) {
				queryString += '?';
			} else {
				queryString += '&';
			}
	
			queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
			i++;
		}
	
		return queryString;
	}
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = Client;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1032 */
[3926, 1031, 1033],
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $, _;
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		$ = __webpack_require__(7);
		_ = __webpack_require__(19);
	}
	
	var LegacyClient = function LegacyClient() {
		var self = this;
		self.sharedHeaders = {};
	
		// Adds an Authorization header to send along with any
		//   requests through using this instance of the client
		self.addAuth = function (value) {
			self.sharedHeaders["Authorization"] = value;
		};
		self.removeAuth = function () {
			delete self.sharedHeaders["Authorization"];
		};
	
		// api.postContacts((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postContacts = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/contacts";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getContact(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getContact = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/contacts/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchContact(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchContact = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/contacts/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postDeals((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postDeals = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/deals";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getDeal(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getDeal = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/deals/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				_.extend(queryParams, arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchDeal(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchDeal = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/deals/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postEstimates((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postEstimates = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/estimates";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getEstimates((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getEstimates = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/estimates";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchEstimate(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchEstimate = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/estimates/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.postInvoices((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.postInvoices = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/invoices";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				data = JSON.stringify(arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "POST",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.getInvoices((primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.getInvoices = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/invoices";
			url += ".json";
	
			url = url;
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 1 && arguments[0]) {
				_.extend(queryParams, arguments[0]);
			}
			if (arguments.length > 2 && arguments[1]) {
				extraParameters = arguments[1];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "GET",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		// api.patchInvoice(id, (primary_parameters), (additional_parameters), callback)
		//   primary_parameters added to query for GET or DELETE and body for POST and PATCH
		//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
		self.patchInvoice = function () {
			var data = null;
			var postBinaryBody = null;
			var extraParameters = null;
	
			var url = getUrlBase() + "/api/crm/invoices/{id}";
			url += ".json";
	
			url = url.replace('{id}', arguments[0]);
	
			var queryParams = {};
			var headerParams = {};
	
			if (arguments.length > 2 && arguments[1]) {
				data = JSON.stringify(arguments[1]);
			}
			if (arguments.length > 3 && arguments[2]) {
				extraParameters = arguments[2];
			}
	
			var callback = arguments[arguments.length - 1];
	
			if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
				throw "can't submit both form and body data";
			}
	
			var mimeTypes = undefined;
			var contentType = "application/json";
			var processData = true;
	
			if (extraParameters != null) {
				if (extraParameters['query']) {
					_.extend(queryParams, extraParameters['query']);
				}
				if (extraParameters['header']) {
					_.extend(headerParams, self.sharedHeaders, extraParameters['header']);
				}
				if (extraParameters['form']) {
					data = extraParameters['form'];
					mimeTypes = "multipart/form-data";
					contentType = false;
					processData = false;
				}
				if (extraParameters['body']) {
					data = JSON.stringify(extraParameters['body']);
				}
			}
			_.extend(headerParams, self.sharedHeaders);
	
			url += createQueryString(queryParams);
	
			var options = {
				type: "PATCH",
				async: true,
				contentType: contentType,
				mimeTypes: mimeTypes,
				dataType: "json",
				processData: processData,
				data: data,
				headers: headerParams
			};
			var request = $.ajax(url, options);
	
			request.fail(function (jqXHR, textStatus, errorThrown) {
				if (callback) {
					callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
				}
			});
	
			request.done(function (response, textStatus, jqXHR) {
				if (callback) {
					callback(response, true, jqXHR.status, jqXHR);
				}
			});
	
			return request;
		};
	
		function replaceAll(haystack, needle, replace) {
			var result = haystack;
			if (needle != null && replace != null) {
				result = haystack.replace(new RegExp(needle, 'g'), replace);
			}
			return result;
		}
	
		function createQueryString(queryParams) {
			var queryString = '';
			var i = 0;
			for (var queryParamName in queryParams) {
				if (i == 0) {
					queryString += '?';
				} else {
					queryString += '&';
				}
	
				queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
				i++;
			}
	
			return queryString;
		}
	
		function getUrlBase() {
			var protocol = LegacyClient.alternateProtocol || "https";
			var host = LegacyClient.alternateHost || "api.whooosreading.org";
			return protocol + "://" + host;
		}
	};
	
	LegacyClient.setHost = function (host, protocol) {
		LegacyClient.alternateHost = host;
		LegacyClient.alternateProtocol = protocol;
	};
	
	// export module for Node.js
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = LegacyClient;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1240);
	
	__webpack_require__(3608);
	
	__webpack_require__(1041);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(1036);
	
	module.exports = function batchProcessorMaker(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var asyncProcess    = utils.getOption(options, "async", true);
	    var autoProcess     = utils.getOption(options, "auto", true);
	
	    if(autoProcess && !asyncProcess) {
	        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
	        asyncProcess = true;
	    }
	
	    var batch = Batch();
	    var asyncFrameHandler;
	    var isProcessing = false;
	
	    function addFunction(level, fn) {
	        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
	            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
	            // This needs to be done before, since we're checking the size of the batch to be 0.
	            processBatchAsync();
	        }
	
	        batch.add(level, fn);
	    }
	
	    function processBatch() {
	        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
	        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
	        isProcessing = true;
	        while (batch.size()) {
	            var processingBatch = batch;
	            batch = Batch();
	            processingBatch.process();
	        }
	        isProcessing = false;
	    }
	
	    function forceProcessBatch(localAsyncProcess) {
	        if (isProcessing) {
	            return;
	        }
	
	        if(localAsyncProcess === undefined) {
	            localAsyncProcess = asyncProcess;
	        }
	
	        if(asyncFrameHandler) {
	            cancelFrame(asyncFrameHandler);
	            asyncFrameHandler = null;
	        }
	
	        if(localAsyncProcess) {
	            processBatchAsync();
	        } else {
	            processBatch();
	        }
	    }
	
	    function processBatchAsync() {
	        asyncFrameHandler = requestFrame(processBatch);
	    }
	
	    function clearBatch() {
	        batch           = {};
	        batchSize       = 0;
	        topLevel        = 0;
	        bottomLevel     = 0;
	    }
	
	    function cancelFrame(listener) {
	        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	        var cancel = clearTimeout;
	        return cancel(listener);
	    }
	
	    function requestFrame(callback) {
	        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
	        var raf = function(fn) { return setTimeout(fn, 0); };
	        return raf(callback);
	    }
	
	    return {
	        add: addFunction,
	        force: forceProcessBatch
	    };
	};
	
	function Batch() {
	    var batch       = {};
	    var size        = 0;
	    var topLevel    = 0;
	    var bottomLevel = 0;
	
	    function add(level, fn) {
	        if(!fn) {
	            fn = level;
	            level = 0;
	        }
	
	        if(level > topLevel) {
	            topLevel = level;
	        } else if(level < bottomLevel) {
	            bottomLevel = level;
	        }
	
	        if(!batch[level]) {
	            batch[level] = [];
	        }
	
	        batch[level].push(fn);
	        size++;
	    }
	
	    function process() {
	        for(var level = bottomLevel; level <= topLevel; level++) {
	            var fns = batch[level];
	
	            for(var i = 0; i < fns.length; i++) {
	                var fn = fns[i];
	                fn();
	            }
	        }
	    }
	
	    function getSize() {
	        return size;
	    }
	
	    return {
	        add: add,
	        process: process,
	        size: getSize
	    };
	}


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	utils.getOption = getOption;
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports.css = __webpack_require__ (3617);
	module.exports.js = __webpack_require__ (1038);


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__ (3522);
	__webpack_require__ (3512);
	__webpack_require__ (3513);
	__webpack_require__ (3514);
	__webpack_require__ (3515);
	__webpack_require__ (3516);
	__webpack_require__ (3517);
	__webpack_require__ (3521);
	__webpack_require__ (3518);
	__webpack_require__ (3519);
	__webpack_require__ (3520);
	__webpack_require__ (3511);


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1037);


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(3869);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // avoid screen readers from reading out loud the text
	    mark.ariaHidden = "true"
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1048);
	module.exports = __webpack_require__(76).RegExp.escape;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	var isArray = __webpack_require__(208);
	var SPECIES = __webpack_require__(37)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(30);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(87);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(129);
	var gOPS = __webpack_require__(212);
	var pIE = __webpack_require__(181);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(182)('native-function-to-string', Function.toString);


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(5);
	var $re = __webpack_require__(1047)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(448) });
	
	__webpack_require__(111)('copyWithin');


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $every = __webpack_require__(84)(4);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', { fill: __webpack_require__(263) });
	
	__webpack_require__(111)('fill');


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $filter = __webpack_require__(84)(2);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(5);
	var $find = __webpack_require__(84)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(111)(KEY);


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(5);
	var $find = __webpack_require__(84)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(111)(KEY);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $forEach = __webpack_require__(84)(0);
	var STRICT = __webpack_require__(78)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(77);
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var call = __webpack_require__(459);
	var isArrayIter = __webpack_require__(271);
	var toLength = __webpack_require__(39);
	var createProperty = __webpack_require__(265);
	var getIterFn = __webpack_require__(287);
	
	$export($export.S + $export.F * !__webpack_require__(210)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $indexOf = __webpack_require__(205)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(208) });


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(70);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(180) != Object || !__webpack_require__(78)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(70);
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(39);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $map = __webpack_require__(84)(1);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var createProperty = __webpack_require__(265);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(30)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $reduce = __webpack_require__(450);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $reduce = __webpack_require__(450);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var html = __webpack_require__(269);
	var cof = __webpack_require__(75);
	var toAbsoluteIndex = __webpack_require__(133);
	var toLength = __webpack_require__(39);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(30)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $some = __webpack_require__(84)(3);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(56);
	var toObject = __webpack_require__(50);
	var fails = __webpack_require__(30);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(78)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132)('Array');


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(5);
	var toISOString = __webpack_require__(1043);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(87);
	
	$export($export.P + $export.F * __webpack_require__(30)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(37)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(60)(proto, TO_PRIMITIVE, __webpack_require__(1044));


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(61)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Function', { bind: __webpack_require__(451) });


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(32);
	var getPrototypeOf = __webpack_require__(69);
	var HAS_INSTANCE = __webpack_require__(37)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(47).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(47).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(42) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(5);
	var log1p = __webpack_require__(462);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(5);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(5);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(5);
	var sign = __webpack_require__(275);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(5);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(5);
	var $expm1 = __webpack_require__(274);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { fround: __webpack_require__(461) });


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(5);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(5);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(30)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(462) });


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { sign: __webpack_require__(275) });


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(5);
	var expm1 = __webpack_require__(274);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(30)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(5);
	var expm1 = __webpack_require__(274);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(28);
	var has = __webpack_require__(67);
	var cof = __webpack_require__(75);
	var inheritIfRequired = __webpack_require__(270);
	var toPrimitive = __webpack_require__(87);
	var fails = __webpack_require__(30);
	var gOPN = __webpack_require__(128).f;
	var gOPD = __webpack_require__(68).f;
	var dP = __webpack_require__(47).f;
	var $trim = __webpack_require__(148).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(127)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(42) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(61)(global, NUMBER, $Number);
	}


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(5);
	var _isFinite = __webpack_require__(28).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(458) });


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(5);
	var isInteger = __webpack_require__(458);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseFloat = __webpack_require__(470);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseInt = __webpack_require__(471);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toInteger = __webpack_require__(79);
	var aNumberValue = __webpack_require__(447);
	var repeat = __webpack_require__(282);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(30)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $fails = __webpack_require__(30);
	var aNumberValue = __webpack_require__(447);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(5);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(464) });


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(127) });


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperties: __webpack_require__(465) });


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperty: __webpack_require__(47).f });


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(32);
	var meta = __webpack_require__(113).onFreeze;
	
	__webpack_require__(86)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(70);
	var $getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	__webpack_require__(86)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(86)('getOwnPropertyNames', function () {
	  return __webpack_require__(466).f;
	});


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(50);
	var $getPrototypeOf = __webpack_require__(69);
	
	__webpack_require__(86)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(32);
	
	__webpack_require__(86)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(32);
	
	__webpack_require__(86)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(32);
	
	__webpack_require__(86)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', { is: __webpack_require__(474) });


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(50);
	var $keys = __webpack_require__(129);
	
	__webpack_require__(86)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(32);
	var meta = __webpack_require__(113).onFreeze;
	
	__webpack_require__(86)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(32);
	var meta = __webpack_require__(113).onFreeze;
	
	__webpack_require__(86)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(279).set });


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(145);
	var test = {};
	test[__webpack_require__(37)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(61)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseFloat = __webpack_require__(470);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseInt = __webpack_require__(471);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(112);
	var global = __webpack_require__(28);
	var ctx = __webpack_require__(77);
	var classof = __webpack_require__(145);
	var $export = __webpack_require__(5);
	var isObject = __webpack_require__(32);
	var aFunction = __webpack_require__(56);
	var anInstance = __webpack_require__(125);
	var forOf = __webpack_require__(126);
	var speciesConstructor = __webpack_require__(183);
	var task = __webpack_require__(284).set;
	var microtask = __webpack_require__(276)();
	var newPromiseCapabilityModule = __webpack_require__(277);
	var perform = __webpack_require__(472);
	var userAgent = __webpack_require__(218);
	var promiseResolve = __webpack_require__(473);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(37)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(131)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(147)($Promise, PROMISE);
	__webpack_require__(132)(PROMISE);
	Wrapper = __webpack_require__(76)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(210)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var rApply = (__webpack_require__(28).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(30)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(5);
	var create = __webpack_require__(127);
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(32);
	var fails = __webpack_require__(30);
	var bind = __webpack_require__(451);
	var rConstruct = (__webpack_require__(28).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(47);
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(87);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(30)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(5);
	var gOPD = __webpack_require__(68).f;
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(22);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(272)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(68);
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(5);
	var getProto = __webpack_require__(69);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(68);
	var getPrototypeOf = __webpack_require__(69);
	var has = __webpack_require__(67);
	var $export = __webpack_require__(5);
	var isObject = __webpack_require__(32);
	var anObject = __webpack_require__(22);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(22);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(469) });


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(22);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(5);
	var setProto = __webpack_require__(279);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(47);
	var gOPD = __webpack_require__(68);
	var getPrototypeOf = __webpack_require__(69);
	var has = __webpack_require__(67);
	var $export = __webpack_require__(5);
	var createDesc = __webpack_require__(130);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(32);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var inheritIfRequired = __webpack_require__(270);
	var dP = __webpack_require__(47).f;
	var gOPN = __webpack_require__(128).f;
	var isRegExp = __webpack_require__(209);
	var $flags = __webpack_require__(179);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(42) && (!CORRECT_NEW || __webpack_require__(30)(function () {
	  re2[__webpack_require__(37)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(61)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(132)('RegExp');


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(39);
	var advanceStringIndex = __webpack_require__(262);
	var regExpExec = __webpack_require__(213);
	
	// @@match logic
	__webpack_require__(207)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(39);
	var toInteger = __webpack_require__(79);
	var advanceStringIndex = __webpack_require__(262);
	var regExpExec = __webpack_require__(213);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(207)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var sameValue = __webpack_require__(474);
	var regExpExec = __webpack_require__(213);
	
	// @@search logic
	__webpack_require__(207)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(209);
	var anObject = __webpack_require__(22);
	var speciesConstructor = __webpack_require__(183);
	var advanceStringIndex = __webpack_require__(262);
	var toLength = __webpack_require__(39);
	var callRegExpExec = __webpack_require__(213);
	var regexpExec = __webpack_require__(278);
	var fails = __webpack_require__(30);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(207)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(480);
	var anObject = __webpack_require__(22);
	var $flags = __webpack_require__(179);
	var DESCRIPTORS = __webpack_require__(42);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(61)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(30)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(62)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(62)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(62)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(62)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $at = __webpack_require__(216)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(5);
	var toLength = __webpack_require__(39);
	var context = __webpack_require__(281);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(268)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(62)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(62)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(62)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var toAbsoluteIndex = __webpack_require__(133);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(5);
	var context = __webpack_require__(281);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(268)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(62)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(216)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(273)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(62)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(70);
	var toLength = __webpack_require__(39);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(282)
	});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(62)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(5);
	var toLength = __webpack_require__(39);
	var context = __webpack_require__(281);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(268)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(62)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(62)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(62)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(148)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(28);
	var has = __webpack_require__(67);
	var DESCRIPTORS = __webpack_require__(42);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(61);
	var META = __webpack_require__(113).KEY;
	var $fails = __webpack_require__(30);
	var shared = __webpack_require__(182);
	var setToStringTag = __webpack_require__(147);
	var uid = __webpack_require__(134);
	var wks = __webpack_require__(37);
	var wksExt = __webpack_require__(477);
	var wksDefine = __webpack_require__(286);
	var enumKeys = __webpack_require__(1045);
	var isArray = __webpack_require__(208);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(32);
	var toObject = __webpack_require__(50);
	var toIObject = __webpack_require__(70);
	var toPrimitive = __webpack_require__(87);
	var createDesc = __webpack_require__(130);
	var _create = __webpack_require__(127);
	var gOPNExt = __webpack_require__(466);
	var $GOPD = __webpack_require__(68);
	var $GOPS = __webpack_require__(212);
	var $DP = __webpack_require__(47);
	var $keys = __webpack_require__(129);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(128).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(181).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(112)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(60)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $typed = __webpack_require__(217);
	var buffer = __webpack_require__(285);
	var anObject = __webpack_require__(22);
	var toAbsoluteIndex = __webpack_require__(133);
	var toLength = __webpack_require__(39);
	var isObject = __webpack_require__(32);
	var ArrayBuffer = __webpack_require__(28).ArrayBuffer;
	var speciesConstructor = __webpack_require__(183);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(30)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(132)(ARRAY_BUFFER);


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	$export($export.G + $export.W + $export.F * !__webpack_require__(217).ABV, {
	  DataView: __webpack_require__(285).DataView
	});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(454);
	var validate = __webpack_require__(135);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(206)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(455);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(39);
	var aFunction = __webpack_require__(56);
	var arraySpeciesCreate = __webpack_require__(264);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(111)('flatMap');


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(455);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(39);
	var toInteger = __webpack_require__(79);
	var arraySpeciesCreate = __webpack_require__(264);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(111)('flatten');


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(5);
	var $includes = __webpack_require__(205)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(111)('includes');


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(5);
	var microtask = __webpack_require__(276)();
	var process = __webpack_require__(28).process;
	var isNode = __webpack_require__(75)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(5);
	var cof = __webpack_require__(75);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(5);
	
	$export($export.G, { global: __webpack_require__(28) });


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(214)('Map');


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(215)('Map');


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(453)('Map') });


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var scale = __webpack_require__(463);
	var fround = __webpack_require__(461);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { scale: __webpack_require__(463) });


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var aFunction = __webpack_require__(56);
	var $defineProperty = __webpack_require__(47);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(42) && $export($export.P + __webpack_require__(211), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var aFunction = __webpack_require__(56);
	var $defineProperty = __webpack_require__(47);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(42) && $export($export.P + __webpack_require__(211), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(5);
	var $entries = __webpack_require__(468)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(5);
	var ownKeys = __webpack_require__(469);
	var toIObject = __webpack_require__(70);
	var gOPD = __webpack_require__(68);
	var createProperty = __webpack_require__(265);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(87);
	var getPrototypeOf = __webpack_require__(69);
	var getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(42) && $export($export.P + __webpack_require__(211), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(87);
	var getPrototypeOf = __webpack_require__(69);
	var getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(42) && $export($export.P + __webpack_require__(211), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(5);
	var $values = __webpack_require__(468)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(5);
	var global = __webpack_require__(28);
	var core = __webpack_require__(76);
	var microtask = __webpack_require__(276)();
	var OBSERVABLE = __webpack_require__(37)('observable');
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var anInstance = __webpack_require__(125);
	var redefineAll = __webpack_require__(131);
	var hide = __webpack_require__(60);
	var forOf = __webpack_require__(126);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(132)('Observable');


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(5);
	var core = __webpack_require__(76);
	var global = __webpack_require__(28);
	var speciesConstructor = __webpack_require__(183);
	var promiseResolve = __webpack_require__(473);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(5);
	var newPromiseCapability = __webpack_require__(277);
	var perform = __webpack_require__(472);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(481);
	var from = __webpack_require__(449);
	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(96);
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(56);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(214)('Set');


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(215)('Set');


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(453)('Set') });


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(5);
	var $at = __webpack_require__(216)(true);
	var $fails = __webpack_require__(30);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(5);
	var defined = __webpack_require__(85);
	var toLength = __webpack_require__(39);
	var isRegExp = __webpack_require__(209);
	var getFlags = __webpack_require__(179);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(272)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5);
	var $pad = __webpack_require__(475);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5);
	var $pad = __webpack_require__(475);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(148)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(148)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(286)('asyncIterator');


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(286)('observable');


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(5);
	
	$export($export.S, 'System', { global: __webpack_require__(28) });


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(214)('WeakMap');


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(215)('WeakMap');


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(214)('WeakSet');


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(215)('WeakSet');


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(288);
	var getKeys = __webpack_require__(129);
	var redefine = __webpack_require__(61);
	var global = __webpack_require__(28);
	var hide = __webpack_require__(60);
	var Iterators = __webpack_require__(146);
	var wks = __webpack_require__(37);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $task = __webpack_require__(284);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(28);
	var $export = __webpack_require__(5);
	var userAgent = __webpack_require__(218);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1168);
	__webpack_require__(1107);
	__webpack_require__(1109);
	__webpack_require__(1108);
	__webpack_require__(1111);
	__webpack_require__(1113);
	__webpack_require__(1118);
	__webpack_require__(1112);
	__webpack_require__(1110);
	__webpack_require__(1120);
	__webpack_require__(1119);
	__webpack_require__(1115);
	__webpack_require__(1116);
	__webpack_require__(1114);
	__webpack_require__(1106);
	__webpack_require__(1117);
	__webpack_require__(1121);
	__webpack_require__(1122);
	__webpack_require__(1074);
	__webpack_require__(1076);
	__webpack_require__(1075);
	__webpack_require__(1124);
	__webpack_require__(1123);
	__webpack_require__(1094);
	__webpack_require__(1104);
	__webpack_require__(1105);
	__webpack_require__(1095);
	__webpack_require__(1096);
	__webpack_require__(1097);
	__webpack_require__(1098);
	__webpack_require__(1099);
	__webpack_require__(1100);
	__webpack_require__(1101);
	__webpack_require__(1102);
	__webpack_require__(1103);
	__webpack_require__(1077);
	__webpack_require__(1078);
	__webpack_require__(1079);
	__webpack_require__(1080);
	__webpack_require__(1081);
	__webpack_require__(1082);
	__webpack_require__(1083);
	__webpack_require__(1084);
	__webpack_require__(1085);
	__webpack_require__(1086);
	__webpack_require__(1087);
	__webpack_require__(1088);
	__webpack_require__(1089);
	__webpack_require__(1090);
	__webpack_require__(1091);
	__webpack_require__(1092);
	__webpack_require__(1093);
	__webpack_require__(1155);
	__webpack_require__(1160);
	__webpack_require__(1167);
	__webpack_require__(1158);
	__webpack_require__(1150);
	__webpack_require__(1151);
	__webpack_require__(1156);
	__webpack_require__(1161);
	__webpack_require__(1163);
	__webpack_require__(1146);
	__webpack_require__(1147);
	__webpack_require__(1148);
	__webpack_require__(1149);
	__webpack_require__(1152);
	__webpack_require__(1153);
	__webpack_require__(1154);
	__webpack_require__(1157);
	__webpack_require__(1159);
	__webpack_require__(1162);
	__webpack_require__(1164);
	__webpack_require__(1165);
	__webpack_require__(1166);
	__webpack_require__(1069);
	__webpack_require__(1071);
	__webpack_require__(1070);
	__webpack_require__(1073);
	__webpack_require__(1072);
	__webpack_require__(1058);
	__webpack_require__(1056);
	__webpack_require__(1062);
	__webpack_require__(1059);
	__webpack_require__(1065);
	__webpack_require__(1067);
	__webpack_require__(1055);
	__webpack_require__(1061);
	__webpack_require__(1052);
	__webpack_require__(1066);
	__webpack_require__(1050);
	__webpack_require__(1064);
	__webpack_require__(1063);
	__webpack_require__(1057);
	__webpack_require__(1060);
	__webpack_require__(1049);
	__webpack_require__(1051);
	__webpack_require__(1054);
	__webpack_require__(1053);
	__webpack_require__(1068);
	__webpack_require__(288);
	__webpack_require__(1140);
	__webpack_require__(479);
	__webpack_require__(1145);
	__webpack_require__(480);
	__webpack_require__(1141);
	__webpack_require__(1142);
	__webpack_require__(1143);
	__webpack_require__(1144);
	__webpack_require__(1125);
	__webpack_require__(478);
	__webpack_require__(481);
	__webpack_require__(482);
	__webpack_require__(1180);
	__webpack_require__(1169);
	__webpack_require__(1170);
	__webpack_require__(1175);
	__webpack_require__(1178);
	__webpack_require__(1179);
	__webpack_require__(1173);
	__webpack_require__(1176);
	__webpack_require__(1174);
	__webpack_require__(1177);
	__webpack_require__(1171);
	__webpack_require__(1172);
	__webpack_require__(1126);
	__webpack_require__(1127);
	__webpack_require__(1128);
	__webpack_require__(1129);
	__webpack_require__(1130);
	__webpack_require__(1133);
	__webpack_require__(1131);
	__webpack_require__(1132);
	__webpack_require__(1134);
	__webpack_require__(1135);
	__webpack_require__(1136);
	__webpack_require__(1137);
	__webpack_require__(1139);
	__webpack_require__(1138);
	__webpack_require__(1183);
	__webpack_require__(1181);
	__webpack_require__(1182);
	__webpack_require__(1224);
	__webpack_require__(1227);
	__webpack_require__(1226);
	__webpack_require__(1228);
	__webpack_require__(1229);
	__webpack_require__(1225);
	__webpack_require__(1230);
	__webpack_require__(1231);
	__webpack_require__(1205);
	__webpack_require__(1208);
	__webpack_require__(1204);
	__webpack_require__(1202);
	__webpack_require__(1203);
	__webpack_require__(1206);
	__webpack_require__(1207);
	__webpack_require__(1189);
	__webpack_require__(1223);
	__webpack_require__(1188);
	__webpack_require__(1222);
	__webpack_require__(1234);
	__webpack_require__(1236);
	__webpack_require__(1187);
	__webpack_require__(1221);
	__webpack_require__(1233);
	__webpack_require__(1235);
	__webpack_require__(1186);
	__webpack_require__(1232);
	__webpack_require__(1185);
	__webpack_require__(1190);
	__webpack_require__(1191);
	__webpack_require__(1192);
	__webpack_require__(1193);
	__webpack_require__(1194);
	__webpack_require__(1196);
	__webpack_require__(1195);
	__webpack_require__(1197);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1201);
	__webpack_require__(1200);
	__webpack_require__(1210);
	__webpack_require__(1211);
	__webpack_require__(1212);
	__webpack_require__(1213);
	__webpack_require__(1215);
	__webpack_require__(1214);
	__webpack_require__(1217);
	__webpack_require__(1216);
	__webpack_require__(1218);
	__webpack_require__(1219);
	__webpack_require__(1220);
	__webpack_require__(1184);
	__webpack_require__(1209);
	__webpack_require__(1239);
	__webpack_require__(1238);
	__webpack_require__(1237);
	module.exports = __webpack_require__(76);


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(343);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(20);
	var factory = __webpack_require__(1241);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:6px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker__navigation{line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;border:.45rem solid transparent;z-index:1}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b2b2}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b2b2}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b2b2}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b2b2}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:30px;width:100%}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b2b2}.react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b2b2}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b2b2}.react-datepicker__month-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;display:inline-block;height:0;outline:0;padding:0;vertical-align:middle}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:7px;text-align:center;top:50%}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b2b2}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b2b2}", ""]);
	
	// exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:0;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:0;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:0;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:0;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:0}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(491) + ");src:url(" + __webpack_require__(491) + ") format(\"embedded-opentype\"),url(" + __webpack_require__(3888) + ") format(\"woff2\"),url(" + __webpack_require__(3887) + ") format(\"woff\"),url(" + __webpack_require__(1545) + ") format(\"truetype\"),url(" + __webpack_require__(3913) + ") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{display:table;content:\" \"}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014\\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0\\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.container:after,.container:before{display:table;content:\" \"}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.container-fluid:after,.container-fluid:before{display:table;content:\" \"}.container-fluid:after{clear:both}.row{margin-right:-15px;margin-left:-15px}.row:after,.row:before{display:table;content:\" \"}.row:after{clear:both}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box;-webkit-appearance:none;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-right:0;padding-left:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{display:table;content:\" \"}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default:hover{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;background-image:none;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary:hover{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;background-image:none;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success:hover{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;background-image:none;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;background-image:none;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;background-image:none;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;background-image:none;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{display:table;content:\" \"}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav:after,.nav:before{display:table;content:\" \"}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{display:table;content:\" \"}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{display:table;content:\" \"}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{display:table;content:\" \"}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px)and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-right:15px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#090909}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.428571429;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager:after,.pager:before{display:table;content:\" \"}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-right:auto;margin-left:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{display:table;content:\" \"}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{display:table;content:\" \"}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{display:table;content:\" \"}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.428571429;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:12px;filter:alpha(opacity=0);opacity:0}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.428571429;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover>.arrow{border-width:11px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;filter:alpha(opacity=90);opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{display:table;content:\" \"}.clearfix:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px)and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px)and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px)and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px)and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px)and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px)and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px)and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px)and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px)and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px)and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".owlPhotosContainer{margin-top:15px}.owlPhotosContainer .photos{border:1px solid #000;display:inline-block;width:50%;vertical-align:top}.owlPhotosContainer .photos.selectedBackground{background:#ff0}.owlPhotosContainer .controls{display:inline-block;width:40%;vertical-align:top;margin-left:10%}.owlPhotosContainer .controls .control{cursor:pointer}.owlPhotosContainer .controls .control .icon{border:1px solid #000;width:35px;height:35px;border-radius:50%;display:inline-block;margin-bottom:15px;margin-right:15px}.owlPhotosContainer .controls .control span{vertical-align:top}.owlPhotosContainer .controls .carouselControl{text-align:center}.owlPhotosContainer .controls .carouselControl .arrow{color:#555;font-size:1em}.owlPhotosContainer .controls .carouselControl .arrow:focus{outline:none}.owlPhotosContainer .controls .positionControl{text-align:center}.owlPhotosContainer .controls .positionControl .arrow{color:#555;font-size:1.2em}.owlPhotosContainer .controls .positionControl .arrow:focus{outline:none}.owlPhotosContainer .controls .xyControl .positionControl{position:relative;height:60px;width:200px;margin:0 auto}.owlPhotosContainer .controls .xyControl .positionControl .arrow{position:absolute}.owlPhotosContainer .controls .xyControl .positionControl .arrow.up{top:-8px;left:78px}.owlPhotosContainer .controls .xyControl .positionControl .arrow.down{top:40px;left:78px}.owlPhotosContainer .controls .xyControl .positionControl .arrow.right{top:15px;left:103px}.owlPhotosContainer .controls .xyControl .positionControl .arrow.left{top:15px;left:53px}.owlPhotosContainer .controls .backgrounds .bg{display:inline-block;width:29%;height:auto;background:#d3d3d3;margin:2%;cursor:pointer}.owlPhotosContainer .controls .backgrounds .bg:first-of-type{margin-left:0}.owlPhotosContainer .controls .backgrounds .bg:nth-of-type(3){margin-right:0}.owlPhotosContainer .controls .backgrounds .bg.selected{border:1px solid #555}.owlPhotosContainer .controls .caption textarea{width:100%}.owlPhotosContainer .coinDisplay{position:relative;bottom:2px}.owlPhotosContainer .controlHeader{text-align:center;padding-bottom:0;margin-bottom:10px;border-bottom:1px solid #ccc;font-weight:700}.owlPhotosContainer .controlSection{margin-bottom:25px}.owlPhotosContainer .curtain{background-color:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb;position:absolute;top:30%;margin-left:25%;width:320px;text-align:center;z-index:3000;padding:15px}.owlPhotosContainer .curtain .lockImg{width:55px;margin-bottom:10px}.closedShop{opacity:.4;pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".owlShopColorPicker{padding-left:30px;padding-right:30px;border-top:1px solid #eee;padding-top:10px;margin-top:10px}.owlShopColorPicker .swatch{position:relative;display:inline-block;border-radius:8px;width:25px;height:25px;margin-right:10px;cursor:pointer}.owlShopColorPicker .swatch:hover{opacity:.7}.owlShopColorPicker .swatch.active{box-shadow:0 0 2px #aaa solid}.owlShopColorPicker .swatch .glyphicon{position:absolute;top:5px;left:11px}", ""]);
	
	// exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".owlShopDisplay{text-align:center;margin-bottom:20px}.owlShopDisplay .displayItem{position:relative;display:inline-block;width:24%;padding:5px;padding-bottom:10px;text-align:center;margin-top:5px;color:inherit;font-size:.8em;text-decoration:none}.owlShopDisplay .displayItem:hover{opacity:.7}.owlShopDisplay .displayItem p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:0}.owlShopDisplay .displayItem.inRangeTier,.owlShopDisplay .displayItem.outRangeTier{opacity:.5}.owlShopDisplay .displayItem.inRangeTier .itemDescription,.owlShopDisplay .displayItem.outRangeTier .itemDescription{opacity:.7}.owlShopDisplay .displayItem.inRangeTier .patchValueContainer .coinDisplay,.owlShopDisplay .displayItem.inRangeTier .patchValueContainer .statusText,.owlShopDisplay .displayItem.sameTier .patchValueContainer .coinDisplay,.owlShopDisplay .displayItem.sameTier .patchValueContainer .statusText{position:relative;right:13px}.owlShopDisplay .displayItem.inRangeTier .patchValueContainer .tierImg,.owlShopDisplay .displayItem.sameTier .patchValueContainer .tierImg{position:relative;right:5px}.owlShopDisplay .displayItem .patchValueContainer{margin-top:5px}.owlShopDisplay .displayItem.outRangeTier .lockImg{width:45px;margin-top:12px;margin-bottom:12px}.owlShopDisplay .displayItem.outRangeTier .itemDescription{display:none}.owlShopDisplay .displayItem .tierImg{width:18px}.owlShopDisplay .displayItem img.patchThumbnail{display:block;height:50%;width:50%;margin:0 auto}.owlShopDisplay .displayItem.selectedPatch{border:1px solid #ddd;border-radius:5px;padding-top:15px}.owlShopDisplay .displayItem.titleClass{width:21%;margin-left:10px}.owlShopDisplay .displayItem.titleClass .title{font-weight:700}.owlShopDisplay .displayItem .verticalDivider{width:0;height:20px;border-left:1px solid #555;display:inline-block;position:relative;top:5px;right:14px}.owlShopDisplay .displayItem .tierDisplay{position:relative;right:5px;border-radius:14px;border:1px solid #555;height:20px;width:20px;display:inline-block}.owlShopDisplay .arrow{color:#555;font-size:26px}.owlShopDisplay .arrow:focus{outline:none}.owlShopDisplay .previewDetails{transition:opacity .3s,max-height .3s;max-height:200px;opacity:1;margin-bottom:15px;padding:0 30px}.owlShopDisplay .previewDetails.expand-enter,.owlShopDisplay .previewDetails.expand-exit{max-height:0;opacity:.01}.owlShopDisplay .previewDetails p{margin-bottom:0}.owlShopDisplay .previewDetails.inRangeTier .previewDesc,.owlShopDisplay .previewDetails.outRangeTier .previewDesc{opacity:.7}.owlShopDisplay .previewDetails.outRangeTier .previewDesc .itemDescription{display:none}.owlShopDisplay .previewDetails .previewDesc{margin-right:5%;display:inline-block;vertical-align:middle;width:70%}.owlShopDisplay .previewDetails .previewDesc .coinDisplay{vertical-align:top}.owlShopDisplay .previewDetails .previewControl{display:inline-block;vertical-align:top;margin-left:10px}.owlShopDisplay .previewDetails .previewControl .enabledButton{width:100px;display:inline-block}.owlShopDisplay .previewDetails .previewControl .btn-link{display:inline-block}.owlShopDisplay .previewDetails .previewControl .statusText{margin-top:5px}.owlShopDisplay .previewDetails .upgradeText{display:inline-block;width:82%}.owlShopDisplay .previewDetails .coinDisplay{vertical-align:top}.owlShopDisplay .displayControls{position:relative}.owlShopDisplay .alternatePatchTypes{position:absolute;left:30px;margin-top:10px}.owlShopDisplay .alternatePatchTypes .verticalDivider{border-color:#ccc;height:20px;margin-right:10px;margin-left:10px}.owlShopDisplay .alternatePatchTypes a{text-decoration:none;padding-bottom:2px}.owlShopDisplay .alternatePatchTypes a.selected,.owlShopDisplay .alternatePatchTypes a:hover{border-bottom:1px solid #999}.owlShopDisplay .inConfirm:hover{opacity:1!important}.owlShopDisplay .emptyMessage{padding:5%}", ""]);
	
	// exports


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#owlShopPage .header{margin-top:15px;width:195px}#owlShopPage .displayToggleControl{margin-bottom:10px;position:relative;left:80%;width:fit-content;padding:.5%}#owlShopPage .withBackground{background-color:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb}#owlShopPage .preview{display:inline-block;max-width:280px}#owlShopPage .preview .previewOwl{padding-left:6%}#owlShopPage .preview .owlConstraints{float:none;margin:0 auto}#owlShopPage .preview .owlConstraints .owlConstraintsInner{overflow:hidden}#owlShopPage .preview .owlvatarStandin{margin-left:45px;float:left}#owlShopPage .preview.fixed{position:fixed;top:55px;border-radius:20px;z-index:100}#owlShopPage .preview.absolute{position:absolute;z-index:100}#owlShopPage .leftControls{padding-top:10px;padding-bottom:10px;text-align:center}#owlShopPage .leftControls .reqsDescriptionTop{margin:5% 10% -5%;font-size:.9em}#owlShopPage .leftControls .reqsDescriptionBottom{margin-top:5%;margin-left:10%;margin-right:10%;font-size:.8em}#owlShopPage .leftControls .nameDisplay{clear:left;padding-top:10%;margin-bottom:5%}#owlShopPage .leftControls .detailsGroup{display:flex;justify-content:center;margin-bottom:10%}#owlShopPage .leftControls .currentTierImage{height:3rem;width:auto;margin-left:1rem;position:relative;z-index:5000}#owlShopPage .leftControls .currentTierReqs{display:inline-block}#owlShopPage .leftControls .currentTierReqs:hover{cursor:pointer}#owlShopPage .leftControls .houseAvatar{position:relative;width:30px;margin-left:1rem;z-index:5000}#owlShopPage .leftControls .saveButton{margin-top:10px;margin-bottom:10%}.hasBackground .leftControls,.hasBackground h1{background-color:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb}", ""]);
	
	// exports


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".OwlShopPatcher .curtain{background-color:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb;position:absolute;top:30%;margin-left:25%;width:320px;text-align:center;z-index:3000;padding:15px}.OwlShopPatcher .curtain .lockImg{width:55px;margin-bottom:10px}.OwlShopPatcher .closedShop{opacity:.4;pointer-events:none}.OwlShopPatcher .categorySelector{border-bottom:1px solid #eee;padding-bottom:10px}.OwlShopPatcher .categorySelector h4{text-align:center}.OwlShopPatcher .categorySelector a.selector{text-align:center;display:inline-block;position:relative;margin-bottom:15px;width:13%;text-decoration:none;color:inherit;line-height:.8}.OwlShopPatcher .categorySelector a.selector:hover{opacity:.7}.OwlShopPatcher .categorySelector a.selector img{width:auto;height:40px;display:block;margin:0 auto}.OwlShopPatcher .categorySelector a.selector .categoryTitle{position:relative;top:3px;font-size:.8em}.OwlShopPatcher .categorySelector .categorySection{text-align:center}.OwlShopPatcher .categorySelector .categorySection .selector{border:1px solid #fff;padding:5px;padding-bottom:10px}.OwlShopPatcher .categorySelector .categorySection .selectedPatchType{border-color:#ddd;border-radius:5px}.OwlShopPatcher .categorySelector .categorySection .modeSelectorRowContainer{display:flex;flex-direction:column;gap:1em}.OwlShopPatcher .categorySelector .categorySection .modeSelectorRowContainer .sectionTitle{font-size:1.1em}.OwlShopPatcher .categorySelector .categorySection .dressingSelectors{background:#fff;padding:2%;border-radius:2%}.OwlShopPatcher .categorySelector .patchCategory{width:50%}.OwlShopPatcher .categorySelector .actionSection{width:20%}.OwlShopPatcher .categorySelector .otherSection{width:30%}.OwlShopPatcher .dressingDisplay{background-color:#fff;border-radius:2%}", ""]);
	
	// exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".Cloze-CategoryPicker{position:relative}.Cloze-CategoryPicker .passageTypeOptions{text-align:center}.Cloze-CategoryPicker .categoryOptions,.Cloze-CategoryPicker .passageOptions{border-top:1px solid #ccc;padding-top:40px;text-align:center;margin-top:20px}.Cloze-CategoryPicker a.bubbleOp{color:inherit;text-decoration:none;border:1px solid #aaa;padding:10px;border-radius:20px;display:inline-block;white-space:nowrap;margin-bottom:20px;margin-left:5px;margin-right:5px}.Cloze-CategoryPicker a.bubbleOp:hover{background-color:#c8ecff;opacity:.7}.Cloze-CategoryPicker a.bubbleOp:hover.active{opacity:1}.Cloze-CategoryPicker a.bubbleOp.active{background-color:#c8ecff}.Cloze-CategoryPicker a.bubbleOp img.icon{height:auto;vertical-align:middle;width:26px;margin-top:-13px;margin-bottom:-9px;margin-right:3px}.Cloze-CategoryPicker .Cloze-PassageTile{vertical-align:top;margin-bottom:10px;margin-right:8px;margin-left:8px;cursor:pointer}.Cloze-CategoryPicker .Cloze-PassageTile:hover{background-color:#c8ecff;opacity:.7}.Cloze-CategoryPicker .passageMessage{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".clozePage .finishedButton{color:#fff;background-color:#2b9401;border:1px solid #237600;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif;min-width:100px!important}.clozePage .finishedButton:hover{color:#fff;background-color:#237600;border-color:#195500}.clozePage .Cloze-Passage{max-width:65rem;margin:0 auto}.clozePage .finishedButton{margin-top:5px}", ""]);
	
	// exports


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".Cloze-Passage .passageHeader{padding-bottom:30px;margin-bottom:30px;border-bottom:1px solid #ccc}.Cloze-Passage .passageHeader .instructions{margin-left:190px}.Cloze-Passage .passageHeader .Cloze-PassageTile{float:left}.Cloze-Passage .passageHeader:after{content:\"\";clear:both;display:table}.Cloze-Passage ol{margin-top:10px;margin-bottom:0}.Cloze-Passage ol li{padding-left:1em}.Cloze-Passage p{margin-top:0;margin-bottom:12.5px}.Cloze-Passage .clozeItem{display:inline-block;min-width:80px;padding-left:10px;padding-right:10px;white-space:nowrap;border-radius:4px;text-align:center;border:1px dashed #aaa;text-decoration:none;color:inherit}.Cloze-Passage .clozeItem:hover{opacity:.7;background-color:#fff864}.Cloze-Passage .clozeItem.completed{border-style:solid}.Cloze-Passage .clozeItem.selected{background-color:#fff864}.Cloze-Passage .clozeItem.selected:hover{opacity:1}.Cloze-Passage .passageWrap{position:relative}.Cloze-Passage .clozeControls{position:relative;height:85px;text-align:left}.Cloze-Passage .clozeControls .inner{padding-top:10px;height:85px;background-color:#fff}.Cloze-Passage .clozeControls .content{border-top:1px solid #ccc;padding-top:16px}.Cloze-Passage .clozeControls.fixed .inner{position:fixed;bottom:0}.Cloze-Passage .clozeControls .bubbleOp{color:inherit;text-decoration:none;border:1px solid #aaa;padding:10px 15px;border-radius:20px;display:inline-block;margin:0 8px}.Cloze-Passage .clozeControls .bubbleOp.selected{background-color:#fff864}.Cloze-Passage .clozeControls .bubbleOp.selected:hover{opacity:1}.Cloze-Passage .clozeControls .bubbleOp:hover{opacity:.7;background-color:#fff864}.Cloze-Passage .completeDisplay{display:inline-block;float:right}.Cloze-Passage .finishedButton{padding:10px 15px;font-size:inherit}", ""]);
	
	// exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".Cloze-PassageTile{display:inline-block;text-align:left;max-width:160px;border:1px solid #aaa;border-radius:5px;padding-top:10px;padding-bottom:10px}.Cloze-PassageTile>div{padding-left:10px;padding-right:10px}.Cloze-PassageTile .title{font-style:italic}.Cloze-PassageTile .category,.Cloze-PassageTile .subCategory{font-size:.8em;margin-top:10px}.Cloze-PassageTile .category{border-top:1px solid #ccc;padding-top:10px}.Cloze-PassageTile img.icon{height:auto;vertical-align:middle;width:26px;margin-top:-13px;margin-bottom:-9px;margin-right:3px}", ""]);
	
	// exports


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookAnswersAnalysisTable{box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:1em 0 0 1em}.bookAnswersAnalysisTable .readBookCell{border-radius:.5em;text-align:center}.bookAnswersAnalysisTable .fontColor-green{color:#42af14}.bookAnswersAnalysisTable .fontColor-red{color:#ff7346}.bookAnswersAnalysisTable .fontColor-yellow{color:#fdda16}.bookAnswersAnalysisTable .backgroundColor-yellow{background:#fef7d9}.bookAnswersAnalysisTable .backgroundColor-green{background:#e3f3e2}.bookAnswersAnalysisTable .backgroundColor-red{background:#ffeae3}.bookAnswersAnalysisTable .centerCell{text-align:center}.bookAnswersAnalysisTable .noBorderTop{border-top:none}.bookAnswersAnalysisTable .writingContainer{width:fit-content;padding:.5em;border:1px solid #ccc;border-radius:.5em}.bookAnswersAnalysisTable .writingContainer.freeResponse{line-height:2em}.bookAnswersAnalysisTable .writingContainer .answerGiven,.bookAnswersAnalysisTable .writingContainer .textDetails{font-weight:700;padding:.2em .4em;border-radius:.5em}.bookAnswersAnalysisTable .writingContainer .answerGiven{text-decoration:underline}.bookAnswersAnalysisTable .answerKeyContainer{margin-top:.5em;margin-bottom:.5em;margin-left:.5em}.bookAnswersAnalysisTable .answerKeyContainer .answerKey{font-weight:700}.bookAnswersAnalysisTable .summary{display:inline-block;width:100%;font-size:1.1em;margin:1em 0 1em 1em}.bookAnswersAnalysisTable .summary .summaryTitle{font-weight:700}.bookAnswersAnalysisTable .summary .maybeSummary,.bookAnswersAnalysisTable .summary .noSummary,.bookAnswersAnalysisTable .summary .yesSummary{display:inline-block;margin-left:1em}.bookAnswersAnalysisTable .summary .maybeBlock,.bookAnswersAnalysisTable .summary .noBlock,.bookAnswersAnalysisTable .summary .yesBlock{padding:.2em .5em;border-radius:.5em}.bookAnswersAnalysisTable .readBookCellContainer{width:15%}.bookAnswersAnalysisTable .typeCell{width:20%}.bookAnswersAnalysisTable .questionCell{width:45%}.bookAnswersAnalysisTable .reasonCell{width:15%}.bookAnswersAnalysisTable .viewCell{width:5%}", ""]);
	
	// exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".classResultsPage .reportSubHeader{font-size:1.4em}.classResultsPage .teacherName{position:relative;bottom:10px}.classResultsPage .studentOwlvatar{vertical-align:middle;display:inline-block}.classResultsPage .studentTextPair{margin-top:-10px;margin-bottom:10px}.classResultsPage .studentTextPair .bookDisplay{width:50%;margin-top:11px}.classResultsPage .studentTextPair .studentDisplay{float:right;margin-right:10px}.classResultsPage .shareSection{margin-bottom:20px}.classResultsPage .shareSection .printLink,.classResultsPage .shareSection .shareLink{display:inline-block;margin-right:3.9em}.classResultsPage .shareSection .copyTextInput{display:inline-block;width:15em;margin-left:.5em}.classResultsPage .shareSection .hideStudents{display:inline-block}.classResultsPage .shareSection input[type=checkbox]{position:relative;bottom:1.5px}.classResultsPage .topSection{position:relative;margin-bottom:25px}.classResultsPage .topSection .left{width:56%;float:left}.classResultsPage .topSection .right{margin-left:8%;width:36%;float:left}.classResultsPage .bestAnswer .studentDisplay{display:block}.classResultsPage .topTexts .bookDisplay .title{margin-bottom:0;padding-right:0}.classResultsPage .topTexts .bookDisplay .about{vertical-align:initial}.classResultsPage .topTexts li{margin-bottom:7.5px}.classResultsPage .topTexts ol{padding-left:2rem}.classResultsPage .topTexts .readCount{font-size:.8em;margin-left:1em}.classResultsPage .feedbackCorrection{position:relative;width:90%}.classResultsPage .feedbackCorrection .studentDisplay{display:block}.classResultsPage .feedbackCorrection .feedbackRow{margin-bottom:15px}.classResultsPage .feedbackCorrection .rowLabel{display:inline-block;width:20%;font-weight:700;vertical-align:top}.classResultsPage .feedbackCorrection .content{display:inline-block;width:80%}.classResultsPage .feedbackCorrection .addition{display:inline-block;background-color:#fff400!important;-webkit-print-color-adjust:exact}.classResultsPage .feedbackCorrection .subtraction{display:inline-block;text-decoration:line-through}.classResultsPage .collectiveStats{background-color:#00a0f4;color:#fff;padding:12px;border-radius:10px;margin-bottom:35px;margin-top:15px}.classResultsPage .collectiveStats .stat{width:20%;display:inline-block;text-align:center}.classResultsPage .collectiveStats .num{font-weight:700}.classResultsPage .collectiveStats .numLabel{font-size:.8em}.classResultsPage .mostImproved{text-align:center}.classResultsPage .mostImproved .improvedStudent{width:33%;display:inline-block;text-align:left}.classResultsPage .mostImproved .rankImg{width:30px;height:auto}.classResultsPage .mostImproved .studentDisplay{position:relative;bottom:1px;margin-left:-5px}.classResultsPage .mostImproved .explanation{font-size:.8em;margin-top:15px;color:#888}", ""]);
	
	// exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataContainer .dataControls{border-bottom:1px solid #ddd;font-size:.8em;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}.dataContainer .dataControls .dropdown-toggle{height:60px}.dataContainer .dataControls .dropdown-toggle .caret{margin-left:10px}.dataContainer .dataControls .dropdown-toggle:hover{background-color:#eee;text-decoration:none}.dataContainer .dataControls .mainControls{height:60px}.dataContainer .dataControls .subjectTypeSelector button{padding-left:0}.dataContainer .dataControls .subjectTypeSelector .dropdown-toggle{padding-left:15px}.dataContainer .dataControls .subjectTypeSelector.buttonDropdown .scrollable-menu{max-height:400px}.dataContainer .dataControls .subjectTypeSelector li.locked a{color:#999}.dataContainer .dataControls .subjectTypeSelector li.locked span.glyphicon{margin-left:0;font-size:.8em}.dataContainer .dataControls .dateSpanSelector .dropdown-menu{max-width:fit-content}.dataContainer .dataControls .dateSpanSelector .dropdown-menu li{margin-right:0}.dataContainer .dataControls .studentSelector .studentListOp{font-weight:700;margin-top:.8em}.dataContainer .dataControls .studentSelector .studentListOp:first-child{margin-top:0}.dataContainer .dataControls .studentSelector .studentOp span{margin-left:10px}.dataContainer .dataControls .studentSelector .caret{margin-right:5px}.dataContainer .dataControls .datePickerContainer{background:#fff;position:relative;z-index:10000}.dataContainer .dataControls .textSelector .bookDisplay .title{max-width:160px;overflow:hidden;text-overflow:ellipsis}.dataContainer .dataControls .textSelector .bookRecommendation .ellipsisText{padding-left:10px}.dataContainer .dataControls .textSelector .caret{margin-left:12px}.dataContainer .dataControls .confirmButton{margin-left:10px;height:28px;padding-top:3px;position:relative;top:-1px}.dataContainer .dataControls .bookRecommendation{margin-left:10px}.dataContainer .dataControls .exportDataText{margin-right:.5em}.dataContainer .rightControls{float:right}.dataContainer .rightControls>a{display:inline-block;padding:21px 12px;vertical-align:middle}.dataContainer .rightControls>a:hover{background-color:#eee;text-decoration:none}.dataContainer .badge{position:relative;bottom:14px;right:14px;font-size:9px;font-weight:400;background-color:#70d544}", ""]);
	
	// exports


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherDigestContainer .digestContent .dataLogTables .logRow td.dateCell{text-align:left;width:20%}.teacherDigestContainer .digestContent .dataLogTables .silverTextContainer{font-size:.8em}.teacherDigestContainer .digestContent .dataLogTables .silverTextContainer .btn-link{padding-left:0}", ""]);
	
	// exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataPage{position:relative}.dataPage .mainControls{white-space:nowrap}.dataPage .contentWrap{margin-top:-2rem;margin:0 3rem}.dataPage .dataAnswers .answerDisplay{margin-bottom:30px}.dataPage .displayToggleControl{padding-bottom:20px}.dataPage .displayToggleControl .toggleOp:first-of-type{padding-left:0}.dataPage .topButtonsContainer{margin-bottom:5px}.dataPage .topButtonsContainer .btn{padding-left:0;border:none;border-radius:0;color:#337ab7;margin-right:20px}.dataPage .topButtonsContainer .btn .caret{margin-left:10px}.dataPage .dataContainer{display:inline-block;vertical-align:top;width:75%;border-left:1px solid #ddd}.dataPage .dataContainer.dataStudentDigest{width:100%;border-left:unset}.dataPage .dataContainer.dataStudentDigest .dataControls{display:block}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer{margin-top:1em;width:100%;display:flex;align-items:center;justify-content:center}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer .exportLink{width:5%;text-align:center}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer .student{width:70%;display:flex;align-items:center;justify-content:center}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer .student .studentOwlvatar{width:25%;z-index:999}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer .student .studentName{text-align:center;font-size:2em}.dataPage .dataContainer.dataStudentDigest .dataStudentDigestHeaderContainer .searchableStudentSelector{width:25%;display:inline-block}.dataPage .dataContainer.dataStudentDigest .mainControls{width:100%}.dataPage .dataContainer .dataContent{padding-left:15px;padding-top:15px}.dataPage .studentDisplaySection{width:25%;border-right:1px solid #ddd}.dataPage .studentDisplay{margin-bottom:10px}@media print{.dataPage .studentsDisplaySection{display:none}.dataPage .dataContainer{width:100%;border-left:none}}.dataPage .itemHeaderInner{position:relative;z-index:1;min-height:35px;overflow:hidden;margin-top:0;margin-bottom:1.5rem}.dataPage .itemHeaderInner .student{float:left}.dataPage .itemHeaderInner .date{float:right}.dataPage .itemHeaderInner .date,.dataPage .itemHeaderInner .student .textContent{position:relative;top:10px}.dataPage .studentItem{page-break-after:always}.dataPage .studentItem .innerHeader{display:inline-block;padding-right:2em}.dataPage .pageBreak{page-break-after:always}.dataPage .paginationControls{font-size:.8em}.dataPage .contentWrap.inset .noneDisplay{margin:0 3rem}.dataPage .contentItems .meta{float:right}.dataPage .contentItems .answerCircle{vertical-align:top;margin-right:1rem;width:4.2rem;height:4.2rem}.dataPage .contentItems .answerIcon{width:2rem;height:2rem}.dataPage .contentItems .warmupQuestionsDisplay{display:inline-block}.dataPage .emptyStateContainer .emptyStateContent .emptyImg{max-width:55%}.dataPage .emptyStateContainer .addStudentsText{width:75%}.dataPage .dataPaywall{margin-top:50px;margin-bottom:20px;text-align:center;border:1px dashed #bbb;padding:15px}.dataPage .dataPaywall .btn{position:relative;bottom:1px;margin-left:1.5em}.dataPage .dataControls .bookDisplay{width:90%}.dataPage .dataControls .timePeriodLabel{display:inline-block;padding:21px 12px;color:#337ab7}.dataPage .dataControls .editGoalsLink a:hover{text-decoration:none}.dataPage .dataControls .editGoalsLink .btn-link{vertical-align:unset}.dataPage .dataGoals .studentListName{display:inline-block;color:#999;margin-top:3px;font-size:.8em}.dataPage .dataGoals .studentRow .rowContent{padding-bottom:5px}.dataPage .dataStudentDigestBtn:active,.dataPage .dataStudentDigestBtn:focus{background-color:unset;outline:none;box-shadow:unset;-webkit-box-shadow:unset}.dataPage .backArrowContainer{background-color:#00a0f4;padding:.3em;margin-bottom:.5em}.dataPage .backArrowContainer .backArrow{color:#fff;border-style:solid;border-color:#fff;border-radius:.5em;padding:0 .4em}.dataPage .backArrowContainer .backArrow .bi-arrow-return-left{vertical-align:bottom;width:1.2em;height:1.2em}.dataPage .backArrowContainer .backArrow .text{font-size:12px}.dataPage .placeholderDisclaimer{text-align:right;font-style:italic;font-size:.9em;margin-bottom:1em}.dataPage .singleQuizView .additonalAnswersContainer{cursor:pointer}.dataPage .singleQuizView .additonalAnswersContainer .answerDisplay{padding:1em}.dataPage .singleQuizView .additonalAnswersContainer .paginationControls{padding-top:2em}.dataPage .singleQuizView .additonalAnswersContainer .headerSection{width:100%;padding:.6em;border-radius:.3em;background:#ddd;text-align:center;box-shadow:0 4px 8px 0 rgba(0,0,0,.2)}.dataPage .singleQuizView .additonalAnswersContainer .headerSection .menuOption{font-size:1.3em;text-align:center;float:right}.dataPage .singleQuizView .additonalAnswersContainer.collapsed .answersContainer{max-height:0;transform-origin:top;overflow:hidden;transition:max-height .3s ease-in-out;-moz-transition:max-height .3s ease-in-out;-webkit-transition:max-height .3s ease-in-out}.dataPage .singleQuizView .additonalAnswersContainer.expanded .answersContainer{height:unset;max-height:1000em;overflow:hidden;transition:max-height 1s ease-in-out;-moz-transition:max-height 1s ease-in-out;-webkit-transition:max-height 1s ease-in-out}.dataPage .singleQuizView .additonalAnswersContainer hr{width:80%}", ""]);
	
	// exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".digestSection .dataQuizzes .itemHeader .student{display:inline-block}.digestSection .dataQuizzes .itemHeader .date{float:right;position:relative;top:8px;font-size:.8em}.digestSection .dataQuizzes .itemHeader .title{margin-bottom:0}.digestSection .dataQuizzes .answerDisplay{padding-bottom:0;margin-top:.8rem}", ""]);
	
	// exports


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataTable{width:100%;font-size:.8em}.dataTable .columnHeader{text-align:center;cursor:default}.dataTable .table{width:unset;min-width:100%;border-collapse:unset}.dataTable .cell{vertical-align:middle;padding-left:10px;padding-right:10px;overflow:hidden;text-overflow:ellipsis}.dataTable .no-wrap{white-space:nowrap}.dataTable .pre-wrap{white-space:pre-wrap}.dataTable .italic{font-style:italic}.dataTable .bold{font-weight:700}.dataTable .gradeQuizLink{cursor:pointer}.dataTable .scoreDisplay{text-align:center;font-weight:700;padding:.3em;border-radius:.7em}.dataTable .scoreDisplay .scoringFlags{display:inline-block;margin-left:15%}.dataTable .scoreDisplay.withFlag{white-space:nowrap}.dataTable .scoreDisplay.failed{background-color:#ffeae3;color:#ff7346}.dataTable .scoreDisplay.passed{background-color:#e3f3e2;color:#42af14}.dataTable .noAdminScore{padding:7px 3px 0}.dataTable .noAdminScore .glyphicon-exclamation-sign{font-size:2em;color:#fbb03c}.dataTable .noAdminScore .glyphicon-question-sign{font-size:2em}.dataTable .quizEvalCellContainer .eval{width:70%;margin-right:10%;display:inline-block}.dataTable .quizEvalCellContainer .link{width:20%;display:inline-block}.dataTable .avatarCell{display:table-row}.dataTable .avatarCell .col-left,.dataTable .avatarCell .col-right{display:table-cell;vertical-align:middle}.dataTable .avatarCell .col-middle{width:.5em}.dataTable .writingColumn .writingItem{width:100%}.dataTable .writingColumn .writingItem .itemSubject{width:55%;display:inline-block;text-align:left}.dataTable .writingColumn .writingItem .itemStat{width:35%;display:inline-block;text-align:center}.dataTable .writingColumn .writingItem .itemLink{width:10%;display:inline-block}.dataTable .readBookColumn{text-align:center}.dataTable .readBookColumn.extraWidth{min-width:9em}.dataTable .readBookColumn .readBookCell{width:3em;height:2em;line-height:2em;border-radius:50%;font-size:1em;color:#fff;display:inline-block}.dataTable .readBookColumn .readBookCell .readBookCellValue{font-weight:700;text-align:center}.dataTable .rubricColumn .rubricItemContainer{width:100%;display:block}.dataTable .rubricColumn .rubricItemContainer .rubricItem{width:75%;display:inline-block}.dataTable .rubricColumn .rubricItemContainer .rubricItemValue{width:25%;display:inline-block;font-weight:700}.dataTable .readBookColumn-Pending{text-align:-webkit-center}.dataTable .readBookColumn-Pending .readBookCell .readBookCellValue{font-weight:700;text-align:center;color:#555}.dataTable .readBookColumn-EmptyState{text-align:-webkit-center}.dataTable .readBookColumn-EmptyState .readBookCell .readBookCellValue{font-weight:700;text-align:center;color:#555}.dataTable .showMoreText{text-align:center;width:100%;color:#00a0f4;cursor:pointer;margin-top:.5em}.dataTable .confidenceValue{width:30%;display:inline-block;text-align:center;margin:0 5%}.dataTable .infoTooltip{display:inline-block;width:15%;color:#00a0f4}.dataTable .quizScoreColumn{width:3em;text-align:center}.dataTable .quizScoreColumn .glyphicon-hourglass{font-size:1.5em}.dataTable .itemLink{cursor:pointer}.dataTable.quizzesTable{width:100%}.dataTable.quizzesTable .dateColumn,.dataTable.quizzesTable .studentNameColumn{max-width:101.25px}.dataTable.quizzesTable .bookTitle{min-width:101.25px;max-width:168.75px}.dataTable.quizzesTable .quizScoreColumn{min-width:58.25px;max-width:63.25px}.dataTable.quizzesTable .readBookColumn{min-width:80px;max-width:80px}.dataTable.quizzesTable .rubricColumn{min-width:155.25px;max-width:182.25px}.dataTable.quizzesTable .viewColumn{max-width:33.75px}.dataTable.booksTable{width:100%}.dataTable.booksTable .dateColumn{max-width:472.5px}.dataTable.booksTable .studentNameColumn{max-width:121.5px}.dataTable.booksTable .bookTitle{max-width:168.75px}.dataTable.booksTable .readBookColumn{max-width:135px}.dataTable.booksTable .writingColumn{max-width:202.5px}.dataTable .fontColor-green{color:#42af14}.dataTable .fontColor-red{color:#ff7346}.dataTable .fontColor-yellow{color:#fdda16}.dataTable .backgroundColor-green{background:#e3f3e2}.dataTable .backgroundColor-red{background:#ffeae3}.dataTable .writingContainer .failed,.dataTable .writingContainer .passed{background-color:unset}.dataTable .bookAnswersAnalysisTableRow{height:0;display:none}.dataTable .bookAnswersAnalysisTableRow .tableContiner{border-top:none}.dataTable .bookAnswersAnalysisTableRow.expanded{height:unset;display:contents}.dataTable .emptyColumn{text-align:center;font-size:.8em}.dataTable #columnDataTip{white-space:pre-wrap;line-height:normal;font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataTableSummary{width:100%;margin-bottom:1em}.dataTableSummary .summaryDateCell{text-align:center;margin-top:1em}.dataTableSummary .summaryCardsContainer{flex-flow:row nowrap;display:flex;justify-content:space-evenly}.dataTableSummary .summaryCard{text-align:center;padding:1em;flex-grow:0;flex-shrink:0;flex-basis:25%}.dataTableSummary .summaryCard .cardContent{box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:.3em;padding:1em}.dataTableSummary .summaryCard.clickable{cursor:pointer}.dataTableSummary .summaryCard .iconContainer{display:flex;flex-flow:row nowrap;justify-content:space-around;align-items:center;height:2em}.dataTableSummary .summaryCard .iconContainer .iconImage{width:1.5em}.dataTableSummary .summaryCard .stat{font-size:2em}.dataTableSummary .caption{display:table-caption;padding:0 1em .3em;color:#d3d3d3;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dateSpanSelector .datePickerContainer,.dateSpanSelector .exportsDatePickerContainer{display:inline-block;margin-left:20px}.dateSpanSelector .datePickerContainer span,.dateSpanSelector .exportsDatePickerContainer span{margin-left:15px;margin-right:15px;font-size:.8em}.dateSpanSelector .datePickerContainer .confirmBtn,.dateSpanSelector .exportsDatePickerContainer .confirmBtn{height:28px;padding-top:3px;position:relative;top:-1px;margin-left:15px;border-radius:3px;min-width:50px!important}.dateSpanSelector .datePickerContainer .react-datepicker__input-container input,.dateSpanSelector .exportsDatePickerContainer .react-datepicker__input-container input{width:100px;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.dateSpanSelector .datePickerContainer>div:first-child,.dateSpanSelector .datePickerContainer>div:nth-of-type(2){display:inline-block}.dateSpanSelector .spanLabel{width:120px}.dateSpanSelector .spanDates{font-size:.8em}.dateSpanSelector .otherStatsMenuOption .otherStatsInfoSign{text-align:center}.dateSpanSelector .otherStatsMenuOption .otherStatsInfoSign .glyphicon-info-sign{margin-right:unset;margin-left:.7em}", ""]);
	
	// exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherDigestContainer .dataTextTables .emptyStateContainer p{position:relative;top:5px}.teacherDigestContainer .emptyStateContainer{margin-bottom:0}.teacherDigestContainer .emptyStateContainer .contentContainer .emptyTextShort{width:50%}.teacherDigestContainer .emptyStateContainer .contentContainer .emptyText{height:30px;margin-bottom:10px}.teacherDigestContainer .emptyStateContainer .contentContainer .emptyTextMiddle{height:125px;margin-bottom:5px}.teacherDigestContainer .emptyStateContainer .tableContainer{height:136px;position:relative;bottom:25px}.teacherDigestContainer .emptyStateContainer .tableContainer .tableRow{border-bottom:1px dashed #bbb;height:45px}.teacherDigestContainer .emptyStateContainer .logContainer .emptyText{width:75%;height:40px;margin-bottom:20px}.teacherDigestContainer .emptyStateContainer .emptyText{border-radius:5px;border:1px dashed #bbb}.teacherDigestContainer .emptyStateContainer .emptyNote{margin-bottom:15px}.teacherDigestContainer .emptyStateContainer .rlGraphContainer .graphFrame{height:175px;border-left:1px solid #bbb;border-bottom:1px solid #bbb}.teacherDigestContainer .emptyStateContainer .rlGraphContainer .graphMiddleLine{border-bottom:1px solid #555;position:relative;top:87px}.teacherDigestContainer .emptyStateContainer .rlGraphContainer .valuesLine{height:25px;width:340px;transform:translateY(20px) translateX(5px) rotate(-26deg);border-bottom:2px dashed #ccc;position:relative;top:55px;right:28px}", ""]);
	
	// exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".confirmationConatiner{width:80%;margin-left:10%;white-space:normal}.confirmationConatiner .flexRow{display:flex;flex-direction:row;align-items:center;justify-content:space-between;margin-bottom:.5em}.confirmationConatiner .itemLabel{font-weight:700;min-width:40%}.confirmationConatiner .selectedItems{text-align:right}.confirmationConatiner .emailInput{border:2px solid #ddd;border-radius:5px;width:50%;box-sizing:border-box;padding:.2em}.confirmationConatiner .emailInput:focus{border-color:#00a0f4;outline:none}", ""]);
	
	// exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dataExportModal{font-size:medium}.dataExportModal .dataExportProgressSection{margin-left:12px;margin-bottom:25px}.dataExportModal .dataExportProgressSection .dataExportTitle{text-align:center;font-size:1.4em}.dataExportModal .progress{width:58%;height:15px;margin:0 auto 15px}.dataExportModal .item-header{font-size:1.1em;text-align:center;border-bottom:2px solid #ccc;padding-bottom:.2em;font-weight:700;margin-bottom:.5em}.dataExportModal .onSubmitContainer{width:100%;text-align:center;display:flex;flex-direction:row;justify-content:space-evenly}.dataExportModal .nextBtn{background-color:#00a0f4}.dataExportModal .backBtn,.dataExportModal .nextBtn{margin-top:10px;color:#fff;border-radius:5px;border:none;padding:10px 20px;font-size:16px;font-weight:700;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-top:.8em}.dataExportModal .backBtn{background-color:#888}.dataExportModal .flex-row{display:flex;flex-direction:row;justify-content:space-evenly;margin-bottom:1em;gap:1em}.dataExportModal .__react_component_tooltip{white-space:normal}", ""]);
	
	// exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".slDropdownSelectorContainer{width:100%}.slDropdownSelectorContainer .dropdownSelector{width:100%;display:flex;flex-direction:column;padding:.5em;border:1px solid #ccc;border-radius:4px}.slDropdownSelectorContainer .dropdownSelector__slName{position:relative;display:flex;flex-wrap:wrap;width:100%;padding:.2em;border-bottom:1px solid #ccc;align-items:center}.slDropdownSelectorContainer .dropdownSelector__slName:last-child{border-bottom:none}.slDropdownSelectorContainer .dropdownSelector__slName div{padding:10px;cursor:pointer;text-align:left}.slDropdownSelectorContainer .braveCheckbox{flex-grow:0;margin-right:1em}.slDropdownSelectorContainer .slNameContainer{flex-grow:1}.slDropdownSelectorContainer .dropdownSelector__slName:hover{background-color:#f1f1f1}.slDropdownSelectorContainer .dropdownSelector__students{padding:10px;margin:.1em 0;width:100%;display:flex;flex-wrap:wrap}.slDropdownSelectorContainer .dropdownSelector__studentsCheckboxContainer{width:50%;display:flex;align-items:center;padding:5px 10px}.slDropdownSelectorContainer .dropdownSelector__students input[type=checkbox]{margin-right:10px;margin-top:0}.slDropdownSelectorContainer .studentsSelectedCount{margin-left:.3em;font-style:italic;color:#888}.slDropdownSelectorContainer .boldBlue{font-size:1.1em;font-weight:700;color:#00a0f4}", ""]);
	
	// exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".metricsDropdownSelectorContainer{width:70%;margin-left:15%}.metricsDropdownSelectorContainer .dropdownSelector{width:100%;display:flex;flex-direction:column;padding:.5em;border:1px solid #ccc;border-radius:4px}.metricsDropdownSelectorContainer .dropdownSelector__metricCategoryName{position:relative;display:flex;flex-wrap:wrap;width:100%;padding:.2em;border-bottom:1px solid #ccc;align-items:center}.metricsDropdownSelectorContainer .dropdownSelector__metricCategoryName:last-child{border-bottom:none}.metricsDropdownSelectorContainer .dropdownSelector__metricCategoryName div{padding:10px;cursor:pointer;text-align:left}.metricsDropdownSelectorContainer .dropdownSelector__metricCategoryNameCheckbox{margin:0}.metricsDropdownSelectorContainer .dropdownSelector__metrics{padding:10px;margin:.1em 0;width:100%;display:flex;flex-wrap:wrap}.metricsDropdownSelectorContainer .dropdownSelector__metrics .dropdownSelector__metricsContainer{width:100%;display:flex;align-items:center;padding:5px 10px;margin-bottom:.5em}.metricsDropdownSelectorContainer .dropdownSelector__metrics .dropdownSelector__metricsContainer .metricLabel{flex-grow:1;padding:3px}.metricsDropdownSelectorContainer .braveCheckbox{margin-right:2em}.metricsDropdownSelectorContainer .dropdownSelector__aggregateOption{margin-left:auto}.metricsDropdownSelectorContainer .selectContainer{margin-top:10px}.metricsDropdownSelectorContainer .selectElement{width:100%;height:2.5em;color:#444;padding:0 10px;border-radius:5px;border:1px solid #ccc;box-shadow:0 4px 4px 0 rgba(0,0,0,.2)}.metricsDropdownSelectorContainer .selectorsContainer{display:flex;margin-bottom:1em;flex-direction:row;gap:1em;justify-content:space-between}.metricsDropdownSelectorContainer .selectorTitle{text-align:center}.metricsDropdownSelectorContainer .metricCategoryTitle{font-size:1.1em;font-weight:700;color:#00a0f4}", ""]);
	
	// exports


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".exportTypeSelector{width:70%;margin-left:15%}.exportTypeSelector .buttonContainer{display:flex;justify-content:center;margin-bottom:1em}.exportTypeSelector .buttonContainer button{flex:1}.exportTypeSelector .buttonContainer .pdfBtn{background-color:#00a0f4;margin-right:1em}.exportTypeSelector .buttonContainer .pdfBtn,.exportTypeSelector .buttonContainer .xslBtn{margin-top:10px;color:#fff;border-radius:5px;border:none;padding:10px 20px;font-size:16px;font-weight:700;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-top:.8em}.exportTypeSelector .buttonContainer .xslBtn{background-color:#42af14;margin-left:1em}", ""]);
	
	// exports


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".exportsDateSpanSelectorContainer .dateSelectorsConainer{margin-left:20%;width:60%;padding:.5em;border:1px solid #ccc;border-radius:4px;text-align:center}.exportsDateSpanSelectorContainer .selectContainer{display:flex;flex-direction:row;margin-bottom:1em;justify-content:space-between}.exportsDateSpanSelectorContainer .datePeriodLabel,.exportsDateSpanSelectorContainer .goalPeriodSelectLabel,.exportsDateSpanSelectorContainer .selectLabel{align-self:center}.exportsDateSpanSelectorContainer .selectElement{padding:.5em;border-radius:4px;border:none;background-color:#f5f5f5;color:#333;text-align:center;-webkit-appearance:none;-moz-appearance:none;appearance:none}.exportsDateSpanSelectorContainer .selectElement::placeholder{color:#333}.exportsDateSpanSelectorContainer .exportsDatePickerContainer{align-items:center}.exportsDateSpanSelectorContainer .datePicker{display:flex;flex-direction:row;flex-wrap:wrap;margin-bottom:1em;justify-content:space-between}.exportsDateSpanSelectorContainer .react-datepicker__day--keyboard-selected{background-color:unset}.exportsDateSpanSelectorContainer .react-datepicker-wrapper{display:flex;align-items:center}.exportsDateSpanSelectorContainer .react-datepicker__input-container{display:flex;align-items:center;width:100%}.exportsDateSpanSelectorContainer .react-datepicker-ignore-onclickoutside{width:100%}.exportsDateSpanSelectorContainer .react-datepicker__input{border:none;border-radius:4px;padding:10px;font-size:16px;width:100%;background-color:#f5f5f5}.exportsDateSpanSelectorContainer .react-datepicker__input:focus{outline:none;box-shadow:0 0 0 2px #00a0f4}.exportsDateSpanSelectorContainer .react-datepicker__day,.exportsDateSpanSelectorContainer .react-datepicker__day-name,.exportsDateSpanSelectorContainer .react-datepicker__time-name{width:2.5rem;line-height:2.5rem;text-align:center}.exportsDateSpanSelectorContainer .react-datepicker__month{margin:1rem}.exportsDateSpanSelectorContainer .react-datepicker__day,.exportsDateSpanSelectorContainer .react-datepicker__day-name{color:#00a0f4}.exportsDateSpanSelectorContainer .react-datepicker__day:hover{background-color:#00a0f4;color:#fff;cursor:pointer;border-radius:1em}.exportsDateSpanSelectorContainer .react-datepicker__day--today{font-weight:700}.exportsDateSpanSelectorContainer .react-datepicker__day--in-range,.exportsDateSpanSelectorContainer .react-datepicker__day--in-selecting-range,.exportsDateSpanSelectorContainer .react-datepicker__day--selected{background-color:#00a0f4;color:#fff;border-radius:1em}.exportsDateSpanSelectorContainer .react-datepicker__month-text,.exportsDateSpanSelectorContainer .react-datepicker__quarter-text{color:#00a0f4}.exportsDateSpanSelectorContainer .react-datepicker__time-container{border-top:1px solid #f5f5f5;display:flex;align-items:center;justify-content:center;margin:1rem}.exportsDateSpanSelectorContainer .react-datepicker__time{display:flex;align-items:center}.exportsDateSpanSelectorContainer .react-datepicker__time-box{display:flex;align-items:center;justify-content:center;width:4rem;margin:0 .5rem}.exportsDateSpanSelectorContainer .react-datepicker__current-month{font-size:16px}.exportsDateSpanSelectorContainer .react-datepicker__header__dropdown{margin:.5em 0;font-size:12px;color:#00a0f4}.exportsDateSpanSelectorContainer .react-datepicker__day-name{font-size:12px;color:#00a0f4}.exportsDateSpanSelectorContainer .react-datepicker__day{font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".schoolOrgDropdownSelectorContainer .selectorContainer{text-align:center;margin-bottom:1.5em}.schoolOrgDropdownSelectorContainer .selectElement{width:60%;height:2.5em;color:#444;padding:0 10px;border-radius:5px;border:1px solid #ccc;box-shadow:0 4px 4px 0 rgba(0,0,0,.2)}", ""]);
	
	// exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".goalsTable .infoSection{width:25%;text-align:center}.goalsTable .infoSection.sortControlCell{text-align:left}.goalsTable .infoSection.sortControlCell button.btn{padding-left:0;position:relative;bottom:1px}.goalsTable .statSection{text-align:center}.goalsTable .studentRow.headerRow{font-size:.8em}.goalsTable .studentRow.headerRow .rowContent{padding-top:0}.goalsTable .studentRow.headerRow .rowContent .sortControlCell{line-height:.6}.goalsTable .studentRow.headerRow .rowContent .sortControlCell .buttonDropdown{width:72%}.goalsTable .studentRow .editStudent{font-size:.8em}.goalsTable .studentRow .avatarBox,.goalsTable .studentRow .infoSection,.goalsTable .studentRow .statSection,.goalsTable .studentRow .studentName{position:relative;vertical-align:middle;display:inline-block}.goalsTable .studentRow .statSection{padding-left:5px;padding-right:5px;text-align:center}.goalsTable .studentRow .statSection p{margin-bottom:0}.goalsTable .studentRow .statSection .sectionLabel{font-size:.8em;color:#bbb}.goalsTable .studentRow .statSection .printLink{font-size:.8em}.goalsTable .studentRow .statSection .buttonContainer{margin-left:10px}.goalsTable .studentRow .statSection .buttonContainer li{margin-left:5px}.goalsTable .studentRow .avatarBox{width:23%}.goalsTable .studentRow .studentName{width:77%;text-align:left}.goalsTable .studentRow .longContent{display:inline-block;width:100%;font-size:.8em;vertical-align:middle;max-height:2.7em;overflow:hidden}.goalsTable .rowContent{border-bottom:1px solid #ddd;padding-bottom:12px;padding-top:12px}.goalsTable .rowContent .buttonDropdown .dropdown-header{margin-right:0;border-bottom:1px solid #ddd;font-size:inherit;padding:0 20px;margin-top:5px;margin-bottom:5px}.goalsTable .rowContent .buttonDropdown .dropdown-menu .ellipsisText{padding-left:30px}.goalsTable .readingLevel .glyphicon{color:#999}.goalsTable .readingVerification .glyphicon-ok-circle{color:#2b9401}.goalsTable .readingVerification .glyphicon-remove-circle{color:#999}.goalsTable .readingVerification .glyphicon-ok,.goalsTable .readingVerification .glyphicon-question-sign{color:#ccc}.goalsTable .zpdCounts .levelStat{display:inline-block;width:3em}.goalsTable .zpdCounts .readingLevelContainer{margin-left:0;position:relative;bottom:1px}.goalsTable .ProgressBar{margin-bottom:6px;max-width:180px;margin-left:auto;margin-right:auto}.goalsTable .progress{height:10px;margin-left:20px;margin-right:20px;margin-bottom:0}.goalsTable .parentLink{cursor:pointer}@media print{.goalsTable .parentLink .glyphicon{opacity:.5}}", ""]);
	
	// exports


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".DigestGraphWithDropdown .header{display:flex;justify-content:center;margin-top:3rem;align-items:flex-end;gap:1rem}.DigestGraphWithDropdown .header .metricNames{font-size:150%}.DigestGraphWithDropdown .header .changeMetricsButton:hover{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mainContainer{background-color:rgba(34,34,34,.541);color:#fff;padding:1rem;border-radius:1rem;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".RubricRadarGraph{display:flex;flex-direction:column;align-items:center}.RubricRadarGraph .controlDiv{display:flex;flex-direction:row;align-items:center;justify-content:center}.RubricRadarGraph .controlDiv .benchmarkDescription{margin-right:1rem}.RubricRadarGraph .controlDiv .dropdownText{display:flex;flex-direction:row}.RubricRadarGraph .controlDiv .dropdownText .metricNameContainer{flex:7}.RubricRadarGraph .controlDiv .dropdownText .checkContainer{flex:1}", ""]);
	
	// exports


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".ScoringGraph{display:flex;flex-direction:column;align-items:center;justify-content:center}.ScoringGraph,.ScoringGraph .spinner{margin-top:3rem}", ""]);
	
	// exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".noActivityBlock .noActivityHeader{border-bottom:1px solid #ddd;display:inline-block}.noActivityBlock .studentDisplay{margin-bottom:15px}", ""]);
	
	// exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".orgActivityTable .infoSection,.orgActivityTable .statSection{display:inline-block;vertical-align:middle;position:relative;padding-bottom:12px;padding-top:12px}.orgActivityTable .infoSection{padding-right:5px;text-align:left}.orgActivityTable .infoSection.sortControlCell{text-align:left}.orgActivityTable .infoSection.sortControlCell button.btn{padding-left:0;position:relative;bottom:1px}.orgActivityTable .subText{font-size:.8em;color:#999}.orgActivityTable .statSection{text-align:center;padding-left:5px;padding-right:5px}.orgActivityTable .orgRow{border-bottom:1px solid #ddd}.orgActivityTable .orgRow.headerRow{font-size:.8em}.orgActivityTable .orgRow.headerRow .infoSection,.orgActivityTable .orgRow.headerRow .statSection{padding-bottom:5px;padding-top:5px}.orgActivityTable .orgRow .buttonDropdown .dropdown-header{margin-right:0;border-bottom:1px solid #ddd;font-size:inherit;padding:0 20px;margin-top:5px;margin-bottom:5px}.orgActivityTable .orgRow .buttonDropdown .dropdown-menu .ellipsisText{padding-left:30px}.orgActivityTable .adminEmptyState{text-align:center;padding-top:30px;padding-bottom:20px;width:400px;margin:0 auto}", ""]);
	
	// exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".readingLevelGraph{position:relative}.readingLevelGraph .assessmentTooltip,.readingLevelGraph .bookTooltip{background-color:#fff;border-radius:3px;border:1px solid #ccc;font-size:.8em}.readingLevelGraph .bookTooltip .title{max-width:223px}.readingLevelGraph .bookTooltip .bookDisplay .aboutWrap{padding-top:15px;padding-right:15px;padding-bottom:15px}.readingLevelGraph .bookTooltip .bookDisplay .aboutWrap.withoutCover{padding-left:15px}.readingLevelGraph .assessmentTooltip{padding:15px}.readingLevelGraph .chartWrap{position:relative;z-index:1;margin-left:20px}.readingLevelGraph .yLabelWrap{position:absolute;z-index:0;width:100%}.readingLevelGraph .yLabel{position:absolute;transform:translateX(-50%) translateY(-50%) rotate(-90deg);top:50%;left:25px;text-align:center}.readingLevelGraph .legend{text-align:right;margin-bottom:10px;margin-right:5px;font-size:.8em}.readingLevelGraph .legend .item{display:inline-block;margin-left:20px}.readingLevelGraph .legend .textIcon{border-radius:10px}.readingLevelGraph .legend .assessmentIcon,.readingLevelGraph .legend .textIcon{display:inline-block;width:10px;height:10px}.readingLevelGraph .legend .zpdIcon{display:inline-block;width:15px;height:10px;border-top-width:2px;border-bottom-width:2px;border-right-width:0;border-left-width:0;border-style:solid}.readingLevelGraph .legend .fallbackMessage{font-size:.8em;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentSelectorSection{display:inline-block;font-size:.8em}.studentSelectorSection .studentListName{color:#999}.studentSelectorSection .buttonDropdown .dropdown-toggle{padding-left:0;white-space:normal}.studentSelectorSection .buttonDropdown .scrollable-menu{min-width:215px}.studentSelectorSection .mainControls{border-bottom:1px solid #ddd}.studentSelectorSection .dropdown-toggle{height:60px;width:200px;text-align:left}.studentSelectorSection .dropdown-toggle .caret{margin-left:25px}.studentSelectorSection .dropdown-toggle:hover{background-color:#eee;text-decoration:none}.studentSelectorSection .studentsDisplaySection .buttonDropdown.studentListSelector{border-bottom:1px solid #ddd;width:200px}.studentSelectorSection .studentsDisplaySection .row{height:60px;cursor:pointer;margin:0;padding-top:8px}.studentSelectorSection .studentsDisplaySection .row.selectedRow,.studentSelectorSection .studentsDisplaySection .row:hover{background:#c8ecff}.studentSelectorSection .studentsDisplaySection .row.allStudentsRow{padding-top:13px}.studentSelectorSection .studentsDisplaySection .row.allStudentsRow img{width:50px}.studentSelectorSection .studentsDisplaySection .studentsInner .studentRow .studentOwlvatar{vertical-align:middle;display:inline-block}.studentSelectorSection .studentsDisplaySection .studentsInner .studentRow .studentInfo{display:inline-block;vertical-align:top;position:relative;top:5px}.studentSelectorSection .studentsDisplaySection .studentsInner .studentRow .studentInfo .studentListName,.studentSelectorSection .studentsDisplaySection .studentsInner .studentRow .studentInfo .studentName{width:130px;display:inline-block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
	
	// exports


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentSelectorSidebar .studentListSelector{margin-top:20px;margin-bottom:6px}.studentSelectorSidebar .studentListSelector .dropdown-toggle{padding-left:0;text-align:left;white-space:normal}.studentSelectorSidebar .studentSelector{margin-top:10px;margin-bottom:10px}.studentSelectorSidebar .studentSelector .dropdown-toggle{padding-left:0}.studentSelectorSidebar .dropdown-menu{max-width:19rem}.studentSelectorSidebar a.studentRow{display:block;text-decoration:none;margin-bottom:10px;line-height:1.1}.studentSelectorSidebar a.studentRow.selectedStudent{font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherDigestContainer .addStudents{margin-bottom:15px}.teacherDigestContainer .addStudents a{cursor:pointer}.teacherDigestContainer .studentListName{display:inline-block;color:#999;margin-top:3px}.teacherDigestContainer .rlGraphContainer{width:100%}.teacherDigestContainer .rlGraphContainer .entireClassText{text-align:center}.teacherDigestContainer .digestSection{margin-bottom:40px}.teacherDigestContainer .digestSection .addStudents{margin-bottom:15px}.teacherDigestContainer .digestSection .addStudents a{cursor:pointer}.teacherDigestContainer .digestSection .digestSection{margin-bottom:0}.teacherDigestContainer .digestSection header{font-size:1.4em;background:#eee;display:inline-block;padding:10px;padding-right:70px;margin-bottom:15px}.teacherDigestContainer .digestSection .digestContent{margin-bottom:15px}.teacherDigestContainer .digestSection .digestContent .digestVideo{margin-bottom:-40px!important}.teacherDigestContainer .digestSection .digestContent .digestVideo.video{position:relative;bottom:25px}.teacherDigestContainer .digestSection .seeMoreLink{cursor:pointer;display:block;width:12%;font-size:.8em}.teacherDigestContainer .digestSection .seeMoreLink .glyphicon{font-size:13px;left:2px}.teacherDigestContainer .digestSection .editGoalsLink{font-size:.8em;margin-left:15px}.teacherDigestContainer .digestSection .innerAnswer .answerText{overflow-wrap:break-word;width:auto}.teacherDigestContainer .digestSection .digestContent .readingLevelContainer .readingLevelImg{margin-left:5px;vertical-align:baseline}.teacherDigestContainer .digestSection .digestContent .dataGoals{position:relative;bottom:15px}.teacherDigestContainer .digestSection .digestContent .dataGoals .goalsDropdown{width:25%;font-size:.8em;top:10px;z-index:100000}.teacherDigestContainer .digestSection .digestContent .dataGoals .goalsDropdown .btn-link{padding-left:0}.teacherDigestContainer .digestSection .digestContent .dataGoals .infoSection{white-space:normal}.teacherDigestContainer .digestSection .digestContent .dataGoals .studentListName{font-size:.8em}.teacherDigestContainer .digestSection .studentDisplay .textContent{position:relative;top:5px}.teacherDigestContainer .digestMiddleContainer .digestSection{display:inline-block;vertical-align:top;width:40%}.teacherDigestContainer .digestMiddleContainer .digestSection.widerDigestSection{width:50%;margin-right:10%}.teacherDigestContainer .digestMiddleContainer .digestSection .seeMoreLink{width:28%}.teacherDigestContainer .goalsTable{position:relative;bottom:15px}.teacherDigestContainer .spinnerBox{position:relative;left:15px;top:3px}.teacherDigestContainer .goalDates{display:inline-block;color:#999;margin-left:15px}.teacherDigestContainer .quizDisplay{height:480px;overflow:hidden;-webkit-mask-image:-webkit-gradient(linear,left 80%,left bottom,from(#000),to(transparent));-moz-mask-image:-moz-gradient(linear,left 80%,left bottom,from(#000),to(transparent));mask-image:gradient(linear,left 80%,left bottom,from(#000),to(transparent))}.teacherDigestContainer .warmupAnswersDisplay{display:none}", ""]);
	
	// exports


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherInsightsPage .rightContent{padding-left:5%;border-left:1px solid #ddd;min-height:60rem;display:flex;flex-direction:column}.teacherInsightsPage .rightContent .pageHeader{display:flex;justify-content:center;margin:1rem}.teacherInsightsPage .rightContent .pageHeader .nameAndYear{display:flex;justify-content:center;align-items:center;font-size:2.5rem;gap:1rem}.teacherInsightsPage .rightContent .pageHeader .ellipsisText{text-overflow:ellipsis;max-width:35rem}.teacherInsightsPage .rightContent .viewToggle{display:flex;justify-content:center}.teacherInsightsPage .rightContent .graphContainer{margin-top:3rem;margin-bottom:3rem}.teacherInsightsPage .rightContent .graphContainer .toggle:hover{cursor:pointer}.teacherInsightsPage .rightContent .graphContainer .containerLabel{font-size:145%;width:fit-content}.teacherInsightsPage .rightContent .groupView{display:flex;flex-direction:column}.teacherInsightsPage .col-sm-9 h1{width:12.5rem}.teacherInsightsPage .attributeRow{display:block;text-decoration:none;padding:2rem;color:#555;border:1px solid transparent;border-bottom-color:#ddd;display:flex;justify-content:space-between;align-items:center}.teacherInsightsPage .attributeRow.beforeSelectedAttribute,.teacherInsightsPage .attributeRow:last-child{border-bottom-color:transparent}.teacherInsightsPage .attributeRow.selectedAttribute{border-color:#ddd;border-radius:5px}.teacherInsightsPage .attributeScore{color:#aaa;font-size:.8em;display:inline-block}.teacherInsightsPage .individualObservations .studentHeaderName{display:inline-block;margin-left:1rem;width:80%}.teacherInsightsPage .individualObservations .row{margin-top:1rem}.teacherInsightsPage .individualObservations .attrName{max-width:197px;display:inline-block}.teacherInsightsPage .individualObservations .attributeScore{float:right;position:relative;top:2px;text-align:right}.teacherInsightsPage .individualObservations .attributeRow{height:63px}.teacherInsightsPage .individualObservations .itemDescription{margin-top:20px}.teacherInsightsPage .individualObservations .colEmpty,.teacherInsightsPage .individualObservations h3{margin-left:2rem}.teacherInsightsPage .individualObservations span.studentOwlvatar{display:inline-block}.teacherInsightsPage .individualExamples .answerDate{color:#aaa}.teacherInsightsPage .groupSelectorSidebar{margin-top:3rem}.teacherInsightsPage .groupSelectorSidebar .attributeRow{width:100%;padding-top:10px;padding-bottom:10px}.teacherInsightsPage .groupSelectorSidebar .attributeScore,.teacherInsightsPage .groupSelectorSidebar .attrName{width:100%;display:block}.teacherInsightsPage .groupSelectorSidebar h3{margin-left:2rem}.teacherInsightsPage .groupSelectorSidebar .studentListSelector .btn-link{padding-left:0;margin-left:2rem}.teacherInsightsPage .groupObservations{margin-top:10px}.teacherInsightsPage .groupObservations .nameAvatarDisplay{display:inline-block;width:30%;margin-right:3%;margin-top:.5rem;margin-bottom:.5rem}.teacherInsightsPage .groupObservations .studentName{display:inline-block;margin-left:1rem;margin-top:1rem;width:65%}.teacherInsightsPage .singleExample .withStudent{max-width:67%}.teacherInsightsPage .singleExample .nameAvatarDisplay{float:right;width:auto;max-width:30%}.teacherInsightsPage .singleExample .studentName{width:auto;max-width:65%}.teacherInsightsPage .exercises .exercisesSubheader{margin-bottom:3rem}.teacherInsightsPage .displayToggleControl{text-align:right}.teacherInsightsPage .dividerWithTitle{margin-bottom:2.5rem;margin-top:2.5rem;position:relative;text-align:center}.teacherInsightsPage .dividerWithTitle .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}.teacherInsightsPage .dividerWithTitle .titleArea{padding-left:4rem;padding-right:4rem;font-size:1.4em;background-color:#fff;display:inline-block;position:relative}.sampleDataLayout .displayToggleControl{padding-bottom:15px}.sampleDataLayout .rightContent{padding-left:4%;border-left:none}.sampleDataLayout .groupObservations,.sampleDataLayout .groupSelectorSidebar,.sampleDataLayout .individualExamples,.sampleDataLayout .individualObservations,.sampleDataLayout .studentSelectorSidebar{border:1px dashed #ddd;padding:15px}.sampleDataLayout .individualExamples{margin-top:10px}.sampleDataLayout .reactionFeedback{top:5px}.sampleDataLayout .studentRow:hover{cursor:auto}.sampleDataLayout .quizzesTrackerContainer{width:80%;margin:auto;margin-bottom:15px}.sampleDataLayout .quizzesTrackerContainer .quizzesTrackerText{width:auto}", ""]);
	
	// exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".truncatedDataNote{margin-bottom:15px;border:1px dashed #ddd;padding-top:12px;padding-bottom:5px;padding-left:10px}.truncatedDataNote .truncatedInner{margin:auto;width:80%}.truncatedDataNote .truncatedInner p{margin-bottom:0}.truncatedDataNote .truncatedInner p a{position:relative;bottom:1.4px}.truncatedDataNoteNoBorder{border:none}", ""]);
	
	// exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".widgetItemsContainer{width:100%;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);padding-top:.5em;border-radius:.3em;margin-bottom:1em}.widgetContainer{position:relative;width:100%;height:100%}.widgetContainer.Student{font-size:.8em}.widgetContainer .placeholderDisclaimer{text-align:right;font-style:italic;font-size:.9em;margin-bottom:.5em}", ""]);
	
	// exports


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".widgetItem{display:inline-block;padding-top:.5em}.widgetItem.width-25{width:25%}.widgetItem.width-25 .widgetItem-table{display:table;width:100%;height:5em}.widgetItem.width-25 .widgetItem-table .widgetItem-column{text-align:center;padding:2%;display:table-cell;vertical-align:middle}.widgetItem.width-25 .widgetItem-table .icon{width:17%;font-size:2.5em;vertical-align:baseline}.widgetItem.width-25 .widgetItem-table .icon.statSize-x-large{display:none}.widgetItem.width-25 .widgetItem-table .icon .iconImage{margin-left:10%;width:90%}.widgetItem.width-25 .widgetItem-table .stat{width:38%}.widgetItem.width-25 .widgetItem-table .stat.statSize-large,.widgetItem.width-25 .widgetItem-table .stat.statSize-x-large{font-size:1.5em}.widgetItem.width-25 .widgetItem-table .stat.statSize-medium{font-size:2.1em}.widgetItem.width-25 .widgetItem-table .stat.statSize-small{width:30%;font-size:2.5em}.widgetItem.width-25 .widgetItem-table .stat.statSize-x-small{width:20%;font-size:2.5em}.widgetItem.width-25 .widgetItem-table .text-column{text-align:left;width:45%;font-size:.7em;padding-left:5%}.widgetItem.width-33{width:33%}.widgetItem.width-33 .widgetItem-table{display:table;width:100%;height:5em}.widgetItem.width-33 .widgetItem-table .widgetItem-column{text-align:center;padding:2%;display:table-cell;vertical-align:middle}.widgetItem.width-33 .widgetItem-table .icon{width:17%;font-size:2.5em;vertical-align:baseline}.widgetItem.width-33 .widgetItem-table .icon.statSize-x-large{display:none}.widgetItem.width-33 .widgetItem-table .icon .iconImage{width:80%}.widgetItem.width-33 .widgetItem-table .stat{width:35%}.widgetItem.width-33 .widgetItem-table .stat.statSize-large,.widgetItem.width-33 .widgetItem-table .stat.statSize-x-large{width:40%;font-size:2.5em}.widgetItem.width-33 .widgetItem-table .stat.statSize-medium{font-size:2.6em}.widgetItem.width-33 .widgetItem-table .stat.statSize-small{width:30%;font-size:3em}.widgetItem.width-33 .widgetItem-table .stat.statSize-x-small{width:20%;font-size:3em}.widgetItem.width-33 .widgetItem-table .text-column{text-align:left;width:48%;font-size:.7em}.widgetItem.width-33 .widgetItem-table .text-column .subtitle.statSize-large,.widgetItem.width-33 .widgetItem-table .text-column .subtitle.statSize-x-large,.widgetItem.width-33 .widgetItem-table .text-column .title.statSize-large,.widgetItem.width-33 .widgetItem-table .text-column .title.statSize-x-large{font-size:.7em}.widgetItem.width-33 .widgetItem-table .text-column .subtitle.statSize-medium,.widgetItem.width-33 .widgetItem-table .text-column .title.statSize-medium{font-size:.8em}.widgetItem.width-33 .widgetItem-table .text-column .subtitle.statSize-small,.widgetItem.width-33 .widgetItem-table .text-column .title.statSize-small{font-size:.85em}.widgetItem.width-50{width:50%}.widgetItem.width-50 .widgetItem-table{display:table;width:100%;height:5em}.widgetItem.width-50 .widgetItem-table .widgetItem-column{text-align:center;padding:2%;display:table-cell;vertical-align:middle}.widgetItem.width-50 .widgetItem-table .icon{width:15%;font-size:2.5em;vertical-align:baseline}.widgetItem.width-50 .widgetItem-table .icon.statSize-x-large{display:none}.widgetItem.width-50 .widgetItem-table .icon .iconImage{width:50%}.widgetItem.width-50 .widgetItem-table .stat{width:35%}.widgetItem.width-50 .widgetItem-table .stat.statSize-large,.widgetItem.width-50 .widgetItem-table .stat.statSize-x-large{width:40%;font-size:2.5em}.widgetItem.width-50 .widgetItem-table .stat.statSize-medium{font-size:2.6em}.widgetItem.width-50 .widgetItem-table .stat.statSize-small{width:30%;font-size:3em}.widgetItem.width-50 .widgetItem-table .stat.statSize-x-small{width:20%;font-size:3em}.widgetItem.width-50 .widgetItem-table .text-column{text-align:left;width:50%;font-size:.9em}.widgetItem.width-50 .widgetItem-table .text-column .subtitle.statSize-large,.widgetItem.width-50 .widgetItem-table .text-column .subtitle.statSize-x-large,.widgetItem.width-50 .widgetItem-table .text-column .title.statSize-large,.widgetItem.width-50 .widgetItem-table .text-column .title.statSize-x-large{font-size:.7em}.widgetItem.width-50 .widgetItem-table .text-column .subtitle.statSize-medium,.widgetItem.width-50 .widgetItem-table .text-column .title.statSize-medium{font-size:.8em}.widgetItem.width-50 .widgetItem-table .text-column .subtitle.statSize-small,.widgetItem.width-50 .widgetItem-table .text-column .title.statSize-small{font-size:.85em}.widgetItem .divider-column{width:1%;border-left:1px solid #ddd}.widgetItem .subtitle{font-style:italic;color:#999}.widgetItem .subtitle.fontColor-red{color:#ff7347}.widgetItem .subtitle.fontColor-green{color:#42af14}.widgetItem .fontColor-red{color:#ff7347}.widgetItem .fontColor-green{color:#42af14}.widgetItem .fontColor-yellow{color:#fdda16}.widgetItem .glyphicon{color:#fff;text-shadow:-1px 0 #000,0 1px #000,1px 0 #000,0 -1px #000}", ""]);
	
	// exports


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".widgetTitle{display:table;width:100%}.widgetTitle .iconContainer{width:6%;display:table-cell;vertical-align:top;text-align:center}.widgetTitle .iconContainer .iconBackground{background-color:#00a0f4;margin:.6em;border-radius:.5em}.widgetTitle .iconContainer .iconBackground .icon{margin:.3em;width:2em}.widgetTitle .title{width:90%;display:table-cell;font-size:1.7em;padding-top:.5em}", ""]);
	
	// exports


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".FurnitureDisplay .editOptions{position:absolute;width:100%;height:100%}.FurnitureDisplay .editOptions .arrow{position:absolute;font-size:40px;z-index:10;cursor:pointer}.FurnitureDisplay .editOptions .left-arrow{top:42%;left:0}.FurnitureDisplay .editOptions .right-arrow{top:42%;left:91%}.FurnitureDisplay .editOptions .up-arrow{top:0;left:45%}.FurnitureDisplay .editOptions .down-arrow{top:85%;left:45%}.FurnitureDisplay .furnitureItem{position:absolute;transition:opacity .3s;opacity:1}.FurnitureDisplay .furnitureItem.appear-enter{opacity:.01}.FurnitureDisplay .furnitureItem.appear-exit{max-height:0;opacity:.01}.FurnitureDisplay .wall_items{z-index:1}.FurnitureDisplay .wall_items2{z-index:2}.FurnitureDisplay .bookshelves{z-index:3}.FurnitureDisplay .sofas{z-index:4}.FurnitureDisplay .floor_items{z-index:5}.FurnitureDisplay .floor_items2{z-index:6}.FurnitureDisplay .shopActions{z-index:10;position:absolute;top:88%;left:67%;font-size:.8em;background:#fff;padding:6px;border-radius:15px;border:1px solid #bbb;box-shadow:0 3px 12px #bbb}.FurnitureDisplay .shopActions .purchase{margin-right:5px;margin-left:5px}.FurnitureDisplay .shopActions .remove{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".animationModal .modal-dialog{display:flex;justify-content:center;align-items:center;height:40%;width:25%}.animationModal .modal-dialog .modal-content{height:100%;width:100%}.animationModal .modal-dialog .modal-content .studentAvatar{display:flex;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dressingRoom{display:flex;height:545px}.dressingRoom .modalBackground{position:absolute;left:0;top:0;width:100%;height:100%;max-width:100%;max-height:100%;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.dressingRoom .owlvatarControl{display:flex;flex-direction:column;align-items:center;position:static;margin-top:18%}.dressingRoom .owlvatarControl .owlvatar{padding-left:3rem;padding-right:3rem}.dressingRoom .owlvatarControl .saveButton{z-index:10000;width:70%}.dressingRoom .dressingPatcher{display:flex;flex-direction:column;z-index:10000;width:73%;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".goldenEggOutofModal{animation:shake 3s infinite;cursor:pointer;width:40px;height:auto;border-opacity:1}.eggModal{min-width:100px;min-height:100px}.eggModal img.patchThumbnail{display:block;height:60%;width:60%;margin:0 auto}.eggModal .itemsDisplay{display:flex;flex-wrap:wrap;justify-content:center}.eggModal .displayItem{position:relative;display:inline-block;width:137px;padding:5px;padding-bottom:10px;text-align:center;margin-top:5px;color:inherit;font-size:.8em;text-decoration:none}.eggModal .patchDescription{font-size:1em;font-weight:400;text-align:center}.eggModal .goldenEggInsideModal{width:auto;height:auto;position:relative;animation:shake .5s 2;text-align:center;margin-top:-20px}.eggModal .eggContainer{text-align:center;margin-bottom:5%}.eggModal .coinAmount{text-align:center;margin-top:2%;font-weight:400;margin-bottom:10%}.eggModal .patchName{font-size:1.4em;text-align:center}.eggModal .wrModalHeader{font-size:1.6em}.eggModal .awardImage{text-align:center;animation:jump 2s ease-out}.eggModal .awardsCoin{text-align:center;cursor:pointer;font-weight:1em}.eggModal .awardsPatch{text-align:center;position:relative}.eggModal .owlShopLink{font-weight:400;text-align:center;margin:20px}.eggModal .awardImage,.eggModal .coinAmount,.eggModal .patchDescription,.eggModal .patchName{font-weight:400}.eggModal .coinAmount,.eggModal .owlShopLink{font-size:1.2em}", ""]);
	
	// exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".houseInteriorRoom{height:545px}.houseInteriorRoom .backgroundImage{position:absolute;left:0;top:0;width:800px;height:575px;max-width:100%}.houseInteriorRoom .owlsInside{position:absolute;bottom:0}.houseInteriorRoom .owlTwo{right:30%}.houseInteriorRoom .owlOne{right:40%}.houseInteriorRoom .owlOneSide{left:30%}.houseInteriorRoom .OwlShopPatcher .categorySelector a.selector{width:90px}.houseInteriorRoom .shopHeader{position:absolute;z-index:9000}.houseInteriorRoom .shopHeader .shopLogo{cursor:pointer;height:46px;padding:5px;background:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb}.houseInteriorRoom .patcher{position:absolute;width:80%;top:5%;left:10%;z-index:10}.houseInteriorRoom .right_close{float:right;cursor:pointer}.houseInteriorRoom .spinnerBox{z-index:9000}", ""]);
	
	// exports


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".houseModal .modal-dialog{width:80rem!important}.houseModal .switchRoomLink{font-size:2rem;position:absolute;top:25rem;color:#555;z-index:10000}.houseModal .switchRoomLink.switchRight{right:0}.houseModal .switchRoomLink.switchLeft{left:0}", ""]);
	
	// exports


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".newItemsModal .modal-title{font-size:1.9em}.newItemsModal .subheadline{text-align:center;font-size:1.3em;line-height:1.5em;padding-bottom:1em}.newItemsModal .owlImages{display:flex;justify-content:center;padding-bottom:1em}.newItemsModal .owlImages img{width:auto;height:200px;padding:10px}.newItemsModal .categorySelector{border-bottom:1px solid #eee;padding-bottom:10px}.newItemsModal .categorySelector h4{text-align:center}.newItemsModal .categorySelector a.selector{text-align:center;display:inline-block;position:relative;margin-bottom:15px;width:73px;text-decoration:none;color:inherit;line-height:.8}.newItemsModal .categorySelector a.selector:hover{opacity:.7}.newItemsModal .categorySelector a.selector img{width:auto;height:40px;display:block;margin:0 auto}.newItemsModal .categorySelector a.selector .categoryTitle{position:relative;top:3px;font-size:.8em}.newItemsModal .categorySelector .categorySection{text-align:center}.newItemsModal .categorySelector .categorySection .selector{border:1px solid #fff;padding:5px;padding-bottom:10px}.newItemsModal .categorySelector .categorySection .selectedPatchType{border-color:#ddd;border-radius:5px}.newItemsModal .categorySelector .categorySection .modeSelectorRowContainer{display:flex;flex-direction:column;gap:1em}.newItemsModal .categorySelector .categorySection .modeSelectorRowContainer .sectionTitle{font-size:1.1em}.newItemsModal .categorySelector .patchCategory{width:50%}.newItemsModal .categorySelector .actionSection{width:20%}.newItemsModal .categorySelector .otherSection{width:30%}", ""]);
	
	// exports


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".purchaseModal .modal-dialog{display:flex;justify-content:center;align-items:center;height:auto;width:50%;min-height:0}.purchaseModal .modal-content{height:100%;width:100%}.purchaseModal .modalItem{margin-top:5%;margin-bottom:5%}.purchaseModal .controls{display:flex;justify-content:center;gap:2em;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".saleModal .patchWrap{display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".tierRequirementsDisplay{overflow:auto;display:flex;flex-wrap:wrap;align-items:center;justify-content:center}.tierRequirementsDisplay .canAffordSquare,.tierRequirementsDisplay .otherSquare,.tierRequirementsDisplay .reqMetSquare,.tierRequirementsDisplay .reqNotMetSquare{float:left;margin-top:2.5rem;margin-left:.8333333333rem;margin-right:.8333333333rem;padding:.8333333333rem;border-radius:10px;line-height:1.1}.tierRequirementsDisplay .canAffordSquare .itemImage,.tierRequirementsDisplay .otherSquare .itemImage,.tierRequirementsDisplay .reqMetSquare .itemImage,.tierRequirementsDisplay .reqNotMetSquare .itemImage{height:3.3333333333rem}.tierRequirementsDisplay .canAffordSquare .miniItemImage,.tierRequirementsDisplay .otherSquare .miniItemImage,.tierRequirementsDisplay .reqMetSquare .miniItemImage,.tierRequirementsDisplay .reqNotMetSquare .miniItemImage{height:1.5rem;padding:.1666666667rem}.tierRequirementsDisplay .perkMiniItemDisplay{width:3.3333333333rem;height:3.3333333333rem}.tierRequirementsDisplay .reqNotMetSquare{border:1px dashed #555;background-color:#fff;opacity:.5}.tierRequirementsDisplay .otherSquare,.tierRequirementsDisplay .reqMetSquare{border:1px solid transparent}.tierRequirementsDisplay .canAffordSquare{border:1.2px solid}.tierRequirementsDisplay .arrowLink{color:#555;margin-top:3.5rem}.tierRequirementsDisplay .arrowLink.arrowLeft{position:absolute;left:-2%}.tierRequirementsDisplay .arrowLink.arrowRight{position:absolute;right:3%}", ""]);
	
	// exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".trophyRoom{height:545px}.trophyRoom .tierIcon{margin-top:2.5rem;height:5rem}.trophyRoom .shelfBackground{width:100%;position:absolute;left:0}.trophyRoom .tierRow{height:9rem}.trophyRoom .modalBackground{position:absolute;left:0;top:0;width:800px;height:575px;max-width:100%;max-height:100%;border-bottom-left-radius:5px;border-bottom-right-radius:5px}", ""]);
	
	// exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".albus-activity{font-family:Didact Gothic;font-size:18px;width:900px;overflow:hidden}.albus-activity strong{font-weight:400;text-shadow:1px 0 0 #888}.albus-activityHeader{text-align:center;min-height:133px;margin-bottom:12px;background-repeat:no-repeat;background-position:bottom}.albus-activityHeader h2{border-bottom:1px solid #ddd;display:inline-block;padding:0 10px;font-size:32.1px;max-width:500px;margin-bottom:60px}.albus-instructions{width:85%;line-height:1.4;margin-bottom:15px}.albus-activity .imageOp,.albus-activity .swatch{cursor:pointer;position:relative;display:inline-block;width:40px;height:40px;margin:5px;border:1px solid #bbb;border-radius:5px}.albus-activity .labelOverlay{position:absolute;top:0;left:0;pointer-events:none}.albus-activity .labelOverlay label{position:absolute}.albus-activity label p{margin-bottom:0}.albus-activity .innerLabel div,.albus-activity .innerLabel p{display:inline-block}.albus-activity .writtenUserInput{border-left:1px solid #ddd;padding-left:10px;color:#888;hyphens:auto;-webkit-hyphens:auto;-ms-hyphens:auto;-moz-hyphens:auto}.albus-InputArrayStructure{width:75%;margin-top:15px}.albus-InputArrayStructure label{font-weight:400;margin-bottom:15px;line-height:1.2;max-width:650px}.albus-InputArrayStructure label.fixedInput{margin-bottom:0}.albus-InputArrayStructure input,.albus-InputArrayStructure select,.albus-InputArrayStructure textarea{max-width:650px;margin-bottom:15px}.albus-InputArrayStructure textarea{min-height:80px}.albus-absoluteBox{position:relative}.albus-absoluteBox .userInput,.albus-absoluteBox .writtenUserInput,.albus-absoluteBox label{position:absolute}.albus-absoluteBox .writtenUserInput{border:0;padding:3px 5px;font-size:.8em}.albus-absoluteBox textarea{resize:none;border-color:#ccc}.albus-GraphicOrganizerStructure{margin-bottom:15px}.albus-GraphicOrganizerStructure.albus-absoluteBox .writtenUserInput{overflow:auto}.albus-canvas{border:5px double #ccc;border-radius:5px;overflow:hidden;background-repeat:no-repeat;max-width:775px}.albus-canvas.upper-canvas{background-image:none!important}.albus-errorField{outline:1px dashed #880b22}.albus-errorBox{color:#880b22}.albus-CollageStructure,.albus-DrawingResponseStructure{position:relative;margin-bottom:15px}.albus-DrawingFormat ul{list-style:none;padding-left:0}.albus-CollageStructure .imageBar,.albus-DrawingResponseStructure .colorBar{position:absolute;top:0;width:112px;padding:5px;border:1px solid #bbb;border-radius:8px}.albus-CollageStructure .imageOps,.albus-DrawingResponseStructure .colorOps{font-size:0}.albus-DragDropStructure{margin-bottom:15px}.albus-DrawingResponseStructure .brushSize{display:inline-block;vertical-align:middle;border-radius:100px;background-color:#eee;border:2px solid #ddd;margin:0 5px;cursor:pointer}.albus-DrawingResponseStructure .brushSize.selected{border-color:#ccc}.albus-DrawingResponseStructure .clearDrawing{font-size:.8em}.albus-CollageStructure a.imageOp{background-color:#fff;vertical-align:middle}.albus-CollageStructure a.imageOp img{margin-left:5%;margin-top:5%;max-width:90%;max-height:90%}.albus-CollageStructure .controls{font-size:14pt;text-align:center;line-height:.8}.albus-CollageStructure .controls .glyphicon{margin-left:5px;margin-right:5px;cursor:pointer}.albus-CollageStructure .controls .glyphicon:hover{opacity:.7}.albus-CollageStructure .form-control.imageSearch{height:28px;font-size:12px;margin:5px;width:90%}.albus-Passage,.albus-passage{border-left:1px solid #ddd;padding-left:8px}.albus-Passage .passageTitle{font-weight:700;font-size:1.2em}.albus-Passage .passageSource{text-align:right;font-style:italic}.albus-ShortPassageFormat .highlightOptions{position:fixed;right:20px;width:160px;padding:5px;border:1px solid #bbb;border-radius:8px;background:#fff}.albus-ShortPassageFormat .highlightOp{position:relative}.albus-ShortPassageFormat .highlightOp .text{display:inline-block;margin-left:25px;margin-bottom:5px;font-size:.8em}.albus-ShortPassageFormat .clearHighlights{font-size:.8em}.albus-ShortPassageFormat .highlightOp .swatch{position:absolute;left:-5px;width:20px;height:20px}.albus-image{display:block;max-width:100%;height:auto;width:auto;margin-left:auto;margin-right:auto;margin-bottom:10px}.albus-VocabContextFormat .vocabBox{column-count:3;column-gap:10px}.albus-activity .vocabWord{display:inline-block;width:100%;padding:5px 15px;border-radius:5px;background:#eee;margin-bottom:10px;break-inside:avoid;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.albus-activity .vocabWord.active{background:#f3e9b5}.albus-activity .vocabWord .exampleLine{font-style:italic;font-size:.8em}.albus-activity .vocabWord .defLine{margin-bottom:5px}.albus-VoiceResponseStructure .audioControlBox{position:relative;width:550px;margin-top:10px;margin-bottom:10px;border:1px solid #bbb;border-radius:8px;padding:10px}.albus-VoiceResponseStructure .audioControl{font-size:2em;margin-right:5px;cursor:pointer;vertical-align:middle}.albus-VoiceResponseStructure img.audioControl{height:36px}.albus-VoiceResponseStructure .glyphicon.audioControl{top:-1px}.albus-VoiceResponseStructure .audioControl:hover{opacity:.7}.albus-VoiceResponseStructure .playbackBar{position:absolute;display:inline-block;background:#ccc;border-radius:10px;height:15px;left:100px;width:400px;top:50%;margin-top:-8px;cursor:pointer}.albus-VoiceResponseStructure .playbackMark{display:block;position:relative;top:0;margin-left:-7px;width:15px;height:15px;border-radius:15px;background:#555;pointer-events:none}.albus-additionalText .btn{margin-left:15px}.albus-ShortPromptFormat .writtenUserInput,.albus-ShortPromptFormat textarea{max-width:650px;margin-top:10px;margin-bottom:15px}.albus-ShortPromptFormat label{display:block;max-width:650px;margin-bottom:0}.albus-ShortPromptFormat .refreshButton{padding-left:0;padding-top:5px;padding-bottom:0}.albus-ShortPromptFormat .refreshButton:focus{outline:0}.albus-CollaborationFormat .albus-MultiStepPhase{position:relative}.albus-CollaborationFormat .blockingOverlay{position:absolute;top:0;bottom:0;left:0;right:0;opacity:.2;z-index:1;background:repeating-linear-gradient(45deg,transparent,transparent 15px,#2b9401 0,#2b9401 40px)}.albus-CollaborationFormat .sectionRole{position:absolute;top:0;right:10px}.albus-MultiStepPhase.pastPhase{border-bottom:5px double #eee}.albus-MultiStepPhase.pastPhase.lastPhase{border-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".active{color:#195500}.topNav{border:1px solid #c8ecff}.topNav li{margin-right:20px;display:inline-block}.ellipsisText{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
	
	// exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "body,html{margin:0;position:relative;height:100%;min-height:100%}body{font-family:museo-sans-rounded,Helvetica,Arial,sans-serif;font-size:16px;line-height:1.428571429;color:#555;background-color:#fff}#app,.outerMostContainer{height:100%}.outerMostContainer{display:flex;flex-direction:column}.outerPageContainer{flex:1 0 auto}.container{max-width:970px}@media(min-width:800px){.container{width:780px}}@media(min-width:920px){.container{width:900px}}.form-control{font-size:16px}h1{font-size:2.1em;border-bottom:1px solid #ddd;margin-bottom:15px;font-weight:300;margin-top:5px}header.pageHeader{text-align:center}header.pageHeader h1{display:inline-block;padding:0 10px}h2{border-bottom:1px solid #ddd;margin-bottom:15px}h2,h3{font-size:1.4em}h4{font-size:1em}h4,h5{font-weight:700}h5{font-size:.8em}.clickableElement{cursor:pointer}.clickableElement:hover{opacity:.7}.__react_component_tooltip{z-index:9999999999!important;max-width:250px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.Select-multi-value-wrapper .Select-value-icon{display:none}label.normal,label input,label select{font-weight:400}label.blockLbl{display:block}.btn-link:focus{outline:none}span.spacer0{width:.4rem}span.spacer0,span.spacer1{white-space:nowrap;display:inline-block}span.spacer1{width:1rem}span.spacer2{width:2rem}span.spacer2,span.spacer4{white-space:nowrap;display:inline-block}span.spacer4{width:3rem}.backgroundPatcher{background:#fff;padding:15px;border-radius:15px;border:1px solid #bbb;box-shadow:0 3px 12px #bbb}.recording{border-color:#da3956;animation:recordingAnimation 6s infinite}", ""]);
	
	// exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	exports.i(__webpack_require__(1244), "");
	exports.i(__webpack_require__(1243), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#pageContent{margin-bottom:25px}.btn{font-size:inherit}.linkStyle,a{color:#337ab7}.redBold{font-weight:700;color:#c31030}.errorRed{color:#da3956}.orangeBold{font-weight:700;color:#e46e36}.blueBold{font-weight:700;color:#00a0f4}.greenBold{font-weight:700;color:#70d544}.lightGray{color:#aaa}.l2eCheckbox{transform:scale(1.2)}.verticalDivider{width:0;height:30px;border-left:1px solid #fff;display:inline-block;position:relative;top:5px}.card{border-radius:5px;border:1px solid #bbb;box-shadow:0 3px 12px #bbb;display:block;transition:.1s}.card:hover{opacity:.7}.largeObject{box-shadow:0 1.5px 6px #ddd}.largeObject,.smallObject{border-radius:5px;border:1px solid #ddd}.smallObject{box-shadow:0 .75px 3px #ddd}.bodyText{font-size:1em}.smallText{font-size:.8em}.sectionHeader{font-size:2.1em;border-bottom:1px solid #ddd;text-align:left;margin-bottom:15px}.sectionHeader:after{content:\"\" \"\" \"\"}.sectionSubHeader{text-align:left}.sectionSubHeader,.subHeader{font-size:1.4em;font-weight:700}.subHeader{text-align:center}@media print{.hideOnPrint{display:none!important}}.showOnPrint{display:none!important}@media print{.showOnPrint{display:block!important}}@media print{body,html{height:auto!important;overflow:initial!important;-webkit-print-color-adjust:exact}body{margin-top:1em}.answerDisplay,.studentReadingLevelGraph{margin-bottom:2em;display:block}.answerDisplay,.studentReadingLevelGraph,.studentRow{page-break-inside:avoid;page-break-after:auto}.StudentActivitiesTable{margin-bottom:2em}}@page{size:auto;margin:20mm}.modal-header{padding-bottom:0!important}.buttonDefault{color:#555;background-color:#fff;border:1px solid #ccc;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.buttonDefault:hover{background-color:#eee;border-color:#aaa}.buttonDanger{color:#fff;background-color:#c31030;border:1px solid #a1011e;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.buttonDanger:hover{color:#fff;background-color:#620818;border-color:#880b22}.buttonWarning{color:#fff;background-color:#fa9362;border:1px solid #e46e36;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.buttonWarning:hover{color:#fff;background-color:#c54e14;border-color:#a13603}.buttonSuccess{color:#fff;background-color:#2b9401;border:1px solid #237600;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif;min-width:100px!important}.buttonSuccess:hover{color:#fff;background-color:#237600;border-color:#195500}.buttonSuccess:disabled{opacity:.7;cursor:disabled}.buttonSuccess:disabled:hover{color:#fff;background-color:#2b9401;border-color:#237600}.buttonPrimary{color:#fff;background-color:#00a0f4;border:1px solid #0082c8;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.buttonPrimary:hover{color:#fff;background-color:#006faa;border-color:#005683}.emptyStateContainer .emptyStateButton{display:inline-block;vertical-align:bottom;margin-bottom:5px;margin-left:15px;border:1px dashed #bbb;color:#555}.emptyStateContainer .emptyStateText{width:50%;display:inline-block}.topEmptyRow{width:100px;height:15px}.bottomEmptyRow{width:75px;height:35px}.bottomEmptyRow,.topEmptyRow{background:#ddd;border-radius:2px}.emptyAvatar,.emptyCoinImage{width:25px;border-radius:24px;height:25px;border:1px dashed #bbb}.editable .glyphicon{font-size:.8em}.editable .editIcon{display:none}.editable:hover .editIcon{display:inline-block;cursor:pointer;opacity:.7}.excludedStripes{background-image:linear-gradient(45deg,#e8e8e8 10%,#fff 0,#fff 50%,#e8e8e8 0,#e8e8e8 60%,#fff 0,#fff);background-size:7.07px 7.07px}", ""]);
	
	// exports


/***/ }),
/* 1305 */
1251,
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".basicSiteHeader{min-height:5rem;background-color:#fff;color:#00a0f4}.basicSiteHeader .headerContainer{text-align:center;padding:1rem 1.5rem}.basicSiteHeader .centerNav,.basicSiteHeader .leftNav,.basicSiteHeader .rightNav{display:inline-block;vertical-align:center}.basicSiteHeader .leftNav,.basicSiteHeader .rightNav{width:25%}.basicSiteHeader .leftNav{text-align:left;font-size:.8em}.basicSiteHeader .centerNav{width:50%}@media(max-width:45rem){.basicSiteHeader .centerNav .wrLogo{width:100%}}@media(min-width:45rem)and (max-width:75rem){.basicSiteHeader .centerNav .wrLogo{width:60%}}@media(min-width:75rem){.basicSiteHeader .centerNav .wrLogo{width:30%}}.basicSiteHeader .rightNav{text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".pendingTaskNotice{pointer-events:none;transition:opacity .9s}.pendingTaskNotice .innerBanner{position:fixed;top:68px;left:-60px;z-index:900010;width:300px;height:36px;background-color:#e46e36;transform:rotate(-45deg)}.pendingTaskNotice p{position:relative;top:7px;z-index:200;text-align:center;color:#fff}.pendingTaskNotice.fadeOut{opacity:0}.pendingTaskNotice .fadeCycle{animation:fadeAnimation 2s infinite ease-in-out}@keyframes fadeAnimation{0%{opacity:.8}50%{opacity:.5}to{opacity:.8}}", ""]);
	
	// exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".returnAccountHeader .inner{border:1px solid #e8cb36;border-radius:5px;padding:10px 30px}.returnAccountHeader .leftSection{display:inline-block;vertical-align:middle;width:65%}.returnAccountHeader .rightSection{display:inline-block;vertical-align:middle;width:33%;border-left:1px solid #ccc;text-align:center}.returnAccountHeader .rightSection a:nth-of-type(2){color:#555}.returnAccountHeader .demoImg{width:auto;height:40px;margin-right:15px}", ""]);
	
	// exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".siteFooter{border-top:1px solid #ddd;padding:0 2rem 2rem;background-color:#555;color:#fff}.siteFooter .favicon{margin-top:2.5rem}@media(max-width:45rem){.siteFooter .favicon{width:25%}}@media(min-width:45rem)and (max-width:75rem){.siteFooter .favicon{width:50%}}@media(min-width:75rem){.siteFooter .favicon{width:40%}}@media(max-width:45rem){.siteFooter .faviconP{text-align:center}}.siteFooter .linkColumn{display:flex;flex-direction:column;align-items:center;margin-top:2.5rem;float:left}@media(max-width:45rem){.siteFooter .linkColumn{width:33.3%}}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.siteFooter .linkColumn{width:25%}}@media(max-width:45rem){.siteFooter .faviconColumn{width:100%}}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.siteFooter .faviconColumn{width:25%;float:left}}.siteFooter .navigationArea{position:relative;justify-content:flex-start;display:flex}.siteFooter .footerColumnLabel{font-weight:700}.siteFooter .footerLink{color:#eee}.siteFooter .footerLink:hover{cursor:pointer}.siteFooter .socialIcon{color:#555;margin-right:1rem;margin-left:-.5rem}.siteFooter .socialIcon :hover{cursor:pointer}.siteFooter .socialIcon.twitter{margin-left:0}.siteFooter .socialIcon img{width:2.5rem}.siteFooter .legal{text-align:center;margin-top:2.5rem;font-size:1.2rem}.siteFooter .legal .legalLink{color:#fff}.siteFooter .legal .legalLink:hover{cursor:pointer}.siteFooter .hiddenInfo{font-size:1rem;color:#555;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#siteHeader{background:#00a0f4;height:54px;margin-bottom:15px;color:#fff!important}#siteHeader .container{position:relative}#siteHeader .leftNav,#siteHeader .rightNav{position:absolute;margin-top:15px}#siteHeader .myClassNavContainer,#siteHeader .mySchoolNavContainer,#siteHeader .myShelfContainer,#siteHeader .owlShopContainer{display:inline-block}#siteHeader .myClassNavContainer a,#siteHeader .mySchoolNavContainer a,#siteHeader .myShelfContainer a,#siteHeader .owlShopContainer a{color:#fff}#siteHeader .myShelfContainer{margin-right:20px}#siteHeader .myShelfContainer img{width:25px;margin-right:5px}#siteHeader .myClassNavContainer,#siteHeader .mySchoolNavContainer{margin-right:20px}#siteHeader .myClassNavContainer img,#siteHeader .mySchoolNavContainer img{width:30px;margin-right:5px}#siteHeader .owlShopContainer{position:relative;bottom:8px;margin-right:12px}#siteHeader .owlShopContainer span{margin-left:5px}#siteHeader .owlShopContainer .owlConstraints{z-index:0}#siteHeader #adminLeftNav .verticalDivider{height:25px;top:0}#siteHeader #adminLeftNav a.dataLink,#siteHeader #adminLeftNav a.rosterLink,#siteHeader #adminLeftNav div.verticalDivider{vertical-align:top}#siteHeader #adminLeftNav a.dataLink,#siteHeader #adminLeftNav a.insightsLink,#siteHeader #adminLeftNav a.rosterLink{margin-right:15px}#siteHeader #adminLeftNav .insightsLogo{background-color:#fff;width:3rem;border-radius:5px;padding:.2rem;margin-top:-1.5rem;margin-left:.2rem}#siteHeader.adminHeader .leftNav{left:13px}#siteHeader.adminHeader .rightNav{right:15px}#siteHeader .leftNav{left:0}#siteHeader .leftNav a{color:#fff}#siteHeader .wizLink{margin-right:1em}#siteHeader .dropdown{display:inline-block;vertical-align:top}#siteHeader .dropdown,#siteHeader .dropdown.wizLink{position:relative;bottom:1px}#siteHeader .dropdown li:hover{background:#efefef}#siteHeader .dropdown li a{text-decoration:none;width:100%}#siteHeader .dropdown .caret{border-top:6px dashed;border-left:6px solid transparent;border-right:6px solid transparent;margin-left:5px}#siteHeader .dropdown #dLabel{color:#fff}#siteHeader .dropdown #dLabel.hasTitle{position:relative;top:-8px}#siteHeader .dropdown #dLabel .ellipsisText{max-width:100px;display:inline-block;vertical-align:middle}#siteHeader .dropdown-menu{z-index:99999}#siteHeader .dropdown-menu a,#siteHeader .dropdown-menu li{color:#555;padding-bottom:0;padding-left:5px}#siteHeader .dropdown-menu .glyphicon{top:-2px;color:#c0f2aa;font-size:.8em;left:3px}#siteHeader .dropdown-menu .dropdownDivider{border-bottom:1px solid #bbb;margin-top:5px;margin-bottom:5px}#siteHeader .dropdown-menu .fadedLink{opacity:.6}#siteHeader .rightNav{right:0}#siteHeader .rightNav .rightNavContent{display:inline-block}#siteHeader .rightNav .rightNavContent .rightNavLink{position:relative;margin-right:15px;color:#fff}#siteHeader .rightNav .rightNavContent .verticalDivider{height:25px;top:0;margin-right:15px}#siteHeader .rightNav .rightNavContent .coinsContainer{position:relative;cursor:pointer;display:inline-block;vertical-align:top;margin-right:15px}#siteHeader .rightNav .rightNavContent .coinsContainer .totalDisplay:hover{opacity:.9}#siteHeader .rightNav .rightNavContent .coinsContainer .popover{z-index:9999;display:block!important;width:160px;left:-67px}#siteHeader .rightNav .rightNavContent .coinsContainer .popover.bottom{margin-top:35px}#siteHeader .rightNav .rightNavContent .coinsContainer .animatedCoinsContainer{display:none;position:absolute;right:95px;width:125px}#siteHeader .rightNav .rightNavContent .coinsContainer .animatedCoinsContainer .displayCoin{width:20px;position:absolute;z-index:200000000000}#siteHeader .rightNav .rightNavContent .coinsContainer .popover-content{padding:0}#siteHeader .rightNav .rightNavContent .coinsContainer .coinNotificationItem{position:relative;color:#555;font-size:.8em;border-bottom:1px solid #ddd;padding:5px;min-height:33px}#siteHeader .rightNav .rightNavContent .coinsContainer .coinNotificationItem p{margin-bottom:0;margin-left:26px}#siteHeader .rightNav .rightNavContent .coinsContainer .coinNotificationItem img.itemCoin{position:absolute;left:6px;top:7px;width:20px}#siteHeader .rightNav .rightNavContent .coinsContainer .coinNotificationItem:last-of-type{border:none}#siteHeader .rightNav .rightNavContent .coinsContainer .emptyStateContainer{padding:5px}#siteHeader .rightNav .rightNavContent .coinsContainer .emptyStateContainer .emptyText{color:#555}#siteHeader .rightNav .rightNavContent .coinsContainer .emptyStateContainer .emptyCoinImage{display:inline-block}#siteHeader .rightNav .rightNavContent .coinsContainer .emptyStateContainer .emptyCoinText{display:inline-block;margin-left:10px;margin-bottom:5px;width:105px}#siteHeader .rightNav .rightNavContent .coinsContainer .emptyStateContainer .emptyCoinRow{margin-bottom:5px}#siteHeader .rightNav .rightNavContent .notificationContainer{display:inline-block;margin-right:15px}#siteHeader .rightNav .rightNavContent .notificationContainer .glyphicon-bell{font-size:22px}#siteHeader .loginButton{border:1px solid #fff;padding:8px 10px;border-radius:5px;color:#fff}#siteHeader .loginButton:hover{color:#00a0f4;background:#fff;text-decoration:none}#siteHeader .logoBox{position:absolute;left:50%;margin-left:-150px;width:300px;border-radius:300px/50px;background:#00a0f4;padding:14px;padding-top:10px}#siteHeader .logoBox:hover{opacity:.7}#siteHeader .logoBox img.wrLogo{width:90%;margin-left:5%;margin-right:5%;height:auto}#siteHeader .classicUserNav a{color:#fff;margin-left:15px}#siteHeader .socialNotificationContainer{position:relative;bottom:5px}#siteHeader .navStatus{position:absolute;right:-10px;bottom:14px;font-size:9px;font-weight:400;background-color:#70d544}#siteHeader .insightsLink .navStatus{bottom:20px;right:75px}#siteHeaderPlaceholder{height:54px;margin-bottom:15px}#siteHeader.headerFixed{position:fixed;top:-54px;width:100%;z-index:900000;height:45px!important}#siteHeader.headerFixed .leftNav,#siteHeader.headerFixed .rightNav{margin-top:8px!important}#siteHeader.headerFixed .logoBox{border-radius:0;padding-bottom:0;padding-top:8px}#siteHeader.headerFixed .logoBox:hover{opacity:.7}#siteHeader.headerFixed .logoBox img.wrLogo{width:66%!important;margin-left:17%!important;margin-right:0!important}", ""]);
	
	// exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".topBarWarning .ieWarning{background-color:#004163;padding:10px 20%;text-align:center;color:#c8ecff}.topBarWarning .ieWarning a{color:#68caff}", ""]);
	
	// exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#universalControls .feedbackBar{position:fixed;right:-28px;bottom:74px;height:0;z-index:100000000}#universalControls .feedbackBar .feedbackEmail{display:block;color:#fff;background:#c31030;padding:4px 64px;text-decoration:none;cursor:pointer;transform:rotate(-30deg)}#universalControls .feedbackBar .feedbackEmail:hover{opacity:.7}", ""]);
	
	// exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".forgotPasswordPage .forgotOwl{width:150px;height:auto;display:block;margin:0 auto;margin-bottom:10px}.forgotPasswordPage .resetForm{width:400px;margin:0 auto;margin-bottom:20px}.forgotPasswordPage .btnLine{margin-top:1em;margin-bottom:1em}.forgotPasswordPage .resetMessage{transition:height .4s;overflow:hidden;color:#888;margin-top:5px;margin-left:12px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".loginPage .loginImgSection{text-align:center}.loginPage .loginImgSection .wiseOwlsImg{width:240px;margin:0 auto;margin-bottom:5px}.loginPage .loginLinks{display:inline-block;vertical-align:top}.loginPage .buttonPrimary{position:absolute;right:16px}.loginPage .googleBtn{width:100%}.loginPage .googleBtn img{width:40px;position:relative;right:11px}.loginPage .g-signin2-alt{cursor:pointer;position:absolute;opacity:0;width:100%;height:48px}", ""]);
	
	// exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".resetPasswordPage .resetForm{width:220px;margin:0 auto;margin-bottom:20px}.resetPasswordPage .validatingInput{margin-bottom:10px}.resetPasswordPage .btnLine{text-align:center;margin-top:15px}", ""]);
	
	// exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".dropDownNotification{position:fixed;left:50%;width:550px;margin-left:-250px;padding:10px;color:#fff;border-radius:4px;z-index:1150000;cursor:pointer;-webkit-transition:top .4s;-webkit-transition-timing-function:cubic-bezier(.5,-.5,.5,1.5);transition:top .4s;transition-timing-function:cubic-bezier(.5,-.5,.5,1.5);top:50px}.dropDownNotification.drop-down-enter.drop-down-enter-active{top:50px}.dropDownNotification.drop-down-enter,.dropDownNotification.drop-down-exit{top:-100px}.dropDownNotification.success{background-color:#2b9401}.dropDownNotification.error{background-color:#c54e14}", ""]);
	
	// exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".newFeaturesModal .newFeatureInfo{display:flex;flex-direction:column;align-items:center;justify-content:center}.newFeaturesModal .imgContainer{padding:1em}.newFeaturesModal .imgContainer .newFeatureImage{max-width:100%;border-radius:.5em;height:auto}.newFeaturesModal .newFeatureDescription{font-size:1em;line-height:1.5;text-align:center;margin-bottom:1em;color:#555}.newFeaturesModal .buttonContainer{width:100%;text-align:center;display:flex;flex-direction:row;justify-content:space-evenly;margin-top:.5em}.newFeaturesModal .nextBtn{background-color:#00a0f4}.newFeaturesModal .backBtn,.newFeaturesModal .nextBtn{margin-top:10px;color:#fff;border-radius:5px;border:none;padding:10px 20px;font-size:16px;font-weight:700;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-top:.8em}.newFeaturesModal .backBtn{background-color:#888}.newFeaturesModal .closeBtn{margin-top:10px;background-color:#42af14;color:#fff;border-radius:5px;border:none;padding:10px 20px;font-size:16px;font-weight:700;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-top:.8em}", ""]);
	
	// exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".siteAnnoucementModal .titleImgeContainer{display:flex;justify-content:space-around;gap:1em;flex-wrap:wrap;align-items:center;margin:2em 0}.siteAnnoucementModal .titleImage{max-width:100%}.siteAnnoucementModal .titleImage.savvasLogo{height:55px}.siteAnnoucementModal .titleImage.wrLogo{height:45px}", ""]);
	
	// exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".siteBannerContainer{background-color:#2b9401;margin-top:-1.5rem;margin-bottom:1rem;position:relative}.siteBannerContainer.goldBackground{background-color:#cdab2c}.siteBannerContainer .content{color:#fff}.siteBannerContainer .content,.siteBannerContainer .content.gold{padding-top:1rem;padding-bottom:1rem}.siteBannerContainer .content.gold .modal-header{background-color:#cdab2c;color:#fff;border-top-right-radius:6px;border-top-left-radius:6px}.siteBannerContainer .content.gold .alertButton{background-color:#fff;color:#cdab2c}.siteBannerContainer .alertText{display:inline-block;vertical-align:middle;width:80%}.siteBannerContainer .alertButton{display:inline-block;border-color:#fff;text-align:center;width:15%;margin-left:3%}.siteBannerContainer .alertButton:hover{border-color:#fff;text-decoration:none}.siteBannerContainer .removeLink{display:inline-block;position:absolute;top:1rem;right:3rem;color:#fff}.siteBannerContainer .alertNumber{font-size:.8em;text-align:center;padding-top:1rem}.siteBannerContainer .goldTrialBannerCTA{font-size:16px;margin-left:5px;cursor:pointer;color:#cdab2c;max-height:fit-content}.siteBannerContainer .modal-header{border-bottom:none;font-size:1.5em}.siteBannerContainer .modal-body{padding-top:0}.siteBannerContainer .altModal.modal .modal-header{border-bottom:none}", ""]);
	
	// exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".slideInAnnouncement{position:sticky;left:100%;bottom:70%;float:left;width:25%;text-align:center;transition:transform 1s ease-out;-moz-transition:transform 1s ease-out;-webkit-transition:transform 1s ease-out}.slideInAnnouncement.showSidebar{transform:translateX(0)}.slideInAnnouncement.hideSidebar{transform:translateX(90%)}.slideInAnnouncement .inner .arrowContainer{display:inline-block;width:10%;float:left;background:#eee;padding:1em .5em;border-radius:1em 0 0 1em}.slideInAnnouncement .inner .arrowContainer .bodyArrow{font-size:1.5em;vertical-align:top;color:#00a0f4}.slideInAnnouncement .inner .bodyText{width:90%;display:inline-block;font-size:1.1em;max-height:fit-content;overflow:hidden;background:#eee;border-radius:0 0 0 1em}.slideInAnnouncement .inner .bodyText .bodyContent{width:93%;display:inline-block;padding:.5em 1em}.slideInAnnouncement .inner .bodyText .removeContainer{display:inline-block;width:5%;margin-right:2%;float:right;padding-top:.5em;cursor:pointer}.slideInAnnouncement .inner .bodyText .blueText{font-weight:700;color:#00a0f4}.slideInAnnouncement .inner .bodyText .cta{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".socialNotificationContainer{cursor:pointer;display:inline-block;vertical-align:top;text-align:center}.socialNotificationContainer .emptyStateContainer .emptyText{padding-left:15px;padding-right:15px;margin-top:15px;margin-bottom:0;color:#555}.socialNotificationContainer .emptyStateContainer .emptyNotificationRow{padding:15px;cursor:default}.socialNotificationContainer .emptyStateContainer .emptyNotificationRow img{width:50px;float:left}.socialNotificationContainer .emptyStateContainer .emptyNotificationRow .emptyNotificationLineContainer{position:relative;left:70px;top:6px;width:200px}.socialNotificationContainer .emptyStateContainer .emptyNotificationRow .emptyNotificationLineContainer .emptyNotificationLine{width:230px;height:12px;margin-bottom:10px;background:#eee;border-radius:2px}.socialNotificationContainer .emptyStateContainer .emptyNotificationRow .emptyNotificationLineContainer .emptyNotificationLine:nth-of-type(2){width:205px}.socialNotificationContainer .notifyLabel{font-size:.8em;position:relative;top:-10px;color:#006faa}.socialNotificationContainer .glyphicon-bell{color:#006faa}.socialNotificationContainer.fullSocialNotificationContainer{margin-right:5px}.socialNotificationContainer.fullSocialNotificationContainer .glyphicon-bell,.socialNotificationContainer.fullSocialNotificationContainer .notifyLabel{color:#fff}.socialNotificationContainer .notificationBadge{position:absolute;background-color:#da3956;left:20px;top:7px;font-size:.8em;min-width:19px;padding:3px 7px;font-size:.7em;color:#fff;line-height:1;text-align:center;border-radius:10px}.socialNotificationContainer .adminBadge{left:16px!important}.socialNotificationContainer .totalDisplay:hover{opacity:.9}.socialNotificationContainer .popover{display:block!important;width:350px;max-width:350px;left:-158px;top:5px;z-index:10000}.socialNotificationContainer .popover.bottom{margin-top:40px}.socialNotificationContainer .popover-content{padding:0;overflow-y:scroll;max-height:350px;color:#000;font-style:\"museo-sans-rounded\",Helvetica,Arial,sans-serif}.socialNotificationContainer .socialNotificationItem{position:relative;color:#555;font-size:1em;border-bottom:1px solid #ddd;padding:15px}.socialNotificationContainer .socialNotificationItem p{margin-bottom:0;margin-left:26px}.socialNotificationContainer .socialNotificationItem:last-of-type{border:none}.socialNotificationContainer .socialNotificationItem:hover{background:#eee}.socialNotificationContainer .teacherPopover{left:-162px!important}.socialNotificationContainer .adminAvatar,.socialNotificationContainer .owlConstraints{float:left}.socialNotificationContainer .itemSummary{margin-left:10px;width:75%;vertical-align:middle;display:inline-block}.socialNotificationContainer .spinnerBox.placeholder{padding:50px 83px}", ""]);
	
	// exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".contestsPage .pageHeader h1{margin-bottom:5px}.contestsPage .pageHeader .datesHeader{display:block}.contestsPage .pageHeader .changeSchoolLink{margin-left:15px;cursor:pointer}.contestsPage .displayToggleControl{float:right;margin-bottom:30px}.contestsPage .unitText{font-size:1.4em;margin-left:15px}.contestsPage h3{margin-bottom:20px}.contestsPage .gradeLevel{font-size:.8em}.contestsPage .contestContainer{clear:both}.contestsPage .contestContainer .statusText{font-size:1.4em}.contestsPage .contestContainer .celebrationContainer .celebrationImage{height:95px;margin-bottom:15px}.contestsPage .contestContainer .meterSection{height:90px}.contestsPage .contestContainer .thermometerContainer{border:1px dashed #555;width:65%;height:25px;top:53px;position:relative;border-radius:40px}.contestsPage .contestContainer .progressContainer{display:inline-block;height:54px;background-size:auto 54px;position:relative;bottom:29px}.contestsPage .contestContainer .trackerContainer{display:inline-block;float:right}.contestsPage .contestContainer .trackerContainer .goalMet{color:#2b9401}.contestsPage .lowerClass{display:inline-block;vertical-align:top;width:45%}.contestsPage .lowerClass:nth-of-type(2n){margin-left:75px;margin-right:0}.contestsPage .lowerClass .leftContainer{width:200px}.contestsPage .upperClass{margin-bottom:15px}.contestsPage .upperClass .leftContainer{width:250px}.contestsPage .leftContainer img.rankImg{height:40px;width:auto;vertical-align:text-bottom;margin-right:15px}.contestsPage .leftContainer p{width:75%;vertical-align:top;display:inline-block}.contestsPage .rightContainer{vertical-align:top}.contestsPage .leftContainer,.contestsPage .rightContainer{display:inline-block}.contestsPage .dividerArea{width:50%;border:1px solid #ddd;margin:auto;margin-top:50px;margin-bottom:50px}.contestsPage .inviteTeachersContainer{text-align:center;margin-top:30px}.contestsPage .inviteTeachersContainer .buttonPrimary{margin-left:25px}", ""]);
	
	// exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".inviteTeachersModal .modal-body{text-align:left;padding-top:5px}.inviteTeachersModal .inviteRecipients,.inviteTeachersModal .modal-body p{margin-bottom:15px}", ""]);
	
	// exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".differentiationTable{margin-top:10px}.differentiationTable .buttonDropdown.studentListSelector{right:15px}.differentiationTable .studentRow .header{display:inline-block;text-align:center}.differentiationTable .headerRow .rowContent{border-bottom:2px solid #ddd}.differentiationTable .rowContent{border-bottom:1px solid #ddd;padding-bottom:12px;padding-top:12px}.differentiationTable .rowContent .saveLink{display:inline-block;color:#2b9401}.differentiationTable .header{display:inline-block}.differentiationTable .dataContainer{display:inline}.differentiationTable .studentNameCell{width:15%;display:inline-block;vertical-align:middle}.differentiationTable .emptyCell{width:14%;display:inline-block}.differentiationTable .firstEmptyCell{width:28%}.differentiationTable .lastEmptyCell{width:19%}.differentiationTable .academicLevelCell{width:14%;display:inline-block;text-align:left!important}.differentiationTable .academicLevelCell .form-control{width:4.5em}.differentiationTable .quizzesCell{width:34%;display:inline-block}.differentiationTable .quizzesCell .btn-link{display:inline-block;margin-left:10px}.differentiationTable .quizzesCell .goalsSection{width:16em}.differentiationTable .quizzesCell .goalsSection .goalTitle{width:9em}.differentiationTable .practiceCell{width:29%;display:inline-block}.differentiationTable .practiceCell .form-control{width:8em}.differentiationTable .practiceCell .goalsSection{width:15em}.differentiationTable .practiceCell .goalsSection .goalTitle{width:9.5em}.differentiationTable .warmupCell{width:18%;display:inline-block}.differentiationTable .warmupCell .form-control{width:4.5em}.differentiationTable .saveCell{width:8%;display:inline-block}.differentiationTable .infoSection{display:inline-block;vertical-align:middle;text-align:center}.differentiationTable .infoSection .form-control{max-width:90%;position:relative;display:inline-block}.differentiationTable .infoSection .editLink{margin-left:5px;font-size:.8em}.differentiationTable .infoSection .editClassLink{margin-left:0}.differentiationTable .nameSection{display:inline-block}.differentiationTable .overallEdit{display:inline-block;vertical-align:middle;font-size:.8em;width:0;position:relative;right:1.5em}.differentiationTable .goalsSection{margin-left:1em;text-align:left;display:inline-block;vertical-align:middle;font-size:.8em}.differentiationTable .goalsSection .goalContainer{margin-bottom:5px}.differentiationTable .goalsSection .goalContainer .editIcon{display:none}.differentiationTable .goalsSection .goalContainer:hover .editIcon{display:inline-block;cursor:pointer;opacity:.7;margin-left:5px}.differentiationTable .goalsSection .goalTitle{display:inline-block;vertical-align:bottom}.differentiationTable .goalsSection .goalInput{width:4em;display:inline-block;background:transparent;border:none;border-bottom:1px solid #bbb}.differentiationTable .goalsSection span.goalInput{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".orgDropdown .btn-group>button.btn.btn-link:first-child{padding-left:0}.orgDropdown .placeholder .glyphicon{font-size:.8em;margin-left:.5em}", ""]);
	
	// exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".ActivationCodesPreferences a{cursor:pointer}.ActivationCodesPreferences .school-select{margin-top:40px;margin-bottom:40px}.ActivationCodesPreferences .school-select b{margin-bottom:5px}.ActivationCodesPreferences .bulk-entry .action{margin-top:5px;float:right;margin-bottom:20px}.ActivationCodesPreferences .bulk-entry .action a{margin-right:5px}.ActivationCodesPreferences .code-table .infoTooltip{margin-left:3px;display:inline}.ActivationCodesPreferences .code-table .name-field{display:inline-block;width:50%;margin:0}.ActivationCodesPreferences .code-table .status{color:#2f4f4f}.ActivationCodesPreferences .code-table .edit{background-color:#d3d3d3}.ActivationCodesPreferences .code-table .remove{color:#cd5c5c}.ActivationCodesPreferences .code-table .sent{background-color:#f0f8ff}.ActivationCodesPreferences .code-table .error{background-color:rgba(255,163,0,.7098039216)}.ActivationCodesPreferences .sending-alert{margin-top:5px;color:#cd5c5c}", ""]);
	
	// exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".expectationPeriodPreference{position:relative}.expectationPeriodPreference .frequencyRadioBtn{margin-right:5px}.expectationPeriodPreference .inputFrequency{font-size:.8em;font-weight:400}.expectationPeriodPreference .periodStartSelector{font-size:.8em;padding-left:2rem}.expectationPeriodPreference .startDatePicker{margin-left:.5rem;margin-bottom:.7rem;width:9rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.expectationPeriodPreference .saveExpectationPeriod{position:absolute;bottom:0;left:70%;width:100%}.expectationPeriodPreference .disclaimer{font-size:90%;margin-bottom:1rem}", ""]);
	
	// exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".GeneralOrgPreferences h2{margin-top:40px}", ""]);
	
	// exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".gradeLevelExpecationsPreference .gradeLevelSelection{margin-top:15px;margin-bottom:15px}.gradeLevelExpecationsPreference .goalSectionContainer{padding-bottom:10px}.gradeLevelExpecationsPreference .inputPair{display:block;font-size:.8em;font-weight:400}.gradeLevelExpecationsPreference .inputPair.disableClass{opacity:.7}.gradeLevelExpecationsPreference .inputPair .text{display:inline-block;width:45%}.gradeLevelExpecationsPreference .inputPair .goalMetricSelector{width:10%}.gradeLevelExpecationsPreference .inputPair .classSelector,.gradeLevelExpecationsPreference .inputPair input,.gradeLevelExpecationsPreference .inputPair select{display:inline-block;width:40%;border:none;border-bottom:1px solid #ccc}.gradeLevelExpecationsPreference .inputPair .classSelector:focus,.gradeLevelExpecationsPreference .inputPair input:focus,.gradeLevelExpecationsPreference .inputPair select:focus{outline:none}.gradeLevelExpecationsPreference .inputPair .classSelector.withFrequency,.gradeLevelExpecationsPreference .inputPair input.withFrequency,.gradeLevelExpecationsPreference .inputPair select.withFrequency{display:inline-block;width:15%}.gradeLevelExpecationsPreference .inputPair .frequency{display:inline-block;white-space:nowrap;width:15%}.gradeLevelExpecationsPreference .inputPair .classSelector .btn-group{width:100%}.gradeLevelExpecationsPreference .inputPair .classSelector button.btn{padding:0 3px;margin:0;border:0;outline:0;box-shadow:none;text-align:left;width:100%}.gradeLevelExpecationsPreference .inputPair .classSelector button.btn .innerText{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;line-height:1}.gradeLevelExpecationsPreference .inputPair .classSelector button.btn.btn-link{cursor:default;color:inherit}.gradeLevelExpecationsPreference .inputPair .classSelector button.btn.btn-link:hover{text-decoration:none}.gradeLevelExpecationsPreference .inputPair .classSelector .dropdown-menu{min-width:16em}.gradeLevelExpecationsPreference .inputPair .passwordSpinner{display:inline-block}.gradeLevelExpecationsPreference .inputPair .classCodeSpinner{display:inline-block;margin-left:15px}.gradeLevelExpecationsPreference .inputPair .passwordSetByStudent{font-style:italic;padding-right:5px}", ""]);
	
	// exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".RosteringMethodPreference .saveAction{float:right}.RosteringMethodPreference .section{margin-top:20px}", ""]);
	
	// exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".SchoolContestPreference .classSection{margin-bottom:40px}.SchoolContestPreference span{display:block;font-weight:700}.SchoolContestPreference label{margin-right:30px;margin-bottom:15px;width:35%}.SchoolContestPreference .saveAction{text-align:right;margin-right:10%}.SchoolContestPreference .dateSection,.SchoolContestPreference .metricSection{padding-left:15px}", ""]);
	
	// exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".googleClassroomView{padding-left:25px;padding-right:25px}.googleClassroomView .googleClassroomStepOne .googleClassroomText{text-align:center}.googleClassroomView .googleClassroomStepOne .googleClassroomText a{cursor:pointer}.googleClassroomView .googleClassroomStepOne .loadingText{text-align:center}.googleClassroomView .loadingButton{margin:auto;display:block;height:45px;margin-top:20px}.googleClassroomView .googleClassroom{padding-left:30px;padding-right:30px;margin-bottom:20px}.googleClassroomView .googleClassroom .classHeader{border-bottom:1px solid #e5e5e5;padding-bottom:5px;text-align:left;margin-top:5px}.googleClassroomView .googleClassroom .classHeader .displayTitle{display:inline-block}.googleClassroomView .googleClassroom .classHeader .deleteClass{margin-left:6px;cursor:pointer}.googleClassroomView .googleClassroom .classHeader .classGrade.displayTitle,.googleClassroomView .googleClassroom .classHeader .deleteClass.displayTitle{margin-left:15px;margin-right:5px}.googleClassroomView .googleClassroom .classHeader .btn-group{width:80px}.googleClassroomView .googleClassroom .classHeader .btn-group .btn{width:100%}.googleClassroomView .allClassrooms{display:inline-block}.googleClassroomView .allClassrooms .googleSyncTip{font-size:.8em;color:#888;width:60%;margin:auto;margin-bottom:20px}.googleClassroomView .classroomDetail{margin-top:10px}.googleClassroomView .classroomDetail .btn-group .btn{width:100%}.googleClassroomView .classroomDetail .deleteLink{display:inline-block;vertical-align:middle;margin-left:10px;cursor:pointer}.googleClassroomView .classroomDetail .deleteStudent{margin-top:6px;margin-left:5px;cursor:pointer}.googleClassroomView .classroomDetail .studentHeader{padding-right:5px;padding-left:0;font-style:italic}.googleClassroomView .classroomDetail .studentRow{margin-top:10px;text-align:left}.googleClassroomView .classroomDetail .studentInput{display:inline-block;padding-right:10px;padding-left:0;max-width:125px}.googleClassroomView .classroomDetail .studentInput input{border:none}.googleClassroomView .classroomDetail .studentInput input:focus{outline:none}.googleClassroomView .classroomDetail .duplicateMessage{font-size:.8em;display:inline-block}.googleClassroomView .classroomDetail #addRow{float:right;position:static;margin-right:2px}", ""]);
	
	// exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".parentEmailsModal table{font-size:.8em}.parentEmailsModal table .glyphicon-ok{color:#2b9401;left:25px}.parentEmailsModal .studentName{width:200px}.parentEmailsModal .parentEmailTable .errorRow{border:1px solid #da3956}.parentEmailsModal .parentEmailTable .instructionsText{font-size:16px}.parentEmailsModal .parentEmailTable .editLink{cursor:pointer}.parentEmailsModal .parentEmailTable .editLink:hover .glyphicon-pencil{display:inline-block!important;position:relative;left:5px;top:0}", ""]);
	
	// exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".rosterEditStudentLists{min-height:10em;vertical-align:top}.rosterEditStudentLists .title{font-size:1.4em;font-weight:700}.rosterEditStudentLists .title:first-of-type{margin-bottom:5px}.rosterEditStudentLists .studentTitle{width:60%;display:inline-block;text-align:center}.rosterEditStudentLists .classTitle{text-align:center;width:40%;display:inline-block}.rosterEditStudentLists .displayToggle{margin-top:1em;width:100%;text-align:center}.rosterEditStudentLists .studentRowContainer.hideStudents{max-height:0;transform-origin:top;overflow:hidden;opacity:0}.rosterEditStudentLists .studentRowContainer.hideStudents,.rosterEditStudentLists .studentRowContainer.showStudents{transition:max-height 1s ease-in-out,opacity 1s ease-in-out;-moz-transition:max-height 1s ease-in-out,opacity 1s ease-in-out;-webkit-transition:max-height 1s ease-in-out,opacity 1s ease-in-out}.rosterEditStudentLists .studentRowContainer.showStudents{height:unset;max-height:1000em}.rosterEditStudentLists .studentRow{width:100%;display:inline-block;padding:1em 0;border-bottom:1px solid #eee}.rosterEditStudentLists .studentRow .allStudentColumn{width:60%;display:inline-block}.rosterEditStudentLists .studentRow .studentColumn{width:60%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rosterEditStudentLists .studentRow .studentListColumn{width:40%;display:inline-block;vertical-align:top}.rosterEditStudentLists .studentRow .studentListColumn .btn-group{width:100%}.rosterEditStudentLists .studentRow .studentListColumn .btn-group .dropdown-toggle{width:100%;white-space:nowrap;overflow:scroll;text-overflow:ellipsis}.rosterEditStudentLists .buttonContainer{width:100%;text-align:center;margin-top:1em}", ""]);
	
	// exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".rosterContent{padding-bottom:30px}@media(max-width:45rem){.rosterContent{font-size:.9em}}.rosterContent .toolbarContainer{margin-top:4em}.rosterContent .toolbarContainer .selectedItems{float:unset;margin-bottom:1em}.rosterContent .switchToDemo{cursor:pointer}.rosterContent .disableEvents .ellipsisText{pointer-events:none}.rosterContent .overdrawnAlert{color:#c31030;display:block}.rosterContent .overdrawnAlert.classLimit{margin-bottom:2rem}.rosterContent .stageNumber{text-align:center}.rosterContent .archiveClassBtn{margin-top:1em;color:red}.rosterContent .btn-link{cursor:pointer}.rosterContent .deleteButton{color:red}.rosterContent .warningContainer{position:absolute;top:0;right:0}.rosterContent .demoBtnSpinner{margin-left:5em}.rosterContent .studentLoadingSpinner{margin-left:-3em}.rosterContent .orgDropdown{margin-bottom:1em;display:inline-block}.rosterContent .classSectionContainer .studentSectionContainer{max-height:0;transform-origin:top;overflow:hidden;transition:max-height .5s ease-in-out;-moz-transition:max-height .5s ease-in-out;-webkit-transition:max-height .5s ease-in-out}.rosterContent .classSectionContainer .studentSectionContainer.unassignedStudent{overflow:unset}.rosterContent .classSectionContainer .studentSectionContainer .slMenuOptions{margin-top:1em;padding-bottom:1em}.rosterContent .classSectionContainer.collapsed .studentSectionContainer{max-height:0;transform-origin:top;overflow:hidden;transition:max-height .5s ease-in-out;-moz-transition:max-height .5s ease-in-out;-webkit-transition:max-height .5s ease-in-out}.rosterContent .classSectionContainer.expanded .studentSectionContainer{height:unset;max-height:1000em;overflow:hidden;transition:max-height 1s ease-in-out;-moz-transition:max-height 1s ease-in-out;-webkit-transition:max-height 1s ease-in-out}.rosterContent .classSectionContainer.expanded .studentSectionContainer.unassignedStudent{overflow:unset}.rosterContent .suspendedIcon,.rosterContent .userIcon{margin-left:.5em}.rosterContent .suspendedIcon{color:#fdda16}.rosterContent .filterIcon{color:#337ab7;margin-right:.6em;width:25px;text-align:center}.rosterContent .deleteStudentModalContainer{height:fit-content}.rosterContent .deleteStudentModalContainer .options{text-align:center}.rosterContent .deleteStudentModalContainer .btn{margin:10px}.rosterContent .deleteStudentModalContainer .modalBody{text-align:center;margin-left:1em;font-size:20px;margin-bottom:15px;margin-top:15px;color:#555}.rosterContent .deleteStudentModalContainer li{list-style-type:none;font-size:18px;color:#555;margin-bottom:5px}.rosterContent .deleteStudentModalContainer ul{padding:0}.rosterContent .deleteStudentModalContainer .slCount{margin-bottom:15px}.rosterContent .deleteStudentModalContainer .slConfirm{margin-top:15px}.rosterContent .rosterStudent,.rosterContent .rosterStudentList{padding-top:5px;padding-bottom:5px}.rosterContent .rosterStudentList .hideBtn{position:absolute;right:0;top:.5em}.rosterContent .rosterStudentList .hideBtn .glyphicon-menu-up{vertical-align:middle;margin-left:.3em}.rosterContent .rosterStudentList .scrollable-menu{max-height:15em}.rosterContent .rosterStudentList .menuOption{font-size:x-large;text-align:center}.rosterContent .rosterStudentList .editClassBtn{margin-bottom:.3em}.rosterContent .rosterStudentList .btn.btn-link.rowButton{color:#fff}.rosterContent .rosterStudentList .checkboxSection{width:10%}.rosterContent .rosterStudentList .nameSection{width:100%;padding:.6em;border-radius:.3em;background:#00a0f4;color:#fff;box-shadow:0 4px 8px 0 rgba(0,0,0,.2)}.rosterContent .rosterStudentList .nameSection.studentList-0{background:#555}.rosterContent .rosterStudentList .nameSection:hover{cursor:pointer;opacity:.7}.rosterContent .rosterStudentList .nameSection .dropdown-menu{max-height:15em}.rosterContent .rosterStudentList .detailSection{width:5%}.rosterContent .rosterStudentList .detailSection.studentListName{width:95%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-weight:700;font-size:1.1em;text-align:center}.rosterContent .rosterStudentList .detailSection.studentListName .studentInfoText{margin-left:.3em}.rosterContent .rosterStudentList .detailSection.studentListName .studentInfoText .topRow{display:flex;justify-content:center;align-items:center;gap:1rem}.rosterContent .rosterStudentList .detailSection.studentListName .studentInfoText .toolTip{width:fit-content}.rosterContent .rosterStudentList .detailSection.studentListName .schoolName{font-weight:400}.rosterContent .overallLine{padding-bottom:1.5em}.rosterContent .overallLine .overallLineContent{padding-bottom:1em;border-bottom:1px solid #eee}.rosterContent .overallLine .overallLineContent .text-right{float:right}.rosterContent .overallLine .rowButton{font-weight:700}.rosterContent .addStudentLine{padding-top:15px;padding-bottom:15px}.rosterContent .checkboxSection,.rosterContent .detailSection,.rosterContent .nameSection{display:inline-block;vertical-align:middle}.rosterContent .studentListMultiselect{border-bottom:1px solid #eee}.rosterContent .studentListMultiselect .__react_component_tooltip{max-width:30em}.rosterContent .studentListMultiselect .checkboxSection{width:5%}.rosterContent .studentListMultiselect .studentInfo{display:inline-block;width:100%;margin-bottom:1em}.rosterContent .studentListMultiselect .editStudentLinkContainer{text-align:right;margin-right:6.5%}.rosterContent .studentListMultiselect .editStudentLinkContainer .editStudentLink{display:inline-block;width:fit-content}.rosterContent .studentListMultiselect .editStudentLink{overflow:hidden;text-align:right;margin-right:6.5%;max-height:0}.rosterContent .studentListMultiselect .editStudentLink,.rosterContent .studentListMultiselect .editStudentLink.expanded{color:#00a0f4;font-size:1em;cursor:pointer;transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;-webkit-transition:all .3s ease-in-out}.rosterContent .studentListMultiselect .editStudentLink.expanded{padding-bottom:1em;max-height:25em}.rosterContent .studentListMultiselect .topRow{padding-top:1em;width:95%;display:inline-block}.rosterContent .studentListMultiselect .topRow.suspended{opacity:.7}.rosterContent .studentListMultiselect .topRow .statSection{display:inline-block}.rosterContent .studentListMultiselect .topRow .statSection.fullLength{width:70%}.rosterContent .studentListMultiselect .topRow .statSection.truncate{width:68%}.rosterContent .studentListMultiselect .topRow .editIcon{width:2%;display:inline-block;color:#00a0f4}.rosterContent .studentListMultiselect .topRow .collapsedView.collapse{display:inline-block}.rosterContent .studentListMultiselect .topRow .collapsedView.expand,.rosterContent .studentListMultiselect .topRow .expandedView.collapse{display:none}.rosterContent .studentListMultiselect .topRow .expandedView.expand{display:inline-block}.rosterContent .studentListMultiselect .topRow .nameSection{width:25%;white-space:nowrap;position:relative}@media(max-width:45rem){.rosterContent .studentListMultiselect .topRow .nameSection{white-space:unset;text-align:center}}.rosterContent .studentListMultiselect .topRow .blue{color:#00a0f4}.rosterContent .studentListMultiselect .topRow .red{color:red}.rosterContent .studentListMultiselect .topRow .grey{color:#9f9d9d}.rosterContent .studentListMultiselect .topRow .narrow{width:8%!important}.rosterContent .studentListMultiselect .topRow .detailSection{width:30%;padding-top:5px;padding-bottom:5px;font-size:.9em;text-align:center}.rosterContent .studentListMultiselect .topRow .detailSection .noActivity{color:red}.rosterContent .studentListMultiselect .topRow .detailSection.double{width:44%}.rosterContent .studentListMultiselect .topRow .detailSection.text-right{text-align:right}.rosterContent .studentListMultiselect .topRow .detailSection.text-right .btn.btn-link:last-child{padding-right:0}.rosterContent .studentListMultiselect .topRow .detailSection.open-true{border-radius:5px;background-color:#eee}.rosterContent .studentListMultiselect .topRow .detailSection:hover .editIcon{visibility:visible}.rosterContent .studentListMultiselect .topRow .detailSection .editIcon{font-size:.8em;visibility:hidden;position:relative;left:10px;width:0}.rosterContent .studentListMultiselect .topRow .detailSection .gradeLevelContainer{display:flex;justify-content:center;gap:1rem}.rosterContent .studentListMultiselect .topRow .detailSection.toggleButton{color:#bbb}.rosterContent .studentListMultiselect .topRow .detailSection.toggleButton .glyphicon-chevron-down{cursor:pointer}.rosterContent .studentListMultiselect .topRow .studentInfo.unassignedStudent .nameSection{width:50%;text-align:center}.rosterContent .studentListMultiselect .topRow .studentInfo.unassignedStudent .classSelector{display:inline-block;width:30%;text-align:center}.rosterContent .studentListMultiselect .topRow .studentInfo.unassignedStudent .saveButton{width:10%;display:inline-block}.rosterContent .studentListMultiselect .topRow .studentInfo.unassignedStudent .scrollable-menu{z-index:20000}.rosterContent div.studentListMultiselect:last-child{border-bottom:none}.rosterContent .btn.btn-link.rowButton{padding-top:0;padding-bottom:0}.rosterContent .btn.btn-link.rowButton:focus{outline:none}.rosterContent .btn.btn-link.textColorButton{margin-top:1em;color:inherit}.rosterContent .btn.btn-link.textColorButton .glyphicon{position:relative;top:2px;color:#bbb}.rosterContent .btn.btn-link.textColorButton:focus{outline:none}.rosterContent .btn.btn-link.noPaddingButton{padding:0}.rosterContent .studentSectionHeader{margin-bottom:10px}.rosterContent .userGlyph{margin-left:1rem}.rosterContent .studentListMultiselect .editSection{position:relative;opacity:0;overflow:visible;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);height:0;padding:0;margin:0}.rosterContent .studentListMultiselect .editSection.drawerOpen{border-radius:5px;height:27em;padding:2em;margin:1em .1em;opacity:1;transition:all 1s ease-in-out .1s;-moz-transition:all 1s ease-in-out .1s;-webkit-transition:all 1s ease-in-out .1s}.rosterContent .studentListMultiselect .editSection.drawerClosed{height:0;padding:0;margin:0;opacity:0;transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s;-moz-transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s;-webkit-transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s}.rosterContent .disclaimer{margin-top:1.4rem;margin-left:1rem;font-size:90%;text-align:center}.rosterContent .editSection{position:relative;opacity:0;overflow:visible;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);height:0;padding:0;margin:0}.rosterContent .editSection.drawerOpen{border-radius:5px;height:27em;padding:2em;margin:1em .1em;opacity:1;transition:all 1s ease-in-out .1s;-moz-transition:all 1s ease-in-out .1s;-webkit-transition:all 1s ease-in-out .1s}.rosterContent .editSection.drawerOpen.extraHeight{height:34em}.rosterContent .editSection.drawerClosed{height:0;padding:0;margin:0;opacity:0;transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s;-moz-transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s;-webkit-transition:all .5s ease-in-out .1s,opacity .2s ease-in-out .1s}.rosterContent .editSection.drawerClosed .firstCol,.rosterContent .editSection.drawerClosed .fourthCol,.rosterContent .editSection.drawerClosed .secondCol,.rosterContent .editSection.drawerClosed .thirdCol{height:0}.rosterContent .editSection.drawerClosed .buttons{display:none}.rosterContent .editSection .buttons{display:unset}.rosterContent .editSection .firstCol,.rosterContent .editSection .fourthCol,.rosterContent .editSection .secondCol,.rosterContent .editSection .thirdCol{display:inline-block;vertical-align:top}.rosterContent .editSection .firstCol,.rosterContent .editSection .secondCol{width:35%;margin-right:5%}.rosterContent .editSection .accountInfo,.rosterContent .editSection .studentLevels{min-height:8em}.rosterContent .editSection .studentLevels{margin-top:1.5em}.rosterContent .editSection .thirdCol{width:20%}.rosterContent .editSection .hideBtn{float:right}.rosterContent .editSection .hideBtn .glyphicon-menu-up{vertical-align:middle;margin-left:.3em}.rosterContent .editSection .fourthCol{width:10%}.rosterContent .editSection .frequencyRadioBtn{margin-right:5px}.rosterContent .editSection .inputFrequency{font-size:.8em;font-weight:400}.rosterContent .editSection .periodStartSelector{font-size:.8em;padding-left:2rem}.rosterContent .editSection .startDatePicker{margin-left:.5rem;margin-bottom:.7rem;width:9rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.rosterContent .editSection .goalSectionContainer{padding-bottom:10px}.rosterContent .editSection .saveButton{margin-bottom:1em;margin-right:1em;padding:.6em 2em;font-size:.8em}.rosterContent .editSection .buttonDanger{padding:.6em 2em;font-size:.8em}.rosterContent .editSection .btnContainer{position:absolute;bottom:.5em;right:2em}.rosterContent .editSection .btnContainer .spinner{left:-1em!important;top:-2em!important}.rosterContent .editSection .passwordDisplayInput .passwordInput{background-color:#fff;width:30%}.rosterContent .editSection .passwordDisplayInput a{float:right}.rosterContent .editSection .firstCol .inputPair .text{display:inline-block;width:40%}.rosterContent .editSection .firstCol .inputPair .classSelector,.rosterContent .editSection .firstCol .inputPair input,.rosterContent .editSection .firstCol .inputPair select{display:inline-block;width:50%;border:none;border-bottom:1px solid #ccc}.rosterContent .editSection .firstCol .inputPair .classSelector:focus,.rosterContent .editSection .firstCol .inputPair input:focus,.rosterContent .editSection .firstCol .inputPair select:focus{outline:none}.rosterContent .editSection .firstCol .inputPair .classSelector.withFrequency,.rosterContent .editSection .firstCol .inputPair input.withFrequency,.rosterContent .editSection .firstCol .inputPair select.withFrequency{display:inline-block;width:15%}.rosterContent .editSection .firstCol .inputPair .passwordDisplayInput .passwordInput{background-color:#fff;width:30%}.rosterContent .editSection .firstCol .inputPair .passwordDisplayInput a{float:right}.rosterContent .editSection .inputPair{display:block;font-size:.8em;font-weight:400}.rosterContent .editSection .inputPair.disableClass{opacity:.7}.rosterContent .editSection .inputPair .text{display:inline-block;width:60%}.rosterContent .editSection .inputPair .goalMetricSelector{width:10%}.rosterContent .editSection .inputPair .classSelector,.rosterContent .editSection .inputPair input,.rosterContent .editSection .inputPair select{display:inline-block;width:40%;border:none;border-bottom:1px solid #ccc}.rosterContent .editSection .inputPair .classSelector:focus,.rosterContent .editSection .inputPair input:focus,.rosterContent .editSection .inputPair select:focus{outline:none}.rosterContent .editSection .inputPair .classSelector.withFrequency,.rosterContent .editSection .inputPair input.withFrequency,.rosterContent .editSection .inputPair select.withFrequency{display:inline-block;width:15%}.rosterContent .editSection .inputPair .frequency{display:inline-block;white-space:nowrap;width:15%}.rosterContent .editSection .inputPair .classSelector .btn-group{width:100%}.rosterContent .editSection .inputPair .classSelector button.btn{padding:0 3px;margin:0;border:0;outline:0;box-shadow:none;text-align:left;width:100%}.rosterContent .editSection .inputPair .classSelector button.btn .innerText{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;line-height:1}.rosterContent .editSection .inputPair .classSelector button.btn.btn-link{cursor:default;color:inherit}.rosterContent .editSection .inputPair .classSelector button.btn.btn-link:hover{text-decoration:none}.rosterContent .editSection .inputPair .classSelector .dropdown-menu{min-width:16em}.rosterContent .editSection .inputPair .passwordSpinner{display:inline-block}.rosterContent .editSection .inputPair .classCodeSpinner{display:inline-block;margin-left:15px}.rosterContent .editSection .inputPair .classCodeLink{margin-left:.6rem}.rosterContent .editSection .inputPair .helpSectionContainer{position:relative;top:-.09rem}.rosterContent .editSection .inputPair .classCodeLink:hover{margin-left:.6rem;cursor:pointer}.rosterContent .editSection .inputPair .passwordSetByStudent{font-style:italic;padding-right:5px}.rosterContent .studentDisplay,.rosterContent .studentDisplay .studentOwlvatar,.rosterContent .studentDisplay .textContent{display:inline-block;vertical-align:middle}.rosterContent .studentGroup{display:inline-block;margin-left:.3em}.rosterContent .braveCheckbox{display:inline-block;vertical-align:middle;margin-right:.6em}.rosterContent .addRosterClasses .colHeader{margin-bottom:5px;font-weight:700}.rosterContent .addRosterClasses .classRow{margin-bottom:10px}.rosterContent .addRosterClasses .nameCol{display:inline-block;width:330px;margin-right:10px}.rosterContent .addRosterClasses .gradeLevelCol{display:inline-block;width:100px;margin-right:10px}.rosterContent .addRosterClasses .removeLink{display:inline-block;padding:0;color:#c31030}.rosterContent .addRosterClasses .removeLink:focus{outline:none}.rosterContent .addRosterClasses .addLink{padding-right:0}.rosterContent .addRosterClasses .addLink:focus{outline:none}.rosterContent .addStudentMethod{padding:15px}.rosterContent .manualAddStudents .textAreaForm{width:60%;margin-right:2%;display:inline-block;vertical-align:top}.rosterContent .manualAddStudents .rightOps{width:38%;display:inline-block;vertical-align:top}.rosterContent .manualAddStudents .gradeLevelContainer{width:6em;margin-bottom:6px}.rosterContent .manualAddStudents .firstNamesOnly{font-size:.8em}.rosterContent .manualAddStudents .manualClass{margin-bottom:10px}.rosterContent .logReadingModal .studentsSelectedSection{margin-top:20px}.rosterContent .logReadingModal .toSection{left:5px}.rosterContent .logReadingModal .listOfStudents{margin-left:5px;margin-bottom:0;width:82%}.rosterContent .smartBookSearch{width:75%;margin-left:7.5%}.rosterContent .smartBookSearch .manualForm .title{width:29%}.rosterContent .studentsSelectedSection .listOfStudents{display:inline-block;font-size:.8em;margin-top:3px;margin-left:10px;margin-bottom:15px;border:1px solid #ddd;background-color:#eee;border-radius:5px;padding-left:5px;padding-bottom:5px;padding-top:2px;width:auto}.rosterContent .studentsSelectedSection .comma{margin-right:5px;margin-left:1px}.rosterContent .studentsSelectedSection .toSection{float:left;position:relative;font-weight:700;margin-right:12px}.rosterContent .sendNote{padding-left:20px}.rosterContent .sendNote .buttonSuccess{margin-top:15px;display:block!important}.rosterContent .sendNote textArea{width:87%;position:relative;top:5px}.rosterContent .sendNote .modalErrors,.rosterContent .sendNote textArea{margin-left:50px}.rosterContent .sendNote .sendNoteForm label{display:block;margin-bottom:5px;position:relative;float:left}.rosterContent .sendNote .errors-lite{margin-left:33px}.rosterContent .awardCoins{padding-left:20px}.rosterContent .awardCoins .coinsInputTitle{font-weight:700;color:#555!important;margin-bottom:0!important}.rosterContent .awardCoins .awardCoinsAmountSection{float:left}.rosterContent .awardCoins .awardCoinsAmountSection label{margin-top:5px;font-weight:400;cursor:pointer;font-size:.8em}.rosterContent .awardCoins .awardCoinsAmountSection input{margin-right:5px}.rosterContent .awardCoins .iconImage{width:26px;float:left;margin-right:5px;padding-top:3px}.rosterContent .awardCoins .selectCoins{width:72%;margin-right:20px;font-size:.8em}.rosterContent .awardCoins .coinsReason{width:59%!important;margin-bottom:20px;font-size:.8em}.rosterContent .awardCoins .buttonSuccess{margin-top:20px}.rosterContent .studentLogins .headerRow,.rosterContent .studentLogins .studentRow{padding:.8rem;border-top:1px solid #ddd}.rosterContent .studentLogins .headerRow{font-weight:700}.rosterContent .studentLogins .loginInstructionSection,.rosterContent .studentLogins .printSection,.rosterContent .studentLogins .sendParentEmailSection{display:inline-block;vertical-align:top}.rosterContent .studentLogins .loginInstructionSection{width:62%}.rosterContent .studentLogins .printSection{margin-bottom:15px;border-right:1px solid #ddd}.rosterContent .studentLogins .printSection .helpSectionLink{margin-left:5px;float:none}.rosterContent .studentLogins .printSection,.rosterContent .studentLogins .sendParentEmailSection{width:50%}.rosterContent .studentLogins .sendParentEmailSection{padding-left:130px}.rosterContent .studentLogins .sendParentEmailSection a{cursor:pointer;display:block}.rosterContent .studentLogins .demoIndicator{font-size:.7em;background-color:#70d544;color:#fff;border-radius:30px;margin-right:.5rem;padding:.3rem;float:left}.rosterContent .studentLogins .name,.rosterContent .studentLogins .password,.rosterContent .studentLogins .username{position:relative;top:2px;display:inline-block;min-height:22px;line-height:1;vertical-align:top}.rosterContent .studentLogins .validatingInput .errorDisplay{padding-top:10px}.rosterContent .studentLogins .password .ellipsisText,.rosterContent .studentLogins .username .ellipsisText{display:inline-block;width:150px}.rosterContent .studentLogins .editHelperText{font-size:.8em;color:#888;font-weight:400;margin-left:.5rem}.rosterContent .studentLogins .name{padding-left:2rem;width:40%}.rosterContent .studentLogins .password,.rosterContent .studentLogins .username{width:30%}.rosterContent .studentLogins .passwordInput,.rosterContent .studentLogins .usernameInput{width:100%;height:3rem;padding-left:.5rem;margin-top:-.5rem;margin-bottom:-.5rem}.rosterContent .studentLogins .username .validatingInput{width:90%;display:inline-block}.rosterContent .studentLogins .password .validatingInput{width:60%;display:inline-block}.rosterContent .studentLogins .enterToSubmit{width:32%;display:inline-block;font-size:.7em;line-height:1;vertical-align:top;margin-left:1rem}.rosterContent .studentLogins .editable .glyphicon{font-size:.8em;vertical-align:top;margin-top:.4rem}.rosterContent .studentLogins .editable .editIcon{display:none}.rosterContent .studentLogins .editable:hover .editIcon{display:inline-block;cursor:pointer;opacity:.7}.rosterContent .studentLogins .editable .errorIcon{color:#c31030}.rosterContent .studentLogins .editable .errorIcon:hover{cursor:pointer}.rosterContent .addRosterStudents .notice{border:2.5px dashed #a0e881;padding:15px;margin-bottom:25px}.rosterContent .addRosterStudents .loginMethod img{margin-bottom:25px;width:100%}.rosterContent .addRosterStudents .loginMethod img:first-of-type{margin-bottom:30px}.rosterContent .addRosterStudents .loginMethod .stepsImg{display:inline-block;width:55%;vertical-align:top;border:1px solid #ddd}.rosterContent .addRosterStudents .loginMethod .infoContainer{display:inline-block;width:40%;margin-left:.3em}.rosterContent .addRosterStudents .loginMethod .infoContainer .studentSteps{display:inline-block;margin-top:15px}.rosterContent .addRosterStudents .loginMethod .infoContainer .header{font-weight:700}.rosterContent .addRosterStudents .loginMethod .infoContainer ol{padding-left:15px}.rosterContent .addRosterStudents .loginMethod .infoContainer ol span{position:relative;right:15px}", ""]);
	
	// exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".schoolInfoModal .errorDisplay{padding-top:0;padding-bottom:5px}.schoolInfoModal .innerWrap{padding-bottom:190px}.schoolInfoModal .toggleView{text-align:right;font-size:.8em;margin-bottom:5px}.schoolInfoModal .modal-dialog{width:500px}.schoolInfoModal .saveBtn{margin-left:auto;margin-right:auto;margin-top:10px;display:block;width:80px}.schoolInfoModal .bannerImg{position:absolute;width:100%;bottom:0;left:0;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.schoolInfoModal .aboveFieldsText{margin-bottom:17.5px}.schoolInfoModal .searchOpDisplay{border-top:1px solid #ddd;padding-top:10px}.schoolInfoModal .teacherTestimonial{margin-top:6rem}.schoolInfoModal .teacherTestimonial .educatorImg{float:left;width:10rem;margin-right:2rem}.schoolInfoModal .teacherTestimonial .quote{width:75%;margin-left:25%;font-size:.8em}.schoolInfoModal .teacherTestimonial .educatorInfo{text-align:center;border-bottom:1px solid #bbb;margin-bottom:1rem}.schoolInfoModal .teacherTestimonial .quoteImg{width:4rem;margin-right:1rem;margin-bottom:1rem;float:left}.schoolInfoModal .teacherTestimonial .quoteText{font-style:italic;width:98%}", ""]);
	
	// exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentSubgroups .title{font-size:1.4em}.studentSubgroups .title:first-of-type{margin-bottom:5px}.studentSubgroups .buttonSuccess,.studentSubgroups .section{margin-bottom:15px}.studentSubgroups .buttonSuccess{margin-top:25px}.studentSubgroups label input{margin-right:5px}.studentSubgroups .form-control{width:40%;display:inline-block}.studentSubgroups .newGroupContainer .buttonDropdown{margin-left:15px}.studentSubgroups .buttonDropdown .dropdown-toggle{padding-left:0}.studentSubgroups .buttonDropdown .dropdown-toggle span.glyphicon{margin-right:5px}.studentSubgroups .buttonDropdown .buttonDropdown .scrollable-menu li{margin-right:0}.studentSubgroups .groupInformation .glyphicon{vertical-align:middle;margin-right:5px}", ""]);
	
	// exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".addStudentsClassCode{padding-left:25px;padding-right:25px}.addStudentsClassCode .classCodeTable.table{margin-top:20px;margin-bottom:25px}.addStudentsClassCode .classCodeTable.table tr{border-bottom:1px solid #ddd}.addStudentsClassCode .classCodeTable.table td.link a{font-size:.8em}.addStudentsClassCode .classCodeTable.table td,.addStudentsClassCode .classCodeTable.table th{padding:2px 8px;min-width:7.5em}", ""]);
	
	// exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".addStudentsMethodSelect{margin-bottom:10px}.addStudentsMethodSelect .methodOptions{margin-left:auto;margin-right:auto;text-align:center}.addStudentsMethodSelect .largeObject{display:inline-block;vertical-align:top;width:13rem;margin:1rem}.addStudentsMethodSelect .methodObjectContent{text-align:center;width:10rem;margin:2rem auto}.addStudentsMethodSelect .selectedOption{background:#c0f2aa}", ""]);
	
	// exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mappingControl .leftItem,.mappingControl .rightItem{text-align:center;min-width:150px;padding-bottom:1rem;cursor:pointer}.mappingControl .leftItem>div,.mappingControl .rightItem>div{border:1px solid #ddd;border-radius:5px;padding:5px}.mappingControl .leftItem:hover,.mappingControl .rightItem:hover{opacity:.7}.mappingControl .leftItem.active>div,.mappingControl .rightItem.active>div{background-color:#defad2}.mappingControl .joinItem{width:80px;text-align:center}.mappingControl .joinItem button{height:32px;margin-bottom:1rem}.mappingControl .joinItem button .showNormal{display:inline}.mappingControl .joinItem button .showHover,.mappingControl .joinItem button:hover .showNormal{display:none}.mappingControl .joinItem button:hover .showHover{display:inline}.mappingControl th{text-align:center;padding-bottom:5px}", ""]);
	
	// exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".rosterUploadButtons{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".rosterUploadProgressMeter{overflow:hidden;margin:15px auto 10px;width:727px;border:1px solid #aaa;border-radius:20px;font-size:14px}.rosterUploadProgressMeter .stage{display:inline-block;float:left;border-right:1px solid #aaa;padding:8px;width:145px}.rosterUploadProgressMeter .stage:last-child{border-right:none}.rosterUploadProgressMeter .stage.past{background-color:#a0e881}.rosterUploadProgressMeter .stage.current{background-color:#defad2}.rosterUploadProgressMeter .stageNumber{display:inline-block;width:20px;height:20px;border-radius:20px;padding-left:1px;padding-top:1px;margin-right:5px;position:relative;color:#fff;background-color:#555;font-weight:700}.rosterUploadProgressMeter .stageName{display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".ssoRosterReview .selectionOptions{margin-bottom:15px}.ssoRosterReview .selectionOptions .classSection{display:inline-block;width:100%}.ssoRosterReview .selectionOptions .classSection .selectionOp{display:block;width:auto}.ssoRosterReview .loginMethod img{margin-bottom:25px;width:100%}.ssoRosterReview .loginMethod img:first-of-type{margin-bottom:30px}.ssoRosterReview .loginMethod .stepsImg{display:inline-block;width:55%;vertical-align:top;border:1px solid #ddd}.ssoRosterReview .loginMethod .infoContainer{display:inline-block;width:40%;margin-left:5%}.ssoRosterReview .loginMethod .infoContainer .studentSteps{display:inline-block;margin-top:15px}.ssoRosterReview .loginMethod .infoContainer .header{font-weight:700}.ssoRosterReview .loginMethod .infoContainer ol{padding-left:15px}.ssoRosterReview .loginMethod .infoContainer ol span{position:relative;right:15px}.ssoRosterReview .orDivider{text-align:center}.ssoRosterReview .notice{border:2.5px dashed #a0e881;padding:15px;margin-bottom:25px}.ssoRosterReview .nextSection{left:90%;position:relative}.ssoRosterReview .nextSection .buttonPrimary,.ssoRosterReview .nextSection .buttonSuccess{top:0!important}.ssoRosterReview .finalStep{left:79%}.ssoRosterReview .selectionOp{display:inline-block;width:47%;margin-right:3%;line-height:1.3;margin-bottom:5px}.ssoRosterReview .selectionOp .double{zoom:1.8;transform:scale(1.8);-ms-transform:scale(1.8);-webkit-transform:scale(1.8);-o-transform:scale(1.8);-moz-transform:scale(1.8);transform-origin:0 0;-ms-transform-origin:0 0;-webkit-transform-origin:0 0;-o-transform-origin:0 0;-moz-transform-origin:0 0}.ssoRosterReview .selectionOp .selectionLabel{vertical-align:middle;display:inline-block;margin-left:10px;cursor:pointer;width:60%;vertical-align:sub}.ssoRosterReview .selectionOp .selectionLabel,.ssoRosterReview .selectionOp .selectionLabel.student{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.ssoRosterReview .selectionOp .selectionCheckbox{vertical-align:middle;position:relative;bottom:3px}.ssoRosterReview .selectionOp .subLine{color:#999;vertical-align:middle;cursor:pointer;padding-left:2%}.ssoRosterReview .continueButton{position:relative}.ssoRosterReview .sectionName{margin-top:15px;margin-bottom:5px}.ssoRosterReview .sectionName .control{font-size:.8em;cursor:pointer;margin-left:10px}.ssoRosterReview .studentOptions{column-count:3}.ssoRosterReview .stageHeader{text-align:center;position:relative;margin-bottom:20px}.ssoRosterReview .stageHeader .backLink{position:absolute;left:0;top:0}", ""]);
	
	// exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".uploadRoster .uploadPair{margin-left:29.3%;margin-top:10px;width:500px}.uploadRoster .uploadPair .uploadField{width:70%;float:left}.uploadRoster .uploadPair .uploadSubmit.btn{margin-top:0;margin-left:7px;height:35px;clear:none;min-width:85px!important}.uploadRoster .explanation{margin-top:20px;margin-bottom:30px;margin-left:4%}.uploadRoster .explanation img{border:1px solid #aaa;margin-bottom:5px}.uploadRoster .explanation .textExplanation{margin:auto;margin-bottom:20px;width:85%}.uploadRoster .explanation .formatText{display:block}.uploadRoster .exampleTableSection{width:85%;margin:auto}.uploadRoster .uploadManager{margin-bottom:30px}.uploadRoster .orgTransferConfirm{margin-left:auto;margin-right:auto;width:50%}.uploadRoster .uploadingWait{position:relative;height:180px;text-align:center}.uploadRoster .uploadingWait .spinnerBox{margin-top:34px}.uploadRoster table.table.csvConfirmTable{font-size:12pt}.uploadRoster table.table.csvConfirmTable.horiz th{border-bottom-width:2px;min-width:130px}.uploadRoster table.table.csvConfirmTable.horiz th select{font-size:12pt}.uploadRoster table.table.csvConfirmTable td,.uploadRoster table.table.csvConfirmTable th{vertical-align:middle}.uploadRoster table.table.csvConfirmTable td.lim30,.uploadRoster table.table.csvConfirmTable th.lim30{max-width:30%}.uploadRoster table.table.csvConfirmTable a.hideEdit,.uploadRoster table.table.csvConfirmTable a.showEdit{font-weight:400}.uploadRoster table.table.csvConfirmTable th.editCol{width:50%}.uploadRoster table.table.csvConfirmTable .csvSampleText{font-family:monospace}.uploadRoster table.table.csvConfirmTable input.form-control,.uploadRoster table.table.csvConfirmTable select.form-control{height:32px;padding:3px 10px}.uploadRoster table.table.csvConfirmTable select.form-control.unrecognized{border:2px solid #c31030}.uploadRoster .tableWrap{max-width:100%;overflow-x:scroll;margin-bottom:20px}.uploadRoster .tableWrap table.table{margin-bottom:5px}.uploadRoster .alertMark{color:#c54e14}.uploadRoster .greenMark{color:#2b9401}.uploadRoster .unrecognized{color:#c31030}", ""]);
	
	// exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".classPage .pageHeader{position:relative;z-index:15}.classPage .viewControls{position:relative;z-index:10000;float:right}.classPage .viewControls.withDropdown{margin-top:-36px}.classPage .center{text-align:center}.classPage .smallStudentList{font-size:16px;margin-left:5px}.classPage .classTree{position:relative;margin-top:-55px}.classPage .emptyStateContainer .emptyStateContent{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".classTree .studentRows{position:relative;height:185px}.classTree .studentRows .owlLine{margin-left:125px}.classTree .studentRows .adjustedAvatarAndName{margin-top:-15px;line-height:1}.classTree .studentRows .avatarAndName{position:relative;display:inline-block;vertical-align:top;text-align:center;width:115px;float:left}.classTree .studentRows .avatarAndName .studentName{display:flex;flex-direction:column}.classTree .studentRows .avatarAndName .studentName .owlLevel{font-size:.8em;margin-top:.4em;color:#747474}.classTree .studentRows .avatarAndName .owlConstraintsInner{pointer-events:none}.classTree .studentRows .avatarAndName:first-child{top:28px}.classTree .studentRows .avatarAndName:nth-child(2){top:21px}.classTree .studentRows .avatarAndName:nth-child(2) .owlHouse{margin-top:23px}.classTree .studentRows .avatarAndName:nth-child(3){top:13px}.classTree .studentRows .avatarAndName:nth-child(3) .owlHouse{margin-top:27px}.classTree .studentRows .avatarAndName:nth-child(4){top:16px}.classTree .studentRows .avatarAndName:nth-child(4) .owlHouse{margin-top:29px}.classTree .studentRows .avatarAndName:nth-child(5){top:25px}.classTree .studentRows .avatarAndName:nth-child(5) .owlHouse{margin-top:29px}.classTree .studentRows .avatarAndName:nth-child(6){top:41px}.classTree .studentRows .avatarAndName:nth-child(6) .owlHouse{margin-top:27px}.classTree .studentRows .avatarAndName .owlvatarStandin{position:relative;z-index:1}.classTree .treeBranchImg{pointer-events:none;position:absolute;top:0;left:0}.classTree .treeTopContainer{position:relative;display:inline-block;margin-bottom:-30px;z-index:10}.classTree .treeRootsContainer img{position:relative;bottom:25px;z-index:5}", ""]);
	
	// exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".creditCardInput ul.errors{font-style:italic;font-weight:700;color:#b00;list-style-type:none}.creditCardInput .ccLogo{width:3rem;display:inline-block;margin-right:.5rem}.creditCardInput .securityNote{font-size:.8em;color:#aaa;float:right}.creditCardInput label{display:inline-block;font-weight:400}.creditCardInput label .form-control{margin-top:1rem}.creditCardInput .creditCardInfoLine{margin-bottom:2rem}.creditCardInput .numberField{width:100%}.creditCardInput .billingZipField,.creditCardInput .cvcField,.creditCardInput .expMonthField,.creditCardInput .expYearField{width:48%}.creditCardInput .cvcField,.creditCardInput .expMonthField{margin-right:4%}", ""]);
	
	// exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".purchaseOrderInput .contactInfoField{font-weight:400;width:100%;margin-bottom:2rem}.purchaseOrderInput .contactInfoField .form-control{margin-top:1rem}", ""]);
	
	// exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookActionSection.studentDashboard .actionImage{display:inline-block;margin-left:10px;margin-bottom:15px;margin-right:10px;width:40px}.bookActionSection.studentDashboard .actionText{display:inline-block;margin-right:5px}.bookActionSection.studentDashboard .findBookHeader{display:inline-block}.bookActionSection .suggestedBooksArea{margin-left:10px}.bookActionSection .bookActionModal{margin-top:30px}.bookActionSection .bookActionModal .subtaskIcon{margin-left:10px}.bookActionSection .bookActionModal .greenIcon{color:green}.bookActionSection .bookActionModal .redIcon{color:red}.bookActionSection .bookActionModal .grayIcon{color:gray}.bookActionSection .bookActionModal .selectedBookHeader{text-align:center;margin-bottom:15px;margin-right:50px;display:inline-block;width:40%;vertical-align:top}.bookActionSection .bookActionModal .selectedBookHeader .bookCover img{width:60px}.bookActionSection .bookActionModal .selectedBookHeader .bookDetails{max-width:350px;padding-left:15px}.bookActionSection .bookActionModal .selectedBookHeader .coverWrap{margin-right:0!important;display:block!important;width:auto!important}.bookActionSection .bookActionModal .selectedBookHeader .coverWrap .cover{margin-bottom:10px}.bookActionSection .bookActionModal .selectedBookHeader .aboutWrap{padding-left:0!important}.bookActionSection .bookActionModal .selectedBookHeader .aboutWrap .title{margin-bottom:0!important}.bookActionSection .bookActionModal .selectedBookHeader .aboutWrap .author{font-size:.8em}.bookActionSection .bookActionModal .finishedQuestion{font-size:1.4em;text-align:center}.bookActionSection .bookActionModal .primaryOnly{text-align:center}.bookActionSection .bookActionModal .primaryOnly .actionOp{width:130px}.bookActionSection .bookActionModal .primaryOnly img{margin:0 auto}.bookActionSection .bookActionModal .primaryOnly .backLink{left:145px}.bookActionSection .bookActionModal .bookOptions{position:relative;display:inline-block;vertical-align:text-bottom}.bookActionSection .bookActionModal .bookOptions .backLink{position:absolute;top:22px;left:50px}.bookActionSection .bookActionModal .bookOptions .primaryOnly .backLink{left:145px}.bookActionSection .bookActionModal .bookOptions .primaryOptions{width:60%;display:inline-block}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp{display:inline-block;color:inherit;text-decoration:none}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp img{width:85px;height:auto;display:block;margin-bottom:5px}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp .questionOp{min-width:140px;vertical-align:bottom}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.questionOp,.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.quizOp{margin-left:15px}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.questionOp.soloOp,.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.quizOp.soloOp{margin-right:8px}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.questionOp.draftLink img,.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.quizOp.draftLink img{margin-left:auto;margin-right:auto}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp.quizOp{display:inline-block}.bookActionSection .bookActionModal .bookOptions .primaryOptions a.actionOp:hover{opacity:.7}.bookActionSection .bookActionModal .bookOptions .primaryOptions .logReadingOp{margin-right:25px}.bookActionSection .bookActionModal .bookOptions .primaryOptions .quizCompleted img,.bookActionSection .bookActionModal .bookOptions .primaryOptions .quizDraft img{margin-left:auto;margin-right:auto}.bookActionSection .bookActionModal .bookOptions .primaryOptions .quizCompleted{cursor:default}.bookActionSection .bookActionModal .bookOptions .primaryOptions .quizCompleted:hover{opacity:1!important}.bookActionSection .bookActionModal .bookOptions .primaryOptions .quizCompleted .quizCompletedText{font-size:.8em;display:inline-block;width:95px;text-align:center}.bookActionSection .bookActionModal .bookOptions .primaryOptions.quizCompleted .verticalDivider,.bookActionSection .bookActionModal .bookOptions .primaryOptions.quizDraft .verticalDivider,.bookActionSection .bookActionModal .bookOptions .primaryOptions.stillReading .verticalDivider{left:38px}.bookActionSection .bookActionModal .bookOptions .primaryOptions .verticalDivider{border-left:1px solid #bbb;left:30px;height:50px}.bookActionSection .bookActionModal .bookOptions .secondaryOptions{vertical-align:bottom;margin:auto}.bookActionSection .bookActionModal .bookOptions .secondaryOptions a.actionOp{margin-bottom:15px;display:block;color:inherit;text-decoration:none}.bookActionSection .bookActionModal .bookOptions .secondaryOptions a.actionOp:hover{opacity:.7}.bookActionSection .bookActionModal .bookOptions .secondaryOptions a.actionOp img{width:25px;margin-right:10px}.bookActionSection .bookActionModal .bookOptions .secondaryOptions a.actionOp:last-of-type{margin-bottom:0!important}.bookActionSection .bookActionModal .bookOptions .secondaryOptions .actionsContainer{display:inline-block;vertical-align:top}.bookActionSection .bookActionModal .bookOptions .secondaryOptions .actionsContainer:first-of-type{margin-right:30px}.bookActionSection .bookSearchBox .smartBookSearch{margin-left:10px;margin-bottom:20px}.bookActionSection .secondaryLabel{border-bottom:1px solid #ddd;display:inline-block;margin-left:5px;padding-right:5px;padding-left:5px}.bookActionSection .suggestedBooksArea .shelfLinks{display:inline-block;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookCover{display:inline-block;position:relative}.bookCover .emptyCoverTitle{width:85px;position:absolute;left:14px;color:#fff;top:20px;font-size:.8em;overflow:hidden;max-height:78%}.bookCover .bookDetails{vertical-align:middle;padding-left:10px;display:inline-block;text-align:left;width:220px}.bookCover .title{font-style:italic;display:block;word-break:break-word}.bookCover .author{display:inline-block;word-break:break-word}.bookCover .quizTakenIcon{box-shadow:0 2px 3px rgba(0,0,0,.55);border-radius:16px}.bookCover .quizTakenIcon,.bookCover .quizTakenIconSquare{float:right;width:32px;height:auto;position:absolute;right:-16px;top:-16px}", ""]);
	
	// exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookDisplay{display:block;max-width:100%}.bookDisplay .title{font-style:italic;padding-right:.5rem;margin-bottom:5px}.bookDisplay .title.titleURL{font-style:normal}.bookDisplay .title .linkURL{margin-left:.5em}.bookDisplay .bookURL{font-size:.8em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bookDisplay .bookURL,.bookDisplay .title{display:block;margin-bottom:5px}.bookDisplay.inlineBook .bookURL,.bookDisplay.inlineBook .title{display:inline-block}.bookDisplay .author{display:inline-block;margin-bottom:5px}.bookDisplay .cover{margin-right:10px}.bookDisplay .aboutWrap{max-width:70%}.bookDisplay .aboutWrap,.bookDisplay .coverWrap{display:inline-block;vertical-align:top}.bookDisplay .excludedText{font-size:.8em;margin-top:10px;margin-bottom:-5px}.bookDisplay .badge.libraryTag{background-color:#fff864;border-radius:4px;margin-right:.5em;font-weight:400;color:#555}.bookDisplay .urlCover{display:flex;align-items:center;border:2px solid #ddd;border-radius:5px;padding:10px;overflow:hidden}.bookDisplay .urlCover .text{width:100%}.bookDisplay .cursive{font-family:cursive}.myShelfPage .infoContainer .bookDisplay .title{display:inline-block}.answerDisplay .bookDisplay .excludedText{margin-bottom:5px}#studentHomePage .bookDisplayContainer,.preferenceContainer .bookDisplayContainer{display:inline-block;vertical-align:top;margin-bottom:5px;margin-left:15px}#studentHomePage .bookDisplayContainer:first-of-type,#studentHomePage .bookDisplayContainer:nth-of-type(4),.preferenceContainer .bookDisplayContainer:first-of-type,.preferenceContainer .bookDisplayContainer:nth-of-type(4){margin-left:0}#studentHomePage .bookDisplay,.preferenceContainer .bookDisplay{width:32%;vertical-align:top;margin-top:10px}#studentHomePage .bookDisplay .about,.preferenceContainer .bookDisplay .about{font-size:.8em;margin-top:5px;width:90px;word-break:break-word}#studentHomePage .bookDisplayContainer{display:inline-block;vertical-align:top;margin-bottom:5px;margin-left:5px}.bookShelf .bookDisplay .about{width:63%}", ""]);
	
	// exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookLogger{width:75%;margin:auto}.bookLogger.onlineText{width:50%}.bookLogger .bookRow{padding:10px}.bookLogger .bookRow .removeBookRow{height:0;position:relative;left:369px;display:inline-block;bottom:10px;color:#ccc;font-size:18px}.bookLogger .bookRow .logSection .logLabels .logMinutes{margin-left:10px}.bookLogger .bookRow .logSection .logLabels .logPages{margin-left:47px;margin-right:13px}.bookLogger .bookRow .logSection .logLabels .logDate{margin-left:49px}.bookLogger .bookRow .logSection .logLabels label{margin-bottom:0!important}.bookLogger .bookRow .logSection .logRows .logRow{margin-bottom:5px}.bookLogger .bookRow .logSection .logRows .logRow input{display:inline-block;width:19%;margin-left:10px}.bookLogger .bookRow .logSection .logRows .logRow .dateSelector{width:40%;display:inline-block;margin-left:10px}.bookLogger .bookRow .logSection .logRows .logRow .dateSelector.onlineText{width:65%}.bookLogger .bookRow .logSection .logRows .logRow .removeLogRow{width:5px;position:relative;right:5px;outline:none}.bookLogger .bookRow .logSection .logRows .logRow .removeLogRow .glyphicon-remove{color:#ccc}.bookLogger .bookRow .logSection .logRows .logRow .logError{font-size:.8em;color:#a1011e;position:relative;top:0;margin-left:10px}.bookLogger .bookRow .logSection .moreRowsContainer{margin-bottom:15px}.bookLogger .bookRow .logSection .moreRowsContainer .moreRows{font-size:.8em;position:relative;left:273px;top:2px}.bookLogger .bookRow .logSection .moreRowsContainer .moreRows.onlineText{left:167px}.bookLogger .bookRow .logSection .moreRowsContainer .glyphicon-plus{margin-right:5px}.bookLogger .bookRow.detailedBookRow .logRows .logRow input.logMinutes,.bookLogger .bookRow.detailedBookRow .logRows .logRow input.logPages{display:block}.bookLogger .showDetailedFormLink{position:relative;left:314px;font-size:.8em;cursor:pointer}.bookLogger .showDetailedFormLink.onlineText{left:205px}.bookLogger .titleSection{margin-left:18px;margin-bottom:10px}.bookLogger .titleSection .title{font-style:italic}.detailedBookLogger{width:93%;margin:auto}.detailedBookLogger .bookRow .logSection .logLabels .logDate{margin-left:118px}.detailedBookLogger .bookRow .logSection .logLabels .logPlace{margin-left:227px}.detailedBookLogger .bookRow .logSection .logLabels label{margin-bottom:0!important}.detailedBookLogger .bookRow .logSection .logRows .logRow{margin-bottom:5px}.detailedBookLogger .bookRow .logSection .logRows .logRow input{width:75%}.detailedBookLogger .bookRow .logSection .logRows .logRow input.logMinutes,.detailedBookLogger .bookRow .logSection .logRows .logRow input.logPages{display:block}.detailedBookLogger .bookRow .logSection .logRows .logRow input.logMinutes{margin-bottom:5px}.detailedBookLogger .bookRow .logSection .logRows .logRow .dateSelector,.detailedBookLogger .bookRow .logSection .logRows .logRow .timeSelector{margin-left:9px;display:block;margin-bottom:5px}.detailedBookLogger .bookRow .logSection .logRows .logRow .removeLogRow{width:5px;position:relative;left:162px;outline:none;vertical-align:top;bottom:65px}.detailedBookLogger .bookRow .logSection .logRows .whenContainer{display:inline-block}.detailedBookLogger .bookRow .logSection .logRows .whenContainer .selector{width:120px}.detailedBookLogger .bookRow .logSection .logRows .whenContainer .timeSelector{display:inline-block}.detailedBookLogger .bookRow .logSection .logRows .whenContainer .timeSelector.endTime{margin-left:5px}.detailedBookLogger .bookRow .logSection .logRows .quantityContainer{display:inline-block;vertical-align:top;width:25%}.detailedBookLogger .bookRow .logSection .logRows .placeContainer{display:inline-block;width:30%;vertical-align:top;margin-left:18px}.detailedBookLogger .bookRow .logSection .logRows .placeContainer input{width:7%;margin-right:5px}.detailedBookLogger .bookRow .logSection .logRows .placeContainer label{width:100%;font-weight:400;display:block}.detailedBookLogger .bookRow .logSection .moreRowsContainer{margin-left:100px}.detailedBookLogger .bookRow .logSection .moreRowsContainer .moreRows{left:348px}", ""]);
	
	// exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookRating{position:relative;display:inline-block;padding-bottom:1px;margin-top:5px;margin-bottom:5px}.bookRating .rateIcon{height:auto;padding-left:1px;padding-right:1px;opacity:.4;filter:grayscale(100%)}.bookRating .rateIcon.active{opacity:1;filter:grayscale(0)}.bookRating .partialIconWrap{display:inline-block;overflow:hidden;position:absolute;top:0}.bookRating.editable:hover{cursor:pointer}.bookRating.editable:hover .rateIcon{opacity:.7;filter:grayscale(40%)}.bookRating.editable:hover .rateIcon.active{opacity:1;filter:grayscale(0)}.bookRating.editable:hover .nestedIconBox:not(:hover) .rateIcon,.bookRating.editable:hover .nestedIconBox:not(:hover) .rateIcon.active{opacity:.4;filter:grayscale(100%)}", ""]);
	
	// exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookSearchModal .modal-body{min-height:370px}", ""]);
	
	// exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookTextVariety .selection{text-align:center}.bookTextVariety .selection .selected{font-weight:700}.bookTextVariety .verticalDivider{border-left:1px solid #bbb;top:50px;left:50%;height:50px}.bookTextVariety .fiction{width:40%;float:left}.bookTextVariety .nonFiction{width:40%;float:right}.bookTextVariety .optionContainer{padding-top:22px}.bookTextVariety .optionContainer button{margin-bottom:10px}.bookTextVariety .optionContainer div{font-style:italic;font-size:.8em}.bookTextVariety .seperator{margin-top:50px}.bookTextVariety .cancelAction{margin-top:15px;float:left;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".logReadingModal .modal-dialog{width:725px}.logReadingModal .modal-body{min-height:300px}.logReadingModal .modal-body .modalAction{text-align:center}.logReadingModal .modal-body .resetSearch{margin-left:10px;cursor:pointer}.logReadingModal .modal-body .dailyMinutesMaxErrorText{font-size:.8em;color:#a1011e;margin-left:80px;position:relative;bottom:10px}.logReadingModal .modal-body .studentsSelectedSection{margin-left:67px}.logReadingModal .smartBookSearch{width:75%;margin-left:12.5%;margin-bottom:15px}.logReadingModal .smartBookSearch .searchBar{margin-left:27px}.logReadingModal .showBookSearch{position:absolute;right:100px;bottom:23px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".smartBookSearch{position:relative;z-index:5}.smartBookSearch.dropUp .Select-menu-outer{top:auto;bottom:100%}.smartBookSearch .bookCover .bookDetails{width:575px;max-width:70%}.smartBookSearch .Select-menu-outer{max-height:300px}.smartBookSearch .Select-menu{max-height:250px;overflow-x:hidden}.smartBookSearch .coverIconSub{margin-left:10px;margin-right:10px}.smartBookSearch .bookTypeControl{margin-left:27px}.smartBookSearch .bookTypeControl .or{display:inline-block;margin:auto 10px}.smartBookSearch .bookTypeControl input[type=radio]{margin-right:1px;position:relative;bottom:1px}.smartBookSearch .bookTypeControl label{font-weight:400;color:#337ab7}.smartBookSearch .manualForm{max-height:63px;vertical-align:top}.smartBookSearch .manualForm>*{vertical-align:top}.smartBookSearch .manualForm .validatingInput,.smartBookSearch .manualForm select.form-control{display:inline-block;margin-right:10px;vertical-align:top}.smartBookSearch .manualForm .validatingInput.title,.smartBookSearch .manualForm select.form-control.title{width:34%}.smartBookSearch .manualForm .validatingInput.author,.smartBookSearch .manualForm .validatingInput.url,.smartBookSearch .manualForm select.form-control.author,.smartBookSearch .manualForm select.form-control.url{width:24%}.smartBookSearch .manualForm .validatingInput.textVariety,.smartBookSearch .manualForm select.form-control.textVariety{width:19%}.smartBookSearch .manualForm .backArrow{position:relative;margin-right:10px;top:7px}.smartBookSearch .manualForm .buttonSuccess{height:34px;padding-top:5px}.smartBookSearch .reactSelectError .Select-noresults{color:#a1011e}.smartBookSearch .emptyContainer{height:15px;display:block;position:relative}.smartBookSearch .emptyContainer .spinnerBox{position:absolute;left:50%}.smartBookSearch .placeholderContainer{height:5px;display:block;position:relative}.smartBookSearch .searchOpDisplay{position:relative}.smartBookSearch .searchOpDisplay .draftIcons{font-size:.8em;position:absolute;right:0;top:-5px}.smartBookSearch .searchOpDisplay .draftIcons img{height:17px;width:auto}.smartBookSearch .searchOpDisplay .draftIcons img.quizDraftIcon{height:23px;margin-top:-4px;margin-bottom:-2px;margin-left:1px}.smartBookSearch .searchOpDisplay .draftPair{display:inline-block;text-align:center;font-size:.8em;margin-left:10px;min-width:40px;filter:grayscale(100%);line-height:1.3;opacity:.5}.smartBookSearch .searchOpDisplay .draftPair:hover{filter:none}", ""]);
	
	// exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".textTable table{font-size:.8em;width:100%}.textTable td.editable a{font-size:.8em;float:right;margin-top:2px}.textTable td.editable .editIcon{position:relative;left:5px;margin-top:2px;float:right}.textTable td{vertical-align:middle!important}.textTable th.bookCol{width:30%}.textTable th.quizCol,.textTable th.writingCol{min-width:7.7em}.textTable th.answerCol,.textTable th.responseCol,.textTable th.reviewCol,.textTable th.textVarietyCol{min-width:5em}.textTable th.ReadingLevelCol{min-width:6em}.textTable .scoreDisplay{display:inline-block;margin-right:.4em}.textTable .textVarietyDisplay{margin-right:.4em}.textTable .truncatedPlaceholder td{text-align:center}.textTable .truncatedPlaceholder td .btn{position:relative;bottom:1px}.textTable .textRow td.writingCount{padding:5px}.textTable .textRow td.writingCount .hideOnPrint{margin-left:10px}", ""]);
	
	// exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".logCalendar table{width:100%;margin-top:15px;margin-bottom:30px}.logCalendar .dayNames{height:30px;vertical-align:middle;text-align:center;background-color:#ddd;border-top:1px solid #bbb;border-left:1px solid #bbb}.logCalendar .dayNames:nth-of-type(7){border-right:1px solid #bbb}.logCalendar .dayBlank{height:80px;width:14.28%;text-align:right;vertical-align:text-bottom;border:1px solid #bbb;padding-right:10px;padding-top:5px}.logCalendar .dayBlank .dateNumber{margin-bottom:0}.logCalendar .dayBlank .data-result{text-align:center;font-size:.8em;margin-bottom:5px;padding:0;vertical-align:text-bottom;display:block}.logCalendar .dayBlank .data-result-all{vertical-align:text-bottom}.logCalendar .currentMonth{display:inline;font-size:1.4em}.logCalendar button{font-family:museo-sans-rounded,Helvetica,Arial,sans-serif;display:inline;font-weight:lighter;outline:none;border-color:transparent;background-color:transparent;color:#555}.logCalendar .button{color:#006faa}.logCalendar .btngroup{float:right;position:relative;left:10px}.logCalendar .todayHighLight{background-color:#c8ecff}", ""]);
	
	// exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".allMonthsLogTable.embedded .logTable .logRow td.dateCell{text-align:center;width:14%}.allMonthsLogTable.standalone th.dateTitle{font-size:1.4em;font-weight:400}.allMonthsLogTable .truncatedPlaceholder{border-bottom:1px solid #bbb;text-align:center;margin-bottom:40px;padding-bottom:14px}.logTable,.monthLogTable .commentWrap{margin-bottom:15px}.logTable{width:100%;margin-left:auto;margin-right:auto}.logTable .logRow{border-bottom:1px solid #bbb}.logTable .logRow td{height:50px;vertical-align:middle;text-align:center;padding-top:5px;padding-bottom:3px}.logTable .logRow .logError{color:#a1011e}.logTable .logRow.excludedLog{background-image:linear-gradient(45deg,#fff 25%,#f6f6f6 0,#f6f6f6 50%,#fff 0,#fff 75%,#f6f6f6 0,#f6f6f6);background-size:5.66px 5.66px}.logTable .logRow.approvedLog{background-image:linear-gradient(45deg,#c0f2aa 12.5%,#fff 0,#fff 50%,#c0f2aa 0,#c0f2aa 62.5%,#fff 0,#fff);background-size:5.66px 5.66px}.logTable .logRow .optionsCell{white-space:nowrap}.logTable .logRow .glyphicon-ok-sign{color:#2b9401}.logTable .infoContainer{margin-bottom:0}.logTable .infoContainer .readingLevelContainer,.logTable .infoContainer .readingLevelContainer .readingLevelImg{margin-left:0}.logTable .sectionLabel{font-size:.8em;color:#bbb;position:relative;bottom:3px}.logTable th{text-align:center}.logTable th .expandLink{font-weight:400}.logTable th.dateTitle{text-align:left}.logTable th.minutesTitle{text-align:center}.logTable th.minuteCell,.logTable th.pageCell{font-weight:400}.logTable tr.innerTitles,.logTable tr.outerTitles{height:50px}.logTable .outerTitles{height:60px;border-bottom:1px solid #bbb}.logTable th.dateTitle{font-weight:400}.logTable tr.clickable{cursor:pointer}.logTable tr.clickable:hover{opacity:.7}.logTable .dateCell{width:20%}.logTable .titleCell{width:25%}.logTable .titleCell .textTitle{width:90%;margin-left:5%}.logTable .titleCell .textTitle .title{width:200px;display:inline-block}.logTable .titleCell .sectionLabel{left:7px}.logTable .editCell,.logTable .minuteCell,.logTable .pageCell{width:18.3333333333%}.logTable th.minutesTitle{font-size:1.4em;font-weight:400}.logTable .editingLogRow .logTitle{width:22%}.logTable .editingLogRow .dateCell .dateLabel{display:block}.logTable .editingLogRow .dateCell .logLocationInput{width:80px}.logTable .editingLogRow .editedDataCell{position:relative}.logTable .editingLogRow .inputBox{display:inline-block;text-align:center;width:33.333%;vertical-align:middle}.logTable .editingLogRow input.form-control{font-size:16px;width:43px;display:inline-block;text-align:center;height:22px;padding:0 4px}.logTable .editingLogRow .buttonSuccess.saveButton{min-width:40px!important;font-size:.8em;padding:4px 10px}.logTable .optionsCell{padding-right:30px}.logTable .optionsCell .dropdown-menu a{display:block;color:#555;padding-left:5px;padding-bottom:0;text-decoration:none;text-align:left;cursor:pointer}.logTable .optionsCell .dropdown-menu a:hover{background:#efefef}.logTable .digestLogRow{font-size:.8em;border-bottom:none}.logTable .digestLogRow .titleCell{text-align:left}.logTable .digestLogRow .titleCell .textTitle{margin-left:0}.logTable .digestLogRow .minuteCell,.logTable .digestLogRow .pagesCell{width:25%}.logTable .digestLogRow td{height:auto;vertical-align:top;padding:none}", ""]);
	
	// exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".participatingStudentsDisplay{font-size:.8em}.participatingStudentsDisplay .studentAvatarWrap{display:inline-block}.participatingStudentsDisplay .moreStudentsContainer{display:inline-block;white-space:nowrap;position:relative;top:5px}.participatingStudentsDisplay .allStudentsDisplay img{height:25px;width:auto}", ""]);
	
	// exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".addLibraryURLPick .assignable{position:relative;margin-bottom:30px}.addLibraryURLPick .assignable .bookDisplay{display:inline-block;width:70%}.addLibraryURLPick .assignable .actions{vertical-align:top;display:inline-block;margin-left:5%;width:25%}.addLibraryURLPick .filters{margin-bottom:10px}.addLibraryURLPick .filters .dropdown-toggle,.addLibraryURLPick .filters .scrollable-menu{text-transform:capitalize}.addLibraryURLPick .noteText{margin-bottom:15px}.addLibraryURLPick .noResultsText{margin-left:12px}", ""]);
	
	// exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".addManualURLPick label{margin-top:5px;margin-bottom:0}.addManualURLPick .form-control{margin-bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".addTitlePick{min-height:350px}.addTitlePick .manualForm{text-align:center}.addTitlePick .manualForm .buttonSuccess{margin-top:20px}", ""]);
	
	// exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".picksPage .taskItemModal{margin-left:30%}.picksPage .loadingButton{margin-top:10px}.picksPage label span{vertical-align:middle;float:right}.picksPage label{margin-left:10px;font-weight:500;display:inline-block;padding-right:10px;white-space:nowrap}.picksPage input{vertical-align:middle;margin-right:10px}.picksPage input[type=number]{width:50px;text-align:center}.picksPage .pickHeader{font-size:1.4em;text-align:left;border-radius:5px}.picksPage .smartBookSearch{width:100%}.picksPage .assignedText{position:relative;margin-bottom:25px}.picksPage .assignedText a.removeLink{position:absolute;right:0;top:0;color:#aaa}.picksPage .assignedText .bookDisplay .about .author,.picksPage .assignedText .bookDisplay .about .title{padding-right:1.5em;margin-bottom:0}.picksPage .assignInstructions{margin-bottom:30px}.picksPage .byTitle{padding-right:30px}.picksPage button.addPick{width:40%;margin-right:10%;background:#fff;padding-top:15px;padding-bottom:15px;text-align:center;border:1px dashed #bbb;height:90px;display:inline-block}.picksPage button.addPick:hover{opacity:.7}.picksPage .participatingStudentsDisplay{margin-right:10px}.picksPage .editTaskAssignment{font-size:.8em}.picksPage .editTaskAssignment,.picksPage .participatingStudentsDisplay{display:inline-block;vertical-align:middle;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".readingLevelContainer{display:inline-block;margin-left:10px}.readingLevelContainer .verticalDivider{border-color:#bbb;height:20px;padding-right:10px}.readingLevelContainer .readingLevelImg{width:15px;margin-left:5px}.contentItems .readingLevelContainer{margin-bottom:5px}.contentItems .readingLevelContainer .readingLevelImg{margin-left:5px}.readingLevelDisplay{margin-right:.4em}.readingLevelDisplay .level{width:30px;display:inline-block}.readingLevelDisplay .readingLevelContainer{position:absolute;margin-left:5px}.readingLevelDisplay .readingLevelContainer .readingLeveLImg{margin-left:0!important}", ""]);
	
	// exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".readingLevelTable{font-size:.8em}.readingLevelTable .table td,.readingLevelTable .table th{vertical-align:middle}.readingLevelTable .studentColumn{width:180px}.readingLevelTable .names{margin-left:35px}.readingLevelTable .names .studentDisplay .name,.readingLevelTable .names .studentListName{text-overflow:ellipsis;overflow:hidden;max-width:10em;white-space:nowrap;display:block}.readingLevelTable .names .studentListName,.readingLevelTable .rlOrigin{color:#999}.dataReadingLevels .readingLevelTable{overflow-x:scroll}.dataReadingLevels .readingLevelTable table td,.dataReadingLevels .readingLevelTable table th{min-width:100px}.dataReadingLevels .readingLevelTable .rldText a{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookGrid{margin-top:20px}.bookGrid .bookContainer{margin-left:20px;margin-right:20px;margin-bottom:20px;display:inline-block;cursor:pointer;vertical-align:top}.bookGrid .bookContainer:hover{opacity:.7}.bookGrid .bookContainer .studentsDisplayContainer{margin:auto;margin-top:10px}.bookGrid .bookContainer .studentsDisplayContainer .moreStudentsContainer{position:relative;top:5px;left:5px}.bookGrid .bookContainer .studentsDisplayContainer .moreStudentsContainer .moreText{font-size:.8em}.bookGrid .emptySection .emptyBook{width:115px;border:1px dashed #ddd;height:170px;display:inline-block;margin-right:45px}", ""]);
	
	// exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookShelf{overflow:hidden;position:relative}.bookShelf .asDraft{margin-top:15px}.bookShelf .toggleOptionContainer{width:100%}.bookShelf .toggleOptionContainer .smallObject{margin-top:10px}.bookShelf .toggleOptionContainer .smallObject .dropdown-toggle{color:#555;font-size:14px}.bookShelf .expandedWrap{transition:left .4s ease-out;position:absolute;top:0;height:100%;z-index:3;width:100%;background-color:#fff}.bookShelf .viewToggle.grid .expandedWrap{left:100%}.bookShelf .viewToggle.expanded .expandedWrap{left:0}.bookShelf .gridWrap{position:relative;overflow:hidden;z-index:1}.bookShelf .sidebarWrap{float:left;width:25%;min-height:300px;border-right:1px solid #ddd}.bookShelf .sidebarWrap .backLink{margin-left:10px;margin-bottom:10px}.bookShelf .detailsWrap{float:right;width:70%}@media print{.bookShelf .detailsWrap{float:none;width:100%}}.bookShelf .emptyStateContainer .emptyStateContent{text-align:center}.bookShelf .emptyStateContainer .emptyStateContent p{margin-top:15px;margin-right:70px}.bookShelf .emptyStateContainer .emptyStateContent img{width:75%}@media print{.bookShelf .viewToggle{height:950px}}@media print{.bookShelf .bookDetailFrame{width:140%!important;margin-left:-40%!important;overflow:visible!important}}@media print{.bookShelf .bookDetailFrame div{overflow:visible!important}}@media print{.bookShelf .hideOnPrint{width:0!important}}", ""]);
	
	// exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookSidebar{font-size:.8em}.bookSidebar .bookContainer{cursor:pointer;padding:10px;padding-top:15px;padding-bottom:0;margin-right:20px;border:1px solid transparent}.bookSidebar .bookContainer:hover{opacity:.7}.bookSidebar .bookContainer.selectedBook{border:1px solid #ddd;border-radius:5px}.bookSidebar .bookContainer .bookCover{margin-bottom:20px}.bookSidebar .bookContainer .bookCover .bookDetails{padding-left:5px;text-align:center;width:115px}", ""]);
	
	// exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".coinDetailsModal .coinTable td{padding:.7rem .5rem}.coinDetailsModal .coinTable .totalCoinsRow{border-top:1px solid #ddd}.coinDetailsModal .subCoins{opacity:.7;text-align:right}.coinDetailsModal .coinMaxDisclaimer{font-size:.8em;text-align:center}.coinDetailsModal .hiddenElement{display:none}.coinDetailsModal .reactionFeedback{float:right}.smallSize .modal-dialog{width:400px}.smallSize .coinTable{margin-left:auto;margin-right:auto}.fullSize .modal-body{min-height:300px}.fullSize .modal-dialog{width:800px;overflow:hidden}.fullSize .coinTable{margin-left:15px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".coinsEarnedDisplay{text-align:right}.coinsEarnedDisplay p{font-size:.8em}.coinsEarnedDisplay p.excluded{padding-right:10px}.coinsEarnedDisplay a{padding-left:10px}.coinsEarnedDisplay .coinDetailsModal{text-align:left}.coinsEarnedDisplay .coinTable td:first-child{width:100px;text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".expandedBookDetails .questionBuilderList .myWorkAnswers .answerDisplayRow{top:0}.expandedBookDetails .dividerSection{margin-top:25px;margin-bottom:35px;position:relative;text-align:center}.expandedBookDetails .dividerSection .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}.expandedBookDetails .dividerSection .nameArea{padding-left:10px;padding-right:10px;background-color:#fff;display:inline-block;position:relative;min-height:47px;padding-top:10px}.expandedBookDetails .dividerSection .nameArea .nameString{font-size:1.3em;margin-right:15px;margin-left:15px}.expandedBookDetails .studentTaskGridContainer{width:100%;display:inline-block;vertical-align:top;margin-right:5%;position:relative;bottom:20px;margin-top:30px}.expandedBookDetails .studentTaskGridContainer .subHeader{font-weight:400;text-align:center}.expandedBookDetails .studentTaskGridContainer .studentTasks{cursor:pointer}.expandedBookDetails .studentTaskGridContainer .studentTasks img{width:15px}.expandedBookDetails .studentTaskGridContainer .studentTasks .task{margin-bottom:15px;width:100%}.expandedBookDetails .studentTaskGridContainer .studentTasks .task:hover{opacity:.7}.expandedBookDetails .studentTaskGridContainer .studentTasks .task .category{font-size:.8em;color:#999;margin-left:5px}.expandedBookDetails .studentTaskGridContainer .studentTasks .task .taskTitle{margin-bottom:5px;max-height:4em;overflow:hidden}.expandedBookDetails .studentTaskGridContainer .studentTasks .task .bookDisplay .title{margin-bottom:0}.expandedBookDetails .bookInformationContainer{margin-top:20px 0}.expandedBookDetails .bookInformationContainer .bookDisplay{min-height:7em}.expandedBookDetails .bookInformationContainer .bookCover{min-height:100px;margin-bottom:15px}.expandedBookDetails .bookStats{width:50%;margin-left:9px;display:inline-block;position:relative}.expandedBookDetails .bookStats .ratingContainer{margin-bottom:5px}.expandedBookDetails .bookStats .readersLabel{margin-bottom:0}.expandedBookDetails .bookStats .studentAvatar{float:left}.expandedBookDetails .bookStats .studentAvatar .__react_component_tooltip{z-index:99999999}.expandedBookDetails .reviewsContent .bookReview,.expandedBookDetails .reviewsContent .skillsetBanner{margin-bottom:15px}.expandedBookDetails .reviewsContent .bookReview.borderedReview{border-bottom:1px solid #ddd;padding-bottom:20px}.expandedBookDetails .quizContent .detailsViewPrompt,.expandedBookDetails .reviewsContent .detailsViewPrompt{font-weight:700}.expandedBookDetails .quizContent .answerText,.expandedBookDetails .quizContent .reviewText,.expandedBookDetails .reviewsContent .answerText,.expandedBookDetails .reviewsContent .reviewText{overflow:hidden}.expandedBookDetails .bookDisplay .title{max-width:100%}.expandedBookDetails .bookAnswer{padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #ddd}.expandedBookDetails .bookAnswer:last-child{border-bottom:none}.expandedBookDetails .bookAnswer .questionAnswerDisplay{display:inline-block;max-width:90%}.expandedBookDetails .bookAnswer .answerText{border:1px solid #ddd;border-radius:5px;padding:1rem;margin-top:.5rem}.expandedBookDetails .answersList .answerDisplay,.expandedBookDetails .reviewsList .answerDisplay{margin-bottom:30px}.expandedBookDetails .exercisesContent .exerciseLink{position:relative;font-size:.8em;float:right;bottom:45px}.expandedBookDetails .warmupAnswersDisplay .warmupAnswer{padding-bottom:2rem;margin-bottom:1rem;border-bottom:1px solid #ddd}.expandedBookDetails .warmupAnswersDisplay .warmupQuestionsDisplay{display:inline-block;max-width:90%}.expandedBookDetails .classReviewsContent{margin-right:20px}.expandedBookDetails .classReviewsContent .reviewText{border:1px solid #ddd;border-radius:5px;padding:.5rem;margin-top:.5rem}.expandedBookDetails .fullBookArea .topRightContainer{position:relative;margin-top:-50px;min-height:60px}.expandedBookDetails .fullBookArea .topRightContainer .scoreDisplay{position:absolute;right:0;top:-115%}.expandedBookDetails .emptySection{margin-top:15px}.expandedBookDetails .answersList,.expandedBookDetails .classReviewsContent,.expandedBookDetails .responsesList{margin-top:20px}.expandedBookDetails .myWorkAnswers .answerDisplayRow{position:relative;top:-130px}.expandedBookDetails .myWorkAnswers .answerDisplayRow.noBookDisplay{top:0}.expandedBookDetails .myWorkAnswers.questionBuilderList .answerDisplayRow{position:relative;top:0}.expandedBookDetails .draftContent .quizDisplayRow,.expandedBookDetails .draftContent .topRow{padding-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".myShelfPage{position:relative}.myShelfPage .toggleOptionContainer{width:100%}.myShelfPage .toggleOptionContainer .smallObject .dropdown-toggle{color:#555;font-size:14px}.myShelfPage .displayToggleControl.topToggle{position:relative;text-align:center;z-index:2}.myShelfPage.withToggle .displayToggleControl.topToggle{text-align:center;margin-bottom:0}.myShelfPage.withToggle .bookGrid,.myShelfPage.withToggle .logsWrap{margin-top:47px}.myShelfPage .shelfSpin{margin-top:20px}", ""]);
	
	// exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".myWork{overflow:visible;position:relative}.myWork .dividerSection{margin-top:25px;margin-bottom:35px;position:relative;text-align:center}.myWork .dividerSection .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}.myWork .dividerSection .nameArea{padding-left:10px;padding-right:10px;background-color:#fff;display:inline-block;position:relative;min-height:47px;padding-top:10px}.myWork .dividerSection .nameArea .nameString{font-size:1.3em;margin-right:15px;margin-left:15px}.myWork .paginationControls{margin-bottom:10px}.myWork .myWorkContainer{border-radius:5px;border:1px solid #bbb;display:block;transition:.1s;padding:20px;margin-bottom:15px}.myWork .expandedBookDetails{margin-top:10px}.myWork .expandedWrap{transition:left .4s ease-out;position:absolute;top:0;height:100%;z-index:3;width:100%;background-color:#fff}.myWork .viewToggle.grid .expandedWrap{left:100%}.myWork .viewToggle.expanded .expandedWrap{left:0}.myWork .gridWrap{position:relative;overflow:hidden;z-index:1}.myWork .sidebarWrap{float:left;width:10%;min-height:100%;border-right:1px solid #ddd}.myWork .sidebarWrap .backLink{margin-left:10px;margin-bottom:10px}.myWork .detailsWrap{float:right;width:85%}@media print{.myWork .detailsWrap{float:none;width:100%}}.myWork .emptyStateContainer .emptyStateContent{text-align:center}.myWork .emptyStateContainer .emptyStateContent p{margin-top:15px;margin-right:70px}.myWork .emptyStateContainer .emptyStateContent img{width:75%}@media print{.myWork .viewToggle{height:950px}}@media print{.myWork .bookDetailFrame{width:140%!important;margin-left:-40%!important}}@media print{.myWork .bookDetailFrame,.myWork .bookDetailFrame div{overflow:visible!important}}@media print{.myWork .hideOnPrint{width:0!important}}", ""]);
	
	// exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".classReviewsContent .detailsViewPrompt{font-weight:700}.classReviewsContent .skillsetBanner{margin-top:40px;margin-bottom:30px}.classReviewsContent .ratingContainer{margin-bottom:15px}.classReviewsContent .bookReview{margin-bottom:20px}.classReviewsContent .bookReview .reviewText{overflow:hidden}.classReviewsContent .bookReview.borderedReview{border-bottom:1px solid #ddd;padding-bottom:20px}.classReviewsContent .bookReview .reviewStudentName{text-align:right}.classReviewsContent .bookReview .reviewStudentName .owlConstraints{float:right;position:relative;bottom:5px;margin-left:5px}.reviewsContent .detailsViewPrompt{font-weight:700;margin-bottom:0}.reviewsContent .removeReview,.reviewsContent .reviseReview{font-size:.8em;display:inline-block}.reviewsContent .verticalDivider{border-color:#ddd;height:20px;margin-left:5px;margin-right:5px}.myShelfPage .reviewsContent .reviewLink{position:relative;font-size:.8em;float:right;bottom:10px;z-index:1}.myShelfPage .reviewsContent .draftReview{opacity:.5}", ""]);
	
	// exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".commentBox{font-size:.8em}.commentBox .content{overflow:hidden;margin-bottom:10px}.commentBox .content span.commenter{font-weight:700}.commentBox .content span.commentInfoLine{color:#888}.commentBox .content a.delete,.commentBox .content a.edit{color:#888;text-decoration:underline}.commentBox .makeComment{font-size:inherit;height:2.5em;width:95%}.commentBox .selectOptions{width:95%}.commentBox .autoSubmitTextArea p{margin-right:5%}.commentBox .autoSubmitTextArea p.hideLine{display:none}.commentBox .withSuggestions{min-height:300px}.commentBox textarea:focus{height:5em}.commentBox form .btn-group{margin-top:0;font-size:.8em}.commentBox .commentEdit{margin-bottom:8px}.commentBox .postButton,.commentBox .postPublicButton,.commentBox .postSecretButton{margin-top:0;margin-right:10px;clear:none;color:#555}.commentBox .commentSubmitButtons,.commentBox .postButton{float:right}.commentBox .commentSubmitButtons input[type=radio],.commentBox .postButton input[type=radio]{display:none}.commentBox .commentSubmitButtons .dropdown-toggle,.commentBox .postButton .dropdown-toggle{margin-right:20px;height:36px;font-size:14px}.commentBox .commentSubmitButtons button .details,.commentBox .postButton button .details{display:none}.commentBox .spinnerBox.placeholder{padding:20px}", ""]);
	
	// exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".photosDisplay .zeroHeader{margin-bottom:3%}.photosDisplay .photos{margin-top:8%}.photosDisplay .owlstagramLink{margin-bottom:20px}.photosDisplay .samplePhoto{opacity:.6;filter:grayscale(80%)}.photosDisplay .photoBox{display:inline-block;width:31%;margin-left:1.165%;margin-right:1.165%}.photosDisplay .photoBox .textHeader{font-size:.8em;color:#888;margin-bottom:5px}.photosDisplay .photoBox img.photo{width:100%;margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".HelpCenterLink{z-index:9000;cursor:pointer;position:fixed;left:0;bottom:0;height:30px;color:#fff;background:#444;border-top-left-radius:5px;border-top-right-radius:5px;margin-left:10px}.HelpCenterLink .icon{display:inline-block;width:36px;border-top-left-radius:5px;padding-top:5px;vertical-align:text-top;text-align:center;background:#393939;color:#fff}.HelpCenterLink .content{font-size:12px;font-family:Verdana,Geneva,sans-serif;display:inline-block;overflow:hidden;vertical-align:text-top;font-weight:700;line-height:30px;padding-left:10px;padding-right:10px}", ""]);
	
	// exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".reactionFeedback{position:relative}.reactionFeedback.position-modal-bottom-left{display:inline-block;right:45%}.reactionFeedback .reactionOption{display:inline-block;margin-left:10px;opacity:.5}.reactionFeedback .reactionOption img{width:30px;height:auto}.reactionFeedback .reactionOption.active,.reactionFeedback .reactionOption:hover{opacity:1}.reactionFeedback .reactionRow.position-modal-bottom-right{text-align:right}.reactionFeedback .reactionRow.position-modal-bottom-left{text-align:left}.reactionFeedback .reactionRow.position-bottom-right{text-align:right}.reactionFeedback .reactionTitle{text-align:right;margin-bottom:3px;margin-top:0;font-size:.8em}.reactionFeedback .popover{display:block;width:340px;max-width:340px;top:55px;left:50%;padding-bottom:0;z-index:4000}.reactionFeedback .popover.textOnly{left:auto;right:0;top:0}.reactionFeedback .popover .form-control{height:75px;font-size:1em}.reactionFeedback .popover .popover-title{font-size:inherit}.reactionFeedback .popover .arrow{border-bottom-color:rgba(0,0,0,.25);border-top-width:0;top:-11px}.reactionFeedback .popover.position-bottom-left{margin-left:5%;left:-80px}.reactionFeedback .popover.position-bottom-left .arrow{left:56%!important}.reactionFeedback .popover.position-bottom-right{margin-left:76%}.reactionFeedback .popover.position-bottom-right .arrow{left:85%!important}", ""]);
	
	// exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".contactModal{color:#555}.contactModal .wrModalBody{padding:0!important}.contactModal .errorDisplay{padding-left:50px}.contactModal .messageArea{height:150px;width:350px;margin:auto}.contactModal .buttonSuccess{width:150px}.contactModal .wrModalHeader{margin-right:0!important}", ""]);
	
	// exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".webinarRegistration{max-width:52rem;margin-left:auto;margin-right:auto;position:relative}.webinarRegistration .formOption{display:block;font-weight:400}.webinarRegistration .formOption input{margin-right:.5rem}.webinarRegistration .formOption:hover{cursor:pointer}.webinarRegistration .buttonSuccess{position:absolute;right:0;bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".surveyPromptContainer{z-index:1000}.surveyPromptContainer .spinnerBox.placeholder{padding:1em}.surveyPromptContainer.contentSurvey{width:100%;text-align:center;margin-bottom:1em;font-size:1em}.surveyPromptContainer.contentSurvey .embededContentInner{background:#eee;border-radius:.5em;padding:1em}.surveyPromptContainer.contentSurvey .commentIcon{font-size:1.3em;color:#2b9401;vertical-align:text-bottom}.surveyPromptContainer.contentSurvey .promptBody{color:#2b9401;display:inline-block;margin-left:1em}.surveyPromptContainer.contentSurvey.twoRows .promptOptions{width:100%;margin-top:.3em}.surveyPromptContainer.contentSurvey .promptOptions{display:inline-block}.surveyPromptContainer.contentSurvey .promptOptions .surveyOptionBtn{font-weight:700;background:none;border:0;box-sizing:border-box;margin-left:1em;font-size:.9em;position:relative;vertical-align:middle}.surveyPromptContainer.contentSurvey .promptOptions .surveyOptionBtn:after,.surveyPromptContainer.contentSurvey .promptOptions .surveyOptionBtn:before{box-sizing:inherit;content:\"\";position:absolute;width:100%;height:100%}.surveyPromptContainer.contentSurvey .promptOptions .surveyOptionBtn.selected,.surveyPromptContainer.contentSurvey .promptOptions .surveyOptionBtn:hover{color:#2b9401}.surveyPromptContainer.contentSurvey .promptOptions .spin{width:2.5em;height:2.5em;padding:0}.surveyPromptContainer.contentSurvey .promptOptions .spin:after,.surveyPromptContainer.contentSurvey .promptOptions .spin:before{top:0;left:0}.surveyPromptContainer.contentSurvey .promptOptions .spin:before{border:2px solid transparent}.surveyPromptContainer.contentSurvey .promptOptions .spin.selected:before,.surveyPromptContainer.contentSurvey .promptOptions .spin:hover:before{border-top-color:#2b9401;border-right-color:#2b9401;border-bottom-color:#2b9401;transition:border-top-color .15s linear,border-right-color .15s linear .1s,border-bottom-color .15s linear .2s}.surveyPromptContainer.contentSurvey .promptOptions .spin:after{border:0 solid transparent}.surveyPromptContainer.contentSurvey .promptOptions .spin.selected:after,.surveyPromptContainer.contentSurvey .promptOptions .spin:hover:after{border-top:2px solid #2b9401;border-left-width:2px;border-right-width:2px;transform:rotate(270deg);transition:transform .4s linear 0s,border-left-width 0s linear .35s}.surveyPromptContainer.contentSurvey .promptOptions .circle{border-radius:100%;box-shadow:none}.surveyPromptContainer.contentSurvey .promptOptions .circle:after,.surveyPromptContainer.contentSurvey .promptOptions .circle:before{border-radius:100%}.surveyPromptContainer.contentSurvey .freeResponse{width:60%;margin-left:20%}.surveyPromptContainer.contentSurvey .freeResponse .submitBtn{text-align:left;margin-top:.5em}.surveyPromptContainer.contentSurvey .freeResponse .submitBtn .btn{padding:2px 6px}.surveyPromptContainer.contentSurvey .freeResponse .freeResponsePrompt{font-weight:700;font-size:.9em;font-style:italic;text-align:left}.surveyPromptContainer.contentSurvey .freeResponse .freeResponseAnswer{max-height:20em;width:100%;border-radius:.5em}.surveyPromptContainer.sidebarSurvey{position:sticky;left:100%;bottom:40%;float:left;width:25%;text-align:center;transition:transform 1s ease-out;-moz-transition:transform 1s ease-out;-webkit-transition:transform 1s ease-out}.surveyPromptContainer.sidebarSurvey.showSidebar{transform:translateX(0)}.surveyPromptContainer.sidebarSurvey.hideSidebar{transform:translateX(85%)}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner{box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:1em 0 0 1em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptBody{height:100%;background:#00a0f4;color:#fff;padding:.5em 1em .5em 0;width:100%;border-radius:1em 0 0 0}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptBody .promptDescription{font-size:smaller;font-style:italic;padding-top:.3em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptBodyArrow{font-size:1.5em;vertical-align:top;display:inline-block;width:15%}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptBodyText{width:85%;display:inline-block;font-size:1.1em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions{padding:5% 5% 5% 15%;background:#fff;text-align:left;border-radius:0 0 0 1em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .freeResponseAnswer{opacity:0;max-height:0;resize:none;border-radius:.5em;width:100%}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .freeResponseAnswer,.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .freeResponseAnswer.showTextArea{transition:max-height .3s ease-in-out,opacity .3s ease-in-out;-moz-transition:max-height .3s ease-in-out,opacity .3s ease-in-out;-webkit-transition:max-height .3s ease-in-out,opacity .3s ease-in-out}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .freeResponseAnswer.showTextArea{opacity:1;max-height:20em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions button[type=submit]{display:block;color:#fff;background:#00a0f4;border:none;padding:.2em .5em;border-radius:.5em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions input[type=radio]{float:left}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .optionLabel{margin-left:1.7em;display:block}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .surveyOptionBtn{background:none;border:0;box-sizing:border-box;position:relative;vertical-align:middle}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .surveyOptionBtn:after,.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .surveyOptionBtn:before{box-sizing:inherit;content:\"\";position:absolute;width:100%;height:100%}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin{width:1em;height:1em;padding:0}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:hover{color:#2b9401}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:after,.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:before{top:0;left:0}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:before{border:2px solid transparent}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:hover:before{border-top-color:#2b9401;border-right-color:#2b9401;border-bottom-color:#2b9401;transition:border-top-color .15s linear,border-right-color .15s linear .1s,border-bottom-color .15s linear .2s}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:after{border:0 solid transparent}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .spin:hover:after{border-top:2px solid #2b9401;border-left-width:2px;border-right-width:2px;transform:rotate(270deg);transition:transform .4s linear 0s,border-left-width 0s linear .35s}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .circle{border-radius:100%;box-shadow:none}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .circle:after,.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner .promptOptions .circle:before{border-radius:100%}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner.hideSidebar{box-shadow:unset;transition:box-shadow .5s ease-in-out;-moz-transition:box-shadow .5s ease-in-out;-webkit-transition:box-shadow .5s ease-in-out}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner.hideSidebar .promptBody{box-shadow:0 4px 8px 0 rgba(0,0,0,.2);border-radius:1em 0 0 1em}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner.hideSidebar .promptBody .promptText{opacity:0;color:#fff}.surveyPromptContainer.sidebarSurvey .sidebarSurveyInner.hideSidebar .promptOptions{opacity:0;transition:opacity 1s ease-in-out;-moz-transition:opacity 1s ease-in-out;-webkit-transition:opacity 1s ease-in-out}", ""]);
	
	// exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".errorPage img{max-width:25rem}.errorPage .description{width:40%;margin-left:30%;margin-top:2rem}", ""]);
	
	// exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".pendingSSOPage .opHeader{text-align:center;font-weight:700}.pendingSSOPage .accountFields input{margin-bottom:12.5px}.pendingSSOPage .bigOr{text-align:center;margin-top:12px;margin-bottom:12px;font-size:2rem}.pendingSSOPage .choice{position:relative;width:80%;margin-left:10%;margin-top:15px}.pendingSSOPage .option{display:inline-block;vertical-align:top;width:45%}.pendingSSOPage .option.small{width:10%}.pendingSSOPage .option button{margin:0 auto;display:block}", ""]);
	
	// exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".goldTrialContainer{color:#888}.goldTrialContainer .buttonRow{width:100%;min-height:100px;margin-top:15px}.goldTrialContainer .benefitList{float:left;width:50%}.goldTrialContainer .featureListIntro{margin-left:1em;font-size:20px;margin-bottom:15px;margin-top:15px;color:#555}.goldTrialContainer li{list-style-type:none;font-size:18px;color:#555;margin-bottom:5px}.goldTrialContainer li .glyphicon-ok{padding-right:3%;color:#cdab2c}.goldTrialContainer .btnAndText{margin-top:20px}.goldTrialContainer .teacherOwl{position:absolute;right:150px;width:20%;bottom:15px}.goldTrialContainer .studentOwl{max-width:10%;bottom:25px;position:absolute;right:80px}.goldTrialContainer .startTrialBtnContainer{font-size:20px;vertical-align:text-top;display:inline-block;width:63%;height:fit-content;text-align:center;margin-left:15px}.goldTrialContainer .startTrialImageContainer{width:40%;display:inline-block;height:fit-content;padding-left:5%}.goldTrialContainer .noCreditCardText{font-size:14px}.goldTrialContainer .row.contentRow{display:table}.goldTrialContainer .row.contentRow [class*=col-]{float:none;display:table-cell;vertical-align:middle}.goldTrialContainer .row .alignRight{text-align:right}.goldTrialContainer .row .alignRight .spinner{left:25%}.goldTrialContainer .row .alignLeft{text-align:left}.goldTrialContainer .row .alignMiddle{text-align:center}.goldTrialContainer .row .alignMiddle .spinner{left:50%!important}.goldTrialContainer .featureHeader{font-size:1.3em;font-weight:700;margin-block-start:1em;margin-inline-start:0;margin-inline-end:0;padding-inline-start:40px}.goldTrialContainer .featureList{margin-bottom:20px}.goldTrialContainer .featureList li{font-style:normal;list-style-type:none;font-size:1.1em;padding-inline-start:20px;margin-block-start:.2em}", ""]);
	
	// exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminHomePage .controlBox{border-bottom:1px solid #ddd}.adminHomePage .controlBox .orgDropdown{display:inline-block;border-right:1px solid #ccc;margin-right:15px;padding-right:6px;padding-bottom:3px}.adminHomePage .controlBox .dateSpanSelector{padding-bottom:3px;display:inline-block}.adminHomePage .controlBox .dateSpanSelector button{padding-left:0}.adminHomePage .setupLink{margin-top:1%;margin-bottom:1%}", ""]);
	
	// exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".codeTable{font-size:.9em}.codeTable .table{table-layout:fixed}.codeTable .table td,.codeTable .table th{vertical-align:middle;overflow-wrap:break-word}.codeTable .table .success{color:rgba(19,128,0,.7607843137)}.codeTable .table .fail{color:rgba(255,0,0,.664)}.codeTable .table .codeStatusHeader,.codeTable .table .nameHeader{width:20%}.codeTable .table .codeHeader,.codeTable .table .onboardingStatusHeader{width:16%}.codeTable .table .emailHeader{width:28%}.codeTable .table .noPadding{padding:0}.spinnerContainer{padding-left:7em;padding-top:1em}", ""]);
	
	// exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".logsApprovalModal .modal-dialog{width:750px}.logsApprovalModal .logTable{width:85%}.logsApprovalModal .instructionsText{text-align:center}.logsApprovalModal .outerTitles .buttonSuccess{min-width:40px!important;font-size:.8em}.logsApprovalModal .logTable{margin-bottom:40px}", ""]);
	
	// exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".parentInfoModal .inputContainer{display:inline-block;margin:5px;width:47%}.parentInfoModal .inputContainer .inputLabel{margin-bottom:5px;font-weight:700}.parentInfoModal .terms{font-size:.8em;margin-top:15px;width:60%;margin-left:20%;text-align:center}.parentInfoModal .buttonSuccess{margin-top:15px}", ""]);
	
	// exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#parentPage{position:relative}#parentPage .displayToggleControl{position:absolute;right:0}#parentPage .readingLogsSection .logCalendar,#parentPage .reportContainer{margin-top:5px}#parentPage .parentContentContainer{min-height:200px}#parentPage .studentOwlvatar{position:relative;top:50px}#parentPage .dashboardContainer{width:80%;display:inline-block;text-align:center;margin-top:15px}#parentPage .dashboardContainer .regularContainer{display:inline-block;margin-right:50px;margin-bottom:15px}#parentPage .dashboardContainer .regularContainer .amount{font-size:2.1em}#parentPage .dashboardContainer .regularContainer img{width:40px}#parentPage .dashboardContainer .circleContainer{width:24%;display:inline-block;margin:5px}#parentPage .dashboardContainer .circleContainer .infoContainer{position:relative;bottom:5px}#parentPage .dashboardContainer .circleContainer .infoContainer .statTotal{text-align:center;margin-bottom:0;font-size:2.1em;position:relative;bottom:5px}#parentPage .dashboardContainer .circleContainer .infoContainer .currentContainer{position:relative;bottom:10px;font-size:.8em}#parentPage .dashboardContainer .circleContainer .infoContainer .totalText{text-align:center;color:#999;position:relative;top:10px}#parentPage .dashboardContainer .circleContainer .metricIcon{width:30px;position:relative;bottom:38px}", ""]);
	
	// exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mergeStudentListsForm .slList{height:35em;overflow:scroll}.mergeStudentListsForm .slList .btnContainer{text-align:center;margin-top:1em}.mergeStudentListsForm .slList .btnContainer .submitLink{width:10em}.mergeStudentListsForm .slRow{width:100%;display:inline-block;padding:.3em 0}.mergeStudentListsForm .slRow.borderBottom{border-bottom:1px solid #eee}.mergeStudentListsForm .slRow .slColumn{width:50%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1em}.mergeStudentListsForm .slRow .slOptionsColumn{width:45%;display:inline-block;vertical-align:top}.mergeStudentListsForm .slRow .slOptionsColumn .btn-group{width:100%}.mergeStudentListsForm .slRow .slOptionsColumn .btn-group .dropdown-toggle{width:100%;white-space:nowrap;overflow:scroll;text-overflow:ellipsis}.mergeStudentListsForm .labelRow{width:100%;font-size:1.2em;border-bottom:1px solid #ddd}.mergeStudentListsForm .labelRow .studentListListLabel{width:50%;display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mergeUserForm .paginationControls{margin-top:1em}.mergeUserForm .btnContainer{text-align:center;margin-top:1em}.mergeUserForm .btnContainer .submitLink{width:10em}.mergeUserForm .userRow{width:100%;display:inline-block;padding:.5em 0}.mergeUserForm .userRow.borderBottom{border-bottom:1px solid #eee}.mergeUserForm .userRow .userColumn{width:40%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:.5em}.mergeUserForm .userRow .duplicateUsersColumn{width:55%;display:inline-block;vertical-align:top}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer{margin-top:.5em;display:inline-block;width:100%}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer .suggestionRow{display:inline-block;width:100%}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer .suggestionRow .column{display:inline-block}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer .suggestionRow .column.two{float:right}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer .perfectMatch{color:#42af14}.mergeUserForm .userRow .duplicateUsersColumn .suggestionContainer .partialMatch{color:#e19d03}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer{margin-top:.5em}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .merge{display:inline-block;width:65%}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .perfectMerge{background-color:#d0e9fd}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .partialMerge{background-color:#fcdb91}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .weakMerge{background-color:#fcd591}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .warning{background-color:#ffcccb}.mergeUserForm .userRow .duplicateUsersColumn .mergeContainer .changeMerge{float:right}.mergeUserForm .userRow .duplicateUsersColumn .btn-group{width:100%}.mergeUserForm .userRow .duplicateUsersColumn .btn-group .dropdown-toggle{width:100%;white-space:nowrap;overflow:scroll;text-overflow:ellipsis}.mergeUserForm .userRow .otherSuggestions{font-size:.8em;font-style:italic;opacity:.8}.mergeUserForm .labelRow{width:100%;font-size:1.2em;border-bottom:1px solid #ddd}.mergeUserForm .labelRow .userListLabel{width:40%;display:inline-block}.mergeUserForm .labelRow .dupUserListLabel{width:60%;display:inline-block}.mergeUserForm .duplicateUsersDropdown .Select--single{width:80%;display:inline-block}.mergeUserForm .duplicateUsersDropdown .changeSuggestion{float:right}", ""]);
	
	// exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mainSection{position:relative;text-align:center;display:flex;flex-direction:column;justify-content:flex-start;margin-top:2%}.mainSection .panelContainer{width:100%;float:left;height:auto;padding-left:5%;padding-right:5%;margin-bottom:3%;margin-top:3%}.mainSection .leftPanel{width:45%;float:left;height:auto}.mainSection .owlvatar{padding-left:11%}.mainSection .rightPanel{width:55%;float:left;height:auto;padding-left:10%}.mainSection .adjustedRightPanel{padding-top:5%}.mainSection .sidePanel{float:left}.mainSection .levelContainer{flex:1;text-align:left;display:flex;flex-direction:row;padding-top:5%;padding-left:5%}.mainSection .tierNumber{flex:1}.mainSection .progressBar{flex:6}.mainSection .nameString{font-size:2.1em;text-align:center}.mainSection .progress{border-radius:10px;height:10px;margin-bottom:5px}.mainSection .ProgressBar{margin-bottom:5px!important}.mainSection .name{flex:1;display:flex;flex-direction:row;justify-content:center}.mainSection .eggContainer{padding-top:.5%;padding-left:2%}.mainSection .shopPanel{display:flex;flex-direction:column}.mainSection .progressContainer{flex:1;display:flex;flex-direction:row;margin-top:3rem}.mainSection .explanationString{flex:4}.mainSection .coinsContainer{flex:1;display:flex;justify-content:flex-end}.mainSection .eggs{display:inline-block}.mainSection .eggs .goldenEggOutofModal{width:30px}.mainSection.eggMargin{margin-bottom:25px}.mainSection .avatarBackground{border-radius:50%;height:12em;width:12em;margin-left:10%;cursor:pointer;position:relative}.mainSection .backgroundBorder{border:2px solid #000}.mainSection .levelBar{background-color:gold}.mainSection .centeredOwl{position:absolute;bottom:0;padding-bottom:8%}.mainSection .shadow{border-radius:50%;width:48%;height:150px;background:#000;opacity:1;filter:blur(10px);transform:scaleY(.2);margin-top:47%;margin-left:27%}", ""]);
	
	// exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".ComponentDemonstrator .demo{transition:left .5s;float:left}.ComponentDemonstrator.slideLeft{left:0}.ComponentDemonstrator .questionFeedbackBox{position:relative;float:right;left:10%}", ""]);
	
	// exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".owlfonsoChat .typingDisplay{text-align:center;color:#888;clear:both;opacity:1;transition:opacity .8s}.owlfonsoChat .typingDisplay.slide-enter{opacity:0}.owlfonsoChat .typingDisplay.slide-enter-active{opacity:1}.owlfonsoChat .chatBox,.owlfonsoChat .chatChoice{border:1px solid #ddd;border-radius:5px;padding:1rem;font-size:.8em;display:inline-block}.owlfonsoChat .chatBox{max-width:16rem;margin-left:1rem;margin-right:1rem}.owlfonsoChat .owlfonsoChatItem,.owlfonsoChat .studentChatItem{max-width:86%;margin-bottom:1rem}.owlfonsoChat .owlfonsoChatItem .chatBox,.owlfonsoChat .studentChatItem .chatBox{position:relative}.owlfonsoChat .owlfonsoChatItem .chatBox:after,.owlfonsoChat .owlfonsoChatItem .chatBox:before,.owlfonsoChat .studentChatItem .chatBox:after,.owlfonsoChat .studentChatItem .chatBox:before{border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.owlfonsoChat .owlfonsoChatItem{float:left;position:relative;opacity:1;left:0;transition:opacity .6s,left .6s}.owlfonsoChat .owlfonsoChatItem.slide-enter{opacity:0;left:-100px}.owlfonsoChat .owlfonsoChatItem.slide-enter-active{opacity:1;left:0}.owlfonsoChat .owlfonsoChatItem .avatarCircle{display:inline-block}.owlfonsoChat .owlfonsoChatItem .chatBox:after,.owlfonsoChat .owlfonsoChatItem .chatBox:before{right:100%;bottom:8px}.owlfonsoChat .owlfonsoChatItem .chatBox:after{border-color:transparent;border-right-color:#fff;border-width:6px;margin-bottom:10px}.owlfonsoChat .owlfonsoChatItem .chatBox:before{border-color:transparent;border-right-color:#ddd;border-width:8px;margin-bottom:8px}.owlfonsoChat .studentChatItem{float:right;position:relative;opacity:1;right:0;transition:opacity .6s,right .6s}.owlfonsoChat .studentChatItem.slide-enter{opacity:0;right:-100px}.owlfonsoChat .studentChatItem.slide-enter-active{opacity:1;right:0}.owlfonsoChat .studentChatItem .avatarCircle{display:inline-block;float:right}.owlfonsoChat .studentChatItem .chatBox:after,.owlfonsoChat .studentChatItem .chatBox:before{left:100%;bottom:8px;transform:rotate(180deg)}.owlfonsoChat .studentChatItem .chatBox:after{border-color:transparent;border-right-color:#fff;border-width:6px;margin-bottom:10px}.owlfonsoChat .studentChatItem .chatBox:before{border-color:transparent;border-right-color:#ddd;border-width:8px;margin-bottom:8px}.owlfonsoChat .chatHistory{min-height:36.5rem;padding:0 1rem}.owlfonsoChat .chatChoicesDisplay{padding:0 1rem;margin-top:1rem;border-top:2px solid #ddd;text-align:center}.owlfonsoChat .chatChoicesDisplay .chatChoice{width:45%;margin-left:2.5%;margin-right:2.5%;margin-top:1.2rem;text-align:center;background-color:#00a0f4;border-color:#00a0f4;color:#fff}.owlfonsoChat .speechControlsContainer{position:absolute;bottom:.7rem;right:-2rem}.owlfonsoChat .speechControlsContainer .textToSpeech{height:2rem}", ""]);
	
	// exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".progressDisplay .timeSpanTitle{font-size:1.4em}.progressDisplay .pointsTotal{font-size:.8em;margin-bottom:5px}.progressDisplay .progress{width:75%;margin-bottom:10px}.progressDisplay .fullReportLink{font-size:.8em;display:none}", ""]);
	
	// exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentClozeStatus{margin-left:10px;margin-bottom:25px}.studentClozeStatus .clozeHeader{font-size:1.4em}.studentClozeStatus .cLeft,.studentClozeStatus .progress{display:inline-block;width:500px;max-width:70%}.studentClozeStatus .actionButton{display:inline-block;margin-left:5%;vertical-align:bottom}.studentClozeStatus .progress{margin-bottom:0;margin-top:-14px;vertical-align:bottom}", ""]);
	
	// exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentDisplay{display:inline-block}.studentDisplay.nameAndAvatar .name{margin-left:.2em}.studentDisplay .academicLevelText{color:#888}.studentDisplay .editable{text-decoration:none;color:#555}.studentDisplay .textContent{display:inline-block;vertical-align:middle}", ""]);
	
	// exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentExpectationsDisplay .dateSpanSelector .btn-group button{padding-left:0}.studentExpectationsDisplay .progressDisplay,.studentExpectationsDisplay .singleStat{display:inline-block;width:20%;vertical-align:top;margin-right:25px}.studentExpectationsDisplay .studentExpectationsDisplay .assignmentHeaderText{font-size:1.4em}.studentExpectationsDisplay .metric{font-size:1.4em;margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#studentHomePageStreamlined .dividerSection{margin-top:25px;margin-bottom:35px;position:relative;text-align:center}#studentHomePageStreamlined .dividerSection .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}#studentHomePageStreamlined .dividerSection .nameArea{padding-left:40px;padding-right:40px;background-color:#fff;display:inline-block;position:relative;min-height:47px}#studentHomePageStreamlined .dividerSection .nameArea .nameString{font-size:2.1em;margin-right:15px;margin-left:15px}#studentHomePageStreamlined .dividerSection .eggs{display:inline-block}#studentHomePageStreamlined .dividerSection .eggs .goldenEggOutofModal{width:30px}#studentHomePageStreamlined .dividerSection.eggMargin{margin-bottom:25px}#studentHomePageStreamlined .dashboardContainer{width:71%;display:inline-block}@keyframes bounceArrow{0%,20%,50%,80%,to{transform:translateX(0)}40%{transform:translateX(5px)}60%{transform:translateX(10px)}}#studentHomePageStreamlined .dashboardContainer .arrow{position:relative;top:-75px;right:15px;font-size:30px;animation:2s bounceArrow infinite}#studentHomePageStreamlined .dashboardContainer .arrow:first-child{padding:4px 4px 0;border-radius:3px 3px 0 0}#studentHomePageStreamlined .dashboardContainer .arrow:last-child{padding:0 4px 4px;border-radius:0 0 3px 3px}#studentHomePageStreamlined .dashboardContainer a{cursor:pointer}#studentHomePageStreamlined .dashboardContainer a:hover{opacity:.7}#studentHomePageStreamlined .dashboardContainer .regularContainer{display:inline-block;margin-right:50px;margin-bottom:15px}#studentHomePageStreamlined .dashboardContainer .regularContainer .amount{font-size:2.1em}#studentHomePageStreamlined .dashboardContainer .regularContainer img{width:40px}#studentHomePageStreamlined .dashboardContainer .circleContainer{width:31.7%;display:inline-block;margin:5px}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer{position:relative;bottom:40px}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .statTotal{text-align:center;margin-bottom:0;font-size:2.1em;position:relative;bottom:5px}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .metricCategory,#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .totalText{font-size:.8em;position:relative;bottom:10px;text-align:center;margin-bottom:0}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .totalText{color:#999}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .metricCategory,#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer .statTotal{color:#555}#studentHomePageStreamlined .dashboardContainer .circleContainer .infoContainer button{font-size:.8em}#studentHomePageStreamlined .dashboardContainer .circleContainer .metricIcon{width:35px;position:relative;bottom:53px}#studentHomePageStreamlined .dashboardContainer.widerDashboard{width:80%;margin:auto;display:block}#studentHomePageStreamlined .studentTasksContainer{width:20%;display:inline-block;vertical-align:top;margin-right:5%;position:relative;bottom:20px}#studentHomePageStreamlined .studentTasksContainer .subHeader{font-weight:400;text-align:left}#studentHomePageStreamlined .studentTasksContainer .studentTasks{cursor:pointer}#studentHomePageStreamlined .studentTasksContainer .studentTasks img{width:15px}#studentHomePageStreamlined .studentTasksContainer .studentTasks .task{margin-bottom:15px}#studentHomePageStreamlined .studentTasksContainer .studentTasks .task:hover{opacity:.7}#studentHomePageStreamlined .studentTasksContainer .studentTasks .task .category{font-size:.8em;color:#999;margin-left:5px}#studentHomePageStreamlined .studentTasksContainer .studentTasks .task .taskTitle{margin-bottom:5px;max-height:4em;overflow:hidden}#studentHomePageStreamlined .studentTasksContainer .studentTasks .task .bookDisplay .title{margin-bottom:0}#studentHomePageStreamlined .studentTaskGridContainer{width:100%;display:inline-block;vertical-align:top;margin-right:5%;position:relative;bottom:20px;margin-top:30px}#studentHomePageStreamlined .studentTaskGridContainer .subHeader{font-weight:400;text-align:center}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks{cursor:pointer}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks img{width:15px}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks .task{margin-bottom:15px;width:100%}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks .task:hover{opacity:.7}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks .task .category{font-size:.8em;color:#999;margin-left:5px}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks .task .taskTitle{margin-bottom:5px;max-height:4em;overflow:hidden}#studentHomePageStreamlined .studentTaskGridContainer .studentTasks .task .bookDisplay .title{margin-bottom:0}#studentHomePageStreamlined .bookActionSection{margin-top:5px}#studentHomePageStreamlined .bookActionSection .recommendedBooksContainer .bookCover{cursor:pointer}#studentHomePageStreamlined .bookActionSection .recommendedBooksContainer .bookDisplay{display:inline-block;margin-right:5px;margin-bottom:25px}#studentHomePageStreamlined .dateSpanSelectorWrap{display:inline-block;margin-right:15px}#studentHomePageStreamlined .emptyDashboard{width:100%}#studentHomePageStreamlined .emptyDashboard img{width:115px}#studentHomePageStreamlined .emptyDashboard .leftContainer{display:inline-block}#studentHomePageStreamlined .emptyDashboard .emptyStateLinks{width:18%;margin-left:175px;text-align:center;vertical-align:top}#studentHomePageStreamlined .emptyStateLinks,#studentHomePageStreamlined .linksContainer{position:relative;display:inline-block}#studentHomePageStreamlined .emptyStateLinks a,#studentHomePageStreamlined .linksContainer a{display:block;cursor:pointer;margin-bottom:15px}#studentHomePageStreamlined .emptyStateLinks a img,#studentHomePageStreamlined .linksContainer a img{margin-right:5px;width:25px}#studentHomePageStreamlined .linksContainer{float:right}#studentHomePageStreamlined .linksContainer a{display:inline-block;margin-right:15px}#studentHomePageStreamlined .saleBanner{margin-top:15px;cursor:pointer;text-align:center}#studentHomePageStreamlined .saleBanner .bannerImg{width:70%;height:auto}", ""]);
	
	// exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentHomePageVertical .studentActivities{overflow:hidden}.studentHomePageVertical .progressBarLabels{padding:5px;color:#fff;font-weight:700}.studentHomePageVertical .progressBarContainer{height:20px;width:100%;background-color:#e0e0de;border-radius:50px}.studentHomePageVertical .progressBarFiller{height:100%;background-color:#00a0f4;border-radius:inherit;text-align:right}.studentHomePageVertical .progressBar{padding-left:0;float:left}.studentHomePageVertical .progressBar.fullWidth,.studentHomePageVertical .progressBar.middleWidth{width:70%;transition:width .3s ease .3s;-moz-transition:width .3s ease .3s;-webkit-transition:width .3s ease .3s}.studentHomePageVertical .progressBar.truncated{width:45%;transition:width .3s ease .3s;-moz-transition:width .3s ease .3s;-webkit-transition:width .3s ease .3s}.studentHomePageVertical .bookCoverLeft{margin-right:5px}.studentHomePageVertical a{text-decoration:none!important}.studentHomePageVertical .additionalActivityContainer{padding-left:0;width:38.3333%;border-left:0 solid #fff;transition:border-left .3s ease .3s;-moz-transition:border-left .3s ease .3s;-webkit-transition:border-left .3s ease .3s}.studentHomePageVertical .additionalActivityContainer.borderLeft{border-left:2px solid #ddd;transition:all .3s ease .3s;-moz-transition:all .3s ease .3s;-webkit-transition:all .3s ease .3s}.studentHomePageVertical .additionalActivityContainer a.activityContainer{white-space:nowrap;text-overflow:ellipsis}.studentHomePageVertical .activityItemText{color:#555}.studentHomePageVertical .activityItemText.hide{display:none}.studentHomePageVertical .activityContainer{display:block;margin-bottom:15px}.studentHomePageVertical .isCompleted,.studentHomePageVertical .isRequired{margin-left:20px}.studentHomePageVertical .activityColumn{height:180px}.studentHomePageVertical .activityColumn,.studentHomePageVertical .activityColumn.expandedColumn220{transition:min-height .3s ease .3s;-moz-transition:min-height .3s ease .3s;-webkit-transition:min-height .3s ease .3s}.studentHomePageVertical .activityColumn.expandedColumn220{min-height:220px}.studentHomePageVertical .activityColumn.expandedColumn300{min-height:300px;transition:min-height .3s ease .3s;-moz-transition:min-height .3s ease .3s;-webkit-transition:min-height .3s ease .3s}.studentHomePageVertical .assignedActivityContainer{padding-right:0;width:45%;white-space:nowrap}.studentHomePageVertical .assignedActivityContainer.borderLeft .activityContainer{overflow:hidden;text-overflow:ellipsis}.studentHomePageVertical .activityItemText:hover{font-weight:700}.studentHomePageVertical .deactivateLink{color:#555;cursor:default}.studentHomePageVertical .deactivateLink:hover{font-weight:inherit}.studentHomePageVertical .bookTitle{display:block;width:100%;text-align:center;margin-bottom:15px;font-style:italic}.studentHomePageVertical .taskTitle{display:inline-block;margin-left:20px}.studentHomePageVertical .category{margin-left:20px;font-weight:700}.studentHomePageVertical .revisionTask{cursor:pointer;margin:20px;padding-bottom:20px;border-bottom:1px solid #ddd}.studentHomePageVertical .dividerSection{margin-top:25px;margin-bottom:35px;position:relative;text-align:center}.studentHomePageVertical .dividerSection .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}.studentHomePageVertical .dividerSection .nameArea{padding-left:40px;padding-right:40px;background-color:#fff;display:inline-block;position:relative;min-height:47px}.studentHomePageVertical .dividerSection .nameArea .nameString{font-size:2.1em;margin-right:15px;margin-left:15px}.studentHomePageVertical .dividerSection .eggs{display:inline-block}.studentHomePageVertical .dividerSection .eggs .goldenEggOutofModal{width:30px}.studentHomePageVertical .dividerSection.eggMargin{margin-bottom:25px}.studentHomePageVertical .dashboardContainer.activitiesPresent{width:25%;display:inline-block}.studentHomePageVertical .dashboardContainer.activitiesPresent .arrow{position:relative;top:-75px;right:15px;font-size:30px;animation:2s bounceArrow infinite}.studentHomePageVertical .dashboardContainer.activitiesPresent .arrow:first-child{padding:4px 4px 0;border-radius:3px 3px 0 0}.studentHomePageVertical .dashboardContainer.activitiesPresent .arrow:last-child{padding:0 4px 4px;border-radius:0 0 3px 3px}.studentHomePageVertical .dashboardContainer.activitiesPresent a{cursor:pointer}.studentHomePageVertical .dashboardContainer.activitiesPresent a:hover{opacity:.7}.studentHomePageVertical .dashboardContainer.activitiesPresent .regularContainer{display:inline-block;margin-right:50px;margin-bottom:15px}.studentHomePageVertical .dashboardContainer.activitiesPresent .regularContainer .amount{font-size:2.1em}.studentHomePageVertical .dashboardContainer.activitiesPresent .regularContainer img{width:40px}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer{width:100%;display:inline-block;margin:5px}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer{position:relative;bottom:40px}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .statTotal{text-align:center;margin-bottom:0;font-size:2.5em;position:relative;bottom:5px}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .metricCategory,.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .totalText{font-size:.8em;position:relative;bottom:10px;text-align:center;margin-bottom:0}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .totalText{color:#999}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .metricCategory,.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer .statTotal{color:#555}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .infoContainer button{font-size:.8em}.studentHomePageVertical .dashboardContainer.activitiesPresent .circleContainer .metricIcon{width:35px;position:relative;bottom:75px}.studentHomePageVertical .dashboardContainer.activitiesPresent.widerDashboard{width:80%;margin:auto;display:block}.studentHomePageVertical .dashboardContainer.activitiesPresent .subTitleContainer{min-width:200px;margin-bottom:20px;position:relative;text-align:center}.studentHomePageVertical .dashboardContainer.activitiesPresent .subTitleContainer .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:100%}.studentHomePageVertical .dashboardContainer.activitiesPresent .subTitleContainer .nameArea{border-bottom:2px solid #ddd;padding-left:40px;padding-right:40px;background-color:#fff;display:inline-block;position:relative;min-height:47px}.studentHomePageVertical .dashboardContainer.activitiesPresent .subTitleContainer .nameArea .nameString{font-size:1.3em}.studentHomePageVertical .dashboardContainer.activitiesPresent .dateSpanSelectorWrap{display:inline-block;margin-right:15px;margin-bottom:30px}.studentHomePageVertical .dashboardContainer.noActivities{width:100%;display:inline-block;text-align:center}@keyframes bounceArrow{0%,20%,50%,80%,to{transform:translateX(0)}40%{transform:translateX(5px)}60%{transform:translateX(10px)}}.studentHomePageVertical .dashboardContainer.noActivities .arrow{position:relative;top:-75px;right:15px;font-size:30px;animation:2s bounceArrow infinite}.studentHomePageVertical .dashboardContainer.noActivities .arrow:first-child{padding:4px 4px 0;border-radius:3px 3px 0 0}.studentHomePageVertical .dashboardContainer.noActivities .arrow:last-child{padding:0 4px 4px;border-radius:0 0 3px 3px}.studentHomePageVertical .dashboardContainer.noActivities a{cursor:pointer}.studentHomePageVertical .dashboardContainer.noActivities a:hover{opacity:.7}.studentHomePageVertical .dashboardContainer.noActivities .regularContainer{display:inline-block;margin-right:50px;margin-bottom:15px}.studentHomePageVertical .dashboardContainer.noActivities .regularContainer .amount{font-size:2.1em}.studentHomePageVertical .dashboardContainer.noActivities .regularContainer img{width:40px}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer{width:31%;display:inline-block;margin:5px}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer{position:relative;bottom:40px}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .statTotal{text-align:center;margin-bottom:0;font-size:3em;position:relative;bottom:5px}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .metricCategory,.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .totalText{font-size:.8em;position:relative;bottom:10px;text-align:center;margin-bottom:0}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .totalText{color:#999}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .metricCategory,.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer .statTotal{color:#555}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .infoContainer button{font-size:.8em}.studentHomePageVertical .dashboardContainer.noActivities .circleContainer .metricIcon{width:50px;position:relative;bottom:100px}.studentHomePageVertical .dashboardContainer.noActivities.widerDashboard{width:80%;margin:auto;display:block}.studentHomePageVertical .dashboardContainer.noActivities .subTitleContainer{min-width:200px;margin-bottom:50px;position:relative;text-align:center}.studentHomePageVertical .dashboardContainer.noActivities .subTitleContainer .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:100%}.studentHomePageVertical .dashboardContainer.noActivities .subTitleContainer .nameArea{border-bottom:2px solid #ddd;padding-left:40px;padding-right:40px;background-color:#fff;display:inline-block;position:relative;min-height:47px}.studentHomePageVertical .dashboardContainer.noActivities .subTitleContainer .nameArea .nameString{font-size:1.7em}.studentHomePageVertical .dashboardContainer.noActivities .dateSpanSelectorWrap{float:left}.studentHomePageVertical .activityCoverImage{width:105px;height:auto}.studentHomePageVertical .row{margin-left:0;margin-right:0}.studentHomePageVertical .row-padding-bottom{padding-bottom:10px}.studentHomePageVertical .activityIcon{max-width:35px;margin-right:15px;margin-left:15px}.studentHomePageVertical .glyphicon-check-green{font-size:20px;top:5px;color:green}.studentHomePageVertical .glyphicon-check-gray{font-size:20px;top:5px;color:#ddd}.studentHomePageVertical .hide-glyphicon{font-size:20px;top:5px;opacity:0}.studentHomePageVertical .colorRed{color:red}.studentHomePageVertical .colorGreen{color:green}.studentHomePageVertical .colorBlack{color:#555}.studentHomePageVertical .col-sm-2{padding-left:0}.studentHomePageVertical .col-sm-10{margin-left:0;margin-right:0}.studentHomePageVertical .col-sm-6{padding-left:0;padding-right:0}.studentHomePageVertical .padding-left{padding-left:5%}.studentHomePageVertical .activityRowContainer{margin:20px;padding-bottom:20px}.studentHomePageVertical .borderBottom{border-bottom:1px solid #ddd}.studentHomePageVertical .dueDate{float:left;margin-left:15px}.studentHomePageVertical .dueDateRow{margin-bottom:20px}.studentHomePageVertical .bookCoverRight{float:left;margin-right:10px}.studentHomePageVertical .bookCoverLeft{float:left}.studentHomePageVertical .activitiesContainer{width:75%;display:inline-block;vertical-align:top;position:relative;padding-left:12%}.studentHomePageVertical .activitiesContainer .subTitleContainer{margin-bottom:35px;position:relative;text-align:center}.studentHomePageVertical .activitiesContainer .subTitleContainer .nameArea{border-bottom:2px solid #ddd;padding-left:40px;padding-right:40px;background-color:#fff;display:inline-block;position:relative;min-height:47px}.studentHomePageVertical .activitiesContainer .subTitleContainer .nameArea .nameString{font-size:1.3em}.studentHomePageVertical .activitiesContainer .studentTasks{cursor:pointer}.studentHomePageVertical .activitiesContainer .studentTasks img{width:15px}.studentHomePageVertical .activitiesContainer .studentTasks .task{margin-bottom:15px}.studentHomePageVertical .activitiesContainer .studentTasks .task:hover{opacity:.7}.studentHomePageVertical .activitiesContainer .studentTasks .task .category{font-size:.8em;color:#999;margin-left:5px}.studentHomePageVertical .activitiesContainer .studentTasks .task .taskTitle{margin-bottom:5px;max-height:4em;overflow:hidden}.studentHomePageVertical .activitiesContainer .studentTasks .task .bookDisplay .title{margin-bottom:0}.studentHomePageVertical .bookActionSection{padding-right:10%;padding-left:10%;margin-top:5px}.studentHomePageVertical .bookActionSection .recommendedBooksContainer .bookCover{cursor:pointer}.studentHomePageVertical .bookActionSection .recommendedBooksContainer .bookDisplay{display:inline-block;margin-right:5px;margin-bottom:25px}.studentHomePageVertical .emptyDashboard{width:100%}.studentHomePageVertical .emptyDashboard img{width:115px}.studentHomePageVertical .emptyDashboard .leftContainer{display:inline-block}.studentHomePageVertical .emptyDashboard .emptyStateLinks{width:18%;margin-left:175px;text-align:center;vertical-align:top}.studentHomePageVertical .emptyStateLinks,.studentHomePageVertical .linksContainer{position:relative;display:inline-block}.studentHomePageVertical .emptyStateLinks a,.studentHomePageVertical .linksContainer a{display:block;cursor:pointer;margin-bottom:15px}.studentHomePageVertical .emptyStateLinks a img,.studentHomePageVertical .linksContainer a img{margin-right:5px;width:25px}.studentHomePageVertical .linksContainer{text-align:center}.studentHomePageVertical .linksContainer a{display:inline-block;margin-right:15px}.studentHomePageVertical .saleBanner{margin-top:15px;cursor:pointer;text-align:center}.studentHomePageVertical .saleBanner .bannerImg{width:70%;height:auto}@media only screen and (max-width:950px){.studentHomePageVertical .activityIcon{max-width:25px;margin-left:5px;margin-right:5px}.studentHomePageVertical .optionalHeader{font-size:14px}.studentHomePageVertical .activityContainer{font-size:12px}.studentHomePageVertical .glyphicon-check-gray,.studentHomePageVertical .glyphicon-check-green{font-size:15px}.studentHomePageVertical .circleContainer{font-size:12px}.studentHomePageVertical .noActivities .metricIcon{top:-90px}.studentHomePageVertical .infoContainer{margin-top:20px}.studentHomePageVertical .infoContainer button{font-size:.6em}}@media only screen and (max-width:920px){.studentHomePageVertical .bookCover img{width:90px!important}.studentHomePageVertical .additionalActivityContainer{width:40%}.studentHomePageVertical .optionalHeader{font-size:14px;margin-bottom:0!important;margin-left:5px}.studentHomePageVertical .assignedActivityContainer{width:40%}.studentHomePageVertical .activityIcon{max-width:25px;margin-left:15px;margin-right:15px}.studentHomePageVertical .activityContainer{font-size:14px;padding-bottom:5px}.studentHomePageVertical .activityContainer.notRequired{margin-bottom:0}.studentHomePageVertical .drawerTrigger{font-size:14px}.studentHomePageVertical .activitiesPresent .metricIcon{top:-60px}}@media only screen and (max-width:780px){.studentHomePageVertical .bookCoverContainer{text-align-last:center}.studentHomePageVertical .additionalActivityContainer,.studentHomePageVertical .assignedActivityContainer{float:left}.studentHomePageVertical .noActivities .metricIcon{top:-75px}}", ""]);
	
	// exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentOnboardingModal .modal-dialog{width:80rem}.studentOnboardingModal .modal-content{min-height:45rem}.studentOnboardingModal .modal-body{padding:0}.studentOnboardingModal .separator{margin-right:7px;margin-left:7px}.studentOnboardingModal .logOutLink{position:absolute;top:3rem;left:3rem;font-size:.8em}.studentOnboardingModal .hiddenSkipLink{position:absolute;right:95%;top:95%;width:5%;height:5%}.studentOnboardingModal .leftColWrapper,.studentOnboardingModal .rightColWrapper{display:inline-block;vertical-align:top;height:45rem}.studentOnboardingModal .leftColWrapper{width:64%}.studentOnboardingModal .rightColWrapper{width:36%;border-left:2px solid #ddd}.studentOnboardingModal .leftCol{padding:3rem}.studentOnboardingModal .rightCol{padding:1rem 0}.studentOnboardingModal .studentOnboardingImage{text-align:center}.studentOnboardingModal .studentOnboardingImage img{display:inline-block}.studentOnboardingModal .studentOnboardingImage .stage-owlfonso-waving{width:20rem;margin-top:8rem}.studentOnboardingModal .studentOnboardingImage .stage-profile-action-buttons{width:40rem;margin-top:4rem}.studentOnboardingModal .studentOnboardingImage .stage-practice-question-1,.studentOnboardingModal .studentOnboardingImage .stage-practice-question-2,.studentOnboardingModal .studentOnboardingImage .stage-practice-question-3{width:36rem;margin-top:4rem}.studentOnboardingModal .studentOnboardingImage .stage-quiz-1{width:38rem;margin-top:3rem}.studentOnboardingModal .studentOnboardingImage .stage-quiz-2,.studentOnboardingModal .studentOnboardingImage .stage-quiz-3{width:30rem;margin-top:2rem}.studentOnboardingModal .studentOnboardingImage .stage-feedback-1,.studentOnboardingModal .studentOnboardingImage .stage-feedback-2,.studentOnboardingModal .studentOnboardingImage .stage-feedback-3{width:45rem;margin-top:4rem}.studentOnboardingModal .studentOnboardingImage .stage-examples-1,.studentOnboardingModal .studentOnboardingImage .stage-examples-2,.studentOnboardingModal .studentOnboardingImage .stage-examples-3{width:40rem;margin-top:2rem}.studentOnboardingModal .studentOnboardingImage .stage-annotated-example-1,.studentOnboardingModal .studentOnboardingImage .stage-annotated-example-2,.studentOnboardingModal .studentOnboardingImage .stage-annotated-example-3{width:40rem;margin-top:3rem}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-hats .hatContainer{margin-top:3rem}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-hats .hatImg{width:6.9rem;height:auto;margin-left:2rem;margin-right:2rem}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-hats .activeHat{left:5rem;top:14rem;z-index:1400;position:absolute}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-hats .owlConstraints{position:absolute;top:10rem;left:12rem}.studentOnboardingModal .studentOnboardingImage .stage-honor-pledge{width:40rem}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-rays{margin-top:8rem}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-rays .owlConstraints{float:right}.studentOnboardingModal .studentOnboardingImage .stage-student-avatar-rays .owlfonsoWaving{width:20rem}.studentOnboardingModal .expectationsContainer{margin-top:50px;width:85%;display:inline-block;text-align:center}@keyframes bounceArrow{0%,20%,50%,80%,to{transform:translateX(0)}40%{transform:translateX(5px)}60%{transform:translateX(10px)}}.studentOnboardingModal .expectationsContainer .arrow{position:relative;top:-75px;right:15px;font-size:30px;animation:2s bounceArrow infinite}.studentOnboardingModal .expectationsContainer .arrow:first-child{padding:4px 4px 0;border-radius:3px 3px 0 0}.studentOnboardingModal .expectationsContainer .arrow:last-child{padding:0 4px 4px;border-radius:0 0 3px 3px}.studentOnboardingModal .expectationsContainer a{cursor:pointer}.studentOnboardingModal .expectationsContainer a:hover{opacity:.7}.studentOnboardingModal .expectationsContainer .regularContainer{display:inline-block;margin-right:50px;margin-bottom:15px}.studentOnboardingModal .expectationsContainer .regularContainer .amount{font-size:2.1em}.studentOnboardingModal .expectationsContainer .regularContainer img{width:40px}.studentOnboardingModal .expectationsContainer .circleContainer{width:45%;display:inline-block;margin:5px}.studentOnboardingModal .expectationsContainer .circleContainer .infoContainer{position:relative;bottom:5px}.studentOnboardingModal .expectationsContainer .circleContainer .infoContainer .statTotal{text-align:center;margin-bottom:0;font-size:2.1em;position:relative;bottom:5px}.studentOnboardingModal .expectationsContainer .circleContainer .infoContainer .currentContainer{position:relative;bottom:10px;font-size:.8em}.studentOnboardingModal .expectationsContainer .circleContainer .infoContainer .totalText{text-align:center;color:#999;position:relative;top:10px}.studentOnboardingModal .expectationsContainer .circleContainer .metricIcon{height:30px;position:relative;bottom:38px}.studentOnboardingModal .expectationsContainer .circleContainer .buttonPrimary{pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".CircularProgressbar .CircularProgressbar-path{stroke:#2b9401;stroke-linecap:round;transition:stroke-dashoffset .5s ease 0s}.CircularProgressbar .CircularProgressbar-trail{stroke:#d6d6d6;stroke-linecap:round}.CircularProgressbar .CircularProgressbar-text{fill:#555;font-size:20px;dominant-baseline:middle;text-anchor:middle}.CircularProgressbar .CircularProgressbar-background{fill:#d6d6d6}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background{fill:#3e98c7}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text{fill:#fff}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path{stroke:#fff}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail{stroke:transparent}", ""]);
	
	// exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentReportModal .evaluationContainer .extraCoinsText,.studentReportModal .evaluationContainer .initialInstructions{text-align:center}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer{width:60%;margin:auto}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer label{display:block}.studentReportModal .evaluationContainer .selfEvaluationForm .labelsContainer label input{margin-right:5px}.studentReportModal .evaluationContainer .selfEvaluationForm .evaluationTextArea{width:75%;margin:auto;margin-bottom:15px}.studentReportModal .evaluationContainer .selfEvaluationForm .extraCoinsText{font-size:.8em;margin-top:10px;margin-bottom:15px}.studentReportModal .evaluationContainer .selfEvaluationForm .buttonSuccess{display:block;margin:auto}", ""]);
	
	// exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".accountCustomizer{padding-right:2rem;margin-bottom:1rem}.accountCustomizer .currentViewContent,.accountCustomizer .leftNavSection{display:inline-block;vertical-align:top}.accountCustomizer .leftNavSection{width:15%;border-right:1px solid #ddd;padding-right:2rem}.accountCustomizer .currentViewContent{width:85%;padding-left:2rem}.accountCustomizer .leftNavLink{display:block;padding-top:.5rem;padding-bottom:.5rem}.accountCustomizer .leftNavLink.selected{font-weight:700}.accountCustomizer .planDetails,.accountCustomizer .planLabel{display:inline-block;vertical-align:top;color:#888}.accountCustomizer .planLabel{width:18%}.accountCustomizer .changeLink{display:inline-block;margin-left:1rem;font-size:.8em}.accountCustomizer .planRow{padding-bottom:.5rem}.accountCustomizer .planSection{padding-bottom:1rem}.accountCustomizer .purchaseDisclaimer{font-size:.8em;color:#888;padding-bottom:1rem}.accountCustomizer .updatePaymentForm{border-top:1px solid #ccc;padding-top:2rem;margin-top:1rem}.accountCustomizer .upgradeBox{border-radius:5px;margin-bottom:2rem}.accountCustomizer .upgradeSentence{font-weight:700;padding-bottom:1rem}.accountCustomizer .benefitsList{padding-bottom:2rem}.accountCustomizer .benefitItem{padding-bottom:.5rem}.accountCustomizer .benefitItem .benefitText,.accountCustomizer .benefitItem .glyphicon{display:inline-block;vertical-align:top}.accountCustomizer .benefitItem .glyphicon{margin-right:1rem}.accountCustomizer .upgradeContainer .buttonDefault,.accountCustomizer .upgradeContainer .buttonSuccess{margin-right:15px}.accountCustomizer .nextChargeDetails,.accountCustomizer .schoolPlanDetails{padding-top:1rem}.accountCustomizer .historyRow{border-bottom:1px solid #ddd}.accountCustomizer .historyCell{display:inline-block;vertical-align:top;padding:1rem;width:25%}.accountCustomizer .historyCell:nth-child(2){width:30%}.accountCustomizer .historyCell:nth-child(4){width:20%}.accountCustomizer .upgradeTokenForm{margin-top:30px}.accountCustomizer .upgradeTokenForm .errorDisplay{padding-top:0}", ""]);
	
	// exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".clozeCustomizerContainer .clozeInstructions{margin-top:2rem}.clozeCustomizerContainer .testDatePicker{margin-bottom:1rem;width:10rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.clozeCustomizerContainer .removeRowLink{color:#c31030}.clozeCustomizerContainer .paywallModal .modal-dialog{max-width:88%}.clozeCustomizerContainer .previewImage{max-width:80%;border:1px solid #ccc;margin-bottom:20px}.clozeCustomizerContainer .previewMessage{margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#teacherHomePage .trialStatusDisplay{margin-bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".expectationsCustomizerContainer{padding-left:3.5rem;padding-right:3.5rem;margin-bottom:1rem}.expectationsCustomizerContainer input,.expectationsCustomizerContainer select{margin-right:.5rem}.expectationsCustomizerContainer label{font-weight:400}.expectationsCustomizerContainer .moreOptionsLink{font-size:.8em}.expectationsCustomizerContainer .freqCol{position:relative;left:30px}.expectationsCustomizerContainer .quizFormColumn{margin-top:15px}.expectationsCustomizerContainer .quizFormColumn .formTitle{font-size:1.4em}.expectationsCustomizerContainer .quizFormColumn .goalFormTitle{margin-bottom:0}.expectationsCustomizerContainer .quizFormColumn .formOption{white-space:nowrap;display:block;margin-bottom:.5rem}.expectationsCustomizerContainer .quizFormColumn .formOption .quizLabel{width:62%}.expectationsCustomizerContainer .quizFormColumn .formOption select{padding:0 6px;height:27px}.expectationsCustomizerContainer .quizFormColumn .formOption .quizInput{width:30%;display:inline-block;white-space:nowrap}.expectationsCustomizerContainer .quizFormColumn .formOption .quizInput .goalAmountBox{width:100%;margin-left:0}.expectationsCustomizerContainer .quizFormColumn .formOption.withPer .quizInput input.goalAmountBox,.expectationsCustomizerContainer .quizFormColumn .formOption.withPer .quizInput select.form-control{width:45px;display:inline-block}.expectationsCustomizerContainer .quizFormColumn .per{font-size:.8em}.expectationsCustomizerContainer .quizFormColumn .maxGoalsSelected{opacity:.7}.expectationsCustomizerContainer .quizFormColumn .hintText{font-size:.8em}.expectationsCustomizerContainer .quizFormColumn .hintHeader{border-bottom:1px solid #ddd}.expectationsCustomizerContainer .quizFormColumn .goalError{color:#c31030}.expectationsCustomizerContainer .quizFormColumn .goalAmountBox{margin-left:.5rem;margin-top:-.1rem;height:2.4rem;width:66px;display:inline;padding:2px 4px}.expectationsCustomizerContainer .quizFormColumn .goalAmountBox.goal-questions{width:45px}.expectationsCustomizerContainer .quizFormColumn .validatingInput{display:inline}.expectationsCustomizerContainer .quizFormColumn .periodStartSelector{font-size:.8em;padding-left:2rem}.expectationsCustomizerContainer .quizFormColumn .periodSelectorLabel{margin-top:.1rem;padding-right:.5rem}.expectationsCustomizerContainer .quizFormColumn .dropdown-toggle{padding-left:0}.expectationsCustomizerContainer .quizFormColumn .buttonDropdown{margin-top:-.1rem}.expectationsCustomizerContainer .quizFormColumn .startDatePicker{margin-left:.5rem;margin-bottom:.7rem;width:9rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.expectationsCustomizerContainer .formColumn{display:inline-block;vertical-align:top;padding-top:1rem;padding-left:4rem;width:50%}.expectationsCustomizerContainer .formColumn .formTitle{font-size:1.4em}.expectationsCustomizerContainer .formColumn .goalFormTitle{margin-bottom:0}.expectationsCustomizerContainer .formColumn .formOption{display:block;margin-top:1rem;margin-bottom:1rem;white-space:nowrap}.expectationsCustomizerContainer .formColumn .maxGoalsSelected{opacity:.7}.expectationsCustomizerContainer .formColumn .hintText{font-size:.8em}.expectationsCustomizerContainer .formColumn .goalError{color:#c31030}.expectationsCustomizerContainer .formColumn .goalAmountBox{margin-left:.5rem;margin-top:-.1rem;height:2.4rem;width:45px;display:inline;font-size:.8em;padding:2px 4px}.expectationsCustomizerContainer .formColumn .validatingInput{display:inline}.expectationsCustomizerContainer .formColumn .periodStartSelector{font-size:.8em;margin-top:-1rem;padding-left:2rem}.expectationsCustomizerContainer .formColumn .periodSelectorLabel{margin-top:.1rem;padding-right:.5rem}.expectationsCustomizerContainer .formColumn .dropdown-toggle{padding-left:0}.expectationsCustomizerContainer .formColumn .buttonDropdown{margin-top:-.1rem}.expectationsCustomizerContainer .formColumn .startDatePicker{margin-left:.5rem;margin-bottom:.7rem;width:9rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.expectationsCustomizerContainer .buttonSuccess{margin-top:2rem}", ""]);
	
	// exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".onboardingChecklist{margin-bottom:20px}.onboardingChecklist .onboardingChecklistItem{display:inline-block;width:32%;margin-right:2%}.onboardingChecklist .onboardingChecklistItem:nth-child(3n){margin-right:0}.onboardingChecklist .onboardingChecklistItemSilverTrial{display:inline-block;width:50%;margin-right:0}.onboardingChecklist .onboardingChecklistItemSilverTrial:nth-child(3n){margin-right:0}.onboardingChecklist .verticalDivider{margin-left:10px;margin-right:10px}.onboardingChecklist .itemContainer{display:inline-block;width:100%}.onboardingChecklist .itemContainerSilverTrial{width:15%;display:inline-block;margin-right:10%}.onboardingChecklist .itemContainerSilverTrial .progressText{font-size:.8em;width:115%}.onboardingChecklist .itemContainerSilverTrial .trialLink{margin-left:15px}.onboardingChecklist .itemContainerSilverTrial .infoContainer .progressImg{width:30px;margin-bottom:10px}.onboardingChecklist .checklistItemsSilverTrial{width:65%;display:inline-block;vertical-align:top}.onboardingChecklist .optionsSilverTrial{position:relative;bottom:10px}.onboardingChecklist .skipLink{cursor:pointer}.onboardingChecklist .CircularProgressbar .CircularProgressbar-path{stroke:#3fb149;stroke-linecap:round;transition:stroke-dashoffset .5s ease 0s}.onboardingChecklist .CircularProgressbar .CircularProgressbar-trail{stroke:#d6d6d6;stroke-linecap:round}.onboardingChecklist .CircularProgressbar .CircularProgressbar-text{fill:#3fb149;font-size:20px;dominant-baseline:middle;text-anchor:middle}.onboardingChecklist .CircularProgressbar .CircularProgressbar-background{fill:#d6d6d6}.onboardingChecklist .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background{fill:#3fb149}.onboardingChecklist .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text{fill:#fff}.onboardingChecklist .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path{stroke:#fff}.onboardingChecklist .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail{stroke:transparent}", ""]);
	
	// exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".onboardingChecklistItem{margin-top:1rem;margin-bottom:1rem;cursor:pointer}.onboardingChecklistItem.complete{border-color:#42af14}.onboardingChecklistItem.incomplete{border-color:#ddd}.onboardingChecklistItem.next{border-color:#00a0f4}.onboardingChecklistItem .imageSection,.onboardingChecklistItem .infoSection{display:inline-block;vertical-align:middle}.onboardingChecklistItem .imageSection{width:15%;margin-right:1rem}.onboardingChecklistItem .itemImg{width:100%}.onboardingChecklistItem .infoSection{max-width:70%}.onboardingChecklistItem .completeText{color:#42af14;font-style:italic}.onboardingChecklistItem .verticalDivider{height:20px;border-color:#ddd;margin-left:5px;margin-right:5px}", ""]);
	
	// exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".onboardingModal .modal-dialog{width:800px}.onboardingModal .modal-content{min-height:450px;padding-top:15px;padding-bottom:20px}.onboardingModal .logOutLink{position:absolute;top:10px;left:25px;font-size:.8em;z-index:10}.onboardingModal .onboardingProgressSection{margin-left:12px;margin-bottom:25px}.onboardingModal .onboardingProgressSection .onboardingTitle{text-align:center;font-size:1.4em}.onboardingModal .progress{width:58%;height:15px;margin:0 auto 15px}.onboardingStage{position:relative}.onboardingStage .leftCol,.onboardingStage .rightCol{display:inline-block;width:50%;vertical-align:top}.onboardingStage .leftCol{padding-left:20px;padding-right:10px}.onboardingStage .rightCol{padding-left:25px;padding-right:20px}.onboardingStage .singleCol{padding-left:20px;padding-right:20px}.onboardingStage .onboardingTestimonial .quote{font-size:.8em}.onboardingStage .onboardingTestimonial .educatorImg{display:block;width:125px;height:auto;border-radius:70px;margin-right:auto;margin-left:auto;margin-bottom:10px}.onboardingStage .onboardingTestimonial .educatorInfo{font-size:.8em;text-align:center;border-bottom:1px solid #bbb;margin-bottom:10px}.onboardingStage .onboardingTestimonial .quoteImg{width:39px;margin-right:8px;margin-bottom:8px;float:left}.onboardingStage .onboardingTestimonial .quoteText{font-style:italic;margin-left:45px;width:80%}.onboardingStage .onboardingGradeLevelRec .educatorOwl{display:block;width:10rem;height:auto;margin-right:auto;margin-left:auto;margin-bottom:1rem}.onboardingStage .onboardingGradeLevelRec .recHeader{text-align:center;border-bottom:1px solid #bbb;margin-bottom:10px}.onboardingStage .onboardingGradeLevelRec .recommendation{margin-left:10%;width:80%;font-size:.8em;font-style:italic}.onboardingStage .onboardingInstructions{margin-bottom:5px;color:#999;font-size:.8em}.onboardingStage .instructionTitle{font-weight:700;display:block;color:#555}.onboardingStage .owlfonsoImage{width:150px;margin-left:60px}.onboardingStage .actionsContainer{float:right;margin-top:5px}.onboardingStage .actionsContainer .skipLink{font-size:.8em;color:#0082c8;padding-left:10px}.onboardingStage .multiLineInput,.onboardingStage .singleLineInput{font-size:.8em;margin-bottom:5px;padding:6px}.onboardingStage .singleLineInput{height:30px}.onboardingStage .multiLineInput{height:75px}.onboardingStage.onboardingStageGenericGradeLevel .gradePicker{margin-bottom:.5em}.onboardingStage.onboardingStageGenericGradeLevel .gradePicker button{margin-top:0;font-size:.8em}.onboardingStage.onboardingStageGenericGradeLevel .gradePicker ul{font-size:.8em}.onboardingStage.onboardingStageGenericGradeLevel .gradeLevelDisclaimer{font-size:.8em;width:80%;margin-top:2rem}.onboardingStage.onboardingStageGenericGradeLevel .onboardingGreeting.extraBottomMargin{margin-bottom:4rem}.onboardingStage.onboardingStageGenericGradeLevel .upgradeCodeInstructions{margin-top:2rem}.onboardingStage.onboardingStageGenericGradeLevel .upgradeTokenForm{font-size:.8em}.onboardingStage.onboardingStageGenericGradeLevel .upgradeTokenForm input.form-control{font-size:1em;padding:9px;height:25px}.onboardingStage.onboardingStageGenericGradeLevel .upgradeTokenForm .btn.btn-link{padding:1px 6px}.onboardingStage.onboardingStageGenericGradeLevel .subStage{margin-bottom:1.5rem}.onboardingStage.onboardingStageGenericCompletion .leftCol{padding-left:22px}.onboardingStage.onboardingStageGenericCompletion .leftCol .bookDisplay{display:block;margin-bottom:15px;font-size:.8em;min-height:75px}.onboardingStage.onboardingStageGenericCompletion .leftCol .bookDisplay .about{max-width:75%}.onboardingStage.onboardingStageGenericCompletion .rightCol{vertical-align:bottom}.onboardingStage.onboardingStageGenericCompletion .actionsContainer{margin-top:20px}.onboardingStage.onboardingStageCustomizeQuiz{width:90%;margin:auto}.onboardingStage.onboardingStageCustomizeQuiz .categoryTitle{font-size:1.1em}.onboardingStage.onboardingStageCustomizeQuiz .disclaimerContainer{display:flex;justify-content:center;margin-top:1.5rem}.onboardingStage.onboardingStageCustomizeQuiz .frequencyContainer,.onboardingStage.onboardingStageCustomizeQuiz .questionsContainer{margin-top:10px}.onboardingStage.onboardingStageCustomizeQuiz .frequencyContainer .frequencyText,.onboardingStage.onboardingStageCustomizeQuiz .frequencyContainer .questionsText,.onboardingStage.onboardingStageCustomizeQuiz .questionsContainer .frequencyText,.onboardingStage.onboardingStageCustomizeQuiz .questionsContainer .questionsText{display:block!important}.onboardingStage.onboardingStageCustomizeQuiz .changeLater{display:inline-block;width:10em;font-size:.8em;color:#aaa}.onboardingStage.onboardingStageCustomizeQuiz .nextStage .changeLater{position:relative;top:10px;text-align:left;margin-left:13px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer{font-size:.9em;margin-bottom:20px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .options{display:flex;justify-content:center}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .selectContainer p{font-size:.9em;display:inline-block;margin-left:1%}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .selectContainer .quizCount{width:15%;margin-bottom:10px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .selectContainer .quizFrenquency{width:20%}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .selectContainer select{display:inline-block;margin-left:10px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg{margin-left:1%;margin-top:15px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg .imgContainer{transition:all .5s ease-in;-moz-transition:all .5s ease-in;-webkit-transition:all .5s ease-in}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg .imgContainer .description{font-size:.9em;margin-bottom:10px;font-style:italic}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg .imgContainer .formatImg{width:100%;border:1px dotted #ccc;padding:15px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg .imgContainer.img-animation-enter{opacity:.01}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textVarietyImg .imgContainer.img-animation-enter.img-animation-enter-active{opacity:1}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .textSpecificity{width:30%}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeTextSpecificity{width:36%}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .difficulty{width:23%}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject{position:relative;display:inline-block;vertical-align:top;margin:.5%;text-align:center;padding:1rem}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject.selected{background-color:#defad2}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject.push{padding-top:2rem}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject .opTitle{margin-bottom:5px}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject .comp{font-size:.8em}.onboardingStage.onboardingStageCustomizeQuiz .settingContainer .largeObject .time{font-size:.8em;color:#999}.onboardingStage.onboardingStageCustomizeQuiz .quizDescription{margin-left:1%}.onboardingStage.onboardingStageCustomizeQuiz .quizDescription .summary{border:1px dotted #ddd;padding:15px}.onboardingStage.onboardingStageCustomizeQuiz .quizDescription .summary .settingsDescription{margin-top:10px}.onboardingStage.onboardingStageCustomizeQuiz .quizDescription .action button{margin-top:45px;margin-bottom:10px}.onboardingStageSelectStandards .attributeList{margin-bottom:2rem}.onboardingStageSelectStandards .rightCol.onboardingLiteracy .instructionTitle{font-weight:400;font-size:16px}.onboardingStageSelectStandards .rightCol.onboardingLiteracy label{font-size:.8em}.onboardingStageSelectStandards .rightCol.onboardingLiteracy label input{margin-right:5px}.onboardingStageSelectStandards .rightCol.onboardingLiteracy label span{vertical-align:text-bottom}.onboardingStageSelectStandards .rightCol.onboardingLiteracy label p{font-weight:400}.onboardingStageSelectStandards .standardsPicker button{margin-top:0;font-size:.8em}.onboardingStageSelectStandards .standardsPicker ul{font-size:.8em}.onboardingStageSelectStandards .standardsDisclaimer{font-size:.8em;width:62%;margin-top:1rem}.onboardingStageSelectStandards .saveButton{float:right}.onboardingStageSelectFeatures .featureOptions{width:82.1%;margin-left:auto;margin-right:auto}.onboardingStageSelectFeatures .largeObject{display:inline-block;vertical-align:top;width:20rem;min-height:15rem;margin:.5rem}.onboardingStageSelectFeatures .largeObject.selectedFeature{background-color:#defad2}.onboardingStageSelectFeatures .featureObjectContent{text-align:center;width:17rem;margin:1rem auto}.onboardingStageSelectFeatures .featureImg{width:10rem}.onboardingStageSelectFeatures .featureDesc{line-height:1.2;margin-top:1rem}.onboardingStageSelectFeatures button{float:right;margin-top:2rem;margin-right:2rem}.onboardingStageSelectQuizFormat .formatOptions{width:82.1%;margin-left:auto;margin-right:auto}.onboardingStageSelectQuizFormat .largeObject{position:relative;display:inline-block;vertical-align:top;width:20rem;height:9rem;margin:.5rem;text-align:center;padding:1rem}.onboardingStageSelectQuizFormat .largeObject.selectedFormat{background-color:#defad2}.onboardingStageSelectQuizFormat .largeObject.push{padding-top:2rem}.onboardingStageSelectQuizFormat .formatImg{float:left;width:70%;display:block;margin:10px auto;min-height:250px;margin-left:10%}.onboardingStageSelectQuizFormat .confirmFormat{float:right;margin-top:20px;margin-right:10%}.onboardingStageSetAssignments .onboardingGreeting{margin-left:5.5rem}.onboardingStageSetAssignments .goalOptions{width:83%;margin-left:auto;margin-right:auto}.onboardingStageSetAssignments .largeObject{display:inline-block;vertical-align:top;width:19rem;margin:1rem}.onboardingStageSetAssignments .largeObject.selectedGoal{background-color:#defad2}.onboardingStageSetAssignments .goalObjectContent{text-align:center;width:13rem;margin:2rem auto;font-size:.8em}.onboardingStageSetAssignments .expectationsCustomizerContainer{padding:0 10rem}.onboardingStageSetAssignments .saveExpectationsButton{float:right;margin-top:2rem;margin-right:2rem}", ""]);
	
	// exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".paywallBlurbContainer{margin-top:10px}.paywallBlurbContainer .paywallText{display:inline-block}.paywallBlurbContainer .insightsPaywall{margin-bottom:25px}.paywallBlurbContainer .studentRosterPaywall{width:67%}.paywallBlurbContainer .paywallLinkButton{position:relative;bottom:15px;margin-left:25px}.paywallBlurbContainer .insightsPaywallBtn{margin-left:0}.paywallBlurbContainer .webinarRegistration{bottom:3rem}.studentRosterBlurb{position:relative;bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".paywallModal{text-align:left}.paywallModal .paywallContentContainer{width:95%;margin:auto}.paywallModal .paywallContentContainer .messageArea{height:4rem}.paywallModal .paywallContentContainer .paywallImg{width:80%;margin-top:1rem;margin-bottom:2rem;margin-left:10%}.paywallModal .paywallContentContainer .actionSection{text-align:center;margin-top:20px;margin-bottom:10px}.paywallModal .paywallContentContainer .actionSection .learnMoreLink{vertical-align:bottom}.paywallModal .paywallContentContainer .actionSection .buttonSuccess{margin-left:10px;border:none}.paywallModal .paywallContentContainer .actionSection .buttonSuccess:hover{text-decoration:none;border:none}.paywallModal .paywallContentContainer .actionSection .upgradeButton{margin-right:2rem}.paywallModal .actionOptionsSection .dividerDot{width:.6rem;height:.6rem;border-radius:10rem;background-color:#555;margin:2.5rem auto}.paywallModal .actionOptionsSection .ctaQuestion{text-align:center;margin-bottom:2rem}.paywallModal .actionOptionsSection .actionDisplay{margin-bottom:2rem}.paywallModal .actionOptionsSection .actionOption{display:inline-block;width:72%;vertical-align:top;margin-left:2.5%;margin-right:2.5%}.paywallModal .actionOptionsSection .actionDescription{font-size:.8em;color:#888;margin-top:1rem;margin-bottom:2rem}.paywallModal .actionOptionsSection .actionButton:hover{text-decoration:none}.paywallModal .actionOptionsSection.rld .actionOption{display:block;margin:auto}.paywallModal .actionOptionsSection.rld .actionOption .buttonSuccess{text-align:center}.paywallModal .actionOptionsSection.rld .actionOption .actionDescription{margin-top:2rem;margin-bottom:3rem}.paywallModal .actionOptionsSection.rld .actionDisplay .buttonSuccess{display:block;width:135px;margin:auto}.paywallModal li{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".preferenceContainer input{margin-right:5px}.preferenceContainer .scoringSystemContainer{min-height:265px}.preferenceContainer .scoringSystemContainer .scoringTypeContainer{margin-bottom:15px}.preferenceContainer .scoringSystemContainer .scoringTypeContainer .imgContainer{display:inline-block;vertical-align:top;margin-left:15px}.preferenceContainer .scoringSystemContainer .scoringTypeContainer .imgContainer img{width:30px}.preferenceContainer .scoringSystemContainer .scoringTypeContainer label .scoringOption{min-width:70px;display:inline-block}.preferenceContainer .paywallContentContainer .actionSection{text-align:center}.preferenceContainer .readingLevelFormatContainer .noteText{width:85%;display:inline-block}.preferenceContainer label{cursor:pointer}.preferenceContainer .skillsetPreferenceContainer .allSkillsetsLabel{margin-top:10px;cursor:pointer;font-weight:400}.preferenceContainer .skillsetPreferenceContainer .skillsetContainer{display:inline-block;width:50%}.preferenceContainer .skillsetPreferenceContainer .skillsetContainer label{font-weight:400;margin-bottom:1rem;cursor:pointer}.preferenceContainer .skillsetPreferenceContainer .skillsetContainer label img{margin-right:.5rem;width:2rem}.preferenceContainer .skillsetPreferenceContainer .skillsetContainer label.disabled:hover{opacity:1}.preferenceContainer .skillsetPreferenceContainer .skillsetContainer label .name{display:inline-block;max-width:21rem;font-size:.8em}.preferenceContainer .skillsetPreferenceContainer .selectStandardsText{margin-bottom:0;display:inline-block}.preferenceContainer .skillsetPreferenceContainer .standardName{margin-top:.8rem;margin-bottom:.5rem}.preferenceContainer .skillsetPreferenceContainer .activeSkillsetHeader{margin-top:2rem}.preferenceContainer .speechControlsPreferenceContainer .browserDisclaimer{font-size:.8em;padding-top:1rem}.preferenceContainer .quizScoringSettingContainer .viewableScoreOptions{margin-top:1rem}.preferenceContainer .bookRecommendationsContainer{margin-left:10px}.preferenceContainer .bookRecommendationsContainer .smartBookSearch{width:95%}.preferenceContainer .bookRecommendationsContainer .smartBookSearch .manualForm{margin-bottom:40px}.preferenceContainer .bookRecommendationsContainer .smartBookSearch .manualForm .textVariety{width:18%}.preferenceContainer .bookRecommendationsContainer .smartBookSearch .manualForm .buttonSuccess{margin-left:25px}.preferenceContainer .bookRecommendationsContainer .instructions .hintText{font-size:.8em}.preferenceContainer .bookRecommendationsContainer .booksDisplayContainer .bookDisplayContainer{width:25%}.preferenceContainer .bookRecommendationsContainer .booksDisplayContainer .bookDisplayContainer .removeBookLink{cursor:pointer;position:relative;left:90px;color:#bbb;text-decoration:none}.preferenceContainer .bookRecommendationsContainer .booksDisplayContainer .bookDisplayContainer .removeBookLink:hover{opacity:.7}.preferenceContainer .bookRecommendationsContainer .booksDisplayContainer .bookDisplayContainer .about{position:relative;bottom:131px;color:#fff;left:10px;width:80px}.preferenceContainer .logReadingViewPreference{margin-top:15px;margin-bottom:15px}.preferenceContainer .referralContainer .userReferralCode{margin-bottom:30px;margin-left:10px}.preferenceContainer .referralContainer .errorMessageContainer{color:red;text-align-last:center;padding-top:10px}.preferenceContainer .referralContainer .referralInputContainer{margin-left:10px}.preferenceContainer .referralContainer .referrralPreferenceSection .levelBar{background-color:gold}@media only screen and (min-width:950px){.preferenceContainer .referralContainer .referralCodeInputIntro{float:left}.preferenceContainer .referralContainer .referralCodeInputField{float:left;max-width:70%;margin-left:20px}}.preferenceContainer .referralContainer .referralInputAreaContainer{margin-bottom:1em}.changeNewsfeedSettingLink{cursor:pointer;margin-left:5px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".questionCustomizerContainer .existingQuestion{margin-top:15px;margin-bottom:15px}.questionCustomizerContainer .existingQuestion:hover{cursor:pointer;opacity:.7}.questionCustomizerContainer .existingQuestion:hover .editQuestionIcon{visibility:visible}.questionCustomizerContainer .existingQuestion img{height:20px;margin-right:5px;float:left}.questionCustomizerContainer .existingQuestion .editQuestionIcon{visibility:hidden}.questionCustomizerContainer .existingQuestion .textTitle{font-weight:700}.questionCustomizerContainer .editQuestionForm,.questionCustomizerContainer .newQuestionForm{min-height:104px}.questionCustomizerContainer .editQuestionForm .buttonSuccess,.questionCustomizerContainer .newQuestionForm .buttonSuccess{float:right;margin-top:10px;min-width:5rem!important;padding:.5rem}.questionCustomizerContainer .editQuestionForm .cancelLink,.questionCustomizerContainer .newQuestionForm .cancelLink{float:right;margin-top:17px;margin-right:15px}.questionCustomizerContainer .editQuestionForm .deleteLink,.questionCustomizerContainer .newQuestionForm .deleteLink{float:right;margin-top:17px;margin-right:15px;color:#c31030}.questionCustomizerContainer .editQuestionForm .skillsetDropdown,.questionCustomizerContainer .newQuestionForm .skillsetDropdown{position:relative;display:inline-block}.questionCustomizerContainer .editQuestionForm .skillsetDropdown .buttonDropdown .scrollable-menu,.questionCustomizerContainer .newQuestionForm .skillsetDropdown .buttonDropdown .scrollable-menu{max-width:450px}.questionCustomizerContainer .editQuestionForm{margin-bottom:15px}.questionCustomizerContainer .newQuestionLink{text-decoration:none;display:block}.questionCustomizerContainer .newQuestionLink:hover{text-decoration:none}.questionCustomizerContainer .customQuestionsToggle{margin-top:15px}.questionCustomizerContainer .controls{font-size:.8em}.questionCustomizerContainer .controls .validatingInput{vertical-align:top;min-width:140px}", ""]);
	
	// exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".settingsPage .orgPreferences{margin-bottom:15px}.settingsPage .linksSection{width:20%;display:inline-block;border-right:1px solid #ddd;padding-top:2%}.settingsPage .linksSection a{cursor:pointer;display:block!important;margin-bottom:2px}.settingsPage .linksSection .linksGroup{margin-bottom:15px}.settingsPage .linksSection .linksGroup p{color:#999;margin-bottom:5px}.settingsPage .linksSection .linksGroup .selected{color:#555;font-weight:700}.settingsPage .accountSettingsSection .pageHeader{text-align:left}.settingsPage .accountSettingsSection .pageHeader h1{padding-left:0}.settingsPage .preferenceArea{display:inline-block;vertical-align:top;width:70%;margin-left:8%;padding-top:1%}.settingsPage .preferenceArea header{text-transform:capitalize}.settingsPage .preferenceArea .currentSettingTitle{font-size:1.4em}.settingsPage .preferenceArea label{font-weight:500}.settingsPage .preferenceArea .accountSyncContainer .relatedUserDisplay{display:block}.settingsPage .preferenceArea .accountSyncContainer .mergeUsersLink{padding-left:0}.settingsPage .preferenceArea .accountSyncContainer .linkedAccountsContainer{margin-bottom:3em}.settingsPage .preferenceArea .accountSyncContainer .accountSyncInstructions,.settingsPage .preferenceArea .accountSyncContainer .linkedAccountText{margin:1em 0}.settingsPage .preferenceArea .accountSyncContainer .buttonSuccess{display:inline-block;vertical-align:bottom;margin-left:1em}.settingsPage .preferenceArea .accountSyncContainer .inputRow{padding-bottom:2rem}.settingsPage .preferenceArea .accountSyncContainer .inputContainer{margin-bottom:0;display:inline-block;vertical-align:top;width:30%}.settingsPage .preferenceArea .accountSyncContainer .inputContainer:nth-of-type(2),.settingsPage .preferenceArea .accountSyncContainer .inputContainer:nth-of-type(3),.settingsPage .preferenceArea .accountSyncContainer .inputContainer:nth-of-type(5){margin-left:1rem}.settingsPage .preferenceArea .accountSyncContainer .form-control{margin-top:.5rem}.settingsPage .preferenceArea .accountSyncContainer .emailInput{width:62%}.settingsPage .preferenceArea .accountSyncContainer .buttonSuccess{margin-top:1rem}.settingsPage .preferenceArea .personalInfoForm .inputRow{padding-bottom:2rem}.settingsPage .preferenceArea .personalInfoForm .inputContainer{margin-bottom:0;display:inline-block;vertical-align:top;width:30%}.settingsPage .preferenceArea .personalInfoForm .inputContainer:nth-of-type(2),.settingsPage .preferenceArea .personalInfoForm .inputContainer:nth-of-type(3),.settingsPage .preferenceArea .personalInfoForm .inputContainer:nth-of-type(5){margin-left:1rem}.settingsPage .preferenceArea .personalInfoForm .form-control{margin-top:.5rem}.settingsPage .preferenceArea .personalInfoForm .emailInput{width:62%}.settingsPage .preferenceArea .personalInfoForm .buttonSuccess{margin-top:1rem}.settingsPage .preferenceArea .billingHistory .historyRow{border-bottom:1px solid #ddd}.settingsPage .preferenceArea .billingHistory .historyCell{display:inline-block;vertical-align:top;padding:1rem;width:25%}.settingsPage .preferenceArea .billingHistory .historyCell:nth-child(2){width:30%}.settingsPage .preferenceArea .billingHistory .historyCell:nth-child(4){width:20%}.settingsPage .preferenceArea .currentPlan .nextChargeDetails{padding-top:1rem}.settingsPage .preferenceArea .currentPlan .planSection{padding-bottom:1rem}.settingsPage .preferenceArea .currentPlan .planSection .planRow{padding-bottom:.5rem}.settingsPage .preferenceArea .currentPlan .planSection .planRow .planLabel{width:30%;display:inline-block;vertical-align:top;color:#888}.settingsPage .preferenceArea .currentPlan .planSection .planRow .changeLink{display:inline-block;margin-left:1rem;font-size:.8em}.settingsPage .preferenceArea .currentPlan .planSection .planRow .cancelNote{font-size:.8em;color:#999;margin-left:10px}.settingsPage .preferenceArea .schoolYearContainer label{min-width:65px;margin-right:20px;font-weight:700}.settingsPage .preferenceArea .subContainer{margin-top:1rem}.settingsPage .preferenceArea .subTitle{border-bottom:1px solid #ddd}", ""]);
	
	// exports


/***/ }),
/* 1419 */
1409,
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".tutorialsPage .tutorialsNavContainer{text-align:center}.tutorialsPage .tutorialsNavContainer .navModuleHeaderLink{display:inline-block;cursor:pointer;width:23%}.tutorialsPage .tutorialsNavContainer .navModuleHeaderLink.selectedLinkClass{font-weight:700}.tutorialsPage .tutorialsNavContainer .verticalDivider{height:20px;border-color:#ddd}.tutorialsPage .tutorialDisplay{margin-top:40px}.tutorialsPage .tutorialDisplay .progressBarContainer{margin-bottom:40px}.tutorialsPage .tutorialDisplay .videoContainer .videoTitle{font-size:1.4em}.tutorialsPage .tutorialDisplay .actionContainer{margin-top:40px}.tutorialsPage .tutorialDisplay .actionContainer .actionContent.complete{opacity:.5}.tutorialsPage .tutorialDisplay .actionContainer .actionContent .nextStepLabel{font-weight:700;margin-bottom:5px}.tutorialsPage .tutorialDisplay .actionContainer .actionContent .actionContentText{display:inline-block}.tutorialsPage .tutorialDisplay .actionContainer .actionContent .actionContentText .glyphicon-ok-circle{margin-right:5px}.tutorialsPage .tutorialDisplay .otherModuleVideosContainer{font-size:.8em;display:inline-block;width:29%}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo{border-bottom:1px solid #ddd;padding:15px}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo:last-of-type{border:none}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo:hover{background:#c8ecff}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo.completedVideo{opacity:.5}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo .glyphicon-film{margin-right:5px}.tutorialsPage .tutorialDisplay .otherModuleVideos .nextVideo .videoTitle{font-weight:700}.tutorialsPage .stickyContainer{display:inline-block;vertical-align:top;width:60%;margin-right:95px}", ""]);
	
	// exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".overdrawnAccountNotice{margin-top:2rem;margin-bottom:2rem}.overdrawnAccountNotice .noticeBox{position:relative;border:1px dashed #c31030;border-radius:5px;padding:12px 5px}.overdrawnAccountNotice .actionOptions,.overdrawnAccountNotice .statusDescription{display:inline-block;vertical-align:top}.overdrawnAccountNotice .statusDescription{width:52%;margin-left:2.5%;margin-right:3.5%}.overdrawnAccountNotice .actionOptions{width:40%}.overdrawnAccountNotice .verticalDivider{height:20px;border-color:#ddd;margin-left:5px;margin-right:5px}", ""]);
	
	// exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".trialStatusDisplay .trialBox{position:relative;border:1px solid #ddd;border-radius:5px;padding:12px 5px;padding-left:0;font-size:.8em;margin-top:15px}.trialStatusDisplay .trialBox:first-child{margin-top:0}.trialStatusDisplay .trialBox p{margin-bottom:0}.trialStatusDisplay .trialBox>div{position:relative;display:inline-block;vertical-align:middle}.trialStatusDisplay .imageBox{width:7%;text-align:center;margin-left:4%}.trialStatusDisplay .imageBox img{width:23px;height:auto;text-align:center}.trialStatusDisplay .statusBox{width:31%}.trialStatusDisplay .consultationBox{width:43%}.trialStatusDisplay .divider{margin-left:6%;margin-right:6%;width:1px;height:35px;background-color:#ddd}.trialStatusDisplay .expandLinkLine{text-align:right;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".upgradeForm .upgradeContainer{padding-top:2rem;padding-bottom:2rem;margin-left:auto;margin-right:auto}@media(min-width:45rem)and (max-width:75rem){.upgradeForm .upgradeContainer{width:50%}}@media(min-width:75rem){.upgradeForm .upgradeContainer{width:30%}}.upgradeForm .changePlanLink{float:right}.upgradeForm .form-control,.upgradeForm .paymentTypeDropdown .btn{box-shadow:none}.upgradeForm .originalPrice{display:inline-block;margin-right:.25em;text-decoration:line-through;color:#999}.upgradeForm .planDetailsBox{border:1px solid #ccc;border-radius:5px;margin-top:1rem;margin-bottom:1rem;padding:2rem}.upgradeForm .planDetailsBox .planDetails .verticalDivider{height:20px;border-left:1px solid #ccc;margin-left:10px;margin-right:10px}.upgradeForm .classesPricing{padding-top:1rem}.upgradeForm .contactUsLink,.upgradeForm .numClassesDropdown,.upgradeForm .xIcon{display:inline-block}.upgradeForm .numClassesDropdown{width:auto}.upgradeForm .xIcon{width:20%;text-align:center}.upgradeForm .xIcon .glyphicon{top:.3rem}.upgradeForm .contactUsLink{margin-left:2rem}.upgradeForm .paymentContentContainer{margin-top:2rem;margin-bottom:2rem}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.upgradeForm .paymentContentContainer{border:1px solid #ccc;border-radius:5px;padding:2rem}}.upgradeForm .paymentChoiceLabel{margin-bottom:1rem}.upgradeForm .paymentTypeDropdown{width:100%;margin-bottom:2rem}.upgradeForm .paymentTypeDropdown .btn{padding:1rem 1.5rem;text-align:left;min-width:100%;border-color:#ccc}.upgradeForm .paymentTypeDropdown .dropdown-menu{min-width:100%}.upgradeForm .paymentTypeDropdown .dropdown-menu .ellipsisText{padding:1rem 1.5rem;font-size:1em}.upgradeForm .existingPaymentMethod{margin-bottom:2rem}.upgradeForm .existingPaymentMethod .changeLink{font-size:.8em}.upgradeForm .submitPayment{border-top:1px solid #ccc;padding-top:2rem;margin-top:2rem}.upgradeForm .termsDisclaimer{margin-top:2rem}.upgradeForm .submitButton,.upgradeForm .totalAmount{display:inline-block;vertical-align:bottom}.upgradeForm .totalAmount{text-align:right;width:45%}.upgradeForm .noSubtotal{float:left;margin-left:1em}.upgradeForm .totalLine{font-size:1.4em}.upgradeForm .subtotalLine{color:#999}.upgradeForm .totalLabel{float:left;display:inline-block;width:25%}.upgradeForm .submitButton{width:55%;text-align:right}.upgradeForm .submitButton .btn{border:none}.upgradeForm .discountMessage,.upgradeForm .purchaseDisclaimer,.upgradeForm .termsDisclaimer{font-size:.8em;color:#888}.upgradeForm .discountMessage{margin-bottom:2rem}.upgradeForm .discountInfo{margin-top:15px;font-size:.8em;color:#999}.upgradeForm .discountInfo a.removeLink{color:inherit;float:right}", ""]);
	
	// exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".upgradeHeader{color:#fff}.upgradeHeader.silverHeader{background-color:#00a0f4}.upgradeHeader.goldHeader{background-color:#fa9362}@media(max-width:45rem){.upgradeHeader .headerContainer{padding-top:3rem;padding-bottom:3rem}}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.upgradeHeader .headerContainer{padding-top:6rem;padding-bottom:6rem}}.upgradeHeader .headerText{padding-bottom:2rem}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.upgradeHeader .headerText{font-size:2.1em}}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.upgradeHeader .benefitsList{text-align:center}}.upgradeHeader .benefitItem{font-size:.8em}@media(min-width:45rem)and (max-width:75rem),(min-width:75rem){.upgradeHeader .benefitItem{display:inline-block;vertical-align:top}}.upgradeHeader .benefitItem .benefitText,.upgradeHeader .benefitItem .glyphicon{display:inline-block;vertical-align:top}.upgradeHeader .benefitItem .glyphicon{margin-left:3rem;margin-right:1rem}.upgradeHeader .laterWrap{margin-top:2rem;height:0;text-align:center}.upgradeHeader a.laterLink{color:#96dafe;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".upgradeTokenForm input.form-control{display:inline-block;width:9em;margin-right:5px}.upgradeTokenForm .errorDisplay{max-width:18em}.upgradeTokenForm .spinnerBox.placeholder{display:inline-block;padding:7px 20px}.upgradeTokenForm .codeField{display:inline-block;width:45%;text-align:left}.upgradeTokenForm .buttonArea{display:inline-block;width:55%;text-align:right}", ""]);
	
	// exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".altModal.modal{display:block}.altModal.modal .modal-header{padding:5px;border-bottom:1px solid #ddd;margin-bottom:0}.altModal.modal .modal-header h2{margin:0;text-align:center;border-bottom:none}.altModal.modal .modal-dialog{max-width:100%}.altModal.modal.slightlyNarrowModal .modal-dialog{width:500px}.altModal.modal.halfWidth .modal-dialog{width:300px}.altModal.modal.twoThirdsWidth .modal-dialog{width:400px}.altModal.modal.twoThirdsWidth .studentSurveyContainer img{width:50%;margin-right:15px}.altModal.modal.wideModal .modal-dialog{width:700px}.altModal.modal.moreWideModal .modal-dialog{width:900px!important}.altModal.modal.veryWideModal .modal-dialog{width:1100px}.altModal.modal .modal-footer{border-top:none;padding-top:0}", ""]);
	
	// exports


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".autoSubmitTextArea .selectOptions{position:relative;top:-2px}.autoSubmitTextArea textarea{position:relative;z-index:20;background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".tileGridWrapper{position:relative;padding-bottom:30px}.tileGridWrapper .spinnerBox{position:absolute;left:50%;bottom:20px}.tileGridWrapper *{z-index:10}.tile{width:-o-calc(50% - 7.5px);width:calc(50% - 7.5px)}@media(min-width:580px){.tile{width:-o-calc(33.33% - 10px);width:calc(33.33% - 10px)}}@media(min-width:850px){.tile{width:-o-calc(25% - 11.25px);width:calc(25% - 11.25px)}}@media(min-width:580px){.tileGridWrapper.narrowGrid .tile{width:-o-calc(50% - 7.5px);width:calc(50% - 7.5px)}}@media(min-width:850px){.tileGridWrapper.narrowGrid .tile{width:-o-calc(33.33% - 10px);width:calc(33.33% - 10px)}}.tile{border:1px solid #ddd;display:inline-block;background:#fff;border-radius:10px;box-shadow:0 1px 2px 0 rgba(0,0,0,.22);margin:0 0 15px;max-width:100%}.tile,.tile>*{position:relative}.tile>*{transition:bottom .5s}.tile img.tileImg{display:block;max-width:100%;height:auto;width:auto;background-color:#fff}.tile.smallTile .imgContainer{height:80px}.tile .userLine{border-bottom:1px solid #ddd;padding:5px 10px}.tile .userLine .owlConstraints{display:inline-block;vertical-align:middle;position:relative;top:-5px;margin-right:5px}.tile.nonInteractive .imgContainer:hover,.tile.nonInteractive .tileImg{cursor:default}.tile.nonInteractive .imgContainer:hover .tileImg{filter:brightness(90%)}.tile .imgContainer{overflow:hidden;position:relative;background-color:#fff;border-radius:10px 10px 0 0}.tile .imgContainer.withImageHover:hover{cursor:zoom-in}.tile .imgContainer.withImageHover:hover .tileImg{filter:brightness(80%)}.tile .imgContainer:hover .buttonsBar li.dynamic{opacity:1}.tile .imgContainer .tileImg{filter:brightness(90%);min-height:114px}.tile .imgContainer .draftContainer .tileImg{filter:brightness(80%);min-height:118px}.tile .imgContainer .draftContainer .buttonsBar{opacity:1;color:#fff;transition:0s}.tile .imgContainer .draftContainer .buttonsBar li{background-color:#00a0f4}.tile .imgContainer img.collaborationImg{position:absolute;top:2px;left:0;z-index:101;width:80px}.tile .imgContainer .buttonsBar{position:absolute;pointer-events:none;right:0;top:14px;z-index:101}.tile .imgContainer .buttonsBar ul{list-style:none}.tile .imgContainer .buttonsBar ul:hover{cursor:auto}.tile .imgContainer .buttonsBar li{pointer-events:auto;padding-left:5px;border-top-left-radius:5px;border-bottom-left-radius:5px;margin-bottom:5px}.tile .imgContainer .buttonsBar li .buttonTitle{display:inline-block;left:5px;font-size:1em;position:relative;vertical-align:middle;bottom:3px;z-index:10}.tile .imgContainer .buttonsBar li .menuIcon{position:relative;top:0;z-index:8;padding:6px;font-size:1em;border-top-left-radius:5px;border-bottom-left-radius:5px}.tile .imgContainer .buttonsBar li.assignedMarker{color:#fff;width:115px;position:relative;left:15px;background-color:#c54e14}.tile .imgContainer .buttonsBar li.assignedMarker .menuIcon,.tile .imgContainer .buttonsBar li.assignedMarker:hover{background-color:#c54e14}.tile .imgContainer .buttonsBar li.assignedMarker .buttonTitle{margin-right:5px}.tile .imgContainer .buttonsBar li.assignMarker{color:#fff;position:relative}.tile .imgContainer .buttonsBar li.assignMarker .menuIcon,.tile .imgContainer .buttonsBar li.assignMarker:hover{background-color:#00a0f4}.tile .imgContainer .buttonsBar li.completedMarker{color:#fff;position:relative;background-color:#2b9401}.tile .imgContainer .buttonsBar li.completedMarker .menuIcon{background-color:#2b9401}.tile .imgContainer .buttonsBar li.printMarker{color:#fff;width:75px;position:relative;left:13px}.tile .imgContainer .buttonsBar li.printMarker .menuIcon,.tile .imgContainer .buttonsBar li.printMarker:hover{background-color:#2b9401}.tile .imgContainer .buttonsBar li.newMarker{color:#fff;background-color:#e8cb3a;width:70px;position:relative;left:15px}.tile .imgContainer .buttonsBar li.newMarker .menuIcon{background-color:#e8cb3a}.tile .imgContainer .buttonsBar li.newMarker .buttonTitle{width:30px}.tile .imgContainer .buttonsBar.featuredTile li.assignMarker{width:94px;left:31px}.tile .imgContainer .buttonsBar.featuredTile li.printMarker{width:84px;left:43px}.tile .imgContainer .buttonsBar.featuredTile li.featuredMarker{color:#fff;background-color:#8e54c1;width:115px;position:relative;left:15px}.tile .imgContainer .buttonsBar.featuredTile li.featuredMarker .menuIcon{background-color:#8e54c1}.tile .imgContainer .buttonsBar.featuredTile li.featuredMarker .buttonTitle{width:67px}.tile .imgContainer .buttonsBar.assignedTile li.assignedMarker{cursor:pointer;width:132px;left:33px}.tile .imgContainer .buttonsBar.assignedTile li.assignedMarker:hover{opacity:.7}.tile .imgContainer .buttonsBar.assignedTile li.printMarker{width:84px;left:61px}.tile .imgContainer .buttonsBar li.draftMarker{color:#fff;background-color:#2b9401}.tile .imgContainer .buttonsBar li.draftMarker .menuIcon{background-color:#2b9401}.tile .imgContainer .buttonsBar li.dynamic{cursor:pointer;opacity:0;transition:.3s}.tile .imgContainer .buttonsBar li.dynamic:hover{opacity:.7}.tile .imgContainer .buttonsBar li.dynamic:hover .buttonTitle{opacity:1}.tile .imgContainer .buttonsBar li.dynamic .buttonTitle{opacity:0;transition:opacity .3s,left .3s}.tile .imgContainer .buttonsBar li.assignMarker .buttonTitle,.tile .imgContainer .buttonsBar li.completedMarker .buttonTitle,.tile .imgContainer .buttonsBar li.draftMarker .buttonTitle,.tile .imgContainer .buttonsBar li.newMarker .buttonTitle,.tile .imgContainer .buttonsBar li.printMarker .buttonTitle{margin-right:6px}.tile .tileInnerText{padding:15px;margin-bottom:0}.tile .skillsetTitle{border-top:1px solid #ddd;position:relative;padding:10px}.tile .skillsetTitle .skillsetImg{width:20px;margin-right:2px}.tile .skillsetTitle span{margin-left:5px;vertical-align:middle}.activeAssignment .assignedActivities .tile li.printMarker{left:26px}.activeAssignment .assignedActivities .tile li.newMarker{left:29px}", ""]);
	
	// exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".braveCheckbox{position:relative;height:25px;width:25px}.braveCheckbox.withLabel{width:100%;height:auto}.braveCheckbox.withLabel .checkedImg{margin-right:1.5em}.braveCheckbox:hover{opacity:.7;cursor:pointer}.braveCheckbox:hover.disabled{opacity:1;cursor:default}.braveCheckbox .checkedImg,.braveCheckbox .uncheckedImg{position:absolute;left:0;bottom:0;height:auto}.braveCheckbox .checkedImg{width:36px}.braveCheckbox .uncheckedImg{width:25px}", ""]);
	
	// exports


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".braveToolbar{text-align:center;padding-top:12px;position:fixed;left:0;bottom:-40px;height:8em;width:100vw;border-top:1px solid #bbb;box-shadow:0 0 7px 0 #bbb;background-color:#fff;z-index:10000;transition:bottom 1.5s cubic-bezier(.76,1.4,.81,1.27)}@media only screen and (max-width:920px){.braveToolbar{font-size:.8em;height:10em}}@media only screen and (max-width:695px){.braveToolbar{height:12em}}@media only screen and (max-width:390px){.braveToolbar{height:13em}}.braveToolbar.initalHiddenPosition{bottom:-110px}.braveToolbar .col-sm-12{padding-left:5px;padding-right:5px}.braveToolbar.atBottom{height:6em;transition:none}@media only screen and (max-width:920px){.braveToolbar.atBottom{font-size:.8em;height:8em}}@media only screen and (max-width:390px){.braveToolbar.atBottom{height:10em}}.braveToolbar .selectedItems{float:left}@media(max-width:45rem){.braveToolbar .selectedItems{float:unset}.braveToolbar .selectedItems .clearAll{margin-left:1em}}.braveToolbar .selectedItems .selectedTotal{font-weight:700;display:inline-block;margin-right:5px}@media(max-width:45rem){.braveToolbar .selectedItems .selectedTotal{margin-right:unset}}.braveToolbar .selectedItems .itemCount{margin-right:3px}.braveToolbar .selectedItems span{vertical-align:bottom}@media(max-width:45rem){.braveToolbar .selectedItems span{vertical-align:unset}}.braveToolbar .selectedItems .pluralSpan{padding-right:6px;border-right:1px solid #ccc;margin-right:6px}.braveToolbar .selectedItems .iconImage{height:27px;margin-top:-4px}.braveToolbar .actions .btn.btn-link,.braveToolbar .actions a{text-decoration:none;margin-left:6px;padding:0 10px 0 6px;border-right:1px solid #bbb}.braveToolbar .actions .btn.btn-link:first-child,.braveToolbar .actions a:first-child{margin-left:none;padding-left:none;border-left:none}.braveToolbar .actions .btn.btn-link:last-child,.braveToolbar .actions a:last-child{border-right:none}.braveToolbar .actions .btn.btn-link:hover,.braveToolbar .actions a:hover{opacity:.7}.braveToolbar .actions .btn.btn-link.disabledControl,.braveToolbar .actions a.disabledControl{text-decoration:line-through}.braveToolbar .actions .btn.btn-link:focus,.braveToolbar .actions a:focus{outline:none}.braveToolbar .actions .glyphicon{margin-right:4px;top:2px;color:#555}.braveToolbar .actions .glyphicon-tags{margin-right:8px}", ""]);
	
	// exports


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".buttonDropdown li .glyphicon{margin-right:5px}.buttonDropdown li.paidOption,.buttonDropdown li.paidOption a{color:#777}.buttonDropdown .caret{margin-left:5px}.buttonDropdown .btn-default.smallObject{margin-bottom:10px;margin-top:5px}.buttonDropdown .scrollable-menu{height:auto;max-height:300px;overflow-x:hidden;max-width:50vw;z-index:10000}.buttonDropdown .scrollable-menu li{margin-right:10px}.buttonDropdown .wide{min-width:25vw}.buttonDropdown.nested li.topLevel a,.buttonDropdown.nested li a{padding-left:20px}.buttonDropdown.nested .dropdown-header{color:#888;margin-right:0;border-bottom:1px solid #ddd;font-size:inherit;padding:0 20px;margin-top:5px}", ""]);
	
	// exports


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".carousel .leftArrow{float:left}.carousel .rightArrow{float:right}.carousel .leftArrow,.carousel .rightArrow{margin-top:5rem;cursor:pointer}.carousel .displayContent{margin-left:6rem;margin-right:6rem}", ""]);
	
	// exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".coinDisplay{display:inline-block;line-height:1;border-radius:50px;background:#f3e9b5;padding-right:10px}.coinDisplay img{margin-right:5px}.coinDisplay .coinCount{position:relative;font-weight:700;color:#555}", ""]);
	
	// exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".copyTextInput{position:relative}.copyTextInput .form-control{background-color:#f6f6f6;padding-right:2.6em}.copyTextInput .btn{background-color:#f6f6f6;position:absolute;top:0;right:0;border-bottom-left-radius:0;border-top-left-radius:0;padding:5px 8px}", ""]);
	
	// exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".monthPickerContainer .react-datepicker__day--keyboard-selected{background-color:unset}.monthPickerContainer .react-datepicker-wrapper{display:flex;align-items:center}.monthPickerContainer .react-datepicker__input-container{display:flex;align-items:center;width:100%}.monthPickerContainer .react-datepicker-ignore-onclickoutside{width:100%}.monthPickerContainer .react-datepicker__input{border:none;border-radius:4px;padding:10px;font-size:16px;width:100%;background-color:#f5f5f5}.monthPickerContainer .react-datepicker__input:focus{outline:none;box-shadow:0 0 0 2px #00a0f4}.monthPickerContainer .react-datepicker__day,.monthPickerContainer .react-datepicker__day-name,.monthPickerContainer .react-datepicker__time-name{width:2.5rem;line-height:2.5rem;text-align:center}.monthPickerContainer .react-datepicker__month{margin:1rem}.monthPickerContainer .react-datepicker__day,.monthPickerContainer .react-datepicker__day-name{color:#00a0f4}.monthPickerContainer .react-datepicker__day:hover{background-color:#00a0f4;color:#fff;cursor:pointer;border-radius:1em}.monthPickerContainer .react-datepicker__day--today{font-weight:700}.monthPickerContainer .react-datepicker__day--in-range,.monthPickerContainer .react-datepicker__day--in-selecting-range,.monthPickerContainer .react-datepicker__day--selected{background-color:#00a0f4;color:#fff;border-radius:1em}.monthPickerContainer .react-datepicker__month-text,.monthPickerContainer .react-datepicker__quarter-text{color:#00a0f4}.monthPickerContainer .react-datepicker__time-container{border-top:1px solid #f5f5f5;display:flex;align-items:center;justify-content:center;margin:1rem}.monthPickerContainer .react-datepicker__time{display:flex;align-items:center}.monthPickerContainer .react-datepicker__time-box{display:flex;align-items:center;justify-content:center;width:4rem;margin:0 .5rem}.monthPickerContainer .react-datepicker__current-month{font-size:16px}.monthPickerContainer .react-datepicker__header__dropdown{margin:.5em 0;font-size:12px;color:#00a0f4}.monthPickerContainer .react-datepicker__day-name{font-size:12px;color:#00a0f4}.monthPickerContainer .react-datepicker__day{font-size:12px}.monthPickerContainer .react-datepicker__month:hover .react-datepicker__day{border-radius:1em;color:#fff;font-weight:700;background-color:#00a0f4}.monthPickerContainer .react-datepicker__month:hover .react-datepicker__day--outside-month{border-radius:unset;color:unset;font-weight:unset;background-color:unset}", ""]);
	
	// exports


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".weekSelectorContainer .react-datepicker__day--keyboard-selected{background-color:unset}.weekSelectorContainer .react-datepicker-wrapper{display:flex;align-items:center}.weekSelectorContainer .react-datepicker__input-container{display:flex;align-items:center;width:100%}.weekSelectorContainer .react-datepicker-ignore-onclickoutside{width:100%}.weekSelectorContainer .react-datepicker__input{border:none;border-radius:4px;padding:10px;font-size:16px;width:100%;background-color:#f5f5f5}.weekSelectorContainer .react-datepicker__input:focus{outline:none;box-shadow:0 0 0 2px #00a0f4}.weekSelectorContainer .react-datepicker__day,.weekSelectorContainer .react-datepicker__day-name,.weekSelectorContainer .react-datepicker__time-name{width:2.5rem;line-height:2.5rem;text-align:center}.weekSelectorContainer .react-datepicker__month{margin:1rem}.weekSelectorContainer .react-datepicker__day,.weekSelectorContainer .react-datepicker__day-name{color:#00a0f4}.weekSelectorContainer .react-datepicker__day:hover{background-color:#00a0f4;color:#fff;cursor:pointer;border-radius:1em}.weekSelectorContainer .react-datepicker__day--today{font-weight:700}.weekSelectorContainer .react-datepicker__day--in-range,.weekSelectorContainer .react-datepicker__day--in-selecting-range,.weekSelectorContainer .react-datepicker__day--selected{background-color:#00a0f4;color:#fff;border-radius:1em}.weekSelectorContainer .react-datepicker__month-text,.weekSelectorContainer .react-datepicker__quarter-text{color:#00a0f4}.weekSelectorContainer .react-datepicker__time-container{border-top:1px solid #f5f5f5;display:flex;align-items:center;justify-content:center;margin:1rem}.weekSelectorContainer .react-datepicker__time{display:flex;align-items:center}.weekSelectorContainer .react-datepicker__time-box{display:flex;align-items:center;justify-content:center;width:4rem;margin:0 .5rem}.weekSelectorContainer .react-datepicker__current-month{font-size:16px}.weekSelectorContainer .react-datepicker__header__dropdown{margin:.5em 0;font-size:12px;color:#00a0f4}.weekSelectorContainer .react-datepicker__day-name{font-size:12px;color:#00a0f4}.weekSelectorContainer .react-datepicker__day{font-size:12px}.weekSelectorContainer .react-datepicker__week:hover .react-datepicker__day{border-radius:1em;color:#fff;font-weight:700;background-color:#00a0f4}", ""]);
	
	// exports


/***/ }),
/* 1437 */
1251,
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".displayToggleControl{position:relative;padding-bottom:10px}.displayToggleControl a.toggleOp{padding-left:12px;padding-right:12px;padding-bottom:2px;text-decoration:none}.displayToggleControl.barMode a.toggleOp{color:inherit}.displayToggleControl.linkMode a.toggleOp:hover{opacity:.7}.displayToggleControl.linkMode a.toggleOp.activeOp{color:#aaa}.displayToggleControl.linkMode a.toggleOp:first-child{padding-left:0}.displayToggleControl.linkMode a.toggleOp:last-child{padding-right:0}.displayToggleControl .activeBar{position:absolute;top:25px;height:2px;background-color:#aaa;transition:left .15s,width .15s}.displayToggleControl .badge{position:absolute;bottom:14px;font-size:9px;font-weight:400;background-color:#70d544}", ""]);
	
	// exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".emptyStateContainer{margin-bottom:25px}.emptyStateContainer .rightContent{padding-left:5%;border-left:1px solid #ddd;min-height:600px}.emptyStateContainer .rightContent,.emptyStateContainer .sideBar{padding-top:20px}.emptyStateContainer .emptyStateContent .emptyImg{max-width:45%}.emptyStateContainer .emptyRightContent .emptyImg{max-width:85%}.emptyStateContainer .emptyRightContent .insightsEmptyText{margin-bottom:35px;display:inline-block;width:60%}.emptyStateContainer .emptyRightContent .buttonPrimary{margin-left:60px}.emptyStateContainer .sideBar .emptyStudentRowContainer img{vertical-align:top}.emptyStateContainer .sideBar .emptyStudentRowContainer .emptyStudentRow{display:inline-block;height:13px;margin-bottom:15px;background:#eee;border-radius:2px;margin-left:5px}", ""]);
	
	// exports


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".errorBoundary .bigError{max-width:400px;margin:0 auto}", ""]);
	
	// exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "div.errorDisplay{padding-top:10px;padding-bottom:10px;background:transparent;border:none;color:#da3956;margin:0;list-style:none;text-align:left}div.errorDisplay ul{padding-left:0}div.errorDisplay li{list-style:none}div.errorDisplay .closeLink{float:right;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".feedbackOverrideDisplay{display:inline-block;line-height:1;margin-top:20px}.feedbackOverrideDisplay img{margin-left:5px}.feedbackOverrideDisplay .overrideStar{position:relative;font-weight:700;color:#555}", ""]);
	
	// exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".helpSectionLink{float:right;font-size:.7em;padding-top:.5em;color:#888}", ""]);
	
	// exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".answerCircle{width:5.2rem;height:5.2rem;border:1px solid #ddd;border-radius:5.2rem;display:inline-block}.answerCircle .answerIcon{width:3rem;height:3rem;margin:1rem}", ""]);
	
	// exports


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".avatarCircle{width:4rem;height:4rem;border:1px solid #ddd;border-radius:4rem;display:inline-block}.avatarCircle .avatarIcon{width:2.5rem;height:2.5rem;margin:.7rem}.avatarCircle.initial{background-color:#00a0f4;border-color:#00a0f4}.avatarCircle.initial .avatarIcon{font-size:1.2em;color:#fff;text-align:center;margin:.6rem}.avatarCircle .owlConstraints{margin:.2rem}", ""]);
	
	// exports


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".newTaskCircle{width:26px;height:26px;border-radius:17px;font-size:21px;text-align:center;line-height:1.23;margin:auto;background-color:#bbb;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".toggleMultiselect .selectedIconPlaceholder{display:inline-block;width:1em;margin-right:5px}.toggleMultiselect .topContent{font-size:.8em;padding-right:10px;padding-left:20px;padding-bottom:5px;border-bottom:1px solid #ddd}", ""]);
	
	// exports


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".l2e_sound .sound_controller{display:none}.l2e_sound .soundOption{position:fixed;cursor:pointer;color:#bbb;z-index:999}.l2e_sound #mainButton{left:70px;top:70px;font-size:45px}.l2e_sound #plusButton{left:125px;top:80px}.l2e_sound #minusButton{left:124px;top:99px}.l2e_sound #mainButton-modal{left:20px;top:10px;font-size:50px}.l2e_sound #plusButton-modal{left:75px;top:20px}.l2e_sound #minusButton-modal{left:74px;top:39px}", ""]);
	
	// exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".loadingButton{position:relative;overflow:hidden}.loadingButton .text{position:relative;transition:left .5s linear}", ""]);
	
	// exports


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".owlfonsoContainer{position:relative}.owlfonsoContainer .suggestionBubble{border:1px solid #ccc;border-radius:4px;padding:10px;position:relative;margin-bottom:5px;transition:margin-bottom .4s ease-in;-moz-transition:margin-bottom .4s ease-in;-webkit-transition:margin-bottom .4s ease-in}.owlfonsoContainer .suggestionBubble .feedbackReward{text-align:right}.owlfonsoContainer .suggestionBubble .feedbackReward .coinDisplay{position:relative;bottom:1px;margin-left:5px}.owlfonsoContainer .suggestionBubble .feedbackOverride{text-align:right;cursor:pointer;color:#337ab7}.owlfonsoContainer .suggestionBubble.bubble-animation-enter{opacity:.01}.owlfonsoContainer .suggestionBubble.bubble-animation-enter.bubble-animation-enter-active{opacity:1;transition:all .4s ease-in;-moz-transition:all .4s ease-in;-webkit-transition:all .4s ease-in}.owlfonsoContainer .suggestionBubble.leftUpper.bubble-animation-enter{left:-20px}.owlfonsoContainer .suggestionBubble.leftUpper.bubble-animation-enter.bubble-animation-enter-active{left:0}.owlfonsoContainer .suggestionBubble.bottomLeft.bubble-animation-enter{top:-20px}.owlfonsoContainer .suggestionBubble.bottomLeft.bubble-animation-enter.bubble-animation-enter-active{top:0}.owlfonsoContainer .withArrow:after,.owlfonsoContainer .withArrow:before{border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.owlfonsoContainer .withArrow.leftUpper:after,.owlfonsoContainer .withArrow.leftUpper:before{right:100%;top:20px}.owlfonsoContainer .withArrow.leftUpper:after{border-color:transparent;border-right-color:#fff;border-width:19px;margin-top:23px}.owlfonsoContainer .withArrow.leftUpper:before{border-color:transparent;border-right-color:#ccc;border-width:21px;margin-top:21px}.owlfonsoContainer .withArrow.bottomLeft{margin-bottom:25px}.owlfonsoContainer .withArrow.bottomLeft:after,.owlfonsoContainer .withArrow.bottomLeft:before{left:20px;top:100%}.owlfonsoContainer .withArrow.bottomLeft:after{border-color:transparent;border-top-color:#fff;border-width:19px;margin-left:23px}.owlfonsoContainer .withArrow.bottomLeft:before{border-color:transparent;border-top-color:#ccc;border-width:21px;margin-left:21px}.owlfonsoContainer .owlImg{height:auto}.owlfonsoContainer .owlImg.leftUpper{position:absolute;left:0}.owlfonsoContainer .speechControlsContainer{text-align:right}.owlfonsoContainer .speechControlsContainer .textToSpeech{margin-bottom:5px}.owlfonsoContainer .reasonBtn{margin:5px}.owlfonsoContainer .reasonHeader{font-size:16px;margin-bottom:5px}.owlfonsoContainer .boldText{font-weight:700}.owlfonsoContainer .overrideLinkText{margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".paginationControls{text-align:center}.paginationControls .control{margin:0 .4em}.paginationControls .pageLabel{margin:0 2.3em}.paginationControls .perPage{position:relative;top:-1px;color:#999;margin-left:5px}.paginationControls .perPage .buttonDropdown button.btn{padding:0;color:#999}.paginationControls .perPage .buttonDropdown button.btn .caret{margin-left:2px}.paginationControls .perPage .dropdown-menu{font-size:.8em;min-width:75px}.paginationControls .perPage .dropdown-menu li a{padding:3px 10px}", ""]);
	
	// exports


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProgressBar{margin-bottom:20px}.ProgressBar .progressMessage{font-size:.8em;color:#666}", ""]);
	
	// exports


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".selectOptions{position:relative;z-index:20}.selectOptions .selectInner{position:absolute}.selectOptions .subDivider{background-color:#ddd;height:1px}.selectOptions .subDivider:first-child{height:0}.selectOptions .colorDot{display:inline-block;width:10px;height:10px;border-radius:10px}.selectOptions.present .selectInner{width:100%;border:1px solid #ddd;background-color:#fff;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.selectOptions .selectOp{padding:.5em 1em;cursor:pointer}.selectOptions .selectOp:hover{background-color:#c8ecff!important}.selectOptions .groupHeader{text-align:center;font-size:1.2em;padding:.5em 1em;color:#aaa}", ""]);
	
	// exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".additionalActivityContainer .slideDrawer{background:#fff;top:0;right:0;z-index:200;transform:translateX(100%);opacity:.01}.additionalActivityContainer .slideDrawer,.additionalActivityContainer .slideDrawer.open{transition:transform .5s ease-in,opacity .3s ease .3s;-moz-transition:transform .5s ease-in,opacity .3s ease .3s;-webkit-transition:transform .5s ease-in,opacity .3s ease .3s}.additionalActivityContainer .slideDrawer.open{opacity:1;transform:translateX(0)}.additionalActivityContainer .slideDrawer .optionalHeader{text-align-last:center;font-style:italic;display:block;margin-bottom:15px;font-weight:700}.additionalActivityContainer .drawerTrigger{position:absolute;bottom:0;right:0;cursor:pointer}.additionalActivityContainer .drawerTrigger:hover{font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".spinnerBox.center{position:absolute;left:50%;top:50%}.spinnerBox.placeholder{display:block;position:relative;text-align:center;padding:50px}.spinnerBox.placeholder .spinner{left:50%!important}", ""]);
	
	// exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".stepProgressMeter{text-align:center;margin-bottom:3rem}.stepProgressMeter .meterContainer{display:inline-block;position:relative}.stepProgressMeter .stepCircle,.stepProgressMeter .trackingBar{display:inline-block;vertical-align:middle}.stepProgressMeter .stepCircle{width:5rem;height:5rem;border:1px solid #ddd;border-radius:5.2rem}.stepProgressMeter .stepIcon{width:2.9rem;height:2.9rem;margin:1rem}.stepProgressMeter .trackingBar{height:1rem;margin-left:-.1rem;margin-right:-.1rem}.stepProgressMeter .trackingBar.empty{border:1px solid #ddd}.stepProgressMeter .trackingBar.full{background-color:#42af14}.stepProgressMeter .currentStepDisplay{position:absolute;left:0;top:-1.2rem;transition:left .5s;border-radius:4.6rem;width:4.6rem;height:4.6rem}.stepProgressMeter .finishImgDisplay{display:inline-block}.stepProgressMeter .finishImgDisplay .finishImg{width:5.2rem;height:5.2rem}", ""]);
	
	// exports


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherPreviewNotice{padding:10px;margin-bottom:5px;text-align:center;border-radius:6px;margin-left:auto;margin-right:auto;max-width:750px}.teacherPreviewNotice .btn{margin-left:10px;padding:3px 10px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".validatingInput .subText{margin-bottom:0;text-align:left;font-size:.8em;margin-left:13px}.validatingInput .subText.errorDisplay{color:#c31030}", ""]);
	
	// exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".activitiesPage{margin-top:30px}.activitiesPage .doneLoadingNotice{text-align:center;border:1px solid #ddd;border-radius:5px;padding:5px 10px;margin:0 auto;max-width:650px}.activitiesPage .filterControls{margin-left:-10px;margin-bottom:5px;float:left}.activitiesPage .helpSectionLink{padding-top:.8em}.activitiesPage .displayToggleControl{text-align:right;font-size:16px;margin-bottom:15px}.activitiesPage .activeBar{top:30px}", ""]);
	
	// exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".activityBox .activityBook{font-style:italic;font-size:1.4em}.activityBox .activityBook img{height:30px;vertical-align:top}.activityBox .activityDraftDisplay{position:fixed;right:50%;margin-right:-467px;z-index:100;padding-left:10px;padding-right:10px;background:#f6f6f6;border-radius:5px}.activityBox .deleteDraft{position:relative;top:3px;display:inline-block}.activityBox .draftSpinner{position:relative;left:20px;display:inline-block;width:40px;left:-3px;bottom:2px}.activityBox .btn-link.deleteDraft:focus{outline:none}.activityBox .confirmDelete{padding-right:0}.activityBox .deleteDraftMessage{margin-right:5px;margin-top:7px}.activityBox .speechToTextButton,.activityBox .textToSpeechButton{cursor:pointer;position:absolute;visibility:hidden;filter:drop-shadow(#fff 0 0 3px)}.activityBox .textToSpeechButton{width:24px}.activityBox .speechToTextButton{width:15px}.activityBox .chromeTip{vertical-align:bottom;font-size:.8em;margin-left:10px}.activityBox .textToSpeechContainer{position:relative}.activityBox .textToSpeechContainer:hover .speechToTextButton,.activityBox .textToSpeechContainer:hover .textToSpeechButton{visibility:visible;position:relative;left:15px}.activityBox .albus-absoluteBox .textToSpeechContainer{position:absolute}@keyframes recordingAnimation{0%{border-color:#da3956}50%{border-color:#ddd}}.activityBox .albus-activityHeader h2{font-size:1.4em}.activityBox.bookTitlePostionHack .albus-activityHeader{margin-bottom:55px}.activityBox.bookTitlePostionHack .textTitle{position:relative;top:150px;height:0;margin-top:0;margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "#activityPage{min-height:200px}", ""]);
	
	// exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".activityTile .activityInfo{padding:15px}.activityTile .activityInfo .activityDetails{text-align:center;position:relative;bottom:5px}.activityTile .activityInfo .activityDetails .coinsContainer,.activityTile .activityInfo .activityDetails .timeEstimateContainer{display:inline-block;color:#999}.activityTile .activityInfo .activityDetails .timeEstimateContainer{margin-right:10px}.activityTile .activityInfo .activityDetails .timeEstimateContainer .glyphicon-time{margin-right:5px;color:#555}.activityTile .activityInfo .activityDetails .verticalDivider{border-color:#bbb;top:10px}.activityTile .activityInfo .activityDetails .coinsContainer{margin-left:10px}.activityTile .activityInfo .activityDetails .coinsContainer img{width:14px;margin-right:3px}.activityTile .tileImg{padding:10px;cursor:zoom-in}.activityTile.nonInteractive .tileImg{cursor:default}.activityTile .completedMark{position:absolute;left:50%;bottom:-30px;margin-left:-75px;width:150px;font-size:subHeaderTextSize}.activityTile .completedAt{padding:1rem;font-size:.8em;border-top:1px solid #ddd}", ""]);
	
	// exports


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".allStudentActivitiesTable .noActivityBlock{margin-top:20px}.allStudentActivitiesTable .ProgressBar{margin-bottom:6px;max-width:180px;margin-left:auto;margin-right:auto}.allStudentActivitiesTable .progress{height:10px;margin-left:20px;margin-right:20px;margin-bottom:0}.allStudentActivitiesTable .studentListName{display:inline-block;color:#999;margin-top:3px;font-size:.8em}.allStudentActivitiesTable .studentRow.headerRow{font-size:.9em}.allStudentActivitiesTable .studentRow.headerRow .rowContent{padding-top:0}.allStudentActivitiesTable .studentRow.headerRow .rowContent .sortControlCell{line-height:.6}.allStudentActivitiesTable .studentRow.headerRow .rowContent .sortControlCell .buttonDropdown{width:72%}.allStudentActivitiesTable .studentRow.headerRow .rowContent .sortControlCell .buttonDropdown .dropdown-toggle{padding-left:0;position:relative;bottom:1px}.allStudentActivitiesTable .studentRow .editStudent{font-size:.8em}.allStudentActivitiesTable .studentRow .avatarBox,.allStudentActivitiesTable .studentRow .infoSection,.allStudentActivitiesTable .studentRow .statSection,.allStudentActivitiesTable .studentRow .studentName{position:relative;vertical-align:middle;display:inline-block}.allStudentActivitiesTable .studentRow .infoSection{width:25%}.allStudentActivitiesTable .studentRow .statSection{padding-left:5px;padding-right:5px;text-align:center;width:35%}.allStudentActivitiesTable .studentRow .statSection p{margin-bottom:0}.allStudentActivitiesTable .studentRow .statSection .sectionLabel{font-size:.8em;color:#bbb}.allStudentActivitiesTable .studentRow .statSection .printLink{font-size:.8em}.allStudentActivitiesTable .studentRow .statSection .buttonContainer{margin-left:10px}.allStudentActivitiesTable .studentRow .statSection .buttonContainer li{margin-left:5px}.allStudentActivitiesTable .studentRow .avatarBox{width:23%}.allStudentActivitiesTable .studentRow .studentName{width:77%;text-align:left}.allStudentActivitiesTable .studentRow .longContent{display:inline-block;width:100%;font-size:.8em;vertical-align:middle;max-height:2.7em;overflow:hidden}.allStudentActivitiesTable .studentRow .rowContent{border-bottom:1px solid #ddd;padding-bottom:12px;padding-top:12px}.allStudentActivitiesTable .studentRow .rowContent .buttonDropdown .dropdown-header{margin-right:0;border-bottom:1px solid #ddd;font-size:inherit;padding:0 20px;margin-top:5px;margin-bottom:5px}.allStudentActivitiesTable .studentRow .rowContent .buttonDropdown .dropdown-menu .ellipsisText{padding-left:30px}.allStudentActivitiesTable .dataCell{width:33%}", ""]);
	
	// exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".assignExerciseDetailsForm .smartBookSearch{width:75%;margin-bottom:15px;float:right}.assignExerciseDetailsForm .smartBookSearch .searchBar{margin-left:5px}.assignExerciseDetailsForm input{margin-left:10px!important;vertical-align:text-top!important}.assignExerciseDetailsForm label{margin-bottom:10px!important}.assignExerciseDetailsForm .activityDetailsNote{font-size:small;margin-left:5px;margin-top:20px;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".exercisePage{margin-top:30px}.exercisePage .modalWrap .Select-input{padding-left:0}.exercisePage .doneLoadingNotice{text-align:center;border:1px solid #ddd;border-radius:5px;padding:5px 10px;margin:0 auto;max-width:650px}.exercisePage .filterControls{margin-left:-10px;margin-bottom:5px;float:left}.exercisePage .displayToggleControl{text-align:right}.exercisePage .helpSectionLink{padding-top:.8em}", ""]);
	
	// exports


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".exerciseTile{overflow:hidden}.exerciseTile .activityTitle,.exerciseTile .responseBody,.exerciseTile .tileImg{padding:10px}.exerciseTile.clickableElement{cursor:zoom-in}.exerciseTile.clickableElement:hover{opacity:.7!important}.exerciseTile .responseInfo .responseHeader{position:relative}.exerciseTile .responseInfo .activityTitle{margin-bottom:0;border-bottom:1px solid #ddd}.exerciseTile .responseInfo .activityTitle.narrow{padding-right:20px;padding-left:20px}.exerciseTile .responseInfo .bookTitle{margin-bottom:5px}.exerciseTile .responseInfo .removeButton{position:absolute;right:4px;top:4px;padding:0;font-size:15px;outline:none;color:#999}.exerciseTile .responseInfo .removeButton:hover{color:#555}.exerciseTile .imgContainer.small{max-height:150px}.exerciseTile .date{display:block;position:relative;color:#999}", ""]);
	
	// exports


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".expandedStudentActivitiesTable table{font-size:.8em;width:100%}.expandedStudentActivitiesTable .sortControlContainer{font-size:.8em;border-bottom:1px solid #ddd;line-height:.6;width:100%;padding-bottom:5px;margin-bottom:15px}.expandedStudentActivitiesTable .sortControlContainer .sortControlCell{width:25%}.expandedStudentActivitiesTable .sortControlContainer .buttonDropdown{width:72%}.expandedStudentActivitiesTable .sortControlContainer .buttonDropdown .dropdown-toggle{padding-left:0;position:relative;bottom:1px}.expandedStudentActivitiesTable td.editable a{font-size:.8em;float:right;margin-top:2px}.expandedStudentActivitiesTable td.editable .editIcon{position:relative;left:5px;margin-top:2px;float:right}.expandedStudentActivitiesTable td{vertical-align:middle!important}.expandedStudentActivitiesTable th.bookCol{width:30%}.expandedStudentActivitiesTable th.quizCol,.expandedStudentActivitiesTable th.writingCol{min-width:7.7em}.expandedStudentActivitiesTable th.answerCol,.expandedStudentActivitiesTable th.responseCol,.expandedStudentActivitiesTable th.reviewCol,.expandedStudentActivitiesTable th.textVarietyCol{min-width:5em}.expandedStudentActivitiesTable th.ReadingLevelCol{min-width:6em}.expandedStudentActivitiesTable .scoreDisplay{display:inline-block;margin-right:.4em}.expandedStudentActivitiesTable .textVarietyDisplay{margin-right:.4em}.expandedStudentActivitiesTable .truncatedPlaceholder td{text-align:center}.expandedStudentActivitiesTable .truncatedPlaceholder td .btn{position:relative;bottom:1px}.expandedStudentActivitiesTable .textRow td.writingCount{padding:5px}.expandedStudentActivitiesTable .textRow td.writingCount .hideOnPrint{margin-left:10px}.expandedStudentActivitiesTable .iconContainer{text-align:center}.expandedStudentActivitiesTable .icon-green{color:green}.expandedStudentActivitiesTable .icon-gray{color:gray}.expandedStudentActivitiesTable .viewLink{margin-left:5px;vertical-align:super}.expandedStudentActivitiesTable .glyphicon{font-size:1.7em}", ""]);
	
	// exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherPicksTable .otherWritingContainer{min-width:150px;min-height:max-content}.teacherPicksTable .textTitleColumn{font-style:italic;max-width:200px}.teacherPicksTable table{font-size:.8em;width:100%}.teacherPicksTable .sortControlContainer{font-size:.8em;border-bottom:1px solid #ddd;line-height:.6;width:100%;padding-bottom:5px;margin-bottom:15px}.teacherPicksTable .sortControlContainer .sortControlCell{width:25%}.teacherPicksTable .sortControlContainer .buttonDropdown{width:72%}.teacherPicksTable .sortControlContainer .buttonDropdown .dropdown-toggle{padding-left:0;position:relative;bottom:1px}.teacherPicksTable td.editable a{font-size:.8em;float:right;margin-top:2px}.teacherPicksTable td.editable .editIcon{position:relative;left:5px;margin-top:2px;float:right}.teacherPicksTable td{vertical-align:middle!important}.teacherPicksTable th.bookCol{width:30%}.teacherPicksTable th.quizCol,.teacherPicksTable th.writingCol{min-width:7.7em}.teacherPicksTable th.answerCol,.teacherPicksTable th.responseCol,.teacherPicksTable th.reviewCol,.teacherPicksTable th.textVarietyCol{min-width:5em}.teacherPicksTable th.ReadingLevelCol{min-width:6em}.teacherPicksTable .scoreDisplay{display:inline-block;margin-right:.4em}.teacherPicksTable .textVarietyDisplay{margin-right:.4em}.teacherPicksTable .truncatedPlaceholder td{text-align:center}.teacherPicksTable .truncatedPlaceholder td .btn{position:relative;bottom:1px}.teacherPicksTable .textRow td.writingCount{padding:5px}.teacherPicksTable .textRow td.writingCount .hideOnPrint{margin-left:10px}.teacherPicksTable .iconContainer{text-align:center}.teacherPicksTable .icon-green{color:green}.teacherPicksTable .icon-gray{color:gray}.teacherPicksTable .viewLink{margin-left:5px;cursor:pointer}.teacherPicksTable .glyphicon{font-size:1.7em}.teacherPicksTable .hide-glyphicon{opacity:0}", ""]);
	
	// exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".answerAnalysisDisplay{margin-top:10px;margin-bottom:20px}.answerAnalysisDisplay .collapseOption{float:right;font-size:.8em;cursor:pointer}.answerAnalysisDisplay .feedbackArea{padding:20px;margin-bottom:50px}.answerAnalysisDisplay .categoryRow{margin-bottom:10px}.answerAnalysisDisplay .feedbackTable{width:100%}.answerAnalysisDisplay .feedbackTable .validCountCell{width:20%}.answerAnalysisDisplay .feedbackTable .descriptionCell{font-size:13px;width:80%}.answerAnalysisDisplay .feedbackTable .valid{color:#42af14}.answerAnalysisDisplay .feedbackTable .average{color:#ede309}.answerAnalysisDisplay .feedbackTable .error{color:#da3956}.answerAnalysisDisplay .feedbackTable .icon{height:15px;width:1.8rem;float:right}.answerAnalysisDisplay .feedbackTable .appearIn{width:100%;height:auto}.answerAnalysisDisplay .hiddenElement{display:none}.answerAnalysisDisplay .reactionFeedback{float:right;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".answerDisplay.asDraft{opacity:.7}.answerDisplay .questionText{font-weight:700;margin-bottom:1rem;clear:both}.answerDisplay .missingEvaluation{margin-top:10px}.answerDisplay .answerText{overflow:hidden;overflow-wrap:break-word;border:1px solid #ddd;border-radius:5px;padding:1rem;width:fit-content;max-width:100%}.answerDisplay .answerText.editMode{overflow:unset}.answerDisplay .innerAnswer .commentBox{margin-top:15px}.answerDisplay .matchStatus{padding-right:.6em;margin-right:.6em;border-right:1px solid #bbb}.answerDisplay .matchStatus.correct .glyphicon{color:#42af14}.answerDisplay .matchStatus.incorrect .glyphicon{color:#a1011e}.answerDisplay .answerKey{font-size:.8em;margin-bottom:10px;margin-top:2px}.answerDisplay .linkToQuiz{border-radius:40px;height:5.2rem;min-width:5.2rem;padding:15px 3px 0;text-align:center;border:2px solid #ddd;line-height:1.3}.answerDisplay .revisionButton{margin-right:10px;margin-bottom:10px}.writingDisplay .answerDisplayRow>div>*,.writingDisplay .quizDisplayRow>div>*{display:inline-block;vertical-align:middle;margin-left:10px;margin-right:10px}.writingDisplay .answerDisplayRow>div>:first-child,.writingDisplay .quizDisplayRow>div>:first-child{margin-left:0}.writingDisplay .answerDisplayRow>div>:last-child,.writingDisplay .quizDisplayRow>div>:last-child{margin-right:0}.writingDisplay .answerDisplayRow.secondRow,.writingDisplay .answerDisplayRow.topRow,.writingDisplay .quizDisplayRow.secondRow,.writingDisplay .quizDisplayRow.topRow{padding-bottom:10px}.writingDisplay .answerDisplayRow .studentDisplay,.writingDisplay .quizDisplayRow .studentDisplay{position:relative;top:6px}.writingDisplay .answerDisplayRow .studentOwlvatar,.writingDisplay .quizDisplayRow .studentOwlvatar{display:inline-block;vertical-align:middle}.writingDisplay .answerDisplayRow .displayToggleControl,.writingDisplay .quizDisplayRow .displayToggleControl{padding-bottom:0}.writingDisplay .innerWrap{display:flex;position:relative}.writingDisplay .innerAnswer{position:relative;z-index:1;transition:width .2s ease 0s;width:100%}.writingDisplay.withControl .innerAnswer{width:58%;display:inline-block;white-space:normal}.writingDisplay.withControl .innerWrap{white-space:nowrap}.writingDisplay .controlBox{position:relative;display:inline-block;vertical-align:top;margin-left:2%;width:40%;white-space:normal;border:1px solid #ddd;border-radius:5px;padding:10px}.writingDisplay .controlBox .removeLink{position:absolute;right:10px;top:10px;color:#aaa;font-size:.8em}.writingDisplay .controlBox .removeLink:hover{opacity:.7}.writingDisplay .controlBox .controlTitle{margin-bottom:10px;font-weight:700}.writingDisplay.withUpperControl .controlBox{border-top:none;border-bottom:none;border-radius:0;padding-top:0;padding-bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".answerLengthMeter .title{margin-bottom:10px;font-size:.8em}.answerLengthMeter .progress{margin-bottom:5px;height:8px;margin-top:-5px}", ""]);
	
	// exports


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".answerWritingInterface .questionOptionBox,.answerWritingInterface .topOuterContainer{float:left;width:56%;position:relative;left:22%;transition:left .5s}.answerWritingInterface .questionOptionBox.slideLeft,.answerWritingInterface .topOuterContainer.slideLeft{left:0}.answerWritingInterface .questionFeedbackBox{float:right;width:40%}.answerWritingInterface .promptText{margin-bottom:12.5px}.answerWritingInterface .speechToText{border-radius:50%;width:auto;height:25px;cursor:pointer;margin-left:10px}.answerWritingInterface textarea.singleAnswer{margin-bottom:10px;resize:vertical}.answerWritingInterface .fillInTheBlank{margin-bottom:10px}.answerWritingInterface .textToSpeech{border-radius:50%;width:auto;height:25px;cursor:pointer}.answerWritingInterface .buttons{position:absolute;top:0;right:0}.answerWritingInterface .controls{position:relative;height:41px}.answerWritingInterface .controls .speechControlsContainer{position:absolute;top:6px;left:0}.answerWritingInterface .voiceFirstSpeechControls .speechToText,.answerWritingInterface .voiceFirstSpeechControls .textToSpeech{height:40px}.answerWritingInterface .voiceFirstSpeechControls .speechControlsContainer{position:relative;top:-10px;margin-top:3%;margin-bottom:3%}.answerWritingInterface .submitAnyway{margin-right:10px}.answerWritingInterface .changeQuestionLink{float:right;margin-left:5px;white-space:nowrap;font-size:.8em;margin-top:4px;position:relative;display:inline-block}", ""]);
	
	// exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".multiPartAnswerDisplay.emphasizeInputs .inputText{border-bottom:2px solid #bbb;padding:.1rem .3em;margin-right:.2em}.multiPartAnswerDisplay.emphasizeStarters .starter{border:1px solid #ddd;border-radius:5px;padding:.1rem .3em;color:#888}", ""]);
	
	// exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".newAnswerPage .textVariety .textTitle{margin-top:0;margin-bottom:20px}.newAnswerPage .skillsetOptions{text-align:center}.newAnswerPage .skillsetOptions .skillsetBanner{margin-bottom:30px;display:inline-block;vertical-align:top;cursor:pointer}.newAnswerPage .skillsetOptions .skillsetBanner:hover{opacity:.7}.newAnswerPage .skillsetOptions .skillsetBanner:nth-child(odd){margin-right:25px}.newAnswerPage .skillsetOptions .skillsetBanner:nth-child(2n){margin-left:25px}.newAnswerPage .changeQuestionsContainer{text-align:right;margin-bottom:5px}.newAnswerPage .backToQuestionsContainer{position:absolute;margin-top:30px;width:15%;text-align:center;font-size:.8em}.newAnswerPage .backToQuestionsContainer .confirmationOptions{font-size:.8em}.newAnswerPage .reviewRating{margin-bottom:10px}.newAnswerPage .reviewRating .bookRating{position:relative;top:-5px}.newAnswerPage .textTitle{font-size:1.4em;font-style:italic;text-align:center;max-width:54%;margin-left:23%}.newAnswerPage .textTitle.onQuestionSelect{margin-top:0;margin-bottom:10px}.newAnswerPage .answerDemo .AnswerWritingDemo{margin-top:30px}", ""]);
	
	// exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".questionBuilderPage .buttonNonClickable{background-color:#ccc;border:1px solid #555;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif}.questionBuilderPage .questionDisplayBox,.questionBuilderPage .topOuterContainer{float:left;width:50%;position:relative;left:22%;transition:left .5s}.questionBuilderPage .questionDisplayBox.slideLeft,.questionBuilderPage .topOuterContainer.slideLeft{left:4%}.questionBuilderPage .textTitle{text-align:center}.questionBuilderPage .questionFeedbackBox{float:right;width:40%;position:relative;right:4%}.questionBuilderPage .buttonsBox{top:5px;position:relative;height:41px;margin-top:20px}.questionBuilderPage .buttonPrimaryLeft{position:absolute;top:0;left:0}.questionBuilderPage .buttonPrimaryRight{position:absolute;top:0;right:0}.questionBuilderPage .submitAnyway{margin-right:120px}.questionBuilderPage .exampleStylingWriteSentence,.questionBuilderPage .questionStylingSelectBlank,.questionBuilderPage .textStylingSelectBlank,.questionBuilderPage .textStylingWriteSentence{position:relative;top:10px}.questionBuilderPage .middleBarStyle{transform:scale(.8)}.questionBuilderPage .editButtonStyling{position:relative;right:-5px;transform:scale(.8)}.questionBuilderPage .deleteButtonStyling{position:relative;left:-5px;transform:scale(.8)}.questionBuilderPage .doneButtonStyling{transform:scale(.8)}.questionBuilderPage .synonym-input{display:inline-block;margin:5px;width:60%}", ""]);
	
	// exports


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".analysisControls .infoBox{font-size:.8em}.analysisControls .infoBox .skillsetStandardLabel{font-size:inherit}.analysisControls .infoBox p:last-child{margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".editControls .editInput{display:inline-block;border:none;border-bottom:1px solid #888;width:3em;text-align:center}.editControls .btn.btn-link.saveButton{color:#42af14;padding:0;position:relative;bottom:1px}.editControls .form-control.scoreEdit{display:inline-block;width:3em;height:25px;padding:5px;margin-left:10px}.editControls .editRow{margin-bottom:10px}.editControls .editRow:last-child{margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".feedbackControls{padding-bottom:15px}.feedbackControls .commentBox{font-size:.8em}.feedbackControls .braveCheckbox{margin-top:20px;font-size:.8em}.feedbackControls .textLabel{margin-left:35px}.feedbackControls .needsCommentsMessage,.feedbackControls .revisedAtText{font-size:.8em;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".onboardingStageAutograderDemo .nextStage{margin-top:1em}.autograderDemo{font-size:.9em}.autograderDemo .intro{padding:0 2em;text-align:center}.autograderDemo .intro .list{padding:1em 4em;text-align:left;line-height:2em}.autograderDemo .step{text-align:center;font-style:italic;margin-top:2em}.autograderDemo .step .title{width:50%;margin-left:25%;font-size:1.2em;border-bottom:1px solid #ccc;margin-bottom:.2em}.autograderDemo .step .subtitle{padding:.5em 4em 2em;font-size:.9em}.autograderDemo .bookOptionsContainer{text-align:center;display:flex;flex-wrap:wrap;gap:1em}.autograderDemo .largeObject{flex-basis:12em;flex-grow:1;flex-shrink:1}.autograderDemo .largeObject .bookCover{width:-webkit-fill-available;padding:.5em}.autograderDemo .largeObject .bookCover .bookDetails{padding-left:0;text-align:center;width:100%}.autograderDemo .largeObject.selected{background-color:#defad2}.autograderDemo .largeObject.push{padding-top:2rem}.autograderDemo .largeObject .opTitle{margin-bottom:5px}.autograderDemo .largeObject .comp{font-size:.8em}.autograderDemo .largeObject .time{font-size:.8em;color:#999}.autograderDemo .questionOptionBox,.autograderDemo .topOuterContainer{float:left;width:56%;position:relative;left:22%;transition:left .5s}.autograderDemo .questionOptionBox.slideLeft,.autograderDemo .topOuterContainer.slideLeft{left:0}.autograderDemo .answerFeedbackContainer{padding-left:1em;padding-right:1em}.autograderDemo .questionFeedbackBox{float:right;width:40%}.autograderDemo .promptText{margin-bottom:12.5px}.autograderDemo .speechToText{border-radius:50%;width:auto;height:25px;cursor:pointer;margin-left:10px}.autograderDemo textarea.singleAnswer{margin-bottom:10px;resize:vertical}.autograderDemo .fillInTheBlank{margin-bottom:10px}.autograderDemo .textToSpeech{border-radius:50%;width:auto;height:25px;cursor:pointer}.autograderDemo .buttons{position:absolute;top:0;right:0}.autograderDemo .controls{position:relative;height:41px}.autograderDemo .controls .speechControlsContainer{position:absolute;top:6px;left:0}.autograderDemo .voiceFirstSpeechControls .speechToText,.autograderDemo .voiceFirstSpeechControls .textToSpeech{height:40px}.autograderDemo .voiceFirstSpeechControls .speechControlsContainer{position:relative;top:-10px;margin-top:3%;margin-bottom:3%}.autograderDemo .submitAnyway{margin-right:10px}.autograderDemo .changeQuestionLink{float:right;margin-left:5px;white-space:nowrap;font-size:.8em;margin-top:4px;position:relative;display:inline-block}.autograderDemo #answerLengthMeter .progress{width:unset;margin:-5px unset 5px;height:8px}.autograderDemo .rubricTableContainer .table,.autograderDemo .rubricTableContainer .table .headerCell{font-size:.9em}.autograderDemo .rubricTableContainer .table .standardCell{cursor:default;max-width:1em;text-align:center;vertical-align:middle}.autograderDemo .rubricTableContainer .table .standardCell .textContainer{padding:.3em 0;border-radius:1em}.autograderDemo .rubricTableContainer .table .longCell{max-width:2.5em;position:relative}.autograderDemo .rubricTableContainer .table .longCell .badge{margin-left:1em;font-size:9px;font-weight:400}.autograderDemo .rubricTableContainer .table .longCell .__react_component_tooltip{text-align:center;font-weight:700}.autograderDemo .rubricTableContainer .table .fontColor-green{color:#42af14}.autograderDemo .rubricTableContainer .table .fontColor-red{color:#ff7346}.autograderDemo .rubricTableContainer .table .fontColor-yellow{color:#de970b}.autograderDemo .rubricTableContainer .table .backgroundColor-yellow{background:#fef7d9}.autograderDemo .rubricTableContainer .table .backgroundColor-green{background:#e3f3e2}.autograderDemo .rubricTableContainer .table .backgroundColor-red{background:#ffeae3}.autograderDemo .rubricTableContainer .table .backgroundColor-blue{background:#00a0f4}.autograderDemo .rubricTableContainer .table .backgroundColor-dark-green{background:#42af14}.autograderDemo .upgradeDisclaimer{text-align:center;margin-bottom:.2em;margin-top:2em;padding:1em 2em;border-radius:1em;background:#ddd}.autograderDemo .upgradeDisclaimer .title{width:50%;margin-left:25%;font-size:1.2em;font-weight:700;border-bottom:1px solid #ccc;margin-bottom:.2em}.autograderDemo .consultationLink{font-weight:700}.autograderDemo .textEvidenceContainer{margin:2em 0}.autograderDemo .textEvidenceContainer .textEvidenceContent{padding:1em 4em;box-shadow:0 4px 8px 0 rgba(0,0,0,.2)}", ""]);
	
	// exports


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".evaluationBox img{max-width:45px}.evaluationBox .btn{margin-left:5px;margin-top:0;padding:0}.evaluationBox .btn-link:focus{outline:none}.evaluationBox .not-selected{opacity:.5}.evaluationBox .not-selected:hover{opacity:1}.evaluationBox .autoGraded:hover{filter:none;-webkit-filter:none}.evaluationBox .autoGraded{filter:hue-rotate(179deg) drop-shadow(#0082c8 0 0 4px);transition:opacity 1s}.evaluationBox .autoGraded.glowOut{opacity:.5}.evaluationBox .autoGraded.glowOut:hover{opacity:1}.evaluationBox .gradeMeNotice{margin-top:10px;float:right;font-style:italic}", ""]);
	
	// exports


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".evaluationTags .feedback{display:block;font-size:.8em}.evaluationTags .tagContainer{display:inline-block;margin-right:10px;margin-bottom:10px}.evaluationTags .tagContainer.positive{color:#195500}.evaluationTags .tagContainer.negative{color:#a1011e}.evaluationTags .tagContainer .evaluationTag{border:1px solid #ddd;border-radius:5px;padding:5px;display:inline-block;cursor:pointer}.evaluationTags .moreTagsLink{cursor:pointer}.evaluationTags .activeTag{border:none;padding-left:10px}.evaluationTags .activeTag.positive{background-color:#c0f2aa}.evaluationTags .activeTag.positive .title{color:#195500}.evaluationTags .activeTag.negative{background-color:#ffcbb3}.evaluationTags .activeTag.negative .title{color:#782700}.evaluationTags .activeTag.expandedTag{background-color:#fff}.evaluationTags .activeTag.expandedTag.positive{border:2px solid #195500}.evaluationTags .activeTag.expandedTag.negative{border:2px solid #782700}.evaluationTags .expandedTag{display:inline-block;vertical-align:top;padding:4px 8px;border:1px solid #ddd;border-radius:6px;padding:5px;width:24%;margin-right:1%;margin-bottom:8px;min-height:90px;color:#555}.evaluationTags .expandedTag .title{font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".rubricItemOverride.tableView{font-size:.8em}.rubricItemOverride.tableView .table{margin-top:.5em}.rubricItemOverride.tableView tr{border-style:none}.rubricItemOverride.tableView td{border:none;padding:4px}.rubricItemOverride.tableView .btnContainer{width:100%;text-align:center}.rubricItemOverride.tableView .btnContainer .saveBtn{padding:3px 12px}.rubricItemOverride .rubricOverrideInlineContainer{width:100%;margin-top:.5em}.rubricItemOverride .rubricOverrideInlineContainer .titleContainer{width:45%;display:inline-block;cursor:default}.rubricItemOverride .rubricOverrideInlineContainer .dropdownContainer{width:45%;display:inline-block}.rubricItemOverride .rubricOverrideInlineContainer .warningContainer{display:inline}.rubricItemOverride .rubricLabelSelector .btn{padding:0}.rubricItemOverride .warningIcon{color:#fbb03c;float:right;font-size:1.3em}.rubricItemOverride .readTheBookOverride{margin-top:.5em}.rubricItemOverride .readTheBookOverride .rubricItemOverride{display:inline}.rubricItemOverride .readTheBookOverride .rubricItemOverride .rubricLabelSelector{margin-left:1em}.rubricItemOverride .readBookDataTip{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".scoreDisplay{text-align:right}.scoreDisplay.empty{display:none}.scoreDisplay.inlineMode{display:flex!important;justify-content:space-between;float:left}.scoreDisplay.inlineMode.withFlag{width:60%}.scoreDisplay.inlineMode.noFlag{width:50%}.scoreDisplay.circleMode{display:inline-block;border-radius:40px;height:5.2rem;min-width:5.2rem;padding:15px 3px 0;text-align:center}.scoreDisplay.circleMode.uncertainDisplay{border:2px solid #bbb;background-color:#ddd}.scoreDisplay.circleMode.passDisplay{border:2px solid #70d544}.scoreDisplay.circleMode.failDisplay{border:2px solid #a1011e}.scoreDisplay.circleMode.neutralDisplay{border:2px solid #ddd}.scoreDisplay.circleMode .denominator{font-size:.8em;color:#888}.scoreDisplay.adminScoreForm{min-width:8em;height:fit-content;padding:8px 3px}.scoreDisplay.adminScoreForm.saveShowing{padding:15px 0 0}.scoreDisplay.adminScoreForm .scoreInput{width:50%;margin-left:5%;display:inline-block;padding:6px}.scoreDisplay.adminScoreForm .scoreCap{width:25%;display:inline-block}.scoreDisplay.adminScoreForm .warningIcon{float:right;color:#fbb03c}.scoreDisplay.adminScoreForm .saveButton{color:#42af14}.inlineFlagContainer{text-align:center!important}.scoreContainer{display:flex!important;flex-direction:row;justify-content:center;align-items:center}.flagContainer{padding-left:5%}.scoringFlags .filterIcon{color:#c31030}.scoringFlags .warningIcon{color:#fbb03c}#hourglassDataTip{white-space:pre-wrap;line-height:normal;font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".scoringData{margin-top:10px;position:relative}.scoringData .categoriesSection .moreScoring{float:right}.scoringData .categoriesSection .scoringCategories,.scoringData .categoriesSection .scoringInfo{display:inline-block;vertical-align:top}.scoringData .categoriesSection .scoringFlags{font-size:.8em;margin-top:10px;margin-bottom:5%}.scoringData .categoriesSection .scoringFlags .filterIcon{color:#c31030}.scoringData .categoriesSection .scoringFlags .warningIcon{color:#fbb03c}.scoringData .categoriesSection .scoringCategories{width:100%;font-size:.8em}.scoringData .categoriesSection .scoringCategories .table{margin-bottom:0}.scoringData .categoriesSection .scoringCategories .table td{cursor:pointer;border:none;padding:4px}.scoringData .categoriesSection .scoringCategories .table tr{cursor:pointer}.scoringData .categoriesSection .scoringCategories .table tr.selectedCategory,.scoringData .categoriesSection .scoringCategories .table tr:hover{font-weight:700}.scoringData .categoriesSection .scoringCategories .table .badge{position:relative;bottom:1em;font-size:9px;font-weight:400;left:.3em}.scoringData .categoriesSection .scoringCategories .table .badge.green{background-color:#42af14}.scoringData .categoriesSection .scoringCategories .table .badge.blue{background-color:#00a0f4}.scoringData .categoriesSection .scoringCategories .editBtnContainer{width:100%;text-align:center;margin-top:1.2em}.scoringData .categoriesSection .scoringCategories .editBtnContainer .btn{padding:3px 6px}.scoringData .categoriesSection .paddingRemark{padding-bottom:55px}.scoringData .categoriesSection .scoringInfo{width:50%;margin-left:45px;font-size:.8em;margin-bottom:10px;margin-top:10px}.scoringData .categoriesSection .scoringInfo .reactionFeedback{margin-bottom:20px}.scoringData .categoriesSection .scoringInfo .tagDetails{margin-bottom:5px!important}.scoringData .categoriesSection .scoringInfo .reactionFeedback{position:absolute;bottom:0;right:0}.scoringData .swatch{float:left;display:inline-block;width:20px;height:20px;border-radius:20px;margin-right:10px;vertical-align:bottom}.scoringData .descriptionAndCount{display:block;margin-left:30px}.scoringData .showToggle{margin-top:5px;text-align:right}.scoringData .showToggle .toggleLink{cursor:pointer}.scoringData .color-green{color:#42af14}.scoringData .color-red{color:#ff7346}.scoringData .color-yellow{color:#fdda16}", ""]);
	
	// exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".textAreaMarkups{text-align:justify;overflow:hidden}", ""]);
	
	// exports


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".fillInTheBlank input{display:inline-block;width:12em;height:26px;padding:6px}.fillInTheBlank input,.fillInTheBlank span.text{margin-right:.6em}", ""]);
	
	// exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".FITBAnswerBox .answerOp{display:inline-block;white-space:nowrap;border:1px solid #ccc;border-radius:3px;padding:0 10px;margin-right:5px;margin-bottom:5px}.FITBAnswerBox .answerOp:hover{text-decoration:line-through;cursor:pointer;opacity:.7}", ""]);
	
	// exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".questionFeedback .feedbackQuote{font-size:.8em;border-left:1px solid #aaa;padding-left:5px;font-style:italic}.questionFeedback .feedbackNormal:last-child,.questionFeedback .feedbackQuote:last-child{margin-bottom:0}.questionFeedback .showMore{position:relative;bottom:100px;right:10px;font-size:.8em}", ""]);
	
	// exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".sentenceStarterTextArea{position:relative}.sentenceStarterTextArea .starterWrap{position:absolute;top:7px;left:12px;right:12px;text-align:justify;pointer-events:none}.sentenceStarterTextArea .lineFix{position:absolute;width:12px;border-bottom:1px solid #ccc;padding-bottom:5px}.sentenceStarterTextArea .lineFix.rightFix{padding-bottom:6px;width:13px}.sentenceStarterTextArea textarea{margin-bottom:10px;resize:none}.sentenceStarterTextArea .starter{color:#888;border-right:1px solid #ccc;border-bottom:1px solid #ccc;border-bottom-right-radius:4px;padding-right:5px;background-color:#fff;padding-top:3px}.sentenceStarterTextArea .end{display:inline-block;opacity:0;width:0}", ""]);
	
	// exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".skillsetBanner{position:relative;text-align:center}.skillsetBanner .title{text-align:center;padding-top:20px;margin-bottom:-61px;font-size:2em}.skillsetBanner .title .inner{display:inline-block;max-width:50%;border-bottom:1px solid #ddd;padding:0 5px}.skillsetBanner.largeBanner img.banner{width:90%;height:auto}.skillsetBanner.smallBanner{width:400px}.skillsetBanner.smallBanner .title{padding-top:11px;margin-bottom:-30px;font-size:16px}.skillsetBanner.smallBanner img.banner{width:100%;height:auto}.skillsetBanner .text{text-align:left;margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".skillsetStandardLabel{display:inline-block;font-size:.8em;font-weight:400;color:#888}", ""]);
	
	// exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".speechControlsContainer .speechToText{margin-left:10px}.speechControlsContainer .speechToText,.speechControlsContainer .textToSpeech{border-radius:50%;width:auto;height:25px;cursor:pointer}.speechControlsContainer .chromeTip{display:inline-block;margin-left:10px;color:#999}", ""]);
	
	// exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".textQuestionsPage .contentContainer .backLink{cursor:pointer}.textQuestionsPage .contentContainer .displayToggleControl{text-align:right}.textQuestionsPage .contentContainer .textQuestionsContainer{margin-top:15px}.textQuestionsPage .contentContainer .textQuestionsContainer .text{margin-bottom:20px}.textQuestionsPage .contentContainer .textQuestionsContainer .validatingInput{vertical-align:top;margin:0 25px 5px 0}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer{font-size:.8em;display:inline-block;width:40%;margin:30px;vertical-align:top;margin-bottom:10px;margin-top:0}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer:nth-of-type(odd){margin-left:0}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer:nth-of-type(odd) .verticalDivider{border-left:1px solid #ddd;vertical-align:top;left:86px;height:50px;top:0}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer:nth-of-type(2n){margin-left:144px;margin-right:0}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer:nth-of-type(2n) .verticalDivider{display:none}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question{display:inline-block;width:99%}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .bodyContainer{overflow-wrap:break-word}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .answersContainer,.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .bodyContainer,.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .originTag{margin-bottom:5px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .originTag{float:left;color:#999}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .questionControls{float:right}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .questionControls a{cursor:pointer}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .questionControls .editLink{border-right:1px solid #bbb;padding-right:10px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .question .questionControls .controlLink{margin-left:10px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .editingContainer{display:inline-block;width:99%;margin-bottom:15px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .editingContainer .editQuestionForm .controls .buttonSuccess{margin-bottom:5px;margin-right:15px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .editingContainer .editQuestionForm .controls .cancelLink{margin-left:5px}.textQuestionsPage .contentContainer .textQuestionsContainer .questionAnswerContainer .editingContainer .FITBAnswerBox{margin-bottom:15px}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm{margin-top:15px}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .inputContainer{display:inline-block;width:40%}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .inputContainer:nth-of-type(2n){vertical-align:top;margin-left:3%}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .inputContainer .inputLabel{font-weight:700}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .inputContainer .instructionText{font-size:.8em;color:#999}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm p{margin-bottom:5px}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .controls{display:inline-block;position:relative;top:49px;margin-left:5%;bottom:15px;vertical-align:top}.textQuestionsPage .contentContainer .textQuestionsContainer .newQuestionForm .controls .buttonSuccess{cursor:pointer}.textQuestionsPage .questionBodyInput .validatingInput .subText{margin-left:0}", ""]);
	
	// exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".autosaver{position:fixed;top:78px;right:30px;z-index:100;text-align:center;padding:3px 10px;background:#fff;border-radius:3px;font-size:.8em}.autosaver .deleteDraft,.autosaver .saveForLater{margin-bottom:0;display:inline-block;padding-top:0;padding-bottom:0}.autosaver .saveForLater{padding-left:0;padding-right:0;min-width:88px!important;margin-top:5px}.autosaver .draftSpinner{position:relative;bottom:5px;display:inline-block;width:29px;left:-3px}.autosaver .btn-link.deleteDraft:focus{outline:none}.autosaver .confirmDelete{padding-right:0}.autosaver.autosaverDelete{width:15%}", ""]);
	
	// exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".quizAnalysisDisplay{margin-bottom:10px}.quizAnalysisDisplay .overriddenDisclaimer{font-size:.6em;margin-top:5px}.quizAnalysisDisplay .questionFeedback{position:absolute}.quizAnalysisDisplay .questionFeedback .owlfonsoContainer{opacity:1;left:80%;transition:all .3s ease-in;-moz-transition:all .3s ease-in;-webkit-transition:all .3s ease-in;width:70%;position:relative}.quizAnalysisDisplay .questionFeedback.owlfonso-animation-enter .owlfonsoContainer{opacity:.01;left:0}.quizAnalysisDisplay .questionFeedback.owlfonso-animation-enter.owlfonso-animation-enter-active .owlfonsoContainer{opacity:1;left:80%}.quizAnalysisDisplay .questionFeedback.owlfonso-animation-exit .owlfonsoContainer .suggestionBubble{opacity:0}.quizAnalysisDisplay .questionFeedback.owlfonso-animation-exit.owlfonso-animation-exit-active .owlfonsoContainer{left:250%}.quizAnalysisDisplay .collapseOption{float:right;font-size:.8em;cursor:pointer}.quizAnalysisDisplay .feedbackArea{display:inline-block;position:relative;top:0;left:0;transition:all .7s ease-in;-moz-transition:all .7s ease-in;-webkit-transition:all .7s ease-in}.quizAnalysisDisplay .feedbackArea.feedback-animation-enter{left:-100%;opacity:.01}.quizAnalysisDisplay .feedbackArea.feedback-animation-enter.feedback-animation-enter-active{left:0;opacity:1}.quizAnalysisDisplay .feedbackArea .dividerWithTitle{margin-bottom:1rem;margin-top:1rem;position:relative;text-align:center}.quizAnalysisDisplay .feedbackArea .dividerWithTitle .dividerArea{width:100%;border:1px solid #ddd;position:absolute;top:50%}.quizAnalysisDisplay .feedbackArea .dividerWithTitle .titleArea{padding-left:4rem;padding-right:4rem;font-size:1em;background-color:#fff;display:inline-block;position:relative}.quizAnalysisDisplay .feedbackArea .categoryDisplay{margin-bottom:5px}.quizAnalysisDisplay .feedbackArea .feedbackContent{padding:15px;padding-top:0}.quizAnalysisDisplay .feedbackArea .feedbackContent .carouselFooter{text-align:center;margin-top:15px}.quizAnalysisDisplay .feedbackArea .feedbackContent .carouselFooter .badge{margin-right:5px}.quizAnalysisDisplay .feedbackArea .feedbackContent .feedbackTitle{margin-bottom:10px}.quizAnalysisDisplay .feedbackArea .feedbackContent .feedbackTitle .titleContent{font-size:1.3em;margin-left:5px}.quizAnalysisDisplay .feedbackArea .feedbackContent .feedbackTitle .speechControlsContainer{display:inline-block;margin-left:15px}.quizAnalysisDisplay .feedbackArea .individualExamples .singleExample{font-size:1.2rem}.quizAnalysisDisplay .feedbackArea .leftArrow,.quizAnalysisDisplay .feedbackArea .rightArrow{margin-top:7rem}.quizAnalysisDisplay .categoryRow{margin-bottom:10px}.quizAnalysisDisplay .valid{color:#42af14}.quizAnalysisDisplay .error{color:#da3956}.quizAnalysisDisplay .validBackground{background-color:#42af14;padding-top:.6em}.quizAnalysisDisplay .errorBackground,.quizAnalysisDisplay .validBackground{font-size:.6em;border-radius:100%;height:2.2em;width:2.2em;padding-left:.4em}.quizAnalysisDisplay .errorBackground{background-color:#da3956;padding-top:.7em}.quizAnalysisDisplay .feedbackTable{width:100%}.quizAnalysisDisplay .feedbackTable .validCountCell{width:20%}.quizAnalysisDisplay .feedbackTable .descriptionCell{font-size:13px;width:80%}.quizAnalysisDisplay .feedbackTable .icon{height:15px;width:1.8rem;float:right}.quizAnalysisDisplay .feedbackTable .appearIn{width:100%;height:auto}.quizAnalysisDisplay .hiddenElement{display:none}.quizAnalysisDisplay .reactionFeedback{float:right;margin-top:15px;margin-right:15px}", ""]);
	
	// exports


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".quizDisplay{margin-bottom:30px}.quizDisplay .innerAnswer,.quizDisplay .innerAnswer .commentBox{margin-bottom:20px}.quizDisplay .answerIndex0 .controlBox{padding-top:10px}.quizDisplay .answerIndex0 .withUpperControl .controlBox{border-top:1px solid #ddd;border-top-left-radius:5px;padding-bottom:10px}.quizDisplay.controlModeEdit .controlBox{visibility:hidden}.quizDisplay.controlModeEdit .answerIndex0 .withUpperControl .controlBox{visibility:visible;border-bottom:1px solid #ddd;border-bottom-left-radius:5px;position:absolute;right:0;z-index:2}.quizDisplay .answerLastIndex .answerText{margin-bottom:0}.quizDisplay .answerLastIndex .withUpperControl .controlBox{border-bottom:1px solid #ddd;border-bottom-left-radius:5px}.quizDisplay .revisionButton{margin-right:10px}.quizDisplay .displayContainer{display:flex;flex-direction:row;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".quizPage .stepProgressMeter{margin-bottom:2rem}.quizPage .pageHeader{margin-bottom:10px}.quizPage .pageHeader h1{font-size:1.4em}.quizPage .textVariety .textTitle{margin-top:0;margin-bottom:20px}.quizPage .closedQuiz{opacity:.4;pointer-events:none}.quizPage .curtainContainer{display:flex;justify-content:center}.quizPage .curtainContainer .curtain{width:60%;text-align:center;padding:15px}.quizPage .curtainContainer .curtain .lockImg{width:55px;margin-bottom:10px}.quizPage .textTitle{font-size:2rem;font-style:italic;text-align:center;max-width:54%;margin-left:23%}.quizPage .textTitle.onQuestionSelect{margin-top:0;margin-bottom:10px}.quizPage .warmupContainer{width:76%;margin-left:12%}.quizPage .warmupContainer .warmupQuestionsDisplay .changeQuestionLink{display:inline-block;font-size:.8em;cursor:pointer;margin-bottom:10px;padding-left:0;box-shadow:none!important}.quizPage .warmupContainer .warmupQuestionsDisplay .changeQuestionLink .glyphicon-refresh{margin-left:5px}", ""]);
	
	// exports


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".quizReview .spacedButton{margin-left:15px}.quizReview .scoreText{margin-top:15px;margin-left:10px}.quizReview .firstButton{margin-left:10px}.quizReview .cancelButton{margin-top:10px}.quizReview .overrideControls{margin-top:15px;margin-left:15px;display:inline-block;overflow-x:auto;width:100%;white-space:nowrap;overflow:hidden}.quizReview .buttons{margin-top:10px}.quizReview .spinnerBox{margin:auto;width:60%;padding:10px}", ""]);
	
	// exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".warmupQuestionsDisplay .buttonDropdown .btn,.warmupQuestionsDisplay .inlineInput,.warmupQuestionsDisplay .multiSelect .Select-control{border:1px solid #ddd;border-radius:5px;box-shadow:none;height:3.8rem;color:#555}.warmupQuestionsDisplay .buttonDropdown,.warmupQuestionsDisplay .inlineInput,.warmupQuestionsDisplay .multiSelect{margin:1rem;display:inline-block}.warmupQuestionsDisplay .multiSelect{vertical-align:middle}.warmupQuestionsDisplay .multiSelect.noMaxOptions{width:60rem}.warmupQuestionsDisplay .multiSelect.threeOptions{width:40rem}.warmupQuestionsDisplay .multiSelect.twoOptions{width:30rem}.warmupQuestionsDisplay .multiSelect.oneOption{width:20rem}.warmupQuestionsDisplay .multiSelect .Select-value{color:#555;background-color:#fff;border:1px solid #ddd;border-radius:5px}.warmupQuestionsDisplay .inlineInput{padding:1rem}.warmupQuestionsDisplay .inlineInput.numberInput{width:8rem}.warmupQuestionsDisplay .inputGroup{display:inline-block}.warmupQuestionsDisplay .inputGroup .subtext{margin-left:2rem}.warmupQuestionsDisplay .topMargin{margin-top:2rem}.warmupQuestionsDisplay .finishButton{float:right;margin-top:1rem}.warmupQuestionsDisplay .displayOnly{display:inline-block;border:1px solid #ddd;border-radius:5px;padding:.5rem;margin:.5rem}", ""]);
	
	// exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".nameModal .modal-dialog{width:432px!important}.nameModal .modal-content{min-height:200px}.nameModal .signatureWrap{margin-right:125px}.nameModal .nameLine{width:400px}.nameModal .errorDisplay{width:250px}", ""]);
	
	// exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".newResponsePage .printOp{margin-left:15px}.newResponsePage .textTitle{font-size:2.1em;font-style:italic;text-align:center;max-width:80%;margin-left:10%;margin-top:10px;margin-bottom:20px}.newResponsePage .smallerHeader{font-size:1em}.newResponsePage .largerHeader{font-size:1.4em}.newResponsePage .studentCurrentAssignment .pageHeader h1{font-size:1.4em!important}", ""]);
	
	// exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".responseModal .responseWrap{position:relative}@media(min-width:1025px){.responseModal .activityBox{padding-left:80px}}.responseModal .evaluationBox{position:absolute;top:0;right:5px}.responseModal .evaluationTags{display:block;margin:0 80px}.responseModal .studentInfoContainer{margin-bottom:20px;margin-right:100px}@media(min-width:1025px){.responseModal .studentInfoContainer{margin-left:80px}}@media(min-width:1025px){.responseModal .commentBox{margin:0 80px}}@media(max-width:1024px){.responseModal .commentBox{margin-left:10px}}.responseModal .editResponse{float:right;cursor:pointer}@media(min-width:1025px){.responseModal .editResponse{margin-right:80px}}", ""]);
	
	// exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".responseTile{overflow:hidden}.responseTile .activityTitle,.responseTile .responseBody{padding:10px}.responseTile .responseInfo .responseHeader{position:relative}.responseTile .responseInfo .activityTitle{background-color:#e4e4e4;margin-bottom:0;border-bottom:1px solid #ddd}.responseTile .responseInfo .activityTitle.narrow{padding-right:20px;padding-left:20px}.responseTile .responseInfo .bookTitle{margin-bottom:5px}.responseTile .responseInfo .removeButton{position:absolute;right:4px;top:4px;padding:0;font-size:15px;outline:none;color:#999}.responseTile .responseInfo .removeButton:hover{color:#555}.responseTile .date{display:block;position:relative;color:#999}", ""]);
	
	// exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".shareResponse{position:absolute;left:15px;top:18px;z-index:1}.shareResponse img{width:40px;height:auto;display:block;margin-bottom:6px}.shareResponse .spinnerBox.placeholder{padding:20px}.shareResponse .loadingText{display:block;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".studentInfoContainer .responseUserLine .owlConstraints{display:inline-block;vertical-align:middle}.studentInfoContainer .editedInfo{color:orange}", ""]);
	
	// exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".teacherViewResponseModal{min-height:200px}.teacherViewResponseModal .studentInfoContainer{margin-bottom:20px}@media(min-width:1025px){.teacherViewResponseModal .studentInfoContainer{margin-left:80px}}@media(min-width:1025px){.teacherViewResponseModal .activityBox{padding-left:80px}}@media(min-width:1025px){.teacherViewResponseModal .commentBox{margin:0 80px}}@media(max-width:1024px){.teacherViewResponseModal .commentBox{margin-left:10px}}", ""]);
	
	// exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".assignTaskModal{text-align:left}.assignTaskModal .greenIcon .completedIcon{color:green}.assignTaskModal .grayIcon .completedIcon{color:gray}.assignTaskModal .studentStat{font-weight:600;font-size:small}.assignTaskModal .studentTaskStats{margin-top:15px;padding:10px;box-shadow:0 5px 15px rgba(0,0,0,.35);margin-bottom:15px}.assignTaskModal .greenText{color:green}.assignTaskModal .redText{color:red}.assignTaskModal .orgDropdown{display:inline-block}.assignTaskModal .controls .buttonSuccess{display:inline-block;margin-left:17%;margin-bottom:10px}.assignTaskModal .studentOptions{column-count:2;padding-left:12px;padding-right:12px;margin-bottom:15px;margin-top:5px}.assignTaskModal .studentOptions label{display:block;cursor:pointer}.assignTaskModal .studentOptions .studentDisplayWrap{display:inline-block;margin-top:5px;cursor:pointer;height:60px;width:100%;padding:5px}.assignTaskModal .studentOptions .studentDisplayWrap.selectedStudent{background:#c8ecff}.assignTaskModal .studentOptions .studentDisplayWrap.selectedStudent:hover,.assignTaskModal .studentOptions .studentDisplayWrap:hover{background:#96dafe}.assignTaskModal .studentOptions .studentDisplayWrap .studentName{width:130px;display:inline-block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;position:relative;top:10px}.assignTaskModal .studentOptions .studentDisplayWrap .studentDisplay .textContent{margin-top:10px;margin-left:10px}.assignTaskModal .modal-title i{margin-right:2px}", ""]);
	
	// exports


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	module.exports = [{"module":"quick-start","level":"beginner","type":"video","key":"why-wr","order":0,"title":"Why Whooo's Reading?","description":"Teachers are searching for something more and Whooo's Reading delivers. Watch and learn how Whooo's Reading will make your life easier and students better readers and writers.","videoID":"M6XyjbrVc7Q","link":"https://www.youtube.com/watch?v=M6XyjbrVc7Q"},{"module":"quick-start","level":"beginner","type":"video","key":"log-reading","order":1,"title":"Log Reading","description":"How students keep track of the number of minutes they have read.","videoID":"6C_RdHsrV5E","link":"https://www.youtube.com/watch?v=6C_RdHsrV5E"},{"module":"quick-start","level":"beginner","type":"video","key":"quizzes","order":2,"title":"Take a Quiz","description":"Owlfonso helps you do the best you can on a quiz.","videoID":"e2iRyxkeNL8","link":"https://www.youtube.com/watch?v=e2iRyxkeNL8"},{"module":"quick-start","level":"beginner","type":"video","key":"dashboard","order":3,"title":"Use the Teacher Dashboard","description":"Change goals, monitor progress and print student data all from your dashboard.","videoID":"N6zeedPyG_k","link":"https://www.youtube.com/watch?v=N6zeedPyG_k"},{"module":"quick-start","level":"beginner","type":"video","key":"view-data","order":4,"title":"View Student Data","description":"The data section allows you to retrieve and print your students' reading and writing activity for a specific time period.","videoID":"ce-hirv9a5g","link":"https://www.youtube.com/watch?v=ce-hirv9a5g"},{"module":"account-setup","level":"beginner","type":"video","key":"why-wr","order":0,"title":"Why Whooo's Reading?","description":"Teachers are searching for something more and Whooo's Reading delivers. Watch and learn how Whooo's Reading will make your life easier and students better readers and writers.","videoID":"M6XyjbrVc7Q","link":"https://www.youtube.com/watch?v=M6XyjbrVc7Q"},{"module":"account-setup","level":"beginner","type":"video","key":"add-students","order":1,"title":"Add Students","description":"Upload your students manually, use a CSV roster, or sync with Google Classroom.","videoID":"3atB_AAzVZg","link":"https://www.youtube.com/watch?v=3atB_AAzVZg"},{"module":"account-setup","level":"beginner","type":"action","key":"add-students","order":null,"title":"Added Students","description":"Go to your Roster page, click Add Students, and then follow the steps (for the uploading method you select).","videoID":null,"link":null},{"module":"account-setup","level":"beginner","type":"video","key":"login-info","order":2,"title":"Find Student Usernames and Passwords","description":"Easily locate your students' usernames and passwords.","videoID":"7wMrz-3q4Cg","link":"https://www.youtube.com/watch?v=7wMrz-3q4Cg"},{"module":"account-setup","level":"beginner","type":"video","key":"gc-sync","order":3,"title":"Sync With Google Classroom","description":"Sync your Whooo's Reading and Google Classroom accounts to allow students to log in to Whooo's Reading with Google Classroom.","videoID":"b3Aj8v_Md_k","link":"https://www.youtube.com/watch?v=b3Aj8v_Md_k"},{"module":"account-setup","level":"intermediate","type":"video","key":"set-goals","order":4,"title":"Set Goals for Students","description":"Set timely student goals for multiple reading and writing categories.","videoID":"mGQzVWam2Og","link":"https://www.youtube.com/watch?v=mGQzVWam2Og"},{"module":"account-setup","level":"intermediate","type":"action","key":"set-goals","order":null,"title":"Set Goals","description":"Click on your name in the upper right -> Class Settings -> Goals, to set goals for your students.","videoID":null,"link":null},{"module":"account-setup","level":"intermediate","type":"video","key":"voice-controls","order":5,"title":"Set Voice Controls","description":"Do younger students need help with their typing? Voice controls reads the question and allows students to dictate their answers.","videoID":"3ZoW5XsjSbc","link":"https://www.youtube.com/watch?v=3ZoW5XsjSbc"},{"module":"account-setup","level":"advanced","type":"video","key":"edit-account","order":6,"title":"Edit Account Information","description":"How to update or change your name, username, and password.","videoID":"aTIBRdeQd6c","link":"https://www.youtube.com/watch?v=aTIBRdeQd6c"},{"module":"account-setup","level":"advanced","type":"video","key":"standards","order":7,"title":"Set Standards for Quiz Questions","description":"Customize quizzes by choosing from 14 different skillset categories based on state standards.","videoID":"VMCwytGGsn4","link":"https://www.youtube.com/watch?v=VMCwytGGsn4"},{"module":"student-account","level":"beginner","type":"video","key":"login-card","order":0,"title":"Log In Using Login Cards","description":"How students enter their usernames and passwords.","videoID":"bAgeCoF5vEo","link":"https://www.youtube.com/watch?v=bAgeCoF5vEo"},{"module":"student-account","level":"beginner","type":"action","key":"login-card","order":null,"title":"Student Logged In","description":"Log out of your account and then use the username and password of one of your students to log in (as a student).","videoID":null,"link":null},{"module":"student-account","level":"beginner","type":"video","key":"class-code","order":1,"title":"Log In Using Class Codes","description":"How students create accounts using a class code.","videoID":"R_4TaY2AGHY","link":"https://www.youtube.com/watch?v=R_4TaY2AGHY"},{"module":"student-account","level":"beginner","type":"video","key":"gc-login","order":2,"title":"Log In Using Google Classroom","description":"How students use Google Classroom to log in to Whooo's Reading.","videoID":"wNRLrdbBBx4","link":"https://www.youtube.com/watch?v=wNRLrdbBBx4"},{"module":"student-account","level":"intermediate","type":"video","key":"log-reading","order":3,"title":"Log Reading","description":"How students keep track of the number of minutes they have read.","videoID":"6C_RdHsrV5E","link":"https://www.youtube.com/watch?v=6C_RdHsrV5E"},{"module":"student-account","level":"intermediate","type":"action","key":"log-reading","order":null,"title":"Student Logged Reading","description":"As a student, search for a text and then click Log Reading to enter reading minutes and date for that text.","videoID":null,"link":null},{"module":"student-account","level":"intermediate","type":"video","key":"add-text","order":4,"title":"Add a Book or Magazine Article","description":"Are students reading a book that's unlisted or a magazine article? Learn how students add new books and articles.","videoID":"N7nZ72K2GJg","link":"https://www.youtube.com/watch?v=N7nZ72K2GJg"},{"module":"student-account","level":"intermediate","type":"video","key":"answers","order":5,"title":"Answer Practice Questions","description":"How students answer practice questions to help prepare for quizzes.","videoID":"hetyaNoCgfs","link":"https://www.youtube.com/watch?v=hetyaNoCgfs"},{"module":"student-account","level":"intermediate","type":"action","key":"answers","order":null,"title":"Student Answered Question","description":"As a student, search for a text and then click Answer Question to answer a practice question for that text.","videoID":null,"link":null},{"module":"student-account","level":"intermediate","type":"video","key":"quizzes","order":6,"title":"Take a Quiz","description":"Owlfonso helps you do the best you can on a quiz.","videoID":"e2iRyxkeNL8","link":"https://www.youtube.com/watch?v=e2iRyxkeNL8"},{"module":"student-account","level":"intermediate","type":"action","key":"quizzes","order":null,"title":"Student Took Quiz","description":"As a student, search for a text and then click Take a Quiz to take the reading comprehension quiz for that text.","videoID":null,"link":null},{"module":"student-account","level":"intermediate","type":"video","key":"reviews","order":7,"title":"Write Book Reviews","description":"How students rate books and write reviews for their classmates.","videoID":"G8I_pmOHIJg","link":"https://www.youtube.com/watch?v=G8I_pmOHIJg"},{"module":"student-account","level":"advanced","type":"video","key":"exercises","order":8,"title":"Complete Exercises","description":"How students do exercises to reinforce the skillsets they are assigned.","videoID":"gaYcdJm046Q","link":"https://www.youtube.com/watch?v=gaYcdJm046Q"},{"module":"student-account","level":"advanced","type":"video","key":"class-shelf","order":9,"title":"Access the Class Shelf","description":"How students see what books their classmates are reading and book reviews.","videoID":"rzqPOcQIkpU","link":"https://www.youtube.com/watch?v=rzqPOcQIkpU"},{"module":"student-account","level":"advanced","type":"video","key":"my-shelf","order":10,"title":"Access My Shelf","description":"How students view all of their work and access unfinished work.","videoID":"LYUYA_B_GsI","link":"https://www.youtube.com/watch?v=LYUYA_B_GsI"},{"module":"teacher-account","level":"beginner","type":"video","key":"dashboard","order":0,"title":"Use the Teacher Dashboard","description":"Change goals, monitor progress and print student data all from your dashboard.","videoID":"N6zeedPyG_k","link":"https://www.youtube.com/watch?v=N6zeedPyG_k"},{"module":"teacher-account","level":"beginner","type":"action","key":"dashboard","order":null,"title":"Used Dashboard","description":"Click on the Whooo's Reading logo to return to your dashboard, and then use the blue selectors to customize the data displayed.","videoID":null,"link":null},{"module":"teacher-account","level":"intermediate","type":"video","key":"view-data","order":1,"title":"View Student Data","description":"The data section allows you to retrieve and print your students' reading and writing activity for a specific time period.","videoID":"ce-hirv9a5g","link":"https://www.youtube.com/watch?v=ce-hirv9a5g"},{"module":"teacher-account","level":"intermediate","type":"video","key":"view-quizzes","order":2,"title":"View Quizzes","description":"Review your students' quizzes to see how they are performing on Whooo's Reading.","videoID":"-PVTqaad6lE","link":"https://www.youtube.com/watch?v=-PVTqaad6lE"},{"module":"teacher-account","level":"intermediate","type":"action","key":"view-quizzes","order":null,"title":"Viewed Student Quiz","description":"Click on Data, and then use the blue selectors to view the quizzes your students have taken.","videoID":null,"link":null},{"module":"teacher-account","level":"intermediate","type":"video","key":"differentiate","order":3,"title":"Differentiate for Students","description":"Changing the academic level will adjust the program's degree of difficulty.","videoID":"9YAfvFx_frQ","link":"https://www.youtube.com/watch?v=9YAfvFx_frQ"},{"module":"teacher-account","level":"intermediate","type":"video","key":"mc-vs-open","order":4,"title":"Shifting from Multiple Choice is Important","description":"Open-ended questions offer more advantages than multiple choice questions.","videoID":"TYBaw9nKKxw","link":"https://www.youtube.com/watch?v=TYBaw9nKKxw"},{"module":"teacher-account","level":"intermediate","type":"video","key":"pass-quizzes","order":5,"title":"Help Students Pass Quizzes","description":"The tools and scaffolding that are available to help students succeed.","videoID":"HSgH9b4nWfY","link":"https://www.youtube.com/watch?v=HSgH9b4nWfY"},{"module":"teacher-account","level":"advanced","type":"video","key":"insights","order":6,"title":"Use Insights","description":"Identify your students' strengths and weaknesses and assign exercises to help close the learning gaps.","videoID":"9w0j3_J6rJU","link":"https://www.youtube.com/watch?v=9w0j3_J6rJU"},{"module":"teacher-account","level":"advanced","type":"video","key":"assign-exercises","order":7,"title":"Assign Exercises","description":"Graphic organizers are fun and effective in reinforcing class lessons.","videoID":"4EeV2i4Azjk","link":"https://www.youtube.com/watch?v=4EeV2i4Azjk"},{"module":"teacher-account","level":"advanced","type":"video","key":"write-questions","order":8,"title":"Write Practice Questions","description":"Enter your own questions that you want your students to answer. Apply to any book or a specific book you are reading in class.","videoID":"lgCa4v-KKeM","link":"https://www.youtube.com/watch?v=lgCa4v-KKeM"},{"module":"teacher-account","level":"advanced","type":"video","key":"rlds","order":9,"title":"Use Reading Level Diagnostics","description":"Diagnose your students' reading levels.","videoID":"5PFp0_5Brfw","link":"https://www.youtube.com/watch?v=5PFp0_5Brfw"}]

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = [{"speaker":"owlfonso","type":"static","stage":0,"text":"Hi {{STUDENT_NAME}}, I'm Owlfonso! I'll be helping you on Whooo's Reading. Are you ready to get started?","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"student","type":"options","stage":1,"text":"Let's go!;I'm listening...","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":2,"text":"Each {{ASSIGNMENT_TIME_PERIOD}}, your teacher wants you to to try and accomplish the goals they have set.","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":3,"text":"Use these buttons at the top of your profile to get to work. Do you think you can do that?","imgPath":"profile-action-buttons","initialOnly":true},{"speaker":"student","type":"options","stage":4,"text":"Yes!;Maybe...","imgPath":"profile-action-buttons","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":5,"text":"Don't worry, I'll be popping in to help you as you write, like this!","imgPath":null,"initialOnly":true},{"speaker":"student","type":"options","stage":6,"text":"Thank you!;What do you know?","imgPath":"feedback-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":7,"text":"Here is a question you might answer on Whooo's Reading. While you type your answer, I look for 3 things in your writing.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":8,"text":"What do you look for?;How do I do well?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":9,"text":"First, I try to read what you wrote. If you write well and remember the rules of writing, it's easier for me to read.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":10,"text":"I will do my best!;What else?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":11,"text":"Next, I check if you stayed on topic and answered all parts of the question.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":12,"text":"I will focus!;Then what?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":13,"text":"Last, I look to see if you talked about parts of your text to show that you understood what you read.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":14,"text":"I will show you my skills!;I think I can do that.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":15,"text":"Which of these answers do you think would get the best score?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":16,"text":"Example 1;Example 2;Example 3","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"options","stage":17,"text":"Example 1::Nope, not that one. Take another look and try again!::-1;Example 2::Yes! Example 2 is written well, it answers the question, and it talks about things that happened in the book.::1;Example 3::Nope, not that one. Take another look and try again!::-1","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":18,"text":"I can do that!;Okay, I'll try.","imgPath":"annotated-example-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":19,"text":"Great! Now, this is your Owlvatar. Everyone gets one, and you get to choose what yours looks like.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":20,"text":"Choose a hat you want to wear. You can change more later in the Owl Shop.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"student","type":"options","stage":21,"text":"Done!","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":22,"text":"Wow, you look great!","imgPath":"student-avatar-hats","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":23,"text":"Okay, that's it for now. See you when you start writing!","imgPath":"student-avatar-rays","initialOnly":false},{"speaker":"student","type":"options","stage":24,"text":"See you later!;Okay, bye!","imgPath":"student-avatar-rays","initialOnly":false}]

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	module.exports = [{"speaker":"owlfonso","type":"static","stage":0,"text":"Hi {{STUDENT_NAME}}, I'm Owlfonso! I'll be helping you on Whooo's Reading. Are you ready to get started?","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"student","type":"options","stage":1,"text":"Let's go!;I'm listening...","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":2,"text":"While you are reading anything you want, you can answer practice questions about that text.","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":3,"text":"Here is an example on the left. Cool?","imgPath":"practice-question-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":4,"text":"Cool.;Got it.","imgPath":"practice-question-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":5,"text":"After you finish what you are reading, you can take a quiz, but it's not just any quiz!","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":6,"text":"Here is what a quiz looks like. Do you think you could do one?","imgPath":"quiz-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":7,"text":"Yes!;Maybe...","imgPath":"quiz-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":8,"text":"Don't worry, I'll be popping in to help you as you write, like this!","imgPath":null,"initialOnly":true},{"speaker":"student","type":"options","stage":9,"text":"Thank you!;What do you know?","imgPath":"feedback-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":10,"text":"Here is a question you might answer on Whooo's Reading. While you type your answer, I look for 3 things in your writing.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":11,"text":"What do you look for?;How do I do well?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":12,"text":"First, I try to read what you wrote. If you write well and remember the rules of writing, it's easier for me to read.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":13,"text":"I will do my best!;What else?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":14,"text":"Next, I check if you stayed on topic and answered all parts of the question.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":15,"text":"I will focus!;Then what?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":16,"text":"Last, I look to see if you talked about parts of your text to show that you understood what you read.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":17,"text":"I will show you my skills!;I think I can do that.","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":18,"text":"Which of these answers do you think would get the best score?","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":19,"text":"Example 1;Example 2;Example 3","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"options","stage":20,"text":"Example 1::Nope, not that one. Take another look and try again!::-1;Example 2::Yes! Example 2 is written well, it answers the question, and it talks about things that happened in the book.::1;Example 3::Nope, not that one. Take another look and try again!::-1","imgPath":"examples-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":21,"text":"I can do that!;Okay, I'll try.","imgPath":"annotated-example-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":22,"text":"Great! Now, this is your Owlvatar. Everyone gets one, and you get to choose what yours looks like.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":23,"text":"Choose a hat you want to wear. You can change more later in the Owl Shop.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"student","type":"options","stage":24,"text":"Done!","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":25,"text":"Wow, you look great!","imgPath":"student-avatar-hats","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":26,"text":"Okay, that's it for now. See you when you start writing!","imgPath":"student-avatar-rays","initialOnly":false},{"speaker":"student","type":"options","stage":27,"text":"See you later!;Okay, bye!","imgPath":"student-avatar-rays","initialOnly":false}]

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports = [{"speaker":"owlfonso","type":"static","stage":0,"text":"Hi {{STUDENT_NAME}}! Before you write, I have some tips.","imgPath":"owlfonso-waving","initialOnly":false},{"speaker":"student","type":"options","stage":1,"text":"Thank you!;What tips?","imgPath":"owlfonso-waving","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":2,"text":"Here is a question you might answer on Whooo's Reading. While you type your answer, I look for 3 things in your writing.","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":3,"text":"What do you look for?;How do I do well?","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":4,"text":"First, I try to read what you wrote. If you write well and remember the rules of writing, it's easier for me to read.","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":5,"text":"I will do my best!;What else?","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":6,"text":"Next, I check if you stayed on topic and answered all parts of the question.","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":7,"text":"I will focus!;Then what?","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":8,"text":"Last, I look to see if you talked about parts of your text to show that you understood what you read.","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":9,"text":"I will show you my skills!;I think I can do that.","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":10,"text":"Which of these answers do you think would get the best score?","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":11,"text":"Example 1;Example 2;Example 3","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"owlfonso","type":"options","stage":12,"text":"Example 1::Nope, not that one. Take another look and try again!::-1;Example 2::Yes! Example 2 is written well, it answers the question, and it talks about things that happened in the book.::1;Example 3::Nope, not that one. Take another look and try again!::-1","imgPath":"examples-{{LEVEL}}","initialOnly":false},{"speaker":"student","type":"options","stage":13,"text":"I can do that!;Okay, I'll try.","imgPath":"annotated-example-{{LEVEL}}","initialOnly":false}]

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	module.exports = [{"speaker":"owlfonso","type":"static","stage":0,"text":"Hi {{STUDENT_NAME}}, I'm Owlfonso! I'll be helping you on Whooo's Reading. Are you ready to get started?","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"student","type":"options","stage":1,"text":"Let's go!;I'm listening...","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":2,"text":"Each {{ASSIGNMENT_TIME_PERIOD}}, your teacher wants you to try and accomplish the goals on the left.","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":3,"text":"Use these buttons at the top of your profile to get to work. Do you think you can do that?","imgPath":"profile-action-buttons","initialOnly":true},{"speaker":"student","type":"options","stage":4,"text":"Yes!;Maybe...","imgPath":"profile-action-buttons","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":5,"text":"Don't worry, I'll be popping in to help you as you write, like this!","imgPath":null,"initialOnly":true},{"speaker":"student","type":"options","stage":6,"text":"Thank you!;Sounds good.","imgPath":"feedback-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":7,"text":"Great! Now, this is your Owlvatar. Everyone gets one, and you get to choose what yours looks like.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":8,"text":"Choose a hat you want to wear. You can change more later in the Owl Shop.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"student","type":"options","stage":9,"text":"Done!","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":10,"text":"Wow, you look great!","imgPath":"student-avatar-hats","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":11,"text":"Okay, that's it for now. See you when you start writing!","imgPath":"student-avatar-rays","initialOnly":false},{"speaker":"student","type":"options","stage":12,"text":"See you later!;Okay, bye!","imgPath":"student-avatar-rays","initialOnly":false}]

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	module.exports = [{"speaker":"owlfonso","type":"static","stage":0,"text":"Hi {{STUDENT_NAME}}, I'm Owlfonso! I'll be helping you on Whooo's Reading. Are you ready to get started?","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"student","type":"options","stage":1,"text":"Let's go!;I'm listening...","imgPath":"owlfonso-waving","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":2,"text":"While you are reading anything you want, you can answer practice questions about that text.","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":3,"text":"Here is an example on the left. Cool?","imgPath":"practice-question-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":4,"text":"Cool.;Got it.","imgPath":"practice-question-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":5,"text":"After you finish what you are reading, you can take a quiz, but it's not just any quiz!","imgPath":null,"initialOnly":true},{"speaker":"owlfonso","type":"static","stage":6,"text":"Here is what a quiz looks like. Do you think you could do one?","imgPath":"quiz-{{LEVEL}}","initialOnly":true},{"speaker":"student","type":"options","stage":7,"text":"Yes!;Maybe...","imgPath":"quiz-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":8,"text":"Don't worry, I'll be popping in to help you as you write, like this!","imgPath":null,"initialOnly":true},{"speaker":"student","type":"options","stage":9,"text":"Thank you!;Sounds good.","imgPath":"feedback-{{LEVEL}}","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":10,"text":"Great! Now, this is your Owlvatar. Everyone gets one, and you get to choose what yours looks like.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":11,"text":"Choose a hat you want to wear. You can change more later in the Owl Shop.","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"student","type":"options","stage":12,"text":"Done!","imgPath":"student-avatar-hats","initialOnly":true},{"speaker":"owlfonso","type":"static","stage":13,"text":"Wow, you look great!","imgPath":"student-avatar-hats","initialOnly":false},{"speaker":"owlfonso","type":"static","stage":14,"text":"Okay, that's it for now. See you when you start writing!","imgPath":"student-avatar-rays","initialOnly":false},{"speaker":"student","type":"options","stage":15,"text":"See you later!;Okay, bye!","imgPath":"student-avatar-rays","initialOnly":false}]

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	module.exports = [{"NF_SUBJECT_OPTIONS":"animals,arts,business,careers,culture,current events,economics,famous people,fashion,food,games,geography,government,health,history,math,mythology,philosophy,religion,school,science,sports,technology","RELATION_OPTIONS":"enemy,father/mother,friend,idol/role model,other,sister/brother,son/daughter,student,teacher","TRAIT_OPTIONS":"active,adventurous,affectionate,afraid,alert,ambitious,angry,annoying,anxious,apologetic,arrogant,attentive,attractive,average,bad,blue,bold,bored,bossy,brainy,brave,bright,brilliant,busy,calm,careful,careless,cautious,charming,cheerful,childish,clever,clumsy,coarse,competent,concerned,confident,confused,considerate,cooperative,courageous,cowardly,cross,cruel,curious,dangerous,daring,dark,decisive,demanding,dependable,depressed,determined,discouraged,dishonest,disrespectful,doubtful,dull,dutiful,eager,easygoing,efficient,embarrassed,encouraging,energetic,evil,excited,expert,fair,faithful,fearless,fierce,foolish,fortunate,foul,fresh,friendly,frustrated,funny,gentle,giving,glamorous,gloomy,good,graceful,grateful,greedy,grouchy,grumpy,guilty,happy,hard-working,harsh,hateful,healthy,helpful,honest,hopeful,hopeless,humorous,ignorant,imaginative,impatient,impolite,inconsiderate,independent,industrious,innocent,intelligent,jealous,kind,lazy,leader,lively,lonely,loving,loyal,lucky,mature,mean,messy,miserable,mysterious,naughty,nervous,nice,noisy,obedient,obnoxious,old,peaceful,picky,pleasant,polite,poor,popular,positive,precise,proper,proud,quick,quiet,rational,reliable,religious,responsible,restless,rich,rough,rowdy,rude,sad,safe,satisfied,scared,secretive,selfish,selfless,serious,sharp,short,shy,silly,skillful,sly,smart,sneaky,sorry,spoiled,stingy,strange,strict,stubborn,sweet,talented,tall,thankful,thoughtful,thoughtless,tired,tolerant,touchy,trusting,trustworthy,unfriendly,unhappy,upset,useful,warm,weak,wicked,wise,worried,wrong,young","GOAL_OPTIONS":"be a successful person,be accepted by others,be better at something than someone else,be the best at something,create something,defeat an enemy,earn money,fall in love,finish something,gain power,have fun,help a friend,learn something,make a discovery,make a friend,protect someone or something,rescue someone or something,solve a mystery,stop an enemy from doing something,survive,travel somewhere,win something","DESCRIPTOR_OPTIONS":"amazing,beautiful,breezy,bright,calm,creepy,dangerous,dark,elegant,empty,fantastic,fresh,frightening,ghostly,gigantic,grand,great,hollow,huge,hulking,incredible,leafy,little,lovely,lush,magnificent,massive,messy,minute,moist,nasty,noisy,perfect,picturesque,quiet,scary,small,soft,spooky,sunny,sweet,tall,tangled,terrifying,weird,wet,wild,windy","EMOTION_OPTIONS":"amused,angry,annoyed,apathetic,bad,blissful,calm,cheerful,content,cranky,depressed,dreamy,ecstatic,energetic,envious,excited,frustrated,giddy,gloomy,good,grumpy,guilty,happy,indifferent,irritated,joyful,loving,melancholy,mellow,optimistic,peaceful,pessimistic,rejected,restless,sad,silly,stressed,sympathetic,weird","TEXT_FEATURE_OPTIONS":"bold/italic print,caption,chart/graph,diagram,glossary,heading,illustration,index,sidebar,table of contents,timeline"}]

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	module.exports = [{"people_people":"is the enemy of, is the father/mother of, is the friend of, is the idol/role model of, is the sister/brother of, is the son/daughter of, is the student of, is the teacher of, is a(n)","animals/plants/objects_people":"eats, is eaten by, lives with, lives in, is the home of, is part of, is on, is under, is near, contains, is within, is the source of, comes from, uses, finds, needs","events_people":"causes, prevents, is part of, changes, influences, reacts to, helps with, is affected by","ideas_people":"creates, causes, discovers, persuades, changes, opposes, supports, argues for, studies, believes, is part of","animals/plants/objects_animals/plants/objects":"eats, is eaten by, lives with, lives in, is the home of, is part of, is on, is under, is near, contains, is within, is the source of, comes from, uses, finds, needs","animals/plants/objects_events":"causes, prevents, is part of, changes, influences, reacts to, helps with, is affected by","animals/plants/objects_ideas":"is used for, is used by, needs, is part of, shows, is affected by, is about, is evidence of, is evidence against","events_events":"causes, prevents, happens because of, happens before, happens after, happens at the same time as, is part of, starts with, ends with","events_ideas":"causes, changes, influences, begins, completes, is evidence of, is evidence against, is part of","ideas_ideas":"is the same as, is the opposite of, is a part of, is a type of, is evidence of, is evidence against, happens before, happens after, happens at the same time as, is used for"}]

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	module.exports = [{"key":"topic.booktype.label1.level1","text":"I read a(n)"},{"key":"topic.booktype.label1.level2","text":"This"},{"key":"topic.booktype.label1.level3","text":"This"},{"key":"topic.booktype.choices1.level1","text":"picture book, chapter book, article, short story, other book"},{"key":"topic.booktype.choices1.level2","text":"picture book, chapter book, article, graphic novel, short story, other text"},{"key":"topic.booktype.choices1.level3","text":"picture book, chapter book, article, graphic novel, short story, other text"},{"key":"topic.booktype.label2.level1","text":"about"},{"key":"topic.booktype.label2.level2","text":"is"},{"key":"topic.booktype.label2.level3","text":"is"},{"key":"topic.booktype.choices2.level1","text":"imaginary things (fiction), real things (non-fiction), neither"},{"key":"topic.booktype.choices2.level2","text":"fiction (imaginary), non-fiction (real), other"},{"key":"topic.booktype.choices2.level3","text":"fiction, non-fiction, other"},{"key":"topic.fgenre.label1.level1","text":"My {{TEXT_TYPE}} happened in"},{"key":"topic.fgenre.label1.level2","text":"This {{TEXT_TYPE}} is in"},{"key":"topic.fgenre.label1.level3","text":"The genre of this {{TEXT_TYPE}} is"},{"key":"topic.fgenre.choices1.level1","text":"a different world, a different time, my world and my time"},{"key":"topic.fgenre.choices1.level2","text":"a different world (fantasy or science fiction), a different time (historical fiction), my world and my time (realistic fiction)"},{"key":"topic.fgenre.choices1.level3","text":"fantasy, science fiction, historical fiction, mystery, adventure, comedy, romance, horror, realistic fiction"},{"key":"topic.nfgenre.label1.level1","text":"My {{TEXT_TYPE}} mainly has"},{"key":"topic.nfgenre.label1.level2","text":"This {{TEXT_TYPE}} mainly has"},{"key":"topic.nfgenre.label1.level3","text":"The genre of this {{TEXT_TYPE}} is"},{"key":"topic.nfgenre.choices1.level1","text":"people, animals/plants/objects, events (things that happened), ideas"},{"key":"topic.nfgenre.choices1.level2","text":"people, animals/plants/objects, events, ideas"},{"key":"topic.nfgenre.choices1.level3","text":"informational text, persuasive text, autobiography, biography"},{"key":"topic.nfgenre.label2.level1","text":"My {{TEXT_TYPE}} is about"},{"key":"topic.nfgenre.label2.level2","text":"The main topics are"},{"key":"topic.nfgenre.label2.level3","text":"This {{TEXT_TYPE}} mainly has"},{"key":"topic.nfgenre.choices2.level1","text":"{{NF_SUBJECT_OPTIONS}}"},{"key":"topic.nfgenre.choices2.level2","text":"{{NF_SUBJECT_OPTIONS}}"},{"key":"topic.nfgenre.choices2.level3","text":"people, animals/plants/objects, events, ideas"},{"key":"topic.nfgenre.label3.level3","text":"The main topics are"},{"key":"topic.nfgenre.choices3.level3","text":"{{NF_SUBJECT_OPTIONS}}"},{"key":"topic.othergenre.label1.level1","text":"My {{TEXT_TYPE}} is"},{"key":"topic.othergenre.label1.level2","text":"This {{TEXT_TYPE}} is"},{"key":"topic.othergenre.label1.level3","text":"The genre of this {{TEXT_TYPE}} is"},{"key":"topic.othergenre.choices1.level1","text":"a fable or myth, a poem, something else"},{"key":"topic.othergenre.choices1.level2","text":"a fable or myth (folklore), a play (drama), a poem (poetry), something else"},{"key":"topic.othergenre.choices1.level3","text":"folklore, drama, poetry, other"},{"key":"fchar.numchars.label1.level1","text":"There are"},{"key":"fchar.numchars.label1.level2","text":"There are"},{"key":"fchar.numchars.label1.level3","text":"There are"},{"key":"fchar.numchars.choices1.level1","text":"0, 1, 2 or more"},{"key":"fchar.numchars.choices1.level2","text":"0, 1, 2 or more"},{"key":"fchar.numchars.choices1.level3","text":"0, 1, 2 or more"},{"key":"fchar.numchars.label2.level1","text":"main characters in this {{TEXT_TYPE}}"},{"key":"fchar.numchars.label2.level2","text":"main characters in this {{TEXT_TYPE}}"},{"key":"fchar.numchars.label2.level3","text":"main characters in this {{TEXT_TYPE}}"},{"key":"fchar.char1name.label1.level1","text":"One main character's name:"},{"key":"fchar.char1name.label1.level2","text":"Main character's name:"},{"key":"fchar.char1name.label1.level3","text":"Protagonist's (main character's) name:"},{"key":"fchar.char1trait.label1.level1","text":"One trait of {{CHAR1_NAME}} (word that describes {{CHAR1_NAME}}):"},{"key":"fchar.char1trait.label1.level2","text":"One trait of {{CHAR1_NAME}}:"},{"key":"fchar.char1trait.label1.level3","text":"One trait of {{CHAR1_NAME}}:"},{"key":"fchar.char1trait.choices1.level1","text":"{{TRAIT_OPTIONS}}"},{"key":"fchar.char1trait.choices1.level2","text":"{{TRAIT_OPTIONS}}"},{"key":"fchar.char1trait.choices1.level3","text":"{{TRAIT_OPTIONS}}"},{"key":"fchar.char1goal.label1.level3","text":"{{CHAR1_NAME}}'s main goal:"},{"key":"fchar.char1goal.choices1.level3","text":"{{GOAL_OPTIONS}}"},{"key":"fchar.char2name.label1.level2","text":"Second main character's name:"},{"key":"fchar.char2name.label1.level3","text":"Second main character's name:"},{"key":"fchar.char2rel.label1.level2","text":"Relationship to {{CHAR1_NAME}}:"},{"key":"fchar.char2rel.label1.level3","text":"Relationship to {{CHAR1_NAME}}:"},{"key":"fchar.char2rel.choices1.level2","text":"{{RELATION_OPTIONS}}"},{"key":"fchar.char2rel.choices1.level3","text":"{{RELATION_OPTIONS}}"},{"key":"fchar.char2trait.label1.level2","text":"One trait of {{CHAR2_NAME}}:"},{"key":"fchar.char2trait.label1.level3","text":"One trait of {{CHAR2_NAME}}:"},{"key":"fchar.char2trait.choices1.level2","text":"{{TRAIT_OPTIONS}}"},{"key":"fchar.char2trait.choices1.level3","text":"{{TRAIT_OPTIONS}}"},{"key":"fmain.mainidea1.label1.level1","text":"The lesson of this {{TEXT_TYPE}} in a few words:"},{"key":"fmain.mainidea1.label1.level2","text":"The main message (theme) of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"fmain.mainidea1.label1.level3","text":"The central idea or theme of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"fmain.mainidea2.label1.level3","text":"Another central idea or theme of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"fplot.event1.label1.level1","text":"A major event at the beginning of this {{TEXT_TYPE}}:"},{"key":"fplot.event1.label1.level2","text":"One major event in this {{TEXT_TYPE}}:"},{"key":"fplot.event1.label1.level3","text":"One major event in this {{TEXT_TYPE}}:"},{"key":"fplot.event1.label2.level1","text":"(character)"},{"key":"fplot.event1.label2.level2","text":"(character)"},{"key":"fplot.event1.label2.level3","text":"(character)"},{"key":"fplot.event1.label3.level1","text":"(action)"},{"key":"fplot.event1.label3.level2","text":"(action)"},{"key":"fplot.event1.label3.level3","text":"(action)"},{"key":"fplot.event1.label4.level3","text":"Type:"},{"key":"fplot.event1.choices4.level3","text":"exposition, rising action, climax, falling action, resolution"},{"key":"fplot.event2.label1.level1","text":"A major event at the end of this {{TEXT_TYPE}}:"},{"key":"fplot.event2.label1.level2","text":"After that:"},{"key":"fplot.event2.label1.level3","text":"A second major event in this {{TEXT_TYPE}}:"},{"key":"fplot.event2.label2.level1","text":"(character)"},{"key":"fplot.event2.label2.level2","text":"(character)"},{"key":"fplot.event2.label2.level3","text":"(character)"},{"key":"fplot.event2.label3.level1","text":"(action)"},{"key":"fplot.event2.label3.level2","text":"(action)"},{"key":"fplot.event2.label3.level3","text":"(action)"},{"key":"fplot.event2.label4.level3","text":"Type:"},{"key":"fplot.event2.choices4.level3","text":"exposition, rising action, climax, falling action, resolution"},{"key":"fsetting.time.label1.level1","text":"When this {{TEXT_TYPE}} happens:"},{"key":"fsetting.time.label1.level2","text":"The setting (when and where) of this {{TEXT_TYPE}}:"},{"key":"fsetting.time.label1.level3","text":"The setting of this {{TEXT_TYPE}}:"},{"key":"fsetting.time.label2.level2","text":"Time (when):"},{"key":"fsetting.time.label2.level3","text":"Time:"},{"key":"fsetting.place.label1.level1","text":"Where this {{TEXT_TYPE}} happens:"},{"key":"fsetting.place.label1.level2","text":"Place (where):"},{"key":"fsetting.place.label1.level3","text":"Place:"},{"key":"fsetting.descriptor.label1.level2","text":"One word to describe the setting:"},{"key":"fsetting.descriptor.label1.level3","text":"One word to describe the setting:"},{"key":"fsetting.descriptor.choices1.level2","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"fsetting.descriptor.choices1.level3","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"forg.numpages.label1.level1","text":"This {{TEXT_TYPE}} is"},{"key":"forg.numpages.label1.level2","text":"This {{TEXT_TYPE}} is"},{"key":"forg.numpages.label1.level3","text":"This {{TEXT_TYPE}} is"},{"key":"forg.numpages.label2.level1","text":"pages long"},{"key":"forg.numpages.label2.level2","text":"pages long"},{"key":"forg.numpages.label2.level3","text":"pages long"},{"key":"forg.orgstructure.label1.level1","text":"This {{TEXT_TYPE}} is organized into"},{"key":"forg.orgstructure.label1.level2","text":"This {{TEXT_TYPE}} is organized into"},{"key":"forg.orgstructure.label1.level3","text":"This {{TEXT_TYPE}} is organized into"},{"key":"forg.orgstructure.choices1.level1","text":"chapters, sections, parts, scenes, paragraphs"},{"key":"forg.orgstructure.choices1.level2","text":"chapters, sections, parts, scenes, paragraphs"},{"key":"forg.orgstructure.choices1.level3","text":"chapters, sections, parts, scenes, paragraphs"},{"key":"forg.randompiece.label1.level1","text":"On {{ORG_PIECE}} {{ORG_PIECE_NUMBER}}, there is a(n):"},{"key":"forg.randompiece.label1.level2","text":"{{ORG_PIECE}} {{ORG_PIECE_NUMBER}}"},{"key":"forg.randompiece.label1.level3","text":"{{ORG_PIECE}} {{ORG_PIECE_NUMBER}}"},{"key":"forg.randompiece.choices1.level2","text":"starts, ends"},{"key":"forg.randompiece.choices1.level3","text":"starts, ends"},{"key":"forg.randompiece.label2.level2","text":"with:"},{"key":"forg.randompiece.label2.level3","text":"with:"},{"key":"forg.randompiece.label3.level2","text":"(character)"},{"key":"forg.randompiece.label3.level3","text":"(character)"},{"key":"forg.randompiece.label4.level2","text":"(action)"},{"key":"forg.randompiece.label4.level3","text":"(action)"},{"key":"forg.randompiecepart.label1.level3","text":"{{ORG_PIECE}} {{ORG_PIECE_NUMBER}} is a part of the"},{"key":"forg.randompiecepart.choices1.level3","text":"exposition, rising action, climax, falling action, resolution"},{"key":"fpov.povtype.label1.level1","text":"Who is telling the story?"},{"key":"fpov.povtype.label1.level2","text":"Point of view of this {{TEXT_TYPE}}:"},{"key":"fpov.povtype.label1.level3","text":"Point of view of this {{TEXT_TYPE}}:"},{"key":"fpov.povtype.choices1.level1","text":"Character (someone in the story), Narrator (someone not in the story)"},{"key":"fpov.povtype.choices1.level2","text":"1st person (narrator uses \"I/me\"), 2nd person (narrator uses \"you\"), 3rd person (narrator uses \"he/she/they\")"},{"key":"fpov.povtype.choices1.level3","text":"1st person, 2nd person, 3rd person"},{"key":"fpov.narrator.label1.level1","text":"Name of Author:"},{"key":"fpov.narrator.label1.level2","text":"Name of who is telling the story (the narrator):"},{"key":"fpov.narrator.label1.level3","text":"Name(s) of Narrator(s):"},{"key":"fpov.narrator.label2.level1","text":"Name of Illustrator:"},{"key":"fpov.thirdptype.label1.level3","text":"Type of 3rd Person:"},{"key":"fpov.thirdptype.choices1.level3","text":"limited (only knows thoughts of one character), omniscient (knows thoughts of all characters)"},{"key":"fpov.thirdpchar.label1.level3","text":"Which character?"},{"key":"fpic.numpics.label1.level1","text":"There are"},{"key":"fpic.numpics.label1.level2","text":"There are"},{"key":"fpic.numpics.label1.level3","text":"There are"},{"key":"fpic.numpics.choices1.level1","text":"0, 1, 2 or more"},{"key":"fpic.numpics.choices1.level2","text":"0, 1, 2 or more"},{"key":"fpic.numpics.choices1.level3","text":"0, 1, 2 or more"},{"key":"fpic.numpics.label2.level1","text":"pictures (illustrations) in this {{TEXT_TYPE}}"},{"key":"fpic.numpics.label2.level2","text":"illustrations in this {{TEXT_TYPE}}"},{"key":"fpic.numpics.label2.level3","text":"illustrations in this {{TEXT_TYPE}}"},{"key":"fpic.pic1.label1.level1","text":"One picture shows a(n):"},{"key":"fpic.pic1.label1.level2","text":"One illustration shows a(n):"},{"key":"fpic.pic1.label1.level3","text":"One illustration shows a(n):"},{"key":"fpic.pic1.label2.level2","text":"One word to describe this illustration:"},{"key":"fpic.pic1.label2.level3","text":"One word to describe this illustration:"},{"key":"fpic.pic1.choices2.level2","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"fpic.pic1.choices2.level3","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"fpic.pic2.label1.level1","text":"Another picture shows a(n):"},{"key":"fpic.pic2.label1.level2","text":"Another illustration shows a(n):"},{"key":"fpic.pic2.label1.level3","text":"Another illustration shows a(n):"},{"key":"fpic.pic2.label2.level2","text":"One word to describe this illustration:"},{"key":"fpic.pic2.label2.level3","text":"One word to describe this illustration:"},{"key":"fpic.pic2.choices2.level2","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"fpic.pic2.choices2.level3","text":"{{DESCRIPTOR_OPTIONS}}"},{"key":"fcomp.diagnosis.label1.level1","text":"Have you read another book with characters?"},{"key":"fcomp.diagnosis.label1.level2","text":"Have you read another fiction text?"},{"key":"fcomp.diagnosis.label1.level3","text":"Have you read another fiction text?"},{"key":"fcomp.diagnosis.choices1.level1","text":"yes, no"},{"key":"fcomp.diagnosis.choices1.level2","text":"yes, no"},{"key":"fcomp.diagnosis.choices1.level3","text":"yes, no"},{"key":"fcomp.othertext.label1.level1","text":"Pick one you remember well:"},{"key":"fcomp.othertext.label1.level2","text":"Pick one you remember well:"},{"key":"fcomp.othertext.label1.level3","text":"Pick one that is most similar to this {{TEXT_TYPE}}:"},{"key":"fcomp.othertext.choices1.level1","text":"{{PREVIOUS_TEXTS}}"},{"key":"fcomp.othertext.choices1.level2","text":"{{PREVIOUS_TEXTS}}"},{"key":"fcomp.othertext.choices1.level3","text":"{{PREVIOUS_TEXTS}}"},{"key":"fcomp.elements.label1.level1","text":"The characters in this {{TEXT_TYPE}} are"},{"key":"fcomp.elements.label1.level2","text":"The setting of this {{TEXT_TYPE}} is"},{"key":"fcomp.elements.label1.level3","text":"What is most similar about these two texts?"},{"key":"fcomp.elements.choices1.level1","text":"similar to, different than"},{"key":"fcomp.elements.choices1.level2","text":"similar to, different than"},{"key":"fcomp.elements.choices1.level3","text":"setting, plot, theme, genre, topic"},{"key":"fcomp.elements.label2.level1","text":"the characters in {{SELECTED_TEXT}}"},{"key":"fcomp.elements.label2.level2","text":"the setting of {{SELECTED_TEXT}}"},{"key":"fcomp.elements.label3.level2","text":"The plot of this {{TEXT_TYPE}} is"},{"key":"fcomp.elements.choices3.level2","text":"similar to, different than"},{"key":"fcomp.elements.label4.level2","text":"the plot of {{SELECTED_TEXT}}"},{"key":"fcomp.elements.label5.level2","text":"The theme of this {{TEXT_TYPE}} is"},{"key":"fcomp.elements.choices5.level2","text":"similar to, different than"},{"key":"fcomp.elements.label6.level2","text":"the theme of {{SELECTED_TEXT}}"},{"key":"fcomp.describe.label1.level3","text":"One to three words to describe the {{SIMILAR_ELEMENT}} of both texts:"},{"key":"femo.beginning.label1.level1","text":"At the beginning of this {{TEXT_TYPE}} I felt"},{"key":"femo.beginning.label1.level2","text":"At the beginning of this {{TEXT_TYPE}} I felt"},{"key":"femo.beginning.label1.level3","text":"The rising action in this {{TEXT_TYPE}} made me feel"},{"key":"femo.beginning.choices1.level1","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.beginning.choices1.level2","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.beginning.choices1.level3","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.middle.label1.level2","text":"In the middle of this {{TEXT_TYPE}} I felt"},{"key":"femo.middle.label1.level3","text":"The climax of this {{TEXT_TYPE}} made me feel"},{"key":"femo.middle.choices1.level2","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.middle.choices1.level3","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.fallingaction.label1.level3","text":"The falling action in this {{TEXT_TYPE}} made me feel"},{"key":"femo.fallingaction.choices1.level3","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.end.label1.level1","text":"At the end of this {{TEXT_TYPE}} I felt"},{"key":"femo.end.label1.level2","text":"At the end of this {{TEXT_TYPE}} I felt"},{"key":"femo.end.label1.level3","text":"The resolution of this {{TEXT_TYPE}} made me feel"},{"key":"femo.end.choices1.level1","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.end.choices1.level2","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.end.choices1.level3","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.overall.label1.level2","text":"This {{TEXT_TYPE}} overall made me feel"},{"key":"femo.overall.label1.level3","text":"This {{TEXT_TYPE}} overall made me feel"},{"key":"femo.overall.choices1.level2","text":"{{EMOTION_OPTIONS}}"},{"key":"femo.overall.choices1.level3","text":"{{EMOTION_OPTIONS}}"},{"key":"fvocab.hardword.label1.level1","text":"One hard word in this {{TEXT_TYPE}} is:"},{"key":"fvocab.hardword.label1.level2","text":"One difficult word in this {{TEXT_TYPE}} is:"},{"key":"fvocab.hardword.label1.level3","text":"One advanced vocabulary word in this {{TEXT_TYPE}} is:"},{"key":"fvocab.specialword.label1.level1","text":"One sensory word (a word that describes what I see, hear, smell, taste, or feel) in this {{TEXT_TYPE}} is:"},{"key":"fvocab.specialword.label1.level2","text":"One nonliteral word or phrase (a word or phrase whose meaning is not meant to be taken exactly as it is stated) in this {{TEXT_TYPE}} is:"},{"key":"fvocab.specialword.label1.level3","text":"One word or phrase in this {{TEXT_TYPE}} that has a"},{"key":"fvocab.specialword.choices1.level3","text":"figurative, connotative"},{"key":"fvocab.specialword.label2.level3","text":"meaning is:"},{"key":"fvocab.specialtype.label1.level2","text":"{{ENTERED_WORD}} is an example of a(n):"},{"key":"fvocab.specialtype.choices1.level2","text":"simile (comparison using \"like\" or \"as\"), metaphor (comparison not using \"like\" or \"as\"), allusion (reference to something outside the text), exaggeration, saying/expression"},{"key":"fvocab.meaningliteral.label1.level3","text":"The denotation (literal definition) of {{ENTERED_WORD}} is:"},{"key":"fvocab.meaningliteral.label2.level3","text":"The literal meaning of {{ENTERED_WORD}} is:"},{"key":"fvocab.meaningnonliteral.label1.level3","text":"The connotation (secondary meaning) of {{ENTERED_WORD}} is:"},{"key":"fvocab.meaningnonliteral.label2.level3","text":"The figurative meaning of {{ENTERED_WORD}} is:"},{"key":"nfsubj.entity1.label1.level1","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nfsubj.entity1.label1.level2","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nfsubj.entity1.label1.level3","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nfsubj.entity2.label1.level1","text":"Another one of the"},{"key":"nfsubj.entity2.label1.level2","text":"One of the"},{"key":"nfsubj.entity2.label1.level3","text":"One of the"},{"key":"nfsubj.entity2.choices1.level1","text":"people, animals/plants/objects, events (thing that happened), ideas"},{"key":"nfsubj.entity2.choices1.level2","text":"people, animals/plants/objects, events, ideas"},{"key":"nfsubj.entity2.choices1.level3","text":"people, animals/plants/objects, events, ideas"},{"key":"nfsubj.entity2.label2.level1","text":"in this {{TEXT_TYPE}}:"},{"key":"nfsubj.entity2.label2.level2","text":"that is related to {{ENTITY1}}:"},{"key":"nfsubj.entity2.label2.level3","text":"that is related to {{ENTITY1}}:"},{"key":"nfsubj.relationship.label1.level2","text":"{{ENTITY1}}"},{"key":"nfsubj.relationship.label1.level3","text":"{{ENTITY1}}"},{"key":"nfsubj.relationship.choices1.level2","text":"{{RELATIONAL_MATRIX}}"},{"key":"nfsubj.relationship.choices1.level3","text":"{{RELATIONAL_MATRIX}}"},{"key":"nfsubj.relationship.label2.level2","text":"{{ENTITY2}}"},{"key":"nfsubj.relationship.label2.level3","text":"{{ENTITY2}}"},{"key":"nfmain.mainidea1.label1.level1","text":"The main topic of this {{TEXT_TYPE}} in a few words:"},{"key":"nfmain.mainidea1.label1.level2","text":"The main idea of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"nfmain.mainidea1.label1.level3","text":"The central idea of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"nfmain.mainidea2.label1.level3","text":"Another central idea of this {{TEXT_TYPE}} (using 3-10 words):"},{"key":"nforg.numpages.label1.level1","text":"This {{TEXT_TYPE}} is"},{"key":"nforg.numpages.label1.level2","text":"This {{TEXT_TYPE}} is"},{"key":"nforg.numpages.label1.level3","text":"This {{TEXT_TYPE}} is"},{"key":"nforg.numpages.label2.level1","text":"pages long"},{"key":"nforg.numpages.label2.level2","text":"pages long"},{"key":"nforg.numpages.label2.level3","text":"pages long"},{"key":"nforg.orgstructure.label1.level1","text":"This {{TEXT_TYPE}} has"},{"key":"nforg.orgstructure.label1.level2","text":"This {{TEXT_TYPE}}'s structure is"},{"key":"nforg.orgstructure.label1.level3","text":"This {{TEXT_TYPE}}'s structure is"},{"key":"nforg.orgstructure.choices1.level2","text":"chronological (time), compare/contrast (how things are similar and different), cause/effect (why things happened), problem/solution, descriptive"},{"key":"nforg.orgstructure.choices1.level3","text":"chronological, compare/contrast, cause/effect, problem/solution, descriptive"},{"key":"nforg.orgstructure.label2.level1","text":"titles and headings"},{"key":"nforg.headinginfo.label1.level1","text":"The {{HEADING_NUMBER}} title/heading has information about:"},{"key":"nforg.chronological.label1.level2","text":"First Event:"},{"key":"nforg.chronological.label1.level3","text":"First Event:"},{"key":"nforg.chronological.label2.level2","text":"Second Event:"},{"key":"nforg.chronological.label2.level3","text":"Second Event:"},{"key":"nforg.comparison.label1.level2","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nforg.comparison.label1.level3","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nforg.comparison.label2.level2","text":"Compared/Contrasted to:"},{"key":"nforg.comparison.label2.level3","text":"Compared/Contrasted to:"},{"key":"nforg.causeeffect.label1.level2","text":"Cause:"},{"key":"nforg.causeeffect.label1.level3","text":"Cause:"},{"key":"nforg.causeeffect.label2.level2","text":"Effect:"},{"key":"nforg.causeeffect.label2.level3","text":"Effect:"},{"key":"nforg.problemsolution.label1.level2","text":"Problem:"},{"key":"nforg.problemsolution.label1.level3","text":"Problem:"},{"key":"nforg.problemsolution.label2.level2","text":"Solution:"},{"key":"nforg.problemsolution.label2.level3","text":"Solution:"},{"key":"nforg.description.label1.level2","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nforg.description.label1.level3","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nforg.description.label2.level2","text":"Described as:"},{"key":"nforg.description.label2.level3","text":"Described as:"},{"key":"nfpov.naming.label1.level1","text":"Name of Author:"},{"key":"nfpov.naming.label2.level1","text":"Name of Illustrator:"},{"key":"nfpov.purpose.label1.level2","text":"The author wrote this {{TEXT_TYPE}} to"},{"key":"nfpov.purpose.label1.level3","text":"The author wrote this {{TEXT_TYPE}} to"},{"key":"nfpov.purpose.choices1.level2","text":"entertain, describe, persuade, inform"},{"key":"nfpov.purpose.choices1.level3","text":"entertain, describe, persuade, inform"},{"key":"nfpov.entertain.label1.level2","text":"This {{TEXT_TYPE}} makes readers feel"},{"key":"nfpov.entertain.label1.level3","text":"The author entertains the reader with"},{"key":"nfpov.entertain.choices1.level3","text":"events from their own life, observations about the world, word choice, surprising ideas/details"},{"key":"nfpov.describe.label1.level2","text":"This {{TEXT_TYPE}} gives details about"},{"key":"nfpov.describe.label1.level3","text":"The information in this {{TEXT_TYPE}} comes from"},{"key":"nfpov.describe.choices1.level3","text":"quotes from experts, other sources/texts, author's experience, author's knowledge, no cited source"},{"key":"nfpov.inform.label1.level2","text":"This {{TEXT_TYPE}} teaches about"},{"key":"nfpov.inform.label1.level3","text":"The information in this {{TEXT_TYPE}} comes from"},{"key":"nfpov.inform.choices1.level3","text":"quotes from experts, other sources/texts, author's experience, author's knowledge, no cited source"},{"key":"nfpov.persuade.label1.level2","text":"This {{TEXT_TYPE}} argues that"},{"key":"nfpov.persuade.label1.level3","text":"The author uses these methods to persuade:"},{"key":"nfpov.persuade.choices1.level3","text":"say they are an expert, cite data or statistics, provide examples, discuss other positions/viewpoints, make counterarguments"},{"key":"nfpic.featuretype.label1.level1","text":"How many pictures (illustrations) are in this {{TEXT_TYPE}}?"},{"key":"nfpic.featuretype.label1.level2","text":"Type(s) of illustrations in this {{TEXT_TYPE}}:"},{"key":"nfpic.featuretype.label1.level3","text":"This {{TEXT_TYPE}} presents information in:"},{"key":"nfpic.featuretype.choices1.level1","text":"0, 1, 2 or more"},{"key":"nfpic.featuretype.choices1.level2","text":"{{TEXT_FEATURE_OPTIONS}}"},{"key":"nfpic.featuretype.choices1.level3","text":"{{TEXT_FEATURE_OPTIONS}}"},{"key":"nfpic.describe1.label1.level1","text":"One picture shows a(n):"},{"key":"nfpic.describe1.label1.level2","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.describe1.label1.level3","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.infotype1.label1.level3","text":"This information is:"},{"key":"nfpic.infotype1.choices1.level3","text":"quantitative (numbers), qualitative (words), visual (images)"},{"key":"nfpic.describe2.label1.level1","text":"Another picture shows a(n):"},{"key":"nfpic.describe2.label1.level2","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.describe2.label1.level3","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.infotype2.label1.level3","text":"This information is:"},{"key":"nfpic.infotype2.choices1.level3","text":"quantitative (numbers), qualitative (words), visual (images)"},{"key":"nfpic.describe3.label1.level2","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.describe3.label1.level3","text":"One {{FEATURE_TYPE}} shows:"},{"key":"nfpic.infotype3.label1.level3","text":"This information is:"},{"key":"nfpic.infotype3.choices1.level3","text":"quantitative (numbers), qualitative (words), visual (images)"},{"key":"nfcomp.diagnosis.label1.level1","text":"Have you read another nonfiction book?"},{"key":"nfcomp.diagnosis.label1.level2","text":"Have you read another nonfiction text?"},{"key":"nfcomp.diagnosis.label1.level3","text":"Have you read another nonfiction text?"},{"key":"nfcomp.diagnosis.choices1.level1","text":"yes, no"},{"key":"nfcomp.diagnosis.choices1.level2","text":"yes, no"},{"key":"nfcomp.diagnosis.choices1.level3","text":"yes, no"},{"key":"nfcomp.othertext.label1.level1","text":"Pick one you remember well:"},{"key":"nfcomp.othertext.label1.level2","text":"Pick a text with a topic most similar to the topic of this {{TEXT_TYPE}}:"},{"key":"nfcomp.othertext.label1.level3","text":"Pick a text with a topic most similar to the topic of this {{TEXT_TYPE}}:"},{"key":"nfcomp.elements.label1.level1","text":"The topic of this {{TEXT_TYPE}} is"},{"key":"nfcomp.elements.label1.level2","text":"What is similar about these two texts?"},{"key":"nfcomp.elements.label1.level3","text":"What is most similar about these two texts?"},{"key":"nfcomp.elements.choices1.level1","text":"similar to, different than"},{"key":"nfcomp.elements.choices1.level2","text":"argument (author's opinion), evidence, topic, illustrations, tone, author, location, source (where the text is written), format/structure, date written"},{"key":"nfcomp.elements.choices1.level3","text":"argument, evidence, topic, illustrations, tone, authors, location, source (where the text is published), format/structure, date written"},{"key":"nfcomp.elements.label2.level1","text":"the topic of {{SELECTED_TEXT}}"},{"key":"nfcomp.describe.label1.level3","text":"One to three words to describe the {{SIMILAR_ELEMENT}} of both texts:"},{"key":"nfvocab.hardword.label1.level1","text":"One hard word in this {{TEXT_TYPE}} is:"},{"key":"nfvocab.hardword.label1.level2","text":"One difficult word in this {{TEXT_TYPE}} is:"},{"key":"nfvocab.hardword.label1.level3","text":"One advanced vocabulary word in this {{TEXT_TYPE}} is:"},{"key":"nfvocab.hardwordpiece.label1.level2","text":"{{HARD_WORD}} contains"},{"key":"nfvocab.hardwordpiece.choices1.level2","text":"a prefix, a suffix, a common root, none of these"},{"key":"nfvocab.topicword.label1.level1","text":"One {{TOPIC}} word in this {{TEXT_TYPE}} is:"},{"key":"nfvocab.topicword.label1.level2","text":"One word related to {{TOPIC}} in this {{TEXT_TYPE}} is:"},{"key":"nfvocab.topicword.label1.level3","text":"One word or phrase in this {{TEXT_TYPE}} related to {{TOPIC}} that has a"},{"key":"nfvocab.topicword.choices1.level3","text":"technical, connotative, figurative"},{"key":"nfvocab.topicword.label2.level3","text":"meaning is:"},{"key":"nfvocab.topicwordpiece.label1.level2","text":"{{ENTERED_WORD}} contains"},{"key":"nfvocab.topicwordpiece.choices1.level2","text":"a prefix, a suffix, a common root, none of these"},{"key":"nfvocab.meaningliteral.label1.level3","text":"The denotation (literal definition) of {{ENTERED_WORD}} is:"},{"key":"nfvocab.meaningliteral.label2.level3","text":"The literal meaning of {{ENTERED_WORD}} is:"},{"key":"nfvocab.meaningnonliteral.label1.level3","text":"The connotation (secondary meaning) of {{ENTERED_WORD}} is:"},{"key":"nfvocab.meaningnonliteral.label2.level3","text":"The figurative meaning of {{ENTERED_WORD}} is:"},{"key":"nfvocab.meaningtechnical.label1.level3","text":"In this context, the technical meaning of {{ENTERED_WORD}} is:"},{"key":"nfarg.specificentity.label1.level1","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nfarg.specificentity.label1.level2","text":"Pick an important paragraph about {{ENTITY_TYPE}}. One of the {{ENTITY_TYPE}} in this paragraph:"},{"key":"nfarg.specificentity.label1.level3","text":"One of the {{ENTITY_TYPE}} in this {{TEXT_TYPE}}:"},{"key":"nfarg.point.label1.level1","text":"One point (piece of information) about {{SPECIFIC_ENTITY}}:"},{"key":"nfarg.point.label1.level2","text":"The point about {{SPECIFIC_ENTITY}} in this paragraph:"},{"key":"nfarg.point.label1.level3","text":"One argument about {{SPECIFIC_ENTITY}} in this {{TEXT_TYPE}}:"},{"key":"nfarg.point.choices1.level1","text":"it, he, she, they"},{"key":"nfarg.point.choices1.level2","text":"it, he, she, they"},{"key":"nfarg.point.choices1.level3","text":"it, he, she, they"},{"key":"nfarg.point.choices2.level1","text":"is/are, did, like/likes, can, will, has/have, was/were"},{"key":"nfarg.point.choices2.level2","text":"is/are, did, like/likes, can, will, has/have, was/were"},{"key":"nfarg.point.choices2.level3","text":"is/are, did, like/likes, can, will, has/have, was/were"},{"key":"nfarg.evidence.label1.level2","text":"One piece of evidence (a reason) that supports this point:"},{"key":"nfarg.evidence.label1.level3","text":"One piece of evidence that supports this argument:"},{"key":"nfarg.evidence.choices1.level2","text":"it, he, she, they"},{"key":"nfarg.evidence.choices1.level3","text":"it, he, she, they"},{"key":"nfarg.evidence.choices2.level2","text":"is/are, did, like/likes, can, will, has/have, was/were"},{"key":"nfarg.evidence.choices2.level3","text":"is/are, did, like/likes, can, will, has/have, was/were"},{"key":"nfarg.evidencetype.label1.level3","text":"This evidence is"},{"key":"nfarg.evidencetype.choices1.level3","text":"factual (facts confirmed by research or experts), anecdotal (personal observations or experiences), quantitative (using numbers or data), opinion (author's personal view or belief)"}]

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1519);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(3544);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1522));
	
	/**
	 * Adds a CSS class to a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	/**
	 * Checks if a given element has a CSS class.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	/**
	 * Removes a CSS class from a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(149);
	var entities = __webpack_require__(1541);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(3531);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(485);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(149);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(149).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(149),
	    getOuterHTML = __webpack_require__(1524),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects objects to elements in order to detect resize events.
	 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	 */
	
	"use strict";
	
	var browserDetector = __webpack_require__(487);
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	
	    if(!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        function listenerProxy() {
	            listener(element);
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support object, but supports the resize event directly on elements.
	            getState(element).object = {
	                proxy: listenerProxy
	            };
	            element.attachEvent("onresize", listenerProxy);
	        } else {
	            var object = getObject(element);
	
	            if(!object) {
	                throw new Error("Element is not detectable by this strategy.");
	            }
	
	            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
	        }
	    }
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	        var debug = options.debug;
	
	        function injectObject(element, callback) {
	            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]);
	
	            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
	
	            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
	            var positionCheckPerformed = false;
	
	            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
	            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
	            var style = window.getComputedStyle(element);
	            var width = element.offsetWidth;
	            var height = element.offsetHeight;
	
	            getState(element).startSize = {
	                width: width,
	                height: height
	            };
	
	            function mutateDom() {
	                function alterPositionStyles() {
	                    if(style.position === "static") {
	                        element.style.setProperty("position", "relative", options.important ? "important" : "");
	
	                        var removeRelativeStyles = function(reporter, element, style, property) {
	                            function getNumericalValue(value) {
	                                return value.replace(/[^-\d\.]/g, "");
	                            }
	
	                            var value = style[property];
	
	                            if(value !== "auto" && getNumericalValue(value) !== "0") {
	                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                                element.style.setProperty(property, "0", options.important ? "important" : "");
	                            }
	                        };
	
	                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                        removeRelativeStyles(reporter, element, style, "top");
	                        removeRelativeStyles(reporter, element, style, "right");
	                        removeRelativeStyles(reporter, element, style, "bottom");
	                        removeRelativeStyles(reporter, element, style, "left");
	                    }
	                }
	
	                function onObjectLoad() {
	                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
	                    if (!positionCheckPerformed) {
	                        alterPositionStyles();
	                    }
	
	                    /*jshint validthis: true */
	
	                    function getDocument(element, callback) {
	                        //Opera 12 seem to call the object.onload before the actual document has been created.
	                        //So if it is not present, poll it with an timeout until it is present.
	                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
	                        if(!element.contentDocument) {
	                            var state = getState(element);
	                            if (state.checkForObjectDocumentTimeoutId) {
	                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
	                            }
	                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
	                                state.checkForObjectDocumentTimeoutId = 0;
	                                getDocument(element, callback);
	                            }, 100);
	
	                            return;
	                        }
	
	                        callback(element.contentDocument);
	                    }
	
	                    //Mutating the object element here seems to fire another load event.
	                    //Mutating the inner document of the object element is fine though.
	                    var objectElement = this;
	
	                    //Create the style element to be added to the object.
	                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
	                        //Notify that the element is ready to be listened to.
	                        callback(element);
	                    });
	                }
	
	                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
	                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
	                if (style.position !== "") {
	                    alterPositionStyles(style);
	                    positionCheckPerformed = true;
	                }
	
	                //Add an object element as a child to the target element that will be listened to for resize events.
	                var object = document.createElement("object");
	                object.style.cssText = OBJECT_STYLE;
	                object.tabIndex = -1;
	                object.type = "text/html";
	                object.setAttribute("aria-hidden", "true");
	                object.onload = onObjectLoad;
	
	                //Safari: This must occur before adding the object to the DOM.
	                //IE: Does not like that this happens before, even if it is also added after.
	                if(!browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	
	                if (!getState(element)) {
	                    // The element has been uninstalled before the actual loading happened.
	                    return;
	                }
	
	                element.appendChild(object);
	                getState(element).object = object;
	
	                //IE: This must occur after adding the object to the DOM.
	                if(browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	            }
	
	            if(batchProcessor) {
	                batchProcessor.add(mutateDom);
	            } else {
	                mutateDom();
	            }
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support objects properly. Luckily they do support the resize event.
	            //So do not inject the object and notify that the element is already ready to be listened to.
	            //The event handler for the resize event is attached in the utils.addListener instead.
	            callback(element);
	        } else {
	            injectObject(element, callback);
	        }
	    }
	
	    /**
	     * Returns the child object of the target element.
	     * @private
	     * @param {element} element The target element.
	     * @returns The object element of the target.
	     */
	    function getObject(element) {
	        return getState(element).object;
	    }
	
	    function uninstall(element) {
	        if (!getState(element)) {
	            return;
	        }
	
	        var object = getObject(element);
	
	        if (!object) {
	            return;
	        }
	
	        if (browserDetector.isIE(8)) {
	            element.detachEvent("onresize", object.proxy);
	        } else {
	            element.removeChild(object);
	        }
	
	        if (getState(element).checkForObjectDocumentTimeoutId) {
	            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
	        }
	
	        delete getState(element).object;
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
	 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
	 */
	
	"use strict";
	
	var forEach = __webpack_require__(488).forEach;
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	    var hasState        = options.stateHandler.hasState;
	    var idHandler       = options.idHandler;
	
	    if (!batchProcessor) {
	        throw new Error("Missing required dependency: batchProcessor");
	    }
	
	    if (!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    //TODO: Could this perhaps be done at installation time?
	    var scrollbarSizes = getScrollbarSizes();
	
	    var styleId = "erd_scroll_detection_scrollbar_style";
	    var detectionContainerClass = "erd_scroll_detection_container";
	
	    function initDocument(targetDocument) {
	        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
	        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
	        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
	    }
	
	    initDocument(window.document);
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    function getScrollbarSizes() {
	        var width = 500;
	        var height = 500;
	
	        var child = document.createElement("div");
	        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        var container = document.createElement("div");
	        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        container.appendChild(child);
	
	        document.body.insertBefore(container, document.body.firstChild);
	
	        var widthSize = width - container.clientWidth;
	        var heightSize = height - container.clientHeight;
	
	        document.body.removeChild(container);
	
	        return {
	            width: widthSize,
	            height: heightSize
	        };
	    }
	
	    function injectScrollStyle(targetDocument, styleId, containerClass) {
	        function injectStyle(style, method) {
	            method = method || function (element) {
	                targetDocument.head.appendChild(element);
	            };
	
	            var styleElement = targetDocument.createElement("style");
	            styleElement.innerHTML = style;
	            styleElement.id = styleId;
	            method(styleElement);
	            return styleElement;
	        }
	
	        if (!targetDocument.getElementById(styleId)) {
	            var containerAnimationClass = containerClass + "_animation";
	            var containerAnimationActiveClass = containerClass + "_animation_active";
	            var style = "/* Created by the element-resize-detector library. */\n";
	            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
	            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
	            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
	            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
	            injectStyle(style);
	        }
	    }
	
	    function addAnimationClass(element) {
	        element.className += " " + detectionContainerClass + "_animation_active";
	    }
	
	    function addEvent(el, name, cb) {
	        if (el.addEventListener) {
	            el.addEventListener(name, cb);
	        } else if(el.attachEvent) {
	            el.attachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to add event listeners.");
	        }
	    }
	
	    function removeEvent(el, name, cb) {
	        if (el.removeEventListener) {
	            el.removeEventListener(name, cb);
	        } else if(el.detachEvent) {
	            el.detachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to remove event listeners.");
	        }
	    }
	
	    function getExpandElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
	    }
	
	    function getShrinkElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        var listeners = getState(element).listeners;
	
	        if (!listeners.push) {
	            throw new Error("Cannot add listener to an element that is not detectable.");
	        }
	
	        getState(element).listeners.push(listener);
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	
	        function debug() {
	            if (options.debug) {
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(idHandler.get(element), "Scroll: ");
	                if (reporter.log.apply) {
	                    reporter.log.apply(null, args);
	                } else {
	                    for (var i = 0; i < args.length; i++) {
	                        reporter.log(args[i]);
	                    }
	                }
	            }
	        }
	
	        function isDetached(element) {
	            function isInDocument(element) {
	                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
	                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
	            }
	
	            if (!isInDocument(element)) {
	                return true;
	            }
	
	            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
	            if (window.getComputedStyle(element) === null) {
	                return true;
	            }
	
	            return false;
	        }
	
	        function isUnrendered(element) {
	            // Check the absolute positioned container since the top level container is display: inline.
	            var container = getState(element).container.childNodes[0];
	            var style = window.getComputedStyle(container);
	            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
	        }
	
	        function getStyle() {
	            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
	            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
	            var elementStyle            = window.getComputedStyle(element);
	            var style                   = {};
	            style.position              = elementStyle.position;
	            style.width                 = element.offsetWidth;
	            style.height                = element.offsetHeight;
	            style.top                   = elementStyle.top;
	            style.right                 = elementStyle.right;
	            style.bottom                = elementStyle.bottom;
	            style.left                  = elementStyle.left;
	            style.widthCSS              = elementStyle.width;
	            style.heightCSS             = elementStyle.height;
	            return style;
	        }
	
	        function storeStartSize() {
	            var style = getStyle();
	            getState(element).startSize = {
	                width: style.width,
	                height: style.height
	            };
	            debug("Element start size", getState(element).startSize);
	        }
	
	        function initListeners() {
	            getState(element).listeners = [];
	        }
	
	        function storeStyle() {
	            debug("storeStyle invoked.");
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getStyle();
	            getState(element).style = style;
	        }
	
	        function storeCurrentSize(element, width, height) {
	            getState(element).lastWidth = width;
	            getState(element).lastHeight  = height;
	        }
	
	        function getExpandChildElement(element) {
	            return getExpandElement(element).childNodes[0];
	        }
	
	        function getWidthOffset() {
	            return 2 * scrollbarSizes.width + 1;
	        }
	
	        function getHeightOffset() {
	            return 2 * scrollbarSizes.height + 1;
	        }
	
	        function getExpandWidth(width) {
	            return width + 10 + getWidthOffset();
	        }
	
	        function getExpandHeight(height) {
	            return height + 10 + getHeightOffset();
	        }
	
	        function getShrinkWidth(width) {
	            return width * 2 + getWidthOffset();
	        }
	
	        function getShrinkHeight(height) {
	            return height * 2 + getHeightOffset();
	        }
	
	        function positionScrollbars(element, width, height) {
	            var expand          = getExpandElement(element);
	            var shrink          = getShrinkElement(element);
	            var expandWidth     = getExpandWidth(width);
	            var expandHeight    = getExpandHeight(height);
	            var shrinkWidth     = getShrinkWidth(width);
	            var shrinkHeight    = getShrinkHeight(height);
	            expand.scrollLeft   = expandWidth;
	            expand.scrollTop    = expandHeight;
	            shrink.scrollLeft   = shrinkWidth;
	            shrink.scrollTop    = shrinkHeight;
	        }
	
	        function injectContainerElement() {
	            var container = getState(element).container;
	
	            if (!container) {
	                container                   = document.createElement("div");
	                container.className         = detectionContainerClass;
	                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
	                getState(element).container = container;
	                addAnimationClass(container);
	                element.appendChild(container);
	
	                var onAnimationStart = function () {
	                    getState(element).onRendered && getState(element).onRendered();
	                };
	
	                addEvent(container, "animationstart", onAnimationStart);
	
	                // Store the event handler here so that they may be removed when uninstall is called.
	                // See uninstall function for an explanation why it is needed.
	                getState(element).onAnimationStart = onAnimationStart;
	            }
	
	            return container;
	        }
	
	        function injectScrollElements() {
	            function alterPositionStyles() {
	                var style = getState(element).style;
	
	                if(style.position === "static") {
	                    element.style.setProperty("position", "relative",options.important ? "important" : "");
	
	                    var removeRelativeStyles = function(reporter, element, style, property) {
	                        function getNumericalValue(value) {
	                            return value.replace(/[^-\d\.]/g, "");
	                        }
	
	                        var value = style[property];
	
	                        if(value !== "auto" && getNumericalValue(value) !== "0") {
	                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                            element.style[property] = 0;
	                        }
	                    };
	
	                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                    removeRelativeStyles(reporter, element, style, "top");
	                    removeRelativeStyles(reporter, element, style, "right");
	                    removeRelativeStyles(reporter, element, style, "bottom");
	                    removeRelativeStyles(reporter, element, style, "left");
	                }
	            }
	
	            function getLeftTopBottomRightCssText(left, top, bottom, right) {
	                left = (!left ? "0" : (left + "px"));
	                top = (!top ? "0" : (top + "px"));
	                bottom = (!bottom ? "0" : (bottom + "px"));
	                right = (!right ? "0" : (right + "px"));
	
	                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
	            }
	
	            debug("Injecting elements");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            alterPositionStyles();
	
	            var rootContainer = getState(element).container;
	
	            if (!rootContainer) {
	                rootContainer = injectContainerElement();
	            }
	
	            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
	            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
	            // the targeted element.
	            // When the bug is resolved, "containerContainer" may be removed.
	
	            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
	            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
	
	            var scrollbarWidth          = scrollbarSizes.width;
	            var scrollbarHeight         = scrollbarSizes.height;
	            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
	            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
	            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
	            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);
	
	            var containerContainer      = document.createElement("div");
	            var container               = document.createElement("div");
	            var expand                  = document.createElement("div");
	            var expandChild             = document.createElement("div");
	            var shrink                  = document.createElement("div");
	            var shrinkChild             = document.createElement("div");
	
	            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
	            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
	            containerContainer.dir              = "ltr";
	
	            containerContainer.style.cssText    = containerContainerStyle;
	            containerContainer.className        = detectionContainerClass;
	            container.className                 = detectionContainerClass;
	            container.style.cssText             = containerStyle;
	            expand.style.cssText                = expandStyle;
	            expandChild.style.cssText           = expandChildStyle;
	            shrink.style.cssText                = shrinkStyle;
	            shrinkChild.style.cssText           = shrinkChildStyle;
	
	            expand.appendChild(expandChild);
	            shrink.appendChild(shrinkChild);
	            container.appendChild(expand);
	            container.appendChild(shrink);
	            containerContainer.appendChild(container);
	            rootContainer.appendChild(containerContainer);
	
	            function onExpandScroll() {
	                var state = getState(element);
	                if (state && state.onExpand) {
	                    state.onExpand();
	                } else {
	                    debug("Aborting expand scroll handler: element has been uninstalled");
	                }
	            }
	
	            function onShrinkScroll() {
	                var state = getState(element);
	                if (state && state.onShrink) {
	                    state.onShrink();
	                } else {
	                    debug("Aborting shrink scroll handler: element has been uninstalled");
	                }
	            }
	
	            addEvent(expand, "scroll", onExpandScroll);
	            addEvent(shrink, "scroll", onShrinkScroll);
	
	            // Store the event handlers here so that they may be removed when uninstall is called.
	            // See uninstall function for an explanation why it is needed.
	            getState(element).onExpandScroll = onExpandScroll;
	            getState(element).onShrinkScroll = onShrinkScroll;
	        }
	
	        function registerListenersAndPositionElements() {
	            function updateChildSizes(element, width, height) {
	                var expandChild             = getExpandChildElement(element);
	                var expandWidth             = getExpandWidth(width);
	                var expandHeight            = getExpandHeight(height);
	                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
	                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
	            }
	
	            function updateDetectorElements(done) {
	                var width           = element.offsetWidth;
	                var height          = element.offsetHeight;
	
	                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
	                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
	
	                debug("Storing current size", width, height);
	
	                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
	                // Otherwise the if-check in handleScroll is useless.
	                storeCurrentSize(element, width, height);
	
	                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
	                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
	
	                batchProcessor.add(0, function performUpdateChildSizes() {
	                    if (!sizeChanged) {
	                        return;
	                    }
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    if (options.debug) {
	                        var w = element.offsetWidth;
	                        var h = element.offsetHeight;
	
	                        if (w !== width || h !== height) {
	                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
	                        }
	                    }
	
	                    updateChildSizes(element, width, height);
	                });
	
	                batchProcessor.add(1, function updateScrollbars() {
	                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
	                    // been restored to the original size, which will have changed the scrollbar positions.
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    positionScrollbars(element, width, height);
	                });
	
	                if (sizeChanged && done) {
	                    batchProcessor.add(2, function () {
	                        if (!getState(element)) {
	                            debug("Aborting because element has been uninstalled");
	                            return;
	                        }
	
	                        if (!areElementsInjected()) {
	                          debug("Aborting because element container has not been initialized");
	                          return;
	                        }
	
	                        done();
	                    });
	                }
	            }
	
	            function areElementsInjected() {
	                return !!getState(element).container;
	            }
	
	            function notifyListenersIfNeeded() {
	                function isFirstNotify() {
	                    return getState(element).lastNotifiedWidth === undefined;
	                }
	
	                debug("notifyListenersIfNeeded invoked");
	
	                var state = getState(element);
	
	                // Don't notify if the current size is the start size, and this is the first notification.
	                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
	                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
	                }
	
	                // Don't notify if the size already has been notified.
	                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
	                    return debug("Not notifying: Size already notified");
	                }
	
	
	                debug("Current size not notified, notifying...");
	                state.lastNotifiedWidth = state.lastWidth;
	                state.lastNotifiedHeight = state.lastHeight;
	                forEach(getState(element).listeners, function (listener) {
	                    listener(element);
	                });
	            }
	
	            function handleRender() {
	                debug("startanimation triggered.");
	
	                if (isUnrendered(element)) {
	                    debug("Ignoring since element is still unrendered...");
	                    return;
	                }
	
	                debug("Element rendered.");
	                var expand = getExpandElement(element);
	                var shrink = getShrinkElement(element);
	                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
	                    debug("Scrollbars out of sync. Updating detector elements...");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                }
	            }
	
	            function handleScroll() {
	                debug("Scroll detected.");
	
	                if (isUnrendered(element)) {
	                    // Element is still unrendered. Skip this scroll event.
	                    debug("Scroll event fired while unrendered. Ignoring...");
	                    return;
	                }
	
	                updateDetectorElements(notifyListenersIfNeeded);
	            }
	
	            debug("registerListenersAndPositionElements invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            getState(element).onRendered = handleRender;
	            getState(element).onExpand = handleScroll;
	            getState(element).onShrink = handleScroll;
	
	            var style = getState(element).style;
	            updateChildSizes(element, style.width, style.height);
	        }
	
	        function finalizeDomMutation() {
	            debug("finalizeDomMutation invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getState(element).style;
	            storeCurrentSize(element, style.width, style.height);
	            positionScrollbars(element, style.width, style.height);
	        }
	
	        function ready() {
	            callback(element);
	        }
	
	        function install() {
	            debug("Installing...");
	            initListeners();
	            storeStartSize();
	
	            batchProcessor.add(0, storeStyle);
	            batchProcessor.add(1, injectScrollElements);
	            batchProcessor.add(2, registerListenersAndPositionElements);
	            batchProcessor.add(3, finalizeDomMutation);
	            batchProcessor.add(4, ready);
	        }
	
	        debug("Making detectable...");
	
	        if (isDetached(element)) {
	            debug("Element is detached");
	
	            injectContainerElement();
	
	            debug("Waiting until element is attached...");
	
	            getState(element).onRendered = function () {
	                debug("Element is now attached");
	                install();
	            };
	        } else {
	            install();
	        }
	    }
	
	    function uninstall(element) {
	        var state = getState(element);
	
	        if (!state) {
	            // Uninstall has been called on a non-erd element.
	            return;
	        }
	
	        // Uninstall may have been called in the following scenarios:
	        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
	        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
	        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
	        // So to be on the safe side, let's check for each thing before removing.
	
	        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
	        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
	        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
	        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
	
	        state.container && element.removeChild(state.container);
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var forEach                 = __webpack_require__(488).forEach;
	var elementUtilsMaker       = __webpack_require__(1535);
	var listenerHandlerMaker    = __webpack_require__(1538);
	var idGeneratorMaker        = __webpack_require__(1536);
	var idHandlerMaker          = __webpack_require__(1537);
	var reporterMaker           = __webpack_require__(1539);
	var browserDetector         = __webpack_require__(487);
	var batchProcessorMaker     = __webpack_require__(1035);
	var stateHandler            = __webpack_require__(1540);
	
	//Detection strategies.
	var objectStrategyMaker     = __webpack_require__(1532);
	var scrollStrategyMaker     = __webpack_require__(1533);
	
	function isCollection(obj) {
	    return Array.isArray(obj) || obj.length !== undefined;
	}
	
	function toArray(collection) {
	    if (!Array.isArray(collection)) {
	        var array = [];
	        forEach(collection, function (obj) {
	            array.push(obj);
	        });
	        return array;
	    } else {
	        return collection;
	    }
	}
	
	function isElement(obj) {
	    return obj && obj.nodeType === 1;
	}
	
	/**
	 * @typedef idHandler
	 * @type {object}
	 * @property {function} get Gets the resize detector id of the element.
	 * @property {function} set Generate and sets the resize detector id of the element.
	 */
	
	/**
	 * @typedef Options
	 * @type {object}
	 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
	                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
	                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
	 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
	                                    If not provided, a default id handler will be used.
	 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
	                                    If not provided, a default id handler will be used.
	                                    If set to false, then nothing will be reported.
	 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
	 */
	
	/**
	 * Creates an element resize detector instance.
	 * @public
	 * @param {Options?} options Optional global options object that will decide how this instance will work.
	 */
	module.exports = function(options) {
	    options = options || {};
	
	    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var idHandler;
	
	    if (options.idHandler) {
	        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
	        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
	        idHandler = {
	            get: function (element) { return options.idHandler.get(element, true); },
	            set: options.idHandler.set
	        };
	    } else {
	        var idGenerator = idGeneratorMaker();
	        var defaultIdHandler = idHandlerMaker({
	            idGenerator: idGenerator,
	            stateHandler: stateHandler
	        });
	        idHandler = defaultIdHandler;
	    }
	
	    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var reporter = options.reporter;
	
	    if(!reporter) {
	        //If options.reporter is false, then the reporter should be quiet.
	        var quiet = reporter === false;
	        reporter = reporterMaker(quiet);
	    }
	
	    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));
	
	    //Options to be used as default for the listenTo function.
	    var globalOptions = {};
	    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
	    globalOptions.debug         = !!getOption(options, "debug", false);
	
	    var eventListenerHandler    = listenerHandlerMaker(idHandler);
	    var elementUtils            = elementUtilsMaker({
	        stateHandler: stateHandler
	    });
	
	    //The detection strategy to be used.
	    var detectionStrategy;
	    var desiredStrategy = getOption(options, "strategy", "object");
	    var importantCssRules = getOption(options, "important", false);
	    var strategyOptions = {
	        reporter: reporter,
	        batchProcessor: batchProcessor,
	        stateHandler: stateHandler,
	        idHandler: idHandler,
	        important: importantCssRules
	    };
	
	    if(desiredStrategy === "scroll") {
	        if (browserDetector.isLegacyOpera()) {
	            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
	            desiredStrategy = "object";
	        } else if (browserDetector.isIE(9)) {
	            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
	            desiredStrategy = "object";
	        }
	    }
	
	    if(desiredStrategy === "scroll") {
	        detectionStrategy = scrollStrategyMaker(strategyOptions);
	    } else if(desiredStrategy === "object") {
	        detectionStrategy = objectStrategyMaker(strategyOptions);
	    } else {
	        throw new Error("Invalid strategy name: " + desiredStrategy);
	    }
	
	    //Calls can be made to listenTo with elements that are still being installed.
	    //Also, same elements can occur in the elements list in the listenTo function.
	    //With this map, the ready callbacks can be synchronized between the calls
	    //so that the ready callback can always be called when an element is ready - even if
	    //it wasn't installed from the function itself.
	    var onReadyCallbacks = {};
	
	    /**
	     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
	     * @public
	     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
	     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
	     * @param {function} listener The callback to be executed for each resize event for each element.
	     */
	    function listenTo(options, elements, listener) {
	        function onResizeCallback(element) {
	            var listeners = eventListenerHandler.get(element);
	            forEach(listeners, function callListenerProxy(listener) {
	                listener(element);
	            });
	        }
	
	        function addListener(callOnAdd, element, listener) {
	            eventListenerHandler.add(element, listener);
	
	            if(callOnAdd) {
	                listener(element);
	            }
	        }
	
	        //Options object may be omitted.
	        if(!listener) {
	            listener = elements;
	            elements = options;
	            options = {};
	        }
	
	        if(!elements) {
	            throw new Error("At least one element required.");
	        }
	
	        if(!listener) {
	            throw new Error("Listener required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        var elementsReady = 0;
	
	        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
	        var onReadyCallback = getOption(options, "onReady", function noop() {});
	        var debug = getOption(options, "debug", globalOptions.debug);
	
	        forEach(elements, function attachListenerToElement(element) {
	            if (!stateHandler.getState(element)) {
	                stateHandler.initState(element);
	                idHandler.set(element);
	            }
	
	            var id = idHandler.get(element);
	
	            debug && reporter.log("Attaching listener to element", id, element);
	
	            if(!elementUtils.isDetectable(element)) {
	                debug && reporter.log(id, "Not detectable.");
	                if(elementUtils.isBusy(element)) {
	                    debug && reporter.log(id, "System busy making it detectable");
	
	                    //The element is being prepared to be detectable. Do not make it detectable.
	                    //Just add the listener, because the element will soon be detectable.
	                    addListener(callOnAdd, element, listener);
	                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
	                    onReadyCallbacks[id].push(function onReady() {
	                        elementsReady++;
	
	                        if(elementsReady === elements.length) {
	                            onReadyCallback();
	                        }
	                    });
	                    return;
	                }
	
	                debug && reporter.log(id, "Making detectable...");
	                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
	                elementUtils.markBusy(element, true);
	                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
	                    debug && reporter.log(id, "onElementDetectable");
	
	                    if (stateHandler.getState(element)) {
	                        elementUtils.markAsDetectable(element);
	                        elementUtils.markBusy(element, false);
	                        detectionStrategy.addListener(element, onResizeCallback);
	                        addListener(callOnAdd, element, listener);
	
	                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
	                        // so that a resize event may be emitted.
	                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
	                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
	                        var state = stateHandler.getState(element);
	                        if (state && state.startSize) {
	                            var width = element.offsetWidth;
	                            var height = element.offsetHeight;
	                            if (state.startSize.width !== width || state.startSize.height !== height) {
	                                onResizeCallback(element);
	                            }
	                        }
	
	                        if(onReadyCallbacks[id]) {
	                            forEach(onReadyCallbacks[id], function(callback) {
	                                callback();
	                            });
	                        }
	                    } else {
	                        // The element has been unisntalled before being detectable.
	                        debug && reporter.log(id, "Element uninstalled before being detectable.");
	                    }
	
	                    delete onReadyCallbacks[id];
	
	                    elementsReady++;
	                    if(elementsReady === elements.length) {
	                        onReadyCallback();
	                    }
	                });
	            }
	
	            debug && reporter.log(id, "Already detecable, adding listener.");
	
	            //The element has been prepared to be detectable and is ready to be listened to.
	            addListener(callOnAdd, element, listener);
	            elementsReady++;
	        });
	
	        if(elementsReady === elements.length) {
	            onReadyCallback();
	        }
	    }
	
	    function uninstall(elements) {
	        if(!elements) {
	            return reporter.error("At least one element is required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        forEach(elements, function (element) {
	            eventListenerHandler.removeAllListeners(element);
	            detectionStrategy.uninstall(element);
	            stateHandler.cleanState(element);
	        });
	    }
	
	    function initDocument(targetDocument) {
	        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
	    }
	
	    return {
	        listenTo: listenTo,
	        removeListener: eventListenerHandler.removeListener,
	        removeAllListeners: eventListenerHandler.removeAllListeners,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var getState = options.stateHandler.getState;
	
	    /**
	     * Tells if the element has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is detectable or not.
	     */
	    function isDetectable(element) {
	        var state = getState(element);
	        return state && !!state.isDetectable;
	    }
	
	    /**
	     * Marks the element that it has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to mark.
	     */
	    function markAsDetectable(element) {
	        getState(element).isDetectable = true;
	    }
	
	    /**
	     * Tells if the element is busy or not.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is busy or not.
	     */
	    function isBusy(element) {
	        return !!getState(element).busy;
	    }
	
	    /**
	     * Marks the object is busy and should not be made detectable.
	     * @public
	     * @param {element} element The element to mark.
	     * @param {boolean} busy If the element is busy or not.
	     */
	    function markBusy(element, busy) {
	        getState(element).busy = !!busy;
	    }
	
	    return {
	        isDetectable: isDetectable,
	        markAsDetectable: markAsDetectable,
	        isBusy: isBusy,
	        markBusy: markBusy
	    };
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function() {
	    var idCount = 1;
	
	    /**
	     * Generates a new unique id in the context.
	     * @public
	     * @returns {number} A unique id in the context.
	     */
	    function generate() {
	        return idCount++;
	    }
	
	    return {
	        generate: generate
	    };
	};


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var idGenerator     = options.idGenerator;
	    var getState        = options.stateHandler.getState;
	
	    /**
	     * Gets the resize detector id of the element.
	     * @public
	     * @param {element} element The target element to get the id of.
	     * @returns {string|number|null} The id of the element. Null if it has no id.
	     */
	    function getId(element) {
	        var state = getState(element);
	
	        if (state && state.id !== undefined) {
	            return state.id;
	        }
	
	        return null;
	    }
	
	    /**
	     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
	     * @public
	     * @param {element} element The target element to set the id of.
	     * @returns {string|number|null} The id of the element.
	     */
	    function setId(element) {
	        var state = getState(element);
	
	        if (!state) {
	            throw new Error("setId required the element to have a resize detection state.");
	        }
	
	        var id = idGenerator.generate();
	
	        state.id = id;
	
	        return id;
	    }
	
	    return {
	        get: getId,
	        set: setId
	    };
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(idHandler) {
	    var eventListeners = {};
	
	    /**
	     * Gets all listeners for the given element.
	     * @public
	     * @param {element} element The element to get all listeners for.
	     * @returns All listeners for the given element.
	     */
	    function getListeners(element) {
	        var id = idHandler.get(element);
	
	        if (id === undefined) {
	            return [];
	        }
	
	        return eventListeners[id] || [];
	    }
	
	    /**
	     * Stores the given listener for the given element. Will not actually add the listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The callback that the element has added.
	     */
	    function addListener(element, listener) {
	        var id = idHandler.get(element);
	
	        if(!eventListeners[id]) {
	            eventListeners[id] = [];
	        }
	
	        eventListeners[id].push(listener);
	    }
	
	    function removeListener(element, listener) {
	        var listeners = getListeners(element);
	        for (var i = 0, len = listeners.length; i < len; ++i) {
	            if (listeners[i] === listener) {
	              listeners.splice(i, 1);
	              break;
	            }
	        }
	    }
	
	    function removeAllListeners(element) {
	      var listeners = getListeners(element);
	      if (!listeners) { return; }
	      listeners.length = 0;
	    }
	
	    return {
	        get: getListeners,
	        add: addListener,
	        removeListener: removeListener,
	        removeAllListeners: removeAllListeners
	    };
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	"use strict";
	
	/* global console: false */
	
	/**
	 * Reporter that handles the reporting of logs, warnings and errors.
	 * @public
	 * @param {boolean} quiet Tells if the reporter should be quiet or not.
	 */
	module.exports = function(quiet) {
	    function noop() {
	        //Does nothing.
	    }
	
	    var reporter = {
	        log: noop,
	        warn: noop,
	        error: noop
	    };
	
	    if(!quiet && window.console) {
	        var attachFunction = function(reporter, name) {
	            //The proxy is needed to be able to call the method with the console context,
	            //since we cannot use bind.
	            reporter[name] = function reporterProxy() {
	                var f = console[name];
	                if (f.apply) { //IE9 does not support console.log.apply :)
	                    f.apply(console, arguments);
	                } else {
	                    for (var i = 0; i < arguments.length; i++) {
	                        f(arguments[i]);
	                    }
	                }
	            };
	        };
	
	        attachFunction(reporter, "log");
	        attachFunction(reporter, "warn");
	        attachFunction(reporter, "error");
	    }
	
	    return reporter;
	};

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	"use strict";
	
	var prop = "_erd";
	
	function initState(element) {
	    element[prop] = {};
	    return getState(element);
	}
	
	function getState(element) {
	    return element[prop];
	}
	
	function cleanState(element) {
	    delete element[prop];
	}
	
	module.exports = {
	    initState: initState,
	    getState: getState,
	    cleanState: cleanState
	};


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(1543),
	    decode = __webpack_require__(1542);
	
	exports.decode = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level) {
	    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level) {
	    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
	
	exports.decodeXML = exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(341),
	    legacyMap = __webpack_require__(611),
	    xmlMap = __webpack_require__(342),
	    decodeCodePoint = __webpack_require__(489);
	
	var decodeXMLStrict = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|"),
	        replace = getReplacer(map);
	
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
	    var re = new RegExp("&(?:" + keys + ");", "g");
	
	    return function(str) {
	        return String(str).replace(re, replace);
	    };
	}
	
	var decodeHTML = (function() {
	    var legacy = Object.keys(legacyMap).sort(sorter);
	
	    var keys = Object.keys(entityMap).sort(sorter);
	
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        } else {
	            keys[i] += ";";
	        }
	    }
	
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	        replace = getReplacer(entityMap);
	
	    function replacer(str) {
	        if (str.substr(-1) !== ";") str += ";";
	        return replace(str);
	    }
	
	    //TODO consider creating a merged map
	    return function(str) {
	        return String(str).replace(re, replacer);
	    };
	})();
	
	function sorter(a, b) {
	    return a < b ? 1 : -1;
	}
	
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
	                return decodeCodePoint(parseInt(str.substr(3), 16));
	            }
	            return decodeCodePoint(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}
	
	module.exports = {
	    XML: decodeXMLStrict,
	    HTML: decodeHTML,
	    HTMLStrict: decodeHTMLStrict
	};


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(342)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(341)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function(inverse, name) {
	            inverse[obj[name]] = "&" + name + ";";
	            return inverse;
	        }, {});
	}
	
	function getInverseReplacer(inverse) {
	    var single = [],
	        multiple = [];
	
	    Object.keys(inverse).forEach(function(k) {
	        if (k.length === 1) {
	            single.push("\\" + k);
	        } else {
	            multiple.push(k);
	        }
	    });
	
	    //TODO add ranges
	    multiple.unshift("[" + single.join("") + "]");
	
	    return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c) {
	    return (
	        "&#x" +
	        c
	            .charCodeAt(0)
	            .toString(16)
	            .toUpperCase() +
	        ";"
	    );
	}
	
	function astralReplacer(c) {
	    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	    var high = c.charCodeAt(0);
	    var low = c.charCodeAt(1);
	    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
	    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re) {
	    function func(name) {
	        return inverse[name];
	    }
	
	    return function(data) {
	        return data
	            .replace(re, func)
	            .replace(re_astralSymbols, astralReplacer)
	            .replace(re_nonASCII, singleCharReplacer);
	    };
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data) {
	    return data
	        .replace(re_xmlChars, singleCharReplacer)
	        .replace(re_astralSymbols, astralReplacer)
	        .replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dfdff59d51d8e3882eb08985abe91b67.png";

/***/ }),
/* 1547 */
1546,
/* 1548 */
186,
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "358dce38613e93e0351fe4f6117f0a07.png";

/***/ }),
/* 1550 */
337,
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60496f7089c445520a97deb0a16dbca2.png";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "baf6137a797f267b6abe88c9b34a9e99.png";

/***/ }),
/* 1553 */
592,
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b636a4b4c2d8b718323b904c25d2b557.png";

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d538258a6e5d2e8b62063224e12ba619.png";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf62783152e8aa0e80ab347104c30b14.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dda9d67266d743fbc3cc935f85a1266d.gif";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "add0eb34eb37a0657d499cdeab810046.gif";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48adea598c5cb6866dee9620e06ad92d.png";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16daa2f9f7a116ae1df9f86977e233fd.png";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f0568ce2fb0066b453fdc8f23af1a6e1.png";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "29b0065adc088c2eadd65e415c84d988.png";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3cf2ff6545d5952b6d7122a6a81da4d8.png";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c8d0d3749b7d7dced865b5ce98ec8953.png";

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d39c7b6295a1ff7a9d2f7db9a13616f2.png";

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b4bad739f6ca0d06765b74a5801efd0e.png";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca5da1b9665f91ea60f9b02d9b114ea9.png";

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "430b9adf1d164cc421bd2d1c56c53f9c.png";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22d49512a0dfe1ba18fe47c65748aa2f.png";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af61f08492eb6fddfc66700066a9074b.png";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "159f495396696d16b19d72e3f9617af2.png";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e98c61cab19b0e0a3ff8de31efc5930.png";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "83914282230e296c843502d34f457328.png";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "016e483100ff926a4cb30bdab2c7ff84.png";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e4596ae242a871364ac575b7c07dd192.png";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87e46c1d666d4c3aaca7a597c51d6e9a.png";

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e498f0b0ab96d3e68f5892cb76897fd0.png";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "804bf87a58acd273ab7900bf54369b78.png";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da7524f5fb07d1df2e4e11011d79141e.png";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55c242aaa23ff30108991f2eada717ab.png";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a7a8599e617040e11deb7aff7a1794d3.png";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd61d84165e1717f8d8fd41debe0f322.png";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "149faf503e4f48cc347cef37bcca35ae.png";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "391ee3c4cba643f137c4315cd5044256.png";

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d09b3948af72c4ca1e8329ca07dff201.png";

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d98b712986ccede56c566525fec9a104.png";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "04d537b3344a37b5b7de71f2869d3857.png";

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fb0fb1518f94271fb6289534244a24b.png";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d0a52c74d789b731c60990bb845b3b0.png";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f16d06d9df109aec232ce99ff6559aba.png";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "075ecb22cc576928705d9d8a823f2e1e.png";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8bcd4ef47651fcf8c53fe7ae5ef0d4f2.png";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0b80eafe92fb9368db3afa1f558ea259.png";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ffc53aef733ae95215eea8bba704e2f1.png";

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c5623380642a412c4144914f2b302591.png";

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6817e3f4bdfda0f3f08a3dd90fe5011b.png";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14ce2f57a234011ff97deb368c8417a9.png";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7b366128ec45fbf4de2cdbe3998eec8.png";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "35d92744bbd8dca6fe7d3dc33df076c2.png";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d6cfb04ffb0bf00f18d6bc6439935d4.png";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81e8a10d173ed7c858204f9b84629f01.png";

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a640a5a1c43fb070befd037c0260080f.png";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4085ce2e77bfee59a522e7ec9f84d808.png";

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "19d39915cf90fff274340476b7b11645.png";

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e1b8c7fa7ad6693daa896857d4d9bf1.png";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17e49296d9351a5e2facc673e2a19f53.png";

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f04d56bb39e3c0cb384de856316c0b7b.png";

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a48ae63278dbc7b70ce9d446a13efc0f.png";

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fbc953e4ff249a9dd7d11b19d2c50ed7.png";

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3be49533fdb4b90eb62b8499b1f3588.png";

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d04dc2ced252e6df6dd48713c04e5d4.png";

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "965b10d605c1dab6cde2f9d689568d84.png";

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82ccdac9bc8fc5f86982412a063103bc.png";

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0890b8536f976d0288ace76db6cfae06.png";

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c97f4c4b699c92e6884d34a07e0b1c05.png";

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "155526fcd8084c539f586b5fdadd5526.png";

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55188eb6eb0293879f3784049efc64e5.png";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "976297ddf6a86ba03bebde91bd060774.png";

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d7af9e83f507eb4ba7ddfddb1c782b2.jpg";

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6bbcb382f68a1f28d679e12a8a33873e.png";

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "214c25a4b623b33764c62214020ef092.png";

/***/ }),
/* 1622 */
527,
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3373d964eac6615397e1154c438246f.png";

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "018958ca0c6f70c579e26a48416c9b83.png";

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "884e278b451159a83d73e5879d6600d5.png";

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "291c59a35d45e0c75aa11cabfe91d21f.gif";

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f874ce38e67ea9eba99d09efdbac3432.png";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2ed29706944a06532adf4f3608e4af0.png";

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bccca05f132278b70df0919aaf354620.png";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c00fcab9801127d28b055781cc3bdfdc.png";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4324c1552bc15e50832b7537bbe79163.png";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e87fa2e398915a512a777b52ece43062.png";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "49208e569aa0185cfe8d3aa4a8d35eb3.png";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1388239cb86df7506d58b5c71cffc873.png";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ef4abd601c008b63d6dc923edd897.png";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4161228396bb70e95f63b870aae21b86.png";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c39cbab3856ef3be61c1b417e4e3c125.png";

/***/ }),
/* 1638 */
551,
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ac59ecb50210571253763e88be1af95.png";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d01061633588578831ba834d2cf3ccd7.png";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fd94926e7164a8dd4bf55bfd11eda0a5.png";

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c64f37dae467728d8f7ea1c828e130f2.png";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6456f2593cb3b31be810f91b6ccdedc1.png";

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e63ab06fcbc28af7d6bc06e72a289c4.png";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6d5c8ed2c6aaf587b48744ada7686ac.png";

/***/ }),
/* 1646 */
529,
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f63993475e9a1ac6dc92c40da0ef933.png";

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc3e3dd371887063d75b25c21e2d190f.gif";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0151d08da1d2f6a86c85a233df9e9a71.gif";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c078a7d2935361052bc94e6fa455fb30.gif";

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0846a3b55f3c0446f5c2a8e86c30e665.png";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2be9daa37c1599ca585883acfc77f195.png";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7302d51fc149714f55898d23903235e9.png";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b89ca69ca916cb1e7b0aeb82c851445d.png";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "279bcd9fee7b2dd786e57d3340465495.png";

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "67d1f983e074ac3187642f7ac320b3ce.png";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52c8507a92eb88208eb938643173e900.png";

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fdad1fb5d8f89eaa0aa47cbc0f066367.png";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "562c26bbb8031bc2f0282b4aca3117a8.png";

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ccda389c3c33c1db6576d89eefec39df.png";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98dd327369fd974b73e085163d74449b.png";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2141f523739a1a0cfad326606d871840.png";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "066f1b36e8fd075b21c1d97889cc2ad5.png";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8057914872dd504b119a453e8c81e239.png";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0c4120ceee671f4dc2a7fe00375bcf7a.png";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8998387ad13b27a7aa71fe9762ad6111.png";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0636f8018aa4b76a27e994fa90dedec3.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48778d13ea2064f4b1877cd931caf905.png";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e54d913d34c36c5d09a02386df3aa84e.png";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "029d3fb7fe5d0768eda6a3e1bd073a80.png";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e50580171ea0388cb342c5c1c87c8ec8.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1d30d3b43cf8d9d48dc0ea775123932.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b64211512445cdf2dba6b40a89119f9.png";

/***/ }),
/* 1674 */
187,
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2bc610498e174229970a36e16ef4a243.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e8222954940cb40d6e8c4a05a0a3e7ff.png";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd4430cfbcd0eeb61f1129860e5348e5.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3642f8f6ea7f0d00a966d90bb441e848.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a10924ad120df40a8753a2d22946d6f0.png";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "181911e2d3f1dcb75f5f59e382a4f18f.png";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8b2e58cd3a9840eab9a89e300f2eaf0.png";

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "393db96df8cfb6bbb9d4b6052c59f5c1.png";

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a3ee07590a37863c19ecbdf74f96c5a.png";

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "370598a1ea77d7be9014609e154e7ca4.png";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32442424d86d7e36d7c19a88e8096a09.png";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbf1acd2ac1fbd258bddb7179e493035.png";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46e09e0395c5c19e7b3e1f94129240a3.png";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6958d35cd381d0d15683ed5735ac64e.png";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a11413bffa7c492b8ac45c715b40f35.png";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab651ab407a8824b38ed1e5fdc339ff1.png";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a98fab2c69891dd9eb37b1bca13dbec1.png";

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ecf27b6b3354f40a0733ee72fe49611.png";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41f772ce0f66e18a63cb9abdd6175b34.png";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff92cb44e3658c11f9e6d9691f789b6f.png";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81269987a1aa2f4eadc6d0b2d13e1540.png";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a712a9817600a94f400602513c42ffdf.png";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1c32b88fe87a37406226467c8a97f00c.png";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cced33086437636e4f0dda6a07e632c3.png";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e058528efd898b23def5fda677acb9e7.png";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aeffbfd69ae0d9f12603e0c0e491e70c.png";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e07058a7ed9542bee21b18874066bde6.png";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3226c145871a1e7b256d05e227fc9099.png";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d20e2b53ca0d7ed14eb673f0b2958efe.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "09e33040fe8231ba0b5f90e8c2c0fd79.png";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "adf3986ae2581c77421d7e01a8bb72b2.png";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "554f87d7afe4683cc59a066a25247958.png";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4aa4926b0b434153237038db2be68e85.png";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1679b58b4ab9066e5cb0cb925bcc00b8.png";

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a3103116f3068ec4f2d990df185ff63.png";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e8fcfff357181ae118cf7e5712546fe.png";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "151269a7036bc5f471cd285dc95e1aa5.png";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca5c8ab3217fa7a31c6e075a3dd023db.png";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f142c9265f4e9597dccaa585c3ce1269.png";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81952a5fc0c2d99f17819c146d992f1c.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34e7b47b4e882d78fb3669e7c1460502.png";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d6694509bd145ef1345068950476603.png";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab48d876869a0fca3cf228ce5d223331.png";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b32ad88d3b4430fadf32da6db2f146ab.png";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "422953aa4a5099d7496dc07664768208.png";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "91ce87791d0e3da6f5252609a59e707f.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "21d5ab16aa2d1346aad4128363fef978.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d77bd9f82ede02a72d9775c93b22cdea.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8321b3c5fc0752b140c703d24917084a.png";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df5aebee7d31872a6f6e87c2997f3785.png";

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "888c9c0b1bd73774324f5c617171e780.png";

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ed82e44342f15a5f9621ead31f3256a5.png";

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6daacca06a04b837db182ad2f8793b9f.png";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c59e9473630dd4ebec51c1e3aca18f8d.png";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65dd02baa669953b87671798e0a0ec88.png";

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a57c2f3634ec07ad89ccb458dd981e9b.png";

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab8f4db4b9ded430675738a636dbcfa1.png";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33af4321d874c8a893bd22252adb49b5.png";

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b621e84f2e2380ad2647f047b4f30ff9.png";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cecb0639aaea01321c2a512d55914213.png";

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d50d9a09f78be5f83ff3bfc5448e8569.png";

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fdd852f57393356bad7f52650ca05584.png";

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "acd312b483dda9cba360af08ac1bcac3.png";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff198a30fc9fc310b633256e35e1c9aa.png";

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1bc75aeb18b6ab929c875935a7446576.png";

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43f360b66617195675410e406f4ce231.png";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "685ab2db77cf1cf368e58be90cde275e.png";

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d77a9108859a24930aefe93fb9f606a.png";

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "459436b58de9f6cf28af9bb77e84d1da.png";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "612ce0de2613fec7fbaf88c9853f54fc.png";

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c25ca2e22132a517dd4f6bd43f56e5d2.png";

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad50063cf06625e57b119585ed337854.png";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18d7604dea329de82a22b8c2a727e216.png";

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a191682bbeef3539f9fe15a831a97f40.png";

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c27e9ebb35631753a1ec94015ba76514.png";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ed1fb4107d9dda397cdf55f78c18098.png";

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a55c5b929d1827d65c2bdb37350552bc.png";

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a304a8c3d45ab69ac04d22f8c7bfdfbf.png";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "248a41148f9962774d15d2ef181b8aeb.png";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab2468b27397cb554d476893e5551610.png";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8eeac42503c4bb3c57b64a2cb317f132.png";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "caac2edb947dfbf321372bdf2a635a43.png";

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17bbb88cd1bf654e25e971ea2158de95.png";

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3666b53eb7efd8541b4f5397f4e40caa.png";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7ad8883ba29dec89e7f23226bb4a4d56.png";

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abce57a42a55712fcd4c9855e8ae6811.png";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "127d8d8ba509c8206b89d09bba54ce18.png";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8356149ac70513da313116f7987314ff.png";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf85b0f399123fe8c3108f38c23c1f28.png";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "164ca2affd9fa9fc01d22937c9493894.png";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cd3f9512bdb9583725ed2574bebe36bf.png";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "73ea4a2fbfedc9730f2efecd962f5169.png";

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e9ae41f26dac6686aa14f6c7f0342bb5.png";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6853a0092ebae1ca26ed73781ae44427.png";

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "73fe5aafae0371c75e4e4fb4ecffd4e7.png";

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "115fa0a8862f4be7e92e12e1848c4794.png";

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fe1c20d58cd62c47ee68c7fb5fa7c00.png";

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ee9e79f6ab177986bc903a2a96c2603e.png";

/***/ }),
/* 1773 */
1746,
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b1b3789b84e2b1b2cd966bb7f2c3d42.png";

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8a7491755e1c78ac3e8cb0c75b115ac.png";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dad60f8e4adbe1ddf3be3ba72e4e5df6.png";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab4cba2e9303a157ab44138b9d897c2e.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8bc1f8138ebb78b6834088c4888b84f4.png";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "77f3e6e2c159a69a9dea208685a289d3.png";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e39ec90aeea62d286d4f9b67cb21767.png";

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc9985923e16efbf6b1a243acd34c10b.png";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "acbf111fea2f9e8709d9195813b30ef7.png";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "178827aac62c7e15e1f2dd1dd213d727.png";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b2613cab59df5e4ea0f26e003880ce79.png";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df4acc21f6df104e0531acae1b844e2f.png";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00ea231965e9abeeb557fe964aa4c2dc.png";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f0f6f8872825b1c0bf8f442011270db6.png";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf3d12cd419269cf13d5e527d36c24a8.png";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "770c3c20801061dce0cab0f3e702d390.png";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e4f8a6371e304a8add6b4bede5d1824a.png";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9db9cfefe750f52671b3214207ccdaa8.png";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33b225b35eef86565fd101fbd55b2ff4.png";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fcb2bfb30eddcfc51eb3bc97c5f1143c.png";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fae69c9841aaebe43661ae750d1db590.png";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b60abfe2f50f812c106d5f1ea71bb8d2.png";

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "db8c361a332c35d3fde5e737808cf1d2.png";

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb64114a3796bbfd98413d723c3f56f4.png";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4c3c8fb760068ea8f2fb720c6dd0bac.png";

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b4d91661e8c1ed340e5b50967faa7007.png";

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "346962cfe83ff4252c8f429a9b10edce.png";

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76b253366d6ff4d313da752984994fd9.png";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb16360a5b28704b02f635b6ceddc1ea.png";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "99dd386a6aed689cba8c725571f40d98.png";

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1954261351f3b33854926e2c7e90cf97.png";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "159de3ec5ada3e259ee07bb51981728b.png";

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea6f6bb53e40fc050402902da0982ac0.png";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1cde6d2127de36ff8f9628995b7a4d8c.png";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f6f423b5fd4b482a76d85db81015c65.png";

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d9c2b1bcfe73f3716d6eb1a19b725b5.png";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f0cbb52b63f3ab6c3ce558fbee5ef06.png";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2b8327ffc5d36771a63dc24d571ba60.png";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "391f82751029bedff54169e01fbf3f7d.png";

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d8462c3e8689b76840cd1a2d993ff77.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e2dd181a12d7562aa41023c458ac8c3.png";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a402443d37ca63b95c9f2c70f1a5716.png";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9dd28675da7a41aa2ab6360c60755a0f.png";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f1b04773541195a74c033a344441517.png";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6d7511d57e9acd53c7c7d81043e05b9.png";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87def88434e6e673a2c7f86db4eb180d.png";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9e65557aa9b3e08108513751cf161030.png";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fb6ef33f3d4e52127d7a8e39be03751a.png";

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "10f72f5e7f7eb9fb52e1a0ba902d6c6c.png";

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abb9410d186921efe33ba7ac080bb01b.png";

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "927740caf0f19e0d4b634896b2c7087a.png";

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8feeb84c56d104a93b3b3cf0949ace1e.png";

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b871edceee97a98deb993f619d33b05.png";

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00281aff08043f48de74581cbbb93890.png";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94d53b491c52f2f7b680947bd5d44085.png";

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "235cbe6e345a5cf927d029f4b071efb7.png";

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6f59a272d27aa142d5175b978ea0ced.png";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ad33766de1ff89cc7adda4470ddcdda.png";

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3432c14f6c345f56b5945c39fd6d7dec.png";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "72e3871e8a597c3e2e951fc6c5831e62.png";

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07bbed275ec28092130c015c3e82690b.png";

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4a20d3d2714b5101f1a603890c77d421.png";

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50c9df4833cd83c73f554b6db36b2ec9.png";

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab68ae1d8c85d67eaaf5dbdfd229de57.png";

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22a2c54dad3a53afa69152c29608a924.png";

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cad3fca45356c19b7069366b34a50d16.png";

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "853d607a6e6db6f149ae89d28c22b8ab.png";

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a4dba18cc3055f6fc2ae032df984aee.png";

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d4605387757ee962f68805ca7d52bc0.png";

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a0e677214200a3a9be595dbf9c75cacb.png";

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b4ac920c007e348c1865df90fda5c97.png";

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b69f3e4c860841e03922787ef4994241.png";

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc55a988cfe43c47251b565f89c0a4cf.png";

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "326c1e67a92cd975df025259e3b900d0.png";

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca6c2fba9fc579dcef2e43bd0d279fc1.png";

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "769065a57e51990bfc6efda98a281ee6.png";

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "770584846f1faf90a1d04f2a5ba82781.png";

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af1c87432b11073fe2fec3abcf618bf5.png";

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6546fb6b0f70ebffa69c7bb0b708eadd.png";

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "09565c7545e2618d43553ac053a814a6.png";

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b23c5010385e38052ae078d507c28e40.png";

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4f5215c046c775e0b3e4f5d1a339751.png";

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34df505128891a05e0ab23058c5c2c64.png";

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7cb87fa0ebdc0f23eaeac2e287be6f2b.png";

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7348d045037ede9e5514779600b61d0d.png";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6961d8455de2e247d2560d3e27e5bc9a.png";

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "344370bfdab946d90de6889f0f208c0c.png";

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab087cf6d197f507cf13f41215747242.png";

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3266bfc628bb022850d3f1950c5727e7.png";

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ee936d63baf99237466948e949a9744.png";

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a89cc8d3c398f3d1866708995455502d.png";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f1e1d4af5eb69948b74f3f4033cca7f7.png";

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "977be2b0630ea16eaa2fa01e05d8d0aa.png";

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8100fab69f6aebecd1e529b4a89777f6.png";

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0660b3a563cddf15dfad9bf27aa0cdcb.png";

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9a95285e0bcf8dfbc8acc2d4edb6436.png";

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "75e4812af1ef07b15b80ff84902b9400.png";

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3346dffdf8b168e71124b41a5a25d6c.png";

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0dee49e714968374e1f0b61d1f558775.png";

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a7655557b98a6688b914e2f3cb5dfb2c.png";

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51de1fc72b7fae5621b91d7e0f7d5a97.png";

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "370e3737e562ad9dbe1e8c3b9bb1e499.png";

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5ae835072e4f54ee188c2c4babd1367a.png";

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c88216c91c78258a39896a2e1eeaa99b.png";

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18a44e9ea1810dc8bc29bdf3669d74f0.png";

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "35381a45375047721dbaec4b68e49de3.png";

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "281fdc1ec5a18cf0b5ddd98846a7f34e.png";

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c27b37edc1119b2c50099eb60723afd.png";

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9098d922d7fa445449ca70446a9fbf8.png";

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20292c1222a907c437c3f2fc9abff274.png";

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48fd2e84aacee2b693d5f180d57c8a27.png";

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3dde85167abdab8907426c7c56e30c06.png";

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "10c5ce6d7b1e2ced341ad18422421cf7.png";

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b4d906162994c0f8ca7acdd76e88539.png";

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f25a09ccab16e53d9be573969cb87e61.png";

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a93d83253ff72965747bb919540b04c7.png";

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e9bdff98d40935435cea0a9096ed857e.png";

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a3932be303b1288e53f1bfded9aa58c.png";

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd0b1cdf615d96a062fddfcd3c14338f.png";

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe3e7487eb3489b15181306c566a1c0c.png";

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aea5869d65e34f6a626487d1553d0a2b.png";

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24dd6a222cafbf45b93288ce3844052f.png";

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c3881903ce7d7a946122fa37895b7b06.png";

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "516afa4db060eb313827b21c0b845d3b.png";

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "baace85b06307ae9282acaba1902db29.png";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "805ca87c6b932004c7a511ce87548df6.png";

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cab0f81406483ce1664966a685938fa6.png";

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e1bf5e067d468e945c50a417f821d51.png";

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f5d9f7273469c7bf24bfdb9fd263e8b.png";

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4a490b5f02cb9cac8fd9234ca648f5c.png";

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c89d027cd2b1ff40f93b5302336bc0c.png";

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1edcd54965e7231050cda33dbe71dc1e.png";

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3b3b0aa29342fe3654555be816ba859a.png";

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c0a5c48ca0abab155ca0845b9e29e47.png";

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ced4dc12a78ec487d4bbc3fbfc4b32e7.png";

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b19c5e9467049c3cc4f0c0f532b9899.png";

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48872c17188673dde9c728aa6d8f680e.png";

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a30401d8c81eac7c3fc43d871cde07b9.png";

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4692eae36a03ac06ebc1fd3ea4266857.png";

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16a0459756c8cf6f10d8f60aced47f71.png";

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "532846eff36d1cf2ee614946c0b4d861.png";

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7846c94432e9f2e48b98c464bcce0641.png";

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4cc601e7dd121ca745b70b565dad9463.png";

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "161908b58972ebecd3e57fc16ac8cb11.png";

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb0cb5a5d873ed02152b5633236362eb.png";

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aab31f476a5083c6c548bceaa5f2b9ec.png";

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d0e4c40a0f70b8f5c71c884cfda85bb.png";

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ac82d4ea15c2d5a7b310dc8e53b076d.png";

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb99ff90eaa7933babfd797bf6fce11a.png";

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51858a54c65684243d464234d3b40044.png";

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b7ac604117609b14e0eea5e19964e87.png";

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16cabe8b85a337879a78f6b51baeb423.png";

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aab4cfbfcb75f19f5a075362f0f8ba14.png";

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28bdca00652c297f41c953ffac707527.png";

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76835c8239deee32a5ad58b3e4bf06fc.png";

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b307a547893e96623f207a4117ee854.png";

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "780a22fa6cd831690595838371c1a6d4.png";

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f5c5c056d8a5131adc463c09252a663.png";

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3ba9a19d0531f25c3bf48742ef3d708.png";

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3595c763d06b51615f1217b3d0be5d4.png";

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "434f6b2ca23c68a517402aa60ef18491.png";

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b67d02d53b45d4b83e2417e1ce880979.png";

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd8871171c9024337b74e0fe7dd58dd6.png";

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d9c6d2bdef8a4a69e3f6ae4543c81cf.png";

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8942fe70ea69b19c420e5ef80a8c9463.png";

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc9402e4468091409e6470e026d155e3.png";

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a675ab122aede71d1c2a4e48ddd003f.png";

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "761d9208cf06bf32bc1470f2db174382.png";

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "377cb65753ecc01b035f69897425bcb3.png";

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f837229f42848ef23a40b05318f4426b.png";

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b69fc7ef6d4acbe612d709ce01c1c66.png";

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd4e04e6de5bdfe6a53faa8a171abf99.png";

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ce248b0a8e487b2f955f8387684b994c.png";

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "affab7b0e7f023049ad94fb828abdab0.png";

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "645893abe9a71b651c2a9c1f57b8bbd8.png";

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3a5e34153130f3293746cc8f401b4fb.png";

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ddfb4b264ddd2e9e87c4c2b8504c997e.png";

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "804ee7002c6139ecdbf0dd3f56c57b29.png";

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8e0636065fa9d21de8434ec88566b0fc.png";

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e49dc13a5aef69252afd35e56e3e4c2.png";

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "983d9e282119c71b1eed5af839a7c092.png";

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "365bcacd37e7c9429c4387e6e8d717bd.png";

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "adb067c51f3a786d5cd68b48a5ee2aab.png";

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17126c22f8a08b3f9a9b1fee92a59d05.png";

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f261c4709546c14b912d9e06b92090f1.png";

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e87d48c59b736582a7f05c6f7f68e71.png";

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2cd0d7d67bffa9fc8c52a1aab23f98fe.png";

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "739d1ec359e75310da447e9faa20af22.png";

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1731cc572076b6608eb27b08462acaf2.png";

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28da61ae6715dcdfa064c25cdc702b4e.png";

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "68ccec75635547c13e6bd40122b2b49e.png";

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a798b089058fa4d6e7c60ad5f1a22be.png";

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf1f27da07b16fed4eab0e6c35e92e5f.png";

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0c56ca4f5e93e8b10e010e49b840620.png";

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13126142cec99a01fa831adaef26f5e8.png";

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd149df1dfda2da9986f3ae2cd7f4a99.png";

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e92554f65cdce9b74da405cd30b2b3cc.png";

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e14cb48c8cb278cfa00487d1c99e46a6.png";

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c41495171d76fad62fa334e36229f3e0.png";

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a174a4150c524219503eb923b4a9bee.png";

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8450fdb64e742df71dca2895a53d4548.png";

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d59b7cb603c21eacf90291be5735f2d9.png";

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22dc58e3e9aa06488b307b1a58be2f23.png";

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aeb0c149651b6dd3379bdd9c7ab3c9d6.png";

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "623a27a542e54af20496076b929548dd.png";

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cef3832015f6f69d4ec258dfe6577657.png";

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7cbf52d15bb65c4e6ba66e2c2b83798e.png";

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "27aff81ecdbf72d35092c0e5d0b72a2d.png";

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f410ba5cb694d747a9454b6295df7f2e.png";

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f0c503765e5c8d852b1ec6d930cf29fa.png";

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "035aad10163d4723b7f62d21a2ec70b4.png";

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd5099f0f99568d4b1f1460ee154aca6.png";

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4437f8c4650c1107886704097166fcd7.png";

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1eac1f3a71340a586d75ab7d91da9d0a.png";

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "62d5b0887aa0ea7a8a3ec1bcc82a1b94.png";

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13e80be0336eab3f1ab67dc952fc4e45.png";

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b167d7f28bd707a74c8cdfd0222ffe76.png";

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2493780ba1ff60d643dba877b0df14df.png";

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6e6cb45ed992cbce778d170c62903202.png";

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f71600f276e98469c9d3229a56c7f5ed.png";

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6a190717fd41b5e489a5df7badbb5f1.png";

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c5f5a7bb2d0e07b1e69a80b75a0a1ca.png";

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5da2569bd2f3aabb605313c5de9be8e8.png";

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8a101766810d3791c42d7ecb1c8684e.png";

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0754d37e4340a2389e1dcba73dae6987.png";

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec27e8d9f838f3b66ac82375a176f281.png";

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b90a354bfa5a565c13bc0443d3d8cbfd.png";

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a602345170868f752e857352af0f4630.png";

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5413aa0f78ed82dc50daf0d7087d9154.png";

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "774e50c3dd64fd7f63a07d5d37f4d67f.png";

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "53610025d77a5d26a5cd130ed42f93ad.png";

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ae6636759001a887a018734bcf2a87a5.png";

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bcf9d742f775c18fcddbe975f601aedc.png";

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a43d207bb960dd929ee7c414f75f8053.png";

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d54e3f9ed25562af55fe19390fc05268.png";

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55620c3c0e076483584c0d5cc2511ae1.png";

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "410503d89c9b91465d7eb62fe8cd0a11.png";

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c66fe40b59ff9f22e5eb46503fe9b135.png";

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32297f97d424378ea25082a0aa5d3427.png";

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c2166dccd0a8eb1c34a30a8a83686a58.png";

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5b2855d7a11537edac6850973816182.png";

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "12029684d8dd60dd4594a5faab6f311a.png";

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a88dea2bc2eba97a940fe21e96a43d0.png";

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "258d0ffb2db51baa68b5573af6ba1a1e.png";

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa30ab5b3b988405a0b9347f17909eed.png";

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1801996a1845aff0ea25a894d9485eaa.png";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0eb2c9a98effc53c7fc4c7a1a991f38a.png";

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bff62724456dc6d9a4e7cc4604973c90.png";

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33bcff2bf383a59711363f0a1ee87320.png";

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe28c328ebaa29830e110e7b8a068da0.png";

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51e1509652ee07ffdc74a6553ec30854.png";

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01c4c12f94167a567a69a95606ae752a.png";

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "adc86e72fe398effa2369deb0409f676.png";

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "773e9dccccb778c1f80dadc987640940.png";

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b98b2ba13ca7f965fcf87427c3a5ab1b.png";

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d8fe57674a08d7ccdf4d29fc08b95a7.png";

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "beae73b15156b893950c82a1a2c38739.png";

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08460493e322c0dcbc213df79a8e70f7.png";

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa1bb46c4431bb7cf8d86c938a6353fc.png";

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3847224a806dc812dd4605da298d9512.png";

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d772f8b6bbc0b998997e856d8711c098.png";

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cd69c1e586e124162e0d145f96314dc2.png";

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a1e955fccb9e81e2ea2429988f575595.png";

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "88d6899fcd01aa8d2e6b0a32309311c2.png";

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e6ed536c4a23f54848a289cd22eb81d.png";

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65096beecacfaa44fcc7e7cd6bfadd7e.png";

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4159f54f8e8c52956252f7997f16e8e6.png";

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e8f1e1b6306f2b8067d812f310a771eb.png";

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbf212c6c737afd6c0deb1d96604d3d1.png";

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7795e27f3ea202f5fd762c525c9471d.png";

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "78ffc5ca39d2bdd640976df81659dd42.png";

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "138e596594e4a77e90ec379aa2d7243e.png";

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3715e4a4520b786391cdcf219ff5955.png";

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43025c401d52c251f1b0b944cfd837f1.png";

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e6d42b317a88d26f196f8195d499fcf5.png";

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14d24903c3be4a504dd14aa372b4f85f.png";

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d105e29fcf233fccff11f1b50b57abc8.png";

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37a2cd0146036fb94f17c03fc0aa6693.png";

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5f9028697fed81327fb9900e262a9796.png";

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e3e4cb7a30dbd0436a719d887a9b8e9.png";

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7dcbbedd9105a6fc3c357291d9f91dfe.png";

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea05f265d6e205b1fea43087299330a5.png";

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "25d5eea6458b22e727a5d4badf7f50c8.png";

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2956f60d27f2fc3a1335eb0611e32d60.png";

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8828005e78777dab61c0038d5a398d95.png";

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6e2499083fdb344cb1e3637599d7e20.png";

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3caeabb3fa37a584c680dd147c61d710.png";

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7ee69ed64a96aeb1744a6d6f3f4bfa6.png";

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e533862bb344bb7801139fb6b8aba1bf.png";

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3aec27ef1d1250be2e9b1c2cc466565.png";

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f63c34b13b4a665a2c0df61268314fe.png";

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9298f3c9fc31b7957e0cfc53690ea06d.png";

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18d6bed7aef8ddf7a9485259621b7515.png";

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f7b53506c68d35e1d331d4a29f89bb1.png";

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4755b516eec77070e741f1a518c492c3.png";

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff721305bec9c4c78883212679be4582.png";

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9fcb965c222db587018cac53c8e5379.png";

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56a8ea16ab3aee1850b7124214d1b2a9.png";

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "121198423c0eb235f03d36b5562e49ae.png";

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "daa4c6c22fb9047c8af53153cdf27c97.png";

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca00e8ce63dbf103b96113e08e31d8f9.png";

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7746e7abef0222ed39a52df50570ca7.png";

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "63710a994ce9f3238dabd05d7bc65517.png";

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97345d4ce497c8b9a2614870ff963609.png";

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bad1af5a9031d00fd4d5894d726df5a.png";

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "258a21c394d4dddc0ca76bb3385f4434.png";

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "856aa8c6efde95f3447746161f6ad577.png";

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c5e3481ad45abf5c4ddeeb65e3881dfa.png";

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e020a0b50219d206c3cf5620433b7919.png";

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "421ccd0ff471b1cca65a994005ed1186.png";

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d7bf50c553f496c1329589f7e1195af4.png";

/***/ }),
/* 2085 */
2058,
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c37897fd8bd59b2ca0669ddd295c9e58.png";

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ce6de835ac882df1be6c457fe751ea90.png";

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e933c6c3a6bb4417a80cd90f157ecda7.png";

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50be212ae4f1775ceff2e97fbdb0204b.png";

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6865d3d9cd63128f3642b714c1475a39.png";

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "135562f4fb386972eac76a21d9fe01e9.png";

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7472f4fd0d6e68953ef80b4dbb42d54d.png";

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0cff8741eaf1ecca0792aea296b3b0d6.png";

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9102ba65992c398772ac7a6cfb23a835.png";

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3289f7c0221002befbad921b0f154135.png";

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1827d93cc17b51c05ab63a035e586bb2.png";

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "595a4935f15b74d469b294d8d9a307e6.png";

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da6820a543d603d18ce32b3348dc30da.png";

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e93e6e803800973cd72efbcc5fd6f617.png";

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5dafaa5d5d3e0a765b7ae4b2295c9c6.png";

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9f2db6c540701515590bdfefd742ab21.png";

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be92a4d70bbd385d16dc6101a30813b5.png";

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcfac78a746ffc769775c369daa15115.png";

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24e3e989077a6d8be8b1a0dee8ea50bb.png";

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "25be5d5b16a42571bde5295351ca1370.png";

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7aa83501b82b6450124c3d15db63fbb2.png";

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f405d01cbed570c59eaeb3daeba2ad29.png";

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18f75af3c70d77e80e6e94dac88bb8fa.png";

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9bd4e83c393612b2648e38d7a78c7340.png";

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "92ec9f8cf4964092134ca240e7b20c95.png";

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5ee9d6fcc1e564d78d510c869447133c.png";

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b86b8f8d8fe356fd6669dbf6b360a448.png";

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eab178c247f42fc4cfa44eb3170668c0.png";

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a3d064b51f4b0a337c5934fd7d17950.png";

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6c9ee803832dbca2450d5c0d59b3d60.png";

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b479027a2f7426b09b143193909e2c40.png";

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "feafe7daa8a9503fcfa5e7835ea1f08d.png";

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7259d70c3f10615bb64ab74e8febe9bc.png";

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c7a8b247f9d448a6d9f315bbc2d0ab9.png";

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "86df4aee193b3206906c572773d348d1.png";

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d075e0fe12d641119b347496309feaa6.png";

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b287f3efb847dd0d6d4d43e1a9d6be9f.png";

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a7931e9d6d728f43f8ea1ca89663dc5c.png";

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "043808cfbb5fa961915ebb823ae65cdc.png";

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "007958303bb3068799eeb4c3c5550ce8.png";

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e4cd784c09d8fb0445e0716af5031556.png";

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4aff55ce83330d6f5d3ddc327bb87006.png";

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc3c0e70f027903f5d57e9c31391d11e.png";

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f87d741328bd3845f01d69c5cebf94ba.png";

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab8e47fa9f38b486932454f0b1c78c38.png";

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f5127d45377cc42d49fc0ad705c9900.png";

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f0f1bb12d26c1b9f26a74c0eb4a7628.png";

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43d115cc8f149fd4a0b9928a3314da23.png";

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4bbce871335ba3865c9be8f1bb07abf2.png";

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3f76fc74b5d61add3326f319ec2b575.png";

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "077698926e91b63445ef624695583cc4.png";

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "582a7c593488aa0dadac01e0c2665ac3.png";

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a53b8ed8090d3d72f3d10157653e633.png";

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87a87a42e95b2a464d920dc904f22852.png";

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4fdd0237c663acf01da7a6a70c6b87d0.png";

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97bd8bda14fd92a8191afa43ed71a48c.png";

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4cf7a2c98e88528c9ccaa274eb65a5e.png";

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ce394ea72ed4ae94a14f0ef6a7e31c07.png";

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bfda5ed4edb39e08103a5f3938f3b03a.png";

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df182bb043de4772afe2bf2ff718dc3b.png";

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8da36a67fd703d63978224f008ff7633.png";

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "436d184fb073e5ea5489e9a58095bbe2.png";

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "31b34f8e27ea75a67c61bea0b6ee4db0.png";

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1acd08d40d83bf27fe23d53494081b8d.png";

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "117d9899255a2618c0dbceef22b545fb.png";

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea7ad5c004a5fa199a527a2f154398d1.png";

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37f8b76a934293a57b9103bf404e0d03.png";

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f3e037b0833c0c91d74833da552bf3f.png";

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "853fff36b473d87ec30f1dc99632c2ca.png";

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3885c73cea0e1cc9e377966bbce1eb7b.png";

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "383f7a51f47ce8f83c3b1ce6202989c1.png";

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a93a00907e93c2b4195b80bd20ae197.png";

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ddcbef0ef3319b2473e7b1b92723042.png";

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9477ff6a0643b78a6d15939ba64ff75f.png";

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f8b0ad2f7730fa8ef9b024bae50e4f8d.png";

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e5d81ee8ae2a391f0d4a932db700b9d4.png";

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d6ec569621adcf960bed373bfedee40.png";

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba6f6ff1c3a53cbd5f856c63efe0ad54.png";

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46ea657bf37669a22c87fb4e70ba79d0.png";

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76cfd29c392148939655924691476202.png";

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c813eb94a991208ecabe7b4b9a273c13.png";

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01c4359d09ba1971f7dc23201bcfd7b7.png";

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "06018f63ce52c8c6da72be6d4fc6ef01.png";

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42f19c112a5f89288fbbcd1346defa52.png";

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6af90213e4aa61137accefd46956c8fe.png";

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d7d5c2b3ee9221de71355d49fcf98b62.png";

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cb794527a5eebf141f43bb28ecb9d45c.png";

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ddd7d2bc9e10594766609b42cb214ccd.png";

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97ae97b4075263af174c14661dcc7c59.png";

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9be9b07013ce770b4ded96eb69fbfbe.png";

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "412aaf5a3e0fff7c9c7207bf2fc610b3.png";

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5863fd422429409efe2e685f2fb6e6dd.png";

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1aef912b1ecda8b586475e2dea5f6bdb.png";

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a1f3ff9c477abe5d29b06a68390cf5f.png";

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f1006844712c8c96d5e1ac045c62192.png";

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "509e9484c0d888b7ae23f6f902f1690a.png";

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5b7de7f1af89c55c66a8d9179ca18d7.png";

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "de57294358905f890d52e397d62bc422.png";

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "954edc66831b030ee3c00c63baaaf998.png";

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bdaa5112cb11684713c6fa53fd782dee.png";

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f97b40b06276391a66d29b76bc34368.png";

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb4e529f3998a83266f025064997a21b.png";

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39486d376167935a50e0565471dea129.png";

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ad506c156dd1d8ba0a830fb78a57fbd.png";

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "11dbdea1a2d215ebf7c71d963d4b541c.png";

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a86126fcb74aec374fbee35842d2f9b6.png";

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e69be9252bfa1b74ca7c2bdf531ae46e.png";

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c16d10e8a40987ce03b1636c33b160cf.png";

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f4ccc64cce76dc14dd66633fdcce783.png";

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d18056f981a36013e00d1b49ab56c6aa.png";

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c5530672c291a58054395e4700cf73be.png";

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "654f147059d335de231b186fd23886dd.png";

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b37e7038c57ff54f2a3b5c59bde28ef2.png";

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c39ea8d91d6174e54204322a210885f6.png";

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "318b41ed23ffad0303dfd4944543184c.png";

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51636defa8bbb3e275bb37d6883a0850.png";

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c0ff8d75e3bd695c39348e699f9fec9.png";

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ef4f52ac138561d7f1f259adcdc7fca.png";

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "75bcd10bd62c36381a36c50fd834d0df.png";

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3f76c435773d41a917f841f10252bbb.png";

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4fb3c62c8c63949d621987df595911ec.png";

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3961414e7d4476627b03e11d8ff5ba78.png";

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3a30591c25bca3297b9d54f1ab10dba.png";

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad65a50811d095ab0fed83d9b2917555.png";

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d64f6c4c4f853fb0cd1fb44d8d84fabb.png";

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1003ce7af4933b1003244d8af9938ac1.png";

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e559e2cc88c7e949cabeefc806fb9e6.png";

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "78d55f3926a71569cbb424a4cd3a1426.png";

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56d82239def716ceb197f27770b57b75.png";

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1841b20d7cf33d0fc786a07e61892f6.png";

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "95c1b3a2a07e82aad964b1f8ed1ad663.png";

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8e1bd78aadd40d56fc7cdb9582f6b39.png";

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bad2a30f9003776d5acf8830bf0fc342.png";

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e43c113578ec1637337b5fae780f9528.png";

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22a7416cf308845a7b8c5431257cfc48.png";

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6586f1c47de1b22d794df2a520c4d97.png";

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "322387152b03dc6f69c4dbc9fa4e7769.png";

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "67700b6bb5be7e83a432224bcd16a4a0.png";

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7cea2dd00b31d4f9f51056cb7799212.png";

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f8becdee9daa9e6e79fe7e5e6e4fbef.png";

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "47e6838605e8848fe754aeb5ac9d9a7d.png";

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7811fe487ecc9a1c4a2251cf740fbe3.png";

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8b6a42a6efd77af288341d7523f16d0.png";

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eec93a8b3e5179d1e7c0a3ffe3caa7d6.png";

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6df8039aacee3cfd95dc1d62fb3cddec.png";

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ae136f98c6645488d80da437562ae6bc.png";

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "904672abf4bde6245f6fe2aceca6d3cb.png";

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ccf414fe456ab5b5ad554e337fd150e.png";

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d078da4bce02d8ecad1a1f8ba84bd64.png";

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42d877ce1c7ff5fd679576c87cd33d68.png";

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "843d434e9ca5fc75d6466ac06aaa7691.png";

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1729a08e0b531cf36b5904d863c1025.png";

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52280e55c43d49a6f2208b306a9181b2.png";

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e55db98e510ffdd990487e13ab0899d3.png";

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3b241932bf899741db7a6edbed9ff01.png";

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b84f9e561dce317ac46a60566d35fa2.png";

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97f3c47482c06ee5c32d1bfb38042873.png";

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5830d198b7d323633138c50439ca957d.png";

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ecf71e7cc8ce6ae580e0cba0771600a.png";

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c07e6eeb392ca6208b8f9d63ce6f680c.png";

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a57b6e46261c3c272e8d8727078a4a0.png";

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a94181159fb43f2108081efd5d886a8.png";

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8050a4697c44836d1ad209325244de85.png";

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c15813a9c48b75ab020a2468f206027.png";

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba6d464c9973fdb8794091f0f76283b8.png";

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0349fb951eac0e0e4afa360dfe3b6493.png";

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7c097155d4dff4160fe601aca2a6c319.png";

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43ec1e39170567983b1f3a8679e5e347.png";

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c08ef47ae8e014dcb965af32c49ab13.png";

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18b4ddcb9592937a7e235d3a415c55a2.png";

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e0ed7a99489333aa6d3243bda935cf4.png";

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3aa5f813f2da8a94cce0bb45bb5b04ca.png";

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "569f4a54a6daaf3fd1fa02f185d258a1.png";

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "009c8ef966d540733b2733ee4aada4e4.png";

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "635441f8865a5d2df6d62cb147659fcd.png";

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4d7e55168c1aef460fe74307d827ae2b.png";

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6f1a3853496ed7b3feb72d3142ffb714.png";

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc9a85070313070212ac0b1c50e90b88.png";

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e8afa68920b49e5b4afe84194c19a454.png";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7b49c627d31fc1b3d412a602deac8e5.png";

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8250310a5bfe319e2c1be13fb222997b.png";

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a52b01abcbbc808aa244040a68ca412e.png";

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b1cb180abe3e74508c79c07896340a97.png";

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aad08f594e066a08bb1ecb951984a2ac.png";

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a06bec87869cb9da277a66563681a5d.png";

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea46c7668641234b1513c93883d4ad58.png";

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b4064f1feed24116a2897d2ece25cbcf.png";

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "10164f6d41e999d9bff511d1fad2828d.png";

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dab4316ec405fc7a623aa7fc501c5040.png";

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e9e80b0eec3521c960ce47338956d4e.png";

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ddc17d6d059a586f9807c05eb102c6d1.png";

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7317be16d79e6fafe7901c73954a019d.png";

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1799ea5087931cd435833f1c4d23a350.png";

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e117d9529ec8562094e5413b70c7687d.png";

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf048894a34744abc0f40e867a3e0781.png";

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad2e1a2fad1c8d9a02279d5da25cdd8c.png";

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82e7d8f28a8ed7e640ab2a35a4b9c0d9.png";

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1336aeb8a05f57114111a38e3835be81.png";

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b09bad71bfe739a139c9e5af8929e835.png";

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0b25ca4c86c6656c4f21e06905b3cc7f.png";

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e5737136aa5846d2f0f939aa6c8191c0.png";

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "90d75c785a865f27d18046dfdd190b5f.png";

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6162afdd525b711b60c3ffb4762c588c.png";

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c6f80a7fec584326fd66f82396c0a9c.png";

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f445f3b64cbea3a48dce622abc7b6d1.png";

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f2f6eaa56317ada57de9dd2e1b700d9.png";

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e06c0b7611aa7df771aa968846e2ee64.png";

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f5870c7e483b5bf3e8f1457c03eca45.png";

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e543b492e48e5560f6f6e87cf14747ae.png";

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e094848999cedda180dc16da38c70846.png";

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cfadb3ce94967b2d061189da5ae75073.png";

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca355f1c96d88db039d0d24cdfef8a5c.png";

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1be62af9752eaf40bca2961efca4b876.png";

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "53c23b2d029cc72b99870bd59ff4ca36.png";

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "778579c515f734d57244ab432b9c58f1.png";

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b1ecb55796b9beb0e1af6c1278f6b7a.png";

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9e905ababec97025f212658266adae5.png";

/***/ }),
/* 2303 */
2276,
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9079eef0f46026093f16095a76e3f364.png";

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f57e2766dfbd4eae5d6937ace33be78e.png";

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5450e83047435db8b0ca11da9a723373.png";

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d59dab6817cadbbc4ae022fd92247429.png";

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b824e64463bf3c9fbeb34ebe3acd22fc.png";

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6803cf186f22bba9acb3e39a963881fd.png";

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb5254487d388c05b3aa2e5b614ec558.png";

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f8142f04743af125d8d8f75a22169a90.png";

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f80e21e5c65e44f2da6ab861e9d31d7.png";

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7af5a4e1b20a0349096cce854eb5e2b0.png";

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a8d332195feed67e327f1bc04b5bbd8.png";

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8810fdfd6560345f96f6d4997a740c63.png";

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "deae8992a942ac31e2e23167f2be6e4b.png";

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "945e55c712a997636b7ecb1526b05cfd.png";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2896ac70813ca9e4768ab8a727f25c47.png";

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97253d40b590438b54cadeaa948fbd79.png";

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7e301051cadd2dcbfb945f803636d440.png";

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6e2f4dcb984a74f9205156214fa999bf.png";

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "520c3fa60f826ff2d046efec002e39f2.png";

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b300a9716a82896bfa39c735b001609b.png";

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c6559f0922fafc0d0e79945d3bf7bcf1.png";

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "348d8a4e5ee03ee36cc64b21b718afce.png";

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "748c1395b4de0519a279cb1891435eda.png";

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85f93cce95b8e82ac25694609efd17bc.png";

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4a8decef111b562883ba755fe0c6a26.png";

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84a805150ff19f55a13224f3460d895b.png";

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6959fb12c52c01b9b6e3cd8f526d0cc.png";

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "787e78dac31a221389618c928cb15570.png";

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a39ab3240dfb2faf69b7508f40c00e35.png";

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "02fa0f896af721aab671e9deaa34a84f.png";

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c5cae3a262c933983c987a21e75300e.png";

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "427d914108ce4d0cca3c84733fa6ee43.png";

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb3c8666a15ade8ee08255bb88518234.png";

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "487e9785b66e13cd44fa88569f350eec.png";

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "295a78fb15893331a2a2d1db212e0649.png";

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "68616cd10604b31ff11b97aa14895c33.png";

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9e1b6d07386650d932194865f8c1ef4.png";

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f88540af9b084b8da7be3d2b68342eca.png";

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d08fc5009993edcc81b9cd6c541276e7.png";

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60d314b1c059149dd36a9a5d2a35b734.png";

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4acff15898df7a32851b004e312a817b.png";

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e05c1812fc718452213e64d37e4d1692.png";

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a0684a9c39f8cdfd43f01fdff484539.png";

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cecaeb808be30169b36cbd5f33f97c2c.png";

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8d40c4c4ebc7ec3b5842fcbdee116e14.png";

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a540f4b6abd823f8746ef9178990a285.png";

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70653b4674843410bb392be280c87b2b.png";

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7865012ebe5cf5ab6b7cb1dccc997eef.png";

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8e43072eb98c2ef04bf4907cc591e265.png";

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "386184e8f8a1af56df647182d605a150.png";

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "63fcc6d14e247635b0c4f615b0b823ad.png";

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f649c961be1cc4de38aa6dee180b0b9a.png";

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d1e308048e6b560436d1f25d56abb202.png";

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4015e9137d9a60565fd90561d274f7d3.png";

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a7e2fe654029e7ae419391f6e63ee4a.png";

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8d37b1a76ba8fa77690bbce3351c720d.png";

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "77861caaafb63075d2b56ea30d74a660.png";

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6efa80b5bbe13d861d153c44b4092bed.png";

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46b235a30c507ea29cf464f3dae87856.png";

/***/ }),
/* 2363 */
2329,
/* 2364 */
2330,
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1455661b98dc884046f2d5845effd181.png";

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec6d38920ca19d995576a9bf10069b56.png";

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd621e8925229b71e8964568c3ae7008.png";

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3b66044b39899307ec3c98d4afeea517.png";

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0aeb95ca37d0ef8dc1b26fc8506a90de.png";

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3e355997552612c1567c68f250e6820.png";

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94ea3733cac36593c8b7aa5c72baa051.png";

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "223c5caeb97e8dda8c69b10a5789dbba.png";

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3282dc7145ac02b9c3c03bdf61f601f8.png";

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "68bf68e731aa43969a12aa231dcc63d8.png";

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b3795ac8a11c1be4bf019ef102eb194.png";

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8424c467167faaca2c16f437784a5498.png";

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf862c3fd4ae1023ba106fbbf3eec68a.png";

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "accaa8ab806e97523fe3a0cd5392be63.png";

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a05c8a38e365f2aa9673f3faf95adaa5.png";

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "703495604d10c4a34e573292958c98c3.png";

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a48fa2703332d68cbf85769fa6671a13.png";

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e2fb7f79a2d4db66be9bb1a37564386.png";

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aba4b415095d265d909e4f26ce33b18f.png";

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6f8771b73910016aad70d99f5f0511f.png";

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54eac6c6567c093f6c69e106594ca0d5.png";

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f90176c5dda5cba521e5a87fa269464.png";

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6194068a248886221755df2512bff4d0.png";

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8552bf2dbdc9882f943e041206494928.png";

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5015b96e9e2e9eac7bb810df85615f8e.png";

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "90d26058a3a05efd461f4f9b8623e512.png";

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ee2c01e251eef5f54a83b047bb5362ba.png";

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "05a96a21a51c7e8a9a27d9aa592b3b38.png";

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e918988edfc2f18e83d4b29aed0c3b4e.png";

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "26745b127b494013728cf8406769327d.png";

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c745c4e004e92bf6ea6edcce7f681766.png";

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "046b6e4d78bc84f577f6da5352ae8854.png";

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8943e6b019d5b622fddc504690bb7f3a.png";

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d47967c43d357cf79a5953b4587f860.png";

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1a4083663e9761908c7aeea5c52a98e6.png";

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69a862e51868e21502fa05828b73fed0.png";

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c44c53d4ce24571a3aef977fa7a02392.png";

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d335bdd926ca7472b0e1e5dd655513e6.png";

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "63f1a52efa0c41a601a560b7a5a2e222.png";

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "024f548738dd491f757a4287d9ec771a.png";

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3aac39fcc745c5922c3230353b74d991.png";

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "874560e797948d2d919a658538151b9c.png";

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5863f90d123fe626afa1d1a4b4453261.png";

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c2fedbbb656249bd791372553f577622.png";

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37f344e43627650cb10e1f499d1fb090.png";

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dfb457e13711f0996286e5a9bc8e1ed5.png";

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c12a18212d865d24711d8bbeb2ecd345.png";

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85f4e95c9dfdb8932c4fb29193cf372e.png";

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b57dfc1c4db414cf36e2fe1ac92e4d17.png";

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8f22b99655e1fd7e6efcba3145a3c8f.png";

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be95f935ee67025f70d6dd95ca2f3ba1.png";

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fed274b424bc19fdac30d83b94c8e9a0.png";

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4018d5fb8bbc6808ea8fd4e2092d3903.png";

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee994a0201f9f481908ef93d33c3286.png";

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3b2af543c3e93d40c4b246ee16bd0eff.png";

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98df57f053d6ec4a7c0b666fb332a7b1.png";

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28e4d47d7d125922411a8ff4809eb0e7.png";

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7a57842af772d9ca81e1ada4a769373.png";

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "212b05a8b4371791789c1831da8775ab.png";

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d7ae84c0142af6502343de494e326942.png";

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df63d21a74696de2998e9caa93ebad20.png";

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa806d8f6259a6329f1c446f6647aeb7.png";

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3be71172ac287b2118d00704a61d52ec.png";

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df94b3e8923309f5ecf0ffb82aebfdc4.png";

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d870da0b93f7dcfab85d2765bf89d2c.png";

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "06cbb004da4a6c7c154e482e3f3930df.png";

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a7b669327180eb3a42065b045da24c20.png";

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0b6f45af0421b9e42d073dd04f8a26b7.png";

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f8f62ba6bf9724200587100dfd64c715.png";

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4fd9d1eaecfbc928580d19f3803094a7.png";

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3095b8e06819a6a81522754075d28a6e.png";

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a90329a49f0b1eba3cc0466f6d8a9d0.png";

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01dc2e3e4118e18b0ac08c03c67da614.png";

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9fd2f3be7d419f4b1c791578ae02605.png";

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "671a1fb4fdd17a74f030633523cf68e6.png";

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5367f8394542e3fcbac9e0852e85ffe3.png";

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "258e0ebaffe64fd48eaf6f119b57956d.png";

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a9eec98af2af2048a4b44cc82af04f0.png";

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "47910de4313c0ad9847794bfad5e7efe.png";

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e39c62682c537dbcac99c88f401583d.png";

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70d0d90f5e323ea2a6a7fdf85174bf87.png";

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6dbff40a013fca32c2b51b97afeb2c68.png";

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28c02a568fe701b89538b85ca4b6ecbf.png";

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5919b0ce6a123706853bd065825fcbf5.png";

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ec4937636959ad1d3cc307e531616cc.png";

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c6153bd376a31edb844ad0e10819fd7.png";

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b2caa686b14da302d8cb221771bb448.png";

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ad7ee12fc655e82a0bfd263c622deb3.png";

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "86399ebd581d5493edbb5aa6aa5bfa1e.png";

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa68d325e402f985611689067cff3856.png";

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e676601848164834ee2f13b6d082fae1.png";

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "73bac18d830947c08f14566bdcfa49ac.png";

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54166f742bf8e077890a194809a94df5.png";

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f0caa5b20c2dc6c0ab211ba89a612d2.png";

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "664ee6786b6e728c7e6a47039805ef85.png";

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "29b4a0abfab2baababfc5c3ac28b7b81.png";

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "137771fdf81f7788641d67e7ebe387e9.png";

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "53bf532c612135308792e1035f27efb2.png";

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "53c8f6df6103bfc5f2212544359e3868.png";

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "61088911474ab40150c37f4767a7a94c.png";

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "566b3d66e82cf0fa2a757af5b2d56283.png";

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4b32e93b0c986f984d54c35611695349.png";

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9727a084e1a32aeded3a738c81a54578.png";

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab175e712fb6502dfc4dd454a7048d43.png";

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c794f4b25c70da37f74a3113c325a02b.png";

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d22edecd731e370fb080507048c7fa45.png";

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abe00fb12d591e4ea637037fbcb104c5.png";

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55462b36451ee17b070a44f55989ddd5.png";

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fd03c3e725888efd37221947f187e4d.png";

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "31fcff85f9654619b5399b93cf529819.png";

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "86b519da6721b33b6117668cc8923c06.png";

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c43834b0c83ec066b8f152ba662a784.png";

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "739c7d03ae6de27e1bc4791fe009e468.png";

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59fac015094e3c9a3eacf181551b3ace.png";

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0311f4b4784d49d4aedba4373d3a9a0e.png";

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "382c57748f88c4c34e88eb218829e03d.png";

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6cb99f940bb3b4968a931848f573b907.png";

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "05030481be12e1f478ce51f38cd5e41f.png";

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bd8ab6b81d0417558355d959e9ef55d.png";

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "99a39d375138d654ad91bb58668dbe43.png";

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b66c94f1c1c6374e38d6486cf78f2eaf.png";

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b646ee4325718a8ab6ac3cd5489882c7.png";

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "31db1602c945ce0b418c3b641f2bec88.png";

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6e3a01fe54c151c79713ea054c5f6e56.png";

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "285d06609e99981e0f76dfc5baaa55d4.png";

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6073a632e2e222e357bf8bac7f0aac1.png";

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "25be3089db04d933515295887dddeddf.png";

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28f7d4ec8f43c85bdcb0e610696730f6.png";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14786f97d1d19fc188a0893f2c6a48be.png";

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "64e30c076079d3114a2f3874b6a9c5d2.png";

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5017c243325f7a5aa8479b3441977c10.png";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcee1ce14b5c5dd4d9b1a8975a4a6ce5.png";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "826e79fdfeeb38b38f508a22108b127f.png";

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5ac65ef16cd71436a8b28a6fc2625ca.png";

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b47d974247b4e587b9f2ec2551899900.png";

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6adbe2dd89d004cdcf7601e46aa44e13.png";

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ee37accecd67d0227cb71ca6fde15e6.png";

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4fbac3b5895072134646107d1551b5c0.png";

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "095681d10316f02c8b6efa3c605f2adf.png";

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "997ef7638a0709d952e1d8402c164a3b.png";

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9a8dbb7da0b09e311c3a33db8fa44ab.png";

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b40f44c6f2d10077d434011b04e1ca5e.png";

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41cff383b02b9e641ea24075d0d9b166.png";

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a6f5f8e1a20a3074803f6ced6a5bd30.png";

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76097df6ae39c324518b5d77a39af946.png";

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc9c1aab9535c4cfa5da9a171bb7eed0.png";

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fecbef38b4553137685054e037b95c0e.png";

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "375dbc71142eec273a6f93f75ebfbf70.png";

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82841a321decc868f76ec08746034d0b.png";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54f0337b83806fcc0a2b4af359d92683.png";

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a05e5af3d2f7d13b35023685fa358cb1.png";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "257ab8481e3dc7b0b182873e61e94f38.png";

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cd8b06c648aa1271e560dd901c64ee14.png";

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "749f968f44bc3c9525f8c57ee5f34d44.png";

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07c9f62ea2424860b29a5bfc3ac21fd5.png";

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5342ac09313896ff8302f497eb3144d7.png";

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bcaa3b3e3a1e89caf9b614c7f223db30.png";

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0432119a47503ae21ebce9e2141bd805.png";

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6f20e269bde8cbd2479561cfd5488d52.png";

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be5322b31548869d6973f6fad855dca4.png";

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "452ab8fb90f66192c390d963b338641f.png";

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c7aa698f9d5661914edebb42c46315e.png";

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8dfde9be220eb9f688220e10aec04c05.png";

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "47bcf513cce8dc77e6a424287df74954.png";

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ffe1c19bd5a92906204430ffd828bdb4.png";

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f0394045f72944d7a692328b851f506.png";

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe394e457485738a38556b4d05778dd5.png";

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a406bd9a3403eccd2d0f954c0958413d.png";

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e924b8913e96783632f7d918989ecfe.png";

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a98d1e35258db0f748a41d4003255f8a.png";

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "194b79201ca2cb5d6a3ec64d139bc4e1.png";

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c10a4cec417b94ccd22317d3d8d9ac4e.png";

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7afce22b66eb1440da5c79499ffba3b.png";

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a70574fc869c1ab633d245d8ad2a69db.png";

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13277db992f6416b569907df96db00d8.png";

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69974609996c59c81a87b97af16529b4.png";

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4b3701ac38e2f6dc6db38fbd37b2351b.png";

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "adca41f546297f2f7392f34c649f7270.png";

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5ad1c660106bbd7805f991abf57f9d8e.png";

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e475794a2fe1253d2d9365eebf7f95b.png";

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39902ce0eb1d016b4ccc1851a4bc0c2a.png";

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "288535709fe2eb1804ed8b2aa5190d02.png";

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f65dd73e5340867ec1dab7492dcc80aa.png";

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c1e75b50d0ca70165e26094b9c04a77e.png";

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "300509399938d6d61ac6c03e6cd70f90.png";

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f32805eb878bdb190e3e63a45ab09c15.png";

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d33dad74f1660243f19e2263200da37.png";

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aecb1b653f6d1ea3ee8d2b3e394a1d00.png";

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d91cb0f132177a2bd260a32c8ececcd.png";

/***/ }),
/* 2554 */
2490,
/* 2555 */
2491,
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f38eb08778de62628763372262834383.png";

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f8499d00c4ed54a38e78e95b1bbec4ab.png";

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbba9b5cb7d1ccb7818032e6e5681ac0.png";

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cff2e59855afbc6e9560939af4987aec.png";

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d72d78c130d984e77a23afe86ae8fe77.png";

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42e75496f850fe35df772c92447601b6.png";

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf22f2a99541701870356f370199e49c.png";

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe311e2c4cd18901a1124f333044aafd.png";

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b5838c0bf2fd2114dac1bd4ec4abc860.png";

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6f76650e6d8008adb1a4c085938d150.png";

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "14ccd366749aa86937c5c561bdec21e9.png";

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f97da6d458722b30e6c91259707c4b8c.png";

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "86f890a78cda325d7d11946383d762df.png";

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c9859df721718e8e3764dfcc302e390.png";

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "edd67b787dfa0792e9e2c8b16c43c543.png";

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0470afed4e06119d71d8bb22a6e74aef.png";

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6a240eb97d56cef8ae2f49372691687.png";

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82ceebeae05b1e4adf05973e4bd7d6cb.png";

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ffa10bd247f0760ecfe5b2d0a7c24891.png";

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "426d05021efefb65e5361d47bf1e59b2.png";

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4b959742ccebddc6bb3715ab65c76e5a.png";

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "640bb447d9d15ef086a454fcf840a595.png";

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fc1e815a313f6e16726ccfb69c14af05.png";

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d821e7fdd86a54c4e9a6041265654f65.png";

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b09849f22488ffa87d3e1bbdb5a7e442.png";

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e501fdbab242a9e8dcc220566c82518.png";

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3ca044849f9eb9998128d2b0eb31a61a.png";

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8994dd252eb1758c0aada1dc6435d3e.png";

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1a366a72a98d540653e95080a2d7e2ac.png";

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "823a75f7ba4a7e02b8a562f6eb31c029.png";

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b914709691601e363c1958449867a486.png";

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5d033c6a1940235f0432699c9bdb30c.png";

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f348add5704264dd602b6c8ac515c8c6.png";

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa354581d39a1eb0a24da01fcb1515f3.png";

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e325e9f7584e1dc286f4f50413ada6a2.png";

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59c9f538d7be41f09009d34c4e082c9f.png";

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b75900b94b280742c7aa212dc0b8f5a8.png";

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e3d4a2aa7be8d3bd8adc2e9bad10da0.png";

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "75b1109d75f099583b835d4b113bbfcb.png";

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3cd5818efc0064bdda5f22089a154833.png";

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8e693de80e52c3b4adbe819621608d13.png";

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39c8e30f966da852f2f7f4285702d892.png";

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ece25d68206965bedda120322c99776.png";

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a2eba3ba4373054a4f4c826105e9998.png";

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd5985e1ef1b66fff5ee7ea34d07fd2e.png";

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48f8498408f94c40422fd38af0d9f0f5.png";

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9600def2dd6eebfccd8a7805db386262.png";

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0adb7e3403a487648fd00b4fe69a674.png";

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8177e5fcc61e98c65c99de678837917.png";

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24c2312606f23de3c86e9e40294e5f40.png";

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9dc7e106702e79e15549624f11005ed3.png";

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b486480205846a73a710a4add86652a7.png";

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ebddec8df3de750a2c5366f18a4528f.png";

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2111c08f5ddd8c818a4e4a7afd69fa69.png";

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52627c7b844cb65e7e80a8a01d1031e8.png";

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a845b3ac9afa60ac7923a87b2f2d995.png";

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4859c90632363192cd360c48aa54954a.png";

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "759e6f652c0c19075d1502f5714ed2b2.png";

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f4fc74ba8c68c146331a4e4c58a06bf.png";

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1cf71bbcd1b93891ca126c0594d986e0.png";

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fe6dee90ed14d2086f5dfeb83f3ae272.png";

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c40eac6836c53daef055d219c9c8becd.png";

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "821e154131d16766a9ab8a89926e53ce.png";

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c358bd4c36e4abd3d6f56586da2c8436.png";

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3f2cac9bc9f4d4b40c12387f0fc9f6a.png";

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "23f492a287981beb4bd2b07ee52b884f.png";

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1910537f323312c90b3c281eae22df40.png";

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ae8d1d45e1bb0e0531ee1a930ebcac50.png";

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84130d886972151bc3b658fd1bbb740b.png";

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13db92ce63008c45e46679bb87d4abaa.png";

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bc9b7d147a78aec6788ec765f9eed7e.png";

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb3403aec691f36856946452c5f470af.png";

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1d3d50349e5382a20702a1ebc518760.png";

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08ad4d7e40604d5c934501dc6720bdb9.png";

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "178557bc7b8990962b2c9cddb3705eab.png";

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "161a30b1d193366abab8f810db4ec6f5.png";

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5077d222300d31fbb9d29dfbb0b04e66.png";

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3c2eaea4228f8e223d3e92151137a71.png";

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56bc58d4b8cc4bccc931f7667f7185e8.png";

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3221eaee8ea4a4a110899743aef3a61a.png";

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89854948047f7d6832a2dfcd14948e06.png";

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f881fd1f654891d9885ece26405df7d0.png";

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6e1ade20925014f03b121fffe8dda57d.png";

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37980905e855660d04d4225b93693801.png";

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3ac84471191870a0299b4414a1aa1b34.png";

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ebe288c668ea3be1aa9e287613cc6ac8.png";

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d7400f7b0cbd507430e85c7357ab8a9.png";

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01c8060544bc82f3c6316e5ff0d6cee0.png";

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d2db822a52d2576f0c984a7b534d023.png";

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fd81d9009262b0bdc333da84edc226b3.png";

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5cd48c56e132e78b67c60526ee0430bd.png";

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2721dc1494dcd9e50fa3135574253334.png";

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a348b16b2cb32c8018263c108c7e8660.png";

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82779f8ee1e9aeac33eccf5a1e790aab.png";

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcc18554e63c81140e3f36a7a3bf94b2.png";

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89a0c137330aea2eb97d54016d4f3920.png";

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc20ca6ff5aecd6a50053171c7fac18a.png";

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d50b7d6ab048fb2695c6a86f9aef552.png";

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96849c9a9a6685ea0fe5ad8f83618ee7.png";

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "49b2229183810681bdfced742b579886.png";

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "438d6f391bf5fde340acbc06519d1450.png";

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4370721c654fe60d78cc13e374a5024e.png";

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "927a441de15bcede13d95fc12217836d.png";

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d119180bab796c5e702d1e099d4a7d7a.png";

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "22f427cbd3a9c35c22c90c9748a7775c.png";

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b470ec460f69ade939c5db2656d3184.png";

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b16236f4aa307ab0096107113e146474.png";

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ace8ffda34b7a2825b0014be241a5b40.png";

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff93e648291c70cc4e528ed98b43ae94.png";

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b216a6c2902685805f909c836661248b.png";

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b211d17420cd9661c4f107e5f8348d2c.png";

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "acc7fdc06690e8389cdecfbf31fafb2a.png";

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "88c69a0ae668592ebfc5d189f4370169.png";

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ed87586be8175f965a7e819360ea97a1.png";

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "93792441316838cd5b67931cab110c9e.png";

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24c11b98899bac00923118d9ed47a4fa.png";

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9d745970ab37b825c2b135ce4e2f9c1.png";

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81aeef4cd7546f72f6236c06e5da03b0.png";

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "441c90290a48c2d9a074c8474ef989ce.png";

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cd7480fe54e239abc4ce3c3c88cab838.png";

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2bff76ac3bca85c1863a9a024fa3ad2e.png";

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "764cd4e6bca69c7bad0afc8e8e138eb9.png";

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "475f30565ccf86541669371a629cbba4.png";

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1697301e8933269b22281bbcea87fbf4.png";

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "733f9cebdd254c4928201e50ba92664b.png";

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43c745b15202129d760996a716497d74.png";

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3cf3e6b8fcd98bd670c5b3a390585c05.png";

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f335a4bf274844f674e96734b5adb77c.png";

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c0e306f57dd7d5cc5013f048af3c3ae.png";

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a78e14d3ffd812968fd5bb273b14622.png";

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "80f82b14a704cab6e7f808ad0b468cc2.png";

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6b4f005f25142fb82b12175b17e26e4a.png";

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0d4e5a215813c421b7913b5459c66da.png";

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7b688df3fe54322e6a2cd7a50e68d0c.png";

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b4234b49cbb2a09b544a58d7dab1f08.png";

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "91bdd4c94b6a46896ef6161bf84ab077.png";

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0aa2d7c726eb523de75244904fec1ed3.png";

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52138d0096996c2033a5e1cc882eb321.png";

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "45ef5e7b27905f8d0510d496e3a32be5.png";

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "985d5ddf042a88959bd0ba8fa392dd8c.png";

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d4bf240e4299f79ebe37f2c100e96d0.png";

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d70d31d5deb295f1e5b0fb76d4a23edc.png";

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a91fdc2028e4aeb074daeeead07236c.png";

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6162d93217ff6751a2b86992ad7d2e7f.png";

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07f5fabf6ceeb6cae46f65ace435b5d4.png";

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b5ca799686ba62161519464f9a32ea2.png";

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "12e3597df050664c6aa4f5d76557841a.png";

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51baa2692a7bbcd3023dbe7f58a8586a.png";

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a2c7b2f968bdd0a3a388e4a0ba60a0e.png";

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41639087f3bd1ded8436ff9891f8a960.png";

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e3e543cbfe1bb40d2405bb3ae194d9c.png";

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3dda7c321a5fc7fd95f028d96278af6.png";

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d1a48e527f61dc8aff0f9ba61869d2e.png";

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69fb769b3712a93be9ad557ad237b7d8.png";

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e5781620820201f5f3ab198373eca556.png";

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "738e096f9532f0b31551f40627bb83e2.png";

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "928538b5da4f7820c7eaffbf1580a3e8.png";

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c578146ff5e017d6bdc68c744f375e1.png";

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ee91a29d84d6e3c6bc04e969d1a43b2.png";

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca3e6b495083c12b09884173f60accc8.png";

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97eb0d330dfda97a4d73d1ab9d81ccf0.png";

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7f585caa95a0294e33cbc855db3c77b.png";

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5469241aaf99345a0a3ac2d9f4d71165.png";

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f865b2f87aee47d3a97181582ac878eb.png";

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8359406b40472a5dce434b09492ed3fa.png";

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6380c332706d7c828da7edf9eb07d26b.png";

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ca43287764f1125321afa997c50f3303.png";

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1ec92b0642143aceb7b042811e4d0f1c.png";

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "60468db9ef8ce24f66fc43125d65f0d2.png";

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1b468a9d022b4c4e39daefcb23ea06a5.png";

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c6e65654566383e0f466cea5f708b27.png";

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbc539ed4e4aa38e233bbe8ac26c43a6.png";

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2fed82fc255870cc7c1b2df73efff9f9.png";

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "821b4198fe7570dbff26769e8c29219f.png";

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf73506836febb4d9401849c2903de71.png";

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "04df54b9044b4b023be2a8f0a4d27f23.png";

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "58d2e8a989502324cc27744155ca1988.png";

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b5693471fb99caac3649208cec94e1c.png";

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34db3d872f08b1dd7553a7ffbfc3f199.png";

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52e1c23e317135dcc552e3d22f61f0f9.png";

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "09fd20329a241fbc1c0db9cf07c9bad4.png";

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6567d6fc2679af736b8ea1944cf0ddc4.png";

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ab213ac0042b7dad459e60ab713e086.png";

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be73238bb061e442ac61980557597435.png";

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "deb9a60ff271f3fc44d2c16468a969f2.png";

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e682e10fb4d86a6bd4681e20662db1d3.png";

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "93cfd8a488b55e8271a78fb3d0b8f7c8.png";

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c6b5e3aa428dab93eabaf552642b2c61.png";

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39e493d5302ccfacba1697a2f52f25ab.png";

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fcee91a77f1677c1827aeb9c0dacf04a.png";

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "15bf8d7ba38c09ca1f75f7125b18b620.png";

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "79b90bba200a564a63febd6a4b5384f3.png";

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c3785b533dd98e77f68ecae936635aa5.png";

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c63a6f5619fbf9db04fcd679f2a014c.png";

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b448890ddeeb6d2b6ac90e0f4443e912.png";

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1c12ffda4bc16054e1e246f48bfcee06.png";

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "de2728dd49bce4aea40a58fda9756372.png";

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "58fa95f7f5e1c08267c1c8f97403b99d.png";

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aec82b74fa1e9a7acd6a29b0c15679a6.png";

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07f55772ab2cf1d2c1559e70521e2b12.png";

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c71d77ea5b259927dd175be674af7542.png";

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ce459ae1b8fea2453901a3618066486.png";

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be0230d15b163a3b17b2c0d8f2074cfe.png";

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "779b8ed82f31ba864b478281ad518382.png";

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0cf09c0dfc69796bb1ec666bd98b1a3.png";

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d92238e761e89d034c5bb0661d94b18.png";

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46bf394bf74cfed4ecea5571d7202358.png";

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b750c5ee368d06f470efb6c6c20bb28e.png";

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87682f1c27d4b4be9ea0a892724e9aac.png";

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48cb21fec6a503240b13d60f9d79c5f6.png";

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "45661fd89ac351825afb4b61faf95b89.png";

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "19ed8397f3b06c26df8baa6c0e692bd0.png";

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b3fd015c91ba62566e72ac1ce976f3d.png";

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff1b101f71796902f3015ac14e665c72.png";

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1fa7017d8f3f206ded055b1ff5221fb.png";

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c3ab17cda7131d0e0fb719c99ea0061b.png";

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d5be176615812617ca64f01c069a4c81.png";

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82830839d6cf3f048185167b9f3ef32e.png";

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea5ed58f858bee68df2481737384b3ce.png";

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7530ea8168bcfca913c14a9666d3d783.png";

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20f6c6b1382410d1792404cc1e5cc0fd.png";

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fea50278cc998e6a6ed7c4da5906bee7.png";

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "604af6c53871854670c932a75642821c.png";

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d2d10e53875b393b1acb0052b90cf08.png";

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "032b93d302485f0c98d2e205da257562.png";

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "19fa845255e69a898e63000deadc6d1f.png";

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "677d2fc8a38d22db60b65510565be7d3.png";

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "83db7eebc648800c235be4ea4d6d5766.png";

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4a27a4b9266d954a308e4a64dc4664ad.png";

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "36df05afcf3ca2e5046868c7348adb81.png";

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87f672e801b9bce1ea2204649a772764.png";

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "047ee29f4be8ed7d2077d767fde5c281.png";

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "998bf875faaa9330f2e13e6710d22ecf.png";

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "80bd7c8620249fbcf6ffc90cc7c82009.png";

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d3272691bcd05aecf5d3028edcd6d8b3.png";

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f080113971226dac11ef1d23ab28a6aa.png";

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e35b1ef229dd73986573511074297cd.png";

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fcee1b88096db6b89d08fe86a711612.png";

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a6389d8eb87a8940a1050e8ec56e2c83.png";

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3094988f9a64f362cc49f4129e469a58.png";

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af36852e239313f02f728a60120b791c.png";

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "befcc2e76327ba68a94754e34f3a7bee.png";

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "689d7c67231bea596884a2e7bf9ab14f.png";

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9e3f0f16d67d571bb886ea7bd00b4705.png";

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1646fa876da76eb831a7b1a7895d5c05.png";

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8d69e5d7b46ade01f1d8493dcdc5be99.png";

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "66dd448f2f59e799d683c68ee971604c.png";

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4351ec0b14cbcf57e70c85d72dd034e4.png";

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bc333ea9469b1e3e5ea47245b8f3dffd.png";

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd7e36b8e1e0f959ee986fc990cf519a.png";

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e94d0311ec09f4c5512fa74773292fbe.png";

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5f453f4bbfc61848a486aeaf4c18e9cc.png";

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7688be75dd5473f1f52d16e9599903e0.png";

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37bb2fc6e90b95ba89795386d5856533.png";

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b58cac0162acd86203d2670f928fe15b.png";

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6c6ed22db17d506d8fa997d5ae7988b.png";

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "025d6716ba42edc16ebbfd1b0c571709.png";

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4e6784ea60289ba5232d69b114cb213.png";

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f368af58763888283641b8ebf0f71bef.png";

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "520586c6596810ccdd1aa6207287d914.png";

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b037216ee2f79248a081d3ccf7e8f0cc.png";

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "946e6bc1f9ae275bdc8ceb6d608243e8.png";

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f948a19c21399daeaf60823dece49a2e.png";

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5823819bdf318e17cc8e2e84be15fa01.png";

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5f24eebff66724721fa11a2012395db2.png";

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "66aa5abf9697a7618de9be8aa50e3bf9.png";

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af1ff3af4337d5e531e40440e0c6a1c0.png";

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "667fb9593cda3547097eaad91bb8b9ff.png";

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3cc927affcf60fce3dad7a05bf368ae.png";

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2189dd9e56b2024e338e867a3817cc09.png";

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c8373819524cb1fea4937e4ac82f254.png";

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "902cade2d1ab330a6d4fb7ce67f15c3e.png";

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c28ba89cb7bae3fde63118fa1ed862c5.png";

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af6977f4e0df69e1ec84a6c86253ab37.png";

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "034875746f635d011e77e6adc81e174c.png";

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3296cdcd1ce4c030b6618390d6dabe26.png";

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b02121aead40a45744e19f8c1aac2210.png";

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a5764ea70cc7ccbc0ae9913d41c68b9.png";

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c4d647d7e56784d2e1e2f0966ee672d.png";

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b13697c95a6f519b523c5569582c9535.png";

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "858f31e7fc6ab829b1d7d4d0d4e4ad86.png";

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e2865f1ac59fc660ce9ad52d592d0683.png";

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2cff76c98857e71cf87e07fe66554f0.png";

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32cfacd4c70e8efeb64051d1d09807a5.png";

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "10de3d014b77216e1e16ad0e0e07de7e.png";

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "95377e3a404385f477f2d3a8a6d8ec92.png";

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbcba4837efd126fe1c793044ebe6c72.png";

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ceddd5ac435a211eb00cdae2f67e60e4.png";

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9267f5027af7df7ea3be6cd62d5a598e.png";

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "95273cca29693cae74fd719932cb7751.png";

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a38aba3a039bdf39d4d52b530441b000.png";

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98dd589ca87bd6ed069db1740fcd0704.png";

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea575d355603ac8f207da77a38798232.png";

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a79171044606eeaf2e7af4e749a1228.png";

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "856e1fc50b2eab92332de1b56143a349.png";

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "999809e13b25381eafe4e6ddae4d3850.png";

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "153da1f116515b73c5f2ae8a30fb90ed.png";

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4bf36516252f325691d3253ff5c49ea.png";

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7cea3ea1546416bee85d0ba7b3d519cd.png";

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba34f32cd18a4a343280855059ea990a.png";

/***/ }),
/* 2856 */
2824,
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c55c2fd3bd15246eb61e6972f72ea828.png";

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a5fffb35e61c01bb6ebc447097d27738.png";

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1adbcddd47ee033aeab8f498a2208932.png";

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6524ee8e4b4ab17a5a9d46988c4a91b7.png";

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6fb1ba5c097e1ea275f298bb4ed61b79.png";

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9194324dbeb62e23db99e4932049b15.png";

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fea227bd1c7fd2d9453c1891b3a5b70.png";

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da7a70f46a9de915c25210b66a159dc1.png";

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c8400057ff537529dc40ad622ac5dc5.png";

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "18b95684fbbf35be53d478743dba82cb.png";

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa2a2b388ad8211f97612b975d6949b2.png";

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ea63ed43a35f15c6abfa866d06ba9aa.png";

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad43b5ec855ddd90237b16c78dce471a.png";

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f36ab3fdc8e2eb40c0bd6916f25526f.png";

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9fb6cc932972abdb9dd43320f8cadef8.png";

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cd0ef6b527e4a8ec16bf4f64979975fa.png";

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4858b5b4d10aab72b56f5e42f61acbed.png";

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8db001836890e4ab18e00c87b1e506a9.png";

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70f916453b2069e94821c0701abd7187.png";

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f33be1b165c49be34e8591671e8a2357.png";

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98334fcaa404c0eb8b223bc7507584d0.png";

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f789f7398d776cb7757a3155b13d8af.png";

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c0fbbfa077ac0ebb0ef9fca8d47f0d16.png";

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "562278e2f7360b7e60e819b27b5535eb.png";

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da55a57521d136ba8ca1e597264fb825.png";

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bcd4a68b019e956c70d3695f138be09f.png";

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e0cf399f72f13c316b02d3ded5c74e1.png";

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a5483a5f2dd4549617f3131234a08be1.png";

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1373d4ec7fdd4b409729ecad1abc16d1.png";

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6af31e501298e4500312576a543ffdff.png";

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17cc8bde1420bd13ee00463ed346e682.png";

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abd7111d7a3871d7621f720784699448.png";

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c360eebfc6d28d56c39258fbca88df6.png";

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a832a502c58584ea288fd4bd03c2fbca.png";

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e51bf1a3113c9cfd90a6662a2d50617a.png";

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37c5e1f3b83d53e2e0358311c655f12b.png";

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fbba87fbf0a95dcf7390d7d34135e9c5.png";

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "92854582a956f594a07ca07b58d6281c.png";

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e5b5d415de21994a1f09674e34cfd64e.png";

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96f1765b4f2fcddbea0074c1ad4ef849.png";

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5158e9d51a5d214ad9aa96b196e172fa.png";

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b2d02058a5130da62454624353e85dd2.png";

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "722fddde98ce8d68e3d50cd0a7b3dd8e.png";

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a756608aa15b18c870019f328e93b4f4.png";

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "286c197c14854eec41020a01eb96d78d.png";

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bfd85f52010ee32908a016907d3df20.png";

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "88f2193ba6748f0081265e6186d3776e.png";

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1507046e94a96a70b455b99ffefbed3f.png";

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ce09a2dfa196f00a66cb071d8cc0fe1a.png";

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "675338d711455c424e7146c828960c90.png";

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f1d1c9314b3716818e3a0ef44b067c26.png";

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69f722de9dc7c58c29b419bd2a05679f.png";

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "470c0cc8f3a543c120d47c2ec378c057.png";

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "685285309a3aba61d764826e2722c151.png";

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c99a18c1d8d117249ac850d10f1c8c3c.png";

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07680754702abc4e1b47905a0d182ef1.png";

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7382d5b98eeb31509551b90ee649d33.png";

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e416af986aa63ad55cc2d5591772f98.png";

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "102040461d0f54e2c5351d6667d0176b.png";

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c6bae67f72402b104bcbbae1c4e6e9c7.png";

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "923be44ccb2b268ee5960ab3478f5604.png";

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5ad6503d34ee6941281f3ab5c3ba8774.png";

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e80d58ff824ecb0d9c593162995df69c.png";

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a09763afa0b8d61bd334eda895e08c19.png";

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c70d09bf9b1d42a6d94d311c7aa1033.png";

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84ef5235f0069f48faa5347d83bad5b2.png";

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3351ff8f8141afc23be3e9152caef1bd.png";

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7ecef941ed8b446e2efb9b4e275e1a4c.png";

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a61c401844c1de5c3538e6e260b1a531.png";

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "243b0355484e82c88d156b9b3bea1e24.png";

/***/ }),
/* 2927 */
2899,
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7ab4ce0d74c1366fa99b6ed8eba60bf5.png";

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7f1ef2cb27d9e696dea3517040db8b4b.png";

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "612edd020d6ad61ebccffeefd62eb81f.png";

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "385ce3bd47412e6f8aed9ab2903957e4.png";

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59857ea3d42632470aec1a39ef2f4bc2.png";

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d95e0efdefa8fa0fb355209dc0bfbeb9.png";

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13f5e5025260f19ee3eef9c3810649b6.png";

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d69cea220c6e9b8a97d33c0e66b5854b.png";

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7af12d1201ece3f50fe57952ca96333c.png";

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f88ae9aef056480749e30280229cb3d.png";

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba229db0793a696054596258082fb83c.png";

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48c526b3303c6f41ca4680a3910e23b5.png";

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d56cb18fe3da6173a850e568998cab98.png";

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcc5b47f0edff6b614a2e0f5b0f8208a.png";

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6680615d766be600b89f5fe3c578755a.png";

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b68c4fb69e0df78867e278e85549da47.png";

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8968446270d017c9668bd8bf4a2af59c.png";

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3153140e55dcabe39c0e752d8fb77c4a.png";

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d05f169f8ba77fdd77a2b30d8180bc5.png";

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d064bd1e2e909f806dfe3e37d4f91dd.png";

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dd843f55303e17b31d1c710b311bfa0c.png";

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "84f1bd49030e046b47d51c7dc34611df.png";

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb183ffc578af856f733784a28b0aa7d.png";

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e3e7be029c2c8080b7f3a5d1bdb8950c.png";

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ba874a9f94abe2526cbe13b9611e341.png";

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dbef3bd9d57cad029f2954cc8e3cf103.png";

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ad4b184dcfcf1248a6aeed1feee108f.png";

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "465f6cd3cfa3e518b7036e4d9307e0a5.png";

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bd10bf4e026e0a054ea950785b067336.png";

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70fa69f1a79311ea931f5a139beb7ff0.png";

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f77a7e873b962b5221f09a8f15262a7.png";

/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f71549ef1a7b196fc0848b1ad527c751.png";

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a5729721280f8f2da78f83120cc508a.png";

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d77246f061083a1d761e2e890acb6172.png";

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9e17a850383dbc146287b7c101e2f2d.png";

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc149190e3c4f2b8c929ec2eaa3772a3.png";

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1570d87a724f49070ec60f254b9e8374.png";

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33ebe5d747ffa1929178fa2216630935.png";

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cba963607c66364869a09e398a34783c.png";

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "229212bc6a36c72b5e110b0f94d64fd9.png";

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6b1c96fb4f80603fa0e68d7c5032ca95.png";

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6d7351cd165ed7fb766cd6603c9add1.png";

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43c1fa0cf2797dfc31a799ff1c3bd16b.png";

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ffe2f2c0cda540a768a38396de64ae9.png";

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec156f9c448058d7268a093a8c3c6c61.png";

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f4cda70180ae2dd9f0c106d6da2b508.png";

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3bbb61bbed381429dbb7c41d0cc33e2c.png";

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d60c1d6a64d91dd8cb78439bdf6aaaa.png";

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4633c2c624d615ec975bc9396ab31dd6.png";

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "edc868a598bce7a8b845c030762eb4ce.png";

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "401f798cf77c440fcd00c5d547a144a2.png";

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c548ec19d4c05a5e2e712c6081b73687.png";

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a30fa07d8d4813210e47812ce38a9001.png";

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ec9caaadcac5f1e1f54bd630ebbbfc0.png";

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e2f453341a5ea65700393104126e3e6.png";

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32b0994c48278ef1af1465e6999d0770.png";

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ccbf30a7f9e8e271b5ecee2245fe31c.png";

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "efb4d20132982438279fcd0d9a8b49f8.png";

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e7370af0b885ed8fcbb91cc2c6a62794.png";

/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52db4a22899d6a3caf989c1c52ddd5ce.png";

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ba6bb6dd1c52557a282eeb0e03bd1f4a.png";

/***/ }),
/* 2989 */
2962,
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c12c446988bea7c8199750b1fa21ff59.png";

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3573c125ccff32e41e30520ef3a0ffe5.png";

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "362a6b5bc094aaba049555732ee33f4a.png";

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5bead4fd60263f2a0b4f4bc2e9dde7e9.png";

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8cabf1be11fdde95fb75411d0a9326aa.png";

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "44bc206d5d57b24a36b48b79a490639c.png";

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a1359d0c636b71532e76832d144dcc9.png";

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1fa9bde26bf9384cc42d97ace3bca023.png";

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "884249f5e2b20fed1f3f71c78fcb218d.png";

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3b31184894467681c189b3b62fc9ab39.png";

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "80f08dbd899784f047d8481c26fed6e8.png";

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c50677ca0f77b3bcff0aadc25a393d29.png";

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ede06df70b81e95d94c2e66bfaf020f3.png";

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7a0aece36089a516fb3992aad90b5fe.png";

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d15636f64435ee987d093983a721787.png";

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f6a72f4405b86cc35a4d12351ddc54b.png";

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf202695ca1efb133bc5a96c7e65fbcf.png";

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96a024e5360dd535e0c4f4e660f3aeb4.png";

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "664ea82e36e23ade921a48bb10562da6.png";

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a57e99ad019a426badfc13f43f42402d.png";

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "acc386cdada74cda61942761b83d7b8e.png";

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7dc889a3849b6ba4b09a046284a40c1b.png";

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fb08027f00961e77e7531e28d6e1eef4.png";

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7dd44e572c13a278929364aea4ab14f.png";

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e21eb8b03f4781d1e9b916f497cbab64.png";

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c44cc65d0aefd6c04a3304108f08bab.png";

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f1c85073813fd7af2472965ff075278b.png";

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f714f3e8b6a0d7141d9ee4d6374c2d8.png";

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e3425a001d0720b0b1a6ba27011638a.png";

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7a5de118e6ea4302741bcebcdadb2e28.png";

/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e04d9d5fc168eddc11dbf66fa55b3c3.png";

/***/ }),
/* 3021 */
2994,
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08876f412c30edacdd29d0f60cb9ec2b.png";

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcf8618502c27f956d2649e39acd5762.png";

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab2b7bd79ffacbc3fc204ea6623152ab.png";

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b02cf00ca66243b7512c959c52d3f69.png";

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9805c57794b16277e8eac120f16684cf.png";

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "259219f1b0541a8eb4fbfa8d3ff90cc9.png";

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aea0057cd0e49213aacf91d2b3fd6b28.png";

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c3c142ccfdf1f2be0d844f6aaec3112.png";

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a76fe021a4040b370538d3139b24970.png";

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7fe4d1ac6a8c15a752f03044e5e6af07.png";

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "efb453e0643ab818a6bff96d52c56942.png";

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "69567ea587e87cdf883fe2aa36529685.png";

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e93f9dd66626c96033df846ac5e71e92.png";

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6dbc8d1e49d30c0db476ac9ebea4e2b8.png";

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a2c89791e8e61ee1e5b9cd3ad97a22f.png";

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "434d3dc2ca60466e946748ffb262deb0.png";

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0268ad268547bda9bb0d2da9d27b8bf3.png";

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "75e022067313b6f8e977d960b0e2c070.png";

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "641d28c4eca3692ea55c8872e4befc19.png";

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "21d7f362532ffcf0806d71e72c20723b.png";

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "38fa6dd75ab2e0fe9345aa2101354b5a.png";

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bfa591dd3a8b39e0a9f7c4db42419c02.png";

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fecd8c6c8ba7cb51a01b5be9a9629058.png";

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da6a1540a0e44d13102a5f2ab868eed8.png";

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3602daf18f89f0f17c48d3c9ba42fa42.png";

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "958179e899fdf81b47c6c46b851c5960.png";

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41727a423af915f0cca3c3fa746779f8.png";

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b04969a2f383342d969355e8e1a8a92.png";

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "30de147296c8876f3a53363a157752f9.png";

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ed8205e4ed0d49cc36662191b78ed9af.png";

/***/ }),
/* 3052 */
3025,
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16de314b9a4abdc0dcf4aca9c4fb6e5b.png";

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5118d65fc16760a7f89242c95469cdb7.png";

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7c4056584a477c16baf6ccda91110a0e.png";

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "21b046fb64a1366066b678f300e266fc.png";

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3bf00960d1f46ecb04d9c0660b12e3e8.png";

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "044bab7e91b0fe2010cef20dccd0a676.png";

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3ec11520e8835e338ccec02eb5c1722.png";

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d7e839223583b8cec543d319bdcef4f.png";

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "88588190828e5888d1b92b4e388e53d2.png";

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56524edafaca1f2e43c3a2a33cd1bc03.png";

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "03d3c2c64daa1655909a91e3dad9378f.png";

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d084baa878fdb03888175acd74456eb1.png";

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4d251399c535cb75318c642c9132b4b4.png";

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ff84c94e4f42336b9da8b097d98a64f.png";

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2672b46062cc26b2f5b0d5b6bbacb2a3.png";

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ac65416c2166d8d41b69892808582d57.png";

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "886c4369654282d3aefb63ef69936c83.png";

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "abf8c2db2d0c462e1f4d7feeb5b04b5e.png";

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b1bdb41563da36dac4ebf3909e9da35.png";

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "27e2c5b081a749fd15bf358db110172d.png";

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "74ffe0d0ac23fd51d476f34a0451a864.png";

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "db19bbf603ae4cffa3a8d0dbaf87bebb.png";

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6fa5d9d58dfc14ce4da607baa295d6fd.png";

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6306d904854d97d5ea82c35263921d1a.png";

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4232aa940ac5a7453d1071a2dc44a099.png";

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "536d4035cc2f864d82db063047ff2a9d.png";

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f0b24e30283d49adde14aef19c02c80b.png";

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8814a4846c29d558a9ded3aaa645b3fb.png";

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4b399c3d45ea6fda68740d0141881b4c.png";

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f65138980d555eaffb24fea50b3f2ac.png";

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6dd4ff9bb225da2be7c63e25bcc1495c.png";

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41c334458275363d36fe12b98f78516b.png";

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9a545fe7acacdef28d645dc3f042e0cc.png";

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2903775100d4c1679a849bdce4a3f800.png";

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ed4c5c6cb2250217611cf26f581d622.png";

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "256a5dbbf4cad681861f8b41fd43ec8e.png";

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52678d2dc8473f207b82e1048c1c91f5.png";

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a1c5deb1c9da145b092f93bae42ce272.png";

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3dfe3ce56d2940b0fe8754ae9e6fa407.png";

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b60ace7f0a14f6b5e6f26d6c9b98ee83.png";

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5f0743a77a0a593ce9def479b579f87b.png";

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "590021d0e923ab3a5c97207076ccc4ef.png";

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e63698daafb85f7734290adff0f7c0f0.png";

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "36017f8660fa1cdb39fb779a4392023d.png";

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c0a912043f8c58cca978e4bf2ac71f6.png";

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "35ddc687683559a24b3d0642779e6457.png";

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aaee442dc0d77087b8e5a3fee6b6ce50.png";

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c16b3cd56719e2cfc1c937836442581f.png";

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c6f59b4ceca625a41c0464a37d5611a.png";

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a9c2db71375a3b12e797b3b9f32acc84.png";

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c3ba29aa0093f1d9e3f58b2906dc105f.png";

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a2f1f2923a326062888c8ddfd41efbc3.png";

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dca8c6b29ff5f5a38d000d88b4be8f3f.png";

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "802db2537941f3385fa2153cb33bddeb.png";

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8492f974871ab6d9650ef3f66ba6a2ea.png";

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d2cd75d25c53c90b9e6a8cc6e2ae13b2.png";

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ce87659dfa8c8fc42abdc2c45160286.png";

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b42d284016002437c3ecee199b5f1321.png";

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bfac37bb4c63c8a4ecebc01329c36444.png";

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f73ce6e975391ae2f060fb342be08de7.png";

/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f97f9b80a4a70986f1f90bcc4e78aba.png";

/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00747ce0babbb4b6b4f702eab88ead9a.png";

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "61b6d9f00136c9c52df12167d64dc358.png";

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "635543c715cc8abba0ebee91fc7a1830.png";

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "77872145052ba524e90485995e05b9ce.png";

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d4141f528c3c4d277280e8e075d9c208.png";

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "633aeabc0feb2aee75c3b754c0d05014.png";

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4252a42661db6d619d6cf0b62e2b911.png";

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "020ace32cfb3749f3ab0e7c8484438f7.png";

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "78871e5d79702e192e3412cd0a628dc2.png";

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c853a4de8d6ebe6b8b611248f306bfa6.png";

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c33be54b30cbe90ad64e9e6df2d3a95.png";

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "91411b0cb3e7ea6c78a8edb5faef8e21.png";

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "483fded4c689cc08229314a364753170.png";

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fdcb30f17c98468d6b0dc0ddc518aa2.png";

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1f032cbe1aa21925bda7a79a058f410.png";

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b762db6c115409caf4b3abd637cff41.png";

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7e122eebdd29778d4082981e7f3763f9.png";

/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32c5eaff70b1bc10011b9f30f706d20a.png";

/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "defdface72e9a2fdbc9cc223ba3c6c14.png";

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "83540e660bba8c7ff88ecc64ceb12999.png";

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "168238242da462ef11f9f5f34168ac65.png";

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7ad89ea42aee49803f57d69eac4e4c9a.png";

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59b5ad184965e7276b5d8605cbcca9f2.png";

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5769e3d863031a5732390cd023ac32a5.png";

/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01f3f72feccc6684d2137302984c4bca.png";

/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "668e87b8c2aed72302ae43746bc36379.png";

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "971efe1870421d5d93c2dcb0bade0af1.png";

/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d6c33d153da2b761e4b82cc93ed25f1.png";

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9b5b6e832b990e24515a5d1d5b446f5e.png";

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab534dd3fc6ee11e5c410d63a5401030.png";

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00fabcbae5f4d0e9d7a5ba9e7466fcee.png";

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "154d58fb52dd5282886c99bb9886dd2f.png";

/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "549528280b2f2b8fd26ce88a5cb064b5.gif";

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a18c975d1a889d0fa285b043f79b612.gif";

/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d1b21b2fb3dbbcb5c25b960502b69f26.png";

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "64379f2c420c4916cf2baa791ba39ff1.gif";

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cb3d6c317730073418588aa3557eb3b4.gif";

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "434981ce9496adebc0bcb3071c86fc45.png";

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34d78e85ddbdcfc0a41967980b022905.png";

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01bf40e7f481a00f08efa58d23c5b6c7.gif";

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e267f5f52e33067dc6396278902a059.gif";

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e4e654f954d16dfd65640d1fcf5f040.png";

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ca67b9b0969ae18bb4ac4bc4a2bd9e6.png";

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a2a3b8ecafaab663ffbea299f886d2d.png";

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c48600e1f9f4612c89dafef72cee5dd2.png";

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7f5de543dbebc158c337488ce04715c.png";

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "384132567a0c457046c0c97c7a009a19.png";

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e71ab58d39d69c5c263a14298e9a496.png";

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bed5b2ab464808e6d6ee9bb2f49db726.png";

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6cc33e370d074ad8ad5ae99c0f91f7c4.png";

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6814c8c7283a283c67e73f6846f522e7.png";

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0cb81712c36157302d169314edb86927.png";

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa7660e8fa65d54c1dc821ce66b5fb36.png";

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "769abba32ad5089bff2cd32fae375295.png";

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9bcd50bcfbfaf00b10a1ae2a3d0d8b52.png";

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c715e472a42e02b8590bcf2d093fcff8.png";

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20d548bb1c4bd96f4c7917015187d051.png";

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1920b6bfbdd8e87dcf9c4d105799931d.png";

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89a67b4c673c4f22ef472aeb3fa304bc.png";

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4bcf4ef07d0fe93a0b61e0456bc3ea9a.png";

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a207f783b3bc2cc98762ffadef789cf2.png";

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "64f924deb0fc15be3a8f740277ce6fe1.png";

/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9bc7e20937bd375dcc27515e0d9e79ce.png";

/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0421bf42380b4f3e2816bb6eb2b9110b.png";

/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50186f374e70013945d9c40483b1f04b.png";

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f5a0fb8e1a7e6cdd70d9797ddefddd3.png";

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ec266a4a664adc9ad6b2751728725bd.png";

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6495cb70be37cb6163edefad107f535.png";

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "38df5ccdd5d92d160a54ed2a11326cf1.png";

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d95624a6f69e60f06710abc803f6e0f.png";

/***/ }),
/* 3184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3284dc75b0c2c221985fc1faaa4ea4e0.png";

/***/ }),
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c08cc81658d673c45c1240d5fd31569f.png";

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6e562e863ccbdecfef340c407d5b75d4.png";

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9178325bd8f7353ce881389d4e5743fd.png";

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b99bbc6ee388476fb7e8c691f7bfe7a0.png";

/***/ }),
/* 3189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81b0f1f02517f0cf91939b4c7591878f.png";

/***/ }),
/* 3190 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c60b89e9b9f0a0ea984992e90c3e2ab.png";

/***/ }),
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52e3086e09b103fd4d7ca03e7ef72003.png";

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e7448a9cdb6c6ef5f91ac5e25f45315e.png";

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cbd7e3c33d280bbf62d4d679b201f074.png";

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "66817da5373c5dd26515454c9c8a1c47.png";

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "45897a66cdddc3fd78c14b4d9da84f05.png";

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37fe18ca88ca666ec02e4cf8f7711ec5.png";

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e39a63afbdb9d51801b57ac3b4fba650.png";

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "941da5f86644fb4557a682f725f27093.png";

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b0d8d7190dca38f6444af7ba8ccfcc5.png";

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3bdb3de3635c99e9774b2199abea55a.png";

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec5eb9bdd70cfecd72a78f575255a3be.png";

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a06cdf94afd3b63a62444fcc0f5c86b5.png";

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0bff2aec5eeb0e1a087b4ca97926bd56.png";

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "528a8d2351f88520788db0d38b334698.png";

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d213469fe29c17bfbef98abef4c5b0ef.png";

/***/ }),
/* 3206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ec7acc6e0fc3b2a115592f868ab6e177.png";

/***/ }),
/* 3207 */
1577,
/* 3208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41548a4d368158e2366de41ac8758b11.png";

/***/ }),
/* 3209 */
1579,
/* 3210 */
1580,
/* 3211 */
1581,
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4882db36d360c59f1b83717b3fe641a9.png";

/***/ }),
/* 3213 */
1583,
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "813fd8df063072d04906817910a56df0.png";

/***/ }),
/* 3215 */
1585,
/* 3216 */
1586,
/* 3217 */
1587,
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0cca9a700e2180795d8f78b181d337f8.png";

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea4f87ad58693b75e2828a1da4b6c624.png";

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d4549e713c6ea8eae0ae12226beab5e4.png";

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "21117de3101bdf02bc96b216015f3fbc.png";

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2171def33673892541d594afb6605603.png";

/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "62c629e1f9964658a9106bc518369870.png";

/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a5afb9764990d0b5a52001cbea90d75f.png";

/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b5e52f2fb486d28f8d9446f074d1e88d.png";

/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "598bed55f1790aae482bcce81de59010.png";

/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "58feb0b9559dc955abea11391a615c9c.png";

/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6d147ff7467860dd03c99979b758052.png";

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab869890c2fc9984ca0cb6d74d13e1a5.png";

/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d13d54bd47690da1923adff81da06752.png";

/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6884e6fb72dcd32b7c256dd820aab45f.png";

/***/ }),
/* 3232 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89abd584b2649955398be1db443324ae.png";

/***/ }),
/* 3233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e1a44dfe8271dc0e9908cbee372dd17.png";

/***/ }),
/* 3234 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6aa68c9181c17718df257ff4e130319e.png";

/***/ }),
/* 3235 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20735618037401631f62863a31d3dce7.png";

/***/ }),
/* 3236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8db93541af8419344e51583b74521f8e.png";

/***/ }),
/* 3237 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b320f9ed36ec3405721b2572d96699d9.png";

/***/ }),
/* 3238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0ff5f5b97f03beea045667ded2ab8883.png";

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "17b18425d6d57788dc23891229cb4c92.png";

/***/ }),
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d55c8ebe340b9932aa4e5d6cc1383974.png";

/***/ }),
/* 3241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "66405807bef19cc7fa512af84ca4f56b.png";

/***/ }),
/* 3242 */
1601,
/* 3243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1c79e9ba2743f7490a66ec170d948492.png";

/***/ }),
/* 3244 */
1603,
/* 3245 */
1604,
/* 3246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6d0809a1d4b130d478c29e2f43de7f0d.png";

/***/ }),
/* 3247 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c2184673a7ff460f7c01a2ea017657f5.png";

/***/ }),
/* 3248 */
1607,
/* 3249 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab8e91886a91f9b6227468b13f212858.png";

/***/ }),
/* 3250 */
1609,
/* 3251 */
1610,
/* 3252 */
1611,
/* 3253 */
1612,
/* 3254 */
1613,
/* 3255 */
1614,
/* 3256 */
1615,
/* 3257 */
1616,
/* 3258 */
1617,
/* 3259 */
1618,
/* 3260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb6681868ef1539e2ba11a0d39c2904d.jpg";

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d552dff81305ed16fc435721f6177c21.jpg";

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9c708336303d3e4d62652ca69dba61f2.jpg";

/***/ }),
/* 3263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a0367a529a08d09276d7b87e8abe6b50.jpg";

/***/ }),
/* 3264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef2fd681eea236cd653815b42b931399.jpg";

/***/ }),
/* 3265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94dbb8d572a8c2dfe2526f3efe04eda6.jpg";

/***/ }),
/* 3266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ab5a5eabe53b4e536aacb5ab1c100885.jpg";

/***/ }),
/* 3267 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "75698b1310426e3f9fd9090dba922d60.jpg";

/***/ }),
/* 3268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "37de899de48c1a9452736b4829934eaa.jpg";

/***/ }),
/* 3269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0274637afddb77edfc3c5d1901f8fd78.jpg";

/***/ }),
/* 3270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b1832884a864ab9d8c1f2f6ebf72701.jpg";

/***/ }),
/* 3271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e84ed9a80dc6e66d730d79fb1531aa76.jpg";

/***/ }),
/* 3272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ee63bb4a42aa965f2a74b4af51f149f.jpg";

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b1e2e1f3ec462f6384273e920fd1a45f.jpg";

/***/ }),
/* 3274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c834d83f15911fd62427398b9e3e12dc.jpg";

/***/ }),
/* 3275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "90119993227303726d89f277f0d44551.jpg";

/***/ }),
/* 3276 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "699a79e580ea57883753da33693bf43e.jpg";

/***/ }),
/* 3277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "33cccc31cd289196231cc264c6372727.jpg";

/***/ }),
/* 3278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4be89fdc45bd55b0b6121f6b98a6b267.jpg";

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "295bf282af805764713de0578fb2355e.jpg";

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c46e6a1dfafb790b1214ad4e8ecd5262.jpg";

/***/ }),
/* 3281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fd9e23614997b6e9831ab21142531c0f.jpg";

/***/ }),
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "400bdd8b4e0d38fb0caf1b7b0674cfab.jpg";

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20b78be27375c92fbc67bc0b21ea6830.jpg";

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9f8a31c0ca58df2e2af552fa3144d98.jpg";

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6e802061f17c8a2d7f06dd490d1c1b8.jpg";

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "575dbd869a4dee629507aceb865a4939.jpg";

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34f194d2425a14ff00b41ca3c1903bc6.jpg";

/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d39824b584628756eeedc041b04e66d3.jpg";

/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e387beeddc7278e03b19fa2448ab68e8.jpg";

/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "81fcebb96a5cca29bf587cf968e3f148.jpg";

/***/ }),
/* 3291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d0f6e24a16f6349b504f1ceaa00ee8f1.jpeg";

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70fc55d854d764bd9036a7f163c8cb8e.jpeg";

/***/ }),
/* 3293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d481740606ba02cb349c3d4b1ca85f89.jpg";

/***/ }),
/* 3294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d5d23004c9e1240682384479127099da.jpg";

/***/ }),
/* 3295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e070716d5e55b30a0b7b661fb7405ba7.jpg";

/***/ }),
/* 3296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82fa0202696f54c6d48243da79d477de.jpg";

/***/ }),
/* 3297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eda04cc8d0ff856ef8b155bd91ad752e.jpg";

/***/ }),
/* 3298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "53bb6173c6cc62d65a33d8f2a8063add.jpg";

/***/ }),
/* 3299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "242ae96df8613b074585c6159c95a794.jpg";

/***/ }),
/* 3300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2994b993094c8bf08097b82cd293cc63.jpg";

/***/ }),
/* 3301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "761853435a18524a9107b46840cf2730.jpg";

/***/ }),
/* 3302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "61ff4c89d63eb69987659f8874569267.jpg";

/***/ }),
/* 3303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ed951fca437da140de9bce51daad1a6.jpg";

/***/ }),
/* 3304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4bf9595e09d83c5af4db9f3bcc10deb1.jpg";

/***/ }),
/* 3305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "878941952f71eb2d6a42d5a05c28992c.jpg";

/***/ }),
/* 3306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "28b3be3aeecf33f44842d50afb4ec692.jpg";

/***/ }),
/* 3307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "627935e06d24a8d1aea0f38047906da5.jpg";

/***/ }),
/* 3308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "269dd2e422e52220b416ad198853042b.jpg";

/***/ }),
/* 3309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b1627fb966b508ad33d4397f8f1eab7e.jpg";

/***/ }),
/* 3310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "927657f4e631d0b354ce399e92f21c70.jpg";

/***/ }),
/* 3311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a92d12e8bc7ddb2cdfb7281334822e4f.jpg";

/***/ }),
/* 3312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d33afdd22bc6e217707bf0983603ec9.jpg";

/***/ }),
/* 3313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b31d2b6ab7376e2b3f4a891c8b8e7c68.jpg";

/***/ }),
/* 3314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b0901f1868791233e0950c17f7868cbc.jpg";

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df4f94d3d6d55f4934f8ed1c6578a3fe.jpg";

/***/ }),
/* 3316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2b77dfa7b0f9b65dece4f7f817bb1af.jpg";

/***/ }),
/* 3317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "05634870e291dfb316504d157df583ba.jpg";

/***/ }),
/* 3318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c5b056fbe240f14e93d92e44d04796db.jpg";

/***/ }),
/* 3319 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e54e96785d3cecaa9fe5813e1ff88152.jpg";

/***/ }),
/* 3320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c79461d2042a8c39c34f442ce557286.jpeg";

/***/ }),
/* 3321 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0c1f0c34440c65b1dcdeef99172da0fc.jpg";

/***/ }),
/* 3322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7958a0311933f4e692a3786e0640e9e9.jpg";

/***/ }),
/* 3323 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87b67265e4866113a43d4ad9177932b0.jpg";

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5c48708355368bcd91e11df4adf06de5.jpg";

/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ae1ea994ee838ae8684dfa10b23ced53.jpg";

/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c70221e60a30e3d5a2ee20915172fc57.jpg";

/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9de29a2e83199880153012ae558c1c95.jpg";

/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dbb6960cede453fd7302cb27b9dc8a50.jpg";

/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c8512b841a9ee7fd74b163dd2afa4a48.jpg";

/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c1ab5add3dfefc8086428aab0057da4b.jpg";

/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "92b9fc335c102a76d80ab4a6de437927.jpg";

/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cdab57cfee201f1a48ea74968140b148.jpg";

/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "678d8acbb34032d5aa01399bac056035.jpg";

/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f1dd40e00df7f6bc00ee1317166c1ea0.jpg";

/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "27f598bdaf19cbe63df87ec521149f92.jpg";

/***/ }),
/* 3336 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39078345b9c79c85970c1521e9ebeacc.jpg";

/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e6220ae86b77279663dfa30758fb31ce.jpg";

/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fdcb67a9284d092dbb7096a58039520f.jpg";

/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8cc4679c151e2792c04abbd414d3f2c1.jpg";

/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f88397381171e71bd0c5b1a91eb3ce21.jpg";

/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7e181221ef4a4a8a8ed204883654ec4.jpg";

/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a82b2ea7042ee25fce58298e82cb5c7e.jpg";

/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e27f176438e23030d3ed501b2003e7f0.jpeg";

/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "47b37d3a987277cebaf6637c3e52a799.jpg";

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7ddbc7c3d5f2cf74057c3bdf16bc357.jpg";

/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "348b47e89d165454096715badd43d5c0.jpg";

/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13ec4292a70b00e21826c3222ba30f66.jpg";

/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0fb4e47a6f9ac3058e1c01bd5cbbe51d.jpg";

/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c78acc54024cd3a68d163ea405be106c.jpg";

/***/ }),
/* 3350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a333c59877fd7ba1e28425521f3db7ae.jpeg";

/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d226c9b80523eed56a031e35ed002756.jpg";

/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5953d715cd89506fdce40e09f09f941.jpg";

/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6f6f664e4b4a74fd58b29782960076e4.jpg";

/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d00d6f30e646b36af4c1c4d806cb2747.jpg";

/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dcabd6fd4efca8c155f949e3602e2dae.jpg";

/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8f2953b60fa80673ec267850819f767b.jpg";

/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af09d8650f5c6fe4eab4b6bc75ad39fe.jpg";

/***/ }),
/* 3358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf701b8e8c77f03dd8abe7eb94691376.jpg";

/***/ }),
/* 3359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "216ce553de689c49b33f5507295715e4.jpg";

/***/ }),
/* 3360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b864d2959f8bb26aa39c937b799ed9a8.jpg";

/***/ }),
/* 3361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a055e71fd63a6abcc1648aad58899a5.jpg";

/***/ }),
/* 3362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e0361d467f78323fc0fb6919808b0b79.jpg";

/***/ }),
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96444c22cba84ae9674aa73f745dddbc.jpg";

/***/ }),
/* 3364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "79fef94eecac8d61ead7f6be3e48bc0e.jpg";

/***/ }),
/* 3365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6943ddc70b5fa54f50594e4a1a1dc207.jpg";

/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9d71a512c1a7c5e18a449d109f3475ac.jpg";

/***/ }),
/* 3367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2f8ffb792fbdcd583ca7b204580b417c.jpg";

/***/ }),
/* 3368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "93cf8107f6d39a09b17f74ddefe45e62.jpg";

/***/ }),
/* 3369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65c31ba19140a54e32278b8a703be096.jpg";

/***/ }),
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7c49be801c5d0aec88180e97cc34bea8.jpg";

/***/ }),
/* 3371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af480b956aa1d0b1cefd605686e75142.jpg";

/***/ }),
/* 3372 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0286f035ae1ffdfc81123cfdbc5a1f14.jpg";

/***/ }),
/* 3373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a72db75c7ed6f1a11380da892ee1d97.jpg";

/***/ }),
/* 3374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4ec2261af7b6973cfa8e839ebec434f5.jpg";

/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08038eb9128258561f4aef13fb8521d4.jpg";

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bcc57883d62707ea1579bf4ecbade2b1.jpg";

/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8796341b019588c5da6f077ad485e7cf.jpg";

/***/ }),
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "214cda05ab233b921389f3524757ec0f.jpg";

/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "13a3bef05939685f4bff6a4e089e1835.jpg";

/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d27c6d960202d1689d7ae91e2a78152e.jpg";

/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "06199c1b0ae96c25c1e6ffbd5ef78128.jpg";

/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb91944c0fd39853c81a90a57a49c0ff.jpg";

/***/ }),
/* 3383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aee9acf56065e68d9ef6d4dc3d1d6622.jpg";

/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b56b6123726af40425788f04029da3d3.jpg";

/***/ }),
/* 3385 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "865029856f294e6870c61aa9e2ff0843.jpg";

/***/ }),
/* 3386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9317f013e4b662390d7dcbce3c19bed.jpg";

/***/ }),
/* 3387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a80c71597cbc5ec057cbe364a0a86f01.jpg";

/***/ }),
/* 3388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1cc8d7aa9ef1efbd9d9ad3f3a3e69b17.jpg";

/***/ }),
/* 3389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "51bab5f3b924a76b15a40cecdc8b567c.png";

/***/ }),
/* 3390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1a3c263880436c26937f48c43a0db33e.png";

/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d9087840afac9a34ca24e02f72fa82c.png";

/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb1f34afaf504a7b3c8977320602631e.png";

/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2d3966a785b4b4c33465077e0edc23cf.png";

/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f17582d7c416c0645f05fef10ca4c356.png";

/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "efbb77eaa011a6d108003d067b689b2d.png";

/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "20524c3fc1b761604a76a670781c19d3.png";

/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ea7e3de7e73f1e2d40ff69019e3c30f3.png";

/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf64bdc3c323dad64a8390b3a76dd311.png";

/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59e470fd5a7fb9d63fa8e6e3b430cb4c.png";

/***/ }),
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7b100d61aadaa5a9dfc56807270ab214.png";

/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e196e78d697d1c7da44f763c16b8798.png";

/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a5f6627445942756ed36cf989d55cbeb.png";

/***/ }),
/* 3403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "504e425cc02dfdb754c807822c565592.png";

/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b32b09975ce96636060a8c941c599b57.png";

/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8a50121664679852049ca8556036fc6.png";

/***/ }),
/* 3406 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "964f88e1a0838330563819b05b2802bb.png";

/***/ }),
/* 3407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ad5947ab0f3236e5b8df6d5a4fccc7b.png";

/***/ }),
/* 3408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ad52a414286b292c1fa1a2ae18756d0a.png";

/***/ }),
/* 3409 */
1552,
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2a4857157c0abf76a8310c2c12e70a55.png";

/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b19b8112082b843ff911339156116d40.png";

/***/ }),
/* 3412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "71c9cffb49b81bedf5330af0a096409f.png";

/***/ }),
/* 3413 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "78e3eeecabb46f4134c69dae7fc9627a.png";

/***/ }),
/* 3414 */
1551,
/* 3415 */
290,
/* 3416 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fae4e4b814159d32685429e36dfbd1f4.png";

/***/ }),
/* 3417 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3c3e4a552c1fc8c0f865380fc2ead38.png";

/***/ }),
/* 3418 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "274a483d902eb6ab2a949b38cbf9e50b.png";

/***/ }),
/* 3419 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ddace9244b98654921dbe40b92823b89.png";

/***/ }),
/* 3420 */
294,
/* 3421 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "515b9ba687a120cceafd7518f026c02f.png";

/***/ }),
/* 3422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "76d4147694fd93f6b295691c4a781e31.png";

/***/ }),
/* 3423 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa7ba48a09fb91dfe32f8576008ec1bc.png";

/***/ }),
/* 3424 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "35209044e60ef390700fe11c385bdc4f.png";

/***/ }),
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "62706064fb716c4f204ea761e59c22bb.png";

/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1dd4b316407fa61962a8789a317c8e3c.png";

/***/ }),
/* 3427 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d55f56d53ebd9516c26a5b4357a3992a.png";

/***/ }),
/* 3428 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89e3a9559d648d40e05bcedc24dacb7c.png";

/***/ }),
/* 3429 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e328a30135a1a275a72c6c0af13b0bbb.png";

/***/ }),
/* 3430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8241e4d139cf678854015894baba9ac9.png";

/***/ }),
/* 3431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "714d45e4e65e508bf8edf162df0d803c.png";

/***/ }),
/* 3432 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e4ce7596ab86286d76bcfa5d91008d6.png";

/***/ }),
/* 3433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2531082406168707d2f2acf9ea1da102.png";

/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "232229a799a6f07335521122d08fb0de.png";

/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5547cddbb4ad3562c9ef8e4ccd5f11ee.png";

/***/ }),
/* 3436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08d8dfaa37ff7478644b0fde3aea48fe.png";

/***/ }),
/* 3437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3db3dbf54be8354c0116c18d6507a9a2.png";

/***/ }),
/* 3438 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "803b456f924b0ee5209381e50a0512a3.png";

/***/ }),
/* 3439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e962150c87378dc779b682f9f8ea3b1a.png";

/***/ }),
/* 3440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f34ae7d9135f30460f6dbb8ac558925d.png";

/***/ }),
/* 3441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df3dfa611a9748b0b143fb79c4ef8bf5.png";

/***/ }),
/* 3442 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "654ee516645a1852fc54157ad855bae7.png";

/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "501a24a4a1514c049bc1d690b096819d.png";

/***/ }),
/* 3444 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c6c9ca381e2c6100c25f9c7381314b0.png";

/***/ }),
/* 3445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85daf3e26718db9ecd1f2d831fbf4cbb.png";

/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bf58bca0d9cd6d939c4cf3c269d3efcd.png";

/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d765712af3e086173f88ab60bbf87498.png";

/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8a4a53c2fd763e5b78cade42b852e219.png";

/***/ }),
/* 3449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8c59f51f8a6d3d2c98a2c86caa198d35.png";

/***/ }),
/* 3450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e7df8aabde182430b66e4b3a6ea0b0a5.png";

/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "864a1e9634105de70916a3980ca014a8.png";

/***/ }),
/* 3452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9c3583be174c52aceba6e3c37dcd9b7.png";

/***/ }),
/* 3453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e0af0143500640526a65f82e4267455.png";

/***/ }),
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4929b7810ce538f45b83bf4756d875ec.png";

/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3d9e571ba0074306acd878d2e347e9bf.png";

/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "16a29b6e5bc014e248db6ef208057deb.png";

/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "390ac6e6e92619932392b9f3b236ca83.png";

/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5dd16492edf1f4c0a4f45ad824875def.png";

/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "573a31f59d8ab245261fb52279a91da9.png";

/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ec71503e72b27bb22dd77b01eda0b5e.png";

/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "74fb21d6c3926d67b9fe9f3e1903d69d.png";

/***/ }),
/* 3462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41050772caac9cd79e4a63e84e6fc147.png";

/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "045eca315c47c2f5b8ce8e10881fd96e.png";

/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4bd3f5a87b6c5b2a2ed15850365ed450.png";

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01464e097a8d4db3c7d52ad9c9cc8adf.png";

/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "944b4f8c7fbd8a2ec4eabdc640e544c1.png";

/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "79e2407c8fbc89990b5a6bf473f1cc55.png";

/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e257b33d0e59e1f208d0801b56e97c1.png";

/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d5db73711ab20a1cbddc6161b8a4acf1.png";

/***/ }),
/* 3470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9ce4a65cc5077024ed1278e6d2d1b8a6.png";

/***/ }),
/* 3471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "67f635bac5620ff22d778d60eb7b3435.png";

/***/ }),
/* 3472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "868d168919c0cba22399a6530c6a6993.png";

/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "07b18828863c32aca3fd41125f48dcc8.png";

/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d737b99282009ed904d46b95d97ef784.png";

/***/ }),
/* 3475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e6bd34d011432df6527ced9370e5de34.png";

/***/ }),
/* 3476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c8b1f3cbceaf5dc2b83122bb7749a5a.png";

/***/ }),
/* 3477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "199ff060f30daa374daaf91f88a88f6f.png";

/***/ }),
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e727aa48315224f94b53664319a70e09.png";

/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d4059d927ff42a1eea6e139b1bc675a5.png";

/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e1bfd2d3d3a5ff598c4d88f00ed8717b.png";

/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "419425202a4652fde137202b0f8f1900.png";

/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "57f7802f41bc9e4e15bba5164f542c0a.png";

/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "29dfa103cfd0a01a007bf29a479be583.png";

/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2614243298eb8478c54249cdacc5d9b5.png";

/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2202211bf54c0497bc616df66c009883.png";

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e72834f8fee05693a208590ebbab23fa.png";

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "efc32b2d7313b354213dbb2e520be8cf.png";

/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4dff8f5510fe3c2f0671273671c2788.png";

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b57866adf9cb1c337c991e401a38bda2.png";

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8289fd0de113a51b5cacc3131f3eeccd.png";

/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9f91b5813be1db970aad46c31684d114.png";

/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "859cfb6a695b728cdd39c90cc74984cf.png";

/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "392c492bc2201576260c3b0678a17bd7.png";

/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "238ffa251b5d70173062d289023e7ab8.png";

/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef239632a9cbb76baabb839a37c5f5ae.png";

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f5a3e76d5d63d29a49dff0f561b29bab.png";

/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "66da48aa9b9ac9379940387f2a1bb1ea.png";

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fb8cbf10f18cf3280cd0b679618893c.png";

/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d712e8cb098942120a6d8c696f6cf47.png";

/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8e0e90324cb6071eadb3ea7355dbf91e.png";

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ff70ec11c0cb265cda8fb83e60284ed.png";

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0cebf9ac96fca41b41a6f13ad395977e.png";

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(1520)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
	      return factory( window, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- makeArray ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	  // return empty array if undefined or null. #6
	  if ( obj === null || obj === undefined ) {
	    return [];
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	};
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = ary.indexOf( obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem.parentNode && elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  elems.forEach( function( elem ) {
	    // check that elem is an actual element
	    if ( !( elem instanceof HTMLElement ) ) {
	      return;
	    }
	    // add elem if no selector
	    if ( !selector ) {
	      ffElems.push( elem );
	      return;
	    }
	    // filter & find items if we have a selector
	    // filter
	    if ( matchesSelector( elem, selector ) ) {
	      ffElems.push( elem );
	    }
	    // find children
	    var childElems = elem.querySelectorAll( selector );
	    // concat childElems to filterFound array
	    for ( var i=0; i < childElems.length; i++ ) {
	      ffElems.push( childElems[i] );
	    }
	  });
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  threshold = threshold || 100;
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    clearTimeout( timeout );
	
	    var args = arguments;
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold );
	  };
	};
	
	// ----- docReady ----- //
	
	utils.docReady = function( callback ) {
	  var readyState = document.readyState;
	  if ( readyState == 'complete' || readyState == 'interactive' ) {
	    // do async to allow for other scripts to run. metafizzy/flickity#441
	    setTimeout( callback );
	  } else {
	    document.addEventListener( 'DOMContentLoaded', callback );
	  }
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via [data-namespace] or .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-options
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  utils.docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var dataAttr = 'data-' + dashedNamespace;
	    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
	    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var elems = utils.makeArray( dataAttrElems )
	      .concat( utils.makeArray( jsDashElems ) );
	    var dataOptionsAttr = dataAttr + '-options';
	    var jQuery = window.jQuery;
	
	    elems.forEach( function( elem ) {
	      var attr = elem.getAttribute( dataAttr ) ||
	        elem.getAttribute( dataOptionsAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
	          ': ' + error );
	        }
	        return;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('namespace')
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    });
	
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(3610)),valueEqual=_interopDefault(__webpack_require__(3915));__webpack_require__(352);var invariant=_interopDefault(__webpack_require__(351));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
	 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	 * Released under MIT License
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
	}(this, (function () { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.
	
	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.
	
	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */
	    /* global Reflect, Promise */
	
	    var extendStatics = function(d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	
	    function __extends(d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    }
	
	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };
	
	    function __awaiter(thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    }
	
	    function __generator(thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    }
	
	    function __spreadArray(to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || from);
	    }
	
	    var Bounds = /** @class */ (function () {
	        function Bounds(left, top, width, height) {
	            this.left = left;
	            this.top = top;
	            this.width = width;
	            this.height = height;
	        }
	        Bounds.prototype.add = function (x, y, w, h) {
	            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
	        };
	        Bounds.fromClientRect = function (context, clientRect) {
	            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
	        };
	        Bounds.fromDOMRectList = function (context, domRectList) {
	            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
	            return domRect
	                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
	                : Bounds.EMPTY;
	        };
	        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
	        return Bounds;
	    }());
	    var parseBounds = function (context, node) {
	        return Bounds.fromClientRect(context, node.getBoundingClientRect());
	    };
	    var parseDocumentSize = function (document) {
	        var body = document.body;
	        var documentElement = document.documentElement;
	        if (!body || !documentElement) {
	            throw new Error("Unable to get document size");
	        }
	        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
	        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
	        return new Bounds(0, 0, width, height);
	    };
	
	    /*
	     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var toCodePoints$1 = function (str) {
	        var codePoints = [];
	        var i = 0;
	        var length = str.length;
	        while (i < length) {
	            var value = str.charCodeAt(i++);
	            if (value >= 0xd800 && value <= 0xdbff && i < length) {
	                var extra = str.charCodeAt(i++);
	                if ((extra & 0xfc00) === 0xdc00) {
	                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	                }
	                else {
	                    codePoints.push(value);
	                    i--;
	                }
	            }
	            else {
	                codePoints.push(value);
	            }
	        }
	        return codePoints;
	    };
	    var fromCodePoint$1 = function () {
	        var codePoints = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            codePoints[_i] = arguments[_i];
	        }
	        if (String.fromCodePoint) {
	            return String.fromCodePoint.apply(String, codePoints);
	        }
	        var length = codePoints.length;
	        if (!length) {
	            return '';
	        }
	        var codeUnits = [];
	        var index = -1;
	        var result = '';
	        while (++index < length) {
	            var codePoint = codePoints[index];
	            if (codePoint <= 0xffff) {
	                codeUnits.push(codePoint);
	            }
	            else {
	                codePoint -= 0x10000;
	                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
	            }
	            if (index + 1 === length || codeUnits.length > 0x4000) {
	                result += String.fromCharCode.apply(String, codeUnits);
	                codeUnits.length = 0;
	            }
	        }
	        return result;
	    };
	    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
	        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
	    }
	
	    /*
	     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
	        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
	    }
	    var decode$1 = function (base64) {
	        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
	        if (base64[base64.length - 1] === '=') {
	            bufferLength--;
	            if (base64[base64.length - 2] === '=') {
	                bufferLength--;
	            }
	        }
	        var buffer = typeof ArrayBuffer !== 'undefined' &&
	            typeof Uint8Array !== 'undefined' &&
	            typeof Uint8Array.prototype.slice !== 'undefined'
	            ? new ArrayBuffer(bufferLength)
	            : new Array(bufferLength);
	        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	        for (i = 0; i < len; i += 4) {
	            encoded1 = lookup$1$1[base64.charCodeAt(i)];
	            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
	            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
	            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
	            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	        }
	        return buffer;
	    };
	    var polyUint16Array$1 = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 2) {
	            bytes.push((buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	    var polyUint32Array$1 = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 4) {
	            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	
	    /** Shift size for getting the index-2 table offset. */
	    var UTRIE2_SHIFT_2$1 = 5;
	    /** Shift size for getting the index-1 table offset. */
	    var UTRIE2_SHIFT_1$1 = 6 + 5;
	    /**
	     * Shift size for shifting left the index array values.
	     * Increases possible data size with 16-bit index values at the cost
	     * of compactability.
	     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	     */
	    var UTRIE2_INDEX_SHIFT$1 = 2;
	    /**
	     * Difference between the two shift sizes,
	     * for getting an index-1 offset from an index-2 offset. 6=11-5
	     */
	    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
	    /**
	     * The part of the index-2 table for U+D800..U+DBFF stores values for
	     * lead surrogate code _units_ not code _points_.
	     * Values for lead surrogate code _points_ are indexed with this portion of the table.
	     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	     */
	    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
	    /** Number of entries in a data block. 32=0x20 */
	    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
	    /** Mask for getting the lower bits for the in-data-block offset. */
	    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
	    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
	    /** Count the lengths of both BMP pieces. 2080=0x820 */
	    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
	    /**
	     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	     */
	    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
	    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	    /**
	     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	     * Variable length, for code points up to highStart, where the last single-value range starts.
	     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	     *
	     * The part of the index-2 table for supplementary code points starts
	     * after this index-1 table.
	     *
	     * Both the index-1 table and the following part of the index-2 table
	     * are omitted completely if there is only BMP data.
	     */
	    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
	    /**
	     * Number of index-1 entries for the BMP. 32=0x20
	     * This part of the index-1 table is omitted from the serialized form.
	     */
	    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
	    /** Number of entries in an index-2 block. 64=0x40 */
	    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
	    /** Mask for getting the lower bits for the in-index-2-block offset. */
	    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
	    var slice16$1 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint16Array(Array.prototype.slice.call(view, start, end));
	    };
	    var slice32$1 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint32Array(Array.prototype.slice.call(view, start, end));
	    };
	    var createTrieFromBase64$1 = function (base64, _byteLength) {
	        var buffer = decode$1(base64);
	        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
	        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
	        var headerLength = 24;
	        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
	        var data = view32[5] === 2
	            ? slice16$1(view16, (headerLength + view32[4]) / 2)
	            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
	        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
	    };
	    var Trie$1 = /** @class */ (function () {
	        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	            this.initialValue = initialValue;
	            this.errorValue = errorValue;
	            this.highStart = highStart;
	            this.highValueIndex = highValueIndex;
	            this.index = index;
	            this.data = data;
	        }
	        /**
	         * Get the value for a code point as stored in the Trie.
	         *
	         * @param codePoint the code point
	         * @return the value
	         */
	        Trie.prototype.get = function (codePoint) {
	            var ix;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
	                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
	                    return this.data[ix];
	                }
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
	                    ix = this.index[ix];
	                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        };
	        return Trie;
	    }());
	
	    /*
	     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
	        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
	    }
	
	    var base64$1 = 'KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==';
	
	    var LETTER_NUMBER_MODIFIER = 50;
	    // Non-tailorable Line Breaking Classes
	    var BK = 1; //  Cause a line break (after)
	    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
	    var LF$1 = 3; //  Cause a line break (after)
	    var CM = 4; //  Prohibit a line break between the character and the preceding character
	    var NL = 5; //  Cause a line break (after)
	    var WJ = 7; //  Prohibit line breaks before and after
	    var ZW = 8; //  Provide a break opportunity
	    var GL = 9; //  Prohibit line breaks before and after
	    var SP = 10; // Enable indirect line breaks
	    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
	    // Break Opportunities
	    var B2 = 12; //  Provide a line break opportunity before and after the character
	    var BA = 13; //  Generally provide a line break opportunity after the character
	    var BB = 14; //  Generally provide a line break opportunity before the character
	    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
	    var CB = 16; //   Provide a line break opportunity contingent on additional information
	    // Characters Prohibiting Certain Breaks
	    var CL = 17; //  Prohibit line breaks before
	    var CP = 18; //  Prohibit line breaks before
	    var EX = 19; //  Prohibit line breaks before
	    var IN = 20; //  Allow only indirect line breaks between pairs
	    var NS = 21; //  Allow only indirect line breaks before
	    var OP = 22; //  Prohibit line breaks after
	    var QU = 23; //  Act like they are both opening and closing
	    // Numeric Context
	    var IS = 24; //  Prevent breaks after any and before numeric
	    var NU = 25; //  Form numeric expressions for line breaking purposes
	    var PO = 26; //  Do not break following a numeric expression
	    var PR = 27; //  Do not break in front of a numeric expression
	    var SY = 28; //  Prevent a break before; and allow a break after
	    // Other Characters
	    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
	    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
	    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
	    var EB = 32; //  Do not break from following Emoji Modifier
	    var EM = 33; //  Do not break from preceding Emoji Base
	    var H2 = 34; //  Form Korean syllable blocks
	    var H3 = 35; //  Form Korean syllable blocks
	    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
	    var ID = 37; //  Break before or after; except in some numeric context
	    var JL = 38; //  Form Korean syllable blocks
	    var JV = 39; //  Form Korean syllable blocks
	    var JT = 40; //  Form Korean syllable blocks
	    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
	    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
	    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
	    var ea_OP = [0x2329, 0xff08];
	    var BREAK_MANDATORY = '!';
	    var BREAK_NOT_ALLOWED$1 = '×';
	    var BREAK_ALLOWED$1 = '÷';
	    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
	    var ALPHABETICS = [AL, HL];
	    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
	    var SPACE$1 = [SP, ZW];
	    var PREFIX_POSTFIX = [PR, PO];
	    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
	    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
	    var HYPHEN = [HY, BA];
	    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
	        if (lineBreak === void 0) { lineBreak = 'strict'; }
	        var types = [];
	        var indices = [];
	        var categories = [];
	        codePoints.forEach(function (codePoint, index) {
	            var classType = UnicodeTrie$1.get(codePoint);
	            if (classType > LETTER_NUMBER_MODIFIER) {
	                categories.push(true);
	                classType -= LETTER_NUMBER_MODIFIER;
	            }
	            else {
	                categories.push(false);
	            }
	            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
	                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
	                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
	                    indices.push(index);
	                    return types.push(CB);
	                }
	            }
	            if (classType === CM || classType === ZWJ$1) {
	                // LB10 Treat any remaining combining mark or ZWJ as AL.
	                if (index === 0) {
	                    indices.push(index);
	                    return types.push(AL);
	                }
	                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
	                // the base character in all of the following rules. Treat ZWJ as if it were CM.
	                var prev = types[index - 1];
	                if (LINE_BREAKS.indexOf(prev) === -1) {
	                    indices.push(indices[index - 1]);
	                    return types.push(prev);
	                }
	                indices.push(index);
	                return types.push(AL);
	            }
	            indices.push(index);
	            if (classType === CJ) {
	                return types.push(lineBreak === 'strict' ? NS : ID);
	            }
	            if (classType === SA) {
	                return types.push(AL);
	            }
	            if (classType === AI) {
	                return types.push(AL);
	            }
	            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
	            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
	            // to take into account the actual line breaking properties for these characters.
	            if (classType === XX) {
	                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
	                    return types.push(ID);
	                }
	                else {
	                    return types.push(AL);
	                }
	            }
	            types.push(classType);
	        });
	        return [indices, types, categories];
	    };
	    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
	        var current = classTypes[currentIndex];
	        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
	            var i = currentIndex;
	            while (i <= classTypes.length) {
	                i++;
	                var next = classTypes[i];
	                if (next === b) {
	                    return true;
	                }
	                if (next !== SP) {
	                    break;
	                }
	            }
	        }
	        if (current === SP) {
	            var i = currentIndex;
	            while (i > 0) {
	                i--;
	                var prev = classTypes[i];
	                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
	                    var n = currentIndex;
	                    while (n <= classTypes.length) {
	                        n++;
	                        var next = classTypes[n];
	                        if (next === b) {
	                            return true;
	                        }
	                        if (next !== SP) {
	                            break;
	                        }
	                    }
	                }
	                if (prev !== SP) {
	                    break;
	                }
	            }
	        }
	        return false;
	    };
	    var previousNonSpaceClassType = function (currentIndex, classTypes) {
	        var i = currentIndex;
	        while (i >= 0) {
	            var type = classTypes[i];
	            if (type === SP) {
	                i--;
	            }
	            else {
	                return type;
	            }
	        }
	        return 0;
	    };
	    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
	        if (indicies[index] === 0) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        var currentIndex = index - 1;
	        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        var beforeIndex = currentIndex - 1;
	        var afterIndex = currentIndex + 1;
	        var current = classTypes[currentIndex];
	        // LB4 Always break after hard line breaks.
	        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
	        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
	        var next = classTypes[afterIndex];
	        if (current === CR$1 && next === LF$1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
	            return BREAK_MANDATORY;
	        }
	        // LB6 Do not break before hard line breaks.
	        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB7 Do not break before spaces or zero width space.
	        if (SPACE$1.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
	        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
	            return BREAK_ALLOWED$1;
	        }
	        // LB8a Do not break after a zero width joiner.
	        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // zwj emojis
	        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB11 Do not break before or after Word joiner and related characters.
	        if (current === WJ || next === WJ) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB12 Do not break after NBSP and related characters.
	        if (current === GL) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
	        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
	        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB14 Do not break after ‘[’, even after spaces.
	        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB15 Do not break within ‘”[’, even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB17 Do not break within ‘——’, even with intervening spaces.
	        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB18 Break after spaces.
	        if (current === SP) {
	            return BREAK_ALLOWED$1;
	        }
	        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
	        if (current === QU || next === QU) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB20 Break before and after unresolved CB.
	        if (next === CB || current === CB) {
	            return BREAK_ALLOWED$1;
	        }
	        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
	        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB21a Don't break after Hebrew + Hyphen.
	        if (before === HL && HYPHEN.indexOf(current) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB21b Don’t break between Solidus and Hebrew letters.
	        if (current === SY && next === HL) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB22 Do not break before ellipsis.
	        if (next === IN) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB23 Do not break between digits and letters.
	        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
	        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
	            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
	        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
	            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB25 Do not break between the following pairs of classes relevant to numbers:
	        if (
	        // (PR | PO) × ( OP | HY )? NU
	        ([PR, PO].indexOf(current) !== -1 &&
	            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
	            // ( OP | HY ) × NU
	            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
	            // NU ×	(NU | SY | IS)
	            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
	        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
	            var prevIndex = currentIndex;
	            while (prevIndex >= 0) {
	                var type = classTypes[prevIndex];
	                if (type === NU) {
	                    return BREAK_NOT_ALLOWED$1;
	                }
	                else if ([SY, IS].indexOf(type) !== -1) {
	                    prevIndex--;
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
	        if ([PR, PO].indexOf(next) !== -1) {
	            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
	            while (prevIndex >= 0) {
	                var type = classTypes[prevIndex];
	                if (type === NU) {
	                    return BREAK_NOT_ALLOWED$1;
	                }
	                else if ([SY, IS].indexOf(type) !== -1) {
	                    prevIndex--;
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        // LB26 Do not break a Korean syllable.
	        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
	            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
	            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB27 Treat a Korean Syllable Block the same as ID.
	        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
	            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB28 Do not break between alphabetics (“at”).
	        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
	        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
	        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
	            next === OP &&
	            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
	            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
	        // indicators preceding the position of the break.
	        if (current === RI$1 && next === RI$1) {
	            var i = indicies[currentIndex];
	            var count = 1;
	            while (i > 0) {
	                i--;
	                if (classTypes[i] === RI$1) {
	                    count++;
	                }
	                else {
	                    break;
	                }
	            }
	            if (count % 2 !== 0) {
	                return BREAK_NOT_ALLOWED$1;
	            }
	        }
	        // LB30b Do not break between an emoji base and an emoji modifier.
	        if (current === EB && next === EM) {
	            return BREAK_NOT_ALLOWED$1;
	        }
	        return BREAK_ALLOWED$1;
	    };
	    var cssFormattedClasses = function (codePoints, options) {
	        if (!options) {
	            options = { lineBreak: 'normal', wordBreak: 'normal' };
	        }
	        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
	        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
	            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
	        }
	        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
	            ? isLetterNumber.map(function (letterNumber, i) {
	                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
	            })
	            : undefined;
	        return [indicies, classTypes, forbiddenBreakpoints];
	    };
	    var Break = /** @class */ (function () {
	        function Break(codePoints, lineBreak, start, end) {
	            this.codePoints = codePoints;
	            this.required = lineBreak === BREAK_MANDATORY;
	            this.start = start;
	            this.end = end;
	        }
	        Break.prototype.slice = function () {
	            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
	        };
	        return Break;
	    }());
	    var LineBreaker = function (str, options) {
	        var codePoints = toCodePoints$1(str);
	        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
	        var length = codePoints.length;
	        var lastEnd = 0;
	        var nextIndex = 0;
	        return {
	            next: function () {
	                if (nextIndex >= length) {
	                    return { done: true, value: null };
	                }
	                var lineBreak = BREAK_NOT_ALLOWED$1;
	                while (nextIndex < length &&
	                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
	                        BREAK_NOT_ALLOWED$1) { }
	                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
	                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
	                    lastEnd = nextIndex;
	                    return { value: value, done: false };
	                }
	                return { done: true, value: null };
	            },
	        };
	    };
	
	    // https://www.w3.org/TR/css-syntax-3
	    var FLAG_UNRESTRICTED = 1 << 0;
	    var FLAG_ID = 1 << 1;
	    var FLAG_INTEGER = 1 << 2;
	    var FLAG_NUMBER = 1 << 3;
	    var LINE_FEED = 0x000a;
	    var SOLIDUS = 0x002f;
	    var REVERSE_SOLIDUS = 0x005c;
	    var CHARACTER_TABULATION = 0x0009;
	    var SPACE = 0x0020;
	    var QUOTATION_MARK = 0x0022;
	    var EQUALS_SIGN = 0x003d;
	    var NUMBER_SIGN = 0x0023;
	    var DOLLAR_SIGN = 0x0024;
	    var PERCENTAGE_SIGN = 0x0025;
	    var APOSTROPHE = 0x0027;
	    var LEFT_PARENTHESIS = 0x0028;
	    var RIGHT_PARENTHESIS = 0x0029;
	    var LOW_LINE = 0x005f;
	    var HYPHEN_MINUS = 0x002d;
	    var EXCLAMATION_MARK = 0x0021;
	    var LESS_THAN_SIGN = 0x003c;
	    var GREATER_THAN_SIGN = 0x003e;
	    var COMMERCIAL_AT = 0x0040;
	    var LEFT_SQUARE_BRACKET = 0x005b;
	    var RIGHT_SQUARE_BRACKET = 0x005d;
	    var CIRCUMFLEX_ACCENT = 0x003d;
	    var LEFT_CURLY_BRACKET = 0x007b;
	    var QUESTION_MARK = 0x003f;
	    var RIGHT_CURLY_BRACKET = 0x007d;
	    var VERTICAL_LINE = 0x007c;
	    var TILDE = 0x007e;
	    var CONTROL = 0x0080;
	    var REPLACEMENT_CHARACTER = 0xfffd;
	    var ASTERISK = 0x002a;
	    var PLUS_SIGN = 0x002b;
	    var COMMA = 0x002c;
	    var COLON = 0x003a;
	    var SEMICOLON = 0x003b;
	    var FULL_STOP = 0x002e;
	    var NULL = 0x0000;
	    var BACKSPACE = 0x0008;
	    var LINE_TABULATION = 0x000b;
	    var SHIFT_OUT = 0x000e;
	    var INFORMATION_SEPARATOR_ONE = 0x001f;
	    var DELETE = 0x007f;
	    var EOF = -1;
	    var ZERO = 0x0030;
	    var a = 0x0061;
	    var e = 0x0065;
	    var f = 0x0066;
	    var u = 0x0075;
	    var z = 0x007a;
	    var A = 0x0041;
	    var E = 0x0045;
	    var F = 0x0046;
	    var U = 0x0055;
	    var Z = 0x005a;
	    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
	    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
	    var isHex = function (codePoint) {
	        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
	    };
	    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
	    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
	    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
	    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
	    var isWhiteSpace = function (codePoint) {
	        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
	    };
	    var isNameStartCodePoint = function (codePoint) {
	        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
	    };
	    var isNameCodePoint = function (codePoint) {
	        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
	    };
	    var isNonPrintableCodePoint = function (codePoint) {
	        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
	            codePoint === LINE_TABULATION ||
	            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
	            codePoint === DELETE);
	    };
	    var isValidEscape = function (c1, c2) {
	        if (c1 !== REVERSE_SOLIDUS) {
	            return false;
	        }
	        return c2 !== LINE_FEED;
	    };
	    var isIdentifierStart = function (c1, c2, c3) {
	        if (c1 === HYPHEN_MINUS) {
	            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
	        }
	        else if (isNameStartCodePoint(c1)) {
	            return true;
	        }
	        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
	            return true;
	        }
	        return false;
	    };
	    var isNumberStart = function (c1, c2, c3) {
	        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
	            if (isDigit(c2)) {
	                return true;
	            }
	            return c2 === FULL_STOP && isDigit(c3);
	        }
	        if (c1 === FULL_STOP) {
	            return isDigit(c2);
	        }
	        return isDigit(c1);
	    };
	    var stringToNumber = function (codePoints) {
	        var c = 0;
	        var sign = 1;
	        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
	            if (codePoints[c] === HYPHEN_MINUS) {
	                sign = -1;
	            }
	            c++;
	        }
	        var integers = [];
	        while (isDigit(codePoints[c])) {
	            integers.push(codePoints[c++]);
	        }
	        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
	        if (codePoints[c] === FULL_STOP) {
	            c++;
	        }
	        var fraction = [];
	        while (isDigit(codePoints[c])) {
	            fraction.push(codePoints[c++]);
	        }
	        var fracd = fraction.length;
	        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
	        if (codePoints[c] === E || codePoints[c] === e) {
	            c++;
	        }
	        var expsign = 1;
	        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
	            if (codePoints[c] === HYPHEN_MINUS) {
	                expsign = -1;
	            }
	            c++;
	        }
	        var exponent = [];
	        while (isDigit(codePoints[c])) {
	            exponent.push(codePoints[c++]);
	        }
	        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
	        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
	    };
	    var LEFT_PARENTHESIS_TOKEN = {
	        type: 2 /* LEFT_PARENTHESIS_TOKEN */
	    };
	    var RIGHT_PARENTHESIS_TOKEN = {
	        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
	    };
	    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
	    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
	    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
	    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
	    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
	    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
	    var LEFT_CURLY_BRACKET_TOKEN = {
	        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
	    };
	    var RIGHT_CURLY_BRACKET_TOKEN = {
	        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
	    };
	    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
	    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
	    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
	    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
	    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
	    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
	    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
	    var LEFT_SQUARE_BRACKET_TOKEN = {
	        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
	    };
	    var RIGHT_SQUARE_BRACKET_TOKEN = {
	        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
	    };
	    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
	    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
	    var Tokenizer = /** @class */ (function () {
	        function Tokenizer() {
	            this._value = [];
	        }
	        Tokenizer.prototype.write = function (chunk) {
	            this._value = this._value.concat(toCodePoints$1(chunk));
	        };
	        Tokenizer.prototype.read = function () {
	            var tokens = [];
	            var token = this.consumeToken();
	            while (token !== EOF_TOKEN) {
	                tokens.push(token);
	                token = this.consumeToken();
	            }
	            return tokens;
	        };
	        Tokenizer.prototype.consumeToken = function () {
	            var codePoint = this.consumeCodePoint();
	            switch (codePoint) {
	                case QUOTATION_MARK:
	                    return this.consumeStringToken(QUOTATION_MARK);
	                case NUMBER_SIGN:
	                    var c1 = this.peekCodePoint(0);
	                    var c2 = this.peekCodePoint(1);
	                    var c3 = this.peekCodePoint(2);
	                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
	                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
	                        var value = this.consumeName();
	                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
	                    }
	                    break;
	                case DOLLAR_SIGN:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return SUFFIX_MATCH_TOKEN;
	                    }
	                    break;
	                case APOSTROPHE:
	                    return this.consumeStringToken(APOSTROPHE);
	                case LEFT_PARENTHESIS:
	                    return LEFT_PARENTHESIS_TOKEN;
	                case RIGHT_PARENTHESIS:
	                    return RIGHT_PARENTHESIS_TOKEN;
	                case ASTERISK:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return SUBSTRING_MATCH_TOKEN;
	                    }
	                    break;
	                case PLUS_SIGN:
	                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    break;
	                case COMMA:
	                    return COMMA_TOKEN;
	                case HYPHEN_MINUS:
	                    var e1 = codePoint;
	                    var e2 = this.peekCodePoint(0);
	                    var e3 = this.peekCodePoint(1);
	                    if (isNumberStart(e1, e2, e3)) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    if (isIdentifierStart(e1, e2, e3)) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeIdentLikeToken();
	                    }
	                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
	                        this.consumeCodePoint();
	                        this.consumeCodePoint();
	                        return CDC_TOKEN;
	                    }
	                    break;
	                case FULL_STOP:
	                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeNumericToken();
	                    }
	                    break;
	                case SOLIDUS:
	                    if (this.peekCodePoint(0) === ASTERISK) {
	                        this.consumeCodePoint();
	                        while (true) {
	                            var c = this.consumeCodePoint();
	                            if (c === ASTERISK) {
	                                c = this.consumeCodePoint();
	                                if (c === SOLIDUS) {
	                                    return this.consumeToken();
	                                }
	                            }
	                            if (c === EOF) {
	                                return this.consumeToken();
	                            }
	                        }
	                    }
	                    break;
	                case COLON:
	                    return COLON_TOKEN;
	                case SEMICOLON:
	                    return SEMICOLON_TOKEN;
	                case LESS_THAN_SIGN:
	                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
	                        this.peekCodePoint(1) === HYPHEN_MINUS &&
	                        this.peekCodePoint(2) === HYPHEN_MINUS) {
	                        this.consumeCodePoint();
	                        this.consumeCodePoint();
	                        return CDO_TOKEN;
	                    }
	                    break;
	                case COMMERCIAL_AT:
	                    var a1 = this.peekCodePoint(0);
	                    var a2 = this.peekCodePoint(1);
	                    var a3 = this.peekCodePoint(2);
	                    if (isIdentifierStart(a1, a2, a3)) {
	                        var value = this.consumeName();
	                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
	                    }
	                    break;
	                case LEFT_SQUARE_BRACKET:
	                    return LEFT_SQUARE_BRACKET_TOKEN;
	                case REVERSE_SOLIDUS:
	                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                        this.reconsumeCodePoint(codePoint);
	                        return this.consumeIdentLikeToken();
	                    }
	                    break;
	                case RIGHT_SQUARE_BRACKET:
	                    return RIGHT_SQUARE_BRACKET_TOKEN;
	                case CIRCUMFLEX_ACCENT:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return PREFIX_MATCH_TOKEN;
	                    }
	                    break;
	                case LEFT_CURLY_BRACKET:
	                    return LEFT_CURLY_BRACKET_TOKEN;
	                case RIGHT_CURLY_BRACKET:
	                    return RIGHT_CURLY_BRACKET_TOKEN;
	                case u:
	                case U:
	                    var u1 = this.peekCodePoint(0);
	                    var u2 = this.peekCodePoint(1);
	                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
	                        this.consumeCodePoint();
	                        this.consumeUnicodeRangeToken();
	                    }
	                    this.reconsumeCodePoint(codePoint);
	                    return this.consumeIdentLikeToken();
	                case VERTICAL_LINE:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return DASH_MATCH_TOKEN;
	                    }
	                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
	                        this.consumeCodePoint();
	                        return COLUMN_TOKEN;
	                    }
	                    break;
	                case TILDE:
	                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
	                        this.consumeCodePoint();
	                        return INCLUDE_MATCH_TOKEN;
	                    }
	                    break;
	                case EOF:
	                    return EOF_TOKEN;
	            }
	            if (isWhiteSpace(codePoint)) {
	                this.consumeWhiteSpace();
	                return WHITESPACE_TOKEN;
	            }
	            if (isDigit(codePoint)) {
	                this.reconsumeCodePoint(codePoint);
	                return this.consumeNumericToken();
	            }
	            if (isNameStartCodePoint(codePoint)) {
	                this.reconsumeCodePoint(codePoint);
	                return this.consumeIdentLikeToken();
	            }
	            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
	        };
	        Tokenizer.prototype.consumeCodePoint = function () {
	            var value = this._value.shift();
	            return typeof value === 'undefined' ? -1 : value;
	        };
	        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
	            this._value.unshift(codePoint);
	        };
	        Tokenizer.prototype.peekCodePoint = function (delta) {
	            if (delta >= this._value.length) {
	                return -1;
	            }
	            return this._value[delta];
	        };
	        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
	            var digits = [];
	            var codePoint = this.consumeCodePoint();
	            while (isHex(codePoint) && digits.length < 6) {
	                digits.push(codePoint);
	                codePoint = this.consumeCodePoint();
	            }
	            var questionMarks = false;
	            while (codePoint === QUESTION_MARK && digits.length < 6) {
	                digits.push(codePoint);
	                codePoint = this.consumeCodePoint();
	                questionMarks = true;
	            }
	            if (questionMarks) {
	                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
	                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
	                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
	            }
	            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
	            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
	                this.consumeCodePoint();
	                codePoint = this.consumeCodePoint();
	                var endDigits = [];
	                while (isHex(codePoint) && endDigits.length < 6) {
	                    endDigits.push(codePoint);
	                    codePoint = this.consumeCodePoint();
	                }
	                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
	                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
	            }
	            else {
	                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
	            }
	        };
	        Tokenizer.prototype.consumeIdentLikeToken = function () {
	            var value = this.consumeName();
	            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
	                this.consumeCodePoint();
	                return this.consumeUrlToken();
	            }
	            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
	                this.consumeCodePoint();
	                return { type: 19 /* FUNCTION_TOKEN */, value: value };
	            }
	            return { type: 20 /* IDENT_TOKEN */, value: value };
	        };
	        Tokenizer.prototype.consumeUrlToken = function () {
	            var value = [];
	            this.consumeWhiteSpace();
	            if (this.peekCodePoint(0) === EOF) {
	                return { type: 22 /* URL_TOKEN */, value: '' };
	            }
	            var next = this.peekCodePoint(0);
	            if (next === APOSTROPHE || next === QUOTATION_MARK) {
	                var stringToken = this.consumeStringToken(this.consumeCodePoint());
	                if (stringToken.type === 0 /* STRING_TOKEN */) {
	                    this.consumeWhiteSpace();
	                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
	                        this.consumeCodePoint();
	                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
	                    }
	                }
	                this.consumeBadUrlRemnants();
	                return BAD_URL_TOKEN;
	            }
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
	                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
	                }
	                else if (isWhiteSpace(codePoint)) {
	                    this.consumeWhiteSpace();
	                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
	                        this.consumeCodePoint();
	                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
	                    }
	                    this.consumeBadUrlRemnants();
	                    return BAD_URL_TOKEN;
	                }
	                else if (codePoint === QUOTATION_MARK ||
	                    codePoint === APOSTROPHE ||
	                    codePoint === LEFT_PARENTHESIS ||
	                    isNonPrintableCodePoint(codePoint)) {
	                    this.consumeBadUrlRemnants();
	                    return BAD_URL_TOKEN;
	                }
	                else if (codePoint === REVERSE_SOLIDUS) {
	                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                        value.push(this.consumeEscapedCodePoint());
	                    }
	                    else {
	                        this.consumeBadUrlRemnants();
	                        return BAD_URL_TOKEN;
	                    }
	                }
	                else {
	                    value.push(codePoint);
	                }
	            }
	        };
	        Tokenizer.prototype.consumeWhiteSpace = function () {
	            while (isWhiteSpace(this.peekCodePoint(0))) {
	                this.consumeCodePoint();
	            }
	        };
	        Tokenizer.prototype.consumeBadUrlRemnants = function () {
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
	                    return;
	                }
	                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                    this.consumeEscapedCodePoint();
	                }
	            }
	        };
	        Tokenizer.prototype.consumeStringSlice = function (count) {
	            var SLICE_STACK_SIZE = 50000;
	            var value = '';
	            while (count > 0) {
	                var amount = Math.min(SLICE_STACK_SIZE, count);
	                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
	                count -= amount;
	            }
	            this._value.shift();
	            return value;
	        };
	        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
	            var value = '';
	            var i = 0;
	            do {
	                var codePoint = this._value[i];
	                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
	                    value += this.consumeStringSlice(i);
	                    return { type: 0 /* STRING_TOKEN */, value: value };
	                }
	                if (codePoint === LINE_FEED) {
	                    this._value.splice(0, i);
	                    return BAD_STRING_TOKEN;
	                }
	                if (codePoint === REVERSE_SOLIDUS) {
	                    var next = this._value[i + 1];
	                    if (next !== EOF && next !== undefined) {
	                        if (next === LINE_FEED) {
	                            value += this.consumeStringSlice(i);
	                            i = -1;
	                            this._value.shift();
	                        }
	                        else if (isValidEscape(codePoint, next)) {
	                            value += this.consumeStringSlice(i);
	                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
	                            i = -1;
	                        }
	                    }
	                }
	                i++;
	            } while (true);
	        };
	        Tokenizer.prototype.consumeNumber = function () {
	            var repr = [];
	            var type = FLAG_INTEGER;
	            var c1 = this.peekCodePoint(0);
	            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
	                repr.push(this.consumeCodePoint());
	            }
	            while (isDigit(this.peekCodePoint(0))) {
	                repr.push(this.consumeCodePoint());
	            }
	            c1 = this.peekCodePoint(0);
	            var c2 = this.peekCodePoint(1);
	            if (c1 === FULL_STOP && isDigit(c2)) {
	                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
	                type = FLAG_NUMBER;
	                while (isDigit(this.peekCodePoint(0))) {
	                    repr.push(this.consumeCodePoint());
	                }
	            }
	            c1 = this.peekCodePoint(0);
	            c2 = this.peekCodePoint(1);
	            var c3 = this.peekCodePoint(2);
	            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
	                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
	                type = FLAG_NUMBER;
	                while (isDigit(this.peekCodePoint(0))) {
	                    repr.push(this.consumeCodePoint());
	                }
	            }
	            return [stringToNumber(repr), type];
	        };
	        Tokenizer.prototype.consumeNumericToken = function () {
	            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
	            var c1 = this.peekCodePoint(0);
	            var c2 = this.peekCodePoint(1);
	            var c3 = this.peekCodePoint(2);
	            if (isIdentifierStart(c1, c2, c3)) {
	                var unit = this.consumeName();
	                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
	            }
	            if (c1 === PERCENTAGE_SIGN) {
	                this.consumeCodePoint();
	                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
	            }
	            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
	        };
	        Tokenizer.prototype.consumeEscapedCodePoint = function () {
	            var codePoint = this.consumeCodePoint();
	            if (isHex(codePoint)) {
	                var hex = fromCodePoint$1(codePoint);
	                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
	                    hex += fromCodePoint$1(this.consumeCodePoint());
	                }
	                if (isWhiteSpace(this.peekCodePoint(0))) {
	                    this.consumeCodePoint();
	                }
	                var hexCodePoint = parseInt(hex, 16);
	                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
	                    return REPLACEMENT_CHARACTER;
	                }
	                return hexCodePoint;
	            }
	            if (codePoint === EOF) {
	                return REPLACEMENT_CHARACTER;
	            }
	            return codePoint;
	        };
	        Tokenizer.prototype.consumeName = function () {
	            var result = '';
	            while (true) {
	                var codePoint = this.consumeCodePoint();
	                if (isNameCodePoint(codePoint)) {
	                    result += fromCodePoint$1(codePoint);
	                }
	                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
	                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
	                }
	                else {
	                    this.reconsumeCodePoint(codePoint);
	                    return result;
	                }
	            }
	        };
	        return Tokenizer;
	    }());
	
	    var Parser = /** @class */ (function () {
	        function Parser(tokens) {
	            this._tokens = tokens;
	        }
	        Parser.create = function (value) {
	            var tokenizer = new Tokenizer();
	            tokenizer.write(value);
	            return new Parser(tokenizer.read());
	        };
	        Parser.parseValue = function (value) {
	            return Parser.create(value).parseComponentValue();
	        };
	        Parser.parseValues = function (value) {
	            return Parser.create(value).parseComponentValues();
	        };
	        Parser.prototype.parseComponentValue = function () {
	            var token = this.consumeToken();
	            while (token.type === 31 /* WHITESPACE_TOKEN */) {
	                token = this.consumeToken();
	            }
	            if (token.type === 32 /* EOF_TOKEN */) {
	                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
	            }
	            this.reconsumeToken(token);
	            var value = this.consumeComponentValue();
	            do {
	                token = this.consumeToken();
	            } while (token.type === 31 /* WHITESPACE_TOKEN */);
	            if (token.type === 32 /* EOF_TOKEN */) {
	                return value;
	            }
	            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
	        };
	        Parser.prototype.parseComponentValues = function () {
	            var values = [];
	            while (true) {
	                var value = this.consumeComponentValue();
	                if (value.type === 32 /* EOF_TOKEN */) {
	                    return values;
	                }
	                values.push(value);
	                values.push();
	            }
	        };
	        Parser.prototype.consumeComponentValue = function () {
	            var token = this.consumeToken();
	            switch (token.type) {
	                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
	                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
	                case 2 /* LEFT_PARENTHESIS_TOKEN */:
	                    return this.consumeSimpleBlock(token.type);
	                case 19 /* FUNCTION_TOKEN */:
	                    return this.consumeFunction(token);
	            }
	            return token;
	        };
	        Parser.prototype.consumeSimpleBlock = function (type) {
	            var block = { type: type, values: [] };
	            var token = this.consumeToken();
	            while (true) {
	                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
	                    return block;
	                }
	                this.reconsumeToken(token);
	                block.values.push(this.consumeComponentValue());
	                token = this.consumeToken();
	            }
	        };
	        Parser.prototype.consumeFunction = function (functionToken) {
	            var cssFunction = {
	                name: functionToken.value,
	                values: [],
	                type: 18 /* FUNCTION */
	            };
	            while (true) {
	                var token = this.consumeToken();
	                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
	                    return cssFunction;
	                }
	                this.reconsumeToken(token);
	                cssFunction.values.push(this.consumeComponentValue());
	            }
	        };
	        Parser.prototype.consumeToken = function () {
	            var token = this._tokens.shift();
	            return typeof token === 'undefined' ? EOF_TOKEN : token;
	        };
	        Parser.prototype.reconsumeToken = function (token) {
	            this._tokens.unshift(token);
	        };
	        return Parser;
	    }());
	    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
	    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
	    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
	    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
	    var isIdentWithValue = function (token, value) {
	        return isIdentToken(token) && token.value === value;
	    };
	    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
	    var nonFunctionArgSeparator = function (token) {
	        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
	    };
	    var parseFunctionArgs = function (tokens) {
	        var args = [];
	        var arg = [];
	        tokens.forEach(function (token) {
	            if (token.type === 4 /* COMMA_TOKEN */) {
	                if (arg.length === 0) {
	                    throw new Error("Error parsing function args, zero tokens for arg");
	                }
	                args.push(arg);
	                arg = [];
	                return;
	            }
	            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
	                arg.push(token);
	            }
	        });
	        if (arg.length) {
	            args.push(arg);
	        }
	        return args;
	    };
	    var isEndingTokenFor = function (token, type) {
	        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
	            return true;
	        }
	        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
	            return true;
	        }
	        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
	    };
	
	    var isLength = function (token) {
	        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
	    };
	
	    var isLengthPercentage = function (token) {
	        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
	    };
	    var parseLengthPercentageTuple = function (tokens) {
	        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
	    };
	    var ZERO_LENGTH = {
	        type: 17 /* NUMBER_TOKEN */,
	        number: 0,
	        flags: FLAG_INTEGER
	    };
	    var FIFTY_PERCENT = {
	        type: 16 /* PERCENTAGE_TOKEN */,
	        number: 50,
	        flags: FLAG_INTEGER
	    };
	    var HUNDRED_PERCENT = {
	        type: 16 /* PERCENTAGE_TOKEN */,
	        number: 100,
	        flags: FLAG_INTEGER
	    };
	    var getAbsoluteValueForTuple = function (tuple, width, height) {
	        var x = tuple[0], y = tuple[1];
	        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
	    };
	    var getAbsoluteValue = function (token, parent) {
	        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
	            return (token.number / 100) * parent;
	        }
	        if (isDimensionToken(token)) {
	            switch (token.unit) {
	                case 'rem':
	                case 'em':
	                    return 16 * token.number; // TODO use correct font-size
	                case 'px':
	                default:
	                    return token.number;
	            }
	        }
	        return token.number;
	    };
	
	    var DEG = 'deg';
	    var GRAD = 'grad';
	    var RAD = 'rad';
	    var TURN = 'turn';
	    var angle = {
	        name: 'angle',
	        parse: function (_context, value) {
	            if (value.type === 15 /* DIMENSION_TOKEN */) {
	                switch (value.unit) {
	                    case DEG:
	                        return (Math.PI * value.number) / 180;
	                    case GRAD:
	                        return (Math.PI / 200) * value.number;
	                    case RAD:
	                        return value.number;
	                    case TURN:
	                        return Math.PI * 2 * value.number;
	                }
	            }
	            throw new Error("Unsupported angle type");
	        }
	    };
	    var isAngle = function (value) {
	        if (value.type === 15 /* DIMENSION_TOKEN */) {
	            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
	                return true;
	            }
	        }
	        return false;
	    };
	    var parseNamedSide = function (tokens) {
	        var sideOrCorner = tokens
	            .filter(isIdentToken)
	            .map(function (ident) { return ident.value; })
	            .join(' ');
	        switch (sideOrCorner) {
	            case 'to bottom right':
	            case 'to right bottom':
	            case 'left top':
	            case 'top left':
	                return [ZERO_LENGTH, ZERO_LENGTH];
	            case 'to top':
	            case 'bottom':
	                return deg(0);
	            case 'to bottom left':
	            case 'to left bottom':
	            case 'right top':
	            case 'top right':
	                return [ZERO_LENGTH, HUNDRED_PERCENT];
	            case 'to right':
	            case 'left':
	                return deg(90);
	            case 'to top left':
	            case 'to left top':
	            case 'right bottom':
	            case 'bottom right':
	                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
	            case 'to bottom':
	            case 'top':
	                return deg(180);
	            case 'to top right':
	            case 'to right top':
	            case 'left bottom':
	            case 'bottom left':
	                return [HUNDRED_PERCENT, ZERO_LENGTH];
	            case 'to left':
	            case 'right':
	                return deg(270);
	        }
	        return 0;
	    };
	    var deg = function (deg) { return (Math.PI * deg) / 180; };
	
	    var color$1 = {
	        name: 'color',
	        parse: function (context, value) {
	            if (value.type === 18 /* FUNCTION */) {
	                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
	                if (typeof colorFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
	                }
	                return colorFunction(context, value.values);
	            }
	            if (value.type === 5 /* HASH_TOKEN */) {
	                if (value.value.length === 3) {
	                    var r = value.value.substring(0, 1);
	                    var g = value.value.substring(1, 2);
	                    var b = value.value.substring(2, 3);
	                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
	                }
	                if (value.value.length === 4) {
	                    var r = value.value.substring(0, 1);
	                    var g = value.value.substring(1, 2);
	                    var b = value.value.substring(2, 3);
	                    var a = value.value.substring(3, 4);
	                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
	                }
	                if (value.value.length === 6) {
	                    var r = value.value.substring(0, 2);
	                    var g = value.value.substring(2, 4);
	                    var b = value.value.substring(4, 6);
	                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
	                }
	                if (value.value.length === 8) {
	                    var r = value.value.substring(0, 2);
	                    var g = value.value.substring(2, 4);
	                    var b = value.value.substring(4, 6);
	                    var a = value.value.substring(6, 8);
	                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
	                }
	            }
	            if (value.type === 20 /* IDENT_TOKEN */) {
	                var namedColor = COLORS[value.value.toUpperCase()];
	                if (typeof namedColor !== 'undefined') {
	                    return namedColor;
	                }
	            }
	            return COLORS.TRANSPARENT;
	        }
	    };
	    var isTransparent = function (color) { return (0xff & color) === 0; };
	    var asString = function (color) {
	        var alpha = 0xff & color;
	        var blue = 0xff & (color >> 8);
	        var green = 0xff & (color >> 16);
	        var red = 0xff & (color >> 24);
	        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
	    };
	    var pack = function (r, g, b, a) {
	        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
	    };
	    var getTokenColorValue = function (token, i) {
	        if (token.type === 17 /* NUMBER_TOKEN */) {
	            return token.number;
	        }
	        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
	            var max = i === 3 ? 1 : 255;
	            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
	        }
	        return 0;
	    };
	    var rgb = function (_context, args) {
	        var tokens = args.filter(nonFunctionArgSeparator);
	        if (tokens.length === 3) {
	            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
	            return pack(r, g, b, 1);
	        }
	        if (tokens.length === 4) {
	            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
	            return pack(r, g, b, a);
	        }
	        return 0;
	    };
	    function hue2rgb(t1, t2, hue) {
	        if (hue < 0) {
	            hue += 1;
	        }
	        if (hue >= 1) {
	            hue -= 1;
	        }
	        if (hue < 1 / 6) {
	            return (t2 - t1) * hue * 6 + t1;
	        }
	        else if (hue < 1 / 2) {
	            return t2;
	        }
	        else if (hue < 2 / 3) {
	            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
	        }
	        else {
	            return t1;
	        }
	    }
	    var hsl = function (context, args) {
	        var tokens = args.filter(nonFunctionArgSeparator);
	        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
	        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
	        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
	        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
	        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
	        if (s === 0) {
	            return pack(l * 255, l * 255, l * 255, 1);
	        }
	        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	        var t1 = l * 2 - t2;
	        var r = hue2rgb(t1, t2, h + 1 / 3);
	        var g = hue2rgb(t1, t2, h);
	        var b = hue2rgb(t1, t2, h - 1 / 3);
	        return pack(r * 255, g * 255, b * 255, a);
	    };
	    var SUPPORTED_COLOR_FUNCTIONS = {
	        hsl: hsl,
	        hsla: hsl,
	        rgb: rgb,
	        rgba: rgb
	    };
	    var parseColor = function (context, value) {
	        return color$1.parse(context, Parser.create(value).parseComponentValue());
	    };
	    var COLORS = {
	        ALICEBLUE: 0xf0f8ffff,
	        ANTIQUEWHITE: 0xfaebd7ff,
	        AQUA: 0x00ffffff,
	        AQUAMARINE: 0x7fffd4ff,
	        AZURE: 0xf0ffffff,
	        BEIGE: 0xf5f5dcff,
	        BISQUE: 0xffe4c4ff,
	        BLACK: 0x000000ff,
	        BLANCHEDALMOND: 0xffebcdff,
	        BLUE: 0x0000ffff,
	        BLUEVIOLET: 0x8a2be2ff,
	        BROWN: 0xa52a2aff,
	        BURLYWOOD: 0xdeb887ff,
	        CADETBLUE: 0x5f9ea0ff,
	        CHARTREUSE: 0x7fff00ff,
	        CHOCOLATE: 0xd2691eff,
	        CORAL: 0xff7f50ff,
	        CORNFLOWERBLUE: 0x6495edff,
	        CORNSILK: 0xfff8dcff,
	        CRIMSON: 0xdc143cff,
	        CYAN: 0x00ffffff,
	        DARKBLUE: 0x00008bff,
	        DARKCYAN: 0x008b8bff,
	        DARKGOLDENROD: 0xb886bbff,
	        DARKGRAY: 0xa9a9a9ff,
	        DARKGREEN: 0x006400ff,
	        DARKGREY: 0xa9a9a9ff,
	        DARKKHAKI: 0xbdb76bff,
	        DARKMAGENTA: 0x8b008bff,
	        DARKOLIVEGREEN: 0x556b2fff,
	        DARKORANGE: 0xff8c00ff,
	        DARKORCHID: 0x9932ccff,
	        DARKRED: 0x8b0000ff,
	        DARKSALMON: 0xe9967aff,
	        DARKSEAGREEN: 0x8fbc8fff,
	        DARKSLATEBLUE: 0x483d8bff,
	        DARKSLATEGRAY: 0x2f4f4fff,
	        DARKSLATEGREY: 0x2f4f4fff,
	        DARKTURQUOISE: 0x00ced1ff,
	        DARKVIOLET: 0x9400d3ff,
	        DEEPPINK: 0xff1493ff,
	        DEEPSKYBLUE: 0x00bfffff,
	        DIMGRAY: 0x696969ff,
	        DIMGREY: 0x696969ff,
	        DODGERBLUE: 0x1e90ffff,
	        FIREBRICK: 0xb22222ff,
	        FLORALWHITE: 0xfffaf0ff,
	        FORESTGREEN: 0x228b22ff,
	        FUCHSIA: 0xff00ffff,
	        GAINSBORO: 0xdcdcdcff,
	        GHOSTWHITE: 0xf8f8ffff,
	        GOLD: 0xffd700ff,
	        GOLDENROD: 0xdaa520ff,
	        GRAY: 0x808080ff,
	        GREEN: 0x008000ff,
	        GREENYELLOW: 0xadff2fff,
	        GREY: 0x808080ff,
	        HONEYDEW: 0xf0fff0ff,
	        HOTPINK: 0xff69b4ff,
	        INDIANRED: 0xcd5c5cff,
	        INDIGO: 0x4b0082ff,
	        IVORY: 0xfffff0ff,
	        KHAKI: 0xf0e68cff,
	        LAVENDER: 0xe6e6faff,
	        LAVENDERBLUSH: 0xfff0f5ff,
	        LAWNGREEN: 0x7cfc00ff,
	        LEMONCHIFFON: 0xfffacdff,
	        LIGHTBLUE: 0xadd8e6ff,
	        LIGHTCORAL: 0xf08080ff,
	        LIGHTCYAN: 0xe0ffffff,
	        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
	        LIGHTGRAY: 0xd3d3d3ff,
	        LIGHTGREEN: 0x90ee90ff,
	        LIGHTGREY: 0xd3d3d3ff,
	        LIGHTPINK: 0xffb6c1ff,
	        LIGHTSALMON: 0xffa07aff,
	        LIGHTSEAGREEN: 0x20b2aaff,
	        LIGHTSKYBLUE: 0x87cefaff,
	        LIGHTSLATEGRAY: 0x778899ff,
	        LIGHTSLATEGREY: 0x778899ff,
	        LIGHTSTEELBLUE: 0xb0c4deff,
	        LIGHTYELLOW: 0xffffe0ff,
	        LIME: 0x00ff00ff,
	        LIMEGREEN: 0x32cd32ff,
	        LINEN: 0xfaf0e6ff,
	        MAGENTA: 0xff00ffff,
	        MAROON: 0x800000ff,
	        MEDIUMAQUAMARINE: 0x66cdaaff,
	        MEDIUMBLUE: 0x0000cdff,
	        MEDIUMORCHID: 0xba55d3ff,
	        MEDIUMPURPLE: 0x9370dbff,
	        MEDIUMSEAGREEN: 0x3cb371ff,
	        MEDIUMSLATEBLUE: 0x7b68eeff,
	        MEDIUMSPRINGGREEN: 0x00fa9aff,
	        MEDIUMTURQUOISE: 0x48d1ccff,
	        MEDIUMVIOLETRED: 0xc71585ff,
	        MIDNIGHTBLUE: 0x191970ff,
	        MINTCREAM: 0xf5fffaff,
	        MISTYROSE: 0xffe4e1ff,
	        MOCCASIN: 0xffe4b5ff,
	        NAVAJOWHITE: 0xffdeadff,
	        NAVY: 0x000080ff,
	        OLDLACE: 0xfdf5e6ff,
	        OLIVE: 0x808000ff,
	        OLIVEDRAB: 0x6b8e23ff,
	        ORANGE: 0xffa500ff,
	        ORANGERED: 0xff4500ff,
	        ORCHID: 0xda70d6ff,
	        PALEGOLDENROD: 0xeee8aaff,
	        PALEGREEN: 0x98fb98ff,
	        PALETURQUOISE: 0xafeeeeff,
	        PALEVIOLETRED: 0xdb7093ff,
	        PAPAYAWHIP: 0xffefd5ff,
	        PEACHPUFF: 0xffdab9ff,
	        PERU: 0xcd853fff,
	        PINK: 0xffc0cbff,
	        PLUM: 0xdda0ddff,
	        POWDERBLUE: 0xb0e0e6ff,
	        PURPLE: 0x800080ff,
	        REBECCAPURPLE: 0x663399ff,
	        RED: 0xff0000ff,
	        ROSYBROWN: 0xbc8f8fff,
	        ROYALBLUE: 0x4169e1ff,
	        SADDLEBROWN: 0x8b4513ff,
	        SALMON: 0xfa8072ff,
	        SANDYBROWN: 0xf4a460ff,
	        SEAGREEN: 0x2e8b57ff,
	        SEASHELL: 0xfff5eeff,
	        SIENNA: 0xa0522dff,
	        SILVER: 0xc0c0c0ff,
	        SKYBLUE: 0x87ceebff,
	        SLATEBLUE: 0x6a5acdff,
	        SLATEGRAY: 0x708090ff,
	        SLATEGREY: 0x708090ff,
	        SNOW: 0xfffafaff,
	        SPRINGGREEN: 0x00ff7fff,
	        STEELBLUE: 0x4682b4ff,
	        TAN: 0xd2b48cff,
	        TEAL: 0x008080ff,
	        THISTLE: 0xd8bfd8ff,
	        TOMATO: 0xff6347ff,
	        TRANSPARENT: 0x00000000,
	        TURQUOISE: 0x40e0d0ff,
	        VIOLET: 0xee82eeff,
	        WHEAT: 0xf5deb3ff,
	        WHITE: 0xffffffff,
	        WHITESMOKE: 0xf5f5f5ff,
	        YELLOW: 0xffff00ff,
	        YELLOWGREEN: 0x9acd32ff
	    };
	
	    var backgroundClip = {
	        name: 'background-clip',
	        initialValue: 'border-box',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return tokens.map(function (token) {
	                if (isIdentToken(token)) {
	                    switch (token.value) {
	                        case 'padding-box':
	                            return 1 /* PADDING_BOX */;
	                        case 'content-box':
	                            return 2 /* CONTENT_BOX */;
	                    }
	                }
	                return 0 /* BORDER_BOX */;
	            });
	        }
	    };
	
	    var backgroundColor = {
	        name: "background-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'color'
	    };
	
	    var parseColorStop = function (context, args) {
	        var color = color$1.parse(context, args[0]);
	        var stop = args[1];
	        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
	    };
	    var processColorStops = function (stops, lineLength) {
	        var first = stops[0];
	        var last = stops[stops.length - 1];
	        if (first.stop === null) {
	            first.stop = ZERO_LENGTH;
	        }
	        if (last.stop === null) {
	            last.stop = HUNDRED_PERCENT;
	        }
	        var processStops = [];
	        var previous = 0;
	        for (var i = 0; i < stops.length; i++) {
	            var stop_1 = stops[i].stop;
	            if (stop_1 !== null) {
	                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
	                if (absoluteValue > previous) {
	                    processStops.push(absoluteValue);
	                }
	                else {
	                    processStops.push(previous);
	                }
	                previous = absoluteValue;
	            }
	            else {
	                processStops.push(null);
	            }
	        }
	        var gapBegin = null;
	        for (var i = 0; i < processStops.length; i++) {
	            var stop_2 = processStops[i];
	            if (stop_2 === null) {
	                if (gapBegin === null) {
	                    gapBegin = i;
	                }
	            }
	            else if (gapBegin !== null) {
	                var gapLength = i - gapBegin;
	                var beforeGap = processStops[gapBegin - 1];
	                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
	                for (var g = 1; g <= gapLength; g++) {
	                    processStops[gapBegin + g - 1] = gapValue * g;
	                }
	                gapBegin = null;
	            }
	        }
	        return stops.map(function (_a, i) {
	            var color = _a.color;
	            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
	        });
	    };
	    var getAngleFromCorner = function (corner, width, height) {
	        var centerX = width / 2;
	        var centerY = height / 2;
	        var x = getAbsoluteValue(corner[0], width) - centerX;
	        var y = centerY - getAbsoluteValue(corner[1], height);
	        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
	    };
	    var calculateGradientDirection = function (angle, width, height) {
	        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
	        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
	        var halfWidth = width / 2;
	        var halfHeight = height / 2;
	        var halfLineLength = lineLength / 2;
	        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
	        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
	        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
	    };
	    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
	    var findCorner = function (width, height, x, y, closest) {
	        var corners = [
	            [0, 0],
	            [0, height],
	            [width, 0],
	            [width, height]
	        ];
	        return corners.reduce(function (stat, corner) {
	            var cx = corner[0], cy = corner[1];
	            var d = distance(x - cx, y - cy);
	            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
	                return {
	                    optimumCorner: corner,
	                    optimumDistance: d
	                };
	            }
	            return stat;
	        }, {
	            optimumDistance: closest ? Infinity : -Infinity,
	            optimumCorner: null
	        }).optimumCorner;
	    };
	    var calculateRadius = function (gradient, x, y, width, height) {
	        var rx = 0;
	        var ry = 0;
	        switch (gradient.size) {
	            case 0 /* CLOSEST_SIDE */:
	                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
	                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
	                if (gradient.shape === 0 /* CIRCLE */) {
	                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
	                }
	                else if (gradient.shape === 1 /* ELLIPSE */) {
	                    rx = Math.min(Math.abs(x), Math.abs(x - width));
	                    ry = Math.min(Math.abs(y), Math.abs(y - height));
	                }
	                break;
	            case 2 /* CLOSEST_CORNER */:
	                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
	                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
	                if (gradient.shape === 0 /* CIRCLE */) {
	                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
	                }
	                else if (gradient.shape === 1 /* ELLIPSE */) {
	                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
	                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
	                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
	                    rx = distance(cx - x, (cy - y) / c);
	                    ry = c * rx;
	                }
	                break;
	            case 1 /* FARTHEST_SIDE */:
	                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
	                if (gradient.shape === 0 /* CIRCLE */) {
	                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
	                }
	                else if (gradient.shape === 1 /* ELLIPSE */) {
	                    rx = Math.max(Math.abs(x), Math.abs(x - width));
	                    ry = Math.max(Math.abs(y), Math.abs(y - height));
	                }
	                break;
	            case 3 /* FARTHEST_CORNER */:
	                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
	                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
	                if (gradient.shape === 0 /* CIRCLE */) {
	                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
	                }
	                else if (gradient.shape === 1 /* ELLIPSE */) {
	                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
	                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
	                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
	                    rx = distance(cx - x, (cy - y) / c);
	                    ry = c * rx;
	                }
	                break;
	        }
	        if (Array.isArray(gradient.size)) {
	            rx = getAbsoluteValue(gradient.size[0], width);
	            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
	        }
	        return [rx, ry];
	    };
	
	    var linearGradient = function (context, tokens) {
	        var angle$1 = deg(180);
	        var stops = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            if (i === 0) {
	                var firstToken = arg[0];
	                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
	                    angle$1 = parseNamedSide(arg);
	                    return;
	                }
	                else if (isAngle(firstToken)) {
	                    angle$1 = angle.parse(context, firstToken);
	                    return;
	                }
	            }
	            var colorStop = parseColorStop(context, arg);
	            stops.push(colorStop);
	        });
	        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
	    };
	
	    var prefixLinearGradient = function (context, tokens) {
	        var angle$1 = deg(180);
	        var stops = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            if (i === 0) {
	                var firstToken = arg[0];
	                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
	                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
	                    angle$1 = parseNamedSide(arg);
	                    return;
	                }
	                else if (isAngle(firstToken)) {
	                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
	                    return;
	                }
	            }
	            var colorStop = parseColorStop(context, arg);
	            stops.push(colorStop);
	        });
	        return {
	            angle: angle$1,
	            stops: stops,
	            type: 1 /* LINEAR_GRADIENT */
	        };
	    };
	
	    var webkitGradient = function (context, tokens) {
	        var angle = deg(180);
	        var stops = [];
	        var type = 1 /* LINEAR_GRADIENT */;
	        var shape = 0 /* CIRCLE */;
	        var size = 3 /* FARTHEST_CORNER */;
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var firstToken = arg[0];
	            if (i === 0) {
	                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
	                    type = 1 /* LINEAR_GRADIENT */;
	                    return;
	                }
	                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
	                    type = 2 /* RADIAL_GRADIENT */;
	                    return;
	                }
	            }
	            if (firstToken.type === 18 /* FUNCTION */) {
	                if (firstToken.name === 'from') {
	                    var color = color$1.parse(context, firstToken.values[0]);
	                    stops.push({ stop: ZERO_LENGTH, color: color });
	                }
	                else if (firstToken.name === 'to') {
	                    var color = color$1.parse(context, firstToken.values[0]);
	                    stops.push({ stop: HUNDRED_PERCENT, color: color });
	                }
	                else if (firstToken.name === 'color-stop') {
	                    var values = firstToken.values.filter(nonFunctionArgSeparator);
	                    if (values.length === 2) {
	                        var color = color$1.parse(context, values[1]);
	                        var stop_1 = values[0];
	                        if (isNumberToken(stop_1)) {
	                            stops.push({
	                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
	                                color: color
	                            });
	                        }
	                    }
	                }
	            }
	        });
	        return type === 1 /* LINEAR_GRADIENT */
	            ? {
	                angle: (angle + deg(180)) % deg(360),
	                stops: stops,
	                type: type
	            }
	            : { size: size, shape: shape, stops: stops, position: position, type: type };
	    };
	
	    var CLOSEST_SIDE = 'closest-side';
	    var FARTHEST_SIDE = 'farthest-side';
	    var CLOSEST_CORNER = 'closest-corner';
	    var FARTHEST_CORNER = 'farthest-corner';
	    var CIRCLE = 'circle';
	    var ELLIPSE = 'ellipse';
	    var COVER = 'cover';
	    var CONTAIN = 'contain';
	    var radialGradient = function (context, tokens) {
	        var shape = 0 /* CIRCLE */;
	        var size = 3 /* FARTHEST_CORNER */;
	        var stops = [];
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var isColorStop = true;
	            if (i === 0) {
	                var isAtPosition_1 = false;
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isAtPosition_1) {
	                        if (isIdentToken(token)) {
	                            switch (token.value) {
	                                case 'center':
	                                    position.push(FIFTY_PERCENT);
	                                    return acc;
	                                case 'top':
	                                case 'left':
	                                    position.push(ZERO_LENGTH);
	                                    return acc;
	                                case 'right':
	                                case 'bottom':
	                                    position.push(HUNDRED_PERCENT);
	                                    return acc;
	                            }
	                        }
	                        else if (isLengthPercentage(token) || isLength(token)) {
	                            position.push(token);
	                        }
	                    }
	                    else if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case CIRCLE:
	                                shape = 0 /* CIRCLE */;
	                                return false;
	                            case ELLIPSE:
	                                shape = 1 /* ELLIPSE */;
	                                return false;
	                            case 'at':
	                                isAtPosition_1 = true;
	                                return false;
	                            case CLOSEST_SIDE:
	                                size = 0 /* CLOSEST_SIDE */;
	                                return false;
	                            case COVER:
	                            case FARTHEST_SIDE:
	                                size = 1 /* FARTHEST_SIDE */;
	                                return false;
	                            case CONTAIN:
	                            case CLOSEST_CORNER:
	                                size = 2 /* CLOSEST_CORNER */;
	                                return false;
	                            case FARTHEST_CORNER:
	                                size = 3 /* FARTHEST_CORNER */;
	                                return false;
	                        }
	                    }
	                    else if (isLength(token) || isLengthPercentage(token)) {
	                        if (!Array.isArray(size)) {
	                            size = [];
	                        }
	                        size.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            if (isColorStop) {
	                var colorStop = parseColorStop(context, arg);
	                stops.push(colorStop);
	            }
	        });
	        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
	    };
	
	    var prefixRadialGradient = function (context, tokens) {
	        var shape = 0 /* CIRCLE */;
	        var size = 3 /* FARTHEST_CORNER */;
	        var stops = [];
	        var position = [];
	        parseFunctionArgs(tokens).forEach(function (arg, i) {
	            var isColorStop = true;
	            if (i === 0) {
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case 'center':
	                                position.push(FIFTY_PERCENT);
	                                return false;
	                            case 'top':
	                            case 'left':
	                                position.push(ZERO_LENGTH);
	                                return false;
	                            case 'right':
	                            case 'bottom':
	                                position.push(HUNDRED_PERCENT);
	                                return false;
	                        }
	                    }
	                    else if (isLengthPercentage(token) || isLength(token)) {
	                        position.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            else if (i === 1) {
	                isColorStop = arg.reduce(function (acc, token) {
	                    if (isIdentToken(token)) {
	                        switch (token.value) {
	                            case CIRCLE:
	                                shape = 0 /* CIRCLE */;
	                                return false;
	                            case ELLIPSE:
	                                shape = 1 /* ELLIPSE */;
	                                return false;
	                            case CONTAIN:
	                            case CLOSEST_SIDE:
	                                size = 0 /* CLOSEST_SIDE */;
	                                return false;
	                            case FARTHEST_SIDE:
	                                size = 1 /* FARTHEST_SIDE */;
	                                return false;
	                            case CLOSEST_CORNER:
	                                size = 2 /* CLOSEST_CORNER */;
	                                return false;
	                            case COVER:
	                            case FARTHEST_CORNER:
	                                size = 3 /* FARTHEST_CORNER */;
	                                return false;
	                        }
	                    }
	                    else if (isLength(token) || isLengthPercentage(token)) {
	                        if (!Array.isArray(size)) {
	                            size = [];
	                        }
	                        size.push(token);
	                        return false;
	                    }
	                    return acc;
	                }, isColorStop);
	            }
	            if (isColorStop) {
	                var colorStop = parseColorStop(context, arg);
	                stops.push(colorStop);
	            }
	        });
	        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
	    };
	
	    var isLinearGradient = function (background) {
	        return background.type === 1 /* LINEAR_GRADIENT */;
	    };
	    var isRadialGradient = function (background) {
	        return background.type === 2 /* RADIAL_GRADIENT */;
	    };
	    var image = {
	        name: 'image',
	        parse: function (context, value) {
	            if (value.type === 22 /* URL_TOKEN */) {
	                var image_1 = { url: value.value, type: 0 /* URL */ };
	                context.cache.addImage(value.value);
	                return image_1;
	            }
	            if (value.type === 18 /* FUNCTION */) {
	                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
	                if (typeof imageFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
	                }
	                return imageFunction(context, value.values);
	            }
	            throw new Error("Unsupported image type " + value.type);
	        }
	    };
	    function isSupportedImage(value) {
	        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
	            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
	    }
	    var SUPPORTED_IMAGE_FUNCTIONS = {
	        'linear-gradient': linearGradient,
	        '-moz-linear-gradient': prefixLinearGradient,
	        '-ms-linear-gradient': prefixLinearGradient,
	        '-o-linear-gradient': prefixLinearGradient,
	        '-webkit-linear-gradient': prefixLinearGradient,
	        'radial-gradient': radialGradient,
	        '-moz-radial-gradient': prefixRadialGradient,
	        '-ms-radial-gradient': prefixRadialGradient,
	        '-o-radial-gradient': prefixRadialGradient,
	        '-webkit-radial-gradient': prefixRadialGradient,
	        '-webkit-gradient': webkitGradient
	    };
	
	    var backgroundImage = {
	        name: 'background-image',
	        initialValue: 'none',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (context, tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var first = tokens[0];
	            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
	                return [];
	            }
	            return tokens
	                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
	                .map(function (value) { return image.parse(context, value); });
	        }
	    };
	
	    var backgroundOrigin = {
	        name: 'background-origin',
	        initialValue: 'border-box',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return tokens.map(function (token) {
	                if (isIdentToken(token)) {
	                    switch (token.value) {
	                        case 'padding-box':
	                            return 1 /* PADDING_BOX */;
	                        case 'content-box':
	                            return 2 /* CONTENT_BOX */;
	                    }
	                }
	                return 0 /* BORDER_BOX */;
	            });
	        }
	    };
	
	    var backgroundPosition = {
	        name: 'background-position',
	        initialValue: '0% 0%',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (_context, tokens) {
	            return parseFunctionArgs(tokens)
	                .map(function (values) { return values.filter(isLengthPercentage); })
	                .map(parseLengthPercentageTuple);
	        }
	    };
	
	    var backgroundRepeat = {
	        name: 'background-repeat',
	        initialValue: 'repeat',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return parseFunctionArgs(tokens)
	                .map(function (values) {
	                return values
	                    .filter(isIdentToken)
	                    .map(function (token) { return token.value; })
	                    .join(' ');
	            })
	                .map(parseBackgroundRepeat);
	        }
	    };
	    var parseBackgroundRepeat = function (value) {
	        switch (value) {
	            case 'no-repeat':
	                return 1 /* NO_REPEAT */;
	            case 'repeat-x':
	            case 'repeat no-repeat':
	                return 2 /* REPEAT_X */;
	            case 'repeat-y':
	            case 'no-repeat repeat':
	                return 3 /* REPEAT_Y */;
	            case 'repeat':
	            default:
	                return 0 /* REPEAT */;
	        }
	    };
	
	    var BACKGROUND_SIZE;
	    (function (BACKGROUND_SIZE) {
	        BACKGROUND_SIZE["AUTO"] = "auto";
	        BACKGROUND_SIZE["CONTAIN"] = "contain";
	        BACKGROUND_SIZE["COVER"] = "cover";
	    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
	    var backgroundSize = {
	        name: 'background-size',
	        initialValue: '0',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
	        }
	    };
	    var isBackgroundSizeInfoToken = function (value) {
	        return isIdentToken(value) || isLengthPercentage(value);
	    };
	
	    var borderColorForSide = function (side) { return ({
	        name: "border-" + side + "-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'color'
	    }); };
	    var borderTopColor = borderColorForSide('top');
	    var borderRightColor = borderColorForSide('right');
	    var borderBottomColor = borderColorForSide('bottom');
	    var borderLeftColor = borderColorForSide('left');
	
	    var borderRadiusForSide = function (side) { return ({
	        name: "border-radius-" + side,
	        initialValue: '0 0',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
	        }
	    }); };
	    var borderTopLeftRadius = borderRadiusForSide('top-left');
	    var borderTopRightRadius = borderRadiusForSide('top-right');
	    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
	    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
	
	    var borderStyleForSide = function (side) { return ({
	        name: "border-" + side + "-style",
	        initialValue: 'solid',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, style) {
	            switch (style) {
	                case 'none':
	                    return 0 /* NONE */;
	                case 'dashed':
	                    return 2 /* DASHED */;
	                case 'dotted':
	                    return 3 /* DOTTED */;
	                case 'double':
	                    return 4 /* DOUBLE */;
	            }
	            return 1 /* SOLID */;
	        }
	    }); };
	    var borderTopStyle = borderStyleForSide('top');
	    var borderRightStyle = borderStyleForSide('right');
	    var borderBottomStyle = borderStyleForSide('bottom');
	    var borderLeftStyle = borderStyleForSide('left');
	
	    var borderWidthForSide = function (side) { return ({
	        name: "border-" + side + "-width",
	        initialValue: '0',
	        type: 0 /* VALUE */,
	        prefix: false,
	        parse: function (_context, token) {
	            if (isDimensionToken(token)) {
	                return token.number;
	            }
	            return 0;
	        }
	    }); };
	    var borderTopWidth = borderWidthForSide('top');
	    var borderRightWidth = borderWidthForSide('right');
	    var borderBottomWidth = borderWidthForSide('bottom');
	    var borderLeftWidth = borderWidthForSide('left');
	
	    var color = {
	        name: "color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'color'
	    };
	
	    var direction = {
	        name: 'direction',
	        initialValue: 'ltr',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, direction) {
	            switch (direction) {
	                case 'rtl':
	                    return 1 /* RTL */;
	                case 'ltr':
	                default:
	                    return 0 /* LTR */;
	            }
	        }
	    };
	
	    var display = {
	        name: 'display',
	        initialValue: 'inline-block',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return tokens.filter(isIdentToken).reduce(function (bit, token) {
	                return bit | parseDisplayValue(token.value);
	            }, 0 /* NONE */);
	        }
	    };
	    var parseDisplayValue = function (display) {
	        switch (display) {
	            case 'block':
	            case '-webkit-box':
	                return 2 /* BLOCK */;
	            case 'inline':
	                return 4 /* INLINE */;
	            case 'run-in':
	                return 8 /* RUN_IN */;
	            case 'flow':
	                return 16 /* FLOW */;
	            case 'flow-root':
	                return 32 /* FLOW_ROOT */;
	            case 'table':
	                return 64 /* TABLE */;
	            case 'flex':
	            case '-webkit-flex':
	                return 128 /* FLEX */;
	            case 'grid':
	            case '-ms-grid':
	                return 256 /* GRID */;
	            case 'ruby':
	                return 512 /* RUBY */;
	            case 'subgrid':
	                return 1024 /* SUBGRID */;
	            case 'list-item':
	                return 2048 /* LIST_ITEM */;
	            case 'table-row-group':
	                return 4096 /* TABLE_ROW_GROUP */;
	            case 'table-header-group':
	                return 8192 /* TABLE_HEADER_GROUP */;
	            case 'table-footer-group':
	                return 16384 /* TABLE_FOOTER_GROUP */;
	            case 'table-row':
	                return 32768 /* TABLE_ROW */;
	            case 'table-cell':
	                return 65536 /* TABLE_CELL */;
	            case 'table-column-group':
	                return 131072 /* TABLE_COLUMN_GROUP */;
	            case 'table-column':
	                return 262144 /* TABLE_COLUMN */;
	            case 'table-caption':
	                return 524288 /* TABLE_CAPTION */;
	            case 'ruby-base':
	                return 1048576 /* RUBY_BASE */;
	            case 'ruby-text':
	                return 2097152 /* RUBY_TEXT */;
	            case 'ruby-base-container':
	                return 4194304 /* RUBY_BASE_CONTAINER */;
	            case 'ruby-text-container':
	                return 8388608 /* RUBY_TEXT_CONTAINER */;
	            case 'contents':
	                return 16777216 /* CONTENTS */;
	            case 'inline-block':
	                return 33554432 /* INLINE_BLOCK */;
	            case 'inline-list-item':
	                return 67108864 /* INLINE_LIST_ITEM */;
	            case 'inline-table':
	                return 134217728 /* INLINE_TABLE */;
	            case 'inline-flex':
	                return 268435456 /* INLINE_FLEX */;
	            case 'inline-grid':
	                return 536870912 /* INLINE_GRID */;
	        }
	        return 0 /* NONE */;
	    };
	
	    var float = {
	        name: 'float',
	        initialValue: 'none',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, float) {
	            switch (float) {
	                case 'left':
	                    return 1 /* LEFT */;
	                case 'right':
	                    return 2 /* RIGHT */;
	                case 'inline-start':
	                    return 3 /* INLINE_START */;
	                case 'inline-end':
	                    return 4 /* INLINE_END */;
	            }
	            return 0 /* NONE */;
	        }
	    };
	
	    var letterSpacing = {
	        name: 'letter-spacing',
	        initialValue: '0',
	        prefix: false,
	        type: 0 /* VALUE */,
	        parse: function (_context, token) {
	            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
	                return 0;
	            }
	            if (token.type === 17 /* NUMBER_TOKEN */) {
	                return token.number;
	            }
	            if (token.type === 15 /* DIMENSION_TOKEN */) {
	                return token.number;
	            }
	            return 0;
	        }
	    };
	
	    var LINE_BREAK;
	    (function (LINE_BREAK) {
	        LINE_BREAK["NORMAL"] = "normal";
	        LINE_BREAK["STRICT"] = "strict";
	    })(LINE_BREAK || (LINE_BREAK = {}));
	    var lineBreak = {
	        name: 'line-break',
	        initialValue: 'normal',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, lineBreak) {
	            switch (lineBreak) {
	                case 'strict':
	                    return LINE_BREAK.STRICT;
	                case 'normal':
	                default:
	                    return LINE_BREAK.NORMAL;
	            }
	        }
	    };
	
	    var lineHeight = {
	        name: 'line-height',
	        initialValue: 'normal',
	        prefix: false,
	        type: 4 /* TOKEN_VALUE */
	    };
	    var computeLineHeight = function (token, fontSize) {
	        if (isIdentToken(token) && token.value === 'normal') {
	            return 1.2 * fontSize;
	        }
	        else if (token.type === 17 /* NUMBER_TOKEN */) {
	            return fontSize * token.number;
	        }
	        else if (isLengthPercentage(token)) {
	            return getAbsoluteValue(token, fontSize);
	        }
	        return fontSize;
	    };
	
	    var listStyleImage = {
	        name: 'list-style-image',
	        initialValue: 'none',
	        type: 0 /* VALUE */,
	        prefix: false,
	        parse: function (context, token) {
	            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
	                return null;
	            }
	            return image.parse(context, token);
	        }
	    };
	
	    var listStylePosition = {
	        name: 'list-style-position',
	        initialValue: 'outside',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, position) {
	            switch (position) {
	                case 'inside':
	                    return 0 /* INSIDE */;
	                case 'outside':
	                default:
	                    return 1 /* OUTSIDE */;
	            }
	        }
	    };
	
	    var listStyleType = {
	        name: 'list-style-type',
	        initialValue: 'none',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, type) {
	            switch (type) {
	                case 'disc':
	                    return 0 /* DISC */;
	                case 'circle':
	                    return 1 /* CIRCLE */;
	                case 'square':
	                    return 2 /* SQUARE */;
	                case 'decimal':
	                    return 3 /* DECIMAL */;
	                case 'cjk-decimal':
	                    return 4 /* CJK_DECIMAL */;
	                case 'decimal-leading-zero':
	                    return 5 /* DECIMAL_LEADING_ZERO */;
	                case 'lower-roman':
	                    return 6 /* LOWER_ROMAN */;
	                case 'upper-roman':
	                    return 7 /* UPPER_ROMAN */;
	                case 'lower-greek':
	                    return 8 /* LOWER_GREEK */;
	                case 'lower-alpha':
	                    return 9 /* LOWER_ALPHA */;
	                case 'upper-alpha':
	                    return 10 /* UPPER_ALPHA */;
	                case 'arabic-indic':
	                    return 11 /* ARABIC_INDIC */;
	                case 'armenian':
	                    return 12 /* ARMENIAN */;
	                case 'bengali':
	                    return 13 /* BENGALI */;
	                case 'cambodian':
	                    return 14 /* CAMBODIAN */;
	                case 'cjk-earthly-branch':
	                    return 15 /* CJK_EARTHLY_BRANCH */;
	                case 'cjk-heavenly-stem':
	                    return 16 /* CJK_HEAVENLY_STEM */;
	                case 'cjk-ideographic':
	                    return 17 /* CJK_IDEOGRAPHIC */;
	                case 'devanagari':
	                    return 18 /* DEVANAGARI */;
	                case 'ethiopic-numeric':
	                    return 19 /* ETHIOPIC_NUMERIC */;
	                case 'georgian':
	                    return 20 /* GEORGIAN */;
	                case 'gujarati':
	                    return 21 /* GUJARATI */;
	                case 'gurmukhi':
	                    return 22 /* GURMUKHI */;
	                case 'hebrew':
	                    return 22 /* HEBREW */;
	                case 'hiragana':
	                    return 23 /* HIRAGANA */;
	                case 'hiragana-iroha':
	                    return 24 /* HIRAGANA_IROHA */;
	                case 'japanese-formal':
	                    return 25 /* JAPANESE_FORMAL */;
	                case 'japanese-informal':
	                    return 26 /* JAPANESE_INFORMAL */;
	                case 'kannada':
	                    return 27 /* KANNADA */;
	                case 'katakana':
	                    return 28 /* KATAKANA */;
	                case 'katakana-iroha':
	                    return 29 /* KATAKANA_IROHA */;
	                case 'khmer':
	                    return 30 /* KHMER */;
	                case 'korean-hangul-formal':
	                    return 31 /* KOREAN_HANGUL_FORMAL */;
	                case 'korean-hanja-formal':
	                    return 32 /* KOREAN_HANJA_FORMAL */;
	                case 'korean-hanja-informal':
	                    return 33 /* KOREAN_HANJA_INFORMAL */;
	                case 'lao':
	                    return 34 /* LAO */;
	                case 'lower-armenian':
	                    return 35 /* LOWER_ARMENIAN */;
	                case 'malayalam':
	                    return 36 /* MALAYALAM */;
	                case 'mongolian':
	                    return 37 /* MONGOLIAN */;
	                case 'myanmar':
	                    return 38 /* MYANMAR */;
	                case 'oriya':
	                    return 39 /* ORIYA */;
	                case 'persian':
	                    return 40 /* PERSIAN */;
	                case 'simp-chinese-formal':
	                    return 41 /* SIMP_CHINESE_FORMAL */;
	                case 'simp-chinese-informal':
	                    return 42 /* SIMP_CHINESE_INFORMAL */;
	                case 'tamil':
	                    return 43 /* TAMIL */;
	                case 'telugu':
	                    return 44 /* TELUGU */;
	                case 'thai':
	                    return 45 /* THAI */;
	                case 'tibetan':
	                    return 46 /* TIBETAN */;
	                case 'trad-chinese-formal':
	                    return 47 /* TRAD_CHINESE_FORMAL */;
	                case 'trad-chinese-informal':
	                    return 48 /* TRAD_CHINESE_INFORMAL */;
	                case 'upper-armenian':
	                    return 49 /* UPPER_ARMENIAN */;
	                case 'disclosure-open':
	                    return 50 /* DISCLOSURE_OPEN */;
	                case 'disclosure-closed':
	                    return 51 /* DISCLOSURE_CLOSED */;
	                case 'none':
	                default:
	                    return -1 /* NONE */;
	            }
	        }
	    };
	
	    var marginForSide = function (side) { return ({
	        name: "margin-" + side,
	        initialValue: '0',
	        prefix: false,
	        type: 4 /* TOKEN_VALUE */
	    }); };
	    var marginTop = marginForSide('top');
	    var marginRight = marginForSide('right');
	    var marginBottom = marginForSide('bottom');
	    var marginLeft = marginForSide('left');
	
	    var overflow = {
	        name: 'overflow',
	        initialValue: 'visible',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return tokens.filter(isIdentToken).map(function (overflow) {
	                switch (overflow.value) {
	                    case 'hidden':
	                        return 1 /* HIDDEN */;
	                    case 'scroll':
	                        return 2 /* SCROLL */;
	                    case 'clip':
	                        return 3 /* CLIP */;
	                    case 'auto':
	                        return 4 /* AUTO */;
	                    case 'visible':
	                    default:
	                        return 0 /* VISIBLE */;
	                }
	            });
	        }
	    };
	
	    var overflowWrap = {
	        name: 'overflow-wrap',
	        initialValue: 'normal',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, overflow) {
	            switch (overflow) {
	                case 'break-word':
	                    return "break-word" /* BREAK_WORD */;
	                case 'normal':
	                default:
	                    return "normal" /* NORMAL */;
	            }
	        }
	    };
	
	    var paddingForSide = function (side) { return ({
	        name: "padding-" + side,
	        initialValue: '0',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'length-percentage'
	    }); };
	    var paddingTop = paddingForSide('top');
	    var paddingRight = paddingForSide('right');
	    var paddingBottom = paddingForSide('bottom');
	    var paddingLeft = paddingForSide('left');
	
	    var textAlign = {
	        name: 'text-align',
	        initialValue: 'left',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, textAlign) {
	            switch (textAlign) {
	                case 'right':
	                    return 2 /* RIGHT */;
	                case 'center':
	                case 'justify':
	                    return 1 /* CENTER */;
	                case 'left':
	                default:
	                    return 0 /* LEFT */;
	            }
	        }
	    };
	
	    var position = {
	        name: 'position',
	        initialValue: 'static',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, position) {
	            switch (position) {
	                case 'relative':
	                    return 1 /* RELATIVE */;
	                case 'absolute':
	                    return 2 /* ABSOLUTE */;
	                case 'fixed':
	                    return 3 /* FIXED */;
	                case 'sticky':
	                    return 4 /* STICKY */;
	            }
	            return 0 /* STATIC */;
	        }
	    };
	
	    var textShadow = {
	        name: 'text-shadow',
	        initialValue: 'none',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (context, tokens) {
	            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
	                return [];
	            }
	            return parseFunctionArgs(tokens).map(function (values) {
	                var shadow = {
	                    color: COLORS.TRANSPARENT,
	                    offsetX: ZERO_LENGTH,
	                    offsetY: ZERO_LENGTH,
	                    blur: ZERO_LENGTH
	                };
	                var c = 0;
	                for (var i = 0; i < values.length; i++) {
	                    var token = values[i];
	                    if (isLength(token)) {
	                        if (c === 0) {
	                            shadow.offsetX = token;
	                        }
	                        else if (c === 1) {
	                            shadow.offsetY = token;
	                        }
	                        else {
	                            shadow.blur = token;
	                        }
	                        c++;
	                    }
	                    else {
	                        shadow.color = color$1.parse(context, token);
	                    }
	                }
	                return shadow;
	            });
	        }
	    };
	
	    var textTransform = {
	        name: 'text-transform',
	        initialValue: 'none',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, textTransform) {
	            switch (textTransform) {
	                case 'uppercase':
	                    return 2 /* UPPERCASE */;
	                case 'lowercase':
	                    return 1 /* LOWERCASE */;
	                case 'capitalize':
	                    return 3 /* CAPITALIZE */;
	            }
	            return 0 /* NONE */;
	        }
	    };
	
	    var transform$1 = {
	        name: 'transform',
	        initialValue: 'none',
	        prefix: true,
	        type: 0 /* VALUE */,
	        parse: function (_context, token) {
	            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
	                return null;
	            }
	            if (token.type === 18 /* FUNCTION */) {
	                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
	                if (typeof transformFunction === 'undefined') {
	                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
	                }
	                return transformFunction(token.values);
	            }
	            return null;
	        }
	    };
	    var matrix = function (args) {
	        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
	        return values.length === 6 ? values : null;
	    };
	    // doesn't support 3D transforms at the moment
	    var matrix3d = function (args) {
	        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
	        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
	        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
	    };
	    var SUPPORTED_TRANSFORM_FUNCTIONS = {
	        matrix: matrix,
	        matrix3d: matrix3d
	    };
	
	    var DEFAULT_VALUE = {
	        type: 16 /* PERCENTAGE_TOKEN */,
	        number: 50,
	        flags: FLAG_INTEGER
	    };
	    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
	    var transformOrigin = {
	        name: 'transform-origin',
	        initialValue: '50% 50%',
	        prefix: true,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            var origins = tokens.filter(isLengthPercentage);
	            if (origins.length !== 2) {
	                return DEFAULT;
	            }
	            return [origins[0], origins[1]];
	        }
	    };
	
	    var visibility = {
	        name: 'visible',
	        initialValue: 'none',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, visibility) {
	            switch (visibility) {
	                case 'hidden':
	                    return 1 /* HIDDEN */;
	                case 'collapse':
	                    return 2 /* COLLAPSE */;
	                case 'visible':
	                default:
	                    return 0 /* VISIBLE */;
	            }
	        }
	    };
	
	    var WORD_BREAK;
	    (function (WORD_BREAK) {
	        WORD_BREAK["NORMAL"] = "normal";
	        WORD_BREAK["BREAK_ALL"] = "break-all";
	        WORD_BREAK["KEEP_ALL"] = "keep-all";
	    })(WORD_BREAK || (WORD_BREAK = {}));
	    var wordBreak = {
	        name: 'word-break',
	        initialValue: 'normal',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, wordBreak) {
	            switch (wordBreak) {
	                case 'break-all':
	                    return WORD_BREAK.BREAK_ALL;
	                case 'keep-all':
	                    return WORD_BREAK.KEEP_ALL;
	                case 'normal':
	                default:
	                    return WORD_BREAK.NORMAL;
	            }
	        }
	    };
	
	    var zIndex = {
	        name: 'z-index',
	        initialValue: 'auto',
	        prefix: false,
	        type: 0 /* VALUE */,
	        parse: function (_context, token) {
	            if (token.type === 20 /* IDENT_TOKEN */) {
	                return { auto: true, order: 0 };
	            }
	            if (isNumberToken(token)) {
	                return { auto: false, order: token.number };
	            }
	            throw new Error("Invalid z-index number parsed");
	        }
	    };
	
	    var time = {
	        name: 'time',
	        parse: function (_context, value) {
	            if (value.type === 15 /* DIMENSION_TOKEN */) {
	                switch (value.unit.toLowerCase()) {
	                    case 's':
	                        return 1000 * value.number;
	                    case 'ms':
	                        return value.number;
	                }
	            }
	            throw new Error("Unsupported time type");
	        }
	    };
	
	    var opacity = {
	        name: 'opacity',
	        initialValue: '1',
	        type: 0 /* VALUE */,
	        prefix: false,
	        parse: function (_context, token) {
	            if (isNumberToken(token)) {
	                return token.number;
	            }
	            return 1;
	        }
	    };
	
	    var textDecorationColor = {
	        name: "text-decoration-color",
	        initialValue: 'transparent',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'color'
	    };
	
	    var textDecorationLine = {
	        name: 'text-decoration-line',
	        initialValue: 'none',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            return tokens
	                .filter(isIdentToken)
	                .map(function (token) {
	                switch (token.value) {
	                    case 'underline':
	                        return 1 /* UNDERLINE */;
	                    case 'overline':
	                        return 2 /* OVERLINE */;
	                    case 'line-through':
	                        return 3 /* LINE_THROUGH */;
	                    case 'none':
	                        return 4 /* BLINK */;
	                }
	                return 0 /* NONE */;
	            })
	                .filter(function (line) { return line !== 0 /* NONE */; });
	        }
	    };
	
	    var fontFamily = {
	        name: "font-family",
	        initialValue: '',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            var accumulator = [];
	            var results = [];
	            tokens.forEach(function (token) {
	                switch (token.type) {
	                    case 20 /* IDENT_TOKEN */:
	                    case 0 /* STRING_TOKEN */:
	                        accumulator.push(token.value);
	                        break;
	                    case 17 /* NUMBER_TOKEN */:
	                        accumulator.push(token.number.toString());
	                        break;
	                    case 4 /* COMMA_TOKEN */:
	                        results.push(accumulator.join(' '));
	                        accumulator.length = 0;
	                        break;
	                }
	            });
	            if (accumulator.length) {
	                results.push(accumulator.join(' '));
	            }
	            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
	        }
	    };
	
	    var fontSize = {
	        name: "font-size",
	        initialValue: '0',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'length'
	    };
	
	    var fontWeight = {
	        name: 'font-weight',
	        initialValue: 'normal',
	        type: 0 /* VALUE */,
	        prefix: false,
	        parse: function (_context, token) {
	            if (isNumberToken(token)) {
	                return token.number;
	            }
	            if (isIdentToken(token)) {
	                switch (token.value) {
	                    case 'bold':
	                        return 700;
	                    case 'normal':
	                    default:
	                        return 400;
	                }
	            }
	            return 400;
	        }
	    };
	
	    var fontVariant = {
	        name: 'font-variant',
	        initialValue: 'none',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (_context, tokens) {
	            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
	        }
	    };
	
	    var fontStyle = {
	        name: 'font-style',
	        initialValue: 'normal',
	        prefix: false,
	        type: 2 /* IDENT_VALUE */,
	        parse: function (_context, overflow) {
	            switch (overflow) {
	                case 'oblique':
	                    return "oblique" /* OBLIQUE */;
	                case 'italic':
	                    return "italic" /* ITALIC */;
	                case 'normal':
	                default:
	                    return "normal" /* NORMAL */;
	            }
	        }
	    };
	
	    var contains = function (bit, value) { return (bit & value) !== 0; };
	
	    var content = {
	        name: 'content',
	        initialValue: 'none',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (_context, tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var first = tokens[0];
	            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
	                return [];
	            }
	            return tokens;
	        }
	    };
	
	    var counterIncrement = {
	        name: 'counter-increment',
	        initialValue: 'none',
	        prefix: true,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            if (tokens.length === 0) {
	                return null;
	            }
	            var first = tokens[0];
	            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
	                return null;
	            }
	            var increments = [];
	            var filtered = tokens.filter(nonWhiteSpace);
	            for (var i = 0; i < filtered.length; i++) {
	                var counter = filtered[i];
	                var next = filtered[i + 1];
	                if (counter.type === 20 /* IDENT_TOKEN */) {
	                    var increment = next && isNumberToken(next) ? next.number : 1;
	                    increments.push({ counter: counter.value, increment: increment });
	                }
	            }
	            return increments;
	        }
	    };
	
	    var counterReset = {
	        name: 'counter-reset',
	        initialValue: 'none',
	        prefix: true,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            if (tokens.length === 0) {
	                return [];
	            }
	            var resets = [];
	            var filtered = tokens.filter(nonWhiteSpace);
	            for (var i = 0; i < filtered.length; i++) {
	                var counter = filtered[i];
	                var next = filtered[i + 1];
	                if (isIdentToken(counter) && counter.value !== 'none') {
	                    var reset = next && isNumberToken(next) ? next.number : 0;
	                    resets.push({ counter: counter.value, reset: reset });
	                }
	            }
	            return resets;
	        }
	    };
	
	    var duration = {
	        name: 'duration',
	        initialValue: '0s',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (context, tokens) {
	            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
	        }
	    };
	
	    var quotes = {
	        name: 'quotes',
	        initialValue: 'none',
	        prefix: true,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            if (tokens.length === 0) {
	                return null;
	            }
	            var first = tokens[0];
	            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
	                return null;
	            }
	            var quotes = [];
	            var filtered = tokens.filter(isStringToken);
	            if (filtered.length % 2 !== 0) {
	                return null;
	            }
	            for (var i = 0; i < filtered.length; i += 2) {
	                var open_1 = filtered[i].value;
	                var close_1 = filtered[i + 1].value;
	                quotes.push({ open: open_1, close: close_1 });
	            }
	            return quotes;
	        }
	    };
	    var getQuote = function (quotes, depth, open) {
	        if (!quotes) {
	            return '';
	        }
	        var quote = quotes[Math.min(depth, quotes.length - 1)];
	        if (!quote) {
	            return '';
	        }
	        return open ? quote.open : quote.close;
	    };
	
	    var boxShadow = {
	        name: 'box-shadow',
	        initialValue: 'none',
	        type: 1 /* LIST */,
	        prefix: false,
	        parse: function (context, tokens) {
	            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
	                return [];
	            }
	            return parseFunctionArgs(tokens).map(function (values) {
	                var shadow = {
	                    color: 0x000000ff,
	                    offsetX: ZERO_LENGTH,
	                    offsetY: ZERO_LENGTH,
	                    blur: ZERO_LENGTH,
	                    spread: ZERO_LENGTH,
	                    inset: false
	                };
	                var c = 0;
	                for (var i = 0; i < values.length; i++) {
	                    var token = values[i];
	                    if (isIdentWithValue(token, 'inset')) {
	                        shadow.inset = true;
	                    }
	                    else if (isLength(token)) {
	                        if (c === 0) {
	                            shadow.offsetX = token;
	                        }
	                        else if (c === 1) {
	                            shadow.offsetY = token;
	                        }
	                        else if (c === 2) {
	                            shadow.blur = token;
	                        }
	                        else {
	                            shadow.spread = token;
	                        }
	                        c++;
	                    }
	                    else {
	                        shadow.color = color$1.parse(context, token);
	                    }
	                }
	                return shadow;
	            });
	        }
	    };
	
	    var paintOrder = {
	        name: 'paint-order',
	        initialValue: 'normal',
	        prefix: false,
	        type: 1 /* LIST */,
	        parse: function (_context, tokens) {
	            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
	            var layers = [];
	            tokens.filter(isIdentToken).forEach(function (token) {
	                switch (token.value) {
	                    case 'stroke':
	                        layers.push(1 /* STROKE */);
	                        break;
	                    case 'fill':
	                        layers.push(0 /* FILL */);
	                        break;
	                    case 'markers':
	                        layers.push(2 /* MARKERS */);
	                        break;
	                }
	            });
	            DEFAULT_VALUE.forEach(function (value) {
	                if (layers.indexOf(value) === -1) {
	                    layers.push(value);
	                }
	            });
	            return layers;
	        }
	    };
	
	    var webkitTextStrokeColor = {
	        name: "-webkit-text-stroke-color",
	        initialValue: 'currentcolor',
	        prefix: false,
	        type: 3 /* TYPE_VALUE */,
	        format: 'color'
	    };
	
	    var webkitTextStrokeWidth = {
	        name: "-webkit-text-stroke-width",
	        initialValue: '0',
	        type: 0 /* VALUE */,
	        prefix: false,
	        parse: function (_context, token) {
	            if (isDimensionToken(token)) {
	                return token.number;
	            }
	            return 0;
	        }
	    };
	
	    var CSSParsedDeclaration = /** @class */ (function () {
	        function CSSParsedDeclaration(context, declaration) {
	            var _a, _b;
	            this.animationDuration = parse(context, duration, declaration.animationDuration);
	            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
	            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
	            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
	            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
	            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
	            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
	            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
	            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
	            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
	            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
	            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
	            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
	            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
	            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
	            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
	            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
	            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
	            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
	            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
	            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
	            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
	            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
	            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
	            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
	            this.color = parse(context, color, declaration.color);
	            this.direction = parse(context, direction, declaration.direction);
	            this.display = parse(context, display, declaration.display);
	            this.float = parse(context, float, declaration.cssFloat);
	            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
	            this.fontSize = parse(context, fontSize, declaration.fontSize);
	            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
	            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
	            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
	            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
	            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
	            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
	            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
	            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
	            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
	            this.marginTop = parse(context, marginTop, declaration.marginTop);
	            this.marginRight = parse(context, marginRight, declaration.marginRight);
	            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
	            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
	            this.opacity = parse(context, opacity, declaration.opacity);
	            var overflowTuple = parse(context, overflow, declaration.overflow);
	            this.overflowX = overflowTuple[0];
	            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
	            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
	            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
	            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
	            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
	            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
	            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
	            this.position = parse(context, position, declaration.position);
	            this.textAlign = parse(context, textAlign, declaration.textAlign);
	            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
	            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
	            this.textShadow = parse(context, textShadow, declaration.textShadow);
	            this.textTransform = parse(context, textTransform, declaration.textTransform);
	            this.transform = parse(context, transform$1, declaration.transform);
	            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
	            this.visibility = parse(context, visibility, declaration.visibility);
	            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
	            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
	            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
	            this.zIndex = parse(context, zIndex, declaration.zIndex);
	        }
	        CSSParsedDeclaration.prototype.isVisible = function () {
	            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
	        };
	        CSSParsedDeclaration.prototype.isTransparent = function () {
	            return isTransparent(this.backgroundColor);
	        };
	        CSSParsedDeclaration.prototype.isTransformed = function () {
	            return this.transform !== null;
	        };
	        CSSParsedDeclaration.prototype.isPositioned = function () {
	            return this.position !== 0 /* STATIC */;
	        };
	        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
	            return this.isPositioned() && !this.zIndex.auto;
	        };
	        CSSParsedDeclaration.prototype.isFloating = function () {
	            return this.float !== 0 /* NONE */;
	        };
	        CSSParsedDeclaration.prototype.isInlineLevel = function () {
	            return (contains(this.display, 4 /* INLINE */) ||
	                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
	                contains(this.display, 268435456 /* INLINE_FLEX */) ||
	                contains(this.display, 536870912 /* INLINE_GRID */) ||
	                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
	                contains(this.display, 134217728 /* INLINE_TABLE */));
	        };
	        return CSSParsedDeclaration;
	    }());
	    var CSSParsedPseudoDeclaration = /** @class */ (function () {
	        function CSSParsedPseudoDeclaration(context, declaration) {
	            this.content = parse(context, content, declaration.content);
	            this.quotes = parse(context, quotes, declaration.quotes);
	        }
	        return CSSParsedPseudoDeclaration;
	    }());
	    var CSSParsedCounterDeclaration = /** @class */ (function () {
	        function CSSParsedCounterDeclaration(context, declaration) {
	            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
	            this.counterReset = parse(context, counterReset, declaration.counterReset);
	        }
	        return CSSParsedCounterDeclaration;
	    }());
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var parse = function (context, descriptor, style) {
	        var tokenizer = new Tokenizer();
	        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
	        tokenizer.write(value);
	        var parser = new Parser(tokenizer.read());
	        switch (descriptor.type) {
	            case 2 /* IDENT_VALUE */:
	                var token = parser.parseComponentValue();
	                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
	            case 0 /* VALUE */:
	                return descriptor.parse(context, parser.parseComponentValue());
	            case 1 /* LIST */:
	                return descriptor.parse(context, parser.parseComponentValues());
	            case 4 /* TOKEN_VALUE */:
	                return parser.parseComponentValue();
	            case 3 /* TYPE_VALUE */:
	                switch (descriptor.format) {
	                    case 'angle':
	                        return angle.parse(context, parser.parseComponentValue());
	                    case 'color':
	                        return color$1.parse(context, parser.parseComponentValue());
	                    case 'image':
	                        return image.parse(context, parser.parseComponentValue());
	                    case 'length':
	                        var length_1 = parser.parseComponentValue();
	                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
	                    case 'length-percentage':
	                        var value_1 = parser.parseComponentValue();
	                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
	                    case 'time':
	                        return time.parse(context, parser.parseComponentValue());
	                }
	                break;
	        }
	    };
	
	    var elementDebuggerAttribute = 'data-html2canvas-debug';
	    var getElementDebugType = function (element) {
	        var attribute = element.getAttribute(elementDebuggerAttribute);
	        switch (attribute) {
	            case 'all':
	                return 1 /* ALL */;
	            case 'clone':
	                return 2 /* CLONE */;
	            case 'parse':
	                return 3 /* PARSE */;
	            case 'render':
	                return 4 /* RENDER */;
	            default:
	                return 0 /* NONE */;
	        }
	    };
	    var isDebugging = function (element, type) {
	        var elementType = getElementDebugType(element);
	        return elementType === 1 /* ALL */ || type === elementType;
	    };
	
	    var ElementContainer = /** @class */ (function () {
	        function ElementContainer(context, element) {
	            this.context = context;
	            this.textNodes = [];
	            this.elements = [];
	            this.flags = 0;
	            if (isDebugging(element, 3 /* PARSE */)) {
	                debugger;
	            }
	            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
	            if (isHTMLElementNode(element)) {
	                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
	                    element.style.animationDuration = '0s';
	                }
	                if (this.styles.transform !== null) {
	                    // getBoundingClientRect takes transforms into account
	                    element.style.transform = 'none';
	                }
	            }
	            this.bounds = parseBounds(this.context, element);
	            if (isDebugging(element, 4 /* RENDER */)) {
	                this.flags |= 16 /* DEBUG_RENDER */;
	            }
	        }
	        return ElementContainer;
	    }());
	
	    /*
	     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var base64 = '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';
	
	    /*
	     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
	        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
	    }
	    var decode = function (base64) {
	        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
	        if (base64[base64.length - 1] === '=') {
	            bufferLength--;
	            if (base64[base64.length - 2] === '=') {
	                bufferLength--;
	            }
	        }
	        var buffer = typeof ArrayBuffer !== 'undefined' &&
	            typeof Uint8Array !== 'undefined' &&
	            typeof Uint8Array.prototype.slice !== 'undefined'
	            ? new ArrayBuffer(bufferLength)
	            : new Array(bufferLength);
	        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
	        for (i = 0; i < len; i += 4) {
	            encoded1 = lookup$1[base64.charCodeAt(i)];
	            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
	            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
	            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
	            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	        }
	        return buffer;
	    };
	    var polyUint16Array = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 2) {
	            bytes.push((buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	    var polyUint32Array = function (buffer) {
	        var length = buffer.length;
	        var bytes = [];
	        for (var i = 0; i < length; i += 4) {
	            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
	        }
	        return bytes;
	    };
	
	    /** Shift size for getting the index-2 table offset. */
	    var UTRIE2_SHIFT_2 = 5;
	    /** Shift size for getting the index-1 table offset. */
	    var UTRIE2_SHIFT_1 = 6 + 5;
	    /**
	     * Shift size for shifting left the index array values.
	     * Increases possible data size with 16-bit index values at the cost
	     * of compactability.
	     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
	     */
	    var UTRIE2_INDEX_SHIFT = 2;
	    /**
	     * Difference between the two shift sizes,
	     * for getting an index-1 offset from an index-2 offset. 6=11-5
	     */
	    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
	    /**
	     * The part of the index-2 table for U+D800..U+DBFF stores values for
	     * lead surrogate code _units_ not code _points_.
	     * Values for lead surrogate code _points_ are indexed with this portion of the table.
	     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
	     */
	    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
	    /** Number of entries in a data block. 32=0x20 */
	    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
	    /** Mask for getting the lower bits for the in-data-block offset. */
	    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
	    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
	    /** Count the lengths of both BMP pieces. 2080=0x820 */
	    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
	    /**
	     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
	     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
	     */
	    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
	    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
	    /**
	     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
	     * Variable length, for code points up to highStart, where the last single-value range starts.
	     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
	     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
	     *
	     * The part of the index-2 table for supplementary code points starts
	     * after this index-1 table.
	     *
	     * Both the index-1 table and the following part of the index-2 table
	     * are omitted completely if there is only BMP data.
	     */
	    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
	    /**
	     * Number of index-1 entries for the BMP. 32=0x20
	     * This part of the index-1 table is omitted from the serialized form.
	     */
	    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
	    /** Number of entries in an index-2 block. 64=0x40 */
	    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
	    /** Mask for getting the lower bits for the in-index-2-block offset. */
	    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
	    var slice16 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint16Array(Array.prototype.slice.call(view, start, end));
	    };
	    var slice32 = function (view, start, end) {
	        if (view.slice) {
	            return view.slice(start, end);
	        }
	        return new Uint32Array(Array.prototype.slice.call(view, start, end));
	    };
	    var createTrieFromBase64 = function (base64, _byteLength) {
	        var buffer = decode(base64);
	        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
	        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
	        var headerLength = 24;
	        var index = slice16(view16, headerLength / 2, view32[4] / 2);
	        var data = view32[5] === 2
	            ? slice16(view16, (headerLength + view32[4]) / 2)
	            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
	        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
	    };
	    var Trie = /** @class */ (function () {
	        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
	            this.initialValue = initialValue;
	            this.errorValue = errorValue;
	            this.highStart = highStart;
	            this.highValueIndex = highValueIndex;
	            this.index = index;
	            this.data = data;
	        }
	        /**
	         * Get the value for a code point as stored in the Trie.
	         *
	         * @param codePoint the code point
	         * @return the value
	         */
	        Trie.prototype.get = function (codePoint) {
	            var ix;
	            if (codePoint >= 0) {
	                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
	                    // Ordinary BMP code point, excluding leading surrogates.
	                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
	                    // 16 bit data is stored in the index array itself.
	                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0xffff) {
	                    // Lead Surrogate Code Point.  A Separate index section is stored for
	                    // lead surrogate code units and code points.
	                    //   The main index has the code unit data.
	                    //   For this function, we need the code point data.
	                    // Note: this expression could be refactored for slightly improved efficiency, but
	                    //       surrogate code points will be so rare in practice that it's not worth it.
	                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint < this.highStart) {
	                    // Supplemental code point, use two-level lookup.
	                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
	                    ix = this.index[ix];
	                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
	                    ix = this.index[ix];
	                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
	                    return this.data[ix];
	                }
	                if (codePoint <= 0x10ffff) {
	                    return this.data[this.highValueIndex];
	                }
	            }
	            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
	            return this.errorValue;
	        };
	        return Trie;
	    }());
	
	    /*
	     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
	     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
	     * Released under MIT License
	     */
	    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    // Use a lookup table to find the index.
	    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	    for (var i = 0; i < chars.length; i++) {
	        lookup[chars.charCodeAt(i)] = i;
	    }
	
	    var Prepend = 1;
	    var CR = 2;
	    var LF = 3;
	    var Control = 4;
	    var Extend = 5;
	    var SpacingMark = 7;
	    var L = 8;
	    var V = 9;
	    var T = 10;
	    var LV = 11;
	    var LVT = 12;
	    var ZWJ = 13;
	    var Extended_Pictographic = 14;
	    var RI = 15;
	    var toCodePoints = function (str) {
	        var codePoints = [];
	        var i = 0;
	        var length = str.length;
	        while (i < length) {
	            var value = str.charCodeAt(i++);
	            if (value >= 0xd800 && value <= 0xdbff && i < length) {
	                var extra = str.charCodeAt(i++);
	                if ((extra & 0xfc00) === 0xdc00) {
	                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
	                }
	                else {
	                    codePoints.push(value);
	                    i--;
	                }
	            }
	            else {
	                codePoints.push(value);
	            }
	        }
	        return codePoints;
	    };
	    var fromCodePoint = function () {
	        var codePoints = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            codePoints[_i] = arguments[_i];
	        }
	        if (String.fromCodePoint) {
	            return String.fromCodePoint.apply(String, codePoints);
	        }
	        var length = codePoints.length;
	        if (!length) {
	            return '';
	        }
	        var codeUnits = [];
	        var index = -1;
	        var result = '';
	        while (++index < length) {
	            var codePoint = codePoints[index];
	            if (codePoint <= 0xffff) {
	                codeUnits.push(codePoint);
	            }
	            else {
	                codePoint -= 0x10000;
	                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
	            }
	            if (index + 1 === length || codeUnits.length > 0x4000) {
	                result += String.fromCharCode.apply(String, codeUnits);
	                codeUnits.length = 0;
	            }
	        }
	        return result;
	    };
	    var UnicodeTrie = createTrieFromBase64(base64);
	    var BREAK_NOT_ALLOWED = '×';
	    var BREAK_ALLOWED = '÷';
	    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
	    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
	        var prevIndex = index - 2;
	        var prev = classTypes[prevIndex];
	        var current = classTypes[index - 1];
	        var next = classTypes[index];
	        // GB3 Do not break between a CR and LF
	        if (current === CR && next === LF) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB4 Otherwise, break before and after controls.
	        if (current === CR || current === LF || current === Control) {
	            return BREAK_ALLOWED;
	        }
	        // GB5
	        if (next === CR || next === LF || next === Control) {
	            return BREAK_ALLOWED;
	        }
	        // Do not break Hangul syllable sequences.
	        // GB6
	        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB7
	        if ((current === LV || current === V) && (next === V || next === T)) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB8
	        if ((current === LVT || current === T) && next === T) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB9 Do not break before extending characters or ZWJ.
	        if (next === ZWJ || next === Extend) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // Do not break before SpacingMarks, or after Prepend characters.
	        // GB9a
	        if (next === SpacingMark) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB9a
	        if (current === Prepend) {
	            return BREAK_NOT_ALLOWED;
	        }
	        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
	        if (current === ZWJ && next === Extended_Pictographic) {
	            while (prev === Extend) {
	                prev = classTypes[--prevIndex];
	            }
	            if (prev === Extended_Pictographic) {
	                return BREAK_NOT_ALLOWED;
	            }
	        }
	        // GB12 Do not break within emoji flag sequences.
	        // That is, do not break between regional indicator (RI) symbols
	        // if there is an odd number of RI characters before the break point.
	        if (current === RI && next === RI) {
	            var countRI = 0;
	            while (prev === RI) {
	                countRI++;
	                prev = classTypes[--prevIndex];
	            }
	            if (countRI % 2 === 0) {
	                return BREAK_NOT_ALLOWED;
	            }
	        }
	        return BREAK_ALLOWED;
	    };
	    var GraphemeBreaker = function (str) {
	        var codePoints = toCodePoints(str);
	        var length = codePoints.length;
	        var index = 0;
	        var lastEnd = 0;
	        var classTypes = codePoints.map(codePointToClass);
	        return {
	            next: function () {
	                if (index >= length) {
	                    return { done: true, value: null };
	                }
	                var graphemeBreak = BREAK_NOT_ALLOWED;
	                while (index < length &&
	                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
	                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
	                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
	                    lastEnd = index;
	                    return { value: value, done: false };
	                }
	                return { done: true, value: null };
	            },
	        };
	    };
	    var splitGraphemes = function (str) {
	        var breaker = GraphemeBreaker(str);
	        var graphemes = [];
	        var bk;
	        while (!(bk = breaker.next()).done) {
	            if (bk.value) {
	                graphemes.push(bk.value.slice());
	            }
	        }
	        return graphemes;
	    };
	
	    var testRangeBounds = function (document) {
	        var TEST_HEIGHT = 123;
	        if (document.createRange) {
	            var range = document.createRange();
	            if (range.getBoundingClientRect) {
	                var testElement = document.createElement('boundtest');
	                testElement.style.height = TEST_HEIGHT + "px";
	                testElement.style.display = 'block';
	                document.body.appendChild(testElement);
	                range.selectNode(testElement);
	                var rangeBounds = range.getBoundingClientRect();
	                var rangeHeight = Math.round(rangeBounds.height);
	                document.body.removeChild(testElement);
	                if (rangeHeight === TEST_HEIGHT) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    var testIOSLineBreak = function (document) {
	        var testElement = document.createElement('boundtest');
	        testElement.style.width = '50px';
	        testElement.style.display = 'block';
	        testElement.style.fontSize = '12px';
	        testElement.style.letterSpacing = '0px';
	        testElement.style.wordSpacing = '0px';
	        document.body.appendChild(testElement);
	        var range = document.createRange();
	        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
	        var node = testElement.firstChild;
	        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
	        var offset = 0;
	        var prev = {};
	        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
	        var supports = textList.every(function (text, i) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + text.length);
	            var rect = range.getBoundingClientRect();
	            offset += text.length;
	            var boundAhead = rect.x > prev.x || rect.y > prev.y;
	            prev = rect;
	            if (i === 0) {
	                return true;
	            }
	            return boundAhead;
	        });
	        document.body.removeChild(testElement);
	        return supports;
	    };
	    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
	    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
	    var testSVG = function (document) {
	        var img = new Image();
	        var canvas = document.createElement('canvas');
	        var ctx = canvas.getContext('2d');
	        if (!ctx) {
	            return false;
	        }
	        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
	        try {
	            ctx.drawImage(img, 0, 0);
	            canvas.toDataURL();
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    };
	    var isGreenPixel = function (data) {
	        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
	    };
	    var testForeignObject = function (document) {
	        var canvas = document.createElement('canvas');
	        var size = 100;
	        canvas.width = size;
	        canvas.height = size;
	        var ctx = canvas.getContext('2d');
	        if (!ctx) {
	            return Promise.reject(false);
	        }
	        ctx.fillStyle = 'rgb(0, 255, 0)';
	        ctx.fillRect(0, 0, size, size);
	        var img = new Image();
	        var greenImageSrc = canvas.toDataURL();
	        img.src = greenImageSrc;
	        var svg = createForeignObjectSVG(size, size, 0, 0, img);
	        ctx.fillStyle = 'red';
	        ctx.fillRect(0, 0, size, size);
	        return loadSerializedSVG$1(svg)
	            .then(function (img) {
	            ctx.drawImage(img, 0, 0);
	            var data = ctx.getImageData(0, 0, size, size).data;
	            ctx.fillStyle = 'red';
	            ctx.fillRect(0, 0, size, size);
	            var node = document.createElement('div');
	            node.style.backgroundImage = "url(" + greenImageSrc + ")";
	            node.style.height = size + "px";
	            // Firefox 55 does not render inline <img /> tags
	            return isGreenPixel(data)
	                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
	                : Promise.reject(false);
	        })
	            .then(function (img) {
	            ctx.drawImage(img, 0, 0);
	            // Edge does not render background-images
	            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
	        })
	            .catch(function () { return false; });
	    };
	    var createForeignObjectSVG = function (width, height, x, y, node) {
	        var xmlns = 'http://www.w3.org/2000/svg';
	        var svg = document.createElementNS(xmlns, 'svg');
	        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
	        svg.setAttributeNS(null, 'width', width.toString());
	        svg.setAttributeNS(null, 'height', height.toString());
	        foreignObject.setAttributeNS(null, 'width', '100%');
	        foreignObject.setAttributeNS(null, 'height', '100%');
	        foreignObject.setAttributeNS(null, 'x', x.toString());
	        foreignObject.setAttributeNS(null, 'y', y.toString());
	        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
	        svg.appendChild(foreignObject);
	        foreignObject.appendChild(node);
	        return svg;
	    };
	    var loadSerializedSVG$1 = function (svg) {
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            img.onload = function () { return resolve(img); };
	            img.onerror = reject;
	            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	        });
	    };
	    var FEATURES = {
	        get SUPPORT_RANGE_BOUNDS() {
	            var value = testRangeBounds(document);
	            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
	            return value;
	        },
	        get SUPPORT_WORD_BREAKING() {
	            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
	            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
	            return value;
	        },
	        get SUPPORT_SVG_DRAWING() {
	            var value = testSVG(document);
	            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
	            return value;
	        },
	        get SUPPORT_FOREIGNOBJECT_DRAWING() {
	            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
	                ? testForeignObject(document)
	                : Promise.resolve(false);
	            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
	            return value;
	        },
	        get SUPPORT_CORS_IMAGES() {
	            var value = testCORS();
	            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
	            return value;
	        },
	        get SUPPORT_RESPONSE_TYPE() {
	            var value = testResponseType();
	            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
	            return value;
	        },
	        get SUPPORT_CORS_XHR() {
	            var value = 'withCredentials' in new XMLHttpRequest();
	            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
	            return value;
	        },
	        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
	            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
	            return value;
	        }
	    };
	
	    var TextBounds = /** @class */ (function () {
	        function TextBounds(text, bounds) {
	            this.text = text;
	            this.bounds = bounds;
	        }
	        return TextBounds;
	    }());
	    var parseTextBounds = function (context, value, styles, node) {
	        var textList = breakText(value, styles);
	        var textBounds = [];
	        var offset = 0;
	        textList.forEach(function (text) {
	            if (styles.textDecorationLine.length || text.trim().length > 0) {
	                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
	                    var clientRects = createRange(node, offset, text.length).getClientRects();
	                    if (clientRects.length > 1) {
	                        var subSegments = segmentGraphemes(text);
	                        var subOffset_1 = 0;
	                        subSegments.forEach(function (subSegment) {
	                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
	                            subOffset_1 += subSegment.length;
	                        });
	                    }
	                    else {
	                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
	                    }
	                }
	                else {
	                    var replacementNode = node.splitText(text.length);
	                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
	                    node = replacementNode;
	                }
	            }
	            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
	                node = node.splitText(text.length);
	            }
	            offset += text.length;
	        });
	        return textBounds;
	    };
	    var getWrapperBounds = function (context, node) {
	        var ownerDocument = node.ownerDocument;
	        if (ownerDocument) {
	            var wrapper = ownerDocument.createElement('html2canvaswrapper');
	            wrapper.appendChild(node.cloneNode(true));
	            var parentNode = node.parentNode;
	            if (parentNode) {
	                parentNode.replaceChild(wrapper, node);
	                var bounds = parseBounds(context, wrapper);
	                if (wrapper.firstChild) {
	                    parentNode.replaceChild(wrapper.firstChild, wrapper);
	                }
	                return bounds;
	            }
	        }
	        return Bounds.EMPTY;
	    };
	    var createRange = function (node, offset, length) {
	        var ownerDocument = node.ownerDocument;
	        if (!ownerDocument) {
	            throw new Error('Node has no owner document');
	        }
	        var range = ownerDocument.createRange();
	        range.setStart(node, offset);
	        range.setEnd(node, offset + length);
	        return range;
	    };
	    var segmentGraphemes = function (value) {
	        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
	        }
	        return splitGraphemes(value);
	    };
	    var segmentWords = function (value, styles) {
	        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var segmenter = new Intl.Segmenter(void 0, {
	                granularity: 'word'
	            });
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
	        }
	        return breakWords(value, styles);
	    };
	    var breakText = function (value, styles) {
	        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
	    };
	    // https://drafts.csswg.org/css-text/#word-separator
	    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
	    var breakWords = function (str, styles) {
	        var breaker = LineBreaker(str, {
	            lineBreak: styles.lineBreak,
	            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
	        });
	        var words = [];
	        var bk;
	        var _loop_1 = function () {
	            if (bk.value) {
	                var value = bk.value.slice();
	                var codePoints = toCodePoints$1(value);
	                var word_1 = '';
	                codePoints.forEach(function (codePoint) {
	                    if (wordSeparators.indexOf(codePoint) === -1) {
	                        word_1 += fromCodePoint$1(codePoint);
	                    }
	                    else {
	                        if (word_1.length) {
	                            words.push(word_1);
	                        }
	                        words.push(fromCodePoint$1(codePoint));
	                        word_1 = '';
	                    }
	                });
	                if (word_1.length) {
	                    words.push(word_1);
	                }
	            }
	        };
	        while (!(bk = breaker.next()).done) {
	            _loop_1();
	        }
	        return words;
	    };
	
	    var TextContainer = /** @class */ (function () {
	        function TextContainer(context, node, styles) {
	            this.text = transform(node.data, styles.textTransform);
	            this.textBounds = parseTextBounds(context, this.text, styles, node);
	        }
	        return TextContainer;
	    }());
	    var transform = function (text, transform) {
	        switch (transform) {
	            case 1 /* LOWERCASE */:
	                return text.toLowerCase();
	            case 3 /* CAPITALIZE */:
	                return text.replace(CAPITALIZE, capitalize);
	            case 2 /* UPPERCASE */:
	                return text.toUpperCase();
	            default:
	                return text;
	        }
	    };
	    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
	    var capitalize = function (m, p1, p2) {
	        if (m.length > 0) {
	            return p1 + p2.toUpperCase();
	        }
	        return m;
	    };
	
	    var ImageElementContainer = /** @class */ (function (_super) {
	        __extends(ImageElementContainer, _super);
	        function ImageElementContainer(context, img) {
	            var _this = _super.call(this, context, img) || this;
	            _this.src = img.currentSrc || img.src;
	            _this.intrinsicWidth = img.naturalWidth;
	            _this.intrinsicHeight = img.naturalHeight;
	            _this.context.cache.addImage(_this.src);
	            return _this;
	        }
	        return ImageElementContainer;
	    }(ElementContainer));
	
	    var CanvasElementContainer = /** @class */ (function (_super) {
	        __extends(CanvasElementContainer, _super);
	        function CanvasElementContainer(context, canvas) {
	            var _this = _super.call(this, context, canvas) || this;
	            _this.canvas = canvas;
	            _this.intrinsicWidth = canvas.width;
	            _this.intrinsicHeight = canvas.height;
	            return _this;
	        }
	        return CanvasElementContainer;
	    }(ElementContainer));
	
	    var SVGElementContainer = /** @class */ (function (_super) {
	        __extends(SVGElementContainer, _super);
	        function SVGElementContainer(context, img) {
	            var _this = _super.call(this, context, img) || this;
	            var s = new XMLSerializer();
	            var bounds = parseBounds(context, img);
	            img.setAttribute('width', bounds.width + "px");
	            img.setAttribute('height', bounds.height + "px");
	            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
	            _this.intrinsicWidth = img.width.baseVal.value;
	            _this.intrinsicHeight = img.height.baseVal.value;
	            _this.context.cache.addImage(_this.svg);
	            return _this;
	        }
	        return SVGElementContainer;
	    }(ElementContainer));
	
	    var LIElementContainer = /** @class */ (function (_super) {
	        __extends(LIElementContainer, _super);
	        function LIElementContainer(context, element) {
	            var _this = _super.call(this, context, element) || this;
	            _this.value = element.value;
	            return _this;
	        }
	        return LIElementContainer;
	    }(ElementContainer));
	
	    var OLElementContainer = /** @class */ (function (_super) {
	        __extends(OLElementContainer, _super);
	        function OLElementContainer(context, element) {
	            var _this = _super.call(this, context, element) || this;
	            _this.start = element.start;
	            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
	            return _this;
	        }
	        return OLElementContainer;
	    }(ElementContainer));
	
	    var CHECKBOX_BORDER_RADIUS = [
	        {
	            type: 15 /* DIMENSION_TOKEN */,
	            flags: 0,
	            unit: 'px',
	            number: 3
	        }
	    ];
	    var RADIO_BORDER_RADIUS = [
	        {
	            type: 16 /* PERCENTAGE_TOKEN */,
	            flags: 0,
	            number: 50
	        }
	    ];
	    var reformatInputBounds = function (bounds) {
	        if (bounds.width > bounds.height) {
	            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
	        }
	        else if (bounds.width < bounds.height) {
	            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
	        }
	        return bounds;
	    };
	    var getInputValue = function (node) {
	        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
	        return value.length === 0 ? node.placeholder || '' : value;
	    };
	    var CHECKBOX = 'checkbox';
	    var RADIO = 'radio';
	    var PASSWORD = 'password';
	    var INPUT_COLOR = 0x2a2a2aff;
	    var InputElementContainer = /** @class */ (function (_super) {
	        __extends(InputElementContainer, _super);
	        function InputElementContainer(context, input) {
	            var _this = _super.call(this, context, input) || this;
	            _this.type = input.type.toLowerCase();
	            _this.checked = input.checked;
	            _this.value = getInputValue(input);
	            if (_this.type === CHECKBOX || _this.type === RADIO) {
	                _this.styles.backgroundColor = 0xdededeff;
	                _this.styles.borderTopColor =
	                    _this.styles.borderRightColor =
	                        _this.styles.borderBottomColor =
	                            _this.styles.borderLeftColor =
	                                0xa5a5a5ff;
	                _this.styles.borderTopWidth =
	                    _this.styles.borderRightWidth =
	                        _this.styles.borderBottomWidth =
	                            _this.styles.borderLeftWidth =
	                                1;
	                _this.styles.borderTopStyle =
	                    _this.styles.borderRightStyle =
	                        _this.styles.borderBottomStyle =
	                            _this.styles.borderLeftStyle =
	                                1 /* SOLID */;
	                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
	                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
	                _this.bounds = reformatInputBounds(_this.bounds);
	            }
	            switch (_this.type) {
	                case CHECKBOX:
	                    _this.styles.borderTopRightRadius =
	                        _this.styles.borderTopLeftRadius =
	                            _this.styles.borderBottomRightRadius =
	                                _this.styles.borderBottomLeftRadius =
	                                    CHECKBOX_BORDER_RADIUS;
	                    break;
	                case RADIO:
	                    _this.styles.borderTopRightRadius =
	                        _this.styles.borderTopLeftRadius =
	                            _this.styles.borderBottomRightRadius =
	                                _this.styles.borderBottomLeftRadius =
	                                    RADIO_BORDER_RADIUS;
	                    break;
	            }
	            return _this;
	        }
	        return InputElementContainer;
	    }(ElementContainer));
	
	    var SelectElementContainer = /** @class */ (function (_super) {
	        __extends(SelectElementContainer, _super);
	        function SelectElementContainer(context, element) {
	            var _this = _super.call(this, context, element) || this;
	            var option = element.options[element.selectedIndex || 0];
	            _this.value = option ? option.text || '' : '';
	            return _this;
	        }
	        return SelectElementContainer;
	    }(ElementContainer));
	
	    var TextareaElementContainer = /** @class */ (function (_super) {
	        __extends(TextareaElementContainer, _super);
	        function TextareaElementContainer(context, element) {
	            var _this = _super.call(this, context, element) || this;
	            _this.value = element.value;
	            return _this;
	        }
	        return TextareaElementContainer;
	    }(ElementContainer));
	
	    var IFrameElementContainer = /** @class */ (function (_super) {
	        __extends(IFrameElementContainer, _super);
	        function IFrameElementContainer(context, iframe) {
	            var _this = _super.call(this, context, iframe) || this;
	            _this.src = iframe.src;
	            _this.width = parseInt(iframe.width, 10) || 0;
	            _this.height = parseInt(iframe.height, 10) || 0;
	            _this.backgroundColor = _this.styles.backgroundColor;
	            try {
	                if (iframe.contentWindow &&
	                    iframe.contentWindow.document &&
	                    iframe.contentWindow.document.documentElement) {
	                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
	                    // http://www.w3.org/TR/css3-background/#special-backgrounds
	                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
	                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    var bodyBackgroundColor = iframe.contentWindow.document.body
	                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
	                        : COLORS.TRANSPARENT;
	                    _this.backgroundColor = isTransparent(documentBackgroundColor)
	                        ? isTransparent(bodyBackgroundColor)
	                            ? _this.styles.backgroundColor
	                            : bodyBackgroundColor
	                        : documentBackgroundColor;
	                }
	            }
	            catch (e) { }
	            return _this;
	        }
	        return IFrameElementContainer;
	    }(ElementContainer));
	
	    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
	    var parseNodeTree = function (context, node, parent, root) {
	        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
	            nextNode = childNode.nextSibling;
	            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
	                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
	            }
	            else if (isElementNode(childNode)) {
	                if (isSlotElement(childNode) && childNode.assignedNodes) {
	                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
	                }
	                else {
	                    var container = createContainer(context, childNode);
	                    if (container.styles.isVisible()) {
	                        if (createsRealStackingContext(childNode, container, root)) {
	                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
	                        }
	                        else if (createsStackingContext(container.styles)) {
	                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
	                        }
	                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
	                            container.flags |= 8 /* IS_LIST_OWNER */;
	                        }
	                        parent.elements.push(container);
	                        childNode.slot;
	                        if (childNode.shadowRoot) {
	                            parseNodeTree(context, childNode.shadowRoot, container, root);
	                        }
	                        else if (!isTextareaElement(childNode) &&
	                            !isSVGElement(childNode) &&
	                            !isSelectElement(childNode)) {
	                            parseNodeTree(context, childNode, container, root);
	                        }
	                    }
	                }
	            }
	        }
	    };
	    var createContainer = function (context, element) {
	        if (isImageElement(element)) {
	            return new ImageElementContainer(context, element);
	        }
	        if (isCanvasElement(element)) {
	            return new CanvasElementContainer(context, element);
	        }
	        if (isSVGElement(element)) {
	            return new SVGElementContainer(context, element);
	        }
	        if (isLIElement(element)) {
	            return new LIElementContainer(context, element);
	        }
	        if (isOLElement(element)) {
	            return new OLElementContainer(context, element);
	        }
	        if (isInputElement(element)) {
	            return new InputElementContainer(context, element);
	        }
	        if (isSelectElement(element)) {
	            return new SelectElementContainer(context, element);
	        }
	        if (isTextareaElement(element)) {
	            return new TextareaElementContainer(context, element);
	        }
	        if (isIFrameElement(element)) {
	            return new IFrameElementContainer(context, element);
	        }
	        return new ElementContainer(context, element);
	    };
	    var parseTree = function (context, element) {
	        var container = createContainer(context, element);
	        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
	        parseNodeTree(context, element, container, container);
	        return container;
	    };
	    var createsRealStackingContext = function (node, container, root) {
	        return (container.styles.isPositionedWithZIndex() ||
	            container.styles.opacity < 1 ||
	            container.styles.isTransformed() ||
	            (isBodyElement(node) && root.styles.isTransparent()));
	    };
	    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
	    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
	    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
	    var isHTMLElementNode = function (node) {
	        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
	    };
	    var isSVGElementNode = function (element) {
	        return typeof element.className === 'object';
	    };
	    var isLIElement = function (node) { return node.tagName === 'LI'; };
	    var isOLElement = function (node) { return node.tagName === 'OL'; };
	    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
	    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
	    var isSVGElement = function (node) { return node.tagName === 'svg'; };
	    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
	    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
	    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
	    var isImageElement = function (node) { return node.tagName === 'IMG'; };
	    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
	    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
	    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
	    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
	    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
	    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
	    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };
	
	    var CounterState = /** @class */ (function () {
	        function CounterState() {
	            this.counters = {};
	        }
	        CounterState.prototype.getCounterValue = function (name) {
	            var counter = this.counters[name];
	            if (counter && counter.length) {
	                return counter[counter.length - 1];
	            }
	            return 1;
	        };
	        CounterState.prototype.getCounterValues = function (name) {
	            var counter = this.counters[name];
	            return counter ? counter : [];
	        };
	        CounterState.prototype.pop = function (counters) {
	            var _this = this;
	            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
	        };
	        CounterState.prototype.parse = function (style) {
	            var _this = this;
	            var counterIncrement = style.counterIncrement;
	            var counterReset = style.counterReset;
	            var canReset = true;
	            if (counterIncrement !== null) {
	                counterIncrement.forEach(function (entry) {
	                    var counter = _this.counters[entry.counter];
	                    if (counter && entry.increment !== 0) {
	                        canReset = false;
	                        if (!counter.length) {
	                            counter.push(1);
	                        }
	                        counter[Math.max(0, counter.length - 1)] += entry.increment;
	                    }
	                });
	            }
	            var counterNames = [];
	            if (canReset) {
	                counterReset.forEach(function (entry) {
	                    var counter = _this.counters[entry.counter];
	                    counterNames.push(entry.counter);
	                    if (!counter) {
	                        counter = _this.counters[entry.counter] = [];
	                    }
	                    counter.push(entry.reset);
	                });
	            }
	            return counterNames;
	        };
	        return CounterState;
	    }());
	    var ROMAN_UPPER = {
	        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
	        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
	    };
	    var ARMENIAN = {
	        integers: [
	            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
	            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
	        ],
	        values: [
	            'Ք',
	            'Փ',
	            'Ւ',
	            'Ց',
	            'Ր',
	            'Տ',
	            'Վ',
	            'Ս',
	            'Ռ',
	            'Ջ',
	            'Պ',
	            'Չ',
	            'Ո',
	            'Շ',
	            'Ն',
	            'Յ',
	            'Մ',
	            'Ճ',
	            'Ղ',
	            'Ձ',
	            'Հ',
	            'Կ',
	            'Ծ',
	            'Խ',
	            'Լ',
	            'Ի',
	            'Ժ',
	            'Թ',
	            'Ը',
	            'Է',
	            'Զ',
	            'Ե',
	            'Դ',
	            'Գ',
	            'Բ',
	            'Ա'
	        ]
	    };
	    var HEBREW = {
	        integers: [
	            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
	            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
	        ],
	        values: [
	            'י׳',
	            'ט׳',
	            'ח׳',
	            'ז׳',
	            'ו׳',
	            'ה׳',
	            'ד׳',
	            'ג׳',
	            'ב׳',
	            'א׳',
	            'ת',
	            'ש',
	            'ר',
	            'ק',
	            'צ',
	            'פ',
	            'ע',
	            'ס',
	            'נ',
	            'מ',
	            'ל',
	            'כ',
	            'יט',
	            'יח',
	            'יז',
	            'טז',
	            'טו',
	            'י',
	            'ט',
	            'ח',
	            'ז',
	            'ו',
	            'ה',
	            'ד',
	            'ג',
	            'ב',
	            'א'
	        ]
	    };
	    var GEORGIAN = {
	        integers: [
	            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
	            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
	        ],
	        values: [
	            'ჵ',
	            'ჰ',
	            'ჯ',
	            'ჴ',
	            'ხ',
	            'ჭ',
	            'წ',
	            'ძ',
	            'ც',
	            'ჩ',
	            'შ',
	            'ყ',
	            'ღ',
	            'ქ',
	            'ფ',
	            'ჳ',
	            'ტ',
	            'ს',
	            'რ',
	            'ჟ',
	            'პ',
	            'ო',
	            'ჲ',
	            'ნ',
	            'მ',
	            'ლ',
	            'კ',
	            'ი',
	            'თ',
	            'ჱ',
	            'ზ',
	            'ვ',
	            'ე',
	            'დ',
	            'გ',
	            'ბ',
	            'ა'
	        ]
	    };
	    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
	        if (value < min || value > max) {
	            return createCounterText(value, fallback, suffix.length > 0);
	        }
	        return (symbols.integers.reduce(function (string, integer, index) {
	            while (value >= integer) {
	                value -= integer;
	                string += symbols.values[index];
	            }
	            return string;
	        }, '') + suffix);
	    };
	    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
	        var string = '';
	        do {
	            if (!isNumeric) {
	                value--;
	            }
	            string = resolver(value) + string;
	            value /= codePointRangeLength;
	        } while (value * codePointRangeLength >= codePointRangeLength);
	        return string;
	    };
	    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
	        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
	        return ((value < 0 ? '-' : '') +
	            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
	                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
	            }) +
	                suffix));
	    };
	    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
	        if (suffix === void 0) { suffix = '. '; }
	        var codePointRangeLength = symbols.length;
	        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
	    };
	    var CJK_ZEROS = 1 << 0;
	    var CJK_TEN_COEFFICIENTS = 1 << 1;
	    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
	    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
	    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
	        if (value < -9999 || value > 9999) {
	            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
	        }
	        var tmp = Math.abs(value);
	        var string = suffix;
	        if (tmp === 0) {
	            return numbers[0] + string;
	        }
	        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
	            var coefficient = tmp % 10;
	            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
	                string = numbers[coefficient] + string;
	            }
	            else if (coefficient > 1 ||
	                (coefficient === 1 && digit === 0) ||
	                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
	                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
	                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
	                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
	            }
	            else if (coefficient === 1 && digit > 0) {
	                string = multipliers[digit - 1] + string;
	            }
	            tmp = Math.floor(tmp / 10);
	        }
	        return (value < 0 ? negativeSign : '') + string;
	    };
	    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
	    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
	    var JAPANESE_NEGATIVE = 'マイナス';
	    var KOREAN_NEGATIVE = '마이너스';
	    var createCounterText = function (value, type, appendSuffix) {
	        var defaultSuffix = appendSuffix ? '. ' : '';
	        var cjkSuffix = appendSuffix ? '、' : '';
	        var koreanSuffix = appendSuffix ? ', ' : '';
	        var spaceSuffix = appendSuffix ? ' ' : '';
	        switch (type) {
	            case 0 /* DISC */:
	                return '•' + spaceSuffix;
	            case 1 /* CIRCLE */:
	                return '◦' + spaceSuffix;
	            case 2 /* SQUARE */:
	                return '◾' + spaceSuffix;
	            case 5 /* DECIMAL_LEADING_ZERO */:
	                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	                return string.length < 4 ? "0" + string : string;
	            case 4 /* CJK_DECIMAL */:
	                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
	            case 6 /* LOWER_ROMAN */:
	                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
	            case 7 /* UPPER_ROMAN */:
	                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
	            case 8 /* LOWER_GREEK */:
	                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
	            case 9 /* LOWER_ALPHA */:
	                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
	            case 10 /* UPPER_ALPHA */:
	                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
	            case 11 /* ARABIC_INDIC */:
	                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
	            case 12 /* ARMENIAN */:
	            case 49 /* UPPER_ARMENIAN */:
	                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
	            case 35 /* LOWER_ARMENIAN */:
	                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
	            case 13 /* BENGALI */:
	                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
	            case 14 /* CAMBODIAN */:
	            case 30 /* KHMER */:
	                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
	            case 15 /* CJK_EARTHLY_BRANCH */:
	                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
	            case 16 /* CJK_HEAVENLY_STEM */:
	                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
	            case 17 /* CJK_IDEOGRAPHIC */:
	            case 48 /* TRAD_CHINESE_INFORMAL */:
	                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case 47 /* TRAD_CHINESE_FORMAL */:
	                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case 42 /* SIMP_CHINESE_INFORMAL */:
	                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case 41 /* SIMP_CHINESE_FORMAL */:
	                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
	            case 26 /* JAPANESE_INFORMAL */:
	                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
	            case 25 /* JAPANESE_FORMAL */:
	                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case 31 /* KOREAN_HANGUL_FORMAL */:
	                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case 33 /* KOREAN_HANJA_INFORMAL */:
	                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
	            case 32 /* KOREAN_HANJA_FORMAL */:
	                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
	            case 18 /* DEVANAGARI */:
	                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
	            case 20 /* GEORGIAN */:
	                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
	            case 21 /* GUJARATI */:
	                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
	            case 22 /* GURMUKHI */:
	                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
	            case 22 /* HEBREW */:
	                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
	            case 23 /* HIRAGANA */:
	                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
	            case 24 /* HIRAGANA_IROHA */:
	                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
	            case 27 /* KANNADA */:
	                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
	            case 28 /* KATAKANA */:
	                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
	            case 29 /* KATAKANA_IROHA */:
	                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
	            case 34 /* LAO */:
	                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
	            case 37 /* MONGOLIAN */:
	                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
	            case 38 /* MYANMAR */:
	                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
	            case 39 /* ORIYA */:
	                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
	            case 40 /* PERSIAN */:
	                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
	            case 43 /* TAMIL */:
	                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
	            case 44 /* TELUGU */:
	                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
	            case 45 /* THAI */:
	                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
	            case 46 /* TIBETAN */:
	                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
	            case 3 /* DECIMAL */:
	            default:
	                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
	        }
	    };
	
	    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
	    var DocumentCloner = /** @class */ (function () {
	        function DocumentCloner(context, element, options) {
	            this.context = context;
	            this.options = options;
	            this.scrolledElements = [];
	            this.referenceElement = element;
	            this.counters = new CounterState();
	            this.quoteDepth = 0;
	            if (!element.ownerDocument) {
	                throw new Error('Cloned element does not have an owner document');
	            }
	            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
	        }
	        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
	            var _this = this;
	            var iframe = createIFrameContainer(ownerDocument, windowSize);
	            if (!iframe.contentWindow) {
	                return Promise.reject("Unable to find iframe window");
	            }
	            var scrollX = ownerDocument.defaultView.pageXOffset;
	            var scrollY = ownerDocument.defaultView.pageYOffset;
	            var cloneWindow = iframe.contentWindow;
	            var documentClone = cloneWindow.document;
	            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	             if window url is about:blank, we can assign the url to current by writing onto the document
	             */
	            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
	                var onclone, referenceElement;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            this.scrolledElements.forEach(restoreNodeScroll);
	                            if (cloneWindow) {
	                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
	                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
	                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
	                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
	                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
	                                }
	                            }
	                            onclone = this.options.onclone;
	                            referenceElement = this.clonedReferenceElement;
	                            if (typeof referenceElement === 'undefined') {
	                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
	                            }
	                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
	                            return [4 /*yield*/, documentClone.fonts.ready];
	                        case 1:
	                            _a.sent();
	                            _a.label = 2;
	                        case 2:
	                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
	                            return [4 /*yield*/, imagesReady(documentClone)];
	                        case 3:
	                            _a.sent();
	                            _a.label = 4;
	                        case 4:
	                            if (typeof onclone === 'function') {
	                                return [2 /*return*/, Promise.resolve()
	                                        .then(function () { return onclone(documentClone, referenceElement); })
	                                        .then(function () { return iframe; })];
	                            }
	                            return [2 /*return*/, iframe];
	                    }
	                });
	            }); });
	            documentClone.open();
	            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
	            // Chrome scrolls the parent document for some reason after the write to the cloned window???
	            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
	            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
	            documentClone.close();
	            return iframeLoad;
	        };
	        DocumentCloner.prototype.createElementClone = function (node) {
	            if (isDebugging(node, 2 /* CLONE */)) {
	                debugger;
	            }
	            if (isCanvasElement(node)) {
	                return this.createCanvasClone(node);
	            }
	            if (isVideoElement(node)) {
	                return this.createVideoClone(node);
	            }
	            if (isStyleElement(node)) {
	                return this.createStyleClone(node);
	            }
	            var clone = node.cloneNode(false);
	            if (isImageElement(clone)) {
	                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
	                    clone.src = node.currentSrc;
	                    clone.srcset = '';
	                }
	                if (clone.loading === 'lazy') {
	                    clone.loading = 'eager';
	                }
	            }
	            if (isCustomElement(clone)) {
	                return this.createCustomElementClone(clone);
	            }
	            return clone;
	        };
	        DocumentCloner.prototype.createCustomElementClone = function (node) {
	            var clone = document.createElement('html2canvascustomelement');
	            copyCSSStyles(node.style, clone);
	            return clone;
	        };
	        DocumentCloner.prototype.createStyleClone = function (node) {
	            try {
	                var sheet = node.sheet;
	                if (sheet && sheet.cssRules) {
	                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
	                        if (rule && typeof rule.cssText === 'string') {
	                            return css + rule.cssText;
	                        }
	                        return css;
	                    }, '');
	                    var style = node.cloneNode(false);
	                    style.textContent = css;
	                    return style;
	                }
	            }
	            catch (e) {
	                // accessing node.sheet.cssRules throws a DOMException
	                this.context.logger.error('Unable to access cssRules property', e);
	                if (e.name !== 'SecurityError') {
	                    throw e;
	                }
	            }
	            return node.cloneNode(false);
	        };
	        DocumentCloner.prototype.createCanvasClone = function (canvas) {
	            var _a;
	            if (this.options.inlineImages && canvas.ownerDocument) {
	                var img = canvas.ownerDocument.createElement('img');
	                try {
	                    img.src = canvas.toDataURL();
	                    return img;
	                }
	                catch (e) {
	                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
	                }
	            }
	            var clonedCanvas = canvas.cloneNode(false);
	            try {
	                clonedCanvas.width = canvas.width;
	                clonedCanvas.height = canvas.height;
	                var ctx = canvas.getContext('2d');
	                var clonedCtx = clonedCanvas.getContext('2d');
	                if (clonedCtx) {
	                    if (!this.options.allowTaint && ctx) {
	                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
	                    }
	                    else {
	                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
	                        if (gl) {
	                            var attribs = gl.getContextAttributes();
	                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
	                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
	                            }
	                        }
	                        clonedCtx.drawImage(canvas, 0, 0);
	                    }
	                }
	                return clonedCanvas;
	            }
	            catch (e) {
	                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
	            }
	            return clonedCanvas;
	        };
	        DocumentCloner.prototype.createVideoClone = function (video) {
	            var canvas = video.ownerDocument.createElement('canvas');
	            canvas.width = video.offsetWidth;
	            canvas.height = video.offsetHeight;
	            var ctx = canvas.getContext('2d');
	            try {
	                if (ctx) {
	                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
	                    if (!this.options.allowTaint) {
	                        ctx.getImageData(0, 0, canvas.width, canvas.height);
	                    }
	                }
	                return canvas;
	            }
	            catch (e) {
	                this.context.logger.info("Unable to clone video as it is tainted", video);
	            }
	            var blankCanvas = video.ownerDocument.createElement('canvas');
	            blankCanvas.width = video.offsetWidth;
	            blankCanvas.height = video.offsetHeight;
	            return blankCanvas;
	        };
	        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
	            if (!isElementNode(child) ||
	                (!isScriptElement(child) &&
	                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
	                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
	                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
	                    clone.appendChild(this.cloneNode(child, copyStyles));
	                }
	            }
	        };
	        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
	            var _this = this;
	            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
	                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
	                    var assignedNodes = child.assignedNodes();
	                    if (assignedNodes.length) {
	                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
	                    }
	                }
	                else {
	                    this.appendChildNode(clone, child, copyStyles);
	                }
	            }
	        };
	        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
	            if (isTextNode(node)) {
	                return document.createTextNode(node.data);
	            }
	            if (!node.ownerDocument) {
	                return node.cloneNode(false);
	            }
	            var window = node.ownerDocument.defaultView;
	            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
	                var clone = this.createElementClone(node);
	                clone.style.transitionProperty = 'none';
	                var style = window.getComputedStyle(node);
	                var styleBefore = window.getComputedStyle(node, ':before');
	                var styleAfter = window.getComputedStyle(node, ':after');
	                if (this.referenceElement === node && isHTMLElementNode(clone)) {
	                    this.clonedReferenceElement = clone;
	                }
	                if (isBodyElement(clone)) {
	                    createPseudoHideStyles(clone);
	                }
	                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
	                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
	                if (isCustomElement(node)) {
	                    copyStyles = true;
	                }
	                if (!isVideoElement(node)) {
	                    this.cloneChildNodes(node, clone, copyStyles);
	                }
	                if (before) {
	                    clone.insertBefore(before, clone.firstChild);
	                }
	                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
	                if (after) {
	                    clone.appendChild(after);
	                }
	                this.counters.pop(counters);
	                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
	                    copyStyles) {
	                    copyCSSStyles(style, clone);
	                }
	                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
	                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
	                }
	                if ((isTextareaElement(node) || isSelectElement(node)) &&
	                    (isTextareaElement(clone) || isSelectElement(clone))) {
	                    clone.value = node.value;
	                }
	                return clone;
	            }
	            return node.cloneNode(false);
	        };
	        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
	            var _this = this;
	            if (!style) {
	                return;
	            }
	            var value = style.content;
	            var document = clone.ownerDocument;
	            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
	                return;
	            }
	            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
	            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
	            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
	            copyCSSStyles(style, anonymousReplacedElement);
	            declaration.content.forEach(function (token) {
	                if (token.type === 0 /* STRING_TOKEN */) {
	                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
	                }
	                else if (token.type === 22 /* URL_TOKEN */) {
	                    var img = document.createElement('img');
	                    img.src = token.value;
	                    img.style.opacity = '1';
	                    anonymousReplacedElement.appendChild(img);
	                }
	                else if (token.type === 18 /* FUNCTION */) {
	                    if (token.name === 'attr') {
	                        var attr = token.values.filter(isIdentToken);
	                        if (attr.length) {
	                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
	                        }
	                    }
	                    else if (token.name === 'counter') {
	                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
	                        if (counter && isIdentToken(counter)) {
	                            var counterState = _this.counters.getCounterValue(counter.value);
	                            var counterType = counterStyle && isIdentToken(counterStyle)
	                                ? listStyleType.parse(_this.context, counterStyle.value)
	                                : 3 /* DECIMAL */;
	                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
	                        }
	                    }
	                    else if (token.name === 'counters') {
	                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
	                        if (counter && isIdentToken(counter)) {
	                            var counterStates = _this.counters.getCounterValues(counter.value);
	                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
	                                ? listStyleType.parse(_this.context, counterStyle.value)
	                                : 3 /* DECIMAL */;
	                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
	                            var text = counterStates
	                                .map(function (value) { return createCounterText(value, counterType_1, false); })
	                                .join(separator);
	                            anonymousReplacedElement.appendChild(document.createTextNode(text));
	                        }
	                    }
	                    else ;
	                }
	                else if (token.type === 20 /* IDENT_TOKEN */) {
	                    switch (token.value) {
	                        case 'open-quote':
	                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
	                            break;
	                        case 'close-quote':
	                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
	                            break;
	                        default:
	                            // safari doesn't parse string tokens correctly because of lack of quotes
	                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
	                    }
	                }
	            });
	            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	            var newClassName = pseudoElt === PseudoElementType.BEFORE
	                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
	                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
	            if (isSVGElementNode(clone)) {
	                clone.className.baseValue += newClassName;
	            }
	            else {
	                clone.className += newClassName;
	            }
	            return anonymousReplacedElement;
	        };
	        DocumentCloner.destroy = function (container) {
	            if (container.parentNode) {
	                container.parentNode.removeChild(container);
	                return true;
	            }
	            return false;
	        };
	        return DocumentCloner;
	    }());
	    var PseudoElementType;
	    (function (PseudoElementType) {
	        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
	        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
	    })(PseudoElementType || (PseudoElementType = {}));
	    var createIFrameContainer = function (ownerDocument, bounds) {
	        var cloneIframeContainer = ownerDocument.createElement('iframe');
	        cloneIframeContainer.className = 'html2canvas-container';
	        cloneIframeContainer.style.visibility = 'hidden';
	        cloneIframeContainer.style.position = 'fixed';
	        cloneIframeContainer.style.left = '-10000px';
	        cloneIframeContainer.style.top = '0px';
	        cloneIframeContainer.style.border = '0';
	        cloneIframeContainer.width = bounds.width.toString();
	        cloneIframeContainer.height = bounds.height.toString();
	        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
	        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
	        ownerDocument.body.appendChild(cloneIframeContainer);
	        return cloneIframeContainer;
	    };
	    var imageReady = function (img) {
	        return new Promise(function (resolve) {
	            if (img.complete) {
	                resolve();
	                return;
	            }
	            if (!img.src) {
	                resolve();
	                return;
	            }
	            img.onload = resolve;
	            img.onerror = resolve;
	        });
	    };
	    var imagesReady = function (document) {
	        return Promise.all([].slice.call(document.images, 0).map(imageReady));
	    };
	    var iframeLoader = function (iframe) {
	        return new Promise(function (resolve, reject) {
	            var cloneWindow = iframe.contentWindow;
	            if (!cloneWindow) {
	                return reject("No window assigned for iframe");
	            }
	            var documentClone = cloneWindow.document;
	            cloneWindow.onload = iframe.onload = function () {
	                cloneWindow.onload = iframe.onload = null;
	                var interval = setInterval(function () {
	                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
	                        clearInterval(interval);
	                        resolve(iframe);
	                    }
	                }, 50);
	            };
	        });
	    };
	    var ignoredStyleProperties = [
	        'all',
	        'd',
	        'content' // Safari shows pseudoelements if content is set
	    ];
	    var copyCSSStyles = function (style, target) {
	        // Edge does not provide value for cssText
	        for (var i = style.length - 1; i >= 0; i--) {
	            var property = style.item(i);
	            if (ignoredStyleProperties.indexOf(property) === -1) {
	                target.style.setProperty(property, style.getPropertyValue(property));
	            }
	        }
	        return target;
	    };
	    var serializeDoctype = function (doctype) {
	        var str = '';
	        if (doctype) {
	            str += '<!DOCTYPE ';
	            if (doctype.name) {
	                str += doctype.name;
	            }
	            if (doctype.internalSubset) {
	                str += doctype.internalSubset;
	            }
	            if (doctype.publicId) {
	                str += "\"" + doctype.publicId + "\"";
	            }
	            if (doctype.systemId) {
	                str += "\"" + doctype.systemId + "\"";
	            }
	            str += '>';
	        }
	        return str;
	    };
	    var restoreOwnerScroll = function (ownerDocument, x, y) {
	        if (ownerDocument &&
	            ownerDocument.defaultView &&
	            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
	            ownerDocument.defaultView.scrollTo(x, y);
	        }
	    };
	    var restoreNodeScroll = function (_a) {
	        var element = _a[0], x = _a[1], y = _a[2];
	        element.scrollLeft = x;
	        element.scrollTop = y;
	    };
	    var PSEUDO_BEFORE = ':before';
	    var PSEUDO_AFTER = ':after';
	    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
	    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
	    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
	    var createPseudoHideStyles = function (body) {
	        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
	    };
	    var createStyles = function (body, styles) {
	        var document = body.ownerDocument;
	        if (document) {
	            var style = document.createElement('style');
	            style.textContent = styles;
	            body.appendChild(style);
	        }
	    };
	
	    var CacheStorage = /** @class */ (function () {
	        function CacheStorage() {
	        }
	        CacheStorage.getOrigin = function (url) {
	            var link = CacheStorage._link;
	            if (!link) {
	                return 'about:blank';
	            }
	            link.href = url;
	            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	            return link.protocol + link.hostname + link.port;
	        };
	        CacheStorage.isSameOrigin = function (src) {
	            return CacheStorage.getOrigin(src) === CacheStorage._origin;
	        };
	        CacheStorage.setContext = function (window) {
	            CacheStorage._link = window.document.createElement('a');
	            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
	        };
	        CacheStorage._origin = 'about:blank';
	        return CacheStorage;
	    }());
	    var Cache = /** @class */ (function () {
	        function Cache(context, _options) {
	            this.context = context;
	            this._options = _options;
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            this._cache = {};
	        }
	        Cache.prototype.addImage = function (src) {
	            var result = Promise.resolve();
	            if (this.has(src)) {
	                return result;
	            }
	            if (isBlobImage(src) || isRenderable(src)) {
	                (this._cache[src] = this.loadImage(src)).catch(function () {
	                    // prevent unhandled rejection
	                });
	                return result;
	            }
	            return result;
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Cache.prototype.match = function (src) {
	            return this._cache[src];
	        };
	        Cache.prototype.loadImage = function (key) {
	            return __awaiter(this, void 0, void 0, function () {
	                var isSameOrigin, useCORS, useProxy, src;
	                var _this = this;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            isSameOrigin = CacheStorage.isSameOrigin(key);
	                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
	                            useProxy = !isInlineImage(key) &&
	                                !isSameOrigin &&
	                                !isBlobImage(key) &&
	                                typeof this._options.proxy === 'string' &&
	                                FEATURES.SUPPORT_CORS_XHR &&
	                                !useCORS;
	                            if (!isSameOrigin &&
	                                this._options.allowTaint === false &&
	                                !isInlineImage(key) &&
	                                !isBlobImage(key) &&
	                                !useProxy &&
	                                !useCORS) {
	                                return [2 /*return*/];
	                            }
	                            src = key;
	                            if (!useProxy) return [3 /*break*/, 2];
	                            return [4 /*yield*/, this.proxy(src)];
	                        case 1:
	                            src = _a.sent();
	                            _a.label = 2;
	                        case 2:
	                            this.context.logger.debug("Added image " + key.substring(0, 256));
	                            return [4 /*yield*/, new Promise(function (resolve, reject) {
	                                    var img = new Image();
	                                    img.onload = function () { return resolve(img); };
	                                    img.onerror = reject;
	                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
	                                    if (isInlineBase64Image(src) || useCORS) {
	                                        img.crossOrigin = 'anonymous';
	                                    }
	                                    img.src = src;
	                                    if (img.complete === true) {
	                                        // Inline XML images may fail to parse, throwing an Error later on
	                                        setTimeout(function () { return resolve(img); }, 500);
	                                    }
	                                    if (_this._options.imageTimeout > 0) {
	                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
	                                    }
	                                })];
	                        case 3: return [2 /*return*/, _a.sent()];
	                    }
	                });
	            });
	        };
	        Cache.prototype.has = function (key) {
	            return typeof this._cache[key] !== 'undefined';
	        };
	        Cache.prototype.keys = function () {
	            return Promise.resolve(Object.keys(this._cache));
	        };
	        Cache.prototype.proxy = function (src) {
	            var _this = this;
	            var proxy = this._options.proxy;
	            if (!proxy) {
	                throw new Error('No proxy defined');
	            }
	            var key = src.substring(0, 256);
	            return new Promise(function (resolve, reject) {
	                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
	                var xhr = new XMLHttpRequest();
	                xhr.onload = function () {
	                    if (xhr.status === 200) {
	                        if (responseType === 'text') {
	                            resolve(xhr.response);
	                        }
	                        else {
	                            var reader_1 = new FileReader();
	                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
	                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
	                            reader_1.readAsDataURL(xhr.response);
	                        }
	                    }
	                    else {
	                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
	                    }
	                };
	                xhr.onerror = reject;
	                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
	                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
	                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
	                    xhr.responseType = responseType;
	                }
	                if (_this._options.imageTimeout) {
	                    var timeout_1 = _this._options.imageTimeout;
	                    xhr.timeout = timeout_1;
	                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
	                }
	                xhr.send();
	            });
	        };
	        return Cache;
	    }());
	    var INLINE_SVG = /^data:image\/svg\+xml/i;
	    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
	    var INLINE_IMG = /^data:image\/.*/i;
	    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
	    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
	    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
	    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
	    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };
	
	    var Vector = /** @class */ (function () {
	        function Vector(x, y) {
	            this.type = 0 /* VECTOR */;
	            this.x = x;
	            this.y = y;
	        }
	        Vector.prototype.add = function (deltaX, deltaY) {
	            return new Vector(this.x + deltaX, this.y + deltaY);
	        };
	        return Vector;
	    }());
	
	    var lerp = function (a, b, t) {
	        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
	    };
	    var BezierCurve = /** @class */ (function () {
	        function BezierCurve(start, startControl, endControl, end) {
	            this.type = 1 /* BEZIER_CURVE */;
	            this.start = start;
	            this.startControl = startControl;
	            this.endControl = endControl;
	            this.end = end;
	        }
	        BezierCurve.prototype.subdivide = function (t, firstHalf) {
	            var ab = lerp(this.start, this.startControl, t);
	            var bc = lerp(this.startControl, this.endControl, t);
	            var cd = lerp(this.endControl, this.end, t);
	            var abbc = lerp(ab, bc, t);
	            var bccd = lerp(bc, cd, t);
	            var dest = lerp(abbc, bccd, t);
	            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
	        };
	        BezierCurve.prototype.add = function (deltaX, deltaY) {
	            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
	        };
	        BezierCurve.prototype.reverse = function () {
	            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
	        };
	        return BezierCurve;
	    }());
	    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };
	
	    var BoundCurves = /** @class */ (function () {
	        function BoundCurves(element) {
	            var styles = element.styles;
	            var bounds = element.bounds;
	            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
	            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
	            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
	            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
	            var factors = [];
	            factors.push((tlh + trh) / bounds.width);
	            factors.push((blh + brh) / bounds.width);
	            factors.push((tlv + blv) / bounds.height);
	            factors.push((trv + brv) / bounds.height);
	            var maxFactor = Math.max.apply(Math, factors);
	            if (maxFactor > 1) {
	                tlh /= maxFactor;
	                tlv /= maxFactor;
	                trh /= maxFactor;
	                trv /= maxFactor;
	                brh /= maxFactor;
	                brv /= maxFactor;
	                blh /= maxFactor;
	                blv /= maxFactor;
	            }
	            var topWidth = bounds.width - trh;
	            var rightHeight = bounds.height - brv;
	            var bottomWidth = bounds.width - brh;
	            var leftHeight = bounds.height - blv;
	            var borderTopWidth = styles.borderTopWidth;
	            var borderRightWidth = styles.borderRightWidth;
	            var borderBottomWidth = styles.borderBottomWidth;
	            var borderLeftWidth = styles.borderLeftWidth;
	            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
	            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
	            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
	            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
	            this.topLeftBorderDoubleOuterBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
	            this.topRightBorderDoubleOuterBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
	            this.bottomRightBorderDoubleOuterBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
	            this.bottomLeftBorderDoubleOuterBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
	            this.topLeftBorderDoubleInnerBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
	            this.topRightBorderDoubleInnerBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
	            this.bottomRightBorderDoubleInnerBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
	            this.bottomLeftBorderDoubleInnerBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
	            this.topLeftBorderStroke =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
	            this.topRightBorderStroke =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
	            this.bottomRightBorderStroke =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
	            this.bottomLeftBorderStroke =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
	            this.topLeftBorderBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
	                    : new Vector(bounds.left, bounds.top);
	            this.topRightBorderBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width, bounds.top);
	            this.bottomRightBorderBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
	            this.bottomLeftBorderBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left, bounds.top + bounds.height);
	            this.topLeftPaddingBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
	            this.topRightPaddingBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
	            this.bottomRightPaddingBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
	            this.bottomLeftPaddingBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
	            this.topLeftContentBox =
	                tlh > 0 || tlv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
	            this.topRightContentBox =
	                trh > 0 || trv > 0
	                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
	            this.bottomRightContentBox =
	                brh > 0 || brv > 0
	                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
	                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
	            this.bottomLeftContentBox =
	                blh > 0 || blv > 0
	                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
	                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
	        }
	        return BoundCurves;
	    }());
	    var CORNER;
	    (function (CORNER) {
	        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
	        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
	        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
	        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
	    })(CORNER || (CORNER = {}));
	    var getCurvePoints = function (x, y, r1, r2, position) {
	        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
	        var ox = r1 * kappa; // control point offset horizontal
	        var oy = r2 * kappa; // control point offset vertical
	        var xm = x + r1; // x-middle
	        var ym = y + r2; // y-middle
	        switch (position) {
	            case CORNER.TOP_LEFT:
	                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
	            case CORNER.TOP_RIGHT:
	                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
	            case CORNER.BOTTOM_RIGHT:
	                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
	            case CORNER.BOTTOM_LEFT:
	            default:
	                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
	        }
	    };
	    var calculateBorderBoxPath = function (curves) {
	        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
	    };
	    var calculateContentBoxPath = function (curves) {
	        return [
	            curves.topLeftContentBox,
	            curves.topRightContentBox,
	            curves.bottomRightContentBox,
	            curves.bottomLeftContentBox
	        ];
	    };
	    var calculatePaddingBoxPath = function (curves) {
	        return [
	            curves.topLeftPaddingBox,
	            curves.topRightPaddingBox,
	            curves.bottomRightPaddingBox,
	            curves.bottomLeftPaddingBox
	        ];
	    };
	
	    var TransformEffect = /** @class */ (function () {
	        function TransformEffect(offsetX, offsetY, matrix) {
	            this.offsetX = offsetX;
	            this.offsetY = offsetY;
	            this.matrix = matrix;
	            this.type = 0 /* TRANSFORM */;
	            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
	        }
	        return TransformEffect;
	    }());
	    var ClipEffect = /** @class */ (function () {
	        function ClipEffect(path, target) {
	            this.path = path;
	            this.target = target;
	            this.type = 1 /* CLIP */;
	        }
	        return ClipEffect;
	    }());
	    var OpacityEffect = /** @class */ (function () {
	        function OpacityEffect(opacity) {
	            this.opacity = opacity;
	            this.type = 2 /* OPACITY */;
	            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
	        }
	        return OpacityEffect;
	    }());
	    var isTransformEffect = function (effect) {
	        return effect.type === 0 /* TRANSFORM */;
	    };
	    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
	    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };
	
	    var equalPath = function (a, b) {
	        if (a.length === b.length) {
	            return a.some(function (v, i) { return v === b[i]; });
	        }
	        return false;
	    };
	    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
	        return path.map(function (point, index) {
	            switch (index) {
	                case 0:
	                    return point.add(deltaX, deltaY);
	                case 1:
	                    return point.add(deltaX + deltaW, deltaY);
	                case 2:
	                    return point.add(deltaX + deltaW, deltaY + deltaH);
	                case 3:
	                    return point.add(deltaX, deltaY + deltaH);
	            }
	            return point;
	        });
	    };
	
	    var StackingContext = /** @class */ (function () {
	        function StackingContext(container) {
	            this.element = container;
	            this.inlineLevel = [];
	            this.nonInlineLevel = [];
	            this.negativeZIndex = [];
	            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
	            this.positiveZIndex = [];
	            this.nonPositionedFloats = [];
	            this.nonPositionedInlineLevel = [];
	        }
	        return StackingContext;
	    }());
	    var ElementPaint = /** @class */ (function () {
	        function ElementPaint(container, parent) {
	            this.container = container;
	            this.parent = parent;
	            this.effects = [];
	            this.curves = new BoundCurves(this.container);
	            if (this.container.styles.opacity < 1) {
	                this.effects.push(new OpacityEffect(this.container.styles.opacity));
	            }
	            if (this.container.styles.transform !== null) {
	                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
	                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
	                var matrix = this.container.styles.transform;
	                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
	            }
	            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
	                var borderBox = calculateBorderBoxPath(this.curves);
	                var paddingBox = calculatePaddingBoxPath(this.curves);
	                if (equalPath(borderBox, paddingBox)) {
	                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
	                }
	                else {
	                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
	                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
	                }
	            }
	        }
	        ElementPaint.prototype.getEffects = function (target) {
	            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
	            var parent = this.parent;
	            var effects = this.effects.slice(0);
	            while (parent) {
	                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
	                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
	                    effects.unshift.apply(effects, croplessEffects);
	                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
	                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
	                        var borderBox = calculateBorderBoxPath(parent.curves);
	                        var paddingBox = calculatePaddingBoxPath(parent.curves);
	                        if (!equalPath(borderBox, paddingBox)) {
	                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
	                        }
	                    }
	                }
	                else {
	                    effects.unshift.apply(effects, croplessEffects);
	                }
	                parent = parent.parent;
	            }
	            return effects.filter(function (effect) { return contains(effect.target, target); });
	        };
	        return ElementPaint;
	    }());
	    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
	        parent.container.elements.forEach(function (child) {
	            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
	            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
	            var paintContainer = new ElementPaint(child, parent);
	            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
	                listItems.push(paintContainer);
	            }
	            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
	            if (treatAsRealStackingContext || createsStackingContext) {
	                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
	                var stack = new StackingContext(paintContainer);
	                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
	                    var order_1 = child.styles.zIndex.order;
	                    if (order_1 < 0) {
	                        var index_1 = 0;
	                        parentStack.negativeZIndex.some(function (current, i) {
	                            if (order_1 > current.element.container.styles.zIndex.order) {
	                                index_1 = i;
	                                return false;
	                            }
	                            else if (index_1 > 0) {
	                                return true;
	                            }
	                            return false;
	                        });
	                        parentStack.negativeZIndex.splice(index_1, 0, stack);
	                    }
	                    else if (order_1 > 0) {
	                        var index_2 = 0;
	                        parentStack.positiveZIndex.some(function (current, i) {
	                            if (order_1 >= current.element.container.styles.zIndex.order) {
	                                index_2 = i + 1;
	                                return false;
	                            }
	                            else if (index_2 > 0) {
	                                return true;
	                            }
	                            return false;
	                        });
	                        parentStack.positiveZIndex.splice(index_2, 0, stack);
	                    }
	                    else {
	                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
	                    }
	                }
	                else {
	                    if (child.styles.isFloating()) {
	                        parentStack.nonPositionedFloats.push(stack);
	                    }
	                    else {
	                        parentStack.nonPositionedInlineLevel.push(stack);
	                    }
	                }
	                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
	            }
	            else {
	                if (child.styles.isInlineLevel()) {
	                    stackingContext.inlineLevel.push(paintContainer);
	                }
	                else {
	                    stackingContext.nonInlineLevel.push(paintContainer);
	                }
	                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
	            }
	            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
	                processListItems(child, listOwnerItems);
	            }
	        });
	    };
	    var processListItems = function (owner, elements) {
	        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
	        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
	        for (var i = 0; i < elements.length; i++) {
	            var item = elements[i];
	            if (item.container instanceof LIElementContainer &&
	                typeof item.container.value === 'number' &&
	                item.container.value !== 0) {
	                numbering = item.container.value;
	            }
	            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
	            numbering += reversed ? -1 : 1;
	        }
	    };
	    var parseStackingContexts = function (container) {
	        var paintContainer = new ElementPaint(container, null);
	        var root = new StackingContext(paintContainer);
	        var listItems = [];
	        parseStackTree(paintContainer, root, root, listItems);
	        processListItems(paintContainer.container, listItems);
	        return root;
	    };
	
	    var parsePathForBorder = function (curves, borderSide) {
	        switch (borderSide) {
	            case 0:
	                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
	            case 1:
	                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
	            case 2:
	                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
	            case 3:
	            default:
	                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
	        }
	    };
	    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
	        switch (borderSide) {
	            case 0:
	                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
	            case 1:
	                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
	            case 2:
	                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
	            case 3:
	            default:
	                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
	        }
	    };
	    var parsePathForBorderDoubleInner = function (curves, borderSide) {
	        switch (borderSide) {
	            case 0:
	                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
	            case 1:
	                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
	            case 2:
	                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
	            case 3:
	            default:
	                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
	        }
	    };
	    var parsePathForBorderStroke = function (curves, borderSide) {
	        switch (borderSide) {
	            case 0:
	                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
	            case 1:
	                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
	            case 2:
	                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
	            case 3:
	            default:
	                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
	        }
	    };
	    var createStrokePathFromCurves = function (outer1, outer2) {
	        var path = [];
	        if (isBezierCurve(outer1)) {
	            path.push(outer1.subdivide(0.5, false));
	        }
	        else {
	            path.push(outer1);
	        }
	        if (isBezierCurve(outer2)) {
	            path.push(outer2.subdivide(0.5, true));
	        }
	        else {
	            path.push(outer2);
	        }
	        return path;
	    };
	    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
	        var path = [];
	        if (isBezierCurve(outer1)) {
	            path.push(outer1.subdivide(0.5, false));
	        }
	        else {
	            path.push(outer1);
	        }
	        if (isBezierCurve(outer2)) {
	            path.push(outer2.subdivide(0.5, true));
	        }
	        else {
	            path.push(outer2);
	        }
	        if (isBezierCurve(inner2)) {
	            path.push(inner2.subdivide(0.5, true).reverse());
	        }
	        else {
	            path.push(inner2);
	        }
	        if (isBezierCurve(inner1)) {
	            path.push(inner1.subdivide(0.5, false).reverse());
	        }
	        else {
	            path.push(inner1);
	        }
	        return path;
	    };
	
	    var paddingBox = function (element) {
	        var bounds = element.bounds;
	        var styles = element.styles;
	        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
	    };
	    var contentBox = function (element) {
	        var styles = element.styles;
	        var bounds = element.bounds;
	        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
	        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
	        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
	        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
	        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
	    };
	
	    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
	        if (backgroundOrigin === 0 /* BORDER_BOX */) {
	            return element.bounds;
	        }
	        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
	            return contentBox(element);
	        }
	        return paddingBox(element);
	    };
	    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
	        if (backgroundClip === 0 /* BORDER_BOX */) {
	            return element.bounds;
	        }
	        if (backgroundClip === 2 /* CONTENT_BOX */) {
	            return contentBox(element);
	        }
	        return paddingBox(element);
	    };
	    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
	        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
	        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
	        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
	        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
	        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
	        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
	        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
	        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
	        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
	    };
	    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
	    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
	    var calculateBackgroundSize = function (size, _a, bounds) {
	        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
	        var first = size[0], second = size[1];
	        if (!first) {
	            return [0, 0];
	        }
	        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
	            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
	        }
	        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
	        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
	            if (hasIntrinsicValue(intrinsicProportion)) {
	                var targetRatio = bounds.width / bounds.height;
	                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
	                    ? [bounds.width, bounds.width / intrinsicProportion]
	                    : [bounds.height * intrinsicProportion, bounds.height];
	            }
	            return [bounds.width, bounds.height];
	        }
	        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
	        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
	        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
	        // If the background-size is auto or auto auto:
	        if (isAuto(first) && (!second || isAuto(second))) {
	            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
	            if (hasIntrinsicWidth && hasIntrinsicHeight) {
	                return [intrinsicWidth, intrinsicHeight];
	            }
	            // If the image has no intrinsic dimensions and has no intrinsic proportions,
	            // it's rendered at the size of the background positioning area.
	            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
	                return [bounds.width, bounds.height];
	            }
	            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
	            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
	            // The other dimension is computed using the specified dimension and the intrinsic proportions.
	            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
	                var width_1 = hasIntrinsicWidth
	                    ? intrinsicWidth
	                    : intrinsicHeight * intrinsicProportion;
	                var height_1 = hasIntrinsicHeight
	                    ? intrinsicHeight
	                    : intrinsicWidth / intrinsicProportion;
	                return [width_1, height_1];
	            }
	            // If the image has only one intrinsic dimension but has no intrinsic proportions,
	            // it's rendered using the specified dimension and the other dimension of the background positioning area.
	            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
	            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
	            return [width_2, height_2];
	        }
	        // If the image has intrinsic proportions, it's stretched to the specified dimension.
	        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
	        if (hasIntrinsicProportion) {
	            var width_3 = 0;
	            var height_3 = 0;
	            if (isLengthPercentage(first)) {
	                width_3 = getAbsoluteValue(first, bounds.width);
	            }
	            else if (isLengthPercentage(second)) {
	                height_3 = getAbsoluteValue(second, bounds.height);
	            }
	            if (isAuto(first)) {
	                width_3 = height_3 * intrinsicProportion;
	            }
	            else if (!second || isAuto(second)) {
	                height_3 = width_3 / intrinsicProportion;
	            }
	            return [width_3, height_3];
	        }
	        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
	        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
	        // if there is one. If there is no such intrinsic dimension,
	        // it becomes the corresponding dimension of the background positioning area.
	        var width = null;
	        var height = null;
	        if (isLengthPercentage(first)) {
	            width = getAbsoluteValue(first, bounds.width);
	        }
	        else if (second && isLengthPercentage(second)) {
	            height = getAbsoluteValue(second, bounds.height);
	        }
	        if (width !== null && (!second || isAuto(second))) {
	            height =
	                hasIntrinsicWidth && hasIntrinsicHeight
	                    ? (width / intrinsicWidth) * intrinsicHeight
	                    : bounds.height;
	        }
	        if (height !== null && isAuto(first)) {
	            width =
	                hasIntrinsicWidth && hasIntrinsicHeight
	                    ? (height / intrinsicHeight) * intrinsicWidth
	                    : bounds.width;
	        }
	        if (width !== null && height !== null) {
	            return [width, height];
	        }
	        throw new Error("Unable to calculate background-size for element");
	    };
	    var getBackgroundValueForIndex = function (values, index) {
	        var value = values[index];
	        if (typeof value === 'undefined') {
	            return values[0];
	        }
	        return value;
	    };
	    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
	        var x = _a[0], y = _a[1];
	        var width = _b[0], height = _b[1];
	        switch (repeat) {
	            case 2 /* REPEAT_X */:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
	                ];
	            case 3 /* REPEAT_Y */:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
	                ];
	            case 1 /* NO_REPEAT */:
	                return [
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
	                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
	                ];
	            default:
	                return [
	                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
	                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
	                ];
	        }
	    };
	
	    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
	
	    var SAMPLE_TEXT = 'Hidden Text';
	    var FontMetrics = /** @class */ (function () {
	        function FontMetrics(document) {
	            this._data = {};
	            this._document = document;
	        }
	        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
	            var container = this._document.createElement('div');
	            var img = this._document.createElement('img');
	            var span = this._document.createElement('span');
	            var body = this._document.body;
	            container.style.visibility = 'hidden';
	            container.style.fontFamily = fontFamily;
	            container.style.fontSize = fontSize;
	            container.style.margin = '0';
	            container.style.padding = '0';
	            container.style.whiteSpace = 'nowrap';
	            body.appendChild(container);
	            img.src = SMALL_IMAGE;
	            img.width = 1;
	            img.height = 1;
	            img.style.margin = '0';
	            img.style.padding = '0';
	            img.style.verticalAlign = 'baseline';
	            span.style.fontFamily = fontFamily;
	            span.style.fontSize = fontSize;
	            span.style.margin = '0';
	            span.style.padding = '0';
	            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.appendChild(span);
	            container.appendChild(img);
	            var baseline = img.offsetTop - span.offsetTop + 2;
	            container.removeChild(span);
	            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
	            container.style.lineHeight = 'normal';
	            img.style.verticalAlign = 'super';
	            var middle = img.offsetTop - container.offsetTop + 2;
	            body.removeChild(container);
	            return { baseline: baseline, middle: middle };
	        };
	        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
	            var key = fontFamily + " " + fontSize;
	            if (typeof this._data[key] === 'undefined') {
	                this._data[key] = this.parseMetrics(fontFamily, fontSize);
	            }
	            return this._data[key];
	        };
	        return FontMetrics;
	    }());
	
	    var Renderer = /** @class */ (function () {
	        function Renderer(context, options) {
	            this.context = context;
	            this.options = options;
	        }
	        return Renderer;
	    }());
	
	    var MASK_OFFSET = 10000;
	    var CanvasRenderer = /** @class */ (function (_super) {
	        __extends(CanvasRenderer, _super);
	        function CanvasRenderer(context, options) {
	            var _this = _super.call(this, context, options) || this;
	            _this._activeEffects = [];
	            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
	            _this.ctx = _this.canvas.getContext('2d');
	            if (!options.canvas) {
	                _this.canvas.width = Math.floor(options.width * options.scale);
	                _this.canvas.height = Math.floor(options.height * options.scale);
	                _this.canvas.style.width = options.width + "px";
	                _this.canvas.style.height = options.height + "px";
	            }
	            _this.fontMetrics = new FontMetrics(document);
	            _this.ctx.scale(_this.options.scale, _this.options.scale);
	            _this.ctx.translate(-options.x, -options.y);
	            _this.ctx.textBaseline = 'bottom';
	            _this._activeEffects = [];
	            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
	            return _this;
	        }
	        CanvasRenderer.prototype.applyEffects = function (effects) {
	            var _this = this;
	            while (this._activeEffects.length) {
	                this.popEffect();
	            }
	            effects.forEach(function (effect) { return _this.applyEffect(effect); });
	        };
	        CanvasRenderer.prototype.applyEffect = function (effect) {
	            this.ctx.save();
	            if (isOpacityEffect(effect)) {
	                this.ctx.globalAlpha = effect.opacity;
	            }
	            if (isTransformEffect(effect)) {
	                this.ctx.translate(effect.offsetX, effect.offsetY);
	                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
	                this.ctx.translate(-effect.offsetX, -effect.offsetY);
	            }
	            if (isClipEffect(effect)) {
	                this.path(effect.path);
	                this.ctx.clip();
	            }
	            this._activeEffects.push(effect);
	        };
	        CanvasRenderer.prototype.popEffect = function () {
	            this._activeEffects.pop();
	            this.ctx.restore();
	        };
	        CanvasRenderer.prototype.renderStack = function (stack) {
	            return __awaiter(this, void 0, void 0, function () {
	                var styles;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            styles = stack.element.container.styles;
	                            if (!styles.isVisible()) return [3 /*break*/, 2];
	                            return [4 /*yield*/, this.renderStackContent(stack)];
	                        case 1:
	                            _a.sent();
	                            _a.label = 2;
	                        case 2: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderNode = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
	                                debugger;
	                            }
	                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
	                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
	                        case 1:
	                            _a.sent();
	                            return [4 /*yield*/, this.renderNodeContent(paint)];
	                        case 2:
	                            _a.sent();
	                            _a.label = 3;
	                        case 3: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
	            var _this = this;
	            if (letterSpacing === 0) {
	                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
	            }
	            else {
	                var letters = segmentGraphemes(text.text);
	                letters.reduce(function (left, letter) {
	                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
	                    return left + _this.ctx.measureText(letter).width;
	                }, text.bounds.left);
	            }
	        };
	        CanvasRenderer.prototype.createFontStyle = function (styles) {
	            var fontVariant = styles.fontVariant
	                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
	                .join('');
	            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
	            var fontSize = isDimensionToken(styles.fontSize)
	                ? "" + styles.fontSize.number + styles.fontSize.unit
	                : styles.fontSize.number + "px";
	            return [
	                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
	                fontFamily,
	                fontSize
	            ];
	        };
	        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
	            return __awaiter(this, void 0, void 0, function () {
	                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
	                var _this = this;
	                return __generator(this, function (_c) {
	                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
	                    this.ctx.font = font;
	                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
	                    this.ctx.textAlign = 'left';
	                    this.ctx.textBaseline = 'alphabetic';
	                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
	                    paintOrder = styles.paintOrder;
	                    text.textBounds.forEach(function (text) {
	                        paintOrder.forEach(function (paintOrderLayer) {
	                            switch (paintOrderLayer) {
	                                case 0 /* FILL */:
	                                    _this.ctx.fillStyle = asString(styles.color);
	                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
	                                    var textShadows = styles.textShadow;
	                                    if (textShadows.length && text.text.trim().length) {
	                                        textShadows
	                                            .slice(0)
	                                            .reverse()
	                                            .forEach(function (textShadow) {
	                                            _this.ctx.shadowColor = asString(textShadow.color);
	                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
	                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
	                                            _this.ctx.shadowBlur = textShadow.blur.number;
	                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
	                                        });
	                                        _this.ctx.shadowColor = '';
	                                        _this.ctx.shadowOffsetX = 0;
	                                        _this.ctx.shadowOffsetY = 0;
	                                        _this.ctx.shadowBlur = 0;
	                                    }
	                                    if (styles.textDecorationLine.length) {
	                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
	                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
	                                            switch (textDecorationLine) {
	                                                case 1 /* UNDERLINE */:
	                                                    // Draws a line at the baseline of the font
	                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
	                                                    // need to take that into account both in position and size
	                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
	                                                    break;
	                                                case 2 /* OVERLINE */:
	                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
	                                                    break;
	                                                case 3 /* LINE_THROUGH */:
	                                                    // TODO try and find exact position for line-through
	                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
	                                                    break;
	                                            }
	                                        });
	                                    }
	                                    break;
	                                case 1 /* STROKE */:
	                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
	                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
	                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
	                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
	                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
	                                    }
	                                    _this.ctx.strokeStyle = '';
	                                    _this.ctx.lineWidth = 0;
	                                    _this.ctx.lineJoin = 'miter';
	                                    break;
	                            }
	                        });
	                    });
	                    return [2 /*return*/];
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
	            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
	                var box = contentBox(container);
	                var path = calculatePaddingBoxPath(curves);
	                this.path(path);
	                this.ctx.save();
	                this.ctx.clip();
	                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
	                this.ctx.restore();
	            }
	        };
	        CanvasRenderer.prototype.renderNodeContent = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
	                return __generator(this, function (_c) {
	                    switch (_c.label) {
	                        case 0:
	                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
	                            container = paint.container;
	                            curves = paint.curves;
	                            styles = container.styles;
	                            _i = 0, _a = container.textNodes;
	                            _c.label = 1;
	                        case 1:
	                            if (!(_i < _a.length)) return [3 /*break*/, 4];
	                            child = _a[_i];
	                            return [4 /*yield*/, this.renderTextNode(child, styles)];
	                        case 2:
	                            _c.sent();
	                            _c.label = 3;
	                        case 3:
	                            _i++;
	                            return [3 /*break*/, 1];
	                        case 4:
	                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
	                            _c.label = 5;
	                        case 5:
	                            _c.trys.push([5, 7, , 8]);
	                            return [4 /*yield*/, this.context.cache.match(container.src)];
	                        case 6:
	                            image = _c.sent();
	                            this.renderReplacedElement(container, curves, image);
	                            return [3 /*break*/, 8];
	                        case 7:
	                            _c.sent();
	                            this.context.logger.error("Error loading image " + container.src);
	                            return [3 /*break*/, 8];
	                        case 8:
	                            if (container instanceof CanvasElementContainer) {
	                                this.renderReplacedElement(container, curves, container.canvas);
	                            }
	                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
	                            _c.label = 9;
	                        case 9:
	                            _c.trys.push([9, 11, , 12]);
	                            return [4 /*yield*/, this.context.cache.match(container.svg)];
	                        case 10:
	                            image = _c.sent();
	                            this.renderReplacedElement(container, curves, image);
	                            return [3 /*break*/, 12];
	                        case 11:
	                            _c.sent();
	                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
	                            return [3 /*break*/, 12];
	                        case 12:
	                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
	                            iframeRenderer = new CanvasRenderer(this.context, {
	                                scale: this.options.scale,
	                                backgroundColor: container.backgroundColor,
	                                x: 0,
	                                y: 0,
	                                width: container.width,
	                                height: container.height
	                            });
	                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
	                        case 13:
	                            canvas = _c.sent();
	                            if (container.width && container.height) {
	                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
	                            }
	                            _c.label = 14;
	                        case 14:
	                            if (container instanceof InputElementContainer) {
	                                size = Math.min(container.bounds.width, container.bounds.height);
	                                if (container.type === CHECKBOX) {
	                                    if (container.checked) {
	                                        this.ctx.save();
	                                        this.path([
	                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
	                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
	                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
	                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
	                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
	                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
	                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
	                                        ]);
	                                        this.ctx.fillStyle = asString(INPUT_COLOR);
	                                        this.ctx.fill();
	                                        this.ctx.restore();
	                                    }
	                                }
	                                else if (container.type === RADIO) {
	                                    if (container.checked) {
	                                        this.ctx.save();
	                                        this.ctx.beginPath();
	                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
	                                        this.ctx.fillStyle = asString(INPUT_COLOR);
	                                        this.ctx.fill();
	                                        this.ctx.restore();
	                                    }
	                                }
	                            }
	                            if (isTextInputElement(container) && container.value.length) {
	                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
	                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
	                                this.ctx.font = fontFamily;
	                                this.ctx.fillStyle = asString(styles.color);
	                                this.ctx.textBaseline = 'alphabetic';
	                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
	                                bounds = contentBox(container);
	                                x = 0;
	                                switch (container.styles.textAlign) {
	                                    case 1 /* CENTER */:
	                                        x += bounds.width / 2;
	                                        break;
	                                    case 2 /* RIGHT */:
	                                        x += bounds.width;
	                                        break;
	                                }
	                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
	                                this.ctx.save();
	                                this.path([
	                                    new Vector(bounds.left, bounds.top),
	                                    new Vector(bounds.left + bounds.width, bounds.top),
	                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
	                                    new Vector(bounds.left, bounds.top + bounds.height)
	                                ]);
	                                this.ctx.clip();
	                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
	                                this.ctx.restore();
	                                this.ctx.textBaseline = 'alphabetic';
	                                this.ctx.textAlign = 'left';
	                            }
	                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
	                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
	                            img = container.styles.listStyleImage;
	                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
	                            image = void 0;
	                            url = img.url;
	                            _c.label = 15;
	                        case 15:
	                            _c.trys.push([15, 17, , 18]);
	                            return [4 /*yield*/, this.context.cache.match(url)];
	                        case 16:
	                            image = _c.sent();
	                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
	                            return [3 /*break*/, 18];
	                        case 17:
	                            _c.sent();
	                            this.context.logger.error("Error loading list-style-image " + url);
	                            return [3 /*break*/, 18];
	                        case 18: return [3 /*break*/, 20];
	                        case 19:
	                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
	                                fontFamily = this.createFontStyle(styles)[0];
	                                this.ctx.font = fontFamily;
	                                this.ctx.fillStyle = asString(styles.color);
	                                this.ctx.textBaseline = 'middle';
	                                this.ctx.textAlign = 'right';
	                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
	                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
	                                this.ctx.textBaseline = 'bottom';
	                                this.ctx.textAlign = 'left';
	                            }
	                            _c.label = 20;
	                        case 20: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderStackContent = function (stack) {
	            return __awaiter(this, void 0, void 0, function () {
	                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
	                return __generator(this, function (_p) {
	                    switch (_p.label) {
	                        case 0:
	                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
	                                debugger;
	                            }
	                            // https://www.w3.org/TR/css-position-3/#painting-order
	                            // 1. the background and borders of the element forming the stacking context.
	                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
	                        case 1:
	                            // https://www.w3.org/TR/css-position-3/#painting-order
	                            // 1. the background and borders of the element forming the stacking context.
	                            _p.sent();
	                            _i = 0, _a = stack.negativeZIndex;
	                            _p.label = 2;
	                        case 2:
	                            if (!(_i < _a.length)) return [3 /*break*/, 5];
	                            child = _a[_i];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 3:
	                            _p.sent();
	                            _p.label = 4;
	                        case 4:
	                            _i++;
	                            return [3 /*break*/, 2];
	                        case 5: 
	                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
	                        case 6:
	                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
	                            _p.sent();
	                            _b = 0, _c = stack.nonInlineLevel;
	                            _p.label = 7;
	                        case 7:
	                            if (!(_b < _c.length)) return [3 /*break*/, 10];
	                            child = _c[_b];
	                            return [4 /*yield*/, this.renderNode(child)];
	                        case 8:
	                            _p.sent();
	                            _p.label = 9;
	                        case 9:
	                            _b++;
	                            return [3 /*break*/, 7];
	                        case 10:
	                            _d = 0, _e = stack.nonPositionedFloats;
	                            _p.label = 11;
	                        case 11:
	                            if (!(_d < _e.length)) return [3 /*break*/, 14];
	                            child = _e[_d];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 12:
	                            _p.sent();
	                            _p.label = 13;
	                        case 13:
	                            _d++;
	                            return [3 /*break*/, 11];
	                        case 14:
	                            _f = 0, _g = stack.nonPositionedInlineLevel;
	                            _p.label = 15;
	                        case 15:
	                            if (!(_f < _g.length)) return [3 /*break*/, 18];
	                            child = _g[_f];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 16:
	                            _p.sent();
	                            _p.label = 17;
	                        case 17:
	                            _f++;
	                            return [3 /*break*/, 15];
	                        case 18:
	                            _h = 0, _j = stack.inlineLevel;
	                            _p.label = 19;
	                        case 19:
	                            if (!(_h < _j.length)) return [3 /*break*/, 22];
	                            child = _j[_h];
	                            return [4 /*yield*/, this.renderNode(child)];
	                        case 20:
	                            _p.sent();
	                            _p.label = 21;
	                        case 21:
	                            _h++;
	                            return [3 /*break*/, 19];
	                        case 22:
	                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
	                            _p.label = 23;
	                        case 23:
	                            if (!(_k < _l.length)) return [3 /*break*/, 26];
	                            child = _l[_k];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 24:
	                            _p.sent();
	                            _p.label = 25;
	                        case 25:
	                            _k++;
	                            return [3 /*break*/, 23];
	                        case 26:
	                            _m = 0, _o = stack.positiveZIndex;
	                            _p.label = 27;
	                        case 27:
	                            if (!(_m < _o.length)) return [3 /*break*/, 30];
	                            child = _o[_m];
	                            return [4 /*yield*/, this.renderStack(child)];
	                        case 28:
	                            _p.sent();
	                            _p.label = 29;
	                        case 29:
	                            _m++;
	                            return [3 /*break*/, 27];
	                        case 30: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.mask = function (paths) {
	            this.ctx.beginPath();
	            this.ctx.moveTo(0, 0);
	            this.ctx.lineTo(this.canvas.width, 0);
	            this.ctx.lineTo(this.canvas.width, this.canvas.height);
	            this.ctx.lineTo(0, this.canvas.height);
	            this.ctx.lineTo(0, 0);
	            this.formatPath(paths.slice(0).reverse());
	            this.ctx.closePath();
	        };
	        CanvasRenderer.prototype.path = function (paths) {
	            this.ctx.beginPath();
	            this.formatPath(paths);
	            this.ctx.closePath();
	        };
	        CanvasRenderer.prototype.formatPath = function (paths) {
	            var _this = this;
	            paths.forEach(function (point, index) {
	                var start = isBezierCurve(point) ? point.start : point;
	                if (index === 0) {
	                    _this.ctx.moveTo(start.x, start.y);
	                }
	                else {
	                    _this.ctx.lineTo(start.x, start.y);
	                }
	                if (isBezierCurve(point)) {
	                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
	                }
	            });
	        };
	        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
	            this.path(path);
	            this.ctx.fillStyle = pattern;
	            this.ctx.translate(offsetX, offsetY);
	            this.ctx.fill();
	            this.ctx.translate(-offsetX, -offsetY);
	        };
	        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
	            var _a;
	            if (image.width === width && image.height === height) {
	                return image;
	            }
	            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
	            var canvas = ownerDocument.createElement('canvas');
	            canvas.width = Math.max(1, width);
	            canvas.height = Math.max(1, height);
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
	            return canvas;
	        };
	        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
	            return __awaiter(this, void 0, void 0, function () {
	                var index, _loop_1, this_1, _i, _a, backgroundImage;
	                return __generator(this, function (_b) {
	                    switch (_b.label) {
	                        case 0:
	                            index = container.styles.backgroundImage.length - 1;
	                            _loop_1 = function (backgroundImage) {
	                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
	                                return __generator(this, function (_h) {
	                                    switch (_h.label) {
	                                        case 0:
	                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
	                                            image = void 0;
	                                            url = backgroundImage.url;
	                                            _h.label = 1;
	                                        case 1:
	                                            _h.trys.push([1, 3, , 4]);
	                                            return [4 /*yield*/, this_1.context.cache.match(url)];
	                                        case 2:
	                                            image = _h.sent();
	                                            return [3 /*break*/, 4];
	                                        case 3:
	                                            _h.sent();
	                                            this_1.context.logger.error("Error loading background-image " + url);
	                                            return [3 /*break*/, 4];
	                                        case 4:
	                                            if (image) {
	                                                _c = calculateBackgroundRendering(container, index, [
	                                                    image.width,
	                                                    image.height,
	                                                    image.width / image.height
	                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
	                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
	                                                this_1.renderRepeat(path, pattern, x, y);
	                                            }
	                                            return [3 /*break*/, 6];
	                                        case 5:
	                                            if (isLinearGradient(backgroundImage)) {
	                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
	                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
	                                                canvas = document.createElement('canvas');
	                                                canvas.width = width;
	                                                canvas.height = height;
	                                                ctx = canvas.getContext('2d');
	                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
	                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
	                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
	                                                });
	                                                ctx.fillStyle = gradient_1;
	                                                ctx.fillRect(0, 0, width, height);
	                                                if (width > 0 && height > 0) {
	                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
	                                                    this_1.renderRepeat(path, pattern, x, y);
	                                                }
	                                            }
	                                            else if (isRadialGradient(backgroundImage)) {
	                                                _f = calculateBackgroundRendering(container, index, [
	                                                    null,
	                                                    null,
	                                                    null
	                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
	                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
	                                                x = getAbsoluteValue(position[0], width);
	                                                y = getAbsoluteValue(position[position.length - 1], height);
	                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
	                                                if (rx > 0 && ry > 0) {
	                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
	                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
	                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
	                                                    });
	                                                    this_1.path(path);
	                                                    this_1.ctx.fillStyle = radialGradient_1;
	                                                    if (rx !== ry) {
	                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
	                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
	                                                        f = ry / rx;
	                                                        invF = 1 / f;
	                                                        this_1.ctx.save();
	                                                        this_1.ctx.translate(midX, midY);
	                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
	                                                        this_1.ctx.translate(-midX, -midY);
	                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
	                                                        this_1.ctx.restore();
	                                                    }
	                                                    else {
	                                                        this_1.ctx.fill();
	                                                    }
	                                                }
	                                            }
	                                            _h.label = 6;
	                                        case 6:
	                                            index--;
	                                            return [2 /*return*/];
	                                    }
	                                });
	                            };
	                            this_1 = this;
	                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
	                            _b.label = 1;
	                        case 1:
	                            if (!(_i < _a.length)) return [3 /*break*/, 4];
	                            backgroundImage = _a[_i];
	                            return [5 /*yield**/, _loop_1(backgroundImage)];
	                        case 2:
	                            _b.sent();
	                            _b.label = 3;
	                        case 3:
	                            _i++;
	                            return [3 /*break*/, 1];
	                        case 4: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
	            return __awaiter(this, void 0, void 0, function () {
	                return __generator(this, function (_a) {
	                    this.path(parsePathForBorder(curvePoints, side));
	                    this.ctx.fillStyle = asString(color);
	                    this.ctx.fill();
	                    return [2 /*return*/];
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
	            return __awaiter(this, void 0, void 0, function () {
	                var outerPaths, innerPaths;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (!(width < 3)) return [3 /*break*/, 2];
	                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
	                        case 1:
	                            _a.sent();
	                            return [2 /*return*/];
	                        case 2:
	                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
	                            this.path(outerPaths);
	                            this.ctx.fillStyle = asString(color);
	                            this.ctx.fill();
	                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
	                            this.path(innerPaths);
	                            this.ctx.fill();
	                            return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
	            return __awaiter(this, void 0, void 0, function () {
	                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
	                var _this = this;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
	                            styles = paint.container.styles;
	                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
	                            borders = [
	                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
	                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
	                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
	                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
	                            ];
	                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
	                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
	                            this.ctx.save();
	                            this.path(backgroundPaintingArea);
	                            this.ctx.clip();
	                            if (!isTransparent(styles.backgroundColor)) {
	                                this.ctx.fillStyle = asString(styles.backgroundColor);
	                                this.ctx.fill();
	                            }
	                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
	                        case 1:
	                            _a.sent();
	                            this.ctx.restore();
	                            styles.boxShadow
	                                .slice(0)
	                                .reverse()
	                                .forEach(function (shadow) {
	                                _this.ctx.save();
	                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
	                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
	                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
	                                if (shadow.inset) {
	                                    _this.path(borderBoxArea);
	                                    _this.ctx.clip();
	                                    _this.mask(shadowPaintingArea);
	                                }
	                                else {
	                                    _this.mask(borderBoxArea);
	                                    _this.ctx.clip();
	                                    _this.path(shadowPaintingArea);
	                                }
	                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
	                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
	                                _this.ctx.shadowColor = asString(shadow.color);
	                                _this.ctx.shadowBlur = shadow.blur.number;
	                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
	                                _this.ctx.fill();
	                                _this.ctx.restore();
	                            });
	                            _a.label = 2;
	                        case 2:
	                            side = 0;
	                            _i = 0, borders_1 = borders;
	                            _a.label = 3;
	                        case 3:
	                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
	                            border = borders_1[_i];
	                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
	                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
	                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
	                        case 4:
	                            _a.sent();
	                            return [3 /*break*/, 11];
	                        case 5:
	                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
	                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
	                        case 6:
	                            _a.sent();
	                            return [3 /*break*/, 11];
	                        case 7:
	                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
	                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
	                        case 8:
	                            _a.sent();
	                            return [3 /*break*/, 11];
	                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
	                        case 10:
	                            _a.sent();
	                            _a.label = 11;
	                        case 11:
	                            side++;
	                            _a.label = 12;
	                        case 12:
	                            _i++;
	                            return [3 /*break*/, 3];
	                        case 13: return [2 /*return*/];
	                    }
	                });
	            });
	        };
	        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
	            return __awaiter(this, void 0, void 0, function () {
	                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
	                return __generator(this, function (_a) {
	                    this.ctx.save();
	                    strokePaths = parsePathForBorderStroke(curvePoints, side);
	                    boxPaths = parsePathForBorder(curvePoints, side);
	                    if (style === 2 /* DASHED */) {
	                        this.path(boxPaths);
	                        this.ctx.clip();
	                    }
	                    if (isBezierCurve(boxPaths[0])) {
	                        startX = boxPaths[0].start.x;
	                        startY = boxPaths[0].start.y;
	                    }
	                    else {
	                        startX = boxPaths[0].x;
	                        startY = boxPaths[0].y;
	                    }
	                    if (isBezierCurve(boxPaths[1])) {
	                        endX = boxPaths[1].end.x;
	                        endY = boxPaths[1].end.y;
	                    }
	                    else {
	                        endX = boxPaths[1].x;
	                        endY = boxPaths[1].y;
	                    }
	                    if (side === 0 || side === 2) {
	                        length = Math.abs(startX - endX);
	                    }
	                    else {
	                        length = Math.abs(startY - endY);
	                    }
	                    this.ctx.beginPath();
	                    if (style === 3 /* DOTTED */) {
	                        this.formatPath(strokePaths);
	                    }
	                    else {
	                        this.formatPath(boxPaths.slice(0, 2));
	                    }
	                    dashLength = width < 3 ? width * 3 : width * 2;
	                    spaceLength = width < 3 ? width * 2 : width;
	                    if (style === 3 /* DOTTED */) {
	                        dashLength = width;
	                        spaceLength = width;
	                    }
	                    useLineDash = true;
	                    if (length <= dashLength * 2) {
	                        useLineDash = false;
	                    }
	                    else if (length <= dashLength * 2 + spaceLength) {
	                        multiplier = length / (2 * dashLength + spaceLength);
	                        dashLength *= multiplier;
	                        spaceLength *= multiplier;
	                    }
	                    else {
	                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
	                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
	                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
	                        spaceLength =
	                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
	                                ? minSpace
	                                : maxSpace;
	                    }
	                    if (useLineDash) {
	                        if (style === 3 /* DOTTED */) {
	                            this.ctx.setLineDash([0, dashLength + spaceLength]);
	                        }
	                        else {
	                            this.ctx.setLineDash([dashLength, spaceLength]);
	                        }
	                    }
	                    if (style === 3 /* DOTTED */) {
	                        this.ctx.lineCap = 'round';
	                        this.ctx.lineWidth = width;
	                    }
	                    else {
	                        this.ctx.lineWidth = width * 2 + 1.1;
	                    }
	                    this.ctx.strokeStyle = asString(color);
	                    this.ctx.stroke();
	                    this.ctx.setLineDash([]);
	                    // dashed round edge gap
	                    if (style === 2 /* DASHED */) {
	                        if (isBezierCurve(boxPaths[0])) {
	                            path1 = boxPaths[3];
	                            path2 = boxPaths[0];
	                            this.ctx.beginPath();
	                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
	                            this.ctx.stroke();
	                        }
	                        if (isBezierCurve(boxPaths[1])) {
	                            path1 = boxPaths[1];
	                            path2 = boxPaths[2];
	                            this.ctx.beginPath();
	                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
	                            this.ctx.stroke();
	                        }
	                    }
	                    this.ctx.restore();
	                    return [2 /*return*/];
	                });
	            });
	        };
	        CanvasRenderer.prototype.render = function (element) {
	            return __awaiter(this, void 0, void 0, function () {
	                var stack;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (this.options.backgroundColor) {
	                                this.ctx.fillStyle = asString(this.options.backgroundColor);
	                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
	                            }
	                            stack = parseStackingContexts(element);
	                            return [4 /*yield*/, this.renderStack(stack)];
	                        case 1:
	                            _a.sent();
	                            this.applyEffects([]);
	                            return [2 /*return*/, this.canvas];
	                    }
	                });
	            });
	        };
	        return CanvasRenderer;
	    }(Renderer));
	    var isTextInputElement = function (container) {
	        if (container instanceof TextareaElementContainer) {
	            return true;
	        }
	        else if (container instanceof SelectElementContainer) {
	            return true;
	        }
	        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
	            return true;
	        }
	        return false;
	    };
	    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
	        switch (clip) {
	            case 0 /* BORDER_BOX */:
	                return calculateBorderBoxPath(curves);
	            case 2 /* CONTENT_BOX */:
	                return calculateContentBoxPath(curves);
	            case 1 /* PADDING_BOX */:
	            default:
	                return calculatePaddingBoxPath(curves);
	        }
	    };
	    var canvasTextAlign = function (textAlign) {
	        switch (textAlign) {
	            case 1 /* CENTER */:
	                return 'center';
	            case 2 /* RIGHT */:
	                return 'right';
	            case 0 /* LEFT */:
	            default:
	                return 'left';
	        }
	    };
	    // see https://github.com/niklasvh/html2canvas/pull/2645
	    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
	    var fixIOSSystemFonts = function (fontFamilies) {
	        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
	            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
	            : fontFamilies;
	    };
	
	    var ForeignObjectRenderer = /** @class */ (function (_super) {
	        __extends(ForeignObjectRenderer, _super);
	        function ForeignObjectRenderer(context, options) {
	            var _this = _super.call(this, context, options) || this;
	            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
	            _this.ctx = _this.canvas.getContext('2d');
	            _this.options = options;
	            _this.canvas.width = Math.floor(options.width * options.scale);
	            _this.canvas.height = Math.floor(options.height * options.scale);
	            _this.canvas.style.width = options.width + "px";
	            _this.canvas.style.height = options.height + "px";
	            _this.ctx.scale(_this.options.scale, _this.options.scale);
	            _this.ctx.translate(-options.x, -options.y);
	            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
	            return _this;
	        }
	        ForeignObjectRenderer.prototype.render = function (element) {
	            return __awaiter(this, void 0, void 0, function () {
	                var svg, img;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
	                            return [4 /*yield*/, loadSerializedSVG(svg)];
	                        case 1:
	                            img = _a.sent();
	                            if (this.options.backgroundColor) {
	                                this.ctx.fillStyle = asString(this.options.backgroundColor);
	                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
	                            }
	                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
	                            return [2 /*return*/, this.canvas];
	                    }
	                });
	            });
	        };
	        return ForeignObjectRenderer;
	    }(Renderer));
	    var loadSerializedSVG = function (svg) {
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            img.onload = function () {
	                resolve(img);
	            };
	            img.onerror = reject;
	            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
	        });
	    };
	
	    var Logger = /** @class */ (function () {
	        function Logger(_a) {
	            var id = _a.id, enabled = _a.enabled;
	            this.id = id;
	            this.enabled = enabled;
	            this.start = Date.now();
	        }
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.debug = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.enabled) {
	                // eslint-disable-next-line no-console
	                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
	                    // eslint-disable-next-line no-console
	                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
	                }
	                else {
	                    this.info.apply(this, args);
	                }
	            }
	        };
	        Logger.prototype.getTime = function () {
	            return Date.now() - this.start;
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.info = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.enabled) {
	                // eslint-disable-next-line no-console
	                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
	                    // eslint-disable-next-line no-console
	                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
	                }
	            }
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.warn = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.enabled) {
	                // eslint-disable-next-line no-console
	                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
	                    // eslint-disable-next-line no-console
	                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
	                }
	                else {
	                    this.info.apply(this, args);
	                }
	            }
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Logger.prototype.error = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.enabled) {
	                // eslint-disable-next-line no-console
	                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
	                    // eslint-disable-next-line no-console
	                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
	                }
	                else {
	                    this.info.apply(this, args);
	                }
	            }
	        };
	        Logger.instances = {};
	        return Logger;
	    }());
	
	    var Context = /** @class */ (function () {
	        function Context(options, windowBounds) {
	            var _a;
	            this.windowBounds = windowBounds;
	            this.instanceName = "#" + Context.instanceCount++;
	            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
	            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
	        }
	        Context.instanceCount = 1;
	        return Context;
	    }());
	
	    var html2canvas = function (element, options) {
	        if (options === void 0) { options = {}; }
	        return renderElement(element, options);
	    };
	    if (typeof window !== 'undefined') {
	        CacheStorage.setContext(window);
	    }
	    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
	        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
	        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
	        return __generator(this, function (_u) {
	            switch (_u.label) {
	                case 0:
	                    if (!element || typeof element !== 'object') {
	                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
	                    }
	                    ownerDocument = element.ownerDocument;
	                    if (!ownerDocument) {
	                        throw new Error("Element is not attached to a Document");
	                    }
	                    defaultView = ownerDocument.defaultView;
	                    if (!defaultView) {
	                        throw new Error("Document is not attached to a Window");
	                    }
	                    resourceOptions = {
	                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
	                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
	                        proxy: opts.proxy,
	                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
	                    };
	                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
	                    windowOptions = {
	                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
	                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
	                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
	                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
	                    };
	                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
	                    context = new Context(contextOptions, windowBounds);
	                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
	                    cloneOptions = {
	                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
	                        onclone: opts.onclone,
	                        ignoreElements: opts.ignoreElements,
	                        inlineImages: foreignObjectRendering,
	                        copyStyles: foreignObjectRendering
	                    };
	                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
	                    documentCloner = new DocumentCloner(context, element, cloneOptions);
	                    clonedElement = documentCloner.clonedReferenceElement;
	                    if (!clonedElement) {
	                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
	                    }
	                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
	                case 1:
	                    container = _u.sent();
	                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
	                        ? parseDocumentSize(clonedElement.ownerDocument)
	                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
	                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
	                    renderOptions = {
	                        canvas: opts.canvas,
	                        backgroundColor: backgroundColor,
	                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
	                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
	                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
	                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
	                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
	                    };
	                    if (!foreignObjectRendering) return [3 /*break*/, 3];
	                    context.logger.debug("Document cloned, using foreign object rendering");
	                    renderer = new ForeignObjectRenderer(context, renderOptions);
	                    return [4 /*yield*/, renderer.render(clonedElement)];
	                case 2:
	                    canvas = _u.sent();
	                    return [3 /*break*/, 5];
	                case 3:
	                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
	                    context.logger.debug("Starting DOM parsing");
	                    root = parseTree(context, clonedElement);
	                    if (backgroundColor === root.styles.backgroundColor) {
	                        root.styles.backgroundColor = COLORS.TRANSPARENT;
	                    }
	                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
	                    renderer = new CanvasRenderer(context, renderOptions);
	                    return [4 /*yield*/, renderer.render(root)];
	                case 4:
	                    canvas = _u.sent();
	                    _u.label = 5;
	                case 5:
	                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
	                        if (!DocumentCloner.destroy(container)) {
	                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
	                        }
	                    }
	                    context.logger.debug("Finished rendering");
	                    return [2 /*return*/, canvas];
	            }
	        });
	    }); };
	    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
	        var ownerDocument = element.ownerDocument;
	        // http://www.w3.org/TR/css3-background/#special-backgrounds
	        var documentBackgroundColor = ownerDocument.documentElement
	            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
	            : COLORS.TRANSPARENT;
	        var bodyBackgroundColor = ownerDocument.body
	            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
	            : COLORS.TRANSPARENT;
	        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
	            ? parseColor(context, backgroundColorOverride)
	            : backgroundColorOverride === null
	                ? COLORS.TRANSPARENT
	                : 0xffffffff;
	        return element === ownerDocument.documentElement
	            ? isTransparent(documentBackgroundColor)
	                ? isTransparent(bodyBackgroundColor)
	                    ? defaultBackgroundColor
	                    : bodyBackgroundColor
	                : documentBackgroundColor
	            : defaultBackgroundColor;
	    };
	
	    return html2canvas;
	
	})));
	//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(151).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(484);
	var DomUtils = __webpack_require__(486);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(221)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(151).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(609);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(221)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(151).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * imagesLoaded v4.1.4
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	( function( window, factory ) { 'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(289)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.imagesLoaded = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	})( typeof window !== 'undefined' ? window : this,
	
	// --------------------------  factory -------------------------- //
	
	function factory( window, EvEmitter ) {
	
	'use strict';
	
	var $ = window.jQuery;
	var console = window.console;
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	function makeArray( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	}
	
	// -------------------------- imagesLoaded -------------------------- //
	
	/**
	 * @param {Array, Element, NodeList, String} elem
	 * @param {Object or Function} options - if function, use as callback
	 * @param {Function} onAlways - callback function
	 */
	function ImagesLoaded( elem, options, onAlways ) {
	  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	  if ( !( this instanceof ImagesLoaded ) ) {
	    return new ImagesLoaded( elem, options, onAlways );
	  }
	  // use elem as selector string
	  var queryElem = elem;
	  if ( typeof elem == 'string' ) {
	    queryElem = document.querySelectorAll( elem );
	  }
	  // bail if bad element
	  if ( !queryElem ) {
	    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
	    return;
	  }
	
	  this.elements = makeArray( queryElem );
	  this.options = extend( {}, this.options );
	  // shift arguments if no options set
	  if ( typeof options == 'function' ) {
	    onAlways = options;
	  } else {
	    extend( this.options, options );
	  }
	
	  if ( onAlways ) {
	    this.on( 'always', onAlways );
	  }
	
	  this.getImages();
	
	  if ( $ ) {
	    // add jQuery Deferred object
	    this.jqDeferred = new $.Deferred();
	  }
	
	  // HACK check async to allow time to bind listeners
	  setTimeout( this.check.bind( this ) );
	}
	
	ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
	
	ImagesLoaded.prototype.options = {};
	
	ImagesLoaded.prototype.getImages = function() {
	  this.images = [];
	
	  // filter & find items if we have an item selector
	  this.elements.forEach( this.addElementImages, this );
	};
	
	/**
	 * @param {Node} element
	 */
	ImagesLoaded.prototype.addElementImages = function( elem ) {
	  // filter siblings
	  if ( elem.nodeName == 'IMG' ) {
	    this.addImage( elem );
	  }
	  // get background image on element
	  if ( this.options.background === true ) {
	    this.addElementBackgroundImages( elem );
	  }
	
	  // find children
	  // no non-element nodes, #143
	  var nodeType = elem.nodeType;
	  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
	    return;
	  }
	  var childImgs = elem.querySelectorAll('img');
	  // concat childElems to filterFound array
	  for ( var i=0; i < childImgs.length; i++ ) {
	    var img = childImgs[i];
	    this.addImage( img );
	  }
	
	  // get child background images
	  if ( typeof this.options.background == 'string' ) {
	    var children = elem.querySelectorAll( this.options.background );
	    for ( i=0; i < children.length; i++ ) {
	      var child = children[i];
	      this.addElementBackgroundImages( child );
	    }
	  }
	};
	
	var elementNodeTypes = {
	  1: true,
	  9: true,
	  11: true
	};
	
	ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	    return;
	  }
	  // get url inside url("...")
	  var reURL = /url\((['"])?(.*?)\1\)/gi;
	  var matches = reURL.exec( style.backgroundImage );
	  while ( matches !== null ) {
	    var url = matches && matches[2];
	    if ( url ) {
	      this.addBackground( url, elem );
	    }
	    matches = reURL.exec( style.backgroundImage );
	  }
	};
	
	/**
	 * @param {Image} img
	 */
	ImagesLoaded.prototype.addImage = function( img ) {
	  var loadingImage = new LoadingImage( img );
	  this.images.push( loadingImage );
	};
	
	ImagesLoaded.prototype.addBackground = function( url, elem ) {
	  var background = new Background( url, elem );
	  this.images.push( background );
	};
	
	ImagesLoaded.prototype.check = function() {
	  var _this = this;
	  this.progressedCount = 0;
	  this.hasAnyBroken = false;
	  // complete if no images
	  if ( !this.images.length ) {
	    this.complete();
	    return;
	  }
	
	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }
	
	  this.images.forEach( function( loadingImage ) {
	    loadingImage.once( 'progress', onProgress );
	    loadingImage.check();
	  });
	};
	
	ImagesLoaded.prototype.progress = function( image, elem, message ) {
	  this.progressedCount++;
	  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	  // progress event
	  this.emitEvent( 'progress', [ this, image, elem ] );
	  if ( this.jqDeferred && this.jqDeferred.notify ) {
	    this.jqDeferred.notify( this, image );
	  }
	  // check if completed
	  if ( this.progressedCount == this.images.length ) {
	    this.complete();
	  }
	
	  if ( this.options.debug && console ) {
	    console.log( 'progress: ' + message, image, elem );
	  }
	};
	
	ImagesLoaded.prototype.complete = function() {
	  var eventName = this.hasAnyBroken ? 'fail' : 'done';
	  this.isComplete = true;
	  this.emitEvent( eventName, [ this ] );
	  this.emitEvent( 'always', [ this ] );
	  if ( this.jqDeferred ) {
	    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	    this.jqDeferred[ jqMethod ]( this );
	  }
	};
	
	// --------------------------  -------------------------- //
	
	function LoadingImage( img ) {
	  this.img = img;
	}
	
	LoadingImage.prototype = Object.create( EvEmitter.prototype );
	
	LoadingImage.prototype.check = function() {
	  // If complete is true and browser supports natural sizes,
	  // try to check for image status manually.
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    // report based on naturalWidth
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    return;
	  }
	
	  // If none of the checks above matched, simulate loading on detached element.
	  this.proxyImage = new Image();
	  this.proxyImage.addEventListener( 'load', this );
	  this.proxyImage.addEventListener( 'error', this );
	  // bind to image as well for Firefox. #191
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.proxyImage.src = this.img.src;
	};
	
	LoadingImage.prototype.getIsImageComplete = function() {
	  // check for non-zero, non-undefined naturalWidth
	  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
	  return this.img.complete && this.img.naturalWidth;
	};
	
	LoadingImage.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.img, message ] );
	};
	
	// ----- events ----- //
	
	// trigger specified handler for event type
	LoadingImage.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	LoadingImage.prototype.onload = function() {
	  this.confirm( true, 'onload' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.onerror = function() {
	  this.confirm( false, 'onerror' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.unbindEvents = function() {
	  this.proxyImage.removeEventListener( 'load', this );
	  this.proxyImage.removeEventListener( 'error', this );
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	// -------------------------- Background -------------------------- //
	
	function Background( url, element ) {
	  this.url = url;
	  this.element = element;
	  this.img = new Image();
	}
	
	// inherit LoadingImage prototype
	Background.prototype = Object.create( LoadingImage.prototype );
	
	Background.prototype.check = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.img.src = this.url;
	  // check if image is already complete
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    this.unbindEvents();
	  }
	};
	
	Background.prototype.unbindEvents = function() {
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	Background.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.element, message ] );
	};
	
	// -------------------------- jQuery -------------------------- //
	
	ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	  jQuery = jQuery || window.jQuery;
	  if ( !jQuery ) {
	    return;
	  }
	  // set local variable
	  $ = jQuery;
	  // $().imagesLoaded()
	  $.fn.imagesLoaded = function( options, callback ) {
	    var instance = new ImagesLoaded( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoaded.makeJQueryPlugin();
	
	// --------------------------  -------------------------- //
	
	return ImagesLoaded;
	
	});


/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	


/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	


/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	


/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	


/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	


/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	


/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	


/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	


/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	


/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	


/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	


/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(7);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	


/***/ }),
/* 3523 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 3524 */
/***/ (function(module, exports) {

	module.exports = {"REQUIREMENT-ALPHA_RATIO":{"Title":"Too many non-letters"},"REQUIREMENT-KEY_MASHING":{"Title":"Key mashing"},"REQUIREMENT-LONG_WORDS":{"Title":"Too many very long words"},"REQUIREMENT-MINIMUM_LENGTH":{"NegativePostQuizFeedback":"You did not write enough to fully answer questions and explain your ideas. Practice writing more so your reader understands what you are thinking.","NegativeTeacherSummary":"$NAME did not write enough to fully answer questions and communicate ideas. Written responses that are too short lack the depth required to demonstrate understanding of both the text and the question.","PostQuizFeedbackTitle":"Answer Length","Title":"Not long enough to grade"},"REQUIREMENT-PARENTHESIS_ISSUE":{"Title":"Mismatched parentheses"},"REQUIREMENT-QUESTION_COPY":{"Title":"Copy-pasted question text"},"REQUIREMENT-QUOTE_ISSUE":{"Title":"Mismatched quotes"},"WARNING-PASTE_DETECTED":{"Title":"Some text was copy-pasted"},"WARNING-FIRST_CHAR_ISSUE":{"Title":"Response starts with non-letter character"}}

/***/ }),
/* 3525 */
/***/ (function(module, exports) {

	module.exports = {"aggregate-read-book":{"Description":"Whether the answer gives enough text evidence to prove that the student read the book","Display":"True","Rubric":"True","Title":"Read Book","Options":"Yes,No","RubricKey":"crit-evi-cote-bert-read-book-1","Order":1},"aggregate-fully-answered-question":{"Description":"Whether the student fully answered the question","Display":"True","Rubric":"True","Title":"Fully Addressed Question","Options":"Yes,No","RubricKey":"crit-rc-atq-coqa-fully-answered-2","Order":2},"aggregate-text-details-count":{"Description":"Whether the answer provides enough text details","Display":"True","Rubric":"True","Title":"Text Details Count","Options":"sufficient,insufficient","RubricKey":"crit-evi-cote-bert-quantity-14","Order":4},"aggregate-restated":{"Description":"Whether the answer restates the question","Display":"True","Rubric":"True","Title":"Restated Question","Options":"Yes,No","RubricKey":"crit-rc-atq-cors-bert-10","Order":5},"aggregate-sentence-structure":{"Description":"The extent to which the sentences in the answer use the correct number and kind of clauses in their syntactic structure","Display":"True","Rubric":"True","Title":"Sentence Structure","Options":"solid,partial,no structure","RubricKey":"comm-conv-org-sent-struct-coso-12","Order":6},"aggregate-capitalization":{"Description":"Whether the answer uses correct capitalization","Display":"True","Rubric":"True","Title":"Capitalization","Options":"correct,incorrect","RubricKey":"comm-conv-mech-caps-4","Order":7},"aggregate-punctuation":{"Description":"Whether the answer uses correct punctuation","Display":"True","Rubric":"True","Title":"Punctuation","Options":"yes,developing,no","RubricKey":"comm-conv-mech-punc-8","Order":8},"aggregate-spelling":{"Description":"Whether the answer uses correct spelling","Display":"True","Rubric":"True","Title":"Spelling","Options":"yes,developing,no","RubricKey":"comm-conv-mech-spell-13","Order":9},"aggregate-grammar":{"Description":"Whether the answer uses correct grammar","Display":"True","Rubric":"True","Title":"Grammar","Options":"yes,developing,no","RubricKey":"comm-conv-mech-gram-5","Order":10},"aggregate-sentence-count":{"Options":"sufficient,insufficient","RubricKey":"comm-conv-org-sent-count-11","Order":11,"Description":"Whether the answer sentence count is sufficient","Display":"True","Rubric":"True","Title":"Sentence Count"},"aggregate-word-count":{"Options":"sufficient,insufficient","RubricKey":"comm-conv-org-word-count-18","Order":12,"Description":"Whether the answer word count is sufficient","Display":"True","Rubric":"True","Title":"Word Count"},"comm-conv-mech-caps":{"Aggregate":"aggregate-well-written","Display":"True","NegativePostQuizFeedback":"You forgot to capitalize words that should start with a capital letter. Practice checking your writing for capital letters in front of proper nouns like names and the first words of sentences.","NegativeTeacherSummary":"$NAME did not capitalize words that should be capitalized, such as the first word of a sentence, proper nouns, or titles, or capitalized words that should not be capitalized.","PositivePostQuizFeedback":"Great job capitalizing words correctly in your writing! This helps show your reader which words are important.","PositiveTeacherSummary":"$NAME capitalized words correctly, including capitalizing words that should be capitalized, such as the first word of a sentence, proper nouns, or titles, and not capitalizing words that should not be capitalized.,","PostQuizFeedbackTitle":"Capitalization","Title":"Capitalization"},"comm-conv-mech-gram":{"Aggregate":"aggregate-well-written","Display":"True","NegativePostQuizFeedback":"You made some mistakes in your writing mechanics, which are rules we must remember when we write. Practice reading through your writing to check for small mistakes.","NegativeTeacherSummary":"$NAME made small mistakes in writing mechanics outside of spelling, capitalization, and organization.","PositivePostQuizFeedback":"Great job following the rules of writing! Good writing mechanics help you sound extra smart because there are so many rules to remember.","PositiveTeacherSummary":"$NAME properly used appropriate writing mechanics outside of spelling, capitalization, and organization.","PostQuizFeedbackTitle":"Writing Conventions","Title":"Grammar"},"comm-conv-mech-punc":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Punctuation"},"comm-conv-mech-spell":{"Aggregate":"aggregate-well-written","Display":"True","NegativePostQuizFeedback":"You had spelling mistakes in your writing. Practice checking that you spelled your words correctly.","NegativeTeacherSummary":"$NAME made frequent spelling mistakes. Try encouraging students to use voice controls when spelling is a hurdle.","PositivePostQuizFeedback":"Great job spelling your words correctly! This makes it much easier for your readers to understand you.","PositiveTeacherSummary":"$NAME spelled most words correctly.","PostQuizFeedbackTitle":"Spelling","Title":"Spelling"},"comm-conv-org-char-count":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Answer Length"},"comm-conv-org-intro":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Introductory Sentences"},"comm-conv-org-sent-count":{"Display":"False","Title":"Sentence Count"},"comm-conv-org-sent-len":{"Display":"False","Title":"Sentence Length Likelihood"},"comm-conv-org-sent-struct":{"Aggregate":"aggregate-well-written","Display":"True","NegativePostQuizFeedback":"You did not organize your thoughts to be easy to follow and understand. Practice restating the question, using concluding sentences, and avoiding run-on sentences.","NegativeTeacherSummary":"$NAME did not organize thoughts in a way that was easy to follow and understand, and needs to practice habits such as restating the question, using concluding sentences, and avoiding run-on sentences.","PositivePostQuizFeedback":"Great job organizing your thoughts with punctuation marks! This helps your readers read your thoughts easily.","PostQuizFeedbackTitle":"Organization","Title":"Sentence Structure"},"comm-conv-org-sent-types-div":{"Display":"False","Title":"Varying Types of Sentences"},"comm-conv-org-sent-var":{"Display":"False","Title":"Varying Length of Sentences"},"comm-conv-org-struct-first-var":{"Display":"False","Title":"Varying First Words of Sentence"},"comm-conv-org-trans":{"Display":"False","Title":"Use of Transition Words"},"comm-conv-voc-level-complex":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Word Complexity"},"comm-conv-voc-level-frq":{"Display":"False","NegativePostQuizFeedback":"You used simple vocabulary instead of meaningful, grade-level vocabulary. Practice choosing more challenging words.","NegativeTeacherSummary":"$NAME often used basic or low-level vocabulary instead of more descriptive or grade-appropriate vocabulary. This also includes using overused words rather than thoughtful word choice.","PositivePostQuizFeedback":"Great job using meaningful, grade-level vocabulary! That helps your readers understand your thoughts.","PositiveTeacherSummary":"$NAME used valuable and descriptive grade-appropriate vocabulary, including using thoughtful word choice and avoiding overused words.","PostQuizFeedbackTitle":"Vocabulary Usage","Title":"Word Rarity"},"comm-conv-voc-level-metrics":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Bucket of Metrics"},"comm-conv-voc-level-overused":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Repeated Overused Vocabulary"},"comm-conv-voc-vary":{"Aggregate":"aggregate-well-written","Display":"True","Title":"Varying Word Choice"},"crit-evi-cote-bert-quantity-14":{"Description":"Whether the answer provides enough text details","Aggregate":"aggregate-text-details-count","Display":"True","Rubric":"True","Title":"Text Details Count"},"crit-rc-atq-restated":{"Aggregate":"aggregate-comprehension","Display":"True","NegativePostQuizFeedback":"Try using part of the question in your answer to help your readers understand how your thoughts connect to the question.","PositivePostQuizFeedback":"Great job using part of the question in your answer. This helps your readers quickly find the answer and understand your thoughts.","PostQuizFeedbackTitle":"Restating the question","Title":"Restated The Question"},"crit-rc-atq-squad-bert":{"Aggregate":"aggregate-comprehension","Display":"True","NegativePostQuizFeedback":"You may not have answered each part of the question.","PositivePostQuizFeedback":"Great job answering each part of the question.","Title":"Answered The Question"},"crit-rc-atq-cors-bert":{"Display":"True","Rubric":"True","NegativePostQuizFeedback":"You may not have fully restated the question.","PositivePostQuizFeedback":"Great job restating the question.","PostQuizFeedbackTitle":"Restating the question","Title":"Restated The Question"},"crit-evi-cote-bert-read-book-1":{"Description":"Whether the answer gives enough text evidence to prove that the student read the book","Aggregate":"aggregate-read-book","Display":"True","Rubric":"True","Title":"Read Book"},"crit-rc-atq-coqa-fully-answered-2":{"Description":"Whether the student fully answered the question","Aggregate":"aggregate-fully-answered-question","Display":"True","Rubric":"True","Title":"Fully Answered Question"},"comm-conv-org-word-count-18":{"Description":"Whether the answer word count is sufficient","Aggregate":"aggregate-word-count","Display":"True","Rubric":"True","Title":"Word Count"},"comm-conv-org-sent-count-11":{"Description":"Whether the answer sentence count is sufficient","Aggregate":"aggregate-sentence-count","Display":"True","Rubric":"True","Title":"Sentence Count"},"crit-rc-atq-cors-bert-10":{"Description":"Whether the answer restates the question","Aggregate":"aggregate-restated","Display":"True","Rubric":"True","Title":"Restated Question"},"comm-conv-org-sent-struct-coso-12":{"Description":"The extent to which the sentences in the answer use the correct number and kind of clauses in their syntactic structure","Aggregate":"aggregate-sentence-structure","Display":"True","Rubric":"True","Title":"Sentence Structure"},"comm-conv-mech-caps-4":{"Description":"Whether the answer uses correct capitalization","Aggregate":"aggregate-capitalization","Display":"True","Rubric":"True","Title":"Capitalization"},"comm-conv-mech-punc-8":{"Description":"Whether the answer uses correct punctuation","Aggregate":"aggregate-punctuation","Display":"True","Rubric":"True","Title":"Punctuation"},"comm-conv-mech-spell-13":{"Description":"Whether the answer uses correct spelling","Aggregate":"aggregate-spelling","Display":"True","Rubric":"True","Title":"Spelling"},"comm-conv-mech-gram-5":{"Description":"Whether the answer uses correct grammar","Aggregate":"aggregate-grammar","Display":"True","Rubric":"True","Title":"Grammar"}}

/***/ }),
/* 3526 */
/***/ (function(module, exports) {

	module.exports = {"0":["BASEK9TjRu8FUCLWxT3PosEdWA","BASE6pO8fFEHm-ijLAuarkQWvw","BASELEx5Od0LgIhzAWx70Kh1fQ","BASEXdgem8gL7sNqmIZyqZNS8Q","BASEQSVecTv-j7JSgoqk9Ij0Sg","BASEw196pAJCBhjna461YQLYPw","BASE2AIF5AqkVvqYnlu6daDyRg","BASE6sWs59oS2lEU1Vorpx_l2A","BASEbkSWXQlp1VCYwTIZSQXnPg","BASEtoOEYdyIeyib6--neZW5tQ","BASEzNEkyKkeyjUhiJ4n8f4BXw","BASE586AnwWOOxS6daZL6OkX1A","BASEPrlf5LZGv67bFkW5jvxIig","BASE1-jmB02KRtUxLRi4YiJduQ","BASEwPHNeslXfLpcQQfHQqyZlw","BASEnR1lo_FMBtIbQxDOjVHMKA","BASEOdD9UkZwwAfGrQ9BKNMd1Q","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASEsLSPmsTmnoBNIXcsVHDVwA","BASET7X2fYnKh9JKU3m2auSayA","BASELl6CCKRg-N8kruyNqwSD7g","BASE08yTUEG3LFNaQ_q53aCo2g","BASELED7VD9SD1Fl8DqkaTaaJw","BASEQ3WXJ_ViuqJJLIUzlpb8qQ","BASEjJ-LDB3vglZ_ak7Q0Kgohg","BASEUm4wpGEtXTEvb5FYQMJDoQ","BASEaH75LMsJ8r5e82QZq3M8Qw","BASEI3_rXuORobKgPPMngCR8Rw","BASEzAfOZPXT2ynp8LNvcbl0yQ","BASE2mDdvo-qiwFGpUcLGxlqcg"],"1":["BASESQyY19tmvzjin_IMDLbvAw","BASE30uGjYQtGaK-jHoGi4iiHg","BASEhq0Ts5RuGcgW8i9cMJiUSQ","BASEVRC8J4bm-WChS_qczxKQMQ","BASE3bbxFihDZ6eRbxKLntzQNQ","BASEFBKy7tyZESXmtIM7kAgdAg","BASECUEjCNyVH14QbF43aanyOg","BASEIQZp8QACt88-NMqQHeYaTg","BASEiappClWiGrPl3PFdk9IB5A","BASEVM-fGsu_VXaP_kyIJlz-Cg","BASE2wGhrsiMZ3ILyACMRceUSg","BASEaH75LMsJ8r5e82QZq3M8Qw","BASEU2xKFP26V1q_vZJkMhxbjg","BASEQ3WXJ_ViuqJJLIUzlpb8qQ","BASEjiwqtr-WF3VH1LHdtbVEjg","BASEkY0nvV3-aTryJR3XuQ7mdQ","BASEXbga4q2DULX2bxaHqJLbpA","BASEPnypT3fWoZLyJOELwqTcug","BASEr8RsRcGJ6Cxp6TcDFqVd2w","BASE95hGrINQbUGm2NX4Y11vcQ","BASE1FPkemXdz9FQ1kC6lFf5ig","BASEkQUi6SFVczsbX_NRKzWsIw","BASEcsZSbOfvExzT-GhpEyq3Ww","BASExR09PYVoRy9M8Rar6Yc8GA","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASExnKwFHuYrW6dZoasy4KZPw","BASEzba_cCkPbMaicHlmjIS53A","BASEtyHXrD6KAjhR53FmNqF1KA","BASEzG9IlXOp8bxsE6jrPgDhkw","BASEX-Kq6-k7S5-7zumftO6cCA"],"2":["BASE95hGrINQbUGm2NX4Y11vcQ","BASE65NgL7NROi6cP2Iz4lgRdw","BASE4e9iOBbm8DAgjwExbrodiA","BASEMOtn4_Z6FOKRvzZJeMgq8A","BASEoylAgpOhdJmQtp6y0itv_A","BASEiWnWHImlcAj2iwOTFtmF4w","BASEG6VrmMVPWsnfxG_fw2_9jA","BASEATxcmqO38LQeT67zqmPAKA","BASEFjGyo6N1i3aLHbvo93VyOg","BASEXevE-JqclWxaS0oJ8G5OWQ","BASEnnyfs0M_zHAYP9K_3crZSw","BASEummwiYz1J_ssmUcGabba0Q","BASED3OhKlw09k6MoxPoSj2fsw","BASEF1pvKlorghEGrMuUoepAvg","BASERiB7g32-RoR0qDYHuFGKxg","BASEXpkYnE2-Un9oDw5xLlfOFA","BASEsLSPmsTmnoBNIXcsVHDVwA","BASEjD5jiGgXbiZCpJ4hZbpxYg","BASENKRKp19gO3UkpcDq-vCmuw","BASEc0DvOwnV1ABDXWxj1J0fyA","BASEGAeREJV6QWiPKsC1t09bLw","BASEVBprgou4VG4OVMHmfuKYyw","BASEVo7XM-DGlD13jlij41Cxdw","BASESWe1G7AVYb56tDwXXhmzUA","BASESk1gsU3z3YJ_wS862o3qKQ","BASEpdYbWY2xTejUlDVQEGkCCQ","BASEU56xWd9v79w0pA5DU85J5A","BASEA2XKv4HELqYVeI7jLidmzw","BASESuHZFUgwuaXImRhfHO-bjw","BASEU2xKFP26V1q_vZJkMhxbjg"],"4":["BASE-r0cHDE3m2dG3W6ZDBjgNg","BASEjD5jiGgXbiZCpJ4hZbpxYg","BASEaH75LMsJ8r5e82QZq3M8Qw","BASEhB7lkemuaIuve1NTlRU6Og","BASEGN5xN7GN-3aiNTCun8SKnQ","BASEU2xKFP26V1q_vZJkMhxbjg","BASEnpsoJTU4Pyc4pi3qJKrqvg","BASEROyHEuyeh6SVGXMa2UkYwQ","BASEFIXDubXAOVVYW6eyC5GUyw","BASEF92g47mdyViR6mNmBsEjqg","BASEf5kMizefnIZVZ5czbDmxZg","BASEiWnWHImlcAj2iwOTFtmF4w","BASE_6kazmLCIXka4Nn6I6zvLg","BASEWZYWSExrEQdBEUdWcsGASA","BASEtXQTnWYwIMM2bD_rvnJuTg","BASE4e9iOBbm8DAgjwExbrodiA","BASEd1w1bMRi7MgHN1J3LAwA9g","BASEVWMTPRBturw_joXekz_NcA","BASEVRC8J4bm-WChS_qczxKQMQ","BASEaapFA4Sqd5FuVfe4p_q9VA","BASEAOH8j3w9WsZOxNQ9dzAUFQ","BASE33MraPhGOMdiYHdocrfhYg","BASEwsZ2z9qD3tzpdZQoMuGCpA","BASEsYLVCw2Pq3PLCPZkmCGiRw","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASEzJ-I-EV8CCjOhhv0uTT2DA","BASEZ9zBNCCj1-2TAlu-LJp-qw","BASEeRRnrc7tIU-tSqWRMIA7uw","BASECwACP4zbgeX6G0a5ZLhI0Q","BASE9-ZoR1d4vSGNTk9W7tPfUw"],"5":["BASEx4xhViXfqATE84_Gsy0svw","BASEX349Czai5pU5EtgfWGmVAA","BASEJEz7dXu66nWBqIJIUy7kQw","BASEQSVecTv-j7JSgoqk9Ij0Sg","BASE4e9iOBbm8DAgjwExbrodiA","BASEzba_cCkPbMaicHlmjIS53A","BASEZicedwCLKFvYFSjL0b6eXQ","BASE8GSDJdpKHhBgBHtDHTtXsg","BASEZ6Y5vk5pe3ZaNk1Pw9r98w","BASEvo-Y6oP4mlZ-d6ID-xbecg","BASEfGGxry921H6EsDrER_rseA","BASEfirkOXXPZpumw3i9M_eAPA","BASEVRC8J4bm-WChS_qczxKQMQ","BASEEW8QdfAT5nMzUOw4HZL6QA","BASE9S4V0Kl0Hze8FzJi8b4ISA","BASE135aA3G-fLaTkOCGnxDZMg","BASElmyZPWvs_uNe5A3FZLf0_Q","BASEkKkZT3sW3ClzOGc3XGA52g","BASEQ6LQhPnAUJ9g91L4_8SG3Q","BASEgRdh0CC825RiF7qWawLR1A","BASES-u9137jUIz-TTXBWbnezw","BASEoeNTSdOdDTxhwWp9U9ft9Q","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASELED7VD9SD1Fl8DqkaTaaJw","BASEU2xKFP26V1q_vZJkMhxbjg","BASEkAITp4dIe3STuqsJ7CGKUw","BASEg1-DrRx66H6jQI4fI0xT2g","BASE1WOVmIAdm3ZaWFrbLcVBoA","BASET7X2fYnKh9JKU3m2auSayA","BASE80C7jwUqtrSrfPjaOwtrZQ"],"6":["BASEttma-oZe45ixFKMS_D99DQ","BASEydiowYMHAKnBkKickaGCmQ","BASEVpjB89eyokxJyr34f7ONUA","BASEi1Wj7q1wmNQPi0IbYlqtHA","BASEU7iU3UHjAMvrRRHCOJrBqw","BASEAOH8j3w9WsZOxNQ9dzAUFQ","BASETxZr1kSOCe7_j7sAz6I2iA","BASEI3h4-uaW3XvSlyvf9dICXg","BASEksMiPh3QCidNHobr7GJSEg","BASEQ3WXJ_ViuqJJLIUzlpb8qQ","BASEN6LfKMeEw5POBU6YqHZ_2Q","BASEiWnWHImlcAj2iwOTFtmF4w","BASEkfZt0b9DBxjzZ0n4HKN9EQ","BASEoQdA5VAfsb9XI5elKSYpUA","BASEe0kqM-XvkQlGkLqz7ghTYg","BASEQTeKRPQtEnGNGUpcEuvtxg","BASED3OhKlw09k6MoxPoSj2fsw","BASEIIzIa4hPxL0k4O1LryYhAA","BASEzAfOZPXT2ynp8LNvcbl0yQ","BASEcHUE1fPPGw8LwysULP3g6Q","BASEWtQLjuQVdt6dr0HXW6Bq7Q","BASEEW8QdfAT5nMzUOw4HZL6QA","BASEU2xKFP26V1q_vZJkMhxbjg","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASEshoJRmiwe2OdV8j3W1Mctw","BASEoeNTSdOdDTxhwWp9U9ft9Q","BASEUmuQK-3x82FMNcEFeoZIDw","BASEpWmZuaucZqGKnTV_Gl6RXQ","BASEpyJuNlLLqunMUAYIm2X9Mg","BASEtXQTnWYwIMM2bD_rvnJuTg"],"7":["BASExeV-Hl3gxiWZm0TjAEBtYQ","BASErpwpe-9BPLPJPWOHmXUG-g","BASE2_RFC1-Fhn_xwjzNIRdjtQ","BASEC6GD-YaMdwml6EXMuO96Sw","BASExcncZgJZUV2Dp_cuq6kVig","BASEikKVl_icgJxHMX15dlddyQ","BASELSQnDL4Sw6mpsDiUcewaGQ","BASEwmb3gW7MM22srmBpzwPioQ","BASE8hNw_4qLckRH0SEPRiSfyw","BASE4e9iOBbm8DAgjwExbrodiA","BASEip_fvCeNnfQuX2649mzNKQ","BASEgdOQA2Ubek2eEVqr3TlAJA","BASEU56xWd9v79w0pA5DU85J5A","BASE8h2rcIxa4unC0w0GbJvGuw","BASEkKkZT3sW3ClzOGc3XGA52g","BASExlvRb5yuJ-coaelA4GN2Uw","BASEZ6Y5vk5pe3ZaNk1Pw9r98w","BASEW9g-CqiGOieMlUgNhfLvsg","BASELmnUGW6bJcwsEQ-ul9qS-Q","BASECGaFwi8csmuhaIXG8CXHxA","BASEZeSaZTyRnWl2vUGf-CPbSA","BASEBdJL9sacf1fJtNlIoT6WYw","BASEYYMYSeMt41jZS1T71iG2Ig","BASEVgqQIlRJoaF7N3fTfUm-yw","BASEaH75LMsJ8r5e82QZq3M8Qw","BASEjwnVmpsCIxMsjSC10Ly1hg","BASEJU-G94C6sy-J3PxZMn_EJQ","BASEipPiQ0xKpgNKzHnqqbM3pg","BASE_3NCdwQJNSqs9qHO37FMXA","BASEjJ-LDB3vglZ_ak7Q0Kgohg"],"8":["BASELED7VD9SD1Fl8DqkaTaaJw","BASE3h9JioM1472TbxCAdsM0HQ","BASED2Hlp-S7KXTbChtYtVmHyg","BASENlBjzVST9wi1MZJYbimlKw","BASENz-gFa2smINoAGcV_EM7Hg","BASEJ6bPehWZXuOrMSCgPCGx6A","BASEKvgVU0vPAWg_gM33xdGxgw","BASEb8X1kASzdNjQC3nih287xw","BASE7nodGXrr36sp9bj5dLlqaw","BASELUz_FgnhDrLjZIAINRhDiw","BASEg9CcZbF6vZB66LWs7w5__w","BASEQSVecTv-j7JSgoqk9Ij0Sg","BASEP_waN6isG1Ub4DInpje8Mw","BASE_9FMCcs4x-K66NCMbuFp9A","BASEkuBnjXYUK0EZML41ZDJVqQ","BASEYvaLidgZQ-CH4XC13C_YXQ","BASEK9TjRu8FUCLWxT3PosEdWA","BASEo-KosfGSeaQgau3S4hWtJA","BASEORheCFOnV8ULCVl53hMD3g","BASEYJbGOO7zSxkPyozEuO-kFg","BASE7PgUM8BOCXTuseGheVY00Q","BASE6kSsc6upq3m3SXT726HJKA","BASEBdJL9sacf1fJtNlIoT6WYw","BASE1Dk6xZl1kNK7Qemf4UomrA","BASEmU104uSbQuRjOu8WNHyBKA","BASE4CjxzAaKXWD6mv2TpS7S2A","BASExNueSlvMdONBSCBQx9yGrg","BASEvqxn7ju8W6DeD_Tr_M1Eng","BASEzjTIfw_2ybqWubPuphP1Sg","BASEwHOSnNPwyIFP3IQXWFGsng"]}

/***/ }),
/* 3527 */
/***/ (function(module, exports) {

	module.exports = {"SKILLSET_ARGUMENTS":{"ExerciseParams":"}","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice staying on track with your arguments. When trying to make a point or explain your thoughts, make sure you support your ideas and stay focused on your point.","NegativeTeacherSummary":"$NAME needs practice evaluating and making arguments, including being able to identify an author's argument or specific claims, as well as assess the reasoning and evidence. This often requires the ability to make arguments for or against the author's points.","PositiveFeedback":"Nice work making good arguments! Being able to support your ideas and stay focused on your point is important when trying to explain your own thoughts to others.","PositiveTeacherSummary":"$NAME effectively evaluated arguments or claims, including the supporting evidence and reasoning. This often requires the ability to make arguments for or against the author's points or analyze the author's writing and sources.","Scope":"Presence","Title":"Arguments & Evidence"},"SKILLSET_COMPARISOMN":{"ExerciseParams":"    skillsets: comparison-and-contrast","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice making connections between the text and other texts. Try thinking about the similarities and differences between the text you are reading and other texts you have read.","NegativeTeacherSummary":"$NAME struggled comparing and contrasting elements of different texts. Making text-to-text connections requires students to find similarities between texts of comparable themes or topics and show an understanding of authors' varying approaches.","PositiveFeedback":"Great job making connections between the text you are reading and other texts you have read. Comparing and contrasting texts helps you understand and learn even more from those texts.","PositiveTeacherSummary":"$NAME successfully compared and contrasted elements of different texts. Making text-to-text connections requires students to find similarities between texts of comparable themes or topics and show an understanding of authors' varying approaches.","Scope":"Presence","Title":"Text-to-Text Connections"},"SKILLSET_CURIOSITY":{"ExerciseParams":"    skillsets: curiosity","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice thinking deeply and asking questions about the text. Try asking yourself questions about the text and seeing if you can find the answers.","NegativeTeacherSummary":"$NAME struggled with reaching a level of inquisitive interest when asked to think deeply and ask questions about a text. Curiosity requires an open mind and a willingness to experiment or think outside the box.","PositiveFeedback":"Great job thinking deeply and asking yourself questions about the text. Wanting to learn more about something is the best way to develop your brain!","PositiveTeacherSummary":"$NAME was able to reach a level of inquisitive interest when asked to think deeply and ask questions about a text. Curiosity requires an open mind and a willingness to experiment or think outside the box.","Scope":"Presence","Title":"Curiosity"},"SKILLSET_EVENTS":{"ExerciseParams":"    skillsets: events-and-ideas","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice ordering and thinking about events and ideas in the text. As you read, try thinking about the order events happened or the ideas the author is teaching you about.","NegativeTeacherSummary":"$NAME struggled with analyzing how and why events or ideas develop and interact over the course of a text. This requires an understanding of how events can shape ideas, how ideas can cause events, and how events and ideas relate to individuals in the text and the reader.","PositiveFeedback":"Great job explaining the events and ideas from texts. Knowing how the events and details in a text relate to each other helps you learn more from the text.","PositiveTeacherSummary":"$NAME could analyze how and why events or ideas develop and interact over the course of a text. This requires an understanding of how events can shape ideas, how ideas can cause events, and how events and ideas relate to individuals in the text and the reader.","Scope":"Presence","Title":"Events"},"SKILLSET_GRAPHS":{"ExerciseParams":"    skillsets: graphs-tables-and-pictures ","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice understanding information from different formats, such as written words, pictures, and movies. Try thinking about what words and pictures in a text tell you.","NegativeTeacherSummary":"$NAME needs practice recognizing and understanding content presented in diverse media and formats. This often requires making connections between the visual components of a text and its written words, or relating a written text to information presented in another format about a similar or identical topic.","PositiveFeedback":"Great job understanding information from different formats, such as written words, pictures, and movies. This helps you understand topics better.","PositiveTeacherSummary":"$NAME showed an understanding of content presented in diverse media and formats. This often requires making connections between the visual components of a text and its written words, or relating a written text to information presented in another format about a similar or identical topic.","Scope":"Presence","Title":"Medias & Formats"},"SKILLSET_INFERENCES":{"ExerciseParams":"    skillsets: inferences","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice making inferences. These are smart guesses about the events or meaning in a text that the author might not tell you. Try using hints from the text to think deeper.","NegativeTeacherSummary":"$NAME needs practice making logical inferences and predictions based on what a text says explicitly. Inferences and conclusions drawn from the text should be supported with specific textual evidence or sound reasoning.","PositiveFeedback":"You have great inferencing skills! Inferences are smart guesses about the events or meaning in a text. This helps you understand the deeper meaning of a text.","PositiveTeacherSummary":"$NAME made logical inferences and predictions based on what texts state explicitly. Inferences and conclusions drawn from the text were supported with specific textual evidence or sound reasoning.","Scope":"Presence","Title":"Inferences"},"SKILLSET_INTROSPECTION":{"ExerciseParams":"    skillsets: introspection-and-application","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice making connections between the text and yourself and the world around you. Try thinking about the similarities and differences between the text and your life.","NegativeTeacherSummary":"$NAME struggled making self and world connections to the text. Text-to-self connections are personal connections to the student's own experiences or life. Text-to-world connections are larger connections to how the world works, often tying into media, news, other school subjects, or culture.","PositiveFeedback":"Great job making connections between the text and your life and the world around you. This helps you understand and learn from the text, and can even make you a better person!,","PositiveTeacherSummary":"$NAME made solid self and world connections to the text. Text-to-self connections are personal connections to the student's own experiences or life. Text-to-world connections are larger connections to how the world works, often tying into media, news, other school subjects, or culture.","Scope":"Presence","Title":"Self & World Connections"},"SKILLSET_MAIN":{"ExerciseParams":"    skillsets: main-ideas","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice finding the main idea. The main idea is the most important topic of a text. Try thinking about what the text is trying to teach you about overall.","NegativeTeacherSummary":"$NAME needs practice determining and describing the main idea of texts, including recognizing central ideas or themes, analyzing their development, and summarizing the key supporting details and ideas.","PositiveFeedback":"Great job understanding the main idea! The main idea is the most important topic the text is teaching. Knowing the main idea is the first step in understanding the text.","PositiveTeacherSummary":"$NAME successfully determined and described the main idea of texts, including recognizing central ideas or themes, analyzing their development, and summarizing the key supporting details and ideas.","Scope":"Presence","Title":"Main Ideas"},"SKILLSET_PEOPLE":{"ExerciseParams":"    skillsets: people-and-characters","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice describing the people or characters in the text. Try paying close attention when the text gives you details about someone, and remember those details.","NegativeTeacherSummary":"$NAME struggled with analyzing how and why individuals develop and interact over the course of a text. This requires an understanding of how events and ideas can shape individuals, the effects of individuals' actions, and the relationship between individuals in the text and the reader.","PositiveFeedback":"You did a great job describing people and characters! Understanding the details about a person or character in a text is an important part of understanding the text as a whole.","PositiveTeacherSummary":"$NAME effectively analyzed how and why individuals develop and interact over the course of a text. This requires an understanding of how events and ideas can shape individuals, the effects of individuals' actions, and the relationship between individuals in the text and the reader.","Scope":"Presence","Title":"People & Characters"},"SKILLSET_PLOT":{"ExerciseParams":"    skillsets: plot-and-setting","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice writing about the plot and setting. Try thinking about where the story takes place and the order of events that happen there.","NegativeTeacherSummary":"$NAME needs practice analyzing how and why the plot and the setting develop and interact over the course of a text. This requires a grasp of the order of events, how the setting influences events, and how the relationship between plot and setting shapes individuals in the text and the text as a whole.","PositiveFeedback":"Great job explaining the plot and setting! Knowing where a story takes place and what happens there is an important part of understanding the story.","PositiveTeacherSummary":"$NAME was able to analyze how and why the plot and the setting develop and interact over the course of a text. This requires a grasp of the order of events, how the setting influences events, and how the relationship between plot and setting shapes individuals in the text and the text as a whole.","Scope":"Presence","Title":"Plot & Setting"},"SKILLSET_POV":{"ExerciseParams":"    skillsets: pov-and-purpose","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice understanding each author's point of view and purpose. Try thinking about the author's background and why they wrote the text for you to read.","NegativeTeacherSummary":"$NAME struggled with identifying and understanding the author's background, point of view, and purpose, including assessing how point of view and purpose each shape the content and style of a text.","PositiveFeedback":"You did a great job understanding each author's point of view and purpose in writing each text! This helps you fully understand the text and why it was written.","PositiveTeacherSummary":"$NAME effectively identified and understood the author's background, point of view, and purpose, including how point of view and purpose each shape the content and style of a text.","Scope":"Presence","Title":"Purpose & Point of View"},"SKILLSET_TEXT,":{"ExerciseParams":"    skillsets: text-structure","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice using how texts are organized to help you learn details about the text. Try looking for signal words to help you find text structures.","NegativeTeacherSummary":"$NAME needs practice analyzing the structure of texts, including how specific sentences, paragraphs, and larger portions of the text relate to each other and to the text as a whole. This also includes using text features to find and understand details.","PositiveFeedback":"You did really well using text structure and organization to find and learn details about the text. This helps you learn faster and more easily!","PositiveTeacherSummary":"$NAME was able to analyze the structure of texts, including how specific sentences, paragraphs, and larger portions of the text relate to each other and to the text as a whole. This also includes using text features to find and understand details.","Scope":"Presence","Title":"Text Structure"},"SKILLSET_THEMES":{"ExerciseParams":"    skillsets: themes","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice finding the theme. The theme is the most important topic or lesson of a text. Try thinking about the big idea that a text is trying to teach you.","NegativeTeacherSummary":"$NAME needs practice determining and describing the themes of texts, including recognizing central lessons or concepts, analyzing their development and meaning, and summarizing the key supporting details and ideas of a text.","PositiveFeedback":"Great job understanding the theme in texts! The theme is the most important topic or lesson. Knowing the theme means you understand the text as a whole.","PositiveTeacherSummary":"$NAME effectively determined and described the themes of texts, including recognizing central lessons or concepts, analyzing their development and meaning, and summarizing the key supporting details and ideas of a text.","Scope":"Presence","Title":"Themes"},"SKILLSET_VOCABULARY":{"ExerciseParams":"    skillsets: vocabulary-in-context","Link":"crit-rc-atq-restated","NegativeFeedback":"You need practice with vocabulary from the text. Try thinking about what words in the text mean or learning their meaning when they are new to you.","NegativeTeacherSummary":"$NAME needs practice interpreting words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, as well as analyzing how word choice shapes meaning and tone.","PositiveFeedback":"You did really well with questions about vocabulary from the text! This means you understand words you read even when they are new to you.","PositiveTeacherSummary":"$NAME successfully interpreted words and phrases as they are used in a text, including determining technical, connotative, and figurative meanings, as well as analyzing how word choice shapes meaning and tone.","Scope":"Presence","Title":"Vocabulary"}}

/***/ }),
/* 3528 */
/***/ (function(module, exports) {

	module.exports = {"CAPITALIZATION_START":{"Title":"Correct sentence capitalization"},"INTRO_ISSUE_ALPHA":{"Title":"Abrupt introduction","GroupSpans":true},"INTRO_ISSUE_BURST_ANSWER":{"Title":"Abrupt introduction","GroupSpans":true},"INTRO_ISSUE_BURST_OPINION":{"Title":"Abrupt introduction","GroupSpans":true},"INTRO_ISSUE_PRONOUN":{"Title":"Abrupt introduction"},"KNOWN_TEXT_GROUP":{"Title":"Text-specific event or concept","GroupSpans":true},"KNOWN_TEXT_VOCAB":{"Title":"Text-specific vocab"},"LOWER_I":{"Title":"Did not capitalize 'I'"},"MISSING_CAPITALIZATION_START":{"Title":"Sentence capitalization issue"},"MISSING_PUNCTUATION_END":{"Title":"End-of-sentence punctuation issue"},"MORFOLOGIK_RULE_EN_US":{"Title":"Spelling error"},"ORG-TRANSITION_WORDS":{"Title":"Transition words"},"OVERUSED_VOCAB":{"Title":"Potentially overused word"},"PROPER_PUNCTUATION_END":{"Title":"Correct end of sentence punctuation"},"QUESTION_RELEVANT_CLAUSE":{"Title":"Restated the question"},"SEMKEY_BOOK_PART.Y.01":{"Title":"Likely text-specific vocab"},"SEMKEY_CAUSAL_AGENT.N.01":{"Title":"Likely text-specific vocab"},"SEMKEY_MAKE.V.01":{"Title":"Likely text-specific vocab"},"SEMKEY_OBJECT.N.01":{"Title":"Likely text-specific vocab"},"SEMKEY_PROPN.Z.01":{"Title":"Likely text-specific vocab"},"UPPER_I":{"Title":"Correctly capitalized 'I'"},"WHITESPACE_RULE":{"Title":"Spacing error"},"ANSWER_SPAN_SQUAD_BERT_0":{"Title":"Answered the first part of the question","GroupSpans":true},"ANSWER_SPAN_SQUAD_BERT_1":{"Title":"Answered the second part of the question","GroupSpans":true},"ANSWER_SPAN_SQUAD_BERT_2":{"Title":"Answered the third part of the question","GroupSpans":true},"CORS_BERT_SCORE":{"Title":"Restated part of the question","GroupSpans":true},"DISABLED_TAGS":{"INTRO_VALID_NGRAM":{"Title":"Good introduction"}}}

/***/ }),
/* 3529 */
/***/ (function(module, exports) {

	module.exports = {"0":"K","50":"K","100":"1","150":"1","200":"1","250":"1","300":"2","350":"2","400":"2","450":"2","500":"3","550":"3","600":"3","650":"3","700":"4","750":"4","800":"5","850":"5","900":"6","950":"6","1000":"7","1050":"8","1100":"9","1150":"10","1200":"11","1220":"12"}

/***/ }),
/* 3530 */
/***/ (function(module, exports) {

	module.exports = {"patches":{"base":{"name":"base","source":"default","patch_type":"base","origin_patch_type":"base","patch_directory":"base","z_index":1000,"price":0,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"stomach":{"name":"stomach","source":"default","patch_type":"stomach","origin_patch_type":"stomach","patch_directory":"stomach","z_index":1004,"price":0,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"eyes":{"name":"large","source":"default","patch_type":"eyes","origin_patch_type":"eyes","patch_directory":"eyes","z_index":1006,"price":0,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"beak":{"name":"talking","source":"default","patch_type":"beak","origin_patch_type":"beak","patch_directory":"beak","z_index":3000,"price":0,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"face":"no_patch","head":{"name":"hat-graduation","source":"store","patch_type":"head","origin_patch_type":"head","patch_directory":"head","z_index":2200,"price":240,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"wings":{"name":"down","source":"default","patch_type":"wings","origin_patch_type":"wings","patch_directory":"wings","z_index":2300,"price":0,"tier":0,"offsets":{"left_x":0,"left_y":0,"right_x":0,"right_y":0},"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"body":"no_patch","hand":"no_patch","feet":{"name":"long","source":"default","patch_type":"feet","origin_patch_type":"feet","patch_directory":"feet","z_index":800,"price":0,"tier":0,"offsets":null,"animation":null,"extra_right":0,"extra_left":0,"extra_top":0,"extra_bottom":0},"left_hand":"no_patch","body2":"no_patch"},"colors":{"base":13,"stomach":13,"eyes":13,"wings":13}}

/***/ }),
/* 3531 */
/***/ (function(module, exports) {

	module.exports = {"elementNames":{"altglyph":"altGlyph","altglyphdef":"altGlyphDef","altglyphitem":"altGlyphItem","animatecolor":"animateColor","animatemotion":"animateMotion","animatetransform":"animateTransform","clippath":"clipPath","feblend":"feBlend","fecolormatrix":"feColorMatrix","fecomponenttransfer":"feComponentTransfer","fecomposite":"feComposite","feconvolvematrix":"feConvolveMatrix","fediffuselighting":"feDiffuseLighting","fedisplacementmap":"feDisplacementMap","fedistantlight":"feDistantLight","fedropshadow":"feDropShadow","feflood":"feFlood","fefunca":"feFuncA","fefuncb":"feFuncB","fefuncg":"feFuncG","fefuncr":"feFuncR","fegaussianblur":"feGaussianBlur","feimage":"feImage","femerge":"feMerge","femergenode":"feMergeNode","femorphology":"feMorphology","feoffset":"feOffset","fepointlight":"fePointLight","fespecularlighting":"feSpecularLighting","fespotlight":"feSpotLight","fetile":"feTile","feturbulence":"feTurbulence","foreignobject":"foreignObject","glyphref":"glyphRef","lineargradient":"linearGradient","radialgradient":"radialGradient","textpath":"textPath"},"attributeNames":{"definitionurl":"definitionURL","attributename":"attributeName","attributetype":"attributeType","basefrequency":"baseFrequency","baseprofile":"baseProfile","calcmode":"calcMode","clippathunits":"clipPathUnits","diffuseconstant":"diffuseConstant","edgemode":"edgeMode","filterunits":"filterUnits","glyphref":"glyphRef","gradienttransform":"gradientTransform","gradientunits":"gradientUnits","kernelmatrix":"kernelMatrix","kernelunitlength":"kernelUnitLength","keypoints":"keyPoints","keysplines":"keySplines","keytimes":"keyTimes","lengthadjust":"lengthAdjust","limitingconeangle":"limitingConeAngle","markerheight":"markerHeight","markerunits":"markerUnits","markerwidth":"markerWidth","maskcontentunits":"maskContentUnits","maskunits":"maskUnits","numoctaves":"numOctaves","pathlength":"pathLength","patterncontentunits":"patternContentUnits","patterntransform":"patternTransform","patternunits":"patternUnits","pointsatx":"pointsAtX","pointsaty":"pointsAtY","pointsatz":"pointsAtZ","preservealpha":"preserveAlpha","preserveaspectratio":"preserveAspectRatio","primitiveunits":"primitiveUnits","refx":"refX","refy":"refY","repeatcount":"repeatCount","repeatdur":"repeatDur","requiredextensions":"requiredExtensions","requiredfeatures":"requiredFeatures","specularconstant":"specularConstant","specularexponent":"specularExponent","spreadmethod":"spreadMethod","startoffset":"startOffset","stddeviation":"stdDeviation","stitchtiles":"stitchTiles","surfacescale":"surfaceScale","systemlanguage":"systemLanguage","tablevalues":"tableValues","targetx":"targetX","targety":"targetY","textlength":"textLength","viewbox":"viewBox","viewtarget":"viewTarget","xchannelselector":"xChannelSelector","ychannelselector":"yChannelSelector","zoomandpan":"zoomAndPan"}}

/***/ }),
/* 3532 */
/***/ (function(module, exports) {

	module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 3533 */
/***/ (function(module, exports) {

	module.exports = {"version":"2023c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Antarctica/Vostok","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {/*global exports, Intl*/
	/**
	 * This script gives you the zone info key representing your device's time zone setting.
	 *
	 * @name jsTimezoneDetect
	 * @version 1.0.6
	 * @author Jon Nylander
	 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
	 *
	 * For usage and examples, visit:
	 * http://pellepim.bitbucket.org/jstz/
	 *
	 * Copyright (c) Jon Nylander
	 */
	
	
	/**
	 * Namespace to hold all the code for timezone detection.
	 */
	var jstz = (function () {
	    'use strict';
	    var HEMISPHERE_SOUTH = 's',
	
	        consts = {
	            DAY: 86400000,
	            HOUR: 3600000,
	            MINUTE: 60000,
	            SECOND: 1000,
	            BASELINE_YEAR: 2014,
	            MAX_SCORE: 864000000, // 10 days
	            AMBIGUITIES: {
	                'America/Denver':       ['America/Mazatlan'],
	                'Europe/London':        ['Africa/Casablanca'],
	                'America/Chicago':      ['America/Mexico_City'],
	                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
	                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
	                // Europe/Minsk should not be in this list... but Windows.
	                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
	                'Pacific/Auckland':     ['Pacific/Fiji'],
	                'America/Los_Angeles':  ['America/Santa_Isabel'],
	                'America/New_York':     ['America/Havana'],
	                'America/Halifax':      ['America/Goose_Bay'],
	                'America/Godthab':      ['America/Miquelon'],
	                'Asia/Dubai':           ['Asia/Yerevan'],
	                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
	                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
	                'Australia/Sydney':     ['Australia/Lord_Howe'],
	                'Asia/Tokyo':           ['Asia/Yakutsk'],
	                'Asia/Dhaka':           ['Asia/Omsk'],
	                // In the real world Yerevan is not ambigous for Baku... but Windows.
	                'Asia/Baku':            ['Asia/Yerevan'],
	                'Australia/Brisbane':   ['Asia/Vladivostok'],
	                'Pacific/Noumea':       ['Asia/Vladivostok'],
	                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
	                'Pacific/Tongatapu':    ['Pacific/Apia'],
	                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
	                'Asia/Karachi':         ['Asia/Yekaterinburg'],
	                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
	            }
	        },
	
	        /**
	         * Gets the offset in minutes from UTC for a certain date.
	         * @param {Date} date
	         * @returns {Number}
	         */
	        get_date_offset = function get_date_offset(date) {
	            var offset = -date.getTimezoneOffset();
	            return (offset !== null ? offset : 0);
	        },
	
	        /**
	         * This function does some basic calculations to create information about
	         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
	         * the script has been tested rather than depend on the year set by the
	         * client device.
	         *
	         * Returns a key that can be used to do lookups in jstz.olson.timezones.
	         * eg: "720,1,2".
	         *
	         * @returns {String}
	         */
	        lookup_key = function lookup_key() {
	            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
	                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
	                diff = january_offset - june_offset;
	
	            if (diff < 0) {
	                return january_offset + ",1";
	            } else if (diff > 0) {
	                return june_offset + ",1," + HEMISPHERE_SOUTH;
	            }
	
	            return january_offset + ",0";
	        },
	
	
	        /**
	         * Tries to get the time zone key directly from the operating system for those
	         * environments that support the ECMAScript Internationalization API.
	         */
	        get_from_internationalization_api = function get_from_internationalization_api() {
	            var format, timezone;
	            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
	                return;
	            }
	            format = Intl.DateTimeFormat();
	            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
	                return;
	            }
	            timezone = format.resolvedOptions().timeZone;
	            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC') && timezone.indexOf("Etc") != 0) {
	                return timezone;
	            }
	        },
	
	        /**
	         * Starting point for getting all the DST rules for a specific year
	         * for the current timezone (as described by the client system).
	         *
	         * Returns an object with start and end attributes, or false if no
	         * DST rules were found for the year.
	         *
	         * @param year
	         * @returns {Object} || {Boolean}
	         */
	        dst_dates = function dst_dates(year) {
	            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
	            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
	            var current = yearstart;
	            var offset = (new Date(current)).getTimezoneOffset();
	            var dst_start = null;
	            var dst_end = null;
	
	            while (current < yearend - 86400000) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    if (dateToCheckOffset < offset) {
	                        dst_start = dateToCheck;
	                    }
	                    if (dateToCheckOffset > offset) {
	                        dst_end = dateToCheck;
	                    }
	                    offset = dateToCheckOffset;
	                }
	
	                current += 86400000;
	            }
	
	            if (dst_start && dst_end) {
	                return {
	                    s: find_dst_fold(dst_start).getTime(),
	                    e: find_dst_fold(dst_end).getTime()
	                };
	            }
	
	            return false;
	        },
	
	        /**
	         * Probably completely unnecessary function that recursively finds the
	         * exact (to the second) time when a DST rule was changed.
	         *
	         * @param a_date - The candidate Date.
	         * @param padding - integer specifying the padding to allow around the candidate
	         *                  date for finding the fold.
	         * @param iterator - integer specifying how many milliseconds to iterate while
	         *                   searching for the fold.
	         *
	         * @returns {Date}
	         */
	        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
	            if (typeof padding === 'undefined') {
	                padding = consts.DAY;
	                iterator = consts.HOUR;
	            }
	
	            var date_start = new Date(a_date.getTime() - padding).getTime();
	            var date_end = a_date.getTime() + padding;
	            var offset = new Date(date_start).getTimezoneOffset();
	
	            var current = date_start;
	
	            var dst_change = null;
	            while (current < date_end - iterator) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    dst_change = dateToCheck;
	                    break;
	                }
	                current += iterator;
	            }
	
	            if (padding === consts.DAY) {
	                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
	            }
	
	            if (padding === consts.HOUR) {
	                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
	            }
	
	            return dst_change;
	        },
	
	        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
	            if (score !== 'N/A') {
	                return score;
	            }
	            if (preliminary_timezone === 'Asia/Beirut') {
	                if (sample.name === 'Africa/Cairo') {
	                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'Asia/Jerusalem') {
	                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
	                        return 0;
	                }
	            }
	            } else if (preliminary_timezone === 'America/Santiago') {
	                if (sample.name === 'America/Asuncion') {
	                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'America/Campo_Grande') {
	                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'America/Montevideo') {
	                if (sample.name === 'America/Sao_Paulo') {
	                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'Pacific/Auckland') {
	                if (sample.name === 'Pacific/Fiji') {
	                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
	                        return 0;
	                    }
	                }
	            }
	
	            return score;
	        },
	
	        /**
	         * Takes the DST rules for the current timezone, and proceeds to find matches
	         * in the jstz.olson.dst_rules.zones array.
	         *
	         * Compares samples to the current timezone on a scoring basis.
	         *
	         * Candidates are ruled immediately if either the candidate or the current zone
	         * has a DST rule where the other does not.
	         *
	         * Candidates are ruled out immediately if the current zone has a rule that is
	         * outside the DST scope of the candidate.
	         *
	         * Candidates are included for scoring if the current zones rules fall within the
	         * span of the samples rules.
	         *
	         * Low score is best, the score is calculated by summing up the differences in DST
	         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
	         *
	         * Yah follow? :)
	         *
	         * @param rule_list
	         * @param preliminary_timezone
	         * @returns {*}
	         */
	        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
	            var score_sample = function score_sample(sample) {
	                var score = 0;
	
	                for (var j = 0; j < rule_list.length; j++) {
	
	                    // Both sample and current time zone report DST during the year.
	                    if (!!sample.rules[j] && !!rule_list[j]) {
	
	                        // The current time zone's DST rules are inside the sample's. Include.
	                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
	                            score = 0;
	                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
	                            score += Math.abs(sample.rules[j].e - rule_list[j].e);
	
	                        // The current time zone's DST rules are outside the sample's. Discard.
	                        } else {
	                            score = 'N/A';
	                            break;
	                        }
	
	                        // The max score has been reached. Discard.
	                        if (score > consts.MAX_SCORE) {
	                            score = 'N/A';
	                            break;
	                        }
	                    }
	                }
	
	                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);
	
	                return score;
	            };
	            var scoreboard = {};
	            var dst_zones = jstz.olson.dst_rules.zones;
	            var dst_zones_length = dst_zones.length;
	            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];
	
	            for (var i = 0; i < dst_zones_length; i++) {
	                var sample = dst_zones[i];
	                var score = score_sample(dst_zones[i]);
	
	                if (score !== 'N/A') {
	                    scoreboard[sample.name] = score;
	                }
	            }
	
	            for (var tz in scoreboard) {
	                if (scoreboard.hasOwnProperty(tz)) {
	                    for (var j = 0; j < ambiguities.length; j++) {
	                        if (ambiguities[j] === tz) {
	                        return tz;
	                        }
	                    }
	                }
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Takes the preliminary_timezone as detected by lookup_key().
	         *
	         * Builds up the current timezones DST rules for the years defined
	         * in the jstz.olson.dst_rules.years array.
	         *
	         * If there are no DST occurences for those years, immediately returns
	         * the preliminary timezone. Otherwise proceeds and tries to solve
	         * ambiguities.
	         *
	         * @param preliminary_timezone
	         * @returns {String} timezone_name
	         */
	        get_by_dst = function get_by_dst(preliminary_timezone) {
	            var get_rules = function get_rules() {
	                var rule_list = [];
	                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
	                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
	                    rule_list.push(year_rules);
	                }
	                return rule_list;
	            };
	            var check_has_dst = function check_has_dst(rules) {
	                for (var i = 0; i < rules.length; i++) {
	                    if (rules[i] !== false) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	            var rules = get_rules();
	            var has_dst = check_has_dst(rules);
	
	            if (has_dst) {
	                return best_dst_match(rules, preliminary_timezone);
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
	         *
	         * Returns an object with one function ".name()"
	         *
	         * @returns Object
	         */
	        determine = function determine() {
	            var preliminary_tz = get_from_internationalization_api();
	
	            if (!preliminary_tz) {
	                preliminary_tz = jstz.olson.timezones[lookup_key()];
	
	                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
	                    preliminary_tz = get_by_dst(preliminary_tz);
	                }
	            }
	
	            return {
	                name: function () {
	                    return preliminary_tz;
	                },
	                stdTimezoneOffset : function () {
	                    // negative to match what (new Date).getTimezoneOffset() will return
	                    return -lookup_key().split(',')[0];
	                },
	                timezoneOffset : function () {
	                    // negative to match what (new Date).getTimezoneOffset() will return
	                    return -get_date_offset(new Date())
	                }
	            };
	        };
	
	    return {
	        determine: determine
	    };
	}());
	
	
	jstz.olson = jstz.olson || {};
	
	/**
	 * The keys in this dictionary are comma separated as such:
	 *
	 * First the offset compared to UTC time in minutes.
	 *
	 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
	 * does.
	 *
	 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
	 * only interesting for timezones with DST.
	 *
	 * The mapped arrays is used for constructing the jstz.TimeZone object from within
	 * jstz.determine();
	 */
	jstz.olson.timezones = {
	    '-720,0': 'Etc/GMT+12',
	    '-660,0': 'Pacific/Pago_Pago',
	    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
	    '-600,1': 'America/Adak',
	    '-600,0': 'Pacific/Honolulu',
	    '-570,0': 'Pacific/Marquesas',
	    '-540,0': 'Pacific/Gambier',
	    '-540,1': 'America/Anchorage',
	    '-480,1': 'America/Los_Angeles',
	    '-480,0': 'Pacific/Pitcairn',
	    '-420,0': 'America/Phoenix',
	    '-420,1': 'America/Denver',
	    '-360,0': 'America/Guatemala',
	    '-360,1': 'America/Chicago',
	    '-360,1,s': 'Pacific/Easter',
	    '-300,0': 'America/Bogota',
	    '-300,1': 'America/New_York',
	    '-270,0': 'America/Caracas',
	    '-240,1': 'America/Halifax',
	    '-240,0': 'America/Santo_Domingo',
	    '-240,1,s': 'America/Asuncion',
	    '-210,1': 'America/St_Johns',
	    '-180,1': 'America/Godthab',
	    '-180,0': 'America/Argentina/Buenos_Aires',
	    '-180,1,s': 'America/Montevideo',
	    '-120,0': 'America/Noronha',
	    '-120,1': 'America/Noronha',
	    '-60,1': 'Atlantic/Azores',
	    '-60,0': 'Atlantic/Cape_Verde',
	    '0,0': 'UTC',
	    '0,1': 'Europe/London',
	    '60,1': 'Europe/Berlin',
	    '60,0': 'Africa/Lagos',
	    '60,1,s': 'Africa/Windhoek',
	    '120,1': 'Asia/Beirut',
	    '120,0': 'Africa/Johannesburg',
	    '180,0': 'Asia/Baghdad',
	    '180,1': 'Europe/Moscow',
	    '210,1': 'Asia/Tehran',
	    '240,0': 'Asia/Dubai',
	    '240,1': 'Asia/Baku',
	    '270,0': 'Asia/Kabul',
	    '300,1': 'Asia/Yekaterinburg',
	    '300,0': 'Asia/Karachi',
	    '330,0': 'Asia/Kolkata',
	    '345,0': 'Asia/Kathmandu',
	    '360,0': 'Asia/Dhaka',
	    '360,1': 'Asia/Omsk',
	    '390,0': 'Asia/Rangoon',
	    '420,1': 'Asia/Krasnoyarsk',
	    '420,0': 'Asia/Jakarta',
	    '480,0': 'Asia/Shanghai',
	    '480,1': 'Asia/Irkutsk',
	    '525,0': 'Australia/Eucla',
	    '525,1,s': 'Australia/Eucla',
	    '540,1': 'Asia/Yakutsk',
	    '540,0': 'Asia/Tokyo',
	    '570,0': 'Australia/Darwin',
	    '570,1,s': 'Australia/Adelaide',
	    '600,0': 'Australia/Brisbane',
	    '600,1': 'Asia/Vladivostok',
	    '600,1,s': 'Australia/Sydney',
	    '630,1,s': 'Australia/Lord_Howe',
	    '660,1': 'Asia/Kamchatka',
	    '660,0': 'Pacific/Noumea',
	    '690,0': 'Pacific/Norfolk',
	    '720,1,s': 'Pacific/Auckland',
	    '720,0': 'Pacific/Majuro',
	    '765,1,s': 'Pacific/Chatham',
	    '780,0': 'Pacific/Tongatapu',
	    '780,1,s': 'Pacific/Apia',
	    '840,0': 'Pacific/Kiritimati'
	};
	
	/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
	jstz.olson.dst_rules = {
	    "years": [
	        2008,
	        2009,
	        2010,
	        2011,
	        2012,
	        2013,
	        2014
	    ],
	    "zones": [
	        {
	            "name": "Africa/Cairo",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1209074400000
	                },
	                {
	                    "e": 1250802000000,
	                    "s": 1240524000000
	                },
	                {
	                    "e": 1285880400000,
	                    "s": 1284069600000
	                },
	                false,
	                false,
	                false,
	                {
	                    "e": 1411678800000,
	                    "s": 1406844000000
	                }
	            ]
	        },
	        {
	            "name": "Africa/Casablanca",
	            "rules": [
	                {
	                    "e": 1220223600000,
	                    "s": 1212278400000
	                },
	                {
	                    "e": 1250809200000,
	                    "s": 1243814400000
	                },
	                {
	                    "e": 1281222000000,
	                    "s": 1272758400000
	                },
	                {
	                    "e": 1312066800000,
	                    "s": 1301788800000
	                },
	                {
	                    "e": 1348970400000,
	                    "s": 1345428000000
	                },
	                {
	                    "e": 1382839200000,
	                    "s": 1376100000000
	                },
	                {
	                    "e": 1414288800000,
	                    "s": 1406944800000
	                }
	            ]
	        },
	        {
	            "name": "America/Asuncion",
	            "rules": [
	                {
	                    "e": 1205031600000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1236481200000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1270954800000,
	                    "s": 1286078400000
	                },
	                {
	                    "e": 1302404400000,
	                    "s": 1317528000000
	                },
	                {
	                    "e": 1333854000000,
	                    "s": 1349582400000
	                },
	                {
	                    "e": 1364094000000,
	                    "s": 1381032000000
	                },
	                {
	                    "e": 1395543600000,
	                    "s": 1412481600000
	                }
	            ]
	        },
	        {
	            "name": "America/Campo_Grande",
	            "rules": [
	                {
	                    "e": 1203217200000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1234666800000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1266721200000,
	                    "s": 1287288000000
	                },
	                {
	                    "e": 1298170800000,
	                    "s": 1318737600000
	                },
	                {
	                    "e": 1330225200000,
	                    "s": 1350792000000
	                },
	                {
	                    "e": 1361070000000,
	                    "s": 1382241600000
	                },
	                {
	                    "e": 1392519600000,
	                    "s": 1413691200000
	                }
	            ]
	        },
	        {
	            "name": "America/Goose_Bay",
	            "rules": [
	                {
	                    "e": 1225594860000,
	                    "s": 1205035260000
	                },
	                {
	                    "e": 1257044460000,
	                    "s": 1236484860000
	                },
	                {
	                    "e": 1289098860000,
	                    "s": 1268539260000
	                },
	                {
	                    "e": 1320555600000,
	                    "s": 1299988860000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1331445600000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362895200000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394344800000
	                }
	            ]
	        },
	        {
	            "name": "America/Havana",
	            "rules": [
	                {
	                    "e": 1224997200000,
	                    "s": 1205643600000
	                },
	                {
	                    "e": 1256446800000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1288501200000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1321160400000,
	                    "s": 1300597200000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1333256400000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Mazatlan",
	            "rules": [
	                {
	                    "e": 1225008000000,
	                    "s": 1207472400000
	                },
	                {
	                    "e": 1256457600000,
	                    "s": 1238922000000
	                },
	                {
	                    "e": 1288512000000,
	                    "s": 1270371600000
	                },
	                {
	                    "e": 1319961600000,
	                    "s": 1301821200000
	                },
	                {
	                    "e": 1351411200000,
	                    "s": 1333270800000
	                },
	                {
	                    "e": 1382860800000,
	                    "s": 1365325200000
	                },
	                {
	                    "e": 1414310400000,
	                    "s": 1396774800000
	                }
	            ]
	        },
	        {
	            "name": "America/Mexico_City",
	            "rules": [
	                {
	                    "e": 1225004400000,
	                    "s": 1207468800000
	                },
	                {
	                    "e": 1256454000000,
	                    "s": 1238918400000
	                },
	                {
	                    "e": 1288508400000,
	                    "s": 1270368000000
	                },
	                {
	                    "e": 1319958000000,
	                    "s": 1301817600000
	                },
	                {
	                    "e": 1351407600000,
	                    "s": 1333267200000
	                },
	                {
	                    "e": 1382857200000,
	                    "s": 1365321600000
	                },
	                {
	                    "e": 1414306800000,
	                    "s": 1396771200000
	                }
	            ]
	        },
	        {
	            "name": "America/Miquelon",
	            "rules": [
	                {
	                    "e": 1225598400000,
	                    "s": 1205038800000
	                },
	                {
	                    "e": 1257048000000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1289102400000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1320552000000,
	                    "s": 1299992400000
	                },
	                {
	                    "e": 1352001600000,
	                    "s": 1331442000000
	                },
	                {
	                    "e": 1383451200000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414900800000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Santa_Isabel",
	            "rules": [
	                {
	                    "e": 1225011600000,
	                    "s": 1207476000000
	                },
	                {
	                    "e": 1256461200000,
	                    "s": 1238925600000
	                },
	                {
	                    "e": 1288515600000,
	                    "s": 1270375200000
	                },
	                {
	                    "e": 1319965200000,
	                    "s": 1301824800000
	                },
	                {
	                    "e": 1351414800000,
	                    "s": 1333274400000
	                },
	                {
	                    "e": 1382864400000,
	                    "s": 1365328800000
	                },
	                {
	                    "e": 1414314000000,
	                    "s": 1396778400000
	                }
	            ]
	        },
	        {
	            "name": "America/Santiago",
	            "rules": [
	                {
	                    "e": 1206846000000,
	                    "s": 1223784000000
	                },
	                {
	                    "e": 1237086000000,
	                    "s": 1255233600000
	                },
	                {
	                    "e": 1270350000000,
	                    "s": 1286683200000
	                },
	                {
	                    "e": 1304823600000,
	                    "s": 1313899200000
	                },
	                {
	                    "e": 1335668400000,
	                    "s": 1346558400000
	                },
	                {
	                    "e": 1367118000000,
	                    "s": 1378612800000
	                },
	                {
	                    "e": 1398567600000,
	                    "s": 1410062400000
	                }
	            ]
	        },
	        {
	            "name": "America/Sao_Paulo",
	            "rules": [
	                {
	                    "e": 1203213600000,
	                    "s": 1224385200000
	                },
	                {
	                    "e": 1234663200000,
	                    "s": 1255834800000
	                },
	                {
	                    "e": 1266717600000,
	                    "s": 1287284400000
	                },
	                {
	                    "e": 1298167200000,
	                    "s": 1318734000000
	                },
	                {
	                    "e": 1330221600000,
	                    "s": 1350788400000
	                },
	                {
	                    "e": 1361066400000,
	                    "s": 1382238000000
	                },
	                {
	                    "e": 1392516000000,
	                    "s": 1413687600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Amman",
	            "rules": [
	                {
	                    "e": 1225404000000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1256853600000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288303200000,
	                    "s": 1269554400000
	                },
	                {
	                    "e": 1319752800000,
	                    "s": 1301608800000
	                },
	                false,
	                false,
	                {
	                    "e": 1414706400000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Damascus",
	            "rules": [
	                {
	                    "e": 1225486800000,
	                    "s": 1207260000000
	                },
	                {
	                    "e": 1256850000000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288299600000,
	                    "s": 1270159200000
	                },
	                {
	                    "e": 1319749200000,
	                    "s": 1301608800000
	                },
	                {
	                    "e": 1351198800000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1382648400000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414702800000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Dubai",
	            "rules": [
	                false,
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Gaza",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1252015200000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1281474000000,
	                    "s": 1269640860000
	                },
	                {
	                    "e": 1312146000000,
	                    "s": 1301608860000
	                },
	                {
	                    "e": 1348178400000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1380229200000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414098000000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Irkutsk",
	            "rules": [
	                {
	                    "e": 1224957600000,
	                    "s": 1206813600000
	                },
	                {
	                    "e": 1256407200000,
	                    "s": 1238263200000
	                },
	                {
	                    "e": 1288461600000,
	                    "s": 1269712800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Jerusalem",
	            "rules": [
	                {
	                    "e": 1223161200000,
	                    "s": 1206662400000
	                },
	                {
	                    "e": 1254006000000,
	                    "s": 1238112000000
	                },
	                {
	                    "e": 1284246000000,
	                    "s": 1269561600000
	                },
	                {
	                    "e": 1317510000000,
	                    "s": 1301616000000
	                },
	                {
	                    "e": 1348354800000,
	                    "s": 1333065600000
	                },
	                {
	                    "e": 1382828400000,
	                    "s": 1364515200000
	                },
	                {
	                    "e": 1414278000000,
	                    "s": 1395964800000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Kamchatka",
	            "rules": [
	                {
	                    "e": 1224943200000,
	                    "s": 1206799200000
	                },
	                {
	                    "e": 1256392800000,
	                    "s": 1238248800000
	                },
	                {
	                    "e": 1288450800000,
	                    "s": 1269698400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Krasnoyarsk",
	            "rules": [
	                {
	                    "e": 1224961200000,
	                    "s": 1206817200000
	                },
	                {
	                    "e": 1256410800000,
	                    "s": 1238266800000
	                },
	                {
	                    "e": 1288465200000,
	                    "s": 1269716400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Omsk",
	            "rules": [
	                {
	                    "e": 1224964800000,
	                    "s": 1206820800000
	                },
	                {
	                    "e": 1256414400000,
	                    "s": 1238270400000
	                },
	                {
	                    "e": 1288468800000,
	                    "s": 1269720000000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Vladivostok",
	            "rules": [
	                {
	                    "e": 1224950400000,
	                    "s": 1206806400000
	                },
	                {
	                    "e": 1256400000000,
	                    "s": 1238256000000
	                },
	                {
	                    "e": 1288454400000,
	                    "s": 1269705600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yakutsk",
	            "rules": [
	                {
	                    "e": 1224954000000,
	                    "s": 1206810000000
	                },
	                {
	                    "e": 1256403600000,
	                    "s": 1238259600000
	                },
	                {
	                    "e": 1288458000000,
	                    "s": 1269709200000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yekaterinburg",
	            "rules": [
	                {
	                    "e": 1224968400000,
	                    "s": 1206824400000
	                },
	                {
	                    "e": 1256418000000,
	                    "s": 1238274000000
	                },
	                {
	                    "e": 1288472400000,
	                    "s": 1269723600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yerevan",
	            "rules": [
	                {
	                    "e": 1224972000000,
	                    "s": 1206828000000
	                },
	                {
	                    "e": 1256421600000,
	                    "s": 1238277600000
	                },
	                {
	                    "e": 1288476000000,
	                    "s": 1269727200000
	                },
	                {
	                    "e": 1319925600000,
	                    "s": 1301176800000
	                },
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Australia/Lord_Howe",
	            "rules": [
	                {
	                    "e": 1207407600000,
	                    "s": 1223134200000
	                },
	                {
	                    "e": 1238857200000,
	                    "s": 1254583800000
	                },
	                {
	                    "e": 1270306800000,
	                    "s": 1286033400000
	                },
	                {
	                    "e": 1301756400000,
	                    "s": 1317483000000
	                },
	                {
	                    "e": 1333206000000,
	                    "s": 1349537400000
	                },
	                {
	                    "e": 1365260400000,
	                    "s": 1380987000000
	                },
	                {
	                    "e": 1396710000000,
	                    "s": 1412436600000
	                }
	            ]
	        },
	        {
	            "name": "Australia/Perth",
	            "rules": [
	                {
	                    "e": 1206813600000,
	                    "s": 1224957600000
	                },
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Helsinki",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        },
	        {
	            "name": "Europe/Minsk",
	            "rules": [
	                {
	                    "e": 1224979200000,
	                    "s": 1206835200000
	                },
	                {
	                    "e": 1256428800000,
	                    "s": 1238284800000
	                },
	                {
	                    "e": 1288483200000,
	                    "s": 1269734400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Moscow",
	            "rules": [
	                {
	                    "e": 1224975600000,
	                    "s": 1206831600000
	                },
	                {
	                    "e": 1256425200000,
	                    "s": 1238281200000
	                },
	                {
	                    "e": 1288479600000,
	                    "s": 1269730800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Pacific/Apia",
	            "rules": [
	                false,
	                false,
	                false,
	                {
	                    "e": 1301752800000,
	                    "s": 1316872800000
	                },
	                {
	                    "e": 1333202400000,
	                    "s": 1348927200000
	                },
	                {
	                    "e": 1365256800000,
	                    "s": 1380376800000
	                },
	                {
	                    "e": 1396706400000,
	                    "s": 1411826400000
	                }
	            ]
	        },
	        {
	            "name": "Pacific/Fiji",
	            "rules": [
	                false,
	                false,
	                {
	                    "e": 1269698400000,
	                    "s": 1287842400000
	                },
	                {
	                    "e": 1327154400000,
	                    "s": 1319292000000
	                },
	                {
	                    "e": 1358604000000,
	                    "s": 1350741600000
	                },
	                {
	                    "e": 1390050000000,
	                    "s": 1382796000000
	                },
	                {
	                    "e": 1421503200000,
	                    "s": 1414850400000
	                }
	            ]
	        },
	        {
	            "name": "Europe/London",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        }
	    ]
	};
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = jstz;
	} else if (("function" !== 'undefined' && __webpack_require__(3916) !== null) && (__webpack_require__(3917) != null)) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return jstz;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	    if (typeof root === 'undefined') {
	        window.jstz = jstz;
	    } else {
	        root.jstz = jstz;
	    }
	}
	}());


/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3534);


/***/ }),
/* 3536 */
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),
/* 3537 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ }),
/* 3538 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3539 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = baseRest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = omit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Masonry v4.2.2
	 * Cascading grid layout library
	 * https://masonry.desandro.com
	 * MIT License
	 * by David DeSandro
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /*globals define, module, require */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(3548),
	        __webpack_require__(340)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      require('outlayer'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Masonry = factory(
	      window.Outlayer,
	      window.getSize
	    );
	  }
	
	}( window, function factory( Outlayer, getSize ) {
	
	'use strict';
	
	// -------------------------- masonryDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var Masonry = Outlayer.create('masonry');
	  // isFitWidth -> fitWidth
	  Masonry.compatOptions.fitWidth = 'isFitWidth';
	
	  var proto = Masonry.prototype;
	
	  proto._resetLayout = function() {
	    this.getSize();
	    this._getMeasurement( 'columnWidth', 'outerWidth' );
	    this._getMeasurement( 'gutter', 'outerWidth' );
	    this.measureColumns();
	
	    // reset column Y
	    this.colYs = [];
	    for ( var i=0; i < this.cols; i++ ) {
	      this.colYs.push( 0 );
	    }
	
	    this.maxY = 0;
	    this.horizontalColIndex = 0;
	  };
	
	  proto.measureColumns = function() {
	    this.getContainerWidth();
	    // if columnWidth is 0, default to outerWidth of first item
	    if ( !this.columnWidth ) {
	      var firstItem = this.items[0];
	      var firstItemElem = firstItem && firstItem.element;
	      // columnWidth fall back to item of first element
	      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
	        // if first elem has no width, default to size of container
	        this.containerWidth;
	    }
	
	    var columnWidth = this.columnWidth += this.gutter;
	
	    // calculate columns
	    var containerWidth = this.containerWidth + this.gutter;
	    var cols = containerWidth / columnWidth;
	    // fix rounding errors, typically with gutters
	    var excess = columnWidth - containerWidth % columnWidth;
	    // if overshoot is less than a pixel, round up, otherwise floor it
	    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
	    cols = Math[ mathMethod ]( cols );
	    this.cols = Math.max( cols, 1 );
	  };
	
	  proto.getContainerWidth = function() {
	    // container is parent if fit width
	    var isFitWidth = this._getOption('fitWidth');
	    var container = isFitWidth ? this.element.parentNode : this.element;
	    // check that this.size and size are there
	    // IE8 triggers resize on body size change, so they might not be
	    var size = getSize( container );
	    this.containerWidth = size && size.innerWidth;
	  };
	
	  proto._getItemLayoutPosition = function( item ) {
	    item.getSize();
	    // how many columns does this brick span
	    var remainder = item.size.outerWidth % this.columnWidth;
	    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
	    // round if off by 1 pixel, otherwise use ceil
	    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
	    colSpan = Math.min( colSpan, this.cols );
	    // use horizontal or top column position
	    var colPosMethod = this.options.horizontalOrder ?
	      '_getHorizontalColPosition' : '_getTopColPosition';
	    var colPosition = this[ colPosMethod ]( colSpan, item );
	    // position the brick
	    var position = {
	      x: this.columnWidth * colPosition.col,
	      y: colPosition.y
	    };
	    // apply setHeight to necessary columns
	    var setHeight = colPosition.y + item.size.outerHeight;
	    var setMax = colSpan + colPosition.col;
	    for ( var i = colPosition.col; i < setMax; i++ ) {
	      this.colYs[i] = setHeight;
	    }
	
	    return position;
	  };
	
	  proto._getTopColPosition = function( colSpan ) {
	    var colGroup = this._getTopColGroup( colSpan );
	    // get the minimum Y value from the columns
	    var minimumY = Math.min.apply( Math, colGroup );
	
	    return {
	      col: colGroup.indexOf( minimumY ),
	      y: minimumY,
	    };
	  };
	
	  /**
	   * @param {Number} colSpan - number of columns the element spans
	   * @returns {Array} colGroup
	   */
	  proto._getTopColGroup = function( colSpan ) {
	    if ( colSpan < 2 ) {
	      // if brick spans only one column, use all the column Ys
	      return this.colYs;
	    }
	
	    var colGroup = [];
	    // how many different places could this brick fit horizontally
	    var groupCount = this.cols + 1 - colSpan;
	    // for each group potential horizontal position
	    for ( var i = 0; i < groupCount; i++ ) {
	      colGroup[i] = this._getColGroupY( i, colSpan );
	    }
	    return colGroup;
	  };
	
	  proto._getColGroupY = function( col, colSpan ) {
	    if ( colSpan < 2 ) {
	      return this.colYs[ col ];
	    }
	    // make an array of colY values for that one group
	    var groupColYs = this.colYs.slice( col, col + colSpan );
	    // and get the max value of the array
	    return Math.max.apply( Math, groupColYs );
	  };
	
	  // get column position based on horizontal index. #873
	  proto._getHorizontalColPosition = function( colSpan, item ) {
	    var col = this.horizontalColIndex % this.cols;
	    var isOver = colSpan > 1 && col + colSpan > this.cols;
	    // shift to next row if item can't fit on current row
	    col = isOver ? 0 : col;
	    // don't let zero-size items take up space
	    var hasSize = item.size.outerWidth && item.size.outerHeight;
	    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
	
	    return {
	      col: col,
	      y: this._getColGroupY( col, colSpan ),
	    };
	  };
	
	  proto._manageStamp = function( stamp ) {
	    var stampSize = getSize( stamp );
	    var offset = this._getElementOffset( stamp );
	    // get the columns that this stamp affects
	    var isOriginLeft = this._getOption('originLeft');
	    var firstX = isOriginLeft ? offset.left : offset.right;
	    var lastX = firstX + stampSize.outerWidth;
	    var firstCol = Math.floor( firstX / this.columnWidth );
	    firstCol = Math.max( 0, firstCol );
	    var lastCol = Math.floor( lastX / this.columnWidth );
	    // lastCol should not go over if multiple of columnWidth #425
	    lastCol -= lastX % this.columnWidth ? 0 : 1;
	    lastCol = Math.min( this.cols - 1, lastCol );
	    // set colYs to bottom of the stamp
	
	    var isOriginTop = this._getOption('originTop');
	    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
	      stampSize.outerHeight;
	    for ( var i = firstCol; i <= lastCol; i++ ) {
	      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
	    }
	  };
	
	  proto._getContainerSize = function() {
	    this.maxY = Math.max.apply( Math, this.colYs );
	    var size = {
	      height: this.maxY
	    };
	
	    if ( this._getOption('fitWidth') ) {
	      size.width = this._getContainerFitWidth();
	    }
	
	    return size;
	  };
	
	  proto._getContainerFitWidth = function() {
	    var unusedCols = 0;
	    // count unused columns
	    var i = this.cols;
	    while ( --i ) {
	      if ( this.colYs[i] !== 0 ) {
	        break;
	      }
	      unusedCols++;
	    }
	    // fit container to columns that have been used
	    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
	  };
	
	  proto.needsResizeLayout = function() {
	    var previousWidth = this.containerWidth;
	    this.getContainerWidth();
	    return previousWidth != this.containerWidth;
	  };
	
	  return Masonry;
	
	}));


/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(3542);
	moment.tz.load(__webpack_require__(3533));


/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.43
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(15)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.43",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-au": 613,
		"./en-au.js": 613,
		"./en-ca": 614,
		"./en-ca.js": 614,
		"./en-gb": 615,
		"./en-gb.js": 615,
		"./en-ie": 616,
		"./en-ie.js": 616,
		"./en-il": 617,
		"./en-il.js": 617,
		"./en-in": 618,
		"./en-in.js": 618,
		"./en-nz": 619,
		"./en-nz.js": 619,
		"./en-sg": 620,
		"./en-sg.js": 620
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3543;


/***/ }),
/* 3544 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(445)
	var ieee754 = __webpack_require__(610)
	var isArray = __webpack_require__(3523)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3546 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	/**
	 * Helpers to enable Immutable compatibility *without* bringing in
	 * the 'immutable' package as a dependency.
	 */
	
	/**
	 * Check if an object is immutable by checking if it has a key specific
	 * to the immutable library.
	 *
	 * @param  {any} object
	 * @return {bool}
	 */
	function isImmutable(object) {
	  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
	  object._map && object._map.hasOwnProperty('__ownerID'))); // Immutable.Record
	}
	/**
	 * Denormalize an immutable entity.
	 *
	 * @param  {Schema} schema
	 * @param  {Immutable.Map|Immutable.Record} input
	 * @param  {function} unvisit
	 * @param  {function} getDenormalizedEntity
	 * @return {Immutable.Map|Immutable.Record}
	 */
	
	function denormalizeImmutable(schema, input, unvisit) {
	  return Object.keys(schema).reduce(function (object, key) {
	    // Immutable maps cast keys to strings on write so we need to ensure
	    // we're accessing them using string keys.
	    var stringKey = "" + key;
	
	    if (object.has(stringKey)) {
	      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
	    } else {
	      return object;
	    }
	  }, input);
	}
	
	var getDefaultGetId = function getDefaultGetId(idAttribute) {
	  return function (input) {
	    return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
	  };
	};
	
	var EntitySchema = /*#__PURE__*/function () {
	  function EntitySchema(key, definition, options) {
	    if (definition === void 0) {
	      definition = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!key || typeof key !== 'string') {
	      throw new Error("Expected a string key for Entity, but found " + key + ".");
	    }
	
	    var _options = options,
	        _options$idAttribute = _options.idAttribute,
	        idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute,
	        _options$mergeStrateg = _options.mergeStrategy,
	        mergeStrategy = _options$mergeStrateg === void 0 ? function (entityA, entityB) {
	      return _extends({}, entityA, entityB);
	    } : _options$mergeStrateg,
	        _options$processStrat = _options.processStrategy,
	        processStrategy = _options$processStrat === void 0 ? function (input) {
	      return _extends({}, input);
	    } : _options$processStrat,
	        _options$fallbackStra = _options.fallbackStrategy,
	        fallbackStrategy = _options$fallbackStra === void 0 ? function (key, schema) {
	      return undefined;
	    } : _options$fallbackStra;
	    this._key = key;
	    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
	    this._idAttribute = idAttribute;
	    this._mergeStrategy = mergeStrategy;
	    this._processStrategy = processStrategy;
	    this._fallbackStrategy = fallbackStrategy;
	    this.define(definition);
	  }
	
	  var _proto = EntitySchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	      var _extends2;
	
	      var schema = definition[key];
	      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
	    }, this.schema || {});
	  };
	
	  _proto.getId = function getId(input, parent, key) {
	    return this._getId(input, parent, key);
	  };
	
	  _proto.merge = function merge(entityA, entityB) {
	    return this._mergeStrategy(entityA, entityB);
	  };
	
	  _proto.fallback = function fallback(id, schema) {
	    return this._fallbackStrategy(id, schema);
	  };
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    var id = this.getId(input, parent, key);
	    var entityType = this.key;
	
	    if (!(entityType in visitedEntities)) {
	      visitedEntities[entityType] = {};
	    }
	
	    if (!(id in visitedEntities[entityType])) {
	      visitedEntities[entityType][id] = [];
	    }
	
	    if (visitedEntities[entityType][id].some(function (entity) {
	      return entity === input;
	    })) {
	      return id;
	    }
	
	    visitedEntities[entityType][id].push(input);
	
	    var processedEntity = this._processStrategy(input, parent, key);
	
	    Object.keys(this.schema).forEach(function (key) {
	      if (processedEntity.hasOwnProperty(key) && typeof processedEntity[key] === 'object') {
	        var schema = _this.schema[key];
	        var resolvedSchema = typeof schema === 'function' ? schema(input) : schema;
	        processedEntity[key] = visit(processedEntity[key], processedEntity, key, resolvedSchema, addEntity, visitedEntities);
	      }
	    });
	    addEntity(this, processedEntity, input, parent, key);
	    return id;
	  };
	
	  _proto.denormalize = function denormalize(entity, unvisit) {
	    var _this2 = this;
	
	    if (isImmutable(entity)) {
	      return denormalizeImmutable(this.schema, entity, unvisit);
	    }
	
	    Object.keys(this.schema).forEach(function (key) {
	      if (entity.hasOwnProperty(key)) {
	        var schema = _this2.schema[key];
	        entity[key] = unvisit(entity[key], schema);
	      }
	    });
	    return entity;
	  };
	
	  _createClass(EntitySchema, [{
	    key: "key",
	    get: function get() {
	      return this._key;
	    }
	  }, {
	    key: "idAttribute",
	    get: function get() {
	      return this._idAttribute;
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	var PolymorphicSchema = /*#__PURE__*/function () {
	  function PolymorphicSchema(definition, schemaAttribute) {
	    if (schemaAttribute) {
	      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
	        return input[schemaAttribute];
	      } : schemaAttribute;
	    }
	
	    this.define(definition);
	  }
	
	  var _proto = PolymorphicSchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = definition;
	  };
	
	  _proto.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
	    return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
	  };
	
	  _proto.inferSchema = function inferSchema(input, parent, key) {
	    if (this.isSingleSchema) {
	      return this.schema;
	    }
	
	    var attr = this.getSchemaAttribute(input, parent, key);
	    return this.schema[attr];
	  };
	
	  _proto.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity, visitedEntities) {
	    var schema = this.inferSchema(value, parent, key);
	
	    if (!schema) {
	      return value;
	    }
	
	    var normalizedValue = visit(value, parent, key, schema, addEntity, visitedEntities);
	    return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
	      id: normalizedValue,
	      schema: this.getSchemaAttribute(value, parent, key)
	    };
	  };
	
	  _proto.denormalizeValue = function denormalizeValue(value, unvisit) {
	    var schemaKey = isImmutable(value) ? value.get('schema') : value.schema;
	
	    if (!this.isSingleSchema && !schemaKey) {
	      return value;
	    }
	
	    var id = this.isSingleSchema ? undefined : isImmutable(value) ? value.get('id') : value.id;
	    var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
	    return unvisit(id || value, schema);
	  };
	
	  _createClass(PolymorphicSchema, [{
	    key: "isSingleSchema",
	    get: function get() {
	      return !this._schemaAttribute;
	    }
	  }]);
	
	  return PolymorphicSchema;
	}();
	
	var UnionSchema = /*#__PURE__*/function (_PolymorphicSchema) {
	  _inheritsLoose(UnionSchema, _PolymorphicSchema);
	
	  function UnionSchema(definition, schemaAttribute) {
	    if (!schemaAttribute) {
	      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
	    }
	
	    return _PolymorphicSchema.call(this, definition, schemaAttribute) || this;
	  }
	
	  var _proto = UnionSchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    return this.normalizeValue(input, parent, key, visit, addEntity, visitedEntities);
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    return this.denormalizeValue(input, unvisit);
	  };
	
	  return UnionSchema;
	}(PolymorphicSchema);
	
	var ValuesSchema = /*#__PURE__*/function (_PolymorphicSchema) {
	  _inheritsLoose(ValuesSchema, _PolymorphicSchema);
	
	  function ValuesSchema() {
	    return _PolymorphicSchema.apply(this, arguments) || this;
	  }
	
	  var _proto = ValuesSchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    return Object.keys(input).reduce(function (output, key, index) {
	      var _extends2;
	
	      var value = input[key];
	      return value !== undefined && value !== null ? _extends({}, output, (_extends2 = {}, _extends2[key] = _this.normalizeValue(value, input, key, visit, addEntity, visitedEntities), _extends2)) : output;
	    }, {});
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    var _this2 = this;
	
	    return Object.keys(input).reduce(function (output, key) {
	      var _extends3;
	
	      var entityOrId = input[key];
	      return _extends({}, output, (_extends3 = {}, _extends3[key] = _this2.denormalizeValue(entityOrId, unvisit), _extends3));
	    }, {});
	  };
	
	  return ValuesSchema;
	}(PolymorphicSchema);
	
	var validateSchema = function validateSchema(definition) {
	  var isArray = Array.isArray(definition);
	
	  if (isArray && definition.length > 1) {
	    throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
	  }
	
	  return definition[0];
	};
	
	var getValues = function getValues(input) {
	  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
	    return input[key];
	  });
	};
	
	var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
	  schema = validateSchema(schema);
	  var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
	  // is not any special information that can be gathered from themselves directly
	
	  return values.map(function (value, index) {
	    return visit(value, parent, key, schema, addEntity, visitedEntities);
	  });
	};
	var denormalize = function denormalize(schema, input, unvisit) {
	  schema = validateSchema(schema);
	  return input && input.map ? input.map(function (entityOrId) {
	    return unvisit(entityOrId, schema);
	  }) : input;
	};
	
	var ArraySchema = /*#__PURE__*/function (_PolymorphicSchema) {
	  _inheritsLoose(ArraySchema, _PolymorphicSchema);
	
	  function ArraySchema() {
	    return _PolymorphicSchema.apply(this, arguments) || this;
	  }
	
	  var _proto = ArraySchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    var values = getValues(input);
	    return values.map(function (value, index) {
	      return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
	    }).filter(function (value) {
	      return value !== undefined && value !== null;
	    });
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    var _this2 = this;
	
	    return input && input.map ? input.map(function (value) {
	      return _this2.denormalizeValue(value, unvisit);
	    }) : input;
	  };
	
	  return ArraySchema;
	}(PolymorphicSchema);
	
	var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
	  var object = _extends({}, input);
	
	  Object.keys(schema).forEach(function (key) {
	    var localSchema = schema[key];
	    var resolvedLocalSchema = typeof localSchema === 'function' ? localSchema(input) : localSchema;
	    var value = visit(input[key], input, key, resolvedLocalSchema, addEntity, visitedEntities);
	
	    if (value === undefined || value === null) {
	      delete object[key];
	    } else {
	      object[key] = value;
	    }
	  });
	  return object;
	};
	
	var _denormalize = function denormalize(schema, input, unvisit) {
	  if (isImmutable(input)) {
	    return denormalizeImmutable(schema, input, unvisit);
	  }
	
	  var object = _extends({}, input);
	
	  Object.keys(schema).forEach(function (key) {
	    if (object[key] != null) {
	      object[key] = unvisit(object[key], schema[key]);
	    }
	  });
	  return object;
	};
	
	var ObjectSchema = /*#__PURE__*/function () {
	  function ObjectSchema(definition) {
	    this.define(definition);
	  }
	
	  var _proto = ObjectSchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	      var _extends2;
	
	      var schema = definition[key];
	      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
	    }, this.schema || {});
	  };
	
	  _proto.normalize = function normalize() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _normalize.apply(void 0, [this.schema].concat(args));
	  };
	
	  _proto.denormalize = function denormalize() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _denormalize.apply(void 0, [this.schema].concat(args));
	  };
	
	  return ObjectSchema;
	}();
	
	var visit = function visit(value, parent, key, schema, addEntity, visitedEntities) {
	  if (typeof value !== 'object' || !value) {
	    return value;
	  }
	
	  if (typeof schema === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
	    var method = Array.isArray(schema) ? normalize : _normalize;
	    return method(schema, value, parent, key, visit, addEntity, visitedEntities);
	  }
	
	  return schema.normalize(value, parent, key, visit, addEntity, visitedEntities);
	};
	
	var addEntities = function addEntities(entities) {
	  return function (schema, processedEntity, value, parent, key) {
	    var schemaKey = schema.key;
	    var id = schema.getId(value, parent, key);
	
	    if (!(schemaKey in entities)) {
	      entities[schemaKey] = {};
	    }
	
	    var existingEntity = entities[schemaKey][id];
	
	    if (existingEntity) {
	      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
	    } else {
	      entities[schemaKey][id] = processedEntity;
	    }
	  };
	};
	
	var schema = {
	  Array: ArraySchema,
	  Entity: EntitySchema,
	  Object: ObjectSchema,
	  Union: UnionSchema,
	  Values: ValuesSchema
	};
	var normalize$1 = function normalize(input, schema) {
	  if (!input || typeof input !== 'object') {
	    throw new Error("Unexpected input given to normalize. Expected type to be \"object\", found \"" + (input === null ? 'null' : typeof input) + "\".");
	  }
	
	  var entities = {};
	  var addEntity = addEntities(entities);
	  var visitedEntities = {};
	  var result = visit(input, input, null, schema, addEntity, visitedEntities);
	  return {
	    entities: entities,
	    result: result
	  };
	};
	
	var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
	  var entity = getEntity(id, schema);
	
	  if (entity === undefined && schema instanceof EntitySchema) {
	    entity = schema.fallback(id, schema);
	  }
	
	  if (typeof entity !== 'object' || entity === null) {
	    return entity;
	  }
	
	  if (!cache[schema.key]) {
	    cache[schema.key] = {};
	  }
	
	  if (!cache[schema.key][id]) {
	    // Ensure we don't mutate it non-immutable objects
	    var entityCopy = isImmutable(entity) ? entity : _extends({}, entity); // Need to set this first so that if it is referenced further within the
	    // denormalization the reference will already exist.
	
	    cache[schema.key][id] = entityCopy;
	    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
	  }
	
	  return cache[schema.key][id];
	};
	
	var getUnvisit = function getUnvisit(entities) {
	  var cache = {};
	  var getEntity = getEntities(entities);
	  return function unvisit(input, schema) {
	    if (typeof schema === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
	      var method = Array.isArray(schema) ? denormalize : _denormalize;
	      return method(schema, input, unvisit);
	    }
	
	    if (input === undefined || input === null) {
	      return input;
	    }
	
	    if (schema instanceof EntitySchema) {
	      return unvisitEntity(input, schema, unvisit, getEntity, cache);
	    }
	
	    return schema.denormalize(input, unvisit);
	  };
	};
	
	var getEntities = function getEntities(entities) {
	  var isImmutable$1 = isImmutable(entities);
	  return function (entityOrId, schema) {
	    var schemaKey = schema.key;
	
	    if (typeof entityOrId === 'object') {
	      return entityOrId;
	    }
	
	    if (isImmutable$1) {
	      return entities.getIn([schemaKey, entityOrId.toString()]);
	    }
	
	    return entities[schemaKey] && entities[schemaKey][entityOrId];
	  };
	};
	
	var denormalize$1 = function denormalize(input, schema, entities) {
	  if (typeof input !== 'undefined') {
	    return getUnvisit(entities)(input, schema);
	  }
	};
	
	exports.denormalize = denormalize$1;
	exports.normalize = normalize$1;
	exports.schema = schema;


/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Outlayer Item
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(289),
	        __webpack_require__(340)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      require('ev-emitter'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Outlayer = {};
	    window.Outlayer.Item = factory(
	      window.EvEmitter,
	      window.getSize
	    );
	  }
	
	}( window, function factory( EvEmitter, getSize ) {
	'use strict';
	
	// ----- helpers ----- //
	
	function isEmptyObj( obj ) {
	  for ( var prop in obj ) {
	    return false;
	  }
	  prop = null;
	  return true;
	}
	
	// -------------------------- CSS3 support -------------------------- //
	
	
	var docElemStyle = document.documentElement.style;
	
	var transitionProperty = typeof docElemStyle.transition == 'string' ?
	  'transition' : 'WebkitTransition';
	var transformProperty = typeof docElemStyle.transform == 'string' ?
	  'transform' : 'WebkitTransform';
	
	var transitionEndEvent = {
	  WebkitTransition: 'webkitTransitionEnd',
	  transition: 'transitionend'
	}[ transitionProperty ];
	
	// cache all vendor properties that could have vendor prefix
	var vendorProperties = {
	  transform: transformProperty,
	  transition: transitionProperty,
	  transitionDuration: transitionProperty + 'Duration',
	  transitionProperty: transitionProperty + 'Property',
	  transitionDelay: transitionProperty + 'Delay'
	};
	
	// -------------------------- Item -------------------------- //
	
	function Item( element, layout ) {
	  if ( !element ) {
	    return;
	  }
	
	  this.element = element;
	  // parent layout class, i.e. Masonry, Isotope, or Packery
	  this.layout = layout;
	  this.position = {
	    x: 0,
	    y: 0
	  };
	
	  this._create();
	}
	
	// inherit EvEmitter
	var proto = Item.prototype = Object.create( EvEmitter.prototype );
	proto.constructor = Item;
	
	proto._create = function() {
	  // transition objects
	  this._transn = {
	    ingProperties: {},
	    clean: {},
	    onEnd: {}
	  };
	
	  this.css({
	    position: 'absolute'
	  });
	};
	
	// trigger specified handler for event type
	proto.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * apply CSS styles to element
	 * @param {Object} style
	 */
	proto.css = function( style ) {
	  var elemStyle = this.element.style;
	
	  for ( var prop in style ) {
	    // use vendor property if available
	    var supportedProp = vendorProperties[ prop ] || prop;
	    elemStyle[ supportedProp ] = style[ prop ];
	  }
	};
	
	 // measure position, and sets it
	proto.getPosition = function() {
	  var style = getComputedStyle( this.element );
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
	  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
	  var x = parseFloat( xValue );
	  var y = parseFloat( yValue );
	  // convert percent to pixels
	  var layoutSize = this.layout.size;
	  if ( xValue.indexOf('%') != -1 ) {
	    x = ( x / 100 ) * layoutSize.width;
	  }
	  if ( yValue.indexOf('%') != -1 ) {
	    y = ( y / 100 ) * layoutSize.height;
	  }
	  // clean up 'auto' or other non-integer values
	  x = isNaN( x ) ? 0 : x;
	  y = isNaN( y ) ? 0 : y;
	  // remove padding from measurement
	  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
	  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
	
	  this.position.x = x;
	  this.position.y = y;
	};
	
	// set settled position, apply padding
	proto.layoutPosition = function() {
	  var layoutSize = this.layout.size;
	  var style = {};
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	
	  // x
	  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
	  var xProperty = isOriginLeft ? 'left' : 'right';
	  var xResetProperty = isOriginLeft ? 'right' : 'left';
	
	  var x = this.position.x + layoutSize[ xPadding ];
	  // set in percentage or pixels
	  style[ xProperty ] = this.getXValue( x );
	  // reset other property
	  style[ xResetProperty ] = '';
	
	  // y
	  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
	  var yProperty = isOriginTop ? 'top' : 'bottom';
	  var yResetProperty = isOriginTop ? 'bottom' : 'top';
	
	  var y = this.position.y + layoutSize[ yPadding ];
	  // set in percentage or pixels
	  style[ yProperty ] = this.getYValue( y );
	  // reset other property
	  style[ yResetProperty ] = '';
	
	  this.css( style );
	  this.emitEvent( 'layout', [ this ] );
	};
	
	proto.getXValue = function( x ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && !isHorizontal ?
	    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
	};
	
	proto.getYValue = function( y ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && isHorizontal ?
	    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
	};
	
	proto._transitionTo = function( x, y ) {
	  this.getPosition();
	  // get current x & y from top/left
	  var curX = this.position.x;
	  var curY = this.position.y;
	
	  var didNotMove = x == this.position.x && y == this.position.y;
	
	  // save end position
	  this.setPosition( x, y );
	
	  // if did not move and not transitioning, just go to layout
	  if ( didNotMove && !this.isTransitioning ) {
	    this.layoutPosition();
	    return;
	  }
	
	  var transX = x - curX;
	  var transY = y - curY;
	  var transitionStyle = {};
	  transitionStyle.transform = this.getTranslate( transX, transY );
	
	  this.transition({
	    to: transitionStyle,
	    onTransitionEnd: {
	      transform: this.layoutPosition
	    },
	    isCleaning: true
	  });
	};
	
	proto.getTranslate = function( x, y ) {
	  // flip cooridinates if origin on right or bottom
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  x = isOriginLeft ? x : -x;
	  y = isOriginTop ? y : -y;
	  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	};
	
	// non transition + transform support
	proto.goTo = function( x, y ) {
	  this.setPosition( x, y );
	  this.layoutPosition();
	};
	
	proto.moveTo = proto._transitionTo;
	
	proto.setPosition = function( x, y ) {
	  this.position.x = parseFloat( x );
	  this.position.y = parseFloat( y );
	};
	
	// ----- transition ----- //
	
	/**
	 * @param {Object} style - CSS
	 * @param {Function} onTransitionEnd
	 */
	
	// non transition, just trigger callback
	proto._nonTransition = function( args ) {
	  this.css( args.to );
	  if ( args.isCleaning ) {
	    this._removeStyles( args.to );
	  }
	  for ( var prop in args.onTransitionEnd ) {
	    args.onTransitionEnd[ prop ].call( this );
	  }
	};
	
	/**
	 * proper transition
	 * @param {Object} args - arguments
	 *   @param {Object} to - style to transition to
	 *   @param {Object} from - style to start transition from
	 *   @param {Boolean} isCleaning - removes transition styles after transition
	 *   @param {Function} onTransitionEnd - callback
	 */
	proto.transition = function( args ) {
	  // redirect to nonTransition if no transition duration
	  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
	    this._nonTransition( args );
	    return;
	  }
	
	  var _transition = this._transn;
	  // keep track of onTransitionEnd callback by css property
	  for ( var prop in args.onTransitionEnd ) {
	    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
	  }
	  // keep track of properties that are transitioning
	  for ( prop in args.to ) {
	    _transition.ingProperties[ prop ] = true;
	    // keep track of properties to clean up when transition is done
	    if ( args.isCleaning ) {
	      _transition.clean[ prop ] = true;
	    }
	  }
	
	  // set from styles
	  if ( args.from ) {
	    this.css( args.from );
	    // force redraw. http://blog.alexmaccaw.com/css-transitions
	    var h = this.element.offsetHeight;
	    // hack for JSHint to hush about unused var
	    h = null;
	  }
	  // enable transition
	  this.enableTransition( args.to );
	  // set styles that are transitioning
	  this.css( args.to );
	
	  this.isTransitioning = true;
	
	};
	
	// dash before all cap letters, including first for
	// WebkitTransform => -webkit-transform
	function toDashedAll( str ) {
	  return str.replace( /([A-Z])/g, function( $1 ) {
	    return '-' + $1.toLowerCase();
	  });
	}
	
	var transitionProps = 'opacity,' + toDashedAll( transformProperty );
	
	proto.enableTransition = function(/* style */) {
	  // HACK changing transitionProperty during a transition
	  // will cause transition to jump
	  if ( this.isTransitioning ) {
	    return;
	  }
	
	  // make `transition: foo, bar, baz` from style object
	  // HACK un-comment this when enableTransition can work
	  // while a transition is happening
	  // var transitionValues = [];
	  // for ( var prop in style ) {
	  //   // dash-ify camelCased properties like WebkitTransition
	  //   prop = vendorProperties[ prop ] || prop;
	  //   transitionValues.push( toDashedAll( prop ) );
	  // }
	  // munge number to millisecond, to match stagger
	  var duration = this.layout.options.transitionDuration;
	  duration = typeof duration == 'number' ? duration + 'ms' : duration;
	  // enable transition styles
	  this.css({
	    transitionProperty: transitionProps,
	    transitionDuration: duration,
	    transitionDelay: this.staggerDelay || 0
	  });
	  // listen for transition end event
	  this.element.addEventListener( transitionEndEvent, this, false );
	};
	
	// ----- events ----- //
	
	proto.onwebkitTransitionEnd = function( event ) {
	  this.ontransitionend( event );
	};
	
	proto.onotransitionend = function( event ) {
	  this.ontransitionend( event );
	};
	
	// properties that I munge to make my life easier
	var dashedVendorProperties = {
	  '-webkit-transform': 'transform'
	};
	
	proto.ontransitionend = function( event ) {
	  // disregard bubbled events from children
	  if ( event.target !== this.element ) {
	    return;
	  }
	  var _transition = this._transn;
	  // get property name of transitioned property, convert to prefix-free
	  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;
	
	  // remove property that has completed transitioning
	  delete _transition.ingProperties[ propertyName ];
	  // check if any properties are still transitioning
	  if ( isEmptyObj( _transition.ingProperties ) ) {
	    // all properties have completed transitioning
	    this.disableTransition();
	  }
	  // clean style
	  if ( propertyName in _transition.clean ) {
	    // clean up style
	    this.element.style[ event.propertyName ] = '';
	    delete _transition.clean[ propertyName ];
	  }
	  // trigger onTransitionEnd callback
	  if ( propertyName in _transition.onEnd ) {
	    var onTransitionEnd = _transition.onEnd[ propertyName ];
	    onTransitionEnd.call( this );
	    delete _transition.onEnd[ propertyName ];
	  }
	
	  this.emitEvent( 'transitionEnd', [ this ] );
	};
	
	proto.disableTransition = function() {
	  this.removeTransitionStyles();
	  this.element.removeEventListener( transitionEndEvent, this, false );
	  this.isTransitioning = false;
	};
	
	/**
	 * removes style property from element
	 * @param {Object} style
	**/
	proto._removeStyles = function( style ) {
	  // clean up transition styles
	  var cleanStyle = {};
	  for ( var prop in style ) {
	    cleanStyle[ prop ] = '';
	  }
	  this.css( cleanStyle );
	};
	
	var cleanTransitionStyle = {
	  transitionProperty: '',
	  transitionDuration: '',
	  transitionDelay: ''
	};
	
	proto.removeTransitionStyles = function() {
	  // remove transition
	  this.css( cleanTransitionStyle );
	};
	
	// ----- stagger ----- //
	
	proto.stagger = function( delay ) {
	  delay = isNaN( delay ) ? 0 : delay;
	  this.staggerDelay = delay + 'ms';
	};
	
	// ----- show/hide/remove ----- //
	
	// remove element from DOM
	proto.removeElem = function() {
	  this.element.parentNode.removeChild( this.element );
	  // remove display: none
	  this.css({ display: '' });
	  this.emitEvent( 'remove', [ this ] );
	};
	
	proto.remove = function() {
	  // just remove element if no transition support or no transition
	  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
	    this.removeElem();
	    return;
	  }
	
	  // start transition
	  this.once( 'transitionEnd', function() {
	    this.removeElem();
	  });
	  this.hide();
	};
	
	proto.reveal = function() {
	  delete this.isHidden;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;
	
	  this.transition({
	    from: options.hiddenStyle,
	    to: options.visibleStyle,
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onRevealTransitionEnd = function() {
	  // check if still visible
	  // during transition, item may have been hidden
	  if ( !this.isHidden ) {
	    this.emitEvent('reveal');
	  }
	};
	
	/**
	 * get style property use for hide/reveal transition end
	 * @param {String} styleProperty - hiddenStyle/visibleStyle
	 * @returns {String}
	 */
	proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
	  var optionStyle = this.layout.options[ styleProperty ];
	  // use opacity
	  if ( optionStyle.opacity ) {
	    return 'opacity';
	  }
	  // get first property
	  for ( var prop in optionStyle ) {
	    return prop;
	  }
	};
	
	proto.hide = function() {
	  // set flag
	  this.isHidden = true;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;
	
	  this.transition({
	    from: options.visibleStyle,
	    to: options.hiddenStyle,
	    // keep hidden stuff hidden
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onHideTransitionEnd = function() {
	  // check if still hidden
	  // during transition, item may have been un-hidden
	  if ( this.isHidden ) {
	    this.css({ display: 'none' });
	    this.emitEvent('hide');
	  }
	};
	
	proto.destroy = function() {
	  this.css({
	    position: '',
	    left: '',
	    right: '',
	    top: '',
	    bottom: '',
	    transition: '',
	    transform: ''
	  });
	};
	
	return Item;
	
	}));


/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Outlayer v2.1.1
	 * the brains and guts of a layout library
	 * MIT license
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(289),
	        __webpack_require__(340),
	        __webpack_require__(3503),
	        __webpack_require__(3547)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Item ) {
	        return factory( window, EvEmitter, getSize, utils, Item);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      window,
	      require('ev-emitter'),
	      require('get-size'),
	      require('fizzy-ui-utils'),
	      require('./item')
	    );
	  } else {
	    // browser global
	    window.Outlayer = factory(
	      window,
	      window.EvEmitter,
	      window.getSize,
	      window.fizzyUIUtils,
	      window.Outlayer.Item
	    );
	  }
	
	}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
	'use strict';
	
	// ----- vars ----- //
	
	var console = window.console;
	var jQuery = window.jQuery;
	var noop = function() {};
	
	// -------------------------- Outlayer -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Outlayer intances
	var instances = {};
	
	
	/**
	 * @param {Element, String} element
	 * @param {Object} options
	 * @constructor
	 */
	function Outlayer( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for ' + this.constructor.namespace +
	        ': ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // add id for Outlayer.getFromElement
	  var id = ++GUID;
	  this.element.outlayerGUID = id; // expando
	  instances[ id ] = this; // associate via id
	
	  // kick it off
	  this._create();
	
	  var isInitLayout = this._getOption('initLayout');
	  if ( isInitLayout ) {
	    this.layout();
	  }
	}
	
	// settings are for internal use only
	Outlayer.namespace = 'outlayer';
	Outlayer.Item = Item;
	
	// default options
	Outlayer.defaults = {
	  containerStyle: {
	    position: 'relative'
	  },
	  initLayout: true,
	  originLeft: true,
	  originTop: true,
	  resize: true,
	  resizeContainer: true,
	  // item options
	  transitionDuration: '0.4s',
	  hiddenStyle: {
	    opacity: 0,
	    transform: 'scale(0.001)'
	  },
	  visibleStyle: {
	    opacity: 1,
	    transform: 'scale(1)'
	  }
	};
	
	var proto = Outlayer.prototype;
	// inherit EvEmitter
	utils.extend( proto, EvEmitter.prototype );
	
	/**
	 * set options
	 * @param {Object} opts
	 */
	proto.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	/**
	 * get backwards compatible option value, check old name
	 */
	proto._getOption = function( option ) {
	  var oldOption = this.constructor.compatOptions[ option ];
	  return oldOption && this.options[ oldOption ] !== undefined ?
	    this.options[ oldOption ] : this.options[ option ];
	};
	
	Outlayer.compatOptions = {
	  // currentName: oldName
	  initLayout: 'isInitLayout',
	  horizontal: 'isHorizontal',
	  layoutInstant: 'isLayoutInstant',
	  originLeft: 'isOriginLeft',
	  originTop: 'isOriginTop',
	  resize: 'isResizeBound',
	  resizeContainer: 'isResizingContainer'
	};
	
	proto._create = function() {
	  // get items from children
	  this.reloadItems();
	  // elements that affect layout, but are not laid out
	  this.stamps = [];
	  this.stamp( this.options.stamp );
	  // set container style
	  utils.extend( this.element.style, this.options.containerStyle );
	
	  // bind resize method
	  var canBindResize = this._getOption('resize');
	  if ( canBindResize ) {
	    this.bindResize();
	  }
	};
	
	// goes through all children again and gets bricks in proper order
	proto.reloadItems = function() {
	  // collection of item elements
	  this.items = this._itemize( this.element.children );
	};
	
	
	/**
	 * turn elements into Outlayer.Items to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - collection of new Outlayer Items
	 */
	proto._itemize = function( elems ) {
	
	  var itemElems = this._filterFindItemElements( elems );
	  var Item = this.constructor.Item;
	
	  // create new Outlayer Items for collection
	  var items = [];
	  for ( var i=0; i < itemElems.length; i++ ) {
	    var elem = itemElems[i];
	    var item = new Item( elem, this );
	    items.push( item );
	  }
	
	  return items;
	};
	
	/**
	 * get item elements to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - item elements
	 */
	proto._filterFindItemElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.itemSelector );
	};
	
	/**
	 * getter method for getting item elements
	 * @returns {Array} elems - collection of item elements
	 */
	proto.getItemElements = function() {
	  return this.items.map( function( item ) {
	    return item.element;
	  });
	};
	
	// ----- init & layout ----- //
	
	/**
	 * lays out all items
	 */
	proto.layout = function() {
	  this._resetLayout();
	  this._manageStamps();
	
	  // don't animate first layout
	  var layoutInstant = this._getOption('layoutInstant');
	  var isInstant = layoutInstant !== undefined ?
	    layoutInstant : !this._isLayoutInited;
	  this.layoutItems( this.items, isInstant );
	
	  // flag for initalized
	  this._isLayoutInited = true;
	};
	
	// _init is alias for layout
	proto._init = proto.layout;
	
	/**
	 * logic before any new layout
	 */
	proto._resetLayout = function() {
	  this.getSize();
	};
	
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * get measurement from option, for columnWidth, rowHeight, gutter
	 * if option is String -> get element from selector string, & get size of element
	 * if option is Element -> get size of element
	 * else use option as a number
	 *
	 * @param {String} measurement
	 * @param {String} size - width or height
	 * @private
	 */
	proto._getMeasurement = function( measurement, size ) {
	  var option = this.options[ measurement ];
	  var elem;
	  if ( !option ) {
	    // default to 0
	    this[ measurement ] = 0;
	  } else {
	    // use option as an element
	    if ( typeof option == 'string' ) {
	      elem = this.element.querySelector( option );
	    } else if ( option instanceof HTMLElement ) {
	      elem = option;
	    }
	    // use size of element, if element
	    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
	  }
	};
	
	/**
	 * layout a collection of item elements
	 * @api public
	 */
	proto.layoutItems = function( items, isInstant ) {
	  items = this._getItemsForLayout( items );
	
	  this._layoutItems( items, isInstant );
	
	  this._postLayout();
	};
	
	/**
	 * get the items to be laid out
	 * you may want to skip over some items
	 * @param {Array} items
	 * @returns {Array} items
	 */
	proto._getItemsForLayout = function( items ) {
	  return items.filter( function( item ) {
	    return !item.isIgnored;
	  });
	};
	
	/**
	 * layout items
	 * @param {Array} items
	 * @param {Boolean} isInstant
	 */
	proto._layoutItems = function( items, isInstant ) {
	  this._emitCompleteOnItems( 'layout', items );
	
	  if ( !items || !items.length ) {
	    // no items, emit event with empty array
	    return;
	  }
	
	  var queue = [];
	
	  items.forEach( function( item ) {
	    // get x/y object from method
	    var position = this._getItemLayoutPosition( item );
	    // enqueue
	    position.item = item;
	    position.isInstant = isInstant || item.isLayoutInstant;
	    queue.push( position );
	  }, this );
	
	  this._processLayoutQueue( queue );
	};
	
	/**
	 * get item layout position
	 * @param {Outlayer.Item} item
	 * @returns {Object} x and y position
	 */
	proto._getItemLayoutPosition = function( /* item */ ) {
	  return {
	    x: 0,
	    y: 0
	  };
	};
	
	/**
	 * iterate over array and position each item
	 * Reason being - separating this logic prevents 'layout invalidation'
	 * thx @paul_irish
	 * @param {Array} queue
	 */
	proto._processLayoutQueue = function( queue ) {
	  this.updateStagger();
	  queue.forEach( function( obj, i ) {
	    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
	  }, this );
	};
	
	// set stagger from option in milliseconds number
	proto.updateStagger = function() {
	  var stagger = this.options.stagger;
	  if ( stagger === null || stagger === undefined ) {
	    this.stagger = 0;
	    return;
	  }
	  this.stagger = getMilliseconds( stagger );
	  return this.stagger;
	};
	
	/**
	 * Sets position of item in DOM
	 * @param {Outlayer.Item} item
	 * @param {Number} x - horizontal position
	 * @param {Number} y - vertical position
	 * @param {Boolean} isInstant - disables transitions
	 */
	proto._positionItem = function( item, x, y, isInstant, i ) {
	  if ( isInstant ) {
	    // if not transition, just set CSS
	    item.goTo( x, y );
	  } else {
	    item.stagger( i * this.stagger );
	    item.moveTo( x, y );
	  }
	};
	
	/**
	 * Any logic you want to do after each layout,
	 * i.e. size the container
	 */
	proto._postLayout = function() {
	  this.resizeContainer();
	};
	
	proto.resizeContainer = function() {
	  var isResizingContainer = this._getOption('resizeContainer');
	  if ( !isResizingContainer ) {
	    return;
	  }
	  var size = this._getContainerSize();
	  if ( size ) {
	    this._setContainerMeasure( size.width, true );
	    this._setContainerMeasure( size.height, false );
	  }
	};
	
	/**
	 * Sets width or height of container if returned
	 * @returns {Object} size
	 *   @param {Number} width
	 *   @param {Number} height
	 */
	proto._getContainerSize = noop;
	
	/**
	 * @param {Number} measure - size of width or height
	 * @param {Boolean} isWidth
	 */
	proto._setContainerMeasure = function( measure, isWidth ) {
	  if ( measure === undefined ) {
	    return;
	  }
	
	  var elemSize = this.size;
	  // add padding and border width if border box
	  if ( elemSize.isBorderBox ) {
	    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
	      elemSize.borderLeftWidth + elemSize.borderRightWidth :
	      elemSize.paddingBottom + elemSize.paddingTop +
	      elemSize.borderTopWidth + elemSize.borderBottomWidth;
	  }
	
	  measure = Math.max( measure, 0 );
	  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
	};
	
	/**
	 * emit eventComplete on a collection of items events
	 * @param {String} eventName
	 * @param {Array} items - Outlayer.Items
	 */
	proto._emitCompleteOnItems = function( eventName, items ) {
	  var _this = this;
	  function onComplete() {
	    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
	  }
	
	  var count = items.length;
	  if ( !items || !count ) {
	    onComplete();
	    return;
	  }
	
	  var doneCount = 0;
	  function tick() {
	    doneCount++;
	    if ( doneCount == count ) {
	      onComplete();
	    }
	  }
	
	  // bind callback
	  items.forEach( function( item ) {
	    item.once( eventName, tick );
	  });
	};
	
	/**
	 * emits events via EvEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	proto.dispatchEvent = function( type, event, args ) {
	  // add original event to arguments
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery ) {
	    // set this.$element
	    this.$element = this.$element || jQuery( this.element );
	    if ( event ) {
	      // create jQuery event
	      var $event = jQuery.Event( event );
	      $event.type = type;
	      this.$element.trigger( $event, args );
	    } else {
	      // just trigger with type if no event available
	      this.$element.trigger( type, args );
	    }
	  }
	};
	
	// -------------------------- ignore & stamps -------------------------- //
	
	
	/**
	 * keep item in collection, but do not lay it out
	 * ignored items do not get skipped in layout
	 * @param {Element} elem
	 */
	proto.ignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    item.isIgnored = true;
	  }
	};
	
	/**
	 * return item to layout collection
	 * @param {Element} elem
	 */
	proto.unignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    delete item.isIgnored;
	  }
	};
	
	/**
	 * adds elements to stamps
	 * @param {NodeList, Array, Element, or String} elems
	 */
	proto.stamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ) {
	    return;
	  }
	
	  this.stamps = this.stamps.concat( elems );
	  // ignore
	  elems.forEach( this.ignore, this );
	};
	
	/**
	 * removes elements to stamps
	 * @param {NodeList, Array, or Element} elems
	 */
	proto.unstamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ){
	    return;
	  }
	
	  elems.forEach( function( elem ) {
	    // filter out removed stamp elements
	    utils.removeFrom( this.stamps, elem );
	    this.unignore( elem );
	  }, this );
	};
	
	/**
	 * finds child elements
	 * @param {NodeList, Array, Element, or String} elems
	 * @returns {Array} elems
	 */
	proto._find = function( elems ) {
	  if ( !elems ) {
	    return;
	  }
	  // if string, use argument as selector string
	  if ( typeof elems == 'string' ) {
	    elems = this.element.querySelectorAll( elems );
	  }
	  elems = utils.makeArray( elems );
	  return elems;
	};
	
	proto._manageStamps = function() {
	  if ( !this.stamps || !this.stamps.length ) {
	    return;
	  }
	
	  this._getBoundingRect();
	
	  this.stamps.forEach( this._manageStamp, this );
	};
	
	// update boundingLeft / Top
	proto._getBoundingRect = function() {
	  // get bounding rect for container element
	  var boundingRect = this.element.getBoundingClientRect();
	  var size = this.size;
	  this._boundingRect = {
	    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
	    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
	    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
	    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
	  };
	};
	
	/**
	 * @param {Element} stamp
	**/
	proto._manageStamp = noop;
	
	/**
	 * get x/y position of element relative to container element
	 * @param {Element} elem
	 * @returns {Object} offset - has left, top, right, bottom
	 */
	proto._getElementOffset = function( elem ) {
	  var boundingRect = elem.getBoundingClientRect();
	  var thisRect = this._boundingRect;
	  var size = getSize( elem );
	  var offset = {
	    left: boundingRect.left - thisRect.left - size.marginLeft,
	    top: boundingRect.top - thisRect.top - size.marginTop,
	    right: thisRect.right - boundingRect.right - size.marginRight,
	    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
	  };
	  return offset;
	};
	
	// -------------------------- resize -------------------------- //
	
	// enable event handlers for listeners
	// i.e. resize -> onresize
	proto.handleEvent = utils.handleEvent;
	
	/**
	 * Bind layout to window resizing
	 */
	proto.bindResize = function() {
	  window.addEventListener( 'resize', this );
	  this.isResizeBound = true;
	};
	
	/**
	 * Unbind layout to window resizing
	 */
	proto.unbindResize = function() {
	  window.removeEventListener( 'resize', this );
	  this.isResizeBound = false;
	};
	
	proto.onresize = function() {
	  this.resize();
	};
	
	utils.debounceMethod( Outlayer, 'onresize', 100 );
	
	proto.resize = function() {
	  // don't trigger if size did not change
	  // or if resize was unbound. See #9
	  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
	    return;
	  }
	
	  this.layout();
	};
	
	/**
	 * check if layout is needed post layout
	 * @returns Boolean
	 */
	proto.needsResizeLayout = function() {
	  var size = getSize( this.element );
	  // check that this.size and size are there
	  // IE8 triggers resize on body size change, so they might not be
	  var hasSizes = this.size && size;
	  return hasSizes && size.innerWidth !== this.size.innerWidth;
	};
	
	// -------------------------- methods -------------------------- //
	
	/**
	 * add items to Outlayer instance
	 * @param {Array or NodeList or Element} elems
	 * @returns {Array} items - Outlayer.Items
	**/
	proto.addItems = function( elems ) {
	  var items = this._itemize( elems );
	  // add items to collection
	  if ( items.length ) {
	    this.items = this.items.concat( items );
	  }
	  return items;
	};
	
	/**
	 * Layout newly-appended item elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.appended = function( elems ) {
	  var items = this.addItems( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // layout and reveal just the new items
	  this.layoutItems( items, true );
	  this.reveal( items );
	};
	
	/**
	 * Layout prepended elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.prepended = function( elems ) {
	  var items = this._itemize( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // add items to beginning of collection
	  var previousItems = this.items.slice(0);
	  this.items = items.concat( previousItems );
	  // start new layout
	  this._resetLayout();
	  this._manageStamps();
	  // layout new stuff without transition
	  this.layoutItems( items, true );
	  this.reveal( items );
	  // layout previous items
	  this.layoutItems( previousItems );
	};
	
	/**
	 * reveal a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.reveal = function( items ) {
	  this._emitCompleteOnItems( 'reveal', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.reveal();
	  });
	};
	
	/**
	 * hide a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.hide = function( items ) {
	  this._emitCompleteOnItems( 'hide', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.hide();
	  });
	};
	
	/**
	 * reveal item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.revealItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.reveal( items );
	};
	
	/**
	 * hide item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.hideItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.hide( items );
	};
	
	/**
	 * get Outlayer.Item, given an Element
	 * @param {Element} elem
	 * @param {Function} callback
	 * @returns {Outlayer.Item} item
	 */
	proto.getItem = function( elem ) {
	  // loop through items to get the one that matches
	  for ( var i=0; i < this.items.length; i++ ) {
	    var item = this.items[i];
	    if ( item.element == elem ) {
	      // return item
	      return item;
	    }
	  }
	};
	
	/**
	 * get collection of Outlayer.Items, given Elements
	 * @param {Array} elems
	 * @returns {Array} items - Outlayer.Items
	 */
	proto.getItems = function( elems ) {
	  elems = utils.makeArray( elems );
	  var items = [];
	  elems.forEach( function( elem ) {
	    var item = this.getItem( elem );
	    if ( item ) {
	      items.push( item );
	    }
	  }, this );
	
	  return items;
	};
	
	/**
	 * remove element(s) from instance and DOM
	 * @param {Array or NodeList or Element} elems
	 */
	proto.remove = function( elems ) {
	  var removeItems = this.getItems( elems );
	
	  this._emitCompleteOnItems( 'remove', removeItems );
	
	  // bail if no items to remove
	  if ( !removeItems || !removeItems.length ) {
	    return;
	  }
	
	  removeItems.forEach( function( item ) {
	    item.remove();
	    // remove item from collection
	    utils.removeFrom( this.items, item );
	  }, this );
	};
	
	// ----- destroy ----- //
	
	// remove and disable Outlayer instance
	proto.destroy = function() {
	  // clean up dynamic styles
	  var style = this.element.style;
	  style.height = '';
	  style.position = '';
	  style.width = '';
	  // destroy items
	  this.items.forEach( function( item ) {
	    item.destroy();
	  });
	
	  this.unbindResize();
	
	  var id = this.element.outlayerGUID;
	  delete instances[ id ]; // remove reference to instance by id
	  delete this.element.outlayerGUID;
	  // remove data for jQuery
	  if ( jQuery ) {
	    jQuery.removeData( this.element, this.constructor.namespace );
	  }
	
	};
	
	// -------------------------- data -------------------------- //
	
	/**
	 * get Outlayer instance from element
	 * @param {Element} elem
	 * @returns {Outlayer}
	 */
	Outlayer.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.outlayerGUID;
	  return id && instances[ id ];
	};
	
	
	// -------------------------- create Outlayer class -------------------------- //
	
	/**
	 * create a layout class
	 * @param {String} namespace
	 */
	Outlayer.create = function( namespace, options ) {
	  // sub-class Outlayer
	  var Layout = subclass( Outlayer );
	  // apply new options and compatOptions
	  Layout.defaults = utils.extend( {}, Outlayer.defaults );
	  utils.extend( Layout.defaults, options );
	  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );
	
	  Layout.namespace = namespace;
	
	  Layout.data = Outlayer.data;
	
	  // sub-class Item
	  Layout.Item = subclass( Item );
	
	  // -------------------------- declarative -------------------------- //
	
	  utils.htmlInit( Layout, namespace );
	
	  // -------------------------- jQuery bridge -------------------------- //
	
	  // make into jQuery plugin
	  if ( jQuery && jQuery.bridget ) {
	    jQuery.bridget( namespace, Layout );
	  }
	
	  return Layout;
	};
	
	function subclass( Parent ) {
	  function SubClass() {
	    Parent.apply( this, arguments );
	  }
	
	  SubClass.prototype = Object.create( Parent.prototype );
	  SubClass.prototype.constructor = SubClass;
	
	  return SubClass;
	}
	
	// ----- helpers ----- //
	
	// how many milliseconds are in each unit
	var msUnits = {
	  ms: 1,
	  s: 1000
	};
	
	// munge time-like parameter into millisecond number
	// '0.4s' -> 40
	function getMilliseconds( time ) {
	  if ( typeof time == 'number' ) {
	    return time;
	  }
	  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
	  var num = matches && matches[1];
	  var unit = matches && matches[2];
	  if ( !num.length ) {
	    return 0;
	  }
	  num = parseFloat( num );
	  var mult = msUnits[ unit ] || 1;
	  return num * mult;
	}
	
	// ----- fin ----- //
	
	// back in global
	Outlayer.Item = Item;
	
	return Outlayer;
	
	}));


/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
	Papa Parse
	v5.4.1
	https://github.com/mholt/PapaParse
	License: MIT
	*/
	!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function s(){"use strict";var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=f.IS_PAPA_WORKER||!1,a={},u=0,b={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;J(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!J(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var i=function(){if(!b.WORKERS_SUPPORTED)return!1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),b.BLOB_URL||(b.BLOB_URL=r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ","(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=u++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=J(t.step),t.chunk=J(t.chunk),t.complete=J(t.complete),t.error=J(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?(e=function(e){if(65279===e.charCodeAt(0))return e.slice(1);return e}(e),n=t.download?new l(t):new p(t)):!0===e.readable&&J(e.read)&&J(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,r=!1,i=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");i=t.columns}void 0!==t.escapeChar&&(a=t.escapeChar+s);("boolean"==typeof t.escapeFormulae||t.escapeFormulae instanceof RegExp)&&(o=t.escapeFormulae instanceof RegExp?t.escapeFormulae:/^[=+\-@\t\r].*$/)}();var u=new RegExp(Q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,r);if("object"==typeof e[0])return h(i||Object.keys(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields||i),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y)}for(var o=0;o<t.length;o++){var u=n?e.length:t[o].length,h=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(h="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<u;l++){var c=s?e[l]:l;d.push(t[o][c])}h=""===d.join("").trim()}if(!h){for(var p=0;p<u;p++){0<p&&!f&&(i+=m);var g=n&&s?e[p]:p;i+=v(t[o][g],p)}o<t.length-1&&(!r||0<u&&!f)&&(i+=y)}}return i}function v(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);var r=!1;o&&"string"==typeof e&&o.test(e)&&(e="'"+e,r=!0);var i=e.toString().replace(u,a);return(r=r||!0===n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1))?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=r,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},u=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)u.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==u.length){var e,t,r,i,n=u[0];if(J(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(J(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void h();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void h()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){J(a)&&a(e,n.file,n.inputElem),h()},b.parse(n.file,n.instanceConfig)}else J(o.complete)&&o.complete()}function h(){u.splice(0,1),e()}}}function h(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&J(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(J(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!J(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0},this._sendError=function(e){J(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1})}}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),h.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)),i.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r)}try{i.send(this._config.downloadRequestBody)}catch(e){this._chunkError(e.message)}n&&0===i.status&&this._chunkError()}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:i.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),h.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function p(e){var r;h.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=r.substring(0,t),r=r.substring(t)):(e=r,r=""),this._finished=!r,this.parseChunk(e)}}}function g(e){h.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){h.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){h.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=v(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(m){var a,o,u,i=Math.pow(2,53),n=-i,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,h=/^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,t=this,r=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(J(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else{if(g(),0===c.data.length)return;r+=e.data.length,m.preview&&r>m.preview?o.abort():(c.data=c.data[0],p(c,t))}}}function y(e){return"greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){return c&&u&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),u=!1),m.skipEmptyLines&&(c.data=c.data.filter(function(e){return!y(e)})),_()&&function(){if(!c)return;function e(e,t){J(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e)}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1)}else c.data.forEach(e)}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var r,i=m.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];m.header&&(n=r>=l.length?"__parsed_extra":l[r]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s}return m.header&&(r>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+r,f+t):r<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+r,f+t)),i}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return r=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[r]&&(m.dynamicTyping[r]=m.dynamicTypingFunction(r)),!0===(m.dynamicTyping[r]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<i)return!0}return!1}(t)?parseFloat(t):h.test(t)?new Date(t):""===t?null:t):t;var r}function k(e,t,r,i){var n={type:e,code:t,message:r};void 0!==i&&(n.row=i),c.errors.push(n)}this.parse=function(e,t,r){var i=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(Q(t)+"([^]*?)"+Q(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),u=!1,m.delimiter)J(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else{var n=function(e,t,r,i,n){var s,a,o,u;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var h=0;h<n.length;h++){var f=n[h],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:i,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(r&&y(p.data[g]))c++;else{var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===u||u<l)&&1.99<l&&(a=d,s=f,u=l)}return{successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(u=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,r),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=J(m.chunk)?"":a.substring(o.getCharIndex())},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,J(m.complete)&&m.complete(c),a=""}}function Q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(j){var z,M=(j=j||{}).delimiter,P=j.newline,U=j.comments,q=j.step,N=j.preview,B=j.fastMode,K=z=void 0===j.quoteChar||null===j.quoteChar?'"':j.quoteChar;if(void 0!==j.escapeChar&&(K=j.escapeChar),("string"!=typeof M||-1<b.BAD_DELIMITERS.indexOf(M))&&(M=","),U===M)throw new Error("Comment character same as delimiter");!0===U?U="#":("string"!=typeof U||-1<b.BAD_DELIMITERS.indexOf(U))&&(U=!1),"\n"!==P&&"\r"!==P&&"\r\n"!==P&&(P="\n");var W=0,H=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw new Error("Input must be a string");var n=i.length,e=M.length,s=P.length,a=U.length,o=J(q),u=[],h=[],f=[],d=W=0;if(!i)return L();if(j.header&&!t){var l=i.split(P)[0].split(M),c=[],p={},g=!1;for(var _ in l){var m=l[_];J(j.transformHeader)&&(m=j.transformHeader(m,_));var y=m,v=p[m]||0;for(0<v&&(g=!0,y=m+"_"+v),p[m]=v+1;c.includes(y);)y=y+"_"+v;c.push(y)}if(g){var k=i.split(P);k[0]=c.join(M),i=k.join(P)}}if(B||!1!==B&&-1===i.indexOf(z)){for(var b=i.split(P),E=0;E<b.length;E++){if(f=b[E],W+=f.length,E!==b.length-1)W+=P.length;else if(r)return L();if(!U||f.substring(0,a)!==U){if(o){if(u=[],I(f.split(M)),F(),H)return L()}else I(f.split(M));if(N&&N<=E)return u=u.slice(0,N),L(!0)}}return L()}for(var w=i.indexOf(M,W),R=i.indexOf(P,W),C=new RegExp(Q(K)+Q(z),"g"),S=i.indexOf(z,W);;)if(i[W]!==z)if(U&&0===f.length&&i.substring(W,W+a)===U){if(-1===R)return L();W=R+s,R=i.indexOf(P,W),w=i.indexOf(M,W)}else if(-1!==w&&(w<R||-1===R))f.push(i.substring(W,w)),W=w+e,w=i.indexOf(M,W);else{if(-1===R)break;if(f.push(i.substring(W,R)),D(R+s),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0)}else for(S=W,W++;;){if(-1===(S=i.indexOf(z,S+1)))return r||h.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:u.length,index:W}),T();if(S===n-1)return T(i.substring(W,S).replace(C,z));if(z!==K||i[S+1]!==K){if(z===K||0===S||i[S-1]!==K){-1!==w&&w<S+1&&(w=i.indexOf(M,S+1)),-1!==R&&R<S+1&&(R=i.indexOf(P,S+1));var O=A(-1===R?w:Math.min(w,R));if(i.substr(S+1+O,e)===M){f.push(i.substring(W,S).replace(C,z)),i[W=S+1+O+e]!==z&&(S=i.indexOf(z,W)),w=i.indexOf(M,W),R=i.indexOf(P,W);break}var x=A(R);if(i.substring(S+1+x,S+1+x+s)===P){if(f.push(i.substring(W,S).replace(C,z)),D(S+1+x+s),w=i.indexOf(M,W),S=i.indexOf(z,W),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0);break}h.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:u.length,index:W}),S++}}else S++}return T();function I(e){u.push(e),d=W}function A(e){var t=0;if(-1!==e){var r=i.substring(S+1,e);r&&""===r.trim()&&(t=r.length)}return t}function T(e){return r||(void 0===e&&(e=i.substring(W)),f.push(e),W=n,I(f),o&&F()),L()}function D(e){W=e,I(f),f=[],R=i.indexOf(P,W)}function L(e){return{data:u,errors:h,meta:{delimiter:M,linebreak:P,aborted:H,truncated:!!e,cursor:d+(t||0)}}}function F(){q(L()),u=[],h=[]}},this.abort=function(){H=!0},this.getCharIndex=function(){return W}}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:y,resume:y};if(J(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else J(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&m(t.workerId,t.results)}function m(e,t){var r=a[e];J(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e]}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=w(e[r]);return t}function v(e,t){return function(){e.apply(t,arguments)}}function J(e){return"function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=b.parse(t.input,t.config);r&&f.postMessage({workerId:b.WORKER_ID,results:r,finished:!0})}}),(l.prototype=Object.create(h.prototype)).constructor=l,(c.prototype=Object.create(h.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(h.prototype)).constructor=g,b});

/***/ }),
/* 3550 */
/***/ (function(module, exports) {

	/**
	 * Expose `pathtoRegexp`.
	 */
	
	module.exports = pathtoRegexp;
	
	/**
	 * Match matching groups in a regular expression.
	 */
	var MATCHING_GROUP_REGEXP = /\((?!\?)/g;
	
	/**
	 * Normalize the given path string,
	 * returning a regular expression.
	 *
	 * An empty array should be passed,
	 * which will contain the placeholder
	 * key names. For example "/user/:id" will
	 * then contain ["id"].
	 *
	 * @param  {String|RegExp|Array} path
	 * @param  {Array} keys
	 * @param  {Object} options
	 * @return {RegExp}
	 * @api private
	 */
	
	function pathtoRegexp(path, keys, options) {
	  options = options || {};
	  keys = keys || [];
	  var strict = options.strict;
	  var end = options.end !== false;
	  var flags = options.sensitive ? '' : 'i';
	  var extraOffset = 0;
	  var keysOffset = keys.length;
	  var i = 0;
	  var name = 0;
	  var m;
	
	  if (path instanceof RegExp) {
	    while (m = MATCHING_GROUP_REGEXP.exec(path.source)) {
	      keys.push({
	        name: name++,
	        optional: false,
	        offset: m.index
	      });
	    }
	
	    return path;
	  }
	
	  if (Array.isArray(path)) {
	    // Map array parts into regexps and return their source. We also pass
	    // the same keys and options instance into every generation to get
	    // consistent matching groups before we join the sources together.
	    path = path.map(function (value) {
	      return pathtoRegexp(value, keys, options).source;
	    });
	
	    return new RegExp('(?:' + path.join('|') + ')', flags);
	  }
	
	  path = ('^' + path + (strict ? '' : path[path.length - 1] === '/' ? '?' : '/?'))
	    .replace(/\/\(/g, '/(?:')
	    .replace(/([\/\.])/g, '\\$1')
	    .replace(/(\\\/)?(\\\.)?:(\w+)(\(.*?\))?(\*)?(\?)?/g, function (match, slash, format, key, capture, star, optional, offset) {
	      slash = slash || '';
	      format = format || '';
	      capture = capture || '([^\\/' + format + ']+?)';
	      optional = optional || '';
	
	      keys.push({
	        name: key,
	        optional: !!optional,
	        offset: offset + extraOffset
	      });
	
	      var result = ''
	        + (optional ? '' : slash)
	        + '(?:'
	        + format + (optional ? slash : '') + capture
	        + (star ? '((?:[\\/' + format + '].+?)?)' : '')
	        + ')'
	        + optional;
	
	      extraOffset += result.length - match.length;
	
	      return result;
	    })
	    .replace(/\*/g, function (star, index) {
	      var len = keys.length
	
	      while (len-- > keysOffset && keys[len].offset > index) {
	        keys[len].offset += 3; // Replacement length minus asterisk length.
	      }
	
	      return '(.*)';
	    });
	
	  // This is a workaround for handling unnamed matching groups.
	  while (m = MATCHING_GROUP_REGEXP.exec(path)) {
	    var escapeCount = 0;
	    var index = m.index;
	
	    while (path.charAt(--index) === '\\') {
	      escapeCount++;
	    }
	
	    // It's possible to escape the bracket.
	    if (escapeCount % 2 === 1) {
	      continue;
	    }
	
	    if (keysOffset + i === keys.length || keys[keysOffset + i].offset > m.index) {
	      keys.splice(keysOffset + i, 0, {
	        name: name++, // Unnamed matching groups must be consistently linear.
	        optional: false,
	        offset: m.index
	      });
	    }
	
	    i++;
	  }
	
	  // If the path is non-ending, match until the end or a slash.
	  path += (end ? '$' : (path[path.length - 1] === '/' ? '' : '(?=\\/|$)'));
	
	  return new RegExp(path, flags);
	};


/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(621)))

/***/ }),
/* 3552 */
/***/ (function(module, exports) {

	var div = null
	var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]
	
	module.exports = function prefixStyle (prop) {
	  // re-use a dummy div
	  if (!div) {
	    div = document.createElement('div')
	  }
	
	  var style = div.style
	
	  // prop exists without prefix
	  if (prop in style) {
	    return prop
	  }
	
	  // borderRadius -> BorderRadius
	  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)
	
	  // find the vendor-prefixed prop
	  for (var i = prefixes.length; i >= 0; i--) {
	    var name = prefixes[i] + titleCase
	    // e.g. WebkitBorderRadius or webkitBorderRadius
	    if (name in style) {
	      return name
	    }
	  }
	
	  return false
	}


/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(3554);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 3554 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderViewDefault = renderViewDefault;
	exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
	exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
	exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
	exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/* eslint-disable react/prop-types */
	
	function renderViewDefault(props) {
	    return _react2["default"].createElement('div', props);
	}
	
	function renderTrackHorizontalDefault(_ref) {
	    var style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        left: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderTrackVerticalDefault(_ref2) {
	    var style = _ref2.style,
	        props = _objectWithoutProperties(_ref2, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        top: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbHorizontalDefault(_ref3) {
	    var style = _ref3.style,
	        props = _objectWithoutProperties(_ref3, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbVerticalDefault(_ref4) {
	    var style = _ref4.style,
	        props = _objectWithoutProperties(_ref4, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _raf2 = __webpack_require__(622);
	
	var _raf3 = _interopRequireDefault(_raf2);
	
	var _domCss = __webpack_require__(483);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	var _react = __webpack_require__(20);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isString = __webpack_require__(3561);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getScrollbarWidth = __webpack_require__(3560);
	
	var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
	
	var _returnFalse = __webpack_require__(3562);
	
	var _returnFalse2 = _interopRequireDefault(_returnFalse);
	
	var _getInnerWidth = __webpack_require__(3559);
	
	var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
	
	var _getInnerHeight = __webpack_require__(3558);
	
	var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
	
	var _styles = __webpack_require__(3557);
	
	var _defaultRenderElements = __webpack_require__(3555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollbars = function (_Component) {
	    _inherits(Scrollbars, _Component);
	
	    function Scrollbars(props) {
	        var _ref;
	
	        _classCallCheck(this, Scrollbars);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            rest[_key - 1] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));
	
	        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
	        _this.getScrollTop = _this.getScrollTop.bind(_this);
	        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
	        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
	        _this.getClientWidth = _this.getClientWidth.bind(_this);
	        _this.getClientHeight = _this.getClientHeight.bind(_this);
	        _this.getValues = _this.getValues.bind(_this);
	        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
	        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
	        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
	        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
	
	        _this.scrollLeft = _this.scrollLeft.bind(_this);
	        _this.scrollTop = _this.scrollTop.bind(_this);
	        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToRight = _this.scrollToRight.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	
	        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
	        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
	        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
	        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
	        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
	        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
	        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleDrag = _this.handleDrag.bind(_this);
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
	        _this.state = {
	            didMountUniversal: false
	        };
	        return _this;
	    }
	
	    _createClass(Scrollbars, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.addListeners();
	            this.update();
	            this.componentDidMountUniversal();
	        }
	    }, {
	        key: 'componentDidMountUniversal',
	        value: function componentDidMountUniversal() {
	            // eslint-disable-line react/sort-comp
	            var universal = this.props.universal;
	
	            if (!universal) return;
	            this.setState({ didMountUniversal: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.update();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeListeners();
	            (0, _raf2.cancel)(this.requestFrame);
	            clearTimeout(this.hideTracksTimeout);
	            clearInterval(this.detectScrollingInterval);
	        }
	    }, {
	        key: 'getScrollLeft',
	        value: function getScrollLeft() {
	            if (!this.view) return 0;
	            return this.view.scrollLeft;
	        }
	    }, {
	        key: 'getScrollTop',
	        value: function getScrollTop() {
	            if (!this.view) return 0;
	            return this.view.scrollTop;
	        }
	    }, {
	        key: 'getScrollWidth',
	        value: function getScrollWidth() {
	            if (!this.view) return 0;
	            return this.view.scrollWidth;
	        }
	    }, {
	        key: 'getScrollHeight',
	        value: function getScrollHeight() {
	            if (!this.view) return 0;
	            return this.view.scrollHeight;
	        }
	    }, {
	        key: 'getClientWidth',
	        value: function getClientWidth() {
	            if (!this.view) return 0;
	            return this.view.clientWidth;
	        }
	    }, {
	        key: 'getClientHeight',
	        value: function getClientHeight() {
	            if (!this.view) return 0;
	            return this.view.clientHeight;
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues() {
	            var _ref2 = this.view || {},
	                _ref2$scrollLeft = _ref2.scrollLeft,
	                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	                _ref2$scrollTop = _ref2.scrollTop,
	                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
	                _ref2$scrollWidth = _ref2.scrollWidth,
	                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
	                _ref2$scrollHeight = _ref2.scrollHeight,
	                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
	                _ref2$clientWidth = _ref2.clientWidth,
	                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
	                _ref2$clientHeight = _ref2.clientHeight,
	                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
	
	            return {
	                left: scrollLeft / (scrollWidth - clientWidth) || 0,
	                top: scrollTop / (scrollHeight - clientHeight) || 0,
	                scrollLeft: scrollLeft,
	                scrollTop: scrollTop,
	                scrollWidth: scrollWidth,
	                scrollHeight: scrollHeight,
	                clientWidth: clientWidth,
	                clientHeight: clientHeight
	            };
	        }
	    }, {
	        key: 'getThumbHorizontalWidth',
	        value: function getThumbHorizontalWidth() {
	            var _props = this.props,
	                thumbSize = _props.thumbSize,
	                thumbMinSize = _props.thumbMinSize;
	            var _view = this.view,
	                scrollWidth = _view.scrollWidth,
	                clientWidth = _view.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
	            if (trackWidth === width) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(width, thumbMinSize);
	        }
	    }, {
	        key: 'getThumbVerticalHeight',
	        value: function getThumbVerticalHeight() {
	            var _props2 = this.props,
	                thumbSize = _props2.thumbSize,
	                thumbMinSize = _props2.thumbMinSize;
	            var _view2 = this.view,
	                scrollHeight = _view2.scrollHeight,
	                clientHeight = _view2.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
	            if (trackHeight === height) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(height, thumbMinSize);
	        }
	    }, {
	        key: 'getScrollLeftForOffset',
	        value: function getScrollLeftForOffset(offset) {
	            var _view3 = this.view,
	                scrollWidth = _view3.scrollWidth,
	                clientWidth = _view3.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var thumbWidth = this.getThumbHorizontalWidth();
	            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
	        }
	    }, {
	        key: 'getScrollTopForOffset',
	        value: function getScrollTopForOffset(offset) {
	            var _view4 = this.view,
	                scrollHeight = _view4.scrollHeight,
	                clientHeight = _view4.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var thumbHeight = this.getThumbVerticalHeight();
	            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
	        }
	    }, {
	        key: 'scrollLeft',
	        value: function scrollLeft() {
	            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollLeft = left;
	        }
	    }, {
	        key: 'scrollTop',
	        value: function scrollTop() {
	            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollTop = top;
	        }
	    }, {
	        key: 'scrollToLeft',
	        value: function scrollToLeft() {
	            if (!this.view) return;
	            this.view.scrollLeft = 0;
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (!this.view) return;
	            this.view.scrollTop = 0;
	        }
	    }, {
	        key: 'scrollToRight',
	        value: function scrollToRight() {
	            if (!this.view) return;
	            this.view.scrollLeft = this.view.scrollWidth;
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            if (!this.view) return;
	            this.view.scrollTop = this.view.scrollHeight;
	        }
	    }, {
	        key: 'addListeners',
	        value: function addListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.addEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.addEventListener('resize', this.handleWindowResize);
	        }
	    }, {
	        key: 'removeListeners',
	        value: function removeListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.removeEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.removeEventListener('resize', this.handleWindowResize);
	            // Possibly setup by `handleDragStart`
	            this.teardownDragging();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(event) {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                onScroll = _props3.onScroll,
	                onScrollFrame = _props3.onScrollFrame;
	
	            if (onScroll) onScroll(event);
	            this.update(function (values) {
	                var scrollLeft = values.scrollLeft,
	                    scrollTop = values.scrollTop;
	
	                _this2.viewScrollLeft = scrollLeft;
	                _this2.viewScrollTop = scrollTop;
	                if (onScrollFrame) onScrollFrame(values);
	            });
	            this.detectScrolling();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart() {
	            var onScrollStart = this.props.onScrollStart;
	
	            if (onScrollStart) onScrollStart();
	            this.handleScrollStartAutoHide();
	        }
	    }, {
	        key: 'handleScrollStartAutoHide',
	        value: function handleScrollStartAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleScrollStop',
	        value: function handleScrollStop() {
	            var onScrollStop = this.props.onScrollStop;
	
	            if (onScrollStop) onScrollStop();
	            this.handleScrollStopAutoHide();
	        }
	    }, {
	        key: 'handleScrollStopAutoHide',
	        value: function handleScrollStopAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleWindowResize',
	        value: function handleWindowResize() {
	            this.update();
	        }
	    }, {
	        key: 'handleHorizontalTrackMouseDown',
	        value: function handleHorizontalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientX = event.clientX;
	
	            var _target$getBoundingCl = target.getBoundingClientRect(),
	                targetLeft = _target$getBoundingCl.left;
	
	            var thumbWidth = this.getThumbHorizontalWidth();
	            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
	            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	        }
	    }, {
	        key: 'handleVerticalTrackMouseDown',
	        value: function handleVerticalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientY = event.clientY;
	
	            var _target$getBoundingCl2 = target.getBoundingClientRect(),
	                targetTop = _target$getBoundingCl2.top;
	
	            var thumbHeight = this.getThumbVerticalHeight();
	            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
	            this.view.scrollTop = this.getScrollTopForOffset(offset);
	        }
	    }, {
	        key: 'handleHorizontalThumbMouseDown',
	        value: function handleHorizontalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientX = event.clientX;
	            var offsetWidth = target.offsetWidth;
	
	            var _target$getBoundingCl3 = target.getBoundingClientRect(),
	                left = _target$getBoundingCl3.left;
	
	            this.prevPageX = offsetWidth - (clientX - left);
	        }
	    }, {
	        key: 'handleVerticalThumbMouseDown',
	        value: function handleVerticalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientY = event.clientY;
	            var offsetHeight = target.offsetHeight;
	
	            var _target$getBoundingCl4 = target.getBoundingClientRect(),
	                top = _target$getBoundingCl4.top;
	
	            this.prevPageY = offsetHeight - (clientY - top);
	        }
	    }, {
	        key: 'setupDragging',
	        value: function setupDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
	            document.addEventListener('mousemove', this.handleDrag);
	            document.addEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = _returnFalse2["default"];
	        }
	    }, {
	        key: 'teardownDragging',
	        value: function teardownDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
	            document.removeEventListener('mousemove', this.handleDrag);
	            document.removeEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = undefined;
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(event) {
	            this.dragging = true;
	            event.stopImmediatePropagation();
	            this.setupDragging();
	        }
	    }, {
	        key: 'handleDrag',
	        value: function handleDrag(event) {
	            if (this.prevPageX) {
	                var clientX = event.clientX;
	
	                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
	                    trackLeft = _trackHorizontal$getB.left;
	
	                var thumbWidth = this.getThumbHorizontalWidth();
	                var clickPosition = thumbWidth - this.prevPageX;
	                var offset = -trackLeft + clientX - clickPosition;
	                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	            }
	            if (this.prevPageY) {
	                var clientY = event.clientY;
	
	                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
	                    trackTop = _trackVertical$getBou.top;
	
	                var thumbHeight = this.getThumbVerticalHeight();
	                var _clickPosition = thumbHeight - this.prevPageY;
	                var _offset = -trackTop + clientY - _clickPosition;
	                this.view.scrollTop = this.getScrollTopForOffset(_offset);
	            }
	            return false;
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd() {
	            this.dragging = false;
	            this.prevPageX = this.prevPageY = 0;
	            this.teardownDragging();
	            this.handleDragEndAutoHide();
	        }
	    }, {
	        key: 'handleDragEndAutoHide',
	        value: function handleDragEndAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleTrackMouseEnter',
	        value: function handleTrackMouseEnter() {
	            this.trackMouseOver = true;
	            this.handleTrackMouseEnterAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseEnterAutoHide',
	        value: function handleTrackMouseEnterAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleTrackMouseLeave',
	        value: function handleTrackMouseLeave() {
	            this.trackMouseOver = false;
	            this.handleTrackMouseLeaveAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseLeaveAutoHide',
	        value: function handleTrackMouseLeaveAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'showTracks',
	        value: function showTracks() {
	            clearTimeout(this.hideTracksTimeout);
	            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
	            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
	        }
	    }, {
	        key: 'hideTracks',
	        value: function hideTracks() {
	            var _this3 = this;
	
	            if (this.dragging) return;
	            if (this.scrolling) return;
	            if (this.trackMouseOver) return;
	            var autoHideTimeout = this.props.autoHideTimeout;
	
	            clearTimeout(this.hideTracksTimeout);
	            this.hideTracksTimeout = setTimeout(function () {
	                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
	                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
	            }, autoHideTimeout);
	        }
	    }, {
	        key: 'detectScrolling',
	        value: function detectScrolling() {
	            var _this4 = this;
	
	            if (this.scrolling) return;
	            this.scrolling = true;
	            this.handleScrollStart();
	            this.detectScrollingInterval = setInterval(function () {
	                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
	                    clearInterval(_this4.detectScrollingInterval);
	                    _this4.scrolling = false;
	                    _this4.handleScrollStop();
	                }
	                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
	                _this4.lastViewScrollTop = _this4.viewScrollTop;
	            }, 100);
	        }
	    }, {
	        key: 'raf',
	        value: function raf(callback) {
	            var _this5 = this;
	
	            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
	            this.requestFrame = (0, _raf3["default"])(function () {
	                _this5.requestFrame = undefined;
	                callback();
	            });
	        }
	    }, {
	        key: 'update',
	        value: function update(callback) {
	            var _this6 = this;
	
	            this.raf(function () {
	                return _this6._update(callback);
	            });
	        }
	    }, {
	        key: '_update',
	        value: function _update(callback) {
	            var _props4 = this.props,
	                onUpdate = _props4.onUpdate,
	                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
	
	            var values = this.getValues();
	            if ((0, _getScrollbarWidth2["default"])()) {
	                var scrollLeft = values.scrollLeft,
	                    clientWidth = values.clientWidth,
	                    scrollWidth = values.scrollWidth;
	
	                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
	                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
	                var thumbHorizontalStyle = {
	                    width: thumbHorizontalWidth,
	                    transform: 'translateX(' + thumbHorizontalX + 'px)'
	                };
	                var scrollTop = values.scrollTop,
	                    clientHeight = values.clientHeight,
	                    scrollHeight = values.scrollHeight;
	
	                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	                var thumbVerticalHeight = this.getThumbVerticalHeight();
	                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
	                var thumbVerticalStyle = {
	                    height: thumbVerticalHeight,
	                    transform: 'translateY(' + thumbVerticalY + 'px)'
	                };
	                if (hideTracksWhenNotNeeded) {
	                    var trackHorizontalStyle = {
	                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
	                    };
	                    var trackVerticalStyle = {
	                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
	                    };
	                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
	                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
	                }
	                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
	                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
	            }
	            if (onUpdate) onUpdate(values);
	            if (typeof callback !== 'function') return;
	            callback(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
	            /* eslint-disable no-unused-vars */
	
	            var _props5 = this.props,
	                onScroll = _props5.onScroll,
	                onScrollFrame = _props5.onScrollFrame,
	                onScrollStart = _props5.onScrollStart,
	                onScrollStop = _props5.onScrollStop,
	                onUpdate = _props5.onUpdate,
	                renderView = _props5.renderView,
	                renderTrackHorizontal = _props5.renderTrackHorizontal,
	                renderTrackVertical = _props5.renderTrackVertical,
	                renderThumbHorizontal = _props5.renderThumbHorizontal,
	                renderThumbVertical = _props5.renderThumbVertical,
	                tagName = _props5.tagName,
	                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
	                autoHide = _props5.autoHide,
	                autoHideTimeout = _props5.autoHideTimeout,
	                autoHideDuration = _props5.autoHideDuration,
	                thumbSize = _props5.thumbSize,
	                thumbMinSize = _props5.thumbMinSize,
	                universal = _props5.universal,
	                autoHeight = _props5.autoHeight,
	                autoHeightMin = _props5.autoHeightMin,
	                autoHeightMax = _props5.autoHeightMax,
	                style = _props5.style,
	                children = _props5.children,
	                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
	            /* eslint-enable no-unused-vars */
	
	            var didMountUniversal = this.state.didMountUniversal;
	
	
	            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }), style);
	
	            var viewStyle = _extends({}, _styles.viewStyleDefault, {
	                // Hide scrollbars by setting a negative margin
	                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
	                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
	            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
	                // Add scrollbarWidth to autoHeight in order to compensate negative margins
	                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
	                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
	            }), autoHeight && universal && !didMountUniversal && {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
	
	            var trackAutoHeightStyle = {
	                transition: 'opacity ' + autoHideDuration + 'ms',
	                opacity: 0
	            };
	
	            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
	                    _this7.container = _ref3;
	                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
	                    _this7.view = _ref4;
	                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
	                    _this7.trackHorizontal = _ref5;
	                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
	                    _this7.thumbHorizontal = _ref6;
	                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
	                    _this7.trackVertical = _ref7;
	                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
	                    _this7.thumbVertical = _ref8;
	                } }))]);
	        }
	    }]);
	
	    return Scrollbars;
	}(_react.Component);
	
	exports["default"] = Scrollbars;
	
	
	Scrollbars.propTypes = {
	    onScroll: _propTypes2["default"].func,
	    onScrollFrame: _propTypes2["default"].func,
	    onScrollStart: _propTypes2["default"].func,
	    onScrollStop: _propTypes2["default"].func,
	    onUpdate: _propTypes2["default"].func,
	    renderView: _propTypes2["default"].func,
	    renderTrackHorizontal: _propTypes2["default"].func,
	    renderTrackVertical: _propTypes2["default"].func,
	    renderThumbHorizontal: _propTypes2["default"].func,
	    renderThumbVertical: _propTypes2["default"].func,
	    tagName: _propTypes2["default"].string,
	    thumbSize: _propTypes2["default"].number,
	    thumbMinSize: _propTypes2["default"].number,
	    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
	    autoHide: _propTypes2["default"].bool,
	    autoHideTimeout: _propTypes2["default"].number,
	    autoHideDuration: _propTypes2["default"].number,
	    autoHeight: _propTypes2["default"].bool,
	    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    universal: _propTypes2["default"].bool,
	    style: _propTypes2["default"].object,
	    children: _propTypes2["default"].node
	};
	
	Scrollbars.defaultProps = {
	    renderView: _defaultRenderElements.renderViewDefault,
	    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
	    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
	    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
	    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
	    tagName: 'div',
	    thumbMinSize: 30,
	    hideTracksWhenNotNeeded: false,
	    autoHide: false,
	    autoHideTimeout: 1000,
	    autoHideDuration: 200,
	    autoHeight: false,
	    autoHeightMin: 0,
	    autoHeightMax: 200,
	    universal: false
	};

/***/ }),
/* 3557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var containerStyleDefault = exports.containerStyleDefault = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '100%'
	};
	
	// Overrides containerStyleDefault properties
	var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
	    height: 'auto'
	};
	
	var viewStyleDefault = exports.viewStyleDefault = {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'scroll',
	    WebkitOverflowScrolling: 'touch'
	};
	
	// Overrides viewStyleDefault properties
	var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
	    position: 'relative',
	    top: undefined,
	    left: undefined,
	    right: undefined,
	    bottom: undefined
	};
	
	var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
	    overflow: 'hidden',
	    marginRight: 0,
	    marginBottom: 0
	};
	
	var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
	    position: 'absolute',
	    height: 6
	};
	
	var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
	    position: 'absolute',
	    width: 6
	};
	
	var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    height: '100%'
	};
	
	var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    width: '100%'
	};
	
	var disableSelectStyle = exports.disableSelectStyle = {
	    userSelect: 'none'
	};
	
	var disableSelectStyleReset = exports.disableSelectStyleReset = {
	    userSelect: ''
	};

/***/ }),
/* 3558 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerHeight;
	function getInnerHeight(el) {
	    var clientHeight = el.clientHeight;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingTop = _getComputedStyle.paddingTop,
	        paddingBottom = _getComputedStyle.paddingBottom;
	
	    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
	}

/***/ }),
/* 3559 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerWidth;
	function getInnerWidth(el) {
	    var clientWidth = el.clientWidth;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingLeft = _getComputedStyle.paddingLeft,
	        paddingRight = _getComputedStyle.paddingRight;
	
	    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
	}

/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getScrollbarWidth;
	
	var _domCss = __webpack_require__(483);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var scrollbarWidth = false;
	
	function getScrollbarWidth() {
	    if (scrollbarWidth !== false) return scrollbarWidth;
	    /* istanbul ignore else */
	    if (typeof document !== 'undefined') {
	        var div = document.createElement('div');
	        (0, _domCss2["default"])(div, {
	            width: 100,
	            height: 100,
	            position: 'absolute',
	            top: -9999,
	            overflow: 'scroll',
	            MsOverflowStyle: 'scrollbar'
	        });
	        document.body.appendChild(div);
	        scrollbarWidth = div.offsetWidth - div.clientWidth;
	        document.body.removeChild(div);
	    } else {
	        scrollbarWidth = 0;
	    }
	    return scrollbarWidth || 0;
	}

/***/ }),
/* 3561 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = isString;
	function isString(maybe) {
	    return typeof maybe === 'string';
	}

/***/ }),
/* 3562 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = returnFalse;
	function returnFalse() {
	    return false;
	}

/***/ }),
/* 3563 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(20),n=__webpack_require__(343),r=__webpack_require__(3613);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(151);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(344);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ }),
/* 3565 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ }),
/* 3566 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ }),
/* 3567 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(625);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(344);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(625);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(3567);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(626);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ }),
/* 3570 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ }),
/* 3571 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(151);
	
	var _TextElementType = __webpack_require__(3570);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(3569);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(3568);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(3571);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(344);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(624);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(151);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(3564);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(3565);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(3566);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(626);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ }),
/* 3575 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ }),
/* 3576 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 3578 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(20),reactDom=__webpack_require__(98);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = {};
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions.passive = !instance.props.preventDefault;
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	var _interopRequireWildcard = __webpack_require__(357)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	var _Context = __webpack_require__(136);
	
	var _Subscription = __webpack_require__(346);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(347);
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = (0, _Subscription.createSubscription)(store);
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(225));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(226));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(628));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(633));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(3582));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(3583));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(3584));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(3585));
	
	var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _bindActionCreators = _interopRequireDefault(__webpack_require__(3590));
	
	var _wrapMapToProps = __webpack_require__(629);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ }),
/* 3583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(629);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = void 0;
	exports.defaultMergeProps = defaultMergeProps;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(225));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(634));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = finalPropsSelectorFactory;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(226));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(3586));
	
	var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 3586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(635));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(63)["default"];
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(3580));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(628));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(136);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(3581));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(3588);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(3589);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(631);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(633));
	
	exports.shallowEqual = _shallowEqual["default"];

/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(136);
	
	var _useStore = __webpack_require__(631);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(20);
	
	var _useReduxContext2 = __webpack_require__(630);
	
	var _Subscription = __webpack_require__(346);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(347);
	
	var _Context = __webpack_require__(136);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return (0, _Subscription.createSubscription)(store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
	
	      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
	        selectedState = newSelectedState;
	      } else {
	        selectedState = latestSelectedState.current;
	      }
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
	
	        if (newStoreState === latestStoreState.current) {
	          return;
	        }
	
	        var _newSelectedState = latestSelector.current(newStoreState);
	
	        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = _newSelectedState;
	        latestStoreState.current = newStoreState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      if (!selector) {
	        throw new Error("You must pass a selector to useSelector");
	      }
	
	      if (typeof selector !== 'function') {
	        throw new Error("You must pass a function as a selector to useSelector");
	      }
	
	      if (typeof equalityFn !== 'function') {
	        throw new Error("You must pass a function as an equality function to useSelector");
	      }
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ }),
/* 3590 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	
	function bindActionCreators(actionCreators, dispatch) {
	  var boundActionCreators = {};
	
	  var _loop = function _loop(key) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = function () {
	        return dispatch(actionCreator.apply(void 0, arguments));
	      };
	    }
	  };
	
	  for (var key in actionCreators) {
	    _loop(key);
	  }
	
	  return boundActionCreators;
	}

/***/ }),
/* 3591 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(98);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ }),
/* 3593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(153),React=_interopDefault(__webpack_require__(20)),history=__webpack_require__(605);__webpack_require__(43),__webpack_require__(352);var invariant=_interopDefault(__webpack_require__(351));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ }),
/* 3594 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(20)),PropTypes=_interopDefault(__webpack_require__(43)),history=__webpack_require__(605);__webpack_require__(352);var invariant=_interopDefault(__webpack_require__(351)),pathToRegexp=_interopDefault(__webpack_require__(3550));__webpack_require__(345);var hoistStatics=_interopDefault(__webpack_require__(606));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(636);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(637);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(222);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 3596 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 3597 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 3598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(622);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_PureComponent) {
	  _inherits(Container, _PureComponent);
	
	  function Container() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Container);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"], _this.subscribers = [], _this.rafHandle = null, _this.subscribe = function (handler) {
	      _this.subscribers = _this.subscribers.concat(handler);
	    }, _this.unsubscribe = function (handler) {
	      _this.subscribers = _this.subscribers.filter(function (current) {
	        return current !== handler;
	      });
	    }, _this.notifySubscribers = function (evt) {
	      if (!_this.framePending) {
	        var currentTarget = evt.currentTarget;
	
	
	        _this.rafHandle = (0, _raf2.default)(function () {
	          _this.framePending = false;
	
	          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	              top = _this$node$getBoundin.top,
	              bottom = _this$node$getBoundin.bottom;
	
	          _this.subscribers.forEach(function (handler) {
	            return handler({
	              distanceFromTop: top,
	              distanceFromBottom: bottom,
	              eventSource: currentTarget === window ? document.body : _this.node
	            });
	          });
	        });
	        _this.framePending = true;
	      }
	    }, _this.getParent = function () {
	      return _this.node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Container, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        subscribe: this.subscribe,
	        unsubscribe: this.unsubscribe,
	        getParent: this.getParent
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.events.forEach(function (event) {
	        return window.addEventListener(event, _this2.notifySubscribers);
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (this.rafHandle) {
	        _raf2.default.cancel(this.rafHandle);
	        this.rafHandle = null;
	      }
	
	      this.events.forEach(function (event) {
	        return window.removeEventListener(event, _this3.notifySubscribers);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement("div", _extends({}, this.props, {
	        ref: function ref(node) {
	          return _this4.node = node;
	        },
	        onScroll: this.notifySubscribers,
	        onTouchStart: this.notifySubscribers,
	        onTouchMove: this.notifySubscribers,
	        onTouchEnd: this.notifySubscribers
	      }));
	    }
	  }]);
	
	  return Container;
	}(_react.PureComponent);
	
	Container.childContextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Container;

/***/ }),
/* 3599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(20);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(98);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(43);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSticky: false,
	      wasSticky: false,
	      style: {}
	    }, _this.handleContainerEvent = function (_ref2) {
	      var distanceFromTop = _ref2.distanceFromTop,
	          distanceFromBottom = _ref2.distanceFromBottom,
	          eventSource = _ref2.eventSource;
	
	      var parent = _this.context.getParent();
	
	      var preventingStickyStateChanges = false;
	      if (_this.props.relative) {
	        preventingStickyStateChanges = eventSource !== parent;
	        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
	      }
	
	      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
	      var contentClientRect = _this.content.getBoundingClientRect();
	      var calculatedHeight = contentClientRect.height;
	
	      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
	
	      var wasSticky = !!_this.state.isSticky;
	      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
	
	      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	      var style = !isSticky ? {} : {
	        position: "fixed",
	        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
	        left: placeholderClientRect.left,
	        width: placeholderClientRect.width
	      };
	
	      if (!_this.props.disableHardwareAcceleration) {
	        style.transform = "translateZ(0)";
	      }
	
	      _this.setState({
	        isSticky: isSticky,
	        wasSticky: wasSticky,
	        distanceFromTop: distanceFromTop,
	        distanceFromBottom: distanceFromBottom,
	        calculatedHeight: calculatedHeight,
	        style: style
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sticky, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	      this.context.subscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.unsubscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + "px";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var element = _react2.default.cloneElement(this.props.children({
	        isSticky: this.state.isSticky,
	        wasSticky: this.state.wasSticky,
	        distanceFromTop: this.state.distanceFromTop,
	        distanceFromBottom: this.state.distanceFromBottom,
	        calculatedHeight: this.state.calculatedHeight,
	        style: this.state.style
	      }), {
	        ref: function ref(content) {
	          _this2.content = _reactDom2.default.findDOMNode(content);
	        }
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("div", { ref: function ref(placeholder) {
	            return _this2.placeholder = placeholder;
	          } }),
	        element
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.propTypes = {
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  relative: _propTypes2.default.bool,
	  children: _propTypes2.default.func.isRequired
	};
	Sticky.defaultProps = {
	  relative: false,
	  topOffset: 0,
	  bottomOffset: 0,
	  disableCompensation: false,
	  disableHardwareAcceleration: false
	};
	Sticky.contextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Sticky;

/***/ }),
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyContainer = exports.Sticky = undefined;
	
	var _Sticky = __webpack_require__(3599);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	var _Container = __webpack_require__(3598);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _Sticky2.default;
	exports.StickyContainer = _Container2.default;
	exports.default = _Sticky2.default;

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(20),__webpack_require__(98)):"function"==typeof define&&define.amd?define("lib",["react","react-dom"],t):"object"==typeof exports?exports.lib=t(require("react"),require("react-dom")):e.lib=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,(function(e,t){return function(){"use strict";var n={655:function(e,t,n){n.r(t),n.d(t,{__assign:function(){return i},__asyncDelegator:function(){return _},__asyncGenerator:function(){return w},__asyncValues:function(){return P},__await:function(){return m},__awaiter:function(){return s},__classPrivateFieldGet:function(){return j},__classPrivateFieldIn:function(){return A},__classPrivateFieldSet:function(){return T},__createBinding:function(){return d},__decorate:function(){return c},__exportStar:function(){return p},__extends:function(){return o},__generator:function(){return f},__importDefault:function(){return E},__importStar:function(){return x},__makeTemplateObject:function(){return O},__metadata:function(){return u},__param:function(){return l},__read:function(){return y},__rest:function(){return a},__spread:function(){return g},__spreadArray:function(){return v},__spreadArrays:function(){return b},__values:function(){return h}});var r=function(e,t){return r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},r(e,t)};function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var i=function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},i.apply(this,arguments)};function a(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}function c(e,t,n,r){var o,i=arguments.length,a=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,r);else for(var c=e.length-1;c>=0;c--)(o=e[c])&&(a=(i<3?o(a):i>3?o(t,n,a):o(t,n))||a);return i>3&&a&&Object.defineProperty(t,n,a),a}function l(e,t){return function(n,r){t(n,r,e)}}function u(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function s(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{l(r.next(e))}catch(e){i(e)}}function c(e){try{l(r.throw(e))}catch(e){i(e)}}function l(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,c)}l((r=r.apply(e,t||[])).next())}))}function f(e,t){var n,r,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(c){return function(l){return function(c){if(n)throw new TypeError("Generator is already executing.");for(;i&&(i=0,c[0]&&(a=0)),a;)try{if(n=1,r&&(o=2&c[0]?r.return:c[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,c[1])).done)return o;switch(r=0,o&&(c=[2&c[0],o.value]),c[0]){case 0:case 1:o=c;break;case 4:return a.label++,{value:c[1],done:!1};case 5:a.label++,r=c[1],c=[0];continue;case 7:c=a.ops.pop(),a.trys.pop();continue;default:if(!((o=(o=a.trys).length>0&&o[o.length-1])||6!==c[0]&&2!==c[0])){a=0;continue}if(3===c[0]&&(!o||c[1]>o[0]&&c[1]<o[3])){a.label=c[1];break}if(6===c[0]&&a.label<o[1]){a.label=o[1],o=c;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(c);break}o[2]&&a.ops.pop(),a.trys.pop();continue}c=t.call(e,a)}catch(e){c=[6,e],r=0}finally{n=o=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,l])}}}var d=Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]};function p(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||d(t,e,n)}function h(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function y(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(r=i.next()).done;)a.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function g(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(y(arguments[t]));return e}function b(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],a=0,c=i.length;a<c;a++,o++)r[o]=i[a];return r}function v(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}function m(e){return this instanceof m?(this.v=e,this):new m(e)}function w(e,t,n){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var r,o=n.apply(e,t||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){return this},r;function a(e){o[e]&&(r[e]=function(t){return new Promise((function(n,r){i.push([e,t,n,r])>1||c(e,t)}))})}function c(e,t){try{(n=o[e](t)).value instanceof m?Promise.resolve(n.value.v).then(l,u):s(i[0][2],n)}catch(e){s(i[0][3],e)}var n}function l(e){c("next",e)}function u(e){c("throw",e)}function s(e,t){e(t),i.shift(),i.length&&c(i[0][0],i[0][1])}}function _(e){var t,n;return t={},r("next"),r("throw",(function(e){throw e})),r("return"),t[Symbol.iterator]=function(){return this},t;function r(r,o){t[r]=e[r]?function(t){return(n=!n)?{value:m(e[r](t)),done:"return"===r}:o?o(t):t}:o}}function P(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var t,n=e[Symbol.asyncIterator];return n?n.call(e):(e=h(e),t={},r("next"),r("throw"),r("return"),t[Symbol.asyncIterator]=function(){return this},t);function r(n){t[n]=e[n]&&function(t){return new Promise((function(r,o){!function(e,t,n,r){Promise.resolve(r).then((function(t){e({value:t,done:n})}),t)}(r,o,(t=e[n](t)).done,t.value)}))}}}function O(e,t){return Object.defineProperty?Object.defineProperty(e,"raw",{value:t}):e.raw=t,e}var S=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t};function x(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&d(t,e,n);return S(t,e),t}function E(e){return e&&e.__esModule?e:{default:e}}function j(e,t,n,r){if("a"===n&&!r)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof t?e!==t||!r:!t.has(e))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===n?r:"a"===n?r.call(e):r?r.value:t.get(e)}function T(e,t,n,r,o){if("m"===r)throw new TypeError("Private method is not writable");if("a"===r&&!o)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof t?e!==t||!o:!t.has(e))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===r?o.call(e,n):o?o.value=n:t.set(e,n),n}function A(e,t){if(null===t||"object"!=typeof t&&"function"!=typeof t)throw new TypeError("Cannot use 'in' operator on non-object");return"function"==typeof e?t===e:e.has(t)}},156:function(t){t.exports=e},111:function(e){e.exports=t}},r={};function o(e){var t=r[e];if(void 0!==t)return t.exports;var i=r[e]={exports:{}};return n[e](i,i.exports,o),i.exports}o.d=function(e,t){for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var i={};return function(){var e=i;Object.defineProperty(e,"__esModule",{value:!0}),e.useReactToPrint=e.PrintContextConsumer=void 0;var t=o(655),n=o(156),r=o(111),a=Object.prototype.hasOwnProperty.call(n,"createContext"),c=Object.prototype.hasOwnProperty.call(n,"useMemo")&&Object.prototype.hasOwnProperty.call(n,"useCallback"),l=a?n.createContext({}):null;e.PrintContextConsumer=l?l.Consumer:function(){return null};var u={copyStyles:!0,pageStyle:"\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",removeAfterPrint:!1,suppressErrors:!1},s=function(e){function o(){var n=null!==e&&e.apply(this,arguments)||this;return n.startPrint=function(e){var t=n.props,r=t.onAfterPrint,o=t.onPrintError,i=t.print,a=t.documentTitle;setTimeout((function(){var t,c;if(e.contentWindow){if(e.contentWindow.focus(),i)i(e).then(n.handleRemoveIframe).catch((function(e){o?o("print",e):n.logMessages(["An error was thrown by the specified `print` function"])}));else if(e.contentWindow.print){var l=null!==(c=null===(t=e.contentDocument)||void 0===t?void 0:t.title)&&void 0!==c?c:"",u=e.ownerDocument.title;a&&(e.ownerDocument.title=a,e.contentDocument&&(e.contentDocument.title=a)),e.contentWindow.print(),a&&(e.ownerDocument.title=u,e.contentDocument&&(e.contentDocument.title=l))}else n.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);r&&r(),n.handleRemoveIframe()}else n.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"])}),500)},n.triggerPrint=function(e){var t=n.props,r=t.onBeforePrint,o=t.onPrintError;if(r){var i=r();i&&"function"==typeof i.then?i.then((function(){n.startPrint(e)})).catch((function(e){o&&o("onBeforePrint",e)})):n.startPrint(e)}else n.startPrint(e)},n.handleClick=function(){var e=n.props,t=e.onBeforeGetContent,r=e.onPrintError;if(t){var o=t();o&&"function"==typeof o.then?o.then(n.handlePrint).catch((function(e){r&&r("onBeforeGetContent",e)})):n.handlePrint()}else n.handlePrint()},n.handlePrint=function(){var e=n.props,o=e.bodyClass,i=e.content,a=e.copyStyles,c=e.fonts,l=e.pageStyle,u=e.nonce,s=i();if(void 0!==s)if(null!==s){var f=document.createElement("iframe");f.width="".concat(document.documentElement.clientWidth,"px"),f.height="".concat(document.documentElement.clientHeight,"px"),f.style.position="absolute",f.style.top="-".concat(document.documentElement.clientHeight+100,"px"),f.style.left="-".concat(document.documentElement.clientWidth+100,"px"),f.id="printWindow",f.srcdoc="<!DOCTYPE html>";var d=(0,r.findDOMNode)(s);if(d){var p=d.cloneNode(!0),h=p instanceof Text,y=document.querySelectorAll("link[rel='stylesheet']"),g=h?[]:p.querySelectorAll("img"),b=h?[]:p.querySelectorAll("video"),v=c?c.length:0;n.numResourcesToLoad=y.length+g.length+b.length+v,n.resourcesLoaded=[],n.resourcesErrored=[];var m=function(e,r){n.resourcesLoaded.includes(e)?n.logMessages(["Tried to mark a resource that has already been handled",e],"debug"):(r?(n.logMessages(t.__spreadArray(['"react-to-print" was unable to load a resource but will continue attempting to print the page'],t.__read(r),!1)),n.resourcesErrored.push(e)):n.resourcesLoaded.push(e),n.resourcesLoaded.length+n.resourcesErrored.length===n.numResourcesToLoad&&n.triggerPrint(f))};f.onload=function(){var e,r,i,s;f.onload=null;var y=f.contentDocument||(null===(r=f.contentWindow)||void 0===r?void 0:r.document);if(y){y.body.appendChild(p),c&&((null===(i=f.contentDocument)||void 0===i?void 0:i.fonts)&&(null===(s=f.contentWindow)||void 0===s?void 0:s.FontFace)?c.forEach((function(e){var t=new FontFace(e.family,e.source);f.contentDocument.fonts.add(t),t.loaded.then((function(){m(t)})).catch((function(e){m(t,["Failed loading the font:",t,"Load error:",e])}))})):(c.forEach((function(e){return m(e)})),n.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'])));var v="function"==typeof l?l():l;if("string"!=typeof v)n.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof v,'". Styles from `pageStyle` will not be applied.')]);else{var w=y.createElement("style");u&&(w.setAttribute("nonce",u),y.head.setAttribute("nonce",u)),w.appendChild(y.createTextNode(v)),y.head.appendChild(w)}if(o&&(e=y.body.classList).add.apply(e,t.__spreadArray([],t.__read(o.split(" ")),!1)),!h){for(var _=h?[]:d.querySelectorAll("canvas"),P=y.querySelectorAll("canvas"),O=0;O<_.length;++O){var S=_[O],x=P[O].getContext("2d");x&&x.drawImage(S,0,0)}var E=function(e){var t=g[e],n=t.getAttribute("src");if(n){var r=new Image;r.onload=function(){return m(t)},r.onerror=function(e,n,r,o,i){return m(t,["Error loading <img>",t,"Error",i])},r.src=n}else m(t,['Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',t])};for(O=0;O<g.length;O++)E(O);var j=function(e){var t=b[e];t.preload="auto";var n=t.getAttribute("poster");if(n){var r=new Image;r.onload=function(){return m(t)},r.onerror=function(e,r,o,i,a){return m(t,["Error loading video poster",n,"for video",t,"Error:",a])},r.src=n}else t.readyState>=2?m(t):(t.onloadeddata=function(){return m(t)},t.onerror=function(e,n,r,o,i){return m(t,["Error loading video",t,"Error",i])},t.onstalled=function(){return m(t,["Loading video stalled, skipping",t])})};for(O=0;O<b.length;O++)j(O);var T="input",A=d.querySelectorAll(T),C=y.querySelectorAll(T);for(O=0;O<A.length;O++)C[O].value=A[O].value;var k="input[type=checkbox],input[type=radio]",M=d.querySelectorAll(k),R=y.querySelectorAll(k);for(O=0;O<M.length;O++)R[O].checked=M[O].checked;var q="select",D=d.querySelectorAll(q),I=y.querySelectorAll(q);for(O=0;O<D.length;O++)I[O].value=D[O].value}if(a)for(var F=document.querySelectorAll("style, link[rel='stylesheet']"),L=function(e,t){var r=F[e];if("style"===r.tagName.toLowerCase()){var o=y.createElement(r.tagName),i=r.sheet;if(i){var a="";try{for(var c=i.cssRules.length,l=0;l<c;++l)"string"==typeof i.cssRules[l].cssText&&(a+="".concat(i.cssRules[l].cssText,"\r\n"))}catch(e){n.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",r],"warning")}o.setAttribute("id","react-to-print-".concat(e)),u&&o.setAttribute("nonce",u),o.appendChild(y.createTextNode(a)),y.head.appendChild(o)}}else if(r.getAttribute("href"))if(r.hasAttribute("disabled"))n.logMessages(["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",r],"warning"),m(r);else{for(var s=y.createElement(r.tagName),f=(l=0,r.attributes.length);l<f;++l){var d=r.attributes[l];d&&s.setAttribute(d.nodeName,d.nodeValue||"")}s.onload=function(){return m(s)},s.onerror=function(e,t,n,r,o){return m(s,["Failed to load",s,"Error:",o])},u&&s.setAttribute("nonce",u),y.head.appendChild(s)}else n.logMessages(["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",r],"warning"),m(r)},W=(O=0,F.length);O<W;++O)L(O)}0!==n.numResourcesToLoad&&a||n.triggerPrint(f)},n.handleRemoveIframe(!0),document.body.appendChild(f)}else n.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop'])}else n.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);else n.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"])},n.handleRemoveIframe=function(e){var t=n.props.removeAfterPrint;if(e||t){var r=document.getElementById("printWindow");r&&document.body.removeChild(r)}},n.logMessages=function(e,t){void 0===t&&(t="error"),n.props.suppressErrors||("error"===t?console.error(e):"warning"===t?console.warn(e):"debug"===t&&console.debug(e))},n}return t.__extends(o,e),o.prototype.render=function(){var e=this.props,t=e.children,r=e.trigger;if(r)return n.cloneElement(r(),{onClick:this.handleClick});if(!l)return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']),null;var o={handlePrint:this.handleClick};return n.createElement(l.Provider,{value:o},t)},o.defaultProps=u,o}(n.Component);e.default=s,e.useReactToPrint=function(e){if(!c)return e.suppressErrors||console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'),function(){throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"')};var r=n.useMemo((function(){return new s(t.__assign(t.__assign({},u),e))}),[e]);return n.useCallback((function(){return r.handleClick()}),[r])}}(),i}()}));

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(98));
	
	var _config = _interopRequireDefault(__webpack_require__(3603));
	
	var _PropTypes = __webpack_require__(644);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(643));
	
	var _reflow = __webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        if (this.props.unmountOnExit || this.props.mountOnEnter) {
	          var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
	          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
	          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
	
	          if (node) (0, _reflow.forceReflow)(node);
	        }
	
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : function (propValue, key, componentName, location, propFullName, secret) {
	      var value = propValue[key];
	      return _propTypes.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
	    }
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ }),
/* 3603 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(20);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 3605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireDefault(__webpack_require__(20));
	
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(490));
	
	var _youtubePlayer = _interopRequireDefault(__webpack_require__(3923));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  } // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	
	
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	/**
	 * Neutralize API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	
	
	function filterResetOptions(opts) {
	  return _objectSpread(_objectSpread({}, opts), {}, {
	    height: 0,
	    width: 0,
	    playerVars: _objectSpread(_objectSpread({}, opts.playerVars), {}, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldResetPlayer(prevProps, props) {
	  return prevProps.videoId !== props.videoId || !(0, _fastDeepEqual.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id !== props.id || prevProps.className !== props.className || prevProps.opts.width !== props.opts.width || prevProps.opts.height !== props.opts.height || prevProps.title !== props.title;
	}
	
	var YouTube = /*#__PURE__*/function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  var _super = _createSuper(YouTube);
	
	  /**
	   * Expose PlayerState constants for convenience. These constants can also be
	   * accessed through the global YT object after the YouTube IFrame API is instantiated.
	   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	   */
	  function YouTube(props) {
	    var _this;
	
	    _classCallCheck(this, YouTube);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
	      return _this.props.onReady(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
	      return _this.props.onError(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
	      _this.props.onStateChange(event);
	
	      switch (event.data) {
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	
	          break;
	
	        default:
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return; // create player
	
	      var playerOpts = _objectSpread(_objectSpread({}, _this.props.opts), {}, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	
	      _this.internalPlayer = (0, _youtubePlayer.default)(_this.container, playerOpts); // attach event handlers
	
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	
	      _this.internalPlayer.on('error', _this.onPlayerError);
	
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
	        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
	        if (_this.props.opts && _this.props.opts.width) iframe.setAttribute('width', _this.props.opts.width);else iframe.removeAttribute('width');
	        if (_this.props.opts && _this.props.opts.height) iframe.setAttribute('height', _this.props.opts.height);else iframe.removeAttribute('height');
	        if (typeof _this.props.title === 'string') iframe.setAttribute('title', _this.props.title);else iframe.setAttribute('title', 'YouTube video player');
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
	      return _this.internalPlayer;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	
	        return;
	      } // set queueing options
	
	
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      } // if autoplay is enabled loadVideoById
	
	
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	
	        return;
	      } // default behaviour just cues the video
	
	
	      _this.internalPlayer.cueVideoById(opts);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
	      _this.container = container;
	    });
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  _createClass(YouTube, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all YouTube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: this.props.containerClassName
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.refContainer,
	        loading: this.props.loading
	      }));
	    }
	  }]);
	
	  return YouTube;
	}(_react.default.Component);
	
	_defineProperty(YouTube, "PlayerState", {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	});
	
	YouTube.propTypes = {
	  videoId: _propTypes.default.string,
	  // custom ID for player element
	  id: _propTypes.default.string,
	  // custom class name for player element
	  className: _propTypes.default.string,
	  // custom class name for player container element
	  containerClassName: _propTypes.default.string,
	  // custom title for the iFrame, see https://www.w3.org/TR/WCAG20-TECHS/H64.html
	  title: _propTypes.default.string,
	  // custom loading for player element
	  loading: _propTypes.default.oneOf(['lazy', 'eager', 'auto']),
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes.default.objectOf(_propTypes.default.any),
	  // event subscriptions
	  onReady: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onPlay: _propTypes.default.func,
	  onPause: _propTypes.default.func,
	  onEnd: _propTypes.default.func,
	  onStateChange: _propTypes.default.func,
	  onPlaybackRateChange: _propTypes.default.func,
	  onPlaybackQualityChange: _propTypes.default.func
	};
	YouTube.defaultProps = {
	  videoId: null,
	  id: null,
	  className: null,
	  loading: null,
	  opts: {},
	  containerClassName: '',
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {},
	  title: null
	};
	var _default = YouTube;
	exports.default = _default;


/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(343),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 3607 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
	  defineProperty(
	    GeneratorFunctionPrototype,
	    "constructor",
	    { value: GeneratorFunction, configurable: true }
	  );
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    defineProperty(this, "_invoke", { value: enqueue });
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method;
	    var method = delegate.iterator[methodName];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method, or a missing .next mehtod, always terminate the
	      // yield* loop.
	      context.delegate = null;
	
	      // Note: ["return"] must be used for ES3 parsing compatibility.
	      if (methodName === "throw" && delegate.iterator["return"]) {
	        // If the delegate iterator has a return method, give it a
	        // chance to clean up.
	        context.method = "return";
	        context.arg = undefined;
	        maybeInvokeDelegate(delegate, context);
	
	        if (context.method === "throw") {
	          // If maybeInvokeDelegate(context) changed context.method from
	          // "return" to "throw", let that override the TypeError below.
	          return ContinueSentinel;
	        }
	      }
	      if (methodName !== "return") {
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a '" + methodName + "' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });
	
	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(val) {
	    var object = Object(val);
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable || iterable === "") {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    throw new TypeError(typeof iterable + " is not iterable");
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}


/***/ }),
/* 3609 */
/***/ (function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3609);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

	/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(446)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.prototype = Object.create(Buffer.prototype)
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 3612 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3612);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 3614 */
/***/ (function(module, exports) {

	'use strict';
	
	var Sister;
	
	/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	Sister = function () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index !== -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	};
	
	module.exports = Sister;


/***/ }),
/* 3615 */
/***/ (function(module, exports) {

	//fgnass.github.com/spin.js#v1.2.5
	/**
	 * Copyright (c) 2011 Felix Gnass [fgnass at neteye dot de]
	 * Licensed under the MIT license
	 */
	
	var prefixes = ['webkit', 'Moz', 'ms', 'O']; /* Vendor prefixes */
	var animations = {}; /* Animation rules keyed by their name */
	var useCssAnimations;
	
	/**
	 * Utility function to create elements. If no tag name is given,
	 * a DIV is created. Optionally properties can be passed.
	 */
	function createEl(tag, prop) {
	  var el = document.createElement(tag || 'div');
	  var n;
	
	  for(n in prop) {
	    el[n] = prop[n];
	  }
	  return el;
	}
	
	/**
	 * Appends children and returns the parent.
	 */
	function ins(parent /* child1, child2, ...*/) {
	  for (var i=1, n=arguments.length; i<n; i++) {
	    parent.appendChild(arguments[i]);
	  }
	  return parent;
	}
	
	/**
	 * Insert a new stylesheet to hold the @keyframe or VML rules.
	 */
	var sheet = function() {
	  var el = createEl('style');
	  ins(document.getElementsByTagName('head')[0], el);
	  return el.sheet || el.styleSheet;
	}();
	
	/**
	 * Creates an opacity keyframe animation rule and returns its name.
	 * Since most mobile Webkits have timing issues with animation-delay,
	 * we create separate rules for each line/segment.
	 */
	function addAnimation(alpha, trail, i, lines) {
	  var name = ['opacity', trail, ~~(alpha*100), i, lines].join('-');
	  var start = 0.01 + i/lines*100;
	  var z = Math.max(1-(1-alpha)/trail*(100-start) , alpha);
	  var prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase();
	  var pre = prefix && '-'+prefix+'-' || '';
	
	  if (!animations[name]) {
	    sheet.insertRule(
	      '@' + pre + 'keyframes ' + name + '{' +
	      '0%{opacity:'+z+'}' +
	      start + '%{opacity:'+ alpha + '}' +
	      (start+0.01) + '%{opacity:1}' +
	      (start+trail)%100 + '%{opacity:'+ alpha + '}' +
	      '100%{opacity:'+ z + '}' +
	      '}', 0);
	    animations[name] = 1;
	  }
	  return name;
	}
	
	/**
	 * Tries various vendor prefixes and returns the first supported property.
	 **/
	function vendor(el, prop) {
	  var s = el.style;
	  var pp;
	  var i;
	
	  if(s[prop] !== undefined) return prop;
	  prop = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for(i=0; i<prefixes.length; i++) {
	    pp = prefixes[i]+prop;
	    if(s[pp] !== undefined) return pp;
	  }
	}
	
	/**
	 * Sets multiple style properties at once.
	 */
	function css(el, prop) {
	  for (var n in prop) {
	    el.style[vendor(el, n)||n] = prop[n];
	  }
	  return el;
	}
	
	/**
	 * Fills in default values.
	 */
	function merge(obj) {
	  for (var i=1; i < arguments.length; i++) {
	    var def = arguments[i];
	    for (var n in def) {
	      if (obj[n] === undefined) obj[n] = def[n];
	    }
	  }
	  return obj;
	}
	
	/**
	 * Returns the absolute page-offset of the given element.
	 */
	function pos(el) {
	  var o = {x:el.offsetLeft, y:el.offsetTop};
	  while((el = el.offsetParent)) {
	    o.x+=el.offsetLeft;
	    o.y+=el.offsetTop;
	  }
	  return o;
	}
	
	var defaults = {
	  lines: 12,            // The number of lines to draw
	  length: 7,            // The length of each line
	  width: 5,             // The line thickness
	  radius: 10,           // The radius of the inner circle
	  rotate: 0,            // rotation offset
	  color: '#000',        // #rgb or #rrggbb
	  speed: 1,             // Rounds per second
	  trail: 100,           // Afterglow percentage
	  opacity: 1/4,         // Opacity of the lines
	  fps: 20,              // Frames per second when using setTimeout()
	  zIndex: 2e9,          // Use a high z-index by default
	  className: 'spinner', // CSS class to assign to the element
	  top: 'auto',          // center vertically
	  left: 'auto'          // center horizontally
	};
	
	/** The constructor */
	var Spinner = function Spinner(o) {
	  if (!this.spin) return new Spinner(o);
	  this.opts = merge(o || {}, Spinner.defaults, defaults);
	};
	
	Spinner.defaults = {};
	merge(Spinner.prototype, {
	  spin: function(target) {
	    this.stop();
	    var self = this;
	    var o = self.opts;
	    var el = self.el = css(createEl(0, {className: o.className}), {position: 'relative', zIndex: o.zIndex});
	    var mid = o.radius+o.length+o.width;
	    var ep; // element position
	    var tp; // target position
	
	    if (target) {
	      target.insertBefore(el, target.firstChild||null);
	      tp = pos(target);
	      ep = pos(el);
	      css(el, {
	        left: (o.left == 'auto' ? tp.x-ep.x + (target.offsetWidth >> 1) : o.left+mid) + 'px',
	        top: (o.top == 'auto' ? tp.y-ep.y + (target.offsetHeight >> 1) : o.top+mid)  + 'px'
	      });
	    }
	
	    el.setAttribute('aria-role', 'progressbar');
	    self.lines(el, self.opts);
	
	    if (!useCssAnimations) {
	      // No CSS animation support, use setTimeout() instead
	      var i = 0;
	      var fps = o.fps;
	      var f = fps/o.speed;
	      var ostep = (1-o.opacity)/(f*o.trail / 100);
	      var astep = f/o.lines;
	
	      !function anim() {
	        i++;
	        for (var s=o.lines; s; s--) {
	          var alpha = Math.max(1-(i+s*astep)%f * ostep, o.opacity);
	          self.opacity(el, o.lines-s, alpha, o);
	        }
	        self.timeout = self.el && setTimeout(anim, ~~(1000/fps));
	      }();
	    }
	    return self;
	  },
	  stop: function() {
	    var el = this.el;
	    if (el) {
	      clearTimeout(this.timeout);
	      if (el.parentNode) el.parentNode.removeChild(el);
	      this.el = undefined;
	    }
	    return this;
	  },
	  lines: function(el, o) {
	    var i = 0;
	    var seg;
	
	    function fill(color, shadow) {
	      return css(createEl(), {
	        position: 'absolute',
	        width: (o.length+o.width) + 'px',
	        height: o.width + 'px',
	        background: color,
	        boxShadow: shadow,
	        transformOrigin: 'left',
	        transform: 'rotate(' + ~~(360/o.lines*i+o.rotate) + 'deg) translate(' + o.radius+'px' +',0)',
	        borderRadius: (o.width>>1) + 'px'
	      });
	    }
	    for (; i < o.lines; i++) {
	      seg = css(createEl(), {
	        position: 'absolute',
	        top: 1+~(o.width/2) + 'px',
	        transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
	        opacity: o.opacity,
	        animation: useCssAnimations && addAnimation(o.opacity, o.trail, i, o.lines) + ' ' + 1/o.speed + 's linear infinite'
	      });
	      if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), {top: 2+'px'}));
	      ins(el, ins(seg, fill(o.color, '0 0 1px rgba(0,0,0,.1)')));
	    }
	    return el;
	  },
	  opacity: function(el, i, val) {
	    if (i < el.childNodes.length) el.childNodes[i].style.opacity = val;
	  }
	});
	
	/////////////////////////////////////////////////////////////////////////
	// VML rendering for IE
	/////////////////////////////////////////////////////////////////////////
	
	/**
	 * Check and init VML support
	 */
	!function() {
	
	  function vml(tag, attr) {
	    return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr);
	  }
	
	  var s = css(createEl('group'), {behavior: 'url(#default#VML)'});
	
	  if (!vendor(s, 'transform') && s.adj) {
	
	    // VML support detected. Insert CSS rule ...
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)');
	
	    Spinner.prototype.lines = function(el, o) {
	      var r = o.length+o.width;
	      var s = 2*r;
	
	      function grp() {
	        return css(vml('group', {coordsize: s +' '+s, coordorigin: -r +' '+-r}), {width: s, height: s});
	      }
	
	      var margin = -(o.width+o.length)*2+'px';
	      var g = css(grp(), {position: 'absolute', top: margin, left: margin});
	
	      var i;
	
	      function seg(i, dx, filter) {
	        ins(g,
	          ins(css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx}),
	            ins(css(vml('roundrect', {arcsize: 1}), {
	                width: r,
	                height: o.width,
	                left: o.radius,
	                top: -o.width>>1,
	                filter: filter
	              }),
	              vml('fill', {color: o.color, opacity: o.opacity}),
	              vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        );
	      }
	
	      if (o.shadow) {
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)');
	        }
	      }
	      for (i = 1; i <= o.lines; i++) seg(i);
	      return ins(el, g);
	    };
	    Spinner.prototype.opacity = function(el, i, val, o) {
	      var c = el.firstChild;
	      o = o.shadow && o.lines || 0;
	      if (c && i+o < c.childNodes.length) {
	        c = c.childNodes[i+o]; c = c && c.firstChild; c = c && c.firstChild;
	        if (c) c.opacity = val;
	      }
	    };
	  }
	  else {
	    useCssAnimations = vendor(s, 'animation');
	  }
	}();
	
	module.exports = Spinner;


/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(3611).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1245);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!../resolve-url-loader/index.js!../sass-loader/dist/cjs.js?sourceMap!./lib/bootstrap.styles.loader.js?{\"bootstrapVersion\":3,\"useCustomIconFontPath\":false,\"extractStyles\":false,\"styleLoaders\":[\"style\",\"css\",\"sass\"],\"styles\":[\"mixins\",\"normalize\",\"print\",\"glyphicons\",\"scaffolding\",\"type\",\"code\",\"grid\",\"tables\",\"forms\",\"buttons\",\"component-animations\",\"dropdowns\",\"button-groups\",\"input-groups\",\"navs\",\"navbar\",\"breadcrumbs\",\"pagination\",\"pager\",\"labels\",\"badges\",\"jumbotron\",\"thumbnails\",\"alerts\",\"progress-bars\",\"media\",\"list-group\",\"panels\",\"wells\",\"responsive-embed\",\"close\",\"modals\",\"tooltip\",\"popovers\",\"carousel\",\"utilities\",\"responsive-utilities\"],\"scripts\":[\"transition\",\"alert\",\"button\",\"carousel\",\"collapse\",\"dropdown\",\"modal\",\"tooltip\",\"popover\",\"scrollspy\",\"tab\",\"affix\"],\"configFilePath\":\"/build/wr_web_client/node_modules/bootstrap-loader/.bootstraprc-3-default\",\"bootstrapPath\":\"/build/wr_web_client/node_modules/bootstrap-sass\",\"bootstrapRelPath\":\"../bootstrap-sass\"}!./no-op.js", function() {
				var newContent = require("!!../css-loader/index.js!../resolve-url-loader/index.js!../sass-loader/dist/cjs.js?sourceMap!./lib/bootstrap.styles.loader.js?{\"bootstrapVersion\":3,\"useCustomIconFontPath\":false,\"extractStyles\":false,\"styleLoaders\":[\"style\",\"css\",\"sass\"],\"styles\":[\"mixins\",\"normalize\",\"print\",\"glyphicons\",\"scaffolding\",\"type\",\"code\",\"grid\",\"tables\",\"forms\",\"buttons\",\"component-animations\",\"dropdowns\",\"button-groups\",\"input-groups\",\"navs\",\"navbar\",\"breadcrumbs\",\"pagination\",\"pager\",\"labels\",\"badges\",\"jumbotron\",\"thumbnails\",\"alerts\",\"progress-bars\",\"media\",\"list-group\",\"panels\",\"wells\",\"responsive-embed\",\"close\",\"modals\",\"tooltip\",\"popovers\",\"carousel\",\"utilities\",\"responsive-utilities\"],\"scripts\":[\"transition\",\"alert\",\"button\",\"carousel\",\"collapse\",\"dropdown\",\"modal\",\"tooltip\",\"popover\",\"scrollspy\",\"tab\",\"affix\"],\"configFilePath\":\"/build/wr_web_client/node_modules/bootstrap-loader/.bootstraprc-3-default\",\"bootstrapPath\":\"/build/wr_web_client/node_modules/bootstrap-sass\",\"bootstrapRelPath\":\"../bootstrap-sass\"}!./no-op.js");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1246);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_photos_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_photos_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3619 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1247);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_color_picker.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_color_picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1248);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3621 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1249);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1250);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_patcher.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owl_shop_patcher.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1251);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owlvatar.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owlvatar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1252);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./category_picker.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./category_picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1253);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./cloze_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./cloze_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1254);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./passage.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./passage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1255);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./passage_tile.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./passage_tile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3628 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1256);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./book_answers_analysis_table.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./book_answers_analysis_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1257);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./class_results_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./class_results_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1258);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_controls.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1259);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_log_tables.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_log_tables.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1260);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1261);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_quizzes.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_quizzes.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_table.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1263);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_table_summary.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./data_table_summary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1265);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./empty_state.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./empty_state.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3637 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1266);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./data_export_confirmation.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./data_export_confirmation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3638 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1267);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./data_export_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./data_export_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3639 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1269);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_stats_selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_stats_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1270);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./export_type_selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./export_type_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1271);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exports_date_span_selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exports_date_span_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3642 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_org_stats_selector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_org_stats_selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3643 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1273);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./goals_table.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./goals_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3644 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1274);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_graph_container.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_graph_container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3645 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1275);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./custom_tooltip.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./custom_tooltip.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3646 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1276);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rubric_radar_graph.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rubric_radar_graph.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3647 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./scoring_graph.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./scoring_graph.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3648 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1278);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./no_activity_block.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./no_activity_block.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3649 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./org_activity_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./org_activity_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3650 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1280);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reading_level_graph.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reading_level_graph.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3651 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./student_selector_section.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./student_selector_section.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3652 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1282);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./student_selector_sidebar.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./student_selector_sidebar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3653 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_digest_container.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_digest_container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./truncated_data_note.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./truncated_data_note.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3655 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1286);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_container.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3656 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1287);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_item.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3657 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1288);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_title.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./widget_title.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3658 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./FurnitureDisplay.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./FurnitureDisplay.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3659 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1290);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./animation_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./animation_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3660 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./dressing_room.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./dressing_room.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3661 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./golden_egg.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./golden_egg.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3662 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1293);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./house_interior_room.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./house_interior_room.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3663 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1294);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./house_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./house_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3664 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./new_items_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./new_items_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3665 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1296);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./purchase_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./purchase_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3666 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./sale_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./sale_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3667 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./tier_requirements_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./tier_requirements_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3668 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1299);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./trophy_room.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./trophy_room.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3669 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./albus.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./albus.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3670 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1301);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./app.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3671 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./globals.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./globals.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3672 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1303);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./vendors.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./vendors.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3673 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./wr_styles.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./wr_styles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3674 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1305);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./wr_styles_mixins.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./wr_styles_mixins.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3675 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1306);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./basic_site_header.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./basic_site_header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3676 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1307);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pending_task_notice.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pending_task_notice.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3677 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./return_account_header.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./return_account_header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3678 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1309);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_footer.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_footer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3679 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1310);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_header.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3680 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./top_bar_warning.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./top_bar_warning.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3681 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./universal_controls.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./universal_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3682 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1313);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./forgot_password_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./forgot_password_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3683 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1314);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./login_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./login_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reset_password_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reset_password_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3685 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./drop_down_notifications.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./drop_down_notifications.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3686 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./new_features_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./new_features_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3687 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_annoucement_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_annoucement_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3688 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_banner.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./site_banner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3689 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./slide_in_announcement.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./slide_in_announcement.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1321);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./social_notifications.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./social_notifications.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3691 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./contests_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./contests_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3692 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./invite_teachers_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./invite_teachers_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3693 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./differentiation_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./differentiation_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3694 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1325);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./org_dropdown.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./org_dropdown.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3695 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activation_codes_preferences.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activation_codes_preferences.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3696 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expectation_period_preference.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expectation_period_preference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3697 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./general_org_preferences.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./general_org_preferences.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3698 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1329);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./grade_level_expectations_preference.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./grade_level_expectations_preference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3699 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1330);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rostering_method_preference.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rostering_method_preference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3700 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1331);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_contest_preference.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_contest_preference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3701 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1332);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./google_sync.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./google_sync.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3702 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1333);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_emails_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_emails_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3703 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1334);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_add_to_student_list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_add_to_student_list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3704 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1335);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_content.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_content.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3705 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1336);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_info_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./school_info_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3706 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1337);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_subgroups.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_subgroups.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3707 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1338);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_students_class_code.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_students_class_code.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3708 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1339);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_students_method_select.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_students_method_select.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3709 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1340);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mapping_control.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./mapping_control.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3710 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1341);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_upload_buttons.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_upload_buttons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3711 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1342);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_upload_progress_meter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./roster_upload_progress_meter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3712 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1343);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./sso_roster_review.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./sso_roster_review.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3713 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1344);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./upload_student_roster.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./upload_student_roster.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3714 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1345);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./class_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./class_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3715 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1346);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./class_tree.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./class_tree.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3716 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1347);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./credit_card_input.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./credit_card_input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3717 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1348);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./purchase_order_input.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./purchase_order_input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3718 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1350);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_cover.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_cover.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3719 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1351);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3720 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1352);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_logger.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_logger.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3721 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1353);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_rating.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_rating.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3722 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1354);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_search_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_search_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3723 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1355);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_text_variety.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_text_variety.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3724 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1356);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_reading_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_reading_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3725 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1357);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./smart_book_search.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./smart_book_search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3726 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1358);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3727 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1359);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_calendar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./log_calendar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3728 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1361);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./participating_students_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./participating_students_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3729 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1362);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_library_url_pick.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_library_url_pick.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3730 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1363);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_manual_url_pick.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_manual_url_pick.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3731 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1364);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_title_pick.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./add_title_pick.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3732 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1365);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./picks_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./picks_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3733 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1366);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reading_level_icon.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reading_level_icon.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3734 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1367);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./reading_level_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./reading_level_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3735 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1368);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_grid.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_grid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3736 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1369);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_shelf.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_shelf.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3737 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1370);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_sidebar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./book_sidebar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3738 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1371);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./coin_details_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./coin_details_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3739 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1372);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./coins_earned_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./coins_earned_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3740 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1374);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./my_shelf_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./my_shelf_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3741 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1375);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./my_work.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./my_work.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3742 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1376);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./reviews_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./reviews_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3743 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1377);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/dist/cjs.js!./scratch.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/dist/cjs.js!./scratch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3744 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1378);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./comment_box.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./comment_box.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3745 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1379);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./photos_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./photos_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3746 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1380);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./help_center_link.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./help_center_link.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3747 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1381);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reaction_feedback.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./reaction_feedback.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3748 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1382);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./support_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./support_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3749 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1383);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./webinar_registration.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./webinar_registration.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3750 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1384);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./survey_prompt.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./survey_prompt.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3751 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3752 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1386);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pending_sso_page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pending_sso_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3753 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1387);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./gold_trial.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./gold_trial.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3754 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1389);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./code_table_preference.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./code_table_preference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3755 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1390);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./logs_approval_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./logs_approval_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3756 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1391);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_info_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./parent_info_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3757 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1393);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./merge_student_lists_form.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./merge_student_lists_form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3758 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1394);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./merge_users_form.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./merge_users_form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3759 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1395);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./gamified_student_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./gamified_student_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3760 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1396);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./component_demonstrator.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./component_demonstrator.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3761 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1397);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./owlfonso_chat.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./owlfonso_chat.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3762 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1398);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./progress_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./progress_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3763 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1399);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_cloze_status.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_cloze_status.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3764 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1401);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_expectations_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_expectations_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3765 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1402);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_home_page_streamlined.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_home_page_streamlined.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3766 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1403);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_home_page_vertical.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_home_page_vertical.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3767 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1404);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_onboarding_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_onboarding_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3768 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1406);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_report_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_report_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3769 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1407);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./account_customizer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./account_customizer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3770 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1408);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cloze_customizer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./cloze_customizer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3771 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1409);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./custom_teacher_home_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./custom_teacher_home_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3772 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1410);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expectations_customizer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expectations_customizer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3773 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1411);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_checklist.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_checklist.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3774 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1412);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_checklist_item.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_checklist_item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3775 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1413);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./onboarding_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3776 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1414);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./paywall_link.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./paywall_link.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3777 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1415);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./paywall_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./paywall_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3778 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1416);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./preferences.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./preferences.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3779 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1417);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_customizer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_customizer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3780 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1418);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./settings_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./settings_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3781 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1419);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_home_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_home_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3782 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1420);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./tutorials_page.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./tutorials_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3783 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1421);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./overdrawn_account_notice.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./overdrawn_account_notice.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3784 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1422);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./trial_status_display.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./trial_status_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3785 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1423);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3786 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1424);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_header.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3787 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1425);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_token_form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./upgrade_token_form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3788 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1426);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./alt_modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./alt_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3789 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1427);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./auto_submit_text_area.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./auto_submit_text_area.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3790 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1429);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./brave_checkbox.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./brave_checkbox.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3791 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1430);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./brave_toolbar.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./brave_toolbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3792 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1431);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./button_dropdown.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./button_dropdown.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3793 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1432);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./carousel.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./carousel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3794 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1433);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./coin_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./coin_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3795 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1434);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./copy_text_input.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./copy_text_input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3796 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1435);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./month_picker.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./month_picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3797 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1436);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./week_picker.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./week_picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3798 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1437);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./diff_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./diff_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3799 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1438);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./display_toggle_control.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./display_toggle_control.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3800 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1439);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./empty_state_container.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./empty_state_container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3801 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1440);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_boundary.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_boundary.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3802 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1441);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./error_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3803 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1442);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./feedback_override_display.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./feedback_override_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3804 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1443);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./help_section_link.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./help_section_link.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3805 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1444);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_circle.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_circle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3806 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1445);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./avatar_circle.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./avatar_circle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3807 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1446);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_task_circle.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_task_circle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3808 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1447);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./toggle_multiselect.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./toggle_multiselect.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3809 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./l2e_sound.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./l2e_sound.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3810 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1449);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./loading_button.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./loading_button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3811 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1450);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owlfonso_container.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./owlfonso_container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3812 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1451);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pagination_controls.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./pagination_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3813 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1452);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./progress_bar.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./progress_bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3814 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1453);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./select_options.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./select_options.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3815 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./sliding_drawer.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./sliding_drawer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3816 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1455);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./spinner.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./spinner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3817 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1456);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./step_progress_meter.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./step_progress_meter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3818 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1457);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_preview_notice.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./teacher_preview_notice.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3819 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1458);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./validating_input.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/dist/cjs.js!./validating_input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3820 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1459);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activities_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activities_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3821 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1460);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3822 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1462);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_tile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./activity_tile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3823 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1463);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./all_student_activities_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./all_student_activities_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3824 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1464);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./assign_activity_details_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./assign_activity_details_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3825 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1465);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exercise_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exercise_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3826 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1466);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exercise_tile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./exercise_tile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3827 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1467);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_student_activities_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./expanded_student_activities_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3828 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1468);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_picks_table.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_picks_table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3829 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1469);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_analysis_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_analysis_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3830 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1471);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_length_meter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_length_meter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3831 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1472);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_scoring_details.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_scoring_details.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3832 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_writing_interface.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./answer_writing_interface.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3833 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1474);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./multi_part_answer_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./multi_part_answer_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3834 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1475);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_answer_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_answer_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3835 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1476);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_builder_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_builder_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3836 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1477);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./analysis_controls.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./analysis_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3837 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./edit_controls.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./edit_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3838 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1479);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./feedback_controls.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./feedback_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3839 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1480);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./autograder_demo.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./autograder_demo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3840 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1481);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./evaluation_box.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./evaluation_box.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3841 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1482);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./evaluation_tags.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./evaluation_tags.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3842 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1483);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rubric_item_override.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./rubric_item_override.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3843 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1484);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./score_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./score_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3844 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1485);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./scoring_data.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./scoring_data.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3845 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1486);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_area_markups.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_area_markups.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3846 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1487);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./fill_in_the_blank.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./fill_in_the_blank.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3847 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1488);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./fitb_answer_box.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./fitb_answer_box.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3848 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1489);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_feedback.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./question_feedback.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3849 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1490);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./sentence_starter_text_area.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./sentence_starter_text_area.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3850 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1491);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./skillset_banner.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./skillset_banner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3851 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1492);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./skillset_standard_label.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./skillset_standard_label.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3852 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1493);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./speech_controls.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./speech_controls.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3853 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1494);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_questions_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./text_questions_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3854 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1495);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./autosaver.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./autosaver.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3855 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1496);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_analysis_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_analysis_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3856 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1497);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3857 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1498);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3858 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1499);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_review.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./quiz_review.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3859 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1500);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./warmup_questions_display.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/dist/cjs.js!./warmup_questions_display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3860 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1502);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_response_page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./new_response_page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3861 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1503);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./response_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./response_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3862 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1504);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./response_tile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./response_tile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3863 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1505);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./share_response.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./share_response.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3864 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1506);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_activity_info_line.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./student_activity_info_line.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3865 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1507);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_view_response_modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./teacher_view_response_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 3866 */
/***/ (function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(3868)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ }),
/* 3867 */
/***/ (function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ }),
/* 3868 */
/***/ (function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(3867)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ }),
/* 3869 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 3870 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d57582d01070cefa9ecd6b8041732ed.mp3";

/***/ }),
/* 3871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "285f1200cfe90a012544b977bc045dd7.mp3";

/***/ }),
/* 3872 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1b1f722a7b7add2e62e376a32b9049f4.mp3";

/***/ }),
/* 3873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "499f591422b3218d9052c7a1cd996ab2.mp3";

/***/ }),
/* 3874 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1513bd11f4d9e3747b7610b4a1cc41a3.mp3";

/***/ }),
/* 3875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "436f6085c21dd7a1c2156a4ce294923a.mp3";

/***/ }),
/* 3876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8202100959a619f85120a44de4cb0b3f.mp3";

/***/ }),
/* 3877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3778c9d82e6b5db71909ea2afb35274a.mp3";

/***/ }),
/* 3878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "74e85996a3fbd1da0409898ef53bbc83.mp3";

/***/ }),
/* 3879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "39012a5b28c9bb4fc883d1cc1733b061.mp3";

/***/ }),
/* 3880 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0d1ed4e57389f825111dfc94fdc1e9ad.mp3";

/***/ }),
/* 3881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "26baf76f23f13f669308903e2d9c3346.mp3";

/***/ }),
/* 3882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e88e879ccd33ac97dac0a0c790812fd.mp3";

/***/ }),
/* 3883 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "445a7b575b7d822f9eb86b9385a4a08f.mp3";

/***/ }),
/* 3884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d1ade2831a8d57d9e7b2ad9728aaea71.mp3";

/***/ }),
/* 3885 */
/***/ (function(module, exports) {

	module.exports = "data:audio/mpeg;base64,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"

/***/ }),
/* 3886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e754f7fd4a69e7a3301bdce96810cac2.mp3";

/***/ }),
/* 3887 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 3888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 3889 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzIxOTZGMyIgZD0iTTM3IDQwSDExbC02IDZWMTJjMC0zLjMgMi43LTYgNi02aDI2YzMuMyAwIDYgMi43IDYgNnYyMmMwIDMuMy0yLjcgNi02IDZ6Ii8+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTIyIDIwaDR2MTFoLTR6Ii8+PGNpcmNsZSBjeD0iMjQiIGN5PSIxNSIgcj0iMiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 3890 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3891 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0FEMTQ1NyIgZD0iTTM2IDRjMCA5LjMtNiAxMy4yLTEyLjggMTcuOEMxNi4xIDI2LjUgOCAzMS44IDggNDRoNGMwLTEwLjEgNi41LTE0LjQgMTMuNC0xOC45QzMyLjIgMjAuNiA0MCAxNS40IDQwIDRoLTR6Ii8+PHBhdGggZmlsbD0iI0FEMTQ1NyIgZD0iTTM4IDQxSDExYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDI3Yy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tMi00SDEyYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDI0Yy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tMi00SDE0Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDIwYy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tNS00SDE5Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDEwYy42IDAgMSAuNCAxIDFzLS40IDEtMSAxeiIvPjxwYXRoIGZpbGw9IiNFOTFFNjMiIGQ9Ik0zNyA5SDEwYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDI3Yy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tMSA0SDEyYy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDI0Yy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tMiA0SDE0Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDIwYy42IDAgMSAuNCAxIDFzLS40IDEtMSAxem0tNSA0SDE5Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDEwYy42IDAgMSAuNCAxIDFzLS40IDEtMSAxeiIvPjxwYXRoIGZpbGw9IiNFOTFFNjMiIGQ9Ik00MCA0NGgtNGMwLTEwLjEtNi41LTE0LjQtMTMuNC0xOC45QzE1LjggMjAuNiA4IDE1LjQgOCA0aDRjMCA5LjMgNiAxMy4yIDEyLjggMTcuOEMzMS45IDI2LjUgNDAgMzEuOCA0MCA0NHoiLz48L3N2Zz4="

/***/ }),
/* 3892 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzJFN0QzMiIgZD0iTTUgMjRjMCAxOC45IDE0LjggMTkgMTcgMTloNFMyNC4xIDI2LjUgNSAyNHoiLz48cGF0aCBmaWxsPSIjMzg4RTNDIiBkPSJNMjIgMjZoNHYxN2gtNHoiLz48cGF0aCBmaWxsPSIjQzYyODI4IiBkPSJNMzQgMTZjMCA1LjEtNS4yIDguMi04IDguMnMtMi0zLjEtMi04LjIgNS05LjIgNS05LjIgNSA0LjEgNSA5LjJ6bS0yMCAwYzAgNS4xIDUuMiA4LjIgOCA4LjJzMi0zLjEgMi04LjItNS05LjItNS05LjItNSA0LjEtNSA5LjJ6Ii8+PHBhdGggZmlsbD0iI0U1MzkzNSIgZD0iTTI0IDI3Yy0yLjItMS42LTEuOS00LjUgMi40LTguOEMzMC44IDEzLjggMzIgNyAzMiA3czUgMy40IDUgOWMwIDUuOS01LjcgMTEtMTMgMTF6Ii8+PHBhdGggZmlsbD0iI0U1MzkzNSIgZD0iTTI0IDI3YzIuMi0xLjYgMS45LTQuNS0yLjQtOC44QzE3LjIgMTMuOCAxNiA3IDE2IDdzLTUgMy40LTUgOWMwIDUuOSA1LjcgMTEgMTMgMTF6Ii8+PHBhdGggZmlsbD0iI0Y0NDMzNiIgZD0iTTMwIDE2YzAgNi4xLTIuNyAxMS02IDExcy02LTQuOS02LTExIDYtMTEgNi0xMSA2IDQuOSA2IDExeiIvPjxwYXRoIGZpbGw9IiM0Q0FGNTAiIGQ9Ik0yMiA0M2g0YzIuMiAwIDE3LS4xIDE3LTE5LTE5LjEgMi41LTIxIDE5LTIxIDE5eiIvPjwvc3ZnPg=="

/***/ }),
/* 3893 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGOTgwMCIgZD0iTTQ0IDE4di00SDM0VjRoLTR2MTBoLTRWNGgtNHYxMGgtNFY0aC00djEwSDR2NGgxMHY0SDR2NGgxMHY0SDR2NGgxMHYxMGg0VjM0aDR2MTBoNFYzNGg0djEwaDRWMzRoMTB2LTRIMzR2LTRoMTB2LTRIMzR2LTRoMTB6Ii8+PHBhdGggZmlsbD0iIzRDQUY1MCIgZD0iTTggMTJ2MjRjMCAyLjIgMS44IDQgNCA0aDI0YzIuMiAwIDQtMS44IDQtNFYxMmMwLTIuMi0xLjgtNC00LTRIMTJjLTIuMiAwLTQgMS44LTQgNHoiLz48cGF0aCBmaWxsPSIjMzc0NzRGIiBkPSJNMzEgMzFIMTdjLTEuMSAwLTItLjktMi0yVjE5YzAtMS4xLjktMiAyLTJoMTRjMS4xIDAgMiAuOSAyIDJ2MTBjMCAxLjEtLjkgMi0yIDJ6Ii8+PC9zdmc+"

/***/ }),
/* 3894 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGNpcmNsZSBmaWxsPSIjRkZBNzI2IiBjeD0iMTIiIGN5PSIyMSIgcj0iNSIvPjxwYXRoIGQ9Ik0yIDM0LjdzMi44LTYuMyAxMC02LjMgMTAgNi4zIDEwIDYuM1YzOEgydi0zLjN6bTQ0IDBzLTIuOC02LjMtMTAtNi4zLTEwIDYuMy0xMCA2LjNWMzhoMjB2LTMuM3oiIGZpbGw9IiM0NTVBNjQiLz48Y2lyY2xlIGZpbGw9IiNGRkI3NEQiIGN4PSIyNCIgY3k9IjE3IiByPSI2Ii8+PHBhdGggZmlsbD0iIzYwN0Q4QiIgZD0iTTM2IDM0LjFzLTMuMy03LjUtMTItNy41LTEyIDcuNS0xMiA3LjVWMzhoMjR2LTMuOXoiLz48Y2lyY2xlIGZpbGw9IiNGRkE3MjYiIGN4PSIzNiIgY3k9IjIxIiByPSI1Ii8+PGNpcmNsZSBmaWxsPSIjRkZBNzI2IiBjeD0iMTIiIGN5PSIyMSIgcj0iNSIvPjxjaXJjbGUgZmlsbD0iI0ZGQTcyNiIgY3g9IjM2IiBjeT0iMjEiIHI9IjUiLz48L3N2Zz4="

/***/ }),
/* 3895 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0NGRDhEQyIgZD0iTTM5LjQgMjNsLS44LTRMMjYgMjEuNlY4aC00djEyLjNsLTEzLjktOS0yLjIgMy40IDE1LjIgOS44TDkuNCAzOS44bDMuMiAyLjQgMTEuMy0xNC44IDguNCAxMi43IDMuNC0yLjItOC40LTEyLjV6Ii8+PGNpcmNsZSBmaWxsPSIjM0Y1MUI1IiBjeD0iMjQiIGN5PSIyNCIgcj0iNyIvPjxnIGZpbGw9IiMwMEJDRDQiPjxjaXJjbGUgY3g9IjI0IiBjeT0iOCIgcj0iNSIvPjxjaXJjbGUgY3g9IjM5IiBjeT0iMjEiIHI9IjUiLz48Y2lyY2xlIGN4PSI3IiBjeT0iMTMiIHI9IjUiLz48Y2lyY2xlIGN4PSIxMSIgY3k9IjQxIiByPSI1Ii8+PGNpcmNsZSBjeD0iMzQiIGN5PSIzOSIgcj0iNSIvPjwvZz48L3N2Zz4="

/***/ }),
/* 3896 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzkwQ0FGOSIgZD0iTTQwIDQ1SDhWM2gyMmwxMCAxMHoiLz48cGF0aCBmaWxsPSIjRTFGNUZFIiBkPSJNMzguNSAxNEgyOVY0LjV6Ii8+PC9zdmc+"

/***/ }),
/* 3897 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzAzOUJFNSIgZD0iTTE3IDI5aDE0djJIMTd6bS00IDRoMjJ2MkgxM3ptLTQgNGgzMHYySDl6bS00IDRoMzh2Mkg1eiIvPjxwYXRoIGZpbGw9IiM4MUQ0RkEiIGQ9Ik0zNSAxM2MtLjQgMC0uOCAwLTEuMi4xQzMyLjkgOC41IDI4LjkgNSAyNCA1Yy00LjEgMC03LjYgMi41LTkuMiA2SDE0Yy00LjQgMC04IDMuNi04IDhzMy42IDggOCA4aDIxYzMuOSAwIDctMy4xIDctN3MtMy4xLTctNy03eiIvPjxwYXRoIGZpbGw9IiMwMzlCRTUiIGQ9Ik0yOCAyMWMwLTIuMi0xLjgtNC00LTRzLTQgMS44LTQgNHY2aDh2LTZ6Ii8+PC9zdmc+"

/***/ }),
/* 3898 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0JGMzYwQyIgZD0iTTQxLjIgNWgtNy4zTDMyIDQzaDExTDQxLjIgNXoiLz48cGF0aCBmaWxsPSIjRTY0QTE5IiBkPSJNMzMgMjNoLTR2LTZsLTEyIDZ2LTZMNSAyM3YyMGgyOFYyM3oiLz48cGF0aCBmaWxsPSIjRkZDMTA3IiBkPSJNOSAyN2g0djRIOXptOCAwaDR2NGgtNHptOCAwaDR2NGgtNHpNOSAzNWg0djRIOXptOCAwaDR2NGgtNHptOCAwaDR2NGgtNHoiLz48L3N2Zz4="

/***/ }),
/* 3899 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzkwQ0FGOSIgZD0iTTQwIDQ1SDhWM2gyMmwxMCAxMHoiLz48cGF0aCBmaWxsPSIjRTFGNUZFIiBkPSJNMzguNSAxNEgyOVY0LjV6Ii8+PHBhdGggZD0iTTE2IDIxaDE3djJIMTZ6bTAgNGgxM3YySDE2em0wIDRoMTd2MkgxNnptMCA0aDEzdjJIMTZ6IiBmaWxsPSIjMTk3NkQyIi8+PC9zdmc+"

/***/ }),
/* 3900 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzNGNTFCNSIgZD0iTTQzIDM5VjI0aC00djE1YzAgNSA0IDkgOSA5di00Yy0yLjggMC01LTIuMi01LTV6Ii8+PGNpcmNsZSBmaWxsPSIjOTBBNEFFIiBjeD0iMjQiIGN5PSIyNCIgcj0iMTkiLz48Y2lyY2xlIGZpbGw9IiMzNzQ3NEYiIGN4PSIyNCIgY3k9IjI0IiByPSIyIi8+PGcgZmlsbD0iIzI1MzI3OCI+PGNpcmNsZSBjeD0iMjQiIGN5PSIxNCIgcj0iNSIvPjxjaXJjbGUgY3g9IjI0IiBjeT0iMzQiIHI9IjUiLz48Y2lyY2xlIGN4PSIzNCIgY3k9IjI0IiByPSI1Ii8+PGNpcmNsZSBjeD0iMTQiIGN5PSIyNCIgcj0iNSIvPjwvZz48L3N2Zz4="

/***/ }),
/* 3901 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGQzEwNyIgZD0iTTMzIDIyaC05LjRMMzAgNUgxOWwtNiAyMWg4LjZMMTcgNDV6Ii8+PC9zdmc+"

/***/ }),
/* 3902 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0NGRDhEQyIgZD0iTTQwIDlWN2gtOXY1SDE1djExSDh2Mmg3djExaDE2djVoOXYtMmgtN3YtOGg3di0yaC05djVIMTdWMTRoMTR2NWg5di0yaC03Vjl6Ii8+PHBhdGggZmlsbD0iIzAwQkNENCIgZD0iTTQgMjBoOHY4SDR6Ii8+PHBhdGggZD0iTTM2IDE0aDh2OGgtOHptMC0xMGg4djhoLTh6TTIwIDloOHY4aC04em0wIDIyaDh2OGgtOHptMTYgNWg4djhoLTh6bTAtMTBoOHY4aC04eiIgZmlsbD0iIzNGNTFCNSIvPjwvc3ZnPg=="

/***/ }),
/* 3903 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgZmlsbD0iIzM3NDc0RiI+PHBhdGggZD0iTTkgMjBoMzB2MTNIOXoiLz48ZWxsaXBzZSBjeD0iMjQiIGN5PSIzMyIgcng9IjE1IiByeT0iNiIvPjwvZz48cGF0aCBmaWxsPSIjNzg5MDlDIiBkPSJNMjMuMSA4LjJMLjYgMTguMWMtLjguNC0uOCAxLjUgMCAxLjlsMjIuNSA5LjljLjYuMiAxLjIuMiAxLjggMEw0Ny40IDIwYy44LS40LjgtMS41IDAtMS45TDI0LjkgOC4yYy0uNi0uMy0xLjItLjMtMS44IDB6Ii8+PGcgZmlsbD0iIzM3NDc0RiI+PHBhdGggZD0iTTQzLjIgMjAuNGwtMjAtMy40Yy0uNS0uMS0xLjEuMy0xLjIuOC0uMS41LjMgMS4xLjggMS4yTDQyIDIyLjJWMzdjMCAuNi40IDEgMSAxczEtLjQgMS0xVjIxLjRjMC0uNS0uNC0uOS0uOC0xeiIvPjxjaXJjbGUgY3g9IjQzIiBjeT0iMzciIHI9IjIiLz48cGF0aCBkPSJNNDYgNDBjMCAxLjctMyA2LTMgNnMtMy00LjMtMy02IDEuMy0zIDMtMyAzIDEuMyAzIDN6Ii8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 3904 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGNpcmNsZSBmaWxsPSIjRkZGNTlEIiBjeD0iMjQiIGN5PSIyMiIgcj0iMjAiLz48cGF0aCBmaWxsPSIjRkJDMDJEIiBkPSJNMzcgMjJjMC03LjctNi42LTEzLjgtMTQuNS0xMi45LTYgLjctMTAuOCA1LjUtMTEuNCAxMS41LS41IDQuNiAxLjQgOC43IDQuNiAxMS4zIDEuNCAxLjIgMi4zIDIuOSAyLjMgNC44di4zaDEydi0uMWMwLTEuOC44LTMuNiAyLjItNC44IDIuOS0yLjQgNC44LTYgNC44LTEwLjF6Ii8+PHBhdGggZmlsbD0iI0ZGRjU5RCIgZD0iTTMwLjYgMjAuMmwtMy0yYy0uMy0uMi0uOC0uMi0xLjEgMEwyNCAxOS44bC0yLjQtMS42Yy0uMy0uMi0uOC0uMi0xLjEgMGwtMyAyYy0uMi4yLS40LjQtLjQuN3MwIC42LjIuOGwzLjggNC43VjM3aDJWMjZjMC0uMi0uMS0uNC0uMi0uNmwtMy4zLTQuMSAxLjUtMSAyLjQgMS42Yy4zLjIuOC4yIDEuMSAwbDIuNC0xLjYgMS41IDEtMy4zIDQuMWMtLjEuMi0uMi40LS4yLjZ2MTFoMlYyNi40bDMuOC00LjdjLjItLjIuMy0uNS4yLS44cy0uMi0uNi0uNC0uN3oiLz48Y2lyY2xlIGZpbGw9IiM1QzZCQzAiIGN4PSIyNCIgY3k9IjQ0IiByPSIzIi8+PHBhdGggZmlsbD0iIzlGQThEQSIgZD0iTTI2IDQ1aC00Yy0yLjIgMC00LTEuOC00LTR2LTVoMTJ2NWMwIDIuMi0xLjggNC00IDR6Ii8+PHBhdGggZD0iTTMwIDQxbC0xMS42IDEuNmMuMy43LjkgMS40IDEuNiAxLjhsOS40LTEuM2MuNC0uNi42LTEuMy42LTIuMXptLTEyLTIuM3YyTDMwIDM5di0yeiIgZmlsbD0iIzVDNkJDMCIvPjwvc3ZnPg=="

/***/ }),
/* 3905 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGQzEwNyIgZD0iTTQ0IDM2SDMwVjE2YzAtMS4xLjktMiAyLTJoOGMuNiAwIDEuMi4zIDEuNi44bDYgNy43Yy4zLjQuNC44LjQgMS4yVjMyYzAgMi4yLTEuOCA0LTQgNHoiLz48ZyBmaWxsPSIjOTU3NUNEIj48cGF0aCBkPSJNOCAzNmgyMlYxM2MwLTIuMi0xLjgtNC00LTRINHYyM2MwIDIuMiAxLjggNCA0IDR6Ii8+PHBhdGggZD0iTTAgOWgxMHYySDB6bTAgNWgxMHYySDB6bTAgNWgxMHYySDB6bTAgNWgxMHYySDB6Ii8+PC9nPjxwYXRoIGQ9Ik00IDExaDE2djJINHptMCA1aDEydjJINHptMCA1aDh2Mkg0em0wIDVoNHYySDR6IiBmaWxsPSIjN0U1N0MyIi8+PGcgZmlsbD0iIzM3NDc0RiI+PGNpcmNsZSBjeD0iMzkiIGN5PSIzNiIgcj0iNSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iMzYiIHI9IjUiLz48L2c+PGcgZmlsbD0iIzc4OTA5QyI+PGNpcmNsZSBjeD0iMzkiIGN5PSIzNiIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYiIGN5PSIzNiIgcj0iMi41Ii8+PC9nPjxwYXRoIGZpbGw9IiM0NTVBNjQiIGQ9Ik00NCAyNmgtMy42Yy0uMyAwLS41LS4xLS43LS4zbC0xLjQtMS40Yy0uMi0uMi0uNC0uMy0uNy0uM0gzNGMtLjYgMC0xLS40LTEtMXYtNmMwLS42LjQtMSAxLTFoNS41Yy4zIDAgLjYuMS44LjRsNC41IDUuNGMuMS4yLjIuNC4yLjZWMjVjMCAuNi0uNCAxLTEgMXoiLz48L3N2Zz4="

/***/ }),
/* 3906 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZD0iTTEgMzhoNDZ2Mkgxem0yNC0yMGg0djE2aC00em02IDBoNHYxNmgtNHptNiAwaDR2MTZoLTR6bS0xOCAwaDR2MTZoLTR6bS02IDBoNHYxNmgtNHptLTYgMGg0djE2SDd6bTM2LTJINXYtM2wxOS05IDE5IDl6TTUgMzRoMzh2Mkg1eiIgZmlsbD0iI0ZGOTgwMCIvPjxnIGZpbGw9IiNFRjZDMDAiPjxwYXRoIGQ9Ik0yNSAxNmg0djJoLTR6bTYgMGg0djJoLTR6bTYgMGg0djJoLTR6bS0xOCAwaDR2MmgtNHptLTYgMGg0djJoLTR6bS02IDBoNHYySDd6TTMgMzZoNDJ2MkgzeiIvPjxjaXJjbGUgY3g9IjI0IiBjeT0iMTEiIHI9IjIiLz48L2c+PC9zdmc+"

/***/ }),
/* 3907 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgZmlsbD0iI0ZGQ0M4MCI+PGNpcmNsZSBjeD0iMzgiIGN5PSIyNiIgcj0iNCIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iMjYiIHI9IjQiLz48cGF0aCBkPSJNMzkgMTljMC0xMi43LTMwLTguMy0zMCAwdjEwYzAgOC4zIDYuNyAxNSAxNSAxNXMxNS02LjcgMTUtMTVWMTl6Ii8+PHBhdGggZD0iTTI0IDRDMTUuMiA0IDggMTEuMiA4IDIwdjMuNWwyLjEuNlYxOWwxOS41LTYuMyA4LjIgNi4zdjUuMWwyLjEtLjZWMjBDNDAgMTIuNSAzNC42IDQgMjQgNHoiLz48L2c+PHBhdGggZmlsbD0iIzAyNzdCRCIgZD0iTTIxLjggMjkuNmMwLTYuNiA1LjEtNi4yIDUuMS0xMC4yIDAtMS0uMy0zLTIuOS0zLTIuOCAwLTMgMi4zLTMgMi44aC0zLjhjMC0xIC40LTYgNi44LTYgNi41IDAgNi43IDUuMSA2LjcgNiAwIDQuOS01LjQgNS42LTUuNCAxMC4zaC0zLjV6bS0uMyA0LjljMC0uMy4xLTIuMSAyLjEtMi4xczIuMiAxLjggMi4yIDIuMWMwIC42LS4zIDItMi4yIDItMS44IDAtMi4xLTEuNC0yLjEtMnoiLz48L3N2Zz4="

/***/ }),
/* 3908 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgZmlsbD0iI0U5MUU2MyI+PGNpcmNsZSBjeD0iMTkiIGN5PSIzMyIgcj0iOSIvPjxwYXRoIGQ9Ik0yNCA2djI3aDRWMTRsMTEgM3YtN3oiLz48L2c+PC9zdmc+"

/***/ }),
/* 3909 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGNTcyMiIgZD0iTTMyIDE1djI4SDEwYy0yLjIgMC00LTEuOC00LTRWMTVoMjZ6Ii8+PHBhdGggZmlsbD0iI0ZGQ0NCQyIgZD0iTTE0IDV2MzRjMCAyLjItMS44IDQtNCA0aDI5YzIuMiAwIDQtMS44IDQtNFY1SDE0eiIvPjxwYXRoIGQ9Ik0yMCAxMGgxOHY0SDIwem0wIDdoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHoiIGZpbGw9IiNGRjU3MjIiLz48L3N2Zz4="

/***/ }),
/* 3910 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzVDNkJDMCIgZD0iTTQwIDQwYy02LjkgMC0xNiA0LTE2IDRWMjJzOS00IDE4LTRsLTIgMjJ6Ii8+PHBhdGggZmlsbD0iIzc5ODZDQiIgZD0iTTggNDBjNi45IDAgMTYgNCAxNiA0VjIycy05LTQtMTgtNGwyIDIyeiIvPjxnIGZpbGw9IiNGRkI3NEQiPjxjaXJjbGUgY3g9IjI0IiBjeT0iMTIiIHI9IjgiLz48cGF0aCBkPSJNNDEgMzJoMWMuNiAwIDEtLjQgMS0xdi00YzAtLjYtLjQtMS0xLTFoLTFjLTEuNyAwLTMgMS4zLTMgM3MxLjMgMyAzIDN6TTcgMjZINmMtLjYgMC0xIC40LTEgMXY0YzAgLjYuNCAxIDEgMWgxYzEuNyAwIDMtMS4zIDMtM3MtMS4zLTMtMy0zeiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 3911 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGNpcmNsZSBmaWxsPSIjRkY5ODAwIiBjeD0iMjgiIGN5PSI5IiByPSI1Ii8+PHBhdGggZmlsbD0iIzAwNzk2QiIgZD0iTTI5IDI3LjNsLTkuMi00LjFjLTEtLjUtMS41IDEtMiAycy00LjEgNy4yLTMuOCA4LjNjLjMuOSAxLjEgMS40IDEuOSAxLjQuMiAwIC40IDAgLjYtLjFMMjguOCAzMWMuOC0uMiAxLjQtMSAxLjQtMS44cy0uNS0xLjYtMS4yLTEuOXoiLz48cGF0aCBmaWxsPSIjMDA5Njg4IiBkPSJNMjYuOCAxNS4ybC0yLjItMWMtMS4zLS42LTIuOSAwLTMuNSAxLjNMOS4yIDQxLjFjLS41IDEgMCAyLjIgMSAyLjcuMy4xLjYuMi45LjIuOCAwIDEuNS0uNCAxLjgtMS4xIDAgMCA5LjYtMTMuMyAxMC40LTE0LjlzNC45LTkuMyA0LjktOS4zYy41LTEuMyAwLTIuOS0xLjQtMy41eiIvPjxwYXRoIGZpbGw9IiNGRjk4MDAiIGQ9Ik00MC41IDE1LjdjLS43LS44LTItMS0yLjgtLjNsLTUgNC4yLTYuNC0zLjVjLTEuMS0uNi0yLjYtLjQtMy4zLjktLjggMS4zLS40IDIuOS44IDMuNGw4LjMgMy40Yy4zLjEuNi4yLjkuMi41IDAgLjktLjIgMS4zLS41bDYtNWMuOC0uNy45LTEuOS4yLTIuOHptLTI4LjggNy40bDMuNC01LjEgNC42LjYgMS41LTMuMWMuNC0uOSAxLjItMS40IDIuMS0xLjVoLTkuMmMtLjcgMC0xLjMuMy0xLjcuOWwtNCA2Yy0uNi45LS40IDIuMi42IDIuOC4yLjIuNi4zIDEgLjMuNiAwIDEuMy0uMyAxLjctLjl6Ii8+PC9zdmc+"

/***/ }),
/* 3912 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzY0QjVGNiIgZD0iTTE3LjQ3NCA4LjU3OGwyNi41NDQgOC45MDQtOC45MDQgMjYuNTQ0TDguNTcgMzUuMTIyeiIvPjxwYXRoIGZpbGw9IiMxRTg4RTUiIGQ9Ik0xOS4yMzggMTIuNTA0bDIwLjkyMiA2LjgyLTYuMiAxOS4wMi0yMC45MjItNi44MnoiLz48cGF0aCBmaWxsPSIjOTBDQUY5IiBkPSJNMTAuODgxIDUuNzc4bDI3LjUyNCA1LjA2OC01LjA2OCAyNy41MjQtMjcuNTI0LTUuMDY4eiIvPjxwYXRoIGZpbGw9IiM0MkE1RjUiIGQ9Ik0xMy4yMTkgOS40NDRsMjEuNjcgMy44NS0zLjUgMTkuNy0yMS42Ny0zLjg1eiIvPjxwYXRoIGZpbGw9IiNCQkRFRkIiIGQ9Ik00IDRoMjh2MjhINHoiLz48cGF0aCBmaWxsPSIjNENBRjUwIiBkPSJNNyA3aDIydjIwSDd6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2IDEzYzAtMS4xLjktMiAyLTJzMiAuOSAyIDItMiA0LTIgNC0yLTIuOS0yLTR6bTQgOGMwIDEuMS0uOSAyLTIgMnMtMi0uOS0yLTIgMi00IDItNCAyIDIuOSAyIDR6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEzLjUgMTYuN2MtMS0uNi0xLjMtMS44LS43LTIuNy42LTEgMS44LTEuMyAyLjctLjcgMSAuNiAyLjUgMy43IDIuNSAzLjdzLTMuNS4zLTQuNS0uM3ptOSAuNmMxIC42IDEuMyAxLjguNyAyLjctLjYgMS0xLjggMS4zLTIuNy43LTEtLjUtMi41LTMuNy0yLjUtMy43czMuNS0uMyA0LjUuM3oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjIuNSAxNi43YzEtLjYgMS4zLTEuOC43LTIuNy0uNi0xLTEuOC0xLjMtMi43LS43LTEgLjUtMi41IDMuNy0yLjUgMy43czMuNS4zIDQuNS0uM3ptLTkgLjZjLTEgLjYtMS4zIDEuOC0uNyAyLjcuNiAxIDEuOCAxLjMgMi43LjcgMS0uNiAyLjUtMy43IDIuNS0zLjdzLTMuNS0uMy00LjUuM3oiLz48Y2lyY2xlIGZpbGw9IiNGRkMxMDciIGN4PSIxOCIgY3k9IjE3IiByPSIyIi8+PC9zdmc+"

/***/ }),
/* 3913 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciLz4="

/***/ }),
/* 3914 */
/***/ (function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ }),
/* 3915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3914);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ }),
/* 3916 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 3917 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 3918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(3920);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 3919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(1518);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(3922);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(3921);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(3918);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/prefer-await-to-then */
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ }),
/* 3920 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ }),
/* 3921 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ }),
/* 3922 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ }),
/* 3923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(3614);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(3924);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(3919);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param maybeElementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      // asume maybeElementId can be rendered inside
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        // eslint-disable-line promise/prefer-await-to-then
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 3924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(3536);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (emitter) {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    } else {
	      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
	        if (error) {
	          emitter.trigger('error', error);
	        }
	      });
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 3925 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 3926 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = {
			Client: __webpack_require__(__webpack_module_template_argument_0__),
			LegacyClient: __webpack_require__(__webpack_module_template_argument_1__)
		};
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle-c02438e790b79834639b-2023-10-06__18-26-42.js